global.version = "1.1.1";


global.bank = [
  { icon: "BNP.png", value: "BNP", label: "BNP Paribas Bangkok Branch", name_th: "", code: "030",},
  { icon: "MHBC.png", value: "MHBC", label: "Mizuho Corporate Bank", name_th: "", code: "031",},
  { icon: "DEUTSHE.png", value: "DEUTSHE", label: "Deutsche Bank AG.", name_th: "", code: "032",},
  { icon: "CGC.png", value: "CGC", label: "Credit Agricole Corporate and Investment Bank", name_th: "", code: "033",},
  { icon: "BA.png", value: "BA", label: "Bank of America National Association", name_th: "", code: "034",},
  { icon: "MEGAICBC.png", value: "MEGAICBC", label: "Mega International Commercial Bank", name_th: "", code: "039",},
  { icon: "SCBT.png", value: "SCBT", label: "Standard Chartered Bank", name_th: "", code: "020",},
  { icon: "SMBC.png", value: "SMBC", label: "Sumitomo Mitsui Banking Corporation", name_th: "", code: "035",},
  { icon: "CITI.png", value: "CITI", label: "CITI Bank N.A.", name_th: "", code: "036",},
  { icon: "TMB.png", value: "TMB", label: "TMB Bank", name_th: "", code: "011",},
  { icon: "RBS.png", value: "RBS", label: "The Royal Bank of Scotland N.V.", name_th: "", code: "037",},
  { icon: "BOT.png", value: "BOT", label: "Bank of Thailand", name_th: "", code: "000",},
  { icon: "CIMB.png", value: "CIMB", label: "CIMB Thai", name_th: "ธนาคารซีไอเอ็มบีไทย", code: "022",},
  { icon: "LHB.png", value: "LHB", label: "Land and Houses Bank", name_th: "ธนาคารแลนด์แอนด์เฮ้าส์", code: "073",},
  { icon: "TCRB.png", value: "TCRB", label: "The Thai Credit Retail Bank", name_th: "ธนาคารไทยเครดิตเพื่อรายย่อย", code: "071",},
  { icon: "KKP.png", value: "KKP", label: "Kiatnakin Bank", name_th: "ธนาคารเกียรตินาคิน", code: "069",},
  { icon: "TISCO.png", value: "TISCO", label: "Tisco Bank", name_th: "ธนาคารทิสโก้", code: "067",},
  { icon: "IBANK.png", value: "IBANK", label: "Islamic Bank of Thailand", name_th: "ธนาคารอิสลามแห่งประเทศไทย", code: "066",},
  { icon: "HSBC.png", value: "HSBC", label: "Hong Kong & Shanghai Corporation", name_th: "ฮ่องกงและเซี่ยงไฮ้แบงกิ้งคอร์ปอเรชั่น", code: "030",},
  { icon: "UOB.png", value: "UOB", label: "United Overseas Bank", name_th: "ธนาคารยูโอบี (ไทย)", code: "024",},
  { icon: "ICBC.png", value: "ICBC", label: "Industrial and Commercial Bank of China Limited", name_th: "ธนาคารพาณิชย์อุตสาหกรรมแห่งประเทศจีน", code: "070",},
  { icon: "BAAC.png", value: "BAAC", label: "Bank for Agriculture and Agricultural Cooperatives", name_th: "ธ.ก.ส.", code: "034",},
  { icon: "GHB.png", value: "GHB", label: "Government Housing Bank", name_th: "ธนาคารอาคารสงเคราะห์", code: "033",},
  { icon: "GSB.png", value: "GSB", label: "Government Savings Bank", name_th: "ธนาคารออมสิน", code: "030",},
  { icon: "BAY.png", value: "BAY", label: "Bank of Ayudhya", name_th: "ธนาคารกรุงศรีอยุธยา", code: "025",},
  { icon: "KTB.png", value: "KTB", label: "Krung Thai Bank", name_th: "ธนาคารกรุงไทย", code: "006",},
  { icon: "BBL.png", value: "BBL", label: "Bangkok Bank", name_th: "ธนาคารกรุงเทพ", code: "002",},
  { icon: "TTB.png", value: "TTB", label: "TTB Thanachart Bank", name_th: "ธนาคารทหารไทยธนชาต", code: "011",},
  { icon: "KBANK.png", value: "KBANK", label: "Kasikorn Bank", name_th: "ธนาคารกสิกรไทย", code: "004",},
  { icon: "SCB.png", value: "SCB", label: "Siam Commercial Bank", name_th: "ธนาคารไทยพาณิชย์", code: "014",},

  { icon: "ACLE.png", value: "ACLE", label: "Acleda Bank Lao Co., Ltd", name_th: "", code: "",},
  { icon: "APB.png", value: "APB", label: "Agricultural Promotion Bank", name_th: "", code: "",},
  { icon: "BOC.png", value: "BOC", label: "Bank Of China", name_th: "", code: "",},
  { icon: "BFL.png", value: "BFL", label: "Banque Franco-Lao Co., Ltd", name_th: "", code: "",},
  { icon: "BCEL.png", value: "BCEL", label: "Banque Pour Le Commerce Exterieur Lao Public", name_th: "", code: "",},
  { icon: "BIC.png", value: "BIC", label: "Bic Bank Lao Co., Ltd", name_th: "", code: "",},
  { icon: "IDB.png", value: "IDB", label: "Indochina Bank Ltd", name_th: "", code: "",},
  { icon: "JDB.png", value: "JDB", label: "Joint Development Bank Public", name_th: "", code: "",},
  { icon: "LDB.png", value: "LDB", label: "Lao Development Bank", name_th: "", code: "",},
  { icon: "LVB.png", value: "LVB", label: "Lao-Viet Bank Co., Ltd", name_th: "", code: "",},
  { icon: "MJB.png", value: "MJB", label: "Maruhan Japan Bank Lao Co., Ltd", name_th: "", code: "",},
  { icon: "VMB.png", value: "VMB", label: "Military Commercial Joint Stock Bank - LAOS Branch", name_th: "", code: "",},
  { icon: "PSV.png", value: "PSV", label: "Phongsavanh Bank", name_th: "", code: "",},
  { icon: "PUBLIC.png", value: "PUBLIC", label: "Public Bank Lao", name_th: "", code: "",},
  { icon: "SACOM.png", value: "SACOM", label: "Sacom Bank Lao", name_th: "", code: "",},
  { icon: "STB.png", value: "STB", label: "St Bank Co., Ltd", name_th: "", code: "",},
  { icon: "VTB.png", value: "VTB", label: "Vietinbank Lao Limited", name_th: "", code: "",},
];

global.category = [
    { icon: "\uf553", name: "เสื้อผ้า", category_name: "shirt กางเกง เสื้อยืด แขนยาว แขนสั้น ชุดราตรี เดรส", image: "" },
    { icon: "\uf290", name: "กระเป๋า", category_name: "กระเป๋า bag", image: "" },
    { icon: "\uf782", name: "รองเท้า", category_name: "รองเท้า shoes", image: "" },
    { icon: "\uf2e1", name: "นาฬิกา", category_name: "นาฬิกา watch", image: "" },
    { icon: "\uf3a5", name: "เครื่องประดับ", category_name: "สร้อย แหวน กำไล เพชร", image: "" },
    { icon: "\uf015", name: "บ้าน", category_name: "กระท่อม ศาลา บ้านน็อคดาว", image: "" },
    { icon: "\uf236", name: "เฟอร์นิเจอร์", category_name: "table chair ตู้ เตียง เก้าอี้", image: "" },
    { icon: "\uf1b9", name: "ยานยนต์", category_name: "ยนต์ รถยนต์ จักรยาน มอเตอร์ไซ bike", image: "" },
    { icon: "\uf795", name: "อุปกรณ์อิเล็กทรอนิกส์", category_name: "หูฟัง คีย์บอ power จอคอม keyboard อิเล็ก", image: "" },
    { icon: "\uf3ce", name: "กล้องและอุปกรณ์ถ่ายรูป", category_name: "กล้อง camera", image: "" },
    { icon: "\uf0eb", name: "เครื่องใช้ไฟฟ้า", category_name: "ซักผ้า ตู้เย็น พัด แอร์", image: "" },
    { icon: "\uf109", name: "คอมพิวเตอร์", category_name: "notebook intel", image: "" },
    { icon: "\uf6d8", name: "ของเล่น", category_name: "ของเล่น ตุ๊กตา", image: "" },
    { icon: "\uf762", name: "ตกแต่งบ้าน", category_name: "ภาพวาด ตกแต่ง ภูมิ บ้าน หิน", image: "" },
]

global.product = [
    {
        "product_name": "MAD WAVE Open water Women Full Back ชุดสำหรับแข่งของผู้หญิงเปิดหลัง",
        "product_image": "https://img.lazcdn.com/g/p/1306f8cbeb76a65c4376d2f0ba27f97a.jpg_200x200q90.jpg",
        "price": 30000,
        "remark": "https://www.lazada.co.th/products/pdp-i5676569962.html",
        "sold": 0
    },
    {
        "product_name": "MAD WAVE Open water Men Full Back ชุดสำหรับแข่งของผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/p/90d245e881af41bad1c31a0596a603ad.jpg_200x200q90.jpg",
        "price": 30000,
        "remark": "https://www.lazada.co.th/products/pdp-i5676683589.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อสเวตเตอร์คอเต่าสไตล์มินิมอลอุ่นสบายสำหรับกิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sde1849440baf426795c7839bf5c5202aP.jpg_200x200q90.jpg",
        "price": 24988,
        "remark": "https://www.lazada.co.th/products/pdp-i16085724127.html",
        "sold": 0
    },
    {
        "product_name": "NAERSI | ชุดกีฬาคอสีบล็อก ฤดูใบไม้ผลิและใบไม้ร่วง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S942877291f204efe99ee74a3dc77b05bO.jpg_200x200q90.jpg",
        "price": 22176.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5854796555.html",
        "sold": 10
    },
    {
        "product_name": "UF PRO | เสื้อคอมแบทแบบซิปหนึ่งในสี่ รุ่นที่สอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6c2a18894f4e40a79e76c717ac721dfbX.jpg_200x200q90.jpg",
        "price": 20489.18,
        "remark": "https://www.lazada.co.th/products/pdp-i6075101598.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้าบางเห็นผ่านด้วยปกคอดีไซน์ริ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd4da56efc1d3429ba237f474a54dc94eQ.jpg_200x200q90.jpg",
        "price": 19379.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16109952805.html",
        "sold": 0
    },
    {
        "product_name": "BOSIDENG | เสื้อผ้าตกปลากันแดด ระบายอากาศ ป้องกันลม กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf711709f00824f83a4e2e328a827d98ci.png_200x200q90.png",
        "price": 16380.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6011010693.html",
        "sold": 9
    },
    {
        "product_name": "เสื้อปั่นจักรยานเพื่อการแข่งขันในสภาพอากาศร้อน (สีฟ้า) จัดส่งพรุ่งนี้",
        "product_image": "https://img.lazcdn.com/g/p/4eca719e2ab28ede854dc17239872c18.jpg_200x200q90.jpg",
        "price": 16360,
        "remark": "https://www.lazada.co.th/products/pdp-i1626086001.html",
        "sold": 0
    },
    {
        "product_name": "BOSIDENG | เสื้อผ้าป้องกัน UV สำหรับฤดูร้อน UPF 100 ให้ความรู้สึกเย็นสบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5eac9ac582e14985b71b0a79b6be14b6f.png_200x200q90.png",
        "price": 15117.86,
        "remark": "https://www.lazada.co.th/products/pdp-i6011076306.html",
        "sold": 0
    },
    {
        "product_name": "แจ็คเก็ตแบบใส่ด้านในสั้นปะขนเป็ดสไตล์เดียวกับผู้เล่น CBA",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4c471f2ffc9a48e598da306c4dd63747s.jpg_200x200q90.jpg",
        "price": 14920,
        "remark": "https://www.lazada.co.th/products/pdp-i16085436560.html",
        "sold": 0
    },
    {
        "product_name": "CASTELBAJAC GOLF | เสื้อกั๊กขนนกอุ่นและแฟชั่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa68e938e9d954856bc2a2a0ac41cce5cS.png_200x200q90.png",
        "price": 14127.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16054843191.html",
        "sold": 0
    },
    {
        "product_name": "Forward WIP x Clubloongchat : เสื้อกันกระแทก Impact Vest 50N แบบมีซิปข้าง สำหรับกีฬาทางน้ำ เวคบอร์ด สกีน้ำ ไคท์เซิร์ฟ วินด์เซิร์ฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8b32f3ae590d40339a65e1b36bcfb19d3.png_200x200q90.png",
        "price": 13980,
        "remark": "https://www.lazada.co.th/products/pdp-i5590270104.html",
        "sold": 2
    },
    {
        "product_name": "แผ่นเพจLevel4  แผ่นเพจใส่เสื้อป้องกัน\nแผ่นเสริม แผ่นเพจSTRIKE FACE\n(การป้องกันระดับสูงสุด)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8084239236b1410f950aa926ea90b5819.jpg_200x200q90.jpg",
        "price": 13976,
        "remark": "https://www.lazada.co.th/products/pdp-i5920762149.html",
        "sold": 0
    },
    {
        "product_name": "เสอถกกอลฟผหญง JYLINDBURG สดำ รน 2025 รโอน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S40226f16eb7b4545b2d79ca0ed496da88.png_200x200q90.png",
        "price": 13603.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5919280159.html",
        "sold": 0
    },
    {
        "product_name": "ต้นฉบับเกาหลี WAAC ชุดกอล์ฟ GOLF เสื้อสเวตเตอร์ถักสวมหัวลำลองใส่สบาย 23 รุ่นฤดูใบไม้ร่วงและฤดูหนาวสำหรับผู้ชายและผู้หญิง-Kerwin Wat",
        "product_image": "https://img.lazcdn.com/g/p/2f720e8449668d80673e2e4f694e3e61.jpg_webp_200x200q90.jpg",
        "price": 13494.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16140452275.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกั๊กตาข่ายสำหรับฝึกออกกำลังกายที่บ้านเสื้อถ่วงน้ำหนักระบายอากาศได้ดีเสื้อกั๊กน้ำหนักออกกำลังกายแบบปรับได้",
        "product_image": "https://img.lazcdn.com/g/p/a2e09c3bb3a9db05cbe581c2c6f49e73.jpg_200x200q90.jpg",
        "price": 7422,
        "remark": "https://www.lazada.co.th/products/pdp-i6060781776.html",
        "sold": 0
    },
    {
        "product_name": "Distin Kidny | เสื้อเชิ้ตแข็งแรง สไตล์วัยรุ่น ใช้งานได้หลากหลาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc1fa4fa2b9df44359fa0e5f21c99b09aC.jpg_200x200q90.jpg",
        "price": 13110.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16110888122.html",
        "sold": 0
    },
    {
        "product_name": "Prolimit x Clubloongchat : เสื้อกันกระแทกผู้หญิง รุ่น Pure Girl แบบมีซิปข้าง สำหรับกีฬาทางน้ำ เวคบอร์ด สกีน้ำ ไคท์เซิร์ฟ วินด์เซิร์ฟ",
        "product_image": "https://img.lazcdn.com/g/p/e5280d4994831eab018bfd8d654bc257.jpg_200x200q90.jpg",
        "price": 12800,
        "remark": "https://www.lazada.co.th/products/pdp-i4920952629.html",
        "sold": 0
    },
    {
        "product_name": "Forward WIP x Clubloongchat : เสื้อกันกระแทก Kompact Vest 50N แบบมีซิปหน้า สำหรับกีฬาทางน้ำ เวคบอร์ด สกีน้ำ ไคท์เซิร์ฟ วินด์เซิร์ฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S35961886d6194c1d8aee1371ef04b5b4P.jpg_200x200q90.jpg",
        "price": 12800,
        "remark": "https://www.lazada.co.th/products/pdp-i5591077035.html",
        "sold": 0
    },
    {
        "product_name": "Forward WIP x Clubloongchat : เสื้อกันกระแทก Wing Neo Vest 50N ตะขอหน้าดีไซน์มาเพื่อกีฬาทางน้ำ วิงฟอยล์ โดยเฉพาะ ไม่สูงไม่ต่ำเกินไป",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S741756eb7f734ca3b1629d8cc65bdc56X.jpg_200x200q90.jpg",
        "price": 12800,
        "remark": "https://www.lazada.co.th/products/pdp-i5590690508.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเจอร์ซีย์นักปั่นเกล็ดมังกรแฟชั่นจักรยานเสือหมอบ MTB เบาพิเศษเสื้อเข้ารูปแขนยาวปั่นจักรยาน3D",
        "product_image": "https://img.lazcdn.com/g/p/06f0f29a0f63c18fed8fe2271b32038b.jpg_200x200q90.jpg",
        "price": 12612,
        "remark": "https://www.lazada.co.th/products/pdp-i5798723017.html",
        "sold": 0
    },
    {
        "product_name": "ผู้หญิงเสื้อเจอร์ซีย์นักปั่นจักรยานเสือหมอบ MTB ระบายอากาศได้ดีเสื้อมืออาชีพเสื้อผ้าปั่นจักรยานเพรียวบาง",
        "product_image": "https://img.lazcdn.com/g/p/8fee16a902c6c0613880330847cc78bb.jpg_200x200q90.jpg",
        "price": 12592,
        "remark": "https://www.lazada.co.th/products/pdp-i5796063755.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเสื้อเจอร์ซีย์นักปั่นแอโรไดนามิกส์ผู้หญิง,เสื้อจักรยานเสือหมอบ MTB ระบายอากาศได้ดีเสื้อยืดปั่นจักรยานเพรียวบาง",
        "product_image": "https://img.lazcdn.com/g/p/56263bab6d1e33f714036735f4475688.jpg_200x200q90.jpg",
        "price": 12556,
        "remark": "https://www.lazada.co.th/products/pdp-i5798587655.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเสื้อเจอร์ซีย์นักปั่นผู้หญิง,เสื้อจักรยานเสือหมอบ MTB ระบายอากาศได้ดีเสื้อผ้าสำหรับขี่จักรยานแฟชั่นแบบบาง",
        "product_image": "https://img.lazcdn.com/g/p/1bacafb21b0a4655ab1896ffd018c705.jpg_200x200q90.jpg",
        "price": 12556,
        "remark": "https://www.lazada.co.th/products/pdp-i5793588956.html",
        "sold": 0
    },
    {
        "product_name": "Prolimit x Clubloongchat : เสื้อกันกระแทก Floating Vest รุ่น Freeride แบบมีซิปข้าง สำหรับกีฬาทางน้ำ เวคบอร์ด สกีน้ำ ไคท์เซิร์ฟ วินด์เซิร์ฟ",
        "product_image": "https://img.lazcdn.com/g/p/c06b2d34bd343f9adf303a1cba556e3d.jpg_200x200q90.jpg",
        "price": 12200,
        "remark": "https://www.lazada.co.th/products/pdp-i4921081141.html",
        "sold": 0
    },
    {
        "product_name": "Distin Kidny | เสื้อแฟชั่นลำลองทันสมัยใส่สบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc1e270992197417d8c58af7fb58c99f1I.jpg_200x200q90.jpg",
        "price": 12100.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16110821313.html",
        "sold": 0
    },
    {
        "product_name": "Castelli | เสื้อปั่นจักรยานไตรกีฬาแขนสั้นสไตล์ใหม่สำหรับผู้หญิงที่ระบายอากาศได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7f03d30c18bc4d1391be1905efe5c17cR.jpg_200x200q90.jpg",
        "price": 11788.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5935329081.html",
        "sold": 0
    },
    {
        "product_name": "265/75R16 TOYOรุ่นOPEN COUNTRY R/T🎏ยางใหม่กริ๊ปปี2024🇯🇵 ผลิตญี่ปุ่น🇯🇵ราคา1เส้น✅แถทจุ๊บลมยางแท้, ซื้อครบสี่เส้นแถมเสื้ออีก 1ตัว👍มีรับประกันนาน3ปี✅❤️ไม่จำกัดระยะทาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1393aa7955734fefab4b09627c3a07807.jpg_200x200q90.jpg",
        "price": 11600,
        "remark": "https://www.lazada.co.th/products/pdp-i2488934173.html",
        "sold": 3
    },
    {
        "product_name": "เสื้อผ้าศิลปะการต่อสู้สำหรับเยาวชนระดับไฮเอนด์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S55a77c9848b6450e8bb66ed4952aeefby.jpg_200x200q90.jpg",
        "price": 11451.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16076598758.html",
        "sold": 0
    },
    {
        "product_name": "ZACHARIAH | แจ็คเก็ตสกีพร้อมซับฟลีซกันหนาวสำหรับชายและหญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S87442b63f4f74eee9ec135e206029606i.jpg_200x200q90.jpg",
        "price": 11386.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16120298619.html",
        "sold": 0
    },
    {
        "product_name": "Skins | เสื้อแขนยาวแบบบีบอัดแห้งไวสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdcc5ac27dff8434c99f3dd78c2d460dfW.png_200x200q90.png",
        "price": 11166.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5875651002.html",
        "sold": 0
    },
    {
        "product_name": "Suunto | เสื้อกั๊กน้ำหนักเบาสำหรับทุกเพศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5109e9986fc84baca5de8b65e3e7a45ek.jpg_200x200q90.jpg",
        "price": 11150.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16105778866.html",
        "sold": 0
    },
    {
        "product_name": "ฟันดาบชุดเสื้อผ้ากางเกงเสื้อแจ็คเก็ตเสื้อกั๊กขวามือปรับการออกแบบบางน้ำหนักเบาฝีมือดีสวมใส่สบายเด็กฟันดาบสูทสำหรับการฝึกอบรมทุกวัน",
        "product_image": "https://img.lazcdn.com/g/p/16cb300c3e28711c0b1517334f2654ff.jpg_200x200q90.jpg",
        "price": 11148,
        "remark": "https://www.lazada.co.th/products/pdp-i16122047334.html",
        "sold": 0
    },
    {
        "product_name": "Balneaire | ชุดว่ายน้ำเด็กผู้หญิงแบบชิ้นเดียว ระบายอากาศและแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S51b0e15fba074828b21ad23db25d70c00.png_200x200q90.png",
        "price": 11058.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5893764638.html",
        "sold": 0
    },
    {
        "product_name": "ชดออกกำลงกาย 2025SS แบรนดแพกกแอนโค รน TRS ฟงกชนพเศษ FTT-2052/FTP-2052 สำหรบผหญง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb45c357cf41644c4acc5f70d0c1f1b621.jpg_200x200q90.jpg",
        "price": 11016.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16076735893.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแขนสั้นลายลิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sde58ec75f58e404a9b43bfd8936df7b1H.png_200x200q90.png",
        "price": 10963.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16119407131.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดเนื้อเบาและนุ่ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0074e5fd3b2642e29db931b4f882a502W.png_200x200q90.png",
        "price": 10919.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16054166432.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS เสื้อกั๊กกันลมเสื้อกั๊กนักปั่นจักรยานผู้หญิง,เสื้อโค้ทขี่จักรยานเปิดสองชั้นซิปเสื้อเจอร์ซีย์แขนกุดจักรยานเสือหมอบน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/14b1be185ec26efd6ea18242cf5a533b.jpg_200x200q90.jpg",
        "price": 10776,
        "remark": "https://www.lazada.co.th/products/pdp-i5360591515.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS เสื้อแขนสั้นสำหรับผู้หญิง,เสื้อเจอร์ซีย์นักปั่น2สีระบายอากาศสำหรับฤดูร้อน MTB จักรยานเสือหมอบเสื้อยืดเสื้อผ้ากีฬาภายนอก",
        "product_image": "https://img.lazcdn.com/g/p/30e063df2b9e229ceed7166a7e5487c0.jpg_200x200q90.jpg",
        "price": 10426,
        "remark": "https://www.lazada.co.th/products/pdp-i4553468175.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อรัดเอวป้องกันด้านบนสำหรับตกปลาทะเลเข็มขัดผู้ถือคันชักที่พยุงเอวปรับได้เข็มขัดต่อสู้ปลา",
        "product_image": "https://img.lazcdn.com/g/p/2e60da33ccbd0fb8c99a777ee3cd335f.jpg_200x200q90.jpg",
        "price": 10407.98,
        "remark": "https://www.lazada.co.th/products/pdp-i6038371361.html",
        "sold": 0
    },
    {
        "product_name": "Distin Kidny | เสื้อเชิ้ตอีเลแกนต์แมทช์ง่ายสำหรับฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S300bd9f28cd84151a1a291edbe5462a8f.jpg_200x200q90.jpg",
        "price": 10124.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16110629057.html",
        "sold": 0
    },
    {
        "product_name": "ชุดปั่นจักรยานฤดูร้อนแขนยาวสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S40137b6995a44d7f86b3a5bbbd495356R.jpg_200x200q90.jpg",
        "price": 10104.9,
        "remark": "https://www.lazada.co.th/products/pdp-i6014174134.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อถ่วงน้ำหนัก 30kg weighted vest",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S490e70c4914a4fe0aae0f48d40079d87p.jpg_200x200q90.jpg",
        "price": 10048.5,
        "remark": "https://www.lazada.co.th/products/pdp-i4054835849.html",
        "sold": 20
    },
    {
        "product_name": "เสื้อผ้าการแข่งขันศิลปะการต่อสู้แบบไหมคุณภาพสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S97999fa97d5f484c9d9d48f9f9a3b144w.png_200x200q90.png",
        "price": 10001,
        "remark": "https://www.lazada.co.th/products/pdp-i16075452348.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อแห้งเร็วดูดเหงื่อป้องกันลื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc1f53d6a5825409b91bea45c8104942cK.jpg_200x200q90.jpg",
        "price": 9976,
        "remark": "https://www.lazada.co.th/products/pdp-i16115489136.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อฮอกกี้คอปกป้องเหงื่อ ไม่ลื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbd0fb76a318d4af58b810be372a35f7d7.jpg_200x200q90.jpg",
        "price": 9918,
        "remark": "https://www.lazada.co.th/products/pdp-i16115393591.html",
        "sold": 0
    },
    {
        "product_name": "RYDER CUP EST．1927 | เสื้อสเวตเตอร์แขนยาวสไตล์รีโทรลายขวางสำหรับผู้หญิงในฤดูใบไม้ร่วง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sab74b2c0d51f4d4dabb3b21eeca5ab22a.png_200x200q90.png",
        "price": 9910.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16054441106.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกั๊กคอตั้งซีรีย์ทีมชาติ ใส่สบาย อบอุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfd9e3f07236e4d7a89a15d70fbd1c14eR.jpg_200x200q90.jpg",
        "price": 9868,
        "remark": "https://www.lazada.co.th/products/pdp-i16085689227.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกั๊กขนเป็ดสำหรับผู้ชายกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Secab3a3ab9034a85add817b971837d48G.jpg_200x200q90.jpg",
        "price": 9730,
        "remark": "https://www.lazada.co.th/products/pdp-i16085765055.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกั๊กสปอร์ตแบบเก็บความร้อนขนเป็ด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6972bb54e7e94cbc87113f5a96f4d2e0o.jpg_200x200q90.jpg",
        "price": 9592,
        "remark": "https://www.lazada.co.th/products/pdp-i16085633436.html",
        "sold": 0
    },
    {
        "product_name": "COLDELEMENT | เสื้อกันหนาวเด็ก ชุดสเก็ตบอร์ด ชุดกันหนาว ปกป้องจากลม ทนทานต่อการสึกหรอ อบอุ่น สำหรับเด็กวัยกลางคนและโต ฤดูใบไม้ร่วง 2024",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se39a2702bfc84ed6bfd09d100e6a8d17Y.jpg_200x200q90.jpg",
        "price": 9524.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5851766433.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเวส 6094 AFG [ AFG-VT28 ] สีพื้น  BY:Task Force",
        "product_image": "https://img.lazcdn.com/g/p/52754c65e4fc9a44d8e2d5df380c1be0.jpg_200x200q90.jpg",
        "price": 8960,
        "remark": "https://www.lazada.co.th/products/pdp-i5586815729.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเสื้อผ้ากอล์ฟกันน้ำ ขนาดใหญ่ น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd3de9eb767654bf0aa5670342b9c24fdi.jpg_200x200q90.jpg",
        "price": 8924,
        "remark": "https://www.lazada.co.th/products/pdp-i16115485259.html",
        "sold": 0
    },
    {
        "product_name": "BOSIDENG | เสื้อผ้าใส่หน้าร้อนป้องกัน UV 100 UPF",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7081c53ba9564bfeaf18628daf13c4818.png_200x200q90.png",
        "price": 8840.44,
        "remark": "https://www.lazada.co.th/products/pdp-i6011039799.html",
        "sold": 5
    },
    {
        "product_name": "เสื้อคลุมกันแดด แห้งไว สำหรับใส่ปั่นจักรยาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S174c60f4b5fa4ed6a6e68c37430853d1q.jpg_200x200q90.jpg",
        "price": 8624.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5879646266.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อซับเหงื่อแห้งไวสำหรับเด็กและผู้ใหญ่ คอต่ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdae693a2d35346ffbf6b668e7a815b7cG.png_200x200q90.png",
        "price": 8550,
        "remark": "https://www.lazada.co.th/products/pdp-i16115211798.html",
        "sold": 0
    },
    {
        "product_name": "ชุดแข่งจักรยานกันน้ำ ระบายอากาศได้ดีสำหรับผู้หญิง BENKIA HDF-JW-W561 สำหรับฤดูใบไม้ผลิและฤดูใบไม้ร่วง ทนทานต่อการสึกหรอ ผลิตจากผ้าโพลีเอสเตอร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc1be93031fe64052af1f53682479661fD.jpg_200x200q90.jpg",
        "price": 8298.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16109655387.html",
        "sold": 0
    },
    {
        "product_name": "JSC | เสื้อผ้าวินเทจสปอร์ตบางเบา ใส่สบาย ระบายอากาศได้ดี และป้องกันแสงแดด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5bcd156466b242b58cbc8a82c77fb64fj.jpg_200x200q90.jpg",
        "price": 8129.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16118996918.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานกันแดดแห้งไว ฤดูใบไม้ผลิ/ฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2a19df8457c245e18695e4c20294f9b0j.jpg_200x200q90.jpg",
        "price": 8083.3,
        "remark": "https://www.lazada.co.th/products/pdp-i5859691184.html",
        "sold": 3
    },
    {
        "product_name": "เสื้อปั่นจักรยานสตรีแบบอบอุ่นและสะท้อนแสง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa6968815237d4824aaad37dbfab9cb7aQ.jpg_200x200q90.jpg",
        "price": 8031.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5942342831.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อคลุมตกปลาปรับได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S94390a8c429c4572a1288fb3db3660f2E.jpg_200x200q90.jpg",
        "price": 8016,
        "remark": "https://www.lazada.co.th/products/pdp-i16118815776.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อวิ่งมีน้ำหนักปรับได้และถอดออกได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sda7046131f6f414194c0d542d78e8f88i.jpg_200x200q90.jpg",
        "price": 7910,
        "remark": "https://www.lazada.co.th/products/pdp-i16123168287.html",
        "sold": 0
    },
    {
        "product_name": "ฮู้ดดี้ผู้หญิงสไตล์คลาสสิกเรโทร ระบายอากาศได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S08af79162bb646b18b7b0701c759c5ccn.jpg_200x200q90.jpg",
        "price": 7878,
        "remark": "https://www.lazada.co.th/products/pdp-i16085531759.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อขี่จักรยานสำหรับอากาศหนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9b2be60422f64b13b9b32358fa34d4e8A.jpg_200x200q90.jpg",
        "price": 7877.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5880248756.html",
        "sold": 1
    },
    {
        "product_name": "YKYWBIKE แขนสั้นกีฬาชุดเสื้อยืดขี่จักรยานฤดูร้อนของผู้หญิงตั้งจักรยาน MTB ขี่ได้7ชั่วโมง",
        "product_image": "https://img.lazcdn.com/g/p/704996c0b4e1f7181a16159024fff57f.jpg_200x200q90.jpg",
        "price": 7870,
        "remark": "https://www.lazada.co.th/products/pdp-i5692231921.html",
        "sold": 0
    },
    {
        "product_name": "Castelli | เสื้อปั่นจักรยานแห้งเร็ว ระบายอากาศได้ดี น้ำหนักเบาสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S454d46caca6c41968195288627096af4X.jpg_200x200q90.jpg",
        "price": 7651.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5934993623.html",
        "sold": 1
    },
    {
        "product_name": "AIDUOEN | เสื้อหลวมสำหรับสตรีผู้สูงอายุ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf6c70cb8ab1d4253a4cae775ef89a9e6Y.jpg_200x200q90.jpg",
        "price": 7605.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16110977970.html",
        "sold": 0
    },
    {
        "product_name": "BOSIDENG | เสื้อป้องกันรังสี UV ระบายความร้อน น้ำหนักเบา UPF80",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8c2b983fda8348d49024cc6e6aca808bI.png_200x200q90.png",
        "price": 7602.28,
        "remark": "https://www.lazada.co.th/products/pdp-i6011010888.html",
        "sold": 55
    },
    {
        "product_name": "BOSIDENG | เสื้อผ้ากันน้ำสำหรับกลางแจ้ง ระบายอากาศได้ดี และป้องกัน UV",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S94b2e9ed4ed04551b9f707d1ff2df0bcK.png_200x200q90.png",
        "price": 7597.86,
        "remark": "https://www.lazada.co.th/products/pdp-i6011096059.html",
        "sold": 55
    },
    {
        "product_name": "AIDUOEN | เสื้อแขนสั้นคอตตอนสบายๆ สำหรับฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S26a66e997ef84e12b5a943310fa1386bP.jpg_200x200q90.jpg",
        "price": 7596.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16110254067.html",
        "sold": 0
    },
    {
        "product_name": "Balneaire | ชุดว่ายน้ำกัน UV สำหรับเด็ก แขนยาวขายาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saec6519d142e4d528c48c05b0feaef6fC.png_200x200q90.png",
        "price": 7512.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5893855803.html",
        "sold": 0
    },
    {
        "product_name": "AIDUOEN | เสื้อเชิ้ตแฟชั่นฤดูร้อนสำหรับสตรีวัยผู้สูงอายุ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd1a2c91624154c0cbc5906f81d5378aaa.jpg_200x200q90.jpg",
        "price": 7458.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16113320055.html",
        "sold": 0
    },
    {
        "product_name": "AIDUOEN | เสื้อชีฟองแขนสั้น 7 ส่วนสำหรับฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2edf3cc2cb6f47e797f425338de70f54a.jpg_200x200q90.jpg",
        "price": 7458.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16110207086.html",
        "sold": 0
    },
    {
        "product_name": "AIDUOEN | เสื้อแขนสั้นหรูหราสำหรับผู้สูงอายุ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8232e20cd61b4cf38951fc917938468bH.jpg_200x200q90.jpg",
        "price": 7441.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16113641923.html",
        "sold": 0
    },
    {
        "product_name": "AIDUOEN | เสื้อยืดสำหรับผู้สูงอายุใส่หน้าร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6f6b8374ff004197997822450f8b88fcN.jpg_200x200q90.jpg",
        "price": 7428.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16110164150.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกีฬาขี่ม้าที่ระบายอากาศได้ ใส่สบาย กันลื่น ทนทาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa971f71dee8d45bdb209320f4743cd03J.jpg_200x200q90.jpg",
        "price": 7422,
        "remark": "https://www.lazada.co.th/products/pdp-i16123299866.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเวส 6094 AFG  [ AFG-VT28 ] ลายพราง BY:Tactical unit",
        "product_image": "https://img.lazcdn.com/g/p/00b7a799878fd259a16aad5e0c43a909.jpg_200x200q90.jpg",
        "price": 7380,
        "remark": "https://www.lazada.co.th/products/pdp-i5586981639.html",
        "sold": 0
    },
    {
        "product_name": "💝🤍New+พร้อมส่ง💝🤍เสื้อคาดิแกนแบรน Endless♾️holiday💝คอลใหม่ วาเลนไทน์🤍ลายสวย ใส่สวย ผ้าดี ใส่ได้บ่อย🤍💝",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S42c27a39bb4640eebc6b56a979ef427eI.jpg_200x200q90.jpg",
        "price": 7380,
        "remark": "https://www.lazada.co.th/products/pdp-i6069986288.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อผ้ากีฬาฤดูใบไม้ร่วง/ฤดูหนาว EVR สำหรับผู้หญิง เสื้อผ้ากีฬาจักรยานแบบมีขนแกะ ผ้า Carvico อบอุ่น ระบายอากาศได้ดี ป้องกันลม เสื้อผ้ากีฬาจักรยาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S768704f806fa4f59bc032311814550b09.jpg_200x200q90.jpg",
        "price": 7376.18,
        "remark": "https://www.lazada.co.th/products/pdp-i5851810494.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานแขนยาว CMYK Shadow สำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf17c6c4b893d41ac8dc2cc020c474e3dL.jpg_200x200q90.jpg",
        "price": 7320.08,
        "remark": "https://www.lazada.co.th/products/pdp-i5880207833.html",
        "sold": 0
    },
    {
        "product_name": "COLDELEMENT | เสื้อแจ็คเก็ตสกีเด็ก Coldelement หนา อบอุ่น กันน้ำ กันลม ระบายอากาศได้ดี ทนทานต่อการสึกหรอ สำหรับเด็กชายและเด็กหญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4ce7780ffc064d83b8df5e5ea414bd2f7.jpg_200x200q90.jpg",
        "price": 7175.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5851812607.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | เสื้อกั๊กสไตล์วิทยาลัยสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb0594b4246b44dad8776d86b501ffb56V.jpg_200x200q90.jpg",
        "price": 7107.34,
        "remark": "https://www.lazada.co.th/products/pdp-i6031372005.html",
        "sold": 0
    },
    {
        "product_name": "✈√◦Compression Shirt Yoga Jacket For Women Stand Collar Sports Top Long Sleeve Zipper Jacket Cycling Fitness Female Clothing◦◐",
        "product_image": "https://img.lazcdn.com/g/p/6e103b5690541f84f98e1eeb7601864e.png_200x200q90.png",
        "price": 7101.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16064600632.html",
        "sold": 0
    },
    {
        "product_name": "ชุดป้องกันกระสุนพิเศษสำหรับการป้องกันข้ามพรมแดน เสื้อกั๊กกันกระสุน IIIA เสื้อผ้ากันกระสุนน้ำหนักเบา หลีกเลี่ยงความเสี่ยง เสื้อยืดป้องกันตัว",
        "product_image": "https://img.lazcdn.com/g/p/6137a4597b82b3f0cfb7ea0563e57b7f.jpg_200x200q90.jpg",
        "price": 7041.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16079307886.html",
        "sold": 0
    },
    {
        "product_name": "RWC'25 Brazil Rugby Women Performance Training Jersey เสื้อRWC ทีมชาติบราซิล ผู้หญิง",
        "product_image": "https://img.lazcdn.com/us/lzd_seller_ai_business/seller/ai/b4ec2bf6-2b36-4421-b2e6-e9e513fc5c87.jpg_200x200q90.jpg",
        "price": 7039.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5970377227.html",
        "sold": 0
    },
    {
        "product_name": "🧡🤍พร้อมส่ง🧡🤍เสื้อเชิ๊ตแบรน Endless♾️holiday🧡เสื้อหอย รุ่นสวย หายาก ใส่สวย📸ถ่ายรูปสวย ผ้าดี ใส่สบาย🧡",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5e7c02d869874050adeea360dbf54361o.jpg_200x200q90.jpg",
        "price": 6980,
        "remark": "https://www.lazada.co.th/products/pdp-i5575023213.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อCNC เสื้อสูบ CNC CBR แบบลม ยาว 90มม. สามารถตีปลอกขยายได้ตามต้องการ งานดี คุณภาพ100%",
        "product_image": "https://img.lazcdn.com/g/p/99c93cb07eda4ff972343385d2f326ce.jpg_200x200q90.jpg",
        "price": 6980,
        "remark": "https://www.lazada.co.th/products/pdp-i4330053948.html",
        "sold": 0
    },
    {
        "product_name": "Yonex | เสื้อเทนนิสแขนสั้นสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S55fd86bef1b24280836defc936bb6c30j.jpg_200x200q90.jpg",
        "price": 6978.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16092657511.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานสตรีฤดูใบไม้ผลิ/ฤดูร้อน พร้อมการถักแบบ 3D",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0205648c229940b4b885c1c8956d9746U.jpg_200x200q90.jpg",
        "price": 6881.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5859463854.html",
        "sold": 0
    },
    {
        "product_name": "ของแท้100% Stussy เสื้อยืดลูกบอล8ลูกเวอร์ชันอเมริกันทรงหลวมใส่ได้ทั้งชายและหญิง-Kerwin Wat",
        "product_image": "https://img.lazcdn.com/g/p/890b864f8dc2271214ddf76dde90cc20.jpg_webp_200x200q90.jpg",
        "price": 2319.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16143616386.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อจักรยานสำหรับฤดูใบไม้ร่วงและหนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S11f208d321ee4213b482652dfcef1a36b.jpg_200x200q90.jpg",
        "price": 6804.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5928447092.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานแขนสั้นสำหรับผู้หญิง ระบายอากาศและแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfe726019f47c405dbe23ec9107f62db1c.jpg_200x200q90.jpg",
        "price": 6804.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5879590010.html",
        "sold": 2
    },
    {
        "product_name": "เสื้อปั่นจักรยานแขนยาวสำหรับผู้หญิง ฤดูใบไม้ผลิและฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sddffd5ea89c74e459224daff2a0ffbeeR.jpg_200x200q90.jpg",
        "price": 6788.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5859725958.html",
        "sold": 0
    },
    {
        "product_name": "Castelli | แจ็กเก็ตปั่นจักรยานกันน้ำแขนยาวเบาๆ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S61df30accff649a2b88077e03cb4f04aM.png_200x200q90.png",
        "price": 6712.76,
        "remark": "https://www.lazada.co.th/products/pdp-i5935520575.html",
        "sold": 10
    },
    {
        "product_name": "AREFFA | เสื้อแจ็คเก็ตพกพาสำหรับปิกนิกและแคมปิ้ง สีคาーキ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4116837996d745368354b43f9d72dc8eS.jpg_200x200q90.jpg",
        "price": 6601.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16084357905.html",
        "sold": 0
    },
    {
        "product_name": "WISKII - Seamless Top ; เสื้อสปอร์ตบราไร้รอยต่อดีไซน์ปกโปโล (Preppy Elegance)",
        "product_image": "https://img.lazcdn.com/g/p/f9ec34e3aa731afd03d8e9f80d169673.jpg_200x200q90.jpg",
        "price": 6580,
        "remark": "https://www.lazada.co.th/products/pdp-i16102435642.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานแขนยาวสำหรับผู้หญิงที่ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S03fe27ae10f8495f89d013cb3283e17an.png_200x200q90.png",
        "price": 6503.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5840985878.html",
        "sold": 4
    },
    {
        "product_name": "เสื้อ Vest Majesty Scutum Tactical Vest (Vacefy)",
        "product_image": "https://img.lazcdn.com/g/p/1c3eebfe3ffca51f9a0b3dc717a82b76.jpg_200x200q90.jpg",
        "price": 6490,
        "remark": "https://www.lazada.co.th/products/pdp-i2842718787.html",
        "sold": 0
    },
    {
        "product_name": "PRE-ORDER 10-14 วัน iCONiC THAI ARUN T-SHIRT #20086X  เสื้อยืด แต่ง ผ้าลูกไม้ สไบ แขนฟู สไตล์ ไทยประยุกต์ เสื้อสงกรานต์  เสื้อแฟชั่น เสื้อแฟชั่นผญ เสื้อออกงาน เสื้อทำงาน เสื้อไฮโซ",
        "product_image": "https://img.lazcdn.com/g/p/d7dbfc4f3d2fc9f77c541f27ce312a25.jpg_200x200q90.jpg",
        "price": 6472.62,
        "remark": "https://www.lazada.co.th/products/pdp-i2910799441.html",
        "sold": 3
    },
    {
        "product_name": "เสื้อยืด Stussy X Goldie Metalheadz 30 สีดำ ของแท้ 100% - Kerwin Wat",
        "product_image": "https://img.lazcdn.com/g/p/19cc3f9c32f2012fc08799cd8fc2a166.png_200x200q90.png",
        "price": 6436.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16140300423.html",
        "sold": 0
    },
    {
        "product_name": "แจ็คเก็ตกีฬาสันทนาการป้องกันความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd7de768e0a9c440b86820732fa8881948.jpg_200x200q90.jpg",
        "price": 6400,
        "remark": "https://www.lazada.co.th/products/pdp-i16085616266.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้าการแข่งขันศิลปะการต่อสู้ระดับพรีเมียม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf40d1456127b4c07b4f4499c13b9f6064.png_200x200q90.png",
        "price": 6399.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16076430922.html",
        "sold": 0
    },
    {
        "product_name": "BOSIDENG | เสื้อป้องกันแดดสำหรับกลางแจ้ง ระบายความร้อน กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S90c108331e43494ab508005a9bffa8cfv.png_200x200q90.png",
        "price": 6330.52,
        "remark": "https://www.lazada.co.th/products/pdp-i6011093022.html",
        "sold": 16
    },
    {
        "product_name": "ชุดยูโด/ไอคิโดสำหรับเด็กรุ่น 500 (สีขาว) ขนาดส่วนสูง110ซม. เสื้อคลุมยูโดทั้งตัว ชุดสวมกีฬาไอคิโด ผ้าคลุมออกกำลังกาย EXERCISE SUIT COSTUME บริการเก็บเงินปลายทาง 500 KIDS' JUDO AIKIDO UNIFORM - WHITE",
        "product_image": "https://img.lazcdn.com/g/p/a3368be92f58026e61f0bc8907437630.jpg_200x200q90.jpg",
        "price": 6318,
        "remark": "https://www.lazada.co.th/products/pdp-i1025616677.html",
        "sold": 0
    },
    {
        "product_name": "ชุดยูโด/ไอคิโดสำหรับเด็กรุ่น 500 (สีขาว) ขนาดส่วนสูง140ซม. เสื้อคลุมยูโดทั้งตัว ชุดสวมกีฬาไอคิโด ผ้าคลุมออกกำลังกาย EXERCISE SUIT COSTUME จัดส่งฟรี 500 KIDS' JUDO AIKIDO UNIFORM - WHITE",
        "product_image": "https://img.lazcdn.com/g/p/a3368be92f58026e61f0bc8907437630.jpg_200x200q90.jpg",
        "price": 6318,
        "remark": "https://www.lazada.co.th/products/pdp-i1025644333.html",
        "sold": 0
    },
    {
        "product_name": "COLDELEMENT | ชุดสกีกันน้ำและกันความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S854051e6c4674220aba43cf319297e25h.jpg_200x200q90.jpg",
        "price": 6297.66,
        "remark": "https://www.lazada.co.th/products/pdp-i5951982641.html",
        "sold": 24
    },
    {
        "product_name": "เสื้อปั่นจักรยานระบายเหงื่อและหายใจได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S30cdd637b1d94d178fa510d47f5e3ec3F.jpg_200x200q90.jpg",
        "price": 6198.34,
        "remark": "https://www.lazada.co.th/products/pdp-i6014146239.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อปั่นจักรยานสำหรับผู้หญิง แห้งไว ระบายอากาศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6d7131f0b9584e52886f92406e4c1ebeU.jpg_200x200q90.jpg",
        "price": 6197.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5841200912.html",
        "sold": 2
    },
    {
        "product_name": "เสื้อปั่นจักรยานสตรีแห้งไวและระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5cc0d83ab9cd4b1195fd6b5a08ae8b52n.jpg_200x200q90.jpg",
        "price": 6196.5,
        "remark": "https://www.lazada.co.th/products/pdp-i6014090841.html",
        "sold": 7
    },
    {
        "product_name": "เสื้อเจอร์ซีย์นักปั่นผู้หญิงชุุดปั่นจักรยานแขนยาวกลางแจ้งยืดหยุ่นเข้ารูปเสื้อระบายสำหรับปั่นจักรยานแห้งเร็ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb702f211da464e7fab34d850b660da4cY.jpg_200x200q90.jpg",
        "price": 6194,
        "remark": "https://www.lazada.co.th/products/pdp-i16138029584.html",
        "sold": 0
    },
    {
        "product_name": "JUEZHU จักรยานผู้หญิงสั้นพิเศษแขนยาวรอบเอวสูง99% แอโรไดนามิกต้านเชื้อแบคทีเรียเสื้อเจอร์ซีย์นักปั่นกันความชื้นยืดหยุ่นสูงพอดีกับกางเกงปั่นจักรยานสำหรับจักรยานเสือหมอบ MTB",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdbf3c2ec3d5e44cdad417fadd7b7a8f2W.jpg_200x200q90.jpg",
        "price": 6194,
        "remark": "https://www.lazada.co.th/products/pdp-i16138432080.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานแขนสั้นพิมพ์ลายสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S75f19b41cdc24d48bd80442ae72764a6p.jpg_200x200q90.jpg",
        "price": 6192,
        "remark": "https://www.lazada.co.th/products/pdp-i5879800604.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานสำหรับผู้หญิง ฤดูใบไม้ผลิ/ฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S32dc01ad2eba4e35b8eb56b20f0202adD.jpg_200x200q90.jpg",
        "price": 6188.38,
        "remark": "https://www.lazada.co.th/products/pdp-i5874276024.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานสตรีแขนสั้น Spring/Summer Red Rock Canyon",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc1725bc84b8944dbb05c8ed6c5070ff1G.jpg_200x200q90.jpg",
        "price": 6175.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5859576561.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานสำหรับผู้หญิง ระบายอากาศและแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1bd564b90eb8461399ba6e82287a18f63.jpg_200x200q90.jpg",
        "price": 6169.66,
        "remark": "https://www.lazada.co.th/products/pdp-i5859866102.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผู้หญิงแฟชั่นดีไซคลาสสิก สบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd8d249b2479840d5a0ba36a9a2fba614k.png_200x200q90.png",
        "price": 6160.94,
        "remark": "https://www.lazada.co.th/products/pdp-i16119592442.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานสำหรับผู้หญิง แห้งเร็ว ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb0e1183c5189469595f010a8b8f6ee11F.jpg_200x200q90.jpg",
        "price": 6152.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5841136121.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อปั่นจักรยานฤดูร้อนแขนสั้นสำหรับผู้หญิง ดูดซับความชื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se957b18c95e64748a06a9ac73ec51b187.jpg_200x200q90.jpg",
        "price": 6152.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5840703788.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อจักรยานเสือหมอบผู้หญิงเสื้อเจอร์ซีย์นักปั่นฤดูร้อนแห้งเร็วเสื้อเจอร์ซีย์นักปั่นผู้หญิงแขนสั้นระบายอากาศได้ยืดหยุ่นสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S595013570c8147bd8626833c5bf6087eV.jpg_200x200q90.jpg",
        "price": 6144,
        "remark": "https://www.lazada.co.th/products/pdp-i16125420385.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผู้หญิงแขนสั้นแห้งเร็วระบายอากาศได้ดีฤดูร้อนเสื้อเจอร์ซีย์นักปั่นเสื้อเจอร์ซีย์นักปั่นจักรยานเสือหมอบยืดหยุ่นสูงน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S48306964d56e43daa82dcc5167fd00751.jpg_200x200q90.jpg",
        "price": 6144,
        "remark": "https://www.lazada.co.th/products/pdp-i16125288396.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเสื้อเจอร์ซีย์นักปั่นปั่นจักรยานเสือภูเขาระบายอากาศได้ดีแห้งเร็วเสื้อยืดแขนสั้นจักรยานเสือหมอบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se977f5f685374925a8ee26517e57449cP.jpg_200x200q90.jpg",
        "price": 6144,
        "remark": "https://www.lazada.co.th/products/pdp-i16125143193.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเจอร์ซีย์นักปั่นเสื้อเจอร์ซีย์นักปั่นขี่จักรยานบนถนนระบายอากาศสำหรับฤดูร้อนยืดหยุ่นแขนสั้นสำหรับผู้หญิงแห้งเร็วป้องกันแสงแดด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdd1187142b9b490faefa2ea349a4d585F.jpg_200x200q90.jpg",
        "price": 6144,
        "remark": "https://www.lazada.co.th/products/pdp-i16134250900.html",
        "sold": 0
    },
    {
        "product_name": "ผู้หญิงจักรยานเสือหมอบกลางแจ้งระบายอากาศได้ดีแห้งเร็วเสื้อเจอร์ซีย์นักปั่นเสื้อยืดแขนสั้น Baju Atasan Olahraga MTB แบบบาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se93dc3359ad643e38b212f4a574b57cev.jpg_200x200q90.jpg",
        "price": 6144,
        "remark": "https://www.lazada.co.th/products/pdp-i16125648265.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผู้หญิงเสื้อเจอร์ซีย์นักปั่นแห้งเร็วระบายอากาศได้ดีเสื้อเสื้อแขนสั้นเข้ารูปจักรยานเสือหมอบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5f35973187fe4fdea84249eb94f88e3bO.jpg_200x200q90.jpg",
        "price": 6144,
        "remark": "https://www.lazada.co.th/products/pdp-i16125460282.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเสื้อเจอร์ซีย์นักปั่นผู้หญิงแขนสั้นขี่จักรยานเสือหมอบเสือภูเขาระบายอากาศได้ดีแห้งเร็ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4c89e701c3024c7587a5771b1007dbbas.jpg_200x200q90.jpg",
        "price": 6144,
        "remark": "https://www.lazada.co.th/products/pdp-i16138012801.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเจอร์ซีย์นักปั่นผู้หญิงแขนสั้นเสื้อกีฬาแห้งเร็วระบายอากาศได้ของผู้หญิงฤดูร้อนเสื้อเจอร์ซีย์นักปั่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6c13bec91d0e435185004e2149e17437F.jpg_200x200q90.jpg",
        "price": 6144,
        "remark": "https://www.lazada.co.th/products/pdp-i16125452547.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS ชุดปั่นจักรยานผู้หญิง,เสื้อเจอร์ซีย์นักปั่นแขนยาวให้ความอบอุ่นในฤดูหนาวผ้าฟลีซยืดหยุ่นอุปกรณ์จักรยานเจอร์ซีย์หมวกขี่ MTB จักรยานน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/3e7f954499171532a24ce30ef621f161.jpg_200x200q90.jpg",
        "price": 6058,
        "remark": "https://www.lazada.co.th/products/pdp-i5347720417.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS Winter Cyling Jerseys with Pocket Windproof Skin-friendly Fleece Lined Bike Clothing for Women",
        "product_image": "https://img.lazcdn.com/g/p/cd0b49c4140a50b2226c144b609c2505.jpg_200x200q90.jpg",
        "price": 6052,
        "remark": "https://www.lazada.co.th/products/pdp-i4877923921.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้าสำหรับการแสดงศิลปะการต่อสู้ สีแดง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S12cb49cdb1a748f68bbca1fa6474ba88s.png_200x200q90.png",
        "price": 6024.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16085651746.html",
        "sold": 0
    },
    {
        "product_name": "【ROAD TO SKY】ROCKBROS Women Cycling Jersey Breathable Short Sleeves Bicycle T-shirts Smooth YKK Zipper Sweat Absorptatin High Elastic Bike Clothing",
        "product_image": "https://img.lazcdn.com/g/p/b5676aea64fee905a18591a5ad60a793.jpg_200x200q90.jpg",
        "price": 5996,
        "remark": "https://www.lazada.co.th/products/pdp-i5189235803.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS เสื้อทีบีแห้งเร็วระบายอากาศดีเสื้อเจอร์ซีย์นักปั่นผู้หญิง,เสื้อทีเชิ๊ตแขนยาวทรงหลวมเรียบมีซิปยืดหยุ่นสูงเสื้อผ้าจักรยานเสือหมอบ",
        "product_image": "https://img.lazcdn.com/g/p/ff51b7772fcf21d8e28786a904e7307c.jpg_200x200q90.jpg",
        "price": 5996,
        "remark": "https://www.lazada.co.th/products/pdp-i5188308493.html",
        "sold": 0
    },
    {
        "product_name": "ผู้หญิงเสื้อเจอร์ซีย์นักปั่นผู้หญิงเสื้อแขนสั้นสำหรับหน้าร้อนเสื้อกีฬารัดรูปสำหรับผู้ชายแห้งเร็วระบายอากาศดีขี่จักรยานบนถนนเสื้อเจอร์ซีย์นักปั่น MTB",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S444e4f0194db4aa09028c457867233118.jpg_200x200q90.jpg",
        "price": 5994,
        "remark": "https://www.lazada.co.th/products/pdp-i16125047737.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเจอร์ซีย์นักปั่นแขนสั้นสำหรับสตรีฤดูร้อนเสื้อเจอร์ซีย์นักปั่นแห้งเร็วระบายอากาศดีจักรยานเสือหมอบเสื้อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seb1301d8d9874ff792d643c201bceaaaN.jpg_200x200q90.jpg",
        "price": 5994,
        "remark": "https://www.lazada.co.th/products/pdp-i16125005557.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเจอร์ซีย์นักปั่นของผู้หญิงขี่จักรยานบนถนนแห้งเร็วป้องกันแสงแดดแขนสั้นยืดหยุ่นระบายอากาศได้ดีฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd493f49ac8174182b9d796e079bad7c2P.jpg_200x200q90.jpg",
        "price": 5994,
        "remark": "https://www.lazada.co.th/products/pdp-i16134672618.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผู้หญิงจักรยานเสือหมอบแห้งเร็วระบายอากาศได้ดีเสื้อเจอร์ซีย์นักปั่นฤดูร้อนเสื้อเจอร์ซีย์นักปั่นน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbed64dcc326a46d1a3e7731d8aad61ddI.jpg_200x200q90.jpg",
        "price": 5994,
        "remark": "https://www.lazada.co.th/products/pdp-i16124961344.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผู้หญิงเสื้อเจอร์ซีย์นักปั่นยืดหยุ่น MTB จักรยานเสือหมอบเสื้อยืดแขนสั้น99% เสื้อจักรยานกลางแจ้งต้านเชื้อแบคทีเรีย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S52ff0be2e1ee415889b55820a3da1c15i.jpg_200x200q90.jpg",
        "price": 5992,
        "remark": "https://www.lazada.co.th/products/pdp-i16138015457.html",
        "sold": 0
    },
    {
        "product_name": "ZHENYU เสื้อจักรยานผู้หญิงสั้นพิเศษแขนสั้นเอวสูงแนวแอโรไดนามิก99% ต้านเชื้อแบคทีเรียเสื้อขี่จักรยานยืดหยุ่นสูงใส่ได้พอดีกับกางเกงปั่นจักรยาน MTB",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf31dba7d6d8a491a83b216cc77518330z.jpg_200x200q90.jpg",
        "price": 5992,
        "remark": "https://www.lazada.co.th/products/pdp-i16138338749.html",
        "sold": 0
    },
    {
        "product_name": "Zumba One Shoulder Bodysuit (ชุดบอดี้สูทออกกำลังกายซุมบ้า)",
        "product_image": "https://img.lazcdn.com/g/p/d7599ff87163ba0b43550e9c9662320c.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i3675484743.html",
        "sold": 0
    },
    {
        "product_name": "จูจุสึกิโมโนบราซิลสำหรับเด็กเสื้อผ้าเครื่องแบบศิลปะการต่อสู้ BJJ Gi มีเข็มขัดสีขาว",
        "product_image": "https://img.lazcdn.com/g/p/ca7f10754662885a570372ab8bb35b7d.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i5573011498.html",
        "sold": 2
    },
    {
        "product_name": "EVR New Jersey รุ่น Ascent - เสื้อปั่นจักรยานแขนสั้นสำหรับผู้หญิง รุ่น Ascent",
        "product_image": "https://img.lazcdn.com/g/p/2fb44e61e60d8bfd87b975ce77cbd9bb.png_200x200q90.png",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i5976281569.html",
        "sold": 0
    },
    {
        "product_name": "【TVI】ROCKBROS ชุดเสื้อเจอร์ซีย์นักปั่นมีซิปสำหรับผู้หญิง,เสื้อผ้าจักรยานเสือหมอบเสือผ้าขนแกะอบอุ่นแขนยาวเสื้อยืดจักรยานกันลมระบายอากาศได้ดียืดหยุ่น",
        "product_image": "https://img.lazcdn.com/g/p/b169e0639e5cdcbb543fbf25ddb6b899.jpg_200x200q90.jpg",
        "price": 5960,
        "remark": "https://www.lazada.co.th/products/pdp-i5347542280.html",
        "sold": 0
    },
    {
        "product_name": "แจ็กเก็ตสกีกันน้ำและกันความร้อนที่ทนทาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saebd688a45ab47b6a8fb16133f06258eG.jpg_200x200q90.jpg",
        "price": 5856,
        "remark": "https://www.lazada.co.th/products/pdp-i16117895327.html",
        "sold": 0
    },
    {
        "product_name": "ZHENYU เสื้อเจอร์ซีย์นักปั่นสั้นพิเศษสำหรับผู้หญิงเอวสูงแอโรไดนามิก99% ต้านเชื้อแบคทีเรียแขนสั้นยืดหยุ่นสูงกางเกงปั่นจักรยาน MTB สำหรับจักรยานเสือหมอบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saa593cc6555742deb0721a81464a9eedd.jpg_200x200q90.jpg",
        "price": 5846,
        "remark": "https://www.lazada.co.th/products/pdp-i16137875428.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานแขนยาว Coolmax ป้องกันแสงแดดแห้งไว สำหรับผู้หญิง ฤดูใบไม้ร่วง ฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S04f17063bdff41af9db5c8c193de5e49U.jpg_200x200q90.jpg",
        "price": 5823.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5874169557.html",
        "sold": 9
    },
    {
        "product_name": "แจ็คเก็ตปั่นจักรยานเทอร์มอลฟลีซ 5-15 องศา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3f6a4b1d56a54c8d8d15adc5bd3f5c9fz.jpg_200x200q90.jpg",
        "price": 5815.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5880033299.html",
        "sold": 0
    },
    {
        "product_name": "PUMA เสื้อแข่งผู้หญิงทีมชาติโปรตุเกส ชุดเยือน ฤดูกาล 2026",
        "product_image": "https://img.lazcdn.com/g/p/df438ad1e2ccda35b90281b3ca591bc2.jpg_200x200q90.jpg",
        "price": 5800,
        "remark": "https://www.lazada.co.th/products/pdp-i16117212773.html",
        "sold": 0
    },
    {
        "product_name": "Masque Jersey Vintage Flower เสื้อปั่นจักรยาน",
        "product_image": "https://img.lazcdn.com/g/p/e35c6972bc874fb394d02d7d65357a63.jpg_200x200q90.jpg",
        "price": 5780,
        "remark": "https://www.lazada.co.th/products/pdp-i4101379416.html",
        "sold": 0
    },
    {
        "product_name": "Masque Jersey Moon เสื้อปั่นจักรยาน",
        "product_image": "https://img.lazcdn.com/g/p/180c5f4aa79e0138932e261186d8bd7b.jpg_200x200q90.jpg",
        "price": 5780,
        "remark": "https://www.lazada.co.th/products/pdp-i4101301925.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกั๊กน้ำหนักบรรทุกดวงจันทร์จรวดสำหรับออกกำลังกายในยิม5กก. ปรับได้พร้อมเสื้อแจ็คเก็ตถ่วงน้ำหนักแถบสะท้อนแสงสำหรับวิ่งจ๊อกกิ้งผู้ชายผู้หญิงนักกีฬา",
        "product_image": "https://img.lazcdn.com/g/p/72bef99115f4373052cab1105975fae0.jpg_200x200q90.jpg",
        "price": 5748,
        "remark": "https://www.lazada.co.th/products/pdp-i5932693870.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้ากีฬาฤดูร้อน EVR PRO สำหรับผู้หญิง แขนสั้นระบายอากาศได้ดี ป้องกันแสงแดด เสื้อผ้ากีฬาปั่นจักรยานเสือภูเขาและทางพิเศษ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S238c21dba6a74b16adc661bd1fec45e6w.jpg_200x200q90.jpg",
        "price": 5719.24,
        "remark": "https://www.lazada.co.th/products/pdp-i5841018459.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานผู้หญิงวินเทจ แห้งไว ยืดหยุ่นสูง ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5cf84431f01d4706adcba109bc0d8f047.png_200x200q90.png",
        "price": 5662.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5841249791.html",
        "sold": 8
    },
    {
        "product_name": "เสื้อขี่ม้าสำหรับเด็กแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S04cb2336652349d29ef44b92164e8c30H.jpg_200x200q90.jpg",
        "price": 5650,
        "remark": "https://www.lazada.co.th/products/pdp-i16115498428.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานสตรีแขนสั้นสำหรับฤดูใบไม้ผลิ/ฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3f6cea71d21c4a56bf89c068c7cace24B.jpg_200x200q90.jpg",
        "price": 5603.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5880746721.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อ..เวส ะ ปลอกเวส ตร. ก้ามปูปลดล็อค 4 จุด ช่องแม็ก 4 ช่อง 1 ช่องวิทยุ ใส่แผ่น มาตรฐาน ขนาด 10\"*12\" ได้ ฟรีอาร์ม 3 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/c2afb09f80186b1c32aa3cf12d3a7d22.jpg_200x200q90.jpg",
        "price": 5600,
        "remark": "https://www.lazada.co.th/products/pdp-i703592603.html",
        "sold": 146
    },
    {
        "product_name": "เสื้อ,,เวสปลอก,,เกsาะ อามี่ ก้ามปูปลดล็อค 4 จุด ช่องแม็กกาซีน 4 ช่อง 1 ช่องวิทยุ ใส่แผ่นเพลทมาตรฐาน ขนาด 10\"*12\"",
        "product_image": "https://img.lazcdn.com/g/p/0dc00fe656efc23bcd7849673f4b6462.jpg_200x200q90.jpg",
        "price": 5600,
        "remark": "https://www.lazada.co.th/products/pdp-i863416465.html",
        "sold": 86
    },
    {
        "product_name": "LAMEDA จักรยานเสือหมอบเสื้อเจอร์ซีย์นักปั่นใหม่สำหรับผู้หญิงฤดูใบไม้ผลิฤดูร้อน UPF50ครีมกันแดดป้องกันรังสียูวี + แห้งเร็วเย็นแขนยาวสั้นน้ำหนักเบาชุดสำหรับขี่จักรยาน Mtb",
        "product_image": "https://img.lazcdn.com/g/p/18c6bc1c5a4be0499b3b564a0f44f8c9.jpg_200x200q90.jpg",
        "price": 5598,
        "remark": "https://www.lazada.co.th/products/pdp-i5156635942.html",
        "sold": 4
    },
    {
        "product_name": "เสื้อขนแกะเสื้อเจอร์ซีย์นักปั่นผู้หญิง,แขนยาวยืดหยุ่นได้กันลมเสื้อเจอร์ซีย์สำหรับผู้หญิงฤดูใบไม้ร่วงฤดูหนาวเล่นกีฬาชุดสำหรับขี่จักรยาน MTB",
        "product_image": "https://img.lazcdn.com/g/p/3ccf05a5fe7135b18ddf5ba615ac26c3.jpg_200x200q90.jpg",
        "price": 5538,
        "remark": "https://www.lazada.co.th/products/pdp-i5390707218.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกีฬาแขนยาวผ้าฟลีซให้ความอบอุ่นกันลมระบายอากาศได้ดีเสื้อเจอร์ซีย์นักปั่นสำหรับผู้หญิงเสื้อกีฬาฤดูใบไม้ร่วงฤดูหนาว MTB จักรยานเสือหมอบชุดสำหรับขี่จักรยาน",
        "product_image": "https://img.lazcdn.com/g/p/a32135b2b56caf980f7c7d7393023038.jpg_200x200q90.jpg",
        "price": 5538,
        "remark": "https://www.lazada.co.th/products/pdp-i5390340817.html",
        "sold": 0
    },
    {
        "product_name": "แจ็คเก็ตขนเป็ดสำหรับฝึกซ้อมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S80f253daa6964fc989fcbc6f6f889879G.jpg_200x200q90.jpg",
        "price": 5530,
        "remark": "https://www.lazada.co.th/products/pdp-i16085266924.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานลดความอ้วนสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S31abe9cede9d4f70942444cf5a5ba08eW.jpg_200x200q90.jpg",
        "price": 5470.82,
        "remark": "https://www.lazada.co.th/products/pdp-i6013944498.html",
        "sold": 4
    },
    {
        "product_name": "เสื้อกั๊กขนเป็ดกันน้ำแบบปักลาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se1e64e96105a4f5aa8324c8a27f11219W.jpg_200x200q90.jpg",
        "price": 5466,
        "remark": "https://www.lazada.co.th/products/pdp-i16085443990.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานสำหรับผู้หญิง ฤดูใบไม้ร่วง/หนาว อบอุ่นและช่วยลดหุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb405fee9ce124ea98ecbab6f06e26755M.jpg_200x200q90.jpg",
        "price": 5430.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5884914495.html",
        "sold": 15
    },
    {
        "product_name": "เวส Ferro Concepts FCPC V5  (FCPC V5 Tactical plate carrier)    ● คุณสมบัติ :  1. เสื้อเวสออกแบบมาให้มีความคล่องตัว  2. เสื้อเวส มีช่องสำหรับใส่แผ่นเพลต  3. มาพร้อมระบบปลดไว 1 จุด ที่หัวไหล่ขวา  4. ออกแบบมาให้ระบายความร้อนได้ดี  5. สวมใส่สบาย  6. ขนาดกำลั",
        "product_image": "https://img.lazcdn.com/g/p/5f4035113aa4ea8880204ba7f47f0b40.jpg_200x200q90.jpg",
        "price": 5400,
        "remark": "https://www.lazada.co.th/products/pdp-i5752713329.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกีฬา TARGET Raymond van Barneveld Playing Shirt",
        "product_image": "https://img.lazcdn.com/g/p/13ac9c793bde69ec5ae5a916fda1576b.png_200x200q90.png",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i5894188699.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อรัดรูปกันแดดแขนยาวคอกลม กันรังสีUV 99.8% สำหรับผู้หญิง - สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/3e95fa71811c8a5e84fda77fc031ef31.png_200x200q90.png",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i2771618464.html",
        "sold": 6
    },
    {
        "product_name": "เสื้อรัดรูปกันแดดแขนยาวคอตั้ง กันรังสีUV 99.8% สำหรับผู้หญิง - สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/ab2ead969109afe38bcd3202a2bdbbf8.png_200x200q90.png",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i3789205715.html",
        "sold": 8
    },
    {
        "product_name": "เสื้อรัดรูปกันแดดแขนยาวคอตั้ง กันรังสีUV 99.8% สำหรับผู้หญิง - สีขาว",
        "product_image": "https://img.lazcdn.com/g/p/fb30cfa05e35c2f5dd12c625dd81f355.png_200x200q90.png",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i3789288366.html",
        "sold": 6
    },
    {
        "product_name": "เสื้อรัดรูปกันแดดแขนยาวคอกลม กันรังสีUV 99.8% สำหรับผู้หญิง - สีเนื้อ",
        "product_image": "https://img.lazcdn.com/g/p/e21f0060d957a85b041822d26001199a.png_200x200q90.png",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i3981343630.html",
        "sold": 6
    },
    {
        "product_name": "เสื้อกีฬา TARGET Josh Rock Playing Shirt",
        "product_image": "https://img.lazcdn.com/g/p/cbcdba55289f2bbff334853eb8677c45.png_200x200q90.png",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i5936238127.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกีฬา TARGET Luke Littler Playing Shirt SIZE XXL",
        "product_image": "https://img.lazcdn.com/g/p/2ad7772db4b0d3dd4ab9d3fbf3da96b8.png_200x200q90.png",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i5894239089.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อรัดรูปกันแดดแขนยาวคอกลม กันรังสีUV 99.8% สำหรับผู้หญิง - สีขาว",
        "product_image": "https://img.lazcdn.com/g/p/a4d7acbf8bb81d38ba45e8d47d9cbdcd.png_200x200q90.png",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i2771557815.html",
        "sold": 18
    },
    {
        "product_name": "KH2695แบบสวมหัวสำหรับผู้หญิงเสื้อฮู้ดแบบหนาลำลองทรงหลวมและทันสมัย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa3ae14923c5d492b8f44ccc7e49874b7n.jpg_200x200q90.jpg",
        "price": 5372.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16049600817.html",
        "sold": 0
    },
    {
        "product_name": "FIZZCOCO | เสื้อสปอร์ตผู้หญิงกันลมพร้อมซับในฟลีซ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb009f8e5a866474fb20b23fc14877fcav.jpg_200x200q90.jpg",
        "price": 5343.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16111412079.html",
        "sold": 0
    },
    {
        "product_name": "SMFK | เสื้อกล้ามแบบหลายประโยชน์ คอแฮลเตอร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S15a5fdf27f394de0ad25903ec399ccfaL.jpg_200x200q90.jpg",
        "price": 5308,
        "remark": "https://www.lazada.co.th/products/pdp-i16082179935.html",
        "sold": 0
    },
    {
        "product_name": "RWC'25 Brazil Rugby Youth Home Performance Jersey เสื้อกีฬารักบี้ ทีมชาติบราซิล เด็ก",
        "product_image": "https://img.lazcdn.com/us/lzd_seller_ai_business/seller/ai/cf5b5ff2-859d-4b76-a022-fd35f012acff.jpg_200x200q90.jpg",
        "price": 5296.08,
        "remark": "https://www.lazada.co.th/products/pdp-i5970605167.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานระบายอากาศสำหรับผู้หญิง แขนยาวบาง สีดรีม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7b66317ca0c34bf8aca7a5abf8e472c7q.jpg_200x200q90.jpg",
        "price": 5215.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5879991924.html",
        "sold": 10
    },
    {
        "product_name": "Zumba 25 Boxy Mesh Top (เสื้อแขนสั้นออกกำลังกายซุมบ้า)",
        "product_image": "https://img.lazcdn.com/g/p/409e2978fcb92b3609ac5ec810f8ae04.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i16116198144.html",
        "sold": 0
    },
    {
        "product_name": "แจ็กเก็ตขนเป็ดแบบคลาสสิกเรโทรพร้อมฮู้ดกันหนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfa000358ac604269b05830de0200d69br.jpg_200x200q90.jpg",
        "price": 5166,
        "remark": "https://www.lazada.co.th/products/pdp-i16085653040.html",
        "sold": 0
    },
    {
        "product_name": "แจ็คเก็ตผู้ชายแบบหลวมฮูดสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sabb1a20ae32943769285e16814c83f90T.jpg_200x200q90.jpg",
        "price": 5166,
        "remark": "https://www.lazada.co.th/products/pdp-i16085538274.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเจอร์ซีย์นักปั่นของผู้หญิงเสื้อแขนสั้นเอวสูงและน้ำหนักเบาย้อมสีมัดย้อมภาพขี่จักรยานมี3กระเป๋าและเรียบ YKK ซิปชุดออกกำลังกายชุดปั่นจักรยาน",
        "product_image": "https://img.lazcdn.com/g/p/14e91f49ccd9927eb879e7d39b8e2be2.jpg_200x200q90.jpg",
        "price": 5158,
        "remark": "https://www.lazada.co.th/products/pdp-i5132656832.html",
        "sold": 0
    },
    {
        "product_name": "แจ็คเก็ตกีฬาเด็กชาย 3 ใน 1 พร้อมความอบอุ่นจากผ้าฟลีซ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbd318d66f79347e28b36ddd19c274882g.jpg_200x200q90.jpg",
        "price": 5154,
        "remark": "https://www.lazada.co.th/products/pdp-i16085622463.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS ชุดเสื้อเจอร์ซีย์นักปั่นผ้าฟลีซสำหรับผู้หญิง,เสื้อผ้าจักรยานเสือหมอบผู้หญิงเนื้อผ้านุ่มเสื้อยืดจักรยานอบอุ่นระบายอากาศได้ดีมีซิปยืดหยุ่นสไตล์ YKK",
        "product_image": "https://img.lazcdn.com/g/p/806fe0cf60d580a9abfc728981839a8d.jpg_200x200q90.jpg",
        "price": 5128,
        "remark": "https://www.lazada.co.th/products/pdp-i5400723490.html",
        "sold": 0
    },
    {
        "product_name": "【TI hot】 Women Basketball Uniform white and black Sublimation Print Name Number Logo Polyester Basketball Jersey shirt For Female ZL1925",
        "product_image": "https://img.lazcdn.com/g/p/898db296205d0cff45f4eb5a6adbc0b1.png_200x200q90.png",
        "price": 5112.08,
        "remark": "https://www.lazada.co.th/products/pdp-i6075940633.html",
        "sold": 0
    },
    {
        "product_name": "SWAN LOVE GOLF | เสื้อผ้ากอล์ฟป้องกันแดดสำหรับฤดูร้อน แห้งไวเย็นสบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S752c0d3a7ad44b3bb30241b448aa6e45Q.jpg_200x200q90.jpg",
        "price": 5088.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16093935046.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อฝึกปรับท่านิ่ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3decf5b35ff84564abd6da3ffe55f363s.jpg_200x200q90.jpg",
        "price": 5081.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6003024418.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น W4BI53KCIE1 สีขาว",
        "product_image": "https://img.lazcdn.com/g/p/d79e667ad7959b386c0747340cdcb0fb.jpg_200x200q90.jpg",
        "price": 5022,
        "remark": "https://www.lazada.co.th/products/pdp-i6074623516.html",
        "sold": 0
    },
    {
        "product_name": "ELLE Active | เสื้อถักนิตติ้งคอตตอนเนื้อนุ่ม ELLE Active เส้นใยโพลีเอสเตอร์ทรงสลิมฟิต ทรงเข้ารูป แขนยาว ปกติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc07dbff8cfc84a6aab77ab777039a8bel.png_200x200q90.png",
        "price": 5006.52,
        "remark": "https://www.lazada.co.th/products/pdp-i5844351901.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อจักรยานผู้หญิง Funkier Rocco Women Elite jerey JW-2105",
        "product_image": "https://img.lazcdn.com/g/p/cc04a505fb723bf321aee0a49e32339e.png_200x200q90.png",
        "price": 5000,
        "remark": "https://www.lazada.co.th/products/pdp-i4443005431.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อยุทธวิธีแบบปลดเร็วลายพลาง – สินค้าใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7559fd7fc5574ef7a3af28bf39f49490O.jpg_200x200q90.jpg",
        "price": 5000,
        "remark": "https://www.lazada.co.th/products/pdp-i5811445767.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อจักรยานผู้หญิง Funkier Bilancia Women Elite jerey JW-2112-3",
        "product_image": "https://img.lazcdn.com/g/p/91803fd1e383813080c9223a66dfb33c.png_200x200q90.png",
        "price": 5000,
        "remark": "https://www.lazada.co.th/products/pdp-i4438871129.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อขี่จักรยานแห้งเร็วสำหรับผู้หญิงฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa9b5f542887b401e93bd7670cf62cdc1w.jpg_200x200q90.jpg",
        "price": 4996.52,
        "remark": "https://www.lazada.co.th/products/pdp-i5840723005.html",
        "sold": 0
    },
    {
        "product_name": "moodytiger | เสื้อโปโลแขนสั้นกันแดดสำหรับกีฬากลางแจ้ง ซับเหงื่อและระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2c1e0dba62b3457abb99bd47157ccc41B.png_200x200q90.png",
        "price": 4990.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16120616029.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้าปั่นจักรยานฤดูใบไม้ร่วง/ฤดูหนาว EVR สำหรับผู้หญิง ขนแกะบาง อบอุ่น ทรงสลิมฟิต จักรยานเสือภูเขา เสื้อผ้าปั่นจักรยาน ฤดูใบไม้ร่วง/ฤดูหนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sec5b0b8e57ad4f8fb4de3be84f66d537W.jpg_200x200q90.jpg",
        "price": 4989.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5850729734.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อแจ็คเก็ตปั่นจักรยานฤดูใบไม้ร่วง/ฤดูหนาวสำหรับผู้หญิง EVR-2025 อบอุ่น ขนแกะ แขนยาว เสื้อผ้ากีฬา ฤดูใบไม้ร่วง/ฤดูหนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S949aec5ec4f34458b70a5a0dcd7c6b38S.jpg_200x200q90.jpg",
        "price": 4989.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5841154189.html",
        "sold": 1
    },
    {
        "product_name": "ROCKBROS เสื้อยืดจักรยานแขนเสื้อสั้นระบายอากาศสำหรับผู้หญิง,เสื้อปั่นจักรยานมีซิปแห้งเร็วสไตล์ YKK มีกระเป๋าหลัง3กระเป๋า",
        "product_image": "https://img.lazcdn.com/g/p/2f60c0034ad932be9be71ff33cb87ea0.jpg_200x200q90.jpg",
        "price": 4988,
        "remark": "https://www.lazada.co.th/products/pdp-i5140546054.html",
        "sold": 0
    },
    {
        "product_name": "(New FALL D2 2025) Tavi Apparel Sporty Tank Wineberry เสื้อออกกำลังกาย",
        "product_image": "https://img.lazcdn.com/g/p/a2b51bfd337f9b37d04f3e004daf60e1.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i5873790891.html",
        "sold": 0
    },
    {
        "product_name": "🍏🍎พร้อมส่ง🍏🍎เสื้อเชิ๊ตแบรน Endless♾️holiday ใส่สวย ใส่สบาย ลายสวย เนื้อผ้าดี ผ้าหนาลื่น mix&match หลากหลาย 🍏🍎",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1b0e0c0ee48f45cfa4f5ddf956fbf19ed.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i5130123138.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยุทธวิธี Team Tango Scout Shirt เสื้อยืดออกกำลัง เสื้อยืดไลฟ์สไตล์",
        "product_image": "https://img.lazcdn.com/g/p/05c96fc1b5b28965ded37e11ba6dd6ef.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i5051345686.html",
        "sold": 1
    },
    {
        "product_name": "Raidlight เสื้อวิ่งแขนกุด ผู้หญิง Trail Raider Tank W, Colour Black",
        "product_image": "https://img.lazcdn.com/g/p/a61a5ac2b2922a9c2beee0b3f247dc30.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i1158908874.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานแขนยาวกันแดดดูดเหงื่อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se43cee07e4c64e18a441512033ee1b298.jpg_200x200q90.jpg",
        "price": 4971.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6014078219.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานฤดูร้อนสำหรับผู้หญิง ซึมซับเหงื่อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf696410101194dda9cede09b7b4675bd9.jpg_200x200q90.jpg",
        "price": 4971.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6014185210.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้ากีฬาจักรยานแขนยาว Lamedda Lampada แห้งเร็ว ระบายอากาศได้ดี สำหรับผู้หญิง ฤดูใบไม้ผลิและฤดูร้อน เสื้อผ้ากีฬาจักรยานเส้นทางและป่า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1ea2bbdffe3d4e2da9b83cda53d3fb52o.jpg_200x200q90.jpg",
        "price": 4967.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5844934359.html",
        "sold": 6
    },
    {
        "product_name": "PGM GOLF | เสื้อยืดกอล์ฟเด็กที่ยืดหยุ่นและมีสไตล์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S95d725b1dee1434fbe3cec8f3ee678a2Y.jpg_200x200q90.jpg",
        "price": 4965.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16110036864.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานผู้หญิงยืดหยุ่นสูง ระบายอากาศได้ดี ดูดเหงื่อแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sca44c213574c4969b181543e836aab64U.jpg_200x200q90.jpg",
        "price": 4963.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6014102851.html",
        "sold": 4
    },
    {
        "product_name": "เสื้อปั่นจักรยานระบายอากาศ แขนสั้นและยาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1141ab20bce04d0eb0ba62a983677392f.jpg_200x200q90.jpg",
        "price": 4960.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5844454835.html",
        "sold": 7
    },
    {
        "product_name": "เสื้อปั่นจักรยานกันแดด ระบายอากาศได้ดี มีความยืดหยุ่นสูง สบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa603d35c169c47eebdb05ca8fd35f40aA.jpg_200x200q90.jpg",
        "price": 4956.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6014023036.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อดำน้ำตื้นนีโอพรีนสำหรับเด็กรุ่น SNK ML 500 หนา 1.5 มม. (สีฟ้า Turquoise) คุ้มค่า คุ้มราคา",
        "product_image": "https://img.lazcdn.com/g/p/eadc4b34a8c9e43ac9f57c806526c50d.jpg_200x200q90.jpg",
        "price": 4954,
        "remark": "https://www.lazada.co.th/products/pdp-i1645768694.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้ากีฬาฤดูใบไม้ร่วง EVR สำหรับผู้หญิง แขนยาว ระบายอากาศได้ดี กันแดด แห้งเร็ว เสื้อผ้ากีฬาจักรยานทางไกล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S26e7d934de124b439cdf807d30965fdcn.png_200x200q90.png",
        "price": 4949.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5841174623.html",
        "sold": 2
    },
    {
        "product_name": "ชุดปั่นจักรยานสไตล์ดุนฮหว่าง แขนยาวและแขนสั้นสำหรับผู้หญิงฤดูใบไม้ผลิและฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S67ec6946470149eaae02a50cd25a2bf0e.jpg_200x200q90.jpg",
        "price": 4949.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5844874923.html",
        "sold": 7
    },
    {
        "product_name": "เสื้อทีเชิร์ตสั้นสไตล์ดิสทรีสซชั้นๆ สนุกสนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S06d47bfa8e5740b4a13518e05fb7ec8cF.jpg_200x200q90.jpg",
        "price": 4946.32,
        "remark": "https://www.lazada.co.th/products/pdp-i16127051104.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้ากีฬาจักรยาน EVR แขนยาวสำหรับผู้หญิง แห้งเร็ว ระบายอากาศได้ดี สะท้อนแสง ฤดูร้อน จักรยานทางบก เสื้อผ้ากีฬาจักรยาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sec05c27d73274817a06d0331172d29f1D.png_200x200q90.png",
        "price": 4942.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5841128287.html",
        "sold": 31
    },
    {
        "product_name": "เสื้อผ้ากีฬาฤดูร้อน EVR Tech สำหรับผู้หญิง เสื้อแขนสั้น ระบายเหงื่อได้ดี ชุดปั่นจักรยานเสือภูเขา ชุดปั่นจักรยาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4120f89900284d18a6e971374778ce0aB.jpg_200x200q90.jpg",
        "price": 4941,
        "remark": "https://www.lazada.co.th/products/pdp-i5841234758.html",
        "sold": 2
    },
    {
        "product_name": "PGM GOLF | กางเกงกอล์ฟเอวยืดปรับได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2167d107f41c4e6095c338a07acfcf84m.jpg_200x200q90.jpg",
        "price": 4940.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6003158966.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานฟิตพอดีตัวแบบกันความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6485757b3d3a4ca692f4e4e73d17cc892.jpg_200x200q90.jpg",
        "price": 4937.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5888274209.html",
        "sold": 23
    },
    {
        "product_name": "Haporri | ชุดนอนผู้หญิงลายลูกไม้เบาสบายสไตล์ซิลค์สำหรับฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saed66c0dfbc94ba8ad19487e9df52164Z.jpg_200x200q90.jpg",
        "price": 4937.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16082442680.html",
        "sold": 0
    },
    {
        "product_name": "Laura Star 1542 Moisture-wicking One-piece Knitted Sports Training Compression Tight Fitness Clothing",
        "product_image": "https://img.lazcdn.com/g/p/212cca6900a6cf0d93d94fa01de5b5a4.jpg_200x200q90.jpg",
        "price": 4932.86,
        "remark": "https://www.lazada.co.th/products/pdp-i6041872836.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานแขนยาวสำหรับผู้หญิงพรีเมียมกัน UV",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sebfab0cc51cb4fdaaf7d14a8a9c49c51m.jpg_200x200q90.jpg",
        "price": 4912.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5841000044.html",
        "sold": 4
    },
    {
        "product_name": "NANEND | ชุดชั้นในกีฬาแห้งเร็ว อบอุ่น ซับเหงื่อได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S22bd854833e4407598ca02fce3ec7339O.jpg_200x200q90.jpg",
        "price": 4894.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5851920290.html",
        "sold": 15
    },
    {
        "product_name": "แจ็คเก็ตขนเป็ดคอตั้งสำหรับเด็กชาย สบายและอบอุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb63d358c442c4378865b1e83dee73851J.jpg_200x200q90.jpg",
        "price": 4892,
        "remark": "https://www.lazada.co.th/products/pdp-i16085362606.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผู้หญิง,เสื้อแขนสั้นผ้าเท่ห์น้ำหนักเบาเสื้อเจอร์ซีย์นักปั่น3D ตัดจักรยาน3กระเป๋าและเรียบ YKK ซิปชุดออกกำลังกายชุดปั่นจักรยาน",
        "product_image": "https://img.lazcdn.com/g/p/2f60c0034ad932be9be71ff33cb87ea0.jpg_200x200q90.jpg",
        "price": 4892,
        "remark": "https://www.lazada.co.th/products/pdp-i5140797330.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟ, กระเป๋าเป้สะพายหลังกันน้ำความจุขนาดใหญ่, กระเป๋าเดินทาง, กระเป๋าสะพายไหล่, กระเป๋ากอล์ฟสองชั้น, กระเป๋าใส่รองเท้า",
        "product_image": "https://img.lazcdn.com/g/p/34c0451d1b2e695044a2d37c4ee27c7e.jpg_webp_200x200q90.jpg",
        "price": 4882.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16147292809.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟ, ใช้ได้ทั้งชายและหญิง, น้ำหนักเบา pu กระเป๋าใส่เสื้อผ้าขนาดใหญ่พร้อมช่องแยกต่างหาก",
        "product_image": "https://img.lazcdn.com/g/p/191b2d7ed51e39c901c98d4bdbd1715a.jpg_200x200q90.jpg",
        "price": 4882.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16147288859.html",
        "sold": 0
    },
    {
        "product_name": "LoveGolf | เสื้อแขนยาวสำหรับกอล์ฟสตรี แห้งเร็ว สัมผัสเย็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S51255a273033451cb128a31662704f19q.jpg_200x200q90.jpg",
        "price": 4855.96,
        "remark": "https://www.lazada.co.th/products/pdp-i6066709898.html",
        "sold": 0
    },
    {
        "product_name": "แจ็กเก็ตขนเป็ดกันหนาวแบบมีฮู้ดสะท้อนแสง น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf31a3372fcec447ab281690c5005dd4bF.jpg_200x200q90.jpg",
        "price": 4852,
        "remark": "https://www.lazada.co.th/products/pdp-i16085494388.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดจับจีบลำลองใหม่สำหรับผู้หญิงหลวม",
        "product_image": "https://img.lazcdn.com/g/p/baccf9d1c14e1390f683845149265b2b.jpg_200x200q90.jpg",
        "price": 3036,
        "remark": "https://www.lazada.co.th/products/pdp-i6038726669.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเวส JPC 2.3 (เสื้อเวส JPC 2.0 + MK3 Chest Rig) (JPC 2.3 Plate Carrier) (JPC 2.0 + MK3 Chest Rig)",
        "product_image": "https://img.lazcdn.com/g/p/618936f1dd67846be02f153db802a556.jpg_200x200q90.jpg",
        "price": 4800,
        "remark": "https://www.lazada.co.th/products/pdp-i5240327527.html",
        "sold": 0
    },
    {
        "product_name": "ชุดสำหรับเด็กรุ่น 200 เหมาะสำหรับผู้เล่นยูโด ไอคิโด และยูยิตสึขั้นเริ่มต้น ขนาดส่วนสูง140ซม. เสื้อคลุมยูโดทั้งตัว ชุดสวมกีฬาไอคิโด ผ้าคลุมออกกำลังกาย EXERCISE SUIT COSTUME จัดส่งฟรี 100 KIDS' JUDO AIKIDO UNIFORM - WHITE",
        "product_image": "https://img.lazcdn.com/g/p/df5f7f066b7260e118f384f0140a4a10.jpg_200x200q90.jpg",
        "price": 4798,
        "remark": "https://www.lazada.co.th/products/pdp-i1025588813.html",
        "sold": 0
    },
    {
        "product_name": "ชุดสำหรับเด็กรุ่น 200 เหมาะสำหรับผู้เล่นยูโด ไอคิโด และยูยิตสึขั้นเริ่มต้น ขนาดส่วนสูง150ซม. เสื้อคลุมยูโดทั้งตัว ชุดสวมกีฬาไอคิโด ผ้าคลุมออกกำลังกาย EXERCISE SUIT COSTUME คุณภาพดี 100 KIDS' JUDO AIKIDO UNIFORM - WHITE",
        "product_image": "https://img.lazcdn.com/g/p/df5f7f066b7260e118f384f0140a4a10.jpg_200x200q90.jpg",
        "price": 4798,
        "remark": "https://www.lazada.co.th/products/pdp-i1025592943.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อผ้ากอล์ฟยืดหยุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S49cde3d32e854ebdb7063909c12c32ab3.jpg_200x200q90.jpg",
        "price": 4784.82,
        "remark": "https://www.lazada.co.th/products/pdp-i6066054424.html",
        "sold": 0
    },
    {
        "product_name": "4F TSHIRT FNK F178",
        "product_image": "https://img.lazcdn.com/g/p/a14524233d802485bf44cf87f0dbd2fa.jpg_200x200q90.jpg",
        "price": 4780,
        "remark": "https://www.lazada.co.th/products/pdp-i4665485819.html",
        "sold": 0
    },
    {
        "product_name": "🔥จัดส่งภายในประเทศ🔥 เสื้อแทคติคอลสีดำ 1000D เกรดหนัก ระบบ MOLLE โมดูลาร์เต็มตัว ปรับขนาดได้ทุกสรีพ ถอดเข้าออกเร็ว แข็งแรงทนรุนแรง เหมาะทั้งเล่นเกมส์ยุทธวิธีหรือเดินป่าลุยฟิลด์",
        "product_image": "https://img.lazcdn.com/g/p/620213a668895dc6837cc7fd99a3128b.jpg_200x200q90.jpg",
        "price": 4778,
        "remark": "https://www.lazada.co.th/products/pdp-i6043220007.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อแขนยาวสำหรับกอล์ฟและเทนนิส ทรงกระโปรง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf6f6631c591e41ee8cd61693f3ecae3cE.jpg_200x200q90.jpg",
        "price": 4773.74,
        "remark": "https://www.lazada.co.th/products/pdp-i6066730570.html",
        "sold": 0
    },
    {
        "product_name": "SWAN LOVE GOLF | เสื้อผ้ากอล์ฟแฟชั่นใหม่ฤดูใบไม้ร่วง ระบายอากาศและดูดซับเหงื่อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8c9b5f61f3304947b681e3244e33d0c6G.jpg_200x200q90.jpg",
        "price": 4764.38,
        "remark": "https://www.lazada.co.th/products/pdp-i6066597353.html",
        "sold": 0
    },
    {
        "product_name": "WOSAWE | WOSAWE เสื้อแจ็คเก็ตและกางเกงมอเตอร์ไซค์สำหรับผู้หญิง ชุดป้องกันเต็มตัว อุปกรณ์ปั่นจักรยานเสือภูเขาลงเขา อุปกรณ์มอเตอร์ไซค์ ชุดแข่งมอเตอร์ครอส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf8bf657be0f04cd1a77f806f6cc612ef7.jpg_200x200q90.jpg",
        "price": 4759.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16103955896.html",
        "sold": 0
    },
    {
        "product_name": "แจ็คเก็ตขนเป็ดกันหนาวแบบสแตนด์คอลแลร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sad3073e1a6cc444f9499657c264822d1e.jpg_200x200q90.jpg",
        "price": 4754,
        "remark": "https://www.lazada.co.th/products/pdp-i16085544266.html",
        "sold": 0
    },
    {
        "product_name": "แจ็คเก็ตขนเป็ดชายกันน้ำแบบหลวมสุดเรียบง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S712c83ae02e2406d8cb2e0fee49ecc4cX.jpg_200x200q90.jpg",
        "price": 4748,
        "remark": "https://www.lazada.co.th/products/pdp-i16085453995.html",
        "sold": 0
    },
    {
        "product_name": "AZUREWAY | เสื้อวิ่งสไตล์สปอร์ตที่มีสไตล์และใช้งานได้หลากหลาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S52eec7c1e75947d184eabf76d44bd206I.jpg_200x200q90.jpg",
        "price": 4732.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6066548842.html",
        "sold": 0
    },
    {
        "product_name": "PGA | เสื้อผ้ากอล์ฟสำหรับผู้หญิงสไตล์เกาหลี แห้งไว แบบใหม่ไฮเอนด์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5d64d6e574f44d48bb85ac2bb58d91f2d.jpg_200x200q90.jpg",
        "price": 4732.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6066842469.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้ากีฬาฤดูร้อน EVR สำหรับผู้หญิง แขนสั้น แห้งเร็ว ดูดซับเหงื่อ รถจักรยานเส้นทาง ระบายอากาศได้ดี เสื้อผ้ากีฬา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S76a1df78fdfa40fba5a36a0d84ed557bx.png_200x200q90.png",
        "price": 4707.18,
        "remark": "https://www.lazada.co.th/products/pdp-i5840640551.html",
        "sold": 29
    },
    {
        "product_name": "ปลอกเสื้อเกราะ เสื้อเวส ปลดไว FCSK 2.0 AFG (AFG FCSK 2.0 plate carrier)[ AFG-VT15 ] Tactical Vest สีพื้น มีช่องใส่เพลทชนิดปาดมุมขนาด  10*12 นิ้ว (หน้า/หลัง) ใช้กับซองแม็กของแบรนด์อื่นๆ ได้ครับ",
        "product_image": "https://img.lazcdn.com/g/p/00ecc20d176d5e6a8ae63bf03161a1d4.jpg_200x200q90.jpg",
        "price": 4700,
        "remark": "https://www.lazada.co.th/products/pdp-i4824141599.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากอล์ฟ Porsche แบบปรับแต่งได้สำหรับผู้ชายและผู้หญิง วัสดุคริสตัล กระเป๋าใส่เสื้อผ้าสองชั้น กระเป๋าใส่รองเท้าแยกต่างหาก กระเป๋าเดินทางน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/533a2fe52a989cd2c9bfedd082acb006.jpg_webp_200x200q90.jpg",
        "price": 4698.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16146907544.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดคอกลมแขนสั้นผู้หญิงฤดูร้อน 2026 ทรงหลวม ลายตัวอักษรเรียบง่าย แฟชั่นลำลอง คอกลม แขนสั้น ผ้าฝ้ายผสม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S026303f768074a69be90c4e1bd848bcfB.jpg_200x200q90.jpg",
        "price": 4696,
        "remark": "https://www.lazada.co.th/products/pdp-i5282462402.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแขนสั้นสไตล์วินเทจสำหรับผู้หญิงใส่สบายในหน้าร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S192d56784dbf4d6e8c2eb2af5b2d320bZ.jpg_200x200q90.jpg",
        "price": 4691.3,
        "remark": "https://www.lazada.co.th/products/pdp-i5927246911.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น W6RI41J1314 สีชมพู",
        "product_image": "https://img.lazcdn.com/g/p/21761aa73da92acb3f513f33f82ae494.jpg_200x200q90.jpg",
        "price": 4662,
        "remark": "https://www.lazada.co.th/products/pdp-i16066338242.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น W6RI41J1314 สีมัลติ",
        "product_image": "https://img.lazcdn.com/g/p/39e46c7b7451e58641e5536cfd54d2e5.jpg_200x200q90.jpg",
        "price": 4662,
        "remark": "https://www.lazada.co.th/products/pdp-i16066123249.html",
        "sold": 0
    },
    {
        "product_name": "GUESS เสื้อยืด ผู้หญิง รุ่น W6GI19K3042  สีน้ำตาล",
        "product_image": "https://img.lazcdn.com/g/p/c55ea56db4982c31113be036be14c68c.jpg_200x200q90.jpg",
        "price": 4662,
        "remark": "https://www.lazada.co.th/products/pdp-i16118692673.html",
        "sold": 0
    },
    {
        "product_name": "GUESS เสื้อยืด ผู้หญิง รุ่น W5GI04J1314  สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/a7439dd23fbf9f0c48505ecc50d551fd.jpg_200x200q90.jpg",
        "price": 4662,
        "remark": "https://www.lazada.co.th/products/pdp-i16118710657.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น W6RP42KCTT1 สีน้ำเงิน",
        "product_image": "https://img.lazcdn.com/g/p/268c8b8520e7c720b8340521a91b7dad.jpg_200x200q90.jpg",
        "price": 4662,
        "remark": "https://www.lazada.co.th/products/pdp-i16066063401.html",
        "sold": 0
    },
    {
        "product_name": "GUESS เสื้อยืด ผู้หญิง รุ่น W5GI04J1314  สีน้ำเงิน",
        "product_image": "https://img.lazcdn.com/g/p/795ab9b6fcbbccaf9ff9fcd262f6336b.jpg_200x200q90.jpg",
        "price": 4662,
        "remark": "https://www.lazada.co.th/products/pdp-i16118465426.html",
        "sold": 0
    },
    {
        "product_name": "ชุดโยคะแขนยาว ZASUWA สำหรับผู้หญิง ชุดกีฬาสุดเซ็กซี่ ทรงเข้ารูป สไตล์สปอร์ต ชุดโยคะพิเศษ ความแข็งแรงสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1decbf867a1a45f39faf6480bb845ca7M.jpg_200x200q90.jpg",
        "price": 4656,
        "remark": "https://www.lazada.co.th/products/pdp-i5507585928.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเจอร์ซีย์นักปั่นผู้หญิง,แขนสั้นระบายอากาศได้ดีน้ำหนักเบาฤดูร้อนแห้งเร็วชุดปั่นจักรยานขับบนถนน",
        "product_image": "https://img.lazcdn.com/g/p/43d97f73de09ce945e61eb5501b4d0db.jpg_200x200q90.jpg",
        "price": 4636,
        "remark": "https://www.lazada.co.th/products/pdp-i5766426108.html",
        "sold": 3
    },
    {
        "product_name": "TA ACTIVE JESSICA JUMPSUIT ชุดจั้มสูท",
        "product_image": "https://img.lazcdn.com/g/p/c5d71637bd0231fba8a54d9901672041.jpg_200x200q90.jpg",
        "price": 4624,
        "remark": "https://www.lazada.co.th/products/pdp-i421346922.html",
        "sold": 3
    },
    {
        "product_name": "René Sleeveless polo top",
        "product_image": "https://img.lazcdn.com/g/p/630801def8b45e4401b3479b76a843bc.jpg_200x200q90.jpg",
        "price": 4620,
        "remark": "https://www.lazada.co.th/products/pdp-i5753036572.html",
        "sold": 0
    },
    {
        "product_name": "Balneaire | ชุดว่ายน้ำแบบชิ้นเดียวสำหรับเด็กหญิง พร้อมฟองน้ำป้องกันแดดและระบายอากาศได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S685cf5c8f7424b7c9e66afa8bbc894c79.png_200x200q90.png",
        "price": 4617.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5893993488.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเสื้อเจอร์ซีย์นักปั่นปั่นจักรยานกลางแจ้ง,เสื้อปั่นจักรยานเสือภูเขาแห้งเร็วเบาสวมใส่สบาย",
        "product_image": "https://img.lazcdn.com/g/p/64773bda352f822d3206102ee77d34f9.jpg_200x200q90.jpg",
        "price": 4616,
        "remark": "https://www.lazada.co.th/products/pdp-i5760008518.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานแห้งไวสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S472c821422d1490eaf3677367e676e07B.jpg_200x200q90.jpg",
        "price": 4597.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5880014645.html",
        "sold": 12
    },
    {
        "product_name": "🖤❤️New+พร้อมส่ง🖤❤️เสื้อยืดแบรน Endless♾️holiday X Hello Kitty🖤รุ่นใหม่ดรอฟสอง ลายสวย🖤คลาสสิค❤️ใส่ได้บ่อย ผ้าดี ใส่สบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seb2b5cd89e124f6ead1c2ca9bd4aae3do.jpg_200x200q90.jpg",
        "price": 4580,
        "remark": "https://www.lazada.co.th/products/pdp-i16109324212.html",
        "sold": 0
    },
    {
        "product_name": "Gommie เสื้อกั๊กออกกำลังกายเสื้อแจ็คเก็ตถ่วงน้ำหนักสำหรับดำน้ำ,เสื้อกั๊กสวมวิ่งฝึกออกกำลังกายฟิตเนสปรับน้ำหนักได้",
        "product_image": "https://img.lazcdn.com/g/p/685a77a011f3b92c405b50fdbc4791a7.jpg_200x200q90.jpg",
        "price": 4580,
        "remark": "https://www.lazada.co.th/products/pdp-i6043921702.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานสตรีแห้งไวระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6c7ae3c9673e45ea965e91fd35d949435.jpg_200x200q90.jpg",
        "price": 4572.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5879294337.html",
        "sold": 2
    },
    {
        "product_name": "เสื้อปั่นจักรยานฤดูร้อนสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbf8fa31e2cef4b02928a180c6d0b5a71B.jpg_200x200q90.jpg",
        "price": 4572.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5840846785.html",
        "sold": 0
    },
    {
        "product_name": "AZUREWAY | เสื้อกั๊กกอล์ฟสตรีแฟชั่นสไตล์เกาหลี V-Neck ฤดูใบไม้ร่วงและหนาวใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3255d0760f59457bb548383df30cbfc9R.jpg_200x200q90.jpg",
        "price": 4570.62,
        "remark": "https://www.lazada.co.th/products/pdp-i6066523524.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกั๊กน้ำหนักจรวดดวงจันทร์เสื้อกั๊กสวมวิ่งเสื้อแจ็คเก็ตถ่วงน้ำหนักสำหรับออกกำลังกายเสื้อกั๊กสำหรับออกกำลังกายออกกำลังกายยิมเสื้อกั๊กน้ำหนักบรรทุกปรับได้สำหรับการดำน้ำตื้นเพาะกาย",
        "product_image": "https://img.lazcdn.com/g/p/3f671160930564087adb67157cfdae94.jpg_200x200q90.jpg",
        "price": 4494,
        "remark": "https://www.lazada.co.th/products/pdp-i5938593014.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานผู้หญิงยืดหยุ่นและระบายอากาศ สไตล์วินเทจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S642c44b75ea3483f97a95d8e04c606baW.jpg_200x200q90.jpg",
        "price": 4473.62,
        "remark": "https://www.lazada.co.th/products/pdp-i6014071243.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อปั่นจักรยานกันแดด ระบายเหงื่อ ยืดหยุ่นได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S22223612a5d143dab7861a890c3e6e12t.jpg_200x200q90.jpg",
        "price": 4467.9,
        "remark": "https://www.lazada.co.th/products/pdp-i6014096886.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อผ้าผู้หญิงไซส์ใหญ่ ให้ความรู้สึกหรูหรา ชุดเสื้อผ้าไหมแขนสั้น เสื้อและกางเกง 2 ชิ้น สไตล์ฤดูร้อนใหม่ เหมาะสำหรับใส่ไปทำงาน แซนชาโมเร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4b3fa98dd66448fab652be9efe5318c9I.jpg_200x200q90.jpg",
        "price": 4340.32,
        "remark": "https://www.lazada.co.th/products/pdp-i16084263444.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อโยคะสุดกระชับ ระบายเหงื่อ ใส่สบาย ไม่มีหลัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S084145c9a57544c68a111f6944b5b4dfE.jpg_200x200q90.jpg",
        "price": 4454,
        "remark": "https://www.lazada.co.th/products/pdp-i16139655285.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกุยเฮง 30 ตัว ผ้านิ่มใส่สบาย ไม่ร้อน  (Y02)",
        "product_image": "https://img.lazcdn.com/g/p/3a42f33f27558a4c26e00c99010f7675.jpg_200x200q90.jpg",
        "price": 4440,
        "remark": "https://www.lazada.co.th/products/pdp-i5230772026.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานแขนยาวกันแดดและดูดซับความชื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5d71c6cc0a1e43ce94785a0224812353Z.jpg_200x200q90.jpg",
        "price": 4432,
        "remark": "https://www.lazada.co.th/products/pdp-i5982094710.html",
        "sold": 0
    },
    {
        "product_name": "COLDELEMENT | เสื้อแจ็คเก็ตสกีเด็ก Coldelement สำหรับเด็กชายและเด็กหญิง อบอุ่น กันน้ำ ใส่ได้ทั้งเล่นสเก็ตบอร์ดและสเก็ตบอร์ดคู่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S29dd796e48ef40d6a340245ce8cb17dak.png_200x200q90.png",
        "price": 4424.64,
        "remark": "https://www.lazada.co.th/products/pdp-i5851689611.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS ชุดปั่นจักรยาน TVI สำหรับผู้หญิงชุดปั่นจักรยานแขนยาวระบายอากาศได้สวมใส่สบายชุดกิจกรรมกลางแจ้งสูทกันลมกีฬาป้องกันแสงแดด",
        "product_image": "https://img.lazcdn.com/g/p/81822b4df279868d1343babbb0e6ff81.jpg_200x200q90.jpg",
        "price": 4420,
        "remark": "https://www.lazada.co.th/products/pdp-i5725614532.html",
        "sold": 0
    },
    {
        "product_name": "F426 | แจ็คเก็ตเบสบอลลายปักสุนัขสไตล์อิลลัสเตรท ใส่ได้หลายโอกาส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S92085825218f471785f86425577f4117Y.png_200x200q90.png",
        "price": 4418,
        "remark": "https://www.lazada.co.th/products/pdp-i6006611739.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อแจ็คเก็ตสำหรับขี่จักรยานกันหนาว ชั้นใน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4a4add9fb65940ea9f892ade7b11d601P.jpg_200x200q90.jpg",
        "price": 4417.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5880256796.html",
        "sold": 3
    },
    {
        "product_name": "เสื้อจักรยานพื้นฐานสำหรับสตรี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9727774c5fe5463aa51f144d3a754d0fP.jpg_200x200q90.jpg",
        "price": 4417.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5880117049.html",
        "sold": 0
    },
    {
        "product_name": "GUESS เสื้อยืดแขนสั้นผู้หญิง รุ่น V5GI10K9RM1 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/07f18423ef57d64c31fec29e9d5de188.jpg_200x200q90.jpg",
        "price": 4404,
        "remark": "https://www.lazada.co.th/products/pdp-i6042997149.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI06KD741 สีเบจ",
        "product_image": "https://img.lazcdn.com/g/p/545a9cb352e04495dba02284f4ea29f6.jpg_200x200q90.jpg",
        "price": 4404,
        "remark": "https://www.lazada.co.th/products/pdp-i16066354182.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI06KD741 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/21f8ec0b35b2a07d1f6ab97756a68a1c.jpg_200x200q90.jpg",
        "price": 4404,
        "remark": "https://www.lazada.co.th/products/pdp-i16066364188.html",
        "sold": 0
    },
    {
        "product_name": "René short-sleeve polo top",
        "product_image": "https://img.lazcdn.com/g/p/bddf7efac820282c70563e6bc6ed56e0.jpg_200x200q90.jpg",
        "price": 4400,
        "remark": "https://www.lazada.co.th/products/pdp-i5753043530.html",
        "sold": 5
    },
    {
        "product_name": "เสื้อ FCSK 3.1 (เสื้อ FCSK 3.0 + แผงแบบ4ช่อง) (FCSK 3.1 P Carrier) (FCSK 3.0 + Quadruple M Plate)",
        "product_image": "https://img.lazcdn.com/g/p/eec0915f37919991822cc23bb8fe3493.jpg_200x200q90.jpg",
        "price": 4400,
        "remark": "https://www.lazada.co.th/products/pdp-i5749590382.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อลายดิสโก้และคลื่นเสียง Sunniiee ถังน้ำแข็งฉนวนกันความร้อนที่ไม่ซ้ำกันสำหรับบุฟเฟ่ต์กิจกรรมกลางแจ้งในช่วงฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/fe9631c34c8a5250bd7eba4ebe2fcc30.jpg_200x200q90.jpg",
        "price": 4392,
        "remark": "https://www.lazada.co.th/products/pdp-i6023095559.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อลายดิสโก้และคลื่นเสียงฮารายาถังน้ำแข็งฉนวนกันความร้อนที่ไม่ซ้ำใครสำหรับบุฟเฟ่ต์กิจกรรมกลางแจ้งในช่วงฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/8222727e7cfc1d9d9b2f8da710158b02.jpg_200x200q90.jpg",
        "price": 4392,
        "remark": "https://www.lazada.co.th/products/pdp-i6022894623.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อลายดิสโก้และคลื่นเสียงของ Sharprepublic ถังน้ำแข็งฉนวนที่ไม่ซ้ำกันสำหรับบุฟเฟ่ต์กิจกรรมกลางแจ้งในช่วงฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/dde85c602075efb22fdc2a8f5fab935d.jpg_200x200q90.jpg",
        "price": 4392,
        "remark": "https://www.lazada.co.th/products/pdp-i6022746732.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเจอร์ซีย์นักปั่นสำหรับผู้หญิง,แคมปิ้งกีฬากลางแจ้งระบายอากาศได้สวมใส่สบายปีนเขาแจ็กเก็ตแขนยาวซิปคู่",
        "product_image": "https://img.lazcdn.com/g/p/32f958142ad958804da18e84602352af.jpg_200x200q90.jpg",
        "price": 4388,
        "remark": "https://www.lazada.co.th/products/pdp-i5724645447.html",
        "sold": 0
    },
    {
        "product_name": "TOOCH - Open Back Bodysuit",
        "product_image": "https://img.lazcdn.com/g/p/ab06ad2eae2552ed0fad5104cbf7d725.jpg_200x200q90.jpg",
        "price": 4380,
        "remark": "https://www.lazada.co.th/products/pdp-i5783168177.html",
        "sold": 9
    },
    {
        "product_name": "AZUREWAY | เสื้อแขนยาวกอล์ฟแฟชั่น สปอร์ตสำหรับผู้หญิง ฤดูใบไม้ร่วง-หนาว คอตั้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5d4577abac794f0891ef6290e5e6cf1da.jpg_200x200q90.jpg",
        "price": 4362.9,
        "remark": "https://www.lazada.co.th/products/pdp-i6066446704.html",
        "sold": 0
    },
    {
        "product_name": "WOSAWE | WOSAWE เสื้อแจ็คเก็ตมอเตอร์ไซค์สำหรับผู้หญิงฤดูร้อน ชุดกางเกงมอเตอร์ครอสระบายอากาศ ชุดเสื้อผ้ากีฬากลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S67811f848c8a47848356cc518cd5bef4j.jpg_200x200q90.jpg",
        "price": 4355.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16126898465.html",
        "sold": 0
    },
    {
        "product_name": "【Cai hot】 Mens Basketball Shirt Sportswear Girls Basketball Jersey Quick dry Fashion Comfortable Clothing Women Basketball Uniform",
        "product_image": "https://img.lazcdn.com/g/p/9571d1c6fdecbafd40537ce3a1d83f6c.png_200x200q90.png",
        "price": 4353.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6055538985.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกั๊กเด็กกันลมและอบอุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S16fdb03f2ae743a6900de03f8a121798w.jpg_200x200q90.jpg",
        "price": 4330,
        "remark": "https://www.lazada.co.th/products/pdp-i16085654233.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกั๊กป้องกันลมสีบล็อกสำหรับวัยรุ่น คอตั้ง ให้ความอบอุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S16fdb03f2ae743a6900de03f8a121798w.jpg_200x200q90.jpg",
        "price": 4330,
        "remark": "https://www.lazada.co.th/products/pdp-i16085545792.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกั๊กขนนกป้องกันลมและเก็บความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S16fdb03f2ae743a6900de03f8a121798w.jpg_200x200q90.jpg",
        "price": 4330,
        "remark": "https://www.lazada.co.th/products/pdp-i16085709088.html",
        "sold": 0
    },
    {
        "product_name": "Elle | เสื้อถักแขนสั้นสไตล์ออฟฟิศหรูหรา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7f478e370d4f4713997a7e505920186d1.png_200x200q90.png",
        "price": 4325.66,
        "remark": "https://www.lazada.co.th/products/pdp-i5881097844.html",
        "sold": 10
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟเกาหลี, กระเป๋าถือ, กระเป๋าสะพายข้าง, กระเป๋าเดินทาง, กระเป๋าบอสตัน, กระเป๋าใส่เสื้อผ้ากอล์ฟเกาหลี",
        "product_image": "https://img.lazcdn.com/g/p/992dd3c3536f74e16e7f8e68d63cfb19.jpg_webp_200x200q90.jpg",
        "price": 4323.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16147224526.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟสไตล์เกาหลีใหม่ กระเป๋าถือแฟชั่น กันน้ำ ใช้ได้ทั้งชายและหญิง ความจุขนาดใหญ่ เหมาะสำหรับการเดินทางกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/e1d3ef7f1b30765eb1774b7a8fd838a5.jpg_webp_200x200q90.jpg",
        "price": 4323.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16146879104.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกั๊กสำหรับเด็กกันลมและกันหนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S16fdb03f2ae743a6900de03f8a121798w.jpg_200x200q90.jpg",
        "price": 4318,
        "remark": "https://www.lazada.co.th/products/pdp-i16085787026.html",
        "sold": 0
    },
    {
        "product_name": "Lalizas เสื้อพยุงตัว Buoyancy Aid, Neo 50N, ISO 12402-5 40-50kg 71069",
        "product_image": "https://img.lazcdn.com/g/p/e32bf942b8ac6c2ee02eea08b08b7ac5.jpg_200x200q90.jpg",
        "price": 4300,
        "remark": "https://www.lazada.co.th/products/pdp-i2461736985.html",
        "sold": 0
    },
    {
        "product_name": "PUMA | เสื้อแขนยาวกีฬาฤดูหนาวที่ทนทานและระบายอากาศได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S260102e45fcc4b0e83e797f665a02122Z.jpg_200x200q90.jpg",
        "price": 4300,
        "remark": "https://www.lazada.co.th/products/pdp-i16111861814.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟสไตล์เกาหลีใหม่ ทันสมัยและใช้ได้ทั้งชายและหญิง กระเป๋าถือความจุขนาดใหญ่ pu กระเป๋าสะพายข้างที่ทนทาน",
        "product_image": "https://img.lazcdn.com/g/p/93c165917a69507408109780436911b8.jpg_webp_200x200q90.jpg",
        "price": 4266.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16146813360.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | เสื้อกั๊กอุ่น ดูดี ช่วยเพรียวบาง สำหรับฤดูหนาวและฤดูใบไม้ร่วง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfa885a64d0544c1b996bcc57ae4c8a87l.jpg_200x200q90.jpg",
        "price": 4265.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6066913112.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อตกปลาระบายอากาศแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa8099a67eb2840cbb7b963a86c4ceba5S.png_200x200q90.png",
        "price": 4247.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16119727704.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดผู้หญิงสลิมมิ่งลำลอง,สีทึบย้อนยุค",
        "product_image": "https://img.lazcdn.com/g/p/b8cdff5d87b6c28962ea498f94d0f6c3.jpg_200x200q90.jpg",
        "price": 4240,
        "remark": "https://www.lazada.co.th/products/pdp-i6024943888.html",
        "sold": 0
    },
    {
        "product_name": "PGA | เสื้อยืดแขนสั้นระบายอากาศแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S78f98dec6cfd4c51ad53852c145a0ed2T.jpg_200x200q90.jpg",
        "price": 4239.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6066887426.html",
        "sold": 0
    },
    {
        "product_name": "AZUREWAY | เสื้อผ้าแฟชั่นใหม่ฤดูใบไม้ร่วง-หนาว แขนยาว คอปก สำหรับเล่นกอล์ฟ สตรี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf74b0d7434604b70b5e41edea1a2a9d8Q.jpg_200x200q90.jpg",
        "price": 4239.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6066430660.html",
        "sold": 0
    },
    {
        "product_name": "AZUREWAY | เสื้อผ้ากอล์ฟสำหรับผู้หญิงทนทาน ระบายอากาศและแห้งไว สีตัดกัน แขนยาวยืดหยุ่นสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S37707e932d57417aa9c55a463a971d55w.jpg_200x200q90.jpg",
        "price": 4238.32,
        "remark": "https://www.lazada.co.th/products/pdp-i6066591678.html",
        "sold": 0
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดแขนยาวสำหรับเด็กที่ระบายอากาศได้และให้พลังงาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb854814a767a45c4bee797f700d03debx.png_200x200q90.png",
        "price": 4231.86,
        "remark": "https://www.lazada.co.th/products/pdp-i6048113332.html",
        "sold": 5
    },
    {
        "product_name": "เสื้อแขนสั้นสำหรับขี่จักรยานระบายอากาศและแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf63e4208247d44cb8bc5604d59f67b042.jpg_200x200q90.jpg",
        "price": 4230.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5880748428.html",
        "sold": 14
    },
    {
        "product_name": "ONIJIE | กางเกงรัดกล้ามเนื้อวิ่งสำหรับผู้หญิง ฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc40fc0acbb21460090b7c49b92e602d1O.jpg_200x200q90.jpg",
        "price": 4213.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16101078640.html",
        "sold": 8
    },
    {
        "product_name": "แจ็คเก็ตขนนกสั้นสำหรับเด็กชาย คอตั้งสะท้อนแสง น้ำหนักเบา พร้อมฉนวนกันความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scd91d1e1ab0e4520bd6a92b0bcc07dd4S.jpg_200x200q90.jpg",
        "price": 4210,
        "remark": "https://www.lazada.co.th/products/pdp-i16085713107.html",
        "sold": 0
    },
    {
        "product_name": "Fairtex เสื้อรัดรูป RG9 สี Black เสื้อ rashguard แขนยาว ใส่ฟิตเนส ซ้อมมวย ระบายอากาศดี ยืดหยุ่นสูง ลดกลิ่นอับ",
        "product_image": "https://img.lazcdn.com/g/p/d71a1f7a8a02463983b6898cec6bfe59.png_200x200q90.png",
        "price": 4200,
        "remark": "https://www.lazada.co.th/products/pdp-i5627225515.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้าแฟชั่น ขายส่ง ราคาถูกกว่าประตูน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc337e9b5b7cc497d8a4d4397a34638c07.jpg_200x200q90.jpg",
        "price": 4200,
        "remark": "https://www.lazada.co.th/products/pdp-i2907858795.html",
        "sold": 0
    },
    {
        "product_name": "VONSU | ชุดฝึกบัลเลต์แขนยาวปักลาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S95b1a542ff1e4fdab8fd2ac452ba160dh.jpg_200x200q90.jpg",
        "price": 4185,
        "remark": "https://www.lazada.co.th/products/pdp-i6014054058.html",
        "sold": 0
    },
    {
        "product_name": "Pre-Order_Sizzlin' Mesh Boxy Crop Top (เสื้อออกกำลังกายซุมบ้า)",
        "product_image": "https://img.lazcdn.com/g/p/128cc03c5ea6923275e646d78fc676b7.jpg_200x200q90.jpg",
        "price": 4180,
        "remark": "https://www.lazada.co.th/products/pdp-i5863757256.html",
        "sold": 0
    },
    {
        "product_name": "Pre-Order_Sizzlin' Boxy Dolman Crop Top (เสื้อออกกำลังกายซุมบ้า)",
        "product_image": "https://img.lazcdn.com/g/p/043e6b9ebcd74ef78f1d09cd66f3c8d1.jpg_200x200q90.jpg",
        "price": 4180,
        "remark": "https://www.lazada.co.th/products/pdp-i5863705650.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อแจ็คเก็ตปั่นจักรยานฤดูใบไม้ร่วง/ฤดูหนาวสำหรับผู้หญิง ป้องกันลม อบอุ่น ปั่นจักรยานทางบก จักรยานปั่นบนภูเขา รถจักรยานยนต์ รถจักรยานยนต์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2d44433f39bc4b3d8fac9c73e1693cf5I.jpg_200x200q90.jpg",
        "price": 4152,
        "remark": "https://www.lazada.co.th/products/pdp-i5797513172.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อแขนสั้นระบายอากาศสำหรับผู้หญิงเสื้อเจอร์ซีย์นักปั่นพิมพ์ลายการ์ตูนเสื้อขี่จักรยาน3กระเป๋าและเรียบ YKK ซิปชุดออกกำลังกายชุดปั่นจักรยาน",
        "product_image": "https://img.lazcdn.com/g/p/474ba253041422e6c5fd2ababa4502c7.jpg_200x200q90.jpg",
        "price": 4150,
        "remark": "https://www.lazada.co.th/products/pdp-i5131606631.html",
        "sold": 6
    },
    {
        "product_name": "ชุดเสื้อกีฬาระบายอากาศได้ดีมีซิปสองชั้นสำหรับผู้หญิงเสื้อกั๊กนักปั่นจักรยานขี่จักรยานไปทำกิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/af5648e47f854306598c17c35d597258.jpg_200x200q90.jpg",
        "price": 4150,
        "remark": "https://www.lazada.co.th/products/pdp-i5732276488.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้ากอล์ฟสตรีป้องกัน UV ระบายอากาศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S63a29111f827407abe9e36e3ad3fdcbd7.jpg_200x200q90.jpg",
        "price": 4142.44,
        "remark": "https://www.lazada.co.th/products/pdp-i6066453912.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟสไตล์เกาหลีใหม่, กระเป๋าถือแบบยูนิเซ็กส์, กระเป๋าสะพายไหล่, กระเป๋าสะพายข้าง, กระเป๋าเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/2db90505474c01df996983cc829eacdf.jpg_webp_200x200q90.jpg",
        "price": 4139.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16147246777.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกั๊กเสื้อกั๊กนักปั่นจักรยานสำหรับผู้หญิง,เสื้อกั๊กจักรยานเสือหมอบเสือเอ็มทีบีระบายอากาศได้ดีมีซิปสองชั้นเสื้อกั๊กออกกำลังกายกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/88df059dd3baec3ead109db37677b24a.jpg_200x200q90.jpg",
        "price": 4136,
        "remark": "https://www.lazada.co.th/products/pdp-i5732478196.html",
        "sold": 0
    },
    {
        "product_name": "GUESS เสื้อยืด ผู้หญิง รุ่น W6GI38K3307  สีเขียว",
        "product_image": "https://img.lazcdn.com/g/p/2ac0900c892663c353dab3b25ac23bc1.jpg_200x200q90.jpg",
        "price": 4122,
        "remark": "https://www.lazada.co.th/products/pdp-i16118545085.html",
        "sold": 0
    },
    {
        "product_name": "GUESS เสื้อยืด ผู้หญิง รุ่น W6GI40K3532  สีขาว",
        "product_image": "https://img.lazcdn.com/g/p/f6ac8c0fd6c1148ca214895a0da5a86f.jpg_200x200q90.jpg",
        "price": 4122,
        "remark": "https://www.lazada.co.th/products/pdp-i16118439591.html",
        "sold": 0
    },
    {
        "product_name": "Balneaire | ชุดว่ายน้ำเด็กพิมพ์ลาย นุ่มสบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc03639e21ea74fffbec36f010608f7c03.png_200x200q90.png",
        "price": 4119.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5893852159.html",
        "sold": 2
    },
    {
        "product_name": "เสื้อวิ่งฤดูร้อน Lamedda Lampada แขนสั้นระบายอากาศได้ดีป้องกันรังสียูวีเอฟเบื้องต้นเสื้อผ้ากีฬาจักรยานเสือภูเขาเส้นทาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4b0a050de04341c6a3f882a7205118e3q.jpg_200x200q90.jpg",
        "price": 4113.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5845053088.html",
        "sold": 9
    },
    {
        "product_name": "เสื้อออกกำลังกายแขนยาวผู้หญิง,เสื้อเจอร์ซีย์นักปั่นระบายอากาศได้ดีเสื้อปั่นจักรยานตัด3D มี3กระเป๋าและเรียบชุดออกกำลังกายชุดปั่นจักรยาน",
        "product_image": "https://img.lazcdn.com/g/p/fae2e71a280d857f7bca32b9578e3d1e.jpg_200x200q90.jpg",
        "price": 4106,
        "remark": "https://www.lazada.co.th/products/pdp-i5159234834.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อปั่นจักรยานลายพิมพ์ซีรีส์สำรวจ ฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2f6d7831f3eb411ca82c5474f84ebe8eJ.jpg_200x200q90.jpg",
        "price": 4100.78,
        "remark": "https://www.lazada.co.th/products/pdp-i6014043754.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟสไตล์เกาหลีใหม่ แบบยูนิเซ็กส์ ความจุขนาดใหญ่ กระเป๋ากันน้ำ กระเป๋าเดินทาง กระเป๋าเก็บของความจุขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/de6c6dff7ec086408635d244e86a265c.jpg_webp_200x200q90.jpg",
        "price": 4082.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16147196973.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟสำหรับผู้ชายแบบใหม่จากเกาหลี ความจุขนาดใหญ่ ดีไซน์เดียวกัน กระเป๋าถือสำหรับเก็บเสื้อผ้ากอล์ฟ กระเป๋าลำลอง",
        "product_image": "https://img.lazcdn.com/g/p/2122ae7050b1324643c7a147faa366f5.jpg_webp_200x200q90.jpg",
        "price": 4082.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16146771382.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อชุดจูงใจ VENUM Liquid First สำหรับฝึกซ้อมจูงใจ ชุดจูงใจสำหรับผู้ชายและผู้หญิง ชุดจูงใจสำหรับฝึกซ้อมจูงใจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S23d607e07121478c8d2d8601cb89bae0W.jpg_200x200q90.jpg",
        "price": 4060,
        "remark": "https://www.lazada.co.th/products/pdp-i5434633585.html",
        "sold": 12
    },
    {
        "product_name": "HUMTTO | เสื้อคอปกแขนสั้นซัมเมอร์ ดูดซับเหงื่อ ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3f8645542c774ae2bdcce34e54162c11z.jpg_200x200q90.jpg",
        "price": 4059.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6013970657.html",
        "sold": 0
    },
    {
        "product_name": "COLDELEMENT | เสื้อสกีแห้งไวสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2ea4c5cfc04446f8982b3cde7c74f63a3.jpg_200x200q90.jpg",
        "price": 4044.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5951719965.html",
        "sold": 9
    },
    {
        "product_name": "GELUOLIAN | ชุดแมทช์กีฬาลำลองพร้อมพลอยสังเคราะห์คุณภาพดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S403c8d7e6d174140810e5d878832b13bk.jpg_200x200q90.jpg",
        "price": 4012.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5878772364.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS เสื้อแขนยาวสำหรับจักรยานกันลมมีซิปสำหรับผู้หญิง,เสื้อโค้ทจักรยานเสือหมอบกันลมให้ความอบอุ่นจาก YKK",
        "product_image": "https://img.lazcdn.com/g/p/d679838d0b19f82b7409b1a552662873.jpg_200x200q90.jpg",
        "price": 4004,
        "remark": "https://www.lazada.co.th/products/pdp-i5383794717.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อ FCSK 3.4 (เสื้อ FCSK 3.0 + เพ้า KTAR (แบบ3ช่อง)) (FCSK 3.4 P Carrier) (FCSK 3.0 + KTAR Front Flap)",
        "product_image": "https://img.lazcdn.com/g/p/523006f0b00039f3496ab9b3ae22a722.jpg_200x200q90.jpg",
        "price": 4000,
        "remark": "https://www.lazada.co.th/products/pdp-i5754058056.html",
        "sold": 0
    },
    {
        "product_name": "VALOR PX - NATIVE BDU Shirt เสื้อฝึกลายพราง ทบ. (เฉพาะเสื้อเท่านั้น) ชุดฝึกปฏิบัติการ ชุดฝึกพราง RTA",
        "product_image": "https://img.lazcdn.com/g/p/d349940e846e4f0ffba917831c049ca5.jpg_200x200q90.jpg",
        "price": 4000,
        "remark": "https://www.lazada.co.th/products/pdp-i5728378987.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อผ้าปั่นจักรยานแขนยาวผู้หญิง Lamedda Lampada ฤดูใบไม้ร่วง/ฤดูหนาว ความหนา 5-15 องศาเซลเซียส อบอุ่น สีบล็อก เสื้อผ้าปั่นจักรยาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd45eb942fad84d8aa3cdce061fe8ce71I.jpg_200x200q90.jpg",
        "price": 3995.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5844972173.html",
        "sold": 1
    },
    {
        "product_name": "Peaches ACTIVE - Halter V-Corset Crop (Baby Yellow) เสื้อครอปออกกำลังกาย",
        "product_image": "https://img.lazcdn.com/g/p/d9291bedb6c1c01f7f2505ec1880dc8f.jpg_200x200q90.jpg",
        "price": 3986.46,
        "remark": "https://www.lazada.co.th/products/pdp-i6052043903.html",
        "sold": 0
    },
    {
        "product_name": "【TI hot】 Youth Boys Compression Leggings Top Long Sleeve Sports Tights Running Basketball Base Layer Children Quick Drying Fitness Suit",
        "product_image": "https://img.lazcdn.com/g/p/4cbf70454047d3326d1f502a31cff411.png_200x200q90.png",
        "price": 3980.62,
        "remark": "https://www.lazada.co.th/products/pdp-i6076195769.html",
        "sold": 0
    },
    {
        "product_name": "TAactive Physique polo เสื้อตีกอล์ฟ เสื้อตีเทนนิส ชุดกอล์ฟ เสื้อกอล์ฟผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/3856f2ae5f59b926c500282e37fc9918.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i16052106202.html",
        "sold": 0
    },
    {
        "product_name": "🌸🖤พร้อมส่ง🌸🖤เสื้อยืดคอลใหม่แบรน Endless♾️holiday💗ลายสวย📸ถ่ายรูปสวย ผ้าดี ใส่สบาย ใส่คู่ครอบครัวสวย🖤🌸ลายพิมพ์ทันสมัย🌸",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S53d402beed2b4ee89564f8af283f1573X.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5373502914.html",
        "sold": 1
    },
    {
        "product_name": "(New FALL D2 2025) Tavi Apparel Perfect Rib Tank Ruby เสื้อออกกำลังกาย",
        "product_image": "https://img.lazcdn.com/g/p/69ded4116ca86155479c764adb9adf68.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5873729978.html",
        "sold": 0
    },
    {
        "product_name": "Cside - Snoopy Classic Collection",
        "product_image": "https://img.lazcdn.com/g/p/477dabaac9df3b4fb149e9d44ebfc610.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5722421078.html",
        "sold": 64
    },
    {
        "product_name": "Tavi Noir แทวี นัวร์ เสื้อออกกำลังกาย Braided Strap Tank",
        "product_image": "https://img.lazcdn.com/g/p/46d314e015af5ea3f4481444b8864d5d.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i2677521066.html",
        "sold": 0
    },
    {
        "product_name": "Tavi Noir แทวี นัวร์ Tie Back Tank เสื้อออกกำลังกาย รุ่น Tie Back Tank",
        "product_image": "https://img.lazcdn.com/g/p/479c07f67122c81cda853b45d3576ae0.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i4486227252.html",
        "sold": 0
    },
    {
        "product_name": "Maison Nabi - Nabi Halter เสื้อคล้องคอสปอร์ตบรา เสื้อผ้าออกกำลังกาย โยคะ พิลาทิส (Pilates) เสื้อกีฬา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4e7b53fc47cf4e349dfe5cfa6511336eD.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5975099432.html",
        "sold": 0
    },
    {
        "product_name": "Adrien Court tennis women Polo",
        "product_image": "https://img.lazcdn.com/g/p/b5f071fcc09b23cba10660b99183d283.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i6010228580.html",
        "sold": 0
    },
    {
        "product_name": "Tavi Noir แทวี นัวร์ Perfect Fit Rib Tank เสื้อออกกำลังกาย รุ่น Perfect Fit Rib Tank",
        "product_image": "https://img.lazcdn.com/g/p/befa5ba3959979a8dedf7df819a99c3b.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i4486035990.html",
        "sold": 0
    },
    {
        "product_name": "ชุดปั่นจักรยานสำหรับผู้ชายในฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0788befaa9b641a28da6d68562bcadfdA.jpg_200x200q90.jpg",
        "price": 3977.76,
        "remark": "https://www.lazada.co.th/products/pdp-i5845088301.html",
        "sold": 96
    },
    {
        "product_name": "เสื้อยืดแฟชั่นจีบผู้หญิงหลวมใหม่",
        "product_image": "https://img.lazcdn.com/g/p/2652603f6815330d23d0ca77b2a63b41.jpg_200x200q90.jpg",
        "price": 3968,
        "remark": "https://www.lazada.co.th/products/pdp-i6046355785.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | เสื้อยืดเด็กชายซับเหงื่อแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S590334c764fa4dfe8cc63f667dc371a3X.jpg_200x200q90.jpg",
        "price": 3967.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16055252485.html",
        "sold": 0
    },
    {
        "product_name": "Amoresy Vixen Series Long Sleeve Sports Tights Color Matching Pants Waist Slim High Elastic Swimming",
        "product_image": "https://img.lazcdn.com/g/p/efa4bdb7c93558fcdb7b92eb2f067002.jpg_200x200q90.jpg",
        "price": 3966,
        "remark": "https://www.lazada.co.th/products/pdp-i16094450780.html",
        "sold": 0
    },
    {
        "product_name": "Femt Golf | เสื้อผู้หญิงแขนยาวสไตล์เกาหลีสำหรับกอล์ฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8df7f98215ea4ccdb7e38a909db11cdfs.jpg_200x200q90.jpg",
        "price": 3964.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6066654153.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกีฬา SEVYSPORTS เสื้อปั่นจักรยาน ผ้านาโนเบาสบายแห้งไว ระบายอากาศได้ดี เนื้อผ้า Polyester เข้าทรงสวย ไร้ตะเข็บ มี Flex ช่วยให้สะท้อนแสง",
        "product_image": "https://img.lazcdn.com/g/p/80265f52883eb9bd92f6452b69faf9ce.jpg_200x200q90.jpg",
        "price": 3960,
        "remark": "https://www.lazada.co.th/products/pdp-i4764444246.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเซ็ตผู้หญิงแฟชั่นจีบระบาย ดีไซน์หรูหรา สองชิ้น สไตล์โดปามีน เสื้อและกางเกงเข้าชุด ผลิตจากเส้นใยโพลีเอสเตอร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S99afdf0ab0674ad5b96656ae284dea454.jpg_200x200q90.jpg",
        "price": 3927.4,
        "remark": "https://www.lazada.co.th/products/pdp-i16105362042.html",
        "sold": 0
    },
    {
        "product_name": "≮211≯alo ชุดชั้นในการค้าข้ามพรมแดน เสื้อกั๊กความรู้สึกเปลือย หลังริบสวยงาม กันกระแทก ชุดชั้นในกีฬาฟิตเนสสูง ชุดโยคะ",
        "product_image": "https://img.lazcdn.com/g/p/1a50616af7ac290282e1143653357a70.jpg_200x200q90.jpg",
        "price": 3919.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16046222993.html",
        "sold": 0
    },
    {
        "product_name": "หลังคาเรือสไตล์ Sfcini ผ้าคลุมสำหรับเปลี่ยนเสื้อ Bimini แบบสากลสำหรับเรือใบ",
        "product_image": "https://img.lazcdn.com/g/p/66046188768c9c772997b48533e85c50.jpg_200x200q90.jpg",
        "price": 3902,
        "remark": "https://www.lazada.co.th/products/pdp-i6078187333.html",
        "sold": 0
    },
    {
        "product_name": "THE NORTH FACE WOMEN REFINA LONGLINE BRA เสื้อสปอร์ตบรา ผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/f091fde696ae32bc0512292e463213c1.jpg_200x200q90.jpg",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i5814462532.html",
        "sold": 0
    },
    {
        "product_name": "ZOOT W LTD CYCLE AERO JERSEY เสื้อปั่นจักรยานผู้หญิง ของแท้ 💯%",
        "product_image": "https://img.lazcdn.com/g/p/1415189a6c99ce9bce49e6d6c11fdbf4.jpg_200x200q90.jpg",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i4371171149.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อ FCSK 3.2 (เสื้อ FCSK 3.0 + M4 Chest Rig) (FCSK 3.2 P Carrier) (FCSK 3.0 + M4 Chest Rig)",
        "product_image": "https://img.lazcdn.com/g/p/1496eb6f8e4cfd20cebabd26f3a0487f.jpg_200x200q90.jpg",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i5750637577.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกั่กคอเต่า งานแท้กองทัพ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6cc0c0f516a34a9fa90ce7f7d5d53075F.jpg_200x200q90.jpg",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i5146991260.html",
        "sold": 5
    },
    {
        "product_name": "เสื้อ FCSK 3.2 (เสื้อ FCSK 3.0 + M4 Chest Rig)  (FCSK 3.2 P Carrier)  (FCSK 3.0 + M4 Chest Rig)",
        "product_image": "https://img.lazcdn.com/g/p/50bdbd8f1d667dc8cc795e73541803a7.jpg_200x200q90.jpg",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i5750532773.html",
        "sold": 0
    },
    {
        "product_name": "CAMP15 : TACTICAL JACKET For Stanley / เสื้อคลุมสำหรับกระติกเก็บความเย็น สแตนเลย์ 16QT/15L",
        "product_image": "https://img.lazcdn.com/g/p/df45e2bc6f6339e8e1ee41af25d81435.jpg_200x200q90.jpg",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i5352513495.html",
        "sold": 1
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI16I3Z14 สีเบจ",
        "product_image": "https://img.lazcdn.com/g/p/fc837efb3837abf71d0e3567ce5872c4.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066137193.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI09I3Z14 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/c2c7d2dc5141af85f8f2d0729cfe11e2.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066296415.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI08K8FQ4 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/f12c6ba4543b0e662f1e084ca01b2059.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066053476.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI08K8FQ4 สีเบจ",
        "product_image": "https://img.lazcdn.com/g/p/08ea6ee7e75be040f2b34a9d8506700d.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066053475.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI15J1314 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/ed02a26beaebcea4f220b295c3712fc8.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066057499.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI17KD741 สีเบจ",
        "product_image": "https://img.lazcdn.com/g/p/7583656df026075c6e0f67f8445e79b1.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066101250.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI09I3Z14 สีเบจ",
        "product_image": "https://img.lazcdn.com/g/p/375b52a88cb8071ce1b354abbffffa48.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16065931891.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI05I3Z14 สีแดง",
        "product_image": "https://img.lazcdn.com/g/p/8f230dec0dd75786aedbadd030c3452b.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066300387.html",
        "sold": 1
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI04K8FQ4 สีน้ำเงิน",
        "product_image": "https://img.lazcdn.com/g/p/26cde07a023f42fa46f899bd3cc39d2d.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066129224.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI20J1314 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/5ca301a1e32f7477f7992de7c46b019f.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066129225.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI05I3Z14 สีเบจ",
        "product_image": "https://img.lazcdn.com/g/p/fc357bfed87bd126587a0ec7b4dcde20.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066057497.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI04K8FQ4 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/bf0ee2ac1648c64c72637b14b347623f.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066105268.html",
        "sold": 0
    },
    {
        "product_name": "GUESS เสื้อยืดผู้หญิง รุ่น W1YI1BI3Z14 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/9bb302998494989bf45481f331a4dbdc.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i5369786737.html",
        "sold": 6
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI17KD741 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/96edc08d2dd80897af043b291670dfc1.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066344229.html",
        "sold": 1
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI20J1314 สีน้ำตาล",
        "product_image": "https://img.lazcdn.com/g/p/ea76d0da339fddd7f778fa6581760522.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066099272.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI16I3Z14 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/d3127195b8df72d068d510ea8fe298e4.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066344232.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS เสื้อผ้าผู้หญิงมีซิป,เสื้อเจอร์ซีย์นักปั่นระบายอากาศได้ดีสไตล์ YKK เสื้อปั่นจักรยานแขนสั้นป้องกันการลื่นเสื้อผ้าจักรยานแห้งเร็วมีกระเป๋า",
        "product_image": "https://img.lazcdn.com/g/p/2520920412f3a63df61c90a5016661b7.jpg_200x200q90.jpg",
        "price": 3876,
        "remark": "https://www.lazada.co.th/products/pdp-i5139193428.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อแขนยาวสำหรับผู้หญิงเสื้อปั่นจักรยาน,เสื้อปั่นจักรยานเสือหมอบเสือภูเขาชุดกีฬากลางแจ้งทรงเข้ารูปยืดหยุ่นสูงใส่สบายเสื้อเจอร์ซีย์นักปั่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5351662b982e4a6bb2a5c9644f18a6133.jpg_200x200q90.jpg",
        "price": 3868,
        "remark": "https://www.lazada.co.th/products/pdp-i6030874833.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเชิ้ตแขนยาวสำหรับปั่นจักรยาน,สีโดพามีนระบายอากาศได้ดีไม่ระคายเคืองผิวเสื้อเจอร์ซีย์นักปั่นผ้าฝ้ายยืดหยุ่นสูงให้ความรู้สึกชุดปั่นจักรยานสำหรับการขับขี่ระยะยาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S36029124f0d14788a70c31dc8f37a80dQ.jpg_200x200q90.jpg",
        "price": 3868,
        "remark": "https://www.lazada.co.th/products/pdp-i6040367351.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเซ็ตสองชิ้น เสื้อสเวตเชิ้ตแขนยาวคอกลมสีพื้น กระโปรงมิดิผ่าข้าง แฟชั่นผู้หญิงสไตล์ลำลอง สำหรับฤดูใบไม้ผลิและฤดูใบไม้ร่วง ใช้งานได้หลากหลาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfaa469014c8c48ae9e8296d4cfbb7138l.jpg_200x200q90.jpg",
        "price": 3864.4,
        "remark": "https://www.lazada.co.th/products/pdp-i16096929968.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานสำหรับผู้หญิง ระบายอากาศได้ดี ฤดูใบไม้ผลิและฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S07c760d437db4fb4a41c2760b9376639D.jpg_200x200q90.jpg",
        "price": 3852.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5874240089.html",
        "sold": 27
    },
    {
        "product_name": "WUYINXIANG | เสื้อผ้าไท่เกี๊ยะสำหรับฤดูร้อน ใส่สบาย สำหรับชายและหญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf7f327737f99450f876c955dd195661c2.jpg_200x200q90.jpg",
        "price": 3841.5,
        "remark": "https://www.lazada.co.th/products/pdp-i6010944267.html",
        "sold": 2
    },
    {
        "product_name": "【Underwear】 เสื้อกล้ามผ้าซาตินเงา XClocKNYoung เสื้อซับในแบบมันเงา เสื้อกล้ามสายเดี่ยวแบบไม่มีแขน เสื้อกล้ามสำหรับเล่นกีฬา โยคะ ชุดว่ายน้ำ บรา",
        "product_image": "https://img.lazcdn.com/g/p/bd1dce0bb0c0bb9b51e49263eff25f96.png_200x200q90.png",
        "price": 3836.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16085343491.html",
        "sold": 0
    },
    {
        "product_name": "Dash ultralight short sleeve shirt",
        "product_image": "https://img.lazcdn.com/g/p/c020705c9c53f450d9988ee6b56afc15.jpg_200x200q90.jpg",
        "price": 3820,
        "remark": "https://www.lazada.co.th/products/pdp-i5741460564.html",
        "sold": 10
    },
    {
        "product_name": "เสื้อยืดแบบหลวมจีบหญิงลำลองใหม่",
        "product_image": "https://img.lazcdn.com/g/p/787fdbbbb91188f5347d8ec2016ee09f.jpg_200x200q90.jpg",
        "price": 3816,
        "remark": "https://www.lazada.co.th/products/pdp-i6041177916.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแฟชั่นใหม่แบบลำลองผู้หญิงจีบ",
        "product_image": "https://img.lazcdn.com/g/p/e68a4119b6a01f93d150d7ba22029d54.jpg_200x200q90.jpg",
        "price": 3816,
        "remark": "https://www.lazada.co.th/products/pdp-i6004863064.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS เสื้อจักรยานเสือหมอบผู้หญิงแขนสั้นเสื้อเจอร์ซีย์นักปั่นมืออาชีพเสื้อเสื้อปั่นจักรยานจักรยานน้ำหนักเบาเนื้อบางระบายอากาศ",
        "product_image": "https://img.lazcdn.com/g/p/2fcb0331dc7325be2a355e80ca35a8d7.jpg_200x200q90.jpg",
        "price": 3810,
        "remark": "https://www.lazada.co.th/products/pdp-i5226597500.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผู้หญิงแขนสั้นระบายอากาศเสื้อเจอร์ซีย์นักปั่นพิมพ์ลายการ์ตูนเสื้อขี่จักรยาน3กระเป๋าและเรียบ YKK ซิปชุดออกกำลังกายชุดปั่นจักรยาน",
        "product_image": "https://img.lazcdn.com/g/p/eea0eb679b5575461f2283ca2a35e155.jpg_200x200q90.jpg",
        "price": 3808,
        "remark": "https://www.lazada.co.th/products/pdp-i5140581930.html",
        "sold": 16
    },
    {
        "product_name": "ROCKBROS ระบายอากาศที่สะดวกสบายเสื้อเจอร์ซีย์นักปั่นผู้หญิงแขนยาวกันยูวีสีสันสดใสจักรยานเสือหมอบเสื้อผ้าผู้หญิงหมวกขี่ MTB อุปกรณ์จักรยานเสื้อผ้า",
        "product_image": "https://img.lazcdn.com/g/p/3f3f1c223ad6b9a472f618b620639d25.jpg_200x200q90.jpg",
        "price": 3806,
        "remark": "https://www.lazada.co.th/products/pdp-i5273388451.html",
        "sold": 5
    },
    {
        "product_name": "แจ็คเก็ตขนเป็ดยาวซีรีส์บาสเก็ตบอล BADFIVE ฤดูหนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S54f64f76f7f548dc93067eccb7bbfe97w.jpg_200x200q90.jpg",
        "price": 3794,
        "remark": "https://www.lazada.co.th/products/pdp-i16085637234.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อพยุงตัว สำหรับเรือคายัค แคนู เสื้อช่วยลอยน้ำ Buoyancy Aid ITIWIT",
        "product_image": "https://img.lazcdn.com/g/p/538dec21ba85a6ed400982bd01ff7eda.jpg_200x200q90.jpg",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i336060062.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS เสื้อขี่จักรยานสำหรับผู้หญิงเสื้อผ้าจักรยานกลางแจ้ง MTB ขี่ระบายอากาศแห้งเร็วเสื้อแขนสั้น",
        "product_image": "https://img.lazcdn.com/g/p/3b34aad85abc0eff415a43588d6aa600.jpg_200x200q90.jpg",
        "price": 3770,
        "remark": "https://www.lazada.co.th/products/pdp-i4169217608.html",
        "sold": 9
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟสไตล์เกาหลีใหม่ แบบยูนิเซ็กส์ ความจุขนาดใหญ่ กันน้ำ กระเป๋าเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/52eb34f563175eb44e51cf6d4d1bc297.jpg_200x200q90.jpg",
        "price": 3769.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16146849669.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อ FCSK 3.6 (เสื้อ FCSK 3.0 + เเผง UTA (แบบ3ช่อง)) (FCSK 3.6 P Carrier) (FCSK 3.0 + UTA Front Flap) ขวัญใจสายตรวจ",
        "product_image": "https://img.lazcdn.com/g/p/4da167dcf33bf10918c7f8eded3c48c6.jpg_200x200q90.jpg",
        "price": 3760,
        "remark": "https://www.lazada.co.th/products/pdp-i5758543230.html",
        "sold": 0
    },
    {
        "product_name": "Balneaire | ชุดว่ายน้ำแขนสั้นสีอ่อนสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S956444fd00054d83b0140e28c1b368fb0.png_200x200q90.png",
        "price": 3752.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5893733042.html",
        "sold": 1
    },
    {
        "product_name": "1JINN STUDIO | เสื้อรักบี้ลายสีบล็อกสไตล์วินเทจแบบดิสทรесс",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7372de9279df4d3abb4a28a0f70a580eG.png_200x200q90.png",
        "price": 3749.46,
        "remark": "https://www.lazada.co.th/products/pdp-i6029462534.html",
        "sold": 0
    },
    {
        "product_name": "Balneaire | ชุดว่ายน้ำพีซเดียวสำหรับสาวๆ ที่ชอบความเรียบร้อย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf51c0930946d4faa8d7d23b5b41726e5o.png_200x200q90.png",
        "price": 3748,
        "remark": "https://www.lazada.co.th/products/pdp-i5893579922.html",
        "sold": 33
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟสไตล์เกาหลีใหม่สำหรับทั้งชายและหญิง GOLF กระเป๋าถือไนลอนกันน้ำสำหรับเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/484d209bcbe6b289629ce107b0055320.jpg_200x200q90.jpg",
        "price": 3747.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16147210539.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกั๊กเทนนิสแขนสั้นคอปก ดูดซับความชื้นสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S28baa0e328d84b59bcdb150598fa9178w.png_200x200q90.png",
        "price": 3737.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16050057388.html",
        "sold": 1
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดสำหรับแฟนบอลผู้คลั่งไคล้ ระบายอากาศได้ดี ฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3fe2bb10403b4628adea1b2961e32cc1s.png_200x200q90.png",
        "price": 3733.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6049023529.html",
        "sold": 3
    },
    {
        "product_name": "TOSUOD | ชุดปั่นจักรยานบนภูเขาสำหรับฤดูใบไม้ร่วง/หนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S244c50bc159f40e0a0cbcbb4ca0db6c62.jpg_200x200q90.jpg",
        "price": 3729.18,
        "remark": "https://www.lazada.co.th/products/pdp-i5935202727.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานระบายอากาศและแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S98e41a3541fe4faa880f1953d89e1df7B.png_200x200q90.png",
        "price": 3727.06,
        "remark": "https://www.lazada.co.th/products/pdp-i5841229349.html",
        "sold": 44
    },
    {
        "product_name": "[XEXYMIX Black Label] Split Longsleeve Bra-Top",
        "product_image": "https://img.lazcdn.com/g/p/dbff73af71cc189bba70749670d7a0d6.jpg_200x200q90.jpg",
        "price": 3722.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5892865659.html",
        "sold": 0
    },
    {
        "product_name": "moodytiger | กางเกงว่ายน้ำแห้งไวป้องกันแดดยืดหยุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S060ed8abec6146ee90118a0fca2131ddX.png_200x200q90.png",
        "price": 3722.76,
        "remark": "https://www.lazada.co.th/products/pdp-i5910935321.html",
        "sold": 2
    },
    {
        "product_name": "เสื้อยืดแขนสั้นปักลาย คอพับ ขอบแขนและปกเย็บ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S058ff26a0c9d4449828f272342eba5f01.jpg_200x200q90.jpg",
        "price": 3717.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16127087081.html",
        "sold": 0
    },
    {
        "product_name": "Rockbros | เสื้อปั่นจักรยานแขนสั้นสำหรับผู้หญิง ดูดซับเหงื่อแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb4c36616449343babdbea06745d72e28A.jpg_200x200q90.jpg",
        "price": 3715.46,
        "remark": "https://www.lazada.co.th/products/pdp-i6003038154.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแขนสั้นหลวมสบายสำหรับเด็กโตเล่นบาสเกตบอลฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5df99c7cd73147bd9beccb9944a10a73E.jpg_200x200q90.jpg",
        "price": 3714,
        "remark": "https://www.lazada.co.th/products/pdp-i16085606154.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดหลวมสำหรับเด็กฤดูร้อน ใส่เล่นบาสเก็ตบอล สบาย ๆ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5df99c7cd73147bd9beccb9944a10a73E.jpg_200x200q90.jpg",
        "price": 3714,
        "remark": "https://www.lazada.co.th/products/pdp-i16085743122.html",
        "sold": 0
    },
    {
        "product_name": "25 กระเป๋าถือกอล์ฟผู้หญิงน้ำหนักเบาแบบใหม่ กระเป๋าใส่เสื้อผ้าขนาดเล็ก กระเป๋ากอล์ฟสุดหรูที่สลักลายด้วยเลเซอร์",
        "product_image": "https://img.lazcdn.com/g/p/d323009465c0f61bca133a28951e07ae.jpg_200x200q90.jpg",
        "price": 3712.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16147216860.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยาน Demonte สำหรับผู้หญิง ลายสายฟ้า สีน้ำเงิน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9e77801016f346f687641c18fb9be8e5w.jpg_200x200q90.jpg",
        "price": 3700,
        "remark": "https://www.lazada.co.th/products/pdp-i2420629912.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยาน Demonte สำหรับผู้หญิง DE-042\nลายดอกชบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7ab148a4e69b4e9bbca25d22c20fbe74X.jpg_200x200q90.jpg",
        "price": 3700,
        "remark": "https://www.lazada.co.th/products/pdp-i2420735066.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยาน Demonte สำหรับผู้หญิง ลายจุด polka dot สีชมพู",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S455958a1a2c84373a4be906926c632beF.jpg_200x200q90.jpg",
        "price": 3700,
        "remark": "https://www.lazada.co.th/products/pdp-i2420788121.html",
        "sold": 0
    },
    {
        "product_name": "CHER'Z - RW2506 เสื้อเสื้อโอบไหล่ ผ้า Glitter Jersey",
        "product_image": "https://img.lazcdn.com/g/p/2f2c3aa95b10c64a28ad0de3e9c8d2eb.jpg_200x200q90.jpg",
        "price": 3697.58,
        "remark": "https://www.lazada.co.th/products/pdp-i5850561930.html",
        "sold": 17
    },
    {
        "product_name": "เสื้อปั่นจักรยานสำหรับผู้หญิง ระบายอากาศได้ดี แห้งไว ป้องกันแสงแดด ฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd060386e61a44b44afd21d389f31256aB.png_200x200q90.png",
        "price": 3694.64,
        "remark": "https://www.lazada.co.th/products/pdp-i5841437795.html",
        "sold": 1
    },
    {
        "product_name": "HUMTTO | เสื้อยืดสบายระบายอากาศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se538ff6611054f20b2014220cca8b8b3w.jpg_200x200q90.jpg",
        "price": 3693.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6013945725.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้าปั่นจักรยานแขนยาวผู้หญิง Carvico Fabric อบอุ่น ขนแกะ ฤดูใบไม้ร่วง/ฤดูหนาว เสื้อผ้าปั่นจักรยาน LAMEDA รุ่น Qinyu",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2de9541e63ed416aa86b0979a74d5e51K.jpg_200x200q90.jpg",
        "price": 3692.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5844971365.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้าพื้นเรียบสำหรับลดหุ่น ใส่สบายและหลวม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc5fa9144bed0465faebbc33759ce43081.png_200x200q90.png",
        "price": 3677.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16057607838.html",
        "sold": 0
    },
    {
        "product_name": "{dfthg} alo yoga ชุดชั้นในโยคะไหล่เดียวแบบเฉียงชุดชั้นในกีฬาสายรัดผิดปกติวิ่งเสื้อกั๊กออกกำลังกาย",
        "product_image": "https://img.lazcdn.com/g/p/a22449388d5333d3af65a8b6df7d70f0.jpg_200x200q90.jpg",
        "price": 3658.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6064745582.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดจับจีบสลิมลำลองผู้หญิงใหม่",
        "product_image": "https://img.lazcdn.com/g/p/a60a73345b48d12433236553d00f52fc.jpg_200x200q90.jpg",
        "price": 3658,
        "remark": "https://www.lazada.co.th/products/pdp-i6048069375.html",
        "sold": 0
    },
    {
        "product_name": "LAMEDA เสื้อปั่นจักรยานสำหรับผู้หญิง รุ่น E-CO SERIE WOMEN",
        "product_image": "https://img.lazcdn.com/g/p/91ce5e512b3b4357c9dd6d86cf32bf32.jpg_200x200q90.jpg",
        "price": 3640,
        "remark": "https://www.lazada.co.th/products/pdp-i5512316430.html",
        "sold": 0
    },
    {
        "product_name": "Zoke | ชุดว่ายน้ำป้องกันแดดสำหรับเด็ก แขนยาวและกางเกง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sae3fbf9de4194d90a61a2c776b85581fc.jpg_200x200q90.jpg",
        "price": 3624.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5893764653.html",
        "sold": 0
    },
    {
        "product_name": "ฮู้ดดี้แฟชั่นกีฬาสไตล์แคชชวล ยูนิเซ็กซ์ ใส่สบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8d2aea5b62514a82a376daf2c51a2f30N.jpg_200x200q90.jpg",
        "price": 3620,
        "remark": "https://www.lazada.co.th/products/pdp-i16085783125.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อฮู้ดหลวมสำหรับทุกเพศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8d2aea5b62514a82a376daf2c51a2f30N.jpg_200x200q90.jpg",
        "price": 3620,
        "remark": "https://www.lazada.co.th/products/pdp-i16085280939.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS Morandi เสื้อกีฬาแขนสั้นสำหรับผู้หญิง,เสื้อกีฬาการขี่จักรยานแบบยืดหยุ่นสูงแห้งเร็วสวมระบายอากาศตอนขี่จักรยานฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/6b152635371f8176792765df468dbe83.jpg_200x200q90.jpg",
        "price": 3614,
        "remark": "https://www.lazada.co.th/products/pdp-i5700283479.html",
        "sold": 0
    },
    {
        "product_name": "แจ็คเก็ตสกีกันน้ำหลายฟังก์ชั่น 5 ชั้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5ba7f12853e746c59791d5b83c83d713c.jpg_200x200q90.jpg",
        "price": 3602,
        "remark": "https://www.lazada.co.th/products/pdp-i16118212310.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกีฬาคอวีระบายอากาศสำหรับชายหาด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9d61330f0bde4dcc823ac29527adff481.jpg_200x200q90.jpg",
        "price": 3596.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16127454023.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS เสื้อเสื้อเจอร์ซีย์นักปั่นเสื้อผ้าปั่นจักรยานผู้หญิงจักรยานเสือหมอบ MTB เบาพิเศษแห้งเร็วระบายอากาศได้สวมใส่สบาย",
        "product_image": "https://img.lazcdn.com/g/p/6b152635371f8176792765df468dbe83.jpg_200x200q90.jpg",
        "price": 3596,
        "remark": "https://www.lazada.co.th/products/pdp-i5706081741.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดจีบหลวมลำลองสำหรับผู้หญิงแฟชั่นใหม่",
        "product_image": "https://img.lazcdn.com/g/p/18231b38f05bdb1356ed4abd259b33f8.jpg_200x200q90.jpg",
        "price": 3588,
        "remark": "https://www.lazada.co.th/products/pdp-i6041155849.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานผู้หญิง,เสื้อปั่นจักรยานกีฬาแขนยาวฤดูใบไม้ผลิฤดูร้อนป้องกันแดดระบายอากาศได้เสื้อเจอร์ซีย์นักปั่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S13e405036605482d8d6cdca4b78738d35.jpg_200x200q90.jpg",
        "price": 3584,
        "remark": "https://www.lazada.co.th/products/pdp-i6030758796.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟสไตล์เกาหลีใหม่ แบบยูนิเซ็กส์ กันน้ำ น้ำหนักเบา ความจุขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/e5ed8ec81c1dc6fcfab288b9b43927b2.jpg_webp_200x200q90.jpg",
        "price": 3582.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16147350318.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟพร้อมช่องใส่รองเท้าแยกต่างหาก   สเตอริโอความถี่สูงรุ่นสูง logoPU พื้นที่จัดเก็บขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/98ef9badf4653d3303d82d0de03f6523.jpg_webp_200x200q90.jpg",
        "price": 3582.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16147230884.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟคุณภาพสูง ดีไซน์ใหม่ทันสมัย ใช้ได้ทั้งชายและหญิง กระเป๋าถือความจุขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/8bf8c0fbd5d9bfa2e138356e6afe4f86.jpg_webp_200x200q90.jpg",
        "price": 3580.94,
        "remark": "https://www.lazada.co.th/products/pdp-i16147204937.html",
        "sold": 0
    },
    {
        "product_name": "Peaches Active - The Essential Tank Baby Yellow เสื้อกล้าม",
        "product_image": "https://img.lazcdn.com/g/p/c608bfa323f10a8234b689b0a3b79a35.jpg_200x200q90.jpg",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i6052118386.html",
        "sold": 1
    },
    {
        "product_name": "Pre-Order_Sizzlin' High Low Crew Neck Top  (เสื้อออกกำลังกายซุมบ้า)",
        "product_image": "https://img.lazcdn.com/g/p/efd5d80c22ee4e9964e6dc97b340af47.jpg_200x200q90.jpg",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i5863807193.html",
        "sold": 0
    },
    {
        "product_name": "Zumba Libre Basketball Tank  (เสื้อกล้ามออกกำลังกายวซุมบ้า)",
        "product_image": "https://img.lazcdn.com/g/p/b1c28dc036e6823a66d3ac59d5be5209.jpg_200x200q90.jpg",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i5830872642.html",
        "sold": 0
    },
    {
        "product_name": "Zumba Prep Basketball Tank  (เสื้อกล้ามออกกำลังกายซุมบ้า)",
        "product_image": "https://img.lazcdn.com/g/p/6b040b343a95fdbee5812d3fc4a79c36.jpg_200x200q90.jpg",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i5279035146.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อ Training Mini Chest Rig BY:CYTAC BY BKKBOY",
        "product_image": "https://img.lazcdn.com/g/p/8e33e3b3e84dc553a31f47babe652abb.jpg_200x200q90.jpg",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i4740447569.html",
        "sold": 0
    },
    {
        "product_name": "Pre-Order_Zumba Libre Basketball Tank  (เสื้อกล้ามออกกำลังกายซุมบ้า)",
        "product_image": "https://img.lazcdn.com/g/p/5471f3dbfc4422aea67e61905524d43a.jpg_200x200q90.jpg",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i5830997296.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแฟชั่นใส่สบายสำหรับทุกเพศ ทรงหลวม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5272df4c06ed42ec8104edd5da659b1c7.png_200x200q90.png",
        "price": 3579.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16101344763.html",
        "sold": 0
    },
    {
        "product_name": "≮203≯Lamshop เสื้อกล้ามโยคะความแข็งแรงสูงแบบชิ้นเดียว ป้องกันแรงกระแทก ระบายอากาศได้ดี สวยงามด้านหลัง พร้อมแผ่นรองหน้าอก สำหรับออกกำลังกาย ชุดชั้นในผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/76493011e9a95c2956453b4114e6c03f.jpg_webp_200x200q90.jpg",
        "price": 3579.66,
        "remark": "https://www.lazada.co.th/products/pdp-i6070042683.html",
        "sold": 0
    },
    {
        "product_name": "ชุดโยคะผู้หญิง สีสันฤดูใบไม้ร่วง แบบคอ halter แขนยาว สองชิ้นปลอม T ท็อปฟิตเนสแบบมีเกลียวพร้อมแผ่นรองหน้าอก",
        "product_image": "https://img.lazcdn.com/g/p/66ade242ce3d6890a81b6ecb58ef07d5.jpg_webp_200x200q90.jpg",
        "price": 3564.88,
        "remark": "https://www.lazada.co.th/products/pdp-i6071376754.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS เสื้อยืดเสื้อเจอร์ซีย์นักปั่นปั่นจักรยานผู้หญิงเนื้อเรียบระบายอากาศได้ดีซึมซับเหงื่อเสื้อผ้าจักรยานเสือหมอบยืดหยุ่นสูง",
        "product_image": "https://img.lazcdn.com/g/p/717b86377b607a44a3162981ae66a0db.jpg_200x200q90.jpg",
        "price": 3532,
        "remark": "https://www.lazada.co.th/products/pdp-i5271041486.html",
        "sold": 0
    },
    {
        "product_name": "TOSUOD | เสื้อปั่นจักรยานแขนยาวแห้งไวสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saa45b5cd046a49b8bb8c04022ea6de55s.jpg_200x200q90.jpg",
        "price": 2866.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5894977217.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดจับจีบหรูหราใหม่สำหรับผู้หญิงพิมพ์ลายทรงหลวม",
        "product_image": "https://img.lazcdn.com/g/p/fda0601f6d502aea1ef2c3e3aa9668cf.jpg_200x200q90.jpg",
        "price": 3526,
        "remark": "https://www.lazada.co.th/products/pdp-i6011329618.html",
        "sold": 0
    },
    {
        "product_name": "PGA | เสื้อยืดแข่งกอล์ฟสำหรับเด็กชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb3d10c56368447c79d7bbdbbc2fb996b3.jpg_200x200q90.jpg",
        "price": 3524.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6066879261.html",
        "sold": 0
    },
    {
        "product_name": "Vszap Shorts MMA Men's Bjj Jiujitsu Fight Pants Wolf Wrestling Grappling Kickboxing Boxing Training Shorts Martial Arts Clothes",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S2e142ba5c8a6417a9745bdd67ff907deI.jpg_200x200q90.jpg",
        "price": 3513.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5967574006.html",
        "sold": 0
    },
    {
        "product_name": "VINN PATARARIN - Cut-Out Wellness Tank - เสื้อแขนกุด เจาะอก เสื้อกล้าม",
        "product_image": "https://img.lazcdn.com/g/p/83814a6b0ee66f8d056d5217de8e9d7f.jpg_200x200q90.jpg",
        "price": 3510,
        "remark": "https://www.lazada.co.th/products/pdp-i5711053945.html",
        "sold": 5
    },
    {
        "product_name": "ROCKBROS ชุดเสื้อเจอร์ซีย์นักปั่นจักรยานบนถนน MTB ผู้หญิงระบายอากาศได้ดีกางเกงปั่นจักรยานชุดสำหรับขี่จักรยานซิป3กระเป๋าใส่สบายสีกาแฟ",
        "product_image": "https://img.lazcdn.com/g/p/2f60c0034ad932be9be71ff33cb87ea0.jpg_200x200q90.jpg",
        "price": 3510,
        "remark": "https://www.lazada.co.th/products/pdp-i5133596194.html",
        "sold": 2
    },
    {
        "product_name": "เสื้อเกราะ แผ่นเพลท เสื้อเทียมเกราะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3f69278ce5e64f179d834c12ea282860l.jpg_200x200q90.jpg",
        "price": 3500,
        "remark": "https://www.lazada.co.th/products/pdp-i750592441.html",
        "sold": 14
    },
    {
        "product_name": "เสื้อปั่นจักรยานกัน UV สำหรับฤดูใบไม้ผลิและฤดูใบไม้ร่วง ผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7409ec3387a7426b8823a13e13cb19f0T.jpg_200x200q90.jpg",
        "price": 3496.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5882438885.html",
        "sold": 100
    },
    {
        "product_name": "toswim | ชุดว่ายน้ำสำหรับเด็กหญิงและนักเรียนมัธยมต้น ปี 2025",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S721b6a4de3b14436b94ed423a56c4d94z.jpg_200x200q90.jpg",
        "price": 3496.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5891853827.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อสตรีแขนยาวผู้หญิงเสื้อเจอร์ซีย์นักปั่นฤดูใบไม้ร่วงฤดูหนาวจักรยานเสือหมอบ MTB ให้ความอบอุ่นชุดสำหรับขี่จักรยานซิป YKK",
        "product_image": "https://img.lazcdn.com/g/p/04852e866a2278b3a96d0cd897fdd796.jpg_200x200q90.jpg",
        "price": 3496,
        "remark": "https://www.lazada.co.th/products/pdp-i5389105984.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานระบายอากาศได้ ป้องกันเหงื่อ และยืดหยุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S60ba213f2aa844109ec87afe8f902489r.jpg_200x200q90.jpg",
        "price": 3495.06,
        "remark": "https://www.lazada.co.th/products/pdp-i5845169502.html",
        "sold": 16
    },
    {
        "product_name": "ROCKBROS เสื้อจักรยานแขนเสื้อสั้นผู้หญิงระบายอากาศได้ดีเสื้อเจอร์ซีย์นักปั่นแห้งเร็วเสื้อผ้าจักรยานมีซิป YKK",
        "product_image": "https://img.lazcdn.com/g/p/e4d00c58eb0dc379e26f638c9ab37bc0.jpg_200x200q90.jpg",
        "price": 3492,
        "remark": "https://www.lazada.co.th/products/pdp-i5140494099.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อป้องกันแดดแห้งไวและให้ความเย็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S579cfd7c59e840d7887a77325e7ea158a.jpg_200x200q90.jpg",
        "price": 3483.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16084567817.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแขนสั้นผ้าฝ้าย 380G",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8358042159a741e2a76ac66589f6cc73A.jpg_200x200q90.jpg",
        "price": 3483.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16127033305.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟใหม่, กระเป๋าเครื่องสำอางสำหรับผู้หญิง, กระเป๋าเดินทางสำหรับจัดเก็บ, กระเป๋าสะพายไหล่, กระเป๋าถือ, กระเป๋าสะพายข้าง",
        "product_image": "https://img.lazcdn.com/g/p/b0446eba2285fe7787bf52b13fcb7e15.jpg_200x200q90.jpg",
        "price": 3480.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16147332088.html",
        "sold": 0
    },
    {
        "product_name": "YKYWBIKE การขี่จักรยานแขนสั้นฤดูร้อนของผู้หญิงที่มีสีสันแห้งเร็วระบายอากาศดีเสื้อวันพักผ่อนกีฬา",
        "product_image": "https://img.lazcdn.com/g/p/f89672977992e658831fb81bda739942.jpg_200x200q90.jpg",
        "price": 3477.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5714945881.html",
        "sold": 0
    },
    {
        "product_name": "【TVI】ROCKBROS เสื้อเจอร์ซีย์นักปั่นสำหรับผู้หญิง,เสื้อสำหรับปั่นจักรยานผู้หญิงยืดหยุ่นชุดกีฬากลางแจ้งระบายอากาศได้ดีมีกระเป๋า",
        "product_image": "https://img.lazcdn.com/g/p/04073dcd1a3040c061fece33a39c54d7.jpg_200x200q90.jpg",
        "price": 3466,
        "remark": "https://www.lazada.co.th/products/pdp-i5120130196.html",
        "sold": 4
    },
    {
        "product_name": "เสื้อเชิ๊ตผู้หญิงแขนสั้นระบายอากาศได้ดีเสื้อเจอร์ซีย์นักปั่น3D Cuts เสื้อปั่นจักรยานมี3กระเป๋าและเรียบ YKK ซิปชุดออกกำลังกายชุดปั่นจักรยาน",
        "product_image": "https://img.lazcdn.com/g/p/0fadf814d2794cc4ff931becb6a11e0d.jpg_200x200q90.jpg",
        "price": 3454,
        "remark": "https://www.lazada.co.th/products/pdp-i5133992662.html",
        "sold": 4
    },
    {
        "product_name": "เสื้อยืดจับจีบหรูหราผู้หญิงใหม่สบายๆ",
        "product_image": "https://img.lazcdn.com/g/p/3b89271e307875adb9b1ac91685e554a.jpg_200x200q90.jpg",
        "price": 3444,
        "remark": "https://www.lazada.co.th/products/pdp-i6038707875.html",
        "sold": 0
    },
    {
        "product_name": "เบสบอล NY เจอร์ซีย์ ML-B เสื้อกีฬาผู้หญิงการขายส่งต่างประเทศอินเทรนด์เสื้อกีฬาข้ามพรมแดนปักเสื้อฝนด้านบน",
        "product_image": "https://img.lazcdn.com/collect/cbu/img/ibank/O1CN01G1i75w1V4qr1rWGG2_!!2219416822600-0-cib.jpg_200x200q90.jpg",
        "price": 3417.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16124341979.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดจีบหลวมลำลองสำหรับผู้หญิงแฟชั่น",
        "product_image": "https://img.lazcdn.com/g/p/6d5348bf47e55cf89862209150367b1e.jpg_200x200q90.jpg",
        "price": 3416,
        "remark": "https://www.lazada.co.th/products/pdp-i6038761245.html",
        "sold": 0
    },
    {
        "product_name": "Women with Built in Bra,Slim Fit Halter Sleeveless Gym Tops Seamless Racerback Athletic Shirts",
        "product_image": "https://img.lazcdn.com/g/p/0a1e7fff0034f5a630f9d4aca3e47fd0.jpg_200x200q90.jpg",
        "price": 3402,
        "remark": "https://www.lazada.co.th/products/pdp-i16137058698.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อคลุมแห้งเร็วพร้อมฉนวนกันความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7740c1e2f62b4e9abc9b0e3c13188982q.jpg_200x200q90.jpg",
        "price": 3401.52,
        "remark": "https://www.lazada.co.th/products/pdp-i6066936089.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อ FCSK 2.2 (เสื้อ FCSK 2.0 + M4 Chest Rig) (FCSK 2.2 P Carrier) (FCSK 2.0 + M4 Chest Rig)",
        "product_image": "https://img.lazcdn.com/g/p/7321f77a8e9d8f3903ecfd282364329e.jpg_200x200q90.jpg",
        "price": 3400,
        "remark": "https://www.lazada.co.th/products/pdp-i5728534234.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อ FCSK 2.2 (เสื้อ FCSK 2.0 + M4 Chest Rig) (FCSK 2.2 P Carrier) (FCSK 2.0 + M4 Chest Rig) มี4สีให้เลือก สีดำ สีทราย สีมัลติแคม สีมัลติแคมดำ",
        "product_image": "https://img.lazcdn.com/g/p/f2f610583a4cd15cbfa839431150f52b.jpg_200x200q90.jpg",
        "price": 3400,
        "remark": "https://www.lazada.co.th/products/pdp-i5728560263.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟสไตล์เกาหลีใหม่สำหรับผู้ชายและผู้หญิง กระเป๋าสะพายข้าง ดีไซน์ทันสมัยและอินเทรนด์ พร้อมช่องใส่รองเท้าแยกต่างหาก",
        "product_image": "https://img.lazcdn.com/g/p/adff3e5cdefe757d4c14adbf004ba5d5.jpg_200x200q90.jpg",
        "price": 3396.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16146763908.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดหรูหราพิมพ์ลายแฟชั่นใหม่ของผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/21ac806a2b28f0cc156e1275d15d7130.jpg_200x200q90.jpg",
        "price": 3392,
        "remark": "https://www.lazada.co.th/products/pdp-i6011440042.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดจับจีบผู้หญิงหลวมลำลองใหม่",
        "product_image": "https://img.lazcdn.com/g/p/d28b081c75356a2ee7ce7413e45354a0.jpg_200x200q90.jpg",
        "price": 3036,
        "remark": "https://www.lazada.co.th/products/pdp-i6038795149.html",
        "sold": 0
    },
    {
        "product_name": "Arena | ชุดว่ายน้ำแขนยาวป้องกันแดดสำหรับเด็กชายและหญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9b9190066c7c47149577d5dc86a82958U.jpg_200x200q90.jpg",
        "price": 3384.34,
        "remark": "https://www.lazada.co.th/products/pdp-i6014060422.html",
        "sold": 0
    },
    {
        "product_name": "Arena | ชุดว่ายน้ำแขนยาวสำหรับเด็ก ป้องกันแดด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0a4952743f3841378b53dcb730a36445w.jpg_200x200q90.jpg",
        "price": 3381.48,
        "remark": "https://www.lazada.co.th/products/pdp-i6014181161.html",
        "sold": 0
    },
    {
        "product_name": "Rookie Girl Tops and Scarf-เสื้อกอล์ฟแขนตุ๊กตา พร้อมผ้าพันคอลายซิกเนเจอร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scadc2b350bfa4a4bb139a20da3bc9fb7z.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i6074898800.html",
        "sold": 0
    },
    {
        "product_name": "Alice Flex Crop Bra Street Navy เสื้อครอปบรา เสื้อครอปบราออกกำลังกาย มีฟองน้ำ ถอดออกได้ ตกแต่งด้วยผ้าMesh และพิมพ์ลาย",
        "product_image": "https://img.lazcdn.com/g/p/9b34f19d23e4937527512f7a96bf2c50.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i867132627.html",
        "sold": 7
    },
    {
        "product_name": "Maison Nabi - Muse Halter เสื้อคล้องคอสปอร์ตบรา เสื้อผ้าออกกำลังกาย โยคะ พิลาทิส (Pilates) ทรงสวยเข้ารูป",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0bfa6ba633304df8855fa5bdccecd18bD.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i5975055587.html",
        "sold": 0
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดเด็กแห้งไวคล้ายฝ้าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3ec7b6e0a699405f9df0181a206e6014K.png_200x200q90.png",
        "price": 3357.12,
        "remark": "https://www.lazada.co.th/products/pdp-i6049049408.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้ากอล์ฟแขนยาวคอเต่าดูดซับความชื้นยืดหยุ่นได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scdee4d8eb0974ea49fef2b98cfac2d2dS.jpg_200x200q90.jpg",
        "price": 3352.18,
        "remark": "https://www.lazada.co.th/products/pdp-i6066481550.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS เสื้อเจอร์ซีย์นักปั่นสำหรับผู้หญิงใส่ในฤดูร้อนเสื้อปั่นจักรยานเสือหมอบแขนสั้นผ้าบางยืดหยุ่นสวมใส่สบายเสื้อผ้าปั่นจักรยาน",
        "product_image": "https://img.lazcdn.com/g/p/3b34aad85abc0eff415a43588d6aa600.jpg_200x200q90.jpg",
        "price": 3352,
        "remark": "https://www.lazada.co.th/products/pdp-i4167493214.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเจอร์ซีย์นักปั่นแขนยาวผู้หญิง,อุปกรณ์จักรยานเสื้อผ้าหมวกขี่ MTB จักรยานเสือหมอบเสื้อผ้าผู้หญิงยืดหยุ่นและระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/p/1fa475e0c3053162bcb0a7bed31591fb.jpg_200x200q90.jpg",
        "price": 3342,
        "remark": "https://www.lazada.co.th/products/pdp-i5365525437.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟแบบใหม่ เหมาะสำหรับจัดเก็บสัมภาระเดินทาง กระเป๋าถือความจุขนาดใหญ่ พกพาสะดวกสำหรับการเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/418a08244901c4b78d14eb265791f5ee.jpg_webp_200x200q90.jpg",
        "price": 3339.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16147126867.html",
        "sold": 0
    },
    {
        "product_name": "WUYINXIANG | เสื้อผ้าไทชี่สำหรับผู้ชายและผู้หญิง ผ้าฝ้าย-ลินินคุณภาพสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S56ddccf861dc4cdeb66b0eedc0430c1bM.jpg_200x200q90.jpg",
        "price": 3338.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6011005045.html",
        "sold": 54
    },
    {
        "product_name": "ROCKBROS เสื้อผ้าขี่จักรยานแขนยาวสำหรับผู้หญิง,เสื้อผ้าสำหรับใส่ปั่นจักรยานจักรยานบนถนน MTB จักรยานบนถนน MTB น้ำหนักเบาเสื้อผ้าระบายอากาศยืดหยุ่นได้เสื้อผ้าผู้หญิงกันลื่น",
        "product_image": "https://img.lazcdn.com/g/p/67b49fc2fd6b26931bef532480eaae8e.jpg_200x200q90.jpg",
        "price": 3332,
        "remark": "https://www.lazada.co.th/products/pdp-i5270037020.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS เสื้อผ้าผู้หญิงแขนยาวเสื้อเจอร์ซีย์นักปั่นนุ่มพิเศษผ้าไหมนมบางพิเศษเสื้อผ้าผู้หญิงสามกระเป๋าจักรยานเสือหมอบหมวกขี่ MTB อุปกรณ์จักรยานเสื้อผ้า",
        "product_image": "https://img.lazcdn.com/g/p/11027c2fb59a1015d139e265c6b4649d.jpg_200x200q90.jpg",
        "price": 3332,
        "remark": "https://www.lazada.co.th/products/pdp-i5359058586.html",
        "sold": 0
    },
    {
        "product_name": "Femt Golf | เสื้อคอกว้างยืดหยุ่นสูงช่วยเพรียว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa7abe40c8ee5476da24bb292a153f42bC.jpg_200x200q90.jpg",
        "price": 3329.04,
        "remark": "https://www.lazada.co.th/products/pdp-i6066906063.html",
        "sold": 0
    },
    {
        "product_name": "CHER'Z - RW2505 เสื้อเจอร์ซีย์จับเดรปไหล่",
        "product_image": "https://img.lazcdn.com/g/p/1951c09149b9be82f92aa9f79e670c72.jpg_200x200q90.jpg",
        "price": 3302.58,
        "remark": "https://www.lazada.co.th/products/pdp-i5850654357.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อ FCSK 3.7 (เสื้อ FCSK 3.0 + เเผง MK5 (แบบ3ช่อง)) (FCSK 3.7 P Carrier) (FCSK 3.0 + MK5 Front Flap)",
        "product_image": "https://img.lazcdn.com/g/p/8b4785482097c4850c3e11f123b9621d.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i5770901743.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อและกางเกงขาสั้นสไตล์เกาหลีสีขาว ฤดูใบไม้ผลิ 2026 ชุดลำลองสีพื้น แต่งขอบพับลายปะติด ผ้ากำมะหยี่ลายแกะ เสื้อยืดแขนยาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa9de180a297c4fd8b77874289b0b0ea9q.jpg_200x200q90.jpg",
        "price": 3288.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16085391896.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเจอร์ซีย์ลำลองใส่สบายดูดเหงื่อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3a400205069f44a49c52465b7d1b50a5Q.jpg_200x200q90.jpg",
        "price": 3283.46,
        "remark": "https://www.lazada.co.th/products/pdp-i6049801227.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อเชิ้ตแขนยาวสำหรับเต้นรำมินิมอลสไตล์มินิมอลสำหรับผู้ชาย แบรนด์ pro Danbo วัสดุอื่นๆ สำหรับฝึกซ้อมและการแสดงวัลส์ คอลเลกชันฤดูร้อน 2025",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa62c496189194d0d83fb8c84dcab4640W.jpg_200x200q90.jpg",
        "price": 3268,
        "remark": "https://www.lazada.co.th/products/pdp-i16088611763.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อผ้าฝึกซ้อมรำลาติน DUOYQ 009 สำหรับผู้ชาย ทรงเข้ารูป แขนยาว คอตั้ง ระบายอากาศได้ดี ไม่ต้องรีด ฤดูใบไม้ผลิ ฤดูร้อน ฤดูใบไม้ร่วง ฤดูหนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf4ba5ba1d5db4323962c34c3bb0b8241W.jpg_200x200q90.jpg",
        "price": 3266,
        "remark": "https://www.lazada.co.th/products/pdp-i16088506606.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกันกระสุนยุทธวิธีแบบถอดได้เร็ว Yakeoda Tactical Vest Molle Outdoor CS กันกระสุนสำหรับผู้ชาย ไซส์กลาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7046dd2e90404e3894e9953021be7a9fk.jpg_200x200q90.jpg",
        "price": 3260,
        "remark": "https://www.lazada.co.th/products/pdp-i5285112461.html",
        "sold": 0
    },
    {
        "product_name": "MANMI | คาร์ดิแกนสไตล์เรียบง่าย แฟชั่นสำหรับลดหุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se381797465f94f859fcafc97e4381912V.jpg_200x200q90.jpg",
        "price": 3254.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16074791923.html",
        "sold": 0
    },
    {
        "product_name": "ชั้นวางของกีฬาบาสเก็ตบอลแบบเหล็กโมเดิร์น ชั้นวางของสำหรับบ้าน จัดระเบียบของเล่น เสื้อผ้า เครื่องประดับสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8260831729f649d1823ee2f94e0c1773L.jpg_200x200q90.jpg",
        "price": 3248,
        "remark": "https://www.lazada.co.th/products/pdp-i16045331197.html",
        "sold": 0
    },
    {
        "product_name": "COLDELEMENT | ชุดว่ายน้ำสำหรับเด็กกัน UV แห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf46c4e0463d84dd9b07a648e45da619fo.jpg_200x200q90.jpg",
        "price": 3245.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5851635989.html",
        "sold": 4
    },
    {
        "product_name": "TOSUOD | เสื้อปั่นจักรยานแขนยาวสำหรับผู้หญิง แห้งไว ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3e8519ce81414c4a946f5ad437425ccdC.jpg_200x200q90.jpg",
        "price": 3244.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5893574644.html",
        "sold": 2
    },
    {
        "product_name": "WOSAWE | WOSAWE เสื้อกั๊กปั่นจักรยานฤดูหนาวฤดูใบไม้ร่วงกันลมผู้หญิงจักรยานเสื้อกันลมกันความร้อนเสื้อกั๊กจักรยานเสือหมอบชุดเสื้อผ้าปั่นจักรยาน MTB",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdd0e8b93adde43dcbab2110cc27160a1O.jpg_200x200q90.jpg",
        "price": 3241.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16104991480.html",
        "sold": 0
    },
    {
        "product_name": "ZOKE | ชุดว่ายน้ำเด็กกันแดดแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S05eeaa741e4b4211b9657a32b65f4392B.jpg_200x200q90.jpg",
        "price": 3236.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16092742304.html",
        "sold": 2
    },
    {
        "product_name": "moodytiger | เสื้อยืดเด็กชายกันแดดแห้งไวซับเหงื่อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3ea2224c62df4a539506b01bdca55f02Q.png_200x200q90.png",
        "price": 3228.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16053533700.html",
        "sold": 0
    },
    {
        "product_name": "moodytiger | เสื้อทีเชิร์ตเด็กสำหรับกีฬา แห้งเร็ว ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sffe9e1fcc63a47debe57262665e4a12bM.png_200x200q90.png",
        "price": 3227.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16104987326.html",
        "sold": 4
    },
    {
        "product_name": "YKYWBIKE ชุดทีมจักรยานสตรีเสื้อผ้าปั่นจักรยานเสื้อสำหรับปั่นจักรยานเสือภูเขาเสื้อเจอร์ซีย์นักปั่นฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/76ad961c8c616e23d298f349856207d6.jpg_200x200q90.jpg",
        "price": 3226,
        "remark": "https://www.lazada.co.th/products/pdp-i5713548576.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | ชุดกีฬาสตรีป้องกัน UV",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6ccf22fdbb5f45fd98fd71d5fbbff76fG.jpg_200x200q90.jpg",
        "price": 3219.88,
        "remark": "https://www.lazada.co.th/products/pdp-i6072580753.html",
        "sold": 0
    },
    {
        "product_name": "SHUANGHUA | เสื้อคาร์ดิแกนถัก สไตล์วินเทจ ลำลอง ใส่ได้หลายโอกาส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2693cac980454d17b39bafc073fddf6bR.jpg_200x200q90.jpg",
        "price": 3215.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16084869103.html",
        "sold": 0
    },
    {
        "product_name": "golf bag กระเป๋าใส่เสื้อผ้ากอล์ฟ  TM กระเป๋าใส่ลูกบอลสองชั้น   เสื้อผ้ากันน้ำ, รองเท้า, กระเป๋าสำหรับออกกำลังกายและเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/ca3aa618e1a062895b9e364eb87f66ca.jpg_200x200q90.jpg",
        "price": 3212.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16146885399.html",
        "sold": 0
    },
    {
        "product_name": "TOSUOD | เสื้อปั่นจักรยานแขนยาวสำหรับผู้หญิง น้ำหนักเบา แห้งไว ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S743bcf99f3b44e088331778aea5153b2P.jpg_200x200q90.jpg",
        "price": 3208.64,
        "remark": "https://www.lazada.co.th/products/pdp-i5894947129.html",
        "sold": 0
    },
    {
        "product_name": "TOSUOD | เสื้อจักรยานแขนยาวสำหรับผู้หญิง น้ำหนักเบา แห้งไว ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sba50c2dcaf68462d8d14b6d2f7bdaf4a5.jpg_200x200q90.jpg",
        "price": 3201.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5894985755.html",
        "sold": 1
    },
    {
        "product_name": "≮318≯Sport bra และ กางเกง gymshark (xs)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2d2725fd05ff4764a39049224699819c6.jpg_200x200q90.jpg",
        "price": 3195.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16098094604.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกั๊กให้ความอบอุ่นในฤดูหนาว17ส่วนของร่างกายเสื้อกั๊กทำความร้อนผู้ชายผู้หญิงซักได้ให้ความร้อนอย่างรวดเร็วสำหรับกลางแจ้งเล่นสกีตกปลาเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/c34bd4acc6d4133abc4fcfcb41cb0fa9.jpg_200x200q90.jpg",
        "price": 3194,
        "remark": "https://www.lazada.co.th/products/pdp-i4440200631.html",
        "sold": 0
    },
    {
        "product_name": "MANMI | เสื้อคอวีหลวมสบายหายใจได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S35cdaf31b01247018418a11d35f746fem.jpg_200x200q90.jpg",
        "price": 3185.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16074904134.html",
        "sold": 0
    },
    {
        "product_name": "Alcove - Corpo Top",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa177bf635b974baeb2be00f2f099fb4bq.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i4117942855.html",
        "sold": 1
    },
    {
        "product_name": "SUMMER SWING: World Okayest Golfer Polo (UPF Protection)",
        "product_image": "https://img.lazcdn.com/g/p/abd4671a17663556e37e074b641a4744.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5620806878.html",
        "sold": 3
    },
    {
        "product_name": "Tavi Noir แทวี นัวร์ Breezy Tank เสื้อออกกำลังกาย รุ่น Breezy Tank",
        "product_image": "https://img.lazcdn.com/g/p/77ef315664d53774f34c8d4c0785c6ce.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i3573285735.html",
        "sold": 0
    },
    {
        "product_name": "Luxury Competition Equestrian Shirt เสื้อขี่ม้าผู้หญิง แขนสั้น ซิปหน้า สำหรับการแข่งขันและการฝึกซ้อมระดับพรีเมียม",
        "product_image": "https://img.lazcdn.com/g/p/48819cd341218272928cd94708252087.png_200x200q90.png",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i6050302329.html",
        "sold": 0
    },
    {
        "product_name": "เว็ทสูทเด็กเล็ก – 2.5mm Infant Wetsuit แบรนด์ WATER PRO",
        "product_image": "https://img.lazcdn.com/g/p/037ec15f2cd5ef5a4ae81cd23fc8ca4c.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5874829851.html",
        "sold": 0
    },
    {
        "product_name": "Cherie Sculpt Top",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S791d2dd3f1fa41babfc9d5d12a7205b6w.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5565253763.html",
        "sold": 4
    },
    {
        "product_name": "เสื้อยืดแขนสั้นสำหรับเด็กเล่นกอล์ฟ ระบายอากาศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seb6892c574034ade9655b8787f37082dw.jpg_200x200q90.jpg",
        "price": 3171,
        "remark": "https://www.lazada.co.th/products/pdp-i6066818461.html",
        "sold": 0
    },
    {
        "product_name": "WOSAWE | เสื้อแจ็คเก็ตมอเตอร์ไซค์สำหรับผู้หญิง WOSAWE รุ่นซัมเมอร์ ทรงเซ็กซี่ เหมาะสำหรับปั่นจักรยานเสือภูเขา ลงเขา ขี่มอเตอร์ครอส พร้อมแผ่นรองข้อศอก ไหล่ และแผ่นรองหลัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6e5e04aa24214dceb3448d1892efe90fF.jpg_200x200q90.jpg",
        "price": 3166.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16104553523.html",
        "sold": 0
    },
    {
        "product_name": "Lulu ใหม่กีฬาโยคะแขนยาวคอกลมปกนิ้วคงที่ชุดชั้นในที่ถอดออกได้ออกกำลังกายยอดนิยม ds220",
        "product_image": "https://img.lazcdn.com/g/p/3fe21dbbcc23a01673cbb5a4961d62f3.jpg_webp_200x200q90.jpg",
        "price": 3141.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5048820907.html",
        "sold": 0
    },
    {
        "product_name": "H.S.H Kids | ชุดกีฬาสไตล์วิทยาลัย แขนสั้นลายดาว ชุดกีฬาหวาน ชุดกีฬาผู้หญิง ชุดกีฬาฤดูร้อน ชุดกีฬาลำลอง ชุดกีฬา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S812a2505f5be41d7989d03b5ebf0b457o.jpg_200x200q90.jpg",
        "price": 3141.08,
        "remark": "https://www.lazada.co.th/products/pdp-i5840368589.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อกั๊กเทนนิสเอวยืดกระชับป้องกันแสงพร้อมบราในตัว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8a54103c74cf4f59a748d753cb18f0c3B.jpg_200x200q90.jpg",
        "price": 3132.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16050215892.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้าฤดูใบไม้ร่วงสำหรับผู้หญิงไซส์ใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa3490bec65d04bdcb5a4752280105e6fF.jpg_200x200q90.jpg",
        "price": 3128.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16084643558.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS เสื้อผ้าผู้หญิงเสื้อเจอร์ซีย์นักปั่นระบายอากาศได้ดีดูดซับเหงื่อแขนสั้นเสื้อยืดจักรยาน YKK ซิปยืดหยุ่นสูง MTB จักรยานเสือหมอบ",
        "product_image": "https://img.lazcdn.com/g/p/c7ef69e826c92efb0e5765c8ed2aa8f5.jpg_200x200q90.jpg",
        "price": 3128,
        "remark": "https://www.lazada.co.th/products/pdp-i5223271508.html",
        "sold": 0
    },
    {
        "product_name": "แจ็คเก็ตสปอร์ตหญิงแบบระบายอากาศเรียบง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S596baaacef1f46259f1176a305a3f060g.jpg_200x200q90.jpg",
        "price": 3126,
        "remark": "https://www.lazada.co.th/products/pdp-i16085379909.html",
        "sold": 0
    },
    {
        "product_name": "LAMEDA เสื้อสำหรับขี่จักรบานมืออาชีพผู้หญิงฤดูใบไม้ผลิฤดูร้อนแขนยาวบางยืดหยุ่นสูงระบายอากาศมีกระเป๋า MTB จักรยานเสือหมอบเสื้อคลุม",
        "product_image": "https://img.lazcdn.com/g/p/4ce890e7fb9a56584648089525a1daef.jpg_200x200q90.jpg",
        "price": 3118,
        "remark": "https://www.lazada.co.th/products/pdp-i5744787752.html",
        "sold": 0
    },
    {
        "product_name": "STK Small Town Kid | เสื้อยืดคอกวีแขนสั้น ทรงหลวม สไตล์รักบี้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0346ca1d8807424489d56b9cb0b4f98eT.png_200x200q90.png",
        "price": 3110.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16082953258.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดลำลองจีบผู้หญิงหลวม",
        "product_image": "https://img.lazcdn.com/g/p/f8beb78109216818e300d04fff0dfd46.jpg_200x200q90.jpg",
        "price": 3106,
        "remark": "https://www.lazada.co.th/products/pdp-i6038713802.html",
        "sold": 0
    },
    {
        "product_name": "KEED :🦖🦖 ชุดว่ายน้ำปรับอุณหภูมิ บอดี้สูทแขนยาว-ขายาว 🦖🦖&gt;&gt; Dino Safari &lt;&lt; *102GR*",
        "product_image": "https://img.lazcdn.com/g/p/95aa469a5870d7cb0c801a08fc717f8c.jpg_200x200q90.jpg",
        "price": 3100.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5515580417.html",
        "sold": 8
    },
    {
        "product_name": "【TVI】ROCKBROSเสื้อผ้าจักรยานเสือหมอบยืดหยุ่นแห้งเร็วมีซิปผู้หญิง,เสื้อผ้าผู้หญิงพื้นเรียบระบายอากาศได้ดีเสื้อยืดจักรยาน",
        "product_image": "https://img.lazcdn.com/g/p/0142c7367764cef21e7f8f19e0d59ee0.jpg_200x200q90.jpg",
        "price": 3100,
        "remark": "https://www.lazada.co.th/products/pdp-i5362179628.html",
        "sold": 0
    },
    {
        "product_name": "แบรนด์ Birdiedreams เสื้อกอล์ฟ รุ่น Bella แบบคอ และ แขนตุ๊กตา  เสื้อยืดใส่สบาย ผ้าเย็น ไม่ซับเหงื่อย (สีฟ้า)",
        "product_image": "https://img.lazcdn.com/g/p/22a3f6f851e2b6f0509204e9f7d115f8.jpg_200x200q90.jpg",
        "price": 3100,
        "remark": "https://www.lazada.co.th/products/pdp-i5673449662.html",
        "sold": 0
    },
    {
        "product_name": "แบรนด์ Birdiedreams เสื้อกอล์ฟรุ่น Bella แบบ คอและ แขนตุ๊กตา เสื้อยืดใส่สบาย ผ้าเย็น ไม่ซับเหงื่อย (สีเขียว เลม่อน)",
        "product_image": "https://img.lazcdn.com/g/p/629cffc1ec5e5f77d77ea9bf6e2926df.jpg_200x200q90.jpg",
        "price": 3100,
        "remark": "https://www.lazada.co.th/products/pdp-i5673443719.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS เสื้อผ้าจักรยานเสือหมอบผู้หญิงผ้าซึมซับเหงื่อ MTB เนื้อเรียบระบายอากาศได้ดีแห้งเร็วมีซิปเสื้อยืดจักรยาน",
        "product_image": "https://img.lazcdn.com/g/p/82e03162e77cdfb1571c157546731c08.jpg_200x200q90.jpg",
        "price": 3092,
        "remark": "https://www.lazada.co.th/products/pdp-i5359314433.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS เสื้อทีเชิ้ตเสื้อเจอร์ซีย์นักปั่นปั่นจักรยานผู้หญิงระบายอากาศได้ดีมีซิปสไตล์ YKK ซึมซับเหงื่อเสื้อผ้าจักรยานเสือหมอบยืดหยุ่นสูง",
        "product_image": "https://img.lazcdn.com/g/p/c46bc8330b98b1798ae79eb83d9484b2.jpg_200x200q90.jpg",
        "price": 3092,
        "remark": "https://www.lazada.co.th/products/pdp-i5265206935.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแขนสั้นพิมพ์ลายตัวอักษร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb398373d93fb41a69a4743dcdd6470deX.jpg_200x200q90.jpg",
        "price": 3092,
        "remark": "https://www.lazada.co.th/products/pdp-i5997909336.html",
        "sold": 0
    },
    {
        "product_name": "INBIKE เสื้อปั่นจักรยานขนแกะผู้หญิงแขนยาวเสื้อสำหรับการขี่จักรยานเสื้อผ้าปั่นจักรยานฤดูหนาว MTB เสื้อจักรยานเสือหมอบภูเขาเสื้อแจ็คเก็ตเสื้อผ้า",
        "product_image": "https://img.lazcdn.com/g/p/df99f33e0914e2a25116a3fc1d81bdfd.jpg_200x200q90.jpg",
        "price": 3070,
        "remark": "https://www.lazada.co.th/products/pdp-i4953328382.html",
        "sold": 2
    },
    {
        "product_name": "เสื้อยืดสุดสดชื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S97a229fc84b048938444173b7f269f520.jpg_200x200q90.jpg",
        "price": 3066.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16113117064.html",
        "sold": 0
    },
    {
        "product_name": "KĖĖD & Bad badtz Maru  : เสื้อชูชีพผ้าลายลิขสิทธ์ พร้อมหางจรเข้ด้านหลัง  *106XO*",
        "product_image": "https://img.lazcdn.com/g/p/646288b045cf483a5aaa043074cc2a79.jpg_200x200q90.jpg",
        "price": 3065.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5515537740.html",
        "sold": 2
    },
    {
        "product_name": "≮211≯(DROP 2) MONCHHICHI FRIEND SPORT TEE (KIDS) (SIZE 12-24M. พร้อมส่ง/ S-XXL PRE-ORDER พร้อมส่ง 27 ก.พ.)",
        "product_image": "https://img.lazcdn.com/g/p/22d0eb11cc5524cccf64b52de94bf169.jpg_200x200q90.jpg",
        "price": 3056.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16046456169.html",
        "sold": 0
    },
    {
        "product_name": "LAMEDA เสื้อปั่นจักรยานสำหรับผู้หญิง - ลายน้องแมว",
        "product_image": "https://img.lazcdn.com/g/p/afbf37902a622907aa56e20b8f6d0300.jpg_200x200q90.jpg",
        "price": 3056,
        "remark": "https://www.lazada.co.th/products/pdp-i5512318471.html",
        "sold": 0
    },
    {
        "product_name": "EnForme Long Sleeve – เสื้อออกกำลังกายแขนยาว",
        "product_image": "https://img.lazcdn.com/g/p/ea41c65805fed205bc2eaf388f219370.jpg_200x200q90.jpg",
        "price": 3040,
        "remark": "https://www.lazada.co.th/products/pdp-i6038006569.html",
        "sold": 2
    },
    {
        "product_name": "เสื้อยืดผู้หญิงมีจีบหลวมลำลองมาใหม่",
        "product_image": "https://img.lazcdn.com/g/p/d8ff4c228a72a64ddfa080b15b49d2f7.jpg_200x200q90.jpg",
        "price": 2450,
        "remark": "https://www.lazada.co.th/products/pdp-i6004671963.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟสไตล์เกาหลีใหม่ กระเป๋าถือแบบยูนิเซ็กส์ กระเป๋าสะพายไหล่ กระเป๋าสะพายข้าง กระเป๋าเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/bd03540928aadd14c715db0d693a2a57.jpg_webp_200x200q90.jpg",
        "price": 3026.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16146859399.html",
        "sold": 0
    },
    {
        "product_name": "CLIMAX VISION | เสื้อถักคอวีรัดเอวเพื่อสรีระ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1ff14361b73641dfaa05e524ed8d7cff0.jpg_200x200q90.jpg",
        "price": 3023.3,
        "remark": "https://www.lazada.co.th/products/pdp-i6067009716.html",
        "sold": 53
    },
    {
        "product_name": "Rockbros | เสื้อปั่นจักรยานผู้หญิงแห้งไวระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S68d9f5b2bcec4316bd799bf7d33bc586j.jpg_200x200q90.jpg",
        "price": 3020.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6003022202.html",
        "sold": 0
    },
    {
        "product_name": "Lulu New เสื้อกล้ามกีฬาโยคะสายคล้องไหล่กว้างที่ถอดออกได้ Bra Fitness TOP dsg395",
        "product_image": "https://img.lazcdn.com/g/p/d3279289b12940c4a91458423939ee9b.jpg_webp_200x200q90.jpg",
        "price": 3014.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5044739999.html",
        "sold": 0
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดป้องกันแดดแห้งไวให้ความรู้สึกเย็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scef02e20d60549d38bc528edd145236aj.png_200x200q90.png",
        "price": 3013.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16060394322.html",
        "sold": 4
    },
    {
        "product_name": "DUHAN | เสื้อผ้ากีฬาจักรยาน Duhuan GP3 สำหรับผู้หญิง ทรงเข้ารูป ทรงสลิมฟิต ดีไซน์เซ็กซี่ เสื้อสเวตเตอร์มอเตอร์ไซค์พิมพ์ลายการแข่งขัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb7abd8b4b78a432a83cb2c3a9b0151e4p.jpg_200x200q90.jpg",
        "price": 3012.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5841060497.html",
        "sold": 0
    },
    {
        "product_name": "WILLIAM FOX&SONS | เสื้อยืดแขนยาวแห้งเร็วและเย็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sca2cb82f849c4aa4b30e6af76e2f8b1fu.jpg_200x200q90.jpg",
        "price": 3010.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6078519492.html",
        "sold": 0
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดแขนสั้นดูดซับความชื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S24596d21c0a841c0829f8669655c79efs.png_200x200q90.png",
        "price": 3007.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16060394206.html",
        "sold": 5
    },
    {
        "product_name": "Blue Ma Belle Shirt เสื้อโปโลคอปกสำหรับกีฬากอล์ฟและเทนนิส ผ้าระบายอากาศ กันยูวี สีฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/d28212ee73483b347c1cf41e66f83e6e.jpg_200x200q90.jpg",
        "price": 3007.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5778011902.html",
        "sold": 4
    },
    {
        "product_name": "BONELESS | เสื้อยืดแขนยาวพิมพ์ลายตารางฟุตบอล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc086483923a849679d3dc00b3be5b4d0Y.jpg_200x200q90.jpg",
        "price": 3003.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16052887975.html",
        "sold": 0
    },
    {
        "product_name": "ONMYGAME | เสื้อเทนนิสสำหรับเด็กแบบแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6cb5be23221b4dd7b6e929bb190d0e93U.png_200x200q90.png",
        "price": 3000.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16103015341.html",
        "sold": 3
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดฝึกซ้อมกลางแจ้งสำหรับเด็กผู้ชาย ระบายอากาศได้ดี มีฟลีซบุข้างใน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S477fd15e66964ee5b5ba2bc1a954ec0aP.png_200x200q90.png",
        "price": 3000.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6049063338.html",
        "sold": 96
    },
    {
        "product_name": "LAMED Aเสื้อยืดแขนยาวผู้หญิงผู้ชาย เนื้อผ้าระบายอากาศ ไซส์หลวม เหมาะสำหรับ วิ่ง แบดมินตัน ปั่นจักรยาน ออกกำลังกายกลางแจ้ง แห้งเร็ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S49e51274dac64f06bd59daacf16510feZ.jpg_200x200q90.jpg",
        "price": 3000,
        "remark": "https://www.lazada.co.th/products/pdp-i16143869404.html",
        "sold": 0
    },
    {
        "product_name": "INBIKE ผู้หญิงเสื้อเจอร์ซีย์นักปั่นฤดูร้อนป้องกันรังสียูวีเสื้อผ้าปั่นจักรยานแห้งเร็วภูเขาหญิงชุดปั่นจักรยาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se5222be613ef415ebcd643af747d1e9eO.jpg_200x200q90.jpg",
        "price": 3000,
        "remark": "https://www.lazada.co.th/products/pdp-i16139159283.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกล้ามเพาะกายผู้ชายรุ่น STRINGER (สีดำ) ชุดออกกำลังกาย Fitness dress STRINGER WEIGHT TRAINING TANK TOP - BLACK weight training exercise wearing dress SIZE M",
        "product_image": "https://img.lazcdn.com/g/p/cf9c3be54e39df2bac6bec4f3b4ec76f.jpg_200x200q90.jpg",
        "price": 2998,
        "remark": "https://www.lazada.co.th/products/pdp-i1021690136.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อโปโลขี่ม้าแขนสั้นผ้าตาข่ายสำหรับเด็กผู้หญิงรุ่น PL500 (สีชมพู/ม่วงพลัม) สำหรับเด็กอายุ8ปี ชุดโปโลแขนสั้นขับขี่ม้า เสื้อคอปกเล่นกีฬา 500 GIRLS' HORSE RIDING MESH SHORT-SLEEVED POLO SHIRT - PINK/PLUM",
        "product_image": "https://img.lazcdn.com/g/p/85c7383dd9eba74841614c353c0ac96a.jpg_200x200q90.jpg",
        "price": 2998,
        "remark": "https://www.lazada.co.th/products/pdp-i1025652300.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเสื้อเจอร์ซีย์นักปั่นปั่นจักรยานสำหรับผู้หญิง,เสื้อเจอร์ซีย์นักปั่นเสื้อแขนสั้นระบายอากาศได้ดีเสื้อผ้าจักรยานเสือหมอบแฟชั่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbb11e341ed15422e9c3a7207a26e6cf6F.jpg_200x200q90.jpg",
        "price": 2998,
        "remark": "https://www.lazada.co.th/products/pdp-i16134680956.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเจอร์ซีย์นักปั่นผู้หญิงแฟชั่นที่เบามากเสื้อจักรยานเสือหมอบ MTB ระบายอากาศเสื้อยืดจักรยานบาง",
        "product_image": "https://img.lazcdn.com/g/p/34a6f9de9917005eb0bb4947b2a01999.jpg_200x200q90.jpg",
        "price": 2998,
        "remark": "https://www.lazada.co.th/products/pdp-i5793649946.html",
        "sold": 0
    },
    {
        "product_name": "YUEBU | เสื้อกั๊กวิ่งดูดซับเหงื่อ ระบายอากาศได้ดี น้ำหนักเบาสุด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S723a88ffb8ab412eb039c6865ceb441aF.jpg_200x200q90.jpg",
        "price": 2997.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16051040186.html",
        "sold": 0
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดแขนสั้นระบายอากาศแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S57308d28537942048697816a6259d758P.png_200x200q90.png",
        "price": 2995.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16106606966.html",
        "sold": 0
    },
    {
        "product_name": "Rockbros | เสื้อปั่นจักรยานระบายเหงื่อได้ดีสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S23e5faed28e64eaaa4e1b7f59c88576a0.jpg_200x200q90.jpg",
        "price": 2994.28,
        "remark": "https://www.lazada.co.th/products/pdp-i6002953819.html",
        "sold": 1
    },
    {
        "product_name": "Lulu New YOGA Sports SHORT Sleeve Tight Elastic Bra Fitness TOP yd069",
        "product_image": "https://img.lazcdn.com/g/p/1be61c4d0ffdc6cc1aec98a9f83f623b.jpg_webp_200x200q90.jpg",
        "price": 2993.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5110932455.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกีฬาสีเขียวเสื้อรัดกล้ามเนื้อชุดจั๊มสูทแบบกางเกง",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S1b4b25a9816f42059d3768ff203b3b845.jpg_200x200q90.jpg",
        "price": 2992,
        "remark": "https://www.lazada.co.th/products/pdp-i16112026340.html",
        "sold": 0
    },
    {
        "product_name": "Nafurno ลุยตกปลาระบายอากาศพีวีซีเสริมตะเข็บสายรัดปรับพร้อมไม้แขวนเสื้อบูตสำหรับผู้ชายผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/74520d4fa3f390948c60e8a25ed1fbbf.jpg_200x200q90.jpg",
        "price": 2992,
        "remark": "https://www.lazada.co.th/products/pdp-i16147136605.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | เสื้อโปโลแขนสั้นสำหรับเด็ก ใส่สบายในฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb39c4e80c843496296f70909204361ceW.jpg_200x200q90.jpg",
        "price": 2989.3,
        "remark": "https://www.lazada.co.th/products/pdp-i6073057249.html",
        "sold": 1
    },
    {
        "product_name": "ชุดว่ายน้ำเด็กชายกันแดดแห้งไวระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5a6da3c3bd704ceea0cbfc9e086c460dU.png_200x200q90.png",
        "price": 2982.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6032011305.html",
        "sold": 0
    },
    {
        "product_name": "SUMMER SWING VENUS HALTER NECK TOPS WHITE [เสื้อกีฬาคล้องคอ]",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9c264c42863c40e7a87a0d9197ebb48at.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i5945940948.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเซทงานป้าย งานตามหา เสื้อ+กางเกง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd10511e646874eb7a2eeece22d51221ee.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i5786740323.html",
        "sold": 0
    },
    {
        "product_name": "D&P Sport Tank | LolliPOP | D-7738 เสื้อกล้าม สายเดี่ยว มีฟองน้ำ ถอดซักได้",
        "product_image": "https://img.lazcdn.com/g/p/8836cb3b631a01fd2514851fea0ab5ba.png_200x200q90.png",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i5649539510.html",
        "sold": 2
    },
    {
        "product_name": "Jenim Sports Jungle Ribbed Bra สปอร์ตบรา ชุดอกกำลังกาย",
        "product_image": "https://img.lazcdn.com/g/p/bde4780b8ef7b9eb5640e3e39a04f443.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i4244803389.html",
        "sold": 0
    },
    {
        "product_name": "NUH SPORTSWEAR HOODED THIN JACKET - เสื้อแจ็คเก็ตผ้าร่มบางสำหรับออกกำลังกาย",
        "product_image": "https://img.lazcdn.com/g/p/1b992bcd23cb680a6f3e67322a3cde13.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i6002849014.html",
        "sold": 0
    },
    {
        "product_name": "Pre-Order_Sizzlin' Muscle Tank (เสื้อออกกำลังกายซุมบ้า)",
        "product_image": "https://img.lazcdn.com/g/p/e5f224bba40075c1e411b0c88f4f1398.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i5863729096.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเnราะ เสื้อเnราะทหาร เสื้อปลอกเnราะ เสื้อเวส Bogie1 รุ่น จิ๋ว ดีไซน์สวย งานเนี้ยบ ผ้าคอร์ดูร่า 1000D ทนทาน แข็งแรง สี-ดำ",
        "product_image": "https://img.lazcdn.com/g/p/7c45d7e0b43cf411897594d36af1c1fb.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i2755842765.html",
        "sold": 0
    },
    {
        "product_name": "Pre-Order_Latin Movement Muscle Crop Tank  (เสื้อครอปออกกำลังกายซุมบ้า)",
        "product_image": "https://img.lazcdn.com/g/p/851ed004fe2caeeaaf41791ab8abcf82.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i16071262159.html",
        "sold": 0
    },
    {
        "product_name": "Maison Nabi - White Sheer Muse Long Sleeve เสื้อแขนยาสีขาว ผ้าซีทรูใส่สบาย แมทช์ได้หลายลุคชุดชั้นใน เสื้อออกกำลังกาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S62986b392dbf4a809a14002f1b75802bO.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i5974974283.html",
        "sold": 0
    },
    {
        "product_name": "BOSIDENG | เสื้อยืดใส่ภายนอกให้ความรู้สึกเย็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa51d61d164604028b68f14ef9f22e8cfr.png_200x200q90.png",
        "price": 2975.58,
        "remark": "https://www.lazada.co.th/products/pdp-i6010996921.html",
        "sold": 23
    },
    {
        "product_name": "【TVI】ROCKBROS เสื้อปั่นจักรยานผู้หญิง,เสื้อปั่นจักรยานแขนสั้นมีกระเป๋าพิมพ์ลายการ์ตูนเสื้อเจอร์ซีย์นักปั่นแห้งเร็วระบายอากาศดี",
        "product_image": "https://img.lazcdn.com/g/p/d63ab3fd77f04444acd26bd8cf18d921.jpg_200x200q90.jpg",
        "price": 2970,
        "remark": "https://www.lazada.co.th/products/pdp-i5136407585.html",
        "sold": 2
    },
    {
        "product_name": "ชุดโยคะ Yoyomeat สำหรับผู้หญิง สองชิ้น แห้งเร็ว เสื้อผ้าออกกำลังกายแบบลำลอง ใส่สบาย ชุดโยคะ ชุดเต้นรำ ชุดกีฬา ชุดโยคะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se55b77c05f0242f29b5cd10ab21df4054.jpg_200x200q90.jpg",
        "price": 2964,
        "remark": "https://www.lazada.co.th/products/pdp-i4497921020.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเจอร์ซีย์นักปั่นผู้หญิงน้ำหนักเบาระบายอากาศได้เสื้อแจ็คเก็ตขี่จักรยานแขนยาวชุดกีฬากลางแจ้งแห้งเร็วสำหรับการเดินป่าการขี่ม้าการเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/feac3bb5e6408130b85deeab006055a2.jpg_200x200q90.jpg",
        "price": 2962,
        "remark": "https://www.lazada.co.th/products/pdp-i5723392056.html",
        "sold": 0
    },
    {
        "product_name": "TOSUOD | เสื้อปั่นจักรยานสำหรับผู้หญิง ระบายเหงื่อ แขนสั้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4c59642cf0eb4ec8a63bb4fbe1ae015ck.jpg_200x200q90.jpg",
        "price": 2957.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5895055246.html",
        "sold": 0
    },
    {
        "product_name": "TOSUOD | เสื้อปั่นจักรยานสำหรับผู้หญิง แขนสั้น ป้องกัน UV ระบายอากาศได้ดี ดูดซับเหงื่อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb5f374ee11a34a68a6f39089af7141few.jpg_200x200q90.jpg",
        "price": 2957.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5895002938.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อชั้นในสไตล์เสื้อกล้ามสำหรับผู้หญิง, ชุดออกกำลังกายโยคะ, เสื้อกีฬากันกระแทกแบบยาวพร้อมแผ่นรองหน้าอก",
        "product_image": "https://img.lazcdn.com/g/p/d03b7f972baf3d19e9dfc86bfc8a7644.jpg_200x200q90.jpg",
        "price": 2955.4,
        "remark": "https://www.lazada.co.th/products/pdp-i16119833506.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดจับจีบผู้หญิงลำลองเสื้อหลวมใหญ่พิเศษไม่สม่ำเสมอใหม่",
        "product_image": "https://img.lazcdn.com/g/p/3902e43a207a5011f1e24f6646ef1209.jpg_200x200q90.jpg",
        "price": 2950,
        "remark": "https://www.lazada.co.th/products/pdp-i6015516484.html",
        "sold": 0
    },
    {
        "product_name": "RockBros | ROCKBROSฤดูหนาวขี่จักรยานเสื้อขนแกะผู้ชายผู้หญิงWindproofจักรยานความร้อนแจ็คเก็ตกลางแจ้งMtb Bike Jersey 0 องศาเสื้อผ้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S098c6002118a4ff0a4768d7870491f1aH.jpg_200x200q90.jpg",
        "price": 2941.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16104838535.html",
        "sold": 0
    },
    {
        "product_name": "✨NEW✨ KEED : ชุดว่ายน้ำปรับอุณหภูมิ บอดี้สูทแขนยาว-ขายาว  &gt;&gt; Hapidanbui  &lt;&lt; *118HP*",
        "product_image": "https://img.lazcdn.com/g/p/514e67dcb6ad977db962912819a68c35.jpg_200x200q90.jpg",
        "price": 2941.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5515520880.html",
        "sold": 4
    },
    {
        "product_name": "เสื้อยืดหลวมๆ สไตล์ Casual Elegance สำหรับฤดูใบไม้ผลิ-ร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa529d798d7544771b948fa44bada4f2cq.jpg_200x200q90.jpg",
        "price": 2932.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16109557315.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเสื้อเจอร์ซีย์นักปั่นผู้หญิงแขนยาวแห้งเร็วระบายอากาศดีชุดสำหรับขี่จักรยานมืออาชีพ",
        "product_image": "https://img.lazcdn.com/g/p/138f65cb02f1ec86eeaf622ee5b5d100.jpg_200x200q90.jpg",
        "price": 2932,
        "remark": "https://www.lazada.co.th/products/pdp-i5230635231.html",
        "sold": 0
    },
    {
        "product_name": "Golf Summer Clothing Sports Leisure Couple Ladies Short Sleeve Lapel Breathable Shirt Leisure Fashion Sports Daily",
        "product_image": "https://img.lazcdn.com/g/p/5749c9ec5a1da748e97ff6a38cbcfcbb.jpg_200x200q90.jpg",
        "price": 2924,
        "remark": "https://www.lazada.co.th/products/pdp-i16100773735.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อแฟชั่นใหม่ ฤดูร้อน 2025 ทันสมัย วัยรุ่น สง่างาม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb32b16ff2f7e487789432ccc8b0bf9a89.jpg_200x200q90.jpg",
        "price": 2922.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5993906818.html",
        "sold": 0
    },
    {
        "product_name": "✨NEW✨ KEED : Thunder bot ชุดว่ายน้ำควบคุมอุณหภูมิ (TempFlex) บอดี้สูท แขนยาว-ขายาว *116NG*",
        "product_image": "https://img.lazcdn.com/g/p/64176cb00675a0021f096eb2cf06df2a.jpg_200x200q90.jpg",
        "price": 2918.36,
        "remark": "https://www.lazada.co.th/products/pdp-i5515611224.html",
        "sold": 5
    },
    {
        "product_name": "PGA | เสื้อโปโลกอล์ฟสำหรับเด็กชาย แห้งไว ป้องกันแดด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S25f1840a8f494ca9aaa74a07babd762bK.jpg_200x200q90.jpg",
        "price": 2908.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6066783617.html",
        "sold": 0
    },
    {
        "product_name": "PGA | เสื้อยืดเย็นพร้อมป้องกันรังสี UV",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S57fda829b9bb48f6b75329c960424bf5O.jpg_200x200q90.jpg",
        "price": 2908.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6066926011.html",
        "sold": 0
    },
    {
        "product_name": "WEST BIKING เสื้อเสื้อผ้าปั่นจักรยานแขนยาวเสื้อเจอร์ซีย์นักปั่นเดินเขาผู้ชายผู้หญิงเสื้อกีฬากลางแจ้งลำลองแฟชั่นฤดูร้อนสวมใส่สบาย",
        "product_image": "https://img.lazcdn.com/g/p/361c704099a9117797b697e1237602db.jpg_200x200q90.jpg",
        "price": 2902,
        "remark": "https://www.lazada.co.th/products/pdp-i5763809312.html",
        "sold": 0
    },
    {
        "product_name": "ชุดไทเก๊กชาย 2026 สีพื้น ชุดเต๋า แขนยาว สำหรับฝึกซ้อมเทควันโด เสื้อผ้าฝึกสมาธิเซน ชุดฮันฟู ชุดฝึกกังฟู",
        "product_image": "https://img.lazcdn.com/g/p/31ed1b29d0c3df4619e2f9a3303b1743.jpg_200x200q90.jpg",
        "price": 2901.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6066470213.html",
        "sold": 0
    },
    {
        "product_name": "Women's Spring Golf Jersey, New Style, Windproof and Breathable, Comfortable to Make You Enjoy Going Out",
        "product_image": "https://img.lazcdn.com/g/p/6619350f7795495bb97292191ca3f605.jpg_webp_200x200q90.jpg",
        "price": 2900,
        "remark": "https://www.lazada.co.th/products/pdp-i16092379227.html",
        "sold": 0
    },
    {
        "product_name": "WOSAWE | WOSAWE เสื้อแจ็คเก็ตมอเตอร์ไซค์สำหรับผู้หญิง MTB Downhill Biker เสื้อสะท้อนแสงสำหรับผู้หญิงวัยรุ่นสาววิบากเสื้อผ้ายืดหยุ่นสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8c93c4e772154bc480f33403f9edc2d5C.jpg_200x200q90.jpg",
        "price": 2893.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16104524322.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเจอร์ซีย์นักปั่นผู้หญิงกันลมอบอุ่นแขนยาวเสื้อเจอร์ซีย์จักรยานมีกระเป๋าฤดูใบไม้ร่วงฤดูหนาว MTB เสื้อใส่ปั่นจักรยานบนถนน",
        "product_image": "https://img.lazcdn.com/g/p/953192822954969242584b0d38af80df.jpg_200x200q90.jpg",
        "price": 2892,
        "remark": "https://www.lazada.co.th/products/pdp-i5381377295.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกั๊กออกกำลังกายพร้อมฟองน้ำรอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S213a2fff67b8474a9fe8bb0667679000R.png_200x200q90.png",
        "price": 2886.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16102461081.html",
        "sold": 0
    },
    {
        "product_name": "Karlak เสื้อกั๊ก6.6LB น้ำหนักปรับน้ำหนักได้,เสื้อแจ็คเก็ตถ่วงน้ำหนักออกกำลังกาย",
        "product_image": "https://img.lazcdn.com/g/p/f72197a60658966a8ab1d23a9aa52788.jpg_200x200q90.jpg",
        "price": 2882.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5897490924.html",
        "sold": 0
    },
    {
        "product_name": "TOSUOD | เสื้อแขนยาวสำหรับปั่นจักรยาน ระบายอากาศได้ดี แห้งไว สำหรับสตรี ฤดูใบไม้ผลิและใบไม้ร่วง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5cf949c9334043c8b1c70eea59f567e8P.jpg_200x200q90.jpg",
        "price": 2882.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5894951199.html",
        "sold": 0
    },
    {
        "product_name": "TOSUOD | เสื้อปั่นจักรยานสำหรับผู้หญิง ระบายอากาศได้ดี แห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3e519ae3e56847a18edb9569e95de0a0r.jpg_200x200q90.jpg",
        "price": 2882.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5895066353.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้ากีฬาลำลองสำหรับผู้หญิง โอเวอร์ไซส์ ลายพิมพ์โลโก้ ผ้าฝ้าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5571dc400ff94d7f8e4939916855cb27y.jpg_200x200q90.jpg",
        "price": 2881.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6031105830.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยาน castelli ผู้หญิง แขนสั้น",
        "product_image": "https://img.lazcdn.com/g/p/1cc2157ce5a7b5836147a4f5e0f81839.jpg_200x200q90.jpg",
        "price": 2880,
        "remark": "https://www.lazada.co.th/products/pdp-i4515940623.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกล้ามเทนนิสแบบบราตัวเดียวเนื้อผ้า Jacquard ไร้ตะเข็บพร้อมฟองน้ำสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdcf562f5cafd4b0ab7db04530e02b0ecN.png_200x200q90.png",
        "price": 2877.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16120135065.html",
        "sold": 3
    },
    {
        "product_name": "STK Small Town Kid | เสื้อยืดแขนยาวแบบวาฟเฟิล ซิปครึ่งตัว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8b2da1db6a6d482f9f680110a11a9ad9R.png_200x200q90.png",
        "price": 2865.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16076362679.html",
        "sold": 0
    },
    {
        "product_name": "Alo North America Al Yoga Tight Long Sleeve Yoga Suit Short Base Shirt Navel Exposed Running Sports Pilates Top",
        "product_image": "https://img.lazcdn.com/collect/cbu/img/ibank/O1CN01OKFwIK1qkcugycI3K_!!2219075235534-0-cib.jpg_200x200q90.jpg",
        "price": 2862,
        "remark": "https://www.lazada.co.th/products/pdp-i6036752468.html",
        "sold": 0
    },
    {
        "product_name": "XIYUQI | เสื้อคลุมท้องสุดชิคสำหรับลดหุ่น ฤดูใบไม้ร่วง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S25f7ddf80cc84456b2a309c111b6b01fG.jpg_200x200q90.jpg",
        "price": 2861.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16076746108.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดกีฬาแห้งไว ป้องกันแดด ช่วยระบายความร้อน ป้องกันแบคทีเรีย และดูดซับเหงื่อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9b48e31e15d549e9a9a20e27131c372eY.jpg_200x200q90.jpg",
        "price": 2856,
        "remark": "https://www.lazada.co.th/products/pdp-i16112069388.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อแจ็คเก็ตกันหนาวสำหรับเล่นสกี,เคสใส่ของสกีกันน้ำได้สำหรับเล่นสกีกลางแจ้งเล่นสกี",
        "product_image": "https://img.lazcdn.com/g/p/fc63d34bdf285ec87f65e892f1e93a2c.jpg_200x200q90.jpg",
        "price": 2854,
        "remark": "https://www.lazada.co.th/products/pdp-i16061419701.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อคอกลมหลวมสไตล์ลำลองสปอร์ตแฟชั่นไซส์ใหญ่สำหรับผู้หญิง พร้อมกางเกงขายาวทรงกว้าง ชุดลำลองสำหรับฤดูร้อนสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sef678c49e2e340c6949da639dcce49d5p.jpg_200x200q90.jpg",
        "price": 2849.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16096868628.html",
        "sold": 0
    },
    {
        "product_name": "TOSUOD | เสื้อปั่นจักรยานแห้งไวสำหรับผู้หญิงฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S51d279d1e4ec43b08d0e9c3b4784f0acD.jpg_200x200q90.jpg",
        "price": 2628.84,
        "remark": "https://www.lazada.co.th/products/pdp-i5893850270.html",
        "sold": 0
    },
    {
        "product_name": "TOSUOD | เสื้อแขนยาวสำหรับปั่นจักรยานสตรี น้ำหนักเบา ระบายอากาศได้ดี แห้งไว สำหรับฤดูใบไม้ผลิและใบไม้ร่วง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa26c0aa41fd74625b4777b9696544ae6P.jpg_200x200q90.jpg",
        "price": 2848.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5894955517.html",
        "sold": 0
    },
    {
        "product_name": "TOSUOD | เสื้อปั่นจักรยานสำหรับผู้หญิง น้ำหนักเบา ระบายอากาศได้ดี สำหรับฤดูใบไม้ผลิและใบไม้ร่วง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf0083d0c075c4c338ddae7bdf35a1529R.jpg_200x200q90.jpg",
        "price": 2848.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5893804953.html",
        "sold": 0
    },
    {
        "product_name": "seven7 | เสื้อยืดแขนสั้นแฟชั่นฤดูร้อน ผ้าฝ้ายหนัก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S359de703b64d449faa23889f403daf666.png_200x200q90.png",
        "price": 2843.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16053649824.html",
        "sold": 0
    },
    {
        "product_name": "TOSUOD | เสื้อปั่นจักรยานระบายเหงื่อได้ดีสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa4bafca2e14c486ab3831c0871870a1d6.jpg_200x200q90.jpg",
        "price": 2828.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5893423250.html",
        "sold": 1
    },
    {
        "product_name": "Kocotree | เสื้อผ้าสกีสำหรับเด็ก แห้งไว ป้องกันความหนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9e96a348bf224644ba2f0d5dc996afa2k.jpg_200x200q90.jpg",
        "price": 2823.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5979590852.html",
        "sold": 11
    },
    {
        "product_name": "TOSUOD | เสื้อปั่นจักรยานแขนยาวสำหรับผู้หญิงในฤดูร้อน ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S03974a39e7c74677ab6e9b8e05e6d925k.jpg_200x200q90.jpg",
        "price": 2818.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5895049953.html",
        "sold": 2
    },
    {
        "product_name": "AMII | เสื้อเชิ้ตเอวไม่เท่ากันสไตล์ฝรั่งเศสสำหรับฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3fd7f0864ab94f7982f7b998fadf2264O.png_200x200q90.png",
        "price": 2818.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5993841960.html",
        "sold": 0
    },
    {
        "product_name": "TOSUOD | เสื้อปั่นจักรยานแขนยาวสำหรับผู้หญิง แห้งเร็ว ระบายอากาศได้ดี เหมาะสำหรับฤดูใบไม้ผลิ/ฤดูร้อน ป้องกันแสงแดด ชุดปั่นจักรยานถนนและภูเขา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S41676c947c174c86bfef8f1b1e67afafi.jpg_200x200q90.jpg",
        "price": 2815.66,
        "remark": "https://www.lazada.co.th/products/pdp-i5895032045.html",
        "sold": 0
    },
    {
        "product_name": "WOSAWE | WOSAWE ผู้หญิงฤดูร้อนชุดขี่จักรยาน Jersey Breathable หญิงสั้น Jersey จักรยานเสื้อผ้าชุด Mtb Maillot นักปั่นจักรยานเสื้อผ้าจักรยาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scde9bb1696954d40ac2f1785d6624daeI.jpg_200x200q90.jpg",
        "price": 2803.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16104845749.html",
        "sold": 0
    },
    {
        "product_name": "ฮู้ดดี้สตรีทรงหลวมระบายอากาศได้ คอสีสันตามเทรนด์กีฬา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8eb7fd4e403848c38f1f7edc89e95f2dv.jpg_200x200q90.jpg",
        "price": 2802,
        "remark": "https://www.lazada.co.th/products/pdp-i16085656166.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อ FCSK 2.6 (เสื้อ FCSK 2.0 + เเผง UTA (แบบ3ช่อง))  (FCSK 2.6 P Carrier)  (FCSK 2.0 + UTA Front Flap)",
        "product_image": "https://img.lazcdn.com/g/p/89d33fb18a10c276ebb01b21281a5ec0.jpg_200x200q90.jpg",
        "price": 2800,
        "remark": "https://www.lazada.co.th/products/pdp-i5714952434.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อจักรยานผู้หญิง Funkier J-394",
        "product_image": "https://img.lazcdn.com/g/p/6c120fbbc9f1683833606d1a48ecfd59.jpg_200x200q90.jpg",
        "price": 2800,
        "remark": "https://www.lazada.co.th/products/pdp-i4135324385.html",
        "sold": 0
    },
    {
        "product_name": "[ผ่อน 0%]เสื้อจักรยานผู้หญิง Funkier J-394",
        "product_image": "https://img.lazcdn.com/g/p/66f1101f3efa843e4bf324d86bc7cece.jpg_200x200q90.jpg",
        "price": 2800,
        "remark": "https://www.lazada.co.th/products/pdp-i3910935399.html",
        "sold": 0
    },
    {
        "product_name": "MYRA Tide Halter Tank - เสื้อคล้องคอแขนกุดออกกำลังกาย มีฟองน้ำในตัว กระชับเข้ารูป ดีเทลเส้นโชว์หลัง",
        "product_image": "https://img.lazcdn.com/g/p/e18d481d785139ecf34d200c0f74f141.png_200x200q90.png",
        "price": 2800,
        "remark": "https://www.lazada.co.th/products/pdp-i5627937995.html",
        "sold": 3
    },
    {
        "product_name": "[ผ่อน 0%]เสื้อปั่นจักรยานผู้หญิง Funkier Stripe Collection",
        "product_image": "https://img.lazcdn.com/g/p/238f315c350e7b54ea0ff5a12b51715f.png_200x200q90.png",
        "price": 2800,
        "remark": "https://www.lazada.co.th/products/pdp-i3909731607.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปลอกเกราะ JPC Vest 1000D ใส่แม็กกาซีน 5.56 ได้ 3 ช่อง สามารถใส่เพลท 10 * 12 นิ้ว (หน้า/หลัง) สามารถปรับระยะช่วงไหล่และหน้าท้องได้  น้ำหนัก 1.1 kg",
        "product_image": "https://img.lazcdn.com/g/p/ed788e8e6edbd97eab56aea5068d5853.jpg_200x200q90.jpg",
        "price": 2800,
        "remark": "https://www.lazada.co.th/products/pdp-i5632107644.html",
        "sold": 0
    },
    {
        "product_name": "[Darkcat] Breeze Guard เสื้อแขนยาว กันแดด UPF50+ เบาสบาย ไม่ร้อน",
        "product_image": "https://img.lazcdn.com/g/p/0e2c01cca755a7805542806706c7ca08.png_200x200q90.png",
        "price": 2798,
        "remark": "https://www.lazada.co.th/products/pdp-i5596949020.html",
        "sold": 1
    },
    {
        "product_name": "[Darkcat] Breeze Guard เสื้อแขนยาว กันแดด UPF50+ เบา เย็นสบาย สีงาช้าง",
        "product_image": "https://img.lazcdn.com/g/p/3ae5b58b25a83557877f3ab0efa5794a.jpg_200x200q90.jpg",
        "price": 2798,
        "remark": "https://www.lazada.co.th/products/pdp-i5936931079.html",
        "sold": 0
    },
    {
        "product_name": "[XEXYMIX] Mock-Neck Point Crop Bra-Top",
        "product_image": "https://img.lazcdn.com/g/p/810d4622ec016b4d81b36cc2f85c4945.jpg_200x200q90.jpg",
        "price": 2792.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5892869853.html",
        "sold": 11
    },
    {
        "product_name": "เสื้อกั๊กนักปั่นจักรยานซิปคู่ระบายอากาศได้ดีและดูดซับความชื้นเสื้อกล้ามกีฬาแขนกุดเสื้อกันลมมีความยืดหยุ่นสำหรับการตั้งแคมป์กีฬาสันทนาการ",
        "product_image": "https://img.lazcdn.com/g/p/88df059dd3baec3ead109db37677b24a.jpg_200x200q90.jpg",
        "price": 2792,
        "remark": "https://www.lazada.co.th/products/pdp-i5731391132.html",
        "sold": 0
    },
    {
        "product_name": "INBIKE | เสื้อปั่นจักรยานแขนยาวสำหรับผู้หญิง สำหรับอุณหภูมิ 5-15°C",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0b5fe6e05acb4fa29412657b28b31ae5O.jpg_200x200q90.jpg",
        "price": 2789.54,
        "remark": "https://www.lazada.co.th/products/pdp-i5879780947.html",
        "sold": 2
    },
    {
        "product_name": "ชุดเสื้อสเวตเตอร์และกางเกงสไตล์จีนสุดหรูสำหรับฤดูใบไม้ร่วงและฤดูหนาว  แบบติดกระดุม  สำหรับผู้หญิง  ดีไซน์ศิลปะย้อนยุค  สีพื้น  ถักนิตติ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S203ed57f0839425a9dd8874f8f3d3f9cU.jpg_200x200q90.jpg",
        "price": 2788.38,
        "remark": "https://www.lazada.co.th/products/pdp-i6068537117.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | ชุดกอล์ฟเด็กแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6a6febd5d85646f19e8ea50334aca016e.jpg_200x200q90.jpg",
        "price": 2786.52,
        "remark": "https://www.lazada.co.th/products/pdp-i6072904448.html",
        "sold": 0
    },
    {
        "product_name": "【TVI】ROCKBROS ร็อคบรอสเสื้อเจอร์ซีย์นักปั่นผู้หญิง,เสื้อขี่จักรยานยืดหยุ่นดูดความชื้นระบายอากาศได้ดีเสื้อสำหรับปั่นจักรยานผู้หญิงมีกระเป๋า",
        "product_image": "https://img.lazcdn.com/g/p/474ba253041422e6c5fd2ababa4502c7.jpg_200x200q90.jpg",
        "price": 2786,
        "remark": "https://www.lazada.co.th/products/pdp-i5119024400.html",
        "sold": 7
    },
    {
        "product_name": "Lace flower set ชุดเซทเสื้อ สายเดี่ยวลูกไม้สีครีม & กระโปรงมีกางเกงซับข้างในในตัว เสื้อสายเดี่ยวลูกไม้ผ้าดีมากค่ะมีบราให้ในตัวใส่แล้วดูน่ารักลูกคุณหนูสุดสุด พร้อมกับกระโปรงสีครีม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sce633457bbf241fbb6f2b0219c097615x.jpg_200x200q90.jpg",
        "price": 2780,
        "remark": "https://www.lazada.co.th/products/pdp-i5786691362.html",
        "sold": 8
    },
    {
        "product_name": "allday tank top",
        "product_image": "https://img.lazcdn.com/g/p/37ffb575d11b6bb34fe9e58934638a8c.jpg_200x200q90.jpg",
        "price": 2780,
        "remark": "https://www.lazada.co.th/products/pdp-i5681284343.html",
        "sold": 0
    },
    {
        "product_name": "Zumba X Peanuts High Neck Mid Crop Tank  (เสื้อครอปออกกำลังกายซุมบ้า)",
        "product_image": "https://img.lazcdn.com/g/p/74ed4c910b82ca7a4e60f26fd8e719dd.jpg_200x200q90.jpg",
        "price": 2780,
        "remark": "https://www.lazada.co.th/products/pdp-i16093049198.html",
        "sold": 0
    },
    {
        "product_name": "FreshMartin -เสื้อสปอร์ตบรา- คอโปโล/มีปก/มีแขน - ฟองน้ำถอดได้-สีเขียว -Polo Crop Top in Sage",
        "product_image": "https://img.lazcdn.com/g/p/2bfe57f258204f354c90f996e27b8b67.png_200x200q90.png",
        "price": 2780,
        "remark": "https://www.lazada.co.th/products/pdp-i4727848067.html",
        "sold": 0
    },
    {
        "product_name": "INBIKE | เสื้อปั่นจักรยานสตรีระบายอากาศแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2e510bc0362944a08949dff343506f39b.jpg_200x200q90.jpg",
        "price": 2776.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5914318107.html",
        "sold": 4
    },
    {
        "product_name": "เสื้อยืดเทนนิสสำหรับชายและหญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S13ef13461cf1450bb6a81747812ed0457.jpg_200x200q90.jpg",
        "price": 2769.48,
        "remark": "https://www.lazada.co.th/products/pdp-i6075147406.html",
        "sold": 0
    },
    {
        "product_name": "≮115≯เสื้อยืดแขนสั้นคอวีผ้าฝ้ายหมายเลข 8 ของคิง ลาเวน เสื้อบาสเก็ตบอลกีฬาแขนสั้นชุดฝึกซ้อมเทรนด์เยาวชน",
        "product_image": "https://img.lazcdn.com/g/p/917d572c645c09ebd7f61cc9b03bd771.jpg_200x200q90.jpg",
        "price": 2768.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6041509646.html",
        "sold": 0
    },
    {
        "product_name": "【TI hot】 Winter Sports Suit for Children Quick Drying Thermal Underwear Boys Compression Sportswear  Basketball Football Tight Clothing",
        "product_image": "https://img.lazcdn.com/g/p/8864430470c32f34a18dcea31a11d869.png_200x200q90.png",
        "price": 2760.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6078189816.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเซ็ตสองชิ้นสไตล์เกาหลีสุดแฟชั่นสำหรับผู้หญิง เสื้อกั๊กทรงเข้ารูป กางเกงขายาวทรงกว้าง ดีไซน์ช่วยลดอายุ ผลิตจากเส้นใยโพลีเอสเตอร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0f4738f844794df5b04b92f2a0e59cd80.jpg_200x200q90.jpg",
        "price": 2757.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16097275429.html",
        "sold": 0
    },
    {
        "product_name": "{SDGDFGR} alo yoga ชุดชั้นในโยคะไหล่เดียวแบบเฉียงชุดชั้นในกีฬาสายรัดผิดปกติวิ่งเสื้อกั๊กออกกำลังกาย",
        "product_image": "https://img.lazcdn.com/g/p/a22449388d5333d3af65a8b6df7d70f0.jpg_200x200q90.jpg",
        "price": 2757.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6014256434.html",
        "sold": 0
    },
    {
        "product_name": "Guuka | เสื้อยืดแฟชั่นฤดูร้อน พร้อมปักหนัง PU",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2d6b9229f8274bada1b2c87e20d67542o.png_200x200q90.png",
        "price": 2756.44,
        "remark": "https://www.lazada.co.th/products/pdp-i16104024996.html",
        "sold": 0
    },
    {
        "product_name": "GUUKA HERO | เสื้อคลุมกันแดดแบบแยกเป็นสองชิ้น กางเกงปั่นจักรยานแบบถอดได้ ระบายอากาศได้ดี ผ้าไนลอน แขนยาว ปกโปโล สำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S35abcfd3535c4300825e38f9cd754818O.png_200x200q90.png",
        "price": 2748.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5857318056.html",
        "sold": 4
    },
    {
        "product_name": "เสื้อผู้หญิงไซส์ใหญ่ใส่สบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8d4cce304387416887022765be581194P.jpg_200x200q90.jpg",
        "price": 2748.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16120742349.html",
        "sold": 0
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดกีฬาเด็กชายยืดหยุ่นสูงแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd7fa3c1cc9a249618168815065d87b8bU.png_200x200q90.png",
        "price": 2744.48,
        "remark": "https://www.lazada.co.th/products/pdp-i6049004615.html",
        "sold": 5
    },
    {
        "product_name": "izzue | เสื้อคลุมเย็นสำหรับทุกเพศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sffb485a05cb247bca10ccd68a88fd38cu.jpg_200x200q90.jpg",
        "price": 2741.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16083479678.html",
        "sold": 0
    },
    {
        "product_name": "Children's Swimsuit UPF50 UV Protection Baby Toddler Boys Swimwear Rash Guard Summer Long Sleeve Swimming Bathing Suit for Boy",
        "product_image": "https://img.lazcdn.com/g/p/79706e9e56a56f37005fdc9d595099ee.jpg_webp_200x200q90.jpg",
        "price": 2733.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16128450540.html",
        "sold": 0
    },
    {
        "product_name": "OU ZHI YAN FASHION | เสื้อแขนสั้นสีดำหรูหราและสดใส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S974436b7d4844ca28d66a8632269c0e2y.jpg_200x200q90.jpg",
        "price": 2733.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16057891201.html",
        "sold": 0
    },
    {
        "product_name": "HAIGEMAN | เสื้อแขนสั้นสีพื้นสไตล์ยุโรปหรูหราและมีสไตล์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5e109eba510446d5b8ef6a274d458c54q.jpg_200x200q90.jpg",
        "price": 2729.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5999776409.html",
        "sold": 3
    },
    {
        "product_name": "Jeep | เสื้อยืดสไตล์เรโทรกีฬาแบบลำลองอเมริกัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1e6b6e401d144564bc732b92313ddbabU.jpg_200x200q90.jpg",
        "price": 2719.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16094066613.html",
        "sold": 0
    },
    {
        "product_name": "West Biking | เสื้อปั่นจักรยานสำหรับผู้หญิงที่ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1f9e9cf786a84154a40808bde3a8749b2.png_200x200q90.png",
        "price": 2715.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5952493757.html",
        "sold": 5
    },
    {
        "product_name": "HAIGEMAN | แจ็คเก็ตสไตล์จีนแบบอ่อนโยน สไตล์วินเทจ ฤดูใบไม้ร่วง ทรงเข้ารูป",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S50623f2aa2654275855c20219452de9ca.jpg_200x200q90.jpg",
        "price": 2713.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5999815174.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อโค้ทและกางเกงขาสั้นสไตล์ฝรั่งเศสที่หรูหรา ดีไซน์เอวกระชับสัดส่วน แฟชั่นฤดูใบไม้ร่วงฤดูหนาว ชุดลำลอง ผ้าโพลีเอสเตอร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd7ff38677cf34fa7977ba9c5293622d7F.jpg_200x200q90.jpg",
        "price": 2708.92,
        "remark": "https://www.lazada.co.th/products/pdp-i6069747173.html",
        "sold": 0
    },
    {
        "product_name": "SPEEDO Printed Long Sleeve เสื้อรัชการ์ดเด็กผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/p/ad04590be8b2e93f8fdbceba0d1d6931.jpg_200x200q90.jpg",
        "price": 2704,
        "remark": "https://www.lazada.co.th/products/pdp-i16090064191.html",
        "sold": 0
    },
    {
        "product_name": "West Biking | แจ็คเก็ตขี่จักรยานแขนยาวสำหรับผู้หญิงทรงเข้ารูปใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S70b0a619589c4464bd3afc98eb808b8dn.png_200x200q90.png",
        "price": 2702.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5953029754.html",
        "sold": 6
    },
    {
        "product_name": "แฟชั่นสไตล์เกาหลีช่วงต้นฤดูใบไม้ร่วง เสื้อสเวตเชิ้ตแบบสบายๆ ตัดต่อผ้ากันหนาว กางเกงขายาว ชุดเซ็ตสองชิ้นสำหรับผู้หญิง ช่วยให้ดูผอมเพรียว ลดอายุ ดูอ่อนเยาว์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0daa56af25f14030be70f17e373fc05cN.jpg_200x200q90.jpg",
        "price": 2700.4,
        "remark": "https://www.lazada.co.th/products/pdp-i16107419246.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเกราะ Police เสื้อเกราะจิ๋ว ยี่ห้อ Kenya เสื้อเกราะอ่อน เสื้อเกราะก้ามปู",
        "product_image": "https://img.lazcdn.com/g/p/f3ba6502fc63be004c46045586ca2da7.jpg_200x200q90.jpg",
        "price": 2700,
        "remark": "https://www.lazada.co.th/products/pdp-i3261610481.html",
        "sold": 0
    },
    {
        "product_name": "Suavecito - OG BLACK & GOLD TEE",
        "product_image": "https://img.lazcdn.com/g/p/e89e9a8663551b71b0b1cb598bad876c.jpg_200x200q90.jpg",
        "price": 2700,
        "remark": "https://www.lazada.co.th/products/pdp-i5908060706.html",
        "sold": 0
    },
    {
        "product_name": "YKYWBIKE ชุดเสื้อเจอร์ซีย์นักปั่นผู้หญิง6ชั่วโมง3กระเป๋าเสื้อเชิ้ตใส่สบายกีฬาจักรยานเสือภูเขากลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/ec9de2cc0103c907c390dbd6bc0fa4a1.jpg_200x200q90.jpg",
        "price": 2698,
        "remark": "https://www.lazada.co.th/products/pdp-i5692511031.html",
        "sold": 3
    },
    {
        "product_name": "GUESS เสื้อยืด ผู้หญิง รุ่น QBYI0CK9TJ1  สีแดง",
        "product_image": "https://img.lazcdn.com/g/p/db78ae5e575d5f004f27c6f2d60ef600.jpg_200x200q90.jpg",
        "price": 2692,
        "remark": "https://www.lazada.co.th/products/pdp-i16118770338.html",
        "sold": 0
    },
    {
        "product_name": "GUESS เสื้อยืด ผู้หญิง รุ่น Q6GIB5K4730  สีน้ำเงิน",
        "product_image": "https://img.lazcdn.com/g/p/27de5e30ec8dbc18c5e73921bf8d3075.jpg_200x200q90.jpg",
        "price": 2692,
        "remark": "https://www.lazada.co.th/products/pdp-i16118365937.html",
        "sold": 0
    },
    {
        "product_name": "GUESS เสื้อยืด ผู้หญิง รุ่น Q6GIA5K4698  สีขาว",
        "product_image": "https://img.lazcdn.com/g/p/468902f901fd05b01f4e1fbdebce68a1.jpg_200x200q90.jpg",
        "price": 2692,
        "remark": "https://www.lazada.co.th/products/pdp-i16118489296.html",
        "sold": 0
    },
    {
        "product_name": "GUESS เสื้อยืด ผู้หญิง รุ่น Q6GIB0K4714  สีขาว",
        "product_image": "https://img.lazcdn.com/g/p/5c2ba63c75beb9143e6d13a58a00d332.jpg_200x200q90.jpg",
        "price": 2692,
        "remark": "https://www.lazada.co.th/products/pdp-i16118343992.html",
        "sold": 0
    },
    {
        "product_name": "GUESS เสื้อยืด ผู้หญิง รุ่น Q6GIA3K4693  สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/7e4a40fdf150618e3c82ea4d692c3d56.jpg_200x200q90.jpg",
        "price": 2692,
        "remark": "https://www.lazada.co.th/products/pdp-i16118453508.html",
        "sold": 0
    },
    {
        "product_name": "GUESS เสื้อยืด ผู้หญิง รุ่น Q6GIA5K4698  สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/a2f7e296c24ab2b972fa6e6cb3adfc3d.jpg_200x200q90.jpg",
        "price": 2692,
        "remark": "https://www.lazada.co.th/products/pdp-i16118804186.html",
        "sold": 0
    },
    {
        "product_name": "GUESS เสื้อยืด ผู้หญิง รุ่น Q6GIB0K4714  สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/588250d56ce45d3b9313161dbc06da38.jpg_200x200q90.jpg",
        "price": 2692,
        "remark": "https://www.lazada.co.th/products/pdp-i16118716604.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น QBYI95K9TJ1  สีขาว",
        "product_image": "https://img.lazcdn.com/g/p/bc7cda38c5a92647488fdae92780184b.jpg_200x200q90.jpg",
        "price": 2692,
        "remark": "https://www.lazada.co.th/products/pdp-i16066358165.html",
        "sold": 0
    },
    {
        "product_name": "GUESS เสื้อยืด ผู้หญิง รุ่น Q6GIA3K4693  สีขาว",
        "product_image": "https://img.lazcdn.com/g/p/2b2a2cfadd4aa91f46b7ee4508185474.jpg_200x200q90.jpg",
        "price": 2692,
        "remark": "https://www.lazada.co.th/products/pdp-i16118403663.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น QBYI0CK9TJ1  สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/51c0280345dde3e5934d22c146a9dc61.jpg_200x200q90.jpg",
        "price": 2692,
        "remark": "https://www.lazada.co.th/products/pdp-i16066162983.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้าเต้นรำแบบมืออาชีพ NY สำหรับผู้ชาย แขนยาว 2 กระดุม สำหรับฝึกซ้อมเต้นรำแบบผสม วัสดุอื่นๆ ฤดูหนาว 2022",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S84444681b88a4e388de8071e90771ecda.jpg_200x200q90.jpg",
        "price": 2686,
        "remark": "https://www.lazada.co.th/products/pdp-i16091751230.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้าสตรีสุดหรูสไตล์ฤดูใบไม้ร่วงและฤดูใบไม้ผลิ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb65012941770402fa3a6cc2b473cd8baH.jpg_200x200q90.jpg",
        "price": 2680.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5996882792.html",
        "sold": 5
    },
    {
        "product_name": "เสื้อขี่จักรยานแบบใหม่เสื้อกีฬากลางแจ้งสำหรับผู้หญิงเสื้อเสื้อแจ็คเก็ตกันหนาวจักรยานเสือหมอบแขนยาวผ้าฟลีซสำหรับฤดูหนาวและฤดูหนาว",
        "product_image": "https://img.lazcdn.com/g/p/48ed46bb7164ed6fa1127bc75402ade4.jpg_200x200q90.jpg",
        "price": 2680,
        "remark": "https://www.lazada.co.th/products/pdp-i5961212630.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแขนสั้นพิมพ์ลายสัตว์หวานฝัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S235425083612444ba2784c50f46ba871n.png_200x200q90.png",
        "price": 2679.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16057697365.html",
        "sold": 0
    },
    {
        "product_name": "203 เสื้อกีฬาโยคะผู้หญิง ชุดฟิตเนส ชุดออกกำลังกาย เสื้อเต้นรำ ระบายอากาศ เสื้อกล้ามออกกำลังกาย แห้งเร็ว",
        "product_image": "https://img.lazcdn.com/g/p/8df4a2924b96cfdf300f8cd24872944d.jpg_200x200q90.jpg",
        "price": 2676.16,
        "remark": "https://www.lazada.co.th/products/pdp-i6070288366.html",
        "sold": 0
    },
    {
        "product_name": "Bondi 8 💕แกรงานจริงสวยตรงปกมากก  ครบกล่อง 🔥ราคานี้ของถึงมือจ่ายรอบเดียว งานสวยตรงปก ราคาดีขนาดนี้ ห้ามพลาด✨#รุ่นตัวนี้กำลังมาเลยค่ะ",
        "product_image": "https://img.lazcdn.com/g/p/2fb797665a30059d79d0f6f3975d402b.jpg_200x200q90.jpg",
        "price": 2656,
        "remark": "https://www.lazada.co.th/products/pdp-i4377355896.html",
        "sold": 0
    },
    {
        "product_name": "YKYWBIKE เสื้อกล้ามผู้หญิง,เสื้อชั้นในใส่ปั่นจักรยานระบายอากาศได้ดีแห้งเร็วแขนยาวพื้นฐานนักปั่น",
        "product_image": "https://img.lazcdn.com/g/p/e07b341127da1bd1d956465f608634f4.jpg_200x200q90.jpg",
        "price": 2676,
        "remark": "https://www.lazada.co.th/products/pdp-i5715318464.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อสเวตเตอร์สไตล์เกาหลีลำลองสำหรับผู้หญิง แฟชั่นฤดูใบไม้ร่วงฤดูหนาว ลดอายุด้วยเสื้อฮู้ดพิมพ์ลายตัวอักษร กางเกงขายาวทรงหลวม สวมใส่สบายๆ แบบสปอร์ต ชุดสองชิ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S07066f761f6c4cfeb152f7bad553e06bF.jpg_200x200q90.jpg",
        "price": 2674.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16107334434.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเสื้อเจอร์ซีย์นักปั่นผู้หญิงผ้ายืดหยุ่นสูง,เสื้อกีฬาขี่จักรยานฤดูใบไม้ผลิ/ฤดูร้อนแขนยาวระบายอากาศได้ดีป้องกันแสงแดด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S06b4ed76bfc24db8bff3d15d15e77c17t.jpg_200x200q90.jpg",
        "price": 2670,
        "remark": "https://www.lazada.co.th/products/pdp-i6033687516.html",
        "sold": 0
    },
    {
        "product_name": "【TI hot】 Kids Compression Soccer Long T Shirt for Boys Running Cycling Jersey Training Workout T-shirt Basketball Exercise Sports Costume",
        "product_image": "https://img.lazcdn.com/g/p/a4895f442362029ded1b2bd9d97d9400.png_200x200q90.png",
        "price": 2668.46,
        "remark": "https://www.lazada.co.th/products/pdp-i6076078607.html",
        "sold": 0
    },
    {
        "product_name": "ALO เสื้อสเวตเตอร์กีฬาผู้หญิง คอกลม ทรงสั้น ระบายอากาศได้ดี เหมาะสำหรับออกกำลังกาย T เสื้อแขนยาวทรงหลวมไหล่ตก เสื้อโยคะ",
        "product_image": "https://img.lazcdn.com/g/p/337fa377cc574daaa45c2eb21c53cdc2.jpg_webp_200x200q90.jpg",
        "price": 2662.24,
        "remark": "https://www.lazada.co.th/products/pdp-i6076046433.html",
        "sold": 0
    },
    {
        "product_name": "Printed Bra, Nude Quick-drying Sports Bra, Outer Wear, Running, Pilates, Yoga Vest Bra Sy",
        "product_image": "https://img.lazcdn.com/g/p/9de3d686b45b38d9564d65436ddc871a.jpg_200x200q90.jpg",
        "price": 2651.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16069075563.html",
        "sold": 0
    },
    {
        "product_name": "Gymshark Oblique One-shoulder Beautiful Back Yoga Bra Nude Sports Bra Shoulder Straps Running Fitness Vest Top Sy",
        "product_image": "https://img.lazcdn.com/g/p/d1b74f8646ef31d355f0e073fbb4f005.jpg_200x200q90.jpg",
        "price": 2651.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16069132802.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดวิ่งสำหรับเด็กชายแห้งไว ระบายอากาศเย็นสบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sffb9740f4d1744d4b0cab5a90bcdcaee7.png_200x200q90.png",
        "price": 2648,
        "remark": "https://www.lazada.co.th/products/pdp-i16085566239.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดคอกลมสำหรับเด็ก ระบายอากาศและซับเหงื่อได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6bd72cb30968413bb7419c2afb26db42h.jpg_200x200q90.jpg",
        "price": 2646,
        "remark": "https://www.lazada.co.th/products/pdp-i16085510475.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดเด็กที่ระบายอากาศได้ ซับเหงื่อ และทนทาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6bd72cb30968413bb7419c2afb26db42h.jpg_200x200q90.jpg",
        "price": 2646,
        "remark": "https://www.lazada.co.th/products/pdp-i16085510551.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดเด็กที่ระบายอากาศได้และทนทาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0c863db6ce9d439593c935c108721f4e3.jpg_200x200q90.jpg",
        "price": 2646,
        "remark": "https://www.lazada.co.th/products/pdp-i16085563180.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อแขนสั้นระบายอากาศและทนทานต่อการสึกหรอ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0c863db6ce9d439593c935c108721f4e3.jpg_200x200q90.jpg",
        "price": 2646,
        "remark": "https://www.lazada.co.th/products/pdp-i16085369902.html",
        "sold": 0
    },
    {
        "product_name": "when.we.stretch - Everyday Rib Tank  มีบราในตัว กระดุมถอดได้จริงทุกเม็ด (-เฉพาะเสื้อ-) สินค้าพร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/p/8ac4c815346ecf51d7fa55d364bb7124.png_200x200q90.png",
        "price": 2642.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5928427932.html",
        "sold": 5
    },
    {
        "product_name": "【User-friendly】 Chinese Wudang Taoist Kung Fu Clothes Men Tai Chi Shaolin Buddhist Monk Robes Martial Arts Kungfu Clothing Spants",
        "product_image": "https://img.lazcdn.com/g/p/d3985294dc13cd5539b0f8b16a4ef0b7.jpg_200x200q90.jpg",
        "price": 2640,
        "remark": "https://www.lazada.co.th/products/pdp-i5075143761.html",
        "sold": 0
    },
    {
        "product_name": "ชุดย้อนยุคแบบแขนสั้นแฟชันใส่เสื้อยืดพิมพ์ลายตัวหนังสือแนวสตรีทสปอร์ตสินค้าใหม่2026ฤดูใบไม้ผลิ/ฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/0a1a0013f62f14a663e5d6e2a5b519ac.jpg_200x200q90.jpg",
        "price": 2638,
        "remark": "https://www.lazada.co.th/products/pdp-i6053272504.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดผู้หญิงมีจีบหลวมๆ",
        "product_image": "https://img.lazcdn.com/g/p/a35d72b882aad1f5c28c23db8dda7877.jpg_200x200q90.jpg",
        "price": 2626,
        "remark": "https://www.lazada.co.th/products/pdp-i6016790483.html",
        "sold": 0
    },
    {
        "product_name": "Flipbelt | เสื้อกล้ามวิ่งแห้งเร็วสำหรับฝึกซ้อม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S493eb84dcca344d580067f80b455053bM.jpg_200x200q90.jpg",
        "price": 2624.76,
        "remark": "https://www.lazada.co.th/products/pdp-i5933146261.html",
        "sold": 34
    },
    {
        "product_name": "West Biking | เสื้อปั่นจักรยานสตรีสำหรับฤดูร้อน บางเบาและระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sde6839b1e173418e8d7a9e8d2116083d3.png_200x200q90.png",
        "price": 2618.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5995640210.html",
        "sold": 8
    },
    {
        "product_name": "✨NEW✨ KEED : Gee-Gee ชุดว่ายน้ำควบคุมอุณหภูมิ (TempFlex) บอดี้สูท แขนยาว-ขายาว *118PG*",
        "product_image": "https://img.lazcdn.com/g/p/d19173027504b817ad6855652ab150a7.jpg_200x200q90.jpg",
        "price": 2617.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5515614170.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อยืดคอกลมแบบโปโล แขนสั้น พิมพ์ลายเพชร สปอร์ต ตาข่ายระบายอากาศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2deb86976604452cb036a296585071357.jpg_200x200q90.jpg",
        "price": 2612,
        "remark": "https://www.lazada.co.th/products/pdp-i16112043586.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อโค้ทสูงแวววาวเสื้อโต้คลื่นไม้รัดรูป Colaxi น้ำหนักเบาอุปกรณ์กระดานโต้คลื่นแผ่นขัดกระดาษทรายสำหรับผู้เริ่มต้น",
        "product_image": "https://img.lazcdn.com/g/p/05ba97da82f0043bc7e937ac83fea06c.jpg_200x200q90.jpg",
        "price": 2612,
        "remark": "https://www.lazada.co.th/products/pdp-i16129475480.html",
        "sold": 0
    },
    {
        "product_name": "Miyake เสื้อเสื้อยืดแบบหลวมแขนสั้นจับจีบไซส์ใหญ่,เสื้อแฟชั่นสุดสวยสำหรับฤดูร้อน8073",
        "product_image": "https://img.lazcdn.com/g/p/0deca4a4e90dd7ee356279d7f7c02e07.jpg_200x200q90.jpg",
        "price": 2605.38,
        "remark": "https://www.lazada.co.th/products/pdp-i4076297997.html",
        "sold": 20
    },
    {
        "product_name": "BARREL KIDS เสื้อรัชการ์ด ชุดว่ายน้ำแขนยาว ชุดว่ายน้ำเด็ก ESSENTIAL ZIP-UP RASHGUARD WHITE/BLACK-3WT001K_U4WTBK",
        "product_image": "https://img.lazcdn.com/g/p/455f0290da60b04d82c4c364ece49235.jpg_200x200q90.jpg",
        "price": 2600.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5710920988.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อ FCSK 3.0 (FCSK 3.0 P Carrier)",
        "product_image": "https://img.lazcdn.com/g/p/5c849ea68e23e3aced9b19957141280d.jpg_200x200q90.jpg",
        "price": 2600,
        "remark": "https://www.lazada.co.th/products/pdp-i5723163933.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อ FCSK 3.0 (FCSK 3.0 PLate Carrier)",
        "product_image": "https://img.lazcdn.com/g/p/8b1d05fc038d4c1d8ce8cdfd5134aa5b.jpg_200x200q90.jpg",
        "price": 2600,
        "remark": "https://www.lazada.co.th/products/pdp-i5723377081.html",
        "sold": 7
    },
    {
        "product_name": "{dkjge} 【p159p】 Muay Thai Fight Shorts Unisex Kick Boxing Pants Women Men Kids MMA Training Shorts Competition Game Sanda Grappling Clothes",
        "product_image": "https://img.lazcdn.com/g/p/ce6f456ab957cfd842c3ea2fedf2b2e5.png_200x200q90.png",
        "price": 2598,
        "remark": "https://www.lazada.co.th/products/pdp-i16146041214.html",
        "sold": 0
    },
    {
        "product_name": "XIAODADEHUA | เสื้อแขนยาวผู้หญิงแบบดีไซน์เนอร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S379884d5e9274fe6ab44e24fd86ebb98O.jpg_200x200q90.jpg",
        "price": 2596.44,
        "remark": "https://www.lazada.co.th/products/pdp-i6029708223.html",
        "sold": 0
    },
    {
        "product_name": "HOACON | เสื้อยืดแขนยาวสำหรับผู้หญิง ใส่ในฤดูหนาว พร้อมผ้าห่มนุ่มที่ไหล่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdcd25618e36a4b2a8ee4652c3b981aca6.jpg_200x200q90.jpg",
        "price": 2593.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6062590450.html",
        "sold": 2
    },
    {
        "product_name": "TOSUOD | เสื้อปั่นจักรยานแห้งไวสำหรับสตรีฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0602646a28ba403cbc7ac46290ce02b05.jpg_200x200q90.jpg",
        "price": 2592.52,
        "remark": "https://www.lazada.co.th/products/pdp-i5894948071.html",
        "sold": 0
    },
    {
        "product_name": "(พร้อมส่ง) Main Character Club | Ivy Long Sleeve - เฉพาะเสื้อ",
        "product_image": "https://img.lazcdn.com/g/p/ea32b8cd6bc9e5ef992a5cf95a4f776c.jpg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i16079008397.html",
        "sold": 0
    },
    {
        "product_name": "The Sparkle Top",
        "product_image": "https://img.lazcdn.com/g/p/1a7304694f226c760dcec3c81d668472.jpg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i6070693533.html",
        "sold": 0
    },
    {
        "product_name": "BKKFit Everyday Pilates Top เสื้อทอปแขนยาว บราในตัว",
        "product_image": "https://img.lazcdn.com/g/p/e94ecd02f43c519bdd113c6d6e58b1d0.jpg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i5355473920.html",
        "sold": 17
    },
    {
        "product_name": "UNBOUND VERDELIGHT SPORTS BRA สปอร์ตบราครึ่งตัว (เฉพาะเสื้อ) มี2สี",
        "product_image": "https://img.lazcdn.com/g/p/6f1235cd361ad01d44028a52c7f38344.jpg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i16048503479.html",
        "sold": 0
    },
    {
        "product_name": "VANESSE : VNS CHICS ROMPER CODE : 029111",
        "product_image": "https://img.lazcdn.com/g/p/3650d42dbd215584e1577b4a62bbe25f.jpg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i6071382276.html",
        "sold": 0
    },
    {
        "product_name": "Decathlon | เสื้อชูชีพสำหรับว่ายน้ำ พายเรือ ดำน้ำตื้น และลอยตัว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S15a2db1fff2442838e2e761429e03527U.jpg_200x200q90.jpg",
        "price": 2572,
        "remark": "https://www.lazada.co.th/products/pdp-i16085737948.html",
        "sold": 0
    },
    {
        "product_name": "ชุดจักรยานผู้หญิงแขนยาวขายาว CheJi 14 (09) สีขาวดำชมพู",
        "product_image": "https://img.lazcdn.com/g/p/f189115fc5c3c4b259a571da7a015603.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i523542517.html",
        "sold": 0
    },
    {
        "product_name": "สินค้าแฟชั่น เสื้อ แฟชั่น Cintage CT1881 Athletic girls collection981",
        "product_image": "https://img.lazcdn.com/g/p/9c85df3e0e49285abf5567728033807b.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i4617429062.html",
        "sold": 0
    },
    {
        "product_name": "ชุดจักรยานผู้หญิงแขนยาวขายาว CheJi 16 (10) สีดำลายเทาชมพู",
        "product_image": "https://img.lazcdn.com/g/p/96b567824344bdb62dc83e815f7d8662.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i508772438.html",
        "sold": 0
    },
    {
        "product_name": "ชุดจักรยานผู้หญิงแขนยาวขายาว CheJi 15 (06) สีชมพูลายเหลือง",
        "product_image": "https://img.lazcdn.com/g/p/3259216aeb9ce063905fe42069048ff0.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i523570422.html",
        "sold": 0
    },
    {
        "product_name": "ฝาครอบดุมล้อหน้า คูโบต้า L3408 L3608 L4508 Kubota เสื้อดุมล้อ เสื้อเพลาล้อ ฝาครอบเฟืองล้อ ฝาครอบจานเฟืองล้อ ฝาปิดดุมล้อ",
        "product_image": "https://img.lazcdn.com/g/p/b6fcb1c344e2cc6e08c83f5a249986e4.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i4091274195.html",
        "sold": 0
    },
    {
        "product_name": "ชุดจักรยานผู้หญิงแขนยาวขายาว CheJi 15 (02) สีขาวลายดำชมพู",
        "product_image": "https://img.lazcdn.com/g/p/df0a2cb63c2ca28d50963f880ba9b8fa.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i508774463.html",
        "sold": 0
    },
    {
        "product_name": "ชุดจักรยานผู้หญิงแขนยาวขายาว CheJi 16 (05) สีดำเขียวชมพู ลายกระโหลก Recing is life",
        "product_image": "https://img.lazcdn.com/g/p/7d53d08ae76f51e8a00303eb0637ccf4.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i508780353.html",
        "sold": 0
    },
    {
        "product_name": "ชุดจักรยานผู้หญิงแขนยาวขายาว CheJi 15 (05) สีชมพูดำฟ้าลายผีเสื้อ",
        "product_image": "https://img.lazcdn.com/g/p/0bb4e2ce1b76f657f386756f6baf66f4.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i523578775.html",
        "sold": 0
    },
    {
        "product_name": "ชุดจักรยานผู้หญิงแขนยาวขายาว CheJi 16 (01) สีน้าเงิน ลายดอกไม้ Recing is life",
        "product_image": "https://img.lazcdn.com/g/p/5d359fae95f9dc91add0c152a7777060.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i523600717.html",
        "sold": 0
    },
    {
        "product_name": "ชุดจักรยานผู้หญิงแขนยาวขายาว CheJi 15 (09) สีม่วงลาย Rose Kiss",
        "product_image": "https://img.lazcdn.com/g/p/cb240c852ee5b806f17d8e6f995142d5.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i523618003.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อแจ็คเก็ตกีฬากลางแจ้งอเนกประสงค์สำหรับผู้หญิงแห้งเร็วเสื้อเจอร์ซีย์นักปั่นเสื้อกันลมเดินป่าตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2777a8b3d2714c8689f6005ca74d2bafV.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i16114170949.html",
        "sold": 0
    },
    {
        "product_name": "ชุดจักรยานผู้หญิงแขนยาวขายาว CheJi 17 (01) สีดำชมพูลาย Devil Gear",
        "product_image": "https://img.lazcdn.com/g/p/2e3acb92c39cf71e8778aa38b0152acb.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i347748160.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อยืดกีฬาสีเทาสำหรับผู้หญิง ชุดลำลองสองชิ้นสำหรับฤดูร้อน สไตล์สบายๆ แฟชั่น ผลิตจากผ้าฝ้ายออร์แกนิก ผลิตในประเทศจีน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc8738793497749cba60d802bbdaf9dbfx.jpg_200x200q90.jpg",
        "price": 2554.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16097309327.html",
        "sold": 0
    },
    {
        "product_name": "ANTA เด็กชายการเดินเรือเด็กโตอายุ7-14ปีชุดว่ายน้ำวันพีช A825332412ขาตั้งกล้อง",
        "product_image": "https://img.lazcdn.com/g/p/34efd4a4c2bff78fcff660f425789281.jpg_200x200q90.jpg",
        "price": 2554.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5784330371.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS ระบายอากาศที่สะดวกสบายเสื้อเจอร์ซีย์นักปั่นผู้หญิงแขนยาวป้องกันรังสียูวีจักรยานเสือหมอบเสื้อผ้าผู้หญิงหลากสีหมวกขี่ MTB อุปกรณ์จักรยานเสื้อผ้า",
        "product_image": "https://img.lazcdn.com/g/p/3f3f1c223ad6b9a472f618b620639d25.jpg_200x200q90.jpg",
        "price": 2554,
        "remark": "https://www.lazada.co.th/products/pdp-i5269401791.html",
        "sold": 2
    },
    {
        "product_name": "【flowerlove shop】 Women Sauna Suit Sweat Shirt Slimming Vest Hot Top Jumpsuit Shapewear,Armpit and Crotch Mesh",
        "product_image": "https://img.lazcdn.com/g/p/a5276e61bd32d63e7efb17cb7554d727.png_200x200q90.png",
        "price": 2546.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16079090340.html",
        "sold": 0
    },
    {
        "product_name": "DANBAOLUO | เสื้อแขนยาวสำหรับฝึกเต้นของผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbad4e65b62554e07bc805ede1f588e76c.jpg_200x200q90.jpg",
        "price": 2543.48,
        "remark": "https://www.lazada.co.th/products/pdp-i6016663042.html",
        "sold": 0
    },
    {
        "product_name": "ชุดบอล พร้อมส่งชุดบอลหญิง เชียร์บอล ชุดพริตตี้ ️ส่งไวจาก กทม.",
        "product_image": "https://img.lazcdn.com/g/p/fdfaa70ec3522eca029951b9137302fc.jpg_200x200q90.jpg",
        "price": 2540,
        "remark": "https://www.lazada.co.th/products/pdp-i5782992552.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อซ้อมฟุตบอลแขนยาวแบบซิปครึ่งตัวสำหรับผู้ใหญ่และเด็ก รุ่น S-2XL และ 10-18 2526 AGTingS และ SpainS",
        "product_image": "https://img.lazcdn.com/g/p/0d4ddabfd95e8c9408170e3eb0039a6e.jpg_webp_200x200q90.jpg",
        "price": 2537.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16145086577.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟ, กระเป๋าคาดเอวกันน้ำทำจากไนลอน golf กระเป๋าสะพายขนาดเล็ก, กระเป๋าใส่เสื้อผ้า, กระเป๋าคาดหน้าอกแบบกว้างสำหรับทุกเพศ",
        "product_image": "https://img.lazcdn.com/g/p/a1579fb11c4077727eac00b697b5cea7.jpg_200x200q90.jpg",
        "price": 2532.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16146859882.html",
        "sold": 0
    },
    {
        "product_name": "5ชิ้นเสื้อยืดชุดกีฬาอูฐของผู้หญิงแจ็คเก็ต & กางเกง & กางเกงขาสั้นสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/c0cd8ae8a40248437bb6545cf50dbdae.jpg_200x200q90.jpg",
        "price": 2528,
        "remark": "https://www.lazada.co.th/products/pdp-i4838062132.html",
        "sold": 7
    },
    {
        "product_name": "PNXK ชุดชั้นในกีฬาลายนู้ดเสื้อกล้ามใส่ออกกำลังกายด้านหลังเป็นรูปตัว H ของผู้หญิงเสื้อกั๊กโยคะเสื้อผ้าโยคะสปอร์ตบราสลิมมิ่งกันกระแทก",
        "product_image": "https://img.lazcdn.com/g/p/cda4bcd018033f39c6991806f15e15b1.png_200x200q90.png",
        "price": 2528,
        "remark": "https://www.lazada.co.th/products/pdp-i16082704134.html",
        "sold": 0
    },
    {
        "product_name": "ชุดชั้นในผู้หญิงรูปตัว H สีนู้ดเสื้อกล้ามรัดรูปสำหรับสปอร์ตบราเสื้อผ้าโยคะฟิตเนสด้านหลังความงามใส่เล่นโยคะ",
        "product_image": "https://img.lazcdn.com/g/p/1ca5109017b01bb151250a32d071b4c3.png_200x200q90.png",
        "price": 2528,
        "remark": "https://www.lazada.co.th/products/pdp-i16082638279.html",
        "sold": 0
    },
    {
        "product_name": "2025 ฤดูร้อน เสื้อกั๊กโยคะหลังสวยงามกันกระแทก แห้งเร็ว เสื้อฟิตเนส เสื้อกั๊กกีฬาวิ่งกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/43994a73d53cdeb2b04295a8e4c9dad1.jpg_webp_200x200q90.jpg",
        "price": 2526.84,
        "remark": "https://www.lazada.co.th/products/pdp-i6071364809.html",
        "sold": 0
    },
    {
        "product_name": "DANBAOLUO | เสื้อแขนยาวสำหรับเต้นรำบัลเลต์ละตินและสังคมผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S634c9f62d27d4890847e8027efc3ca054.jpg_200x200q90.jpg",
        "price": 2526.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6016552807.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกั๊กสำหรับใส่วิ่งโยคะสำหรับผู้หญิงมีแผ่นปิดหน้าอกที่ถอดออกได้แผ่นบางด้านหลังมีความแข็งแรงสูงเสื้อกล้ามกีฬาฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/276bab309ac8a468e32b29ba805f8067.png_200x200q90.png",
        "price": 2520,
        "remark": "https://www.lazada.co.th/products/pdp-i16082682239.html",
        "sold": 0
    },
    {
        "product_name": "PNXK เสื้อผ้าโยคะสำหรับผู้หญิงให้ความรู้สึกเปลือยแบบยุโรปและอเมริกันชุดชั้นในโยคะกีฬารัดรูปแห้งเร็วสำหรับใส่วิ่งกลางแจ้งชุดชั้นในออกกำลังกายความงาม",
        "product_image": "https://img.lazcdn.com/g/p/63c1c731afa61e9dcff4163522bee9f1.png_200x200q90.png",
        "price": 2520,
        "remark": "https://www.lazada.co.th/products/pdp-i16082565701.html",
        "sold": 0
    },
    {
        "product_name": "PNXK เสื้อกั๊กสำหรับวิ่งโยคะสำหรับผู้หญิงมีแผ่นปิดหน้าอกด้านหลังที่ถอดออกได้แบบบางเสื้อกล้ามกีฬาสำหรับฤดูร้อนมีความแข็งแรงสูงกันกระแทก",
        "product_image": "https://img.lazcdn.com/g/p/5febf7acb8e266083f6a97f53021fa82.png_200x200q90.png",
        "price": 2520,
        "remark": "https://www.lazada.co.th/products/pdp-i16082657905.html",
        "sold": 0
    },
    {
        "product_name": "ชุดชั้นในออกกำลังกายคล้องคอไร้สายเซ็กซี่ของชุดชั้นในผู้หญิงสำหรับเล่นโยคะเสื้อกล้ามกีฬาสวยงามแบบยุโรปและอเมริกา",
        "product_image": "https://img.lazcdn.com/g/p/560bc31145137268c3e8d2bfdd57c7d6.png_200x200q90.png",
        "price": 2520,
        "remark": "https://www.lazada.co.th/products/pdp-i16082779122.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อสเวตเชิ้ตสไตล์ฮาราจูกุลำลองสำหรับผู้หญิง ชุดเซ็ตสองชิ้นแฟชั่นใหม่สำหรับฤดูใบไม้ผลิและฤดูใบไม้ร่วง กางเกงขายาว ผ้าคอตตอนผสม ช่วยลดอายุ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S12e5c96f94504a469acc23bf80091eb9s.jpg_200x200q90.jpg",
        "price": 2516.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16097378852.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อสเวตเชิ้ตผู้หญิงสไตล์ฮาราจูกุลำลอง ชุดเซ็ตสองชิ้นแฟชั่นใหม่ ฤดูใบไม้ผลิ ฤดูใบไม้ร่วง ผ้าผสมคอตตอน กางเกงขายาว ช่วยลดอายุ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S12e5c96f94504a469acc23bf80091eb9s.jpg_200x200q90.jpg",
        "price": 2516.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16097240326.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | เสื้อผ้าไหมสำหรับกอล์ฟแขนยาวป้องกันแดด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbbd1734c071846138cb806fe31fb3326B.jpg_200x200q90.jpg",
        "price": 2513.98,
        "remark": "https://www.lazada.co.th/products/pdp-i6066923376.html",
        "sold": 0
    },
    {
        "product_name": "when.we.stretch - Rally&Rest Polo Vest เสื้อคอปกมาพร้อมฟองน้ำในตัว",
        "product_image": "https://img.lazcdn.com/g/p/c83000c158cab426290619cfbdefd17e.jpg_200x200q90.jpg",
        "price": 2512.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5802698965.html",
        "sold": 0
    },
    {
        "product_name": "GUESS เสื้อยืด ผู้หญิง รุ่น Q6OIB5K3633  สีเทา",
        "product_image": "https://img.lazcdn.com/g/p/0f186481b7105907be5adf0970a788df.jpg_200x200q90.jpg",
        "price": 2512,
        "remark": "https://www.lazada.co.th/products/pdp-i16118860021.html",
        "sold": 0
    },
    {
        "product_name": "【ส่งจากกรุงเทพฯ】GENIO LAMODE 【โค้ทกันแดดสุดฮิต】 ผ้าPremium UPF50+ เย็นทันที-บางเบา！！ กันน้ำกันฝน เสื้อกันแดดชายหญิง ป้องกันยูวี+ระบายอากาศข้างตัว บางเบาระบายอากาศดี M-4XL",
        "product_image": "https://img.lazcdn.com/g/p/dde2ee642bd9fbfec52cd960293bec81.jpg_200x200q90.jpg",
        "price": 2510,
        "remark": "https://www.lazada.co.th/products/pdp-i5898680475.html",
        "sold": 0
    },
    {
        "product_name": "INBIKE | เสื้อจักรยานแขนยาวสำหรับผู้หญิง ฤดูร้อน-ฤดูใบไม้ร่วง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd297543a4e5b496fa6c4dc52b1b89784Y.jpg_200x200q90.jpg",
        "price": 2509,
        "remark": "https://www.lazada.co.th/products/pdp-i5914281911.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานระบายอากาศแห้งไวสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5871d55a9db540af9e9ee6b213d1d20cF.jpg_200x200q90.jpg",
        "price": 2508.18,
        "remark": "https://www.lazada.co.th/products/pdp-i5874316885.html",
        "sold": 0
    },
    {
        "product_name": "Jeep | เสื้อยืดชายฤดูร้อน แห้งเร็ว ซิปครึ่งตัว สีอ่อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S463e9dec8f0747f091f5f7e030fdb25aJ.jpg_200x200q90.jpg",
        "price": 2508.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16119637974.html",
        "sold": 0
    },
    {
        "product_name": "【support】 CHANBAEK Muay มวยไทยแขนยาวมวยชุดนักมวยผู้ชายเสื้อโค้ทเก๋ไก๋สำหรับบุรุษชุดนักมวยร้านขายฮอว์ก",
        "product_image": "https://img.lazcdn.com/g/p/08abb06ec10966680600fee46dfd63c7.jpg_200x200q90.jpg",
        "price": 2508.06,
        "remark": "https://www.lazada.co.th/products/pdp-i4880918703.html",
        "sold": 0
    },
    {
        "product_name": "QYUED | ชุดฟลีซอเนกประสงค์สบายๆ อบอุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0a2705bbabef439c89c18114dc8a014cY.jpg_200x200q90.jpg",
        "price": 2507.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6001906361.html",
        "sold": 0
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดแขนสั้นเด็กแห้งไว ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb122c5a946fe415cb7bb0f0404db37afo.png_200x200q90.png",
        "price": 2506.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16103154797.html",
        "sold": 11
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดแห้งไวป้องกันแดด ป้องกันแบคทีเรีย ให้ความรู้สึกเย็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7d6a0e97fa4f42de830046aab0d23addv.png_200x200q90.png",
        "price": 2506.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16106935530.html",
        "sold": 7
    },
    {
        "product_name": "VFU | เสื้อกล้ามกีฬาแบบซับในแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfd03e4a9817548fe86353b80fe8b4363F.png_200x200q90.png",
        "price": 2506.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5927035335.html",
        "sold": 67
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟสไตล์เกาหลีใหม่ ใช้ได้ทั้งชายและหญิง ความจุขนาดใหญ่ สามารถสะพายข้างได้ พกพาสะดวกและใช้งานได้จริง",
        "product_image": "https://img.lazcdn.com/g/p/191934626fb860364199977a766255d1.jpg_200x200q90.jpg",
        "price": 2504.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16147370206.html",
        "sold": 0
    },
    {
        "product_name": "ชุดปั่นจักรยานระบายอากาศได้ดี กางเกงขาสั้นและเสื้อแขนสั้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S851cc4d3f05647dfa294379f0bc51964S.jpg_200x200q90.jpg",
        "price": 2504.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5875624548.html",
        "sold": 80
    },
    {
        "product_name": "ชุดกีฬาผู้หญิง Dongda Gate ซัมเมอร์ 2025 เสื้อคอกลมแขนสั้น กางเกงขายาวทรงกว้าง แฟชั่นสีพื้น ชุดลำลอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb5e0583c8023474d9e5cd9776a778c4fi.jpg_200x200q90.jpg",
        "price": 2504.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16102119084.html",
        "sold": 0
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดเด็กกันแดดแห้งไวให้ความรู้สึกเย็นจาก City Sports",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2c93172c120942f39d21d05e08477b4bG.png_200x200q90.png",
        "price": 2503.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16105495583.html",
        "sold": 0
    },
    {
        "product_name": "เสืters สำหรับฤดูใบไม้ร่วงและหนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S20296d77d5764aaf86141b4b7087d86eI.jpg_200x200q90.jpg",
        "price": 2501.38,
        "remark": "https://www.lazada.co.th/products/pdp-i6001867368.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากอล์ฟใหม่, กระเป๋าถือน้ำหนักเบา, กระเป๋าคลัทช์ขนาดเล็ก, กระเป๋าเดินทาง, กระเป๋าสะพายข้าง, กระเป๋าสะพายไหล่, กระเป๋าใส่เสื้อผ้า",
        "product_image": "https://img.lazcdn.com/g/p/a362963f30f17db80c48b0520307d768.jpg_200x200q90.jpg",
        "price": 2500.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16146927393.html",
        "sold": 0
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดแขนยาวสำหรับเด็กชาย ซึมซับความชื้นและระบายอากาศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb542e586d663447cac9fe6eaccdb824dZ.png_200x200q90.png",
        "price": 2500.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6049031193.html",
        "sold": 57
    },
    {
        "product_name": "INBIKE | เสื้อปั่นจักรยานสตรีที่ระบายเหงื่อและระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S70629f8c957c4915b92e9c6a6bf52abar.jpg_200x200q90.jpg",
        "price": 2500.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5914300202.html",
        "sold": 14
    },
    {
        "product_name": "INBIKE | เสื้อปั่นจักรยานสำหรับผู้หญิง แขนยาวและแขนสั้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se0160725e27643daa30154b510f0bf25o.jpg_200x200q90.jpg",
        "price": 2500.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5971074841.html",
        "sold": 3
    },
    {
        "product_name": "izzue | เสื้อยืดแขนยาว สไตล์สบายๆ หลวม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5aa2869eafd542158b552002ed5b0b50b.jpg_200x200q90.jpg",
        "price": 2500.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16076399364.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดจับจีบใหม่สำหรับผู้หญิงพิมพ์สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/ad01e81f5dca6abfd1772f1322e4a1ba.jpg_200x200q90.jpg",
        "price": 2500,
        "remark": "https://www.lazada.co.th/products/pdp-i16106053039.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดจับจีบลำลองของผู้หญิงหลวมขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/45eb63076a49d88a18c4b36b526023e2.jpg_200x200q90.jpg",
        "price": 2500,
        "remark": "https://www.lazada.co.th/products/pdp-i16105905429.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดจับจีบใหม่สำหรับผู้หญิงขนาดใหญ่สำหรับฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/c2aabdf50dd307e082e249b41e326b5c.jpg_200x200q90.jpg",
        "price": 2500,
        "remark": "https://www.lazada.co.th/products/pdp-i16084861815.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแขนสั้นทรงเข้ารูปพร้อมกางเกงขายาวทรงกว้าง ชุดเซ็ตสองชิ้น ดีไซน์ทันสมัย สวมใส่สบายสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3d62e247b27e4da589ddbb12ed38f822h.jpg_200x200q90.jpg",
        "price": 2498.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16107494164.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้ากีฬาจักรยานแขนสั้นทรงสลิมฟิตแห้งเร็วสำหรับผู้หญิง XINTOWN QXXTW062DY ฤดูร้อน จักรยานเสือภูเขา จักรยานทางบก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S14a5d8d85073419db7de31b36f7aae7fi.jpg_200x200q90.jpg",
        "price": 2498,
        "remark": "https://www.lazada.co.th/products/pdp-i4503935044.html",
        "sold": 0
    },
    {
        "product_name": "West Biking | แจ็คเก็ตปั่นจักรยานกันหนาว ชุดปั่นจักรยานฤดูใบไม้ร่วงและฤดูหนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sda2e4c451fea4d90be4f0245eea66c25A.jpg_200x200q90.jpg",
        "price": 2497.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5995797735.html",
        "sold": 0
    },
    {
        "product_name": "XIYUQI | เสื้อแขนยาวสไตล์เกาหลี ดีไซน์เชือกรูดไม่สม่ำเสมอ ให้ความรู้สึกหรูหรา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4ae64bb4c530483cad2b63d0de5e38f2W.jpg_200x200q90.jpg",
        "price": 2496.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16074949237.html",
        "sold": 0
    },
    {
        "product_name": "XIYUQI | เสื้อชิฟฟ่อนสีเหลือง แขนระบาย แบบหัวไหล่ตก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S675c287a1cb5449484a08eb9577b0e77d.jpg_200x200q90.jpg",
        "price": 2496.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16106875774.html",
        "sold": 0
    },
    {
        "product_name": "XIYUQI | เสื้อคลุมสไตล์ฝรั่งเศสสีน้ำตาลสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5f9e2caa32934a199eeb640180daec78g.jpg_200x200q90.jpg",
        "price": 2496.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16076333653.html",
        "sold": 0
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดแขนยาวสำหรับเด็กชาย ซับเหงื่อ ระบายอากาศได้ และป้องกันแดด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S23a2ce0496b84b108c6eb2425a5f0954s.png_200x200q90.png",
        "price": 2494.66,
        "remark": "https://www.lazada.co.th/products/pdp-i6048991848.html",
        "sold": 72
    },
    {
        "product_name": "S&W | บราสปอร์ตคู่มือสนับสนุนแรงสูงกันสั่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4ee59f68d79a49318f5bec8668fe5ed6Z.jpg_200x200q90.jpg",
        "price": 2494,
        "remark": "https://www.lazada.co.th/products/pdp-i5245563184.html",
        "sold": 0
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดแขนสั้นสำหรับเด็ก แห้งไว ป้องกันแดด ให้ความรู้สึกเย็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5b56cb3278fa4df2b4973fb31e11ede9R.png_200x200q90.png",
        "price": 2491.44,
        "remark": "https://www.lazada.co.th/products/pdp-i16105061863.html",
        "sold": 0
    },
    {
        "product_name": "CryingCenter | เสื้อฮู้ดดี้โลโก้ผ้าฟลีซ ทรงโอเวอร์ไซส์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdbdbc9a154cb4b679d690378aa0bea1bI.png_200x200q90.png",
        "price": 2490.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6002893847.html",
        "sold": 360
    },
    {
        "product_name": "เสื้อยืดสีบล็อกสบาย สลิมฟิต",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S291a69590bb74f3f91db81f53e7f357e2.png_200x200q90.png",
        "price": 2490.44,
        "remark": "https://www.lazada.co.th/products/pdp-i6029568968.html",
        "sold": 0
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดเด็กแห้งไวระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf637ef05d2b843cf9f829c07b809deddk.png_200x200q90.png",
        "price": 2490.38,
        "remark": "https://www.lazada.co.th/products/pdp-i6048969693.html",
        "sold": 62
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดแขนสั้นกันแดดแห้งไวและเย็นสบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S36529a11496547ddaef57ccc157bdfb5k.png_200x200q90.png",
        "price": 2490,
        "remark": "https://www.lazada.co.th/products/pdp-i16112092586.html",
        "sold": 4
    },
    {
        "product_name": "Venum | เสื้อกั๊กซ้อมวิ่งสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdf2cdfdd581340caa9e1b2ef7c28b7dcP.jpg_200x200q90.jpg",
        "price": 2487.66,
        "remark": "https://www.lazada.co.th/products/pdp-i16053794571.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อแฟชั่นฤดูร้อนแบบหลวม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdf50c7ec5e124fc38b5ca8afd44e4403p.jpg_200x200q90.jpg",
        "price": 2486.18,
        "remark": "https://www.lazada.co.th/products/pdp-i16113037638.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อกันแดดสัมผัสน้ำแข็งขนาดพิเศษชุดเซิร์ฟชุดบอดี้สูทสำหรับผู้หญิง,Upf50 + สัมผัสน้ำแข็ง Hxber ความรู้สึกน้ำแข็งยืดหยุ่นง่าย Qaohe ชุดว่ายน้ำผู้หญิงป้องกัน Upf50ร่างกายผ้า + ว่ายน้ำดวงอาทิตย์2024ผู้หญิง2024ผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/6de00a7dcaaacd0424fa0ee56c150be1.jpg_200x200q90.jpg",
        "price": 2486,
        "remark": "https://www.lazada.co.th/products/pdp-i5435475215.html",
        "sold": 0
    },
    {
        "product_name": "✨NEW✨ KEED : NEW YORK ชุดว่ายน้ำ บอดี้สูท แขนยาว-ขสั้น ตกแต่งสกรีนการ์ตูน *120NY*",
        "product_image": "https://img.lazcdn.com/g/p/a19d49b9b3086cfd0338eff5be11c135.jpg_200x200q90.jpg",
        "price": 2485.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5515557543.html",
        "sold": 3
    },
    {
        "product_name": "ARESFUEL | เสื้อปั่นจักรยานกัน UV น้ำหนักเบา ฤดูใบไม้ผลิ/ฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S106ef2ed30ec461e95477c367a22c56fr.jpg_200x200q90.jpg",
        "price": 2482,
        "remark": "https://www.lazada.co.th/products/pdp-i5909731620.html",
        "sold": 4
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดแขนสั้นเด็กป้องกันแดดแห้งไวพร้อมคุณสมบัติให้ความเย็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfff2fc032bfb4885a05f8010cb6f0173Q.png_200x200q90.png",
        "price": 2481.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16105152785.html",
        "sold": 5
    },
    {
        "product_name": "ONMYGAME | เสื้อยืดดูดซับความชื้นและป้องกันแบคทีเรีย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S62209c3823004419892cc0b487e5477bL.png_200x200q90.png",
        "price": 2475.88,
        "remark": "https://www.lazada.co.th/products/pdp-i6048936904.html",
        "sold": 45
    },
    {
        "product_name": "เสื้อปั่นจักรยานสำหรับผู้หญิง แขนสั้นและยาว กันเหงื่อ แห้งไว ระบายอากาศได้ดี สำหรับฤดูใบไม้ผลิและฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S549fe396609540238aed492f7af93844W.jpg_200x200q90.jpg",
        "price": 2474.46,
        "remark": "https://www.lazada.co.th/products/pdp-i5878166727.html",
        "sold": 15
    },
    {
        "product_name": "เสื้อยืดทรงตรงลายดอกไม้สไตล์ลำลอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scb79f08edfd1405c926738f53a2bdbcfN.jpg_200x200q90.jpg",
        "price": 2471.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16119596489.html",
        "sold": 0
    },
    {
        "product_name": "ริคัวโอ เสื้อคอมเพรสชั่นสำหรับเด็กผู้ชาย เสื้อแขนยาวสำหรับเด็ก เสื้อชั้นในกีฬาแห้งเร็วสำหรับเบสบอล ฟุตบอล",
        "product_image": "https://img.lazcdn.com/g/p/3f4a959e7e598734dd60cfcd6b86fb0d.jpg_webp_200x200q90.jpg",
        "price": 2469.52,
        "remark": "https://www.lazada.co.th/products/pdp-i6043073983.html",
        "sold": 0
    },
    {
        "product_name": "กางเกงออกกำลังกายแบบยืดหยุ่นสำหรับผู้หญิง Bandit กางเกงวิ่งระบายอากาศแห้งเร็ว กระเป๋าใส่ของ ทรงสลิมฟิต กางเกงกีฬา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sabdbca3f043f4b2ea1e92030ee6b70b0O.jpg_200x200q90.jpg",
        "price": 2468,
        "remark": "https://www.lazada.co.th/products/pdp-i16089400261.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อชั้นในสำหรับปั่นจักรยานแขนยาวสำหรับผู้หญิง ฤดูใบไม้ร่วง/หนาว ดูดเหงื่อ อบอุ่นและระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2ccd91adb8914d66b13b192da80e00ebr.jpg_200x200q90.jpg",
        "price": 2464.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5851840104.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อผ้าเด็กพร้อมหมวกขนสัตว์ถอดได้ หนา ฟลีซ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa197bd038b8f4ef59d390a2f0a579e61A.jpg_200x200q90.jpg",
        "price": 2458.86,
        "remark": "https://www.lazada.co.th/products/pdp-i6001747963.html",
        "sold": 0
    },
    {
        "product_name": "when.we.stretch - Abby Sculpt Tank เสื้อกล้ามออกกำลังกายพร้อมบราในตัว **สินค้าพร้อมส่ง**",
        "product_image": "https://img.lazcdn.com/g/p/ba32f6d4e6256b5c881c6836514824a2.png_200x200q90.png",
        "price": 2452.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16060036964.html",
        "sold": 1
    },
    {
        "product_name": "Sweet Sculpt Double Layer Tank -  Sweet Mess Collection",
        "product_image": "https://img.lazcdn.com/g/p/ac3fa2ea89d274de10d1188e4e2e29aa.jpg_200x200q90.jpg",
        "price": 2446.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5943293311.html",
        "sold": 26
    },
    {
        "product_name": "happy nocnoc | เสื้อยืดเด็กที่ระบายอากาศได้ แห้งไว น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sebabb63d1c634c3bb1a9c0d75dfc44e12.jpg_200x200q90.jpg",
        "price": 2440.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16094267504.html",
        "sold": 9
    },
    {
        "product_name": "PNXK ชุดชั้นในกีฬาโยคะสำหรับฟิตเนส Rompi Olahraga วิ่งออกกำลังกายแห้งเร็วใหม่",
        "product_image": "https://img.lazcdn.com/g/p/c41b60c7fc250083110261de570ba8c6.png_200x200q90.png",
        "price": 2434,
        "remark": "https://www.lazada.co.th/products/pdp-i16082675369.html",
        "sold": 0
    },
    {
        "product_name": "DANBAOLUO | เสื้อฝึกเต้นบัลเลต์แบบดีไซน์รวมทันสมัย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3a6244704bb942a7a56f2375f604d628H.png_200x200q90.png",
        "price": 2433.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6014893195.html",
        "sold": 1
    },
    {
        "product_name": "INBIKE เสื้อปั่นจักรยานแขนยาวกันลมผู้หญิง,เสื้อผ้าปั่นจักรยานน้ำหนักเบาแบบพกพากลางแจ้งระบายอากาศได้สำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/016ee91ff9a690f0dd3a5daa07e9dbad.jpg_200x200q90.jpg",
        "price": 2432,
        "remark": "https://www.lazada.co.th/products/pdp-i5958191596.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้าฝึกซ้อมมวยไทยสำหรับผู้ชาย FLUORY ป้องกันการสึกหรอ ด้านหน้าเป็นลายสก็อต สวมใส่สบาย ระบายอากาศได้ดี สำหรับทุกฤดูกาล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S454e864e1b124b85bb60bc5b34825ff6n.jpg_200x200q90.jpg",
        "price": 2432,
        "remark": "https://www.lazada.co.th/products/pdp-i16079366612.html",
        "sold": 0
    },
    {
        "product_name": "WEST BIKING เสื้อจักรยานชุดเสื้อผ้าเมาเท่นไบค์ผู้หญิงน้ำหนักเบา,UPF50 + ฤดูร้อนเสื้อเจอร์ซีย์นักปั่นเสื้อเชิ้ตแขนยาวขี่จักรยานแห้งเร็วมีกระเป๋า",
        "product_image": "https://img.lazcdn.com/g/p/794e5bdfcd3c191a5f9a5ed3aa61fd67.jpg_200x200q90.jpg",
        "price": 2430,
        "remark": "https://www.lazada.co.th/products/pdp-i5821583821.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS Morandi ชุดเสื้อเจอร์ซีย์นักปั่นของผู้หญิงแขนสั้นแห้งเร็วเสื้อผ้าระบายอากาศจักรยานเสือหมอบยืดหยุ่นสูง",
        "product_image": "https://img.lazcdn.com/g/p/6b152635371f8176792765df468dbe83.jpg_200x200q90.jpg",
        "price": 2428,
        "remark": "https://www.lazada.co.th/products/pdp-i5695241799.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกีฬาต่อสู้แบบดั้งเดิมสีแดงบริสุทธิ์และสีน้ำเงินบริสุทธิ์ ชุดฝึกซ้อมและเสื้อผ้าแสดง สำหรับผู้ชายและผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8ae779c195e84191af8df69bcfaf2927s.jpg_200x200q90.jpg",
        "price": 2428,
        "remark": "https://www.lazada.co.th/products/pdp-i16079620900.html",
        "sold": 0
    },
    {
        "product_name": "X-TIGER ผู้หญิงเสื้อเจอร์ซีย์นักปั่นขี่จักรยานกลางแจ้งระบายอากาศแห้งเร็วแขนสั้น Pro ผ้ายืดหยุ่นสูงเสื้อจักรยานแฟชั่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3b0d201caf9e4fd298dce6bb63cbb51d3.jpg_200x200q90.jpg",
        "price": 2425.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5839487796.html",
        "sold": 0
    },
    {
        "product_name": "ฮู้ดดี้แขนยาวสไตล์กีฬาและลำลอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbb3d99c967cd4d5eb4a1f4769a05a5498.jpg_200x200q90.jpg",
        "price": 2424,
        "remark": "https://www.lazada.co.th/products/pdp-i16139521939.html",
        "sold": 0
    },
    {
        "product_name": "Rompi Olahraga วิ่งฟิตเนสชุดชั้นในกีฬาโยคะแห้งเร็วด้านหลังใหม่",
        "product_image": "https://img.lazcdn.com/g/p/33d9e1a67e1a50bcf43a8607da53ef6f.png_200x200q90.png",
        "price": 2420,
        "remark": "https://www.lazada.co.th/products/pdp-i16082708143.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้าฝึกซ้อมมวยปล้ำชาย FLUORY ชุดป้องกันการสึกหรอแบบเข้ารูป ชุดกีฬา ชุดคาราเต้ ชุดจักรยานยนต์ เสื้อยืด วิ่ง ฟิตเนส ไตรathlon",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se0356e89c1c64ce08c89eecfa6a5aaecd.jpg_200x200q90.jpg",
        "price": 2420,
        "remark": "https://www.lazada.co.th/products/pdp-i16079753184.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS เสื้อแขนยาวจักรยานเสือหมอบเสือภูเขาผู้หญิง,ชุดใส่ปั่นจักรยานใส่สบายป้องกันรังสียูวีแห้งเร็วระบายอากาศได้ดีเสื้อเจอร์ซีย์นักปั่น",
        "product_image": "https://img.lazcdn.com/g/p/c46bc8330b98b1798ae79eb83d9484b2.jpg_200x200q90.jpg",
        "price": 2418,
        "remark": "https://www.lazada.co.th/products/pdp-i5271536443.html",
        "sold": 0
    },
    {
        "product_name": "INBIKE Women's Cycling Jersey Winter Thermal Long Sleeve Fleece Cycling Jacket with 3 Rear Pockets Full Zip Bicycle Shirt Cold Weather Windproof Breathable Reflective",
        "product_image": "https://img.lazcdn.com/g/p/e24ab34037ab5a83ddd93cc5139d1053.jpg_200x200q90.jpg",
        "price": 2418,
        "remark": "https://www.lazada.co.th/products/pdp-i4877125583.html",
        "sold": 5
    },
    {
        "product_name": "เสื้อผ้าฝึกซ้อมมวยฟลูออรี่สำหรับผู้ชาย รัดรูป Fit Anti-Wear Martial Arts MMA Grappling T-Shirt โพลีเอสเตอร์ ยืดได้ Micro Stretch",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3d48f211988644fb8c65e25196d6c668K.jpg_200x200q90.jpg",
        "price": 2418,
        "remark": "https://www.lazada.co.th/products/pdp-i16079711339.html",
        "sold": 0
    },
    {
        "product_name": "ชดวายนำผหญงแบบเตมตว สำหรบฝกซอม รนซมเมอรดรม สดำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scc58634834e645cba33a9338ff72a7a9N.png_200x200q90.png",
        "price": 2406.78,
        "remark": "https://www.lazada.co.th/products/pdp-i6003005250.html",
        "sold": 0
    },
    {
        "product_name": "Sports Vest Women's Beautiful Back Tight Quick-Dry Fitness Running Vest Shockproof Push-Up High Strength Yoga Clothes （ALO LULU）",
        "product_image": "https://img.lazcdn.com/g/p/23246ae3d4077515287956d7534a3989.jpg_200x200q90.jpg",
        "price": 2406,
        "remark": "https://www.lazada.co.th/products/pdp-i5977630450.html",
        "sold": 2
    },
    {
        "product_name": "เสื้อไหมพรมสไตร์ชิคพร้อมลูกไม้เพื่อหุ่นฟิต",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S697ea1cc39014888af5b71b39ad6753aK.jpg_200x200q90.jpg",
        "price": 2402.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6035555952.html",
        "sold": 3
    },
    {
        "product_name": "เสื้อฝึกว่ายน้ำเด็ก รุ่น SWIMVEST+ สีชมพู/ฟ้า ช่วยลอยตัว ปลอดภัย ใส่สบาย เหมาะสำหรับฝึกว่ายน้ำและเล่นน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/c6778fa658923616a8d3d9b3eae25bd4.png_200x200q90.png",
        "price": 2400,
        "remark": "https://www.lazada.co.th/products/pdp-i5963579252.html",
        "sold": 0
    },
    {
        "product_name": "ร็อคบรอสเสื้อผ้าขี่จักรยานแขนยาวมีซิปซึมซับเหงื่อเสื้อแจ๊กเก็ตจักรยานน้ำหนักเบาระบายอากาศได้ดีสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/b86c1cb38b1308326d65aa700b4de295.jpg_200x200q90.jpg",
        "price": 2400,
        "remark": "https://www.lazada.co.th/products/pdp-i5218978237.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อฝึกว่ายน้ำเด็ก สีฟ้า/แดง ช่วยลอยตัว ปลอดภัย ใส่สบาย เหมาะสำหรับฝึกว่ายน้ำและเล่นน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/8531d7e126a41ac5656366a69bc687f1.png_200x200q90.png",
        "price": 2400,
        "remark": "https://www.lazada.co.th/products/pdp-i5962314056.html",
        "sold": 0
    },
    {
        "product_name": "2XU WR6928A-PXLWRF AERO SINGLET WOMEN เสื้อออกกำลังผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/f54b4f7d7f029a7e397a6792a3ecf0af.png_200x200q90.png",
        "price": 2400,
        "remark": "https://www.lazada.co.th/products/pdp-i16050529063.html",
        "sold": 0
    },
    {
        "product_name": "WEST BIKING เสื้อจักรยานผู้หญิงแขนยาวกันยูวีระบายอากาศได้ดีเสื้อขี่จักรยานใส่สบายเสื้อเจอร์ซีย์ปั่นจักรยานเป็นมิตรกับผิว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4c3dfcf25272415db57ce653dcd89fa75.jpg_200x200q90.jpg",
        "price": 2400,
        "remark": "https://www.lazada.co.th/products/pdp-i5989165857.html",
        "sold": 0
    },
    {
        "product_name": "SwimFly Wetsuit for Kids, Neoprene Long Sleeve Swimwear- Dinosaur Design (Gray/Green, Pink/Yellow)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S547723d388aa442d827ce62e7c9db579f.jpg_200x200q90.jpg",
        "price": 2400,
        "remark": "https://www.lazada.co.th/products/pdp-i264837726.html",
        "sold": 4
    },
    {
        "product_name": "MEDM | เสื้อยืดแขนสั้นตัวการ์ตูนอนิเมะเก๋ๆ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9ce59fe5378c491c952981a9740c91961.jpg_200x200q90.jpg",
        "price": 2399.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6066524640.html",
        "sold": 0
    },
    {
        "product_name": "BJHG | เสื้อยืดแขนยาวสไตล์แข่งรถสำหรับคู่รัก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd13437519a7949749229fc784d5b6414F.png_200x200q90.png",
        "price": 2399.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6048124409.html",
        "sold": 6
    },
    {
        "product_name": "WEST BIKING กันแดดเสื้อปั่นจักรยานสำหรับผู้หญิง,เสื้อปั่นจักรยานแขนสั้นระบายอากาศได้ดีแห้งเร็วเครื่องประดับลำตัวปั่นจักรยาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S418e80acff2e4598a8c6e1e16997c346Q.jpg_200x200q90.jpg",
        "price": 2398,
        "remark": "https://www.lazada.co.th/products/pdp-i5989191663.html",
        "sold": 0
    },
    {
        "product_name": "ชุดโดบ็อกกของเด็กชุดเครื่องแบบ Gi เสื้อแขนยาวชายและหญิงสำหรับคาราเต้ยูโดเสื้อผ้าสีขาวชุดเทควันโด",
        "product_image": "https://img.lazcdn.com/g/p/d9985e8318b88126d5910ecd1f92c186.jpg_200x200q90.jpg",
        "price": 2394.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16141650602.html",
        "sold": 0
    },
    {
        "product_name": "likeuu | เสื้อยืดแขนยาวสำหรับเด็ก ป้องกันแดด ระบายอากาศได้และแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S456c315c42a040f6a70e05fe9423a9b6r.png_200x200q90.png",
        "price": 2392.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16050076409.html",
        "sold": 2
    },
    {
        "product_name": "เสื้อเจอร์ซีย์มวย MMA สำหรับเด็ก เสื้อยืดรัดรูป MMA + กางเกง ชุดรัดรูปแขนยาวสำหรับยูยิตส์ กางเกงรัดรูปสำหรับเด็ก ชุดกีฬา BJJ MMA",
        "product_image": "https://img.lazcdn.com/g/p/e0312669631e0c5e08933b00e817783a.jpg_webp_200x200q90.jpg",
        "price": 2392.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16120809789.html",
        "sold": 0
    },
    {
        "product_name": "Zoke | ชุดว่ายน้ำสำหรับเด็กหญิงกันแดดแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc9afca6cb4cb48709b705ec5aedfca4aC.jpg_200x200q90.jpg",
        "price": 2388.24,
        "remark": "https://www.lazada.co.th/products/pdp-i5893544541.html",
        "sold": 10
    },
    {
        "product_name": "PNXK ชุดชั้นในสปอร์ตบราดันทรงด้านหลังแบบชิ้นเดียวด้านหลังสวยสปอร์ตบรา",
        "product_image": "https://img.lazcdn.com/g/p/aebcc0d7a20f9bf82f6280c6609c7194.png_200x200q90.png",
        "price": 2388,
        "remark": "https://www.lazada.co.th/products/pdp-i16082681787.html",
        "sold": 0
    },
    {
        "product_name": "REEBOK Tech Jersey Ls เสื้อวิ่งผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/b59b060a0ca192cb5668bb6db3b113ab.jpg_200x200q90.jpg",
        "price": 2388,
        "remark": "https://www.lazada.co.th/products/pdp-i5958633617.html",
        "sold": 1
    },
    {
        "product_name": "XIYUQI | เสื้อเชิ้ตแขนยาวสไตล์เกาหลี ดีไซน์เรียบง่าย หรูหรา กระชับรูปร่าง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa31291f897804599b33835b280d83df2K.jpg_200x200q90.jpg",
        "price": 2387.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16074711703.html",
        "sold": 0
    },
    {
        "product_name": "สลิมมิ่ง สลิมมิ่ง แฟชั่นฤดูใบไม้ร่วง เสื้อสเวตเตอร์ ชุดกระโปรง ชุดสองชิ้น สไตล์หรูหรา บล็อกสี สีพื้น ลำลอง สไตล์เกาหลี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd6bc131ac42f4a3bab23fb3f4246a411d.jpg_200x200q90.jpg",
        "price": 2385.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16105339062.html",
        "sold": 0
    },
    {
        "product_name": "TOOCH - Cami Tank Top",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sab6580f4d0a2449bb10007f79d137d9dx.jpg_200x200q90.jpg",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i5690263397.html",
        "sold": 9
    },
    {
        "product_name": "ชุดชั้นในดันทรงสปอร์ตบราชิ้นเดียวด้านหลังสวยงามสปอร์ตบราใหม่",
        "product_image": "https://img.lazcdn.com/g/p/b6233eb7e72706f3c16fce825056c5b7.png_200x200q90.png",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i16082692089.html",
        "sold": 0
    },
    {
        "product_name": "(พร้อมส่ง) Korea set เสื้อ+กางเกงขาสั้น เนื้อผ้าดี ใส่สวยมาก ทรงสวย สีดีมากๆ ใส่ชุดเดียว หรือใส่โค้ท , แจ็คเก็ตคลุมทับอีกชั้นก็สวยค่าา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf2da2e3121bb46998202d291ebd13576B.jpg_200x200q90.jpg",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i5111734534.html",
        "sold": 6
    },
    {
        "product_name": "ANTA Kids เสื้อยืดสั้นชาย 3525B8103 Official Store",
        "product_image": "https://img.lazcdn.com/g/p/75491b061a4c43b30b697df346e28bba.jpg_200x200q90.jpg",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i5674043386.html",
        "sold": 0
    },
    {
        "product_name": "Janesuda x Wakingbee Rally Tank เสื้อกล้าม ดีไซน์เก๋ ผ้าฉลุ ผ่าข้าง ชายเฉียง คลุมออกกำลังกาย วิ่ง เทนนิส ฟิตเนส",
        "product_image": "https://img.lazcdn.com/g/p/bf1b042813fdb790504ca989e3faada0.jpg_200x200q90.jpg",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i6043647269.html",
        "sold": 11
    },
    {
        "product_name": "เสื้อยืดผู้หญิง Levi's® Women's Graphic Favorite Tee",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0de3f372ce544cee8b09394e29bdf85ef.jpg_200x200q90.jpg",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i16096616950.html",
        "sold": 0
    },
    {
        "product_name": "Adelaide Cross-Back Tank Top",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6f47727ac60e47178ef40de937636dac0.jpg_200x200q90.jpg",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i5800607538.html",
        "sold": 2
    },
    {
        "product_name": "NEW HOURGLASS TANK TOP WITH SUPPORT BRA \"LIGHT HUG - CLOUD EDITION\"  เสื้อกล้ามเสริมซัพพอร์ทบรา รุ่น Light Hug - Cloud Ed.",
        "product_image": "https://img.lazcdn.com/g/p/02cf4ec3785bfbe4830f5338f29b37e2.jpg_200x200q90.jpg",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i5825261137.html",
        "sold": 10
    },
    {
        "product_name": "Gymshark Shark Chest Pad Bra Shockproof Beautiful Back Women Wear Inside And Outside Knitted Beautiful Back Sports Vest 【MAR】 yy",
        "product_image": "https://img.lazcdn.com/g/p/8dfda40ae3c9d42ec0bc034c780a5337.jpg_200x200q90.jpg",
        "price": 2378.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6062334119.html",
        "sold": 0
    },
    {
        "product_name": "AZUREWAY | เสื้อผู้หญิงแขนยาวทรงกระชับสไตล์เกาหลีสำหรับกอล์ฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc05d74fc6c914b8e9a978478a98f0fedB.jpg_200x200q90.jpg",
        "price": 2377.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6066124887.html",
        "sold": 0
    },
    {
        "product_name": "แจ็คเก็ตกีฬาฟิตกระชับสำหรับฤดูร้อน ยืดหยุ่นสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2bc84adcc2e04f6cbad62df3251ba8dfK.jpg_200x200q90.jpg",
        "price": 2376.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16119952249.html",
        "sold": 2
    },
    {
        "product_name": "เสื้อยืดดูดซับเหงื่อแห้งสบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5637ae6af0064d03828feb9a3a7734f2q.jpg_200x200q90.jpg",
        "price": 2374,
        "remark": "https://www.lazada.co.th/products/pdp-i16085270992.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อวัฒนธรรมบาสเกตบอลที่ระบายอากาศและดูดซับเหงื่อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4600d86712bc4921b0f11a7b6c70f075M.jpg_200x200q90.jpg",
        "price": 2374,
        "remark": "https://www.lazada.co.th/products/pdp-i16085595345.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแขนสั้นซับเหงื่อสบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5637ae6af0064d03828feb9a3a7734f2q.jpg_200x200q90.jpg",
        "price": 2374,
        "remark": "https://www.lazada.co.th/products/pdp-i16085525598.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดบาสเกตบอลชาย ระบายอากาศได้ดี ซับเหงื่อ สบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4600d86712bc4921b0f11a7b6c70f075M.jpg_200x200q90.jpg",
        "price": 2374,
        "remark": "https://www.lazada.co.th/products/pdp-i16085440569.html",
        "sold": 0
    },
    {
        "product_name": "West Biking | เสื้อปั่นจักรยานกันแดดระบายอากาศ แขนยาวสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S38abf64a9a1c463b9b2f3a9478a28bafP.jpg_200x200q90.jpg",
        "price": 2372.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5995609653.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อคลุมแบบสวมหัวลายตัวอักษรและสีบล็อก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb48576f22f3e463ea7c527f9554442c1k.jpg_200x200q90.jpg",
        "price": 2372,
        "remark": "https://www.lazada.co.th/products/pdp-i16085721101.html",
        "sold": 0
    },
    {
        "product_name": "บราสำหรับวิ่งและโยคะแฟชั่นใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfc6639f0739e4843bca5d18de5d7acb4E.jpg_200x200q90.jpg",
        "price": 2365.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5909796778.html",
        "sold": 22
    },
    {
        "product_name": "เสื้อถักเอลิแกนต์ ฟิตกระชับ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb1bb8fb3dea146668129067794203409I.jpg_200x200q90.jpg",
        "price": 2365.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5996821071.html",
        "sold": 2
    },
    {
        "product_name": "SPEEDO Long Sleeve Print เสื้อรัชการ์ดเด็กผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/p/fcfc8f90b3b74be4ef43aa8859dd4791.jpg_200x200q90.jpg",
        "price": 2364,
        "remark": "https://www.lazada.co.th/products/pdp-i16046413766.html",
        "sold": 0
    },
    {
        "product_name": "ARESFUEL | เสื้อขี่จักรยานผู้หญิงแขนสั้น ซัมเมอร์ ระบายอากาศได้ดี ช่วยดูดซับเหงื่อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7c2e710e71ba4de1a1093e8897cf66e1u.jpg_200x200q90.jpg",
        "price": 2363.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5909772354.html",
        "sold": 0
    },
    {
        "product_name": "unifree | เสื้อยืดแขนสั้นผู้หญิง แฟชั่นสไตล์อเมริกัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6a0fb154d691476e9469b5f62dbb3a1a8.png_200x200q90.png",
        "price": 2362.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5857163859.html",
        "sold": 6
    },
    {
        "product_name": "West Biking | ชุดปั่นจักรยานฤดูร้อนที่ระบายอากาศได้ แขนยาวสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scee453ba69974d558ffe870f1559d3d81.jpg_200x200q90.jpg",
        "price": 2362.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5995817825.html",
        "sold": 0
    },
    {
        "product_name": "LAMEDA เสื้อปั่นจักรยานเสือภูเขาสำหรับผู้หญิง,เสื้อปั่นจักรยานเสือภูเขาชุดกีฬาจักรยานรัดรูปชายแขนยาวฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/6c69185b28b472fa7856c516d79a7c96.jpg_200x200q90.jpg",
        "price": 2362,
        "remark": "https://www.lazada.co.th/products/pdp-i5348047113.html",
        "sold": 3
    },
    {
        "product_name": "เสื้อสไตล์สบายๆ ขนาดใหญ่ พร้อมซับนุ่ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf528f8d361464c51b39e1208d1d3e610S.jpg_200x200q90.jpg",
        "price": 2361.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5995406198.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อยืดจับจีบลำลองใหม่สำหรับผู้หญิงทรงหลวมพิมพ์ลาย",
        "product_image": "https://img.lazcdn.com/g/p/223900664cf86d8b5dff175f96eff582.jpg_200x200q90.jpg",
        "price": 2360,
        "remark": "https://www.lazada.co.th/products/pdp-i16110082787.html",
        "sold": 0
    },
    {
        "product_name": "ชุดจักรยานผู้หญิงแขนยาวขายาว CheJi 16 (20) สีดำลายพรางชมพู ผ้าขนแกะ",
        "product_image": "https://img.lazcdn.com/g/p/ca8dca9b3112b3522135dfd815084c9e.jpg_200x200q90.jpg",
        "price": 2360,
        "remark": "https://www.lazada.co.th/products/pdp-i523684415.html",
        "sold": 0
    },
    {
        "product_name": "ชุดจักรยานผู้หญิงแขนยาวขายาว CheJi 16 (21) สีดำขีดชมพูขาว ผ้าขนแกะ",
        "product_image": "https://img.lazcdn.com/g/p/0cc7235e6fd1eec3d271b16f52ada8ac.jpg_200x200q90.jpg",
        "price": 2360,
        "remark": "https://www.lazada.co.th/products/pdp-i510424473.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อยืดปักลายจีบผู้หญิงใหม่",
        "product_image": "https://img.lazcdn.com/g/p/f4590db1841a5181391d060e0004ca90.jpg_200x200q90.jpg",
        "price": 2360,
        "remark": "https://www.lazada.co.th/products/pdp-i16143465375.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดผู้หญิงจีบสง่างามลำลองใหม่",
        "product_image": "https://img.lazcdn.com/g/p/6f951076cc35473a55bae49300e7fd35.jpg_200x200q90.jpg",
        "price": 2360,
        "remark": "https://www.lazada.co.th/products/pdp-i16095716437.html",
        "sold": 0
    },
    {
        "product_name": "XIYUQI | เสื้อเบลาส์ทรงลูกแพร์สำหรับผู้หญิง ช่วยให้ดูเพรียวและมีสไตล์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1215c7d221c24f7ebdacd29e861d13d21.jpg_200x200q90.jpg",
        "price": 2357.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16083675181.html",
        "sold": 0
    },
    {
        "product_name": "J.LINDEBERG Titleist DESCENNTE 2026 Golf Clothing Men's Short-sleeved T-shirt Spring And Summer Quick-drying Breathable Clothing Clothes Tops Polo Shirts",
        "product_image": "https://img.lazcdn.com/g/p/d1e163283946e294cfd70e03fba5deda.jpg_200x200q90.jpg",
        "price": 2356,
        "remark": "https://www.lazada.co.th/products/pdp-i16114804457.html",
        "sold": 0
    },
    {
        "product_name": "J.LINDEBERG Titleist DESCENNTE New Golf Men's Short-sleeved Fashion T-shirt Breathable And Quick-drying Men's Polo Shirt Sports Ball Clothes",
        "product_image": "https://img.lazcdn.com/g/p/b251b477ec1699197a8ce17a34bad600.jpg_200x200q90.jpg",
        "price": 2356,
        "remark": "https://www.lazada.co.th/products/pdp-i16114853433.html",
        "sold": 0
    },
    {
        "product_name": "J.LINDEBERG Titleist DESCENNTE Golf Clothing Men's Digital Printed Short-sleeved T-shirt Summer Quick-drying Clothes Top Polo Shirt",
        "product_image": "https://img.lazcdn.com/g/p/e69bb4b23b199b994a33ee0d390ba02e.jpg_200x200q90.jpg",
        "price": 2356,
        "remark": "https://www.lazada.co.th/products/pdp-i16114775322.html",
        "sold": 0
    },
    {
        "product_name": "J.LINDEBERG Titleist DESCENNTE Summer New Golf Men's Outdoor Leisure Sports High-end Polo Shirt Moisture-wicking, Quick-drying And Breathable Clothes",
        "product_image": "https://img.lazcdn.com/g/p/08bfed2308ead329336011cd35a0b172.jpg_200x200q90.jpg",
        "price": 2356,
        "remark": "https://www.lazada.co.th/products/pdp-i16114755366.html",
        "sold": 0
    },
    {
        "product_name": "WEST BIKING ชุดเสื้อเจอร์ซีย์นักปั่น UPF50แขนสั้นสำหรับผู้หญิง + ซับเหงื่อเหมาะสำหรับฤดูใบไม้ผลิฤดูร้อนจักรยานเสือหมอบจักรยานที่มีน้ำหนักเบาเข้ารูปพอดีเสื้อผ้าป้องกันแสงแดดสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3439871d0f554829be962c1a456f01daF.jpg_200x200q90.jpg",
        "price": 2356,
        "remark": "https://www.lazada.co.th/products/pdp-i5994330327.html",
        "sold": 0
    },
    {
        "product_name": "INBIKE เสื้อแขนกุดปั่นจักรยานแบบบางสำหรับผู้หญิงกันลมซิปคู่เสื้อกั๊กนักปั่นจักรยานอุปกรณ์กีฬากลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/77f6e9c257cb8460224f96d96f6247d1.jpg_200x200q90.jpg",
        "price": 2352,
        "remark": "https://www.lazada.co.th/products/pdp-i5961167713.html",
        "sold": 0
    },
    {
        "product_name": "HAIGEMAN | เสื้อยืดแขนยาวสไตล์หรูหราและสามารถใส่ได้หลายโอกาส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa876acdcd1034e5b8dbe2714cc8f4e3eu.jpg_200x200q90.jpg",
        "price": 2351.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5999848117.html",
        "sold": 0
    },
    {
        "product_name": "HAIGEMAN | เสื้อยืดแฟชั่นผู้หญิงทรงกระชับ ฤดูร้อน 2026",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfc9e478e726e4768bae522b66b7775779.jpg_200x200q90.jpg",
        "price": 2351.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5999627957.html",
        "sold": 0
    },
    {
        "product_name": "HOACON | เสื้อยืดแขนยาวลดความอ้วนและสร้างรูปร่าง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S147123ce98714d58bc38d8453d0b5101h.jpg_200x200q90.jpg",
        "price": 2350.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5928808998.html",
        "sold": 3
    },
    {
        "product_name": "NABAIJI ชุดว่ายน้ำแขนยาวเด็กผู้ชาย 5-15 ปี สวมใส่สบาย กันแดดได้ดี",
        "product_image": "https://img.lazcdn.com/g/p/f29d041cd98d6061ea57d83d0a6efe48.jpg_200x200q90.jpg",
        "price": 2350,
        "remark": "https://www.lazada.co.th/products/pdp-i5078655959.html",
        "sold": 1
    },
    {
        "product_name": "QIANJIEFU | เสื้อแขนยาวพิมพ์ลายทายดายสีฟ้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8f3a94b6d3aa4ebf86da9c7f6afd272ca.jpg_200x200q90.jpg",
        "price": 2346.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16082365329.html",
        "sold": 0
    },
    {
        "product_name": "HOACON | เสื้อยืดแขนสอดสีบล็อก สำหรับผู้หญิง ทรงเรโทร เรียบหรู ใส่สบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8131861ba782422692316bb12bb007cfQ.jpg_200x200q90.jpg",
        "price": 2345.64,
        "remark": "https://www.lazada.co.th/products/pdp-i5929617342.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่เสื้อผ้ากอล์ฟใหม่, ใช้ได้ทั้งชายและหญิง, กระเป๋าถือความจุขนาดใหญ่, กระเป๋าเก็บของ, กระเป๋าเดินทาง, กระเป๋าสะพายไหล่ทันสมัย, กระเป๋าสะพายข้าง",
        "product_image": "https://img.lazcdn.com/g/p/4274e219c4907f43b7df4e8db10c42e0.jpg_webp_200x200q90.jpg",
        "price": 2342.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16147073158.html",
        "sold": 0
    },
    {
        "product_name": "YAKEJIA | เสื้อเชิ้ตลำลองแบบเรียบง่ายสำหรับฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7fd4d453bf134c2cbf0f9404ed89625bh.png_200x200q90.png",
        "price": 2340.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16085020990.html",
        "sold": 0
    },
    {
        "product_name": "Camel ชุดสูทชุดโยคะสำหรับผู้หญิง,ชุดชุดฟิตเนสลำลองบางชุดออกกำลังกายระบายอากาศยืดหยุ่นสูงสำหรับใส่กลางแจ้งชุดวิ่งตอนเช้าฤดูใบไม้ผลิและฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/45050ff177559a915e4210a8eb66942a.jpg_200x200q90.jpg",
        "price": 2338,
        "remark": "https://www.lazada.co.th/products/pdp-i5047087231.html",
        "sold": 5
    },
    {
        "product_name": "ชุดกีฬาใหม่ เสื้อแจ็คเก็ตมีฮู้ดสองด้าน ไซส์ใหญ่สำหรับผู้ชาย เสื้อคลุมสำหรับโค้ช ศิลปะการต่อสู้ เทควันโด ชุดฝึกซ้อมฤดูหนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se048378b1c07492294c6f7aeae8f701dt.jpg_200x200q90.jpg",
        "price": 2337.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5983206826.html",
        "sold": 0
    },
    {
        "product_name": "HAIGEMAN | เสื้อทีเชิ้ตคอตั้งประดับกลิตเตอร์สำหรับลดน้ำหนัก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3df756170e484642add2a6bb71c1f7c2I.jpg_200x200q90.jpg",
        "price": 2336.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5999841052.html",
        "sold": 2
    },
    {
        "product_name": "HAIGEMAN | เสื้อฟิตกระชับคลุมสะโพก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7e1ed790c5f54aa1ac43c34975ffce80S.jpg_200x200q90.jpg",
        "price": 2335.1,
        "remark": "https://www.lazada.co.th/products/pdp-i6029256278.html",
        "sold": 2
    },
    {
        "product_name": "WATERTIME | ชุดว่ายน้ำบอดี้สูทสำหรับเด็กชายกันแดด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3a6f5bbd42ef495f83ce42e0d9f9ab13M.jpg_200x200q90.jpg",
        "price": 2334.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5894958828.html",
        "sold": 3
    },
    {
        "product_name": "เสื้อปั่นจักรยานแขนยาวสำหรับผู้หญิง แบรนด์ Lanpa Da ผลิตจากผ้าโพลีเอสเตอร์ผสมสแปนเด็กซ์ ระบายเหงื่อได้ดี สีพื้น เหมาะสำหรับวิ่ง ปั่นจักรยาน และเล่นกีฬาในฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9ef1839f13754937b514a3fb08c1fdd1W.jpg_200x200q90.jpg",
        "price": 2331.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16096181990.html",
        "sold": 0
    },
    {
        "product_name": "INBIKE แจ็คเก็ตขี่จักรยานของผู้หญิงน้ำหนักเบามากจักรยานถนนเสื้อปั่นจักรยานกันลมกันลมและแจ็คเกตกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/43bd2dcf211e0a7a7c0e7df46fc4ca1d.jpg_200x200q90.jpg",
        "price": 2328,
        "remark": "https://www.lazada.co.th/products/pdp-i5392447191.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อสเวตเตอร์ครึ่งกระโปรงสไตล์ลำลองใหม่ ผ้าไหมน้ำแข็ง ลุคเลเยอร์ ฤดูใบไม้ผลิ 2025 แขนทรงเจ้าหญิง คอกลม เสื้อถักสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seb9af7d4508041709b611e40fc38b721W.jpg_200x200q90.jpg",
        "price": 2320.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16073629384.html",
        "sold": 0
    },
    {
        "product_name": "{SDGDFGR} ALO สปอร์ตบราของผู้หญิงชุดชั้นในเสื้อกั๊กสวมวิ่งด้านหลังสวยเสื้อผ้าโยคะ",
        "product_image": "https://img.lazcdn.com/g/p/e00b38d83462ae013cb59f2b084eaaa3.jpg_200x200q90.jpg",
        "price": 2319.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6014392012.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผู้หญิงสีพื้น ใส่สบายและมีสไตล์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sffd1fe31f2d74ca2b4b995005b96ee3bC.jpg_200x200q90.jpg",
        "price": 2318.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16118227659.html",
        "sold": 24
    },
    {
        "product_name": "TOSUOD | ชุดจักรยานสตรีสำหรับฤดูใบไม้ผลิ/ฤดูร้อน พร้อมเสื้อกันลม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8c49046390094178a377f3d2cb266bd0c.jpg_200x200q90.jpg",
        "price": 2302.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5892643107.html",
        "sold": 0
    },
    {
        "product_name": "{SDGDFGR} ALO โยคะเสื้อผ้ากีฬาชุดชั้นในสลิงออกกำลังกายชุดชั้นในวิ่งเสื้อกั๊ก",
        "product_image": "https://img.lazcdn.com/g/p/36a145e6aa746830e1d13ba85b5a8940.jpg_200x200q90.jpg",
        "price": 2301.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6014325432.html",
        "sold": 0
    },
    {
        "product_name": "ผู้หญิงเสื้อยืดจับจีบใหม่แขนสั้นหลวม",
        "product_image": "https://img.lazcdn.com/g/p/ac9297acc6cfbe7e013b82846ae26e9f.jpg_200x200q90.jpg",
        "price": 2300,
        "remark": "https://www.lazada.co.th/products/pdp-i16119736193.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดจีบทรงหลวมแฟชั่นใหม่สำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/8eb61b5dcbcdec35aa0e68fcae5fd7a0.jpg_200x200q90.jpg",
        "price": 2300,
        "remark": "https://www.lazada.co.th/products/pdp-i6022257481.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากอล์ฟเกาหลีรุ่นใหม่, กระเป๋าผ้าแคนวาส, กระเป๋าถือ, กระเป๋าใส่เสื้อผ้า, กระเป๋าสะพายไหล่และกระเป๋าสะพายข้าง",
        "product_image": "https://img.lazcdn.com/g/p/25cecff1903c17e939b723b3f628b480.jpg_200x200q90.jpg",
        "price": 2299.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16147230499.html",
        "sold": 0
    },
    {
        "product_name": "ROCKBROS Women Cycling Jersey Professional Ladies Road Bike Jersey Thin Breathable Lightweight Bicycle Top Short Sleeve Cycling Shirts",
        "product_image": "https://img.lazcdn.com/g/p/91e62bd7ebaa947a6371d78e61ff5be9.jpg_200x200q90.jpg",
        "price": 2296,
        "remark": "https://www.lazada.co.th/products/pdp-i5211667246.html",
        "sold": 31
    },
    {
        "product_name": "เสื้อแจ็กเก็ตกันหนาวสำหรับผู้หญิงเสื้อเสื้อผ้าสำหรับขี่จักรยานกันหนาวผ้าฟลีซแขนยาวจักรยานเสือภูเขาความร้อนสูงสุดสำหรับขี่จักรยานเสือหมอบ",
        "product_image": "https://img.lazcdn.com/g/p/d34aa938de5667d4338a9286b90a95ea.jpg_200x200q90.jpg",
        "price": 2296,
        "remark": "https://www.lazada.co.th/products/pdp-i5369998464.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดถัก VICTOR T-2602BAC สำหรับผู้ชายและผู้หญิง ทรงหลวม คอตั้ง แขนสั้น ระบายอากาศได้ดี ดูดซับเหงื่อ สำหรับผู้ชมกีฬา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc045b89053bb4a4da3a961757849c727e.jpg_200x200q90.jpg",
        "price": 2288,
        "remark": "https://www.lazada.co.th/products/pdp-i16091827471.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้าแบดมินตันระบายอากาศได้ แห้งไว สบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se1708fd7f79542ae9c1982ff5532baae9.jpg_200x200q90.jpg",
        "price": 2286,
        "remark": "https://www.lazada.co.th/products/pdp-i16118144820.html",
        "sold": 0
    },
    {
        "product_name": "แจ็คเก็ตกันลมมีฮู้ดสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc862889893e84bc2971512f41283cd04N.jpg_200x200q90.jpg",
        "price": 2286,
        "remark": "https://www.lazada.co.th/products/pdp-i16085531429.html",
        "sold": 0
    },
    {
        "product_name": "Alo 2025 Spring/Summer New Alo Three-Color Padded One-Piece Zipper Yoga Tank Top Sports Bra Running Vest",
        "product_image": "https://img.lazcdn.com/collect/cbu/img/ibank/O1CN01QB06z91G9EMuB4k8s_!!2218346900579-0-cib.jpg_200x200q90.jpg",
        "price": 2282.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6037029603.html",
        "sold": 0
    },
    {
        "product_name": "URBAN REVIVO เสื้อยืดแขนเสื้อแขนสั้นสำหรับผู้หญิงเสื้อพิมพ์ลายตัวอักษรกราฟิกเสื้อเสื่อทรงหลวมพอดีตัวลำลอง",
        "product_image": "https://img.lazcdn.com/g/tps/imgextra/i3/2104668892/O1CN016gWK9n2FYawo2Zs7O_!!2104668892.jpg_200x200q90.jpg",
        "price": 2280,
        "remark": "https://www.lazada.co.th/products/pdp-i16124836678.html",
        "sold": 0
    },
    {
        "product_name": "URBAN REVIVO เสื้อยืดแฟชั่นครอสดีไซน์เรียบง่ายและสง่างามสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/tps/imgextra/i3/2104668892/O1CN01t5lVsR2FYasdvgs2U_!!2104668892.jpg_200x200q90.jpg",
        "price": 2280,
        "remark": "https://www.lazada.co.th/products/pdp-i16100323236.html",
        "sold": 0
    },
    {
        "product_name": "PGA | เสื้อสปอร์ตแขนยาวคอตั้งสำหรับฤดูใบไม้ร่วงและฤดูหนาว ยืดหยุ่นได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdf685d5bc3044f10aba6a604188ea8e0Q.jpg_200x200q90.jpg",
        "price": 2278.9,
        "remark": "https://www.lazada.co.th/products/pdp-i6066376654.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเจอร์ซีย์ปั่นจักรยานเสือจักรยานผู้หญิง X-TIGER ผ้ากันลื่นกันความชื้นป้องกัน UV",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6e71ea777638486d960904dd4af8b494A.jpg_200x200q90.jpg",
        "price": 2278,
        "remark": "https://www.lazada.co.th/products/pdp-i16111683823.html",
        "sold": 0
    },
    {
        "product_name": "X-TIGER ผู้หญิงเสื้อเจอร์ซีย์นักปั่น SummerBreathable แห้งเร็ว3กระเป๋าด้านหลังเสื้อสำหรับปั่นจักรยานซิป SBS",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb4cb5279ce7044aa8447e377be91832dt.jpg_200x200q90.jpg",
        "price": 2278,
        "remark": "https://www.lazada.co.th/products/pdp-i16111840093.html",
        "sold": 0
    },
    {
        "product_name": "X-TIGER เสื้อเจอร์ซีย์นักปั่นผู้หญิงแขนสั้นพิมพ์ลายกันความร้อนมีกระเป๋า3ช่องใส่ของแบบแห้งเร็วป้องกันรังสียูวี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S12e90f1508bd4247a1f3824d7e64ac42C.jpg_200x200q90.jpg",
        "price": 2278,
        "remark": "https://www.lazada.co.th/products/pdp-i16111741547.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดพื้นฐานสไตล์ลำลองใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4ea7719b73d84f9fbecf4aece3603feau.jpg_200x200q90.jpg",
        "price": 2276.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16099193842.html",
        "sold": 0
    },
    {
        "product_name": "alo ชุดโยคะแขนยาวแห้งเร็วแบบใหม่จากยุโรปและอเมริกา สำหรับการวิ่งและฟิตเนส ระบายอากาศได้ดี ไม่มีรอยต่อ yoga เสื้อผ้า",
        "product_image": "https://img.lazcdn.com/g/p/e26168cd2ea8ca12f10952d922d7702c.jpg_200x200q90.jpg",
        "price": 2274.44,
        "remark": "https://www.lazada.co.th/products/pdp-i6014319268.html",
        "sold": 0
    },
    {
        "product_name": "X-TIGER เสื้อเจอร์ซีย์นักปั่นผู้หญิงป้องกัน UV แขนสั้นระบายอากาศได้ดีผ้า86% โพลีเอสเตอร์14% สแปนเด็กซ์3ช่องเก็บชายผ้ากันลื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf1e769da01c242e2b893b4d90672235e6.jpg_200x200q90.jpg",
        "price": 2274,
        "remark": "https://www.lazada.co.th/products/pdp-i16111738536.html",
        "sold": 0
    },
    {
        "product_name": "Golfist | เสื้อแขนกุดน้ำหนักเบาสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6695ab8597e94770b58655386d3484bfG.jpg_200x200q90.jpg",
        "price": 2270.9,
        "remark": "https://www.lazada.co.th/products/pdp-i6029006086.html",
        "sold": 0
    },
    {
        "product_name": "STK Small Town Kid | เสื้อยืดแขนยาวลายพิมพ์สกินสเนคแบบเรโทร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S330b631f3992467ea1bcfb0e1c03f706l.png_200x200q90.png",
        "price": 2270.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16080569785.html",
        "sold": 0
    },
    {
        "product_name": "STK Small Town Kid | เสื้อยืดแขนยาวสไตล์รีโทรปกอัลบั้ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd14d0db9f437454690aa8fd43c998028U.png_200x200q90.png",
        "price": 2270.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16084055060.html",
        "sold": 0
    },
    {
        "product_name": "ชุดโยคะแบบมีฟองน้ำ ด้านหลังเป็นลูกไม้ระบายอากาศได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S02a644d48a8041429ded585cbd4e63b3A.jpg_200x200q90.jpg",
        "price": 3962.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5909589220.html",
        "sold": 10
    },
    {
        "product_name": "YKYWBIKE พื้นฐานนักปั่นสตรีแขนสั้นเสื้อท่อนบนจักรยานระบายอากาศแห้งเร็ว",
        "product_image": "https://img.lazcdn.com/g/p/3efaabb8c7a9cfd3947a4ea294a44d50.jpg_200x200q90.jpg",
        "price": 2270,
        "remark": "https://www.lazada.co.th/products/pdp-i5715318406.html",
        "sold": 0
    },
    {
        "product_name": "PSO Brand | เสื้อยืดสกรีนลายสุนัข แห้งไว สีบล็อก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S054097ed1a2c4ac28b1c24341e8956f2B.png_200x200q90.png",
        "price": 2267.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6077025676.html",
        "sold": 7
    },
    {
        "product_name": "Golfist | เสื้อคลุมแบบเวสท์สำหรับผู้หญิง ฤดูใบไม้ผลิและใบไม้ร่วง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S863aed5c05b7466e8093aa37cd521374Y.jpg_200x200q90.jpg",
        "price": 2265.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6028104870.html",
        "sold": 0
    },
    {
        "product_name": "Beneunder | เสื้อยืดแขนยาวแห้งไวดูดซับความชื้นให้ความเย็นป้องกันรังสี UV สำหรับทั้งชายและหญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa1e415f32aa94baca6b6a59c98989c83J.jpg_200x200q90.jpg",
        "price": 2264,
        "remark": "https://www.lazada.co.th/products/pdp-i16111862394.html",
        "sold": 10
    },
    {
        "product_name": "INBIKE | เสื้อปั่นจักรยานสตรีแห้งไวระบายอากาศสำหรับฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5ebbfd897dae49d89a60227bc60ab55aM.jpg_200x200q90.jpg",
        "price": 2263.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5914404737.html",
        "sold": 10
    },
    {
        "product_name": "when.we.stretch - Flow Cardi Top เสื้อออกกำลังกายแขนยาวพร้อมฟองน้ำในตัว",
        "product_image": "https://img.lazcdn.com/g/p/65bbe35749f6435806a529f427bba08c.png_200x200q90.png",
        "price": 2262.66,
        "remark": "https://www.lazada.co.th/products/pdp-i5293059065.html",
        "sold": 78
    },
    {
        "product_name": "Oner Sports Bra Fitness Sling Beautiful Back Quick-drying Soft Vest Running Shockproof Spring And Summer Yoga Wear Sy",
        "product_image": "https://img.lazcdn.com/g/p/d28f975e89c438273f872985991d1e52.jpg_200x200q90.jpg",
        "price": 2262.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16069167538.html",
        "sold": 0
    },
    {
        "product_name": "Oneractive Sports Long-sleeved High-elastic Tight Yoga Tops High-quality Yoga Wear Trendy Brand Fitness Long-sleeved Sy",
        "product_image": "https://img.lazcdn.com/g/p/dd1f6c651db59ff01679ebd45be53aa3.jpg_200x200q90.jpg",
        "price": 2262.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16069139322.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเซ็ตแฟชั่นสไตล์ฝรั่งเศส กลิ่นอายฤดูใบไม้ร่วง-ฤดูหนาว ดีไซน์ใหม่ สวยสง่า น้ำหนักเบา ชุดสองชิ้น กระโปรงทรงเข้ารูป ช่วยพรางหุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd48ee88a18a844319e379f74851b21e49.jpg_200x200q90.jpg",
        "price": 2261.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16080489195.html",
        "sold": 0
    },
    {
        "product_name": "ANTA Kids  เสื้อกันหนาวชาย 3524C8715 Official Store",
        "product_image": "https://img.lazcdn.com/g/p/8bce67a0baf41f763f62625b7a98a679.jpg_200x200q90.jpg",
        "price": 2260,
        "remark": "https://www.lazada.co.th/products/pdp-i5580750180.html",
        "sold": 0
    },
    {
        "product_name": "BARREL KIDS  ชุดว่ายน้ำเด็ก เสื้อรัชการ์ด ชุดว่ายน้ำแขนยาว LONG SLEEVE RASHGUARD WHITE/BLACK -3WT002K_U4WTBK",
        "product_image": "https://img.lazcdn.com/g/p/ef5c40deb68b3f1779bc4bc8529d604d.jpg_200x200q90.jpg",
        "price": 2259.38,
        "remark": "https://www.lazada.co.th/products/pdp-i5281407456.html",
        "sold": 0
    },
    {
        "product_name": "aloyoga ชุดโยคะชุดชั้นในความแข็งแรงสูงกีฬากันกระแทกวิ่งฟิตเนสชุดชั้นในด้ายด้านบนเสื้อกั๊กหลังสวย",
        "product_image": "https://img.lazcdn.com/g/p/e4f0afdd621a7c3378ee9e4aa31ca8bf.jpg_webp_200x200q90.jpg",
        "price": 2258.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5496668671.html",
        "sold": 12
    },
    {
        "product_name": "izzue | เสื้อเชิ้ตลำลองสีพื้นทรงสลิมฟิตเบาสบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S441e045b84394b1c93cd3d5e5f66d30aX.jpg_200x200q90.jpg",
        "price": 2258.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16076027685.html",
        "sold": 0
    },
    {
        "product_name": "STK Small Town Kid | เสื้อยืดแขนยาวลายเรโทรกราเดียนที่พิมพ์แบบสั่งทำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb1f13b62049e42f79aaeba7a2cafbc14G.png_200x200q90.png",
        "price": 2257.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16084187986.html",
        "sold": 0
    },
    {
        "product_name": "angelseason | เสื้อยืดกีฬาคอปกป้อง UV สำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S78edf7448aab4a549b4236f9b968af55L.jpg_200x200q90.jpg",
        "price": 2257.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16103068544.html",
        "sold": 16
    },
    {
        "product_name": "Yonex | เสื้อฝึกซ้อมแขนสั้นสำหรับเด็กที่ระบายอากาศได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfb57d8e7fdff4fa9b2bb56ca126fa24dE.jpg_200x200q90.jpg",
        "price": 2257.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16093823813.html",
        "sold": 0
    },
    {
        "product_name": "INBIKE | เสื้อปั่นจักรยานแขนสั้นแห้งไวสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S965cb5f820fe401db5200538ccca7a66j.jpg_200x200q90.jpg",
        "price": 2256.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5914378683.html",
        "sold": 1
    },
    {
        "product_name": "when.we.stretch - Everyday Zip Crop Sweatshirt (-เฉพาะเสื้อ-) ผ้าใส่สบาย",
        "product_image": "https://img.lazcdn.com/g/p/1d77ff5b2ff3619fccdef361a8639d2f.png_200x200q90.png",
        "price": 2254.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5928933753.html",
        "sold": 0
    },
    {
        "product_name": "XIYUQI | เสื้อผู้หญิงแขนยาวสไตล์ฝรั่งเศส คอปีเตอร์แพนสำหรับฤดูใบไม้ร่วง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S520b1927188a47258ddb74c6b6ac8476h.jpg_200x200q90.jpg",
        "price": 2253.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16082529223.html",
        "sold": 0
    },
    {
        "product_name": "XIYUQI | เสื้อแขนยาวผู้หญิง ดีไซน์กระชับเอว สไตล์ทันสมัย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scd84585b7ffd4aa6b32ebd01b13c55892.jpg_200x200q90.jpg",
        "price": 2253.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16082392743.html",
        "sold": 0
    },
    {
        "product_name": "XIYUQI | เสื้อเชิ้ตสปริงสีเขียวหลวมสไตล์ทันสมัย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S52918af4ff4c440ea88430b14d4e0fa8c.jpg_200x200q90.jpg",
        "price": 2253.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16102947381.html",
        "sold": 0
    },
    {
        "product_name": "XIYUQI | เสื้อแขนยาวสไตล์เรียบง่ายสำหรับใส่พักผ่อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3b1da8ab15264d4e9f56eda870c4e2f9R.jpg_200x200q90.jpg",
        "price": 2253.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16079014769.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแขนยาวสำหรับเด็ก ซับเหงื่อแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc7a1b6e8633149da8eaca282720ec0ebt.jpg_200x200q90.jpg",
        "price": 2253.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16084621923.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผู้หญิงทรงเอวเข้ารูป ดีไซน์หรูหรา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbf2d78c5a8414834951e8606af7505dbS.jpg_200x200q90.jpg",
        "price": 2253.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16097752976.html",
        "sold": 0
    },
    {
        "product_name": "VIPHOME | ชุดนอนนุ่มๆ สำหรับผู้หญิงไซส์ใหญ่ วัสดุฟลีซ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S24aad299024542249f6528e039fa23129.jpg_200x200q90.jpg",
        "price": 2246.72,
        "remark": "https://www.lazada.co.th/products/pdp-i5935251556.html",
        "sold": 0
    },
    {
        "product_name": "SHANGSHA | เสื้อยืดสไตล์เกาหลีสีดำ Elegant Chic",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5351d82a72274a5a9fdd65bebf846f9d8.jpg_200x200q90.jpg",
        "price": 2244.24,
        "remark": "https://www.lazada.co.th/products/pdp-i6014470871.html",
        "sold": 18
    },
    {
        "product_name": "เสื้อกล้ามกีฬาซับเหงื่อ คูล น้ำหนักเบา รองรับการฝึกซ้อม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1d64b1daae72487b80d9a9e1154e5a9bF.jpg_200x200q90.jpg",
        "price": 2244,
        "remark": "https://www.lazada.co.th/products/pdp-i16085346850.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแขนยาวปั่นจักรยานผู้หญิงเสื้อระบายสำหรับปั่นจักรยานครีมกันแดดแห้งเร็วเหงื่อออกชุดดอกซากุระ",
        "product_image": "https://img.lazcdn.com/g/p/323a64236a3b5977cb7849243fc50401.jpg_200x200q90.jpg",
        "price": 2242,
        "remark": "https://www.lazada.co.th/products/pdp-i5357960419.html",
        "sold": 5
    },
    {
        "product_name": "ROCKBROS เสื้อปั่นจักรยานผู้หญิง,เสื้อเจอร์ซีย์นักปั่นยืดหยุ่นระบายอากาศได้ดีมีซิปเสื้อแขนยาวจักรยานเสือหมอบขี่จักรยานน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/8cf03c54b705aa3f43b74608ed96b5dd.jpg_200x200q90.jpg",
        "price": 2236,
        "remark": "https://www.lazada.co.th/products/pdp-i5353694798.html",
        "sold": 3
    },
    {
        "product_name": "WOSAWE | เสื้อกั๊กปั่นจักรยาน WOSAWE สำหรับฤดูใบไม้ร่วงและฤดูหนาว ผู้หญิง ผ้าฟลีซกันลม อุ่นสบาย เสื้อกั๊กจักรยานเสือภูเขา/เสือหมอบ มีกระเป๋า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd5907daaf49d4fde99722063084ca5a2w.jpg_200x200q90.jpg",
        "price": 2235.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16104516916.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแฟชั่นแนววัยรุ่นชายและเด็กโต",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa661164fafb644b5b170e033554a71770.jpg_200x200q90.jpg",
        "price": 2234,
        "remark": "https://www.lazada.co.th/products/pdp-i16085514394.html",
        "sold": 0
    },
    {
        "product_name": "TOSUOD | กางเกงปั่นจักรยานสตรีฤดูร้อน แบบไม่มีตะเข็บ พร้อมพ็อด 3/4",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S72aa60be68a94d5a9a95f586d88c9d691.jpg_200x200q90.jpg",
        "price": 2233.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5894965114.html",
        "sold": 2
    },
    {
        "product_name": "INBIKE | เสื้อปั่นจักรยานผู้หญิงระบายอากาศสำหรับฤดูใบไม้ผลิและฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa9cabacd725c471890e88c51ead814f94.jpg_200x200q90.jpg",
        "price": 2233.06,
        "remark": "https://www.lazada.co.th/products/pdp-i5914425150.html",
        "sold": 139
    },
    {
        "product_name": "เสื้อ XIOM TYRA SHIRT MINT",
        "product_image": "https://img.lazcdn.com/g/p/641d6626f63f4e2cce427e360672c97f.jpg_200x200q90.jpg",
        "price": 2230,
        "remark": "https://www.lazada.co.th/products/pdp-i5731173856.html",
        "sold": 0
    },
    {
        "product_name": "Rockbros |เสื้อปั่นจักรยานผู้หญิงน้ำหนักเบา ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sef6abf25212143a88eb36c14498bcf1aT.png_200x200q90.png",
        "price": 2229.82,
        "remark": "https://www.lazada.co.th/products/pdp-i6003035342.html",
        "sold": 0
    },
    {
        "product_name": "HOACON | เสื้อยืดลายขวางน่ารักสไตล์ฮ่องกงใส่สบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa9f892302463478ca02d94d34cbf4303T.jpg_200x200q90.jpg",
        "price": 2229,
        "remark": "https://www.lazada.co.th/products/pdp-i5927907201.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S52998db288374546bbfc32fba457319a3.jpg_200x200q90.jpg",
        "price": 7000,
        "remark": "https://www.lazada.co.th/products/pdp-i6022969403.html",
        "sold": 0
    },
    {
        "product_name": "PELICAN | กระเปาเดนทางแบบแขง Pelican AIR 1595WF (พรอมโฟม) สดำ รน Air Black Pelican Case",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8c4a1d9ff92c4c738cc801d2084cf16af.jpg_200x200q90.jpg",
        "price": 39116.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16076726282.html",
        "sold": 0
    },
    {
        "product_name": "COCCINELLE กระเป๋าถือผู้หญิง รุ่น SHELL HANDBAG 180201 สี PEARL",
        "product_image": "https://img.lazcdn.com/g/p/fd3d7e3097f9e550201bafdcc1731acb.jpg_200x200q90.jpg",
        "price": 37800,
        "remark": "https://www.lazada.co.th/products/pdp-i16050053879.html",
        "sold": 0
    },
    {
        "product_name": "COCCINELLE กระเป๋าถือผู้หญิง รุ่น DOUBLE BEAT HANDBAG 180201 สี SANDSHELL",
        "product_image": "https://img.lazcdn.com/g/p/7cc2a8124bb9b319a95a0621f6990b9f.jpg_200x200q90.jpg",
        "price": 37800,
        "remark": "https://www.lazada.co.th/products/pdp-i16050073863.html",
        "sold": 0
    },
    {
        "product_name": "สายสะพายไหล่แบบปรับได้กระเป๋าเป้ CHICIRIS สำหรับใต้น้ำ (4L",
        "product_image": "https://img.lazcdn.com/g/p/a02b735b5a088253d69de41b5dc8857c.jpg_200x200q90.jpg",
        "price": 37706,
        "remark": "https://www.lazada.co.th/products/pdp-i6058474806.html",
        "sold": 0
    },
    {
        "product_name": "Travel Board Bag for Efoils",
        "product_image": "https://img.lazcdn.com/g/p/5b80029ce92494ef8fe603b8fb7ffcf9.png_200x200q90.png",
        "price": 36000,
        "remark": "https://www.lazada.co.th/products/pdp-i5176320421.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟผู้หญิงสไตลใหม่ พร้อมล้อหมุนรอบทิศทาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3ba1811e532e48d2b36ddb72c56e1a78j.jpg_200x200q90.jpg",
        "price": 35734.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6073064169.html",
        "sold": 18
    },
    {
        "product_name": "COCCINELLE กระเป๋าถือผู้หญิง รุ่น C-ME TOP HANDLE BAG 180101 สี NOIR",
        "product_image": "https://img.lazcdn.com/g/p/f9b07a43058c79bdb0eb3d067af06a68.jpg_200x200q90.jpg",
        "price": 35000,
        "remark": "https://www.lazada.co.th/products/pdp-i5572578497.html",
        "sold": 0
    },
    {
        "product_name": "COCCINELLE กระเป๋าถือผู้หญิง รุ่น DOUBLE BEAT HANDBAG 180301 สี NOIR",
        "product_image": "https://img.lazcdn.com/g/p/f040f4c7fc06fcb5ee0a2d48d4418415.jpg_200x200q90.jpg",
        "price": 31800,
        "remark": "https://www.lazada.co.th/products/pdp-i5814307850.html",
        "sold": 0
    },
    {
        "product_name": "COCCINELLE กระเป๋าถือผู้หญิง รุ่น C-ME TOP HANDLE BAG 180201 สี SILVER",
        "product_image": "https://img.lazcdn.com/g/p/dc9ad455f576856ab55358e2d78e9153.jpg_200x200q90.jpg",
        "price": 31800,
        "remark": "https://www.lazada.co.th/products/pdp-i5585950039.html",
        "sold": 0
    },
    {
        "product_name": "Songmont | กระเป๋าถือทรงลูกโบว์ลิ่งสไตล์วินเทจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S68e860e3af454e27b085060aeabb895a8.jpg_200x200q90.jpg",
        "price": 29182,
        "remark": "https://www.lazada.co.th/products/pdp-i16144514613.html",
        "sold": 0
    },
    {
        "product_name": "COCCINELLE กระเป๋าถือผู้หญิง รุ่น MAVERY HANDBAG 180201 สี CRAB",
        "product_image": "https://img.lazcdn.com/g/p/a6d43848bcd66fbd894bae0daf68f58e.jpg_200x200q90.jpg",
        "price": 29000,
        "remark": "https://www.lazada.co.th/products/pdp-i16050524362.html",
        "sold": 0
    },
    {
        "product_name": "COCCINELLE กระเป๋าถือผู้หญิง รุ่น C-ME TOP HANDLE BAG 180201 สี NOIR",
        "product_image": "https://img.lazcdn.com/g/p/c125da9d1672898b0dc567062eca1a2c.png_200x200q90.png",
        "price": 29000,
        "remark": "https://www.lazada.co.th/products/pdp-i5466313363.html",
        "sold": 2
    },
    {
        "product_name": "COCCINELLE กระเป๋าถือผู้หญิง รุ่น NIKLA HANDBAG 180201 สี SANDSHELL/SEAGRASS",
        "product_image": "https://img.lazcdn.com/g/p/8d738e00d62e21d2e0488e269c1fb70a.jpg_200x200q90.jpg",
        "price": 27800,
        "remark": "https://www.lazada.co.th/products/pdp-i16050215161.html",
        "sold": 0
    },
    {
        "product_name": "COCCINELLE กระเป๋าถือผู้หญิง รุ่น NIKLA HANDBAG 180201 สี SEAGRASS/SANDSHELL",
        "product_image": "https://img.lazcdn.com/g/p/e33e6cef401126b976a9f5dcaf2cf412.jpg_200x200q90.jpg",
        "price": 27800,
        "remark": "https://www.lazada.co.th/products/pdp-i16050213150.html",
        "sold": 0
    },
    {
        "product_name": "Pacsafe | เป้เดินทางกันน้ำ 35 ลิตร ป้องกันการโจรกรรม น้ำหนักเบา ทนทาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S24579a946f6548978ccbd33cd363a380l.png_200x200q90.png",
        "price": 27277.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16049359155.html",
        "sold": 0
    },
    {
        "product_name": "ถุงกอล์ฟ OMNIX GOLF Cart Bag",
        "product_image": "https://img.lazcdn.com/g/p/a65f1a7df11e9af0ecbc7703d37e4c16.jpg_200x200q90.jpg",
        "price": 26400,
        "remark": "https://www.lazada.co.th/products/pdp-i4697643799.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาถอผหญง กระเปาสะพายไหล กระเปาทำงาน กระเปาชอปปง กระเปาธรกจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd5400c3016b9406a846766a72beccdd7y.png_200x200q90.png",
        "price": 26218.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16121704090.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd20b9ec4dcb44c8eba56edd6a9619fc1H.jpg_200x200q90.jpg",
        "price": 23912.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16127524094.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋าเดินทางสำหรับกอล์ฟแบบแข็งใสพร้อมล้อหมุน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S21fd86b06f6149ab901aaa43e1b0e6f8P.jpg_200x200q90.jpg",
        "price": 23713.88,
        "remark": "https://www.lazada.co.th/products/pdp-i6072715763.html",
        "sold": 7
    },
    {
        "product_name": "SUREN | กระเป๋าถือสปริงนุ่มหรูหรา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S77151d89e5a44d2db5be43ca5b2a9477u.jpg_200x200q90.jpg",
        "price": 22757.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16061289449.html",
        "sold": 6
    },
    {
        "product_name": "Love Moschino | กระเป๋าถือแบบปิดด้วยกระดุม มีโลโก้เมทัล วัสดุ PU",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3e089141c7bd4df3916eef584c7a24daj.jpg_200x200q90.jpg",
        "price": 22454,
        "remark": "https://www.lazada.co.th/products/pdp-i16144550610.html",
        "sold": 0
    },
    {
        "product_name": "PING BAG PIONEER 244 PING CART BAG ถุงกอล์ฟ",
        "product_image": "https://img.lazcdn.com/g/p/779ede464a64edab5ed069206ab9411f.jpg_200x200q90.jpg",
        "price": 22240,
        "remark": "https://www.lazada.co.th/products/pdp-i5499435025.html",
        "sold": 0
    },
    {
        "product_name": "ถุงกอล์ฟ Taylormade 2024 Model TaylorMade Golf UN113 Circle T Light Caddy Bag",
        "product_image": "https://img.lazcdn.com/g/p/7aced03883d9e9cc58c2a730f6d525cf.jpg_200x200q90.jpg",
        "price": 21800,
        "remark": "https://www.lazada.co.th/products/pdp-i5246835837.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋าถือ Coach ของแท้ มือ 1 รุ่นหรูที่สุด หนังแท้ หนังนิ่ม มีสายยาว สีสวยหายาก ไซส์ใหญ่ มีหมุดที่ฐาน COACH 35796 SWAGGER 32 IN PEBBLE LEATHER BAG PUCE สีชมพู",
        "product_image": "https://img.lazcdn.com/g/p/a8ad46a8a28f4ee44db2cc7f3474e7d0.jpg_200x200q90.jpg",
        "price": 21800,
        "remark": "https://www.lazada.co.th/products/pdp-i3133409.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ47 81 108ลิตร – 47L 81L 108L BA02X Roller Bag 24' แบรนด์ TUSA",
        "product_image": "https://img.lazcdn.com/g/p/e22c0afe8b488adf65b41201a52229a3.png_200x200q90.png",
        "price": 21800,
        "remark": "https://www.lazada.co.th/products/pdp-i5270230391.html",
        "sold": 0
    },
    {
        "product_name": "TUMI กระเป๋าสะพายข้าง TYLER CROSSBODY",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S78ef1585ec18411dafbbadbc1b549af7v.jpg_200x200q90.jpg",
        "price": 21600,
        "remark": "https://www.lazada.co.th/products/pdp-i4954475903.html",
        "sold": 4
    },
    {
        "product_name": "ถุงกอล์ฟ Big Max Dri Lite Hybrid Prime - White สินค้าใหม่ แท้ 100%",
        "product_image": "https://img.lazcdn.com/g/p/1187bf2c2e94d6894eb0893fe605150e.jpg_200x200q90.jpg",
        "price": 20800,
        "remark": "https://www.lazada.co.th/products/pdp-i5045837128.html",
        "sold": 0
    },
    {
        "product_name": "ส่งด่วน Scubapro Sport Bag 125 Gear Bag, dive bag - กระเป๋าใส่อุปกรณ์ดำน้ำ กระเป๋าสะพายมีล้อลาก",
        "product_image": "https://img.lazcdn.com/g/p/d7786bc43a48bd5eab267e3210ea7471.jpg_200x200q90.jpg",
        "price": 20090,
        "remark": "https://www.lazada.co.th/products/pdp-i5622524563.html",
        "sold": 0
    },
    {
        "product_name": "ซองกันน้ำสงกรานต์ ซองมือถือสงกรานต์ วันสงกานต์ ลายน่ารัก รุ่นใหญ่ใส่ได้ค่ะ ยกโหล12ชิ้นคล่ะลาย คล่ะสี #ซองกันน้ำสงกรานต์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se7a1953b10ad48deb8a548e03b37a9c5D.jpg_200x200q90.jpg",
        "price": 19998,
        "remark": "https://www.lazada.co.th/products/pdp-i4572030827.html",
        "sold": 10
    },
    {
        "product_name": "🧳✨ Aqualung Explorer II Roller Gear Bag, dive bag - กระเป๋าใส่อุปกรณ์ดำน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/711d1fad29d381b703a21c353e54e121.jpg_200x200q90.jpg",
        "price": 19940,
        "remark": "https://www.lazada.co.th/products/pdp-i5311422193.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสตางค์รูปจมูกหมูสไตล์ยุโรปหรูหราหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf7ef9b27cd8c4cb88ffaad79631dd6b4o.png_200x200q90.png",
        "price": 19697.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6066701453.html",
        "sold": 0
    },
    {
        "product_name": "COCCINELLE กระเป๋าถือผู้หญิง รุ่น C-ME TOP HANDLE BAG 180401 สี SKIN",
        "product_image": "https://img.lazcdn.com/g/p/8e8722e46183c1ea830816851421a85a.jpg_200x200q90.jpg",
        "price": 19460,
        "remark": "https://www.lazada.co.th/products/pdp-i5572531617.html",
        "sold": 1
    },
    {
        "product_name": "Scubapro Dive’N Roll Bag กระเป๋าเดินทาง เกียร์แบ็คล้อลาก กระเป๋าอุปกรณ์ดำน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/88257fc61b89d0ff68e6c07a0cccb7ed.jpg_200x200q90.jpg",
        "price": 19380,
        "remark": "https://www.lazada.co.th/products/pdp-i4900519441.html",
        "sold": 0
    },
    {
        "product_name": "Titleist Players 5 StaDry Golf Stand Bag - ถุงกอล์ฟ กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/2fb448bef1ba764c112bc53bd356d650.png_200x200q90.png",
        "price": 19360,
        "remark": "https://www.lazada.co.th/products/pdp-i4668177792.html",
        "sold": 25
    },
    {
        "product_name": "Coach กระเป๋าสะพายข้าง 91016 LILLIE CARRYALL IN COLORBLOCK SIGNATURE CANVAS (IME7V) Color: IM/KHAKI MULTI ของแท้ 💯%",
        "product_image": "https://img.lazcdn.com/g/p/2eb44a6fb02f58d2664d5a3f0ed2fb75.jpg_200x200q90.jpg",
        "price": 19180,
        "remark": "https://www.lazada.co.th/products/pdp-i5745889793.html",
        "sold": 0
    },
    {
        "product_name": "PING BAG TRAVERSE 244 PING CART BAG ถุงกอล์ฟ",
        "product_image": "https://img.lazcdn.com/g/p/6beba199744ba1e37131e1c07eff0dfd.jpg_200x200q90.jpg",
        "price": 19040,
        "remark": "https://www.lazada.co.th/products/pdp-i5493361061.html",
        "sold": 2
    },
    {
        "product_name": "PING BAG HOOFER 231 PING CARRY BAG ถุงกอล์ฟ",
        "product_image": "https://img.lazcdn.com/g/p/6e5148ef7a5b675311cddf75acacf7de.jpg_200x200q90.jpg",
        "price": 19040,
        "remark": "https://www.lazada.co.th/products/pdp-i4451538009.html",
        "sold": 5
    },
    {
        "product_name": "SHIPAILUO | กระเป๋าถือแฟชั่นความจุสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S44b171c9c77341eba00c3a60df6677b9z.jpg_200x200q90.jpg",
        "price": 18250.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6079587601.html",
        "sold": 1
    },
    {
        "product_name": "Songmont กระเป๋าทรงหยดน้ำขนาดเล็ก,กระเป๋าสะพายไหล่สำหรับผู้หญิงหนังแท้ลายไม้",
        "product_image": "https://img.lazcdn.com/g/p/b344e51398265ae989a5b80a44ef9a70.jpg_200x200q90.jpg",
        "price": 20400,
        "remark": "https://www.lazada.co.th/products/pdp-i5719465346.html",
        "sold": 121
    },
    {
        "product_name": "VERAFIED | กระเป๋าหนังสะพายข้างสไตล์หรูหรา รุ่น VERAIFIED HOBO",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd03f927c76a3437f9ce6838000bbcef9X.png_200x200q90.png",
        "price": 18210.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5845905806.html",
        "sold": 16
    },
    {
        "product_name": "Ostrich กระเป๋าใส่จักรยาน Alex Mouton Made in Japan",
        "product_image": "https://img.lazcdn.com/g/p/497627e1610c7136b9b6e39020487b20.jpg_200x200q90.jpg",
        "price": 18000,
        "remark": "https://www.lazada.co.th/products/pdp-i4135212528.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน สมิธ Smith  ลูกโม่ 5นิ้ว - 6นิ้ว  มีช่องใส่ลูก 2แถว .38 357 9มม   ไม่มีช่อง ใส่เอกสาร  ( 5ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7d6efa6500174fcc8b1dedc531f344e27.jpg_200x200q90.jpg",
        "price": 17900,
        "remark": "https://www.lazada.co.th/products/pdp-i5182148279.html",
        "sold": 0
    },
    {
        "product_name": "ถุงกอล์ฟ Big Max Dri Lite Hybrid Plus 2024",
        "product_image": "https://img.lazcdn.com/g/p/1b9c1197ae624efc53c663f841c41049.jpg_200x200q90.jpg",
        "price": 17800,
        "remark": "https://www.lazada.co.th/products/pdp-i5042798013.html",
        "sold": 6
    },
    {
        "product_name": "Titleist Players 4 StaDry Golf Stand Bag - ถุงกอล์ฟ กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/bbed144d783d3adc798ae25ba9b5cf12.jpg_200x200q90.jpg",
        "price": 17632,
        "remark": "https://www.lazada.co.th/products/pdp-i4668244231.html",
        "sold": 4
    },
    {
        "product_name": "COCCINELLE กระเป๋าถือผู้หญิง รุ่น NEW NEVER WITHOUT BAG TOP HANDLE BAG 180501 สี MULTI NOIR/NOIR",
        "product_image": "https://img.lazcdn.com/g/p/3143ca3c703ebb641476894ffbf1fca2.jpg_200x200q90.jpg",
        "price": 17500,
        "remark": "https://www.lazada.co.th/products/pdp-i5609287430.html",
        "sold": 0
    },
    {
        "product_name": "COCCINELLE กระเป๋าถือผู้หญิง รุ่น C-ME TOP HANDLE BAG 180201 สี ROSETTE",
        "product_image": "https://img.lazcdn.com/g/p/28aa8e618dcb7c69780fa5aae0582f63.jpg_200x200q90.jpg",
        "price": 17400,
        "remark": "https://www.lazada.co.th/products/pdp-i5609204773.html",
        "sold": 0
    },
    {
        "product_name": "COCCINELLE กระเป๋าถือผู้หญิง รุ่น C-ME TOP HANDLE BAG 180201 สี ROSETTE/SKIN",
        "product_image": "https://img.lazcdn.com/g/p/735ccb1eeecb8e023b4caf43a0367f90.jpg_200x200q90.jpg",
        "price": 17400,
        "remark": "https://www.lazada.co.th/products/pdp-i5609220624.html",
        "sold": 0
    },
    {
        "product_name": "COCCINELLE กระเป๋าถือผู้หญิง รุ่น C-ME TOP HANDLE BAG 180201 สี SKIN",
        "product_image": "https://img.lazcdn.com/g/p/13a84916703a49927351c1f7cc500b5f.jpg_200x200q90.jpg",
        "price": 17400,
        "remark": "https://www.lazada.co.th/products/pdp-i5572703151.html",
        "sold": 1
    },
    {
        "product_name": "COCCINELLE กระเป๋าถือผู้หญิง รุ่น C-ME TOP HANDLE BAG 180201 สี MIDNIGHT BLUE/BLANCO",
        "product_image": "https://img.lazcdn.com/g/p/277c80a1c4bbe6d599f2a0e99897bca5.jpg_200x200q90.jpg",
        "price": 17400,
        "remark": "https://www.lazada.co.th/products/pdp-i5609416021.html",
        "sold": 1
    },
    {
        "product_name": "ที่ใส่ปลากระเป๋าเก็บความเย็นคายัคทนทานกันรั่วซึมมีซิปปิดภาชนะใส่ปลา",
        "product_image": "https://img.lazcdn.com/g/p/a6b7fdcfe1a083d1b8b35b0e7817fa5b.jpg_200x200q90.jpg",
        "price": 17338,
        "remark": "https://www.lazada.co.th/products/pdp-i16136053982.html",
        "sold": 0
    },
    {
        "product_name": "ทาฮิดะเรือคายัคปลากระเป๋าเก็บความเย็น Peralatan Pancing มืออาชีพเก็บอุณหภูมิแบบพกพากันรั่ว",
        "product_image": "https://img.lazcdn.com/g/p/317c732379acf069234de15218234a1a.jpg_200x200q90.jpg",
        "price": 17338,
        "remark": "https://www.lazada.co.th/products/pdp-i16136664843.html",
        "sold": 0
    },
    {
        "product_name": "Futoys ความจุมากกระเป๋าเก็บความเย็นปลาคายัคแบบมีซิปปิดแบบพกพา",
        "product_image": "https://img.lazcdn.com/g/p/ce0ce2278ae78f4e2587b03557e6caf4.jpg_200x200q90.jpg",
        "price": 17338,
        "remark": "https://www.lazada.co.th/products/pdp-i16136829088.html",
        "sold": 0
    },
    {
        "product_name": "Beatycare เรือคายัคอุปกรณ์ตกปลากระเป๋าเก็บความเย็นปลาความจุมากพรีเมี่ยมแบบพกพา",
        "product_image": "https://img.lazcdn.com/g/p/ceea4edcc6c7c467c90f5b1ff941cef9.jpg_200x200q90.jpg",
        "price": 17338,
        "remark": "https://www.lazada.co.th/products/pdp-i16136573391.html",
        "sold": 0
    },
    {
        "product_name": "Gazechimp อุปกรณ์กระเป๋าเก็บความเย็นปลาคายัคทนทานต่อการใช้งานความจุมาก",
        "product_image": "https://img.lazcdn.com/g/p/7f73d980d2b463714bf27fa9c5a35762.jpg_200x200q90.jpg",
        "price": 17338,
        "remark": "https://www.lazada.co.th/products/pdp-i16136983482.html",
        "sold": 0
    },
    {
        "product_name": "เรือคายัคจรวดดวงจันทร์กระเป๋าเก็บความเย็นความทนทาน Peralatan Pancing อุปกรณ์ตกปลาฉนวน",
        "product_image": "https://img.lazcdn.com/g/p/61cbeaf42a5a382b163f6dfceaf815c6.jpg_200x200q90.jpg",
        "price": 17338,
        "remark": "https://www.lazada.co.th/products/pdp-i16136684419.html",
        "sold": 0
    },
    {
        "product_name": "ที่ใส่ปลากระเป๋าเก็บความเย็นเรือคายัคทนทานต่อการรั่วซึมมีซิปปิด",
        "product_image": "https://img.lazcdn.com/g/p/42e44441432f51e20cdadeb170882334.jpg_200x200q90.jpg",
        "price": 17338,
        "remark": "https://www.lazada.co.th/products/pdp-i16136488900.html",
        "sold": 0
    },
    {
        "product_name": "Goyan กระเป๋าเก็บความเย็นคายัคทนทานต่อการรั่วซึมของความจุมาก",
        "product_image": "https://img.lazcdn.com/g/p/2b5e00434d3cc9c1e79ac3c01c67ac78.jpg_200x200q90.jpg",
        "price": 17338,
        "remark": "https://www.lazada.co.th/products/pdp-i16137198130.html",
        "sold": 0
    },
    {
        "product_name": "WDEarth เรือคายัคปลากระเป๋าเก็บความเย็นความทนทาน Peralatan Pancing อุปกรณ์ตกปลาฉนวน",
        "product_image": "https://img.lazcdn.com/g/p/1270109d730a1f35eba13db0489b8365.jpg_200x200q90.jpg",
        "price": 17338,
        "remark": "https://www.lazada.co.th/products/pdp-i16136403878.html",
        "sold": 0
    },
    {
        "product_name": "Peralatan Pancing กระเป๋าเก็บความเย็นปลาพายเรือคายัคแบบมีซิปความจุมากพรีเมี่ยม",
        "product_image": "https://img.lazcdn.com/g/p/54924fce0fedc5e3f028b9f5ab380299.jpg_200x200q90.jpg",
        "price": 17338,
        "remark": "https://www.lazada.co.th/products/pdp-i16134632964.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าซิปพรีเมี่ยมสำหรับกระเป๋าเก็บความเย็นปลาเรือคายัคพระจันทร์แบบพกพากันรั่ว",
        "product_image": "https://img.lazcdn.com/g/p/b9f339bf3d8d4f8bcd0bf57d09075e06.jpg_200x200q90.jpg",
        "price": 17338,
        "remark": "https://www.lazada.co.th/products/pdp-i16137447821.html",
        "sold": 0
    },
    {
        "product_name": "Pacsafe | เป้สะพายหลังกันน้ำ ป้องกันการโจรกรรม ตัดไม่ขาด สำหรับเดินทางธุรกิจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se13f06f9e11347a1a21c780d341fe145n.jpg_200x200q90.jpg",
        "price": 17072.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16049358031.html",
        "sold": 0
    },
    {
        "product_name": "Titleist Aspirer Golf Cart Bag - ถุงกอล์ฟ",
        "product_image": "https://img.lazcdn.com/g/p/7e82bd6cbc26ace08b8ffbdb740d38d6.jpg_200x200q90.jpg",
        "price": 16950,
        "remark": "https://www.lazada.co.th/products/pdp-i4668256217.html",
        "sold": 15
    },
    {
        "product_name": "COCCINELLE กระเป๋าถือผู้หญิง รุ่น C-ME TOP HANDLE BAG 180401 สี ROSETTE",
        "product_image": "https://img.lazcdn.com/g/p/a65bef34cca064eb4d41602bd8694b20.jpg_200x200q90.jpg",
        "price": 16680,
        "remark": "https://www.lazada.co.th/products/pdp-i5609273449.html",
        "sold": 0
    },
    {
        "product_name": "CCAngel กระเป๋าเก็บความเย็นปลาคายัคทนทานกันรั่วซึมมีซิปปิดภาชนะใส่ปลา",
        "product_image": "https://img.lazcdn.com/g/p/3a3c8e01597c3f6e072ebd3fb429571d.jpg_200x200q90.jpg",
        "price": 16592.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16136806070.html",
        "sold": 0
    },
    {
        "product_name": "อุปกรณ์กระเป๋าเก็บความเย็นปลาเรือคายัคแบบไลฟ์ทนทานภาชนะปลาใช้ได้จริง",
        "product_image": "https://img.lazcdn.com/g/p/9a4fa54fb28a811f406c132506a9a5ce.jpg_200x200q90.jpg",
        "price": 16592.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16137052483.html",
        "sold": 0
    },
    {
        "product_name": "เบนน์ซิปปิดเรือคายัคปลากระเป๋าเก็บความเย็น Peralatan Pancing กันรั่ว",
        "product_image": "https://img.lazcdn.com/g/p/700882721982e8afa732f28bd9cac7a7.jpg_200x200q90.jpg",
        "price": 16592.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16136815772.html",
        "sold": 0
    },
    {
        "product_name": "Sunniiee เรือคายัคดูปลากระเป๋าเก็บความเย็นกันรั่วซึมทนทานซิปปิดภาชนะใส่ปลา",
        "product_image": "https://img.lazcdn.com/g/p/200e7196a7aa6940b46d88eb8c230f12.jpg_200x200q90.jpg",
        "price": 16592.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16136550823.html",
        "sold": 0
    },
    {
        "product_name": "Prasku กระเป๋าเก็บความเย็นปลาคายัคทนทานกันรั่วมีซิปปิดภาชนะใส่ปลา",
        "product_image": "https://img.lazcdn.com/g/p/aefd879d026998626c9f63acf55ff6d1.jpg_200x200q90.jpg",
        "price": 16592.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16136400838.html",
        "sold": 0
    },
    {
        "product_name": "ZYEarth กระเป๋าเก็บความเย็นปลาเรือคายัคทนทานต่อการรั่วซึมมีซิปปิดภาชนะใส่ปลา",
        "product_image": "https://img.lazcdn.com/g/p/f55051fe8ac547db4bb695214823b181.jpg_200x200q90.jpg",
        "price": 16592.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16136706228.html",
        "sold": 0
    },
    {
        "product_name": "Sharkskin Performance Dry Wheelie Bag 90L",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7bd0625282e64c9aa6ae408e8f456317O.png_200x200q90.png",
        "price": 14980,
        "remark": "https://www.lazada.co.th/products/pdp-i16111484866.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายข้าง COACH C8499 KATY SATCHEL IN SIGNATURE CANVASS (IME7V) Coach Outlet ของแท้ 💯%",
        "product_image": "https://img.lazcdn.com/g/p/df267bbaf061dc9c0f982eff4ade23a0.jpg_200x200q90.jpg",
        "price": 16180,
        "remark": "https://www.lazada.co.th/products/pdp-i5736548541.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายข้าง COACH C8287 ROWAN SATCHEL WITH SIGNATURE CANVAS DETAIL (IMR19) Coach Outlet ของแท้ 💯%",
        "product_image": "https://img.lazcdn.com/g/p/728016269c96735ffe6bd2a9e3028cde.jpg_200x200q90.jpg",
        "price": 16180,
        "remark": "https://www.lazada.co.th/products/pdp-i5736497758.html",
        "sold": 0
    },
    {
        "product_name": "ของแท้ 💯% กระเป๋าสะพายข้าง COACH C8499 KATY SATCHEL IN SIGNATURE CANVASS (IME7V)",
        "product_image": "https://img.lazcdn.com/g/p/39bcb02f17b64bca5e7767336794d086.jpg_200x200q90.jpg",
        "price": 16180,
        "remark": "https://www.lazada.co.th/products/pdp-i4329929600.html",
        "sold": 0
    },
    {
        "product_name": "ORTLIEB Back-Roller Classic กระเป๋าแพนเนียร์คู่หลัง  ความจุข้างละ 20 ลิตร (2ใบ)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5bc56a0a943545379fdf684ddb8163e1L.jpg_200x200q90.jpg",
        "price": 15980,
        "remark": "https://www.lazada.co.th/products/pdp-i2908716085.html",
        "sold": 0
    },
    {
        "product_name": "Cressi Tuna Bag กระเป๋าล้อลากใส่อุปกรณ์ดำน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/8924e740295bfb7111a6a16ebce112fb.png_200x200q90.png",
        "price": 15904,
        "remark": "https://www.lazada.co.th/products/pdp-i5067964587.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋า  เก็บกระสุน .38   9มม   357    ใส่ได้ 100นัด     ( 6 ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S790aa7a0d71c4db292adecedff532de03.jpg_200x200q90.jpg",
        "price": 15600,
        "remark": "https://www.lazada.co.th/products/pdp-i5250088305.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S83cf8e6de94c4a4ebf47581cf741b0e3F.jpg_200x200q90.jpg",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i5580631758.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า กระเป๋าใส่อุปกรณ์ดำน้ำ Cressi Tuna Bag",
        "product_image": "https://img.lazcdn.com/g/p/2af69524a852dfb1f889f83e19ae8623.jpg_200x200q90.jpg",
        "price": 15440,
        "remark": "https://www.lazada.co.th/products/pdp-i5622693154.html",
        "sold": 1
    },
    {
        "product_name": "Titleist Cart 14 StaDry Golf Bag - ถุงกอล์ฟ กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/64b3cf24325696291fd4ba402e8370f3.png_200x200q90.png",
        "price": 25160,
        "remark": "https://www.lazada.co.th/products/pdp-i5092190278.html",
        "sold": 25
    },
    {
        "product_name": "ซองปืน  กระเป๋าใส่ปืน   กระเป๋าปืน   ปืน  commando  คอมมานโด 8.6   ลูกซอง   (  3 ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf1940752c9d34111aac6e5ded4ddd7a0t.jpg_200x200q90.jpg",
        "price": 15000,
        "remark": "https://www.lazada.co.th/products/pdp-i4816510122.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า CRESSI Freezy SUP Dry Coolerbag, กระเป๋าเก็บความเย็นกันน้ำซิปปิดสนิท, สายรัดปรับได้เหมาะกับบอร์ด SUP, เก็บอุณหภูมิได้ 12 ชั่วโมง, ยูนิเซ็กส์ผู้ใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/7a5ef2e25d3820bd22256fcd52c6fbd4.jpg_200x200q90.jpg",
        "price": 14998,
        "remark": "https://www.lazada.co.th/products/pdp-i5832479710.html",
        "sold": 0
    },
    {
        "product_name": "Thermaltake TT100 Waterproof Backpack GEA-BAK-BBPBLK-01",
        "product_image": "https://img.lazcdn.com/g/p/daf5bfa1e04926aaeff61ec90895751a.jpg_200x200q90.jpg",
        "price": 14758,
        "remark": "https://www.lazada.co.th/products/pdp-i4615107634.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟพกพาเบา พร้อมที่จับไม้กอล์ฟแบบตรึง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2603e727ff294121948bd2a6c1e6d0ceX.jpg_200x200q90.jpg",
        "price": 14709.44,
        "remark": "https://www.lazada.co.th/products/pdp-i16055285757.html",
        "sold": 0
    },
    {
        "product_name": "New Golf Bag Golf Standard Bag Golf Bag Golf Bag Sports Fashion Club Bag",
        "product_image": "https://img.lazcdn.com/g/p/ff2df3cafbab8df0011913f107614315.png_200x200q90.png",
        "price": 14425.46,
        "remark": "https://www.lazada.co.th/products/pdp-i5850871803.html",
        "sold": 1
    },
    {
        "product_name": "SHARKSKIN PERFORMANCE DRY DUFFLE BAG 80L กระเป๋าใส่อุปกรณ์ดำน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/304486ec763c40b7d6b37135ceb670c8.png_200x200q90.png",
        "price": 14400,
        "remark": "https://www.lazada.co.th/products/pdp-i5374935029.html",
        "sold": 0
    },
    {
        "product_name": "Titleist Cart 14 Golf Bag - ถุงกอล์ฟ",
        "product_image": "https://img.lazcdn.com/g/p/0453b668eb856a1e2ad90a69d9793d9c.jpg_200x200q90.jpg",
        "price": 14048,
        "remark": "https://www.lazada.co.th/products/pdp-i4668252434.html",
        "sold": 62
    },
    {
        "product_name": "Titleist Players 4 Golf Stand Bag - ถุงกอล์ฟ",
        "product_image": "https://img.lazcdn.com/g/p/1b52b6232eb7d924f9b399bbce510142.png_200x200q90.png",
        "price": 14016,
        "remark": "https://www.lazada.co.th/products/pdp-i4668297100.html",
        "sold": 44
    },
    {
        "product_name": "Aristotle bag x haus of abbi - Abbi",
        "product_image": "https://img.lazcdn.com/g/p/61017af637fb1ec9d08f675246c84cd4.jpg_200x200q90.jpg",
        "price": 13980,
        "remark": "https://www.lazada.co.th/products/pdp-i4660150895.html",
        "sold": 0
    },
    {
        "product_name": "pgm | เคสแข็งป้องกันแรงสำหรับการเดินทางกอล์ฟ",
        "product_image": "https://img.lazcdn.com/3rd/q/aHR0cHM6Ly9hZS1waWMtYTEuYWxpZXhwcmVzcy1tZWRpYS5jb20va2YvUzA0YjA4MjA1N2IzYzRkNDFiMWNhOWZmZjc0YjFhNjc1ZS5wbmc=_200x200q90.png",
        "price": 13979.46,
        "remark": "https://www.lazada.co.th/products/pdp-i6066706617.html",
        "sold": 0
    },
    {
        "product_name": "MESH BAG ถุงตาข่ายยกของ สีฟ้าอมเขียว เชือกหนาพิเศษ 4 มิล ช่องตา 5x5 cm.พร้อมเชือกใยยักษ์ทำบ่วง4มุม ใช้งานได้ทันที",
        "product_image": "https://img.lazcdn.com/g/p/7061ff8b5c2f9d60a91d3c4ccdaf9751.jpg_200x200q90.jpg",
        "price": 13940,
        "remark": "https://www.lazada.co.th/products/pdp-i16123342073.html",
        "sold": 0
    },
    {
        "product_name": "[PGM GOLF] ถุงกอล์ฟแบบมีล้อ 5.8kg PGM QB153 Golf Standard Ball Bags Multi-Functional Soft Leather Invert the cue Aviation Pack",
        "product_image": "https://img.lazcdn.com/g/p/54e035888e4c4ff6b493fb54244d4b01.jpg_200x200q90.jpg",
        "price": 13920,
        "remark": "https://www.lazada.co.th/products/pdp-i5591587320.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเป้กันน้ำกลางแจ้งกระเป๋าดำน้ำสะพายหลังกระเป๋ากันน้ำกระเป๋าฟลิปเปอร์ ST",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S79fd038670c94b87a3e2c7c56ac8fb4al.jpg_200x200q90.jpg",
        "price": 13858,
        "remark": "https://www.lazada.co.th/products/pdp-i4877990535.html",
        "sold": 0
    },
    {
        "product_name": "SALOMON ADV SKIN 12 เป้น้ำ สำหรับวิ่งเทรล ความจุ 12ลิตร น้ำหนักเบา มีช่องเก็บของเยอะ มาพร้อมนกหวีดและขวดนิ่ม 2 ขวด",
        "product_image": "https://img.lazcdn.com/g/p/adc9d44549ebb1d770e2b1ae18009914.jpg_200x200q90.jpg",
        "price": 13780,
        "remark": "https://www.lazada.co.th/products/pdp-i6065332163.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่อุปกรณ์ดำน้ำ Fourth Element Expedition Series Duffel Bag",
        "product_image": "https://img.lazcdn.com/g/p/398c279612d64bf9d91612907a868383.png_200x200q90.png",
        "price": 13750,
        "remark": "https://www.lazada.co.th/products/pdp-i5418860792.html",
        "sold": 0
    },
    {
        "product_name": "⚡️NEW ARRIVAL⚡️กระเป๋า Abscent Bag รุ่น GRIND กระเป๋าเป้ กระเป๋ากระเป๋าเป้สะพายหลัง จุของได้เยอะ 28 ลิตร จากอเมริกา",
        "product_image": "https://img.lazcdn.com/g/p/261c77df7bd05b80ef2b8ab55bab5d87.jpg_200x200q90.jpg",
        "price": 13700,
        "remark": "https://www.lazada.co.th/products/pdp-i5421388696.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายข้าง COACH CA721 MINI GALLERY CROSSBODY IN SIGNATURE CANVAS (IMUOE) Coach Outlet ของแท้ 💯%",
        "product_image": "https://img.lazcdn.com/g/p/b4915794d3762b02bbe1603b21883013.jpg_200x200q90.jpg",
        "price": 13580,
        "remark": "https://www.lazada.co.th/products/pdp-i5736499886.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายข้าง COACH 2935 FLAP BELT BAG IN SIGNATURE CANVAS WITH BUTTERFLY APPLIQUE (IMR2L) Coach Outlet ของแท้ 💯%",
        "product_image": "https://img.lazcdn.com/g/p/f8726d64399575bcefbac09b4945bc8a.jpg_200x200q90.jpg",
        "price": 13580,
        "remark": "https://www.lazada.co.th/products/pdp-i5732571163.html",
        "sold": 0
    },
    {
        "product_name": "Coach กระเป๋าสะพายข้าง C2816 KARLEE CROSSBODY IN SIGNATURE CANVAS (IMD9S) ของแท้ 💯%",
        "product_image": "https://img.lazcdn.com/g/p/75a95c97e7b0451976b224575ec6b4ae.jpg_200x200q90.jpg",
        "price": 13580,
        "remark": "https://www.lazada.co.th/products/pdp-i5745830931.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟแบบมาตรฐานสำหรับทุกเพศ พร้อมขาตั้งกันกระแทก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S17132d8153304dfdbec0a021152597060.jpg_200x200q90.jpg",
        "price": 13182.08,
        "remark": "https://www.lazada.co.th/products/pdp-i6003239390.html",
        "sold": 21
    },
    {
        "product_name": "กระเป๋าใส่ปืน  cmmg  Derya  เดย่า  กระเป๋า หนัง สีดำ  พร้อม สายสะพาย ไหล่  ยาว  40นิ้ว   กว้าง 10นิ้ว   2ใบ    และ   สายสะพาย  1จุด   2เส้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9874f64c4032454c8fff580c38d74958N.jpg_200x200q90.jpg",
        "price": 13000,
        "remark": "https://www.lazada.co.th/products/pdp-i5184437821.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า  เก็บกระสุน .22  ใส่ได้ 200นัด   ( ด้านนอก เป็น ผ้า )   ( รวม  6ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se150327d4a6a44ef9f24cb2d67389f81t.jpg_200x200q90.jpg",
        "price": 12600,
        "remark": "https://www.lazada.co.th/products/pdp-i5250014627.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า เก็บกระสุน ลูกซอง เบอร์12  ใส่ได้ 50นัด    ( 6ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7921d836b86646b180bdbec04b0d77662.jpg_200x200q90.jpg",
        "price": 12600,
        "remark": "https://www.lazada.co.th/products/pdp-i5158357128.html",
        "sold": 0
    },
    {
        "product_name": "007 | เป้กันน้ำสำหรับเดินป่าและว่ายน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2624463a2b124569b0de0ed93edfce81H.jpg_200x200q90.jpg",
        "price": 12006.58,
        "remark": "https://www.lazada.co.th/products/pdp-i6001618356.html",
        "sold": 0
    },
    {
        "product_name": "Balikha อุปกรณ์จัดระเบียบเคสว่ายน้ำสำหรับผู้เริ่มต้นพกพาได้อุปกรณ์สำหรับผู้ใหญ่พร้อมสายรัดพาดไหล่ปรับได้กระเป๋าหิ้วไม้บิลเลียด",
        "product_image": "https://img.lazcdn.com/g/p/33ccaa07316c815800f20952e5a2f70c.jpg_200x200q90.jpg",
        "price": 11939.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16127098277.html",
        "sold": 0
    },
    {
        "product_name": "TRIBOND กระเป๋าเดินทางสำหรับการดำน้ำลึกพร้อมโครงที่แข็งแรงทนทานรุ่น SCD 90 L กันน้ำ จุได้เยอะ ส่งไว",
        "product_image": "https://img.lazcdn.com/g/p/97208d91ae4e7da0e062e4abacde1f7f.jpg_200x200q90.jpg",
        "price": 11900,
        "remark": "https://www.lazada.co.th/products/pdp-i4732589197.html",
        "sold": 0
    },
    {
        "product_name": "Coach กระเป๋าสะพายข้าง C3134 TRACK SMALL FLAP CROSSBODY IN SIGNATURE CANVAS(QBCHR) ของแท้ 💯%",
        "product_image": "https://img.lazcdn.com/g/p/8703f145d479e774c14f6513faa4dfed.jpg_200x200q90.jpg",
        "price": 11780,
        "remark": "https://www.lazada.co.th/products/pdp-i5745910762.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋าเดินทางสำหรับกอล์ฟป้องกันการชนและทนต่อแรงกระแทก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb19a5fd4ed094049aa296eb331a4a605f.jpg_200x200q90.jpg",
        "price": 11748.98,
        "remark": "https://www.lazada.co.th/products/pdp-i6072885437.html",
        "sold": 85
    },
    {
        "product_name": "Ortlieb กระเป๋าเป้สะพายหลังกันน้ำ Light Pack",
        "product_image": "https://img.lazcdn.com/g/p/19dd24219f2304fd52d5b4c7997e611d.jpg_200x200q90.jpg",
        "price": 11550,
        "remark": "https://www.lazada.co.th/products/pdp-i4864234566.html",
        "sold": 1
    },
    {
        "product_name": "Sharkskin Performance Backpack 30L",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd0e1c512d9fb433ab5ccad9fe4ce0a29T.png_200x200q90.png",
        "price": 11450,
        "remark": "https://www.lazada.co.th/products/pdp-i16054463285.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟกันน้ำเบาสุดๆ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S931ad623eb3044bcae7d9447c876fb8eI.jpg_200x200q90.jpg",
        "price": 11270.9,
        "remark": "https://www.lazada.co.th/products/pdp-i6003483784.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋าถือใบเล็กของผู้หญิง Coach Nnlita 19 สามารถใส่มือถือขนาด7.4นิ้วได้",
        "product_image": "https://img.lazcdn.com/g/p/491aa77592499fc92e8305a4debeb726.jpg_200x200q90.jpg",
        "price": 11180,
        "remark": "https://www.lazada.co.th/products/pdp-i5486899218.html",
        "sold": 0
    },
    {
        "product_name": "Gociy กระเป๋าเก็บบิลเลียดสำหรับเคสว่ายน้ำ,กระเป๋าหิ้วไม้บิลเลียด9หลุมสำหรับเล่นเกมกลางแจ้งที่ทันสมัย",
        "product_image": "https://img.lazcdn.com/g/p/04d1e0467531f59e4997c88ddba4bdbe.jpg_200x200q90.jpg",
        "price": 11016,
        "remark": "https://www.lazada.co.th/products/pdp-i16136887463.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าผ้ากันน้ำ SHAD TERRA REAR BAG TR50 ของแท้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa63781bdcf7e4770a5d58aa111702dc9I.jpg_200x200q90.jpg",
        "price": 11000,
        "remark": "https://www.lazada.co.th/products/pdp-i5464158210.html",
        "sold": 0
    },
    {
        "product_name": "Scuba-diving travel bag 90 L with rigid shell and wheels - black/blue",
        "product_image": "https://img.lazcdn.com/g/p/9a7eea102a3a329924ad3ba8e1eaa7f3.jpg_200x200q90.jpg",
        "price": 11000,
        "remark": "https://www.lazada.co.th/products/pdp-i5689396607.html",
        "sold": 0
    },
    {
        "product_name": "Cressi Gorilla Pro Bag กระเป๋าใส่อุปกรณ์ดำน้ำแบบกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/4181b0a234b2faeb911d2fa8247b3216.png_200x200q90.png",
        "price": 10908,
        "remark": "https://www.lazada.co.th/products/pdp-i16064792389.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า CRESSI Gorilla Pro Bag กระเป๋าดัฟเฟิลกันน้ำขนาดใหญ่ มีรุ่นพร้อมล้อหรือไม่มีล้อ วัสดุทนทาน ดีไซน์อิตาลี เหมาะกับอุปกรณ์ดำน้ำและตีนกบยาว",
        "product_image": "https://img.lazcdn.com/g/p/040036ab2f6c498053f267ee21fd963d.jpg_200x200q90.jpg",
        "price": 10908,
        "remark": "https://www.lazada.co.th/products/pdp-i5832563145.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟกันน้ำสำหรับผู้หญิง พร้อมช่องใส่รองเท้าและล้อใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1eff71142e124c7d8d697f07c05f8f1by.jpg_200x200q90.jpg",
        "price": 10904.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6073086020.html",
        "sold": 2
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟกันน้ำสำหรับสุภาพสตรี พร้อมที่แยกไม้กอล์ฟ 5 ช่อง และสายสะพายไหล่คู่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9d849f0194204437b67be81da44ca6024.jpg_200x200q90.jpg",
        "price": 10862.28,
        "remark": "https://www.lazada.co.th/products/pdp-i6003133281.html",
        "sold": 14
    },
    {
        "product_name": "กระเป๋าสะพายสองข้างกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbc1945fb1b7a4d6186baf476e7a506369.jpg_200x200q90.jpg",
        "price": 10820,
        "remark": "https://www.lazada.co.th/products/pdp-i16124153475.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าปืน   commando   คอมมานโด 8.6     1ชุด  ประกอบ ไปด้วย มี ดังนี้.........",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa0dc89413926443686bfd381c111860dH.jpg_200x200q90.jpg",
        "price": 9600,
        "remark": "https://www.lazada.co.th/products/pdp-i777900790.html",
        "sold": 0
    },
    {
        "product_name": "⚡️NEW ARRIVAL⚡️ Abscent Bag รุ่น Scout Roll Top กระเป๋าเป้ กระเป๋าเดินทาง กระเป๋าสะพายหลัง เก็บกลิ่น กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/167a4ec10f7e198cb050f7c1756f452a.jpg_200x200q90.jpg",
        "price": 10580,
        "remark": "https://www.lazada.co.th/products/pdp-i5421575105.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟมาตรฐานน้ำหนักเบาแบบม้วนได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sce3a41da4e564d24a60a6794bd80f3b2P.jpg_200x200q90.jpg",
        "price": 10572.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16053809715.html",
        "sold": 7
    },
    {
        "product_name": "กระเปาชอปปง กระเปาสะพายไหล กระเปาเดท กระเปาถอสำหรบคนทำงาน กระเปาสำหรบออกนอกบาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5611f357cd8341428d0549c4854f5cdfj.png_200x200q90.png",
        "price": 10103.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16099430819.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายข้างผ้าแคนวาสเบาๆ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4f8bfa10bd3a4021aa8e7a998d1588d5G.png_200x200q90.png",
        "price": 5156.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16105623959.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือแฟชั่นขนาดใหญ่ความจุมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8de8925025d747cf9301ad898156c3bdD.png_200x200q90.png",
        "price": 10401.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16120535624.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ Touratech Waterproof",
        "product_image": "https://img.lazcdn.com/g/p/947cf9e81ffe61d4242ae73eba0774eb.jpg_200x200q90.jpg",
        "price": 10400,
        "remark": "https://www.lazada.co.th/products/pdp-i5120199894.html",
        "sold": 1
    },
    {
        "product_name": "พร้อมส่ง🇺🇸 Bitty Bogg Bag (ขนาดเล็ก)  แบรนด์  bogg  จากอเมริกา กระเป๋าพลาสติกโฟม น้ำหนักเบา คล้ายยาง ไม่มีกลิ่นของแท้💯🇺🇸",
        "product_image": "https://img.lazcdn.com/us/lzd_seller_ai_business/seller/ai/d2ae47ac-f2f9-4acf-bb3d-d81664b32bc7.jpg_200x200q90.jpg",
        "price": 10400,
        "remark": "https://www.lazada.co.th/products/pdp-i5948397397.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาถอขนาดเลก กระเปาสะพายไหล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9cd3e139824942a8baef313152d8a501W.png_200x200q90.png",
        "price": 10130.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16119340553.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน   ลูกโม่ 2นิ้ว   สมิธ ชิพ  Smith    มีช่องใส่ลูก 2แถว   ไม่มีช่องใส่ เอกสาร   ช่องใส่ลูก สำหรับ  .38   357   9mm   9มม    กระเป๋า หนังสีดำ    (  5ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sadaa614c8c0c44a7bd52429c63059910l.jpg_200x200q90.jpg",
        "price": 10200,
        "remark": "https://www.lazada.co.th/products/pdp-i5181700511.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาหนงสะพายขาง กระเปาแฟชนลำลอง กระเปาชอปปงสนำตาล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdde764b1814f464f8cccd2ff07d634b43.png_200x200q90.png",
        "price": 10188.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16099451517.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟกันน้ำ พร้อมล้อเงียบและคันชักซ่อนได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1755241efbe4406f93795a98ed149b0d3.jpg_200x200q90.jpg",
        "price": 10177.44,
        "remark": "https://www.lazada.co.th/products/pdp-i6072679818.html",
        "sold": 10
    },
    {
        "product_name": "Ping | 2025 กระเปาสปอรต PL บอสตนแบค สดำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S118bca861b6b4db18e847384871d19f6T.png_200x200q90.png",
        "price": 10055.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16072909383.html",
        "sold": 0
    },
    {
        "product_name": "Stream Trail - Dry Tank 60L D2 Waterproof Backpack กระเป๋าเป้กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/6b7da638d6f415c686883a9b9b56bb17.jpg_200x200q90.jpg",
        "price": 10000,
        "remark": "https://www.lazada.co.th/products/pdp-i385332070.html",
        "sold": 4
    },
    {
        "product_name": "CRESSI Piovra Backpack for Free Diving Fins กระเป๋าใส่ฟินฟรีไดฟ์วิ่ง กระเป๋าใส่ฟินดำน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/171aa9ff692d5a59af941d5c52cd0b50.jpg_200x200q90.jpg",
        "price": 9996,
        "remark": "https://www.lazada.co.th/products/pdp-i5108926250.html",
        "sold": 0
    },
    {
        "product_name": "UD-RACE VEST 6L l UNISEXเป้น้ำ",
        "product_image": "https://img.lazcdn.com/g/p/3d7a5b1de09a35640aee200a70c21949.jpg_200x200q90.jpg",
        "price": 9900,
        "remark": "https://www.lazada.co.th/products/pdp-i5899747010.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าTouratech Waterproof Dry bag Adventure Rack-Pack ขนาด 89 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/869017a09d729b674835d23f0e4b6296.jpg_200x200q90.jpg",
        "price": 9900,
        "remark": "https://www.lazada.co.th/products/pdp-i5120288611.html",
        "sold": 0
    },
    {
        "product_name": "JW PEI | กระเป๋าถือผู้หญิงขนาดใหญ่แบบโปร่ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4194bd2adce947e7820262fe8b436eb5y.png_200x200q90.png",
        "price": 9891.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5926364479.html",
        "sold": 9
    },
    {
        "product_name": "กระเป๋าผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5c066159d5f14222ae0bb3ee1c610f3cT.jpg_200x200q90.jpg",
        "price": 9780,
        "remark": "https://www.lazada.co.th/products/pdp-i16083845795.html",
        "sold": 0
    },
    {
        "product_name": "ORTLIEB กระเป๋าเดินทางกันน้ำ K64 RACK-PACK XL 89L",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sed7569695a8a44fc8b1b37ef3de03b2eE.jpg_200x200q90.jpg",
        "price": 9700,
        "remark": "https://www.lazada.co.th/products/pdp-i5019201686.html",
        "sold": 0
    },
    {
        "product_name": "Aristotle bag - nylon bento + nylon strap พร้อมสายสะพาย",
        "product_image": "https://img.lazcdn.com/g/p/94d25ec807f01b749acc9ff1045ecf13.jpg_200x200q90.jpg",
        "price": 9700,
        "remark": "https://www.lazada.co.th/products/pdp-i4660161425.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋าใส่ปืน  cmmg  Derya  MK12 - 9.5 นิ้ว  /  Brigade 9mm AR9    กระเป๋า หนัง สีดำ    กระเป๋า พร้อม สายสะพาย ไหล่     กระเป๋า ยาว 76 เซน   กว้าง 28 เซน   (  2ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0711959ecbfb4b4c876f6edc8612b57cd.jpg_200x200q90.jpg",
        "price": 9600,
        "remark": "https://www.lazada.co.th/products/pdp-i4816552430.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน  cmmg  Derya  เดย่า  กระเป๋า หนัง สีดำ   กระเป๋า พร้อม สายสะพาย ไหล่   กระเป๋า ยาว 102 เซน กว้าง 26 เซน   ( 2ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf0bb267a1483400182c47d3f36d9baa9u.jpg_200x200q90.jpg",
        "price": 9600,
        "remark": "https://www.lazada.co.th/products/pdp-i5541125784.html",
        "sold": 0
    },
    {
        "product_name": "Rhinowalk | กระเป๋าข้างมอเตอร์ไซค์กันน้ำใช้ได้ทุกสภาพอากาศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S554bf322ad6a4947a605b1cdebfd627d6.jpg_200x200q90.jpg",
        "price": 9582.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5993381066.html",
        "sold": 4
    },
    {
        "product_name": "ถุงกอล์ฟสุภาพสตรี PGM จุของได้เยอะมาก (QB094) PGM Ladies microfiber golf stand bag สินค้ามีจำนวนจำกัด",
        "product_image": "https://img.lazcdn.com/g/p/8541ca1c28740ebf74e0a9dbe01bff16.jpg_200x200q90.jpg",
        "price": 9581.26,
        "remark": "https://www.lazada.co.th/products/pdp-i4496798641.html",
        "sold": 0
    },
    {
        "product_name": "PGY - P-CB-115 PGYTECH OneMo Lite Backpack 22L (Twilight Black) ประกันศูนย์ไทย 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/7108d49579b1aa2260742854ec5a3d7f.jpg_200x200q90.jpg",
        "price": 9520,
        "remark": "https://www.lazada.co.th/products/pdp-i4218620237.html",
        "sold": 1
    },
    {
        "product_name": "กระเปาแฟชน กระเปาสะพายขางผหญง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S22acaca8a6b14d1bb63bae4e8fd83bf0s.png_200x200q90.png",
        "price": 9455.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16099434810.html",
        "sold": 0
    },
    {
        "product_name": "(โกลดสไมล)กระเปาแฟชนลำลองรนใหม กระเปานกเรยนหญง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se7153de620654591b94e73c27022c89eu.png_200x200q90.png",
        "price": 9412.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16108208030.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเดินทางกันน้ำ ขนาด 90 ลิตร FEELFREE CRUISER 90L",
        "product_image": "https://img.lazcdn.com/g/p/7635a29c0d866f44f072f78c2d9df1d5.jpg_200x200q90.jpg",
        "price": 9360,
        "remark": "https://www.lazada.co.th/products/pdp-i2932498922.html",
        "sold": 0
    },
    {
        "product_name": "Ortlieb กระเป๋ากันน้ำ89ลิตร Rack-Pack 89L",
        "product_image": "https://img.lazcdn.com/g/p/6926f8e32dde86f721150a917d8b7f02.jpg_200x200q90.jpg",
        "price": 9360,
        "remark": "https://www.lazada.co.th/products/pdp-i4095952852.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋าใส่ปืน   กล็อก19   px4    กล็อก30    sig320    ( ใส่ได้ 2กระบอก )    พร้อม กระเป๋าใส่ลูก  2ใบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb3927aac81ff4e7aaeb4434f08589dc64.jpg_200x200q90.jpg",
        "price": 9300,
        "remark": "https://www.lazada.co.th/products/pdp-i5089798143.html",
        "sold": 0
    },
    {
        "product_name": "Rhinowalk | กระเป๋าใต้อานกันน้ำสำหรับทางไกล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1b77ae01882e49c2a8b98ddf616c99600.png_200x200q90.png",
        "price": 9280.9,
        "remark": "https://www.lazada.co.th/products/pdp-i6064380171.html",
        "sold": 0
    },
    {
        "product_name": "Ulight กระเป๋าครีบยาวกระเป๋าใส่อุปกรณ์ตกปลา,สายรัดพาดไหล่ปรับได้พร้อมซิปกระเป๋าเป้สะพายหลังยูทิลิตี้กระเป๋าเป้สะพายหลังตีนกบดำน้ำสำหรับตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/8e8158d28ffec56bd71d109e70a649fa.png_200x200q90.png",
        "price": 9196,
        "remark": "https://www.lazada.co.th/products/pdp-i16090710707.html",
        "sold": 0
    },
    {
        "product_name": "SALOMON ACTIVE SKIN 4 SET เป้น้ำสำหรับวิ่งเทรล ความจุ 4 ลิตร เน้นสบาย คล่องตัว น้ำหนักเบา ระบายอากาศดี แห้งเร็ว",
        "product_image": "https://img.lazcdn.com/g/p/30c8c71f5f851ee117f5b1a8be4f418f.jpg_200x200q90.jpg",
        "price": 9180,
        "remark": "https://www.lazada.co.th/products/pdp-i6071511349.html",
        "sold": 0
    },
    {
        "product_name": "PGM  | กระเป๋ากอล์ฟสำหรับผู้หญิง QB042+",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0410e4034bba48aba505b692418cf879q.jpg_200x200q90.jpg",
        "price": 9147.82,
        "remark": "https://www.lazada.co.th/products/pdp-i6072665810.html",
        "sold": 3
    },
    {
        "product_name": "กระเป๋าปืน  ยาว 76 เซน   กว้าง 28 เซน   1ใบ    และ  เข็มขัด ใส่ ลูกซอง เบอร์12   2อัน      และ  แถม สายสะพาย  3จุด  1อัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1fa26e97dae34692ada0af9caf30f630m.jpg_200x200q90.jpg",
        "price": 9100,
        "remark": "https://www.lazada.co.th/products/pdp-i5541769055.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าปืน   ยาว 102เซน   กว้าง  26เซน   1ใบ    และ  เข็มขัด ใส่ ลูกซอง เบอร์12   2อัน     และ  แถม สายสะพาย  3จุด  1อัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S62d07e2b0e794d819c71d3f68ca747c2L.jpg_200x200q90.jpg",
        "price": 9100,
        "remark": "https://www.lazada.co.th/products/pdp-i4703229247.html",
        "sold": 0
    },
    {
        "product_name": "ORTLIEB กระเป๋าเดินทางกันน้ำ RACK-PACK# L K63 BLACK 49L",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saeb0a09f1ba64a2eb57a38584badab234.jpg_200x200q90.jpg",
        "price": 9100,
        "remark": "https://www.lazada.co.th/products/pdp-i5019932740.html",
        "sold": 0
    },
    {
        "product_name": "CARLYN🇰🇷TWEE Backpack กระเป๋าถือสะพายเป้ ✨[พร้อมส่ง🔥] freeถุงกระดาษแบรนด์✨",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S748f0e4a36da4d32956d42370df43d3fr.jpg_200x200q90.jpg",
        "price": 9100,
        "remark": "https://www.lazada.co.th/products/pdp-i5060584184.html",
        "sold": 7
    },
    {
        "product_name": "คันเบ็ดตกปลาอลูมิเนียมอัลลอยน้ำหนักเบาพับเก็บได้คันเบ็ดตกปลาบินเดินป่ากลางแจ้งพร้อมกระเป๋า",
        "product_image": "https://img.lazcdn.com/g/p/df9b5295690ead9ef27aa73fd9bad022.jpg_200x200q90.jpg",
        "price": 9094,
        "remark": "https://www.lazada.co.th/products/pdp-i6004646865.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาผหญง กระเปานกเรยน กระเปาถอ กระเปาสะพายไหล สำหรบธรกจและคนทำงาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7bdc141e221b4d24a4a8f2ca10d6e92eX.png_200x200q90.png",
        "price": 8721.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16121349740.html",
        "sold": 0
    },
    {
        "product_name": "Arena | เป้พันธุ์หลายใช้งาน 55 ลิตร กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S04547568959c4e69b65d6ac324d266dea.jpg_200x200q90.jpg",
        "price": 9005.3,
        "remark": "https://www.lazada.co.th/products/pdp-i6041902779.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋าใส่ปืน  คอมมานโด8.6   พร้อม กระเป๋าเก็บ กระสุน ลูกซอง เบอร์12 ใส่ลูกได้ 50นัด  และ สายสะพาย ลูกซอง  มีช่องใส่ ลูกซอง  เบอร์12",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb77ff6f256d549b38556e7c842ee56a0T.jpg_200x200q90.jpg",
        "price": 5900,
        "remark": "https://www.lazada.co.th/products/pdp-i4833029179.html",
        "sold": 0
    },
    {
        "product_name": "Stream Trail-Stormy Backpacks MK2 Waterproof Bag 23L",
        "product_image": "https://img.lazcdn.com/g/p/316beb3e5f5c11aefd923ff88d418bf1.jpg_200x200q90.jpg",
        "price": 9000,
        "remark": "https://www.lazada.co.th/products/pdp-i5751476854.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าปืน คอมมานโด 8.6 1ใบ\n\nและ กระเป๋าเก็บ กระสุน ลูกซอง เบอร์12 ใส่ลูกได้ 50นัด  1ใบ\n\nและ สายสะพาย มีช่องใส่ ลูกซอง เบอร์12  1อัน\n \nและ เข็มขัด ลูกซอง เบอร์12  1อัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd8df16a71abc46dd925390cf3c6e0626e.jpg_200x200q90.jpg",
        "price": 9000,
        "remark": "https://www.lazada.co.th/products/pdp-i5986936761.html",
        "sold": 0
    },
    {
        "product_name": "Arena | เป้สะพายหลังกันน้ำแยกช่องแห้งและเปียก ความจุใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9947c5bd5322431e83b6224ef9309693K.jpg_200x200q90.jpg",
        "price": 8920.66,
        "remark": "https://www.lazada.co.th/products/pdp-i6014156192.html",
        "sold": 9
    },
    {
        "product_name": "Stream Trail - Dry Tank 40L D2 Waterproof Bag กระเป๋าเป้กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/78d816ceae9fd1106ff6bbea31023497.jpg_200x200q90.jpg",
        "price": 8900,
        "remark": "https://www.lazada.co.th/products/pdp-i377900409.html",
        "sold": 10
    },
    {
        "product_name": "Waterproof Bag กระเป๋ากันน้ำ Stream Trail รุ่น Roadster D2 (รุ่นนี้มีทั้งหมด 3 สีให้เลือก) แบรนด์กระเป๋ากันน้ำอันดับ 1 จากญี่ปุ่น",
        "product_image": "https://img.lazcdn.com/g/p/d2536b92fd43568ebcf79e9566ccf13d.jpg_200x200q90.jpg",
        "price": 8900,
        "remark": "https://www.lazada.co.th/products/pdp-i515890843.html",
        "sold": 2
    },
    {
        "product_name": "🧳✨ Aqualung Explorer II Duffle Pack Gear Bag, dive bag - กระเป๋าใส่อุปกรณ์ดำน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/083c2b06f6fc5bfb9fd76d55f296531c.jpg_200x200q90.jpg",
        "price": 8900,
        "remark": "https://www.lazada.co.th/products/pdp-i5313039773.html",
        "sold": 0
    },
    {
        "product_name": "Arena | เป้สำหรับว่ายน้ำและฟิตเนส ความจุใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa5bcabf9fbe24e99a6afefa7b439b0095.png_200x200q90.png",
        "price": 8878.34,
        "remark": "https://www.lazada.co.th/products/pdp-i6079476235.html",
        "sold": 2
    },
    {
        "product_name": "Speedo | เป้สะพายหลังใช้ได้ทั้งเปียกและแห้ง 45 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S31de2f5ee8114afabc594e3391527d61c.jpg_200x200q90.jpg",
        "price": 8860.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16099033845.html",
        "sold": 0
    },
    {
        "product_name": "[ New Arrival ] Brooklyn Works Waterproof Tote Bag กระเป๋า",
        "product_image": "https://img.lazcdn.com/us/lzd_seller_ai_business/seller/ai/5f6654ba-ae45-4e38-a5da-fb3f1f86b4fe.jpg_200x200q90.jpg",
        "price": 8750,
        "remark": "https://www.lazada.co.th/products/pdp-i5960159954.html",
        "sold": 0
    },
    {
        "product_name": "[สินค้าพร้อมจัดส่ง]⭐⭐Cookies cylinder bag size 49x26cm[สินค้าใหม่]จัดส่งฟรีมีบริการเก็บเงินปลายทาง⭐⭐",
        "product_image": "https://img.lazcdn.com/g/p/084444269340b981cdbd3439ed0f0e4d.jpg_200x200q90.jpg",
        "price": 8713.6,
        "remark": "https://www.lazada.co.th/products/pdp-i4355993124.html",
        "sold": 0
    },
    {
        "product_name": "🔥 สินค้าขายดี🔥👜✨ กระเป๋าทรง Cylinder (ทรงกระบอก) ลายโมโนแกรม ผสมหนัง ดีไซน์เก๋ หิ้วหรือสะพายได้ ✨👜💯 แท้ 100% จาก Factory 💯",
        "product_image": "https://img.lazcdn.com/g/p/461f0fae12c889734796f0b0b415f584.png_200x200q90.png",
        "price": 8700,
        "remark": "https://www.lazada.co.th/products/pdp-i5872932421.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าปืน   commando  คอมมานโด 8.6    1ชุด ประกอบ ไปด้วย มี ดังนี้.........",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6e3ba3d03910487b8d1abd3a40012102i.jpg_200x200q90.jpg",
        "price": 8700,
        "remark": "https://www.lazada.co.th/products/pdp-i777928632.html",
        "sold": 0
    },
    {
        "product_name": "Ortlieb กระเป๋าเป้สะพายหลังกันน้ำ 100% X-Plorer",
        "product_image": "https://img.lazcdn.com/g/p/43e0729c6ae04e93a4492e34974dfeab.jpg_200x200q90.jpg",
        "price": 8690,
        "remark": "https://www.lazada.co.th/products/pdp-i5384735964.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน    ลูกโม่ .22    ช่องใส่ลูก .22    ( 4 นิ้ว )   ( รวม  4 ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S149aceeca60a411fb463cc776423e061E.jpg_200x200q90.jpg",
        "price": 8660,
        "remark": "https://www.lazada.co.th/products/pdp-i4759299276.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน    ลูกโม่ .22    ช่องใส่ลูก .22    ( 3 นิ้ว )   ( รวม  4 ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S67f0883627bd48229e3d4f4733a3afa3Q.jpg_200x200q90.jpg",
        "price": 8660,
        "remark": "https://www.lazada.co.th/products/pdp-i4759174776.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน    ลูกโม่ .22    ช่องใส่ลูก .22    ( 2.5 นิ้ว )   ( รวม  4 ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9228f55e56994c6485ff0e5b421c5a30I.jpg_200x200q90.jpg",
        "price": 8660,
        "remark": "https://www.lazada.co.th/products/pdp-i4759365163.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า 𝗟𝗶𝗺𝗶𝘁𝗲𝗱 𝗘𝗱𝗶𝘁𝗶𝗼𝗻 - 𝗦𝗺𝗮𝗹𝗹 𝗖𝗼𝗹𝗯𝗶𝗲 𝗥𝗮𝗳𝗳𝗶𝗮 𝘄𝗶𝘁𝗵 𝗽𝗼𝘂𝗰𝗵.",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sef1c10b34e0a48adb45751667a6dff464.jpg_200x200q90.jpg",
        "price": 8658,
        "remark": "https://www.lazada.co.th/products/pdp-i16118273309.html",
        "sold": 0
    },
    {
        "product_name": "Fogong กระเป๋าครีบยาวกระเป๋าเป้สะพายหลังอเนกประสงค์สายพาดไหล่ปรับได้ไนลอนกระเป๋าครีบฟรีไดฟ์วิ่งกระเป๋าเป้สำหรับกิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/a0b6127108d581e6b14997f4b5c4f6d4.jpg_200x200q90.jpg",
        "price": 8630,
        "remark": "https://www.lazada.co.th/products/pdp-i16091696778.html",
        "sold": 0
    },
    {
        "product_name": "Stream Trail-Backpack Kozu Waterproof Backpack 23L",
        "product_image": "https://img.lazcdn.com/g/p/0d38c6e9feb972e97c201ee0dda705b5.jpg_200x200q90.jpg",
        "price": 8600,
        "remark": "https://www.lazada.co.th/products/pdp-i775226167.html",
        "sold": 2
    },
    {
        "product_name": "กระเป๋าถือ ขนาดเล็ก Tory Burch Kira Top Handle Satchel กระเป๋าทรงใหม่ล่าสุดจากรุ่นคิร่า (Kira)",
        "product_image": "https://img.lazcdn.com/g/p/6ca9943498b6c2b1b6628c675dfeb28a.jpg_200x200q90.jpg",
        "price": 8580,
        "remark": "https://www.lazada.co.th/products/pdp-i2981793488.html",
        "sold": 2
    },
    {
        "product_name": "กระเป๋าถือ คล้องแขน Tory burch lee radziwill pebbled small double bag กระเป๋า Lee Radziwill Double Bag",
        "product_image": "https://img.lazcdn.com/g/p/92ba066b1085af367d53827b2c2354f3.jpg_200x200q90.jpg",
        "price": 8580,
        "remark": "https://www.lazada.co.th/products/pdp-i3483341499.html",
        "sold": 0
    },
    {
        "product_name": "EBKZ | กระเป๋าถือหรูหราขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S895eacf298e242ab98c0447756bf5761g.jpg_200x200q90.jpg",
        "price": 8509.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16102941769.html",
        "sold": 0
    },
    {
        "product_name": "Stream Trail - Dry Tank 33L D2 Waterproof Backpack กระเป๋าเป้กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/860ff213058a68d7e2d187db02ddba87.jpg_200x200q90.jpg",
        "price": 8500,
        "remark": "https://www.lazada.co.th/products/pdp-i387990809.html",
        "sold": 3
    },
    {
        "product_name": "กระเปาสะพายไหลลำลอง หนงววแท กระเปาถอสำหรบผชายและผหญง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6a4ed45200304730814ef7aa356205a8R.png_200x200q90.png",
        "price": 8209.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16121301493.html",
        "sold": 0
    },
    {
        "product_name": "✈√♀30L Large Capacity Dry Bag Dry and Wet Separation Waterproof Swimming Backpack for Travel/water Sports/Hiking Storage Bag♀◐",
        "product_image": "https://img.lazcdn.com/g/p/d274ed5680875b074a0a30a758f951c3.png_200x200q90.png",
        "price": 8451.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16093013114.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่กอล์ฟ PGM Ultralight กระเป๋าใส่กอล์ฟแบบพกพา 14 กระเป๋ากระเป๋าเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/76af82035aee23b324f407022dababdb.jpg_200x200q90.jpg",
        "price": 8419.6,
        "remark": "https://www.lazada.co.th/products/pdp-i1803112973.html",
        "sold": 39
    },
    {
        "product_name": "กระเป๋าสะพายข้างและถือสำหรับผู้หญิง สไตล์ใหม่ 2026",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S162247eebe5a4ce69c3752fbac6775fc4.jpg_200x200q90.jpg",
        "price": 8412.04,
        "remark": "https://www.lazada.co.th/products/pdp-i6066536900.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า เก็บกระสุน  .22   ใส่ได้  200นัด   ( ผ้า 2ใบ )  (  หนัง 2ใบ )  ( รวม  4 ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc2591d4ece6741eb9bc1df116840a2d75.jpg_200x200q90.jpg",
        "price": 8400,
        "remark": "https://www.lazada.co.th/products/pdp-i397368059.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าปืน   หนังสีดำ    ( 4ใบ )   วอลเทอร์ walther   ppk  .380 ACP   9มม   /   STI ELEKTRA  .45 ACP   /  RETAY 84FS  /  Makarov  /  Sig Sauer P239",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdcbb34f6e2c44f368bd52c6d81f5eeafb.jpg_200x200q90.jpg",
        "price": 8400,
        "remark": "https://www.lazada.co.th/products/pdp-i5487462824.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากอล์ฟ ถุงกอล์ฟ HONMA พรีเมียม หนังแท้ กันน้ำ ดีไซน์หรู น้ำหนักเบา สำหรับนักกอล์ฟมืออาชีพ QBH002",
        "product_image": "https://img.lazcdn.com/g/p/06030a134489705c2bfb7b3aa8aa1e02.jpg_200x200q90.jpg",
        "price": 8396.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5946937169.html",
        "sold": 5
    },
    {
        "product_name": "กระเป๋า เก็บกระสุน  .38  9มม   357    ใส่ได้  100นัด    ( 4 ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S43032239601b48569363218c6354f8ef4.jpg_200x200q90.jpg",
        "price": 8360,
        "remark": "https://www.lazada.co.th/products/pdp-i5160727809.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า เก็บกระสุน ลูกซอง เบอร์12  ใส่ได้ 50นัด   ( 4 ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S35b8334a0d05413c901457bccaac88a3k.jpg_200x200q90.jpg",
        "price": 8360,
        "remark": "https://www.lazada.co.th/products/pdp-i5149342899.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า กระเป๋าใส่อุปกรณ์ดำน้ำ Cressi Piovra Bag",
        "product_image": "https://img.lazcdn.com/g/p/a3b12fafc56eedbcae97d6b7606aaf14.jpg_200x200q90.jpg",
        "price": 8310,
        "remark": "https://www.lazada.co.th/products/pdp-i5622678204.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเดินทางกันน้ำ ขนาด 72 ลิตร FEELFREE CRUISER 72L",
        "product_image": "https://img.lazcdn.com/g/p/d0f173ccdc64e7062c351e3700d56570.jpg_200x200q90.jpg",
        "price": 8280,
        "remark": "https://www.lazada.co.th/products/pdp-i2932429819.html",
        "sold": 1
    },
    {
        "product_name": "Lixada กระเป๋ากันน้ำสำหรับกลางแจ้ง,กระเป๋าเป้สะพายหลังแบบม้วนด้านบนลอยน้ำได้สำหรับเดินป่าลุยแม่น้ำ10L/15L / 23L",
        "product_image": "https://img.lazcdn.com/g/p/2075759e938cad0345843e919e2bc006.jpg_200x200q90.jpg",
        "price": 8160,
        "remark": "https://www.lazada.co.th/products/pdp-i5710203225.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน  ลูกโม่  2นิ้ว   สมิธ ชิพ   Smith     มีช่องใส่ลูก 2แถว   .38    357    9mm    9มม    กระเป๋า หนังสีดำ  ( 2ใบ )    พร้อม กระเป๋าใส่ลูก  .38   ( 3ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S37348ecc604343638241d687b8548778d.jpg_200x200q90.jpg",
        "price": 8160,
        "remark": "https://www.lazada.co.th/products/pdp-i394456739.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า เก็บกระสุน  11มม  .45   .22   .38   9มม   357   ลูกซอง เบอร์12   ( รวม  4 ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf3eed87712ae47b8a065eaec6b6bb1ccg.jpg_200x200q90.jpg",
        "price": 8150,
        "remark": "https://www.lazada.co.th/products/pdp-i5149469054.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเป้ถือขนาดเล็ก ดีไซน์พิเศษหรูหรา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sce0a95813cb24498af88aa88f6a7a4b6c.jpg_200x200q90.jpg",
        "price": 8062.92,
        "remark": "https://www.lazada.co.th/products/pdp-i6066275922.html",
        "sold": 0
    },
    {
        "product_name": "Aqualung Explorer II Duffle Pack",
        "product_image": "https://img.lazcdn.com/g/p/bfbecfd9d009ad8a3bb3df3521c43c92.jpg_200x200q90.jpg",
        "price": 8010,
        "remark": "https://www.lazada.co.th/products/pdp-i5145582363.html",
        "sold": 0
    },
    {
        "product_name": "Pacsafe | กระเป๋าสะพายข้างเล็กกันน้ำและกันขโมย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se5aafa81bbb948649e1def33dc3797a37.jpg_200x200q90.jpg",
        "price": 8008.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16048617677.html",
        "sold": 0
    },
    {
        "product_name": "STREAM TRAIL DRY TANK 25L กระเป๋าเป้กันน้ำ ขนาด 25 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/850250696270425babf8c2a8ad94e4f2.jpg_200x200q90.jpg",
        "price": 8000,
        "remark": "https://www.lazada.co.th/products/pdp-i3834558226.html",
        "sold": 0
    },
    {
        "product_name": "Waterproof Drysuit Bag 60L.(ถุงกันน้ำ แบบ backpack ผลิตจาก Cordura ทนทานสูง สำหรับบรรจุดรายสูทหรืออุปกรฌ์ดำน้ำ 50L)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd57c422742ed4237a3f3cb657547c0c8Y.jpg_200x200q90.jpg",
        "price": 8000,
        "remark": "https://www.lazada.co.th/products/pdp-i5834774572.html",
        "sold": 0
    },
    {
        "product_name": "(pre-order) Molchanovs Lightweight Monofin Bag 3",
        "product_image": "https://img.lazcdn.com/g/p/dfd01bb335508f12f95b7d4b359b7d86.jpg_200x200q90.jpg",
        "price": 7980,
        "remark": "https://www.lazada.co.th/products/pdp-i5688749299.html",
        "sold": 0
    },
    {
        "product_name": "GULL WATER PROTECT BAG กระเป๋ากันน้ำพกพา อเนกประสงค์ สำหรับดำน้ำ เดินป่า ท่องเที่ยว",
        "product_image": "https://img.lazcdn.com/g/p/4230694c119fd9ad325f52f49728de8d.png_200x200q90.png",
        "price": 7980,
        "remark": "https://www.lazada.co.th/products/pdp-i5716418730.html",
        "sold": 0
    },
    {
        "product_name": "เป้กันน้ำ 40 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se3f6db1ec4ed4912a759f0732612e8adf.jpg_200x200q90.jpg",
        "price": 7932,
        "remark": "https://www.lazada.co.th/products/pdp-i16124474550.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน  สมิธ  Smith   ลูกโม่ 3นิ้ว   ช่องใส่ลูก .38   357   9มม    มีช่องใส่ เอกสาร   ( 5ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S62acfa4890cc4463b6036b073175ecaeh.jpg_200x200q90.jpg",
        "price": 7900,
        "remark": "https://www.lazada.co.th/products/pdp-i5182158040.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน   สมิธ   Smith   ลูกโม่  4นิ้ว   มีช่องใส่ลูก  .38    357   9มม   มีช่องใส่ เอกสาร   ( 5ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S11920a78eeb74bc1b61c7433467664798.jpg_200x200q90.jpg",
        "price": 7900,
        "remark": "https://www.lazada.co.th/products/pdp-i5182061619.html",
        "sold": 0
    },
    {
        "product_name": "ถุงว่ายน้ำอารีน่ากันน้ำกันน้ำได้หลายกล่องเก็บของมีช่องแบ่งเป้สะพายคอมพิวเตอร์สำหรับว่ายน้ำและฟิตเนส",
        "product_image": "https://img.lazcdn.com/g/p/a419ba2a49c87901fb896df0cb17742a.png_200x200q90.png",
        "price": 7886.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16124948190.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าว่ายน้ำกันน้ำพกพาได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1610c6528de3491289d9287dc86edc7eg.jpg_200x200q90.jpg",
        "price": 7884,
        "remark": "https://www.lazada.co.th/products/pdp-i2303639365.html",
        "sold": 1
    },
    {
        "product_name": "กระเปาผหญงขนาดเลก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1ed539ddabfa4759b5b08db225f0e9cex.png_200x200q90.png",
        "price": 7880.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16099714384.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่อุปกรณ์กันน้ำ พลาโน่ ฟิลด์ล็อคเกอร์ อีลิเม้นท์ พรู๊ฟ XL ขนาด 49x38x23 ซม.",
        "product_image": "https://img.lazcdn.com/g/p/c726f8c5e41a73677da2e96754e7aef7.jpg_200x200q90.jpg",
        "price": 7840,
        "remark": "https://www.lazada.co.th/products/pdp-i5181422359.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายข้างผ้าแคนวาสสำหรับฤดูใบไม้ผลิ-ฤดูร้อน น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5d466f01376444b8b58548bb5bfaf409R.png_200x200q90.png",
        "price": 7830.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16105685766.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสำหรับผู้หญิงไซส์เล็ก รุ่นใหม่ 2026",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd2aee284e3324389a2dfd3586a400b05u.jpg_200x200q90.jpg",
        "price": 7808.12,
        "remark": "https://www.lazada.co.th/products/pdp-i6066576358.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสำหรับผู้หญิง ความจุมาก ดีไซน์ใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc7ac4468890d4b2cb8a7d41eed6eaeaai.jpg_200x200q90.jpg",
        "price": 7806.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6066515539.html",
        "sold": 0
    },
    {
        "product_name": "ถุงกอล์ฟสนูปี้มีขาตั้ง ขนาด 9 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S61078c85ba4f4b0cb8f5a42c5d0f5feao.jpg_200x200q90.jpg",
        "price": 7800,
        "remark": "https://www.lazada.co.th/products/pdp-i3007668257.html",
        "sold": 6
    },
    {
        "product_name": "Bulgarian Bag 15kg /กระสอบทรายการฝึกอบรมการออกกำลังกายโยคะหนักออกกำลังกายยิม",
        "product_image": "https://img.lazcdn.com/g/p/fa9e3eed1a8b11fc995772cbd0a208a2.jpg_200x200q90.jpg",
        "price": 7800,
        "remark": "https://www.lazada.co.th/products/pdp-i893780871.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาเปสำหรบคนทำงาน กระเปาแฟชนลำลอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4d0f394f9b664b4a9b5ad9c1f88f1eb2F.png_200x200q90.png",
        "price": 7484.66,
        "remark": "https://www.lazada.co.th/products/pdp-i16099746173.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสตรีหลายประโยชน์หรูหราและทันสมัย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd4e6b003dbf6465bb68e8e9bc746e693u.jpg_200x200q90.jpg",
        "price": 7709.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16111117598.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากอล์ฟ PGM สีเทาดำ วัสดุ PU กันน้ำ (QB134) Golf Bag PGM สามารถใช้งานได้ทั้งชายและหญิง สามารถพกพาได้เยอะ",
        "product_image": "https://img.lazcdn.com/g/p/94fc55f880e9671e903b14a88c96d5ed.jpg_200x200q90.jpg",
        "price": 7706.14,
        "remark": "https://www.lazada.co.th/products/pdp-i4955286250.html",
        "sold": 0
    },
    {
        "product_name": "Stream trail Mero-0 กระเป๋าใส่อุปกรณ์ กันน้ำขนาดใหญ่ มีวาล์วระบายน้ำ มี 5 สี",
        "product_image": "https://img.lazcdn.com/g/p/317b64636db00c3d7ba633476468f81b.jpg_200x200q90.jpg",
        "price": 7700,
        "remark": "https://www.lazada.co.th/products/pdp-i4132439900.html",
        "sold": 0
    },
    {
        "product_name": "Stream Trail-Mero 0 94L Waterproof Duffle Bag",
        "product_image": "https://img.lazcdn.com/g/p/a601591591af5a58f629e19b4c20ba83.jpg_200x200q90.jpg",
        "price": 7700,
        "remark": "https://www.lazada.co.th/products/pdp-i1001460791.html",
        "sold": 5
    },
    {
        "product_name": "กระเป๋าใส่ไม้กอล์ฟผู้หญิง มีขาตั้ง สีรุ้ง (QB063) PGM Golf Stand Bag",
        "product_image": "https://img.lazcdn.com/g/p/c36e4ef0df29d49bfce31a9d8c90b0be.jpg_200x200q90.jpg",
        "price": 7695.86,
        "remark": "https://www.lazada.co.th/products/pdp-i3711164539.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากอล์ฟ ใส่ไม้กอล์ฟได้ครบชุด โปร่งใส สีรุ้ง (QB063) PGM Pro Golf Master Standard Bag",
        "product_image": "https://img.lazcdn.com/g/p/7d6d11a6d54a86b1da5bc4d3c5df1d40.jpg_200x200q90.jpg",
        "price": 7695.86,
        "remark": "https://www.lazada.co.th/products/pdp-i4578589873.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากอล์ฟ PGM สีเทาดำ วัสดุ PU กันน้ำ (QB134) Golf Bag PGM สามารถใช้งานได้ทั้งชายและหญิง",
        "product_image": "https://img.lazcdn.com/g/p/f8206f5b143c3041ced7397acae1d0d5.jpg_200x200q90.jpg",
        "price": 7695.86,
        "remark": "https://www.lazada.co.th/products/pdp-i4955040878.html",
        "sold": 0
    },
    {
        "product_name": "Manta กระเป๋าครีบยาวกระเป๋าเป้สะพายหลังอเนกประสงค์สายพาดไหล่ปรับได้ไนลอนกระเป๋าครีบฟรีสำหรับกิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/7b917263203557fc6d2210d6e2149db0.png_200x200q90.png",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16091155236.html",
        "sold": 0
    },
    {
        "product_name": "Moon Rodeo กระเป๋าครีบยาวกระเป๋าเป้สะพายหลังอุปกรณ์ดำน้ำเข้าถึงเร็วที่ใส่ของอเนกประสงค์แบบพกพากระเป๋าเป้ตีนกบดำน้ำสำหรับกีฬากลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/8fe64f4ec212082287d12e98bb9b8d50.jpg_200x200q90.jpg",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16091002633.html",
        "sold": 0
    },
    {
        "product_name": "WDEarth กระเป๋าครีบยาวกระเป๋าใส่อุปกรณ์ตกปลา,สายรัดพาดไหล่ปรับได้พร้อมซิปกระเป๋าเป้สะพายหลังยูทิลิตี้กระเป๋าเป้สะพายหลังตีนกบดำน้ำสำหรับตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/c82e9669d9f1fdb52d17c59501e790a1.png_200x200q90.png",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16091177625.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าตีนกบยาวกระเป๋าเป้สะพายหลังอุปกรณ์ดำน้ำเข้าถึงเร็วที่ใส่ของอเนกประสงค์กระเป๋าเป้ตีนกบดำน้ำแบบพกพาสำหรับกีฬาทางน้ำกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/0d01f0a583a1f3357e64956f66a50e0b.jpg_200x200q90.jpg",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16091368808.html",
        "sold": 0
    },
    {
        "product_name": "Sharprepublic กระเป๋าครีบยาวกระเป๋ากระเป๋าอุปกรณ์มีซิปกระเป๋าหน้าฉนวนยูทิลิตี้กีฬากิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/4a9d5f9da5dd98a5f341ecd4d4fa8614.jpg_200x200q90.jpg",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16093568374.html",
        "sold": 0
    },
    {
        "product_name": "Motoautt กระเป๋าเป้อุปกรณ์ดำน้ำกระเป๋าเก็บของครีบยาวกระเป๋าใส่อุปกรณ์ตกปลาตีนกบดำน้ำกระเป๋าเป้สำหรับกิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/e151c60092961e6b44ae4943e76df604.jpg_200x200q90.jpg",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16092506599.html",
        "sold": 0
    },
    {
        "product_name": "WDFINE กระเป๋าครีบยาวกระเป๋าครีบทนต่อการสึกหรอเข้าถึงเร็วปรับได้พร้อมซิปตีนกบดำน้ำกระเป๋าเป้สะพายหลังสำหรับกีฬาทางน้ำว่ายน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/f0c3321fc9baebcfa4c425d51b8b5fea.png_200x200q90.png",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16129050457.html",
        "sold": 0
    },
    {
        "product_name": "Moon Okey กระเป๋าครีบยาวกระเป๋าเป้สะพายหลังอุปกรณ์ดำน้ำเข้าถึงเร็วที่ใส่ของอเนกประสงค์กระเป๋าเป้ตีนกบดำน้ำแบบพกพาสำหรับกีฬากลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/e151c60092961e6b44ae4943e76df604.jpg_200x200q90.jpg",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16091710396.html",
        "sold": 0
    },
    {
        "product_name": "Miusue กระเป๋ากระเป๋าเก็บของครีบยาวมีซิปกระเป๋าเป้ครีบฟรีไดฟ์วิ่งสำหรับตกปลากลางแจ้งที่ใส่ของอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/p/d4c2b3e71ef527ae9439f3e8e1bfa933.png_200x200q90.png",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16091794477.html",
        "sold": 0
    },
    {
        "product_name": "Sunniiee กระเป๋าอุปกรณ์ดำน้ำหูรูดแบบยาว,กระเป๋าเป้สะพายหลังพร้อมซิปกระเป๋าใส่อุปกรณ์ตกปลาดำน้ำตื้นสำหรับตกปลากลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/d34e1acdf68994a03e7a49034fbb644f.png_200x200q90.png",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16093778792.html",
        "sold": 0
    },
    {
        "product_name": "Pecine กระเป๋าครีบยาวกระเป๋าเป้สะพายหลังอุปกรณ์ดำน้ำเข้าถึงเร็วที่ใส่ของอเนกประสงค์กระเป๋าเป้ตีนกบดำน้ำแบบพกพาสำหรับกีฬากลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/e151c60092961e6b44ae4943e76df604.jpg_200x200q90.jpg",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16091711797.html",
        "sold": 0
    },
    {
        "product_name": "Ellwewe กระเป๋าครีบยาวกระเป๋าเป้สะพายหลังตีนกบดำน้ำกระเป๋าครีบ",
        "product_image": "https://img.lazcdn.com/g/p/6f7e8cee448b61059b9f0d3afb68c71e.jpg_200x200q90.jpg",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16132186338.html",
        "sold": 0
    },
    {
        "product_name": "Chulisia กระเป๋าครีบยาวกระเป๋ากระเป๋าอุปกรณ์จับปลามีซิปกระเป๋าหน้าฉนวนยูทิลิตี้กีฬากิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/efacbf5af7c4cf36f5de64b253f87096.png_200x200q90.png",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16093519014.html",
        "sold": 0
    },
    {
        "product_name": "ทาฮิดะกระเป๋าครีบยาวกระเป๋าใส่อุปกรณ์ตกปลามีสายรัดพาดไหล่ปรับได้พร้อมซิปกระเป๋าเป้สะพายหลังยูทิลิตี้กระเป๋าเป้สะพายหลังตีนกบดำน้ำสำหรับตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/3f19a2e83c2ae61622d3ef99579359dd.png_200x200q90.png",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16091310863.html",
        "sold": 0
    },
    {
        "product_name": "Moon กระเป๋ามีครีบยาวจรวดกระเป๋าใส่อุปกรณ์ตกปลามีสายรัดพาดไหล่ปรับได้พร้อมกระเป๋าเป้สะพายหลังยูทิลิตี้ซิปกระเป๋าเป้สะพายหลังตีนกบดำน้ำสำหรับตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/66b50d610861b6bca302f988c47605bd.jpg_200x200q90.jpg",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16091048139.html",
        "sold": 0
    },
    {
        "product_name": "CCPlanet กระเป๋าครีบยาวกระเป๋าใส่อุปกรณ์ตกปลา,สายรัดพาดไหล่ปรับได้พร้อมซิปกระเป๋าเป้สะพายหลังยูทิลิตี้กระเป๋าเป้สะพายหลังตีนกบดำน้ำสำหรับตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/e151c60092961e6b44ae4943e76df604.jpg_200x200q90.jpg",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16091016802.html",
        "sold": 0
    },
    {
        "product_name": "Gociy กระเป๋าเป้เก็บของกระเป๋าเก็บของอุปกรณ์สกูบ้าครีบยาวมีซิปทำจากไนลอนกระเป๋าเป้สะพายหลังสำหรับตกปลากีฬาทางน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/a53e0850b799817079626edd948cb95a.png_200x200q90.png",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16136421858.html",
        "sold": 0
    },
    {
        "product_name": "Flameer กระเป๋าอุปกรณ์ดำน้ำครีบยาว,กระเป๋าเป้สะพายหลังพร้อมซิปกระเป๋าใส่อุปกรณ์สำหรับตกปลากลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/515392b9293768a6bf1dd38aa98fb497.jpg_200x200q90.jpg",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16093680445.html",
        "sold": 0
    },
    {
        "product_name": "Moon Lighte กระเป๋าครีบยาวกระเป๋าใส่อุปกรณ์ตกปลามีสายรัดพาดไหล่ปรับได้พร้อมกระเป๋าเป้สะพายหลังยูทิลิตี้ซิปกระเป๋าเป้สะพายหลังตีนกบดำน้ำสำหรับตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/04c9a3b4b33f6d749e5b95031b189bf0.png_200x200q90.png",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16090997669.html",
        "sold": 0
    },
    {
        "product_name": "Beatycare กระเป๋าเก็บของครีบยาวกระเป๋าครีบมีซิปที่ใส่ของอเนกประสงค์กระเป๋าเป้ครีบสำหรับตกปลากลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/56647d001c2dcdb22b67e3bad4a735f9.png_200x200q90.png",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16092274632.html",
        "sold": 0
    },
    {
        "product_name": "BNCLOTH กระเป๋าครีบยาวกระเป๋าครีบกระเป๋าเก็บของพร้อมซิปที่ใส่ของอเนกประสงค์ปฏิบัติฟรีไดฟ์วิ่งกระเป๋าเป้สำหรับตกปลากลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/e151c60092961e6b44ae4943e76df604.jpg_200x200q90.jpg",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16092126265.html",
        "sold": 0
    },
    {
        "product_name": "Moon กระเป๋าครีบยาวสามเหลี่ยมกระเป๋าใส่อุปกรณ์ตกปลามีสายรัดพาดไหล่ปรับได้พร้อมซิปกระเป๋าเป้สะพายหลังยูทิลิตี้กระเป๋าเป้สะพายหลังตีนกบดำน้ำสำหรับตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/52b4cbe9e8754559dad368a1b2121671.png_200x200q90.png",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16091629730.html",
        "sold": 0
    },
    {
        "product_name": "Livestyl กระเป๋าครีบยาวกระเป๋ากระเป๋าอุปกรณ์จับปลามีซิปกระเป๋าด้านหน้าฉนวนยูทิลิตี้กีฬากิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/e151c60092961e6b44ae4943e76df604.jpg_200x200q90.jpg",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16092687147.html",
        "sold": 0
    },
    {
        "product_name": "BNTOOL กระเป๋าเป้สะพายหลังอุปกรณ์ดำน้ำกระเป๋าเก็บของครีบยาวกระเป๋าใส่อุปกรณ์ตกปลาตีนกบดำน้ำกระเป๋าเป้สำหรับกิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/f720c8d883759533ffe686ae9c69d056.png_200x200q90.png",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16091972902.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเป้กันน้ำมีครีบยาวสำหรับกระเป๋าเก็บของกระเป๋าเก็บของกระเป๋าเป้กันน้ำมีสวมใส่ได้จริงสำหรับว่ายน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/e151c60092961e6b44ae4943e76df604.jpg_200x200q90.jpg",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16105307445.html",
        "sold": 0
    },
    {
        "product_name": "Cocoli กระเป๋ากระเป๋าเก็บของครีบยาวกระเป๋าใส่อุปกรณ์สำหรับตกปลา,กระเป๋าเป้ตีนกบดำน้ำแบบพกพากระเป๋าเป้สะพายหลังสำหรับอุปกรณ์ดำน้ำกีฬาตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/ddc168709eeffd81f17a821ca399e9e4.jpg_200x200q90.jpg",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16136857351.html",
        "sold": 0
    },
    {
        "product_name": "Moon กระเป๋าครีบยาวน่ารักกระเป๋าเป้สะพายหลังอเนกประสงค์สายรัดพาดไหล่ปรับได้ไนลอนกระเป๋าครีบฟรีสำหรับกิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/b5890866e377b3675d7a006c2e4a7481.png_200x200q90.png",
        "price": 7684,
        "remark": "https://www.lazada.co.th/products/pdp-i16091766196.html",
        "sold": 0
    },
    {
        "product_name": "Arena | เป้สะพายหลังกันน้ำขนาดใหญ่หลายช่องสำหรับทุกเพศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scc3aa2cbd6914f3491a228ef4e15e19fY.jpg_200x200q90.jpg",
        "price": 7681,
        "remark": "https://www.lazada.co.th/products/pdp-i6055952468.html",
        "sold": 0
    },
    {
        "product_name": "GEAR BAGS Scubapro Mesh 95 กระเป๋าเดินทาง กระเป๋ากีฬาทางน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/6f8712a8aaadab7f9e82c24727fefe46.webp_200x200q90.jpg",
        "price": 6500,
        "remark": "https://www.lazada.co.th/products/pdp-i4900487310.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋ากันน้ำ EcoFlow DELTA 3 Plus",
        "product_image": "https://img.lazcdn.com/g/p/7916acc64fe022fa0099cd2897066e5c.jpg_webp_200x200q90.jpg",
        "price": 7654.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16138944070.html",
        "sold": 0
    },
    {
        "product_name": "PGM | กระเป๋ากอล์ฟพกพาสำหรับเดินทาง   QB128   SOB009",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2555238be60640b59c5617a5fc33f4b9E.jpg_200x200q90.jpg",
        "price": 7614.1,
        "remark": "https://www.lazada.co.th/products/pdp-i6072833550.html",
        "sold": 4
    },
    {
        "product_name": "กระเป๋าปืน  ยาว 102เซน   กว้าง 26เซน   1ใบ   และ  นาฬิกา   1อัน    และ แถม สายสะพาย 3จุด  1อัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2ec51845275c4b67b828f7318cd70d1b2.jpg_200x200q90.jpg",
        "price": 7600,
        "remark": "https://www.lazada.co.th/products/pdp-i4865305124.html",
        "sold": 0
    },
    {
        "product_name": "Stream Trail - Dry Tank 25L D2 Waterproof Backpack กระเป๋าเป้กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/60c38d704884d00c327f793324b72e5f.jpg_200x200q90.jpg",
        "price": 7600,
        "remark": "https://www.lazada.co.th/products/pdp-i394336302.html",
        "sold": 9
    },
    {
        "product_name": "กระเป๋าปืน   ยาว 76 เซน    กว้าง 28 เซน   1ใบ   และ  นาฬิกา   1อัน    และ  แถม สายสะพาย 3จุด  1อัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8bb109f403c145b2a3aec3d203dfd626K.jpg_200x200q90.jpg",
        "price": 7600,
        "remark": "https://www.lazada.co.th/products/pdp-i508164371.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาสำหรบพนกงานออฟฟศ กระเปาสะพายไหลขนาดเลก กระเปาสะพายขาง กระเปาแฟชน กระเปาโทท",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S34d8bad2eae1464c9a425aa891382086A.png_200x200q90.png",
        "price": 7588.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16121457365.html",
        "sold": 0
    },
    {
        "product_name": "Gull -  Water Protect Tote Bag กระเป๋ากันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/d096d09ff3abc0af3483501c1e2ea7fd.jpg_200x200q90.jpg",
        "price": 7580,
        "remark": "https://www.lazada.co.th/products/pdp-i5140628678.html",
        "sold": 0
    },
    {
        "product_name": "GULL - WATER PROTECT BAG TOTE 91L -  กระเป๋าใส่อุปกรณ์ดำน้ำ กระเป๋ากันน้ำใส่ของตอนไปดำน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/2a55d92088e954eb11ccb8df6b3645e9.jpg_200x200q90.jpg",
        "price": 7580,
        "remark": "https://www.lazada.co.th/products/pdp-i4952703157.html",
        "sold": 0
    },
    {
        "product_name": "ARENA TEAM BACKPACK กระเป๋าเป้ เป้สะพายหลัง ASB1P5",
        "product_image": "https://img.lazcdn.com/g/p/8c598d6e834ab521e0241ea47773321e.jpg_200x200q90.jpg",
        "price": 7560,
        "remark": "https://www.lazada.co.th/products/pdp-i4433194114.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋า เก็บกระสุน .22    ใส่ได้  76นัด   หนังสีดำ   ( รวม 4 ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5607757b612841c381866fc105bdf8a2d.jpg_200x200q90.jpg",
        "price": 7500,
        "remark": "https://www.lazada.co.th/products/pdp-i609698752.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน   กล็อก26    glock26    กล็อก43   glock43   sig p365    หนังสีดำ   มีช่องใส่แม็ก  2ช่อง    ไม่มีช่อง ใส่เอกสาร     ( รวม  4 ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S864d1531d26847d5927906676e1c581eD.jpg_200x200q90.jpg",
        "price": 7500,
        "remark": "https://www.lazada.co.th/products/pdp-i5181630601.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า เก็บกระสุน  11มม   .45    ใส่ได้   72นัด     หนังสีดำ   ( 4ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S970d7755ce2141909fc06ae61a3c90bcm.jpg_200x200q90.jpg",
        "price": 7500,
        "remark": "https://www.lazada.co.th/products/pdp-i3262907499.html",
        "sold": 0
    },
    {
        "product_name": "PGM  |กระเป๋ากอล์ฟพกพา กันน้ำได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S48d4b02977b34cf394d24131f1285b82I.jpg_200x200q90.jpg",
        "price": 7452.92,
        "remark": "https://www.lazada.co.th/products/pdp-i6072633959.html",
        "sold": 21
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟแบบมีล้อลาก โครงแข็ง 3Dน้ำหนักเบา 4.8 กก. มีที่ใส่หมวก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S914d80265eeb41d5993fee02e6be19c1x.jpg_200x200q90.jpg",
        "price": 7424.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6066553641.html",
        "sold": 0
    },
    {
        "product_name": "CCUEEL กระเป๋าครีบยาวกระเป๋าครีบทนต่อการสึกหรอเข้าถึงเร็วปรับได้พร้อมซิปตีนกบดำน้ำกระเป๋าเป้สะพายหลังสำหรับกีฬาทางน้ำว่ายน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/c04b1685e8821f7407972ac22d85b232.jpg_200x200q90.jpg",
        "price": 7416.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16129532612.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน  สมิธ  Smith   ลูกโม่ 5นิ้ว - 6นิ้ว   มีช่องใส่ลูก 2แถว   ช่องใส่ลูก สำหรับ  .38  357  9mm  9มม    มีสายสะพาย   ปรับสั้น ยาวได้ครับๆ   และ  เข็มขัด ใส่ลูก  .38   357  9mm    ( 1 เส้น )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S82b4ce3278d04c0ea0c769928385217ee.jpg_200x200q90.jpg",
        "price": 7400,
        "remark": "https://www.lazada.co.th/products/pdp-i394484592.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเดินทางกันน้ำ ขนาด 42 ลิตร FEELFREE CRUISER 42L",
        "product_image": "https://img.lazcdn.com/g/p/0c1f189f35d5c9dabda1ee3021f7de89.jpg_200x200q90.jpg",
        "price": 7380,
        "remark": "https://www.lazada.co.th/products/pdp-i2931884669.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสำหรับเดินทางขนาดกะทัดรัด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5da415826cbd493e9794090bbc824536h.jpg_200x200q90.jpg",
        "price": 7336.52,
        "remark": "https://www.lazada.co.th/products/pdp-i6066561197.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือ กระเป๋าสะพายข้าง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S89007d3b0d3645de9e97bfc7cda6f1a2U.jpg_200x200q90.jpg",
        "price": 7336.52,
        "remark": "https://www.lazada.co.th/products/pdp-i6066602520.html",
        "sold": 0
    },
    {
        "product_name": "Aldo | กระเป๋าถือแฟชั่นพกพาพร้อมเชือกรูด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S56f4760bb5174978ae9117219a1b41f9u.jpg_200x200q90.jpg",
        "price": 7333.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5878285590.html",
        "sold": 0
    },
    {
        "product_name": "เป้สกีมีล้อ พร้อมแยกช่องแห้งและเปียก และที่ใส่สโนว์บอร์ด 100 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S19379e6c886e4f1eb0db6c56bd27a8bfg.jpg_200x200q90.jpg",
        "price": 7307.08,
        "remark": "https://www.lazada.co.th/products/pdp-i6066789605.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาสำหรบคนทำงาน กระเปาแฟชน กระเปาสำหรบออกนอกบาน กระเปานกเรยน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd40e03f0cba34af09b03d0d68ccaf0e3R.png_200x200q90.png",
        "price": 7301.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16099558673.html",
        "sold": 0
    },
    {
        "product_name": "Golf Club 26 New Golf Bags Men's And Women's Backpack Club Bag Cameron Standard Tarpaulin Lightweight Stand Bag",
        "product_image": "https://img.lazcdn.com/g/p/5a181e0b1fc6965638dca7eb8d7ccfde.jpg_200x200q90.jpg",
        "price": 7298,
        "remark": "https://www.lazada.co.th/products/pdp-i16144288281.html",
        "sold": 0
    },
    {
        "product_name": "Aldo | กระเป๋าถือทวีดหรูพร้อมสายคล้องไหล่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S42c4a35ce35e448c9ef7036d232c29a4n.jpg_200x200q90.jpg",
        "price": 7255.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5893539044.html",
        "sold": 5
    },
    {
        "product_name": "กระเป๋าเป้สะพายหลังลอยน้ำได้สำหรับกลางแจ้ง,กระเป๋ากันน้ำออกไปเดินป่าลุยแม่น้ำกระเป๋าเป้สะพายหลังลอยน้ำได้กระเป๋ากันน้ำสำหรับ10L/15L / 20L",
        "product_image": "https://img.lazcdn.com/g/p/8ac150356fa037249acf267decdbd475.jpg_200x200q90.jpg",
        "price": 7242,
        "remark": "https://www.lazada.co.th/products/pdp-i4896439696.html",
        "sold": 0
    },
    {
        "product_name": "สินค้าขายดีพร้อมส่ง กระเป๋าสะพายข้างเเละคล้องไหล่ LYN  crossbody bag รุ่นเเม่อั้ม ทรงเหลี่ยม 6 สี มีหนังรองบ่า ดีเทลเรียบหรูแนะนำ จัดส่งจริง",
        "product_image": "https://img.lazcdn.com/g/p/4b50d9970ad94c9883dfe7f48c3bbbe2.jpg_200x200q90.jpg",
        "price": 7200,
        "remark": "https://www.lazada.co.th/products/pdp-i5592035234.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน  กล็อก19   px4    กล็อก30    sig320    ( ใส่ได้ 2กระบอก )   1ใบ     พร้อม กระเป๋าใส่ลูก  .38   9มม    4ใบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S23c0ea64211440418389e35231349128P.jpg_200x200q90.jpg",
        "price": 7200,
        "remark": "https://www.lazada.co.th/products/pdp-i5191803178.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่คัน HANDING 2 ช่อง White-Gold วัสดุหนังเทียมสังเคราะห์ไมโครไฟเบอร์ มีขาตั้งระบบพับเก็บอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/p/ed20d2b15acc29a015c7467a3b402d46.jpg_200x200q90.jpg",
        "price": 7200,
        "remark": "https://www.lazada.co.th/products/pdp-i5883073381.html",
        "sold": 0
    },
    {
        "product_name": "ถุงกอล์ฟ PGM สีเขียว วัสดุกันน้ำได้เป็นอย่างดี (QB116) PGM Golf Stand Bag",
        "product_image": "https://img.lazcdn.com/g/p/b5a2ec51598a3c75b0264ab31202c89a.jpg_200x200q90.jpg",
        "price": 7181.66,
        "remark": "https://www.lazada.co.th/products/pdp-i4464515286.html",
        "sold": 0
    },
    {
        "product_name": "ถุงกอล์ฟสุภาพสตรี PGM กันน้ำได้เป็นอย่างดี (QB116) women golf sports stand bag lattice golf stand bag หนังไนลอน ทนต่อการขีดข่วน",
        "product_image": "https://img.lazcdn.com/g/p/b5a2ec51598a3c75b0264ab31202c89a.jpg_200x200q90.jpg",
        "price": 7181.66,
        "remark": "https://www.lazada.co.th/products/pdp-i4889959139.html",
        "sold": 0
    },
    {
        "product_name": "Lunar Flight Bag ลูนาร์ ไฟลท์แบ็ก",
        "product_image": "https://img.lazcdn.com/g/p/f5af16c0e136f1c4508eb83e3b1cc4c4.jpg_200x200q90.jpg",
        "price": 7180,
        "remark": "https://www.lazada.co.th/products/pdp-i5297066281.html",
        "sold": 0
    },
    {
        "product_name": "ECOFLOW RIVER 2 PRO BAG  กระเป๋า",
        "product_image": "https://img.lazcdn.com/g/p/1da341127074c2e2db4dce027fed2b1c.jpg_200x200q90.jpg",
        "price": 7180,
        "remark": "https://www.lazada.co.th/products/pdp-i4863899171.html",
        "sold": 9
    },
    {
        "product_name": "กระเป๋า เก็บกระสุน .38  9มม  357  ใส่ได้ 100นัด  ( 2ใบ )  และ  ใบเล็ก  ใส่ได้  20นัด  ( 2ใบ )   ( รวม  4ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se19fa33d393a4340bb64cfdd4c61b247R.jpg_200x200q90.jpg",
        "price": 7160,
        "remark": "https://www.lazada.co.th/products/pdp-i4825076002.html",
        "sold": 0
    },
    {
        "product_name": "Sublue | กระเป๋าเก็บอุปกรณ์ว่ายน้ำกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S27acf06c55114d2ca03fdd28ee1afcefR.jpg_200x200q90.jpg",
        "price": 7155.66,
        "remark": "https://www.lazada.co.th/products/pdp-i16049301052.html",
        "sold": 0
    },
    {
        "product_name": "GESHIFAN | กระเป๋าถือสไตล์เรโทรขนาดใหญ่ความจุสูงสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0050500cf17e409b9c2f5a4ff10cdde1M.png_200x200q90.png",
        "price": 7137.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16101937703.html",
        "sold": 0
    },
    {
        "product_name": "ถุงกอล์ฟ เบนซ์ มีขาตั้ง 9 นิ้ว วัสดุผ้ากันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S45e4f12cabbf4f7ab357906ea3d22f52M.jpg_200x200q90.jpg",
        "price": 7121.2,
        "remark": "https://www.lazada.co.th/products/pdp-i2561000652.html",
        "sold": 15
    },
    {
        "product_name": "กระเป๋ากันน้ำ สะพายหลังและถือได้ ใช้งานง่าย สะดวกสบายและทนทาน ขนาด 60 ลิตร Panama - สีเทา",
        "product_image": "https://img.lazcdn.com/g/p/12e220e30cca54a8a031102cf9d918e0.jpg_200x200q90.jpg",
        "price": 7116,
        "remark": "https://www.lazada.co.th/products/pdp-i4358398653.html",
        "sold": 0
    },
    {
        "product_name": "เป้ดำน้ำกันน้ำความจุใหญ่ 25 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa88e033478574d0093a00b9178916f77P.jpg_200x200q90.jpg",
        "price": 7112,
        "remark": "https://www.lazada.co.th/products/pdp-i16139593389.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟพกพาได้ 14 ไม้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb76e4854fb534327a4edd47e960e6386e.jpg_200x200q90.jpg",
        "price": 7082.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16055476965.html",
        "sold": 2
    },
    {
        "product_name": "กระเป๋าเป้ดำน้ำแยกแห้งและเปียก พร้อมสายสะพายปรับได้สบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9644fc60f58d47d19bb96a8d736647c7c.jpg_200x200q90.jpg",
        "price": 7078,
        "remark": "https://www.lazada.co.th/products/pdp-i16124113380.html",
        "sold": 0
    },
    {
        "product_name": "Sea to Summit | กระเป๋าเก็บของกันน้ำสำหรับกิจกรรมกลางแจ้ง ความจุใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0aa752ca7ca945bb8baff20d6d7fd931d.png_200x200q90.png",
        "price": 7041.52,
        "remark": "https://www.lazada.co.th/products/pdp-i6001665017.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน  ออโต้  aoto   ปืน แม็กกาซีน  6นิ้ว    (  รวม  4 ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0698caa9edde435bb6f08effb614651cN.jpg_200x200q90.jpg",
        "price": 7020,
        "remark": "https://www.lazada.co.th/products/pdp-i5181676517.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า  เก็บกระสุน .22   ใส่ได้ 200นัด   (  ด้านนอก เป็น ผ้า )    ( รวม  3ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3738b62976694676b293b943daf05016U.jpg_200x200q90.jpg",
        "price": 7000,
        "remark": "https://www.lazada.co.th/products/pdp-i3328512418.html",
        "sold": 0
    },
    {
        "product_name": "ถุงกอล์ฟ  หนัง pvc ขนาดปากถุง 9 นิ้ว มี cover",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S31cfca63226d497fb95906affcd39fd4G.jpg_200x200q90.jpg",
        "price": 7000,
        "remark": "https://www.lazada.co.th/products/pdp-i2831739304.html",
        "sold": 10
    },
    {
        "product_name": "ถุงกอล์ฟ หนัง pvc ขนาดปากถุง 9 นิ้ว กันน้ำ มี cover",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scd7f997f5bc441388b31eaedf5b22cb56.jpg_200x200q90.jpg",
        "price": 7000,
        "remark": "https://www.lazada.co.th/products/pdp-i2561962303.html",
        "sold": 5
    },
    {
        "product_name": "ถุงกอล์ฟหนัง pvc ลายเคฟล่า  ขนาดปากถุง 10 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9fc5d59c7ff34ba0bc630c4c654cbe5ez.jpg_200x200q90.jpg",
        "price": 7000,
        "remark": "https://www.lazada.co.th/products/pdp-i4047226390.html",
        "sold": 13
    },
    {
        "product_name": "กระเป๋าสะพายตาข่าย Tusa Mesh Backpack ใส่อุปกรณ์ดำน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/87a5d340a0cfcbdd0adaeb6231ab3c11.png_200x200q90.png",
        "price": 7000,
        "remark": "https://www.lazada.co.th/products/pdp-i5255178582.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่อุปกรณ์ดำน้ำ81ลิตร – 81L BA0103 Mesh Backpack แบรนด์ TUSA – กระเป๋าตาข่ายสะพายหลัง",
        "product_image": "https://img.lazcdn.com/g/p/3e078bc15ae892dd926f2928b3ee8346.jpg_200x200q90.jpg",
        "price": 7000,
        "remark": "https://www.lazada.co.th/products/pdp-i4740535886.html",
        "sold": 0
    },
    {
        "product_name": "ถุงกอล์ฟ คาลลาเวย์ หนัง pvc ลายเคฟล่า ขนาดปากถุง 9 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2896013449f54b709943a2467aee71e7L.jpg_200x200q90.jpg",
        "price": 7000,
        "remark": "https://www.lazada.co.th/products/pdp-i2562026347.html",
        "sold": 32
    },
    {
        "product_name": "กระเป๋าปืน  ใส่ได้ 2กระบอก   ช่องใส่ แม็กกาซีน 4ช่อง    ช่องใส่ปืน  1911  5นิ้ว   92fs   และ  อีกช่อง ใส่ปืน  4นิ้ว  กล็อก19   px4   p320   ในใบเดียว  1ใบ       และ   กระเป๋า ใส่ลูก  .45   11มม    ใส่ได้ 100นัด  1ใบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc6cfbca10d1e4b0494e2ad2781282b04L.jpg_200x200q90.jpg",
        "price": 7000,
        "remark": "https://www.lazada.co.th/products/pdp-i4869093631.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าหิ้วบอสตันไซส์เล็กสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S47a5b06793ea4a65b9dc09d73fd25b84z.png_200x200q90.png",
        "price": 6994.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6066488273.html",
        "sold": 0
    },
    {
        "product_name": "Rinowalk MFT2306 กระเป๋าติดปิ๊บข้างกระเป๋าทัวร์ริ่ง 16L กันน้ำ 100%",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S09e916e0532041f89274813f06477475a.jpg_200x200q90.jpg",
        "price": 6980,
        "remark": "https://www.lazada.co.th/products/pdp-i5779332299.html",
        "sold": 2
    },
    {
        "product_name": "กระเป๋าสะพายขนาดใหญ่ ทันสมัยสำหรับการเดินทาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S354dbace928947e299785fd81d9b0c70T.jpg_200x200q90.jpg",
        "price": 6977.54,
        "remark": "https://www.lazada.co.th/products/pdp-i6066516493.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se1224fac3836492e9a30a23ff2bcda94S.jpg_200x200q90.jpg",
        "price": 6973.32,
        "remark": "https://www.lazada.co.th/products/pdp-i6066317689.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือคุณภาพสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6627b592992e4257b6a1e254bb4b13778.jpg_200x200q90.jpg",
        "price": 6960.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6066479620.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือผู้หญิงสไตล์วินเทจ ความจุมาก ดีไซน์ใหม่ 2026",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb08730ab507e4fe3a42dd1d84f89bf27e.jpg_200x200q90.jpg",
        "price": 6960.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6066362984.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายหรือคล้องข้างขนาดใหญ่แต่ตัวเล็ก สำหรับใช้เป็นกระเป๋าฮอบโซหรือทอท์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S59fe3c76acef4bb99addb3b268c0aa80k.jpg_200x200q90.jpg",
        "price": 6960.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6066587339.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า Ostomy ระบบ 2 ชิ้น SenSura Click Wide Drainable ขนาด 11.5\" L 60 มม. 11196, 20 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/9a7c073d9d2a2939c0a36bb93ec493d8.jpg_200x200q90.jpg",
        "price": 6931.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6040551089.html",
        "sold": 0
    },
    {
        "product_name": "Stream Trail-Marche DX-1.5 Rider Waterproof Shoulder/Backpack 23L",
        "product_image": "https://img.lazcdn.com/g/p/32206de0166cb8f6d11965ef8443c113.jpg_200x200q90.jpg",
        "price": 6900,
        "remark": "https://www.lazada.co.th/products/pdp-i405030507.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋าสะพายข้างและกระเป๋าถือสำหรับผู้หญิง Browns สำหรับการเดินทางไปทำงาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S71637786d6a7478f8605ee0687b980adN.jpg_200x200q90.jpg",
        "price": 6873.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6066584712.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเดินทางกันน้ำ พรีเมี่ยม FEELFREE CRUISER 25L",
        "product_image": "https://img.lazcdn.com/g/p/dd0e18af0b22df4c74bfdce520575855.jpg_200x200q90.jpg",
        "price": 6840,
        "remark": "https://www.lazada.co.th/products/pdp-i2487827237.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากอล์ฟ PGM Precision X Golf Club Carry Bag (QB034) ใส่ได้ 13 ไม้",
        "product_image": "https://img.lazcdn.com/g/p/20321f17047a26e2f25a0f4ea4eecaa6.jpg_200x200q90.jpg",
        "price": 6838.86,
        "remark": "https://www.lazada.co.th/products/pdp-i1466082318.html",
        "sold": 34
    },
    {
        "product_name": "กระเป๋าใส่ไม้กอล์ฟ PGM 13-14 ไม้ (QB034) PGM Golf Club Carry Bag",
        "product_image": "https://img.lazcdn.com/g/p/38ae0654a2d37d3492fb85f86da3b965.jpg_200x200q90.jpg",
        "price": 6838.86,
        "remark": "https://www.lazada.co.th/products/pdp-i1373404612.html",
        "sold": 17
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟพกพาเบาและมีขาตั้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4792b3bec3794d93a245a4d4bb67e471C.jpg_200x200q90.jpg",
        "price": 6831.32,
        "remark": "https://www.lazada.co.th/products/pdp-i6072675954.html",
        "sold": 13
    },
    {
        "product_name": "เป้สะพายหลังกันน้ำทนทาน 27 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S479a86b3f0b24c7cb441915bf79c5d6cz.jpg_200x200q90.jpg",
        "price": 6828,
        "remark": "https://www.lazada.co.th/products/pdp-i16124486102.html",
        "sold": 0
    },
    {
        "product_name": "[พร้อมส่ง] เป้สะพายหลังกันน้ำ ขนาด 30 ลิตร Waterproof Backpack",
        "product_image": "https://img.lazcdn.com/g/p/99bdd629fa5546a52ef362bed43750f7.jpg_200x200q90.jpg",
        "price": 6800,
        "remark": "https://www.lazada.co.th/products/pdp-i2527079870.html",
        "sold": 0
    },
    {
        "product_name": "Ellalyn-พร้อมส่ง! กระเป๋าถือแฟชั่น หนังพียูเกรดพรีเมียม ใส่ของได้เยอะ รุ่น 1822DB",
        "product_image": "https://img.lazcdn.com/g/p/c64ce23e3255f50d205096b45bb6c77a.png_200x200q90.png",
        "price": 6800,
        "remark": "https://www.lazada.co.th/products/pdp-i408374289.html",
        "sold": 0
    },
    {
        "product_name": "CASDON-กระเป๋าถือแฟชั่น หนังพียูเกรดพรีเมียม ใส่ของได้เยอะ รุ่น 1822DB พร้อมส่งจากไทย",
        "product_image": "https://img.lazcdn.com/g/p/28ba0a5145e4f260f01e4c7c9f7755e0.jpg_200x200q90.jpg",
        "price": 6800,
        "remark": "https://www.lazada.co.th/products/pdp-i2862077371.html",
        "sold": 0
    },
    {
        "product_name": "Ellalyn-พร้อมส่ง! กระเป๋าถือแฟชั่น หนังพียูเกรดพรีเมียม ใส่ของได้เยอะ รุ่น 1823DB",
        "product_image": "https://img.lazcdn.com/g/p/47da47e7bbb6d198c745fa85c363fde6.png_200x200q90.png",
        "price": 6800,
        "remark": "https://www.lazada.co.th/products/pdp-i408484149.html",
        "sold": 0
    },
    {
        "product_name": "CASDON-กระเป๋าถือแฟชั่น หนังพียูเกรดพรีเมียม ใส่ของได้เยอะ รุ่น 1823DB พร้อมส่งจากไทย",
        "product_image": "https://img.lazcdn.com/g/p/61ad27df48857f5f8015711e491fce28.jpg_200x200q90.jpg",
        "price": 6800,
        "remark": "https://www.lazada.co.th/products/pdp-i2862033642.html",
        "sold": 0
    },
    {
        "product_name": "Ellalyn-พร้อมส่ง กระเป๋าถือ Feiyana หนังพียูเกรดพรีเมียม ใส่ของได้เยอะ รุ่น 1821DB",
        "product_image": "https://img.lazcdn.com/g/p/9df998717fa3ab7935f5f18c77bfd7b9.png_200x200q90.png",
        "price": 6800,
        "remark": "https://www.lazada.co.th/products/pdp-i407612265.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้กันน้ำ ไซส์ L FEELFREE URBANION ECO BACKPACK L",
        "product_image": "https://img.lazcdn.com/g/p/d6dc6527a55dcf7625e5fc0211ad002c.jpg_200x200q90.jpg",
        "price": 6780,
        "remark": "https://www.lazada.co.th/products/pdp-i4985996576.html",
        "sold": 0
    },
    {
        "product_name": "Titleist Players Boston Bag",
        "product_image": "https://img.lazcdn.com/g/p/efe339a12e1fd749869bffa33d32dd22.jpg_200x200q90.jpg",
        "price": 6720,
        "remark": "https://www.lazada.co.th/products/pdp-i4668155554.html",
        "sold": 8
    },
    {
        "product_name": "Sea to summit Hydraulic Packing Cube SIZE XL กระเป๋าจัดระเบียบสิ่งของ กระเป๋าอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/p/a9b86a8ef2be887643cb302d9a6e5c7d.jpg_200x200q90.jpg",
        "price": 6720,
        "remark": "https://www.lazada.co.th/products/pdp-i4445153733.html",
        "sold": 1
    },
    {
        "product_name": "PGM GOLF |กระเป๋ากอล์ฟสำหรับผู้หญิงพร้อมขาตั้ง กระเป๋าใส่ไม้กอล์ฟแบบพกพาน้ำหนักเบา  QB148",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf979772613af41a28919a5b59076a145K.jpg_200x200q90.jpg",
        "price": 6711.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16054587214.html",
        "sold": 2
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟพกพาอัลตราไลท์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3f0e552f106d4f58a8d8ffab23339d3ei.jpg_200x200q90.jpg",
        "price": 6711.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16055124481.html",
        "sold": 2
    },
    {
        "product_name": "🔥 สินค้าขายดี🔥💯Factory 💯👜 กระเป๋าสะพายไหล่ Perry Zip ดีไซน์ทันสมัย",
        "product_image": "https://img.lazcdn.com/g/p/dfa66a0f3d953bfee85253da7a84d293.png_200x200q90.png",
        "price": 6700,
        "remark": "https://www.lazada.co.th/products/pdp-i5965638390.html",
        "sold": 0
    },
    {
        "product_name": "Stream Trail - Dry Tank DX 18L Waterproof Backpack กระเป๋าเป้กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/3c3a1f4be28e7a9c1d555a8af8392a29.jpg_200x200q90.jpg",
        "price": 6700,
        "remark": "https://www.lazada.co.th/products/pdp-i399128824.html",
        "sold": 1
    },
    {
        "product_name": "La Festin | กระเป๋าถังสุดหรูสะพายข้าง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S676a2f6c190548da8e59e1d62ff70072U.png_200x200q90.png",
        "price": 6694.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5893739726.html",
        "sold": 181
    },
    {
        "product_name": "PGM|กระเป๋ากอล์ฟจุได้ 14 ไม้ น้ำหนักเบา พกพาสะดวก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S21d86334ff2d4922a3f9c5c5b1b1d9c2J.jpg_200x200q90.jpg",
        "price": 6636.76,
        "remark": "https://www.lazada.co.th/products/pdp-i6003378890.html",
        "sold": 44
    },
    {
        "product_name": "กระเปาของขวญ ดไซนทนสมย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5170bb71a6f7440bbc8507dd03eec593j.png_200x200q90.png",
        "price": 6627.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16121445374.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถังขนาดเล็กสำหรับสะพายข้างและสะพายไหล่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbb87648990ab4fcd8c78b833d546a73fK.jpg_200x200q90.jpg",
        "price": 6613.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6066351894.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือใหม่หรูหรา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2a5880893f714c1b886a9cc8b3fabc73m.jpg_200x200q90.jpg",
        "price": 6613.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6066388725.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือขนาดใหญ่สำหรับผู้หญิง สะพายไหล่เดี่ยว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S21d2bbc8d9674697987e94f33af4366aH.jpg_200x200q90.jpg",
        "price": 6610.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6066307974.html",
        "sold": 0
    },
    {
        "product_name": "ถุงกอล์ฟ หนัง pvc ขนาดปากถุง 9 นิ้ว กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8433e1f16cbc457d8c380746015bbe4bA.jpg_200x200q90.jpg",
        "price": 6600,
        "remark": "https://www.lazada.co.th/products/pdp-i2604100242.html",
        "sold": 15
    },
    {
        "product_name": "ซองปืน  กระเป๋าใส่ปืน   กล็อก19   px4    กล็อก30   sig320    1911 4นิ้ว   เทารัส g3   CZ P10 c    stoeger str-9c  ( ใส่ได้ 2กระบอก ) 1ใบ   และ   พร้อม กระเป๋าใส่ลูก .38  9มม  357  ( 2ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S14ba22191149422f9593c16324998e555.jpg_200x200q90.jpg",
        "price": 5800,
        "remark": "https://www.lazada.co.th/products/pdp-i5191796128.html",
        "sold": 0
    },
    {
        "product_name": "Gear Bag Square Mesh Bag - GULL",
        "product_image": "https://img.lazcdn.com/g/ot/lzd-client-service/afbe873c2e6d682d81ab7c51d30d3a68.jpeg_200x200q90.jpg",
        "price": 6580,
        "remark": "https://www.lazada.co.th/products/pdp-i3129240499.html",
        "sold": 2
    },
    {
        "product_name": "Charles & Keith | กระเป๋าสะพายหลายแบบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S778e927b62c34d9ba56503f6d86b91cb0.jpg_200x200q90.jpg",
        "price": 6563.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16126935208.html",
        "sold": 0
    },
    {
        "product_name": "ถุงกอล์ฟไนกี้ หนัง pvc ขนาด 9 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se1151660e96b438abbdc816781cb28abH.jpg_200x200q90.jpg",
        "price": 6559,
        "remark": "https://www.lazada.co.th/products/pdp-i2561538723.html",
        "sold": 42
    },
    {
        "product_name": "ถุงกอล์ฟ ไทเทิลลิส หนัง pvc ขนาด 9 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1ad7c07f60734097a752b8923f81937fz.jpg_200x200q90.jpg",
        "price": 6559,
        "remark": "https://www.lazada.co.th/products/pdp-i2863933112.html",
        "sold": 89
    },
    {
        "product_name": "ถุงกอล์ฟผ้ากันน้ำ วัสดุผ้ากันน้ำ ขนาด 9 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4de9b4a46d964f289ea66a8b9811e10bo.jpg_200x200q90.jpg",
        "price": 6559,
        "remark": "https://www.lazada.co.th/products/pdp-i3102215586.html",
        "sold": 12
    },
    {
        "product_name": "ถุงกอล์ฟขาตั้ง stand bag ของใหม่น้ำหนักเบา model:2026",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saf5b7ddf8d704fcea07297ee8df5fb2ck.jpg_200x200q90.jpg",
        "price": 6540.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5730628004.html",
        "sold": 11
    },
    {
        "product_name": "ถุงกอล์ฟ Staff Bag Scotty Cameron ขนาด 9 นิ้ว รุ่น For Tour Use Only หนังพรีเมียม กันน้ำ ดีไซน์หรูหรา งานปักละเอียด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S819e62ed432842f5845dc86884aee119v.jpg_200x200q90.jpg",
        "price": 6540.26,
        "remark": "https://www.lazada.co.th/products/pdp-i4823820989.html",
        "sold": 10
    },
    {
        "product_name": "ถุงกอล์ฟ ขาตั้ง stand bag ของใหม่มีหลายสี พร้อมส่งจากไทย",
        "product_image": "https://img.lazcdn.com/g/p/dc14536f359719e295f349b3142a7834.jpg_200x200q90.jpg",
        "price": 6526.32,
        "remark": "https://www.lazada.co.th/products/pdp-i4998134868.html",
        "sold": 26
    },
    {
        "product_name": "กระเป๋ากอล์ฟ PGM ใส่ได้ 13-14 ไม้ แข็งแรง ทนทาน มี 3 สี PGM Golf Bag Men's Club (QB034)",
        "product_image": "https://img.lazcdn.com/g/p/57949427a34b756df46d14bc2ebddf6e.png_200x200q90.png",
        "price": 6500.5,
        "remark": "https://www.lazada.co.th/products/pdp-i1416238040.html",
        "sold": 13
    },
    {
        "product_name": "[NEW ARRIVAL] FEELFREE NEW DRY TANK กระเป๋าเป้กันน้ำ ขนาด 50 ลิตร รุ่นใหม่ล่าสุด",
        "product_image": "https://img.lazcdn.com/g/p/70890ed597b0f89a595a223e9f6b6b26.jpg_200x200q90.jpg",
        "price": 6500,
        "remark": "https://www.lazada.co.th/products/pdp-i5939694182.html",
        "sold": 0
    },
    {
        "product_name": "[NEW ARRIVAL] FEELFREE NEW DRY TANK กระเป๋าเป้กันน้ำ สำหรับสายลุย ขนาด 50 ลิตร รุ่นใหม่ล่าสุด",
        "product_image": "https://img.lazcdn.com/g/p/70890ed597b0f89a595a223e9f6b6b26.jpg_200x200q90.jpg",
        "price": 6500,
        "remark": "https://www.lazada.co.th/products/pdp-i5942835713.html",
        "sold": 0
    },
    {
        "product_name": "[NEW ARRIVAL] FEELFREE NEW DRY TANK กระเป๋าเป้กันน้ำ รุ่นใหม่ล่าสุด ขนาด 50 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/70890ed597b0f89a595a223e9f6b6b26.jpg_200x200q90.jpg",
        "price": 6500,
        "remark": "https://www.lazada.co.th/products/pdp-i5988344954.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายข้างแฟชั่นไซส์เล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb8d9a485c00f4f4eb917903963e974ecP.jpg_200x200q90.jpg",
        "price": 6492.44,
        "remark": "https://www.lazada.co.th/products/pdp-i6066490624.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือแฟชั่นขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S496916cb8eaa40638d602410453d531bF.jpg_200x200q90.jpg",
        "price": 6492.44,
        "remark": "https://www.lazada.co.th/products/pdp-i6066618790.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายข้างสำหรับฤดูร้อน ขนาดเล็ก ดีไซน์ทันสมัย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc6732320f7b446e9814fdadf12dce29cg.jpg_200x200q90.jpg",
        "price": 6476.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6066599439.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือทรงโต้ท์ดีไซน์ใหม่สำหรับผู้หญิงไซส์เล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb9094100d2ba463ba2624e0cec595e4fF.jpg_200x200q90.jpg",
        "price": 6476.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6066649311.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสไตล์ชิคขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3f24bf84d2504e338f3bf4557f756ccbA.jpg_200x200q90.jpg",
        "price": 6476.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6066598428.html",
        "sold": 0
    },
    {
        "product_name": "landgulls | เป้กันน้ำหลายฟังก์ชัน พร้อมแยกของแห้งและเปียก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd54f08261bca4587bbafce0ab61e15dch.jpg_200x200q90.jpg",
        "price": 6469.08,
        "remark": "https://www.lazada.co.th/products/pdp-i6066200390.html",
        "sold": 0
    },
    {
        "product_name": "PGM QB134/QB174 Anti-collision Fixed Frame Golf Bag, Men's And Women's Golf Bags, Golf Club Bag",
        "product_image": "https://img.lazcdn.com/g/p/412555dbfe09edd7558b855455a50eb9.jpg_200x200q90.jpg",
        "price": 6439.06,
        "remark": "https://www.lazada.co.th/products/pdp-i5737921903.html",
        "sold": 6
    },
    {
        "product_name": "PGM Golf Clubs Bag Unisex Standard Ball Package Waterproof PU Portable QB134/174 Wholesale",
        "product_image": "https://img.lazcdn.com/g/p/7d397f26a7ed49216958b91ce0632311.jpg_200x200q90.jpg",
        "price": 6438,
        "remark": "https://www.lazada.co.th/products/pdp-i5696244174.html",
        "sold": 10
    },
    {
        "product_name": "Camnal | กระเป๋าเชือกความปลอดภัยสำหรับกลางแจ้ง สะพายสองข้าง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scf087fed50a4403293051a1e63ba1a65k.jpg_200x200q90.jpg",
        "price": 6408.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16049269185.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า ใส่ปืน  สมิธ  Smith  ลูกโม่ 5นิ้ว - 6นิ้ว  มีช่องใส่ลูก 2แถว  ช่องใส่ลูก สำหรับ .38 357  9mm  9มม     1ใบ      และ  กระเป๋า ใส่ปืน พกพา    1ใบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0061c64e360046a18a2caf7c33adfcf66.jpg_200x200q90.jpg",
        "price": 6400,
        "remark": "https://www.lazada.co.th/products/pdp-i5428711637.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า เก็บกระสุน .38  9มม   357   ใส่ได้ 100นัด  ( 2ใบ )   และ   ใบเล็ก  ใส่ได้ 20นัด   ( 2ใบ )   ( รวม 4ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf303c4078f5b4f9dafe64f8ce31ca2b6t.jpg_200x200q90.jpg",
        "price": 6400,
        "remark": "https://www.lazada.co.th/products/pdp-i4355305560.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า ใส่ปืน  สมิธ  Smith  ลูกโม่ 5นิ้ว - 6นิ้ว  มีช่องใส่ลูก 2แถว  ช่องใส่ลูก สำหรับ .38 357  9mm  9มม     1ใบ      และ  กระเป๋า ใส่ปืน พกพา  สีดำ   1ใบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S51d4fd35e33e4a7eac362605b617b198m.jpg_200x200q90.jpg",
        "price": 6400,
        "remark": "https://www.lazada.co.th/products/pdp-i3328602169.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน  ลูกโม่  2นิ้ว   สมิธ ชิพ   Smith     มีช่องใส่ลูก 2แถว   .38    357    9mm    9มม    กระเป๋า หนังสีดำ  ( 1ใบ )    พร้อม กระเป๋าใส่ลูก  .38   ( 3ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S870a06da1148450886fbb5a01cdae200g.jpg_200x200q90.jpg",
        "price": 6380,
        "remark": "https://www.lazada.co.th/products/pdp-i1920830430.html",
        "sold": 0
    },
    {
        "product_name": "ถุงกอล์ฟ เทเลอร์เมด มีขาตั้ง ขนาดปากถุง 9 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S49ca32c96a984a5bb4141dbbc153078ci.jpg_200x200q90.jpg",
        "price": 6361.2,
        "remark": "https://www.lazada.co.th/products/pdp-i2718934726.html",
        "sold": 30
    },
    {
        "product_name": "ถุงกอล์ฟ 9”",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc734e6df6dc840548426e70dcecb7a1dS.jpg_200x200q90.jpg",
        "price": 6355.28,
        "remark": "https://www.lazada.co.th/products/pdp-i3373988270.html",
        "sold": 33
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟแบบมีขาตั้ง เบา พกพาสะดวก เหมาะสำหรับเดินเล่นสนาม ทำจากวัสดุไนลอน + อลูมิเนียม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb4c1a044faff400ab1223e6b7b8802206.jpg_200x200q90.jpg",
        "price": 6312.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6072660841.html",
        "sold": 37
    },
    {
        "product_name": "เป้กันน้ำและกันอากาศสำหรับเดินทาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5438983e90a64d7d980fda35efafc5b8z.jpg_200x200q90.jpg",
        "price": 6310,
        "remark": "https://www.lazada.co.th/products/pdp-i16115290769.html",
        "sold": 0
    },
    {
        "product_name": "Stream Trail Mactra L กระเป๋ากันน้ำ สำหรับใส่อุปกรณ์ 30L.",
        "product_image": "https://img.lazcdn.com/g/p/c69d96411b4ca80a328280e5bd8d253a.jpg_200x200q90.jpg",
        "price": 6300,
        "remark": "https://www.lazada.co.th/products/pdp-i5373518639.html",
        "sold": 0
    },
    {
        "product_name": "[ New Arrival ] KAVU Hauler Tote Bag กระเป๋าใส่ของเอนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/p/933bc12019aa714152afa614e5648c55.jpg_200x200q90.jpg",
        "price": 6300,
        "remark": "https://www.lazada.co.th/products/pdp-i5631420412.html",
        "sold": 0
    },
    {
        "product_name": "Xinda | เป้กันน้ำสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1a7ec91dd3244c03b535a0ac3c20efdbh.jpg_200x200q90.jpg",
        "price": 6266.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16049778718.html",
        "sold": 0
    },
    {
        "product_name": "ถุงกอล์ฟ ขาตั้ง 2.76kg PGM QB111 personalized stand golf bag lightweight logo",
        "product_image": "https://img.lazcdn.com/g/p/42d1388fcdf54d531336c222921c3c3b.jpg_200x200q90.jpg",
        "price": 6240,
        "remark": "https://www.lazada.co.th/products/pdp-i5280344195.html",
        "sold": 0
    },
    {
        "product_name": "BLACK DIAMOND BULLET 16 PACK เป้น้ำ สำหรับวิ่งเทรล เป้ daypack สำหรับ trekking เดินป่า หรือในเมืองdaytrip",
        "product_image": "https://img.lazcdn.com/g/p/0c3917d584dbc5346f0f7b9532ad14df.png_200x200q90.png",
        "price": 6238,
        "remark": "https://www.lazada.co.th/products/pdp-i5087757151.html",
        "sold": 0
    },
    {
        "product_name": "Naturehike waterproof backpack เดินป่ากระเป๋าเป้สะพายหลังกันน้ํา 28L ความจุ IPX7 กันน้ํา 600D โพลีเอสเตอร์กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/669ad049a2eb8cd1381e8b17d9359e1e.jpg_200x200q90.jpg",
        "price": 6230,
        "remark": "https://www.lazada.co.th/products/pdp-i5939600144.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน   หนังสีดำ  มีช่องใส่ เอกสาร   ( 4นิ้ว )    Glock  กล็อก19   px4    sig320   //  กล็อก30  //  cz p10 1911 4นิ้ว  //  โตกาเรฟ 9มม     ( รวม  4 ใบ  )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2581a188c92c4fdeb217f1637c272a760.jpg_200x200q90.jpg",
        "price": 6220,
        "remark": "https://www.lazada.co.th/products/pdp-i5181549934.html",
        "sold": 0
    },
    {
        "product_name": "XUNTENG | เคสกันน้ำสำหรับถ่ายภาพและวิดีโอน้ำลึก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S98e918fd719b4dea9d068fffce410bff0.jpg_200x200q90.jpg",
        "price": 6210,
        "remark": "https://www.lazada.co.th/products/pdp-i4427724762.html",
        "sold": 0
    },
    {
        "product_name": "ถุงกอล์ฟ Golf Bag รุ่น Prestige สำหรับกอล์ฟ ดีไซน์พรีเมียม กระเป๋ากอล์ฟ Titleist แบบขาตั้ง รุ่นพรีเมียม น้ำหนักเบา ทนทาน ดีไซน์สวย เหมาะสำหรับพกพาในสนาม QBS003",
        "product_image": "https://img.lazcdn.com/g/p/526e5b9d560e55eb5a2945e36b66aaba.jpg_200x200q90.jpg",
        "price": 6200.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5912175467.html",
        "sold": 5
    },
    {
        "product_name": "ของแท้ กระเป๋าถือผู้หญิงทันสมัย กระเป๋าถือทั่วไป ความจุมาก สำหรับใช้ประจำวัน CN733 ขนาด：23cmx20cmx11cm",
        "product_image": "https://img.lazcdn.com/g/p/7375028ec92fa5e43f4f36286550ad18.jpg_200x200q90.jpg",
        "price": 6200,
        "remark": "https://www.lazada.co.th/products/pdp-i16135972878.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ40ลิตร – 40L Water Pro Printed Dry Bag แบรนด์ WATER PRO",
        "product_image": "https://img.lazcdn.com/g/p/4835af9ae141f9ef5f071675e13850d0.jpg_200x200q90.jpg",
        "price": 6200,
        "remark": "https://www.lazada.co.th/products/pdp-i389944142.html",
        "sold": 0
    },
    {
        "product_name": "Speedo | เป้สะพายหลังกันน้ำ ความจุมาก 35 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbc823e8a4e614f6cb9b4a68bf5457795C.jpg_200x200q90.jpg",
        "price": 6190.94,
        "remark": "https://www.lazada.co.th/products/pdp-i6051771636.html",
        "sold": 8
    },
    {
        "product_name": "Speedo | เป้สะพายหลังกันน้ำความจุมากสำหรับผู้ชายและผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S819f1a4a5e854ababe5c49ea7ec7eb2ck.jpg_200x200q90.jpg",
        "price": 6189.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16063634903.html",
        "sold": 6
    },
    {
        "product_name": "Speedo | กระเป๋าว่ายน้ำกันน้ำ 35 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scf7e4a72dbb84fc79df838c878a78061p.jpg_200x200q90.jpg",
        "price": 6183.86,
        "remark": "https://www.lazada.co.th/products/pdp-i6014112744.html",
        "sold": 0
    },
    {
        "product_name": "🔥 สินค้าขายดี🔥💯 แท้ 100% จาก Factory 💯📌กระเป๋าสะพายไหล่ Asher ดีไซน์หรู",
        "product_image": "https://img.lazcdn.com/g/p/1aa9bc2b4e46e5f2085080aceb88a9a4.png_200x200q90.png",
        "price": 6180,
        "remark": "https://www.lazada.co.th/products/pdp-i5925287379.html",
        "sold": 1
    },
    {
        "product_name": "CCGREAT กระเป๋าเป้สะพายหลังกันน้ำกันน้ำแห้งทนทานต่อเก็บของกระเป๋าน้ำหนักเบาสำหรับตั้งแคมป์กลางแจ้งชายหาดตกปลาโต้คลื่นเรือคายัค",
        "product_image": "https://img.lazcdn.com/g/p/95be1377f58ef446bd41061180eda966.jpg_200x200q90.jpg",
        "price": 6170,
        "remark": "https://www.lazada.co.th/products/pdp-i5955007613.html",
        "sold": 0
    },
    {
        "product_name": "Koklife ถุงแห้งและกันน้ำพีวีซีกระเป๋าเป้สะพายหลังกันน้ำความจุขนาดใหญ่ช่วยให้เกียร์แห้งมัลติฟังก์ชั่กระเป๋ากันน้ำที่ทนทานสำหรับการท่องแพ",
        "product_image": "https://img.lazcdn.com/g/p/eaac949c6c958f35503377404c967329.jpg_200x200q90.jpg",
        "price": 6170,
        "remark": "https://www.lazada.co.th/products/pdp-i6048231763.html",
        "sold": 0
    },
    {
        "product_name": "Benent กระเป๋าแห้งและกันน้ำกันน้ำน้ำหนักเบา,กระเป๋าเป้สะพายหลังกันน้ำแห้งจุของได้เยอะสำหรับพายเรือแคนูกลางแจ้งตั้งแคมป์ท่อง",
        "product_image": "https://img.lazcdn.com/g/p/ab1a14cf92e03cf885e53a6239a45e81.jpg_200x200q90.jpg",
        "price": 6170,
        "remark": "https://www.lazada.co.th/products/pdp-i5867535458.html",
        "sold": 0
    },
    {
        "product_name": "Gamchiano กระเป๋าเป้สะพายหลังกันน้ำ PVC อเนกประสงค์กันน้ำแห้งน้ำหนักเบาพกพาสะดวกสำหรับพายเรือแคนูล่องแก่งว่ายน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/c3a4b1152b790d342c587803b13cde43.jpg_200x200q90.jpg",
        "price": 6170,
        "remark": "https://www.lazada.co.th/products/pdp-i5993608730.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าแห้งและกันน้ำ Phenovo กระเป๋าเป้สะพายหลังกันน้ำใส่อุปกรณ์แห้งแข็งแรงทนทานกระเป๋ากันน้ำความจุมากสำหรับการว่ายน้ำพายเรือแคนูการแล่นเรือใบชายทะเล",
        "product_image": "https://img.lazcdn.com/g/p/7eefdae12387fcf4deee8ff50a9a1e2d.jpg_200x200q90.jpg",
        "price": 6170,
        "remark": "https://www.lazada.co.th/products/pdp-i6018666002.html",
        "sold": 0
    },
    {
        "product_name": "Scubapro - Sport bag 10 กระเป๋าใส่อุปกรณ์ดำน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/49d2e1c2652a1fd73f197a57302842e1.jpg_200x200q90.jpg",
        "price": 6166,
        "remark": "https://www.lazada.co.th/products/pdp-i5622499797.html",
        "sold": 0
    },
    {
        "product_name": "WOTAO กระเป๋ากันน้ำแบบม้วนสำหรับกระเป๋าเป้สะพายหลังกันน้ำสีดำ,กระเป๋าแห้งแบบม้วนสำหรับงานหนักสำหรับพายเรือคายัคล่องแพพายเรือ",
        "product_image": "https://img.lazcdn.com/g/p/8a5be33c30dbdd3ad9da963b45db6db7.jpg_200x200q90.jpg",
        "price": 6165,
        "remark": "https://www.lazada.co.th/products/pdp-i6075222240.html",
        "sold": 0
    },
    {
        "product_name": "Speedo | เป้กีฬาความจุใหญ่กันน้ำ 35 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S82f2f348ddac4a7c9279c5b2d49199ccu.jpg_200x200q90.jpg",
        "price": 6129.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6014169387.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือขนาดเล็กสไตล์หรูหรา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saf578256bbd64661ab8b8105a0766c73Y.jpg_200x200q90.jpg",
        "price": 6128.34,
        "remark": "https://www.lazada.co.th/products/pdp-i6066551153.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากรองน้ำพกพาเบาสุดๆ 1 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4531ea97c95548b79bcd88c615d27f3cQ.png_200x200q90.png",
        "price": 6117.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6002890254.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายข้างหรูหราขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S77507e839db04b5ca82527920ecf506a0.jpg_200x200q90.jpg",
        "price": 6113.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6066437471.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือหรูหราและไม่เหมือนใครสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1ce187a1d16a4187886e9bc97c8c75a40.jpg_200x200q90.jpg",
        "price": 6113.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6066686269.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเป้ ซิปกันละอองน้ำ  ไซส์ L FEELFREE URBANION ECO BACKPACK L",
        "product_image": "https://img.lazcdn.com/g/p/d6dc6527a55dcf7625e5fc0211ad002c.jpg_200x200q90.jpg",
        "price": 6102,
        "remark": "https://www.lazada.co.th/products/pdp-i3143875997.html",
        "sold": 4
    },
    {
        "product_name": "Stream Trail-Marche DX-1 Waterproof Tote Bag 32L",
        "product_image": "https://img.lazcdn.com/g/p/75808e5f79170f8d3314ebfa3d38201f.jpg_200x200q90.jpg",
        "price": 6000,
        "remark": "https://www.lazada.co.th/products/pdp-i404326088.html",
        "sold": 3
    },
    {
        "product_name": "Stream trail Wahoo Long II กระเป๋ากันน้ำ ใส่ ฟินฟรีไดฟ์ มี 6 สี",
        "product_image": "https://img.lazcdn.com/g/p/d5f230f43026e047d94678fd5692c0e1.jpg_200x200q90.jpg",
        "price": 6000,
        "remark": "https://www.lazada.co.th/products/pdp-i4132397739.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่จักรยาน Ostrich L-100 กันนำ้ Made in Japan",
        "product_image": "https://img.lazcdn.com/g/p/97d43a598354f42e38f97e6ff53b19aa.jpg_200x200q90.jpg",
        "price": 6000,
        "remark": "https://www.lazada.co.th/products/pdp-i4135124799.html",
        "sold": 0
    },
    {
        "product_name": "CHAOFANJI | เป้กันน้ำหลายฟังก์ชันความจุมากสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbd455c6797fe40ecbabbe182a1052e7do.jpg_200x200q90.jpg",
        "price": 5990.58,
        "remark": "https://www.lazada.co.th/products/pdp-i5935372178.html",
        "sold": 51
    },
    {
        "product_name": "กระเป๋ากอล์ฟ PGM Golf Cart Bag For Women (QB103) 5 ช่องใส่ไม้กอล์ฟได้แบบครบชุด",
        "product_image": "https://img.lazcdn.com/g/p/bb8aac25076c1fea171bda8eb3f5565a.jpg_200x200q90.jpg",
        "price": 5980.14,
        "remark": "https://www.lazada.co.th/products/pdp-i3356902400.html",
        "sold": 10
    },
    {
        "product_name": "กระเป๋า Alpaka - GO Sling Mini V2 Axoflux",
        "product_image": "https://img.lazcdn.com/g/p/ee12d83278f716917469865eae723d9d.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i5119694947.html",
        "sold": 8
    },
    {
        "product_name": "กระเป๋าถือ ขนาดกลาง TORY BURCH ELEANOR PEBBLED MINI SATCHEL",
        "product_image": "https://img.lazcdn.com/g/p/052e083b28d0ff9bd437e3b1bb5ac2ee.png_200x200q90.png",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i5914093338.html",
        "sold": 0
    },
    {
        "product_name": "Waterproof WPAD Expandable Pocket  (กระเป๋าข้างแบบถอดออกได้ สำหรับเวทสูทรุ่น W5, W50, W30 สามารถขยายขนาดได้ด้วยซิป YKK)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbe1d7d2b4d7846a9825ea8337f47499dT.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i5837302725.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือ shopping มีสายยาว \nขนาดปาก  15.5 นิ้ว ฐาน 12.5 นิ้ว\nอปก ป้ายแท็กถุงผ้า ที่ห้อย ใบลูก \n \n#lyn",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1e280fe6f25e4525abe3952c6420b7b2x.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i4326968541.html",
        "sold": 0
    },
    {
        "product_name": "How กระเป๋าถือ MONOGRAM ทรง Double Top Handle รุ่น HHH0613 ( COLLECTION Taylor )",
        "product_image": "https://img.lazcdn.com/g/p/e713d4057021e1a3046630b824a4bd41.png_200x200q90.png",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i5687531936.html",
        "sold": 1
    },
    {
        "product_name": "เหมาะสำหรับรถ Polaris  SL LE R S SLR 2015-24 กระเป๋าเก็บของด้านข้าง ， กระเป๋าข้าง Mile Master",
        "product_image": "https://img.lazcdn.com/g/p/a9a84b5ef4b81f915a7a9e225de38c14.jpg_webp_200x200q90.jpg",
        "price": 5926.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16123017921.html",
        "sold": 0
    },
    {
        "product_name": "MOMOMOMOKoka กระเป๋ากันน้ำระบายอากาศเก็บของกระเป๋า,ทนทานต่อแห้งและกันน้ำสำหรับพายเรือล่องแพตกปลาพายเรือคายัค",
        "product_image": "https://img.lazcdn.com/g/p/abe8bd847a447018a4d18822358db6f2.jpg_200x200q90.jpg",
        "price": 5904.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16128628002.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเป้ ซิปกันละอองน้ำ ไซส์ M FEELFREE URBANION ECO BACKPACK M",
        "product_image": "https://img.lazcdn.com/g/p/0a3e6483b662add1b1dd6e34908adcf0.jpg_200x200q90.jpg",
        "price": 5310,
        "remark": "https://www.lazada.co.th/products/pdp-i3143869938.html",
        "sold": 2
    },
    {
        "product_name": "Mystery Ranch High Water Lid กระเป๋าเสริมคู่กันน้ำ ใช้เสริมเป้ Guide Light MTและTerraframe pack หรือกับอุปกรณ์อื่นๆได้",
        "product_image": "https://img.lazcdn.com/g/p/029777ca424472854c78c3c4195847fd.jpg_200x200q90.jpg",
        "price": 5900,
        "remark": "https://www.lazada.co.th/products/pdp-i4640312750.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้กันน้ำ ไซส์ M FEELFREE URBANION ECO BACKPACK M",
        "product_image": "https://img.lazcdn.com/g/p/0a3e6483b662add1b1dd6e34908adcf0.jpg_200x200q90.jpg",
        "price": 5900,
        "remark": "https://www.lazada.co.th/products/pdp-i4986136330.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือขนาดเล็กสีชมพูคลุมด้วยเมฆฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd6872cec7a5e44ec8bd1ad94fb46adfbF.jpg_200x200q90.jpg",
        "price": 5871.08,
        "remark": "https://www.lazada.co.th/products/pdp-i6066434733.html",
        "sold": 0
    },
    {
        "product_name": "ถุงกอล์ฟเทเลอร์เมดหนัง pvc ลายเคฟล่า ขนาด 9 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1215542d42fe44cb8923e34fb3ae1299L.jpg_200x200q90.jpg",
        "price": 5859,
        "remark": "https://www.lazada.co.th/products/pdp-i3255502948.html",
        "sold": 28
    },
    {
        "product_name": "ถุงกอล์ฟไนกี้ หนังแก้ว ขนาดปากถุง 9 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2a09e2902b4a44cab7f0d89c4ff33842I.jpg_200x200q90.jpg",
        "price": 5859,
        "remark": "https://www.lazada.co.th/products/pdp-i4426207557.html",
        "sold": 3
    },
    {
        "product_name": "นีโอสป30L กันน้ำกลางแจ้งกระเป๋าเป้สะพายหลังสำหรับว่ายน้ำกระเป๋าเป้กระสอบลอยน้ำน้ำกีฬาพายเรือคายัคล่องแพเดินป่าแม่น้ำ",
        "product_image": "https://img.lazcdn.com/g/p/c9d32d65c12a0c40285ccabf23f99e75.jpg_200x200q90.jpg",
        "price": 5853.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6050379220.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่เชือกยี่ห้อ camnal ความจุ 100ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/5428563894046444e9495c84f3d23013.jpg_200x200q90.jpg",
        "price": 5840,
        "remark": "https://www.lazada.co.th/products/pdp-i5980194994.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือทรงเรขาคณิตสไตล์วินเทจแบบหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sffddaa149c4140279302ed3788f43732Y.png_200x200q90.png",
        "price": 5838.36,
        "remark": "https://www.lazada.co.th/products/pdp-i5881849767.html",
        "sold": 6
    },
    {
        "product_name": "กระเป๋าใส่อุปกรณ์และแม็กจาก Pantac Ind. รุ่น Dual P i s t o l Bag มีบุกันกระแทกด้านใน",
        "product_image": "https://img.lazcdn.com/g/p/a0d0cae5c18ea930d72ac80e71422765.jpg_200x200q90.jpg",
        "price": 5800,
        "remark": "https://www.lazada.co.th/products/pdp-i5168848457.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/tps/imgextra/i3/2104668892/O1CN01Awt7pp2FYatJtjbaW_!!2104668892.jpg_200x200q90.jpg",
        "price": 4480,
        "remark": "https://www.lazada.co.th/products/pdp-i6043357626.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ FEELFREE FLAG TOTE L OSCAR",
        "product_image": "https://img.lazcdn.com/g/p/5d1a8a588ca436c86deb4abc915da11d.jpg_200x200q90.jpg",
        "price": 5800,
        "remark": "https://www.lazada.co.th/products/pdp-i4986144336.html",
        "sold": 0
    },
    {
        "product_name": "Hikosen Cara (Japan) | กระเป๋าถือโทท์สีบล็อกสไตล์มินิมอลความจุมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/See95bdfeda00493a8e11ca544e298ed2V.jpg_200x200q90.jpg",
        "price": 5781.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5909593491.html",
        "sold": 0
    },
    {
        "product_name": "GULL - WATER PROTECT SNORKELING BAG 24L",
        "product_image": "https://img.lazcdn.com/g/p/e68bae610efe7e1e294c852c62590c2e.png_200x200q90.png",
        "price": 5780,
        "remark": "https://www.lazada.co.th/products/pdp-i4682967611.html",
        "sold": 3
    },
    {
        "product_name": "Rally La Costa City Tote & Mini Whisper Bag (Limited) - กระเป๋าทรง Tote และ Bucket ลายโลโก้",
        "product_image": "https://img.lazcdn.com/g/p/2741530cf73859964b7b278aa46da470.jpg_200x200q90.jpg",
        "price": 5780,
        "remark": "https://www.lazada.co.th/products/pdp-i16124161392.html",
        "sold": 0
    },
    {
        "product_name": "Gull - Water Protect Bag Backpack Type 24L  - กระเป๋ากันน้ำ กระเป๋าอุปกรณ์ดำน้ำ",
        "product_image": "https://img.lazcdn.com/g/ot/lzd-client-service/ec1088a9809f8a616cf3708c7f9de650.jpeg_200x200q90.jpg",
        "price": 5780,
        "remark": "https://www.lazada.co.th/products/pdp-i3130297602.html",
        "sold": 5
    },
    {
        "product_name": "GULL WATER PROTECT SNORKELING RUCKSACK 24L กระเป๋ากันน้ำ กระเป๋าอุปกรณ์ดำน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/607fcd2f366dd7e2e36cb8bee3389b50.jpg_200x200q90.jpg",
        "price": 5780,
        "remark": "https://www.lazada.co.th/products/pdp-i5108238008.html",
        "sold": 1
    },
    {
        "product_name": "Charles & Keith | กระเป๋าถือสไตล์เรโทรสีพื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0368f703ee4e4276ac8dd052300b1b0bk.jpg_200x200q90.jpg",
        "price": 5768.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16126895611.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ80ลิตร – 80L WaterPro PVC Dry Bag แบรนด์ WATER PRO",
        "product_image": "https://img.lazcdn.com/g/p/7c01a3f20298677fc4208fc09e9d5373.jpg_200x200q90.jpg",
        "price": 5760,
        "remark": "https://www.lazada.co.th/products/pdp-i399240908.html",
        "sold": 3
    },
    {
        "product_name": "Toughbuilt | เป้สะพายหลังกันน้ำฐานแข็งแรง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S125ac28cc6084fcbab69ea7f4d8d2636P.jpg_200x200q90.jpg",
        "price": 5758.48,
        "remark": "https://www.lazada.co.th/products/pdp-i6002910908.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า tote ขนาดใหญ่สำหรับแม่ ได้แรงบันดาลใจจากคำอธิษฐาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S371d39172f2b43f183ad03a08b6a08f8B.jpg_200x200q90.jpg",
        "price": 5737.92,
        "remark": "https://www.lazada.co.th/products/pdp-i6066722542.html",
        "sold": 0
    },
    {
        "product_name": "toswim | กระเป๋าว่ายน้ำกันน้ำแยกแห้งเปียก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S25e29f23f744462d8d4e9ade5f3f9088U.jpg_200x200q90.jpg",
        "price": 5725.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5893660998.html",
        "sold": 1
    },
    {
        "product_name": "Arcane Warrior | กระเป๋าเก็บของกันน้ำพกพา ความจุใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8b3ba39f8943403ba3c22eb44e29acd1Q.jpg_200x200q90.jpg",
        "price": 5718.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5876911032.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋าถือสะพายไหล่เดี่ยวแบบใหม่ปี 2025 หนังวัวแท้ชั้นบนสุด ดีไซน์มินิมอล ใช้งานได้หลากหลาย กระเป๋าผู้หญิงสุดฮิต ทันสมัย เหมาะสำหรับการเดินทางแบบสบายๆ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2f2a8ebe1c8546b38f744a6ddfcb984c1.jpg_200x200q90.jpg",
        "price": 5708.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16105345151.html",
        "sold": 0
    },
    {
        "product_name": "โปร Mystery Ranch High Water Hip Pack กระเป๋ากันน้ำคาดเอวและคาดอก ซิปกันน้ำและผ้าไนลอนหนาเคลือบ TPU กันน้ำได้แน่นสนิท คล่องตัวตลอดเวลา",
        "product_image": "https://img.lazcdn.com/g/p/fece007ad58d8908866d9182a7d517ab.jpg_200x200q90.jpg",
        "price": 5700,
        "remark": "https://www.lazada.co.th/products/pdp-i4640353998.html",
        "sold": 0
    },
    {
        "product_name": "ถุงน้ำหนัก Bulgarian Bag 12kg/กระสอบทรายการฝึกอบรมการออกกำลังกายโยคะหนักออกกำลังกายยิม",
        "product_image": "https://img.lazcdn.com/g/p/a71a00a9cfc805a8b00f8398bfd1f8f9.jpg_200x200q90.jpg",
        "price": 5700,
        "remark": "https://www.lazada.co.th/products/pdp-i4789279004.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาสะพายไหล หนงแท สำหรบสาวออฟฟศ ใชไดทกวน ดไซนเรยบงาย หนงววแท",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sea9559f5657f417fb5ae8971c7ee7d5fK.png_200x200q90.png",
        "price": 5696.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16118102391.html",
        "sold": 0
    },
    {
        "product_name": "✈→◫2L5L10L/20L40L70L Waterproof Dry Bag Waterproof Exped Small Lighweight Dry Bag for Kayaking,Swimming,Fishing,Rafting,Floating◫✈",
        "product_image": "https://img.lazcdn.com/g/p/68e00dbac30071ccc4b831421ecbf707.png_200x200q90.png",
        "price": 5668.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16081485448.html",
        "sold": 0
    },
    {
        "product_name": "Arena กระเป๋าว่ายน้ำ45L ความจุขนาดใหญ่กีฬาฟิตเนสกระเป๋าผู้ชายและผู้หญิงกระเป๋าเป้สะพายหลังหลายชั้น21ปีกระเป๋าใหม่",
        "product_image": "https://img.lazcdn.com/g/p/2d3c1575f5cd0aa65696ed2acebef482.jpg_200x200q90.jpg",
        "price": 5654.04,
        "remark": "https://www.lazada.co.th/products/pdp-i4253540490.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1bca9af9e4d6495697bdf236969b8b931.jpg_200x200q90.jpg",
        "price": 5642.86,
        "remark": "https://www.lazada.co.th/products/pdp-i6066608447.html",
        "sold": 0
    },
    {
        "product_name": "เป้สะพายหลังกันน้ำเพื่อการล่องเรือ 60 ลิตร (สีดำ)",
        "product_image": "https://img.lazcdn.com/g/p/430e13005e6f4e0201e62e1415be8f1f.jpg_200x200q90.jpg",
        "price": 5618,
        "remark": "https://www.lazada.co.th/products/pdp-i4466122108.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน  cmmg  Derya   เดย่า   กระเป๋า หนัง สีดำ    กระเป๋า พร้อม สายสะพาย ไหล่     กระเป๋า ยาว 102 เซน   กว้าง 26 เซน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd6fb2a10571e4faf922ea12d5d5b30bf8.jpg_200x200q90.jpg",
        "price": 5600,
        "remark": "https://www.lazada.co.th/products/pdp-i4702977993.html",
        "sold": 0
    },
    {
        "product_name": "Stream Trail-Marche DX-2 Waterproof Tote/Shoulder Bag 16L",
        "product_image": "https://img.lazcdn.com/g/p/b171f580fd23fc9106e06da2395c4aef.jpg_200x200q90.jpg",
        "price": 5600,
        "remark": "https://www.lazada.co.th/products/pdp-i405250164.html",
        "sold": 4
    },
    {
        "product_name": "✨ ปรับราคาลง ✨ 💼 กระเป๋าสะพายข้าง / กระเป๋าถือ รุ่นเล็ก",
        "product_image": "https://img.lazcdn.com/g/p/daf7426d5c01552b62f24a0362ac2df4.png_200x200q90.png",
        "price": 5600,
        "remark": "https://www.lazada.co.th/products/pdp-i5883960523.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้สะพายหลังกันน้ำ ขนาด 60 ลิตร FEELFREE DRY TANK 60L",
        "product_image": "https://img.lazcdn.com/g/p/99a2734152fa7c99f304bd6b423251b7.jpg_200x200q90.jpg",
        "price": 4760,
        "remark": "https://www.lazada.co.th/products/pdp-i4640599673.html",
        "sold": 0
    },
    {
        "product_name": "ของแท้ กระเป๋าถือผู้หญิงทันสมัย กระเป๋าถือทั่วไป ความจุมาก สำหรับใช้ประจำวัน F58292 ขนาด：30cmx26cmx15cm",
        "product_image": "https://img.lazcdn.com/g/p/81b589e34304dbeb7ad4818ed71065cf.jpg_200x200q90.jpg",
        "price": 5600,
        "remark": "https://www.lazada.co.th/products/pdp-i16135821015.html",
        "sold": 0
    },
    {
        "product_name": "[พร้อมส่ง] เป้สะพายหลังกันน้ำ ขนาด 25 ลิตร Water Backpack",
        "product_image": "https://img.lazcdn.com/g/p/8e6b2b178661b5772cc8aede8bd6f8be.jpg_200x200q90.jpg",
        "price": 5600,
        "remark": "https://www.lazada.co.th/products/pdp-i2527079769.html",
        "sold": 0
    },
    {
        "product_name": "AquaPlay | เป้กันน้ำความจุสูงแยกของแห้งและของเปียก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0aab1e36d0384514892b90d7a093e10fn.jpg_200x200q90.jpg",
        "price": 5588.46,
        "remark": "https://www.lazada.co.th/products/pdp-i6027433056.html",
        "sold": 4
    },
    {
        "product_name": "PGM GOLF | ปกป้องถุงกอล์ฟสำหรับการเดินทางทางอากาศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S95f6834fea6b4440b112779603a2d49cF.jpg_200x200q90.jpg",
        "price": 5504.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16053729847.html",
        "sold": 21
    },
    {
        "product_name": "Stream Trail-Mussel 6.5L Flap Bag กระเป๋าสะพายข้าง",
        "product_image": "https://img.lazcdn.com/g/p/mdc/74ebc9be2cad520b188d1106113f1838.jpg_200x200q90.jpg",
        "price": 5500,
        "remark": "https://www.lazada.co.th/products/pdp-i746698827.html",
        "sold": 2
    },
    {
        "product_name": "Case-Mate Jelly Tote Bow with Pouch กระเป๋าสะพายข้างดีไซน์โบว์หวาน พร้อมซองกันน้ำสำหรับสมาร์ทโฟน",
        "product_image": "https://img.lazcdn.com/g/p/12d29e9c869414cc5dcda3668f39ba62.jpg_200x200q90.jpg",
        "price": 5500,
        "remark": "https://www.lazada.co.th/products/pdp-i16123830397.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเดินทางกันน้ำพกพาได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd604860b978b4168a2829f909ec185b6q.jpg_200x200q90.jpg",
        "price": 5496,
        "remark": "https://www.lazada.co.th/products/pdp-i16124333030.html",
        "sold": 0
    },
    {
        "product_name": "Sunloke กระเป๋าแห้งและกันน้ำ6x น้ำหนักเบาสำหรับผู้หญิงผู้ชายสำหรับล่องแพท่องชายหาด",
        "product_image": "https://img.lazcdn.com/g/p/6136e1f68a7a9d631cf083a9ad350111.jpg_200x200q90.jpg",
        "price": 5496,
        "remark": "https://www.lazada.co.th/products/pdp-i16047917288.html",
        "sold": 0
    },
    {
        "product_name": "muva|กระเป๋าถือหนังขนาดใหญ่ หลายวิธีในการพกพา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S58e26318ba414b449ceb42180ddb5221n.jpg_200x200q90.jpg",
        "price": 5473.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6003003794.html",
        "sold": 11
    },
    {
        "product_name": "WinnerGolf ถุงกอล์ฟ แบบพกพา คุณภาพสูง สําหรับทุกเพศ รหัสสินค้า QB001",
        "product_image": "https://img.lazcdn.com/g/p/5f56103bd3448623cfd25d05ba5206cb.jpg_200x200q90.jpg",
        "price": 5469.3,
        "remark": "https://www.lazada.co.th/products/pdp-i5043841947.html",
        "sold": 73
    },
    {
        "product_name": "กระเป๋า CRESSI Gorgona Travel Mesh, กระเป๋าอุปกรณ์เบา 107 ลิตร, พับเก็บได้ทรงกลมพร้อมหูหิ้ว, วัสดุตาข่ายโพลีเอสเตอร์ทนทาน, เหมาะสำหรับดำน้ำและฟรีไดฟ์",
        "product_image": "https://img.lazcdn.com/g/p/cd473967c17d5c8170a4cc44510d0e97.jpg_200x200q90.jpg",
        "price": 5450,
        "remark": "https://www.lazada.co.th/products/pdp-i5832441978.html",
        "sold": 0
    },
    {
        "product_name": "LEE กระเป๋าหิ้วโคเวอร์พับได้แบบมีสไตล์ LEE สีดำกันน้ำสำหรับผู้หญิง,กระเป๋าใส่โทรศัพท์กระเป๋าบุรุษสะพายเฉียงลำลองสำหรับใส่ไปทำงานกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sccf9f689b4d6416cbacee4a836403d724.jpg_200x200q90.jpg",
        "price": 5428,
        "remark": "https://www.lazada.co.th/products/pdp-i16044639273.html",
        "sold": 0
    },
    {
        "product_name": "♪♪▣Large Capacity Waterproof Storage Bag for Fitness Clothing Swimming and Toiletries Stylish Drawstring Pouch for Men and Women▣✈",
        "product_image": "https://img.lazcdn.com/g/p/61d136f45e59d1d3525b90598100903e.png_200x200q90.png",
        "price": 5409.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16089188119.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือแบบคล้องไหล่ลายหนัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdf035fde08ad4a86870df5df1bab4568L.png_200x200q90.png",
        "price": 5400.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5881782414.html",
        "sold": 6
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้กันน้ำ กระเป๋าสะพายหลัง ลายพราง FEELFREE ROADSTER UR CAMO",
        "product_image": "https://img.lazcdn.com/g/p/7381118a0c5ae53c7dcd1bd2c63f5c53.jpg_200x200q90.jpg",
        "price": 4590,
        "remark": "https://www.lazada.co.th/products/pdp-i2988745217.html",
        "sold": 16
    },
    {
        "product_name": "FEELFREE ROADSTER UR CAMO กระเป๋า เป้ กันน้ำ พรีเมียม ดีไซน์แบบใหม่ ทนทาน by Jeep Camping",
        "product_image": "https://img.lazcdn.com/g/p/595862c8d2c14b63825f8e19f337db20.jpg_200x200q90.jpg",
        "price": 5400,
        "remark": "https://www.lazada.co.th/products/pdp-i16058493141.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน  cmmg  Derya  MK12 - 9.5 นิ้ว  /  Brigade 9mm AR9    กระเป๋า หนัง สีดำ    กระเป๋า พร้อม สายสะพาย ไหล่     กระเป๋า ยาว 76 เซน   กว้าง 28 เซน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7b579dfdae604c5c8dc9bf6b447e49f4D.jpg_200x200q90.jpg",
        "price": 5400,
        "remark": "https://www.lazada.co.th/products/pdp-i508186688.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้สะพายหลังกันน้ำ ลายพราง ขนาด15ลิตร FEELFREE ROADSTER UR CAMO",
        "product_image": "https://img.lazcdn.com/g/p/35972c1acc21da48f81a91092db4a9a7.jpg_200x200q90.jpg",
        "price": 5400,
        "remark": "https://www.lazada.co.th/products/pdp-i2488519279.html",
        "sold": 5
    },
    {
        "product_name": "Korea Malbon Golf Bag 26 New Waterproof Gun Bag Fashionable Lightweight Unisex Practice Small Club Bag",
        "product_image": "https://img.lazcdn.com/g/p/35bd261da9cc68e27a3a7febba69541d.jpg_200x200q90.jpg",
        "price": 5323.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16141266255.html",
        "sold": 0
    },
    {
        "product_name": "Stream Trail-Mero 2 23L Waterproof Duffle Bag",
        "product_image": "https://img.lazcdn.com/g/p/2f5673a710911f1d8fe1f198bf123b3a.jpg_200x200q90.jpg",
        "price": 5300,
        "remark": "https://www.lazada.co.th/products/pdp-i999262231.html",
        "sold": 0
    },
    {
        "product_name": "[NEW ARRIVAL] FEELFREE NEW DRY TANK กระเป๋าเป้กันน้ำ สำหรับสายลุย ขนาด 33 ลิตร รุ่นใหม่ล่าสุด",
        "product_image": "https://img.lazcdn.com/g/p/7a73f8065e2dee2519cfda01bb2c0119.jpg_200x200q90.jpg",
        "price": 5300,
        "remark": "https://www.lazada.co.th/products/pdp-i5943156017.html",
        "sold": 0
    },
    {
        "product_name": "🎒 กระเป๋าสะพายดีไซน์หรู",
        "product_image": "https://img.lazcdn.com/g/p/02ccaa44a550d3043ec70745235d1337.png_200x200q90.png",
        "price": 5300,
        "remark": "https://www.lazada.co.th/products/pdp-i5910815294.html",
        "sold": 0
    },
    {
        "product_name": "[NEW ARRIVAL] FEELFREE NEW DRY TANK กระเป๋าเป้กันน้ำ รุ่นใหม่ล่าสุด ขนาด 33 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/7a73f8065e2dee2519cfda01bb2c0119.jpg_200x200q90.jpg",
        "price": 5300,
        "remark": "https://www.lazada.co.th/products/pdp-i5988646241.html",
        "sold": 0
    },
    {
        "product_name": "[NEW ARRIVAL] FEELFREE NEW DRY TANK กระเป๋าเป้กันน้ำ ขนาด 33 ลิตร รุ่นใหม่ล่าสุด",
        "product_image": "https://img.lazcdn.com/g/p/7a73f8065e2dee2519cfda01bb2c0119.jpg_200x200q90.jpg",
        "price": 5300,
        "remark": "https://www.lazada.co.th/products/pdp-i5939369853.html",
        "sold": 0
    },
    {
        "product_name": "Waterproof Bag กระเป๋ากันน้ำ Stream Trail รุ่น SD Waist Bag II แบรนด์กระเป๋ากันน้ำอันดับ 1จากประเทศญี่ปุ่น (มี 3 สีให้เลือก)",
        "product_image": "https://img.lazcdn.com/g/p/e56400a7774bf0b8aaca70e13428436a.jpg_200x200q90.jpg",
        "price": 5300,
        "remark": "https://www.lazada.co.th/products/pdp-i415974124.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้สะพายหลังกันน้ำ FEELFREE BLUE RIDGE BACKPACK",
        "product_image": "https://img.lazcdn.com/g/p/dc3f88bac6615568f119bd0fc1cb60e6.jpg_200x200q90.jpg",
        "price": 3998,
        "remark": "https://www.lazada.co.th/products/pdp-i4642589197.html",
        "sold": 3
    },
    {
        "product_name": "กระเป๋าถือสองหูวงกลมอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfb7cdebbda7d4c67bbb31b0a804ee63cX.png_200x200q90.png",
        "price": 5278.76,
        "remark": "https://www.lazada.co.th/products/pdp-i5881851564.html",
        "sold": 7
    },
    {
        "product_name": "กระเป๋าถือแฟชั่น รุ่น 3063",
        "product_image": "https://img.lazcdn.com/g/p/a4234721401f11980b684be37f79d759.jpg_200x200q90.jpg",
        "price": 5264,
        "remark": "https://www.lazada.co.th/products/pdp-i5354149586.html",
        "sold": 0
    },
    {
        "product_name": "Huron Dry DX Mesh Backpack กระเป๋าเป้ตาข่ายเสริมความแข็งแรงเป็นพิเศษ น้ำหนักเบา ระบายอากาศดี ขนาด 60 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/5cec123a9b7bfc094f4a9a98a32a5eef.jpg_200x200q90.jpg",
        "price": 5220,
        "remark": "https://www.lazada.co.th/products/pdp-i5596408247.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ แบบกระเป๋าเป้สะพายหลัง กระเป๋าโน๊ตบุ๊คกันน้ำ  FEELFREE ROADSTER UR 25L",
        "product_image": "https://img.lazcdn.com/g/p/00128fcaaff7b15990b03b96977508ae.jpg_200x200q90.jpg",
        "price": 5220,
        "remark": "https://www.lazada.co.th/products/pdp-i2427408643.html",
        "sold": 15
    },
    {
        "product_name": "เป้สกีกันน้ำแยกช่องแห้งและเปียก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S30ab1cb8ce9d4142928021e81d213fa8c.jpg_200x200q90.jpg",
        "price": 5204.3,
        "remark": "https://www.lazada.co.th/products/pdp-i6066652590.html",
        "sold": 0
    },
    {
        "product_name": "Sea to Summit | เป้สะพายหลังกันน้ำและเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc08a354f50df498699a2e75a6625f107I.png_200x200q90.png",
        "price": 5200.82,
        "remark": "https://www.lazada.co.th/products/pdp-i6001569604.html",
        "sold": 0
    },
    {
        "product_name": "[พร้อมส่ง] เป้สะพายหลังกันน้ำเพื่อการล่องเรือ 60 ลิตร Waterproof Duffle Bag",
        "product_image": "https://img.lazcdn.com/g/p/a13acf760eefa550ab3660a839f60d32.png_200x200q90.png",
        "price": 5200,
        "remark": "https://www.lazada.co.th/products/pdp-i4461255317.html",
        "sold": 0
    },
    {
        "product_name": "FEELFREE TRACK 25L กระเป๋าเป้กันน้ำ พรีเมี่ยม",
        "product_image": "https://img.lazcdn.com/g/p/82ecd7f9f7471e69deefe73c0e252edb.jpg_200x200q90.jpg",
        "price": 4420,
        "remark": "https://www.lazada.co.th/products/pdp-i4461562920.html",
        "sold": 6
    },
    {
        "product_name": "กระเป๋าคล้องแขน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se94d1133e0f740c3bfe543a8bf19963b8.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i5067660714.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายข้าง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6d3c5a08da4d4e01883d1cce964374ba4.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i5695803683.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟสำหรับเด็กพกพาได้สะดวก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sccbe7121b35140149c6e9e8128f5e8540.jpg_200x200q90.jpg",
        "price": 5166.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16054119604.html",
        "sold": 0
    },
    {
        "product_name": "Charles & Keith | กระเป๋าถือสำหรับผู้หญิงไซส์กลาง สปริง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6b3e217734974b6a8423bcd721134134l.png_200x200q90.png",
        "price": 5162.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16128635288.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาสะพายขาง กระเปาทำงาน กระเปาชอปปง กระเปานกเรยน กระเปาแฟชน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S437ce122796049dbb123523b818a3192l.png_200x200q90.png",
        "price": 5154.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16099381662.html",
        "sold": 0
    },
    {
        "product_name": "LA FESTIN FUFU กระเป๋าหนังแท้สะพายข้าง กระเป๋าถือทรงเหลี่ยม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb3498fb3ae134eac8d0250bbd58c6183T.png_200x200q90.png",
        "price": 5149.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5892365475.html",
        "sold": 319
    },
    {
        "product_name": "Balneaire | กระเป๋าถือสำหรับว่ายน้ำกันน้ำและกันทราย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4f9720c4b81a4725b9278ed6a8cfc800W.jpg_200x200q90.jpg",
        "price": 5141.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5893709357.html",
        "sold": 15
    },
    {
        "product_name": "toswim | กระเป๋าเก็บชุดว่ายน้ำกันน้ำ พร้อมแยกแห้ง/เปียก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S34f26d4912964f488413ce92a875c2d3X.jpg_200x200q90.jpg",
        "price": 5113.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5914214538.html",
        "sold": 0
    },
    {
        "product_name": "กระเปา EVA กนนำสำหรบวนหยดพกผอน ชายหาด สระวายนำ และกจกรรมทางนำในฤดรอน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4ad7e668bc0746e3a9fd4ee8e21cfb742.jpg_200x200q90.jpg",
        "price": 5103.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16069168562.html",
        "sold": 0
    },
    {
        "product_name": "สายกระเป๋าเก็บของสกีกระเป๋าสโนว์บอร์ดทนต่อการขีดข่วนปรับได้",
        "product_image": "https://img.lazcdn.com/g/p/89cba6f15ddd403106814a24733ff783.jpg_200x200q90.jpg",
        "price": 5084,
        "remark": "https://www.lazada.co.th/products/pdp-i6024671718.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาถอแบบลำลอง กระเปาเสรมสำหรบเดนทาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S55aff1dc45694d0691ea322bed74bd325.png_200x200q90.png",
        "price": 4894.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16121582331.html",
        "sold": 0
    },
    {
        "product_name": "[PGM GOLF] ถุงกอล์ฟ EXCEED รุ่นใหม่ ขนาดใหญ่ 9.5 นิ้ว 3.5kg แบรนด์ EXCEED รหัสสินค้า QBE002",
        "product_image": "https://img.lazcdn.com/g/p/a8a0ed8ad7dfc7b11d69bda1f703df51.jpg_200x200q90.jpg",
        "price": 5052,
        "remark": "https://www.lazada.co.th/products/pdp-i5497780354.html",
        "sold": 0
    },
    {
        "product_name": "Almencla กระเป๋าหิ้วของขวัญอเนกประสงค์สำหรับผู้เริ่มต้น,อุปกรณ์เสริมเรือคายัคเป่าลมป้องกันกระเป๋าใส่เรือพองกระเป๋าเก็บของสำหรับผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/p/cb5e383302ff1e037ae803287e5841f8.jpg_200x200q90.jpg",
        "price": 5042,
        "remark": "https://www.lazada.co.th/products/pdp-i16126499915.html",
        "sold": 0
    },
    {
        "product_name": "เป้สกีแยกช่องเปียกแห้ง 68 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se4b6bb6aaa4e4202a75f11a6b68f8b67L.jpg_200x200q90.jpg",
        "price": 5041.54,
        "remark": "https://www.lazada.co.th/products/pdp-i6066762444.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายผู้หญิงทรงสี่เหลี่ยม หนังและฟลันเนล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4bf7cc83774241be962ceaff46bcf702U.jpg_200x200q90.jpg",
        "price": 5038.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6002079620.html",
        "sold": 1
    },
    {
        "product_name": "SMOSMOS | กระเป๋าฝรั่งเศสแบบสะพายไหล่เดียว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8a6bb7fd70364098b18904369d26867fB.jpg_200x200q90.jpg",
        "price": 5023.62,
        "remark": "https://www.lazada.co.th/products/pdp-i6066601639.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | เป้สะพายหลังกันน้ำ น้ำหนักเบา ความจุมาก สำหรับเดินป่าและใช้ที่ชายหาด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sefcc1609e129491c8468d648fa945fc3Q.jpg_200x200q90.jpg",
        "price": 5015.28,
        "remark": "https://www.lazada.co.th/products/pdp-i16110255232.html",
        "sold": 0
    },
    {
        "product_name": "[พร้อมส่ง] เป้สะพายหลังกันน้ำ ขนาด 20 ลิตร Waterproof Backpack",
        "product_image": "https://img.lazcdn.com/g/p/9f1b126275905017858c30d7beafbc56.jpg_200x200q90.jpg",
        "price": 5000,
        "remark": "https://www.lazada.co.th/products/pdp-i220938846.html",
        "sold": 0
    },
    {
        "product_name": "ซองปืนยาว   กระเป๋าปืนยาว ลายพราง   ยาว 53นิ้ว  กว้าง 10นิ้ว   1ใบ  //   หูกวิน  1คู่   //  สายสะพาย  2จุด   1เส้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S31e1fd4b3bb2470e9c97eb75b7e718f6b.jpg_200x200q90.jpg",
        "price": 5000,
        "remark": "https://www.lazada.co.th/products/pdp-i386340622.html",
        "sold": 0
    },
    {
        "product_name": "GIVI Prime PWB03 (2ltr) กระเป๋าคาดเอวกันนํ้า",
        "product_image": "https://img.lazcdn.com/g/p/3fc51c87aa968cbca11c4892b54f18b8.png_200x200q90.png",
        "price": 5000,
        "remark": "https://www.lazada.co.th/products/pdp-i5156086676.html",
        "sold": 0
    },
    {
        "product_name": "ซองปืนยาว  กระเป๋าปืนยาว  ลายพราง   ยาว 53นิ้ว   กว้าง 10นิ้ว 1ใบ  //  หูกวิน 1คู่ //  สายสะพาย 2จุด 1เส้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5ca57e55f523401fab0a63d67fb01109b.jpg_200x200q90.jpg",
        "price": 5000,
        "remark": "https://www.lazada.co.th/products/pdp-i5068095556.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้กันน้ำ ขนาด 25L  กระเป๋ากันน้ำ FEELFREE  METRO 25L",
        "product_image": "https://img.lazcdn.com/g/p/1b9fc32866aefa0f681db6c9422bbc3b.jpg_200x200q90.jpg",
        "price": 5000,
        "remark": "https://www.lazada.co.th/products/pdp-i4986195098.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเก็บอุณหภูมิ ถนอมอาหาร",
        "product_image": "https://img.lazcdn.com/g/p/bfaccd97134daca8a99373d3359ee4d4.jpg_200x200q90.jpg",
        "price": 5000,
        "remark": "https://www.lazada.co.th/products/pdp-i251845016.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ารักษาอุณหภูมิสำหรับเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/b9edf62ff6493c34d8225cf6a00a1f33.jpg_200x200q90.jpg",
        "price": 5000,
        "remark": "https://www.lazada.co.th/products/pdp-i251845014.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเก็บความเย็นสำหรับเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/c269db4253e8607954e4a6d7237eae3e.jpg_200x200q90.jpg",
        "price": 5000,
        "remark": "https://www.lazada.co.th/products/pdp-i251845015.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเป้สะพายหลังแคมป์พักแรมกันน้ำ Hanke (19L)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S774d6a8fb4694ecd8f5aaf3d814260f5a.jpg_200x200q90.jpg",
        "price": 4998,
        "remark": "https://www.lazada.co.th/products/pdp-i5888236898.html",
        "sold": 0
    },
    {
        "product_name": "(แพค100ใบ) 💦ซองกันน้ำลายการ์ตูนแบบคาดเอวสายปรับระดับได้💦  วัสดุ PVC กันน้ำ สัมผัสหน้าจอได้แม้อยู่ในกระเป๋า กระเป๋ากันน้ำสำหรับคาดเอว ล็อค 3 ชั้น สายปรับระดับได้ จุของได้เยอะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa631d81bf2a64c24a266f03c78d3b619w.jpg_200x200q90.jpg",
        "price": 4998,
        "remark": "https://www.lazada.co.th/products/pdp-i5659874101.html",
        "sold": 0
    },
    {
        "product_name": "Chiwanji เรือพองกระเป๋าเก็บของถุงกระเป๋าสะพาย",
        "product_image": "https://img.lazcdn.com/g/p/3795524441f2d12a2d3ec2b61495db77.jpg_200x200q90.jpg",
        "price": 4988,
        "remark": "https://www.lazada.co.th/products/pdp-i16129561723.html",
        "sold": 0
    },
    {
        "product_name": "BNMUSIC กระเป๋าเรือพองพับได้สำหรับกระเป๋าใส่อุปกรณ์เรือคายัคตกปลาผู้ชายสะดวกกระเป๋าหิ้วตั้งแคมป์อเนกประสงค์สำหรับเรือคายัค",
        "product_image": "https://img.lazcdn.com/g/p/0f5ca6d2e29048ba384e03ea4cf202f3.jpg_200x200q90.jpg",
        "price": 4988,
        "remark": "https://www.lazada.co.th/products/pdp-i16128192397.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเรือพอง CCGREAT พับได้กระเป๋าหิ้ววันพ่อ,อุปกรณ์จัดระเบียบเรือยางสำหรับผู้ชายสำหรับเรือเล็กๆทำจากยาง",
        "product_image": "https://img.lazcdn.com/g/p/0a57c67a7b16f7e67abbaf8293cb6b4b.jpg_200x200q90.jpg",
        "price": 4988,
        "remark": "https://www.lazada.co.th/products/pdp-i16131632738.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเรือพอง CCClever พับได้สำหรับผู้ชายเรือประมงเกียร์วอลเปเปอร์หินเรือที่จัดระเบียบกระเป๋าหิ้วเรือคายัคตกปลากระเป๋าใส่อุปกรณ์",
        "product_image": "https://img.lazcdn.com/g/p/5191cbe5e11d1f3cd4c629d76aa79dc2.jpg_200x200q90.jpg",
        "price": 4988,
        "remark": "https://www.lazada.co.th/products/pdp-i16127858171.html",
        "sold": 0
    },
    {
        "product_name": "CARGO CUSTOM BAG L กระเป๋าเก็บอุปกรณ์",
        "product_image": "https://img.lazcdn.com/g/p/f051560f3735b958ffa59d0ca0fd14f1.jpg_200x200q90.jpg",
        "price": 4960,
        "remark": "https://www.lazada.co.th/products/pdp-i4677924218.html",
        "sold": 1
    },
    {
        "product_name": "Phenovo กระเป๋ากันน้ำแห้งเสื้อม้วนสายรัดพาดไหล่ปรับได้ช่วยให้กระเป๋าเป้สะพายหลังแห้งสำหรับสวนน้ำตั้งแคมป์ว่ายน้ำชายหาดแล่นเรือใบ",
        "product_image": "https://img.lazcdn.com/g/p/67c56a0b6fd34ff3ae7ebdd9468bac27.jpg_200x200q90.jpg",
        "price": 4954,
        "remark": "https://www.lazada.co.th/products/pdp-i6012597606.html",
        "sold": 0
    },
    {
        "product_name": "TOOYFUL เสื้อม้วนกระเป๋าแห้งและกันน้ำพร้อม Tali Bahu น้ำหนักเบากระเป๋าเป้กันอากาศแห้งสำหรับแบกเป้พายเรือคายัคแคมป์ปิ้ง",
        "product_image": "https://img.lazcdn.com/g/p/439e593c3b56c4635e30261360f65a54.jpg_200x200q90.jpg",
        "price": 4954,
        "remark": "https://www.lazada.co.th/products/pdp-i6015160381.html",
        "sold": 0
    },
    {
        "product_name": "Ellwewe กระเป๋ากันน้ำแห้งกระเป๋าเก็บของแห้งป้องกันอากาศแห้งกระเป๋าเป้สายพาดไหล่ปรับได้แบบสุญญากาศสำหรับพายเรือคายัคชายหาดแบกเป้",
        "product_image": "https://img.lazcdn.com/g/p/5038d6bff164774d92618f71cd8a0af3.jpg_200x200q90.jpg",
        "price": 4954,
        "remark": "https://www.lazada.co.th/products/pdp-i16121879114.html",
        "sold": 0
    },
    {
        "product_name": "Beatycare กระเป๋าแห้งและกันน้ำเสื้อม้วนสำหรับผู้หญิงถุงกันน้ำผู้ชายถุงแห้งเก็บอุปกรณ์สำหรับล่องแพพายเรือคายัคพายเรือเล่นกีฬาทางน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/439d85326f6d54ea867e8ba55bcc6a38.jpg_200x200q90.jpg",
        "price": 4954,
        "remark": "https://www.lazada.co.th/products/pdp-i16127831348.html",
        "sold": 0
    },
    {
        "product_name": "Moon Lighte กระเป๋าเป้กันน้ำแห้งกระเป๋าเป้สะพายหลังช่วยให้เกียร์แห้งสายพาดไหล่ปรับได้แบบพกพากระเป๋าเก็บของแห้งสำหรับตั้งแคมป์ล่องแก่งเรือคายัค",
        "product_image": "https://img.lazcdn.com/g/p/9c04cb1cec6f3d4e13aa999afb28290a.jpg_200x200q90.jpg",
        "price": 4954,
        "remark": "https://www.lazada.co.th/products/pdp-i5976801547.html",
        "sold": 0
    },
    {
        "product_name": "Sea to summit  Ultra-Silk Garment Mesh SIZE MEDUIM กระเป๋าจัดระเบียบสิ่งของ กระเป๋าอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/p/2f79fc690fa2201b75def5549a9941e1.jpg_200x200q90.jpg",
        "price": 4940,
        "remark": "https://www.lazada.co.th/products/pdp-i4444870721.html",
        "sold": 3
    },
    {
        "product_name": "กระเป๋ากอล์ฟ Titleist แบบพกพา น้ำหนักเบา ใส่ไม้กอล์ฟได้หลายไม้ ดีไซน์เรียบหรู  Stand Bag กระเป๋ากอล์ฟแบบพกพา ดีไซน์พรีเมียม หลากสี QIAB002",
        "product_image": "https://img.lazcdn.com/g/p/a5d787fc66b5ab73c9e01a94d2e6df66.jpg_200x200q90.jpg",
        "price": 4926.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5996016897.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายไหล่กันน้ำหลายฟังก์ชันแยกแห้งเปียก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S66e16f3a525e4ed0973f35c6a874fabak.jpg_200x200q90.jpg",
        "price": 4918,
        "remark": "https://www.lazada.co.th/products/pdp-i16138295268.html",
        "sold": 0
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าหรูหราสำหรับผู้หญิง น้ำหนักเบา สไตล์ใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S403cbc6e46c14bceb006420082dea60es.jpg_200x200q90.jpg",
        "price": 4909,
        "remark": "https://www.lazada.co.th/products/pdp-i16099742274.html",
        "sold": 0
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าสะพายแฟชั่นสำหรับคนทำงาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7a1362bd60e349eeae17a056b93f7432A.jpg_200x200q90.jpg",
        "price": 4909,
        "remark": "https://www.lazada.co.th/products/pdp-i16101671455.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | เป้สะพายหลังกันน้ำ ความจุมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S531b3b9fdbf84b5abaf6447c4a4f9950S.png_200x200q90.png",
        "price": 4900.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16099452134.html",
        "sold": 2
    },
    {
        "product_name": "กระเป๋าใส่ปืน สมิธ Smith ลูกโม่ 5นิ้ว - 6นิ้ว  มีช่องใส่ลูก 2แถว   ช่องใส่ลูก สำหรับ  .38  357  9mm  9มม   ( 1ใบ )  และ ที่ใส่ลูก เหน็บเอว  .38   357   9มม   ( 1อัน )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc505bc5b28fd4cb1acb31784dc985aa6m.jpg_200x200q90.jpg",
        "price": 4900,
        "remark": "https://www.lazada.co.th/products/pdp-i1037620836.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเกลือกตลกใหม่ กระเป๋าเกลือกสำหรับเล่นกอล์ฟแบบอเนกประสงค์สำหรับผู้ชายและผู้หญิง กระเป๋าเกลือกแบบพกพาที่เบาและทนทานต่อฝน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0ccd8c9f6da4455fba787575d26ffe37I.jpg_200x200q90.jpg",
        "price": 4890.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5691286368.html",
        "sold": 21
    },
    {
        "product_name": "Hanayo | กระเป๋าถือสตรีหรูหราสไตล์ใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9cbef2d8ed0c4db3969fe5153435884bu.jpg_200x200q90.jpg",
        "price": 4880.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6017948801.html",
        "sold": 0
    },
    {
        "product_name": "Misty Mynx Drawstring Shoulder Bag กระเป๋าสะพายไหล่แบบมีเชือกรูด รุ่น M26SBWA004 (SS26 #A1)",
        "product_image": "https://img.lazcdn.com/g/p/c5bd50d7dfad18f8e143d6d9c855f20a.jpg_200x200q90.jpg",
        "price": 4878.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16091681425.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าบุฟองน้ำอย่างดีสำหรับใส่ แบนโจ TGI รุ่น 4839",
        "product_image": "https://img.lazcdn.com/g/p/c87f5918e0198a2edec4ae96fcc2e79c.jpg_200x200q90.jpg",
        "price": 4840,
        "remark": "https://www.lazada.co.th/products/pdp-i4048047574.html",
        "sold": 0
    },
    {
        "product_name": "PGM|กระเป๋ากอล์ฟพกพาได้ 14 ช่อง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb6251f4a9a5d45c5a5109816cc43a1b1b.jpg_200x200q90.jpg",
        "price": 7726.32,
        "remark": "https://www.lazada.co.th/products/pdp-i6003199499.html",
        "sold": 18
    },
    {
        "product_name": "26 Arena Arena Swimming Shoulder Bag Portable Dry And Wet Separation Waterproof Wear-resistant Large Capacity Sports Bag For Men And Women",
        "product_image": "https://img.lazcdn.com/g/p/bec348afcff1718280cb5053adb58d66.jpg_200x200q90.jpg",
        "price": 4834,
        "remark": "https://www.lazada.co.th/products/pdp-i16082903737.html",
        "sold": 0
    },
    {
        "product_name": "FANJI PROJECT | เป้สะพายหลังกระดาษ Dupont ไอออนเงินป้องกันแบคทีเรีย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6cbea6b20ff24cf5974cd5e876b6b5424.jpg_200x200q90.jpg",
        "price": 4822,
        "remark": "https://www.lazada.co.th/products/pdp-i16078177259.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | เป้กันน้ำหลายฟังก์ชั่นสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbac0a6efbf3a4674b6881b12e7e6fd2fv.jpg_200x200q90.jpg",
        "price": 4818.26,
        "remark": "https://www.lazada.co.th/products/pdp-i6062703283.html",
        "sold": 0
    },
    {
        "product_name": "Pecine กระเป๋าป้องกันเรือพองพับได้สะดวกสำหรับผู้เริ่มต้นตั้งแคมป์กระเป๋าหิ้วแบบพกพาสำหรับเรือประมงเรือคายัค",
        "product_image": "https://img.lazcdn.com/g/p/0f5ca6d2e29048ba384e03ea4cf202f3.jpg_200x200q90.jpg",
        "price": 4813.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16128226022.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเรือพองพับได้แบบกระเป๋าหิ้ววันพ่อ,กระเป๋าอเนกประสงค์เครื่องประดับเรือคายัคเป่าลมสำหรับเรือเล็กทำจากยาง",
        "product_image": "https://img.lazcdn.com/g/p/82c25c5be2e915fc4b2312e7caeb52be.jpg_200x200q90.jpg",
        "price": 4813.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16127416263.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน  กล็อก26   glock26    กล็อก43   glock43   sig p365    หนังสีดำ    ( 1ใบ  )   และ   กระเป๋าใส่ลูก   9มม   .38    357   ( 2ใบ )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa80b932034b44b33aebd5088c8fc18c1e.jpg_200x200q90.jpg",
        "price": 4800,
        "remark": "https://www.lazada.co.th/products/pdp-i5272016963.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้สะพายหลังกันน้ำ FEELFREE DRY TANK 40L",
        "product_image": "https://img.lazcdn.com/g/p/21385acc18ca5a228b5b63dd9f076c6b.jpg_200x200q90.jpg",
        "price": 4320,
        "remark": "https://www.lazada.co.th/products/pdp-i4627691689.html",
        "sold": 1
    },
    {
        "product_name": "SMOSMOS | กระเป๋าถือหรือสะพายข้างวินเทจสไตล์กำมะหยี่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sca243e869de64313853cfdd662278620h.jpg_200x200q90.jpg",
        "price": 4799.58,
        "remark": "https://www.lazada.co.th/products/pdp-i6066398676.html",
        "sold": 0
    },
    {
        "product_name": "PGM Golf Aviation Bag Hard Shell Anti Collision Squeeze Aircraft Consignment Men Women Belt Roller Skating Travel Bags HKB014",
        "product_image": "https://img.lazcdn.com/g/p/86e1c7d5f9aadc24546bad61d97aa2f8.jpg_200x200q90.jpg",
        "price": 4798,
        "remark": "https://www.lazada.co.th/products/pdp-i5692364545.html",
        "sold": 10
    },
    {
        "product_name": "GOULLES | กระเป๋าถือผ้าแคนวาสพิมพ์ลายขนนก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S49b915ca8eb141e0a78b831154c73a3cv.jpg_200x200q90.jpg",
        "price": 4794,
        "remark": "https://www.lazada.co.th/products/pdp-i16080458500.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายข้างสำหรับผู้หญิงแบบหรูหรา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2c4eab0a65b04a95a2be9e38029e9647c.jpg_200x200q90.jpg",
        "price": 4791.88,
        "remark": "https://www.lazada.co.th/products/pdp-i6066754564.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากอล์ฟ PGM Stand Bag (QB027) มีให้เลือก 3 สี พร้อมส่งในไทยทันที",
        "product_image": "https://img.lazcdn.com/g/p/3c90319060f49fa3527fb1645ff132f1.jpg_200x200q90.jpg",
        "price": 4782.06,
        "remark": "https://www.lazada.co.th/products/pdp-i1371238847.html",
        "sold": 24
    },
    {
        "product_name": "กระเป๋าถือลายย่น สัมผัสเหมือนเมฆ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/See7e6888a5814129abeed11438e60cf4m.jpg_200x200q90.jpg",
        "price": 4781.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6002172694.html",
        "sold": 0
    },
    {
        "product_name": "Moon Okey กระเป๋าเรือพองพับได้กระเป๋าใส่อุปกรณ์เรือคายัคตกปลาผู้ชายสะดวกสบายมัลติฟังก์ชั่นแคมป์ปิ้งกระเป๋าหิ้วสำหรับเรือคายัค",
        "product_image": "https://img.lazcdn.com/g/p/cb5e383302ff1e037ae803287e5841f8.jpg_200x200q90.jpg",
        "price": 4773.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16128146126.html",
        "sold": 0
    },
    {
        "product_name": "ZYStar กระเป๋าเรือพองพับได้เรือประมงผู้ชายที่จัดระเบียบเกียร์วอลเปเปอร์หินเรือกระเป๋าใส่อุปกรณ์เรือคายัคตกปลากระเป๋าหิ้ว",
        "product_image": "https://img.lazcdn.com/g/p/e9a6425c408dcd7765f5f58bde0471f5.jpg_200x200q90.jpg",
        "price": 4773.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16127476548.html",
        "sold": 0
    },
    {
        "product_name": "Prasku เรือพองกระเป๋าเก็บของถุงกระเป๋าสะพาย",
        "product_image": "https://img.lazcdn.com/g/p/0829f6d4405182ef39b34100c40397c3.jpg_200x200q90.jpg",
        "price": 4773.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16130358027.html",
        "sold": 0
    },
    {
        "product_name": "SMOSMOS | กระเป๋า tote สำหรับธุรกิจและคอมพิวเตอร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S33449ce74001449a8d8edeb379fa3011N.jpg_200x200q90.jpg",
        "price": 4760.44,
        "remark": "https://www.lazada.co.th/products/pdp-i6066667094.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | เป้สะพายหลังกันน้ำขนาดใหญ่จุของได้เยอะและเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd733dc27b7344dcb9e956ff811e342c4A.jpg_200x200q90.jpg",
        "price": 4730.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16111164248.html",
        "sold": 0
    },
    {
        "product_name": "NATUREHIKE Far mountain Lightweight shoulder waterproof bag ขนาด25L กระเป๋ากันน้ำ กระเป๋าสะพายหลัง สำหรับเดินป่า CNH22BB003",
        "product_image": "https://img.lazcdn.com/g/p/8c8e8bde15253e7f2ae5a21c12c320cf.jpg_200x200q90.jpg",
        "price": 4730,
        "remark": "https://www.lazada.co.th/products/pdp-i5196722118.html",
        "sold": 0
    },
    {
        "product_name": "Ortlieb กระเป๋าอเนกประสงค์ Folding Bowl",
        "product_image": "https://img.lazcdn.com/g/p/311802bb63db18564c8c6d5fa7e6cd1f.jpg_200x200q90.jpg",
        "price": 4730,
        "remark": "https://www.lazada.co.th/products/pdp-i4864321398.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาสำหรบพนกงานออฟฟศ กระเปานกศกษา กระเปาสะพายไหล กระเปาแฟชน กระเปาเดนทาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S44dc4f269fdf4776807938ff17a22a03D.png_200x200q90.png",
        "price": 4725.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16099686450.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้สะพายหลังกันน้ำ ขนาด 15 ลิตร FEELFREE ROADSTER UR 15L",
        "product_image": "https://img.lazcdn.com/g/p/ef8bbeb852c9b83cb9e147948eeea9c9.jpg_200x200q90.jpg",
        "price": 4680,
        "remark": "https://www.lazada.co.th/products/pdp-i2488356775.html",
        "sold": 10
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้สะพายหลังกันน้ำ ขนาด 25 ลิตร FEELFREE TRACK 25L",
        "product_image": "https://img.lazcdn.com/g/p/8e1c8ebd1c448d0527fe692e80de96b2.jpg_200x200q90.jpg",
        "price": 4680,
        "remark": "https://www.lazada.co.th/products/pdp-i2488834255.html",
        "sold": 3
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าสะพายกันน้ำ ขนาดใหญ่ พรีเมี่ยม FEELFREE DRY DUFFEL CS 40L",
        "product_image": "https://img.lazcdn.com/g/p/e65832954894f63dc5705040eb7904e9.jpg_200x200q90.jpg",
        "price": 4680,
        "remark": "https://www.lazada.co.th/products/pdp-i2488273955.html",
        "sold": 0
    },
    {
        "product_name": "toswim | กระเป๋ากีฬาแยกช่องเปียกและแห้ง ความจุมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2fb518f83d3747c2acd1ea159b828fbfT.jpg_200x200q90.jpg",
        "price": 4675.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5935351469.html",
        "sold": 6
    },
    {
        "product_name": "toswim | กระเป๋าว่ายน้ำแยกแห้งเปียก ความจุมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S28721fd63d15482ba45cc0f3b61ebe9aT.jpg_200x200q90.jpg",
        "price": 4674,
        "remark": "https://www.lazada.co.th/products/pdp-i5893999440.html",
        "sold": 73
    },
    {
        "product_name": "ZOKE | กระเป๋าใส่ของสำหรับว่ายน้ำแยกช่องเปียกและแห้ง กันน้ำ ความจุสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7c0c7b283cc8466fb6b0fed4857230d18.jpg_200x200q90.jpg",
        "price": 4658.54,
        "remark": "https://www.lazada.co.th/products/pdp-i6050861315.html",
        "sold": 2
    },
    {
        "product_name": "Xinda | เป้สะพายหลังกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8d3d7ada4ab448deaa6d7432e46f1edcg.jpg_200x200q90.jpg",
        "price": 4644.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16049349396.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาสะพายไหลลำลอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S80cfc8a5d48f4617a1ed0434a2bdf4a0V.png_200x200q90.png",
        "price": 4640.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16121241994.html",
        "sold": 0
    },
    {
        "product_name": "Sea to Summit BIG RIVER DRY BAG กระเป๋ากันน้ำ ถุงกันน้ำ Waterproof",
        "product_image": "https://img.lazcdn.com/g/p/1882ee26c91c493c76ca33c08901aa30.jpg_200x200q90.jpg",
        "price": 4640,
        "remark": "https://www.lazada.co.th/products/pdp-i4723903672.html",
        "sold": 9
    },
    {
        "product_name": "Colins Keirs | กระเป๋าสะพายข้างสำหรับธุรกิจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6499daf0a88e4a5789600e23e2a5e7a77.jpg_200x200q90.jpg",
        "price": 4632.64,
        "remark": "https://www.lazada.co.th/products/pdp-i5932790902.html",
        "sold": 3
    },
    {
        "product_name": "LIXADA-ขจัดคราบน้ำกระเป๋าเทรนนิ่งน้ำความหนาแน่นสูงกระเป๋าเทรนนิ่งการฝึกน้ำหนัก/เล่นเวทสำหรับการออกกำลังกายกลางแจ้งแบบครอบครัว",
        "product_image": "https://img.lazcdn.com/g/p/cb6e4c8c2090d1444d877d80c534305f.jpg_200x200q90.jpg",
        "price": 4632,
        "remark": "https://www.lazada.co.th/products/pdp-i5716309357.html",
        "sold": 0
    },
    {
        "product_name": "Osprey | กระเปาแหงกนนำ Osprey Wildwater Dry Bag 15 ลตร / กระเปาเปสะพายหลงสำหรบกฬา ทองเทยว ปนเขา และเดนปา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5e6b99a6a7394eea8b160e098aa8048ep.jpg_200x200q90.jpg",
        "price": 4625.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16076912304.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือแฟชั่น รุ่น B1682",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0e7f2f39ed9345288c617863857c7b81M.jpg_200x200q90.jpg",
        "price": 4624,
        "remark": "https://www.lazada.co.th/products/pdp-i5117605513.html",
        "sold": 0
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าสตรีอเนกประสงค์แบบหรูหราและทันสมัย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb1773399cc6842998d1d82a6db82f069x.jpg_200x200q90.jpg",
        "price": 4619.46,
        "remark": "https://www.lazada.co.th/products/pdp-i5994956577.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋ากอล์ฟ ใส่ไม้กอล์ฟได้ 14 ช่อง แบบมีขาตั้ง (QB027) PGM Pro Golf Master Standard Bag",
        "product_image": "https://img.lazcdn.com/g/p/bb87eb1100794f1f14604d7e6b8f9601.jpg_200x200q90.jpg",
        "price": 4610.66,
        "remark": "https://www.lazada.co.th/products/pdp-i4890096651.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าสะพายข้างกันน้ำ อเนกประสงค์ FEELFREE SPYDER",
        "product_image": "https://img.lazcdn.com/g/p/23f8069ef6a6306138518d5afeb776b2.jpg_200x200q90.jpg",
        "price": 4600,
        "remark": "https://www.lazada.co.th/products/pdp-i4986190100.html",
        "sold": 0
    },
    {
        "product_name": "(รับประกัน 2 ปี!) FEELFREE ROADSTER UR 15L กระเป๋ากันน้ำ กระเป๋าสะพาย ผช ผญ กระเป๋าเป้กันน้ำ กระเป๋าเดินทาง กระเป๋าสะพายหลัง ขนาด 15 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/9a7d2413f12451b86a7e2c4e3bb6fd37.png_200x200q90.png",
        "price": 4600,
        "remark": "https://www.lazada.co.th/products/pdp-i5553440036.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้สะพายหลังกันน้ำ ขนาด 15 ลิตร FEELFREE TRACK 15L",
        "product_image": "https://img.lazcdn.com/g/p/7d03a7304417db0c9bade84b1d7c8562.jpg_200x200q90.jpg",
        "price": 3910,
        "remark": "https://www.lazada.co.th/products/pdp-i2898445721.html",
        "sold": 7
    },
    {
        "product_name": "Hydrapak - Velocity IT 2L hydration bag Clear ถุงน้ำ กระเป๋าน้ำ สำหรับวิ่ง ปั่นจักรยาน น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/29fc4bfcc20d67dad068d8a8dd6758b6.jpg_200x200q90.jpg",
        "price": 4600,
        "remark": "https://www.lazada.co.th/products/pdp-i5946771424.html",
        "sold": 0
    },
    {
        "product_name": "New Balance | กระเปาสะพายขางเดก นวบาลานซ รน NK8AFS704U-19",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf783dbfdc6de461eb9e45c1daef2d5a03.jpg_200x200q90.jpg",
        "price": 4594.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16076937092.html",
        "sold": 0
    },
    {
        "product_name": "New Balance | กระเปาสะพายขางเดก นวบาลานซ รน NK8AFS704U-39",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S164403210d524d72b260cab7e045e2c8r.jpg_200x200q90.jpg",
        "price": 4594.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16076861308.html",
        "sold": 0
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าสะพายไหล่คุณภาพสูงสำหรับเดินทาง พร้อมโซ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S87914e7f609d4748bcdfffb3f953f62cs.jpg_200x200q90.jpg",
        "price": 4587.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5994945058.html",
        "sold": 3
    },
    {
        "product_name": "Lee(ลี) | กระเป๋าสะพายข้างขนาดใหญ่สำหรับฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9e08d402ef4649789da8dad581375ea6R.jpg_200x200q90.jpg",
        "price": 4581.9,
        "remark": "https://www.lazada.co.th/products/pdp-i6066386160.html",
        "sold": 59
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าผ้ากันน้ำแบบสะพายข้าง FEELFREE URBANION ECO MESSENGER BAG",
        "product_image": "https://img.lazcdn.com/g/p/ed382b1c559d27376bc9f0b81b1a55fb.jpg_200x200q90.jpg",
        "price": 4122,
        "remark": "https://www.lazada.co.th/products/pdp-i3143985070.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าปืน   หนังสีดำ  วอลเทอร์ walther ppk/s .380 ACP 9มม / STI ELEKTRA .45 ACP / RETAY 84FS / Makarov / Sig Sauer P239      ( พร้อม กระเป๋าใส่ลูก .38  9มม   357   2อัน )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S81ead471655746feb5b7a0aeadb6ab25m.jpg_200x200q90.jpg",
        "price": 4580,
        "remark": "https://www.lazada.co.th/products/pdp-i5487579338.html",
        "sold": 0
    },
    {
        "product_name": "RUNOFF WATERPROOF HIP PACK กระเป๋ากันน้ำ เคสกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/8f665efcebb9c71ef95a798e207a9ec6.jpg_200x200q90.jpg",
        "price": 4580,
        "remark": "https://www.lazada.co.th/products/pdp-i5075041929.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าผ้ากันน้ำแบบสะพายข้าง FEELFREE URBANION ECO MESSENGER BAG",
        "product_image": "https://img.lazcdn.com/g/p/ed382b1c559d27376bc9f0b81b1a55fb.jpg_200x200q90.jpg",
        "price": 4580,
        "remark": "https://www.lazada.co.th/products/pdp-i6048769334.html",
        "sold": 0
    },
    {
        "product_name": "RS-206 : Pit Bag กระเป๋าพิทน้ำมัน",
        "product_image": "https://img.lazcdn.com/g/p/210b476f1dc0cffb8df265e1da735328.jpg_200x200q90.jpg",
        "price": 4580,
        "remark": "https://www.lazada.co.th/products/pdp-i5675116894.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าผ้ากันน้ำสะพายข้าง FEELFREE URBANION ECO MESSENGER BAG",
        "product_image": "https://img.lazcdn.com/g/p/ed382b1c559d27376bc9f0b81b1a55fb.jpg_200x200q90.jpg",
        "price": 4580,
        "remark": "https://www.lazada.co.th/products/pdp-i6048693842.html",
        "sold": 0
    },
    {
        "product_name": "Xinda | กระเป๋าเก็บของอุปกรณ์ผจญภัยกลางแจ้งกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9df18c4343bd4993b02b76d7f883af2co.jpg_200x200q90.jpg",
        "price": 4569.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16049221190.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ไม้กอล์ฟ 14 ช่อง มีขาตั้ง (QB027) PGM Golf Stand Bag",
        "product_image": "https://img.lazcdn.com/g/p/14e3b566a4e07b9c82482839f69824bf.jpg_200x200q90.jpg",
        "price": 4545.46,
        "remark": "https://www.lazada.co.th/products/pdp-i3602676219.html",
        "sold": 5
    },
    {
        "product_name": "UNDERARMOUR กระเป๋าสะพายหลังผู้ใหญ่ รุ่น UA Hustle 6.0 Backpack /1384672 (ดำลายพราง,ดำ,ม่วง)",
        "product_image": "https://img.lazcdn.com/g/p/7d062b525b6472350b4b85ffe602690b.jpg_200x200q90.jpg",
        "price": 4542,
        "remark": "https://www.lazada.co.th/products/pdp-i5518219930.html",
        "sold": 0
    },
    {
        "product_name": "เข็มขัด ใส่ลูก  .38   9มม   357    1เส้น      และ   กระเป๋า ใส่กระสุน   .38   9มม   357    ใส่ได้ 100นัด    กระเป๋า หนัง สีดำ    ตัว กระเป๋า ยาว 25 เซน    กว้าง 18 เซน   1ใบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S19348f1c117d432e98f372a3ad65df04Y.jpg_200x200q90.jpg",
        "price": 4540,
        "remark": "https://www.lazada.co.th/products/pdp-i5500652763.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากอล์ฟ PGM Stand Bag (QB027) 14 ช่องใส่ไม้กอล์ฟ มีให้เลือก 3 สี",
        "product_image": "https://img.lazcdn.com/g/p/b04557267cd5522357a6265b45c99a8a.jpg_200x200q90.jpg",
        "price": 4534.3,
        "remark": "https://www.lazada.co.th/products/pdp-i1416138513.html",
        "sold": 128
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าถือสำหรับงานแต่งและใช้ทุกวัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S589e97797bc54c149d477d1e61a6feed2.jpg_200x200q90.jpg",
        "price": 4503.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5994787399.html",
        "sold": 2
    },
    {
        "product_name": "กระเป๋า Alpaka - Flight Pouch X-PAC",
        "product_image": "https://img.lazcdn.com/g/p/5469c9af2e01f7dcc2a5d8dbaac0a205.jpg_200x200q90.jpg",
        "price": 4500,
        "remark": "https://www.lazada.co.th/products/pdp-i5773784730.html",
        "sold": 2
    },
    {
        "product_name": "NEVO RHINO HALF COLOR 5L VEST #9280 เป้น้ำขนาด 5 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/a534abfe9a630ab176e00d938f9e9e1e.jpg_200x200q90.jpg",
        "price": 4500,
        "remark": "https://www.lazada.co.th/products/pdp-i5965255868.html",
        "sold": 0
    },
    {
        "product_name": "[NEW ARRIVAL] FEELFREE NEW DRY TANK กระเป๋าเป้กันน้ำ สุดเท่ จุของได้เยอะ ขนาด 18 ลิตร รุ่นใหม่ล่าสุด",
        "product_image": "https://img.lazcdn.com/g/p/a0d57102d8bc9f85af30428bd4b1e2eb.jpg_200x200q90.jpg",
        "price": 4500,
        "remark": "https://www.lazada.co.th/products/pdp-i5939654376.html",
        "sold": 0
    },
    {
        "product_name": "[NEW ARRIVAL] FEELFREE NEW DRY TANK กระเป๋าเป้กันน้ำ ขนาด 18 ลิตร รุ่นใหม่ล่าสุด",
        "product_image": "https://img.lazcdn.com/g/p/a0d57102d8bc9f85af30428bd4b1e2eb.jpg_200x200q90.jpg",
        "price": 3798,
        "remark": "https://www.lazada.co.th/products/pdp-i5933864465.html",
        "sold": 1
    },
    {
        "product_name": "Pelican Marine Waterproof Phone Sling Bag กระเป๋ากันน้ำ คาดอกหรือคาดเอว สำหรับใส่ Smartphone",
        "product_image": "https://img.lazcdn.com/g/p/f8f792365d21e8c1e6f09f7f55d97b71.jpg_200x200q90.jpg",
        "price": 4500,
        "remark": "https://www.lazada.co.th/products/pdp-i16122158393.html",
        "sold": 0
    },
    {
        "product_name": "NEVO RHINO CLASSIC 5L VEST #9271 เป้น้ำขนาด 5 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/9850cb3370eed89d6dca7722936b6df5.jpg_200x200q90.jpg",
        "price": 4500,
        "remark": "https://www.lazada.co.th/products/pdp-i5965265859.html",
        "sold": 2
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าสะพายข้างกันน้ำ  FEELFREE FREERUNNER EX",
        "product_image": "https://img.lazcdn.com/g/p/268314dabb767655578ac1079e29c103.jpg_200x200q90.jpg",
        "price": 4050,
        "remark": "https://www.lazada.co.th/products/pdp-i2914166118.html",
        "sold": 0
    },
    {
        "product_name": "STREAM TRAIL WP SAKOSH กระเป๋ากันน้ำ 100%",
        "product_image": "https://img.lazcdn.com/g/p/cb778929f6f70f13755ade9596ab1907.jpg_200x200q90.jpg",
        "price": 4500,
        "remark": "https://www.lazada.co.th/products/pdp-i3834524404.html",
        "sold": 0
    },
    {
        "product_name": "Waterproof Bag กระเป๋ากันน้ำ Stream Trail รุ่น WP Sakosh  (มี 5 สีให้เลือก)",
        "product_image": "https://img.lazcdn.com/g/p/af2584caec906df97750ecdcaf9391b6.jpg_200x200q90.jpg",
        "price": 4500,
        "remark": "https://www.lazada.co.th/products/pdp-i1983246295.html",
        "sold": 6
    },
    {
        "product_name": "พร้อมส่งในไทย 💖ของแท้ POP MART The monsters FALL IN WILD Rain boot bag กระเป๋าลาบูบู้รองเท้าบู้ที่ bag cute bag fashion bag",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa17201fa2ca34d3aa07ba1be9ce8400fF.jpg_200x200q90.jpg",
        "price": 4498,
        "remark": "https://www.lazada.co.th/products/pdp-i5361016050.html",
        "sold": 1
    },
    {
        "product_name": "PGM GOLF | กระเป๋าไม้กอล์ฟน้ำหนักเบา ความจุสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sab6dcac537d348f6a25f2e06b3a329e67.jpg_200x200q90.jpg",
        "price": 4493.3,
        "remark": "https://www.lazada.co.th/products/pdp-i6003261897.html",
        "sold": 0
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าถือผู้หญิงสไตล์ใหม่ 2026",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7579a465603245428437ccf259627e9a4.jpg_200x200q90.jpg",
        "price": 4478.94,
        "remark": "https://www.lazada.co.th/products/pdp-i6027745387.html",
        "sold": 9
    },
    {
        "product_name": "tourus | เป้สะพายหลังกันน้ำแยกส่วนเปียกและแห้ง 35 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scf1084c8eb384e2abed0f90b03dbeab5R.jpg_200x200q90.jpg",
        "price": 4468.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16084052728.html",
        "sold": 0
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าถือแฟชั่นสุดเก๋",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa7cf08c7f41f447da5d0138b62062f73m.jpg_200x200q90.jpg",
        "price": 4467.3,
        "remark": "https://www.lazada.co.th/products/pdp-i5994893138.html",
        "sold": 3
    },
    {
        "product_name": "กระเป๋าสำหรับฝึกยกน้ำหนัก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6ee0361a2d0b44468abe6d5dcf1f0068Q.jpg_200x200q90.jpg",
        "price": 4461.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16122807787.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าบอสตันสไตล์เกาหลีแบบลำลองสไตล์วินเทจ กระเป๋าทรงสี่เหลี่ยมเล็ก กระเป๋าสะพายข้าง หนังนุ่ม สไตล์มินิมอลในเมือง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf96874029a4e4ca5b253dbf61b17ea32b.jpg_200x200q90.jpg",
        "price": 4460.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16098230011.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า CRESSI Crete สำหรับดำน้ำตื้นและว่ายน้ำ, น้ำหนักเบา พับเก็บง่าย, ดีไซน์ตาข่ายระบายอากาศ ช่วยให้แห้งเร็ว เหมาะสำหรับพกพาเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/125f8a70d5e97ff0caac8caac7bc67ac.jpg_200x200q90.jpg",
        "price": 4460,
        "remark": "https://www.lazada.co.th/products/pdp-i5832454763.html",
        "sold": 0
    },
    {
        "product_name": "CRESSI CRETE BAG BLACK/BLUE กระเป๋า กระเป๋าใส่อุปกรณ์ดำน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/a5b77094bf450449196e0f4496d6b0c3.jpg_200x200q90.jpg",
        "price": 4460,
        "remark": "https://www.lazada.co.th/products/pdp-i5043240197.html",
        "sold": 0
    },
    {
        "product_name": "ZOKE | เป้สะพายหลังกันน้ำสำหรับว่ายน้ำ ใช้งานได้ทั้งเปียกและแห้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5e8af61deccc491aa5d59f16f8ff75a7L.jpg_200x200q90.jpg",
        "price": 4458.72,
        "remark": "https://www.lazada.co.th/products/pdp-i5934658817.html",
        "sold": 2
    },
    {
        "product_name": "กระเป๋าเชือก Phenovo สำหรับปีนเขากระเป๋าเป้สำหรับปีนเขาหินความจุ25L กระเป๋าเก็บของเชือกสำหรับปีนเขาทำสวนตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/f34e9993f5890be76a16b1282f85576c.png_200x200q90.png",
        "price": 4440,
        "remark": "https://www.lazada.co.th/products/pdp-i5966756146.html",
        "sold": 0
    },
    {
        "product_name": "Gociy กระเป๋าเชือกปีนเขากระเป๋าเป้สะพายหลังสำหรับปีนเขาเสื้อม้วนเข็มขัดพยุงหลังกระเป๋าเก็บของเชือกสำหรับกีฬากลางแจ้งการเดินป่าการก่อสร้าง",
        "product_image": "https://img.lazcdn.com/g/p/c918947090fdffc7bde59a05e7097ba1.jpg_200x200q90.jpg",
        "price": 4440,
        "remark": "https://www.lazada.co.th/products/pdp-i5974281275.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเชือกสำหรับใช้ปีน CCPlanet เสื้อม้วนเชือกเชือกกันน้ำกระเป๋าเก็บของสำหรับการเดินป่าการสร้างสวนการปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/a59643ece45527238efebe506f0eaf89.png_200x200q90.png",
        "price": 4440,
        "remark": "https://www.lazada.co.th/products/pdp-i6004160952.html",
        "sold": 0
    },
    {
        "product_name": "Deevoka กระเป๋าเป้สำหรับปีนเขา,กระเป๋าเป้สะพายหลังสำหรับปีนเขาเข็มขัดพยุงหลังที่ใช้งานได้จริงกันน้ำมีห่วงเชือกสำหรับงานก่อสร้าง",
        "product_image": "https://img.lazcdn.com/g/p/64a94b21034a7fc9bf76c13e85ef1600.png_200x200q90.png",
        "price": 4440,
        "remark": "https://www.lazada.co.th/products/pdp-i6040877138.html",
        "sold": 0
    },
    {
        "product_name": "OCEANARIUM - Dry Bag 50 L: 46cm x 42cm x 28cm, 33cm (strap length to shoulder) กระเป๋าสะพายกันน้ำ ลายน่ารัก",
        "product_image": "https://img.lazcdn.com/g/p/d0d8dcb8bd72c2bb53ed05bbe7f3077e.jpg_200x200q90.jpg",
        "price": 4440,
        "remark": "https://www.lazada.co.th/products/pdp-i4015665328.html",
        "sold": 0
    },
    {
        "product_name": "WDAir กระเป๋าเป้สะพายหลังสำหรับปีนเขา,กระเป๋าเป้สะพายหลังสำหรับปีนเขาปีนเขา25L กันน้ำสามารถจัดเก็บได้อย่างทนทานสำหรับการปีนเขาแคมป์ปิ้งปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/95891ba37bc957af035b1e8fd40507e2.jpg_200x200q90.jpg",
        "price": 4440,
        "remark": "https://www.lazada.co.th/products/pdp-i6002002345.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้ กระเป๋าสะพายหลัง กันน้ำ ขนาด 20L  FEELFREE  DRY TANK TROPICAL 20L",
        "product_image": "https://img.lazcdn.com/g/p/34d6d4595b7cab2df66454d5d38299f9.jpg_200x200q90.jpg",
        "price": 4430,
        "remark": "https://www.lazada.co.th/products/pdp-i4986147313.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้ กระเป๋าสะพายหลัง กันน้ำ ขนาด 20L  FEELFREE  DRY TANK TROPICAL 20L.",
        "product_image": "https://img.lazcdn.com/g/p/34d6d4595b7cab2df66454d5d38299f9.jpg_200x200q90.jpg",
        "price": 4430,
        "remark": "https://www.lazada.co.th/products/pdp-i6012368866.html",
        "sold": 0
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าสะพายไหล่ที่มีสไตล์และใช้งานได้หลากหลาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb0f9fb712c6745d981c50939f99869a5p.jpg_200x200q90.jpg",
        "price": 4429.18,
        "remark": "https://www.lazada.co.th/products/pdp-i5994933186.html",
        "sold": 5
    },
    {
        "product_name": "PGM GOLF | กระเป๋าใส่เสื้อผ้ากอล์ฟกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc3499e65dca3414e8c606c0cfd9fd701j.jpg_200x200q90.jpg",
        "price": 4408.76,
        "remark": "https://www.lazada.co.th/products/pdp-i6072592000.html",
        "sold": 14
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้กันน้ำ ขนาด 15 ลิตร กระเป่ากันน้ำ FEELFREE METRO 15L",
        "product_image": "https://img.lazcdn.com/g/p/e5b8a9bafe846d11102035e7c7f879cc.jpg_200x200q90.jpg",
        "price": 4400,
        "remark": "https://www.lazada.co.th/products/pdp-i4986140191.html",
        "sold": 0
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าถือผู้หญิงแฟชั่น หลายวิธีในการพกพา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3a3fe91775e84a0fbac7e5f343cf3e5cM.jpg_200x200q90.jpg",
        "price": 4397.38,
        "remark": "https://www.lazada.co.th/products/pdp-i6073213713.html",
        "sold": 1
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าถืออเนกประสงค์สุดฮิต",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6365f8ae32c945e2af5d015211219a1dq.jpg_200x200q90.jpg",
        "price": 4395.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5994892554.html",
        "sold": 0
    },
    {
        "product_name": "กอล์ฟ | กระเป๋าถือและกระเป๋าสะพาย จุของได้เยอะ ใส่โน้ตบุ๊คได้ พกสำหรับเดินทางไปเที่ยว หรือทำงานได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3e0a198cb77c45ae8f99d34b6520bf18A.jpg_200x200q90.jpg",
        "price": 4383.84,
        "remark": "https://www.lazada.co.th/products/pdp-i5909504499.html",
        "sold": 200
    },
    {
        "product_name": "กระเป๋าใส่แอร์ wiman 9000 btu เคสแอร์ วิมานแอร์",
        "product_image": "https://img.lazcdn.com/g/p/6d0eef3fc496df200a38af49253f5c16.jpg_200x200q90.jpg",
        "price": 4380,
        "remark": "https://www.lazada.co.th/products/pdp-i16085687230.html",
        "sold": 0
    },
    {
        "product_name": "Nite Ize RunOff Waterproof Large Packing Cube -  กระเป๋ากันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/17ade91a35f340f39934c43a2867ac2c.jpg_200x200q90.jpg",
        "price": 4380,
        "remark": "https://www.lazada.co.th/products/pdp-i315560142.html",
        "sold": 1
    },
    {
        "product_name": "กระเปาสะพายไหลขนาดเลก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S27e4ee8040f54c0c840b75eb031e7b7bj.png_200x200q90.png",
        "price": 4379.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16118859923.html",
        "sold": 0
    },
    {
        "product_name": "เป้น้ำวิ่งเทรล เป้วิ่ง เป้วิ่งเทรล 5 ลิตร KIPRUN 5-LITRE trail running gilet with bottle holder for competition green",
        "product_image": "https://img.lazcdn.com/g/p/4ede88c1877cd24f706a7948d5938579.jpg_200x200q90.jpg",
        "price": 4378,
        "remark": "https://www.lazada.co.th/products/pdp-i5906782892.html",
        "sold": 0
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าถือหนังคุณภาพสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb3a945b69437479596050caf8bc73781o.jpg_200x200q90.jpg",
        "price": 4373.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5994823746.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋าใส่แอมป์ กระเป๋าอเนกประสงค์ กระเป๋ากันน้ำ ผ้าแคนวาส",
        "product_image": "https://img.lazcdn.com/g/p/d6d4bbcee3aaec8710fc8427b9441b51.jpg_200x200q90.jpg",
        "price": 4360,
        "remark": "https://www.lazada.co.th/products/pdp-i4376344181.html",
        "sold": 0
    },
    {
        "product_name": "【XIXINBO】ด้ามจับกันลื่นกระเป๋าใส่โน๊ตบุ๊คแบบพกพาผ้าแคนวาส,ด้ามจับสั้นเบ็ดตกปลาพกพาได้เบ็ดตกปลาทะเล EVA [ไม่พลาด] [เปิดตัวผลิตภัณฑ์ใหม่]",
        "product_image": "https://img.lazcdn.com/g/p/049b00a5e85b4be0d928ef04c662f025.jpg_200x200q90.jpg",
        "price": 4338,
        "remark": "https://www.lazada.co.th/products/pdp-i5981663796.html",
        "sold": 0
    },
    {
        "product_name": "Loboo | กระเป๋าถังกันน้ำสไตล์เรโทร พร้อมที่วางโทรศัพท์และกุญแจ ใช้แม่เหล็ก ปลดออกได้รวดเร็ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8c6805f81e44436c85d9e4014022d512z.jpg_200x200q90.jpg",
        "price": 4330,
        "remark": "https://www.lazada.co.th/products/pdp-i16080279817.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าโน๊ตบุ๊คกันน้ำ FEELFREE CASPIAN TOTE BACKPACK",
        "product_image": "https://img.lazcdn.com/g/p/2e314f78fc444de7b90e81c5906628fd.jpg_200x200q90.jpg",
        "price": 4320,
        "remark": "https://www.lazada.co.th/products/pdp-i2489021415.html",
        "sold": 0
    },
    {
        "product_name": "Charles & Keith | กระเป๋าถืออ่อนโยนสไตล์บอสตันเหมาะสำหรับฤดูใบไม้ผลิ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0329b2b72d68473ca6ac15eb12a102e3f.png_200x200q90.png",
        "price": 4314.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16128617215.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเสื้อผ้ากันน้ำสำหรับผู้ชาย พร้อมช่องใส่รองเท้า ความจุใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S22dcf434cc7e4c409960b5ce159f94f7o.jpg_200x200q90.jpg",
        "price": 4311.3,
        "remark": "https://www.lazada.co.th/products/pdp-i6066865196.html",
        "sold": 0
    },
    {
        "product_name": "Livestyl กระเป๋าใส่น้ำหนักสำหรับดำน้ำพร้อมที่ใส่ตัวล๊อคแบบหัวเข็มขัดกะทัดรัดสำหรับการผลิตใต้น้ำและหน้ากากดำน้ำตื้น",
        "product_image": "https://img.lazcdn.com/g/p/a3e4a90bdeee26745b04fbf78c8aec49.jpg_200x200q90.jpg",
        "price": 4304,
        "remark": "https://www.lazada.co.th/products/pdp-i16052231557.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือแฟชั่น รุ่น B2405",
        "product_image": "https://img.lazcdn.com/g/p/8ecfddd5c167f31f2cf40e68f3d0daf8.jpg_200x200q90.jpg",
        "price": 4304,
        "remark": "https://www.lazada.co.th/products/pdp-i5722335641.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือแฟชั่น รุ่น B1786-1",
        "product_image": "https://img.lazcdn.com/g/p/be8460f10db72fd86ae9f30d65e9056b.jpg_200x200q90.jpg",
        "price": 4304,
        "remark": "https://www.lazada.co.th/products/pdp-i5117600570.html",
        "sold": 0
    },
    {
        "product_name": "CinvaiKrose | กระเป๋าถือขนาดใหญ่ใหม่ที่หรูหรา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf9cf23c6cd184551bc87b53d278cb55cI.png_200x200q90.png",
        "price": 4302.88,
        "remark": "https://www.lazada.co.th/products/pdp-i6076983301.html",
        "sold": 4
    },
    {
        "product_name": "👜 กระเป๋าสะพาย ดีไซน์ทันสมัย",
        "product_image": "https://img.lazcdn.com/g/p/5a92c648938654bc52efc575029b209c.png_200x200q90.png",
        "price": 4300,
        "remark": "https://www.lazada.co.th/products/pdp-i5910700873.html",
        "sold": 0
    },
    {
        "product_name": "🌟👜 กระเป๋าสะพายดีไซน์ทันสมัย ใช้งานสะดวกทุกวัน",
        "product_image": "https://img.lazcdn.com/g/p/d0e7b1ae1616800467a41f8158741066.png_200x200q90.png",
        "price": 4300,
        "remark": "https://www.lazada.co.th/products/pdp-i5902372690.html",
        "sold": 0
    },
    {
        "product_name": "Stream Trail - Snapper Waterproof Bag 16L กระเป๋าเป้กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/3380a55a75f2bfdf98a849402c5185d0.jpg_200x200q90.jpg",
        "price": 4260,
        "remark": "https://www.lazada.co.th/products/pdp-i518585000.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเป้ ซิปกันละอองน้ำ ขนาด 25L FEELFREE  METRO 25L",
        "product_image": "https://img.lazcdn.com/g/p/1b9fc32866aefa0f681db6c9422bbc3b.jpg_200x200q90.jpg",
        "price": 4250,
        "remark": "https://www.lazada.co.th/products/pdp-i3611879756.html",
        "sold": 1
    },
    {
        "product_name": "Hosa | กระเป๋าว่ายน้ำแข่งขัน ความจุมาก หลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saf221a9131ca4b42b51bbf4473415109c.jpg_200x200q90.jpg",
        "price": 4244.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16052415640.html",
        "sold": 0
    },
    {
        "product_name": "Caterpillar (CAT) กระเป๋าเป้กันน้ำ 100% รุ่น 84958-42 (33L) สีเหลือง CAT Yellow | Aqua Backpack Roll-top",
        "product_image": "https://img.lazcdn.com/g/p/a634dc7a177e9c1453d3e29d14652d90.jpg_200x200q90.jpg",
        "price": 4240,
        "remark": "https://www.lazada.co.th/products/pdp-i16111894793.html",
        "sold": 0
    },
    {
        "product_name": "Sposport กระเป๋าเก็บเคสว่ายน้ำแบบพกพาทนต่อการสึกหรอพร้อมอุปกรณ์เสริมกระเป๋ากระเป๋าใส่โน๊ตบุ๊คแบบพกพามืออาชีพสำหรับผู้ชายผู้หญิงกระเป๋าเก็บของแบบพกพา",
        "product_image": "https://img.lazcdn.com/g/p/8b7b49dc6b55b3e90e2965dd42ea65ed.jpg_200x200q90.jpg",
        "price": 4218,
        "remark": "https://www.lazada.co.th/products/pdp-i16057205861.html",
        "sold": 0
    },
    {
        "product_name": "สำหรับการขี่จักรยานตั้งแคมป์กระเป๋าเป้เดินทางกระเป๋าเป้สะพายหลังกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/ce243d0553fa5a519d9e0abd9641011c.jpg_200x200q90.jpg",
        "price": 4212,
        "remark": "https://www.lazada.co.th/products/pdp-i5887695525.html",
        "sold": 0
    },
    {
        "product_name": "CinvaiKrose | กระเป๋าถือสำหรับเดินทางทอ ความจุมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1e09ddd0c21c4fd0974d0908b563d1048.png_200x200q90.png",
        "price": 4201.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5882293049.html",
        "sold": 38
    },
    {
        "product_name": "(รับประกัน 2 ปี!)FEELFREE DRY TANK 60L กระเป๋ากันน้ำ กระเป๋าสะพาย ผช ผญ กระเป๋าเป้กันน้ำ กระเป๋าเดินทาง กระเป๋าสะพายหลัง ขนาด 60 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/57b9a2f2bc40eaf922f31bad56eb1d24.png_200x200q90.png",
        "price": 4200,
        "remark": "https://www.lazada.co.th/products/pdp-i5553055451.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋ากันน้ำสะพายข้าง ขนาด 15 ลิตร FEELFREE CLIPPER 15L",
        "product_image": "https://img.lazcdn.com/g/p/65d7c939b68b971bdb39d7c47134661a.jpg_200x200q90.jpg",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i2899158323.html",
        "sold": 1
    },
    {
        "product_name": "STREAM TRAIL ST DRY CUBE 20L กระเป๋ากันน้ำทรงกระบอก ขนาด 20 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/7ea78bb16ee60055a26be0908c692e88.jpg_200x200q90.jpg",
        "price": 4200,
        "remark": "https://www.lazada.co.th/products/pdp-i3834511557.html",
        "sold": 1
    },
    {
        "product_name": "Stream Trail-Dry cube 20L Waterproof Backpack",
        "product_image": "https://img.lazcdn.com/g/p/1ecec91b239b7d1c4c98117bb87cffff.jpg_200x200q90.jpg",
        "price": 4200,
        "remark": "https://www.lazada.co.th/products/pdp-i421484108.html",
        "sold": 1
    },
    {
        "product_name": "Hosa | เป้สะพายหลังความจุใหญ่สำหรับว่ายน้ำและหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8d6c5d9bc4384607b4f47aa27a8aa160d.jpg_200x200q90.jpg",
        "price": 4199.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16053209942.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาสะพายขางสไตลนารก ตกแตงโบว สำหรบผหญง กระเปาสะพายไหลสไตลเจาหญง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb08d9257a3de48eebd7644849a8e6a40q.png_200x200q90.png",
        "price": 3947.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16123460323.html",
        "sold": 0
    },
    {
        "product_name": "WATERTIME | เป้กันน้ำสำหรับเด็กความจุมาก พร้อมแยกช่องแห้งและชื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc77e0e507d99407187df58c0edee18f5K.jpg_200x200q90.jpg",
        "price": 4193.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5894934190.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าฝึกฟิตเนสสไตล์บัลแกเรีย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S153f08cb8c75411e8258acb5ab4e6161x.jpg_200x200q90.jpg",
        "price": 4190,
        "remark": "https://www.lazada.co.th/products/pdp-i16123246640.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือขนาดเล็กสี่เหลี่ยมน่ารักและเป็นต้นฉบับ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scd1fe2c5f7d341a581355470a61fc2b3f.jpg_200x200q90.jpg",
        "price": 4185.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6003035595.html",
        "sold": 1
    },
    {
        "product_name": "MLZH | เป้กันน้ำแบบขยายได้หลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se668dfdaa6a74ae98b5bfd8daf9e5253m.jpg_200x200q90.jpg",
        "price": 4183.3,
        "remark": "https://www.lazada.co.th/products/pdp-i6044125005.html",
        "sold": 0
    },
    {
        "product_name": "Golf | เป้พกพาแล็ปท็อปหลายฟังก์ชัน ความจุใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9cd4d8411e114761892d7d602f45965dz.jpg_200x200q90.jpg",
        "price": 4170,
        "remark": "https://www.lazada.co.th/products/pdp-i5906810942.html",
        "sold": 35
    },
    {
        "product_name": "WATERTIME | ถุงเก็บของกันน้ำแยกแห้งและเปียก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Secbd9412d1474533af20593f1958799dJ.jpg_200x200q90.jpg",
        "price": 4153.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5894907899.html",
        "sold": 0
    },
    {
        "product_name": "Hanayo | กระเป๋าถือเล็กหรูหราและทันสมัย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf6baee41a9924c6486548de9f5375af87.jpg_200x200q90.jpg",
        "price": 4129.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16116935788.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือหนังทำมือสไตล์เรโทร ความจุขนาดใหญ่ กระเป๋าโท้ทลำลอง กระเป๋าผู้หญิง JOGUJOS สไตล์ใหม่ กระเป๋าหนังสำหรับเดินทางแบบลำลอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9dd91afb2008449c81af497f2fc028a9A.jpg_200x200q90.jpg",
        "price": 4129.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16107700086.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันนํ้า สะพายหลัง สำหรับว่ายนํ้าชายหาดไปเดินป่า ขนาด 20 ลิตร Tanami Outdoor Waterproof Backpack Dry Bag 20L",
        "product_image": "https://img.lazcdn.com/g/p/4390e70ea661269757b57a4357410dd1.jpg_200x200q90.jpg",
        "price": 4128,
        "remark": "https://www.lazada.co.th/products/pdp-i4358450183.html",
        "sold": 0
    },
    {
        "product_name": "Huron LT Mesh Backpack กระเป๋าเป้ตาข่ายน้ำหนักเบา ทนทาน ระบายอากาศดี สายสะพายบุนวมพกพาสะดวก เหมาะสำหรับนักดำน้ำ ขนาด 60 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/904f872d045e72c3aa4222cdc4aa6621.jpg_200x200q90.jpg",
        "price": 4128,
        "remark": "https://www.lazada.co.th/products/pdp-i5596350379.html",
        "sold": 0
    },
    {
        "product_name": "FRENZEL | กระเป๋าหิ้วสำหรับเก็บฟินดำน้ำกันน้ำ ความจุใหญ่ 30 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc261f3fe994b4f93ac0618e76bacf608c.jpg_200x200q90.jpg",
        "price": 4125.18,
        "remark": "https://www.lazada.co.th/products/pdp-i6031125175.html",
        "sold": 0
    },
    {
        "product_name": "Befairy ไนลอนน้ำหนักกระเป๋าอุปกรณ์ดำน้ำใต้น้ำสำหรับดำน้ำลึกและเข็มขัดแนบมาด้วย",
        "product_image": "https://img.lazcdn.com/g/p/8d162603c8145f048218bf9b54fc4da6.jpg_200x200q90.jpg",
        "price": 4118.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16121734930.html",
        "sold": 0
    },
    {
        "product_name": "Serciya กระเป๋าแห้งและกันน้ำ6ใบกระเป๋ากันน้ำ2L,5L,10L,15L,20L,ถุงที่เก็บของแห้ง30ลิตรสำหรับผู้หญิงผู้ชายสำหรับการเดินป่าพายเรือคายัคชุดกัน้ำกันลมพายเรือแคนู",
        "product_image": "https://img.lazcdn.com/g/p/71bdd6185628649add903e89dbfe54f4.jpg_200x200q90.jpg",
        "price": 4106,
        "remark": "https://www.lazada.co.th/products/pdp-i16060170927.html",
        "sold": 0
    },
    {
        "product_name": "Beatycare กระเป๋าที่เก็บของแห้งกระเป๋าเป้สะพายหลังแห้งกันน้ำ6ชิ้นสำหรับพายเรือคายัคพายเรือเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/61065910c2a51744cc4a1316b68f675a.jpg_200x200q90.jpg",
        "price": 4106,
        "remark": "https://www.lazada.co.th/products/pdp-i16057117301.html",
        "sold": 0
    },
    {
        "product_name": "STREAM TRAIL - Bream Flap Bag กระเป๋าสะพายข้างกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/e7768a6eb8eac1d1767708ace7eb2191.jpg_200x200q90.jpg",
        "price": 4100,
        "remark": "https://www.lazada.co.th/products/pdp-i411818978.html",
        "sold": 2
    },
    {
        "product_name": "กระเป๋าเป้กันน้ำ พรีเมี่ยม ขนาด 30 ลิตร FEELFREE DRY TANK LURE 30L",
        "product_image": "https://img.lazcdn.com/g/p/5aff3f75999834773da6de13be7d26cb.jpg_200x200q90.jpg",
        "price": 3398,
        "remark": "https://www.lazada.co.th/products/pdp-i4891353513.html",
        "sold": 2
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้สะพายหลังกันน้ำ ขนาด 30 ลิตร EELFREE DRY TANK 30L",
        "product_image": "https://img.lazcdn.com/g/p/8bcc1dc91eb394af674597313588acad.jpg_200x200q90.jpg",
        "price": 3484,
        "remark": "https://www.lazada.co.th/products/pdp-i4627607641.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าสะพายกันน้ำ พรีเมี่ยม FEELFREE BLUE RIDGE PLAYMATE",
        "product_image": "https://img.lazcdn.com/g/p/c4489658057d863e469fb4b9c9d678b2.jpg_200x200q90.jpg",
        "price": 4100,
        "remark": "https://www.lazada.co.th/products/pdp-i4985892837.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าโบว์เคสพกพากล่องใส่มีโบว์ Koolsoo",
        "product_image": "https://img.lazcdn.com/g/p/033acc9e450dfd737ca333186307cc78.jpg_200x200q90.jpg",
        "price": 4093.54,
        "remark": "https://www.lazada.co.th/products/pdp-i6003404754.html",
        "sold": 0
    },
    {
        "product_name": "เป้สะพายหลังกันน้ำแยกช่องแห้งและชื้น 25 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S74f610acd28b4778ad1c9349b8ffa531x.jpg_200x200q90.jpg",
        "price": 4086,
        "remark": "https://www.lazada.co.th/products/pdp-i16124259414.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายผู้หญิงลำลองพร้อมกับสายปรับได้กระเป๋าโฮโบกระเป๋าหลายใบ",
        "product_image": "https://img.lazcdn.com/g/tps/imgextra/i4/2104668892/O1CN01cZioP12FYawtGNuWS_!!2104668892.jpg_200x200q90.jpg",
        "price": 4080,
        "remark": "https://www.lazada.co.th/products/pdp-i16141101875.html",
        "sold": 0
    },
    {
        "product_name": "Ortlieb ถุงกันน้ำ Dry Bag PS10 with Valve",
        "product_image": "https://img.lazcdn.com/g/p/2c41fa654ffae79ffeaece13e238784a.jpg_200x200q90.jpg",
        "price": 4070,
        "remark": "https://www.lazada.co.th/products/pdp-i4834995270.html",
        "sold": 0
    },
    {
        "product_name": "Lee(ลี) | กระเป๋าสะพายข้างแฟชั่นฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0b671e220f56456fbdc37144cd713089S.jpg_200x200q90.jpg",
        "price": 4055.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16104774055.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าสะพายข้างกันน้ำ FEELFREE FREERUNNER EX",
        "product_image": "https://img.lazcdn.com/g/p/268314dabb767655578ac1079e29c103.jpg_200x200q90.jpg",
        "price": 4050,
        "remark": "https://www.lazada.co.th/products/pdp-i2503852136.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าผ้าแคนวาสสะพายไหล่ขนาดใหญ่ พร้อมตัวล็อคหนัง กระเป๋าถือแบบมีหูหิ้ว กระเป๋าเอกสาร กระเป๋าโท้ททันสมัยสำหรับการเดินทางเพื่อธุรกิจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S975a0f1753fd4dde9e0afeff89ca2268S.jpg_200x200q90.jpg",
        "price": 4048.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16099570690.html",
        "sold": 0
    },
    {
        "product_name": "NEVO RHINO AIR 4L VEST #9283 เป้น้ำขนาด 4 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/616d9ff623ff93354cbf501a5d283774.jpg_200x200q90.jpg",
        "price": 4040,
        "remark": "https://www.lazada.co.th/products/pdp-i5965280791.html",
        "sold": 0
    },
    {
        "product_name": "Arena Snapdragon Swim Shoulder Bag Wet And Dry Separable Tote Bag Same As Zhejiang Team",
        "product_image": "https://img.lazcdn.com/g/p/59dc945ff9870a43b0390923d4573015.jpg_200x200q90.jpg",
        "price": 4038.38,
        "remark": "https://www.lazada.co.th/products/pdp-i6010890249.html",
        "sold": 0
    },
    {
        "product_name": "Freneci กระเป๋ามีปกสโนว์บอร์ดแบบพกพา,อุปกรณ์เสริมกระเป๋าป้องกันรอยขีดข่วนสำหรับผู้ชายผู้หญิงมีล้อกระเป๋าใส่โน๊ตบุ๊คแบบพกพาสโนว์บอร์ดกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/f38fe4df3ba477292f5a1796cfd13a39.jpg_200x200q90.jpg",
        "price": 4027.34,
        "remark": "https://www.lazada.co.th/products/pdp-i6007725270.html",
        "sold": 0
    },
    {
        "product_name": "CinvaiKrose | กระเป๋าหลายประโยชน์ใหม่ 2026",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sacce3e61f6974b4e94eed2840b061d31F.png_200x200q90.png",
        "price": 4026.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5878064279.html",
        "sold": 70
    },
    {
        "product_name": "CinvaiKrose | กระเป๋าสะพายขนาดใหญ่สำหรับผู้หญิง ใช้ในการเดินทางไปทำงาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd093f119ebfc41709221f154cc08149cV.png_200x200q90.png",
        "price": 4016.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5875774532.html",
        "sold": 189
    },
    {
        "product_name": "กระเป๋าหลายวิธีการใช้งานสไตล์ชิค",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se49cf0169f254c08a35f12bcf5268c90s.png_200x200q90.png",
        "price": 4015.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6066501357.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาเสรม นำหนกเบา เหมาะสำหรบพกพาออกนอกบาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa96c61cd2b2947a885eef7acbad97725f.png_200x200q90.png",
        "price": 4008.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16121614227.html",
        "sold": 0
    },
    {
        "product_name": "Sposport กระเป๋าใส่กล่องใส่มีโบว์,กระเป๋าใส่โบว์เคสพกพาพกพาได้ด้วยความจุขนาดใหญ่ใช้งานได้จริงน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/fbe433ab7079f770e152cc2a36cb28de.jpg_200x200q90.jpg",
        "price": 4001.16,
        "remark": "https://www.lazada.co.th/products/pdp-i6005509073.html",
        "sold": 0
    },
    {
        "product_name": "Condor - QD M4 Mag Pouch (2 Pack) ซองแม็กกาซีน ซองแม็ก เพ้า กระเป๋า",
        "product_image": "https://img.lazcdn.com/g/p/4eb91566af8ad41f84115c6cb499062d.jpg_200x200q90.jpg",
        "price": 4000,
        "remark": "https://www.lazada.co.th/products/pdp-i5290074119.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเป้กันน้ำ 20 ลิตรใช้แล้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb0f5a2a8e3704e60b4f710eb439e5d30G.jpg_200x200q90.jpg",
        "price": 3998,
        "remark": "https://www.lazada.co.th/products/pdp-i5867113738.html",
        "sold": 0
    },
    {
        "product_name": "TernX ถุงกันน้ำ ใส่เสื้อผ้า ม้วนเก็บได้ Waterproof Bag",
        "product_image": "https://img.lazcdn.com/g/p/724cdc552f08a208dcdb949c02c09f41.jpg_200x200q90.jpg",
        "price": 3998,
        "remark": "https://www.lazada.co.th/products/pdp-i5860084884.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือแฟชั่น รุ่น B1767",
        "product_image": "https://img.lazcdn.com/g/p/f9f190367c8b74fec7b2247ba28a0c20.jpg_200x200q90.jpg",
        "price": 3984,
        "remark": "https://www.lazada.co.th/products/pdp-i5758608554.html",
        "sold": 0
    },
    {
        "product_name": "Henneybear-H1196 รุ่น Wonder bag ลาย Cute Bear กระเป๋าสะพายข้าง กระเป๋าพาดลำตัว กระเป๋าผู้หญิง สายสปอร์ตปรับระดับได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7a944492331b4936ba49acff2c679f253.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5375286228.html",
        "sold": 0
    },
    {
        "product_name": "Henneybear-H1196 รุ่น Wonder bag ลาย Teddy Bear กระเป๋าสะพายข้าง กระเป๋าพาดลำตัว กระเป๋าผู้หญิง สายสปอร์ตปรับระดับได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa6cb61e910514dc788c21fbfbacfe70el.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5375238243.html",
        "sold": 1
    },
    {
        "product_name": "Case-Mate Waterproof Phone Bucket Bag 2L กระเป๋ากันน้ำ ขนาด 2 ลิตร - Sand Dollar",
        "product_image": "https://img.lazcdn.com/g/p/8a02dbb7669b18e9ba5d001477ed3ab1.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i16060642824.html",
        "sold": 0
    },
    {
        "product_name": "NATUREHIKE Far mountain Lightweight shoulder waterproof bag ขนาด18L กระเป๋ากันน้ำ กระเป๋าสะพายหลัง CNH22BB003",
        "product_image": "https://img.lazcdn.com/g/p/82aa3bb854c965189f9d6a2efc3640f8.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5647989456.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน   หนังสีดำ    ( 2ใบ )   วอลเทอร์ walther ppk/s .380 ACP   9มม   /   STI ELEKTRA  .45 ACP   /  RETAY 84FS  /  Makarov  /  Sig Sauer P239",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa66b6be4184b402380635f13f6e82eccX.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5474854029.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถ่วงน้ำหนัก 10/20/30kg Sandbag กระเป๋ายกน้ำหนัก สำหรับฝึก Hyrox  เกรดแข่งขัน (ไม่มีทราย) - Homefittools",
        "product_image": "https://img.lazcdn.com/g/p/92f218d7b7c9016a3358363bd580b227.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5933965102.html",
        "sold": 7
    },
    {
        "product_name": "กระเป๋าชิงหลิว3ช่องกระเป๋าตกปลาDiawa 3ช่องแข็ง ลายเคฟล่า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd48a982ee908491daf3f3d084914b2daA.jpg_200x200q90.jpg",
        "price": 3978.92,
        "remark": "https://www.lazada.co.th/products/pdp-i4919791670.html",
        "sold": 18
    },
    {
        "product_name": "FEELFREE NEW TROPICAL DRY TANK กระเป๋าเป้ผ้ากันฝน รุ่น TROPICAL",
        "product_image": "https://img.lazcdn.com/g/p/47d7bec4e9d4c2ffc7d485ed24f497c9.jpg_200x200q90.jpg",
        "price": 3960,
        "remark": "https://www.lazada.co.th/products/pdp-i6013437431.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเป้ ซิปกันละอองน้ำ ขนาด 15 ลิตร FEELFREE METRO 15L",
        "product_image": "https://img.lazcdn.com/g/p/e5b8a9bafe846d11102035e7c7f879cc.jpg_200x200q90.jpg",
        "price": 3960,
        "remark": "https://www.lazada.co.th/products/pdp-i3611793652.html",
        "sold": 5
    },
    {
        "product_name": "คัน AIRGEAR PROMAX 5 ท่อน เวท 8-17lb และ 10-20lb พร้อมกระเป๋า พกง่ายสะดวกสบาย",
        "product_image": "https://img.lazcdn.com/g/p/c250c9c1dc258785469009f025eb92ac.jpg_200x200q90.jpg",
        "price": 3960,
        "remark": "https://www.lazada.co.th/products/pdp-i16106710667.html",
        "sold": 0
    },
    {
        "product_name": "FEELFREE NEW TROPICAL DRY TANK กระเป๋าเป้ผ้ากันฝน ลาย TROPICAL รุ่นใหม่",
        "product_image": "https://img.lazcdn.com/g/p/47d7bec4e9d4c2ffc7d485ed24f497c9.jpg_200x200q90.jpg",
        "price": 3960,
        "remark": "https://www.lazada.co.th/products/pdp-i6013402804.html",
        "sold": 0
    },
    {
        "product_name": "FEELFREE NEW TROPICAL DRY TANK กระเป๋าเป้ผ้ากันฝนรุ่นใหม่",
        "product_image": "https://img.lazcdn.com/g/p/47d7bec4e9d4c2ffc7d485ed24f497c9.jpg_200x200q90.jpg",
        "price": 3960,
        "remark": "https://www.lazada.co.th/products/pdp-i6013353899.html",
        "sold": 0
    },
    {
        "product_name": "CCZedo กระเป๋าเป้สะพายหลังสำหรับว่ายน้ำแห้งและกันน้ำกระเป๋าใส่โต้คลื่นล่องแพกระเป๋าเป้สะพายหลังชายหาดขนาดใหญ่แห้งเปียก",
        "product_image": "https://img.lazcdn.com/g/p/ec0709ee254006540efcc3bd87bb3711.jpg_200x200q90.jpg",
        "price": 3960,
        "remark": "https://www.lazada.co.th/products/pdp-i6008074793.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือและสะพายข้างสุนัขสีสันสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1a07623d66664a18998673d6cb374a22r.png_200x200q90.png",
        "price": 3957.36,
        "remark": "https://www.lazada.co.th/products/pdp-i6066614477.html",
        "sold": 0
    },
    {
        "product_name": "Sea to summit Lightweight View Dry Bag ถุงกันน้ำ Waterproof",
        "product_image": "https://img.lazcdn.com/g/p/f6ae68f0bca0a6ee0b2a186d3e9fe876.jpg_200x200q90.jpg",
        "price": 3940,
        "remark": "https://www.lazada.co.th/products/pdp-i4912082406.html",
        "sold": 1
    },
    {
        "product_name": "EcoFlow WAVE 2 Air Conditioner Protective Bag Waterproof Dustproof Cover",
        "product_image": "https://img.lazcdn.com/g/p/3d3313b0e4a1567d461243d34027cd8a.jpg_200x200q90.jpg",
        "price": 3926,
        "remark": "https://www.lazada.co.th/products/pdp-i16079320499.html",
        "sold": 0
    },
    {
        "product_name": "Koolsoo กระเป๋ากันน้ำสายพาดไหล่ปรับได้กระเป๋าเป้สะพายหลังกันน้ำสำหรับผู้หญิงผู้ชายกระเป๋าเป้สะพายหลังสำหรับกระเป๋าเก็บของแล่นเรือคายัคกีฬาทางน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/b575316b9df4a64325691f92e143abb4.jpg_200x200q90.jpg",
        "price": 3924,
        "remark": "https://www.lazada.co.th/products/pdp-i6075431025.html",
        "sold": 0
    },
    {
        "product_name": "Oshhni กระเป๋ากันน้ำสายคล้องพาดไหล่ปรับได้กระเป๋าเป้สะพายหลังกันน้ำสำหรับผู้หญิงผู้ชายกระเป๋าเป้สะพายหลังสำหรับกระเป๋าเก็บของแล่นเรือคายัคทางน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/eedd0d94b5a6d4e252337742fced9934.jpg_200x200q90.jpg",
        "price": 3924,
        "remark": "https://www.lazada.co.th/products/pdp-i6032904842.html",
        "sold": 0
    },
    {
        "product_name": "Gamchiano ถุงกันอากาศแห้งกระเป๋าเป้สะพายหลังกันน้ำช่วยให้อุปกรณ์แห้งแบบพกพาปิดเสื้อม้วนสำหรับเดินป่าว่ายน้ำชายหาดแล่นเรือใบกีฬาทางน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/c10ba3a5b48c126adda0488d2ec9d8a5.jpg_200x200q90.jpg",
        "price": 3924,
        "remark": "https://www.lazada.co.th/products/pdp-i16044086552.html",
        "sold": 0
    },
    {
        "product_name": "Deevoka กระเป๋าแห้งกระเป๋าเป้สะพายหลังกันน้ำสำหรับผู้หญิงผู้ชาย,แห้งอุปกรณ์สำหรับเสื้อม้วน30L สำหรับพายเรือแคนูเดินป่าพายเรือล่องแก่งสวนน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/985b353b2b485e113f35301a3360e623.jpg_200x200q90.jpg",
        "price": 3924,
        "remark": "https://www.lazada.co.th/products/pdp-i16055238314.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสำหรับสุนัข Windsor สำหรับผู้หญิง ใหม่ 2026",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9322fdbff1b8408995c9cbe91f70c04aJ.png_200x200q90.png",
        "price": 3920.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6066603889.html",
        "sold": 0
    },
    {
        "product_name": "CinvaiKrose | กระเป๋าสะพายไหล่สำหรับเดินทางไปทำงาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S17df06ba190c47a4905dae03b1652ab2Q.png_200x200q90.png",
        "price": 3912.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16104405025.html",
        "sold": 5
    },
    {
        "product_name": "ดาวเทียมฮาร์ดกรณีน้ำแบบพกพาป้องกันรอยขีดข่วนหลักฐานกระเป๋าที่มีซับโฟมสำหรับการเดินทางตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/ab0a3ca723e591c42fe189f5ec045d67.jpg_200x200q90.jpg",
        "price": 3910,
        "remark": "https://www.lazada.co.th/products/pdp-i16119715594.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือขนาดเล็กหรูหรา สะพายไหล่/คาดลำตัว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4fb9bd5c7cbc48c98e8f508a17437a96A.png_200x200q90.png",
        "price": 3902.98,
        "remark": "https://www.lazada.co.th/products/pdp-i6066464284.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน   สมิธ  Smith   ลูกโม่   6นิ้ว  มีช่องใส่ลูก 2แถว  ช่องใส่ลูก  สำหรับ .38 357 9mm 9มม   ( พร้อม สายสะพาย )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se0f519e25f324e0f96aed4dd7634dc56J.jpg_200x200q90.jpg",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i394472602.html",
        "sold": 0
    },
    {
        "product_name": "ITIWIT เป้สะพายหลังกันน้ำขนาด 20 ลิตร และ 30 ลิตร กระเป๋ากันน้ำ ส่งไว",
        "product_image": "https://img.lazcdn.com/g/p/f203bcef8a1ed518a7dfa0ac101be7fa.png_200x200q90.png",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i5107419395.html",
        "sold": 3
    },
    {
        "product_name": "กระเป๋าเป้กันน้ำ พรีเมี่ยม TROPICAL MINI BACKPACK",
        "product_image": "https://img.lazcdn.com/g/p/d7034bd63885338da5a5e5b297adc99a.png_200x200q90.png",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i5007444605.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ปืน   4นิ้ว   กล็อก19   px4     sig320   กล็อก30    1911 4นิ้ว     หนังสีดำ    ใส่ได้ 2กระบอก   มีช่องใส่แม็ก 4ช่อง",
        "product_image": "https://img.lazcdn.com/g/p/0c307a066e09528b52c36965df04f11e.jpg_200x200q90.jpg",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i2377431329.html",
        "sold": 0
    },
    {
        "product_name": "Mexican | กระเป๋าสตรีพิมพ์ลายหรูหรา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S14139589dfd34d8598c8d3347b4b06d69.jpg_200x200q90.jpg",
        "price": 3898,
        "remark": "https://www.lazada.co.th/products/pdp-i16091896874.html",
        "sold": 0
    },
    {
        "product_name": "Sea to Summit | กระเป๋าเก็บของกันน้ำเบา 30D สามารถบีบอัดได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5e6051146be3490e8041baf9b2067649k.png_200x200q90.png",
        "price": 3894.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6003458019.html",
        "sold": 0
    },
    {
        "product_name": "CinvaiKrose | กระเป๋าถือสตรีสีแดงใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa397b6b4d37a4dcdac22320fdda75ddbS.png_200x200q90.png",
        "price": 3889.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5875723149.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋าถือลายแสงจันทร์อ่อนโยน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S01ceab916066427cb03e87fad6d8d7e3G.png_200x200q90.png",
        "price": 3885.48,
        "remark": "https://www.lazada.co.th/products/pdp-i6066348917.html",
        "sold": 0
    },
    {
        "product_name": "Dacina 3x เคสว่ายน้ำ4กระเป๋าเก็บของอุปกรณ์บิลเลียดแบบพกพาน้ำหนักเบาสายพาดไหล่ปรับได้กระเป๋าเก็บของทนต่อการสึกหรอ",
        "product_image": "https://img.lazcdn.com/g/p/619f79609c9e76c91f6328dcbd66d091.jpg_200x200q90.jpg",
        "price": 3870,
        "remark": "https://www.lazada.co.th/products/pdp-i16121586325.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าคิวใส่เคสพกพาสำหรับผู้ชายผู้หญิงน้ำหนักเบา,อุปกรณ์จัดระเบียบพกพาเคสว่ายน้ำเสียงมหัศจรรย์3x 4ไม้บิลเลียด",
        "product_image": "https://img.lazcdn.com/g/p/284704ed5a7d1d5f074064d280387c7a.jpg_200x200q90.jpg",
        "price": 3870,
        "remark": "https://www.lazada.co.th/products/pdp-i6042101259.html",
        "sold": 0
    },
    {
        "product_name": "Hasune ที่เก็บทนต่อการสึกหรอกระเป๋าเก็บของเคสว่ายน้ำน้ำหนักเบา,กระเป๋าเก็บของอุปกรณ์บิลเลียดกระเป๋นถือพกพาน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/840e310b6f32307066a01ad99bcaa5c5.jpg_200x200q90.jpg",
        "price": 3870,
        "remark": "https://www.lazada.co.th/products/pdp-i6048679353.html",
        "sold": 0
    },
    {
        "product_name": "ทาฮิดะหัวคิวโต๊ะพูลกระเป๋าถือกระเป๋าสำหรับผู้ชายผู้หญิงไม้บิลเลียดกระเป๋าเก็บของกระเป๋าเก็บของเคสพกพา",
        "product_image": "https://img.lazcdn.com/g/p/2d13ea301c9b1e0bfd63d04c7be86dc7.jpg_200x200q90.jpg",
        "price": 3870,
        "remark": "https://www.lazada.co.th/products/pdp-i16118490461.html",
        "sold": 0
    },
    {
        "product_name": "K2 Moto Bag กระเป๋ากันน้ำ 40 ลิตร และ 60 ลิตร by Jeep Camping",
        "product_image": "https://img.lazcdn.com/g/p/bcb32074bead9e00d4e769a3a34a826d.jpg_200x200q90.jpg",
        "price": 3860,
        "remark": "https://www.lazada.co.th/products/pdp-i2283141446.html",
        "sold": 3
    },
    {
        "product_name": "K2 Motobag กระเป๋ากันน้ำ กระเป๋ามอเตอร์ไซค์ กระเป๋าทัวร์ริ่ง ติดตั้งง่าย ทนทาน กันน้ำ 100% ขนาด 40L",
        "product_image": "https://img.lazcdn.com/g/p/a03ba4d64b46551ba2eba67c2d81c912.jpg_200x200q90.jpg",
        "price": 3860,
        "remark": "https://www.lazada.co.th/products/pdp-i1097952445.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า K2 MOTO BAG กระเป๋ากันน้ำ 100%",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S27fa2577ec5f40f8bba588d523202be69.jpg_200x200q90.jpg",
        "price": 3860,
        "remark": "https://www.lazada.co.th/products/pdp-i2118444365.html",
        "sold": 2
    },
    {
        "product_name": "Muva| กระเป๋าสะพายข้าง รุ่น OVERSIZED COTTON CANDY BAG",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb8a7bfd1280140a19f1c7f094931a54ba.jpg_200x200q90.jpg",
        "price": 3853.78,
        "remark": "https://www.lazada.co.th/products/pdp-i6002253470.html",
        "sold": 79
    },
    {
        "product_name": "KAVU Packwood Backpack กระเป๋าสะพายหลัง",
        "product_image": "https://img.lazcdn.com/g/p/3f1ec6ef682f3fae3fc816dc65902987.jpg_200x200q90.jpg",
        "price": 3850,
        "remark": "https://www.lazada.co.th/products/pdp-i4608371683.html",
        "sold": 3
    },
    {
        "product_name": "(โกลดสไมล)กระเปาสะพายไหลผหญงแบบเบา รนใหม สไตลลำลอง เหมาะสำหรบนกเรยนและเดท",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbed35be4c9364f069d4c86c73c6805650.png_200x200q90.png",
        "price": 3840.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16102038057.html",
        "sold": 0
    },
    {
        "product_name": "(เซล러เอيد) กระเปาชายหาดสำหรบฤดรอน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb5e62ec7897d4f85b0ebfd1b25054afbK.png_200x200q90.png",
        "price": 3711.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16118036637.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือขนาดใหญ่สไตล์วินเทจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1e79910d09f9473f8aba316f210e1c816.png_200x200q90.png",
        "price": 3835,
        "remark": "https://www.lazada.co.th/products/pdp-i6066644466.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายข้างสำหรับเดินทาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2765564d6f294429909520821baca50en.png_200x200q90.png",
        "price": 3835,
        "remark": "https://www.lazada.co.th/products/pdp-i6066665206.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถืออเนกประสงค์แบบหรูหรา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1283a1d9a4ff4058afabbf30bfa34775K.png_200x200q90.png",
        "price": 3835,
        "remark": "https://www.lazada.co.th/products/pdp-i6066557899.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายข้างสำหรับฤดูใบไม้ผลิและฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa971bf789ae1470291120e5444820f3cj.png_200x200q90.png",
        "price": 3835,
        "remark": "https://www.lazada.co.th/products/pdp-i6066651305.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสไตล์เรโทรสแลค",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saa3917051cef4a37b9a4896974fe3cf0A.png_200x200q90.png",
        "price": 3835,
        "remark": "https://www.lazada.co.th/products/pdp-i6066694006.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือขนาดใหญ่จุของได้มาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa041d8cda32c403caba93c85f9dd5f94o.png_200x200q90.png",
        "price": 3835,
        "remark": "https://www.lazada.co.th/products/pdp-i6066568432.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสำหรับผู้หญิงขนาดใหญ่จุของได้มาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9323054d47504315b9e5b5e32d29e048y.png_200x200q90.png",
        "price": 3835,
        "remark": "https://www.lazada.co.th/products/pdp-i6066707065.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือผู้หญิงสุดเก๋",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S401b2d9c58904583ba10ea927e79aefb8.png_200x200q90.png",
        "price": 3835,
        "remark": "https://www.lazada.co.th/products/pdp-i6066535951.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสไตล์วินเทจขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S934dcfc3569040f9b01f31963a08bb656.png_200x200q90.png",
        "price": 3835,
        "remark": "https://www.lazada.co.th/products/pdp-i6066584690.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสีน้ำตาลฮันนี่สไตล์เก๋",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7e1a126d536f4eabbca1e267c2f5719fY.png_200x200q90.png",
        "price": 3835,
        "remark": "https://www.lazada.co.th/products/pdp-i6066665015.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือทรงโครงสร้างแบบมินิมอล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3236ae1c9e614ab5bff413bcfce85e9ex.png_200x200q90.png",
        "price": 3835,
        "remark": "https://www.lazada.co.th/products/pdp-i6066495820.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือผู้หญิง Autumn Dream หลายประโยชน์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sed3380ca3d5547ec9a2a573e06fccf05Y.png_200x200q90.png",
        "price": 3835,
        "remark": "https://www.lazada.co.th/products/pdp-i6066440618.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถืออเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd23ae641a7334f069c9f4196b74e9ff8O.png_200x200q90.png",
        "price": 3835,
        "remark": "https://www.lazada.co.th/products/pdp-i6066595624.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสำหรับเดินทางที่เรียบหรู",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S88577e8cbef9461f9433eb479291b043y.png_200x200q90.png",
        "price": 3835,
        "remark": "https://www.lazada.co.th/products/pdp-i6066387911.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายข้างสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa7fd95ebf9b94c63a5bc81c044a2699cF.png_200x200q90.png",
        "price": 3833.08,
        "remark": "https://www.lazada.co.th/products/pdp-i6066445719.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายข้างกันน้ำสำหรับกิจกรรมทางน้ำและกลางแจ้งแบบพับได้ 5 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sde050df18baf4aa69289c494c532947dA.jpg_200x200q90.jpg",
        "price": 3830,
        "remark": "https://www.lazada.co.th/products/pdp-i16138670319.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสไตล์อเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbfa4bc359e71470dbd951d4eca8d67f8Z.png_200x200q90.png",
        "price": 3825.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6066478611.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสำหรับผู้หญิง ใหม่ ปี 2026",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S37556de165f54b80bcdddcfff034bdeaj.png_200x200q90.png",
        "price": 3825.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6066591765.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือขนาดใหญ่สไตล์ลำลอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc7509ded375d47448509489b0c1ffc77h.png_200x200q90.png",
        "price": 3825.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6066602355.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือดีไซน์ใหม่ 2026 สไตล์ชิค",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8acdc28ba6564ea5923f6978dd607a38s.png_200x200q90.png",
        "price": 3825.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6066460547.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายขนาดใหญ่ใช้งานได้หลากหลาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S15d19cfa89654dc8924cf7b60bc61246L.png_200x200q90.png",
        "price": 3825.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6066367604.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า tote ดีไซน์พิเศษสำหรับแม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S962e5628b3d84ea9a999439179923b343.png_200x200q90.png",
        "price": 3825.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6066420527.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสะพายข้างสำหรับเดินทาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbb4062438d774bc7911d21fb787c42eer.png_200x200q90.png",
        "price": 3825.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6066604784.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าขนาดเล็กสุดชิค",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S914c6c5e9b2042fdb92f6a0b57a29bec0.png_200x200q90.png",
        "price": 3822.34,
        "remark": "https://www.lazada.co.th/products/pdp-i6066718141.html",
        "sold": 0
    },
    {
        "product_name": "เป้สะพายหลังสตรีสีน้ำตาลสไตล์วินเทจ รุ่นใหม่ 2026",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf159e8b3f3d847babf5599983ab36a44W.png_200x200q90.png",
        "price": 3822.34,
        "remark": "https://www.lazada.co.th/products/pdp-i6066444766.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสีดำสไตล์เรโทรชิค",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S831c3025739f4db999ec9564b08706c0A.png_200x200q90.png",
        "price": 3822.34,
        "remark": "https://www.lazada.co.th/products/pdp-i6066444695.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายข้างหลายประโยชน์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0111399d16c14a74bdd8432e8fce2e21u.png_200x200q90.png",
        "price": 3822.34,
        "remark": "https://www.lazada.co.th/products/pdp-i6066587371.html",
        "sold": 0
    },
    {
        "product_name": "(โกลดสไมล)กระเปาสะพายไหลผหญง กระเปาสะพายขาง กระเปาแฟชนลำลองสำหรบผหญง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2b058bcc863c4a8eb01be2a7550c45a70.png_200x200q90.png",
        "price": 3693.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16122230309.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสำหรับเดินทางที่หลากหลาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S89f41c07a005451bb01fe3d003e8554fm.png_200x200q90.png",
        "price": 3817.96,
        "remark": "https://www.lazada.co.th/products/pdp-i6065710640.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาแฟชนสำหรบออกนอกบาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S39d42f1b7322426db50a35058714d4beY.png_200x200q90.png",
        "price": 3690.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16099734234.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือผู้หญิง Mint Manor หรูหรา รู้สึกพิเศษ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S065103f4b59a4c62a4eaa24b824d37f58.png_200x200q90.png",
        "price": 3812.98,
        "remark": "https://www.lazada.co.th/products/pdp-i6066390534.html",
        "sold": 0
    },
    {
        "product_name": "(รับประกัน 2 ปี!) FEELFREE DRY TANK 40L กระเป๋ากันน้ำ กระเป๋าสะพาย ผช ผญ กระเป๋าเป้กันน้ำ กระเป๋าเดินทาง กระเป๋าสะพายหลัง ขนาด 40 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/e250463df0a65381eb940ee5cc3eb8b4.png_200x200q90.png",
        "price": 3800,
        "remark": "https://www.lazada.co.th/products/pdp-i5553061552.html",
        "sold": 0
    },
    {
        "product_name": "Dory Bag กระเป๋าเป้สำหรับใส่ Dory Underwater Drone",
        "product_image": "https://img.lazcdn.com/g/p/327ebf7a8fe6b8dcd31649ad1c5628a2.jpg_200x200q90.jpg",
        "price": 3798,
        "remark": "https://www.lazada.co.th/products/pdp-i2376864948.html",
        "sold": 0
    },
    {
        "product_name": "toswim | กระเป๋าว่ายน้ำกันน้ำสำหรับเด็ก แยกช่องแห้งและเปียก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbd698ab8925c494db36a1bf2ef6cdea4o.jpg_200x200q90.jpg",
        "price": 3793.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5893704976.html",
        "sold": 17
    },
    {
        "product_name": "CROSSING FOG | กระเป๋าแยกของเปียกและแห้ง กันน้ำ แบบคาดไหล่สำหรับทุกเพศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9a666d82d74f4b19a8509e6e84f6f3e4D.jpg_200x200q90.jpg",
        "price": 3788.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5909682092.html",
        "sold": 25
    },
    {
        "product_name": "MOTOWOLF รุ่น 0714 กระเป๋าเป้กันน้ำ พร้อมตาข่ายใส่หมวกกันน็อคได้ สำหรับเดินทาง หรือขับขี่มอเตอร์ไซค์ ของแท้100%",
        "product_image": "https://img.lazcdn.com/g/p/ef030c041eb08cfc4efdcd2927077db2.jpg_200x200q90.jpg",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i5334545468.html",
        "sold": 1
    },
    {
        "product_name": "PGY - OneGo Rope Strap Bag ประกันศูนย์ไทย",
        "product_image": "https://img.lazcdn.com/g/p/d8f0d878be4507b219ca78deca0145fd.jpg_200x200q90.jpg",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i5777310429.html",
        "sold": 0
    },
    {
        "product_name": "เป้กันน้ำ 20L/30L สะพายหลัง ลุยน้ำ ลุยฝน กันน้ำ น้ำหนักเบา dry bag",
        "product_image": "https://img.lazcdn.com/g/p/4792dca8bd1a0c45189dbc216d020b95.jpg_200x200q90.jpg",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i4328260073.html",
        "sold": 1
    },
    {
        "product_name": "Power Bag กระเป๋าถ่วงน้ำหนัก เกรดยิม  กระเป๋ากระสอบทรายออกกําลังกาย ฝึกความแข็งแรง -Homefittools",
        "product_image": "https://img.lazcdn.com/g/p/49db3e74dc265c4fec1850f4e5dc1d64.png_200x200q90.png",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i5895483586.html",
        "sold": 1
    },
    {
        "product_name": "คันเบ็ด Fenwick Eagle MC คันสามท่อนพร้อมกระเป๋าใส่คัน",
        "product_image": "https://img.lazcdn.com/g/p/9e2ba1e4b8ea2d2715dd59cba295c13e.jpg_200x200q90.jpg",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i3512441345.html",
        "sold": 2
    },
    {
        "product_name": "ITIWIT เป้กันน้ำ Waterproof duffel bag กระเป๋าดัฟเฟิลกันน้ำ ขนาด 30 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/cb63d7cad0f788fa2e2cfd0d6b81285f.jpg_200x200q90.jpg",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i339480512.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าสะพายข้างกันน้ำ ขนาด 15 ลิตร FEELFREE CLIPPER 15L",
        "product_image": "https://img.lazcdn.com/g/p/65d7c939b68b971bdb39d7c47134661a.jpg_200x200q90.jpg",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i2487925148.html",
        "sold": 0
    },
    {
        "product_name": "Moon Lightte กระเป๋าตีนกบว่ายน้ำกระเป๋าถือซิปปิดกระเป๋ากระเป๋าเก็บของอุปกรณ์ดำน้ำสำหรับว่ายน้ำชายหาด Spearfishing การดำน้ำแบบสน็อคเกอร์",
        "product_image": "https://img.lazcdn.com/g/p/832b7896b1063dec1a7796d8a78006ad.jpg_200x200q90.jpg",
        "price": 3762.94,
        "remark": "https://www.lazada.co.th/products/pdp-i6034054375.html",
        "sold": 0
    },
    {
        "product_name": "LEE กระเป๋าทรงตั้งผ้าฝ้ายขนาดกลางสำหรับแฟชั่นสำหรับผู้หญิง14 \"แล็ปท็อปความจุขนาดใหญ่น้ำหนักเบากระเป๋าสะพายหนัง PU สำหรับผู้หญิงเดินป่ากลางแจ้งปิกนิกสบายๆ",
        "product_image": "https://img.lazcdn.com/g/p/92b93e512c324286dca50dbc1930837d.jpg_200x200q90.jpg",
        "price": 3754.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5876370853.html",
        "sold": 0
    },
    {
        "product_name": "2026 24-hour shipping from Tha/iland-RP Protektor ng golf club PXG Golf New Storage Bag, Golf Clutch Bag, Double Layer, Multi-functional,",
        "product_image": "https://img.lazcdn.com/g/p/ff60aa540ef1a036805519d32a38cd80.jpg_200x200q90.jpg",
        "price": 3722.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16126505948.html",
        "sold": 0
    },
    {
        "product_name": "2026 24-hour shipping from Tha/iland-RP /TiS/ Golf Bags Goods Storage Bags Handbags Clutch Bags Double Zipper Wear-Resistant Waterproof",
        "product_image": "https://img.lazcdn.com/g/p/191f204566f00e54740c7ac94aa219b0.jpg_200x200q90.jpg",
        "price": 3722.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16126623717.html",
        "sold": 0
    },
    {
        "product_name": "2026 24-hour shipping from Tha/iland-RP PXG Golf New Storage Bag, Golf Clutch Bag, Double Layer, Multi-functional, Portable, Sports, Unisex,",
        "product_image": "https://img.lazcdn.com/g/p/b1a6ec753160e9b4e014b282dd10936e.jpg_200x200q90.jpg",
        "price": 3722.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16127126696.html",
        "sold": 0
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าถือหลายประโยชน์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S735404e368154ddfb1a94ee01ebedd69g.jpg_200x200q90.jpg",
        "price": 3709.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6062730042.html",
        "sold": 0
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าถือทรงใหญ่สไตล์วินเทจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S30a37ebb6c544b4c979d19e0ddc3bc0az.jpg_200x200q90.jpg",
        "price": 3709.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5996764766.html",
        "sold": 8
    },
    {
        "product_name": "Hosa | เป้สะพายหลังกันน้ำแยกช่องเปียกและแห้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S72b96a45985d46b4a52bcacd940fc4d9I.jpg_200x200q90.jpg",
        "price": 3700.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16053102239.html",
        "sold": 0
    },
    {
        "product_name": "Sea to summit Lightweight Stuff Sack กระเป๋ากันน้ำ ถุงกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/72c2e35c9700943266a9374734ad4893.jpg_200x200q90.jpg",
        "price": 3700,
        "remark": "https://www.lazada.co.th/products/pdp-i4911928906.html",
        "sold": 6
    },
    {
        "product_name": "กระเป๋าปืน   ใส่ได้  2กระบอก   ช่องใส่ แม็กกาซีน  4ช่อง    ช่องใส่ปืน  5นิ้ว   อีกช่อง ใส่ปืน  4นิ้ว  ในใบเดียว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4d8f4fae37a84f538b2860a150766f202.jpg_200x200q90.jpg",
        "price": 3700,
        "remark": "https://www.lazada.co.th/products/pdp-i396366151.html",
        "sold": 0
    },
    {
        "product_name": "【A Boutique】 Durable 25L Outdoor Waterproof Backpack PVC Large Capacity Travel Bag Reflective Strips Comfortable Camping Bag for Men",
        "product_image": "https://img.lazcdn.com/g/p/7303ed384ec009ef2c11d1977319f96f.png_200x200q90.png",
        "price": 3699.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16085392450.html",
        "sold": 0
    },
    {
        "product_name": "Mexican | กระเป๋าใต้วงแขนสำหรับเดินทางฤดูใบไม้ผลิและฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2b9afffcaf4a4845909d385f1a2e00d9S.jpg_200x200q90.jpg",
        "price": 3699.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5893590555.html",
        "sold": 80
    },
    {
        "product_name": "Hosa | กระเป๋าว่ายน้ำกันน้ำ แยกแห้งเปียก น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S70c96d7c71db40eaafad2a07d608b2fai.jpg_200x200q90.jpg",
        "price": 3691.44,
        "remark": "https://www.lazada.co.th/products/pdp-i16052676180.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟขนาดใหญ่จุของได้มากสำหรับผู้ชายและผู้หญิง น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S82c28ebf78b441ebad091b22ba5f17acx.jpg_200x200q90.jpg",
        "price": 3687.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6066977154.html",
        "sold": 0
    },
    {
        "product_name": "Deevoka กระเป๋าเป้สะพายหลัง30L กันน้ำได้,กระเป๋าใส่ฟินสำหรับเดินทางเดินป่ากระเป๋าที่จัดเก็บอเนกประสงค์มีหลายช่อง",
        "product_image": "https://img.lazcdn.com/g/p/470d66df100d915b5f0b8fcc6e14c373.jpg_200x200q90.jpg",
        "price": 3686,
        "remark": "https://www.lazada.co.th/products/pdp-i5975356989.html",
        "sold": 0
    },
    {
        "product_name": "Colaxi กระเป๋าเป้สะพายหลังว่ายน้ำ30ลิตรถุงแห้งใต้น้ำทนต่อการสึกหรอพับเก็บได้กระเป๋าสะพายความจุมาก",
        "product_image": "https://img.lazcdn.com/g/p/b2c0060beb5fa9d5023ee3fefec6cc9b.jpg_200x200q90.jpg",
        "price": 3686,
        "remark": "https://www.lazada.co.th/products/pdp-i16043737557.html",
        "sold": 0
    },
    {
        "product_name": "Gociy กระเป๋าเป้ว่ายน้ำ30ลิตรถุงแห้งใต้น้ำได้สำหรับเดินทางเดินป่าอเนกประสงค์กระเป๋าเป้วินเทจน้ำหนักเบาหลายช่อง",
        "product_image": "https://img.lazcdn.com/g/p/c91be811d031b249e10064914ac2889b.jpg_200x200q90.jpg",
        "price": 3686,
        "remark": "https://www.lazada.co.th/products/pdp-i5967301905.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเป้สะพายหลัง30L TOOYFUL กันน้ำได้หลากหลายช่องสำหรับเดินทางเดินป่าที่จัดเก็บอเนกประสงค์กระเป๋า",
        "product_image": "https://img.lazcdn.com/g/p/f33ef7cade9089d7cc7daefabc1fdcbe.jpg_200x200q90.jpg",
        "price": 3686,
        "remark": "https://www.lazada.co.th/products/pdp-i5975022722.html",
        "sold": 0
    },
    {
        "product_name": "SunnT กระเป๋าเป้สะพายหลัง30L กันน้ำหลายช่องสำหรับตั้งแคมป์ชายหาดแห้งและเปียกแยกพับที่ใส่ของอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/p/e976e3d42a03c1a2c1d77f1d420070e1.jpg_200x200q90.jpg",
        "price": 3686,
        "remark": "https://www.lazada.co.th/products/pdp-i5961409457.html",
        "sold": 0
    },
    {
        "product_name": "Oshni อุปกรณ์หลายช่องครีบแบบจุ่มกระเป๋ากันน้ำกระเป๋าเป้สำหรับว่ายน้ำ30ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/6f482ca9deebb2d35243be0435a6cdea.jpg_200x200q90.jpg",
        "price": 3686,
        "remark": "https://www.lazada.co.th/products/pdp-i6069809989.html",
        "sold": 0
    },
    {
        "product_name": "LoHobobby กระเป๋าเป้สะพายหลังสำหรับดำน้ำ,กระเป๋าเป้สะพายหลังสำหรับใส่อุปกรณ์ดำน้ำ30L น้ำหนักเบามีหลายช่องทนต่อการสึกหรอกระเป๋าเก็บของ",
        "product_image": "https://img.lazcdn.com/g/p/388593d2b3d2ed8333fb0b20620a0943.jpg_200x200q90.jpg",
        "price": 3686,
        "remark": "https://www.lazada.co.th/products/pdp-i5945495059.html",
        "sold": 2
    },
    {
        "product_name": "30L เป้สะพายหลัง Koolsoo กันน้ำหลายกระเป๋าสำหรับดำน้ำดูปะการังล่องแพกระเป๋าเป้วินเทจน้ำหนักเบาจุได้มากอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/p/087fbd89ddf707ab1994a57c292c02bd.jpg_200x200q90.jpg",
        "price": 3686,
        "remark": "https://www.lazada.co.th/products/pdp-i5965769981.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเป้สะพายหลัง30L Hicaee กระเป๋าเดย์แพ็คกันน้ำพีวีซีกระเป๋าสะพายขนาดใหญ่อเนกประสงค์เคลือบตาข่ายน้ำหนักเบาหลายช่อง",
        "product_image": "https://img.lazcdn.com/g/p/b794d68d666184c3d0b02724c69e20db.jpg_200x200q90.jpg",
        "price": 3686,
        "remark": "https://www.lazada.co.th/products/pdp-i16083534369.html",
        "sold": 0
    },
    {
        "product_name": "Gamchiano กระเป๋าเป้สะพายหลังสำหรับดำน้ำ30L กันน้ำถุงตาข่ายเคลือบพีวีซีพับได้สำหรับเดินทางเดินป่าอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/p/20a7b7d8f786a70cc69a9d387b32801f.jpg_200x200q90.jpg",
        "price": 3686,
        "remark": "https://www.lazada.co.th/products/pdp-i6032978956.html",
        "sold": 0
    },
    {
        "product_name": "Moon กระเป๋าเป้สะพายหลังว่ายน้ำ30ลิตรน่ารักกระเป๋ากันน้ำอเนกประสงค์แห้งและเปียกกระเป๋าเก็บของแยก",
        "product_image": "https://img.lazcdn.com/g/p/7b619e0412e4f6f7f3071feefc1e561f.jpg_200x200q90.jpg",
        "price": 3686,
        "remark": "https://www.lazada.co.th/products/pdp-i5984667399.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าโท้ทใบใหญ่สำหรับฤดูใบไม้ผลิและฤดูร้อน กระเป๋าสะพายไหล่เดียว กระเป๋าแพทย์ กระเป๋าหนัง สไตล์ผู้หญิงสุดหรู พร้อมตัวล็อคแบบหัวเข็มขัด รูปทรงหมอนนุ่ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7093eb7f269747b29c54fad0b13e2f47L.jpg_200x200q90.jpg",
        "price": 3682.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16078887964.html",
        "sold": 0
    },
    {
        "product_name": "Hanayo | กระเป๋าถือสำหรับทุกวันดีไซน์เรียบง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3cf0baf2edcd4142b599b737620db1fdA.jpg_200x200q90.jpg",
        "price": 3677.46,
        "remark": "https://www.lazada.co.th/products/pdp-i6062503630.html",
        "sold": 0
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าสะพายข้างสไตล์แคชชวล ใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sca63db321d9c4243bc38f0e9641dc0b41.jpg_200x200q90.jpg",
        "price": 3677.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6018071090.html",
        "sold": 3
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าสี่เหลี่ยมเล็กสำหรับเดินทางที่มีสไตล์และใช้ได้หลายแบบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scbe26e2a1758447da28a1dfa76bf5a662.jpg_200x200q90.jpg",
        "price": 3673.26,
        "remark": "https://www.lazada.co.th/products/pdp-i6034268132.html",
        "sold": 0
    },
    {
        "product_name": "Golf | เป้สำหรับแล็ปท็อปธุรกิจเดินทางสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S171e10d2b0b84c6d9ad640fc1995ddfaN.jpg_200x200q90.jpg",
        "price": 3672.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5909596442.html",
        "sold": 50
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าผู้หญิงดีไซน์ใหม่ ทันสมัย พกพาสะดวกและใช้งานได้หลายแบบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sce9469e7e6fe421eb28995be7e8679c34.jpg_200x200q90.jpg",
        "price": 3670.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16095170631.html",
        "sold": 1
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าถือผู้หญิงหรูหราหวาน รุ่นใหม่ 2026",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S073baa19137e4d9d952a3032dc2680b2m.jpg_200x200q90.jpg",
        "price": 3670.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16094167411.html",
        "sold": 2
    },
    {
        "product_name": "TMSU | กระเป๋าถือแฟชั่นและใช้งานได้จริง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3b6ac85e618e461e9b98b89833d973fcF.jpg_200x200q90.jpg",
        "price": 3661.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16104399305.html",
        "sold": 0
    },
    {
        "product_name": "Sea to Sumit Lightweight Compression Sack กระเป๋ากันน้ำ ถุงกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/a90801509d1055cfbfea88366c44942b.png_200x200q90.png",
        "price": 3660,
        "remark": "https://www.lazada.co.th/products/pdp-i5619945167.html",
        "sold": 2
    },
    {
        "product_name": "ECODAY | กระเป๋าบอสตันทรงโบว์ สะพายข้างหรือถือ สำหรับฤดูใบไม้ผลิและฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc4a28a7cfea34b499b00d2ef47c0d442K.png_200x200q90.png",
        "price": 3657.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6066554893.html",
        "sold": 4
    },
    {
        "product_name": "WESTBRONCO รุ่นPie (พาย) กระเป๋าสะพายข้าง ดีไซน์แฟชั่น สีสันน่ารัก กันน้ำได้",
        "product_image": "https://img.lazcdn.com/g/p/bbf93d4f6aae655f5192cc5c35bd74e5.jpg_200x200q90.jpg",
        "price": 3656.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16114111294.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าสะพายข้างกันน้ำ  FEELFREE FREERUNNER EX S",
        "product_image": "https://img.lazcdn.com/g/p/b1ed96f1c8b4e61dba1a30cfd28b0ab0.jpg_200x200q90.jpg",
        "price": 3054,
        "remark": "https://www.lazada.co.th/products/pdp-i2245446333.html",
        "sold": 3
    },
    {
        "product_name": "Hanayo | กระเป๋าถือแฟชั่นขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S553f56636b9846fbadb443a773e10186h.jpg_200x200q90.jpg",
        "price": 3639.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5999753116.html",
        "sold": 2
    },
    {
        "product_name": "(Ac)2026ใหม่กระเป๋า Chhc มีสไตล์และอเนกประสงค์กระเป๋าสะพายไหล่ใหม่สำหรับผู้หญิงกระเป๋าสะพายข้างข้ามพรมแดนขายดี",
        "product_image": "https://img.lazcdn.com/g/p/9cd1d32a579c801160d09eb0bb11d076.jpg_200x200q90.jpg",
        "price": 3636.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16123161269.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเสื้อกั๊กแขวนยาว สำหรับตกปลา ความจุได้ 4-6 ต้น ป้องกันน้ำหนักเบา ด้านซ้ายและด้านขวา กล่องเก็บอุปกรณ์ตกปลากลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4ca6e0ff49ee4c8a8de09342bbfa7f08o.jpg_200x200q90.jpg",
        "price": 3634,
        "remark": "https://www.lazada.co.th/products/pdp-i16050696374.html",
        "sold": 0
    },
    {
        "product_name": "Korea's New Malbon Golf Handbag Portable Men's And Women's Lightweight Large-capacity Contrasting Color Tote Bag",
        "product_image": "https://img.lazcdn.com/g/p/8b0d7baa4db17bc700a4ba1b7cd07ec1.jpg_200x200q90.jpg",
        "price": 3625.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16140591399.html",
        "sold": 0
    },
    {
        "product_name": "MEXNO | กระเป๋าคาดเอวและสะพายข้างกันน้ำสำหรับเดินทางและกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1064a74f77b84bcc94bbfeb34868761cm.png_200x200q90.png",
        "price": 3615.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6002184376.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า Surecatch HPS Waterproof Dry bag",
        "product_image": "https://img.lazcdn.com/g/p/81a0a7d8a9372aae854fd51ae91d29e1.jpg_200x200q90.jpg",
        "price": 3600,
        "remark": "https://www.lazada.co.th/products/pdp-i5990462804.html",
        "sold": 0
    },
    {
        "product_name": "LEFIGHT | กระเป๋ากีฬาขนาดใหญ่กันน้ำได้สำหรับทุกเพศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa3580619168d44e69fc746696eab7cff3.jpg_200x200q90.jpg",
        "price": 3597.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16050245699.html",
        "sold": 0
    },
    {
        "product_name": "Deevoka ถุงกันน้ำความจุสูงพร้อม Tali Bahu ป้องกันการกระเด็น25ลิตรกระเป๋าเป้ลอยน้ำสำหรับตั้งแคมป์เดินป่ากลางแจ้งพายเรือว่ายน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/8a12f183add5689578113fa6af8866b9.jpg_200x200q90.jpg",
        "price": 3593.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16108802602.html",
        "sold": 0
    },
    {
        "product_name": "Gamchiano กระเป๋าเป้สะพายหลังแห้งกันน้ำ35ลิตรกระเป๋าเก็บของสำหรับการแล่นเรือใบแบกเป้ด้านนอก",
        "product_image": "https://img.lazcdn.com/g/p/e869b2b3e7db1efa8faa1bacd287d8f3.jpg_200x200q90.jpg",
        "price": 3592,
        "remark": "https://www.lazada.co.th/products/pdp-i6075437118.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าฟิตเนสขนาดใหญ่แยกเปียกแห้งได้หลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saef8b66698574d268ffbe875822d0fb3Y.jpg_200x200q90.jpg",
        "price": 3589.08,
        "remark": "https://www.lazada.co.th/products/pdp-i6075328022.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าหนังนุ่มแฟชั่นสำหรับเดินทาง ความจุขนาดใหญ่ ฤดูใบไม้ร่วงฤดูหนาว ใหม่ กระเป๋าสะพายข้างผู้หญิง กระเป๋าสะพายไหล่เดี่ยว สไตล์เกาหลี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sca2a4b031fba4c2182e050f8c59ae8aec.jpg_200x200q90.jpg",
        "price": 3582.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16097881700.html",
        "sold": 0
    },
    {
        "product_name": "Benent กระเป๋าเป้35L กระเป๋าเป้สะพายหลังแห้งกันน้ำสำหรับเดินป่าปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/f2df3d53064de085d21f91480e4609a4.jpg_200x200q90.jpg",
        "price": 3582,
        "remark": "https://www.lazada.co.th/products/pdp-i5867470895.html",
        "sold": 0
    },
    {
        "product_name": "Moon Lighte กระเป๋าเป้สะพายหลังลอยน้ำ35L กระเป๋าเป้สะพายหลังแห้งกันน้ำสำหรับชายหาดล่องแก่งด้านนอก",
        "product_image": "https://img.lazcdn.com/g/p/b1c752dd7b9fd2173fde554090d71a87.jpg_200x200q90.jpg",
        "price": 3582,
        "remark": "https://www.lazada.co.th/products/pdp-i5994492659.html",
        "sold": 0
    },
    {
        "product_name": "Core Bag กระเป๋าถ่วงน้ำหนัก 5 KG. (1 ชิ้น)",
        "product_image": "https://img.lazcdn.com/g/p/4d146d6c0df6306828224262acd02071.png_200x200q90.png",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i5061067783.html",
        "sold": 0
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าความจุใหญ่หรูหราสำหรับเดินทาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb77b171abe8f4ab8b8c43e698781c474r.jpg_200x200q90.jpg",
        "price": 3575.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6077009605.html",
        "sold": 0
    },
    {
        "product_name": "[ New Arrival ] KAVU Mini Remix Rope กระเป๋าสะพายหลัง",
        "product_image": "https://img.lazcdn.com/g/p/0cdd6b2ee124966a1e07bc2da204379e.jpg_200x200q90.jpg",
        "price": 3570,
        "remark": "https://www.lazada.co.th/products/pdp-i4874307011.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าติดเวส Banger ( WOSPORT ) [ VE-75-ACC-07 ] BY:Task Force",
        "product_image": "https://img.lazcdn.com/g/p/5a1de70c457a89a19cef23479c8ea4b2.jpg_200x200q90.jpg",
        "price": 3560,
        "remark": "https://www.lazada.co.th/products/pdp-i4698621302.html",
        "sold": 0
    },
    {
        "product_name": "โมโมกะสโนว์บอร์ดสายคล้องไหล่กระเป๋ามีปกกระเป๋าเดินทางสโนว์บอร์ดแบบนิ่ม",
        "product_image": "https://img.lazcdn.com/g/p/9ee0a13734d88b1626ddb5cf18faf9b9.jpg_200x200q90.jpg",
        "price": 3558,
        "remark": "https://www.lazada.co.th/products/pdp-i16089586588.html",
        "sold": 0
    },
    {
        "product_name": "NeoHome ถุงกอล์ฟ QB074 มีขาตั้ง Golf Bag กระเป๋ากอล์ฟ แบบพกพา สำหรับผู้ชายและผู้หญิง Golf Stand Bag",
        "product_image": "https://img.lazcdn.com/g/p/d76bf222551290fbbedbc069b99d7fd8.png_200x200q90.png",
        "price": 3558,
        "remark": "https://www.lazada.co.th/products/pdp-i5093056436.html",
        "sold": 49
    },
    {
        "product_name": "กระเป๋าเดินทางกระเป๋ากันน้ำ WDAir น้ำหนักเบามี Tali Bahu 25L ความจุมากกันอากาศสำหรับกลางแจ้งปีนเขาตั้งแคมป์พายเรือคายัคท่องเที่ยว",
        "product_image": "https://img.lazcdn.com/g/p/c71e82d9b166c4224ee3406af9e5f58c.jpg_200x200q90.jpg",
        "price": 3552.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6034403943.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาสะพายไหลสำหรบผหญง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa6fa2d56844448f8a00837079eaeb9aby.png_200x200q90.png",
        "price": 3549.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16119358649.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟพกพาความจุมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saf75917b60bd4bcead31d236057cdd61t.jpg_200x200q90.jpg",
        "price": 3546.88,
        "remark": "https://www.lazada.co.th/products/pdp-i6003431152.html",
        "sold": 9
    },
    {
        "product_name": "WDGOOD กระเป๋าเก็บของเชือกอุปกรณ์ปีนเขาน้ำหนักเบากระเป๋าเครื่องมือความจุมากเชือกสำหรับสวนหินไต่เขาเดินป่าสนามแบกเป้",
        "product_image": "https://img.lazcdn.com/g/p/3594f611e0d69a55e754442688232fcf.jpg_200x200q90.jpg",
        "price": 3524,
        "remark": "https://www.lazada.co.th/products/pdp-i5872493187.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าหลัง แบบกลม กระเป๋าผ้ากันน้ำ บรรจุได้ 45 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/588f1a5a0dae81a009cc3f6174299f47.jpg_200x200q90.jpg",
        "price": 3520,
        "remark": "https://www.lazada.co.th/products/pdp-i4678312621.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือแฟชั่น รุ่น B1672",
        "product_image": "https://img.lazcdn.com/g/p/cac57729228c623804899c57f22169d4.jpg_200x200q90.jpg",
        "price": 3504,
        "remark": "https://www.lazada.co.th/products/pdp-i4531715519.html",
        "sold": 0
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าถือตะกร้าสำหรับผู้หญิง รุ่นใหม่ 2026",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc7f20dc979144a1d9714fc7fe08e71a0w.jpg_200x200q90.jpg",
        "price": 3503.52,
        "remark": "https://www.lazada.co.th/products/pdp-i5994880987.html",
        "sold": 5
    },
    {
        "product_name": "กระเป๋าใส่ปืน   หนังสีดำ   วอลเทอร์ walther ppk/s .380 ACP 9มม / STI ELEKTRA .45 ACP / RETAY 84FS / Makarov / Sig Sauer P239   ( กระเป๋า + พกใน)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S299d96d0aa4c43e58e4355840b9ceceaJ.jpg_200x200q90.jpg",
        "price": 3500,
        "remark": "https://www.lazada.co.th/products/pdp-i4883941226.html",
        "sold": 0
    },
    {
        "product_name": "สะพายขนาดกำลังดีกว้าง7นิ้ว สูง8นิ้งครึ่ง น้ำหนักเบาคุณผู้หญิงชอบมาก",
        "product_image": "https://img.lazcdn.com/g/p/c743a0b006ac1df3fd5a1dc1b71c2ca4.jpg_200x200q90.jpg",
        "price": 3500,
        "remark": "https://www.lazada.co.th/products/pdp-i5793824891.html",
        "sold": 0
    },
    {
        "product_name": "Stream Trail-Dry Cube 10L Waterproof Backpack",
        "product_image": "https://img.lazcdn.com/g/p/c2bd77e549f91718bb44cd53f3028810.jpg_200x200q90.jpg",
        "price": 3500,
        "remark": "https://www.lazada.co.th/products/pdp-i421398285.html",
        "sold": 8
    },
    {
        "product_name": "STREAM TRAIL ST DRY CUBE 10L กระเป๋ากันน้ำทรงกระบอก ขนาด 10 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/7964104ccdc0bf9e13c72f035e569f2d.jpg_200x200q90.jpg",
        "price": 3500,
        "remark": "https://www.lazada.co.th/products/pdp-i3834496727.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาสะพายไหล นำหนกเบา เหมาะสำหรบการเดนทาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seacd5fa03e2141c199d5bd0767470221d.png_200x200q90.png",
        "price": 3495.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16121530588.html",
        "sold": 0
    },
    {
        "product_name": "KKn | เป้กันน้ำขนาดเบา 20 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S21d2ab8537da4da4889debba24d02f81K.jpg_200x200q90.jpg",
        "price": 3488.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6071936823.html",
        "sold": 6
    },
    {
        "product_name": "ชายหาดกระเป๋ากันน้ำกระเป๋ากันน้ำหัวฉีดลมสองเท่าสำหรับการดริฟท์",
        "product_image": "https://img.lazcdn.com/g/p/88a73d4aeb865d789848f8809ae0e48c.jpg_200x200q90.jpg",
        "price": 3488,
        "remark": "https://www.lazada.co.th/products/pdp-i6071775972.html",
        "sold": 0
    },
    {
        "product_name": "toswim | กระเป๋าเป้กันน้ำขนาดใหญ่พกพาสำหรับว่ายน้ำและฟิตเนส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S794f643388c446299f8fbbb626a37521B.jpg_200x200q90.jpg",
        "price": 3487.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5892807253.html",
        "sold": 0
    },
    {
        "product_name": "PetFitPro ถุงกอล์ฟ QB074 มีขาตั้ง กระเป๋ากอล์ฟ แบบพกพา สำหรับผู้ชายและผู้หญิง  Golf Stand Bag",
        "product_image": "https://img.lazcdn.com/g/p/d2e86fce9c159420e3e931ee44a710f6.jpg_200x200q90.jpg",
        "price": 3482,
        "remark": "https://www.lazada.co.th/products/pdp-i5092213712.html",
        "sold": 30
    },
    {
        "product_name": "NatureHike | เป้แบคแพ็คกันน้ำแยกส่วนแห้งและเปียก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2be4a92b96194157ac24002094708ab55.jpg_200x200q90.jpg",
        "price": 3475.04,
        "remark": "https://www.lazada.co.th/products/pdp-i6062759114.html",
        "sold": 0
    },
    {
        "product_name": "เป้กันน้ำลายการ์ตูนสำหรับเด็ก แยกช่องแห้งและชื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scb8ec3ca7b274c3ab0001410904437e3F.jpg_200x200q90.jpg",
        "price": 3472.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16120756142.html",
        "sold": 2
    },
    {
        "product_name": "LEE กระเป๋าเล็กขนาดเล็กน้ำหนักเบาสำหรับผู้หญิงเดินป่ากลางแจ้งปิคนิคกระเป๋าเป้สะพายหลังน่ารักสไตล์เกาหลีสำหรับใส่เดินเดินทางลำลอง",
        "product_image": "https://img.lazcdn.com/g/p/d29ff989454541c7c657054f187e4f74.jpg_200x200q90.jpg",
        "price": 3472,
        "remark": "https://www.lazada.co.th/products/pdp-i5789621220.html",
        "sold": 10
    },
    {
        "product_name": "Golf | เป้คอมพิวเตอร์สำหรับเดินทางธุรกิจ ความจุใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scc379885307148eca7a3b7276c19ba953.jpg_200x200q90.jpg",
        "price": 3463.38,
        "remark": "https://www.lazada.co.th/products/pdp-i5909677909.html",
        "sold": 78
    },
    {
        "product_name": "Zoke | กระเป๋าว่ายน้ำกันน้ำแยกแห้ง-เปียกสำหรับเด็กผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S496d17e6cb2d4aab84cf72b32027fa554.jpg_200x200q90.jpg",
        "price": 3459.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5893869806.html",
        "sold": 6
    },
    {
        "product_name": "Arena | กระเป๋าความจุใหญ่กันน้ำแยกส่วนเปียกและแห้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sae284d058df948e4b444edf52bd94915s.jpg_200x200q90.jpg",
        "price": 3454.78,
        "remark": "https://www.lazada.co.th/products/pdp-i6014094132.html",
        "sold": 7
    },
    {
        "product_name": "Hanayo | กระเป๋าถือขนฟูคุณภาพสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbe830e196c814b2ab0dbdfc68d0f9092Y.jpg_200x200q90.jpg",
        "price": 3438.26,
        "remark": "https://www.lazada.co.th/products/pdp-i6026216033.html",
        "sold": 0
    },
    {
        "product_name": "Momoka กระสอบตั้งแคมป์35L กระเป๋าเป้สะพายหลังแห้งกันน้ำสำหรับการเดินทางภายนอกการตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/a318d4a4ce59d19da99fcdb511d52e58.jpg_200x200q90.jpg",
        "price": 3437.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16128103194.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า35L กระเป๋าเป้สะพายหลังแห้งกันน้ำ Sposport กระเป๋าเป้สะพายหลังแบบลอยน้ำได้สำหรับพายเรือคายัคด้านนอก",
        "product_image": "https://img.lazcdn.com/g/p/9282206385eed770094e2357a4038751.jpg_200x200q90.jpg",
        "price": 3437.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16121657109.html",
        "sold": 0
    },
    {
        "product_name": "Hanayo | กระเป๋าถือสำหรับเดินทางขนาดใหญ่พรีเมี่ยม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S62c92062cfe240cf991d0c8b00346a7a9.jpg_200x200q90.jpg",
        "price": 3437.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6068333009.html",
        "sold": 1
    },
    {
        "product_name": "7สี กระเป๋ากันน้ำ Dry Backpack water pro 30 L ขนาดยอดนิยม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3a6ca745cede4b5585a4371abd130db1p.jpg_200x200q90.jpg",
        "price": 3426.28,
        "remark": "https://www.lazada.co.th/products/pdp-i4138352741.html",
        "sold": 11
    },
    {
        "product_name": "fishfalcon | กระเป๋าคาดเอวกันน้ำทนทาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seffff4c01f4b460895692ed53a88fba1F.jpg_200x200q90.jpg",
        "price": 3425.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6031193669.html",
        "sold": 0
    },
    {
        "product_name": "Hosa | กระเป๋าว่ายน้ำความจุใหญ่มากฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S98956a7187a44dedac6fd68d391611f01.jpg_200x200q90.jpg",
        "price": 3423.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16052446967.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาสะพายขาง กระเปาแฟชน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S74c9c7c4dcce4836ab10e363b92eb7ddt.png_200x200q90.png",
        "price": 3422,
        "remark": "https://www.lazada.co.th/products/pdp-i16099642517.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ Rapha Rainproof Case ของแท้",
        "product_image": "https://img.lazcdn.com/g/p/d84aa64c75e47bbf339f7deac7381e09.png_200x200q90.png",
        "price": 3400,
        "remark": "https://www.lazada.co.th/products/pdp-i418278578.html",
        "sold": 16
    },
    {
        "product_name": "Hanayo | กระเป๋าถือทรงโตเกะขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd2b5335843964eb4b413b8997905a4c5w.jpg_200x200q90.jpg",
        "price": 3399.16,
        "remark": "https://www.lazada.co.th/products/pdp-i6068063704.html",
        "sold": 1
    },
    {
        "product_name": "พร้อมส่ง กระเป๋าใส่ปืนยาว 9.11 ยาว 120 เซ็นติเมตร ( 47 นิ้ว )",
        "product_image": "https://img.lazcdn.com/g/p/0c17392da3ac807fc179d6bcbda19551.jpg_200x200q90.jpg",
        "price": 3396,
        "remark": "https://www.lazada.co.th/products/pdp-i5789790118.html",
        "sold": 0
    },
    {
        "product_name": "【lock】 25L Waterproof Backpack Swimming Beach Dry Bag Outdoor Water Sports Rafting Boating Roll Top Bags Kayaking Handbag Camping Bag",
        "product_image": "https://img.lazcdn.com/g/p/b5bf32c4e33b4b3fd409b3b7bb0654a3.png_200x200q90.png",
        "price": 3390.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16085224782.html",
        "sold": 0
    },
    {
        "product_name": "AOTU ตัวล็อคความจุขนาดใหญ่เคลือบอ๊อกซ์ฟอร์ดผ้ากันน้ำทนต่อการฉีกขาดกระเป๋าเก็บของเหมาะหูหิ้วเพิ่มความแข็งแรงสำหรับการตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/fdd98013e2cdbb35061a87a0512fd026.jpg_200x200q90.jpg",
        "price": 3384,
        "remark": "https://www.lazada.co.th/products/pdp-i4989873712.html",
        "sold": 0
    },
    {
        "product_name": "Benent กระเป๋าใส่โน๊ตบุ๊คแบบพกพากระเป๋ามีปกสโนว์บอร์ดสโนว์บอร์ดแบบนุ่มป้องกันสโนว์บอร์ดวัสดุห่อบรรจุภัณฑ์ขนส่งเคส Sarung Lengan กระเป๋าเก็บของสกี",
        "product_image": "https://img.lazcdn.com/g/p/11d16d200cc0211646bb67351b28c5d0.jpg_200x200q90.jpg",
        "price": 3380.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16119086096.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าฟินฟรีไดฟ์ ผ้ากันน้ำ กระเป๋าใส่ครีบยาวมีสายสะพาย กระเป๋าใส่อุปกรณ์กีฬาทางน้ำผ้ากันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/9cabe47ffae53eac6c567a5e967c6d55.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i5845388577.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาแฟชนลำลองรนใหม กระเปาสะพายไหล กระเปาเดนทาง กระเปาสำหรบออกนอกบาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S051ce7b1c3b641bd849f8f8fa8462b73y.png_200x200q90.png",
        "price": 3266.4,
        "remark": "https://www.lazada.co.th/products/pdp-i16121590420.html",
        "sold": 0
    },
    {
        "product_name": "Korea's New Malbon Golf Bag Lightweight Stand Standard Universal Men's And Women's Clubs Thickened Waterproof Fabric",
        "product_image": "https://img.lazcdn.com/g/p/687d84ca11a14360f201d4326c842b27.jpg_200x200q90.jpg",
        "price": 13037.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16140473829.html",
        "sold": 0
    },
    {
        "product_name": "Waterproof Backpack, Roll-Top, Large Capacity, Unisex, Outdoor, Surfing, Drifting, Water Activities, Travel",
        "product_image": "https://img.lazcdn.com/g/p/f86b400dcb2ab231b5c6cc5eaea50bdb.jpg_200x200q90.jpg",
        "price": 3373,
        "remark": "https://www.lazada.co.th/products/pdp-i16043783460.html",
        "sold": 0
    },
    {
        "product_name": "PUMA | พูม่ากระเป๋าสะพายแฟชั่นอินเทรนด์สำหรับบุรุษและสตรี กระเป๋าเป้สะพายหลังลำลอง กระเป๋าเดินทางรายวัน กระเป๋ากีฬา 092377-01",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S80494f26d45a4c628833434874f5bb6by.jpg_200x200q90.jpg",
        "price": 3365.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16104724985.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาถอสำหรบพนกงานออฟฟศ กระเปาสะพายไหลขนาดเลก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8320bddc0f584feb9defb953657f7df3T.png_200x200q90.png",
        "price": 3361.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16099271837.html",
        "sold": 0
    },
    {
        "product_name": "FANJI PROJECT | กระเป๋าผ้ากันน้ำแบบมีเชือกรูดสำหรับ Dragon 8811",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4fac0056c65243b4be3af46654790998g.jpg_200x200q90.jpg",
        "price": 3359.12,
        "remark": "https://www.lazada.co.th/products/pdp-i6003099814.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า CRESSI 360 Regulator Bag สำหรับเก็บเรกูเลเตอร์และเกจวัดความดันดำน้ำ ผลิตจากไนลอนทนทาน บุโฟมกันกระแทก ซิป YKK สายสะพายไหล่ปรับได้",
        "product_image": "https://img.lazcdn.com/g/p/2636f371a9e160396142cd94ab76ff53.jpg_200x200q90.jpg",
        "price": 3348,
        "remark": "https://www.lazada.co.th/products/pdp-i5832489561.html",
        "sold": 0
    },
    {
        "product_name": "Pontoon Top Storage Bag Waterproof Heavy Duty Boat T-top Bag for Life Jackets Large Capacity Yacht Pontoon Bimini Storage Bag Marine Grade Float Top Hanging Organizer",
        "product_image": "https://img.lazcdn.com/g/p/fcd75b365ac725b6f22a108f2c67b671.jpg_200x200q90.jpg",
        "price": 3346.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6008809741.html",
        "sold": 0
    },
    {
        "product_name": "≮117≯กระเป๋ากันน้ำ กระเป๋าใส่เสื้อผ้า The North Face BASECAMP FUSEBOX พร้อมส่งจากไทย",
        "product_image": "https://img.lazcdn.com/g/p/295ec5361a9f74f832676d42ac26fe8e.jpg_200x200q90.jpg",
        "price": 3344.36,
        "remark": "https://www.lazada.co.th/products/pdp-i6043282550.html",
        "sold": 0
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าถือแฟชั่นความจุใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sefa37ace478b4c9cb7b3b1167a8515abq.jpg_200x200q90.jpg",
        "price": 3344.18,
        "remark": "https://www.lazada.co.th/products/pdp-i5994842795.html",
        "sold": 0
    },
    {
        "product_name": "CinvaiKrose | กระเป๋าถือสำหรับผู้หญิง ความจุมาก สะพายไหล่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S148dc60bcfa44f3aafc8ae3a99f874a5A.png_200x200q90.png",
        "price": 3344.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5878266888.html",
        "sold": 2
    },
    {
        "product_name": "กระเป๋าถือสีเงินแฟชั่นพร้อมพวงกุญแจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S660c94c76003444eb9d665b25b4b5a9b7.png_200x200q90.png",
        "price": 3336.86,
        "remark": "https://www.lazada.co.th/products/pdp-i6029515276.html",
        "sold": 0
    },
    {
        "product_name": "CinvaiKrose | กระเป๋าถือหนังสำหรับเดินทาง ความจุมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb66695a6b8114f2aa23a1274da14e63bc.png_200x200q90.png",
        "price": 3335.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5875668116.html",
        "sold": 10
    },
    {
        "product_name": "CinvaiKrose | กระเป๋าถือทรงบักเก็ตขนาดใหญ่ ใหม่ 2026",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sba45f5dc129f4014a80bce8a702692c4g.png_200x200q90.png",
        "price": 3333.06,
        "remark": "https://www.lazada.co.th/products/pdp-i5881944273.html",
        "sold": 10
    },
    {
        "product_name": "SMOSMOS | กระเป๋าใต้วงแขนดีไซน์เก๋",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S50b0e3e912644b3cad6c36607208e36ao.jpg_200x200q90.jpg",
        "price": 3328.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6066471798.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาสะพายไหลสำหรบผหญง ดไซนเรยบงาย สสนสดใส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2ce59ac8c5174549abe9940507ab2775S.png_200x200q90.png",
        "price": 3326,
        "remark": "https://www.lazada.co.th/products/pdp-i6069089915.html",
        "sold": 0
    },
    {
        "product_name": "Playboy(PLAYBOY(เพลย์บอย)) | กระเป๋าถือหรูหราสำหรับสตรีวัยกลางคน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1c6354e32fbd4b038e46d2f1017f4b1fe.jpg_200x200q90.jpg",
        "price": 3324.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16050322000.html",
        "sold": 0
    },
    {
        "product_name": "ช่องเก็บแห้งและเปียก25ลิตรสำหรับตั้งแคมป์ทำจากพีวีซีแข็งแรงทนทานสำหรับเดินทางกระเป๋ากันน้ำกระเป๋าแบ็คแพ็คกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/32ea3ec6588feca1b188c0c73f911ab2.jpg_200x200q90.jpg",
        "price": 3321.78,
        "remark": "https://www.lazada.co.th/products/pdp-i6073899229.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าแบบกล่องนูนลายเฉพาะ 2026 กระเป๋าถือสไตล์ใหม่ที่ให้ความรู้สึกหรูหรา กระเป๋าสี่เหลี่ยมเล็ก",
        "product_image": "https://img.lazcdn.com/g/p/a3316104576b84e9ba483c7454217a64.jpg_200x200q90.jpg",
        "price": 3318,
        "remark": "https://www.lazada.co.th/products/pdp-i6045959460.html",
        "sold": 0
    },
    {
        "product_name": "(โกลดสไมล) กระเปาเปใสกนนำ กระเปาชายหาด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7c9981b1a15143ed9e884e2d8fd22722U.jpg_200x200q90.jpg",
        "price": 3314.94,
        "remark": "https://www.lazada.co.th/products/pdp-i16069128680.html",
        "sold": 0
    },
    {
        "product_name": "BSEWO กระเป๋ากระเป๋าเป้สะพายหลังกันน้ำแบบม้วนด้านบนกระเป๋าเป้สะพายหลังกันน้ำงานหนักกระเป๋าว่ายน้ำแบบม้วนด้านบนพร้อมกระเป๋าซิปด้านหน้า",
        "product_image": "https://img.lazcdn.com/g/p/6b781e71b64e1c8c8b77ae583a4508d7.jpg_200x200q90.jpg",
        "price": 3314,
        "remark": "https://www.lazada.co.th/products/pdp-i6068322277.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA WOTAO กระเป๋ากระเป๋าเป้สะพายหลังกันน้ำแบบม้วนด้านบนสำหรับงานหนักกระเป๋าว่ายน้ำปิดแบบม้วนด้านบนพร้อมกระเป๋าซิปด้านหน้าสีฟ้า30L",
        "product_image": "https://img.lazcdn.com/g/p/aba62ae1cf552424eb6ea7ce0ceb401d.jpg_200x200q90.jpg",
        "price": 3314,
        "remark": "https://www.lazada.co.th/products/pdp-i6016054758.html",
        "sold": 0
    },
    {
        "product_name": "WOTAO กระเป๋าแห้งแบบม้วนด้านบนกระเป๋าเป้สะพายหลังกันน้ำกระเป๋าว่ายน้ำปิดแบบม้วนด้านบนพร้อมกระเป๋าซิปด้านหน้าสีฟ้า30L",
        "product_image": "https://img.lazcdn.com/g/p/6cfcb4453ba940faf34ddee87a635a4c.jpg_200x200q90.jpg",
        "price": 3314,
        "remark": "https://www.lazada.co.th/products/pdp-i6016072574.html",
        "sold": 0
    },
    {
        "product_name": "SMOSMOS | กระเป๋าสะพายข้างสีดำสำหรับเดินทางดีไซน์เนอร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6e091e4536ad44f6baf8df819547ede2a.jpg_200x200q90.jpg",
        "price": 3311.94,
        "remark": "https://www.lazada.co.th/products/pdp-i6066558641.html",
        "sold": 0
    },
    {
        "product_name": "Zoke | กระเป๋าว่ายน้ำกันน้ำ ความจุมาก พร้อมแยกแห้ง/เปียก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S29336b79b50f4e4d8d302d8676a22f66k.jpg_200x200q90.jpg",
        "price": 3310.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5892499506.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาเสรม กระเปาสไตลลำลอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc80fbd7df6cd49a5b08033bc2a881d10t.png_200x200q90.png",
        "price": 3305.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16121462485.html",
        "sold": 0
    },
    {
        "product_name": "Mexican | กระเป๋าสะพายข้างขนาดใหญ่ จุของได้เยอะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sabff87f044d0430686c8fcdefea2bf6dd.jpg_200x200q90.jpg",
        "price": 3300.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5893657520.html",
        "sold": 12
    },
    {
        "product_name": "FEELFREE DRY TANK 15L กระเป๋าเป้กันน้ำ พรีเมี่ยม ขนาด 15 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/2fea457d7bdc821cdb551fcb48c5c42a.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i4986045830.html",
        "sold": 0
    },
    {
        "product_name": "Nite Ize กระเป๋ากันน้ำ RunOff Waterproof Medium Packing Cube",
        "product_image": "https://img.lazcdn.com/g/p/460b7ac9bf4c798de151fcb97abcaf57.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i315688278.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋าติดเวส Double Pouch ( WOSPORT ) Back Panel Double Pouch [ VE-75-ACC-06 ] BY:Task Force",
        "product_image": "https://img.lazcdn.com/g/p/5a1de70c457a89a19cef23479c8ea4b2.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i4696185471.html",
        "sold": 0
    },
    {
        "product_name": "Muva | กระเป๋าถือ รุ่น MINI COTTON CANDY",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Se1dcfb25f32f424eb5e19aa58e8ebd7aj.png_200x200q90.png",
        "price": 3297.74,
        "remark": "https://www.lazada.co.th/products/pdp-i6002330548.html",
        "sold": 61
    },
    {
        "product_name": "กระเป๋าเก็บฟินดำน้ำกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S61c47041957a4f7c9b1cc8c36a2895aft.jpg_200x200q90.jpg",
        "price": 3296,
        "remark": "https://www.lazada.co.th/products/pdp-i16124370304.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาสะพายไหล กระเปาแฟชน กระเปาทำงาน กระเปาเปธรกจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa69261b347c04bd0bb17cfe337575f78q.png_200x200q90.png",
        "price": 3293.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16099391704.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาแฟชนสำหรบออกงาน กระเปาสะพายไหลผหญง กระเปาทำงานขนาดเลก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S61533e9fcc614c1e828c3fe508a2862dC.png_200x200q90.png",
        "price": 3293.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16099450828.html",
        "sold": 0
    },
    {
        "product_name": "(โกลดสไมล)เดล มน ครอสแบค กระเปาสะพายไหลผหญง กระเปานกเรยนแบบยนเซกส กระเปาลำลอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S80ee1f498c9a463ca4e815a40ad148f0d.png_200x200q90.png",
        "price": 3170.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16117733917.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA WOTAO กระเป๋าแห้งกระเป๋าเป้สะพายหลังกันน้ำกันน้ำ-กระสอบกลางแจ้งสำหรับการติดตามแม่น้ำ-การว่ายน้ำ-การเล่นเซิร์ฟชายหาด-30L ความจุขนาดใหญ่-ผ้าตาข่ายพีวีซี500D-IPX6ระดับกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/86efc51e0ee193e16e38375fad96038a.jpg_200x200q90.jpg",
        "price": 3276,
        "remark": "https://www.lazada.co.th/products/pdp-i6056593192.html",
        "sold": 0
    },
    {
        "product_name": "Sunlooke กระเป๋าแห้งและกันน้ำ6ชิ้น,ถุงกันน้ำอเนกประสงค์ถุงเก็บของกันน้ำกระสอบผ้าสำหรับกีฬาทางน้ำชายหาดตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/91d859c24a97cb65625281fc784eb306.jpg_200x200q90.jpg",
        "price": 3274,
        "remark": "https://www.lazada.co.th/products/pdp-i5909399962.html",
        "sold": 0
    },
    {
        "product_name": "Waterproof Outdoor Backpack, Lightweight Hiking Double Shoulder Bag, Unisex for Trekking, Rafting, Surfing, Diving",
        "product_image": "https://img.lazcdn.com/g/p/f9861b288a1e1a752798d1d9eabb0eae.jpg_200x200q90.jpg",
        "price": 3264.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6074941653.html",
        "sold": 0
    },
    {
        "product_name": "Waterproof Creek Trekking Backpack, Lightweight Outdoor Dry Bag, Unisex Double Shoulder Pack for Rafting, Surfing, Diving",
        "product_image": "https://img.lazcdn.com/g/p/e604e444ce035b089f0e85df1bf7f144.jpg_200x200q90.jpg",
        "price": 3264.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6073771371.html",
        "sold": 0
    },
    {
        "product_name": "Golf | เป้สำหรับผู้หญิง ท่องเที่ยว ธุรกิจ สไตล์ลำลอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7aa1d2d41e5649feb1ec82e035823f53b.jpg_200x200q90.jpg",
        "price": 3631.54,
        "remark": "https://www.lazada.co.th/products/pdp-i5909852331.html",
        "sold": 408
    },
    {
        "product_name": "Waterproof Trekking Backpack, Lightweight Outdoor Hiking Sports Bag, Unisex Double Shoulder Pack for Diving, Surfing, Rafting",
        "product_image": "https://img.lazcdn.com/g/p/f9861b288a1e1a752798d1d9eabb0eae.jpg_200x200q90.jpg",
        "price": 3264.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6073782690.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเป้สะพายหลังแห้งและกันน้ำ Fangzi 20L พีวีซีสำหรับล่องแพเรือคายัคตกปลากลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/eb3b9958daae4c1a1221a08df53baeab.jpg_200x200q90.jpg",
        "price": 3263.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6075192431.html",
        "sold": 0
    },
    {
        "product_name": "CinvaiKrose | กระเป๋าถือขนาดใหญ่สำหรับผู้หญิง ปี 2026",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S601e607548be43989ee35edf8091e164l.png_200x200q90.png",
        "price": 3260.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5878114811.html",
        "sold": 7
    },
    {
        "product_name": "joinfit | ถุงน้ำหนักสำหรับฝึกความแข็งแรง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdc95b255d0f04ffaa8379465fda3a958d.png_200x200q90.png",
        "price": 3258.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16051856480.html",
        "sold": 0
    },
    {
        "product_name": "กอล์ฟ | เป้สะพายหลังสำหรับเดินทางที่ทันสมัยและใช้งานได้หลายแบบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saf1b1f2b17394150a3ede6ad2c81d893Q.png_200x200q90.png",
        "price": 3251.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5972782431.html",
        "sold": 53
    },
    {
        "product_name": "Zoke | กระเป๋าสำหรับว่ายน้ำขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S27ee580b56424ca2b1b754bfcb00af68O.jpg_200x200q90.jpg",
        "price": 3238.52,
        "remark": "https://www.lazada.co.th/products/pdp-i5893634947.html",
        "sold": 2
    },
    {
        "product_name": "Deevoka กระเป๋าแห้งและกันน้ำถุงกันน้ำ6ชิ้น,ถุงเก็บของกันน้ำอัดลมสำหรับพายเรือแคนูว่ายน้ำลอยตั้งแคมป์ท่องเที่ยว",
        "product_image": "https://img.lazcdn.com/g/p/ab07485979396af9dfa09b6576559ce2.jpg_200x200q90.jpg",
        "price": 3238,
        "remark": "https://www.lazada.co.th/products/pdp-i5960985235.html",
        "sold": 0
    },
    {
        "product_name": "VANWALK | กระเป๋าถือสไตล์รีโทรสำหรับฤดูใบไม้ร่วงและหนาว แบบบอสตัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4749c2a027d04acb81fd87457a286ef1r.jpg_200x200q90.jpg",
        "price": 3228.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16049273973.html",
        "sold": 0
    },
    {
        "product_name": "Golf | เป้สะพายหลังสำหรับเดินทางและเดินทางไปทำงาน น้ำหนักเบา ความจุมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S725b0994765540409d1d28c42507c14bV.jpg_200x200q90.jpg",
        "price": 3222.58,
        "remark": "https://www.lazada.co.th/products/pdp-i5909790459.html",
        "sold": 61
    },
    {
        "product_name": "ZICHAO | ของขวัญสำหรับแฟนสาว กระเป๋าเป้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S287064551b574adab43723bf28355aefL.jpg_200x200q90.jpg",
        "price": 3220.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5912466559.html",
        "sold": 13
    },
    {
        "product_name": "KAVU Wombat กระเป๋าเป้ กระเป๋าสะพายหลัง",
        "product_image": "https://img.lazcdn.com/g/p/41286c00919129940246773fe544b75f.jpg_200x200q90.jpg",
        "price": 3220,
        "remark": "https://www.lazada.co.th/products/pdp-i4874283261.html",
        "sold": 1
    },
    {
        "product_name": "Hosa | กระเป๋าความจุใหญ่สำหรับการฝึกว่ายน้ำกันน้ำ พร้อมแยกช่องเปียก-แห้ง แบบสองสายสะพาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1073530f445f41fcb7fdd99273d20b477.jpg_200x200q90.jpg",
        "price": 3200.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16052413933.html",
        "sold": 0
    },
    {
        "product_name": "[NEW ARRIAL] FEELFREE TOTE L CHANG  กระเป๋าเอนกประสงค์ผ้ากันฝน",
        "product_image": "https://img.lazcdn.com/g/p/7e3aa99efdbccf82e5308bb9db3751db.jpg_200x200q90.jpg",
        "price": 3200,
        "remark": "https://www.lazada.co.th/products/pdp-i6035336761.html",
        "sold": 0
    },
    {
        "product_name": "[NEW ARRIAL] FEELFREE TOTE L CHANG  กระเป๋าผ้ากันฝนเอนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/p/7e3aa99efdbccf82e5308bb9db3751db.jpg_200x200q90.jpg",
        "price": 3200,
        "remark": "https://www.lazada.co.th/products/pdp-i6035425301.html",
        "sold": 0
    },
    {
        "product_name": "riosquarerich 100 ใบ/50ใบคละสี11cm×20.5cmพร้อมส่งซองกันน้ำคล้องคอ ทัชสกรีนได้ กระเป๋ากันน้ำ ซองดำน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/82ee327fc9dcefcf18757482fb22052c.jpg_200x200q90.jpg",
        "price": 3200,
        "remark": "https://www.lazada.co.th/products/pdp-i5795875141.html",
        "sold": 0
    },
    {
        "product_name": "(รับประกัน 2 ปี!)FEELFREE DRY TANK 30L กระเป๋ากันน้ำ กระเป๋าสะพาย ผช ผญ กระเป๋าเป้กันน้ำ กระเป๋าเดินทาง กระเป๋าสะพายหลัง ขนาด 30 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/857bc556ef01a01aef83b385902a4455.png_200x200q90.png",
        "price": 3200,
        "remark": "https://www.lazada.co.th/products/pdp-i5552945418.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือผู้หญิง Tabby 26ในสต็อก91215",
        "product_image": "https://img.lazcdn.com/g/p/01a3d0e632b19a250b57e950575c832f.jpg_200x200q90.jpg",
        "price": 3198,
        "remark": "https://www.lazada.co.th/products/pdp-i6072408503.html",
        "sold": 0
    },
    {
        "product_name": "Hanayo | กระเป๋าถือแฟชั่นสำหรับแม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd91ca80d87ef48939438fa3998ccf873k.jpg_200x200q90.jpg",
        "price": 3197.86,
        "remark": "https://www.lazada.co.th/products/pdp-i6019159565.html",
        "sold": 0
    },
    {
        "product_name": "FANJI PROJECT | กระเป๋าใส่ของกันน้ำสำหรับ Chanel22bag",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se5d058a2efa348dc92a0a3b4522c46d10.jpg_200x200q90.jpg",
        "price": 3191.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6003278998.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่โทรศัพท์กันน้ำ KATE SPADE Waterproof Floating Pouch-Silver Glitter แท้ 100% 🔥จากShop ✅",
        "product_image": "https://img.lazcdn.com/g/p/88a29b3d2312ee4fd019380996a376cc.png_200x200q90.png",
        "price": 3190,
        "remark": "https://www.lazada.co.th/products/pdp-i5381221741.html",
        "sold": 0
    },
    {
        "product_name": "ใหม่ล่าสุด กระเป๋าใส่โทรศัพท์กันน้ำ KATE SPADE Waterproof Floating Pouch-Silver Glitter แท้ 100% 🔥จากShop ✅",
        "product_image": "https://img.lazcdn.com/g/p/88a29b3d2312ee4fd019380996a376cc.png_200x200q90.png",
        "price": 3190,
        "remark": "https://www.lazada.co.th/products/pdp-i5381432081.html",
        "sold": 0
    },
    {
        "product_name": "Hosa | เป้สะพายหลังความจุใหญ่สำหรับการฝึกว่ายน้ำหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7242d95bd0fd45eab92513cb2ba403bdo.jpg_200x200q90.jpg",
        "price": 3189.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16053201420.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำสำหรับพายเรือคายัค กระเป๋าเป้สะพายหลังสำหรับว่ายน้ำ ล่องแก่งขนาดใหญ่ กระเป๋าสะพายไหล่สำหรับเดินป่าชายหาด ดำน้ำ ล่องแพ แคนู กระเป๋าแคมป์ปิ้ง PVC",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd7920edd58474e5a83003dea50ffde24e.jpg_200x200q90.jpg",
        "price": 3188.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16127669611.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าจัดระเบียบกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S37ca5422c67d4ec8af8ee25d8506e5f68.png_200x200q90.png",
        "price": 3188.44,
        "remark": "https://www.lazada.co.th/products/pdp-i16116531859.html",
        "sold": 0
    },
    {
        "product_name": "Hanayo | กระเป๋าถือสำหรับผู้หญิงสไตล์แฟชั่นสำหรับเดินทาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc765fd52c8ef472aadd9a8da465d906b1.jpg_200x200q90.jpg",
        "price": 3185.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6019094762.html",
        "sold": 0
    },
    {
        "product_name": "FANJI PROJECT | กระเป๋าเก็บของกันน้ำวัสดุ DuPont น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfb097a6cf09c47709133e72a3c5990a0Y.jpg_200x200q90.jpg",
        "price": 3181.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6003100413.html",
        "sold": 0
    },
    {
        "product_name": "ซองปืน  กระเป๋าใส่ปืน    ( ลูกโม่ .22 )     4นิ้ว    1ใบ      พร้อม กระเป๋า ใส่ลูก .22    1ใบ",
        "product_image": "https://img.lazcdn.com/g/p/49ef751dc676fd92ff7514d593d7ae80.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5274506932.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือแฟชั่น รุ่น B1890",
        "product_image": "https://img.lazcdn.com/g/p/fe9bd36a644429c7d4daf27127d09942.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5188248679.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ - Deep Blue Adventure Backpack 2.0 30L",
        "product_image": "https://img.lazcdn.com/g/p/586bb9617904cd835cd5db1c13aad2ea.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5180393533.html",
        "sold": 0
    },
    {
        "product_name": "👜กระเป๋าสะพาย CH008 ถือแล้วลุคแพงขึ้นทันที 🤎สะพายไหล่ก็ได้ / สะพายยาวก็ปัง 💰พร้อมส่ง ราคาน่ารักมากกก",
        "product_image": "https://img.lazcdn.com/g/p/b5a513ab2ad2d3655a22cec0e8a9ed44.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i16103953261.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า Alpaka - Flight Sling 1L Axoflux 210D",
        "product_image": "https://img.lazcdn.com/g/p/5c5723b204a6c088c67910bfa9846de5.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5564223346.html",
        "sold": 17
    },
    {
        "product_name": "EcoFlow River Bagpack กระเป๋า",
        "product_image": "https://img.lazcdn.com/g/p/b3ad388b2caad192765e2ff2183375f9.png_200x200q90.png",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5504045883.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋าติดเวส Compress Hydration Bladder Backpack (AFG)[AFG-HP005] ใช้สำหรับใส่ถุงน้ำ หรือสัมภาระอื่นๆ สามารถขยายขนาดได้ จุได้ 8L  ใช้ร้อยติดเวส หรือ เป้ได้ ขนาด 21 * 32 cm. (8L) ไม่ได้แถมถุงน้ำ นะครับ",
        "product_image": "https://img.lazcdn.com/g/p/ea4bf3a75c830b584d6b882d0c5529f4.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5198997660.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันกระแทก กระเป๋าใส่ปืนยาว Hardcase กล่องใส่ปืน เก็บของ Tool Box ความยาว90cm 120cm สีดำ ส่งจากไทย",
        "product_image": "https://img.lazcdn.com/g/p/d6453306db559c9455ffc88eb77dee69.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5289110200.html",
        "sold": 10
    },
    {
        "product_name": "Matador FlatPak Dry Bag กระเป๋ากันน้ำป้องกันได้ระดับ IPX7 ขนาด 8 ลิตร และ 2 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/39802a033fefdfd38853289c37f452e6.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i4867361156.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋ากอล์ฟแบบถือ Golf Boston Bag ความจุใหญ่ กันน้ำ ดีไซน์แฟชั่น หลายช่อง พร้อมสายสะพาย  YWB007",
        "product_image": "https://img.lazcdn.com/g/p/b12f34b2a869a30ebd92a645a17233c8.jpg_webp_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i16106903021.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสุดคิ้วท์ สะพายก็ได้ เป้ก็เก๋🎀5155🎀ใบเดียวเปลี่ยนลุคในพริบตา 🔥แมตช์ได้ทุกสไตล์ ใช้ได้ทุกโอกาส",
        "product_image": "https://img.lazcdn.com/g/p/0f2794e95104b7fa102b5473f7c6ace5.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5951331603.html",
        "sold": 0
    },
    {
        "product_name": "Case-Mate Essential Beach Bow Zip Pouch กระเป๋ากันน้ำอเนกประสงค์ ดีไซน์โบว์สุดหรู (สี Ivory Shine)",
        "product_image": "https://img.lazcdn.com/g/p/308f99786aa8fed02244d02e6572d89b.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i16061436494.html",
        "sold": 0
    },
    {
        "product_name": "ซองปืน  กระเป๋าใส่ปืน    ( ลูกโม่ .22 )    2.5นิ้ว    1ใบ      พร้อม กระเป๋า ใส่ลูก .22    1ใบ",
        "product_image": "https://img.lazcdn.com/g/p/6bc240f47c27889daf66da3b366733df.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5274609222.html",
        "sold": 0
    },
    {
        "product_name": "Golf Club Golf Bag For Men And Women, Ultra-light Backpack Golf Bag, Club Bag, Pony Clown Waterproof Stand Bag, Fashionable And Lightweight",
        "product_image": "https://img.lazcdn.com/g/p/eb0501e99ffd1c83b35868029f227fab.jpg_200x200q90.jpg",
        "price": 8010,
        "remark": "https://www.lazada.co.th/products/pdp-i16143661638.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า Alpaka - Flight Pouch Axoflux",
        "product_image": "https://img.lazcdn.com/g/p/e6c4551f6cb77392b131a96155156bb9.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5357734114.html",
        "sold": 31
    },
    {
        "product_name": "Power Bag กระเป๋ายิม กระเป๋าถ่วงน้ำหนัก กระเป๋าออกกำลังกาย กระสอบทรายออกกําลังกาย ฝึกความแข็งแรง -Homefittools",
        "product_image": "https://img.lazcdn.com/g/p/49db3e74dc265c4fec1850f4e5dc1d64.png_200x200q90.png",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5397744564.html",
        "sold": 15
    },
    {
        "product_name": "Case-Mate Essential Beach Zip Pouch - Soap Bubble กระเป๋ากันน้ำ พกพาสะดวก ดีไซน์โฮโลแกรม (ของแท้ 100%)",
        "product_image": "https://img.lazcdn.com/g/p/3f3086ecae241ad321a26170945fbd6c.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i16061245286.html",
        "sold": 0
    },
    {
        "product_name": "Case-Mate Essential Beach Bow Zip Pouch (Ballet Pink) กระเป๋ากันน้ำอเนกประสงค์ ดีไซน์โบว์สุดหรู",
        "product_image": "https://img.lazcdn.com/g/p/c759b0bda419e75ef458c4ffb9031a8b.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i16061452486.html",
        "sold": 0
    },
    {
        "product_name": "ซองปืน  กระเป๋าใส่ปืน    ( ลูกโม่ .22 )    3นิ้ว    1ใบ      พร้อม กระเป๋า ใส่ลูก .22    1ใบ",
        "product_image": "https://img.lazcdn.com/g/p/dc41bdff14b88d2eb82d64a54ae2642a.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5274538791.html",
        "sold": 0
    },
    {
        "product_name": "KAVU Mini Rope Bag กระเป๋าสะพายหลัง กระเป๋าสะพายข้าง",
        "product_image": "https://img.lazcdn.com/g/p/720fa0958ae30f5cf0bc1a951e1ea3e4.jpg_200x200q90.jpg",
        "price": 3150,
        "remark": "https://www.lazada.co.th/products/pdp-i4608472579.html",
        "sold": 3
    },
    {
        "product_name": "[ New Arrival ] KAVU Mini Rope Sling Bag กระเป๋าสะพายหลัง กระเป๋าสะพายข้าง",
        "product_image": "https://img.lazcdn.com/g/p/f124ae5a0e7d13de84a7c58a03f58caa.jpg_200x200q90.jpg",
        "price": 3150,
        "remark": "https://www.lazada.co.th/products/pdp-i4608223978.html",
        "sold": 3
    },
    {
        "product_name": "Deevoka กระเป๋าแห้งและกันน้ำเป้สะพายหลังม้วนได้20ลิตรทนต่อการสึกหรออเนกประสงค์กันน้ำกระเป๋าเก็บของสำหรับล่องแพชายหาดสกีพายเรือคายัค",
        "product_image": "https://img.lazcdn.com/g/p/a87e25f88726ebe6117bcc3a17fc6c8d.jpg_200x200q90.jpg",
        "price": 3145,
        "remark": "https://www.lazada.co.th/products/pdp-i16108845437.html",
        "sold": 0
    },
    {
        "product_name": "Genuine imported New style Malbon The New Korean Golf Rangefinder Bag Waist Bag Accessories Bag Double Marks Gift Box Packaging Exquisite Workmanship",
        "product_image": "https://img.lazcdn.com/g/p/9061d0c2a1f676f80380fba67ecea280.jpg_200x200q90.jpg",
        "price": 3130.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6061522602.html",
        "sold": 0
    },
    {
        "product_name": "LEE กระเป๋าพาดลำตัวสำหรับผู้หญิงแฟชั่นสีดำลีเคสแบบพับปิดได้ชายกันน้ำกระเป๋าหิ้วกลางแจ้งความจุขนาดใหญ่อ็อกซ์ฟอร์ดสำหรับนักศึกษานักศึกษานักศึกษาพร้อมกระเป๋ากันขโมย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S85f9c52e440540c39292622122c93555T.jpg_200x200q90.jpg",
        "price": 3128.58,
        "remark": "https://www.lazada.co.th/products/pdp-i5661501615.html",
        "sold": 96
    },
    {
        "product_name": "[ Store] Exclusive2X Weight Sandbag Boxing Fitness Workout Multi-Functional Training Sand Bag High Intensity Exercises Power Bag 10Kg",
        "product_image": "https://img.lazcdn.com/g/p/4b2e0cc35fed3b68bb8e4e0a309a18d4.jpg_200x200q90.jpg",
        "price": 3126,
        "remark": "https://www.lazada.co.th/products/pdp-i16142266789.html",
        "sold": 0
    },
    {
        "product_name": "ZOKE | กระเป๋าว่ายน้ำกันน้ำแยกแห้งเปียกสำหรับฝึกซ้อม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S384fbfcf9dc64aff9e036ab8d63339b5Q.jpg_200x200q90.jpg",
        "price": 3125.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16050631504.html",
        "sold": 0
    },
    {
        "product_name": "Kesoto กระเป๋าเป้สะพายหลัง Tas Carrier แบบถ่วงน้ำหนักสำหรับยิมกระเป๋าสะพายหลังกระเป๋าหิ้วอ๊อกฟอร์ดสำหรับฟิตเนสยิมที่บ้านยกกระชับน่อง",
        "product_image": "https://img.lazcdn.com/g/p/f13887bdfb4eae4d6c0947d47e75c442.jpg_200x200q90.jpg",
        "price": 3122,
        "remark": "https://www.lazada.co.th/products/pdp-i16052876587.html",
        "sold": 0
    },
    {
        "product_name": "Hedgren กระเป๋าใส่โทรศัพท์ , กระเป๋าใส่ร่ม ขนาดเล็ก , กระเป๋าใส่ขวดน้ำ , กระเป๋าสะพาย กระเป๋าสะพายข้าง กระเป๋าพาดไหล่ กระเป๋าพาดตัว เคลือบกันน้ำ รุ่น Sipho Phone Bag - 2 Year Warranty ( HSTG07 )",
        "product_image": "https://img.lazcdn.com/g/p/777d882c053945efe69f53a73edeab3e.jpg_200x200q90.jpg",
        "price": 3120,
        "remark": "https://www.lazada.co.th/products/pdp-i5373167699.html",
        "sold": 1
    },
    {
        "product_name": "Golf | เป้เดินทางแบบไม่แบ่งเพศ ขนาดใหญ่ ใส่แล็ปท็อปได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb861b1d7c289487baba1361896709f87l.jpg_200x200q90.jpg",
        "price": 3119.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5904842071.html",
        "sold": 95
    },
    {
        "product_name": "กอล์ฟ | เป้แม่พิมพ์ความจุสูง กระเป๋าสำหรับนักเรียนและแล็ปท็อป",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S684398eb934f4529b4db603eb78c6115b.jpg_200x200q90.jpg",
        "price": 3119.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5909667368.html",
        "sold": 444
    },
    {
        "product_name": "ZOKE | กระเป๋าว่ายน้ำกันน้ำขนาดใหญ่สำหรับฝึกอบรมมืออาชีพ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbca296e3b29448fe858a7149fa8f8979i.jpg_200x200q90.jpg",
        "price": 3118.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16051150552.html",
        "sold": 0
    },
    {
        "product_name": "WDAir กระเป๋าเป้สะพายหลังม้วนกันน้ำได้20ลิตรกระเป๋าเก็บของกันน้ำแบบพกพาทนทานต่อการฉีกขาดสำหรับเล่นสกีพายเรือตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/a2990b6ef8c199509e00a6bdfe0984e3.jpg_200x200q90.jpg",
        "price": 3115.5,
        "remark": "https://www.lazada.co.th/products/pdp-i6047948081.html",
        "sold": 0
    },
    {
        "product_name": "≮419≯กระเป๋าคาดเอวแบบลำลองสำหรับเล่นกอล์ฟ กระเป๋าใส่ของขนาดเล็กสำหรับผู้ชายและผู้หญิง กระเป๋าใส่ของสำหรับเล่นกอล์ฟแบบมีหลายช่อง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se0c2b6947a974f06b2a191ac8c405e2fI.jpg_200x200q90.jpg",
        "price": 3114.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16137107322.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าสะพายข้างสไตล์เรโทรเกาหลีสำหรับผู้หญิง กระเป๋าสะพายไหล่เดียว แฟชั่นใหม่ หนังนิ่ม หนังวัวชั้นบน หัวเข็มขัดล็อค",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa28d84f839bf4530b8618b54705bfda4t.jpg_200x200q90.jpg",
        "price": 3114.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16073232379.html",
        "sold": 0
    },
    {
        "product_name": "Ailong กระเป๋าเป้สะพายหลังน้ำหนักสำหรับยิมแผ่นน้ำหนัก Tas Carrier สายรัดปรับได้สำหรับ Pushups ยกน้ำหนักออกกำลังกายฝึกอบรมโรงยิมที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/p/83d7d966098ea25c501b60f216b322c3.jpg_200x200q90.jpg",
        "price": 3114,
        "remark": "https://www.lazada.co.th/products/pdp-i5945594060.html",
        "sold": 0
    },
    {
        "product_name": "Fido Dido | เป้แฟชั่นผู้หญิงสไตล์กีฬา แบบกันน้ำจากผ้าแคนวาส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S80c36a98deb644729be4d7f6e7a6f424V.jpg_200x200q90.jpg",
        "price": 3112.58,
        "remark": "https://www.lazada.co.th/products/pdp-i6004049459.html",
        "sold": 0
    },
    {
        "product_name": "Lee(ลี) | กระเป๋าถือสำหรับผู้หญิง ขนาดใหญ่ ความจุมาก น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S59328336cc3f4e3aba5263bb0c19fef33.jpg_200x200q90.jpg",
        "price": 3108.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16113707778.html",
        "sold": 74
    },
    {
        "product_name": "กระเป๋าถือสุดเรียบง่ายสำหรับนักเรียน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S260db743fc5c4db8bc16498e9a47fd99x.jpg_200x200q90.jpg",
        "price": 3108.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6066386849.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้กันน้ำ ลายช้าง ความจุ 12 ลิตร FEELFREE MINI DRY TANK CHANG",
        "product_image": "https://img.lazcdn.com/g/p/ebff5b35b2d953f833e17a55825f2d54.jpg_200x200q90.jpg",
        "price": 3100,
        "remark": "https://www.lazada.co.th/products/pdp-i4894703463.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้กันน้ำ ขนาด 12 ลิตร FEELFREE TROPICAL MINI DRY TANK",
        "product_image": "https://img.lazcdn.com/g/p/34d6d4595b7cab2df66454d5d38299f9.jpg_200x200q90.jpg",
        "price": 3100,
        "remark": "https://www.lazada.co.th/products/pdp-i2303167858.html",
        "sold": 4
    },
    {
        "product_name": "กระเป๋าปืนยาว   หนังสีดำ   กระเป๋า  พร้อม สายสะพาย    มียาว   31นิ้ว   36นิ้ว    37นิ้ว   43นิ้ว   48นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se9b89d0e0fdf4ed4ab11aaa250edda3fA.jpg_200x200q90.jpg",
        "price": 3100,
        "remark": "https://www.lazada.co.th/products/pdp-i394858428.html",
        "sold": 0
    },
    {
        "product_name": "Lohobby กระเป๋าเป้สะพายหลังแห้ง40L แบบแยกเปียกและแห้งห่วงยางว่ายน้ำสายรัดแบบขยายได้ปรับได้สำหรับพายเรือคายัคว่ายน้ำเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/bd94324860a74e039774adb9b2c99404.jpg_200x200q90.jpg",
        "price": 3094,
        "remark": "https://www.lazada.co.th/products/pdp-i5975600532.html",
        "sold": 0
    },
    {
        "product_name": "TOOYFUL กระเป๋ากันน้ำ40L กันน้ำห่วงยางว่ายน้ำกระเป๋าเป้สะพายหลังแห้งอุปกรณ์เป่าลมน้ำหนักเบาสำหรับท่องตกปลาผู้ชายสำหรับการเดินทางผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/5f308f73fef0cf8988b9ab5020ac1197.jpg_200x200q90.jpg",
        "price": 3094,
        "remark": "https://www.lazada.co.th/products/pdp-i6020158104.html",
        "sold": 0
    },
    {
        "product_name": "Moon ONAIR กระเป๋าแห้ง40L กระเป๋าเป้แห้งและกันน้ำน้ำหนักเบากระเป๋าเดินทางเดินป่าพายเรือคายัคสำหรับนักโต้คลื่นเรือคายัคนักดำน้ำตื้นผู้ชายผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/968932c0eed2968521062c190529f9ea.jpg_200x200q90.jpg",
        "price": 3094,
        "remark": "https://www.lazada.co.th/products/pdp-i6058838015.html",
        "sold": 0
    },
    {
        "product_name": "Koolsoo กระเป๋ากระเป๋าเดินป่าตั้งแคมป์กันน้ำแห้ง40L กระเป๋าเป้สะพายหลังแห้งอุปกรณ์ห่วงยางว่ายน้ำล่องแก่งสำหรับแล่นเรือว่ายน้ำตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/c94108152acfc642d7033d368b95ce86.jpg_200x200q90.jpg",
        "price": 3094,
        "remark": "https://www.lazada.co.th/products/pdp-i5989265771.html",
        "sold": 0
    },
    {
        "product_name": "Gociy กระเป๋ากันน้ำ40L น้ำหนักเบา,กระเป๋าเป้สะพายหลังแห้งพายเรือกระเป๋าเดินทางเดินป่าสายรัดแบบขยายได้ปรับได้สำหรับผู้ดำน้ำตื้นเดินทางตกปลาโต้คลื่น",
        "product_image": "https://img.lazcdn.com/g/p/2ea89250b5d326f0eae62525ef79418e.jpg_200x200q90.jpg",
        "price": 3094,
        "remark": "https://www.lazada.co.th/products/pdp-i16093846777.html",
        "sold": 0
    },
    {
        "product_name": "CCPlanet กระเป๋ากันน้ำ40L กระเป๋าเป้ดำน้ำทำให้แห้งห่วงยางว่ายน้ำกระเป๋าเป้สะพายหลังพายเรือคายัคล่องแพน้ำหนักเบาสำหรับการปีนเขาการเดินทางแล่นเรือใบว่ายน้ำตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/b38048bcfbf69c77e4fefd11df1da290.jpg_200x200q90.jpg",
        "price": 3094,
        "remark": "https://www.lazada.co.th/products/pdp-i16131406702.html",
        "sold": 0
    },
    {
        "product_name": "Phenovo กระเป๋าแห้ง40L ห่วงยางว่ายน้ำพายเรือแห้งกระเป๋าเป้สะพายหลังสายรัดแบบขยายได้ปรับได้ IPX6กันน้ำน้ำหนักเบาสำหรับนักพายเรือผู้ชายสำหรับการเดินทางผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/8a56d96abbd1dfd80888325df5dff553.jpg_200x200q90.jpg",
        "price": 3094,
        "remark": "https://www.lazada.co.th/products/pdp-i6035208995.html",
        "sold": 0
    },
    {
        "product_name": "SunnT กระเป๋าเป้40L แห้งน้ำหนักเบาสำหรับพายเรือกระเป๋าเป้สะพายหลังแบบเป่าลมได้ทั้งเปียกและแห้งสำหรับการเดินทางท่องเรือคายัคกีฬาทางน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/3c59caca35901c5adb697159b6185603.jpg_200x200q90.jpg",
        "price": 3094,
        "remark": "https://www.lazada.co.th/products/pdp-i5966307367.html",
        "sold": 0
    },
    {
        "product_name": "Moon กระเป๋ากันน้ำ40L น่ารักกระเป๋าเป้ดำน้ำทำให้แห้งน้ำหนักเบากระเป๋าเดินทางเดินป่าพายเรือคายัคสำหรับนักดำน้ำตื้นกีฬาทางน้ำผู้ชายผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/41781d7ce6e2f845f5eadfc535cbc23a.jpg_200x200q90.jpg",
        "price": 3094,
        "remark": "https://www.lazada.co.th/products/pdp-i6066938936.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเป้ดำน้ำทำให้แห้งแยกเปียกและแห้ง40L Hicaee พายเรือคายัคห่วงยางว่ายน้ำสายรัดแบบขยายได้ปรับได้สำหรับเล่นกีฬาทางน้ำแล่นเรือ",
        "product_image": "https://img.lazcdn.com/g/p/f0a9dd07099f2740f896d0611880015c.jpg_200x200q90.jpg",
        "price": 3094,
        "remark": "https://www.lazada.co.th/products/pdp-i16136985378.html",
        "sold": 0
    },
    {
        "product_name": "อารีน่า กระเป๋าว่ายน้ําแห้งแยกเปียกการจัดเก็บกระเป๋าเป้สะพายหลังกระเป๋ากันน้ําอุปกรณ์ออกกําลังกายว่ายน้ํากระเป๋า",
        "product_image": "https://img.lazcdn.com/g/p/bc64b23394ccf1da2d2da7287978604d.jpg_200x200q90.jpg",
        "price": 3093.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16096325711.html",
        "sold": 0
    },
    {
        "product_name": "Loobby กระเป๋าเป้สะพายหลังแบบถ่วงน้ำหนักสำหรับยิมแผ่นน้ำหนักกระเป๋าเก็บของแผ่นบาร์เบลสำหรับการฝึกความแข็งแรงออกกำลังกายที่บ้านยิมน่อง",
        "product_image": "https://img.lazcdn.com/g/p/f6eae90f064fea5d8267980d4dba16a4.jpg_200x200q90.jpg",
        "price": 3088,
        "remark": "https://www.lazada.co.th/products/pdp-i5990247995.html",
        "sold": 0
    },
    {
        "product_name": "Gazechimp กระเป๋าเป้สะพายหลังแบบถ่วงน้ำหนักสำหรับยิมแผ่นรองหลังหรือด้านหน้ากระเป๋าหิ้วสำหรับออกกำลังกายฟิตเนสน่อง Squats",
        "product_image": "https://img.lazcdn.com/g/p/b00cb2160d7cd611bfa7e0dc02a380c2.jpg_200x200q90.jpg",
        "price": 3088,
        "remark": "https://www.lazada.co.th/products/pdp-i5955145343.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าใส่ถุงกอล์ฟขึ้นเครื่องบิน Air Package มีล้อลาก (HKB008) PGM Golf Air Bag Travel",
        "product_image": "https://img.lazcdn.com/g/p/2f4f9cffdc2f836e2dd2e720842f04e8.jpg_200x200q90.jpg",
        "price": 3068.06,
        "remark": "https://www.lazada.co.th/products/pdp-i1416300515.html",
        "sold": 25
    },
    {
        "product_name": "กระเป๋าถือแฟชั่น รุ่น B1824",
        "product_image": "https://img.lazcdn.com/g/p/622b3744567702a6fd36a3822ab8c78d.jpg_200x200q90.jpg",
        "price": 3066,
        "remark": "https://www.lazada.co.th/products/pdp-i4974246617.html",
        "sold": 0
    },
    {
        "product_name": "เป้เดินทางกันน้ำ 35 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb651a8b07fcc4e61bfcd47101c002344Q.jpg_200x200q90.jpg",
        "price": 3052.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16118923803.html",
        "sold": 0
    },
    {
        "product_name": "Arena Arena Wet And Dry Separation Swimming Bag Waterproof Large Capacity Travel Storage Bag Universal Crossbody Shoulder Bag",
        "product_image": "https://img.lazcdn.com/g/p/0d3859617368c1ff9849f6e195f64c9e.jpg_200x200q90.jpg",
        "price": 3048,
        "remark": "https://www.lazada.co.th/products/pdp-i16131853468.html",
        "sold": 0
    },
    {
        "product_name": "CHARLIE & KELLI | กระเป๋าถือที่มีสไตล์และใช้ได้หลายแบบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6e6785c3704840818357fa7e98d39c000.jpg_200x200q90.jpg",
        "price": 3044.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5994808333.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋ากระเป๋าเก็บของประตูสำหรับ UTV ความจุมากและผ้ากันน้ำเพื่อเพิ่มความทนทาน",
        "product_image": "https://img.lazcdn.com/g/p/fad8f8b877e48309b1b10b30797eab54.jpg_200x200q90.jpg",
        "price": 3028.92,
        "remark": "https://www.lazada.co.th/products/pdp-i6019003174.html",
        "sold": 0
    },
    {
        "product_name": "Ellwewe กระเป๋าบวมน้ำเครื่องมือฝึกยกน้ำหนักแบบพกพา Tas Daya น้ำแกนเครื่องชั่งน้ำหนักสำหรับออกกำลังกายที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/p/74bccd7e8ab12b9e9686b07f48567caa.jpg_200x200q90.jpg",
        "price": 3028,
        "remark": "https://www.lazada.co.th/products/pdp-i16121964353.html",
        "sold": 0
    },
    {
        "product_name": "Gazechimp กระเป๋าบวมน้ำกระเป๋าเทรนนิ่งหลักสำหรับการเพาะกายถุงทรายออกกำลังกายการออกกำลังกายสำหรับกีฬาภายในภายนอกอาคาร",
        "product_image": "https://img.lazcdn.com/g/p/518f5cbe2f5d8461bdb4fa82a556122d.jpg_200x200q90.jpg",
        "price": 3028,
        "remark": "https://www.lazada.co.th/products/pdp-i6014882552.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าบวมน้ำ Moon Lighte กระเป๋าเทรนนิ่งหลักสำหรับสร้างสมดุลถุงน้ำออกกำลังกายเพาะกายถุงทรายสำหรับกีฬาภายในภายนอกอาคาร",
        "product_image": "https://img.lazcdn.com/g/p/bbc3ff69f5d0da999198bcc542746799.jpg_200x200q90.jpg",
        "price": 3028,
        "remark": "https://www.lazada.co.th/products/pdp-i5983467599.html",
        "sold": 0
    },
    {
        "product_name": "Balneaire | กระเป๋าแยกส่วนกันน้ำสำหรับออกกำลังกายและว่ายน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8ab27654ff5d4f5f9e83ac9376e20ca8x.jpg_200x200q90.jpg",
        "price": 3016.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5893360223.html",
        "sold": 40
    },
    {
        "product_name": "Lee| กระเป๋าสะพายสไตล์วิทยาลัย สำหรับแล็ปท็อป ความจุมาก",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S5cb66315bacc4eb68c890e95567be6f8w.jpeg_200x200q90.jpg",
        "price": 3013.54,
        "remark": "https://www.lazada.co.th/products/pdp-i6066467021.html",
        "sold": 209
    },
    {
        "product_name": "Sea to Summit | ถุงเก็บของกันน้ำ ปิดด้วยการม้วน มีน้ำหนักเบา ระบายอากาศได้ และป้องกันความชื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sabde9bc153a04867ba194a5f7ef5f36fL.png_200x200q90.png",
        "price": 3007.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6003295159.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาแฟชน กระเปาถอ กระเปาใชงานประจำวน กระเปาผหญง กระเปาธรกจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9c25e674d5744022ba8c040b60fd8373S.png_200x200q90.png",
        "price": 3007.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16121432623.html",
        "sold": 0
    },
    {
        "product_name": "กระเปาแฟชน กระเปาสะพายไหล กระเปาชอปปง กระเปามน สำหรบเดท",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb6aa13d488a747f49f579850fd6019af2.png_200x200q90.png",
        "price": 3007.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16099519299.html",
        "sold": 0
    },
    {
        "product_name": "PLAYEAGLE Airplane Golf Travel Bag กับล้อไนลอนพับได้สำหรับกระเป๋าไม้กลอ์ฟพกพา กระเป๋ากอล์ฟการบิน Golf Bag Travel Golf Tour Bag Cover  (send lock for gift)",
        "product_image": "https://img.lazcdn.com/g/p/fb3b045df7542b6011be515c10db08b7.jpg_200x200q90.jpg",
        "price": 3001.3,
        "remark": "https://www.lazada.co.th/products/pdp-i4306995037.html",
        "sold": 19
    },
    {
        "product_name": "กระเป๋าสะพายกันน้ำ VINCITA B038WP-S",
        "product_image": "https://img.lazcdn.com/g/p/2f0bddb8f7c8e78613fc114159a3c32a.jpg_200x200q90.jpg",
        "price": 3000,
        "remark": "https://www.lazada.co.th/products/pdp-i5624502787.html",
        "sold": 0
    },
    {
        "product_name": "Naturehike ถุงกันน้ำ  Dry-Wet Separating NEW! (รับประกันของแท้ศูนย์ไทย)",
        "product_image": "https://img.lazcdn.com/g/p/494c7d9f132ed5ee4cafd3a5ad2a60d9.jpg_200x200q90.jpg",
        "price": 3000,
        "remark": "https://www.lazada.co.th/products/pdp-i962502431.html",
        "sold": 0
    },
    {
        "product_name": "Stream Trail-Stormy Shoulder Pouch 3.5L กระเป๋าสะพายข้างกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/26eacf7b3b4ac7890f318451e9270cd2.jpg_200x200q90.jpg",
        "price": 3000,
        "remark": "https://www.lazada.co.th/products/pdp-i5751588571.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋า Taylormade Box",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdeff5cdd1f2b4f0ebf92c1e8a9679c07u.jpg_200x200q90.jpg",
        "price": 3000,
        "remark": "https://www.lazada.co.th/products/pdp-i5086479854.html",
        "sold": 2
    },
    {
        "product_name": "กระเป๋าเดินทางแบบไม่มีล้อ SC , Pearly Gates Golf Travel cover without wheels(original)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S48a8c99eef644dee8cbc0bb4328e21e3Y.jpg_200x200q90.jpg",
        "price": 3000,
        "remark": "https://www.lazada.co.th/products/pdp-i4006729824.html",
        "sold": 6
    },
    {
        "product_name": "กระเป๋าถือสตรีใหม่กระเป๋าสลิงแฟชั่นกระเป๋า CP130 CP132",
        "product_image": "https://img.lazcdn.com/g/p/4829107a0b70e27202ebaaf3c3c3deee.jpg_200x200q90.jpg",
        "price": 3000,
        "remark": "https://www.lazada.co.th/products/pdp-i16107160241.html",
        "sold": 0
    },
    {
        "product_name": "Divevolk EVA Travel Box",
        "product_image": "https://img.lazcdn.com/g/p/dbaa056eea1676396fd13e41412fa56f.jpg_200x200q90.jpg",
        "price": 3000,
        "remark": "https://www.lazada.co.th/products/pdp-i5709421803.html",
        "sold": 0
    },
    {
        "product_name": "TOUTOU | กระเป๋าสะพายข้างธีมสุนัขสีน้ำตาล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2c90c09735c74997b98f91d1393017434.png_200x200q90.png",
        "price": 2992.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16051176716.html",
        "sold": 98
    },
    {
        "product_name": "Golf | เป้สะพายหลังสำหรับผู้หญิง ความจุมาก ทำจากผ้าออกซ์ฟอร์ดและผ้าแคนวาส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8e0f7bddd55f438d861e0f5573f3ad4bE.jpg_200x200q90.jpg",
        "price": 2992,
        "remark": "https://www.lazada.co.th/products/pdp-i5909575044.html",
        "sold": 414
    },
    {
        "product_name": "Ping กระเป๋าใส่เสื้อผ้ากอล์ฟ 24 ใหม่ชายหญิงแมทช์ลุคง่ายความจุขนาดใหญ่ golf กระเป๋ากีฬาแบบพกพากันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/6ce029c7474aad505c3b7ad13b1cd1b0.jpg_webp_200x200q90.jpg",
        "price": 2990,
        "remark": "https://www.lazada.co.th/products/pdp-i5627019961.html",
        "sold": 0
    },
    {
        "product_name": "≮419≯Bellroy Australia Venture Ready Sling2.5L Explorer Swimming Chest Bag Lightweight Commuter Bag",
        "product_image": "https://img.lazcdn.com/g/p/4b5f0724401c802d1524a208d50e18ce.jpg_200x200q90.jpg",
        "price": 2989.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16137382356.html",
        "sold": 0
    },
    {
        "product_name": "SEAPLAY Waterproof Water Resistant Dry Bag, Sack Storage Pack Pouch Swimming Outdoor Kayaking Canoeing, River Trekking Boating",
        "product_image": "https://img.lazcdn.com/g/p/e3d0ae5b6a77b35ee400b53b7347525a.jpg_webp_200x200q90.jpg",
        "price": 2988.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6005132208.html",
        "sold": 0
    },
    {
        "product_name": "[NEW ARRIAL] FEELFREE TOTE L CHANG  กระเป๋าเอนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/p/7e3aa99efdbccf82e5308bb9db3751db.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i6035322873.html",
        "sold": 0
    },
    {
        "product_name": "GULL - WATER PROTECT POUCH waterproof bag กระเป๋าสะพาย กระเป๋ากันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/80f0e9b41fde57a563668e8cafbc7f36.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i3141236408.html",
        "sold": 4
    },
    {
        "product_name": "✨Code: 9280 เปิดตัวกระเป๋าหนังแคนวาสลายปั๊มดีเทลน่ารัก สีสันละมุนตา ใบนี้ต้องมีก่อนปีใหม่! 🎀 รีบกด 🎀",
        "product_image": "https://img.lazcdn.com/g/p/10f3560c88dac254167bdc8aead4574f.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i5937569750.html",
        "sold": 0
    },
    {
        "product_name": "GULL WATER PROTECT POUCH กระเป๋าซองกันน้ำ ขนาดพกพา สำหรับดำน้ำ ท่องเที่ยว กันน้ำ 100%",
        "product_image": "https://img.lazcdn.com/g/p/48fef24ecce57125fa44726195b99df7.png_200x200q90.png",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i5716526027.html",
        "sold": 0
    },
    {
        "product_name": "RUNOFF WATERPROOF PHONE POUCH - กระเป๋ากันน้ำ เคสกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/3dc6472df6d46b070f0736ad40210544.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i1910472382.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าปืน   หนังสีดำ  วอลเทอร์ walther ppk/s .380 ACP 9มม / STI ELEKTRA .45 ACP / RETAY 84FS / Makarov / Sig Sauer P239      ( พร้อม กระเป๋าใส่ลูก .38  9มม   357   1อัน )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7e0b1b5f3c4b4c4cb897e05759ce590fJ.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i406464963.html",
        "sold": 1
    },
    {
        "product_name": "elago Waterproof Pouch กระเป๋ากันนำ้สำหรับมือถือและใส่การ์ดได้ ไปสวนน้ำหรือเล่นสงกรานต์ หมดกังวล",
        "product_image": "https://img.lazcdn.com/g/p/f040964637d4597c210c9aa657b3fdeb.png_200x200q90.png",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i5179571049.html",
        "sold": 2
    },
    {
        "product_name": "กระเป๋าปืน   หนังสีดำ   วอลเทอร์ walther ppk/s .380 ACP 9มม  STI ELEKTRA  .45  ACP  / RETAY 84FS /akar Mov / Sig Sauer P239    ( พร้อม กระเป๋าใส่ลูก .380   1อัน )",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1549e851ce4945738e727a3e9675a60fV.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i406448853.html",
        "sold": 0
    },
    {
        "product_name": "Gull Bag Water Protect Pouch กระเป๋ากันน้ำจากแบรนด์ GULL",
        "product_image": "https://img.lazcdn.com/g/p/6125f7a3539e14266a6ea3bdfb15967a.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i4208217711.html",
        "sold": 0
    },
    {
        "product_name": "Casio | นาฬิกาอิเล็กทรอนิกส์แบบยูนิเซ็กซ์ รุ่นลิมิเต็ดเอดิชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3b91e976cd744a268a4f3b5970ded74dr.jpg_200x200q90.jpg",
        "price": 53017.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5949031388.html",
        "sold": 1
    },
    {
        "product_name": "【COD】New TWS Wireless Bluetooth Earbud Earphone 5.0 Touch Earphone 9D Stereo Sports Music Waterproof LED Display with Mic Wireless Earphone Compatible for Android and Ios",
        "product_image": "https://img.lazcdn.com/g/p/8b74894a3c173175e97fae9c8bc103e9.jpg_200x200q90.jpg",
        "price": 52520,
        "remark": "https://www.lazada.co.th/products/pdp-i5892442550.html",
        "sold": 0
    },
    {
        "product_name": "หูฟังบลูทูธ [ไฟ LED ที่เหลือตัวแสดงการชาร์จไฟและ Type-C ชาร์จเร็ว] แบบแฮนด์ฟรีดีไซน์น้ำหนักเบา Hi-Fi IPX7การเชื่อมต่ออัตโนมัติกันน้ำขนาดเล็กกะทัดรัดการประชุมมีความสะดวกสบายในการสวมใส่/การทำงานระยะไกล/การเดินทาง/โรงเรียน/กีฬา/เกม...",
        "product_image": "https://img.lazcdn.com/g/p/7118d3a84961672effd216818eb36ff8.png_200x200q90.png",
        "price": 45202,
        "remark": "https://www.lazada.co.th/products/pdp-i16110779773.html",
        "sold": 0
    },
    {
        "product_name": "EverSolo Z6 DAC-AMP คุณภาพสูง",
        "product_image": "https://img.lazcdn.com/g/p/211f2079b29bace761da3a04fd56fb05.jpg_200x200q90.jpg",
        "price": 33800,
        "remark": "https://www.lazada.co.th/products/pdp-i4381827535.html",
        "sold": 0
    },
    {
        "product_name": "Lepmerk เครื่องให้คะแนนไฟฟ้า100-240โวลต์พกพาได้15หลักสกอร์บอร์ดอิเล็กทรอนิกส์อเนกประสงค์มีเสถียรภาพสำหรับสำหรับบาสเก็ตบอลยิม",
        "product_image": "https://img.lazcdn.com/g/p/dae92cb34cf067fee471d4b6a51f2f1c.jpg_200x200q90.jpg",
        "price": 29472,
        "remark": "https://www.lazada.co.th/products/pdp-i16089519620.html",
        "sold": 0
    },
    {
        "product_name": "ป้ายบอกคะแนนดิจิตอล 15 หลักหลายโหมดใช้งานง่ายโดยใช้ป้ายบอกคะแนนบาสเกตบอลอิเล็กทรอนิกส์ความสว่างสูงลำโพงในตัวสำหรับสนุ๊กเกอร์",
        "product_image": "https://img.lazcdn.com/g/p/393659e36f22562c79581dd113a598c9.jpg_200x200q90.jpg",
        "price": 25456,
        "remark": "https://www.lazada.co.th/products/pdp-i16099466833.html",
        "sold": 0
    },
    {
        "product_name": "Zonejoy ป้ายบอกคะแนนบาสเกตบอล Hamwesh จอแสดงผล LED 15 หลัก ป้ายบอกคะแนนดิจิตอลแบบพกพาอิเล็กทรอนิกส์พร้อมรีโมทคอนโทรลหลายโหมดสำหรับเกมกีฬากลางแจ้งในร่ม",
        "product_image": "https://img.lazcdn.com/g/p/f6f3888dd96dfa696fa533522ee2f957.jpg_200x200q90.jpg",
        "price": 22816,
        "remark": "https://www.lazada.co.th/products/pdp-i16147008613.html",
        "sold": 0
    },
    {
        "product_name": "ป้ายคะแนนบาสเกตบอลอิเล็กทรอนิกส์ Meterk หลายโหมดความสว่างสูงอเนกประสงค์สกอร์บอร์ดดิจิทัลสำหรับสนุ๊กเกอร์",
        "product_image": "https://img.lazcdn.com/g/p/5824b3e3913bad65dc0b6da645377be4.jpg_200x200q90.jpg",
        "price": 19804.24,
        "remark": "https://www.lazada.co.th/products/pdp-i6016481118.html",
        "sold": 0
    },
    {
        "product_name": "หูฟังไร้สายบลูทูธ 5.3 สเตอริโอ เล่นเพลงได้นาน 50 ชั่วโมง พร้อมหน้าจอ LED และไมโครโฟนตัดเสียงรบกวน 4 ตัว สำหรับศัพท์ แท็บเล็ต แล็ปท็อป กีฬา สีขาว",
        "product_image": "https://img.lazcdn.com/g/p/ee2c2ea28febdef8832d958eba3c17b8.jpg_webp_200x200q90.jpg",
        "price": 17625,
        "remark": "https://www.lazada.co.th/products/pdp-i16081132753.html",
        "sold": 0
    },
    {
        "product_name": "IB DESIGN Unique Metal Watches Retro Digital BENLY Watches For Men Retro-futuristic Punk Fashion Led Electronic Watches X7000",
        "product_image": "https://img.lazcdn.com/g/p/2e1e899088e352f08568b6f7bef7f942.jpg_200x200q90.jpg",
        "price": 15738,
        "remark": "https://www.lazada.co.th/products/pdp-i5651251507.html",
        "sold": 0
    },
    {
        "product_name": "HP-H300BT รัศมีรัศมีหูฟังไร้สายอย่างสมบูรณ์: หูฟังบลูทูธแบบ Hear-Scape,ทำความสะอาดหู,กะทัดรัด,แยกซ้าย/ขวา,AAC,น้ำหนักเบา,TWS HP-H300BTBG (สีน้ำเงิน-เทา)",
        "product_image": "https://img.lazcdn.com/g/p/bfd97702b002d45da8ece1c53122019a.png_200x200q90.png",
        "price": 13798,
        "remark": "https://www.lazada.co.th/products/pdp-i16110876487.html",
        "sold": 0
    },
    {
        "product_name": "Zonejoy 11 หลักกระดานบอกคะแนนอิเล็กทรอนิกส์ Score Keeper LED นาฬิกาดิจิตอลพร้อมรีโมทคอนโทรลสำหรับเกมบาสเกตบอลการฝึกอบรม",
        "product_image": "https://img.lazcdn.com/g/p/c7465e853269a77f0eb1803b5a156d7f.jpg_200x200q90.jpg",
        "price": 13520,
        "remark": "https://www.lazada.co.th/products/pdp-i16147084548.html",
        "sold": 0
    },
    {
        "product_name": "15หลักสกอร์บอร์ดอิเล็กทรอนิกส์15หลักสกอร์หลักใช้งานง่าย100-240V สำหรับบาสเก็ตบอลสำหรับยิม",
        "product_image": "https://img.lazcdn.com/g/p/510af7913a4dbe12446d538d05bfedc6.jpg_200x200q90.jpg",
        "price": 13134,
        "remark": "https://www.lazada.co.th/products/pdp-i6068175368.html",
        "sold": 0
    },
    {
        "product_name": "HP-H300BT รัศมีรัศมีหูฟังไร้สายอย่างสมบูรณ์: หูฟังชนิดเกี่ยวหูบลูทูธ,ทำความสะอาดหู,กะทัดรัด,แยกซ้าย/ขวา,AAC,น้ำหนักเบา,HP-H300BTK TWS (สีดำ)",
        "product_image": "https://img.lazcdn.com/g/p/f1ee2ed061ad0b085aa68356e24f6210.png_200x200q90.png",
        "price": 13124,
        "remark": "https://www.lazada.co.th/products/pdp-i16110583951.html",
        "sold": 0
    },
    {
        "product_name": "ซมซงอเลกทรอนกส 245HLO62 FIT Plus USB 3.1 แฟลชไดรฟ (MUF-AB) 256",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S32ce4461f4104397be87ae40da79ce97K.png_200x200q90.png",
        "price": 12486.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16097689863.html",
        "sold": 0
    },
    {
        "product_name": "SRAM | คันโยกเปลี่ยนเกียร์ด้านซ้ายไร้สาย AXS",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se232d70a785748328f0054c76477299d3.png_200x200q90.png",
        "price": 11998.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6001922348.html",
        "sold": 0
    },
    {
        "product_name": "กล้องถ่ายรูปทันทีสำหรับเด็กเพื่อการศึกษา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sed9813f7e4224333815b22b2f20b54ddB.jpg_200x200q90.jpg",
        "price": 11694.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16084602618.html",
        "sold": 0
    },
    {
        "product_name": "KELAJI | แตรเรือเสียงดังพร้อมไซเรนหมอก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S51f47d0448104d6489f8fb0ace89304eR.jpg_200x200q90.jpg",
        "price": 11205.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16101360542.html",
        "sold": 0
    },
    {
        "product_name": "Meterk สกอร์บอร์ดอิเล็กทรอนิกส์บาสเกตบอลหลายโหมดกระดานคะแนนบาสเก็ตบอลดิจิทัลสำหรับฝึกเล่นเกมใช้งานได้จริงลำโพงมีในตัวแบบพกพา",
        "product_image": "https://img.lazcdn.com/g/p/adc24a6992d947e29a51fc1cdce8ba44.jpg_200x200q90.jpg",
        "price": 10540.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6016496282.html",
        "sold": 0
    },
    {
        "product_name": "สกอร์บอร์ดรีโมทควบคุมอิเล็กทรอนิกส์สกอร์บอร์ดสำหรับการแข่งขัน",
        "product_image": "https://img.lazcdn.com/g/p/4ff180771e26bbf9b647e8c022a63f50.jpg_200x200q90.jpg",
        "price": 10496,
        "remark": "https://www.lazada.co.th/products/pdp-i5942016168.html",
        "sold": 0
    },
    {
        "product_name": "ป้ายคะแนนนำสกอร์บอร์ดอิเล็กทรอนิกส์สำหรับการแข่งขัน",
        "product_image": "https://img.lazcdn.com/g/p/4db108dd0254dda3d36350655062df6a.jpg_200x200q90.jpg",
        "price": 10496,
        "remark": "https://www.lazada.co.th/products/pdp-i5893670040.html",
        "sold": 0
    },
    {
        "product_name": "ป้ายคะแนนสกอร์บอร์ดอิเล็กทรอนิกส์รีโมทคอนโทรล8 Brightnesses นับถอยหลังการแข่งขันแสดงเวลาสำหรับบาสเก็ตบอลอเนกประสงค์ปิงปองแบดมินตันกิจกรรม",
        "product_image": "https://img.lazcdn.com/g/p/c8d88774c17cc5a4e87759bda8ec1ff3.jpg_200x200q90.jpg",
        "price": 9790,
        "remark": "https://www.lazada.co.th/products/pdp-i16098106675.html",
        "sold": 0
    },
    {
        "product_name": "ผู้รักษาคะแนนสกอร์บอร์ดอิเล็กทรอนิกส์ SunniMix จอแสดงผลแอลอีดีสำหรับบาสเก็ตบอลควบคุมระยะไกล",
        "product_image": "https://img.lazcdn.com/g/p/4e6e972046d73dd2f0547bb35b15a72e.jpg_200x200q90.jpg",
        "price": 9292,
        "remark": "https://www.lazada.co.th/products/pdp-i5996956608.html",
        "sold": 0
    },
    {
        "product_name": "Giiker | ของเล่นการศึกษาอิเล็กทรอนิกส์ฝึกสมองซูโดกุ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saefcbd12dd4048e89a038bc35cc00cceQ.png_200x200q90.png",
        "price": 8891.94,
        "remark": "https://www.lazada.co.th/products/pdp-i16049300919.html",
        "sold": 0
    },
    {
        "product_name": "Electronic Basketball Scoreboard, Portable Digital Scoreboard With Remote for Multisports Indoor Outdoor",
        "product_image": "https://img.lazcdn.com/g/p/47fb360eb397d6af54ec4d68ecfadb8e.jpg_200x200q90.jpg",
        "price": 8639.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16132336723.html",
        "sold": 0
    },
    {
        "product_name": "รอกตกปลาแบบหมุนเร็วรอกหมุนควบคุมความเร็วแบบอิเล็กทรอนิกส์",
        "product_image": "https://img.lazcdn.com/g/p/99cf9642f5aa0e069a5659e72ba1b71b.jpg_200x200q90.jpg",
        "price": 8802,
        "remark": "https://www.lazada.co.th/products/pdp-i16122962066.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสร้างเสียงดนตรีแบบอัจฉริยะเป้าต่อยมวยสำหรับเด็กผู้ใหญ่เป้าซ้อมเตะมวยแบบ BT Link สำหรับออกกำลังกายที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/p/96bdd45a2b477ce8fb425b13c48e89d3.jpg_200x200q90.jpg",
        "price": 8682,
        "remark": "https://www.lazada.co.th/products/pdp-i16143309095.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องฝึกมวยอัจฉริยะโหมดปรับได้อุปกรณ์เจาะอิเล็กทรอนิกส์อัจฉริยะแบบมืออาชีพพกพาได้สำหรับบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/80e388bb46b926d92f1fee5a05f7f109.jpg_200x200q90.jpg",
        "price": 8666,
        "remark": "https://www.lazada.co.th/products/pdp-i6023174739.html",
        "sold": 0
    },
    {
        "product_name": "Best Selling- <br>Electronic Basketball Scoreboard, Portable Digital Scoreboard With Remote for Multisports Indoor Outdoor",
        "product_image": "https://img.lazcdn.com/g/p/2a2c975ac0b90026fd4d0f6c31291544.jpg_200x200q90.jpg",
        "price": 8458,
        "remark": "https://www.lazada.co.th/products/pdp-i16132614857.html",
        "sold": 0
    },
    {
        "product_name": "emie kids | กล้องสำหรับเด็กผู้หญิง ถ่ายรูปสีสันสดใส พร้อมหน้าจอ HD ที่พลิกได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0c583f3991674e438e144d7cea147b0c2.png_200x200q90.png",
        "price": 8436,
        "remark": "https://www.lazada.co.th/products/pdp-i16127353667.html",
        "sold": 0
    },
    {
        "product_name": "Lenovo พร้อมที่จับดนตรีสำหรับผู้ใหญ่แผ่นรองเต้นโยคะสองชั้นพร้อมฟังก์ชันมัลติฟังก์ชันแผ่นรองเต้นอิเล็กทรอนิกส์",
        "product_image": "https://img.lazcdn.com/g/p/4ea1d9026ec0e20690e6068840f0b647.jpg_200x200q90.jpg",
        "price": 8204,
        "remark": "https://www.lazada.co.th/products/pdp-i6016467504.html",
        "sold": 0
    },
    {
        "product_name": "SKMEI Digital Electronic Large Dial Watch Fashion Sport Watches For Men Waterproof Quartz Wristwatch Alarm Clock Horloges Mannen",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S09369835162c4937b9e8f684baf1b975K.jpg_200x200q90.jpg",
        "price": 8200,
        "remark": "https://www.lazada.co.th/products/pdp-i5953059883.html",
        "sold": 0
    },
    {
        "product_name": "Lenovo AI อัดวิดีโอแบบ HD กล้องถ่ายรูปเด็ก2.4GHz WiFi จอแอลซีดีหน้าจอสัมผัส AI การเรียนรู้กล้องวีดีโอดิจิทัล",
        "product_image": "https://img.lazcdn.com/g/p/268249f21ce8b4411590f2db5e956c1a.jpg_200x200q90.jpg",
        "price": 7988,
        "remark": "https://www.lazada.co.th/products/pdp-i16082525495.html",
        "sold": 0
    },
    {
        "product_name": "Homtom AI อัดวิดีโอแบบ HD กล้องถ่ายรูปเด็ก2.4GHz WiFi LCD หน้าจอสัมผัส AI การเรียนรู้กล้องวีดีโอดิจิทัล",
        "product_image": "https://img.lazcdn.com/g/p/8bf78ee0a0f2d73a8dec54fcd58061e7.jpg_200x200q90.jpg",
        "price": 7988,
        "remark": "https://www.lazada.co.th/products/pdp-i16082557507.html",
        "sold": 0
    },
    {
        "product_name": "vivo X300 Pro (16+512G) โทรศัพท์มือถือ กล้อง 200MP ZEISS APO Telephoto, OriginOS 6, ชาร์จไว 90W+ชาร์จไร้สาย 40W",
        "product_image": "https://img.lazcdn.com/g/p/6518dda87f6d239765ce7640b031f364.jpg_200x200q90.jpg",
        "price": 79998,
        "remark": "https://www.lazada.co.th/products/pdp-i5948477274.html",
        "sold": 164
    },
    {
        "product_name": "IBasso DC-Elite USB DAC ความละเอียดสูงและแอมป์แบบพกพา",
        "product_image": "https://img.lazcdn.com/g/p/ab95868fd4e567d861f478bc15fd7be3.jpg_200x200q90.jpg",
        "price": 42452,
        "remark": "https://www.lazada.co.th/products/pdp-i5856377825.html",
        "sold": 0
    },
    {
        "product_name": "[New]OPPO Reno15 F(12+256G) โทรศัพท์มือถือ กล้องหน้ามุมกว้างพิเศษ 50MP AI Portrait Glow ชาร์จไว80W แบต 7,000mAh รับประกัน 12 เดือน",
        "product_image": "https://img.lazcdn.com/g/p/1581d8236f8f75dce8fb7c2213eef7a3.jpg_200x200q90.jpg",
        "price": 29998,
        "remark": "https://www.lazada.co.th/products/pdp-i6007117158.html",
        "sold": 258
    },
    {
        "product_name": "[New] HONOR X9d (12+256GB) โทรศัพท์มือถือ ถึกทน หน้าจอ 6.79 นิ้ว | ชิปเซ็ต Snapdragon 6 Gen 4 | กล้อง 108MP | กันฝุ่น กันนํ้า IP69K | กันกระแทกสูง 2.5m | แบตเตอรี่อึด 8300mAh โทรศัพท์กันกระแทก พร้อม AI กล้องความละเอียดสูง |  รองรับ 5G",
        "product_image": "https://img.lazcdn.com/g/p/6db634b829b0b49d82f746c764f72af6.jpg_200x200q90.jpg",
        "price": 25798,
        "remark": "https://www.lazada.co.th/products/pdp-i5430231111.html",
        "sold": 769
    },
    {
        "product_name": "Technics EAH-AZ100 True Wireless หูฟังไร้สาย by Pro Gadgets",
        "product_image": "https://img.lazcdn.com/g/p/1ad9de082eb7049a16723537879fed4d.jpg_200x200q90.jpg",
        "price": 23980,
        "remark": "https://www.lazada.co.th/products/pdp-i5557971030.html",
        "sold": 11
    },
    {
        "product_name": "Sony WH-1000XM5 หูฟังไร้สาย พร้อมระบบตัดเสียงรบกวน  by munkong",
        "product_image": "https://img.lazcdn.com/g/p/45ac44951773920ec8b96e3bc0352fbf.jpg_200x200q90.jpg",
        "price": 21800,
        "remark": "https://www.lazada.co.th/products/pdp-i4436622445.html",
        "sold": 1530
    },
    {
        "product_name": "[4.25-4.30 ลดสูงสุด15%*] HUAWEI MatePad 11.5 2025 Standard Edition | แท็บเล็ต | PC-level WPS Office 2.0 | HUAWEI Notes เวอร์ชันใหม่ | แบตเตอรี่ 10,100mAh | ร้านค้าอย่างเป็นทางการ",
        "product_image": "https://img.lazcdn.com/g/p/98738367e8979ec5ac8a2a43b8395c16.png_200x200q90.png",
        "price": 19980,
        "remark": "https://www.lazada.co.th/products/pdp-i5961762076.html",
        "sold": 158
    },
    {
        "product_name": "vivo V60 Lite 5G(8+256GB) Dimensity 7360-Turbo l  จอภาพ 6.77” OLED (By Lazada SuperTphone)",
        "product_image": "https://img.lazcdn.com/g/p/ba2641bc4fe861ede78bf7a4185f4f18.jpg_200x200q90.jpg",
        "price": 18198,
        "remark": "https://www.lazada.co.th/products/pdp-i5896468555.html",
        "sold": 167
    },
    {
        "product_name": "REDMI Note 15 5G 8+256 ป้องกันการตกกระแทก 1.7 เมตร|กล้อง 108MP สุดคมชัด|จอ AMOLED สุดคมชัดขนาด 6.77\"",
        "product_image": "https://img.lazcdn.com/g/p/afa5a00c86c06d2cb094d4d7a241c0f3.jpg_200x200q90.jpg",
        "price": 16998,
        "remark": "https://www.lazada.co.th/products/pdp-i5990286914.html",
        "sold": 201
    },
    {
        "product_name": "HONOR X7d 5G (8+256GB) โทรศัพท์มือถือ หน้าจอใหญ่ 6.77 นิ้ว | ชิปเซ็ต Snapdragon 6s Gen 3 | แบตเตอรี่ 6500mAh | ชาร์จเร็ว 35W | ประกันศูนย์ไทย 12 เดือน ลำโพงคู่ พร้อม AI อัจฉริยะ",
        "product_image": "https://img.lazcdn.com/g/p/f341cbcf1f5587ac4eafe7fccecf1c8b.jpg_200x200q90.jpg",
        "price": 15098,
        "remark": "https://www.lazada.co.th/products/pdp-i5870414472.html",
        "sold": 359
    },
    {
        "product_name": "HONOR X6C หน้าจอใหญ่ 6.61 นิ้ว / แบตเตอรี่อึด 5300mAh / ชาร์จเร็ว 35W / RAM 6GB / ความจุ 128GB-256GB / กันฝุ่นและน้ำ IP64 โทรศัพท์ AI ปรับภาพ กล้องคมชัด",
        "product_image": "https://img.lazcdn.com/g/p/f657213e468c3aac25299029493d2a7e.jpg_200x200q90.jpg",
        "price": 8598,
        "remark": "https://www.lazada.co.th/products/pdp-i5813686036.html",
        "sold": 815
    },
    {
        "product_name": "realme Note 80 สมาร์ทโฟน แบตเตอรี่ 6300mAh ทนทานระดับ ArmorShell™ ลื่นไหลทุกการใช้งาน รองรับการใช้งานยาวนาน 48 เดือน ดีไซน์บางเพียง 7.94 มม.",
        "product_image": "https://img.lazcdn.com/g/p/b741c9408568fb0291eedf7a571d1238.jpg_200x200q90.jpg",
        "price": 8298,
        "remark": "https://www.lazada.co.th/products/pdp-i6071464496.html",
        "sold": 71
    },
    {
        "product_name": "Geevorks AI อัดวิดีโอแบบ HD กล้องถ่ายรูปเด็ก2.4GHz WiFi LCD หน้าจอสัมผัส AI การเรียนรู้กล้องวีดีโอดิจิตอล",
        "product_image": "https://img.lazcdn.com/g/p/1ec8a696fe421605ba785a3908e4ebf8.jpg_200x200q90.jpg",
        "price": 7988,
        "remark": "https://www.lazada.co.th/products/pdp-i16082531445.html",
        "sold": 0
    },
    {
        "product_name": "อัดวิดีโอแบบ HD กล้องถ่ายรูปเด็ก2.4GHz WiFi LCD หน้าจอสัมผัส AI การเรียนรู้กล้องวีดีโอดิจิทัล",
        "product_image": "https://img.lazcdn.com/g/p/23dd7b45333ab6390ff9c070b0e7e24e.jpg_200x200q90.jpg",
        "price": 7988,
        "remark": "https://www.lazada.co.th/products/pdp-i16082426918.html",
        "sold": 0
    },
    {
        "product_name": "กล้องดิจิตอล CCD สำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S36ab902272494527ae25c93f55b4a0c22.jpg_200x200q90.jpg",
        "price": 7917.28,
        "remark": "https://www.lazada.co.th/products/pdp-i16082423266.html",
        "sold": 0
    },
    {
        "product_name": "Geevorks แผ่นรองเต้น100เพลงเต้นรำในตัวคู่เพลง160เกมแผ่นรองเต้นอิเล็กทรอนิกส์สำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/41f3e2960eb1ad20101e7b08c389fb41.jpg_200x200q90.jpg",
        "price": 7826,
        "remark": "https://www.lazada.co.th/products/pdp-i6016545146.html",
        "sold": 0
    },
    {
        "product_name": "NAVIFORCE Creative Multifunction Man Wristwatches Silicone Strap LCD Display Electronic Watches for Man Casual Wild Male Clocks",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S7092349b210344ba952bbfa2b0b289477.jpg_200x200q90.jpg",
        "price": 7676,
        "remark": "https://www.lazada.co.th/products/pdp-i5953097829.html",
        "sold": 0
    },
    {
        "product_name": "Nafurno เครื่องชกมวยเพลง BT อัจฉริยะเป้าหมายเจาะอิเล็กทรอนิกส์พร้อมชิป AI ซิงค์เพื่อเอาชนะสำหรับเด็กผู้ใหญ่การฝึกอบรมการออกกำลังกายการเผาผลาญแคลอรี่",
        "product_image": "https://img.lazcdn.com/g/p/8d161a31f9dba8a69341a783bc3d4fd4.jpg_200x200q90.jpg",
        "price": 7648,
        "remark": "https://www.lazada.co.th/products/pdp-i16146299113.html",
        "sold": 0
    },
    {
        "product_name": "QIAOPIGU | หมากรุกอิเล็กทรอนิกส์ฝึกสมองอัจฉริยะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S51f642c57391484a89ff1c0817b9611aa.jpg_200x200q90.jpg",
        "price": 7602.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16082115673.html",
        "sold": 0
    },
    {
        "product_name": "HONGMEITIANYI | กล้องถ่ายรูปพิมพ์ทันทีสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scb0a14bd13f5456c96ffc790bcf4758eU.png_200x200q90.png",
        "price": 7554.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16111959841.html",
        "sold": 0
    },
    {
        "product_name": "AI อัดวิดีโอแบบ HD กล้องถ่ายรูปเด็ก2.4GHz WiFi LCD หน้าจอสัมผัส AI การเรียนรู้กล้องวีดีโอดิจิทัล",
        "product_image": "https://img.lazcdn.com/g/p/ea9e3066a00fdeaac7f743a6154bc7c7.jpg_200x200q90.jpg",
        "price": 7452,
        "remark": "https://www.lazada.co.th/products/pdp-i6034692013.html",
        "sold": 0
    },
    {
        "product_name": "Nannigr Zopsc 2.4GHz WiFi AI กล้องสำหรับเด็ก 2MP 5MP กล้องดิจิตอลเลนส์คู่พร้อมหน้าจอสัมผัส 4 นิ้วการจดจำวัตถุบทสนทนาด้วยเสียงเครื่องเล่น MP3 พื้นที่เก็บข้อมูล 16GB วันเกิดคริสต์มาส (สีน้ำเงิน)",
        "product_image": "https://img.lazcdn.com/g/p/49bb95f70f9e804f96cf26a4fca1bd52.jpg_200x200q90.jpg",
        "price": 7382,
        "remark": "https://www.lazada.co.th/products/pdp-i16147060978.html",
        "sold": 0
    },
    {
        "product_name": "Fire-Maple | เตาแคมปิ้งพกพาแบบกันลมพร้อมระบบจุดไฟอิเล็กทรอนิกส์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S663d6f39fa4b46a9858993e450010ec2H.jpg_200x200q90.jpg",
        "price": 7365.32,
        "remark": "https://www.lazada.co.th/products/pdp-i16101033293.html",
        "sold": 0
    },
    {
        "product_name": "Robotic Car Kit Learning and Develop Smart Automation Complete Kit As Shown Plastic for Programming",
        "product_image": "https://img.lazcdn.com/g/p/f9d3dc44c5efdded204247757ce3a38f.jpg_200x200q90.jpg",
        "price": 7232,
        "remark": "https://www.lazada.co.th/products/pdp-i6001875863.html",
        "sold": 0
    },
    {
        "product_name": "MANTUOLUO | กล้องความละเอียดสูงสำหรับนักเรียนผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S12fcbb0d47c34c658cbb8d453109faabv.jpg_200x200q90.jpg",
        "price": 7112.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16084687304.html",
        "sold": 0
    },
    {
        "product_name": "JUMPGO | ของเล่นหุ่นยนต์แปลงร่างสำหรับเด็กชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4372835ce14240ddb1920e1217c8b1b3V.png_200x200q90.png",
        "price": 7015.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16049146689.html",
        "sold": 0
    },
    {
        "product_name": "ของเล่นกล้องถ่ายรูปสไตล์วินเทจสำหรับนักเรียน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7510a200a66a427594a4145d39b0973eb.jpg_200x200q90.jpg",
        "price": 6953.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16084765246.html",
        "sold": 0
    },
    {
        "product_name": "MANTUOLUO | กล้องดิจิตอลพกพาความละเอียดสูง CCD",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3cb4cb26f948413aa7812ead867b6803p.jpg_200x200q90.jpg",
        "price": 6904.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16084556847.html",
        "sold": 0
    },
    {
        "product_name": "(LACC) 6X Electronic Altimeter Carabiner Altimeter Handheld Thermometer Outdoor Fishing Weather Forecast Mode Meter",
        "product_image": "https://img.lazcdn.com/g/p/7dfac3144dfd973578533483525b2870.jpg_200x200q90.jpg",
        "price": 6264,
        "remark": "https://www.lazada.co.th/products/pdp-i16132467172.html",
        "sold": 0
    },
    {
        "product_name": "SEGA FAVE กล้องพิมพ์ PRICA Sanrio Characters",
        "product_image": "https://img.lazcdn.com/g/p/a9113d54cb342e7641e9507657f289af.png_200x200q90.png",
        "price": 6258,
        "remark": "https://www.lazada.co.th/products/pdp-i5776852820.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องจ่ายของเล่นแคปซูลคุณภาพสูง ขนาดเล็กสำหรับใช้ที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd8b3a4ac4d8c44b8ad87603b89e4520fh.png_200x200q90.png",
        "price": 6164,
        "remark": "https://www.lazada.co.th/products/pdp-i16120489125.html",
        "sold": 0
    },
    {
        "product_name": "TTYGJ | เครื่องวัดระยะด้วยเลเซอร์ความแม่นยำสูง เครื่องวัดระยะทางอิเล็กทรอนิกส์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0f6f5a0b7ae04504a9a9cf667670a96ca.jpg_200x200q90.jpg",
        "price": 6080.46,
        "remark": "https://www.lazada.co.th/products/pdp-i5895037199.html",
        "sold": 0
    },
    {
        "product_name": "CONVERSE รองเท้าผ้าใบ STAR PLAYER 76 PREMIUM CANVAS OX BLACK UNISEX ( A01607C ) A01607CM_H2BKXX",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3e3d80807f6047abb7676f581256d651w.jpg_200x200q90.jpg",
        "price": 6000,
        "remark": "https://www.lazada.co.th/products/pdp-i4783619541.html",
        "sold": 95
    },
    {
        "product_name": "For Referee Scoreboards & Timer Electronic Scoreboard for Outdoor Use in for Basketball and Football",
        "product_image": "https://img.lazcdn.com/g/p/6fed8faca640a9b0d9c12b84ae86720a.jpg_200x200q90.jpg",
        "price": 5934,
        "remark": "https://www.lazada.co.th/products/pdp-i16108375622.html",
        "sold": 0
    },
    {
        "product_name": "[DCS Store] Selected3X Version SFR1M44-U100K USB Emulator Gray 3.5In 1.44MB USB SSD Floppy Drive Emulator for Electronic Keyboard",
        "product_image": "https://img.lazcdn.com/g/p/49b3c0961824cfe93fc8770523c580c8.jpg_200x200q90.jpg",
        "price": 5904,
        "remark": "https://www.lazada.co.th/products/pdp-i16108485983.html",
        "sold": 0
    },
    {
        "product_name": "[New] HONOR Play 10 (3+64GB) โทรศัพท์มือถือ สนุก! สไตล์สาย Play | หน้าจอ 6.74\" 90Hz | กล้อง AI 13 MP | แบตเตอรี่ 5000mAh | ประกันศูนย์ไทย 12 เดือน | รองรับ 4G",
        "product_image": "https://img.lazcdn.com/g/p/217560caeedbbf63e4dae8b979036c07.jpg_200x200q90.jpg",
        "price": 5898,
        "remark": "https://www.lazada.co.th/products/pdp-i5663922795.html",
        "sold": 328
    },
    {
        "product_name": "กลไกจักรกลชีวภาพสำหรับสุนัข2026ของเล่นควบคุมระยะไกลสำหรับเด็กพร้อมโปรแกรมมือถือ",
        "product_image": "https://img.lazcdn.com/g/p/4659653003c9608d69cd60e4b9208751.jpg_200x200q90.jpg",
        "price": 5776.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16089300859.html",
        "sold": 0
    },
    {
        "product_name": "COONOR ประหยัดพลังงานติดตามแรงดันอากาศกันน้ำ10ATM Jam Tangan Elektronik นาฬิกากีฬากลางแจ้งสำหรับตกปลาเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/4634c30567665eacf7b3811a6d0666dd.jpg_200x200q90.jpg",
        "price": 5738,
        "remark": "https://www.lazada.co.th/products/pdp-i16091259214.html",
        "sold": 0
    },
    {
        "product_name": "MAQUCC | กล้องสำหรับเด็ก HD CCD ถ่ายภาพและวิดีโอ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd9cc37d873aa45bdbed539e6b56dbc5bd.jpg_200x200q90.jpg",
        "price": 5688,
        "remark": "https://www.lazada.co.th/products/pdp-i16089276444.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องเป้าล่อสำหรับต่อยมวยเพลงอิเล็กทรอนิกส์ Gociy สำหรับใช้ในบ้านอุปกรณ์ออกกำลังกาย",
        "product_image": "https://img.lazcdn.com/g/p/29c843ef582880e798c49ad65f26c479.jpg_200x200q90.jpg",
        "price": 5620,
        "remark": "https://www.lazada.co.th/products/pdp-i5990821811.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องฝึกชกมวยอิเล็กทรอนิกส์ Goyan ตอบสนองอุปกรณ์ฝึกชกมวยสำหรับฝึกซ้อมออกกำลังกายยิมที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/p/064d0c134c70aea8b3dffbd9397d3229.jpg_200x200q90.jpg",
        "price": 5616,
        "remark": "https://www.lazada.co.th/products/pdp-i5848878473.html",
        "sold": 0
    },
    {
        "product_name": "( M 1 )ซื้อ 1 แถม 1 SPORT WEI นาฬิกาอิเล็กทรอนิกส์ ทรงกลม+ทรงเหลี่ยม กันน้ำได้ ( 7 สี )",
        "product_image": "https://img.lazcdn.com/g/p/ccfa0dd70c0ef704b5f1e96df01e206b.jpg_200x200q90.jpg",
        "price": 5596.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5936578136.html",
        "sold": 0
    },
    {
        "product_name": "นาฬิกา10ATM Jam Tangan Elektronik กันน้ำเครื่องวัดอุณหภูมิแบ็คไลท์มัลติฟังก์ชันสำหรับตกปลาปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/838311a01775c27ff9188709e30b91cd.jpg_200x200q90.jpg",
        "price": 5402,
        "remark": "https://www.lazada.co.th/products/pdp-i6066626838.html",
        "sold": 0
    },
    {
        "product_name": "เบรกอิเล็กทรอนิกส์ DC DC รอกตกปลาเบรกอิเล็กทรอนิกส์ป้องกันสายพันกัน",
        "product_image": "https://img.lazcdn.com/g/p/345c5deedd4d854d61488302475bbc9d.jpg_200x200q90.jpg",
        "price": 5390,
        "remark": "https://www.lazada.co.th/products/pdp-i16122826702.html",
        "sold": 0
    },
    {
        "product_name": "MANTUOLUO | กล้อง CCD รูปลักษณ์น่ารักสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3c42a720c8a942899a768ece640f8e0bM.jpg_200x200q90.jpg",
        "price": 5354.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16083794147.html",
        "sold": 0
    },
    {
        "product_name": "อุปกรณ์ออกกำลังกายที่บ้านสำหรับฝึกมวยดนตรีอิเล็กทรอนิกส์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3df675ec73084652bbb83bede8f90d4fe.jpg_200x200q90.jpg",
        "price": 5341.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6066488583.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องชกมวยอิเล็กทรอนิกส์ Goyan อุปกรณ์ฝึกชกมวยติดผนัง",
        "product_image": "https://img.lazcdn.com/g/p/88d347974019cfde6875bda394700b70.jpg_200x200q90.jpg",
        "price": 5232,
        "remark": "https://www.lazada.co.th/products/pdp-i5851062668.html",
        "sold": 0
    },
    {
        "product_name": "M-horse 17 Pro max 4G (4/64) ประกันศูนย์ 12 เดือน [ หน้าจอ 6.6 นิ้ว แบต 5000 mAh ] (zeropoint)",
        "product_image": "https://img.lazcdn.com/g/p/0ad26f1b93248899e46663bc2712f584.png_200x200q90.png",
        "price": 5198,
        "remark": "https://www.lazada.co.th/products/pdp-i6018613276.html",
        "sold": 13
    },
    {
        "product_name": "HONGMEITIANYI | ของขวัญวันเกิด กล้องโพลารอยด์พรีเมียม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf2699184794e4856ba1c0f3dd6bb05c0C.png_200x200q90.png",
        "price": 5139.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5954013434.html",
        "sold": 58
    },
    {
        "product_name": "Heei | กล้องจุลทรรศน์ USB พกพาสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6444b7fa87e948b7ae54d7a0e3227e2bA.jpg_200x200q90.jpg",
        "price": 5117.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5954048556.html",
        "sold": 0
    },
    {
        "product_name": "[LLK MALL]For 2 Stroke 40 Boat Engine Outboard Motor Electronic Throttle Electric Throttle",
        "product_image": "https://img.lazcdn.com/g/p/1613ec8eb0392ee4a8979395040e6268.jpg_200x200q90.jpg",
        "price": 5068,
        "remark": "https://www.lazada.co.th/products/pdp-i16043624298.html",
        "sold": 0
    },
    {
        "product_name": "[p6yg]For 2 Stroke 40 Compatible Electric Throttle Electronic Throttle for Boat Engine Outboard Motor",
        "product_image": "https://img.lazcdn.com/g/p/1613ec8eb0392ee4a8979395040e6268.jpg_200x200q90.jpg",
        "price": 5068,
        "remark": "https://www.lazada.co.th/products/pdp-i6070845528.html",
        "sold": 0
    },
    {
        "product_name": "KELAJI | ของเล่นโทรศัพท์มือถือพร้อมฟีเจอร์กล้องสำหรับเด็กผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3095db14ee0b42189feaf2a94f4e81f8k.jpg_200x200q90.jpg",
        "price": 4989.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16113116843.html",
        "sold": 0
    },
    {
        "product_name": "AI Dialogue Robot ChatGPT Companion Toy สำหรับเด็ก แชทแบบโต้ตอบบนเดสก์ท็อป",
        "product_image": "https://img.lazcdn.com/g/p/f81b47c0e8c7dea1b9e156cd5857272a.png_200x200q90.png",
        "price": 4888,
        "remark": "https://www.lazada.co.th/products/pdp-i16099141505.html",
        "sold": 0
    },
    {
        "product_name": "กล้องดิจิตอล Razer Vlogging 2.4นิ้วอเนกประสงค์สำหรับโรงเรียน",
        "product_image": "https://img.lazcdn.com/g/p/bf286d803a378cd484f29bdac915a0fe.jpg_200x200q90.jpg",
        "price": 4868,
        "remark": "https://www.lazada.co.th/products/pdp-i16089535355.html",
        "sold": 0
    },
    {
        "product_name": "กล้องดิจิทัลพกพาได้กล้องถ่ายรูปเด็ก Lenovo 2.4นิ้ว HD FHD 1080P วิดีโอสำหรับการเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/f165ac631d6aea58102ab04c8f6e8a30.jpg_200x200q90.jpg",
        "price": 4868,
        "remark": "https://www.lazada.co.th/products/pdp-i16089367692.html",
        "sold": 0
    },
    {
        "product_name": "กล้องดิจิทัลซูมได้16X แบบพกพาสำหรับการเดินทางภาพถ่าย44MP วิดีโอ1080P HD FHD มัลติฟังก์ชัน2.4นิ้ว",
        "product_image": "https://img.lazcdn.com/g/p/59fa02c47dc0cfec087433cb741e3e07.jpg_200x200q90.jpg",
        "price": 4868,
        "remark": "https://www.lazada.co.th/products/pdp-i16089605109.html",
        "sold": 0
    },
    {
        "product_name": "LELEYU | กล้องเด็กพิมพ์ภาพทันทีความละเอียดสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6c93e04bb37e41dabd4591137e99b5ffH.jpg_200x200q90.jpg",
        "price": 4861.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16052671130.html",
        "sold": 0
    },
    {
        "product_name": "【Latest model】For 2 Stroke 40 Boat Engine Outboard Motor Electronic Throttle Electric Control System",
        "product_image": "https://img.lazcdn.com/g/p/1613ec8eb0392ee4a8979395040e6268.jpg_200x200q90.jpg",
        "price": 4848,
        "remark": "https://www.lazada.co.th/products/pdp-i6066380667.html",
        "sold": 0
    },
    {
        "product_name": "CRRJU | นาฬิกาอิเล็กทรอนิกส์กันน้ำหลายฟังก์ชันสำหรับนักเรียนชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd0882a8f87d44730af882b482d099e5bG.jpg_200x200q90.jpg",
        "price": 4815.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16052054172.html",
        "sold": 0
    },
    {
        "product_name": "GEEKPAPA | กล้องสัมผัสสำหรับเด็กพกพา WiFi",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2183621c7cb44877845d5d9ecee52037k.jpg_200x200q90.jpg",
        "price": 4788,
        "remark": "https://www.lazada.co.th/products/pdp-i16120597272.html",
        "sold": 0
    },
    {
        "product_name": "VEGER VE-02T หูฟังบลูทูธไร้สาย True Wireless Bluetooth 5.3 จอ LED แบตอึด เสียงคมชัด",
        "product_image": "https://img.lazcdn.com/g/p/63474112ad4a93edf28ebea665f21a1a.png_200x200q90.png",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5855890541.html",
        "sold": 0
    },
    {
        "product_name": "[STF Store] Exclusive5X Electronic Whistle with USB Charging, Emergency Whistle for Referee Coaches Teacher, for Outdoor Sport Game Camping",
        "product_image": "https://img.lazcdn.com/g/p/a40e7db3c7b87eab6eaea4b57054b56c.jpg_200x200q90.jpg",
        "price": 4758,
        "remark": "https://www.lazada.co.th/products/pdp-i16108219614.html",
        "sold": 0
    },
    {
        "product_name": "7-คอร์ เตาแก๊สสำหรับตั้งแคมป์ ระบบจุดระเบิดอิเล็กทรอนิกส์ เปลวไฟแรงสูง เตาแก๊สกันลม เตาแก๊สกลางแจ้ง ต้มเดือดเร็ว เตาแบบพกพา การตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/c3b89b5c909b7096d9108652a6f46020.jpg_200x200q90.jpg",
        "price": 4748.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16074909625.html",
        "sold": 0
    },
    {
        "product_name": "For 2 Stroke 40 Boat Engine Outboard Motor Electronic Throttle Electric Control System",
        "product_image": "https://img.lazcdn.com/g/p/1613ec8eb0392ee4a8979395040e6268.jpg_200x200q90.jpg",
        "price": 4746.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16108647138.html",
        "sold": 0
    },
    {
        "product_name": "ไมโครเวฟ เตาไมโครเวฟ ระบบลูกบิด ความจุสูง 28L กำลังไฟสูง 2200W ทำความร้อน 360° รับประกัน 3ปี",
        "product_image": "https://img.lazcdn.com/g/p/18c86af19daf47a374db68a2320d8f67.jpg_200x200q90.jpg",
        "price": 4598,
        "remark": "https://www.lazada.co.th/products/pdp-i6069889016.html",
        "sold": 24
    },
    {
        "product_name": "สำหรับห้องนั่งเล่นแผ่นรองเต้นสำหรับผู้ใหญ่เพื่อพัฒนาการทางดนตรีแผ่นรองเต้นดนตรีตั้งแต่เนิ่นๆ",
        "product_image": "https://img.lazcdn.com/g/p/3521173c415f49df059012290aa84078.jpg_200x200q90.jpg",
        "price": 4570,
        "remark": "https://www.lazada.co.th/products/pdp-i6069471958.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องชกมวยติดผนังใช้กับห่วงออกกำลังกายที่บ้านอุปกรณ์เจาะออกกำลังกายแบบบลูทูธได้ในเป้าต่อยมวย",
        "product_image": "https://img.lazcdn.com/g/p/c799261360ffed35d017c280a743aac8.jpg_200x200q90.jpg",
        "price": 4556,
        "remark": "https://www.lazada.co.th/products/pdp-i5775058915.html",
        "sold": 0
    },
    {
        "product_name": "ระบบจุดระเบิดอิเล็กทรอนิกส์ เตาแก๊สสำหรับตั้งแคมป์ เปลวไฟแรงสูง 7-คอร์ หัวเผาพลังงานสูง อุปกรณ์ตั้งแคมป์ ดีไซน์พกพาสะดวก เตาแบบพกพา การตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/98f4b6629d1bda1984dccab55847bb28.jpg_200x200q90.jpg",
        "price": 4550.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16074791000.html",
        "sold": 0
    },
    {
        "product_name": "Onefire | กล้องโพลารอยด์สำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S54ecdb2cd42047d4a125c595590547a6K.jpg_200x200q90.jpg",
        "price": 4487.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16118977568.html",
        "sold": 0
    },
    {
        "product_name": "ของขวัญวันเกิดสำหรับเด็กผู้หญิงอายุ 10 ปี กล้องถ่ายรูปทันทีของเล่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S136d1c65101641ba969b7ecc17b529e8N.jpg_200x200q90.jpg",
        "price": 4482.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16084757169.html",
        "sold": 0
    },
    {
        "product_name": "ซมซงอเลกทรอนกส 044ZRQ85 FIT Plus USB 3.1 แฟลชไดรฟ (MUF-AB) 64G",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S681a93dd41f342a986b1ccabeefcb951B.png_200x200q90.png",
        "price": 4480.94,
        "remark": "https://www.lazada.co.th/products/pdp-i16097833769.html",
        "sold": 0
    },
    {
        "product_name": "กล้องถ่ายรูปเด็กเล่นพริ้นทันที",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf5114b1199524d0797ca354a2a9cf828E.jpg_200x200q90.jpg",
        "price": 4446.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16119208915.html",
        "sold": 0
    },
    {
        "product_name": "กล้องถ่ายรูปสำหรับเด็กพร้อมปริ้นทันที",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf9ec9ec965bf403ca9ab5a9feb80a0ab3.jpg_200x200q90.jpg",
        "price": 4442.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16083606389.html",
        "sold": 0
    },
    {
        "product_name": "เพลงอิเล็กทรอนิกส์แผ่นรองเต้นแผ่นรองเต้นเด็กเพลงต่างๆสำหรับเล่นที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/p/55aacaf31d868e0245889a6c610553b5.jpg_200x200q90.jpg",
        "price": 4388,
        "remark": "https://www.lazada.co.th/products/pdp-i6069410715.html",
        "sold": 0
    },
    {
        "product_name": "LIVING STONES | กล้องสำหรับเด็กผู้หญิง 3-6 ปี ถ่ายรูปและวิดีโอ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S01060013bd4641699224adf402cf3588k.jpg_200x200q90.jpg",
        "price": 4386,
        "remark": "https://www.lazada.co.th/products/pdp-i5996918247.html",
        "sold": 0
    },
    {
        "product_name": "MAQUCC | กล้องของเล่นสัมผัสหน้าจอ พร้อมฟังก์ชันการบันทึก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S57174855ff38400fb47a1e9ec7ab11191.jpg_200x200q90.jpg",
        "price": 4342,
        "remark": "https://www.lazada.co.th/products/pdp-i16089251453.html",
        "sold": 0
    },
    {
        "product_name": "กล้องถ่ายรูปทันทีสำหรับของขวัญวันเกิด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbda4890d3e7a4d29be933139327d21952.jpg_200x200q90.jpg",
        "price": 4331.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5994139673.html",
        "sold": 7
    },
    {
        "product_name": "กล้องถ่ายภาพทันทีสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfb3b57506c9744b18aeb1242f19a452dy.jpg_200x200q90.jpg",
        "price": 4330.44,
        "remark": "https://www.lazada.co.th/products/pdp-i16084682137.html",
        "sold": 0
    },
    {
        "product_name": "ESC ชุดเครื่องควบคุมความเร็วไฟฟ้า50A พร้อมคันเร่งสำหรับเรือคายัคใบพัดใต้น้ำ",
        "product_image": "https://img.lazcdn.com/g/p/e86bef2a298f4d219121ff7515dc3d0b.jpg_200x200q90.jpg",
        "price": 4274,
        "remark": "https://www.lazada.co.th/products/pdp-i6012724873.html",
        "sold": 0
    },
    {
        "product_name": "Xidanyinxiang | กล้อง CCD ไฮเอนด์สำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa1ce797fd37f47dd9a1c8877d3987407e.png_200x200q90.png",
        "price": 4257.38,
        "remark": "https://www.lazada.co.th/products/pdp-i5981028967.html",
        "sold": 23
    },
    {
        "product_name": "LIVING STONES | กล้องดิจิตอลเด็ก กล้องถ่ายภาพและบันทึกวิดีโอ ของเล่นสำหรับเด็กผู้หญิง ของขวัญวันเกิด กล้องถ่ายภาพแบบ Instant Photography",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se4842b67b45348b4939e74ac66377b3ab.jpg_200x200q90.jpg",
        "price": 4212,
        "remark": "https://www.lazada.co.th/products/pdp-i5996860893.html",
        "sold": 0
    },
    {
        "product_name": "MANTUOLUO | กล้องสำหรับเด็ก พร้อมถ่ายรูปและวิดีโอ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S23d292dddce14b5a86c6b5a77a617ff7S.jpg_200x200q90.jpg",
        "price": 4209.44,
        "remark": "https://www.lazada.co.th/products/pdp-i16076246997.html",
        "sold": 0
    },
    {
        "product_name": "MANTUOLUO | กล้องของขวัญวันเกิดสำหรับเด็กผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S529d64db678e4eda9d30b06d7f89b982M.jpg_200x200q90.jpg",
        "price": 4200.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16083684470.html",
        "sold": 0
    },
    {
        "product_name": "Adeept AWR 4WD WiFi Smart Robot Car Kit สำหรับ Raspberry Pi",
        "product_image": "https://img.lazcdn.com/g/p/f33dd161c4a28f61c1ecae5f3d748793.jpg_200x200q90.jpg",
        "price": 4198,
        "remark": "https://www.lazada.co.th/products/pdp-i5909691344.html",
        "sold": 0
    },
    {
        "product_name": "กล้องพร้อมถ่ายภาพและวิดีโอความละเอียดสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4d7c2c21ac1b4e9d839d9bf56b7ef0a4t.png_200x200q90.png",
        "price": 4189.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16052888195.html",
        "sold": 0
    },
    {
        "product_name": "[NEW ARRIVAL] JBL WAVE FLEX2 หูฟังไร้สาย",
        "product_image": "https://img.lazcdn.com/g/p/67ab6df578352eee6a23e23b1740207c.jpg_200x200q90.jpg",
        "price": 4186,
        "remark": "https://www.lazada.co.th/products/pdp-i5727190384.html",
        "sold": 89
    },
    {
        "product_name": "เครื่องมวยอิเล็กทรอนิกส์1200มิลลิแอมป์ชั่วโมงแบตเตอรี่ในตัวเครื่องเล่นเพลง RGB แสงจังหวะเป้าต่อยมวยสมาร์ทสำหรับออกกำลังกายที่บ้านสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/5aea34ed78bd0b44c2cd5520fc2b31c7.jpg_200x200q90.jpg",
        "price": 4180,
        "remark": "https://www.lazada.co.th/products/pdp-i6047836192.html",
        "sold": 0
    },
    {
        "product_name": "Edifier W830NB/W820NB Plus 2025 หูฟังครอบหูไร้สาย Bluetooth เสียงความละเอียดสูงพร้อมระบบตัดเสียงรบกวนแบบแอคทีฟ รองรับ LDAC และแอป EDIFIER Connex",
        "product_image": "https://img.lazcdn.com/g/p/ff5f2a179b5a35987e772ee46493ac8f.jpg_200x200q90.jpg",
        "price": 4180,
        "remark": "https://www.lazada.co.th/products/pdp-i5083301097.html",
        "sold": 427
    },
    {
        "product_name": "Casio | นาฬิกาอิเล็กทรอนิกส์กันน้ำสำหรับกีฬา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sad6a27351d7b4085ba166e26d8e0f1e9c.jpg_200x200q90.jpg",
        "price": 4168.66,
        "remark": "https://www.lazada.co.th/products/pdp-i6023242845.html",
        "sold": 0
    },
    {
        "product_name": "MANTUOLUO | กล้องของขวัญการศึกษาธีมชินชังสำหรับเด็กหญิงอายุ 10 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf25f1319a29d46aeb52ec7c2c4a25580k.jpg_200x200q90.jpg",
        "price": 4087.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16082322601.html",
        "sold": 0
    },
    {
        "product_name": "ศิลปินรวบรวมเครื่องยนต์ RC จำลองเสียงโมดูลบันทึกเสียงสำหรับรถโมเดล RC อุปกรณ์แข่ง",
        "product_image": "https://img.lazcdn.com/g/p/095aeb70f2a24c749bb0d665aeaa328c.jpg_200x200q90.jpg",
        "price": 4078.94,
        "remark": "https://www.lazada.co.th/products/pdp-i16122653138.html",
        "sold": 0
    },
    {
        "product_name": "Giiker | ของเล่นการศึกษาอิเล็กทรอนิกส์ฝึกสมองด้วยซูโดกุ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S81d058d2e2b2408790b630ba0e1bdff9g.png_200x200q90.png",
        "price": 4068.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16049474059.html",
        "sold": 0
    },
    {
        "product_name": "กล้องดิจิตอลขนาดเล็กสำหรับของขวัญวันเกิดเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S397360999a0642c1bb3e09505020d927C.jpg_200x200q90.jpg",
        "price": 4068.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16084837161.html",
        "sold": 0
    },
    {
        "product_name": "HONGMEITIANYI | กล้องสไตล์เรโทรสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4369794423c64d7a893cdbddd433247c3.png_200x200q90.png",
        "price": 4051.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5999731226.html",
        "sold": 40
    },
    {
        "product_name": "เครื่องดนตรีอิเล็กทรอนิกส์ LED,เครื่องดนตรีมวยติดผนังนักมวยเพลงสำหรับออกกำลังกายที่บ้านสำหรับเด็กและผู้ใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/47ff6588cdc0984a56e31c12e73cf023.jpg_200x200q90.jpg",
        "price": 4036,
        "remark": "https://www.lazada.co.th/products/pdp-i16136983256.html",
        "sold": 0
    },
    {
        "product_name": "ของเล่นอัจฉริยะ AI สำหรับสนทนาและเรียนรู้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4f2277055a9140b89975826574e524e6b.jpg_200x200q90.jpg",
        "price": 4036,
        "remark": "https://www.lazada.co.th/products/pdp-i16089334279.html",
        "sold": 0
    },
    {
        "product_name": "Giiker | ของเล่นดิจิตอลอิเล็กทรอนิกส์เพื่อการศึกษา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1cd08b4085774a3c8ecf95a4074580b5Z.png_200x200q90.png",
        "price": 4012.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16049057307.html",
        "sold": 0
    },
    {
        "product_name": "หูฟัง [แฮนด์ฟรีและชัดเจนสาย] หูฟังบลูทูธ,หูฟังสำหรับโทร,Binaural,ชุดหูฟังพร้อมไมโครโฟน,รองรับบลูทูธ5.3 AAC,ฟังก์ชั่นปิดเสียง,ตัดเสียงรบกวน,ไม่ป้องกันหู,น้ำหนักเบา32ก.,10ชั่วโมงต่อเนื่อง P...",
        "product_image": "https://img.lazcdn.com/g/p/a82903f200ec2251010b524c363bd7a5.png_200x200q90.png",
        "price": 4012,
        "remark": "https://www.lazada.co.th/products/pdp-i16110737671.html",
        "sold": 0
    },
    {
        "product_name": "กล้องดิจิตอล4K 64ล้านพิกเซลกล้องดิจิตอล30FPS พร้อมฟังก์ชั่นเซลฟี่64การ์ด GB TF 18X ซูมดิจิตอล2.8หน้าจอ IPS AF โฟกัสอัตโนมัติกล้อง YouTube แบบชาร์จไฟได้สำหรับผู้เริ่มต้นเว็บแคมสำหรับวันเกิดสำหรับเด็กคริสต์มาสปีใหม่ VLOG แบบพกพาน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/49eaeb7b2c6c6540325065d5591c43c7.png_200x200q90.png",
        "price": 4004,
        "remark": "https://www.lazada.co.th/products/pdp-i16138530359.html",
        "sold": 0
    },
    {
        "product_name": "ของขวัญกล้องถ่ายรูป CCD สไตล์เรโทรสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9c0860a5361f40409e952a6387272a46M.jpg_200x200q90.jpg",
        "price": 3998.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16119430099.html",
        "sold": 0
    },
    {
        "product_name": "ควอไลเซอร์ดิจิตอลมีBLUETOOTH USB EQ-31 ลดเสียงรบกวน อีควอไลเซอร์การประมวลผล DSP31 ส่วน ลดเสียงรบกวนระดับมืออาชีพ",
        "product_image": "https://img.lazcdn.com/g/p/453d52591eeb74b37e084ef491d1bf24.jpg_200x200q90.jpg",
        "price": 3998,
        "remark": "https://www.lazada.co.th/products/pdp-i5982345414.html",
        "sold": 0
    },
    {
        "product_name": "เป้าหมายมวยอิเล็กทรอนิกส์สมาร์ทBTเพลงมวยเครื่องที่มี9โหมดตีตีจับคู่เพลงฮิตเสียงสเตอริโอเจาะเกมสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/1f2fc96b05f2e1bf00d4e599fa0bc36f.jpg_200x200q90.jpg",
        "price": 3938,
        "remark": "https://www.lazada.co.th/products/pdp-i16145476296.html",
        "sold": 0
    },
    {
        "product_name": "kufire | ของขวัญสำหรับเด็ก กล้องถ่ายรูปทันทีของเล่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbfa9236726ed44ffb5f9708a6e959a85Y.jpg_200x200q90.jpg",
        "price": 3928.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5910854504.html",
        "sold": 187
    },
    {
        "product_name": "[NEW ARRIVAL] JBL WAVE BEAM2 หูฟังไร้สาย",
        "product_image": "https://img.lazcdn.com/g/p/9dd5043232236f79849e644dc92eb30a.jpg_200x200q90.jpg",
        "price": 3906,
        "remark": "https://www.lazada.co.th/products/pdp-i5727231925.html",
        "sold": 130
    },
    {
        "product_name": "My Little Pony | กล้องสำหรับเด็ก ถ่ายภาพและวิดีโอความละเอียดสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc7a0b18d42be44f78187ab780b22783am.jpg_200x200q90.jpg",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i5881849192.html",
        "sold": 0
    },
    {
        "product_name": "DFVDS 7-คอร์ เตาแก๊สสำหรับตั้งแคมป์ ระบบจุดระเบิดอิเล็กทรอนิกส์ เปลวไฟแรงสูง เตาแบบพกพา เตาแก๊สกลางแจ้ง สายสวนปัสสาวะแบบยาว เตาแก๊สกันลม การตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/a9e8287cdcd8562a43fe845adfcaba1d.jpg_200x200q90.jpg",
        "price": 3883.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16075011518.html",
        "sold": 0
    },
    {
        "product_name": "LIGHTER ระบบจุดระเบิดอิเล็กทรอนิกส์ เตาแก๊สสำหรับตั้งแคมป์ 7-คอร์ เปลวไฟแรงสูง เตาแบบพกพา อุปกรณ์ตั้งแคมป์ สายสวนปัสสาวะแบบยาว หัวเผาพลังงานสูง การตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/77caac75932d7e624d55ce1b271cde76.png_200x200q90.png",
        "price": 3869.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16074848933.html",
        "sold": 0
    },
    {
        "product_name": "JEWELRY 7-คอร์ เตาแก๊สสำหรับตั้งแคมป์ ระบบจุดระเบิดอิเล็กทรอนิกส์ เปลวไฟแรงสูง หัวเผาพลังงานสูง เตาแก๊สกลางแจ้ง 21000 วัตต์ เตาแบบพกพา การตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/1ed5dc7d6605474f437b724410d88c83.jpg_200x200q90.jpg",
        "price": 3858.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16075043417.html",
        "sold": 0
    },
    {
        "product_name": "CURIO12 7-คอร์ เตาแก๊สสำหรับตั้งแคมป์ ระบบจุดระเบิดอิเล็กทรอนิกส์ เปลวไฟแรงสูง หัวเผาพลังงานสูง เตาแก๊สกลางแจ้ง ดีไซน์พกพาสะดวก เตาแบบพกพา การตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/12f812024c650ca151f0f3656ed10fbd.png_200x200q90.png",
        "price": 3850.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16075195001.html",
        "sold": 0
    },
    {
        "product_name": "ซมซงอเลกทรอนกส 246IOV68 FIT Plus USB 3.1 แฟลชไดรฟ (MUF-AB) 64GB",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S51896bb5545f42b18788eec7d6ef84a9E.png_200x200q90.png",
        "price": 3833.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16098112072.html",
        "sold": 0
    },
    {
        "product_name": "Andoer Andoer 4K กล้องดิจิตอลกล้องวิดีโอ 48MP 2.4 นิ้วหน้าจอ IPS ออโต้โฟกัส 16X ซูมดิจิตอลป้องกันการสั่นตรวจจับใบหน้าจับรอยยิ้มแฟลชในตัวและแบตเตอรี่พร้อมการ์ดหน่วยความจำ 32GB สำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/1d6717efe2d85f442346e47059e3c0ed.jpg_200x200q90.jpg",
        "price": 3820,
        "remark": "https://www.lazada.co.th/products/pdp-i16147192207.html",
        "sold": 0
    },
    {
        "product_name": "กล้องดิจิตอลพิมพ์ทันทีสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S52d93fb79dc3453d87d204963475679aC.jpg_200x200q90.jpg",
        "price": 3810.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16120451442.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสร้างเสียงเพลงอิเล็กทรอนิกส์ LED,เป้าล่อสำหรับต่อยมวยบ็อกเซอร์เชื่อมต่อแบบ BT สำหรับออกกำลังกายที่บ้านสำหรับเด็กและผู้ใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/c62766c6805434b671c20ececc1a5aee.jpg_200x200q90.jpg",
        "price": 3810,
        "remark": "https://www.lazada.co.th/products/pdp-i16090842824.html",
        "sold": 0
    },
    {
        "product_name": "Futoys เครื่องสร้างเสียงดนตรีในร่ม,อุปกรณ์อิเล็กทรอนิกส์สำหรับออกกำลังกาย",
        "product_image": "https://img.lazcdn.com/g/p/731fc50f8c944113cd8077e432fd4298.jpg_200x200q90.jpg",
        "price": 3800,
        "remark": "https://www.lazada.co.th/products/pdp-i16088246759.html",
        "sold": 0
    },
    {
        "product_name": "surepower | ของขวัญวันเกิดกล้องถ่ายรูปทันทีสำหรับเด็กหญิงอายุ 6 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4142b658210449f99a88a3737641b0caA.png_200x200q90.png",
        "price": 3787.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5910868523.html",
        "sold": 67
    },
    {
        "product_name": "กล้องดิจิตอลพิกเซลสูงของเล่นสำหรับเด็กผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S59409cdedbea4e63b4811bae6e471d700.jpg_200x200q90.jpg",
        "price": 3782.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16119270793.html",
        "sold": 0
    },
    {
        "product_name": "huiwaa | กล้องถ่ายรูปทันทีหน้าจอสัมผัสความละเอียดสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7b25309fb07d4dcca165a82319829672D.jpg_200x200q90.jpg",
        "price": 3782,
        "remark": "https://www.lazada.co.th/products/pdp-i16089417086.html",
        "sold": 0
    },
    {
        "product_name": "ประกัน 1ปี หูฟังบลูทูธ Sennheiser CX 400BT หูฟังทูธ เบส หูฟังบลูทูธแท้ bluetooth หูฟังไร้สายแท้ หูงฟังบลูทูธ หูพังบลูทูธ หูพังไร้สาย",
        "product_image": "https://img.lazcdn.com/g/p/6753e3c838201fdc299208cbdde73f9a.jpg_200x200q90.jpg",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i4975040173.html",
        "sold": 0
    },
    {
        "product_name": "อีควอไลเซอร์ดิจิตอล DPS EQ31 ความถี่ในการแสดงสเปกตรัมอิเล็กทรอนิกส์ อีคิวปรับเสียง จอแสดงผลเสียง RGB กระโจม ออดิโอ",
        "product_image": "https://img.lazcdn.com/g/p/8c0444e17bfa3e9ffad91004f348d7af.jpg_200x200q90.jpg",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i5993881083.html",
        "sold": 0
    },
    {
        "product_name": "【Latest model】Mini Digital Scoreboard Portable Wireless Electronic Scoreboard with Buzzer 6-Digit Display for Cornhole Basketball",
        "product_image": "https://img.lazcdn.com/g/p/a6d4261cf66349510a770d97f720b43e.jpg_200x200q90.jpg",
        "price": 3746,
        "remark": "https://www.lazada.co.th/products/pdp-i16136324094.html",
        "sold": 0
    },
    {
        "product_name": "【Latest model】For Cornhole Basketball Mini Digital Scoreboard 6-Digit Display Portable Wireless Electronic Scoreboard with Buzzer",
        "product_image": "https://img.lazcdn.com/g/p/a6d4261cf66349510a770d97f720b43e.jpg_200x200q90.jpg",
        "price": 3746,
        "remark": "https://www.lazada.co.th/products/pdp-i16136037312.html",
        "sold": 0
    },
    {
        "product_name": "【Latest model】Mini Digital Scoreboard 6-Digit Display Portable Wireless Electronic Scoreboard with Buzzer for Cornhole Basketball",
        "product_image": "https://img.lazcdn.com/g/p/a6d4261cf66349510a770d97f720b43e.jpg_200x200q90.jpg",
        "price": 3746,
        "remark": "https://www.lazada.co.th/products/pdp-i16136354095.html",
        "sold": 0
    },
    {
        "product_name": "【Latest model】Digital Scoreboard Mini Portable Wireless Electronic with Buzzer 6-Digit Display for Cornhole Basketball",
        "product_image": "https://img.lazcdn.com/g/p/a6d4261cf66349510a770d97f720b43e.jpg_200x200q90.jpg",
        "price": 3746,
        "remark": "https://www.lazada.co.th/products/pdp-i16136256130.html",
        "sold": 0
    },
    {
        "product_name": "Heei | กล้องความละเอียดสูงสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb30581936beb4e99aa80d44a0352f6f0z.jpg_200x200q90.jpg",
        "price": 3742.76,
        "remark": "https://www.lazada.co.th/products/pdp-i5955108972.html",
        "sold": 1
    },
    {
        "product_name": "huiwaa | กล้องสำหรับเด็ก พิมพ์ภาพทันที สี HD",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S70672c774493405080b69c7e216919e3g.jpg_200x200q90.jpg",
        "price": 3730,
        "remark": "https://www.lazada.co.th/products/pdp-i16089457028.html",
        "sold": 0
    },
    {
        "product_name": "หูฟังไร้สาย, หูฟังบลูทูธ 5.3 เล่นเพลงได้นาน 40 ชั่วโมง เสียงเบสหนักแน่น สเตอริโอแบบอินเอียร์, หน้าจอแสดงพลังงาน LED, หูฟังตัดเสียงรบกวนพร้อมไมโครโฟน, หูฟังกันน้ำระดับ IP7 สำหรับ IOS และ Android สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/c4c90bea0fcba92bc9c07b82c18276d0.jpg_webp_200x200q90.jpg",
        "price": 3721.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16122264426.html",
        "sold": 0
    },
    {
        "product_name": "Heei | กล้องดิจิตอล HD สำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se83d49be04274b86bbd6df0ebc9c67d72.jpg_200x200q90.jpg",
        "price": 3719,
        "remark": "https://www.lazada.co.th/products/pdp-i5955241351.html",
        "sold": 3
    },
    {
        "product_name": "WUQUGONGSHE | กล้องดิจิตอลขนาดเล็กสำหรับเป็นของขวัญให้แฟน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd15a7e0bd0bc47ef802dc2f2e97a308bz.jpg_200x200q90.jpg",
        "price": 3695.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6001842488.html",
        "sold": 0
    },
    {
        "product_name": "Heei | ของเล่นการศึกษา กล้องดิจิตอลเด็ก พร้อมกล้องคู่ HD",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd84bcb830ff342dab565d84e939abee46.jpg_200x200q90.jpg",
        "price": 3693.18,
        "remark": "https://www.lazada.co.th/products/pdp-i5953774910.html",
        "sold": 2
    },
    {
        "product_name": "Heei | กล้องซีซีดีความละเอียดสูงสำหรับเด็ก พร้อมเลนส์หมุนและยืดได้ และหน้าจอพลิก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se7ad53dbbd274d6ab516975eeaef862fr.jpg_200x200q90.jpg",
        "price": 3681.84,
        "remark": "https://www.lazada.co.th/products/pdp-i5955208149.html",
        "sold": 5
    },
    {
        "product_name": "surepower | ของขวัญวันเกิดสำหรับเด็กหญิงอายุ 6-12 ปี กล้องโพลารอยด์ขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se00736f53ed34b9eb71f4633f8010ef0A.jpg_200x200q90.jpg",
        "price": 3654.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5910883642.html",
        "sold": 138
    },
    {
        "product_name": "กล้องสำหรับเด็กพร้อมพิมพ์ภาพสีทันที",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3f0b1c4ab6974833b5982580dbdf49cfA.jpg_200x200q90.jpg",
        "price": 3629.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16119267060.html",
        "sold": 0
    },
    {
        "product_name": "หุ่นยนต์ของเล่นวาดรูปหุ่นยนต์จดจำได้อย่างรวดเร็วพร้อมการ์ด100 14ใบสำหรับเป็นของขวัญคริสต์มาสสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/ba2b19a51240fc1e70454ae7a27c9f1a.jpg_200x200q90.jpg",
        "price": 3606,
        "remark": "https://www.lazada.co.th/products/pdp-i6060628975.html",
        "sold": 0
    },
    {
        "product_name": "HONGMEITIANYI | กล้องถ่ายรูปของขวัญสำหรับเด็ก 2026 ใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S70226b6bbc61406a89fbc40601555ebbc.png_200x200q90.png",
        "price": 3585.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6055184917.html",
        "sold": 4
    },
    {
        "product_name": "ของเล่นหุ่นยนต์ AI แชทบอท",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S311b3c44572b4897b5875df0ab0e02abl.jpg_200x200q90.jpg",
        "price": 3585.38,
        "remark": "https://www.lazada.co.th/products/pdp-i5894730661.html",
        "sold": 6
    },
    {
        "product_name": "REXUELONG | พรมเต้นไร้สายบลูทูธสำหรับเด็กใช้ที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdffeed441be14a37a5f6e2c4c2289372O.jpg_200x200q90.jpg",
        "price": 3578.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16049019896.html",
        "sold": 0
    },
    {
        "product_name": "Electronic Fishing Alarm 1+2 Set Wireless Bite Alarm for European Carp Fishing Gear Kit",
        "product_image": "https://img.lazcdn.com/g/p/c29fe2a42417c4c935c5d7a36662f8eb.jpg_200x200q90.jpg",
        "price": 3570,
        "remark": "https://www.lazada.co.th/products/pdp-i16065516391.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำความเย็นเทอร์โมอิเล็กทริคอุปกรณ์กึ่งตัวนำ Peltier อิเล็กทรอนิกส์ DIY 12V TEC ตู้เย็นระบายความร้อนด้วยน้ำเครื่องปรับอากาศการเคลื่อนไหวระบายความร้อนด้วยสำหรับตู้เย็นและพัดลม",
        "product_image": "https://img.lazcdn.com/g/p/8d2c79a01aca825e8e0a58ba89630324.jpg_200x200q90.jpg",
        "price": 3560.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6066763245.html",
        "sold": 0
    },
    {
        "product_name": "JIANLEXI | กล้องสำหรับเด็กผู้หญิง รุ่นใหม่ 2025 ถ่ายรูปและวิดีโอ พิมพ์สี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd3823156c991438eb9d5ab09730af399I.jpg_200x200q90.jpg",
        "price": 3546.66,
        "remark": "https://www.lazada.co.th/products/pdp-i16055410097.html",
        "sold": 0
    },
    {
        "product_name": "CRAYON SHINCHAN | กล้องดิจิตอลรุ่นเก่าสำหรับนักเรียน ความละเอียดสูง พกพาได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc0c07034b242482fa18d77f0340feaf4c.png_200x200q90.png",
        "price": 3542,
        "remark": "https://www.lazada.co.th/products/pdp-i6006044786.html",
        "sold": 0
    },
    {
        "product_name": "กล้องของเล่นโทรศัพท์มือถือ ° พับได้สำหรับเด็กโทรศัพท์ใช้เล่นหน้าจอสัมผัสความละเอียด1080P 2.8นิ้วมัลติฟังก์ชันสำหรับใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/0a03093864cf82dea34f04b493571162.jpg_200x200q90.jpg",
        "price": 3528,
        "remark": "https://www.lazada.co.th/products/pdp-i16086162426.html",
        "sold": 0
    },
    {
        "product_name": "Viltrox 1080P กล้องวีดีโอขนาดเล็กสำหรับกล้องดิจิทัลสำหรับเด็ก48MP หน้าจอ2.4นิ้ว IPS เลนส์คู่แบตเตอรี่ในตัวพร้อมการ์ดความจำ32GB และของขวัญวันเกิดคริสต์มาสเครื่องอ่านการ์ดและขาตั้งกล้องแบบสามขาสำหรับตั้งโต๊ะสำหรับเด็กหญิงเด็กชาย",
        "product_image": "https://img.lazcdn.com/g/p/76185acbf32463aac87d5c865b5e9f3e.jpg_200x200q90.jpg",
        "price": 3508,
        "remark": "https://www.lazada.co.th/products/pdp-i16076628324.html",
        "sold": 0
    },
    {
        "product_name": "MOLTEN | นกหวีดอิเล็กทรอนิกส์สำหรับผู้ตัดสินบาสเก็ตบอลฟุตบอลวอลเลย์บอล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2eb24b8e6c4748f0abeccf29551d2396i.jpg_200x200q90.jpg",
        "price": 3437.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16045712606.html",
        "sold": 0
    },
    {
        "product_name": "Andoer กล้องถ่ายรูปเด็ก2.4หน้าจอขนาดนิ้วเลนส์คู่48MP กล้องดิจิทัล HD พร้อมตัวกรองแฟลชสำหรับเป็นของขวัญของเล่น",
        "product_image": "https://img.lazcdn.com/g/p/f1aaca33bdfe059187905ca9bb0a5623.jpg_200x200q90.jpg",
        "price": 3432.28,
        "remark": "https://www.lazada.co.th/products/pdp-i16093845089.html",
        "sold": 0
    },
    {
        "product_name": "กล้องดิจิตอลการ์ตูน ของขวัญคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4b301bfc44c54bf3b4eda56e1cb3cf76j.jpg_200x200q90.jpg",
        "price": 3429.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16082520505.html",
        "sold": 0
    },
    {
        "product_name": "【Huang Li Electronics】Retro Vintage Mini Screenless Digital Camera Screen Free 8 Mode Filters Without Screen 8MP Photo Flash Camping",
        "product_image": "https://img.lazcdn.com/g/p/540d53b1444009addbf578b433e80cc9.jpg_200x200q90.jpg",
        "price": 3414,
        "remark": "https://www.lazada.co.th/products/pdp-i16092654356.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องขายของเล่นแคปซูลสำหรับใช้ที่บ้าน สำหรับเด็กผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb2a1f00186d34aec961eabb4d19cdecdO.jpg_200x200q90.jpg",
        "price": 3406,
        "remark": "https://www.lazada.co.th/products/pdp-i16089466004.html",
        "sold": 0
    },
    {
        "product_name": "SONGDIAN | กล้องดิจิตอลขนาดเล็กสไตล์วินเทจสำหรับนักเรียน พกพาได้ ความละเอียดสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sea773d61dd2b4014a5b878f024ddb962J.jpg_200x200q90.jpg",
        "price": 3404,
        "remark": "https://www.lazada.co.th/products/pdp-i6006151251.html",
        "sold": 0
    },
    {
        "product_name": "Momoka เครื่องเป้าต่อยมวยเพลงแบบอิเล็กทรอนิกส์ปรับความเร็วได้กระบองมวยไทยมีไฟพร้อมถุงมือสำหรับเล่นกีฬาในร่ม",
        "product_image": "https://img.lazcdn.com/g/p/83df407b2df00d6776bc3bcf94b81b83.jpg_200x200q90.jpg",
        "price": 3353.32,
        "remark": "https://www.lazada.co.th/products/pdp-i16125210896.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสร้างเสียงดนตรีอัจฉริยะสำหรับเด็กพระจันทร์พร้อมไฟติดผนังเครื่องฝึกมวยอิเล็กทรอนิกส์",
        "product_image": "https://img.lazcdn.com/g/p/775781a95d6215534238bb08a5e83506.jpg_200x200q90.jpg",
        "price": 3336,
        "remark": "https://www.lazada.co.th/products/pdp-i16059015220.html",
        "sold": 0
    },
    {
        "product_name": "mobee | ของเล่นกล้อง CCD พิกเซลความละเอียดสูงสไตล์เรโทร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf2ae0584cbaf462d9269f66243c63bc4u.jpg_200x200q90.jpg",
        "price": 3319.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5996875836.html",
        "sold": 4
    },
    {
        "product_name": "เครื่องออกกำลังกายเป้าต่อยมวยแบบ BT Link เครื่องเป้าซ้อมเตะมวยเพลงอิเล็กทรอนิกส์สำหรับเด็กผู้ใหญ่ออกกำลังกายที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/p/6063eb3390e575caecf58b7b67321c25.jpg_200x200q90.jpg",
        "price": 3318,
        "remark": "https://www.lazada.co.th/products/pdp-i16087429789.html",
        "sold": 0
    },
    {
        "product_name": "เปียโนไฟฟ้า61คีย์，เปียโนไฟฟ้าอัจฉริยะ 61,เปียโนอิเล็กทรอนิกส์ Electronic piano 61 keyboard，Believe in musicเปียโนอิเล็กทรอนิกส์คุณภาพสูง เครื่องเสียงระดับไฮเอนด์",
        "product_image": "https://img.lazcdn.com/g/p/8c4781e475caae2bcbc374367adb1523.jpg_200x200q90.jpg",
        "price": 3293.62,
        "remark": "https://www.lazada.co.th/products/pdp-i4365547595.html",
        "sold": 24
    },
    {
        "product_name": "KIDDYCOLOR | กล้องถ่ายรูปของเล่นความละเอียดสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S961cf55d78ae43e88855c615bc479063w.jpg_200x200q90.jpg",
        "price": 3281.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16049115581.html",
        "sold": 0
    },
    {
        "product_name": "LIVING STONES | กล้องโพลารอยด์สำหรับเด็กความละเอียดสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3dffd9b895f34fa98e24fe5006130f30A.png_200x200q90.png",
        "price": 3268.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16088213270.html",
        "sold": 0
    },
    {
        "product_name": "BAQILING | เครื่องเล่นเกมส์จับของตู้หยอดเหรียญขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S41dbb54b8b6549f884d84810547e0984q.png_200x200q90.png",
        "price": 3261,
        "remark": "https://www.lazada.co.th/products/pdp-i16056710109.html",
        "sold": 0
    },
    {
        "product_name": "HONGMEITIANYI | กล้อง HD สำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0f27b113bc574626b4d8fd28d3e570cfd.png_200x200q90.png",
        "price": 3221.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6019122424.html",
        "sold": 5
    },
    {
        "product_name": "S.X Toys | ของเล่นหุ่นยนต์สุนัขอัจฉริยะ AI",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2a2ccc5b362543e5903961e2f8e97ea1q.jpg_200x200q90.jpg",
        "price": 3213.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5948669994.html",
        "sold": 10
    },
    {
        "product_name": "HONGMEITIANYI | ของขวัญวันเกิดสำหรับเด็กผู้หญิงนักเรียน กล้อง CCD 10MP",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2c9f38e8e6aa415890b5d707bad6fdd0U.png_200x200q90.png",
        "price": 3211.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5955284084.html",
        "sold": 28
    },
    {
        "product_name": "Cai Zu | กล้องดิจิทัล Cai Zu Z3  รุ่นนักเรียน ความละเอียดสูง พกพาสะดวก ใช้งานง่าย ราคานักเรียน",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Sfeceae9051124d6f83dfa030b695cf147.jpg_200x200q90.jpg",
        "price": 3211.36,
        "remark": "https://www.lazada.co.th/products/pdp-i6014922441.html",
        "sold": 35
    },
    {
        "product_name": "นาฬิกา Casio G-SHOCK นาฬิกาข้อมือผู้ชายแฟชั่น รุ่น GA-100CM-5A  กีฬาอิเล็กทรอนิกส์",
        "product_image": "https://img.lazcdn.com/g/p/763afde78581ba682d778008d4d9ab31.jpg_200x200q90.jpg",
        "price": 3198,
        "remark": "https://www.lazada.co.th/products/pdp-i3934139914.html",
        "sold": 0
    },
    {
        "product_name": "surepower | ของขวัญวันเกิด ไฟฉายภาพท้องฟ้าประดับดาวสำหรับเด็กหญิง เพิ่มบรรยากาศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4f7ccb5e91154cc6821e36d218b5ac7ff.jpg_200x200q90.jpg",
        "price": 3195.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5910795656.html",
        "sold": 22
    },
    {
        "product_name": "WPOT 7-คอร์ เตาแก๊สสำหรับตั้งแคมป์ เปลวไฟแรงสูง ระบบจุดระเบิดอิเล็กทรอนิกส์ หัวเผาพลังงานสูง อุปกรณ์ตั้งแคมป์ ต้มเดือดเร็ว เตาแบบพกพา การตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/f06149e202d7b5308e6bb75f7ca64aa4.jpg_200x200q90.jpg",
        "price": 3184,
        "remark": "https://www.lazada.co.th/products/pdp-i16105412989.html",
        "sold": 0
    },
    {
        "product_name": "KIDDYCOLOR | กล้องถ่ายรูปและวิดีโอสำหรับเด็ก HD ดิจิตอลทันที",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8e9197da22a84e9b8134cb482f5dbc53X.jpg_200x200q90.jpg",
        "price": 3157.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16049416090.html",
        "sold": 0
    },
    {
        "product_name": "DFHRE 7-คอร์ เตาแก๊สสำหรับตั้งแคมป์ ระบบจุดระเบิดอิเล็กทรอนิกส์ เปลวไฟแรงสูง เตาแบบพกพา อุปกรณ์ตั้งแคมป์ ต้มเดือดเร็ว เตาแก๊สกันลม การตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/99face4a23703316cb85dd833cfe6758.png_200x200q90.png",
        "price": 3152,
        "remark": "https://www.lazada.co.th/products/pdp-i16105786080.html",
        "sold": 0
    },
    {
        "product_name": "Disney | นาฬิกาอิเล็กทรอนิกส์สำหรับเด็กที่มีสไตล์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd359a81ef7e54c678377f12512ec2753b.jpg_200x200q90.jpg",
        "price": 3143.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5877090596.html",
        "sold": 12
    },
    {
        "product_name": "(LACC) 3X Electronic Altimeter Carabiner Altimeter Handheld Thermometer Outdoor Fishing Weather Forecast Mode Meter",
        "product_image": "https://img.lazcdn.com/g/p/e300d3df7bcc815a5d4f26c3bf7c593f.jpg_200x200q90.jpg",
        "price": 3136,
        "remark": "https://www.lazada.co.th/products/pdp-i16132848231.html",
        "sold": 0
    },
    {
        "product_name": "Z83C Electron <br>DODICI Bicycle Handlebar Carbon Fiber Matte Bike Handlebar Handlebars Bike Accessories",
        "product_image": "https://img.lazcdn.com/g/p/ed5bd11f2e6d1b76187f5f8e25f2cfb7.jpg_200x200q90.jpg",
        "price": 3116,
        "remark": "https://www.lazada.co.th/products/pdp-i6077932877.html",
        "sold": 0
    },
    {
        "product_name": "เสื่อลานเต้นแผ่นเกมเต้นแบบอินเตอร์แอคทีฟผู้เล่นคนเดียวเพื่อการศึกษาความไวสูงสำหรับบ้านและเด็กหญิงเด็กชาย",
        "product_image": "https://img.lazcdn.com/g/p/b61455f621629625ebb010e78740eb05.jpg_200x200q90.jpg",
        "price": 3114,
        "remark": "https://www.lazada.co.th/products/pdp-i6040863662.html",
        "sold": 0
    },
    {
        "product_name": "Disney | กล้องสำหรับเด็กพร้อมใช้งานทันที ระดับไฮเอนด์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa33519bd78804c6ba198a43f41c772b3N.png_200x200q90.png",
        "price": 3098.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5968651721.html",
        "sold": 6
    },
    {
        "product_name": "Fire-Maple | เตาแคมปิ้งพกพาประหยัดพลังงาน สามารถถอดแยกได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1708898a9ac64a62bde8e63c7e8bda00H.jpg_200x200q90.jpg",
        "price": 3080.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16097705538.html",
        "sold": 0
    },
    {
        "product_name": "ความคมชัดสูงเซลฟี่อิเล็กทรอนิกส์แบบกล้องพิมพ์ทันทีกล้องถ่ายรูปเด็กพร้อมสายชาร์จพิมพ์ได้ทันทีสำหรับเด็กชีวิตประจำวัน",
        "product_image": "https://img.lazcdn.com/g/p/dd2f5ef50cae2904b6dc8685c75b3e67.jpg_200x200q90.jpg",
        "price": 3070,
        "remark": "https://www.lazada.co.th/products/pdp-i6024579530.html",
        "sold": 0
    },
    {
        "product_name": "Andoer Wennzy แบบพกพา 1080P กล้องดิจิตอลกล้องวิดีโอ 48MP Anti-Shake 8X ซูม 2.7 นิ้วหน้าจอ LCD Face Detact จับภาพรอยยิ้มแบตเตอรี่ลิเธียมในตัวพร้อมกระเป๋าถือสายรัดข้อมือสำหรับเด็กวัยรุ่น",
        "product_image": "https://img.lazcdn.com/g/p/9881118ef046d567601455e7f169871e.jpg_200x200q90.jpg",
        "price": 3066,
        "remark": "https://www.lazada.co.th/products/pdp-i16146649428.html",
        "sold": 0
    },
    {
        "product_name": "ตัวการ์ตูนสะสมชุดเกราะฮัลค์บัสเตอร์ MK44",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S88df30ef5aa24748a18cd808685e4795i.jpg_200x200q90.jpg",
        "price": 3061.34,
        "remark": "https://www.lazada.co.th/products/pdp-i6034610477.html",
        "sold": 7
    },
    {
        "product_name": "Disney | กล้องความละเอียดสูงสำหรับเด็ก ถ่ายภาพและบันทึกวิดีโอ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S232fe2ef98164a25b112a2835b2a3e97C.png_200x200q90.png",
        "price": 3054,
        "remark": "https://www.lazada.co.th/products/pdp-i16144751902.html",
        "sold": 0
    },
    {
        "product_name": "RiToEasysports สีสว่างเกมแผ่นรองเต้นสำหรับวัยรุ่นแผ่นรองเต้นของเล่นเด็กสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/544ea2b53fb27b947605bb2d4fd1f61d.jpg_200x200q90.jpg",
        "price": 3048,
        "remark": "https://www.lazada.co.th/products/pdp-i16065580567.html",
        "sold": 0
    },
    {
        "product_name": "BABYSHOME | ของเล่นรถหุ่นยนต์แปลงร่างสำหรับเด็กชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1840cf0a1b364525b49cbf700cf874c0l.jpg_200x200q90.jpg",
        "price": 3046.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5948899835.html",
        "sold": 15
    },
    {
        "product_name": "COJR | นาฬิกากีฬาสำหรับกลางแจ้งและทหาร พร้อมเข็มทิศอิเล็กทรอนิกส์และฟังก์ชันดำน้ำ",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S60a80c253d6d404e97f4c27d23de18a1x.jpeg_200x200q90.jpg",
        "price": 3041.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5996779328.html",
        "sold": 14
    },
    {
        "product_name": "เครื่องชั่งแบบแขวนการแปลงหน่วยกุญแจอิเล็กทรอนิกส์หนึ่งเครื่องชั่งปลาสำหรับกระเป๋าเดินทางพร้อมตะขอหนัก0.2กก. ถึง100กก.",
        "product_image": "https://img.lazcdn.com/g/p/d23fac51b7b4407579126b36bdb2be95.jpg_200x200q90.jpg",
        "price": 3029.66,
        "remark": "https://www.lazada.co.th/products/pdp-i6011068412.html",
        "sold": 0
    },
    {
        "product_name": "Homtom โทรศัพท์มือถือปลอมสำหรับเด็ก,วิดีโอ1080P ของเล่นโทรศัพท์มือถือเด็ก MP3น่าสนใจเครื่องเล่น MP4มัลติฟังก์ชั่นการศึกษาสำหรับเด็กผู้ชายและเด็กผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/56766db18daa98fccf1cf9bd9138a6fd.jpg_200x200q90.jpg",
        "price": 2998,
        "remark": "https://www.lazada.co.th/products/pdp-i6033534080.html",
        "sold": 0
    },
    {
        "product_name": "Acer OT THREE หูฟังไร้สายบลูทู ธ 5.3 หูฟัง HiFi ไม่มีในหูไมโครโฟนในตัวโทรชุดหูฟังเกมมิ่งไม่ล่าช้า (รับสาย: ส่ายหัวเพื่อรับสาย) หูฟังบลูทู ธ กีฬาคุณภาพสูง",
        "product_image": "https://img.lazcdn.com/g/p/960f73d520ca0b6b4fe86f7ab6cfca6d.jpg_200x200q90.jpg",
        "price": 2936,
        "remark": "https://www.lazada.co.th/products/pdp-i5025301995.html",
        "sold": 4
    },
    {
        "product_name": "A0SAMOLLA Electronic Baitcasting Fishing Reel Led Screen USB and Solar Charging 7.2:1 Sea Saltwater Wheel",
        "product_image": "https://img.lazcdn.com/g/p/c611a0c6f85d31802e2b454fd9e4e4c3.jpg_200x200q90.jpg",
        "price": 2928,
        "remark": "https://www.lazada.co.th/products/pdp-i16140920662.html",
        "sold": 0
    },
    {
        "product_name": "K0SAMOLLA Electronic Baitcasting Fishing Reel Led Screen USB and Solar Charging 7.2:1 Sea Saltwater Wheel",
        "product_image": "https://img.lazcdn.com/g/p/05657ab0e05bd6a023d42714eaaf51c6.jpg_200x200q90.jpg",
        "price": 2928,
        "remark": "https://www.lazada.co.th/products/pdp-i16135995899.html",
        "sold": 0
    },
    {
        "product_name": "B8SAMOLLA Electronic Baitcasting Fishing Reel Led Screen USB and Solar Charging 7.2:1 Sea Saltwater Wheel",
        "product_image": "https://img.lazcdn.com/g/p/145cd2e3d159cd96615500cf446cc60e.jpg_200x200q90.jpg",
        "price": 2928,
        "remark": "https://www.lazada.co.th/products/pdp-i16132348750.html",
        "sold": 0
    },
    {
        "product_name": "Lepmerk อุปกรณ์รักษาคะแนนอิเล็กทรอนิกส์แบบสกอร์บอร์ดอิเล็กทรอนิกส์เฟรมอลูมิเนียมอัลลอยด์ตัวเลข4หลักจอแสดงผลสีแดงเขียวน้ำหนักเบาพกพาได้สำหรับฟุตบอล",
        "product_image": "https://img.lazcdn.com/g/p/33878e247a0f53d26157de115fa629d7.jpg_200x200q90.jpg",
        "price": 2908,
        "remark": "https://www.lazada.co.th/products/pdp-i16080331834.html",
        "sold": 0
    },
    {
        "product_name": "LELEYU | กล้องถ่ายรูปและวิดีโอของเล่นสำหรับเด็กผู้หญิง ลายสตอร์เบอร์รี่แบร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S958694b687374b52ace365030203e005V.png_200x200q90.png",
        "price": 2907.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16052738800.html",
        "sold": 0
    },
    {
        "product_name": "{skfjhw} LALAPLAY | High-Pixel Children's Camera for Birthday and Children's Day Gifts",
        "product_image": "https://img.lazcdn.com/g/p/d8a7f70f658205939e9c3890e4b48ba2.jpg_200x200q90.jpg",
        "price": 2906,
        "remark": "https://www.lazada.co.th/products/pdp-i16147494919.html",
        "sold": 0
    },
    {
        "product_name": "OLEVS | นาฬิกาผู้ชายสไตล์เมคคา อัตโนมัติ ควอทซ์ เครื่องอิเล็กทรอนิกส์ สายสแตนเลส กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfb2d855eb0154d96a612c7e16ca9d6d1F.jpg_200x200q90.jpg",
        "price": 2896.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5893746458.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องขว้างลูกเบสบอลอิเล็กทรอนิกส์ Mippos มีหกลูก EVA,ไม้เทนนิส,ค้างคาว",
        "product_image": "https://img.lazcdn.com/g/p/ee867a1c7cd6e6f50bdbb9cd66b2834e.jpg_200x200q90.jpg",
        "price": 2873.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16110215381.html",
        "sold": 0
    },
    {
        "product_name": "SONGDIAN | กล้องดิจิตอลรีโทรพกพาความละเอียดสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S233875637b1d40d0aef15a4066cc782bs.jpg_200x200q90.jpg",
        "price": 2858,
        "remark": "https://www.lazada.co.th/products/pdp-i6006106440.html",
        "sold": 0
    },
    {
        "product_name": "แผ่นรองเต้นดนตรีอิเล็กทรอนิกส์แบบมีไฟสำหรับเด็กหญิงเด็กชายอายุ7ปีขึ้นไปกันลื่นแผ่นรองเต้น",
        "product_image": "https://img.lazcdn.com/g/p/718e859bc3d8e585463a3f5473bfd8d5.jpg_200x200q90.jpg",
        "price": 1961.9,
        "remark": "https://www.lazada.co.th/products/pdp-i6055469702.html",
        "sold": 0
    },
    {
        "product_name": "MAQUCC | ของเล่นกล้องถ่ายรูปขนาดเล็ก ร่วมกับ Bebe Parrot",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6ee8eb605412495b93dfb3b3a9f3bdcfM.jpg_200x200q90.jpg",
        "price": 2834,
        "remark": "https://www.lazada.co.th/products/pdp-i16089438124.html",
        "sold": 0
    },
    {
        "product_name": "HONGMEITIANYI | กล้อง CCD คุณภาพสูงสำหรับเด็กหญิงอายุ 9-12 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0e33ac0fee154c978b5048901087fb9ds.jpg_200x200q90.jpg",
        "price": 2830.62,
        "remark": "https://www.lazada.co.th/products/pdp-i6003427141.html",
        "sold": 46
    },
    {
        "product_name": "Electronic Baitcasting Fishing Reel Led Screen USB and Solar Charging 7.2:1 Sea Saltwater Wheel",
        "product_image": "https://img.lazcdn.com/g/p/db039c8e680f4088fb7641345075a224.jpg_200x200q90.jpg",
        "price": 2612.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16093489634.html",
        "sold": 0
    },
    {
        "product_name": "Rockhouse การออกแบบหน้าจอ LED แบบพกพาอากาศ X4 Insta360ที่ชาร์จแบตเตอรี่ช่องคู่,ขายดีของมาใหม่",
        "product_image": "https://img.lazcdn.com/g/p/66828bcc73335560827acb58cb513b2a.jpg_200x200q90.jpg",
        "price": 2780,
        "remark": "https://www.lazada.co.th/products/pdp-i16147734214.html",
        "sold": 0
    },
    {
        "product_name": "หูฟังไร้สาย Havit TW916 หูฟัง True Wireless บลูทูธ 5.0 เชื่อมต่อรวดเร็วทันใจ แบตอึด พร้อมเคสสำหรับชาร์จในตัว หูฟังบลูทูธ หูฟัง havit ราคาถูก ของแท้100%",
        "product_image": "https://img.lazcdn.com/g/p/9d6f0aae2c9d99127da98fd24a7ddc79.jpg_200x200q90.jpg",
        "price": 2780,
        "remark": "https://www.lazada.co.th/products/pdp-i2315840884.html",
        "sold": 0
    },
    {
        "product_name": "Onefire | ไฟกลางคืนโปรเจ็กชันท้องฟ้าดาว พร้อมเพลงหมุนได้สำหรับห้องนอน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8f72aea5f2914252bc5031ade8be4b51P.jpg_200x200q90.jpg",
        "price": 2745.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5910813837.html",
        "sold": 99
    },
    {
        "product_name": "Children'S Digital Microscope for Kids Mini Microscope Camera with 2.4\" IPS Screen 1000x Zoom Portable New",
        "product_image": "https://img.lazcdn.com/g/p/f4f499abb800348b9b5401e7bc3955bd.jpg_200x200q90.jpg",
        "price": 2738,
        "remark": "https://www.lazada.co.th/products/pdp-i6068145348.html",
        "sold": 0
    },
    {
        "product_name": "Disney | กล้องดิจิตอลสำหรับเด็ก 10Y Girl",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7636aabc22bf4870b09d1b5ec87b6b02Q.png_200x200q90.png",
        "price": 2725.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6069764057.html",
        "sold": 2
    },
    {
        "product_name": "HONGMEITIANYI | กล้องดิจิตอลของขวัญนักเรียนสุดอบอุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se33408a2e79d421990b564d3d083b41dS.png_200x200q90.png",
        "price": 2698.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5909634699.html",
        "sold": 11
    },
    {
        "product_name": "Version SFR1M44-U100K USB Emulator Gray 3.5In 1.44MB USB SSD Floppy Drive Emulator for Electronic Keyboard for",
        "product_image": "https://img.lazcdn.com/g/p/094fe7cfc0b0bc2fa702bc6a95440bcb.jpg_200x200q90.jpg",
        "price": 1950,
        "remark": "https://www.lazada.co.th/products/pdp-i6035890678.html",
        "sold": 0
    },
    {
        "product_name": "พรมเต้นรำสำหรับเด็กผู้หญิง 3-6+ ของขวัญวันเกิด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0d0c82b748994765b47aaca7cefc3462x.jpg_200x200q90.jpg",
        "price": 2683.18,
        "remark": "https://www.lazada.co.th/products/pdp-i16050791820.html",
        "sold": 0
    },
    {
        "product_name": "OLEVS | นาฬิกาควอตซ์อิเล็กทรอนิกส์กันน้ำหรูหรา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7932a7e1bb1b4cdbaf81209f960b3b8f7.jpg_200x200q90.jpg",
        "price": 2682.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6005918393.html",
        "sold": 0
    },
    {
        "product_name": "กล้องถ่ายรูปทันทีแบบพิมพ์สีสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S29c6eb52685b49d59d1ec889dd4a1bb8x.jpg_200x200q90.jpg",
        "price": 2663.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16120271832.html",
        "sold": 0
    },
    {
        "product_name": "Goldenhour Brand Dual Display Movement Multi-functional Waterproof Outdoor Electronic Watch GH120 Men's Watch Sy",
        "product_image": "https://img.lazcdn.com/g/p/0059f86041673306459b1780c62cd9b5.jpg_200x200q90.jpg",
        "price": 2662,
        "remark": "https://www.lazada.co.th/products/pdp-i16146596051.html",
        "sold": 0
    },
    {
        "product_name": "หุ่นยนต์ของเล่น CCFine สำหรับเด็กโปรแกรมอัจฉริยะ LED สำหรับเด็กอายุ3 + ปี",
        "product_image": "https://img.lazcdn.com/g/p/254f18f19725fa3bd646dcdf0218e0d6.jpg_200x200q90.jpg",
        "price": 2644,
        "remark": "https://www.lazada.co.th/products/pdp-i5970117357.html",
        "sold": 0
    },
    {
        "product_name": "LELEYU | กล้องถ่ายรูปสำหรับเด็กความละเอียดสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S87fdfa92c54c424ab27aab8592495cfc4.png_200x200q90.png",
        "price": 2632.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16053124004.html",
        "sold": 0
    },
    {
        "product_name": "LIVING STONES | พรมเต้นรำดนตรีสำหรับเด็ก 2 คน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S95a39f142756432ca7c7597150e11e3f8.jpg_200x200q90.jpg",
        "price": 2623,
        "remark": "https://www.lazada.co.th/products/pdp-i16076578445.html",
        "sold": 0
    },
    {
        "product_name": "KIDDYCOLOR | กล้องดิจิตอลพกพาพร้อมปรินท์ทันทีความละเอียดสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S888f5aa7fae3406dbf91f5a82f6f93b4j.jpg_200x200q90.jpg",
        "price": 2606.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16049360629.html",
        "sold": 0
    },
    {
        "product_name": "LELEYU | กล้องถ่ายภาพและบันทึกวิดีโอสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdc502e6bb6ca4f568875f7ad9cf0dd76P.jpg_200x200q90.jpg",
        "price": 2606.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16052499434.html",
        "sold": 0
    },
    {
        "product_name": "สินค้าแท้ 100% Casio นาฬิกาข้อมือชุดแฟชั่นกีฬาG-SHOCKกันน้ำเรืองแสง A168WG-9 นักเรียนผู้ชายนาฬิกาอิเล็กทรอนิกส์ จัดส่งพร้อม",
        "product_image": "https://img.lazcdn.com/g/p/6adde60498db02a67d21e8f429e8d402.jpg_200x200q90.jpg",
        "price": 2598,
        "remark": "https://www.lazada.co.th/products/pdp-i5780250726.html",
        "sold": 0
    },
    {
        "product_name": "SKMEI นาฬิกาจับเวลาสำหรับผู้ชาย,Fashion Jam Tangan นาฬิกากันน้ำอิเล็กทรอนิกส์หน้าจอคู่มัลติฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/p/0b0bae005c1ef2a4092d3e9a2c6848a0.jpg_200x200q90.jpg",
        "price": 2598,
        "remark": "https://www.lazada.co.th/products/pdp-i16124015876.html",
        "sold": 0
    },
    {
        "product_name": "กล้องงูสำหรับเด็กพร้อมหน้าจอสายยางเบา2.4นิ้ว2MP ของเล่นวิทยาศาสตร์กล้องงู HD สำหรับการสำรวจกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/916fdb2293aae6a1b69546c8dbc6d36e.jpg_200x200q90.jpg",
        "price": 2592,
        "remark": "https://www.lazada.co.th/products/pdp-i16143716415.html",
        "sold": 0
    },
    {
        "product_name": "เลนส์กล้องดิจิตอล4K ด้านหน้าด้านหลังกล้องวีดีโอ50MP พร้อมขาตั้งสำหรับเด็กผู้ชายของขวัญวันเกิดเด็กผู้หญิงระบบป้องกันภาพสั่นไหวแบบอิเล็กทรอนิกส์",
        "product_image": "https://img.lazcdn.com/g/p/1c8d613f60a158c56bda4488a4f9ec2d.jpg_200x200q90.jpg",
        "price": 2588,
        "remark": "https://www.lazada.co.th/products/pdp-i6066706387.html",
        "sold": 0
    },
    {
        "product_name": "กล้องดิจิตอลของเล่น HD",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S843b5cb59d8b4db38597c33a3f79dbc9x.jpg_200x200q90.jpg",
        "price": 2573,
        "remark": "https://www.lazada.co.th/products/pdp-i16052409715.html",
        "sold": 0
    },
    {
        "product_name": "MLZH | กล้องจุลทรรศน์ DV ความละเอียดสูงสำหรับการศึกษา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7b74806e6a9940dbacaeb0c534917d57v.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i16092532045.html",
        "sold": 0
    },
    {
        "product_name": "HONGMEITIANYI | กล้องของเล่นธีม Zootopia สำหรับเด็กผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb25d6cecb5a545a0b8e53878161d0b5aR.png_200x200q90.png",
        "price": 2558.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5971764286.html",
        "sold": 24
    },
    {
        "product_name": "Skmei นาฬิกาข้อมือดิจิทัล มีไฟ LED 5 บาร์ นับถอยหลัง กันน้ํา แสดงปฏิทิน อิเล็กทรอนิกส์ แฟชั่นสําหรับผู้ชาย และผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/c323b6222ca719a700165af9402e3335.jpg_200x200q90.jpg",
        "price": 2558,
        "remark": "https://www.lazada.co.th/products/pdp-i16099032659.html",
        "sold": 0
    },
    {
        "product_name": "นาฬิกาข้อมือยูนิเซ็กส์ สปอร์ต ดิจิตอล อิเล็กทรอนิกส์ 2100 นาฬิกาฟังก์ชั่นครบครัน แสดงเวลาโลก หน้าปัดโลหะผสม LED ซีรีส์โอ๊ค",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb7a03aaca7bf4b74bfa912461d745a48V.jpg_200x200q90.jpg",
        "price": 2549.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6064762740.html",
        "sold": 0
    },
    {
        "product_name": "แผ่นรองเต้นวันเกิดแผ่นรองเต้นเพลงแบบพกพาสำหรับอายุ3ถึง10ปี",
        "product_image": "https://img.lazcdn.com/g/p/2ba1ebdce8d4dae1a266ca4cead21767.jpg_200x200q90.jpg",
        "price": 2530,
        "remark": "https://www.lazada.co.th/products/pdp-i6022167384.html",
        "sold": 0
    },
    {
        "product_name": "{skfjhw} Waterproof Remote-Controlled Camera Toy Dinosaur",
        "product_image": "https://img.lazcdn.com/g/p/fdfe79103cfc423e75d53e1f39d07b16.jpg_200x200q90.jpg",
        "price": 2526,
        "remark": "https://www.lazada.co.th/products/pdp-i16147067395.html",
        "sold": 0
    },
    {
        "product_name": "surepower | หุ่นยนต์เพื่อนอัจฉริยะ AI",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S31957fb5fd0044b7820c539c014d0939k.jpg_200x200q90.jpg",
        "price": 2520.46,
        "remark": "https://www.lazada.co.th/products/pdp-i5910863080.html",
        "sold": 151
    },
    {
        "product_name": "หูฟังบลูทูธสัมผัสอัจฉริยะ ไร้สาย ลดเสียงรบกวน แบตเตอรี่ใช้งานยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S75e26c36095d446eaf5d14f514f1592a2.jpg_200x200q90.jpg",
        "price": 2506,
        "remark": "https://www.lazada.co.th/products/pdp-i5938202375.html",
        "sold": 1
    },
    {
        "product_name": "กล้องดิจิตอล2.5K สำหรับเด็กวัยหัดเดิน28เฟรมขนาดหน้าจอ IPS 3.5นิ้วสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/6fa33d79ca12978a4d61457abb85ea00.jpg_200x200q90.jpg",
        "price": 2500,
        "remark": "https://www.lazada.co.th/products/pdp-i6033388032.html",
        "sold": 0
    },
    {
        "product_name": "หูฟัง KZ S2 1BA+1DD หูฟังบลูทูธ 5.0หูฟังเกมมิ่ง หูฟังไรสาย หูฟังบลูทูธไร้สาย หูฟังไร้สายแท้ ชุดหูฟังไร้สาย kz หูฟัง หูฟังไร้สาย หูฟังบลูทูธแท้",
        "product_image": "https://img.lazcdn.com/g/p/3ae67dd8a77edf8dc300fcedd25236f6.jpg_200x200q90.jpg",
        "price": 2498,
        "remark": "https://www.lazada.co.th/products/pdp-i1640882542.html",
        "sold": 0
    },
    {
        "product_name": "KELAJI | กล้องดิจิตอลพิมพ์ทันทีสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S61abcdffa7694585b526c84fe9d6c95ed.jpg_200x200q90.jpg",
        "price": 2484.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16113013748.html",
        "sold": 0
    },
    {
        "product_name": "beiens | กล้องสำหรับเด็ก HD ถ่ายภาพและวิดีโอ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sed49a9e510c943af91963851fbb8ea9ew.jpg_200x200q90.jpg",
        "price": 2484.28,
        "remark": "https://www.lazada.co.th/products/pdp-i16049108603.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องอุปกรณ์ฝึกชกมวยมวยอิเล็กทรอนิกส์ Ellwewe สำหรับเด็กออกกำลังกายเทควันโดกีฬา Sanda ใช้ในยิมที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/p/a98ca603806d0ede35815cd794f15138.jpg_200x200q90.jpg",
        "price": 2480,
        "remark": "https://www.lazada.co.th/products/pdp-i16137708800.html",
        "sold": 0
    },
    {
        "product_name": "Disney | นาฬิกาข้อมือกลไกอิเล็กทรอนิกส์สำหรับผู้ชาย เอดิชั่นใหม่ 2025",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9fcc605582104ce89be5db9771d0a963N.jpg_200x200q90.jpg",
        "price": 2456.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5880002621.html",
        "sold": 154
    },
    {
        "product_name": "กล้องถ่ายรูปพิมพ์สีสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5979b7fae0b54aefb50f13eeb70d50f7t.jpg_200x200q90.jpg",
        "price": 2456,
        "remark": "https://www.lazada.co.th/products/pdp-i5996833851.html",
        "sold": 5
    },
    {
        "product_name": "เครื่องซ้อมมวยอัจฉริยะ BT เป้าต่อยมวยอิเล็กทรอนิกส์มี9โหมดตีแทร็คจับคู่ตีเกมต่อยเสียงสเตอริโอสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/b06124081cf2548aab8733f2bc70cdc9.jpg_200x200q90.jpg",
        "price": 2450,
        "remark": "https://www.lazada.co.th/products/pdp-i16045551853.html",
        "sold": 0
    },
    {
        "product_name": "OLEVS | นาฬิกาควอทซ์อิเล็กทรอนิกส์หรูหรา กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S08aabb62bcd64bb9829cc155fb6e01f9q.jpg_200x200q90.jpg",
        "price": 2440,
        "remark": "https://www.lazada.co.th/products/pdp-i5880014589.html",
        "sold": 24
    },
    {
        "product_name": "ของเล่นหุ่นยนต์เดินควบคุมด้วยรีโมทอัจฉริยะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saeff38ab55e44eb1a8bad2088c18f109q.jpg_200x200q90.jpg",
        "price": 2434,
        "remark": "https://www.lazada.co.th/products/pdp-i16080635908.html",
        "sold": 0
    },
    {
        "product_name": "นาฬิกาของเล่นดิจิตอลสำหรับเด็กผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S79151a3fe77e4fc1bb6593fcfa4f78c4g.jpg_200x200q90.jpg",
        "price": 2428.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16052667199.html",
        "sold": 0
    },
    {
        "product_name": "นาฬิกาผู้ชายแถบซิลิโคน Jam Tangan Elektronik 5ATM กันน้ำ: หน้าจอดิจิตอลนาฬิกาปลุกเคสทำจากวัสดุ PC จอแสดงผล LED นาฬิกากีฬาสแตนเลสผู้ชายแบบอเนกประสงค์ยอดนิยมของขวัญวันเกิดครบรอบวันวาเลนไทน์วันเกิด",
        "product_image": "https://img.lazcdn.com/g/p/371613fb96968ba7112ccc4c06b5d9bb.png_200x200q90.png",
        "price": 2426,
        "remark": "https://www.lazada.co.th/products/pdp-i6036976776.html",
        "sold": 0
    },
    {
        "product_name": "ไร้สายมินิกลางแจ้งวิดีโออินเตอร์คอมสำหรับผู้ปกครองเด็กสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/b739bedabc814704a292d5ceb05d39d0.jpg_200x200q90.jpg",
        "price": 2420,
        "remark": "https://www.lazada.co.th/products/pdp-i16146720949.html",
        "sold": 0
    },
    {
        "product_name": "OPPO Enco Air 4บลูทูธหูฟัง5.4ตัดเสียงรบกวนแบบแอกทีฟอายุการใช้งานแบตเตอรี่43ชั่วโมงหูฟัง True Wireless",
        "product_image": "https://img.lazcdn.com/g/p/e3b462e305b1f137799c3765d361f24a.jpg_200x200q90.jpg",
        "price": 2410.42,
        "remark": "https://www.lazada.co.th/products/pdp-i3994678819.html",
        "sold": 19
    },
    {
        "product_name": "กล้องจุลทรรศน์ดิจิทัลมือถือ Bewinner แว่นขยายโฟกัสอัตโนมัติสำหรับเด็ก,1080P HD พร้อมการขยาย200x และการซูมดิจิตอล5X กล้องจุลทรรศน์ขนาดเล็ก1.5นิ้วกล้องหลังสำหรับเด็กผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/540b9596512d25eb5aaaf5fe0f60d7fc.jpg_200x200q90.jpg",
        "price": 2410,
        "remark": "https://www.lazada.co.th/products/pdp-i16046820955.html",
        "sold": 0
    },
    {
        "product_name": "Disney | กล้องดิจิตอลสำหรับเด็ก ของขวัญสำหรับนักเรียนและเด็ก ขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4187509e50314cfdadf148892413a8b9e.png_200x200q90.png",
        "price": 2405.82,
        "remark": "https://www.lazada.co.th/products/pdp-i6003440099.html",
        "sold": 4
    },
    {
        "product_name": "หูฟังบลูทูธสัมผัสหน้าจอ ลดเสียงรบกวน คุณภาพเสียงสูง แบตเตอรี่ใช้งานยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8e21c96c379e46d7b4aa398408dd69e73.jpg_200x200q90.jpg",
        "price": 2404,
        "remark": "https://www.lazada.co.th/products/pdp-i16141027222.html",
        "sold": 0
    },
    {
        "product_name": "Disney | กล้องดิจิตอล CCD สำหรับเด็ก 2026 เวอร์ชันใหม่ ของขวัญวันเกิดสำหรับเด็กผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sba641c8a98ad4db4a46eb96d73ebd19bz.png_200x200q90.png",
        "price": 2395.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5955236288.html",
        "sold": 6
    },
    {
        "product_name": "HONGMEITIANYI | หุ่นยนต์สนทนาอัจฉริยะขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S41f0dc6cbd67409fa07d9266b049d712o.jpg_200x200q90.jpg",
        "price": 2385.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5905793720.html",
        "sold": 59
    },
    {
        "product_name": "surepower | กล้องเล่นของเด็กผู้หญิง ของขวัญสำหรับอายุ 10-12 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3ede32efc3e048b388db68e49da93401H.jpg_200x200q90.jpg",
        "price": 2381.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5910850001.html",
        "sold": 140
    },
    {
        "product_name": "UGREEN EchoBuds Magic Hi-Res Bluetooth Earphones ANC Active Noise Cancelling 52dB Touch Screen Wireless In-Ear Sports Suitable for iPhone 17 16 Pro Max Model:55137",
        "product_image": "https://img.lazcdn.com/g/p/97f7712aaa5525a7e4e98b52758a6117.jpg_200x200q90.jpg",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i5566870066.html",
        "sold": 262
    },
    {
        "product_name": "MANTUOLUO | กล้องของขวัญวันเกิดสำหรับเด็กหญิงอายุ 10 ปี ดีไซน์ HelloKitty KUROMI",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S76812685bf304a2dba86e4c7bc3de7bcO.jpg_200x200q90.jpg",
        "price": 2364.66,
        "remark": "https://www.lazada.co.th/products/pdp-i16084659355.html",
        "sold": 0
    },
    {
        "product_name": "KIDDYCOLOR | ของเล่นกล้องดิจิตอลพิมพ์ได้สำหรับเด็กอายุ 3 ปี ขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S836083bdd56a4bb38586cf6c2807ffbed.jpg_200x200q90.jpg",
        "price": 2363.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16049420238.html",
        "sold": 0
    },
    {
        "product_name": "GARRYFIZH 4 K/30FPS กล้องดิจิตอล 64MP กล้องวิดีโอดิจิตอลหน้าจอ 2.4 นิ้ว 18X ซูมดิจิตอลแบตเตอรี่ในตัวสำหรับวัยรุ่นนักเรียนเพื่อน",
        "product_image": "https://img.lazcdn.com/g/p/a1e2dc3d9ad88bbd6c09d4c64d2f480b.jpg_200x200q90.jpg",
        "price": 2358,
        "remark": "https://www.lazada.co.th/products/pdp-i6034646236.html",
        "sold": 0
    },
    {
        "product_name": "กล้องของเล่นอัจฉริยะยูนิคอร์นสำหรับเด็ก - ของขวัญปริศนาบันทึกภาพ HD 24MP",
        "product_image": "https://img.lazcdn.com/g/p/97098ed63e5ae6cfc6152e172bc816a8.jpg_200x200q90.jpg",
        "price": 2352,
        "remark": "https://www.lazada.co.th/products/pdp-i16146237557.html",
        "sold": 0
    },
    {
        "product_name": "HONGMEITIANYI | กล้องดิจิตอลสำหรับเด็กผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9030bccb326c48639d6512e8e195b6c50.png_200x200q90.png",
        "price": 2348.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5992572741.html",
        "sold": 11
    },
    {
        "product_name": "LIVING STONES | กล้องถ่ายรูปทันทีสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S15dca482344f4d5eb80e46e81550486fO.png_200x200q90.png",
        "price": 2348.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16082179610.html",
        "sold": 0
    },
    {
        "product_name": "HONGMEITIANYI | กล้องดิจิตอล CCD ความละเอียดสูงสำหรับถ่ายภาพและบันทึกวิดีโอเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0d17312d79ae485dab77e042b218c14da.png_200x200q90.png",
        "price": 2331.82,
        "remark": "https://www.lazada.co.th/products/pdp-i6012780563.html",
        "sold": 2
    },
    {
        "product_name": "Logitech G213 PRODIGY RGB GAMING KEYBOARD ( คีย์บอร์ดเกมมิ่งแมคคานิคอล พร้อมปุ่มควบคุมสื่อ ไฟ RGB แป้นพิมพ์ไทย / อังกฤษ)",
        "product_image": "https://img.lazcdn.com/g/p/8bce8f24c03ccc1203576f341ccea68a.jpg_200x200q90.jpg",
        "price": 2320,
        "remark": "https://www.lazada.co.th/products/pdp-i1244996324.html",
        "sold": 1167
    },
    {
        "product_name": "ไลฟ์กลอนของเล่นไดโนเสาร์ Mainan Remote Control ไดโนเสาร์กลไฟ LED ไฟหน้าแบบประกอบของเล่นสำหรับเด็กหญิงเด็กชาย",
        "product_image": "https://img.lazcdn.com/g/p/1513ced5042270d1788bfc82b2638230.jpg_200x200q90.jpg",
        "price": 2312,
        "remark": "https://www.lazada.co.th/products/pdp-i16094672677.html",
        "sold": 0
    },
    {
        "product_name": "Goldenhour Watch Authentic Fashion Sports Multifunctional Electronic Watch Popular Men's Waterproof Sy",
        "product_image": "https://img.lazcdn.com/g/p/a63c640e159fba8f73d98e3e592f36ed.jpg_200x200q90.jpg",
        "price": 2310,
        "remark": "https://www.lazada.co.th/products/pdp-i16146111051.html",
        "sold": 0
    },
    {
        "product_name": "หูฟังไร้สายแบบหน้าจอสัมผัส - หูฟังตัดเสียงรบกวนแบบแอคทีฟ (ANC) พร้อมหน้าจอสัมผัสอัจฉริยะ - หูฟังพร้อมเคสชาร์จไร้สาย หน้าจอ LED เสียงเบสหนักแน่น หูฟังพร้อมระบบเสียงในตัว (สีดำ)",
        "product_image": "https://img.lazcdn.com/g/p/30d0b40f3aa331c0952bd42588186c36.jpg_webp_200x200q90.jpg",
        "price": 2292,
        "remark": "https://www.lazada.co.th/products/pdp-i16080970863.html",
        "sold": 0
    },
    {
        "product_name": "พรมเต้นรำดนตรีสำหรับเด็กอายุ 3-6 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3f7fed97208c4b6992b30ffcc2612ce0i.jpg_200x200q90.jpg",
        "price": 2274,
        "remark": "https://www.lazada.co.th/products/pdp-i16120285870.html",
        "sold": 0
    },
    {
        "product_name": "[VET Store] Exclusive2X Electronic Altimeter Carabiner Altimeter Handheld Thermometer Outdoor Fishing Weather Forecast Mode Meter Gadget",
        "product_image": "https://img.lazcdn.com/g/p/bb959f63f07dffc9b4c1388de6fcdb24.jpg_200x200q90.jpg",
        "price": 2254,
        "remark": "https://www.lazada.co.th/products/pdp-i16111404061.html",
        "sold": 0
    },
    {
        "product_name": "[ Store] Exclusive2X Electronic Altimeter Carabiner Altimeter Handheld Thermometer Outdoor Fishing Weather Forecast Mode Meter Gadget",
        "product_image": "https://img.lazcdn.com/g/p/bb959f63f07dffc9b4c1388de6fcdb24.jpg_200x200q90.jpg",
        "price": 2254,
        "remark": "https://www.lazada.co.th/products/pdp-i16068561632.html",
        "sold": 0
    },
    {
        "product_name": "ชุดหูฟังบลูทูธพร้อมไมโครโฟนบูม, หูฟังแบบเปิดหู, หูฟังบลูทูธ 5.4 เชื่อมต่อคู่พร้อมระบบตัดเสียงรบกวนและปิดเสียง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se67944ccf9b544cc802d8b703b2feae9E.jpg_200x200q90.jpg",
        "price": 2250.54,
        "remark": "https://www.lazada.co.th/products/pdp-i5981201747.html",
        "sold": 0
    },
    {
        "product_name": "SHENMISHAONIAN | พรมเต้นรำแบบมีปฏิสัมพันธ์สำหรับเด็กผู้หญิงเพื่อออกกำลังกายที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3c7c5e7fa0114a7f94b793ad650a8513n.jpg_200x200q90.jpg",
        "price": 2249.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16052433093.html",
        "sold": 0
    },
    {
        "product_name": "【ไทยสปอตผ】หูฟังรุ่นใหม่ล่าสุด TWS Bluetooth V5.0 Earbuds IPX7 หูฟังคู่แบบสัมผัสพร้อมกล่องชารจ์ บลูทูธ 2 ข้าง Hd Sport Waterproof True Wireless Earbuds with Charging box for Apple Android",
        "product_image": "https://img.lazcdn.com/g/p/8c6c5f4b342074460ade2d74f1a5cc35.jpg_200x200q90.jpg",
        "price": 2236,
        "remark": "https://www.lazada.co.th/products/pdp-i4095382474.html",
        "sold": 0
    },
    {
        "product_name": "JIHU | กล้องดิจิตอลสำหรับเด็กใช้ทันที",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1b89cec8fad648a6be0268bf49f9242be.png_200x200q90.png",
        "price": 2227.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16049125106.html",
        "sold": 0
    },
    {
        "product_name": "[ส่งฟรี] Orsen EW55 E43 20000mAh 25000mAh แบตสำรอง ไร้สาย ชาร์จเร็ว PowerBank Wireless Charge พาวเวอร์แบงค์ Eloop ของแท้ PD 20W 45W Type C เพาเวอร์แบงค์ Fast Charge",
        "product_image": "https://img.lazcdn.com/g/p/d7f48a6e223d063678fc580b7e50ac22.png_200x200q90.png",
        "price": 2220,
        "remark": "https://www.lazada.co.th/products/pdp-i4626153770.html",
        "sold": 33
    },
    {
        "product_name": "SHENMISHAONIAN | พรมเต้นรำพร้อมเสียงสเตอริโอและไฟสำหรับเด็กผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S20d1d77dd12d4a309e0d38daafc64b8fz.jpg_200x200q90.jpg",
        "price": 2208.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16052772643.html",
        "sold": 0
    },
    {
        "product_name": "[ Store] ExclusiveVersion SFR1M44-U100K USB Emulator Gray 3.5In 1.44MB USB SSD Floppy Drive Emulator for Electronic Keyboard for",
        "product_image": "https://img.lazcdn.com/g/p/9f30597672c41c4d3eeb197a014d5942.jpg_200x200q90.jpg",
        "price": 2206,
        "remark": "https://www.lazada.co.th/products/pdp-i16089538040.html",
        "sold": 0
    },
    {
        "product_name": "[RNM Store] ExclusiveVersion SFR1M44-U100K USB Emulator Gray 3.5In 1.44MB USB SSD Floppy Drive Emulator for Electronic Keyboard for",
        "product_image": "https://img.lazcdn.com/g/p/0fa9d37a0066dee0dbabcb4315a1f135.jpg_200x200q90.jpg",
        "price": 2206,
        "remark": "https://www.lazada.co.th/products/pdp-i16074955907.html",
        "sold": 0
    },
    {
        "product_name": "[IHN Store] ExclusiveVersion SFR1M44-U100K USB Emulator Gray 3.5In 1.44MB USB SSD Floppy Drive Emulator for Electronic Keyboard for",
        "product_image": "https://img.lazcdn.com/g/p/b529ca84eeaa77945dc55920d51fafbf.jpg_200x200q90.jpg",
        "price": 2206,
        "remark": "https://www.lazada.co.th/products/pdp-i6073623217.html",
        "sold": 0
    },
    {
        "product_name": "นาฬิกากันน้ำสำหรับกีฬานักเรียนจอแสดงผลคู่ Snoopy887 Jam Tangan Elektronik นาฬิกาแฟชั่นสไตล์เท่ๆมัธยมต้น",
        "product_image": "https://img.lazcdn.com/g/p/404d6c61c1495db0ace11c607b08760f.jpg_200x200q90.jpg",
        "price": 2186,
        "remark": "https://www.lazada.co.th/products/pdp-i4915605487.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องเล่น MP4 MP3สำหรับเด็กโทรศัพท์มือถือของเล่นสำหรับเด็กถ่ายรูป48ม. ของเล่นโทรศัพท์มือถือเด็กมัลติฟังก์ชั่นน่าสนใจพร้อมกล้องสำหรับเด็กผู้ชายและเด็กผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/79fda69f59ae9746aa4c5c88fe457954.jpg_200x200q90.jpg",
        "price": 2184,
        "remark": "https://www.lazada.co.th/products/pdp-i6043897177.html",
        "sold": 0
    },
    {
        "product_name": "LIVING STONES | กล้องถ่ายรูปสีพิมพ์ทันทีใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scd34fc1dcf044066ac4f6d34f39065e8e.png_200x200q90.png",
        "price": 2182.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16082195697.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องเป้าหมายการเจาะเพลงอัจฉริยะแบบติดผนังโหมดสนุก5ระดับบลูทูธอิเล็กทรอนิกส์พร้อมไฟ LED สำหรับบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/a4aa3da425f5e2052985aef5a2ecd53c.jpg_200x200q90.jpg",
        "price": 2172,
        "remark": "https://www.lazada.co.th/products/pdp-i6068352274.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องซ้อมดนตรีแบบ Kodaily เครื่องออกกำลังกายตามเป้าหมายจังหวะนวมเครื่องออกกำลังกายแบบเป้าต่อยมวยอิเล็กทรอนิกส์สำหรับยิมวัยรุ่นเด็กๆ",
        "product_image": "https://img.lazcdn.com/g/p/c54d6d52fbad9236692ec477b7aae9a7.jpg_200x200q90.jpg",
        "price": 2160,
        "remark": "https://www.lazada.co.th/products/pdp-i5963792804.html",
        "sold": 0
    },
    {
        "product_name": "Andoer Andoer 4K กล้องวิดีโอดิจิตอล 48MP กล้องวิดีโอดิจิตอล 2.4 นิ้วหน้าจอ 16X ซูมดิจิตอล Anti-Shake การตรวจจับใบหน้าเอฟเฟกต์ความงามการตรวจจับการเคลื่อนไหวแบตเตอรี่แฟลชในตัว",
        "product_image": "https://img.lazcdn.com/g/p/7f1332f5c3ae0729bcc6fa9de4260c3a.jpg_200x200q90.jpg",
        "price": 2150,
        "remark": "https://www.lazada.co.th/products/pdp-i16146639548.html",
        "sold": 0
    },
    {
        "product_name": "MUHONGYU | ทุ่นปลาไฟสว่างเวลากลางคืน CR425",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdf553cd6ae154105adbc5e1e1bc82c63a.png_200x200q90.png",
        "price": 2146.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16097888191.html",
        "sold": 2
    },
    {
        "product_name": "Lan Lantern Buddha'S Front Lamp Battery Power Supply for Buddha Electronic Lamp",
        "product_image": "https://img.lazcdn.com/g/p/783697648f44de219e9b34b454bf69dc.jpg_200x200q90.jpg",
        "price": 2144,
        "remark": "https://www.lazada.co.th/products/pdp-i16068714581.html",
        "sold": 0
    },
    {
        "product_name": "CRAYON SHINCHAN | กล้องของขวัญนักเรียนสไตล์รีโทร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa25c41f876514c0cb16baaaa577724929.jpg_200x200q90.jpg",
        "price": 2138,
        "remark": "https://www.lazada.co.th/products/pdp-i6006080914.html",
        "sold": 0
    },
    {
        "product_name": "Kids Printing Camera - กล้องมินิโพลารอยด์ของเล่นดิจิทัลสำหรับนักเรียน",
        "product_image": "https://img.lazcdn.com/g/p/e9ce2a6c7dc1ab81160b2744b7cf67bd.jpg_200x200q90.jpg",
        "price": 2126,
        "remark": "https://www.lazada.co.th/products/pdp-i16146804012.html",
        "sold": 0
    },
    {
        "product_name": "RUANFU | ไฟกลางคืนแบบลอยน้ำอิเล็กทรอนิกส์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdf553cd6ae154105adbc5e1e1bc82c63a.png_200x200q90.png",
        "price": 2121.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16097589303.html",
        "sold": 0
    },
    {
        "product_name": "MANTUOLUO | ของขวัญวันเกิดเด็ก กล้องถ่ายรูปของเล่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6b34c6c421f24d5ca0d1dfe2b1d100d6u.jpg_200x200q90.jpg",
        "price": 2114.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16074663936.html",
        "sold": 0
    },
    {
        "product_name": "KIDDYCOLOR | กล้องดิจิตอลสำหรับเด็กพร้อมปริ้นทันที",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S28b117746f40498c871dc43e96f2db91b.jpg_200x200q90.jpg",
        "price": 2105.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16049436545.html",
        "sold": 0
    },
    {
        "product_name": "(LACC) 2X Electronic Altimeter Carabiner Altimeter Handheld Thermometer Outdoor Fishing Weather Forecast Mode Meter Gadget",
        "product_image": "https://img.lazcdn.com/g/p/ccf661dcd290be531f43935d72074ab1.jpg_200x200q90.jpg",
        "price": 2100,
        "remark": "https://www.lazada.co.th/products/pdp-i16132543075.html",
        "sold": 0
    },
    {
        "product_name": "กล้องพิมพ์หัดเดินแบบพกพากล้องพิมพ์48MP สำหรับการเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/ef20f049dff9be9798e7f2e58ec77a80.jpg_200x200q90.jpg",
        "price": 2096,
        "remark": "https://www.lazada.co.th/products/pdp-i16113924626.html",
        "sold": 0
    },
    {
        "product_name": "หูฟังไร้สาย realme Buds T200 บลูทูธ 5.4 ตัดเสียงรบกวน 32dB หูฟัง TWS สำหรับเล่นเกมและฟังเพลง แบตเตอรี่ 530mAh ใช้งานได้นาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S805251ff74e6403480a080436a16b8b4d.jpg_200x200q90.jpg",
        "price": 2096,
        "remark": "https://www.lazada.co.th/products/pdp-i5980284470.html",
        "sold": 0
    },
    {
        "product_name": "แผ่นรองเต้นหัวลูกศรไฟฟ้าพับได้ปรับได้ปลอดภัยสำหรับบ้านของเด็กไฟแผ่นรองเต้น",
        "product_image": "https://img.lazcdn.com/g/p/b3caf9dc147ec25e85a142aee44f8967.jpg_200x200q90.jpg",
        "price": 2088,
        "remark": "https://www.lazada.co.th/products/pdp-i6040897480.html",
        "sold": 0
    },
    {
        "product_name": "กล้องซีซีดีย้อนยุค1080P หน้าจอขนาดเล็กกล้องถ่ายรูปเด็กกล้องดิจิตอลขนาดเล็กวินเทจ",
        "product_image": "https://img.lazcdn.com/g/p/9022ac311fe0c070783a617b20165f27.jpg_200x200q90.jpg",
        "price": 2072,
        "remark": "https://www.lazada.co.th/products/pdp-i6066442059.html",
        "sold": 0
    },
    {
        "product_name": "Onefire | ไฟกลางคืนโปรเจคดาวบนท้องฟ้าสำหรับห้องนอน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sae9acedee61943e69c076c0aa356c5c4W.jpg_200x200q90.jpg",
        "price": 2083.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5910853279.html",
        "sold": 41
    },
    {
        "product_name": "กล้องถ่ายภาพสัตว์ป่า เกม กล้อง ABS Trail ทนอุณหภูมิ 16M เพื่อความปลอดภัยภายในบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/9985ec7dd2c70e1ffd2203a3aea4a66f.jpg_200x200q90.jpg",
        "price": 2078,
        "remark": "https://www.lazada.co.th/products/pdp-i6068159663.html",
        "sold": 0
    },
    {
        "product_name": "LINSHENBUZHICHU | ของเล่นโทรศัพท์เรียนรู้สำหรับเด็กเล็ก พร้อมฟังก์ชันถ่ายรูปและวิดีโอ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3008e6af3e0042099638e4cf22f8a2c2V.jpg_200x200q90.jpg",
        "price": 2074,
        "remark": "https://www.lazada.co.th/products/pdp-i16120675274.html",
        "sold": 0
    },
    {
        "product_name": "LIVING STONES | เครื่องพิมพ์รูปและกล้องสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9467d9f9f1fa415e9c9222243c8e4f1eP.jpg_200x200q90.jpg",
        "price": 2058,
        "remark": "https://www.lazada.co.th/products/pdp-i5996920581.html",
        "sold": 0
    },
    {
        "product_name": "[pokjew]Wireless Earbuds Sport Bluetooth 5.3 Headphones with HD ENC Noise Cancelling Mic, in Ear Headsets",
        "product_image": "https://img.lazcdn.com/g/p/32df58a772c28d1278de2babf03a2c99.jpg_200x200q90.jpg",
        "price": 2056,
        "remark": "https://www.lazada.co.th/products/pdp-i16075167494.html",
        "sold": 0
    },
    {
        "product_name": "Xidanyinxiang | กล้องดิสนีย์ระดับไฮเอนด์สำหรับเด็กผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8d92619664e64860ba1067bad8d7cc50Q.png_200x200q90.png",
        "price": 2050.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5933141111.html",
        "sold": 34
    },
    {
        "product_name": "เครื่องค้นหาขอบแบบอิเล็กทรอนิกส์ใช้งานง่ายวัสดุชั้นดีดีสำหรับบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/e8b0848638890fb71572c9615e21ab9d.jpg_200x200q90.jpg",
        "price": 2046.26,
        "remark": "https://www.lazada.co.th/products/pdp-i6066644892.html",
        "sold": 0
    },
    {
        "product_name": "Disney | กล้องดิจิตอลสำหรับเด็ก เพื่อเป็นของขวัญ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S17df7cf2e38f4cb69a3ffa49f27bb98c6.png_200x200q90.png",
        "price": 2037.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5968514661.html",
        "sold": 5
    },
    {
        "product_name": "COONOR 3860 ABS นาฬิกาจับเวลากีฬามัลติฟังก์ชั่น,นาฬิกาจับเวลานับถอยหลังเดินป่าและออกสนามอิเล็กทรอนิกส์",
        "product_image": "https://img.lazcdn.com/g/p/9b059fce52488986576a33cbcf45720e.jpg_200x200q90.jpg",
        "price": 2036,
        "remark": "https://www.lazada.co.th/products/pdp-i16080809020.html",
        "sold": 0
    },
    {
        "product_name": "หุ่นยนต์ลำโพงอัจฉริยะ AI",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0688a516f08a4d12808bd7bb64e360e8Y.jpg_200x200q90.jpg",
        "price": 2034.38,
        "remark": "https://www.lazada.co.th/products/pdp-i6066523543.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO นาฬิกาจับเวลาตัวจับเวลาแบบมืออาชีพสำหรับวิ่งนาฬิกาจับเวลากีฬาอิเล็กทรอนิกส์2แถว30 60ช่องมัลติฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/p/2e9a0f6c1f474a30ec92cd4fd1ed1a84.jpg_200x200q90.jpg",
        "price": 2022,
        "remark": "https://www.lazada.co.th/products/pdp-i16146442516.html",
        "sold": 0
    },
    {
        "product_name": "【Huang Li Electronics】Version SFR1M44-U100K USB Emulator Gray 3.5In 1.44MB USB SSD Floppy Drive Emulator for Electronic Keyboard for",
        "product_image": "https://img.lazcdn.com/g/p/0fa9d37a0066dee0dbabcb4315a1f135.jpg_200x200q90.jpg",
        "price": 2014,
        "remark": "https://www.lazada.co.th/products/pdp-i16089618117.html",
        "sold": 0
    },
    {
        "product_name": "【msaiqwsa】Version SFR1M44-U100K USB Emulator Gray 3.5In 1.44MB USB SSD Floppy Drive Emulator for Electronic Keyboard for",
        "product_image": "https://img.lazcdn.com/g/p/9f30597672c41c4d3eeb197a014d5942.jpg_200x200q90.jpg",
        "price": 2014,
        "remark": "https://www.lazada.co.th/products/pdp-i16092508648.html",
        "sold": 0
    },
    {
        "product_name": "HONGMEITIANYI | กล้องถ่ายภาพและวิดีโอสำหรับผู้หญิง รุ่นใหม่ 2026",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa9b09b91201948ecba9e14d26a207f09z.png_200x200q90.png",
        "price": 2013.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5960820250.html",
        "sold": 41
    },
    {
        "product_name": "COJR | นาฬิกากีฬาภายนอกหลายฟังก์ชันกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2652a0df9c8747f5b9b67d5c696bcf3eA.jpg_200x200q90.jpg",
        "price": 2011.72,
        "remark": "https://www.lazada.co.th/products/pdp-i5996901039.html",
        "sold": 3
    },
    {
        "product_name": "SKMEI สายรัดเหล็กกล้าไร้สนิมสไตล์วินเทจสำหรับผู้ชายและผู้หญิง,กันน้ำแนวธุรกิจจับเวลา Jam Tangan Elektronik หน้าจอคู่2632",
        "product_image": "https://img.lazcdn.com/g/p/5232027683ebf7ea6a27e0ceafbd24a9.jpg_200x200q90.jpg",
        "price": 1892.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16124407392.html",
        "sold": 0
    },
    {
        "product_name": "หูฟังไร้สาย, หูฟังบลูทูธ 5.3 รุ่นใหม่ปี 2023 น้ำหนักเบาพิเศษสำหรับกีฬา พร้อมหน้าจอ LED, ไมโครโฟนในตัว, หูฟังกันน้ำระดับ IPX7 พร้อมที่เกี่ยวหูสำหรับออกกำลังกายในยิม (สีดำ)",
        "product_image": "https://img.lazcdn.com/g/p/f6d437b3ad434f3601db1d8d395de682.jpg_200x200q90.jpg",
        "price": 1984,
        "remark": "https://www.lazada.co.th/products/pdp-i16075534730.html",
        "sold": 0
    },
    {
        "product_name": "huiwaa | กล้องสำหรับเด็ก ถ่ายรูปและวิดีโอทันที",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sed47b2741bc14bf9a2569e48459f43bem.jpg_200x200q90.jpg",
        "price": 1978,
        "remark": "https://www.lazada.co.th/products/pdp-i16089430130.html",
        "sold": 0
    },
    {
        "product_name": "A1100D ชุดนาฬิกาอิเล็กทรอนิกส์ดิจิตอลย้อนยุคใหม่นาฬิกาคู่รักเพื่อส่งพร้อมการรับประกันรุ่น A1100D-1 A1100G-5",
        "product_image": "https://img.lazcdn.com/g/p/65ae30c3f0c226a5c525d9157ed60093.jpg_200x200q90.jpg",
        "price": 1976.62,
        "remark": "https://www.lazada.co.th/products/pdp-i6022217903.html",
        "sold": 3
    },
    {
        "product_name": "นาฬิกาควอตซ์อิเล็กทรอนิกส์สำหรับผู้ชายซิลิโคนดิจิตอล: 3ATM นาฬิกา LED แนวทหารกันน้ำสายรัดยางมีสไตล์ลำลองเครื่องประดับผู้ชายแฟชั่น-วันเกิดครบรอบวันคริสต์มาสวันวาเลนไทน์แฟนของขวัญ",
        "product_image": "https://img.lazcdn.com/g/p/f98282145816f88f9111e0d60b5a1cb4.png_200x200q90.png",
        "price": 1970,
        "remark": "https://www.lazada.co.th/products/pdp-i6037016475.html",
        "sold": 0
    },
    {
        "product_name": "กล้องถ่ายรูปพริ้นท์ทันทีความละเอียดสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S57ad287d63754df9bfba0818ab0e14ae2.jpg_200x200q90.jpg",
        "price": 1964,
        "remark": "https://www.lazada.co.th/products/pdp-i16089091858.html",
        "sold": 0
    },
    {
        "product_name": "JIHU | กล้องดิจิตอลพิมพ์ทันทีของเล่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seca84be8f3d3485ea648a96f1cce01fco.jpg_200x200q90.jpg",
        "price": 1960.28,
        "remark": "https://www.lazada.co.th/products/pdp-i16049296214.html",
        "sold": 0
    },
    {
        "product_name": "surepower | ของขวัญวันเกิด กล้องถ่ายรูปของเล่นสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9cf8f6ea97ad4af0a78bab47c792abd28.jpg_200x200q90.jpg",
        "price": 1959.66,
        "remark": "https://www.lazada.co.th/products/pdp-i5910770735.html",
        "sold": 21
    },
    {
        "product_name": "Onefire | โปรเจคเตอร์แสงดาวท้องฟ้าออโรร่า โบเรลิส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sef40ea1e0251406c8dfd4b16a79d9801k.jpg_200x200q90.jpg",
        "price": 1957.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5910803538.html",
        "sold": 25
    },
    {
        "product_name": "Disney | นาฬิกาสำหรับนักเรียนดูเวลาสอบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S139f762d91824c2884149506c8367c0cR.jpg_200x200q90.jpg",
        "price": 1954.52,
        "remark": "https://www.lazada.co.th/products/pdp-i6017924972.html",
        "sold": 6
    },
    {
        "product_name": "หูฟังหูช่องบลูทูธไร้สาย TUNE 220TWS (T220 TWS) เสียงสเตอริโอบเบสหนัก มีกล่องชาร์จ รองรับการ",
        "product_image": "https://img.lazcdn.com/g/p/73e71aead1e88034dd6d033bae53050b.jpg_webp_200x200q90.jpg",
        "price": 1952.28,
        "remark": "https://www.lazada.co.th/products/pdp-i16144625965.html",
        "sold": 0
    },
    {
        "product_name": "Onefire | ไฟโปรเจคเตอร์ท้องฟ้าประกายดาวออโรร่า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S66d5b28dfd034fb4b9bda8afe212a581p.jpg_200x200q90.jpg",
        "price": 1944.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5910826453.html",
        "sold": 98
    },
    {
        "product_name": "เลนส์กล้องดิจิตอล4K ด้านหน้าด้านหลังกล้องวีดีโอ50MP พร้อมขาตั้งสำหรับเด็กหญิงเด็กชายเซลฟี่ของขวัญวันเกิดระบบป้องกันภาพสั่นไหวแบบอิเล็กทรอนิกส์",
        "product_image": "https://img.lazcdn.com/g/p/7393b8cac13356417d7811b91919d9ab.jpg_200x200q90.jpg",
        "price": 1940,
        "remark": "https://www.lazada.co.th/products/pdp-i6036017299.html",
        "sold": 0
    },
    {
        "product_name": "รุ่นอัพเกรด   หูฟังบลูทูธไร้สายรุ่นใหม่   หูฟังสเตอริโอ HIFI หูฟังสปอร์ตเบสหนัก -ElectroPlex",
        "product_image": "https://img.lazcdn.com/g/p/917161b99a57f5c30c8aa3ba5ae81995.jpg_webp_200x200q90.jpg",
        "price": 1936.18,
        "remark": "https://www.lazada.co.th/products/pdp-i16046257963.html",
        "sold": 0
    },
    {
        "product_name": "【UII MALL】<br>Version SFR1M44-U100K USB Emulator Gray 3.5In 1.44MB USB SSD Floppy Drive Emulator for Electronic Keyboard for",
        "product_image": "https://img.lazcdn.com/g/p/9f30597672c41c4d3eeb197a014d5942.jpg_200x200q90.jpg",
        "price": 1930,
        "remark": "https://www.lazada.co.th/products/pdp-i16089602324.html",
        "sold": 0
    },
    {
        "product_name": "【Life and Movement】Version SFR1M44-U100K USB Emulator Gray 3.5In 1.44MB USB SSD Floppy Drive Emulator for Electronic Keyboard for",
        "product_image": "https://img.lazcdn.com/g/p/094fe7cfc0b0bc2fa702bc6a95440bcb.jpg_200x200q90.jpg",
        "price": 1930,
        "remark": "https://www.lazada.co.th/products/pdp-i16089160989.html",
        "sold": 0
    },
    {
        "product_name": "ค้อนหัวฉลามบังคับระยะไกล2.4ก. ของเล่นไบโอนิคจุ่มกันน้ำสำหรับสระว่ายน้ำเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/13b8505fff057bcf733b99096773d2d4.png_200x200q90.png",
        "price": 1916.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16092227936.html",
        "sold": 0
    },
    {
        "product_name": "kufire | ของเล่นกล้องถ่ายรูปสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S16bfae3135214452bc3f79293792a103D.jpg_200x200q90.jpg",
        "price": 1904.72,
        "remark": "https://www.lazada.co.th/products/pdp-i5910914033.html",
        "sold": 23
    },
    {
        "product_name": "QINZIBULUO | พรมเต้นไร้สายสำหรับเด็กผู้หญิง ดนตรีและออกกำลังกาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8b21b18f7175465997ad2e0cdab4b0d88.jpg_200x200q90.jpg",
        "price": 1900,
        "remark": "https://www.lazada.co.th/products/pdp-i16089101831.html",
        "sold": 0
    },
    {
        "product_name": "EMP | เครื่องบันทึกเสียงพกพาขนาดเล็ก ความละเอียดสูง ลดเสียงรบกวน ใช้งานได้นาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa545df0804624bfa8c6116b848e2594fO.jpg_200x200q90.jpg",
        "price": 1899.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5938227858.html",
        "sold": 1
    },
    {
        "product_name": "รถบังคับวิทยุโลหะผสมเครื่องควบคุมความเร็วอิเล็กทรอนิกส์ RC ปัด ESC สำหรับ540 550มอเตอร์750",
        "product_image": "https://img.lazcdn.com/g/p/e22cc5e13a4bd893e26ccefac49c60b8.jpg_200x200q90.jpg",
        "price": 1894,
        "remark": "https://www.lazada.co.th/products/pdp-i6031906037.html",
        "sold": 0
    },
    {
        "product_name": "Jam Tangan Elektronik สนูปปี้แบลควอตซ์อิเล็กทรอนิกส์กลไกคู่สวยงามกันน้ำได้นาฬิกาปลุกจับเวลา",
        "product_image": "https://img.lazcdn.com/g/p/e0dfe2ba109f6a6fe456868d94b32d6a.jpg_200x200q90.jpg",
        "price": 1894,
        "remark": "https://www.lazada.co.th/products/pdp-i4940513615.html",
        "sold": 0
    },
    {
        "product_name": "Jam Tangan Elektronik POEDAGAR นาฬิกากีฬาส่องสว่างปฏิทินสเตนเลสอเนกประสงค์สำหรับกันน้ำผู้ชาย50ATM ดั้งเดิม",
        "product_image": "https://img.lazcdn.com/g/p/e3f8bc95d32bf6472c99404751e085cf.jpg_200x200q90.jpg",
        "price": 1890.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5800117403.html",
        "sold": 0
    },
    {
        "product_name": "ของเล่นฉลามหัวค้อนควบคุมระยะไกล 2.4G - กันน้ำแบบจุ่มไบโอนิคสำหรับสระเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/969c80e5b73087f6bc37048959f0bab3.png_200x200q90.png",
        "price": 1886,
        "remark": "https://www.lazada.co.th/products/pdp-i16092353993.html",
        "sold": 0
    },
    {
        "product_name": "Aomosin | หุ่นยนต์สุนัขเดินและพูดได้ ของเล่นควบคุมระยะไกล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S43104ac9a472492490854166f9d4eafcG.jpg_200x200q90.jpg",
        "price": 1884,
        "remark": "https://www.lazada.co.th/products/pdp-i5996967058.html",
        "sold": 0
    },
    {
        "product_name": "Hape | ของเล่นกล้องพร้อมเสียงและไฟสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4b40cf5a6a1b40f8a04ffb34bdf00c1fT.jpg_200x200q90.jpg",
        "price": 1882.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5909695132.html",
        "sold": 4
    },
    {
        "product_name": "SHENMISHAONIAN | แผ่นเต้นรำฟิตเนสไร้สายสำหรับคนเดียวในร่ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sde14a26a65c542a3b1104e19a9f01e06g.jpg_200x200q90.jpg",
        "price": 1876.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16052973010.html",
        "sold": 0
    },
    {
        "product_name": "MAOMEI วางไว้เหนือประตู ชุดห่วงบาสเก็ตบอลขนาดเล็ก พร้อมกระดานคะแนนอิเล็กทรอนิกส์ ติดผนัง หัวข้อย่อย: หัวข้อย่อยเกี่ยวกับการเล่นบาสเกตบอลในร่ม ไม่จำเป็นต้องเจาะ แบบพับได้ กระดานบาสเก็ตบอลแบบแขวน ฝึกซ้อมในร่ม",
        "product_image": "https://img.lazcdn.com/g/p/6ed1af3317dc1def63a9a6f81df7fd7a.jpg_200x200q90.jpg",
        "price": 1872,
        "remark": "https://www.lazada.co.th/products/pdp-i16146867672.html",
        "sold": 0
    },
    {
        "product_name": "Zeberg มิเตอร์อิเล็กทรอนิกส์ 5(45)A 1P 2W รุ่น ZB1 มิเตอร์ดิจิตอล",
        "product_image": "https://img.lazcdn.com/g/p/5134f1bdaf53822aff47e92b4bb8983b.jpg_200x200q90.jpg",
        "price": 1870,
        "remark": "https://www.lazada.co.th/products/pdp-i6074976754.html",
        "sold": 0
    },
    {
        "product_name": "Awei TA8 ANC หูฟังไร้สายบลูทูธ TWS หูฟังไร้สายพร้อมจอแสดงผล LED ดิจิตอล Bluetooth 5.2 หูฟัง IPX6 กันน้ำรอบทิศทางสเตอริโอเกรด 300 ชั่วโมงหูฟังสแตนด์บายนานสำหรับโทรศัพท์มือถือบลูทูธทั้งหมด",
        "product_image": "https://img.lazcdn.com/g/p/6b5e9dbf6193a6c7c7cbf84c14282eed.jpg_200x200q90.jpg",
        "price": 1862,
        "remark": "https://www.lazada.co.th/products/pdp-i2410013479.html",
        "sold": 134
    },
    {
        "product_name": "หูฟังไร้สายพร้อมจอแสดงผล LED, ดีไซน์แบบครึ่งหูตามหลักสรีรศาสตร์, แบตเตอรี่ 24 ชั่วโมง, ควบคุมด้วยระบบสัมผัสอัจฉริยะ, ชาร์จเร็วด้วย USB-C, สีขาว",
        "product_image": "https://img.lazcdn.com/g/p/b431f29d04a6f5ff7a28697748991c38.jpg_webp_200x200q90.jpg",
        "price": 1860.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6055936170.html",
        "sold": 0
    },
    {
        "product_name": "กล้องของเล่นสำหรับเด็กความละเอียดสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd24b530a81e140e1ae45d91abad09f71L.jpg_200x200q90.jpg",
        "price": 1858,
        "remark": "https://www.lazada.co.th/products/pdp-i6006070580.html",
        "sold": 0
    },
    {
        "product_name": "อ่างสปาแช่น้ำร้อนขนาด 2.15 เมตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb6dc51c3a9104b00ba3c82c4b4279fcen.jpg_200x200q90.jpg",
        "price": 525798.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16084330952.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำน้ำอุ่น ME 45 FG (FREE)",
        "product_image": "https://img.lazcdn.com/g/p/bbb06fb9a892c1c4ea1e59f7d7c6b8f0.jpg_200x200q90.jpg",
        "price": 177776,
        "remark": "https://www.lazada.co.th/products/pdp-i6059717157.html",
        "sold": 0
    },
    {
        "product_name": "MUHUASHA | เครื่องปั่นบาร์ประสิทธิภาพสูงเงียบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8b4cc6db61e944069cd0f0ed8a37719cH.jpg_200x200q90.jpg",
        "price": 166870.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16059836846.html",
        "sold": 0
    },
    {
        "product_name": "LINCAT เครื่องจ่ายน้ำร้อน กาต้มน้ำไฟฟ้า กาต้มน้ำอัตโนมัติ แบบตั้งโต๊ะ LIN1-EB",
        "product_image": "https://img.lazcdn.com/g/p/378d5101cf839bc3787fe545addc9fab.jpg_200x200q90.jpg",
        "price": 164566,
        "remark": "https://www.lazada.co.th/products/pdp-i4731700903.html",
        "sold": 0
    },
    {
        "product_name": "Robot Coupe J80 Automatic Juice Extractors 230V/50/1 (56000B) / เครื่องคั้นน้ำผลไม้",
        "product_image": "https://img.lazcdn.com/g/p/1d1ecb8b2fda0e072da3234decb6c8b9.jpg_200x200q90.jpg",
        "price": 164566,
        "remark": "https://www.lazada.co.th/products/pdp-i3602183941.html",
        "sold": 0
    },
    {
        "product_name": "*New*เครื่องทำน้ำร้อนแก๊สรินไน 32 ลิตร รุ่น REU-AM3237WC-GEN ของแท้ 100% (สินค้านำเข้าจากญี่ปุ่น) มีใบรับประกัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sccb4abaff9ab40fc93a05fcac60fed62J.jpg_200x200q90.jpg",
        "price": 151600,
        "remark": "https://www.lazada.co.th/products/pdp-i4378508580.html",
        "sold": 0
    },
    {
        "product_name": "(MEX) EES-120 เครื่องทำน้ำร้อนไฟฟ้าขดลวดความร้อนคู่ ขนาด 455 ลิตร ชนิดถัง",
        "product_image": "https://img.lazcdn.com/g/p/72e3487918c5f0b16fae22fa974bee6c.jpg_200x200q90.jpg",
        "price": 135800,
        "remark": "https://www.lazada.co.th/products/pdp-i4119856418.html",
        "sold": 0
    },
    {
        "product_name": "Vitamix The Quiet One 1.4L 1450 watts เครื่องปั่น เทคโนโลยีเก็บเสียงเงียบสุด Made in USA สำหรับธุรกิจร้านกาแฟและเครื่องดื่ม รับประกันมอเตอร์ 3 ปี",
        "product_image": "https://img.lazcdn.com/g/p/066c84850b7aad6c1c9d8d50b67f137b.jpg_200x200q90.jpg",
        "price": 135800,
        "remark": "https://www.lazada.co.th/products/pdp-i300010640.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำน้ำร้อนแก๊ส 28 ลิตร RINNAI รุ่น REU-VCM2837WC-GE",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7f0fbd97bfae451783646d31ca28faf6D.jpg_200x200q90.jpg",
        "price": 133600,
        "remark": "https://www.lazada.co.th/products/pdp-i4960021522.html",
        "sold": 0
    },
    {
        "product_name": "HOMEMATE เครื่องปั่นความเร็วสูง 2 ลิตร รุ่น HOM-301281",
        "product_image": "https://img.lazcdn.com/g/p/1e3ea7bb4ab05e6c26d06aeec5ab807b.jpg_200x200q90.jpg",
        "price": 129640,
        "remark": "https://www.lazada.co.th/products/pdp-i16087096444.html",
        "sold": 0
    },
    {
        "product_name": "MUHUASHA | เครื่องปั่นอเนกประสงค์ประสิทธิภาพสูง เงียบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S026d207db2d644a0abee78f67d80b171g.jpg_200x200q90.jpg",
        "price": 129216.66,
        "remark": "https://www.lazada.co.th/products/pdp-i16059705313.html",
        "sold": 0
    },
    {
        "product_name": "Rinnai Infinity เครื่องทำน้ำร้อนแก๊ส 28 ลิตร รุ่นREU-VCM2837WC-GEN และ รุ่นREU-VCM2837FFC-GEN",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S66e362595b3643b5b700e496766d9324S.jpg_200x200q90.jpg",
        "price": 129000,
        "remark": "https://www.lazada.co.th/products/pdp-i4823858254.html",
        "sold": 0
    },
    {
        "product_name": "Joyoung | เครื่องทำนมถั่วเหลืองอัตโนมัติ ความถี่แปรผัน เสียงเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S96357b29f2aa44999a8509365f2e34c0n.png_200x200q90.png",
        "price": 122758.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16050935829.html",
        "sold": 0
    },
    {
        "product_name": "Vitamix Touch & Go Advance เครื่องปั่นสมูทตี้ เก็บเสียง โถ 0.9 ลิตร - 220V (รับประกันศูนย์ไทย 3ปี)",
        "product_image": "https://img.lazcdn.com/g/p/813f4c8b16e7f98ea7c2e1b457824204.png_200x200q90.png",
        "price": 115800,
        "remark": "https://www.lazada.co.th/products/pdp-i661882072.html",
        "sold": 1
    },
    {
        "product_name": "HAMILTON BEACH COMMERCIAL เครื่องปั่นน้ำผักผลไม้ โถปั่นโพลีคาร์บอเนต ระบบปิดการทำงานอัตโนมัติ การปั่นโดยอัตโนมัติ ความจุ 0.95 ลิตร HAM1-1G91555",
        "product_image": "https://img.lazcdn.com/g/p/f1bf11baf674c55c8991df442f52cd3a.jpg_200x200q90.jpg",
        "price": 106786,
        "remark": "https://www.lazada.co.th/products/pdp-i4380446136.html",
        "sold": 0
    },
    {
        "product_name": "HAMILTON BEACH COMMERCIAL เครื่องปั่นน้ำผักผลไม้ โถปั่นโพลีคาร์บอเนต ความจุ0.95ลิตร HAM1-1G91515",
        "product_image": "https://img.lazcdn.com/g/p/6aff73f7fe6a88db47c02150efea8de0.jpg_200x200q90.jpg",
        "price": 101864,
        "remark": "https://www.lazada.co.th/products/pdp-i4380425530.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำน้ำหวานเกล็ดหิมะ iCHI-COOL ขนาด 12 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/09578ea12a168ca2efe495882f58537f.png_200x200q90.png",
        "price": 90850,
        "remark": "https://www.lazada.co.th/products/pdp-i2657064307.html",
        "sold": 4
    },
    {
        "product_name": "เครื่องทำน้ำอุ่นไฟฟ้า 90 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf4b204fe859d468290e1d75dddbcd688w.jpg_200x200q90.jpg",
        "price": 88956,
        "remark": "https://www.lazada.co.th/products/pdp-i16077438030.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำน้ำหวานเกล็ดหิมะ ICHI-COOL ขนาด 12 ลิตร ระบบดิจิตอลคอนโทรล",
        "product_image": "https://img.lazcdn.com/g/p/8f606c9f9763c877000c82cb8809dc50.png_200x200q90.png",
        "price": 88550,
        "remark": "https://www.lazada.co.th/products/pdp-i16065683798.html",
        "sold": 0
    },
    {
        "product_name": "Laurastar Lift Plus Ultimate Black เครื่องรีดถนอมผ้า 3-in-1 คุณภาพสูง Portable Steam Station, Irons, Steams and Purifies Clothing, Hygienic Steam, Removable Water Tank, Vertical Ironing, Cable Rewinder, 3D Active Soleplate (นำเข้าจากยุโรป))",
        "product_image": "https://img.lazcdn.com/g/p/1e9e1a529602df3a3c86875ed6ec8f1a.jpg_200x200q90.jpg",
        "price": 85800,
        "remark": "https://www.lazada.co.th/products/pdp-i2738865013.html",
        "sold": 0
    },
    {
        "product_name": "HAMILTON BEACH COMMERCIAL เครื่องปั่นน้ำผักผลไม้ โถปั่นโพลีคาร์บอเนต ความจุ0.95ลิตร HAM1-1G91503",
        "product_image": "https://img.lazcdn.com/g/p/29e0b9e5735ac7a8e99c338647f50800.jpg_200x200q90.jpg",
        "price": 85172,
        "remark": "https://www.lazada.co.th/products/pdp-i4380411476.html",
        "sold": 0
    },
    {
        "product_name": "Madin MD-36SE Blendicon The Quiet Commercial Blender+Cover 2L, 1800W/ เครื่องปั่นสมูทตี้ เครื่องปั่น",
        "product_image": "https://img.lazcdn.com/g/p/7942d906ffafc37f4e4a75d2e1570ad7.jpg_200x200q90.jpg",
        "price": 83246,
        "remark": "https://www.lazada.co.th/products/pdp-i3573752655.html",
        "sold": 0
    },
    {
        "product_name": "Madin T-35SE Blendicon Touch Screen Commercial Blender 1.2L, 1800W / เครื่องปั่นสมูทตี้ เครื่องปั่น",
        "product_image": "https://img.lazcdn.com/g/p/264e131862f369c226729976db9884b4.jpg_200x200q90.jpg",
        "price": 83246,
        "remark": "https://www.lazada.co.th/products/pdp-i3573719705.html",
        "sold": 0
    },
    {
        "product_name": "HAMILTON BEACH COMMERCIAL เครื่องปั่นน้ำผักผลไม้ โถปั่นโพลีคาร์บอเนต ความจุ0.95ลิตร HAM1-1G915",
        "product_image": "https://img.lazcdn.com/g/p/2f31ef855f680b0ec26964196141f834.jpg_200x200q90.jpg",
        "price": 82390,
        "remark": "https://www.lazada.co.th/products/pdp-i4380359913.html",
        "sold": 0
    },
    {
        "product_name": "HAMILTON BEACH COMMERCIAL เครื่องปั่นผสมอาหาร เครื่องปั่น โถปั่นสแตนเลส ขนาด 1.8 ลิตร HAM1-HBF510S-CE",
        "product_image": "https://img.lazcdn.com/g/p/c46d5ea6bf6afc101302d2e32fd7aba0.jpg_200x200q90.jpg",
        "price": 82390,
        "remark": "https://www.lazada.co.th/products/pdp-i4202223662.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำน้ำร้อนแก๊ส 16 ลิตร RINNAI รุ่น REU-A1620WD-GEN",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S91cea1e259ab4466b658195ec2427357g.jpg_200x200q90.jpg",
        "price": 78000,
        "remark": "https://www.lazada.co.th/products/pdp-i4960094034.html",
        "sold": 0
    },
    {
        "product_name": "(New)เครื่องน้ำร้อนแก๊ส 16,28,32 ลิตร RINNAI *No.1 Japan",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb5eeb6c406a64e888d88c03d0a87c700v.jpg_200x200q90.jpg",
        "price": 78000,
        "remark": "https://www.lazada.co.th/products/pdp-i4960064089.html",
        "sold": 3
    },
    {
        "product_name": "Rinnai Infinity เครื่องทำน้ำร้อนแก๊ส 16,26,28,32 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa33725474b144071b306d6e3615bf02a2.jpg_200x200q90.jpg",
        "price": 78000,
        "remark": "https://www.lazada.co.th/products/pdp-i4960003003.html",
        "sold": 1
    },
    {
        "product_name": "*New*เครื่องทำน้ำร้อนแก๊สรินไน 16 ลิตร รุ่น REU-A1620WD-GEN  ของแท้ 100% (สินค้านำเข้าจากญี่ปุ่น) มีใบรับประกัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa2ee30a952b44092b376fedfbd23b975E.jpg_200x200q90.jpg",
        "price": 78000,
        "remark": "https://www.lazada.co.th/products/pdp-i5063137896.html",
        "sold": 0
    },
    {
        "product_name": "(MEX) เครื่องทำน้ำร้อนชนิดหม้อต้ม A.O.Smith รุ่น EES-50 (ขนาด 190 ลิตร)",
        "product_image": "https://img.lazcdn.com/g/p/1dea49d7efa25b5a50597c9e08fd6520.jpg_200x200q90.jpg",
        "price": 77800,
        "remark": "https://www.lazada.co.th/products/pdp-i3916786935.html",
        "sold": 0
    },
    {
        "product_name": "Kuvings เครื่องสกัดเย็นคั้นน้ำผลไม้ รุ่น CS600(KCS-6000) เพื่อเชิงพาณิชย์",
        "product_image": "https://img.lazcdn.com/g/p/d60fcbbd745d8582429cb72521b21fc3.jpg_200x200q90.jpg",
        "price": 77600,
        "remark": "https://www.lazada.co.th/products/pdp-i368256527.html",
        "sold": 17
    },
    {
        "product_name": "Waring Xtreme MX1000XTX เครื่องปั่นเชิงพาณิชย์ โถ 64 oz. เครื่องปั่น Waring MX1000 Made in USA เครื่องปั่นเครื่องดื่ม เครื่องปั่นน้ำผักผลไม้",
        "product_image": "https://img.lazcdn.com/g/p/2018090f10cd97cfb1456ef7d056dd04.jpg_200x200q90.jpg",
        "price": 75800,
        "remark": "https://www.lazada.co.th/products/pdp-i596226348.html",
        "sold": 0
    },
    {
        "product_name": "JIAWENHUA | เครื่องอาบน้ำอุณหภูมิคงที่พกพาพร้อมถังคู่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9b02a0b12b8d45d49d09085951df1bd2u.jpg_200x200q90.jpg",
        "price": 75060.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5910852421.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำน้ำหวานเกล็ดหิมะ ICHI-COOL ขนาด 12 ลิตร  ระบบดิจิตอลคอนโทรล",
        "product_image": "https://img.lazcdn.com/g/p/5d36a66f097e5a754ea8e62a4b88bbd1.png_200x200q90.png",
        "price": 74750,
        "remark": "https://www.lazada.co.th/products/pdp-i4034031930.html",
        "sold": 2
    },
    {
        "product_name": "Madin MD-326S ChefMaster Stainless Steel Jar Commercial Blender 1.8L, 1800W / เครื่องปั่นสมูทตี้ เครื่องปั่น",
        "product_image": "https://img.lazcdn.com/g/p/88c1acc3b24a3db2dcb6e5c9223900c0.jpg_200x200q90.jpg",
        "price": 72546,
        "remark": "https://www.lazada.co.th/products/pdp-i4729799082.html",
        "sold": 0
    },
    {
        "product_name": "EVERHOT เครื่องทำน้ำร้อนหม้อต้มไฟฟ้า 120 ลิตร 1 เฟส รุ่น ERAS แบรนด์ชั้นนำจาก Australia",
        "product_image": "https://img.lazcdn.com/g/p/1769e3db8a0b8f97d29941a998dc59c7.jpg_200x200q90.jpg",
        "price": 70620,
        "remark": "https://www.lazada.co.th/products/pdp-i5600502118.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องปั่น KitchenAid 5 KSB5080E Artisan Magnetic Side Drive",
        "product_image": "https://img.lazcdn.com/g/p/bc54796a80198948a6e5f619e6fa6805.jpg_200x200q90.jpg",
        "price": 70406,
        "remark": "https://www.lazada.co.th/products/pdp-i8274258.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อน (8000 วัตต์) รุ่น DHC8 ILEC",
        "product_image": "https://img.lazcdn.com/g/p/975e9b72286149be9163a0841a9d16bf.jpg_200x200q90.jpg",
        "price": 70191.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16081766378.html",
        "sold": 0
    },
    {
        "product_name": "Vitamix Vita-Prep 3 (พร้อมไม้ Tamper) เครื่องปั่นเชิงพาณิชย์ พร้อมโถ 2 ลิตร ปั่นละเอียดใบมีดพิเศษ รองรับไฟไทย 220V (รับประกันศูนย์ไทย 3 ปี)",
        "product_image": "https://img.lazcdn.com/g/p/2c553e3f896355f6f6144967181e0a12.png_200x200q90.png",
        "price": 69800,
        "remark": "https://www.lazada.co.th/products/pdp-i661862673.html",
        "sold": 7
    },
    {
        "product_name": "Vitamix Vita-Prep 3 เครื่องปั่นเชิงพาณิชย์ (โถเตี้ย) Made in USA 1450 วัตต์ 3HP ไฟไทย โถปั่น 2.0L พร้อมด้ามคน ประกันมอเตอร์ 3 ปี (มีศูนย์ซ่อมและบริการ) Vita Prep 3 , Vitaprep 3 , Prep3",
        "product_image": "https://img.lazcdn.com/g/p/2b5dbf80eb47bfe817e0b107d7a03dad.jpg_200x200q90.jpg",
        "price": 69800,
        "remark": "https://www.lazada.co.th/products/pdp-i709412321.html",
        "sold": 2
    },
    {
        "product_name": "sanliang | ตู้ฟักเพาะเลี้ยงที่มีการสั่นสะเทือนอุณหภูมิคงที่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfcaa461c0eef45e68f2407882335d672V.jpg_200x200q90.jpg",
        "price": 69365.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16052647403.html",
        "sold": 0
    },
    {
        "product_name": "Kuvings CB850 Commercial Pro เครื่องปั่นเชิงพาณิชย์ อัตโนมัติ ทรงพลัง ใช้งานง่าย",
        "product_image": "https://img.lazcdn.com/g/p/2cff22b26cfa16d289c157c266b3d6b4.jpg_200x200q90.jpg",
        "price": 69300,
        "remark": "https://www.lazada.co.th/products/pdp-i5713341327.html",
        "sold": 0
    },
    {
        "product_name": "(MEX) เครื่องทำน้ำร้อนชนิดหม้อต้ม A.O.Smith รุ่น EES-40 (ขนาด 150 ลิตร)",
        "product_image": "https://img.lazcdn.com/g/p/1dea49d7efa25b5a50597c9e08fd6520.jpg_200x200q90.jpg",
        "price": 69000,
        "remark": "https://www.lazada.co.th/products/pdp-i3916815635.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อน (6000 วัตต์) รุ่น DHC6 ILEC",
        "product_image": "https://img.lazcdn.com/g/p/95f0dba53f64b1e5ee7f7b4352ecc59e.jpg_200x200q90.jpg",
        "price": 67447.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16081828235.html",
        "sold": 0
    },
    {
        "product_name": "Vitamix Vita-Prep 3 Blender เครื่องปั่นเชิงพาณิชย์ Made in USA 1450 วัตต์ 3HP ไฟไทย โถปั่น 2.0L พร้อมด้ามคน ประกันมอเตอร์ 3 ปี (มีศูนย์ซ่อมและบริการ) Vita Prep 3 , Vitaprep 3 , Prep3",
        "product_image": "https://img.lazcdn.com/g/p/d87b074e4f86e634d1b8b473f047ec59.jpg_200x200q90.jpg",
        "price": 66500,
        "remark": "https://www.lazada.co.th/products/pdp-i1446578466.html",
        "sold": 8
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำอุ่น (4500 วัตต์) รุ่น Chrome-2 DS 45 EC",
        "product_image": "https://img.lazcdn.com/g/p/2c950b0036749f178cdfb99943abc001.jpg_200x200q90.jpg",
        "price": 66350.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16081787399.html",
        "sold": 0
    },
    {
        "product_name": "KitchenAid 5KSB5080 Artisan Magnetic Side Drive Blen / เครื่องปั่นเอนกประสงค์ ขนาด 1.75 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/c5ee3a2c75e652bd9d37000de79c7ce7.jpg_200x200q90.jpg",
        "price": 65800,
        "remark": "https://www.lazada.co.th/products/pdp-i1532132564.html",
        "sold": 0
    },
    {
        "product_name": "Vitamix | Vitamix A2500I Ascent Series 2L BI สขาว นำเขาอยางเปนทางการ จดสงในวนเดยวกน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S579d7e8eb0644b3bb82ec1fa1bcb5b5ad.png_200x200q90.png",
        "price": 65333.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5961846561.html",
        "sold": 0
    },
    {
        "product_name": "HAFELE เครื่องปั่นอเนกประสงค์ร้อนเย็น 1.75 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/0dd8ec088449233812de7ea28d9cd8c7.jpg_200x200q90.jpg",
        "price": 64740,
        "remark": "https://www.lazada.co.th/products/pdp-i16086998463.html",
        "sold": 0
    },
    {
        "product_name": "หม้อทอด  Airfryer XXL HD9650/91",
        "product_image": "https://img.lazcdn.com/g/p/1f7bcc30334b6d760995020a98cabe36.jpg_200x200q90.jpg",
        "price": 64656.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16058454590.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อน (6000 วัตต์) รุ่น DDC 6 EC",
        "product_image": "https://img.lazcdn.com/g/p/6f8d6a69c6bee7f74525c4a80596e384.jpg_200x200q90.jpg",
        "price": 64155.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16081885224.html",
        "sold": 0
    },
    {
        "product_name": "FERROLI เครื่องทำน้ำร้อนชนิดหม้อต้ม รุ่น SEV 150",
        "product_image": "https://img.lazcdn.com/g/p/1007ec81df2e11d03fbc75858fec0147.jpg_200x200q90.jpg",
        "price": 63600,
        "remark": "https://www.lazada.co.th/products/pdp-i16135648064.html",
        "sold": 0
    },
    {
        "product_name": "COSORI ICONIC Airfryer, หม้อทอดลมร้อนไร้น้ำมันทรงสวย 6.2L, 96% Stainless Steel, PFAS and BPA Free Ceramic Coating, 7-in-1 Baking, Grilling, Fermentation, Dehydration, 61% Energy Saving",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S62389b2573314c2d99f44b059716205c7.jpg_200x200q90.jpg",
        "price": 63352.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16123592866.html",
        "sold": 0
    },
    {
        "product_name": "Dux เครื่องทำน้ำร้อนชนิดหม้อต้มไฟฟ้ารุ่น Proflo 80T1 (90Litres) (Product of Australia)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S61ac0dab9ef0436a915edb7bdb530856L.jpg_200x200q90.jpg",
        "price": 63000,
        "remark": "https://www.lazada.co.th/products/pdp-i307466489.html",
        "sold": 0
    },
    {
        "product_name": "OPPLE | พัดลมและเครื่องทำความร้อนในห้องน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S61a3b87efcfa4a4b84f5ae86a765f87dR.jpg_200x200q90.jpg",
        "price": 62075.38,
        "remark": "https://www.lazada.co.th/products/pdp-i5910879549.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อน (6000 วัตต์) รุ่น DHC 6 EC",
        "product_image": "https://img.lazcdn.com/g/p/494bae89dad43610fe14ce55eb05a772.jpg_200x200q90.jpg",
        "price": 61960.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16081613786.html",
        "sold": 0
    },
    {
        "product_name": "เตาเผาเซรามิคไฟฟ้าขนาดเล็กสำหรับงานปั้นดินเผาอุณหภูมิกลางถึงสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scada9e13ab1a45f285a620797ea26a55R.png_200x200q90.png",
        "price": 61770.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16097907020.html",
        "sold": 0
    },
    {
        "product_name": "Kuvings เครื่องสกัดเย็นคั้นน้ำผลไม้ รุ่น CS520(KCS-5200) เพื่อเชิงพาณิชย์",
        "product_image": "https://img.lazcdn.com/g/p/9156df7981a257d55cddc33f76f3401d.jpg_200x200q90.jpg",
        "price": 60000,
        "remark": "https://www.lazada.co.th/products/pdp-i407214377.html",
        "sold": 53
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำอุ่น (4500 วัตต์) รุ่น Steel",
        "product_image": "https://img.lazcdn.com/g/p/82ea43a45942e1517443038e34a18fdb.jpg_200x200q90.jpg",
        "price": 59818.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16081547918.html",
        "sold": 0
    },
    {
        "product_name": "SHIMONO Blendtec blender เครื่องปั่นพลังสูง รุ่น Designer 625",
        "product_image": "https://img.lazcdn.com/g/p/5d8791156b949df88320ecca46f5663b.jpg_200x200q90.jpg",
        "price": 59800,
        "remark": "https://www.lazada.co.th/products/pdp-i5377233663.html",
        "sold": 0
    },
    {
        "product_name": "Vitamix Drink Machine Advance + โถ 1.4L (New Model) - เครื่องปั่นเหมาะสำหรับธุรกิจ",
        "product_image": "https://img.lazcdn.com/g/p/f689d77c359d29c0089e4fb9526e9ac0.png_200x200q90.png",
        "price": 59800,
        "remark": "https://www.lazada.co.th/products/pdp-i729468708.html",
        "sold": 9
    },
    {
        "product_name": "Vitamix Drink Machine Advance 1.4L เครื่องปั่นเชิงพาณิชย์ สำหรับธุรกิจร้านกาแฟ (มีศูนย์ซ่อมและบริการหลังการขาย) ประกันมอเตอร์ 3 ปี Made in USA ไฟไทย",
        "product_image": "https://img.lazcdn.com/g/p/6ed814c6ab26e7a75d7d6fbdc55c593c.jpg_200x200q90.jpg",
        "price": 59800,
        "remark": "https://www.lazada.co.th/products/pdp-i1113792285.html",
        "sold": 1
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อน (6000 วัตต์) รุ่น DHM6",
        "product_image": "https://img.lazcdn.com/g/p/206433b4f2c375362afcf72a50cd4e42.jpg_200x200q90.jpg",
        "price": 59216.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16081877202.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำอุ่น (4500 วัตต์) รุ่น WL 45EC",
        "product_image": "https://img.lazcdn.com/g/p/0566888f3a8e00297c53c532c3b9bcee.jpg_200x200q90.jpg",
        "price": 58118.44,
        "remark": "https://www.lazada.co.th/products/pdp-i16081799412.html",
        "sold": 0
    },
    {
        "product_name": "Blendtec EZ 600 Blender เครื่องปั่นเชิงพาณิชย์ ใช้ปั่นเครื่องดื่ม Made in USA 1560 วัตต์ โถปั่น FourSide Jar 0.9L / 32oz ใช้ไฟไทย Blendtec Blender",
        "product_image": "https://img.lazcdn.com/g/p/58668e619f0c64366672643f77fa9ca8.jpg_200x200q90.jpg",
        "price": 57800,
        "remark": "https://www.lazada.co.th/products/pdp-i2109266327.html",
        "sold": 2
    },
    {
        "product_name": "KITCHENAID K150 เครื่องปั่น (650 วัตต์, 1.4 ลิตร, สีแดง) รุ่น 5KSB1325WPA",
        "product_image": "https://img.lazcdn.com/g/p/6715f551d13347b105fef8f74ba1242c.jpg_200x200q90.jpg",
        "price": 57623.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16078147083.html",
        "sold": 0
    },
    {
        "product_name": "Joyoung | เครื่องปั่นไม่ใช้ฟิลเตอร์ ทำงานตามกำหนดเวลา ทำความสะอาดง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sad1fc354834844f28d443748685c3b3cj.jpg_200x200q90.jpg",
        "price": 57358,
        "remark": "https://www.lazada.co.th/products/pdp-i6064763825.html",
        "sold": 0
    },
    {
        "product_name": "Kuvings เครื่องสกัดเย็นคั้นน้ำผลไม้ รุ่น AUTO10S",
        "product_image": "https://img.lazcdn.com/g/p/5c7be393e93b1acf97e58c0ccf04b12a.jpg_200x200q90.jpg",
        "price": 56408,
        "remark": "https://www.lazada.co.th/products/pdp-i5031680264.html",
        "sold": 11
    },
    {
        "product_name": "เครื่องทำน้ำหวานเกล็ดหิมะ ICHI-COOL ขนาด 3 ลิตร ระบบดิจิตอลคอนโทรล",
        "product_image": "https://img.lazcdn.com/g/p/220ad5641c5859d00d5fc5b865b70c56.jpg_200x200q90.jpg",
        "price": 56350,
        "remark": "https://www.lazada.co.th/products/pdp-i16066328356.html",
        "sold": 0
    },
    {
        "product_name": "SHIMONO Blendtec blender เครื่องปั่นเอนกประสงค์ พลังสูง รุ่น Designer 625 สินค้าขายดีใน อเมริกา ผลิตใน ในประเทศ อเมริกา ความจุ 1 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/ebfdac6c80a2e25ba183c9b6d31f030c.jpg_200x200q90.jpg",
        "price": 55860,
        "remark": "https://www.lazada.co.th/products/pdp-i3769490559.html",
        "sold": 2
    },
    {
        "product_name": "Joyoung | เครื่องปั่นอินเวอร์เตอร์แบบไม่ต้องใช้มือสำหรับใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6798b318d07a4fee895ace84122906c0U.png_200x200q90.png",
        "price": 55531.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16052252724.html",
        "sold": 0
    },
    {
        "product_name": "Dux เครื่องทำน้ำร้อนชนิดหม้อต้มไฟฟ้ารุ่น Proflo 50S1 (55Litres) (Product of Australia)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1e5ff49635fc4619a4f5131cd10de5aeF.jpg_200x200q90.jpg",
        "price": 55000,
        "remark": "https://www.lazada.co.th/products/pdp-i271514072.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำอุ่น (4500 วัตต์) รุ่น Chrome",
        "product_image": "https://img.lazcdn.com/g/p/23833193ca25a9a4e5ddbeac173176e9.jpg_200x200q90.jpg",
        "price": 54330.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16081671596.html",
        "sold": 0
    },
    {
        "product_name": "MEX เครื่องทำน้ำอุ่น (6000 วัตต์, สีดำ) รุ่น CUBE 6E (RMB)",
        "product_image": "https://img.lazcdn.com/g/p/857121c1fb80a968b8533baba77767f2.jpg_200x200q90.jpg",
        "price": 54330.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16079951162.html",
        "sold": 0
    },
    {
        "product_name": "คั้นน้ำผลไม้ปั่นเย็นอย่างเดียวถังเดียวหรูหรา220V/145W",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3ddd6a18adfb4dd4a49f8b88ae34c26aH.png_200x200q90.png",
        "price": 54116,
        "remark": "https://www.lazada.co.th/products/pdp-i16137635840.html",
        "sold": 0
    },
    {
        "product_name": "Ninja เครื่องปั่นอัตโนมัติ 2-in-1 Detect Power Mixer Pro & Single Serve Mixer with Jug, & Single Serve Cup, Smoothies Mixing, Chopping Vegetables & Mixing Frozen Drinks, 1200W, สี Copper/Black",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se3486c4c883241908b688e9cd6e7c8c1H.jpg_200x200q90.jpg",
        "price": 53800,
        "remark": "https://www.lazada.co.th/products/pdp-i5518927289.html",
        "sold": 0
    },
    {
        "product_name": "Kuvings เครื่องสกัดเย็นคั้นน้ำผลไม้ รุ่น REVO830(KSP-2478)",
        "product_image": "https://img.lazcdn.com/g/p/3de851b270733ea88aec2d72506a7c43.jpg_200x200q90.jpg",
        "price": 53800,
        "remark": "https://www.lazada.co.th/products/pdp-i3838637066.html",
        "sold": 19
    },
    {
        "product_name": "Taurino เครื่องปั่นสมูทตี้ เครื่องปั่นน้ำผลไม้ รุ่น Professional Blender",
        "product_image": "https://img.lazcdn.com/g/p/2629a13f0f3be0f005fb9c179a804e6a.png_200x200q90.png",
        "price": 53600,
        "remark": "https://www.lazada.co.th/products/pdp-i16059893271.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อน (8000 วัตต์) รุ่น DDH8EC",
        "product_image": "https://img.lazcdn.com/g/p/bbc70c03d793d2391cfb2e272cc0684a.jpg_200x200q90.jpg",
        "price": 53341.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16079456948.html",
        "sold": 0
    },
    {
        "product_name": "Joyoung | เครื่องปั่นอเนกประสงค์แบบไม่ต้องกดด้วยมือ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S59c7f1c8d7af415eba5241175980d7f4M.jpg_200x200q90.jpg",
        "price": 53305.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16051543828.html",
        "sold": 0
    },
    {
        "product_name": "Ninja ชุดเครื่องปั่น 2-in-1 Blender พร้อมโถ 2 ขนาด (2.1 Litre Jug, 0.7 Litre Cup) ระบบ Auto-iQ 1200 W.",
        "product_image": "https://img.lazcdn.com/g/p/cf69ef01377a5bf7c79367c4445dcf4d.jpg_200x200q90.jpg",
        "price": 51800,
        "remark": "https://www.lazada.co.th/products/pdp-i2319791646.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องปั่นน้ำผลไม้ HEALTHY-MIX GP3.5 2 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/d013343372647230ea599aa44d3dffd2.png_200x200q90.png",
        "price": 51800,
        "remark": "https://www.lazada.co.th/products/pdp-i1663888155.html",
        "sold": 2
    },
    {
        "product_name": "Joyoung | เครื่องปั่นอัจฉริยะไร้มือถือเงียบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdb1df6466f7a45e2b370347377f4000dL.png_200x200q90.png",
        "price": 51782.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16052001291.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำอุ่น (4800 วัตต์) รุ่น XGL48 EC",
        "product_image": "https://img.lazcdn.com/g/p/b82a675bc322c8f1b3ec56cbbb9dd98f.jpg_200x200q90.jpg",
        "price": 51068.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16081605791.html",
        "sold": 0
    },
    {
        "product_name": "Hurom | เครื่องคั้นน้ำผลไม้อัตโนมัติแยกกากสำหรับใช้ที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4d9311a24dbb44f394bea45c47838b90n.jpg_200x200q90.jpg",
        "price": 50962,
        "remark": "https://www.lazada.co.th/products/pdp-i16044637469.html",
        "sold": 0
    },
    {
        "product_name": "Hurom | เครื่องคั้นน้ำผลไม้ปากกว้างแยกเยื่อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4185f67cbef1464c805afb424b9de7b0g.jpg_200x200q90.jpg",
        "price": 50882,
        "remark": "https://www.lazada.co.th/products/pdp-i16127508835.html",
        "sold": 0
    },
    {
        "product_name": "(Stiebel) เครื่องทำน้ำร้อนแบบผ่านร้อน 18/21/24 kW รุ่น DHB-E 18/21/24",
        "product_image": "https://img.lazcdn.com/g/p/c68d9cdca39e526e3770beedcf2e81f5.jpg_200x200q90.jpg",
        "price": 50360,
        "remark": "https://www.lazada.co.th/products/pdp-i6074198406.html",
        "sold": 0
    },
    {
        "product_name": "ARISTON เครื่องทำน้ำอุ่น (4500 วัตต์) รุ่น AURES TOP 4.5 CU SBS",
        "product_image": "https://img.lazcdn.com/g/p/8e440b38aaa05a5d0687046bfeb3308b.jpg_200x200q90.jpg",
        "price": 50273.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16079759471.html",
        "sold": 0
    },
    {
        "product_name": "Hamilton Beach | เครื่องทำน้ำผลไม้สุญญากาศ ความจุมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S908c0898dfb64da39ca78d0ad0299749Q.jpg_200x200q90.jpg",
        "price": 50229.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5991115165.html",
        "sold": 0
    },
    {
        "product_name": "HAMILTON BEACH COMMERCIAL เครื่องปั่นสมูทตี้ โถปั่นโพลีคาร์บอเนต ความจุ1.25ลิตร HAM1-1G91300",
        "product_image": "https://img.lazcdn.com/g/p/3caab988088cecc8cf3fbef4ac53d278.jpg_200x200q90.jpg",
        "price": 50076,
        "remark": "https://www.lazada.co.th/products/pdp-i4380269620.html",
        "sold": 0
    },
    {
        "product_name": "Juicer เครื่องคั้นสกัดนํ้าต้นอ่อนข้าวสาลี ระบบไฟฟ้า Stainless Steel Wheatgrass Juicer เกลียวคั้น ห้องคั้นทำจากสแตนเลสเนื้อดี ใช้คั้นต้นอ่อนข้าวสาลี",
        "product_image": "https://img.lazcdn.com/g/p/e86bf524f19de9a0102d73919296806c.jpg_200x200q90.jpg",
        "price": 49800,
        "remark": "https://www.lazada.co.th/products/pdp-i259928658.html",
        "sold": 0
    },
    {
        "product_name": "Ninja Foodi 2-in-1  เครื่องปั่นอาหาร  Power Nutri Mixer with Cup (700 ml) and Bowl (400 ml), 1100 W, Smart Torque Motor and Auto-iQ Technology สี Silver",
        "product_image": "https://img.lazcdn.com/g/p/a7fe715e76b3ef23fe199982f83c6572.jpg_200x200q90.jpg",
        "price": 49800,
        "remark": "https://www.lazada.co.th/products/pdp-i4966697057.html",
        "sold": 0
    },
    {
        "product_name": "Ninja เครื่องปั่นเอนกประสงค์  ร้อน/เย็น Cold & Hot Blender 2-in-1 รองรับทั้งร้อน และเย็น Soup Maker & Blender ทำซุปร้อน และสมูตตี้เย็นๆ ได้ (นำเข้าจากยุโรป)",
        "product_image": "https://img.lazcdn.com/g/p/ec93272eb61a9f0b495b5a286be60a1c.jpg_200x200q90.jpg",
        "price": 49800,
        "remark": "https://www.lazada.co.th/products/pdp-i713158748.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อน (6,000 วัตต์) รุ่น DDH6EC",
        "product_image": "https://img.lazcdn.com/g/p/718a0d0d72aa577f01167f8d31f24fdc.jpg_200x200q90.jpg",
        "price": 49364.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16079763477.html",
        "sold": 0
    },
    {
        "product_name": "MEX เครื่องทำน้ำอุ่น (6000 วัตต์) รุ่น CODE 6E (RMB)",
        "product_image": "https://img.lazcdn.com/g/p/9f9c0b40c30ec8133795b015e611b6a7.jpg_200x200q90.jpg",
        "price": 48852.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16079852051.html",
        "sold": 0
    },
    {
        "product_name": "MEX เครื่องทำน้ำร้อน (8000 วัตต์) รุ่น CUBE 8000R",
        "product_image": "https://img.lazcdn.com/g/p/d0229d426c89e5e61e92c3c094ba0521.jpg_200x200q90.jpg",
        "price": 48796.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16079778198.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำอุ่น (4500 วัตต์) รุ่น XG45EC Limited",
        "product_image": "https://img.lazcdn.com/g/p/ad55fb83082fb3dc16c37d2070313f4f.jpg_200x200q90.jpg",
        "price": 48796.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16079933183.html",
        "sold": 0
    },
    {
        "product_name": "ARISTON เครื่องทำน้ำอุ่น (3500 วัตต์) รุ่น AURES TOP 3.5 CU SBS",
        "product_image": "https://img.lazcdn.com/g/p/5e37a750e6171490b7f3941029806e28.jpg_200x200q90.jpg",
        "price": 48398.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16079762244.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำน้ำร้อนชนิดหม้อต้มไฟฟ้า DUX รุ่น Proflo 25 W, S 1",
        "product_image": "https://img.lazcdn.com/g/p/c71f247853e2148782d3b2f4705dedb3.jpg_200x200q90.jpg",
        "price": 48000,
        "remark": "https://www.lazada.co.th/products/pdp-i3536688723.html",
        "sold": 0
    },
    {
        "product_name": "Vitamix Explorian E310 Blender เครื่องปั่นอเนกประสงค์ Made in USA ใช้งานตามบ้านเท่านั้น Home Use Only โถ 2.0L ไฟไทย ใช้งานดีมาก ปั่นได้เนียน",
        "product_image": "https://img.lazcdn.com/g/p/6307d1dbca666101379dc3d6728dbd3e.jpg_200x200q90.jpg",
        "price": 47800,
        "remark": "https://www.lazada.co.th/products/pdp-i2147628760.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องปั่นน้ำผลไม้รอบสูง BRAUN JB9040BK 3 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/a0b8647911b56aec84991b82ea55292f.png_200x200q90.png",
        "price": 47800,
        "remark": "https://www.lazada.co.th/products/pdp-i5469306905.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องคั้นน้ำอ้อยระบบ 2 ระบบ 350w รุ่นA9L-2ระบบ ใช้งานง่าย เสียงเงียบมาก คั้นแห้ง ได้น้ำเยอะ ประสิทธิภาพสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5cc00abb8f824d349fb861190d0c1eb7R.jpg_200x200q90.jpg",
        "price": 47800,
        "remark": "https://www.lazada.co.th/products/pdp-i3481168976.html",
        "sold": 2
    },
    {
        "product_name": "Braun เครื่องปั่นทรงพลังสูง PowerBlend 9 รุ่น JB9040.BK",
        "product_image": "https://img.lazcdn.com/g/p/ac9e186675b863ceecf889a22a79e25c.jpg_200x200q90.jpg",
        "price": 47600,
        "remark": "https://www.lazada.co.th/products/pdp-i16111755840.html",
        "sold": 0
    },
    {
        "product_name": "Magimix 18082F Juice Expert 3 Chorme Mat/Noir / เครื่องคั้นน้ำผลไม้",
        "product_image": "https://img.lazcdn.com/g/p/acee36206b239176c9ea16b99aa01795.jpg_200x200q90.jpg",
        "price": 46866,
        "remark": "https://www.lazada.co.th/products/pdp-i4002041711.html",
        "sold": 0
    },
    {
        "product_name": "BAMIX 106.053 Gastro G350 (044) Light Grey / เครื่องปั่นอาหารแบบมือถือ",
        "product_image": "https://img.lazcdn.com/g/p/d62560f9b882c13b3ca149f5a66d545e.jpg_200x200q90.jpg",
        "price": 46866,
        "remark": "https://www.lazada.co.th/products/pdp-i9553280.html",
        "sold": 2
    },
    {
        "product_name": "MEX เครื่องทำน้ำร้อน ( 6000 วัตต์)  รุ่น CUBE6000R",
        "product_image": "https://img.lazcdn.com/g/p/62d5de93d11a02af6df87d48f74b935f.jpg_200x200q90.jpg",
        "price": 46524.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16081700613.html",
        "sold": 0
    },
    {
        "product_name": "Vitamix Explorian E310 Blender เครื่องปั่นอเนกประสงค์ Made in USA ใช้งานตามบ้านเท่านั้น Home Use Only โถ 1200 วัตต์ ไฟไทย ใช้งานดีมาก ปั่นได้เนียน",
        "product_image": "https://img.lazcdn.com/g/p/fef6c0749fcbaaa4899ff99b33254977.jpg_200x200q90.jpg",
        "price": 45800,
        "remark": "https://www.lazada.co.th/products/pdp-i1229610429.html",
        "sold": 18
    },
    {
        "product_name": "(Stiebel) เครื่องทำน้ำร้อนแบบผ่านร้อน 2,000 W รุ่น EBK 5 G",
        "product_image": "https://img.lazcdn.com/g/p/4fc2487de81c30d77e6c015fd2e5b5c7.jpg_200x200q90.jpg",
        "price": 45300,
        "remark": "https://www.lazada.co.th/products/pdp-i6074215199.html",
        "sold": 0
    },
    {
        "product_name": "MEX เครื่องทำน้ำอุ่น (5100 วัตต์, สีทองแดง)  รุ่น CODE 5E (RCA)",
        "product_image": "https://img.lazcdn.com/g/p/3e54f0c95b0644499a166fffd25fe65d.jpg_200x200q90.jpg",
        "price": 44876.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16081750414.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อนหม้อต้ม ESH 150 H PLUS T ขนาด 150 ลิตร แนวนอน/หม้อต้ม เครื่องทำน้ำร้อน 150ลิตร แนวนอน",
        "product_image": "https://img.lazcdn.com/g/p/f406764b4b06c80406778b51a52d0216.png_200x200q90.png",
        "price": 44188,
        "remark": "https://www.lazada.co.th/products/pdp-i5420248501.html",
        "sold": 0
    },
    {
        "product_name": "Stiebel eltron เครื่องทำน้ำร้อน DHF 18C",
        "product_image": "https://img.lazcdn.com/g/p/b5c5475a74414661b3a29855e0c3c030.jpg_200x200q90.jpg",
        "price": 43980,
        "remark": "https://www.lazada.co.th/products/pdp-i1254114517.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อน DHB-E 18SLi",
        "product_image": "https://img.lazcdn.com/g/p/cf56ad785a42c88780f373085c7ade4f.jpg_200x200q90.jpg",
        "price": 43980,
        "remark": "https://www.lazada.co.th/products/pdp-i336334367.html",
        "sold": 0
    },
    {
        "product_name": "FERROLI เครื่องทำน้ำร้อนชนิดหม้อต้ม รุ่น SEV 80",
        "product_image": "https://img.lazcdn.com/g/p/d09058b80d26b873f158d3a4cf372f9e.jpg_200x200q90.jpg",
        "price": 43600,
        "remark": "https://www.lazada.co.th/products/pdp-i16111972104.html",
        "sold": 0
    },
    {
        "product_name": "SIRMAN เครื่องคั้นน้ำผลไม้แบบแยกกาก 400W SIR1-EKTOR 37",
        "product_image": "https://img.lazcdn.com/g/p/1bede2428c937a62360b2bcd367afb6f.jpg_200x200q90.jpg",
        "price": 43250,
        "remark": "https://www.lazada.co.th/products/pdp-i4377398004.html",
        "sold": 0
    },
    {
        "product_name": "Joyoung 6L Air Fryer — รุ่นใหม่สำหรับบ้าน: หม้อทอดและเตาอบไฟฟ้าอเนกประสงค์ขนาดใหญ่ ความจุสูง พร้อมหน้าต่างโปร่งใส - Kerwin Wat",
        "product_image": "https://img.lazcdn.com/g/p/65179155294560af11e9637624aab301.jpg_webp_200x200q90.jpg",
        "price": 43176.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16132464082.html",
        "sold": 0
    },
    {
        "product_name": "MEX เครื่องทำน้ำอุ่น ( 5100 วัตต์) CRYSTAL 5E (WH)",
        "product_image": "https://img.lazcdn.com/g/p/c0951e739fa02b814d3e9fc527b3d818.jpg_200x200q90.jpg",
        "price": 43116.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16081779413.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำอุ่น (6000 วัตต์) รุ่น DS 60EC",
        "product_image": "https://img.lazcdn.com/g/p/8202ce48c7cb33153cb7102eb2eb95b2.jpg_200x200q90.jpg",
        "price": 43116.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16081830211.html",
        "sold": 0
    },
    {
        "product_name": "Tefal AEROSTEAM เครื่องรีดไอน้ำ (1400 วัตต์, สี Eucalyptus) รุ่น DT9814",
        "product_image": "https://img.lazcdn.com/g/p/6f19807abfdf25a42faeb92137c69f70.jpg_200x200q90.jpg",
        "price": 43116.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16078177056.html",
        "sold": 0
    },
    {
        "product_name": "(Stiebel) เครื่องทำน้ำร้อนแบบผ่านร้อน 18,000 W รุ่น DHF 18 C",
        "product_image": "https://img.lazcdn.com/g/p/9f0dfa69aa16168b3260a4a2cb940da5.jpg_200x200q90.jpg",
        "price": 42880,
        "remark": "https://www.lazada.co.th/products/pdp-i6074094057.html",
        "sold": 0
    },
    {
        "product_name": "Robot Coupe Mini MP 190 VV.Blender 230V/50/1 (34750) / เครื่องปั่นแบบมือถือ",
        "product_image": "https://img.lazcdn.com/g/p/04ffb7b2cf2aa4ea15c882e1399a57fe.jpg_200x200q90.jpg",
        "price": 42586,
        "remark": "https://www.lazada.co.th/products/pdp-i100101877.html",
        "sold": 0
    },
    {
        "product_name": "AUX | เครื่องทำน้ำร้อนไฟฟ้าใช้พลังงานอย่างมีประสิทธิภาพ ความจุ 60 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb56d27b4782e4ff49439e7543866e8dcl.jpg_200x200q90.jpg",
        "price": 42464,
        "remark": "https://www.lazada.co.th/products/pdp-i16127816502.html",
        "sold": 0
    },
    {
        "product_name": "Tefal เตารีดแรงดันไอน้ำอเนกประสงค์ All in one IXEO VISION รุ่น QT1811",
        "product_image": "https://img.lazcdn.com/g/p/5950cefde4291682ac3e07738647acfd.png_200x200q90.png",
        "price": 42158,
        "remark": "https://www.lazada.co.th/products/pdp-i5873861145.html",
        "sold": 0
    },
    {
        "product_name": "ARISTON เครื่องทำน้ำอุ่น (4500 วัตต์) รุ่น AURES PREMIUM+ 4.5 C",
        "product_image": "https://img.lazcdn.com/g/p/f6650c3419cd2f10737751ebb3d5c10f.jpg_200x200q90.jpg",
        "price": 42093.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16079828095.html",
        "sold": 0
    },
    {
        "product_name": "Hurom H400 P + W เครื่องปั่นผสมมอเตอร์ไร้เสียงแบบแฮนด์ฟรีเครื่องคั้นน้ำหมุนช้าทำความสะอาดง่ายแบบเกาหลี",
        "product_image": "https://img.lazcdn.com/g/p/a036b5ff088a5920a5bed4d2952333cb.jpg_200x200q90.jpg",
        "price": 42026,
        "remark": "https://www.lazada.co.th/products/pdp-i5711904969.html",
        "sold": 0
    },
    {
        "product_name": "Hurom H400 W + B เครื่องปั่นผสมมอเตอร์ไร้เสียงแบบแฮนด์ฟรีเครื่องคั้นน้ำหมุนช้าทำความสะอาดง่ายแบบเกาหลี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc0a02645c0324547a08bc85729d8bab5p.jpg_200x200q90.jpg",
        "price": 42026,
        "remark": "https://www.lazada.co.th/products/pdp-i5712071557.html",
        "sold": 1
    },
    {
        "product_name": "Hamilton Beach | เครื่องปั่นหลายฟังก์ชันขนาดเล็กสำหรับครัวเรือน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S26393961e1c2445986346ae0064542act.jpg_200x200q90.jpg",
        "price": 42008.38,
        "remark": "https://www.lazada.co.th/products/pdp-i5991099252.html",
        "sold": 1
    },
    {
        "product_name": "(Stiebel) เครื่องทำน้ำร้อนแบบหม้อต้ม 150 L รุ่น ESH 150 H Plus T",
        "product_image": "https://img.lazcdn.com/g/p/76a427ef40886032bf24bdde2d73c1ff.jpg_200x200q90.jpg",
        "price": 41998,
        "remark": "https://www.lazada.co.th/products/pdp-i16043692501.html",
        "sold": 0
    },
    {
        "product_name": "(Stiebel) เครื่องทำน้ำร้อนแบบหม้อต้ม 150 L รุ่น EVS 150",
        "product_image": "https://img.lazcdn.com/g/p/de5c478e13f4450e37c1c7d75657079a.jpg_200x200q90.jpg",
        "price": 41998,
        "remark": "https://www.lazada.co.th/products/pdp-i6074609302.html",
        "sold": 0
    },
    {
        "product_name": "Tefal เตารีดแรงดันไอน้ำอเนกประสงค์ All in one IXEO VISION กำลังไฟ 2200 วัตต์ รุ่น QT1811",
        "product_image": "https://img.lazcdn.com/g/p/2360cea47c2a5ffb320b7dd5dc0e32e5.png_200x200q90.png",
        "price": 41558,
        "remark": "https://www.lazada.co.th/products/pdp-i5873838357.html",
        "sold": 0
    },
    {
        "product_name": "ARISTON เครื่องทำน้ำอุ่น (4500 วัตต์) รุ่น Aures Round Smart 4.5W",
        "product_image": "https://img.lazcdn.com/g/p/9dfd03ee5b1c98657a1608e3b497d248.jpg_200x200q90.jpg",
        "price": 41411.94,
        "remark": "https://www.lazada.co.th/products/pdp-i16081704598.html",
        "sold": 0
    },
    {
        "product_name": "ตู้อบผ้า Tefal GV9580 กำลังไฟฟ้าสูง กำลังสูง อบผ้าติดผนัง ตู้อบผ้าแบบมีสาย กำลังไฟฟ้า 220V ตู้อบผ้าแบบมีสาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sea9c502c77344b36b1a706e544c9cdeeF.jpg_200x200q90.jpg",
        "price": 41012,
        "remark": "https://www.lazada.co.th/products/pdp-i5280721190.html",
        "sold": 0
    },
    {
        "product_name": "Tefal All in one IXEO VISION เตารีดแรงดันไอน้ำอเนกประสงค์ รุ่น QT1811",
        "product_image": "https://img.lazcdn.com/g/p/df6383c4321df4d3ffb304eb54e6f4f7.png_200x200q90.png",
        "price": 40978,
        "remark": "https://www.lazada.co.th/products/pdp-i5873740986.html",
        "sold": 0
    },
    {
        "product_name": "Joyoung | เครื่องปั่นอาหารอเนกประสงค์ไร้มือถือ ปรับความถี่ได้ ทำงานเงียบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa0b02cbee90e4281a984484b6005c33ed.png_200x200q90.png",
        "price": 40692.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16052434016.html",
        "sold": 0
    },
    {
        "product_name": "Joyoung | เครื่องทำนมถั่วเหลือง สำหรับบ้าน แบบอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S02ae93cedc914d759d0464a589cf86bac.png_200x200q90.png",
        "price": 40675.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16051328024.html",
        "sold": 0
    },
    {
        "product_name": "ARISTON เครื่องทำน้ำอุ่น (3500 วัตต์) รุ่น AURES PREMIUM+ 3.5 C",
        "product_image": "https://img.lazcdn.com/g/p/b911816d10e20fa77deabb4c3dc7ecdc.jpg_200x200q90.jpg",
        "price": 40275.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16081669603.html",
        "sold": 0
    },
    {
        "product_name": "(Stiebel) เครื่องทำน้ำร้อนแบบผ่านร้อน 10/12 kW รุ่น DCE-M 10/12 T",
        "product_image": "https://img.lazcdn.com/g/p/69a8cc1a72acad2abd03b867b7204ab4.jpg_200x200q90.jpg",
        "price": 40240,
        "remark": "https://www.lazada.co.th/products/pdp-i6073998692.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องปั่นน้ำผลไม้ ปั่นน้ำแข็งเกล็ดหิมะ 16นิ้วx23นิ้ว พร้อมมอเตอร์ขนาดใหญ่ 3 แรง",
        "product_image": "https://img.lazcdn.com/g/p/e01837ed450dc2ebdaa87b19f8f79e08.jpg_200x200q90.jpg",
        "price": 40232,
        "remark": "https://www.lazada.co.th/products/pdp-i2515097737.html",
        "sold": 0
    },
    {
        "product_name": "(MEX) เครื่องทำน้ำร้อนชนิดหม้อต้ม A.O.Smith รุ่น MEV-100 (ขนาด 100 ลิตร)",
        "product_image": "https://img.lazcdn.com/g/p/7c3f13f0e9a3644dd5323607d2105b47.jpg_200x200q90.jpg",
        "price": 39800,
        "remark": "https://www.lazada.co.th/products/pdp-i3916782817.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องปั่นน้ำผลไม้ SMEG BLF03",
        "product_image": "https://img.lazcdn.com/g/p/49fc14ca350e4f912ad6c5c9c336ac26.jpg_200x200q90.jpg",
        "price": 39800,
        "remark": "https://www.lazada.co.th/products/pdp-i5469520892.html",
        "sold": 1
    },
    {
        "product_name": "ASTINA เครื่องทำน้ำร้อน (8000 วัตต์) รุ่น EC-999EM (X5)8.0KW",
        "product_image": "https://img.lazcdn.com/g/p/5eaea12f3ede747d5f5f7bb941d7f19b.jpg_200x200q90.jpg",
        "price": 39707.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16079674486.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องบดปั่นสำหรับอบในบ้าน H400เครื่องปั่นน้ำผลไม้ใหม่",
        "product_image": "https://img.lazcdn.com/g/p/54819f348ee1ded48efbcd1142621548.jpg_200x200q90.jpg",
        "price": 39370,
        "remark": "https://www.lazada.co.th/products/pdp-i16058239760.html",
        "sold": 0
    },
    {
        "product_name": "RUSSELL HOBBS หม้อทอดไร้น้ำมัน (1600 วัตต์, 3.5 ลิตร, สีดำ) รุ่น RHAF3-TH",
        "product_image": "https://img.lazcdn.com/g/p/dde9fe9507af14ab003041888a03f8e3.jpg_200x200q90.jpg",
        "price": 39195.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16077990328.html",
        "sold": 0
    },
    {
        "product_name": "@HOME เครื่องรีดถนอมผ้าไอน้ำ (1500 วัตต์ , 2 ลิตร, สีดำ) รุ่น HO0239",
        "product_image": "https://img.lazcdn.com/g/p/ff947f446d11e3e456a4bd5dfa370f5e.jpg_200x200q90.jpg",
        "price": 39195.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16077740992.html",
        "sold": 0
    },
    {
        "product_name": "Kuvings เครื่องสกัดเย็นคั้นน้ำผลไม้ EVO820(NS-1226)",
        "product_image": "https://img.lazcdn.com/g/p/ad21ab6c49532c82ac943320c5467279.jpg_200x200q90.jpg",
        "price": 39080,
        "remark": "https://www.lazada.co.th/products/pdp-i363394007.html",
        "sold": 83
    },
    {
        "product_name": "Ratika | เครื่องปั่นน้ำผลไม้ 3.5 แรงม้า MAX MIXER PRO เครื่องปั่นสมูทตี้",
        "product_image": "https://img.lazcdn.com/g/p/9be8499dd6dbe1fadde07722441e72f6.jpg_200x200q90.jpg",
        "price": 39000,
        "remark": "https://www.lazada.co.th/products/pdp-i4165982900.html",
        "sold": 0
    },
    {
        "product_name": "HILLKOFF : เครื่องปั่นสมูทตี้ MAX MIXER PRO 3.5 แรงม้า เครื่องปั่น อเนกประสงค์ เครื่องปั่นน้ําผลไม้ ปั่นสมูทตี้ Blender Mixer",
        "product_image": "https://img.lazcdn.com/g/p/ef3b4d2658629e5fcddec17aa04779fb.jpg_200x200q90.jpg",
        "price": 39000,
        "remark": "https://www.lazada.co.th/products/pdp-i4184880560.html",
        "sold": 0
    },
    {
        "product_name": "พร้อมส่ง STIEBEL ELTRON เครื่องทำน้ำร้อน DHB-E 13SLi",
        "product_image": "https://img.lazcdn.com/g/p/cf56ad785a42c88780f373085c7ade4f.jpg_200x200q90.jpg",
        "price": 38780,
        "remark": "https://www.lazada.co.th/products/pdp-i2360377707.html",
        "sold": 0
    },
    {
        "product_name": "MEX เครื่องทำน้ำร้อน ( 6000 วัตต์)  รุ่น CENTRI 6R",
        "product_image": "https://img.lazcdn.com/g/p/959585a8e7b8c1a113c0ea3751fe1d0a.jpg_200x200q90.jpg",
        "price": 38571.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16079739561.html",
        "sold": 0
    },
    {
        "product_name": "Joyoung | เครื่องปั่นอัตโนมัติหลายฟังก์ชัน ไร้การสัมผัส ปรับความถี่ได้ เงียบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S46486a548f6e48138006b6c6c2101daaP.png_200x200q90.png",
        "price": 38245.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16051063986.html",
        "sold": 0
    },
    {
        "product_name": "(Stiebel) เครื่องทำน้ำร้อนแบบผ่านร้อน 13,000 W รุ่น DHB-E 13 Sli",
        "product_image": "https://img.lazcdn.com/g/p/8c270204d1ae1b8bed84c8f4d57b6be7.jpg_200x200q90.jpg",
        "price": 37820,
        "remark": "https://www.lazada.co.th/products/pdp-i6074081757.html",
        "sold": 0
    },
    {
        "product_name": "ส่งฟรี เครื่องทำน้ำร้อน STIEBEL ELTRON รุ่น DHB-E 11 SLi",
        "product_image": "https://img.lazcdn.com/g/p/cf56ad785a42c88780f373085c7ade4f.jpg_200x200q90.jpg",
        "price": 37780,
        "remark": "https://www.lazada.co.th/products/pdp-i336308973.html",
        "sold": 0
    },
    {
        "product_name": "MEX เครื่องทำน้ำอุ่น (3700 วัตต์, สีดำ)  รุ่น CRYSTAL 3I (NE)",
        "product_image": "https://img.lazcdn.com/g/p/502b24f00aa482ab57265ab6e5e1cd19.jpg_200x200q90.jpg",
        "price": 37435.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16081605755.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำอุ่น (4500 วัตต์) รุ่น XGL 45 EC",
        "product_image": "https://img.lazcdn.com/g/p/7d6c4951cd3b4c599714dfbd9b5dddd7.jpg_200x200q90.jpg",
        "price": 36867.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16081798310.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำอุ่น (4500 วัตต์) รุ่น DS 45EC",
        "product_image": "https://img.lazcdn.com/g/p/6c5b29d5f2fab50f4cc185ddab4b9652.jpg_200x200q90.jpg",
        "price": 36867.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16079790210.html",
        "sold": 0
    },
    {
        "product_name": "MEX เครื่องทำน้ำอุ่น ( 5100 วัตต์) รุ่น CUBE 5E (SA)",
        "product_image": "https://img.lazcdn.com/g/p/4cd1fd330704bc4564f9f6d9de55bcc2.jpg_200x200q90.jpg",
        "price": 36867.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16081639684.html",
        "sold": 0
    },
    {
        "product_name": "MEX เครื่องทำน้ำอุ่น (5100 วัตต์, สีดำ) รุ่น CUBE 5E (MB)",
        "product_image": "https://img.lazcdn.com/g/p/09f09156546b60468eab2c5f87a73da6.jpg_200x200q90.jpg",
        "price": 36867.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16081758423.html",
        "sold": 0
    },
    {
        "product_name": "(Stiebel) เครื่องทำน้ำร้อนแบบผ่านร้อน 11,000 W รุ่น DHB-E 11 Sli",
        "product_image": "https://img.lazcdn.com/g/p/0a84b124150d930c64675278437ca8cd.jpg_200x200q90.jpg",
        "price": 36720,
        "remark": "https://www.lazada.co.th/products/pdp-i6074137309.html",
        "sold": 0
    },
    {
        "product_name": "Tefal เครื่องดูแลผ้าไอน้ำอัตโนมัติ รุ่น YT4050E1 CARE FOR YOU I-BLUE ECO (1800 วัตต์)",
        "product_image": "https://img.lazcdn.com/g/p/8c39552c1113ff87be9c4b0efc966921.png_200x200q90.png",
        "price": 36498,
        "remark": "https://www.lazada.co.th/products/pdp-i4805528295.html",
        "sold": 21
    },
    {
        "product_name": "RINNAI เครื่องทำน้ำร้อน (6000 วัตต์) รุ่น DENKI 600MP",
        "product_image": "https://img.lazcdn.com/g/p/d86913c673dd720b20f8ac6135ec04af.jpg_200x200q90.jpg",
        "price": 36299.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16079903246.html",
        "sold": 0
    },
    {
        "product_name": "Elvira Power Blender Rainbow เครื่องปั่น - สีเหลือง Banana",
        "product_image": "https://img.lazcdn.com/g/p/ad9ef50821ed63b9de2e1bf3a46ad99e.jpg_200x200q90.jpg",
        "price": 36237.6,
        "remark": "https://www.lazada.co.th/products/pdp-i8733551.html",
        "sold": 0
    },
    {
        "product_name": "Elvira Power Blender Rainbow เครื่องปั่น สีมิ้นต์ Soda",
        "product_image": "https://img.lazcdn.com/g/p/1c36e8185a6deb24bc7520e7821fa585.jpg_200x200q90.jpg",
        "price": 36237.6,
        "remark": "https://www.lazada.co.th/products/pdp-i499379.html",
        "sold": 0
    },
    {
        "product_name": "(Stiebel) เครื่องทำน้ำร้อนแบบหม้อต้ม 100 L รุ่น EVS 100",
        "product_image": "https://img.lazcdn.com/g/p/f916b3724b40d571895b91af3f9c75e1.jpg_200x200q90.jpg",
        "price": 36060,
        "remark": "https://www.lazada.co.th/products/pdp-i6074539947.html",
        "sold": 0
    },
    {
        "product_name": "(Stiebel) เครื่องทำน้ำร้อนแบบหม้อต้ม 100 L รุ่น ESH 100 H Plus T",
        "product_image": "https://img.lazcdn.com/g/p/c947c1bf594bf5ef2d60024f9f769e4e.jpg_200x200q90.jpg",
        "price": 36060,
        "remark": "https://www.lazada.co.th/products/pdp-i16043684667.html",
        "sold": 0
    },
    {
        "product_name": "SURE เตารีดไอน้ำหม้อต้มอุตสาหกรรม SR-1H / SR-2H (ไฟฟ้าไอน้ำ) (🔥 ดูดปั๊มน้ำอัตโนมัติ) เตารีดไอน้ำแบบหม้อต้ม",
        "product_image": "https://img.lazcdn.com/g/p/78e79f40e86a5c5c83da67d23778385a.jpg_200x200q90.jpg",
        "price": 36000,
        "remark": "https://www.lazada.co.th/products/pdp-i4294266371.html",
        "sold": 1
    },
    {
        "product_name": "SURE เตารีดไอน้ำหม้อต้มอุตสาหกรรม (🔥 ดูดปั๊มน้ำอัตโนมัติ ใช้ต่อเนื่อง 24 ชม.) SR-1H / SR-2H  เตารีดไอน้ำแบบหม้อต้ม",
        "product_image": "https://img.lazcdn.com/g/p/db7dd26557d32a89a6564a530c26a868.jpg_200x200q90.jpg",
        "price": 36000,
        "remark": "https://www.lazada.co.th/products/pdp-i4290555250.html",
        "sold": 0
    },
    {
        "product_name": "Braun เครื่องปั่นเอนกประสงค์ รุ่น JB7192",
        "product_image": "https://img.lazcdn.com/g/p/cfeba43bd8bafce2cb17c2e8c3fdd187.jpg_200x200q90.jpg",
        "price": 35960,
        "remark": "https://www.lazada.co.th/products/pdp-i16111861259.html",
        "sold": 0
    },
    {
        "product_name": "MEX เครื่องทำน้ำร้อนชนิดหม้อต้ม A.O.Smith รุ่น MEV-100 ขนาด 100 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/777d0840a69b4fcf3deb34f40f82b47d.png_200x200q90.png",
        "price": 35800,
        "remark": "https://www.lazada.co.th/products/pdp-i4826295011.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องกำเนิดไอน้ำสำหรับห้องอบไอน้ำในบ้าน 9KW เครื่องกำเนิดไอน้ำสำหรับซาวน่าในครัวเรือน",
        "product_image": "https://img.lazcdn.com/g/p/f1396685fea8c3244242aad3f03a8b3d.jpg_webp_200x200q90.jpg",
        "price": 35787.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16091189987.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำอุ่น (3500 วัตต์) รุ่น DS 35EC",
        "product_image": "https://img.lazcdn.com/g/p/1531c01f086be572116db7293f537366.jpg_200x200q90.jpg",
        "price": 35731.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16079758276.html",
        "sold": 0
    },
    {
        "product_name": "RINNAI เครื่องทำน้ำอุ่น (3500 วัตต์) รุ่น SENTO 350",
        "product_image": "https://img.lazcdn.com/g/p/577e8bbc30742f246b90831bfdf73907.jpg_200x200q90.jpg",
        "price": 35163.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16079933186.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อนหม้อต้มแนวนอน 2000 วัตต์ 150 ลิตร รุ่น ESH-150HPT โดย สยามทีวี by Siam T.V.",
        "product_image": "https://img.lazcdn.com/g/p/c524f0759634e181ccd9e0e16affa599.jpg_200x200q90.jpg",
        "price": 34980,
        "remark": "https://www.lazada.co.th/products/pdp-i4660817493.html",
        "sold": 0
    },
    {
        "product_name": "MEX MEX เครื่องทำน้ำอุ่น ( 3500 วัตต์)  รุ่น CUBE 35E (SA)",
        "product_image": "https://img.lazcdn.com/g/p/0812c7cf283a19e54ea5d3b4da1ae1fb.jpg_200x200q90.jpg",
        "price": 34595.32,
        "remark": "https://www.lazada.co.th/products/pdp-i16079810125.html",
        "sold": 0
    },
    {
        "product_name": "MEX เครื่องทำน้ำอุ่น (3500 วัตต์, สีดำ) รุ่น CUBE 35E (MB)",
        "product_image": "https://img.lazcdn.com/g/p/608ee5556122901d1c0034f6cb4ab159.jpg_200x200q90.jpg",
        "price": 34595.32,
        "remark": "https://www.lazada.co.th/products/pdp-i16081843299.html",
        "sold": 0
    },
    {
        "product_name": "Rinnai เครื่องทำน้ำอุ่น (4500 วัตต์) รุ่น KIN450(BL)",
        "product_image": "https://img.lazcdn.com/g/p/25e76745c8796de85bc2bbed6d1c4e4a.jpg_200x200q90.jpg",
        "price": 34027.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16081897164.html",
        "sold": 0
    },
    {
        "product_name": "iMIX Soundproof/ Blender + 1 blender jar, 1680W เครื่องปั่น รุ่นฝาครอบกันเสียงปั่น แถมโถปั่น 1 ใบ by Rich Healthcare",
        "product_image": "https://img.lazcdn.com/g/p/d3ef7db11f1966ff5cbd04c664f613bd.png_200x200q90.png",
        "price": 34000,
        "remark": "https://www.lazada.co.th/products/pdp-i5999791485.html",
        "sold": 0
    },
    {
        "product_name": "iMIX เครื่องปั่นน้ำผลไม้ เครื่องผสม มีฝาครอบ ลดเสียงดัง 1680 W พิเศษ แถมโถให้เพิ่มฟรีอีก 1 ใบ 1602-137",
        "product_image": "https://img.lazcdn.com/g/p/3130b9ce39e2d852fecd7b89bea6168a.jpg_200x200q90.jpg",
        "price": 33980,
        "remark": "https://www.lazada.co.th/products/pdp-i5127787075.html",
        "sold": 0
    },
    {
        "product_name": "4.4 NORTHSTAR WATER FESTIVAL SALE เครื่องทำน้ำร้อนหม้อต้มดิจิตอล 100 ลิตร 2.5kw รุ่น SVD-100",
        "product_image": "https://img.lazcdn.com/g/p/6e788e1d88d926ad853559dc33757045.jpg_200x200q90.jpg",
        "price": 33980,
        "remark": "https://www.lazada.co.th/products/pdp-i5603969948.html",
        "sold": 0
    },
    {
        "product_name": "(MEX) เครื่องทำน้ำร้อนชนิดหม้อต้ม A.O.Smith รุ่น MEV-50 (ขนาด 50 ลิตร)",
        "product_image": "https://img.lazcdn.com/g/p/cb7bdbb191d5ef2009c591bc56aa9bf7.jpg_200x200q90.jpg",
        "price": 33800,
        "remark": "https://www.lazada.co.th/products/pdp-i3916837113.html",
        "sold": 0
    },
    {
        "product_name": "(ตรวจเช็คหน้างานฟรี) MEX รุ่น MEV-50 A.O.Smith เครื่องทำน้ำร้อนชนิดหม้อต้ม ขนาด 50 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/3370c079dd9d72566d6adbb434aa046b.jpg_200x200q90.jpg",
        "price": 33800,
        "remark": "https://www.lazada.co.th/products/pdp-i4979974342.html",
        "sold": 0
    },
    {
        "product_name": "(MEX) ELJH-80 เครื่องทำน้ำร้อนไฟฟ้า ขนาด 80 ลิตร ชนิดถังเก็บแบบแขวนผนัง แนวนอน",
        "product_image": "https://img.lazcdn.com/g/p/30972ab1097d047388d3caa704eb6790.jpg_200x200q90.jpg",
        "price": 33800,
        "remark": "https://www.lazada.co.th/products/pdp-i4120189495.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อนแบบหม้อต้ม(แนวนอน) รุ่นESH 150 H Plus T",
        "product_image": "https://img.lazcdn.com/g/p/d5aaf711a08c40cb462f95aa31df6c40.jpg_200x200q90.jpg",
        "price": 33800,
        "remark": "https://www.lazada.co.th/products/pdp-i5036904240.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสกัดเย็น Kenwood JMP85.000SI ความจุ 600ml โถกาก 1 ลิตร คั้นน้ำผลไม้เพื่อสุขภาพ ดีไซน์พรีเมียม ทำความสะอาดง่าย รับประกัน 2 ปี",
        "product_image": "https://img.lazcdn.com/g/p/14151329ba518dfe369a9613bf8f48ef.png_200x200q90.png",
        "price": 33780,
        "remark": "https://www.lazada.co.th/products/pdp-i16053831621.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อนแบบหม้อต้ม(แนวนอน) รุ่น ESH 100 H Plus T",
        "product_image": "https://img.lazcdn.com/g/p/eccd41cfb0d39e2c531570f054129ab5.png_200x200q90.png",
        "price": 33764,
        "remark": "https://www.lazada.co.th/products/pdp-i4826463661.html",
        "sold": 0
    },
    {
        "product_name": "KENWOOD เครื่องสกัดน้ำผลไม้แยกกาก รุ่น JMP85.000SI 250W Slow Juicer รอบต่ำ 55RPM น้ำไม่แยกชั้น คงคุณค่าวิตามิน รับประกันศูนย์ 2 ปี",
        "product_image": "https://img.lazcdn.com/g/p/8fb855d1e174fa0abf303b5391c8d4d5.png_200x200q90.png",
        "price": 33760,
        "remark": "https://www.lazada.co.th/products/pdp-i16053841550.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสqueezing แบบอัตโนมัติ Breville ขนาดใหญ่ รับประทานในโรงแรม ร้านอาหาร บ้าน ผลไม้ น้ำผลไม้ แยกส่วน เครื่องมือทำอาหารแบบอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf5fefd92736c45f79529f4d200e85d96F.png_200x200q90.png",
        "price": 33496,
        "remark": "https://www.lazada.co.th/products/pdp-i5401060986.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำความร้อนระบบเหนี่ยวนำแม่เหล็กไฟฟ้า ABS ทองเหลือง800 ℃ เครื่องทำความร้อนระบบเหนี่ยวนำแม่เหล็กหน่วงไฟน็อตสกรูโรงงานเครื่องมือลบ",
        "product_image": "https://img.lazcdn.com/g/p/861456182280fd5530f962520ecfec46.jpg_200x200q90.jpg",
        "price": 33462,
        "remark": "https://www.lazada.co.th/products/pdp-i6049572373.html",
        "sold": 0
    },
    {
        "product_name": "(Stiebel) เครื่องทำน้ำร้อนแบบหม้อต้ม 80 L รุ่น ESH 80 H Plus T",
        "product_image": "https://img.lazcdn.com/g/p/e0cd0b785c7ca36d12accc7d408877c3.jpg_200x200q90.jpg",
        "price": 33420,
        "remark": "https://www.lazada.co.th/products/pdp-i16043688506.html",
        "sold": 0
    },
    {
        "product_name": "(Stiebel) เครื่องทำน้ำร้อนแบบหม้อต้ม 80 L รุ่น EVS 80",
        "product_image": "https://img.lazcdn.com/g/p/2ab706749a7fa0db5937ffd4acf9b728.jpg_200x200q90.jpg",
        "price": 33420,
        "remark": "https://www.lazada.co.th/products/pdp-i6074609065.html",
        "sold": 0
    },
    {
        "product_name": "Corona CORONA CH-12RB-W ความร้อนสูงอินฟราเรด",
        "product_image": "https://img.lazcdn.com/g/p/735983bd2e2756d3f391edfc059eec47.png_200x200q90.png",
        "price": 33210,
        "remark": "https://www.lazada.co.th/products/pdp-i16118940398.html",
        "sold": 0
    },
    {
        "product_name": "Kenwood Slow Juicer รุ่น JMP85 เครื่องคั้นน้ำผักผลไม้แยกกาก 250 วัตต์ เสียงเงียบ สกัดเย็น 55 รอบ/นาที น้ำเข้มข้น กากแห้ง ของแท้",
        "product_image": "https://img.lazcdn.com/g/p/1df8cf9ab23975ba81dcd666193c1b64.png_200x200q90.png",
        "price": 33100,
        "remark": "https://www.lazada.co.th/products/pdp-i16054146717.html",
        "sold": 0
    },
    {
        "product_name": "Hurom ปากกดเย็น H430เกาหลีเครื่องคั้นน้ำหมุนช้าเครื่องปั่นทำความสะอาดง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S831396dd2af34200962cee050d3cecb1D.jpg_200x200q90.jpg",
        "price": 32850,
        "remark": "https://www.lazada.co.th/products/pdp-i16110506871.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON DHF 13C เครื่องทำน้ำร้อน ระบบไฟ 3 เฟส",
        "product_image": "https://img.lazcdn.com/g/p/b5c5475a74414661b3a29855e0c3c030.jpg_200x200q90.jpg",
        "price": 32600,
        "remark": "https://www.lazada.co.th/products/pdp-i4996038469.html",
        "sold": 0
    },
    {
        "product_name": "MEX เครื่องทำน้ำอุ่น (4500 วัตต์) รุ่น CRAVE 45E",
        "product_image": "https://img.lazcdn.com/g/p/109c96902490c42716a8a882db2a75be.jpg_200x200q90.jpg",
        "price": 32323.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16081887194.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำอุ่น (4800 วัตต์) รุ่น XG48 EC",
        "product_image": "https://img.lazcdn.com/g/p/e846ede6f2d6b50f86251d4ddb4bdb60.jpg_200x200q90.jpg",
        "price": 32323.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16081801378.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำน้ำร้อนขนาดเล็กทันทีประหยัดพลังงานอุณหภูมิคงที่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa9a8754f08ad450e91f9a7d5c71b9e15o.png_200x200q90.png",
        "price": 32066,
        "remark": "https://www.lazada.co.th/products/pdp-i16069151403.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อนแบบหม้อต้มแนวตั้ง รุ่น EVS 100 / EVS 150 เครื่องทำน้ำร้อนติดผนัง ขนาด 100 ลิตร / 150 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/b1a2edd624b6edef58d0d0353ada7b7d.jpg_200x200q90.jpg",
        "price": 32000,
        "remark": "https://www.lazada.co.th/products/pdp-i5617469384.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อนแบบหม้อต้ม (แนวตั้ง) EVS 100 - EVS150 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/e042381da05ce10f0d97768530327356.jpg_200x200q90.jpg",
        "price": 32000,
        "remark": "https://www.lazada.co.th/products/pdp-i5630148302.html",
        "sold": 0
    },
    {
        "product_name": "Tefal เครื่องดูแลผ้าไอน้ำอัตโนมัติ CARE FOR YOU FIRST รุ่น YT2020E0 รับประกัน 2 ปี ส่งฟรีทั่วไทย",
        "product_image": "https://img.lazcdn.com/g/p/226024e11ca530446b3e1893d6310207.jpg_200x200q90.jpg",
        "price": 31998,
        "remark": "https://www.lazada.co.th/products/pdp-i5284787243.html",
        "sold": 54
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อน รุ่น DHB-E13Sli -13000 วัตต์ ไฟ 3เฟส โดย สยามทีวี by Siam T.V.",
        "product_image": "https://img.lazcdn.com/g/p/14b756311d4c73672640ebbe1ee6b676.jpg_200x200q90.jpg",
        "price": 31900,
        "remark": "https://www.lazada.co.th/products/pdp-i4840368893.html",
        "sold": 0
    },
    {
        "product_name": "Tefal เตารีดแรงดันไอน้ำพลังสูง รุ่น GV9712 PRO EXPRESS ULTIMATE II",
        "product_image": "https://img.lazcdn.com/g/p/921262a0423399d7ffb0de7a6a11e52d.png_200x200q90.png",
        "price": 31900,
        "remark": "https://www.lazada.co.th/products/pdp-i5643730479.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำน้ำร้อนแก๊สKANGDA-28Lขนาดใหญ่ 28 ลิตรเกรดคุณภาพหม้อต้มทองแดงขนาดใหญ่หนาพิเศษรับประกันศูนย์ไทย3ปีใช้งานง่ายปลอดภภํย",
        "product_image": "https://img.lazcdn.com/g/p/f902433c3b9029e91473e6193684095e.jpg_200x200q90.jpg",
        "price": 31800,
        "remark": "https://www.lazada.co.th/products/pdp-i6045599659.html",
        "sold": 0
    },
    {
        "product_name": "พร้อมส่ง เครื่องปั่นรุ่นใหม่ GreenGene Y MAX ตะกร้ามีของแถม",
        "product_image": "https://img.lazcdn.com/g/p/5e22910e6adfe8c81a95f856ccf509d1.jpg_200x200q90.jpg",
        "price": 31800,
        "remark": "https://www.lazada.co.th/products/pdp-i5987105102.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำน้ำร้อนแก๊สKANGDA-28Lขนาดใหญ่ 28 ลิตรเกรดคุณภาพหม้อต้มทองแดงขนาดใหญ่หนาพิเศษรับประกันศูนย์ไทย5ปีใช้งานง่ายปลอดภัย",
        "product_image": "https://img.lazcdn.com/g/p/9d44c086a79af0076ad83a82f6bc249f.jpg_200x200q90.jpg",
        "price": 31800,
        "remark": "https://www.lazada.co.th/products/pdp-i6045684082.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON DHB-E13SLI เครื่องทำน้ำร้อน 12000W. 3เฟส",
        "product_image": "https://img.lazcdn.com/g/p/cf56ad785a42c88780f373085c7ade4f.jpg_200x200q90.jpg",
        "price": 31800,
        "remark": "https://www.lazada.co.th/products/pdp-i4996110017.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องปั่นน้ำ ผลไม้-สมูทตี้ พร้อมฝาครอบลดเสียงดัง รุ่นMAXIMUM Blender Smoothie ปรับได้หลายระดับ รับประกัน 1 ปี **สอบถามวิธีใช้งานได้ค่ะ**",
        "product_image": "https://img.lazcdn.com/g/p/160198338f186a78e16709bd53d36c8e.jpg_200x200q90.jpg",
        "price": 31800,
        "remark": "https://www.lazada.co.th/products/pdp-i307502398.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อนแบบหม้อต้ม แนวนอน 150 ลิตร ESH150 H PLUS T (รับประกันศูนย์)",
        "product_image": "https://img.lazcdn.com/g/p/1db438e3b878919e6e4eb19bef908505.jpg_200x200q90.jpg",
        "price": 31796,
        "remark": "https://www.lazada.co.th/products/pdp-i4252445225.html",
        "sold": 1
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อนแบบหม้อต้ม แนวตั้ง 150 ลิตร EVS150 (รับประกันศูนย์)",
        "product_image": "https://img.lazcdn.com/g/p/202b92e04847d71b3070949bc52d7043.png_200x200q90.png",
        "price": 31796,
        "remark": "https://www.lazada.co.th/products/pdp-i4247573629.html",
        "sold": 3
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำอุ่น (4500 วัตต์) รุ่น IS45E-2",
        "product_image": "https://img.lazcdn.com/g/p/6155965357e18a185580e3c88b494090.jpg_200x200q90.jpg",
        "price": 31755.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16079792176.html",
        "sold": 0
    },
    {
        "product_name": "ASTINA เครื่องทำน้ำอุ่น (4500 วัตต์) รุ่น IM-9E V10 SIL 4.5KW",
        "product_image": "https://img.lazcdn.com/g/p/abbea08564fec42e4145f1d987ff4780.jpg_200x200q90.jpg",
        "price": 31755.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16081837281.html",
        "sold": 0
    },
    {
        "product_name": "[จัดส่งพร้อมติดตั้ง] ARISTON เครื่องทำน้ำร้อน AURES ME 8000 วัตต์ สีขาว/ดำ",
        "product_image": "https://img.lazcdn.com/g/p/4dd6f74a79042097c283504add55d661.jpg_200x200q90.jpg",
        "price": 31400,
        "remark": "https://www.lazada.co.th/products/pdp-i4889961616.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องปั่นอเนกประสงค์ TAC รุ่น Classic C3 ขนาด 1.4 L",
        "product_image": "https://img.lazcdn.com/g/p/c18e72e4e7cadfebc680db2d72acc92d.png_200x200q90.png",
        "price": 31250,
        "remark": "https://www.lazada.co.th/products/pdp-i5654022379.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องปั่นสมูทตี้ ไร้เสียงรบกวน ZYLO รุ่น Quiet A8 ขนาด 1.8 L",
        "product_image": "https://img.lazcdn.com/g/p/e46b8ba4795b301a8bfcffe6033e858e.png_200x200q90.png",
        "price": 31250,
        "remark": "https://www.lazada.co.th/products/pdp-i5653846753.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องปั่นน้ำผลไม้ HEALTHY-MIX HMB-01 1.80 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/f30741ff64140428e5b1bc46da889a84.png_200x200q90.png",
        "price": 31180,
        "remark": "https://www.lazada.co.th/products/pdp-i5469304785.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องปั่น เครื่องปั่นรุ่น Alton Blender 2",
        "product_image": "https://img.lazcdn.com/g/p/4f2c6b3dfbd0f3a3028cbfb07baa0993.jpg_200x200q90.jpg",
        "price": 31000,
        "remark": "https://www.lazada.co.th/products/pdp-i4882151355.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องทำน้ำร้อนแก๊สKANGDA-28Lขนาดใหญ่ 28 ลิตรเกรดคุณภาพหม้อต้มทองแดงขนาดใหญ่หนาพิเศษรับประกันศูนย์ไทย3ปีใช้งานง่ายปลอดภัย",
        "product_image": "https://img.lazcdn.com/g/p/3f016dea3b6fe87be5499350709bbc65.jpg_200x200q90.jpg",
        "price": 31000,
        "remark": "https://www.lazada.co.th/products/pdp-i6045620884.html",
        "sold": 0
    },
    {
        "product_name": "SHANBEN เตารีดไอน้ำหม้อต้มอุตสาหกรรม ( ดูดปั๊มน้ำอัตโนมัติ ใช้ต่อเนื่อง 24 ชม.) SR-1H / SR-2H เตารีดไอน้ำแบบหม้อต้ม",
        "product_image": "https://img.lazcdn.com/g/p/215b74dfe60a4dcf2ca2f2108bac7412.jpg_200x200q90.jpg",
        "price": 30800,
        "remark": "https://www.lazada.co.th/products/pdp-i16072603616.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อน แบบหม้อต้ม รุ่น EVS100 -100ลิตร โดย สยามทีวี by Siam T.V.",
        "product_image": "https://img.lazcdn.com/g/p/97bab134cc22b4351e39929b6c8d4dc2.jpg_200x200q90.jpg",
        "price": 30580,
        "remark": "https://www.lazada.co.th/products/pdp-i16057165099.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อน แบบหม้อต้ม รุ่นESH-100H-Plus-T แนวนอน โดย สยามทีวี by Siam T.V.",
        "product_image": "https://img.lazcdn.com/g/p/4a979564427ce8b346255098b66ba688.jpg_200x200q90.jpg",
        "price": 30536,
        "remark": "https://www.lazada.co.th/products/pdp-i3413791840.html",
        "sold": 1
    },
    {
        "product_name": "(Stiebel) เครื่องทำน้ำร้อน 8,000 W รุ่น DCE-L 8 T",
        "product_image": "https://img.lazcdn.com/g/p/4de9b1037ee007ec265b1dee5f2db3e4.jpg_200x200q90.jpg",
        "price": 30340,
        "remark": "https://www.lazada.co.th/products/pdp-i6073873783.html",
        "sold": 0
    },
    {
        "product_name": "RINNAI  เครื่องทำน้ำอุ่น (4500วัตต์)  รุ่น KIN450 (PW)",
        "product_image": "https://img.lazcdn.com/g/p/9de67b6b7aa0fc2b099ed5fc36ecd9cb.jpg_200x200q90.jpg",
        "price": 30050.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16081718531.html",
        "sold": 0
    },
    {
        "product_name": "MEX เครื่องทำน้ำอุ่น (3500 วัตต์) รุ่น CRAVE 35E",
        "product_image": "https://img.lazcdn.com/g/p/7828ad09294c8859f3049be6ea17c4df.jpg_200x200q90.jpg",
        "price": 30050.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16081748429.html",
        "sold": 0
    },
    {
        "product_name": "Stiebel Eltron เครื่องทำน้ำร้อนสตีเบลรุ่น DCE-M 10/12T (10/12-12/14.3kW./1phase/220V)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf9461fc5964c487e9bc72614a532ad6f1.jpg_200x200q90.jpg",
        "price": 29980,
        "remark": "https://www.lazada.co.th/products/pdp-i4376188423.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำความร้อนระบบเหนี่ยวนำแม่เหล็กเครื่องทำความร้อนระบบเหนี่ยวนำแม่เหล็กตัวเหนี่ยวนำแม่เหล็กไฟฟ้า50-60Hz ทองเหลือง1500W สนิมกำจัดน็อตสกรูมือถือสำหรับรถยนต์",
        "product_image": "https://img.lazcdn.com/g/p/861456182280fd5530f962520ecfec46.jpg_200x200q90.jpg",
        "price": 29918,
        "remark": "https://www.lazada.co.th/products/pdp-i6049557545.html",
        "sold": 0
    },
    {
        "product_name": "( พร้อมส่ง )เครื่องทำร้อน รุ่น DCE-M 10/12 T ของแท้100%",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8edb64fbbb7944f7aafc1a189af0d34bj.jpg_200x200q90.jpg",
        "price": 29900,
        "remark": "https://www.lazada.co.th/products/pdp-i5689630666.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อน ขนาด 13000 วัตต์ รุ่น DHB-E 13 SLi (Made in Germany) ชนิดขดลวดทำความร้อน ระบบไฟ 3 เฟส ปรับความร้อนได้ 7 ระดับ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfa9d504eba5a4e0babdc11cb6e14c12cx.jpg_200x200q90.jpg",
        "price": 29800,
        "remark": "https://www.lazada.co.th/products/pdp-i4573750793.html",
        "sold": 14
    },
    {
        "product_name": "Dyson Pure Cool ™ Air Purifier Fan TP00 (White/Silver) เครื่องฟอกอากาศ ไดสัน สีขาว",
        "product_image": "https://img.lazcdn.com/g/p/eb99729d0a7a150e8929c2aa213b0a13.jpg_200x200q90.jpg",
        "price": 29800,
        "remark": "https://www.lazada.co.th/products/pdp-i2387579353.html",
        "sold": 718
    },
    {
        "product_name": "ULKA Blender รุ่น 2B เครื่องปั่น เครื่องปั่นสมูทตี้ เครื่องปั่นน้ำผลไม้ แรง ทนทาน ใบมีดสแตนเลส 6 แฉก มาตรฐานญี่ปุ่น",
        "product_image": "https://img.lazcdn.com/g/p/182121ee3848c5240c4c022d0bb04ada.png_200x200q90.png",
        "price": 29800,
        "remark": "https://www.lazada.co.th/products/pdp-i5892181981.html",
        "sold": 0
    },
    {
        "product_name": "[สินค้าพร้อมจัดส่ง]⭐⭐MIUI Slow Juicer 7-Stage Spiral Cold Press Patented Filterless Technology Easy to Clean Electric Commercial Juicer[สินค้าใหม่]จัดส่งฟรีมีบริการเก็บเงินปลายทาง⭐⭐",
        "product_image": "https://img.lazcdn.com/g/p/07dcaf01d4a9d4e0f8fb753df3e66215.jpg_200x200q90.jpg",
        "price": 29626.74,
        "remark": "https://www.lazada.co.th/products/pdp-i4580209774.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำความร้อนแม่เหล็กไฟฟ้า ABS ทองเหลือง1500W อุปกรณ์กำจัดน็อตสกรูเครื่องทำความร้อนระบบเหนี่ยวนำแม่เหล็กแบบพกพาสำหรับโรงงาน",
        "product_image": "https://img.lazcdn.com/g/p/6918a7c924363c77557de28fa40495ec.jpg_200x200q90.jpg",
        "price": 29564,
        "remark": "https://www.lazada.co.th/products/pdp-i6066204680.html",
        "sold": 0
    },
    {
        "product_name": "Tefal เตารีดแรงดันไอน้ำอเนกประสงค์ All in one IXEO VISION  รุ่น QT1811",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S00957c0c9ff64e41a889b01dc5686247k.jpg_200x200q90.jpg",
        "price": 29560,
        "remark": "https://www.lazada.co.th/products/pdp-i5845790055.html",
        "sold": 67
    },
    {
        "product_name": "(Stiebel) เครื่องทำน้ำร้อน 6,000 W รุ่น DCE-L 6 T",
        "product_image": "https://img.lazcdn.com/g/p/4de9b1037ee007ec265b1dee5f2db3e4.jpg_200x200q90.jpg",
        "price": 29460,
        "remark": "https://www.lazada.co.th/products/pdp-i6073999202.html",
        "sold": 0
    },
    {
        "product_name": "JTC TM-800AQ Omni Blend V Professional Blender / เครื่องปั่นแบบมีฝาครอบ",
        "product_image": "https://img.lazcdn.com/g/p/e9970e2c812bc0b01674b04bcb1c0b3a.jpg_200x200q90.jpg",
        "price": 28890,
        "remark": "https://www.lazada.co.th/products/pdp-i9094716.html",
        "sold": 2
    },
    {
        "product_name": "JTC TM-800AQ OmniBlend V Heavy Duty Professional Commercial Blender / เครื่องปั่น",
        "product_image": "https://img.lazcdn.com/g/p/eb3dd5decb40a3bfbf0c6c25a785edaf.jpg_200x200q90.jpg",
        "price": 28890,
        "remark": "https://www.lazada.co.th/products/pdp-i3157775523.html",
        "sold": 0
    },
    {
        "product_name": "LENODI high speed blender 2000ML เครื่องปั่นสมูทตี้ แบบเก็บเสียง เพื่อการพาณิชย์ มอเตอร์ทองแดงแท้",
        "product_image": "https://img.lazcdn.com/g/p/3c6728a30bd4120d1e7f7b0d2e86264a.jpg_200x200q90.jpg",
        "price": 28798,
        "remark": "https://www.lazada.co.th/products/pdp-i5909255488.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อน แบบหม้อต้ม รุ่น ESH 80 H Plus T แนวนอน โดย สยามทีวี by Siam T.V.",
        "product_image": "https://img.lazcdn.com/g/p/5e84631503c5e08ceaae1def38595628.jpg_200x200q90.jpg",
        "price": 28380,
        "remark": "https://www.lazada.co.th/products/pdp-i5276315082.html",
        "sold": 0
    },
    {
        "product_name": "Rheem เครื่องทำน้ำร้อนแบบหม้อต้ม ความจุ 100 ลิตร กำลังไฟ 2500W รุ่น RVE-100 โดย สยามทีวี by Siam T.V.",
        "product_image": "https://img.lazcdn.com/g/p/caa4eed3a735e743c4ce8de2846eade8.jpg_200x200q90.jpg",
        "price": 28380,
        "remark": "https://www.lazada.co.th/products/pdp-i3014682663.html",
        "sold": 1
    },
    {
        "product_name": "(Stiebel) เครื่องทำน้ำร้อนแบบหม้อต้ม 50 L รุ่น EVS 50",
        "product_image": "https://img.lazcdn.com/g/p/8b9ec86384c23878386482c9a7eb04c1.jpg_200x200q90.jpg",
        "price": 28360,
        "remark": "https://www.lazada.co.th/products/pdp-i6074560442.html",
        "sold": 0
    },
    {
        "product_name": "(Stiebel) เครื่องทำน้ำร้อนแบบหม้อต้ม 50 L รุ่น ESH 50 H Plus T",
        "product_image": "https://img.lazcdn.com/g/p/f68162e9ccc5c53af4f15a3a0d169539.jpg_200x200q90.jpg",
        "price": 28360,
        "remark": "https://www.lazada.co.th/products/pdp-i6079211876.html",
        "sold": 0
    },
    {
        "product_name": "ULKA Blender เครื่องปั่น เครื่องปั่นสมูทตี้ เครื่องปั่นอุตสาหกรรม เสียงเงียบ แรง ทนทาน ใบมีดสแตนเลส 6 แฉก ปั่นละเอียด",
        "product_image": "https://img.lazcdn.com/g/p/6001e3fee83c2b14d9ee1c38711bbc5c.jpg_200x200q90.jpg",
        "price": 28310,
        "remark": "https://www.lazada.co.th/products/pdp-i5892255326.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องคั้นน้ำอ้อย ไฟฟ้า รุ่นใหม่ (2ระบบ) 1.ระบบไฟแบต 2.ระบบไฟบ้าน (ใช้งานไม่ต้องเสียบปลั๊ก) เครื่องทำน้ำอ้อย เครื่องรีดน้ำอ้อย",
        "product_image": "https://img.lazcdn.com/g/p/74b48c64bb725cd7b6181af26c65e6f7.png_200x200q90.png",
        "price": 28270,
        "remark": "https://www.lazada.co.th/products/pdp-i2107402999.html",
        "sold": 36
    },
    {
        "product_name": "AUX | เครื่องทำน้ำอุ่นไฟฟ้า ความจุเล็ก ทำความร้อนเร็ว 3000W",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4cc93a5f23b74808a5028fd5866b3b73O.jpg_200x200q90.jpg",
        "price": 28152,
        "remark": "https://www.lazada.co.th/products/pdp-i16127441320.html",
        "sold": 0
    },
    {
        "product_name": "Tefal IXEO VISION All-in-One เตารีดแรงดันไอน้ำอเนกประสงค์ รุ่น QT1811T0 – 2200W / 6 บาร์",
        "product_image": "https://img.lazcdn.com/g/p/0dc5781f6e6e420200042b65b81fe78b.jpg_200x200q90.jpg",
        "price": 27990,
        "remark": "https://www.lazada.co.th/products/pdp-i5966799560.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสกัดน้ำผลไม้รอบต่ำ KUVINGS NS-1721 1.20ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/64d603bdcfc790e22ee863dcb70e10c2.png_200x200q90.png",
        "price": 27980,
        "remark": "https://www.lazada.co.th/products/pdp-i5422211674.html",
        "sold": 1
    },
    {
        "product_name": "JTC เครื่องปั่นสมูทตี้  รุ่น TM-800AQ OmniBlend  พร้อมกล่องเก็บเสียง",
        "product_image": "https://img.lazcdn.com/g/p/41fdc5dd3f6d879ed6b8c14a8c2c0552.png_200x200q90.png",
        "price": 27980,
        "remark": "https://www.lazada.co.th/products/pdp-i4256336828.html",
        "sold": 0
    },
    {
        "product_name": "3L 5000แบบสองห้อง + เรือกลไฟหม้อทอด Air Fryer 6ลิตร220V 2200W ปลั๊กมาตรฐาน3ขา",
        "product_image": "https://img.lazcdn.com/g/p/77ef6fadeae57339ada0b071e3f806f2.jpg_200x200q90.jpg",
        "price": 27936,
        "remark": "https://www.lazada.co.th/products/pdp-i16144104732.html",
        "sold": 0
    },
    {
        "product_name": "[GlobalLink] หม้อทอดไร้น้ำมัน หม้อทอดไร้มัน 8 ลิตร 3000W อเนกประสงค์ อบลมร้อน ระบบตัดไฟฟ้าอัตโนมัติ Air Fryer อเนกประสงค์ หน้าจอแสดงผลแบบสี",
        "product_image": "https://img.lazcdn.com/g/p/6a4e7baf232309ad77f55cb374acd738.jpg_200x200q90.jpg",
        "price": 27924.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16114529737.html",
        "sold": 0
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อน กำลังไฟ 8000 วัตต์ สีเงิน รุ่น DHC 8 EC",
        "product_image": "https://img.lazcdn.com/g/p/027e7671a0067349ad005200b308ed7c.png_200x200q90.png",
        "price": 27807,
        "remark": "https://www.lazada.co.th/products/pdp-i6048530867.html",
        "sold": 0
    },
    {
        "product_name": "พร้อมส่ง เครื่องปั่นรุ่นใหม่ GreenGene Y MAX (ราคาพิเศษไม่มีของแถม)",
        "product_image": "https://img.lazcdn.com/g/p/6d4126c8cc220d43aad3eaf17e933b29.jpg_200x200q90.jpg",
        "price": 27800,
        "remark": "https://www.lazada.co.th/products/pdp-i4138816918.html",
        "sold": 63
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำอุ่น (4500 วัตต์) รุ่น WS45E-2",
        "product_image": "https://img.lazcdn.com/g/p/651209f0fd9aa9fe98954ca8a0c88a49.jpg_200x200q90.jpg",
        "price": 27778.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16081722467.html",
        "sold": 0
    },
    {
        "product_name": "MEX เครื่องทำน้ำอุ่น ( 5100 วัตต์) รุ่น CODE 5E (CB)",
        "product_image": "https://img.lazcdn.com/g/p/963f454339b1097c3831737ac94bee4b.jpg_200x200q90.jpg",
        "price": 27778.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16081869206.html",
        "sold": 0
    },
    {
        "product_name": "AUX | เครื่องทำน้ำอุ่นสำหรับครัวเรือนประหยัดพลังงาน ถังคู่บางพิเศษ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S82b702ad206b43d48e5e66a06ded692bJ.jpg_200x200q90.jpg",
        "price": 27776,
        "remark": "https://www.lazada.co.th/products/pdp-i16127492879.html",
        "sold": 0
    },
    {
        "product_name": "HOMEMATE ชุดเครื่องปั่นร้อน-เย็นความเร็วสูง พร้อมโถปั่นของแห้ง รุ่น HOM-128021",
        "product_image": "https://img.lazcdn.com/g/p/e3837819a28da1b86c7627adbf696893.jpg_200x200q90.jpg",
        "price": 27710,
        "remark": "https://www.lazada.co.th/products/pdp-i5196171313.html",
        "sold": 1
    },
    {
        "product_name": "Kitchen Aid (KitchenAid) 5KSB5553EAC Artisan Blender 5 Speed - Creme / เครื่องปั่น",
        "product_image": "https://img.lazcdn.com/g/p/ce310347b45a43e30318eb3ae686f646.jpg_200x200q90.jpg",
        "price": 27606,
        "remark": "https://www.lazada.co.th/products/pdp-i715610172.html",
        "sold": 1
    },
    {
        "product_name": "BRAUN เครื่องปั่น 2ลิตร 1600W รุ่นJB9040BK โดย สยามทีวี by Siam T.V.",
        "product_image": "https://img.lazcdn.com/g/p/2d931a757322d3e1deea18474915fde0.jpg_200x200q90.jpg",
        "price": 27500,
        "remark": "https://www.lazada.co.th/products/pdp-i6046523406.html",
        "sold": 0
    },
    {
        "product_name": "KitchenAid Slow Juicer เครื่องคั้นน้ำแยกกากสกัดเย็นผักและผลไม้  [5KVJ0111]",
        "product_image": "https://img.lazcdn.com/g/p/0ac9ff803eda3cdcb5d563021567b2ba.jpg_200x200q90.jpg",
        "price": 27400,
        "remark": "https://www.lazada.co.th/products/pdp-i259652835.html",
        "sold": 2
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อนแบบหม้อต้ม แนวนอน 100 ลิตร ESH100 H PLUS T (รับประกันศูนย์)",
        "product_image": "https://img.lazcdn.com/g/p/68da7bd61910c105abfe1815efb3a870.jpg_200x200q90.jpg",
        "price": 27196,
        "remark": "https://www.lazada.co.th/products/pdp-i4251832785.html",
        "sold": 13
    },
    {
        "product_name": "STIEBEL ELTRON เครื่องทำน้ำร้อนแบบหม้อต้ม แนวตั้ง 100 ลิตร EVS100 (รับประกันศูนย์)",
        "product_image": "https://img.lazcdn.com/g/p/885cc2288751091b9eb51e6f970fd17f.png_200x200q90.png",
        "price": 27196,
        "remark": "https://www.lazada.co.th/products/pdp-i4247521154.html",
        "sold": 9
    },
    {
        "product_name": "เครื่องรีดไอน้ำสำหรับบ้าน 26 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S36eccbd5ee774b3f943a154f98363a00u.jpg_200x200q90.jpg",
        "price": 27050,
        "remark": "https://www.lazada.co.th/products/pdp-i16124537075.html",
        "sold": 0
    },
    {
        "product_name": "room_shop101 MIDEA เครื่องทำน้ำอุ่น ขนาด  4500 วัตต์ รุ่น DSK45EY5 สีขาว",
        "product_image": "https://img.lazcdn.com/g/p/422c8aac0adbe5aebd947d7f44942b50.jpg_200x200q90.jpg",
        "price": 27040,
        "remark": "https://www.lazada.co.th/products/pdp-i5437162122.html",
        "sold": 0
    },
    {
        "product_name": "COSORI Air Fryer Lite หม้อทอดลมร้อนไร้น้ำมัน 3.8L, 75-230 ℃, 7 Cooking Functions, Smart Control, 1500W, 1-3 Portions",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa1bacb3bfb764b109e3b2a78163574e42.jpg_200x200q90.jpg",
        "price": 27030,
        "remark": "https://www.lazada.co.th/products/pdp-i16124184044.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องปั่นน้ำผลไม้ MINIMEX MCB1-2 1.5ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/e6b574d2d97800eb2d73319c9c884236.png_200x200q90.png",
        "price": 27000,
        "remark": "https://www.lazada.co.th/products/pdp-i5177757518.html",
        "sold": 0
    },
    {
        "product_name": "FERROLI เครื่องทำน้ำร้อนชนิดหม้อต้ม รุ่น SEV 100 (ชนิดถังตั้ง)",
        "product_image": "https://img.lazcdn.com/g/p/242d68194751490e65181c352eb3bc39.jpg_200x200q90.jpg",
        "price": 26994,
        "remark": "https://www.lazada.co.th/products/pdp-i4321372999.html",
        "sold": 2
    },
    {
        "product_name": "STIEBEL เครื่องทำน้ำร้อนแบบหม้อต้ม (แนวนอน) ขนาด 80 ลิตร รุ่น ESH 80 H Plus T",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0f7fbf1a5cc445bdbda675ffd2c38228v.jpg_200x200q90.jpg",
        "price": 26980,
        "remark": "https://www.lazada.co.th/products/pdp-i161188104.html",
        "sold": 3
    },
    {
        "product_name": "ขดลวดเหนี่ยวนำเครื่องทำความร้อนระบบเหนี่ยวนำแม่เหล็กเครื่องทำความร้อนการป้องกันการลัดวงจรไฟฟ้าความร้อนไร้เปลวไฟสำหรับการกำจัดถั่ว",
        "product_image": "https://img.lazcdn.com/g/p/1bd21dc8cb69b7f86cb4d9b3072271d7.jpg_200x200q90.jpg",
        "price": 26864,
        "remark": "https://www.lazada.co.th/products/pdp-i6047726844.html",
        "sold": 0
    },
    {
        "product_name": "HOMEMATE เครื่องปั่นร้อน-เย็นความเร็วสูง 25000 รอบ พร้อมโถปั่นของแห้ง รุ่น HOM-128021",
        "product_image": "https://img.lazcdn.com/g/p/88d605e50a446ea169090b42b802cfb6.jpg_200x200q90.jpg",
        "price": 26770,
        "remark": "https://www.lazada.co.th/products/pdp-i5190980868.html",
        "sold": 2
    },
    {
        "product_name": "[สินค้าใหม่] Tefal เครื่องปั่นอาหารเมนูร้อนเย็นพลังสูง Ultrablend Silence รุ่น BL98S เครื่องปั่นน้ำผลไม้ เครื่องปั่นtefal เครื่องปั่นร้อนเย็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd2295bf8fbc5492cb97d288e09e96bd3m.jpg_200x200q90.jpg",
        "price": 26700,
        "remark": "https://www.lazada.co.th/products/pdp-i4360988188.html",
        "sold": 67
    },
    {
        "product_name": "MOVESPEED | ไดรฟ์แฟลช USB พอร์ตคู่ Type-C ความจุสูง 1TB โอนถ่ายข้อมูลความเร็วสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S123a95392a834d4d920032490cb68bfb2.jpg_200x200q90.jpg",
        "price": 18257.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5909580158.html",
        "sold": 126
    },
    {
        "product_name": "Brateck | ที่วางทีวีแบบมือถือ 32-85 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8df98097d5be4388a9b1fbe70f7a9f92C.jpg_200x200q90.jpg",
        "price": 15112.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5931033792.html",
        "sold": 52
    },
    {
        "product_name": "EHOMEWEI | จอภาพพกพา 16 นิ้ว",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S710687a5f6ce4f608a4a81187838c05ek.jpg_200x200q90.jpg",
        "price": 15097.36,
        "remark": "https://www.lazada.co.th/products/pdp-i5909686058.html",
        "sold": 14
    },
    {
        "product_name": "โทรศัพท์ติดตั้งประจำเครือข่าย IP",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sef026670c75d4903b7114deedb6047657.png_200x200q90.png",
        "price": 13491.62,
        "remark": "https://www.lazada.co.th/products/pdp-i6005826725.html",
        "sold": 0
    },
    {
        "product_name": "SANDISK Ultra DualDrive LUXE FlashDrive 1TB (400MB/s) (Metal) USB3.2 Gen1, Type C, A OTG Flash drive ของแท้ แฟลชไดรฟ์ โทรศัพท์ มือถือ Tablet SDDDC4",
        "product_image": "https://img.lazcdn.com/g/p/73a1928c41a56f398658b261a6695cd6.png_200x200q90.png",
        "price": 13278,
        "remark": "https://www.lazada.co.th/products/pdp-i4706965466.html",
        "sold": 3
    },
    {
        "product_name": "Lexar PLAY PRO microSDXC Express การ์ดหน่วยความจำความเร็วสูงพิเศษ สำหรับเกมมิ่ง วิดีโอ 4K/8K และมือถือ",
        "product_image": "https://img.lazcdn.com/g/p/a48d948de5ad5174f46b2aef4235291e.png_200x200q90.png",
        "price": 12380,
        "remark": "https://www.lazada.co.th/products/pdp-i5805224496.html",
        "sold": 0
    },
    {
        "product_name": "ชุดอุปกรณ์เสริม Vivo X300 และ X300 Pro ซื้อแยก ZEISS 2.35x Telephoto Extender Kit Compatible และ vivo PGYTECH Imaging Grip Kit",
        "product_image": "https://img.lazcdn.com/g/p/1669f2b7b4085765b70321ac98ca0626.jpg_200x200q90.jpg",
        "price": 11998,
        "remark": "https://www.lazada.co.th/products/pdp-i5961522358.html",
        "sold": 33
    },
    {
        "product_name": "เครื่องทำฮีตเตอร์ต่อประกบเซ็นเซอร์อัจฉริยะเครื่องต่อใยแก้วนำแสงหลอมรวมอิสระกับแบตเตอรี่โทรศัพท์ Li ชาร์จซ้ำได้สำหรับงานกลางแจ้งฮีตเตอร์ความร้อน",
        "product_image": "https://img.lazcdn.com/g/p/22c6279de3c286f3790c2aca73dd7200.jpg_200x200q90.jpg",
        "price": 11274,
        "remark": "https://www.lazada.co.th/products/pdp-i6052171971.html",
        "sold": 0
    },
    {
        "product_name": "SanDisk Ultra® Dual Drive Luxe USB Type-C 1TB (SDDDC4-1T00-G46)แฟลชไดรฟ์ ไดร์ฟOTG สำหรับโทรศัพท์ แทปเลท Tablet iPad Pro",
        "product_image": "https://img.lazcdn.com/g/p/d059b3a7da531ec6006b0318c9a7617e.jpg_200x200q90.jpg",
        "price": 9980,
        "remark": "https://www.lazada.co.th/products/pdp-i5684395919.html",
        "sold": 0
    },
    {
        "product_name": "EHOMEWEI | หน้าจอขยายพกพาหลายอุปกรณ์ 16 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2ffa67dce9d34bca8b1dd1eaab5ec4f7y.jpg_200x200q90.jpg",
        "price": 9762.18,
        "remark": "https://www.lazada.co.th/products/pdp-i5909612989.html",
        "sold": 206
    },
    {
        "product_name": "ประหยัดพื้นที่หนีบโต๊ะสายไฟ2 USB C Port PD18W/65W เครื่องชาร์จเร็ว Overcurrent Protections 1.8M Cord",
        "product_image": "https://img.lazcdn.com/g/p/edd680b1d3e13032b693e7ed8479904a.jpg_200x200q90.jpg",
        "price": 8638,
        "remark": "https://www.lazada.co.th/products/pdp-i16105734879.html",
        "sold": 0
    },
    {
        "product_name": "MOVESPEED | ไดรฟ์แฟลช USB แบบสองอินเทอร์เฟซ (Type-C) ความเร็วสูงสำหรับมือถือและพีซี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa3445f2331a34b57b641fd1b15e840c4z.jpg_200x200q90.jpg",
        "price": 8488.52,
        "remark": "https://www.lazada.co.th/products/pdp-i5909519754.html",
        "sold": 165
    },
    {
        "product_name": "AMBITFUL T16หน้าจอขนาดใหญ่สำหรับโปรโมตสัมภาษณ์มืออาชีพ Teleprompter โทรศัพท์มือถือพับได้สำหรับกล้อง DSLR TeleprompterFor ถึง16 \"บันทึกวิดีโอถ่ายทอดสด",
        "product_image": "https://img.lazcdn.com/g/p/3749878d753dd4cfcb1ad1d0fdc4d95d.jpg_200x200q90.jpg",
        "price": 8240.64,
        "remark": "https://www.lazada.co.th/products/pdp-i4684917708.html",
        "sold": 6
    },
    {
        "product_name": "ZILAIXIU | สายชาร์จเร็ว 3-in-1 ยืดหยุ่น หลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8bbc09808db74e5f8e4990ef556f9684i.png_200x200q90.png",
        "price": 7543.28,
        "remark": "https://www.lazada.co.th/products/pdp-i6007666503.html",
        "sold": 0
    },
    {
        "product_name": "เลนส์ซูม APEXEL 20x-60x เลนส์กล้องโทรทรรศน์เทเลโฟโต้กำลังขยายสูง ใช้ได้กับโทรศัพท์มือถือ iPhone และ Android สำหรับดูนกและตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbbc14f68fdfb42e2b5beed69721222c7s.jpg_200x200q90.jpg",
        "price": 7342.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5961543742.html",
        "sold": 4
    },
    {
        "product_name": "ขาตั้งกล้องสามขาเหนือศีรษะ SmallRig | ขาตั้งเสากลางด้านข้าง (รับน้ำหนักสูงสุด10กก.) ความสูง26-185ซม. สำหรับอาหารมุมต่ำกล้องถ่ายรูป4288/5290โทรศัพท์มือถือที่ไม่มีกระจก",
        "product_image": "https://img.lazcdn.com/g/p/28fce3a237c7425fa7d06373be94236e.jpg_200x200q90.jpg",
        "price": 7138,
        "remark": "https://www.lazada.co.th/products/pdp-i5812781081.html",
        "sold": 0
    },
    {
        "product_name": "เลนส์ซูมเทเลโฟโต้ 400 มม. ความละเอียดสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S880475eee2a24671916fd2c3f015bc097.jpg_200x200q90.jpg",
        "price": 6952,
        "remark": "https://www.lazada.co.th/products/pdp-i16069106538.html",
        "sold": 0
    },
    {
        "product_name": "Alldocube iPlay 60s [4+128GB]แถมเคสหนังแท้ แบตอึด6,200mAh เครื่องศูนย์แท้ รับประกันศูนย์ไทย 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/fd9e9734ad9321dabd2f97a7b2360881.jpg_200x200q90.jpg",
        "price": 6780,
        "remark": "https://www.lazada.co.th/products/pdp-i5828811817.html",
        "sold": 0
    },
    {
        "product_name": "[พร้อมส่ง ไทย] ราคาโปร Insta360 กิมบอล ไม้กันสั่น มือถือ Flow 2 PRO ไม้เซลฟี่ ขาตั้งมือถือ ขาตั้งกล้อง เซลฟี่ Tripod Smartphone Gimbal",
        "product_image": "https://img.lazcdn.com/g/p/4b165b46bef44a1bd753dc21ce8d1803.jpg_200x200q90.jpg",
        "price": 6580,
        "remark": "https://www.lazada.co.th/products/pdp-i5958945508.html",
        "sold": 2
    },
    {
        "product_name": "AOCHUANสมาร์ทP2 3แกนGimbal Stabilizerผู้ถือโทรศัพท์แม่เหล็กBuilt-Inเติมแสงและ20ซม.ขยายRodสําหรับiPhone & Android",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sce324fc491b14e3bbbcb2f630514ed76C.jpg_200x200q90.jpg",
        "price": 6247.38,
        "remark": "https://www.lazada.co.th/products/pdp-i5846450696.html",
        "sold": 0
    },
    {
        "product_name": "Piconicer 4 Phone storage แฟลชไดร์ฟพกพาสำหรับมือถือ",
        "product_image": "https://img.lazcdn.com/g/p/a3393f2c3e81ef73f242028ee73b1520.jpg_200x200q90.jpg",
        "price": 6118.3,
        "remark": "https://www.lazada.co.th/products/pdp-i5301149508.html",
        "sold": 99
    },
    {
        "product_name": "apexel | เลนส์ซูม APEXEL 20x-60x เลนส์กล้องโทรทรรศน์เทเลโฟโต้กำลังขยายสูง ใช้ได้กับโทรศัพท์มือถือ iPhone และ Android สำหรับดูนกและตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd97c335fa616408fac71e16bfc0745e5u.jpg_200x200q90.jpg",
        "price": 5966.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16126808959.html",
        "sold": 0
    },
    {
        "product_name": "NEEWER 71\"/180ซม. ขาตั้งกล้องแบบขาเดียว ขาตั้งกล้องอะลูมิเนียมแบบทนทาน พกพาสะดวกสำหรับเดินทาง พร้อมขาตั้งโทรศัพท์มือถือแบบหัวบอล 360°",
        "product_image": "https://img.lazcdn.com/g/p/9e7d3abb4ac4a481bafe97518ce37e5b.jpg_200x200q90.jpg",
        "price": 5821.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5949156963.html",
        "sold": 1
    },
    {
        "product_name": "APEXEL 50x UltraTelephoto เลนส์ Universal โทรศัพท์ Professional กล้องโทรทรรศน์เลนส์ขาตั้งกล้องโลหะสําหรับ Camping ดูนก",
        "product_image": "https://img.lazcdn.com/g/p/c4a00050a5c0113c5f979ac5bc056008.jpg_200x200q90.jpg",
        "price": 5744,
        "remark": "https://www.lazada.co.th/products/pdp-i5889689667.html",
        "sold": 0
    },
    {
        "product_name": "APEXEL โทรศัพท์มือถือชุดเลนส์กล้องโทรศัพท์36X พร้อมกระเป๋าเลนส์หนีบโทรศัพท์อเนกประสงค์สำหรับขาตั้งกล้องทำจากโลหะเดินป่าตั้งแคมป์สัตว์ป่าการสังเกตดวงจันทร์กีฬาคอนเสิร์ตเกมดูสามารถใส่ได้กับ iPhone 14/13/12/11 Huawei สมาร์ทโฟน",
        "product_image": "https://img.lazcdn.com/g/p/1d350116ca356ca4d0bcacb684d009e9.jpg_200x200q90.jpg",
        "price": 5308,
        "remark": "https://www.lazada.co.th/products/pdp-i4664096969.html",
        "sold": 15
    },
    {
        "product_name": "GAN Fast Charge AENZR 130W Adapter PD QC3.0 หัวชาร์จ USB-C 4 พอร์ตชาร์จ ใช้พร้อมกันได้ Charger ชาร์จ USB C Type 100W",
        "product_image": "https://img.lazcdn.com/g/p/c42a64cf9c503719516eb9f57ebfec4f.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i4408163085.html",
        "sold": 0
    },
    {
        "product_name": "อะแดปเตอร์สำหรับยึดโทรศัพท์ Celestron NEXYZ 3-AXIS UNIVERSAL SMARTPHONE ADAPTER [CELESTRON OFFICAL]",
        "product_image": "https://img.lazcdn.com/g/p/71bc3443115497e8e6b732ee9eacf8a3.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i3797753747.html",
        "sold": 1
    },
    {
        "product_name": "PGYTECH MANTISPOD 2.0 ขาตั้งกล้องโทรศัพท์บลูทูธขนาดเล็ก สำหรับ Vlogging โทรศัพท์กล้อง 6 โหมด ขาตั้งพกพาได้ เหมาะสำหรับ DSLR โพเก็ต วิดีโอ การถ่ายเองบนโต๊ะ การถ่ายเองด้วยตนเอง รีโมทคอนโทรล",
        "product_image": "https://img.lazcdn.com/g/p/9a5e86aad5ce9f49661102ba8f57683a.jpg_200x200q90.jpg",
        "price": 5040,
        "remark": "https://www.lazada.co.th/products/pdp-i5353622511.html",
        "sold": 11
    },
    {
        "product_name": "✨Hot Sale! FlashDrive iXpand Luxe 64GB/128GB/256GB (SDIX70N) แฟลชไดร์ฟ OTG ใช้สำหรับ !Ph๐ne และ !Pad, มือถือAndroid TypeC สุดคุ้ม แฟลชไดร์ฟไอโฟน",
        "product_image": "https://img.lazcdn.com/g/p/3f67297c9c2887c3d4c0df20888f474f.jpg_200x200q90.jpg",
        "price": 4918,
        "remark": "https://www.lazada.co.th/products/pdp-i4619611621.html",
        "sold": 0
    },
    {
        "product_name": "PGYTECH Mantis ขาตั้งกล้อง SLR โทรศัพท์มือถือขาตั้งเซลฟี่เดสก์ท็อปแพน/เอียง vlog สดท่องเที่ยวการถ่ายภาพขาตั้งกล้อง",
        "product_image": "https://img.lazcdn.com/g/p/ae3b8707d54b6283be81cb42810ec061.jpg_200x200q90.jpg",
        "price": 4900,
        "remark": "https://www.lazada.co.th/products/pdp-i5353520117.html",
        "sold": 2
    },
    {
        "product_name": "Sooop เครื่องปั่นเครื่องทำเนยถั่วมินิเครื่องเนยถั่วประสิทธิภาพสูงสำหรับข้าวโอ๊ตเครื่องทำโยเกิร์ตอัลมอนด์เครื่องทำโยเกิร์ตเคสโทรศัพท์ลายเครื่องดื่ม",
        "product_image": "https://img.lazcdn.com/g/p/7b8a4fd00e1f0a5ca31dd2138a51466d.jpg_200x200q90.jpg",
        "price": 4722,
        "remark": "https://www.lazada.co.th/products/pdp-i16060169798.html",
        "sold": 0
    },
    {
        "product_name": "YYTCG | สายเชื่อมต่อ Type-C ไป USB B สำหรับ DAC และการ์ดเสียง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4695b97face94a509b1bce6e402de2f53.jpg_200x200q90.jpg",
        "price": 4529.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5909839151.html",
        "sold": 2
    },
    {
        "product_name": "เร๊าเตอร์ใส่ชิม 5G/4G อินเตอร์เนตไร้สายพกพา TP-LINK TL-MR100 Router Wi-Fi +แบตเตอรื่  FrankTech RT-02A9V Battery POCKET",
        "product_image": "https://img.lazcdn.com/g/p/fea1bb4716d1cd38fe38836001887e0b.jpg_200x200q90.jpg",
        "price": 4398,
        "remark": "https://www.lazada.co.th/products/pdp-i5577382274.html",
        "sold": 0
    },
    {
        "product_name": "เลนส์เทเลโฟโต้ APEXEL 30x แบบมืออาชีพสำหรับโทรศัพท์มือถือ พร้อมขาตั้งกล้อง สำหรับการเดินทาง ตั้งแคมป์ และดูนก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sda34e47a74854fc0a0311e82ad382560p.jpg_200x200q90.jpg",
        "price": 4394.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16046186964.html",
        "sold": 0
    },
    {
        "product_name": "SmallRig ชุดกรงสำหรับโทรศัพท์มือถืออเนกประสงค์พร้อมที่จับสำหรับ iPhone 16 15 14 Pro Max Android Huawei 4121",
        "product_image": "https://img.lazcdn.com/g/p/1a3a8230027fec6d2295014d3eefb083.jpg_200x200q90.jpg",
        "price": 4378.2,
        "remark": "https://www.lazada.co.th/products/pdp-i4313665082.html",
        "sold": 42
    },
    {
        "product_name": "apexel | APEXEL HD เลนส์ซูมโทรศัพท์มือถือแบบโลหะ 60X กล้องโทรทรรศน์แบบตาเดียว เลนส์ดาราศาสตร์สำหรับไอโฟน เสี่ยวมี่สมาร์ทโฟนทุกรุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4616600436724a6d9b7817ceb283af13k.jpg_200x200q90.jpg",
        "price": 4228.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16116584164.html",
        "sold": 0
    },
    {
        "product_name": "ขาตั้งโทรศัพท์มือถือ ขาตั้ง ขาตั้งไอแพด (ใช้กับ Tablet, iPad mini-pro 12.9 นิ้ว และมือถือ) มี 1 รุ่นให้เลือก สินค้าพร้อมส่งทันที!",
        "product_image": "https://img.lazcdn.com/g/p/824a5446d9aac2e3b55988b86a382138.jpg_200x200q90.jpg",
        "price": 2493.9,
        "remark": "https://www.lazada.co.th/products/pdp-i3752940757.html",
        "sold": 214
    },
    {
        "product_name": "SanDisk | ไดรฟ์แฟลช Type-C ใช้ได้ทั้งโทรศัพท์ Android และคอมพิวเตอร์ 64GB",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S62dcd5873ce842938d941c5ac980f886J.png_200x200q90.png",
        "price": 2932,
        "remark": "https://www.lazada.co.th/products/pdp-i16044454618.html",
        "sold": 8
    },
    {
        "product_name": "แท็บเล็ตเด็กอัจฉริยะ แท็บเล็ตการศึกษา เรียนรู้ผ่านเกมสนุก พัฒนาทักษะภาษาและคณิตศาสตร์ สำหรับเด็กอายุ 3-12 ปี อุปกรณ์อิเล็กทรอนิกส์เพื่อการเรียนรู้",
        "product_image": "https://img.lazcdn.com/g/p/82d418db20e43456498b8c93131f6c66.png_200x200q90.png",
        "price": 2920.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16125940815.html",
        "sold": 0
    },
    {
        "product_name": "Lenovo | ไดรฟ์ USB SSD ความจุสูง สองช่องต่อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0205d691dcec468785ab86840bde32057.jpg_200x200q90.jpg",
        "price": 2918,
        "remark": "https://www.lazada.co.th/products/pdp-i6065287647.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | ที่วางโทรศัพท์มือถือยางนิ่ม ความจุใหญ่ กันน้ำ ถาดใส่ลูกกอล์ฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S67a60b590374481d8b2b9bec754eddc0a.jpg_200x200q90.jpg",
        "price": 2908.4,
        "remark": "https://www.lazada.co.th/products/pdp-i16054236370.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | ที่วางโทรศัพท์กันน้ำ ออกแบบนุ่ม ความจุมาก สำหรับกล่องที กอล์ฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbebbb4d1bc5b4d508337710a0bcda6c1P.jpg_200x200q90.jpg",
        "price": 2899.94,
        "remark": "https://www.lazada.co.th/products/pdp-i6003363923.html",
        "sold": 0
    },
    {
        "product_name": "GUANQU | ที่ยึดโทรศัพท์ในรถแบบปรับได้ ใช้สุญญากาศและแม่เหล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saa5f0490de3243d0a41018ed277802a4v.jpg_200x200q90.jpg",
        "price": 2877.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16051161041.html",
        "sold": 0
    },
    {
        "product_name": "BASEUS | ชาร์จเร็ว 45W GaN หัวชาร์จยืดได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf9c625c57b2046e8ba1ccf3df8d394fb7.jpg_200x200q90.jpg",
        "price": 2850,
        "remark": "https://www.lazada.co.th/products/pdp-i6028017159.html",
        "sold": 0
    },
    {
        "product_name": "PGYTECH OneGo กระเป๋ากล้องมือถือ – รุ่น Classic แม่เหล็ก & รุ่น Casual เชือกรูด | จุแนวนอน สำหรับอุปกรณ์ถ่ายมือถือ / กล้องคอมแพค / ของใช้ส่วนตัว | มีสีดำ/เขียว/เทา/ม่วง",
        "product_image": "https://img.lazcdn.com/g/p/8ee4833475507798f811cd1b6d3ac868.jpg_200x200q90.jpg",
        "price": 2800,
        "remark": "https://www.lazada.co.th/products/pdp-i16085733014.html",
        "sold": 0
    },
    {
        "product_name": "Ulanzi รุ่น SK-21 Magnetic Auto-Open Tripod ขาตั้งจับมือถือหัวจับแม่เหล็ก พร้อมปุ่มกางขาอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/p/efcacabb704fd41e4fa600008dba232b.jpg_200x200q90.jpg",
        "price": 2798,
        "remark": "https://www.lazada.co.th/products/pdp-i16076216750.html",
        "sold": 0
    },
    {
        "product_name": "Ulanzi MT80 Auto-Open Tripod ขาตั้งกล้อง ขาตั้งมือถือ ไม้เซลฟี่ กางอัตโนมัติ น้ำหนักเบา สูง 213cm",
        "product_image": "https://img.lazcdn.com/g/p/56398c2c6f731661201793cc0a4f9a50.jpg_200x200q90.jpg",
        "price": 2779.76,
        "remark": "https://www.lazada.co.th/products/pdp-i5898546850.html",
        "sold": 20
    },
    {
        "product_name": "มือถือจิ๋ว ไอ 17  หน้าจอ4.5นิ้ว พกพาสะดวกใส่ซิมได้2ซิม แถมฟรีเคสเรซิ่นคละลาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf35ad016871b4ffcb5d867e5ffe4677bi.jpg_200x200q90.jpg",
        "price": 2758,
        "remark": "https://www.lazada.co.th/products/pdp-i5960830269.html",
        "sold": 16
    },
    {
        "product_name": "ขาตั้งโทรศัพท์มือถือแบบพกพาหลายมุมพร้อมล้อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5f1d0af24c29406281a84df6b9294946g.png_200x200q90.png",
        "price": 2682.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16051844413.html",
        "sold": 0
    },
    {
        "product_name": "ขอใบกำกับทักแชทเท่านั้น Apple Lightning To USB-C Cable (2 m) [iStudio by UFicon]",
        "product_image": "https://img.lazcdn.com/g/p/2e16136b3dfe2e45b10d70a44fdfb6d4.jpg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i954530747.html",
        "sold": 33
    },
    {
        "product_name": "TP-LINK 4G LTE MOBILE WI-FI M7000-V3 /ประกัน 1 YEAR",
        "product_image": "https://img.lazcdn.com/g/p/6f03b243773ec03e66c92555202a0ed5.jpg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i5516294805.html",
        "sold": 0
    },
    {
        "product_name": "Anker® USB C to USB C Cable 6FT 100W Braided 2 Pack สายชาร์จ",
        "product_image": "https://img.lazcdn.com/g/p/848bc99cca55db9971276072286e834d.png_200x200q90.png",
        "price": 2570,
        "remark": "https://www.lazada.co.th/products/pdp-i5710208486.html",
        "sold": 0
    },
    {
        "product_name": "BASEUS | ชาร์จเจอร์แบบพับได้ GaN 100W รองรับ iPhone",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf0b555f7bd6c499ebe051e7e3c91e514J.png_200x200q90.png",
        "price": 2554,
        "remark": "https://www.lazada.co.th/products/pdp-i16112081738.html",
        "sold": 0
    },
    {
        "product_name": "Celestron NexYZ 3-Axis Universal สมาร์ทโฟนอะแดปเตอร์โทรศัพท์มือถือ Mount สําหรับกล้องโทรทรรศน์ดาราศาสตร์กล้องส่องทางไกลกล้องจุลทรรศน์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9692e6f1f59741e9b6670076aec16b39v.png_200x200q90.png",
        "price": 2425.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5723847977.html",
        "sold": 2
    },
    {
        "product_name": "Blackshark(แบล็คชาร์ค) | ที่ระบายความร้อนโทรศัพท์สำหรับเล่นเกมและสตรีมสด ใช้เซมิคอนดักเตอร์ ทำงานเงียบมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc03068f7080a46a3b3b997780e1e4d7a7.jpg_200x200q90.jpg",
        "price": 2538.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5909606912.html",
        "sold": 127
    },
    {
        "product_name": "Black Shark FunCooler 5 พัดลมระบายความร้อนมือถือ พัดลมโทรศัพท์มือถือ",
        "product_image": "https://img.lazcdn.com/g/p/7ab055537afa5e83b3b4fe5e885dac78.jpg_200x200q90.jpg",
        "price": 2502,
        "remark": "https://www.lazada.co.th/products/pdp-i5752732455.html",
        "sold": 1
    },
    {
        "product_name": "coolbarขาตั้งพื้น ขาตั้งโทรศัพท์มือถือ นอนดูหนังสบาย ขาตั้งipad ขาตั้งมือถือ PHONE/TABLET HOLDER ใช้สำหรับตั้งดูหนัง ถ่ายรูปขาตั้งโทรศัพท์มือถือ ขาตั้ง ขาตั้งไอแพด (ใช้กับ Tablet, iPad mini-pro 12.9 นิ้ว และมือถือ) มี 1 รุ่นให้เลือก สินค้าพร้อมส่งทันที!",
        "product_image": "https://img.lazcdn.com/g/p/6971a72aa4739bae28b3da63febe8713.jpg_200x200q90.jpg",
        "price": 2493.9,
        "remark": "https://www.lazada.co.th/products/pdp-i4648370497.html",
        "sold": 21
    },
    {
        "product_name": "ขาตั้งโทรศัพท์มือถือ ขาตั้ง ขาตั้งไอแพด (ใช้กับ Tablet, iPad mini-pro 12.9 นิ้ว และมือถือ)ขาตั้งไอแพด สูงต่ำปรับได้ที่วางขาตั้ง",
        "product_image": "https://img.lazcdn.com/g/p/1fa7b9a5e5b9643401966b497dee4e49.jpg_200x200q90.jpg",
        "price": 2493.9,
        "remark": "https://www.lazada.co.th/products/pdp-i3719564997.html",
        "sold": 60
    },
    {
        "product_name": "【Paraclete】ขาตั้งโทรศัพท์ตั้งพื้น ที่วาง iPad / ปรับความสูงได้ / ดูวิดีโอสด (สำหรับแท็บเล็ต, iPad Mini Pro 12.9 นิ้วและโทรศัพท์มือถือ) มี 1 รุ่นให้เลือก",
        "product_image": "https://img.lazcdn.com/g/p/55d96921328e230694030b612105ae82.jpg_200x200q90.jpg",
        "price": 2493.9,
        "remark": "https://www.lazada.co.th/products/pdp-i4053963488.html",
        "sold": 56
    },
    {
        "product_name": "ขาตั้งไอแพด (ใช้กับ Tablet, iPad mini-pro 12.9 นิ้ว และมือถือ) ขาตั้งโทรศัพท์มือถือ ขาตั้ง ขาตั้งไอแพด ปรับความสูงได้",
        "product_image": "https://img.lazcdn.com/g/p/c4a49e96a45f6da3c3227843c5ecb8e3.png_200x200q90.png",
        "price": 2493.9,
        "remark": "https://www.lazada.co.th/products/pdp-i4684840035.html",
        "sold": 20
    },
    {
        "product_name": "FFขาตั้งโทรศัพท์มือถือ ขาตั้ง ขาตั้งไอแพด (ใช้กับ Tablet, iPad mini-pro 12.9 นิ้ว และมือถือ) มี 1 รุ่นให้เลือก สินค้าพร้อมส่งทันที!",
        "product_image": "https://img.lazcdn.com/g/p/476e75bc16420f06685efb7c2c04f55e.jpg_200x200q90.jpg",
        "price": 2493.9,
        "remark": "https://www.lazada.co.th/products/pdp-i3729883076.html",
        "sold": 137
    },
    {
        "product_name": "CAM ขาตั้งกล้อง Manfrotto MCPIXI Universal Smartphone Clamp ขาตั้งมือถือ",
        "product_image": "https://img.lazcdn.com/g/p/ed7ffd80d4482a8f011988d6cc9e1fcb.jpg_200x200q90.jpg",
        "price": 2474,
        "remark": "https://www.lazada.co.th/products/pdp-i2327038175.html",
        "sold": 0
    },
    {
        "product_name": "CAM ขาตั้งกล้อง Manfrotto PIXI Clamp for smartphone (เฉพาะตัวหนีบตัวโทรศัพท์) ขาตั้งมือถือ",
        "product_image": "https://img.lazcdn.com/g/p/8804c0ad09f522dfe7aefcfd06a38afc.jpg_200x200q90.jpg",
        "price": 2474,
        "remark": "https://www.lazada.co.th/products/pdp-i2326836967.html",
        "sold": 0
    },
    {
        "product_name": "WONEW | ขาตั้งกล้องขนาดเล็กพร้อมที่หนีบโทรศัพท์แบบแม่เหล็กสองด้าน",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S612e00b34eca4c28b06bd99e024e8601b.jpg_200x200q90.jpg",
        "price": 2468.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16043477247.html",
        "sold": 44
    },
    {
        "product_name": "NEEWER ขาตั้งกล้องเซลฟี่แบบแม่เหล็กขนาด 167 ซม. ใช้งานร่วมกับ MagSafe iPhone Android ขาตั้งโทรศัพท์มือถือแบบพกพาพร้อมรีโมท ขาตั้งกล้องแบบกางออกด้วยปุ่มเดียว PA989",
        "product_image": "https://img.lazcdn.com/g/p/e76ec243e123bb2655751816e2ed2f8a.jpg_200x200q90.jpg",
        "price": 2460,
        "remark": "https://www.lazada.co.th/products/pdp-i5895987698.html",
        "sold": 2
    },
    {
        "product_name": "เครื่องปั่น เครื่องปั่นมือถือ hand blender เครื่องปั่นบด5in1 วัสดุสแตนเลส304【รับประกัน 3 ปี】เครื่องปั่นอาหาร ปรับระดับได้ 2 ระดับ 1200W มอเตอร์ความเร็วสูง ใช้ทำอาหารได้หลายประเภท เช่น ตีไข่ ตีวิปปิ้งครีม บดเนื้อ เครื่องบดหมูบด blender",
        "product_image": "https://img.lazcdn.com/g/p/58157e362a7537a450d63a5081ef05a0.png_200x200q90.png",
        "price": 2457.18,
        "remark": "https://www.lazada.co.th/products/pdp-i5870997204.html",
        "sold": 69
    },
    {
        "product_name": "Ulanzi MT78 Vlog Tripod ขาตั้งกล้องมือถือ ไม้เซลฟี่ ขนาดพกพา  สำหรับถ่ายวีดีโอ Mobile Phone Tripod, Selfie Stick",
        "product_image": "https://img.lazcdn.com/g/p/d545cbc11d8d641719fcb13b3183bbbd.jpg_200x200q90.jpg",
        "price": 2421.06,
        "remark": "https://www.lazada.co.th/products/pdp-i5339608333.html",
        "sold": 45
    },
    {
        "product_name": "กล้องตกปลาแบบมือถือ 1080P หน้าจอ LCD 4.3 นิ้ว รุ่น 130 ° เครื่องหาปลาแบบพกพา สำหรับตกปลา พร้อมระบบมองเห็นในเวลากลางคืน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc3a3332cb9cf4d5d9673d3dfed54b5e5M.jpg_200x200q90.jpg",
        "price": 2402.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16097383956.html",
        "sold": 0
    },
    {
        "product_name": "ชุดชาร์จ หัวเหว่ย สายชาร์จ+หัวชาร์จ 5A Type-C ของแท้ 100% Original Huawei Super Charger ของแท้ รองรับ Mate9/Mate9pro/P10/P10plus/P20/P20Pro/P30/P30Pro/Mate20/Mate 20Pro รับประกัน1ปี BY BOSSTORE",
        "product_image": "https://img.lazcdn.com/g/p/8ab1fc18d2ae3f9e50472fe8521b71b3.jpg_200x200q90.jpg",
        "price": 2400,
        "remark": "https://www.lazada.co.th/products/pdp-i657952501.html",
        "sold": 680
    },
    {
        "product_name": "(มีสต็อกพร้อมส่งจากไทย)เครื่องดูดสัญญาณโทรศัพท์ 2G/3G/4G/5G 3-in-1 เสาดูดสัญญาณมือถือ ขยายสัญญาณมือถือ Mobile Signal Amplifier เครื่องขยายสัญญาณมือถือเครื่องขยายเสียงโทรศัพท์มือถือ GSM LTE WCDMA",
        "product_image": "https://img.lazcdn.com/g/p/c96648fbbd8801423f437ec7fb37279c.jpg_200x200q90.jpg",
        "price": 2396,
        "remark": "https://www.lazada.co.th/products/pdp-i5658231306.html",
        "sold": 3
    },
    {
        "product_name": "apexel | ชุดเลนส์ APEXEL 2 in 1 Telemacro ประกอบด้วยเลนส์เทเลโฟโต้ 6 เท่า และเลนส์มาโคร 150 มม. พร้อมคลิปหนีบเลนส์อเนกประสงค์สำหรับโทรศัพท์ iPhone และ Android",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2097c7f38f3943f797dd247d741548f1L.jpg_200x200q90.jpg",
        "price": 2393.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16126463779.html",
        "sold": 0
    },
    {
        "product_name": "Black Shark FunCooler 5 พัดลมระบายความร้อนมือถือ พัดลมโทรศัพท์มือถือ เย็นเร็ว เสียงเงียบ ไฟRGB",
        "product_image": "https://img.lazcdn.com/g/p/f7b82eb30643b43cd0afb8ee36ecdcbe.jpg_200x200q90.jpg",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i5980590838.html",
        "sold": 0
    },
    {
        "product_name": "HAFELE เครื่องปั่นมือถือ 4 in 1",
        "product_image": "https://img.lazcdn.com/g/p/19ec9e8c32c420780dceda6210d1e095.jpg_200x200q90.jpg",
        "price": 2378,
        "remark": "https://www.lazada.co.th/products/pdp-i3028657215.html",
        "sold": 2372
    },
    {
        "product_name": "Ulanzi | ขาตั้งกล้อง Ulanzi MT80 ของแท้ ทำจากอลูมิเนียมอัลลอยด์ รับน้ำหนักได้ดี พร้อมแผ่นปลดเร็ว พับเก็บได้ สำหรับกล้อง โทรศัพท์ และไฟวิดีโอ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S15a417b4a3a74990a7a0af6dc3eeb6f86.jpg_200x200q90.jpg",
        "price": 2369.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16127134167.html",
        "sold": 0
    },
    {
        "product_name": "NEEWER 62.9”/160cm Phone Tripod, ขาตั้งกล้องโทรศัพท์ พร้อมรีโมท Bluetooth และขาตั้งโทรศัพท์ ไม้เซลฟี่พับได้ ขาตั้งกล้องแบบพกพา สำหรับ, TS05",
        "product_image": "https://img.lazcdn.com/g/p/1f45b3c4bd284193a9083208001b8e4d.jpg_200x200q90.jpg",
        "price": 2340,
        "remark": "https://www.lazada.co.th/products/pdp-i5688851976.html",
        "sold": 4
    },
    {
        "product_name": "INZU | ขาตั้งกล้องพกพาขนาดเบาจากคาร์บอนไฟเบอร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf99bea49e2b242aa905ea66ea451d4f7R.jpg_200x200q90.jpg",
        "price": 2336,
        "remark": "https://www.lazada.co.th/products/pdp-i6027932635.html",
        "sold": 4
    },
    {
        "product_name": "APEXEL MS200กล้องจุลทรรศน์โทรศัพท์กำลังขยาย200X,เลนส์มาโครคลิปเดียวไฮเอนด์อัลตร้า HD พิเศษพร้อมไฟไฟ Led UV ใช้ได้กับ IOS Android",
        "product_image": "https://img.lazcdn.com/g/p/2c5c70111c009b4d1ad851f6029df017.jpg_200x200q90.jpg",
        "price": 2322.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5730094657.html",
        "sold": 2
    },
    {
        "product_name": "MOFT Snap Invisible Phone Tripod Stand MOVAS™ MagSafe ขาตั้ง for iphone แบบแม่เหล็ก ไม้เซลฟี่ griptok magsafe moft tripod ที่ตั้งโทรศัพท์",
        "product_image": "https://img.lazcdn.com/g/p/0ced728d5422216f893bde313f79517b.png_200x200q90.png",
        "price": 2322,
        "remark": "https://www.lazada.co.th/products/pdp-i5120127178.html",
        "sold": 1972
    },
    {
        "product_name": "จอมอนิเตอร์กล้องหลังระบบแม่เหล็กโทรศัพท์หน้าจอแสดงภาพเซลฟี่ Vlog หน้าจอเซลฟี่สำหรับโทรศัพท์มือถือ iPhone แอนดรอยด์",
        "product_image": "https://img.lazcdn.com/g/p/2de7f8e719fd71604f8ba2d8d7ee43dc.jpg_200x200q90.jpg",
        "price": 2268,
        "remark": "https://www.lazada.co.th/products/pdp-i5893708222.html",
        "sold": 0
    },
    {
        "product_name": "Neewer | ที่ยึดกล้องปรับได้ ขยายได้ รองรับฟิลเตอร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4d084531adb9406baf461aff01656e7ah.jpg_200x200q90.jpg",
        "price": 2264.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16051155434.html",
        "sold": 0
    },
    {
        "product_name": "Ulanzi | แคลมป์กล้องหลายฟังก์ชัน ราง 10 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3707a56502024d588d44fd5c9de904cfP.jpg_200x200q90.jpg",
        "price": 2260,
        "remark": "https://www.lazada.co.th/products/pdp-i5995094899.html",
        "sold": 11
    },
    {
        "product_name": "อุปกรณ์ขยายสัญญาณ TP-Link M7000 LTE Mobile Wi-Fi by Banana IT",
        "product_image": "https://img.lazcdn.com/g/p/8980db982785c11a488f554b721ac5ec.jpg_200x200q90.jpg",
        "price": 2240,
        "remark": "https://www.lazada.co.th/products/pdp-i2310473900.html",
        "sold": 77
    },
    {
        "product_name": "สายชาร์จเร็วแบบถัก 60W USB C to Type C สำหรับ Apple iPhone 11 12 13 14 15 16 Pro Max Plus จำนวน 1-50 ชิ้น อุปกรณ์เสริมสำหรับโทรศัพท์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7cbbe3b105d142f3a0f0cdaf52bf8998X.png_200x200q90.png",
        "price": 2233.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5973725557.html",
        "sold": 0
    },
    {
        "product_name": "สายชาร์จเร็วสำหรับ iPhone 11-14 Pro Max",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbf9264f948ad405e8d2caf64c71310f6x.jpg_200x200q90.jpg",
        "price": 2212,
        "remark": "https://www.lazada.co.th/products/pdp-i16120048416.html",
        "sold": 0
    },
    {
        "product_name": "คิมดูลขาตั้งจอภาพแบบพกพาแขนยาวแท็บเล็ตไอแพดขาตั้งแบบหมุนได้แบบปรับได้ขาตั้งโทรศัพท์แบบแม่เหล็กขาตั้งคลิปเมาท์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4a57491b055f45c7894b9501ca1e79faR.jpg_200x200q90.jpg",
        "price": 2166.16,
        "remark": "https://www.lazada.co.th/products/pdp-i5848224785.html",
        "sold": 0
    },
    {
        "product_name": "Lenovo | แฟลชไดรฟ์ความจุสูงพร้อมพอร์ต Type-C คู่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S05da3db6e5bc40bab54905db8cf6885bp.jpg_200x200q90.jpg",
        "price": 2134,
        "remark": "https://www.lazada.co.th/products/pdp-i6006231352.html",
        "sold": 1
    },
    {
        "product_name": "TP-LINK 4G LTE Mobile Wi-Fi M7000 (MD3-000246)",
        "product_image": "https://img.lazcdn.com/g/p/e0be672948f58e5f4c3caf771b4517b2.jpg_200x200q90.jpg",
        "price": 2134,
        "remark": "https://www.lazada.co.th/products/pdp-i5073502944.html",
        "sold": 3
    },
    {
        "product_name": "ไฟ LED ปรับได้ 2 สี 3 โหมดแสง พร้อมที่วางโทรศัพท์ แขนคู่แบบยืดหยุ่น สำหรับถ่ายวิดีโอและไลฟ์สด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S83b9a9fb00bc446696e5edfc8433f14bJ.jpg_200x200q90.jpg",
        "price": 2132.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16096146312.html",
        "sold": 0
    },
    {
        "product_name": "ขาตั้งกล้องกอล์ฟแบบแม่เหล็กสำหรับโทรศัพท์มือถือ ใช้สำหรับถ่ายภาพเซลฟี่ ถ่ายวิดีโอ ตกปลา และกิจกรรมกลางแจ้งอื่นๆ สำหรับ iPhone 16 15 และ Android",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scb982896c9a1429ca5218c89e121cb48U.jpg_200x200q90.jpg",
        "price": 2127.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5944013403.html",
        "sold": 0
    },
    {
        "product_name": "ขาตั้งกล้องอัตโนมัติ TT07 สำหรับโทรศัพท์มือถือ พร้อมระบบ AI ติดตามการถ่ายภาพ ไม้เซลฟี่แบบยืดหดได้ ขาตั้งแบบสี่ขา พร้อมรีโมท  ไฟเสริมเป็นอุปกรณ์เสริม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc342219f5dbd46e987cbc43dbc18e5e75.jpg_200x200q90.jpg",
        "price": 2083.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5992325172.html",
        "sold": 0
    },
    {
        "product_name": "Apple | สายชาร์จ USB แท้ ชาร์จเร็ว 2 เมตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd2a5c5fddbc34a08bea053dd77142e09v.jpg_200x200q90.jpg",
        "price": 2064,
        "remark": "https://www.lazada.co.th/products/pdp-i16119599659.html",
        "sold": 0
    },
    {
        "product_name": "surepower|ของขวัญวันเกิดปีใหม่ กล้องโทรทรรศน์ดาราศาสตร์ ของเล่นสำหรับเด็กอายุ 10 ปีขึ้นไปและนักเรียนประถม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sed7aca61f609436bac654147097ea0f9a.jpg_200x200q90.jpg",
        "price": 2038.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5910826316.html",
        "sold": 193
    },
    {
        "product_name": "ZMI AL870 / Cuktech AL870 สายชาร์จ Type-C to LN รองรับชาร์จไว Phone ยาว 1 ม. มาตรฐาน Made For Phone (รับประกันสินค้า 2 ปี)",
        "product_image": "https://img.lazcdn.com/g/p/6cd8890f84fce762f35b793b4450de6c.jpg_200x200q90.jpg",
        "price": 2031.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16111838283.html",
        "sold": 0
    },
    {
        "product_name": "Apple | สายชาร์จและถ่ายโอนข้อมูล PD ความเร็วสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S817b428751f240eea080ab7c39acd5f0i.jpg_200x200q90.jpg",
        "price": 2030,
        "remark": "https://www.lazada.co.th/products/pdp-i16111888559.html",
        "sold": 0
    },
    {
        "product_name": "ThinkPlus | สายชาร์จเร็วและโอนข้อมูลสำหรับอุปกรณ์หลายชนิด รองรับ PD ด้วยหัว Type-C คู่",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S7141ae64e18c4d93a208195ec4bdec99x.jpg_200x200q90.jpg",
        "price": 2023.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5985140748.html",
        "sold": 144
    },
    {
        "product_name": "SHARGE | สายชาร์จ C-Type แบบแม่เหล็ก ชาร์จเร็ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbed3c3594f6941cca99f6114b9ccd2f5E.jpg_200x200q90.jpg",
        "price": 2016.94,
        "remark": "https://www.lazada.co.th/products/pdp-i6073251600.html",
        "sold": 13
    },
    {
        "product_name": "SmallRig Windproof Selfie Stick ขาตั้งกล้อง ขาตั้งมือถือ แบบ 4 ขา ไม้เซลฟี่ สำหรับถ่ายวีดีโอ Vlog ไลฟ์สด 4668",
        "product_image": "https://img.lazcdn.com/g/p/86c0c91d09e7a8f813c9a240cf780850.jpg_200x200q90.jpg",
        "price": 2014.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5194826694.html",
        "sold": 227
    },
    {
        "product_name": "[สินค้าสมนาคุณ งดจำหน่าย] สายชาร์จ Type C ชาร์จเร็ว 60w ความยาว 1 เมตร C to C",
        "product_image": "https://img.lazcdn.com/g/p/78700e544a0f540660ec6b281299f4b1.jpg_200x200q90.jpg",
        "price": 1998,
        "remark": "https://www.lazada.co.th/products/pdp-i16074882411.html",
        "sold": 0
    },
    {
        "product_name": "[ใช้คูปอง ลดเหลือ 699 บ.] CUKTECH C2C515 Ai Charging สายชาร์จ 100W เพิ่มเทคโนโลยีชาร์จเร็ว PD3.0 PPS 2 พอร์ต USB-C -2Y",
        "product_image": "https://img.lazcdn.com/g/p/602d835c24a3449f6cf7e518252acc2d.png_200x200q90.png",
        "price": 1998,
        "remark": "https://www.lazada.co.th/products/pdp-i5713472903.html",
        "sold": 24
    },
    {
        "product_name": "YULING | ที่วางแล็ปท็อปรุ่นปรับได้ 360 องศา พร้อม HUB และที่วางโทรศัพท์แบบแม่เหล็ก พับได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7bbe8db623744c10bdb21a0a074055f7T.jpg_200x200q90.jpg",
        "price": 1984,
        "remark": "https://www.lazada.co.th/products/pdp-i6029571056.html",
        "sold": 0
    },
    {
        "product_name": "elago M5 Mobile iPhone iPad Stand ที่วางมือถือสเตนเลสระดับพรีเมี่ยม พับเก็บได้ใช้ท่องเที่ยว",
        "product_image": "https://img.lazcdn.com/g/p/843a72d1aea076e4e084a192946406ee.jpg_200x200q90.jpg",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i2119520142.html",
        "sold": 14
    },
    {
        "product_name": "[ผ่อน 0% สูงสุด 10 ด.] (สายชาร์จ) BELKIN PVC Sync and Charge USB-C to Lightning Cable - 1 M. 2.4A / 30W Output 2Yrs.",
        "product_image": "https://img.lazcdn.com/g/p/16654a85fbabaf47a59e858f3f64c114.jpg_200x200q90.jpg",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i2478204473.html",
        "sold": 0
    },
    {
        "product_name": "Honeywell สายชาร์จเร็ว 5A 100W Type C to Type C 3.1 cable 1.8Mtr ถ่ายโอนข้อมูลสูง 10 Gbps",
        "product_image": "https://img.lazcdn.com/g/p/dbf9a403271735ab37b9506397887e79.png_200x200q90.png",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i5617714687.html",
        "sold": 0
    },
    {
        "product_name": "MAGEASY Magnetic Wire Fast Charging/Sync Cable สายชาร์จ 1.5m Type C to C สำหรับโทรศัพท์",
        "product_image": "https://img.lazcdn.com/g/p/86424b64da070fb4c9d858a5c28c1a8b.png_200x200q90.png",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i16056938754.html",
        "sold": 0
    },
    {
        "product_name": "DD - TC05M3 สายชาร์จและถอดรหัส OTG แบบ 2-in-1 สำหรับ DAC/AMP ต่อกับมือถือ พาวเวอร์แบงค์ จ่ายไฟเสถียร ประกันศูนย์ไทย",
        "product_image": "https://img.lazcdn.com/g/p/e8b39ef8bd17179e88e7f9b790486f27.png_200x200q90.png",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i6022708885.html",
        "sold": 0
    },
    {
        "product_name": "สาย KOALA STYLEPIE 3-In-1แบบพกพาสายชาร์จใช้งานได้หลากหลาย | ไฟ LED สว่าง | ตัวทำความร้อนที่มีความแม่นยำ | กำลังไฟสูง240W",
        "product_image": "https://img.lazcdn.com/g/p/efc53b85fe211a1b0621157269170dfa.png_200x200q90.png",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i5629923778.html",
        "sold": 0
    },
    {
        "product_name": "CUKTECH | สายชาร์จเร็วแบบคู่ Type-C 100W",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6218c58b5e104ca7b6a1fc45fca2b3c9t.jpg_200x200q90.jpg",
        "price": 1970,
        "remark": "https://www.lazada.co.th/products/pdp-i6048816058.html",
        "sold": 13
    },
    {
        "product_name": "Eloop หัวชาร์จเร็ว QC 3.0 PD 65W สีดำ รุ่น C61T",
        "product_image": "https://img.lazcdn.com/g/p/f22f3262665ce6f4c271cc51546355b5.png_200x200q90.png",
        "price": 1958,
        "remark": "https://www.lazada.co.th/products/pdp-i5515955134.html",
        "sold": 0
    },
    {
        "product_name": "ที่ยึดโทรศัพท์แบบคล้องคอ, ที่ยึดโทรศัพท์แบบแม่เหล็กและแบบหนีบ 2-in-1, ที่ยึดโทรศัพท์แบบ POV, สำหรับบันทึกวิดีโอ Vlog สำหรับโทรศัพท์ iPhone และ Android",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa14e747f6a174d73bacb60b13fa08952h.jpg_200x200q90.jpg",
        "price": 1954.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16097780755.html",
        "sold": 0
    },
    {
        "product_name": "Apple | สายชาร์จ AppleType-C  แบบสายถัก ชาร์จเร็ว PD สำหรับ iPhone 17/16/15 Pro Max",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8ee1b518608a48dcaf04d2decd8e51f9N.jpg_200x200q90.jpg",
        "price": 1938,
        "remark": "https://www.lazada.co.th/products/pdp-i6027987239.html",
        "sold": 0
    },
    {
        "product_name": "Kiorafoto ขาตั้งกล้องแบบยืดหยุ่นแม่เหล็กติดโทรศัพท์ที่จับสำหรับ iPhone 16 15 14 13,มาพร้อมกับฟังก์ชัน Magsafe ชุดกล้องถ่ายภาพและกล้องรูสกรูขนาด1/4นิ้ว-20นิ้ว & สมาร์ทโฟน Android อื่นๆ",
        "product_image": "https://img.lazcdn.com/g/p/ffc0c15e4ca6676849c97f3f63484132.jpg_200x200q90.jpg",
        "price": 1930.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5401184853.html",
        "sold": 4
    },
    {
        "product_name": "YYTCG | อะแดปเตอร์ OTG Lightning เป็น Type-C หัวคู่ พร้อม DAC สายแปลงสัญญาณเสียง Hi-Fi",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S45cdb606ddc04f0396002e13df448908W.jpg_200x200q90.jpg",
        "price": 1914.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5909757795.html",
        "sold": 0
    },
    {
        "product_name": "Lenovo | อแดปเตอร์ชาร์จเร็ว 3 ใน 1 100W พร้อมสาย C คู่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S743dc7c6ba404e959fcac9503d9041f9A.jpg_200x200q90.jpg",
        "price": 1914,
        "remark": "https://www.lazada.co.th/products/pdp-i6004164033.html",
        "sold": 2
    },
    {
        "product_name": "1-50 ชิ้น 35W ประเภท C สายถักสำหรับ Apple iPhone 17 16 15 14 13 Pro Max iPad Air USB C สายชาร์จเร็วอุปกรณ์เสริมโทรศัพท์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S02de19b16382488fb7af7f0ab2b883fbg.jpg_200x200q90.jpg",
        "price": 1901.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16137380349.html",
        "sold": 0
    },
    {
        "product_name": "NEEWER SP-04 Phone Tripod ขาตั้งโทรศัพท์พร้อมฐานปรับระดับขาตั้งกล้องแบบ Cold Shoe (Φ55mm) พร้อมแผ่น QR Plate 1/4\" เกลียว 3/8\" รับน้ำหนักสูงสุด 22 ปอนด์",
        "product_image": "https://img.lazcdn.com/g/p/4a2b416265bb916cdedec71199be89cc.jpg_200x200q90.jpg",
        "price": 1898,
        "remark": "https://www.lazada.co.th/products/pdp-i5555953449.html",
        "sold": 4
    },
    {
        "product_name": "DJI | สายชาร์จโทรศัพท์และสายบันทึกเสียง DJI ของแท้ รุ่น USB-C to Lightning สำหรับ Osmo Mobile 7P Osmo Mobile 7 อุปกรณ์เสริมแท้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S394bbe79b13a4ade94789f93dcc3eae00.jpg_200x200q90.jpg",
        "price": 1896,
        "remark": "https://www.lazada.co.th/products/pdp-i16116678724.html",
        "sold": 0
    },
    {
        "product_name": "แฟลชไดรฟ์ SanDisk Ultra Dual Drive Luxe USB Type-C ความจุ 32GB 64GB 128GB 256GB 512GB USB 3.2 Gen 1 สำหรับโทรศัพท์มือถือ ตัวเรือนโลหะ แบบ Type-C OTG",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6973d11a46e64afd9b60e75101dff905B.jpg_200x200q90.jpg",
        "price": 1887.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5961274058.html",
        "sold": 0
    },
    {
        "product_name": "Kokkiri | ที่ชาร์จไร้สาย 3-in-1 พับได้ สำหรับ iPhone + Apple Watch + AirPods รองรับ MagSafe ชาร์จเร็ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbde5d7c5a7ae4c72a62c6e00f4930c7co.png_200x200q90.png",
        "price": 1886.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6063395170.html",
        "sold": 0
    },
    {
        "product_name": "BASEUS | สายชาร์จเร็ว 3-in-1 อะแดปเตอร์ Type-C",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0194e41fe7a2466d919dea89f3fcaf24d.jpg_200x200q90.jpg",
        "price": 1866,
        "remark": "https://www.lazada.co.th/products/pdp-i6000218054.html",
        "sold": 0
    },
    {
        "product_name": "สายเคเบิล C-type รุ่น 2026 Hot A8 For Pro 3 พร้อมหูฟังบลูทูธไร้สาย ANC ตัดเสียงรบกวนแบบแอคทีฟ สำหรับเล่นเกมส์และสนทนาแบบแฮนด์ฟรี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6c0583b0af7c4ac9adbb239f2db8e1a1i.jpg_200x200q90.jpg",
        "price": 1865.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16099500431.html",
        "sold": 0
    },
    {
        "product_name": "Anker | สายเคเบิลข้อมูล Type-C สองหัว ชาร์จเร็ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S02a52bd86f3b46b7be1894abf832b57ee.png_200x200q90.png",
        "price": 1864,
        "remark": "https://www.lazada.co.th/products/pdp-i6004068513.html",
        "sold": 0
    },
    {
        "product_name": "WONEW | ที่วางโทรศัพท์สำหรับสตรีมสดบนโต๊ะ สำหรับการเขียนและวาดรูป มีฟังก์ชันไฟและทำความเย็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S11e6881c31114553865ced02eb8940b0E.jpg_200x200q90.jpg",
        "price": 1849.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6077819716.html",
        "sold": 134
    },
    {
        "product_name": "USB-C to Lightning Adapter",
        "product_image": "https://img.lazcdn.com/g/p/4ed81d30a83b2620cfff44d7b2a47fd3.jpg_200x200q90.jpg",
        "price": 1838,
        "remark": "https://www.lazada.co.th/products/pdp-i4873577773.html",
        "sold": 184
    },
    {
        "product_name": "Ulanzi TT88 4in1 MagSafe Overhead Selfie Stick ขาตั้งมือถือ ไม้เซลฟี่ แบบ MagSafe พร้อมรีโมทบลูทูธ",
        "product_image": "https://img.lazcdn.com/g/p/fa400c318375bb4ca4c1902593f71de1.jpg_200x200q90.jpg",
        "price": 1830,
        "remark": "https://www.lazada.co.th/products/pdp-i5663854763.html",
        "sold": 1
    },
    {
        "product_name": "ขาตั้งกล้องแม่เหล็กสำหรับโทรศัพท์ขาตั้งแม็กเซฟและคลิปไม้เซลฟี่ขนาดพกพาสำหรับแอนดรอยด์/ไอโฟนรีโมทคอนโทรลไร้สาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se2780b94d6494a62ba979c9d17d5992cH.jpg_200x200q90.jpg",
        "price": 1801.96,
        "remark": "https://www.lazada.co.th/products/pdp-i6071641804.html",
        "sold": 0
    },
    {
        "product_name": "Ulanzi JJ03 Extendable Grip Phone Tripod ด้ามจับมือถือ ขาตั้ง ไม้เซลฟี่ แบบ MagSafe พร้อมรีโมทบลูทูธ",
        "product_image": "https://img.lazcdn.com/g/p/aa20f6cbfc6d0771210969d3024ab5d4.jpg_200x200q90.jpg",
        "price": 1798,
        "remark": "https://www.lazada.co.th/products/pdp-i5591349116.html",
        "sold": 16
    },
    {
        "product_name": "ขาตั้งกล้อง ขาตั้งมือถือปรับระดับได้ แข็งแรง ทนทาน พร้อมรีโมทบลูทูธ ขนาดพกพา PLOKAMA  รุ่น9950",
        "product_image": "https://img.lazcdn.com/g/p/1341c76997f1f02bb2ae0751d2d195d7.jpg_200x200q90.jpg",
        "price": 1798,
        "remark": "https://www.lazada.co.th/products/pdp-i4160160770.html",
        "sold": 88
    },
    {
        "product_name": "ส่งในไทย Realme 120W SuperVOOC หัวชาร์จ สายชาร์จ ของแท้ มี มอก. ขากลม รองรับ GT 8 GT 7 GT 6",
        "product_image": "https://img.lazcdn.com/g/p/ebb6a8b20f22a6c7b405732293955cb2.png_200x200q90.png",
        "price": 1798,
        "remark": "https://www.lazada.co.th/products/pdp-i16121809338.html",
        "sold": 1
    },
    {
        "product_name": "Ulanzi MT84 Magnetic Tripod for Phone ขาตั้งมือถือ ไม้เซลฟี่ ระบบ M*gSafe พร้อมรีโมทบลูทูธในตัว",
        "product_image": "https://img.lazcdn.com/g/p/a3ff1f1ed63bec1230bbad57c3eef853.jpg_200x200q90.jpg",
        "price": 1798,
        "remark": "https://www.lazada.co.th/products/pdp-i5558912886.html",
        "sold": 40
    },
    {
        "product_name": "ขาตั้งมือถือแบบแม่เหล็ก Ulanzi - MA60 Foldable Magnetic Phone Tripod",
        "product_image": "https://img.lazcdn.com/g/p/959cca682a976005db00e0220d4d3fc7.jpg_200x200q90.jpg",
        "price": 1798,
        "remark": "https://www.lazada.co.th/products/pdp-i5870410128.html",
        "sold": 1
    },
    {
        "product_name": "DJI Osmo Pocket 3,แบตสำรองแบบมือถือ TYPE-C ชาร์จแบตเตอรี่กล้องเพื่อการกีฬามือจับที่จับกล้องแบตสำรองอุปกรณ์เสริมชาร์จกล้อง",
        "product_image": "https://img.lazcdn.com/g/p/97833cef30b48d319fc96c4ebafec3a3.jpg_200x200q90.jpg",
        "price": 1794,
        "remark": "https://www.lazada.co.th/products/pdp-i16101315895.html",
        "sold": 0
    },
    {
        "product_name": "[ส่งฟรี]  Eloop C13 / S51 / S8 GaN เซตหัวชาร์จเร็ว 3 พอร์ต PD 65W QC 3.0 Apapter อแดปเตอร์ หัวชาร์จ Type C Notebook Laptop มือถือ สมาร์ทโฟน",
        "product_image": "https://img.lazcdn.com/g/p/cad4c31f1450ca9c2359723440a2ce8e.png_200x200q90.png",
        "price": 1790,
        "remark": "https://www.lazada.co.th/products/pdp-i3986124254.html",
        "sold": 15
    },
    {
        "product_name": "NEEWER ขาตั้งกล้องโทรศัพท์168ซม. พร้อมรีโมทและที่วางโทรศัพท์ไม้เซลฟี่โลหะ TS03",
        "product_image": "https://img.lazcdn.com/g/p/73f1b8945aef08777b9c2453c2f83bf3.jpg_200x200q90.jpg",
        "price": 1781.28,
        "remark": "https://www.lazada.co.th/products/pdp-i6008787253.html",
        "sold": 2
    },
    {
        "product_name": "YUNTENG VCT-288 ขาตั้งโมโนพอด ขาตั้งกล้อง Photo Video Aluminum Monopod ขาตั้งมือถือ มีกระเป๋าแถมให้",
        "product_image": "https://img.lazcdn.com/g/p/defc6ba9199c0f69e65bea6dd00034b8.png_200x200q90.png",
        "price": 1780,
        "remark": "https://www.lazada.co.th/products/pdp-i4644632607.html",
        "sold": 0
    },
    {
        "product_name": "Belkin สายชาร์จ USB-C to Lightning Cable Braided PCR 1M  [CAA022FQ1M]",
        "product_image": "https://img.lazcdn.com/g/p/f0dd4918135c7dd14b2a61491c11e331.jpg_200x200q90.jpg",
        "price": 1780,
        "remark": "https://www.lazada.co.th/products/pdp-i5996159161.html",
        "sold": 0
    },
    {
        "product_name": "Apple Lightning to USB-C Cable 2 m (สายชาร์จไอโฟน)",
        "product_image": "https://img.lazcdn.com/g/p/db10e23e1d6be574bf1180f21b2f55b3.jpg_200x200q90.jpg",
        "price": 1780,
        "remark": "https://www.lazada.co.th/products/pdp-i2731496989.html",
        "sold": 1434
    },
    {
        "product_name": "xiaotian | ขาตั้งโทรศัพท์แบบพกพาหลายฟังก์ชันสำหรับไลฟ์สตรีมและถ่ายวิดีโอสั้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S635e3d2962064a298e4081f3c1697213N.png_200x200q90.png",
        "price": 1774.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16049290860.html",
        "sold": 3
    },
    {
        "product_name": "Ulanzi | ไม้เซลฟี่แม่เหล็กขาตั้งกล้อง ขาตั้งโทรศัพท์มือถือ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S45e9d2f4a8d74c3898151030d905c3be2.jpg_200x200q90.jpg",
        "price": 1770.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16049716159.html",
        "sold": 13
    },
    {
        "product_name": "Anker | สายชาร์จเร็ว 2-in-1 แบบ Type-C",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S988153fa3248456787d04454ed09ce1en.jpg_200x200q90.jpg",
        "price": 1758,
        "remark": "https://www.lazada.co.th/products/pdp-i6062865620.html",
        "sold": 0
    },
    {
        "product_name": "apexel | เลนส์มาโคร APEXEL รุ่นใหม่ HD ซูม 10-20 เท่า ขนาดเล็กพกพาสะดวก สำหรับกล้องโทรศัพท์มือถือ iPhone 17/pro max และสมาร์ทโฟน Android ทุกรุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4e1e9d421a2e4dd9bf56a54a5557956em.jpg_200x200q90.jpg",
        "price": 1749.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16127060260.html",
        "sold": 0
    },
    {
        "product_name": "SKINARMA รุ่น Lanyard Dyno VE (240W) สายคล้องคอพร้อมสายชาร์จ (USB-C to USB-C)",
        "product_image": "https://img.lazcdn.com/g/p/59955828f883e200bcb2f5816bc9637e.jpg_200x200q90.jpg",
        "price": 1744,
        "remark": "https://www.lazada.co.th/products/pdp-i5849362660.html",
        "sold": 4
    },
    {
        "product_name": "1-50 ชิ้นเดิม PD 60W สายชาร์จประเภท C แบบรวดเร็วสำหรับ Apple iPhone 13 14 12 11 17 Air 15 16 Pro Max Plus สายชาร์จทอ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2ac4b9e879a84304b7e6a651dc103c21v.jpg_200x200q90.jpg",
        "price": 1737.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5963418651.html",
        "sold": 0
    },
    {
        "product_name": "ชั้นวางคอมพิวเตอร์และตัวจัดระเบียบมือถือปรับได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2dc5863454ad4e1293e821cc84274c5e0.jpg_200x200q90.jpg",
        "price": 1716.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5912520820.html",
        "sold": 22
    },
    {
        "product_name": "UGREEN | อะแดปเตอร์ชาร์จเร็ว 65W",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3f24754623224710a20a72bfd778271cb.jpg_200x200q90.jpg",
        "price": 1716,
        "remark": "https://www.lazada.co.th/products/pdp-i6006085595.html",
        "sold": 12
    },
    {
        "product_name": "LORT | อะแดปเตอร์ชาร์จเร็ว PD 40W สาย Type-C",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd8f9161eb57a43b99fd75ea4fb4b3e8eT.jpg_200x200q90.jpg",
        "price": 1712,
        "remark": "https://www.lazada.co.th/products/pdp-i6006080972.html",
        "sold": 1
    },
    {
        "product_name": "ที่วางโทรศัพท์มือถือและแล็ปท็อป 2 in 1 ปรับระดับความสูงได้ ระบายความร้อนแนวตั้ง พับได้ ใช้ในสำนักงาน ยกได้ โครงเหล็กคาร์บอน ออกแบบตามหลักสรีรศาสตร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1f34f10d035c45d989d80b596905caa0N.jpg_200x200q90.jpg",
        "price": 1710.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16111597139.html",
        "sold": 0
    },
    {
        "product_name": "(ประกัน 1 ปี)iBitzz พัดลมระบายความร้อน พัดลมระบายความร้อนมือถือ แท็บเล็ต พัดลมระบายความร้อนโทรศัพท์ พัดลมติดมือถือ พัดลมโทรศัพท์ พัดลมเกมมิ่ง พัดสำหรับเล่นเกม พัดลมสายเกมเมอร์  พัดลมมือถือเเบบพกพา  จอแสดงผลดิจิตอลอุณหภูมิ",
        "product_image": "https://img.lazcdn.com/g/p/fa0fd486c6d6186e9beabd41a6bb5b04.jpg_200x200q90.jpg",
        "price": 1696.68,
        "remark": "https://www.lazada.co.th/products/pdp-i4870955479.html",
        "sold": 103
    },
    {
        "product_name": "Unicraft สายชาร์จ  รุ่น USB-C Phone Lanyard USB C-to-USB C Cable",
        "product_image": "https://img.lazcdn.com/g/p/dfc223ed4ac4021bb4f677024bcf802f.jpg_200x200q90.jpg",
        "price": 1690,
        "remark": "https://www.lazada.co.th/products/pdp-i5893057042.html",
        "sold": 9
    },
    {
        "product_name": "สายของแท้100% Sanrio Hello Kitty ชาร์จไว Type-C ถึง Type-C ไปยังสาย PD Lightning Kuromi 27W/100W สำหรับสมาร์ทโฟนไอโฟนไอแพดแอนดรอยด์ MYD82",
        "product_image": "https://img.lazcdn.com/g/p/6c8b43b5985917189cf831bee86195b3.png_200x200q90.png",
        "price": 1679.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5431034949.html",
        "sold": 1
    },
    {
        "product_name": "ส่งจากไทย สถานีชาร์จบนโต๊ะ, ที่ชาร์จพร้อมจอแสดงผลกำลังไฟ, อะแดปเตอร์โทรศัพท์มือถือ,อะแดปเตอร์ไฟฟ้า,อะแดปเตอร์แล็ปท็อป, สายยาว 2 เมตร, รองรับการชาร์จพร้อมกันหลายอุปกรณ์",
        "product_image": "https://img.lazcdn.com/g/p/bbce660c7fbb82b69181081dcda98664.jpg_200x200q90.jpg",
        "price": 1678,
        "remark": "https://www.lazada.co.th/products/pdp-i6015969379.html",
        "sold": 1
    },
    {
        "product_name": "ที่จับโทรศัพท์แม่เหล็ก TELESIN สำหรับถ่ายภาพ พร้อมรีโมทคอนโทรล ใช้ได้กับสมาร์ทโฟน iPhone และ Android",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seecee8263a79416dbb1f76456ac3f47a4.jpg_200x200q90.jpg",
        "price": 1672.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6035005196.html",
        "sold": 0
    },
    {
        "product_name": "BRAVO เครื่องผสมอาหารมือถือ BHM-500 (500 วัตต์)",
        "product_image": "https://img.lazcdn.com/g/p/fa676a5fba0a97a44ce4178294236c09.jpg_200x200q90.jpg",
        "price": 1658,
        "remark": "https://www.lazada.co.th/products/pdp-i1779540420.html",
        "sold": 10
    },
    {
        "product_name": "ที่ยึดโทรศัพท์แบบคล้องคอพร้อมสายกันสั่น - ขาตั้งกล้องแบบคล้องคอสำหรับถ่าย POV/Vlog ใช้งานได้กับสมาร์ทโฟนและกล้องแอคชั่นทุกประเภท",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdd89857cf9fc44f89b2b92bd700516fcX.jpg_200x200q90.jpg",
        "price": 1640.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6073985707.html",
        "sold": 0
    },
    {
        "product_name": "Cuktech | สายชาร์จแบบถัก PD Type-C รุ่น No.6 พร้อมจอแสดงผล สายชาร์จแม่เหล็ก",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S64867665232f4181b7b273e27b0703ccz.jpg_200x200q90.jpg",
        "price": 1634,
        "remark": "https://www.lazada.co.th/products/pdp-i6026308100.html",
        "sold": 16
    },
    {
        "product_name": "JIAHUACAI | ไม้เซลฟี่พร้อมขาตั้งและไฟเติมแสงสำหรับการสตรีมสด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S041b1bdabb824088817b4f8c7488fc8bv.png_200x200q90.png",
        "price": 1615.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16051016692.html",
        "sold": 0
    },
    {
        "product_name": "Apple | สายชาร์จ Apple แท้ PD 20W พร้อมหัวชาร์จ iPhone 13-16 Pro Max",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sec1cc0320869410284fcd3d7fe9b08f1b.jpg_200x200q90.jpg",
        "price": 1610,
        "remark": "https://www.lazada.co.th/products/pdp-i6027881615.html",
        "sold": 6
    },
    {
        "product_name": "TELESIN | TELESIN P9-MPR-01 ตัวระบายความร้อนโทรศัพท์แบบแม่เหล็ก พัดลมเงียบ ระบายความร้อนได้อย่างมีประสิทธิภาพ สำหรับเล่นเกม ถ่ายทอดสด แท็บเล็ต และอุปกรณ์อื่นๆ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc329b6bb81b34fc3b21649c399428cdb8.jpg_200x200q90.jpg",
        "price": 1598.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16116865286.html",
        "sold": 0
    },
    {
        "product_name": "[ใช้คูปอง ลดเหลือ 559 บ.] ZMI HA832 หัวชาร์จ 3 พอร์ต ใช้งานรวม 65W พร้อมสาย Type-C to Type-C ชาร์จเร็ว PD3.0/QC3.0/FCP รับประกันศูนย์ไทย 2 ปี",
        "product_image": "https://img.lazcdn.com/g/p/660e4c4974b346e6dce019e903f87f57.png_200x200q90.png",
        "price": 1598,
        "remark": "https://www.lazada.co.th/products/pdp-i347352501.html",
        "sold": 254
    },
    {
        "product_name": "ที่ชาร์จไร้สายสำหรับมือถือ 4in1 ปรับหมุนได้ 180 องศา พร้อมขาตั้งและชาร์จไร้สายแบบแม่เหล็ก",
        "product_image": "https://img.lazcdn.com/g/p/17f47de644abba6032592c5c7e3ecd59.jpg_200x200q90.jpg",
        "price": 1598,
        "remark": "https://www.lazada.co.th/products/pdp-i5721969459.html",
        "sold": 7
    },
    {
        "product_name": "KEYSION หูฟัง3 In 1 Type C ถึง3.5มม. ตัวแปลงสัญญาณเสียงดิจิตอลเป็นอานาล็อกหูฟังคู่ประเภท C อะแดปเตอร์เชื่อมหูฟัง PD60W แยกการชาร์จอย่างรวดเร็วสำหรับ iPhone 15",
        "product_image": "https://img.lazcdn.com/g/p/0bb61a2bd9e60a80aeadd1b8167361e2.jpg_200x200q90.jpg",
        "price": 1598,
        "remark": "https://www.lazada.co.th/products/pdp-i4955462196.html",
        "sold": 192
    },
    {
        "product_name": "Ulanzi MT-44B V2  2-in-1 Selfie Stick Tripod ไม้เซลฟี่ ขาตั้งมือถือ Dual Camera รีโมทบลูทูธ สำหรับVlogg",
        "product_image": "https://img.lazcdn.com/g/p/a177a04c07dd6b9aa14988c17a814f5d.jpg_200x200q90.jpg",
        "price": 1598,
        "remark": "https://www.lazada.co.th/products/pdp-i4294442635.html",
        "sold": 2
    },
    {
        "product_name": "รุ่นขายดี!!ที่วางโทรศัพท์แม่เหล็กหมุนได้ 360°รองรับทุกมุมมองอย่างเต็มที่ พร้อมสูญญากาศดูดติดแน่น มั่นคง ทนทาน และระบบไฟฟ",
        "product_image": "https://img.lazcdn.com/g/p/4a2f3b323b7eae1db98c413c4e5d6369.jpg_200x200q90.jpg",
        "price": 1596,
        "remark": "https://www.lazada.co.th/products/pdp-i5691689622.html",
        "sold": 42
    },
    {
        "product_name": "telesin | ฟิลเตอร์โทรศัพท์ TELESIN 67 มม. ของแท้ สำหรับการถ่ายภาพแบบภาพยนตร์ด้วยสมาร์ทโฟน พร้อมเอฟเฟกต์การปรับสีระดับมืออาชีพ และดีไซน์ยึดติดแน่นหนา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9d83d5104e064959aa76ced86e6f0e12N.jpg_200x200q90.jpg",
        "price": 1584.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16103823990.html",
        "sold": 0
    },
    {
        "product_name": "240W USB-C Charge Cable (2 m)",
        "product_image": "https://img.lazcdn.com/g/p/b9590ce8a3341c858689674d502f7f32.jpg_200x200q90.jpg",
        "price": 1580,
        "remark": "https://www.lazada.co.th/products/pdp-i4873634230.html",
        "sold": 1122
    },
    {
        "product_name": "UNIQ สายคล้องโทรศัพท์และคล้องมือแบบ 2-in-1 (Lanyard & Hand Strap) รุ่น Vista",
        "product_image": "https://img.lazcdn.com/g/p/2ee81fb2a4dd3f9c746156caa7cbdc9d.png_200x200q90.png",
        "price": 1580,
        "remark": "https://www.lazada.co.th/products/pdp-i5148401690.html",
        "sold": 3
    },
    {
        "product_name": "สายชาร์จ Ugreen USB-C to USB-C Cable 240W 1M. GEN2 Gray (80150) by Banana IT",
        "product_image": "https://img.lazcdn.com/g/p/89479930431e635e98b3aa42a77e74e3.jpg_200x200q90.jpg",
        "price": 1580,
        "remark": "https://www.lazada.co.th/products/pdp-i5764374386.html",
        "sold": 0
    },
    {
        "product_name": "ขอใบกำกับทักแชทเท่านั้น Apple Lightning To USB-C Cable (1 m) [iStudio by UFicon]",
        "product_image": "https://img.lazcdn.com/g/p/50a9afbe26b0c8896d503a2a9ea19eb6.jpg_200x200q90.jpg",
        "price": 1580,
        "remark": "https://www.lazada.co.th/products/pdp-i966110751.html",
        "sold": 260
    },
    {
        "product_name": "Apple 60W USB-C Charge Cable (1m) by Studio 7",
        "product_image": "https://img.lazcdn.com/g/p/a573d5f2fd84267691aa18b73eece790.jpg_200x200q90.jpg",
        "price": 1580,
        "remark": "https://www.lazada.co.th/products/pdp-i5387693138.html",
        "sold": 212
    },
    {
        "product_name": "สายชาร์จ Apple USB-C to Lightning Cable (1m) by Studio 7",
        "product_image": "https://img.lazcdn.com/g/p/cc8ec0d8eadcbb18ff452fb8d6ce0c06.jpg_200x200q90.jpg",
        "price": 1580,
        "remark": "https://www.lazada.co.th/products/pdp-i5099878420.html",
        "sold": 643
    },
    {
        "product_name": "ขาตั้งไอแพด 7\"-12.9\" รุ่นใหม่ปี2021🔥อลูมินั่มสีเงิน ฐานมั่นคง ปรับองศาก้มเงยได้อิสระ AP7S Universal Tablet/Mobile phone ใส่ไอแพด/แทบเล็ต/มือถือได้ทุกรุ่น",
        "product_image": "https://img.lazcdn.com/g/p/251151dc9eeeaf2df8e2f224e1a26e5b.jpg_200x200q90.jpg",
        "price": 1580,
        "remark": "https://www.lazada.co.th/products/pdp-i2021402667.html",
        "sold": 8
    },
    {
        "product_name": "Anker 641 สายชาร์จ 30W Type-C To Lightning ประกัน 18 เดือน ชาร์จเร็ว มีมาตรฐานMfi แข็งแรงทนทาน สวยงาม ผลิตจากวัสดุธรรมชาติ สําหรับ iPhone iPad ไอโฟน ไอแพด",
        "product_image": "https://img.lazcdn.com/g/p/70ec64df1c5676a27fd71a5587e99813.jpg_200x200q90.jpg",
        "price": 1580,
        "remark": "https://www.lazada.co.th/products/pdp-i4907671357.html",
        "sold": 2
    },
    {
        "product_name": "เครื่องค้นหาปลาแบบเรียลไทม์และไดนามิก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6f2864ace2234698a5319fff6937b154l.jpg_200x200q90.jpg",
        "price": 155963.24,
        "remark": "https://www.lazada.co.th/products/pdp-i6003313482.html",
        "sold": 0
    },
    {
        "product_name": "SATA 09950 ชุดถาดเครื่องมือช่าง 176 ชิ้น ชุดเครื่องมือช่าง",
        "product_image": "https://img.lazcdn.com/g/p/97f0d27d8f310a3d6ae898ebff4c5726.jpg_200x200q90.jpg",
        "price": 104000,
        "remark": "https://www.lazada.co.th/products/pdp-i16091878174.html",
        "sold": 1
    },
    {
        "product_name": "BESITA ชุดตู้เครื่องมือ 380 ชิ้น ตู้เครื่องมือช่าง 7 ชั้น พร้อมเครื่องมือครบชุด (6850S)",
        "product_image": "https://img.lazcdn.com/g/p/8233f8c2d2068e84341a49bbbe372a2c.jpg_200x200q90.jpg",
        "price": 93800,
        "remark": "https://www.lazada.co.th/products/pdp-i5897176529.html",
        "sold": 0
    },
    {
        "product_name": "yishujia office | เครื่องลอกสายไฟกำลังสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S518056a61c0d4489951333fa51f5334fy.png_200x200q90.png",
        "price": 77904.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16101109128.html",
        "sold": 0
    },
    {
        "product_name": "Total ชุดเครื่องมือช่าง อเนกประสงค์ 369 ชิ้นชุด / 288 ชิ้น ( พร้อมตู้เครื่องมือ 7 ชั้น มีล้อ ) รุ่น THPTCS83692 / THPTCS82882 ( Tools Set ) ชุดเครื่องมือ ตู้เครื่องมือช่าง พร้อมเครื่องมือ",
        "product_image": "https://img.lazcdn.com/g/p/91dbd4a4b4fd73b0da9ea257f0d70251.jpg_200x200q90.jpg",
        "price": 73000,
        "remark": "https://www.lazada.co.th/products/pdp-i5884009801.html",
        "sold": 1
    },
    {
        "product_name": "OP ตู้เครื่องมือพร้อมอุปกรณ์ 444 ชิ้น รุ่น EMTOP2459",
        "product_image": "https://img.lazcdn.com/g/p/0580cc5ac5bf11621f5a93082e75927e.jpg_200x200q90.jpg",
        "price": 67800,
        "remark": "https://www.lazada.co.th/products/pdp-i5864292305.html",
        "sold": 0
    },
    {
        "product_name": "HELIX | กระเป๋ากอล์ฟ แข็งทนน้ำและแรงกด ใช้ได้ทั้งถือขึ้นเครื่องและโหลดใต้ท้องเครื่อง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb5b472f8b4f6449dbb83797fdc9ab77el.jpg_200x200q90.jpg",
        "price": 55446.04,
        "remark": "https://www.lazada.co.th/products/pdp-i6031788899.html",
        "sold": 1
    },
    {
        "product_name": "TOTAL THPTCS73281 ตู้เครื่องมือช่างอเนกประสงค์ 328 ชิ้น พร้อมเครื่องมือ รุ่นงานหนัก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7f29ca22466942d0a24ce0ba5b830e69y.jpg_200x200q90.jpg",
        "price": 53580,
        "remark": "https://www.lazada.co.th/products/pdp-i5686376462.html",
        "sold": 0
    },
    {
        "product_name": "TOTAL ตู้เครื่องมือช่างอเนกประสงค์ 7 ชั้น 328 ชิ้น (พร้อมเครื่องมือ) ชุด ประแจ ไขควง คีม  รุ่น THPTCS73281",
        "product_image": "https://img.lazcdn.com/g/p/411be8487a141a8a9f626d3ea8caa3a2.jpg_200x200q90.jpg",
        "price": 53580,
        "remark": "https://www.lazada.co.th/products/pdp-i5918107208.html",
        "sold": 0
    },
    {
        "product_name": "Total ตู้เครื่องมือช่าง 7 ชั้น พร้อมอุปกรณ์ 162 ชิ้น รุ่น THPTCS71621 / 328 ชิ้น รุ่น THPTCS73281 ( Tools Chest Set ) ชุดเครื่องมือช่าง ตู้เครื่องมือ เครื่องมือช่างพร้อมตู้",
        "product_image": "https://img.lazcdn.com/g/p/5f5f4bc99743095749d35429bc9bf8d7.jpg_200x200q90.jpg",
        "price": 53580,
        "remark": "https://www.lazada.co.th/products/pdp-i2888504650.html",
        "sold": 7
    },
    {
        "product_name": "ตู้เครื่องมือช่างอเนกประสงค์ 328 ชิ้น(พร้อมเครื่องมือ) #THPTCS73281",
        "product_image": "https://img.lazcdn.com/g/p/02a666041c35348415c50b7d93da12ee.jpg_200x200q90.jpg",
        "price": 51763.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5458133381.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องเปลี่ยนยางรถยนต์หนักด้วยระบบลมและสุญญากาศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2ea784f1a7f8430e9147c8c7bee8298fM.jpg_200x200q90.jpg",
        "price": 51301.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16107326126.html",
        "sold": 0
    },
    {
        "product_name": "Oral-B | เครื่องเปลี่ยนยางรถบรรทุกแบบลม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S05c5f301ade34be4869660dcd70cbbd5L.jpg_200x200q90.jpg",
        "price": 49905.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16107282039.html",
        "sold": 0
    },
    {
        "product_name": "Camnal | เครื่องขึ้นเชือกไฟฟ้า 24V สำหรับงานลุย ขึ้น-ลงด้วยปุ่มเดียว แบตในตัว ใช้งานได้ 30 นาที",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfa91c0bd3f8c4d779cda0e36344084819.jpg_200x200q90.jpg",
        "price": 47458.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16049446511.html",
        "sold": 1
    },
    {
        "product_name": "Milwaukee 🇹🇭 ทาวเวอร์ไลท์ รุ่น M18 SAL2-0 (เครื่องเปล่า) ไฟส่องพื้นที่18โวลท์ พร้อมขาตั้ง ยืดสูงสุด 2.2 ม. มิว มิววอกี้ มิลวอกี้ เครื่องมือช่าง",
        "product_image": "https://img.lazcdn.com/g/p/e549e1c03d01364cda0e368cbc8522f4.jpg_200x200q90.jpg",
        "price": 27254,
        "remark": "https://www.lazada.co.th/products/pdp-i3983844823.html",
        "sold": 0
    },
    {
        "product_name": "Garmin Quatix 8 51mm Marine Nautical GPS Watch AMOLED",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S515b7ffe639c436db91947f542675b079.jpg_200x200q90.jpg",
        "price": 40000,
        "remark": "https://www.lazada.co.th/products/pdp-i16087886552.html",
        "sold": 0
    },
    {
        "product_name": "Astro Products ชุดเครื่องมือช่าง 76 ชิ้น EVOLUTION SET Evolution Tool Set MATTE BLACK TS203 W505×D200×H53 160mm 75mm, 150mm 9.5 kg 72T Impact Universal Joint Q-Fit With Drawer Precision / Evolition Tool Set MATTE BLACK 76PCS TS 203",
        "product_image": "https://img.lazcdn.com/g/p/30592690c6786f2cf3eb7fba198f1a35.jpg_200x200q90.jpg",
        "price": 36200,
        "remark": "https://www.lazada.co.th/products/pdp-i2544154833.html",
        "sold": 2
    },
    {
        "product_name": "ชุดบล็อกและประแจ Sonic จำนวน 34 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/7884867ccc4581f4b00085b9c1698474.jpg_200x200q90.jpg",
        "price": 33800,
        "remark": "https://www.lazada.co.th/products/pdp-i6008137803.html",
        "sold": 0
    },
    {
        "product_name": "กล้องถ่ายรูปใต้น้ำกันน้ำ IP68ภาพกล้องตรวจค้นหาปลาชัดเจนสำหรับการตกปลาในน้ำแข็ง",
        "product_image": "https://img.lazcdn.com/g/p/3ac895ffd05d6eb386bf93dfd0e49664.jpg_200x200q90.jpg",
        "price": 31178,
        "remark": "https://www.lazada.co.th/products/pdp-i6066567102.html",
        "sold": 0
    },
    {
        "product_name": "รีโมทคอนโทรลปรับความเร็วกล้องตรวจค้นหาปลากล้องใต้น้ำกันน้ำ IP68สำหรับตกปลาน้ำแข็ง",
        "product_image": "https://img.lazcdn.com/g/p/ab0abdee39d06413025ef95d066fa386.jpg_200x200q90.jpg",
        "price": 31178,
        "remark": "https://www.lazada.co.th/products/pdp-i6066408593.html",
        "sold": 0
    },
    {
        "product_name": "ต้านทานการกัดกร่อนเหยื่อล่อปลากล้องใต้น้ำ IP68กันน้ำสำหรับการตกปลาในน้ำแข็ง",
        "product_image": "https://img.lazcdn.com/g/p/6f788cf01e917245405e77ea7ac3686d.jpg_200x200q90.jpg",
        "price": 31162,
        "remark": "https://www.lazada.co.th/products/pdp-i6050727436.html",
        "sold": 0
    },
    {
        "product_name": "กล้องใต้น้ำไฟ LED 38ชิ้นสำหรับตกปลาในน้ำแข็งแบบกล้องตรวจค้นหาปลา",
        "product_image": "https://img.lazcdn.com/g/p/f5abd9d06e80e99d87ad03e8c950c8b6.jpg_200x200q90.jpg",
        "price": 31162,
        "remark": "https://www.lazada.co.th/products/pdp-i6043896675.html",
        "sold": 0
    },
    {
        "product_name": "BLUESHARK เครื่องกว้านอลูมิเนียม10 \"สำหรับแล่นเรือใบใน3100: อุปกรณ์อลูมิเนียมความแข็งแรงสูงเกรดพรีเมี่ยม",
        "product_image": "https://img.lazcdn.com/g/p/164da7c9992df0864c90b9accc73cdd0.jpg_200x200q90.jpg",
        "price": 31063.76,
        "remark": "https://www.lazada.co.th/products/pdp-i5727498684.html",
        "sold": 0
    },
    {
        "product_name": "ชุดไขควงปรับแรงบิดได้ 13 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S43af69c9f913480c9a5156b576a2db62R.jpg_200x200q90.jpg",
        "price": 29352.94,
        "remark": "https://www.lazada.co.th/products/pdp-i6066819167.html",
        "sold": 0
    },
    {
        "product_name": "( ออกใบกำกับภาษีได้ ) KONY ตู้เครื่องมือช่าง 7 ชั้น มีล้อ (AA) และชุดเครื่องมือช่าง 260 ชิ้น (สั่งครบชุด กรุณากดสั่งแยก ) KN-BT015SET จัดส่งด่วนจากกรุงเทพ",
        "product_image": "https://img.lazcdn.com/g/p/410b01e70a5a890ad624f7b8ea60c959.jpg_200x200q90.jpg",
        "price": 27880,
        "remark": "https://www.lazada.co.th/products/pdp-i5140920480.html",
        "sold": 0
    },
    {
        "product_name": "( ออกใบกำกับภาษีได้ ) KONY ตู้เครื่องมือช่าง 7 ชั้น มีล้อ (ฺBB) และชุดเครื่องมือช่าง 260 ชิ้น (สั่งครบชุด กรุณากดสั่งแยก ) KN-BT017SET ทักแชท ส่งของไว ได้ใช้ของจริง",
        "product_image": "https://img.lazcdn.com/g/p/881dd39366c1d2387c1640528fdd0c7c.jpg_200x200q90.jpg",
        "price": 26960,
        "remark": "https://www.lazada.co.th/products/pdp-i5142301365.html",
        "sold": 0
    },
    {
        "product_name": "TT KONY ตู้เครื่องมือช่าง 7 ชั้น มีล้อ (ฺBB) และชุดเครื่องมือช่าง 260 ชิ้น (สั่งครบชุด กรุณากดสั่งแยก ) KN-BT017SET ทักแ",
        "product_image": "https://img.lazcdn.com/g/p/ccbd79ab08a30d5e7f338d60c1324f3c.jpg_200x200q90.jpg",
        "price": 25070,
        "remark": "https://www.lazada.co.th/products/pdp-i5183167410.html",
        "sold": 0
    },
    {
        "product_name": "MILWAUKEE ทาวเวอร์ไลท์ รุ่น M18 SAL2-0 (เครื่องเปล่า) ไฟส่องพื้นที่18โวลท์ พร้อมขาตั้ง ยืดสูงสุด 2.2 ม. มิว มิววอกี้ มิลวอกี้ เครื่องมือช่าง",
        "product_image": "https://img.lazcdn.com/g/p/63751411ca3a77e02230d31b6b57f9d2.jpg_200x200q90.jpg",
        "price": 24776,
        "remark": "https://www.lazada.co.th/products/pdp-i4973463961.html",
        "sold": 0
    },
    {
        "product_name": "TONE ชุดบล็อก 33ชิ้น ขนาด 1/2\" รุ่น 170M",
        "product_image": "https://img.lazcdn.com/g/p/22598c3d64a6e00d1b4f71bfcf544600.jpg_200x200q90.jpg",
        "price": 22432,
        "remark": "https://www.lazada.co.th/products/pdp-i4880967204.html",
        "sold": 0
    },
    {
        "product_name": "KONY ประแจขันปอนด์ 3/4\"  แรงบิด 200-1000Nm ด้ามขันปอนด์ รุ่น Heavy Duty ซีรี่ส์ KING COBRA No.KN-KB06-1000NM",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9f34935372534e1eb8f8acee2725b747F.jpg_200x200q90.jpg",
        "price": 19600,
        "remark": "https://www.lazada.co.th/products/pdp-i5821619953.html",
        "sold": 0
    },
    {
        "product_name": "KONY ประแจขันปอนด์ 1\"  แรงบิด 300-1500Nm ด้ามขันปอนด์ รุ่น Heavy Duty ซีรี่ส์ KING COBRA No.KN-KB08-1500NM",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4e41557b5c0b43a4afaa3b50fde258ae8.jpg_200x200q90.jpg",
        "price": 22000,
        "remark": "https://www.lazada.co.th/products/pdp-i5821750321.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องขับดันใต้น้ำเครื่องควบคุมด้วยไฟฟ้าแบบไร้แปรงถ่านสำหรับเรือ RC",
        "product_image": "https://img.lazcdn.com/g/p/c01435fb6fe83df19a880d2c00f5241f.jpg_200x200q90.jpg",
        "price": 20081.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16098105314.html",
        "sold": 0
    },
    {
        "product_name": "ARCA อาร์ก้า ชุดเครื่องมือ-ลูกบล็อก 3/4\" ชุด 23 ตัว มีแบบ 6 เหลี่ยม, 12 เหลี่ยม นำเข้าจากไต้หวัน",
        "product_image": "https://img.lazcdn.com/g/p/b519ce3352d0da4dfca5570a330f94b1.jpg_200x200q90.jpg",
        "price": 19740,
        "remark": "https://www.lazada.co.th/products/pdp-i5724064474.html",
        "sold": 0
    },
    {
        "product_name": "Flameer เครื่องการทำล่อจับปลาแบบหมุนเครื่องหนีบคาดบินชุดพันเหยื่อฟลายสำหรับตกปลาภายนอก",
        "product_image": "https://img.lazcdn.com/g/p/a9c79db9a08eed7949f0f5807eebbe91.jpg_200x200q90.jpg",
        "price": 19190,
        "remark": "https://www.lazada.co.th/products/pdp-i5983541428.html",
        "sold": 0
    },
    {
        "product_name": "ตู้เครื่องมือ พร้อมเครื่องมือ ตู้ขนาด 7 ชั้น",
        "product_image": "https://img.lazcdn.com/g/p/f2c6f955219640ab1c0121ce2e8184f8.jpg_200x200q90.jpg",
        "price": 19000,
        "remark": "https://www.lazada.co.th/products/pdp-i2368062162.html",
        "sold": 1
    },
    {
        "product_name": "ตู้เครื่องมือ 7 ชั้น พร้อมเครื่องมือ 352 ชิ้น ตู้เก็บเครื่องมือช่าง ตู้",
        "product_image": "https://img.lazcdn.com/g/p/81122186aaca87d6168a0a6f71606f09.jpg_200x200q90.jpg",
        "price": 19000,
        "remark": "https://www.lazada.co.th/products/pdp-i3665456450.html",
        "sold": 6
    },
    {
        "product_name": "ชุดเครื่องมือช่าง สีแดง TS227 W450×L185×H40mm 178 mm 14 kg. (including eq 90T Impact Universal Joint Q-Fit Portable With Drawer / Tool Set Red 82 Pcs TS227",
        "product_image": "https://img.lazcdn.com/g/p/c9c41ab0133c1def554321b81e43e64a.jpg_200x200q90.jpg",
        "price": 18900,
        "remark": "https://www.lazada.co.th/products/pdp-i5140571483.html",
        "sold": 0
    },
    {
        "product_name": "KONY ประแจขันปอนด์ 3/4\"  แรงบิด 150-800Nm ด้ามขันปอนด์ รุ่น Heavy Duty ซีรี่ส์ KING COBRA No.KN-KB06-800NM",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S11f40e4958f548408fb601fca42fe7c4B.jpg_200x200q90.jpg",
        "price": 17000,
        "remark": "https://www.lazada.co.th/products/pdp-i5821639889.html",
        "sold": 0
    },
    {
        "product_name": "WDAir เครื่องยิงลูกขนไก่ปรับมุมได้ในร่มกลางแจ้งสำหรับผู้เริ่มต้นเครื่องขว้างลูกแบบพกพา",
        "product_image": "https://img.lazcdn.com/g/p/3b6890c85a50da078e4bb837b52766f5.jpg_200x200q90.jpg",
        "price": 18764,
        "remark": "https://www.lazada.co.th/products/pdp-i5999657902.html",
        "sold": 0
    },
    {
        "product_name": "( PRO+++ ) โปรแน่น.. แพ็คราคาสุดคุ้ม!! ชุดบล็อก ชุดประแจรวม 105 ชิ้น พร้อมกล่องเหล็กเก็บอุปกรณ์อย่างดี ราคาสุดคุ้ม ประแจ ประแจ เลื่อน ประแจ ปอนด์ ประแจ คอม้า",
        "product_image": "https://img.lazcdn.com/g/p/cd7613e29b9d29b32d02bfd7e2fb1394.jpg_200x200q90.jpg",
        "price": 17978,
        "remark": "https://www.lazada.co.th/products/pdp-i4418881330.html",
        "sold": 0
    },
    {
        "product_name": "SATA ชุดเครื่องมือช่าง 70 ชิ้น พร้อมกล่องเหล็ก (ลูกบ๊อกซ์ 12 เหลี่ยม และ ลูกบ๊อกซ์ 6 เหลี่ยม) รุ่น 95104A70 , 95104A70-6 ( 70 Pcs Tools Set )",
        "product_image": "https://img.lazcdn.com/g/p/878aae0a7f43fb932c96798aa6940a6c.jpg_200x200q90.jpg",
        "price": 17202,
        "remark": "https://www.lazada.co.th/products/pdp-i3812600201.html",
        "sold": 0
    },
    {
        "product_name": "Milwaukee - ชุดพลังขันเต็มแมกซ์ ประแจบล็อกด้ามฟรี 1/2นิ้ว + กระเป๋าเก็บอุปกรณ์ดูดฝุ่น พร้อมแบตและแท่นชาร์จ QT 4",
        "product_image": "https://img.lazcdn.com/g/p/7367215c87a676614693e010ef822211.png_200x200q90.png",
        "price": 17016,
        "remark": "https://www.lazada.co.th/products/pdp-i16141634902.html",
        "sold": 0
    },
    {
        "product_name": "ไขควงแบนชุดไขควงแม่นยำอเนกประสงค์ Essential สำหรับการบำรุงรักษาบ้านซ่อม DIY",
        "product_image": "https://img.lazcdn.com/g/p/e825bddfa9bb9c083fa9a08ecf8ee90d.jpg_200x200q90.jpg",
        "price": 16882,
        "remark": "https://www.lazada.co.th/products/pdp-i6050105193.html",
        "sold": 0
    },
    {
        "product_name": "FIXMAN ชุดเครื่องมือช่างไฟ เครื่องมืองานไฟฟ้า กันกระแสไฟ 29ตัว/ชุด VDE1000V",
        "product_image": "https://img.lazcdn.com/g/p/f734b907cd94286eb5438fe83f76e1f4.jpg_200x200q90.jpg",
        "price": 16780,
        "remark": "https://www.lazada.co.th/products/pdp-i5245792194.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องออกกำลังกายแนวดิ่งแบบพับได้เครื่องอุปกรณ์ออกกำลังกายไม่ลื่นสำหรับยิมที่บ้านผู้ชายผู้หญิงอุปกรณ์ปีนป่ายออกกำลังกาย",
        "product_image": "https://img.lazcdn.com/g/p/8b01577dd28a6fed986116daca275587.jpg_200x200q90.jpg",
        "price": 16547.1,
        "remark": "https://www.lazada.co.th/products/pdp-i6022088710.html",
        "sold": 0
    },
    {
        "product_name": "MILWAUKEE SET 4.0 Ah. สปอทไลท์ชนิดถือ 12โวลท์ รุ่น M12 SLED-0 ส่องได้ไกล 640m. สปอทไลท์ ไฟฉาย สปอตไลท์ มิว มิววอกี้ มิลวอกี้ เครื่องมือช่าง",
        "product_image": "https://img.lazcdn.com/g/p/33b336c427db2dae4aa1e90d7f148d64.jpg_200x200q90.jpg",
        "price": 16228,
        "remark": "https://www.lazada.co.th/products/pdp-i4972012153.html",
        "sold": 0
    },
    {
        "product_name": "KOCHE บล็อกชุด 6 เหลี่ยม SQ.3/4\" 24 ตัวชุด",
        "product_image": "https://img.lazcdn.com/g/p/7ce9991519aa12b87415bf56c2dfbb4a.jpg_200x200q90.jpg",
        "price": 16180,
        "remark": "https://www.lazada.co.th/products/pdp-i2038290036.html",
        "sold": 1
    },
    {
        "product_name": "KOCHE บล็อกชุด 6 เหลี่ยม SQ.3/4\" 24ตัวชุด",
        "product_image": "https://img.lazcdn.com/g/p/7ce9991519aa12b87415bf56c2dfbb4a.jpg_200x200q90.jpg",
        "price": 15746.4,
        "remark": "https://www.lazada.co.th/products/pdp-i4196839757.html",
        "sold": 0
    },
    {
        "product_name": "KONY ประแจขันปอนด์ 3/4\"  แรงบิด 100-600Nm ด้ามขันปอนด์ รุ่น Heavy Duty ซีรี่ส์ KING COBRA No.KN-KB06-600NM",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb3327f92ea2e4c92bebf1a3bdde789dbk.jpg_200x200q90.jpg",
        "price": 13980,
        "remark": "https://www.lazada.co.th/products/pdp-i5821738245.html",
        "sold": 0
    },
    {
        "product_name": "ของแท้!!! KINGTONY 7577MR C02 ชุดเครื่องมือ 80 ชิ้น/ชุด ชุดบล็อก ประแจ ชุด เคื่องมือ คิงโทนี่ เครื่องมือช่าง อเนกประสงค์ - หัวและอุปกรณ์เสริม",
        "product_image": "https://img.lazcdn.com/g/p/7d781ad182cf15b2aa469cb73420c179.jpg_200x200q90.jpg",
        "price": 15580,
        "remark": "https://www.lazada.co.th/products/pdp-i16052184639.html",
        "sold": 0
    },
    {
        "product_name": "DEWALT รุ่น DWMT45184-1 ชุดเซ็ทลูกบล็อกซ์ Mechanical Tools Black Chrome 184 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3f6aa22834e24e62a5d250bbde29ba5bq.jpg_200x200q90.jpg",
        "price": 15368,
        "remark": "https://www.lazada.co.th/products/pdp-i5836176232.html",
        "sold": 0
    },
    {
        "product_name": "Wiha | ชุดไขควงหลายฟังก์ชันหัวคู่ปรับได้ 11 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S46de22c0f3de4177b2abf7eeb2d490940.jpg_200x200q90.jpg",
        "price": 15263.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5878646737.html",
        "sold": 0
    },
    {
        "product_name": "DeWalt | ชุดเครื่องมือพกพาความจุใหญ่ทนทาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S89f170c1b49b461d876c1506e0c7607bE.jpg_200x200q90.jpg",
        "price": 14908.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5872743711.html",
        "sold": 0
    },
    {
        "product_name": "pgm | เครื่องจ่ายลูกกอล์ฟหลายฟังก์ชันที่ได้รับสิทธิบัตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2399d15a145749d9b87b650228fcb9d89.jpg_200x200q90.jpg",
        "price": 14632.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6003393583.html",
        "sold": 4
    },
    {
        "product_name": "ชุด เครื่องมือ ชุดบล็อก เอนกประสงค์ KOCHE 3/4''[ โคเช่ ] 24 ชิ้น Pcs.",
        "product_image": "https://img.lazcdn.com/g/p/2fada08ea40d0ef0b43b9bb35fc0fe85.jpg_200x200q90.jpg",
        "price": 14580,
        "remark": "https://www.lazada.co.th/products/pdp-i4642865587.html",
        "sold": 0
    },
    {
        "product_name": "Homtom เหยื่อล่อปลาวิดีโอเหยื่อล่อปลา12 LED ความแข็งแรงสูงสำหรับทะเลสาบสำหรับทะเล",
        "product_image": "https://img.lazcdn.com/g/p/698ba35ac28605dad8d90354d4fdcfa3.jpg_200x200q90.jpg",
        "price": 14322,
        "remark": "https://www.lazada.co.th/products/pdp-i16072084566.html",
        "sold": 0
    },
    {
        "product_name": "Razer เหยื่อล่อปลากล้องจับปลาใต้น้ำ HD 1000TVL พกพาสำหรับทะเลสาบสำหรับทะเล",
        "product_image": "https://img.lazcdn.com/g/p/631dc91b58c5ee8747392723d7219cff.jpg_200x200q90.jpg",
        "price": 14322,
        "remark": "https://www.lazada.co.th/products/pdp-i6016594332.html",
        "sold": 0
    },
    {
        "product_name": "Total ชุดเครื่องมือช่าง อเนกประสงค์ 142 ชิ้น รุ่น THKTHP21426 ( Tools Set ) / ชุดเครื่องมือ / เครื่องมือชุด / ชุดกระเป๋าเครื่องมือ / เครื่องมือช่าง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9bd9886882654ed7b49833d54a396e532.jpg_200x200q90.jpg",
        "price": 14180,
        "remark": "https://www.lazada.co.th/products/pdp-i306364303.html",
        "sold": 3
    },
    {
        "product_name": "Total ชุดเครื่องมือช่าง อเนกประสงค์ 142 ชิ้น รุ่น THKTHP21426 ( Tools Set ) / ชุดเครื่องมือ / เครื่องมือชุด / ชุดกระเป๋าเครื่องมือ / เครื่องมือช่าง / ชุดบล็อก / ชุดบ๊อกซ์",
        "product_image": "https://img.lazcdn.com/g/p/a530ea153e72c9634b8c3a1b4815dec4.jpg_200x200q90.jpg",
        "price": 14180,
        "remark": "https://www.lazada.co.th/products/pdp-i110334309.html",
        "sold": 16
    },
    {
        "product_name": "THKTHP21426 TOTAL ชุดเครื่องมือ 142 ชิ้น งานหนัก Total รุ่น THKTHP21426 รับประกันคุณภาพ กรุงเทพฯ",
        "product_image": "https://img.lazcdn.com/g/p/bea29e37a925b6f8d6ff9610b658e806.jpg_200x200q90.jpg",
        "price": 14180,
        "remark": "https://www.lazada.co.th/products/pdp-i5161422145.html",
        "sold": 2
    },
    {
        "product_name": "Total ชุดเครื่องมือช่าง อเนกประสงค์ 142 ชิ้น รุ่น THKTHP21426 ( Tools Set ) / ชุดเครื่องมือ / เครื่องมือชุด / ชุดกระเป๋าเครื่องมือ / เครื่องมือช่าง / ชุดบล็อก / ชุดบ๊อกซ์ - ไม่รวมค่าขนส่ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4681f796ad174299ad74088cf0d0d6cb7.jpg_200x200q90.jpg",
        "price": 14180,
        "remark": "https://www.lazada.co.th/products/pdp-i1580850064.html",
        "sold": 2
    },
    {
        "product_name": "Total  ชุดเครื่องมือช่าง 147 ชิ้น รุ่น THKTHP21476 อุปกรณ์เครื่องช่างครบเช็ต รุ่นใหม่ สินค้าแท้100%",
        "product_image": "https://img.lazcdn.com/g/p/e4c60bfebfb3cfb82c7116b9468dca2f.jpg_200x200q90.jpg",
        "price": 14100,
        "remark": "https://www.lazada.co.th/products/pdp-i5093692892.html",
        "sold": 0
    },
    {
        "product_name": "Total ชุดเครื่องมือช่าง 147 ชิ้น พร้อมกระเป๋าอลูมิเนียม เครื่องมือช่างพร้อมกระเป๋า รุ่น THKTHP21476 (147 Pcs Hand Tools Set )",
        "product_image": "https://img.lazcdn.com/g/p/6aed875e1f790bfb44b499ac68f98277.jpg_200x200q90.jpg",
        "price": 14100,
        "remark": "https://www.lazada.co.th/products/pdp-i4052746466.html",
        "sold": 4
    },
    {
        "product_name": "ชุดเครื่องมือช่าง 147 ชิ้น พร้อมกระเป๋าอลูมิเนียม (147 Pcs Hand Tools Set ) รุ่น THKTHP21476 TOTAL",
        "product_image": "https://img.lazcdn.com/g/p/b21991bb0956c1183f75e3a141b6f768.jpg_200x200q90.jpg",
        "price": 14100,
        "remark": "https://www.lazada.co.th/products/pdp-i5078423693.html",
        "sold": 0
    },
    {
        "product_name": "Total ชุดเครื่องมือช่าง 147 ชิ้น พร้อมกระเป๋าอลูมิเนียม รุ่น THKTHP21476 (147 Pcs Hand Tools Set ) เครื่องมือช่างพร้อมกระเป๋า",
        "product_image": "https://img.lazcdn.com/g/p/5f1dca50d16a6498eef6f4c640ae27c4.jpg_200x200q90.jpg",
        "price": 14100,
        "remark": "https://www.lazada.co.th/products/pdp-i3613723458.html",
        "sold": 4
    },
    {
        "product_name": "TOTAL ชุดเครื่องมือ 147 ชิ้น #THKTHP21476",
        "product_image": "https://img.lazcdn.com/g/p/b1873e0ce6430777414503650f1a30cd.png_200x200q90.png",
        "price": 14100,
        "remark": "https://www.lazada.co.th/products/pdp-i5877462660.html",
        "sold": 0
    },
    {
        "product_name": "ชุดบล็อก 129 ชิ้น/ชุด ชุดเครื่องมือ บล็อก ประแจ อุปกรณ์ช่าง ชุดประแจบล็อก+กล่องสำหรับใส่เครื่องมือ 129ชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/35b882f6c60a9302a31b837c20b83c64.png_200x200q90.png",
        "price": 14076,
        "remark": "https://www.lazada.co.th/products/pdp-i2289082773.html",
        "sold": 0
    },
    {
        "product_name": "INGCO ชุดเครื่องมือช่าง 147 ชิ้น พร้อมกระเป๋าอลูมิเนียม รุ่น HKTHP21471 ( Tools Set )",
        "product_image": "https://img.lazcdn.com/g/p/63317cbd105b8e5a37525c2c708247b0.jpg_200x200q90.jpg",
        "price": 14000,
        "remark": "https://www.lazada.co.th/products/pdp-i5527967352.html",
        "sold": 1
    },
    {
        "product_name": "INGCO ชุดเครื่องมือช่าง 147 ชิ้น พร้อมกระเป๋าอลูมิเนียม รุ่น HKTHP21471 ( Tools Set ) เครื่องมือกล่องเหล็ก",
        "product_image": "https://img.lazcdn.com/g/p/63317cbd105b8e5a37525c2c708247b0.jpg_200x200q90.jpg",
        "price": 14000,
        "remark": "https://www.lazada.co.th/products/pdp-i5617473033.html",
        "sold": 0
    },
    {
        "product_name": "กล้องใต้น้ำกล้องจับปลากันน้ำ HD 1000TVL ล้านพิกเซลมุมมอง90องศาสำหรับใต้น้ำสำหรับตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/dfae143294ae2b7a2f61a75b0035e592.jpg_200x200q90.jpg",
        "price": 13680,
        "remark": "https://www.lazada.co.th/products/pdp-i16113887212.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องมือช่าง 187 ชิ้น Professional Tool Set กล่องเครื่องมือพร้อมประแจบล็อกครบชุด อุปกรณ์ซ่อมบำรุงครบวงจร",
        "product_image": "https://img.lazcdn.com/g/p/0c734a59bef1ee2f08777e4b5527ac3f.jpg_200x200q90.jpg",
        "price": 13600,
        "remark": "https://www.lazada.co.th/products/pdp-i5892663821.html",
        "sold": 0
    },
    {
        "product_name": "ชุดบล็อก 24ชิ้น+ประแจYETI+แหวนYETIใช้งานหนัก ได้3อย่าง ชุดบล๊อค ประแจแหวนข้าง ประแจแหวนๆ",
        "product_image": "https://img.lazcdn.com/g/p/42c33cfc8874823d2a8587eac1e57474.jpg_200x200q90.jpg",
        "price": 13600,
        "remark": "https://www.lazada.co.th/products/pdp-i5892684633.html",
        "sold": 0
    },
    {
        "product_name": "TOTAL 🇹🇭 ชุดเครื่องมือช่าง THPTCS70971 97 ชิ้น พร้อมกล่องเก็บเครื่องมือ 97 pcs Tool Chest Set เครื่องมือช่าง",
        "product_image": "https://img.lazcdn.com/g/p/9241d395c87f383449c220bb9fcc4220.jpg_200x200q90.jpg",
        "price": 13580,
        "remark": "https://www.lazada.co.th/products/pdp-i4058713396.html",
        "sold": 0
    },
    {
        "product_name": "TONE ชุดบล็อก 17ชิ้น ขนาด 1/2\" รุ่น 760M",
        "product_image": "https://img.lazcdn.com/g/p/8eb1bb5c17019a257ebb582c633aec1a.jpg_200x200q90.jpg",
        "price": 13554,
        "remark": "https://www.lazada.co.th/products/pdp-i4879244383.html",
        "sold": 0
    },
    {
        "product_name": "Total  ชุดเครื่องมือช่าง 147 ชิ้น รุ่น THKTHP21476 อุปกรณ์เครื่องช่าง ครบเช็ต (พร้อมจัดส่ง)",
        "product_image": "https://img.lazcdn.com/g/p/f95d26dce8511bb4a73e3c65ea857739.jpg_200x200q90.jpg",
        "price": 13395,
        "remark": "https://www.lazada.co.th/products/pdp-i5093818548.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องมือช่าง 59 ชิ้น พร้อมกล่องเครื่องมือเหล็ก 3 ชั้น รุ่น THTCS12591 ( Tools Set ) TOTAL",
        "product_image": "https://img.lazcdn.com/g/p/2720e4790ba95e4eb5c2568ddf557124.jpg_200x200q90.jpg",
        "price": 13300,
        "remark": "https://www.lazada.co.th/products/pdp-i4991574888.html",
        "sold": 0
    },
    {
        "product_name": "Lohobby เครื่องซ้อมดนตรีมวย,เครื่องออกกำลังกายตามจังหวะติดผนัง",
        "product_image": "https://img.lazcdn.com/g/p/ebc6f65ddf13ef542b47155aa17b50a1.jpg_200x200q90.jpg",
        "price": 13252,
        "remark": "https://www.lazada.co.th/products/pdp-i5908498006.html",
        "sold": 0
    },
    {
        "product_name": "Total ชุดเครื่องมือช่าง 132 ชิ้นชุด พร้อม ตู้เครื่องมือ แบบมีลิ้นชัก รุ่น THPTCS71321 ( 132 Pcs Tools Chest Set )",
        "product_image": "https://img.lazcdn.com/g/p/e49a656ba233d442743aa731cf1542f9.jpg_200x200q90.jpg",
        "price": 13100,
        "remark": "https://www.lazada.co.th/products/pdp-i5295917827.html",
        "sold": 8
    },
    {
        "product_name": "TOTAL รุ่น THPTCS71321 ตู้เครื่องมือช่างอเนกประสงค์ 132 ชิ้น(พร้อมเครื่องมือ)",
        "product_image": "https://img.lazcdn.com/g/p/2edb014cdc418049750e4265b4c04737.jpg_200x200q90.jpg",
        "price": 13100,
        "remark": "https://www.lazada.co.th/products/pdp-i5200588257.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องตัดอโนไดซ์สำหรับน้ำทะเลเครื่อง CNC แบบไร้แปรงถ่าน",
        "product_image": "https://img.lazcdn.com/g/p/ee1b6b4378e68306644397f918a9d377.jpg_200x200q90.jpg",
        "price": 13056,
        "remark": "https://www.lazada.co.th/products/pdp-i6066718708.html",
        "sold": 0
    },
    {
        "product_name": "INGCO ชุดเครื่องมือช่าง 132 ชิ้น พร้อมกล่องเก็บเครื่องมือ รุ่น HTCS221321 (132 pcs Tool Chest Set) ชุดเครื่องมือช่าง  พร้อมกล่องเก็บเครื่องมือ",
        "product_image": "https://img.lazcdn.com/g/p/a468eac848508e81705dd7c2ad953984.jpg_200x200q90.jpg",
        "price": 12580,
        "remark": "https://www.lazada.co.th/products/pdp-i5189534997.html",
        "sold": 0
    },
    {
        "product_name": "INGCO ชุดเครื่องมือช่าง 132 ชิ้น พร้อมกล่องเก็บเครื่องมือ รุ่น HTCS221321 (132 pcs Tool Chest Set) ชุดกล่องเครื่องมือช่าง",
        "product_image": "https://img.lazcdn.com/g/p/a468eac848508e81705dd7c2ad953984.jpg_200x200q90.jpg",
        "price": 12580,
        "remark": "https://www.lazada.co.th/products/pdp-i5189380940.html",
        "sold": 0
    },
    {
        "product_name": "KING TONY เครื่องมือชุด 47 ชิ้น ชุดเครื่องมือช่าง ชุดเครื่องมือ ชุดเครื่องมือkingtony ชุดบล็อก kingtony ชุดบล็อก 1/2 ชุดเครื่องมือ ยี่ห้อ KING TONY แท้ 100%",
        "product_image": "https://img.lazcdn.com/g/p/7c23007b4ae20c5a74c7d63f89d37f97.jpg_200x200q90.jpg",
        "price": 12400,
        "remark": "https://www.lazada.co.th/products/pdp-i2700617792.html",
        "sold": 0
    },
    {
        "product_name": "ไฟฉายWUBEN X1 SUPER HI-END FLASHLIGHT ACTIVE COOLING FANS เครื่องศูนย์ รับประกันไฟฉาย6 เดือน",
        "product_image": "https://img.lazcdn.com/g/p/0860f62434710158b94f59ca2cd02f49.jpg_200x200q90.jpg",
        "price": 12328,
        "remark": "https://www.lazada.co.th/products/pdp-i4804072404.html",
        "sold": 1
    },
    {
        "product_name": "TONE ชุดบล็อก 18ชิ้น ขนาด 3/8\" รุ่น 3130MP",
        "product_image": "https://img.lazcdn.com/g/p/49eb660a63ed19d4f9857417d4b7f8b2.jpg_200x200q90.jpg",
        "price": 12224,
        "remark": "https://www.lazada.co.th/products/pdp-i4879184191.html",
        "sold": 0
    },
    {
        "product_name": "JETECH เจเทค ชุดเครื่องมือช่างมืออาชีพ 65 ชิ้น ในกล่องเครื่องมือเหล็ก รุ่น TB-65S/ JE060665",
        "product_image": "https://img.lazcdn.com/g/p/6b47231c90980a7646a283957629ebc2.jpg_200x200q90.jpg",
        "price": 12000,
        "remark": "https://www.lazada.co.th/products/pdp-i5715145015.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องมือล้อล็อครอกสายเคเบิลเดี่ยว Colaxi สำหรับเครื่องออกกำลังกายแนวสปอร์ตกลางแจ้งปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/ec5fe44210237daada5d312bf1f149a0.jpg_200x200q90.jpg",
        "price": 11984,
        "remark": "https://www.lazada.co.th/products/pdp-i6007567643.html",
        "sold": 0
    },
    {
        "product_name": "Total ชุดเครื่องมือช่าง พร้อมกล่องเครื่องมือ 3 ชั้น รุ่นงานหนัก 59 ชิ้นชุด รุ่น THTCS12591 / 108 ชิ้นชุด รุ่น THTCS121081 ( Tools Set ) ชุดเครื่องมือ พร้อมกล่องเหล็ก",
        "product_image": "https://img.lazcdn.com/g/p/c26f661b13a88cdfcec8b0fbfa99ea15.jpg_200x200q90.jpg",
        "price": 11980,
        "remark": "https://www.lazada.co.th/products/pdp-i112021566.html",
        "sold": 4
    },
    {
        "product_name": "Total กล่องเครื่องมือช่าง 108 ชิ้น   รุ่น THTCS121081 Total 108 Pcs tool set",
        "product_image": "https://img.lazcdn.com/g/p/e620076786d15aead87dc4f1d4ca9060.jpg_200x200q90.jpg",
        "price": 11980,
        "remark": "https://www.lazada.co.th/products/pdp-i5197878234.html",
        "sold": 0
    },
    {
        "product_name": "TOTAL  รุ่นTHTCS121081( Tools Set ) ชุดเครื่องมือช่าง อเนกประสงค์ 108 ชิ้นชุดเครื่องมือ/เครื่องมือช่าง/ชุดบล็อก/ชุดบ๊อกซ์",
        "product_image": "https://img.lazcdn.com/g/p/55cd56f8ce86d8314d42d2ce8aca0c4e.jpg_200x200q90.jpg",
        "price": 11980,
        "remark": "https://www.lazada.co.th/products/pdp-i5195342150.html",
        "sold": 0
    },
    {
        "product_name": "TOTAL เครื่องมือช่าง 108 ชิ้น #THTCS121081",
        "product_image": "https://img.lazcdn.com/g/p/981a8014b117ef17f16b50690e13eeac.png_200x200q90.png",
        "price": 11980,
        "remark": "https://www.lazada.co.th/products/pdp-i16071381063.html",
        "sold": 0
    },
    {
        "product_name": "Total กล่องเครื่องมือช่าง 108 ชิ้น รุ่น THTCS121081 Total 108 Pcs tool set (ของแท้)",
        "product_image": "https://img.lazcdn.com/g/p/948ab2389503ea00f9ea9927d13ad3e1.jpg_200x200q90.jpg",
        "price": 11980,
        "remark": "https://www.lazada.co.th/products/pdp-i5197851301.html",
        "sold": 0
    },
    {
        "product_name": "MILWAUKEE ชุดประแจบล็อก รุ่น 4932471864 1/2\" (28 PC/P.)  บล๊อก ด้ามฟรี ลูกบล๊อกยาว ลูกบล๊อกสั้น เครื่องมือช่าง อุปกรณ์ช่าง อู่ซ่อมรถ จัดส่ง FLASH",
        "product_image": "https://img.lazcdn.com/g/p/6e090b94d2f77cd5efae3a36cf44c7ff.jpg_200x200q90.jpg",
        "price": 11976,
        "remark": "https://www.lazada.co.th/products/pdp-i16058562302.html",
        "sold": 0
    },
    {
        "product_name": "KING TONY ประแจแหวนข้างปากตาย 26 ตัว/ชุด (6-32 mm) ประแจชุด ประแจแหวนข้างkingtony ประแจแหวนข้าง ประแจแหวนข้างปากตาย ยี่ห้อ kingtony  แท้ 100%",
        "product_image": "https://img.lazcdn.com/g/p/29a6b0a011f27157707d01ae4087f783.jpg_200x200q90.jpg",
        "price": 11800,
        "remark": "https://www.lazada.co.th/products/pdp-i2734541674.html",
        "sold": 0
    },
    {
        "product_name": "Total ชุดเครื่องมือช่าง 156 ชิ้นชุด รุ่น THKTHP21566 ( 156 Pcs Tools Set ) ชุดเครื่องมือช่างยนต์ เครื่องมือซ่อมรถ",
        "product_image": "https://img.lazcdn.com/g/p/ca62f6cceaf2d8e4ccb8c062d9db4bb8.jpg_200x200q90.jpg",
        "price": 11780,
        "remark": "https://www.lazada.co.th/products/pdp-i5698864811.html",
        "sold": 1
    },
    {
        "product_name": "TOTAL/INGCO ชุดเครื่องมือช่าง THPTCS70971/HTCS220971 97 ชิ้น พร้อมกล่องเก็บเครื่องมือ 97 pcs Tool Chest Set เครื่องมือช่าง ครบชุดพร้อมใช้งาน",
        "product_image": "https://img.lazcdn.com/g/p/e51b1ebc6987e5dc2c0d20c784152eff.jpg_200x200q90.jpg",
        "price": 11700,
        "remark": "https://www.lazada.co.th/products/pdp-i2788095003.html",
        "sold": 4
    },
    {
        "product_name": "PB Swiss Tools PB 8510.R-100 SET ไขควงชุด Premium Box Set ด้ามฟรี Ratchet ปรับล็อคซ้ายขวา พร้อมดอกไขควง 20 ดอก",
        "product_image": "https://img.lazcdn.com/g/p/521fe572011b210341176ad2284879f2.jpg_200x200q90.jpg",
        "price": 11580,
        "remark": "https://www.lazada.co.th/products/pdp-i4784560176.html",
        "sold": 0
    },
    {
        "product_name": "MAKITA E-08458 : ชุดเครื่องมือ และอุปกรณ์ 87 ชิ้น พร้อมกล่อง",
        "product_image": "https://img.lazcdn.com/g/p/528a7516e095dcf6756c79930300fe42.jpg_200x200q90.jpg",
        "price": 11552,
        "remark": "https://www.lazada.co.th/products/pdp-i4976366792.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องมือดึงสายไฟเบอร์กลาส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9265d533b7e54de8a5ba45b12b38a299B.png_200x200q90.png",
        "price": 11533.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16083434597.html",
        "sold": 0
    },
    {
        "product_name": "EMTOP ชุดเครื่องมือช่าง อเนกประสงค์ 105 ชิ้น รุ่น EHTS01051( Tools Set )ชุดเครื่องมือ/เครื่องมือช่าง/ชุดบล็อก/ชุดบ๊อกซ์",
        "product_image": "https://img.lazcdn.com/g/p/9dbceb496da11e5fa4336958849b0a77.jpg_200x200q90.jpg",
        "price": 11530,
        "remark": "https://www.lazada.co.th/products/pdp-i5392746093.html",
        "sold": 0
    },
    {
        "product_name": "DEWALT/DWMT45184-1 ชุดเซ็ท ประแจและลูกบล็อกชุบดำ 184 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/4ca43a0d8788499d26479e4a53e142cb.jpg_200x200q90.jpg",
        "price": 11520,
        "remark": "https://www.lazada.co.th/products/pdp-i5924587856.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องมือช่าง 132 ชิ้น INGCO รุ่น HTCS221321 กล่องเหล็ก 3 ชั้น ขนาดโดยรวม 520x218x320 มม. (อิงโก้)",
        "product_image": "https://img.lazcdn.com/g/p/93da802d15e542b375e7fe4134c055f1.jpg_200x200q90.jpg",
        "price": 11340,
        "remark": "https://www.lazada.co.th/products/pdp-i5689513407.html",
        "sold": 0
    },
    {
        "product_name": "DEWALT ชุดบล็อก184ชิ้น DWMT45184 ชุดบล็อค แท้ 100% ร้านเป็นตัวแทนจำหน่าย",
        "product_image": "https://img.lazcdn.com/g/p/534e54d800e351745465c7f45c38ec31.jpg_200x200q90.jpg",
        "price": 11134,
        "remark": "https://www.lazada.co.th/products/pdp-i4810673460.html",
        "sold": 23
    },
    {
        "product_name": "Astro Products ชุดเครื่องมือช่าง 56 ชิ้นin 56 PCS Tool Set Inch TS218 of the top part W340×D210×H50mm 7.5kg 45T With Drawer / Compact Tool Set Inch (56 Pcs) TS218",
        "product_image": "https://img.lazcdn.com/g/p/e851f3292041ba557057b23894fff0b1.jpg_200x200q90.jpg",
        "price": 10920,
        "remark": "https://www.lazada.co.th/products/pdp-i4722362974.html",
        "sold": 0
    },
    {
        "product_name": "DEWALT DWMT45184 ชุดเครื่องมือช่าง ชุปโครเมียมสีดำ (184 ชิ้น) ทั้งไขควง บ๊อกซ์ ประแจ ประแจปอนด์ ด้ามขันปอนด์",
        "product_image": "https://img.lazcdn.com/g/p/ccc2ff7ecaaca1afdbfd2c56e31376e7.jpg_200x200q90.jpg",
        "price": 10798,
        "remark": "https://www.lazada.co.th/products/pdp-i5867528651.html",
        "sold": 0
    },
    {
        "product_name": "TOTAL ชุดเครื่องมือช่าง 216 ชิ้นTHKTHP22166",
        "product_image": "https://img.lazcdn.com/g/p/e748f8594fe821a45020ef35209831ea.png_200x200q90.png",
        "price": 10780,
        "remark": "https://www.lazada.co.th/products/pdp-i5581882954.html",
        "sold": 0
    },
    {
        "product_name": "TONE ชุดบล็อก 19ชิ้น ขนาด 1/4\" รุ่น 1800M",
        "product_image": "https://img.lazcdn.com/g/p/4f089a4ea270845427b8f43fda9b96ef.jpg_200x200q90.jpg",
        "price": 10726,
        "remark": "https://www.lazada.co.th/products/pdp-i4878932949.html",
        "sold": 0
    },
    {
        "product_name": "หน้าจอสีอุปกรณ์ตกปลาแบบใช้สายความถี่คู่328ft/100M เรือหาปลาความลึกของน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/6365e8318fed95544424ec5ddec548ab.jpg_200x200q90.jpg",
        "price": 10726,
        "remark": "https://www.lazada.co.th/products/pdp-i6038453850.html",
        "sold": 0
    },
    {
        "product_name": "DEWALT DWMT45184-1 ชุดเครื่องมือช่าง ชุปโครเมียมสีดำ (184 ชิ้น) ทั้งไขควง บ๊อกซ์ ประแจ ประแจปอนด์ ด้ามขันปอนด์",
        "product_image": "https://img.lazcdn.com/g/p/648148ce043a82442b25d8e7c1075d50.jpg_200x200q90.jpg",
        "price": 10680,
        "remark": "https://www.lazada.co.th/products/pdp-i5169338358.html",
        "sold": 0
    },
    {
        "product_name": "Milwaukee ชุดประแจแหวนข้าง ปากตาย 15 ชิ้น รุ่น 48-22-9515 แท้ 100%",
        "product_image": "https://img.lazcdn.com/g/p/b714769ab7046f9643dcf03bc95d8285.jpg_200x200q90.jpg",
        "price": 10376,
        "remark": "https://www.lazada.co.th/products/pdp-i5896592228.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องเปลี่ยนยางรถจักรยานยนต์ Dolity พร้อมคันโยกที่ปรับได้สำหรับล้อขนาด16 ''-21\"",
        "product_image": "https://img.lazcdn.com/g/p/6cc7dc2ce795cad9dc4f67fb2271cca5.jpg_200x200q90.jpg",
        "price": 10110.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16108495704.html",
        "sold": 0
    },
    {
        "product_name": "อุปกรณ์พิเศษสำหรับคนไม่ชอบเทคโนโลยี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb5d4f98b378f43d0bd755234fec6da8bF.png_200x200q90.png",
        "price": 10045.86,
        "remark": "https://www.lazada.co.th/products/pdp-i6066843227.html",
        "sold": 0
    },
    {
        "product_name": "ชุดบล็อก 108 ชิ้นพร้อมด้ามพลาสติก GIANT KINGKONG PRO รุ่น TS 9004 สีน้ำเงิน + เงิน",
        "product_image": "https://img.lazcdn.com/g/p/1208ebc7b4c05ca9f40fe7a5cc6d6780.jpg_200x200q90.jpg",
        "price": 6260,
        "remark": "https://www.lazada.co.th/products/pdp-i4205827371.html",
        "sold": 5
    },
    {
        "product_name": "ชุดเครื่องมืออเนกประสงค์สำหรับครอบครัว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc869c329b4b94c549f6fdf64098ebdec9.jpg_200x200q90.jpg",
        "price": 9982,
        "remark": "https://www.lazada.co.th/products/pdp-i16120908033.html",
        "sold": 0
    },
    {
        "product_name": "Total ชุดเครื่องมือช่าง 135 ชิ้นชุด รุ่น THKTHP21356 ( 135 Pcs Tools Set ) ชุดเครื่องมือช่างยนต์ เครื่องมือซ่อมรถ",
        "product_image": "https://img.lazcdn.com/g/p/7815af16b365583c79a0daa87c6c13ce.jpg_200x200q90.jpg",
        "price": 9980,
        "remark": "https://www.lazada.co.th/products/pdp-i5698685683.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องมือช่าง 135 ชิ้นชุด รุ่น THKTHP21356 ( 135 Pcs Tools Set ) ชุดเครื่องมือช่างยนต์ เครื่องมือซ่อมรถ TOTAL",
        "product_image": "https://img.lazcdn.com/g/p/41a5692e56b6d1c5c3ae3f01bfc352ea.jpg_200x200q90.jpg",
        "price": 9980,
        "remark": "https://www.lazada.co.th/products/pdp-i5704045802.html",
        "sold": 0
    },
    {
        "product_name": "MILWAUKEE ชุดประแจแหวนข้างปากตาย 15 ชิ้น รุ่น 48-22-9515 (เบอร์ 8-22 มม.) ชุดประแจแหวน ประแจ ประแจแหวนข้างปากตาย จัดส่ง Flash Express",
        "product_image": "https://img.lazcdn.com/g/p/86ed5f347f6fc536806473f7bc4948af.jpg_200x200q90.jpg",
        "price": 9976,
        "remark": "https://www.lazada.co.th/products/pdp-i5035464538.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องมือรวมสำหรับใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S25394e5d7f4a4cee8c349f755b152112O.jpg_200x200q90.jpg",
        "price": 9472,
        "remark": "https://www.lazada.co.th/products/pdp-i16118924797.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องมือโลหะแบบทำงานหนักชุดซ่อมแซมสำหรับผู้ที่ชื่นชอบงานประดิษฐ์ด้วยตนเองและช่างมืออาชีพ",
        "product_image": "https://img.lazcdn.com/g/p/cac0e45107d2fbddc9e40e0c415b33e0.jpg_200x200q90.jpg",
        "price": 9450.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6002331215.html",
        "sold": 0
    },
    {
        "product_name": "SATA | ชุดเครื่องมือหลายฟังก์ชันสำหรับบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S310847011a9342b1aada07fb6222476fr.jpg_200x200q90.jpg",
        "price": 9371.46,
        "remark": "https://www.lazada.co.th/products/pdp-i6018073004.html",
        "sold": 6
    },
    {
        "product_name": "KONY Official ประแจหุ้มฉนวน VDE 1000V ชุดเครื่องมือช่างงานไฟฟ้า 18 ตัว/ชุด No.KN-HT068-18",
        "product_image": "https://img.lazcdn.com/g/p/05aec39a2db62c6789c51ab5e05b452d.jpg_200x200q90.jpg",
        "price": 9350,
        "remark": "https://www.lazada.co.th/products/pdp-i5871426778.html",
        "sold": 0
    },
    {
        "product_name": "ประแจแหวนข้าง ชุดประแจแหวนข้างปากตาย KOCHE 26 ตัวชุด",
        "product_image": "https://img.lazcdn.com/g/p/b20d9afd114c9fd35c4d937e6eadc094.jpg_200x200q90.jpg",
        "price": 9000,
        "remark": "https://www.lazada.co.th/products/pdp-i2685199229.html",
        "sold": 10
    },
    {
        "product_name": "Blue-Point ประแจบล็อกลม Blue-Point รุ่น AT123B 1/2\" Air Impact Wrench เครื่องมือช่างสำหรับงานหนัก",
        "product_image": "https://img.lazcdn.com/g/p/dc99b131f5e5878a22e8a8193b4f08b3.jpg_200x200q90.jpg",
        "price": 8898,
        "remark": "https://www.lazada.co.th/products/pdp-i5941211396.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องมือ ชุดบล็อก เอนกประสงค์ KOCHE ชุดใหญ่ 1/2'' + 1/4'' [ โคเช่ ] 111 ชิ้น Pcs.",
        "product_image": "https://img.lazcdn.com/g/p/ba1b61880d92cb023e56383dba7362a9.jpg_200x200q90.jpg",
        "price": 8878,
        "remark": "https://www.lazada.co.th/products/pdp-i4819835752.html",
        "sold": 0
    },
    {
        "product_name": "ไฟฉายไร้สาย HIGH BEAM LED 18V รุ่น DML812 (เฉพาะเครื่อง) MAKITA",
        "product_image": "https://img.lazcdn.com/g/p/3e0172d7e4f145c267e2d7b3d8bcd8cf.png_200x200q90.png",
        "price": 8780,
        "remark": "https://www.lazada.co.th/products/pdp-i5119191621.html",
        "sold": 0
    },
    {
        "product_name": "INGCO ชุดเครื่องมือช่าง 135 ชิ้น HKTHP21351 สินค้าดี ราคาคุณภาพ!!!!",
        "product_image": "https://img.lazcdn.com/g/p/bce2500fe9ce61fd33305e8a43aa59d1.jpg_200x200q90.jpg",
        "price": 8700,
        "remark": "https://www.lazada.co.th/products/pdp-i5801939921.html",
        "sold": 0
    },
    {
        "product_name": "KingTony ชุดประแจ แหวน ปากตาย คิงโทนี่ ประแจแหวน ประแจปากตาย แหวนข้างปากตาย",
        "product_image": "https://img.lazcdn.com/g/p/07cf450610d011a450fc355fa91dbdaf.jpg_200x200q90.jpg",
        "price": 8700,
        "remark": "https://www.lazada.co.th/products/pdp-i5693068038.html",
        "sold": 3
    },
    {
        "product_name": "เครื่องออกกำลังกายแบบเป้าต่อยมวยด้วยสัญญาณ BT Link เครื่องออกกำลังกายแบบต่อยมวยออกกำลังกายสำหรับออกกำลังกายที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/p/c6d4f6235fcfc5c81cdb8eed47889285.jpg_200x200q90.jpg",
        "price": 8682,
        "remark": "https://www.lazada.co.th/products/pdp-i16143764971.html",
        "sold": 0
    },
    {
        "product_name": "SATA | ชุดเครื่องมือไฟฟ้าสำหรับซ่อมแซมบ้านและไม้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S833c954fcb014fee8a04a6da91fd5cefy.jpg_200x200q90.jpg",
        "price": 8666.5,
        "remark": "https://www.lazada.co.th/products/pdp-i6017976790.html",
        "sold": 0
    },
    {
        "product_name": "Oshhni เครื่องทำด้ายไฟเบอร์เครื่องบิดเกลียวหมุนกลับด้านได้ปรับความเร็วได้",
        "product_image": "https://img.lazcdn.com/g/p/f2e894346614f120f0bd79e5c64461aa.jpg_200x200q90.jpg",
        "price": 8660,
        "remark": "https://www.lazada.co.th/products/pdp-i16093604868.html",
        "sold": 0
    },
    {
        "product_name": "( PRO+++ ) โปรแน่น.. HOBAYASHI ชุดเครื่องมือ บล็อกชุด 111 ตัวชุด มาตรฐานญี่ปุ่น รุ่น HTB-111 ชุดประแจ บล็อกชุด ราคาสุดคุ้ม ประแจ ประแจ เลื่อน ประแจ ปอนด์ ประแจ คอม้า",
        "product_image": "https://img.lazcdn.com/g/p/a4aca202a167dea24ae1e73c08ebaf02.jpg_200x200q90.jpg",
        "price": 8654,
        "remark": "https://www.lazada.co.th/products/pdp-i4418849157.html",
        "sold": 0
    },
    {
        "product_name": "Total ชุดเครื่องมือช่าง 19 ตัวชุด รุ่น THKITH1901  หุ้มฉนวน กันไฟฟ้า 1000 โวลท์ (พร้อมกระเป๋า) ของแท้พร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/p/1fe5910cb2f1ac43114ea3b795957771.jpg_200x200q90.jpg",
        "price": 8580,
        "remark": "https://www.lazada.co.th/products/pdp-i5048413639.html",
        "sold": 1
    },
    {
        "product_name": "Astro Products ชุดเครื่องมือช่าง 48 ชิ้น Tool Set TS197 200mm Approximately 3.9Kg S2 (bit), chrome vanadium (others) 90T Impact Precision / Tool Set (48Pcs) TS197 mm",
        "product_image": "https://img.lazcdn.com/g/p/a3af4bcfeaf61ea380b6d3bd0b90f1bd.jpg_200x200q90.jpg",
        "price": 8560,
        "remark": "https://www.lazada.co.th/products/pdp-i2416309031.html",
        "sold": 1
    },
    {
        "product_name": "SATA | ชุดเครื่องมือซ่อมบำรุงบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdd7e120f0b9f4f8298328c87143029fbT.jpg_200x200q90.jpg",
        "price": 8500.18,
        "remark": "https://www.lazada.co.th/products/pdp-i6017893981.html",
        "sold": 36
    },
    {
        "product_name": "HUK เครื่องมือช่าง FION STAR บล๊อกชุดใหญ่ 112ชิ้น 1/2\" & 1/4\" ชุดเดียวเอาอยู่ จบทุกงานช่าง รับประกันของแท้100% ชุดเครื่องมือช่าง  ชุดประแจบล็อก",
        "product_image": "https://img.lazcdn.com/g/p/6628d179f5c88c7b347785f0e61fd19d.jpg_200x200q90.jpg",
        "price": 8288,
        "remark": "https://www.lazada.co.th/products/pdp-i3384520709.html",
        "sold": 0
    },
    {
        "product_name": "( Pro+++ ) คุ้มค่า ชุด เครื่องมือ ชุดบล็อก เอนกประสงค์ KOCHE ชุดใหญ่ 1/2'' + 1/4'' [ โคเช่ ] 96 ชิ้น Pcs. ราคาดี ชุด เครื่องมือ ชุดเครื่องมือช่าง ชุดเครื่องมือ diy",
        "product_image": "https://img.lazcdn.com/g/p/a76730f0114ae52289c04cc4b191a81a.jpg_200x200q90.jpg",
        "price": 8220,
        "remark": "https://www.lazada.co.th/products/pdp-i4543351256.html",
        "sold": 0
    },
    {
        "product_name": "SO NICE | อุปกรณ์ฝึกซ้อมฟุตบอลสำหรับการฝึกเซ็ตพีซ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scd6d175f192242b98c9989107df2a657a.jpg_200x200q90.jpg",
        "price": 8199.1,
        "remark": "https://www.lazada.co.th/products/pdp-i6029601995.html",
        "sold": 0
    },
    {
        "product_name": "Goyan เครื่องหนีบคาดบินหมุนได้360 ° เครื่องร้อยกระสวย",
        "product_image": "https://img.lazcdn.com/g/p/25ee95da53ae025b09c33952fa66c484.jpg_200x200q90.jpg",
        "price": 8022,
        "remark": "https://www.lazada.co.th/products/pdp-i5848844603.html",
        "sold": 0
    },
    {
        "product_name": "Milwaukee 🇹🇭 ไฟส่องทำงาน แบบบานพับ รุ่น L4 FFL-301 ASIA  ไฟฉาย 550 ลูเมน ไฟทำงาน มิว มิววอกี้ มิลวอกี้ เครื่องมือช่าง",
        "product_image": "https://img.lazcdn.com/g/p/af56ce7be67ae6ee6407c23153693aba.png_200x200q90.png",
        "price": 8018,
        "remark": "https://www.lazada.co.th/products/pdp-i4828530978.html",
        "sold": 1
    },
    {
        "product_name": "ไฟล์ \"คอสเรียน\" สำหรับช่างกุญแจมือใหม่",
        "product_image": "https://img.lazcdn.com/g/p/d90ec47ba8ff8d22572210ff5cdf3b61.jpg_200x200q90.jpg",
        "price": 7980,
        "remark": "https://www.lazada.co.th/products/pdp-i5798431057.html",
        "sold": 2
    },
    {
        "product_name": "ชุดเครื่องมือช่าง ชุดบล็อกประแจ จำนวน 150 pcs ชุดเครื่องมือช่างอเนประสงค์ ชุดบล็อก150 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/39bbe36c789ef263eab26ff5ed42ad08.jpg_200x200q90.jpg",
        "price": 7980,
        "remark": "https://www.lazada.co.th/products/pdp-i5960653303.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องมือก่อสร้างสำหรับยกหินคีมยกหินอ่อนหนีบแผ่นหิน/คอนกรีต สำหรับงานก่อสร้าง-ตกแต่ง",
        "product_image": "https://img.lazcdn.com/3rd/q/aHR0cHM6Ly9hZS1waWMtYTEuYWxpZXhwcmVzcy1tZWRpYS5jb20va2YvU2FjMmRlNDkwZWUwZjQ4MmY4NDI0YTJkOGYzMzI5OWUwdi5qcGc=_200x200q90.png",
        "price": 7904.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16099735386.html",
        "sold": 0
    },
    {
        "product_name": "( ออกใบกำกับภาษีได้ ) ชุดเครื่องมือมัลติฟังก์ชั่น 85 ชิ้น ชุดบล็อกประแจ เครื่องมือช่าง ชุดเครื่องมือช่าง Dr. 1/2\" & 1/4 พร้อมกล่องเหล็ก",
        "product_image": "https://img.lazcdn.com/g/p/ea4883d50ceb2c12656186211ffd0725.jpg_200x200q90.jpg",
        "price": 7860,
        "remark": "https://www.lazada.co.th/products/pdp-i4662675148.html",
        "sold": 0
    },
    {
        "product_name": "( Pro+++ ) คุ้มค่า HOBAYASHI ชุดเครื่องมือ บล็อกชุด 110 ตัวชุด มาตรฐานญี่ปุ่น รุ่น HTB-110 ชุดประแจ บล็อกชุด ราคาดี ชุด เครื่องมือ ชุดเครื่องมือช่าง ชุดเครื่องมือ diy",
        "product_image": "https://img.lazcdn.com/g/p/110a803119d912966a995f2d9769628d.jpg_200x200q90.jpg",
        "price": 7860,
        "remark": "https://www.lazada.co.th/products/pdp-i4543365233.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องค้นหาปลาด้วยโซนาร์ไร้สายแบบภาพ HD 150 เมตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa80093d8f15c4d1882bea58abe8533ecf.jpg_200x200q90.jpg",
        "price": 7829.28,
        "remark": "https://www.lazada.co.th/products/pdp-i16082192423.html",
        "sold": 0
    },
    {
        "product_name": "Kingtony แหวนข้างปากตาย ตัวยาว มีแบบ 7-24 ตัวชุด ให้เลือก ประแจ ประแจแหวนข้าง แหวนข้าง ปากตาย ประแจปากตาย รุ่น 12A07MRN / 12A1MRN / 12A4MRN / 12B4MRN",
        "product_image": "https://img.lazcdn.com/g/p/0688c0b0a41e117786885a4c88225850.jpg_200x200q90.jpg",
        "price": 7800,
        "remark": "https://www.lazada.co.th/products/pdp-i4456288554.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องเครื่องกำเนิดไฟฟ้าแบบกังหันลมพกพา Futoys มีริ้วสายไฟสำหรับสนามหลังบ้านการเดินทางแคมป์ปิ้ง",
        "product_image": "https://img.lazcdn.com/g/p/f0503df94b4ba28597d1d2011c5a4dcf.jpg_200x200q90.jpg",
        "price": 7694,
        "remark": "https://www.lazada.co.th/products/pdp-i16136962957.html",
        "sold": 0
    },
    {
        "product_name": "PATGEAR | อุปกรณ์พายยึดเครื่องยนต์อลูมิเนียม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2db7f496623d4fdab7ba1265c2efecbcf.jpg_200x200q90.jpg",
        "price": 7662.78,
        "remark": "https://www.lazada.co.th/products/pdp-i6017960825.html",
        "sold": 1
    },
    {
        "product_name": "MAKITA ชุด โฮลซอร์ คาร์ไบด์ พร้อมกระเป๋า (TCT HOLE SAW) แบบ 10ชิ้น/ชุด (ดอกใหญ่) รุ่น D-51297 ++ติดแอร์ ช่างประปา ช่างไฟ++",
        "product_image": "https://img.lazcdn.com/g/p/f470c8e1a667c5aeb96416d07d51248f.jpg_200x200q90.jpg",
        "price": 7598,
        "remark": "https://www.lazada.co.th/products/pdp-i705546689.html",
        "sold": 0
    },
    {
        "product_name": "Dingqi ชุดเครื่องมือช่าง 59 ชิ้น/ชุด รุ่น ART110059  กล่องเครื่องมือช่าง คุณภาพอย่างดี พร้อมกล่องเครื่องมือเหล็ก 3 ชั้น  สินค้าใหม่ 100%",
        "product_image": "https://img.lazcdn.com/g/p/23492da6704cc277cb951567b2e1a7e5.jpg_200x200q90.jpg",
        "price": 7040,
        "remark": "https://www.lazada.co.th/products/pdp-i4985011861.html",
        "sold": 7
    },
    {
        "product_name": "FION  ชุดบล็อก 112 ชิ้น ชุดบล็อกเอนกประสงค์ FION STAR 1/2'' + 1/4'' ชุดเครื่องมือ เครื่องมือช่าง ชุดใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/3ba2fb21b6a3126344a0a4a1a0390e64.png_200x200q90.png",
        "price": 7324,
        "remark": "https://www.lazada.co.th/products/pdp-i4498419003.html",
        "sold": 32
    },
    {
        "product_name": "ชุดบล็อก 112 ชิ้น FION ชุดบล็อกเอนกประสงค์ FION STAR 1/2'' + 1/4'' ชุดเครื่องมือ เครื่องมือช่าง ชุดใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/23c10bd4e7b986363c4427166ffeba0a.png_200x200q90.png",
        "price": 7324,
        "remark": "https://www.lazada.co.th/products/pdp-i4822597113.html",
        "sold": 0
    },
    {
        "product_name": "ชุดบล็อก 112 ชิ้น ชุดบล็อกเอนกประสงค์ FION STAR 1/2'' + 1/4'' ชุดเครื่องมือ ชุดใหญ่  เครื่องมือช่าง",
        "product_image": "https://img.lazcdn.com/g/p/a8b64b830b10b32b85f3a9e6a29e0d7c.png_200x200q90.png",
        "price": 7324,
        "remark": "https://www.lazada.co.th/products/pdp-i4586819598.html",
        "sold": 4
    },
    {
        "product_name": "TOTAL ชุดเครื่องมือ รุ่น THKTHP21006 (100PCS/SET) ประแจ/ลูกบ๊อก/คีม/ด้ามฟรี/ไขควง อุปกรณ์เสริม งานช่าง งานซ่อมแซม เครื่องมือช่าง เครื่องมือ ชุดเครื่องมือช่างอเนกประสงค์ จัดส่ง FLASH",
        "product_image": "https://img.lazcdn.com/g/p/306fa1021e5891fc4170fd8f20052fa9.jpg_200x200q90.jpg",
        "price": 7300,
        "remark": "https://www.lazada.co.th/products/pdp-i2618153100.html",
        "sold": 6
    },
    {
        "product_name": "Total ชุดเครื่องมือช่าง 100 ชิ้น รุ่น THKTHP21006 (100 pcs Tools Set) เครื่องมือชุด ชุดเครื่องมือ พร้อมกระเป๋า",
        "product_image": "https://img.lazcdn.com/g/p/10e40838ff8cb05ba6c26fe4d0a370fb.jpg_200x200q90.jpg",
        "price": 7300,
        "remark": "https://www.lazada.co.th/products/pdp-i3314787935.html",
        "sold": 8
    },
    {
        "product_name": "INGCO ชุดเครื่องมือช่าง อเนกประสงค์ 100 ชิ้น รุ่นงานหนัก รุ่น HKTHP21001 ( 100 pcs Tools Set ) ชุดเครื่องมือ เครื่องมือช่าง",
        "product_image": "https://img.lazcdn.com/g/p/85c7a550f782b64a3e2783c0f76d81e8.jpg_200x200q90.jpg",
        "price": 7300,
        "remark": "https://www.lazada.co.th/products/pdp-i5279705533.html",
        "sold": 0
    },
    {
        "product_name": "Milwaukee 🇹🇭 ไฟส่องทำงาน แบบบานพับ รุ่น L4 FFL-301 ASIA ไฟฉาย 2000 ลูเมน ไฟทำงาน มิว มิววอกี้ มิลวอกี้ เครื่องมือช่าง",
        "product_image": "https://img.lazcdn.com/g/p/78a0714aa463b4379e6460a3e4b9fc9e.png_200x200q90.png",
        "price": 7234,
        "remark": "https://www.lazada.co.th/products/pdp-i4828629170.html",
        "sold": 1
    },
    {
        "product_name": "deli | ชุดเครื่องมือซ่อมแซมหลายฟังก์ชันสำหรับช่างไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5af4d1c80ecf429bbbb0f2d47b3eea813.jpg_200x200q90.jpg",
        "price": 7228.1,
        "remark": "https://www.lazada.co.th/products/pdp-i6067000117.html",
        "sold": 1
    },
    {
        "product_name": "deli | ชุดเครื่องมือช่างไฟฟ้าหลายฟังก์ชันสำหรับใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9167f462ae1b4dd6b412bcc434881a1cg.jpg_200x200q90.jpg",
        "price": 7208,
        "remark": "https://www.lazada.co.th/products/pdp-i16080442334.html",
        "sold": 0
    },
    {
        "product_name": "คิง โทนี่ : ชุดลูกบล็อก รู 1/2 นิ้ว 12 เหลี่ยม 25 ตัวชุด King Tony : 25 Pcs.. 1/2\"DR. 12PT Socket Wrench Set (4226MR)",
        "product_image": "https://img.lazcdn.com/g/p/2f34eb26a9205b606c69dfa5efc31d21.png_200x200q90.png",
        "price": 7200,
        "remark": "https://www.lazada.co.th/products/pdp-i2731697080.html",
        "sold": 0
    },
    {
        "product_name": "ชุดประแจแหวนข้างปากตาย (26 ตัว 6-32 mm) ประแจรวม ประแจแหวนข้าง เหล็กเกรด CR-V สำหรับงานหนัก ชุดประแจ ของแท้ 100% ประแจ",
        "product_image": "https://img.lazcdn.com/g/p/1ec74d3255dcb797f9b81894fb4bfbf2.jpg_200x200q90.jpg",
        "price": 7160,
        "remark": "https://www.lazada.co.th/products/pdp-i5148420888.html",
        "sold": 0
    },
    {
        "product_name": "โปรแรง จัดหนัก บล็อกชุด Meta 110 ชิ้น ประแจบล็อก ชุดบล็อก ประแจ​ เครื่องมือช่าง​ สุดคุ้ม เก็บเงินปลายทาง",
        "product_image": "https://img.lazcdn.com/g/p/81d9baeffc7be1997b2c1ba35b57a850.jpg_200x200q90.jpg",
        "price": 7158,
        "remark": "https://www.lazada.co.th/products/pdp-i3998421056.html",
        "sold": 3
    },
    {
        "product_name": "INGCO ชุดเครื่องมือช่าง อเนกประสงค์ 100 ชิ้น รุ่นงานหนัก รุ่น HKTHP21001 ( 100 pcs Tools Set ) ชุดเครื่องมือ",
        "product_image": "https://img.lazcdn.com/g/p/d8a95abb1cbac654ac3b58fa6e382421.jpg_200x200q90.jpg",
        "price": 7000,
        "remark": "https://www.lazada.co.th/products/pdp-i5280159528.html",
        "sold": 0
    },
    {
        "product_name": "ไฟฉาย Weltool M3 Work Light ให้แสงสว่างบริเวณที่ทำงาน มาพร้อมฐานแม่เหล็กแรงสูง สำหรับงานซ่อมบำรุง / งานช่าง / โรงงาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se84b77e23d3847908ad7308bee632e175.jpg_200x200q90.jpg",
        "price": 6960,
        "remark": "https://www.lazada.co.th/products/pdp-i312184512.html",
        "sold": 2
    },
    {
        "product_name": "( PRO+++ ) โปรแน่น.. KINGTONY ประแจแหวนฟรี 2หัวหางแหลม 30-41มิล. รุ่น 1500 คิงโทนี่ ไต้หวันแท้ ราคาสุดคุ้ม ประแจ ประแจ เลื่อน ประแจ ปอนด์ ประแจ คอม้า",
        "product_image": "https://img.lazcdn.com/g/p/a0a31923df86d029e059dc78d8e8ea6d.jpg_200x200q90.jpg",
        "price": 6952,
        "remark": "https://www.lazada.co.th/products/pdp-i4418816416.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องมือพกพาเทคโนโลยีเยอรมันและญี่ปุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sea021ebf532348508aa2219a293bb41cf.jpg_200x200q90.jpg",
        "price": 6938,
        "remark": "https://www.lazada.co.th/products/pdp-i16123454280.html",
        "sold": 0
    },
    {
        "product_name": "DINGQI ชุดเครื่องมือช่าง ชุดกล่องเครื่องมือช่างเหล็ก ชุดเครื่องมือช่าง 59 ชิ้น กล่องเหล็กอย่างดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8e3ab7d580984d3aa522c9d147577680H.jpg_200x200q90.jpg",
        "price": 6902.12,
        "remark": "https://www.lazada.co.th/products/pdp-i4802318413.html",
        "sold": 34
    },
    {
        "product_name": "King tony เครื่องมือชุด 47 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S91cc2b7355f142b2bf9ad6c936e58b24a.jpg_200x200q90.jpg",
        "price": 6900,
        "remark": "https://www.lazada.co.th/products/pdp-i2767123118.html",
        "sold": 0
    },
    {
        "product_name": "Koche บล็อกชุด 111 ชิ้น ขนาด 1/2”-1/4”นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S636aa46156e14edaaa32c6932401968bs.jpg_200x200q90.jpg",
        "price": 6822,
        "remark": "https://www.lazada.co.th/products/pdp-i4364163136.html",
        "sold": 0
    },
    {
        "product_name": "รีลโลหะ1คู่1/4รีล10นิ้วอะไหล่ตัวเปิดเครื่องรีลเปล่า6รูสำหรับรอกต่อรอกเครื่องบันทึกเทป",
        "product_image": "https://img.lazcdn.com/g/p/7ee4c7e3f3b4f8da0d3f8293b07c3fd1.jpg_200x200q90.jpg",
        "price": 6772,
        "remark": "https://www.lazada.co.th/products/pdp-i5805191814.html",
        "sold": 0
    },
    {
        "product_name": "บล็อกลม ประแจ แบบเสื้อสั้น 1/2นิ้ว 4หุน เข้าพื้นที่แคบได้ดี แรงบิดสูง ใช้ขันน็อต คล่องตัว บล็อคลม อะไหล่รถขุด เครื่องมือช่าง",
        "product_image": "https://img.lazcdn.com/g/p/c5c75210e19c2b51c7ca76ebccd4ce39.png_200x200q90.png",
        "price": 6764.1,
        "remark": "https://www.lazada.co.th/products/pdp-i4426619080.html",
        "sold": 1
    },
    {
        "product_name": "KOCHE บล็อกชุด 6 เหลี่ยม 111 ตัวชุด ชุดเครื่องมือ อเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/p/992c2365104468d7b605a6a07d660797.jpg_200x200q90.jpg",
        "price": 6694,
        "remark": "https://www.lazada.co.th/products/pdp-i5443216817.html",
        "sold": 10
    },
    {
        "product_name": "YK7เครื่องยนต์เรือทะเลระบบพวงมาลัยเครื่องจักรกลโรทารีกังหัน TSportcy",
        "product_image": "https://img.lazcdn.com/g/p/3009ea0ff5d88eda544519c6f24729c6.jpg_200x200q90.jpg",
        "price": 6670,
        "remark": "https://www.lazada.co.th/products/pdp-i5906155931.html",
        "sold": 0
    },
    {
        "product_name": "YK7 BNLIGHT กังหันเครื่องยนต์เรือทะเลระบบพวงมาลัยเครื่องจักรกลโรทารี",
        "product_image": "https://img.lazcdn.com/g/p/96913869abe882499deed68c919b055d.jpg_200x200q90.jpg",
        "price": 6670,
        "remark": "https://www.lazada.co.th/products/pdp-i5934007570.html",
        "sold": 0
    },
    {
        "product_name": "TOOLS (  ) Koche ชุดประแจบล็อก 96 ชิ้น โคเช่ บล็อกชุด ลูกบล็อก ชุดบล็อกโคเช่ HP",
        "product_image": "https://img.lazcdn.com/g/p/531bb88541094be6033eb74b1ad6ae31.jpg_200x200q90.jpg",
        "price": 6580,
        "remark": "https://www.lazada.co.th/products/pdp-i5930817704.html",
        "sold": 0
    },
    {
        "product_name": "MILWAUKEE ไฟส่องทำงาน แบบบานพับ รุ่น L4 FFL-301 ไฟฉาย 2000 ลูเมน ไฟทำงาน มิว มิววอกี้ มิลวอกี้ เครื่องมือช่าง",
        "product_image": "https://img.lazcdn.com/g/p/63d03fb540fb94e15f02a113df2d3222.jpg_200x200q90.jpg",
        "price": 6576,
        "remark": "https://www.lazada.co.th/products/pdp-i4966037522.html",
        "sold": 0
    },
    {
        "product_name": "ชุดบล็อก KINGTONY 4526MR 1/2 นิ้ว 24 ตัว/ชุด ชุดบล็อคพร้อมด้ามขันและอุปกรณ์ 24 ชิ้น ครบชุด เหมาะสำหรับงานไม้ งานอิเล็คทรอนิคส์ งานก่อสร้าง",
        "product_image": "https://img.lazcdn.com/g/p/e74af3be168647b5805066dbcf2b79d6.jpg_200x200q90.jpg",
        "price": 6572,
        "remark": "https://www.lazada.co.th/products/pdp-i3009992764.html",
        "sold": 0
    },
    {
        "product_name": "MILWAUKEE 48-22-9001 ชุดประแจบล็อก 3/8 12ชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/7340e8f4463b4e840957625597363b2a.jpg_200x200q90.jpg",
        "price": 6570,
        "remark": "https://www.lazada.co.th/products/pdp-i5924952401.html",
        "sold": 0
    },
    {
        "product_name": "KOCHE บล็อกชุด เครื่องมือชุด 111ชิ้น KS-111",
        "product_image": "https://img.lazcdn.com/g/p/6160bb2184f86e2bc399c7967942e86b.jpg_200x200q90.jpg",
        "price": 6508,
        "remark": "https://www.lazada.co.th/products/pdp-i315654772.html",
        "sold": 63
    },
    {
        "product_name": "ไฟฉายNitecore EDC35  EDC Tactical เครื่องศูนย์ไทย",
        "product_image": "https://img.lazcdn.com/g/p/f6eea11852a913f82b4811d6fe44c54e.png_200x200q90.png",
        "price": 6500,
        "remark": "https://www.lazada.co.th/products/pdp-i5085007288.html",
        "sold": 1
    },
    {
        "product_name": "BLUE POINT บล็อกชุด ชุดบล็อก 3/8\" 24 ตัวชุด ชุดลูกบล็อก 3/8\" นิ้ว พร้อมลูกบล็อกสั้นและยาว ชุดบล็อกของแท้ 100% สินค้าพร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S342c516752db4c3e997143cbf8fd05cb9.jpg_200x200q90.jpg",
        "price": 6500,
        "remark": "https://www.lazada.co.th/products/pdp-i6008988771.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องมือซ่อมแซมบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1259be0cc0004886b3a6020543f1aa37o.jpg_200x200q90.jpg",
        "price": 6442.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16098246276.html",
        "sold": 0
    },
    {
        "product_name": "Wiha | ชุดไขควงความแม่นยำหลายฟังก์ชันป้องกันไฟสถิต 65 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf50b6f45bbe54162958d2500e16a8cdaH.jpg_200x200q90.jpg",
        "price": 6431.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5979627900.html",
        "sold": 8
    },
    {
        "product_name": "SEDY : SDY94288* ชุดไขควงแม่เหล็ก Magnetic Screwdriver Set, 122 piece",
        "product_image": "https://img.lazcdn.com/g/p/913ad901d367eafeb9ba81ba827fc616.jpg_200x200q90.jpg",
        "price": 6410,
        "remark": "https://www.lazada.co.th/products/pdp-i4284805126.html",
        "sold": 0
    },
    {
        "product_name": "DSZH 806N ชุดบานแฟร์ ลูกเบี้ยว อลูมิเนียม 2-6หุน ใช้กับสว่านได้ พร้อมคัตเตอร์ Flaring Tool Set WK-806N-L ส่งไว",
        "product_image": "https://img.lazcdn.com/g/p/577296857005d2d033c68ac79bc116d9.jpg_200x200q90.jpg",
        "price": 6400,
        "remark": "https://www.lazada.co.th/products/pdp-i16076260431.html",
        "sold": 0
    },
    {
        "product_name": "KONY ชุดบล็อก 137 ตัวชุด บล็อกชุด 2 หุน 4 หุน พร้อมชุดเครื่องมือ ลูกบล็อกสั้น No.KN-CM226-137",
        "product_image": "https://img.lazcdn.com/g/p/d228207adbba5366486f0e00196e0895.jpg_200x200q90.jpg",
        "price": 5898,
        "remark": "https://www.lazada.co.th/products/pdp-i5598473970.html",
        "sold": 0
    },
    {
        "product_name": "ชุด เครื่องมือ ชุดบล็อก เอนกประสงค์ KOCHE ชุดใหญ่ 1/2 นิ้ว + 1/4 นิ้ว  โคเช่  111ชิ้น Pcs. KOCHE111 KOCHE 111 KS-111 บล็อกชุด",
        "product_image": "https://img.lazcdn.com/g/p/38ae82fa50b1386db69e435de023cc50.jpg_200x200q90.jpg",
        "price": 6234.3,
        "remark": "https://www.lazada.co.th/products/pdp-i4882948982.html",
        "sold": 15
    },
    {
        "product_name": "ชุดบล็อกประแจ 46 ชิ้น เครื่องมือช่าง ชุดประเเจ ชุดบล็อก ขนาด 1/4 2 หุน จำนวน 46 pcs",
        "product_image": "https://img.lazcdn.com/g/p/338dfb37a1869b4a3add5170913b1415.jpg_200x200q90.jpg",
        "price": 6163.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5968163028.html",
        "sold": 0
    },
    {
        "product_name": "FLASH ชุดบล็อก 216 ชิ้น บล็อกชุด 1/2\", 1/4\", 3/8\" พร้อมชุดเครื่องมือ 216 ชิ้น No.FS-ST003-216",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scd1e948adb644ecc9fa3b822c17afca5g.jpg_200x200q90.jpg",
        "price": 6140,
        "remark": "https://www.lazada.co.th/products/pdp-i5992196547.html",
        "sold": 0
    },
    {
        "product_name": "KONY บล็อกชุด รุ่น KN-111 ขนาด 1/2\"- 1/4\"นิ้ว พร้อมชุดเครื่องมือ 111 ชิ้น เครื่องมือช่าง ชุดบล็อก ของแท้ 100%",
        "product_image": "https://img.lazcdn.com/g/p/2452220afb3cc4a1a172a30fbc6c47db.jpg_200x200q90.jpg",
        "price": 6130,
        "remark": "https://www.lazada.co.th/products/pdp-i4181371577.html",
        "sold": 37
    },
    {
        "product_name": "WORKPRO ชุดเครื่องมือช่าง 108 ชิ้น รุ่น WP202535",
        "product_image": "https://img.lazcdn.com/g/p/d8d23c2ed963dc68998ed8bd0e20d4af.jpg_200x200q90.jpg",
        "price": 6108,
        "remark": "https://www.lazada.co.th/products/pdp-i4739492918.html",
        "sold": 3
    },
    {
        "product_name": "ใหม่เอี่ยมเครื่องมือฮาร์ดแวร์ใช้งานได้สองแบบชุดประแจมือทนทานต่อการสึกหรอชิ้น/เซ็ต6ชิ้น/ชุด",
        "product_image": "https://img.lazcdn.com/g/p/da1feccbcb0075fff044174000ff72ad.jpg_200x200q90.jpg",
        "price": 6096,
        "remark": "https://www.lazada.co.th/products/pdp-i6025765525.html",
        "sold": 0
    },
    {
        "product_name": "ชุดไขควงปรับละเอียด Wiha วัสดุเหล็กกล้าโครเมียมวานadiumแบบเปลี่ยนได้กันไฟ ชุดไขควงแบบแบนและไขว้จากเยอรมัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seee02ee535d349dc96d1a0b0a7df8045Y.jpg_200x200q90.jpg",
        "price": 6086,
        "remark": "https://www.lazada.co.th/products/pdp-i6067560487.html",
        "sold": 0
    },
    {
        "product_name": "PB Swiss Tools ชุดไขควง รุ่น PB 8215ESD ด้ามยาง ด้ามกันไฟฟ้าสถิตย์ ไขควงซองหนัง 10 ตัวชุด Swiss Made PB8215ESD",
        "product_image": "https://img.lazcdn.com/g/p/b5274dbe3a656adde632e21b6584b576.jpg_200x200q90.jpg",
        "price": 6070,
        "remark": "https://www.lazada.co.th/products/pdp-i4970489685.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องติดตั้งได้ง่ายเพลงเป้าหมายการเจาะอัจฉริยะเครื่องชกมวยสำหรับยิมที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/p/1511084589942a1746af50283ccca7df.jpg_200x200q90.jpg",
        "price": 6054.58,
        "remark": "https://www.lazada.co.th/products/pdp-i6012890373.html",
        "sold": 0
    },
    {
        "product_name": "KONY แท้100 % ประแจขันปอนด์ 1/2\" KN-KB04-330NM ซีรี่ส์ KING COBRA **KONY สินค้าดีมีคุณภาพ**",
        "product_image": "https://img.lazcdn.com/g/p/07fb8bd919f9112d32297ee9d54f7063.jpg_200x200q90.jpg",
        "price": 6000,
        "remark": "https://www.lazada.co.th/products/pdp-i6057650386.html",
        "sold": 0
    },
    {
        "product_name": "Muscle Cow TOOLS ชุดเครื่องมือ ประแจ ชุดบล็อก 24 ชิ้น ขนาด 1/2 (4หุน) เครื่องมือช่าง CR-V แท้ ประแจ  หมุน",
        "product_image": "https://img.lazcdn.com/g/p/a310375f062cba85668eb8bd4fd602a6.jpg_200x200q90.jpg",
        "price": 5984,
        "remark": "https://www.lazada.co.th/products/pdp-i5955646487.html",
        "sold": 0
    },
    {
        "product_name": "บล็อกชุด 1/2\" 4026MR ชุด24ชิ้น KINGTONY",
        "product_image": "https://img.lazcdn.com/g/p/5c04e46ff82f7a0629df3b464698959f.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i5134187136.html",
        "sold": 0
    },
    {
        "product_name": "บล็อกชุดKoche 111 ชิ้น ชุดเครื่องมือชุดใหญ่ Koche แท้",
        "product_image": "https://img.lazcdn.com/g/p/mdc/50291aa046fa1d20f303c368686309b3.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i276643015.html",
        "sold": 128
    },
    {
        "product_name": "ถุงมือป้องกันแรงงานหนา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6e269f6adb994103bc8ffc88131bb624z.jpg_200x200q90.jpg",
        "price": 5962.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16103034907.html",
        "sold": 0
    },
    {
        "product_name": "KONY ชุดบล็อก 137 ตัวชุด บล็อกชุด 2 หุน 4 หุน พร้อมชุดเครื่องมือ ลูกบล็อกสั้น No.KN-CM226-137 by SuperM",
        "product_image": "https://img.lazcdn.com/g/p/c5bda2e1af3d1fbee49f174716b4b840.jpg_200x200q90.jpg",
        "price": 5936,
        "remark": "https://www.lazada.co.th/products/pdp-i5482404976.html",
        "sold": 0
    },
    {
        "product_name": "MILWAUKEE ไฟฉายพ็อคเก็ต แอลอีดี รุ่น L4 FL-301 ไฟฉาย LED ไฟฉายพกพา มิว มิววอกี้ มิลวอกี้ เครื่องมือช่าง",
        "product_image": "https://img.lazcdn.com/g/p/95842ad332284ae718e220ff213f33ca.jpg_200x200q90.jpg",
        "price": 5916,
        "remark": "https://www.lazada.co.th/products/pdp-i4973672223.html",
        "sold": 0
    },
    {
        "product_name": "Milwaukee  ไฟฉายพ็อคเก็ต รุ่น L4 FL-301 ไฟฉาย LED 100 ลูเมน ไฟส่องสว่าง ไฟทำงาน มิว มิววอกี้ มิลวอกี้ เครื่องมือช่าง",
        "product_image": "https://img.lazcdn.com/g/p/95842ad332284ae718e220ff213f33ca.jpg_200x200q90.jpg",
        "price": 5916,
        "remark": "https://www.lazada.co.th/products/pdp-i5081999490.html",
        "sold": 0
    },
    {
        "product_name": "META ชุดประแจบล็อก ชุดบล็อก  1/2\" - 1/4\"   110 ชิ้น  เหล็ก CR-V มาตรฐานอเมริกา",
        "product_image": "https://img.lazcdn.com/g/p/9264b83489d09bb8ceb8b3349b16bab3.jpg_200x200q90.jpg",
        "price": 5860,
        "remark": "https://www.lazada.co.th/products/pdp-i4826973452.html",
        "sold": 0
    },
    {
        "product_name": "Fenteer อุปกรณ์เซ็ทขากรรไกรโคล10 \"ทนทานทนต่อการสึกหรอสะดวกใช้ได้จริงเครื่องมืองานไม้สำหรับช่างไม้มืออาชีพ DIY",
        "product_image": "https://img.lazcdn.com/g/p/449a574d15a7e19ec1fdd831b3c57223.jpg_200x200q90.jpg",
        "price": 5855.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5333158170.html",
        "sold": 0
    },
    {
        "product_name": "DANBIYIN | ชุดเครื่องมือใช้ในบ้านแบบแมนนวล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sddc43acc51a9433b854fb24f5b323ef2t.png_200x200q90.png",
        "price": 5833.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16060353321.html",
        "sold": 0
    },
    {
        "product_name": "MAKITA ชุดเซ็ท 4 ไร้สาย รุ่น 369V  🛠️สว่าน +บล็อก+เครื่องเจียร+สว่านโรตารี่🛠️(AAA) ✨ ประสิทธิภาพสูง พลังแรง ครบครันทุกฟังก์ชัน พร้อมลุยทุกงาน!!!✨  💥ส่งเร็ว ตรงปก มีสินค้าพร้อมจัดส่งแน่นอน 100%💯🔥🏆(PM)🚩",
        "product_image": "https://img.lazcdn.com/g/p/39a2b90e8f87bd4b71b1974de2d65f48.png_200x200q90.png",
        "price": 5809.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5794286300.html",
        "sold": 197
    },
    {
        "product_name": "VAUKO : KOCHE ชุดเครื่องมือช่าง ประแจบล็อคชุด/บล๊อกชุด/บ๊อกชุด จำนวน 111 ชิ้นต่อชุด บรรจุกล่อง รุ่น KOCHE-111 จำนวน 1 ชุด",
        "product_image": "https://img.lazcdn.com/g/p/efdfe840a196f208da2d944745f6254a.jpg_200x200q90.jpg",
        "price": 5800,
        "remark": "https://www.lazada.co.th/products/pdp-i100055401.html",
        "sold": 82
    },
    {
        "product_name": "PUMPKIN INF 20V ประแจบล็อกไฟฟ้าด้ามฟรีไร้สายคอยาว 3/8″-1/2″ ไร้แปรงถ่าน INF-E3812RB/50469 คอยาว แข็งแรง ใช้งานง่ายในที่แคบ ( เฉพาะเครื่อง ) แถมอุปกรณ์ตามรูป",
        "product_image": "https://img.lazcdn.com/g/p/20b2936534e30e8417df32e01390b3ca.jpg_200x200q90.jpg",
        "price": 5780,
        "remark": "https://www.lazada.co.th/products/pdp-i5853900550.html",
        "sold": 0
    },
    {
        "product_name": "HOBAYASHI ชุดบล็อก 111ชิ้น มาตรฐานญี่ปุ่น แข็งแรง ทนทาน บล็อกชุดใหญ่ สำหรับงานหนัก ชุดเดียวครบทุกอย่าง ของแท้100%",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbb59ad9ca0154a999740058d28750e85k.jpg_200x200q90.jpg",
        "price": 5780,
        "remark": "https://www.lazada.co.th/products/pdp-i3098201199.html",
        "sold": 17
    },
    {
        "product_name": "PUMPKIN INF 20V ประแจบล็อกไฟฟ้าด้ามฟรีไร้สายคอยาว 3/8″-1/2″ ไร้แปรงถ่าน INF-E3812RB/50469 คอยาว แข็งแรง ใช้งานง่ายในที่แคบ ( เฉพาะเครื่อง )",
        "product_image": "https://img.lazcdn.com/g/p/20b2936534e30e8417df32e01390b3ca.jpg_200x200q90.jpg",
        "price": 5780,
        "remark": "https://www.lazada.co.th/products/pdp-i5853895274.html",
        "sold": 0
    },
    {
        "product_name": "Lohobby เครื่องกระบองมวยไทยดนตรีสำหรับฝึกเล่นกีฬาคาราเต้พร้อมถุงมือ",
        "product_image": "https://img.lazcdn.com/g/p/e18090f3633d1ea8c23233e138e500fc.jpg_200x200q90.jpg",
        "price": 5778,
        "remark": "https://www.lazada.co.th/products/pdp-i5922334190.html",
        "sold": 0
    },
    {
        "product_name": "Milwaukee 48-22-9001 ชุดประแจบล็อก 3/8\" 12 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/233e9f522dbccb297d489bcb9b725622.png_200x200q90.png",
        "price": 5776,
        "remark": "https://www.lazada.co.th/products/pdp-i5057070074.html",
        "sold": 0
    },
    {
        "product_name": "MILWAUKEE ชุดประแจบล็อก รุ่น 48-22-9001 3/8\" (12PC/P) SOCKET SET บล๊อกยาว ด้ามฟรี เครื่องมือช่าง ประแจด้ามฟรี อุปกรณ์งานช่าง ประแจ ช่าง จัดส่ง Flash Express",
        "product_image": "https://img.lazcdn.com/g/p/79165f625f0d41b83238b0256787bca4.jpg_200x200q90.jpg",
        "price": 5776,
        "remark": "https://www.lazada.co.th/products/pdp-i5590233154.html",
        "sold": 0
    },
    {
        "product_name": "META เครื่องมือช่าง ชุดประแจบล็อก 110 ชิ้น เครื่องมือช่าง",
        "product_image": "https://img.lazcdn.com/g/p/e935cddfe4b5bc4b77d57dc0a79fbd2e.jpg_200x200q90.jpg",
        "price": 5768,
        "remark": "https://www.lazada.co.th/products/pdp-i4146135020.html",
        "sold": 1
    },
    {
        "product_name": "BESITA รวมชุดประแจปากตาย ประแจแหวนข้างปากตาย ประแจแหวนคู่ ประแจแหวนผ่า ประแจแหวนฟรี(ก็อกแก็ก)",
        "product_image": "https://img.lazcdn.com/g/p/5df5457440b92e6a6809760c191119b4.jpg_200x200q90.jpg",
        "price": 5728,
        "remark": "https://www.lazada.co.th/products/pdp-i5897105879.html",
        "sold": 0
    },
    {
        "product_name": "MIXPRO บล็อคชุด 24ตัว/ชุด  MIX PRO (ST-M0010) CRV 26-007-003",
        "product_image": "https://img.lazcdn.com/g/p/eb606b37060468324fb655ec09a22264.jpg_200x200q90.jpg",
        "price": 5700,
        "remark": "https://www.lazada.co.th/products/pdp-i5307201581.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องมือประแจบล็อก META 110 ชิ้น (ชุดใหญ่)",
        "product_image": "https://img.lazcdn.com/g/p/9b88d651d9a2b6b0abfa6c762d1da689.jpg_200x200q90.jpg",
        "price": 5700,
        "remark": "https://www.lazada.co.th/products/pdp-i4425052012.html",
        "sold": 0
    },
    {
        "product_name": "META เครื่องมือช่าง ชุดประแจบล็อก 110 ชิ้น เครื่องมือช่าง .",
        "product_image": "https://img.lazcdn.com/g/p/e935cddfe4b5bc4b77d57dc0a79fbd2e.jpg_200x200q90.jpg",
        "price": 5700,
        "remark": "https://www.lazada.co.th/products/pdp-i4204760452.html",
        "sold": 2
    },
    {
        "product_name": "YTB ลูกบล็อกลมชุด ชุดบล็อก6หุน (3/4นิ้ว) ชุด26ชิ้น บล็อกชุดสีดำครบชุด ชุดราคาสุดคุ้ม",
        "product_image": "https://img.lazcdn.com/g/p/61c96eab790706dd93a81b4610c72455.jpg_200x200q90.jpg",
        "price": 5700,
        "remark": "https://www.lazada.co.th/products/pdp-i2644085188.html",
        "sold": 0
    },
    {
        "product_name": "KONY ชุดบล็อก 86 ตัวชุด บล็อกชุด 2 หุน 4 หุน พร้อมชุดเครื่องมือ ลูกบล็อกสั้น No.KN-CM226-86",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se4a74829a5594a82b65d492dbb1036cfB.jpg_200x200q90.jpg",
        "price": 5660,
        "remark": "https://www.lazada.co.th/products/pdp-i5452792856.html",
        "sold": 0
    },
    {
        "product_name": "48-22-9504 4932464943 Milwaukee 48-22-9510 1/2\" หรือ 48-22-9504 1/4\" Metric Ratchet and Socket 28 pcs Set ชุดประแจบล็อก",
        "product_image": "https://img.lazcdn.com/g/p/89b15da272044702cc4e48f4b169e136.jpg_200x200q90.jpg",
        "price": 5660,
        "remark": "https://www.lazada.co.th/products/pdp-i4870753595.html",
        "sold": 3
    },
    {
        "product_name": "PRO'S KIT ชุดประแจบล็อก 38 ชิ้น HW-23801M",
        "product_image": "https://img.lazcdn.com/g/p/0637cf395ec202101417cced0a6af305.jpg_200x200q90.jpg",
        "price": 5648,
        "remark": "https://www.lazada.co.th/products/pdp-i4136436414.html",
        "sold": 0
    },
    {
        "product_name": "ST MIRREN | เพิงสวนพลังงานแสงอาทิตย์กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6659024153c841efbcca5bbbc1bc50346.png_200x200q90.png",
        "price": 119316.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16097799469.html",
        "sold": 0
    },
    {
        "product_name": "MEIDIHUAFU | เต็นท์หลบแดดกลางแจ้ง 8 ด้านสำหรับสวนวิลล่าและลานระเบียง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5eeb85f0bd0347b0a91ab1318adc51eel.jpg_200x200q90.jpg",
        "price": 115773.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16099362728.html",
        "sold": 0
    },
    {
        "product_name": "Sinlege | ศาลาภายนอกอาคารอลูมิเนียมกันน้ำและป้องกันแสงแดด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S100730cfcb6343a498ae138e49d96ee2p.jpg_200x200q90.jpg",
        "price": 73878.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16096178599.html",
        "sold": 0
    },
    {
        "product_name": "ZIYEYANGTAI | ร่มสนามสำหรับสวน ป้องกันแสงแดด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5d732dd5e71342b58fbe1a8042ddf3ff2.png_200x200q90.png",
        "price": 45256.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5992644558.html",
        "sold": 0
    },
    {
        "product_name": "MEIDIHUAFU | ร่มป้องกันแสงแดดสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Scbc904459b03462fb0b3297e85b732efp.png_200x200q90.png",
        "price": 41885.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5909603403.html",
        "sold": 77
    },
    {
        "product_name": "เตาผิงเอทานอลแบบตั้งได้สำหรับตกแต่งบ้านเตาผิงแคมป์ไฟไฟกลางแจ้งสำหรับเดินเขาสวนแบกเป้ปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/8b024a2ddc39471e36322255638c8fc1.jpg_200x200q90.jpg",
        "price": 31166,
        "remark": "https://www.lazada.co.th/products/pdp-i16056507052.html",
        "sold": 0
    },
    {
        "product_name": "Outdoor Fitness Equipment, Double Walking Machine, Garden Community Square Sports Path Set",
        "product_image": "https://img.lazcdn.com/g/p/60f4776f5109fe1d4ca99ccd36964c75.jpg_200x200q90.jpg",
        "price": 25129.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16102973751.html",
        "sold": 0
    },
    {
        "product_name": "JDD [จัดส่งรวดเร็ว] Huina 1594เครื่องขุด,พรีเมี่ยมควบคุมระยะไกล1:14พลังงานสกรูพาณิชย์โมเดลดัดแปลงสวนสนุกโลหะผสมของเล่นรถขุดดินของขวัญ",
        "product_image": "https://img.lazcdn.com/g/p/f97c4707642041397895309b2683bdea.jpg_200x200q90.jpg",
        "price": 21594.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5961475536.html",
        "sold": 0
    },
    {
        "product_name": "GUAIJUE | โคมไฟสนามสไตล์จีนใหม่ กันน้ำ สำหรับเสาสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd0cb3107f9654443a656a241b1c45397G.jpg_200x200q90.jpg",
        "price": 19700.5,
        "remark": "https://www.lazada.co.th/products/pdp-i6003302035.html",
        "sold": 0
    },
    {
        "product_name": "เตาบารบคว TBZ สำหรบสวน ลานบาน หรอโตะปงยาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa1a3db65f32d4b78b9e7c23d8a28b1f4Z.png_200x200q90.png",
        "price": 16850.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16121271489.html",
        "sold": 0
    },
    {
        "product_name": "intelamp | ไฟส่องสว่างพลังงานแสงอาทิตย์สำหรับสวน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S129613fb0bc84d39abd343d43142edc04.jpg_200x200q90.jpg",
        "price": 16138.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5992801262.html",
        "sold": 25
    },
    {
        "product_name": "Mobi Garden | เก้าอี้พับได้สำหรับกลางแจ้ง หลังสูงปรับเอนได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb293169afad74464b34f435ac2c18a42w.jpg_200x200q90.jpg",
        "price": 11670.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6003200754.html",
        "sold": 0
    },
    {
        "product_name": "อุปกรณ์เอาตัวรอดกลางแจ้งเดือยแหลมปีนเขากลางแจ้งอุปกรณ์ปีนเขาต้นไม้สำหรับล่าสัตว์และทำสวนอย่างง่าย",
        "product_image": "https://img.lazcdn.com/g/p/9ec201e88cc1b3869cf6d51ae2b789b1.jpg_200x200q90.jpg",
        "price": 9300,
        "remark": "https://www.lazada.co.th/products/pdp-i6023008143.html",
        "sold": 0
    },
    {
        "product_name": "MagiDeal ตาข่ายสนามเด็กเล่นสองชั้นตาข่ายไนลอนป้องกันสนามเด็กเล่นสำหรับสวนหลังบ้านสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/b3d3e826c5daf80a1e67f36cbce1384f.jpg_200x200q90.jpg",
        "price": 9152,
        "remark": "https://www.lazada.co.th/products/pdp-i5943624101.html",
        "sold": 0
    },
    {
        "product_name": "เบาะรองนั่งป้องกัน UVs สำหรับสวนชายหาดกลางแจ้งผ้าโพลีเอสเตอร์กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/ae78baef1e1919da1ff9fe5eaad3480c.jpg_200x200q90.jpg",
        "price": 9034,
        "remark": "https://www.lazada.co.th/products/pdp-i6011075241.html",
        "sold": 0
    },
    {
        "product_name": "DUOSHANG | เสาไฟส่องสว่างกลางแจ้ง สูง 3-4 เมตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S92b400069a154fa0b4a2d5d25e493c49p.jpg_200x200q90.jpg",
        "price": 8461.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6066651280.html",
        "sold": 0
    },
    {
        "product_name": "SunnT เก้าอี้สนามเลานจ์พนักพิงศีรษะเก้าอี้พักผ่อนถอดที่วางเท้าสำหรับอาบแดดสวนคอนเสิร์ตตกปลาด้านนอก",
        "product_image": "https://img.lazcdn.com/g/p/bf806792faa8926ed1e08c8154aa7509.jpg_200x200q90.jpg",
        "price": 8269.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16110068243.html",
        "sold": 0
    },
    {
        "product_name": "ลูกกลิ้งสมอติดบนที่วางลูกกลิ้งสำหรับงานหนักเรือยอชท์แบบไม่ใช้ในสวนขนาด50X165มม.",
        "product_image": "https://img.lazcdn.com/g/p/76f1ca43cff5220adde52152320d5b8f.jpg_200x200q90.jpg",
        "price": 7964,
        "remark": "https://www.lazada.co.th/products/pdp-i6012723135.html",
        "sold": 0
    },
    {
        "product_name": "ระบบการรีไซเคิลลูกบอลเทนนิส Motoise ตาข่ายฝึกเดี่ยวแบบมืออาชีพสำหรับผู้ใหญ่เบสบอลโรงจอดรถในสวน",
        "product_image": "https://img.lazcdn.com/g/p/ad00b119a333c9a428218b341147681f.jpg_200x200q90.jpg",
        "price": 7790,
        "remark": "https://www.lazada.co.th/products/pdp-i6069459925.html",
        "sold": 0
    },
    {
        "product_name": "ระบบการรีไซเคิลลูกเทนนิส Pecine ตาข่ายตาข่ายอุปกรณ์แบบพกพาสำหรับสนามหลังบ้านสนามเล่นพิเกิลบอลสวนบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/ce431f8f3430b4526a21661c5adf26c6.jpg_200x200q90.jpg",
        "price": 7790,
        "remark": "https://www.lazada.co.th/products/pdp-i6027891886.html",
        "sold": 0
    },
    {
        "product_name": "โมเดลจำลองการใส่สายสวนท่อปัสสาวะเพื่อการสอน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7a980e3dc0e94c0298d1fba9ba1bbc7c8.jpg_200x200q90.jpg",
        "price": 7764,
        "remark": "https://www.lazada.co.th/products/pdp-i16089288386.html",
        "sold": 0
    },
    {
        "product_name": "Motoautt โคมไฟอัตโนมัติเครื่องกำเนิดไฟฟ้าแบบกังหันลมแบบพกพาสำหรับตั้งแคมป์ในสวนการเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/0d624f7204e5be69dfca1d61e4817f3f.jpg_200x200q90.jpg",
        "price": 7694,
        "remark": "https://www.lazada.co.th/products/pdp-i16136781443.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟอัตโนมัติชุดสร้างกังหันลมขนาดเล็ก DIY ดวงจันทร์สำหรับสวนท่องเที่ยว",
        "product_image": "https://img.lazcdn.com/g/p/ca6c07e37eee7ae0c1a1ff3e36424e0c.jpg_200x200q90.jpg",
        "price": 7694,
        "remark": "https://www.lazada.co.th/products/pdp-i16137658602.html",
        "sold": 0
    },
    {
        "product_name": "ร่มสวนกลางแจ้งสำหรับการค้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S875ea9d3324c4f05851f34dca49a586cL.jpg_200x200q90.jpg",
        "price": 7596.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16099751666.html",
        "sold": 0
    },
    {
        "product_name": "CCSoil เก้าอี้เลานจ์ปรับเก้าอี้สนามได้,เก้าอี้พักผ่อนแบบหนาพับได้สำหรับสวนกลางแจ้งลานสระว่ายน้ำคอนเสิร์ต",
        "product_image": "https://img.lazcdn.com/g/p/b92aa769596a0eb75411be316d485f79.jpg_200x200q90.jpg",
        "price": 7566,
        "remark": "https://www.lazada.co.th/products/pdp-i16124118638.html",
        "sold": 0
    },
    {
        "product_name": "Freneci ตาข่ายอเนกประสงค์สำหรับรีไซเคิลลูกเทนนิสตาข่ายการฝึกกีฬาติดตั้งได้ง่ายสำหรับสวนกลางแจ้งสนามหลังบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/2ba0d6e70f66a397c171aeeef90c99cb.jpg_200x200q90.jpg",
        "price": 7462,
        "remark": "https://www.lazada.co.th/products/pdp-i6069550854.html",
        "sold": 0
    },
    {
        "product_name": "รถเข็นคนพิการไฟฟ้าล้อไม่ลื่นแบบหลุมตรงล้อ16in พองได้พร้อมรูกุญแจสำหรับสวน",
        "product_image": "https://img.lazcdn.com/g/p/fc7966f3cba7d3de3cf4212d73477ebc.jpg_200x200q90.jpg",
        "price": 7366,
        "remark": "https://www.lazada.co.th/products/pdp-i6066684658.html",
        "sold": 0
    },
    {
        "product_name": "แบบจำลองกระดกสนหลง AK72 แบบยดหยน แยกสวนได",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5bd09935abab44ce9af191ee3d9621dfW.png_200x200q90.png",
        "price": 6767.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16118072274.html",
        "sold": 0
    },
    {
        "product_name": "Mobi Garden | เก้าอี้พกพาสำหรับแคมปิ้ง ตกปลา พิกนิก วาดรูป",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S255559698b004841a89a513be9e641fdy.jpg_200x200q90.jpg",
        "price": 6740.04,
        "remark": "https://www.lazada.co.th/products/pdp-i6003273991.html",
        "sold": 0
    },
    {
        "product_name": "Outdoor moon-shaped hanging lamp for courtyard and garden, atmosphere tree lamp, decorative landscape light for scenic areas and sales offices, waterproof moon lamp, colorful outdoor light",
        "product_image": "https://img.lazcdn.com/g/p/3552daecc40363d6bcbf88ca92340eea.jpg_200x200q90.jpg",
        "price": 6305.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16099701201.html",
        "sold": 0
    },
    {
        "product_name": "Miusue ชุดช้อนปลูกและส้อมพรวนปรับระดับสนามหญ้าพื้นที่ครอบคลุมกว้างทนทานเครื่องมือปรับระดับมืออาชีพอเนกประสงค์สำหรับบ้านฟาร์ม",
        "product_image": "https://img.lazcdn.com/g/p/6a0d75c313597afb837419f6185093b2.jpg_200x200q90.jpg",
        "price": 6212,
        "remark": "https://www.lazada.co.th/products/pdp-i6004481743.html",
        "sold": 0
    },
    {
        "product_name": "Manta คราดปรับระดับงานหนักระดับมืออาชีพอเนกประสงค์สำหรับสวนฟาร์ม",
        "product_image": "https://img.lazcdn.com/g/p/f4cfde4fa893790e16194838252a5bec.jpg_200x200q90.jpg",
        "price": 6212,
        "remark": "https://www.lazada.co.th/products/pdp-i6003389149.html",
        "sold": 0
    },
    {
        "product_name": "Xinda | เทปและเชือกสำหรับการปีนเขาสำหรับการทำงานกลางแจ้ง ชุดเก็บอุปกรณ์พับได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S122ec46d675941a785fa03224e8d7cbfs.jpg_200x200q90.jpg",
        "price": 6177.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16049043474.html",
        "sold": 0
    },
    {
        "product_name": "Mobi Garden | ชิงช้าพกพาสำหรับกลางแจ้งน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S57d2ad3a1737406cba40a7f95c1ab8ffL.png_200x200q90.png",
        "price": 6101.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16103267138.html",
        "sold": 0
    },
    {
        "product_name": "White moon lamp, outdoor solar garden lamp, moon lamp, landscape lamp, villa garden lamp, lawn lamp, floor lamp, colorful lighting",
        "product_image": "https://img.lazcdn.com/g/p/2939b0da46b63ca15c4a9c2ed7c53955.jpg_200x200q90.jpg",
        "price": 5973.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16099918251.html",
        "sold": 0
    },
    {
        "product_name": "YUNHONG | โคมไฟสวนแบบพกพาใช้พลังงานแสงอาทิตย์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1441b54c371a4feea12d4e9e4d70be29S.jpg_200x200q90.jpg",
        "price": 5662.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5963788237.html",
        "sold": 4
    },
    {
        "product_name": "Moon lamp outdoor solar lawn light courtyard moon lamp garden landscape decoration waterproof ambient light colorful atmosphere light",
        "product_image": "https://img.lazcdn.com/g/p/37607d93dc75d4509309ff2073bcf324.jpg_200x200q90.jpg",
        "price": 5444.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16099785096.html",
        "sold": 0
    },
    {
        "product_name": "PUMPKIN ไฟโคม รุ่น  INF-50AL (50602) ไฟ LED ไร้สาย (ตัวเปล่า) INF-XT20 20V ส่องพื้นที่รอบด้าน 360 โคมไฟเคลื่อนที่ โคมไฟ  เครื่องมือช่าง สนาม สวน  จัดส่ง FLASH",
        "product_image": "https://img.lazcdn.com/g/p/7676f449d74075fe2cc66a7aeccdc82f.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i16146903994.html",
        "sold": 0
    },
    {
        "product_name": "Mobi Gardenเต็นท์ Zero Automatic 135 พร้อมผ้าคลุมเคลือบสีดำ ป้องกันรังสียูวี กันฝน",
        "product_image": "https://img.lazcdn.com/g/p/b5441a3746841013693b876372391647.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i16090440986.html",
        "sold": 0
    },
    {
        "product_name": "【HPS】 4-Fold Aluminum Alloy Outdoor Folding Table W/ Carry Bag Portable Folding Picnic Table for Garden Outdoor BBQ Cooking",
        "product_image": "https://img.lazcdn.com/g/p/1bab7a197d2caf29b295dd08ba506c42.jpg_200x200q90.jpg",
        "price": 5018,
        "remark": "https://www.lazada.co.th/products/pdp-i16146437726.html",
        "sold": 0
    },
    {
        "product_name": "XiMei WoodWork | รั้วประดับไม้ไผ่คาร์บอนไรซ์สำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S684d54e51fa7415f839c05a6ffd3bff1c.jpg_200x200q90.jpg",
        "price": 9680.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16075272641.html",
        "sold": 0
    },
    {
        "product_name": "XiMei WoodWork |เก้าอี้ม้านั่งรอบต้นไม้ไม้กันน้ำสำหรับสวนกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Saf24da5b65c744c1a187ae3c26fd20aal.jpg_200x200q90.jpg",
        "price": 8610.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16052689397.html",
        "sold": 0
    },
    {
        "product_name": "2ชิ้นโคมไฟพลังงานแสงอาทิตย์อุณหภูมิ3สี2โหมด IPX4 Lampu Tenaga Surya แขวนกันน้ำพร้อมขาตั้งสำหรับอุปกรณ์ตกแต่งสวนในสนาม",
        "product_image": "https://img.lazcdn.com/g/p/4e088172f737040751b0c8aca3b26d06.jpg_200x200q90.jpg",
        "price": 4892,
        "remark": "https://www.lazada.co.th/products/pdp-i16129569402.html",
        "sold": 0
    },
    {
        "product_name": "อุปกรณ์ BB เครื่องมือสวนรักษาเส้นผ่านศูนย์กลางเครื่องซักผ้าระบบ: 57มม. ใช้ได้ BBs: เกลียว,เข้าด้วยกัน,ตลับ,ถ้วยและกรวย BBT-RS สีดำขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/p/57a0d83c62c43a18dce4b5366b0c3b52.jpg_200x200q90.jpg",
        "price": 4884,
        "remark": "https://www.lazada.co.th/products/pdp-i5481222252.html",
        "sold": 0
    },
    {
        "product_name": "ตาขายรวสนามฟตซอล ขนาด 150x80 ซม. สำหรบสนามฟตบอลแบบแบงสวน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfb9213bacc5b446db72a7a876eaf22a1x.png_200x200q90.png",
        "price": 4876.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16118086179.html",
        "sold": 0
    },
    {
        "product_name": "(เซลเลอรเอيد) ตาขายสนามฟตซอล ตาขายสนามฟตบอลแบบแบงสวน ขนาด 150x80 ซม.",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbce52faa295e41e0928ee510ee1f594eP.png_200x200q90.png",
        "price": 4851.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16117868819.html",
        "sold": 0
    },
    {
        "product_name": "เล้าไก่ TOOYFUL ที่คลุมผ้าใบกันน้ำทนต่อการแข็งตัวรันสำหรับลานบ้านเรือนกระจก Pergola ในฤดูหนาว",
        "product_image": "https://img.lazcdn.com/g/p/fa664846de19e4cd628767a6d9938731.jpg_200x200q90.jpg",
        "price": 4620,
        "remark": "https://www.lazada.co.th/products/pdp-i16053224738.html",
        "sold": 0
    },
    {
        "product_name": "Outdoor water drop light, waterproof lawn light, villa courtyard garden terrace ambiance light, landscape courtyard decorative floor lamp, multicolor",
        "product_image": "https://img.lazcdn.com/g/p/431d06a7f8dafcfaaeca33016b45ded6.jpg_200x200q90.jpg",
        "price": 4608.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16099719213.html",
        "sold": 0
    },
    {
        "product_name": "GAOBIGEGE | โคมไฟประดับตระแกรงสำหรับโต๊ะสวนกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S75925fa53aec460cb17d234bc8238014s.jpg_200x200q90.jpg",
        "price": 4542.66,
        "remark": "https://www.lazada.co.th/products/pdp-i5877094265.html",
        "sold": 0
    },
    {
        "product_name": "Kovia Relax Long Chair เก้าอี้สนามยาวเก้าอี้แคมป์ปิ้ง  KECQ9CA",
        "product_image": "https://img.lazcdn.com/g/p/53a12aaa8fc8b8f0ca0564d31cc36a7c.jpg_200x200q90.jpg",
        "price": 4400,
        "remark": "https://www.lazada.co.th/products/pdp-i16080615141.html",
        "sold": 0
    },
    {
        "product_name": "Nafurno Luocuteแบบพกพาเครื่องตัดหลุมกอล์ฟที่ถอดออกได้ไม่ลื่นจับกอล์ฟใส่เครื่องตัดหลุมสีเขียวสำหรับสนามหญ้าและสวน",
        "product_image": "https://img.lazcdn.com/g/p/76abba91c673f6ffe9d3b7f0b1c8aef5.jpg_200x200q90.jpg",
        "price": 4318,
        "remark": "https://www.lazada.co.th/products/pdp-i16146299040.html",
        "sold": 0
    },
    {
        "product_name": "รล I7G7U9C1 สายยาง 30 เมตร ดแลสวน เครองพนนำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdc67a584632146d083505b40627ea6c6j.png_200x200q90.png",
        "price": 4274.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16117607800.html",
        "sold": 0
    },
    {
        "product_name": "ตัวบ่งชี้เทปติดหลอดไฟความร้อนสายนำความร้อนนาโนเว่ย20ม. สำหรับสวน",
        "product_image": "https://img.lazcdn.com/g/p/57175728ede70acc175f21282b80a4d7.jpg_200x200q90.jpg",
        "price": 4192,
        "remark": "https://www.lazada.co.th/products/pdp-i6015040919.html",
        "sold": 0
    },
    {
        "product_name": "มายเฮาส ฟลอราการเดน ผาหมกนฝน 4 ฤด รน SS",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3db78381758041cc9b217af3e71a7063U.png_200x200q90.png",
        "price": 4184.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16117698981.html",
        "sold": 0
    },
    {
        "product_name": "ไฟหน้ากันน้ำสำหรับกลางแจ้ง ดีไซน์เสาพระจันทร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saccf51015b8140d0a7cc7e7892780719N.jpg_200x200q90.jpg",
        "price": 4114.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5931036578.html",
        "sold": 3
    },
    {
        "product_name": "Mobi Garden | เตาแคมปิ้งพกพาป้องกันลม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb5e06c0702c249a9b0ac29d8d87dd750b.png_200x200q90.png",
        "price": 4104.32,
        "remark": "https://www.lazada.co.th/products/pdp-i16097715775.html",
        "sold": 0
    },
    {
        "product_name": "Mobi Garden | เตาปิคนิคพกพาทนลม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scce790679b194e4aa7cf5deaf01cf7cf9.jpg_200x200q90.jpg",
        "price": 4096.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16099203915.html",
        "sold": 4
    },
    {
        "product_name": "เก้าอี้พกพาสำหรับแคมปิ้ง ชายหาด สวน ตกปลา ขนาดคู่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa1490cc1b1504fea9fc700f97d6f8b00R.jpg_200x200q90.jpg",
        "price": 4091.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6066743693.html",
        "sold": 0
    },
    {
        "product_name": "Futoys คราดทรายกันสนิมพร้อมเครื่องร่อนโลหะเครื่องมือพลั่วชายหาดมีประสิทธิภาพเครื่องทำความสะอาดสวนกลางแจ้งสำหรับชายฝั่ง",
        "product_image": "https://img.lazcdn.com/g/p/80c1c61bfb6fd35717c7a8b74c3cf6c1.jpg_200x200q90.jpg",
        "price": 4030,
        "remark": "https://www.lazada.co.th/products/pdp-i16137010721.html",
        "sold": 0
    },
    {
        "product_name": "Motoautt คราดทรายสแตนเลสที่แยกออกได้เครื่องมือทำสวนกลางแจ้งที่มีด้ามยาวสำหรับการค้นหาชายหาด",
        "product_image": "https://img.lazcdn.com/g/p/f02bc037e6f6af029224a24bf4929a4e.jpg_200x200q90.jpg",
        "price": 4030,
        "remark": "https://www.lazada.co.th/products/pdp-i16137018688.html",
        "sold": 0
    },
    {
        "product_name": "Mobi Garden | เก้าอี้พกพาที่พับได้พร้อมที่พยุงหลัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S85e1f98527354efc878c5b5f8d908f8fc.jpg_200x200q90.jpg",
        "price": 4021.38,
        "remark": "https://www.lazada.co.th/products/pdp-i6003331766.html",
        "sold": 0
    },
    {
        "product_name": "ผ้าม่านตกแต่งเป่าลมกระต่ายอีสเตอร์กันน้ำลึก1.5เมตรเติมลมตกแต่งกลางแจ้งสำหรับงานเทศกาลสวนสนามหญ้าลานบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/da27a7376917fe20e269607d054175eb.jpg_200x200q90.jpg",
        "price": 4008,
        "remark": "https://www.lazada.co.th/products/pdp-i16072171318.html",
        "sold": 0
    },
    {
        "product_name": "MUQZI 6000 วัตต์ วงแหวนต้มแก๊ส โครงสร้างเหล็กหล่อ การปรุงอาหารในสวนหลังบ้าน เตาแก๊ส LPG ระบบควบคุมไฟแบบพกพา โครงเหล็ก หัวเผาแรงดันสูง การทำอาหารกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/9983b196029e379c480e2276ea65d70b.jpg_200x200q90.jpg",
        "price": 3942,
        "remark": "https://www.lazada.co.th/products/pdp-i16147162878.html",
        "sold": 0
    },
    {
        "product_name": "MAOMEI 6000 วัตต์ วงแหวนต้มแก๊ส การปรุงอาหารในสวนหลังบ้าน โครงสร้างเหล็กหล่อ เตาเผาเหล็กหล่อ เตาขนาดใหญ่ เตาแก๊สหัวเดียว เตาแก๊ส LPG การทำอาหารกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/e38d0a24540d72b8a68e18a28b582fa9.jpg_200x200q90.jpg",
        "price": 3922,
        "remark": "https://www.lazada.co.th/products/pdp-i16147224887.html",
        "sold": 0
    },
    {
        "product_name": "BGKToys อีสเตอร์พองได้ลายเทศกาลกระต่ายอีสเตอร์น่ารักแบบพองได้สำหรับสนามหญ้าลานบ้านสวนระเบียง",
        "product_image": "https://img.lazcdn.com/g/p/0179ae3b1905455f057a88e3454c368a.jpg_200x200q90.jpg",
        "price": 3914,
        "remark": "https://www.lazada.co.th/products/pdp-i16092612045.html",
        "sold": 0
    },
    {
        "product_name": "12/14/16/18mm  5/10/20M Natural Jute Rope, Decking Garden Boating Sash Cord Crafts",
        "product_image": "https://img.lazcdn.com/g/p/6a7baaa3fa2cd9691fec1bcc7c4d1ccf.png_200x200q90.png",
        "price": 3914,
        "remark": "https://www.lazada.co.th/products/pdp-i6071953940.html",
        "sold": 0
    },
    {
        "product_name": "Bhuuno สไลเดอร์สระว่ายน้ำสระน้ำมีสไลเดอร์เป่าลมเกมเล่นกลางแจ้งพกพาสะดวกสำหรับปาร์ตี้ฤดูร้อนลานสวน",
        "product_image": "https://img.lazcdn.com/g/p/11693239aaba582755f4aa100e0baecb.jpg_200x200q90.jpg",
        "price": 3818.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16122668751.html",
        "sold": 0
    },
    {
        "product_name": "MagiDeal ของตกแต่งภาพเป่าลมอีสเตอร์กระต่ายอีสเตอร์พองลมได้อย่างรวดเร็วน่ารักตกแต่งสวนกลางแจ้งสำหรับภายนอก",
        "product_image": "https://img.lazcdn.com/g/p/da4a02cc533fd3dc3ad21dbfe204a5a8.jpg_200x200q90.jpg",
        "price": 3775.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16119127481.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องยับยั้งนกใช้พลังงานแสงอาทิตย์เซนเซอร์ตรวจจับความเคลื่อไหวนกสำหรับสวนหลังบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/a5863fd63ce0f4e1b5ddf3fca98e2f44.jpg_200x200q90.jpg",
        "price": 1990,
        "remark": "https://www.lazada.co.th/products/pdp-i16065502463.html",
        "sold": 0
    },
    {
        "product_name": "Goyan เป้าหมายฟุตบอลของขวัญสำหรับเด็ก Jaring Gawang Sepak Bola สำหรับสวนหลังบ้านในร่มกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/2b4760ba95db7ac6fc47a56edf268d26.jpg_200x200q90.jpg",
        "price": 3748,
        "remark": "https://www.lazada.co.th/products/pdp-i5932911361.html",
        "sold": 0
    },
    {
        "product_name": "Outdoor Garden, Patio, Pathway and Yard Large Capacity Battery High Efficiency Solar Powered Lights",
        "product_image": "https://img.lazcdn.com/g/p/aa75ad6fa46fa13770ddf4f364c26a81.jpg_200x200q90.jpg",
        "price": 3744,
        "remark": "https://www.lazada.co.th/products/pdp-i16138745310.html",
        "sold": 0
    },
    {
        "product_name": "{slige} MOBI GARDEN Camping Retro Camp Lamp LED Hanging Retro Atmosphere Star Lantern Outdoor",
        "product_image": "https://img.lazcdn.com/g/p/92895c8283d76e467fb215e980690672.jpg_200x200q90.jpg",
        "price": 3720,
        "remark": "https://www.lazada.co.th/products/pdp-i16146325511.html",
        "sold": 0
    },
    {
        "product_name": "Mobi Garden | เตาบาร์บีคิวพับได้ 2 ชั้น สแตนเลส พกพาสะดวก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S69338a0e705a44b78082dca2cc8d2d0dj.jpg_200x200q90.jpg",
        "price": 3702.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16097954270.html",
        "sold": 2
    },
    {
        "product_name": "Camping Stool,Mountaineering and Hiking Portable Stools 13.5“ Portable Folding Stools for Outdoor Gardening and Beach Hiking Fishing,Foot Stool with Carry Bag to 330LB",
        "product_image": "https://img.lazcdn.com/g/p/36252809b7de95d6e661d3263dddb4f3.jpg_200x200q90.jpg",
        "price": 3649.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5844890692.html",
        "sold": 0
    },
    {
        "product_name": "สายฉดนำแรงดนสง U3R2I6Z3 พรอมหวฉด 15 เมตร หนาตาง และสวน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8e2d161431664a8892aa9df1242ef1ccm.png_200x200q90.png",
        "price": 3582.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16117866486.html",
        "sold": 0
    },
    {
        "product_name": "DUANYUN | กรรไกรตัดกิ่งไม้ใช้ง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se4cc3045d6ab417998fedb42ad389979W.jpg_200x200q90.jpg",
        "price": 3572.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5981306377.html",
        "sold": 0
    },
    {
        "product_name": "Jimdary LAISANIM เครื่องเล่นเทปคาสเซ็ตย้อนยุคพร้อมย้อนกลับอัตโนมัติเครื่องเล่นเทปแบบพกพา AM/FM จอแสดงผล LED ดิจิตอลลำโพงในตัวฟังก์ชั่นการบันทึกแจ็คหูฟังสำหรับเดินในสวน",
        "product_image": "https://img.lazcdn.com/g/p/85a96c124a11f71cbe7043847b17e85f.jpg_200x200q90.jpg",
        "price": 3566,
        "remark": "https://www.lazada.co.th/products/pdp-i16147214872.html",
        "sold": 0
    },
    {
        "product_name": "Toyisland ตัวตลกว่าวยักษ์ของเล่นว่าวบินมืออาชีพสำหรับสวนสาธารณะกิจกรรมกลางแจ้งสวน",
        "product_image": "https://img.lazcdn.com/g/p/4d5fff9f270690e8ee6b0540ea1450fb.jpg_200x200q90.jpg",
        "price": 3566,
        "remark": "https://www.lazada.co.th/products/pdp-i6077011039.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้สนามกีฬา Colaxi สำหรับอัฒจันทร์เก้าอี้ Bleacher ถือขึ้น360lbs มีพนักพิงสำหรับตกปลาปิกนิกสวนเดินป่ากิจกรรมกีฬา",
        "product_image": "https://img.lazcdn.com/g/p/4225bedf6e71f15381dbfdd39a5339b6.jpg_200x200q90.jpg",
        "price": 3491.94,
        "remark": "https://www.lazada.co.th/products/pdp-i6007546820.html",
        "sold": 0
    },
    {
        "product_name": "COONOR ร่มชายหาดใบเรือมุ้งคาร์ซีตสำหรับเด็กรูปร่างสามเหลี่ยมสุทธิสำหรับ3x3x3M สวนชาวบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/8c118d4065fc132fb6c17c7ef4787ae1.jpg_200x200q90.jpg",
        "price": 3404,
        "remark": "https://www.lazada.co.th/products/pdp-i16089370784.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้มีที่วางเท้าเก้าอี้สนามมีน้ำหนักเบามากผ้าออกซ์ฟอร์ดแบบใช้ได้จริงกระเป๋าเก็บของแบบออตโตมันสำหรับสวนลานคอนเสิร์ตในสวน",
        "product_image": "https://img.lazcdn.com/g/p/639e2829d423434d8da25a13d82acaea.jpg_200x200q90.jpg",
        "price": 3248,
        "remark": "https://www.lazada.co.th/products/pdp-i16121145882.html",
        "sold": 0
    },
    {
        "product_name": "Outdoor Swing Hanging Chair Eggshell Dust Cover Polyester UV Protection Universal Cover Garden Waterproof Dust Cover Dropship",
        "product_image": "https://img.lazcdn.com/g/p/d18be7558019062157b4ee9cc2af8bde.jpg_200x200q90.jpg",
        "price": 3216,
        "remark": "https://www.lazada.co.th/products/pdp-i3578379247.html",
        "sold": 0
    },
    {
        "product_name": "รั้วสวนหย่อม 6 ชิ้น สีดำ แต่งสวน สีดำ 50x182 ซม  รั้วต้นไม้ รั้วตกแต่งสวน 6pcs Panel Garden Fence Metal Decor Lawn Border Climbing Plants Edge Landscaping Interlocking รั้วสวนเหล็ก",
        "product_image": "https://img.lazcdn.com/g/p/45ead275c6fa4e4f8ba30d26dbb640fa.jpg_200x200q90.jpg",
        "price": 3184.56,
        "remark": "https://www.lazada.co.th/products/pdp-i4559608643.html",
        "sold": 4
    },
    {
        "product_name": "ใบเรือร่มชายหาดมุ้งคาร์ซีตสำหรับเด็กรูปสามเหลี่ยมสุทธิสำหรับ3x3x3M สวนชาวบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/3875c2d3426922c1ce63f8f4750a7567.jpg_200x200q90.jpg",
        "price": 3108,
        "remark": "https://www.lazada.co.th/products/pdp-i6078833257.html",
        "sold": 0
    },
    {
        "product_name": "ร่มหลังคากั้นกันยูวีกันน้ำตาระบายอากาศได้ดีพระอาทิตย์ล่องเรือสำหรับสวนกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/ba1fef752a63be70684892d19b936529.jpg_200x200q90.jpg",
        "price": 3090,
        "remark": "https://www.lazada.co.th/products/pdp-i5999837382.html",
        "sold": 0
    },
    {
        "product_name": "YFD  White moon lamp, outdoor solar garden lamp, moon lamp, landscape lamp, villa garden lamp, lawn lamp, floor lamp, colorful lighting",
        "product_image": "https://img.lazcdn.com/g/p/a0dd195abac8b7bce695e859bcc30617.jpg_webp_200x200q90.jpg",
        "price": 3088.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16091489088.html",
        "sold": 0
    },
    {
        "product_name": "Ftype สำหรบตกแตงโตะคาเฟและสวน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S646723bb9b224d3eaac27f8395ec4100w.png_200x200q90.png",
        "price": 3046.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16120475569.html",
        "sold": 0
    },
    {
        "product_name": "10 อัน l รั้ว เคราฤาษี ต้นไม้ฟอกอากาศ ตกแต่งบ้าน สไตล์ธรรมชาติ",
        "product_image": "https://img.lazcdn.com/g/p/e399544775a91c2503a1299fff241708.jpg_200x200q90.jpg",
        "price": 3000,
        "remark": "https://www.lazada.co.th/products/pdp-i5809385067.html",
        "sold": 0
    },
    {
        "product_name": "Mobi GARDEN เก้าอี้ปิกนิก พับได้ พกพา สวยหรู เหมาะสําหรับตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/11c17e76152af9a9cf305e120c943dd7.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i16098226514.html",
        "sold": 0
    },
    {
        "product_name": "Waterproof Outdoor Furniture Cover L Shape Corner Garden Patio Rattan Sofa Couch Protective Covers Set Dust Proof Set 4 Size XL",
        "product_image": "https://img.lazcdn.com/g/p/f5efcd1b063d04757758044ce88892bf.jpg_200x200q90.jpg",
        "price": 2974,
        "remark": "https://www.lazada.co.th/products/pdp-i3578305674.html",
        "sold": 0
    },
    {
        "product_name": "Mobi Garden | เก้าอี้เปลญวนสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S06267562a9b3433a89840b5411a2d8a2d.jpg_200x200q90.jpg",
        "price": 2894.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16097794747.html",
        "sold": 0
    },
    {
        "product_name": "ว่าว Pelaso ที่แข็งแรงทนทานสำหรับการเดินทางในสวนกิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/dfa0c066736b9bbe4baf98ebc09b5a69.jpg_200x200q90.jpg",
        "price": 2894,
        "remark": "https://www.lazada.co.th/products/pdp-i16049150907.html",
        "sold": 0
    },
    {
        "product_name": "ประตูตีกอล์ฟทนทาน50มม. 55มม. 60มม. พร้อมฐานสำหรับสวนสีเขียว",
        "product_image": "https://img.lazcdn.com/g/p/50716be57a57c6d561429339d41adeec.jpg_200x200q90.jpg",
        "price": 2890,
        "remark": "https://www.lazada.co.th/products/pdp-i6003295925.html",
        "sold": 0
    },
    {
        "product_name": "(ชุด4สำหรับการขุดหอย,คราด,พลั่ว,ถัง,สุทธิ,ขุดหอย,พลั่ว,หอย,หอย,หอย,หอย,หอย,และหอยคู่,พักผ่อน,เล่นในทราย,การทำสวน",
        "product_image": "https://img.lazcdn.com/g/p/3577b68d40bc61b6d18dfa403753d2a6.png_200x200q90.png",
        "price": 2878,
        "remark": "https://www.lazada.co.th/products/pdp-i5906438905.html",
        "sold": 1
    },
    {
        "product_name": "Jimdary Diydeg โคมไฟพลังงานแสงอาทิตย์ 2 แพ็คกลางแจ้งกันน้ำตกแต่งพลังงานแสงอาทิตย์ริบหรี่ Flameless โคมไฟแขวน 2 โหมดและขาตั้งกล้องสำหรับลานลานต้นไม้สวนตกแต่งโต๊ะ",
        "product_image": "https://img.lazcdn.com/g/p/acd1dc388a34516b499ff618837374c5.jpg_200x200q90.jpg",
        "price": 2876,
        "remark": "https://www.lazada.co.th/products/pdp-i16146391400.html",
        "sold": 0
    },
    {
        "product_name": "พรมพื้นสวนรถยนต์สระว่ายน้ำสีดำของ Ellwewe RV",
        "product_image": "https://img.lazcdn.com/g/p/c59d255cd418874df632a75b676ee61d.jpg_200x200q90.jpg",
        "price": 2874,
        "remark": "https://www.lazada.co.th/products/pdp-i5920622577.html",
        "sold": 0
    },
    {
        "product_name": "โซฟาแบบพองวัสดุพีวีซีเก้าอี้เป่าลมสำหรับห้องนั่งเล่นนุ่มพิเศษระเบียงห้องนอนสวน",
        "product_image": "https://img.lazcdn.com/g/p/6a9ef52482ff3ab9c5f2a09369ad986a.jpg_200x200q90.jpg",
        "price": 2840,
        "remark": "https://www.lazada.co.th/products/pdp-i6022154768.html",
        "sold": 0
    },
    {
        "product_name": "Mobi garden เก้าอี้พกพา อลูมิเนียมอัลลอยด์ เก้าอี้หลังสูง",
        "product_image": "https://img.lazcdn.com/g/p/3b03c0b98adce795ae1d164cfdc4cd09.jpg_200x200q90.jpg",
        "price": 2780,
        "remark": "https://www.lazada.co.th/products/pdp-i16098370363.html",
        "sold": 0
    },
    {
        "product_name": "Colaxi สไลเดอร์สระว่ายน้ำทำจากพีวีซีสไลเดอร์น้ำสำหรับสวนฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/745844e1af68d7814cd678ba2c70b3a1.jpg_200x200q90.jpg",
        "price": 2774.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5808851073.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟกลางแจ้งกันน้ำสว่างมากสำหรับบ้านและสวน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7534dfe458fe4e86b6f8dc04ea93ca4cR.jpg_200x200q90.jpg",
        "price": 2738.16,
        "remark": "https://www.lazada.co.th/products/pdp-i5928411035.html",
        "sold": 0
    },
    {
        "product_name": "BNMUSIC ชุดเก้าอี้ติดม่านบังแดดที่นั่งริมชายหาดพับได้สำหรับเด็กเก้าอี้ผ่อนคลายกลางแจ้งน้ำหนักเบาสำหรับตั้งแคมป์ในสวนหลังบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/96a596bb7f195a660347b64bbea06c89.jpg_200x200q90.jpg",
        "price": 2728,
        "remark": "https://www.lazada.co.th/products/pdp-i16121427329.html",
        "sold": 0
    },
    {
        "product_name": "210D Oxford Cloth Outdoor Patio Furniture Recliner Cover Dust Cover Waterproof Protective Cover Beach Recliner Garden Supplies",
        "product_image": "https://img.lazcdn.com/g/p/79bc09ab25b870978d16383e1e0d022d.jpg_200x200q90.jpg",
        "price": 2680,
        "remark": "https://www.lazada.co.th/products/pdp-i3578276848.html",
        "sold": 0
    },
    {
        "product_name": "XLYS | ไฟกลางแจ้งสองโหมดพร้อมเซ็นเซอร์ ความสว่างสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa3655cdb81b843d28ad8dc6f979fa57bh.jpg_200x200q90.jpg",
        "price": 2629.12,
        "remark": "https://www.lazada.co.th/products/pdp-i6015094320.html",
        "sold": 32
    },
    {
        "product_name": "ไฟสายประดับดาวสำหรับแค้มปิ้งกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S40aff73552ed4e2f89ba2fa89fef2ac1m.jpg_200x200q90.jpg",
        "price": 2605.54,
        "remark": "https://www.lazada.co.th/products/pdp-i5878388607.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟพลังงานแสงอาทิตย์สำหรับกลางแจ้งกันน้ำแขวนไฟหวายพลาสติกสำหรับการตั้งแคมป์สวนทางเดินลานบ้านโต๊ะ",
        "product_image": "https://img.lazcdn.com/g/p/5973d127fc2e28c740f784400c4bdb75.jpg_200x200q90.jpg",
        "price": 2562,
        "remark": "https://www.lazada.co.th/products/pdp-i16129443983.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟพลังงานแสงอาทิตย์ LED โคมไฟแบบแขวนพลังงานแสงอาทิตย์ประหยัดพลังงานไม้เท้าพลาสติกและเหล็กกันน้ำสำหรับสวน",
        "product_image": "https://img.lazcdn.com/g/p/f50496c625f21db7e91a9f5b3226849f.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i6023178996.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้ที่นั่งริมชายหาดสำหรับเด็กแบบพับได้และปรับได้พร้อมร่มกันแดดสำหรับสวนชายหาด",
        "product_image": "https://img.lazcdn.com/g/p/a1080c8125c78a34af5c1f1513de390c.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i16123990614.html",
        "sold": 0
    },
    {
        "product_name": "สายยางรดนำในสวน สายยางแบบมวนเกบได ใชงานงายเพยงปมเดยว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdb5d2c65b70242c39ec0b723155b986fm.png_200x200q90.png",
        "price": 2559.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16120738445.html",
        "sold": 0
    },
    {
        "product_name": "เต้นท์กันแดดชายทะเลเต็นท์ชายหาดพร้อมถุงทรายสำหรับสวนหลังบ้านตั้งแคมป์ตกปลาเดินเขา",
        "product_image": "https://img.lazcdn.com/g/p/0e3a19dfda707564b23f48b9cad09818.jpg_200x200q90.jpg",
        "price": 2554,
        "remark": "https://www.lazada.co.th/products/pdp-i16109925866.html",
        "sold": 0
    },
    {
        "product_name": "กิจกรรมสำหรับเด็กและพ่อแม่เกมกระโดดร่มสำหรับสวนสนุก",
        "product_image": "https://img.lazcdn.com/g/p/275242f31038bd13f90924296ab37166.jpg_200x200q90.jpg",
        "price": 2550,
        "remark": "https://www.lazada.co.th/products/pdp-i16090856968.html",
        "sold": 0
    },
    {
        "product_name": "Mobi Garden | เก้าอี้พับได้สูงพนักพิงโค้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S79f3434b38e147539a194e79906e0a89P.png_200x200q90.png",
        "price": 2530.96,
        "remark": "https://www.lazada.co.th/products/pdp-i6017986480.html",
        "sold": 21
    },
    {
        "product_name": "สวนแนวตั้ง ต้นไม้มงคล แบบติดผนัง ขนาด ยาว 80 ซม. กว้าง 15 ซม. โทนสีเขียวเป็นธรรมชาติ ไม่ต้องเจาะกำแพง",
        "product_image": "https://img.lazcdn.com/g/p/0784d5405f827e3886901ebea0f1c768.jpg_200x200q90.jpg",
        "price": 2500,
        "remark": "https://www.lazada.co.th/products/pdp-i6031505407.html",
        "sold": 0
    },
    {
        "product_name": "ท่อภายในเครื่องตัดหญ้า16X650X8สำหรับนั่งบนรถแทรกเตอร์และรถเข็นในสวน",
        "product_image": "https://img.lazcdn.com/g/p/967a9acd47c3003182b374d8a9f97ef8.jpg_200x200q90.jpg",
        "price": 2462,
        "remark": "https://www.lazada.co.th/products/pdp-i6023188950.html",
        "sold": 0
    },
    {
        "product_name": "รูปปั้นสัตว์ทำจากยางเรซินสำหรับตกแต่งสวนสนามหญ้าลาน",
        "product_image": "https://img.lazcdn.com/g/p/7b29d0b393e65d75d7a0e4dfe78e5eec.jpg_200x200q90.jpg",
        "price": 2454,
        "remark": "https://www.lazada.co.th/products/pdp-i6024674534.html",
        "sold": 0
    },
    {
        "product_name": "Kokiya Battle Game Team 3สวนสนามหญ้าในฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/8502313b63054dcd8d00a712ffe4608c.jpg_200x200q90.jpg",
        "price": 2430,
        "remark": "https://www.lazada.co.th/products/pdp-i16086221251.html",
        "sold": 0
    },
    {
        "product_name": "Outdoor Garden Lawn Landscape Decorative Light 2pcs Solar Flame Lantern Auto On/Off",
        "product_image": "https://img.lazcdn.com/g/p/130a4f0543c617cb508358ec1ae37073.jpg_200x200q90.jpg",
        "price": 2426,
        "remark": "https://www.lazada.co.th/products/pdp-i16138475917.html",
        "sold": 0
    },
    {
        "product_name": "codA pair of cotton printed pillowcases with ruffled edges, garden body pillowcases, bed pillowcases",
        "product_image": "https://img.lazcdn.com/g/p/9ffd0d2dcba71557dbf5e4732e9a9678.jpg_200x200q90.jpg",
        "price": 2410.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16147094763.html",
        "sold": 0
    },
    {
        "product_name": "Nafurno Estink โคมไฟพลังงานแสงอาทิตย์กลางแจ้ง USB ชาร์จไฟพลังงานแสงอาทิตย์พร้อมเอฟเฟกต์ริบหรี่สำหรับลานสวนลานทางเดิน 2 แพ็ควัสดุ ABS Weatherproof ชาร์จคู่",
        "product_image": "https://img.lazcdn.com/g/p/d2b168a96deff5305d861df97cdaf138.jpg_200x200q90.jpg",
        "price": 2392,
        "remark": "https://www.lazada.co.th/products/pdp-i16146986759.html",
        "sold": 0
    },
    {
        "product_name": "Toyisland ชุดติดตั้งง่ายอุปกรณ์สนามเด็กเล่นกลางแจ้งสำหรับเด็ก,ชุดของเล่นกลางแจ้งสำหรับบ้านเด็กเล่นสวนต้นไม้",
        "product_image": "https://img.lazcdn.com/g/p/011045ae62de83ad7d50736bd2315613.jpg_200x200q90.jpg",
        "price": 2386.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16118500962.html",
        "sold": 0
    },
    {
        "product_name": "สายคล้องคอดินในสวนไฮไลท์แบบมืออาชีพช่วยให้ขุดได้ง่าย",
        "product_image": "https://img.lazcdn.com/g/p/2ecea132431da58aaf28063db070dc8e.jpg_200x200q90.jpg",
        "price": 2343.74,
        "remark": "https://www.lazada.co.th/products/pdp-i6017892481.html",
        "sold": 0
    },
    {
        "product_name": "BNMUSIC ร่มชายหาดทนทานต่อลมแบบพกพาม่านบังแดดการป้องกันแสงแดดสำหรับสวนชายหาดสวนสนามหลังบ้านระเบียง",
        "product_image": "https://img.lazcdn.com/g/p/2d8ae0541c6c85803fe5e7fa86cd1884.jpg_200x200q90.jpg",
        "price": 2286,
        "remark": "https://www.lazada.co.th/products/pdp-i16121572151.html",
        "sold": 0
    },
    {
        "product_name": "ชุดตุ๊กตาพองตัวได้ตะเข็บเสริมชุดพองลมความสนุกสนานสำหรับผู้ชายที่โตแล้วสำหรับสวนคอสเพลย์",
        "product_image": "https://img.lazcdn.com/g/p/d159adc5902969cec4b5025ce8a4e6c4.jpg_200x200q90.jpg",
        "price": 2268,
        "remark": "https://www.lazada.co.th/products/pdp-i6054034611.html",
        "sold": 0
    },
    {
        "product_name": "ดินเพาะพันธุ์ดอกไม้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1a653b0fb8f7456a9d27ddd9d4e7bd81E.jpg_200x200q90.jpg",
        "price": 2264.94,
        "remark": "https://www.lazada.co.th/products/pdp-i16091194162.html",
        "sold": 0
    },
    {
        "product_name": "✈√웃2IN1 Outdoor Solar Camping Wall Lamps Lawn Lamps Floor Lamp LED Induction Lamps Garden Landscape Lamps Decorative Tungsten Lamp웃◐",
        "product_image": "https://img.lazcdn.com/g/p/e2fcde74bc6e2df4472bd2b2fc206a41.png_200x200q90.png",
        "price": 2258.4,
        "remark": "https://www.lazada.co.th/products/pdp-i16087899298.html",
        "sold": 0
    },
    {
        "product_name": "MaiMeng | ไฟส่องสว่างพลังงานแสงอาทิตย์สำหรับสนามหญ้าและพื้นที่ชนบท",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S513f00185fae4887a99475b55ab51505d.jpg_200x200q90.jpg",
        "price": 2254.06,
        "remark": "https://www.lazada.co.th/products/pdp-i5878332422.html",
        "sold": 9
    },
    {
        "product_name": "ชุดไดโนเสาร์ ไดโนเสาร์มิสชั่นส์ อลโลซอรัส MOC ชุดรถบรรทุกขนส่ง ของเล่นไดโนเสาร์สำหรับเด็ก ของเล่นสวนสนุกไดโนเสาร์ ของขวัญคริสต์มาส 76966",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2b17782810b140b89930927906be7b2cz.jpg_200x200q90.jpg",
        "price": 2245.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16099484411.html",
        "sold": 0
    },
    {
        "product_name": "ฟมา 25SS คอลเลคชนใหม กางเกงเอวยางยด Shield Tech สำหรบผชายและผหญง 3 แบบ (ความยาว 7 สวน)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S34dcd05cfae1466abdbe58853044d155T.png_200x200q90.png",
        "price": 2230.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16092450852.html",
        "sold": 0
    },
    {
        "product_name": "🎄【Special price】🎄Shao รูปปั้นเป็ดพลังงานแสงอาทิตย์ทำจากเรซินโคมไฟพลังงานแสงอาทิตย์ส่องสว่างมากโคมไฟพลังงานแสงอาทิตย์ใช้ในสวนไฟ LED รูปสัตว์กลางแจ้งประหยัดพลังงาน",
        "product_image": "https://img.lazcdn.com/g/p/04b450dd849e449c87456170a1081f59.jpg_200x200q90.jpg",
        "price": 2229.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16115085239.html",
        "sold": 0
    },
    {
        "product_name": "BOSTO เครื่องยับยั้งนกกลางแจ้งอุปกรณ์ยับยั้งนก Scarer พลังงานแสงอาทิตย์สำหรับสวนหลังบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/6d12d188ea1eaecd38af3b62256adb00.jpg_200x200q90.jpg",
        "price": 2220,
        "remark": "https://www.lazada.co.th/products/pdp-i16143872208.html",
        "sold": 0
    },
    {
        "product_name": "GARRYFIZH เครื่องยับยั้งนกกลางแจ้งอุปกรณ์ยับยั้งนก Scarer พลังงานแสงอาทิตย์สำหรับสวนหลังบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/fec5f1f7b99ffbe7ec0159b38e5b1d4a.jpg_200x200q90.jpg",
        "price": 2214,
        "remark": "https://www.lazada.co.th/products/pdp-i16146642301.html",
        "sold": 0
    },
    {
        "product_name": "Oudain 4 Pcs 4 ft Halloween Medieval Fantasy Pull-down Banner with Lion Design Hanging Party Bunting Banner Medieval Party Decorations Garden Cutouts Flag for Castle Theme Festival Birthday Decor",
        "product_image": "https://img.lazcdn.com/g/p/463813c16c5e1add152867ea35698f63.jpg_webp_200x200q90.jpg",
        "price": 2212.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5922682959.html",
        "sold": 0
    },
    {
        "product_name": "รถของเล่นสวนผลไม้อเนกประสงค์สำหรับบ้านการนับเพื่อการศึกษารถของเล่นวางซ้อนกัน",
        "product_image": "https://img.lazcdn.com/g/p/7abb3f52b0e77b76ab39e2abb43e7c47.jpg_200x200q90.jpg",
        "price": 2212,
        "remark": "https://www.lazada.co.th/products/pdp-i6019718789.html",
        "sold": 0
    },
    {
        "product_name": "สายคล้องปีนต้นไม้อะลูมิเนียม + โพลีเอสเตอร์สำหรับงานสวนต้นไม้บนปีนต้นไม้",
        "product_image": "https://img.lazcdn.com/g/p/b049ce1f5ea2aaf6116fc92c46b7cc36.jpg_200x200q90.jpg",
        "price": 2208,
        "remark": "https://www.lazada.co.th/products/pdp-i5784608989.html",
        "sold": 0
    },
    {
        "product_name": "Dream nylone รูปปั้นเป็ดพลังงานแสงอาทิตย์ทำจากเรซินโคมไฟพลังงานแสงอาทิตย์ส่องสว่างมากโคมไฟพลังงานแสงอาทิตย์ใช้ในสวนไฟ LED รูปสัตว์กลางแจ้งประหยัดพลังงาน",
        "product_image": "https://img.lazcdn.com/g/p/c6778e71974d777f7134501e92f17322.jpg_200x200q90.jpg",
        "price": 2203.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16139024195.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟพลังงานแสงอาทิตย์แอพพลิเคชั่นกว้างโคมไฟแขวนพลังงานแสงอาทิตย์กันน้ำสำหรับลานบ้านสำหรับสวน",
        "product_image": "https://img.lazcdn.com/g/p/f177bf15e26c57aa9ae81da62ce6cff2.jpg_200x200q90.jpg",
        "price": 2154,
        "remark": "https://www.lazada.co.th/products/pdp-i16125196710.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟแขวนพลังงานแสงอาทิตย์โคมไฟตกแต่งพลังงานแสงอาทิตย์โคมไฟอบอุ่น LED ประยุกต์กว้างสำหรับวิลล่าสำหรับสวน",
        "product_image": "https://img.lazcdn.com/g/p/f177bf15e26c57aa9ae81da62ce6cff2.jpg_200x200q90.jpg",
        "price": 2154,
        "remark": "https://www.lazada.co.th/products/pdp-i16124819742.html",
        "sold": 0
    },
    {
        "product_name": "TOOYFUL ถุงเย็นฉนวนอเนกประสงค์ชั้นสองสำหรับการตั้งแคมป์สวนการเดินทางปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/5e590c6049412abf6c0f17c5f056c5ce.jpg_200x200q90.jpg",
        "price": 2148,
        "remark": "https://www.lazada.co.th/products/pdp-i6007721823.html",
        "sold": 0
    },
    {
        "product_name": "ชุดบอร์ดคอร์นโฮลชุดเกมกลางแจ้งคอร์นโฮลผ้าอ๊อกซ์ฟอร์ดแบบพกพากระเป๋าเก็บของหัวเข็มขัดสำหรับสวน",
        "product_image": "https://img.lazcdn.com/g/p/de749d195e2ce073e2b8b2c601be651d.jpg_200x200q90.jpg",
        "price": 2120,
        "remark": "https://www.lazada.co.th/products/pdp-i5852097940.html",
        "sold": 0
    },
    {
        "product_name": "Travel Folding Camping Stool, Outdoor Tripod Seat, Folding Camping Chairs,Fishing Chair for Camping Party Mountaineering Picnic Beach Garden Lawn",
        "product_image": "https://img.lazcdn.com/g/p/4fe547fb12a3223c288636722ed30685.jpg_webp_200x200q90.jpg",
        "price": 2083.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5768617813.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟพลังงานแสงอาทิตย์ขนาด300มิลลิแอมป์ต่อชั่วโมงสำหรับระเบียงทำจากพลาสติกเหล็กหวายแขวนในสวน",
        "product_image": "https://img.lazcdn.com/g/p/ea826daab763df500141c3769f2b8895.jpg_200x200q90.jpg",
        "price": 2078,
        "remark": "https://www.lazada.co.th/products/pdp-i6023217835.html",
        "sold": 0
    },
    {
        "product_name": "ERYUE Lampu Tenaga Surya แขวนอบอุ่นไฟสวนกลางแจ้งตกแต่งสำหรับสวนชาวบ้านแขวนโคมไฟพลังงานแสงอาทิตย์สำหรับการตกแต่งบ้านพลาสติกหวาย",
        "product_image": "https://img.lazcdn.com/g/p/882d699fff8a1bb0c691102e8d0ac1a4.jpg_200x200q90.jpg",
        "price": 2078,
        "remark": "https://www.lazada.co.th/products/pdp-i6024752406.html",
        "sold": 0
    },
    {
        "product_name": "Lohobby เก้าอี้เก้าอี้ชายหาดรองรับหลังเบาะพับได้ที่นั่งสำหรับสวนอาบแดดเดินป่าในเก้าอี้ชายหาด",
        "product_image": "https://img.lazcdn.com/g/p/370dccb87e83e86ed3f05aa5ec40eb4a.jpg_200x200q90.jpg",
        "price": 2074,
        "remark": "https://www.lazada.co.th/products/pdp-i5922214579.html",
        "sold": 0
    },
    {
        "product_name": "Jimdary Yosoo ไฟฉายพลังงานแสงอาทิตย์กลางแจ้งพร้อมเอฟเฟกต์ลึกลับ / แฟนตาซีเวลาแสงนานขึ้นและสองโหมดแสง - สวนพลังงานแสงอาทิตย์ 2 ชิ้นสำหรับปาร์ตี้ริมสระน้ำวัสดุ ABS ที่ทนทานสีดำ",
        "product_image": "https://img.lazcdn.com/g/p/bd8d34dd22fc31f8a90f7472999961a8.jpg_200x200q90.jpg",
        "price": 2054,
        "remark": "https://www.lazada.co.th/products/pdp-i16146705074.html",
        "sold": 0
    },
    {
        "product_name": "มุ้งคาร์ซีตสำหรับเด็ก Lohobby Wagon สำหรับสวนท่อเหลี่ยม1.5ซม. กันสาดแบบผลักสำหรับปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/8928c0cb53816efea3190b79dcc80731.jpg_200x200q90.jpg",
        "price": 2040,
        "remark": "https://www.lazada.co.th/products/pdp-i16097443950.html",
        "sold": 0
    },
    {
        "product_name": "สายสวนปัสสาวะแมว สายสวนแมว 1.0 1.3 มม. 12 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/f8e9be8649f69c889d34446772339c30.jpg_200x200q90.jpg",
        "price": 2038.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5936818322.html",
        "sold": 0
    },
    {
        "product_name": "รั้วสวนหย่อม 6 ชิ้น สีดำ แต่งสวน สีดำ 50x195cm ซม  รั้วต้นไม้ รั้วตกแต่งสวน 6 Panel Garden Fence Metal Decor Lawn Border Climbing Plants Edge Landscaping Interlocking รั้วสวนเหล็ก",
        "product_image": "https://img.lazcdn.com/g/p/f66fdb1cc3a62fa5b0b7f2f322aea734.jpg_200x200q90.jpg",
        "price": 2022.42,
        "remark": "https://www.lazada.co.th/products/pdp-i4869152041.html",
        "sold": 32
    },
    {
        "product_name": "เก้าอี้สนามลายพรางเก้าอี้ตั้งแคมป์บนต้นไม้เปลญวนน้ำหนักเบาสวิงซีทสำหรับการเดินป่าในสวนกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/1dde6efcc369e086b8ef3748d2b5e1a6.jpg_200x200q90.jpg",
        "price": 1984,
        "remark": "https://www.lazada.co.th/products/pdp-i5973374460.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้สนามที่นั่งเปลญวนขนาดกะทัดรัดบนต้นไม้ลายพราง Deevoka สวิงซีทเก้าอี้ตั้งแคมป์บนต้นไม้สำหรับนกพิราบกวางชายหาดแบกเป้สวน",
        "product_image": "https://img.lazcdn.com/g/p/143ec5a1514400941b4bbc96c0f362e3.jpg_200x200q90.jpg",
        "price": 1984,
        "remark": "https://www.lazada.co.th/products/pdp-i5968833357.html",
        "sold": 0
    },
    {
        "product_name": "Baoblaze เครื่องบินขับเคลื่อนด้วยความยืดหยุ่นแบบพกพาเครื่องบินขับเคลื่อนด้วยหนังยางสำหรับงานปาร์ตี้วันเกิดในสวน",
        "product_image": "https://img.lazcdn.com/g/p/0c44e493573d0c5c8581a8060ca2abb5.jpg_200x200q90.jpg",
        "price": 1960,
        "remark": "https://www.lazada.co.th/products/pdp-i6044991721.html",
        "sold": 0
    },
    {
        "product_name": "ยูวีหลักฐานเรือใบบังแดดขนาด3X4ม. พับได้พกพาระบายอากาศได้มีรูบังแดดสำหรับสวนผลไม้",
        "product_image": "https://img.lazcdn.com/g/p/300743f6b67eb88fd46790d57d7fe1b5.jpg_200x200q90.jpg",
        "price": 1930,
        "remark": "https://www.lazada.co.th/products/pdp-i6004570521.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเกมสำหรับสวนหลังบ้านแบบยายพร้อมกางเกงขนาดใหญ่และลูกบอลสำหรับเล่น",
        "product_image": "https://img.lazcdn.com/g/p/9cc09273516488c1cde895c2870977c3.jpg_200x200q90.jpg",
        "price": 1926,
        "remark": "https://www.lazada.co.th/products/pdp-i16122529862.html",
        "sold": 0
    },
    {
        "product_name": "Kodaily รองเท้าเหยื่อตกปลาแบบเท้าบูทยาวทำจากพีวีซีสำหรับทำสวนเกษตร",
        "product_image": "https://img.lazcdn.com/g/p/7e23122b8969d5e7baf56f1a6c135466.jpg_200x200q90.jpg",
        "price": 1892.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16119406912.html",
        "sold": 0
    },
    {
        "product_name": "ตะกร้าจักรยานทอด้านหน้าบัมเปอร์โลหะวิลโลว์สำหรับลูกสุนัขตะกร้าจักรยานใช้งานได้จริง",
        "product_image": "https://img.lazcdn.com/g/p/4611bb1ef6dec3fc45dffccf13546072.jpg_200x200q90.jpg",
        "price": 1878,
        "remark": "https://www.lazada.co.th/products/pdp-i6062762335.html",
        "sold": 0
    },
    {
        "product_name": "ตะกร้าจักรยานตะกร้าจักรยานสุนัขด้านหน้ากันน้ำที่มีสไตล์เชื่อมต่ออย่างแน่นหนาสำหรับสวน",
        "product_image": "https://img.lazcdn.com/g/p/4611bb1ef6dec3fc45dffccf13546072.jpg_200x200q90.jpg",
        "price": 1878,
        "remark": "https://www.lazada.co.th/products/pdp-i6056418448.html",
        "sold": 0
    },
    {
        "product_name": "Mobi Garden | เก้าอี้พับได้สำหรับกลางแจ้งปรับระดับได้พนักพิงสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S99c11c425a7a48c49178026303a0116cI.jpg_200x200q90.jpg",
        "price": 1866,
        "remark": "https://www.lazada.co.th/products/pdp-i16065292461.html",
        "sold": 0
    },
    {
        "product_name": "FENGCHISHI | ชุดอุปกรณ์ทำสวน ขุด เก็บใบไม้ ปลูก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S874e4a81b20c4e4ca19d065b739d566ap.jpg_200x200q90.jpg",
        "price": 1847.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16103266405.html",
        "sold": 0
    },
    {
        "product_name": "ธงกอล์ฟ Flameer พร้อมถ้วยและเสาฝึก3ส่วนสำหรับสวนสนามหญ้าและระยะขับรถ",
        "product_image": "https://img.lazcdn.com/g/p/ebfab66a733f21d524abc9ac80f42f93.jpg_200x200q90.jpg",
        "price": 1797.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6076846367.html",
        "sold": 0
    },
    {
        "product_name": "【พิเศษ】เพิ่มความจุของเกวียนในสวนของคุณได้อย่างง่ายดายด้วยกระเป๋าข้างรถเข็นที่ใช้งานได้จริง",
        "product_image": "https://img.lazcdn.com/g/p/260dd58734474b8c1f5b7a93fbaa7ed6.jpg_200x200q90.jpg",
        "price": 1786,
        "remark": "https://www.lazada.co.th/products/pdp-i6006063529.html",
        "sold": 0
    },
    {
        "product_name": "Joy Jia น้ำเสียบผมแบบมีธรรมชาติที่ให้ความรู้สึกถึงความเป็นกลาง น้ำเสียบผมเพื่อการดูแลผมที่ไร้ซิลิโคน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6f525422536b4383b4031b36b44c0e1cP.png_200x200q90.png",
        "price": 1782,
        "remark": "https://www.lazada.co.th/products/pdp-i16092504304.html",
        "sold": 0
    },
    {
        "product_name": "สนามกีฬาที่สามารถเคลื่อนย้ายได้สำหรับการเปิดยอดการจัดเก็บหนาแน่นเหมาะสำหรับโรงเรียนการต่อสู้ในสวนความบันเทิงสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/c2834115c786f83efe2c91bf93f32417.jpg_200x200q90.jpg",
        "price": 1767.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6009563382.html",
        "sold": 0
    },
    {
        "product_name": "【Innovative】 Mini Japanese Natural Stone Lanterns Granite Stone Pagoda For Garden",
        "product_image": "https://img.lazcdn.com/g/p/b70594c968706cc889598e2380408646.jpg_200x200q90.jpg",
        "price": 1755.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5822963257.html",
        "sold": 2
    },
    {
        "product_name": "สวนแขวนโคมไฟพลังงานแสงอาทิตย์แสงอบอุ่นโคมไฟพลังงานแสงอาทิตย์กลางแจ้ง 300mAh ปุ่มสวิทช์สำหรับระเบียง",
        "product_image": "https://img.lazcdn.com/g/p/ea826daab763df500141c3769f2b8895.jpg_200x200q90.jpg",
        "price": 1748,
        "remark": "https://www.lazada.co.th/products/pdp-i16124867410.html",
        "sold": 0
    },
    {
        "product_name": "ติดตั้งอย่างรวดเร็วมุ้งกันยุงเหมาะกับชิงช้าในสวนตั้งแคมป์กันน้ำตาตาข่ายโพลีเอสเตอร์ดีไซน์ประหยัดพื้นที่กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/8364b48821dec6d77a5e5f13ac734344.jpg_200x200q90.jpg",
        "price": 1458,
        "remark": "https://www.lazada.co.th/products/pdp-i16109876742.html",
        "sold": 0
    },
    {
        "product_name": "กริ่งหน้าประตูสไตล์วินเทจสำหรับบ้านระเบียงสวนในฟาร์มรูปปั้นตกแต่งศิลปะระฆังอาหารมื้อค่ำด้วยมือ",
        "product_image": "https://img.lazcdn.com/g/p/0a3e037fe9bacd10c065efbbd394a86d.jpg_200x200q90.jpg",
        "price": 1722,
        "remark": "https://www.lazada.co.th/products/pdp-i6011003487.html",
        "sold": 0
    },
    {
        "product_name": "Solar Energy led Colorful ball lights for outdoor waterproof landscape lawn decoration, floor-standing luminous ball lights for garden lighting",
        "product_image": "https://img.lazcdn.com/g/p/f96f53869cf09639554220baf98dc04e.jpg_webp_200x200q90.jpg",
        "price": 1693.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16146572242.html",
        "sold": 0
    },
    {
        "product_name": "แบนเนอร์โพลีเอสเตอร์ 2D แบบแบน 1 ชิ้น - ลายกำแพงหินพร้อมพืชสีเขียวเข้มและไม้อวบน้ำ เหมาะสำหรับบ้าน สวน และงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa3287d1243f740278d6e4daedfe7f8b99.jpg_200x200q90.jpg",
        "price": 1686.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16095881817.html",
        "sold": 0
    },
    {
        "product_name": "ไม้แขวนตะเกียงตั้งแคมป์ Koolsoo เสาโคมไฟพับได้สำหรับตั้งแคมป์ BBQ ปิกนิกสวน",
        "product_image": "https://img.lazcdn.com/g/p/af129d3c45d6b3fef64410aa2db9e4dc.jpg_200x200q90.jpg",
        "price": 1686,
        "remark": "https://www.lazada.co.th/products/pdp-i5973274320.html",
        "sold": 0
    },
    {
        "product_name": "STYLE HAUL ลาน สวน ในร่มกลางแจ้ง ระเบิด พร้อมไฟ LED หมุนได้ ส่องสว่าง ตกแต่งคริสต์มาส ตุ๊กตาโคมไฟ ของเล่นบอลลูน ตุ๊กตาหิมะพอง",
        "product_image": "https://img.lazcdn.com/g/p/6f8c88f31a4fb81087b3371824f8f6e7.jpg_200x200q90.jpg",
        "price": 1678,
        "remark": "https://www.lazada.co.th/products/pdp-i5947519505.html",
        "sold": 0
    },
    {
        "product_name": "ถังแบบพกพาที่เหมาะสำหรับผู้เชี่ยวชาญด้านการทำสวนโดยมีชุดประกอบฟรีเหมาะสำหรับการปฏิบัติการสนาม",
        "product_image": "https://img.lazcdn.com/g/p/2c307cc4fb4c07ad6d93d54ac572de98.jpg_200x200q90.jpg",
        "price": 1674,
        "remark": "https://www.lazada.co.th/products/pdp-i16112113801.html",
        "sold": 0
    },
    {
        "product_name": "Ravensburger ยินดีต้อนรับสู่สวนสัตว์ (ปริศนา2X24ชิ้น)",
        "product_image": "https://img.lazcdn.com/g/p/7ec17426993595386f5936bc302b886c.jpg_200x200q90.jpg",
        "price": 1658,
        "remark": "https://www.lazada.co.th/products/pdp-i4837113921.html",
        "sold": 0
    },
    {
        "product_name": "จอบปลอมที่จับบีชน้ำหนักเบาเครื่องมือทำสวนรถแบบเรียบง่ายใช้งานได้จริงสแตนเลสดีสำหรับทำสวนสำหรับภูมิทัศน์กระถางต้นไม้",
        "product_image": "https://img.lazcdn.com/g/p/82766bfc48b2850f5e808913813d2831.jpg_200x200q90.jpg",
        "price": 1652,
        "remark": "https://www.lazada.co.th/products/pdp-i6033476426.html",
        "sold": 0
    },
    {
        "product_name": "SXH  Solar pillar light outdoor waterproof moon lamp for home villa courtyard wall light garden pillar doorpost lighting with upgraded colorful lights",
        "product_image": "https://img.lazcdn.com/g/p/364785cfa9b172b40e74587ebca7126e.jpg_webp_200x200q90.jpg",
        "price": 1634.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16145967953.html",
        "sold": 0
    },
    {
        "product_name": "แบนเนอร์ภูมิทัศน์ปราสาทสวนมหัศจรรย์ เหมาะสำหรับวันเกิด วันหยุด งานปาร์ตี้ มีหลายขนาดให้เลือก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7990f81057ee4237955e87e66acfd00eh.jpg_200x200q90.jpg",
        "price": 1597.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16096208222.html",
        "sold": 0
    },
    {
        "product_name": "กันสาดกันน้ำ 17 สี ผ้าบังแดด สำหรับสวน ชายหาด ตั้งแคมป์ ระเบียง สระว่ายน้ำ เต็นท์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S73d3448c34d6485f9740850a1df93231s.jpg_200x200q90.jpg",
        "price": 1584.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16099383524.html",
        "sold": 0
    },
    {
        "product_name": "EFFIEO ลาน สวน ปลั๊กสหรัฐ ระเบิด ส่องสว่าง พร้อมไฟ LED หมุนได้ ตุ๊กตาโคมไฟ ตุ๊กตาหิมะพอง ตกแต่งคริสต์มาส ของเล่นบอลลูน",
        "product_image": "https://img.lazcdn.com/g/p/e34cd85718cbeeaffc38c399ad864b13.jpg_200x200q90.jpg",
        "price": 1580,
        "remark": "https://www.lazada.co.th/products/pdp-i5967099277.html",
        "sold": 1
    },
    {
        "product_name": "Phenovo ผ้าม่านสำหรับความเป็นส่วนตัวเรืออเนกประสงค์ใช้งานได้จริงทนทานติดตั้งง่ายติดตั้งได้ง่ายสำหรับการเดินทางสวนหลังบ้านตั้งแคมป์ชายหาดว่ายน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/2eb17a7a1d28a2aba3c4b90017e3fcb7.jpg_200x200q90.jpg",
        "price": 1572,
        "remark": "https://www.lazada.co.th/products/pdp-i5988883563.html",
        "sold": 0
    },
    {
        "product_name": "Nafurno RiToEasysports ไฟริบหรี่โคมไฟพลังงานแสงอาทิตย์ LED แบบชาร์จแขวนตกแต่งโคมไฟพลังงานแสงอาทิตย์พร้อมแบตเตอรี่ 1500mAh สำหรับลานสวนกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/567dc41d7d914eaba06505e26c051f85.jpg_200x200q90.jpg",
        "price": 1554,
        "remark": "https://www.lazada.co.th/products/pdp-i16146557455.html",
        "sold": 0
    },
    {
        "product_name": "ดอกไม้คลุมสวน Fityle",
        "product_image": "https://img.lazcdn.com/g/p/fd96637910962e0e584caaf80116d145.jpg_200x200q90.jpg",
        "price": 1554,
        "remark": "https://www.lazada.co.th/products/pdp-i6034749005.html",
        "sold": 0
    },
    {
        "product_name": "สวนผลไม้รถของเล่นไม้สนสำหรับบ้านทารกนับรถของเล่นอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/p/2ac8574355c10447d85bb26605245722.jpg_200x200q90.jpg",
        "price": 1554,
        "remark": "https://www.lazada.co.th/products/pdp-i6038309815.html",
        "sold": 0
    },
    {
        "product_name": "หฟงเกมมงแบบมสายชนดแยกสวน Lu Mi",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3435ab4ac12b403494a517e18af2ed2dT.png_200x200q90.png",
        "price": 1551.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16118014437.html",
        "sold": 0
    },
    {
        "product_name": "รถเครื่องมือทำสวนจอบปลอมขนาดเล็กฝีมือดีง่ายเหมาะสำหรับภูมิทัศน์กระถางต้นไม้ทำสวน",
        "product_image": "https://img.lazcdn.com/g/p/d8a3f95b8c8714ce30ba445d6485a4f1.jpg_200x200q90.jpg",
        "price": 1542,
        "remark": "https://www.lazada.co.th/products/pdp-i6015172421.html",
        "sold": 0
    },
    {
        "product_name": "led Luminous Sphere Light Outdoor Waterproof Solar Garden Lawn Decorative Light Landscape Lighting Atmosphere Sphere Light",
        "product_image": "https://img.lazcdn.com/g/p/daa68a68e135ade738fd7802b190ecce.jpg_webp_200x200q90.jpg",
        "price": 1540.94,
        "remark": "https://www.lazada.co.th/products/pdp-i16146063229.html",
        "sold": 0
    },
    {
        "product_name": "MAOMEI รวดเร็วรวดเร็วมาก สำหรับการหยิบขึ้นมา เกาลัดเกาลัด เครื่องมือคู่มือกลางแจ้ง เครื่องมือสำหรับสวน ปรับได้ปรับได้ นักสะสมเกาลัด น็อตเก็บถั่ว ที่หยิบผลไม้แบบม้วน เครื่องเก็บเกี่ยวถั่ว ที่หยิบลูกบอล เครื่องมือเก็บผลไม้ นักสะสมลูกบอล",
        "product_image": "https://img.lazcdn.com/g/p/b3d4e36bfcbb40fb6997bf88b6bbcd5c.jpg_200x200q90.jpg",
        "price": 1534,
        "remark": "https://www.lazada.co.th/products/pdp-i16146823445.html",
        "sold": 0
    },
    {
        "product_name": "ป้ายต้อนรับเด็ก 3 ชิ้น ป้ายดอกไม้ ป้ายดอกไม้ป่า ตกแต่งงานเลี้ยงเด็ก ตกแต่งดอกไม้ใบไม้ ป้ายเกิดเด็ก ป้ายวันเกิดดอกไม้ป่า สำหรับตกแต่งสวน ผนังฉากหลัง ภายในและภายนอก",
        "product_image": "https://img.lazcdn.com/g/p/d42d55f2dc06843d73ef2e930d51515d.jpg_webp_200x200q90.jpg",
        "price": 1515.44,
        "remark": "https://www.lazada.co.th/products/pdp-i6047853286.html",
        "sold": 0
    },
    {
        "product_name": "Menolana ดาวว่าวห้าแฉกน่ารักว่าวบินของเล่นชายหาดสวนท่องเที่ยวแบบครอบครัวกิจกรรมกลางแจ้งสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/34203df0c9c23c7cd5ac1823ad4c7d7e.jpg_200x200q90.jpg",
        "price": 1507.12,
        "remark": "https://www.lazada.co.th/products/pdp-i6062861047.html",
        "sold": 0
    },
    {
        "product_name": "LECAN | กรรไกรตัดกิ่งขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf770c2fabdcf488fab708a6001c06f681.jpg_200x200q90.jpg",
        "price": 1505.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5933105274.html",
        "sold": 0
    },
    {
        "product_name": "Jimdary เต็นท์บังแดดกลางแจ้งสวิงหลังคาสำหรับระเบียงสวนและลานบ้าน – ฝาครอบสวิงกันฝนและกันหิมะสำหรับงานหนัก (สีแดง)",
        "product_image": "https://img.lazcdn.com/g/p/e49cb0cb84e5657056e3cf2b1e2fbe97.jpg_200x200q90.jpg",
        "price": 1502,
        "remark": "https://www.lazada.co.th/products/pdp-i16146482557.html",
        "sold": 0
    },
    {
        "product_name": "อุปกรณ์ปีนเขาบนดวงจันทร์เบา8.9kN สำหรับช่วยสวนต้นไม้กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/b278566e58d4c79c7585c7e0110d8582.jpg_200x200q90.jpg",
        "price": 1502,
        "remark": "https://www.lazada.co.th/products/pdp-i5983457602.html",
        "sold": 0
    },
    {
        "product_name": "ภาชนะพกพาน้ำหนักเบาพร้อมซีลที่ปลอดภัยสำหรับการขนส่งและการใช้งานง่ายโดยชาวสวนรวมถึงผู้สูงอายุ",
        "product_image": "https://img.lazcdn.com/g/p/d5d234e9c7885fd35c6955546ac1a2bd.jpg_200x200q90.jpg",
        "price": 1498,
        "remark": "https://www.lazada.co.th/products/pdp-i6012829257.html",
        "sold": 0
    },
    {
        "product_name": "1 ชิ้น \"ผ้าพื้นหลังโค้งโรแมนติกคลาสสิก สร้างโอเอซิสสวนยุโรป แบนเนอร์ปาร์ตี้ หลายขนาด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S308ef78689594d26bceb296005fe3871v.jpg_200x200q90.jpg",
        "price": 1496.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16099562593.html",
        "sold": 0
    },
    {
        "product_name": "ที่เก็บของทำสวนถุงเครื่องมือสวนพร้อมเส้นด้ายโพลีเอสเตอร์กระเป๋ากระเป๋าเก็บของกระเป๋าเครื่องสำอางขนาดใหญ่สำหรับการบำรุงรักษาสวน",
        "product_image": "https://img.lazcdn.com/g/p/371f86161f57a7de9d7cf2d9ff5629fa.jpg_200x200q90.jpg",
        "price": 1480,
        "remark": "https://www.lazada.co.th/products/pdp-i16099910414.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟเรโทรจากแสงอาทิตย์คุณภาพไฟแอลอีดีแบบแขวนวัสดุโลหะบรรยากาศอบอุ่นประหยัดพลังงานแบตเตอรี่เอเอ MAh 600สำหรับงานเลี้ยงลานสวน",
        "product_image": "https://img.lazcdn.com/g/p/af2aa26757f5eba48a3e45f9e89c814a.jpg_200x200q90.jpg",
        "price": 1448,
        "remark": "https://www.lazada.co.th/products/pdp-i6023126747.html",
        "sold": 0
    },
    {
        "product_name": "ไฟพลังงานแสงอาทิตย์ทำจากโลหะกลางแจ้งกันน้ำโคมไฟแบบแขวนพลังงานแสงอาทิตย์พร้อมตะขอสำหรับนอกบ้านสวนระเบียงด้านนอก",
        "product_image": "https://img.lazcdn.com/g/p/b97dc0e967732aae2d9bd2a29d9d35b7.jpg_200x200q90.jpg",
        "price": 1446,
        "remark": "https://www.lazada.co.th/products/pdp-i16129503350.html",
        "sold": 0
    },
    {
        "product_name": "【HOT】 Transparent Haircut Apron Replacement Barbershop Durable Gardening Apron Waterproof Dog Grooming Bib",
        "product_image": "https://img.lazcdn.com/g/p/90037ca990fdd9d47853ae8465f5b90d.png_200x200q90.png",
        "price": 1442,
        "remark": "https://www.lazada.co.th/products/pdp-i16146790572.html",
        "sold": 0
    },
    {
        "product_name": "Mobi Garden | ไม้เท้าเดินป่าคาร์บอนยืดหดได้น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf687498986be40dfb264e14dce4a2b0dc.jpg_200x200q90.jpg",
        "price": 1431.92,
        "remark": "https://www.lazada.co.th/products/pdp-i6016530030.html",
        "sold": 42
    },
    {
        "product_name": "เครื่องทำสเลอปี้SLUSH MACHINE 3โถ12ลิตรX-450สินค้าใหม่ๆต้องสั่งเบิกจากศูนย์แท้ๆ100%PREORDERฟรีSOUNDBARลำโพงบูลทูธพกพา",
        "product_image": "https://img.lazcdn.com/g/p/5fe9c347385513eea44f58d8c98178dc.jpg_200x200q90.jpg",
        "price": 507366,
        "remark": "https://www.lazada.co.th/products/pdp-i16086849654.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องชงกาแฟขนาด 2 หัวชง Commercial coffee machine",
        "product_image": "https://img.lazcdn.com/g/p/3bf8bdaee14b01f700c685dc0d5b9e84.jpg_200x200q90.jpg",
        "price": 168000,
        "remark": "https://www.lazada.co.th/products/pdp-i5862017381.html",
        "sold": 0
    },
    {
        "product_name": "รอกเบท  อาบู การ์เซีย AMB 6500CS URSPRUNG และ นาฬิกา อาบู การ์เซีย รุ่น แอมบาสเดอร์ 1000 เมตร เพื่อเป็นการเฉลิมฉลองครบ 100 ปี อาบู การ์เซีย",
        "product_image": "https://img.lazcdn.com/g/p/020fc82d2fb9cf372b06dda4edcc9229.jpg_200x200q90.jpg",
        "price": 99800,
        "remark": "https://www.lazada.co.th/products/pdp-i4458678539.html",
        "sold": 0
    },
    {
        "product_name": "i POWER เครื่องยนต์ ดีเซล 2 สูบ รุ่น AP2V88F เครื่องยนต์ 4 จังหวะ / 20HP/ 3600 รอบ/นาที (กุญแจสตาร์จ) เครื่องยนต์",
        "product_image": "https://img.lazcdn.com/g/p/26161e5e84efa1c81cd7102ab8f6b8af.jpg_200x200q90.jpg",
        "price": 90000,
        "remark": "https://www.lazada.co.th/products/pdp-i4756767310.html",
        "sold": 0
    },
    {
        "product_name": "KANTO เครื่องปั่นไฟ ดีเซล รุ่น KT-YAMA-D5-SILENT 5500วัตต์ 10HP เสียงเงียบ ประหยัดน้ำมัน เครื่อง 4 จังหวะ1สูบ ปั่นไฟ ส่ง Flash Express (ของแถม)",
        "product_image": "https://img.lazcdn.com/g/p/3e4c4e8352c557414bcac1ec11b4c51c.jpg_200x200q90.jpg",
        "price": 79000,
        "remark": "https://www.lazada.co.th/products/pdp-i4530258856.html",
        "sold": 0
    },
    {
        "product_name": "De'Longhi Magnifica Evo 290.81 เครื่องชงกาแฟเอสเปรสโซอัตโนมัติ รุ่น ECAM 290.81.TB",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S77e9ddacec5c4723a776d9104ce286c3c.jpg_200x200q90.jpg",
        "price": 78000,
        "remark": "https://www.lazada.co.th/products/pdp-i5666762065.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องมิลลิ่ง 16 mm. ( Milling machine ) MEGA รุ่น XJ9512/N รับประกันสินค้า 1 ปี By mcmachinetools",
        "product_image": "https://img.lazcdn.com/g/p/37955c956a91eee7012726ea1aa2edae.jpg_200x200q90.jpg",
        "price": 75304,
        "remark": "https://www.lazada.co.th/products/pdp-i5535969638.html",
        "sold": 1
    },
    {
        "product_name": "Daiwa | รอกตกปลาไฟฟ้าสำหรับทะเลลึก เรือ และปลาใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S182aec5b785b4f15b90bff3eadbdadc9Q.png_200x200q90.png",
        "price": 72033.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6003392400.html",
        "sold": 0
    },
    {
        "product_name": "A-i-POWER 🚚 เครื่องปั่นไฟ เบนซิน รุ่น IN13000CEW 220V 7500วัตต์ **ทักแชทก่อนกดสั่งซื้อนะคะ** 16แรงม้า ลานดึงสตาร์ท/กุญแจสตาร์ท GENERATOR ปั่นไฟ เครื่องกำเนิดไฟ",
        "product_image": "https://img.lazcdn.com/g/p/9f720848580db73f3bea895b92f24fa4.jpg_200x200q90.jpg",
        "price": 69392,
        "remark": "https://www.lazada.co.th/products/pdp-i4209319088.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องชงกาแฟราคาพิเศษสุด Breville BES878 \"the Barista Pro\"",
        "product_image": "https://img.lazcdn.com/g/p/1e3efdcd211a8c80848f13faf397b93e.jpg_200x200q90.jpg",
        "price": 65800,
        "remark": "https://www.lazada.co.th/products/pdp-i2886166610.html",
        "sold": 10
    },
    {
        "product_name": "DeLonghi | เครื่องชงกาแฟอีสเปรสโซอัตโนมัติสำหรับบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf71ddd2f29bd4b3fbcf346cd36533c8eA.png_200x200q90.png",
        "price": 61098.84,
        "remark": "https://www.lazada.co.th/products/pdp-i6017872221.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องหั่นผักสายพาน 660 เครื่องหั่นผัก เครื่องหั่นข่า ตะไคร้ ในตัวเดียวกัน",
        "product_image": "https://img.lazcdn.com/g/p/f8cb0b93fd442e1200a5850a0a2f68bc.jpg_200x200q90.jpg",
        "price": 60000,
        "remark": "https://www.lazada.co.th/products/pdp-i2785464383.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำน้ำแข็งอัตโนมัติ ULKA รุ่น 45M  น้ำแข็งทรงพระจันทร์เสี้ยว เครื่องทำน้ำแข็งขนาดใหญ่ เครื่องผลิตน้ำแข็ง 64ก้อน/50กิโลกรัมต่อวัน",
        "product_image": "https://img.lazcdn.com/g/p/bc96bfb6869d2e77e3266eb9f8bbb7c7.png_200x200q90.png",
        "price": 59800,
        "remark": "https://www.lazada.co.th/products/pdp-i5325077414.html",
        "sold": 0
    },
    {
        "product_name": "MONTA เครื่องสูบน้ำดีเซล  MT-WP60DES  ท่อน้ำเข้าออก 6 นิ้ว เครื่องยนต์ 15 แรงม้า ส่งสูง 15 ม. ปริมาณน้ำ 200 Q  ระบบสตาร์ทด้วยกุญแจ ปั๊มน้ำ สูบน้ำ ดูดน้ำ ของแท้ สินค้าพร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/p/90d853ef2623f18c8d0fb5adfadf6129.png_200x200q90.png",
        "price": 59800,
        "remark": "https://www.lazada.co.th/products/pdp-i16075757177.html",
        "sold": 0
    },
    {
        "product_name": "Ryobi AD 100 High Power  12v Big Game Electric Reel",
        "product_image": "https://img.lazcdn.com/g/p/dbd2a5042299e178a9abed152ae4b9fd.jpg_200x200q90.jpg",
        "price": 59000,
        "remark": "https://www.lazada.co.th/products/pdp-i3651063971.html",
        "sold": 0
    },
    {
        "product_name": "Megabass | ไม้ตกปลาหลายประโยชน์สำหรับเหยื่อแข็ง ปลาเปรช ปลาแบส และการขว้างไกล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S166725010aee4eb99c9244a3ed27b253t.jpg_200x200q90.jpg",
        "price": 52907.96,
        "remark": "https://www.lazada.co.th/products/pdp-i6003419180.html",
        "sold": 0
    },
    {
        "product_name": "🧡เทสก่อนส่ง🧡เครื่องปั่นไฟเบนซิน ระบบ INVERTER 4 จังหวะ 5.5 KW สตาร์ท 2 ระบบ มือ/ไฟฟ้า PUMPKIN รุ่น PTT-G5550EiS (44388)",
        "product_image": "https://img.lazcdn.com/g/p/8983f3f56aee14cdc4e27e988d9c0097.jpg_200x200q90.jpg",
        "price": 51998,
        "remark": "https://www.lazada.co.th/products/pdp-i5951134003.html",
        "sold": 0
    },
    {
        "product_name": "De'Longhi | เครื่องชงกาแฟอัตโนมัติ รุ่น ECAM350.15.B",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sea1b98c8835e4857a19f6e12b29f60des.png_200x200q90.png",
        "price": 50783.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5958549743.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องยนต์เบนซิน เครื่องยนต์อเนกประสงค์ เครื่องยนต์ 2 สูบ V-TWIN  KAISER 688cc 24 แรงม้า KTM688E",
        "product_image": "https://img.lazcdn.com/g/p/c9a64b136447516e24c38975d121f8f4.jpg_200x200q90.jpg",
        "price": 49600,
        "remark": "https://www.lazada.co.th/products/pdp-i3709711042.html",
        "sold": 1
    },
    {
        "product_name": "SKG เครื่องชงกาแฟอัตโนมัติ (มีระบบดูดน้ำจากภายนอกเครื่อง) 3000W 1.6 ลิตร รุ่น CRM 3148",
        "product_image": "https://img.lazcdn.com/g/p/dff4bfa1b247944a8705dff46ffa528e.jpg_200x200q90.jpg",
        "price": 48966.54,
        "remark": "https://www.lazada.co.th/products/pdp-i5788277563.html",
        "sold": 3
    },
    {
        "product_name": "รับประกัน 1 ปี เครื่องปั้นลูกชิ้น แนวตั้ง เครื่องทำลุกชิ้น เครื่องทำลูกชิ้นปลา HL-280",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S578e61e168da46dd91640f4673595ff0a.jpg_200x200q90.jpg",
        "price": 48000,
        "remark": "https://www.lazada.co.th/products/pdp-i5600317324.html",
        "sold": 0
    },
    {
        "product_name": "รอกหยดน้ำ SHIMANO ANTARES DC 2021 Made in Japan รอบ 7.1:1 รุ่นท็อปสุด ของชิมาโน่",
        "product_image": "https://img.lazcdn.com/g/p/42860b103fb7a594954001b01b1d0e56.jpg_200x200q90.jpg",
        "price": 48000,
        "remark": "https://www.lazada.co.th/products/pdp-i4167586436.html",
        "sold": 0
    },
    {
        "product_name": "Jadever เครื่องปั่นไฟเบนซิน 7Kw รุ่น JDGEAA09 ระบบสตาร์ท รีคอยส์+ไฟฟ้า (Gasoline generator) เครื่องยนต์เบนซิน 4 จังหวะ",
        "product_image": "https://img.lazcdn.com/g/p/9e775df50357c1bbc1ed8846ff5ef00d.jpg_200x200q90.jpg",
        "price": 46300,
        "remark": "https://www.lazada.co.th/products/pdp-i5290880618.html",
        "sold": 0
    },
    {
        "product_name": "รอกหยดน้ำ ชิมาโน่ SHIMANO ANTARES DC ปี 2021 (มีทั้งหมุนขวาและหมุนซ้าย)",
        "product_image": "https://img.lazcdn.com/g/p/d3249d63a152c4ed7c8a897e87f62fc3.jpg_200x200q90.jpg",
        "price": 45800,
        "remark": "https://www.lazada.co.th/products/pdp-i5314174781.html",
        "sold": 0
    },
    {
        "product_name": "KEMAGE เครื่องปั่นไฟ เบนซิน INVERTER เครื่องยนต์ เบนซิน 4 จังหวะ กำลังไฟ 7.5 กิโลวัตต์ (มีกุญแจ และมือจับ+ล้อเข็น) รุ่น KM-INVT-7.5KW",
        "product_image": "https://img.lazcdn.com/g/p/b7ebf05ff14ee2ff9bbcfef16a595205.jpg_200x200q90.jpg",
        "price": 45300,
        "remark": "https://www.lazada.co.th/products/pdp-i4497391590.html",
        "sold": 0
    },
    {
        "product_name": "รอก SHIMANO TWIN POWER SW ปี 2016",
        "product_image": "https://img.lazcdn.com/g/p/91b15701b0fd36f5745dec5e7d5d0f0d.jpg_200x200q90.jpg",
        "price": 44000,
        "remark": "https://www.lazada.co.th/products/pdp-i4237775288.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องซักผ้าฝาหน้า รุ่น F2515SNEW ระบบ AI DD™ ความจุซัก 15 กก. AI DD™",
        "product_image": "https://img.lazcdn.com/g/p/776fdf4472e487a7660f1411fa685906.jpg_200x200q90.jpg",
        "price": 43900,
        "remark": "https://www.lazada.co.th/products/pdp-i5703161294.html",
        "sold": 183
    },
    {
        "product_name": "เครื่องสูบน้ำดีเซล TAZAWA D-MP20E ขนาด 2 นิ้ว | 10HP ส่งสูง 90เมตร กุญแจสตาร์ท พร้อมล้อเข็น",
        "product_image": "https://img.lazcdn.com/g/p/7ac947fdede68aa22ec2397487b1416b.jpg_200x200q90.jpg",
        "price": 43198,
        "remark": "https://www.lazada.co.th/products/pdp-i5781828694.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องกำเนิดไฟฟ้า POLO 6 KW (6000W) | เครื่องปั่นไฟ 14 แรงม้า | สตาร์ทไฟฟ้า (Electric Start) | ถังน้ำมันใหญ่ 25 ลิตร | รับประกัน 1 ปี #ผู้จัดจำหน่ายเดียวกับ MAKITA",
        "product_image": "https://img.lazcdn.com/g/p/6655c08a5641f71a1e193c192d190f21.jpg_200x200q90.jpg",
        "price": 43000,
        "remark": "https://www.lazada.co.th/products/pdp-i5056545605.html",
        "sold": 0
    },
    {
        "product_name": "Shimano | รอกตกปลาสำหรับน้ำจืดและน้ำเค็ม ใช้กับอุปกรณ์เบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6e79710b79f7439db427955b7068f55cN.jpg_200x200q90.jpg",
        "price": 41959.66,
        "remark": "https://www.lazada.co.th/products/pdp-i6003433156.html",
        "sold": 0
    },
    {
        "product_name": "Shimano | วงล้อตกปลาแสดงผลดิจิตอล200 /300PG /HG /MG /XG",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2e5ac7bb033e485c9a20073cb139f289y.jpg_200x200q90.jpg",
        "price": 41442.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6003352665.html",
        "sold": 3
    },
    {
        "product_name": "MITSUMAX เครื่องสูบน้ำ รุ่น DMX100KB 10แรงม้า 4X4นิ้ว (กุญแจสตาร์ท/ลานสตาร์ท) เครื่องยนต์ 4จังหวะ ดูดลึก 8เมตร HAEDMAX 31เมตร DIESEL WATER PUMP เครื่องยนต์ชนปั๊ม เครื่องยนต์สูบน้ำ ดูดน้ำ ปั๊มสูบน้ำ จัดส่งทั่วประเทศไทย",
        "product_image": "https://img.lazcdn.com/g/p/47a423b9e37e9d259d527592ad018525.jpg_200x200q90.jpg",
        "price": 39980,
        "remark": "https://www.lazada.co.th/products/pdp-i5938042267.html",
        "sold": 0
    },
    {
        "product_name": "POLO เครื่องปั่นไฟ เบนซิน กำลังไฟ 5.0 กิโลวัตต์ กำลังเครื่องยนต์ 13 แรงม้า รุ่น KT6600DDC กระบอกสูบ 389 มล. ถังน้ำมัน 25 ลิตร สตาร์ทไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/bad876ef29591dd6b6a6e557acceaa23.jpg_200x200q90.jpg",
        "price": 39936,
        "remark": "https://www.lazada.co.th/products/pdp-i5964048701.html",
        "sold": 0
    },
    {
        "product_name": "รอกสปิน SHIMANO TWIN POWER SW5000XG",
        "product_image": "https://img.lazcdn.com/g/p/ea2a11f7940e01c23aec84ec0bf11fe7.png_200x200q90.png",
        "price": 39400,
        "remark": "https://www.lazada.co.th/products/pdp-i4021043228.html",
        "sold": 0
    },
    {
        "product_name": "Kenwood เครื่ิองผสมอาาหาร kMix by Kenwood รุ่น KMX751ACR",
        "product_image": "https://img.lazcdn.com/g/p/4d7cd4b2f44fea96431ef05e725caf68.jpg_200x200q90.jpg",
        "price": 39000,
        "remark": "https://www.lazada.co.th/products/pdp-i5604249520.html",
        "sold": 1
    },
    {
        "product_name": "Duchess CM1320 เครื่องชงกาแฟสดเอสเปรสโซ่ ขนาดพกพา ใช้งานง่าย สำหรับมือใหม่และบาริสต้า",
        "product_image": "https://img.lazcdn.com/g/p/fbee22cf923a33488dea1e2ab9680bad.jpg_200x200q90.jpg",
        "price": 38380,
        "remark": "https://www.lazada.co.th/products/pdp-i123752281.html",
        "sold": 229
    },
    {
        "product_name": "#ใหม่ญี่ปุ่น เครื่องสูบน้ำ ดีเซล ท่อ 4 นิ้ว กำลัง 7 เเรงม้า #ดูดเเรง 1,600 ลิตร ต่อ นาที เเบรนด์ Tazawa : DIESEL WATER PUMP WP40E #รับประกัน 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/b7c017352e2f003e8b53fbc0a6f948ef.png_200x200q90.png",
        "price": 37800,
        "remark": "https://www.lazada.co.th/products/pdp-i5448534239.html",
        "sold": 0
    },
    {
        "product_name": "รอกเบส Daiwa Ryoga Bay Jigging C1012 PE-SH",
        "product_image": "https://img.lazcdn.com/g/p/9d06a7ae29da6ef6d9c78a53b28ebdf8.jpg_200x200q90.jpg",
        "price": 36400,
        "remark": "https://www.lazada.co.th/products/pdp-i3971677494.html",
        "sold": 0
    },
    {
        "product_name": "รอกหยดน้ำ Shimano - Antares 2025",
        "product_image": "https://img.lazcdn.com/g/p/fb90a158e1991c4301914f26c9c2c8f8.jpg_200x200q90.jpg",
        "price": 35800,
        "remark": "https://www.lazada.co.th/products/pdp-i5834836658.html",
        "sold": 0
    },
    {
        "product_name": "GARMIN APPROACH G80 (ลดถึง21 พ.ย.เท่านั้น) เครื่อง LAUNCH MONITOR ระดับพรีเมี่ยม พร้อมระบบ GPS Distributed By KASCO",
        "product_image": "https://img.lazcdn.com/g/p/dcdd41f95e7e754d6e29f7221748e55a.png_200x200q90.png",
        "price": 35380,
        "remark": "https://www.lazada.co.th/products/pdp-i2583160866.html",
        "sold": 4
    },
    {
        "product_name": "รอกเบท Shimano - Ocea Conquest CT 2024 รุ่นล่าสุด",
        "product_image": "https://img.lazcdn.com/g/p/504f7f5af918acb108ff3456b288fc69.jpg_200x200q90.jpg",
        "price": 35000,
        "remark": "https://www.lazada.co.th/products/pdp-i5664760424.html",
        "sold": 0
    },
    {
        "product_name": "รอกหยดน้ำ Shimano Antares 2019",
        "product_image": "https://img.lazcdn.com/g/p/dfc5bef6e5100609abd97ac167f28c68.jpg_200x200q90.jpg",
        "price": 35000,
        "remark": "https://www.lazada.co.th/products/pdp-i4159099773.html",
        "sold": 0
    },
    {
        "product_name": "TAZAWA เครื่องยนต์ รุ่น MONSTER-X-622CC 22แรงม้า 622CC  (มือดึง/สตาร์ทไฟฟ้า) เครื่องยนต์ 4จังหวะ GASOLINE WATER PUMP หัวเครื่องยนต์ชนปั๊ม หัวเครื่องยนต์สูบน้ำ เบนซิน เครื่องเรือ เครื่องยนต์อเนกประสงค์ จัดส่งทั่วประเทศไทย",
        "product_image": "https://img.lazcdn.com/g/p/74696ac0c1bc7662801e6f3c0888b5b8.jpg_200x200q90.jpg",
        "price": 34980,
        "remark": "https://www.lazada.co.th/products/pdp-i1964098218.html",
        "sold": 2
    },
    {
        "product_name": "เครื่องซักผ้า 9 กก รุ่น FV1209S5WG ระบบ AI DD™ พร้อม Smart Diagnosis ตรวจสอบปัญหาผ่านมือถือ",
        "product_image": "https://img.lazcdn.com/g/p/0f3f9938b69e45b1cc0127abf8ca4d0b.jpg_200x200q90.jpg",
        "price": 34480,
        "remark": "https://www.lazada.co.th/products/pdp-i4910683699.html",
        "sold": 2
    },
    {
        "product_name": "Duchess CM7500 เครื่องชงกาแฟสด ระบบอัตโนมัติ ขนาดกะทัดรัด (สีขาว/สีดำ)",
        "product_image": "https://img.lazcdn.com/g/p/70151fd3225c058e3e288c4254e79883.jpg_200x200q90.jpg",
        "price": 34180,
        "remark": "https://www.lazada.co.th/products/pdp-i4928218099.html",
        "sold": 37
    },
    {
        "product_name": "[ศูนย์ไทย] เครื่องปั่นไฟ tosaki รุ่น TGG6501K เครื่องปั่นไฟเบนซิน กำลังไฟออกสูงสุด 5.5 KW เครื่องยนต์ 13 แรงม้า 220 V สตาร์ทด้วยมือดึง จำหน่ายโดย GROWCERY",
        "product_image": "https://img.lazcdn.com/g/p/d8f29f2636e5da10f2064b4a7379be28.jpg_200x200q90.jpg",
        "price": 33708,
        "remark": "https://www.lazada.co.th/products/pdp-i3158915168.html",
        "sold": 2
    },
    {
        "product_name": "POLO เครื่องปั่นไฟ เบนซิน กำลังไฟ 5.0 กิโลวัตต์ กำลังเครื่องยนต์ 13 แรงม้า รุ่น KT6600DC / KT6500DC",
        "product_image": "https://img.lazcdn.com/g/p/81f0404d5826652f0e9eeaeb30e223ec.jpg_200x200q90.jpg",
        "price": 32802,
        "remark": "https://www.lazada.co.th/products/pdp-i5631492788.html",
        "sold": 2
    },
    {
        "product_name": "HISENSE เครื่องซักผ้า ฝาบน 17 กก. รุ่น WT5T1715DT สีเทา [ไม่รวมติดตั้ง] |MC|",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S949e5759c631489b9ed7031a55ec6357t.jpg_200x200q90.jpg",
        "price": 32518,
        "remark": "https://www.lazada.co.th/products/pdp-i5183072146.html",
        "sold": 0
    },
    {
        "product_name": "รอกเบส SHIMANO CALCUTTA CONQUEST 100HG / 101HG",
        "product_image": "https://img.lazcdn.com/g/p/8c7f51890be7e571c1c6ed7e534457f3.jpg_200x200q90.jpg",
        "price": 31800,
        "remark": "https://www.lazada.co.th/products/pdp-i3307501219.html",
        "sold": 0
    },
    {
        "product_name": "รอกหยดน้ำ Shimano - Aldebaran DC 2025",
        "product_image": "https://img.lazcdn.com/g/p/4b7be42399d60c9ceae221184984ac09.jpg_200x200q90.jpg",
        "price": 31800,
        "remark": "https://www.lazada.co.th/products/pdp-i5834831825.html",
        "sold": 2
    },
    {
        "product_name": "POLO เครื่องยนต์ อเนกประสงค์ (ดีเซล) สูบตั้ง สตาร์ทกุญแจ ขนาด 13HP รุ่น DX195E (ไม่รวมแบตเตอรี่) รับประกัน 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/feeff479867ca50f81f24fc207426fc0.jpg_200x200q90.jpg",
        "price": 31440,
        "remark": "https://www.lazada.co.th/products/pdp-i5988180299.html",
        "sold": 0
    },
    {
        "product_name": "Kemage เครื่องปั่นไฟระบบอินเวอร์เตอร์ รุ่นKM-INVT-5.5KW 5500W เครื่องยนต์เบนซิน 4 จังหวะ ขนาด 5.5 กิโลวัตต์ ใช้กุญแจสตาร์ทและเชือกสตาร์ทได้",
        "product_image": "https://img.lazcdn.com/g/p/1d846fa83f90e2b0e91cb616b954307c.jpg_200x200q90.jpg",
        "price": 30000,
        "remark": "https://www.lazada.co.th/products/pdp-i5046156822.html",
        "sold": 0
    },
    {
        "product_name": "MITSUMAX เครื่องยนต์ดีเซล สูบตั้ง/สูบน้ำ (มีตัวเลือก DX192EB /DX186EB /DXP178EB /DX178EB) เครื่องยนต์สูบตั้ง เครื่องยนต์ดีเซล4จังหวะ เครื่องยนต์ สินค้ามาตรฐานอัศวินโน่ จัดส่งFLASH",
        "product_image": "https://img.lazcdn.com/g/p/a99c90d561dfcf0db5da702342cf16fe.jpg_200x200q90.jpg",
        "price": 30000,
        "remark": "https://www.lazada.co.th/products/pdp-i5900302876.html",
        "sold": 0
    },
    {
        "product_name": "KANTO เครื่องปั่นไฟ รุ่น KT-GEN-6500 5500วัตต์ 13แรงม้า 220V (เชือกดึงสตาร์ท) เครื่องยนต์ 4จังหวะ GASOLINE GENERATOR ปั่นไฟ เครื่องกำเนิดไฟ จัดส่งทั่วประเทศไทย",
        "product_image": "https://img.lazcdn.com/g/p/10363a95473b07e551481a025c2312df.jpg_200x200q90.jpg",
        "price": 29900,
        "remark": "https://www.lazada.co.th/products/pdp-i1604076396.html",
        "sold": 4
    },
    {
        "product_name": "TAILWALK | ไม้ตกปลาโลหะแผ่นเบาสำหรับการตกปลาเรือและทะเล Slow Rock Jigging",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb68df40039bb4ccf98547258d5f33ec9B.jpg_200x200q90.jpg",
        "price": 29324.52,
        "remark": "https://www.lazada.co.th/products/pdp-i6003390741.html",
        "sold": 0
    },
    {
        "product_name": "Sharp เครื่องซักผ้าฝาบน ขนาด 17 kg รุ่น ES-WJX17 / รับประกันมอเตอร์ 10 ปี Washing machine",
        "product_image": "https://img.lazcdn.com/g/p/b0383fc86e617b004c88482f993fecd3.jpg_200x200q90.jpg",
        "price": 28980,
        "remark": "https://www.lazada.co.th/products/pdp-i5976070989.html",
        "sold": 0
    },
    {
        "product_name": "KEMAGE เครื่องปั่นไฟ เบนซิน รุ่น KM-GI-5KW (230V./ 5.5KW / 9HP /เชือกดึงสตาร์จ) มอเตอร์ Brushless ปั่นไฟ กำเนิดไฟฟ้า จัดส่ง KERRY",
        "product_image": "https://img.lazcdn.com/g/p/919574fd37f1ce14505b8de4c4a7ce9e.jpg_200x200q90.jpg",
        "price": 28900,
        "remark": "https://www.lazada.co.th/products/pdp-i4480553148.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องซักผ้า electrolux ฝาหน้า รุ่น EWF8024D3WC UltimateCare 300 ความจุ 8 กก.",
        "product_image": "https://img.lazcdn.com/g/p/ba2cb64c7d9887d400efa1b6d4f32275.jpg_200x200q90.jpg",
        "price": 27900,
        "remark": "https://www.lazada.co.th/products/pdp-i5810770797.html",
        "sold": 0
    },
    {
        "product_name": "รอกสปิน Shimano Twin Power FE 2024 ของแท้ 100%",
        "product_image": "https://img.lazcdn.com/g/p/d511ebb5b1a13911ba7e70daea119bf5.jpg_200x200q90.jpg",
        "price": 27000,
        "remark": "https://www.lazada.co.th/products/pdp-i5142444402.html",
        "sold": 0
    },
    {
        "product_name": "🧡เทสก่อนส่ง🧡เครื่องปั่นไฟเบนซิน ระบบ INVERTER 4 จังหวะ 4.5 KW  PUMPKIN รุ่น PTT-G4542iO (44391)",
        "product_image": "https://img.lazcdn.com/g/p/ab6f2fcdf349d1f4530bf9f1f06a6ac5.jpg_200x200q90.jpg",
        "price": 27000,
        "remark": "https://www.lazada.co.th/products/pdp-i5950831625.html",
        "sold": 0
    },
    {
        "product_name": "รอกสปิน Shimano Twin Power FE 2024 ของแท้",
        "product_image": "https://img.lazcdn.com/g/p/06bc108717a03885d5fc60c50e25f3dd.jpg_200x200q90.jpg",
        "price": 27000,
        "remark": "https://www.lazada.co.th/products/pdp-i5142443346.html",
        "sold": 3
    },
    {
        "product_name": "Gemilai เครื่องชงกาแฟอัตโนมัติ (ตั้งค่าเวลาชง,บ่มกาแฟ,ตั้งอุณหภูมิสตีมได้) 1700W 1.7 ลิตร รุ่น CRM 3006",
        "product_image": "https://img.lazcdn.com/g/p/276e62788486283aa2b899eefbf23e2a.jpg_200x200q90.jpg",
        "price": 26372,
        "remark": "https://www.lazada.co.th/products/pdp-i5147537468.html",
        "sold": 70
    },
    {
        "product_name": "Gemilai เครื่องชงกาแฟอัตโนมัติ (ตั้งค่าเวลาชง,บ่มกาแฟ,ตั้งอุณหภูมิสกัด) 1700W 1.7 ลิตร รุ่น CRM 3006",
        "product_image": "https://img.lazcdn.com/g/p/4a785d5e99408431779f2672cf397f37.jpg_200x200q90.jpg",
        "price": 26980,
        "remark": "https://www.lazada.co.th/products/pdp-i5437511912.html",
        "sold": 0
    },
    {
        "product_name": "KEMAGE เครื่องปั่นไฟ รุ่น KM-GI-5KW 5500วัตต์ 9แรงม้า 230V (เชื่อกดึงสตาร์ท) เครื่องยนต์ 4จังหวะ เบนซิน ปั่นไฟ GENERATOR กำเนิดไฟ ส่ง KERRํY",
        "product_image": "https://img.lazcdn.com/g/p/76969c85b57cca2a601e67b2c4953f96.jpg_200x200q90.jpg",
        "price": 26600,
        "remark": "https://www.lazada.co.th/products/pdp-i5077006162.html",
        "sold": 0
    },
    {
        "product_name": "คัน Shimano Cardiff NATIVE Special",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd1695181ffc94751b53374d477f3d00ei.jpg_200x200q90.jpg",
        "price": 26580,
        "remark": "https://www.lazada.co.th/products/pdp-i5824417096.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำบิงซู สายไหม เกล็ดหิมะ +พร้อมถาดรองหมุนอัตโนมัติ กำลังไฟ750วัตต์ รับประกันสินค้า1ปีเต็ม ขนาดลูกกลิ้ง 9 เซนติเมตร ถังบรรจุ2ใบ มาตรฐาน ครบชุด เครื่องทำบิงซูสายไหม เครื่องทำน้ำแข็งบิงซู เครื่องทําบิงซูเกล็ดหิมะ เครื่องทำบิงซูเกาหลี พร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/p/12966fc569e5c6873ceeee1400dc8431.png_200x200q90.png",
        "price": 26130,
        "remark": "https://www.lazada.co.th/products/pdp-i5667819307.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องยนต์ดีเซล 14HP HERO รุ่น S188FBE เครื่องดีเซล เครื่องยนต์ เครื่องยนต์ดีเซลฮีโร่ มีไดร์สตาร์ท DESIGN BY JAPAN",
        "product_image": "https://img.lazcdn.com/g/p/dbe6969fa698e01f7faaa598b17e8107.jpg_200x200q90.jpg",
        "price": 25980,
        "remark": "https://www.lazada.co.th/products/pdp-i5179380476.html",
        "sold": 1
    },
    {
        "product_name": "Toshiba เครื่องซักผ้าฝาหน้า 9.5 กก. รุ่น TW-T21BU105UWT(MG)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S99e9237beb9341adbfa6a38dad5587549.jpeg_200x200q90.jpg",
        "price": 25940,
        "remark": "https://www.lazada.co.th/products/pdp-i4993747944.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องปั่นไฟเบนซินระบบ Inverter POLO รุ่น GT4500i แรงทะลุพิกัดด้วยกำลังไฟสูงสุด 3.7 กิโลวัตต์",
        "product_image": "https://img.lazcdn.com/g/p/a85ee4ed547e101cf1396c7821984b4b.jpg_200x200q90.jpg",
        "price": 25800,
        "remark": "https://www.lazada.co.th/products/pdp-i4402060783.html",
        "sold": 2
    },
    {
        "product_name": "Kitchenmall เครื่องบดหมู ไฟฟ้า เครื่องบดเนื้อ อัตโนมัติ แบบตั้งโต๊ะ  สำหรับ บดโครงไก่ พริกแกง กำลังผลิต 75-350 กก./ชม. สำหรับธุรกิจขนาดเล็ก-กลาง",
        "product_image": "https://img.lazcdn.com/g/p/b93d9b23f190331fa3ef969285615fe1.jpg_200x200q90.jpg",
        "price": 25800,
        "remark": "https://www.lazada.co.th/products/pdp-i4207975684.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องซักผ้าฝาหน้า (9 กก.) Whirlpool รุ่น Radiant WFRB904AJW TH  + ฟรีขาตั้ง รับประกัน 10 ปี",
        "product_image": "https://img.lazcdn.com/g/p/a3f657864aaff9451fe7a19873129066.png_200x200q90.png",
        "price": 25382.04,
        "remark": "https://www.lazada.co.th/products/pdp-i987704270.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟเอนกประสงค์น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S919b9fbb2bf447ca89b0ce49627063e1A.jpg_200x200q90.jpg",
        "price": 25258.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16055249142.html",
        "sold": 0
    },
    {
        "product_name": "Worldtech เครื่องชงกาแฟอัตโนมัติ รุ่น WT-CM501_BLK พร้อมระบบฟองนมในตัว",
        "product_image": "https://img.lazcdn.com/g/p/5a4fa2c1cb1167575bc847096fd4ba87.jpg_200x200q90.jpg",
        "price": 25098,
        "remark": "https://www.lazada.co.th/products/pdp-i4975046138.html",
        "sold": 121
    },
    {
        "product_name": "ครื่องสูบน้ำดีเซล ควายทอง K221 (4 นิ้ว) KD40P  √ ทางน้ำออก 4 นิ้ว  √ 8 แรงม้า  √ น้ำหนักเครื่อง 71 กิโลกรัม  √ เครื่อง 4 จังหวะ สูบเดียว  √ปริมาตรกระบอกสูบ 418 CC  √ ถังน้ำมัน 5.5 ลิตร  √ ปริมาณน้ำที่ได้ 667 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/2c34f06b9a63f992b31becb8fdb410c0.jpg_200x200q90.jpg",
        "price": 25000,
        "remark": "https://www.lazada.co.th/products/pdp-i5722743499.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสูบน้ำดีเซล MITSUKI (มิตซูกิ) ขนาด 2 นิ้ว เครื่องสูบน้ำดีเซล2นิ้ว ประหยัดน้ำมัน (002-0001)",
        "product_image": "https://img.lazcdn.com/g/p/10428b7d057df61c8e0605f40e181b3b.jpg_200x200q90.jpg",
        "price": 25000,
        "remark": "https://www.lazada.co.th/products/pdp-i5168807847.html",
        "sold": 0
    },
    {
        "product_name": "SIEMENS เครื่องซักผ้าฝาหน้า  รุ่น WM08E261TH 7 กก. (สินค้าใหม่ สินค้าเคลียร์แลนซ์)",
        "product_image": "https://img.lazcdn.com/g/p/f08f5a392c6a65bc3d0701e3035d1f4d.png_200x200q90.png",
        "price": 23980,
        "remark": "https://www.lazada.co.th/products/pdp-i5808566084.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องซักผ้าฝาหน้า (10.5 กก.) Whirlpool รุ่น Radiant WFRB1054AJW TH  + ฟรีขาตั้ง รับประกัน 10 ปี",
        "product_image": "https://img.lazcdn.com/g/p/6f4f9e4c3d4d61f265aac122e27fd723.png_200x200q90.png",
        "price": 23800,
        "remark": "https://www.lazada.co.th/products/pdp-i987664143.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องปั่นพลังสูงเชิงพาณิชย์ SHIMONO EVO 850PRO",
        "product_image": "https://img.lazcdn.com/g/p/43d9f7bb44c8c99b79e3951a02f643c4.jpg_200x200q90.jpg",
        "price": 23800,
        "remark": "https://www.lazada.co.th/products/pdp-i4976802252.html",
        "sold": 1
    },
    {
        "product_name": "#มาเเรงที่สุด เครื่องปั่นไฟ อินเวอร์เตอร์ ทำงานต่อเนื่อง 6 ชม. รุ่น GT45 เบนซิน กำลัง 3.8 KW 7.5 แรงม้า #223 ซีซี (ผู้จัดจำหน่าย MAKITA) #รับประกัน 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/84d792be87c39ee83c459f08d74cb96c.jpg_200x200q90.jpg",
        "price": 23800,
        "remark": "https://www.lazada.co.th/products/pdp-i4864226055.html",
        "sold": 0
    },
    {
        "product_name": "POLO เครื่องปั่นไฟ เบนซิน กำลังไฟ 2.5 กิโลวัตต์ กำลังเครื่องยนต์ 7.0 แรงม้า รุ่น KT3500V-DDC (รุ่น V) กระบอกสูบ 420 มล. ถังน้ำมัน 15 ลิตร สตาร์ทไฟฟ้า (โปโล)",
        "product_image": "https://img.lazcdn.com/g/p/935a998159202fecaa2a62772957a5a4.jpg_200x200q90.jpg",
        "price": 19994,
        "remark": "https://www.lazada.co.th/products/pdp-i1314228840.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องไสไม้ 12\" JEMAR TC13",
        "product_image": "https://img.lazcdn.com/g/p/ae3340fd48f9217f5b7580ffdd8d18ec.jpg_200x200q90.jpg",
        "price": 23500,
        "remark": "https://www.lazada.co.th/products/pdp-i5025894588.html",
        "sold": 60
    },
    {
        "product_name": "เครื่องสับผสมลูกชิ้น เบอร์24 3000วัตต์ (สับผสมได้4-5Kg./ครั้ง) มีขอบหล่อเย็น ถังสแตนเลสเกรดอาหาร เชิงพาณิชย์ เครื่องตีเนื้อทำลูกชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/752ae332dd75e3a2bbcb99cbc9ad7024.png_200x200q90.png",
        "price": 23380,
        "remark": "https://www.lazada.co.th/products/pdp-i1561580644.html",
        "sold": 44
    },
    {
        "product_name": "เครื่องยนต์ Lifan150cc แบบสูบตั้ง ระบบก้านกระทุ้ง ลูกสูบเดี่ยว,สี่จังหวะ,ระบายความร้อนด้วยอากาศ มีใบคุมเครื่องทุกเครื่อง",
        "product_image": "https://img.lazcdn.com/g/p/ad87279c87a85338a0e88d1f0292956c.jpg_200x200q90.jpg",
        "price": 23160,
        "remark": "https://www.lazada.co.th/products/pdp-i6065255190.html",
        "sold": 0
    },
    {
        "product_name": "รอกทรงกลม ABU GARCIA AMBASSADEUR 6500 CS Rocket Lemon รอกอาบู แอมบาสเดอร์ CS โปรร็อคเก็ต อัตราทด 5.3:1 กำลังเบรก 7Kg สีเขียวเลม่อน",
        "product_image": "https://img.lazcdn.com/g/p/1c39da4627565999135846297291a26d.jpg_200x200q90.jpg",
        "price": 22000,
        "remark": "https://www.lazada.co.th/products/pdp-i4873495734.html",
        "sold": 0
    },
    {
        "product_name": "Tefal เครื่องปั่นร้อนเย็นพลังสูง ULTRABLEND SILENCE กำลังไฟ 2,000 วัตต์ รุ่น BL98SC66",
        "product_image": "https://img.lazcdn.com/g/p/7625e2be905957d7e22d85514f16b6bb.png_200x200q90.png",
        "price": 21998,
        "remark": "https://www.lazada.co.th/products/pdp-i4445657641.html",
        "sold": 6
    },
    {
        "product_name": "ส่งพรี!! เครื่องชงกาแฟ ETZEL รุ่น SN6570 สำหรับเปิดร้าน | ETZEL Commercial Espresso machine model SN6570",
        "product_image": "https://img.lazcdn.com/g/p/78f0ecb25edb971f0e1bf1962feb4760.jpg_200x200q90.jpg",
        "price": 21980,
        "remark": "https://www.lazada.co.th/products/pdp-i1221582632.html",
        "sold": 197
    },
    {
        "product_name": "POLO เครื่องปั่นไฟ เบนซิน รุ่น GT4500i กำลังไฟ 3.5 กิโลวัตต์ ระบบ Inverter สตาร์ทด้วยมือ",
        "product_image": "https://img.lazcdn.com/g/p/1c7132bfd7fd573dca33a11d211c6e1c.jpg_200x200q90.jpg",
        "price": 21980,
        "remark": "https://www.lazada.co.th/products/pdp-i4905028077.html",
        "sold": 0
    },
    {
        "product_name": "ไม้เบ็ดตกปลาทะเลคาร์บอนน้ำหนักเบา สำหรับตกปลาด้วยเหยื่อปลอมและขว้างไกล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S20ce3d23aee645ddb18083a0db7100f8M.jpg_200x200q90.jpg",
        "price": 21374.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6003446121.html",
        "sold": 0
    },
    {
        "product_name": "Shimano | รอกตกปลาทะเลแบบสปินนิ่ง ปรับความเร็วสูง-ต่ำได้ COMPLEX CI4+ XR",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S239eb8402def497791300644d9f8e1b3k.jpg_200x200q90.jpg",
        "price": 21370.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6003377966.html",
        "sold": 3
    },
    {
        "product_name": "ปั๊มบาดาลบ่อ 6 นิ้ว KEN KS-300330-6SM 3HP รูน้ำ 3 นิ้ว 3 ใบพัด พร้อมกล่องอุปกรณ์ สายไฟยาว 30 เมตร",
        "product_image": "https://img.lazcdn.com/g/p/6e77c3ef3b375b2f642c03816bd9e315.jpg_200x200q90.jpg",
        "price": 21282,
        "remark": "https://www.lazada.co.th/products/pdp-i1999392334.html",
        "sold": 1
    },
    {
        "product_name": "Tailwalk | รีลตกปลาขนาดใหญ่ระยะไกลเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5f31c6e172854a72a7c54ab72d9cf593W.jpg_200x200q90.jpg",
        "price": 21109.26,
        "remark": "https://www.lazada.co.th/products/pdp-i6003165857.html",
        "sold": 0
    },
    {
        "product_name": "POLO เครื่องไสไม้ ขนาด 13 นิ้ว (330 มม.) กำลังมอเตอร์ 2000 วัตต์ รุ่น MB1301 ความเร็วรอบ 10000 รอบ/นาที มี 3ใบมีด (โปโล)",
        "product_image": "https://img.lazcdn.com/g/p/22cb95eacc39342c2bf06d64e0015c5d.jpg_200x200q90.jpg",
        "price": 20976,
        "remark": "https://www.lazada.co.th/products/pdp-i5817868297.html",
        "sold": 7
    },
    {
        "product_name": "เครื่องชงกาแฟ Auto เครื่องชงกาแฟสดอัตโนมัติ A10S แบบหน้าจอสัมผัส Coffee machine 19bar เครื่องชงชาสด เครื่องชงกาแฟเชิงพาณิชย์ เติมน้ําอัตโนมัติ（COD）",
        "product_image": "https://img.lazcdn.com/g/p/570bbdca377f3416903d425d555c311f.jpg_200x200q90.jpg",
        "price": 20959.68,
        "remark": "https://www.lazada.co.th/products/pdp-i4187537588.html",
        "sold": 62
    },
    {
        "product_name": "KANTO เครื่องสีข้าว+เครื่องโม่ รุ่น KT-MILL-3 2200 วัตต์ 2หัว (พร้อมมอเตอร์ 3HP) เครื่องสีข้าว โม่บด โม่แป้ง สีข้าวได้เมล็ดสวย สีข้าว",
        "product_image": "https://img.lazcdn.com/g/p/1dc8379ec71df16b1b2b9c9810fcbdcc.jpg_200x200q90.jpg",
        "price": 20930,
        "remark": "https://www.lazada.co.th/products/pdp-i4374156636.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำน้ำแข็งขนาด 40KG เหมาะสำหรับใช้ในร้านอาหาร บาร์ ร้านกาแฟ หรือ ร้านอาหารก็ได้ตามต้องการเครื่องทำน้ำแข็ง เครื่องผลิตน้ำแข็ง",
        "product_image": "https://img.lazcdn.com/g/p/dd4129a6a34140b35e598c09853c320b.jpg_200x200q90.jpg",
        "price": 20894,
        "remark": "https://www.lazada.co.th/products/pdp-i2376795862.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องยนต์เป่าลม มือถือ เครื่อง 2จังหวะ ความแรงลม 60m/s  น้ำหนักเพียง 3.6กิโลกรัม STIHL รุ่น BG50 (รับประกัน 6เดือน)",
        "product_image": "https://img.lazcdn.com/g/p/c23aee163edb72444636a0115650e789.jpg_200x200q90.jpg",
        "price": 19600,
        "remark": "https://www.lazada.co.th/products/pdp-i779164840.html",
        "sold": 6
    },
    {
        "product_name": "[พร้อมส่ง] เครื่องชงกาแฟ Calet Espresso อัตโนมัติ รุ่น CLT-Q07R หน้าจอสัมผัส LED 19 บาร์ แทงค์น้ำจุ 1.8 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/ccc15b4571f1d6014874a6acf530f0a1.jpg_200x200q90.jpg",
        "price": 19598,
        "remark": "https://www.lazada.co.th/products/pdp-i3634186078.html",
        "sold": 70
    },
    {
        "product_name": "KEMAGE เครื่องปั่นไฟ เบนซิน INVERTER เครื่องยนต์ เบนซิน 4 จังหวะ กำลังไฟ 2 กิโลวัตต์ รุ่น KM-INVT-2KW",
        "product_image": "https://img.lazcdn.com/g/p/1c1d2836f8fdcc6c0e7f6a100634b6fc.jpg_200x200q90.jpg",
        "price": 19500,
        "remark": "https://www.lazada.co.th/products/pdp-i4497249702.html",
        "sold": 0
    },
    {
        "product_name": "Toshiba เครื่องซักผ้าฝาบน 19 กก. รุ่น AW-DUHN2000QT(SG) Origin Inverter",
        "product_image": "https://img.lazcdn.com/g/p/787ace0e7036c7c644df03876c45af46.jpg_200x200q90.jpg",
        "price": 19380,
        "remark": "https://www.lazada.co.th/products/pdp-i5692669199.html",
        "sold": 185
    },
    {
        "product_name": "POLO เครื่องปั่นไฟเบนซิน รุ่น KT3500GDC เครื่องกําเนิดไฟฟ้า เครื่องกำเนิดไฟฟ้าเบนซิน จำหน่ายโดย MontreeMore",
        "product_image": "https://img.lazcdn.com/g/p/694fedf0ff8a84c18f95c4828b382f47.jpg_200x200q90.jpg",
        "price": 19380,
        "remark": "https://www.lazada.co.th/products/pdp-i4196746244.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสีข้าว เครื่องสีข้าวตราสิงโตทอง ระบบเครื่องยนต์ รุ่น4.0-GE คุณภาพดี",
        "product_image": "https://img.lazcdn.com/g/p/94abc8592055b79c18b1b0219bd7665f.png_200x200q90.png",
        "price": 19100,
        "remark": "https://www.lazada.co.th/products/pdp-i5143104902.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องเลื่อยกระดูก",
        "product_image": "https://img.lazcdn.com/g/p/47a2a7b0156ea27f82aa62c0b3c477ff.jpg_200x200q90.jpg",
        "price": 19000,
        "remark": "https://www.lazada.co.th/products/pdp-i2080018996.html",
        "sold": 45
    },
    {
        "product_name": "เครื่องสับเนื้ออัตโนมัติ คุณภาพสูง ใช้งานได้ทั้งบ้าน ร้านอาหาร และเชิงพาณิชย์ แข็งแรง ทนทาน",
        "product_image": "https://img.lazcdn.com/g/p/04fb8f3f4ff18699043e23a22c6c377a.png_200x200q90.png",
        "price": 18966,
        "remark": "https://www.lazada.co.th/products/pdp-i16092963367.html",
        "sold": 0
    },
    {
        "product_name": "siamsport เครื่องยนต์สูบนอน LIFAN(ลี่ฟาน) 125cc มีเกียร์ถอยหลัง สตาร์ทมือ/เท้า ไดร์สตาร์ทบน ไม่มีครัชมื",
        "product_image": "https://img.lazcdn.com/g/p/1354703b58a379c1c9ff2018eb24508f.jpg_200x200q90.jpg",
        "price": 18160,
        "remark": "https://www.lazada.co.th/products/pdp-i16081709164.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องชงชาสด เครื่องชงกาแฟ มัลติฟังก์ชั่นปัญญาเครื่องชงกาแฟอัตโนมัติ coffee machines 19 bar หน้าจอสัมพัส รุ่น07S มีพร้อมส่ง เครื่องชงกาแฟส่ง COD",
        "product_image": "https://img.lazcdn.com/g/p/72123c569a8d1f9f9d5a78aa83739ec7.jpg_200x200q90.jpg",
        "price": 18093.3,
        "remark": "https://www.lazada.co.th/products/pdp-i3646798973.html",
        "sold": 481
    },
    {
        "product_name": "PGM GOLF | ไม้กอล์ฟสำหรับการแข่งขันของผู้ชาย 2 หรือ 3 เหล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se438c80cbf8f4948a681c727a1d35f830.jpg_200x200q90.jpg",
        "price": 17846.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16055382149.html",
        "sold": 2
    },
    {
        "product_name": "DAIWA | รอกตกปลาทะเลสำหรับเกมใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0d7edfec32234ad7b00b67bcf4abc7b11.jpg_200x200q90.jpg",
        "price": 17478.1,
        "remark": "https://www.lazada.co.th/products/pdp-i6003350910.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสีข้าวโพด เครื่องแกะเมล็ดข้าวโพดตราสิงโตทอง ระบบเครื่องยนต์4HP 1200 กก./ชม. คุณภาพดี",
        "product_image": "https://img.lazcdn.com/g/p/dfc8f9a0be5d90c8bfb52348a3ce1e47.png_200x200q90.png",
        "price": 17380,
        "remark": "https://www.lazada.co.th/products/pdp-i4885016070.html",
        "sold": 3
    },
    {
        "product_name": "TAILWALK|ไม้เบ็ดสปินนิ่งปลายแข็งสำหรับปลาเล็ก AJIST SD S68/SL  AJIST SD S510/SL",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9b2a88e74df94406bb2eed656270a7ddc.jpg_200x200q90.jpg",
        "price": 17071.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6003376485.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องโม่ทำน้ำเต้าหู้ (กำลังการผลิต 60 กิโลกรัม/ชม.) เครื่องทำนมถั่วเหลือง น้ำนมข้าวโพด Soy Bean Machine Model : ET-06",
        "product_image": "https://img.lazcdn.com/g/p/09b977dfea8b0e4c9ff08c93acb24f77.png_200x200q90.png",
        "price": 17000,
        "remark": "https://www.lazada.co.th/products/pdp-i1631448596.html",
        "sold": 25
    },
    {
        "product_name": "Toshiba เครื่องซักผ้าฝาหน้า 7.0 กก. รุ่น TW-T21BU80UWT(WW)",
        "product_image": "https://img.lazcdn.com/g/p/69c863a3d3ed0da8296bac61a54e3cd8.jpg_200x200q90.jpg",
        "price": 16980,
        "remark": "https://www.lazada.co.th/products/pdp-i5741446672.html",
        "sold": 54
    },
    {
        "product_name": "KANTO เครื่องยนต์ปั่นไฟเบนซิน 4จังหวะ มีให้เลือกหลายรุ่น",
        "product_image": "https://img.lazcdn.com/g/p/3f5c771bf6ae8a7998a0cb1ec048c5c2.jpg_200x200q90.jpg",
        "price": 16800,
        "remark": "https://www.lazada.co.th/products/pdp-i5776160055.html",
        "sold": 0
    },
    {
        "product_name": "Toshiba เครื่องซักผ้า ฝาบน รุ่น AW-DUN1800MT(SG) ความจุ 17 กก. อินเวอร์ตอร์ ประหยัดไฟ รับประกัน 2 ปี มอเตอร์ 10 ปี",
        "product_image": "https://img.lazcdn.com/g/p/e80639b40c844ffd170dfe4f6d71e90c.jpg_200x200q90.jpg",
        "price": 16780,
        "remark": "https://www.lazada.co.th/products/pdp-i5823850594.html",
        "sold": 0
    },
    {
        "product_name": "Toshiba เครื่องซักผ้าฝาบน ระบบ Inverter Direct Drive รุ่น AW-DUN1800MT ขนาด 17 กก.",
        "product_image": "https://img.lazcdn.com/g/p/be465da29e69c91474d7b62d91cbbbbf.jpg_200x200q90.jpg",
        "price": 16580,
        "remark": "https://www.lazada.co.th/products/pdp-i5754943639.html",
        "sold": 1
    },
    {
        "product_name": "Okuma Cavalla 5N-II / 5N-IILX 2-Speed Lever Drag Reel – Machined Aluminum Frame, 17-4 Stainless Gears, Max 11kg Drag | รอกโยก 2 สปีด งานทะเล โครงอลูมิเนียมแข็งแรง เฟืองสเตนเลส แรงดึงสูงสุด 11 กก. ลุยจิ๊ก–ลากเบา",
        "product_image": "https://img.lazcdn.com/g/p/d0e9ef037e0dda6345b883b014b8ef2b.png_200x200q90.png",
        "price": 16500,
        "remark": "https://www.lazada.co.th/products/pdp-i16060992446.html",
        "sold": 0
    },
    {
        "product_name": "Toshiba เครื่องซักผ้าฝาบน 15 กก. รุ่น AW-DUM1600LT(HH) Inverter",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S58543f1b99f14b5b8a0b58494b33a4b50.jpg_200x200q90.jpg",
        "price": 16460,
        "remark": "https://www.lazada.co.th/products/pdp-i5692413899.html",
        "sold": 106
    },
    {
        "product_name": "รอกสปิน Shimano Stradic SW 2024 ของแท้ 100% มีประกัน",
        "product_image": "https://img.lazcdn.com/g/p/1ea42a7c64c5c94801753fd7577d64cb.jpg_200x200q90.jpg",
        "price": 16400,
        "remark": "https://www.lazada.co.th/products/pdp-i5301233164.html",
        "sold": 2
    },
    {
        "product_name": "SHIMANO STRADIC SW 🆕  ปี2024 ลุยงานหนักสบายๆ",
        "product_image": "https://img.lazcdn.com/g/p/b7ddfcfa84d07aa57463ac1159a3e61d.jpg_200x200q90.jpg",
        "price": 16200,
        "remark": "https://www.lazada.co.th/products/pdp-i5903144808.html",
        "sold": 0
    },
    {
        "product_name": "SHIMANO STRADIC SW 🆕  ปี2024 ลุยงานหนัก ทะเลสบายๆ",
        "product_image": "https://img.lazcdn.com/g/p/ee1863185e8971c331f6ffe3f70c686d.jpg_200x200q90.jpg",
        "price": 16200,
        "remark": "https://www.lazada.co.th/products/pdp-i5903104805.html",
        "sold": 0
    },
    {
        "product_name": "Shimano | รอกสปินสำหรับน้ำเค็มและน้ำจืด พร้อมการขว้างไกล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S530553dfbaec4fccb2423d0cf07b1323x.jpg_200x200q90.jpg",
        "price": 16014.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6003470205.html",
        "sold": 8
    },
    {
        "product_name": "13Fishing|รอกเบทแคสติงระบบเบรกคู่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se7ec17f71e8943008eaf7454c2b723e1V.jpg_200x200q90.jpg",
        "price": 16001.28,
        "remark": "https://www.lazada.co.th/products/pdp-i6003324942.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องบดอาหาร โม่บดเนื้อ เครื่องบดพริกแกง เครื่องบดหมู เครื่องทำอาหาร โม่บดเนื้อเบอร์ 32 มอเตอร์ 1/2HP  โม่แท่นทดโซ่เบอร์ 32 พร้อมมอเตอร์ โม่บดเนื้อเบอร์32พร้อมมอเตอร์ เครื่องทำอาหาร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1a87edbd22a1424bb3dc5ee214921ec5o.jpg_200x200q90.jpg",
        "price": 16000,
        "remark": "https://www.lazada.co.th/products/pdp-i4384562673.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องซักผ้า Toshiba ฝาบน รุ่น AW-DUN1800MT(SG) ความจุ 17 กก. อินเวอร์ตอร์ ประหยัดไฟ รับประกัน 2 ปี มอเตอร์ 10 ปี",
        "product_image": "https://img.lazcdn.com/g/p/20fd0e787860200debd1ad59f160fb25.jpg_200x200q90.jpg",
        "price": 15980,
        "remark": "https://www.lazada.co.th/products/pdp-i5815504721.html",
        "sold": 0
    },
    {
        "product_name": "Total เครื่องเซาะร่อง 5 นิ้ว (130 มม.) 3000 วัตต์ รุ่นงานหนัก รุ่น TWLC1301 ( Wall Chaser ) เครื่องกรีดผนัง",
        "product_image": "https://img.lazcdn.com/g/p/be5b6ec4becdfd4c00f0a90721acd4cf.jpg_200x200q90.jpg",
        "price": 15900,
        "remark": "https://www.lazada.co.th/products/pdp-i4964072849.html",
        "sold": 3
    },
    {
        "product_name": "รอกหยดน้ำ ชิมาโน่ SHIMANO SLX DC 70/71 HG และ XG (มีทั้งหมุนขวาและหมุนซ้าย)",
        "product_image": "https://img.lazcdn.com/g/p/43b317706ce836abb331ff4c912ce8c2.jpg_200x200q90.jpg",
        "price": 15800,
        "remark": "https://www.lazada.co.th/products/pdp-i5300828674.html",
        "sold": 0
    },
    {
        "product_name": "TaylorMade | กระเป๋าเดินทางสำหรับกอล์ฟขนาดใหญ่พกพาสะดวก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4a7c7d69595d45c1bffd15631abc426fj.jpg_200x200q90.jpg",
        "price": 15450.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16054158823.html",
        "sold": 0
    },
    {
        "product_name": "Toshiba เครื่องซักผ้าฝาบน 14 กก. รุ่น AW-DUM1500LT(HH) Direct Drive Inverter",
        "product_image": "https://img.lazcdn.com/g/p/7c622f6c8b15342597c94487901f8714.jpg_200x200q90.jpg",
        "price": 15380,
        "remark": "https://www.lazada.co.th/products/pdp-i4993755972.html",
        "sold": 627
    },
    {
        "product_name": "Duchess CM1480B/W เครื่องชงกาแฟสดอัตโนมัติ ใช้งานง่าย มีให้เลือก 2 สี (ดำ/ขาว)",
        "product_image": "https://img.lazcdn.com/g/p/6755a78508addf96801a54bf8630c815.jpg_200x200q90.jpg",
        "price": 15380,
        "remark": "https://www.lazada.co.th/products/pdp-i5014388200.html",
        "sold": 372
    },
    {
        "product_name": "รอกสปินนิ่ง SHIMANO VANFORD C3000SDH ปี 2024",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8b09e2e6d6c846b1bdd774053f3816cfX.jpg_200x200q90.jpg",
        "price": 15300,
        "remark": "https://www.lazada.co.th/products/pdp-i5352507327.html",
        "sold": 0
    },
    {
        "product_name": "“ถูกและดีมากๆ” YAMATEX เครื่องสูบน้ำ 4นิ้ว 13แรง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa8d7d2c2031c4a538039062f49d1d4800.jpg_200x200q90.jpg",
        "price": 15206.54,
        "remark": "https://www.lazada.co.th/products/pdp-i3843817289.html",
        "sold": 1
    },
    {
        "product_name": "รอกทรอลลิ่ง รอกหน้าดิน เพ็นน์ Fathom 15XNLD2 หมุนขวาและขวา",
        "product_image": "https://img.lazcdn.com/g/p/82c0111f37963e5c0d93f2be2a2fba9e.jpg_200x200q90.jpg",
        "price": 15180,
        "remark": "https://www.lazada.co.th/products/pdp-i4313387554.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องซักผ้าโตชิบา DirectDriveINVERTER AW-DUM1400HT 13KG เทคโนโลยี GREATWAVE",
        "product_image": "https://img.lazcdn.com/g/ot/lzd-client-service/f4b9aecb2e8c8cfcfe7f83030c67eb13.jpeg_200x200q90.jpg",
        "price": 14980,
        "remark": "https://www.lazada.co.th/products/pdp-i2882575857.html",
        "sold": 2
    },
    {
        "product_name": "เครื่องปั่นไฟ เบนซิน  0.8 กิโลวัตต์ 3.5 แรงม้า รุ่น KT1500DC POLO",
        "product_image": "https://img.lazcdn.com/g/p/aaa6816a264e447fb71b5f3da133b8f0.jpg_200x200q90.jpg",
        "price": 14780,
        "remark": "https://www.lazada.co.th/products/pdp-i5375961441.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องยนต์ดีเซล 7 แรง รุ่นใหม่แกน 19 มิล ดึงสตาร์ท/กุญแจสตาร์ท VIGO-DE-240-PRE วีโกเทค เครื่องแน่น ประหยัดน้ำมัน",
        "product_image": "https://img.lazcdn.com/g/p/caf58da86da1cb4b928cb1b2ef1e322f.jpg_200x200q90.jpg",
        "price": 14758,
        "remark": "https://www.lazada.co.th/products/pdp-i1542302313.html",
        "sold": 10
    },
    {
        "product_name": "รอกสปินตกหมึก Shimano Sephia SS ของแท้",
        "product_image": "https://img.lazcdn.com/g/p/01881adb10dddd234128a94a144d53ac.jpg_200x200q90.jpg",
        "price": 14600,
        "remark": "https://www.lazada.co.th/products/pdp-i5498827185.html",
        "sold": 2
    },
    {
        "product_name": "KitchenAid | เครื่องทำอาหารหลายฟังก์ชัน หั่น เคี้ยว ปั้น    5KFP0720C",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb3a7731b26584f33a1ee0b1cbe1582c1U.jpg_200x200q90.jpg",
        "price": 14442,
        "remark": "https://www.lazada.co.th/products/pdp-i16067759892.html",
        "sold": 1
    },
    {
        "product_name": "รอก SHIMANO VANFORD 2024",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1e3e58f9da1c495c92ccd96395826dd0C.jpg_200x200q90.jpg",
        "price": 14400,
        "remark": "https://www.lazada.co.th/products/pdp-i5385348454.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องซักผ้าถังคู่ เครื่องซักผ้า 2 ถัง ขนาด 15 กิโล Sharp รุ่น ES-TW150BK 15kg.",
        "product_image": "https://img.lazcdn.com/g/p/0344ef459129d1de4488f3f8b6e80989.jpg_200x200q90.jpg",
        "price": 14380,
        "remark": "https://www.lazada.co.th/products/pdp-i16098299282.html",
        "sold": 0
    },
    {
        "product_name": "POLO เครื่องปั่นไฟ เบนซิน กำลังไฟ 0.8 กิโลวัตต์ รุ่น KT1500DC # ออก..ใบเสร็จ-ใบกำกับภาษี..ได้ครับ..",
        "product_image": "https://img.lazcdn.com/g/p/15b90e74c4e2d00db78ed42dcf9bd1b9.png_200x200q90.png",
        "price": 14172,
        "remark": "https://www.lazada.co.th/products/pdp-i5404227099.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องเตรียมอาหาร KENWOOD prepared food machine 1,000 วัตต์ รุ่น FDP65.400WH",
        "product_image": "https://img.lazcdn.com/g/p/0c04ba3aed22ef9c6e5d2542ddf33357.jpg_200x200q90.jpg",
        "price": 13994,
        "remark": "https://www.lazada.co.th/products/pdp-i3508236839.html",
        "sold": 5
    },
    {
        "product_name": "CAMEL เครื่องซักผ้าฝาบน 10กก. รุ่น GL-768 อัตโนมัติ เครื่องซักผ้าอัตโนมัติ ซัก/การคายน้ำ 2-in-1 Washing Machine",
        "product_image": "https://img.lazcdn.com/g/p/34e496ea0a84a4c092107b81d426a1e0.png_200x200q90.png",
        "price": 8780,
        "remark": "https://www.lazada.co.th/products/pdp-i5678128234.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องซักผ้าฝาบน โตชิบา 1 ถัง Toshiba ความจุ 7 กก. รุ่น AW-K801AT(WW)",
        "product_image": "https://img.lazcdn.com/g/p/e2293f6d7cee5ee93941722c708b021d.jpg_200x200q90.jpg",
        "price": 13980,
        "remark": "https://www.lazada.co.th/products/pdp-i4982556321.html",
        "sold": 0
    },
    {
        "product_name": "CAMEL เครื่องทำน้ำแข็ง 55 / 70 / 80KG เครื่องทำน้ำแข็งเชิงพาณิชย์ การทำน้ำแข็งเร็ว ปรับความหนาได้ และหยุดทำงานอัตโนมัติเมื่อถังน้ำแข็งเต็ม Ice Makers",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3117c9a5c3714a93aa31f3d1f9548b91K.jpg_200x200q90.jpg",
        "price": 13878,
        "remark": "https://www.lazada.co.th/products/pdp-i16115625201.html",
        "sold": 5
    },
    {
        "product_name": "เครื่องสูบน้ำญี่ปุ่น 8.5แรงม้า 4 นิ้ว เฟืองเหล็กแท้ ขนาดท่อ ดูด 4 นิ้ว ออก 4 นิ้ว รับประกันเครื่องยนต์ 1 ปี เครื่องแน่น คาบุพัฒนาใหม่ประหยัด",
        "product_image": "https://img.lazcdn.com/g/p/3b326f705a633071274ff6e2dc865527.jpg_200x200q90.jpg",
        "price": 13780,
        "remark": "https://www.lazada.co.th/products/pdp-i4693399866.html",
        "sold": 2
    },
    {
        "product_name": "เครื่องสูบน้ำญี่ปุ่น 8.5แรงม้า เฟืองเหล็กแท้ ขนาดท่อ ดูด 4 นิ้ว ออก 4 นิ้ว รับประกันเครื่องยนต์ 1 ปี เครื่องแน่น คาบุพัฒนาใหม่ประหยัด",
        "product_image": "https://img.lazcdn.com/g/p/902bba3e7887b8e3b0a8a34806781b59.jpg_200x200q90.jpg",
        "price": 13780,
        "remark": "https://www.lazada.co.th/products/pdp-i4736601019.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำน้ำแข็งเชิงพาณิชย์ ขนาดใหญ่ สามารถเก็บน้ำแข็งได้ 30 กิโลกรัม ผลิตน้ำแข็งได้อย่างรวดเร็วภายใน 7 นาที กำลังการผลิตน้ำแข็งสูงสุด 85 กิโลกรัม  ทำความสะอาดได้ในปุ่มเดียว",
        "product_image": "https://img.lazcdn.com/g/p/97ccb6c5c0817b756c5b3693c4d05daf.jpg_200x200q90.jpg",
        "price": 13772,
        "remark": "https://www.lazada.co.th/products/pdp-i5307758824.html",
        "sold": 1
    },
    {
        "product_name": "HAILANG เครื่องทำน้ำแข็งเชิงพาณิชย์ ตั้งเวลาได้ ปรับความหนาของน้ำแข็งได้ เครื่องทำน้ำแข็งขนาด 55KG-85KG ทำความสะอาดได้ในปุ่มเดียว อุปกรณ์เสริมฟรี 2 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/2898ca38c41ab609bf36e42cb71380b3.jpg_200x200q90.jpg",
        "price": 13710,
        "remark": "https://www.lazada.co.th/products/pdp-i5307801501.html",
        "sold": 20
    },
    {
        "product_name": "Tailwalk | รอกตกปลาล่อปลาใหญ่ ดึงช้าและเร็ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9e77945e5f154f0caee1d9f26ece7249m.jpg_200x200q90.jpg",
        "price": 13692.76,
        "remark": "https://www.lazada.co.th/products/pdp-i6003331274.html",
        "sold": 0
    },
    {
        "product_name": "MAKITA เครื่องขันบล๊อกไร้สาย 18 โวลต์ 1/2 นิ้ว รุ่น DTW300RTJ แรงบิดสูงสุด 330 นิวตันเมตร รวมแบตเตอรี่และแท่นชาร์จ (มากีต้า)",
        "product_image": "https://img.lazcdn.com/g/p/d266d92a991ec5d3586182aca39a1d0a.png_200x200q90.png",
        "price": 13660,
        "remark": "https://www.lazada.co.th/products/pdp-i5785551577.html",
        "sold": 0
    },
    {
        "product_name": "Daiwa | รอกตกปลาแบบยาวสำหรับปลาหมึก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdacad9c865af49da878d8bed20e35f62V.jpg_200x200q90.jpg",
        "price": 13365.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6003267444.html",
        "sold": 0
    },
    {
        "product_name": "รอกตกปลาในน้ำจืดและน้ำเค็มแบบดรอปช็อต",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S00098ae7d4c845ea93ea2d0276d9cdf1e.jpg_200x200q90.jpg",
        "price": 13211.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6003424145.html",
        "sold": 0
    },
    {
        "product_name": "RAPTOR TACTICAL ทรง WENDY",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa87dcc790a1c47c4b7cc474cc452f184f.jpg_200x200q90.jpg",
        "price": 13206.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16102894896.html",
        "sold": 0
    },
    {
        "product_name": "ชั้นวางถุงกอล์ฟ ชั้นจัดเก็บไม้กอล์ฟ ชั้นโชว์อุปกรณ์กีฬา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf80734ea2159488880fd3af2c21018d13.jpg_200x200q90.jpg",
        "price": 13125.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5927949085.html",
        "sold": 0
    },
    {
        "product_name": "รอกสปินนิ่ง PENN SPINFISHER® VII",
        "product_image": "https://img.lazcdn.com/g/p/8123c5c0055cc93d799b26f554dbe88b.jpg_200x200q90.jpg",
        "price": 13120,
        "remark": "https://www.lazada.co.th/products/pdp-i16096797683.html",
        "sold": 0
    },
    {
        "product_name": "POLO เครื่องสูบน้ำโปโล เบนซิน 4 จังหวะ  ขนาด 7 แรงม้า รุ่น H80ZB3248Q ท่อ 3 นิ้ว รับประกัน 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/cc6cebf42bd03d6055e5946ec96f42d6.jpg_200x200q90.jpg",
        "price": 13000,
        "remark": "https://www.lazada.co.th/products/pdp-i2871253660.html",
        "sold": 0
    },
    {
        "product_name": "ลวดสลิงไส้เหล็ก16มิล5หุน50เมตร(6*37)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd35d13463c5c4f0cb839b4012859b7d66.jpg_200x200q90.jpg",
        "price": 13000,
        "remark": "https://www.lazada.co.th/products/pdp-i16090927615.html",
        "sold": 0
    },
    {
        "product_name": "KASEI เครื่องเจาะดิน คาไซ รุ่น 3WT-300D พร้อมดอกเจาะ 8นิ้ว เครื่องยนต์เบนซิน 2จังหวะ เครื่องเจาะหลุม มือจับคู่ **ส่งเร็ว ของแท้100%**",
        "product_image": "https://img.lazcdn.com/g/p/8d09b4eae9403a31d73f72932f95ebce.jpg_200x200q90.jpg",
        "price": 12960,
        "remark": "https://www.lazada.co.th/products/pdp-i4243932246.html",
        "sold": 3
    },
    {
        "product_name": "Toshiba เครื่องซักผ้า 2 ถัง ความจุ 17 กก รุ่น VH-Q180MT",
        "product_image": "https://img.lazcdn.com/g/p/9e1d53886d0c6633efe371b410b770a6.jpg_200x200q90.jpg",
        "price": 12960,
        "remark": "https://www.lazada.co.th/products/pdp-i5901564851.html",
        "sold": 63
    },
    {
        "product_name": "Worldtech เครื่องซักผ้า ความจุ 12KG เครื่องซักผ้าฝาบน อัตโนมัติ รุ่น WT-MB120-620_Grey",
        "product_image": "https://img.lazcdn.com/g/p/4ddf78b3eb13d363deb1dd3755b98ae4.jpg_200x200q90.jpg",
        "price": 12938,
        "remark": "https://www.lazada.co.th/products/pdp-i5489545146.html",
        "sold": 19
    },
    {
        "product_name": "MENGCHI เครื่องปั่นไฟ เครื่องปั่นไฟขนาดเล็ก เครื่องกำเนิดไฟฟ้าเบนซิน เครื่องปั่นไฟ220v เครื่องกำเนิด 3kw เครื่องปั่นไฟเชื่อมได้",
        "product_image": "https://img.lazcdn.com/g/p/8a41aefb651b2fa2b48f324bc3204c5f.jpg_200x200q90.jpg",
        "price": 12212,
        "remark": "https://www.lazada.co.th/products/pdp-i6035099866.html",
        "sold": 3
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟสำหรับทุกเพศ พร้อมที่ยืน 14 ช่อง หลายฟังก์ชันควบคุมอุณหภูมิ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seff053e17ca245488ad5c8b98ee1c994w.jpg_200x200q90.jpg",
        "price": 12692.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16054116499.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องกำเนิดไฟฟ้าเบนซิน 3kw เสียงเบาในการใช้งานในบ้านขนาดเล็ก 220V เครื่องยนต์4จังหวะ เครื่องกำเนิดไฟฟ้า กุญแจสตาร์ทเครื่องยนต์",
        "product_image": "https://img.lazcdn.com/g/p/a99d80feaf47f88d1d723677c843dcd9.jpg_200x200q90.jpg",
        "price": 12570,
        "remark": "https://www.lazada.co.th/products/pdp-i2490560982.html",
        "sold": 16
    },
    {
        "product_name": "MILWAUKEE เครื่องเจียรแกนคอตรงไร้สาย 12V.รุ่น M12 FDGS-0 (เครื่องเปล่า | รับประกัน 1 ปี) ของแท้ 100%",
        "product_image": "https://img.lazcdn.com/g/p/4de31b42108340147b731e76e21460c1.jpg_200x200q90.jpg",
        "price": 12474,
        "remark": "https://www.lazada.co.th/products/pdp-i4896349715.html",
        "sold": 1
    },
    {
        "product_name": "8000W เครื่องหั่น เครื่องหั่นผักและผลไม้ เครื่องเตรียมอาหาร เครื่องหั่นอเนกประสงค์ 3-in-1 เครื่องหั่น เครื่องหั่น ขนาดใบมีด: 10mm และ 4mm กำลังการผลิต: 200kg/h สแตนเลส 304 เพื่อความทนทานและความปลอดภัยของอาหาร",
        "product_image": "https://img.lazcdn.com/g/p/5d36be05599a4181f2240655efb16ab4.png_200x200q90.png",
        "price": 12448,
        "remark": "https://www.lazada.co.th/products/pdp-i5904706921.html",
        "sold": 3
    },
    {
        "product_name": "KASEI เครื่องเป่าลม คาไซ รุ่น 6MF-16-30 รุ่นใหม่ล่าสุด เครื่องเบนซิน 2จังหวะ 4แรงม้า ดับไฟป่า เป่าใบไม้ ทำแนวกันไฟ **ส่งเร็ว ของแท้100%**",
        "product_image": "https://img.lazcdn.com/g/p/c24884386d3df7e08c9dc05c2331ae3a.jpg_200x200q90.jpg",
        "price": 12420,
        "remark": "https://www.lazada.co.th/products/pdp-i5348190093.html",
        "sold": 1
    },
    {
        "product_name": "CAREER เครื่องปั่นไฟ3kw เครื่องปั่นไฟขนาดเล็ก เครื่องกำเนิด 220v ความจุขนาดใหญ่ 15L เครื่องกำเนิดไฟฟ้าเบนซิน ใช้งานติดต่อกัน3-8ชั่วโมง",
        "product_image": "https://img.lazcdn.com/g/p/88d4fe7c5617d4e9a95d846c00725726.jpg_200x200q90.jpg",
        "price": 12232,
        "remark": "https://www.lazada.co.th/products/pdp-i5903545457.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องชงกาแฟสด 15 bar รุ่น CRM3605 ฟังก์ชันกลั่นอัติโนมัติ  เครื่องชงกาแฟสด👍👍👍สินค้าพร้อมส่ง✨✨",
        "product_image": "https://img.lazcdn.com/g/p/a048fd591fa5303343259dc54e268f13.jpg_200x200q90.jpg",
        "price": 12200,
        "remark": "https://www.lazada.co.th/products/pdp-i3482712686.html",
        "sold": 0
    },
    {
        "product_name": "Total ปั๊มน้ำเครื่องยนต์ เบนซิน 4 จังหวะ 7 แรงม้า ท่อ 2 นิ้ว รุ่น TP3202 ( Gasoline Water Pump ) ปั๊มน้ำ เครื่องยนต์เบนซิน ปั๊มเกษตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se4951794011e4d57ab3153a9c01e1210P.jpg_200x200q90.jpg",
        "price": 12180,
        "remark": "https://www.lazada.co.th/products/pdp-i247683483.html",
        "sold": 6
    },
    {
        "product_name": "Worldtech เครื่องซักผ้า ความจุ 10KG เครื่องซักผ้าฝาบน อัตโนมัติ รุ่น WT-MB100-620_Grey",
        "product_image": "https://img.lazcdn.com/g/p/09d431e5377a3a386639f1a54a93329c.jpg_200x200q90.jpg",
        "price": 12138,
        "remark": "https://www.lazada.co.th/products/pdp-i5489340704.html",
        "sold": 6
    },
    {
        "product_name": "รอก Shimano Scorpion dc รอบ 7.4  เป็น สินค้ามือสองจากญี่ปุ่น ไม่เคยใช้งานในไทย  มีกล่อง + คู่มือ  สภาพมีรอยจากการใช้งาน    หมุนเนียน ไม่ขึ้นมือ  ชิปเสียงดังปรกติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S612b655133414b70a0a6dabb942a0cf8e.jpg_200x200q90.jpg",
        "price": 12000,
        "remark": "https://www.lazada.co.th/products/pdp-i5463828963.html",
        "sold": 0
    },
    {
        "product_name": "ยักษ์เกษตร เครื่องสูบน้ำ 5.5 เบนซิน 4 จังหวะ  ปั้มน้ำ ขนาด 5.5 แรงม้า ปั้มขนาด 2 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/p/c7b651221a72ad53aac9ac098d9ceea6.png_200x200q90.png",
        "price": 12000,
        "remark": "https://www.lazada.co.th/products/pdp-i353766347.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องปั่นน้ำผลไม้ tefal เครื่องปั่นเครื่องปั่นร้อนเย็นพลังสูง Perfectmix Cook รุ่น BL83S , BL83SD66 ประกัน 2 ปี จาก tefal",
        "product_image": "https://img.lazcdn.com/g/p/f4bcbcdf78d194e35ceea6a443e97310.png_200x200q90.png",
        "price": 11998,
        "remark": "https://www.lazada.co.th/products/pdp-i3454380305.html",
        "sold": 33
    },
    {
        "product_name": "Treeow เครื่องทำน้ำแข็ง 60/90/120KG  เครื่องทำน้ำแข็งก้อน ตู้ทำน้ำแข็ง เครื่องทำน้ำแข็งขนาดใหญ่ เครื่องผลิตน้ำแข็ง เคื่องทำน้ำแขง เครื่องทำน้ำแข็งก ผลิตน้ำแข็งได้ สามารถผลิตน้ำแข็งภายใน 10 นาที แถมฟรีที่ตักน้ำแข็ง",
        "product_image": "https://img.lazcdn.com/g/p/888801d105e04abc3b4d3cbdddfebd94.png_200x200q90.png",
        "price": 11998,
        "remark": "https://www.lazada.co.th/products/pdp-i16113652168.html",
        "sold": 0
    },
    {
        "product_name": "HISENSE เครื่องซักผ้าฝาบน 13 KG. สีดำ รุ่น WTJH1313UB",
        "product_image": "https://img.lazcdn.com/g/p/294ca1c477c20868fa34d8b7c95539b0.jpg_200x200q90.jpg",
        "price": 11980,
        "remark": "https://www.lazada.co.th/products/pdp-i5356671068.html",
        "sold": 34
    },
    {
        "product_name": "Toshiba เครื่องซักผ้าฝาบน ขนาด 10 kg รุ่น AW-M1100PT(MK) AW-M1100PT AW M1100 PT",
        "product_image": "https://img.lazcdn.com/g/p/9d1a63410a10c60ebc64afb1beb6b437.jpg_200x200q90.jpg",
        "price": 11976,
        "remark": "https://www.lazada.co.th/products/pdp-i4947293865.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องเบนซิน 7.5แรง ชนหอยโข่ง ขนาด3นิ้ว\n\nเครื่องเบนซินติดปั๊มเหล็กหล่อคุณภาพดี ปั๊มชนเครื่องรุ่นลูกปืน ส่งน้ำไกล ทนทาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S53af95f25ba44b09b6235a6d99400e7fs.jpg_200x200q90.jpg",
        "price": 11800,
        "remark": "https://www.lazada.co.th/products/pdp-i4089417612.html",
        "sold": 4
    },
    {
        "product_name": "Kanto เครื่องสูบน้ำเบนซิน 3 นิ้ว 6.5HP KT-YAMA-30CX",
        "product_image": "https://img.lazcdn.com/g/p/b07e0da138d76269dfbc3ba4f63fff5a.jpg_200x200q90.jpg",
        "price": 11800,
        "remark": "https://www.lazada.co.th/products/pdp-i353168171.html",
        "sold": 0
    },
    {
        "product_name": "Kenwood เครื่องเตรียมอาหาร Multipro Compact รุ่น FDM301SS",
        "product_image": "https://img.lazcdn.com/g/p/fb4e78b8c57be8da2aafae2e687e4622.jpg_200x200q90.jpg",
        "price": 11750,
        "remark": "https://www.lazada.co.th/products/pdp-i2505931706.html",
        "sold": 27
    },
    {
        "product_name": "DAIWA | รอกสปินนิ่งเบาและโยนได้ไกล รุ่น Moonlight Beauty X LT ตกปลาทั้งน้ำจืดและน้ำเค็ม เน้นความเบา ลื่น และแม่นยำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa545d6bf7c6a49c0b445f031225b119ad.jpg_200x200q90.jpg",
        "price": 11491.32,
        "remark": "https://www.lazada.co.th/products/pdp-i6003246859.html",
        "sold": 4
    },
    {
        "product_name": "🚀【รับประกัน 10 ปี】เครื่องหั่นผักไฟฟ้าอเนกประสงค์ 3-in-1 เครื่องหั่นผลไม้ เครื่องหั่นลูกเต๋า เครื่องเตรียมอาหาร เครื่องหั่นผักอเนกประสงค์ EU เครื่องหั่นผัก เครื่องเตรียมอาหาร เครื่องตัดผัก เครื่องหั่นผลไม้",
        "product_image": "https://img.lazcdn.com/g/p/381906b19a588b45847ba0676b73bf20.png_200x200q90.png",
        "price": 11452.16,
        "remark": "https://www.lazada.co.th/products/pdp-i5947320205.html",
        "sold": 6
    },
    {
        "product_name": "เครื่องปั่นไฟ220v เครื่องกำเนิดไฟฟ้าเบนซิน 3kw เสียงเบาในการใช้ เครื่องยนต์4จังหวะ เครื่องกำเนิดไฟฟ้า กุญแจสตาร์ทเครื่องยนต",
        "product_image": "https://img.lazcdn.com/g/p/c0eb56707c37b3a79870dc98ada0b3ae.jpg_200x200q90.jpg",
        "price": 11360,
        "remark": "https://www.lazada.co.th/products/pdp-i4830896244.html",
        "sold": 52
    },
    {
        "product_name": "Daiwa | รอกตกปลาอัลตร้าไลท์แบบป้องกันสายพัน",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Sda4cede16b3d408b90a001ddd7b2215ah.jpg_200x200q90.jpg",
        "price": 11323.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6003369286.html",
        "sold": 82
    },
    {
        "product_name": "COROLLA เครื่องยนต์ปั่นไฟเบนซิน 900 w. 2.5HP รุ่น CL-GEN-1500",
        "product_image": "https://img.lazcdn.com/g/p/mdc/bca7ac7d891815c771e8211f7c32e694.jpg_200x200q90.jpg",
        "price": 11200,
        "remark": "https://www.lazada.co.th/products/pdp-i299404936.html",
        "sold": 0
    },
    {
        "product_name": "ประกัน1ปี เครื่องเจียร 9นิ้ว 2350 วัตต์ 230มม. เจียรลูกหมู หินเจียร ไฟฟ้า ด้ามจับหมุนได้ CAT DX351",
        "product_image": "https://img.lazcdn.com/g/p/e471aab29b6ba8f3b2f77b593d364028.png_200x200q90.png",
        "price": 11180,
        "remark": "https://www.lazada.co.th/products/pdp-i5795506739.html",
        "sold": 0
    },
    {
        "product_name": "DELONGHI เครื่องชงกาแฟเอสเพรสโซ่ Stilosa รุ่น EC230.BK",
        "product_image": "https://img.lazcdn.com/g/p/754e3bb3ab6d0f7851d8e140a1f323d4.jpg_200x200q90.jpg",
        "price": 11000,
        "remark": "https://www.lazada.co.th/products/pdp-i2710916905.html",
        "sold": 7
    },
    {
        "product_name": "EMTOP เครื่องสกัดไฟฟ้า กำลัง 1,700 วัตต์ รุ่น EDBRH1703 แถมฟรี!!! ดอกสกัดคอนกรีต ปากแหลม ชนิดก้าน SDS HEX เครื่องสกัดปูน สกัดปูน สกัดไฟฟ้า เครื่องแย็ก เครื่องแย็กปูน แย็ก เจาะปูน เจาะทำลาย (1991703)",
        "product_image": "https://img.lazcdn.com/g/p/ce0deea9ae08224458a73184c669ef31.png_200x200q90.png",
        "price": 10980,
        "remark": "https://www.lazada.co.th/products/pdp-i5601416764.html",
        "sold": 0
    },
    {
        "product_name": "Toshiba เครื่องซักผ้า 2 ถัง ความจุ 14 กก รุ่น VH-Q150MT",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8893a44a40484f9fb70ebdc5d99450f1Y.jpg_200x200q90.jpg",
        "price": 10900,
        "remark": "https://www.lazada.co.th/products/pdp-i5901565786.html",
        "sold": 33
    },
    {
        "product_name": "DIMAN เครื่องสเลอปี้ เครื่องทำน้ำแข็งไสเชิงพาณิชย์ เครื่องทำสมูทตี้ เครื่องดื่ม ทำสมูทตี้ smoothie machine เครื่องทำสเลอปี้และไอศกรีมอัตโนมัติ ( สี Snow สีขาว )",
        "product_image": "https://img.lazcdn.com/g/p/3ac2d7f639ee7edbdcab6f342b4072d7.jpg_200x200q90.jpg",
        "price": 10796,
        "remark": "https://www.lazada.co.th/products/pdp-i6060233548.html",
        "sold": 0
    },
    {
        "product_name": "Ryobi | รอกตกปลาแบบสโลว์จิกกิ้งที่ทำจากโลหะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saf0c7824d2644c838f5b475cb7555d1aC.jpg_200x200q90.jpg",
        "price": 10787.24,
        "remark": "https://www.lazada.co.th/products/pdp-i5974472612.html",
        "sold": 0
    },
    {
        "product_name": "VERGIN เครื่องสูบน้ำ 8.5 แรง 3 นิ้ว  ดูดลึก ส่งไกล เบนซิน 4 จังหวะ ส่งไกล900+ เมตร ดูดลึก 12 เมตร ส่งสูง 28 เมตร รุ่น 1 ใบพัด (มาตราฐานญี่ปุ่น)",
        "product_image": "https://img.lazcdn.com/g/p/adfa4aee7ce56ea8ec5411006e6ab678.jpg_200x200q90.jpg",
        "price": 10780,
        "remark": "https://www.lazada.co.th/products/pdp-i5433115982.html",
        "sold": 2
    },
    {
        "product_name": "MAKITA 9500NB เครื่องเจียร์ไฟฟ้า 4 นิ้ว ฉนวน 2 ชั้น 570W มากีต้า",
        "product_image": "https://img.lazcdn.com/g/p/a378e78527c7455f8d8160756fbd8309.jpg_200x200q90.jpg",
        "price": 10680,
        "remark": "https://www.lazada.co.th/products/pdp-i5689870478.html",
        "sold": 0
    },
    {
        "product_name": "Panson เครื่องสเลอปี้ เครื่องทำน้ำแข็งไสเชิงพาณิชย์ เครื่องทำสมูทตี้ เครื่องดื่ม ทำสมูทตี้ smoothie machine เครื่องทำสเลอปี้และไอศกรีมอัตโนมัติ ( สี Snow สีขาว )",
        "product_image": "https://img.lazcdn.com/g/p/7639513861d68d5956bc0913a798f235.jpg_200x200q90.jpg",
        "price": 10658,
        "remark": "https://www.lazada.co.th/products/pdp-i6059600050.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟมาตรฐานน้ำหนักเบาแบบม้วนได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sce3a41da4e564d24a60a6794bd80f3b2P.jpg_200x200q90.jpg",
        "price": 10572.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16053809715.html",
        "sold": 7
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟ PGM รุ่นพรีเมียม ฐานพับได้ กระเป๋าแม่เหล็ก ช่องเก็บเครื่องดื่มควบคุมอุณหภูมิ กันน้ำ 100%",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S232906cb5df94edaa15b28744e7836252.jpg_200x200q90.jpg",
        "price": 10561.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6003152981.html",
        "sold": 1
    },
    {
        "product_name": "Nespresso เครื่องชงกาแฟ รุ่น Essenza Mini C Range",
        "product_image": "https://img.lazcdn.com/g/p/254d18b8d646a2c70f33680d6b0ab228.jpg_200x200q90.jpg",
        "price": 10450,
        "remark": "https://www.lazada.co.th/products/pdp-i1023720466.html",
        "sold": 2395
    },
    {
        "product_name": "รอกหยดน้ำ SHIMANO CURADO 300K",
        "product_image": "https://img.lazcdn.com/g/p/05a1254609258cb262d2f4d19cbdb92c.jpg_200x200q90.jpg",
        "price": 10400,
        "remark": "https://www.lazada.co.th/products/pdp-i4254931824.html",
        "sold": 6
    },
    {
        "product_name": "เครื่องยนต์ดีเซล 4จังหวะ สูบเอียง กำลัง 7แรงม้า ความเร็วรอบ 3000รอบ/นาที ยี่ห้อ TAKARA รุ่น MET012 (รับประกัน 6เดือน)",
        "product_image": "https://img.lazcdn.com/g/p/2a67e7031435b6a263fff799bc55f709.jpg_200x200q90.jpg",
        "price": 10400,
        "remark": "https://www.lazada.co.th/products/pdp-i5648266016.html",
        "sold": 21
    },
    {
        "product_name": "REAIM เครื่องปั่นไฟเบนซิน 3000W 4 จังหวะ พกพา เสียงเบา 220V กุญแจสตาร์ท สำหรับบ้านและฉุกเฉิน",
        "product_image": "https://img.lazcdn.com/g/p/11367ca6e590a67dea915b9c1f970372.jpg_200x200q90.jpg",
        "price": 10398,
        "remark": "https://www.lazada.co.th/products/pdp-i16051780796.html",
        "sold": 22
    },
    {
        "product_name": "SUMO เครื่องยนต์จี้ปูน รุ่น VE65 ของแท้ 100%",
        "product_image": "https://img.lazcdn.com/g/p/7cb34cd6f7b2d8515730b7ba8df8ecb7.jpg_200x200q90.jpg",
        "price": 10242,
        "remark": "https://www.lazada.co.th/products/pdp-i4989429083.html",
        "sold": 0
    },
    {
        "product_name": "MAKITA GA-7050 เครื่องเจียรไฟฟ้า ขนาด 7 นิ้ว กำลังไฟ 2,000 วัตต์ ความเร็วรอบตัวเปล่า 8,500 รอบ/นาที ฉนวนสองชั้น (มากีต้า)",
        "product_image": "https://img.lazcdn.com/g/p/088bf65eae0756f931bb4709b83e226b.jpg_200x200q90.jpg",
        "price": 10020,
        "remark": "https://www.lazada.co.th/products/pdp-i5004940834.html",
        "sold": 0
    },
    {
        "product_name": "CAMEL เครื่องซักผ้า 2 ถัง ความจุ 14 กิโลกรัม เครื่องซักผ้าฝาบน ซักล้าง ปั่นหมาด ฟังก์ชั่น 2In1 ใช้งานง่าย ซักเร็ว ความจุใหญ่ เครื่องซักผ้าฝาบนสองถัง",
        "product_image": "https://img.lazcdn.com/g/p/d08ce70945943e6c4db36cd07b281e63.jpg_200x200q90.jpg",
        "price": 9998,
        "remark": "https://www.lazada.co.th/products/pdp-i5819059866.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋าเดินทางกอล์ฟพกพาสำหรับผู้ชาย พร้อมช่องเก็บเครื่องดื่มกันความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9e70cdb604e8458bb69c9eac996e1921t.jpg_200x200q90.jpg",
        "price": 9982.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16055430765.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องสูบน้ำ 2 นิ้ว 7.5 แรงม้า ดูดลึก ส่งไกล เบนซิน 4 จังหวะ ส่งไกล900+ เมตร ดูดลึก 12 เมตร ส่งสูง 28 เมตร รุ่น 1 ใบพัด (มาตราฐานญี่ปุ่น)",
        "product_image": "https://img.lazcdn.com/g/p/86c842d08a694e3637e128ef38b89ff6.png_200x200q90.png",
        "price": 9980,
        "remark": "https://www.lazada.co.th/products/pdp-i4385406728.html",
        "sold": 7
    },
    {
        "product_name": "Toshiba เครื่องซักผ้าฝาบน รุ่น AW-M901BT ขนาด 8 กก",
        "product_image": "https://img.lazcdn.com/g/p/8d81b7801d0a42e447b35bc13e4eb7ca.jpg_200x200q90.jpg",
        "price": 9980,
        "remark": "https://www.lazada.co.th/products/pdp-i4591279687.html",
        "sold": 12
    },
    {
        "product_name": "เครื่องสูบน้ำ  4 จังหวะ ดูดลึก ส่งไกล รุ่นรถเข็น 2 ล้อ รุ่น 1-2 ใบพัด ขนาด 2 - 4 นิ้ว  เครื่องยนต์ 7.5 - 13 แรง เคลื่อนย้ายสะดวก (มาตราฐานญึ่ปุ่น)",
        "product_image": "https://img.lazcdn.com/g/p/126eaf811d3bb4b640c8020077b3e549.jpg_200x200q90.jpg",
        "price": 9980,
        "remark": "https://www.lazada.co.th/products/pdp-i5411332185.html",
        "sold": 1
    },
    {
        "product_name": "POLO ปั๊มน้ำเครื่องยนต์เบนซินขนาด 2\" ระบบสตาร์ท สตาร์ทมือ ขนาดท่อ 50 MM (2\"X2\") รุ่น H50ZB3040Q",
        "product_image": "https://img.lazcdn.com/g/p/mdc/1092e19ac7690053aedb3de50407f8fe.jpg_200x200q90.jpg",
        "price": 9980,
        "remark": "https://www.lazada.co.th/products/pdp-i1990714330.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องยนต์ปั่นไฟเบนซิน 2 จังหวะ ขนาด 800 w. TOTAL วัตต์เต็ม",
        "product_image": "https://img.lazcdn.com/g/p/1078bb0d2a1efa467778b92b12d3b437.jpg_200x200q90.jpg",
        "price": 9980,
        "remark": "https://www.lazada.co.th/products/pdp-i273479319.html",
        "sold": 1
    },
    {
        "product_name": "จักรเย็บผ้าไฟฟ้าขนาดเล็ก Brother GS-2700 สำหรับการเย็บผ้าทั่วไป มีลวดลายเย็บถึง 27 ลายให้เลือกใช้",
        "product_image": "https://img.lazcdn.com/g/p/ecffc3476e8406581ea818377793eeac.png_200x200q90.png",
        "price": 9980,
        "remark": "https://www.lazada.co.th/products/pdp-i665540470.html",
        "sold": 13
    },
    {
        "product_name": "Toshiba เครื่องซักผ้าฝาบนอัตโนมัติ ขนาด 8 kg รุ่น AW-M901BT (WW) AW M901BT",
        "product_image": "https://img.lazcdn.com/g/p/2a8fffae69cfcac86b89d8011598bb44.jpg_200x200q90.jpg",
        "price": 9976,
        "remark": "https://www.lazada.co.th/products/pdp-i5434260825.html",
        "sold": 0
    },
    {
        "product_name": "REAIM เครื่องปั่นไฟเบนซิน 3000W 4 จังหวะ พกพา เสียงเบา 220V กุญแจสตาร์ท สำหรับใช้ในบ้านและฉุกเฉิน",
        "product_image": "https://img.lazcdn.com/g/p/93d0a849d847bd2a56f5d6b040962a9e.jpg_200x200q90.jpg",
        "price": 9904.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16061520720.html",
        "sold": 32
    },
    {
        "product_name": "DAIWA | รอกตกปลา อัตราทดสูง (6.3-8.4) เหมาะสำหรับเหยื่อผิวน้ำที่ต้องการความเร็วในการเก็บสาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S88aab900f3654fc7802a9df208cb36e28.jpg_200x200q90.jpg",
        "price": 9783.76,
        "remark": "https://www.lazada.co.th/products/pdp-i6003333310.html",
        "sold": 44
    },
    {
        "product_name": "DEWALT รุ่น DWE492-KR เครื่องเจียร์ 9 นิ้ว 2200 วัตต์",
        "product_image": "https://img.lazcdn.com/g/p/e982204e94c9f4231ad2b399c6d29d56.jpg_200x200q90.jpg",
        "price": 9738,
        "remark": "https://www.lazada.co.th/products/pdp-i4364046811.html",
        "sold": 4
    },
    {
        "product_name": "เครื่องซักผ้าฝาบน CANDY รุ่น CTLVSB ขนาด 8 - 10 KG.",
        "product_image": "https://img.lazcdn.com/g/p/ded11d3484b9d418470117d78b4c2b2a.png_200x200q90.png",
        "price": 9640,
        "remark": "https://www.lazada.co.th/products/pdp-i4793501039.html",
        "sold": 0
    },
    {
        "product_name": "ALL STAR เครื่องอัดฉีด เครื่องอัดฉีดมินิ 4 จังหวะ + โรลม้วนสาย รุ่น AS-GX768C-3 ขนาด 1.4 Hp แถมสายพ่นยายาว 50 เมตร",
        "product_image": "https://img.lazcdn.com/g/p/47e52969e484dd199d04a9ed9264f22c.jpg_200x200q90.jpg",
        "price": 9600,
        "remark": "https://www.lazada.co.th/products/pdp-i5845672176.html",
        "sold": 0
    },
    {
        "product_name": "L&K(ขายดี)เครื่องบดเนื้อ 32A กำลังมอเตอร์ 2.2KW กำลังผลิต 180KG/H เบอร์ 32 คุณภาพดี รับประกันคุณภาพ เครื่องบดหมู เครื่องบดไก่ เครื่องบดเนื้อ",
        "product_image": "https://img.lazcdn.com/g/p/83d42f631fb66b6855b8d92776142b20.jpg_200x200q90.jpg",
        "price": 9530.2,
        "remark": "https://www.lazada.co.th/products/pdp-i4762763979.html",
        "sold": 3
    },
    {
        "product_name": "J&D(ขายดี)เครื่องบดเนื้อ 32A กำลังมอเตอร์ 2.2KW กำลังผลิต 180KG/H เบอร์ 32 คุณภาพดี รับประกันคุณภาพ เครื่องบดหมู เครื่องบดไก่ เครื่องบดเนื้อ",
        "product_image": "https://img.lazcdn.com/g/p/221108dbe1275c67719952eca49d249a.jpg_200x200q90.jpg",
        "price": 9530.2,
        "remark": "https://www.lazada.co.th/products/pdp-i4762778913.html",
        "sold": 5
    },
    {
        "product_name": "MAKITA (MJ) 9533 เครื่องเจียร์ไฟฟ้า 4นิ้ว 720W รุ่น 9533 (CB-411A) เสื้อมิเนียม    |ชิ้น| TTR Store",
        "product_image": "https://img.lazcdn.com/g/p/4f4be1b3d7e60c8691933b3a622277ce.png_200x200q90.png",
        "price": 9314,
        "remark": "https://www.lazada.co.th/products/pdp-i3190055976.html",
        "sold": 2
    },
    {
        "product_name": "เครื่องยนต์เบนซิน มดงาน ANT เครื่องยนต์ 4 จังหวะ 5.5 HP(163ซีซี) 6.5HP(196ซีซี) 13 HP(389ซีซี) เครื่องยนต์ เครื่องยนต์สูบน้ำ เครื่องเบนซิน เครื่องเรือ เครื่องยนต์อเนกประสงค์ รับประกัน 1 ปี  สวดยวด",
        "product_image": "https://img.lazcdn.com/g/p/ceeddb6ac96d0b5d2da24627f584caf9.jpg_200x200q90.jpg",
        "price": 9310.06,
        "remark": "https://www.lazada.co.th/products/pdp-i2322146627.html",
        "sold": 22
    },
    {
        "product_name": "TAZAWA รุ่นWP-20 เครื่องยนต์เบนซิน เครื่องสูบน้ำ เครื่องยนต์ 7 แรงม้า 4จังหวะ เครื่องยนต์อเนกประสงค์ สินค้าพร้อมส่ง มีบริการเก็บเงินปลายทาง",
        "product_image": "https://img.lazcdn.com/g/p/aadce9669169172c80b3e5b9031cdbf3.jpg_200x200q90.jpg",
        "price": 9200,
        "remark": "https://www.lazada.co.th/products/pdp-i4375570643.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋า 골프เบาสำหรับผู้หญิง สไตล์เกาหลี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sde18adf8795d42a38cc7bfb49bfb2fbdg.jpg_200x200q90.jpg",
        "price": 9193.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6003396188.html",
        "sold": 0
    },
    {
        "product_name": "Toshiba เครื่องซักผ้า 2 ถัง ความจุ 12 กก รุ่น VH-Q130MT",
        "product_image": "https://img.lazcdn.com/g/p/dd72032cc273685d7ecde740123bb236.jpg_200x200q90.jpg",
        "price": 9180,
        "remark": "https://www.lazada.co.th/products/pdp-i5901591564.html",
        "sold": 19
    },
    {
        "product_name": "เครื่องซักผ้า VH-Q110MT 2 ถัง ความจุ 10 กก.",
        "product_image": "https://img.lazcdn.com/g/p/36454d542d5b5331e90df000c6f7a283.jpg_200x200q90.jpg",
        "price": 9180,
        "remark": "https://www.lazada.co.th/products/pdp-i16092772650.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสูบน้ำ 3 นิ้วสตาทกุญแจ 4 จังหวะ  7.5 แรง (มาตราฐานญี่ปุ่น) ส่งไกล 900+ เมตร ลึก 12 เมตร สูง 35 เมตร",
        "product_image": "https://img.lazcdn.com/g/p/a3726f316bb129f99afb74bd79aafb15.png_200x200q90.png",
        "price": 9180,
        "remark": "https://www.lazada.co.th/products/pdp-i289758570.html",
        "sold": 49
    },
    {
        "product_name": "Daiwa | ไม้ตกปลาบนฝั่งสำหรับปลาหิน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb96010509eb34d26ad888eeee81051a6o.jpg_200x200q90.jpg",
        "price": 9084.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6003314959.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟพกพาได้ ที่พับเก็บได้ กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0ec5acd13e8146229c3ee476afa794faO.jpg_200x200q90.jpg",
        "price": 8999.4,
        "remark": "https://www.lazada.co.th/products/pdp-i16053871093.html",
        "sold": 0
    },
    {
        "product_name": "POLO เครื่องสูบน้ำติดเครื่องยนต์เบนซิน 5.5 HP เครื่องสูบน้ำ รุ่น H50ZB3040Q ราคาถูกและดีที่นี่เท่านั้น ของแท้แน่นอน",
        "product_image": "https://img.lazcdn.com/g/p/0007aa6a2193a06ad8ae4a677cb2fc6c.jpg_200x200q90.jpg",
        "price": 8900,
        "remark": "https://www.lazada.co.th/products/pdp-i1544520962.html",
        "sold": 0
    },
    {
        "product_name": "PUMPKIN เครื่องฉีดน้ำแรงดันสูง 135 บาร์ (1800วัตต์) รุ่น CHICAGO CG-135AJ 42224 รับประกัน 1 ปี ของแท้ 100% ร้านเป็นตัวแทนจำหน่ายโดยตรง",
        "product_image": "https://img.lazcdn.com/g/p/c8297bad8bc7bf5cbe3dfc8a236828cf.jpg_200x200q90.jpg",
        "price": 8880,
        "remark": "https://www.lazada.co.th/products/pdp-i4323742048.html",
        "sold": 106
    },
    {
        "product_name": "Total เครื่องเซาะร่องไฟฟ้า 5 นิ้ว พร้อมใบตัด 4 ใบ รุ่น TWLC1256 ( Wall Chaser ) เครื่องเซาะร่องคอนกรีต เซาะร่องกำแพง เครื่องกรีดผนัง รับประกัน 1 ปีเต็ม",
        "product_image": "https://img.lazcdn.com/g/p/b6e0ceb3d2e79046413a715b16b2af42.jpg_200x200q90.jpg",
        "price": 8800,
        "remark": "https://www.lazada.co.th/products/pdp-i5384623560.html",
        "sold": 0
    },
    {
        "product_name": "Total เครื่องเซาะร่อง 5 นิ้ว พร้อมใบตัด 4 ใบ รุ่น TWLC1256 ( Wall Chaser ) เครื่องเซาะร่องคอนกรีต เซาะร่องกำแพง เครื่องกรีดผนัง รับประกัน 1 ปีเต็ม",
        "product_image": "https://img.lazcdn.com/g/p/86f51e3a38f3fd08e80dc79db651d81a.jpg_200x200q90.jpg",
        "price": 8800,
        "remark": "https://www.lazada.co.th/products/pdp-i5422646712.html",
        "sold": 0
    },
    {
        "product_name": "Total เครื่องเซาะร่อง 5 นิ้ว พร้อมใบตัด 4 ใบ รุ่น TWLC1256 ( Wall Chaser ) เครื่องเซาะร่องคอนกรีต เซาะร่องกำแพง เครื่องกรีดผนัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sad4181d495d84fe5a0bc1e9c37a6c87dU.jpg_200x200q90.jpg",
        "price": 8800,
        "remark": "https://www.lazada.co.th/products/pdp-i386824769.html",
        "sold": 15
    },
    {
        "product_name": "PGM GOLF | เครื่องวัดระยะกอล์ฟ Pin-Lock พร้อมสั่นและชดเชยความลาดเอียง 1300 หลา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9561282e79b44989ac8d698737c5c26d2.jpg_200x200q90.jpg",
        "price": 8798.96,
        "remark": "https://www.lazada.co.th/products/pdp-i6003372050.html",
        "sold": 0
    },
    {
        "product_name": "Toshiba เครื่องซักผ้า 2 ถัง รุุ่น VH-Q130MT ความจุ 12 กก. ความจุถังปั่น 7 กก. รับประกัน 2 ปี มอเตอร์ 5 ปี รุ่นใหม่",
        "product_image": "https://img.lazcdn.com/g/p/22bde5ab71b4fb31321377c466bd33ad.jpg_200x200q90.jpg",
        "price": 8730,
        "remark": "https://www.lazada.co.th/products/pdp-i6072735030.html",
        "sold": 0
    },
    {
        "product_name": "Shimano Scorpion DC 100 HG รอบ 7.2 หมุนซ้าย มือสอง",
        "product_image": "https://img.lazcdn.com/g/p/ac66942aec22f42d7a676e20481d8c7c.jpg_200x200q90.jpg",
        "price": 8718,
        "remark": "https://www.lazada.co.th/products/pdp-i5981066237.html",
        "sold": 0
    },
    {
        "product_name": "Hurma | เครื่องคั้นน้ำผลไม้อัตโนมัติแยกชั้นกาก ป้อนอาหารได้มาก ทำความสะอาดง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S17616afa2de94392bb06aa82d873176bm.jpg_200x200q90.jpg",
        "price": 8650.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5877019314.html",
        "sold": 17
    },
    {
        "product_name": "เครื่องสูบน้ำ เครื่องยนต์ 8 แรงม้า ติดปั๊มหอยโข่งเหล็กหล่อ ขนาด 2 นิ้ว ประกอบพร้อมใช้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sce1eae924fbf4456be8d63c4ffd048c7s.jpg_200x200q90.jpg",
        "price": 8580,
        "remark": "https://www.lazada.co.th/products/pdp-i4789465150.html",
        "sold": 1
    },
    {
        "product_name": "Toshiba เครื่องซักผ้า 2 ถัง ขนาด 10-17 kg รุ่น VH-Q110MT/ รุ่น VH-Q180MT รับประกันมอเตอร์ 5 ปี",
        "product_image": "https://img.lazcdn.com/g/p/3b117d6956caa34370006273bcc1dac8.png_200x200q90.png",
        "price": 8380,
        "remark": "https://www.lazada.co.th/products/pdp-i268881342.html",
        "sold": 10
    },
    {
        "product_name": "Total เครื่องปั่นไฟเบนซิน 800 w รุ่น TP18001",
        "product_image": "https://img.lazcdn.com/g/p/a09aa8d69bf04a4a768aedbc1d9a62b0.png_200x200q90.png",
        "price": 8300,
        "remark": "https://www.lazada.co.th/products/pdp-i4175340486.html",
        "sold": 0
    },
    {
        "product_name": "[การอนุญาตแบรนด์]MAKITA DTM52/50 เครื่องมืออเนกประสงค์ 18v แบบชาร์จ brushless งานไม้มัลติฟังก์ชั่ตัด บด และตัดแต่งเครื่อง มาพร้อมกับแบตเตอรี่ 2 ก้อน",
        "product_image": "https://img.lazcdn.com/g/p/f124bcae881132b5914529777ffdf9d5.jpg_200x200q90.jpg",
        "price": 8260,
        "remark": "https://www.lazada.co.th/products/pdp-i5016107551.html",
        "sold": 14
    },
    {
        "product_name": "รอกชิมาโน Shimano19 Spheros 4000XG รอบ6.2:1 สินค้าแท้100%",
        "product_image": "https://img.lazcdn.com/g/p/f28804e3680f332566565ab844abc3d7.png_200x200q90.png",
        "price": 8258,
        "remark": "https://www.lazada.co.th/products/pdp-i4709978153.html",
        "sold": 0
    },
    {
        "product_name": "KOJIMA VT-30 เครื่องสูบน้ำ 3 นิ้ว เครื่องยนต์เบนซิน 4จังหวะ 2แรงม้า ปริมาณน้ำ 43คิว/ชม. (720ลิตร/นาที)",
        "product_image": "https://img.lazcdn.com/g/p/5e823f0dc7061acd34e4c0c9045bd2ea.jpg_200x200q90.jpg",
        "price": 8138,
        "remark": "https://www.lazada.co.th/products/pdp-i4977828768.html",
        "sold": 0
    },
    {
        "product_name": "TSU timeless 9 ฟุต เวท 15-30 คันเบ็ดตกปลา คันเบ็ดสปินนิ่ง คันเบ็ดเบท อุปกรณ์ตกปลา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5fe7b409d0f54968b65f7e26b3a7f5d1B.jpg_200x200q90.jpg",
        "price": 8120,
        "remark": "https://www.lazada.co.th/products/pdp-i16084508682.html",
        "sold": 0
    },
    {
        "product_name": "JADEVER เครื่องปั่นไฟ 800 วัตต์ เครื่องยนต์เบนซิน 2 จังหว่ะ รุ่น JDGEAA01 ราคาพิเศษ!!!",
        "product_image": "https://img.lazcdn.com/g/p/edb739a5db6177590fc7923fe794c29e.jpg_200x200q90.jpg",
        "price": 8100,
        "remark": "https://www.lazada.co.th/products/pdp-i5048207494.html",
        "sold": 0
    },
    {
        "product_name": "Jadever เครื่องปั่นไฟ 800 วัตต์ เครื่องยนต์เบนซิน รุ่น JDGEAA01 ( Gasoline generator )",
        "product_image": "https://img.lazcdn.com/g/p/f0e9f00a69ed01a477920fca8620f36a.jpg_200x200q90.jpg",
        "price": 8100,
        "remark": "https://www.lazada.co.th/products/pdp-i4982839960.html",
        "sold": 1
    },
    {
        "product_name": "CAMEL เครื่องซักผ้าแบบฝาบน 14kg ระบบอัตโนมัติ ซักและปั่นในเครื่องเดียว สามารถตั้งเวลาล่วงหน้าได้สูงสุด 24 ชั่วโมง ประหยัดน้ำประหยัดไฟ Washing Machine",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0ed4a76b7eb544e8b69934f6b60a4bd1i.jpg_200x200q90.jpg",
        "price": 8078,
        "remark": "https://www.lazada.co.th/products/pdp-i5899683217.html",
        "sold": 20
    },
    {
        "product_name": "CAMEL เครื่องซักผ้าฝาบน 14 กก. เครื่องซักผ้าอัตโนมัติ ซัก/การคายน้ำ 2in1 Washing Machine",
        "product_image": "https://img.lazcdn.com/g/p/d00e7897d851079bed1fd0d1f2347d74.jpg_200x200q90.jpg",
        "price": 8078,
        "remark": "https://www.lazada.co.th/products/pdp-i5891192365.html",
        "sold": 13
    },
    {
        "product_name": "【รุ่นอัพเกรด】เครื่องบดเนื้อ 32A กำลังมอเตอร์ 2.2KW กำลังผลิต 180KG/H เบอร์ 32 คุณภาพดี รับประกันคุณภาพ เครื่องบดหมู เครื่องบดไก่ เครื่องบดเนื้อ",
        "product_image": "https://img.lazcdn.com/g/p/8a82835d4267fa51d9487994bb344904.jpg_200x200q90.jpg",
        "price": 7999.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6067529490.html",
        "sold": 0
    },
    {
        "product_name": "ปั้มน้ำบาดาลไฟฟ้า ซัมเมิส มาตราฐานญี่ปุ่น ขนาด 1.5 นิ้ว บ่อกว้าง3นิ้ว มีรุ่น 18ใบพัด ส่งสูง 85เมตร พร้อมสายไฟ ทำจากสแตนเลสแท้ ทนน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/6ba20e047c74abd6d91e2f22f15171f4.jpg_200x200q90.jpg",
        "price": 7980,
        "remark": "https://www.lazada.co.th/products/pdp-i4549751246.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องเตรียมอาหาร KENWOOD MultiPro Go รุ่น FDP22.130GY",
        "product_image": "https://img.lazcdn.com/g/p/2a9cd910563b40a928db65da0d9ed60f.jpg_200x200q90.jpg",
        "price": 7974,
        "remark": "https://www.lazada.co.th/products/pdp-i4971328256.html",
        "sold": 1
    },
    {
        "product_name": "Ksrain เครื่องชงกาแฟ เครื่องชงกาแฟ สด 1350W 2.5 ลิตร 2in1 ระดับบาริ สต้ามืออาชีพ เครื่องทำกาแฟ เครื่องชงกาแฟอัตโนมัติ ตัวเครื่องเป็นสแตนเลส มาพร้อมกับเครื่องบดเมล็ดกาแฟในตัวเครื่อ สามารถกลั่นกาแฟ สตรีมฟ coffee machine Commercial Espresso machine",
        "product_image": "https://img.lazcdn.com/g/p/aa2e131d915b31df5f23b5a28515bfa4.jpg_200x200q90.jpg",
        "price": 7916,
        "remark": "https://www.lazada.co.th/products/pdp-i3879752970.html",
        "sold": 29
    },
    {
        "product_name": "SUPER M เครื่องพ่นยาแบบพกพา เครื่องยนต์ 4 จังหวะ SM-768C-6 รุ่นมีหม้อลมใหญ่เพิ่มแรงดัน ปั๊มทองเหลือง เครื่องพ่นยาลากสาย แบบหิ้ว พ่นไกล พ่นสูง ประหยัด",
        "product_image": "https://img.lazcdn.com/g/p/93dfa0c8ecb46bbb208989be70c8bfb6.jpg_200x200q90.jpg",
        "price": 7900,
        "remark": "https://www.lazada.co.th/products/pdp-i5856050976.html",
        "sold": 0
    },
    {
        "product_name": "TSU timeless m2. 9 ฟุต คันเบ็ดตกปลา คันเบ็ดสปินนิ่ง คันเบ็ดเบท อุปกรณ์ตกปลา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb6e4e6f4b1c949089dc4d45c2c2b092bg.jpg_200x200q90.jpg",
        "price": 7880,
        "remark": "https://www.lazada.co.th/products/pdp-i16084649310.html",
        "sold": 0
    },
    {
        "product_name": "POLO (โปโล) เครื่องยนต์เบนซิน 6.5 แรงม้า POLO รุ่น G200F สตาร์ทมือ สูบเดี่ยว 4 จังหวะ ความจุน้ำมันเครื่อง 196 มล.",
        "product_image": "https://img.lazcdn.com/g/p/2dd67521b2bfe3cae11e3f6572863502.jpg_200x200q90.jpg",
        "price": 7800,
        "remark": "https://www.lazada.co.th/products/pdp-i3078876791.html",
        "sold": 0
    },
    {
        "product_name": "camelbak จัดส่งจากประเทศไทยเครื่องทำน้ำเต้าหู้ โม่ถั่วเหลืองแยกกาก ถ่ายจากสินค้าจริง เครื่องทำนมถั่วเหลือง เครื่องทำน้ำเต้าหู้แยกกาก เครื่องปั่นน้่ำเต้าหู้",
        "product_image": "https://img.lazcdn.com/g/p/fea3fb4c2a215da12b0440c5ea73d813.jpg_200x200q90.jpg",
        "price": 7800,
        "remark": "https://www.lazada.co.th/products/pdp-i4238646800.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสูบน้ำ 3 นิ้ว TAZAWA รุ่น RWP30 เครื่องยนต์เบนซิน 7HP (01-4580)",
        "product_image": "https://img.lazcdn.com/g/p/7e722e6e0621c1f092c0741ec5767189.jpg_200x200q90.jpg",
        "price": 7800,
        "remark": "https://www.lazada.co.th/products/pdp-i5844534176.html",
        "sold": 1
    },
    {
        "product_name": "Braun Mall-เครื่องทำน้ำเต้าหู้ โม่ถั่วเหลืองแยกกาก ถ่ายจากสินค้าจริง เครื่องทำนมถั่วเหลือง เครื่องทำน้ำเต้าหู้แยกกาก เครื่องปั่นน้่ำเต้าหู้ เครื่องทำน้ำเต้าหู้แยกกาก แถมผ้ากรอง2ผืน/หินโม่1คู่/ถุงใส่กาก1ถุง เครื่องทำนมถั่วเหลือง น้ำนมข้าวโพด Soy Bean Machi",
        "product_image": "https://img.lazcdn.com/g/p/e1911aef3616d5e084ef0830a0e5dbb6.jpg_200x200q90.jpg",
        "price": 7800,
        "remark": "https://www.lazada.co.th/products/pdp-i5271963117.html",
        "sold": 0
    },
    {
        "product_name": "wjhh เครื่องทำน้ำเต้าหู้ โม่ถั่วเหลืองแยกกาก ถ่ายจากสินค้าจริง เครื่องทำนมถั่วเหลือง เครื่องทำน้ำเต้าหู้แยกกาก เครื่องปั่นน้่ำเต้าหู้",
        "product_image": "https://img.lazcdn.com/g/p/33c173285813846a73d965ddffd214b7.jpg_200x200q90.jpg",
        "price": 7800,
        "remark": "https://www.lazada.co.th/products/pdp-i5566152761.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสูบน้ำ เครื่องยนต์ 4 จังหวะ 3HP ARNOLD PA300 ท่อดูด 3 นิ้ว ออก 3 นิ้ว   เครื่องสูบน้ำพกพา เครื่องสูบน้ำแบบหิ้ว ชนปั๊ม ปั้มดูดน้ำเทอร์โบ",
        "product_image": "https://img.lazcdn.com/g/p/c17145a9a58854e96767245b4c2c7814.jpg_200x200q90.jpg",
        "price": 7780,
        "remark": "https://www.lazada.co.th/products/pdp-i4863515920.html",
        "sold": 1
    },
    {
        "product_name": "SUM【ส่งจากไทย】เครื่องปั่นไฟ power box 3500W  เบนซิน 4 จังหวะ 3 กิโลวัตต์ เสียงเงียบ สำหรับใช้ในบ้านขนาดเล็ก 210 ซีซี เครื่องปั่นไฟเบนซิน เสียงเบาในการใช้งานในบ้านขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/p/c137a904831298eaef9b3cc67869342a.jpg_200x200q90.jpg",
        "price": 7157.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16092975374.html",
        "sold": 37
    },
    {
        "product_name": "TSU steel lotus legend master m1. ยาว 10 ฟุต คันเบ็ดตกปลา คันเบ็ดสปินนิ่ง คันเบ็ดเบท อุปกรณ์ตกปลา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc3a5e856bdfb40cc940c3826f3994f51z.jpg_200x200q90.jpg",
        "price": 7640,
        "remark": "https://www.lazada.co.th/products/pdp-i16084607473.html",
        "sold": 0
    },
    {
        "product_name": "รอกเบทกลม OMOTO รุ่น CHIEF PLUS ดีไซน์ใหม่ล่าสุด พร้อมเฉดสีใหม่ เหมาะสำหรับตกปลาหน้าดิน/สวาย/งานบ่อ/งานเขื่อน/งานทะเล",
        "product_image": "https://img.lazcdn.com/g/p/5cf2d077e22c3ac3ad3f9c77996d52d5.jpg_200x200q90.jpg",
        "price": 7600,
        "remark": "https://www.lazada.co.th/products/pdp-i5570535020.html",
        "sold": 9
    },
    {
        "product_name": "HIStAR | รีลตกปลาไฟเบอร์คาร์บอน Hastra Extreme Feather 99 น้ำหยด น้ำหนักเบา ระยะไกล รีลตกปลาขนาดเล็ก รีลเส้นด้าย Lure สำหรับตกปลาในแม่น้ำและทะเล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S65ef3ea8887f47499f81772badacbd9a9.jpg_200x200q90.jpg",
        "price": 7591.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5841290322.html",
        "sold": 130
    },
    {
        "product_name": "เครื่องซักผ้าถังคู่ ME-W105 Meier เครื่องซักผ้า2ถัง ฝาบน ขนาด 10.5 กก ถั่นปั่นแห้งเป็นสแตนเลส. รุ่น  ขายผงซักฟอก",
        "product_image": "https://img.lazcdn.com/g/p/7c47a86213fc256e7babf7dd39c39aef.png_200x200q90.png",
        "price": 7578,
        "remark": "https://www.lazada.co.th/products/pdp-i3301755370.html",
        "sold": 2
    },
    {
        "product_name": "[ฟรีแบตเตอรี่สองก้อน] Makita DTM50 เครื่องบดแบบชาร์จไฟได้สมบัติสากล 18V 6.0Ah แบตเตอรี่ลิเธียมงานไม้เครื่องตัดอเนกประสงค์และเครื่องตัดขอบเครื่องมือไฟฟ้า slotting กำลังสูง",
        "product_image": "https://img.lazcdn.com/g/p/daa8d2110dba24d3f7ee722ff11e1951.jpg_200x200q90.jpg",
        "price": 7530,
        "remark": "https://www.lazada.co.th/products/pdp-i5350394118.html",
        "sold": 4
    },
    {
        "product_name": "(ขายดี)เครื่องบดเนื้อ 32A กำลังมอเตอร์ 2.2KW กำลังผลิต มอเตอร์  บดไก่ บดโครงไก่ได้ทั้งตัว บดเนื้อ",
        "product_image": "https://img.lazcdn.com/g/p/e04a3e9ee7c94fb8f3cca0a49f6d9eb7.jpg_200x200q90.jpg",
        "price": 7519.46,
        "remark": "https://www.lazada.co.th/products/pdp-i5018751244.html",
        "sold": 15
    },
    {
        "product_name": "POLO เครื่องยนต์ เบนซิน 4 จังหวะ กำลังเครื่องยนต์ 7.0 แรงม้า รุ่น G211X ความจุกระบอกสูบ 208 ซีซี ถังน้ำมัน 3.6 ลิตร สตาร์ทมือ รุ่นแนะนำขายดี ของแท้ รับประกัน 1 ปีเต็ม",
        "product_image": "https://img.lazcdn.com/g/p/e71dc0f57d5ebd81a6fffdb983a30c1f.png_200x200q90.png",
        "price": 7458,
        "remark": "https://www.lazada.co.th/products/pdp-i5427786102.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟแบบมีล้อลาก โครงแข็ง 3Dน้ำหนักเบา 4.8 กก. มีที่ใส่หมวก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S914d80265eeb41d5993fee02e6be19c1x.jpg_200x200q90.jpg",
        "price": 7424.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6066553641.html",
        "sold": 0
    },
    {
        "product_name": "REAIM เครื่องปั่นไฟ เครื่องปั่นไฟเล็ก เครื่องกำเนิดไฟฟ้าเบนซิน มอเตอร์ 4จังหวะ 1000W 98CC มือดึงสตาร์ท  มอเตอร์ทองแดงแท้100% โครงแข็งแรง เคลือบกันสนิม",
        "product_image": "https://img.lazcdn.com/g/p/fb216918cc5b556e31d2d50d10bf2e38.png_200x200q90.png",
        "price": 7423.18,
        "remark": "https://www.lazada.co.th/products/pdp-i5985236805.html",
        "sold": 57
    },
    {
        "product_name": "APIXINTL | เครื่องทำอาหารอัตโนมัติเต็มรูปแบบสำหรับใช้ในบ้าน พร้อมฟังก์ชันหลายอย่าง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S380bbbdf925b4a449d10951cb7770a1ae.png_200x200q90.png",
        "price": 7413.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5880036187.html",
        "sold": 7
    },
    {
        "product_name": "รอก Shimano Cardiff 200A/201A 400A/401A รอกที่ได้รับความนิยม กำลังเบรคสูง พร้อมระบบลูกปืนป้องกันน้ำเค็ม",
        "product_image": "https://img.lazcdn.com/g/p/55c559301e22da7be40dd996793094a3.jpg_200x200q90.jpg",
        "price": 7400,
        "remark": "https://www.lazada.co.th/products/pdp-i5031030588.html",
        "sold": 16
    },
    {
        "product_name": "TAZAWA  เครื่องสูบน้ำเบนซิน 1.5 inch  รุ่น WP15",
        "product_image": "https://img.lazcdn.com/g/p/7d5cb0b5ad371fd5024404217d3138fa.jpg_200x200q90.jpg",
        "price": 7398,
        "remark": "https://www.lazada.co.th/products/pdp-i5091375851.html",
        "sold": 0
    },
    {
        "product_name": "KANTOเครื่องสูบน้ำเบนซิน 3 นิ้ว(80mm.)เครื่องยนต์ 4จังหวะ7.0HP รุ่นKT-G30CXเครื่องยนต์ชนปั๊มความเร็ว3600-4000รอบ/นาทีส่งสูง28เมตรปริมารน้ำ 1100ลิตร/นาที",
        "product_image": "https://img.lazcdn.com/g/p/9c5d69bff6c79fed775cc676c30bbc1a.jpg_200x200q90.jpg",
        "price": 7340,
        "remark": "https://www.lazada.co.th/products/pdp-i4219865143.html",
        "sold": 1
    },
    {
        "product_name": "PGM GOLF | กระเป๋า 골프สำหรับผู้หญิง น้ำหนักเบา ดูดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbda82e788ceb470d845239f97be59e19Y.jpg_200x200q90.jpg",
        "price": 7319.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16055339322.html",
        "sold": 0
    },
    {
        "product_name": "6500W เครื่องเซาะร่อง สำหรับงานหล่อขึ้นรูปครั้งเดียว งานประปา และงานติดตั้งไฟฟ้า เครื่องตัดเซาะร่องผนังคอนกรีตอัตโนมัติเต็มรูปแบบ 5000r/min การกำหนดตำแหน่งโดยใช้เลเซอร์ช่วย เครื่องเซาะร่องใบมีด 135mm ความกว้างในการเซาะร่อง:40mm ความลึกในการเซาะร่อง:42mm",
        "product_image": "https://img.lazcdn.com/g/p/40fc70ed8f211d52251c040ef22752ae.png_200x200q90.png",
        "price": 7316,
        "remark": "https://www.lazada.co.th/products/pdp-i6029167452.html",
        "sold": 6
    },
    {
        "product_name": "เครื่องบดเนื้อ 32A กำลังมอเตอร์ 2.2KW กำลังผลิต 180KG/H เบอร์ 32 คุณภาพดี รับประกันคุณภาพ เครื่องบดหมู เครื่องบดไก่ เครื่องบดเนื้อ",
        "product_image": "https://img.lazcdn.com/g/p/93a0a3ecfa6ea9d0e64809d800c3135c.png_200x200q90.png",
        "price": 6720,
        "remark": "https://www.lazada.co.th/products/pdp-i5725443849.html",
        "sold": 14
    },
    {
        "product_name": "รอกเบท OMOTO CHIEF PLUS 6",
        "product_image": "https://img.lazcdn.com/g/p/ba6d78afa441a8bc966f82efe8005ad2.jpg_200x200q90.jpg",
        "price": 7300,
        "remark": "https://www.lazada.co.th/products/pdp-i5281692845.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องปั่นน้ำผลไม้ เครื่องปั่น เครื่องปั่นน้ำผลไม้พลังสูง เครื่องปั่นน้ำผลไม้ เครื่องปั่นอเนกประสงค์ เครื่องปั่นสมูทตี้ เครื่องปั่นประสิทธิภาพสูง Blender รุ่นBD-9908",
        "product_image": "https://img.lazcdn.com/g/p/64e84806633b952e68daf49855dfedd9.jpg_200x200q90.jpg",
        "price": 7300,
        "remark": "https://www.lazada.co.th/products/pdp-i355122765.html",
        "sold": 28
    },
    {
        "product_name": "SHANBEN เครื่องปั่นสมูทตี้ กำลังสูง 2200W 6ใบมีด ปั่นน้ำแข็งได้ น้ําผลไม้ พริก blender",
        "product_image": "https://img.lazcdn.com/g/p/1d8199d038b27146ad8567e8790829fd.jpg_200x200q90.jpg",
        "price": 7200,
        "remark": "https://www.lazada.co.th/products/pdp-i5906665635.html",
        "sold": 2
    },
    {
        "product_name": "เครื่องสูบน้ำเบนซิน 2 นิ้ว6.5HP ( 50mm.) KT-YAMA-20CX  KANTO",
        "product_image": "https://img.lazcdn.com/g/p/30bc6637feb90e7a3babddeb5c5148f5.jpg_200x200q90.jpg",
        "price": 7160,
        "remark": "https://www.lazada.co.th/products/pdp-i2381120407.html",
        "sold": 2
    },
    {
        "product_name": "เครื่องหั่นไฟฟ้า หั่นเนื้อ รุ่น MC-RED กำลัง 300กก/ชม. มีใบมีดใหเลือก 7 ขนาด ศูนย์ไทย",
        "product_image": "https://img.lazcdn.com/g/p/d08e4383a33cdd754204f8972222421b.jpg_200x200q90.jpg",
        "price": 7148,
        "remark": "https://www.lazada.co.th/products/pdp-i5986841209.html",
        "sold": 0
    },
    {
        "product_name": "Daiwa | รอกสปินนิ่งน้ำเค็มสำหรับการขว้างไกล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S55266836f31d424e91f17efc950b1d94k.jpg_200x200q90.jpg",
        "price": 7138.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6003397882.html",
        "sold": 0
    },
    {
        "product_name": "LONGWANGHEN | แพปลาที่เบาและทนทาน",
        "product_image": "https://img.lazcdn.com/3rd/q/aHR0cHM6Ly9hZS1waWMtYTEuYWxpZXhwcmVzcy1tZWRpYS5jb20va2YvUzRmZmNmZmRjNTMxMjQ0OTM5OWE3NTdhNTM1YmJjNGVmRy5wbmc=_200x200q90.png",
        "price": 7113.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16051062305.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำน้ำเต้าหู้แยกกาก แถมผ้ากรอง2ผืน/หินโม่1คู่/ถุงใส่กาก1ถุง เครื่องทำนมถั่วเหลือง น้ำนมข้าวโพด Soy Bean Machine เครื่องทำน้ำเต้าหู้ เครื่องปั่นน้ำเต้าหู้ โม่ถั่วเหลืองแยกกาก",
        "product_image": "https://img.lazcdn.com/g/p/26473e3c32d3a16323b3d761ddd9cf8f.jpg_200x200q90.jpg",
        "price": 7052,
        "remark": "https://www.lazada.co.th/products/pdp-i5935076125.html",
        "sold": 0
    },
    {
        "product_name": "Ellwewe รอกตกปลาไฟฟ้าแบตเตอรี่รีลมืออาชีพ14.8V สำหรับ200J 500MJ /L 600",
        "product_image": "https://img.lazcdn.com/g/p/3e234363fb2c583eb09a349deecd0291.jpg_200x200q90.jpg",
        "price": 7040,
        "remark": "https://www.lazada.co.th/products/pdp-i5995378377.html",
        "sold": 0
    },
    {
        "product_name": "💚พร้อมส่ง💚เครื่องปั่นหน้าปูน 15\" SUMO รุ่น 7800 กำลังไฟฟ้า 800W (เครื่องแท้ประกันศูนย์ 6 เดือน)",
        "product_image": "https://img.lazcdn.com/g/p/65cb0dbd2d9dca6fa6f45e0929ee5697.jpg_200x200q90.jpg",
        "price": 7000,
        "remark": "https://www.lazada.co.th/products/pdp-i4800413943.html",
        "sold": 1
    },
    {
        "product_name": "ใหม่! ETZEL เครื่องชงกาแฟ หน้าจอสัมผัส 20 บาร์ รุ่น SN5082 (ชงแคปซูลได้) Espresso Machine with digital display",
        "product_image": "https://img.lazcdn.com/g/p/29ce42edf75660d9b902bb2eae31de46.jpg_200x200q90.jpg",
        "price": 6980,
        "remark": "https://www.lazada.co.th/products/pdp-i5290039211.html",
        "sold": 9
    },
    {
        "product_name": "DINGQI เครื่องยนต์เบนซินปั่นไฟ เครื่องปั่นไฟ  2.0 HP รุ่น 108005",
        "product_image": "https://img.lazcdn.com/g/p/ea5d309542f1599d98bc37c271d38acc.png_200x200q90.png",
        "price": 6980,
        "remark": "https://www.lazada.co.th/products/pdp-i3920781555.html",
        "sold": 12
    },
    {
        "product_name": "TSU timeless 8.6 ฟุต เวท 15-30 คันเบ็ดตกปลา คันเบ็ดสปินนิ่ง คันเบ็ดเบท อุปกรณ์ตกปลา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S716a110d2bbc46048fb0ea328a9b46a73.jpg_200x200q90.jpg",
        "price": 6920,
        "remark": "https://www.lazada.co.th/products/pdp-i16084562387.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋า 골프สำหรับผู้หญิงกันน้ำ เบา สายหิ้วคู่ 25 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S16145ac91826439eb4d0ecf032df7331C.jpg_200x200q90.jpg",
        "price": 6903.66,
        "remark": "https://www.lazada.co.th/products/pdp-i6066398954.html",
        "sold": 0
    },
    {
        "product_name": "[สินค้าใหม่] เครื่องปั่นแบบพกพา Tefal Blend Up รุ่น BL19H4F0",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S36b7d92ef9db4dfd8e32091f455e8f8dd.jpg_200x200q90.jpg",
        "price": 6820,
        "remark": "https://www.lazada.co.th/products/pdp-i5548427991.html",
        "sold": 67
    },
    {
        "product_name": "เครื่องชงกาแฟ HiBREW Cafetera 20บาร์ Inox เครื่องชงกาแฟบางเฉียบแบบฝักและผงเครื่องชงกาแฟเอสเพรสโซ H11น้ำร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3c4503bca6ec41afa761a4e465f9c3a1s.jpg_200x200q90.jpg",
        "price": 6798,
        "remark": "https://www.lazada.co.th/products/pdp-i5148014211.html",
        "sold": 18
    },
    {
        "product_name": "KAYANA ( เครื่องสูบน้ำ 3 นิ้ว) เครื่องสูบน้ำเบนซิน เครื่องปั๊มน้ำ เครื่องยนต์ 4 จังหวะ  ขนาด 3 นิ้ว  เครื่องยนต์แรง 9.5 แรงม้า  JAPAN BRAND",
        "product_image": "https://img.lazcdn.com/g/p/06732b2033383c3bdcf081dd02a6ea96.png_200x200q90.png",
        "price": 6780,
        "remark": "https://www.lazada.co.th/products/pdp-i1988764701.html",
        "sold": 295
    },
    {
        "product_name": "KAYANA เครื่องสูบน้ำ 9.5 แรงม้า ขนาด 3 นิ้ว และ แบรนด์ MITSURIKI 8.5 แรงม้า ปั้มเครื่องยนต์เบนซิน เครื่องสูบน้ำเบนซิน แรงที่สุดในรุ่น",
        "product_image": "https://img.lazcdn.com/g/p/108210f52cf2a049272c5ad1dee38f48.png_200x200q90.png",
        "price": 6780,
        "remark": "https://www.lazada.co.th/products/pdp-i2380019583.html",
        "sold": 480
    },
    {
        "product_name": "CAMEL เครื่องซักผ้า2ถัง เครื่องซักผ้า 18kg ตัวเครื่องกันสนิม ประหยัดพลังงาน เสียงเงียบ เครื่องซักผ้ากึ่งอัตโนมัติ ถังซักคู่ big washing machines",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdf449fb3dd8a46379d1aec6959e5a636A.jpg_200x200q90.jpg",
        "price": 6778,
        "remark": "https://www.lazada.co.th/products/pdp-i5800272135.html",
        "sold": 46
    },
    {
        "product_name": "KANTO เรือรดน้ำ รุ่น KT-LION-BOAT เครื่องยนต์ 2จังหวะ 4แรงม้า ขนาดสาย 1.5นิ้ว(แถมฟรีสายฉีด5เมตร) (รับประกัน 6เดือน)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0e02a0de0fb64dbdadeafc3e5cb3e951a.jpg_200x200q90.jpg",
        "price": 6700,
        "remark": "https://www.lazada.co.th/products/pdp-i5098026706.html",
        "sold": 1
    },
    {
        "product_name": "รอกเบท OMOTO CHIEF #PLUS 6000CS",
        "product_image": "https://img.lazcdn.com/g/p/4bb61831639163c6d1b4f48005bb8177.jpg_200x200q90.jpg",
        "price": 6700,
        "remark": "https://www.lazada.co.th/products/pdp-i5283423484.html",
        "sold": 1
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟยืนแบบกันน้ำและเบา สำหรับทุกเพศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S09cac387512241f998de717c46524375t.jpg_200x200q90.jpg",
        "price": 6695.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6066724083.html",
        "sold": 0
    },
    {
        "product_name": "【รับประกัน 10 ปี】เครื่องเจาะไฮดรอลิกไฟฟ้า พกพาสะดวก เหล็กฉาก เหล็กฉาก เหล็กช่องเจาะ เครื่องเจาะรูสแตนเลส เครื่องมือเจาะเหล็กช่องสแตนเลส งานเจาะแผ่น, งานเจาะเหล็กช่อง, งานเจาะเหล็กฉาก แรง : 20T ความหนา: ≤8MM เส้นผ่านศูนย์กลางการเจาะ: 4-22MM",
        "product_image": "https://img.lazcdn.com/g/p/8e90898088788dde02977bceda94da63.png_200x200q90.png",
        "price": 6689.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5682980671.html",
        "sold": 73
    },
    {
        "product_name": "【รับประกัน 10 ปี】เครื่องเซาะร่องผนังแบบพกพา กำลังสูง 6500 วัตต์ (พร้อมเลเซอร์) 5 ใบมีด รุ่น 133 มอเตอร์ทองแดงบริสุทธิ์ ใบเลื่อยเพชร สามารถปรับความลึกของการตัดได้ตั้งแต่ 1-42MM. ความเร็วที่กำหนด: 5,000rpm/min มาตรฐานยุโรป",
        "product_image": "https://img.lazcdn.com/g/p/bbc9f9449e42dd4cb1ddbbc21873016b.png_200x200q90.png",
        "price": 6640.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5980805605.html",
        "sold": 5
    },
    {
        "product_name": "PGM|กระเป๋ากอล์ฟจุได้ 14 ไม้ น้ำหนักเบา พกพาสะดวก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S21d86334ff2d4922a3f9c5c5b1b1d9c2J.jpg_200x200q90.jpg",
        "price": 6636.76,
        "remark": "https://www.lazada.co.th/products/pdp-i6003378890.html",
        "sold": 44
    },
    {
        "product_name": "เครื่องทำน้ำเต้าหู้ โม่ถั่วเหลืองแยกกาก ถ่ายจากสินค้าจริง เครื่องทำนมถั่วเหลือง เครื่องทำน้ำเต้าหู้แยกกาก เครื่องปั่นน้่ำเต้าหู้",
        "product_image": "https://img.lazcdn.com/g/p/e5fe75998e5bdb99a2305514ffb02058.png_200x200q90.png",
        "price": 5771.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5538035165.html",
        "sold": 2
    },
    {
        "product_name": "พร้อมส่ง WGEAA01 เครื่องปั่นไฟ เบนซิน แบบ 2 จังหวะ ใช้ง่าย เสียงดังเท่ามอเตอร์ไซ ของแท้ มีประกัน 6 เดือนจาก WADFOW",
        "product_image": "https://img.lazcdn.com/g/p/2d28d1a67949b1d87b692bab665a60c8.jpg_200x200q90.jpg",
        "price": 6620,
        "remark": "https://www.lazada.co.th/products/pdp-i5758334379.html",
        "sold": 0
    },
    {
        "product_name": "Blendera เครื่องทำสมูทตี้ชานมร้านค้าเครื่องการชงชานมปั่นแบบโกนหนวดเครื่องบดน้ำแข็งเรียบพร้อมฝาครอบเครื่องปั่นอาหารผนังแตกแบบเงียบ  2L 2600w",
        "product_image": "https://img.lazcdn.com/g/p/35a74cc6728dbe4576c2e28b9170323e.jpg_200x200q90.jpg",
        "price": 6598,
        "remark": "https://www.lazada.co.th/products/pdp-i5028037276.html",
        "sold": 38
    },
    {
        "product_name": "SHIMANO Metanium Mg7 หมุนซ้าย รอบ 7 มือสอง",
        "product_image": "https://img.lazcdn.com/g/p/604bfc63b625285c5c3d574a9dbf1111.jpg_200x200q90.jpg",
        "price": 6598,
        "remark": "https://www.lazada.co.th/products/pdp-i6007529249.html",
        "sold": 0
    },
    {
        "product_name": "รอกสปิน SHIMANO NASCI 2026",
        "product_image": "https://img.lazcdn.com/g/p/932d5783ece4f3a787e080b8e4cb56bd.png_200x200q90.png",
        "price": 6520,
        "remark": "https://www.lazada.co.th/products/pdp-i6026650497.html",
        "sold": 2
    },
    {
        "product_name": "【RM】เครื่องทำน้ำเต้าหู้ โม่ถั่วเหลืองแยกกาก ถ่ายจากสินค้าจริง เครื่องทำนมถั่วเหลือง เครื่องทำน้ำเต้าหู้แยกกาก เครื่องปั่นน้่ำเต้าหู้",
        "product_image": "https://img.lazcdn.com/g/p/0ed95702b41d1e281c29aa82ac9826f4.jpg_200x200q90.jpg",
        "price": 6503.64,
        "remark": "https://www.lazada.co.th/products/pdp-i5220208435.html",
        "sold": 0
    },
    {
        "product_name": "เรือปั๊มรดน้ำ เรือรดน้ำสวน เรือสูบน้ำ เรือพ่นน้ำ เรือปั้มน้ำ เครื่องยนต์ 2 จังหวะ AZANO รุ่น AZWP520",
        "product_image": "https://img.lazcdn.com/g/p/e195adb31bb9cf8a8653b530bce0c472.jpg_200x200q90.jpg",
        "price": 6160,
        "remark": "https://www.lazada.co.th/products/pdp-i3346913158.html",
        "sold": 0
    },
    {
        "product_name": "KANTOเครื่องสูบน้ำเบนซิน 2 นิ้ว6.5HP ( 50mm.) KT-YAMA-20CX",
        "product_image": "https://img.lazcdn.com/g/p/mdc/a0a4d346a82f4cfb31c597da91e53ff6.jpg_200x200q90.jpg",
        "price": 6500,
        "remark": "https://www.lazada.co.th/products/pdp-i1800514470.html",
        "sold": 8
    },
    {
        "product_name": "เครื่องบดสับย่อยผักและเนื้อ /ตีผสม (Vegetable and Meat Chopper Machine ) CY-220",
        "product_image": "https://img.lazcdn.com/g/p/068f9e95bf768e351d237c8d176d0b17.jpg_200x200q90.jpg",
        "price": 6418,
        "remark": "https://www.lazada.co.th/products/pdp-i2042676151.html",
        "sold": 5
    },
    {
        "product_name": "เครื่องสูบน้ำชนเครื่อง พญานาค ขนาด 2นิ้ว สีทอง เหมาะสำหรับเครื่องยนต์ 9HP-13HP",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb831dc96cb054aafb95da2d30d826b51V.jpg_200x200q90.jpg",
        "price": 6400,
        "remark": "https://www.lazada.co.th/products/pdp-i5101530160.html",
        "sold": 1
    },
    {
        "product_name": "TURBOMAX เครื่องสูบน้ำ ขนาด 3 นิ้ว เครื่องยนต์ 7.5 แรงม้า ไม่โกงแรง เครื่องสูบน้ำเบนซิน ปั้มเครื่องยนต์เบนซิน ได้ปริมาณน้ำ 58000ลิตรต่อชั่วโมง",
        "product_image": "https://img.lazcdn.com/g/p/678a769a032183f43121a54cbd8562eb.png_200x200q90.png",
        "price": 6400,
        "remark": "https://www.lazada.co.th/products/pdp-i5861444793.html",
        "sold": 0
    },
    {
        "product_name": "CAMEL เครื่องซักผ้าฝาบน เครื่องซักผ้า ซักและปั่นหมาด 2IN1 เครื่องซักผ้า 14kg อัตโนมัติ washing machine ซักผ้าทรงพลัง 360° ระบบทำความสะอาดตัวเอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc4752426107c47afa819fd1561a289c8G.jpg_200x200q90.jpg",
        "price": 6398,
        "remark": "https://www.lazada.co.th/products/pdp-i5900471361.html",
        "sold": 49
    },
    {
        "product_name": "เครื่องสูบน้ำเบนซิน Tomitsu 4'' 8.5HPMAX ปั๊มใหม่ 4 จังหวะสตาร์ทง่าย ปั๊มชนเครื่อง เครื่องสูบน้ำเบนซิน เครื่องยนต์ เครื่องยนต์เบนซิน",
        "product_image": "https://img.lazcdn.com/g/p/97cc921f9c535196634624d6591a1fc9.jpg_200x200q90.jpg",
        "price": 6380,
        "remark": "https://www.lazada.co.th/products/pdp-i4367957272.html",
        "sold": 47
    },
    {
        "product_name": "เครื่องสูบน้ำ Rabin รุ่น WP25X  (สีแดง) 4 จังหวะ เครื่องสูบน้ำชนปั้มเทอร์โบ เครื่องสูบน้ำเครื่องยนต์ 4 จังหวะ (01-3695)",
        "product_image": "https://img.lazcdn.com/g/p/3e7735771262b61b6750917be7f9d318.jpg_200x200q90.jpg",
        "price": 6380,
        "remark": "https://www.lazada.co.th/products/pdp-i3355081985.html",
        "sold": 13
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟสำหรับเด็กหลายฟังก์ชันพร้อมขาตั้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S23328e1cff9e40b59fd9c69901742d90D.jpg_200x200q90.jpg",
        "price": 6324.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16055392297.html",
        "sold": 3
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟสำหรับเด็กพกพาได้สะดวก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S533f9f7e2003499785115904b7205f8cQ.jpg_200x200q90.jpg",
        "price": 6295.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16055201358.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋าใส่เสื้อผ้าและรองเท้ากอล์ฟสำหรับผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S272fcc82100240208c8c7dac6359cf64C.jpg_200x200q90.jpg",
        "price": 6286.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16053791609.html",
        "sold": 2
    },
    {
        "product_name": "คันตีเหยื่อปลอม Shimano Bass One XT+ 2023 ของแท้",
        "product_image": "https://img.lazcdn.com/g/p/33e3dac066f6af48054821f25688f2f9.jpg_200x200q90.jpg",
        "price": 6200,
        "remark": "https://www.lazada.co.th/products/pdp-i5834854732.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องผลิตน้ำแข็ง Marshall HZB-16A ทำน้ำแข็งได้เร็ว ผลิตน้ำแข็งภายใน 8 นาที เครื่องทำงานเงียบ - เครื่องน้ำแข็ง เครื่องผลิตน้ำแข็งขนาดเล็ก ที่ทำน้ำแข็ง เครื่องทำน้ำแข็ง เครื่องทำน้ำแข็งขนาดเล็ก ตู้ผลิตน้ำแข็ง ตู้ทำน้ำแข็ง ตู้ทำน้ำแข็งขนาดเล็ก ice maker",
        "product_image": "https://img.lazcdn.com/g/p/7d569b24bcfe7eddad8a63d9c65cbc2b.jpg_200x200q90.jpg",
        "price": 6180,
        "remark": "https://www.lazada.co.th/products/pdp-i1356710320.html",
        "sold": 0
    },
    {
        "product_name": "WASABI เครื่องสูบน้ำ รุ่น WB-WP415 1.5แรงม้า เครื่องยนต์ 4จังหวะ (ลานดึงสตาร์ท) ขนาด 1.5นิ้ว TOTALHEAD 35เมตร เครื่องสูบน้ำพกพา ปั๊มน้ำหูหิ้ว เครื่องดูดน้ำ ปั๊มดูดน้ำ ปั๊มน้ำ เครื่องชนปั๊ม จัดส่ง Flash Express",
        "product_image": "https://img.lazcdn.com/g/p/c5fa6db4fd7d426e2b27793e2ef7b253.jpg_200x200q90.jpg",
        "price": 6180,
        "remark": "https://www.lazada.co.th/products/pdp-i5877910524.html",
        "sold": 1
    },
    {
        "product_name": "PGM GOLF | ไม้กอล์ฟเหล็กสำหรับผู้ชายซ้ายมือ หมายเลข 7",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S98abfe0cd1774c44b945f577f2cade0aM.jpg_200x200q90.jpg",
        "price": 6077.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16055091703.html",
        "sold": 0
    },
    {
        "product_name": "Shimano | ไม้เบ็ดตกปลาเหยื่อปลอมสำหรับปลาบัสและปลาเพิร์ช",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf5a78160205b4c258d513d04908cfba8W.jpg_200x200q90.jpg",
        "price": 6009.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6003327218.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องพ่นหว่าน2จังหวะและ4จังหวะไรโนครื่องพ่นหว่าน RHINO 2 จังหวะ เครื่องยนต์แรง ทนทานเครื่องพ่นเมล็ดข้าว เครื่องพ่นปุ๋ย ไรโน่ แบบสะพายหลังสะพายหลัง เบา ใช้ง่าย",
        "product_image": "https://img.lazcdn.com/g/p/953bfe26ee4819c546377607276181b0.jpg_200x200q90.jpg",
        "price": 6000,
        "remark": "https://www.lazada.co.th/products/pdp-i5891008027.html",
        "sold": 0
    },
    {
        "product_name": "KASHIWA เครื่องซักผ้า 2 ถัง ซัก-ปั่นแห้ง ขนาด 5.5 กิโล  รุ่น S36D พร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/p/d376507a5dee835a10301b034bc51ed8.jpg_200x200q90.jpg",
        "price": 5998,
        "remark": "https://www.lazada.co.th/products/pdp-i5753520798.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสูบน้ำ 2 นิ้ว/3 นิ้ว 8.5 แรงม้า เบนซิน 4 จังหวะ 45m³/H ปั๊มชนเครื่อง เครื่องสูบน้ำเบนซิน เครื่องยนต์ เครื่องยนต์เบนซิน (การจัดส่งที่รวดเร็ว）",
        "product_image": "https://img.lazcdn.com/g/p/03cf686f9be52bc0ade60c640f126a45.jpg_200x200q90.jpg",
        "price": 5996,
        "remark": "https://www.lazada.co.th/products/pdp-i5950935023.html",
        "sold": 0
    },
    {
        "product_name": "DELTON เครื่องสูบน้ำ 3 นิ้ว 8.5 แรงม้า ปั๊มใหม่ แรงดันสูง 4 จังหวะ สตาร์ทง่าย ปั๊มน้ำ ปั๊มชนเครื่อง เครื่องสูบน้ำเบนซิน Gasoline Water Pump เครื่องยนต์ รุ่น DT-GSE-8.5 ใช้อะไหล่ได้ทุกยี่ห้อ",
        "product_image": "https://img.lazcdn.com/g/p/a217a45234c6e35230c189db5f999c3c.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i5346825456.html",
        "sold": 1
    },
    {
        "product_name": "STELLAR เครื่องสูบน้ำ 3 นิ้ว 8.5 แรงม้า ปั๊มใหม่ แรงดันสูง 4 จังหวะ สตาร์ทง่าย ปั๊มน้ำ ปั๊มชนเครื่อง เครื่องสูบน้ำเบนซิน Gasoline Water Pump เครื่องยนต์ รุ่น ST-GSE-8.5 ใช้อะไหล่ได้ทุกยี่ห้อ",
        "product_image": "https://img.lazcdn.com/g/p/31e5f2b011ae1c3e82b702d29309069b.png_200x200q90.png",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i4572883474.html",
        "sold": 3
    },
    {
        "product_name": "เครื่องสูบน้ำ 8.5 แรง 3 นิ้ว ยี่ห้อVERGIN ดูดลึก ส่งไกล เบนซิน 4 จังหวะ ส่งไกล900+ เมตร ดูดลึก 12 เมตร ส่งสูง 28 เมตร ตร รุ่น",
        "product_image": "https://img.lazcdn.com/g/p/cfdea8ebd58bc293cc1164ed7ad5d5ba.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i5628665003.html",
        "sold": 2
    },
    {
        "product_name": "KONY เครื่องเซาะร่องผนังคอนกรีต 5 นิ้ว 5800W No.KN-EL013\n\n- แรงดันไฟฟ้า : 220V\n- กำลังขับ : 5700W\n- กำลังโหลดสูงสุด : 5800W\n- ความเร็วรอบเปล่า : 5700RPM\n- กำลังใช้งานปกติ : 2800W\n- ความสามารถในการตัด : ลึกสูงสุด 32MM / กว้าง 40MM\n\n- เหมาะสำหรับ การเดินสาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0a7234e5be8a4e618aaa5b9e964a7a6aZ.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i5936910370.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสูบน้ำ 3 นิ้ว 7.5แรง เบนซิน MITSUZEN ,เครื่องเบนซินชนปั๊มขนาด3 นิ้ว,เครื่องยนต์,เครื่องยนต์สูบน้ำมิตซูเซน 7แรง ขนาด 3 นิ้วปั๊มชนเครื่อง",
        "product_image": "https://img.lazcdn.com/g/p/1df4721af6bb9dd626fb06fe20b585aa.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i1391094617.html",
        "sold": 15
    },
    {
        "product_name": "เครื่องสูบน้ำหูหิ้ว เครื่องสูบน้ำเบนซิน 4 จังหวะ 1นิ้ว 1.5นิ้ว เครื่องยนต์ชนปั้มหูหิ้ว ปั้มชนเครื่อง เครื่องสูบน้ำ เครื่องสูบน้ำพกพา",
        "product_image": "https://img.lazcdn.com/g/p/b3017b5e03eef2045249f2274d7e3e33.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i5517690272.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องซักผ้า 8.5/10/12/15/18 กก. เครื่องซักผ้าฝาบน อัตโนมัติ เครื่องซักผ้า พร้อมด้วยฟังก์ชั่น Deep Softener ะบบ ฆ่าเชื้อและทำความสะอาดอย่างลึกล้ำ เครื่องซักผ้าฝาบนถังเดียว พร้อมถังซักแบบสแตนเลส",
        "product_image": "https://img.lazcdn.com/g/p/af698bf1d0d3d603de9130bf6b600c07.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i4863811757.html",
        "sold": 45
    },
    {
        "product_name": "Tefal เครื่องปั่น (1000 วัตต์, 0.7 ลิตร, สี Boreal Blue) รุ่น BL19H",
        "product_image": "https://img.lazcdn.com/g/p/cd7eb161b3e702dfdd80839f96a592b5.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i5909195123.html",
        "sold": 3
    },
    {
        "product_name": "Makita เครื่องเจียร์ไฟฟ้า ขนาด 4 นิ้ว ฉนวน 2 ชั้น รุ่น 9500NB",
        "product_image": "https://img.lazcdn.com/g/p/65aa6dc6b323e945f00df3d60cc86581.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i154155248.html",
        "sold": 13
    },
    {
        "product_name": "เครื่องปั่น ขายดี เครื่องปั่นเก็บเสียง การรับรองซีอี เครื่องปั่นน้ำสมูทตี้ เครื่องปั่นน้ำผลไม้ ปั่นน้ำแข็ง เครื่องปั่นน้ำแข็ง2200Wเครื่องปั่นผลไม้ COD",
        "product_image": "https://img.lazcdn.com/g/p/b7276e89f30d052e4a08d4b2a73574fd.jpg_200x200q90.jpg",
        "price": 5458,
        "remark": "https://www.lazada.co.th/products/pdp-i5163778140.html",
        "sold": 9
    },
    {
        "product_name": "เครื่องปั่นสมูทตี้ เครื่องปั่นน้ำผลไม้ เครื่องปั่นน้ำผลไม้คาเฟ่ เครื่องปั่นน้ำผลไม้สมูทตี้ เครื่องปั่นน้ำสมูทเก็บเสียง",
        "product_image": "https://img.lazcdn.com/g/p/cce30e87bffa7c664585e5e50a025df3.png_200x200q90.png",
        "price": 5966,
        "remark": "https://www.lazada.co.th/products/pdp-i4815829122.html",
        "sold": 88
    },
    {
        "product_name": "(เรือรดน้ำ แบบท่อคู่) พ่นออกข้าง เครื่องยนต์520 2จังหวะ 4แรง อุปกรณ์ครบ พร้อมใช่งาน Byดีจริงการเกษตร",
        "product_image": "https://img.lazcdn.com/g/p/123effb4024f65d5e67c1dabd37eaa6f.png_200x200q90.png",
        "price": 5962.84,
        "remark": "https://www.lazada.co.th/products/pdp-i5811095191.html",
        "sold": 0
    },
    {
        "product_name": "Accurate เครื่องชั่ง เครื่องชั่งดิจิตอล 150kg\\300kg\\500kg แบบตั้งพื้น มีใบรับรอง",
        "product_image": "https://img.lazcdn.com/g/p/169e36339b64da54c6d60de2d208f635.jpg_200x200q90.jpg",
        "price": 5960,
        "remark": "https://www.lazada.co.th/products/pdp-i16122962050.html",
        "sold": 0
    },
    {
        "product_name": "MAKITA เครื่องเจีย 5 นิ้ว M9002B เจียไฟฟ้า เจียร์ไฟฟ้า ลูกหมู 5 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/p/6b4122b4ca61dd1435f0997399afbd6b.jpg_200x200q90.jpg",
        "price": 5924,
        "remark": "https://www.lazada.co.th/products/pdp-i5780809300.html",
        "sold": 2
    },
    {
        "product_name": "Tomitsu เครื่องยนต์เบนซิน 8.5แรงม้า รุ่น 223ซีซี-เพลาทด (New-Premium) แคร้งเหล็กแท้อัพไซร์ แคมเหล็ก กรองแบบเปียก แรงเต็ม100% 4 จังหวะ เครื่องยนต์",
        "product_image": "https://img.lazcdn.com/g/p/7dde8f8195a05978e93f053145e19056.jpg_200x200q90.jpg",
        "price": 5900,
        "remark": "https://www.lazada.co.th/products/pdp-i3450325023.html",
        "sold": 161
    },
    {
        "product_name": "【รับประกัน 10 ปี】2025 รูปแบบใหม่ เครื่องบดเนื้อ Meat grinder เครื่องปั่นในครัวเรือน เครื่องเตรียมอาหารไฟฟ้ามัลติฟังก์ชั่นอัตโนมัติเต็มรูปแบบ การบรรจุเนื้อสับ สแตนเลส เครื่องบดเนื้อไฟฟ้า พลังงานสูงและประสิทธิภาพสูง",
        "product_image": "https://img.lazcdn.com/g/p/406e813dac9f567333198d6664b96643.png_200x200q90.png",
        "price": 5876,
        "remark": "https://www.lazada.co.th/products/pdp-i5522410819.html",
        "sold": 1
    },
    {
        "product_name": "DONG CHENG เครื่องเซาะร่อง กรีดผนัง 5 นิ้ว กำลังไฟฟ้า 1800 วัตต์ รุ่น DZR125S",
        "product_image": "https://img.lazcdn.com/g/p/db8ac5cb57861b024af30ba0050729b1.jpg_200x200q90.jpg",
        "price": 5858,
        "remark": "https://www.lazada.co.th/products/pdp-i5960040023.html",
        "sold": 3
    },
    {
        "product_name": "เครื่องสูบน้ำยี้ห้อ Kanto ขนาด 2\" พร้อมเครื่องยนต์ 4 จังหวะ 7 แรงม้า ส่งสูง 26 เมตร ดูดลึก 8 เมตร ปริมาณน้ำ 550 ลิตร/นาที รุ่น  KT-G20CX",
        "product_image": "https://img.lazcdn.com/g/p/61e062614107cb7f0c7608cbadbe4805.jpg_200x200q90.jpg",
        "price": 5800,
        "remark": "https://www.lazada.co.th/products/pdp-i4865762142.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสูบน้ำ เครื่องชนปั๊ม 8.5 แรง ขนาด 2 นิ่ว 3 นิ้ว แรงดันสูง 4 จังหวะ สตาร์ทง่าย ปั๊มชนเครื่อง เครื่องสูบน้ำเบนซิน WATER PUMP",
        "product_image": "https://img.lazcdn.com/g/p/e243e7ab1300a7c089a49d04757cc935.jpg_200x200q90.jpg",
        "price": 5800,
        "remark": "https://www.lazada.co.th/products/pdp-i16060469575.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสูบน้ำ ชนปั๊ม ขนาด 2 นิ้ว 3 นิ้ว 8.5 แรงม้า ดูดลึก ส่งไกล เบนซิน 4 จังหวะ สตาร์ทง่าย ปั๊มชนเครื่อง เครื่องสูบน้ำเบนซิน WATER PUMP แบรนด์ TOP",
        "product_image": "https://img.lazcdn.com/g/p/4e4c42472c26459079221af4ace191f3.jpg_200x200q90.jpg",
        "price": 5800,
        "remark": "https://www.lazada.co.th/products/pdp-i16062938067.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องอเนกประสงค์ 8.5 แรง Dragonfly เพลาทด เฟืองเหล็ก ทนทาน ลุยงานหนัก ประหยัดน้ำมัน",
        "product_image": "https://img.lazcdn.com/g/p/32eaf1698724d5b5a85be2a5d59c1467.jpg_200x200q90.jpg",
        "price": 5798,
        "remark": "https://www.lazada.co.th/products/pdp-i6059177486.html",
        "sold": 1
    },
    {
        "product_name": "เรือรดน้ำ-สูบน้ำ-พ่นน้ำ NIPPON TL 52 เบนซิน 2 จังหวะ 4แรงม้า  แถมสายยางและหัวฉีดน้ำ ครบชุด",
        "product_image": "https://img.lazcdn.com/g/p/296ab68fc15ca04afc7a4ea6bab35ffc.jpg_200x200q90.jpg",
        "price": 5798,
        "remark": "https://www.lazada.co.th/products/pdp-i5447823979.html",
        "sold": 3
    },
    {
        "product_name": "เรือสูบน้ำ-รดน้ำ-พ่นน้ำเบนซิน NIPPON TL 52  2 จังหวะ MAX 5 แถมสายฉีดยาว 3 เมตรและ 10 เมตรหัวฉีด2แบบรับประกัน 1ปี",
        "product_image": "https://img.lazcdn.com/g/p/10b5550f14db98ea34a6ddb0dc991360.jpg_200x200q90.jpg",
        "price": 5798,
        "remark": "https://www.lazada.co.th/products/pdp-i2160856828.html",
        "sold": 49
    },
    {
        "product_name": "GERUSON เครื่องปั่นไฟ เครื่องปั่นไฟเบนซิน ขนาดพกพา เครื่องยนต์ 4 จังหวะ เครื่องกำเนิดไฟฟ้าเบนซิน 4.8kw เสียงเบาในการใช้งานในบ้านขนาดเล็ก 220V เครื่องกำเนิดไฟฟ้า กุญแจสตาร์ทเครื่องยนต์",
        "product_image": "https://img.lazcdn.com/g/p/58d9cc1282444d638e81c4c7aac1fe0f.jpg_200x200q90.jpg",
        "price": 5780,
        "remark": "https://www.lazada.co.th/products/pdp-i5848500787.html",
        "sold": 12
    },
    {
        "product_name": "PPD เครื่องปั่นไฟ เครื่องปั่นไฟเบนซิน ขนาดพกพา เครื่องยนต์ 4 จังหวะ เครื่องกำเนิดไฟฟ้าเบนซิน 4.8kw เสียงเบาในการใช้งานในบ้านขนาดเล็ก 220V เครื่องกำเนิดไฟฟ้า กุญแจสตาร์ทเครื่องยนต์",
        "product_image": "https://img.lazcdn.com/g/p/9a035fa11f94ee8cd6edda0d4b7cfbbe.jpg_200x200q90.jpg",
        "price": 5780,
        "remark": "https://www.lazada.co.th/products/pdp-i5848594319.html",
        "sold": 7
    },
    {
        "product_name": "เครื่องสูบน้ำ 7.5แรงม้า 4 จังหวะ แรงดันสุง ดูดลึก 10-12 เมตร สุดประหยัดน้ำมัน1ถังใช้ได้ 6-7 ชั่วโมง ส่งไกล 900+เมตร (ใช้ต่อเนื่องนาน 8 ชั่วโมง)",
        "product_image": "https://img.lazcdn.com/g/p/1ecc7b5108aa859577b3b0742370b1d8.jpg_200x200q90.jpg",
        "price": 5780,
        "remark": "https://www.lazada.co.th/products/pdp-i2269664706.html",
        "sold": 27
    },
    {
        "product_name": "BONCHI เครื่องสูบน้ำ 2 นิ้ว / 3 นิ้ว 8.5 แรงม้า ปั๊มใหม่ แรงดันสูง 4 จังหวะ สตาร์ทง่าย ปั๊มน้ำ ปั๊มชนเครื่อง เครื่องสูบน้ำเบนซิน Gasoline Water Pump เครื่องยนต์ รุ่น 8.5 HP ใช้อะไหล่ได้ทุกยี่ห้อ",
        "product_image": "https://img.lazcdn.com/g/p/85d43f7587457710403d0d63f92f4b3d.jpg_200x200q90.jpg",
        "price": 5780,
        "remark": "https://www.lazada.co.th/products/pdp-i5261498400.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องสูบน้ำ 3 นิ้ว 8.5 แรงม้า รุ่นดึงสตาท และ กุญแจสตาท เบนซิน 4 จังหวะ ส่งไกล900+ เมตร ดูดลึก 12 เมตร ส่งสูง 28 เมตร รุ่น 1 ใบพัด (มาตราฐานญี่ปุ่น)",
        "product_image": "https://img.lazcdn.com/g/p/f2cf04f3738b6a654fc08ea90dba2c9c.png_200x200q90.png",
        "price": 5780,
        "remark": "https://www.lazada.co.th/products/pdp-i4379234153.html",
        "sold": 166
    },
    {
        "product_name": "RUIBA เครื่องเจียร์ไร้สายขนาด 4 นิ้ว 21V 4.0Ah บัลเลส ปรับความเร็วได้ 6 ระดับ PROFESSIONAL มีระบบกันสบัด รุ่น RBJM100",
        "product_image": "https://img.lazcdn.com/g/p/28a8933f63acee0bc9072c30b152629b.jpg_200x200q90.jpg",
        "price": 5780,
        "remark": "https://www.lazada.co.th/products/pdp-i4891426047.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสูบน้ำ 2 จังหวะ 4 แรง  พกพา 3 นิ้ว แถมฟรี หัวรดน้ำ 490.- ระยะส่งสูง 30 เมตร  ระยะดูดลึกสุด 8 เมตร  ปริมาตราน้ำสูงสุด 300 ลิตร / นาที",
        "product_image": "https://img.lazcdn.com/g/p/d59a53279f636596f4cc72eb0a56aa3e.png_200x200q90.png",
        "price": 5777.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5505881860.html",
        "sold": 0
    },
    {
        "product_name": "BlackBull เครื่องสูบน้ำ เบนซิน ปั๊มน้ำ ปั๊มชนเครื่อง เทารัส 4 จังหวะ 6.5 แรงม้า ขนาด 3 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/p/09dadcbe830496577642dfe03907cf88.jpg_200x200q90.jpg",
        "price": 5760,
        "remark": "https://www.lazada.co.th/products/pdp-i281236112.html",
        "sold": 17
    },
    {
        "product_name": "CASIKO เครื่องผสมอาหาร รุ่น SW 8822",
        "product_image": "https://img.lazcdn.com/g/p/2246d33b48b6de8ceb5ca98cb5a38cc7.jpg_200x200q90.jpg",
        "price": 5756,
        "remark": "https://www.lazada.co.th/products/pdp-i5205858828.html",
        "sold": 62
    },
    {
        "product_name": "Bear | เครื่องปั่นอัตโนมัติขนาดเล็กพร้อมฟังก์ชันคั้นน้ำผลไม้สำหรับใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seac26550920b4bc781fc1c5bb8020218k.jpg_200x200q90.jpg",
        "price": 5755.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5869162564.html",
        "sold": 27
    },
    {
        "product_name": "M9002B เครื่องเจียร์ 5\" MAKITA 1050W",
        "product_image": "https://img.lazcdn.com/g/p/a39a2769310393390707a65e857ecc5d.jpg_200x200q90.jpg",
        "price": 5750,
        "remark": "https://www.lazada.co.th/products/pdp-i4679419035.html",
        "sold": 1
    },
    {
        "product_name": "เรือรดน้ำ 2 จังหวะ 4 จังหวะ เครื่องยนต์ gx-35",
        "product_image": "https://img.lazcdn.com/g/p/e4fc35e2e491e79f92db8df8656d4b4c.png_200x200q90.png",
        "price": 5700,
        "remark": "https://www.lazada.co.th/products/pdp-i5088660654.html",
        "sold": 0
    },
    {
        "product_name": "จักรเย็บไฟฟ้า 38 วิธีเย็บ ระบบด้ายคู่ - จักรเย็บผ้า เครื่องเย็บผ้า จักรเย็บผ้าไฟฟ้า จักรเย็บผ้าอุตสาหกรรม จักรเย็บผ้าหนา จักรเย็บผ้ามินิ จักรเย็บผ้าขนาดเล็ก จักเหย็บผ้า เครื่องจักรเย็บผ้า sewing machine",
        "product_image": "https://img.lazcdn.com/g/p/bf187b64f7752647f30c877a5b7cfc70.jpg_200x200q90.jpg",
        "price": 5700,
        "remark": "https://www.lazada.co.th/products/pdp-i4875960484.html",
        "sold": 0
    },
    {
        "product_name": "เรือปั๊มน้ำ เรือสูบน้ำ นิปปอน (Model TL 52 ) 2จังหวะ 5แรงม้า (แถมฟรีสายฉีด10เมตร) หัวฝักบัวปรับระดับน้ำได้ 2 หัว รับประกัน 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/83394587cf7c219bf6a7832abfcccaeb.jpg_200x200q90.jpg",
        "price": 5682.04,
        "remark": "https://www.lazada.co.th/products/pdp-i4991355008.html",
        "sold": 1
    },
    {
        "product_name": "เรือสูบน้ำ เรือรดน้ำ เครื่องยนต์เบนซิน 2 จังหวะ4HP MAX5แรงม้า รุ่น TL 52 สายยาว 3 เมตรสายยาว 10 เมตรแล้วแต่กดเลือก รับประกัน 1ปี",
        "product_image": "https://img.lazcdn.com/g/p/c3757373d5e2f1b6570afea4c379093e.jpg_200x200q90.jpg",
        "price": 5682.04,
        "remark": "https://www.lazada.co.th/products/pdp-i1968974632.html",
        "sold": 77
    },
    {
        "product_name": "เรือสูบน้ำ เรือรดน้ำ เรือพ่นน้ำ เครื่องยนต์เบนซิน 2 จังหวะ4แรงม้า MAX 5 แรงม้า รุ่น TL- 52 NIPPONแถมสายฉีดยาว 3 เมตรและ 10 เมตรหัวฉีด2แบบรับประกัน 1ปี",
        "product_image": "https://img.lazcdn.com/g/p/cb2611405909c51e519abd4b238f76ca.jpg_200x200q90.jpg",
        "price": 5682.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5448113072.html",
        "sold": 3
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟกันน้ำพร้อมขาตั้งและช่องแม่เหล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4b9306268e264c358dc166c5c417c684v.jpg_200x200q90.jpg",
        "price": 5665.9,
        "remark": "https://www.lazada.co.th/products/pdp-i6066667621.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องปั่นอเนกประสงค์ Sharp รุ่น EMC-21 ความจุ 2 ลิตร 1200W สีดำ (รับประกันสินค้า 1 ปี)",
        "product_image": "https://img.lazcdn.com/g/p/4e434cd6eaa8123fc24107cb50f259bb.jpg_200x200q90.jpg",
        "price": 5638,
        "remark": "https://www.lazada.co.th/products/pdp-i5595206237.html",
        "sold": 0
    },
    {
        "product_name": "TTYGJ | กระเป๋ากอล์ฟพกพาความจุใหญ่ พร้อมรถเข็นและพัตเตอร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1d3a45db380f41cba5382f1ab4a1fab0G.jpg_200x200q90.jpg",
        "price": 5634.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5894981513.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสูบน้ำ 3 นิ้ว 6.5แรงม้า WP30 รุ่น F-80L 4 จังหวะ สตาร์ทง่าย ประหยัดพลังงาน ฮาชิเทค",
        "product_image": "https://img.lazcdn.com/g/p/36e9a96791525efa0d265ed2ffe6bcd9.png_200x200q90.png",
        "price": 5600,
        "remark": "https://www.lazada.co.th/products/pdp-i5150854508.html",
        "sold": 0
    },
    {
        "product_name": "Dragonfly เครื่องสูบน้ำเบนซิน ชนิดเครื่อง 4 จังหวะ ขนาด 8.5 แรงม้า ชนปั้มขนาดท่อเข้า-ออก 2/3 นิ้ว (เครื่องสูบน้ำ 8.5แรง ชนปั้ม 2/3 นิ้ว)",
        "product_image": "https://img.lazcdn.com/g/p/cd0f1728d718c5a3aaff7c9c6d0ec43e.jpg_200x200q90.jpg",
        "price": 5598,
        "remark": "https://www.lazada.co.th/products/pdp-i3651808947.html",
        "sold": 26
    },
    {
        "product_name": "💥【รับประกัน 10 ปี】【จัดส่งฟรี】3500W เครื่องบดเนื้อ เครื่องบด เครื่องบดเนื้อ เครื่องบดหมู บดพริก เครื่องบดไฟฟ้า ที่บดหมูแบบละเอียด เครื่องบดเนื้อ บดพริกแกง กระเทียม ฯลฯ อัดไส้กรอก พร้อมส่ง ฟรีใบมีดและแผ่นรังผึ้ง 2ชุด",
        "product_image": "https://img.lazcdn.com/g/p/dff412db6d647175357dc9c6f5bb10dd.jpg_200x200q90.jpg",
        "price": 5582.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5493084168.html",
        "sold": 30
    },
    {
        "product_name": "【รับประกัน 10 ปี】3500W เครื่องบดเนื้อ เครื่องบด  เครื่องบดหมู บดพริก เครื่องบดไฟฟ้า ที่บดหมูแบบละเอียด มิกเซอร์ เครื่องปั่นอเนกประส",
        "product_image": "https://img.lazcdn.com/g/p/7cc97d31e47d09571a4ace6ae4f3c28e.jpg_200x200q90.jpg",
        "price": 5582.2,
        "remark": "https://www.lazada.co.th/products/pdp-i4095595218.html",
        "sold": 216
    },
    {
        "product_name": "【รับประกัน 10 ปี】3500W เครื่องบดเนื้อ เครื่องบด เครื่องบดเนื้อ เครื่องบดหมู บดพริก เครื่องบดไฟฟ้า ที่บดหมูแบบละเอียด",
        "product_image": "https://img.lazcdn.com/g/p/9288bbeb92d1427d3a152b4b095cb509.png_200x200q90.png",
        "price": 5582.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5904718399.html",
        "sold": 8
    },
    {
        "product_name": "🔥รับประกัน 5 ปี🔥3500W เครื่องบดเนื้อ เครื่องบด เครื่องบดหมู บดพริก เครื่องบดไฟฟ้า ที่บดหมูแบบละเอียด",
        "product_image": "https://img.lazcdn.com/g/p/425c5254c05412ff4a2388580e94d8c1.jpg_200x200q90.jpg",
        "price": 5582,
        "remark": "https://www.lazada.co.th/products/pdp-i4779388014.html",
        "sold": 32
    },
    {
        "product_name": "🔥🔥 รับของภายใน 48H เครื่องบดเนื้อไฟฟ้า เครื่องบดเนื้อไฟฟ้าในครัวเรือน ปั่นเนื้อที่เร็วที่สุด เครื่องบด ทำไส้กรอก Meat Grinder",
        "product_image": "https://img.lazcdn.com/g/p/217c425460b652fac68332cbdb15a6ee.jpg_200x200q90.jpg",
        "price": 5582,
        "remark": "https://www.lazada.co.th/products/pdp-i3009961747.html",
        "sold": 56
    },
    {
        "product_name": "【รับประกัน 10 ปี】เครื่องบดเนื้อ Meat grinder เครื่องเตรียมอาหารไฟฟ้าขนาดเล็กในครัวเรือน มัลติฟังก์ชั่นอัตโนมัติเต็มรูปแบบ ทำไส้เนื้อ สแตนเลส พลังงานสูง เครื่องทำไส้กรอก เครื่องสับเนื้อขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/p/0b96b92c0ea3589796798c550e58d34d.png_200x200q90.png",
        "price": 5582,
        "remark": "https://www.lazada.co.th/products/pdp-i5522194699.html",
        "sold": 31
    },
    {
        "product_name": "CANON PIXMA E4270 เครื่องพิมพ์ไร้สาย ALL-IN-ONE พร้อมแฟกซ์และการพิมพ์สองหน้าแบบอัตโนมัติ (หมึก PG-47 CL-57)  by Printersale",
        "product_image": "https://img.lazcdn.com/g/p/b395f641029ef00d73e29ea3e57d6bbd.jpg_200x200q90.jpg",
        "price": 5580,
        "remark": "https://www.lazada.co.th/products/pdp-i2784202798.html",
        "sold": 0
    },
    {
        "product_name": "KASHIWA รุ่น S36C เครื่องซักผ้าฝาบน 2 ถัง ขนาด 9 กก. เครื่องซักผ้า (ถังซัก 5 กก. ถังปั่น 4 กก.) รับประกันศูนย์",
        "product_image": "https://img.lazcdn.com/g/p/131bfd99de4d526035f92b07bcdaad7b.jpg_200x200q90.jpg",
        "price": 5580,
        "remark": "https://www.lazada.co.th/products/pdp-i5828655891.html",
        "sold": 0
    },
    {
        "product_name": "AP เครื่องสูบน้ำหูหิ้ว 4จังหวะ ขนาด 1 และ 1.5 นิ้ว เครื่องสูบน้ำพกพา เครื่องสูบน้ำแบบหิ้ว ไม่ต้องใช้น้ำมัน 2T เครื่องสูบน้ำชนปั๊ม",
        "product_image": "https://img.lazcdn.com/g/p/29cfc4026977478818ca1de6865338b5.png_200x200q90.png",
        "price": 5564,
        "remark": "https://www.lazada.co.th/products/pdp-i5772970137.html",
        "sold": 0
    },
    {
        "product_name": "รอกเบท CAENAN 151 150 รอบ6 ชิมาโน่เคแนน",
        "product_image": "https://img.lazcdn.com/g/p/13b6d7d1dd5e71e821dcdcc20bf1177c.jpg_200x200q90.jpg",
        "price": 5560,
        "remark": "https://www.lazada.co.th/products/pdp-i4762703903.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสูบน้ำ 4 จังหวะ 4 แรงม้า แถมฟรีหัวรดน้ำ มูลค่า 490.- ดูดลึก 8เมตร ส่งไกล 900 เมตร มีให้เลือก ขนาด 1นิ้ว และ 1.5นิ้ว รับประกัน 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/71c9ecf36a9d02bf3a097f34d829f5d4.jpg_200x200q90.jpg",
        "price": 5357.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5382836168.html",
        "sold": 11
    },
    {
        "product_name": "KASHIWA เครื่องซักผ้า 2in1 พร้อมถังปั่นหมาด (ถังซัก 5 กก.ถังปั่นหมาด 4 กก.) รุ่น S36C",
        "product_image": "https://img.lazcdn.com/g/p/806df566856d2c245f012b15297cee58.jpg_200x200q90.jpg",
        "price": 5540,
        "remark": "https://www.lazada.co.th/products/pdp-i5829586020.html",
        "sold": 20
    },
    {
        "product_name": "เรือปั๊มน้ำ เรือสูบน้ำ นิปปอน (Model NP 52 ) 2 จังหวะ 5แรงม้า (แถมฟรีสายฉีด10เมตร) หัวฝักบัวปรับระดับน้ำได้ 2 หัว และชุดโรับประกัน 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/edc428174c2d42275bc11462fcf00db2.jpg_200x200q90.jpg",
        "price": 5533.02,
        "remark": "https://www.lazada.co.th/products/pdp-i4994815983.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | ปกป้องถุงกอล์ฟสำหรับการเดินทางทางอากาศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S95f6834fea6b4440b112779603a2d49cF.jpg_200x200q90.jpg",
        "price": 5504.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16053729847.html",
        "sold": 21
    },
    {
        "product_name": "เครื่องสูบน้ำ เบนซิน ชนิดเครื่อง 4 จังหวะ ขนาด 8.5 แรงม้า ชนปั้มขนาดท่อเข้า-ออก 2/3 นิ้ว (เครื่องlสูบน้ำ 8.5แรง ชนปั้ม 2/3 นิ้ว)",
        "product_image": "https://img.lazcdn.com/g/p/a03f0c4309fa67af504e73c2628e119c.jpg_200x200q90.jpg",
        "price": 5504.04,
        "remark": "https://www.lazada.co.th/products/pdp-i4207213238.html",
        "sold": 133
    },
    {
        "product_name": "SHIMANO SAHANO C3000HG",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc0fa411aef8b4aeaba0908e7ee9aa6a7N.jpg_200x200q90.jpg",
        "price": 5500,
        "remark": "https://www.lazada.co.th/products/pdp-i5012482418.html",
        "sold": 1
    },
    {
        "product_name": "KASHIWA รุ่น S36C เครื่องซักผ้าฝาบน 2 ถัง ขนาด 9 กก. (ถังซัก 5 กก. ถังปั่น 4 กก.) รับประกันศูนย์ 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/e771386847f8127465c935de98938f01.jpg_200x200q90.jpg",
        "price": 5500,
        "remark": "https://www.lazada.co.th/products/pdp-i5828763345.html",
        "sold": 1
    },
    {
        "product_name": "FBS เครื่องสูบน้ำเบนซิน 2นิ้ว 3 นิ้ว 4 จังหวะ 6.5/8.5แรงม้า  จังหวะสตาร์ทง่าย ปั๊มชนเครื่อง เครื่องสูบน้ำเบนซิน เครื่องยนต์ เครื่องยนต์เบนซิน ปั๊มน้ำแรงม้าสูง การสูบน้ำ ท่อระบายน้ำ พกพาสะดวก สำหรับบ้านและเกษตร อะไหล่แท้ 100%",
        "product_image": "https://img.lazcdn.com/g/p/c389a38681c13ff13935a284c79f485e.jpg_200x200q90.jpg",
        "price": 5498,
        "remark": "https://www.lazada.co.th/products/pdp-i16079124664.html",
        "sold": 20
    },
    {
        "product_name": "REAIM เครื่องสูบน้ำ 2 นิ้ว/3 นิ้ว 8.5 แรงม้า เบนซิน 4 จังหวะ 45m³/H ปั๊มชนเครื่อง เครื่องสูบน้ำเบนซิน เครื่องยนต์ เครื่องยนต์เบนซิน",
        "product_image": "https://img.lazcdn.com/g/p/37a4a4a3711d2fe59b1e02b21d950575.jpg_200x200q90.jpg",
        "price": 5447.84,
        "remark": "https://www.lazada.co.th/products/pdp-i5731377443.html",
        "sold": 127
    },
    {
        "product_name": "HW【ส่งจากไทย】เครื่องสูบน้ำ เครื่องสูบน้ำเบนซิน 4 จังหวะ ปั๊มน้ำแรงม้าสูง การสูบน้ำ ท่อระบายน้ำ  เบนซิน 8.5 แรงม้า 2นิ้ว/3 นิ้ว สำหรับงานเกษตรและอุตสาหกรรม",
        "product_image": "https://img.lazcdn.com/g/p/ed3b3bae08848b30b3c142e8af121e2f.jpg_200x200q90.jpg",
        "price": 5438,
        "remark": "https://www.lazada.co.th/products/pdp-i16091364398.html",
        "sold": 10
    },
    {
        "product_name": "เรือสูบน้ำ 2 จังหวะ TL 52 MAX 5แรงม้า แถมสาย 3 และ 10 เมตร รับประกัน 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/9d6667b4f69ab827255aa7b99fc28de6.jpg_200x200q90.jpg",
        "price": 5408.36,
        "remark": "https://www.lazada.co.th/products/pdp-i761238032.html",
        "sold": 88
    },
    {
        "product_name": "🚀【รับประกัน 10 ปี】【จัดส่งฟรี】3500W เครื่องบดเนื้อ เครื่องบด เครื่องบดเนื้อ เครื่องบดหมู บดพริก เครื่องบดไฟฟ้า ที่บดหมูแบบละเอียด Electric Grinder Fine Pork Grinder",
        "product_image": "https://img.lazcdn.com/g/p/a13112124a3f6f2f25c678d256d701c3.png_200x200q90.png",
        "price": 5405.92,
        "remark": "https://www.lazada.co.th/products/pdp-i4649074829.html",
        "sold": 260
    },
    {
        "product_name": "MAKITAES เครื่องยนต์ 4 จังหวะ เครื่องปั่นไฟ เครื่องปั่นไฟเบนซิน ขนาดพกพา เครื่องกำเนิดไฟฟ้าเบนซิน 3.35kw เสียงเบาในการใช้งานในบ้านขนาดเล็ก 220V เครื่องกำเนิดไฟฟ้า กุญแจสตาร์ทเครื่องยนต",
        "product_image": "https://img.lazcdn.com/g/p/139113af2336a2a4886d095d7ae7d7ba.jpg_200x200q90.jpg",
        "price": 5380.78,
        "remark": "https://www.lazada.co.th/products/pdp-i1816194756.html",
        "sold": 29
    },
    {
        "product_name": "STELLAR เครื่องสูบน้ำ 2 นิ้ว / 3 นิ้ว 8.5 แรงม้า ปั๊มใหม่ แรงดันสูง 4 จังหวะ สตาร์ทง่าย ปั๊มน้ำ ปั๊มชนเครื่อง เครื่องสูบน้ำเบนซิน Gasoline Water Pump เครื่องยนต์ รุ่น ST-GSE-8.5 ใช้อะไหล่ได้ทุกยี่ห้อ",
        "product_image": "https://img.lazcdn.com/g/p/f3b3b37bdd9f745cb0ab49997a6e37a6.jpg_200x200q90.jpg",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i4527889586.html",
        "sold": 128
    },
    {
        "product_name": "DELTON เครื่องสูบน้ำ 2 นิ้ว / 3 นิ้ว 8.5 แรงม้า ปั๊มใหม่ แรงดันสูง 4 จังหวะ สตาร์ทง่าย ปั๊มน้ำ ปั๊มชนเครื่อง เครื่องสูบน้ำเบนซิน Gasoline Water Pump เครื่องยนต์ รุ่น DT-GSE-8.5 ใช้อะไหล่ได้ทุกยี่ห้อ",
        "product_image": "https://img.lazcdn.com/g/p/3f9d418469c9a0664a17012228d40400.jpg_200x200q90.jpg",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i5341939380.html",
        "sold": 0
    },
    {
        "product_name": "DELTON เครื่องสูบน้ำ 2 นิ้ว 8.5 แรงม้า ปั๊มใหม่ แรงดันสูง 4 จังหวะ สตาร์ทง่าย ปั๊มน้ำ ปั๊มชนเครื่อง เครื่องสูบน้ำเบนซิน Gasoline Water Pump เครื่องยนต์ รุ่น DT-GSE-8.5 ใช้อะไหล่ได้ทุกยี่ห้อ",
        "product_image": "https://img.lazcdn.com/g/p/c1be89da0b944a785a498d0e7dfe7fdc.jpg_200x200q90.jpg",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i5346075531.html",
        "sold": 5
    },
    {
        "product_name": "เครื่องสูบน้ำ เครื่องสูบน้ำเบนซิน 2 นิ้ว 3 นิ้ว MISUZEN 7.5 แรงม้า เครื่องยนต์ 4 จังหวะ เครื่องเบนซินสูบน้ำ เครื่องเบนซิน 7.5 ยี่ห้อมิตซูเซ็น",
        "product_image": "https://img.lazcdn.com/g/p/41b0ec7bbfbcc0eb76a757194f05408b.jpg_200x200q90.jpg",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i1606388465.html",
        "sold": 13
    },
    {
        "product_name": "เครื่องสูบน้ำ 2 นิ้ว 3 นิ้ว 6.5 แรง ปั้มน้ำ เครื่องยนต์ชนปั้ม 4 จังหวะ ประหยัดน้ำมัน ยี่ห้อ Mitsushark",
        "product_image": "https://img.lazcdn.com/g/p/420e4f61ab82292521050a19e763400f.jpg_200x200q90.jpg",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i5509990376.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องยนต์เบนซิน  ขนาด 8.5 แรงม้า (เฟืองเหล็ก แท้ๆ) เครื่องยนต์อเนกประสงค์ รุ่น ร้อนไม่ดับ งานหนัก ทนร้อนสูง สตาทง่าย ประหยัดน้ำมัน",
        "product_image": "https://img.lazcdn.com/g/p/8110135a6204b323763fb4b1c1b88430.jpg_200x200q90.jpg",
        "price": 5378.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5205526427.html",
        "sold": 0
    },
    {
        "product_name": "จัดส่งที่รวดเร็ว ประเเครื่องทําสมูทตี้ 2200W เครื่องปั่น ขายดี เครื่องปั่นเก็บเสียง การรับรองซีอี เครื่องปั่นน้ำสมูทตี้ เครื่องปั่นน้ำผลไม้ ปั่นน้ำแข็ง เครื่องปั่นน้ำแข็งเครื่องปั่นผลไม้",
        "product_image": "https://img.lazcdn.com/g/p/3f76e6387b41ae6c8563ddc5543628ee.jpg_200x200q90.jpg",
        "price": 5374,
        "remark": "https://www.lazada.co.th/products/pdp-i5180406781.html",
        "sold": 9
    },
    {
        "product_name": "REALM เครื่องสูบน้ำเบนซิน 2 /3 นิ้ว 6.5/8.5แรงม้า 4 จังหวะ จังหวะสตาร์ทง่าย ปั๊มชนเครื่อง เครื่องสูบน้ำเบนซิน เครื่องยนต์ เครื่องยนต์เบนซิน ปั๊มน้ำแรงม้าสูง การสูบน้ำ ท่อระบายน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/7433d86e415b4c3aca8f2c581a32ded5.jpg_200x200q90.jpg",
        "price": 5311.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16070242184.html",
        "sold": 37
    },
    {
        "product_name": "เครื่องยนต์เบนซินเอนกประสงค์ 4 จังหวะ 196 ซีซี  PONZO POWER รุ่น PZ200 ขนาด 6.5 แรงม้า",
        "product_image": "https://img.lazcdn.com/g/p/eb946b43db5196169314a472a4921536.png_200x200q90.png",
        "price": 5300,
        "remark": "https://www.lazada.co.th/products/pdp-i5865559120.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องสูบน้ำ มิตซูแม็ก (Mitsumax) เครื่องยนต์เบนซิน 7 แรงม้า ขนาด 2 นิ้ว , 3 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/p/d19e99d4bf19bdc939c88ccebda98276.jpg_200x200q90.jpg",
        "price": 5300,
        "remark": "https://www.lazada.co.th/products/pdp-i5006073956.html",
        "sold": 2
    },
    {
        "product_name": "REAIM เครื่องสูบน้ำเบนซิน 2''/3'' 8.5HP MAX ปั๊มใหม่ 4 จังหวะสตาร์ทง่าย ปั๊มชนเครื่อง เครื่องสูบน้ำเบนซิน เครื่องยนต์ เครื่องยนต์เบนซิน",
        "product_image": "https://img.lazcdn.com/g/p/812e7e0d1a9100056c88c944c9864199.jpg_200x200q90.jpg",
        "price": 5298,
        "remark": "https://www.lazada.co.th/products/pdp-i5731112868.html",
        "sold": 12
    },
    {
        "product_name": "REAIM เครื่องสูบน้ำเบนซิน 2/3 8.5HPMAX ปั๊มใหม่ 4 จังหวะสตาร์ทง่าย ปั๊มชนเครื่อง เครื่องสูบน้ำเบนซิน เครื่องยนต์ เครื่องยนต์เบนซิน",
        "product_image": "https://img.lazcdn.com/g/p/7c9f532e756b8862432e609b4403e2a8.jpg_200x200q90.jpg",
        "price": 5298,
        "remark": "https://www.lazada.co.th/products/pdp-i5760230913.html",
        "sold": 18
    },
    {
        "product_name": "REAIM เครื่องสูบน้ำ 2 นิ้ว / 3 นิ้ว 8.5HPMAX แรงม้า ปั๊มใหม่ แรงดันสูง 4 จังหวะ สตาร์ทง่าย ปั๊มน้ำ ปั๊มชนเครื่อง เครื่องสูบน้ำเบนซิน Gasoline Water Pump",
        "product_image": "https://img.lazcdn.com/g/p/5135ad0328ab2f903a29e3603422147d.jpg_200x200q90.jpg",
        "price": 5298,
        "remark": "https://www.lazada.co.th/products/pdp-i5818908673.html",
        "sold": 61
    },
    {
        "product_name": "(F.) เครื่องอัดฉีดน้ำแรงดันสูง ฉีดน้ำ HYUNDAI TRANSFORMER III รุ่น HD-HBT-70P 105 Bar 1200 วัตต์ เครื่องอัดฉีดน้ำแรง สำหรับงานรดน้ำต้นไม้ ล้างรถ ทำความสะอาดสิ่งสกปรกต่างๆ จำหน่ายโดย Montree More",
        "product_image": "https://img.lazcdn.com/g/p/d7a5ce1eedf753679092190d922c9339.jpg_200x200q90.jpg",
        "price": 5292,
        "remark": "https://www.lazada.co.th/products/pdp-i5390165798.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | ชั้นวางไม้กอล์ฟท่อเหล็กหนา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S14b01c6e3c274e42a0990dfee0d4bc810.jpg_200x200q90.jpg",
        "price": 5267.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6003402687.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องสูบน้ำ 3 นิ้ว 8.5 แรงม้า ดูดลึก ส่งไกล เบนซิน 4 จังหวะ ส่งไกล900+ เมตร ดูดลึก 12 เมตร ส่งสูง 28 เมตร รุ่น 1 ใบพัด (มาตราฐานญี่ปุ่น)",
        "product_image": "https://img.lazcdn.com/g/p/f2cf04f3738b6a654fc08ea90dba2c9c.png_200x200q90.png",
        "price": 5242,
        "remark": "https://www.lazada.co.th/products/pdp-i4385411366.html",
        "sold": 72
    },
    {
        "product_name": "เครื่องสูบน้ำ 4จังหวะ 1.8แรงม้า พกพาระยะส่งสูง 30 เมตร ระยะดูดลึกสุด 8 เมตร ปริมาตราน้ำสูงสุด 300 ลิตร / นาที",
        "product_image": "https://img.lazcdn.com/g/p/bcd96a90f64fb8f667f280fb95f2e657.png_200x200q90.png",
        "price": 5236,
        "remark": "https://www.lazada.co.th/products/pdp-i4399637847.html",
        "sold": 20
    },
    {
        "product_name": "MAKITA  รุ่น M9003B เครื่องเจียร์ไฟฟ้า ขนาด 6 นิ้ว (150 มม.) กำลังไฟฟ้า 1050W สำหรับเจียร์และตัดโลหะ วัสดุที่เป็นหิน",
        "product_image": "https://img.lazcdn.com/g/p/a11fd37028dc7aedabfd8d524508c02b.jpg_200x200q90.jpg",
        "price": 5200,
        "remark": "https://www.lazada.co.th/products/pdp-i4980232639.html",
        "sold": 0
    },
    {
        "product_name": "TOTAL เครื่องเร้าเตอร์ไฟฟ้า 1600 วัตต์ เครื่องเซาะร่องไม้ แกะสลักไม้ ขนาด 1/2 นิ้ว รุ่น TR111216 เกรดอุตสาหกรรม",
        "product_image": "https://img.lazcdn.com/g/p/4a06add40538c7d1290de09b6bd88d08.png_200x200q90.png",
        "price": 5200,
        "remark": "https://www.lazada.co.th/products/pdp-i4957794844.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องสูบน้ำ แบบพกพา 4 จังหวะ ขนาด 1 นิ้ว หรือ 1.5 นิ้ว (มี 2 ขนาดให้เลือก) ปั๊มน้ำ เครื่องสูบน้ำเบนซิน",
        "product_image": "https://img.lazcdn.com/g/p/307801779fc0ccd4b277a01a80713227.jpg_200x200q90.jpg",
        "price": 5200,
        "remark": "https://www.lazada.co.th/products/pdp-i1324714167.html",
        "sold": 35
    },
    {
        "product_name": "MrTool【ส่งจากไทย】เครื่องสูบน้ำ เครื่องสูบน้ำเบนซิน 4 จังหวะ ปั๊มน้ำแรงม้าสูง การสูบน้ำ ท่อระบายน้ำ  เบนซิน 8.5 แรงม้า 2นิ้ว/3 นิ้ว สำหรับงานเกษตรและอุตสาหกรรม",
        "product_image": "https://img.lazcdn.com/g/p/fb201a1bb66f2643f59a55a98477cc4b.jpg_200x200q90.jpg",
        "price": 5198,
        "remark": "https://www.lazada.co.th/products/pdp-i16114414431.html",
        "sold": 11
    },
    {
        "product_name": "KASHIWA รุ่น XPB30 เครื่องซักผ้าถังเดี่ยวมินิ 2 in 1 ขนาด 3 กิโลกรัม กําลังไฟ 180 วัตต์",
        "product_image": "https://img.lazcdn.com/g/p/7d08b58312892590078c6771a694bb4b.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i5981650715.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องปริ้นเตอร์มัลติฟังก์ชันwifi Canon all in one ปริ้นท์ สแกน ถ่ายเอกสารความละเอียดสูง รองรับการใช้งานผ่านwifi ประกันศูนย์ 1ปี แถมหมึก/canon e3370",
        "product_image": "https://img.lazcdn.com/g/p/387877a6ebe7ac4a4b32ececf7a959c2.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i2206840115.html",
        "sold": 77
    },
    {
        "product_name": "เครื่องสูบน้ำเบนซิน Tomitsu 2''/3'' 8.5HPMAX(แถมฟรีสายส่งน้ำ5เมตร!!!) ปั๊มใหม่ 4 จังหวะสตาร์ทง่าย ปั๊มชนเครื่อง เครื่องสูบน้ำเบนซิน  เครื่องยนต์ เครื่องยนต์เบนซิน",
        "product_image": "https://img.lazcdn.com/g/p/0d477aa4b7120ceb3656d570f35bf2c1.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i1440322794.html",
        "sold": 1723
    },
    {
        "product_name": "เครื่องยนต์ชนปั๊ม เครื่องสูบน้ำแบบหิ้ว KAWAMA ขนาด 1.5 นิ้ว (สีแดง) (01-0132)",
        "product_image": "https://img.lazcdn.com/g/p/f41d145589dfedbc68c6fde398b73f17.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i3310534023.html",
        "sold": 0
    },
    {
        "product_name": "NEOBEE สายไฟระย้า สายแพร 5m 10m 20m ขั้ว E27 ไฟตกแต่งกลางแจ้ง กันน้ำ ต่อกันได้ รุ่น NB-SW-10 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/bc989a1e1b0ac61897e40db047c23966.jpg_200x200q90.jpg",
        "price": 6066.28,
        "remark": "https://www.lazada.co.th/products/pdp-i4361764922.html",
        "sold": 6
    },
    {
        "product_name": "MODI ไฟห้อยระย้าโซล่าเซลล์ 15เมตร30หลอด รุ่นSUPERอะคริลิค แสงเหลือง ตกแต่งสวน ปีใหม่ คริสมาส ปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/3c516d6095aaf9f8076a3150ddda1ff8.jpg_200x200q90.jpg",
        "price": 5331.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5950895698.html",
        "sold": 19
    },
    {
        "product_name": "ไฟม่านอัจฉริยะ 2 ชิ้น ไฟ LED RGB แบบสาย พร้อมซิงค์เพลง ควบคุมผ่านแอพและรีโมท ไฟประดับตกแต่งห้องนอน งานปาร์ตี้ สวน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd589a4343b994aaebce9fc5e867b2931v.jpg_200x200q90.jpg",
        "price": 5296.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5966206029.html",
        "sold": 0
    },
    {
        "product_name": "MODI ไฟห้อยระย้าโซล่าเซลล์ ไฟลูกแก้ว  ไฟปิงปอง  สายไฟห้อยระย้า15เมตร30หลอด รุ่นSUPERอะคริลิค แสงเหลือง ตกแต่งสวน ปีใหม่ คริสมาส ปาร์ตี้ คริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/p/535bc0336f04ab2e119b03e40e17d947.jpg_200x200q90.jpg",
        "price": 5226.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5952317737.html",
        "sold": 7
    },
    {
        "product_name": "RGB Neon FLEX 220V-240V ไฟเส้นแบบสายยาง ดัดงอได้อิสระ ไฟเปลี่ยนสีควบคุมผ่านรีโมทคอนโทรล เปลี่ยนสีและจังหวะไฟได้ ตกแต่งบ้านและสวน ได้ทั้งภายในและถายนอก",
        "product_image": "https://img.lazcdn.com/g/p/a94df46c0710fd6f3b8d774a60e114f9.jpg_200x200q90.jpg",
        "price": 5090,
        "remark": "https://www.lazada.co.th/products/pdp-i526432287.html",
        "sold": 103
    },
    {
        "product_name": "สายไฟห้อยระย้าขั้วe27 แถมหลอดled ปิงปอง3w 5-100เมตร(พร้อมหลอดใช้งานได้)ขั้วกันน้ำ สายไฟหนาทนทาน ติดตั้งใช้งานได้ทั้งภายในและภายนอก",
        "product_image": "https://img.lazcdn.com/g/p/0685e4f51cd58a9b076f93b4d52958b8.jpg_200x200q90.jpg",
        "price": 5000,
        "remark": "https://www.lazada.co.th/products/pdp-i4769930809.html",
        "sold": 1
    },
    {
        "product_name": "MODI ไฟห้อยระย้าโซล่าเซลล์ ไฟปิงปอง สายไฟห้อยระย้า ไฟประดับ หลอดไฟ 15เมตร30หลอด รุ่นSUPER แสงเหลือง ไฟตกแต่งสวน ปีใหม่ คริสมาส ปาร์ตี้ christmas light",
        "product_image": "https://img.lazcdn.com/g/p/1ebc14e3b802b4b4f609fad79f112bf8.jpg_200x200q90.jpg",
        "price": 4992.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5769157038.html",
        "sold": 37
    },
    {
        "product_name": "ไฟเส้น RGB Led Strip Light 5050 3 Row 220V ไฟเส้น รุ่น ไฟ3แถบ เปลี่ยนสีได้ กันน้ำ ไฟเส้นเปลี่ยนสี ไฟสำหรับตกแต่ง",
        "product_image": "https://img.lazcdn.com/g/p/c9d0ec332d6f29d890e477af4cb6bf65.jpg_200x200q90.jpg",
        "price": 4932,
        "remark": "https://www.lazada.co.th/products/pdp-i1757320704.html",
        "sold": 31
    },
    {
        "product_name": "ไฟเส้นCOB หน้าขุ่น ม้วน 100 เมตรแถมปลั๊ก 5 ชุด ไม่เห็นเม็ดไฟ LED 288เม็ด/เมตร 220V แสงขาว,วอร์ม,คลูไวท์ ไฟสายยาง ไฟประดับ ตกแต่ง กันน้ำกันฝน ค่ะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S520c8ae0d8d94355bc18f40a33d6a77ec.jpg_200x200q90.jpg",
        "price": 4735,
        "remark": "https://www.lazada.co.th/products/pdp-i16097063909.html",
        "sold": 0
    },
    {
        "product_name": "สายไฟห้อยระย้า ขั้วE27 5-100เมตร พร้อมหลอดAKARI ไฟ 220v สายระย้า LED 3W หลอดปิงปอง ขั้วกันน้ำ ไฟตกเเต่ง",
        "product_image": "https://img.lazcdn.com/g/p/fcb30f4f091a30d6e34c33a098a3b7d2.jpg_200x200q90.jpg",
        "price": 4727.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5098979329.html",
        "sold": 61
    },
    {
        "product_name": "LED Neon Flex LED ไฟเส้น ประดับตกแต่งแม้ในบ้าน หรือนอกบ้าน ไฟบ้าน ไฟรถ กันน้ำ ทนแดด ทนฝน มีสีให้เลือก10สี (50 เมตร) คุ้มค่าที่สุดค่ะแถมปลั๊ก 5เส้น",
        "product_image": "https://img.lazcdn.com/g/p/bba1719ca88063799f87cb01346e4dd5.jpg_200x200q90.jpg",
        "price": 4622.88,
        "remark": "https://www.lazada.co.th/products/pdp-i1262494897.html",
        "sold": 39
    },
    {
        "product_name": "ไฟตกแต่งร้าน สายไฟ สายระย้า ขั้ว E27  ความยาว 5-100เมตร (ไม่รวมหลอด)ขั้วกันน้ำเส้นหนาทนใช้ติดตั้งได้ทั้งภายในภายนอก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S291ac952f069439294abb4d68ac5f2e5t.jpg_200x200q90.jpg",
        "price": 4600,
        "remark": "https://www.lazada.co.th/products/pdp-i4671723545.html",
        "sold": 50
    },
    {
        "product_name": "ไฟตกแต่งร้าน สายไฟห้อยระย้าขั้วe27( แถมหลอดled 3w)5-100เมตรขั้วกันน้ำ เส้นหนาทนใช้",
        "product_image": "https://img.lazcdn.com/g/p/5ccc049ef0541173e7b709f4a72aba0b.jpg_200x200q90.jpg",
        "price": 4540,
        "remark": "https://www.lazada.co.th/products/pdp-i4766064067.html",
        "sold": 4
    },
    {
        "product_name": "Tuya Smart WIFI RGB Led Strip Light 220V ไฟเส้น ไฟแถบ ควบคุมผ่าน Tuya App ไฟสำหรับตกแต่ง ไฟเส้น เปลี่ยนสีได้ TuyaRGB รวม",
        "product_image": "https://img.lazcdn.com/g/p/f1f213c5e59527f115b5dbd1193a289f.jpg_200x200q90.jpg",
        "price": 4506,
        "remark": "https://www.lazada.co.th/products/pdp-i2402719487.html",
        "sold": 16
    },
    {
        "product_name": "MODI ไฟห้อยระย้าโซล่าเซลล์ 10เมตร20หลอด รุ่นSUPER แสงเหลือง แต่งสวน ปีใหม่ คริสมาส ปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/bfca6fbd416172d8614f71d104c129cb.jpg_200x200q90.jpg",
        "price": 4043.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5426405554.html",
        "sold": 70
    },
    {
        "product_name": "ไฟเส้น 50เมตร รุ่นใหม่! COB ไม่เห็นเม็ดไฟ LED 288เม็ด/เมตร 220V แสงขาว,วอร์ม,คลูไวท์ ไฟสายยาง ไฟประดับ ราคาส่ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9f5c92d6cdab4c528f99dcfc57902362x.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5828654506.html",
        "sold": 5
    },
    {
        "product_name": "แถบเดี่ยว RGB LED STRIP 5050 ไฟ LED ไฟเส้นRGB LED รุ่นไฟ1ดวงในเส้น ไฟ1แถบ แบบกันน้ำ สามารถต่อกับไฟบ้านได้ แถมฟรีปลั๊กและรีโมท ไฟสวน ไฟรถ ไฟผนัง",
        "product_image": "https://img.lazcdn.com/g/p/87d29ca881a8b7ee772d6f23298f8925.jpg_200x200q90.jpg",
        "price": 3830,
        "remark": "https://www.lazada.co.th/products/pdp-i347494146.html",
        "sold": 16
    },
    {
        "product_name": "สายไฟห้อยระย้า ขั้วE27 5-100เมตร พร้อมหลอดAKARI ไฟ 220v สายระย้า LED 3W หลอดปิงปอง ขั้วกันน้ำ 1เมตร3ขั้ว",
        "product_image": "https://img.lazcdn.com/g/p/c4c188fcfca01ba65a2975f5a2df1c52.jpg_200x200q90.jpg",
        "price": 3805.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5099048139.html",
        "sold": 34
    },
    {
        "product_name": "MODI ไฟห้อยระย้าโซล่าเซลล์ 15เมตร30หลอด รุ่นSUPER แสงเหลือง ตกแต่งสวน ปีใหม่ คริสมาส ปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/ba38524df8a6bc3a97f6beb1059b4742.jpg_200x200q90.jpg",
        "price": 3745.3,
        "remark": "https://www.lazada.co.th/products/pdp-i5769095020.html",
        "sold": 319
    },
    {
        "product_name": "MODI ไฟห้อยระย้าโซล่าเซลล์ 10เมตร20หลอด รุ่นSUPER แสงเหลือง ตกแต่งสวน ปีใหม่ คริสมาส ปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/1791f9cdd4ece31585638c351ef5d0c5.jpg_200x200q90.jpg",
        "price": 3745.3,
        "remark": "https://www.lazada.co.th/products/pdp-i5441762540.html",
        "sold": 533
    },
    {
        "product_name": "IWACHI (มีทั้งหมด 21 สี) หลอดไฟงานวัด หลอดสี ไฟประดับ ไฟกันน้ำ ไฟLED ไฟงานวัด เครื่องไฟ หลอดไฟLED (แพ็ค 30 หลอด) หลอดนีออนสีขั้วกันน้ำ LED T8 18W พร้อมปลั๊กเสียบ",
        "product_image": "https://img.lazcdn.com/g/p/c50f11ec43878b72b22de6236532d1fa.jpg_200x200q90.jpg",
        "price": 3638,
        "remark": "https://www.lazada.co.th/products/pdp-i703732559.html",
        "sold": 6
    },
    {
        "product_name": "ไฟสาย LED กลางแจ้ง G40 ชุดสายไฟระย้า กันน้ำได้ ประดับสวน christmas decoration ไฟปีใหม่ ไฟกระพริบ ไฟปิงปอง LED ไฟประดับ 7.6M/10/15M/20M ไฟฐาน E12 สายไฟพร้อมหลอด ไฟสวน ไฟย้อนยุค ไฟปิงปอง ไฟตกแต่งทังสเตน",
        "product_image": "https://img.lazcdn.com/g/p/cdb96798dd78b8962a15fde0710e81c6.jpg_200x200q90.jpg",
        "price": 3627.8,
        "remark": "https://www.lazada.co.th/products/pdp-i4777518828.html",
        "sold": 206
    },
    {
        "product_name": "ไฟ LED รูปผีเสื้อ 1 ชิ้น สำหรับตกแต่งภายนอกอาคาร แบบไดนามิกและแบบคงที่ เหมาะสำหรับงานปาร์ตี้ วันหยุด คริสต์มาส และตกแต่งบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf5b336aca6ba4c91ae94c653101dd4d0p.jpg_200x200q90.jpg",
        "price": 3314.5,
        "remark": "https://www.lazada.co.th/products/pdp-i6019518295.html",
        "sold": 0
    },
    {
        "product_name": "สมาร์ท RGB ไฟ LED ม่าน RGB LED String Light AppControl USB DIY ข้อความภาพเคลื่อนไหวจอแสดงผลเพลง SYNC สําหรับ Christmas PARTY Decor",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S82c710d010204ddf863ae7a3da57ad92E.jpg_200x200q90.jpg",
        "price": 3064.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5847688082.html",
        "sold": 0
    },
    {
        "product_name": "สมาร์ทไฟม่าน LED RGB สายไฟแอพควบคุมกันน้ำ DIY ไฟนางฟ้าปลั๊ก USB รูปแบบข้อความสำหรับตกแต่งห้องปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se1e30748d1714c7e920e8e7179eca00er.jpg_200x200q90.jpg",
        "price": 3048.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5955477903.html",
        "sold": 0
    },
    {
        "product_name": "MODIไฟห้อยระย้าโซล่าเซลล์ ยาว10เมตร20หลอด แสงเหลืองสว่างค้าง ไฟปิงปองแต่งสวน ปีใหม่ คริสมาส ปาร์ตี้ ไฟประดับ ไฟกระพริบ ไฟกระพริบโซล่า",
        "product_image": "https://img.lazcdn.com/g/p/214c41f4057af1e730b1c4a428299a4e.jpg_200x200q90.jpg",
        "price": 2975.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5511040955.html",
        "sold": 44
    },
    {
        "product_name": "MODIไฟห้อยระย้าโซล่าเซลล์ ไฟลูกแก้ว ไฟปิงปอง สายไฟห้อยระย้า ยาว10เมตร20หลอด แสงเหลืองสว่างค้าง ไฟปิงปองแต่งสวน ปีใหม่ คริสมาส ปาร์ตี้ christmas light",
        "product_image": "https://img.lazcdn.com/g/p/08279937a3a2df5dac5048434609bab1.jpg_200x200q90.jpg",
        "price": 2944.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5511266532.html",
        "sold": 11
    },
    {
        "product_name": "200M 100M 50M Green Wire Outdoor LED String lights Holiday Waterproof Fairy Garland For Christmas Tree Wedding Party Decoration",
        "product_image": "https://img.lazcdn.com/g/p/cf7b083440d41a531719939e57fdf9a3.jpg_webp_200x200q90.jpg",
        "price": 2807.7,
        "remark": "https://www.lazada.co.th/products/pdp-i4485847532.html",
        "sold": 19
    },
    {
        "product_name": "MODIไฟกระพริบโซล่าเซลล์ ยาว10เมตร หลากสีRGB รีโมทคอนโทรล ไฟตกแต่ง ประดับสวน ปีใหม่ คริสมาส ปาร์ตี้ ไฟคริสต์มาส คริสมาสต์ christmas light ไฟปีใหม่สวยๆ ไฟตกแต่งร้าน",
        "product_image": "https://img.lazcdn.com/g/p/0fe1eb5d9c04d593bbe431be1b31f7cc.jpg_200x200q90.jpg",
        "price": 2798,
        "remark": "https://www.lazada.co.th/products/pdp-i5441688323.html",
        "sold": 10
    },
    {
        "product_name": "สายไฟห้อยระย้า ขั้วE27 5-50เมตร พร้อมหลอดแบรนด์Green LED ไฟ 220v สายระย้า LED 3W หลอดปิงปอง",
        "product_image": "https://img.lazcdn.com/g/p/a85669e4159727c45b5a98a9b62bfd9b.png_200x200q90.png",
        "price": 2702.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5621472019.html",
        "sold": 68
    },
    {
        "product_name": "แถมรีโมท+ปลั๊ก! ไฟเส้นเปลี่ยนสีได้ RGBนีออน ไฟประดับตกแต่ง ไฟเส้น แบบยาง กันน้ำ ทนทาน RGB ตกแต่งได้ทั้งในและนอกอาคาร ควบคุมด้วยรีโม",
        "product_image": "https://img.lazcdn.com/g/p/7faed70f1716978af68909950f83ed69.jpg_200x200q90.jpg",
        "price": 2692,
        "remark": "https://www.lazada.co.th/products/pdp-i526612428.html",
        "sold": 43
    },
    {
        "product_name": "MODI ไฟริบบิ้นโซล่าเซลล์ หลากสีRGB ยาว5เมตร ไฟเส้นเหมาะสำหรับใช้ภายในอาคาร ไฟตกแต่ง ไฟประดับ",
        "product_image": "https://img.lazcdn.com/g/p/e3d34dd99f53c557de45186a9cd4c98f.jpg_200x200q90.jpg",
        "price": 2654.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5448650140.html",
        "sold": 27
    },
    {
        "product_name": "ไฟราว ไฟปิงปอง ไฟห้อยระย้า 5-100เมตร ไม่รวมหลอด ไฟระยะเทศกาล ขั้วกันน้ำ ไฟตกแต่ง",
        "product_image": "https://img.lazcdn.com/g/p/18293ce608df50daaa01bfc3128c51c3.jpg_200x200q90.jpg",
        "price": 2653.92,
        "remark": "https://www.lazada.co.th/products/pdp-i4346304887.html",
        "sold": 535
    },
    {
        "product_name": "สายไฟห้อยระย้า 1เมตรละ2ขั้ว 5-100เมตร ขั้วe27 พร้อมหลอดLED 3W หลอดปิงปอง กันน้ำเส้นหนาทนทาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seda8f2f8d9b6480993dfc431d400323bu.jpg_200x200q90.jpg",
        "price": 2600,
        "remark": "https://www.lazada.co.th/products/pdp-i5914405809.html",
        "sold": 0
    },
    {
        "product_name": "30 M กลางแจ้ง Garland ไฟ 220V G40 หลอดไฟพลาสติก LED เต็นท์ Fairy Patio String Light งานแต่งงานตกแต่งสวน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S874c44a1f8634a37bbaafb4e9281f2af1.jpg_200x200q90.jpg",
        "price": 2591.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5727078760.html",
        "sold": 0
    },
    {
        "product_name": "ไฟ LED แบบม่านสำหรับคริสต์มาส, ไฟประดับกันน้ำ ควบคุมผ่านแอพ ปรับเปลี่ยนสีได้เอง สำหรับของขวัญ งานปาร์ตี้ ตกแต่งบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S28e8110e5d69439f885d84d01c46d753p.jpg_200x200q90.jpg",
        "price": 2575.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5931788123.html",
        "sold": 0
    },
    {
        "product_name": "MODI ไฟริบบิ้นโซล่าเซลล์ รุ่นA ยาว10M20M30M ระบบสว่างค้าง รีโมทคอนโทรลไฟกระพริบ แถมแสง LED กันน้ำIP65 ประดับตกแต่งต้นไม้ สวน รั้วบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/af6437e8c235294841501f1086b2add9.jpg_200x200q90.jpg",
        "price": 2553.86,
        "remark": "https://www.lazada.co.th/products/pdp-i4792192768.html",
        "sold": 71
    },
    {
        "product_name": "MODIไฟกระพริบโซล่าเซลล์ ไฟระย้า ไฟแฟรี่ ไฟคริสต์มาสตกแต่ง ไฟกระพริบ ยาว10เมตร หลากสีRGB รีโมทคอนโทรล ไฟตกแต่ง ประดับสวน ปีใหม่ คริสมาส ปาร์ตี้ christmas light",
        "product_image": "https://img.lazcdn.com/g/p/a9c6daafba2fedcc43e4f74326229877.jpg_200x200q90.jpg",
        "price": 2545,
        "remark": "https://www.lazada.co.th/products/pdp-i5441650640.html",
        "sold": 2
    },
    {
        "product_name": "MODI ไฟริบบิ้นโซล่าเซลล์ ไฟแฟรี่ ไฟคริสต์มาสตกแต่ง ไฟประดับ ไฟกระพริบ หลากสีRGB ยาว5เมตร ไฟเส้นเหมาะสำหรับใช้ภายในอาคาร ไฟตกแต่ง ประดับภายใน",
        "product_image": "https://img.lazcdn.com/g/p/973b782b15250d3cdec7a78aef1f428f.jpg_200x200q90.jpg",
        "price": 2483.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5448680515.html",
        "sold": 2
    },
    {
        "product_name": "ไฟประดับ LED รูปพลุ สำหรับคริสต์มาส สีขาวอบอุ่น กันน้ำ ปลั๊กแบบ EU พร้อมรีโมท สำหรับตกแต่งต้นคริสต์มาส พวงมาลัย หน้าต่าง และงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2a51ccebf31a43428dc0cc1083c8e26dm.jpg_200x200q90.jpg",
        "price": 2474.52,
        "remark": "https://www.lazada.co.th/products/pdp-i5994354240.html",
        "sold": 0
    },
    {
        "product_name": "RGB ไฟสามสี LED Led Light Strip Three-color 220V Waterproof เปลี่ยนสีได้ ไฟเส้นเปลี่ยนได้ 3 สี คุณภาพสูง สว่างมาก",
        "product_image": "https://img.lazcdn.com/g/p/07cb54951158a52e35ad78e289f84cdd.jpg_200x200q90.jpg",
        "price": 2460,
        "remark": "https://www.lazada.co.th/products/pdp-i2411786134.html",
        "sold": 8
    },
    {
        "product_name": "ไฟม่านอัจฉริยะ 400LED ควบคุมผ่านแอป Bluetooth ไฟ LED สายรุ้ง RGB ไฟประดับตกแต่ง DIY เปลี่ยนสีตามเสียงเพลง สำหรับตกแต่งหน้าต่างและห้องนอน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S15006631bb7e4ea5a40a104dfbce3112K.jpg_200x200q90.jpg",
        "price": 2451.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5972175585.html",
        "sold": 0
    },
    {
        "product_name": "ไฟม่านอัจฉริยะ USB 5V ควบคุมผ่านแอพ ไฟ LED สายไฟตกแต่งห้องนอน ไฟประดับตกแต่งคริสต์มาส พวงมาลัย DIY แสดงผลแบบข้อความ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S620b9935b33d45f687dc38a5a6e518a02.png_200x200q90.png",
        "price": 2409.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5876820826.html",
        "sold": 0
    },
    {
        "product_name": "ไฟตาข่าย 6x4 เมตร ตาข่ายไฟขนาดใหญ่ เเสง warmwhite / white / RGB ไฟปีใหม่ เเบบไฟกระพริบ/ไฟนิ่ง ปรับได้ 8 โหมด ไฟหยดน้ำ ไฟปีใหม่ ไฟคริสมาส",
        "product_image": "https://img.lazcdn.com/g/p/99871cc92b5659a90cce1d096111a9b6.jpg_200x200q90.jpg",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i1845304426.html",
        "sold": 12
    },
    {
        "product_name": "ไฟม่าน LED อัจฉริยะ ไฟประดับม่านบนหน้าต่าง ใช้พลังงานจาก USB ไฟประดับตกแต่งพร้อมรีโมท ไฟประดับปีใหม่ ไฟ LED รูปพวงมาลัย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se193717f03484551b8b3050cee6d3bf77.jpg_200x200q90.jpg",
        "price": 2258.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5967518591.html",
        "sold": 0
    },
    {
        "product_name": "ไฟคริสต์มาสอัจฉริยะ 1/2 ชิ้น พร้อม Google & Amazon Alexa, ไฟประดับแบบม่าน 400 LED ควบคุมผ่านแอป สำหรับตกแต่งบ้านทั้งภายนอกและภายใน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1de767dc02a84682887b91eddfb019acI.jpg_200x200q90.jpg",
        "price": 2253.76,
        "remark": "https://www.lazada.co.th/products/pdp-i5976032875.html",
        "sold": 0
    },
    {
        "product_name": "ไฟม่านอัจฉริยะ 1/2 ชิ้น 400 หลอด LED ไฟคริสต์มาส ไฟไดนามิก DIY เปลี่ยนสีได้ พร้อมรีโมทและแอพ สำหรับตกแต่งบ้านและงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S77605174043640779d184698538d23c4W.jpg_200x200q90.jpg",
        "price": 2249.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5976134306.html",
        "sold": 0
    },
    {
        "product_name": "ไฟม่านอัจฉริยะ 400 LED ไฟประดับม่านแบบไดนามิก เปลี่ยนสีได้ตามต้องการ พร้อมรีโมทและแอปพลิเคชัน สำหรับตกแต่งบ้านและงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd50377418e6a44789aac7ab71930c75a1.jpg_200x200q90.jpg",
        "price": 2235.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5984157572.html",
        "sold": 0
    },
    {
        "product_name": "ไฟม่าน RGB สายไฟประดับพร้อมซิงค์เพลง แสดงผลข้อความ ไฟนางฟ้า 256 LED ควบคุมผ่านแอพ DIY ไฟม่านคริสต์มาส ตกแต่งผนังห้อง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9c1829dc4843439282f94eb3c9439c0e9.jpg_200x200q90.jpg",
        "price": 2201.06,
        "remark": "https://www.lazada.co.th/products/pdp-i5985751396.html",
        "sold": 0
    },
    {
        "product_name": "ไฟต้นคริสต์มาสอัจฉริยะ 7 ฟุต ไฟ LED แบบสาย พร้อมดาวประดับยอดต้น  ปรับแต่งลวดลายได้ ตั้งเวลา ซิงค์เพลง ควบคุมผ่านแอพ สำหรับตกแต่งต้นคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb644711e7b934986a7fa434ed4aab97bA.jpg_200x200q90.jpg",
        "price": 2172.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5991347706.html",
        "sold": 0
    },
    {
        "product_name": "ไฟม่าน LED อัจฉริยะ 1/2 ชิ้น ไฟประดับ LED ควบคุมผ่านแอพ ซิงค์เพลง สร้างลวดลายได้เอง กันน้ำ สำหรับตกแต่งงานปาร์ตี้ในร่มและกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1e57535e3b7c41e5b44557aebd77c091r.jpg_200x200q90.jpg",
        "price": 2094.84,
        "remark": "https://www.lazada.co.th/products/pdp-i5907765368.html",
        "sold": 0
    },
    {
        "product_name": "ไฟม่านอัจฉริยะ 1/2/3 เมตร 2 ชิ้น ไฟคริสต์มาส แบบไดนามิก เปลี่ยนสีได้เอง พร้อมรีโมทแอพ สำหรับตกแต่งงานปาร์ตี้ที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S06cdafcbacb64ec4b4297bdd6a6e2f4cr.jpg_200x200q90.jpg",
        "price": 2153.52,
        "remark": "https://www.lazada.co.th/products/pdp-i5991399597.html",
        "sold": 0
    },
    {
        "product_name": "MODI ไฟห้อยระย้าโซล่าเซลล์ ไฟปิงปอง สายไฟห้อยระย้า สายยาว7M 10M แสงเหลือง ไฟประดับตกแต่งโซล่าเซลล์ เปิดปิดอัตโนมัติ แต่งสวน ปีใหม่ christmas  ปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/89f34e6e23b2faed79012dd3b1e811b9.jpg_200x200q90.jpg",
        "price": 2141.96,
        "remark": "https://www.lazada.co.th/products/pdp-i4987537770.html",
        "sold": 65
    },
    {
        "product_name": "ไฟประดับตกแต่งคริสต์มาสกลางแจ้ง LED ความยาว 30-60 เมตร แสงวอร์มไลท์ 220V แบบกันน้ำ มาตรฐาน EU สำหรับต้นคริสต์มาส สวน และกิ่งไม้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2f7b92b80960474c8c2c9d801eb8d805T.jpg_200x200q90.jpg",
        "price": 2132.82,
        "remark": "https://www.lazada.co.th/products/pdp-i6002406523.html",
        "sold": 0
    },
    {
        "product_name": "MODI ไฟห้อยระย้าโซล่าเซลล์ ไฟปิงปอง สายไฟห้อยระย้า7M 10M สีเหลือง/สีRGB ไฟประดับตกแต่ง โซล่าเซลล์ christmas light แต่งสวน ปีใหม่ คริสมาส ปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/b48564cbfad6a2c2e0f657b5962e6a2d.jpg_200x200q90.jpg",
        "price": 2115.56,
        "remark": "https://www.lazada.co.th/products/pdp-i4985989500.html",
        "sold": 64
    },
    {
        "product_name": "ไฟม่าน LED อัจฉริยะ 400 ดวง พร้อมรีโมทคอนโทรลผ่านแอพ ควบคุมการซิงค์เพลง ไฟประดับตกแต่งคริสต์มาส ไฟม่านสำหรับภายนอกอาคาร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S96eeeb30cde247dca5d46bb991144926k.jpg_200x200q90.jpg",
        "price": 2114.86,
        "remark": "https://www.lazada.co.th/products/pdp-i6002468146.html",
        "sold": 0
    },
    {
        "product_name": "ไฟประดับแบบม่าน DC5V WS2812 ไฟ LED RGBIC ควบคุมผ่านแอป Bluetooth ปรับความสว่างได้ เหมาะสำหรับงาน DIY ปาร์ตี้คริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0437d3fb369148948554edbece4c0e7dn.jpg_200x200q90.jpg",
        "price": 2100.18,
        "remark": "https://www.lazada.co.th/products/pdp-i5970732298.html",
        "sold": 0
    },
    {
        "product_name": "ไฟประดับม่านอัจฉริยะ WiFi ขนาด 2*2 เมตร 400 LED สำหรับของขวัญคริสต์มาส ควบคุมผ่านแอพฯ โหมดเพลง กันน้ำระดับ IP65 สำหรับตกแต่งบ้านและภายนอกอาคารในเทศกาลคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa502a9395b0a4654ae097af80b137ae8w.jpg_200x200q90.jpg",
        "price": 2071.3,
        "remark": "https://www.lazada.co.th/products/pdp-i6003951049.html",
        "sold": 0
    },
    {
        "product_name": "ไฟ LED สายรุ้ง RGB แบบมีแอปบลูทูธ ขนาด 2ม.*2ม./3ม. ไฟม่านอัจฉริยะ ปรับเปลี่ยนสีตามเพลง สำหรับตกแต่งหน้าต่างและห้องนอน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S851700e1e18340a992c59ecb427d8a9fP.jpg_200x200q90.jpg",
        "price": 2045.72,
        "remark": "https://www.lazada.co.th/products/pdp-i5986720675.html",
        "sold": 0
    },
    {
        "product_name": "ไฟประดับตกแต่งงานปาร์ตี้คริสต์มาส DIY แบบสายไฟ LED รุ่น DC5V WS2812 ไฟ LED แบบม่าน USB ไฟ LED แบบสาย RGBIC ควบคุมผ่านแอป Bluetooth อัจฉริยะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seb32424ca1044c5ab06ed3d5dc8a0521q.jpg_200x200q90.jpg",
        "price": 2023.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5988466029.html",
        "sold": 0
    },
    {
        "product_name": "ไฟม่านอัจฉริยะ 400 LED, ควบคุมผ่านแอป/รีโมท, ไฟคริสต์มาส 3x3 เมตร สำหรับตกแต่งงานเทศกาล, กันน้ำระดับ IP65, ซิงค์เพลง สร้างลวดลายได้เอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbab2635bf1864226b3450cec4db56799o.jpg_200x200q90.jpg",
        "price": 2020.72,
        "remark": "https://www.lazada.co.th/products/pdp-i5984929598.html",
        "sold": 0
    },
    {
        "product_name": "ป้ายไฟนีออนลายคริสต์มาสสำหรับตกแต่งผนัง ไฟหรี่แสงได้ พร้อมต้นคริสต์มาส ไฟนีออน USB สำหรับหน้าต่าง ห้อง งานปาร์ตี้ ของขวัญ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2ab243b55b5b45a1abb3ed1a0bff34f6Q.jpg_200x200q90.jpg",
        "price": 2020.54,
        "remark": "https://www.lazada.co.th/products/pdp-i5996317459.html",
        "sold": 0
    },
    {
        "product_name": "ไฟประดับต้นคริสต์มาสแบบสายยาว 1.8 เมตร/5.9 ฟุต 400 หลอด LED เปลี่ยนสีได้ สำหรับตกแต่งภายในบ้านในช่วงเทศกาลวันหยุด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saa27d7dee5a045e48fee7c173c753196J.jpg_200x200q90.jpg",
        "price": 2000.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5991142932.html",
        "sold": 0
    },
    {
        "product_name": "ไฟม่านอัจฉริยะรุ่นใหม่ ปี 2026 พร้อมลวดลาย DIY, ไฟประดับหน้าต่าง 400 LED สำหรับตกแต่งภายนอกอาคาร เหมาะสำหรับเป็นของขวัญคริสต์มาสและตกแต่งบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S261d1b86bd4d49c68787d5bf73462c8c2.jpg_200x200q90.jpg",
        "price": 1998.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5984108674.html",
        "sold": 0
    },
    {
        "product_name": "MODI ไฟห้อยระย้าโซล่าเซลล์ สายยาว7M 10M แสงเหลือง ไฟประดับตกแต่งโซล่าเซลล์ เปิดปิดอัตโนมัติ แต่งสวน ปีใหม่ คริสมาส ปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/754fc763f7885194639a914165a9431e.jpg_200x200q90.jpg",
        "price": 1998,
        "remark": "https://www.lazada.co.th/products/pdp-i4987379953.html",
        "sold": 260
    },
    {
        "product_name": "MODI ไฟห้อยระย้าโซล่าเซลล์7M 10M เหลือง/RGB/สีฟ้าอ่อน/สีชมพูอ่อน ไฟประดับตกแต่งโซล่าเซลล์ เปิดปิดอัตโนมัติ แต่งสวน ปีใหม่ คริสมาส ปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/effd7a2a3b6bc375db20ce4ced37f6c3.jpg_200x200q90.jpg",
        "price": 1998,
        "remark": "https://www.lazada.co.th/products/pdp-i4985775863.html",
        "sold": 148
    },
    {
        "product_name": "MODI ไฟห้อยระย้าโซล่าเซลล์ 7เมตร10หลอด สีชมพูอ่อน/สีฟ้าอ่อน ไฟประดับตกแต่งโซล่าเซลล์ เปิดปิดอัตโนมัติ แต่งสวน ปีใหม่ คริสมาส ปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/297313ac8e3f496f7663eff06bf9aea3.jpg_200x200q90.jpg",
        "price": 1998,
        "remark": "https://www.lazada.co.th/products/pdp-i5015961484.html",
        "sold": 51
    },
    {
        "product_name": "ไฟคริสต์มาส USB 2.1 เมตร 400 ดวง ไฟประดับรูปดาว ไฟ LED อัจฉริยะสำหรับตกแต่งต้นคริสต์มาส ภายในและภายนอกอาคาร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S648428eb0f7a4eba968bcd8878cba1e2F.jpg_200x200q90.jpg",
        "price": 1992.54,
        "remark": "https://www.lazada.co.th/products/pdp-i5986003017.html",
        "sold": 0
    },
    {
        "product_name": "ไฟห้อย สายไฟระย้า สายไฟพร้อมขั้วE27 สายไฟขั้วห้อย ไฟตกแต่ง ปีใหม่ ไฟปิงปอง 5M 10M 20M 50M 100M หลอดปิงปองสีวอร์ม",
        "product_image": "https://img.lazcdn.com/g/p/1448114a28790e00026f3077b7285dac.jpg_200x200q90.jpg",
        "price": 1990,
        "remark": "https://www.lazada.co.th/products/pdp-i1984018725.html",
        "sold": 423
    },
    {
        "product_name": "ไฟคริสต์มาส RGBIC 6.9 ฟุต 400 หลอด LED รูปดาว ไฟประดับตกแต่งเทศกาล ไฟ LED อัจฉริยะสำหรับตกแต่งต้นคริสต์มาส ภายในและภายนอกอาคาร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc909737e1e2b4f7aa1d55324ba82d905m.jpg_200x200q90.jpg",
        "price": 1980.08,
        "remark": "https://www.lazada.co.th/products/pdp-i5929137982.html",
        "sold": 0
    },
    {
        "product_name": "ไฟม่านอัจฉริยะ 1.6*1.6 เมตร/3*3 เมตร 400 หลอด LED ควบคุมผ่านแอปฯ  โหมดดนตรี กันน้ำระดับ IP65 สำหรับตกแต่งคริสต์มาสกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5c60232c882b4700acabe6397e9b0e7dI.jpg_200x200q90.jpg",
        "price": 1947.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5992360169.html",
        "sold": 0
    },
    {
        "product_name": "สายไฟห้อยระย้า+หลอดไฟ E27 LED 3W ยาว 5-20เมตร กันน้ำ เส้นหนา ไฟตลาดกลางคืน ไฟปีใหม่ ไฟตกแต่ง ไฟตกแต่งสวน ปาร์ตี้ คริสมาส",
        "product_image": "https://img.lazcdn.com/g/p/ec2c2c3e95a678541cb5672a62c048cd.jpg_200x200q90.jpg",
        "price": 1920,
        "remark": "https://www.lazada.co.th/products/pdp-i5861781344.html",
        "sold": 0
    },
    {
        "product_name": "MODI ไฟห้อยระย้าโซล่าเซลล์ แสงเหลือง ยาว7M/10M ไฟประดับตกแต่งโซล่าเซลล์ เปิดปิดอัตโนมัติ กันน้ำIP65 เส้นหนาทนทาน ไฟแต่งสวน คริสต์มาส ปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/ot/lzd-share/3b7de4cdfa5d61ea446da8a1936fc1cb.png_200x200q90.png",
        "price": 1906,
        "remark": "https://www.lazada.co.th/products/pdp-i6035100247.html",
        "sold": 2448
    },
    {
        "product_name": "สมาร์ทผ้าม่านบลูทูธ App ควบคุม RGB LED String กันน้ํา Fairy Light USB DIY รูปแบบข้อความ Party Room Decor",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa025b3838ddc44dfa213e07f818fcc7cY.jpg_200x200q90.jpg",
        "price": 1901.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5728615101.html",
        "sold": 0
    },
    {
        "product_name": "MODI ไฟห้อยระย้าโซล่าเซลล์ แสงเหลือง ยาว7M 10M 15M ไฟประดับตกแต่งโซล่าเซลล์ เปิดปิดอัตโนมัติ ไฟแต่งสวน ปีใหม่ คริสมาส ปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/06ee0a98d6f8d1ce8942ce53be1a0619.jpg_200x200q90.jpg",
        "price": 1900.8,
        "remark": "https://www.lazada.co.th/products/pdp-i4754955267.html",
        "sold": 1203
    },
    {
        "product_name": "ไฟม่าน LED อัจฉริยะ 400 ดวง แบบ USB ลายไดนามิก DIY พร้อมรีโมทแอป สำหรับของขวัญวันเกิดและเทศกาลอีสเตอร์ ขนาด 2*2 ม./3*3 ม.",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfcf914c529c74add8536b58d2809c80dr.jpg_200x200q90.jpg",
        "price": 1899.18,
        "remark": "https://www.lazada.co.th/products/pdp-i6003595335.html",
        "sold": 0
    },
    {
        "product_name": "ไฟคริสต์มาสอัจฉริยะบลูทูธ ปี 2025 พร้อมแอปควบคุม DIY RGBIC ไฟ LED แบบม่านสำหรับงานปาร์ตี้ ตกแต่งบ้าน ของขวัญคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7a4049ed6f8940b48f93be97a859877dy.jpg_200x200q90.jpg",
        "price": 1886.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5959876439.html",
        "sold": 0
    },
    {
        "product_name": "ไฟม่าน LED อัจฉริยะ DIY พร้อมแอปและรีโมทคอนโทรล สำหรับตกแต่งผนังห้องนอน แสงไฟตกแต่งคริสต์มาสและฮาโลวีน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S488e54d59d2144e281592d90dc5087f1X.jpg_200x200q90.jpg",
        "price": 1881.58,
        "remark": "https://www.lazada.co.th/products/pdp-i6015615046.html",
        "sold": 0
    },
    {
        "product_name": "เสื้ออิออน เสื้อประจุลบ เสื้อไอออนิค begative ion cloth thailand",
        "product_image": "https://img.lazcdn.com/g/p/ee107ed3918667a74b0528bbef58c7f2.jpg_200x200q90.jpg",
        "price": 90000,
        "remark": "https://www.lazada.co.th/products/pdp-i4681766881.html",
        "sold": 0
    },
    {
        "product_name": "Wilson Women Winning Tennis Dress WW00481531BUT Official Store",
        "product_image": "https://img.lazcdn.com/g/p/028a7c1acb3698868ecca2fd42908778.jpg_200x200q90.jpg",
        "price": 12780,
        "remark": "https://www.lazada.co.th/products/pdp-i5903445729.html",
        "sold": 1
    },
    {
        "product_name": "Wilson Women RIVIERA DRESS WE00073R024001 Official Store",
        "product_image": "https://img.lazcdn.com/g/p/8bcad5a9ba096cf0e140989b9ecdac3d.jpg_200x200q90.jpg",
        "price": 11980,
        "remark": "https://www.lazada.co.th/products/pdp-i6048861007.html",
        "sold": 1
    },
    {
        "product_name": "Wilson Women Laser Cut Pleat Dress WE00080E014001 Official Store",
        "product_image": "https://img.lazcdn.com/g/p/0e630d43ed42468ac54e3a26475e4d27.jpg_200x200q90.jpg",
        "price": 11980,
        "remark": "https://www.lazada.co.th/products/pdp-i16069266264.html",
        "sold": 0
    },
    {
        "product_name": "Wilson Women Laser Cut Pleat Dress WE00080W002001 Official Store",
        "product_image": "https://img.lazcdn.com/g/p/6020cfc607c6f0793212fac452db8099.jpg_200x200q90.jpg",
        "price": 11980,
        "remark": "https://www.lazada.co.th/products/pdp-i16069203187.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อฮาเลย์ เดวิดสัน เสื้อวินเทจ เสื้อสะสม ผ้า 50/50 ลิขสิทธิ์ Holoubek ตอกปี 1988 มือสองของแท้ Made in USA อก 23.5 ยาว 28 ตำหนิหลายจุด ไม่สามารถลงรูปได้หมด ทักมาขอดูตำหนิเพิ่มเติมได้ #ขอคนรับได้ค่ะ #เสนห์วินเทจ👍👍👍",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdf307b2f547a4f0aa0864b5ba088b5eaV.jpg_200x200q90.jpg",
        "price": 11600,
        "remark": "https://www.lazada.co.th/products/pdp-i4184968302.html",
        "sold": 0
    },
    {
        "product_name": "Gull Wetsuit Jersey 2.5mm Women เสื้อและกางเกง เวทสูท สำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/aeb24bc4cd8dd25c542619e42087ca78.png_200x200q90.png",
        "price": 10980,
        "remark": "https://www.lazada.co.th/products/pdp-i5175097570.html",
        "sold": 0
    },
    {
        "product_name": "Columbia | เสื้อกันหนาวบุนวมผู้หญิง สีไอวอรี่ C64-YLD334",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S88714b2affd14c02860790be4409a039S.jpg_200x200q90.jpg",
        "price": 10620.24,
        "remark": "https://www.lazada.co.th/products/pdp-i5919581982.html",
        "sold": 3
    },
    {
        "product_name": "Wilson Women All Court Tennis Dress WW00397511DBC Official Store",
        "product_image": "https://img.lazcdn.com/g/p/7719eacc4e6bb929d66183dab4f4288e.jpg_200x200q90.jpg",
        "price": 9980,
        "remark": "https://www.lazada.co.th/products/pdp-i16069534522.html",
        "sold": 0
    },
    {
        "product_name": "CAT WATCHES LE.111.21.137T SPIRIT II LIMITED EDITION ผลิตเพียง999เรือน ไทยแลนด์ รัชกาลที่10 สายยางสีดำ - Black/Yellow *แถมฟรี!เสื้อโปโลสีเหลือง1ชิ้น* รับประกันศูนย์1ปี",
        "product_image": "https://img.lazcdn.com/g/p/596e8cb74b69c0ed4f5148ef0ec0bc32.jpg_200x200q90.jpg",
        "price": 9450,
        "remark": "https://www.lazada.co.th/products/pdp-i324778875.html",
        "sold": 2
    },
    {
        "product_name": "Wilson Women Contrast Scoop Neck Dress WE00071W002001 Official Store",
        "product_image": "https://img.lazcdn.com/g/p/d100b017675f1b83220d2825049206ae.jpg_200x200q90.jpg",
        "price": 9380,
        "remark": "https://www.lazada.co.th/products/pdp-i16069200530.html",
        "sold": 0
    },
    {
        "product_name": "🖤❤️🎄พร้อมส่ง🎄❤️🖤(used）ชุดเซตแบรน Endless♾️holiday🎄คอลคริสมาสใหม่🖤สวยเท่ เก๋ มีสไตล์ โดดเด่น ผ้าดี ใส่สบาย📸ถ่ายรูปสวย🖤❤️🎄",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdde24ac9f0ed495fb6a59d3488a1a110Z.jpg_200x200q90.jpg",
        "price": 9380,
        "remark": "https://www.lazada.co.th/products/pdp-i5501850468.html",
        "sold": 0
    },
    {
        "product_name": "Wilson Women Contrast Scoop Neck Dress WE00071U050001 Official Store",
        "product_image": "https://img.lazcdn.com/g/p/eac8aa1fc7da6ceddcd3d175278191ba.jpg_200x200q90.jpg",
        "price": 9380,
        "remark": "https://www.lazada.co.th/products/pdp-i16069222895.html",
        "sold": 0
    },
    {
        "product_name": "[asv aw25] Deanna Long Sleeve Shirt เชิ้ตผู้หญิง แขนยาว ตัดต่อผ้าชีฟองช่วงไหล่ แต่งแถบลูกไม้ ปลายแขนแต่งวอลลุม กระดุมทองหน้า",
        "product_image": "https://img.lazcdn.com/g/p/fd6a33a05c77d2b7b6e0cd9cf939c877.jpg_200x200q90.jpg",
        "price": 9366,
        "remark": "https://www.lazada.co.th/products/pdp-i5896438203.html",
        "sold": 0
    },
    {
        "product_name": "VICKTEERUT (ราคาปกติ 7,880 -.) Front Button Long Sleeve V Neck Blouse เสื้อแขนยาว คอวี กระดุมหน้า",
        "product_image": "https://img.lazcdn.com/g/p/5f26225676b5ce15de411c069c4951f8.jpg_200x200q90.jpg",
        "price": 8668,
        "remark": "https://www.lazada.co.th/products/pdp-i5858315225.html",
        "sold": 3
    },
    {
        "product_name": "ชุดกีฬาเทนนิส  สำหรับผู้หญิง ฤดูร้อน 2025 กระโปรงสั้นสีขาว แขนกุด คอตั้ง ทรงหลวม สวมใส่สบาย ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scba29673d23140eb9731431c50c315c1B.jpg_200x200q90.jpg",
        "price": 7482,
        "remark": "https://www.lazada.co.th/products/pdp-i5245465259.html",
        "sold": 0
    },
    {
        "product_name": "Elle | ชุดเดรสทรงเอ ลดหุ่น ฤดูใบไม้ร่วง 2025",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2a371c9e570a4d5d8e744d29fbfec99di.png_200x200q90.png",
        "price": 7455.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16055440331.html",
        "sold": 0
    },
    {
        "product_name": "💝🤍New+พร้อมส่ง💝🤍เสื้อคาดิแกนแบรน Endless♾️holiday💝คอลใหม่ วาเลนไทน์🤍ลายสวย ใส่สวย ผ้าดี ใส่ได้บ่อย🤍💝",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S42c27a39bb4640eebc6b56a979ef427eI.jpg_200x200q90.jpg",
        "price": 7380,
        "remark": "https://www.lazada.co.th/products/pdp-i6069986288.html",
        "sold": 1
    },
    {
        "product_name": "2026 เสื้อกอล์ฟสำหรับสุภาพสตรีรุ่นใหม่ คอเสื้อแบบมีสีตัดกัน ทรงเข้ารูป ดูอ่อนเยาว์ เสื้อยืดแขนสั้น ดีไซน์เรียบง่ายมีสไตล์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7380d200879548fc810b55d1dce1678dg.jpg_200x200q90.jpg",
        "price": 6623.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16133433827.html",
        "sold": 0
    },
    {
        "product_name": "ชุดคอสเพลย์ Narata Genshin Impact ของเล่นสำหรับผู้หญิง สไตล์ญี่ปุ่นและเกาหลีใต้ เสื้อผ้าคอสเพลย์แบบสองมิติ เหมาะสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb585295cda504ed4a3f73d0f9f331294s.png_200x200q90.png",
        "price": 6604,
        "remark": "https://www.lazada.co.th/products/pdp-i5642767535.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อดอนงานวาด เสื้อดอนยูโทเปีย มือ1 ของแท้100%",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb421509ece8e4f21a004710fa856f512o.jpg_200x200q90.jpg",
        "price": 6600,
        "remark": "https://www.lazada.co.th/products/pdp-i5144709970.html",
        "sold": 0
    },
    {
        "product_name": "Kokiya แจ็กเก็ตชุดว่ายน้ำ3มม. สำหรับผู้ชาย,เสื้อโค้ทนีโอพรีนดำน้ำแขนยาวสีดำเปียก",
        "product_image": "https://img.lazcdn.com/g/p/8819d8c0b8591823bb9236de490d33f5.jpg_200x200q90.jpg",
        "price": 5914,
        "remark": "https://www.lazada.co.th/products/pdp-i5992705620.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อยืดคอตั้งแขนสั้นพิมพ์ลายกอล์ฟระบายอากาศได้ดีสำหรับเล่นกอล์ฟ DEVEREUX GOLF สวมใส่สบาย สำหรับผู้ชายและผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S67285750c6c14f63ae86bab4d4953f6bL.jpg_200x200q90.jpg",
        "price": 5746,
        "remark": "https://www.lazada.co.th/products/pdp-i5724845816.html",
        "sold": 5
    },
    {
        "product_name": "DANBAOLUO | ชุดเดรสวอลตซ์สตรี สีดำ กระโปรงบาน + แต่งขนนกกระจอกเทศ สำหรับเต้นรำ",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S190767a7077c402594da8e534115b22cu.jpg_200x200q90.jpg",
        "price": 5631.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6016627211.html",
        "sold": 2
    },
    {
        "product_name": "CALVIN KLEIN เสื้อยืดคอกลมแขนสั้นผู้หญิง รุ่น 47D206G UB1-สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/0d71ea28d0a1615e8c0b861c59f34da4.jpg_200x200q90.jpg",
        "price": 5600,
        "remark": "https://www.lazada.co.th/products/pdp-i16142804356.html",
        "sold": 0
    },
    {
        "product_name": "Blue Jean Baseball Button-Up Jersey (เสื้อแขนสั้นออกกำลังกายซุมบ้า)",
        "product_image": "https://img.lazcdn.com/g/p/28392a44e9e468595ee54ecb84e506e3.jpg_200x200q90.jpg",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i5775897604.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อรัดรูปกันแดดแขนยาวคอตั้ง กันรังสีUV 99.8% สำหรับผู้หญิง - สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/ab2ead969109afe38bcd3202a2bdbbf8.png_200x200q90.png",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i3789205715.html",
        "sold": 8
    },
    {
        "product_name": "เสื้อรัดรูปกันแดดแขนยาวคอกลม กันรังสีUV 99.8% สำหรับผู้หญิง - สีขาว",
        "product_image": "https://img.lazcdn.com/g/p/a4d7acbf8bb81d38ba45e8d47d9cbdcd.png_200x200q90.png",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i2771557815.html",
        "sold": 18
    },
    {
        "product_name": "เสื้อรัดรูปกันแดดแขนยาวคอกลม กันรังสีUV 99.8% สำหรับผู้หญิง - สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/3e95fa71811c8a5e84fda77fc031ef31.png_200x200q90.png",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i2771618464.html",
        "sold": 6
    },
    {
        "product_name": "เสื้อรัดรูปกันแดดแขนยาวคอตั้ง กันรังสีUV 99.8% สำหรับผู้หญิง - สีขาว",
        "product_image": "https://img.lazcdn.com/g/p/fb30cfa05e35c2f5dd12c625dd81f355.png_200x200q90.png",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i3789288366.html",
        "sold": 6
    },
    {
        "product_name": "FatCryingClub - Courtie dress",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8408371c21bc41618da3cc48047723b23.jpg_200x200q90.jpg",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i5838690354.html",
        "sold": 2
    },
    {
        "product_name": "Zumba Amour Baseball Button-Up Jersey  (เสื้อแขนสั้นออกกำลังกายซุมบ้า)",
        "product_image": "https://img.lazcdn.com/g/p/022fc2b798e7bf569d25f1932f1f3f33.jpg_200x200q90.jpg",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i6049113243.html",
        "sold": 0
    },
    {
        "product_name": "🖤❤️New+พร้อมส่ง🤍❤️กระโปรงแบรน Endless♾️holiday X Mickey Disney🖤รุ่นใหม่ น่ารัก📸ถ่ายรูปสวย ผ้าดี ใส่สบาย🖤🤍❤️",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa52bfe52928042eda3bc5e5b045c9ccdA.jpg_200x200q90.jpg",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i6071950163.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อรัดรูปกันแดดแขนยาวคอกลม กันรังสีUV 99.8% สำหรับผู้หญิง - สีเนื้อ",
        "product_image": "https://img.lazcdn.com/g/p/e21f0060d957a85b041822d26001199a.png_200x200q90.png",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i3981343630.html",
        "sold": 6
    },
    {
        "product_name": "SMFK | เสื้อกล้ามแบบหลายประโยชน์ คอแฮลเตอร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S15a5fdf27f394de0ad25903ec399ccfaL.jpg_200x200q90.jpg",
        "price": 5308,
        "remark": "https://www.lazada.co.th/products/pdp-i16082179935.html",
        "sold": 0
    },
    {
        "product_name": "Kloset Design Ordinary T-shirt (AW24-T025-C)  เสื้อยืดผ้าคอตตอนดีไซน์คลาสสิก",
        "product_image": "https://img.lazcdn.com/g/p/74291ee660bd861fb5590315f85525cd.jpg_200x200q90.jpg",
        "price": 5300,
        "remark": "https://www.lazada.co.th/products/pdp-i5495398775.html",
        "sold": 0
    },
    {
        "product_name": "AZUREWAY | ชุดเดรสสไตล์ฝรั่งเศสสำหรับเล่นกอล์ฟในฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0e1966b59e3144dcbbae856ff24f2460a.jpg_200x200q90.jpg",
        "price": 5253.52,
        "remark": "https://www.lazada.co.th/products/pdp-i6066411907.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเทนนิสทรงสลิม เอลาสติกสูง แขนเปล่า เอวสูง สีพื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S66bf0369189a4edd93ba44275ad6bc61v.png_200x200q90.png",
        "price": 5214.16,
        "remark": "https://www.lazada.co.th/products/pdp-i6075196320.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเชิ้ตผ้าไหมมัลเบอร์รี่ 19 มอมเม่ แขนยาว ปักลาย สำหรับผู้หญิง สวมใส่ทำงาน ฤดูใบไม้ผลิ ฤดูร้อน สไตล์ใหม่ เรียบง่าย เหมาะกับการเดินทาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8f1340fa994f42bb91305299c6ad8f0et.jpg_200x200q90.jpg",
        "price": 5195.28,
        "remark": "https://www.lazada.co.th/products/pdp-i16105198384.html",
        "sold": 0
    },
    {
        "product_name": "Zumba 25 Boxy Mesh Top (เสื้อแขนสั้นออกกำลังกายซุมบ้า)",
        "product_image": "https://img.lazcdn.com/g/p/409e2978fcb92b3609ac5ec810f8ae04.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i16116198144.html",
        "sold": 0
    },
    {
        "product_name": "FootJoy FJ ProDry Performance Lightweight Woven Women's Golf Skort [Asian Fit] - กระโปรง ชุดกอล์ฟ สำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/1722f6221f28a52b0dff6dd1222fd641.jpg_200x200q90.jpg",
        "price": 5040,
        "remark": "https://www.lazada.co.th/products/pdp-i5121580229.html",
        "sold": 6
    },
    {
        "product_name": "ELLE Active | ชุดเดรสกระชับและระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se418906a3b72424f8c855267f22616d0o.png_200x200q90.png",
        "price": 5026.58,
        "remark": "https://www.lazada.co.th/products/pdp-i5882442063.html",
        "sold": 10
    },
    {
        "product_name": "ELLE Active | ชุดเดรสทรงเอเอวสูง ELLE Active ทรงหลวมสบาย ๆ สำหรับผู้หญิง ชุดทำงานกลางแจ้ง ฤดูใบไม้ผลิและฤดูใบไม้ร่วง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S82c4fc4bbed84115819b2b04e5acf53e6.png_200x200q90.png",
        "price": 5023.72,
        "remark": "https://www.lazada.co.th/products/pdp-i5844485479.html",
        "sold": 7
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น W4BI53KCIE1 สีขาว",
        "product_image": "https://img.lazcdn.com/g/p/d79e667ad7959b386c0747340cdcb0fb.jpg_200x200q90.jpg",
        "price": 5022,
        "remark": "https://www.lazada.co.th/products/pdp-i6074623516.html",
        "sold": 0
    },
    {
        "product_name": "moodytiger | เสื้อยืดแขนยาวรูปทรงกระชับพุงพร้อมฟังก์ชันความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S01108fef5caf43c28e8d142e280b24528.png_200x200q90.png",
        "price": 5011.24,
        "remark": "https://www.lazada.co.th/products/pdp-i5945416959.html",
        "sold": 3
    },
    {
        "product_name": "moodytiger | เสื้อโปโลแห้งไวสำหรับเด็กชาย ลายสก็อต ดูดซับเหงื่อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9f6e5f61cbb9413fa2dc19626d9a76dff.png_200x200q90.png",
        "price": 4996.76,
        "remark": "https://www.lazada.co.th/products/pdp-i5910837026.html",
        "sold": 16
    },
    {
        "product_name": "moodytiger | เสื้อโปโลแขนสั้นกันแดดสำหรับกีฬากลางแจ้ง ซับเหงื่อและระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2c1e0dba62b3457abb99bd47157ccc41B.png_200x200q90.png",
        "price": 4990.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16120616029.html",
        "sold": 0
    },
    {
        "product_name": "FatcryingClub - Serena dress",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S128459643dba42c3873cc2677f3a194dG.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i4840696786.html",
        "sold": 2
    },
    {
        "product_name": "FatcryingClub - Strappy dress - Dress with Shorts Sportswear Activewear Athleisure Tennis Golf Woman ออกกำลังกาย ชุดออกกำลัง เดรส ขาสั้น เปืดหลัง กระชับ เก็บทรง เทนนิส กอล์ฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6d16ff7b19be4568abc1847fd33be74dF.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i4841881087.html",
        "sold": 3
    },
    {
        "product_name": "เสื้อเชิ้ตผ้าไหมคอตั้ง ทรงหลวม ผ้าใยวิสโคสหนา แขนยาว คุณภาพสูง สไตล์ลำลองทางธุรกิจ แฟชั่นฤดูใบไม้ผลิ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S19cc6fae52da49c0bc221501a3891418c.jpg_200x200q90.jpg",
        "price": 4954.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16096868456.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเดรสกอล์ฟยืดหยุ่นแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb1ff82d2a9e84b648bbf6e130f961e07H.png_200x200q90.png",
        "price": 4809.08,
        "remark": "https://www.lazada.co.th/products/pdp-i6066887208.html",
        "sold": 0
    },
    {
        "product_name": "WOSAWE | WOSAWE เสื้อแจ็คเก็ตและกางเกงมอเตอร์ไซค์สำหรับผู้หญิง ชุดป้องกันเต็มตัว อุปกรณ์ปั่นจักรยานเสือภูเขาลงเขา อุปกรณ์มอเตอร์ไซค์ ชุดแข่งมอเตอร์ครอส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf8bf657be0f04cd1a77f806f6cc612ef7.jpg_200x200q90.jpg",
        "price": 4759.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16103955896.html",
        "sold": 0
    },
    {
        "product_name": "AZUREWAY | กระโปรงพับป้องกันแสงแดดสำหรับลดความอ้วน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S783e832c929b4907bbd95083a9edcddfx.jpg_200x200q90.jpg",
        "price": 4745.58,
        "remark": "https://www.lazada.co.th/products/pdp-i6066965117.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อสเวตเตอร์ถักและกางเกงขาสั้นสไตล์ลำลองสำหรับผู้หญิง ดีไซน์รูเก๋ๆ ทันสมัย เสื้อและกางเกงทรงหลวม ผ้าขนสัตว์ ทอลายเกลียว  ชุดเซ็ตสุดอินเทรนด์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9d8b1493cb2a4bd08a77249173f68710G.jpg_200x200q90.jpg",
        "price": 4742.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16105280065.html",
        "sold": 0
    },
    {
        "product_name": "Elle | เสื้อเชิ้ตคอวีปักลวดลายละเอียด ใส่ได้ทั้งไปทำงานและลำลอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S97cbb3b2a2c74a3c91b94bd4a85740d0Q.png_200x200q90.png",
        "price": 4740.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16058397142.html",
        "sold": 14
    },
    {
        "product_name": "เสื้อเชิ้ตแขนยาวผ้าไหมชาร์มูส คอตั้ง แฟชั่นผู้หญิง สไตล์ฝรั่งเศส สำหรับฤดูใบไม้ร่วง ผ้าไหมมัลเบอร์รี่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5a50fee8fc614d6285874c7e050fe619Z.jpg_200x200q90.jpg",
        "price": 4685.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16102380504.html",
        "sold": 0
    },
    {
        "product_name": "Golfist | ชุดเดรสทรงกระชับสำหรับฤดูร้อน สำหรับกอล์ฟและเทนนิส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S63adff7f0b004a1db5ff534a0b98ce75n.jpg_200x200q90.jpg",
        "price": 4681.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6066757436.html",
        "sold": 1
    },
    {
        "product_name": "SWAN LOVE GOLF | เสื้อโปโลหญิงคอผีเสื้อ กันลม อบอุ่น กระชับ ยืดหยุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8928d89c74254731a36d78b09b131f7dn.jpg_200x200q90.jpg",
        "price": 4645.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5993181177.html",
        "sold": 2
    },
    {
        "product_name": "René Sleeveless polo top",
        "product_image": "https://img.lazcdn.com/g/p/630801def8b45e4401b3479b76a843bc.jpg_200x200q90.jpg",
        "price": 4620,
        "remark": "https://www.lazada.co.th/products/pdp-i5753036572.html",
        "sold": 0
    },
    {
        "product_name": "AZUREWAY | กระโปรงกอล์ฟสั้น ฤดูใบไม้ร่วงและฤดูหนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S182717044e7a455fbf616d681c165d1eD.jpg_200x200q90.jpg",
        "price": 4618.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6066516732.html",
        "sold": 0
    },
    {
        "product_name": "Peaches ACTIVE - Sporty Halter Neck Dress จั๊มสูทเทนนิส",
        "product_image": "https://img.lazcdn.com/g/p/7d08458a0268e93a0bd79eb55d471bd6.png_200x200q90.png",
        "price": 4580,
        "remark": "https://www.lazada.co.th/products/pdp-i5921124700.html",
        "sold": 0
    },
    {
        "product_name": "GUESS เสื้อยืดแขนสั้นผู้หญิง รุ่น V5GI10K9RM1 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/07f18423ef57d64c31fec29e9d5de188.jpg_200x200q90.jpg",
        "price": 4404,
        "remark": "https://www.lazada.co.th/products/pdp-i6042997149.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI06KD741 สีเบจ",
        "product_image": "https://img.lazcdn.com/g/p/545a9cb352e04495dba02284f4ea29f6.jpg_200x200q90.jpg",
        "price": 4404,
        "remark": "https://www.lazada.co.th/products/pdp-i16066354182.html",
        "sold": 0
    },
    {
        "product_name": "René short-sleeve polo top",
        "product_image": "https://img.lazcdn.com/g/p/bddf7efac820282c70563e6bc6ed56e0.jpg_200x200q90.jpg",
        "price": 4400,
        "remark": "https://www.lazada.co.th/products/pdp-i5753043530.html",
        "sold": 5
    },
    {
        "product_name": "TOOCH - Open Back Bodysuit",
        "product_image": "https://img.lazcdn.com/g/p/ab06ad2eae2552ed0fad5104cbf7d725.jpg_200x200q90.jpg",
        "price": 4380,
        "remark": "https://www.lazada.co.th/products/pdp-i5783168177.html",
        "sold": 9
    },
    {
        "product_name": "WOSAWE | WOSAWE เสื้อแจ็คเก็ตมอเตอร์ไซค์สำหรับผู้หญิงฤดูร้อน ชุดกางเกงมอเตอร์ครอสระบายอากาศ ชุดเสื้อผ้ากีฬากลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S67811f848c8a47848356cc518cd5bef4j.jpg_200x200q90.jpg",
        "price": 4355.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16126898465.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อผ้าผู้หญิงไซส์ใหญ่ ให้ความรู้สึกหรูหรา ชุดเสื้อผ้าไหมแขนสั้น เสื้อและกางเกง 2 ชิ้น สไตล์ฤดูร้อนใหม่ เหมาะสำหรับใส่ไปทำงาน แซนชาโมเร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4b3fa98dd66448fab652be9efe5318c9I.jpg_200x200q90.jpg",
        "price": 4340.32,
        "remark": "https://www.lazada.co.th/products/pdp-i16084263444.html",
        "sold": 0
    },
    {
        "product_name": "Elle | เสื้อถักแขนสั้นสไตล์ออฟฟิศหรูหรา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7f478e370d4f4713997a7e505920186d1.png_200x200q90.png",
        "price": 4325.66,
        "remark": "https://www.lazada.co.th/products/pdp-i5881097844.html",
        "sold": 10
    },
    {
        "product_name": "เสื้อเชิ้ตผ้าไหม คอกลม ทรงหลวม ผ้าซาตินผสม แขนยาว ติดกระดุม สไตล์คลาสสิก ฤดูใบไม้ผลิ ฤดูร้อน สินค้ามาใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S08c304c123dc4751b6148bdfc8ed53b1G.jpg_200x200q90.jpg",
        "price": 4285.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16117864619.html",
        "sold": 0
    },
    {
        "product_name": "ชุดคอสเพลย์โชจิกุ คากุยะ สึคิมิ, ชุดเสื้อครอปและกางเกงขาสั้นสีขาวและสีเขียว, ชุดอนิเมะคอมมิคคอน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S239bbdc3422d4190b92b24023d69afc3b.jpeg_200x200q90.jpg",
        "price": 4243.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16107472667.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกอล์ฟระบายอากาศแห้งไวสำหรับผู้หญิง พร้อมกระโปรงสีดำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd72cf006888641f5849dc987497ca23dA.jpg_200x200q90.jpg",
        "price": 4212.52,
        "remark": "https://www.lazada.co.th/products/pdp-i5877088234.html",
        "sold": 0
    },
    {
        "product_name": "Wakingbee Brooklyn Dress (Black) เดรส ออกกำลังกาย เทนนิส กอล์ฟ มีฟองน้ำในตัว มีซับในขาสั้น ผ้ายืดหยุ่นดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd60622ece75a4839a59a6473bbaffa62g.jpg_200x200q90.jpg",
        "price": 4166,
        "remark": "https://www.lazada.co.th/products/pdp-i5599018090.html",
        "sold": 7
    },
    {
        "product_name": "Wakingbee Brooklyn Dress (Walnut) เดรส ออกกำลังกาย เทนนิส กอล์ฟ มีฟองน้ำในตัว มีซับในขาสั้น ผ้ายืดหยุ่นดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2df3f3ea4ff740e9810142b20ea59deeY.jpg_200x200q90.jpg",
        "price": 4166,
        "remark": "https://www.lazada.co.th/products/pdp-i5599033105.html",
        "sold": 1
    },
    {
        "product_name": "ชุดแฟชั่นฤดูใบไม้ร่วง-ฤดูหนาวแบบหนาสำหรับผู้หญิงไซส์ใหญ่ ชุดสามชิ้นพร้อมเสื้อคลุมเปิดเอวยางยืดสำหรับสาวอวบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5654c9ce09054d79a16a6ed9337b61a12.jpg_200x200q90.jpg",
        "price": 4162.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16105098040.html",
        "sold": 0
    },
    {
        "product_name": "BANANA BABY | เสื้อถักสีบล็อกสำหรับวัยรุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd7e5d5c6b4e4420299987cab740adb71x.png_200x200q90.png",
        "price": 4153.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16071622151.html",
        "sold": 5
    },
    {
        "product_name": "Venum | ชุดวิ่งเรียบเนียนแห้งไวยืดหยุ่นสบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6a6af5cd23064404858b21da2ad12ca5R.jpg_200x200q90.jpg",
        "price": 4026.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16092547948.html",
        "sold": 0
    },
    {
        "product_name": "ZOOT W LTD CYCLE BIB ชุดเอี๊ยมปั่นจักรยานผู้หญิง ของแท้ 💯% 📌 ชุดเอี๊ยม ไม่มีเสื้อตัวในนะคะ",
        "product_image": "https://img.lazcdn.com/g/p/b38ff36ded46caf1d7b6a110493cdfed.jpg_200x200q90.jpg",
        "price": 4000,
        "remark": "https://www.lazada.co.th/products/pdp-i4371049840.html",
        "sold": 1
    },
    {
        "product_name": "TAactive Physique polo เสื้อตีกอล์ฟ เสื้อตีเทนนิส ชุดกอล์ฟ เสื้อกอล์ฟผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/3856f2ae5f59b926c500282e37fc9918.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i16052106202.html",
        "sold": 0
    },
    {
        "product_name": "Kloset and Etcetera Carl &Ellie T-Shirt  (Pixar-01)  เสื้อยืดสีเหลืองดีไซน์พิเศษจาก Disney Pixar – Up พิมพ์ลาย Carl & Ellie ถ่ายทอดเรื่องราวความรักและการผจญภัยอันอบอุ่น โทนสีสดใส ใส่ง่าย เพิ่มความน่ารักให้ลุคประจำวัน",
        "product_image": "https://img.lazcdn.com/g/p/d40f205aaffc358432409c8454230620.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i16096741440.html",
        "sold": 1
    },
    {
        "product_name": "C&D Woman's shirt Linen Fusion เสื้อเชิ้ตผู้หญิง ปกเชิ้ต แขนยาว สีดำ C9ZNBL",
        "product_image": "https://img.lazcdn.com/g/p/d6d3e8fc3360c856f032b31c7e5aa2ee.jpg_200x200q90.jpg",
        "price": 3814.82,
        "remark": "https://www.lazada.co.th/products/pdp-i6006518934.html",
        "sold": 8
    },
    {
        "product_name": "🌸🖤พร้อมส่ง🌸🖤เสื้อยืดคอลใหม่แบรน Endless♾️holiday💗ลายสวย📸ถ่ายรูปสวย ผ้าดี ใส่สบาย ใส่คู่ครอบครัวสวย🖤🌸ลายพิมพ์ทันสมัย🌸",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S53d402beed2b4ee89564f8af283f1573X.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5373502914.html",
        "sold": 1
    },
    {
        "product_name": "Kloset and Etcetera Forky & Karen T-Shirt (Pixar-03) เสื้อยืดสีขาวดีไซน์พิเศษจาก Disney Pixar พิมพ์ลายตัวละครสุดน่ารัก โทนสดใส เพิ่มลูกเล่นให้ลุคดูสนุก ใส่ง่ายในทุกวัน เนื้อผ้านุ่ม สวมใส่สบาย เหมาะกับทั้งลุคชิลและลุคคิวต์",
        "product_image": "https://img.lazcdn.com/g/p/6d1ec32f2b08188a28e380b737f3c861.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i16096661657.html",
        "sold": 3
    },
    {
        "product_name": "Janesuda x Wakingbee Belle Bratop บราท็อปแขนยาว ทรงคร็อป โยคะ พิลาทิส ผ้า \"CoolFit\" เย็น แห้งไว กันยูวี",
        "product_image": "https://img.lazcdn.com/g/p/565d3e8b965ba49215420da0b8130736.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i6043620857.html",
        "sold": 6
    },
    {
        "product_name": "SWAN LOVE GOLF | ชุดกอล์ฟผู้หญิงฤดูใบไม้ผลิ/ฤดูร้อน แขนยาวสไตร์หวาน แห้งไว ระบายอากาศได้ดี กางเกงกระโปรงเอไลน์สูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf5a89dfe4723408b8dc3bb37ae099330x.jpg_200x200q90.jpg",
        "price": 3975.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5875906820.html",
        "sold": 28
    },
    {
        "product_name": "ชุดเซ็ตผู้หญิงแฟชั่นจีบระบาย ดีไซน์หรูหรา สองชิ้น สไตล์โดปามีน เสื้อและกางเกงเข้าชุด ผลิตจากเส้นใยโพลีเอสเตอร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S99afdf0ab0674ad5b96656ae284dea454.jpg_200x200q90.jpg",
        "price": 3927.4,
        "remark": "https://www.lazada.co.th/products/pdp-i16105362042.html",
        "sold": 0
    },
    {
        "product_name": "ชุดคอสเพลย์ Guzheng Fairy สำหรับผู้หญิง เวอร์ชั่นฤดูใบไม้ผลิ 2024 พร้อมหมวก รองเท้า กระเป๋า ชุดคอสเพลย์เกม Guzheng Fairy",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf0cf8abfcc834f90ac96f2c6e46f7e9cm.jpg_200x200q90.jpg",
        "price": 3920,
        "remark": "https://www.lazada.co.th/products/pdp-i5968856593.html",
        "sold": 0
    },
    {
        "product_name": "THE NORTH FACE WOMEN REFINA LONGLINE BRA เสื้อสปอร์ตบรา ผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/f091fde696ae32bc0512292e463213c1.jpg_200x200q90.jpg",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i5814462532.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI09I3Z14 สีเบจ",
        "product_image": "https://img.lazcdn.com/g/p/375b52a88cb8071ce1b354abbffffa48.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16065931891.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI17KD741 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/96edc08d2dd80897af043b291670dfc1.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066344229.html",
        "sold": 1
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI09I3Z14 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/c2c7d2dc5141af85f8f2d0729cfe11e2.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066296415.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI08K8FQ4 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/f12c6ba4543b0e662f1e084ca01b2059.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066053476.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI20J1314 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/5ca301a1e32f7477f7992de7c46b019f.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066129225.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI05I3Z14 สีแดง",
        "product_image": "https://img.lazcdn.com/g/p/8f230dec0dd75786aedbadd030c3452b.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066300387.html",
        "sold": 1
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น V6RI16I3Z14 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/d3127195b8df72d068d510ea8fe298e4.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i16066344232.html",
        "sold": 0
    },
    {
        "product_name": "GUESS เสื้อยืดผู้หญิง รุ่น W1YI1BI3Z14 สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/9bb302998494989bf45481f331a4dbdc.jpg_200x200q90.jpg",
        "price": 3894,
        "remark": "https://www.lazada.co.th/products/pdp-i5369786737.html",
        "sold": 6
    },
    {
        "product_name": "BANANA BABY | เสื้อถักน่ารักสำหรับผู้หญิง ปักลายกระต่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S37bbaafc6f544e69ac0a672c4826cbc8C.png_200x200q90.png",
        "price": 3846.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16071314860.html",
        "sold": 0
    },
    {
        "product_name": "Dash ultralight short sleeve shirt",
        "product_image": "https://img.lazcdn.com/g/p/c020705c9c53f450d9988ee6b56afc15.jpg_200x200q90.jpg",
        "price": 3820,
        "remark": "https://www.lazada.co.th/products/pdp-i5741460564.html",
        "sold": 10
    },
    {
        "product_name": "เสื้อผู้หญิงแขนสั้นระบายอากาศเสื้อเจอร์ซีย์นักปั่นพิมพ์ลายการ์ตูนเสื้อขี่จักรยาน3กระเป๋าและเรียบ YKK ซิปชุดออกกำลังกายชุดปั่นจักรยาน",
        "product_image": "https://img.lazcdn.com/g/p/eea0eb679b5575461f2283ca2a35e155.jpg_200x200q90.jpg",
        "price": 3808,
        "remark": "https://www.lazada.co.th/products/pdp-i5140581930.html",
        "sold": 16
    },
    {
        "product_name": "เสื้อรัดรูป Fairtex x Reversal Rashguard – Spirit of Wai Kru Edition",
        "product_image": "https://img.lazcdn.com/g/p/2834ba5692072af78915bf60f682a31c.png_200x200q90.png",
        "price": 3800,
        "remark": "https://www.lazada.co.th/products/pdp-i16124200850.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อเชิ้ตแขนยาวผู้หญิง ดีไซน์เรียบหรู สีพื้น แต่งสายผูก แขนเสื้อแบบพิเศษ คอลเลคชั่นใหม่ ฤดูใบไม้ผลิ/ฤดูร้อน 2025 ผลิตจากผ้าไหมมัลเบอร์รี่ 100% เหมาะสำหรับใส่ทำงาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S65dad39097b845cf918da9160ac045a4s.jpg_200x200q90.jpg",
        "price": 3793.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16102455016.html",
        "sold": 0
    },
    {
        "product_name": "[สินค้าของแท้100% พร้อมส่ง] Marithe  Mouvement Classic Logo Tee White size S",
        "product_image": "https://img.lazcdn.com/g/p/ceffa8ac71b1c3176d2333b152dcef78.png_200x200q90.png",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i5328221626.html",
        "sold": 0
    },
    {
        "product_name": "ELLE Active | ชุดเดรสทรงเอสปอร์ต ลายจั๊คการ์ด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S95985e1c321544e9a61d4a37f95f39c6a.png_200x200q90.png",
        "price": 3768.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5845002113.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเชิ้ตผ้าไหมผู้หญิง 100% ผ้าไหมมัลเบอร์รี่ สีดำหรูหรา คอวี มีซับใน ติดกระดุม แขนยาว เสื้อเบลาส์สำหรับสุภาพสตรีทำงาน ไซส์ L XL M1104",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6bf9aba7d3584eec821f37ecb89dc23ds.jpg_200x200q90.jpg",
        "price": 3741,
        "remark": "https://www.lazada.co.th/products/pdp-i5972129936.html",
        "sold": 0
    },
    {
        "product_name": "Peaches ACTIVE - Reversible Zip-Up Top สปอร์ตราเทนนิส",
        "product_image": "https://img.lazcdn.com/g/p/e11a38284749d1211af61a8c8a7cc83b.jpg_200x200q90.jpg",
        "price": 3700,
        "remark": "https://www.lazada.co.th/products/pdp-i5920909926.html",
        "sold": 0
    },
    {
        "product_name": "CHER'Z - RW2506 เสื้อเสื้อโอบไหล่ ผ้า Glitter Jersey",
        "product_image": "https://img.lazcdn.com/g/p/2f2c3aa95b10c64a28ad0de3e9c8d2eb.jpg_200x200q90.jpg",
        "price": 3697.58,
        "remark": "https://www.lazada.co.th/products/pdp-i5850561930.html",
        "sold": 17
    },
    {
        "product_name": "เสื้อเชิ้ตผ้าไหมมัลเบอร์รี่ 100% ทรงเข้ารูป แขนยาว สำหรับผู้หญิง สไตล์ลำลอง ใส่ได้ทั้งฤดูใบไม้ผลิและฤดูใบไม้ร่วง เสื้อทำงาน คอเหลี่ยม ตัดสี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3469ae3063744e3a85b866dceb670fady.png_200x200q90.png",
        "price": 3614.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16072572871.html",
        "sold": 0
    },
    {
        "product_name": "HANCHUN | ชุดเดรสสไตล์รีโทรฝรั่งเศส กระชับเอว สปริงและออทูม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5c7a482c01ea4042b72a4fd2b2f6cfb2m.jpg_200x200q90.jpg",
        "price": 3609.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5993997305.html",
        "sold": 0
    },
    {
        "product_name": "เดรสทรงเอไลน์แบบไม่มีแขนพร้อมปกเสื้อ - สไตล์ลำลองสำหรับกอล์ฟ &   ชุดกีฬาเทนนิส",
        "product_image": "https://img.lazcdn.com/g/p/a5d4cc1f9d9e65de77888d628e008a90.jpg_webp_200x200q90.jpg",
        "price": 3600,
        "remark": "https://www.lazada.co.th/products/pdp-i16129284322.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อกั๊กถักคอปกสไตล์ใหม่สำหรับฤดูร้อน ชุดกีฬากอล์ฟสำหรับผู้หญิง ใส่สบาย แมทช์ง่ายกับทุกชุด",
        "product_image": "https://img.lazcdn.com/g/p/ce93be85edf3f35bbbca197fb1b4f416.jpg_200x200q90.jpg",
        "price": 3600,
        "remark": "https://www.lazada.co.th/products/pdp-i16122157060.html",
        "sold": 0
    },
    {
        "product_name": "Peaches Active Soft Sport Era Adjustable Off Shoulder Top – เสื้อเปิดไหล่ มีฟองน้ำในตัว ปรับใส่ได้หลายแบบ Everyday Y2K Active Top",
        "product_image": "https://img.lazcdn.com/g/p/ce5aaa6ca2522a4985d09d1427ab379f.png_200x200q90.png",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i16092327419.html",
        "sold": 0
    },
    {
        "product_name": "XOLO LAYER POE WOMEN รหัส : 040148",
        "product_image": "https://img.lazcdn.com/g/p/a08bd6970bcab44ee6e7a5696d796b3d.jpg_200x200q90.jpg",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i16115445089.html",
        "sold": 1
    },
    {
        "product_name": "TAACTIVE HELENA CROP เสื้อสปอร์ตบรา ซิปด้านหน้า",
        "product_image": "https://img.lazcdn.com/g/p/9e2d68fee69b5913e97beb2741028ccd.jpg_200x200q90.jpg",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i5083289884.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อเชิ้ตผ้าลินินแขนยาวทรงหลวมสไตล์เกาหลีเรียบง่าย สีพื้น ดีไซน์ใหม่รับซัมเมอร์  แบบสบายๆ  ใส่เที่ยวๆ ได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S17d9831d3bf54f4c96226797bc49323cc.jpg_200x200q90.jpg",
        "price": 3562.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16117810200.html",
        "sold": 0
    },
    {
        "product_name": "Peaches Active -The Halter V-Corset Crop สปอร์ตบราออกกำลังกาย",
        "product_image": "https://img.lazcdn.com/g/p/50a26e541602e3c165894e460362ab41.png_200x200q90.png",
        "price": 3554,
        "remark": "https://www.lazada.co.th/products/pdp-i5806621180.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อเชิ้ตผ้าลินินแขนยาวทรงหลวมสไตล์เกาหลี ดีไซน์ใหม่รับซัมเมอร์  แบบเรียบง่าย สีพื้น  ใส่สบายๆ  สำหรับวันสบายๆ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S17d9831d3bf54f4c96226797bc49323cc.jpg_200x200q90.jpg",
        "price": 3549.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16105115672.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อผ้าผู้หญิงสไตล์ยุโรปและอเมริกา แนวลำลองสำหรับต้นฤดูใบไม้ผลิ หรูหรา สง่างาม ลายดอกไม้ วินเทจ ไซส์ 24",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc406e34cdb8d459caec5c77bd9da51a8A.jpg_200x200q90.jpg",
        "price": 3546.66,
        "remark": "https://www.lazada.co.th/products/pdp-i16107233440.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเชิ้ตผ้าไหมผู้หญิง แขนยาว ดีไซน์หรูหรา ชายเสื้อแบบจับจีบ แฟชั่นฤดูใบไม้ผลิ ผ้าไหมมัลเบอร์รี่คุณภาพสูง ทรงเข้ารูป ติดกระดุม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7bfc9f932c20499aa70db4a60cb69418u.jpg_200x200q90.jpg",
        "price": 3546.66,
        "remark": "https://www.lazada.co.th/products/pdp-i16107119901.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเชิ้ตผ้าไหมผู้หญิง แขนยาว เรียบหรู สง่างาม เสื้อเชิ้ตผ้าไหมมัลเบอร์รี่ คอลเลคชั่นใหม่รับฤดูใบไม้ผลิ ทรงหลวม ติดกระดุม สีพื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc6a03939f31244dbbc21ccc9d031089cF.jpg_200x200q90.jpg",
        "price": 3539.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16096999391.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเชิ้ตผ้าไหมผู้หญิง แขนยาว ดีไซน์หรูหรา ชายเสื้อแบบจับเดรป แฟชั่นฤดูใบไม้ผลิ ผ้าไหมมัลเบอร์รี่คุณภาพสูง ทรงเข้ารูป ติดกระดุม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7bfc9f932c20499aa70db4a60cb69418u.jpg_200x200q90.jpg",
        "price": 3539.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16097382362.html",
        "sold": 0
    },
    {
        "product_name": "2XU ชุดออกกำลังกาย ชุดไตรกีฬา สำหรับผู้หญิง 2XU X-VENT Front Zip Trisuit - WT4365d by WeRunOutlet",
        "product_image": "https://img.lazcdn.com/g/p/93cb5172898429abc8938db397fba8f6.jpg_200x200q90.jpg",
        "price": 3510,
        "remark": "https://www.lazada.co.th/products/pdp-i2069958835.html",
        "sold": 0
    },
    {
        "product_name": "VINN PATARARIN - Cut-Out Wellness Tank - เสื้อแขนกุด เจาะอก เสื้อกล้าม",
        "product_image": "https://img.lazcdn.com/g/p/83814a6b0ee66f8d056d5217de8e9d7f.jpg_200x200q90.jpg",
        "price": 3510,
        "remark": "https://www.lazada.co.th/products/pdp-i5711053945.html",
        "sold": 5
    },
    {
        "product_name": "Elle | เสื้อเชิ้ตลายทางสไตล์ฝรั่งเศส ช่วยให้ดูผอม",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S612d0a4766fd447899db39d092676c90r.jpg_200x200q90.jpg",
        "price": 3501.54,
        "remark": "https://www.lazada.co.th/products/pdp-i5878686781.html",
        "sold": 162
    },
    {
        "product_name": "เสื้อเชิ๊ตผู้หญิงแขนสั้นระบายอากาศได้ดีเสื้อเจอร์ซีย์นักปั่น3D Cuts เสื้อปั่นจักรยานมี3กระเป๋าและเรียบ YKK ซิปชุดออกกำลังกายชุดปั่นจักรยาน",
        "product_image": "https://img.lazcdn.com/g/p/0fadf814d2794cc4ff931becb6a11e0d.jpg_200x200q90.jpg",
        "price": 3454,
        "remark": "https://www.lazada.co.th/products/pdp-i5133992662.html",
        "sold": 4
    },
    {
        "product_name": "Miyake เสื้อจีบแขนพองของผู้หญิง,เสื้อยืดลำลองสีทึบอเนกประสงค์ใหม่",
        "product_image": "https://img.lazcdn.com/g/p/103431fe44ee46b81a9be0cbbd7aef22.jpg_200x200q90.jpg",
        "price": 3446,
        "remark": "https://www.lazada.co.th/products/pdp-i5689263005.html",
        "sold": 0
    },
    {
        "product_name": "PGM YF781 ผู้หญิงกอล์ฟฤดูใบไม้ผลิฤดูร้อนผู้หญิงโปโลท็อปส์ซูเสื้อเทนนิสเสื้อยืดกีฬากระโปรงสั้นชุด 2025",
        "product_image": "https://img.lazcdn.com/g/p/af57bd43fb6af07243970dd6296ca649.jpg_200x200q90.jpg",
        "price": 3403.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5661914091.html",
        "sold": 2
    },
    {
        "product_name": "Muuv & Gruuv Beau Sleeveless Dress เดรสกีฬาแขนกุดพร้อมกางเกงซับในและชั้นใน",
        "product_image": "https://img.lazcdn.com/g/p/6b4591f175e9381df2be33aa00976263.jpg_200x200q90.jpg",
        "price": 3402,
        "remark": "https://www.lazada.co.th/products/pdp-i5783039986.html",
        "sold": 2
    },
    {
        "product_name": "Muuv & Gruuv Daisy Dress เดรสกีฬาแขนสั้นพร้อมกางเกงซับในและชั้นใน",
        "product_image": "https://img.lazcdn.com/g/p/b0b7ba26b76c1ee4f8f6254465506540.jpg_200x200q90.jpg",
        "price": 3402,
        "remark": "https://www.lazada.co.th/products/pdp-i5271894113.html",
        "sold": 22
    },
    {
        "product_name": "เสื้อยืดผ้าไหมแขนสั้นทรงหลวมสำหรับผู้หญิง สไตล์ลำลองสำหรับฤดูร้อน คอกลม ดีไซน์ซับเหงื่อ ใส่ได้ทั้งเป็นเสื้อตัวในและตัวนอก สีพื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S761f352278614f448677416ee9ef02524.jpg_200x200q90.jpg",
        "price": 3383.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16096955201.html",
        "sold": 0
    },
    {
        "product_name": "🐻💛พร้อมส่ง🐻💛(used)เสื้อยืดแบรน Lookbookpetite รุ่น🐻Little Bear Benny💛ผ้าดี ลายสวย ใส่สบาย📸ถ่ายรูปสวย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf5ad2b990d8d492f89fbee9facaba8fee.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i6005836396.html",
        "sold": 0
    },
    {
        "product_name": "BIRUCHU LÉNA SHIRTS เสื้อเชิ้ต แขนยาว ผ้าลินิน สีชมพู",
        "product_image": "https://img.lazcdn.com/g/p/8666b582599b7dee2398af57b047397b.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i16044729034.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเดรสสวยหรูดูดีมีระดับในสไตล์คุณ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se872ae03ceb14f7d83a0ccb9ba13c53ch.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i6069613772.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อคาราบาว ของแท้100% พร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S67329e69c04647f9a7258ad2f32b1dceN.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i5144836273.html",
        "sold": 0
    },
    {
        "product_name": "Rookie Girl Tops and Scarf-เสื้อกอล์ฟแขนตุ๊กตา พร้อมผ้าพันคอลายซิกเนเจอร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scadc2b350bfa4a4bb139a20da3bc9fb7z.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i6074898800.html",
        "sold": 0
    },
    {
        "product_name": "GIORDANO Women Shirts Ruffle Round Neck Elegant Blouses Long Sleeve Button Closure Trendy Chic Fashion Casual Shirts 18345517",
        "product_image": "https://img.lazcdn.com/g/p/80336faf7bacf5f73e4fd5dbab775948.jpg_200x200q90.jpg",
        "price": 3378,
        "remark": "https://www.lazada.co.th/products/pdp-i5903549810.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเจอร์ซีย์นักปั่นแขนยาวผู้หญิง,อุปกรณ์จักรยานเสื้อผ้าหมวกขี่ MTB จักรยานเสือหมอบเสื้อผ้าผู้หญิงยืดหยุ่นและระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/p/1fa475e0c3053162bcb0a7bed31591fb.jpg_200x200q90.jpg",
        "price": 3342,
        "remark": "https://www.lazada.co.th/products/pdp-i5365525437.html",
        "sold": 1
    },
    {
        "product_name": "WOSAWE | WOSAWE เสื้อกั๊กปั่นจักรยานฤดูหนาวฤดูใบไม้ร่วงกันลมผู้หญิงจักรยานเสื้อกันลมกันความร้อนเสื้อกั๊กจักรยานเสือหมอบชุดเสื้อผ้าปั่นจักรยาน MTB",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdd0e8b93adde43dcbab2110cc27160a1O.jpg_200x200q90.jpg",
        "price": 3241.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16104991480.html",
        "sold": 0
    },
    {
        "product_name": "ELLE Active | ชุดเดรสเอไลน์สุภาพสบาย ช่วยให้ดูผอม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se3ef511944a54048a9c8039a3adaa2efU.png_200x200q90.png",
        "price": 3227.38,
        "remark": "https://www.lazada.co.th/products/pdp-i6047213467.html",
        "sold": 0
    },
    {
        "product_name": "NATIONAL GEOGRAPHIC T-SHIRT-เสื้อยืดทีเชิ๊ตสำหรับผู้ชายและผู้หญิง#O242UTS305-093",
        "product_image": "https://img.lazcdn.com/g/p/94d84940284a1f33f90b20b4843df9c3.png_200x200q90.png",
        "price": 3190,
        "remark": "https://www.lazada.co.th/products/pdp-i5693905982.html",
        "sold": 0
    },
    {
        "product_name": "สไตล์เกาหลีชุดกีฬาแขนสั้นลำลองผู้หญิงฤดูร้อนใหม่สีบล็อกแฟชั่นกางเกงขากว้างชุดสองชิ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sed5c8ad49c364397bdc9e28fd1a07f59k.jpg_200x200q90.jpg",
        "price": 3187.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16097172734.html",
        "sold": 0
    },
    {
        "product_name": "Cherie Sculpt Top",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S791d2dd3f1fa41babfc9d5d12a7205b6w.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5565253763.html",
        "sold": 4
    },
    {
        "product_name": "ARROW LITE เสื้อแขนยาวคอวี ซื้อ 4 แถม 2 ตัว เสื้อยืดสวย เสื้อแขนยาว ผ้าฝ้าย100% เสื้อแขนยาวผช",
        "product_image": "https://img.lazcdn.com/g/p/7d861f757c9b6f8d10a4694ecdd0b44e.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i2760069139.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อเชิ้ตผ้าไหมแขนยาวทรงหรูหรา ผ้าไหมมัลเบอร์รี่ 100% ผ้าสองชั้น ทรงตรง คอปกโปโล สไตล์คลาสสิก เหมาะสำหรับใส่ทำงาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Safd98e4e76a144ce81e6eaea6a1fd4d1I.jpg_200x200q90.jpg",
        "price": 3170.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16097454562.html",
        "sold": 0
    },
    {
        "product_name": "DODC | ชุดเดรสสไตล์ฝรั่งเศส คอกลม แขนพอง ความยาวกลาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sea750fb465814153ad67f4c7e767444e3.jpg_200x200q90.jpg",
        "price": 3168.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5893833014.html",
        "sold": 29
    },
    {
        "product_name": "WOSAWE | เสื้อแจ็คเก็ตมอเตอร์ไซค์สำหรับผู้หญิง WOSAWE รุ่นซัมเมอร์ ทรงเซ็กซี่ เหมาะสำหรับปั่นจักรยานเสือภูเขา ลงเขา ขี่มอเตอร์ครอส พร้อมแผ่นรองข้อศอก ไหล่ และแผ่นรองหลัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6e5e04aa24214dceb3448d1892efe90fF.jpg_200x200q90.jpg",
        "price": 3166.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16104553523.html",
        "sold": 0
    },
    {
        "product_name": "26 Early Spring New Style Golf Jersey Ladies Sports Windproof Breathable Casual Vest Jersey Outdoor Comfortable All-Match Sleeveless Vest",
        "product_image": "https://img.lazcdn.com/g/p/6619350f7795495bb97292191ca3f605.jpg_200x200q90.jpg",
        "price": 3160,
        "remark": "https://www.lazada.co.th/products/pdp-i6055897193.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแขนสั้นคอกลมผ้าไหมมัลเบอร์รี่ ดีไซน์เรียบง่าย สวมใส่สบาย หลากหลายสไตล์ แฟชั่นฤดูร้อน 2025",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S929605d38854467fbb9708c611989028w.jpg_200x200q90.jpg",
        "price": 3154.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16097648085.html",
        "sold": 0
    },
    {
        "product_name": "XIYUQI | ชุดเดรสยาวสีดำหลวมสไตล์แคชชวลฝรั่งเศสสำหรับฤดูใบไม้ร่วง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc5241fd5bf914cb58c96934c31e65e58Y.jpg_200x200q90.jpg",
        "price": 3150.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16078694300.html",
        "sold": 8
    },
    {
        "product_name": "สามารถซื้อเพิ่มได้ & CHILD ENCIM EMBROIDERED KEBAYA",
        "product_image": "https://img.lazcdn.com/g/p/edfb9a4c4b2f8b6fe20e7222e7d309ae.jpg_200x200q90.jpg",
        "price": 3128,
        "remark": "https://www.lazada.co.th/products/pdp-i5886449010.html",
        "sold": 0
    },
    {
        "product_name": "ชุดแสดงระบำหน้าท้องฤดูร้อน ชุดเต้นระบำหน้าท้อง ชุดเต้นระบำแบบดั้งเดิมของวัฒนธรรมอียิปต์ สำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa89de4f739044030b1c70f948277d6a7j.jpg_200x200q90.jpg",
        "price": 3126.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16104995570.html",
        "sold": 0
    },
    {
        "product_name": "ชุดสวยสง่างามเรียบหรูดูดีตัดเย็บจากผ้าชีฟองอิตาลี่เนื้อนุ่มสวมใส่สบายผิว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc0315f4cf91244c9b2980a7d1278e827e.jpg_200x200q90.jpg",
        "price": 3120,
        "remark": "https://www.lazada.co.th/products/pdp-i6024289197.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแขนสั้นผ้าไหมชานตุง ดีไซน์เก๋สำหรับผู้หญิง ทรงเอวเข้ารูป ช่วยให้ดูผอมเพรียว ผลิตจากผ้าไหมมัลเบอร์รี่ เหมาะสำหรับฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb1c730002d534769ae6e24013030682fe.jpg_200x200q90.jpg",
        "price": 3101.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16102428347.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อเชิ้ตเด็กผู้หญิงสไตล์เกาหลีหลากสี ผ้าแคชเมียร์ คอกลม ผ้าไหมแกะ ลูกไม้ ดอกไม้ ประดับลูกปัด สีพื้น อเนกประสงค์ ลายดอกไม้ แบบชิ้นเดียว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se4c558b688494c91b04ce86a3934ccf8Q.jpg_200x200q90.jpg",
        "price": 3095.94,
        "remark": "https://www.lazada.co.th/products/pdp-i16102025115.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแขนสั้นพิมพ์ลายตัวอักษร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb398373d93fb41a69a4743dcdd6470deX.jpg_200x200q90.jpg",
        "price": 3092,
        "remark": "https://www.lazada.co.th/products/pdp-i5997909336.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดคอกลมจับจีบทรงหลวมลำลองสำหรับผู้หญิงแขนสั้นใหม่ฤดูร้อน2025",
        "product_image": "https://img.lazcdn.com/g/p/2fe61b77b5fb9b133cd9c3afb9a98129.jpg_200x200q90.jpg",
        "price": 3078,
        "remark": "https://www.lazada.co.th/products/pdp-i5940868115.html",
        "sold": 2
    },
    {
        "product_name": "XIYUQI | ชุดเดรสยาวสไตล์มินิมอลสำหรับฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9c610e5ce97245fb910ef5b450690efax.jpg_200x200q90.jpg",
        "price": 3074.94,
        "remark": "https://www.lazada.co.th/products/pdp-i16078590364.html",
        "sold": 0
    },
    {
        "product_name": "INBIKE เสื้อปั่นจักรยานขนแกะผู้หญิงแขนยาวเสื้อสำหรับการขี่จักรยานเสื้อผ้าปั่นจักรยานฤดูหนาว MTB เสื้อจักรยานเสือหมอบภูเขาเสื้อแจ็คเก็ตเสื้อผ้า",
        "product_image": "https://img.lazcdn.com/g/p/df99f33e0914e2a25116a3fc1d81bdfd.jpg_200x200q90.jpg",
        "price": 3070,
        "remark": "https://www.lazada.co.th/products/pdp-i4953328382.html",
        "sold": 2
    },
    {
        "product_name": "ชุดเสื้อสเวตเตอร์ถักสำหรับผู้หญิง คอลเลคชั่นฤดูใบไม้ผลิ 2026 สไตล์ลำลองสำหรับใส่ไปทำงาน ทรงหลวม ผสมผสานเส้นใยขนสัตว์ ชุดสองชิ้น ดีไซน์สีสันตัดกันทันสมัย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S917ded483c9d408caec3bc0672082defR.jpg_200x200q90.jpg",
        "price": 3059.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16107442052.html",
        "sold": 0
    },
    {
        "product_name": "EnForme Long Sleeve – เสื้อออกกำลังกายแขนยาว",
        "product_image": "https://img.lazcdn.com/g/p/ea41c65805fed205bc2eaf388f219370.jpg_200x200q90.jpg",
        "price": 3040,
        "remark": "https://www.lazada.co.th/products/pdp-i6038006569.html",
        "sold": 2
    },
    {
        "product_name": "เสื้อเชิ้ตแขนยาวผ้าไหมกำมะหยี่สไตล์มินิมอลหรูหรา ทรงตรง กระชับสัดส่วน คลาสสิก คอกลม ติดกระดุม เหมาะกับทุกประเภทรูปร่าง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sff88fdc55cf441c79a75c4a9d9bb9ac92.jpg_200x200q90.jpg",
        "price": 3031.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16096882426.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดอะซิเตทคอกลมแขนกุดแฟชั่น เสื้อผ้าผู้หญิง ดีไซน์ใหม่สำหรับฤดูร้อน เสื้อจับจีบแบบต่อผ้า คอกลมอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S756b4a3830254052819bc28f5f60a54ci.jpg_200x200q90.jpg",
        "price": 3027.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16097287498.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเดรสสุภาพเรียบร้อย สีคาปูชิโน่ เน้นเอว สำหรับฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S962b27c3ed744d0a97738ecd202cf110z.jpg_200x200q90.jpg",
        "price": 3018,
        "remark": "https://www.lazada.co.th/products/pdp-i6006031446.html",
        "sold": 0
    },
    {
        "product_name": "YNY | ชุด 3 ชิ้นสำหรับผู้หญิงไซส์ใหญ่ ฤดูใบไม้ร่วง-หนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S026c9620c98d431da97d355e0d82331dU.jpg_200x200q90.jpg",
        "price": 3016,
        "remark": "https://www.lazada.co.th/products/pdp-i6005926989.html",
        "sold": 0
    },
    {
        "product_name": "Lulu New เสื้อกล้ามกีฬาโยคะสายคล้องไหล่กว้างที่ถอดออกได้ Bra Fitness TOP dsg395",
        "product_image": "https://img.lazcdn.com/g/p/d3279289b12940c4a91458423939ee9b.jpg_webp_200x200q90.jpg",
        "price": 3014.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5044739999.html",
        "sold": 0
    },
    {
        "product_name": "Blue Ma Belle Shirt เสื้อโปโลคอปกสำหรับกีฬากอล์ฟและเทนนิส ผ้าระบายอากาศ กันยูวี สีฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/d28212ee73483b347c1cf41e66f83e6e.jpg_200x200q90.jpg",
        "price": 3007.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5778011902.html",
        "sold": 4
    },
    {
        "product_name": "เสื้อกั๊กกอล์ฟผู้หญิงสไตล์ใหม่สำหรับฤดูร้อน เสื้อกีฬากลางแจ้งแบบไม่มีแขน คอสูงครึ่งตัว แห้งเร็ว แฟชั่น",
        "product_image": "https://img.lazcdn.com/g/p/e328a261e1a67f1d0c3da328b515fedb.jpg_webp_200x200q90.jpg",
        "price": 3000,
        "remark": "https://www.lazada.co.th/products/pdp-i16111467491.html",
        "sold": 0
    },
    {
        "product_name": "Lulu New YOGA Sports SHORT Sleeve Tight Elastic Bra Fitness TOP yd069",
        "product_image": "https://img.lazcdn.com/g/p/1be61c4d0ffdc6cc1aec98a9f83f623b.jpg_webp_200x200q90.jpg",
        "price": 2993.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5110932455.html",
        "sold": 0
    },
    {
        "product_name": "D&P Sport 2-IN-1 Mesh Tank | LolliPOP | D-7729 เสื้อกล้ามซีทรู มีสปอร์ตบราด้านใน ไร้โครง กระชับ มีฟองน้ำ ถอดซักได้",
        "product_image": "https://img.lazcdn.com/g/p/a483a378221dbcc525bec6cf23945b4c.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i5635528695.html",
        "sold": 0
    },
    {
        "product_name": "FatCryingClub - Ribbed Form bra",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1d6372f25d35464fa758fa25eab75d72V.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i5738529551.html",
        "sold": 1
    },
    {
        "product_name": "🖤❤️🐭พร้อมส่ง❤️🖤 🐭เสื้อเชิ๊ตเด็ก(ใส่ได้ทั้งชาย-หญิง)แบรน Endless♾️holiday รุ่น Mickey Floral All day shirt🤍ลายสวย🖤❤️",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S86d6fd52909c4c57ba1462975c178e42d.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i5395339708.html",
        "sold": 0
    },
    {
        "product_name": "(LIMITED) SPORTY MOOD 3\" - BUTTER FABRIC",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4db6e28ad71748119b02d75fe62edc78X.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i4884288033.html",
        "sold": 1
    },
    {
        "product_name": "SPORTY MOOD 3\" - BUTTER FABRIC",
        "product_image": "https://img.lazcdn.com/g/p/2773a0090d73084547126d4deb5a6da8.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i5067428835.html",
        "sold": 3
    },
    {
        "product_name": "Golf clothing women's short skirt 26 summer new style, elegant and versatile golf sport anti-slip pleated skirt",
        "product_image": "https://img.lazcdn.com/g/p/24c5d1fc26b0fd5cfe5979f7fb96abe9.jpg_200x200q90.jpg",
        "price": 2960,
        "remark": "https://www.lazada.co.th/products/pdp-i16096302097.html",
        "sold": 0
    },
    {
        "product_name": "M 夏季高爾夫女裙免燙速乾彈力戶外運動短褲時尚高爾夫球裙服裝#M2501Golf Amariss",
        "product_image": "https://img.lazcdn.com/g/p/4e288bcc7256dff7160d85930cee26bf.jpg_webp_200x200q90.jpg",
        "price": 2960,
        "remark": "https://www.lazada.co.th/products/pdp-i5730151807.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกอล์ฟแขนยาวผู้หญิงสไตล์เกาหลี ชุดเทนนิส ชุดกระโปรงยืดหยุ่น ชุดกอล์ฟสำหรับผู้หญิง ชุดกีฬาสุภาพสตรี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbb540daf424e42128a2430f4493ca1c7j.jpg_200x200q90.jpg",
        "price": 2943.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5241060531.html",
        "sold": 0
    },
    {
        "product_name": "RockBros | ROCKBROSฤดูหนาวขี่จักรยานเสื้อขนแกะผู้ชายผู้หญิงWindproofจักรยานความร้อนแจ็คเก็ตกลางแจ้งMtb Bike Jersey 0 องศาเสื้อผ้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S098c6002118a4ff0a4768d7870491f1aH.jpg_200x200q90.jpg",
        "price": 2941.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16104838535.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดเกรดBยกแพค100ตัวคละไชร์xs-s-m-l-xl-2xl-3xlมีเก็บปลายทางมีโค้ดส่งฟรีคะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S39a5c517f99e4447af736619b5ad2777x.jpg_200x200q90.jpg",
        "price": 2900,
        "remark": "https://www.lazada.co.th/products/pdp-i4727670298.html",
        "sold": 1
    },
    {
        "product_name": "Women's Spring Golf Jersey, New Style, Windproof and Breathable, Comfortable to Make You Enjoy Going Out",
        "product_image": "https://img.lazcdn.com/g/p/6619350f7795495bb97292191ca3f605.jpg_webp_200x200q90.jpg",
        "price": 2900,
        "remark": "https://www.lazada.co.th/products/pdp-i16092379227.html",
        "sold": 0
    },
    {
        "product_name": "Brooklyn & Brighton - Astronaut Uniform เด็กผู้ชาย เด็กผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/a96566264d5a385a0c8fae05cbea8630.jpg_200x200q90.jpg",
        "price": 2900,
        "remark": "https://www.lazada.co.th/products/pdp-i5490261266.html",
        "sold": 30
    },
    {
        "product_name": "WOSAWE | WOSAWE เสื้อแจ็คเก็ตมอเตอร์ไซค์สำหรับผู้หญิง MTB Downhill Biker เสื้อสะท้อนแสงสำหรับผู้หญิงวัยรุ่นสาววิบากเสื้อผ้ายืดหยุ่นสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8c93c4e772154bc480f33403f9edc2d5C.jpg_200x200q90.jpg",
        "price": 2893.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16104524322.html",
        "sold": 0
    },
    {
        "product_name": "VFU | กระโปรงเทนนิสทรงพลีทสไตล์สปอร์ต",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S27f9406e2f594fecb5d716202bc84afeH.png_200x200q90.png",
        "price": 2887,
        "remark": "https://www.lazada.co.th/products/pdp-i5933065270.html",
        "sold": 104
    },
    {
        "product_name": "URBAN REVIVO แขนยาวผู้หญิงในเมืองเสื้อสตรีแขนยาวเปิดไหล่เหมาะสำหรับการทำงานและออกเดท",
        "product_image": "https://img.lazcdn.com/g/p/9e7e1cf7d6ec8bd1d87a876efe2b7a04.jpg_200x200q90.jpg",
        "price": 2880,
        "remark": "https://www.lazada.co.th/products/pdp-i5931593293.html",
        "sold": 0
    },
    {
        "product_name": "betweenand | เสื้อเบลาส์แขนระฆังสีน้ำเงินกรมท่าลายดาว น่ารักสไตล์ฤดูใบไม้ผลิ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S37378c70167d48e38cca0c8319a39bd01.jpg_200x200q90.jpg",
        "price": 2860.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16075918958.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อคอกลมหลวมสไตล์ลำลองสปอร์ตแฟชั่นไซส์ใหญ่สำหรับผู้หญิง พร้อมกางเกงขายาวทรงกว้าง ชุดลำลองสำหรับฤดูร้อนสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sef678c49e2e340c6949da639dcce49d5p.jpg_200x200q90.jpg",
        "price": 2849.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16096868628.html",
        "sold": 0
    },
    {
        "product_name": "WOSAWE | WOSAWE ผู้หญิงฤดูร้อนชุดขี่จักรยาน Jersey Breathable หญิงสั้น Jersey จักรยานเสื้อผ้าชุด Mtb Maillot นักปั่นจักรยานเสื้อผ้าจักรยาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scde9bb1696954d40ac2f1785d6624daeI.jpg_200x200q90.jpg",
        "price": 2803.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16104845749.html",
        "sold": 0
    },
    {
        "product_name": "MYRA Tide Halter Tank - เสื้อคล้องคอแขนกุดออกกำลังกาย มีฟองน้ำในตัว กระชับเข้ารูป ดีเทลเส้นโชว์หลัง",
        "product_image": "https://img.lazcdn.com/g/p/e18d481d785139ecf34d200c0f74f141.png_200x200q90.png",
        "price": 2800,
        "remark": "https://www.lazada.co.th/products/pdp-i5627937995.html",
        "sold": 3
    },
    {
        "product_name": "XIAODADEHUA | ชุดเดรสเสื้อยืดบางๆ สไตล์ลำลองแบบไล่สี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd303ddad84e74d64933b2fbb7f63ffaeX.jpg_200x200q90.jpg",
        "price": 2794.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6029482776.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแขนสั้นผ้าไหมกำมะหยี่สำหรับผู้หญิง แฟชั่นฤดูร้อน คอกลม ทรงหลวม ผ้าไหมมัลเบอร์รี่ แต่งขอบลูกไม้ ปะติดปะต่อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se376572fb46a4998ad4a97979b6db0c0Q.jpg_200x200q90.jpg",
        "price": 2794.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16107199671.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเต้นรำ ชุดฝึกซ้อม ชุดแสดงบนเวที ขายดีประจำฤดูกาล แฟชั่นโชว์ใหม่ ชุดพิธีการทรงเข้ารูป XT1028 ชุดเต้นรำแบบกลุ่ม B",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scd4d960e2ec841aeb46f698a26c9a997z.jpg_200x200q90.jpg",
        "price": 2774.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16096999057.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเต้นรำ ชุดซ้อม ชุดแสดงบนเวที ขายดีประจำฤดูกาล แฟชั่นโชว์ใหม่ ชุดกระชับสัดส่วน งานพิธี XT1028 ชุดเต้นรำ B...",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scd4d960e2ec841aeb46f698a26c9a997z.jpg_200x200q90.jpg",
        "price": 2774.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16097059264.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดแฟชั่นผู้หญิง คอลเลคชั่นซัมเมอร์ 2025 ดีไซน์จับจีบเอว คอทรงกลม แขนกุด/แขนสั้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S701be086c86444dd95dc532f35a28480F.jpg_200x200q90.jpg",
        "price": 2773.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16097388001.html",
        "sold": 0
    },
    {
        "product_name": "Golfist | ชุดกอล์ฟแขนยาวสำหรับผู้หญิง ใส่ได้ทั้งฤดูใบไม้ผลิและใบไม้ร่วง ระบายอากาศได้ดีและยืดหยุ่น สกิร์ต",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdd8d087527e947aaa0064bdaa282b8e13.jpg_200x200q90.jpg",
        "price": 2773.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6066521619.html",
        "sold": 0
    },
    {
        "product_name": "unifree | เสื้อแขนสั้นคอกลม Peter Pan สีชมพู ขอบฟู ประดับด้วยเส้นไหมวิบวับ ขอบระบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S61ef23afe17449d78e10f72ca229943fK.png_200x200q90.png",
        "price": 2772.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16107698314.html",
        "sold": 0
    },
    {
        "product_name": "Wakingbee Slash Bratop (Midnight Bloom) สปอร์ตบราพร้อมเสื้อคลุม ใส่ได้สองแบบ ดีไซน์สวย ผ้านุ่ม ยืดหยุ่นดี แห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S23b625fe2de54aa18e6df826b6effc63N.jpg_200x200q90.jpg",
        "price": 2766,
        "remark": "https://www.lazada.co.th/products/pdp-i5387684149.html",
        "sold": 7
    },
    {
        "product_name": "ชุดทุกอย่างใหม่สไตล์เกาหลี เสื้อแขนกุดบางแฟชั่นไหมน้ำแข็งกอล์ฟและชุดเดรส A-Line กันแสง # 6011 #",
        "product_image": "https://img.lazcdn.com/g/p/b37488b51262b04589a75eac774d97c6.jpg_200x200q90.jpg",
        "price": 2760,
        "remark": "https://www.lazada.co.th/products/pdp-i5778881255.html",
        "sold": 0
    },
    {
        "product_name": "KAVU Klear Above Etch Art T-Shirt เสื้อยืด",
        "product_image": "https://img.lazcdn.com/g/p/bdd2bfecf2a9d11b8dffb1989a38c636.jpg_200x200q90.jpg",
        "price": 2730,
        "remark": "https://www.lazada.co.th/products/pdp-i4608426361.html",
        "sold": 28
    },
    {
        "product_name": "ชุดเซ็ตสามชิ้นสำหรับผู้หญิงไซส์พลัส เสื้อถักนิตติ้ง กางเกงขายาวทรงกว้าง แฟชั่นลำลองสำหรับฤดูใบไม้ผลิ เนื้อผ้า PVC ระบายอากาศได้ดี สวมใส่สบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1c266aba556646d9ada7c313aa9b0e92R.jpg_200x200q90.jpg",
        "price": 2716.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16107266507.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อผ้าลำลองสำหรับผู้หญิง ผ้าฝ้ายแท้สามชั้น ลายดอกไม้คลาสสิก สำหรับฤดูหนาว ทรงหลวม สวมใส่สบาย อุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb5aad0b3efba42a1977f790d219978dbP.jpg_200x200q90.jpg",
        "price": 2716.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16072774579.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อสเวตเชิ้ตผ้ากำมะหยี่ลายแกะน่ารักสำหรับเด็กผู้หญิง 3 ชิ้น ชุดลำลองสไตล์โลลิต้า แฟชั่นฤดูใบไม้ร่วงฤดูหนาว ผ้ากำมะหยี่หนานุ่ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa56ea1c9493c4610b08188f5d018b065R.jpg_200x200q90.jpg",
        "price": 2700.66,
        "remark": "https://www.lazada.co.th/products/pdp-i16104999976.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเดรสสไตล์ฝรั่งเศสไซส์ใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S572905ebe6894c69ae713fb1b0a4b833B.jpg_200x200q90.jpg",
        "price": 2692,
        "remark": "https://www.lazada.co.th/products/pdp-i6006235377.html",
        "sold": 0
    },
    {
        "product_name": "GUESS WOMEN เสื้อยืด รุ่น QBYI0CK9TJ1  สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/51c0280345dde3e5934d22c146a9dc61.jpg_200x200q90.jpg",
        "price": 2692,
        "remark": "https://www.lazada.co.th/products/pdp-i16066162983.html",
        "sold": 0
    },
    {
        "product_name": "ชุดลำลองสไตล์สปอร์ตสองชิ้น แฟชั่นฤดูใบไม้ผลิสำหรับผู้หญิง สไตล์เกาหลี ผ้าฝ้าย เสื้อผ้าคุณแม่ ทันสมัย ลดอายุ ดูอ่อนเยาว์ ไซส์เล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8e86b6f7208a4dd98e2ce94a52ddacecV.jpg_200x200q90.jpg",
        "price": 2686.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16107295362.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อขี่จักรยานแบบใหม่เสื้อกีฬากลางแจ้งสำหรับผู้หญิงเสื้อเสื้อแจ็คเก็ตกันหนาวจักรยานเสือหมอบแขนยาวผ้าฟลีซสำหรับฤดูหนาวและฤดูหนาว",
        "product_image": "https://img.lazcdn.com/g/p/48ed46bb7164ed6fa1127bc75402ade4.jpg_200x200q90.jpg",
        "price": 2680,
        "remark": "https://www.lazada.co.th/products/pdp-i5961212630.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อสเวตเตอร์สไตล์เกาหลีลำลองสำหรับผู้หญิง แฟชั่นฤดูใบไม้ร่วงฤดูหนาว ลดอายุด้วยเสื้อฮู้ดพิมพ์ลายตัวอักษร กางเกงขายาวทรงหลวม สวมใส่สบายๆ แบบสปอร์ต ชุดสองชิ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S07066f761f6c4cfeb152f7bad553e06bF.jpg_200x200q90.jpg",
        "price": 2674.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16107334434.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกีฬาลำลองสไตล์เกาหลีสำหรับผู้หญิง เสื้อฮู้ดผ้าฟลีซหลวม กางเกงขายาวทรงกว้าง ชุดสองชิ้น สีแดง สำหรับฤดูใบไม้ร่วงและฤดูหนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S13f756b5f6414f22994c6f09cf7065e4d.jpg_200x200q90.jpg",
        "price": 2674.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16107129774.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเดรสพอดีตัวสไตล์ชิปาว พิมพ์ลายสีขาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S23180a7808d6452e9f76dac21539577ez.jpg_200x200q90.jpg",
        "price": 2672.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16113950226.html",
        "sold": 0
    },
    {
        "product_name": "[MILIN] Long sleeves ruched front detail sheer shir เสื้อเชิ้ตแขนยาวผ้าโปร่งแต่งรูดด้านหน้า / Cedar Top",
        "product_image": "https://img.lazcdn.com/g/p/8cf5f7e833e1dff2403bc41e116a3e10.jpg_200x200q90.jpg",
        "price": 2664.62,
        "remark": "https://www.lazada.co.th/products/pdp-i3582700308.html",
        "sold": 9
    },
    {
        "product_name": "เสื้อเชิ้ตผ้าไหมผู้หญิงแขนยาวสีพื้นสำหรับเดินทางไปทำงาน ผ้าไหมหม่อนหางโจว คอปก ปิดกระดุม แฟชั่นผู้หญิง ฤดูใบไม้ผลิ ฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S546a5f8724e744d7bfdb3bdfc5086fb2D.jpg_200x200q90.jpg",
        "price": 2650.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16096907809.html",
        "sold": 0
    },
    {
        "product_name": "when.we.stretch - Everyday Rib Tank  มีบราในตัว กระดุมถอดได้จริงทุกเม็ด (-เฉพาะเสื้อ-) สินค้าพร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/p/8ac4c815346ecf51d7fa55d364bb7124.png_200x200q90.png",
        "price": 2642.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5928427932.html",
        "sold": 5
    },
    {
        "product_name": "Peaches Active - Fabric Silk Flex Timeless Halter Dress - เดรสออกกำลังกาย / ชุดออกกำลังกายผู้หญิง ชุดเดรสมีกางเกงขาสั้นในตัว กระโปรง",
        "product_image": "https://img.lazcdn.com/g/p/784f272a1158bac117f46ebcf46cc775.png_200x200q90.png",
        "price": 2628,
        "remark": "https://www.lazada.co.th/products/pdp-i4674125778.html",
        "sold": 1
    },
    {
        "product_name": "ชุดแฟชั่นถักนิตติ้งสุดหรู ฤดูใบไม้ร่วง ฤดูหนาว สินค้ามาใหม่ สไตล์หรูหรา เสื้อผ้าลำลองสำหรับผู้หญิง แขนยาว กางเกงสามส่วน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf1f83eee67cd4d358768cdd66906c2edd.jpg_200x200q90.jpg",
        "price": 2626.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16105277191.html",
        "sold": 0
    },
    {
        "product_name": "Flipbelt | เสื้อกล้ามวิ่งแห้งเร็วสำหรับฝึกซ้อม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S493eb84dcca344d580067f80b455053bM.jpg_200x200q90.jpg",
        "price": 2624.76,
        "remark": "https://www.lazada.co.th/products/pdp-i5933146261.html",
        "sold": 34
    },
    {
        "product_name": "lookbookpetite lookbook academy cardigan เสื้อคาร์ดิแกน หนานุ่มใส่สบาย สี pink pommette/ little benny",
        "product_image": "https://img.lazcdn.com/g/p/6764946da580491820bd1c7916c52383.jpg_200x200q90.jpg",
        "price": 2600,
        "remark": "https://www.lazada.co.th/products/pdp-i5979189654.html",
        "sold": 12
    },
    {
        "product_name": "LI-NING ผู้หญิงเสื้อกล้ามฟิตเนสกีฬาอาชีพ AUDV020ขาตั้งกล้องที่ถูกกฎหมาย",
        "product_image": "https://img.lazcdn.com/g/p/a7683dc22da9b0614ee85b35bb6c3ba3.jpg_200x200q90.jpg",
        "price": 2599.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5580953155.html",
        "sold": 0
    },
    {
        "product_name": "Soft Ribbed Biker Off white แบรนด์ Pleasure & Leisure กางเกงขาสั้นสำหรับออกกำลังกาย วิ่ง ไร้ตะเข็บด้านหน้า เนื้อผ้าดี สัมผัสนุ่ม กระชับ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa9382f9f34e24583a2a37d419285f111d.jpg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i5740676667.html",
        "sold": 0
    },
    {
        "product_name": "BKKFit Everyday Pilates Top เสื้อทอปแขนยาว บราในตัว",
        "product_image": "https://img.lazcdn.com/g/p/e94ecd02f43c519bdd113c6d6e58b1d0.jpg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i5355473920.html",
        "sold": 17
    },
    {
        "product_name": "UNBOUND TIME RIPPLE SPORTS BRA &gt;PEACH สปอร์ตบราสีพีช (เฉพาะเสื้อ)",
        "product_image": "https://img.lazcdn.com/g/p/e245b2af0dc738857d5aab4dabad7ed2.jpg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i16048558953.html",
        "sold": 0
    },
    {
        "product_name": "VANESSE : VNS CHICS ROMPER CODE : 029111",
        "product_image": "https://img.lazcdn.com/g/p/3650d42dbd215584e1577b4a62bbe25f.jpg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i6071382276.html",
        "sold": 0
    },
    {
        "product_name": "Audrey Bra in White Lily (สปอร์ตบรา)",
        "product_image": "https://img.lazcdn.com/g/p/81236e350a975f577c7d0b223e52059a.jpg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i5707287483.html",
        "sold": 19
    },
    {
        "product_name": "Margarita - AVA KNITTED TOP",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S369586b9426c46af8346d306acb30579z.jpg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i16064732408.html",
        "sold": 2
    },
    {
        "product_name": "when.we.stretch - Everyday Double Layer Rib Bra สายคล้องคอปรับระดับได้ (-เฉพาะบรา-) *พร้อมส่ง*",
        "product_image": "https://img.lazcdn.com/g/p/900addff7cd86e835c56e78a21c4aa70.png_200x200q90.png",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i5928736613.html",
        "sold": 1
    },
    {
        "product_name": "2025 สไตล์ใหม่ [เกาหลี] เสื้อผ้ากอล์ฟ กระโปรงจีบฤดูร้อนสำหรับผู้หญิง แฟชั่นกีฬา ฮากามะสั้น",
        "product_image": "https://img.lazcdn.com/g/p/91f6aff730e31687dbc5ad7654afee38.jpg_webp_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i5635231699.html",
        "sold": 1
    },
    {
        "product_name": "ชุดเสื้อยืดกีฬาสีเทาสำหรับผู้หญิง ชุดลำลองสองชิ้นสำหรับฤดูร้อน สไตล์สบายๆ แฟชั่น ผลิตจากผ้าฝ้ายออร์แกนิก ผลิตในประเทศจีน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc8738793497749cba60d802bbdaf9dbfx.jpg_200x200q90.jpg",
        "price": 2554.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16097309327.html",
        "sold": 0
    },
    {
        "product_name": "angelseason | ชุดเดรสกีฬาป้องกัน UV แห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S680720d559274403ad6285f1ad1537c6y.jpg_200x200q90.jpg",
        "price": 2552,
        "remark": "https://www.lazada.co.th/products/pdp-i6065855390.html",
        "sold": 162
    },
    {
        "product_name": "เสื้อแจ็คเก็ตสตรีสไตล์จีนคอวีหรูหราแฟชั่นฤดูใบไม้ร่วงใหม่ย้อนยุคหรูหราชุดถังเสื้อแขนยาวผ้าโพลีเอสเตอร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sea9276e2afda4ea3b1a120f51f4b209el.jpg_200x200q90.jpg",
        "price": 2538.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16105041999.html",
        "sold": 0
    },
    {
        "product_name": "ชุดแฟชั่นฤดูใบไม้ร่วงสำหรับผู้หญิง เสื้อและกางเกงไซส์ใหญ่ระดับไฮเอนด์ ชุดสองชิ้นทรงพลีทช่วยพรางหุ่น สวมใส่สบาย สไตล์วินเทจลำลอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6797604129fc45b8a8c33524fffd0713j.jpg_200x200q90.jpg",
        "price": 2508.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16107473006.html",
        "sold": 0
    },
    {
        "product_name": "GIORDANO ผู้หญิง  เสื้อยืดพิมพ์ลายขาดๆ จีบไม่สมมาตร คอกลม แขนสั้น เสื้อยืดแฟชั่นเก๋ๆ สบายๆ 18325806",
        "product_image": "https://img.lazcdn.com/g/p/39b15258a5efd42497ad4695a794e474.jpg_200x200q90.jpg",
        "price": 2518,
        "remark": "https://www.lazada.co.th/products/pdp-i5737775791.html",
        "sold": 12
    },
    {
        "product_name": "ชุดเสื้อสเวตเชิ้ตสไตล์ฮาราจูกุลำลองสำหรับผู้หญิง ชุดเซ็ตสองชิ้นแฟชั่นใหม่สำหรับฤดูใบไม้ผลิและฤดูใบไม้ร่วง กางเกงขายาว ผ้าคอตตอนผสม ช่วยลดอายุ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S12e5c96f94504a469acc23bf80091eb9s.jpg_200x200q90.jpg",
        "price": 2516.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16097378852.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อสเวตเชิ้ตผู้หญิงสไตล์ฮาราจูกุลำลอง ชุดเซ็ตสองชิ้นแฟชั่นใหม่ ฤดูใบไม้ผลิ ฤดูใบไม้ร่วง ผ้าผสมคอตตอน กางเกงขายาว ช่วยลดอายุ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S12e5c96f94504a469acc23bf80091eb9s.jpg_200x200q90.jpg",
        "price": 2516.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16097240326.html",
        "sold": 0
    },
    {
        "product_name": "Kumpoo | เสื้อทีเชิร์ตกีฬาแบบซับเหงื่อและระบายอากาศได้ สำหรับชายและหญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbb53878065304c1fa8f623898e3070a68.jpg_200x200q90.jpg",
        "price": 2516.16,
        "remark": "https://www.lazada.co.th/products/pdp-i6051701992.html",
        "sold": 12
    },
    {
        "product_name": "Miyake Pleated เสื้อยืดแขนสั้นจับจีบคอกลมระดับไฮเอนด์ 2026 สีเขียวมิ้นท์เรียบง่าย เสื้อกระชับสัดส่วนอเนกประสงค์สำหรับฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/1d8e2a61783396c4efd350ef798bb3aa.jpg_200x200q90.jpg",
        "price": 2514,
        "remark": "https://www.lazada.co.th/products/pdp-i5901666294.html",
        "sold": 9
    },
    {
        "product_name": "when.we.stretch - Rally&Rest Polo Vest เสื้อคอปกมาพร้อมฟองน้ำในตัว",
        "product_image": "https://img.lazcdn.com/g/p/c83000c158cab426290619cfbdefd17e.jpg_200x200q90.jpg",
        "price": 2512.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5802698965.html",
        "sold": 0
    },
    {
        "product_name": "Peaches Active - V-FORM Halter Top เสื้อฮาลเตอร์บราโครงเสริมฟองน้ำ พร้อมดีไซน์ตัดช่วงเอวรูปตัววี กระชับและซัพพอร์ต",
        "product_image": "https://img.lazcdn.com/g/p/183cf20fe7bf734b066296a121c4ac7c.png_200x200q90.png",
        "price": 2508,
        "remark": "https://www.lazada.co.th/products/pdp-i5728906775.html",
        "sold": 1
    },
    {
        "product_name": "HANCHUN | ชุดเดรสแฟชั่นฤดูร้อน ใส่แล้วดูผอมที่เอว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S866dac7c8a7345dfa958025efbfb352eF.jpg_200x200q90.jpg",
        "price": 2507.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5993985480.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกีฬาผู้หญิง Dongda Gate ซัมเมอร์ 2025 เสื้อคอกลมแขนสั้น กางเกงขายาวทรงกว้าง แฟชั่นสีพื้น ชุดลำลอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb5e0583c8023474d9e5cd9776a778c4fi.jpg_200x200q90.jpg",
        "price": 2504.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16102119084.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดผู้หญิงแขนสั้นผ้าไหมสีดำแฟชั่นฤดูร้อนสไตล์หลวมบางเซ็กซี่สวมใส่สบายเหมาะสำหรับสวมใส่สบายๆสำหรับหญิงสาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf153243cfcef400aa37d5ed2c1d54c26q.jpg_200x200q90.jpg",
        "price": 2495.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16102356538.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดผู้หญิงแขนสั้นผ้าไหมสีดำแฟชั่นฤดูร้อนสไตล์หลวมบางเซ็กซี่สวมใส่สบายเหมาะสำหรับสวมใส่แบบลำลองสำหรับหญิงสาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf153243cfcef400aa37d5ed2c1d54c26q.jpg_200x200q90.jpg",
        "price": 2492.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16107151940.html",
        "sold": 0
    },
    {
        "product_name": "Miyake เสื้อยืดเสื้อยืดคอกลมจีบแขนสั้นสำหรับผู้หญิง,ใหม่2026สีทึบหลวมระบายอากาศสำหรับฤดูร้อนลำลองสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/1fe2095181b6a5573d7afbf1d32b438b.jpg_200x200q90.jpg",
        "price": 2491.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16089069682.html",
        "sold": 0
    },
    {
        "product_name": "MEIZICAI | ชุด Dans ฝึกและแสดง รุ่นใหม่ 2026 กระโปรงเต็ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb30b514fdac34dc4bfed81c35d381a6bf.jpg_200x200q90.jpg",
        "price": 2490,
        "remark": "https://www.lazada.co.th/products/pdp-i16079405658.html",
        "sold": 1
    },
    {
        "product_name": "NATIONAL GEOGRAPHIC T-SHIRT-เสื้อยืดทีเชิ๊ตสำหรับผู้ชายและผู้หญิง#N243UTS210-010",
        "product_image": "https://img.lazcdn.com/g/p/1a7d7353f8674643e6ba6d5962c53b19.jpg_200x200q90.jpg",
        "price": 2490,
        "remark": "https://www.lazada.co.th/products/pdp-i5694030522.html",
        "sold": 0
    },
    {
        "product_name": "HANCHUN | ชุดเดรสสองชิ้นสไตล์เรโทรฝรั่งเศส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd9f9cf6b81b04deba7bc907ff9894f8eR.jpg_200x200q90.jpg",
        "price": 2488.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5994002203.html",
        "sold": 3
    },
    {
        "product_name": "moodytiger | เสื้อยืดสำหรับเด็กผู้หญิงแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2fc47ae5dea24ba480bbf38795964823z.jpg_200x200q90.jpg",
        "price": 2478.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5910836011.html",
        "sold": 56
    },
    {
        "product_name": "XIYUQI | ชุดเดรสฤดูร้อนเกาหลี สไตล์เรียบง่าย สง่างาม ใส่สบาย กระชับ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S70904c4c576446a89aaa6e2cea3567b0n.jpg_200x200q90.jpg",
        "price": 2467.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16083682322.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเดรสสลิปแขนสั้นสำหรับผู้หญิง แนวเซ็กซี่รัดรูป เหมาะสำหรับเล่นกีฬา โยคะ ชุดว่ายน้ำ กระโปรงบัลเลต์เงา ชุดเลโอตาร์ดสำหรับงานปาร์ตี้ ชุดเต้นรำบอลรูม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S48b265e57afd47de8ee04103a12d21d2g.jpg_200x200q90.jpg",
        "price": 2464.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16097741540.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อแจ็กเก็ตดำน้ำ & แล่นเรือ Baju Menyelam Neoprene 3มม. สำหรับผู้ชายผู้หญิงชุดดำน้ำตื้นชุดเล่นกระดานโต้คลื่นกีฬาทางน้ำชุดดำน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/95dc15cc9bbf0352020bc8754a0f7f00.jpg_200x200q90.jpg",
        "price": 2463.56,
        "remark": "https://www.lazada.co.th/products/pdp-i4707998183.html",
        "sold": 0
    },
    {
        "product_name": "Giordano Women's เสื้อผู้หญิง Linen Cotton Loose Long Sleeve Shirt 05346222001 เสื้อเชิ้ตผู้หญิง เสื้อลินิน เสื้อจิออดาโน",
        "product_image": "https://img.lazcdn.com/g/p/b712f87702103f939775cb1ec98f653f.jpg_200x200q90.jpg",
        "price": 2458,
        "remark": "https://www.lazada.co.th/products/pdp-i16116016010.html",
        "sold": 0
    },
    {
        "product_name": "when.we.stretch - Abby Sculpt Tank เสื้อกล้ามออกกำลังกายพร้อมบราในตัว **สินค้าพร้อมส่ง**",
        "product_image": "https://img.lazcdn.com/g/p/ba32f6d4e6256b5c881c6836514824a2.png_200x200q90.png",
        "price": 2452.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16060036964.html",
        "sold": 1
    },
    {
        "product_name": "maison KEEPS Kids | Mina Knitted Cardigan | เสื้อเด็ก คาร์ดิแกนไหมพรม | มีให้เลือก 3 Size",
        "product_image": "https://img.lazcdn.com/g/p/4a8a6f8f768e985b378dc1cb8a03bef3.jpg_200x200q90.jpg",
        "price": 2452,
        "remark": "https://www.lazada.co.th/products/pdp-i5833208636.html",
        "sold": 5
    },
    {
        "product_name": "Sweet Sculpt Double Layer Tank -  Sweet Mess Collection",
        "product_image": "https://img.lazcdn.com/g/p/ac3fa2ea89d274de10d1188e4e2e29aa.jpg_200x200q90.jpg",
        "price": 2446.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5943293311.html",
        "sold": 26
    },
    {
        "product_name": "X-TIGER ผู้หญิงเสื้อเจอร์ซีย์นักปั่นขี่จักรยานกลางแจ้งระบายอากาศแห้งเร็วแขนสั้น Pro ผ้ายืดหยุ่นสูงเสื้อจักรยานแฟชั่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3b0d201caf9e4fd298dce6bb63cbb51d3.jpg_200x200q90.jpg",
        "price": 2425.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5839487796.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดผ้าไหมปักลายห่าน แขนสั้น คอกลม ทรงหลวม เสื้อยืดผ้าไหมผู้หญิง ฤดูใบไม้ผลิ ฤดูร้อน สไตล์ใหม่ ลำลอง สไตล์เกาหลี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S658207fcbb3c4206bdb7b64d60a284339.jpg_200x200q90.jpg",
        "price": 2421.4,
        "remark": "https://www.lazada.co.th/products/pdp-i16107434171.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อไฟท์ ฮอ แท้ USA Size M",
        "product_image": "https://img.lazcdn.com/g/p/282ccde1af12c003f3a77355c6099054.jpg_200x200q90.jpg",
        "price": 13980,
        "remark": "https://www.lazada.co.th/products/pdp-i5128360387.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อแท้!! Newcastle Home Jersey 95-97 Retro เสื้อนิวคาสเซิลแท้ ย้อนยุค คลาสสิคมากตัวนี้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S905d9b5152c84dc5a39c8524f8f980a7G.jpg_200x200q90.jpg",
        "price": 13800,
        "remark": "https://www.lazada.co.th/products/pdp-i5930771827.html",
        "sold": 0
    },
    {
        "product_name": "Columbia | แจ็คเก็ตบุนวมขนเป็ดสำหรับผู้ชาย น้ำหนักเบา สีดำ C64-YMD326",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Sc706663c35dc4a578bf841518baac333A.jpg_200x200q90.jpg",
        "price": 12192.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5963952024.html",
        "sold": 0
    },
    {
        "product_name": "Darling ยางนีโอพรีนสำหรับผู้ชายดำน้ำเต็มรูปแบบเสื้อเวทสูทผู้ชายสำหรับแขนยาว5มม. ชุดเว็ทสูท",
        "product_image": "https://img.lazcdn.com/g/p/6647e006cab00734728f006b2717232b.jpg_200x200q90.jpg",
        "price": 11592,
        "remark": "https://www.lazada.co.th/products/pdp-i5412476862.html",
        "sold": 0
    },
    {
        "product_name": "Skins | เสื้อออกกำลังกายแบบบีบอัดแห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S47fb2e396b2c4f7d884be7fe5174c85em.png_200x200q90.png",
        "price": 11166.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5876335854.html",
        "sold": 5
    },
    {
        "product_name": "PUMA เสื้อแข่งผู้ชายทีมชาติโปรตุเกส โรนัลโด้ หมายเลข 7 ชุดเยือน เกรด Authentic ฤดูกาล 2026",
        "product_image": "https://img.lazcdn.com/g/p/53cafd1aa0067fe880cc4623fd6331c4.jpg_200x200q90.jpg",
        "price": 10200,
        "remark": "https://www.lazada.co.th/products/pdp-i16117278576.html",
        "sold": 0
    },
    {
        "product_name": "Liverpool FC | เสื้อแฟนซีชั่น 25-26 สำหรับใส่ที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S33aa584ba821479fad66910caa391b17v.jpg_200x200q90.jpg",
        "price": 8298,
        "remark": "https://www.lazada.co.th/products/pdp-i16044491651.html",
        "sold": 67
    },
    {
        "product_name": "Liverpool FC | เสื้อฟุตบอลแฟนนอกบ้าน ฤดูกาล 25-26",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scbce9aa862024dd5892cc26fc0ccc094o.jpg_200x200q90.jpg",
        "price": 8282,
        "remark": "https://www.lazada.co.th/products/pdp-i16044651279.html",
        "sold": 13
    },
    {
        "product_name": "แท้ล้าน% Manchester United Away 1991 Jersey Retro เสื้อแมนยูแท้ ย้อนยุค",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf384f7f248af4dec925084be23e6c86cv.jpg_200x200q90.jpg",
        "price": 7400,
        "remark": "https://www.lazada.co.th/products/pdp-i5931086018.html",
        "sold": 0
    },
    {
        "product_name": "96/98 *แท้*Original* - Liverpool Home - ลิเวอร์พูลเหย้า ปี96 size 34/36",
        "product_image": "https://img.lazcdn.com/g/p/9a163177c79dfc278debdc5a898b3fbb.jpg_200x200q90.jpg",
        "price": 6980,
        "remark": "https://www.lazada.co.th/products/pdp-i5801560593.html",
        "sold": 0
    },
    {
        "product_name": "ผู้ชายรูปแบบตานกงานฝีมือระดับ high-end ฤดูร้อนบางชุด 2 ชิ้นจัดเลี้ยงงานแต่งงานธุรกิจชุดลําลอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9b089e8f2cce4d0ea8ed413ab323340bK.jpg_200x200q90.jpg",
        "price": 6614.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16095006857.html",
        "sold": 0
    },
    {
        "product_name": "PUMA เสื้อแข่งผู้ชายทีมชาติโปรตุเกส โรนัลโด้ หมายเลข 7 ชุดเยือน เกรด Replica ฤดูกาล 2026",
        "product_image": "https://img.lazcdn.com/g/p/eaf9ad6aefc2b026b5dda2834afc712c.jpg_200x200q90.jpg",
        "price": 6400,
        "remark": "https://www.lazada.co.th/products/pdp-i16117346351.html",
        "sold": 0
    },
    {
        "product_name": "PUMA Manchester City KING Retro เสื้อฟุตบอลผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/p/d7f93ce7fa6e9b3fac716c8cf2e5dd8b.jpg_200x200q90.jpg",
        "price": 6080,
        "remark": "https://www.lazada.co.th/products/pdp-i16089860483.html",
        "sold": 0
    },
    {
        "product_name": "PUMA เสื้อแข่งผู้ชายทีมชาติโปรตุเกส ชุดเหย้า เกรด Replica ฤดูกาล 2025/26",
        "product_image": "https://img.lazcdn.com/g/p/b96a58620e6461f2fc5373f2e3385129.jpg_200x200q90.jpg",
        "price": 5510,
        "remark": "https://www.lazada.co.th/products/pdp-i5997520610.html",
        "sold": 1
    },
    {
        "product_name": "PUMA AC Milan KING Retro เสื้อฟุตบอลผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/p/e551613a3e257d90f437033691713248.jpg_200x200q90.jpg",
        "price": 6080,
        "remark": "https://www.lazada.co.th/products/pdp-i16090092012.html",
        "sold": 0
    },
    {
        "product_name": "PUMA เสื้อแข่งผู้ชายทีมแมนเชสเตอร์ ซิตี้ ชุดที่สี่ เกรด Replica ฤดูกาล 2025/26",
        "product_image": "https://img.lazcdn.com/g/p/b0b564267346dd9f4ab9ff4c35af794d.jpg_200x200q90.jpg",
        "price": 5800,
        "remark": "https://www.lazada.co.th/products/pdp-i5958593904.html",
        "sold": 2
    },
    {
        "product_name": "เสื้อเว็ทสูทดำน้ำผู้ชาย –  3mm Blue Wave Jacket Male แบรนด์ WATER PRO",
        "product_image": "https://img.lazcdn.com/g/p/5144e7b17543bc9f5f2ce1833645d1d8.jpg_200x200q90.jpg",
        "price": 5800,
        "remark": "https://www.lazada.co.th/products/pdp-i389874060.html",
        "sold": 1
    },
    {
        "product_name": "PUMA เสื้อแข่งผู้ชายทีมชาติโปรตุเกส ชุดเยือน ฤดูกาล 2026",
        "product_image": "https://img.lazcdn.com/g/p/e427af06fc71c6dddaf1c80cfc1e0a04.jpg_200x200q90.jpg",
        "price": 5800,
        "remark": "https://www.lazada.co.th/products/pdp-i16117033869.html",
        "sold": 0
    },
    {
        "product_name": "[ของแท้พร้อมส่ง🇹🇭] เสื้อบอล CARNIVAL® x Big Mountain Cow Stage Jersey",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S201b483a07674f72872689bb147e19e6V.jpg_200x200q90.jpg",
        "price": 5798,
        "remark": "https://www.lazada.co.th/products/pdp-i5982022782.html",
        "sold": 0
    },
    {
        "product_name": "LCFC เสื้อแข่งทีมเหย้า รุ่น 2025/2026 Adult Home Shirt",
        "product_image": "https://img.lazcdn.com/g/p/ab9f829c7312916162bce691edaffa1d.jpg_200x200q90.jpg",
        "price": 5700,
        "remark": "https://www.lazada.co.th/products/pdp-i6050349329.html",
        "sold": 0
    },
    {
        "product_name": "LCFC เสื้อแข่งทีมเยือน รุ่น 2025/2026  Adult Away Shirt",
        "product_image": "https://img.lazcdn.com/g/p/35a93ed1b8604d42aecbde7b8018a3a1.jpg_200x200q90.jpg",
        "price": 5700,
        "remark": "https://www.lazada.co.th/products/pdp-i6050332731.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อปั่นจักรยานชายยืดหยุ่นสูง ระบายอากาศได้เร็ว แห้งไว ซับเหงื่อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdf77780efa2c4743b956f5e0d6f252190.jpg_200x200q90.jpg",
        "price": 5695.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5841057492.html",
        "sold": 20
    },
    {
        "product_name": "เสื้อปั่นจักรยานฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9ffc97f9b14e488bb67daea8f6a3dc1aX.jpg_200x200q90.jpg",
        "price": 5613.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5874300991.html",
        "sold": 19
    },
    {
        "product_name": "BROOO เสื้อแขนสั้น[ OUT OF CONTROL ] เสื้อวิ่ง PRO SINGLET RUNNING Singlet",
        "product_image": "https://img.lazcdn.com/g/p/5ed32a05ede199f98eb39152cd0e1d40.jpg_200x200q90.jpg",
        "price": 5580,
        "remark": "https://www.lazada.co.th/products/pdp-i5990381924.html",
        "sold": 0
    },
    {
        "product_name": "PUMA เสื้อแข่งผู้ชายทีมโบรุสซีอาดอร์ทมุนท์ เกรด Replica คัพ ฤดูกาล 2025/26",
        "product_image": "https://img.lazcdn.com/g/p/4d845df3b54a625aafe1b073630c475d.jpg_200x200q90.jpg",
        "price": 5510,
        "remark": "https://www.lazada.co.th/products/pdp-i5874724046.html",
        "sold": 0
    },
    {
        "product_name": "PUMA เสื้อแข่งผู้ชายทีมแมนเชสเตอร์ซิตี้ ชุด City Year Of The Horse Special Edition ฤดูกาล 2025/26",
        "product_image": "https://img.lazcdn.com/g/p/0f996f6c5aea98be934b7f91b564fa5a.jpg_200x200q90.jpg",
        "price": 5510,
        "remark": "https://www.lazada.co.th/products/pdp-i6061307229.html",
        "sold": 0
    },
    {
        "product_name": "PUMA เสื้อแข่งผู้ชายทีมแมนเชสเตอร์ซิตี ชุดที่สาม เกรด Replica ฤดูกาล 2025/26",
        "product_image": "https://img.lazcdn.com/g/p/323f748be804e80480ba9828058848bf.jpg_200x200q90.jpg",
        "price": 5510,
        "remark": "https://www.lazada.co.th/products/pdp-i5851312833.html",
        "sold": 0
    },
    {
        "product_name": "PUMA เสื้อแข่งผู้ชายทีมเอซี มิลาน ชุดเยือน ฤดูกาล 2025/26",
        "product_image": "https://img.lazcdn.com/g/p/398a7c15b1ff28e671b342c0b076a58b.jpg_200x200q90.jpg",
        "price": 5510,
        "remark": "https://www.lazada.co.th/products/pdp-i5813585191.html",
        "sold": 0
    },
    {
        "product_name": "เสื้ออาเซน่อลเกรดแฟนบอล ตัวล่าสุด ARSENAL 2024/2025 HOME REPLICA JERSEY - BETTER SCARLET/WHITE",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfc315c72ff384820b42fa2aae1adcd619.jpg_200x200q90.jpg",
        "price": 5400,
        "remark": "https://www.lazada.co.th/products/pdp-i5226113292.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อรัดรูปกันแดดแขนยาวคอกลม กันรังสีUV 99.8% สำหรับผู้ชาย - สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/c6c92a24c6cb15c31c1dc25440a10029.png_200x200q90.png",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i2771631339.html",
        "sold": 16
    },
    {
        "product_name": "เสื้อรัดรูปกันแดดแขนยาวคอตั้ง กันรังสีUV 99.8% สำหรับผู้ชาย - สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/91fc859da366b3ce812491ada1f81209.png_200x200q90.png",
        "price": 5380,
        "remark": "https://www.lazada.co.th/products/pdp-i3789341186.html",
        "sold": 3
    },
    {
        "product_name": "เสื้อแท้ล้าน% ป้ายไทย Manchester United Home Jersey 25/26 เสื้อแมนยูแท้ แขนสั้น / ยาว เกรดแฟนบอล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S11fc96e685d44330b215c3610179d2a8f.jpg_200x200q90.jpg",
        "price": 5200,
        "remark": "https://www.lazada.co.th/products/pdp-i5929853231.html",
        "sold": 0
    },
    {
        "product_name": "ผู้ชาย New Balance 2010 โจ Freshgoods กระเป๋า ผู้หญิง Trainer",
        "product_image": "https://img.lazcdn.com/g/p/3c075ec085383ab035a0ff9993ae0aa8.jpg_200x200q90.jpg",
        "price": 5176,
        "remark": "https://www.lazada.co.th/products/pdp-i6069590413.html",
        "sold": 0
    },
    {
        "product_name": "Manchester United Home Shirt ปี2023-2024 แฟนบอล มือ1ป้ายห้อย สีเขียว หลังโล่ง อก 40-42 Size M",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6e84c2eacff34879ac1dce796de0a113L.jpg_200x200q90.jpg",
        "price": 5100,
        "remark": "https://www.lazada.co.th/products/pdp-i16094062099.html",
        "sold": 0
    },
    {
        "product_name": "Manchester United Home Shirt ปี 2022-2023 ของแท้มือ1 ขนาด 3XL อก 52-54",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S94e61eda7363449e96e3c9dd24f58cd4M.jpg_200x200q90.jpg",
        "price": 5100,
        "remark": "https://www.lazada.co.th/products/pdp-i6062132431.html",
        "sold": 0
    },
    {
        "product_name": "moodytiger | เสื้อยืดแขนยาวสำหรับเด็กชาย ยืดหยุ่นสูง เสื้อกีฬา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9936ecf8c72a4666880784992d2e2a5dn.png_200x200q90.png",
        "price": 4998.84,
        "remark": "https://www.lazada.co.th/products/pdp-i5950123179.html",
        "sold": 15
    },
    {
        "product_name": "WARRIX เสื้อฟุตบอลทีมชาติไทย (Player) Blackout TH National Jersey 2025/26 (WA-254FBATH51)",
        "product_image": "https://img.lazcdn.com/g/p/68ae6e98591f7f695e357c78add05fd6.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i5943003103.html",
        "sold": 17
    },
    {
        "product_name": "Under Armour UA U Easy Step",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sef6cbcc2a281475e882f0fe7d2ce921dM.png_200x200q90.png",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i16058868812.html",
        "sold": 1
    },
    {
        "product_name": "ชุดเซ็ทลำลองสไตล์สปอร์ตสำหรับผู้ชาย เสื้อฮู้ดและกางเกงขายาว แฟชั่นฤดูใบไม้ร่วงและฤดูหนาว สวมใส่สบาย ระบายอากาศได้ดี สไตล์สตรีทแวร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0014d4213fae47e3adac130fb75078c3Q.jpg_200x200q90.jpg",
        "price": 4944.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5987125932.html",
        "sold": 0
    },
    {
        "product_name": "UMBRO เสื้อแข่งผู้ชายทีมเรนเจอร์ส ชุดเยือน ฤดูกาล 2025/26",
        "product_image": "https://img.lazcdn.com/g/p/d0addf856f06bd792580ef497708f4a2.jpg_200x200q90.jpg",
        "price": 4930,
        "remark": "https://www.lazada.co.th/products/pdp-i5874705114.html",
        "sold": 0
    },
    {
        "product_name": "UMBRO เสื้อแข่งผู้ชายทีมอิปสวิช ทาวน์ ชุดที่สาม ฤดูกาล 2025/26",
        "product_image": "https://img.lazcdn.com/g/p/da023ab12cbbe365095055c13f24589c.jpg_200x200q90.jpg",
        "price": 4930,
        "remark": "https://www.lazada.co.th/products/pdp-i5874694112.html",
        "sold": 1
    },
    {
        "product_name": "UMBRO เสื้อแข่งผู้ชายทีมซานโตส ชุดเหย้า ฤดูกาล 2025/26",
        "product_image": "https://img.lazcdn.com/g/p/44be9aee001c1ab75f298ea5a3c9ab73.jpg_200x200q90.jpg",
        "price": 4930,
        "remark": "https://www.lazada.co.th/products/pdp-i5958624749.html",
        "sold": 0
    },
    {
        "product_name": "UMBRO เสื้อแข่งผู้ชายทีมเกรมิโอ ชุดเหย้า ฤดูกาล 2025/26",
        "product_image": "https://img.lazcdn.com/g/p/c369ae5ce1e20648589fd3397085afac.jpg_200x200q90.jpg",
        "price": 4930,
        "remark": "https://www.lazada.co.th/products/pdp-i5958624748.html",
        "sold": 0
    },
    {
        "product_name": "UMBRO เสื้อแข่งผู้ชายทีมอิปสวิช ทาวน์ ชุดเหย้า ฤดูกาล 2025/26",
        "product_image": "https://img.lazcdn.com/g/p/cd819feea5497816804bfe1f068674da.jpg_200x200q90.jpg",
        "price": 4930,
        "remark": "https://www.lazada.co.th/products/pdp-i5874694111.html",
        "sold": 3
    },
    {
        "product_name": "UMBRO เสื้อแข่งผู้ชายทีมอิปสวิช ทาวน์ ชุดเยือน ฤดูกาล 2025/26",
        "product_image": "https://img.lazcdn.com/g/p/f0251a1aff2af96a8abfc793325ba25b.jpg_200x200q90.jpg",
        "price": 4930,
        "remark": "https://www.lazada.co.th/products/pdp-i5874697133.html",
        "sold": 3
    },
    {
        "product_name": "PUMA AUSTRIA 2026 REPLICA JERSEY -  เสื้อฟุตบอล พูม่า ออสเตรีย 2026",
        "product_image": "https://img.lazcdn.com/g/p/5ef3354449017710c6eed11c6abaf9be.jpg_200x200q90.jpg",
        "price": 4930,
        "remark": "https://www.lazada.co.th/products/pdp-i16109171403.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อทีม Real Madrid 2001/2002 Centenary (Away) เสื้อแท้ 💯 ชื่อเบอร์ Zidane 5 (มือ 2)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5d686645bc7e46d7866dcb62802b0670I.jpg_200x200q90.jpg",
        "price": 4780,
        "remark": "https://www.lazada.co.th/products/pdp-i16081516317.html",
        "sold": 0
    },
    {
        "product_name": "LFC Retro 2004/05 Home เสื้อผู้รักษาประตูผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/p/df0b60642420f368160ec22b10541ce6.jpg_200x200q90.jpg",
        "price": 4744,
        "remark": "https://www.lazada.co.th/products/pdp-i6061341083.html",
        "sold": 0
    },
    {
        "product_name": "【JB Traders】 Men's Elite Sleeved Triathlon Suit Short Sleeve Trisuit Speedsuit Skinsuit Swim-Bike-Run Ciclismo Maillot Jumpsuit 2xs-4xl Size",
        "product_image": "https://img.lazcdn.com/g/p/7e7343dd106b20d73a9ab87471ca9860.jpg_200x200q90.jpg",
        "price": 4666.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5086931359.html",
        "sold": 0
    },
    {
        "product_name": "BOSIDENG | เสื้อยืดคอกลมหลวมระบายอากาศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc1ade2e5875e40a19397187213bcc4657.png_200x200q90.png",
        "price": 4577.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6011113034.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อผู้ชายอันเดอร์ อาร์เมอร์, ชุดกีฬา, สวมใส่สบาย, ระบายอากาศได้ดี, เสื้อโปโลลำลอง, เสื้อยืดวิ่งออกกำลังกาย 1377374-012",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5197d3ec6cce4dcfae3be06c72dc90049.jpg_200x200q90.jpg",
        "price": 4537.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16116528235.html",
        "sold": 0
    },
    {
        "product_name": "SLINX 5MM Neoprene Wetsuit ผู้ชายแยกเสื้อดำน้ำกีฬาทางน้ำดำน้ำครีมกันแดด Warm Surf ดำน้ำดูปะการังดำน้ำชุดว่ายน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/c896afcac79695cc7002a40a0cef2aa9.jpg_200x200q90.jpg",
        "price": 4517.32,
        "remark": "https://www.lazada.co.th/products/pdp-i4189102425.html",
        "sold": 6
    },
    {
        "product_name": "เสื้อยืดผู้ชายอันเดอร์ อาร์เมอร์ชุดกีฬาฟิตเนสเทรนนิ่งออกกำลังกายแฟชั่นเสื้อแขนยาวระบายอากาศได้ดี 1387434-014",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se3b37362b67b4ed5848307571408f31e8.jpg_200x200q90.jpg",
        "price": 4499.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16105008312.html",
        "sold": 0
    },
    {
        "product_name": "WARRIX ใหม่ล่าสุด!! เสื้อฟุตบอลทีมชาติไทย 2025-26 เกรดนักเตะ (Player Version) Thailand National Jersey WA-253FBATH51",
        "product_image": "https://img.lazcdn.com/g/p/7b0705ed2ac7b43db9dfae76086ac2c2.jpg_200x200q90.jpg",
        "price": 4480,
        "remark": "https://www.lazada.co.th/products/pdp-i5858079713.html",
        "sold": 0
    },
    {
        "product_name": "ชุดลำลองผู้ชายแบบสปอร์ต แจ็คเก็ตคอตั้งปักลาย  ชุดเซ็ตสำหรับฤดูใบไม้ผลิและฤดูใบไม้ร่วง สวมใส่สบาย ระบายอากาศดี รุ่นสำหรับผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb2ac515bf5624828a6cbce0630634de1F.jpg_200x200q90.jpg",
        "price": 4457.94,
        "remark": "https://www.lazada.co.th/products/pdp-i16072889457.html",
        "sold": 0
    },
    {
        "product_name": "LFC เสื้อแข่งย้อนยุคผู้ชายทีมลิเวอร์พูล Retro Candy ชุดที่สาม ฤดูกาล 1988/89",
        "product_image": "https://img.lazcdn.com/g/p/9137a1599ddfd20a424dfdb3c3621abd.jpg_200x200q90.jpg",
        "price": 4404,
        "remark": "https://www.lazada.co.th/products/pdp-i16076891669.html",
        "sold": 0
    },
    {
        "product_name": "LIVERPOOL FOOTBALL CLUB เสื้อแข่งย้อนยุคผู้ชายทีมลิเวอร์พูล Istanbul ปี 2005",
        "product_image": "https://img.lazcdn.com/g/p/6de037179c76f488c89ab4c22061c875.jpg_200x200q90.jpg",
        "price": 4404,
        "remark": "https://www.lazada.co.th/products/pdp-i5379479047.html",
        "sold": 7
    },
    {
        "product_name": "Kywbike เสื้อแขนสั้นลายดวงดาวสำหรับผู้ชายเสื้อปั่นจักรยานเสือภูเขาดูดซับระบายอากาศได้ให้ความชื้นเสื้อเจอร์ซีย์นักปั่นฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/7ca044903b1a1860ebaaa26fca3c1ffc.jpg_200x200q90.jpg",
        "price": 4380,
        "remark": "https://www.lazada.co.th/products/pdp-i5628662535.html",
        "sold": 1
    },
    {
        "product_name": "ROCKBROS เสื้อปั่นจักรยานใยสังเคราะห์เอลาสเทนด์ไฟเบอร์นุ่มสบายผิวแขนสั้นเป็นมิตรชุดปั่นจักรยานอุปกรณ์เสริมจักรยาน",
        "product_image": "https://img.lazcdn.com/g/p/827626b9204a7a48b0dc36195e573894.jpg_200x200q90.jpg",
        "price": 4372,
        "remark": "https://www.lazada.co.th/products/pdp-i3504612058.html",
        "sold": 56
    },
    {
        "product_name": "ชุดคอสเพลย์ฟู่หรงเฉียน ชุดฮั่นฝูโบราณสำหรับผู้ชาย ชุดเต็มสไตล์โบราณ ชุดฮั่นฝูสำหรับผู้ชายแบบครบชุด ชุดสาวน้อยสไตล์โบราณ สำหรับเกม ต้นแบบจากจีนแผ่นดินใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf5a0d6ac74a042139958235a6a16af84W.jpg_200x200q90.jpg",
        "price": 4302,
        "remark": "https://www.lazada.co.th/products/pdp-i16045757375.html",
        "sold": 0
    },
    {
        "product_name": "ชุดลำลองผู้ชายแบบใหม่ ชุดเสื้อสเวตเชิ้ตปักลายคอกลม สำหรับฤดูใบไม้ผลิและฤดูใบไม้ร่วง สวมใส่สบาย ระบายอากาศได้ดี ทันสมัย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1db555d466b34153b1b6afbf6fbce86ao.jpg_200x200q90.jpg",
        "price": 4250.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16099317100.html",
        "sold": 0
    },
    {
        "product_name": "ชุดลำลองผู้ชาย สไตล์ยุโรปสุดหรู สำหรับฤดูใบไม้ร่วงและฤดูหนาว  ชุดเสื้อแจ็คเก็ตและกางเกงขายาว  ผ้าคอตตอนผสม  แขนยาว  สไตล์สปอร์ตแคชชวล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S32ee55cb40854534acdb32413cb05cc84.jpg_200x200q90.jpg",
        "price": 4192.66,
        "remark": "https://www.lazada.co.th/products/pdp-i16090524030.html",
        "sold": 0
    },
    {
        "product_name": "PUMA Manchester City เสื้อฟุตบอลผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/p/67e067aaaa952ef97ae5259ed494ccec.jpg_200x200q90.jpg",
        "price": 4180,
        "remark": "https://www.lazada.co.th/products/pdp-i16090018235.html",
        "sold": 0
    },
    {
        "product_name": "Apres Zumba Men's Basketball Tank  (เสื้อออกกำลังกายซุมบ้า)",
        "product_image": "https://img.lazcdn.com/g/p/5b111aeae69f3cb08f25af899c505106.jpg_200x200q90.jpg",
        "price": 4180,
        "remark": "https://www.lazada.co.th/products/pdp-i5927433772.html",
        "sold": 0
    },
    {
        "product_name": "moodytiger | เสื้อโปโลแขนสั้นสำหรับเด็กชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sda0edc83f578499f9a074aee4624e6cej.png_200x200q90.png",
        "price": 4132.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5910771701.html",
        "sold": 18
    },
    {
        "product_name": "ชุดกีฬาแฟชั่นผู้ชาย ขายดีประจำฤดู ฤดูใบไม้ผลิ ฤดูใบไม้ร่วง เสื้อสเวตเชิ้ตปักลายกลิตเตอร์ กางเกงขายาว ชุดสองชิ้น สไตล์ลำลอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S63549fd9df7945af8b1adec9c6468d77t.jpg_200x200q90.jpg",
        "price": 4121.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16098083016.html",
        "sold": 0
    },
    {
        "product_name": "UMBRO เสื้อแข่งผู้ชายทีมเวสต์แฮมยูไนเต็ด ชุดเหย้า ฤดูกาล 2025/26",
        "product_image": "https://img.lazcdn.com/g/p/5334725bee823b9e2999af16afd7ec18.jpg_200x200q90.jpg",
        "price": 4060,
        "remark": "https://www.lazada.co.th/products/pdp-i5874676156.html",
        "sold": 3
    },
    {
        "product_name": "HLHYX ชุดออกกำลังกายสำหรับผู้ชาย แห้งเร็ว กระชับรูปร่าง เหมาะสำหรับฝึกซ้อมบาสเก็ตบอล แขนสั้น ยืดหยุ่นสูง ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf13fc8445c084fc2b876bac05e6f03daY.jpg_200x200q90.jpg",
        "price": 4051.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16106522615.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเสื้อฮู้ดแขนยาวปักลายแฟชั่นลำลองผ้าฝ้ายสำหรับผู้ชายฤดูใบไม้ร่วงใหม่ สวมใส่สบาย ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5c391a01fd4248ccb03d3ceb8032b8fao.jpg_200x200q90.jpg",
        "price": 4022.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16082833695.html",
        "sold": 0
    },
    {
        "product_name": "ชุดปกติขาว (ชาย) (เสื้อและกางเกง/เสื้ออย่างเดียว) by BANG BANG",
        "product_image": "https://img.lazcdn.com/g/p/9e1e32256db4d9b7be352758d5b0601f.jpg_200x200q90.jpg",
        "price": 4000,
        "remark": "https://www.lazada.co.th/products/pdp-i4883492762.html",
        "sold": 0
    },
    {
        "product_name": "WARRIX เสื้อแข่งฟุตบอลทีมชาติไทย 2025/26 (Player Grade) WA-253FBATH51",
        "product_image": "https://img.lazcdn.com/g/p/c2044d7a17f5c492fdc7c59223eb7552.png_200x200q90.png",
        "price": 3984,
        "remark": "https://www.lazada.co.th/products/pdp-i5851621752.html",
        "sold": 32
    },
    {
        "product_name": "Versatile Aero Jersey : OFF White เสื้อปั่นจักรยาน แอโร่ว กระชับ Hi Speed . ใส่ได้ทั้ง ช/ญ UV tec. 3D Waffle Fabric",
        "product_image": "https://img.lazcdn.com/g/p/e42df892aa8762c7306f71ddd79dba21.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i16072812204.html",
        "sold": 0
    },
    {
        "product_name": "XOLO LAYER POP POLO รหัส : 040147",
        "product_image": "https://img.lazcdn.com/g/p/fee153a7dfd991b5bd1708a3a4124d38.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i16115429127.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อบอล PORT FC 2025/26 Home Player Jersey ชุดเหย้า เกรดนักเตะ การท่าเรือ เอฟซี Official",
        "product_image": "https://img.lazcdn.com/g/p/ea66f11ba3e904eb8ca73173b9500958.jpg_200x200q90.jpg",
        "price": 3934,
        "remark": "https://www.lazada.co.th/products/pdp-i16123620585.html",
        "sold": 0
    },
    {
        "product_name": "INBIKE ชุดเสื้อเจอร์ซีย์นักปั่นผู้ชาย,ชุดชุดกีฬาจักรยานรัดรูปชายซิปเต็มแขนชุดปั่นจักรยานขาสั้นซิปกางเกง Bib แบบมีรูระบายอากาศฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/708a17ef122903a10e72cd7548a3e01b.jpg_200x200q90.jpg",
        "price": 3914,
        "remark": "https://www.lazada.co.th/products/pdp-i4966154935.html",
        "sold": 92
    },
    {
        "product_name": "ชุดเสื้อสเวตเชิ้ตผู้ชายทรงสลิมแฟชั่นลำลองแบบสองชิ้น ชุดกีฬา ฤดูใบไม้ร่วง สินค้าใหม่ แบรนด์เสื้อผ้าจากจีนแผ่นดินใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S947a2a5ef3174edb9a8bdc5bfce99556S.jpg_200x200q90.jpg",
        "price": 3879.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16083393111.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อทีม Liverpool 1989-1991 (Home) Retro เสื้อแท้ 💯 (มือ 2)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8c36be24fc2042189130ac7ef8b37c17A.jpg_200x200q90.jpg",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i16081410842.html",
        "sold": 0
    },
    {
        "product_name": "moodytiger | เสื้อยืดแขนยาวป้องกันแดดสีบล็อกสำหรับเด็กชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sec556437e20b4eabb1bc42c7e2bd34a4d.png_200x200q90.png",
        "price": 3754.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16106903520.html",
        "sold": 6
    },
    {
        "product_name": "ROCKBROS เสื้อปั่นจักรยานผู้ชาย,เสื้อเจอร์ซีย์นักปั่นแขนยาวแห้งเร็วระบายอากาศเสื้อเจอร์ซีย์นักปั่นเสื้อปั่นจักรยานมืออาชีพไร้รอยต่อไม่ระคายเคืองผิวติดเพชร",
        "product_image": "https://img.lazcdn.com/g/p/af5b45d52979b06e568853a5b5b53cc9.jpg_200x200q90.jpg",
        "price": 3750,
        "remark": "https://www.lazada.co.th/products/pdp-i5876410854.html",
        "sold": 7
    },
    {
        "product_name": "moodytiger | เสื้อยืดสำหรับเด็กชายแห้งเร็วซึมซับเหงื่อ ไม่มีเหงื่อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sccc35d09f5354f3c93124ba2cda58f60U.png_200x200q90.png",
        "price": 3725.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5910827137.html",
        "sold": 2
    },
    {
        "product_name": "เสื้อยืดอันเดอร์อาร์เมอร์ผู้ชายชุดกีฬาฟิตเนสการฝึกอบรมยกน้ำหนักออกกำลังกายเสื้อรัดกล้ามเนื้อแขนยาวเสื้อพูลโอเวอร์ 1387696-001",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3b67db99b26542d5a0f1ebcdda0cb530a.jpg_200x200q90.jpg",
        "price": 3611.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16104520996.html",
        "sold": 0
    },
    {
        "product_name": "ฤดูใบไม้ร่วงฤดูหนาว 2025 ใหม่เกาหลีรุ่นแฟชั่นชายหนุ่ม Slim Casual Corduroy ชุดผ้าฝ้าย Corduroy เสื้อสูท M-4XL",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1f2da1892221461a9f7ec9037fe335e0M.jpg_200x200q90.jpg",
        "price": 3602.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16097731981.html",
        "sold": 0
    },
    {
        "product_name": "ของแท้อย่างเป็นทางการ Manchester City F.C. เสื้อฟุตบอล 25/26",
        "product_image": "https://img.lazcdn.com/g/p/fafde403d27a9602e57cfa8508b9ab58.jpg_200x200q90.jpg",
        "price": 3593.66,
        "remark": "https://www.lazada.co.th/products/pdp-i5916643596.html",
        "sold": 42
    },
    {
        "product_name": "BROOO เสื้อวิ่ง RUNNING SHIRT \"OUT OF PLAY \" เสื้อวิ่ง unisex",
        "product_image": "https://img.lazcdn.com/g/p/69a48eed96a98c5fe6bb6efc646e18aa.jpg_200x200q90.jpg",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i5864984095.html",
        "sold": 1
    },
    {
        "product_name": "เสื้อทีม Liverpool 1982-1985 (Home) Retro เสื้อแท้ 💯 (มือ 2)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sed31bb7b994b4d3d94c3581ce3a16d70F.jpg_200x200q90.jpg",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i16081412881.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อทีม Arsenal 2012-2014 (Home) เสื้อแท้ 💯(มือ 2)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2c5f808b0f3541cd99649c0b86c7df03K.jpg_200x200q90.jpg",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i16081369901.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อทีม Manchester City 2015/2016 (Home) เสื้อแท้ 💯 (มือ 2)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S99a96957344e42d1978fa02786507862z.jpg_200x200q90.jpg",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i16081408711.html",
        "sold": 0
    },
    {
        "product_name": "BROOO OUT OF PLAY ROAD RUNNING SHIRT BLUE",
        "product_image": "https://img.lazcdn.com/g/p/8d2988ed4e6363af6f79d0f813f2fcf3.jpg_200x200q90.jpg",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i5865288220.html",
        "sold": 2
    },
    {
        "product_name": "เสื้อทีม Leeds United 1991/1992 (Home) Retro เสื้อแท้ 💯(มือ 2)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S97fdb0ccd2e1485dbe3c5990e2668aae6.jpg_200x200q90.jpg",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i16081455146.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืด Men's H-D Night Rider Tee 96026-25VM",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S435faa18f8e442aab1dba4a316c4534bX.jpg_200x200q90.jpg",
        "price": 3500,
        "remark": "https://www.lazada.co.th/products/pdp-i5730998021.html",
        "sold": 0
    },
    {
        "product_name": "Venum | เสื้อกล้ามออกกำลังกายสำหรับผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9c7a402eaccb471984140bcd1ad13dfbl.jpg_200x200q90.jpg",
        "price": 3482.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5914257955.html",
        "sold": 5
    },
    {
        "product_name": "BROOO OUT OF PLAY ROAD RUNNING SHIRT LIGHT BLUE",
        "product_image": "https://img.lazcdn.com/g/p/9d027e9e08716e9ecaf5ea1b7d405b7e.jpg_200x200q90.jpg",
        "price": 3457.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5865086588.html",
        "sold": 4
    },
    {
        "product_name": "Deadpool Cosplay ชุดยูนิฟอร์มสวมใส่รัดรูป ชุดฮาราจูกุสำหรับผู้ชาย ชุดคอสเพลย์ Marvel Deadpool 3 ชุดเสื้อคลุมหนังสำหรับผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sce4ba923052c44babd9bcac3d21bc9b1M.jpg_200x200q90.jpg",
        "price": 3422,
        "remark": "https://www.lazada.co.th/products/pdp-i5399101000.html",
        "sold": 3
    },
    {
        "product_name": "ร้านปลอดภาษีของแท้ Manchester City F.C. Home and Away Football Jerseys 25/26",
        "product_image": "https://img.lazcdn.com/g/p/41641941d02acf4ef69bf0844c86ad61.jpg_200x200q90.jpg",
        "price": 3243.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5928399827.html",
        "sold": 34
    },
    {
        "product_name": "G-FORM เสื้อรัดกล้ามเนื้อกันกระแทกสำหรับบาสเกตบอล และกีฬาประเภทอื่นๆ ผู้รักษาประตู PRO TANKS FOR BASKETBALL & OTHER SPORTS GOALKEEPER",
        "product_image": "https://img.lazcdn.com/g/p/d1e53ee8f007f07f3a97254e666d0c0e.png_200x200q90.png",
        "price": 3388,
        "remark": "https://www.lazada.co.th/products/pdp-i3385835513.html",
        "sold": 0
    },
    {
        "product_name": "BROOO OUT OF PLAY ROAD RUNNING SHIRT BROWN",
        "product_image": "https://img.lazcdn.com/g/p/4c5b6475225dec2cb61749e62b3872cd.jpg_200x200q90.jpg",
        "price": 3385.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5864931998.html",
        "sold": 3
    },
    {
        "product_name": "YKYWBIKE เสื้อเจอร์ซีย์นักปั่นผู้ชาย2025เสื้อจักรยานแขนเสื้อสั้นไม่มีปกจักรยานเสือหมอบโปร MTB เสื้อเจอร์ซีย์ฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/5487a76c92641dbf1c0101ce8b2ac2c1.jpg_200x200q90.jpg",
        "price": 3384,
        "remark": "https://www.lazada.co.th/products/pdp-i5843241526.html",
        "sold": 3
    },
    {
        "product_name": "(ของขวัญธงชาติอเมริกัน) เสื้อกล้ามฝึกซ้อมกลางแจ้ง MOLLE อเนกประสงค์ กันน้ํา ทนต่อการสึกหรอ เสื้อกล้ามแบบปลดเร็ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se3717567ff8b4586a7df0b3cd51a33e7m.jpg_200x200q90.jpg",
        "price": 3381.24,
        "remark": "https://www.lazada.co.th/products/pdp-i5815484813.html",
        "sold": 0
    },
    {
        "product_name": "🤍💚พร้อมส่ง💚🤍ชุดเซตคุณหนูชายแบรน💚Endless♾️holiday💚ชุดน่ารัก เรียบหรู📸ถ่ายรูปสวย เข้าเซตพ่อแม่ลูก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S350ab6168ce14988b4cfb2f54213b3a9A.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i5179840457.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อทีม Chelsea 2015/2016 (Away) เสื้อแท้ 💯(มือ 2)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S90d4b4fc843c461bbf2dc93687020a39n.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i16081407679.html",
        "sold": 0
    },
    {
        "product_name": "XOLO CUBE GRAPHIC POLO รหัส : 040141",
        "product_image": "https://img.lazcdn.com/g/p/88eba401f74fe068ac3760fac68449ce.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i16111982160.html",
        "sold": 1
    },
    {
        "product_name": "GIORDANO ผู้ชาย  เสื้อคาร์ดิแกน ผ้าฝ้าย 100% ถัก 12 เกจ คอวี สีพื้น เรียบง่าย แฟชั่นลำลอง คาร์ดิแกน 13054668",
        "product_image": "https://img.lazcdn.com/g/p/fb349e6e12c914e275a17f12d82d6a1f.jpg_200x200q90.jpg",
        "price": 3378,
        "remark": "https://www.lazada.co.th/products/pdp-i5281599131.html",
        "sold": 76
    },
    {
        "product_name": "Under Armour เสื้อกล้ามสำหรับผู้ชาย UA Vanish Elite Seamless59",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S74850adaf5364bb79fb9c2b5e4b2a52e2.png_200x200q90.png",
        "price": 3346,
        "remark": "https://www.lazada.co.th/products/pdp-i16116973019.html",
        "sold": 0
    },
    {
        "product_name": "YKYWBIKE ชุดเสื้อเจอร์ซีย์นักปั่นสีสันสดใสของผู้ชายชุดเล่นกีฬาขี่จักรยานแบบระบายอากาศได้สำหรับจักรยานเสือหมอบฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/205e700a4db875df94c6b99a7aad7ca9.jpg_200x200q90.jpg",
        "price": 3318.3,
        "remark": "https://www.lazada.co.th/products/pdp-i5328722012.html",
        "sold": 1
    },
    {
        "product_name": "Yoomee เสื้อกีฬาสำหรับผู้ชายผู้ชายผู้หญิงชุดดำน้ำชุดยาง3มม. สำหรับโต้คลื่นดำน้ำพายเรือแคนูชุดดำน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S97378cd9fc344493a0894ad86b9917356.jpg_200x200q90.jpg",
        "price": 3306,
        "remark": "https://www.lazada.co.th/products/pdp-i5961420953.html",
        "sold": 0
    },
    {
        "product_name": "Manchester City F.C. Home and Away Football Jerseys 25/26",
        "product_image": "https://img.lazcdn.com/g/p/fc4ee9810a09696d33faa08a34d9ca72.jpg_200x200q90.jpg",
        "price": 3289.66,
        "remark": "https://www.lazada.co.th/products/pdp-i5944649309.html",
        "sold": 27
    },
    {
        "product_name": "ชุดสูทสองชิ้นของผู้ชายอินเทรนด์แฟชั่นสีทึบสลิมฟิตธุรกิจชุดสูทสไตล์ลําลองชุดสูทปุ่มเดียว [เสื้อ + กางเกง]",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5e5b4f5a6b664eaea8a549641f71cfd0S.jpg_200x200q90.jpg",
        "price": 3223.06,
        "remark": "https://www.lazada.co.th/products/pdp-i5847490908.html",
        "sold": 0
    },
    {
        "product_name": "(โปรโมชั่นสิ้นปี)25-26 Manchester City home and away short sleeved jerseys, men's and women's fan versions, football jerseys, sports jerseys",
        "product_image": "https://img.lazcdn.com/g/p/86af1935f396e1e81913cda10c65639d.jpg_200x200q90.jpg",
        "price": 3185.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5978345030.html",
        "sold": 26
    },
    {
        "product_name": "V2 Light Pro jersey 2 สี Super White / Metalic Grey ใส่ได้ทั้งชาย,หญิง เสื้อจักรยาน เสื้อปั่นจักรยาน กับผ้าเบาสุด นุ่ม เย็น  แห้งไว สวมใส่สบาย ใส่ได้ทั้ง ชาย,หญิง",
        "product_image": "https://img.lazcdn.com/g/p/cc7f7aeeb48c3653d4478b8bdaaaac12.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5967967625.html",
        "sold": 1
    },
    {
        "product_name": "(โปรโมชั่นส่วนลด)25-26 Manchester City home and away short sleeved football jersey sportswear men's and women's fan edition shirt",
        "product_image": "https://img.lazcdn.com/g/p/e933aca794b4a507cb4d18129e3b2fa9.jpg_200x200q90.jpg",
        "price": 3175.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5978436140.html",
        "sold": 20
    },
    {
        "product_name": "MINI BALA | กางเกงยีนส์เด็กไม่ซีด สบาย และเป็นมิตรต่อสิ่งแวดล้อม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S59747975d6ff4d249287d0db17964aa6X.jpg_200x200q90.jpg",
        "price": 3160.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6011127003.html",
        "sold": 4
    },
    {
        "product_name": "Titanic Jack Dawson คอสเพลย์เครื่องแต่งกายแจ็คเสื้อกางเกง Overalls ชุดสุภาพบุรุษผู้ใหญ่ชายฮาโลวีน Carnival Disguise ชุด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1d4fdbc9134a4fa98e7664fcaf53978cj.jpg_200x200q90.jpg",
        "price": 3151.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16099680168.html",
        "sold": 0
    },
    {
        "product_name": "ชุด Cosplay Michael Jackson ชุดการแสดงสำหรับการแสดงและงานเลี้ยง สไตล์การ์ตูนญี่ปุ่นและเกาหลีใต้ ชุดคอสเพลย์สำหรับผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa7ea01c70fb148feb9a6a985955cd350g.jpg_200x200q90.jpg",
        "price": 3136.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5851849822.html",
        "sold": 0
    },
    {
        "product_name": "2026 New national team Argentina, Germany, Mexico football training uniform for men, sleeveless vest set, breathable",
        "product_image": "https://img.lazcdn.com/g/p/e6fffd576be57a2c5c53cb78a97e4488.jpg_200x200q90.jpg",
        "price": 3124.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16117112272.html",
        "sold": 0
    },
    {
        "product_name": "YKYWBIKE ชุดเสื้อยืดขี่จักรยานมืออาชีพสำหรับผู้ชาย,SPF50คอวี + กางเกงขาสั้นเสื้อกีฬารัดรูปสำหรับผู้ชายและกันแดดระบายอากาศ",
        "product_image": "https://img.lazcdn.com/g/p/a440a160e58059e06d892b146f7ef905.jpg_200x200q90.jpg",
        "price": 3106,
        "remark": "https://www.lazada.co.th/products/pdp-i5689942686.html",
        "sold": 2
    },
    {
        "product_name": "Manchester United 2016-17 Home Shirt - แท้ มือ2",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9b059e182b70428ea25924673fe11408m.jpg_200x200q90.jpg",
        "price": 3100,
        "remark": "https://www.lazada.co.th/products/pdp-i6020465686.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อยืดผู้ชายอันเดอร์อาร์เมอร์ชุดกีฬาฟิตเนสเทรนนิ่งเรียบง่ายนุ่มสบายระบายอากาศได้ดีแขนสั้น 1387285-001",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S26d418d4411c4062892f38f706edaed61.jpg_200x200q90.jpg",
        "price": 3062.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16106427039.html",
        "sold": 0
    },
    {
        "product_name": "LIGHTWILL ไฟโซล่าเซลล์ ไฟถนน ไฟสนาม 1800W / 2700W พร้อมแผงโซล่าเซลล์ ขนาดใหญ่ 155-180 ซม. แสงสีขาว (DayLight) วัตต์เต็ม Solar Cell LED Ultra Street Light ไฟ ไฟโซล่า โคมไฟโซล่าเซล โคมไฟถนนโซล่าเซลล์ สว่างทั้งคืน พร้อมอุปกรณ์ติดตั้งครบชุด",
        "product_image": "https://img.lazcdn.com/g/p/28faf13ebc53fd71dc66b234b176c36c.jpg_200x200q90.jpg",
        "price": 39800,
        "remark": "https://www.lazada.co.th/products/pdp-i5034823058.html",
        "sold": 0
    },
    {
        "product_name": "SL LIGHTING | LED Street Light โคมไฟสนาม สไตล์โมเดิร์น LED 100W สูง 3 เมตร รับประกัน 3 ปี รุ่น MIRA-100W-MW-3M",
        "product_image": "https://img.lazcdn.com/g/p/db613b7fc52637224ece51ad51dd47f9.png_200x200q90.png",
        "price": 36000,
        "remark": "https://www.lazada.co.th/products/pdp-i5392809241.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟถนนโซล่าเซลล์ ST2-60 (แสง : ขาว) ไฟถนน โซล่าเซลล์ ไฟโซล่าเซลล์ ไฟส่องทาง โคมไฟ",
        "product_image": "https://img.lazcdn.com/g/p/47dcc410f592561a3c9a2914204054a7.jpg_200x200q90.jpg",
        "price": 29980,
        "remark": "https://www.lazada.co.th/products/pdp-i4724355857.html",
        "sold": 0
    },
    {
        "product_name": "Randy LED Solar StreetLight PROMAX โคมไฟถนน AllIn1 ประกัน2ปี ไฟ แอลอีดี โซล่าเซลล์ กันน้ำ สว่าง ไฟถนนโซล่าเซลล์ ขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/d84bca1829a84a5f748145aa7812ad32.jpg_200x200q90.jpg",
        "price": 17980,
        "remark": "https://www.lazada.co.th/products/pdp-i4800263063.html",
        "sold": 3
    },
    {
        "product_name": "ไฟติดผนังโซล่าเซลล์ Premium 120W รุ่น LSXML-195 สำหรับติด ส่องป้ายโฆษณา ไฟติดผนัง โซล่าเซลล์ ไฟโซล่าเซลล์ ติดผนัง ส่องป้าย",
        "product_image": "https://img.lazcdn.com/g/p/13a911a4fe6f1ff92ef8a46bcaf53081.jpg_200x200q90.jpg",
        "price": 15998,
        "remark": "https://www.lazada.co.th/products/pdp-i5273008035.html",
        "sold": 1
    },
    {
        "product_name": "🔥JD🔥Solar Light 10000W LED ไฟถนนโซล่าเซลล์ ไฟโซล่าเซลล์ ไฟถนนโซล่าเซล ไฟโซล่าเซล ไฟสปอตไลท์ โคมไฟถนนโซล่าเซลล์ ไฟถนน โคมไฟถนนโซล่าเซล โคมไฟติดผนัง โคมไฟโซล่าเซล โซล่าเซลไฟบ้าน โคมไฟสปอร์ตไลท์ ไฟโซล่าเซลถนน สุดๆ พลังสูง โคมไฟโซลาเซลล์ ไฟสวน ไฟถนน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S38de72d9f0cf4e9db30448273f35f1cfd.png_200x200q90.png",
        "price": 15404,
        "remark": "https://www.lazada.co.th/products/pdp-i5224662017.html",
        "sold": 0
    },
    {
        "product_name": "ไฟถนน Solar Light 10000W LED ไฟถนนโซล่าเซลล์ ไฟโซล่าเซลล์ ไฟถนนโซล่าเซล ไฟโซล่าเซล ไฟสปอตไลท์ โคมไฟถนนโซล่าเซลล์ ไฟถนน โคมไฟถนนโซล่าเซล โคมไฟติดผนัง โคมไฟโซล่าเซล โซล่าเซลไฟบ้าน โคมไฟสปอร์ตไลท์ ไฟโซล่าเซลถนน สุดๆ พลังสูง โคมไฟโซลาเซลล์ ไฟสวน ไฟถนน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S984337f88ac04965ab158580cbf11facW.png_200x200q90.png",
        "price": 14741.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5335880426.html",
        "sold": 0
    },
    {
        "product_name": "ไฟถนน NEW Solar Light 10000W LED ไฟถนนโซล่าเซลล์ ไฟโซล่าเซลล์ ไฟถนนโซล่าเซล ไฟโซล่าเซล ไฟสปอตไลท์ โคมไฟถนนโซล่าเซลล์ ไฟถนน โคมไฟถนนโซล่าเซล โคมไฟติดผนัง โคมไฟโซล่าเซล โซล่าเซลไฟบ้าน โคมไฟสปอร์ตไลท์ ไฟโซล่าเซลถนน สุดๆ พลังสูง โคมไฟโซลาเซลล์ ไฟสวน ไฟถนน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf74ef3ebce8e409f9f628bcb8ba98edcv.png_200x200q90.png",
        "price": 14472.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5336117315.html",
        "sold": 4
    },
    {
        "product_name": "GAOBIGEGE | ไฟส่องสว่างกันน้ำสำหรับกลางแจ้งทรงสี่เหลี่ยม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdee2651b654443e683ecb0fd1b0dcd3eX.jpg_200x200q90.jpg",
        "price": 13967.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5876787631.html",
        "sold": 18
    },
    {
        "product_name": "BEWON โคมถนนโซล่าเซลล์แผงในตัว 5,000W โซล่าเซลล์ 5000วัตต์ แสงขาว พร้อมขาจับ ออกบิลภาษีได้",
        "product_image": "https://img.lazcdn.com/g/p/48c4c5818dc5c0e45a002740c9f0256a.jpg_200x200q90.jpg",
        "price": 12449.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5699270936.html",
        "sold": 0
    },
    {
        "product_name": "Randy LED Solar street light โคมไฟถนน 4G CCTV ประกัน2ปี ไฟ แอลอีดี โซล่าเซลล์ กันน้ำ สว่าง ไฟถนนโซล่าเซลล์ ควบคุมผ่านAPP",
        "product_image": "https://img.lazcdn.com/g/p/d5f7aafacad7efc92fd1cb94bf3063d0.jpg_200x200q90.jpg",
        "price": 11980,
        "remark": "https://www.lazada.co.th/products/pdp-i5282793179.html",
        "sold": 0
    },
    {
        "product_name": "PAIMIJI | โคมไฟดวงจันทร์โซลาร์เซลล์กันน้ำสำหรับประดับนอกบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc4e7fbe6508b4027bbdfe76bf75cfc34o.jpg_200x200q90.jpg",
        "price": 11468.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5870281704.html",
        "sold": 2
    },
    {
        "product_name": "1,000W ไฟสนามกีฬา LED AC120-277V มุมกว้าง 130LM/W Super Bright IP65 กันน้ำไฟสนามกีฬากลางแจ้ง 240W/500W/1000W FOORDLIGHT/Sports Light",
        "product_image": "https://img.lazcdn.com/g/p/5596d4d2504817d3eaf03502f084da31.jpg_200x200q90.jpg",
        "price": 11000,
        "remark": "https://www.lazada.co.th/products/pdp-i5775916906.html",
        "sold": 1
    },
    {
        "product_name": "โปรโมชั่นพิเศษ ไฟโซล่าเซลล์ รุ่น UFO พร้อมฐานซีเมนต์ เเละ เสาสำเร็จรูป ทรงสวยงาม ติดตั้งง่าย ไม่ต้องง้อช่าง เสาสูง 4 เมตร * 2 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/9006b58949d29cc92f7be4635af11161.jpg_200x200q90.jpg",
        "price": 10720,
        "remark": "https://www.lazada.co.th/products/pdp-i6028467237.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟสนาม เสาสนาม ขั้วE27 โคมไฟ ตกแต่งสวน ไฟทางเดิน (ไม่รวมหลอด)",
        "product_image": "https://img.lazcdn.com/g/p/2bc70049442828c3433d74d902b5f580.jpg_200x200q90.jpg",
        "price": 9860,
        "remark": "https://www.lazada.co.th/products/pdp-i6048537982.html",
        "sold": 0
    },
    {
        "product_name": "SL LIGHTING | KANIN Outdoor Wall Lamp โคมไฟติดผนังภายนอก LED 15W 3000K (แสงวอร์ม) ขนาด50cm.",
        "product_image": "https://img.lazcdn.com/g/p/1475d9807f01301a2f0ab163f9ee2964.png_200x200q90.png",
        "price": 9800,
        "remark": "https://www.lazada.co.th/products/pdp-i5925911148.html",
        "sold": 0
    },
    {
        "product_name": "\"1 แถม 1\" สปอตไลท์ SOLAR SHINING GALAXY PRO 770 วัตต์ DAYLIGHT แสงขาว  IP66 สว่าง แบตทน Toshiba lighting",
        "product_image": "https://img.lazcdn.com/g/p/1be7c16a2382cdc5575444c6aae55b92.jpg_200x200q90.jpg",
        "price": 9400.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6008616555.html",
        "sold": 1
    },
    {
        "product_name": "โคมไฟสนาม โคมโบลาส โคมสนามภายนอก E27",
        "product_image": "https://img.lazcdn.com/g/p/6ef1c2475ae7b0e7798dd50766d3651b.jpg_200x200q90.jpg",
        "price": 6180,
        "remark": "https://www.lazada.co.th/products/pdp-i5740743035.html",
        "sold": 2
    },
    {
        "product_name": "โคมไฟถนนโซล่าเซลล์ 1000W รุ่น MD-SLT30-1000W (แสง : ขาว) โคมไฟถนน โซล่าเซลล์ โคมไฟโซล่าเซลล์ ไฟถนนโซล่าเซลล์ ไฟถนน",
        "product_image": "https://img.lazcdn.com/g/p/34b7ab38d3ba014a7ae321db94465965.jpg_200x200q90.jpg",
        "price": 9033.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5165749455.html",
        "sold": 7
    },
    {
        "product_name": "ไฟถนนโซลาร์เซลล์ LED กำลังสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3f6506138a954e778ac7f087aaea40ecx.png_200x200q90.png",
        "price": 8683.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16084583993.html",
        "sold": 1
    },
    {
        "product_name": "SL LIGHTING | Bollard LED โคมไฟสนาม โคมไฟทางเดิน ให้แสงสว่างตามทางเดิน รุ่น SL-11-3121 | 013104 | 3104",
        "product_image": "https://img.lazcdn.com/g/p/c049057cee3bad405f7dd70b8f729c00.jpg_200x200q90.jpg",
        "price": 8640,
        "remark": "https://www.lazada.co.th/products/pdp-i2757819328.html",
        "sold": 10
    },
    {
        "product_name": "JUYU | ไฟดวงจันทร์ชาร์จพลังงานแสงอาทิตย์กันน้ำ 24V",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0111d127dc2549d7ba0087f3bc0ffef1Y.jpg_200x200q90.jpg",
        "price": 8623.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5878597424.html",
        "sold": 27
    },
    {
        "product_name": "Randy ไฟโซล่าเซลล์ UFO โคมไฟ อลูมิเนียมอัลลอยด์ ไฟถนน ประกัน2ปี Solar cell พลังงานแสงอาทิตย์ ไฟสวน Solar Light (เฉพาะเครื่อง)",
        "product_image": "https://img.lazcdn.com/g/p/15c1874ebf0fd99285e7cecd69d6475d.png_200x200q90.png",
        "price": 8600,
        "remark": "https://www.lazada.co.th/products/pdp-i4122355447.html",
        "sold": 48
    },
    {
        "product_name": "MODI Solar street light MD-SLT18-300 W โโคมไฟถนนโซล่าเซลล์ MODI-Solar 300 W Series",
        "product_image": "https://img.lazcdn.com/g/p/b4f3655ed59c0ae156d36d7bafe6c0db.jpg_200x200q90.jpg",
        "price": 8570,
        "remark": "https://www.lazada.co.th/products/pdp-i1805346804.html",
        "sold": 33
    },
    {
        "product_name": "ไฟเสาทางเข้าสวนวิลล่า ใช้พลังงานแสงอาทิตย์ กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8532c580bd6c4663a8e1994433a8765fn.jpg_200x200q90.jpg",
        "price": 8546.78,
        "remark": "https://www.lazada.co.th/products/pdp-i6003325063.html",
        "sold": 0
    },
    {
        "product_name": "MODI ไฟโซล่าเซลล์ ไฟภายนอกอาคาร พลังแสงอาทิตย์ โคมไฟถนนโซล่าเซลล์ ไฟติดผนังโซล่า 800W1000W แสงขาว สว่างค้าง เปิดปิดอัตโนมัติ Solar street light",
        "product_image": "https://img.lazcdn.com/g/p/fd3ebcbb446ba4d22eb8f801cd4da904.jpg_200x200q90.jpg",
        "price": 8077.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5153883927.html",
        "sold": 10
    },
    {
        "product_name": "RANDY UFO Ultimate ไฟโซลาร์เซลล์ 1200W รุ่น DW-EW 1200W",
        "product_image": "https://img.lazcdn.com/g/p/a49c0de68e7d4b33556f733defbb0830.jpg_200x200q90.jpg",
        "price": 7980,
        "remark": "https://www.lazada.co.th/products/pdp-i5768624036.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟถนนโซล่าเซลล์ 800W รุ่น MD-SLT30-800W (แสง : ขาว) โคมไฟถนน โซล่าเซลล์ โคมไฟโซล่าเซลล์ ไฟถนนโซล่าเซลล์ ไฟถนน",
        "product_image": "https://img.lazcdn.com/g/p/2dc8feca5fe08e27934f3e7126671ef9.jpg_200x200q90.jpg",
        "price": 7642.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5165520717.html",
        "sold": 0
    },
    {
        "product_name": "⚡ใหม่ล่าสุด!! RANDY รุ่น Sport X ไฟสปอร์ตไลท์โซล่าเซลล์ สว่าง คุ้มค่า มาตรฐานสากล ไม่ต้องเดินสายไฟ รับประกันนาน 2 ปี",
        "product_image": "https://img.lazcdn.com/g/p/29aaf3534421c4f5d83093bd52b1d19f.jpg_200x200q90.jpg",
        "price": 7580,
        "remark": "https://www.lazada.co.th/products/pdp-i5741718370.html",
        "sold": 92
    },
    {
        "product_name": "\"1 แถม 1\" ไฟสนาม SOLAR SHINING GARDEN UFO-X 1000 วัตต์ เดย์ไลท์ ควบคุมด้วยรีโมต ใช้งานง่าย Toshiba lighting",
        "product_image": "https://img.lazcdn.com/g/p/3e129a5fa4a6d6f8011ab4cc953860f2.jpg_200x200q90.jpg",
        "price": 7497.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6061583545.html",
        "sold": 0
    },
    {
        "product_name": "MODI โคมไฟถนนโซล่าเซลล์ 800W1000W แสงขาว ระบบสว่างค้าง เปิดปิดอัตโนมัติ Solar street light",
        "product_image": "https://img.lazcdn.com/g/p/4b7d1716c6adbe23f9ad1140b0613646.jpg_200x200q90.jpg",
        "price": 7342.72,
        "remark": "https://www.lazada.co.th/products/pdp-i5148742823.html",
        "sold": 11
    },
    {
        "product_name": "โคมไฟถนนโซล่าเซลล์ 600W รุ่น MD-SLT30-600W (แสง : ขาว) ไฟถนน โซล่าเซลล์ ไฟโซล่าเซลล์ ไฟส่องทาง โคมไฟ",
        "product_image": "https://img.lazcdn.com/g/p/e49556b7ba74c1d4384f5d899be0333a.jpg_200x200q90.jpg",
        "price": 7333.38,
        "remark": "https://www.lazada.co.th/products/pdp-i4864335774.html",
        "sold": 14
    },
    {
        "product_name": "ไฟสนามกีฬา LED กันน้ำ IP66 AC100-277V ไฟโรงงาน 100W/200W/300W/400W/600W/800W สปอตไลท์เหมาะสำหรับสนามกีฬา/โรงละคร/อุโมงค์/สะพานจราจร",
        "product_image": "https://img.lazcdn.com/g/p/aab7c555b5ac8d3a13a02b3e32526572.jpg_200x200q90.jpg",
        "price": 7195.3,
        "remark": "https://www.lazada.co.th/products/pdp-i4829067598.html",
        "sold": 15
    },
    {
        "product_name": "JUYU | ไฟสปอร์ตไลท์ LED กันน้ำ สำหรับเพิ่มความสว่างบนผนัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S531521dce6c244abb82b77deb777af45E.jpg_200x200q90.jpg",
        "price": 7132.66,
        "remark": "https://www.lazada.co.th/products/pdp-i6046774390.html",
        "sold": 0
    },
    {
        "product_name": "EVE โคมฟลัดไลท์ โซล่าเซลล์ แอลอีดี พลังงานแสงอาทิตย์ รุ่น DAWN โคมกันน้ำ IP65 ขนาด 10W 40W 60W 100W 200W 300W",
        "product_image": "https://img.lazcdn.com/g/p/561961abfac5766d5f28c5c3b2c04ff3.jpg_200x200q90.jpg",
        "price": 6980,
        "remark": "https://www.lazada.co.th/products/pdp-i4477393177.html",
        "sold": 42
    },
    {
        "product_name": "\"1แถม1\" สปอร์ตไลท์โซล่าเซลล์ SOLAR SHINING GALAXY 220 วัตต์ สาย 5 เมตร สว่างถึงเช้า หลอดไฟโตชิบา Toshiba lighting",
        "product_image": "https://img.lazcdn.com/g/p/0f3da723cb7eb4e9e13528ca60b2600a.jpg_200x200q90.jpg",
        "price": 6916,
        "remark": "https://www.lazada.co.th/products/pdp-i5347698777.html",
        "sold": 4
    },
    {
        "product_name": "\"1 แถม 1\"สปอตไลท์ SOLAR SHINING GALAXY PRO 570 วัตต์ DAYLIGHT แสงขาว  IP66 สว่าง แบตทน Toshiba lighting",
        "product_image": "https://img.lazcdn.com/g/p/a075f5042a0465975a8fe4ca473b86a4.jpg_200x200q90.jpg",
        "price": 6854.28,
        "remark": "https://www.lazada.co.th/products/pdp-i6008577693.html",
        "sold": 2
    },
    {
        "product_name": "ไฟสนามสไตล์ยุโรป กันน้ำ สว่างมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sef8e40820f16408f90b403e2b93726af7.jpg_200x200q90.jpg",
        "price": 6755.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6001601340.html",
        "sold": 0
    },
    {
        "product_name": "\"ใหม่\" 1แถม1 ไฟถนนโซล่าเซลล์ SOLAR SHINING URANUS 350 วัตต์ DAYLIGHT พร้อมเสายึด ทนทาน IP65 กันน้ำ สว่างถึงเช้า หลอดไฟโตชิบา Toshiba lighting",
        "product_image": "https://img.lazcdn.com/g/p/588aaff51578bc52eb2538e016d56c65.jpg_200x200q90.jpg",
        "price": 6667.46,
        "remark": "https://www.lazada.co.th/products/pdp-i5851830412.html",
        "sold": 2
    },
    {
        "product_name": "SL LIGHTING | โคมไฟสนาม เสาไฟทางเดิน 80CM 100CM รุ่น SL-11-7194D/BK-80CM | SL-11-7194D/BK-100CM",
        "product_image": "https://img.lazcdn.com/g/p/2e1e1ec11649719fb134642fec3f5f47.png_200x200q90.png",
        "price": 6660,
        "remark": "https://www.lazada.co.th/products/pdp-i4573143984.html",
        "sold": 0
    },
    {
        "product_name": "JD สินค้าแนะนำ ไฟถนนโซล่าเซลล์ JD-XJL73000 3000W ไฟพลังงานแสงอาทิตย์ โคมไฟโซล่าเซลล์ โคมไฟถนนโซล่าเซลล์ รับประกัน3ปี IP67กันน้ำ พลังงานแสงอาทิตย์ ระบบไฟเปิด-ปิดอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sce3fd7ff535e4e798d78777b295c8544J.png_200x200q90.png",
        "price": 6600,
        "remark": "https://www.lazada.co.th/products/pdp-i1171046475.html",
        "sold": 342
    },
    {
        "product_name": "สินค้าแนะนำ JD โคมไฟถนนโซล่าเซลล์ XJL-73000 3000W ไฟพลังงานแสงอาทิตย์ 100% ไฟส่องสนาม ไฟถนนรุ่นใหม่ล่าสุด โซล่าเซลล์พลังงานแสงอาทิตย์ รับประกัน3ปี IP67กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S036895a5e40542db93d21a45ca9ba02f8.png_200x200q90.png",
        "price": 6600,
        "remark": "https://www.lazada.co.th/products/pdp-i5953199530.html",
        "sold": 0
    },
    {
        "product_name": "JD ไฟถนนโซล่าเซลล์ JD-XJL73000 30000W โคมไฟถนน โคมไฟถนนโซล่าเซลล์ ไฟพลังงานแสงอาทิตย์100% รับประกัน3ปี IP67กันน้ำ ไฟโซล่าเซลล์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S22afc05f40db4ebd800142722bac90327.png_200x200q90.png",
        "price": 6600,
        "remark": "https://www.lazada.co.th/products/pdp-i5953345236.html",
        "sold": 0
    },
    {
        "product_name": "สินค้าขายดี JD ไฟถนนรุ่นใหม่ JD-XJL73000 3000W ไฟถนนโซล่าเซลล์ ไฟพลังงานแสงอาทิตย์ รับประกัน3ปี IP67กันน้ำ JD SOLAR LIGHT โคมไฟโซล่าเซลล์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf22b1ae5382e4ab89031992db2094ab9y.png_200x200q90.png",
        "price": 6600,
        "remark": "https://www.lazada.co.th/products/pdp-i4154897213.html",
        "sold": 50
    },
    {
        "product_name": "JD ไฟถนนโซล่าเซลล์ JD-XJL73000 (3000W) ไฟโซล่าเซลล์ ไฟพลังงานแสงอาทิตย์100% โคมไฟถนนโซล่าเซลล์ รับประกัน3ปี IP67กันน้ำ ระบบเปิด-ปิดอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9c36022d5192421b9d1d690ccdbf57d1y.png_200x200q90.png",
        "price": 6600,
        "remark": "https://www.lazada.co.th/products/pdp-i5953247388.html",
        "sold": 2
    },
    {
        "product_name": "JD1000W รุ่นJD-81000L Jindian Solar Street Light ไฟสปอร์ตไลท์ 1000วัตต์ JD1000W แสงไฟสีขาว โซลาร์เซลล์ พลังงานแสงอาทิตย์ โคมไฟโซล่าเซลล์ รับประกันJDของแท้100%",
        "product_image": "https://img.lazcdn.com/g/p/86528747baee4706326aa5a660c0ab69.jpg_200x200q90.jpg",
        "price": 6600,
        "remark": "https://www.lazada.co.th/products/pdp-i2003350864.html",
        "sold": 24
    },
    {
        "product_name": "โคมไฟสนาม2.3เมตรพร้อมโป๊ะ10นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S65c9cf32f6514f6dab3c766d5c682623N.jpg_200x200q90.jpg",
        "price": 6600,
        "remark": "https://www.lazada.co.th/products/pdp-i4625301533.html",
        "sold": 1
    },
    {
        "product_name": "JINNENG | ไฟส่องสว่างกันน้ำสำหรับเสาภายนอก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0ef645043ae0457bbd9f20f7fb8fb1435.png_200x200q90.png",
        "price": 6577.24,
        "remark": "https://www.lazada.co.th/products/pdp-i5872678972.html",
        "sold": 3
    },
    {
        "product_name": "JD ของแท้100% โคมไฟโซล่าเซลล์ 25W 40W 60W 100W 200W 300W 500W 1000W  สปอร์ตไลท์ ไฟโซล่าเซลล์ พลังงานแสงอาทิตย์ ราคาส่ง",
        "product_image": "https://img.lazcdn.com/g/p/f828ce849d21edd090057c79d59b010d.jpg_200x200q90.jpg",
        "price": 6558,
        "remark": "https://www.lazada.co.th/products/pdp-i2099242039.html",
        "sold": 70
    },
    {
        "product_name": "CHEXIA | ไฟ LED กลางแจ้งกันน้ำสำหรับสวนถนน 220V 24V",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5737be6eb9a8422987db65e71c9f72a2Q.jpg_200x200q90.jpg",
        "price": 6494.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16117931234.html",
        "sold": 0
    },
    {
        "product_name": "ZHAIGUANG | ไฟ LED ภูมิทัศน์พลังงานแสงอาทิตย์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdc08051ebbed447dbc3e57302519b661g.jpg_200x200q90.jpg",
        "price": 6340.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16051088178.html",
        "sold": 0
    },
    {
        "product_name": "สินค้าแนะนำ ไฟถนนJD ไฟถนนโซล่าเซลล์ ไฟโซล่าเซลล์ JD-XJL73000 3000W ไฟพลังงานแสงอาทิตย์ รับประกัน3ปี IP67 JD SOLAR LIGHR  LEDโซล่าเซลล์  โคมไฟโซล่าเซลล์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbfd09a0dfb5548e583c87d8767aaf40cF.png_200x200q90.png",
        "price": 6316.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5953219261.html",
        "sold": 0
    },
    {
        "product_name": "สินค้าขายดี JD โคมไฟถนนโซล่าเซลล์ XJL-73000 3000W ไฟพลังงานแสงอาทิตย์ 100% พลังงานแสงอาทิตย์ ไฟถนนรุ่นใหม่ล่าสุด โซล่าเซลล์พลังงานแสงอาทิตย์  รับประกัน3ปี IP67กันน้ำ JD SOLAR LIGHT แท้100%",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S805d4b5d1fa342228c3a8b3a842d1122v.png_200x200q90.png",
        "price": 6316.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5953221094.html",
        "sold": 20
    },
    {
        "product_name": "JD โซล่าเซลล์ XJL73000 3000W ไฟถนนพลังงานแสงอาทิตย์ ไฟโซล่าเซลล์ ไฟส่องถนน แสงขาว โคมไฟพลังงานแสงอาทิตย์ รับประกัน3ปี  IP67กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S501f56a9124b4e9e9449c2f47f7f8234l.png_200x200q90.png",
        "price": 6312.9,
        "remark": "https://www.lazada.co.th/products/pdp-i4138302807.html",
        "sold": 35
    },
    {
        "product_name": "HEIKESZ สแตนเลสเบาเสากลางแจ้งพลังงานแสงอาทิตย์แบบทันสมัยโคมไฟในสวนกันน้ำสำหรับตกแต่งลานวิลล่า",
        "product_image": "https://img.lazcdn.com/g/p/4b7fe2fd3065cdc22d3d1e7117ed7202.jpg_200x200q90.jpg",
        "price": 6276.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16098448472.html",
        "sold": 0
    },
    {
        "product_name": "JD ไฟถนนโซล่าเซลล์ JD-XJL73000 3000W ไฟพลังงานแสงอาทิตย์100% โคมไฟโซล่าเซลล์ รับประกัน3ปี IP67 ไฟโซล่าเซลล์100% JD SOLAR LIGHT",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se6916c16cf3d46fbac1455c3a14b71bcW.png_200x200q90.png",
        "price": 6250.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5032226014.html",
        "sold": 0
    },
    {
        "product_name": "JD โคมไฟถนนโซล่าเซลล์ JD-XJL73000 (30000W) ไฟถนนโซล่าเซลล์ ระบบเปิด-ปิดอัตโนมัติ ไฟพลังงานแสงอาทิตย์ รับประกัน3ปี IP67 ไฟส่องถนน แสงสีขาว ไฟโซล่าเซล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S880ae45b05c3497e88de9d7a2d3c58f8L.png_200x200q90.png",
        "price": 6250.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5953310243.html",
        "sold": 24
    },
    {
        "product_name": "MODI โคมไฟถนนโซล่าเซลล์ 400W แสงขาว 2492.6lm ไฟถนนพลังงานแสงอาทิตย์ เซนเซอร์ตรวจจับความเคลื่อนไหว Solar street light IP65",
        "product_image": "https://img.lazcdn.com/g/p/8e4099615185f193c9503158e2a9179c.jpg_200x200q90.jpg",
        "price": 6116.34,
        "remark": "https://www.lazada.co.th/products/pdp-i3856372532.html",
        "sold": 15
    },
    {
        "product_name": "SXH 50cm / 60cm / 80cm แสงจันทร์กลางแจ้งกันน้ำลานโคมไฟสนามหญ้าพลังงานแสงอาทิตย์แสงจันทร์บรรยากาศภูมิทัศน์ลูกโคมไฟขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/0b04523cc9b6a295388ee8e5b7b9fa76.jpg_200x200q90.jpg",
        "price": 6099.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5321741178.html",
        "sold": 3
    },
    {
        "product_name": "MODI โคมไฟถนนสวมเสาโซล่าเซลล์ 500W แสงขาว โคมไฟพลังงานแสงอาทิตย์ Solar street light กันน้ำIP65",
        "product_image": "https://img.lazcdn.com/g/p/df36bef0489c6e60cf695e04089c0bae.jpg_200x200q90.jpg",
        "price": 6066.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5608529723.html",
        "sold": 47
    },
    {
        "product_name": "RANDY ไฟสปอร์ตไลท์โซลาร์เซลล์ SPORT D 800W แสงขาว รุ่น DW-BW800",
        "product_image": "https://img.lazcdn.com/g/p/58c157689191729bbf4decbea1ed3d45.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i5768350974.html",
        "sold": 0
    },
    {
        "product_name": "Randy ไฟโซล่าเซลล์  โคมไฟถนน โซลาร์เซลล์อลูมิเนียม แอลอีดี สปอร์ตไลท์ กันน้ำ ไฟถนนโซล่าเซลล์ Solar cell",
        "product_image": "https://img.lazcdn.com/g/p/0aa81cd24aca822016070e44392fc783.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i3809529947.html",
        "sold": 76
    },
    {
        "product_name": "โคมไฟสนาม 2.2เมตรO3004/2F",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S56cb65295231400cb37d77a312bf2222P.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i4632906347.html",
        "sold": 0
    },
    {
        "product_name": "สปอตไลท์JD-81000L-W แสงขาว / เเสงวอร์มไวท์(1000W) Jindian Solar Street Lightพลังงานแสงอาทิตย์ JD81000L1000W ไฟสปอตไลท์ รุ่นใหม่ กันน้ำ IP67",
        "product_image": "https://img.lazcdn.com/g/p/f4892c247b53da24b23dfbf3cf66b2bc.jpg_200x200q90.jpg",
        "price": 5970,
        "remark": "https://www.lazada.co.th/products/pdp-i4173373807.html",
        "sold": 1
    },
    {
        "product_name": "FANKESEN | ไฟสนามกันน้ำสไตล์ยุโรป",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd426c48bece24d369b0267af43ab3231f.jpg_200x200q90.jpg",
        "price": 5836.52,
        "remark": "https://www.lazada.co.th/products/pdp-i6001630235.html",
        "sold": 0
    },
    {
        "product_name": "🔥Randy  ไฟถนนรุ่นที่ดีที่สุด ฝนตก แดดน้อยชาร์จ์ไฟได้ กันน้ำ แผงแยก ไฟถนนโซล่าเซลล์ รุ่นUltra พลังงานแสงอาทิตย์ Solarcell",
        "product_image": "https://img.lazcdn.com/g/p/6cd744a830dd268ce18049b7fe2668b0.jpg_200x200q90.jpg",
        "price": 5663.06,
        "remark": "https://www.lazada.co.th/products/pdp-i2421897187.html",
        "sold": 397
    },
    {
        "product_name": "โคมไฟถนนโซล่าเซลล์ UFO ทรงกลม รุ่น MD-SLT-39-500W Plus",
        "product_image": "https://img.lazcdn.com/g/p/140f910883cfaa02c7d1daecc9714072.jpg_200x200q90.jpg",
        "price": 5660,
        "remark": "https://www.lazada.co.th/products/pdp-i5921769282.html",
        "sold": 0
    },
    {
        "product_name": "สปอตไลท์โซล่าเซลล์JD-81000L (1000W) Jindian Solar Street Light แสงขาวและวอร์มไวท์ รับประกัน 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/67e1f6dfd5cc4034a96993e193baf5da.jpg_200x200q90.jpg",
        "price": 5598,
        "remark": "https://www.lazada.co.th/products/pdp-i2862822042.html",
        "sold": 64
    },
    {
        "product_name": "jdjindian ไฟสปอร์ตไลท์โซล่าเซลล์ รุ่น JD-81000L สว่างยันเช้า รุ่นใหญ่ รับประกันสินค้า 1ปีเต็ม",
        "product_image": "https://img.lazcdn.com/g/p/da5e7af64fd7ada580f3825bff29abde.jpg_200x200q90.jpg",
        "price": 5598,
        "remark": "https://www.lazada.co.th/products/pdp-i5819877391.html",
        "sold": 0
    },
    {
        "product_name": "[1 แถม 1] มีจำนวนจำกัด! Solar Floodlight โคมไฟสนามโซล่าเซลล์ รุ่น SOLARSHIPII-65K แสง DAY LIGHT",
        "product_image": "https://img.lazcdn.com/g/p/6d7feeee5d31819f2fb8f61283a14fa8.png_200x200q90.png",
        "price": 5580,
        "remark": "https://www.lazada.co.th/products/pdp-i6032351192.html",
        "sold": 0
    },
    {
        "product_name": "MODI โคมไฟถนนสวมเสาโซล่าเซลล์ ไฟถนน ไฟสวมเสา ไฟภายนอกอาคาร 500W แสงขาว ไฟพลังงานแสงอาทิตย์ Solar street light กันน้ำIP65 ไฟโซล่าเซลล์",
        "product_image": "https://img.lazcdn.com/g/p/f551260744456cb77e6d9b77e0a50db5.jpg_200x200q90.jpg",
        "price": 5548.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5608902663.html",
        "sold": 17
    },
    {
        "product_name": "สปอร์ตไลท์ โซล่าเซลล์ STARLIGHT 1,000W",
        "product_image": "https://img.lazcdn.com/g/p/7560be761a4ed6be346a0fd9400d49f6.png_200x200q90.png",
        "price": 5540,
        "remark": "https://www.lazada.co.th/products/pdp-i6043049805.html",
        "sold": 0
    },
    {
        "product_name": "HONGDILAI | โคมไฟส่องสว่างกลางแจ้งพลังงานแสงอาทิตย์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5525be1e693b49249e847772e68e3809U.jpg_200x200q90.jpg",
        "price": 5537.28,
        "remark": "https://www.lazada.co.th/products/pdp-i16053242224.html",
        "sold": 0
    },
    {
        "product_name": "KONIG 🔥 1 แถม 1🔥 ไฟโซล่าเซลล์ 2000w 3000w 4000w ไฟถนนพลังงานแสงอาทิตย์ โคมไฟโซล่าเซล โคมไฟถนน โคมไฟติดผนัง โคมไฟสปอร์ตไลท์ Solar Light ไฟสปอตไลท์ ควบคุมแสงอัจฉริยะ ไฟถนน LED ไฟสวนกลา",
        "product_image": "https://img.lazcdn.com/g/p/444cb81ce89bcea92409b9475191ff7c.jpg_200x200q90.jpg",
        "price": 5516,
        "remark": "https://www.lazada.co.th/products/pdp-i4744023901.html",
        "sold": 32
    },
    {
        "product_name": "โคมไฟถนนโซล่าเซลล์ 400W รุ่น MD-SLT30-400W (แสง : ขาว) โคมไฟ โซล่าเซลล์ ไฟถนนโซล่าเซลล์ ไฟโซล่าเซลล์ ไฟถนน",
        "product_image": "https://img.lazcdn.com/g/p/83cb030b5941f8de9a4ab552743a8581.jpg_200x200q90.jpg",
        "price": 5507.46,
        "remark": "https://www.lazada.co.th/products/pdp-i3865687631.html",
        "sold": 9
    },
    {
        "product_name": "【รับประกัน30ปี💥】 ไฟถนนโซล่าเซลล์ 20000000W ไฟโซล่าเซลล์ ไฟถนน UFO  IP67 ป้องกันฟ้าผ่า แสงสีขาว",
        "product_image": "https://img.lazcdn.com/g/p/4ab209485d2b0f7442d45ef7fd6c6539.png_200x200q90.png",
        "price": 5496,
        "remark": "https://www.lazada.co.th/products/pdp-i5397953354.html",
        "sold": 32
    },
    {
        "product_name": "Phillips โคมไฟโซล่าเซลล์ UFO 3แสงในโคมเดียว 200W 300W 400W 500W รุ่น BPC010 ไฟโซล่าเซลล์สนาม โคมไฟพลังงานแสงอาทิตย์ LED10 -LED50/MCT Solar posttop",
        "product_image": "https://img.lazcdn.com/g/p/0bace568f311c854a9583845e6a6fcd4.jpg_200x200q90.jpg",
        "price": 5436,
        "remark": "https://www.lazada.co.th/products/pdp-i4999428495.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟถนน ไฟโซล่าเซลล์ ENRICH streetlight solar รุ่น Maxnum+ ขนาด300W 400W แสงขาว มีรีโมท รับประกัน 1 ปี ไฟLed โซล่าเซลล์",
        "product_image": "https://img.lazcdn.com/g/p/df588ff140864b332acc81ac4456de1c.jpg_200x200q90.jpg",
        "price": 5424,
        "remark": "https://www.lazada.co.th/products/pdp-i4546617819.html",
        "sold": 1
    },
    {
        "product_name": "Randy LED STREET Solar Light รุ่น Ultra โคมไฟถนน โซล่าเซลล์ โคมไฟโซล่าเซลล์ พลังงานแสงอาทิตย์ Solar cell อัปเกรด New Ultra 2024 รุ่นใหม่",
        "product_image": "https://img.lazcdn.com/g/p/bc631671404f18397194b51758860832.png_200x200q90.png",
        "price": 5340,
        "remark": "https://www.lazada.co.th/products/pdp-i3373861986.html",
        "sold": 116
    },
    {
        "product_name": "สปอตไลท์JD-81000L-W แสงขาว 1000W Jindian Solar Street Lightพลังงานแสงอาทิตย์ รุ่นใหม่ JD88-L SERIES กันน้ำ IP67",
        "product_image": "https://img.lazcdn.com/g/p/67e1f6dfd5cc4034a96993e193baf5da.jpg_200x200q90.jpg",
        "price": 5339.94,
        "remark": "https://www.lazada.co.th/products/pdp-i2873479219.html",
        "sold": 121
    },
    {
        "product_name": "LeonLight โคมไฟสนาม โคมไฟจัดสวน โคมไฟทางเดิน 2.3-2.5 เมตร ขั้วE27",
        "product_image": "https://img.lazcdn.com/g/p/5ad5acd6f8993a4e1bd74d8eed85ff58.jpg_200x200q90.jpg",
        "price": 5300,
        "remark": "https://www.lazada.co.th/products/pdp-i5898793397.html",
        "sold": 4
    },
    {
        "product_name": "JD UFO  SOLAR LIGHT รุ่นใหม่ UFO-4500W ไฟถนน พลังงานแสงอาทิตย์  ไฟถนน โคมไฟสนาม โคมไฟโซล่าเซลล์ ไฟสวนพลังงานแสงอาทิตย์ แสงสีขาว ไฟแสงอาทิตย์ JD JINFENG",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9e62d9b962dd4f79af5216742fbb24bbd.png_200x200q90.png",
        "price": 5271.96,
        "remark": "https://www.lazada.co.th/products/pdp-i6051260925.html",
        "sold": 2
    },
    {
        "product_name": "JD ของแท้!!ไฟสปอตไลท์โซล่าเซลล์ JINDIAN L-SERIES รุ่น JD-8500L 500W กันน้ำ IP67 ใช้พลังงานแสงอาทิตย์ รับประกัน 1ปี",
        "product_image": "https://img.lazcdn.com/g/p/5b8d5f87d0cf12f02d7a5609413c6992.jpg_200x200q90.jpg",
        "price": 5198,
        "remark": "https://www.lazada.co.th/products/pdp-i2871437260.html",
        "sold": 2
    },
    {
        "product_name": "KKSKY ไฟโซล่าเซลล์ หลอดไฟ led 1000W IP68 กันน้ำ กันฟ้าผ่า โซล่าแสงสีขาว ไฟถนน เซ็นเซอร์ Solar Light โซล่าเซลล์ ไฟสปอร์ตไลท์ LED(New Metal Aluminum)",
        "product_image": "https://img.lazcdn.com/g/p/c51bb6c45ceba47dd8305b9eb40a92b9.jpg_200x200q90.jpg",
        "price": 5196,
        "remark": "https://www.lazada.co.th/products/pdp-i5881035405.html",
        "sold": 0
    },
    {
        "product_name": "KKSKY ไฟโซล่าเซล 1000W ไฟโซล่าเซลล์ LED solar light สีขาว ไฟสปอตไลท์ ไฟ solar cell กันน้ำ IP68(New Metal Aluminum)",
        "product_image": "https://img.lazcdn.com/g/p/cb748b584e2ad61030ae187da930a9ac.jpg_200x200q90.jpg",
        "price": 5196,
        "remark": "https://www.lazada.co.th/products/pdp-i5881011273.html",
        "sold": 0
    },
    {
        "product_name": "MODI โคมไฟถนนโซล่าเซลล์ ไฟถนน ไฟพลังงานแสงอาทิตย์ ไฟภายนอกอาคาร 400W แสงขาว ระบบสว่างค้าง ระบบเซนเซอร์ เปิดปิดอัตโนมัติ Solar street light",
        "product_image": "https://img.lazcdn.com/g/p/98561347ad1a6856282e6b24abfca356.jpg_200x200q90.jpg",
        "price": 5170.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5847104645.html",
        "sold": 0
    },
    {
        "product_name": "ไฟผนังกันน้ำ PIR สำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S710b21fb09d24317885c04e2c5adfee0G.png_200x200q90.png",
        "price": 5168,
        "remark": "https://www.lazada.co.th/products/pdp-i5837268362.html",
        "sold": 1
    },
    {
        "product_name": "พลังงานแสงอาทิตย์ประตูโคมไฟเสาไฟไฟนอกบ้านกันน้ำ LED Lampu รั้วอลูมิเนียม",
        "product_image": "https://img.lazcdn.com/g/p/b89495d88b4517d77c13eee9b838c3d5.jpg_200x200q90.jpg",
        "price": 5154,
        "remark": "https://www.lazada.co.th/products/pdp-i2462079082.html",
        "sold": 21
    },
    {
        "product_name": "MODI โคมไฟถนนโซล่าเซลล์400W แสงขาว ระบบสว่างค้าง ระบบเซนเซอร์ เปิดปิดอัตโนมัติ Solar street light",
        "product_image": "https://img.lazcdn.com/g/p/f925b74e6edf6d177c2c96dbcfafccd5.jpg_200x200q90.jpg",
        "price": 5128.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5847172204.html",
        "sold": 2
    },
    {
        "product_name": "Randyไฟโซล่าเซลล์ Gen2สปอตไลท์ ประกัน2ปี โคมไฟCCTV WIFI 100W-1500W พลังงานแสงอาทิตย์ ไฟสวน SolarLight",
        "product_image": "https://img.lazcdn.com/g/p/867c12236794080dd615bdf99c4fc26a.jpg_200x200q90.jpg",
        "price": 5120,
        "remark": "https://www.lazada.co.th/products/pdp-i5482712517.html",
        "sold": 18
    },
    {
        "product_name": "ke wei|ไฟติดผนังแบบยาว กันน้ำ สำหรับใช้กลาง    KW-5172",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S06f62eda266b486d8269ce22106966c1f.jpg_200x200q90.jpg",
        "price": 5082.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5926998069.html",
        "sold": 0
    },
    {
        "product_name": "SL LIGHTING | Post Light Solar โคมไฟหัวเสาโซล่าเซลล์ รุ่น  SL-11-SCB8163/BK",
        "product_image": "https://img.lazcdn.com/g/p/691259ae4945e9c94e152dcad564e629.jpg_200x200q90.jpg",
        "price": 5040,
        "remark": "https://www.lazada.co.th/products/pdp-i4117891899.html",
        "sold": 4
    },
    {
        "product_name": "BOANG | ไฟสปอร์ตไลท์ LED กันน้ำ สำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc0c83b25c59246cda10a04d3eadf0b8db.png_200x200q90.png",
        "price": 4994.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5893272224.html",
        "sold": 6
    },
    {
        "product_name": "EVE (1 แถม 1) โคมไฟถนน โซล่าเซลล์ รุ่น MAX ขนาด 100 - 500W ไม่มีโมชั่นตรวจจับ แสงขาว 6500K พร้อมขายึดอุปกรณ์ กันน้ำ IP65",
        "product_image": "https://img.lazcdn.com/g/p/8499bca5013516f12e4c4a06b07591b0.jpg_200x200q90.jpg",
        "price": 3600,
        "remark": "https://www.lazada.co.th/products/pdp-i5181605223.html",
        "sold": 3
    },
    {
        "product_name": "BIO โซล่าเซลล์ สปอร์ตไลท์ ไบโอ พร้อมรีโมท โคมฟลัดไลท์ โซล่าเซลล์ 200 W แสงขาว Fighter BIO ENERGY",
        "product_image": "https://img.lazcdn.com/g/p/884e3c6188d16a23963cda5dc4ea802d.jpg_200x200q90.jpg",
        "price": 4966,
        "remark": "https://www.lazada.co.th/products/pdp-i5407573296.html",
        "sold": 0
    },
    {
        "product_name": "GUANGPAIKE | ไฟเสาส่องสว่างกันน้ำพลังงานแสงอาทิตย์   C1322",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd15cd8b0099d47a98a9f9b8a518293f8U.png_200x200q90.png",
        "price": 4964.46,
        "remark": "https://www.lazada.co.th/products/pdp-i6003370354.html",
        "sold": 5
    },
    {
        "product_name": "โคมไฟโซล่าเซลแผงใหญ่ 200W แสงสีขาว ไฟโซล่าเซลล์ JD-8200 โคมไฟสปอร์ตไลท์ 288 SMD พร้อมรีโมท รับประกัน3ปี ยี่ห้อJDแท้",
        "product_image": "https://img.lazcdn.com/g/p/aa82e01ddfaeb604856badd34fb4c2bb.jpg_200x200q90.jpg",
        "price": 4960,
        "remark": "https://www.lazada.co.th/products/pdp-i676326988.html",
        "sold": 2
    },
    {
        "product_name": "ไฟสปอร์ตไลท์ LED กำลังสูง กันน้ำ สำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seb6702d3f6b64978b9dbc1440b92984aM.jpg_200x200q90.jpg",
        "price": 4938.44,
        "remark": "https://www.lazada.co.th/products/pdp-i6003146621.html",
        "sold": 0
    },
    {
        "product_name": "BEWON ไฟถนนโซล่าเซลล์ 800w โซล่าเซลล์ โคมไฟถนน ไฟกิ่งโซล่า ไฟทางโซล่าเซลล์ ไฟพลังงานแสงอาทิตย์ไฟนอกอาคาร ประกัน1ปี",
        "product_image": "https://img.lazcdn.com/g/p/31d79fc1b698f410c8a56b99b8e64c07.png_200x200q90.png",
        "price": 4851,
        "remark": "https://www.lazada.co.th/products/pdp-i2799279647.html",
        "sold": 0
    },
    {
        "product_name": "สปอร์ตไลท์ โซล่าเซลล์ STARLIGHT 800W",
        "product_image": "https://img.lazcdn.com/g/p/cbf7ae3dda96b8499d20532cb4d8c76f.png_200x200q90.png",
        "price": 4850,
        "remark": "https://www.lazada.co.th/products/pdp-i6043045402.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟหัวเสาโซล่าเซลล์ ทรง ญี่ปุ่น Japanese Style (สีดำ) (เเสง : เหลืองวอมไวท์) โคมไฟ หัวเสา โซล่าเซลล์ ไฟหัวเสาโซล่าเซลล์ ไฟโซล่าเซลล์",
        "product_image": "https://img.lazcdn.com/g/p/80d0e9b37419d5e274c32414b52a6108.jpg_200x200q90.jpg",
        "price": 4800,
        "remark": "https://www.lazada.co.th/products/pdp-i667548893.html",
        "sold": 2
    },
    {
        "product_name": "ไฟโซล่าเซลล์ ไฟUFO ไฟโซล่าเซล Solar Light ไฟถนน UFO 300000000w ไฟยูเอฟโอ ไฟภายนอกอาคาร ไฟถนนLED ไฟ โซล่าเซลล์ ไฟแสงอาทิตย์ แสงสีขาว โคมไฟถนน ไฟถนนโซล่าเซลล์ ไฟเซลล กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/59f8c2ba12c8ba057e021683597814dc.jpg_200x200q90.jpg",
        "price": 4798,
        "remark": "https://www.lazada.co.th/products/pdp-i16114379692.html",
        "sold": 0
    },
    {
        "product_name": "XLYS | โคมไฟผนังกันน้ำสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sac3306bfa7874a11b02d5b54de14b777G.jpg_200x200q90.jpg",
        "price": 4778.18,
        "remark": "https://www.lazada.co.th/products/pdp-i5925478749.html",
        "sold": 16
    },
    {
        "product_name": "ไฟถนนโซล่าเซลล์ สว่างถึงเช้า!! ไฟถนนโซล่าเซลล์STREET-LIGHT-36L 150000W ไฟถนนโซล่าเซลล์ ส่องได้36ช่อง ไฟถนน ส่องสว่างถึงเช้า ประกัน 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/3759c922b46b4b058e78f120624b6150.jpg_200x200q90.jpg",
        "price": 4770,
        "remark": "https://www.lazada.co.th/products/pdp-i4984834199.html",
        "sold": 12
    },
    {
        "product_name": "ไฟติดผนังกันน้ำกลางแจ้งสไตล์ยุโรปหรูหรา,โคมไฟติดผนัง LED ประดับคริสตัลสำหรับระเบียงทางเดินโรงแรมในบ้านและภายนอก",
        "product_image": "https://img.lazcdn.com/g/p/6a639d46a9c4b920acfa20cd18178126.jpg_200x200q90.jpg",
        "price": 4768,
        "remark": "https://www.lazada.co.th/products/pdp-i2862339521.html",
        "sold": 12
    },
    {
        "product_name": "โคมไฟถนนโซล่าเซลล์ 300W รุ่น MD-SLT30-300W (แสง : ขาว) โคมไฟถนน โซล่าเซลล์  โคมไฟ ไฟถนนโซล่าเซลล์  ไฟถนน ไฟโซล่าเซลล์",
        "product_image": "https://img.lazcdn.com/g/p/56b9c7f093522f756e16e9a19f386142.jpg_200x200q90.jpg",
        "price": 4760,
        "remark": "https://www.lazada.co.th/products/pdp-i5051348039.html",
        "sold": 1
    },
    {
        "product_name": "โคมไฟถนนโซล่าเซลล์ UFO ทรงกลม รุ่น MD-SLT-39-500W Plus โคมไฟ ไฟถนนโซล่าเซลล์ ไฟถนน โซล่าเซลล์ ไฟโซล่าเซลล์ ไฟUFO",
        "product_image": "https://img.lazcdn.com/g/p/140f910883cfaa02c7d1daecc9714072.jpg_200x200q90.jpg",
        "price": 4751.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5053361017.html",
        "sold": 9
    },
    {
        "product_name": "KKSKY โซล่าเซลล์ 1 แถม 1 ไฟโซล่าเซลล์ 1000w ไฟ สปอร์ตไลท์ solar light กันน้ำ กันฟ้าผ่า แสงสีขาว พร้อมรีโมท",
        "product_image": "https://img.lazcdn.com/g/p/8fa319774fefc36652b19458a53b144e.jpg_200x200q90.jpg",
        "price": 4722.48,
        "remark": "https://www.lazada.co.th/products/pdp-i3582554079.html",
        "sold": 2047
    },
    {
        "product_name": "【อัพเกรดความสว่าง📢】ไฟถนนโซล่าเซลล์150000W solar light LED ไฟเซนเซอร์ แสงสีขาว IP67 กันน้ำและกันฟ้าผ่",
        "product_image": "https://img.lazcdn.com/g/p/cb8562f7594519d1ddceb9e7c7dce505.png_200x200q90.png",
        "price": 4698,
        "remark": "https://www.lazada.co.th/products/pdp-i5674708739.html",
        "sold": 20
    },
    {
        "product_name": "ซื้อ 1แถม 1 ไฟถนนโซล่าเซลล์  20000000W ไฟโซล่าเซลถนน Solar Street Light สปอตไลท์ ไฟโซล่าเซล IP68กันน้ำ โคมไฟถนน กันน้ำและป้อ รับประกัน 30ปี",
        "product_image": "https://img.lazcdn.com/g/p/fb7fa9eb743bf9364069948e197bd7f1.jpg_200x200q90.jpg",
        "price": 4694.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5890429411.html",
        "sold": 131
    },
    {
        "product_name": "สปอตไลท์ ไฟ สปอร์ตไลท์ สปอร์ตไลท์ outdoor lighting สปอตไลท์ โซล่า สปอร์ตไลน์ led 100W 300W 400W 500W Spotlight IP65 COB Floodlight ซื้อ 1แถม 1",
        "product_image": "https://img.lazcdn.com/g/p/d0e7bb3e4a9fbb2b35fc3a60d90ee858.jpg_200x200q90.jpg",
        "price": 4624,
        "remark": "https://www.lazada.co.th/products/pdp-i5697559552.html",
        "sold": 6
    },
    {
        "product_name": "DUOSHANG | ไฟส่องสว่างผนังสีขาวกันน้ำพลังงานแสงอาทิตย์สำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S48d96cd1ffe0464dbd5ac40f45b4629bR.jpg_200x200q90.jpg",
        "price": 4615.52,
        "remark": "https://www.lazada.co.th/products/pdp-i6066592607.html",
        "sold": 1
    },
    {
        "product_name": "PopLight โคมไฟอลูมิเนียมโซล่าเซลล์ 500W แสงขาว พร้อมเซ็นเซอร์ตรวจจับการเคลื่อนไหวสุดล้ำ LED SOLAR GARDEN LIGHT",
        "product_image": "https://img.lazcdn.com/g/p/6be37b030d6895b9ee37e89607c7492d.jpg_200x200q90.jpg",
        "price": 4598,
        "remark": "https://www.lazada.co.th/products/pdp-i5182413225.html",
        "sold": 0
    },
    {
        "product_name": "BINGO ไฟโซล่าเซลล์ ไฟUFO ไฟโซล่าเซลถนน solar light outdoor ไฟถนนLED ไฟโซล่าเซล 60000W  โซล่าเซลล์ ทรงกลม แสงสีขาว IP67กันน้ำ พร้อมเสาไฟสูง 2M/2.6M",
        "product_image": "https://img.lazcdn.com/g/p/eba9d4289edee802bd0be6e57203bc89.jpg_200x200q90.jpg",
        "price": 4596,
        "remark": "https://www.lazada.co.th/products/pdp-i6014571302.html",
        "sold": 0
    },
    {
        "product_name": "ไฟตั้งพื้นโซล่าเซลล์ ทรงยุโรป สูง 110 ซม. (เปิดได้ 2 แสง) โคมไฟ ตั้งพื้นโซล่าเซลล์ ตั้งพื้น ไฟตั้งพื้นโซล่าเซลล์ ไฟตั้งพื้น",
        "product_image": "https://img.lazcdn.com/g/p/bc50575d35974e7ecac3ca961b792552.jpg_200x200q90.jpg",
        "price": 4580,
        "remark": "https://www.lazada.co.th/products/pdp-i4062398943.html",
        "sold": 1
    },
    {
        "product_name": "โคมหัวเสา Solarlight Eve โคมไฟหัวเสาโซล่าเซลล์พร้อมหลอดLED ทรงเพชรมีเปิดปิดเองตอนกลางคืน GSL-01",
        "product_image": "https://img.lazcdn.com/g/p/cdd8d566a93f037ca4a53515a22df17c.jpg_200x200q90.jpg",
        "price": 4571.38,
        "remark": "https://www.lazada.co.th/products/pdp-i114615314.html",
        "sold": 3
    },
    {
        "product_name": "MODI ไฟโซล่าเซลล์ 500W แสงขาว/3แสง ระบบสว่างค้าง ไฟถนน Solar street light โคมไฟโซล่าเซลล์ หลอดไฟ",
        "product_image": "https://img.lazcdn.com/g/p/37b81f3515c66dfe5ce6d8d94b2e7a3a.jpg_200x200q90.jpg",
        "price": 4558.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16100369376.html",
        "sold": 2
    },
    {
        "product_name": "MODI โคมไฟถนนโซล่าเซลล์ 300W 400W 600W 800W 1000W แสงขาว 3000lm ไฟถนนพลังงานแสงอาทิตย์ เซนเซอร์ตรวจจับความเคลื่อนไหว Solar street light IP65",
        "product_image": "https://img.lazcdn.com/g/p/8df53b034ea618a847d3a76e7172fd79.jpg_200x200q90.jpg",
        "price": 4523.94,
        "remark": "https://www.lazada.co.th/products/pdp-i3856134301.html",
        "sold": 40
    },
    {
        "product_name": "ไฟตั้งพื้นโซล่าเซลล์ ทรงยุโรป สูง 175 ซม. (เปิดได้ 2 แสง) โคมไฟ ตั้งพื้นโซล่าเซลล์ ตั้งพื้น ไฟตั้งพื้นโซล่าเซลล์ ไฟตั้งพื้น",
        "product_image": "https://img.lazcdn.com/g/p/ef44deb49901a5f905ad7d048bc454be.jpg_200x200q90.jpg",
        "price": 4516.5,
        "remark": "https://www.lazada.co.th/products/pdp-i4062683057.html",
        "sold": 8
    },
    {
        "product_name": "MODI ไฟถนนโซล่าเซลล์ ไฟถนน ไฟโซล่าเซลล์ ไฟภายนอกอาคาร ไฟพลังแสงอาทิตย์ ไฟsolarcell  400W แสงขาว ระบบสว่างค้าง เปิดปิดอัตโนมัติ Solar street light IP65",
        "product_image": "https://img.lazcdn.com/g/p/742af9a41f2cd26b4bf63bbcd2e9b5f4.jpg_200x200q90.jpg",
        "price": 4505.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5608926917.html",
        "sold": 27
    },
    {
        "product_name": "ไฟถนนโซล่าเซลล์ Solarcell streelight 100w 150w 300w Day light  คุณภาพดี ทนทาน",
        "product_image": "https://img.lazcdn.com/g/p/33a4bd4b9f0369e2d77d7341e52dbe71.jpg_200x200q90.jpg",
        "price": 4500,
        "remark": "https://www.lazada.co.th/products/pdp-i3859264243.html",
        "sold": 0
    },
    {
        "product_name": "SL LIGHTING  | ESFERA โคมไฟสนาม โคมไฟตั้งพื้น วัสดุ Polyethylene สีขาว ทรงกลม  IP65 รุ่น ESFERA-E27 ขนาด 40 cm. และ 50 cm.",
        "product_image": "https://img.lazcdn.com/g/p/fd1258cffbad9c6d994e1a6f932a6fd9.jpg_200x200q90.jpg",
        "price": 4500,
        "remark": "https://www.lazada.co.th/products/pdp-i5381360214.html",
        "sold": 8
    },
    {
        "product_name": "MODI โคมไฟถนนโซล่าเซลล์300W/400W/600W เปิดได้ 3 แสง รีโมทคอนโทรล ระบบสว่างค้าง เปิดปิดอัตโนมัติ Solar street light IP65",
        "product_image": "https://img.lazcdn.com/g/p/f07cd7681c3c9922b9d8eab467895ffc.jpg_200x200q90.jpg",
        "price": 4450.38,
        "remark": "https://www.lazada.co.th/products/pdp-i4789850648.html",
        "sold": 47
    },
    {
        "product_name": "SL LIGHTING | BOLD Series โคมไฟติดผนังภายนอกและโคมไฟเสาสนาม LED รุ่น BOLD",
        "product_image": "https://img.lazcdn.com/g/p/42bb1f84d7230a687902eeadd897ded0.jpg_200x200q90.jpg",
        "price": 4400,
        "remark": "https://www.lazada.co.th/products/pdp-i5914830160.html",
        "sold": 0
    },
    {
        "product_name": "LAMPTAN โคมไฟถนนกำลังวัตต์สูงพลังงานแสงอาทิตย์แบบแยกแผง SOLAR SPLIT STREETLIGHT GRANT แสงขาว พร้อมเซนเซอร์ความสว่าง",
        "product_image": "https://img.lazcdn.com/g/p/1949fffc1edb3944e8c716f282950b62.jpg_200x200q90.jpg",
        "price": 4398,
        "remark": "https://www.lazada.co.th/products/pdp-i5916594454.html",
        "sold": 2
    },
    {
        "product_name": "ไฟสนามบอล100w 200w 300w  COB 220v  flood สปอตไลท์ Spotlight LED Floodlight (ใช้ไฟบ้าน 220V)",
        "product_image": "https://img.lazcdn.com/g/p/8ac3dfb1593ff7943f8c1a4950602040.jpg_200x200q90.jpg",
        "price": 4380,
        "remark": "https://www.lazada.co.th/products/pdp-i1769782161.html",
        "sold": 3
    },
    {
        "product_name": "\"1 แถม 1\" สปอร์ตไลท์โซลาร์เซลล์ SHINING รุ่น PLUTO 250W แสงขาว สายยาว 5 เมตร IP65 ควบคุมด้วยรีโมต ใช้งานง่าย Toshiba lighting",
        "product_image": "https://img.lazcdn.com/g/p/5de457108625f36a4079dbdc6f2f17be.jpg_200x200q90.jpg",
        "price": 4348.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5966390284.html",
        "sold": 0
    },
    {
        "product_name": "JD-82000L 2000W JD SOLAR LIGHT LED รุ่นใหม่ JD-L ไฟโซล่าเซลล์เปลือกอลูมิเนียม ใช้พลังงานแสงอาทิตย์100% โคมไฟสนาม โคมไฟสปอร์ตไลท์ โคมไฟโซล่าเซลล์ แผงโซล่าเซลล์ ไฟLED รับประกัน 3 ปี",
        "product_image": "https://img.lazcdn.com/g/p/65d278256ebfb9082a7077981fa1a468.png_200x200q90.png",
        "price": 4306.44,
        "remark": "https://www.lazada.co.th/products/pdp-i3462571073.html",
        "sold": 15
    },
    {
        "product_name": "สปอตไลท์โซล่าเซลล์แผงแยก SOLAR SHINING 200 วัตต์ แสงขาว สายต่อ 5 เมตร IP65 กันน้ำ สว่างถึงเช้า หลอดไฟโตชิบา Toshiba lighting",
        "product_image": "https://img.lazcdn.com/g/p/fe945124906f6efcdf71297405ab408a.jpg_200x200q90.jpg",
        "price": 4232.12,
        "remark": "https://www.lazada.co.th/products/pdp-i4849849223.html",
        "sold": 37
    },
    {
        "product_name": "MODI ไฟถนนโซล่าเซลล์ 400-W แสงขาว ระบบสว่างค้าง รีโมทคอนโทรล(พร้อมขาเหล็กยึดเสา) Solar street light",
        "product_image": "https://img.lazcdn.com/g/p/f807bf3f9f2a92b6c6f9b08f15a63d2b.jpg_200x200q90.jpg",
        "price": 4227.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5153882928.html",
        "sold": 53
    },
    {
        "product_name": "Lamptan โคมไฟถนน 500w 1000w LED Solar Streetlight Sensor รุ่น Titan โซลาร์เซลล์ จับสว่าง เปิด-ปิด",
        "product_image": "https://img.lazcdn.com/g/p/e0db048af2eedec1758ad2978138e092.png_200x200q90.png",
        "price": 4218,
        "remark": "https://www.lazada.co.th/products/pdp-i4650312122.html",
        "sold": 5
    },
    {
        "product_name": "MODI โคมไฟถนนโซล่าเซลล์ 300W/400W/600W แสงขาว รีโมทคอนโทรล แผงMono ไฟถนนพลังงานแสงอาทิตย์ ระบบสว่างค้าง เปิดปิดอัตโนมัติ Solar street light IP65",
        "product_image": "https://img.lazcdn.com/g/p/46b51a325390d1c41bb93bf21c806dfd.jpg_200x200q90.jpg",
        "price": 4216.44,
        "remark": "https://www.lazada.co.th/products/pdp-i4778122275.html",
        "sold": 31
    },
    {
        "product_name": "RUILUO | ไฟ LED สี RGB กันน้ำ สำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S326b7f4bb6e84bff818012868b6e3454U.jpeg_200x200q90.jpg",
        "price": 4214.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5881322661.html",
        "sold": 3
    },
    {
        "product_name": "JUYU | ไฟส่องสว่างกลางแจ้งพลังงานแสงอาทิตย์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9a42d635f8c9408f836ae521e8b7eb3er.jpg_200x200q90.jpg",
        "price": 4200.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5878655511.html",
        "sold": 8
    },
    {
        "product_name": "ไฟสปอตไลท์โซล่าเซลล์ 300 W. รุ่น Modi x XML ไซต์ใหญ่ (เเสง : ขาว) ไฟสปอตไลท์ ไฟโซล่าเซลล์ สปอตไลท์โซล่าเซลล์",
        "product_image": "https://img.lazcdn.com/g/p/576eaf946bc8c0efc661255ad3d0cc5a.jpg_200x200q90.jpg",
        "price": 4198.5,
        "remark": "https://www.lazada.co.th/products/pdp-i461548147.html",
        "sold": 48
    },
    {
        "product_name": "XLYS | ไฟส่องสว่างผนังพลังงานแสงอาทิตย์กันน้ำสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Sfc1981540a85404484fd9279ae13de56k.jpg_200x200q90.jpg",
        "price": 4178.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5968474177.html",
        "sold": 10
    },
    {
        "product_name": "MODI ไฟถนนโซล่าเซลล์ 400W แสงขาว ระบบสว่างค้าง รีโมทคอนโทรล(พร้อมขาเหล็กยึดเสา) Solar street light",
        "product_image": "https://img.lazcdn.com/g/p/450d1a86411f2f9f53cfcae9e6139cfb.jpg_200x200q90.jpg",
        "price": 4145.08,
        "remark": "https://www.lazada.co.th/products/pdp-i5153892898.html",
        "sold": 11
    },
    {
        "product_name": "MODI โคมไฟถนนโซล่าเซลล์ ไฟภายนอกอาคาร ไฟถนน 300W แสงขาว รีโมทคอนโทรล ไฟถนนพลังงานแสงอาทิตย์ ระบบสว่างค้าง เปิดปิดอัตโนมัติ Solar street light IP65",
        "product_image": "https://img.lazcdn.com/g/p/26a8d4eead8d251f29fa122032690b8a.jpg_200x200q90.jpg",
        "price": 4137.72,
        "remark": "https://www.lazada.co.th/products/pdp-i4789916507.html",
        "sold": 1
    },
    {
        "product_name": "MODI โคมไฟถนนโซล่าเซลล์ 300W แสงขาว รีโมท ไฟถนนพลังงานแสงอาทิตย์ ระบบสว่างค้าง เปิดปิดอัตโนมัติ Solar street light IP65",
        "product_image": "https://img.lazcdn.com/g/p/6fdc055e7289b841f6a2407e947aeaca.jpg_200x200q90.jpg",
        "price": 4118.04,
        "remark": "https://www.lazada.co.th/products/pdp-i4789953293.html",
        "sold": 18
    },
    {
        "product_name": "🔥การประกัน 30ปี🔥 ไฟโซล่าเซลล์ 150000W Solar Light LED ไฟถนนโซล่าเซลล์ ไฟสปอตไลท์ IP67กันน้ำ ควบคุมแสงอัจฉริยะ",
        "product_image": "https://img.lazcdn.com/g/p/d9981b91c30b368fe057a944590c83f5.png_200x200q90.png",
        "price": 4106,
        "remark": "https://www.lazada.co.th/products/pdp-i5674554989.html",
        "sold": 28
    },
    {
        "product_name": "สปอตไลท์ COB 600W 500W 400W 300W 200W 100W  สปอตไลท์ COB รุ่นใหม่แสงพุ่งไกล ไฟฟ้า220V แอลอีดี Flood light โคมไฟ ไฟถนน โคมไฟภูมิทัศน์ สปอร์ตไลท์ ไฟงานแต่ง ไฟงานบวช",
        "product_image": "https://img.lazcdn.com/g/p/1cd8c76cf8d2da0eb68ff0c5c669fec3.jpg_200x200q90.jpg",
        "price": 4100,
        "remark": "https://www.lazada.co.th/products/pdp-i5800413090.html",
        "sold": 0
    },
    {
        "product_name": "MODI โคมไฟถนนโซล่าเซลล์ 400W แสงขาว ระบบสว่างค้าง เปิดปิดอัตโนมัติ Solar street light IP65",
        "product_image": "https://img.lazcdn.com/g/p/4059176988bbedc60f6c5b8818afbe74.jpg_200x200q90.jpg",
        "price": 4095.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5608825612.html",
        "sold": 3
    },
    {
        "product_name": "LAMPTAN โคมไฟฟลัดไลท์พลังงานแสงอาทิตย์ LED SOLAR FLOODLIGHT ARCRAY หน้าโค้งกระจายแสงกว้าง พร้อมเซนเซอร์จับความสว่าง",
        "product_image": "https://img.lazcdn.com/g/p/bdbcad6d61640e6e45e9ae8edee78d09.jpg_200x200q90.jpg",
        "price": 4088,
        "remark": "https://www.lazada.co.th/products/pdp-i16118379059.html",
        "sold": 0
    },
    {
        "product_name": "ใหม่! 2024 BOVO Solar Flood Light  Solar Cell ไฟสปอร์ตไลท์โคมอลูมิเนียมแสงขาว โซล่าเซลล์ กันน้ำกันฝุ่น 300W",
        "product_image": "https://img.lazcdn.com/g/p/e252371c4563130529955fe35cdba860.jpg_200x200q90.jpg",
        "price": 4082.06,
        "remark": "https://www.lazada.co.th/products/pdp-i5382294356.html",
        "sold": 0
    },
    {
        "product_name": "MODI โคมไฟถนนโซล่าเซลล์ไฟภายนอกอาคาร ไฟถนน 300W/400W/600W เปิดได้ 3 แสง รีโมทคอนโทรล ระบบสว่างค้าง เปิดปิดอัตโนมัติ Solar street light IP65",
        "product_image": "https://img.lazcdn.com/g/p/213f2698114fb91fe1f5ee7b73028ee8.jpg_200x200q90.jpg",
        "price": 4070.44,
        "remark": "https://www.lazada.co.th/products/pdp-i4789951440.html",
        "sold": 15
    },
    {
        "product_name": "โคมไฟถนนโซล่าเซลล์ 300W/400W/600W รุ่น MD-SLT31 (เปิดได้ 3 แสง) โคมไฟ ไฟถนนโซล่าเซลล์ ไฟโซล่าเซลล์",
        "product_image": "https://img.lazcdn.com/g/p/d68743984ad4253b1b190aa0bf7b05b9.jpg_200x200q90.jpg",
        "price": 4063.18,
        "remark": "https://www.lazada.co.th/products/pdp-i5596386680.html",
        "sold": 3
    },
    {
        "product_name": "SXH ในสต็อกจัดส่งที่รวดเร็วพลังงานแสงอาทิตย์ / แบบชาร์จไฟดวงจันทร์กลางแจ้งกันน้ำพลังงานแสงอาทิตย์ดวงจันทร์โคมไฟภูมิทัศน์ลานภูมิทัศน์โคมไฟสวนหญ้าโคมไฟตั้งพื้นพลังงานแสงอาทิตย์โรงงานที่มีสีสัน RGBW",
        "product_image": "https://img.lazcdn.com/g/p/4a7766d3e80e89044d7e5398ad7fc9ed.jpg_webp_200x200q90.jpg",
        "price": 4036.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5245319672.html",
        "sold": 23
    },
    {
        "product_name": "ไฟ UFO ทรงสี่เหลี่ยม โซล่าเซลล์ ไฟถนน LED 2800W แสงขาว ไฟโซล่าเซลล์ โคมไฟถนน รุ่น TSM-2800.",
        "product_image": "https://img.lazcdn.com/g/p/287eb8022fd862e1c7ba60b45758afea.jpg_200x200q90.jpg",
        "price": 4020,
        "remark": "https://www.lazada.co.th/products/pdp-i5831722732.html",
        "sold": 0
    },
    {
        "product_name": "โคมโซล่าเซลล์ ฟลัดไลท์ RACER รุ่น MAX BEAM (100W, 200W, 300W) แสงขาว | โคมไฟฟลัดไลท์โซล่าร์เซลล์ โคมไฟ หลอดไฟ แสงอาทิตย์ โซล่า โซล่าร์ solar cell โซล่าเซลล์",
        "product_image": "https://img.lazcdn.com/g/p/78114e74606c0e4ac760e0b52d50010e.jpg_200x200q90.jpg",
        "price": 4014,
        "remark": "https://www.lazada.co.th/products/pdp-i4494140860.html",
        "sold": 10
    },
    {
        "product_name": "\"ใหม่\" 1แถม1 ไฟถนนโซล่าเซลล์ SOLAR SHINING URANUS 150 วัตต์ DAYLIGHT พร้อมเสายึด ทนทาน IP65 กันน้ำ สว่างถึงเช้า หลอดไฟโตชิบา Toshiba lighting",
        "product_image": "https://img.lazcdn.com/g/p/919ab8b2d57f74be7f47225c63c7e80e.jpg_200x200q90.jpg",
        "price": 4010,
        "remark": "https://www.lazada.co.th/products/pdp-i5829706937.html",
        "sold": 0
    },
    {
        "product_name": "EVE โคมฟลัดไลท์ โซล่าเซลล์ แอลอีดี LED รุ่น DAWN IP65 ขนาด 10 ถึง 300W ( ไม่เอากล่อง ลดเพิ่ม 20% )",
        "product_image": "https://img.lazcdn.com/g/p/c994e4920d464d2fe00eed8b12c9f284.jpg_200x200q90.jpg",
        "price": 4000,
        "remark": "https://www.lazada.co.th/products/pdp-i2804866500.html",
        "sold": 268
    },
    {
        "product_name": "SL LIGHTING | Post Light โคมไฟสนาม โคมไฟหัวเสา ให้แสงสว่างยามค่ำคืน เพื่อเพิ่มความปลอดภัย SL-11-8154/BK | SL-11-8156/BK",
        "product_image": "https://img.lazcdn.com/g/p/b4a6ba2a078096e78d7f3304dd355641.jpg_200x200q90.jpg",
        "price": 4000,
        "remark": "https://www.lazada.co.th/products/pdp-i706000018.html",
        "sold": 1
    },
    {
        "product_name": "Randy Ultra Pro ไฟถนนโซลาร์เซลล์ 200 วัตต์ รุ่น DW-XJ-902",
        "product_image": "https://img.lazcdn.com/g/p/302d1e1e128e9c1041417a0a2b7b49e0.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5768354989.html",
        "sold": 0
    },
    {
        "product_name": "Randy ไฟLED ไฟถนนโซล่าเซลล์ SolarLight ไฟโซล่าเซลล์ โคมไฟถนน แอลอีดี สปอร์ตไลท์ โซล่าเซลล์ กันน้ำ สปอตไลท์ พลังงานแสงอาทิตย์ Solarcell 200W 300W 400W 600W",
        "product_image": "https://img.lazcdn.com/g/p/6bf35f3ad8ce9b808075a779fbddc983.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i1779116128.html",
        "sold": 350
    },
    {
        "product_name": "⚡🔥 ไฟถนน ULTRA PRO อัพเกรดความสว่าง ⚡🔥 ขั้นสุดของความคุ้มค่า ระบบการทำงานพิเศษ‼",
        "product_image": "https://img.lazcdn.com/g/p/cdafaeedb81480e4393009d6f01f3562.png_200x200q90.png",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i4840339666.html",
        "sold": 24
    },
    {
        "product_name": "MODI ไฟห้อยระย้าโซล่าเซลล์ ไฟลูกแก้ว ไฟปิงปอง สายไฟห้อยระย้า ไฟประดับ 10เมตร20หลอด รุ่นSUPER แสงเหลือง แต่งสวน ปีใหม่ คริสมาส ปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/43c3be4d9d462c454f81d1f3628612fd.jpg_200x200q90.jpg",
        "price": 3964.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5426523346.html",
        "sold": 14
    },
    {
        "product_name": "โคมไฟสวนกันน้ำกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc7baac5c51144c7bb0bca718c97c6adcQ.jpg_200x200q90.jpg",
        "price": 3960.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6001682024.html",
        "sold": 0
    },
    {
        "product_name": "SL LIGHTING | Bollard โคมไฟสนามโซล่าเซลล์ 5 วัตต์ ปรับได้ 3 แสง รุ่น SCB-601-5W3CT-60CM",
        "product_image": "https://img.lazcdn.com/g/p/d6f05b2c35f1e1b9683d051f52518ff9.jpg_200x200q90.jpg",
        "price": 3960,
        "remark": "https://www.lazada.co.th/products/pdp-i4872539752.html",
        "sold": 6
    },
    {
        "product_name": "JDJINDIAN  พร้อมจัดส่ง!!  ไฟโซล่าเซล ไฟประหยัดพลังงาน25w 40w 60w 100w 200w 300w 500w 1000w ไฟโซล่าเซลล์ แสดงแบตเตอรี่ solar light แสงสีเหลือง สีขาว ไฟสปอตไลท์ ไฟ solar cell กันน้ำ IP67 ทนทาน",
        "product_image": "https://img.lazcdn.com/g/p/c36b4722fe6e9a368908d78db5b9196c.jpg_200x200q90.jpg",
        "price": 3950,
        "remark": "https://www.lazada.co.th/products/pdp-i3413756038.html",
        "sold": 569
    },
    {
        "product_name": "MODI Solar street light โคมไฟถนนโซล่าเซลล์ Modi 300w.V-S18-300W Golden (แสง : เหลืองวอมไวท์)",
        "product_image": "https://img.lazcdn.com/g/p/b9c42ac6efec4e0a19ac4017848f4d6c.jpg_200x200q90.jpg",
        "price": 3948.96,
        "remark": "https://www.lazada.co.th/products/pdp-i1875304321.html",
        "sold": 15
    },
    {
        "product_name": "SHINING สปอตไลท์ภายนอก LED Floodlight 200 วัตต์  สีขาว กันน้ำ สว่างมากกำลังสูง ป้ายโฆษณา ไฟสนาม หลอดไฟโตชิบา Toshiba Lighting",
        "product_image": "https://img.lazcdn.com/g/p/a69e1a2cd886c144786299a559c93211.jpg_200x200q90.jpg",
        "price": 3931.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5155375691.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟสปอร์ตไลท์ UFO รุ่น Cosmo 2000W โซลาร์เซลล์พร้อมรีโมต LED แสงขาว Daylight EVE LIGHTING 6500K",
        "product_image": "https://img.lazcdn.com/g/p/06f034c16c1f2ed7d3cb3e578f1e5ab2.jpg_200x200q90.jpg",
        "price": 3931.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5548756924.html",
        "sold": 1
    },
    {
        "product_name": "MODI ไฟถนนสวมเสาโซล่าเซลล์ 300W เปิดได้ 3 แสง สวมเสา 3 นิ้ว พลังงานแสงอาทิตย์ Solar street light",
        "product_image": "https://img.lazcdn.com/g/p/2c5c144c28e21da76dc3e5198d7a3530.jpg_200x200q90.jpg",
        "price": 3918.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16092766650.html",
        "sold": 2
    },
    {
        "product_name": "JDJINDIAN  8300L ไฟโซล่าเซลล์ led  300W  ไฟสปอร์ตไลท์ solar light ไฟ Solar Cell โคมไฟพลังงานแสงอาทิตย์",
        "product_image": "https://img.lazcdn.com/g/p/725872e2baa0ddc37c9cff9a48fe50f5.jpg_200x200q90.jpg",
        "price": 3910.5,
        "remark": "https://www.lazada.co.th/products/pdp-i3582191835.html",
        "sold": 138
    },
    {
        "product_name": "FANKESEN |โคมไฟถนนกันน้ำ สำหรับลานบ้านสไตล์ยุโรป พร้อมเสาสูง 3 เมตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd099da5bca7242a8ad4c3df9850aaab2k.jpg_200x200q90.jpg",
        "price": 3895.74,
        "remark": "https://www.lazada.co.th/products/pdp-i6001690116.html",
        "sold": 0
    },
    {
        "product_name": "JD ไฟโซล่าเซลล์ SOLAR STREET LIGHT 200W 300W 600W 1000W 2000W ไฟถนนโซล่าเซลล์ MTXL LED พลังงานแสงอาทิตย์ ไฟถนน ไฟเซลล์ส",
        "product_image": "https://img.lazcdn.com/g/p/02aea3d6b0bd2b38bbb4c556df6b480f.png_200x200q90.png",
        "price": 3882.4,
        "remark": "https://www.lazada.co.th/products/pdp-i4576425112.html",
        "sold": 4
    },
    {
        "product_name": "MODI โคมไฟถนนสวมเสาโซล่าเซลล์ 300W แสงขาว/เหลือง 2000Lm 18000mAh สวมเสา 3 นิ้ว พลังงานแสงอาทิตย์ Solar street light IP65",
        "product_image": "https://img.lazcdn.com/g/p/a8292d7ee7cf0abf95f5a64b62043be0.jpg_200x200q90.jpg",
        "price": 3877.3,
        "remark": "https://www.lazada.co.th/products/pdp-i4267838562.html",
        "sold": 124
    },
    {
        "product_name": "ENRICH โคมไฟสนาม แบบโซล่าเซลล์ LED Garden light UFO รุ่น Space ขนาด 200W แสงขาว",
        "product_image": "https://img.lazcdn.com/g/p/6de283112d44744076e74ea86879c159.jpg_200x200q90.jpg",
        "price": 3876,
        "remark": "https://www.lazada.co.th/products/pdp-i4546673252.html",
        "sold": 1
    },
    {
        "product_name": "MODI ไฟถนนโซล่าเซลล์ 600W แสงขาว รีโมทคอนโทรล ไฟถนนพลังงานแสงอาทิตย์ ระบบสว่างค้าง เปิดปิดอัตโนมัติ Solar street light IP65",
        "product_image": "https://img.lazcdn.com/g/p/97862d21bb187c17035ae765ab0d4718.jpg_200x200q90.jpg",
        "price": 3872,
        "remark": "https://www.lazada.co.th/products/pdp-i4778024726.html",
        "sold": 27
    },
    {
        "product_name": "โคมถนนโซล่าเซลล์ แอลอีดี 500W MAX EVE ไม่มีโมชั่น พร้อมขายึด Street Light Solar Cell z8",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd36120cefaa447bbb6e32642e2df0893Q.jpg_200x200q90.jpg",
        "price": 3858.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5130612479.html",
        "sold": 0
    },
    {
        "product_name": "ใหม่ BEC โคมไฟฟลัดไลท์ โซลาร์เซลล์ LED 170w 220w 320w รุ่น SPIDER 3 แสง",
        "product_image": "https://img.lazcdn.com/g/p/d9bf1287ae8f875415883fbb7c975aca.jpg_200x200q90.jpg",
        "price": 3858,
        "remark": "https://www.lazada.co.th/products/pdp-i4797194809.html",
        "sold": 3
    },
    {
        "product_name": "BEC เปลี่ยนได้ 3 แสง LED Solar Floodlight รุ่น SPIDER 170w 220w 320w โคมไฟฟลัดไลท์ โซลาร์เซลล์",
        "product_image": "https://img.lazcdn.com/g/p/aa4ad2c5b118114ae48a5a710689f4d4.png_200x200q90.png",
        "price": 3858,
        "remark": "https://www.lazada.co.th/products/pdp-i4797226899.html",
        "sold": 2
    },
    {
        "product_name": "แบรนด์ JD ของแท้100% ไฟโซล่าเซลล์JDแท้ สปอร์ตไลท์ Solar LED โซล่าเซลล์ JD-L เปลือกอลูมิเนียมอัพเกรดใหม่ รับประกันถึง 3 ปีเต็ม 45W 65W 120W 200W 300W 650W 1000W 2000W",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saf4bf42dcffa40f8bdc393dada640e5fC.png_200x200q90.png",
        "price": 3846.86,
        "remark": "https://www.lazada.co.th/products/pdp-i3462474871.html",
        "sold": 3041
    },
    {
        "product_name": "JD Jindian แท้ ไฟสปอร์ตไลท์ รุ่น JD-81000L ขนาด1,000 วัตต์ โซล่าเซลล์ แสงขาว และ แสงวอร์ม (ประกันศูนย์ไทย 1ปี)",
        "product_image": "https://img.lazcdn.com/g/p/4138685187c56ca920e360451acb188a.jpg_200x200q90.jpg",
        "price": 3798,
        "remark": "https://www.lazada.co.th/products/pdp-i4948856292.html",
        "sold": 0
    },
    {
        "product_name": "🔰ทีเดียวในไทย🔰เเสงwarm [ Jd Jindian เเท้ ]UFO รุ่นพรีเมี่ยม เพิ่มฟังก์ชั่นพิเศษ โคมไฟจานบิน ไฟถนนโซล่าเซลล์ ไฟโซล่าเซลล์ JD ของเเท้",
        "product_image": "https://img.lazcdn.com/g/p/95f49854a7a5417f0a22aaadeb6d230b.jpg_200x200q90.jpg",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i3137765345.html",
        "sold": 44
    },
    {
        "product_name": "🧧ซื้อ 3 เเถม 1🧧โคมไฟ UFO รุ่นพรีเมี่ยม [ Jd Jindian เเท้ ] ไฟถนนโซล่าเซลล์ ไฟโซล่าเซลล์ JD ของเเท้ โปรโมชั่น ซื้อ 3 โคม เเถมกาน้ำร้อนลิมิเต็ด",
        "product_image": "https://img.lazcdn.com/g/p/8b4c3062d60fa2103d6a03d047263ce4.jpg_200x200q90.jpg",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i3398329801.html",
        "sold": 18
    },
    {
        "product_name": "LUMAX โคมไฟสปอร์ตไลท์ โซล่าร์เซลล์ LED 100W พร้อมรีโมทควบคุม รุ่น STAR SERIES EFLL100W/BL-82LED/6.5K/STAR",
        "product_image": "https://img.lazcdn.com/g/p/8bf8a0a204636085af0faa1e91bddb25.jpg_200x200q90.jpg",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i4672934017.html",
        "sold": 0
    },
    {
        "product_name": "🔥ไฟถนน Top of All in 1 🔥รุ่น Space Light‼ 🔋\"แบตเตอรี่ชุดใหญ่ สว่างกว้างกระจายเต็มพื้นที่ \"✨",
        "product_image": "https://img.lazcdn.com/g/p/0f662e24a120060ebb083e1808527ee2.jpg_200x200q90.jpg",
        "price": 3745.18,
        "remark": "https://www.lazada.co.th/products/pdp-i4705156939.html",
        "sold": 24
    },
    {
        "product_name": "KKSKY ไฟโซล่าเซลล์  โซล่าไลท์กลางแจ้ง แสงขาวสว่าง 100W 300W 500W 1000W โซล่าเซลล์ ไฟสปอร์ตไลท์ LED กำลังสูง Solar Light กันน้ำ IP67 ตัวอลูมิเนียม",
        "product_image": "https://img.lazcdn.com/g/p/42b1287a8c13b2e66f2308a89cfed465.png_200x200q90.png",
        "price": 3744.24,
        "remark": "https://www.lazada.co.th/products/pdp-i5877914589.html",
        "sold": 167
    },
    {
        "product_name": "MODI ไฟห้อยระย้าโซล่าเซลล์ ไฟลูกแก้ว ไฟปิงปอง สายไฟห้อยระย้า ไฟระย้า 10เมตร20หลอด รุ่นSUPER แสงเหลือง ตกแต่งสวน ปีใหม่ คริสมาส ปาร์ตี้ christmas light",
        "product_image": "https://img.lazcdn.com/g/p/1903335682c6a3e3fe54411ab0cdece9.jpg_200x200q90.jpg",
        "price": 3730.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5442826725.html",
        "sold": 31
    },
    {
        "product_name": "โคมไฟโซล่าเซลล์ UFO รุ่น JDของแท้* (200,000W) โคมไฟ โซล่าเซลล์ ไฟถนนโซล่าเซลล์ ไฟโซล่าเซลล์ ไฟUFO",
        "product_image": "https://img.lazcdn.com/g/p/c51a14d5131f2a079707960e0cb98073.jpg_200x200q90.jpg",
        "price": 3729.26,
        "remark": "https://www.lazada.co.th/products/pdp-i3774516421.html",
        "sold": 48
    },
    {
        "product_name": "NEW JD-SOLAR LIGHTS XJD-L โคมไฟถนน ไฟถนนโซล่าเซลล์ โคมไฟถนนLED ไฟพลังงานแสงอาทิตย์100% ไฟถนนJD อุปกรณ์พร้อมติดตั้ง รับประกัน2ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6f4286fe3ea2487ca41be18747f4b702W.png_200x200q90.png",
        "price": 3724,
        "remark": "https://www.lazada.co.th/products/pdp-i16058353980.html",
        "sold": 0
    },
    {
        "product_name": "ไฟเสาส่องสว่างกลางแจ้งกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S23df8bf908b34d70adcfdae35d8c3440r.jpg_200x200q90.jpg",
        "price": 3718.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5925670720.html",
        "sold": 6
    },
    {
        "product_name": "kufire | ไฟเสาทรงกลมพลังงานแสงอาทิตย์สำหรับใช้งานกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0534187332f34c75b16ddbf493e9b62cZ.jpg_200x200q90.jpg",
        "price": 3713.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5910962098.html",
        "sold": 93
    },
    {
        "product_name": "โคมไฟถนนโซล่าเซลล์ XML-Solar 300 W (แสง : ขาว)(สว่างค้าง) โคมไฟ ไฟถนน ไฟโซล่าเซลล์ ไฟถนนโซล่าเซลล์",
        "product_image": "https://img.lazcdn.com/g/p/7bfdde55f70d3c00b3b3168e681d5275.jpg_200x200q90.jpg",
        "price": 3713.34,
        "remark": "https://www.lazada.co.th/products/pdp-i674268259.html",
        "sold": 221
    },
    {
        "product_name": "JD ของแท้100% โคมไฟโซล่าเซลล์ 300W รุ่น JD8300L สปอร์ตไลท์ โซล่าเซลล์ โคมไฟ พลังงานแสงอาทิตย์ ราคาส่ง สอบถามได้นะคะ",
        "product_image": "https://img.lazcdn.com/g/p/4030e88ebadaacdc5ce470e50c992b78.jpg_200x200q90.jpg",
        "price": 3700,
        "remark": "https://www.lazada.co.th/products/pdp-i4640844954.html",
        "sold": 1
    },
    {
        "product_name": "SL LIGHTING | In Ground Uplight โคมไฟฝังพื้น LED 15W 3000K IP67 Stainless 304 รุ่น CHAKREE-15W30K",
        "product_image": "https://img.lazcdn.com/g/p/162f60aae3681ac38f088971558ccbb1.jpg_200x200q90.jpg",
        "price": 3700,
        "remark": "https://www.lazada.co.th/products/pdp-i5993427048.html",
        "sold": 0
    },
    {
        "product_name": "MODI ไฟสปอตไลท์โซล่าเซลล์ 300W 3000ลูเมน แสงขาว Day light ไฟ led Solar Cell Led กันน้ำIP65 รีโมทคอนโทรล รับประกัน1ปี",
        "product_image": "https://img.lazcdn.com/g/p/a4dc20d1ac4527798533745c53313612.jpg_200x200q90.jpg",
        "price": 3696.74,
        "remark": "https://www.lazada.co.th/products/pdp-i4874436252.html",
        "sold": 0
    },
    {
        "product_name": "JD JINFENG JD SOLAR LIGHT LED รุ่นใหม่ JD-L เปลือกอลูมิเนียม ไฟโซล่าเซลล์พลังงานแสงอาทิตย์  ใช้พลังงานแสงอาทิตย์100% JD โคมไฟสนาม โคมไฟสปอร์ตไลท์ โคมไฟโซล่าเซลล์ แผงโซล่าเซลล์ ไฟ LED รับประกัน 3 ปี",
        "product_image": "https://img.lazcdn.com/g/p/9e5475edc9a5daac68ec7e9a72bcb9d3.png_200x200q90.png",
        "price": 3683.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5397700360.html",
        "sold": 1
    },
    {
        "product_name": "intelamp | ไฟถนน LED โซลาร์เซลล์ขนาดใหญ่สำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S04ad1fb8185b4a3a949141249cc687f82.jpg_200x200q90.jpg",
        "price": 3666.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5993092755.html",
        "sold": 48
    },
    {
        "product_name": "18 10W 4-in-1 โคมไฟติดผนังไม่กันน้ำโคมไฟสปอตไลท์พื้นหลังแต่งงาน/ไฟตกแต่งในร่มและกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/8aafbcf03cf35ee2654320fbdc3619fc.png_200x200q90.png",
        "price": 3522.6,
        "remark": "https://www.lazada.co.th/products/pdp-i4299789398.html",
        "sold": 15
    },
    {
        "product_name": "HEIKESZ เสาไฟทองแดงโคมไฟผนังกันน้ำพลังงานแสงอาทิตย์สำหรับกลางแจ้งสำหรับประตูวิลลาลานสวน",
        "product_image": "https://img.lazcdn.com/g/p/f66f712634e57daf35540062f7a7cc8f.jpg_200x200q90.jpg",
        "price": 3638.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16098460327.html",
        "sold": 0
    },
    {
        "product_name": "wall washer light solar  โคมไฟติดผนังโซล่าเซลล์ คุณภาพสูง โคมไฟติดผนัง โคมไฟติดผนัง LED (ระดับการป้องกัน IP65)",
        "product_image": "https://img.lazcdn.com/g/p/e458e39534856a3ccea543612491c49d.png_200x200q90.png",
        "price": 3610,
        "remark": "https://www.lazada.co.th/products/pdp-i16097979620.html",
        "sold": 5
    },
    {
        "product_name": "wall washer light solar โคมไฟติดผนัง LED พลังงานแสงอาทิตย์ ไฟติดผนังภายนอก IP65  คุณภาพสูง โคมไฟติดผนัง",
        "product_image": "https://img.lazcdn.com/g/p/999ae7b6bf7e235197f13f65287508d1.png_200x200q90.png",
        "price": 3610,
        "remark": "https://www.lazada.co.th/products/pdp-i16097052929.html",
        "sold": 5
    },
    {
        "product_name": "MODI ไฟสปอตไลท์โซล่าเซลล์ แสงเหลือง 50W200W300W400W IP65 พลังงานแสงอาทิตย์ ส่องป้ายโฆษณา รีโมทคอนโทรล คุณภาพสูง",
        "product_image": "https://img.lazcdn.com/g/p/8322cca44e69701ad836c283a2eea557.jpg_200x200q90.jpg",
        "price": 3600,
        "remark": "https://www.lazada.co.th/products/pdp-i4990002736.html",
        "sold": 147
    },
    {
        "product_name": "SL LIGHTING | Outdoor Wall Lamp โคมไฟติดผนังภายนอก LED 30W 3000K (แสงวอร์ม) IP54  รุ่น MINTRA-30W30K",
        "product_image": "https://img.lazcdn.com/g/p/2ae809d3d51aa20f31f8a1502bb34c72.png_200x200q90.png",
        "price": 3600,
        "remark": "https://www.lazada.co.th/products/pdp-i5368909721.html",
        "sold": 6
    },
    {
        "product_name": "โคมสปอตไลท์ LED 100w กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/46f43ab22649985f199a50730d276444.jpg_200x200q90.jpg",
        "price": 3600,
        "remark": "https://www.lazada.co.th/products/pdp-i402178834.html",
        "sold": 1
    },
    {
        "product_name": "SL LIGHTING | FIORE Series โคมไฟติดผนังภายนอกและโคมไฟเสาสนาม LED รุ่น FIORE-12W",
        "product_image": "https://img.lazcdn.com/g/p/baddba4b6b5c84908ccd410c91448028.png_200x200q90.png",
        "price": 3600,
        "remark": "https://www.lazada.co.th/products/pdp-i5367323982.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟโซล่าเซลล์UFO รุ่น TSM-2200  ควบคุมด้วยรีโมท กำลังไฟ 2200W โคมไฟ โซล่าเซลล์",
        "product_image": "https://img.lazcdn.com/g/p/e7d7a028aaeb6b1c2b8f2fa278944908.jpg_200x200q90.jpg",
        "price": 3599.94,
        "remark": "https://www.lazada.co.th/products/pdp-i4738390865.html",
        "sold": 3
    },
    {
        "product_name": "WELLUX โคมไฟถนนพลังงานแสงอาทิตย์ 100W 200W 300W แสงขาว แสงวอร์ม LED Solar Street Light",
        "product_image": "https://img.lazcdn.com/g/p/c438cc3c7fc736eae912c493789a339c.png_200x200q90.png",
        "price": 3598,
        "remark": "https://www.lazada.co.th/products/pdp-i2385379193.html",
        "sold": 5
    },
    {
        "product_name": "JD 300W ( รุ่นใหม่ล่าสุด) JD-8300L สปอร์ตไลท์ พลังงานแสงอาทิตย์ พร้อมรีโมทควบคุมระยะไกล JD Solar Flood Light แผงโซล่าเซล โคมไฟโซล่าเซล",
        "product_image": "https://img.lazcdn.com/g/p/536beaeec791fffd9e8b351ae40f8555.jpg_200x200q90.jpg",
        "price": 3598,
        "remark": "https://www.lazada.co.th/products/pdp-i1155064871.html",
        "sold": 240
    },
    {
        "product_name": "JD-82000L 2000W JD SOLAR LIGHT LED รุ่นใหม่ JD-L ใช้พลังงานแสงอาทิตย์100% โคมไฟสนาม ไฟโซล่าร์เซลล์JDแท้ โคมไฟสปอร์ตไลท์ โคมไฟโซล่าเซลล์ แผงโซล่าเซลล์ ไฟLED รับประกัน 3 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1af9c2afbb2a439c86f6f65a27b95778a.png_200x200q90.png",
        "price": 3598,
        "remark": "https://www.lazada.co.th/products/pdp-i5474127878.html",
        "sold": 0
    },
    {
        "product_name": "รุ่นใหม่ล่าสุด UFO ไฟหัวเสาโซลาร์เซลล์ แสงขาว 1344LED สว่าง 360 องศา กันน้ำ IP67 ใช้พลังงานแสงอาทิตย์100% รับประกัน1ปี",
        "product_image": "https://img.lazcdn.com/g/p/59f07407783350bf3be7018d622e809a.jpg_200x200q90.jpg",
        "price": 3598,
        "remark": "https://www.lazada.co.th/products/pdp-i4814614666.html",
        "sold": 0
    },
    {
        "product_name": "JD JINDIAN เเท้ โคมไฟหัวเสา UFO 500,000W โซล่าเซลล์ Solar Light  ไฟจานบิน พลังงานแสงอาทิตย์ รับประกัน1ปี",
        "product_image": "https://img.lazcdn.com/g/p/5bb5a781ebc328def1072e3d3ab6719e.jpg_200x200q90.jpg",
        "price": 3598,
        "remark": "https://www.lazada.co.th/products/pdp-i4909343751.html",
        "sold": 5
    },
    {
        "product_name": "สปอร์ตไลท์โซล่าเซลล์ 1000w 2000w 3000w ไฟสนามโซล่าเซลล์ ไฟถนนโซล่าเซลล์  ตัวใหญ่ ไฟสว่างจ้า ไฟสวน บ้านสวน วัด",
        "product_image": "https://img.lazcdn.com/g/p/6207ceb72781f9dbcf56e67ee11a08a5.png_200x200q90.png",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i3421550612.html",
        "sold": 13
    },
    {
        "product_name": "โคมไฟถนน💥รุ่นใหม่💥ไฟโซล่าเซลล์ ไฟถนนโซล่าเซล 3000W 2000W 1000W JDแท้ ไฟแสงอาทิตย์ โคมไฟโซล่าเซลล์ solar light IP 67 สปอตไลท์ รับประกันสินค้า2ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0502bcd55e0f409e98e09d8ba46eb23eF.png_200x200q90.png",
        "price": 3563.86,
        "remark": "https://www.lazada.co.th/products/pdp-i4964176292.html",
        "sold": 77
    },
    {
        "product_name": "EVE โคมฟลัดไลท์ สปอร์ตไลท์ โคมไฟสปอร์ตไลท์ LED 400W 34,000lm IP66 กันน้ำกันฝุ่น แสงขาว ทรงใหม่ สลิมกว่าแต่สว่างกว่าเดิม สินค้ามีประกัน",
        "product_image": "https://img.lazcdn.com/g/p/d99358512d9b9d4079236fe2ba506a1e.jpg_200x200q90.jpg",
        "price": 3560,
        "remark": "https://www.lazada.co.th/products/pdp-i4951171672.html",
        "sold": 1
    },
    {
        "product_name": "สปอตไลท์ ไฟโซล่าเซลล์ Solar LED 300W โซล่าเซลล์ รุ่นJD-7300 Light",
        "product_image": "https://img.lazcdn.com/g/p/91ab2224169ff289345aa8d7416e0613.jpg_200x200q90.jpg",
        "price": 3560,
        "remark": "https://www.lazada.co.th/products/pdp-i2705051039.html",
        "sold": 12
    },
    {
        "product_name": "LAMPTAN โคมไฟถนนพลังงานแสงอาทิตย์ Solar Streetlight รุ่นShinic พร้อมเซ็นเซอร์ความสว่างและความเคลื่อนไหว",
        "product_image": "https://img.lazcdn.com/g/p/7ffd8cf3738450862390e05c0e1c7d13.png_200x200q90.png",
        "price": 3538,
        "remark": "https://www.lazada.co.th/products/pdp-i5027883409.html",
        "sold": 4
    },
    {
        "product_name": "MODI โคมไฟถนนสวมเสาโซล่าเซลล์ ไฟภายนอกอาคาร ไฟถนน ไฟUFO 300W สวมเสา 3 นิ้ว พลังงานแสงอาทิตย์ Solar street light IP65",
        "product_image": "https://img.lazcdn.com/g/p/2c5c144c28e21da76dc3e5198d7a3530.jpg_200x200q90.jpg",
        "price": 3504.88,
        "remark": "https://www.lazada.co.th/products/pdp-i4267882351.html",
        "sold": 29
    },
    {
        "product_name": "ไฟสปอตไลท์โซล่าเซลล์ 200 W. รุ่น Modi x XML ไซต์ใหญ่ (เเสง : ขาว) ไฟสปอตไลท์ ไฟโซล่าเซลล์ สปอตไลท์โซล่าเซลล์",
        "product_image": "https://img.lazcdn.com/g/p/a121093dd1f1b8a87202b288ab639309.jpg_200x200q90.jpg",
        "price": 3500,
        "remark": "https://www.lazada.co.th/products/pdp-i461770525.html",
        "sold": 77
    },
    {
        "product_name": "ไฟโซล่าเซลล์ UFO JD 200,000W 988 LED แสงขาว-แสงเหลือง 5 ทิศทาง ไฟสนาม ไฟพลังงานแสงอาทิตย์ ไฟถนน ไม่รวมเสา JDแท้",
        "product_image": "https://img.lazcdn.com/g/p/e700ae5494780a3370e26c246eef1758.jpg_200x200q90.jpg",
        "price": 3498,
        "remark": "https://www.lazada.co.th/products/pdp-i2808074855.html",
        "sold": 513
    },
    {
        "product_name": "โคมไฟถนน LED ENRICH รุ่นใหม่ FAMOUS ขนาด 100W-250W มีระบบป้องกันไฟกระชาก กันน้ำ แสงขาว แสงเหลือง ไฟส่องถนน ไฟ led",
        "product_image": "https://img.lazcdn.com/g/p/b55230030bf88f48101dc653c06ad205.jpg_200x200q90.jpg",
        "price": 3488,
        "remark": "https://www.lazada.co.th/products/pdp-i5564118365.html",
        "sold": 1
    },
    {
        "product_name": "JD-Jindian แท้ 300W (รุ่นใหม่ล่าสุด) JD-8300L สปอร์ตไลท์ พลังงานแสงอาทิตย์ พร้อมรีโมทควบคุมระยะไกล รับประกัน 6เดือน",
        "product_image": "https://img.lazcdn.com/g/p/f4b0b3823767302d1d84ab65473a9cd0.jpg_200x200q90.jpg",
        "price": 3481.42,
        "remark": "https://www.lazada.co.th/products/pdp-i4101512497.html",
        "sold": 81
    },
    {
        "product_name": "🔥ซื้อ1แถม1🔥ไฟถนนโซล่าเซลล์ 50000W ไฟถนนรีโมทคอนโทรล ไฟถนน โคมไฟติดผนัง Solar Light ไฟสปอตไลท์ ไฟโซล่าเซลล์ กันฝนกันฟ้าผ่า สว่างขึ้นโดย อัตโนมัติtในที่มืด",
        "product_image": "https://img.lazcdn.com/g/p/96a998af180bb65230710562fcf087cd.jpg_200x200q90.jpg",
        "price": 3478,
        "remark": "https://www.lazada.co.th/products/pdp-i5738450083.html",
        "sold": 2
    },
    {
        "product_name": "🔥ซื้อ 1 แถม 1🔥 ไฟโซล่าเซลล์ 110000W โซล่าเซลล์ ไฟสว่างมาก ไฟโซล่าเซล กันน้ำ สว่างอัตโนมัติเมื่อฟ้ามืด",
        "product_image": "https://img.lazcdn.com/g/p/659e7f047f16de2af2e5fe1b064594c3.jpg_200x200q90.jpg",
        "price": 3466,
        "remark": "https://www.lazada.co.th/products/pdp-i5033146197.html",
        "sold": 1534
    },
    {
        "product_name": "NeoX โคมไฟถนน LED แสงขาวและแสงวอร์ม ขนาด 30W 50W 100W 150W และ 200W รุ่น METRO NEOX สว่างขั้นเทพ 130lm/W โคมภายนอกอาคาร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd654c45331ae4e6db269252ae4c58d0eb.jpg_200x200q90.jpg",
        "price": 3458,
        "remark": "https://www.lazada.co.th/products/pdp-i3865052194.html",
        "sold": 41
    },
    {
        "product_name": "โคมไฟถนน UFO ไฟโซล่าเซลล์ LED แสงขาว 2300W สว่างถึงเช้า ไฟสนาม ไฟถนน โซล่าเซลล์ โคมไฟ รุ่น TSM-2300",
        "product_image": "https://img.lazcdn.com/g/p/a13b4ca8467d160786260390c3529099.jpg_200x200q90.jpg",
        "price": 3452,
        "remark": "https://www.lazada.co.th/products/pdp-i5815800083.html",
        "sold": 2
    },
    {
        "product_name": "HACO SOLAR WALL LIGHT ไฟส่องสว่างจากโซลาร์เซลล์สำหรับติดผนัง IP54 รุ่น HACO-SWL-12",
        "product_image": "https://img.lazcdn.com/g/p/2b6c6d554c977e123e35a82aaf7bf48a.png_200x200q90.png",
        "price": 3450,
        "remark": "https://www.lazada.co.th/products/pdp-i5306938622.html",
        "sold": 0
    },
    {
        "product_name": "RANDY ไฟโซล่าเซลล์ Top of All in 1 รุ่น Space Light 800W 2550LM 30AH 1200W 3840LM 45AH ไฟถนนโซล่าเซลล์ ไฟถนน โซล่าเซลล์",
        "product_image": "https://img.lazcdn.com/g/p/fc8a65fd733d1e30c535bff7359b0df8.jpg_200x200q90.jpg",
        "price": 3420,
        "remark": "https://www.lazada.co.th/products/pdp-i5631300429.html",
        "sold": 6
    },
    {
        "product_name": "BINGO 1 แถม 1 ไฟถนนโซล่าเซลล์ ไฟโซล่าเซลล์ 3000W ไฟภายนอกอาคาร หลอดไฟ LED โซ่ล่าเซลล์ Solar Street Light แสงสีขาว กันน้ำIP67 โคมไฟติดผนังโซล่าเซลล์",
        "product_image": "https://img.lazcdn.com/g/p/fe0879636d2421a77b89b6343dd9d748.png_200x200q90.png",
        "price": 3416.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16124499138.html",
        "sold": 0
    },
    {
        "product_name": "KKSKY ไฟถนนโซล่าเซลล์ 1000W 2000W 3000W ไฟโซล่าเซลล์ หลอดไฟ LED แสงสีขาว IP67กันน้ำ ไฟภายนอกอาคาร โซล่าเซลล์ รีโมทคอนโทรล Solar street light",
        "product_image": "https://img.lazcdn.com/g/p/f979572688ecf2fa48526158704f8c9f.png_200x200q90.png",
        "price": 3416.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16123091531.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟติดผนังกลางแจ้งแบบกันน้ำสำหรับบ้านพักชั่วคราวสไตล์ยุโรปแบบเรโทรสำหรับทางเดินในสวนหน้าบ้านและรั้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S335a07ba4bc747f1ae97504d208955cdm.png_200x200q90.png",
        "price": 3406.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5837311004.html",
        "sold": 0
    },
    {
        "product_name": "✨โซล่าเซลล์ ไฟสายยาง ✨300ดวง ยาว10m ประดับตกแต่งติดตั้งได้ทั้งในและนอกอาคาร (IP67) ทนแดด ทนฝน （ไฟโซล่าเซลล์ LED แผงพลังงานแสงอาทิตย์ไฟสาย Led ไ",
        "product_image": "https://img.lazcdn.com/g/p/d9a4c240dbf51a63225b0ac2d57789eb.jpg_200x200q90.jpg",
        "price": 3398,
        "remark": "https://www.lazada.co.th/products/pdp-i4809241004.html",
        "sold": 139
    },
    {
        "product_name": "JD-8650L 650W JD SOLAR LIGHT LED รุ่นใหม่ JD-L ใช้พลังงานแสงอาทิตย์100% โคมไฟสนาม โคมไฟสปอร์ตไลท์ โคมไฟโซล่าเซลล์ แผงโซล่าเซลล์ ไฟLED รับประกัน 3 ปี",
        "product_image": "https://img.lazcdn.com/g/p/60a3eac40217208f3a373dd3fcf0a8cd.png_200x200q90.png",
        "price": 3398,
        "remark": "https://www.lazada.co.th/products/pdp-i3462543192.html",
        "sold": 4
    },
    {
        "product_name": "Solar 1000W Honor Solar FloodLight ไฟโซลาร์เซล 1000วัตต์รุ่น JT-RY-1000W กันน้ำIP66",
        "product_image": "https://img.lazcdn.com/g/p/f5436a0b2a88ad0de80b133e5dd6bca6.jpg_200x200q90.jpg",
        "price": 3398,
        "remark": "https://www.lazada.co.th/products/pdp-i5698587886.html",
        "sold": 2
    },
    {
        "product_name": "MODI ไฟสปอตไลท์โซล่าเซลล์ 60W120W240W360W สายยาว5M แสงขาว IP65 พลังงานแสงอาทิตย์ ส่องป้ายโฆษณา รีโมทคอนโทรล คุณภาพสูง",
        "product_image": "https://img.lazcdn.com/g/p/777e240e96a761730bc74a0baa5f8ba3.jpg_200x200q90.jpg",
        "price": 3398,
        "remark": "https://www.lazada.co.th/products/pdp-i5607676150.html",
        "sold": 126
    },
    {
        "product_name": "PopLight LED Garden Light ไฟหัวเสา220v กำลังไฟ100W แสงไฟสีขาว6500K กันน้ำไฟส่องทางเดิน ไฟส่องถนน ไฟตกแต่งสวน",
        "product_image": "https://img.lazcdn.com/g/p/90a967dc9bc0ce6764e623dd149b856f.jpg_200x200q90.jpg",
        "price": 3398,
        "remark": "https://www.lazada.co.th/products/pdp-i5155994617.html",
        "sold": 0
    },
    {
        "product_name": "ไฟถนนโซล่าเซลล์ พลังงานแสงอาทิตย์ UFO Solar Light 200000W ไฟถนนเซลล์สุริยะ 48ช่องแสง ไฟพลังงานแสงอาทิตย์ เซลล์แสงอาทิตย์ ไฟ LED ไฟถนน ไฟเซลล์ส",
        "product_image": "https://img.lazcdn.com/g/p/9343a06b31e94cf15ce02e3422ea8710.png_200x200q90.png",
        "price": 3396,
        "remark": "https://www.lazada.co.th/products/pdp-i5803210280.html",
        "sold": 1
    },
    {
        "product_name": "MODI ไฟถนนโซล่าเซลล์ 300W 400W 500W แสงขาว ระบบสว่างค้าง รีโมทคอนโทรล Solar street light  (แสง : ขาว) daylight กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/785b0718e13197df5315cb4cc2dad32d.jpg_200x200q90.jpg",
        "price": 3393.72,
        "remark": "https://www.lazada.co.th/products/pdp-i4921690411.html",
        "sold": 59
    },
    {
        "product_name": "JD🔥รุ่นล่าสุด🔥【รับประกัน30ปี】แท้100% ไฟถนนโซล่าเซลล์ ไฟโซล่าเซลล์  สปอตไลท์โซล่า ไฟโซล่าเซล ไฟถนน LED ไฟถนนโซลาร์เซลล์ ไฟถนนแบบบูรณาการ IP67กันน้ำ พร้อมรีโมท กินไฟน้อย โคมไฟโซล่าเซลล์ solar light outdoor ไฟแสงอาทิตย์ ไฟพลังงานแสงอาทิตย์ Solar Light",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4d9167fd04ba4c379e466c2b671817a11.png_200x200q90.png",
        "price": 3390,
        "remark": "https://www.lazada.co.th/products/pdp-i5224427813.html",
        "sold": 2
    },
    {
        "product_name": "🔥รุ่นล่าสุด🔥【รับประกัน30ปี】แท้100% ไฟถนนโซล่าเซลล์ ไฟโซล่าเซลล์  สปอตไลท์โซล่า ไฟโซล่าเซล ไฟถนน LED ไฟถนนโซลาร์เซลล์ ไฟถนนแบบบูรณาการ IP67กันน้ำ พร้อมรีโมท กินไฟน้อย โคมไฟโซล่าเซลล์ solar light outdoor ไฟแสงอาทิตย์ ไฟพลังงานแสงอาทิตย์ Solar Light",
        "product_image": "https://img.lazcdn.com/g/p/d187a712f698900716078decbd59f8d7.png_200x200q90.png",
        "price": 3390,
        "remark": "https://www.lazada.co.th/products/pdp-i5211781542.html",
        "sold": 0
    },
    {
        "product_name": "NEW ไฟถนนโซล่าเซลล์ ไฟโซล่าเซลล์  สปอตไลท์โซล่า ไฟโซล่าเซล ไฟถนน LED ไฟถนนโซลาร์เซลล์ ไฟถนนแบบบูรณาการ IP67กันน้ำ พร้อมรีโมท กินไฟน้อย โคมไฟโซล่าเซลล์ solar light outdoor ไฟแสงอาทิตย์ ไฟพลังงานแสงอาทิตย์ Solar Light",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb59b568e31be4000aaba54de5bb43cf7a.png_200x200q90.png",
        "price": 3390,
        "remark": "https://www.lazada.co.th/products/pdp-i5336111507.html",
        "sold": 0
    },
    {
        "product_name": "Solar Light 10000W LED ไฟถนนโซล่าเซลล์ ไฟโซล่าเซลล์ ไฟถนนโซล่าเซล ไฟโซล่าเซล ไฟสปอตไลท์ โคมไฟถนนโซล่าเซลล์ ไฟถนน โคมไฟถนนโซล่าเซล โคมไฟติดผนัง โคมไฟโซล่าเซล โซล่าเซลไฟบ้าน โคมไฟสปอร์ตไลท์ ไฟโซล่าเซลถนน สุดๆ พลังสูง โคมไฟโซลาเซลล์ ไฟสวน ไฟถนน",
        "product_image": "https://img.lazcdn.com/g/p/8dbe113ee9a089d3c83c43e5271047bf.png_200x200q90.png",
        "price": 3390,
        "remark": "https://www.lazada.co.th/products/pdp-i5336320311.html",
        "sold": 2
    },
    {
        "product_name": "💥จัดส่งเร็ว💥 ไฟถนนโซล่าเซลล์ 150000W ไฟโซล่าเซลล์ โคมไฟถนนโซล่าเซลล์ กันน้ำและกันฟ้าผ่ ไฟ LED โซล่าเซลล์ พร้อมขาตั้งและรีโมท แสงสีขาว",
        "product_image": "https://img.lazcdn.com/g/p/c68c2cac5fbc0904720cb281ed027c74.jpg_200x200q90.jpg",
        "price": 3386,
        "remark": "https://www.lazada.co.th/products/pdp-i5399019972.html",
        "sold": 1214
    },
    {
        "product_name": "ไฟโซล่าเซลล์ 300W ไฟถนนแผงแยก ไไฟสปอร์ตไลท์ LED 300W JD-66300 แสงสีขาว ไฟ 6 ช่อง กันน้ำ Spotlight Led ไฟโชล่าเซลล์ โคมไฟสปอร์ตไลท์ โคมไฟโซล่าเซล",
        "product_image": "https://img.lazcdn.com/g/p/1c47ad16f4a0e1583ec0678de4b11337.jpg_200x200q90.jpg",
        "price": 3386,
        "remark": "https://www.lazada.co.th/products/pdp-i600740395.html",
        "sold": 35
    },
    {
        "product_name": "โคมไฟถนนโซล่าเซลล์ UFO ทรงกลมแถบเหลือง รุ่น MODI x XML 300W + Motion Sensor (แสง : ขาว) ไฟถนน",
        "product_image": "https://img.lazcdn.com/g/p/d0878c4492fdb429c9cb4be0398e81c8.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i5968008677.html",
        "sold": 0
    },
    {
        "product_name": "สปอตต์ไลท์ Spotlight LEDflood light ไฟส่องตึกไฟส่องป้ายไฟส่องนามCOB ถูกที่สุด กันน้ำ กันฝน น น้ำหนักเบา 100W 200W 300W",
        "product_image": "https://img.lazcdn.com/g/p/1a887cded16c6b0405ed6cc8db49c225.jpg_200x200q90.jpg",
        "price": 3358,
        "remark": "https://www.lazada.co.th/products/pdp-i4413457120.html",
        "sold": 20
    },
    {
        "product_name": "ไฟสปอตไลท์โซล่าเซลล์ 80 W. รุ่น Modi x XML (เเสง : ขาว) (1 เเถม 1) ไฟสปอตไลท์ ไฟโซล่าเซลล์ สปอตไลท์โซล่าเซลล์ สปอตไลท์",
        "product_image": "https://img.lazcdn.com/g/p/de4610708160902ac3f7f050d440f0a9.jpg_200x200q90.jpg",
        "price": 3354.64,
        "remark": "https://www.lazada.co.th/products/pdp-i809952792.html",
        "sold": 112
    },
    {
        "product_name": "KKSKY ไฟโซล่าเซลล์ โซล่าเซลล์ 50000w 100000w 500000w 800000w IP67 Solar Light ไฟสปอตไลท์ โซลา ไฟโซล่าเซลสนาม โซล่าเซลสปอตไลท์ สปอร์ตไลท์ solar cell",
        "product_image": "https://img.lazcdn.com/g/p/03b688dac789782aef0dbb7f2dcbee06.jpg_200x200q90.jpg",
        "price": 3350.7,
        "remark": "https://www.lazada.co.th/products/pdp-i3931786301.html",
        "sold": 1890
    },
    {
        "product_name": "EVE โคมฟลัดไลท์ โซล่าเซลล์ แอลอีดี LED รุ่น OSCAR กันน้ำกันฝุ่น IP67 ขนาด 200W 500W 800W",
        "product_image": "https://img.lazcdn.com/g/p/a1dc642054bbccc3ffcdadd63c0845f1.png_200x200q90.png",
        "price": 3344,
        "remark": "https://www.lazada.co.th/products/pdp-i5892485015.html",
        "sold": 28
    },
    {
        "product_name": "Daiwa | รอกตกปลาไฟฟ้าสำหรับทะเลลึก เรือ และปลาใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S182aec5b785b4f15b90bff3eadbdadc9Q.png_200x200q90.png",
        "price": 72033.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6003392400.html",
        "sold": 0
    },
    {
        "product_name": "HELIX | กระเป๋ากอล์ฟ แข็งทนน้ำและแรงกด ใช้ได้ทั้งถือขึ้นเครื่องและโหลดใต้ท้องเครื่อง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb5b472f8b4f6449dbb83797fdc9ab77el.jpg_200x200q90.jpg",
        "price": 55446.04,
        "remark": "https://www.lazada.co.th/products/pdp-i6031788899.html",
        "sold": 1
    },
    {
        "product_name": "Megabass | ไม้ตกปลาหลายประโยชน์สำหรับเหยื่อแข็ง ปลาเปรช ปลาแบส และการขว้างไกล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S166725010aee4eb99c9244a3ed27b253t.jpg_200x200q90.jpg",
        "price": 52907.96,
        "remark": "https://www.lazada.co.th/products/pdp-i6003419180.html",
        "sold": 0
    },
    {
        "product_name": "Garmin | นาฬิกาสปอร์ตวัดระยะทางกอล์ฟ ตรวจสอบสุขภาพ สำหรับวิ่งและออกกำลังกาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc54d8ec5d98d4c4980f40b39ec8940c0r.jpg_200x200q90.jpg",
        "price": 45068,
        "remark": "https://www.lazada.co.th/products/pdp-i16068928540.html",
        "sold": 0
    },
    {
        "product_name": "Shimano | รอกตกปลาสำหรับน้ำจืดและน้ำเค็ม ใช้กับอุปกรณ์เบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6e79710b79f7439db427955b7068f55cN.jpg_200x200q90.jpg",
        "price": 41959.66,
        "remark": "https://www.lazada.co.th/products/pdp-i6003433156.html",
        "sold": 0
    },
    {
        "product_name": "Shimano | วงล้อตกปลาแสดงผลดิจิตอล200 /300PG /HG /MG /XG",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2e5ac7bb033e485c9a20073cb139f289y.jpg_200x200q90.jpg",
        "price": 41442.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6003352665.html",
        "sold": 3
    },
    {
        "product_name": "Garmin | นาฬิกาวิ่งและฟิตเนส วัดระยะทางกอล์ฟ และติดตามสุขภาพ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S98132069f2f946519816ab037c1ea7f3v.png_200x200q90.png",
        "price": 41301,
        "remark": "https://www.lazada.co.th/products/pdp-i16106012064.html",
        "sold": 0
    },
    {
        "product_name": "Garmin | นาฬิกาฝึกซ้อมกอล์ฟอัจฉริยะ แผนที่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saf15593bc7b14cb2afe410d0db37e229q.jpg_200x200q90.jpg",
        "price": 40901.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16050366714.html",
        "sold": 0
    },
    {
        "product_name": "รอกหยดน้ำ Shimano - Antares 2025",
        "product_image": "https://img.lazcdn.com/g/p/fb90a158e1991c4301914f26c9c2c8f8.jpg_200x200q90.jpg",
        "price": 35800,
        "remark": "https://www.lazada.co.th/products/pdp-i5834836658.html",
        "sold": 0
    },
    {
        "product_name": "[🚚จัดส่งไว]  Garmin Approach Z82 Golf Rangefinder(Black)[Thai Manual]",
        "product_image": "https://img.lazcdn.com/g/p/93300ffd8360c98aba746a31dde59e75.png_200x200q90.png",
        "price": 35800,
        "remark": "https://www.lazada.co.th/products/pdp-i5366971177.html",
        "sold": 0
    },
    {
        "product_name": "GARMIN APPROACH G80 (ลดถึง21 พ.ย.เท่านั้น) เครื่อง LAUNCH MONITOR ระดับพรีเมี่ยม พร้อมระบบ GPS Distributed By KASCO",
        "product_image": "https://img.lazcdn.com/g/p/dcdd41f95e7e754d6e29f7221748e55a.png_200x200q90.png",
        "price": 35380,
        "remark": "https://www.lazada.co.th/products/pdp-i2583160866.html",
        "sold": 4
    },
    {
        "product_name": "รอกหยดน้ำ Shimano - Aldebaran DC 2025",
        "product_image": "https://img.lazcdn.com/g/p/4b7be42399d60c9ceae221184984ac09.jpg_200x200q90.jpg",
        "price": 31800,
        "remark": "https://www.lazada.co.th/products/pdp-i5834831825.html",
        "sold": 2
    },
    {
        "product_name": "[🚚จัดส่งไว] GARMIN Approach Z80 Golf Rangefinder[Thai Manual]",
        "product_image": "https://img.lazcdn.com/g/p/022c5db98e17b2822120392b8149ef1b.png_200x200q90.png",
        "price": 29600,
        "remark": "https://www.lazada.co.th/products/pdp-i5491482869.html",
        "sold": 0
    },
    {
        "product_name": "คัน Shimano Cardiff NATIVE Special",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd1695181ffc94751b53374d477f3d00ei.jpg_200x200q90.jpg",
        "price": 26580,
        "remark": "https://www.lazada.co.th/products/pdp-i5824417096.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟเอนกประสงค์น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S919b9fbb2bf447ca89b0ce49627063e1A.jpg_200x200q90.jpg",
        "price": 25258.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16055249142.html",
        "sold": 0
    },
    {
        "product_name": "ไม้เบ็ดตกปลาทะเลคาร์บอนน้ำหนักเบา สำหรับตกปลาด้วยเหยื่อปลอมและขว้างไกล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S20ce3d23aee645ddb18083a0db7100f8M.jpg_200x200q90.jpg",
        "price": 21374.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6003446121.html",
        "sold": 0
    },
    {
        "product_name": "Shimano | รอกตกปลาทะเลแบบสปินนิ่ง ปรับความเร็วสูง-ต่ำได้ COMPLEX CI4+ XR",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S239eb8402def497791300644d9f8e1b3k.jpg_200x200q90.jpg",
        "price": 21370.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6003377966.html",
        "sold": 3
    },
    {
        "product_name": "Tailwalk | รีลตกปลาขนาดใหญ่ระยะไกลเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5f31c6e172854a72a7c54ab72d9cf593W.jpg_200x200q90.jpg",
        "price": 21109.26,
        "remark": "https://www.lazada.co.th/products/pdp-i6003165857.html",
        "sold": 0
    },
    {
        "product_name": "รอกสปิน DAIWA BALLISTIC AIR\n2025",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7a01d66193b146a88d1a519f7c1a24b4s.jpg_200x200q90.jpg",
        "price": 17980,
        "remark": "https://www.lazada.co.th/products/pdp-i5882482662.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | ไม้กอล์ฟสำหรับการแข่งขันของผู้ชาย 2 หรือ 3 เหล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se438c80cbf8f4948a681c727a1d35f830.jpg_200x200q90.jpg",
        "price": 17846.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16055382149.html",
        "sold": 2
    },
    {
        "product_name": "TAILWALK|ไม้เบ็ดสปินนิ่งปลายแข็งสำหรับปลาเล็ก AJIST SD S68/SL  AJIST SD S510/SL",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9b2a88e74df94406bb2eed656270a7ddc.jpg_200x200q90.jpg",
        "price": 17071.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6003376485.html",
        "sold": 0
    },
    {
        "product_name": "13Fishing|รอกเบทแคสติงระบบเบรกคู่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se7ec17f71e8943008eaf7454c2b723e1V.jpg_200x200q90.jpg",
        "price": 16001.28,
        "remark": "https://www.lazada.co.th/products/pdp-i6003324942.html",
        "sold": 0
    },
    {
        "product_name": "TaylorMade | กระเป๋าเดินทางสำหรับกอล์ฟขนาดใหญ่พกพาสะดวก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4a7c7d69595d45c1bffd15631abc426fj.jpg_200x200q90.jpg",
        "price": 15450.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16054158823.html",
        "sold": 0
    },
    {
        "product_name": "รอกหยดน้ำ ชิมาโน่ SHIMANO CURADO 150/151 HG และ XG ปี 2025 (มีทั้งหมุนขวาและหมุนซ้าย)",
        "product_image": "https://img.lazcdn.com/g/p/31cb95f37d12c6f69c0ce5c9aeb58afc.jpg_200x200q90.jpg",
        "price": 14200,
        "remark": "https://www.lazada.co.th/products/pdp-i6040411211.html",
        "sold": 0
    },
    {
        "product_name": "pgm | เคสแข็งป้องกันแรงสำหรับการเดินทางกอล์ฟ",
        "product_image": "https://img.lazcdn.com/3rd/q/aHR0cHM6Ly9hZS1waWMtYTEuYWxpZXhwcmVzcy1tZWRpYS5jb20va2YvUzA0YjA4MjA1N2IzYzRkNDFiMWNhOWZmZjc0YjFhNjc1ZS5wbmc=_200x200q90.png",
        "price": 13979.46,
        "remark": "https://www.lazada.co.th/products/pdp-i6066706617.html",
        "sold": 0
    },
    {
        "product_name": "SALOMON ADV SKIN 12 เป้น้ำ สำหรับวิ่งเทรล ความจุ 12ลิตร น้ำหนักเบา มีช่องเก็บของเยอะ มาพร้อมนกหวีดและขวดนิ่ม 2 ขวด",
        "product_image": "https://img.lazcdn.com/g/p/adc9d44549ebb1d770e2b1ae18009914.jpg_200x200q90.jpg",
        "price": 13780,
        "remark": "https://www.lazada.co.th/products/pdp-i6065332163.html",
        "sold": 0
    },
    {
        "product_name": "Tailwalk | รอกตกปลาล่อปลาใหญ่ ดึงช้าและเร็ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9e77945e5f154f0caee1d9f26ece7249m.jpg_200x200q90.jpg",
        "price": 13692.76,
        "remark": "https://www.lazada.co.th/products/pdp-i6003331274.html",
        "sold": 0
    },
    {
        "product_name": "Daiwa | รอกตกปลาแบบยาวสำหรับปลาหมึก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdacad9c865af49da878d8bed20e35f62V.jpg_200x200q90.jpg",
        "price": 13365.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6003267444.html",
        "sold": 0
    },
    {
        "product_name": "รอกตกปลาในน้ำจืดและน้ำเค็มแบบดรอปช็อต",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S00098ae7d4c845ea93ea2d0276d9cdf1e.jpg_200x200q90.jpg",
        "price": 13211.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6003424145.html",
        "sold": 0
    },
    {
        "product_name": "RAPTOR TACTICAL ทรง WENDY",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa87dcc790a1c47c4b7cc474cc452f184f.jpg_200x200q90.jpg",
        "price": 13206.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16102894896.html",
        "sold": 0
    },
    {
        "product_name": "ชั้นวางถุงกอล์ฟ ชั้นจัดเก็บไม้กอล์ฟ ชั้นโชว์อุปกรณ์กีฬา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf80734ea2159488880fd3af2c21018d13.jpg_200x200q90.jpg",
        "price": 13125.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5927949085.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟมาตรฐานกันน้ำและป้องกันการชน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S42f6d5ba57ff43e7893d988ea14bba11b.jpg_200x200q90.jpg",
        "price": 12735.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6066821258.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟสำหรับทุกเพศ พร้อมที่ยืน 14 ช่อง หลายฟังก์ชันควบคุมอุณหภูมิ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seff053e17ca245488ad5c8b98ee1c994w.jpg_200x200q90.jpg",
        "price": 12692.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16054116499.html",
        "sold": 0
    },
    {
        "product_name": "ชั้นวางเคตเทิลเบล 2 ชั้น แบบ Heavy-Duty | ชั้นวางอุปกรณ์ฟิตเนส แข็งแรง รับน้ำหนักได้เยอะ Kettlebell Rack 2-Tier สำหรับยิมและบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/3408885ccf2a8d03f6b34d05b2150539.jpg_200x200q90.jpg",
        "price": 11800,
        "remark": "https://www.lazada.co.th/products/pdp-i5769221918.html",
        "sold": 2
    },
    {
        "product_name": "เอนเทนนสโกเซน G-Tour 3 220 เมตร รล 1.18 1.23 1.28",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saff000627ca84db6b9f5138bb503c4cas.png_200x200q90.png",
        "price": 11798.62,
        "remark": "https://www.lazada.co.th/products/pdp-i6050969147.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟสำหรับผู้หญิง น้ำหนักเบา กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8cd5fe88795c43b7b0c80c0119347db6L.jpg_200x200q90.jpg",
        "price": 11551.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6003192854.html",
        "sold": 0
    },
    {
        "product_name": "DAIWA | รอกสปินนิ่งเบาและโยนได้ไกล รุ่น Moonlight Beauty X LT ตกปลาทั้งน้ำจืดและน้ำเค็ม เน้นความเบา ลื่น และแม่นยำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa545d6bf7c6a49c0b445f031225b119ad.jpg_200x200q90.jpg",
        "price": 11491.32,
        "remark": "https://www.lazada.co.th/products/pdp-i6003246859.html",
        "sold": 4
    },
    {
        "product_name": "Daiwa | รอกตกปลาอัลตร้าไลท์แบบป้องกันสายพัน",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Sda4cede16b3d408b90a001ddd7b2215ah.jpg_200x200q90.jpg",
        "price": 11323.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6003369286.html",
        "sold": 82
    },
    {
        "product_name": "ถุงกอล์ฟคาราเวย์ Callaway ELYTE Golf bag",
        "product_image": "https://img.lazcdn.com/g/p/eb855f38e8d4860472b76820cbe8d7aa.jpg_200x200q90.jpg",
        "price": 10980,
        "remark": "https://www.lazada.co.th/products/pdp-i5956367673.html",
        "sold": 0
    },
    {
        "product_name": "Ryobi | รอกตกปลาแบบสโลว์จิกกิ้งที่ทำจากโลหะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saf0c7824d2644c838f5b475cb7555d1aC.jpg_200x200q90.jpg",
        "price": 10787.24,
        "remark": "https://www.lazada.co.th/products/pdp-i5974472612.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟมาตรฐานน้ำหนักเบาแบบม้วนได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sce3a41da4e564d24a60a6794bd80f3b2P.jpg_200x200q90.jpg",
        "price": 10572.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16053809715.html",
        "sold": 7
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟ PGM รุ่นพรีเมียม ฐานพับได้ กระเป๋าแม่เหล็ก ช่องเก็บเครื่องดื่มควบคุมอุณหภูมิ กันน้ำ 100%",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S232906cb5df94edaa15b28744e7836252.jpg_200x200q90.jpg",
        "price": 10561.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6003152981.html",
        "sold": 1
    },
    {
        "product_name": "PGM GOLF | กระเป๋าเดินทางกอล์ฟพกพาสำหรับผู้ชาย พร้อมช่องเก็บเครื่องดื่มกันความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9e70cdb604e8458bb69c9eac996e1921t.jpg_200x200q90.jpg",
        "price": 9982.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16055430765.html",
        "sold": 1
    },
    {
        "product_name": "Ultimate Direction Race Vest 6L Unisex เป้น้ำสำหรับนักวิ่งเทรลระยะไกล ความจุ-ช่องเก็บของเยอะ น้ำหนักเบา แห้งเร็ว",
        "product_image": "https://img.lazcdn.com/g/p/a8cd269984d5ca40c002abde3c05ff0d.jpg_200x200q90.jpg",
        "price": 9900,
        "remark": "https://www.lazada.co.th/products/pdp-i5865567413.html",
        "sold": 0
    },
    {
        "product_name": "ถุงกอล์ฟ Titleist Light weight Early 2026 Golf Bag",
        "product_image": "https://img.lazcdn.com/g/p/11e4e53e2085112c790931bedf79807d.jpg_200x200q90.jpg",
        "price": 9581.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5987606739.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋า 골프เบาสำหรับผู้หญิง สไตล์เกาหลี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sde18adf8795d42a38cc7bfb49bfb2fbdg.jpg_200x200q90.jpg",
        "price": 9193.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6003396188.html",
        "sold": 0
    },
    {
        "product_name": "SALOMON ACTIVE SKIN 8 SET เป้น้ำสำหรับวิ่งเทรล ความจุ 8 ลิตร เน้นสบาย คล่องตัว น้ำหนักเบา ระบายอากาศดี แห้งเร็ว",
        "product_image": "https://img.lazcdn.com/g/p/93c5dadfeddf9e3ea04e0dfa21c4ac91.jpg_200x200q90.jpg",
        "price": 9180,
        "remark": "https://www.lazada.co.th/products/pdp-i6065160684.html",
        "sold": 0
    },
    {
        "product_name": "Daiwa | ไม้ตกปลาบนฝั่งสำหรับปลาหิน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb96010509eb34d26ad888eeee81051a6o.jpg_200x200q90.jpg",
        "price": 9084.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6003314959.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟพกพาได้ ที่พับเก็บได้ กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0ec5acd13e8146229c3ee476afa794faO.jpg_200x200q90.jpg",
        "price": 8999.4,
        "remark": "https://www.lazada.co.th/products/pdp-i16053871093.html",
        "sold": 0
    },
    {
        "product_name": "คันตกหมึก Daiwa Emeraldas BT 2024 ของแท้",
        "product_image": "https://img.lazcdn.com/g/p/4b3a73efdde1025b04119aef8d94239f.png_200x200q90.png",
        "price": 8900,
        "remark": "https://www.lazada.co.th/products/pdp-i5400399414.html",
        "sold": 2
    },
    {
        "product_name": "คันตกหมึก Daiwa Emeraldas BT 2024 ของแท้ 100% มีประกัน",
        "product_image": "https://img.lazcdn.com/g/p/19526ca92a4e8475dca60a4dd60c9187.png_200x200q90.png",
        "price": 8900,
        "remark": "https://www.lazada.co.th/products/pdp-i5400358791.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | เครื่องวัดระยะกอล์ฟ Pin-Lock พร้อมสั่นและชดเชยความลาดเอียง 1300 หลา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9561282e79b44989ac8d698737c5c26d2.jpg_200x200q90.jpg",
        "price": 8798.96,
        "remark": "https://www.lazada.co.th/products/pdp-i6003372050.html",
        "sold": 0
    },
    {
        "product_name": "TSU timeless 9 ฟุต เวท 15-30 คันเบ็ดตกปลา คันเบ็ดสปินนิ่ง คันเบ็ดเบท อุปกรณ์ตกปลา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5fe7b409d0f54968b65f7e26b3a7f5d1B.jpg_200x200q90.jpg",
        "price": 8120,
        "remark": "https://www.lazada.co.th/products/pdp-i16084508682.html",
        "sold": 0
    },
    {
        "product_name": "TSU timeless m2. 9 ฟุต คันเบ็ดตกปลา คันเบ็ดสปินนิ่ง คันเบ็ดเบท อุปกรณ์ตกปลา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb6e4e6f4b1c949089dc4d45c2c2b092bg.jpg_200x200q90.jpg",
        "price": 7880,
        "remark": "https://www.lazada.co.th/products/pdp-i16084649310.html",
        "sold": 0
    },
    {
        "product_name": "TSU steel lotus legend master m1. ยาว 10 ฟุต คันเบ็ดตกปลา คันเบ็ดสปินนิ่ง คันเบ็ดเบท อุปกรณ์ตกปลา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc3a5e856bdfb40cc940c3826f3994f51z.jpg_200x200q90.jpg",
        "price": 7640,
        "remark": "https://www.lazada.co.th/products/pdp-i16084607473.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟแบบมีล้อลาก โครงแข็ง 3Dน้ำหนักเบา 4.8 กก. มีที่ใส่หมวก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S914d80265eeb41d5993fee02e6be19c1x.jpg_200x200q90.jpg",
        "price": 7424.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6066553641.html",
        "sold": 0
    },
    {
        "product_name": "[Limited Edition] กระเป๋ากอล์ฟ Snoopy 9“ ทรง Stand Bag ขาตั้งในตัว น้ำหนักเบา แข็งแรง ทนทาน มีให้เลือก 2 สี (ดำ/ขาว)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S68b41113536449b1b84b843f219f831ax.jpg_200x200q90.jpg",
        "price": 7254.06,
        "remark": "https://www.lazada.co.th/products/pdp-i5807968648.html",
        "sold": 2
    },
    {
        "product_name": "Daiwa | รอกสปินนิ่งน้ำเค็มสำหรับการขว้างไกล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S55266836f31d424e91f17efc950b1d94k.jpg_200x200q90.jpg",
        "price": 7138.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6003397882.html",
        "sold": 0
    },
    {
        "product_name": "Ellwewe รอกตกปลาไฟฟ้าแบตเตอรี่รีลมืออาชีพ14.8V สำหรับ200J 500MJ /L 600",
        "product_image": "https://img.lazcdn.com/g/p/3e234363fb2c583eb09a349deecd0291.jpg_200x200q90.jpg",
        "price": 7040,
        "remark": "https://www.lazada.co.th/products/pdp-i5995378377.html",
        "sold": 0
    },
    {
        "product_name": "TSU timeless 8.6 ฟุต เวท 15-30 คันเบ็ดตกปลา คันเบ็ดสปินนิ่ง คันเบ็ดเบท อุปกรณ์ตกปลา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S716a110d2bbc46048fb0ea328a9b46a73.jpg_200x200q90.jpg",
        "price": 6920,
        "remark": "https://www.lazada.co.th/products/pdp-i16084562387.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋า 골프สำหรับผู้หญิงกันน้ำ เบา สายหิ้วคู่ 25 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S16145ac91826439eb4d0ecf032df7331C.jpg_200x200q90.jpg",
        "price": 6903.66,
        "remark": "https://www.lazada.co.th/products/pdp-i6066398954.html",
        "sold": 0
    },
    {
        "product_name": "Srixon | 4The Zone 48 ลกกอลฟ ดนลอป คอรア ซอฟท ฟล 14 ไบรท สำหรบผชายและผหญง สเขยว 2 ชน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc62068a4e5a84f54aeb51596e1b6be1dF.png_200x200q90.png",
        "price": 6746.18,
        "remark": "https://www.lazada.co.th/products/pdp-i16057810170.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟยืนแบบกันน้ำและเบา สำหรับทุกเพศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S09cac387512241f998de717c46524375t.jpg_200x200q90.jpg",
        "price": 6695.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6066724083.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋าเก็บอุปกรณ์กอล์ฟกันน้ำทนทานพกพาสำหรับผู้ชายและผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf9cdafcd45ea454f9b52b776d96a8321e.jpg_200x200q90.jpg",
        "price": 6675.74,
        "remark": "https://www.lazada.co.th/products/pdp-i6066800161.html",
        "sold": 0
    },
    {
        "product_name": "PGM|กระเป๋ากอล์ฟจุได้ 14 ไม้ น้ำหนักเบา พกพาสะดวก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S21d86334ff2d4922a3f9c5c5b1b1d9c2J.jpg_200x200q90.jpg",
        "price": 6636.76,
        "remark": "https://www.lazada.co.th/products/pdp-i6003378890.html",
        "sold": 44
    },
    {
        "product_name": "GEAR BAGS Scubapro Mesh 95 กระเป๋าเดินทาง กระเป๋ากีฬาทางน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/6f8712a8aaadab7f9e82c24727fefe46.webp_200x200q90.jpg",
        "price": 6500,
        "remark": "https://www.lazada.co.th/products/pdp-i4900487310.html",
        "sold": 1
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟเบาๆ สำหรับหมวก 2 ใบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8d5f707acd6643e99b257c1d90ea2f44n.jpg_200x200q90.jpg",
        "price": 6481.66,
        "remark": "https://www.lazada.co.th/products/pdp-i6066816223.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟสำหรับเด็กพกพาได้สะดวก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S533f9f7e2003499785115904b7205f8cQ.jpg_200x200q90.jpg",
        "price": 6295.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16055201358.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋าใส่เสื้อผ้าและรองเท้ากอล์ฟสำหรับผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S272fcc82100240208c8c7dac6359cf64C.jpg_200x200q90.jpg",
        "price": 6286.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16053791609.html",
        "sold": 2
    },
    {
        "product_name": "คันตีเหยื่อปลอม Shimano Bass One XT+ 2023 ของแท้",
        "product_image": "https://img.lazcdn.com/g/p/33e3dac066f6af48054821f25688f2f9.jpg_200x200q90.jpg",
        "price": 6200,
        "remark": "https://www.lazada.co.th/products/pdp-i5834854732.html",
        "sold": 0
    },
    {
        "product_name": "Purelure Yannic 167G Berr Reel Serat Karbon Ringan Cetek โรเตอร์ Berr Reel 1000 2500รุ่น Reel Memancing",
        "product_image": "https://img.lazcdn.com/g/p/00e6b4f241383a325421d7f98834078c.jpg_200x200q90.jpg",
        "price": 6091.6,
        "remark": "https://www.lazada.co.th/products/pdp-i4223812571.html",
        "sold": 8
    },
    {
        "product_name": "PUMA เสื้อแข่งผู้ชายทีมชาติโปรตุเกส ชุดเหย้า เกรด Replica ฤดูกาล 2025/26",
        "product_image": "https://img.lazcdn.com/g/p/bc971e909989ec99bc10a66a9136b3b5.jpg_200x200q90.jpg",
        "price": 6080,
        "remark": "https://www.lazada.co.th/products/pdp-i6036616251.html",
        "sold": 1
    },
    {
        "product_name": "Accurate เครื่องชั่ง เครื่องชั่งดิจิตอล 150kg\\300kg\\500kg แบบตั้งพื้น มีใบรับรอง",
        "product_image": "https://img.lazcdn.com/g/p/169e36339b64da54c6d60de2d208f635.jpg_200x200q90.jpg",
        "price": 5960,
        "remark": "https://www.lazada.co.th/products/pdp-i16122962050.html",
        "sold": 0
    },
    {
        "product_name": "POLO GOLF | กระเป๋ากอล์ฟ PU กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scd45983486b34cd3b79d79c8cc9f8563f.jpg_200x200q90.jpg",
        "price": 5717.32,
        "remark": "https://www.lazada.co.th/products/pdp-i6031936925.html",
        "sold": 3
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟกันน้ำพร้อมขาตั้งและช่องแม่เหล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4b9306268e264c358dc166c5c417c684v.jpg_200x200q90.jpg",
        "price": 5665.9,
        "remark": "https://www.lazada.co.th/products/pdp-i6066667621.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | ปกป้องถุงกอล์ฟสำหรับการเดินทางทางอากาศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S95f6834fea6b4440b112779603a2d49cF.jpg_200x200q90.jpg",
        "price": 5504.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16053729847.html",
        "sold": 21
    },
    {
        "product_name": "PGM GOLF | ชั้นวางไม้กอล์ฟท่อเหล็กหนา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S14b01c6e3c274e42a0990dfee0d4bc810.jpg_200x200q90.jpg",
        "price": 5267.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6003402687.html",
        "sold": 1
    },
    {
        "product_name": "Shimano 21 New NASCI 500 1000 3000 5000 รอกตกปลาทะเล แบบโลหะ",
        "product_image": "https://img.lazcdn.com/g/p/17260e6d78ea4c678c657379fac81002.jpg_200x200q90.jpg",
        "price": 5111.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16111074581.html",
        "sold": 0
    },
    {
        "product_name": "WARRIX เสื้อฟุตบอลทีมชาติไทย (Player) Blackout TH National Jersey 2025/26 (WA-254FBATH51)",
        "product_image": "https://img.lazcdn.com/g/p/68ae6e98591f7f695e357c78add05fd6.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i5943003103.html",
        "sold": 17
    },
    {
        "product_name": "Xinda | เข็มขัดรัดตัวแบบห้าจุดสำหรับการช่วยเหลือภายนอกและปีนเขา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0f247151ace6448bac3cc63976ceaea3M.jpg_200x200q90.jpg",
        "price": 4953.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16049274275.html",
        "sold": 1
    },
    {
        "product_name": "Camnal | ชุดปีนเขาและลงห้วยสำหรับความสูงปลอดภัย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S16900b9a55614b85bc82813215632f3fu.jpg_200x200q90.jpg",
        "price": 4882.66,
        "remark": "https://www.lazada.co.th/products/pdp-i16049061703.html",
        "sold": 0
    },
    {
        "product_name": "HIBOY | รอกตกปลาแบบเหยื่อปลอมพร้อมตลับลูกปืนเซรามิก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdf3f186551f84bd1b42e4b3aa7ad0a18V.jpg_200x200q90.jpg",
        "price": 4815.26,
        "remark": "https://www.lazada.co.th/products/pdp-i6075105681.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋ากอล์ฟขนาพกพา ฮาฟเซ็ตกอล์ฟ ใส่ไม้ 7-8 ไม้ , Golf Bag Half Set Ready to Ship 🛒🛍️",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8109f55680414f0ba8f454ba913a69a8F.jpg_200x200q90.jpg",
        "price": 4780,
        "remark": "https://www.lazada.co.th/products/pdp-i5827035220.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าเป้สะพายหลังกันน้ำ ขนาด 60 ลิตร FEELFREE DRY TANK 60L",
        "product_image": "https://img.lazcdn.com/g/p/99a2734152fa7c99f304bd6b423251b7.jpg_200x200q90.jpg",
        "price": 4760,
        "remark": "https://www.lazada.co.th/products/pdp-i4640599673.html",
        "sold": 0
    },
    {
        "product_name": "UNDERARMOUR กระเป๋าสะพายหลังผู้ใหญ่ รุ่น UA Hustle 6.0 Backpack /1384672 (ดำลายพราง,ดำ,ม่วง)",
        "product_image": "https://img.lazcdn.com/g/p/7d062b525b6472350b4b85ffe602690b.jpg_200x200q90.jpg",
        "price": 4542,
        "remark": "https://www.lazada.co.th/products/pdp-i5518219930.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋าเดินทางสำหรับกอล์ฟเปลือกแข็งกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7bee6f90d0cf43b8ab98b7e1c73e3f2eq.jpg_200x200q90.jpg",
        "price": 4511.44,
        "remark": "https://www.lazada.co.th/products/pdp-i6066602329.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋าไม้กอล์ฟน้ำหนักเบา ความจุสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sab6dcac537d348f6a25f2e06b3a329e67.jpg_200x200q90.jpg",
        "price": 4493.3,
        "remark": "https://www.lazada.co.th/products/pdp-i6003261897.html",
        "sold": 0
    },
    {
        "product_name": "WARRIX ใหม่ล่าสุด!! เสื้อฟุตบอลทีมชาติไทย 2025-26 เกรดนักเตะ (Player Version) Thailand National Jersey WA-253FBATH51",
        "product_image": "https://img.lazcdn.com/g/p/c2059a9b61749200f2557445d1c3297e.jpg_200x200q90.jpg",
        "price": 4480,
        "remark": "https://www.lazada.co.th/products/pdp-i5864763219.html",
        "sold": 0
    },
    {
        "product_name": "อันเดอร์ อาร์เมอร์กางเกงกีฬาผู้ชายกางเกงขาสั้นออกกำลังกายแฟชั่นอินเทรนด์วิ่งระบายอากาศแห้งเร็วกางเกงฝึกซ้อมแบบทอ 1376782-001",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa317843381534b9c9224a22685ed2a90w.jpg_200x200q90.jpg",
        "price": 4436.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16105058146.html",
        "sold": 0
    },
    {
        "product_name": "RISE ZIPPER TRAINING SHORTS, Gym Shorts, Dry Fit Shorts, Pocket gym shorts, Muay Thai / Boxing / Gym / Running / MMA / Cross-Training / Fitness / Daily Activewear",
        "product_image": "https://img.lazcdn.com/g/p/81a880cee1d2f6c3153fe9dc0f7ffcde.jpg_200x200q90.jpg",
        "price": 4400,
        "remark": "https://www.lazada.co.th/products/pdp-i5750576955.html",
        "sold": 0
    },
    {
        "product_name": "ตีเหยื่อปลอม เบิร์คเลย์ เคนเนติก  Berkley Kinetic ขนาด 6.6 และ 6.8 ฟุต เบท/สปินนิ่ง มีทั้งคัน1ท่อนและ สองท่อน แบล็งค์คาร์บอนกราไฟท์ X-Wrap ทั้งคัน",
        "product_image": "https://img.lazcdn.com/g/p/f3c835dff39515000872b509fe43c51f.jpg_200x200q90.jpg",
        "price": 4400,
        "remark": "https://www.lazada.co.th/products/pdp-i4833172134.html",
        "sold": 0
    },
    {
        "product_name": "เป้น้ำวิ่งเทรล เป้วิ่ง เป้วิ่งเทรล 5 ลิตร KIPRUN 5-LITRE trail running gilet with bottle holder for competition green",
        "product_image": "https://img.lazcdn.com/g/p/4ede88c1877cd24f706a7948d5938579.jpg_200x200q90.jpg",
        "price": 4378,
        "remark": "https://www.lazada.co.th/products/pdp-i5906782892.html",
        "sold": 0
    },
    {
        "product_name": "Callaway | ลูกกอล์ฟแท้รุ่น ERC Soft 25 Triple Track  1 โหล /12 ลูก  รุ่น TA3833086",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4fb9b999bda0476c992c013571a125d52.png_200x200q90.png",
        "price": 4341.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6066359608.html",
        "sold": 0
    },
    {
        "product_name": "G-FORM PRO SHORT COMPRESSION LINER - BASKETBALL FUTSAL VOLLEYBALL กางเกงขาสั้นรัดกล้ามเนื้อกันกระแทกสำหรับบาสเกตบอล ฟุตซอล วอลเล่ย์บอล เเละกีฬาอื่นๆ",
        "product_image": "https://img.lazcdn.com/g/p/1a5b6f83bf94611e1d7a70d3282da65b.png_200x200q90.png",
        "price": 4337.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5292741631.html",
        "sold": 2
    },
    {
        "product_name": "PGM GOLF | กระเป๋าใส่เสื้อผ้ากอล์ฟกันน้ำสองชั้นพกพาได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8e570abee56a4c429b79cc0ff735f2a64.jpg_200x200q90.jpg",
        "price": 4248.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16055257677.html",
        "sold": 1
    },
    {
        "product_name": "กระเป๋ากอล์ฟสำหรับผู้ชาย ความจุมาก พร้อมที่เก็บรองเท้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4a74464911f94ae4876daea07b4b6e65K.jpg_200x200q90.jpg",
        "price": 4243.16,
        "remark": "https://www.lazada.co.th/products/pdp-i6066818212.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟสตรีกันน้ำและเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd5abcd63a3b84fb0a0758762d9e168539.jpg_200x200q90.jpg",
        "price": 4123.24,
        "remark": "https://www.lazada.co.th/products/pdp-i6066524644.html",
        "sold": 2
    },
    {
        "product_name": "13 Fishing | รีลเบทคาสติ้งสำหรับมือใหม่ พร้อมการปล่อยสายยาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se43fc212f4144988bc58007dfb4fe1fcg.jpg_200x200q90.jpg",
        "price": 3959.76,
        "remark": "https://www.lazada.co.th/products/pdp-i6003364042.html",
        "sold": 2
    },
    {
        "product_name": "TTYGJ | กระเป๋ากอล์ฟสำหรับเด็ก 4 ช่องใส่ไม้กอล์ฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8a151acdac594be0898fbbda70b0ee1cU.jpg_200x200q90.jpg",
        "price": 3927.84,
        "remark": "https://www.lazada.co.th/products/pdp-i6041028227.html",
        "sold": 0
    },
    {
        "product_name": "13 Fishing | รอกตกปลาสำหรับการขว้างไกล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S49006f52e31f4edab19d7b98c36db9008.jpg_200x200q90.jpg",
        "price": 3815.62,
        "remark": "https://www.lazada.co.th/products/pdp-i6003364070.html",
        "sold": 0
    },
    {
        "product_name": "Callaway | ERC SOFT 25 ทรปเปลแทรค 1 เธอ-ซน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3ca3a7c022f045a89bf1fabec8c9d018y.png_200x200q90.png",
        "price": 3615.28,
        "remark": "https://www.lazada.co.th/products/pdp-i6071788972.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋ากอล์ฟพกพาความจุมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saf75917b60bd4bcead31d236057cdd61t.jpg_200x200q90.jpg",
        "price": 3546.88,
        "remark": "https://www.lazada.co.th/products/pdp-i6003431152.html",
        "sold": 9
    },
    {
        "product_name": "2XU ชุดออกกำลังกาย ชุดไตรกีฬา สำหรับผู้หญิง 2XU X-VENT Front Zip Trisuit - WT4365d สีCBU/BLK",
        "product_image": "https://img.lazcdn.com/g/p/52db7dd4d03b3e9615ba398635895f17.jpg_200x200q90.jpg",
        "price": 3510,
        "remark": "https://www.lazada.co.th/products/pdp-i1407776614.html",
        "sold": 3
    },
    {
        "product_name": "Venum | เสื้อกล้ามออกกำลังกายสำหรับผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9c7a402eaccb471984140bcd1ad13dfbl.jpg_200x200q90.jpg",
        "price": 3482.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5914257955.html",
        "sold": 5
    },
    {
        "product_name": "XTEP | รองเท้าวิ่งมาราธอนสำหรับผู้ชาย ดูดซับแรงกระแทก0007 0062",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc1f98d8721d74125bc238d273a3f2e730.jpg_200x200q90.jpg",
        "price": 3482,
        "remark": "https://www.lazada.co.th/products/pdp-i6065892914.html",
        "sold": 12
    },
    {
        "product_name": "กระเป๋าถือสำหรับเสื้อผ้ากอล์ฟ ความจุใหญ่ น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6d2dbfa8f3084614a1b6fe5de6d9d3212.png_200x200q90.png",
        "price": 3418.76,
        "remark": "https://www.lazada.co.th/products/pdp-i6066434732.html",
        "sold": 0
    },
    {
        "product_name": "คันตกหมึก PAN BASSQUID ยาว 8.6 ฟุต บาลานซ์ดี คม นิ่ง ควบคุมเหยื่อแม่น  สำหรับสายตกหมึกที่ต้องการ",
        "product_image": "https://img.lazcdn.com/g/p/273b6787ad283757ce15bd6c167fbad3.jpg_200x200q90.jpg",
        "price": 3400,
        "remark": "https://www.lazada.co.th/products/pdp-i4030346437.html",
        "sold": 6
    },
    {
        "product_name": "รอก RYOBI รุ่น CASPRO FS 5000 (เบทรันเนอร์)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saffe4b2b042c4980b94522594c9a5652Y.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i5861251831.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเชือกนิรภัย ปรับตำแหน่ง แบรนด์ Xinda",
        "product_image": "https://img.lazcdn.com/g/p/46587b4ff64cdeaca6033efb585df487.png_200x200q90.png",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i5948102180.html",
        "sold": 1
    },
    {
        "product_name": "คันเบ็ดคาร์บอนไฟเบอร์ปรับได้รวดเร็ว สำหรับการตกปลาแบบตีเหยื่อไกล ตกปลาทะเล ปลากะพง ปลาเทราท์ทะเล ความไวสูง หลากหลาย คันเบ็ด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdf60186c36ad4a7796ef5271455c12d5P.jpg_200x200q90.jpg",
        "price": 3258,
        "remark": "https://www.lazada.co.th/products/pdp-i5931264144.html",
        "sold": 0
    },
    {
        "product_name": "ASICS :  2032D269.500 NAGINO FLEX 7/8 TIGHT WOMEN เลกกิ้งผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/8557d9ebcb10b5e5f1631f1c6868fb31.png_200x200q90.png",
        "price": 3240,
        "remark": "https://www.lazada.co.th/products/pdp-i16056416083.html",
        "sold": 0
    },
    {
        "product_name": "ซองพกใน Universal (Kydex + Nylon) Warriorland",
        "product_image": "https://img.lazcdn.com/g/p/ce6356395218801b571cbeecf3465851.jpg_200x200q90.jpg",
        "price": 3200,
        "remark": "https://www.lazada.co.th/products/pdp-i5846161515.html",
        "sold": 0
    },
    {
        "product_name": "คันเบทตีเหยื่อปลอม 5 ท่อน AIRGEAR PROMAX ปี2026",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saf28f0a354ab49778192b30547bcac3bj.jpg_200x200q90.jpg",
        "price": 3200,
        "remark": "https://www.lazada.co.th/products/pdp-i16098298246.html",
        "sold": 0
    },
    {
        "product_name": "FITTERGEAR : TRAINING BELT POWER OF DRAGON เข็มขัดฟิตเนสหนังแท้ เข็มขัดยกน้ำหนัก Weightlifting",
        "product_image": "https://img.lazcdn.com/g/p/2b3242a5484bdaa77f73f85072c6d7e2.png_200x200q90.png",
        "price": 3198,
        "remark": "https://www.lazada.co.th/products/pdp-i5647368982.html",
        "sold": 5
    },
    {
        "product_name": "LI-NING Running Shoes Lightweight High Rebound Sport Training Shoes - Men‘s’ Women‘s’ Fitness Workout",
        "product_image": "https://img.lazcdn.com/g/p/50e3bbedf4a1a62092cd6801e4b2814e.jpg_200x200q90.jpg",
        "price": 3197.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16085441563.html",
        "sold": 4
    },
    {
        "product_name": "คัน โครตเหนียว v.6 มีเวท 8-17 , 10-20 มี 1ท่อน ,2ท่อน",
        "product_image": "https://img.lazcdn.com/g/p/bfe2d411ef29bba0921b608fc1d1fb80.jpg_200x200q90.jpg",
        "price": 3196.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5846134715.html",
        "sold": 0
    },
    {
        "product_name": "รอกตกปลาทางถนนขนาดเล็กทั้งหมดเป็นโลหะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfa4e92e685ef4d59af10801b91fbceeeq.jpg_200x200q90.jpg",
        "price": 3173.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6075144376.html",
        "sold": 0
    },
    {
        "product_name": "รอก RYOBI รุ่น OASYS ll  6000 (สีแดง)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa4bdd450a9ee42a2983438883db228ae9.jpg_200x200q90.jpg",
        "price": 3140,
        "remark": "https://www.lazada.co.th/products/pdp-i5888734824.html",
        "sold": 0
    },
    {
        "product_name": "ZOKE | กระเป๋าว่ายน้ำกันน้ำแยกแห้งเปียกสำหรับฝึกซ้อม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S384fbfcf9dc64aff9e036ab8d63339b5Q.jpg_200x200q90.jpg",
        "price": 3125.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16050631504.html",
        "sold": 0
    },
    {
        "product_name": "คลุมรถกอล์ฟ ZYStar ผ้าคลุมรถเข็นมีซิปเต็มรูปแบบเหมาะกับแบรนด์ส่วนใหญ่การป้องกันสภาพอากาศคลุมรถกอล์ฟ",
        "product_image": "https://img.lazcdn.com/g/p/6d0ee040a9e58232adb1124761912e82.jpg_200x200q90.jpg",
        "price": 3120,
        "remark": "https://www.lazada.co.th/products/pdp-i5943554465.html",
        "sold": 0
    },
    {
        "product_name": "กางเกงขาสั้นวิ่งแบบยืดหยุ่นสูงสำหรับผู้ชายและผู้หญิง Bmai Potential Racing Compression กางเกงขาสั้นกีฬาแห้งเร็ว ฤดูใบไม้ผลิและฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se53a46eefaf1492e8db4672af6064c23g.jpg_200x200q90.jpg",
        "price": 3078,
        "remark": "https://www.lazada.co.th/products/pdp-i5691297323.html",
        "sold": 16
    },
    {
        "product_name": "กระเป๋ากันน้ำ กระเป๋าสะพายข้างกันน้ำ  FEELFREE FREERUNNER EX S",
        "product_image": "https://img.lazcdn.com/g/p/b1ed96f1c8b4e61dba1a30cfd28b0ab0.jpg_200x200q90.jpg",
        "price": 3054,
        "remark": "https://www.lazada.co.th/products/pdp-i2245446333.html",
        "sold": 3
    },
    {
        "product_name": "Blue Ma Belle Shirt เสื้อโปโลคอปกสำหรับกีฬากอล์ฟและเทนนิส ผ้าระบายอากาศ กันยูวี สีฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/d28212ee73483b347c1cf41e66f83e6e.jpg_200x200q90.jpg",
        "price": 3007.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5778011902.html",
        "sold": 4
    },
    {
        "product_name": "รอกเบท หมุนขวา BAZOOKA ALTIS เบอร์ 6000 แถมฟรี !!! เอ็น 2 ม้วน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5a8abe67d3004979b37a1e886862ab2dW.jpg_200x200q90.jpg",
        "price": 3000,
        "remark": "https://www.lazada.co.th/products/pdp-i5920629520.html",
        "sold": 0
    },
    {
        "product_name": "ZOOT W LTD TRI RACESUIT ชุดไตรกีฬาเต็มตัวแบบไม่มีแขนผู้หญิง (ว่าย ปั่น วิ่ง) ของแท้ 💯%",
        "product_image": "https://img.lazcdn.com/g/p/76d4425537558a638dcb374ceda317ed.jpg_200x200q90.jpg",
        "price": 3000,
        "remark": "https://www.lazada.co.th/products/pdp-i4605000837.html",
        "sold": 1
    },
    {
        "product_name": "Aolon CUBE สมาร์ทวอทช์ smart watch ผู้ชายสไตล์ธุรกิจระดับพรีเมียม วัดชีพจรแจ้งเตือน รองรับโทร–ตอบข้อความ WhatsApp 140+ โหมดกีฬา AGPS หน้าจอ AMOLED 1.43″ คมชัด กันน้ำ 10 เมตร นาฬิกาอัจฉริยะเพื่อสุขภาพและกิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/98d3029daa11afba64fe6d630b657136.png_200x200q90.png",
        "price": 2998,
        "remark": "https://www.lazada.co.th/products/pdp-i6027145339.html",
        "sold": 38
    },
    {
        "product_name": "Golf | เป้สะพายหลังสำหรับผู้หญิง ความจุมาก ทำจากผ้าออกซ์ฟอร์ดและผ้าแคนวาส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8e0f7bddd55f438d861e0f5573f3ad4bE.jpg_200x200q90.jpg",
        "price": 2992,
        "remark": "https://www.lazada.co.th/products/pdp-i5909575044.html",
        "sold": 414
    },
    {
        "product_name": "สายถัก VARIVAS สายPE MAX POWER  Avani Jigging 10x10 สลับสี",
        "product_image": "https://img.lazcdn.com/g/p/e8d2a1a2c19fad0f7567ebb1e2b2076c.png_200x200q90.png",
        "price": 2967.42,
        "remark": "https://www.lazada.co.th/products/pdp-i4520631483.html",
        "sold": 2
    },
    {
        "product_name": "กระเป๋ากอล์ฟกันน้ำเบาที่มีช่องใส่รองเท้าแยกต่างหากและสามารถต่อพ่วงกระเป๋าเดินทางได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sadd76394461a44ea9a58129f9b6ea01ca.jpg_200x200q90.jpg",
        "price": 2947.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6066906062.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | ที่วางโทรศัพท์มือถือยางนิ่ม ความจุใหญ่ กันน้ำ ถาดใส่ลูกกอล์ฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S67a60b590374481d8b2b9bec754eddc0a.jpg_200x200q90.jpg",
        "price": 2908.4,
        "remark": "https://www.lazada.co.th/products/pdp-i16054236370.html",
        "sold": 0
    },
    {
        "product_name": "รอกหยดน้ำ SAP FUTO EBC ระบบเดียวกับ DC มีไฟ มีเสียงวี๊ดๆ แถมอะไหล่",
        "product_image": "https://img.lazcdn.com/g/p/a90a9e677fff5f405ba677569af23bf4.jpg_200x200q90.jpg",
        "price": 2900,
        "remark": "https://www.lazada.co.th/products/pdp-i5954083009.html",
        "sold": 0
    },
    {
        "product_name": "kastiza | เชือกตกปลาแข็งแรงสำหรับปลาใหญ่ ใช้ในทะเล เชือกไนลอนหลัก/เชือกด้านหน้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2d175c230d5b423e8946fc1b1f8b72d3z.jpg_200x200q90.jpg",
        "price": 2889.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16082572444.html",
        "sold": 0
    },
    {
        "product_name": "รอกตกปลาโลหะเต็มตัว ระบบเบรกคู่ 2+1BB สำหรับตกปลาจิ๊กกิ้ง ตกปลาทะเล ตกปลาคาร์พ  แบบ Baitcasting  พร้อมด้ามจับ  สำหรับน้ำเค็ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa8bb4507801043b09536ea7133c2f3f67.jpg_200x200q90.jpg",
        "price": 2791.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16095895728.html",
        "sold": 0
    },
    {
        "product_name": "Under Armour เสื้อกล้ามสำหรับผู้ชาย UA Velociti8",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1796e969b6ab4db587bb57e487760cb4T.png_200x200q90.png",
        "price": 2780,
        "remark": "https://www.lazada.co.th/products/pdp-i16116967037.html",
        "sold": 0
    },
    {
        "product_name": "รอกตกปลา WOLF COBRA EDC ทรงกลม เฟืองทองเหลือง 6BB ระบบ Digital Control คลิ๊กเสียงปลาลาก ตกปลา รอกหยดน้ำ รอกเบท",
        "product_image": "https://img.lazcdn.com/g/p/fd02ec3d1fc74cc62b72c6093801234b.jpg_200x200q90.jpg",
        "price": 2780,
        "remark": "https://www.lazada.co.th/products/pdp-i16047021019.html",
        "sold": 4
    },
    {
        "product_name": "รอก WOLF COBRA EDC รอกทรงกลม เฟืองทองเหลือง 6BB ระบบ Digital Control คลิ๊กเสียงปลาลาก ตกปลา รอกหยดน้ำ รอกเบท",
        "product_image": "https://img.lazcdn.com/g/p/fd02ec3d1fc74cc62b72c6093801234b.jpg_200x200q90.jpg",
        "price": 2780,
        "remark": "https://www.lazada.co.th/products/pdp-i16046930496.html",
        "sold": 0
    },
    {
        "product_name": "Skechers สเก็ตเชอร์ส รองเท้าผู้หญิง Women Virtue Sport Active Shoes - 104421-NTBK Air-Cooled Memory Foam",
        "product_image": "https://img.lazcdn.com/g/p/b7e0d5ca3146c7ada61d9b8731dad0fa.jpg_200x200q90.jpg",
        "price": 2780,
        "remark": "https://www.lazada.co.th/products/pdp-i5124986139.html",
        "sold": 112
    },
    {
        "product_name": "Kanle | เชือกความปลอดภัยสำหรับปีนเขา ทำงานที่สูง และการช่วยเหลือ",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Sdf11c0f46f264b40a25f69841b733570Q.jpeg_200x200q90.jpg",
        "price": 2724.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16049040739.html",
        "sold": 2
    },
    {
        "product_name": "TTYGJ | กระเป๋ากอล์ฟครึ่งชุด พกพาสะดวก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S20cda22d8e974bf7bcd8baf87e62ec8c9.jpg_200x200q90.jpg",
        "price": 2696.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5895032228.html",
        "sold": 2
    },
    {
        "product_name": "Mizuno | มซโน RB MAX ลกกอลฟ 3 ชน 12 ลก 2 ส สำหรบผชายและผหญง รน TA3805531",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S104ad93084a0466d83035ede393e5952H.png_200x200q90.png",
        "price": 2681.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6051934554.html",
        "sold": 0
    },
    {
        "product_name": "Koklife อุปกรณ์กีฬาออกกำลังกายเสื้อกั๊กน้ำหนักปีนเขาเสื้อกล้ามออกกำลังกายวิ่งระบายอากาศ",
        "product_image": "https://img.lazcdn.com/g/p/77bebadb1d2201b9fb0bad04fe615d25.jpg_200x200q90.jpg",
        "price": 2652,
        "remark": "https://www.lazada.co.th/products/pdp-i6066481499.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | ฝาครอบถุงกอล์ฟสีสันโปร่งใสใช้ได้ทุกแบบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2a22e41536544c5baf2dd423073f88bda.jpg_200x200q90.jpg",
        "price": 2624.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16055061712.html",
        "sold": 1
    },
    {
        "product_name": "❌มีตำหนิ ❌ กระเป๋ากอล์ฟขนาพกพา ฮาฟเซ็ตกอล์ฟ ใส่ไม้ 7-8 ไม้ , Golf Bag Half Set Ready to Ship 🛒🛍️",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S356bfd512c024d329752f772b51f746b4.jpg_200x200q90.jpg",
        "price": 2600,
        "remark": "https://www.lazada.co.th/products/pdp-i5964875470.html",
        "sold": 0
    },
    {
        "product_name": "AAPV021กางเกงใส่แข่งขันเท่ๆแห้งเร็วสำหรับผู้ชาย LI-NING BADFIVE",
        "product_image": "https://img.lazcdn.com/g/p/baa62cd1727501f87dd0fd415f73a30a.jpg_200x200q90.jpg",
        "price": 2599.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5687821820.html",
        "sold": 0
    },
    {
        "product_name": "รองเท้ากีฬาป้องกันลื่นใหม่แบบมืออาชีพ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S33926dd224b64128b9aca477ca19726bM.jpg_200x200q90.jpg",
        "price": 2599.1,
        "remark": "https://www.lazada.co.th/products/pdp-i6074924917.html",
        "sold": 0
    },
    {
        "product_name": "Mizuno | RB MAX ลูกกอล์ฟ สีเหลือง รุ่น 5N733512D",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Sd090321cc64646f9a3cf35f3edb600f2j.png_200x200q90.png",
        "price": 2596.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6053721283.html",
        "sold": 0
    },
    {
        "product_name": "อนเตอรแมกซ 972 ซนากาวะ เบททรล รอกตกปลาเบททรล รอกตกปลา รอกตกปลาแบบลร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd66bc1dd052045ef9bb290c082f27976q.jpg_200x200q90.jpg",
        "price": 2582.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16076484710.html",
        "sold": 0
    },
    {
        "product_name": "[ส่งในไทย] คันตีเหยื่อปลอม Elektra ARMORY Limited Pro Carbon ใหม่ล่าสุด!! #ช่อน ชะโด กระสูบ",
        "product_image": "https://img.lazcdn.com/g/p/4934e772d2c28fa459093403781e3ad8.jpg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i5441830602.html",
        "sold": 11
    },
    {
        "product_name": "DAIWA | รอกตกปลาโยนไกล สปูลโลหะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se0690d46e29f4ae09e99697b4fecf0667.jpg_200x200q90.jpg",
        "price": 2574.12,
        "remark": "https://www.lazada.co.th/products/pdp-i6001838575.html",
        "sold": 5
    },
    {
        "product_name": "Golf | กระเป๋าผู้หญิงสไตล์หรูหลายประโยชน์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4dd65312fea44858963363f111b4f1b64.jpg_200x200q90.jpg",
        "price": 2561.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5909483559.html",
        "sold": 120
    },
    {
        "product_name": "รอกตกปลา Sposport ล้อเลื่อนเหยื่อม้วน",
        "product_image": "https://img.lazcdn.com/g/p/9e5a103218cf992cbfdfe0d6a9ba99bc.jpg_200x200q90.jpg",
        "price": 2526,
        "remark": "https://www.lazada.co.th/products/pdp-i5942020049.html",
        "sold": 0
    },
    {
        "product_name": "คันเบ็ด คันสปิน OLYMPIC-X ไกด์ฟูจิ ด้ามก๊อกเคลือบ คันสองท่อน มี 8-10ฟุต เวท 8-15lb",
        "product_image": "https://img.lazcdn.com/g/p/85d8780d2a4977b0591842a8bb5b0173.jpg_200x200q90.jpg",
        "price": 2400,
        "remark": "https://www.lazada.co.th/products/pdp-i5970524007.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกีฬาผู้หญิง Dongda Gate ซัมเมอร์ 2025 เสื้อคอกลมแขนสั้น กางเกงขายาวทรงกว้าง แฟชั่นสีพื้น ชุดลำลอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb5e0583c8023474d9e5cd9776a778c4fi.jpg_200x200q90.jpg",
        "price": 2504.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16102119084.html",
        "sold": 0
    },
    {
        "product_name": "Active Dryaeroflow Short Sleeve Tee เสื้อวิ่ง UNISEX",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S84247263d0c7471bb49a78e2fcc94fd2K.jpg_200x200q90.jpg",
        "price": 2442,
        "remark": "https://www.lazada.co.th/products/pdp-i16091397423.html",
        "sold": 0
    },
    {
        "product_name": "Titleist | ลูกกอล์ฟ TruFeel แบบนุ่ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S24bc015058f6443cb6ec916dce620bcdP.jpg_200x200q90.jpg",
        "price": 2487.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16055079674.html",
        "sold": 3
    },
    {
        "product_name": "กางเกงสปอร์ตสตรีกระชับเอวและยกก้น 4 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd40ab9ece4034014a18555a534a33ed3i.jpg_200x200q90.jpg",
        "price": 2476,
        "remark": "https://www.lazada.co.th/products/pdp-i16086547935.html",
        "sold": 0
    },
    {
        "product_name": "TTYGJ | กระเป๋ากอล์ฟสำหรับเด็ก ขนาดกะทัดรัด ทนทาน ทำจากไนลอน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S55ed87ac92df401b96ce0636b82e29dec.jpg_200x200q90.jpg",
        "price": 2454.36,
        "remark": "https://www.lazada.co.th/products/pdp-i5895003638.html",
        "sold": 5
    },
    {
        "product_name": "[ ของแท้ ]  คันตีเหยื่อปลอม Elektra ARMORY Limited Pro Carbon ใหม่ล่าสุด เหมาะกับงานช่อน ชะโด กระสูบ ตกหมึก",
        "product_image": "https://img.lazcdn.com/g/p/9f41f399cb6a00820a42e89fd75d73cc.jpg_200x200q90.jpg",
        "price": 2452,
        "remark": "https://www.lazada.co.th/products/pdp-i5513317291.html",
        "sold": 1
    },
    {
        "product_name": "คันตีเหยื่อปลอม Bison Bull F3 ไกด์ Fuji O ring ด้ามท้ายทรงเบสบอล",
        "product_image": "https://img.lazcdn.com/g/p/d2eae4c0359869d11d3c6831385a4e1c.jpg_200x200q90.jpg",
        "price": 2310,
        "remark": "https://www.lazada.co.th/products/pdp-i5970455472.html",
        "sold": 0
    },
    {
        "product_name": "HIStAR |รอกตกปลาฮาสเทรดแบบอัลตร้าไลท์ รอกสำหรับตกปลาทะเล รอกสำหรับตกปลาย่านชายฝั่ง รอกโยนไกลพิเศษ พร้อมล้อหมุนด้าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S81a0c76c4b524b72bae844d58a814e9e9.jpg_200x200q90.jpg",
        "price": 2427.84,
        "remark": "https://www.lazada.co.th/products/pdp-i5841238624.html",
        "sold": 88
    },
    {
        "product_name": "Wakingbee by Mark Kim Sprint Shorts (Navy) กางเกงขาสั้นออกกำลังกาย ของผู้ชาย มีซับใน ผ้าเบา แห้งไว ยืดหยุ่นได้ มีกระเป๋าสี่ใบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7d79214eb2d34e89a04a95f465d87f80e.jpg_200x200q90.jpg",
        "price": 2390,
        "remark": "https://www.lazada.co.th/products/pdp-i5017480729.html",
        "sold": 1
    },
    {
        "product_name": "BARREL PIECE LOGO DRY BAG 10L [01] - กระเป๋ากันน้ำ-3AP002U_U3BKXX",
        "product_image": "https://img.lazcdn.com/g/p/20c816235bed8ba5440022377e01ff04.jpg_200x200q90.jpg",
        "price": 2390,
        "remark": "https://www.lazada.co.th/products/pdp-i5260251582.html",
        "sold": 0
    },
    {
        "product_name": "REEBOK Tech Jersey Ls เสื้อวิ่งผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/b59b060a0ca192cb5668bb6db3b113ab.jpg_200x200q90.jpg",
        "price": 2388,
        "remark": "https://www.lazada.co.th/products/pdp-i5958633617.html",
        "sold": 1
    },
    {
        "product_name": "Under Armour เสื้อกล้ามสำหรับผู้ชาย UA Tech™ Vent",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3478dfb3c8cc4da2aeb5181ca6f9a452q.jpg_200x200q90.jpg",
        "price": 2384,
        "remark": "https://www.lazada.co.th/products/pdp-i5851606898.html",
        "sold": 3
    },
    {
        "product_name": "กอล์ฟ | กระเป๋าสะพายไหล่ขนาดใหญ่ น้ำหนักเบา กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2940489803ee4cd689746f0cd4d74382s.jpg_200x200q90.jpg",
        "price": 2361.24,
        "remark": "https://www.lazada.co.th/products/pdp-i6045241435.html",
        "sold": 6
    },
    {
        "product_name": "WARRIX ใหม่ล่าสุด!! เสื้อฟุตบอลทีมชาติไทย 2025-26 เกรดเสมือนเสื้อแข่ง (Replica Version) Thailand National Jersey WA-253FBATH52",
        "product_image": "https://img.lazcdn.com/g/p/ed816a9863a8d3bb52d6eedcb5c4d068.jpg_200x200q90.jpg",
        "price": 2320,
        "remark": "https://www.lazada.co.th/products/pdp-i5864714517.html",
        "sold": 0
    },
    {
        "product_name": "ค้นตกหมึก IKA HYDRA สีดำ รุ่นใหม่ล่าสุดปี 2026",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S88732bd7dde74d149eba34badf4341ccC.jpg_200x200q90.jpg",
        "price": 2300,
        "remark": "https://www.lazada.co.th/products/pdp-i16129507106.html",
        "sold": 0
    },
    {
        "product_name": "เสื้อแขนยาวแบบบีบอัดสำหรับกีฬา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S259e0f7d3a064f38b664628b696fea6e2.jpg_200x200q90.jpg",
        "price": 2203.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16051192730.html",
        "sold": 0
    },
    {
        "product_name": "Helang | ดัมเบลปรับน้ำหนักได้สำหรับฟิตเนส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S20ef6557aa5d4bb6ad634b4a59b37977w.jpg_200x200q90.jpg",
        "price": 2202.16,
        "remark": "https://www.lazada.co.th/products/pdp-i6041023328.html",
        "sold": 106
    },
    {
        "product_name": "Jordan Dri-FIT Men's Sport Essentials Sleeveless Tank - White [IF0889-100]",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S06fdfce4249649439700dd0b4d06172bM.jpg_200x200q90.jpg",
        "price": 2200,
        "remark": "https://www.lazada.co.th/products/pdp-i6050292157.html",
        "sold": 9
    },
    {
        "product_name": "รอกสปินนิ่ง RYOBI ECUSIMA VI SERIES (เรียวบิ อิคูซิม่า vi)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0b60e31b697d420082dbef38360b3dc1J.jpg_200x200q90.jpg",
        "price": 2200,
        "remark": "https://www.lazada.co.th/products/pdp-i5927763315.html",
        "sold": 1
    },
    {
        "product_name": "WARRIX เสื้อซ้อมฟุตบอลทีมชาติไทย (FULL SPONSOR) รุ่น AEROLINE (WA-261FBATH74)",
        "product_image": "https://img.lazcdn.com/g/p/dd54899c94c6c702847c25e7b3a16b66.jpg_200x200q90.jpg",
        "price": 2198,
        "remark": "https://www.lazada.co.th/products/pdp-i16125113401.html",
        "sold": 8
    },
    {
        "product_name": "4-Seater Electric 6OV Golf Cart with 4000W Motor 70-90km\nRange Tail Caddie Standing Position for Sale",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7cce930aeb5343dc868ed5e5c64c4f3b6.jpg_200x200q90.jpg",
        "price": 70000,
        "remark": "https://www.lazada.co.th/products/pdp-i16146349385.html",
        "sold": 0
    },
    {
        "product_name": "KM|รถกระบะ RAM 1500 รุ่นจำลองเหมาะสำหรับกิจกรรมวิบากและการเล่นกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S2f705f192a7344f58e6673f014dbc968b.jpg_200x200q90.jpg",
        "price": 66048.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6031912002.html",
        "sold": 3
    },
    {
        "product_name": "MENGBIZHEN | มอเตอร์เรือนอกบอร์ดไฟฟ้าสตาร์ท 15 แรงม้า แบบกลับด้านได้ รุ่นปรับปรุง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S25f07b663f28431fa04414dd440486708.jpg_200x200q90.jpg",
        "price": 62711.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16083468545.html",
        "sold": 0
    },
    {
        "product_name": "ST [จัดส่งรวดเร็ว] [มีของแท้] สินค้าใหม่พาดลำตัว H8P มอเตอร์แบบไม่มีแปรงถ่าน1:8ปรับได้มอเตอร์ไฟฟ้าฟอร์ดของเล่นโมเดลวิทยุบังคับ Mobil Remote Control ที่ได้รับอนุญาต",
        "product_image": "https://img.lazcdn.com/g/p/2fb5d4a6c98ebacfc0b44bdb19040155.jpg_webp_200x200q90.jpg",
        "price": 49314.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5908865769.html",
        "sold": 0
    },
    {
        "product_name": "BONINGYU | มอเตอร์ไซค์ไฟฟ้าสำหรับเด็ก 3-12 ปี พร้อมรีโมทคอนโทรล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S87348f6a6a54496abcbb24371fa80fbeh.jpg_200x200q90.jpg",
        "price": 42844.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5928290212.html",
        "sold": 1
    },
    {
        "product_name": "มอเตอร์ยกสำหรับเชื่อมต่อ2สายสำหรับมอเตอร์นอกเรือ200 300แรงม้าให้การหมุนย้อนกลับได้",
        "product_image": "https://img.lazcdn.com/g/p/3f6c22802936fe878da0532a5efc5b90.jpg_200x200q90.jpg",
        "price": 40676,
        "remark": "https://www.lazada.co.th/products/pdp-i16094479886.html",
        "sold": 0
    },
    {
        "product_name": "(งง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5b58df83664a4cbd9dec100f4f2973bcT.png_200x200q90.png",
        "price": 32793.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16087670400.html",
        "sold": 0
    },
    {
        "product_name": "ISEE MIGOA | ชุดสกีกันน้ำสำหรับมืออาชีพ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S83b7da1e5ff542dd8082a5676eb13528V.png_200x200q90.png",
        "price": 31773.98,
        "remark": "https://www.lazada.co.th/products/pdp-i6049254945.html",
        "sold": 26
    },
    {
        "product_name": "💠Preorder💠",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S332f12d646204fceb0b9a54a053db9ffO.jpg_200x200q90.jpg",
        "price": 27400,
        "remark": "https://www.lazada.co.th/products/pdp-i5898266551.html",
        "sold": 0
    },
    {
        "product_name": "MENGBIZHEN | มอเตอร์ขับเคลื่อนเรือพอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfc68ae238682433f936521cc1d005acaw.jpg_200x200q90.jpg",
        "price": 27202.44,
        "remark": "https://www.lazada.co.th/products/pdp-i16087858821.html",
        "sold": 0
    },
    {
        "product_name": "ชุดสตาร์ทไฟฟ้าสำหรับเรือมอเตอร์สตาร์ทเตอร์เอาท์บรอด15HP มีเสถียรภาพเพิ่มประสิทธิภาพสำหรับเครื่องยนต์นอกเรือ",
        "product_image": "https://img.lazcdn.com/g/p/560c877cd5b88666b1dd78406038f632.jpg_200x200q90.jpg",
        "price": 25940,
        "remark": "https://www.lazada.co.th/products/pdp-i6046276118.html",
        "sold": 0
    },
    {
        "product_name": "การออกแบบ OEM ชิ้นส่วนมือจับพวงมาลัยพรวนดิน692-42111คู่ที่สมบูรณ์แบบสำหรับเครื่องยนต์เรือ75ถึง90HP 2จังหวะ",
        "product_image": "https://img.lazcdn.com/g/p/b8cfa777794dafc8f9026c53937a032e.jpg_200x200q90.jpg",
        "price": 21878,
        "remark": "https://www.lazada.co.th/products/pdp-i6019838225.html",
        "sold": 0
    },
    {
        "product_name": "ขนาดมน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S734d73ae53434547bd6c1306b9e2cab5y.png_200x200q90.png",
        "price": 20890.32,
        "remark": "https://www.lazada.co.th/products/pdp-i16118016213.html",
        "sold": 0
    },
    {
        "product_name": "ชุดตัวควบคุมมอเตอร์ล้อหลังชุดแปลงจักรยานไฟฟ้าความเหนียวสูง36V 250W ชุดอลูมิเนียมกันน้ำสำหรับมอเตอร์26นิ้ว",
        "product_image": "https://img.lazcdn.com/g/p/c089a321b145a915732505e4af2c1ebf.jpg_200x200q90.jpg",
        "price": 20568,
        "remark": "https://www.lazada.co.th/products/pdp-i6067917847.html",
        "sold": 0
    },
    {
        "product_name": "เปลือกมอเตอร์อลูมิเนียม155ROV ทรัสเตอร์มุ้งไนล่อนทรัสเตอร์ใต้น้ำ",
        "product_image": "https://img.lazcdn.com/g/p/f594bb97407bdf86c560da0c8a41500c.jpg_200x200q90.jpg",
        "price": 18944,
        "remark": "https://www.lazada.co.th/products/pdp-i16122608891.html",
        "sold": 0
    },
    {
        "product_name": "มอเตอร์เล็มขอบเอียงสำหรับเครื่องยนต์เอาต์บอร์ด8M0089940ทนทานอายุการใช้งานยาวนานป้องกันริ้วรอย",
        "product_image": "https://img.lazcdn.com/g/p/03870057978f25c777e10a4636064041.jpg_200x200q90.jpg",
        "price": 17032,
        "remark": "https://www.lazada.co.th/products/pdp-i6066777094.html",
        "sold": 0
    },
    {
        "product_name": "6CB-81800มอเตอร์สตาร์ทสำหรับมอเตอร์ติดท้ายเรือยามาฮ่า2T & 4T 115HP 200HP 225HP 250HP 6CB-81800-00;6CB-81800-01",
        "product_image": "https://img.lazcdn.com/g/p/740eef98243c2b9c1efd1bd4532ea684.jpg_200x200q90.jpg",
        "price": 16352,
        "remark": "https://www.lazada.co.th/products/pdp-i16146755398.html",
        "sold": 0
    },
    {
        "product_name": "ชุดแปลงมอเตอร์ดุมแบบไม่มีแปรงถ่านฮับชุดมอเตอร์48V 250W พร้อม KT 900S สำหรับล้อ26in (",
        "product_image": "https://img.lazcdn.com/g/p/7f323af630580494289803e1ed3cd726.jpg_200x200q90.jpg",
        "price": 15802,
        "remark": "https://www.lazada.co.th/products/pdp-i6020791735.html",
        "sold": 0
    },
    {
        "product_name": "มอเตอร์กระสวยหมุนพลังลมชุดมอเตอร์แกนหมุนประสิทธิภาพสูง500W ใช้งานง่ายสำหรับ DIY",
        "product_image": "https://img.lazcdn.com/g/p/5525ee4ca3b750fbc9046df15fbe9693.jpg_200x200q90.jpg",
        "price": 13836,
        "remark": "https://www.lazada.co.th/products/pdp-i6023089292.html",
        "sold": 0
    },
    {
        "product_name": "ซนอล 2 in 1 มอเตอร BLDC แบบหมนไดรอบทศทาง พรอมรโมทคอนโทรล พดลมตงพนแบบหมนได 16 ระดบความเรวลม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7cdca1755a3448bdbe4668d86126a338C.png_200x200q90.png",
        "price": 12685.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16117641707.html",
        "sold": 0
    },
    {
        "product_name": "udiR／C/|รถรีโมทคอนโทรลออฟโรดแข่งความเร็ว 1/16",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb3ef17afafe348db9bf62104e69a9779h.png_200x200q90.png",
        "price": 12409.98,
        "remark": "https://www.lazada.co.th/products/pdp-i6029711078.html",
        "sold": 5
    },
    {
        "product_name": "PIXHAWK2.4.8 Flight Control Carbon Fiber Smart550 Frame Kit Ardupilot 100MW Radio Telemetry Quadcopter BLHELI 30A ESC 2212 Motor",
        "product_image": "https://img.lazcdn.com/g/p/55c30ec02f0ac747174a8fe1046be25e.jpg_200x200q90.jpg",
        "price": 12250.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5933985289.html",
        "sold": 0
    },
    {
        "product_name": "RLAARLO| รถมอนสเตอร์ทรัค RC 4WD ความเร็วสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7cad5eeb58994fe6a4397108a0cbd69aG.png_200x200q90.png",
        "price": 12019.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6031684984.html",
        "sold": 85
    },
    {
        "product_name": "ชุดศิลปะการต่อสู้ระดับไฮเอนด์ แวววัยเยาว์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8d0d0d483dee4122bb3a8abcda1b340aO.jpg_200x200q90.jpg",
        "price": 11450.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16076528566.html",
        "sold": 0
    },
    {
        "product_name": "ชุดแข่งศิลปะการต่อสู้พรีเมียมคุณภาพสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S884f485c84974ebe8ef208a7f3b78a36G.png_200x200q90.png",
        "price": 11450.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16076637295.html",
        "sold": 0
    },
    {
        "product_name": "เรือบังคับวิทยุไฟฟ้าความเร็วสูงสำหรับผู้ใหญ่ พร้อมระบบระบายความร้อนด้วยน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbf16fa756a1141cf8c2402c893da2dd4Q.jpg_200x200q90.jpg",
        "price": 11265.86,
        "remark": "https://www.lazada.co.th/products/pdp-i6031920652.html",
        "sold": 0
    },
    {
        "product_name": "PT627NM มอเตอร์ตัดแบบเอียง2สายปิดแน่นสำหรับเรือ75 90HP F75 F90",
        "product_image": "https://img.lazcdn.com/g/p/bdeacae44dec0afdbff6ad1c8d2d4ed5.jpg_200x200q90.jpg",
        "price": 10528,
        "remark": "https://www.lazada.co.th/products/pdp-i6049341604.html",
        "sold": 0
    },
    {
        "product_name": "ตัวยึดเครื่องยนต์เรือ Lohobby Kicker ตัวยึดสแตนเลสฐานไม้",
        "product_image": "https://img.lazcdn.com/g/p/42eb508bf4c2acc0f9aa6902a0fa282d.jpg_200x200q90.jpg",
        "price": 10048,
        "remark": "https://www.lazada.co.th/products/pdp-i5887438979.html",
        "sold": 0
    },
    {
        "product_name": "แขนพวงมาลัยเซอร์โวโลหะมอเตอร์เซอร์โวสำหรับเฮลิคอปเตอร์เรือสำหรับหุ่นยนต์1:5 1:6รถ RC",
        "product_image": "https://img.lazcdn.com/g/p/edb4007470a20a912b8dfbeec1833fc1.jpg_200x200q90.jpg",
        "price": 9304,
        "remark": "https://www.lazada.co.th/products/pdp-i6058770345.html",
        "sold": 0
    },
    {
        "product_name": "มอเตอร์1:14ไร้แปรงถ่าน MJX 14208ใหม่,รถ Rc ขับเคลื่อนสี่ล้อดริฟท์รถออฟโรดขนาด2.4ก. โมเดลเปลือกคู่ของเล่นความเร็วรถ",
        "product_image": "https://img.lazcdn.com/g/p/8b7031adfc38d5fdca32ca8c01bbec6b.jpg_webp_200x200q90.jpg",
        "price": 9269.36,
        "remark": "https://www.lazada.co.th/products/pdp-i5914830206.html",
        "sold": 0
    },
    {
        "product_name": "yishujia office | ชุดรถสองล้อสมาร์ทดุลตัวเองพร้อมระบบหลีกเลี่ยงอุปสรรค PID",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa367e2d5dfa14ba99e6f1043d9515caf2.png_200x200q90.png",
        "price": 9227.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16099327659.html",
        "sold": 0
    },
    {
        "product_name": "ST [จัดส่งเร็ว] [ของดั้งเดิมใช้ได้] Coolbank M8 1/16รถถัง RC สงครามโลกครั้งที่สองเรา M8ถัง Scott ปืนครก Tzer มอเตอร์พร้อมป้อมปืนควันหมุน360 ° ของขวัญเด็กชายจังหวะ",
        "product_image": "https://img.lazcdn.com/g/p/617ca13e0c0beb355d2f73fe820d078b.jpg_webp_200x200q90.jpg",
        "price": 9085.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5747087421.html",
        "sold": 0
    },
    {
        "product_name": "มอเตอร์ขอบเอียงเรือยนต์ขอบเอียงอัลลอยด์โลหะแบบมืออาชีพสำหรับ F75-130ด้านนอก",
        "product_image": "https://img.lazcdn.com/g/p/90e05393a8297fdf399d17ed65b0c8d4.jpg_200x200q90.jpg",
        "price": 8976,
        "remark": "https://www.lazada.co.th/products/pdp-i6069195752.html",
        "sold": 0
    },
    {
        "product_name": "เพลาข้อเหวี่ยงแอสซี่เครื่องยนต์เรือเหล็กทนทาน6B4-11400-00สำหรับการซ่อม",
        "product_image": "https://img.lazcdn.com/g/p/6664139afbe9e91cfc41a1142540a896.jpg_200x200q90.jpg",
        "price": 8591.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5957911069.html",
        "sold": 0
    },
    {
        "product_name": "มอเตอร์เล็มขอบเอียงเครื่องยนต์มอเตอร์828708แรงบิดสูง12โวลต์ทนทานสำหรับ XR6ทะเลขนาดใหญ่ III",
        "product_image": "https://img.lazcdn.com/g/p/88a23fccf1f00fc91d8fe91d5fc6398c.jpg_200x200q90.jpg",
        "price": 8582,
        "remark": "https://www.lazada.co.th/products/pdp-i6047617405.html",
        "sold": 0
    },
    {
        "product_name": "มอเตอร์ขอบเอียง12V มอเตอร์ขอบโค้งมี878265A1ตอบสนองรวดเร็วทนทานสำหรับ XR6ทะเลขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/7a7befd5ab1042a079459352cad98b1d.jpg_200x200q90.jpg",
        "price": 8582,
        "remark": "https://www.lazada.co.th/products/pdp-i6019018673.html",
        "sold": 0
    },
    {
        "product_name": "มอเตอร์828708ทริมปรับเอียงเครื่องยนต์ทนทาน12V ทนทานกันน้ำสำหรับ XR6ทะเลขนาดใหญ่ III",
        "product_image": "https://img.lazcdn.com/g/p/88a23fccf1f00fc91d8fe91d5fc6398c.jpg_200x200q90.jpg",
        "price": 8582,
        "remark": "https://www.lazada.co.th/products/pdp-i6049221333.html",
        "sold": 0
    },
    {
        "product_name": "มอเตอร์ RC ทำงานได้เต็มรูปแบบฝีมือประณีตสำหรับในร่ม",
        "product_image": "https://img.lazcdn.com/g/p/0abe71cac7c94a7d17406feb742a33a8.jpg_200x200q90.jpg",
        "price": 8536,
        "remark": "https://www.lazada.co.th/products/pdp-i6035817692.html",
        "sold": 0
    },
    {
        "product_name": "JDD [ส่งเร็ว] [ของดั้งเดิมใช้ได้] M8 Coolbank 1/4 \"สงครามโลกครั้งที่สองเรารถถัง RC M8ถัง Scott Howi Tzer มอเตอร์พร้อมป้อมปืนควันหมุน360 ° Tempo Boy ของขวัญ",
        "product_image": "https://img.lazcdn.com/g/p/617ca13e0c0beb355d2f73fe820d078b.jpg_200x200q90.jpg",
        "price": 8205.66,
        "remark": "https://www.lazada.co.th/products/pdp-i5737053078.html",
        "sold": 0
    },
    {
        "product_name": "มอเตอร์ไร้แกน60กก. อลูมิเนียมอัลลอยด์เกียร์พวงมาลัยเซอร์โวเกียร์ RC RC สำหรับหุ่นยนต์ RC",
        "product_image": "https://img.lazcdn.com/g/p/7af0d576932bf92363ba3a03e05f4891.jpg_200x200q90.jpg",
        "price": 7994,
        "remark": "https://www.lazada.co.th/products/pdp-i6003376983.html",
        "sold": 0
    },
    {
        "product_name": "Yotown Keenso Tilt Trim Motor Assy 12V แรงบิดสูงเครื่องยนต์นอกเรือมอเตอร์พร้อมแบริ่งที่ปิดสนิทและโลหะผสมสำหรับ 115 ถึง 225 F115 Marine เครื่องยนต์ 1997 ขึ้นไป",
        "product_image": "https://img.lazcdn.com/g/p/7dd0419555dc6f2421a5b6dc6550bcc7.jpg_200x200q90.jpg",
        "price": 7848,
        "remark": "https://www.lazada.co.th/products/pdp-i16146708701.html",
        "sold": 0
    },
    {
        "product_name": "มอเตอร์ไฟฟ้าแบบลาดเอียง43880 01 00 DC12V 62Y สำหรับ40MJHZ 40MLHZ",
        "product_image": "https://img.lazcdn.com/g/p/032d36e2acdd059a85bbc06ef2f63c61.jpg_200x200q90.jpg",
        "price": 7790,
        "remark": "https://www.lazada.co.th/products/pdp-i6019762735.html",
        "sold": 0
    },
    {
        "product_name": "ชุดแปลงจักรยานไฟฟ้าจักรยานร่องตัวควบคุมมอเตอร์ที่อยู่อาศัยโลหะมีเสถียรภาพสำหรับมอเตอร์จักรยาน350วัตต์",
        "product_image": "https://img.lazcdn.com/g/p/607f1e0af71bb56d341f6294b1cc142f.jpg_200x200q90.jpg",
        "price": 7748,
        "remark": "https://www.lazada.co.th/products/pdp-i6068045503.html",
        "sold": 0
    },
    {
        "product_name": "รถ RC รถของเล่นสำหรับ D90 SCX10สำหรับนักสะสมรถของเล่นเกียร์มอเตอร์โลหะมอเตอร์แปลกใหม่",
        "product_image": "https://img.lazcdn.com/g/p/da68e34fc7512e62a58b83ccd9d5b199.jpg_200x200q90.jpg",
        "price": 7556,
        "remark": "https://www.lazada.co.th/products/pdp-i6049616119.html",
        "sold": 0
    },
    {
        "product_name": "เซ็นเซอร์ช่วยเหยียบพลังงานจักรยานไฟฟ้าเคสระบายความร้อนยอดเยี่ยมสำหรับการขี่จักรยานตัวควบคุมมอเตอร์คลื่นไซน์40A",
        "product_image": "https://img.lazcdn.com/g/p/959a37175cc12e5de927cf622903d880.jpg_200x200q90.jpg",
        "price": 7468,
        "remark": "https://www.lazada.co.th/products/pdp-i5896623929.html",
        "sold": 0
    },
    {
        "product_name": "Miatoo ESC ชุดระบบไฟฟ้าเซ็นเซอร์แบบบูรณาการมอเตอร์ประสาทสัมผัสมอเตอร์รวม ESC",
        "product_image": "https://img.lazcdn.com/g/p/2d4f25c9f9ff94daadba0925d08ca2a1.jpg_200x200q90.jpg",
        "price": 7388,
        "remark": "https://www.lazada.co.th/products/pdp-i16121420629.html",
        "sold": 0
    },
    {
        "product_name": "yishujia office | มอเตอร์ฮับไร้แปรงสีฟัน พร้อมยางแข็ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7adb0ba09e7b4526a16be4d3df0701637.jpg_200x200q90.jpg",
        "price": 7099.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16101039563.html",
        "sold": 0
    },
    {
        "product_name": "มอเตอร์ FPV 1950KV 6S Compatible 1 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se28fcefc06c84c9d89c3a4f7174b429ci.jpg_200x200q90.jpg",
        "price": 6690.5,
        "remark": "https://www.lazada.co.th/products/pdp-i6031946895.html",
        "sold": 0
    },
    {
        "product_name": "มอเตอร์ไฟฟ้า62X 43880 09นิ้วเริ่มต้นอย่างรวดเร็ว2เส้นสำหรับ40ถึง100มอเตอร์ออนบอร์ด HP",
        "product_image": "https://img.lazcdn.com/g/p/525d4c987383952e7fa0e57036ed070a.jpg_200x200q90.jpg",
        "price": 6662,
        "remark": "https://www.lazada.co.th/products/pdp-i6049325325.html",
        "sold": 0
    },
    {
        "product_name": "JDD [มีอยู่ตอนนี้] [จัดส่งรวดเร็ว] ของเล่น Wl 184008 2.4GHz 1/18พื้นที่ทั้งหมดรถออฟโรด60KM/H พร้อมมอเตอร์ไร้แปรงถ่าน",
        "product_image": "https://img.lazcdn.com/g/p/32830a0d3becacba57426a5414c3b666.jpg_200x200q90.jpg",
        "price": 6598.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5278142880.html",
        "sold": 0
    },
    {
        "product_name": "ระบบรอกที่สร้างขึ้นอย่างเชี่ยวชาญสำหรับมอเตอร์ K24ช่วยเพิ่มผลผลิตและอายุการใช้งานที่ยืนยาว",
        "product_image": "https://img.lazcdn.com/g/p/d82c43d4c0dd0c50e60e9aa3d31f3a59.jpg_200x200q90.jpg",
        "price": 6586.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16088250995.html",
        "sold": 0
    },
    {
        "product_name": "6K8-41121-00เรือภายในฝาครอบท่อไอเสียสำหรับมอเตอร์ติดท้ายเรือยามาฮ่า2T 25HP 6K8-41121-00-1S 30HP",
        "product_image": "https://img.lazcdn.com/g/p/19d38eca3309c7b189b8746de69fba60.jpg_200x200q90.jpg",
        "price": 6510,
        "remark": "https://www.lazada.co.th/products/pdp-i16147110675.html",
        "sold": 0
    },
    {
        "product_name": "รถขับเคลื่อนสี่ล้อสำหรับปีนเขาและวิ่งนอกถนน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sadfad9bee9ab4246a7d91b5fb65581aeJ.jpg_200x200q90.jpg",
        "price": 6504.94,
        "remark": "https://www.lazada.co.th/products/pdp-i6031903522.html",
        "sold": 6
    },
    {
        "product_name": "TOMSHOO ฐานขดลวดเครื่องยนต์เรืออายุการใช้งานยาวนานฐานขดลวดมอเตอร์เรือมืออาชีพปรับปรุงประสิทธิภาพการเริ่มต้น69P 85560 00สำหรับ2จังหวะ25 30 HP มอเตอร์ทางทะเล",
        "product_image": "https://img.lazcdn.com/g/p/d8130060776ea0a81a1c76db86fc89ca.jpg_200x200q90.jpg",
        "price": 6398,
        "remark": "https://www.lazada.co.th/products/pdp-i16147150582.html",
        "sold": 0
    },
    {
        "product_name": "ของเล่น Wl 184008 Mobil Remote Control 2.4กิกะเฮิร์ตซ์1/18ทุกพื้นที่รถบรรทุกควบคุมรีโมต60กม./ชม. พร้อมมอเตอร์ไร้แปรงถ่าน",
        "product_image": "https://img.lazcdn.com/g/p/32830a0d3becacba57426a5414c3b666.jpg_webp_200x200q90.jpg",
        "price": 6368.46,
        "remark": "https://www.lazada.co.th/products/pdp-i5301496239.html",
        "sold": 0
    },
    {
        "product_name": "4 ชน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc5a21b0dbb874fb4bead48d4e8cdeebfw.png_200x200q90.png",
        "price": 2209.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16121652235.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO RC Thruster สีดำ RC Motor สำหรับรองรับ2-6S",
        "product_image": "https://img.lazcdn.com/g/p/3a9ce5fe014af08447a6e83ead806a15.jpg_200x200q90.jpg",
        "price": 6302,
        "remark": "https://www.lazada.co.th/products/pdp-i5982557416.html",
        "sold": 0
    },
    {
        "product_name": "เรือยนต์บังคับระยะไกลสำหรับเด็กความปลอดภัยพลังงานต่ำ",
        "product_image": "https://img.lazcdn.com/g/p/45757e007840a4b4eea1c3a44df6903a.jpg_200x200q90.jpg",
        "price": 6228,
        "remark": "https://www.lazada.co.th/products/pdp-i16099750705.html",
        "sold": 0
    },
    {
        "product_name": "66T-45611-00เพลาใบพัดสำหรับมอเตอร์ติดท้ายเรือยามาฮ่า4T F25 F30 F40 2T 40X 40HP 66T-45611เครื่องยนต์เรืออะไหล่มือสอง",
        "product_image": "https://img.lazcdn.com/g/p/af2e3d410658d0f1c7e29e2b47c39e11.jpg_200x200q90.jpg",
        "price": 6144,
        "remark": "https://www.lazada.co.th/products/pdp-i16146711728.html",
        "sold": 0
    },
    {
        "product_name": "JDD LD1296 LDRC ทางวิบากใหม่,แฟลชไดรฟ์สองหัวความเร็วสูงเกียร์โลหะ2ตัวรถ Rc เซอร์โวไฟ Led ของขวัญสำหรับเด็กผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/p/33fac23ca8aa0bef029447b340b7761f.jpg_webp_200x200q90.jpg",
        "price": 5999.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5949392293.html",
        "sold": 1
    },
    {
        "product_name": "Serciya เรือ Transom ประหยัด23 \"-35\" ติดตั้งได้ง่ายมอเตอร์เรือการสนับสนุน",
        "product_image": "https://img.lazcdn.com/g/p/969be3547705b6b2d4290626e9d46ef1.jpg_200x200q90.jpg",
        "price": 5864,
        "remark": "https://www.lazada.co.th/products/pdp-i5823057678.html",
        "sold": 0
    },
    {
        "product_name": "กล่องเกมกระดานหรูหรา เทพเจ้าสมบัติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S351a262b3533451f8728fa1c9b909260u.jpg_200x200q90.jpg",
        "price": 5815.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16107238306.html",
        "sold": 0
    },
    {
        "product_name": "{skfjhw} JDD【Available】【Fast delivery】SCY-16103 1/16 2.4GHz 4wd Rc Car 390 High-speed 38KM/H Carbon Brush Strong Magnetic Motor 5-wire 17g Steering Gear Spring Shock Absorption Car Model Toys",
        "product_image": "https://img.lazcdn.com/g/p/fc7719968377d7a0fbef672fd62abdc9.jpg_200x200q90.jpg",
        "price": 5740,
        "remark": "https://www.lazada.co.th/products/pdp-i16147251173.html",
        "sold": 0
    },
    {
        "product_name": "ชุดแปลงจักรยานไฟฟ้ากันน้ำสำหรับมอเตอร์36V 48V 250W ชุดควบคุมจักรยานไฟฟ้า DIY",
        "product_image": "https://img.lazcdn.com/g/p/f119d9b0008310ac18400caeff0fe46b.jpg_200x200q90.jpg",
        "price": 5530,
        "remark": "https://www.lazada.co.th/products/pdp-i6054068026.html",
        "sold": 0
    },
    {
        "product_name": "Luqeeg ชุดดัดแปลงจักรยานไฟฟ้าจักรยานไฟฟ้า22A ตัวควบคุมมอเตอร์พร้อมแผง GD01ชุดมอเตอร์ไฟฟ้าสำหรับมอเตอร์เกียร์500W",
        "product_image": "https://img.lazcdn.com/g/p/7f4e571ab03605fee102aaa503dc7bd7.jpg_200x200q90.jpg",
        "price": 5474,
        "remark": "https://www.lazada.co.th/products/pdp-i6066492335.html",
        "sold": 0
    },
    {
        "product_name": "พนักงานส่งของ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc73f7d2e93f042e08823509f3146b56cf.png_200x200q90.png",
        "price": 5408.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6011056574.html",
        "sold": 0
    },
    {
        "product_name": "858763 Primer Bulb Parts Mercury Outboard Motor 30-90 1031207AF 1090411VD for 18-7083 Auto Pro Zone",
        "product_image": "https://img.lazcdn.com/g/p/755f0fd6d5b5ee2d4eb166e69e8cd1be.jpg_200x200q90.jpg",
        "price": 5372.44,
        "remark": "https://www.lazada.co.th/products/pdp-i16099866472.html",
        "sold": 0
    },
    {
        "product_name": "Liven | เครื่องปั่นและทำนมถั่วเหลืองเงียบหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1cc04c3faabd4a8ea2437934faec2474v.jpg_200x200q90.jpg",
        "price": 5283.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5968615770.html",
        "sold": 108
    },
    {
        "product_name": "JDD มอเตอร์แปรงรถ RC ความเร็วสูง,C8828 JJRC 1/14สเกลใหม่พื้นที่เต็มรูปแบบของเล่นรีโมทคอนโทรลไฟฟ้าสำหรับเด็กผู้ชายและผู้ใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/7919348bfd0faccda0fbda0f99acf686.jpg_webp_200x200q90.jpg",
        "price": 5168.16,
        "remark": "https://www.lazada.co.th/products/pdp-i5942481663.html",
        "sold": 0
    },
    {
        "product_name": "36120-ZY3 Tilt Trim Motor 12V For Honda Outboard Motor 75HP-225HP 36120-ZY3-023 36120-ZY9-013 36120-ZY3-013",
        "product_image": "https://img.lazcdn.com/g/p/bd5b829ea0d397e2a2f1d02ba926b499.jpg_200x200q90.jpg",
        "price": 5160.06,
        "remark": "https://www.lazada.co.th/products/pdp-i5285056119.html",
        "sold": 0
    },
    {
        "product_name": "TYXIN | เรือรีโมทคอลโทรลความเร็วสูง เครื่องยนต์ไร้แปรงถ่านระบบเย็นด้วยน้ำ สำหรับการแข่งขัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa730ca69b8354765bbe2119abf71a341a.jpg_200x200q90.jpg",
        "price": 5124.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16084697462.html",
        "sold": 0
    },
    {
        "product_name": "(รับประกัน 5 ปี)เลื่อยยนต์  เลื่อยโซ่ยนต์2.5KW  เลื่อยยนต์ตัดไม้ เลื่อยน้ำมันเบนซินกำลังสูงใหม่ 11.5นิ้ว/12นิ้ว การตัดที่ลื่นไหลขึ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0e85328e02364f48b007c7744603327eW.jpg_200x200q90.jpg",
        "price": 5118,
        "remark": "https://www.lazada.co.th/products/pdp-i4475271537.html",
        "sold": 9
    },
    {
        "product_name": "Harilla ขาตั้งแท่นติดตั้งมอเตอร์เรือยางพาราสำหรับกีฬาทางน้ำเครื่องยนต์เรือเรือเล็ก",
        "product_image": "https://img.lazcdn.com/g/p/33da0b77b0f5e56c05470793c1e676a6.jpg_200x200q90.jpg",
        "price": 5090,
        "remark": "https://www.lazada.co.th/products/pdp-i5964983556.html",
        "sold": 0
    },
    {
        "product_name": "Flameer ที่แท่นติดตั้งมอเตอร์เรือยางพาราในน้ำกีฬาขาตั้งเครื่องยนต์เรือเล็กๆ",
        "product_image": "https://img.lazcdn.com/g/p/13fcf571a146934939e43f3af7697812.jpg_200x200q90.jpg",
        "price": 5090,
        "remark": "https://www.lazada.co.th/products/pdp-i6026140888.html",
        "sold": 0
    },
    {
        "product_name": "ชุดแข่งศิลปะการต่อสู้ที่ปรับแต่งได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd945bd4303c54ca68d0cecbc2b9795baq.png_200x200q90.png",
        "price": 5079.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16076604299.html",
        "sold": 0
    },
    {
        "product_name": "ST [จัดส่งรวดเร็ว] เครื่องบิน RC SR22 QIDI580ของแท้ปีกกว้าง2.4ก. 520มม. พร้อมมอเตอร์ไร้แปรงถ่าน & เครื่องบินของเล่นโฟม EPP เครื่องบินผาดโผนสมดุลRC อัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/p/7384cca59a4701499ee49458288234e1.jpg_webp_200x200q90.jpg",
        "price": 5068.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5909917696.html",
        "sold": 0
    },
    {
        "product_name": "ST [ส่งเร็ว] LD1296 LDRC ใหม่ทางวิบากรถ Rc 2แฟลชไดรฟ์สองหัวความเร็วสูงโลหะเกียร์มอเตอร์ Esc เซอร์โวไฟ Led ของขวัญสำหรับเด็กผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/p/33fac23ca8aa0bef029447b340b7761f.jpg_200x200q90.jpg",
        "price": 4722.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5948369014.html",
        "sold": 0
    },
    {
        "product_name": "ระบบติดตั้งมอเตอร์เรือคายัก Ellwewe สำหรับการใช้งาน Trolling กับติดตั้งง่าย",
        "product_image": "https://img.lazcdn.com/g/p/5990597f3329834b31ae1e5beb2072c6.jpg_200x200q90.jpg",
        "price": 4656,
        "remark": "https://www.lazada.co.th/products/pdp-i16092587538.html",
        "sold": 0
    },
    {
        "product_name": "JDD [จัดส่งรวดเร็ว] SCY18103 31กม./ชม. 1/18รถ Rc SCY18103pro 50กม./ชม. ทางวิบาก4X4มอเตอร์แปรงความเร็วสูงมอเตอร์ไร้แปรงถ่านหิมะทะเลทรายรถดริฟท์ของเล่นเด็กชายของขวัญ",
        "product_image": "https://img.lazcdn.com/g/p/93271df4458f3c5e02b523a6e3db7b47.jpg_200x200q90.jpg",
        "price": 4646.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5730191930.html",
        "sold": 0
    },
    {
        "product_name": "ST [ส่งเร็ว] [มีของแท้] เรือเจ็ทกระแสน้ำวนความเร็วสูง TX749 25กม./ชม. มอเตอร์1806ไร้แปรงถ่าน2.4กิกะเฮงเรือเจ็ทและของเล่นเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/29b1bdf73a8eea5396d5dae220f37a72.jpg_webp_200x200q90.jpg",
        "price": 4622.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5705428715.html",
        "sold": 0
    },
    {
        "product_name": "sjlerst Kayak Trolling Motor Mount Locking Lip ขายึดอลูมิเนียมอัลลอยด์สำหรับการผจญภัย",
        "product_image": "https://img.lazcdn.com/g/p/a9cc275dd006ff7b282c91dcc9380ea0.jpg_200x200q90.jpg",
        "price": 4606,
        "remark": "https://www.lazada.co.th/products/pdp-i16147130301.html",
        "sold": 0
    },
    {
        "product_name": "2X Motorboat Reverse Gear Motor for Jetski",
        "product_image": "https://img.lazcdn.com/g/p/a4704ad98dfe3881f30e2266a90b822a.jpg_200x200q90.jpg",
        "price": 3973.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16117729137.html",
        "sold": 0
    },
    {
        "product_name": "ST [ส่งเร็ว] [ของแท้มีให้เลือก] รถออฟโรดความเร็วสูง4wd รถ MJX 18208 1:18รถ RC 30กม./ชม. พร้อมตัวถังที่เปลี่ยนได้2ตัวถังมอเตอร์แปรงถ่าน17G ของเล่นรถ Rc เซอร์โว",
        "product_image": "https://img.lazcdn.com/g/p/83772958e336b25b31a97bb183abc1cc.jpg_200x200q90.jpg",
        "price": 4502.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5914821239.html",
        "sold": 0
    },
    {
        "product_name": "12160-96300ก้าน Conneting ชุดอุปกรณ์ซูซูกิ30HP 25HP 91L00ชิ้นส่วนมอเตอร์เครื่องยนต์เรือท้ายเรือ",
        "product_image": "https://img.lazcdn.com/g/p/463f0f81b3139ee8ae0c7cfbf4984567.jpg_200x200q90.jpg",
        "price": 4482,
        "remark": "https://www.lazada.co.th/products/pdp-i16147106690.html",
        "sold": 0
    },
    {
        "product_name": "ไม่มีข้อมูลเพียงพอในการสร้างชื่อสินค้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scb3c53d3408347b389e9ce9eed5c98e5X.jpg_200x200q90.jpg",
        "price": 4480.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16120609125.html",
        "sold": 0
    },
    {
        "product_name": "CGGUE ไม้ รถประกอบหลากหลาย หุ่นยนต์ผสมผสาน รถไฟรวมฉาก ของเล่นรางรถไฟข้าม ของเล่นอุปกรณ์เสริมรางรถไฟ ทำเอง รางรถไฟวิศวกรรมขนาดเล็ก สำหรับเด็กชายวัยหัดเดิน",
        "product_image": "https://img.lazcdn.com/g/p/e2ed823dea351d194e232cf3d48ef566.jpg_200x200q90.jpg",
        "price": 4454,
        "remark": "https://www.lazada.co.th/products/pdp-i16101216398.html",
        "sold": 0
    },
    {
        "product_name": "JJRC | รถรีโมทคอนโทรลปีนเขาแบบมืออาชีพ",
        "product_image": "https://img.lazcdn.com/3rd/q/aHR0cHM6Ly9hZS1waWMtYTEuYWxpZXhwcmVzcy1tZWRpYS5jb20va2YvUzlmODEyYWYxMTBmYjRkNzdhYjYxZGU2MGI3MWRjMjFhcS5qcGc=_200x200q90.png",
        "price": 4440.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6066577713.html",
        "sold": 2
    },
    {
        "product_name": "JJRC | รถบังคับหลายฟังก์ชันแบบออฟโรด โมเดลฮัมเมอร์ทหาร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd4930b7ddd2a47dc9aa543f83bd43cfdv.jpg_200x200q90.jpg",
        "price": 4439.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6066635656.html",
        "sold": 2
    },
    {
        "product_name": "เครื่องยนต์เรือปรับความหนักได้เรือประหยัดขวางทำจากโลหะมีความแข็งแรงสูง",
        "product_image": "https://img.lazcdn.com/g/p/1d37c94930956cea7b96f69e56a70af0.jpg_200x200q90.jpg",
        "price": 4284,
        "remark": "https://www.lazada.co.th/products/pdp-i6035937981.html",
        "sold": 0
    },
    {
        "product_name": "ชุดอัปเกรด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S74ef75b5f66d4b44900c0a6b4b53f0d88.jpg_200x200q90.jpg",
        "price": 4213.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16119450335.html",
        "sold": 0
    },
    {
        "product_name": "JDD [จัดส่งรวดเร็ว] ZLL SG202สูงสุด2.4กรัม4WD รถดริฟท์การแข่งรถความเร็วสูง1:20 50นาที55กม./ชม. มอเตอร์ไร้แปรงรถ RC รถของเล่นออฟโรด SG202รถ RC รถของเล่น RC แบบ PRO",
        "product_image": "https://img.lazcdn.com/g/p/e72e35f83851865933fe77e651880ae7.jpg_200x200q90.jpg",
        "price": 4201.72,
        "remark": "https://www.lazada.co.th/products/pdp-i5730210735.html",
        "sold": 1
    },
    {
        "product_name": "Electric Bike for DZ5348 Mid-Drive Motor Display, CAN Protocol Color Screen",
        "product_image": "https://img.lazcdn.com/g/p/b95c092ae78faa96e95ab2a3b8c1c68c.jpg_200x200q90.jpg",
        "price": 4072.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16120682320.html",
        "sold": 0
    },
    {
        "product_name": "ทำจากหนง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5be31a844e66431a92c1a8d285b8c967P.png_200x200q90.png",
        "price": 4010.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16120645451.html",
        "sold": 0
    },
    {
        "product_name": "6 ชน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S870ea1a70fe54cd484ce3c2b9c811bdep.png_200x200q90.png",
        "price": 3995,
        "remark": "https://www.lazada.co.th/products/pdp-i16120714575.html",
        "sold": 0
    },
    {
        "product_name": "DANBAOLUO | ชุดเดรสยาวสำหรับแสดงทังโก สีไล่ระดับ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S77825353e94a4439aa925562af9dea1f3.jpg_200x200q90.jpg",
        "price": 3969.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6016635095.html",
        "sold": 0
    },
    {
        "product_name": "ผลตในประเทศ _สงดวน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5ee175a6c1d74648bc2f8f37303f731bB.png_200x200q90.png",
        "price": 3960.76,
        "remark": "https://www.lazada.co.th/products/pdp-i5978580463.html",
        "sold": 0
    },
    {
        "product_name": "ST [ส่งเร็ว] SCY18103 31กม./ชม. 1/18รถ Rc SCY18103pro 50กม./ชม. ทางวิบาก4X4มอเตอร์แปรงความเร็วสูงมอเตอร์ไร้แปรงถ่านหิมะทะเลทรายรถดริฟท์ของเล่นเด็กชายของขวัญ",
        "product_image": "https://img.lazcdn.com/g/p/93271df4458f3c5e02b523a6e3db7b47.jpg_webp_200x200q90.jpg",
        "price": 3948.24,
        "remark": "https://www.lazada.co.th/products/pdp-i5746837432.html",
        "sold": 0
    },
    {
        "product_name": "Super Power 480 Motor รุ่นที่สอง NdFeB แรงบิดสูงความเร็วสูงเบอร์ 2 เวฟ",
        "product_image": "https://img.lazcdn.com/g/p/3a6385538fbdd9358d6204c43c980e12.jpg_200x200q90.jpg",
        "price": 3945,
        "remark": "https://www.lazada.co.th/products/pdp-i5960318283.html",
        "sold": 0
    },
    {
        "product_name": "JJRC | ของเล่นรถถังรีโมทคอนโทรลสำหรับดริฟต์ความเร็วสูง ขนาดทุกมาตราฐาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf14a7a03236948e0b90000ef663646a8e.jpg_200x200q90.jpg",
        "price": 3939.04,
        "remark": "https://www.lazada.co.th/products/pdp-i6066476753.html",
        "sold": 2
    },
    {
        "product_name": "Sharprepublic ชั้นวางมอเตอร์เรือคายักตกปลาแบบพกพาติดตั้งติดตั้งอย่างรวดเร็วเครื่องยนต์เรือเรือคายัคสำหรับเรือยาง",
        "product_image": "https://img.lazcdn.com/g/p/4d19b383b080583d89752e88561dda14.jpg_200x200q90.jpg",
        "price": 3930,
        "remark": "https://www.lazada.co.th/products/pdp-i16136133044.html",
        "sold": 0
    },
    {
        "product_name": "JOYTOY | หุ่นยนต์โจมตีหนัก 02",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S406447ad13664dd688c9c75281c6fc7a4.png_200x200q90.png",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i5996940569.html",
        "sold": 3
    },
    {
        "product_name": "มอเตอร์ลากเรือคายัคแบบสแตนเลส91ซม. พร้อมฮาร์ดแวร์",
        "product_image": "https://img.lazcdn.com/g/p/a24f909e94f4d29373474e7aa83f184b.jpg_200x200q90.jpg",
        "price": 3868,
        "remark": "https://www.lazada.co.th/products/pdp-i6040903090.html",
        "sold": 0
    },
    {
        "product_name": "JDD [ส่งเร็ว] TX749เจ็ทวอร์เทกซ์ความเร็วสูง25กม./ชม. มอเตอร์1806ไร้แปรงถ่าน2.4GHz เรือเจ็ทและของเล่นเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/29b1bdf73a8eea5396d5dae220f37a72.jpg_200x200q90.jpg",
        "price": 3841.52,
        "remark": "https://www.lazada.co.th/products/pdp-i5705546245.html",
        "sold": 0
    },
    {
        "product_name": "1 ใบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5caa2288c7e3459097b0d1179709b8faR.png_200x200q90.png",
        "price": 3443.4,
        "remark": "https://www.lazada.co.th/products/pdp-i16121323457.html",
        "sold": 0
    },
    {
        "product_name": "Perfeclan แพดเดิลบอร์ดที่ไฟ LED ความแข็งแรงเปลี่ยนไฟสำหรับเรือแคนูเรือยนต์",
        "product_image": "https://img.lazcdn.com/g/p/1ee037bb70a818cd8151c580f532ab3e.jpg_200x200q90.jpg",
        "price": 3740.06,
        "remark": "https://www.lazada.co.th/products/pdp-i5872904969.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องยนต์เรือชุดตัวเรือนเครื่องยนต์เรือซีลน้ำมันมอเตอร์เสถียรสำหรับการเปลี่ยน",
        "product_image": "https://img.lazcdn.com/g/p/a78502e78517377cdf3845bd08d2102d.jpg_200x200q90.jpg",
        "price": 3676,
        "remark": "https://www.lazada.co.th/products/pdp-i5774129384.html",
        "sold": 0
    },
    {
        "product_name": "ที่วางแท็บเล็ตเป่าลมชุดติดตั้งเรือคายัคที่สนับสนุนสเตปมอเตอร์ยังคงมีประสิทธิภาพสูง",
        "product_image": "https://img.lazcdn.com/g/p/2283f41eab60984b77001130412400ef.jpg_200x200q90.jpg",
        "price": 3609.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6066498079.html",
        "sold": 0
    },
    {
        "product_name": "เซนต์ [จัดส่งรวดเร็ว] ZLL SG202สูงสุด2.4กรัม4WD รถดริฟท์การแข่งรถความเร็วสูง1:20 50นาที55กม./ชม. มอเตอร์ไร้แปรงรถ RC รถของเล่นออฟโรด SG202รถ RC รถของเล่น RC แบบ PRO",
        "product_image": "https://img.lazcdn.com/g/p/e72e35f83851865933fe77e651880ae7.jpg_webp_200x200q90.jpg",
        "price": 3590.58,
        "remark": "https://www.lazada.co.th/products/pdp-i5746899305.html",
        "sold": 0
    },
    {
        "product_name": "Programmed USB for BBS01 BBS02 Mid Drive Center Electric Bike Motor CAN Protocol Cable",
        "product_image": "https://img.lazcdn.com/g/p/2f4926f78dd9710cb2b93a2183e54b67.jpg_200x200q90.jpg",
        "price": 3514,
        "remark": "https://www.lazada.co.th/products/pdp-i16140103525.html",
        "sold": 0
    },
    {
        "product_name": "รนมน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se2ddd708eccd4be897601314893916c8Z.png_200x200q90.png",
        "price": 3455.4,
        "remark": "https://www.lazada.co.th/products/pdp-i16119005835.html",
        "sold": 0
    },
    {
        "product_name": "มอเตอร์ไร้แปรงถ่าน4370kv กับ F540 60A ดัดแปลง ESC DIY ขนาดกะทัดรัด",
        "product_image": "https://img.lazcdn.com/g/p/d52774d0667cc581cee2eaff625698cb.jpg_200x200q90.jpg",
        "price": 3450,
        "remark": "https://www.lazada.co.th/products/pdp-i6054025716.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าเก็บของเครื่องยนต์เรือสูงกระเป๋าหิ้วเหมาะกับเพลารุ่นสั้น",
        "product_image": "https://img.lazcdn.com/g/p/9b238c19878379b4e544be95eac46016.jpg_200x200q90.jpg",
        "price": 3418,
        "remark": "https://www.lazada.co.th/products/pdp-i16125044544.html",
        "sold": 0
    },
    {
        "product_name": "ของเล่นวิทยาศาสตร์ทางกายภาพมอเตอร์เครื่องสเตอร์โมเดลเครื่องยนต์สเตอร์ลิงแบบใช้ลมร้อน",
        "product_image": "https://img.lazcdn.com/g/p/b9cefc692a34bc99d8e942d90498360e.jpg_200x200q90.jpg",
        "price": 3319.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6031681848.html",
        "sold": 0
    },
    {
        "product_name": "Prettyia ชั้นวางประสิทธิภาพสูงสำหรับขาตั้งมอเตอร์เรือพรีเมี่ยม",
        "product_image": "https://img.lazcdn.com/g/p/03a55660f5436be9175c2feac7d59645.jpg_200x200q90.jpg",
        "price": 3291.54,
        "remark": "https://www.lazada.co.th/products/pdp-i6070732263.html",
        "sold": 0
    },
    {
        "product_name": "ชุดระบายความร้อนด้วยสแตนเลสสำหรับมอเตอร์ซีรีส์ LS ช่วยเพิ่มประสิทธิภาพเคสระบายความร้อน",
        "product_image": "https://img.lazcdn.com/g/p/aadac4d1e46c84dff6fe0fddabad438c.jpg_200x200q90.jpg",
        "price": 3279.88,
        "remark": "https://www.lazada.co.th/products/pdp-i6007773126.html",
        "sold": 0
    },
    {
        "product_name": "มอเตอร์แบบไร้แปรงถ่านสำหรับ1/4รถ RC มอเตอร์แรงบิดสูง60A แบบ F540ชุดมอเตอร์",
        "product_image": "https://img.lazcdn.com/g/p/eedb0701c9846cfd3ea42fa085e82931.jpg_200x200q90.jpg",
        "price": 3274,
        "remark": "https://www.lazada.co.th/products/pdp-i6019895031.html",
        "sold": 0
    },
    {
        "product_name": "JDD [มีอยู่ตอนนี้] [จัดส่งรวดเร็ว] รถบรรทุกดริฟท์จำลองแบบรถ RC 1/10 D-14 D14 4WD แปรงมอเตอร์280ปีนรถไฟ LED ของเล่นรถ RC บนถนนสำหรับเป็นของขวัญเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/ebb9500f79fb6e52d8b73bf9a691e64a.png_200x200q90.png",
        "price": 3246.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5244835053.html",
        "sold": 8
    },
    {
        "product_name": "รถบรรทุกดริฟท์จำลอง1/10 D-14 D14 WPL,รถบรรทุกดริฟท์280แปรงมอเตอร์ปีนรถของเล่นรถ RC บนถนนไฟ LED สำหรับเป็นของขวัญเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/a6ee251329d8a57ca46e1f8e6a0f937d.png_200x200q90.png",
        "price": 3246.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5264811279.html",
        "sold": 0
    },
    {
        "product_name": "15100-90j11-000 Fuel Pump Assy For Suzuki Outboard Df50-Df140 40hp-140hp 15100-90j00 15100-90j00-000 15100-90j11 Boat Motor",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Hb84ab6b9dfef4cd59f5abacf6a75f7f2Y.jpg_200x200q90.jpg",
        "price": 3196,
        "remark": "https://www.lazada.co.th/products/pdp-i5969924378.html",
        "sold": 0
    },
    {
        "product_name": "ของขวัญบล็อกสร้างสรรค์ DIY สำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1e525491051645b3b40873341573d8abn.png_200x200q90.png",
        "price": 3094.04,
        "remark": "https://www.lazada.co.th/products/pdp-i6066799519.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA-รูปลักษณ์สวยงามตัวยึดมอเตอร์สำหรับเรือตัววงเล็บยึดมอเตอร์ที่มีน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/ee09d9af33b8e89b86dfc9e8642f3e61.jpg_200x200q90.jpg",
        "price": 3078,
        "remark": "https://www.lazada.co.th/products/pdp-i5801469730.html",
        "sold": 0
    },
    {
        "product_name": "เพลาใบพัดมอเตอร์เรือแบบ2จังหวะสำหรับ15HP 15/18 45611 00ทนทานน้ำหนักเบา683",
        "product_image": "https://img.lazcdn.com/g/p/d550ebb2aaf953bcff19953295e038ad.jpg_200x200q90.jpg",
        "price": 2982,
        "remark": "https://www.lazada.co.th/products/pdp-i6058784132.html",
        "sold": 0
    },
    {
        "product_name": "เรืออาร์ซี1/32 TX694 2.4ก. มอเตอร์ไร้แปรงถ่านความเร็วสูง8กม./ชม.,เรือของเล่นสำหรับเด็กโมเดลสปีดโบ้ทกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/e06ec2daa7c5b3328d3976d3624bda4f.jpg_webp_200x200q90.jpg",
        "price": 2968.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5386485152.html",
        "sold": 1
    },
    {
        "product_name": "มอเตอร์ขับเคลื่อน Ebike สายลงโปรแกรม USB รถรุ่น Bafang สำหรับ BBS0102",
        "product_image": "https://img.lazcdn.com/g/p/7c32266ded1b70c0b61b0d5b6a8b33ff.jpg_200x200q90.jpg",
        "price": 2960,
        "remark": "https://www.lazada.co.th/products/pdp-i6073773042.html",
        "sold": 0
    },
    {
        "product_name": "แท่นแขวนมอเตอร์เรือน้ำหนักเบาแป้นชะลอแบบมอเตอร์เรือสำหรับเรือยางสำหรับแล่นเรือใบ",
        "product_image": "https://img.lazcdn.com/g/p/a91291a04b3eb592898ce234f7f01bd4.jpg_200x200q90.jpg",
        "price": 2942,
        "remark": "https://www.lazada.co.th/products/pdp-i6068262519.html",
        "sold": 0
    },
    {
        "product_name": "แป้นชะลอมอเตอร์เรือ ABS สีดำมอเตอร์เรือแขวนยืนใช้กันอย่างแพร่หลายสำหรับตกปลาสำหรับเรือยาง",
        "product_image": "https://img.lazcdn.com/g/p/57a17dcf060f8bd472ea2cd38ca2f83f.jpg_200x200q90.jpg",
        "price": 2942,
        "remark": "https://www.lazada.co.th/products/pdp-i6058965022.html",
        "sold": 0
    },
    {
        "product_name": "ชุดก้านสูบ12161-94400สำหรับมอเตอร์ Suzuki Outboard DT40C DT40 DT50A DT55 DT60 DT65 12160-94400 92L00เปลี่ยนเครื่องยนต์เรือ",
        "product_image": "https://img.lazcdn.com/g/p/3b61a5e437f07b5fbf0ee33ee4f64d23.jpg_200x200q90.jpg",
        "price": 2906,
        "remark": "https://www.lazada.co.th/products/pdp-i16147206185.html",
        "sold": 0
    },
    {
        "product_name": "Befairy แท่นวางมอเตอร์เรือติดพายเรือแคนูเรือคายัคฮาร์ดแวร์ทางทะเลสำหรับอุปกรณ์ Motor Listrik",
        "product_image": "https://img.lazcdn.com/g/p/5278ca3659cdec43a7d0c60df80b75b6.jpg_200x200q90.jpg",
        "price": 2878,
        "remark": "https://www.lazada.co.th/products/pdp-i16094968372.html",
        "sold": 0
    },
    {
        "product_name": "TOOYFUL ไฟฟ้า Trolling Motor วงเล็บชิ้นส่วนบานพับมอเตอร์เรือ Premium",
        "product_image": "https://img.lazcdn.com/g/p/6e74e302d05db700df3b053aa44e5f58.jpg_200x200q90.jpg",
        "price": 2858,
        "remark": "https://www.lazada.co.th/products/pdp-i6040849114.html",
        "sold": 0
    },
    {
        "product_name": "Retail For  Terrova/Riptide Ulterra PowerDrive Trolling Motor Stabilizer Mount",
        "product_image": "https://img.lazcdn.com/g/p/d9ecbcf7933afabc3e5a54bc90781d3e.jpg_200x200q90.jpg",
        "price": 2826,
        "remark": "https://www.lazada.co.th/products/pdp-i16140109277.html",
        "sold": 0
    },
    {
        "product_name": "5 ชน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S335831b4d49d441bb1bdf6f7f4ba0c09S.png_200x200q90.png",
        "price": 2793.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16117940359.html",
        "sold": 0
    },
    {
        "product_name": "ชุดโมเดลเครื่องยนต์สเตอร์ลิงเครื่องยนต์สเตอร์ลิงมอเตอร์ป้องกันเสียงรบกวนต่ำสีดำใช้งานง่ายสำหรับครู",
        "product_image": "https://img.lazcdn.com/g/p/fab8c9c5d8233fde357ebf56c02a8da2.jpg_200x200q90.jpg",
        "price": 2770,
        "remark": "https://www.lazada.co.th/products/pdp-i6015014741.html",
        "sold": 0
    },
    {
        "product_name": "ลิงก์ในการตั้งค่า",
        "product_image": "https://img.lazcdn.com/g/p/c0e6e61d25f3086a0fd228f6eba19fe9.jpg_200x200q90.jpg",
        "price": 2754,
        "remark": "https://www.lazada.co.th/products/pdp-i5976961088.html",
        "sold": 0
    },
    {
        "product_name": "ที่ยึดรถพ่วงและลูกกลิ้งมอเตอร์เรือขนาด23ถึง35นิ้วสำหรับเรือ",
        "product_image": "https://img.lazcdn.com/g/p/3f9f249e9005201dd7e0256ff1a32ae8.jpg_200x200q90.jpg",
        "price": 2744,
        "remark": "https://www.lazada.co.th/products/pdp-i16122676578.html",
        "sold": 0
    },
    {
        "product_name": "สดำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1b5e2a372f234d3f8110edbd54cc7a04N.png_200x200q90.png",
        "price": 2723.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16109901432.html",
        "sold": 0
    },
    {
        "product_name": "มอเตอร์โมเดลเครื่องบินมอเตอร์ไม่มีแปรง RC แบบไม่มีแปรงถ่าน Lepmerk น้ำหนักเบาแรงบิดของใบพัดที่ดีเยี่ยมสำหรับการซ่อม",
        "product_image": "https://img.lazcdn.com/g/p/17cbaa68abddf050270520bd6fe4ff40.jpg_200x200q90.jpg",
        "price": 2720,
        "remark": "https://www.lazada.co.th/products/pdp-i6012761649.html",
        "sold": 0
    },
    {
        "product_name": "【Popular choice】 Hangkai Outboard Motor Parts Large And Small Gears Spline Shafts For 3.5 Horse Power 2 Stroke Boat Engine Access",
        "product_image": "https://img.lazcdn.com/g/p/8d45359f749297249e86014b45980561.jpg_200x200q90.jpg",
        "price": 2717.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5653668577.html",
        "sold": 0
    },
    {
        "product_name": "【Bestseller】 Greentag DTF การไหลเวียนของหมึกสีขาวพร้อมมอเตอร์กวนพร้อมอะแดปเตอร์แปลงไฟหมึกสีขาว250มล. สำหรับ L800 L1800 L1390 L805เครื่องพิมพ์ DTF",
        "product_image": "https://img.lazcdn.com/g/p/cb6f20def61e440af1435e8e9d3f4a25.jpg_200x200q90.jpg",
        "price": 2688.36,
        "remark": "https://www.lazada.co.th/products/pdp-i4868547840.html",
        "sold": 2
    },
    {
        "product_name": "ไม่มีข้อมูล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa09052fb05f444e0994e0c718e051648k.jpg_200x200q90.jpg",
        "price": 2677.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16052760812.html",
        "sold": 0
    },
    {
        "product_name": "การรับประกัน 5 ปี ไม่ต้องซ่อม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8e2ec002d2ab4b45b6e2bd5083d074ceo.jpg_200x200q90.jpg",
        "price": 2601.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16083754042.html",
        "sold": 0
    },
    {
        "product_name": "3bj-64010 Forward Gear For Tohatsu Outboard Motor 9.9hp 15hp 18hp 4 Stroke 3bj-64010-0 ;3bj640100",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S8119922908234fa7b43604bfcc9ea09cZ.jpg_200x200q90.jpg",
        "price": 2598,
        "remark": "https://www.lazada.co.th/products/pdp-i5969966085.html",
        "sold": 0
    },
    {
        "product_name": "ชุดสตาร์ตเตอร์มอเตอร์เรือมีความไวต่อการสัมผัสทนความชื้น69W 14380 00สำหรับ F60 4จังหวะด้านนอก",
        "product_image": "https://img.lazcdn.com/g/p/358e5a31ea4964183f72195f1802682e.jpg_200x200q90.jpg",
        "price": 2556,
        "remark": "https://www.lazada.co.th/products/pdp-i16087987299.html",
        "sold": 0
    },
    {
        "product_name": "โปรโมชั่นพิเศษ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8ca025d268484947ac3170936591cfefH.png_200x200q90.png",
        "price": 2551.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16095008590.html",
        "sold": 0
    },
    {
        "product_name": "ทั่วไป เครื่องบันทึกการขับขี่",
        "product_image": "https://img.lazcdn.com/g/p/d847d9e9bf84865a221ba2975103d697.png_200x200q90.png",
        "price": 2477.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5919474542.html",
        "sold": 0
    },
    {
        "product_name": "ขดลวดกระแสสลับมอเตอร์เรือติดตั้งง่าย3AA-06023-0ที่แม่นยำสำหรับ9.9HP 8HP เครื่องยนต์นอกเรือ",
        "product_image": "https://img.lazcdn.com/g/p/fed3a51eb406936e76488eb545dbaab8.jpg_200x200q90.jpg",
        "price": 2438,
        "remark": "https://www.lazada.co.th/products/pdp-i6035942241.html",
        "sold": 0
    },
    {
        "product_name": "โสมอเมริกันหั่นบางๆของแท้ .AutoMaxion",
        "product_image": "https://img.lazcdn.com/g/p/502648c56e9894d2f5f93433b8daac34.jpg_200x200q90.jpg",
        "price": 2420.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16087828267.html",
        "sold": 0
    },
    {
        "product_name": "Eelhoe】มอเตอร์ PWM ดิจิตอลขั้นสูงเครื่องควบคุมความเร็วความจุ30A ระยะไกลแบบไร้สาย (ของมาใหม่สินค้าคงคลังขนาดใหญ่)",
        "product_image": "https://img.lazcdn.com/g/p/b878218aff4e3da200a5b507aa9a701a.jpg_200x200q90.jpg",
        "price": 2404,
        "remark": "https://www.lazada.co.th/products/pdp-i16147648722.html",
        "sold": 0
    },
    {
        "product_name": "Marine Boat Ocean Ship Trolling Motor Outboard Connector Handle Anodized Aluminum Fixed Type 44.6cm",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Hca839b9ab6d74133a74c8fccbb687129E.jpg_200x200q90.jpg",
        "price": 2398,
        "remark": "https://www.lazada.co.th/products/pdp-i5969944173.html",
        "sold": 0
    },
    {
        "product_name": "มอเตอร์ไม่มีแปรงทรัสเตอร์เรือ RC 12 24V 20A 300KV สำหรับพีซี PLA",
        "product_image": "https://img.lazcdn.com/g/p/ad22d0a1fc35b440d8d40389d9f31022.jpg_200x200q90.jpg",
        "price": 2386,
        "remark": "https://www.lazada.co.th/products/pdp-i16136851552.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเดรสแขนกุดทรงเอ สไตล์มินิมอลฝรั่งเศส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0683f3710c964870a8882e191e5b15e5V.jpg_200x200q90.jpg",
        "price": 2366.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16096359088.html",
        "sold": 4
    },
    {
        "product_name": "ส่วนประกอบหลายแบบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1d90a9afd0e54b6e82c52dce0aeb9c378.jpg_200x200q90.jpg",
        "price": 2357.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16063968746.html",
        "sold": 0
    },
    {
        "product_name": "ไฟเพดาน LED แบบมินิมอลสว่างมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7721099135f14583b728188bb712d91d0.jpg_200x200q90.jpg",
        "price": 2355.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16084386823.html",
        "sold": 0
    },
    {
        "product_name": "ดวงจันทร์วิลโลว์2ครั้ง15/18เครื่องยนต์เรือหัวกุญแจ",
        "product_image": "https://img.lazcdn.com/g/p/5fbab51dd532978575c8a60bcf734840.jpg_200x200q90.jpg",
        "price": 2354,
        "remark": "https://www.lazada.co.th/products/pdp-i16128549006.html",
        "sold": 0
    },
    {
        "product_name": "【Exclusive Online Deals】 12100-93120-025 Piston Set 025 For Suzuki Outboard Motor 2t 9.9hp 15hp Dt15 Outboard Motor Two Stroke 12100-93120 Oversize 025",
        "product_image": "https://img.lazcdn.com/g/p/e55109c3ccd93384fe0b964822a483ad.jpg_200x200q90.jpg",
        "price": 2323.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5651839009.html",
        "sold": 0
    },
    {
        "product_name": "Camerina Surpass 3650 5900KV 4ขั้วมอเตอร์ไร้ขอบสำหรับ1/10 1/16 1/18รถ RC อุปกรณ์เสริมสำหรับเรือ",
        "product_image": "https://img.lazcdn.com/g/p/e2b3ffb09d859a0c4e967a4d05ca4579.jpg_200x200q90.jpg",
        "price": 2320,
        "remark": "https://www.lazada.co.th/products/pdp-i16086212378.html",
        "sold": 0
    },
    {
        "product_name": "[12/5/26] TAMIYA 22098 R/C 540 Brushed Super Stock VZ Motor (23T)",
        "product_image": "https://img.lazcdn.com/g/p/2443ae0e1804e572da9ddb7b46c31916.png_200x200q90.png",
        "price": 2300,
        "remark": "https://www.lazada.co.th/products/pdp-i16146391388.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องมือติดตั้งและถอดフォーก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2092818c30d74eb191dae8271c534638H.jpg_200x200q90.jpg",
        "price": 2262,
        "remark": "https://www.lazada.co.th/products/pdp-i16101689014.html",
        "sold": 0
    },
    {
        "product_name": "Uan Marine Boat Motor Upper Front Motor Mount For Johnson Evinrude 20 25 30 35 1979-2005 331812",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Sab66f43047264521a9f8949e9ebc5ea36.jpg_200x200q90.jpg",
        "price": 2250,
        "remark": "https://www.lazada.co.th/products/pdp-i5969898654.html",
        "sold": 0
    },
    {
        "product_name": "17450-93930 Water Inlet Housing For Suzuki Outboard Motor 15hp 2t Include Seal 17450-93921;17450-94j00",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/H78e46336e1584d8195446ce27507d78cL.jpg_200x200q90.jpg",
        "price": 2194,
        "remark": "https://www.lazada.co.th/products/pdp-i5969924364.html",
        "sold": 0
    },
    {
        "product_name": "PHINK | หุ่นยนต์แชท AI บนพื้นฐานของ ESP32",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf1afc43df71f490bab0ef3297d3730a1W.png_200x200q90.png",
        "price": 2172,
        "remark": "https://www.lazada.co.th/products/pdp-i6006187887.html",
        "sold": 0
    },
    {
        "product_name": "มอเตอร์เรือเพลาขับ45510 01เพลาขับยาวแบบยืดหยุ่นสำหรับมอเตอร์เครื่องยนต์เอาท์บอร์ด",
        "product_image": "https://img.lazcdn.com/g/p/f5fa42a872ba8db0df4f8f471b22ecac.jpg_200x200q90.jpg",
        "price": 2172,
        "remark": "https://www.lazada.co.th/products/pdp-i6019133248.html",
        "sold": 0
    },
    {
        "product_name": "【Must-Have Accessories】 Boat Outboard Motor Cover Dustproof Sunproof Pu Coating Engine Protector Accessories With Storage Bag 60-100hp",
        "product_image": "https://img.lazcdn.com/g/p/9c4840550c8b94694c39543c4d006026.jpg_200x200q90.jpg",
        "price": 2149.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5651695496.html",
        "sold": 0
    },
    {
        "product_name": "Hangkai 2 Stroke 4 Outboard Motors Boat Motor Water Pump Assembly",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/H1c033a29138b44e2b9f0b6e638c3cbe5U.jpg_200x200q90.jpg",
        "price": 2142,
        "remark": "https://www.lazada.co.th/products/pdp-i5969937193.html",
        "sold": 0
    },
    {
        "product_name": "ติดตั้งบนมอเตอร์เรือ Prettyia",
        "product_image": "https://img.lazcdn.com/g/p/76d7ba166a04061ccccd677959403655.jpg_200x200q90.jpg",
        "price": 2122.32,
        "remark": "https://www.lazada.co.th/products/pdp-i6070689599.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องยนต์เรือโพลีเอสเตอร์ฝาปิดเครื่องยนต์กันน้ำกันลมมีกระเป๋าเก็บของ",
        "product_image": "https://img.lazcdn.com/g/p/c57e1411aae8a94d7bdd3e4362900930.jpg_200x200q90.jpg",
        "price": 2098,
        "remark": "https://www.lazada.co.th/products/pdp-i6066544102.html",
        "sold": 0
    },
    {
        "product_name": "【Must-Have Accessories】 Ppyy-Mini Hot Air Stirling Engine Motor Model Stream Power Physics Experiment Model Educational Science Toy For Children",
        "product_image": "https://img.lazcdn.com/g/p/65435aa54a9b72cc5607941d246cac96.jpg_200x200q90.jpg",
        "price": 2094,
        "remark": "https://www.lazada.co.th/products/pdp-i5160527386.html",
        "sold": 0
    },
    {
        "product_name": "Perfeclan มอเตอร์เรือติดชุดตัวยึดความน่าเชื่อถือสูงตัวยึดแบบทนทานเรือคายัคตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/13aa24224e2c41be0b4a6a0f726bbd47.jpg_200x200q90.jpg",
        "price": 2079.44,
        "remark": "https://www.lazada.co.th/products/pdp-i6066575363.html",
        "sold": 0
    },
    {
        "product_name": "420d Black Boat Full Outboard Engine Cover Heavy Engine Motor Protector For 175-225hp / 250-350hp Waterproof",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S83e636bd5eec48e4abd8155cf993aef2Q.jpg_200x200q90.jpg",
        "price": 2068,
        "remark": "https://www.lazada.co.th/products/pdp-i5969936218.html",
        "sold": 0
    },
    {
        "product_name": "แขนบังคับเลี้ยวเครื่องยนต์เรือไม่เหมือนจริงก้านสูบสแตนเลสปรับได้สำหรับ15-200HP",
        "product_image": "https://img.lazcdn.com/g/p/40cd086e2e0873dbbc2359c27e2a4377.jpg_200x200q90.jpg",
        "price": 2066,
        "remark": "https://www.lazada.co.th/products/pdp-i16084665526.html",
        "sold": 0
    },
    {
        "product_name": "335359 Cylinder Gasket For Evinrude Johnson Omc Outboard Motor Fits 40hp 45hp 48hp 50hp 55hp 60hp; 0320658;320658;327795",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Saceeb0bb650c4fc28868fdf00619346c0.jpg_200x200q90.jpg",
        "price": 2042,
        "remark": "https://www.lazada.co.th/products/pdp-i5969870951.html",
        "sold": 0
    },
    {
        "product_name": "【Discount】 【",
        "product_image": "https://img.lazcdn.com/g/p/3552e6da0b5623a68a6c5b2fffab6aa7.jpg_200x200q90.jpg",
        "price": 2020.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16119759661.html",
        "sold": 0
    },
    {
        "product_name": "forever princess | ชุดอุปกรณ์วาดรูปหลายประโยชน์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2212aba5d08c490dbdfbd76cfdcac7021.jpg_200x200q90.jpg",
        "price": 2020,
        "remark": "https://www.lazada.co.th/products/pdp-i16080443490.html",
        "sold": 0
    },
    {
        "product_name": "WDAir หม้อสนามแคมป์ปิ้งเครื่องครัวกลางแจ้งขนาด5.5ลิตรสำหรับ5-8คนหม้อไอน้ำไทเทเนียมหม้อตุ๋นสำหรับบาร์บีคิวครอบครัวรูยูเนี่ยนเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/62be5fc9181541f6784527204f653f44.jpg_200x200q90.jpg",
        "price": 43542,
        "remark": "https://www.lazada.co.th/products/pdp-i5972224706.html",
        "sold": 0
    },
    {
        "product_name": "Benent หม้อต้มหม้อต้มหม้อสนาม5.5ลิตร,หม้อซุปทำอาหารสำหรับท่องเที่ยวครอบครัวรวมตัวปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/3b2b2b4cb3d5e4c7f9df9fc935b601ed.jpg_200x200q90.jpg",
        "price": 35328,
        "remark": "https://www.lazada.co.th/products/pdp-i16084637122.html",
        "sold": 0
    },
    {
        "product_name": "Snowpeak | ชุดเครื่องครัวอลูมิเนียมความจุใหญ่สำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5523b4611703432a93a192dd022b5f203.jpg_200x200q90.jpg",
        "price": 32887.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5875713366.html",
        "sold": 1
    },
    {
        "product_name": "เตาผิงเอทานอลแบบตั้งได้สำหรับตกแต่งบ้านเตาผิงแคมป์ไฟไฟกลางแจ้งสำหรับเดินเขาสวนแบกเป้ปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/8b024a2ddc39471e36322255638c8fc1.jpg_200x200q90.jpg",
        "price": 31166,
        "remark": "https://www.lazada.co.th/products/pdp-i16056507052.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องครัวเครื่องล้างจานปลอดภัยอเนกประสงค์แบบไม่ติดกระถางและกระทะใช้งานได้จริงชุดทำอาหารในครัวมีด้ามจับที่ถอดออกได้",
        "product_image": "https://img.lazcdn.com/g/p/cc782e334004a3f845e125f10d84e269.jpg_200x200q90.jpg",
        "price": 17296,
        "remark": "https://www.lazada.co.th/products/pdp-i6018560972.html",
        "sold": 0
    },
    {
        "product_name": "SYSTEM-1L-371g ทำอาหารแฟลช Jetboil",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa3995f306ed34c31af7063d3a6883e5fW.jpg_200x200q90.jpg",
        "price": 16992,
        "remark": "https://www.lazada.co.th/products/pdp-i16114411970.html",
        "sold": 0
    },
    {
        "product_name": "Campart Travel KI-0752 Camping Kitchen Valencia ชุดครัวเคลื่อนที่พับได้ Foldable Camping ของแท้ UK Import *ไม่รวมเตาและอุปกรณ์ครัวอื่นๆ* Authentic Great for Survival Camping Hiking Outdoor Kitchen",
        "product_image": "https://img.lazcdn.com/g/p/a536430c24aba433c846cb9f1891bd26.jpg_200x200q90.jpg",
        "price": 16000,
        "remark": "https://www.lazada.co.th/products/pdp-i1885902799.html",
        "sold": 0
    },
    {
        "product_name": "แคมป์ปิ้งกลางแจ้ง2L หม้อแรงดันหม้อหุงข้าวเตาอเนกประสงค์หม้ออาหารสแตนเลส",
        "product_image": "https://img.lazcdn.com/g/p/d6088976ce1340ddb7f34d6f6519fa3b.jpg_200x200q90.jpg",
        "price": 15672,
        "remark": "https://www.lazada.co.th/products/pdp-i5183592314.html",
        "sold": 0
    },
    {
        "product_name": "ชุดทำอาหารแคมป์ปิ้งขนาดเล็กบรรจุทำความสะอาดง่ายเครื่องครัวแคมปิ้ง",
        "product_image": "https://img.lazcdn.com/g/p/7ac5c699dfac5540ad529f9ca890a408.jpg_200x200q90.jpg",
        "price": 15314,
        "remark": "https://www.lazada.co.th/products/pdp-i6025126932.html",
        "sold": 0
    },
    {
        "product_name": "Panci Camping เคลือบอเนกประสงค์เพื่อความปลอดภัยในหม้ออาหารกลางแจ้งให้ความร้อนสำหรับบาร์บีคิวอย่างสม่ำเสมอสำหรับการเดินป่าสำหรับปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/c8e96696dfa1b0a61217a4f4db4c1f4d.jpg_200x200q90.jpg",
        "price": 14280.5,
        "remark": "https://www.lazada.co.th/products/pdp-i6012959964.html",
        "sold": 0
    },
    {
        "product_name": "ชุดหม้อและกระทะเหล็ก LOGOS",
        "product_image": "https://img.lazcdn.com/g/p/c28dd63dc78a149c57ca8a43ae7634a9.png_200x200q90.png",
        "price": 14100,
        "remark": "https://www.lazada.co.th/products/pdp-i2896117621.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA Outdoor Camping ชุดเครื่องครัวแขวนหม้อชุดเครื่องครัวแบบพกพาเครื่องครัว 1.6L ชากาต้มน้ำสำหรับ 6-8 คน",
        "product_image": "https://img.lazcdn.com/g/p/45f04f2c79fce74fb2daef0da2aa991d.jpg_200x200q90.jpg",
        "price": 13852,
        "remark": "https://www.lazada.co.th/products/pdp-i16145898612.html",
        "sold": 0
    },
    {
        "product_name": "Outdoor Campingชุดเครื่องครัวแขวนหม้อชุดเครื่องครัวแบบพกพาเครื่องครัว 1.6Lชากาต้มน้ำสำหรับ 6-8 คน",
        "product_image": "https://img.lazcdn.com/g/p/c98291a7265aa8d97b106691031bcfd7.jpg_200x200q90.jpg",
        "price": 13852,
        "remark": "https://www.lazada.co.th/products/pdp-i16145093865.html",
        "sold": 0
    },
    {
        "product_name": "หม้อและกระทะเซทเครื่องครัวตั้งแคมป์เครื่องครัวกลางแจ้งสำหรับแบกเป้ค้างแรม",
        "product_image": "https://img.lazcdn.com/g/p/ac6a917ec98a6ca489d84fb686012a59.jpg_200x200q90.jpg",
        "price": 12510,
        "remark": "https://www.lazada.co.th/products/pdp-i6078073270.html",
        "sold": 0
    },
    {
        "product_name": "For Ultralight Portable Forging Cookingware Set in Titanium with Hanging Pot for Wood Stove Firewood Furnace for Outdoor BBQ Grills Cookware",
        "product_image": "https://img.lazcdn.com/g/p/7d42d801561e528877d23922c8742f3e.jpg_200x200q90.jpg",
        "price": 8384,
        "remark": "https://www.lazada.co.th/products/pdp-i16121109826.html",
        "sold": 0
    },
    {
        "product_name": "Set Alat Masak ตั้งค่ายไททาเนียม1000มล. 750มล. Set Sendok กระทะสำหรับอุปกรณ์ทำอาหารแบกเป้ปิกนิกเดินป่าตั้งแคมป์กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/13142a2031f3e0f93113b73c0cc3aae4.jpg_200x200q90.jpg",
        "price": 12964,
        "remark": "https://www.lazada.co.th/products/pdp-i5009382698.html",
        "sold": 0
    },
    {
        "product_name": "Conjunto De อุปกรณ์ปิกนิก Koconan เครื่องครัว Mewmewcat กลางแจ้ง Eryue Huiop De Panela 750มล. หม้อกระทะ-Set Alat Masak 1000มล. 750มล. กระทะ Siuke Set Sendok Ar Caminhadas Dsfen 750 Ml Conjunto",
        "product_image": "https://img.lazcdn.com/g/p/f5a665be53c5c98bb1f7e339a65385ae.jpg_200x200q90.jpg",
        "price": 12964,
        "remark": "https://www.lazada.co.th/products/pdp-i5640470839.html",
        "sold": 0
    },
    {
        "product_name": "Lixada ชุดอุปกรณ์เครื่องครัวทำอาหารกลางแจ้งสำหรับครอบครัว,ภาชนะเดินทางไปปิกนิกเดินป่าชามยุบได้ส้อมกระทะ",
        "product_image": "https://img.lazcdn.com/g/p/f74a2db92e07b645bd3e7f5373235d07.jpg_200x200q90.jpg",
        "price": 12876,
        "remark": "https://www.lazada.co.th/products/pdp-i5009262640.html",
        "sold": 0
    },
    {
        "product_name": "Mewmewcat เรือกลไฟ Siuke หม้อซุปเรือกลไฟกลางแจ้งทำจากเงินโคแคนสำหรับทำซุปกระทะไอน้ำไฟป่าชุดเข่งนึ่งนึ่งพร้อมฝาปิดหม้อนึ่งชุดหม้อน้ำซุปหม้อซุปป่าฝาหม้อทำอาหาร Lechnical",
        "product_image": "https://img.lazcdn.com/g/p/bf118fd7024d7fa1c7c7f71642357952.jpg_200x200q90.jpg",
        "price": 12870,
        "remark": "https://www.lazada.co.th/products/pdp-i5640661277.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO กาต้มน้ำหม้อปรุงอาหารกลางแจ้งกาต้มน้ำชา600มล./1000มล. Huiop Mewmewcat/1000มล. ชากาต้มน้ำกาต้มน้ำห้องครัวกาต้มน้ำ600มล./1000มล. หม้อห้องครัวและกาน้ำชา",
        "product_image": "https://img.lazcdn.com/g/p/52b14e53d788723124aa061c7849a639.jpg_200x200q90.jpg",
        "price": 12790,
        "remark": "https://www.lazada.co.th/products/pdp-i5177091928.html",
        "sold": 0
    },
    {
        "product_name": "Snowpeak | ชุดเครื่องครัวสำหรับแคมปิ้งกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb86ac4fd4e764ea99156d9be5213381aX.png_200x200q90.png",
        "price": 12734.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5878251217.html",
        "sold": 1
    },
    {
        "product_name": "ชุดหม้อและกระทะทอดไทเทเนียมเซทเครื่องครัวตั้งแคมป์พร้อมฝาและที่จับแบบพับเก็บได้สำหรับแบกเป้ปิกนิกเดินป่าตั้งแคมป์กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/4ea5c1f0a3f8c0d76de64bf95964359e.jpg_200x200q90.jpg",
        "price": 12650,
        "remark": "https://www.lazada.co.th/products/pdp-i4989935996.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวปิคนิค 6-8 คน ALOCS CW-T05",
        "product_image": "https://img.lazcdn.com/g/p/5da3623e51d2d44cd0fcc5f4dd0eaadb.jpg_200x200q90.jpg",
        "price": 12592,
        "remark": "https://www.lazada.co.th/products/pdp-i241022685.html",
        "sold": 0
    },
    {
        "product_name": "เซทเครื่องครัวตั้งแคมป์กลางแจ้งกาน้ำชาแบบ4หรือ5ท่านอลูมิเนียมไม่ติดทำความสะอาดง่ายพกพาได้สำหรับเดินป่าตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/820e30c79244a91f141eb85c93d8d4f7.jpg_200x200q90.jpg",
        "price": 12374.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6073628529.html",
        "sold": 0
    },
    {
        "product_name": "Jun Hong|ชุดเครื่องครัวเหล็กหล่อเคลือบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa1b0871f45ee463f8e554419c9b5c5d3K.jpg_200x200q90.jpg",
        "price": 12280.18,
        "remark": "https://www.lazada.co.th/products/pdp-i6079028633.html",
        "sold": 0
    },
    {
        "product_name": "หม้อไทเทเนียม หม้ออัดแรงดันอเนกประสงค์ หม้อหุงข้าว Keith Ti6302",
        "product_image": "https://img.lazcdn.com/g/p/aaaf87ff89f6f22788ac239b7af99381.jpg_200x200q90.jpg",
        "price": 12180,
        "remark": "https://www.lazada.co.th/products/pdp-i5731374148.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA-De Panela Conjunto De Pan ชุด Set Sendok กลางแจ้ง1000มล. 750มล. เครื่องครัว Kopan 750มล. หม้อกระทะอุปกรณ์ปิกนิก Huiop Set Alat Masak Erythue Mewcat Woodlan Panelas De Titânio Hxber",
        "product_image": "https://img.lazcdn.com/g/p/04d8c23d7871b5c47df39223903aeaac.jpg_200x200q90.jpg",
        "price": 11942,
        "remark": "https://www.lazada.co.th/products/pdp-i5640628463.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA-ชุดเครื่องครัวแคมปิ้ง กระทะเตาหม้อไทเทเนียมทรงถ้วยถ้วยเบาพกพาได้สะดวกอุปกรณ์ทำอาหารเครื่องมือพร้อม HANDEL Lipat สำหรับตั้งแคมป์เดินป่าปิกนิกกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/1f102b7f888ec40517f1e76486bfe202.jpg_200x200q90.jpg",
        "price": 11885.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5949429385.html",
        "sold": 0
    },
    {
        "product_name": "ส่งฟรี ชุดเครื่องครัวไม่ติดกระทะ Awada สำหรับตั้งแคมป์กลางแจ้ง ชุดเครื่องครัวสำหรับแคมป์ปิ้ง กระทะสำหรับตั้งแคมป์ กระทะแบน campng ครัวแคมป์ปิ้ง หม้อแคมป์ปิ้ง 0001",
        "product_image": "https://img.lazcdn.com/g/p/0fd7e365a6b99a5a1fae4b68b6c4b7b5.jpg_200x200q90.jpg",
        "price": 11658,
        "remark": "https://www.lazada.co.th/products/pdp-i5414761418.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA-ชุดอุปกรณ์ทำอาหารสำหรับตั้งแคมป์ปิ้งปิ้งย่างสำหรับทำอาหารในครัว",
        "product_image": "https://img.lazcdn.com/g/p/10a4d49c99a681207f94b7e686bd3137.jpg_200x200q90.jpg",
        "price": 11574,
        "remark": "https://www.lazada.co.th/products/pdp-i5936544617.html",
        "sold": 0
    },
    {
        "product_name": "LAIBODUN | ชุดเครื่องใช้สำหรับรับประทานอาหารสเตนเลส 316L ใหม่มาถึง สำหรับใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1ab4e10f88f549a9a0596a3133e9fa52p.jpg_200x200q90.jpg",
        "price": 11328.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16051144151.html",
        "sold": 0
    },
    {
        "product_name": "ถ้วยชามถาดนึ่งและกาต้มน้ำหม้ออลูมิเนียมอัลลอยด์พร้อมฝาหม้อกระทะชุดอุปกรณ์ทานอาหารเครื่องครัวแคมปิ้ง",
        "product_image": "https://img.lazcdn.com/g/p/1ba9dfa73b3b5b81fba6f21042e742ca.jpg_200x200q90.jpg",
        "price": 10970,
        "remark": "https://www.lazada.co.th/products/pdp-i5241355471.html",
        "sold": 0
    },
    {
        "product_name": "YICHEN | ชุดเครื่องใช้บนโต๊ะหรูหราสำหรับของขวัญย้ายบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa7fd9c10e907442e80335cc516b7ef41o.png_200x200q90.png",
        "price": 10835.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5878399653.html",
        "sold": 9
    },
    {
        "product_name": "LIXADA-Fangzi ชุดสำหรับรับประทานอาหารไทเทเนียมตั้งแคมป์นอกบ้านชุดสำหรับรับประทานอาหารไทเทเนียม380มล. 750มล. หม้อ Ing ปิกนิกบ้าน Backpacking",
        "product_image": "https://img.lazcdn.com/g/p/f310043950a4243f210a3162c8f6a163.jpg_200x200q90.jpg",
        "price": 10818,
        "remark": "https://www.lazada.co.th/products/pdp-i5949225581.html",
        "sold": 0
    },
    {
        "product_name": "Fire-Maple | ชุดเครื่องครัวสำหรับทำอาหารแคมปิ้ง สำหรับทอด ย่าง และต้ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9421cfbc197a4e81996bb8cdb0de5004G.png_200x200q90.png",
        "price": 10735.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16049129519.html",
        "sold": 0
    },
    {
        "product_name": "Baynie หม้อทองแดงเครื่องครัว Saucepans",
        "product_image": "https://img.lazcdn.com/g/p/7bfd7f93463898d0b50016a1344748b9.jpg_200x200q90.jpg",
        "price": 10572,
        "remark": "https://www.lazada.co.th/products/pdp-i6022472527.html",
        "sold": 0
    },
    {
        "product_name": "Redchef | ชุดเครื่องครัวไม่ติดกระทะแบบซ้อนกันได้พร้อมด้ามจับถอดออกได้ 16 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7c98ebc6169c40a0824d8461b0ea67c8V.jpg_200x200q90.jpg",
        "price": 10478,
        "remark": "https://www.lazada.co.th/products/pdp-i16044516548.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO 1.6l หม้อทำอาหาร1.6l เตาแบบพกพารถใช้ในครัวกลางแจ้งหม้อแรงดัน Huiop Kcan",
        "product_image": "https://img.lazcdn.com/g/p/55f9b54a63d03c53c93556a6017f6e2e.jpg_200x200q90.jpg",
        "price": 10478,
        "remark": "https://www.lazada.co.th/products/pdp-i5164089667.html",
        "sold": 0
    },
    {
        "product_name": "KitchenAid | เครื่องทำอาหารหลายฟังก์ชัน หั่น เคี้ยว ปั้น    5KFP0720C",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb3a7731b26584f33a1ee0b1cbe1582c1U.jpg_200x200q90.jpg",
        "price": 14442,
        "remark": "https://www.lazada.co.th/products/pdp-i16067759892.html",
        "sold": 1
    },
    {
        "product_name": "LOGOS ชุดหม้อและกระทะแคมป์ปิ้ง  Family Cooker Set",
        "product_image": "https://img.lazcdn.com/g/p/c4a3540bee95ef056c5c1b0bf4458163.jpg_200x200q90.jpg",
        "price": 10400,
        "remark": "https://www.lazada.co.th/products/pdp-i3150157380.html",
        "sold": 0
    },
    {
        "product_name": "Tahida กระทะทองแดงหม้อทองแดงหนาทำด้วยมือกระทะทอดหม้ออาหารเรียบ32ซม. สำหรับปิกนิกที่บ้านเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/e8d71c20922fb9cfcf63f30d7a9fef48.jpg_200x200q90.jpg",
        "price": 10236,
        "remark": "https://www.lazada.co.th/products/pdp-i16134960645.html",
        "sold": 0
    },
    {
        "product_name": "Stanley Adventure Base Camp Cook Set for Four 21 pieces เครื่องครัวครบเซ็ต 21 ชิ้น เหมาะกับ Camping บ้านขนาดเล็ก หอพัก Authentic USA Imported",
        "product_image": "https://img.lazcdn.com/us/lzd_seller_ai_business/seller/ai/4f64a655-b706-49be-a5c8-6db6318a858f.jpg_200x200q90.jpg",
        "price": 9980,
        "remark": "https://www.lazada.co.th/products/pdp-i5912595798.html",
        "sold": 0
    },
    {
        "product_name": "HUIOP ทนทานชุดเครื่องครัวตั้งแคมป์การออกแบบพับได้น้ำหนักเบาชุดทำอาหารสำหรับ 4-6 คนค่าย (CW-C78)",
        "product_image": "https://img.lazcdn.com/g/p/54a1f1605da30beb46f98a6897cd7e2e.jpg_200x200q90.jpg",
        "price": 9922,
        "remark": "https://www.lazada.co.th/products/pdp-i16145179199.html",
        "sold": 0
    },
    {
        "product_name": "Gazechimp 4ชิ้น Set Alat Masak กาน้ำตั้งแคมป์กระทะทอดมีกระเป๋าเก็บของเครื่องใช้ในครัว Panci Camping และกระทะสำหรับปิกนิกกลางแจ้งปีนเขาบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/36f248c2d2dfca2a0ee413428401850b.jpg_200x200q90.jpg",
        "price": 9902,
        "remark": "https://www.lazada.co.th/products/pdp-i16063757161.html",
        "sold": 0
    },
    {
        "product_name": "GSI  Pinnacle CAMPER {3-4 Person}#ชุดหม้อเคลือบกันติดขนาดกะทัดรัด",
        "product_image": "https://img.lazcdn.com/g/p/7c3e43854c61d19e676c284550bc07ae.jpg_200x200q90.jpg",
        "price": 9900,
        "remark": "https://www.lazada.co.th/products/pdp-i848176860.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO Huiop กระทะและกระทะพร้อมที่จับไฟเปิดขนาดพกพาพร้อมชุดกระทะกระทะเปิด1100มล. กระทะทอดกระทะทอดตั้งแคมป์กลางแจ้งและ Kopan Mewcat",
        "product_image": "https://img.lazcdn.com/g/p/52f2bdd73528adc5d697f64d5e3cff22.jpg_200x200q90.jpg",
        "price": 9802,
        "remark": "https://www.lazada.co.th/products/pdp-i5177125672.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO ฝาเตาอบทั้งหมดมีมือจับสวมใส่ได้แบบสากล2ล.,พร้อมฝาปิดสต็อก2l หม้อครอบจักรวาลทั้งหมด100% เตากลางแจ้งพับเก็บได้เตาพกพาที่จับพับได้หม้อซุป",
        "product_image": "https://img.lazcdn.com/g/p/b82ee217b5b9cf1ae36b87a6eb91973a.jpg_200x200q90.jpg",
        "price": 9788,
        "remark": "https://www.lazada.co.th/products/pdp-i5640712014.html",
        "sold": 0
    },
    {
        "product_name": "Snow Peak Cookware 65th Anniversary Big Shera Cup E-565",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S26bd1f9a383749608217b076d95b32a1J.jpg_200x200q90.jpg",
        "price": 9780,
        "remark": "https://www.lazada.co.th/products/pdp-i4962746612.html",
        "sold": 0
    },
    {
        "product_name": "DANBIYIN | หม้อชาดินแดงทำมือ เตาปิ้งย่างกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8e226aa368b9417780d28a29a8545967Y.jpg_200x200q90.jpg",
        "price": 9747.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16060171912.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเตากระทะ Panci Camping ชุดเตาสำหรับตั้งแคมป์10ชิ้นสำหรับทำอาหารกลางแจ้งแคมป์ปิ้งแบกเป้",
        "product_image": "https://img.lazcdn.com/g/p/59d78a293ef5070ef71b79fdf7fcc9bf.jpg_200x200q90.jpg",
        "price": 9738,
        "remark": "https://www.lazada.co.th/products/pdp-i5009895605.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกระทะทอดกระทะซุปชุดทำอาหารสำหรับตั้งแคมป์ Kokiya หม้อต้มอาหารของใช้ในครัวเรือนอุปกรณ์ทำอาหารแบบพกพารวมกระเป๋าใส่โน๊ตบุ๊คแบบพกพาสำหรับบาร์บีคิวปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/6e61543bf4e6a2bda887a9e935ff041e.jpg_200x200q90.jpg",
        "price": 9678,
        "remark": "https://www.lazada.co.th/products/pdp-i5992492683.html",
        "sold": 0
    },
    {
        "product_name": "WDWonder กระทะครัวเรือนการทอดในกระทะซุปชุดทำอาหารสำหรับตั้งแคมป์น้ำหนักเบาเครื่องครัวแคมปิ้งชุดอุปกรณ์ทานอาหารสำหรับบาร์บีคิวเดินทางตกปลาที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/p/f87a629d47dd9d1483c31cc0ea4edd77.jpg_200x200q90.jpg",
        "price": 9678,
        "remark": "https://www.lazada.co.th/products/pdp-i6004201852.html",
        "sold": 0
    },
    {
        "product_name": "ชุดทำอาหารตั้งแคมป์ Motoautt กระทะแบบพกพารวมกระเป๋าใส่โน๊ตบุ๊คแบบพกพาสำหรับบาร์บีคิวเดินทางแคมป์ไฟแบกเป้ตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/711c50763a0c6ad835f356ab9564842f.jpg_200x200q90.jpg",
        "price": 9678,
        "remark": "https://www.lazada.co.th/products/pdp-i5963898583.html",
        "sold": 0
    },
    {
        "product_name": "Goyan ชุดทำอาหารตั้งแคมป์พร้อมกระเป๋าเก็บของกระทะความจุมากสแตนเลสกระทะทอดกระทะซุปสำหรับบาร์บีคิวการเดินป่าแบกเป้",
        "product_image": "https://img.lazcdn.com/g/p/28b83adaa9838ad5452dc206367d5325.jpg_200x200q90.jpg",
        "price": 9678,
        "remark": "https://www.lazada.co.th/products/pdp-i5995555540.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO ชุดจานชามและอุปกรณ์บาร์บีคิวเครื่องใช้สำหรับโต๊ะอาหารกลางแจ้ง5ชิ้นบาร์บีคิวปิกนิกเครื่องใช้บนโต๊ะอาหารชุดปิกนิก8ชิ้นและช้อนอุปกรณ์เครื่องครัวชุดกลางแจ้งชุดจาน5ชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/97a4a1fc761e4ee003f6e164f07dc60e.jpg_200x200q90.jpg",
        "price": 9610,
        "remark": "https://www.lazada.co.th/products/pdp-i5465511511.html",
        "sold": 0
    },
    {
        "product_name": "COONOR ชุดเครื่องครัวกระทะทอดขนาด350มล. สำหรับทอดขนาด350มล. ชุดเครื่องครัวหม้อทำอาหารและ350มล. ชุด Handles-ta8327b-1หม้อขนาด1100มล. เครื่องครัวกลางแจ้งชุดเครื่องครัว Huiop ชุดทำอาหาร",
        "product_image": "https://img.lazcdn.com/g/p/ac28c17a43de345bd1daa7619b30b8eb.jpg_200x200q90.jpg",
        "price": 9498,
        "remark": "https://www.lazada.co.th/products/pdp-i5572998829.html",
        "sold": 0
    },
    {
        "product_name": "ชุด Handles-ta8327b-1หม้อ Lixada ขนาด350มล. หม้อขนาด1100มล. และ Set Alat Masak ทอด350มล. กระทะทอดเครื่องครัวกลางแจ้งพร้อมชุดเครื่องครัวชุดเครื่องครัวกระทะทอด350มล. ชุดเครื่องครัว Huiop",
        "product_image": "https://img.lazcdn.com/g/p/c278d5b712513c9287398231134e4a71.jpg_200x200q90.jpg",
        "price": 9498,
        "remark": "https://www.lazada.co.th/products/pdp-i5436801629.html",
        "sold": 0
    },
    {
        "product_name": "COONOR Set Alat Masak Handles-ta8327b-1 Huiop ชุดเครื่องครัวหม้อขนาด1100มล. กระทะทอดมล. และ350มล. ชุดทำอาหารทอดหม้อและ350มล. Funien Dseryfen Tooart Fen Tooart Feslechnical Dbloom Mewcat Set1100ml Kcan",
        "product_image": "https://img.lazcdn.com/g/p/33edbfb4b4069c7243d16f6db8cd8eae.jpg_200x200q90.jpg",
        "price": 9498,
        "remark": "https://www.lazada.co.th/products/pdp-i5573223655.html",
        "sold": 0
    },
    {
        "product_name": "Gazechimp หม้อเตาอบแบบดัตช์พร้อมฝาปิดกระทะจุได้มากอเนกประสงค์เหล็กหล่อของขวัญทนทานสำหรับอบขนมปังเครื่องครัวสำหรับห้องครัว",
        "product_image": "https://img.lazcdn.com/g/p/96007a99d9ccf25154a06c53a83f1254.jpg_200x200q90.jpg",
        "price": 9404,
        "remark": "https://www.lazada.co.th/products/pdp-i5955311279.html",
        "sold": 0
    },
    {
        "product_name": "Kohome เหล็กหล่อความจุมากสำหรับตั้งแคมป์แบบพกพาหม้อก้นลึกกระทะทอดและกระทะเหล็กเตาอบแบบดัตช์แบบอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/p/fc1fab5af30234384e78d00c7fa1f492.jpg_200x200q90.jpg",
        "price": 9404,
        "remark": "https://www.lazada.co.th/products/pdp-i5897947478.html",
        "sold": 0
    },
    {
        "product_name": "Sharprepublic เตาอบแบบดัตช์และ Skillet หม้อก้นลึกคำสั่งผสมและเครื่องครัวกะทะทอด",
        "product_image": "https://img.lazcdn.com/g/p/9c92485af962997554f371ad802f8341.jpg_200x200q90.jpg",
        "price": 9404,
        "remark": "https://www.lazada.co.th/products/pdp-i5896807042.html",
        "sold": 0
    },
    {
        "product_name": "Moon ONAIR หม้อเตาอบแบบดัตช์พร้อมฝาปิดกระทะใช้งานหนักสำหรับการอบขนมปังเหล็กหล่ออเนกประสงค์ทำความสะอาดง่ายสำหรับบ้านตั้งแคมป์กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/e14e05755ae1525ede3b2d96fa3157cb.jpg_200x200q90.jpg",
        "price": 9404,
        "remark": "https://www.lazada.co.th/products/pdp-i5897082686.html",
        "sold": 0
    },
    {
        "product_name": "Portable Stainless Steel Camping Cookware, Thickened Frying Pan with Detachable Handle for Picnic and Steak Cooking",
        "product_image": "https://img.lazcdn.com/g/p/726c3b57d77e9d81a9fc65d2a1c54cea.jpg_200x200q90.jpg",
        "price": 9400,
        "remark": "https://www.lazada.co.th/products/pdp-i16086681706.html",
        "sold": 0
    },
    {
        "product_name": "หม้อพร้อมฝาและถุงตาข่ายไทเทเนียม-เครื่องครัวที่มีน้ำหนักเบาและทนต่อการกัดกร่อนสำหรับการตั้งแคมป์และกิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/f62a82e3db2c1ed060a9bf9aa827bc81.jpg_200x200q90.jpg",
        "price": 8988,
        "remark": "https://www.lazada.co.th/products/pdp-i4990100433.html",
        "sold": 0
    },
    {
        "product_name": "ทาฮิดะน้ำมันกระทะสำหรับทอดกระทะท้องแบนมีด้ามจับไม่ติดชุดกระทะเหล็กหล่ออุปกรณ์ทำอาหารแบบไม่เคลือบผิวสำหรับตั้งแคมป์บ้านร้านอาหารโรงแรม",
        "product_image": "https://img.lazcdn.com/g/p/17c1868c47c806529edccf1cc9a6f4bc.jpg_200x200q90.jpg",
        "price": 8760,
        "remark": "https://www.lazada.co.th/products/pdp-i16083316794.html",
        "sold": 0
    },
    {
        "product_name": "Sharprepublic กระทะสำหรับทอดกระทะทอดไข่เจียว Nonstick ทำความสะอาดง่ายแม้ความร้อนละลายชุดกระทะเหล็กหล่อสำหรับบุฟเฟ่ต์อพาร์ทเม้นบ้านโรงแรม",
        "product_image": "https://img.lazcdn.com/g/p/ddccdf770aced6263f6382fa93a14a71.jpg_200x200q90.jpg",
        "price": 8760,
        "remark": "https://www.lazada.co.th/products/pdp-i16086204449.html",
        "sold": 0
    },
    {
        "product_name": "Chiwanji กระทะทอดไข่เจียวกระทะสำหรับทอดนอนสติ๊กทำความสะอาดง่ายแม้ความร้อนละลายชุดกระทะเหล็กหล่อสำหรับบุฟเฟ่ต์อพาร์ทเม้นบ้านโรงแรม",
        "product_image": "https://img.lazcdn.com/g/p/f6d54a191335e3bf6b3ac9b9cc797b97.jpg_200x200q90.jpg",
        "price": 8760,
        "remark": "https://www.lazada.co.th/products/pdp-i16086057760.html",
        "sold": 0
    },
    {
        "product_name": "BNTOOL กระทะสำหรับทอดทำความสะอาดง่ายแม้กระทั่งความร้อนไม่ติดกระทะไข่เจียวที่อุ่นเนยหม้อกระทะเหล็กหล่อชุดสำหรับใช้ในครัวเรือนบุฟเฟ่ต์โรงแรม",
        "product_image": "https://img.lazcdn.com/g/p/dbbf45718377fc95b131f5fba5149c1d.jpg_200x200q90.jpg",
        "price": 8760,
        "remark": "https://www.lazada.co.th/products/pdp-i16089399006.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกระทะท้องแบนมีด้ามจับกระทะสำหรับทอดโรดีโอพระจันทร์กระทะเหล็กหล่อ",
        "product_image": "https://img.lazcdn.com/g/p/82932c54c7409cf50c8ff08a596eed98.jpg_200x200q90.jpg",
        "price": 8760,
        "remark": "https://www.lazada.co.th/products/pdp-i16082675501.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกระทะเหล็กหล่อกระทะท้องแบนมีด้ามจับกระทะสำหรับทอด CCLight",
        "product_image": "https://img.lazcdn.com/g/p/3290214cd5b157ffdd4306a7ef6eb983.jpg_200x200q90.jpg",
        "price": 8760,
        "remark": "https://www.lazada.co.th/products/pdp-i16082828652.html",
        "sold": 0
    },
    {
        "product_name": "BNCLOTH น้ำมันกระทะสำหรับทอดกระทะท้องแบนมีด้ามจับไม่ติดชุดกระทะเหล็กหล่อเครื่องครัวสำหรับทำอาหารแคมป์ปิ้งบ้านร้านอาหารโรงแรม",
        "product_image": "https://img.lazcdn.com/g/p/66729ebfbed67949a8e1229a51382a3b.jpg_200x200q90.jpg",
        "price": 8760,
        "remark": "https://www.lazada.co.th/products/pdp-i16083885256.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกระทะเหล็กหล่อกระทะท้องแบนมีด้ามจับกระทะสำหรับทอด CCClever",
        "product_image": "https://img.lazcdn.com/g/p/d7cee1f435716fa73a61ed2d4eb71155.jpg_200x200q90.jpg",
        "price": 8760,
        "remark": "https://www.lazada.co.th/products/pdp-i16082859784.html",
        "sold": 0
    },
    {
        "product_name": "Doorslay ชุดเครื่องครัวตั้งแคมป์น้ำหนักเบาไม่ติด 3L หม้อขนาดใหญ่ 1.7L หม้อขนาดกลาง 8 นิ้วกระทะพร้อมด้ามจับหุ้มฉนวนพับได้และถุงตาข่ายสำหรับกล้องแบกเป้กลางแจ้ง (CW-C96-A)",
        "product_image": "https://img.lazcdn.com/g/p/8905ffbccb3be46715be9066cf7872eb.jpg_200x200q90.jpg",
        "price": 8710,
        "remark": "https://www.lazada.co.th/products/pdp-i16145726676.html",
        "sold": 0
    },
    {
        "product_name": "MSR Pocket Rocket Mini Stove Kit ชุดอุปกรณ์หม้อพร้อมเตา",
        "product_image": "https://img.lazcdn.com/g/p/522d1b4e57c76105c6bfb687a2ec7761.jpg_200x200q90.jpg",
        "price": 8690,
        "remark": "https://www.lazada.co.th/products/pdp-i4904773569.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA-ชุดอัลตราไลต์ไทเทเนียมสำหรับกลางแจ้งเซทเครื่องครัวตั้งแคมป์ขนาด1100มล. และกระทะทอดขนาด350มล. พร้อมที่จับพับได้",
        "product_image": "https://img.lazcdn.com/g/p/381dc61f1c9b7176a890dbb22c579cd8.jpg_200x200q90.jpg",
        "price": 8676,
        "remark": "https://www.lazada.co.th/products/pdp-i5949342566.html",
        "sold": 0
    },
    {
        "product_name": "กระทะทอดสีทองฟีโนโวอุปกรณ์เครื่องมือเก็บรวบรวมค้นหา",
        "product_image": "https://img.lazcdn.com/g/p/724c9b69a52d6c5e0e5283d569f98f65.jpg_200x200q90.jpg",
        "price": 8643.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16065417126.html",
        "sold": 0
    },
    {
        "product_name": "(โกลดสไมล)เขยงไมแทเคลอบผว สำหรบแคมปปงและทำอาหาร เบอร 9",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S96529513198a4778910856712a022a08X.png_200x200q90.png",
        "price": 8640.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16117716514.html",
        "sold": 0
    },
    {
        "product_name": "หม้ออเนกประสงค์น้ำหนักเบาป้องกันลมพกพาได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S29fce8d9d5f546bb9d1d00d29336ead45.jpg_200x200q90.jpg",
        "price": 8622,
        "remark": "https://www.lazada.co.th/products/pdp-i16118501401.html",
        "sold": 0
    },
    {
        "product_name": "Lixada 2ชิ้นเซทเครื่องครัวตั้งแคมป์หม้อไทเทเนียมชุดทำอาหารกับกระเป๋าใส่โน๊ตบุ๊คแบบพกพาตาข่ายที่จับแบบพับเก็บได้",
        "product_image": "https://img.lazcdn.com/g/p/09ecd8cd413a3665c1fdb003888ba7d1.jpg_200x200q90.jpg",
        "price": 8520,
        "remark": "https://www.lazada.co.th/products/pdp-i4356768114.html",
        "sold": 0
    },
    {
        "product_name": "Hanging Pot Included Portable Wood Stove Firewood Furnace Titanium Cookware Set for Ultralight Picnic BBQ Grills",
        "product_image": "https://img.lazcdn.com/g/p/7d42d801561e528877d23922c8742f3e.jpg_200x200q90.jpg",
        "price": 8494,
        "remark": "https://www.lazada.co.th/products/pdp-i16118000178.html",
        "sold": 0
    },
    {
        "product_name": "【Latest model】3X Cookware Outdoor Cooking Set Tableware Rapid Heating Camping Pot Heat Exchanger Cooker Travel Equipment",
        "product_image": "https://img.lazcdn.com/g/p/a1d678ee327bf2c6001771d7e2489013.jpg_200x200q90.jpg",
        "price": 8476,
        "remark": "https://www.lazada.co.th/products/pdp-i16089108771.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องใช้บนโต๊ะอาหารสองชั้นหรูหราสำหรับครัวเรือน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S27dc726db4714b3a961995309be09b035.jpg_200x200q90.jpg",
        "price": 8442.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16119073339.html",
        "sold": 0
    },
    {
        "product_name": "All Metal 15\" Cooking Utensil Set-18/10 Stainless Steel Kitchen Tools with Countertop Rotating Holder Stand",
        "product_image": "https://img.lazcdn.com/g/p/13bf78c66bc6e890d85febbc12144ff4.jpg_200x200q90.jpg",
        "price": 8358,
        "remark": "https://www.lazada.co.th/products/pdp-i16069516507.html",
        "sold": 0
    },
    {
        "product_name": "CAM หม้อสนาม #พร้อมส่ง ✻โปรโมชั่นชุด แคมป์ปิ้ง FHS ชุดหม้อปิกนิค COOKING SET DS-308 สำหรับแคมป์ปิ้งเดินป่าหม้อปิคอนสนามหม้อปิ หม้อแคมป์ปิ้ง",
        "product_image": "https://img.lazcdn.com/g/p/d37cc06fa27056a598b501315a4933b9.jpg_200x200q90.jpg",
        "price": 8312,
        "remark": "https://www.lazada.co.th/products/pdp-i1820596452.html",
        "sold": 0
    },
    {
        "product_name": "For Ultralight for Outdoor Cooking Accessories Titanium Cookware Set with Portable Wood Stove Firewood Furnace Hanging Pot for Picnic BBQ Grills",
        "product_image": "https://img.lazcdn.com/g/p/ffc19936a64fa5c92b91829fe0116c69.jpg_200x200q90.jpg",
        "price": 8308,
        "remark": "https://www.lazada.co.th/products/pdp-i16130687123.html",
        "sold": 0
    },
    {
        "product_name": "LE CREUSET ฝรั่งเศสนำเข้าเหล็กหล่อเคลือบสีดำ 31 ซม. หม้อรูปไข่ใช้ในครัวเรือนทอดและตุ๋นหม้อร้อนแท",
        "product_image": "https://img.lazcdn.com/g/p/75ed518ac5896525574639c2574aa7c4.png_200x200q90.png",
        "price": 8250,
        "remark": "https://www.lazada.co.th/products/pdp-i16046248565.html",
        "sold": 0
    },
    {
        "product_name": "Furnace with Hanging Pot for Ultralight Picnic BBQ Grills Portable Wood Stove Firewood Titanium Cookware Set",
        "product_image": "https://img.lazcdn.com/g/p/7d42d801561e528877d23922c8742f3e.jpg_200x200q90.jpg",
        "price": 8244,
        "remark": "https://www.lazada.co.th/products/pdp-i16107185098.html",
        "sold": 0
    },
    {
        "product_name": "ชุดทำอาหารตั้งแคมป์ในเครื่องครัวแคมปิ้งฉนวนกันความร้อนสูงกันรอยขีดข่วนสำหรับการเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/3abf7d58a647cfef9e2902963d55191e.jpg_200x200q90.jpg",
        "price": 8242,
        "remark": "https://www.lazada.co.th/products/pdp-i6003433563.html",
        "sold": 0
    },
    {
        "product_name": "Kosar กระทะหัวแบนสีทองเครื่องมือตรวจสอบแยกง่ายเครื่องมือเก็บรวมของ20.08นิ้วเครื่องมือเก็บรวมของสำหรับการสำรวจลำห้วยกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/335f02d62e7cfa5f43d6e9b8d84256f8.jpg_200x200q90.jpg",
        "price": 8204.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16101566283.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO ฝาเตาอบกลางแจ้งพร้อม2l ฝาหม้อ,หม้อซุป2ลิตรพร้อมเตากลางแจ้งสามารถพับเก็บได้100% สต็อกที่จับพับได้สวมใส่ได้แบบสากลของทุกเตาพกพาสวมใส่ได้แบบสากล",
        "product_image": "https://img.lazcdn.com/g/p/b82ee217b5b9cf1ae36b87a6eb91973a.jpg_200x200q90.jpg",
        "price": 8143.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5640730173.html",
        "sold": 0
    },
    {
        "product_name": "Fire-Maple | ชุดเครื่องครัวพกพาสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8d15468cb47842eba6787cc18008f833J.jpg_200x200q90.jpg",
        "price": 8120.66,
        "remark": "https://www.lazada.co.th/products/pdp-i16049125264.html",
        "sold": 0
    },
    {
        "product_name": "Panci Camping โคลซี่พร้อมฝาปิดไทเทเนียมแก้วตั้งแคมป์ขนาด2200มล. เครื่องใช้ใน HANDEL Lipat อุปกรณ์ทำอาหารแบบพกพาสำหรับกลางแจ้งในบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/f350bb10ecb2ff4f25738de64c9aae4a.jpg_200x200q90.jpg",
        "price": 8084,
        "remark": "https://www.lazada.co.th/products/pdp-i5992910905.html",
        "sold": 0
    },
    {
        "product_name": "(โกลดสไมล)เขยงไมแทเคลอบผว สำหรบแคมปปงและทำอาหาร เบอร 8",
        "product_image": "https://img.lazcdn.com/g/ff/kf/See0636964c1749afb3dfbbffda657466f.png_200x200q90.png",
        "price": 8060.94,
        "remark": "https://www.lazada.co.th/products/pdp-i16117577249.html",
        "sold": 0
    },
    {
        "product_name": "หม้อหุงต้มครัว Fenteer หม้อชาบูทำความร้อนเร็วความจุมากใช้งานได้จริงสำหรับปิคนิคตั้งค่ายในวันหยุดหม้ออาหารอย่างหนา",
        "product_image": "https://img.lazcdn.com/g/p/a13b2663e565ac3fd2c0cda7a1a92665.jpg_200x200q90.jpg",
        "price": 8012.3,
        "remark": "https://www.lazada.co.th/products/pdp-i5279056585.html",
        "sold": 0
    },
    {
        "product_name": "HAFELE ชุดเครื่องครัวอะลูมิเนียม 8 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/55bf69f232589431232cb47d600989de.jpg_200x200q90.jpg",
        "price": 7980,
        "remark": "https://www.lazada.co.th/products/pdp-i5829076174.html",
        "sold": 33
    },
    {
        "product_name": "หม้อเหล็กสแตนเลสแรงดันหม้อแรงดัน Motoise",
        "product_image": "https://img.lazcdn.com/g/p/46f005fd6aa7dc286b1e2d028d9ef849.jpg_200x200q90.jpg",
        "price": 7924,
        "remark": "https://www.lazada.co.th/products/pdp-i16054202931.html",
        "sold": 0
    },
    {
        "product_name": "Befairy หม้อแรงดัน1.6L หม้อปรุงซุปทนทานอเนกประสงค์แบบหม้อแรงดันสำหรับร้านอาหารเดินทางตั้งแคมป์กลางแจ้งโรงแรม",
        "product_image": "https://img.lazcdn.com/g/p/7eb1a9df327a246d70cc689fee4263f4.jpg_200x200q90.jpg",
        "price": 7906,
        "remark": "https://www.lazada.co.th/products/pdp-i6078866935.html",
        "sold": 0
    },
    {
        "product_name": "WDWonder อุปกรณ์ทำครัวหม้อแรงดัน,หม้ออาหารหม้อซุปสแตนเลสความดันอเนกประสงค์สำหรับใช้ในบ้านเวลาเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/fe461d333a890be285ca34941ca64461.jpg_200x200q90.jpg",
        "price": 7906,
        "remark": "https://www.lazada.co.th/products/pdp-i16137377366.html",
        "sold": 0
    },
    {
        "product_name": "BAKERSTONE | ชุดเครื่องครัวสำหรับแค้มปิ้งพกพา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3a417236ab7a4fed851f922b92a31bfdS.jpg_200x200q90.jpg",
        "price": 7874.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5879905343.html",
        "sold": 21
    },
    {
        "product_name": "Montbell Alpine Cooker Square หม้อสนามสี่เหลี่ยม สำหรับเดินป่า ชุด 12+13 Set",
        "product_image": "https://img.lazcdn.com/g/p/51e880cac5a652d8f650c6ef28abe64e.jpg_200x200q90.jpg",
        "price": 7800,
        "remark": "https://www.lazada.co.th/products/pdp-i3131303188.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA-Fangzi ชุดทำอาหารหม้อไทเทเนียมเซทเครื่องครัวตั้งแคมป์2ชิ้นชุดกระทะ Panci Camping พร้อมกระเป๋าใส่โน๊ตบุ๊คแบบพกพาตาข่ายที่จับแบบพับเก็บได้",
        "product_image": "https://img.lazcdn.com/g/p/9faf75dc1030aad15e525d0c6bf3e9ef.jpg_200x200q90.jpg",
        "price": 7778,
        "remark": "https://www.lazada.co.th/products/pdp-i5948496580.html",
        "sold": 0
    },
    {
        "product_name": "(LAY0) 3X WIDESEA Cookware Outdoor Cooking Set Tableware Rapid Heating Camping Pot Heat Exchanger Cooker Travel Equipment",
        "product_image": "https://img.lazcdn.com/g/p/02dc1aad2f2a0bad4e29afdb153e7041.jpg_200x200q90.jpg",
        "price": 7750,
        "remark": "https://www.lazada.co.th/products/pdp-i16133408382.html",
        "sold": 0
    },
    {
        "product_name": "(LB6H) 3 x Widesea Cookware Outdoor Cooking Set Tableware Rapid Heating Camping Pot Heat Exchanger Cooker Travel Equipment",
        "product_image": "https://img.lazcdn.com/g/p/02dc1aad2f2a0bad4e29afdb153e7041.jpg_200x200q90.jpg",
        "price": 7750,
        "remark": "https://www.lazada.co.th/products/pdp-i16131862585.html",
        "sold": 0
    },
    {
        "product_name": "(LQ5X) 3 x Widesea Cookware Outdoor Cooking Set Tableware Rapid Heating Camping Pot Heat Exchanger Cooker Travel Equipment",
        "product_image": "https://img.lazcdn.com/g/p/02dc1aad2f2a0bad4e29afdb153e7041.jpg_200x200q90.jpg",
        "price": 7750,
        "remark": "https://www.lazada.co.th/products/pdp-i16133473684.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA ชุด Huiop ชุดกระทะกระทะจับตาข่าย Set Alat Masak 2ชิ้น,พร้อมที่จับหม้อ Set Alat Masak ตาข่ายพร้อมที่จับตาข่าย Mewmewcat ชุดหม้อกระทะ Lechndsfen Buzhi อุปกรณ์โต๊ะอาหาร2ชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/fae3a1a174defc1f8f72f0e1e863f495.jpg_200x200q90.jpg",
        "price": 7731.84,
        "remark": "https://www.lazada.co.th/products/pdp-i5640694426.html",
        "sold": 0
    },
    {
        "product_name": "ชุดหม้อทำอาหารกลางแจ้งหลายประโยชน์ ไทเทเนียม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8a0618914ba5499384d8296294c00c28P.jpg_200x200q90.jpg",
        "price": 7726,
        "remark": "https://www.lazada.co.th/products/pdp-i16118985162.html",
        "sold": 0
    },
    {
        "product_name": "Mini Cooking System Outdoor Windproof Stove Boiling Water for Hiking Mountaineering Camping Cookware",
        "product_image": "https://img.lazcdn.com/g/p/d1a92caddfdd7ccb62d1655ad83d14f5.jpg_200x200q90.jpg",
        "price": 7720,
        "remark": "https://www.lazada.co.th/products/pdp-i16094026732.html",
        "sold": 0
    },
    {
        "product_name": "ZYStar เซ็ตกระถางและกระทะแบบพกพาหม้อซุปกระทะทอดทำความสะอาดง่ายไม่ติดถอดออกได้ Set Alat Masak ครัวสำหรับบ้านเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/1c2212f273faccdfc8e233524c49e484.jpg_200x200q90.jpg",
        "price": 7634.94,
        "remark": "https://www.lazada.co.th/products/pdp-i16118281019.html",
        "sold": 0
    },
    {
        "product_name": "หม้อแรงดันหม้อแรงดันดวงจันทร์เครื่องครัวอเนกประสงค์ขนาดกะทัดรัดแบบพกพา1.6L เหล็กสแตนเลสสำหรับบ้านเดินทางร้านอาหารโรงแรม",
        "product_image": "https://img.lazcdn.com/g/p/631b5813e594810286f1942205610039.jpg_200x200q90.jpg",
        "price": 7566.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16126789522.html",
        "sold": 0
    },
    {
        "product_name": "Petromax Rotating Waffle Iron (รุ่น wf-tx) เตาทำวาฟเฟิลแบบหมุน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0b9cdea407ac4c90851c042beb81e4b1n.jpg_200x200q90.jpg",
        "price": 7400,
        "remark": "https://www.lazada.co.th/products/pdp-i16093106382.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO ชามเซียร่าสเตนเลสสตีลสำหรับกลางแจ้ง450มล. ถ้วยสำหรับออกแคมป์บาร์บีคิวแบบพกพาใช้บนโต๊ะอาหารปิกนิกปิคนิคเครื่องครัวมีกระเป๋าเก็บของ",
        "product_image": "https://img.lazcdn.com/g/p/aaa1a642c4944ecc3d40d28d88b2f151.jpg_200x200q90.jpg",
        "price": 7354,
        "remark": "https://www.lazada.co.th/products/pdp-i4904931783.html",
        "sold": 0
    },
    {
        "product_name": "Camping Cookware Set Stainless Steel Outdoor Cooking Kit Tableware Cookset Pan Bowl Kettle Pot Picnic With Mesh Bag",
        "product_image": "https://img.lazcdn.com/g/p/0e8442c3f4e6835cf624e66473f9989c.jpg_200x200q90.jpg",
        "price": 7352,
        "remark": "https://www.lazada.co.th/products/pdp-i16114466751.html",
        "sold": 0
    },
    {
        "product_name": "CAMPLEADER | กล่องอาหารพับได้ไทเทเนียมสำหรับแคมปิ้งกลางแจ้ง 1 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3cfa758928424fc591846a8b6ffc1c8cW.jpg_200x200q90.jpg",
        "price": 7322,
        "remark": "https://www.lazada.co.th/products/pdp-i6066885190.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแคมปิ้งสแตนเลสพร้อมไม่ติดหม้อตั้งแคมป์ฝาพับชุดกาต้มน้ำกระทะสำหรับปิกนิกทำอาหารกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/be2cd7ef3b3b9107dc861f0db7176d11.jpg_200x200q90.jpg",
        "price": 7308,
        "remark": "https://www.lazada.co.th/products/pdp-i6012674668.html",
        "sold": 0
    },
    {
        "product_name": "Fire-Maple | ชุดเครื่องครัวสำหรับทำอาหารกลางแจ้งหรูหรา 4 ชุด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0bba7959f1fb46be88f66534d776ccffc.jpg_200x200q90.jpg",
        "price": 7278.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16049818719.html",
        "sold": 0
    },
    {
        "product_name": "【Latest model】Widesea Outdoor Camping Pot, Outdoor Cooking Kettle Set, Travel Tableware, Tourist Kitchenware",
        "product_image": "https://img.lazcdn.com/g/p/7c83e98be1eaef66e2ccdfd00207c694.jpg_200x200q90.jpg",
        "price": 7230,
        "remark": "https://www.lazada.co.th/products/pdp-i16106256486.html",
        "sold": 0
    },
    {
        "product_name": "Coleman JP Aluminum Cooker Set #ชุดหม้ออลูมิเนียมเคลือบ ต้ม ผัด นึ่ง อบ และทอด",
        "product_image": "https://img.lazcdn.com/g/p/cf062f0bfde681efa6000dc84a866e80.jpg_200x200q90.jpg",
        "price": 7200,
        "remark": "https://www.lazada.co.th/products/pdp-i2388637357.html",
        "sold": 2
    },
    {
        "product_name": "[NEW] Barebones กระทะแบนเหล็กหล่อ Cast Iron Skillet แข็งแรง ทนทาน ทนไฟ กระจายความร้อนดี เหมาะสำหรับทำอาหารทั้งเตาแก๊สและแคมป์ปิ้ง",
        "product_image": "https://img.lazcdn.com/g/p/c25cf301af889847e212ac47d9548919.png_200x200q90.png",
        "price": 7180,
        "remark": "https://www.lazada.co.th/products/pdp-i5746382550.html",
        "sold": 0
    },
    {
        "product_name": "Snowpeak | เครื่องครัวเหล็กหล่อสำหรับกลางแจ้ง หลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf9b87be9be534d429650128708d051bfT.jpg_200x200q90.jpg",
        "price": 7068.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5876816703.html",
        "sold": 4
    },
    {
        "product_name": "ZYEarth ชุดกระถางและกระทะ Set Alat Masak ในครัวหม้อซุปทำความสะอาดง่ายหม้ออาหารที่ไม่เหนียวเหนอะหนะสำหรับตั้งแคมป์ปิกนิกร้านอาหาร",
        "product_image": "https://img.lazcdn.com/g/p/0c1ec93d577af18c4e630656933ef033.jpg_200x200q90.jpg",
        "price": 7012.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16118286809.html",
        "sold": 0
    },
    {
        "product_name": "Prasku ชุดกระถางและกระทะ Set Alat Masak ในครัวหม้อซุปทำความสะอาดง่ายหม้ออาหารไม่เหนียวทนทานสำหรับตั้งแคมป์ปิกนิกร้านอาหาร",
        "product_image": "https://img.lazcdn.com/g/p/0fccb6736947281d63fb1c4c50352d09.jpg_200x200q90.jpg",
        "price": 7012.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16118434122.html",
        "sold": 0
    },
    {
        "product_name": "【Latest model】Outdoor Light Steamer Camping Soup Pot Set in Titanium Includes Steam Chamber Compartment",
        "product_image": "https://img.lazcdn.com/g/p/9e835b2688be609eb8d9b3178bdb2ba7.jpg_200x200q90.jpg",
        "price": 6404,
        "remark": "https://www.lazada.co.th/products/pdp-i16068624113.html",
        "sold": 0
    },
    {
        "product_name": "Sea to Summit Frontier Ultralight Collapsible Kettle 1.1L เครื่องครัว กาน้ำพับได้",
        "product_image": "https://img.lazcdn.com/g/p/f66bf24d3412801a31b8b0427ad246d1.jpg_200x200q90.jpg",
        "price": 6920,
        "remark": "https://www.lazada.co.th/products/pdp-i6035536778.html",
        "sold": 0
    },
    {
        "product_name": "Fire-Maple | ชุดเครื่องครัวกลางแจ้งพกพาพร้อมด้ามจับพับได้ 6 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5f1ce5d917da40399e4092183676595dp.jpg_200x200q90.jpg",
        "price": 6915.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6001683177.html",
        "sold": 0
    },
    {
        "product_name": "Loviver วิปปิ้งชามหนาเครื่องครัวทองแดงสำหรับกระทะเตาหม้อทองแดงหม้อแยมทองแดงสำหรับร้านอาหารการเดินป่าบ้านงานเลี้ยงปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/97d0a1d873a10853ec7b9d5a6c4b4425.jpg_200x200q90.jpg",
        "price": 6892.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5287639557.html",
        "sold": 0
    },
    {
        "product_name": "Onetwone 3ชิ้นกระทะ Set Alat Masak สแตนเลส304และหม้อสต็อกกระทะแบนชุดเครื่องครัวกระทะกับฝากระจกนิรภัย26ซมหม้ออาหาร Mot นม",
        "product_image": "https://img.lazcdn.com/g/p/c520372575c4675a63f8d97cc0e81cdf.jpg_200x200q90.jpg",
        "price": 6890.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5845796199.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO และปิกนิกและเครื่องครัวในหนึ่งค่ายทุกคนทั้งชุดและทั้งหมดในชุดปิกนิกกลางแจ้งอุปกรณ์2-3ในอุปกรณ์ Mewmewcat ชุดอุปกรณ์กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/82671a10bde9e76e44972184252c1a9d.jpg_200x200q90.jpg",
        "price": 6844,
        "remark": "https://www.lazada.co.th/products/pdp-i5164176042.html",
        "sold": 0
    },
    {
        "product_name": "for Folding Basket 2 Units Water Filter Basket Table Board Storage Accessory for Kitchen",
        "product_image": "https://img.lazcdn.com/g/p/edca871567064dce403b7f1c86a7e7f6.jpg_200x200q90.jpg",
        "price": 6804,
        "remark": "https://www.lazada.co.th/products/pdp-i16099305839.html",
        "sold": 0
    },
    {
        "product_name": "CCGREAT ชุดกระถางและกระทะ Set Alat Masak หม้ออาหารกระทะทอดหม้อซุปที่จับถอดออกได้สำหรับตั้งแคมป์ปิกนิกในหอพักร้านอาหารบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/375f5bd9cb518d080e022269cd4eb25f.jpg_200x200q90.jpg",
        "price": 6774,
        "remark": "https://www.lazada.co.th/products/pdp-i16118873432.html",
        "sold": 0
    },
    {
        "product_name": "CCLight ชุดกระถางและกระทะ Set Alat Masak อเนกประสงค์แบบพกพากระทะทอดไม่เหนียวสำหรับตั้งแคมป์ที่บ้านห้องครัวร้านอาหารปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/b12dc64e2898a6755cf0140ec7756b62.jpg_200x200q90.jpg",
        "price": 6774,
        "remark": "https://www.lazada.co.th/products/pdp-i16119262163.html",
        "sold": 0
    },
    {
        "product_name": "Chiwanji ชุดกระถางและกระทะกระทะทอดทำความสะอาดง่ายแบบพกพาหม้อซุปไม่ติดถอดออกได้ Set Alat Masak ครัวสำหรับบ้านเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/b380af9e28cf0f199266fb8d820e2246.jpg_200x200q90.jpg",
        "price": 6774,
        "remark": "https://www.lazada.co.th/products/pdp-i16118378054.html",
        "sold": 0
    },
    {
        "product_name": "Gommie แคมป์ไฟไฟชามคอนกรีตหม้ออุ่นกาน้ำชาเตาเดสก์ท็อปไฟสำหรับห้องนั่งเล่นห้องรับประทานอาหารสวน",
        "product_image": "https://img.lazcdn.com/g/p/58eafd88d18fef89d23a9f2122256c93.jpg_200x200q90.jpg",
        "price": 6652.38,
        "remark": "https://www.lazada.co.th/products/pdp-i6027966352.html",
        "sold": 0
    },
    {
        "product_name": "เซทเครื่องครัวตั้งแคมป์ Ellwewe สำหรับหม้ออาหารแคมป์ไฟสำหรับบาร์บีคิวปิกนิกกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/8ee5c9142dba340810a5751b7ec88542.jpg_200x200q90.jpg",
        "price": 6540,
        "remark": "https://www.lazada.co.th/products/pdp-i5929266776.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกระถางและกระทะ Set Alat Masak ห้องครัวมีฝาปิดเหมือนจริง",
        "product_image": "https://img.lazcdn.com/g/p/c37eec26ba3de89ebf13b279f4d104c9.jpg_200x200q90.jpg",
        "price": 6482.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16137816107.html",
        "sold": 0
    },
    {
        "product_name": "CCAngel ชุดกระถางและกระทะ Set Alat Masak อเนกประสงค์,ทำความสะอาดง่ายหม้อซุปพร้อมฝาปิดไม่เหนียวเหนอะหนะสำหรับปิกนิกปีนเขาตั้งแคมป์ในหอพัก",
        "product_image": "https://img.lazcdn.com/g/p/5d377bb22ce1604090845ced40244dcc.jpg_200x200q90.jpg",
        "price": 6482.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16127184847.html",
        "sold": 0
    },
    {
        "product_name": "Sunniiee ชุดกระถางและกระทะ Set Alat Masak หม้ออาหารกระทะทอดหม้อซุปที่จับถอดออกได้สำหรับบ้านร้านอาหารหอพักตั้งแคมป์ปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/70005186ef343fbb08814e8e0d32039f.jpg_200x200q90.jpg",
        "price": 6482.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16117949818.html",
        "sold": 0
    },
    {
        "product_name": "【Latest model】Camping Pure Titanium Portable Skillet Outdoor Light Steamer Outdoor Multi-Functional Ultra Light Pan",
        "product_image": "https://img.lazcdn.com/g/p/9e835b2688be609eb8d9b3178bdb2ba7.jpg_200x200q90.jpg",
        "price": 6404,
        "remark": "https://www.lazada.co.th/products/pdp-i16066773082.html",
        "sold": 0
    },
    {
        "product_name": "Tourist Kitchenware, Outdoor Camping Pot, Outdoor Cooking Kettle Set, Travel Tableware",
        "product_image": "https://img.lazcdn.com/g/p/7c83e98be1eaef66e2ccdfd00207c694.jpg_200x200q90.jpg",
        "price": 6378,
        "remark": "https://www.lazada.co.th/products/pdp-i16106004769.html",
        "sold": 0
    },
    {
        "product_name": "ครัวแคมป์ปิ้ง,มินิครัวแคมป์ปิ้ง,ครัวไม้สน,ครัวสนาม",
        "product_image": "https://img.lazcdn.com/g/p/b1148a9b830d26319b10ae628b397fc8.jpg_200x200q90.jpg",
        "price": 6358,
        "remark": "https://www.lazada.co.th/products/pdp-i4870841334.html",
        "sold": 0
    },
    {
        "product_name": "แบรนด Talent Cook",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd16e41d683174662ac29f5ab71f22f97P.png_200x200q90.png",
        "price": 6340.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16109758856.html",
        "sold": 0
    },
    {
        "product_name": "Camping Soup Pot Set with Outdoor Light Steamer Steam Compartment in Titanium MaterialNew Year Special",
        "product_image": "https://img.lazcdn.com/g/p/9e835b2688be609eb8d9b3178bdb2ba7.jpg_200x200q90.jpg",
        "price": 6308,
        "remark": "https://www.lazada.co.th/products/pdp-i16084570297.html",
        "sold": 0
    },
    {
        "product_name": "Titanium Camping Soup Pot Set with Cover Soup Pot Steam Compartment Multi Functional CookwareNew Year Special",
        "product_image": "https://img.lazcdn.com/g/p/9e835b2688be609eb8d9b3178bdb2ba7.jpg_200x200q90.jpg",
        "price": 6308,
        "remark": "https://www.lazada.co.th/products/pdp-i16084679225.html",
        "sold": 0
    },
    {
        "product_name": "【Latest model】2X Outdoor Folding Pot Silicone Hiking Cooking Pot Portable Picnic Pot Stainless Steel Camping Cooker,Green",
        "product_image": "https://img.lazcdn.com/g/p/490ae18a62bfed6182e3b8bb09ab4d86.jpg_200x200q90.jpg",
        "price": 6306,
        "remark": "https://www.lazada.co.th/products/pdp-i16086578986.html",
        "sold": 0
    },
    {
        "product_name": "SHUDUODUN | หม้อครัวหนา ทนความร้อน ไม่แตก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfb3a6dfe26e84bdfb359bee45a83e3d59.jpg_200x200q90.jpg",
        "price": 6271.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5910878030.html",
        "sold": 0
    },
    {
        "product_name": "[โปรร้อนแรง!!] หม้อสุกี้บาร์บีคิว รุ่น HW-BP01 สีแดง | หม้อสุกี้บาร์บีคิว เครื่องครัว ราคาถูก",
        "product_image": "https://img.lazcdn.com/g/p/4dde5a1ad2f520875fa0dd2a4ae85b0a.png_200x200q90.png",
        "price": 6218,
        "remark": "https://www.lazada.co.th/products/pdp-i3112859505.html",
        "sold": 0
    },
    {
        "product_name": "[HOT SALE!] คูลเลอร์ ขนาด 36 ลิตร (36 ซม.) สีเงิน | คูลเลอร์ เครื่องครัว ราคาถูก",
        "product_image": "https://img.lazcdn.com/g/p/a01ccbe254970b1c67cf2a25527ed2ef.jpg_200x200q90.jpg",
        "price": 6208,
        "remark": "https://www.lazada.co.th/products/pdp-i3112833736.html",
        "sold": 0
    },
    {
        "product_name": "Deevoka เครื่องใช้บนโต๊ะอาหารสำหรับตั้งแคมป์ใน20x ชุดจานชามทำความสะอาดง่ายอุปกรณ์ทำอาหารอุปกรณ์เสริมสำหรับทานอาหารข้างนอกเดินทางการตั้งแคมป์แบบกลุ่ม",
        "product_image": "https://img.lazcdn.com/g/p/d7e60fee53572e46dec82471dea93614.jpg_200x200q90.jpg",
        "price": 6196,
        "remark": "https://www.lazada.co.th/products/pdp-i5960897770.html",
        "sold": 0
    },
    {
        "product_name": "Colaxi ชุดจานชามเครื่องใช้บนโต๊ะอาหารสำหรับตั้งแคมป์20x อุปกรณ์รับประทานอาหารอุปกรณ์ทำอาหารน้ำหนักเบาขัดเงาสำหรับการตั้งแคมป์กลางแจ้งห้องครัว RV",
        "product_image": "https://img.lazcdn.com/g/p/9aaf45f954d5cf403ce210fcf96c5704.jpg_200x200q90.jpg",
        "price": 6196,
        "remark": "https://www.lazada.co.th/products/pdp-i6007585599.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO กลางแจ้งอุปกรณ์ในหนึ่ง2คนหนึ่งค่ายหนึ่งและปิกนิกทั้งหมดในชุดอุปกรณ์กลางแจ้งเครื่องครัวใน",
        "product_image": "https://img.lazcdn.com/g/p/88832304b7fe022b4a0b253a3e52c3a6.jpg_200x200q90.jpg",
        "price": 6182,
        "remark": "https://www.lazada.co.th/products/pdp-i5164122398.html",
        "sold": 0
    },
    {
        "product_name": "ชุดหม้อสนาม Snow Peak Yaen Cooker 1000 (SCS-200) น้ำหนักเบา เพียง 520g 🎉พร้อมจัดส่ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3c5bcb5daa564aa6b3170a673005be40r.jpg_200x200q90.jpg",
        "price": 6180,
        "remark": "https://www.lazada.co.th/products/pdp-i4501101377.html",
        "sold": 1
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาอลูมิเนียมอัลลอยด์น้ำหนักเบา - สำหรับ 2-3 คนเดินป่าตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/5a4b3f088c4a6399c453706276f97b67.jpg_200x200q90.jpg",
        "price": 6168,
        "remark": "https://www.lazada.co.th/products/pdp-i16123058550.html",
        "sold": 0
    },
    {
        "product_name": "ชุดรับประทานอาหารกลางแจ้งพกพา สแตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2c985940b2674558a312f59b8ff103c6w.jpg_200x200q90.jpg",
        "price": 6158,
        "remark": "https://www.lazada.co.th/products/pdp-i16117897886.html",
        "sold": 0
    },
    {
        "product_name": "The Primitive | รถเข็นมือพับได้ขนาดใหญ่สำหรับแคมปิ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd3fbebf148bf4784822aece8349d48f4i.jpg_200x200q90.jpg",
        "price": 6153.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5909564817.html",
        "sold": 6
    },
    {
        "product_name": "DR.Hows Portable compact mini stove butane magnet type kitchenware",
        "product_image": "https://img.lazcdn.com/g/p/709c1d3feb3e49469f18d876baeee27e.jpg_200x200q90.jpg",
        "price": 6148,
        "remark": "https://www.lazada.co.th/products/pdp-i6020725486.html",
        "sold": 0
    },
    {
        "product_name": "WDAir กระทะกระทะทองหนิงอุปกรณ์กระทะทองกลางแจ้งอเนกประสงค์สำหรับผู้เริ่มกิจกรรมกลางแจ้งสำหรับผู้ที่ชื่นชอบงานอดิเรกในแม่น้ำ",
        "product_image": "https://img.lazcdn.com/g/p/2354c565add4fc51a08f9726fc643a35.jpg_200x200q90.jpg",
        "price": 6134.32,
        "remark": "https://www.lazada.co.th/products/pdp-i16051721564.html",
        "sold": 0
    },
    {
        "product_name": "[LA1R]Portable Stainless Steel Camping Cookware, Thickened Frying Pan with Detachable Handle for Picnic and Steak Cooking",
        "product_image": "https://img.lazcdn.com/g/p/726c3b57d77e9d81a9fc65d2a1c54cea.jpg_200x200q90.jpg",
        "price": 6090,
        "remark": "https://www.lazada.co.th/products/pdp-i16068846484.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวสำหรับแคมปิ้งกลางแจ้ง อลูมิเนียมอัลลอย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se150ce5873fe41168aeba880670df412n.jpg_200x200q90.jpg",
        "price": 6066,
        "remark": "https://www.lazada.co.th/products/pdp-i16118052868.html",
        "sold": 0
    },
    {
        "product_name": "อุปกรณ์ครัว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc76be9af5ce54cd293877634e0945487J.png_200x200q90.png",
        "price": 6001.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5945155898.html",
        "sold": 0
    },
    {
        "product_name": "SHUDUODUN | ชุดเครื่องครัวทนความร้อนไม่ติดกระทะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7f040ac8410744e197fe62a332e13d58R.png_200x200q90.png",
        "price": 5994.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6005943103.html",
        "sold": 3
    },
    {
        "product_name": "TOMSHOO อุปกรณ์ทำอาหารเซทเครื่องครัวตั้งแคมป์พกพา48ชิ้นสำหรับ6ถึง8คน (สีส้ม)",
        "product_image": "https://img.lazcdn.com/g/p/0419f9627c676035683040257dc1689a.jpg_200x200q90.jpg",
        "price": 5976,
        "remark": "https://www.lazada.co.th/products/pdp-i16145311243.html",
        "sold": 0
    },
    {
        "product_name": "หม้อเก็บความร้อนตั้งแคมป์เดินทางกลางแจ้ง2.1L สำหรับเดินป่าเครื่องครัว1.5ชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/d27a454bdae7543d2bf64b4b6dc716d7.jpg_200x200q90.jpg",
        "price": 5956,
        "remark": "https://www.lazada.co.th/products/pdp-i16043278415.html",
        "sold": 0
    },
    {
        "product_name": "หม้อชงชาความร้อนสูง 316 สแตนเลส ความจุใหญ่ พกพาได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5b4fba020cd4480a9622a8f3d901a7ca6.jpg_200x200q90.jpg",
        "price": 5900,
        "remark": "https://www.lazada.co.th/products/pdp-i16114878768.html",
        "sold": 0
    },
    {
        "product_name": "หม้อชงชาสแตนเลสกันความร้อน 316",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb71d868472f6454b82978fcc51856912R.jpg_200x200q90.jpg",
        "price": 5900,
        "remark": "https://www.lazada.co.th/products/pdp-i16122921459.html",
        "sold": 0
    },
    {
        "product_name": "SunnT กระทะร่อนร่อนสีทองที่ล้างกระทะทองอุปกรณ์การทำแพนเค้กสำหรับค้นหาสินค้า",
        "product_image": "https://img.lazcdn.com/g/p/69f1591db3281dc831b504b33a0d550e.jpg_200x200q90.jpg",
        "price": 5876.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16075228110.html",
        "sold": 0
    },
    {
        "product_name": "เตาฟืนตั้งแคมป์สเตนเลสสตีลทำอาหารเผาไหม้เตาเผาไหม้เครื่องทำไม้พกพา",
        "product_image": "https://img.lazcdn.com/g/p/97cc5d944e6d81201bebbd3d9e2424ae.jpg_200x200q90.jpg",
        "price": 5068,
        "remark": "https://www.lazada.co.th/products/pdp-i5923814763.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องเครื่องครัวแคมปิ้งเตาตั้งแคมป์กันลมเตากลางแจ้งน้ำหนักเบาแบบพกพาอุปกรณ์ทำอาหารส่วนตัวสำหรับแบกเป้",
        "product_image": "https://img.lazcdn.com/g/p/099c079486d3cb0b0a2a7ef3b400dffc.jpg_200x200q90.jpg",
        "price": 5830,
        "remark": "https://www.lazada.co.th/products/pdp-i5523494949.html",
        "sold": 0
    },
    {
        "product_name": "หม้อ Montbell ALPINE COOKER SQUARE 12+13 set",
        "product_image": "https://img.lazcdn.com/g/p/1b72e691aeda8e99f8cf9c9cede35bf5.jpg_200x200q90.jpg",
        "price": 5800,
        "remark": "https://www.lazada.co.th/products/pdp-i4264640284.html",
        "sold": 0
    },
    {
        "product_name": "เตาประกอบอาหารเตาไฟแคมปิ้งเหมือนจริงพร้อมหม้อไม่มีฝาปิดหม้อหม้อร้อนทนทานสำหรับการเดินป่าอุปกรณ์ทำครัวการทำบาร์บีคิวกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/8759aaff516d445905623c1465b2f893.jpg_200x200q90.jpg",
        "price": 5784.18,
        "remark": "https://www.lazada.co.th/products/pdp-i6078055916.html",
        "sold": 0
    },
    {
        "product_name": "(LB7H) 2X Outdoor Folding Pot Silicone Hiking Cooking Pot Portable Picnic Pot Stainless Steel Camping Cooker,Green",
        "product_image": "https://img.lazcdn.com/g/p/a3edec822d81f7cef4e8d3f0092aefb1.jpg_200x200q90.jpg",
        "price": 5766,
        "remark": "https://www.lazada.co.th/products/pdp-i16132991796.html",
        "sold": 0
    },
    {
        "product_name": "(LB6H) 2 x Outdoor Folding Pot Silicone Hiking Cooking Pot Portable Picnic Pot Stainless Steel Camping Cooker,Green",
        "product_image": "https://img.lazcdn.com/g/p/a3edec822d81f7cef4e8d3f0092aefb1.jpg_200x200q90.jpg",
        "price": 5766,
        "remark": "https://www.lazada.co.th/products/pdp-i16131335551.html",
        "sold": 0
    },
    {
        "product_name": "CAROTE | ชุดกระทะครัวพร้อมด้ามจับถอดได้ ไม่ติดกระทะ 3 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S06fa3f7bfa024ecc9fff979d7cd9a922L.png_200x200q90.png",
        "price": 5740.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5891941747.html",
        "sold": 14
    },
    {
        "product_name": "MEYER Stackable Cookware Set 4 ชิ้น Non-Stick ชุดหม้อกระทะ ประหยัดพื้นที่ครัว ใช้ได้กับทุกเตา",
        "product_image": "https://img.lazcdn.com/g/p/7635785331464a08dd53b13cc6d8785d.png_200x200q90.png",
        "price": 5728,
        "remark": "https://www.lazada.co.th/products/pdp-i5845379525.html",
        "sold": 0
    },
    {
        "product_name": "Tiartisan | หม้อทำอาหารไทเทเนียมพกพาสำหรับ 2 คน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S163844dc8a354f54bf894159753372bbz.jpg_200x200q90.jpg",
        "price": 5700.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16049219476.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา GF-TH",
        "product_image": "https://img.lazcdn.com/g/p/4a781d9ca9b70298dc2aa1468202811a.jpg_200x200q90.jpg",
        "price": 5664,
        "remark": "https://www.lazada.co.th/products/pdp-i16082642047.html",
        "sold": 0
    },
    {
        "product_name": "กระตกนำรอน-เยนขนาดใหญ 1.8 ลตร สแตนเลสสญญากาศ พกพาสะดวก สำหรบแคมปปง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sac53987b70db4a469abee8bcd18c1e07V.png_200x200q90.png",
        "price": 5661.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16120263979.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA ชุดเครื่องครัวแคมป์ปิ้งหม้อและกระทะสำหรับทำรังแบบพกพาน้ำหนักเบาสำหรับ 2-3 คนพร้อมที่จับกันลื่น",
        "product_image": "https://img.lazcdn.com/g/p/d69460ae96e599ec4e9237039c35fdae.jpg_200x200q90.jpg",
        "price": 5660,
        "remark": "https://www.lazada.co.th/products/pdp-i16145249999.html",
        "sold": 0
    },
    {
        "product_name": "ชุดถ้วย Panci Camping เซทเครื่องครัวตั้งแคมป์ปลอดภัยสแตนเลส304พับได้แบบพกพา12ชิ้นสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/036a5a0617836c099f11e42ec7dd4252.jpg_200x200q90.jpg",
        "price": 5660,
        "remark": "https://www.lazada.co.th/products/pdp-i6002265438.html",
        "sold": 0
    },
    {
        "product_name": "เตากระทะร้อนชาบู ( เตาปิคนิค + กระทะร้อนชาบูทองเหลือง 11.5 นิ้ว) กระทะโคขุน เตาแก๊สกระป๋อง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seeab1897d59a4349bd35c491c283ff93B.jpg_200x200q90.jpg",
        "price": 5660,
        "remark": "https://www.lazada.co.th/products/pdp-i4297182657.html",
        "sold": 1
    },
    {
        "product_name": "ชุดเครื่องครัวแคมป์ปิ้งหม้อและกระทะสำหรับทำรังแบบพกพาน้ำหนักเบาสำหรับ 2-3 คนพร้อมที่จับกันลื่น",
        "product_image": "https://img.lazcdn.com/g/p/bf09c10d97cfa630c84a84b1aa2fcb2b.jpg_200x200q90.jpg",
        "price": 5660,
        "remark": "https://www.lazada.co.th/products/pdp-i16145123943.html",
        "sold": 0
    },
    {
        "product_name": "2 Quart Camping Saucepan Boiling Water Portable Picnic Pot Cooking Pot with Lid Foldable Handle",
        "product_image": "https://img.lazcdn.com/g/p/28a1bd262e89354ed2547aa163490845.jpg_200x200q90.jpg",
        "price": 5096,
        "remark": "https://www.lazada.co.th/products/pdp-i16116651058.html",
        "sold": 0
    },
    {
        "product_name": "2 Quart Camping Saucepan Boiling Water Portable Picnic Pot Cooking Pot with Lid Portable IH Compatible CC-18",
        "product_image": "https://img.lazcdn.com/g/p/28a1bd262e89354ed2547aa163490845.jpg_200x200q90.jpg",
        "price": 5656,
        "remark": "https://www.lazada.co.th/products/pdp-i16138763576.html",
        "sold": 0
    },
    {
        "product_name": "Solo Stove 2 Pot Set หม้อสแตนเลส 2 ใบ ขนาด 1.5 ลิตร 3 ลิตร เข้าชุดกับเตา Solo Stove Campfire by Jeep Camping",
        "product_image": "https://img.lazcdn.com/g/p/f74183126938a295a46bdc72186bfd4c.jpg_200x200q90.jpg",
        "price": 5640,
        "remark": "https://www.lazada.co.th/products/pdp-i5281722783.html",
        "sold": 0
    },
    {
        "product_name": "YIWENG กาต้มน้ำ Set Alat Masak 4ชิ้น,ถ้วยโรงอาหารอะลูมิเนียมชุดเตาไม้พร้อมช้อนส้อมแบบพับได้และกระเป๋าครอบสำหรับตั้งแคมป์เดินป่าแบกเป้เงิน",
        "product_image": "https://img.lazcdn.com/g/p/9ff85b81808942a8cd85f1c18d45025d.jpg_200x200q90.jpg",
        "price": 3660,
        "remark": "https://www.lazada.co.th/products/pdp-i6071383206.html",
        "sold": 0
    },
    {
        "product_name": "CHUMS Reversible Grill Plate / กระทะเหล็กหล่อ cast iron กระทะปิ้งย่าง BBQ บาร์บีคิว ใช้งานได้ 2 ด้าน แบรนด์ชัมส์",
        "product_image": "https://img.lazcdn.com/g/p/26b84d6f18bd1ace4ba8587a7110a49e.png_200x200q90.png",
        "price": 5610,
        "remark": "https://www.lazada.co.th/products/pdp-i4392059205.html",
        "sold": 0
    },
    {
        "product_name": "【Latest model】Mini Cooking System Outdoor Cookware Hiking Mountaineering Stoves Boiling Water Windproof Camping",
        "product_image": "https://img.lazcdn.com/g/p/d1a92caddfdd7ccb62d1655ad83d14f5.jpg_200x200q90.jpg",
        "price": 5586,
        "remark": "https://www.lazada.co.th/products/pdp-i16081637720.html",
        "sold": 0
    },
    {
        "product_name": "YICHEN | ชุดภาชนะดินเผาสีอันเดอร์กลาซใหม่สไตล์เอสเธติก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbf07cac1aaf8464985556f4edd5922a1i.jpg_200x200q90.jpg",
        "price": 5556.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5912542123.html",
        "sold": 2
    },
    {
        "product_name": "ตั้งแคมป์เดินป่าปิกนิกกลางแจ้งอัลตราไลต์ไทเทเนียม Snozy กระทะทอดทำอาหาร",
        "product_image": "https://img.lazcdn.com/g/p/ca0dde67575eded47a495f4d2af7fe90.jpg_200x200q90.jpg",
        "price": 5556.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6075275526.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO กลางแจ้งเครื่องครัวหม้อสแตนเลสอย่างหนาหม้อเคี่ยวหม้อเคี่ยวหม้อเหล็กหนาสแตนเลสหม้อดัตช์ของชาวดัตช์สแตนเลสหม้อดัตช์หม้อเคี่ยว Huiop Mewcat",
        "product_image": "https://img.lazcdn.com/g/p/55f325f9cf9768045209fc43f05f6041.jpg_200x200q90.jpg",
        "price": 5504,
        "remark": "https://www.lazada.co.th/products/pdp-i5164134418.html",
        "sold": 0
    },
    {
        "product_name": "ทาฮิดะกาต้มน้ำกระทะทอดเครื่องครัวแคมปิ้งชุดอุปกรณ์ทานอาหารชุดอุปกรณ์ทำอาหารพับได้สำหรับการเดินป่าในครอบครัวที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/p/1981e62891e4df2cc5290b6211c73fa4.jpg_200x200q90.jpg",
        "price": 5502,
        "remark": "https://www.lazada.co.th/products/pdp-i16086940089.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องตัดส้อมช้อนตวงกาต้มน้ำกระทะแบบพกพาสำหรับปิกนิกเดินป่าแบบเซทเครื่องครัวตั้งแคมป์น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/6c5e794ad187fde687920d0b420fa070.jpg_200x200q90.jpg",
        "price": 5500,
        "remark": "https://www.lazada.co.th/products/pdp-i6077199181.html",
        "sold": 0
    },
    {
        "product_name": "ชุดชุดเครื่องใช้บนโต๊ะอาหารทำอาหารหม้อปิกนิกและชามอุปกรณ์ทำอาหารขณะตั้งแคมป์เหล็กซิลิโคนสแตนเลสพับได้สำหรับเครื่องครัวบาร์บีคิวตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/9194f6d7b342d216fb18e45e7d0e67e2.jpg_200x200q90.jpg",
        "price": 5452,
        "remark": "https://www.lazada.co.th/products/pdp-i6007557703.html",
        "sold": 0
    },
    {
        "product_name": "Ailong ชุดเตาหม้อข้าวญี่ปุ่นพร้อมฝาไม้และถาดให้ความร้อนหม้อซุปเตาหม้อหุงข้าวขาตั้งหม้อสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/a05584b927b7eb657baa409c9feb3366.jpg_200x200q90.jpg",
        "price": 5452,
        "remark": "https://www.lazada.co.th/products/pdp-i5408617448.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO เตาอั้งโล่ฟืนเหล็กกลางแจ้งเตาอั้งโล่ Bbq ปิกนิกฟืนสแตนเลสแบบพกพาได้เตาอั้งโล่พกพาได้สำหรับปิกนิกเตาอั้งโล่เงินแบบพกพา Bbq ปิกนิก Huiop Twirltide Qahe Buzhi",
        "product_image": "https://img.lazcdn.com/g/p/8b995aafde703acf4dd9833809b170f7.jpg_200x200q90.jpg",
        "price": 5426,
        "remark": "https://www.lazada.co.th/products/pdp-i5436973112.html",
        "sold": 0
    },
    {
        "product_name": "Moon กระถางและกระทะตั้งแคมป์สำหรับ2-3คนเครื่องครัวแคมปิ้งชุดทำอาหารตั้งแคมป์สำหรับปิกนิกแบกเป้บาร์บีคิว",
        "product_image": "https://img.lazcdn.com/g/p/de41d2afb78955de85948a5a55195a1c.jpg_200x200q90.jpg",
        "price": 5422,
        "remark": "https://www.lazada.co.th/products/pdp-i16075725698.html",
        "sold": 0
    },
    {
        "product_name": "【Life and Movement】Portable Stainless Steel Camping Cookware, Thickened Frying Pan with Detachable Handle for Picnic and Steak Cooking",
        "product_image": "https://img.lazcdn.com/g/p/726c3b57d77e9d81a9fc65d2a1c54cea.jpg_200x200q90.jpg",
        "price": 5408,
        "remark": "https://www.lazada.co.th/products/pdp-i16067946798.html",
        "sold": 0
    },
    {
        "product_name": "Gispark หม้อทำอาหารหม้อข้าวญี่ปุ่นหม้อซุปเตาตั้งไม่ติดหม้อสำหรับแบกเป้เดินทางปาร์ตี้กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/ae1c7ec54b51f3054b888fc253e32dfc.jpg_200x200q90.jpg",
        "price": 5406,
        "remark": "https://www.lazada.co.th/products/pdp-i5408667166.html",
        "sold": 0
    },
    {
        "product_name": "Gociy ชุดเตาหม้อข้าวญี่ปุ่นแผ่นให้ความร้อนไม่ติดหม้ออาหารขาตั้งหม้อเครื่องครัวอเนกประสงค์สำหรับการเดินทางกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/1d624a3e76a550e44b17b8f40bf247f1.jpg_200x200q90.jpg",
        "price": 5406,
        "remark": "https://www.lazada.co.th/products/pdp-i5408480965.html",
        "sold": 0
    },
    {
        "product_name": "Primus LiTech Pot Set 2.3L#หม้ออลูมิเนียมขนาดใหญ่ เคลือบเซรามิกแบบไม่ติดหม้อ2.3ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/f952091ef5a00bd1b7d17e9af2a1d3a3.jpg_200x200q90.jpg",
        "price": 5400,
        "remark": "https://www.lazada.co.th/products/pdp-i5842183325.html",
        "sold": 0
    },
    {
        "product_name": "UCO® Mess Kit Camping Spork 6 Piece ชุดอุปกรณ์ทานอาหารสำหรับการตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/82617c0979deefbeffa22c9324240385.jpg_200x200q90.jpg",
        "price": 5370,
        "remark": "https://www.lazada.co.th/products/pdp-i5904135396.html",
        "sold": 0
    },
    {
        "product_name": "Outdoor Cooking System Mini Hiking Mountaineering Cookware Stove Boiling Water Windproof Camping",
        "product_image": "https://img.lazcdn.com/g/p/d1a92caddfdd7ccb62d1655ad83d14f5.jpg_200x200q90.jpg",
        "price": 5358,
        "remark": "https://www.lazada.co.th/products/pdp-i16134284823.html",
        "sold": 0
    },
    {
        "product_name": "Camping Cooking Mini System Windproof Outdoor Boiling Water Stove Mountaineering Hiking Cookware",
        "product_image": "https://img.lazcdn.com/g/p/d1af1afe5b4ea5789f680dc94361dfd7.jpg_200x200q90.jpg",
        "price": 5358,
        "remark": "https://www.lazada.co.th/products/pdp-i16125760139.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO ทั่วไป ชุดเครื่องครัวตั้งแคมป์ อะลูมินัมอัลลอยเครื่องครัวตั้งแคมป์หม้อปรุงอาหารกระทะชุดกาต้มน้ำน้ำหนักเบาแบบพกพาเครื่องครัวตั้งแคมป์ชุดระเบียบสำหรับตั้งแคมป์เดินป่าปิคนิค",
        "product_image": "https://img.lazcdn.com/g/p/70307deea96bcf2e0d2791b3d90dd319.jpg_200x200q90.jpg",
        "price": 5357.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16078557372.html",
        "sold": 0
    },
    {
        "product_name": "Titanium Camping Soup Pot Set Outdoor Light Steamer Steam Compartment Multi Functional Cookware",
        "product_image": "https://img.lazcdn.com/g/p/9e835b2688be609eb8d9b3178bdb2ba7.jpg_200x200q90.jpg",
        "price": 5354,
        "remark": "https://www.lazada.co.th/products/pdp-i16068152483.html",
        "sold": 0
    },
    {
        "product_name": "เซทเครื่องครัวตั้งแคมป์เป้พับได้ตั้งแคมป์กระถางและกระทะพร้อมกาต้มน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/15c5cfd7d1f72e05a20e84f7899e41fc.jpg_200x200q90.jpg",
        "price": 5344,
        "remark": "https://www.lazada.co.th/products/pdp-i6077421266.html",
        "sold": 0
    },
    {
        "product_name": "ใชงานไดหลากหลาย เหมาะสำหรบรานอาหาร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S151e8ed7a3c841d88fa68df89100acc5H.jpg_200x200q90.jpg",
        "price": 5326.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16046933207.html",
        "sold": 0
    },
    {
        "product_name": "[Lapurer] Boiling Water Camping Soup Pot Thickened Composite Outdoor Portable Picnic Pot Cooking Utensil",
        "product_image": "https://img.lazcdn.com/g/p/28a1bd262e89354ed2547aa163490845.jpg_200x200q90.jpg",
        "price": 5298,
        "remark": "https://www.lazada.co.th/products/pdp-i16136884612.html",
        "sold": 0
    },
    {
        "product_name": "กระบอกน้ำถ้วยเก็บอุณหภูมิไทเทเนียมกับธุรกิจที่กรองชาพ่นทราย",
        "product_image": "https://img.lazcdn.com/g/p/3a1144d86db8607996a5ca5e79878319.jpg_200x200q90.jpg",
        "price": 5274,
        "remark": "https://www.lazada.co.th/products/pdp-i6023256770.html",
        "sold": 0
    },
    {
        "product_name": "Camping Cooking System Mini Outdoor Stove Water Boiling Mountaineering Hiking Windproof Cookware",
        "product_image": "https://img.lazcdn.com/g/p/d1af1afe5b4ea5789f680dc94361dfd7.jpg_200x200q90.jpg",
        "price": 4532,
        "remark": "https://www.lazada.co.th/products/pdp-i16138779019.html",
        "sold": 0
    },
    {
        "product_name": "Hiking Mountaineering Mini Cooking System Outdoor Stove Windproof Camping Cookware Boiling Water",
        "product_image": "https://img.lazcdn.com/g/p/d1a92caddfdd7ccb62d1655ad83d14f5.jpg_200x200q90.jpg",
        "price": 5260,
        "remark": "https://www.lazada.co.th/products/pdp-i16140393469.html",
        "sold": 0
    },
    {
        "product_name": "Soto Amicus New River Pot Combo ชุดหม้อพร้อมหัวเตา หม้ออะลูมิเนียมแคมป์ปิ้ง ชุดครัวแคมปิ้ง หม้อแคมป์ปิ้ง พกพา น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/4d40023362bb33dccc705679f551408d.jpg_200x200q90.jpg",
        "price": 5260,
        "remark": "https://www.lazada.co.th/products/pdp-i910062477.html",
        "sold": 3
    },
    {
        "product_name": "Cocoli อ่างล้างจานสแตนเลสสำหรับถังล้างอุปกรณ์อ่างล้างแคมป์ปิ้งกลางแจ้งสำหรับทำอาหารแว่นกันแดดตกปลาสวนหลังบ้าน RV",
        "product_image": "https://img.lazcdn.com/g/p/119e2f13e04c79ed5345d71dc39df27f.jpg_200x200q90.jpg",
        "price": 5256,
        "remark": "https://www.lazada.co.th/products/pdp-i5991653974.html",
        "sold": 0
    },
    {
        "product_name": "Ellwewe อ่างล้างจานสแตนเลสสำหรับสวนหลังบ้านอ่างล้างอ่างน้ำของก๊อกน้ำสำหรับอ่างล้างจานสำหรับตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/f07255f073cfe27dc8ae581988197269.jpg_200x200q90.jpg",
        "price": 5256,
        "remark": "https://www.lazada.co.th/products/pdp-i16077684809.html",
        "sold": 0
    },
    {
        "product_name": "Ailong อ่างล้างจานสแตนเลสสำหรับตั้งแคมป์ในก๊อกน้ำสำหรับอ่างล้างจานอ่างล้างจานชามเดี่ยวอเนกประสงค์สำหรับห้องครัวกลางแจ้งเล่นกีฬาทำบาร์บีคิว",
        "product_image": "https://img.lazcdn.com/g/p/57e6d7f3d00db449519f1327b39b43cf.jpg_200x200q90.jpg",
        "price": 5256,
        "remark": "https://www.lazada.co.th/products/pdp-i5920666773.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา MA-TH",
        "product_image": "https://img.lazcdn.com/g/p/31b2bb99391abea4db37ac181224b481.jpg_200x200q90.jpg",
        "price": 5220,
        "remark": "https://www.lazada.co.th/products/pdp-i16071974974.html",
        "sold": 0
    },
    {
        "product_name": "Mini Cooking System Outdoor Cookware Hiking Mountaineering Stove Boiling Water Windproof Camping",
        "product_image": "https://img.lazcdn.com/g/p/d1af1afe5b4ea5789f680dc94361dfd7.jpg_200x200q90.jpg",
        "price": 5214,
        "remark": "https://www.lazada.co.th/products/pdp-i16143821864.html",
        "sold": 0
    },
    {
        "product_name": "(LB6H) 2 x Widesea Camping Cookware Outdoor Cooking Set Tableware Rapid Heating Camping Pot Heat Exchanger Cooker Equipment",
        "product_image": "https://img.lazcdn.com/g/p/a0d420bfb90c0ab9734b53752bc46c73.jpg_200x200q90.jpg",
        "price": 5210,
        "remark": "https://www.lazada.co.th/products/pdp-i16131447060.html",
        "sold": 0
    },
    {
        "product_name": "(LQ5X) 2 x Widesea Camping Cookware Outdoor Cooking Set Tableware Rapid Heating Camping Pot Heat Exchanger Cooker Equipment",
        "product_image": "https://img.lazcdn.com/g/p/a0d420bfb90c0ab9734b53752bc46c73.jpg_200x200q90.jpg",
        "price": 5210,
        "remark": "https://www.lazada.co.th/products/pdp-i16133862956.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัว 4 ชิ้น หม้อต้มน้ำนม เคลือบผิวไม่ติด กระทะทอด กระทะกลมลึก ใช้ได้กับเตาทุกชนิด พร้อมฝาปิด",
        "product_image": "https://img.lazcdn.com/g/p/d1f0e0ee4f36edfdf3208361dff4a3bd.png_200x200q90.png",
        "price": 5198,
        "remark": "https://www.lazada.co.th/products/pdp-i16131718098.html",
        "sold": 0
    },
    {
        "product_name": "Loobby กระทะหม้อนึ่ง Panci Camping กระทะหม้อปรุงอาหารกลางแจ้งอะลูมินัมอัลลอยเครื่องนึ่งในครัวเรือนเพื่อความอยู่รอดกระเป๋าแบ็คแพ็คสำหรับกิจกรรมกลางแจ้งบาร์บีคิว",
        "product_image": "https://img.lazcdn.com/g/p/a9f6467d680214695a9bb9cd84e4f925.jpg_200x200q90.jpg",
        "price": 5194,
        "remark": "https://www.lazada.co.th/products/pdp-i5887518151.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวไม่ติด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S140a11d8bfe94006a83b73484322b1cdy.jpg_200x200q90.jpg",
        "price": 5189.18,
        "remark": "https://www.lazada.co.th/products/pdp-i6066655062.html",
        "sold": 0
    },
    {
        "product_name": "ชุดหม้อและกระทะไททาเนียม 3 ชิ้น Keith Ti6014",
        "product_image": "https://img.lazcdn.com/live/th/p/4a642314d481498918715f5c174dc074.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i155046658.html",
        "sold": 0
    },
    {
        "product_name": "Tefal ชุดเครื่องครัว SO MATCHA​ 4 ชิ้น สีเขียวอ่อน รุ่น G179S495",
        "product_image": "https://img.lazcdn.com/g/p/9d8ac4410c506c0c6fd31ad2b5a712f7.png_200x200q90.png",
        "price": 5178,
        "remark": "https://www.lazada.co.th/products/pdp-i5281471968.html",
        "sold": 0
    },
    {
        "product_name": "ชุดตะเกียงหม้อข้าวญี่ปุ่นพร้อมฝาไม้และถาดใส่เครื่องครัวหม้ออาหารอะลูมินัมอัลลอยหม้อซุปอเนกประสงค์สำหรับปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/fcdee1e684f01e021531e259a18e1cf4.jpg_200x200q90.jpg",
        "price": 5173.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16120619912.html",
        "sold": 0
    },
    {
        "product_name": "เหล็กหล่อรูปวงรี ถาดอบขนมปัง *คละสี* หม้อเตาอบเคลือบดัตช์ เครื่องครัว หม้อตุ๋น เหล็กหล่อ ปลอดภัย Bread Baking Pan โปรโมชั่น Toppick",
        "product_image": "https://img.lazcdn.com/g/p/2193c9709ba1893b9a289e00fb4dd284.jpg_200x200q90.jpg",
        "price": 5170,
        "remark": "https://www.lazada.co.th/products/pdp-i16069195617.html",
        "sold": 0
    },
    {
        "product_name": "COONOR ชุดอุปกรณ์ทานอาหารชุดพกพาสำหรับกลางแจ้งชุดปิกนิก2-3คน Set Alat Masak ชุดกระทะใช้บนโต๊ะอาหารเครื่องครัว Huiop แบบพกพาหม้อหม้อหุงต้มชุดกระทะเครื่องใช้สำหรับโต๊ะอาหารกลางแจ้งเตาพกพา",
        "product_image": "https://img.lazcdn.com/g/p/6ab99b72e5f783e0210ee2e29cf2f26d.jpg_200x200q90.jpg",
        "price": 5142,
        "remark": "https://www.lazada.co.th/products/pdp-i5573162883.html",
        "sold": 0
    },
    {
        "product_name": "COONOR เครื่องครัวชุดภาชนะแบบพกพาเครื่องครัวชุดอุปกรณ์ทานอาหารชุดเตา Set Alat Masak ชุดกระทะ2-3คนชุดเตากลางแจ้ง Huiop เครื่องใช้สำหรับโต๊ะอาหารกลางแจ้งปิคนิคกลางแจ้ง Mewmewcat หม้อกระทะคนหม้อหุงต้ม2-3 Pessoas",
        "product_image": "https://img.lazcdn.com/g/p/6ab99b72e5f783e0210ee2e29cf2f26d.jpg_200x200q90.jpg",
        "price": 5142,
        "remark": "https://www.lazada.co.th/products/pdp-i5572047825.html",
        "sold": 0
    },
    {
        "product_name": "Widesea Camping ระบบทําอาหารพร้อมแลกเปลี่ยนความร้อนเตาแก๊สกลางแจ้งชุดหม้อท่องเที่ยวถ้วยบนโต๊ะอาหารเครื่องครัวการท่องเที่ยว Hike",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7b096a070c434a40bd7cb3f7b14727c3d.jpg_200x200q90.jpg",
        "price": 5140.72,
        "remark": "https://www.lazada.co.th/products/pdp-i5799529288.html",
        "sold": 0
    },
    {
        "product_name": "CCAngel คีมคีบฟืนสำหรับงานหนักที่คีบฟืนแบบอเนกประสงค์คีมคีบฟืนที่คีบฟืนที่ใช้ในครัวเรือนสำหรับบาร์บีคิวการตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/b607e8023ca3f2b0df11672262e159ef.jpg_200x200q90.jpg",
        "price": 5138.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16062395015.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา YR-TH",
        "product_image": "https://img.lazcdn.com/g/p/b7ae7ff34904a930c6aa0f56faf4e43a.jpg_200x200q90.jpg",
        "price": 5088,
        "remark": "https://www.lazada.co.th/products/pdp-i16083739089.html",
        "sold": 0
    },
    {
        "product_name": "เตาแคมป์พับได้แบบพกพา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4ff3471633724f57b957b66951e4c8fdx.jpg_200x200q90.jpg",
        "price": 5088,
        "remark": "https://www.lazada.co.th/products/pdp-i539660071.html",
        "sold": 0
    },
    {
        "product_name": "หม้อต้มชาม Mangkuk Bertutup ตั้งแคมป์พร้อม HANDEL Lipat กันลวกแบบพกพาเครื่องครัวสำหรับกลางแจ้งปิกนิกเดินป่าการเดินทางแบบสะพายหลังน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/bad405a3a42f9a922c9863661d5fd249.jpg_200x200q90.jpg",
        "price": 5073.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6073793827.html",
        "sold": 0
    },
    {
        "product_name": "กระตกนำสแตนเลสเกบความรอน-เยน สำหรบแคมปปง พกพาสะดวก สเงน คณภาพพรเมยม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd73627087492430aa451604411bc3562W.png_200x200q90.png",
        "price": 5060.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16120501572.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา JS-006-TH",
        "product_image": "https://img.lazcdn.com/g/p/15129985ecd4368e7e49db2322bf6a1f.jpg_200x200q90.jpg",
        "price": 5055,
        "remark": "https://www.lazada.co.th/products/pdp-i16083450596.html",
        "sold": 0
    },
    {
        "product_name": "แผ่นแสตนเลสสตีล Teggry และชามอุปกรณ์ทานอาหารสำหรับตั้งแคมป์สำหรับบาร์บีคิวใช้กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/e2a4d4c2511475b8141b46101b124716.jpg_200x200q90.jpg",
        "price": 5043.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16121741718.html",
        "sold": 0
    },
    {
        "product_name": "WUXIN | ชุดจานชามของขวัญสำหรับงานเลี้ยงต้อนรับบ้านใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S85655967e34b4460af299f81935c009d1.jpg_200x200q90.jpg",
        "price": 5022.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16055085507.html",
        "sold": 0
    },
    {
        "product_name": "กระทะต้มเส้น กระทะต้มข้าวสาร กระทะต้มเส้นอันร้อนแรง กระทะต้มขนมจีน กระทะต้มข้าวอันร้อนแรง อุปกรณ์ทำอาหารในครัว เตาแก๊สอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8d3e32f01aab44aa985238d7deda37e0M.jpg_200x200q90.jpg",
        "price": 5016,
        "remark": "https://www.lazada.co.th/products/pdp-i4878031326.html",
        "sold": 13
    },
    {
        "product_name": "[โปรร้อนแรง!!] อ่างรูปไข่ซ้อนได้ รุ่น CR-620-11 ขนาด 620 ลิตร สีน้ำเงิน | อ่างรูปไข่ซ้อนได้ เครื่องครัว ราคาถูก",
        "product_image": "https://img.lazcdn.com/g/p/f1d2d31fb14c8af9ed8df0787f3b08ac.jpg_200x200q90.jpg",
        "price": 5014,
        "remark": "https://www.lazada.co.th/products/pdp-i3112869507.html",
        "sold": 0
    },
    {
        "product_name": "ZEROKY CLAN | ชุดเครื่องใช้สำหรับรับประทานอาหารที่บ้านหรูหรา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0f807079fb6a4264b347410a58a365f8b.jpg_200x200q90.jpg",
        "price": 5007.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5877120186.html",
        "sold": 3
    },
    {
        "product_name": "หม้อปรุงอาหารกลางแจ้งความจุใหญ่ทำจากไทเทเนียมบริสุทธิ์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4f808cb20388401a8da7447b86cb7d2bo.jpg_200x200q90.jpg",
        "price": 5003.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16117729855.html",
        "sold": 0
    },
    {
        "product_name": "กระทะ Petromax Grill Fire Skillet with two handles (gp35h-t)",
        "product_image": "https://img.lazcdn.com/g/p/7adc9a0375f522fa078b1fce887f3063.jpg_200x200q90.jpg",
        "price": 5000,
        "remark": "https://www.lazada.co.th/products/pdp-i4107094441.html",
        "sold": 0
    },
    {
        "product_name": "[HOT SALE!] ชุดหม้อแขกสแตนเลส รุ่น แปซิฟิค ขนาด 14 - 30 ซม. สีเงิน | ชุดหม้อแขกสแตนเลส เครื่องครัว ราคาถูก",
        "product_image": "https://img.lazcdn.com/g/p/83549d242deeeb0e4502d9800e308a97.jpg_200x200q90.jpg",
        "price": 5000,
        "remark": "https://www.lazada.co.th/products/pdp-i3112858517.html",
        "sold": 0
    },
    {
        "product_name": "[สินค้าใหม่]Tefal เซ็ตเครื่องครัว 6 ชิ้น So Matcha ก้นอินดักชั่น รุ่น G179S695",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S35271a5c3bc443559378a40ab134aaf6m.jpg_200x200q90.jpg",
        "price": 4990,
        "remark": "https://www.lazada.co.th/products/pdp-i4871035206.html",
        "sold": 19
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา LA3PF-VIB-TH",
        "product_image": "https://img.lazcdn.com/g/p/bf9e88a7e7e53339c029a6e80071d972.jpg_200x200q90.jpg",
        "price": 4990,
        "remark": "https://www.lazada.co.th/products/pdp-i16093938719.html",
        "sold": 0
    },
    {
        "product_name": "ชุดครัวอลูมิเนียม ชุดแคมปิ้ง เก็บได้เล็ก มีหม้อ-กระทะ-บังลม-กาต้มน้ำ-เตาแอลกอฮอล์",
        "product_image": "https://img.lazcdn.com/g/p/8d7a4a2d95889477e82d346d7c0e499b.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i2495883645.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา TA-TH",
        "product_image": "https://img.lazcdn.com/g/p/a2f49ee55eef2bc8e01e8f813a5c3e52.jpg_200x200q90.jpg",
        "price": 4971,
        "remark": "https://www.lazada.co.th/products/pdp-i16074980916.html",
        "sold": 0
    },
    {
        "product_name": "เตาประกอบอาหารแบบพกพาสำหรับใช้กลางแจ้งนี้ เป็นอุปกรณ์ที่ขาดไม่ได้สำหรับการหุงข้าว ผัดผัก ตั้งแคมป์ ปิกนิก ตกปลา และกิจกรรมกลางแจ้งอื่นๆ",
        "product_image": "https://img.lazcdn.com/g/p/31bc64f6664f08cbcbbd0d87a9ecd9a1.jpg_200x200q90.jpg",
        "price": 4970,
        "remark": "https://www.lazada.co.th/products/pdp-i16106546464.html",
        "sold": 0
    },
    {
        "product_name": "Sposport ชุดทำอาหารตั้งแคมป์เซทเครื่องครัวตั้งแคมป์4ชิ้นพร้อมมือจับหม้อพับและกระทะสำหรับตั้งแคมป์กระเป๋าแบ็คแพ็คสำหรับกิจกรรมกลางแจ้งอุปกรณ์ปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/57bab0e9fd3b156120cedd567c51ccb2.jpg_200x200q90.jpg",
        "price": 4946,
        "remark": "https://www.lazada.co.th/products/pdp-i5909029948.html",
        "sold": 0
    },
    {
        "product_name": "Thickened Composite Outdoor Camping Soup Pot Boiling Water Pot Portable Picnic Cooking Utensil",
        "product_image": "https://img.lazcdn.com/g/p/28a1bd262e89354ed2547aa163490845.jpg_200x200q90.jpg",
        "price": 4946,
        "remark": "https://www.lazada.co.th/products/pdp-i16123709021.html",
        "sold": 0
    },
    {
        "product_name": "Windproof Camping Cooking System Mini Outdoor Stove Boiling Water Hiking Mountaineering Cookware",
        "product_image": "https://img.lazcdn.com/g/p/d1a92caddfdd7ccb62d1655ad83d14f5.jpg_200x200q90.jpg",
        "price": 4942,
        "remark": "https://www.lazada.co.th/products/pdp-i16120828143.html",
        "sold": 0
    },
    {
        "product_name": "Fire-Maple | ชุดเครื่องครัวสำหรับแค้มปิ้งไม่ติดกระทะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S14e2d7994f2a45988578b0efd0656d53v.jpg_200x200q90.jpg",
        "price": 4940.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16049148982.html",
        "sold": 0
    },
    {
        "product_name": "[LA1R]Mini Cooking System Outdoor Camping Windproof Stove Boiling Water Mountaineering Hiking Cookware",
        "product_image": "https://img.lazcdn.com/g/p/982800b9e8e05589e8058f8bf4792c5c.jpg_200x200q90.jpg",
        "price": 4928,
        "remark": "https://www.lazada.co.th/products/pdp-i16131184167.html",
        "sold": 0
    },
    {
        "product_name": "Oshhni ชุดเครื่องครัวแคมปิ้งเครื่องใช้ในครัวอลูมิเนียมหม้ออาหารพร้อมกระทะทอดกาต้มน้ำแบบไม่ติดสำหรับเดินป่ากลางแจ้งบาร์บีคิวเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/9363d6d477734f1684a09a49c5ed6f19.jpg_200x200q90.jpg",
        "price": 4916,
        "remark": "https://www.lazada.co.th/products/pdp-i5912367434.html",
        "sold": 0
    },
    {
        "product_name": "PHANT ค่าการนำความร้อนที่สม่ำเสมอ ถาดอบขนมสำหรับตั้งแคมป์ ดีไซน์น้ำหนักเบา ทนต่ออุณหภูมิสูง บาร์บีคิว ตัวเลือกการประกอบที่รวดเร็ว ขนาดพกพา บาร์บีคิวกริลล์ ตั้งแคมป์กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/e0812abd652f37cfdd390a9f5d2fd6ca.jpg_200x200q90.jpg",
        "price": 4898.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16095776191.html",
        "sold": 0
    },
    {
        "product_name": "2 Quart Camping Saucepan Boiling Water Portable Picnic Pot Cooking Utensils Portable IH Compatible CC-18",
        "product_image": "https://img.lazcdn.com/g/p/28a1bd262e89354ed2547aa163490845.jpg_200x200q90.jpg",
        "price": 4828,
        "remark": "https://www.lazada.co.th/products/pdp-i16138473491.html",
        "sold": 0
    },
    {
        "product_name": "Tefal เซ็ตเครื่องครัว 8 ชิ้น Day By Day ก้นอินดักชั่น รุ่น G143S895  ใช้ได้กับเตาทุกประเภท** รับประกันศูนย์ 2ปี",
        "product_image": "https://img.lazcdn.com/g/p/4213f6a01d42c254648c039afad1a273.png_200x200q90.png",
        "price": 4780,
        "remark": "https://www.lazada.co.th/products/pdp-i1081964012.html",
        "sold": 134
    },
    {
        "product_name": "ชามผสม ชามผสมแป้ง ชามสแตนเลส ชามเตรียมอาหาร กะละมังสแตนเลส (ชนิดหนาคุณภาพดี) 45 cm / 1 ใบ (STAINLESS STEAL 304 ชนิดหนาพิเศษ) - (High Quality) Stainless Steel Mixing Bowl",
        "product_image": "https://img.lazcdn.com/g/p/f479cb6748a1af943af25464a72d2d4c.jpg_200x200q90.jpg",
        "price": 4780,
        "remark": "https://www.lazada.co.th/products/pdp-i372556472.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO หม้อและกระทะเซทเครื่องครัวตั้งแคมป์เครื่องครัวกลางแจ้งสำหรับแบกเป้ค้างแรม",
        "product_image": "https://img.lazcdn.com/g/p/a8e4a3eb939ae63b4b49e95bd00872be.jpg_200x200q90.jpg",
        "price": 4766,
        "remark": "https://www.lazada.co.th/products/pdp-i5987913533.html",
        "sold": 0
    },
    {
        "product_name": "CAROTE | ชุดหม้อและกระทะไม่ติด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3849e93b7d284b4785550e6a89b01145L.jpg_200x200q90.jpg",
        "price": 4754.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5893321088.html",
        "sold": 18
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา XZZ-TH",
        "product_image": "https://img.lazcdn.com/g/p/9ec37556175324082b2f367ae94e15e1.jpg_200x200q90.jpg",
        "price": 4752,
        "remark": "https://www.lazada.co.th/products/pdp-i16085896804.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา TF-Ard-TH",
        "product_image": "https://img.lazcdn.com/g/p/2c537cdea08021b7896ab9a53294b8c1.jpg_200x200q90.jpg",
        "price": 4752,
        "remark": "https://www.lazada.co.th/products/pdp-i16078171533.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา ERT-TH",
        "product_image": "https://img.lazcdn.com/g/p/d994245a327f1ae9db79045a8599e01f.jpg_200x200q90.jpg",
        "price": 4752,
        "remark": "https://www.lazada.co.th/products/pdp-i16085964663.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา TF-Osh-TH",
        "product_image": "https://img.lazcdn.com/g/p/a70527e71b5f6d195bc096ef841d49e2.jpg_200x200q90.jpg",
        "price": 4746,
        "remark": "https://www.lazada.co.th/products/pdp-i16078187366.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา FDY-TH",
        "product_image": "https://img.lazcdn.com/g/p/d228190a0e90852616cbd06248d9988a.jpg_200x200q90.jpg",
        "price": 4746,
        "remark": "https://www.lazada.co.th/products/pdp-i16082584131.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา RHS-TH",
        "product_image": "https://img.lazcdn.com/g/p/8d9143694b180090fbab0856aff2f577.jpg_200x200q90.jpg",
        "price": 4746,
        "remark": "https://www.lazada.co.th/products/pdp-i16086158103.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา TF-Eda-TH",
        "product_image": "https://img.lazcdn.com/g/p/d4f106af21b6443405294f40509410a8.jpg_200x200q90.jpg",
        "price": 4746,
        "remark": "https://www.lazada.co.th/products/pdp-i16078040847.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา WMAO-TH",
        "product_image": "https://img.lazcdn.com/g/p/b9b01e53053906b6eca9754b2b30e50d.jpg_200x200q90.jpg",
        "price": 4746,
        "remark": "https://www.lazada.co.th/products/pdp-i16080230743.html",
        "sold": 0
    },
    {
        "product_name": "Mini Cooking System Outdoor Boiling Water Stove Windproof Camping Cookware for Hiking Mountaineering",
        "product_image": "https://img.lazcdn.com/g/p/d1a92caddfdd7ccb62d1655ad83d14f5.jpg_200x200q90.jpg",
        "price": 4738,
        "remark": "https://www.lazada.co.th/products/pdp-i16121449143.html",
        "sold": 0
    },
    {
        "product_name": "SUPVIBE ชุดเครื่องครัว 17ชิ้น ชุดหม้อกระทะ ถอดหม้อด้ามได้ ไม่ติดกระทะ กระทะ กระทะลึก หม้อต้ม รับรอง FDA",
        "product_image": "https://img.lazcdn.com/g/p/c16e22a8a0d24cd54d57db2a61ccb9ba.jpg_200x200q90.jpg",
        "price": 4738,
        "remark": "https://www.lazada.co.th/products/pdp-i5693561635.html",
        "sold": 5
    },
    {
        "product_name": "LIXADA-ชุดรับประทานอาหารเครื่องครัวแคมปิ้ง 10ชิ้น,ชุดเครื่องครัวไม่ติดภาชนะที่มีน้ำหนักเบาสามารถวางซ้อนกันได้อุปกรณ์เครื่องครัวตั้งแคมป์พร้อมกระเป๋าเก็บของกลางแจ้งแบบพกพาสำหรับปิกนิกกระเป๋าเป้ปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/502c4340f571347d3c25e7b2aecfc7a5.jpg_200x200q90.jpg",
        "price": 4704,
        "remark": "https://www.lazada.co.th/products/pdp-i5990634179.html",
        "sold": 0
    },
    {
        "product_name": "Prasku จานเตาถ่านแผ่นกระทะปิ้งย่างสำหรับปิกนิกอเนกประสงค์สำหรับงานปาร์ตี้ตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/1635654cb9f76130010ae73ecabc2903.jpg_200x200q90.jpg",
        "price": 4700,
        "remark": "https://www.lazada.co.th/products/pdp-i5520672531.html",
        "sold": 0
    },
    {
        "product_name": "CCClever กระทะทองน้ำหนักเบาอเนกประสงค์กลางแจ้งกระทะทองหนิงกระทะทองหนิงอุปกรณ์ที่ล้างกระทะทองสำหรับทำเหมืองในแหล่งน้ำแม่น้ำได้ง่ายขึ้น",
        "product_image": "https://img.lazcdn.com/g/p/5d22f63cfd4c9b9f1db18ceaea4f7433.jpg_200x200q90.jpg",
        "price": 4684,
        "remark": "https://www.lazada.co.th/products/pdp-i5923159284.html",
        "sold": 0
    },
    {
        "product_name": "BSWOLF | ชุดเครื่องครัวพกพาสำหรับนึ่ง ต้ม และทอด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbf2de9b550894bf38fe5a05f30e7b4698.jpg_200x200q90.jpg",
        "price": 4676.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6013925256.html",
        "sold": 34
    },
    {
        "product_name": "Ecowin ชุดเครื่องครัว 3/4 ชิ้น - ชุดกระทะไม่ติดกระทะ กระทะลึก กระทะ กระทะซอส กระทะทอด หม้อซุป",
        "product_image": "https://img.lazcdn.com/g/p/4b025c182650d1dda15976e684572487.jpg_200x200q90.jpg",
        "price": 4674,
        "remark": "https://www.lazada.co.th/products/pdp-i4293144766.html",
        "sold": 215
    },
    {
        "product_name": "BSWOLF | ชุดเครื่องครัวสำหรับแคมป์ปิ้งแบบครบวงจร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S61dfd72dc71e4efb8fe0714eeec89f0ex.jpg_200x200q90.jpg",
        "price": 4670.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6013924628.html",
        "sold": 8
    },
    {
        "product_name": "QUECHUA ชุดเครื่องครัวสเตนเลส เคลือบผิวกันติด รุ่น MH500 สำหรับ 4 คน ขนาด 3.5 ลิตร ( Stainless Steel Camping Cook Set - 3.5L ) CAMPING TENTS เต็นท์ แคมป์ปิ้ง ตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/49ced5a548b0fa132348e47439c8ad36.jpg_200x200q90.jpg",
        "price": 4640,
        "remark": "https://www.lazada.co.th/products/pdp-i3851474733.html",
        "sold": 0
    },
    {
        "product_name": "Kovea Solo Lite (Stove included) ชุดหม้อพร้อมหัวเตา หม้ออะลูมิเนียมแคมป์ปิ้ง ชุดครัวแคมปิ้ง หม้อแคมป์ปิ้งพกพา",
        "product_image": "https://img.lazcdn.com/g/p/ef07d5632050cff4c39356b308da1af5.jpg_200x200q90.jpg",
        "price": 4640,
        "remark": "https://www.lazada.co.th/products/pdp-i1310898482.html",
        "sold": 1
    },
    {
        "product_name": "แก้วเก็บความร้อนขนาดใหญ่ พกพาได้ ป้องกันการลวก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbf154483ef564bdcbf2c54b5a0ecf4f0d.png_200x200q90.png",
        "price": 4638.28,
        "remark": "https://www.lazada.co.th/products/pdp-i6068025216.html",
        "sold": 5
    },
    {
        "product_name": "ชุดหม้อ  และกระทะ 5PCS กระทะเคลือบ กระทะหินอ่อน ชิ้น กระทะก้นลึก หม้อซุป หม้อนม ใช้ได้กับเตาทุกประเภท",
        "product_image": "https://img.lazcdn.com/g/p/bb6e297a7c8b6568db145ccb7d6a0657.jpg_200x200q90.jpg",
        "price": 4638.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5651916434.html",
        "sold": 33
    },
    {
        "product_name": "กระทะแบบพกพาสำหรับปิกนิกถือง่าย",
        "product_image": "https://img.lazcdn.com/g/p/a49887d5cd8c7ab0702a4f993547589f.jpg_200x200q90.jpg",
        "price": 4634,
        "remark": "https://www.lazada.co.th/products/pdp-i6002244121.html",
        "sold": 0
    },
    {
        "product_name": "ภาชนะ และอปกรณทำอาหาร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd0aab04067cb4274a5ee4fd820e5bab1H.jpg_200x200q90.jpg",
        "price": 4633.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16046835599.html",
        "sold": 0
    },
    {
        "product_name": "BAREBONES CAST IRON GRIDDLE - GRILL PLATE#กระทะใช้งานได้2ด้าน",
        "product_image": "https://img.lazcdn.com/g/p/c5eb3fb282f15dc386b759d78208d785.jpg_200x200q90.jpg",
        "price": 4600,
        "remark": "https://www.lazada.co.th/products/pdp-i1242060805.html",
        "sold": 2
    },
    {
        "product_name": "Redchef ชุดเครื่องครัวเซรามิกเคลือบสารกันติด (7 ชิ้น) ปลอดสารพิษ ปราศจาก PFAS และ PTFE และ PFOA (กระทะจีน 28 ซม. + กระทะทอด 26 ซม. + หม้อตุ๋น 24 ซม. + หม้อด้าม 16 ซม.)",
        "product_image": "https://img.lazcdn.com/g/p/c03ff94478768845f1d94efb39216866.jpg_200x200q90.jpg",
        "price": 4598,
        "remark": "https://www.lazada.co.th/products/pdp-i5636704532.html",
        "sold": 3
    },
    {
        "product_name": "Gazechimp หม้อหุงข้าวตั้งแคมป์หม้ออาหารข้าวอุปกรณ์ตั้งแคมป์เครื่องนึ่งอเนกประสงค์น้ำหนักเบาสำหรับแบกเป้ปิกนิกบาร์บีคิวกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/dfb8005b2457dc5a53995b5d3e8ca563.jpg_200x200q90.jpg",
        "price": 4584.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16131961603.html",
        "sold": 0
    },
    {
        "product_name": "Gazechimp Panci Camping สำหรับนึ่งอุปกรณ์ต้มอุปกรณ์พร้อมที่จับเครื่องครัวหม้อนึ่งสำหรับบาร์บีคิวกลางแจ้งชุดอยู่รอดการเดินป่าปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/9b50c96ae2e15f59be8b3ba1ff5cd9d4.jpg_200x200q90.jpg",
        "price": 4584.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16126544111.html",
        "sold": 0
    },
    {
        "product_name": "กระทะแคมป์ปิ้ง Fire-maple  แบบพกพา ด้ามจับถอดได้ *ฟรีกระเป๋า*",
        "product_image": "https://img.lazcdn.com/g/ot/lzd-client-service/9c5d923529a9b3d69fb7f40dc8b3117b.jpeg_200x200q90.jpg",
        "price": 4580,
        "remark": "https://www.lazada.co.th/products/pdp-i2356930117.html",
        "sold": 15
    },
    {
        "product_name": "ชุดเครื่องครัวแคมปิ้งเสียงมายากลชุดทำอาหารตั้งแคมป์ HANDEL Lipat อะลูมินัมอัลลอยมีผ้าสำหรับทำความสะอาดแบกเป้ตกปลาบาร์บีคิวท่องเที่ยว",
        "product_image": "https://img.lazcdn.com/g/p/56c1553072385b26e6fa53dc930b91aa.jpg_200x200q90.jpg",
        "price": 4574,
        "remark": "https://www.lazada.co.th/products/pdp-i16091075221.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแคมปิ้ง Phenovo กาต้มน้ำหม้อกระทะทอดอะลูมินัมอัลลอยตามหลักสรีรศาสตร์ชุดทำอาหารสำหรับตกปลากระเป๋าเป้ปีนเขาปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/46a305e0bf81c20d5aa4f493ee56c543.jpg_200x200q90.jpg",
        "price": 4574,
        "remark": "https://www.lazada.co.th/products/pdp-i16132257311.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแคมปิ้ง Freneci พร้อมผ้าทำความสะอาดตั้งแคมป์ชุดทำอาหารกาต้มน้ำหม้อกระทะทอดสำหรับตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/bc8a90e23cf196eefb55fae11791e0d4.jpg_200x200q90.jpg",
        "price": 4574,
        "remark": "https://www.lazada.co.th/products/pdp-i16090843854.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวนกหวีดตั้งแคมป์ดวงจันทร์ HANDEL Lipat กาน้ำหม้อกระทะทอดตามหลักสรีรศาสตร์จานถ้วยส้อมสำหรับตกปลากลางแจ้งทำอาหารเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/46ed3a9ea4125478d374bf9ce3b66ef2.jpg_200x200q90.jpg",
        "price": 4574,
        "remark": "https://www.lazada.co.th/products/pdp-i16091137027.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา DGRR-TH",
        "product_image": "https://img.lazcdn.com/g/p/a69e3d482605a14c5510057a79f5924c.jpg_200x200q90.jpg",
        "price": 4574,
        "remark": "https://www.lazada.co.th/products/pdp-i16086175028.html",
        "sold": 0
    },
    {
        "product_name": "Harayaa ชุดเครื่องครัวแคมปิ้งตั้งแคมป์ชุดทำอาหารพับได้พกพาได้,กาต้มน้ำหม้อกระทะทอดนำความร้อนเร็วสำหรับการเดินทางทำบาร์บีคิว",
        "product_image": "https://img.lazcdn.com/g/p/610884b1874910d70dd6c50554e8141f.jpg_200x200q90.jpg",
        "price": 4574,
        "remark": "https://www.lazada.co.th/products/pdp-i16091055182.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแคมปิ้ง Moon Lighte สำหรับตั้งแคมป์ชุดทำอาหารนำความร้อนเร็วอเนกประสงค์พร้อมผ้าสำหรับทำความสะอาดปิคนิคเดินป่าแบกเป้",
        "product_image": "https://img.lazcdn.com/g/p/669e402d3ac855fc49a2adce30ef6b22.jpg_200x200q90.jpg",
        "price": 4574,
        "remark": "https://www.lazada.co.th/products/pdp-i16120972298.html",
        "sold": 0
    },
    {
        "product_name": "Outdoor Cooking System Mini Hiking Mountaineering Stove Boiling Water Windproof Camping Cookware",
        "product_image": "https://img.lazcdn.com/g/p/d1af1afe5b4ea5789f680dc94361dfd7.jpg_200x200q90.jpg",
        "price": 4562.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16129545444.html",
        "sold": 0
    },
    {
        "product_name": "Gazechimp หม้อนึ่งแบบพกพา Panci Camping สแตนเลสน้ำหนักเบาหม้ออาหารและชุดฝาปิดสำหรับการรับประทานอาหารแบบแบกเป้เพื่อความอยู่รอด",
        "product_image": "https://img.lazcdn.com/g/p/6b0809642e4a2a185729101a15eb26ca.jpg_200x200q90.jpg",
        "price": 4562,
        "remark": "https://www.lazada.co.th/products/pdp-i5960839817.html",
        "sold": 0
    },
    {
        "product_name": "กระทะไทเทเนียมเบาพิเศษสำหรับแค้มปิ้งเดินป่าปิกนิกทำอาหารกระทะทอด",
        "product_image": "https://img.lazcdn.com/g/p/9e8acc6380fbab654f272a414ee69faa.jpg_200x200q90.jpg",
        "price": 4558,
        "remark": "https://www.lazada.co.th/products/pdp-i3770484117.html",
        "sold": 14
    },
    {
        "product_name": "(LQ5X) 20 x Stainless Steel Food Tongs Gold Kitchen Utensils Buffet Cooking Tools Bbq Clips Bread Steak Tong",
        "product_image": "https://img.lazcdn.com/g/p/70a6204abf8efa08d86e57da0f26b4fc.jpg_200x200q90.jpg",
        "price": 4532,
        "remark": "https://www.lazada.co.th/products/pdp-i16133908276.html",
        "sold": 0
    },
    {
        "product_name": "(LB7H) 20X Stainless Steel Food Tongs Gold Kitchen Utensils Buffet Cooking Tools BBQ Clips Bread Steak Tong",
        "product_image": "https://img.lazcdn.com/g/p/70a6204abf8efa08d86e57da0f26b4fc.jpg_200x200q90.jpg",
        "price": 4532,
        "remark": "https://www.lazada.co.th/products/pdp-i16133009851.html",
        "sold": 0
    },
    {
        "product_name": "(LAY0) 20X Stainless Steel Food Tongs Gold Kitchen Utensils Buffet Cooking Tools BBQ Clips Bread Steak Tong",
        "product_image": "https://img.lazcdn.com/g/p/70a6204abf8efa08d86e57da0f26b4fc.jpg_200x200q90.jpg",
        "price": 4532,
        "remark": "https://www.lazada.co.th/products/pdp-i16133065340.html",
        "sold": 0
    },
    {
        "product_name": "(LA9L) 20 x Stainless Steel Food Tongs Gold Kitchen Utensils Buffet Cooking Tools Bbq Clips Bread Steak Tong",
        "product_image": "https://img.lazcdn.com/g/p/70a6204abf8efa08d86e57da0f26b4fc.jpg_200x200q90.jpg",
        "price": 4532,
        "remark": "https://www.lazada.co.th/products/pdp-i16132889099.html",
        "sold": 0
    },
    {
        "product_name": "(LB6H) 20 x Stainless Steel Food Tongs Gold Kitchen Utensils Buffet Cooking Tools Bbq Clips Bread Steak Tong",
        "product_image": "https://img.lazcdn.com/g/p/70a6204abf8efa08d86e57da0f26b4fc.jpg_200x200q90.jpg",
        "price": 4532,
        "remark": "https://www.lazada.co.th/products/pdp-i16131445173.html",
        "sold": 0
    },
    {
        "product_name": "(LEJ0) 20X Stainless Steel Food Tongs Gold Kitchen Utensils Buffet Cooking Tools BBQ Clips Bread Steak Tong",
        "product_image": "https://img.lazcdn.com/g/p/70a6204abf8efa08d86e57da0f26b4fc.jpg_200x200q90.jpg",
        "price": 4532,
        "remark": "https://www.lazada.co.th/products/pdp-i16133094313.html",
        "sold": 0
    },
    {
        "product_name": "Campingmoon | ถาดอบเคลือบกันติด CAMPINGMOON GRW-33F แบบลายหินบด ขนาดกลาง กระทะทอดสำหรับทำอาหารในครัว แผ่นย่างบาร์บีคิวแบบพับได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S83814747a5cf4a4f89a5d089fcdffe91n.jpg_200x200q90.jpg",
        "price": 4517.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16104840390.html",
        "sold": 0
    },
    {
        "product_name": "[LB2S]Mini Cooking System Outdoor Water Boiling Stove Mountaineering Hiking Windproof Camping Cookware",
        "product_image": "https://img.lazcdn.com/g/p/d1af1afe5b4ea5789f680dc94361dfd7.jpg_200x200q90.jpg",
        "price": 4502,
        "remark": "https://www.lazada.co.th/products/pdp-i16129928474.html",
        "sold": 0
    },
    {
        "product_name": "Petromax Enamel Pan 0.5L,1.0Lหม้อหูเดียว ด้ามไม้ เคลือบอินาเมล  หม้อเหล็กเคลือบ Enamel คุณภาพดี แข็งแรง ทนต่อความร้อน ความเย็นได้ดีเยี่ยม",
        "product_image": "https://img.lazcdn.com/g/p/a0cb9504a418a82d272cf97617796001.jpg_200x200q90.jpg",
        "price": 4500,
        "remark": "https://www.lazada.co.th/products/pdp-i4469093368.html",
        "sold": 0
    },
    {
        "product_name": "Aimishion Panci Camping เครื่องครัวแคมปิ้งและชุดกระทะรวมตาข่ายกระเป๋าใส่โน๊ตบุ๊คแบบพกพาสำหรับแคมป์ไฟแบบพกพาพร้อมกาต้มน้ำสำหรับอุปกรณ์เดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/b45a901832ab63a6e3a8e1e6695cecbe.jpg_200x200q90.jpg",
        "price": 4498,
        "remark": "https://www.lazada.co.th/products/pdp-i5943554704.html",
        "sold": 0
    },
    {
        "product_name": "WADFOW WFM1501K เครื่องผสมอาหารมือถือไร้สาย 90W",
        "product_image": "https://img.lazcdn.com/g/p/e56d9caa07f4406f9dda561cd099bc54.jpg_200x200q90.jpg",
        "price": 4496,
        "remark": "https://www.lazada.co.th/products/pdp-i5829887492.html",
        "sold": 0
    },
    {
        "product_name": "Prasku ชุดเครื่องใช้บนโต๊ะอาหารน้ำหนักเบาเซทเครื่องครัวตั้งแคมป์แบบพกพาหม้ออาหารอุปกรณ์ทำอาหารสำหรับบาร์บีคิวปิกนิกกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/bccea12ad4d1e7ab0212831ad6cf2e62.jpg_200x200q90.jpg",
        "price": 4492,
        "remark": "https://www.lazada.co.th/products/pdp-i5973147995.html",
        "sold": 0
    },
    {
        "product_name": "ZYStar แผ่นเหล็กสแตนเลสและชามอุปกรณ์ทานอาหารสำหรับตั้งแคมป์ภาชนะอาหารเย็นทนทานทีพกพาตั้งแคมป์ชุดรับประทานอาหารสำหรับปิกนิกงานปาร์ตี้กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/4afb5321c9d92834bbe00b52b1dece92.jpg_200x200q90.jpg",
        "price": 4476,
        "remark": "https://www.lazada.co.th/products/pdp-i5949406601.html",
        "sold": 0
    },
    {
        "product_name": "Gommie หม้อนึ่งหม้อหุงข้าวสำหรับตั้งแคมป์พร้อมฝาปิดแบบไม่ติด304เครื่องครัวสแตนเลสสำหรับเอาท์ดอร์ปีนเขาท่องเที่ยวตกปลาแบบแบกเป้",
        "product_image": "https://img.lazcdn.com/g/p/b0ac7228527636c07b45171acba66a2e.jpg_200x200q90.jpg",
        "price": 4476,
        "remark": "https://www.lazada.co.th/products/pdp-i5883877666.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัว Nonstick ชุดเครื่องครัว 4 ชิ้น Wok ทอดกระทะกระทะหม้อน้ำนมกระทะชุดครัวชุดเครื่องครัวเหมาะสำหรับเตาทุกชนิด",
        "product_image": "https://img.lazcdn.com/g/p/6af2a8d1dacb26b58f4c3c11b968b476.jpg_200x200q90.jpg",
        "price": 4452.54,
        "remark": "https://www.lazada.co.th/products/pdp-i5415534955.html",
        "sold": 52
    },
    {
        "product_name": "ชุดเครื่องครัวแคมปิ้งทำถ้วยเหล็กกล้าไร้สนิมบาร์บีคิวกลางแจ้งสำหรับเดินป่ากาต้มน้ำกระทะหม้อที่จับสามารถพับได้นำความร้อนเร็วแบบพกพา",
        "product_image": "https://img.lazcdn.com/g/p/8c3a57ac370bfd2b55b9aafe9b87a3c5.jpg_200x200q90.jpg",
        "price": 4450,
        "remark": "https://www.lazada.co.th/products/pdp-i16076668404.html",
        "sold": 0
    },
    {
        "product_name": "BSWOLF | ชุดเครื่องครัวแคมปิ้งพกพา หม้อทอดและต้มในตัว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S42da828f769342599538c0cf3e4258146.jpg_200x200q90.jpg",
        "price": 4429.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6015284492.html",
        "sold": 72
    },
    {
        "product_name": "DIHUANTUO | ชุดเครื่องครัวสแตนเลส 316",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0777a549b10549c09b5913bb3b10b875h.jpg_200x200q90.jpg",
        "price": 4416.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16114915897.html",
        "sold": 0
    },
    {
        "product_name": "กระจกบังลมเตาไฟแคมปิ้งของ Kokiya น้ำหนักเบาบังลมพร้อมถุงเก็บของพับได้บังลมสำหรับเตาทำอาหารกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/971e397f11b846b048702a4769d69d15.jpg_200x200q90.jpg",
        "price": 4410,
        "remark": "https://www.lazada.co.th/products/pdp-i16103438123.html",
        "sold": 0
    },
    {
        "product_name": "BENGPEN ค่าการนำความร้อนที่สม่ำเสมอ ถาดอบขนมสำหรับตั้งแคมป์ ทนต่ออุณหภูมิสูง ดีไซน์น้ำหนักเบา บาร์บีคิว ตัวเลือกการประกอบที่รวดเร็ว ขนาดพกพา บาร์บีคิวกริลล์ ตั้งแคมป์กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/aa2b8f95860028d7313824712acf65d5.png_200x200q90.png",
        "price": 4409.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16131744184.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA-Fangzi กระทะทอดกลางแจ้ง1000มล./1500มล. กระทะจานผลไม้อาหารเย็นกระทะทอดไทเทเนี่ยมน้ำหนักเบาสำหรับ BBQ ปิกนิกตั้งแคมป์เดินป่าแบกเป้กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/8480bfaea7242117af5a1191887f7c5a.jpg_200x200q90.jpg",
        "price": 4408,
        "remark": "https://www.lazada.co.th/products/pdp-i5948401780.html",
        "sold": 0
    },
    {
        "product_name": "GiPP ชุดเครื่องครัวกระทะ หม้อ จาก 10PCS（6 หม้อ） ใช้ได้กับเตาทุกประเภท",
        "product_image": "https://img.lazcdn.com/g/p/99f782b2e7df0184dff8a959af1c60cd.jpg_200x200q90.jpg",
        "price": 3942,
        "remark": "https://www.lazada.co.th/products/pdp-i5917812888.html",
        "sold": 0
    },
    {
        "product_name": "อลูมิเนียมชุบแข็ง6L เครื่องครัวแคมปิ้งน้ำหนักเบาและหม้อสนามแบบพกพา",
        "product_image": "https://img.lazcdn.com/g/p/ab539a14470d4af2eeb1add80d9d1f2a.jpg_200x200q90.jpg",
        "price": 4408,
        "remark": "https://www.lazada.co.th/products/pdp-i6028358663.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา TF-Eac-TH",
        "product_image": "https://img.lazcdn.com/g/p/fc1e5cfc24f37597989995c37e3c3a3a.jpg_200x200q90.jpg",
        "price": 4406,
        "remark": "https://www.lazada.co.th/products/pdp-i16078123772.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา JS-014-TH",
        "product_image": "https://img.lazcdn.com/g/p/c42217e16b38183ff4d6293641381da7.jpg_200x200q90.jpg",
        "price": 4406,
        "remark": "https://www.lazada.co.th/products/pdp-i16086065590.html",
        "sold": 0
    },
    {
        "product_name": "หม้อทำอาหารออกแคมป์สแตนเลส3เสิร์ฟหม้อหุงข้าวพร้อมที่จับพับได้",
        "product_image": "https://img.lazcdn.com/g/p/4c39d464a0075ffbb80bd2f5dabb80cc.jpg_200x200q90.jpg",
        "price": 4404,
        "remark": "https://www.lazada.co.th/products/pdp-i6025387895.html",
        "sold": 0
    },
    {
        "product_name": "WDAir กระทะทอดแคมป์ปิ้งขนาดกะทัดรัดเคลือบ Nonstick พกพาได้สำหรับการเดินทางท่องเที่ยวการตั้งแคมป์บาร์บีคิวการเดินทางแบบแบกเป้",
        "product_image": "https://img.lazcdn.com/g/p/bfcb5c8732dabe265a1cbe63d52db15b.jpg_200x200q90.jpg",
        "price": 4402,
        "remark": "https://www.lazada.co.th/products/pdp-i5972301560.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกระทะและถ้วยซุป LOGOS",
        "product_image": "https://img.lazcdn.com/g/p/d7b564a4ee9fe1c3f85fad91d6209c55.jpg_200x200q90.jpg",
        "price": 4400,
        "remark": "https://www.lazada.co.th/products/pdp-i2895750148.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา Vja-TH",
        "product_image": "https://img.lazcdn.com/g/p/d4e320e0828fbf7484d060aa172fc859.jpg_200x200q90.jpg",
        "price": 4400,
        "remark": "https://www.lazada.co.th/products/pdp-i16089230733.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา SE-TH",
        "product_image": "https://img.lazcdn.com/g/p/48efc15a792866a7a82af83879611a77.jpg_200x200q90.jpg",
        "price": 4400,
        "remark": "https://www.lazada.co.th/products/pdp-i16080019946.html",
        "sold": 0
    },
    {
        "product_name": "มีดครัว มีเชฟ Santoku Knife 7\"  วัสดุใบมีดเหล็กดามัสกัส 67 ชั้น แกนกลางVG 1O ใบร่อง ด้ามจับ หอยเป่าฮื้อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4a63a3b6ce8246f4a49ac6c793156f977.jpg_200x200q90.jpg",
        "price": 4400,
        "remark": "https://www.lazada.co.th/products/pdp-i5859034859.html",
        "sold": 0
    },
    {
        "product_name": "COLEMAN ENAMEL DISHWARE SET",
        "product_image": "https://img.lazcdn.com/g/p/1430982263d1e8866b9612b7821d0cd6.jpg_200x200q90.jpg",
        "price": 4400,
        "remark": "https://www.lazada.co.th/products/pdp-i5293344002.html",
        "sold": 0
    },
    {
        "product_name": "Panci Camping Koolsoo สำหรับการนึ่งอุปกรณ์ต้มอุปกรณ์พร้อมที่จับอุปกรณ์หม้อนึ่งเครื่องครัวสำหรับบาร์บีคิวกลางแจ้งชุดอยู่รอดการเดินป่าปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/078a591877bf9bbb0d91d2b26e20a677.jpg_200x200q90.jpg",
        "price": 4392,
        "remark": "https://www.lazada.co.th/products/pdp-i6003469146.html",
        "sold": 0
    },
    {
        "product_name": "Panci Camping Motoise สำหรับนึ่งอุปกรณ์ต้มอุปกรณ์หม้อนึ่งอุปกรณ์สำหรับบาร์บีคิวกลางแจ้งชุดอยู่รอดการเดินป่าปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/278e8b0ec5e8d846980b6dd29b3e3e27.jpg_200x200q90.jpg",
        "price": 4392,
        "remark": "https://www.lazada.co.th/products/pdp-i6024474059.html",
        "sold": 0
    },
    {
        "product_name": "Panci Camping TOOYFUL สำหรับการนึ่งอุปกรณ์ต้มอุปกรณ์พร้อมที่จับอุปกรณ์หม้อนึ่งเครื่องครัวสำหรับบาร์บีคิวกลางแจ้งชุดอยู่รอดการเดินป่าปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/09477631cad43ddcc392bf986ef78c93.jpg_200x200q90.jpg",
        "price": 4392,
        "remark": "https://www.lazada.co.th/products/pdp-i16050938707.html",
        "sold": 0
    },
    {
        "product_name": "Freneci หม้อตุ๋นหม้อตั้งแคมป์กลางแจ้งน้ำหนักเบาพร้อมฝาปิดเครื่องครัวแคมป์ไฟอุปกรณ์กระเป๋าเก็บของสำหรับทำอาหารกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/bd6633b2615fcb8746420d30372bb050.jpg_200x200q90.jpg",
        "price": 4392,
        "remark": "https://www.lazada.co.th/products/pdp-i5960826746.html",
        "sold": 0
    },
    {
        "product_name": "Chiwanji Panci Camping สำหรับนึ่งอุปกรณ์พกพาอเนกประสงค์ที่ใช้ในครัวเรือนบาร์บีคิวปิกนิกตกปลาแบกเป้",
        "product_image": "https://img.lazcdn.com/g/p/4acdfcc6db0b7b69a6b233cb0d6a5375.jpg_200x200q90.jpg",
        "price": 4392,
        "remark": "https://www.lazada.co.th/products/pdp-i5960873759.html",
        "sold": 0
    },
    {
        "product_name": "CCSoil Panci Camping สำหรับการนึ่งอุปกรณ์ต้มอุปกรณ์หม้อนึ่งเครื่องครัวสำหรับปิกนิกชุดอยู่รอดการเดินป่าบาร์บีคิวกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/771850cb3b3c508afa9aaa64c34b3019.jpg_200x200q90.jpg",
        "price": 4392,
        "remark": "https://www.lazada.co.th/products/pdp-i6014550853.html",
        "sold": 0
    },
    {
        "product_name": "ดาซีนา Panci Camping สำหรับนึ่งอุปกรณ์ต้มอุปกรณ์หม้อนึ่งเครื่องครัวสำหรับบาร์บีคิวกลางแจ้งชุดอยู่รอดการเดินป่าปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/b86ce03071379be3c59c26b4851681fb.jpg_200x200q90.jpg",
        "price": 4392,
        "remark": "https://www.lazada.co.th/products/pdp-i6019204886.html",
        "sold": 0
    },
    {
        "product_name": "WDAir Panci Camping สำหรับนึ่งอุปกรณ์ต้มอุปกรณ์หม้อนึ่งอุปกรณ์สำหรับบาร์บีคิวกลางแจ้งชุดอยู่รอดการเดินป่าปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/a2648ca30a4f4cb0a6b8fe9a5e6029dc.jpg_200x200q90.jpg",
        "price": 4392,
        "remark": "https://www.lazada.co.th/products/pdp-i16131354243.html",
        "sold": 0
    },
    {
        "product_name": "CCPlanet Panci Camping สำหรับการนึ่งอุปกรณ์ต้มอุปกรณ์หม้อนึ่งเครื่องครัวสำหรับปิกนิกชุดอยู่รอดการเดินป่าบาร์บีคิวกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/19b5d4c48b8b5365794ea12960aab8bc.jpg_200x200q90.jpg",
        "price": 4392,
        "remark": "https://www.lazada.co.th/products/pdp-i16130545804.html",
        "sold": 0
    },
    {
        "product_name": "Gazechimp เครื่องครัวสำหรับตั้งแคมป์หม้อหุงข้าวหม้ออาหารอเนกประสงค์น้ำหนักเบาไม่ติดข้าวเหล็กกล้าไร้สนิมสำหรับบาร์บีคิวแบกเป้",
        "product_image": "https://img.lazcdn.com/g/p/b6c84c26d0caa9c94605f27d3dbeb0c7.jpg_200x200q90.jpg",
        "price": 4392,
        "remark": "https://www.lazada.co.th/products/pdp-i16103229648.html",
        "sold": 0
    },
    {
        "product_name": "SunnT Panci Camping สำหรับการนึ่งอุปกรณ์ต้มอุปกรณ์หม้อนึ่งเครื่องครัวสำหรับบาร์บีคิวกลางแจ้งชุดอยู่รอดการเดินป่าปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/85d95d1ad2ffdd4f9bdb94bb325e1d1f.jpg_200x200q90.jpg",
        "price": 4392,
        "remark": "https://www.lazada.co.th/products/pdp-i16136341305.html",
        "sold": 0
    },
    {
        "product_name": "ZYEarth Panci Camping สำหรับการนึ่งอุปกรณ์ต้มอุปกรณ์หม้อนึ่งอุปกรณ์สำหรับบาร์บีคิวกลางแจ้งชุดอยู่รอดการเดินป่าปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/c4b07ee6b493d54cd17295c1302e2a50.jpg_200x200q90.jpg",
        "price": 4392,
        "remark": "https://www.lazada.co.th/products/pdp-i5962004695.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO หม้อตั้งแคมป์พับได้พกพาสะดวก,ชุดอุปกรณ์ทำอาหารขณะตั้งแคมป์กลางแจ้งทรงสี่เหลี่ยมสำหรับเดินป่าปั่นจักรยาน",
        "product_image": "https://img.lazcdn.com/g/p/0b87bff26b08b9a87f8033f54dddf632.jpg_200x200q90.jpg",
        "price": 4388.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16107718278.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเขียงไม้แคมป์ปิ้ง NexTool Camp Chef Cookware พร้อมมีดเชฟและกรรไกร (พับได้ แม่เหล็กดูดแน่น)",
        "product_image": "https://img.lazcdn.com/g/p/93c00a4081b400339bd64156e8cad837.jpg_200x200q90.jpg",
        "price": 4380,
        "remark": "https://www.lazada.co.th/products/pdp-i5962238332.html",
        "sold": 0
    },
    {
        "product_name": "Mini Cooking System Hiking Mountaineering Outdoor Cookware Stoves Boiling Water Windproof Camping Cooking",
        "product_image": "https://img.lazcdn.com/g/p/d1a92caddfdd7ccb62d1655ad83d14f5.jpg_200x200q90.jpg",
        "price": 4376,
        "remark": "https://www.lazada.co.th/products/pdp-i16125620883.html",
        "sold": 0
    },
    {
        "product_name": "Fire-Maple |หม้อแคมป์ปิ้งพับได้มัลติฟังก์ชัน สำหรับทอดและตุ๋น ใช้กับเตาไฟโดยตรงได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S568b65da52c54f0db588efa0b2a757159.jpg_200x200q90.jpg",
        "price": 4372.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16049362843.html",
        "sold": 1
    },
    {
        "product_name": "SRAITH ค่าการนำความร้อนที่สม่ำเสมอ ถาดอบขนมสำหรับตั้งแคมป์ ทนต่ออุณหภูมิสูง ดีไซน์น้ำหนักเบา บาร์บีคิว ตัวเลือกการประกอบที่รวดเร็ว ขนาดพกพา บาร์บีคิวกริลล์ ตั้งแคมป์กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/e648c5759648a8f8f6b83f3f695f88b3.png_200x200q90.png",
        "price": 4370.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16119023383.html",
        "sold": 0
    },
    {
        "product_name": "อุปกรณ์ทำอาหารแคมป์ไฟสแตนเลส304น้ำหนักเบาหม้อสนามหม้อทำอาหารออกแคมป์จรวดดวงจันทร์สำหรับการเดินป่าตกปลาการเดินทางปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/97f5490ab9ae8388f2c97f6196021b1a.jpg_200x200q90.jpg",
        "price": 4362,
        "remark": "https://www.lazada.co.th/products/pdp-i16123655215.html",
        "sold": 0
    },
    {
        "product_name": "[โปรร้อนแรง!!] หม้อสองหูสแตนเลสพร้อมฝา รุ่น แปซิฟิค ขนาด 30 ซม. สีเงิน | หม้อสองหูสแตนเลสพร้อมฝา เครื่องครัว ราคาถูก",
        "product_image": "https://img.lazcdn.com/g/p/924ab68260ae2185f0c872fefee324ba.jpg_200x200q90.jpg",
        "price": 4360,
        "remark": "https://www.lazada.co.th/products/pdp-i3112887385.html",
        "sold": 0
    },
    {
        "product_name": "ชุดหม้อกระทะเหล็กหล่อเคลือบเอนามัล 7 ชิ้น ใช้ได้ทุกเตา หม้อซุป+กระทะผัด+หม้อเล็ก สำหรับครัวบ้าน",
        "product_image": "https://img.lazcdn.com/3rd/q/aHR0cHM6Ly9hZS1waWMtYTEuYWxpZXhwcmVzcy1tZWRpYS5jb20va2YvU2VhZjMzYWU3NjM1YjRiOWI4ZTMzMDBhMTVjNTc2Y2VjTi5qcGc=_200x200q90.png",
        "price": 4338.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6079049642.html",
        "sold": 0
    },
    {
        "product_name": "JEETEE| ชุดหม้อหินเคลือบเมลามีนไม่ติดกระทะ หม้อซุป และกระทะสำหรับเตาอินดักชันและแก๊ส 4 ชิ้",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S2dd74ce1f326492498611b767f0a0bffB.jpg_200x200q90.jpg",
        "price": 4338,
        "remark": "https://www.lazada.co.th/products/pdp-i5857406101.html",
        "sold": 338
    },
    {
        "product_name": "LINECY ชุดหม้อนึ่งหม้อนึ่งพร้อมจานนึ่งสำหรับหม้อตุ๋นหม้อนึ่งนึ่งขนาด19-25ซม. หม้อตุ๋นจานนึ่งจานนึ่ง304สแตนเลสพร้อมอุปกรณ์นึ่งเพื่อสุขภาพจานนึ่งพร้อมแหล่งความร้อนหลากหลาย",
        "product_image": "https://img.lazcdn.com/g/p/f2b2e6b3e60cfc1a20470b86da5e195a.png_200x200q90.png",
        "price": 4330,
        "remark": "https://www.lazada.co.th/products/pdp-i16119097026.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องครัวแคมปิ้งกันหมอกชุดอุปกรณ์ทานอาหารแบบพกพาอุณหภูมิสูงและกันฝุ่นสำหรับ2-3คนพร้อมชามสำหรับการเดินป่ากลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/4aa03ac127b78655301a59e6abc55e98.jpg_200x200q90.jpg",
        "price": 4324,
        "remark": "https://www.lazada.co.th/products/pdp-i16099220100.html",
        "sold": 0
    },
    {
        "product_name": "FIRE-MAPLE FMC-212 COOKWARE ชุดทำอาหาร จาน ชาม หม้อ กระทะ",
        "product_image": "https://img.lazcdn.com/g/ot/lzd-client-service/f5533351375916f1b9ee5412f440c98f.jpeg_200x200q90.jpg",
        "price": 4320,
        "remark": "https://www.lazada.co.th/products/pdp-i3303145127.html",
        "sold": 4
    },
    {
        "product_name": "DXSFV ค่าการนำความร้อนที่สม่ำเสมอ ถาดอบขนมสำหรับตั้งแคมป์ ดีไซน์น้ำหนักเบา ทนต่ออุณหภูมิสูง บาร์บีคิว ติดตั้งง่ายสำหรับเตาย่าง ขนาดพกพา บาร์บีคิวกริลล์ ตั้งแคมป์กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/30e61b00314abae981d19cc1d240d1fe.jpg_200x200q90.jpg",
        "price": 4317.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16135566803.html",
        "sold": 0
    },
    {
        "product_name": "หม้อแคมปิ้งพกพาไม่ติดกระทะ สแตนเลส เบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sef008b09f7124abc98983f885c06fc12M.jpg_200x200q90.jpg",
        "price": 4284.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16118210323.html",
        "sold": 0
    },
    {
        "product_name": "Snowpeak | ชุดอุปกรณ์ทานอาหารแคมปิ้งสแตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0a650e2a15754ab4a212c2515646f2af8.jpg_200x200q90.jpg",
        "price": 4270.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5875730151.html",
        "sold": 6
    },
    {
        "product_name": "ชุดทำอาหารกลางแจ้งพกพา ไม่ติดกระทะ สแตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S76562f3092414173bd2dad7036bbbcb68.jpg_200x200q90.jpg",
        "price": 4266,
        "remark": "https://www.lazada.co.th/products/pdp-i16118315996.html",
        "sold": 0
    },
    {
        "product_name": "คีมคีบฟืนเหมือนจริงคีมสำหรับปิกนิคไว้หุงอาหารที่คีบฟืนแบบพกพาสำหรับใช้ในครัวเรือน",
        "product_image": "https://img.lazcdn.com/g/p/4a66e4ee7747ca0f2c93191389c88bff.jpg_200x200q90.jpg",
        "price": 4264,
        "remark": "https://www.lazada.co.th/products/pdp-i5994604478.html",
        "sold": 0
    },
    {
        "product_name": "ส่งฟรี ชุดครัวสนาม หม้อสนาม ชุดเครื่องครัวสเตนเลสเคลือบผิวกันติดสำหรับการตั้งแคมป์รุ่น MH 500",
        "product_image": "https://img.lazcdn.com/g/p/1c44a7efb43ace1eb3c576587717c53d.jpg_200x200q90.jpg",
        "price": 4258,
        "remark": "https://www.lazada.co.th/products/pdp-i5417316820.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา RTF-TH",
        "product_image": "https://img.lazcdn.com/g/p/6ed5b5e5cc86a4e662b4fb7201c7db76.jpg_200x200q90.jpg",
        "price": 4252,
        "remark": "https://www.lazada.co.th/products/pdp-i16084668773.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา VH-TH",
        "product_image": "https://img.lazcdn.com/g/p/13469910551bd28a7e603ba1986c3862.jpg_200x200q90.jpg",
        "price": 4252,
        "remark": "https://www.lazada.co.th/products/pdp-i16084648683.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา DC-TH",
        "product_image": "https://img.lazcdn.com/g/p/58d51ccbe8de224b980f4c6ab08972c7.jpg_200x200q90.jpg",
        "price": 4242,
        "remark": "https://www.lazada.co.th/products/pdp-i16075074704.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวปิกนิกอลูมินาแบบพกพาสำหรับกลางแจ้ง Set Alat Masak เดินป่าตั้งแคมป์ชุดอุปกรณ์ทำอาหารสำหรับเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/700fd04768dcef65363bb09c6a351455.jpg_200x200q90.jpg",
        "price": 4242,
        "remark": "https://www.lazada.co.th/products/pdp-i6076954974.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา 5LA-wsf-TH",
        "product_image": "https://img.lazcdn.com/g/p/795516407da0fa9970a455e340fb2c33.jpg_200x200q90.jpg",
        "price": 4242,
        "remark": "https://www.lazada.co.th/products/pdp-i16072943558.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | ชุดเครื่องครัวแคมปิ้งอลูมิเนียมพกพา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sec723af93d5145059ad509311ee269eao.jpg_200x200q90.jpg",
        "price": 4228.34,
        "remark": "https://www.lazada.co.th/products/pdp-i6065039748.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | ชุดเครื่องครัวพกพาสำหรับแคมปิ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf1096a592c3144c4b7a9441f13f695f7g.png_200x200q90.png",
        "price": 4228.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5894250066.html",
        "sold": 3
    },
    {
        "product_name": "GSI GOURMET GRIDDLE 68156 กระทะเคลือบ#วางบนเตาแก๊สColeman2หัวเตา/เตาน้ำมัน 2 หัวได้",
        "product_image": "https://img.lazcdn.com/g/p/487ce9d10e03e6b2a4591f8913196df6.jpg_200x200q90.jpg",
        "price": 4200,
        "remark": "https://www.lazada.co.th/products/pdp-i1604648294.html",
        "sold": 1
    },
    {
        "product_name": "JEETEE ชุดเครื่องครัวไม่ติด 4PCS หินแกรนิตสีขาวชุดทำอาหารครัว",
        "product_image": "https://img.lazcdn.com/g/p/52cfe98304d0f95e3b57ddf9ad971fb9.png_200x200q90.png",
        "price": 4198,
        "remark": "https://www.lazada.co.th/products/pdp-i3676977851.html",
        "sold": 1234
    },
    {
        "product_name": "BSWOLF | ชุดอุปกรณ์ทำอาหารสำหรับแคมปิ้งกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S42da828f769342599538c0cf3e4258146.jpg_200x200q90.jpg",
        "price": 4177.82,
        "remark": "https://www.lazada.co.th/products/pdp-i6014111991.html",
        "sold": 105
    },
    {
        "product_name": "CAROTE | ชุดเครื่องครัวไม่ติดกระทะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S009fc4af8d8143d082b4372f2571f3beX.jpg_200x200q90.jpg",
        "price": 4176.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5893583586.html",
        "sold": 167
    },
    {
        "product_name": "NatureHike | ชุดเครื่องครัวสำหรับแค้มปิ้ง ไม่ติดกระทะ พกพาสะดวก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se4e0ac76ca424ab9825798075b14219aN.png_200x200q90.png",
        "price": 4176.26,
        "remark": "https://www.lazada.co.th/products/pdp-i6063494057.html",
        "sold": 2
    },
    {
        "product_name": "Firemaple feast 5 ชุดหม้ออลูมิเนียมเคลือบ สามารถเก็บรวมไว้ในหม้อใบเดียว",
        "product_image": "https://img.lazcdn.com/g/p/6636de831238670a34b51738b976c937.jpg_200x200q90.jpg",
        "price": 4158,
        "remark": "https://www.lazada.co.th/products/pdp-i2380707078.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องใช้สำหรับโต๊ะอาหารกลางแจ้งชุดอุปกรณ์ทานอาหารค่ำแคมป์ปิ้งแบบ48x ชุดเครื่องใช้มีดน้ำหนักเบาชุดอุปกรณ์ทานอาหารกลางแจ้งสำหรับครัวบ้านกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/ff8b3877c289184b487bf3ad06dd21fa.jpg_200x200q90.jpg",
        "price": 4151.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6077187243.html",
        "sold": 0
    },
    {
        "product_name": "หม้อชาถ่านสำหรับกลางแจ้ง/ในร่ม ฤดูหนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2924e2c782c44cd1a955a4459d7a245cZ.jpg_200x200q90.jpg",
        "price": 4129.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5909664901.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA-จานตั้งแคมป์ FAPAO พร้อมชุดเครื่องใช้บนโต๊ะอาหาร3ชิ้นจานไทเทเนียมจานบาร์บีคิวจานสลัดแผ่นตั้งแคมป์โลหะชุดทานข้าวกลางแจ้งเบามาก",
        "product_image": "https://img.lazcdn.com/g/p/c2816032da9d7556b838452bf5b7c73f.jpg_200x200q90.jpg",
        "price": 4122,
        "remark": "https://www.lazada.co.th/products/pdp-i5936478973.html",
        "sold": 0
    },
    {
        "product_name": "WDFINE หม้อไททาเนียมกลางแจ้ง900มล. HANDEL Lipat หม้อสนามขนาดกะทัดรัดนำกลับมาใช้ใหม่ได้แก้วทรงกลมกลางแจ้งสำหรับตั้งแคมป์บาร์บีคิวในครัว",
        "product_image": "https://img.lazcdn.com/g/p/30b093cd412b19090f629f581571cb49.jpg_200x200q90.jpg",
        "price": 4120,
        "remark": "https://www.lazada.co.th/products/pdp-i5319649644.html",
        "sold": 0
    },
    {
        "product_name": "Prasku ชุดหม้ออาหารตั้งแคมป์พับเก็บได้พกพาได้มือจับน้ำหนักเบาสำหรับใช้ในครัวเรือนกลางแจ้งอุปกรณ์บาร์บีคิวห้องครัว",
        "product_image": "https://img.lazcdn.com/g/p/29816c2408f2105676c68a6193ffff6b.jpg_200x200q90.jpg",
        "price": 4116,
        "remark": "https://www.lazada.co.th/products/pdp-i5965573826.html",
        "sold": 0
    },
    {
        "product_name": "Ulight เครื่องครัวน้ำหนักเบาตั้งแคมป์กระทะโลหะอเนกประสงค์กระทะทอดกลางแจ้งสำหรับกระทะทอดเต็นท์ร้อนและแบกเป้",
        "product_image": "https://img.lazcdn.com/g/p/f69985f73fa8a608e82a57a56a8ce1f3.jpg_200x200q90.jpg",
        "price": 4111.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16126079800.html",
        "sold": 0
    },
    {
        "product_name": "COONOR TOMSHOO หม้อขนาด750มล. พร้อมฝาและ Huiop ขนาด750มล. มีฝาปิดอะลูมิเนียมแบบพกพามีฝาปิดและหม้อหูจับน้ำกระทะร้อนจับเครื่องครัวปิกนิก2นิ้วพร้อม750ml-1ถ้วยหม้อทนทาน) หม้อหรือถ้วย Dsfen",
        "product_image": "https://img.lazcdn.com/g/p/77f3fe6c7c274f8a1292f28be89cd699.jpg_200x200q90.jpg",
        "price": 4110,
        "remark": "https://www.lazada.co.th/products/pdp-i5572396678.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา GUY-TH",
        "product_image": "https://img.lazcdn.com/g/p/f9e865ef8c2b07bfb2a7f82d7a0094fa.jpg_200x200q90.jpg",
        "price": 4108,
        "remark": "https://www.lazada.co.th/products/pdp-i16084731602.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา D4-TH",
        "product_image": "https://img.lazcdn.com/g/p/3b61b19acbedb20e319024947e356552.jpg_200x200q90.jpg",
        "price": 4108,
        "remark": "https://www.lazada.co.th/products/pdp-i16075015857.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา 5LA-zh-TH",
        "product_image": "https://img.lazcdn.com/g/p/9586cc09b75345c08a9e3658ac8c6b1b.jpg_200x200q90.jpg",
        "price": 4108,
        "remark": "https://www.lazada.co.th/products/pdp-i16083302928.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา TF-Ela-TH",
        "product_image": "https://img.lazcdn.com/g/p/33c49fce01b6aa48d75a8d8f4ba720f0.jpg_200x200q90.jpg",
        "price": 4102,
        "remark": "https://www.lazada.co.th/products/pdp-i16078161566.html",
        "sold": 0
    },
    {
        "product_name": "Soto Aluminium Griddle กระทะแบนอลูมิเนียม",
        "product_image": "https://img.lazcdn.com/g/p/e6931073f5d3383fb35c81532874a755.jpg_200x200q90.jpg",
        "price": 4100,
        "remark": "https://www.lazada.co.th/products/pdp-i5347175608.html",
        "sold": 0
    },
    {
        "product_name": "BAOLUOYOUXUAN | ชุดอุปกรณ์ทำครัวแคมปิ้งพับได้แบบพกพา สแตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S657c438333ff417c8df09a52e2158d24g.jpg_200x200q90.jpg",
        "price": 4097.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6014102949.html",
        "sold": 14
    },
    {
        "product_name": "Koolsoo เครื่องครัวแคมปิ้งพร้อมกาต้มน้ำขนาดกะทัดรัดสแตนเลส Panci Camping แบบพกพาและชามสำหรับอุปกรณ์เดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/6403c96bfd5ec9e30f3f4f8116686223.jpg_200x200q90.jpg",
        "price": 4084,
        "remark": "https://www.lazada.co.th/products/pdp-i6004469566.html",
        "sold": 0
    },
    {
        "product_name": "WDAir เซทเครื่องครัวตั้งแคมป์ชุดทำอาหารน้ำหนักเบาสำหรับค่าย",
        "product_image": "https://img.lazcdn.com/g/p/4d21dfe64a6c6420f7354696c7be12e6.jpg_200x200q90.jpg",
        "price": 4084,
        "remark": "https://www.lazada.co.th/products/pdp-i5980615855.html",
        "sold": 0
    },
    {
        "product_name": "ชุดชามและ Panci Camping เซทเครื่องครัวตั้งแคมป์พร้อมชุดชุดประกอบอาหารสแตนเลสสตีล HANDEL Lipat สำหรับอุปกรณ์เสริมเป้สะพายหลัง",
        "product_image": "https://img.lazcdn.com/g/p/edbf9a217e3a7b85e49cbd85861982bd.jpg_200x200q90.jpg",
        "price": 4084,
        "remark": "https://www.lazada.co.th/products/pdp-i5997075412.html",
        "sold": 0
    },
    {
        "product_name": "Kodaily Panci Camping เครื่องครัวแคมปิ้งและชามขนาดกะทัดรัดชุดทำอาหารสแตนเลสสำหรับเป้สะพายหลังเดินป่ากลางแจ้งอุปกรณ์ปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/cb31c24c87b1c466c48cf751d6262ca9.jpg_200x200q90.jpg",
        "price": 4084,
        "remark": "https://www.lazada.co.th/products/pdp-i5943945107.html",
        "sold": 0
    },
    {
        "product_name": "ชุดทำอาหารเซทเครื่องครัวตั้งแคมป์ดวงจันทร์น่ารักน้ำหนักเบาพร้อมตาข่ายกระเป๋าใส่โน๊ตบุ๊คแบบพกพา Panci Camping และชามขนาดกะทัดรัดสำหรับเกียร์แบกเป้ปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/fc3eeda1fb56425ded1b0b56400c39d8.jpg_200x200q90.jpg",
        "price": 4084,
        "remark": "https://www.lazada.co.th/products/pdp-i5970972055.html",
        "sold": 0
    },
    {
        "product_name": "เซทเครื่องครัวตั้งแคมป์ CCPlanet ชุดทำอาหาร Panci Camping และชาม",
        "product_image": "https://img.lazcdn.com/g/p/8b81b1bd002d586c1f27ae5e28b9b348.jpg_200x200q90.jpg",
        "price": 4084,
        "remark": "https://www.lazada.co.th/products/pdp-i5956012624.html",
        "sold": 0
    },
    {
        "product_name": "Gamchiano ชุดชามและ Panci Camping เซทเครื่องครัวตั้งแคมป์ชุดทำอาหารขนาดกะทัดรัดพกพาสำหรับค่ายปิกนิกกระเป๋าแบ็คแพ็คสำหรับกิจกรรมกลางแจ้งอุปกรณ์เสริม",
        "product_image": "https://img.lazcdn.com/g/p/28fcd28aba8d2543309bc1e3e709c294.jpg_200x200q90.jpg",
        "price": 4084,
        "remark": "https://www.lazada.co.th/products/pdp-i5993052579.html",
        "sold": 0
    },
    {
        "product_name": "Deevoka กระทะไททาเนียมกระทะปรุงอาหารทำจากไทเทเนียมจานจานชาม HANDEL Lipat แบบพกพากระทะทอดสำหรับการเดินป่าแคมป์เดินป่ากระเป๋าเป้สะพายหลังปิคนิค",
        "product_image": "https://img.lazcdn.com/g/p/d9cb6087987baeb0e38bf78b3cac72fe.jpg_200x200q90.jpg",
        "price": 4070,
        "remark": "https://www.lazada.co.th/products/pdp-i5960682157.html",
        "sold": 0
    },
    {
        "product_name": "[Easy E-Receipt ]เครื่องครัว tefal ชุดเซ็ตเครื่องครัว 8 ชิ้น Day By Day ก้นอินดักชั่น รุ่น G143S895 ชุดเครื่องครัว เครื่องครัว กระทะ  tefal ชุดหม้อและกระทะ",
        "product_image": "https://img.lazcdn.com/g/p/771bade8082b27ecc8683e385e96fac1.png_200x200q90.png",
        "price": 4064.64,
        "remark": "https://www.lazada.co.th/products/pdp-i1283816446.html",
        "sold": 59
    },
    {
        "product_name": "ชุดเครื่องครัวสแตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sebf988b8196f44f6b578f66d660c0f4aZ.jpg_200x200q90.jpg",
        "price": 4047.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16119186848.html",
        "sold": 0
    },
    {
        "product_name": "กระทะพับได้แบบพกพาเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc601ff847f924b6f8f0967cbcc1a3656q.jpg_200x200q90.jpg",
        "price": 4040.12,
        "remark": "https://www.lazada.co.th/products/pdp-i6002996642.html",
        "sold": 0
    },
    {
        "product_name": "Tomshoo หม้อซุป2L แคมป์ปิ้งแบบพกพาพร้อมฝาปิดที่จับพับได้หม้อสเตนเลสสตีลทำอาหารไทเทเนี่ยมเครื่องครัวนักเดินทางสวมใส่ได้แบบสากลเตาทั้งหมดของแท้100%",
        "product_image": "https://img.lazcdn.com/g/p/775228ec9aa117a3755ef2abeb7840c8.png_200x200q90.png",
        "price": 4018,
        "remark": "https://www.lazada.co.th/products/pdp-i5123587421.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | ชุดหม้อปิกนิก Naturehike 2025 รุ่นใหม่ สำหรับกิจกรรมกลางแจ้ง พกพาสะดวก คุณภาพสูง ผลิตจากอะลูมิเนียม 4 ชิ้น ชุดเครื่องครัวเคลือบกันติด สำหรับตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0ca6b246b72e43a688cf3661de838585T.jpg_200x200q90.jpg",
        "price": 4014.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16104628734.html",
        "sold": 0
    },
    {
        "product_name": "MAGIC ทนต่ออุณหภูมิสูง ถาดอบขนมสำหรับตั้งแคมป์ ค่าการนำความร้อนที่สม่ำเสมอ ดีไซน์น้ำหนักเบา บาร์บีคิว ตัวเลือกการประกอบที่รวดเร็ว ขนาดพกพา บาร์บีคิวกริลล์ ตั้งแคมป์กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/35be15784b77c7764c02779cd3a1ac23.jpg_200x200q90.jpg",
        "price": 4000.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16128282238.html",
        "sold": 0
    },
    {
        "product_name": "หม้อลวกเส้น หม้อต้มซุปลวกก๋วยเตี๋ยว หม้อลวกก๋ยวเตี๋ยว 3ช่อง4ช่องและ5ช่อง หม้อลวกก๋วยเตี๋ยวพร้อมกระชอนลวกเส้น",
        "product_image": "https://img.lazcdn.com/g/p/4fb9dc4e6741d5ca691f1944f3bb3fd9.jpg_200x200q90.jpg",
        "price": 4000,
        "remark": "https://www.lazada.co.th/products/pdp-i5228672822.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัว แคมป์ Camping",
        "product_image": "https://img.lazcdn.com/g/p/0533deddc23871eb7d1dd769b7997a7d.jpg_200x200q90.jpg",
        "price": 4000,
        "remark": "https://www.lazada.co.th/products/pdp-i4713213824.html",
        "sold": 0
    },
    {
        "product_name": "Innerwell กระทะมีฝา หินไมฟาน ไม่ติด  ปลอดสารพิษ ทำความสะอาดง่าย สําหรับเตาแก๊สทุกรุ่น 8 ชิ้น สีชมพู/สีเขียว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa442dc8793984057896da1254c0367584.jpg_200x200q90.jpg",
        "price": 3998,
        "remark": "https://www.lazada.co.th/products/pdp-i5838060114.html",
        "sold": 0
    },
    {
        "product_name": "เตาน้ำมันmr.t วางหม้อใหญ่ หม้อก๋วยเตี๋ยว​กะทะเล็กใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sea71207f36f74f898bba15cb1f0c13f6F.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5843576623.html",
        "sold": 0
    },
    {
        "product_name": "ชุดหม้อ ชุดหม้อ 7 ชิ้นหม้ออเนกประสงค์ กระทะไม่ติด ซีรีส์ Black Currant กระทะทอด หม้อซุป กระทะผัด หม้อทำเครื่องดื่มขนาด  ไม่มี PFOA ใช้งานกับเตาแม่เหล็กไฟฟ้าและเตาเซรามิกได้ GUOJ041",
        "product_image": "https://img.lazcdn.com/g/p/20b027004bcf96910f4fd7bcbb75de5d.jpg_200x200q90.jpg",
        "price": 3978,
        "remark": "https://www.lazada.co.th/products/pdp-i5709918563.html",
        "sold": 1
    },
    {
        "product_name": "Simplus Outlets🔥 ชุดหม้อ INSSA ชุดหม้อ 7 ชิ้นหม้ออเนกประสงค์ กระทะไม่ติด ซีรีส์ Black Currant กระทะทอด, หม้อซุป, กระทะผัด, หม้อทำเครื่องดื่มขนาด  ไม่มี PFOA ใช้งานกับเตาแม่เหล็กไฟฟ้าและเตาเซรามิกได้ Cookware Sets GUOJ041",
        "product_image": "https://img.lazcdn.com/g/p/70eab6d35ac9e214397bf61e3490967e.jpg_200x200q90.jpg",
        "price": 3978,
        "remark": "https://www.lazada.co.th/products/pdp-i5741357964.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแบบพกพาสำหรับ 2-3 คนตั้งแคมป์เดินป่าหม้ออลูมิเนียมน้ำหนักเบา GZ-TH",
        "product_image": "https://img.lazcdn.com/g/p/3aecf0850a65162fd2b59d2b2171f7d7.jpg_200x200q90.jpg",
        "price": 3968,
        "remark": "https://www.lazada.co.th/products/pdp-i16083538263.html",
        "sold": 0
    },
    {
        "product_name": "FireMaple FMC-212 Cookware ชุดหม้อขนาด 6-7คน",
        "product_image": "https://img.lazcdn.com/g/p/457cb944e7549b9dd941993613e4c48f.png_200x200q90.png",
        "price": 3960,
        "remark": "https://www.lazada.co.th/products/pdp-i5202558146.html",
        "sold": 0
    },
    {
        "product_name": "All-Metal 15\" Kitchen Utensil Set-18/10 Stainless Steel Cooking Tools with Countertop Rotating Holder Stand Included",
        "product_image": "https://img.lazcdn.com/g/p/13bf78c66bc6e890d85febbc12144ff4.jpg_200x200q90.jpg",
        "price": 3950,
        "remark": "https://www.lazada.co.th/products/pdp-i16087486891.html",
        "sold": 0
    },
    {
        "product_name": "18/10 Stainless Steel Kitchen Utensils Set - 15'' All Metal Cooking Utensils with Countertop Rotating Holder Stand",
        "product_image": "https://img.lazcdn.com/g/p/13bf78c66bc6e890d85febbc12144ff4.jpg_200x200q90.jpg",
        "price": 3950,
        "remark": "https://www.lazada.co.th/products/pdp-i16094369914.html",
        "sold": 0
    },
    {
        "product_name": "Cooking Utensils Set-All-Metal 18/10 Stainless Steel, 15\" Kitchen Tools with Countertop Rotating Holder Stand",
        "product_image": "https://img.lazcdn.com/g/p/df8e8a238acd8ba02781b5258937a0a2.jpg_200x200q90.jpg",
        "price": 3354,
        "remark": "https://www.lazada.co.th/products/pdp-i16094509555.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA-หม้อสแตนเลส1L กาต้มน้ำทำอาหารสำหรับแบกเป้ปิกนิกเดินป่า,หม้อสแตนเลสพร้อมที่จับพับได้ที่คลุมพกพาได้ใช้งานได้สองแบบ",
        "product_image": "https://img.lazcdn.com/g/p/4767a00e2fa12421d2edcb76b437ec83.jpg_200x200q90.jpg",
        "price": 3945.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5949234731.html",
        "sold": 0
    },
    {
        "product_name": "Harayaa คีมคีบฟืนอเนกประสงค์แบบฉนวนกันความร้อนสูงน้ำหนักเบาหนัง PU สำหรับปิกนิกบาร์บีคิวกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/b09723b31d7c711f988072c2699b018e.jpg_200x200q90.jpg",
        "price": 3944,
        "remark": "https://www.lazada.co.th/products/pdp-i5973254372.html",
        "sold": 0
    },
    {
        "product_name": "คีมคีบฟืนฟืนเตาไฟฉนวนกันความร้อนสูงคีมคีบอาหารสำหรับย่าง BBQ ปิกนิกตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/29f0c39aca99c9568ff879b056702bec.jpg_200x200q90.jpg",
        "price": 3944,
        "remark": "https://www.lazada.co.th/products/pdp-i16137164214.html",
        "sold": 0
    },
    {
        "product_name": "คีมคีบฟืนคีมคีบอาหารเตาผิงสำหรับงานหนัก",
        "product_image": "https://img.lazcdn.com/g/p/3ef44bfd3d310448c9b90e410187de3d.jpg_200x200q90.jpg",
        "price": 3944,
        "remark": "https://www.lazada.co.th/products/pdp-i16050655145.html",
        "sold": 0
    },
    {
        "product_name": "The Hugs Shop DS300 / SY300 ชุดหม้อสนามแคมป์ปิ้ง ชุดหม้อตั้งแคมป์ DS-300 Outdoor Camping Cooking Set สำหรับ 3-4 คน",
        "product_image": "https://img.lazcdn.com/g/p/737f5da64000e6d4b847f29ea9de7f4a.jpg_200x200q90.jpg",
        "price": 3938,
        "remark": "https://www.lazada.co.th/products/pdp-i5914760874.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกระทะปิกนิกกลางแจ้งแบบพกพาชุดหม้อกระทะ Set Alat Masak คนหม้อหุงต้มเตา2-3คนเครื่องครัว Huiop ชุดคิทเครื่องครัวแบบพกพาแบบพกพาชุดเครื่องใช้สำหรับโต๊ะอาหารกลางแจ้งกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/75c6ebe9f2bc0d74ca0fc127b9f9c8b3.jpg_200x200q90.jpg",
        "price": 3938,
        "remark": "https://www.lazada.co.th/products/pdp-i5640724055.html",
        "sold": 0
    },
    {
        "product_name": "Fire-Maple | หม้อปิ้งย่างพิเศษไม่ติดกระทะ ความจุ 3 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5e715da9019d49aabed630d0b72b23fdt.jpg_200x200q90.jpg",
        "price": 3934.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16049500970.html",
        "sold": 0
    },
    {
        "product_name": "Mini Cooking System Outdoor Water Boiling Stove Mountaineering Hiking Windproof Camping Cookware",
        "product_image": "https://img.lazcdn.com/g/p/d1af1afe5b4ea5789f680dc94361dfd7.jpg_200x200q90.jpg",
        "price": 3934,
        "remark": "https://www.lazada.co.th/products/pdp-i16134153585.html",
        "sold": 0
    },
    {
        "product_name": "แบบพกพาพับไม่ติดกระทะตั้งแคมป์ชุดเครื่องครัวการออกแบบที่มีน้ำหนักเบาสำหรับการปรุงอาหารกลางแจ้ง LA3PF-VIB-TH",
        "product_image": "https://img.lazcdn.com/g/p/486275c70408d87e183dacd5c34441cb.jpg_200x200q90.jpg",
        "price": 3922,
        "remark": "https://www.lazada.co.th/products/pdp-i16090522074.html",
        "sold": 0
    },
    {
        "product_name": "ชุดหม้อลวกก๋วยเตี๋ยว พร้อมอุปกรณ์ หม้อสแตนเลส ลวกเส้น 3/4/5ช่อง หม้อสตูว์",
        "product_image": "https://img.lazcdn.com/g/p/4a4a875f34eed517f8d1d8b81514a55d.jpg_200x200q90.jpg",
        "price": 3910,
        "remark": "https://www.lazada.co.th/products/pdp-i5847901196.html",
        "sold": 0
    },
    {
        "product_name": "NTS ชามผสม ถ้วยเตรียมอาหาร ภาชนะสแตนเลส อ่างสแตนเลส ถ้วยผสม ถ้วยแบ่ง ชามสแตนเลส NTS1-MIB",
        "product_image": "https://img.lazcdn.com/g/p/d54ed4ebfb445e6a0bae21b7e03b491e.jpg_200x200q90.jpg",
        "price": 3852,
        "remark": "https://www.lazada.co.th/products/pdp-i4401876288.html",
        "sold": 0
    },
    {
        "product_name": "【Latest model】Light Weight Cooking Accessories, Open Flame Cookware, Camping Tray, Outdoor Camping Cookware Set, and Miscellaneous Set",
        "product_image": "https://img.lazcdn.com/g/p/23f593c21387ab9f8438c07d7f6f30ab.jpg_200x200q90.jpg",
        "price": 3848,
        "remark": "https://www.lazada.co.th/products/pdp-i16096368260.html",
        "sold": 0
    },
    {
        "product_name": "fire-maple ชุดหม้อ Feast 4 Cookware Set",
        "product_image": "https://img.lazcdn.com/g/p/f820f913e2f46a30d58c05637c29ea83.jpg_200x200q90.jpg",
        "price": 3840,
        "remark": "https://www.lazada.co.th/products/pdp-i5353480234.html",
        "sold": 0
    },
    {
        "product_name": "FIRE-MAPLE FEAST 4 COOKING SET หม้อชุดสำหรับแค้มป์ปิ้ง",
        "product_image": "https://img.lazcdn.com/g/p/d9165bd3ed80c58561e90da06ed0a0d6.jpg_200x200q90.jpg",
        "price": 3840,
        "remark": "https://www.lazada.co.th/products/pdp-i3303052794.html",
        "sold": 6
    },
    {
        "product_name": "Fire maple feast 5 ชุดครัวแคมป์ปิ้ง",
        "product_image": "https://img.lazcdn.com/g/p/85481f7667a9061fa322b7f989e3c122.jpg_200x200q90.jpg",
        "price": 3840,
        "remark": "https://www.lazada.co.th/products/pdp-i4071446181.html",
        "sold": 0
    },
    {
        "product_name": "[aou09g]All-Metal Cooking Utensilas Set-15\" 18/10 Stainless Steel Kitchen Utensil Tools with Countertop Rotating Holder Stand",
        "product_image": "https://img.lazcdn.com/g/p/13bf78c66bc6e890d85febbc12144ff4.jpg_200x200q90.jpg",
        "price": 3836,
        "remark": "https://www.lazada.co.th/products/pdp-i16071926292.html",
        "sold": 0
    },
    {
        "product_name": "Snowpeak | อุปกรณ์ทำครัวแคมปิ้งไทเทเนียมน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S83af978685d74e128f9f7eab9bac300cw.jpg_200x200q90.jpg",
        "price": 3833.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5948881450.html",
        "sold": 1
    },
    {
        "product_name": "Gazechimp หม้อต้มอาหารทะเลสแตนเลสแบบพกพาเครื่องครัวแคมป์ไฟ Panci Camping หม้อต้มนึ่งสำหรับเดินทางเดินป่าบาร์บีคิว",
        "product_image": "https://img.lazcdn.com/g/p/331d72ae8ba41c73a4dc37f430c80ee6.jpg_200x200q90.jpg",
        "price": 3830,
        "remark": "https://www.lazada.co.th/products/pdp-i5960918300.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | อุปกรณ์ทำอาหารพกพาไม่ติดกระทะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf6f0e53baa4e41829ed3cb4a794ac122K.jpg_200x200q90.jpg",
        "price": 3827.74,
        "remark": "https://www.lazada.co.th/products/pdp-i6065004030.html",
        "sold": 11
    },
    {
        "product_name": "Phenovo ชุดเครื่องครัวแคมปิ้งตั้งแคมป์ชุดทำอาหารส้อมและช้อนถ้วยเหล็กกล้าไร้สนิมสำหรับปิกนิกเดินป่ากระเป๋าแบ็คแพ็คสำหรับกิจกรรมกลางแจ้งบาร์บีคิว",
        "product_image": "https://img.lazcdn.com/g/p/37404c9c79ec056b094aaafa2199fe88.jpg_200x200q90.jpg",
        "price": 3814,
        "remark": "https://www.lazada.co.th/products/pdp-i16121658147.html",
        "sold": 0
    },
    {
        "product_name": "ZYStar ชุดเครื่องครัวแคมปิ้งสำหรับตั้งแคมป์กาต้มน้ำกระทะหม้อส้อมและช้อนตามหลักสรีรศาสตร์ชุดทำอาหารสำหรับปิกนิกปีนเขากลางแจ้งทำอาหารบาร์บีคิวท่องเที่ยว",
        "product_image": "https://img.lazcdn.com/g/p/cbb23cf9174dbfb24f2e22f6bc73b2da.jpg_200x200q90.jpg",
        "price": 3814,
        "remark": "https://www.lazada.co.th/products/pdp-i16069401102.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแคมปิ้งเด็ก Moon ชุดทำอาหารพับได้อะลูมิเนียมอัลลอยตั้งแคมป์กาต้มน้ำกระทะหม้อสำหรับแบกเป้ปิกนิกกลางแจ้งปีนเขาทำอาหาร",
        "product_image": "https://img.lazcdn.com/g/p/51008b61e34172f2b6b10f5c1f12720d.jpg_200x200q90.jpg",
        "price": 3814,
        "remark": "https://www.lazada.co.th/products/pdp-i16070706674.html",
        "sold": 0
    },
    {
        "product_name": "ชุดอุปกรณ์ทำอาหารบนโต๊ะอาหารเครื่องครัวแคมปิ้งกันลื่นพร้อมที่จับหม้ออาหารสำหรับทำอาหารกลางแจ้งปิคนิคเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/99104c8bb64c74d23377f3b1a1cc271c.jpg_200x200q90.jpg",
        "price": 3814,
        "remark": "https://www.lazada.co.th/products/pdp-i6007604392.html",
        "sold": 0
    },
    {
        "product_name": "Freneci ชุดเครื่องครัวแคมปิ้งหม้อพับได้ตามหลักสรีรศาสตร์กาต้มน้ำกระทะถ้วยเหล็กกล้าไร้สนิมส้อมและช้อนสำหรับปิกนิกปีนเขาการทำบาร์บีคิวกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/1ce7b9ff205937475f2ae4050fbc9c47.jpg_200x200q90.jpg",
        "price": 3814,
        "remark": "https://www.lazada.co.th/products/pdp-i16073967516.html",
        "sold": 0
    },
    {
        "product_name": "Deevoka ชุดอุปกรณ์ทานอาหารเครื่องครัวแคมปิ้งอุปกรณ์ทำอาหารช้อนชุดภาชนะส้อมกระทะทอดสำหรับบาร์บีคิวปิกนิกเดินป่าแคมปิ้งเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/a42a7a91ecafd5878060da966b5e7fc6.jpg_200x200q90.jpg",
        "price": 3814,
        "remark": "https://www.lazada.co.th/products/pdp-i6013335774.html",
        "sold": 0
    },
    {
        "product_name": "เซทเครื่องครัวตั้งแคมป์ Kodaily ช้อนง่ายต่อการพกพาหม้ออาหารแคมป์ไฟส้อมชุดทำอาหารกระทะทอดสำหรับการเดินทางแคมป์ปิ้งบาร์บีคิว",
        "product_image": "https://img.lazcdn.com/g/p/66d29f107942d10072ca0630f5da6843.jpg_200x200q90.jpg",
        "price": 3814,
        "remark": "https://www.lazada.co.th/products/pdp-i5993925973.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแคมปิ้ง CCGREAT ชุดกาต้มน้ำกระทะหม้อส้อมและช้อนดีไซน์ตามหลักสรีรศาสตร์สำหรับปิกนิกปีนเขาทำอาหารบาร์บีคิวกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/695e1ea5172fb3bde99d734b439b28fe.jpg_200x200q90.jpg",
        "price": 3814,
        "remark": "https://www.lazada.co.th/products/pdp-i16070372136.html",
        "sold": 0
    },
    {
        "product_name": "【Latest model】Outdoor Cooking Equipment Camping and Picnic Tools Picnic Utensils Picnic Cookware",
        "product_image": "https://img.lazcdn.com/g/p/23f593c21387ab9f8438c07d7f6f30ab.jpg_200x200q90.jpg",
        "price": 3808,
        "remark": "https://www.lazada.co.th/products/pdp-i16123994177.html",
        "sold": 0
    },
    {
        "product_name": "Gamchiano คีมคีบฟืน,คีมอเนกประสงค์ใช้ในครัวเรือนอุปกรณ์แคมป์บาร์บีคิวสำหรับตะแกรงทำอาหารตั้งแคมป์กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/8bb7fc5af58b3d5d4bdc767486dec0c3.jpg_200x200q90.jpg",
        "price": 3805.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16126143051.html",
        "sold": 0
    },
    {
        "product_name": "Ulight หม้อหม้ออาหารเซทเครื่องครัวตั้งแคมป์อเนกประสงค์ง่ายต่อการตั้งแคมป์บาร์บีคิวทำอาหารที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/p/e4efe41b0de63e493b002b68d14aa56d.jpg_200x200q90.jpg",
        "price": 3802,
        "remark": "https://www.lazada.co.th/products/pdp-i6020070932.html",
        "sold": 0
    },
    {
        "product_name": "CCPlanet ที่จับพับกาน้ำเซทเครื่องครัวตั้งแคมป์พร้อมกระเป๋าเก็บของอเนกประสงค์ไม่ติด Panci Camping กระทะทอดสำหรับปิกนิกปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/a9c23ea26bc188982cadda5f5e0fe617.jpg_200x200q90.jpg",
        "price": 3802,
        "remark": "https://www.lazada.co.th/products/pdp-i5993904467.html",
        "sold": 0
    },
    {
        "product_name": "Jetbeam | ชุดเครื่องครัวสำหรับแค้มปิ้งพกพาพร้อมเตาและกาต้มน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S69ad24a7c1af43f4a300f783910c5361r.jpg_200x200q90.jpg",
        "price": 3801.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5929677398.html",
        "sold": 29
    },
    {
        "product_name": "ชุดหม้อ K2 ชุดหม้อสนาม ชุดหม้อพกพา K2 Cooker size M ขนาด 2-4 คน by Jeep Camping",
        "product_image": "https://img.lazcdn.com/g/p/b425fa7992bd2a02ce5c5c9746680370.jpg_200x200q90.jpg",
        "price": 3800,
        "remark": "https://www.lazada.co.th/products/pdp-i2811428578.html",
        "sold": 0
    },
    {
        "product_name": "หม้อนกหวีดตั้งแคมป์พร้อมฝาปิดสแตนเลสหม้อต้มเครื่องครัวแคมป์ไฟสำหรับบาร์บีคิวในแบกเป้ปิกนิกเพื่อความอยู่รอดการเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/ede519c19ab6ff01f9a0ef04675de597.jpg_200x200q90.jpg",
        "price": 3798,
        "remark": "https://www.lazada.co.th/products/pdp-i16105094633.html",
        "sold": 0
    },
    {
        "product_name": "Tefal ชุดอุปกรณ์ประกอบอาหาร รุ่น G135S696 จำนวน 6 ชิ้น ก้น Induction ใช้ได้กับเตาทุกชนิด",
        "product_image": "https://img.lazcdn.com/g/p/d859a2d73653e1d066cc9001cadfb1bd.png_200x200q90.png",
        "price": 3798,
        "remark": "https://www.lazada.co.th/products/pdp-i3665274367.html",
        "sold": 14
    },
    {
        "product_name": "เครื่องครัวกระทะทอดไฟแสงจันทร์แบบเปิด Panci Camping พร้อมฝาเครื่องใช้หม้อต้มหม้อต้มอาหารทะเลเพื่อความอยู่รอดบาร์บีคิวการเดินทางเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/cc04ba69955a233750722e55a9a4a721.jpg_200x200q90.jpg",
        "price": 3798,
        "remark": "https://www.lazada.co.th/products/pdp-i16075135770.html",
        "sold": 0
    },
    {
        "product_name": "หม้อพร้อมฝานึ่ง Panci Camping แบบพกพาสำหรับกระทะทอดอาหารทะเลหม้อไฟแบบเปิดเครื่องครัวสำหรับบาร์บีคิวกระเป๋าเป้ปีนเขาบาร์บีคิว",
        "product_image": "https://img.lazcdn.com/g/p/6165440ce0e9b1c1e38568586d19508a.jpg_200x200q90.jpg",
        "price": 3798,
        "remark": "https://www.lazada.co.th/products/pdp-i16097099557.html",
        "sold": 0
    },
    {
        "product_name": "Koolsoo เครื่องครัวกระทะทอดไฟเปิด Panci Camping พร้อมฝาปิดหม้อนึ่งหม้อต้มทำอาหารสำหรับกระเป๋าเป้ปีนเขาบาร์บีคิว",
        "product_image": "https://img.lazcdn.com/g/p/96f2212162385b6c31d89a0d1581428c.jpg_200x200q90.jpg",
        "price": 3798,
        "remark": "https://www.lazada.co.th/products/pdp-i16068595182.html",
        "sold": 0
    },
    {
        "product_name": "หม้อสนาม อุปกรณ์แคมป์ปิ้ง ชุดเครื่องครัว ชุดครัวสนาม ชุดเครื่องครัวสเตนเลสเคลือบผิวกันติดสำหรับการตั้งแคมป์รุ่น MH 500 หม้อตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/e58d2598706e2233fb095ccca149de57.jpg_200x200q90.jpg",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i1434926713.html",
        "sold": 0
    },
    {
        "product_name": "WDFINE ชุดเครื่องครัวแคมปิ้งกาต้มน้ำหม้อกระทะทอดอเนกประสงค์พับได้ออกแบบตามหลักสรีรศาสตร์,ชุดทำอาหารตั้งแคมป์สำหรับเดินทางตกปลาทำบาร์บีคิว",
        "product_image": "https://img.lazcdn.com/g/p/c5ba48a81f20df26e6f8d6e0fabfe6e6.jpg_200x200q90.jpg",
        "price": 3778,
        "remark": "https://www.lazada.co.th/products/pdp-i16076112555.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแคมปิ้ง WBStar พร้อมเครื่องใช้ในครัวกาต้มน้ำหม้อกระทะทอดถ้วยเหล็กกล้าไร้สนิมเดินทางเดินป่าตกปลาปิกนิกทำอาหารกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/9029c96c012a607298490f119bd04b37.jpg_200x200q90.jpg",
        "price": 3778,
        "remark": "https://www.lazada.co.th/products/pdp-i16087480154.html",
        "sold": 0
    },
    {
        "product_name": "ทาฮิดาชุดเครื่องครัวแคมปิ้งกาต้มน้ำหม้อกระทะทอดอเนกประสงค์พับได้ตามหลักสรีรศาสตร์,ชุดทำอาหารตั้งแคมป์สำหรับเดินทางตกปลาทำบาร์บีคิว",
        "product_image": "https://img.lazcdn.com/g/p/ea00b628991f8d91974bd0618d9767e3.jpg_200x200q90.jpg",
        "price": 3778,
        "remark": "https://www.lazada.co.th/products/pdp-i16076119988.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแคมปิ้งจรวดดวงจันทร์กาน้ำหม้อกระทะทอดอเนกประสงค์พับเก็บได้ออกแบบตามหลักสรีรศาสตร์ชุดทำอาหารตั้งแคมป์สำหรับเดินทางตกปลาทำบาร์บีคิว",
        "product_image": "https://img.lazcdn.com/g/p/d0c614d765ba674bfd5c2adbd0f28cd3.jpg_200x200q90.jpg",
        "price": 3778,
        "remark": "https://www.lazada.co.th/products/pdp-i16075366883.html",
        "sold": 0
    },
    {
        "product_name": "ถ้วยชุดสแตนเลสเครื่องครัวแคมปิ้งสำหรับตั้งแคมป์ชุดทำอาหารหม้อกาต้มน้ำกระทะสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/98b568418e0be14f4379f102879a3c7a.jpg_200x200q90.jpg",
        "price": 3778,
        "remark": "https://www.lazada.co.th/products/pdp-i16134675285.html",
        "sold": 0
    },
    {
        "product_name": "WDEarth ชุดเครื่องครัวแคมปิ้งกาต้มน้ำหม้อกระทะทอดอเนกประสงค์พับได้ออกแบบตามหลักสรีรศาสตร์,ชุดทำอาหารตั้งแคมป์สำหรับเดินทางตกปลาทำบาร์บีคิว",
        "product_image": "https://img.lazcdn.com/g/p/51fe5f0794e80623a6a1f42d5cc4b719.jpg_200x200q90.jpg",
        "price": 3778,
        "remark": "https://www.lazada.co.th/products/pdp-i16076413050.html",
        "sold": 0
    },
    {
        "product_name": "Livestyl ชุดเครื่องครัวแคมปิ้งกาต้มน้ำกระทะหม้ออะลูมินัมอัลลอยแคมป์ปิ้งสำหรับบาร์บีคิวปิกนิกเดินป่ากลางแจ้งทำอาหารตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/8da3ddb966007686b1b1f0b2e57d8d6f.jpg_200x200q90.jpg",
        "price": 3778,
        "remark": "https://www.lazada.co.th/products/pdp-i16077791082.html",
        "sold": 0
    },
    {
        "product_name": "BNCLOTH ชุดเครื่องครัวแคมปิ้งกาต้มน้ำหม้อกระทะทอดชุดทำอาหารอเนกประสงค์สำหรับตั้งแคมป์พร้อมเครื่องใช้สำหรับบาร์บีคิวท่องเที่ยวกลางแจ้งเดินทางเป้",
        "product_image": "https://img.lazcdn.com/g/p/ea84895b47862811add35c91328dbb42.jpg_200x200q90.jpg",
        "price": 3778,
        "remark": "https://www.lazada.co.th/products/pdp-i16076648470.html",
        "sold": 0
    },
    {
        "product_name": "CCClever 17 In 1สแตนเลสเครื่องครัวแคมปิ้งชามปิกนิคไว้หุงอาหารชุดจานกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/fcc98054af8ca7de0422957805e6cd2e.jpg_200x200q90.jpg",
        "price": 3778,
        "remark": "https://www.lazada.co.th/products/pdp-i5905333765.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแคมปิ้ง Chiwanji ชุดทำอาหารอะลูมินัมอัลลอยตั้งแคมป์หม้อกระทะทอดถ้วยกาต้มน้ำสแตนเลสสำหรับบาร์บีคิวทำอาหารกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/071e8bb9369a0e9ff6a258e406bcd0e3.jpg_200x200q90.jpg",
        "price": 3778,
        "remark": "https://www.lazada.co.th/products/pdp-i16078630708.html",
        "sold": 0
    },
    {
        "product_name": "BNMUSIC ชุดเครื่องครัวแคมปิ้งชุดหม้ออะลูมินัมอัลลอยกาต้มน้ำกระทะตั้งแคมป์สำหรับบาร์บีคิวปิกนิกเดินป่ากลางแจ้งทำอาหารตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/ea84895b47862811add35c91328dbb42.jpg_200x200q90.jpg",
        "price": 3778,
        "remark": "https://www.lazada.co.th/products/pdp-i16076606557.html",
        "sold": 0
    },
    {
        "product_name": "BNTOOL ชุดเครื่องครัวแคมปิ้งเครื่องมืออเนกประสงค์ถ้วยเหล็กกล้าไร้สนิมพับนำความร้อนเร็วอะลูมินัมอัลลอยพร้อมเครื่องใช้สำหรับตกปลาบาร์บีคิว",
        "product_image": "https://img.lazcdn.com/g/p/94fba1ecec08434c94b3b9e3678a92ac.jpg_200x200q90.jpg",
        "price": 3778,
        "remark": "https://www.lazada.co.th/products/pdp-i16084390564.html",
        "sold": 0
    },
    {
        "product_name": "Benent ชุดเครื่องครัวแคมปิ้งถ้วยเหล็กกล้าไร้สนิมแบบพกพาได้อย่างรวดเร็วนำความร้อนหม้อที่จับสามารถพับได้กาต้มน้ำกระทะสำหรับการเดินป่าบาร์บีคิวกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/3db13bac3289e7c2d937ecb72393c910.jpg_200x200q90.jpg",
        "price": 3778,
        "remark": "https://www.lazada.co.th/products/pdp-i16078005242.html",
        "sold": 0
    },
    {
        "product_name": "CAROTE | ชุดเครื่องครัวกระทะไทเทเนียมไม่ติดกระทะ ด้ามจับถอดได้ ปลอดภัยกับเครื่องล้างจาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S13086ca545054313af9c89647873bdebe.jpg_200x200q90.jpg",
        "price": 3777.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5892646945.html",
        "sold": 40
    },
    {
        "product_name": "Panci Camping เด็กพร้อม HANDEL Lipat ทำความสะอาดง่ายขนาด1.6ลิตรพร้อมกระเป๋าตาข่ายเก็บของหม้ออลูมิเนียมแบบพกพาสำหรับการเดินป่าแบกเป้",
        "product_image": "https://img.lazcdn.com/g/p/ce8e1983fa10435dbde3ad63f4d03bf2.jpg_200x200q90.jpg",
        "price": 3764,
        "remark": "https://www.lazada.co.th/products/pdp-i5990138315.html",
        "sold": 0
    },
    {
        "product_name": "Light Weight Cooking Accessories, Open Flame Cookware, Camping Tray, Outdoor Camping Cookware Set, and Miscellaneous Set",
        "product_image": "https://img.lazcdn.com/g/p/23f593c21387ab9f8438c07d7f6f30ab.jpg_200x200q90.jpg",
        "price": 3761,
        "remark": "https://www.lazada.co.th/products/pdp-i16126300043.html",
        "sold": 0
    },
    {
        "product_name": "ชุด LIXADA ที่จำเป็นเครื่องใช้ในครัว",
        "product_image": "https://img.lazcdn.com/g/p/59a0d7c042f7133badb02d2f3bd226c2.jpg_200x200q90.jpg",
        "price": 3748,
        "remark": "https://www.lazada.co.th/products/pdp-i5373020037.html",
        "sold": 0
    },
    {
        "product_name": "Motoautt กาต้มน้ำกระทะหม้อชุดอุปกรณ์ทานอาหารเครื่องครัวแคมปิ้งมีชามแบบพกพาสำหรับเดินทางเป้สะพายหลังกิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/0b424dada58a9be7af2fdf04e3cabebc.jpg_200x200q90.jpg",
        "price": 3742,
        "remark": "https://www.lazada.co.th/products/pdp-i16072874945.html",
        "sold": 0
    },
    {
        "product_name": "อุปกรณ์จำเป็นเครื่องใช้ในครัวเซตจาก TOMSHOO",
        "product_image": "https://img.lazcdn.com/g/p/59a0d7c042f7133badb02d2f3bd226c2.jpg_200x200q90.jpg",
        "price": 3738,
        "remark": "https://www.lazada.co.th/products/pdp-i5372946603.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | ชุดเครื่องครัวแคมปิ้งพกพาไม่ติดกระทะ สำหรับกลางแจ้งฤดูใบไม้ผลิ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S804b8f89e47841b8b3aa656384f1c8c9h.png_200x200q90.png",
        "price": 3737.3,
        "remark": "https://www.lazada.co.th/products/pdp-i6064380385.html",
        "sold": 0
    },
    {
        "product_name": "กระจกบังลมกระจกกันลมสำหรับแคมป์แบบพับได้สำหรับเชฟตะเกียงทำอาหารแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/ea5156ed0a7ba21e26758497c16ec4eb.jpg_200x200q90.jpg",
        "price": 3732,
        "remark": "https://www.lazada.co.th/products/pdp-i5902093653.html",
        "sold": 0
    },
    {
        "product_name": "All-Metal Cooking Utensilas Set-15\" 18/10 Stainless Steel Kitchen Utensil Tools with Countertop Rotating Holder Stand",
        "product_image": "https://img.lazcdn.com/g/p/13bf78c66bc6e890d85febbc12144ff4.jpg_200x200q90.jpg",
        "price": 3354,
        "remark": "https://www.lazada.co.th/products/pdp-i16097427783.html",
        "sold": 0
    },
    {
        "product_name": "Kitchen Utensils Set-Countertop Rotating Holder Stand Included 18/10 Stainless Steel Cooking Utensils(15\") All Metal",
        "product_image": "https://img.lazcdn.com/g/p/13bf78c66bc6e890d85febbc12144ff4.jpg_200x200q90.jpg",
        "price": 3728,
        "remark": "https://www.lazada.co.th/products/pdp-i16085767291.html",
        "sold": 0
    },
    {
        "product_name": "JEETEE ชุดเครื่องครัวหินแกรนิตเคลือบสารกันติด 4 ชิ้น ใช้ได้กับเตาแม่เหล็กไฟฟ้าและแก๊ส ปราศจาก PFAS และ PFOA",
        "product_image": "https://img.lazcdn.com/g/p/7c90b26281819fbf2c4c899467123da5.jpg_200x200q90.jpg",
        "price": 3722,
        "remark": "https://www.lazada.co.th/products/pdp-i5251252021.html",
        "sold": 144
    },
    {
        "product_name": "ชุดหม้อ 1.25L กระทะ 800ml ไททาเนียม Keith Ti6017",
        "product_image": "https://img.lazcdn.com/live/th/p/a07dec86ab13ba17f2909492a431a883.jpg_200x200q90.jpg",
        "price": 3704,
        "remark": "https://www.lazada.co.th/products/pdp-i154113195.html",
        "sold": 0
    },
    {
        "product_name": "GSI GLACIER STAINLESS 12 CUP PERC#กาต้มน้ำ1.8 ลิตร",
        "product_image": "https://img.lazcdn.com/g/p/2910870d519c409dde126a7e4dd3f74c.jpg_200x200q90.jpg",
        "price": 3700,
        "remark": "https://www.lazada.co.th/products/pdp-i2420198987.html",
        "sold": 2
    },
    {
        "product_name": "Barebones Cast Iron Flat Panกระทะเหล็กหล่อ#เหมาะสำหรับใช้ทำเครป แพนเค้ก พิซซ่าอื่นๆ",
        "product_image": "https://img.lazcdn.com/g/p/22ea0fdcd1d2c325c3ea373abde5f26e.jpg_200x200q90.jpg",
        "price": 3680,
        "remark": "https://www.lazada.co.th/products/pdp-i1254956692.html",
        "sold": 1
    },
    {
        "product_name": "ชุดเครื่องครัวชุดเครื่องครัว 4 PCS ดั้งเดิมหม้อ และกระทะชุดเครื่องครัว  พร้อมกระทะบานทอด ที่เหมาะสำหรับเตาทุกเตา",
        "product_image": "https://img.lazcdn.com/g/p/6b13d0ae8bc100711a2e7f5363a866a5.jpg_200x200q90.jpg",
        "price": 3673.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5725827445.html",
        "sold": 19
    },
    {
        "product_name": "Gazechimp ชุดอุปกรณ์ทานอาหารเครื่องครัวแคมปิ้งพกพากันฝุ่นกะทัดรัดน้ำหนักเบาพร้อมชามสำหรับปิกนิกแบกเป้ทำอาหารกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/5b43f84ba3b0f49de6faebf80e93538a.jpg_200x200q90.jpg",
        "price": 3672,
        "remark": "https://www.lazada.co.th/products/pdp-i16090690310.html",
        "sold": 0
    },
    {
        "product_name": "Chiwanji เครื่องครัวแคมปิ้งชุดอุปกรณ์ทานอาหารกาน้ำพกพากาต้มน้ำกระทะ",
        "product_image": "https://img.lazcdn.com/g/p/f587bd18b59a58b092340245e03fec1d.jpg_200x200q90.jpg",
        "price": 3672,
        "remark": "https://www.lazada.co.th/products/pdp-i16074706435.html",
        "sold": 0
    },
    {
        "product_name": "BNMUSIC ชุดเครื่องครัวแคมปิ้งพร้อมชามง่ายต่อการพกพาอุณหภูมิสูงและกันฝุ่นพกพาได้น้ำหนักเบาสำหรับปิกนิกเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/0b424dada58a9be7af2fdf04e3cabebc.jpg_200x200q90.jpg",
        "price": 3672,
        "remark": "https://www.lazada.co.th/products/pdp-i16072556855.html",
        "sold": 0
    },
    {
        "product_name": "WBStar หม้อเซทเครื่องครัวตั้งแคมป์แบบพกพาพร้อมกาต้มน้ำกระทะชามไม้พายข้าวทัพพีตักซุปและฟองน้ำขัดทำความสะอาดสำหรับกิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/2ec7d1b1c398a683977349b682950bd5.jpg_200x200q90.jpg",
        "price": 3672,
        "remark": "https://www.lazada.co.th/products/pdp-i16087367356.html",
        "sold": 0
    },
    {
        "product_name": "Tahida กาต้มน้ำกระทะหม้อชุดอุปกรณ์ทานอาหารเครื่องครัวแคมปิ้งมีชามแบบพกพาสำหรับเดินทางเป้กิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/450a989387398c971458c3e5574d85b3.jpg_200x200q90.jpg",
        "price": 3672,
        "remark": "https://www.lazada.co.th/products/pdp-i16072643271.html",
        "sold": 0
    },
    {
        "product_name": "WDEarth หม้อกาต้มน้ำกระทะชุดอุปกรณ์ทานอาหารเครื่องครัวแคมปิ้งพร้อมชามแบบพกพาสำหรับเดินทางเดินทางเป้กิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/25ff5fa857212fe9a523c910e263277c.jpg_200x200q90.jpg",
        "price": 3672,
        "remark": "https://www.lazada.co.th/products/pdp-i16072592175.html",
        "sold": 0
    },
    {
        "product_name": "BNTOOL ชุดอุปกรณ์ทานอาหารเครื่องครัวแคมปิ้งแบบพกพากันฝุ่นกะทัดรัดน้ำหนักเบาพร้อมชามสำหรับปิกนิกแบกเป้ทำอาหารกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/bdfcbd220078e9d4facf444a7f81a542.jpg_200x200q90.jpg",
        "price": 3672,
        "remark": "https://www.lazada.co.th/products/pdp-i16092158198.html",
        "sold": 0
    },
    {
        "product_name": "หม้อชุดอุปกรณ์ทานอาหารเครื่องครัวแคมปิ้งน้ำหนักเบาของดวงจันทร์กาต้มน้ำกระทะน้ำหนักเบาทนอุณหภูมิสูงพร้อมโบลิ่งสำหรับปิกนิกการผจญภัยกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/4b068dba75d68a23866f5edcea7b866b.jpg_200x200q90.jpg",
        "price": 3672,
        "remark": "https://www.lazada.co.th/products/pdp-i16134489976.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องครัวแคมปิ้ง Benent ชุดอุปกรณ์ทานอาหารกาต้มน้ำกระทะกาน้ำพกพา",
        "product_image": "https://img.lazcdn.com/g/p/684bc6b9c16e5750ddf87ada0d181f16.jpg_200x200q90.jpg",
        "price": 3672,
        "remark": "https://www.lazada.co.th/products/pdp-i16073045851.html",
        "sold": 0
    },
    {
        "product_name": "หม้อชุดอุปกรณ์ทานอาหารเครื่องครัวแคมปิ้ง Manta Manta กาต้มน้ำกระทะสำหรับ2-3คนอุณหภูมิสูงและกันฝุ่นกับชามสำหรับกิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/d97366f7d6b143adee6d7ee6a3c5edb4.jpg_200x200q90.jpg",
        "price": 3672,
        "remark": "https://www.lazada.co.th/products/pdp-i16075835181.html",
        "sold": 0
    },
    {
        "product_name": "กาต้มน้ำกระทะหม้อชุดอุปกรณ์ทานอาหารเครื่องครัวแคมปิ้งพร้อมชามแบบพกพาสำหรับแบกเป้กิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/0b424dada58a9be7af2fdf04e3cabebc.jpg_200x200q90.jpg",
        "price": 3672,
        "remark": "https://www.lazada.co.th/products/pdp-i16072544850.html",
        "sold": 0
    },
    {
        "product_name": "กาต้มน้ำกระทะหม้อเซทเครื่องครัวตั้งแคมป์ดวงจันทร์น่ารักน้ำหนักเบาง่ายต่อการพกพากะทัดรัดพร้อมชามสำหรับแบกเป้ทำอาหารกลางแจ้งการเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/d77ef7ae4a4639b3090e1e84148e4fc3.jpg_200x200q90.jpg",
        "price": 3672,
        "remark": "https://www.lazada.co.th/products/pdp-i16072737053.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแคมปิ้ง WDFINE พกพาได้กันฝุ่นและอุณหภูมิสูงพร้อมกาต้มน้ำกระทะหม้อชามสำหรับปิกนิกผจญภัยกลางแจ้งการเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/1203bc729cec85004f534177fe609810.jpg_200x200q90.jpg",
        "price": 3672,
        "remark": "https://www.lazada.co.th/products/pdp-i16137640366.html",
        "sold": 0
    },
    {
        "product_name": "หม้อพกพาสำหรับชงชาและกาแฟกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9f0a92d217fd4310a4c4fba2eb5547bcC.jpg_200x200q90.jpg",
        "price": 3666,
        "remark": "https://www.lazada.co.th/products/pdp-i6072454643.html",
        "sold": 0
    },
    {
        "product_name": "กาต้มน้ำ LIXADA YIWENG 4ชิ้นถ้วยโรงอาหารอะลูมิเนียม Set Alat Masak ชุดเตาไม้พร้อมช้อนส้อมแบบพับได้และกระเป๋าครอบสำหรับตั้งแคมป์เดินป่าแบกเป้เงิน",
        "product_image": "https://img.lazcdn.com/g/p/e7a910d97de1ffd911c02195c72e2345.jpg_200x200q90.jpg",
        "price": 3660,
        "remark": "https://www.lazada.co.th/products/pdp-i6071385436.html",
        "sold": 0
    },
    {
        "product_name": "ที่แขวนเครื่องครัวแบบพกพาง่ายต่อการพกพาอุปกรณ์ทำอาหารสำหรับปาร์ตี้วันเกิดที่เกิดขึ้นจรวดของดวงจันทร์บาร์บีคิว",
        "product_image": "https://img.lazcdn.com/g/p/fbfd0ea6dba8a5e4e9b58c03dee7a728.jpg_200x200q90.jpg",
        "price": 3650.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16053255747.html",
        "sold": 0
    },
    {
        "product_name": "ชุดอุปกรณ์ทานอาหารเครื่องครัวสำหรับตั้งแคมป์แบกเป้เซทเครื่องครัวตั้งแคมป์การทำอาหารกลางแจ้งและปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/64cb62e0cd7e990b89deac542322fef6.jpg_200x200q90.jpg",
        "price": 3626,
        "remark": "https://www.lazada.co.th/products/pdp-i5778724543.html",
        "sold": 0
    },
    {
        "product_name": "Moon Rodeo กระทะปีนเขาน้ำหนักเบากระจายความร้อนที่มีประสิทธิภาพกระทะทอดกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/0f86d4685877dfde79fcd4414d799caf.jpg_200x200q90.jpg",
        "price": 3616,
        "remark": "https://www.lazada.co.th/products/pdp-i16126591604.html",
        "sold": 0
    },
    {
        "product_name": "Futoys อุปกรณ์ทำอาหารกลางแจ้งแบบพกพาน้ำหนักเบาเครื่องครัวแคมปิ้งทนทานสำหรับการเดินป่าผจญภัย",
        "product_image": "https://img.lazcdn.com/g/p/4530671179f59a0a465145d7386ed2c8.jpg_200x200q90.jpg",
        "price": 3616,
        "remark": "https://www.lazada.co.th/products/pdp-i16125275259.html",
        "sold": 0
    },
    {
        "product_name": "Moon Lighte กระทะกระทะทอดกลางแจ้งพับได้น้ำหนักเบาเครื่องครัวแคมปิ้งสำหรับเดินป่าแบกเป้ทำอาหาร",
        "product_image": "https://img.lazcdn.com/g/p/475262ad6e7146188d13559e83126735.jpg_200x200q90.jpg",
        "price": 3616,
        "remark": "https://www.lazada.co.th/products/pdp-i16134758413.html",
        "sold": 0
    },
    {
        "product_name": "BNMUSIC กระทะเตาและเครื่องครัวแคมปิ้งให้ความร้อนที่มีประสิทธิภาพกระทะทอดกลางแจ้งน้ำหนักเบาพิเศษสำหรับเต็นท์ร้อน",
        "product_image": "https://img.lazcdn.com/g/p/8efa70db5232db2b584477c8589c3c43.jpg_200x200q90.jpg",
        "price": 3616,
        "remark": "https://www.lazada.co.th/products/pdp-i16125254779.html",
        "sold": 0
    },
    {
        "product_name": "ทาฮิดะกระทะน้ำหนักเบากระทะทอดกลางแจ้งอเนกประสงค์สำหรับเครื่องครัวแคมปิ้งแบกเป้และอาหารกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/30444aba5cd3f5b826191de7bb8e2a87.jpg_200x200q90.jpg",
        "price": 3616,
        "remark": "https://www.lazada.co.th/products/pdp-i16136503607.html",
        "sold": 0
    },
    {
        "product_name": "CCGREAT กระทะปีนเขาน้ำหนักเบากระจายความร้อนกระทะทอดกลางแจ้งกระทะสำหรับใช้งานกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/18e2d3cdef629b41fda3be04f6dc098a.jpg_200x200q90.jpg",
        "price": 3616,
        "remark": "https://www.lazada.co.th/products/pdp-i16127072671.html",
        "sold": 0
    },
    {
        "product_name": "CCClever อุปกรณ์ทำอาหารสำหรับเต็นท์เตาแม่แรงพับได้,กระทะทอดกลางแจ้งขนาดกะทัดรัดเครื่องครัวแคมปิ้งพรีเมี่ยม",
        "product_image": "https://img.lazcdn.com/g/p/b5ec4537b54fd283560d40bbfa499430.jpg_200x200q90.jpg",
        "price": 3616,
        "remark": "https://www.lazada.co.th/products/pdp-i16127116776.html",
        "sold": 0
    },
    {
        "product_name": "Motoautt กระทะเครื่องครัวแคมปิ้งกระทะทอดกลางแจ้งแบบพกพาด้ามพับได้สำหรับห้องครัวตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/8efa70db5232db2b584477c8589c3c43.jpg_200x200q90.jpg",
        "price": 3616,
        "remark": "https://www.lazada.co.th/products/pdp-i16125374635.html",
        "sold": 0
    },
    {
        "product_name": "Beatycare กระทะเครื่องครัวแคมปิ้งกลางแจ้งแบบพกพากระทะทอดใช้ความร้อนและพับเก็บได้สำหรับห้องครัวตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/8efa70db5232db2b584477c8589c3c43.jpg_200x200q90.jpg",
        "price": 3616,
        "remark": "https://www.lazada.co.th/products/pdp-i16125504330.html",
        "sold": 0
    },
    {
        "product_name": "กระทะก้นตื้นสำหรับตั้งแคมป์และทำอาหารเดินทางได้กระทะครัวใช้ความร้อนกระทะทอดกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/4faaeb289e9166cbeb72c7d75eb1b830.jpg_200x200q90.jpg",
        "price": 3616,
        "remark": "https://www.lazada.co.th/products/pdp-i16136656727.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแคมปิ้ง FeLike กาต้มน้ำกระทะทอดสำหรับปิกนิกทำอาหารกลางแจ้งบาร์บีคิวการยศาสตร์แบบพกพาชุดทำอาหารแคมป์ปิ้งหม้อที่จับสามารถพับได้",
        "product_image": "https://img.lazcdn.com/g/p/3cdb05b593fabee9b721d707515ee730.jpg_200x200q90.jpg",
        "price": 3615.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16118783970.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัว ชุด 4 ชิ้น อาหารไม่ติด ชุดหม้อ และกระทะ กระทะ หม้อซุป หม้อนม ใช้ได้กับเตาแม่เหล็กไฟฟ้า เตาเซรามิกไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/46e17c0976879b71b964630bcd110e13.png_200x200q90.png",
        "price": 3600.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5937753419.html",
        "sold": 0
    },
    {
        "product_name": "ชุดหม้อสนาม Fire Maple FMC-212 Cookware ชุดใหญ่ 5-6 คน ของแท้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4184cf39c1df43dfa331a669f128d1f0c.jpg_200x200q90.jpg",
        "price": 3600,
        "remark": "https://www.lazada.co.th/products/pdp-i4239708492.html",
        "sold": 0
    },
    {
        "product_name": "GiPP ชุดกระทะ 15 ชิ้น ชุดเครื่องครัวไม่ติด หินแกรนิตชุดทำอาหารครัว",
        "product_image": "https://img.lazcdn.com/g/p/63420f749894bdc4fbceb24cb61202f5.jpg_200x200q90.jpg",
        "price": 3600,
        "remark": "https://www.lazada.co.th/products/pdp-i5781104124.html",
        "sold": 2
    },
    {
        "product_name": "Petromax Enamel Pan 1L หม้อเคลือบอินาเมล มีด้ามจับเป็นไม้ น้ำหนักเบา หม้อเเคมป์ปิ้ง",
        "product_image": "https://img.lazcdn.com/g/p/729ed436ebd171673a8c148146c1670a.jpg_200x200q90.jpg",
        "price": 3600,
        "remark": "https://www.lazada.co.th/products/pdp-i3999219541.html",
        "sold": 0
    },
    {
        "product_name": "YOUYO ป้องกันลม แผ่นกันลมเตา พับสามตอน ขนาดกะทัดรัด ป้องกันลมเตา พร้อมถุงเก็บของ ผ้าสีพื้น กระจกหน้ารถเครื่องครัว ครัวเรือน",
        "product_image": "https://img.lazcdn.com/g/p/3c784c2227938d910cd6d4c2a4a00e96.jpg_200x200q90.jpg",
        "price": 3596.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16076422900.html",
        "sold": 0
    },
    {
        "product_name": "MARRCIAN พับสามตอน แผ่นกันลมเตา ป้องกันลม ขนาดกะทัดรัด ป้องกันลมเตา บล็อกเกอร์ลม แบบพกพา กระจกหน้ารถเครื่องครัว ครัวเรือน",
        "product_image": "https://img.lazcdn.com/g/p/0e77aee36e888246f854a96803cf2cee.jpg_200x200q90.jpg",
        "price": 3593.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16076735209.html",
        "sold": 0
    },
    {
        "product_name": "후라이팬 팬 생선구이 캠핑 후라이팬 30cm",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4b6ab75fead2493595c5a55d8ce6d52b4.png_200x200q90.png",
        "price": 3587.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16109554497.html",
        "sold": 0
    },
    {
        "product_name": "[HOT SALE!] ชุดเครื่องครัว รุ่น C116AK-09 (ชุด 9 ชิ้น) สีดำ | ชุดเครื่องครัว เครื่องครัว ราคาถูก",
        "product_image": "https://img.lazcdn.com/g/p/d7209f59fa6cdb3958bb7aadb535b8c1.jpg_200x200q90.jpg",
        "price": 3586,
        "remark": "https://www.lazada.co.th/products/pdp-i3112834746.html",
        "sold": 0
    },
    {
        "product_name": "Camping Stainless Steel Bowl Portable Tableware Cookware 300Ml Sierra Cup Hiking Backpacking Camping Supplies TW3006",
        "product_image": "https://img.lazcdn.com/g/p/599c22346c7a904dc7d1863ae1c1587c.jpg_200x200q90.jpg",
        "price": 3586,
        "remark": "https://www.lazada.co.th/products/pdp-i16114291963.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike เซรามิคไม่ติดชุด กระทะแบบพกพา กลางแจ้งบนโต๊ะอาหารตั้งแคมป์เดินป่าชุดเครื่องครัว 4-7 คน CNK2450CF013",
        "product_image": "https://img.lazcdn.com/g/p/167bf3c5a275519151d135388188de41.jpg_200x200q90.jpg",
        "price": 3582,
        "remark": "https://www.lazada.co.th/products/pdp-i16114018889.html",
        "sold": 0
    },
    {
        "product_name": "QUECHUA ชุดเครื่องครัวสเตนเลส เคลือบผิวกันติด รุ่น MH500 สำหรับ 2 คน ขนาด 2.1 ลิตร ( Stainless Steel Camping Cook Set - 2.1L ) CAMPING TENTS เต็นท์ แคมป์ปิ้ง ตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/7a2d2112c0cad028ac0a1684c8ef68a1.jpg_200x200q90.jpg",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i3851484468.html",
        "sold": 1
    },
    {
        "product_name": "[HOT SALE!] หม้อสุกี้ - บาร์บีคิว รุ่น PG-165 ขนาด 2 ลิตร สีดำ - แดง | หม้อสุกี้ เครื่องครัว ราคาถูก",
        "product_image": "https://img.lazcdn.com/g/p/669accc6ce84d96b0dcf2345c2cde514.jpg_200x200q90.jpg",
        "price": 3578,
        "remark": "https://www.lazada.co.th/products/pdp-i3112823747.html",
        "sold": 0
    },
    {
        "product_name": "เซทเครื่องครัวตั้งแคมป์ ZYStar หม้อไฟชุดทำอาหารสำหรับตั้งแคมป์เครื่องใช้ในครัว Panci Camping กระทะทอดน้ำหนักเบาและกาต้มน้ำกระทะสำหรับทำอาหาร",
        "product_image": "https://img.lazcdn.com/g/p/82e2502e976d39eae27e70641cdfdaf3.jpg_200x200q90.jpg",
        "price": 3576,
        "remark": "https://www.lazada.co.th/products/pdp-i6016453772.html",
        "sold": 0
    },
    {
        "product_name": "เซทเครื่องครัวตั้งแคมป์ Kodaily กระทะทอดชุดทำอาหารตั้งแคมป์ที่มีน้ำหนักเบาที่จับพับกระทะ Panci Camping และกาต้มน้ำสำหรับการเดินป่าตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/d7ba35fbd576a50ed04fb5f8fb636a41.jpg_200x200q90.jpg",
        "price": 3576,
        "remark": "https://www.lazada.co.th/products/pdp-i16104517242.html",
        "sold": 0
    },
    {
        "product_name": "เซทเครื่องครัวตั้งแคมป์ Gociy,ตั้งแคมป์ชุดทำอาหารกระทะทอดที่จับพับที่มีน้ำหนักเบากระทะ Panci Camping และกาต้มน้ำสำหรับการเดินป่า,ตกปลา,",
        "product_image": "https://img.lazcdn.com/g/p/7b908f3c491f110e67edbc0dc75f5b27.jpg_200x200q90.jpg",
        "price": 3576,
        "remark": "https://www.lazada.co.th/products/pdp-i16104521800.html",
        "sold": 0
    },
    {
        "product_name": "เซทเครื่องครัวตั้งแคมป์ Hicaee ชุดทำอาหารสำหรับตั้งแคมป์ HANDEL Lipat สแตนเลสกระทะ Panci Camping และกาต้มน้ำสำหรับปิกนิกทำอาหาร",
        "product_image": "https://img.lazcdn.com/g/p/727a5a0f8f387a89409b14179961297e.jpg_200x200q90.jpg",
        "price": 3576,
        "remark": "https://www.lazada.co.th/products/pdp-i16110042539.html",
        "sold": 0
    },
    {
        "product_name": "TANGXU926926929 แผ่นรองกันลื่น ชุดอุปกรณ์ทำอาหารสำหรับตั้งแคมป์ สแตนเลสสตีล พร้อมถุงตาข่าย ชุดหม้อสำหรับตั้งแคมป์ ทนทาน เตาแก๊สพกพาสำหรับตั้งแคมป์ การทำอาหารกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/97ac1bd8f3908a6dea343baa119af6eb.jpg_200x200q90.jpg",
        "price": 3568,
        "remark": "https://www.lazada.co.th/products/pdp-i16143166987.html",
        "sold": 0
    },
    {
        "product_name": "KEQI ป้องกันลม แผ่นกันลมเตา พับสามตอน ขนาดกะทัดรัด กระจกหน้ารถเครื่องครัว เตาชา ผ้าสีพื้น ป้องกันลมเตา ครัวเรือน",
        "product_image": "https://img.lazcdn.com/g/p/2828a3d9b2cdff7368eccfcc8a0b7b50.jpg_200x200q90.jpg",
        "price": 3566.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16076558627.html",
        "sold": 0
    },
    {
        "product_name": "ที่รักชุดชามและแผ่นแสตนเลสสตีลตั้งแคมป์สำหรับเด็กทารกชุดรับประทานอาหารเครื่องครัวแคมปิ้งชุดภาชนะตั้งแคมป์สำหรับงานเลี้ยงบาร์บีคิวในบ้านการเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/88cdcee04c475a7a8dc03174a359f807.jpg_200x200q90.jpg",
        "price": 3548.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16103465037.html",
        "sold": 0
    },
    {
        "product_name": "Tiartisan | หม้อทำอาหารไทเทเนียมสำหรับกลางแจ้ง 2.1 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfccd8eb1d9954d0dbd5bfc2f1d094c08k.jpg_200x200q90.jpg",
        "price": 3548.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16049382299.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA-เซทเครื่องครัวตั้งแคมป์ชุดอุปกรณ์ทำอาหารสแตนเลสแบบพกพาสำหรับสำหรับปิคนิคตั้งค่ายกลางแจ้ง4-5คน",
        "product_image": "https://img.lazcdn.com/g/p/80dbc3c709237efdf80213f1e34d9c24.jpg_200x200q90.jpg",
        "price": 3542,
        "remark": "https://www.lazada.co.th/products/pdp-i5809173630.html",
        "sold": 0
    },
    {
        "product_name": "【Latest model】Cooking Accessories Set, Camping Tray, Outdoor Cookware Set Light Weight Open Flame Cooking Kit",
        "product_image": "https://img.lazcdn.com/g/p/23f593c21387ab9f8438c07d7f6f30ab.jpg_200x200q90.jpg",
        "price": 3536,
        "remark": "https://www.lazada.co.th/products/pdp-i16123765635.html",
        "sold": 0
    },
    {
        "product_name": "Tiartisan | ชุดเครื่องครัวแคมปิ้งไทเทเนียมสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1e9e45273c0c4651b9ad58230caed8f8a.jpg_200x200q90.jpg",
        "price": 3532.28,
        "remark": "https://www.lazada.co.th/products/pdp-i16048953995.html",
        "sold": 0
    },
    {
        "product_name": "GSI Bugaboo Square Frypan",
        "product_image": "https://img.lazcdn.com/g/p/58558135fa4dcf14c32c786f37794ef9.png_200x200q90.png",
        "price": 3520,
        "remark": "https://www.lazada.co.th/products/pdp-i4776897857.html",
        "sold": 0
    },
    {
        "product_name": "【Latest model】Outdoor Folding Pot Silicone Hiking Cooking Pot Portable Picnic Pot Stainless Steel Camping Cooker",
        "product_image": "https://img.lazcdn.com/g/p/e3c0950206a6dabba7f6e9ad643087cb.jpg_200x200q90.jpg",
        "price": 3520,
        "remark": "https://www.lazada.co.th/products/pdp-i16075232690.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแคมป์ปิ้ง เครื่องครัวพกพาน้ำหนักเบา สำหรับทำอาหารกลางแจ้ง 2-3 คน VH-TH",
        "product_image": "https://img.lazcdn.com/g/p/80703f887c338d4837eca04f937e8e23.jpg_200x200q90.jpg",
        "price": 3519,
        "remark": "https://www.lazada.co.th/products/pdp-i16084879249.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวแคมปิ้งเหมือนจริงแบบพกพาพร้อมชาม",
        "product_image": "https://img.lazcdn.com/g/p/f14a00587a3f00587cad664c4cbe45ed.jpg_200x200q90.jpg",
        "price": 3514.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16118985202.html",
        "sold": 0
    },
    {
        "product_name": "Tiartisan | ชุดหม้อสำหรับกลางแจ้งไทเทเนียม 2.1 ลิตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf2b8a44a27074775aa0f30864810b70a6.jpg_200x200q90.jpg",
        "price": 3509.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16049368433.html",
        "sold": 0
    },
    {
        "product_name": "Redchef ชุดเครื่องครัวเซรามิกเคลือบสารกันติด 9 ชิ้น พร้อมกระทะและฝาปิด ถอดด้ามจับได้",
        "product_image": "https://img.lazcdn.com/g/p/ddd2dc46ed811c91f35e39c39c0a4b45.jpg_200x200q90.jpg",
        "price": 3508,
        "remark": "https://www.lazada.co.th/products/pdp-i6017512634.html",
        "sold": 5
    },
    {
        "product_name": "Tiartisan | ชุดหม้อทำอาหารไทเทเนียมสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S28a013679c3d44c2a4c8b0e6eb3b96a4j.jpg_200x200q90.jpg",
        "price": 3507.66,
        "remark": "https://www.lazada.co.th/products/pdp-i16049420481.html",
        "sold": 0
    },
    {
        "product_name": "MONGDIO | ชุดหม้อมอคค่าพกพา วาล์วคู่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sff66fa1cd1aa40ff83d3e018844dcb00w.jpg_200x200q90.jpg",
        "price": 3504.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6066814274.html",
        "sold": 0
    },
    {
        "product_name": "Panci Camping หม้อสนาม Prasku อะลูมินัมอัลลอยภาคปฏิบัติสำหรับหม้ออาหารความร้อนแคมป์ไฟ5-6คนสำหรับบาร์บีคิวตกปลาเดินป่าสำรวจ",
        "product_image": "https://img.lazcdn.com/g/p/e5a4a27cffe8f57bc1e5a27e883164bf.jpg_200x200q90.jpg",
        "price": 3504,
        "remark": "https://www.lazada.co.th/products/pdp-i5973245540.html",
        "sold": 0
    },
    {
        "product_name": "หม้อ Montbell ALPINE COOKER SQUARE 12",
        "product_image": "https://img.lazcdn.com/g/p/14106bef89d4677f90097d893dca1778.jpg_200x200q90.jpg",
        "price": 3500,
        "remark": "https://www.lazada.co.th/products/pdp-i4264567266.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัวสเตนเลสเคลือบผิวกันติดสำหรับการตั้งแคมป์รุ่น MH 500 หม้อสนาม ชุดครัวสนาม หม้อเดินป่า ชุดเครื่องครัว หม้อแคมป์ปิ้ง ชุดหม้อสนาม หม้อตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/ac7ea2f0dcd57af75ec7db0862b941e3.jpg_200x200q90.jpg",
        "price": 3500,
        "remark": "https://www.lazada.co.th/products/pdp-i1434960855.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์กลางแจ้งน้ำหนักเบาพิเศษเต็นท์ขนาดเล็กกระทะทอดกระทะทอดตั้งแคมป์ครัวสำหรับทำอาหารสเต็กและซุป",
        "product_image": "https://img.lazcdn.com/g/p/0b87bdc477d9834bf96e44df28040679.jpg_200x200q90.jpg",
        "price": 3491.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16126597572.html",
        "sold": 0
    },
    {
        "product_name": "Pezhong กระทะทอดกลางแจ้งพับได้มือจับขนาดกะทัดรัดเครื่องครัวแคมปิ้งอุปกรณ์ทำอาหารพรีเมี่ยมสำหรับเต็นท์เตาแจ็ค",
        "product_image": "https://img.lazcdn.com/g/p/7eb9e5ef9a8b4d53fdaddd08377e8cb2.jpg_200x200q90.jpg",
        "price": 3491.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16127272515.html",
        "sold": 0
    },
    {
        "product_name": "WDEarth กระทะเครื่องครัวแคมปิ้งสำหรับใช้เดินทางเต็นท์พับได้กระทะทอดกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/406617dbef18c638191029e255396e43.jpg_200x200q90.jpg",
        "price": 3491.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16126819475.html",
        "sold": 0
    },
    {
        "product_name": "Gazechimp กระทะทอดไททาเนียมเครื่องใช้บนโต๊ะอาหารน้ำหนักเบาทำความสะอาดง่ายกระทะเครื่องครัวพร้อม HANDEL Lipat สำหรับการเดินทางในครัว",
        "product_image": "https://img.lazcdn.com/g/p/9e7346b3e8f2b279eaefaa13108c9ab2.jpg_200x200q90.jpg",
        "price": 3481.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16135899140.html",
        "sold": 0
    },
    {
        "product_name": "Teggry 4x ถ้วยสำหรับออกแคมป์ชามอาหารเย็นตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/651bfaafcff019210719e146b177eb59.jpg_200x200q90.jpg",
        "price": 3476.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16061527280.html",
        "sold": 0
    },
    {
        "product_name": "Fire-Maple | ชุดหม้อปรุงอาหารแบบพกพาไม่ติดกระทะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S67b9118f11e74c01891bbaa890d5e677P.jpg_200x200q90.jpg",
        "price": 3467.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16049149360.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA เครื่องครัวปิกนิกชุดเครื่องใช้สำหรับโต๊ะอาหารกลางแจ้งชุดอุปกรณ์ทานอาหารข้าวสาลีแบบพกพาพร้อมช้อนถ้วยปากกว้าง1ชุดพกพา1ชุด",
        "product_image": "https://img.lazcdn.com/g/p/d77f0880dc314b4d5911e7fe4d64839d.jpg_200x200q90.jpg",
        "price": 3466,
        "remark": "https://www.lazada.co.th/products/pdp-i5308762262.html",
        "sold": 0
    },
    {
        "product_name": "Livestyl กระทะเตาสำหรับเต็นท์ร้อนที่มีประสิทธิภาพกระทะทอดกลางแจ้ง,กระทะน้ำหนักเบาพิเศษสำหรับเตาและเครื่องครัวแคมปิ้ง",
        "product_image": "https://img.lazcdn.com/g/p/8efa70db5232db2b584477c8589c3c43.jpg_200x200q90.jpg",
        "price": 3460.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16125115440.html",
        "sold": 0
    },
    {
        "product_name": "Sunniiee กระทะทอดตั้งแคมป์สำหรับใช้ในครัวกลางแจ้งกระทะโลหะอเนกประสงค์เครื่องครัวน้ำหนักเบาสำหรับเต้นท์ร้อนกระทะทอดและแบกเป้",
        "product_image": "https://img.lazcdn.com/g/p/189d350b67d06c17000f2df3b6476868.jpg_200x200q90.jpg",
        "price": 3460.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16126838527.html",
        "sold": 0
    },
    {
        "product_name": "Bhuuno กระทะปีนเขาน้ำหนักเบากระจายความร้อนที่มีประสิทธิภาพกระทะทอดสำหรับใช้กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/1dec120321f438f78d80cad86aaccf83.jpg_200x200q90.jpg",
        "price": 3460.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16125605714.html",
        "sold": 0
    },
    {
        "product_name": "FeLike อุปกรณ์ทำอาหารกลางแจ้งแบบพกพากระทะทอดน้ำหนักเบามากเครื่องครัวแคมปิ้งทนทานสำหรับการเดินป่าผจญภัย",
        "product_image": "https://img.lazcdn.com/g/p/8efa70db5232db2b584477c8589c3c43.jpg_200x200q90.jpg",
        "price": 3460.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16125392711.html",
        "sold": 0
    },
    {
        "product_name": "ZYStar กระทะทอดตั้งแคมป์ในครัวกลางแจ้งอเนกประสงค์กระทะโลหะเครื่องครัวน้ำหนักเบาสำหรับกระทะทอดเต็นท์ร้อนและแบกเป้",
        "product_image": "https://img.lazcdn.com/g/p/75b1e46abe23a57f45f59d2f6e5780b7.jpg_200x200q90.jpg",
        "price": 3460.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16127174179.html",
        "sold": 0
    },
    {
        "product_name": "ZYEarth เต็นท์กลางแจ้งขนาดเล็กน้ำหนักเบามากกระทะทอดกระทะทอดตั้งแคมป์ครัวสำหรับทำอาหารสเต็กและซุป",
        "product_image": "https://img.lazcdn.com/g/p/13b1049a343f8e467e5986b4c552b2cb.jpg_200x200q90.jpg",
        "price": 3460.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16127022439.html",
        "sold": 0
    },
    {
        "product_name": "Prasku กระทะทอดตั้งแคมป์กระทะโลหะอเนกประสงค์สำหรับกระทะทอดเต็นท์ร้อน",
        "product_image": "https://img.lazcdn.com/g/p/e272196ad0ba85254770c79dbd4d0c34.jpg_200x200q90.jpg",
        "price": 3460.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16126252155.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA-FAPAO โลหะพกพาได้แผ่นตั้งแคมป์ความเข้มสูงจานถ้วยซุปพร้อมกระเป๋าตาข่ายอุปกรณ์ทานอาหารเบาพิเศษสำหรับตั้งแคมป์เดินป่าปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/dc6785934c81fdb1d0340f6ae21df2d6.jpg_200x200q90.jpg",
        "price": 3458,
        "remark": "https://www.lazada.co.th/products/pdp-i5936483978.html",
        "sold": 0
    },
    {
        "product_name": "กระทะแคมปิ้งไม่ติดกระทะ พร้อมด้ามจับถอดได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S33e8f292f27b41e9adcdca53738ad832i.jpg_200x200q90.jpg",
        "price": 3446.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16105091006.html",
        "sold": 0
    },
    {
        "product_name": "Fire-Maple | กระทะปิ้งย่างไม่ติดพื้นผิวพร้อมด้ามจับถอดได้สำหรับแคมป์ปิ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8bb97b7b29874cc3bb1f16945ef45d42p.jpg_200x200q90.jpg",
        "price": 3442.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16049500969.html",
        "sold": 0
    },
    {
        "product_name": "4pcs กระทะ หม้อ ชุดเครื่องครัวกระทะ 24cm หม้อนม พร้อมฝาปิด ใช้ได้กับเตาทุกประเภท",
        "product_image": "https://img.lazcdn.com/g/p/96b545a1e66864f407e733aab567f4e6.jpg_200x200q90.jpg",
        "price": 3427.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5466948401.html",
        "sold": 10
    },
    {
        "product_name": "Campingmoon | CAMPINGMOON CC-26 หม้อเหล็กคอมโพสิตสามชั้น 3.4 ลิตร ความจุขนาดใหญ่ เหมาะสำหรับเตาแม่เหล็กไฟฟ้า พร้อมฝาแก้วมองเห็นภายใน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3529498489db46a68c855a8fcac4cd18T.jpg_200x200q90.jpg",
        "price": 3427.44,
        "remark": "https://www.lazada.co.th/products/pdp-i16104802381.html",
        "sold": 0
    },
    {
        "product_name": "ถ้วยไทเทเนียมปิกนิกสีเทาออกแบบตามหลักสรีรศาสตร์มาพร้อมกับฝาครอบกันฝุ่น",
        "product_image": "https://img.lazcdn.com/g/p/5db7ef613239028317b1d0dcca855d31.jpg_200x200q90.jpg",
        "price": 3412,
        "remark": "https://www.lazada.co.th/products/pdp-i6023315082.html",
        "sold": 0
    },
    {
        "product_name": "เซทเครื่องครัวตั้งแคมป์ Ulight มีด้ามจับพับได้อุปกรณ์ทำอาหารบาร์บีคิวอเนกประสงค์กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/5a92857314ab2da40e8b33ea8f8668cb.jpg_200x200q90.jpg",
        "price": 3406,
        "remark": "https://www.lazada.co.th/products/pdp-i16051048897.html",
        "sold": 0
    },
    {
        "product_name": "แบบพกพาพับไม่ติดกระทะตั้งแคมป์ชุดเครื่องครัวการออกแบบที่มีน้ำหนักเบาสำหรับการปรุงอาหารกลางแจ้ง RTF-TH",
        "product_image": "https://img.lazcdn.com/g/p/07915249c163e5cf8205df7c3f25e580.jpg_200x200q90.jpg",
        "price": 3402,
        "remark": "https://www.lazada.co.th/products/pdp-i16084821209.html",
        "sold": 0
    },
    {
        "product_name": "หม้อสแตนเลสลวกเส้นก๋วยเตี๋ยวแบบ4ช่อง หม้อนึ่งติ่มซำ🍜",
        "product_image": "https://img.lazcdn.com/g/p/efa59154901887b6ebcbf4dabd7c6561.jpg_200x200q90.jpg",
        "price": 3400,
        "remark": "https://www.lazada.co.th/products/pdp-i6049959578.html",
        "sold": 0
    },
    {
        "product_name": "Tefal  So Matcha รุ่น G179S495 เซ็ตเครื่องครัว 4 ชิ้น  ก้นอินดักชั่น  : กระทะก้นลึก 30 ซม.  พร้อมฝา และหม้อด้าม 18 ซม. พร้อมฝา  รับประกัน 2 ปี",
        "product_image": "https://img.lazcdn.com/g/p/2fca2a553e742e78a18fec96f5b5def1.jpg_200x200q90.jpg",
        "price": 3398,
        "remark": "https://www.lazada.co.th/products/pdp-i5815829516.html",
        "sold": 0
    },
    {
        "product_name": "Redchef Sea Series ชุดเครื่องครัวเซรามิกเคลือบสารกันติด 7 ชิ้น ปราศจากสาร PFAS และ PTFE และ PFОA เหมาะสำหรับเตาทุกประเภท กระทะแบบจีน กระทะแบบเหนี่ยวนำ ฝา หม้อ หม้อซอส เครื่องครัว ของขวัญปีใหม่",
        "product_image": "https://img.lazcdn.com/g/p/c421419a7e8c8c9849291fa875bea282.jpg_200x200q90.jpg",
        "price": 3398,
        "remark": "https://www.lazada.co.th/products/pdp-i5930173977.html",
        "sold": 29
    },
    {
        "product_name": "ชุดเครื่องครัวแคมป์ปิ้งน้ำหนักเบาแบบพกพาสำหรับทำอาหารกลางแจ้ง 2-3 คน D4-TH",
        "product_image": "https://img.lazcdn.com/g/p/7da9071f3349e4f98e1dc4beada6d585.jpg_200x200q90.jpg",
        "price": 3396,
        "remark": "https://www.lazada.co.th/products/pdp-i16075238300.html",
        "sold": 0
    },
    {
        "product_name": "BSWOLF | ชุดครัวพกพาสำหรับแคมปิ้งกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S489c4e81b2fe476284d21abafd4e27e4k.jpg_200x200q90.jpg",
        "price": 3390.16,
        "remark": "https://www.lazada.co.th/products/pdp-i6013944624.html",
        "sold": 6
    },
    {
        "product_name": "CAROTE | หม้อตุ๋นเหล็กหล่อเคลือบกันติด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scd6bb8ea65244013a6573388483184fdG.png_200x200q90.png",
        "price": 3366.46,
        "remark": "https://www.lazada.co.th/products/pdp-i5892789198.html",
        "sold": 733
    },
    {
        "product_name": "หม้อก๋วยเตี๋ยวไร้สารตะกั่ว ตราม้าลาย Chef ขนาด 30 ซม., 36 ซม., 40 ซม., 45 ซม., 50 ซม., / 1 ช่อง / 2 ช่อง / 3 ช่อง ของแท้ ส่งเร็ว ส่งไว มีห่อกันกระแทก",
        "product_image": "https://img.lazcdn.com/g/p/ffcd0dcbed5c2419c44fa1064c86436a.jpg_200x200q90.jpg",
        "price": 3358,
        "remark": "https://www.lazada.co.th/products/pdp-i2332296909.html",
        "sold": 15
    },
    {
        "product_name": "CAROTE | ชุดเครื่องครัวเคลือบสารกันติด 3 ชิ้นสำหรับใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sff55c1da97f844cba2283846074b1f58M.jpg_200x200q90.jpg",
        "price": 3356,
        "remark": "https://www.lazada.co.th/products/pdp-i5893695997.html",
        "sold": 75
    },
    {
        "product_name": "Kitchen Utensils Set in 18/10 Stainless Steel-All Metal 15\" Cooking Tools with Countertop Rotating Holder Stand",
        "product_image": "https://img.lazcdn.com/g/p/13bf78c66bc6e890d85febbc12144ff4.jpg_200x200q90.jpg",
        "price": 3312,
        "remark": "https://www.lazada.co.th/products/pdp-i16097755336.html",
        "sold": 0
    },
    {
        "product_name": "COOKER KING | ชุดเครื่องครัวสแตนเลส 316L ด้ามจับไม่ร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7e4dad9a7f35405ab59a498976946be9E.jpg_200x200q90.jpg",
        "price": 3350,
        "remark": "https://www.lazada.co.th/products/pdp-i16110460731.html",
        "sold": 92
    },
    {
        "product_name": "หม้อทำอาหารอเนกประสงค์ไททาเนียม Keith Ti6300",
        "product_image": "https://img.lazcdn.com/g/p/f90a2a568ba6100e3806eba3ee53df9e.png_200x200q90.png",
        "price": 3340,
        "remark": "https://www.lazada.co.th/products/pdp-i156399717.html",
        "sold": 24
    },
    {
        "product_name": "Moon TRIANGLE หม้ออาหารกระทะทอดไทเทเนียมพร้อม HANDEL Lipat สำหรับการเดินทางแบกเป้ค้างแรมอุปกรณ์กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/0397d428e1509f86f93c1c48f58971cb.jpg_200x200q90.jpg",
        "price": 3336,
        "remark": "https://www.lazada.co.th/products/pdp-i5973261718.html",
        "sold": 0
    },
    {
        "product_name": "หมอตมนำขนาดเลกแบบพกพา วสดสแตนเลส 304 ใชไดหลากหลาย เหมาะสำหรบแคมปปง ใชกบเตา IH ได",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sddd50aa92c2c413d9845fded35f5ac1cd.png_200x200q90.png",
        "price": 3323.28,
        "remark": "https://www.lazada.co.th/products/pdp-i16109873660.html",
        "sold": 0
    },
    {
        "product_name": "ชุดอุปกรณ์ทานอาหารเครื่องครัวแคมปิ้ง1.4L หม้อ0.7L และชุดกระทะพร้อมกระเป๋าเก็บของสำหรับเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/24b8fd75e21b68c2702f254f1ba8a0a0.jpg_200x200q90.jpg",
        "price": 3322,
        "remark": "https://www.lazada.co.th/products/pdp-i6001887933.html",
        "sold": 0
    },
    {
        "product_name": "ชุดหม้อ 0.95L กระทะ 600ml ไททาเนียม Keith Ti6016",
        "product_image": "https://img.lazcdn.com/live/th/p/c952eb3262bd974da991431ee829901a.jpg_200x200q90.jpg",
        "price": 3318,
        "remark": "https://www.lazada.co.th/products/pdp-i154107315.html",
        "sold": 0
    },
    {
        "product_name": "Blesiya อุปกรณ์ทำอาหารกระทะทอดสำหรับตั้งแคมป์,เครื่องครัวไม่ติดเครื่องใช้บนโต๊ะอาหารน้ำหนักเบากระทะทอดตั้งแคมป์สำหรับตกปลาในร่มกิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/2125ef5c7605d036c0a184f5cb006a6f.jpg_200x200q90.jpg",
        "price": 3316,
        "remark": "https://www.lazada.co.th/products/pdp-i5971443087.html",
        "sold": 0
    },
    {
        "product_name": "Koolsoo กระทะทอดสำหรับตั้งแคมป์พร้อมฝาปิดอุปกรณ์หม้อหุงข้าวแบบไม่ติดหม้อน้ำหนักเบากระทะแบนสำหรับกลางแจ้งในร่มตกปลาทำอาหารปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/6b8e3749a6a8f7d3d0c68206612a9648.jpg_200x200q90.jpg",
        "price": 3316,
        "remark": "https://www.lazada.co.th/products/pdp-i5965810965.html",
        "sold": 0
    },
    {
        "product_name": "Campingmoon | CAMPINGMOON BKSW-6 หม้อแคมป์ปิ้งสเตนเลสสตีลเคลือบไทเทเนียม หม้อกาแฟแบบพกพาสำหรับกิจกรรมกลางแจ้ง กาต้มน้ำสำหรับชงชา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se9852fa82a734e24bac19617d02ec1f78.jpg_200x200q90.jpg",
        "price": 3315.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16104702713.html",
        "sold": 0
    },
    {
        "product_name": "LS2G HOT Outdoor Folding Pot Silicone Hiking Cooking Pot Portable Picnic Pot Stainless Steel Camping Cooker",
        "product_image": "https://img.lazcdn.com/g/p/e3c0950206a6dabba7f6e9ad643087cb.jpg_200x200q90.jpg",
        "price": 3314,
        "remark": "https://www.lazada.co.th/products/pdp-i16087850671.html",
        "sold": 0
    },
    {
        "product_name": "BSWOLF | ชุดเครื่องครัวสำหรับแคมปิ้งนอก trời",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S65fa343e3d8f4192a1e78f30d23f3ca9a.jpg_200x200q90.jpg",
        "price": 3305.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16107884502.html",
        "sold": 0
    },
    {
        "product_name": "ดไซนสวยงาม เหมาะสำหรบการตงแคมป",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7090807badfa40f3b2a54a89fc55cca76.jpg_200x200q90.jpg",
        "price": 3305.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16072979814.html",
        "sold": 0
    },
    {
        "product_name": "BSWOLF | ชุดหม้อและกระทะสำหรับทำอาหารแคมปิ้งกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb8d24816ce02451c914ad516dca92bf7H.jpg_200x200q90.jpg",
        "price": 3305.28,
        "remark": "https://www.lazada.co.th/products/pdp-i6013958749.html",
        "sold": 0
    },
    {
        "product_name": "CAROTE | ชุดกระทะไม่ติด 3 ชิ้นพร้อมด้ามจับถอดได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6f5c1110990548c7977a73e6768d6b55O.png_200x200q90.png",
        "price": 3304.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5892066156.html",
        "sold": 28
    },
    {
        "product_name": "Ellwewe หม้อซุปตั้งแคมป์แบบพกพาน้ำหนักเบามาก Panci Camping อุปกรณ์เสริมสำหรับบาร์บีคิวเพื่อความอยู่รอดปิคนิคเดินป่าท่องเที่ยว",
        "product_image": "https://img.lazcdn.com/g/p/6c2a91cb8383154506eac273e708847c.jpg_200x200q90.jpg",
        "price": 3304,
        "remark": "https://www.lazada.co.th/products/pdp-i16122000571.html",
        "sold": 0
    },
    {
        "product_name": "HENGI ป้องกันลม แผ่นกันลมเตา พับสามตอน ขนาดกะทัดรัด ป้องกันลมเตา พร้อมถุงเก็บของ น้ำหนักเบา กระจกหน้ารถเครื่องครัว ครัวเรือน",
        "product_image": "https://img.lazcdn.com/g/p/b18331ae85fcf67bbf1b1c3077498926.jpg_200x200q90.jpg",
        "price": 3301.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16076536638.html",
        "sold": 0
    },
    {
        "product_name": "ชุด Solo cooking วัสดุ​Stanless ยี่ห้อCampingmoon พร้อมส่งจากไทย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sffa03d02f5674a409d75bb00d61e5e46i.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i3390869556.html",
        "sold": 0
    },
    {
        "product_name": "EPNER แผ่นรองกันลื่น ชุดอุปกรณ์ทำอาหารสำหรับตั้งแคมป์ พร้อมถุงตาข่าย สแตนเลสสตีล ชุดหม้อสำหรับตั้งแคมป์ ทนทาน เตาแก๊สพกพาสำหรับตั้งแคมป์ การทำอาหารกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/31ffc531fdd42a71a2dea12386d7abbd.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i16143449370.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA เครื่องใช้ในแก้วน้ำแบบพกพาจานอาหารขนาด450มล. 800มล. สำหรับ1คนเครื่องใช้ในครัว3ชิ้นเครื่องใช้ในครัว1ชุดช้อนถ้วยจานอาหารขนาด800มล.",
        "product_image": "https://img.lazcdn.com/g/p/8d933f5cfba8182dc12caa88e44b8fbc.jpg_200x200q90.jpg",
        "price": 3296,
        "remark": "https://www.lazada.co.th/products/pdp-i5518758924.html",
        "sold": 0
    },
    {
        "product_name": "WDAir หม้อเครื่องครัวแคมปิ้งอลูมิเนียมแบบพกพาพร้อมฝาปิดหม้อซุปสำหรับการเดินทางกีฬาเดินป่าตั้งแคมป์กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/82b50b32d232b91edc900cebeefa2c56.jpg_200x200q90.jpg",
        "price": 3294,
        "remark": "https://www.lazada.co.th/products/pdp-i5967006787.html",
        "sold": 0
    },
    {
        "product_name": "หม้อหม้อซุปเครื่องครัวแคมปิ้ง CCPlanet",
        "product_image": "https://img.lazcdn.com/g/p/0eda42b320d40ccf7275f6740a96d6ad.jpg_200x200q90.jpg",
        "price": 3294,
        "remark": "https://www.lazada.co.th/products/pdp-i6003537474.html",
        "sold": 0
    },
    {
        "product_name": "Lixada ชุดเครื่องครัวปิกนิกแบบพกพา,Set Alat Masak เดินป่าตั้งแคมป์กลางแจ้งหม้อกระทะทอดชุดกาต้มน้ำอุปกรณ์ทำอาหารเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/8ea920a42d6b82dbef488c398e3719c2.png_200x200q90.png",
        "price": 3288,
        "remark": "https://www.lazada.co.th/products/pdp-i4721691204.html",
        "sold": 0
    },
    {
        "product_name": "หัวจับมัฟฟินแบบหนีบสำหรับมัฟฟินนอกบ้าน,ที่หนีบมัฟฟินแบบหนีบสำหรับมัฟฟินที่หนีบปิกนิกกระทะแซนด์วิชแซนวิช",
        "product_image": "https://img.lazcdn.com/g/p/6a51c7786acbfcdfb0d66fbf613ae293.jpg_200x200q90.jpg",
        "price": 3282,
        "remark": "https://www.lazada.co.th/products/pdp-i5640612848.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA-3L Panci Camping 304สแตนเลสโลหะพกพาได้เครื่องครัวแคมปิ้งหม้อหุงข้าวสำหรับทำอาหารเดินป่ากลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/2228dda1e5b8064c84547bd9c71d774b.jpg_200x200q90.jpg",
        "price": 3278,
        "remark": "https://www.lazada.co.th/products/pdp-i5885385186.html",
        "sold": 0
    },
    {
        "product_name": "1/2/3Pcs Camping Stainless Steel Small Dish Outdoor Cooking Tableware Sierra Cup Cookware Picnic Camping Supplies",
        "product_image": "https://img.lazcdn.com/g/p/4b0923f4296d689da7941710b58edaf0.jpg_200x200q90.jpg",
        "price": 3272,
        "remark": "https://www.lazada.co.th/products/pdp-i16114662328.html",
        "sold": 0
    },
    {
        "product_name": "Aluminum Nonstick Camping Cookware Set Portable Outdoor Kettle Pot Cookset Cooking Pan Bowl Tableware for Hiking",
        "product_image": "https://img.lazcdn.com/g/p/034b9f1c0853175d5a1a0de8d52f48a7.jpg_200x200q90.jpg",
        "price": 3272,
        "remark": "https://www.lazada.co.th/products/pdp-i16142702404.html",
        "sold": 0
    },
    {
        "product_name": "ชุดหม้อเหล็กหล่อเคลือบสาร 7 ชิ้น รวมกระทะทอด กระทะแบน หม้อตุ๋น หม้อซีฟู้ด",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S19f1f0cbb0e847ecbf475c2ffcf4ac8e5.jpg_200x200q90.jpg",
        "price": 3261.32,
        "remark": "https://www.lazada.co.th/products/pdp-i6079082303.html",
        "sold": 2
    },
    {
        "product_name": "ชุดหม้อกระทะไทเทเนียม 3 ชิ้น Keith Ti6053 หนัก243 กรัม",
        "product_image": "https://img.lazcdn.com/g/p/a7c56f3cde281b80e303bf948663cd10.jpg_200x200q90.jpg",
        "price": 3254,
        "remark": "https://www.lazada.co.th/products/pdp-i3788656691.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA-กล่องอาหารกลางวัน Fangzi ชุดอุปกรณ์ทานอาหารเครื่องครัว4ชิ้นกล่องแค๊มปิ๊งมื้อเที่ยงขนาด800มล. พร้อมเตาชั้นนึ่งเขียงสำหรับกระเป๋าเป้ปีนเขาการตกปลาการปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/4a6f3b0f83aa5bb59cca0f658ed922c9.jpg_200x200q90.jpg",
        "price": 3248,
        "remark": "https://www.lazada.co.th/products/pdp-i5948784192.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกระทะกลางแจ้ง8ชิ้นสแตนเลสหม้อซ้อนหม้อสำหรับเดินป่าเครื่องครัวแคมปิ้งไม่ติดชามทำอาหารปิกนิกชุดหม้อ",
        "product_image": "https://img.lazcdn.com/g/p/da107bb6519db5a2c8e54b2d00f83528.jpg_200x200q90.jpg",
        "price": 3234,
        "remark": "https://www.lazada.co.th/products/pdp-i6077116558.html",
        "sold": 0
    },
    {
        "product_name": "FeLike เครื่องใช้บนโต๊ะอาหารสำหรับชุดอุปกรณ์ทานอาหารค่ำ,เครื่องใช้บนโต๊ะอาหารสำหรับใช้ซ้ำได้จำนวน48ชิ้นช้อนสำหรับเดินทางสำหรับงานเลี้ยงอาหารค่ำตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/1608886d248a2725226e566e838dd3f9.jpg_200x200q90.jpg",
        "price": 3226.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16049524604.html",
        "sold": 0
    },
    {
        "product_name": "Satsmoon หม้อตุ๋นเครื่องครัวแคมปิ้งสำหรับทำอาหารกลางแจ้งหม้อเคี่ยวหม้อตุ๋นหม้อทำครัวสต็อกหม้อพร้อมฝา Panci Camping สำหรับปิกนิก",
        "product_image": "https://img.lazcdn.com/g/p/4218f7e211851e475fab1b6623fc6a3c.jpg_200x200q90.jpg",
        "price": 3222.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16057637077.html",
        "sold": 0
    },
    {
        "product_name": "ชุดหม้อแคมป์ปิ้งชุดหม้อแคมป์ปิ้ง ขนาดพกพาสะดวก จัดเก็บง่าย K2 COOKER ชุดหม้อแคมป์ปิ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb659963209434b53a4c19c7fe55d6b8b3.jpg_200x200q90.jpg",
        "price": 3220,
        "remark": "https://www.lazada.co.th/products/pdp-i3263670265.html",
        "sold": 4
    },
    {
        "product_name": "Gazechimp อุปกรณ์กาต้มน้ำน้ำกาน้ำพกพาเครื่องดื่มทำความสะอาดง่ายเครื่องครัวพกพาที่มีฝาปิด1ลิตรสำหรับการปีนเขากิจกรรมกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/b5f5f7dd8357fee8c29c8e5f7735834c.jpg_200x200q90.jpg",
        "price": 3216,
        "remark": "https://www.lazada.co.th/products/pdp-i16070386686.html",
        "sold": 0
    },
    {
        "product_name": "พร้อมจานช้อนชุดสูทจานบนโต๊ะอาหาร4ชิ้นจานกลางแจ้งจานช้อนปิคนิคกลางแจ้งชุดจาน3ชิ้นจานบาร์บีคิวจานบาร์บีคิวชุดจานสลัดโลหะ3ชุดจานสลัด",
        "product_image": "https://img.lazcdn.com/g/p/3900b8579daeb2475d53e80a0683f590.jpg_200x200q90.jpg",
        "price": 3202,
        "remark": "https://www.lazada.co.th/products/pdp-i5640567787.html",
        "sold": 0
    },
    {
        "product_name": "GSI Crossover Kitchen Kit#ชุดทำครัว 12 ชิ้นเก็บเล็กน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/36296e9fa37da8c2155846960737dd94.jpg_200x200q90.jpg",
        "price": 3200,
        "remark": "https://www.lazada.co.th/products/pdp-i981926971.html",
        "sold": 0
    },
    {
        "product_name": "Ecowin กระทะถอดด้ามได้ 4ชิ้น กระทะทำอาหารในครัวเรือน เซตเครื่องครัว ของใช้ในครัว ใช้ได้ทุกเตา ของดีบอกต่อ",
        "product_image": "https://img.lazcdn.com/g/p/fb13c3a4fddcbaa8955f2f1781631b65.jpg_200x200q90.jpg",
        "price": 3198,
        "remark": "https://www.lazada.co.th/products/pdp-i5851813208.html",
        "sold": 1
    },
    {
        "product_name": "NatureHike เซรามิคไม่ติดชุด ที่เก็บหม้อและกระทะแบบพกพา กลางแจ้งบนโต๊ะอาหารตั้งแคมป์เดินป่าชุดเครื่องครัว 4 in 1 ปิคนิคสำหรับ 4-7 คน",
        "product_image": "https://img.lazcdn.com/g/p/496b0d60b7318e20d962238a9f6b0a6b.jpg_200x200q90.jpg",
        "price": 3198,
        "remark": "https://www.lazada.co.th/products/pdp-i5906712683.html",
        "sold": 0
    },
    {
        "product_name": "🔥พร้อมส่ง🔥 QUECHUA เครื่องครัวสนาม สเตนเลส เคลือบผิวกันติด สำหรับ 1-4 คน ขนาดกะทัดรัด ทนทาน ดูแลรักษาง่าย ของแท้100%",
        "product_image": "https://img.lazcdn.com/g/p/884bbdefca066e4e6ecade0dfd51f92c.jpg_200x200q90.jpg",
        "price": 3198,
        "remark": "https://www.lazada.co.th/products/pdp-i4446050256.html",
        "sold": 2
    },
    {
        "product_name": "TOMSHOO Huiop เครื่องครัว Mewmewcat,ถ้วยอลูมิเนียมกลางแจ้ง Kocan Eryue อุปกรณ์ตั้งแคมป์ Bbq ปิกนิกบนโต๊ะอาหารพร้อมแผงอัลลอยด์ Braet ปิกนิก Iuppa Okware ที่ตั้งแคมป์ Sto Siuke Buzhi Dsfen Xiaoxin",
        "product_image": "https://img.lazcdn.com/g/p/8a8f0a0a938e7c3fdbfc5fdcf948326f.jpg_200x200q90.jpg",
        "price": 3198,
        "remark": "https://www.lazada.co.th/products/pdp-i5147625039.html",
        "sold": 0
    },
    {
        "product_name": "Chunkbass】พร้อมที่จับกล่องอาหารโลหะโบราณและกล่องปิกนิกสลัก9.5L กล่องเก็บกระบอกน้ำอาหารและเครื่องดื่ม",
        "product_image": "https://img.lazcdn.com/g/p/c00aee87b76a7ae6d3085effa5adc523.jpg_200x200q90.jpg",
        "price": 3196,
        "remark": "https://www.lazada.co.th/products/pdp-i16136051045.html",
        "sold": 0
    },
    {
        "product_name": "พร้อมที่จับกล่องอาหารกลางวันโลหะโบราณและสลักภาชนะโลหะย้อนยุคร้านค้าอาหารและเครื่องดื่มกระบอกน้ำ",
        "product_image": "https://img.lazcdn.com/g/p/55730946917fff244509619b6bb7d8fb.jpg_200x200q90.jpg",
        "price": 3196,
        "remark": "https://www.lazada.co.th/products/pdp-i16135969036.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องครัว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5c9b7c4bba564b0a8dde8fb100ae77f6a.jpg_200x200q90.jpg",
        "price": 3191.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16109872138.html",
        "sold": 0
    },
    {
        "product_name": "Gazechimp Panci Camping สแตนเลสหม้อสนาม4เพื่อทำความสะอาดไม่ติดที่มีฝาปิดหม้อสต็อคสำหรับบาร์บีคิวปิกนิกท่องเที่ยว",
        "product_image": "https://img.lazcdn.com/g/p/2e3d898041d2069058ba8d0758efc1fb.jpg_200x200q90.jpg",
        "price": 3188,
        "remark": "https://www.lazada.co.th/products/pdp-i16063543958.html",
        "sold": 0
    },
    {
        "product_name": "Pure Titanium Frying Pan, Portable Plate, Suitable for Outdoor Camping, Hiking and Picnicking- Food ContainerNew Year Special",
        "product_image": "https://img.lazcdn.com/g/p/53b67380bb9c72f6a786b0a845565c12.jpg_200x200q90.jpg",
        "price": 3186,
        "remark": "https://www.lazada.co.th/products/pdp-i16105512637.html",
        "sold": 0
    },
    {
        "product_name": "Keith Titanium Fry Pan Ti6034 กระทะไทเทเนียม กระทะแคมป์ปิ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S31b90e25a8aa4dbeb84cca62e73cf26cH.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5813927803.html",
        "sold": 0
    },
    {
        "product_name": "หม้อทำข้าวเกรียบปากหม้อ หม้อนึ่งแสตนเลส ไซส์จัมโบ้ ขนาด39ซม. (มีให้เลือกทั้งหมด4ขนาด)",
        "product_image": "https://img.lazcdn.com/g/p/mdc/d40b256d82bdd04a77643dbbaf6103d2.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i399762124.html",
        "sold": 10
    },
    {
        "product_name": "ชุดเครื่องครัวแคมป์ปิ้งไทเทเนียม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa836ec5e91ac4ff49dd1e2ddeec3922f8.jpg_200x200q90.jpg",
        "price": 3177.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16118117332.html",
        "sold": 0
    },
    {
        "product_name": "แบบพกพาพับไม่ติดกระทะตั้งแคมป์เครื่องครัวชุดน้ำหนักเบาสำหรับทำอาหารกลางแจ้ง VH-TH",
        "product_image": "https://img.lazcdn.com/g/p/495c46b5aab5bb2414088ee0e6452606.jpg_200x200q90.jpg",
        "price": 3177,
        "remark": "https://www.lazada.co.th/products/pdp-i16084800243.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO จานบนโต๊ะอาหารจานชุดสูทจานสลัดพร้อมจานบาร์บีคิวจานบาร์บีคิวแผ่นโลหะ3ชิ้นกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/3900b8579daeb2475d53e80a0683f590.jpg_200x200q90.jpg",
        "price": 3174,
        "remark": "https://www.lazada.co.th/products/pdp-i5507503589.html",
        "sold": 0
    },
    {
        "product_name": "FORUM ตลก ชุดสุนัขไส้กรอกเป่าลม การ์ตูน ชุดจั๊มสูทเต็มตัว ชุดเป่าลมสุนัขไส้กรอกน่ารัก ชุดตุ๊กตา ป้องกันน้ำ ชุดสุนัขเป่าลมรูปไส้กรอก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/0df774d4487854034089d7d46f1ee835.png_200x200q90.png",
        "price": 6858.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16135951380.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกีฬามวยแบบพรีเมียมส่วนตัวที่มีประกายวิบวับ ซีรีส์ Star-Shine",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S952effae60124460a2dfefadb88fb6cbi.png_200x200q90.png",
        "price": 6375.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16076607129.html",
        "sold": 0
    },
    {
        "product_name": "กระดานหน่วยพกพาได้อะคริลิคใสกระดานโต๊ะ IGT ของใช้บนโต๊ะ",
        "product_image": "https://img.lazcdn.com/g/p/8213045efa8f34d99e6f18af3e22b596.jpg_200x200q90.jpg",
        "price": 5950,
        "remark": "https://www.lazada.co.th/products/pdp-i16124831877.html",
        "sold": 0
    },
    {
        "product_name": "QIANSEPENG | เต็นท์ผีเสื้อทรงแปดเหลี่ยมพกพาได้ พร้อมโลโก้ส่วนตัวสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S76f5ca786bcc44baaf95d485b68e8428A.jpg_200x200q90.jpg",
        "price": 5695.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16098016036.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์ส่วนตัวกลางแจ้งสำหรับอาบน้ำและเปลี่ยนระหว่างการตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/31a6d5ca3d19109303f2173f93f407b6.jpg_200x200q90.jpg",
        "price": 5480,
        "remark": "https://www.lazada.co.th/products/pdp-i16122924051.html",
        "sold": 0
    },
    {
        "product_name": "LUTUMEI | หม้อไฟส่วนตัวสำหรับคนเดียว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf54069917b384c26956aca3ba469bfb86.png_200x200q90.png",
        "price": 5306,
        "remark": "https://www.lazada.co.th/products/pdp-i6026156495.html",
        "sold": 0
    },
    {
        "product_name": "QINBAOSHUIJING | คอลเลกชันส่วนตัวระดับพรีเมียม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S43bafe3d76384f148e7c0bd3db4b2216U.jpg_200x200q90.jpg",
        "price": 5264.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5951785932.html",
        "sold": 2
    },
    {
        "product_name": "เว็บแคม30fps คอมพิวเตอร์ USB กล้องเว็บแคมติดตั้งได้ง่าย1080P พร้อมหน้าปกส่วนตัวสำหรับการถ่ายทอดสดวิดีโอ",
        "product_image": "https://img.lazcdn.com/g/p/938477f00341728995db89b956b69da6.jpg_200x200q90.jpg",
        "price": 3428,
        "remark": "https://www.lazada.co.th/products/pdp-i5832215386.html",
        "sold": 0
    },
    {
        "product_name": "MAIDALING | แผ่นพื้นหลังตกแต่งวันเกิด สร้างบรรยากาศ ของใช้วันเกิดแรกสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S77af3dbfa6f3478f9e5660c31b5c502fI.png_200x200q90.png",
        "price": 3363.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16053165267.html",
        "sold": 0
    },
    {
        "product_name": "Chiwanji เหยือกถุงใส่ของใช้ซ้ำได้อเนกประสงค์แบบพกพามีมีฝาเกลียวถังน้ำที่เก็บน้ำ PC สำหรับเดินป่าดื่มน้ำ RV",
        "product_image": "https://img.lazcdn.com/g/p/ab42703ee369a15831fab187dfefb2e9.jpg_200x200q90.jpg",
        "price": 2810,
        "remark": "https://www.lazada.co.th/products/pdp-i6075099962.html",
        "sold": 0
    },
    {
        "product_name": "RIRIANN เตาแบบพกพา เตาแก๊สแคมปิ้ง น้ำหนักเบามาก สีกากีเชิ๊ต เตาตั้งแคมป์พับได้ เครื่องมือทำบาร์บีคิว ของใช้ในครัวเรือน เตาตั้งแคมป์กลางแจ้ง แบกเป้สะพายหลัง",
        "product_image": "https://img.lazcdn.com/g/p/9a5d33b04446352579f2a8702ae5aca6.jpg_200x200q90.jpg",
        "price": 2796,
        "remark": "https://www.lazada.co.th/products/pdp-i16141751839.html",
        "sold": 0
    },
    {
        "product_name": "MANNYI สีกากีเชิ๊ต เตาแก๊สแคมปิ้ง เตาแบบพกพา น้ำหนักเบามาก เตาบิวเทนสำหรับตั้งแคมป์ เตาทำอาหารทำอาหาร ของใช้ในครัวเรือน เตาตั้งแคมป์กลางแจ้ง แบกเป้สะพายหลัง",
        "product_image": "https://img.lazcdn.com/g/p/3ab8fb6d50e690dcba72acb843947946.jpg_200x200q90.jpg",
        "price": 2796,
        "remark": "https://www.lazada.co.th/products/pdp-i16141869087.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสำหรับกอล์ฟ honma กระเป๋าถือคุณภาพสูงแบบยูนิเซ็กส์ กันน้ำและทนต่อการสึกหรอ กระเป๋าใส่ลูกบอลขนาดเล็กสำหรับกีฬากลางแจ้ง กระเป๋าใส่ของใช้ส่วนตัว",
        "product_image": "https://img.lazcdn.com/g/p/7fdaa0d60575e618505d67a9909d2f3d.jpg_200x200q90.jpg",
        "price": 2759.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16147434997.html",
        "sold": 0
    },
    {
        "product_name": "กล่องอเนกประสงค์ตกปลาคาร์พฟีโนโวเคสใส่ของใช้ได้จริงสำหรับคลิปยางเฟืองท่อ",
        "product_image": "https://img.lazcdn.com/g/p/918c069123cab557bc1db18fe8e1868e.jpg_200x200q90.jpg",
        "price": 2704,
        "remark": "https://www.lazada.co.th/products/pdp-i5989101311.html",
        "sold": 0
    },
    {
        "product_name": "ลูกกอล์ฟพร้อมโลโก้ส่วนตัวสำหรับของขวัญระลึก Hole-in-One พร้อมกล่อง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6b222ef9f677447093a1eee2d5b8db69r.jpg_200x200q90.jpg",
        "price": 2622.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16091354485.html",
        "sold": 0
    },
    {
        "product_name": "SRAITH ชาร์จผ่าน USB ได้ คั้นน้ำผลไม้ไฟฟ้า ไร้สาย จอแสดงผลไฟฟ้า ที่บดน้ำแข็ง ของใช้ในครัว กำลังสูง ปั่นสมูทตี้ ใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/44f9024ffc778a12ca78185d1b7781ed.jpg_200x200q90.jpg",
        "price": 2616.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16090968537.html",
        "sold": 0
    },
    {
        "product_name": "BLACKON ไม่มีวงกลม ตาข่ายสไตล์อเมริกัน ตารางนิ้ว 1 นิ้ว หล่อด้วยมือ เหวี่ยงอวนจับปลา รอกตกปลา ลูกตุ้มเหล็ก ตาข่ายจับปลา ของใช้ตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/2e4eaf229ec477e67e93e457a5c2e840.jpg_200x200q90.jpg",
        "price": 2526,
        "remark": "https://www.lazada.co.th/products/pdp-i16146035063.html",
        "sold": 0
    },
    {
        "product_name": "BENGPEN 4 กรงเล็บ ตะขอเกี่ยว นержักร 3 กรงเล็บ ปีนป่าย ของใช้สำหรับปีนเขา ดีไซน์พับได้ ตะขอสแตนเลส ปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/0459b77cd0fbc9dd1d44d459d82efded.jpg_200x200q90.jpg",
        "price": 2419.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16121146970.html",
        "sold": 0
    },
    {
        "product_name": "ARVOL ที่ชาร์จ USB ถ้วยคั้นน้ำผลไม้ไฟฟ้า มัลติฟังก์ชั่ จุได้มาก ถ้วยดื่มน้ำ เครื่องคั้นน้ำผลไม้ เล็กๆน้อยๆ ถ้วยปั่นแบบพกพา ของใช้ในครัวเรือน",
        "product_image": "https://img.lazcdn.com/g/p/eb9ed952a2b404629389a7a7674a1217.jpg_200x200q90.jpg",
        "price": 2410.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16141225672.html",
        "sold": 0
    },
    {
        "product_name": "MARRCIAN 4 กรงเล็บ ตะขอเกี่ยว นержักร 3 กรงเล็บ ตะขอสแตนเลส ของใช้สำหรับปีนเขา โครงสร้างเหล็ก ตะขอเกี่ยวแบบพับได้ ปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/b42f232d6173b71b6514e73ca979e5ad.jpg_200x200q90.jpg",
        "price": 2383.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16126855017.html",
        "sold": 0
    },
    {
        "product_name": "KEQI 3 กรงเล็บ ตะขอเกี่ยว 4 กรงเล็บ นержักร ตะขอสแตนเลส ของใช้สำหรับปีนเขา ดีไซน์พับได้ ตะขออเนกประสงค์ ปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/bd44b070f7a90d0997bc184db2a27f94.png_200x200q90.png",
        "price": 2347.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16127220470.html",
        "sold": 0
    },
    {
        "product_name": "SRAITH 4 กรงเล็บ ตะขอเกี่ยว 3 กรงเล็บ นержักร ปีนป่าย ของใช้สำหรับปีนเขา ดีไซน์พับได้ ตะขอสแตนเลส ปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/5e15db94fef1f0b14222b81bbc858ed6.jpg_200x200q90.jpg",
        "price": 2344.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16127214604.html",
        "sold": 0
    },
    {
        "product_name": "MAYINGLONG | ผ้าเปียกทำความสะอาดที่สามารถล้างออกได้ แบบพกพา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfd783420e014488b8d2264108586c848P.jpg_200x200q90.jpg",
        "price": 2219.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16112235415.html",
        "sold": 0
    },
    {
        "product_name": "RUNDTY สร้างสรรค์ ชุดขี่ม้าเป่าลม การ์ตูน ป้องกันน้ำ ชุดคอสเพลย์ปาร์ตี้ ชุดตุ๊กตา พัดลมที่ถอดออกได้ ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/e596e4be4fce30f5f98775c3a39d5c7b.png_200x200q90.png",
        "price": 2200,
        "remark": "https://www.lazada.co.th/products/pdp-i16100889662.html",
        "sold": 0
    },
    {
        "product_name": "BOTISY สร้างสรรค์ ชุดขี่ม้าเป่าลม การ์ตูน ป้องกันน้ำ ชุดคอสเพลย์ปาร์ตี้ ชุดตุ๊กตา พัดลมที่ถอดออกได้ ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/d9c3232f3a577d99c3e12d6f5b86815a.jpg_200x200q90.jpg",
        "price": 2198,
        "remark": "https://www.lazada.co.th/products/pdp-i16100998952.html",
        "sold": 0
    },
    {
        "product_name": "ที่รักตะกร้าด้านหลังจักรยานสำหรับเด็กตะกร้าตะกร้าใส่ของสีดำติดตั้งง่ายมีสไตล์เดินทางด้วยจักรยานไฟฟ้าซื้อของใช้กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/bff0499c02aa155eab042df4c03c5cde.jpg_200x200q90.jpg",
        "price": 2194.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16097898294.html",
        "sold": 0
    },
    {
        "product_name": "ABOND สร้างสรรค์ ชุดขี่ม้าเป่าลม ป้องกันน้ำ การ์ตูน ชุดคอสเพลย์ปาร์ตี้ คอสเพลย์สำหรับผู้ใหญ่และเด็ก น้ำหนักเบา ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/258841efa8776ec0f098c19d19677412.png_200x200q90.png",
        "price": 2194,
        "remark": "https://www.lazada.co.th/products/pdp-i16101068839.html",
        "sold": 0
    },
    {
        "product_name": "ANGEL การ์ตูน ชุดขี่ม้าเป่าลม สร้างสรรค์ ป้องกันน้ำ ชุดเทศกาลตลก คอสเพลย์สำหรับผู้ใหญ่และเด็ก น้ำหนักเบา ชุดคอสเพลย์ปาร์ตี้ ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/b8e2a3f12e9ad213440153139609122c.png_200x200q90.png",
        "price": 2192,
        "remark": "https://www.lazada.co.th/products/pdp-i16100883663.html",
        "sold": 0
    },
    {
        "product_name": "Gazechimp เต็นท์ส่วนตัวแขวนหลังคาเรือแบบพกพาขนาด39.3X39.3X78.7นิ้วอเนกประสงค์ติดตั้งได้ง่ายสำหรับฝักบัวอาบน้ำกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/9c981302b449a772872dd93daf328d96.jpg_200x200q90.jpg",
        "price": 2188,
        "remark": "https://www.lazada.co.th/products/pdp-i5951827913.html",
        "sold": 0
    },
    {
        "product_name": "HONGUS สร้างสรรค์ ชุดขี่ม้าเป่าลม ป้องกันน้ำ การ์ตูน ชุดคอสเพลย์ปาร์ตี้ คอสเพลย์สำหรับผู้ใหญ่และเด็ก น้ำหนักเบา ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/2327c492c5c66f7942e585fce89e6ac7.png_200x200q90.png",
        "price": 2182,
        "remark": "https://www.lazada.co.th/products/pdp-i16101075166.html",
        "sold": 0
    },
    {
        "product_name": "SIMPLIC สร้างสรรค์ ชุดขี่ม้าเป่าลม การ์ตูน ป้องกันน้ำ ชุดคอสเพลย์ปาร์ตี้ คอสเพลย์สำหรับผู้ใหญ่และเด็ก พัดลมที่ถอดออกได้ ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/9a1f34986fdebc78e73e610374faa35e.png_200x200q90.png",
        "price": 2162,
        "remark": "https://www.lazada.co.th/products/pdp-i16101170519.html",
        "sold": 0
    },
    {
        "product_name": "VINEY การ์ตูน ชุดขี่ม้าเป่าลม สร้างสรรค์ ป้องกันน้ำ ชุดคอสเพลย์ปาร์ตี้ คอสเพลย์สำหรับผู้ใหญ่และเด็ก น้ำหนักเบา ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/0650f9b8513d6fe82ee7e077cca7f0b6.png_200x200q90.png",
        "price": 2162,
        "remark": "https://www.lazada.co.th/products/pdp-i16101292236.html",
        "sold": 0
    },
    {
        "product_name": "ZIAAN การ์ตูน ชุดขี่ม้าเป่าลม ป้องกันน้ำ สร้างสรรค์ ชุดคอสเพลย์ปาร์ตี้ ชุดตุ๊กตา น้ำหนักเบา ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/9270e836fe0d22b1194921ce1c0faa9b.png_200x200q90.png",
        "price": 2156,
        "remark": "https://www.lazada.co.th/products/pdp-i16101336126.html",
        "sold": 0
    },
    {
        "product_name": "YARUA สร้างสรรค์ ชุดขี่ม้าเป่าลม การ์ตูน ป้องกันน้ำ ชุดคอสเพลย์ปาร์ตี้ ระบบพองลมอัตโนมัติ น้ำหนักเบา ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/3792e82b98af3d04edfcfe8c83d2fc97.jpg_200x200q90.jpg",
        "price": 2152,
        "remark": "https://www.lazada.co.th/products/pdp-i16101202441.html",
        "sold": 0
    },
    {
        "product_name": "YOURUN การ์ตูน ชุดขี่ม้าเป่าลม สร้างสรรค์ ป้องกันน้ำ ชุดคอสเพลย์ปาร์ตี้ ชุดตุ๊กตา พัดลมที่ถอดออกได้ ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/89af33c8d6087bc825cfc65e67305e12.jpg_200x200q90.jpg",
        "price": 2144,
        "remark": "https://www.lazada.co.th/products/pdp-i16101216417.html",
        "sold": 0
    },
    {
        "product_name": "AISHA สร้างสรรค์ ชุดขี่ม้าเป่าลม ป้องกันน้ำ การ์ตูน ชุดเทศกาลตลก ชุดตุ๊กตา น้ำหนักเบา ชุดคอสเพลย์ปาร์ตี้ ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/d7881765e7aa7584178370f78772e319.jpg_200x200q90.jpg",
        "price": 2140,
        "remark": "https://www.lazada.co.th/products/pdp-i16101053242.html",
        "sold": 0
    },
    {
        "product_name": "ED การ์ตูน ชุดขี่ม้าเป่าลม ป้องกันน้ำ สร้างสรรค์ ชุดคอสเพลย์ปาร์ตี้ ระบบพองลมอัตโนมัติ น้ำหนักเบา ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/e497b6e1d42c051fcc52a462b4893f35.png_200x200q90.png",
        "price": 2124,
        "remark": "https://www.lazada.co.th/products/pdp-i16101153004.html",
        "sold": 0
    },
    {
        "product_name": "ชุด Baju Otot Baoblaze ผ้าเนื้อนุ่มน้ำหนักเบาสำหรับของใช้สำหรับปาร์ตี้ปีใหม่การแสดงบนเวทีงานคาร์นิวัล",
        "product_image": "https://img.lazcdn.com/g/p/18020d5114e3fcd731baf393ff9fb050.jpg_200x200q90.jpg",
        "price": 2108,
        "remark": "https://www.lazada.co.th/products/pdp-i16105914229.html",
        "sold": 0
    },
    {
        "product_name": "ผลิตภัณฑ์ขจัดคราบ Miss Mouth's Messy Eater - น้ำยาขจัดคราบ 4 ออนซ์ - ของใช้จำเป็นสำหรับทารกแรกเกิดและเด็กเล็ก - ขจัดคราบอาหาร คราบไขมัน คราบกาแฟ ออกจากผ้า ชุดชั้นใน และผ้าทุกชนิดโดยไม่ต้องซักแห้ง",
        "product_image": "https://img.lazcdn.com/g/p/cfa05ff4e035164507b5427ef4fb8797.jpg_webp_200x200q90.jpg",
        "price": 2093.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16145022230.html",
        "sold": 0
    },
    {
        "product_name": "GUDY การ์ตูน ชุดขี่ม้าเป่าลม สร้างสรรค์ ป้องกันน้ำ ชุดเทศกาลตลก ระบบพองลมอัตโนมัติ น้ำหนักเบา ชุดคอสเพลย์ปาร์ตี้ ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/d586021f69541023dfc12ac633fb4ef3.jpg_200x200q90.jpg",
        "price": 2076.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16101214507.html",
        "sold": 0
    },
    {
        "product_name": "LONGKE | พัดลมเป่าฝุ่นไฟฟ้าพลังสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se708b9cfad874cf2af39abba0854078dN.jpg_200x200q90.jpg",
        "price": 2630.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5910882630.html",
        "sold": 2
    },
    {
        "product_name": "Vaseline | โลชั่นอาบน้ำ Vaseline Daily Moisture Body Wash สูตร pH 5.5 ขนาด 1000 มล. x 2 ขวด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdeb30758f157429483cb66c04bf446edt.png_200x200q90.png",
        "price": 2382.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5964887354.html",
        "sold": 0
    },
    {
        "product_name": "Dove | โดฟ นอรสซง ออยล แคร แชมพ 680 มล. 2 ขวด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sef1ae4d445504e4fa3b34aea8d586c7br.png_200x200q90.png",
        "price": 2334.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16092772202.html",
        "sold": 0
    },
    {
        "product_name": "CHICKETTI สร้างสรรค์ ชุดขี่ม้าเป่าลม ป้องกันน้ำ การ์ตูน ชุดเทศกาลตลก คอสเพลย์สำหรับผู้ใหญ่และเด็ก น้ำหนักเบา ชุดคอสเพลย์ปาร์ตี้ ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/38e09ed5e274ed3acd2871fdde9f8c19.jpg_200x200q90.jpg",
        "price": 2076.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16100897638.html",
        "sold": 0
    },
    {
        "product_name": "Plu | สครับขัดผิวกาย Plu Body Scrub 200g x 2 โรสแมรี่ ขจัดเซลล์ผิวเก่า บำรุงให้ชุ่มชื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfd978c4584af448b9b8e9e3cbe6c2ecb0.png_200x200q90.png",
        "price": 2046.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5959396352.html",
        "sold": 1
    },
    {
        "product_name": "Mr.Snail | ชุดเครื่องใช้บนโต๊ะสำหรับครอบครัว 4 คน ดีไซน์สวยงาม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sda18f031158f47ceafb264bba6dbe160u.jpg_200x200q90.jpg",
        "price": 2038.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5874200186.html",
        "sold": 86
    },
    {
        "product_name": "TUS สร้างสรรค์ ชุดขี่ม้าเป่าลม ป้องกันน้ำ การ์ตูน ชุดเทศกาลตลก ชุดตุ๊กตา พัดลมที่ถอดออกได้ ชุดคอสเพลย์ปาร์ตี้ ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/25a55d419f3a1e94c5517ac2ab7a8f6b.jpg_200x200q90.jpg",
        "price": 2021.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16101358044.html",
        "sold": 0
    },
    {
        "product_name": "TOOYFUL เรือผ้าม่านสำหรับความเป็นส่วนตัวห้องเปลี่ยนเสื้อผ้าแขวนได้ห้องแต่งตัวม่านอาบน้ำเต็นท์ส่วนตัวสำหรับเรือโป๊ะถ่ายรูปชายหาด",
        "product_image": "https://img.lazcdn.com/g/p/b2eb445d98736f27c9ba2364e11295c9.jpg_200x200q90.jpg",
        "price": 1974,
        "remark": "https://www.lazada.co.th/products/pdp-i5970242981.html",
        "sold": 0
    },
    {
        "product_name": "SHEBE668 ตารางนิ้ว 1 นิ้ว ตาข่ายสไตล์อเมริกัน หล่อด้วยมือ ไม่มีวงกลม เหวี่ยงอวนจับปลา แข็งแกร่ง ลูกตุ้มเหล็ก ตาข่ายจับปลา ของใช้ตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/2ffbe4c5e749d0a7e53511d4bf8ff40d.jpg_200x200q90.jpg",
        "price": 1968.92,
        "remark": "https://www.lazada.co.th/products/pdp-i6012809164.html",
        "sold": 0
    },
    {
        "product_name": "JUNOTERNEY ประสิทธิภาพสูง เครื่องเจาะกระดาษ 30 หลุม น้ำหนักเบา ที่เจาะรู คุณภาพสูง รูปทรงกลม เครื่องเจาะปกเอกสาร ของใช้สำนักงาน",
        "product_image": "https://img.lazcdn.com/g/p/aa4cd17a47d217461532c74c67e56190.jpg_200x200q90.jpg",
        "price": 1916,
        "remark": "https://www.lazada.co.th/products/pdp-i16101271385.html",
        "sold": 0
    },
    {
        "product_name": "กล่องอุปกรณ์เสริมตกปลาเรือกล่องอุปกรณ์ตกปลา4ชั้นแบบพกพาสำหรับตกปลากล่องอเนกประสงค์พร้อมที่จับกล่องของใช้",
        "product_image": "https://img.lazcdn.com/g/p/e42a2adec2007f397082db61c6dce101.jpg_200x200q90.jpg",
        "price": 1910,
        "remark": "https://www.lazada.co.th/products/pdp-i5129028602.html",
        "sold": 0
    },
    {
        "product_name": "JDTYJDT สร้างสรรค์ ชุดขี่ม้าเป่าลม ป้องกันน้ำ การ์ตูน ชุดคอสเพลย์ปาร์ตี้ ชุดตุ๊กตา พัดลมที่ถอดออกได้ ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/665de6190f0af9696fb3a3997bbc657d.jpg_200x200q90.jpg",
        "price": 1898,
        "remark": "https://www.lazada.co.th/products/pdp-i16075060813.html",
        "sold": 0
    },
    {
        "product_name": "ผลิตภัณฑ์ใช้ประจำวัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8a345f7ee569466da9d610ab4f69aba78.jpg_200x200q90.jpg",
        "price": 1896.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16111316091.html",
        "sold": 0
    },
    {
        "product_name": "YZHX | ปั๊มพองบอลลูนฮีเลียมพกพา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S95bd3ca0184348279d2b60ef05b59a89P.jpg_200x200q90.jpg",
        "price": 1892,
        "remark": "https://www.lazada.co.th/products/pdp-i6026165497.html",
        "sold": 1
    },
    {
        "product_name": "YDIJEJ การ์ตูน ชุดขี่ม้าเป่าลม สร้างสรรค์ ป้องกันน้ำ ชุดคอสเพลย์ปาร์ตี้ ระบบพองลมอัตโนมัติ น้ำหนักเบา ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/3f9ceaefc2902e4f2ad768ee4f6300b1.jpg_200x200q90.jpg",
        "price": 1872,
        "remark": "https://www.lazada.co.th/products/pdp-i16089334811.html",
        "sold": 0
    },
    {
        "product_name": "MUQZI ตารางนิ้ว 1 นิ้ว ตาข่ายสไตล์อเมริกัน หล่อด้วยมือ ไม่มีวงกลม เหวี่ยงอวนจับปลา รอกตกปลา 4.8 เมตร ตาข่ายจับปลา ของใช้ตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/b36439a4f69fd245dc459e8b308ebdeb.jpg_200x200q90.jpg",
        "price": 1862,
        "remark": "https://www.lazada.co.th/products/pdp-i16147396666.html",
        "sold": 0
    },
    {
        "product_name": "GBDSVD สร้างสรรค์ ชุดขี่ม้าเป่าลม การ์ตูน ป้องกันน้ำ ชุดเทศกาลตลก ชุดตุ๊กตา น้ำหนักเบา ชุดคอสเพลย์ปาร์ตี้ ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/34b4caca42e7ed365290a14ab1cb15df.jpg_200x200q90.jpg",
        "price": 1848,
        "remark": "https://www.lazada.co.th/products/pdp-i16082261950.html",
        "sold": 0
    },
    {
        "product_name": "MAOMEI ไม่มีวงกลม ตาข่ายสไตล์อเมริกัน หล่อด้วยมือ ตารางนิ้ว 1 นิ้ว เหวี่ยงอวนจับปลา แข็งแกร่ง แบบพับได้ ตาข่ายจับปลา ของใช้ตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/ec9140e46c81e90bc86ac7842882c40f.png_200x200q90.png",
        "price": 1846,
        "remark": "https://www.lazada.co.th/products/pdp-i16146913335.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋าใส่รองเท้ากอล์ฟแบบพกพา น้ำหนักเบา กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0a4ebf6afb634beb93ae4d2deb43eacdb.jpg_200x200q90.jpg",
        "price": 1814.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16055117188.html",
        "sold": 0
    },
    {
        "product_name": "MARRCIAN ปีนเขา ฟิงเกอร์บอร์ดปีนเขา ที่เสริมแรงจับ ที่บริหารแขน กระดานฝึกปีนเขา ของใช้สำหรับกีฬา ดึงขึ้น แผ่นหินแข็งแรง บ้านกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/abeb53c5544ce8a4c3a6efd14c4d4103.jpg_200x200q90.jpg",
        "price": 1811.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16086242602.html",
        "sold": 0
    },
    {
        "product_name": "เจลอาบน้ำควบคุมความมัน บำรุงผิวชุ่มชื้น กลิ่นหอมยาวนาน ไนโตรนาไมด์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S08f86c7bd025412bb12f212b32afdfb76.jpg_200x200q90.jpg",
        "price": 1800.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16089746033.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องปั่นอาหารเด็ก เครื่องปั่น เครื่องบดอาหารสำหรับเด็ก  4ใบมีด ของใช้ครัวเรือน วัสดุสแตนเลส+พลาสติกเครื่องปั่นไฟฟ้าโถพลาสติกอย่างดี 300วัตต์ เครื่องปั่นผสมอาหารอเนกประสงค์ ของแท้ พร้อมส่งจากไทย",
        "product_image": "https://img.lazcdn.com/g/p/4e6f99422500ff724b78b4b3e398a9dd.jpg_200x200q90.jpg",
        "price": 1780,
        "remark": "https://www.lazada.co.th/products/pdp-i5615549469.html",
        "sold": 0
    },
    {
        "product_name": "WDAir ตะเกียงแอลกอฮอล์เตาแอลกอฮอล์น้ำหนักเบาสำหรับเดินทางร้านอาหารของใช้ในครัวเรือน",
        "product_image": "https://img.lazcdn.com/g/p/cb0578899c1f92ce848f4d005173ad5e.jpg_200x200q90.jpg",
        "price": 1772,
        "remark": "https://www.lazada.co.th/products/pdp-i5967046805.html",
        "sold": 0
    },
    {
        "product_name": "YAHURO ที่เสริมแรงจับ ฟิงเกอร์บอร์ดปีนเขา ปีนเขา ที่บริหารแขน กระดานฝึกปีนเขา ของใช้สำหรับกีฬา ไม้ แผ่นหินแข็งแรง บ้านกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/d60e2705d350039e38d244618227dc33.jpg_200x200q90.jpg",
        "price": 1771.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16086223149.html",
        "sold": 0
    },
    {
        "product_name": "Koolsoo ที่แขวนผ้าม่านสำหรับความเป็นส่วนตัวเรือม่านอาบน้ำทะเลที่คลุมผ้าอ๊อกซ์ฟอร์ดเต็นท์ส่วนตัวกลางแจ้งสำหรับถ่ายภาพชายหาด",
        "product_image": "https://img.lazcdn.com/g/p/eda8d5d7e60c72f00007b069d167b8bf.jpg_200x200q90.jpg",
        "price": 1760,
        "remark": "https://www.lazada.co.th/products/pdp-i5973207772.html",
        "sold": 0
    },
    {
        "product_name": "YUHENNY สร้างสรรค์ ชุดขี่ม้าเป่าลม ป้องกันน้ำ การ์ตูน ชุดคอสเพลย์ปาร์ตี้ ชุดตุ๊กตา พัดลมที่ถอดออกได้ ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/6ef42f3b8c9fa5e04bcf90e5cce909bc.jpg_200x200q90.jpg",
        "price": 1760,
        "remark": "https://www.lazada.co.th/products/pdp-i16113648906.html",
        "sold": 0
    },
    {
        "product_name": "BEYTM การ์ตูน ชุดขี่ม้าเป่าลม ป้องกันน้ำ สร้างสรรค์ ชุดเทศกาลตลก ชุดตุ๊กตา น้ำหนักเบา ชุดคอสเพลย์ปาร์ตี้ ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/8c00c38b3fad8507d7b5eabbed0f047f.jpg_200x200q90.jpg",
        "price": 1752,
        "remark": "https://www.lazada.co.th/products/pdp-i16056628319.html",
        "sold": 0
    },
    {
        "product_name": "DXSFV ปีนเขา ฟิงเกอร์บอร์ดปีนเขา ที่บริหารแขน ที่เสริมแรงจับ กระดานฝึกปีนเขา ของใช้สำหรับกีฬา ไม้ แผ่นหินแข็งแรง บ้านกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/457d7a0de7c9d19afb3f9626006713f5.jpg_200x200q90.jpg",
        "price": 1733.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16137072465.html",
        "sold": 0
    },
    {
        "product_name": "RISEDOT แบบพับได้ ยาง MTB 26 27.5 291.95 นิ้ว น้ำหนักเบา ยางจักรยานแข่ง ใหม่ ป้องกันการแทง ยางจักรยานเสือภูเขา CST ของใช้สำหรับขี่",
        "product_image": "https://img.lazcdn.com/g/p/cd947e220f51585445d968bfb079d28c.jpg_200x200q90.jpg",
        "price": 1730.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16090908315.html",
        "sold": 0
    },
    {
        "product_name": "WAYCAI 26 27.5 291.95 นิ้ว ยาง MTB แบบพับได้ น้ำหนักเบา ยางจักรยานแข่ง ใหม่ ป้องกันการแทง ยางจักรยานเสือภูเขา CST ของใช้สำหรับขี่",
        "product_image": "https://img.lazcdn.com/g/p/f5cf40bfb2d934e3343945b7885935bc.jpg_200x200q90.jpg",
        "price": 1726.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5875465988.html",
        "sold": 4
    },
    {
        "product_name": "Dove | โดฟ แชมพ อนเทนส รแพร แชมพ 680 มล. x 2 ขวด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se8e176b1bd2e4168aeaab0a895ee53832.png_200x200q90.png",
        "price": 1725.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5968757085.html",
        "sold": 0
    },
    {
        "product_name": "ลูกกอล์ฟ 3 ชั้นพร้อมโลโก้ส่วนตัว 10 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3dd32b8c8d6249038790960a0f8fe7daN.png_200x200q90.png",
        "price": 1721.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16087341946.html",
        "sold": 0
    },
    {
        "product_name": "BAOZITI | เจลอาบน้ำอโลเวร่าและสมุนไพร ชุ่มชื่นอย่างอ่อนโยน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0e0ab621f96349c38c902d19d68b3089e.jpg_200x200q90.jpg",
        "price": 1704.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16117659227.html",
        "sold": 0
    },
    {
        "product_name": "MUQZI จังหวะคลิกเสียง ผู้ฝึกสอนวงสวิงกอล์ฟ แกนกอล์ฟ น้ำหนักเบา คลับฝึกซ้อมกอล์ฟ แบบพกพา ตามหลักสรีรศาสตร์ ผู้ฝึกสอนพัตเตอร์ยาวกอล์ฟ ของใช้สำหรับการฝึกอบรม",
        "product_image": "https://img.lazcdn.com/g/p/940cc32bd761365e841c9171dca9b495.jpg_200x200q90.jpg",
        "price": 1700,
        "remark": "https://www.lazada.co.th/products/pdp-i16147402356.html",
        "sold": 0
    },
    {
        "product_name": "MAOMEI น้ำหนักเบา ผู้ฝึกสอนวงสวิงกอล์ฟ แกนกอล์ฟ จังหวะคลิกเสียง คลับฝึกซ้อมกอล์ฟ ของเล่น หลายฟังก์ชัน ผู้ฝึกสอนพัตเตอร์ยาวกอล์ฟ ของใช้สำหรับการฝึกอบรม",
        "product_image": "https://img.lazcdn.com/g/p/ddac361f5281a0b6a33f78171ce08173.png_200x200q90.png",
        "price": 1696,
        "remark": "https://www.lazada.co.th/products/pdp-i16147306354.html",
        "sold": 0
    },
    {
        "product_name": "PICKING การ์ตูน ชุดขี่ม้าเป่าลม ป้องกันน้ำ สร้างสรรค์ ชุดเทศกาลตลก ชุดตุ๊กตา พัดลมที่ถอดออกได้ ชุดคอสเพลย์ปาร์ตี้ ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/6b9fb17e514e025697635a4c487f96aa.jpg_200x200q90.jpg",
        "price": 1676.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16100929611.html",
        "sold": 0
    },
    {
        "product_name": "ABOND 3 กรงเล็บ ตะขอเกี่ยว นержักร 4 กรงเล็บ ปีนป่าย ของใช้สำหรับปีนเขา ดีไซน์พับได้ ตะขอเกี่ยวแบบพับได้ ปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/704fb86750ef5a7829285fa15d0e8794.png_200x200q90.png",
        "price": 1662,
        "remark": "https://www.lazada.co.th/products/pdp-i16126845020.html",
        "sold": 0
    },
    {
        "product_name": "ANSINE 4 กรงเล็บ ตะขอเกี่ยว 3 กรงเล็บ นержักร ปีนป่าย ของใช้สำหรับปีนเขา ดีไซน์พับได้ ตะขอสแตนเลส ปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/bcf54ea1a012d1f0f29eead15b467e55.jpg_200x200q90.jpg",
        "price": 1660,
        "remark": "https://www.lazada.co.th/products/pdp-i16127166937.html",
        "sold": 0
    },
    {
        "product_name": "Shi Xiang|เครื่องหนีบผมไร้สายพกพาชาร์จผ่าน USB",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S420c2a8047f5473c89e857062dda68509.png_200x200q90.png",
        "price": 1653.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6022156767.html",
        "sold": 5
    },
    {
        "product_name": "WILD 3 กรงเล็บ ตะขอเกี่ยว นержักร 4 กรงเล็บ ปีนป่าย ของใช้สำหรับปีนเขา โครงสร้างเหล็ก ตะขออเนกประสงค์ ปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/1bf814af6f63cb26035884ac371d6561.png_200x200q90.png",
        "price": 1644,
        "remark": "https://www.lazada.co.th/products/pdp-i16121290720.html",
        "sold": 0
    },
    {
        "product_name": "Homerunpet Smart Pet Dryer 135L ▪️ประกันศูนย์ไทย3ปี▪️รุ่นPD135 ตู้เป่าขนสัตว์เลี้ยงขนาดใหญ่ แบบมีล้อ",
        "product_image": "https://img.lazcdn.com/g/p/56cb61f20d15ba0543985b6a86aab4b3.jpg_200x200q90.jpg",
        "price": 47800,
        "remark": "https://www.lazada.co.th/products/pdp-i5911666153.html",
        "sold": 0
    },
    {
        "product_name": "Homerunpet Pet Dryer PD135 ตู้เป่าขนสัตว์เลี้ยง by munkong",
        "product_image": "https://img.lazcdn.com/g/p/680aba5df7e27b9fc92deda6d7298185.jpg_200x200q90.jpg",
        "price": 45980,
        "remark": "https://www.lazada.co.th/products/pdp-i5687344785.html",
        "sold": 0
    },
    {
        "product_name": "HOMERUN | ห้องน้ำแมวอัตโนมัติเติมทรายได้ ขนาดใหญ่พิเศษ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S80843d23cb934abbb55d34dd541055e8x.jpg_200x200q90.jpg",
        "price": 43648,
        "remark": "https://www.lazada.co.th/products/pdp-i16120574193.html",
        "sold": 0
    },
    {
        "product_name": "Homerunpet Smart Litter Box ห้องน้ำแมวอัตโนมัติ ขนาดใหญ่ ระบบเติมทรายอัตโนมัติ ▪️ประกันศูนย์ไทย2ปี▪️",
        "product_image": "https://img.lazcdn.com/g/p/5f8370a5a61ee8a540f2de72d253c11e.jpg_200x200q90.jpg",
        "price": 41980,
        "remark": "https://www.lazada.co.th/products/pdp-i5911691727.html",
        "sold": 0
    },
    {
        "product_name": "PETKIT Purobot Ultra ห้องน้ำแมวอัตโนมัติมาพร้อมกล้อง Ai ตรวตจับแมวอัจฉริยะ ประกันศูนย์ไทย 2 ปี Onsite Service",
        "product_image": "https://img.lazcdn.com/g/p/930f1ab9a30e7cec2b6346a2523d9c97.png_200x200q90.png",
        "price": 39800,
        "remark": "https://www.lazada.co.th/products/pdp-i5430899594.html",
        "sold": 1
    },
    {
        "product_name": "HomeRunPet Drybo Pro Smart Pet Dryer PD80 Pro ตู้เป่าขนสัตว์เลี้ยง ไส้กรอง HEPA 2 ชั้น ความจุ 80 ลิตร รับประกัน 3 ปี",
        "product_image": "https://img.lazcdn.com/g/p/e16f5ec0e96862387c2a8c7099cf788d.png_200x200q90.png",
        "price": 33980,
        "remark": "https://www.lazada.co.th/products/pdp-i5749143517.html",
        "sold": 0
    },
    {
        "product_name": "AiRROBO | กล่องทรายแมวอัจฉริยะขนาดใหญ่พิเศษ พร้อมระบบทำความสะอาดไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S987f1d1c7c104ddaa5f687e50f6266487.jpg_200x200q90.jpg",
        "price": 30278,
        "remark": "https://www.lazada.co.th/products/pdp-i16120732794.html",
        "sold": 0
    },
    {
        "product_name": "PETKIT Pura-MAX PRO 2 ห้องน้ำแมวอัตโนมัติรุ่นโปรพร้อมกล้อง Ai อัจฉริยะ [Global Version] ประกันศูนย์ไทย 2 ปี",
        "product_image": "https://img.lazcdn.com/g/p/a92eea7291985dcccb7e38713799cf68.jpg_200x200q90.jpg",
        "price": 27800,
        "remark": "https://www.lazada.co.th/products/pdp-i5875970051.html",
        "sold": 0
    },
    {
        "product_name": "HATELI การทำความสะอาดด้วยตนเองกล่องทรายแมวอัตโนมัติอัจฉริยะสำหรับ65L ปิดมิดชิดแอปควบคุมกลิ่นเหงื่อขนาดใหญ่กล่องทรายแมวถาดขับถ่ายสัตว์เลี้ยงถาดทรายแมว",
        "product_image": "https://img.lazcdn.com/g/p/1fcd6d960da818ca8fd411e367f88787.jpg_200x200q90.jpg",
        "price": 26860,
        "remark": "https://www.lazada.co.th/products/pdp-i5176463397.html",
        "sold": 0
    },
    {
        "product_name": "โบลเวอร์ เติมอากาศบ่อปลา กุ้ง โบลเวอร์เติม-ดูดอากาศ Ring Blower NORVAX รุ่น NVT-220 3สาย 2.2kW. 2P 380V. ท่อ 2 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/p/9de6766a8004ae5f67da919c22dab294.jpg_200x200q90.jpg",
        "price": 24780,
        "remark": "https://www.lazada.co.th/products/pdp-i5322899434.html",
        "sold": 2
    },
    {
        "product_name": "HATELI กล่องทรายแมวอัตโนมัติ ดับกลิ่นอัตโนมัติ 65 ลิตร พร้อมรีโมทคอนโทรล ควบคุมผ่านแอป กล่องทรายแมวอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/p/aaf9246fd176915b6e92fa5cdc56c79c.jpg_200x200q90.jpg",
        "price": 24550,
        "remark": "https://www.lazada.co.th/products/pdp-i5826429982.html",
        "sold": 0
    },
    {
        "product_name": "[[พร้อมส่ง]] Y192 PETKIT PURA X 2024 (Gobal Version เชื่อมต่อ APPได้ ประกัน2ปี ศูนย์ไทย)   ห้องน้ำแมวอัตโนมัติ [แถมฟรี แผ่นดักทราย+น้ำยากำจัดกลิ่น ]ห้องน้ำแมว",
        "product_image": "https://img.lazcdn.com/g/p/e82ff573ecd96f169908508f5eb99b7a.png_200x200q90.png",
        "price": 23800,
        "remark": "https://www.lazada.co.th/products/pdp-i2330625601.html",
        "sold": 16
    },
    {
        "product_name": "Homerunpet CS106 Self-Cleaning Litter Box White ห้องน้ำแมวอัตโนมัติ by Pro Gadgets",
        "product_image": "https://img.lazcdn.com/g/p/8a47be333e33452540b76e1b4bfccfc1.jpg_200x200q90.jpg",
        "price": 23800,
        "remark": "https://www.lazada.co.th/products/pdp-i5776014334.html",
        "sold": 2
    },
    {
        "product_name": "【DUDUสัตว์เลี้ยง】Cat Castle Catกระบะทรายปิดมิดชิดขนาดใหญ่ห้องน้ำแมวDeodorizationและป้องกันการสาดผลิตภัณฑ์แมวกล่องครอกแมว + ที่นอนแมว",
        "product_image": "https://img.lazcdn.com/g/p/1625ff818c4f15edc1f0fa944517d7dd.jpg_200x200q90.jpg",
        "price": 22686,
        "remark": "https://www.lazada.co.th/products/pdp-i1721918084.html",
        "sold": 2
    },
    {
        "product_name": "AiRROBO | กล่องทรายแมวอัตโนมัติขนาดใหญ่ ป้องกันกระเด็นและกำจัดกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc925510134044ef7a45cdf5f99e8d734U.jpg_200x200q90.jpg",
        "price": 21748,
        "remark": "https://www.lazada.co.th/products/pdp-i16076366150.html",
        "sold": 0
    },
    {
        "product_name": "Pickfun | กล่องทรายแมวอัจฉริยะสำหรับหลายแมว วิเคราะห์สุขภาพ เติมทรายและทำความสะอาดอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8f1302ee3f744247ac125cb8343ca1dbE.jpg_200x200q90.jpg",
        "price": 21430,
        "remark": "https://www.lazada.co.th/products/pdp-i16089470041.html",
        "sold": 0
    },
    {
        "product_name": "Aclium Air Dryer ตู้เป่าขนสัตว์เลี้ยง by munkong",
        "product_image": "https://img.lazcdn.com/g/p/6f4060f3278dacc776da6df55d73403f.jpg_200x200q90.jpg",
        "price": 20700,
        "remark": "https://www.lazada.co.th/products/pdp-i5263238559.html",
        "sold": 2
    },
    {
        "product_name": "Lovinland Pet ถาดรองทรายแมวอัตโนมัติอัจฉริยะ ทำความสะอาดตัวเองได้ ปิดสนิท ตัวกรองประสิทธิภาพสูง ความจุ 65 ลิตร พร้อมระบบดับกลิ่น พร้อมการควบคุมผ่านแอป",
        "product_image": "https://img.lazcdn.com/g/p/30d3f428d5ea5938e269984fa71fa94e.jpg_200x200q90.jpg",
        "price": 19676,
        "remark": "https://www.lazada.co.th/products/pdp-i5821042903.html",
        "sold": 0
    },
    {
        "product_name": "โบลเวอร์ เติมอากาศบ่อปลา กุ้ง โบลเวอร์เติม-ดูดอากาศ  Ring Blower NORVAX รุ่น NVS-150 2สาย 1.5kW. 2P  220V. ท่อ 2 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/p/9de6766a8004ae5f67da919c22dab294.jpg_200x200q90.jpg",
        "price": 18580,
        "remark": "https://www.lazada.co.th/products/pdp-i5322729685.html",
        "sold": 0
    },
    {
        "product_name": "Alectric Pet Smart Cat Litter Box ห้องน้ำแมวอัจฉริยะ เชื่อมแอปฯได้ พร้อมระบบฆ่าเชื้อ รุ่น LB1 -  รับประกัน 3 ปี",
        "product_image": "https://img.lazcdn.com/g/p/7a8f30b5787f4877a2c58ae72453392b.jpg_200x200q90.jpg",
        "price": 17980,
        "remark": "https://www.lazada.co.th/products/pdp-i5107765624.html",
        "sold": 0
    },
    {
        "product_name": "VITAINNO VITA-PET PRO เครื่องกรูมมิ่งสัตว์เลี้ยง 9-in-1 ดูดขนพร้อมเป่าแห้ง 17000PA ปัตตาเลี่ยนไร้สาย หวีตัดแต่งขนสุนัข แมว เสียงเบา",
        "product_image": "https://img.lazcdn.com/g/p/a9b6a7003ec0854831c869f3e30168eb.jpg_200x200q90.jpg",
        "price": 17980,
        "remark": "https://www.lazada.co.th/products/pdp-i16060104590.html",
        "sold": 0
    },
    {
        "product_name": "Petkit | ห้องน้ำแมวอัตโนมัติ ดูดซับกลิ่น ทำความสะอาดเอง ขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S68d54c7ea40c4a1cbd6c6814135b5cb4Q.jpg_200x200q90.jpg",
        "price": 17232,
        "remark": "https://www.lazada.co.th/products/pdp-i16111912587.html",
        "sold": 0
    },
    {
        "product_name": "NEW AGE PET ตู้แมวพร้อมที่นั่ง ซ่อนกระบะทราย ไม่มีกลิ่น ECOFLEX เก็บของได้ ใช้เป็นม้านั่งใส่รองเท้า ดีไซน์มินิมอล",
        "product_image": "https://img.lazcdn.com/g/p/e3277911539d47ed4c91603a2c1f19e6.png_200x200q90.png",
        "price": 15998,
        "remark": "https://www.lazada.co.th/products/pdp-i16125426886.html",
        "sold": 0
    },
    {
        "product_name": "Petkit | อุปกรณ์ให้อาหารสัตว์เลี้ยงอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1920921bc7ee4428ac5e54a210c00ae6i.jpg_200x200q90.jpg",
        "price": 15106,
        "remark": "https://www.lazada.co.th/products/pdp-i16063358239.html",
        "sold": 37
    },
    {
        "product_name": "BAIWO | เครื่องฟอกอากาศพร้อมเก็บขนแมวอัตโนมัติลอยตัว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf313e9ae69834d41a9ed010eb46e7b5dg.jpg_200x200q90.jpg",
        "price": 13286,
        "remark": "https://www.lazada.co.th/products/pdp-i16068731856.html",
        "sold": 0
    },
    {
        "product_name": "โบลเวอร์ เติมอากาศบ่อปลา กุ้ง โบลเวอร์เติม-ดูดอากาศ  Ring Blower NORVAX รุ่น NVT-085 3สาย 0.85kW. 2P 380V. ท่อ 1 1/2 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/p/9de6766a8004ae5f67da919c22dab294.jpg_200x200q90.jpg",
        "price": 13180,
        "remark": "https://www.lazada.co.th/products/pdp-i5322659128.html",
        "sold": 0
    },
    {
        "product_name": "กล่องทรายแมวอัตโนมัติขนาดใหญ่ ป้องกันกลิ่นและทรายกระเด็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scebe3682e45442f2a11bab6a6feca2d2e.png_200x200q90.png",
        "price": 12706,
        "remark": "https://www.lazada.co.th/products/pdp-i16124706741.html",
        "sold": 0
    },
    {
        "product_name": "ทรายแมวเบนโทไนต์ควบคุมกลิ่นสำหรับแมวหลายตัว ไม่มีฝุ่น 2 กล่อง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S34da8d13252e404689f7a0b53938466d9.jpg_200x200q90.jpg",
        "price": 12248,
        "remark": "https://www.lazada.co.th/products/pdp-i16124709059.html",
        "sold": 0
    },
    {
        "product_name": "Ferwa | กล่องทรายแมวอัตโนมัติควบคุมกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbf992009a6c947b0b71b1cc38018422cs.png_200x200q90.png",
        "price": 11994,
        "remark": "https://www.lazada.co.th/products/pdp-i16089075949.html",
        "sold": 0
    },
    {
        "product_name": "HELLOLEIBOO | เครื่องฟอกอากาศสำหรับสัตว์เลี้ยง ดูดขนแมว กำจัดฝุ่น ลดกลิ่น ฆ่าเชื้อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S68a0b79279d446558e789c2a4a125894O.png_200x200q90.png",
        "price": 11484.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5942109878.html",
        "sold": 4
    },
    {
        "product_name": "UPKEYE | ทรายแมวธรรมชาติจากแร่ธาตุ ไม่มีฝุ่น ไม่มีกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S64cac9fbbe294c6985213bdded476f0c7.png_200x200q90.png",
        "price": 11279.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5927588585.html",
        "sold": 50
    },
    {
        "product_name": "[Energetic] กระบะทรายแมวพร้อมฝาปิดถาดใส่กระบะทรายแมวที่ปิดด้านบน",
        "product_image": "https://img.lazcdn.com/g/p/630021913ba0b2d12f31c4f763787536.jpg_200x200q90.jpg",
        "price": 10741.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6019141568.html",
        "sold": 0
    },
    {
        "product_name": "Toshiba | เครื่องฟอกอากาศสำหรับสัตว์เลี้ยง ลดกลิ่นและกำจัดภูมิแพ้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S94fb8ac7bf1f4dc4ae7496816caa828fQ.jpg_200x200q90.jpg",
        "price": 10288,
        "remark": "https://www.lazada.co.th/products/pdp-i16117821541.html",
        "sold": 0
    },
    {
        "product_name": "กรงสัตว์เลี้ยงขนาดใหญ่พื้นโล่ง 150*120*120ซม.",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7bb2f0d7f56b4f729fa1eef029c73181j.jpg_200x200q90.jpg",
        "price": 9800,
        "remark": "https://www.lazada.co.th/products/pdp-i5366472191.html",
        "sold": 0
    },
    {
        "product_name": "กล่องขยะสัตว์เลี้ยงชั้นเดียวขนาดใหญ่ ป้องกันกลิ่นและทำความสะอาดง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfaa5b5718402461e877c162ea88c7f9aL.jpg_200x200q90.jpg",
        "price": 9662,
        "remark": "https://www.lazada.co.th/products/pdp-i16116776055.html",
        "sold": 0
    },
    {
        "product_name": "ที่ครอบไม้กอล์ฟประดับสัตว์เลี้ยงน่ารัก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S411068fd274e4b11aa730c7ce4523b43y.jpg_200x200q90.jpg",
        "price": 9308,
        "remark": "https://www.lazada.co.th/products/pdp-i16122927546.html",
        "sold": 0
    },
    {
        "product_name": "Mango ห้องน้ำแมวอัตโนมัติ 78L ขนาดใหญ่ ห้องน้ำแมวอัจฉริยะ ปลอดภัยไม่หนีบแมว การควบคุมระยะไกล APP มีภาษาไทยรองรับ",
        "product_image": "https://img.lazcdn.com/g/p/92bbd25c572fe3bcd8f18fe59c4d2470.jpg_200x200q90.jpg",
        "price": 9198,
        "remark": "https://www.lazada.co.th/products/pdp-i5992955236.html",
        "sold": 0
    },
    {
        "product_name": "Integrated Litter Box 3-Tier Foldable Cat Kennel Large Space Multi-Level Cat Crate Spacious Interior Pet enclosure Easy to Clean for young cat Owners, Apartment Dwellers, Indoors, Home, Living Room, Bedroom",
        "product_image": "https://img.lazcdn.com/g/p/b0dbe3f5b1175af3dc75b1d37a4957ca.jpg_200x200q90.jpg",
        "price": 9018.78,
        "remark": "https://www.lazada.co.th/products/pdp-i6073678341.html",
        "sold": 0
    },
    {
        "product_name": "ถังทรายแมวอัตโนมัติ [78L] ขนาดใหญ่! ห้องโดยสารตรวจสอบอัตโนมัติ สำหรับแมวสัตว์เลี้ยงทุกสายพันธุ์ ใช้งานง่าย ปลอดภัย มั่นใจให้น้องแมวสะอาดตลอดวัน",
        "product_image": "https://img.lazcdn.com/g/p/db6fea2ca40c98d83853b879b0248cd4.jpg_200x200q90.jpg",
        "price": 8798,
        "remark": "https://www.lazada.co.th/products/pdp-i5989280421.html",
        "sold": 0
    },
    {
        "product_name": "PETX FRESH BOX V.1 เครื่องกำจัดกลิ่นสัตว์เลี้ยง ดับกลิ่นฉี่แมว ฉี่สุนัข กรองขนสัตว์ ฟอกอากาศ PM2.5",
        "product_image": "https://img.lazcdn.com/g/p/c628b376b951bc0240740b7f3f38cb6a.jpg_200x200q90.jpg",
        "price": 8400,
        "remark": "https://www.lazada.co.th/products/pdp-i1760188493.html",
        "sold": 68
    },
    {
        "product_name": "HELLOLEIBOO | เครื่องฟอกอากาศสำหรับสัตว์เลี้ยง กำจัดขนแมวลอยฟ้าอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbc1521b362da4273b992b696015318ee2.png_200x200q90.png",
        "price": 11552.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5960784042.html",
        "sold": 4
    },
    {
        "product_name": "โบลเวอร์ เติมอากาศบ่อปลา กุ้ง โบลเวอร์เติม-ดูดอากาศ  Ring Blower NORVAX รุ่น NVT-020 3สาย 0.2kW. 2P 380V. ท่อ 1 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/p/9de6766a8004ae5f67da919c22dab294.jpg_200x200q90.jpg",
        "price": 9180,
        "remark": "https://www.lazada.co.th/products/pdp-i5322294657.html",
        "sold": 0
    },
    {
        "product_name": "กล่องขยะสำหรับสัตว์เลี้ยงแบบพกพาและใช้แล้วทิ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2be77a9a1e2441f9bf43c83ed1866bdaQ.jpg_200x200q90.jpg",
        "price": 8350,
        "remark": "https://www.lazada.co.th/products/pdp-i16116611335.html",
        "sold": 0
    },
    {
        "product_name": "Automatic Cat Toilet ส้วมแมว ห้องน้ำแมวอัจฉริยะ รองรับแมวหลายตัว ดีไซน์ใหญ่ เชื่อมแอปได้ ห้องน้ำแมวอัต ห้องน้ำแมวอัตโนมัติรุ่น กระบะทราย ห้องน้ำเเมวแบบอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/p/b1b90a320c6860e5a55641a88e6167b7.png_200x200q90.png",
        "price": 8230,
        "remark": "https://www.lazada.co.th/products/pdp-i6071158510.html",
        "sold": 0
    },
    {
        "product_name": "【DUDU Pet】ห้องน้ำแมวกึ่งอัตโนมัติขนาดใหญ่พิเศษชนิดลิ้นชักที่ล้อมรอบกล่องทำความสะอาดเฟอร์นิเจอร์กล่องทรายแมว",
        "product_image": "https://img.lazcdn.com/g/p/4faf8ee94c9485cf1f70ffa54e039278.jpg_200x200q90.jpg",
        "price": 8116,
        "remark": "https://www.lazada.co.th/products/pdp-i2350471001.html",
        "sold": 2
    },
    {
        "product_name": "MULUOZI | กล่องทรายแมวขนาดใหญ่ ควบคุมกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf037ee4b32b546e4959edd61153956fb6.jpg_200x200q90.jpg",
        "price": 8007.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16100923613.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องดูดขนแมวแบบอัตโนมัติเครื่องฟอกอากาศสำหรับสัตว์เลี้ยงกำจัดขนแมวกำจัดกลิ่นเหม็นรสชาติบริสุทธิ์พิเศษสำหรับการเลี้ยงแมว เครื่องฟอกอากาศcat",
        "product_image": "https://img.lazcdn.com/g/p/55a3f49faa47500a140f849134cd8898.jpg_200x200q90.jpg",
        "price": 7998,
        "remark": "https://www.lazada.co.th/products/pdp-i6017519615.html",
        "sold": 1
    },
    {
        "product_name": "DIGITALPET ตู้เป่าขนสัตว์เลี้ยงอัจฉริยะ แรงดูดอันทรงพลัง+ชุดโกนหนวดลมแรงมาก ไดร์เป่าผมสุนัข ตู้เป่าขนแมว ไดร์เป่าผม",
        "product_image": "https://img.lazcdn.com/g/p/902ce5028c0c8fde3677519cb148433e.jpg_200x200q90.jpg",
        "price": 7960,
        "remark": "https://www.lazada.co.th/products/pdp-i16115993566.html",
        "sold": 0
    },
    {
        "product_name": "Lovinland แมวครอกกล่องห้องน้ำกึ่งอัตโนมัติลิ้นชักประเภททำความสะอาดกล่องกึ่งล้อมรอบทำความสะอาดง่ายป้องกันสาดทิปถังกรองเฟอร์นิเจอร์",
        "product_image": "https://img.lazcdn.com/g/p/b41b453f54634fd72f99009fc0b79f26.jpg_200x200q90.jpg",
        "price": 7894,
        "remark": "https://www.lazada.co.th/products/pdp-i4261911583.html",
        "sold": 0
    },
    {
        "product_name": "โปรโมชั่น+ []✨ พร้อมส่ง ห้องน้ำแมว UFO cat litter box ห้องน้ำแมว ห้องน้ำแมวUFO ห้องน้ำแมวอวกาศ ห้องน้ำแมวเหมียวอวกาศ ราคาถูก ห้องน้ำแมว ห้องน้ำแมวทรงโดม มีฝาครอบ ห้องน้ำแมวพับได้  ห้องน้ำแมวพกพา",
        "product_image": "https://img.lazcdn.com/g/p/88a4217ad7a1dfd8c5c9ffc8693a386a.jpg_200x200q90.jpg",
        "price": 7560,
        "remark": "https://www.lazada.co.th/products/pdp-i4702307823.html",
        "sold": 0
    },
    {
        "product_name": "navipet PETKIT Pura Max 2 Cylinder ถังใส่ทรายสำหรับห้องน้ำแมวรุ่น Pura Max2 Maxlite2",
        "product_image": "https://img.lazcdn.com/g/p/3908066f8e548a2c7491b69763c6c7c4.jpg_200x200q90.jpg",
        "price": 7000,
        "remark": "https://www.lazada.co.th/products/pdp-i5977397302.html",
        "sold": 0
    },
    {
        "product_name": "กันน้ำพับเก็บได้สำหรับสัตว์เลี้ยงกล่องทรายแมวกล่องทรายแมว",
        "product_image": "https://img.lazcdn.com/g/p/b39ccc3d0d841bffd163fb6c37afd700.jpg_200x200q90.jpg",
        "price": 6937.98,
        "remark": "https://www.lazada.co.th/products/pdp-i6062347938.html",
        "sold": 0
    },
    {
        "product_name": "หมอนรองนั่งสำหรับสัตว์เลี้ยงกันน้ำ ถอดออกได้ และป้องกันขน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa50fea48ff1b4681a483980ecf795581Z.jpg_200x200q90.jpg",
        "price": 6876,
        "remark": "https://www.lazada.co.th/products/pdp-i16124754123.html",
        "sold": 0
    },
    {
        "product_name": "DIGITALPET PetDryer ควบคุมอุณหภูมิได้การฆ่าเชื้อด้วยไอออนลบ ไดร์เป่าขนสัตว์เลี้ยง ตู้อบแมว เครื่องเป่าขนแมว ตู้เป่าขนแมว",
        "product_image": "https://img.lazcdn.com/g/p/e68f282fec64f3ffcbda5decc1be0639.jpg_200x200q90.jpg",
        "price": 6798,
        "remark": "https://www.lazada.co.th/products/pdp-i16115939927.html",
        "sold": 0
    },
    {
        "product_name": "CHONGXIAOQI | กล่องทรายแมวขนาดใหญ่ป้องกันน้ำกระเด็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S39d883d7fe1b4a2e83e242db1662f8b8m.jpg_200x200q90.jpg",
        "price": 6718,
        "remark": "https://www.lazada.co.th/products/pdp-i16092357327.html",
        "sold": 0
    },
    {
        "product_name": "ทรายแมวเบนโทไนต์ ควบคุมกลิ่นและฝุ่น 12.7 กก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S25bd4cc5dbf44e03bf69a7d557405e79I.jpg_200x200q90.jpg",
        "price": 6500,
        "remark": "https://www.lazada.co.th/products/pdp-i16118589533.html",
        "sold": 0
    },
    {
        "product_name": "ทรายแมวกล่องดำป้ายฟ้า ควบคุมกลิ่น ไม่มีฝุ่น 12.7 กก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S180560316bc24b3e80fa277a2b9d48081.jpg_200x200q90.jpg",
        "price": 6318,
        "remark": "https://www.lazada.co.th/products/pdp-i16120812170.html",
        "sold": 0
    },
    {
        "product_name": "Carpum | กล่องทรายแมวอัตโนมัติขนาดใหญ่กึ่งปิด ป้องกันกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbe18a2e5de364c0b855d271e1ca06b79U.jpg_200x200q90.jpg",
        "price": 6274,
        "remark": "https://www.lazada.co.th/products/pdp-i16111901631.html",
        "sold": 0
    },
    {
        "product_name": "กล่องทรายแมวสองชั้นขนาดใหญ่ พร้อมพื้นที่จัดเก็บด้านบน 86 ซม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0166f87e727942d595b8edea5fe81390j.jpg_200x200q90.jpg",
        "price": 6242.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16103324484.html",
        "sold": 0
    },
    {
        "product_name": "โปรโมชั่น+ MPS Toilette Netta Maxi กระบะทรายแมว และ ห้องน้ำแมว ขนาดใหญ่มาก แมวน้ำหนักมากกว่า6กิโลยังเข้าสบายๆๆ ราคาถูก ห้องน้ำแมว ห้องน้ำแมวทรงโดม มีฝาครอบ ห้องน้ำแมวพับได้  ห้องน้ำแมวพกพา",
        "product_image": "https://img.lazcdn.com/g/p/d20d9fe9e85f3f1be09c2c6e019d95ad.jpg_200x200q90.jpg",
        "price": 6200,
        "remark": "https://www.lazada.co.th/products/pdp-i4702334698.html",
        "sold": 0
    },
    {
        "product_name": "MOMOVIDA Pet Grooming Kit PG1 เครื่องดูดฝุ่นและตัดแต่งขนสัตว์เลี้ยง แรงดูดปรับได้ 3 ระดับ ระดับเสียงรบกวนสูงสุดเพียง 70dBA ความจุ 1.9 ลิตร ง่ายต่อการทำความสะอาด น้ำหนักเบาและเคลื่อนย้ายสะดวก",
        "product_image": "https://img.lazcdn.com/g/p/cbee7a2a674083527f47ea5e65b4bd0b.jpg_200x200q90.jpg",
        "price": 5998,
        "remark": "https://www.lazada.co.th/products/pdp-i5631672611.html",
        "sold": 0
    },
    {
        "product_name": "Aoresac ทำความสะอาดง่ายกล่องห้องน้ำสุนัขสำหรับลูกสุนัขสำหรับฝึกสุนัข",
        "product_image": "https://img.lazcdn.com/g/p/0301382cce42d0c3f7429622efc782a4.jpg_200x200q90.jpg",
        "price": 5982,
        "remark": "https://www.lazada.co.th/products/pdp-i5940621830.html",
        "sold": 0
    },
    {
        "product_name": "กล่องทรายแมวแบบปิดฝาเปิดปิด ขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd8b878dad5a2482db5e28442fad480eaR.jpg_200x200q90.jpg",
        "price": 5974,
        "remark": "https://www.lazada.co.th/products/pdp-i16089340258.html",
        "sold": 0
    },
    {
        "product_name": "โปรโมชั่น+ Unicharm Pet Deo Toilet ห้องน้ำแมว unicharm กระบะทรายแมว ห้องน้ำแมวลดกลิ่น แบบมีฝาครอบ [UN02] ราคาถูก ห้องน้ำแมว ห้องน้ำแมวทรงโดม มีฝาครอบ ห้องน้ำแมวพับได้  ห้องน้ำแมวพกพา",
        "product_image": "https://img.lazcdn.com/g/p/30e3f71a08754a3fe0f08a83b5a4e24a.jpg_200x200q90.jpg",
        "price": 5960,
        "remark": "https://www.lazada.co.th/products/pdp-i4702330616.html",
        "sold": 0
    },
    {
        "product_name": "โปรโมชั่น+ Deo toilet เดโอทอยเล็ท ห้องน้ำแมว ลดกลิ่น จาก Unicharm รุ่น มีฝาครอบ (เปิดได้) ราคาถูก ห้องน้ำแมว ห้องน้ำแมวทรงโดม มีฝาครอบ ห้องน้ำแมวพับได้  ห้องน้ำแมวพกพา",
        "product_image": "https://img.lazcdn.com/g/p/554a5bc126df5c6b515ef5a821c4f935.jpg_200x200q90.jpg",
        "price": 5960,
        "remark": "https://www.lazada.co.th/products/pdp-i4702305838.html",
        "sold": 0
    },
    {
        "product_name": "LP83 กรงไม้ อะคริลิค ขนาดใหญ่ เป็นไม้เกรดA สำหรับสัตว์เลี้ยง หนูแฮมเตอร์ งู เม่น แกสบี้ นก กระต่าย กิ้งก่า เต่า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S08737b6138a64bcfaee6df4029ed300b3.jpg_200x200q90.jpg",
        "price": 5950.56,
        "remark": "https://www.lazada.co.th/products/pdp-i2918291868.html",
        "sold": 4
    },
    {
        "product_name": "Aoresac กล่องพ่นละอองยาสำหรับสัตว์เลี้ยงห้องออกซิเจนสำหรับแมวสุนัขแมว",
        "product_image": "https://img.lazcdn.com/g/p/6e830d7cc1c0ea0669394e0df0cec010.jpg_200x200q90.jpg",
        "price": 5898,
        "remark": "https://www.lazada.co.th/products/pdp-i5940478756.html",
        "sold": 0
    },
    {
        "product_name": "HOOPET | เสาลับเล็บแมว คอนโดแมวสำหรีบปีนป่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc47a5a13c15544e8823023b339dc7757k.jpg_200x200q90.jpg",
        "price": 5880.24,
        "remark": "https://www.lazada.co.th/products/pdp-i5894621776.html",
        "sold": 101
    },
    {
        "product_name": "Ongsee เตียงสำหรับสัตว์เลี้ยงที่นอนสุนัขยกระดับเตียงสัตว์เลี้ยงกรอบเสื่อที่ถอดออกได้เตียงนอนแมวเบาะนอนน้องแมวแบบพกพาสำหรับแมวและลูกสุนัขในร่ม",
        "product_image": "https://img.lazcdn.com/g/p/981d5b0315ec39405e58ca10265346e4.jpg_200x200q90.jpg",
        "price": 5862,
        "remark": "https://www.lazada.co.th/products/pdp-i5850308465.html",
        "sold": 0
    },
    {
        "product_name": "SHANNAIER | รั้วสุนัขและแมวแบบยืดขยายได้ ไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sab3993ee54d24a84b32303d9cfa4198d9.jpg_200x200q90.jpg",
        "price": 5828.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16062411587.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องเป่าขนสัตว์เลี้ยง ตู้อบแมวอัตโนมัติ Pet Dryer Box สำหรับแมวและสุนัข ระบบ PTC อบแห้งเร็ว เสียงเงียบ ควบคุมอุณหภูมิ ตั้งเวลาได้",
        "product_image": "https://img.lazcdn.com/g/p/cf47b0b7f99cda0f8b9b440441f3b79c.png_200x200q90.png",
        "price": 5776,
        "remark": "https://www.lazada.co.th/products/pdp-i16092791302.html",
        "sold": 3
    },
    {
        "product_name": "TAYISHENG | กล่องทรายแมวปิดขนาดใหญ่ป้องกันกลิ่นไม่หกเลอะเทอะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8417d4babb934500b9c38241023ec993O.jpg_200x200q90.jpg",
        "price": 5676,
        "remark": "https://www.lazada.co.th/products/pdp-i16118631369.html",
        "sold": 0
    },
    {
        "product_name": "petsche | กล่องทรายแมวพับได้ขนาดใหญ่พกพาสะดวก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbcbcd8de8843469bb26b3fda074d059fN.jpg_200x200q90.jpg",
        "price": 5600,
        "remark": "https://www.lazada.co.th/products/pdp-i16087247265.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องฟอกอากาศสำหรับสัตว์เลี้ยงดูดขนแมว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S46e228364ac74a23b57a3b6727a595be7.jpg_200x200q90.jpg",
        "price": 2776.84,
        "remark": "https://www.lazada.co.th/products/pdp-i5893812456.html",
        "sold": 1
    },
    {
        "product_name": "Moon OKY อุปกรณ์สำหรับสัตว์เลี้ยงทำจากสแตนเลสสตีลทนทานกล่องทรายแมวสำหรับถาดชำระโลหะทำความสะอาดง่ายแบบพกพาสำหรับแมวเล็กและใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/3d0f644451f619b7410e406bb77361dc.jpg_200x200q90.jpg",
        "price": 5398.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16118708046.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องให้อาหารสัตว์อัตโนมัติ โซล่า(ชุดไก่นอนนา)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdcfef4d24d644f449eb6bc2a68f509c2Y.jpg_200x200q90.jpg",
        "price": 5398,
        "remark": "https://www.lazada.co.th/products/pdp-i4990388407.html",
        "sold": 8
    },
    {
        "product_name": "[MALETKHAO] Catit (แคทอิท) SmartSift​​ ห้องน้ำแมว​คันโยก​ แยกมูลอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/p/989f9f2a0c17412307a4fc7063f5a518.jpg_200x200q90.jpg",
        "price": 5378,
        "remark": "https://www.lazada.co.th/products/pdp-i5039887901.html",
        "sold": 0
    },
    {
        "product_name": "กระบะทรายแมวขนาดใหญ ถาดรองฉแมว ตกแตงบานแมว โถสขภณฑรปยานอวกาศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S83aa0143800347c5b613b4fef6fc42a99.jpg_200x200q90.jpg",
        "price": 5367.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16075007577.html",
        "sold": 0
    },
    {
        "product_name": "สแตนเลสกล่องครอกแมวขนาดใหญ่พิเศษป้องกันการกระเด็นรายการด้านบนโลหะด้านสูงกล่องครอกแมวถาดสำหรับแมวขนาดใหญ่ (สีเทาอ่อน)",
        "product_image": "https://img.lazcdn.com/g/p/070db59323384a1db1f561992fd1abb3.jpg_200x200q90.jpg",
        "price": 5336,
        "remark": "https://www.lazada.co.th/products/pdp-i16120468287.html",
        "sold": 0
    },
    {
        "product_name": "MAVIS LAVEN สแตนเลสกล่องทรายแมวพับได้ปิดมิดชิดครอกพร้อมที่ตักสำหรับร้านขายสัตว์เลี้ยงที่บ้าน (สีชมพูพีช)",
        "product_image": "https://img.lazcdn.com/g/p/56e056de43622d90e4bddc06e4e3e691.jpg_200x200q90.jpg",
        "price": 5230,
        "remark": "https://www.lazada.co.th/products/pdp-i16051961976.html",
        "sold": 0
    },
    {
        "product_name": "KDO แปรงหวีขน สุดยอดสินค้า ถูกสุด PetNeedleComb แปรงหวีขนสัตว์เลี้ยง แปรงขนแมวสุนัข แบบพรีเมี่ยม ที่แปรงขน แปรงหมุดป้องกันการดึงขนน้อง แปรงหวีขนสัตว์ แปรงหวีขนสุนัข",
        "product_image": "https://img.lazcdn.com/g/p/6cd0080a3d3c8d20f804dc1875441184.jpg_200x200q90.jpg",
        "price": 5132,
        "remark": "https://www.lazada.co.th/products/pdp-i3375553225.html",
        "sold": 0
    },
    {
        "product_name": "Catit Smartsift ห้องน้ำแมวคันโยก ห้องน้ำโดมสำหรับแมว Size XL ขนาด 66x48x63 ซม.",
        "product_image": "https://img.lazcdn.com/g/p/d00eabbcfe2f40345e90cf887494be95.jpg_200x200q90.jpg",
        "price": 4998,
        "remark": "https://www.lazada.co.th/products/pdp-i746860107.html",
        "sold": 16
    },
    {
        "product_name": "𝗬𝘂𝗺𝗲' 𝗽𝗿𝗲𝗺𝗶𝘂𝗺 𝗽𝗲𝘁 𝗯𝗲𝗱 ที่นอนสัตว์เลี้ยงมีสไตล์ ที่นอนหมา ที่นอนแมว สไตล์ใหม่",
        "product_image": "https://img.lazcdn.com/g/p/66fb73e730bf3f6a2b429b2750fe873a.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i5069050631.html",
        "sold": 1
    },
    {
        "product_name": "GT90,GT75โต๊ะกรูมมิ่ง,โต๊ะตัดขนสุนัข,พับเก็บได้  แข็งแรงมาก มีด้ามจับหิ้ว เสาโต๊ะยาวถึง 120 ซม. ปรับระดับเสาได้ เสาเหลี่ยมแข็งแรง",
        "product_image": "https://img.lazcdn.com/g/p/ed375f82276a333df5cb279a5f2539ff.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i4374725284.html",
        "sold": 2
    },
    {
        "product_name": "กล่องครอกแมวกึ่งอัตโนมัติ กล่องครอกกึ่งปิดขนาดใหญ่พลาสติกแข็งแรงทนทานสำหรับแมวในร่ม",
        "product_image": "https://img.lazcdn.com/g/p/fbe523a0b9bac0404a86b0b5b28b9157.jpg_200x200q90.jpg",
        "price": 4810,
        "remark": "https://www.lazada.co.th/products/pdp-i16128657512.html",
        "sold": 0
    },
    {
        "product_name": "กล่องครอกแมว Hamwesh การออกแบบที่กว้างขวางด้านข้างสูงป้องกันการรั่วไหลการควบคุมกลิ่นกึ่งปิดกล่องครอกแมวขนาดใหญ่พิเศษพร้อมทำความสะอาดง่ายสำหรับแมวหลาย",
        "product_image": "https://img.lazcdn.com/g/p/88e2f9d822d63c161c6660082f97f80c.jpg_200x200q90.jpg",
        "price": 4810,
        "remark": "https://www.lazada.co.th/products/pdp-i16127753198.html",
        "sold": 0
    },
    {
        "product_name": "Catit SmartSift ห้องน้ำแมว​คันโยก​ แยกมูลอัตโนมัติ​ กระบะทรายแมว เหมาะกับแมวทุกขนาด ทุกสายพันธุ์",
        "product_image": "https://img.lazcdn.com/g/p/bbb0d3a2781fac93b43b621e8d213515.jpg_200x200q90.jpg",
        "price": 4798,
        "remark": "https://www.lazada.co.th/products/pdp-i5862960513.html",
        "sold": 0
    },
    {
        "product_name": "ห้องน้ำแมว​คันโยก​ แยกมูลอัตโนมัติ Catit SmartSift​ รุ่นใหม่สีขาว​ กระบะทรายแมว ส้วมแมว​ ​ของแท้ 100% คุณภาพสูง",
        "product_image": "https://img.lazcdn.com/g/p/6f39f93599c8c1b2676866ca24a6c585.jpg_200x200q90.jpg",
        "price": 4780,
        "remark": "https://www.lazada.co.th/products/pdp-i4295938791.html",
        "sold": 0
    },
    {
        "product_name": "SHENJINGMAO | ทาวเวอร์แมวไม้จริงหลายชั้นประหยัดพื้นที่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sebb8e75358c24483871e63e0aac391a3q.jpg_200x200q90.jpg",
        "price": 4746.28,
        "remark": "https://www.lazada.co.th/products/pdp-i6045912165.html",
        "sold": 6
    },
    {
        "product_name": "Momovida เครื่องให้อาหารและน้ำอัตโนมัติ 2 IN 1 WiFi และแอปควบคุม สำหรับสัตว์เลี้ยง สุนัข แมว รุ่น PTM-30A1",
        "product_image": "https://img.lazcdn.com/g/p/47904583a3ca18c71fd2b31a858d744c.jpg_200x200q90.jpg",
        "price": 4718,
        "remark": "https://www.lazada.co.th/products/pdp-i5977660285.html",
        "sold": 3
    },
    {
        "product_name": "พรมควบคุมขยะสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf1ed685b2a8a400ea4fab61b254f53f1s.jpg_200x200q90.jpg",
        "price": 4612,
        "remark": "https://www.lazada.co.th/products/pdp-i16116582681.html",
        "sold": 0
    },
    {
        "product_name": "GIORGIO ARMANI MALL#[ส่งเร็วจากกทม]กรงสุนัขใหญ่ กรงหมา กรงสุนัข กรงสุนัขท่อเหลี่ยมขนาดใหญ่ กรงสุนัขขนาดใหญ่ แข็งแรง ทนทาน กรงสัตว์เลี้ยง กรงสุนัข พับได้ พร้อมถาดพลาสติก เหมาะสำหรับ สุนัข แมว กระต่าย มอบของขวัญ",
        "product_image": "https://img.lazcdn.com/g/p/92f93f39ad58625e94160b1ec96e2490.jpg_200x200q90.jpg",
        "price": 4590,
        "remark": "https://www.lazada.co.th/products/pdp-i5796563370.html",
        "sold": 1
    },
    {
        "product_name": "ลังแมวแบบพับได้ทำความสะอาดง่ายแบบพกพาวัสดุ PP บ้านสุนัขแบบระบายอากาศได้ติดตั้งง่ายพับเก็บได้สำหรับการเดินป่าสำหรับตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/40e602d3646583d3b0154a420198e77c.jpg_200x200q90.jpg",
        "price": 4590,
        "remark": "https://www.lazada.co.th/products/pdp-i6042918791.html",
        "sold": 0
    },
    {
        "product_name": "Arm & Hammer® Pet Fresh Carpet Odor Eliminator 850 g ผงดูแลพรม ลดกลิ่นสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/p/35c344b456e1ddef1410a9f8e52e3f57.png_200x200q90.png",
        "price": 4570,
        "remark": "https://www.lazada.co.th/products/pdp-i16100361270.html",
        "sold": 0
    },
    {
        "product_name": "Meoof | พรมรองน้ำยาทรายแมวป้องกันการกระเด็น ทำความสะอาดง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb4afeefa834c4388ad6bcd2c80001565M.jpg_200x200q90.jpg",
        "price": 4567.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6054964781.html",
        "sold": 35
    },
    {
        "product_name": "Iris กรงกระต่ายไอริส Iris Rabbit Cage UK650",
        "product_image": "https://img.lazcdn.com/g/p/c1202dce21dfe678aae894ca34133a7b.jpg_200x200q90.jpg",
        "price": 4560,
        "remark": "https://www.lazada.co.th/products/pdp-i3395196011.html",
        "sold": 0
    },
    {
        "product_name": "พรมกันทรายแมว สองชั้น กรองทรายแมว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sad091edb16c24c55980618398bc9b2361.jpg_200x200q90.jpg",
        "price": 4537.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16116552800.html",
        "sold": 0
    },
    {
        "product_name": "NEW AGE PET กระบะทรายแมวสแตนเลส แบบปิดเต็ม ไม่มีกลิ่น ไม่ติดคราบ ล้างง่าย กันทรายกระเด็น ปลอดภัย",
        "product_image": "https://img.lazcdn.com/g/p/8ae090c8c7842cab947a01f419dce7a9.png_200x200q90.png",
        "price": 4398,
        "remark": "https://www.lazada.co.th/products/pdp-i16125425295.html",
        "sold": 0
    },
    {
        "product_name": "Keluojing | กล่องทรายแมวแบบลิ้นชักขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0da4776209ed4aea86bf5ecc4d82a1e3r.png_200x200q90.png",
        "price": 4332.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16062131933.html",
        "sold": 0
    },
    {
        "product_name": "ที่เลี้ยงสุนัขแบบพับได้ ทนทานต่อการกัดของสัตว์เลี้ยง ขนาดกลาง ขนาดเล็ก ที่เลี้ยงแมว ที่เลี้ยงกระต่าย ที่เลี้ยงสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd9ec444ccd22464a8811bb9e1d6a41c75.jpg_200x200q90.jpg",
        "price": 4296,
        "remark": "https://www.lazada.co.th/products/pdp-i5951157745.html",
        "sold": 0
    },
    {
        "product_name": "MAIKAJI | อุปกรณ์พิเศษอัจฉริยะสำหรับกล่องขยะแมว E1 Model",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2de972303ee74722afcedbcff5aae51bG.jpg_200x200q90.jpg",
        "price": 4216,
        "remark": "https://www.lazada.co.th/products/pdp-i16127648486.html",
        "sold": 0
    },
    {
        "product_name": "Cator | ทรายแมวควบคุมกลิ่น ไม่มีฝุ่น ไม่ติดกัน 2.6 กก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S39640287d21f4323ba29e56933fbf6f6j.png_200x200q90.png",
        "price": 4201.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5990922866.html",
        "sold": 23
    },
    {
        "product_name": "โปรโมชั่น+ Unicharm Pet Deo Toilet ห้องน้ำแมว unicharm ห้องน้ำแมวลดกลิ่น แบบไม่มีฝาครอบ [UN01] ราคาถูก ห้องน้ำแมว ห้องน้ำแมวทรงโดม มีฝาครอบ ห้องน้ำแมวพับได้  ห้องน้ำแมวพกพา",
        "product_image": "https://img.lazcdn.com/g/p/c86c54be3532e2cdc003822244ce55ff.jpg_200x200q90.jpg",
        "price": 4200,
        "remark": "https://www.lazada.co.th/products/pdp-i4702344558.html",
        "sold": 0
    },
    {
        "product_name": "cat toilet ห้องน้ำแมว (กึ่งอัตโนมัติ) My monster ของแท้ พลาสติก หนาแข็งแรง สีขาวชมพู/ ใช้ง่ายสะดวกสบายแค่พลิก ไม่ต้องสัมผัสกับปฏิกูลใดๆ ป้องกัน,ยับยั้งแบคทีเรีย กระบะไม่เหลืองดำ นอกจากนั้นยังช่วยประหยัดทรายแมว,ช่วยลดกลิ่นที่ไม่พึงประสงค์ แถมฟรี หมวกแก๊ป",
        "product_image": "https://img.lazcdn.com/g/p/0c0124fa6e9a91485bc448a6101f50aa.jpg_200x200q90.jpg",
        "price": 3998,
        "remark": "https://www.lazada.co.th/products/pdp-i639688283.html",
        "sold": 0
    },
    {
        "product_name": "ห้องน้ำแมว กึ่งอัตโนมัติ (Smartsift) กระบะทราย กระบะทรายแมว - PUPPY KITTENS",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa46b4fb1541940b28f4f29cb46ac4be75.jpg_200x200q90.jpg",
        "price": 4198,
        "remark": "https://www.lazada.co.th/products/pdp-i2806717068.html",
        "sold": 12
    },
    {
        "product_name": "กรงพับได้สำหรับสุนัขและแมวขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S25ae2b3706a5453f83cc646198dbcef6v.jpg_200x200q90.jpg",
        "price": 4106.46,
        "remark": "https://www.lazada.co.th/products/pdp-i6016644102.html",
        "sold": 1
    },
    {
        "product_name": "กล่องทรายแมวป้องกันกระเด็นขนาดใหญ่พิเศษ ขจัดกลิ่น สแตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3b84d810f0a1414d97dd53bbf1175035o.jpg_200x200q90.jpg",
        "price": 4081.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16116766221.html",
        "sold": 0
    },
    {
        "product_name": "ถุงมือกำจัดขนสัตว์เลี้ยงแบบไฟฟ้าสถิต รุ่นอัพเกรดปี 2025, ถุงมือกำจัดขนสัตว์เลี้ยงแบบใช้ซ้ำได้สำหรับแมวและสุนัข, ถุงมือกำจัดขนแมวและสุนัขคุณภาพพรีเมียมสำหรับโซฟา เฟอร์นิเจอร์ พรม และเบาะรถยนต์ (2)",
        "product_image": "https://img.lazcdn.com/g/p/1e2606b0aa341aa1d306ae60250174d4.jpg_webp_200x200q90.jpg",
        "price": 4030.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16080985000.html",
        "sold": 0
    },
    {
        "product_name": "กล่องทรายแมวห้องน้ำแมวชามป้อนอาหารเด็กกันรั่วไหลพลาสติกขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/eef18d73aa1184fc18d1785fac413f8e.jpg_200x200q90.jpg",
        "price": 4016,
        "remark": "https://www.lazada.co.th/products/pdp-i6055506033.html",
        "sold": 0
    },
    {
        "product_name": "CLPOWER | ไดร์เป่าขนสัตว์เลี้ยงพลังสูงเงียบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S62730e53d54843f7b9862f97596de208S.png_200x200q90.png",
        "price": 4014,
        "remark": "https://www.lazada.co.th/products/pdp-i16044605649.html",
        "sold": 0
    },
    {
        "product_name": "Miffer ห้องน้ำทรายแมวแฟชั่นกันน้ำกระเซ็นกับที่ตักลูกแมวทำความสะอาดง่ายสำหรับทรายแมวทุกชนิด",
        "product_image": "https://img.lazcdn.com/g/p/02ec930b2637fdb99e5499dd1f664bed.jpg_200x200q90.jpg",
        "price": 4011.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16128922105.html",
        "sold": 0
    },
    {
        "product_name": "++ของแท้ Sterpet ( 15 แคปซูล ) เนื้องอกมะเร็งจัดการได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se6a8da179ffb400c8cd5d4be0f1ee96cJ.jpg_200x200q90.jpg",
        "price": 4000,
        "remark": "https://www.lazada.co.th/products/pdp-i5208796138.html",
        "sold": 27
    },
    {
        "product_name": "cat toilet ห้องน้ำแมว (กึ่งอัตโนมัติ) My monster ของแท้ พลาสติก หนาแข็งแรง สีขาวครีม/ใช้ง่ายสะดวกสบายแค่พลิก ไม่ต้องสัมผัสกับปฏิกูลใดๆ ป้องกัน,ยับยั้งแบคทีเรีย กระบะไม่เหลืองดำ นอกจากนั้นยังช่วยประหยัดทรายแมว,ช่วยลดกลิ่นที่ไม่พึงประสงค์ แถมฟรี หมวกแก๊ป",
        "product_image": "https://img.lazcdn.com/g/p/1c3a49eadc282d0f1cd4a000c3e6a03f.png_200x200q90.png",
        "price": 3998,
        "remark": "https://www.lazada.co.th/products/pdp-i639572331.html",
        "sold": 0
    },
    {
        "product_name": "Carpum | กล่องทรายแมวป้องกันกลิ่นและไม่เลอะ แบบปิดสนิท",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S34793128b61347e2a102999ea51c31bce.jpg_200x200q90.jpg",
        "price": 3954,
        "remark": "https://www.lazada.co.th/products/pdp-i16111782847.html",
        "sold": 0
    },
    {
        "product_name": "Prettyia แพสระน้ำสำหรับสุนัขลอยน้ำได้เสื่อเป่าลมลอยได้เรือสัตว์เลี้ยงลอยน้ำได้สำหรับเล่นเกมทางน้ำกลางแจ้งในฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/a59b9ee596d0f629c028532ebbf00dab.jpg_200x200q90.jpg",
        "price": 3930.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16071380219.html",
        "sold": 0
    },
    {
        "product_name": "Gaines | แผ่นรองฉี่สัตว์เลี้ยงป้องกันกลิ่นและยับยั้งแบคทีเรีย 10 แผ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S56da1e3da28b4c58afd3d1739ffdad01d.png_200x200q90.png",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i16124964286.html",
        "sold": 0
    },
    {
        "product_name": "(ยกชุด6ใบ) กรงเดินทางสัตว์เลี้ยง ไซส์ L ยกชุด6ใบ เหมาะสำหรับฟาร์มและเพ็ทช๊อป",
        "product_image": "https://img.lazcdn.com/g/p/b39fcd9d885be345eeeb32e1f122cbf4.png_200x200q90.png",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i5362373111.html",
        "sold": 1
    },
    {
        "product_name": "WRA ทิชชู่เปียก แผ่นทำความสะอาด ซื้อ5แถม1 แพ็กใหญ่ ทิชชู่เปียก  ผ้าเปียก เช็ดทำความสะอาดสัตว์เลี้ยง ผ้าเช็ดทำความสะอาด กระดาษทำความสะอาด",
        "product_image": "https://img.lazcdn.com/g/p/50dacfbd767961aad81b0b1680b1eeaf.jpg_200x200q90.jpg",
        "price": 3890,
        "remark": "https://www.lazada.co.th/products/pdp-i5784197211.html",
        "sold": 0
    },
    {
        "product_name": "ถังรีดนมความจุมาก10L สำหรับปศุสัตว์โครงสร้างเหล็กกล้าไร้สนิมกันสนิม",
        "product_image": "https://img.lazcdn.com/g/p/b93359c01dfd4e65bdebe50bd8063687.jpg_200x200q90.jpg",
        "price": 3886.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6014781349.html",
        "sold": 0
    },
    {
        "product_name": "NEW AGE PET กระบะทรายแมวสแตนเลส แบบกึ่งปิด ไม่มีกลิ่น ไม่ติดคราบ ล้างง่าย กันทรายกระเด็น ทนทาน",
        "product_image": "https://img.lazcdn.com/g/p/b52d2797c7e3304da58fca83aa0b0e66.png_200x200q90.png",
        "price": 3798,
        "remark": "https://www.lazada.co.th/products/pdp-i16125594802.html",
        "sold": 0
    },
    {
        "product_name": "Miffer กระโถนแมวสแตนเลสกล่องทิ้งขยะทนทานสำหรับสัตว์เล็ก",
        "product_image": "https://img.lazcdn.com/g/p/ea8adcee17927e8f978cb0038b9e2d41.jpg_200x200q90.jpg",
        "price": 3782.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16118313585.html",
        "sold": 0
    },
    {
        "product_name": "(ยกชุด10ใบ) กรงเดินทางสัตว์เลี้ยงไซส์ m 10ชุด คละสีหูหิ้วขาว เหมาสำหรับฟาร์มและเพ็ทช๊อป",
        "product_image": "https://img.lazcdn.com/g/p/86ba610a9ab8731a80bad8ab8890cba9.png_200x200q90.png",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i5362340141.html",
        "sold": 1
    },
    {
        "product_name": "เสื่อกันน้ำอเนกประสงค์สำหรับให้อาหารแมวเสื่อรองที่เก็บขี้แมวซิลิโคนหนาเสื่อรองที่เก็บขี้แมวทำความสะอาดง่าย",
        "product_image": "https://img.lazcdn.com/g/p/ccf3f629447a20de56799db727fa0666.jpg_200x200q90.jpg",
        "price": 3766,
        "remark": "https://www.lazada.co.th/products/pdp-i16130822869.html",
        "sold": 0
    },
    {
        "product_name": "โปรโมชั่น+ Unicharm Pet Deo toilet เดโอทอยเล็ท ห้องน้ำแมวลดกลิ่น แบบไม่มีฝาครอบ ราคาถูก ห้องน้ำแมว ห้องน้ำแมวทรงโดม มีฝาครอบ ห้องน้ำแมวพับได้  ห้องน้ำแมวพกพา",
        "product_image": "https://img.lazcdn.com/g/p/8fead39ac4f76c8b0c4efe0783219e3f.jpg_200x200q90.jpg",
        "price": 3756,
        "remark": "https://www.lazada.co.th/products/pdp-i4702371414.html",
        "sold": 0
    },
    {
        "product_name": "ตู้กกลูกนก ตู้ฟักไข่ ตู้สำหรับสัตว์เลี้ยง Exotic พ่นยาให้ออกซิเจน",
        "product_image": "https://img.lazcdn.com/g/p/e47eef8d37c8a5a0626c25177b6e845e.jpg_200x200q90.jpg",
        "price": 3750.74,
        "remark": "https://www.lazada.co.th/products/pdp-i2310615638.html",
        "sold": 21
    },
    {
        "product_name": "เครื่องดูดขนสัตว์เลี้ยง Pet Grooming Vacuum Kit เครื่องตัดแต่งขน และดูดฝุ่น สำหรับสัตว์เลี้ยง การตัดแต่งสัตว์เลี้ยง ใช้ได้ทั้งสุนัขและแมว  ดูดซับเส้นขนได้ง่าย",
        "product_image": "https://img.lazcdn.com/g/p/8532a92e7609dfe890b8ac00532aa084.png_200x200q90.png",
        "price": 3714,
        "remark": "https://www.lazada.co.th/products/pdp-i4984645339.html",
        "sold": 145
    },
    {
        "product_name": "กล่องขยะสัตว์เลี้ยงปิดอัตโนมัติแบบครึ่งแมนนวลขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S72b8d65a716a48c780989e654b1efbeet.png_200x200q90.png",
        "price": 3646,
        "remark": "https://www.lazada.co.th/products/pdp-i16112036206.html",
        "sold": 0
    },
    {
        "product_name": "ABEYINUOR | กล่องทรายปิดกั้นกลิ่นขนาดใหญ่พิเศษ ไม่กระเด็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sba7ccd1fea644da980e62bad633873181.jpg_200x200q90.jpg",
        "price": 3646,
        "remark": "https://www.lazada.co.th/products/pdp-i16125593027.html",
        "sold": 0
    },
    {
        "product_name": "AutoBot | กล่องทรายแมวเงียบ ควบคุมทรายถ่านช่วยดับกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S14312ce67d894c1ea657bc368d15e0357.jpg_200x200q90.jpg",
        "price": 3608,
        "remark": "https://www.lazada.co.th/products/pdp-i16120021106.html",
        "sold": 0
    },
    {
        "product_name": "Paw & Pal ผลิตภัณฑ์ทำความสะอาดอเนกประสงค์ สำหรับสัตว์เลี้ยง Pet Multipurpose Cleaner 500ml.",
        "product_image": "https://img.lazcdn.com/g/p/41b73b0813f600fcdcd801fa6a4a5b2f.png_200x200q90.png",
        "price": 3600,
        "remark": "https://www.lazada.co.th/products/pdp-i5377256615.html",
        "sold": 0
    },
    {
        "product_name": "Unicharm Easy-toilet ห้องน้ำแมวลดกลิ่น เก็บกลิ่น อีซี่ทอยเล็ท แบบกว้างสบาย สำหรับแมวตัวใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/fd37765ac6764f16aec9645df7d61f2d.jpg_200x200q90.jpg",
        "price": 3578,
        "remark": "https://www.lazada.co.th/products/pdp-i4166447429.html",
        "sold": 111
    },
    {
        "product_name": "Moon Okey ห้องน้ำสุนัขพร้อมท่อระบายน้ำแบบพกพา",
        "product_image": "https://img.lazcdn.com/g/p/4137bc586d8006547ca93c834e68d0b4.jpg_200x200q90.jpg",
        "price": 3569.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16070900417.html",
        "sold": 0
    },
    {
        "product_name": "โปรโมชั่น+ PETLOVE เครื่องให้น้ำแมวอัตโนมัติ 2 ลิตร โถน้ำแมว วัสดุปลอดภัยไม่มีสนิม มีระบบป้องกันน้ำแห้งไหม้ ราคาถูก ห้องน้ำแมว ห้องน้ำแมวทรงโดม มีฝาครอบ ห้องน้ำแมวพับได้  ห้องน้ำแมวพกพา",
        "product_image": "https://img.lazcdn.com/g/p/906fa88308d87b5f6d1db23b5debd754.jpg_200x200q90.jpg",
        "price": 3560,
        "remark": "https://www.lazada.co.th/products/pdp-i4702417092.html",
        "sold": 0
    },
    {
        "product_name": "ZHONGHENG | กล่องทรายแมวขนาดใหญ่ป้องกันกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scfa51d60e3c3463f8eac602800165b48a.jpg_200x200q90.jpg",
        "price": 3560,
        "remark": "https://www.lazada.co.th/products/pdp-i16089339249.html",
        "sold": 0
    },
    {
        "product_name": "ABEYINUOR | กล่องทรายแมวป้องกันกลิ่นแบบปิด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S00c20411721c4b8dbd9e06f9ad24a61cR.jpg_200x200q90.jpg",
        "price": 3548,
        "remark": "https://www.lazada.co.th/products/pdp-i16141904496.html",
        "sold": 0
    },
    {
        "product_name": "BOBOKALA | กล่องทรายแมวป้องกันกลิ่นและไม่กระเด็น 70 ซม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S267faf11d8564448a1b058f59155cc9dS.png_200x200q90.png",
        "price": 3538,
        "remark": "https://www.lazada.co.th/products/pdp-i16120319187.html",
        "sold": 0
    },
    {
        "product_name": "ABEYINUOR | กล่องทรายแมวขนาดใหญ่กันน้ำและกันกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S95c03ed0ef0e4233aae4debe1a7c434fh.jpg_200x200q90.jpg",
        "price": 3506,
        "remark": "https://www.lazada.co.th/products/pdp-i16141611106.html",
        "sold": 0
    },
    {
        "product_name": "PRYNWAN Pets - Cotton Square Pet Bed ที่นอนสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/p/350cac40fe681b59283dc164c63da237.jpg_200x200q90.jpg",
        "price": 3500,
        "remark": "https://www.lazada.co.th/products/pdp-i5711087565.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องกำจัดกลิ่นกล่องทรายแมวครอกแมวเหมาะสำหรับตู้เสื้อผ้าห้องสัตว์เลี้ยงทุกชนิดตู้รองเท้าห้องครัวห้องน้ำพื้นที่ขนาดเล็กกำจัดกลิ่นและฝุ่นอัจฉริยะ",
        "product_image": "https://img.lazcdn.com/g/p/3b4376515f4a7993af79eb768dbf2e21.png_200x200q90.png",
        "price": 3484,
        "remark": "https://www.lazada.co.th/products/pdp-i4883830480.html",
        "sold": 0
    },
    {
        "product_name": "ไฟฉายความปลอดภัยสำหรับสุนัขเดินกลางคืน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0f0264d4ee694083a97777e17e75f564C.jpg_200x200q90.jpg",
        "price": 3482.32,
        "remark": "https://www.lazada.co.th/products/pdp-i16116615096.html",
        "sold": 0
    },
    {
        "product_name": "กล่องขยะแมวปิดสนิท กันกลิ่น กันน้ำ ป้องกันกระเด็น ขนาดใหญ่พิเศษ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdc40452d347d4cf0bff9a025eed953dfC.jpg_200x200q90.jpg",
        "price": 3482,
        "remark": "https://www.lazada.co.th/products/pdp-i16129428482.html",
        "sold": 0
    },
    {
        "product_name": "TIANDONGLI | กล่องทรายแมวขนาดใหญ่ ป้องกันกลิ่นและป้องกันการหกรั่ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc50402f9ae8e4952a8a3136ce6d9fd6fb.jpg_200x200q90.jpg",
        "price": 3480,
        "remark": "https://www.lazada.co.th/products/pdp-i16089346254.html",
        "sold": 0
    },
    {
        "product_name": "BOBOKALA | กล่องทรายแมวป้องกันกระเด็น ทนต่อการเกิดกลิ่น ขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4ae4eab380764c089f50edc76e9f1836p.jpg_200x200q90.jpg",
        "price": 3466,
        "remark": "https://www.lazada.co.th/products/pdp-i16120816225.html",
        "sold": 0
    },
    {
        "product_name": "[2025 ใหม่] เซิร์ฟเวอร์ลูกบอลอัตโนมัติอัจฉริยะสำหรับสัตว์เลี้ยง เครื่องขว้างลูกบอลฝึก เครื่องขว้างอัตโนมัติ วัสดุเกรดอาหาร เครื่องยิงเทนนิสสำหรับสุนัข ของเล่นแบบโต้ตอบกลางแจ้ง ลูกบอลเด้งสูง สิ่งประดิษฐ์สำหรับเดินสุนัข",
        "product_image": "https://img.lazcdn.com/g/p/50bf93106149570c655d51952248e9cb.jpg_200x200q90.jpg",
        "price": 3460,
        "remark": "https://www.lazada.co.th/products/pdp-i5033640463.html",
        "sold": 28
    },
    {
        "product_name": "กล่องทรายแมวขนาดใหญ่พิเศษ ป้องกันกลิ่นและไม่หกเลอะเทอะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4a1c2e9a1cba48189d47d985b9e7e607q.jpg_200x200q90.jpg",
        "price": 3452,
        "remark": "https://www.lazada.co.th/products/pdp-i16087086814.html",
        "sold": 0
    },
    {
        "product_name": "STXIAOJIZHAI | กล่องทรายแมวขนาดใหญ่พิเศษ สองชั้นแยกส่วน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S97a01a649eab4b7d9d82a9775432e179D.jpg_200x200q90.jpg",
        "price": 3431.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16112335201.html",
        "sold": 0
    },
    {
        "product_name": "ทรายแมวแบบจับตัวเป็นก้อน 5-in-1 ผสม 15.8 ปอนด์, ควบคุมกลิ่นและจับตัวเป็นก้อนได้รวดเร็ว, ดูดซับน้ำและสามารถทิ้งลงชักโครกได้, ปราศจากฝุ่น, เหมาะสำหรับแมวหลายตัว, ทรายแมวเบนโทไนต์เต้าหู้และมันสำปะหลัง, กลิ่นมะลิ, 7.9 ปอนด์/ถุง",
        "product_image": "https://img.lazcdn.com/g/p/424c9f85a35059e71016c018aed6ed34.jpg_webp_200x200q90.jpg",
        "price": 3423,
        "remark": "https://www.lazada.co.th/products/pdp-i16081277283.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องให้อาหารสัตว์ อัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc92816000b524d31a938bca7fa0800eah.jpg_200x200q90.jpg",
        "price": 3398,
        "remark": "https://www.lazada.co.th/products/pdp-i4910650462.html",
        "sold": 8
    },
    {
        "product_name": "DIGITALPETSmart Pet Feederแอปควบคุมอัจฉริยะแหล่งจ่ายไฟคู เครื่องให้อาหารแมวอัตโนมัติ ที่ให้อาหารสัตว์อัตโนมัติ ประกัน2ปี",
        "product_image": "https://img.lazcdn.com/g/p/2aa28cfc6e81c08cfed502731ed64b1a.jpg_200x200q90.jpg",
        "price": 3398,
        "remark": "https://www.lazada.co.th/products/pdp-i16116156391.html",
        "sold": 0
    },
    {
        "product_name": "บ้านสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S66257033650e435e8865b068c67dee13V.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i5214693948.html",
        "sold": 1
    },
    {
        "product_name": "สเปร์ยขจัดคราบบนขนสุนัข/แมว PURE PAWS - BIO-ENZYMATIC PRETREATMENT SPRAY, STAIN REMOVER, 16 OZ",
        "product_image": "https://img.lazcdn.com/g/p/d2916072311d6835ae67320c889e9d2f.jpg_200x200q90.jpg",
        "price": 3370,
        "remark": "https://www.lazada.co.th/products/pdp-i299408100.html",
        "sold": 0
    },
    {
        "product_name": "Puang | ชั้นเก็บอาหารสัตว์เลี้ยงหลายชั้น ทำจากเหล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7068162c8d114c9187edadb239dfc41ea.jpg_200x200q90.jpg",
        "price": 3348,
        "remark": "https://www.lazada.co.th/products/pdp-i5949715292.html",
        "sold": 0
    },
    {
        "product_name": "Pet Toilet Odor Purifier Smart for Cat for Cat Litter Box Deodorizer Dog for Cat Litter Deodorant",
        "product_image": "https://img.lazcdn.com/g/p/a45302d713e78807e0f2730f60937d95.jpg_200x200q90.jpg",
        "price": 3346,
        "remark": "https://www.lazada.co.th/products/pdp-i5911624047.html",
        "sold": 0
    },
    {
        "product_name": "ชุดปลูกหญ้าแมว MUJI จำนวน2ชิ้น47879612 (X 5)",
        "product_image": "https://img.lazcdn.com/g/p/5e2800b347a7e1d38215fbb562ff3497.png_200x200q90.png",
        "price": 3340,
        "remark": "https://www.lazada.co.th/products/pdp-i16119667455.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องกำจัดกลิ่นสัตว์เลี้ยงอัจฉริยะสำหรับอ่างอาบน้ำแมวและสุนัขกล่องทิ้งขยะเครื่องกำจัดกลิ่นสุนัขตัวฟอกอากาศชาร์จได้สำหรับสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/p/ef1beede60602c8c1edb075ebedb0fa9.jpg_200x200q90.jpg",
        "price": 3330,
        "remark": "https://www.lazada.co.th/products/pdp-i4873744165.html",
        "sold": 0
    },
    {
        "product_name": "YIFANGJIAYI | ชั้นเก็บของหลายฟังก์ชันสำหรับอุปกรณ์สัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S83bd11551fbd47bfb82162bd8609928fV.jpg_200x200q90.jpg",
        "price": 3328.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16145543547.html",
        "sold": 0
    },
    {
        "product_name": "ไดร์เป่าขนสัตว์ รุ่นใหม่ไดร์ขนสุนัข ไดร์เป่าขนแมว เครื่องเป่าขน ไดร์ไล่น้ำ สินค้าพร้อมส่งในไทย",
        "product_image": "https://img.lazcdn.com/g/p/4ff5e338d1169b64fddf9e3f57c9b88a.png_200x200q90.png",
        "price": 3312,
        "remark": "https://www.lazada.co.th/products/pdp-i4181585039.html",
        "sold": 0
    },
    {
        "product_name": "ปลอกคลุมไม้กอล์ฟลายสุนัขจมูกใหญ่สุดน่ารัก, ปลอกคลุมหัวไม้ไดรเวอร์, ปลอกคลุมไม้กอล์ฟขนาดเล็ก, อุปกรณ์เสริมกอล์ฟ",
        "product_image": "https://img.lazcdn.com/g/p/ec43948bc364ef793325ac816ff9f6c2.jpg_webp_200x200q90.jpg",
        "price": 3298.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16147378726.html",
        "sold": 0
    },
    {
        "product_name": "Dolity ที่ขัดฟัน Scaler เครื่องไล่แมวสัตว์",
        "product_image": "https://img.lazcdn.com/g/p/493f0c7373964a7d893e1e86a74c60cd.jpg_200x200q90.jpg",
        "price": 3262,
        "remark": "https://www.lazada.co.th/products/pdp-i6030932936.html",
        "sold": 0
    },
    {
        "product_name": "Gazechimp เครื่องไล่หนู/งูด้วยคลื่นอุลตร้าโซนิกนกนกกระสาแมวยับยั้ง",
        "product_image": "https://img.lazcdn.com/g/p/73f3be80afee363a8769ec9f7d943de4.jpg_200x200q90.jpg",
        "price": 3262,
        "remark": "https://www.lazada.co.th/products/pdp-i6055436794.html",
        "sold": 0
    },
    {
        "product_name": "BOBOKALA | กล่องทรายแมวป้องกันหก แบบมีฝาปิด ขนาดใหญ่พิเศษ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S64202ac6d17a45478c611d996b4eb7c0M.jpg_200x200q90.jpg",
        "price": 3242,
        "remark": "https://www.lazada.co.th/products/pdp-i16120732225.html",
        "sold": 0
    },
    {
        "product_name": "FUNNYDEER | ที่ขับถ่ายสุนัขอัตโนมัติพร้อมกำจัดของเสีย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8e9f59dc2cf7466bb7521e1d9f0d5ccfS.jpg_200x200q90.jpg",
        "price": 3223.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16052511112.html",
        "sold": 0
    },
    {
        "product_name": "Unicharm Easy-toilet อีซี่ทอยเล็ท ห้องน้ำแมวลดกลิ่น เก็บกลิ่น แบบมีฝาครอบ (พร้อมรีฟิล)",
        "product_image": "https://img.lazcdn.com/g/p/aee2f95330ebb88f2d64e841e411dcb9.jpg_200x200q90.jpg",
        "price": 3212,
        "remark": "https://www.lazada.co.th/products/pdp-i4936582141.html",
        "sold": 0
    },
    {
        "product_name": "ถุงมือกำจัดขนสัตว์เลี้ยง YomiHair Remover รุ่นอัพเกรดปี 2025 ถุงมือกำจัดขนสัตว์เลี้ยงด้วยไฟฟ้าสถิต ถุงมือกำจัดขนสัตว์เลี้ยงแบบสองด้าน ใช้ซ้ำได้สำหรับแมวและสุนัข (2 ชิ้น)",
        "product_image": "https://img.lazcdn.com/g/p/f3c031e1d3934d1eebcb4a505a56377f.jpg_webp_200x200q90.jpg",
        "price": 3211.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16081275306.html",
        "sold": 0
    },
    {
        "product_name": "บูสเตอร์เบาะนั่งสัตว์เลี้ยงที่สะดวกสบายพร้อมแผ่นซับน้ำสองด้านและปกสะอาดสุนัขได้ง่าย",
        "product_image": "https://img.lazcdn.com/g/p/6ef96b92272145ebdfa8879336e41f28.jpg_200x200q90.jpg",
        "price": 3202.74,
        "remark": "https://www.lazada.co.th/products/pdp-i6004399611.html",
        "sold": 0
    },
    {
        "product_name": "Taigepets | กล่องทรายแมวป้องกันกระเด็น ปิดสนิท ป้องกันกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc41cf1229ae341e082b5ea2069f96f14x.jpg_200x200q90.jpg",
        "price": 3199.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16092186111.html",
        "sold": 32
    },
    {
        "product_name": "เครื่องให้อาหารอัตโนมัติ สุนัขเม็ดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2d578fae296e47e5897765818cfbae80f.jpg_200x200q90.jpg",
        "price": 3198,
        "remark": "https://www.lazada.co.th/products/pdp-i5085107675.html",
        "sold": 3
    },
    {
        "product_name": "เครื่องให้อาหารสุนัขเม็ดใหญ่ อัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S199a0a3c372942439cd163b48c99dea0Z.jpg_200x200q90.jpg",
        "price": 3198,
        "remark": "https://www.lazada.co.th/products/pdp-i5042051179.html",
        "sold": 1
    },
    {
        "product_name": "กรงสุนัขใหญ่ กรงหมา รับน้ำหนักได้ 10-100KG ใช้งานนาน 10 ปี ไม่พัง เหมาะสำหรับสุนัข แมว และกระต่าย กรงกระต่าย กรงแมวแบบใหญ่ กรงเหล็กมีถาดรองรับ",
        "product_image": "https://img.lazcdn.com/g/p/c2262d6d088b8f7d76ba7a3638cdc9df.jpg_200x200q90.jpg",
        "price": 3178,
        "remark": "https://www.lazada.co.th/products/pdp-i5808404936.html",
        "sold": 10
    },
    {
        "product_name": "[12แถม1] Pramie แผ่นเช็ดทำความสะอาดสำหรับสัตว์เลี้ยง สูตรซิลเวอร์ไอออน กลิ่นสปา แพ็คใหญ่ 80 แผ่น 20x20 ซม.",
        "product_image": "https://img.lazcdn.com/g/p/c7b55cdb4e6eb86a819b7ff8fdf6cd83.jpg_200x200q90.jpg",
        "price": 3160,
        "remark": "https://www.lazada.co.th/products/pdp-i16110428290.html",
        "sold": 0
    },
    {
        "product_name": "Sukina Petto Pet Wipes 70 sheet (6 Packs) ผ้าเปียก สำหรับ เช็ดทำความสะอาด สุนัข แมว และสัตว์เลี้ยง 70 แผ่น (แพ๊ค 6 ห่อ)",
        "product_image": "https://img.lazcdn.com/g/p/2595d531b04801b3896092fc5e1bc3ee.jpg_200x200q90.jpg",
        "price": 3147.6,
        "remark": "https://www.lazada.co.th/products/pdp-i3481355847.html",
        "sold": 0
    },
    {
        "product_name": "ทรายแมวคอสมกแคท ชนดละเอยด กลนยฟанг (AK453) 6 กก. 3 ถง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S64dcd7a832144fb8b16f7b90cf07c815u.png_200x200q90.png",
        "price": 3135.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6026222158.html",
        "sold": 0
    },
    {
        "product_name": "ทรายแมวคอสมกแคท ชนดละเอยดพเศษ ไรกลน (AK452) 6 กก. 3 ถง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S25ea0bd7cd944333a0c4ba75bc2fec5eh.png_200x200q90.png",
        "price": 3135.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6026222152.html",
        "sold": 0
    },
    {
        "product_name": "แล็บ โค. โปรไบโอติกส์สำหรับสัตว์เลี้ยงเพื่อการลดอาการแพ้และเสริมสร้างภูมิคุ้มกัน - ช่วยบรรเทาอาการแพ้ตามฤดูกาล - ส่งเสริมสุขภาพลำไส้และระบบย่อยอาหาร - รสหมู - 30 เม็ดเคี้ยวแบบนิ่ม - บรรจุภัณฑ์อาจแตกต่างกัน",
        "product_image": "https://img.lazcdn.com/g/p/828b00f16234f65c49d1f0d1c27964b1.jpg_webp_200x200q90.jpg",
        "price": 3132.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16145056057.html",
        "sold": 0
    },
    {
        "product_name": "MAIKAJI | อุปกรณ์สำหรับกล่องทรายแมวอัจฉริยะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4c216c67a4644d2e9deb72cab7a70ef9Q.jpg_200x200q90.jpg",
        "price": 3124,
        "remark": "https://www.lazada.co.th/products/pdp-i16132554575.html",
        "sold": 0
    },
    {
        "product_name": "MAISHILANG | ของเล่นสุนัขหุ่นยนต์ AI ฉลาด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6ce7353eb33b4810915c0871e10b7f67U.jpg_200x200q90.jpg",
        "price": 3116.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16117996116.html",
        "sold": 0
    },
    {
        "product_name": "Carpum | กล่องทรายแมวขนาดใหญ่สองชั้นป้องกันการหกรั่ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc5bafceec2074ab48592173cfdbd847cw.jpg_200x200q90.jpg",
        "price": 3110,
        "remark": "https://www.lazada.co.th/products/pdp-i16111900630.html",
        "sold": 0
    },
    {
        "product_name": "แท่นวางแมวแบบแข็งด้านข้างพับได้กระเป๋าใส่สัตว์เลี้ยงเดินทางมือจับด้านบน4ด้านมีช่องระบายอากาศแข็งแรงทนทานสำหรับการเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/84b5628aa6af52686e92d5453c064dad.jpg_200x200q90.jpg",
        "price": 3106,
        "remark": "https://www.lazada.co.th/products/pdp-i6044694169.html",
        "sold": 0
    },
    {
        "product_name": "Asixxsix กล่องครอกแมวขนาดใหญ่พิเศษ Proof กล่องครอกสแตนเลสด้านสูงโลหะพร้อมที่ตักสำหรับแมวหลายตัว (ขนาดใหญ่พิเศษ 32.7 X 24.4 X 31.5 นิ้ว)",
        "product_image": "https://img.lazcdn.com/g/p/d88eb8b306e61dd21aa9702a7604b820.jpg_200x200q90.jpg",
        "price": 3104,
        "remark": "https://www.lazada.co.th/products/pdp-i16129090325.html",
        "sold": 0
    },
    {
        "product_name": "AFP กระบะทรายแมวพับได้ สีเทา",
        "product_image": "https://img.lazcdn.com/g/p/53f245e0ef40daa4fd10da34c6bde3d1.jpg_200x200q90.jpg",
        "price": 3098,
        "remark": "https://www.lazada.co.th/products/pdp-i5497595747.html",
        "sold": 0
    },
    {
        "product_name": "AFP กระบะทรายแมวแบบพับได้",
        "product_image": "https://img.lazcdn.com/g/p/67b6a4cf3c5ac2a2873b742ad03c8088.jpg_200x200q90.jpg",
        "price": 3098,
        "remark": "https://www.lazada.co.th/products/pdp-i5497815622.html",
        "sold": 0
    },
    {
        "product_name": "ถังรีดนมความจุมากสำหรับปศุสัตว์โครงสร้างเหล็กกล้าไร้สนิมกันสนิม",
        "product_image": "https://img.lazcdn.com/g/p/77519e8d9a370271deba893b4f487a70.jpg_200x200q90.jpg",
        "price": 3096.96,
        "remark": "https://www.lazada.co.th/products/pdp-i6014733817.html",
        "sold": 0
    },
    {
        "product_name": "[12แถม1] Pramie แผ่นเช็ดทำความสะอาดสำหรับสัตว์เลี้ยง สูตรไม่มีน้ำหอม แพ็คใหญ่ 80 แผ่น 20x20 ซม. ย่อยสลายได้ 12แถม1 แพ็ค",
        "product_image": "https://img.lazcdn.com/g/p/2058af76d6034e8fba515235ac366e1f.jpg_200x200q90.jpg",
        "price": 3096,
        "remark": "https://www.lazada.co.th/products/pdp-i5724353360.html",
        "sold": 0
    },
    {
        "product_name": "[12แถม1] Pramie แผ่นเช็ดทำความสะอาดสำหรับสัตว์เลี้ยง สูตรกลิ่นคาโมมายล์ แพ็คใหญ่ 80 แผ่น 20x20 ซม. ย่อยสลายได้ 12แถม1",
        "product_image": "https://img.lazcdn.com/g/p/97b36f6bbae33453e072d6ed718352d3.jpg_200x200q90.jpg",
        "price": 3096,
        "remark": "https://www.lazada.co.th/products/pdp-i5724205888.html",
        "sold": 0
    },
    {
        "product_name": "BOBOKALA | กล่องทรายแมวขนาดใหญ่ป้องกันการหกรั่ว 80 ซม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd973093ca5fa464eab808ab99908546cY.jpg_200x200q90.jpg",
        "price": 3082,
        "remark": "https://www.lazada.co.th/products/pdp-i16120478776.html",
        "sold": 0
    },
    {
        "product_name": "PETBLEE | กล่องขยะสัตว์เลี้ยงขนาดใหญ่ ป้องกันการกระเด็น สแตนเลสแบบมีขอบสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa7267ea192404d1987bdfe05b271be10v.jpg_200x200q90.jpg",
        "price": 3082,
        "remark": "https://www.lazada.co.th/products/pdp-i16090661487.html",
        "sold": 0
    },
    {
        "product_name": "Pet Blanket Sofa Pet Waterproof & Anti-Slip Dog Bed Cover and Bed Mat Incontinence Mattress Protectors Furniture",
        "product_image": "https://img.lazcdn.com/g/p/a7614dab01fc797f6b7778219af844b8.jpg_200x200q90.jpg",
        "price": 3076,
        "remark": "https://www.lazada.co.th/products/pdp-i6046622688.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกรูมมิ่งการดูแลสัตว์เลี้ยงใหม่ 7-in-1 เครื่องโกนหนวดแมวและสุนัขมัลติฟังก์ชั่นผมผลักดันและหวีเครื่องดูดฝุ่นไฟฟ้าครัวเรือนแมวทําความสะอาดผม",
        "product_image": "https://img.lazcdn.com/g/p/1b99f7ab38ae9af44728a1ce22fe43bd.jpg_200x200q90.jpg",
        "price": 3066,
        "remark": "https://www.lazada.co.th/products/pdp-i5401395489.html",
        "sold": 1
    },
    {
        "product_name": "กล่องครอกสุนัขหญ้าสุนัขกระโถนสุนัขกระโถนหญ้าพรมทนทานหลายหลุมด้านล่างสำหรับอพาร์ทเมนท์",
        "product_image": "https://img.lazcdn.com/g/p/50c270b2d132180ef6d69f062696bf67.jpg_200x200q90.jpg",
        "price": 3057.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16125120996.html",
        "sold": 0
    },
    {
        "product_name": "ถุงมือกำจัดขนสัตว์เลี้ยง - ถุงมือกำจัดขนสัตว์เลี้ยงแบบไฟฟ้าสถิตรุ่นใหม่ปี 2025, ถุงมือกรูมมิ่งสัตว์เลี้ยงแบบสองด้านที่ล้างทำความสะอาดได้และนำกลับมาใช้ใหม่ได้ สำหรับโซฟา, เสื้อผ้า, เฟอร์นิเจอร์, พรม, เบาะรถยนต์ (2 ชิ้น)",
        "product_image": "https://img.lazcdn.com/g/p/e60a591059402d5de4c8159ca8eeb7dc.jpg_webp_200x200q90.jpg",
        "price": 3049.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16081233741.html",
        "sold": 0
    },
    {
        "product_name": "LORDE | ทรายแมวถั่วเหลืองดับกลิ่นและฆ่าเชื้อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3bc055c3e9c745c5b824508a1979f440G.png_200x200q90.png",
        "price": 3047.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5935411224.html",
        "sold": 9
    },
    {
        "product_name": "zeze | ที่นอนสัตว์เลี้ยง โซฟาสัตว์เลี้ยง นุ่ม ซักได้ ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S734500442e5c4b2680afa306284520c8j.png_200x200q90.png",
        "price": 3020.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5914275983.html",
        "sold": 127
    },
    {
        "product_name": "Decopark | กล่องทรายแมวป้องกันกระเด็นขนาดใหญ่พิเศษ ควบคุมกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfde2813bdba84227a3ed0fea56375b692.png_200x200q90.png",
        "price": 3018,
        "remark": "https://www.lazada.co.th/products/pdp-i16087151760.html",
        "sold": 0
    },
    {
        "product_name": "กรงแมวอเนกประสงค์ระบายอากาศได้แบบพกพาพับเก็บได้เต็นท์แมวน้ำหนักเบาสำหรับสัตว์ขนาดเล็กอื่นๆ",
        "product_image": "https://img.lazcdn.com/g/p/401c223343b29ccb0fdd33b8268d3b5a.jpg_200x200q90.jpg",
        "price": 3016,
        "remark": "https://www.lazada.co.th/products/pdp-i6038308372.html",
        "sold": 0
    },
    {
        "product_name": "กล่องทรายแมวขนาดใหญ่พิเศษ พร้อมแผ่นกันกระเด็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S09351ea2b3864702874b524e93609c71M.jpg_200x200q90.jpg",
        "price": 3008,
        "remark": "https://www.lazada.co.th/products/pdp-i6028827187.html",
        "sold": 0
    },
    {
        "product_name": "[เซ็ตสุดคุ้ม] Unicharm Pet เซ็ตสุดคุ้ม สำหรับ 4 เดือน อีซี่ทอยเล็ท ทรายแมวลดกลิ่น แบบรีฟิล 4 ลิตร, 3.8 ลิตร x2 แพ็ค  + อีซี่ทอยเล็ท ชีท x2 แพ็ค",
        "product_image": "https://img.lazcdn.com/g/p/0487f7bd39a4c3003b1d121232a08d0c.jpg_200x200q90.jpg",
        "price": 3000,
        "remark": "https://www.lazada.co.th/products/pdp-i4304332444.html",
        "sold": 181
    },
    {
        "product_name": "Pet Soft ผ้าเปียกทำความสะอาดสำหรับสุนัข (ยกลัง 24 ห่อ) ทำความสะอาดสิ่งสกปรก เพิ่มความเงางามให้เส้นขน กลิ่นแอปเปิ้ล",
        "product_image": "https://img.lazcdn.com/g/p/9f8cc8be8b7353018d0ea52c24bd076b.jpg_200x200q90.jpg",
        "price": 2998,
        "remark": "https://www.lazada.co.th/products/pdp-i4867598680.html",
        "sold": 0
    },
    {
        "product_name": "iKKLE กรงสุนัขขนาดกลางถึงใหญ่ ทำจากท่อเหล็กสี่เหลี่ยมเสริมแรง มีช่องแสงด้านบนแบบโต้ตอบได้ ประตูสำหรับให้อาหาร และถาดพีวีซีสองถาด",
        "product_image": "https://img.lazcdn.com/g/p/cc6673e95e61469b19330e21e2ba7cea.png_200x200q90.png",
        "price": 2998,
        "remark": "https://www.lazada.co.th/products/pdp-i6072556178.html",
        "sold": 9
    },
    {
        "product_name": "PAIPAIMAO | กล่องทรายแมวแบบฝาเปิดปิดพร้อมขอบกันกระเด็น ขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfe05010909ef4e3daa46c25f09e2fcd7Z.jpg_200x200q90.jpg",
        "price": 2990,
        "remark": "https://www.lazada.co.th/products/pdp-i16127387200.html",
        "sold": 0
    },
    {
        "product_name": "โซฟาลอยน้ำแบบสูบลมสุนัขแบบพกพาสำหรับแม่น้ำทะเลสาบสระฤดูร้อนปาร์ตี้อาบแดดของเล่นแพยางพองลมสุนัขขนาดกลางถึงใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/879247e08333a255127758c1ead624eb.jpg_200x200q90.jpg",
        "price": 2988,
        "remark": "https://www.lazada.co.th/products/pdp-i6010262685.html",
        "sold": 0
    },
    {
        "product_name": "‼️พร้อมส่ง‼️คอกไม้สำหรับกระต่าย คอกสัตว์เลี้ยง แกสบี้ ชินชิล่า แพรี่ด็อก หมา แมว สัตว์เลี้ยงขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/p/5479d28262a7c7c738cab8549273da61.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i4666488441.html",
        "sold": 3
    },
    {
        "product_name": "เม็ดโรยทรายแมว ที่ดับกลิ่นทรายแมว ผงโรยทรายแมว ดับกลิ่นขี้แมว เม็ดดับกลิ่น Cat เม็ดหอมลดกลิ่นสำหรับทรายแมว Unicharm Pet กลิ่น Natural soap 450ml. (3ขว",
        "product_image": "https://img.lazcdn.com/g/p/3ba86b162d14c6330bc133d8567eb7ee.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i3359445138.html",
        "sold": 0
    },
    {
        "product_name": "PETBLEE | กล่องทรายแมวขนาดใหญ่แบบกึ่งปิด สแตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S31fc47c68a284fb99275dc05b6127249j.jpg_200x200q90.jpg",
        "price": 2976,
        "remark": "https://www.lazada.co.th/products/pdp-i16090617169.html",
        "sold": 0
    },
    {
        "product_name": "ABEYINUOR | กล่องทรายแมวป้องกันกลิ่นแบบปิดสนิท ขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se75497184bd345df8564335524c98c8dt.jpg_200x200q90.jpg",
        "price": 2974,
        "remark": "https://www.lazada.co.th/products/pdp-i16125505328.html",
        "sold": 0
    },
    {
        "product_name": "กล่องทรายแมวป้องกันกลิ่น ขนาดใหญ่ ป้องกันการกระเด็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0631ddbc5d1840e1a9254bd8da6552fdR.jpg_200x200q90.jpg",
        "price": 2939.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16102753573.html",
        "sold": 0
    },
    {
        "product_name": "ทบคอง콩 ทรายแมวสตรออรจนล ไมโครไฟเบอร (AK667) 2.8 กก. 6 ชน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sea051ce01fd640f98b3d680c39c76458C.png_200x200q90.png",
        "price": 2930.94,
        "remark": "https://www.lazada.co.th/products/pdp-i6026146295.html",
        "sold": 0
    },
    {
        "product_name": "PAIPAIMAO | กล่องทรายแมวป้องกันกระเด็นแบบใส่จากด้านบน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdd5e4dd833354bcbac00ada88d231b4ff.jpg_200x200q90.jpg",
        "price": 2904,
        "remark": "https://www.lazada.co.th/products/pdp-i16140098632.html",
        "sold": 0
    },
    {
        "product_name": "2.2N5คอกหมา กรงหมา คอกกั้นสัตว์เลี้ยงขนาดเล็ก รุ่นXXL ขนาด 200cm X 200cm X 52cm รุ่นไม่มีประตู",
        "product_image": "https://img.lazcdn.com/g/p/6255a6912873448c65d89fc5db3d7990.png_200x200q90.png",
        "price": 2900,
        "remark": "https://www.lazada.co.th/products/pdp-i2106508629.html",
        "sold": 19
    },
    {
        "product_name": "[PETClub] Unicharm Pet ห้องน้ำแมวลดกลิ่น Deo-toilet (เดโอทอยเล็ท) แบบมีฝาครอบ (ฟรีแผ่นรองซับ 1 แพ็ค และทรายแมว 2 ลิตร ในกล่อง)",
        "product_image": "https://img.lazcdn.com/g/p/abed95a7263d84b9cff6ba7408f0b98e.jpg_200x200q90.jpg",
        "price": 2900,
        "remark": "https://www.lazada.co.th/products/pdp-i331900403.html",
        "sold": 3
    },
    {
        "product_name": "WRA ทิชชู่เปียก แผ่นทำความสะอาด ทิชชู่เปียกสัตว์เลี้ยง ผ้าเปียกเช็ดตัว สูตรคาโมมายล์ ช่วยยับยั้งแบคทีเรีย สำหรับสุนัขและแมว ผ้าเช็ดทำความสะอาด กระดาษทำความสะอาด",
        "product_image": "https://img.lazcdn.com/g/p/0ee8a5ac27d45f438fd594b51f3d578d.jpg_200x200q90.jpg",
        "price": 2878,
        "remark": "https://www.lazada.co.th/products/pdp-i5783934947.html",
        "sold": 0
    },
    {
        "product_name": "MLZH | กรงสัตว์เลี้ยงอัตโนมัติสำหรับไข่กลิ้ง ขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6f776c494c744904bb87dc541f14300eg.jpg_200x200q90.jpg",
        "price": 2868.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16094613992.html",
        "sold": 0
    },
    {
        "product_name": "Yeasa | ทรายแมวถั่วเหลืองสีรุ้ง กลิ่นหอม ฝุ่นน้อย เกาะตัวเป็นก้อนอนุภาคเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S59fd7dcd14e94dabbe9624eb26d51676e.jpg_200x200q90.jpg",
        "price": 2854,
        "remark": "https://www.lazada.co.th/products/pdp-i16090742244.html",
        "sold": 0
    },
    {
        "product_name": "HOOPET | ที่นอนสัตว์เลี้ยงอุ่นสบายสำหรับทุกฤดูกาล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd9399dcdf2cd4ff1af8412b2962957d3v.jpg_200x200q90.jpg",
        "price": 2831.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6053746709.html",
        "sold": 0
    },
    {
        "product_name": "กล่องทรายแมวป้องกันกลิ่นและกระเด็น ขนาดใหญ่พิเศษ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scd2110b210a64c3aa96d32c52162d520f.png_200x200q90.png",
        "price": 2822,
        "remark": "https://www.lazada.co.th/products/pdp-i16087173463.html",
        "sold": 0
    },
    {
        "product_name": "hipidog | ทรายแมวดูดซับกลิ่นเบนโทไนต์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd8552cff3aed45d6bbbbb67fd2a5c9d0S.png_200x200q90.png",
        "price": 2816.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5841066071.html",
        "sold": 23
    },
    {
        "product_name": "กล่องครอกแมว กล่องครอกแบบปิดพร้อมพลั่วและแผ่นกันรั่ว กล่องครอกด้านข้างสูง ป้องกันการรั่วไหล รายการยอดนิยม ถาดรองครอกแมว ทำความสะอาดง่าย (2)",
        "product_image": "https://img.lazcdn.com/g/p/2ac9fcdf55cd4268fbca2ce92c207114.jpg_200x200q90.jpg",
        "price": 2812,
        "remark": "https://www.lazada.co.th/products/pdp-i16121897373.html",
        "sold": 0
    },
    {
        "product_name": "[[Sale!!!]] อุปกรณ์สัตว์เลี้ยง ของเล่นแมว ถูกๆ เครื่องให้น้ำ อัตโนมัติเซรามิกสัตว์เลี้ยงสุนัขป้อนน้ำอัตโนมัติสัตว์ SY15 ส่งฟรีทั่วไทย by powerfull4289",
        "product_image": "https://img.lazcdn.com/g/p/1b201d16254d7f1abed6a4c0a26cd3f5.jpg_200x200q90.jpg",
        "price": 2798,
        "remark": "https://www.lazada.co.th/products/pdp-i1244744551.html",
        "sold": 0
    },
    {
        "product_name": "Imac Zuma ห้องน้ำแมวแบบโดม สีเขียว มีลิ้นชักตักเปลี่ยนทรายง่ายสะดวก ประตูใสมองเห็น มีช่องใส่แผ่นคาร์บอนดูดกลิ่น",
        "product_image": "https://img.lazcdn.com/g/p/02497505019ec76e3777264d0d07d04c.jpg_200x200q90.jpg",
        "price": 2780,
        "remark": "https://www.lazada.co.th/products/pdp-i5046937130.html",
        "sold": 0
    },
    {
        "product_name": "YIMING |  รั้วกั้นสัตว์เลี้ยงสำหรับสุนัขและแมว ป้องกันบันได รั้วแบบยืดหดได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4237ae6ec8014a87ac828fab9df39691o.jpg_200x200q90.jpg",
        "price": 2760.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5927936933.html",
        "sold": 13
    },
    {
        "product_name": "ยกไปเลย 1 ลัง Kanimal Pet Wipes ทิชชู่เปียกสัตว์เลี้ยง ผ้าเปียกเช็ดตัว สูตรคาโมมายล์ ช่วยยับยั้งแบคทีเรีย สำหรับสุนัขและแมว",
        "product_image": "https://img.lazcdn.com/g/p/ea245399560d11d841d2c4bb2c72f3c6.jpg_200x200q90.jpg",
        "price": 2760,
        "remark": "https://www.lazada.co.th/products/pdp-i5167233612.html",
        "sold": 0
    },
    {
        "product_name": "ShineTrip เบาะนอนน้องแมวสัตว์เลี้ยง Kancan ยกระดับอลูมิเนียมกลางแจ้ง Huiop ด้วยเบาะนอนน้องแมวอัลลอยด์เตียงสำหรับสัตว์เลี้ยงยกระดับเตียงนอนยกสูงในร่มยกระดับเตียงอลูมิเนียมอัลลอยด์ Hxber Erythlechnical Siuke Lanru Dsfen",
        "product_image": "https://img.lazcdn.com/g/p/d078d7c8b38aaa5148b69f1fe0168595.jpg_200x200q90.jpg",
        "price": 2738,
        "remark": "https://www.lazada.co.th/products/pdp-i5640483971.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO เตียงสำหรับสัตว์เลี้ยงเตียงพร้อมเตียงในร่มกลางแจ้ง,อะลูมินัมอัลลอยเบาะนอนน้องแมวยกสูงอะลูมินัมอัลลอยกับการใช้งานกลางแจ้งในร่มอลูมิเนียมเตียงสำหรับสัตว์เลี้ยงเบาะนอนน้องแมวโลหะผสมสัตว์เลี้ยงที่มี Lanru ยกเตียงนอนยกสูง",
        "product_image": "https://img.lazcdn.com/g/p/4b2bd23ccfb94381280fb44c4e370967.jpg_200x200q90.jpg",
        "price": 2732,
        "remark": "https://www.lazada.co.th/products/pdp-i5436910653.html",
        "sold": 0
    },
    {
        "product_name": "อ่างลitter ขนาดใหญ่สำหรับแมว Mango แบบปิดเต็มรูปแบบ ฝาด้านบนแบบถอดออกได้ อ่างลitter สำหรับแมว ผลิตจากจีนแผ่นดินใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9386f1ca38b64b619276040227bdb74c4.jpg_200x200q90.jpg",
        "price": 2732,
        "remark": "https://www.lazada.co.th/products/pdp-i5399403350.html",
        "sold": 2
    },
    {
        "product_name": "Zerodis กล่องทรายแมวขนาดใหญ่พิเศษแบบกึ่งปิดถาดรองกระทะพลาสติกพร้อมการออกแบบที่ถอดออกได้และตักด้านสูงสำหรับแมวหลายตัว 23.43x17.32in (สีชมพู)",
        "product_image": "https://img.lazcdn.com/g/p/836de791c668652cf42f0b7cc2151bf8.jpg_200x200q90.jpg",
        "price": 2728,
        "remark": "https://www.lazada.co.th/products/pdp-i16124335805.html",
        "sold": 0
    },
    {
        "product_name": "paikewei | กล่องขยะแมวป้องกันกระเด็นสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S69087dcce0ea45bbb15b0ba50a37bd3fF.jpg_200x200q90.jpg",
        "price": 2726,
        "remark": "https://www.lazada.co.th/products/pdp-i16123608906.html",
        "sold": 0
    },
    {
        "product_name": "BOBOKALA | กล่องทรายแมวขนาดใหญ่ป้องกันการกระเด็นและกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0cd0bba4cd5a411cb8eba1ca7623303bM.jpg_200x200q90.jpg",
        "price": 2720,
        "remark": "https://www.lazada.co.th/products/pdp-i16123385785.html",
        "sold": 0
    },
    {
        "product_name": "BOBOKALA | กล่องทรายแมวป้องกันกลิ่นและไม่กระเด็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6a12acea06264e928a079bbb7b916efeZ.png_200x200q90.png",
        "price": 2704,
        "remark": "https://www.lazada.co.th/products/pdp-i16120266893.html",
        "sold": 0
    },
    {
        "product_name": "WEVOLA | ทรายแร่กำจัดกลิ่นสำหรับสุนัขเล็ก สามารถล้างได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S01ffde5a9e414173baff2e4c7b658a86S.png_200x200q90.png",
        "price": 2702.52,
        "remark": "https://www.lazada.co.th/products/pdp-i6022175740.html",
        "sold": 1
    },
    {
        "product_name": "Hosttail เบาะนอนสัตว์เลี้ยงรุ่น Twinkle",
        "product_image": "https://img.lazcdn.com/g/p/782be360b22634ae78739071302b18f8.jpg_200x200q90.jpg",
        "price": 2700,
        "remark": "https://www.lazada.co.th/products/pdp-i5842826637.html",
        "sold": 5
    },
    {
        "product_name": "WRA ทิชชู่เปียก แผ่นทำความสะอาด 10+2แพคเล็ก พอว์พอว์ ผ้าเปียกสัตว์เลี้ยง เส้นใยธรรมชาติ อ่อนโยน สุนัข แมว 20 แผ่น ผ้าเช็ดทำความสะอาด กระดาษทำความสะอาด",
        "product_image": "https://img.lazcdn.com/g/p/7109679523926e58b115a1aa21bdba0a.jpg_200x200q90.jpg",
        "price": 2690,
        "remark": "https://www.lazada.co.th/products/pdp-i5782327066.html",
        "sold": 0
    },
    {
        "product_name": "น้ำพุสำหรับสัตว์เลี้ยงอัตโนมัติ DUOKA: ให้ทั้งเครื่องดื่มร้อนและเย็น ดีไซน์ไร้สาย ไม่ต้องใช้ไฟฟ้า ถาดสแตนเลส เหมาะสำหรับแมวและสุนัข ระบบหมุนเวียนน้ำ ชาร์จไฟได้ สินค้าขายดีทั่วโลก",
        "product_image": "https://img.lazcdn.com/g/p/7dc3e00ad212ff96c09959eb2fe33f67.jpg_200x200q90.jpg",
        "price": 2683.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16117226567.html",
        "sold": 0
    },
    {
        "product_name": "มุ้งจีบ มุ้งจีบสำหรับสัตว์เลียง มุ้งจีบกันแมวข่วน มีบริการติดตั้ง",
        "product_image": "https://img.lazcdn.com/g/p/2c472461a87b637f5a893a4d537ca86b.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i2896783383.html",
        "sold": 0
    },
    {
        "product_name": "WUKU | กล่องทรายแมวขนาดใหญ่หรูหราปิดทั้งหมด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sec3e780e72084b459914be50ae0c1a62x.jpg_200x200q90.jpg",
        "price": 2682,
        "remark": "https://www.lazada.co.th/products/pdp-i16092340653.html",
        "sold": 0
    },
    {
        "product_name": "Kanimal ผ้าเปียกหมาแมว (80 แผ่น x ยกลัง 12 ห่อ) ทิชชู่เปียก สะอาด อ่อนโยนและไม่ระคายเคือง เนื้อผ้าหนานุ่ม ดับกลิ่นได้",
        "product_image": "https://img.lazcdn.com/g/p/038cfdc446605994166996e2a300db3f.jpg_200x200q90.jpg",
        "price": 2678,
        "remark": "https://www.lazada.co.th/products/pdp-i4875413428.html",
        "sold": 0
    },
    {
        "product_name": "Zerodis สุนัขทำความสะอาดอุปกรณ์กรูมมิ่งกล่องครอกรายการด้านบนถาดทิ้งขยะโลหะพร้อมแผ่นป้องกันการรั่วสำหรับแมวหลายตัวขนาดใหญ่พิเศษขนาด 60 X 40 X 20 ซม สำหรับลูกแมวแมวสแตนเลส (ขนาดใหญ่พิเศษ 32.7",
        "product_image": "https://img.lazcdn.com/g/p/55baf664c4f31e7c57e04dfc74ca2d14.jpg_200x200q90.jpg",
        "price": 2672,
        "remark": "https://www.lazada.co.th/products/pdp-i16125469897.html",
        "sold": 0
    },
    {
        "product_name": "Mewo Mall 3-7ลิตร เครื่องให้อาหารสัตว์เลี้ยงอัตโนมัติ ที่ให้อาหารแบบออโต้ เครื่องให้อาหาร แมว สัตว์เลี้ยง สุนัข กระต่",
        "product_image": "https://img.lazcdn.com/g/p/5c47887a3eef52e966c76d538c772dc9.jpg_200x200q90.jpg",
        "price": 2664.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5383851803.html",
        "sold": 42
    },
    {
        "product_name": "MUHONGYU | กล่องทรายแมวพกพาแบบพับได้ขนาดใหญ่ชั่วคราว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5588450599404b589476c3aaea3f267fq.jpg_200x200q90.jpg",
        "price": 2660.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16110441360.html",
        "sold": 0
    },
    {
        "product_name": "Sukina Petto tofu cat litter Original 20L สุกินะ เพ็ทโตะ ทรายเต้าหู้ กลิ่นออริจินัล 20 ลิตร x 2 Bags",
        "product_image": "https://img.lazcdn.com/g/p/63a9f180a54fb6ed2d8fb0684e4691c7.png_200x200q90.png",
        "price": 2658,
        "remark": "https://www.lazada.co.th/products/pdp-i4805399834.html",
        "sold": 7
    },
    {
        "product_name": "hipidog | อ่างล้างหน้าแบบเปิดขนาดใหญ่แบบใช้แล้วทิ้งสำหรับแมว อ่างล้างหน้าพกพาได้ป้องกันการรั่วไหล อ่างล้างหน้าสำหรับแมวขนาดเล็ก อ่างล้างหน้าแบบเปิดสำหรับแมว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5eb6aee5cbfb462e8a23dbee7c8c7b624.jpg_200x200q90.jpg",
        "price": 2652.3,
        "remark": "https://www.lazada.co.th/products/pdp-i5840981750.html",
        "sold": 1
    },
    {
        "product_name": "สุนัขแมวเสื่อเตียงคอกสัตว์เลี้ยงขนาดใหญ่ผ้าปูสำหรับสุนัขอบอุ่นสำหรับสุนัขเล็กกลางใหญ่ลูกสุนัขลูกแมวเบาะที่นอนขนาดพิเศษ",
        "product_image": "https://img.lazcdn.com/g/p/a1b68a9a2908781b98519578989b6ee6.jpg_200x200q90.jpg",
        "price": 2621.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5731162223.html",
        "sold": 4
    },
    {
        "product_name": "WRA ทิชชู่เปียก แผ่นทำความสะอาดทิชชู่เปียกสำหรับสัตว์เลี้ยง  3ห่อ/1ห่อมี50แผ่น ผ้าเช็ดทำความสะอาด กระดาษทำความสะอาด",
        "product_image": "https://img.lazcdn.com/g/p/ebf9c837349f1577d255baba1dff9ee5.jpg_200x200q90.jpg",
        "price": 2650,
        "remark": "https://www.lazada.co.th/products/pdp-i5778420298.html",
        "sold": 0
    },
    {
        "product_name": "แผ่นรองให้อาหารแมวอย่างช้าๆเพื่อการดมกลิ่นแผ่นซิลิโคนเพื่อความสนุกสนานสำหรับให้อาหารสัตว์เลี้ยงทุกวันการดมกลิ่นแบบเปียก",
        "product_image": "https://img.lazcdn.com/g/p/1e812e1f6225139bbbc87c2f9a4c7b00.jpg_200x200q90.jpg",
        "price": 2636,
        "remark": "https://www.lazada.co.th/products/pdp-i6037893357.html",
        "sold": 0
    },
    {
        "product_name": "SHOUAI | กล่องทรายแมวแบบครึ่งปิดกันหกรั่ว สามารถเปิดได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S12396795ef314a3797184da15d2ea953w.jpg_200x200q90.jpg",
        "price": 2634,
        "remark": "https://www.lazada.co.th/products/pdp-i16127247977.html",
        "sold": 0
    },
    {
        "product_name": "LLwell กล่องทรายแมวกรงด้านสูงกึ่งปิดสินค้าพรมสัตว์เลี้ยงแมวใหญ่ถาดชำระสำหรับสัตว์กระต่ายแฮมสเตอร์ขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/p/cb31499431a2a8ae71593ba7221cecdf.jpg_200x200q90.jpg",
        "price": 2632,
        "remark": "https://www.lazada.co.th/products/pdp-i6073044817.html",
        "sold": 0
    },
    {
        "product_name": "โปรโมชั่น+ P275 ห้องน้ำแมว ขนาดใหญ่ แบบลิ้นชักทำความสะอาดง่าย เก็บกลิ่นดี ราคาถูก ห้องน้ำแมว ห้องน้ำแมวทรงโดม มีฝาครอบ ห้องน้ำแมวพับได้  ห้องน้ำแมวพกพา",
        "product_image": "https://img.lazcdn.com/g/p/b61eeed10e24e9e1a862602fb43d5fb5.jpg_200x200q90.jpg",
        "price": 2620,
        "remark": "https://www.lazada.co.th/products/pdp-i4702388307.html",
        "sold": 0
    },
    {
        "product_name": "กล่องครอกแมวแบบพกพา การออกแบบลิ้นชักขนาดใหญ่ กล่องครอกแมวแบบปิด ทำความสะอาดง่ายสำหรับใช้ในร่ม",
        "product_image": "https://img.lazcdn.com/g/p/3b59c8e6adbb46c0b3241b9da4013997.jpg_200x200q90.jpg",
        "price": 2620,
        "remark": "https://www.lazada.co.th/products/pdp-i16126333063.html",
        "sold": 0
    },
    {
        "product_name": "Ritogato Cool rayon bumper mat ที่นอนนวัตกรรมผ้าเย็น ไม่ต้องเเช่เย็น พร้อมหมอนในตัว สำหรับสัตว์เลี้ยง นำเข้าจากเกาหลี",
        "product_image": "https://img.lazcdn.com/g/p/be6240a78e955c0f25ffd0a8a5c8ad8c.jpg_200x200q90.jpg",
        "price": 2600,
        "remark": "https://www.lazada.co.th/products/pdp-i5181189967.html",
        "sold": 12
    },
    {
        "product_name": "shobi​ ห้องน้ำสำหรับสัตว์เลี้ยง​ เเบบสี่เหลี่ยม​ Do Does Did",
        "product_image": "https://img.lazcdn.com/g/p/bc868d4d74092afb956fd1393d0a7b34.jpg_200x200q90.jpg",
        "price": 2600,
        "remark": "https://www.lazada.co.th/products/pdp-i3664605333.html",
        "sold": 0
    },
    {
        "product_name": "[[แท้100%]] Cat toy กระเป๋าใส่หมาและแมว ถูกๆ กระเป๋าสัตว์เลี้ยงดีไซน์สวยงาม แข็งแรง ทน ส่งฟรีทั่วไทย by powerfull4289",
        "product_image": "https://img.lazcdn.com/g/p/34d50a9590866af2b38adeaaef48ad55.jpg_200x200q90.jpg",
        "price": 2598,
        "remark": "https://www.lazada.co.th/products/pdp-i1242656249.html",
        "sold": 0
    },
    {
        "product_name": "😸หมดกังวน จัดส่งฟรี  😸  [เซ็ตสุดคุ้ม] Unicharm Pet สำหรับ 2 เดือน เดโอทอยเล็ท แซนด์ ทรายแมว ลดกลิ่น 4ลิตร + เดโอทอยเล็ท ชีท ห้องน้ำเก็บกลิ่น  ✨",
        "product_image": "https://img.lazcdn.com/g/p/3908050b3dbdfe63414131726720eebe.jpg_200x200q90.jpg",
        "price": 2598,
        "remark": "https://www.lazada.co.th/products/pdp-i5388062285.html",
        "sold": 7
    },
    {
        "product_name": "ถุงมือกำจัดขนสัตว์เลี้ยง, เครื่องกำจัดขนสัตว์เลี้ยงด้วยไฟฟ้าสถิต, ที่กำจัดขนแมวและสุนัขแบบใช้ซ้ำได้สำหรับโซฟา, เฟอร์นิเจอร์, พรม, เบาะรถยนต์, ถุงมือสำหรับกรูมมิ่งสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/p/bf92e6b9ea6a31bd3237552a3aff61f7.jpg_200x200q90.jpg",
        "price": 2596.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16098515927.html",
        "sold": 0
    },
    {
        "product_name": "LIMAIXIAOSHENG | กล่องทรายแมวขนาดใหญ่ป้องกันการหก กึ่งปิด ควบคุมทราย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se5518d25c1ac41cdb7c14ab58dc4426eV.jpg_200x200q90.jpg",
        "price": 2588,
        "remark": "https://www.lazada.co.th/products/pdp-i16125942078.html",
        "sold": 0
    },
    {
        "product_name": "ถุงมือกำจัดขนสัตว์เลี้ยงสำหรับแมวและสุนัข, ถุงมือกำจัดขนสัตว์เลี้ยงแบบใช้ซ้ำได้สำหรับโซฟา, เฟอร์นิเจอร์, พรม",
        "product_image": "https://img.lazcdn.com/g/p/11181caeac28ef99b3fc31acfe51f383.jpg_200x200q90.jpg",
        "price": 2583.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16098509727.html",
        "sold": 0
    },
    {
        "product_name": "AOBIXIONG | อุปกรณ์ดูแลสัตว์เลี้ยงหลายฟังก์ชันสำหรับสุนัขและแมว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3f3ad60196c64290ae382e39ab44a17av.jpg_200x200q90.jpg",
        "price": 2582.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16118070356.html",
        "sold": 0
    },
    {
        "product_name": "Pet Protect Cleaner 5L. น้ำยาอเนกประสงค์ สูตรธรรมชาติ กลิ่นมิ้นท์ สดชื่น ทำความสะอาดพื้นบ้าน เช็ดพื้น สำหรับสุนัขและแมว (5,000 มล/แกลอน)",
        "product_image": "https://img.lazcdn.com/g/p/a1b3183d139a48507b911d427eba1c3c.jpg_200x200q90.jpg",
        "price": 2578,
        "remark": "https://www.lazada.co.th/products/pdp-i1228312422.html",
        "sold": 3
    },
    {
        "product_name": "ยางกแซนด 1968 ฮบ ทรายแมว (AK262) 7 กก.x2 ชน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf9bf4fbd183b4a26a3098cb3d87e2e6cM.png_200x200q90.png",
        "price": 2565.1,
        "remark": "https://www.lazada.co.th/products/pdp-i6026167203.html",
        "sold": 0
    },
    {
        "product_name": "ทรายแมวยองกแซนด 1959 ฟทโทนช โกยางอ (AK261) 7 กก. 2 ถง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S48a6dda4537a454b8deb1714e0138996O.png_200x200q90.png",
        "price": 2565.1,
        "remark": "https://www.lazada.co.th/products/pdp-i6026151779.html",
        "sold": 0
    },
    {
        "product_name": "Moon ชุดฝึกกัดสำหรับฝึกสุนัขแขนป้องกันสำหรับกัดสุนัขน่ารักป้องกันแขนกัด",
        "product_image": "https://img.lazcdn.com/g/p/30f4a95355754b761ab5b417d8ed7418.jpg_200x200q90.jpg",
        "price": 2554.72,
        "remark": "https://www.lazada.co.th/products/pdp-i4486111952.html",
        "sold": 5
    },
    {
        "product_name": "Meowhouse ที่กรองร่อนกล่องทรายแมวอุปกรณ์เสริมสำหรับสัตว์เลี้ยงที่ใช้งานได้จริงแทนที่บำรุงรักษาง่ายอุปกรณ์กรองกล่องทรายแมวอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/p/c8e2c743cccb7361c246f0721923061c.jpg_200x200q90.jpg",
        "price": 2554,
        "remark": "https://www.lazada.co.th/products/pdp-i5981971099.html",
        "sold": 0
    },
    {
        "product_name": "Care | ทรายแมวซับน้ำและกำจัดกลิ่นจากเต้าหู้ 20 กก.",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1333702d5a714a29a7c0ae1acd1925deR.jpg_200x200q90.jpg",
        "price": 2549.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5968593786.html",
        "sold": 0
    },
    {
        "product_name": "ของขวัญวันเกิดตุ๊กตาพัฟส์บีเกิล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se3cec66903664a5a9aa7e8c81b6a66c5I.jpg_200x200q90.jpg",
        "price": 2526,
        "remark": "https://www.lazada.co.th/products/pdp-i16089451033.html",
        "sold": 0
    },
    {
        "product_name": "ถุงมือกำจัดขนสัตว์เลี้ยง Yomi, ถุงมือกำจัดขนสัตว์เลี้ยงด้วยไฟฟ้าสถิต, ถุงมือกำจัดขนแมวและสุนัขแบบใช้ซ้ำได้, สำหรับโซฟา, เฟอร์นิเจอร์, พรม, เบาะรถยนต์ (3 ชิ้น)",
        "product_image": "https://img.lazcdn.com/g/p/de801c9b7bda6aaf4c4230fd4a2fd91e.jpg_webp_200x200q90.jpg",
        "price": 2503.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16108802563.html",
        "sold": 0
    },
    {
        "product_name": "ถุงมือกำจัดขนสัตว์เลี้ยง Yomi, ถุงมือกำจัดขนสัตว์เลี้ยงด้วยไฟฟ้าสถิต, ที่กำจัดขนแมวและสุนัขแบบใช้ซ้ำได้, สำหรับโซฟา, เฟอร์นิเจอร์, พรม, เบาะรถยนต์ (1 ชิ้น)",
        "product_image": "https://img.lazcdn.com/g/p/0892e343e36e182abe7d7a297fcb517c.jpg_webp_200x200q90.jpg",
        "price": 2503.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16089919643.html",
        "sold": 0
    },
    {
        "product_name": "[MALETKHAO] Catidea (แคทไอเดีย) ห้องน้ำแมว รุ่น Cat Ears CL 101 สีครีม ไซส์ XL (จำกัด 1 ชิ้นต่อ 1 ออเดอร์)",
        "product_image": "https://img.lazcdn.com/g/p/e754e7b4642f94c8944b873291a5b068.jpg_200x200q90.jpg",
        "price": 2498,
        "remark": "https://www.lazada.co.th/products/pdp-i5031022450.html",
        "sold": 0
    },
    {
        "product_name": "[Fish & Bone] Mango กระบะทรายแมว ขนาดใหญ่ แถมฟรี ที่ตักทราย ไซส์ใหญ่พิเศษ",
        "product_image": "https://img.lazcdn.com/g/p/05f47e6604100e8fa3d4c8898aa6553c.jpg_200x200q90.jpg",
        "price": 2486,
        "remark": "https://www.lazada.co.th/products/pdp-i4148072627.html",
        "sold": 16
    },
    {
        "product_name": "เครื่องเป่าขนสัตว์เลี้ยง 2100w เป่าและดูดพลังสูง ถังด้านในลดเสียงรบกวน ลมแรงและแห้งเร็ว ขนแห้งอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/p/c7a7b1707ca1570aba01c27d767205dc.png_200x200q90.png",
        "price": 2478,
        "remark": "https://www.lazada.co.th/products/pdp-i5124668777.html",
        "sold": 13
    },
    {
        "product_name": "กล่องทรายแมวสัตว์เลี้ยงที่ดีกว่าสำหรับทรายแมวแบบพกพากล่องทรายแมวกันน้ำกระเด็น",
        "product_image": "https://img.lazcdn.com/g/p/0b2086079aefb8040410c936370fc943.jpg_200x200q90.jpg",
        "price": 2472.18,
        "remark": "https://www.lazada.co.th/products/pdp-i6060676448.html",
        "sold": 0
    },
    {
        "product_name": "Aoresac ปากกาออกกำลังกายสุนัขปากกาของเล่นสัตว์เลี้ยงรั้วสุนัขขนาดใหญ่แบบพกพาสำหรับลูกสุนัข12แผงเหมาะสำหรับแมวสัตว์เลี้ยงที่มีน้ำหนักน้อยกว่า10กก.",
        "product_image": "https://img.lazcdn.com/g/p/61f02b9f231812ed1ddb24e9aa60f5c8.jpg_200x200q90.jpg",
        "price": 2460,
        "remark": "https://www.lazada.co.th/products/pdp-i5811067005.html",
        "sold": 1
    },
    {
        "product_name": "OOD ทรายแมวภูเขาไฟ ขนาด 8.5 kg 3 ถุง",
        "product_image": "https://img.lazcdn.com/g/p/6c5bed09eadbea89ea0f93c7816cdf17.jpg_200x200q90.jpg",
        "price": 2458,
        "remark": "https://www.lazada.co.th/products/pdp-i5795015259.html",
        "sold": 0
    },
    {
        "product_name": "ZHUOMO | บARRIERป้องกันน้ำกระเด็นสำหรับห้องน้ำสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd0830dbb166148988fc0431936f5b683u.jpg_200x200q90.jpg",
        "price": 2454,
        "remark": "https://www.lazada.co.th/products/pdp-i16142291202.html",
        "sold": 0
    },
    {
        "product_name": "ZHUOMO | รั้วป้องกันน้ำกระเด็นสำหรับห้องน้ำสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S68f7616c955a4851aa676c8beef7c43eK.jpg_200x200q90.jpg",
        "price": 2454,
        "remark": "https://www.lazada.co.th/products/pdp-i16142313142.html",
        "sold": 0
    },
    {
        "product_name": "Micky Cat | เครื่องให้อาหารสัตว์เลี้ยงอัจฉริยะพร้อมกล้อง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8b9cb66ae9414f3da4589dd6db803645r.jpg_200x200q90.jpg",
        "price": 2453.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5907904261.html",
        "sold": 8
    },
    {
        "product_name": "กล่องขยะแมวขนาดใหญ่ป้องกันกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se286c46ac70740b7bc043dbb9d1f4ac7L.jpg_200x200q90.jpg",
        "price": 2452.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16105637497.html",
        "sold": 0
    },
    {
        "product_name": "Gaines | ทรายแมวโซเดียมเบนโทไนต์คลีธรรมชาติ ควบคุมกลิ่น ป้องกันแบคทีเรีย 4 กก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4dafbc635b624acda6c5a0c13581b719r.jpg_200x200q90.jpg",
        "price": 2450,
        "remark": "https://www.lazada.co.th/products/pdp-i16124810417.html",
        "sold": 0
    },
    {
        "product_name": "PetSnowy Cat Toilet/mat/Filter Mesh/Rubber Strip/Charger/Cat Litter Complete Set of Accessories Toilets Ball Compartment",
        "product_image": "https://img.lazcdn.com/g/p/e23c1f0574a9d6b7325f4fbe5a745adc.jpg_webp_200x200q90.jpg",
        "price": 2446,
        "remark": "https://www.lazada.co.th/products/pdp-i16088070583.html",
        "sold": 0
    },
    {
        "product_name": "น้ำยาทำความสะอาดกรง Bioline สเปร์ยล้างกรงดับกลิ่น สำหรับกรงกระต่าย กรงแฮมเตอร์ กรงหนู สัตว์เลี้ยงขนาดเล็ก และกรงนก500ml.",
        "product_image": "https://img.lazcdn.com/g/p/6779657f5926b5f24240c8c035e7c34f.jpg_200x200q90.jpg",
        "price": 2437.56,
        "remark": "https://www.lazada.co.th/products/pdp-i3481214672.html",
        "sold": 0
    },
    {
        "product_name": "Unicharm Easy-toilet อีซี่ทอยเล็ท ห้องน้ำแมวลดกลิ่น เก็บกลิ่น แบบไม่มีฝาครอบ (พร้อมรีฟิล)",
        "product_image": "https://img.lazcdn.com/g/p/7114cf9e801f30ad04d8dea1ea676765.jpg_200x200q90.jpg",
        "price": 2426,
        "remark": "https://www.lazada.co.th/products/pdp-i4936539262.html",
        "sold": 0
    },
    {
        "product_name": "BOBOKALA | กล่องทรายแมวขนาดใหญ่ ป้องกันกระเด็น ควบคุมกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se8c3d6c2400e420897b83b3225be567aL.jpg_200x200q90.jpg",
        "price": 2422,
        "remark": "https://www.lazada.co.th/products/pdp-i16123590977.html",
        "sold": 0
    },
    {
        "product_name": "JINGZHIYU | ชั้นวางทรายแมวหลายชั้นแบบตั้งพื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc56efa03e6e84bfdbbb827fa11afc35fP.jpg_200x200q90.jpg",
        "price": 2418.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16045693424.html",
        "sold": 2
    },
    {
        "product_name": "รacks สำหรับสัตว์เลี้ยงแบบเหล็ก ชั้นวางของหลายชั้นสำหรับแมว ชั้นวางของสำหรับอาหารแมว ชั้นวางของสำหรับของเล่น ชั้นวางของสำหรับขยะแมว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S85b705adaa2f4d12be5a31d334943de2Y.png_200x200q90.png",
        "price": 2416,
        "remark": "https://www.lazada.co.th/products/pdp-i16077888961.html",
        "sold": 0
    },
    {
        "product_name": "แผ่นรองแมวลิตเตอร์ซิลิโคนขนาดใหญ่สำหรับให้อาหารแผ่นรองชามแผ่นรองสัตว์เลี้ยงกันน้ำชามอาหารแมวกันหกแผ่นรองชามแผ่นรองให้อาหารกันลื่น",
        "product_image": "https://img.lazcdn.com/g/p/e618d993bc378ce95219998a9e9dd3e5.jpg_200x200q90.jpg",
        "price": 2412,
        "remark": "https://www.lazada.co.th/products/pdp-i6062214591.html",
        "sold": 0
    },
    {
        "product_name": "KAMA MUTA | ชามป้อนอาหารสัตว์เลี้ยงป้องกันล้ม ไซส์เล็ก/กลาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa13e24379452444481a12a4616270ac9y.jpg_200x200q90.jpg",
        "price": 2409.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5909720903.html",
        "sold": 67
    },
    {
        "product_name": "😺รับประกัน5ปี คอกกรงสัตว์เลี้ยง คอนโดแมว ออกแบบกรงได้ตามต้องการ สำหรับสัตว์เลี้ยง สุนัข แมว กระต่าย สัตว์อื่น ๆกรงแมว กรงสัตว์เลี้ยง ขนาดใหญ่ พับได้ ไม่เป็นสนิม แข็งแรง ไม่กลัวการขีดข่วนกัด ของใช้ในชีวิตประจำวันทุกชนิด",
        "product_image": "https://img.lazcdn.com/g/p/84e5b62b7ccef55722bd37efbf6eefba.jpg_200x200q90.jpg",
        "price": 2408.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5011887037.html",
        "sold": 293
    },
    {
        "product_name": "Dettol(เดทตอล) | สารฆ่าเชื้อสำหรับสัตว์เลี้ยงที่ช่วยลดกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfc79f1ef3ff64eff988dbd047559928fs.jpg_200x200q90.jpg",
        "price": 2404,
        "remark": "https://www.lazada.co.th/products/pdp-i16090830067.html",
        "sold": 0
    },
    {
        "product_name": "HOOPET | กล่องทรายแมวป้องกันกลิ่นและไม่ให้น้ำกระเด็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S23e22ecbc9f24c31b5daa4ecbe70a5c8P.jpg_200x200q90.jpg",
        "price": 2402,
        "remark": "https://www.lazada.co.th/products/pdp-i16089432119.html",
        "sold": 0
    },
    {
        "product_name": "[แพคคู่] PettoBonnys น้ำยาทำความสะอาดอเนกประสงค์ น้ำยาถูพื้น สัตว์เลี้ยง สเปรย์ดับกลิ่นฉี่สุนัข แมว สารสกัดธรรมชาติ",
        "product_image": "https://img.lazcdn.com/g/p/a29915c0ab051e7d586353eee33cce6b.jpg_200x200q90.jpg",
        "price": 2400,
        "remark": "https://www.lazada.co.th/products/pdp-i16050225048.html",
        "sold": 0
    },
    {
        "product_name": "Petsnowy Snow+ Robertet Fragrance Box (Snowy Zephyr) 3 Pcs./Box น้ำหอมดับกลิ่น",
        "product_image": "https://img.lazcdn.com/g/p/d3f24333cc862dbfc64716734da76d78.jpg_200x200q90.jpg",
        "price": 2400,
        "remark": "https://www.lazada.co.th/products/pdp-i5314482454.html",
        "sold": 1
    },
    {
        "product_name": "[[Sale!!!]] อุปกรณ์สัตว์เลี้ยง ของเล่นแมว ถูกๆ กระเป๋าใส่สุนัขและแมวแบบใส ส่งฟรีทั่วไทย by powerfull4289",
        "product_image": "https://img.lazcdn.com/g/p/a50b96db83d7e66e03f2e10591bcefc4.jpg_200x200q90.jpg",
        "price": 2398,
        "remark": "https://www.lazada.co.th/products/pdp-i1244702913.html",
        "sold": 0
    },
    {
        "product_name": "Carry-home สะดวกเก็บและย้าย กรงสุนัขสแตนเลส กรงสัตว์ พับได้  กรงสุนัข  กรงสแตนเลสท่อเหลี่ยม กรงสแตนเลสพับ  ป้องกันสนิม มีล้อล็อคได้ กรงสุนัขใหญ่ๆ",
        "product_image": "https://img.lazcdn.com/g/p/ad1a57739022fad325c64eba16d7e77f.jpg_200x200q90.jpg",
        "price": 2398,
        "remark": "https://www.lazada.co.th/products/pdp-i5042795987.html",
        "sold": 40
    },
    {
        "product_name": "DIGITALPET รถเข็นสุนัขพับได้ รับนน.ได้ 20 kg รถเข็นสัตว์เลี้ยง รถเข็นสุนัข รถเข็นสุนัขใหญ่ รถเข็นแมว รถเข็นสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/p/641269a60a860fd805ac844da80b8549.jpg_200x200q90.jpg",
        "price": 2398,
        "remark": "https://www.lazada.co.th/products/pdp-i16116102584.html",
        "sold": 0
    },
    {
        "product_name": "เตียงนอนแมว เตียงนอนสุนัข กระต่าย ดีไซน์เตียงทรงเจ้าหญิง  มีที่นอนและหมอนแถมให้พร้อมใช้งาน ตัวเตียงทำจากเหล็กเส้นดัดแข็งแรงมาก พ่นด้วยสีทองเพิ่มความหรูหราลักชูให้กับลูกๆ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6c7690761f184546ac9e6a93b7865ce4x.jpg_200x200q90.jpg",
        "price": 2398,
        "remark": "https://www.lazada.co.th/products/pdp-i5721567014.html",
        "sold": 1
    },
    {
        "product_name": "กล่องทรายแมวกระบะทรายแมว SATmoon ถาดคอกสัตว์เลี้ยง Baju Atasan Terbuka กล่องเก็บของขนาดเล็กแมว",
        "product_image": "https://img.lazcdn.com/g/p/eade20cbd3d65d38ba8ec38f426d4517.jpg_200x200q90.jpg",
        "price": 2392.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16128333327.html",
        "sold": 0
    },
    {
        "product_name": "[ ถุงเติมแพคคู่] PettoBonnys น้ำยาทำความสะอาดอเนกประสงค์ น้ำยาถูพื้น สัตว์เลี้ยง สเปรย์ดับกลิ่นฉี่สุนัข แมว สารสกัดธรรมชาติ",
        "product_image": "https://img.lazcdn.com/g/p/2eba7d0bfb050b184102954c4eec6492.jpg_200x200q90.jpg",
        "price": 2392,
        "remark": "https://www.lazada.co.th/products/pdp-i16054215490.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องฟอกอากาศกำจัดขนสัตว์และดับกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S97ba9bff93b94b1db252950b4317dd5ek.jpg_200x200q90.jpg",
        "price": 2388,
        "remark": "https://www.lazada.co.th/products/pdp-i16127587295.html",
        "sold": 0
    },
    {
        "product_name": "ABEYINUOR | กล่องทรายแมวป้องกันกลิ่น ป้องกันกระเด็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb245168725824bd2a587131ef5f12517x.jpg_200x200q90.jpg",
        "price": 2386,
        "remark": "https://www.lazada.co.th/products/pdp-i16142496931.html",
        "sold": 0
    },
    {
        "product_name": "น้ำยาล้างกรง สเปร์ยทำความสะอาดกรงกระต่าย กรงกระรอก กรงแฮมเตอร์ หนูแกสบี้ และสัตว์เล็ก 500มล. (3 ขวด) Pet Protect Natural Cage and Hutch Cleaning Spray for Rabbits Hamster",
        "product_image": "https://img.lazcdn.com/g/p/12efe8a56eaf924883a5002ac63137ab.jpg_200x200q90.jpg",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i3883998604.html",
        "sold": 0
    },
    {
        "product_name": "Kin+Kind Fabric+Carpet Pee+Stain+Odor Destroyer สเปรย์ออร์แกนิคขจัดคราบและกลิ่นฉี่สัตว์เลี้ยงสำหรับผ้าและพรม กลิ่นฟลอรัล",
        "product_image": "https://img.lazcdn.com/g/p/b28cd6dcabba4b778babb161d13e2949.png_200x200q90.png",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i4450648870.html",
        "sold": 2
    },
    {
        "product_name": "หมากรุกแม่เหล็กโหมดเกมเกมกระดาน3โหมดเกมหมากรุกอิเลคโทรนิคส์ตั้งค่ากับคู่ต่อสู้ AI สำหรับการฝึกซ้อมการเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/a893069c13e0f7fe7f761acfae32dfaf.jpg_200x200q90.jpg",
        "price": 24788,
        "remark": "https://www.lazada.co.th/products/pdp-i5889718803.html",
        "sold": 1
    },
    {
        "product_name": "ไม้ตกปลาเรือ แผ่นเหล็ก 5G เขย่าช้า ดึงไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9f806c28f06b4cd882a9bf077ed3d826C.jpg_200x200q90.jpg",
        "price": 23420.88,
        "remark": "https://www.lazada.co.th/products/pdp-i6003146957.html",
        "sold": 0
    },
    {
        "product_name": "udiR／C/|รถรีโมทคอนโทรลออฟโรดแข่งความเร็ว 1/16",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb3ef17afafe348db9bf62104e69a9779h.png_200x200q90.png",
        "price": 12409.98,
        "remark": "https://www.lazada.co.th/products/pdp-i6029711078.html",
        "sold": 5
    },
    {
        "product_name": "WUQUGONGSHE | ตุ๊กตาสะสม AI สร้างสรรค์และอารมณ์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5f10aaff880443358805bbd3f45972fas.jpg_200x200q90.jpg",
        "price": 10926.76,
        "remark": "https://www.lazada.co.th/products/pdp-i6001920676.html",
        "sold": 0
    },
    {
        "product_name": "Mould King | ของเล่นโมเดลตึกควบคุมด้วยรีโมท",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4456c7f6f6024aa0ab313ff0c32b55c2U.jpg_200x200q90.jpg",
        "price": 9881.86,
        "remark": "https://www.lazada.co.th/products/pdp-i6003201817.html",
        "sold": 0
    },
    {
        "product_name": "TRIMUI | คอนโซลเกมพกพาแนวตั้งจำลอง GBA รุ่นพิเศษโลหะสไตล์เรโทร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbf2fc3a046b84b958fcbb894a5afbe79s.png_200x200q90.png",
        "price": 9213.24,
        "remark": "https://www.lazada.co.th/products/pdp-i5938272766.html",
        "sold": 34
    },
    {
        "product_name": "Mould King | โมเดลรถแทรกเตอร์ควบคุมระยะไกลสำหรับประกอบที่มีความซับซ้อนสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc0b257acb89841c7b065b438365501f7U.jpg_200x200q90.jpg",
        "price": 9193.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6003325064.html",
        "sold": 0
    },
    {
        "product_name": "R36H รุ่นใหม่ล่าสุด!!!***ของแถมมากมาย-ของแท้100%-ลด30%***แบบพกพาเกม 128G Gameboy Gameboy PSP ของเล่นเกมคอนโซล Retro เกมคอนโซล 21000 + เกมของขวัญปีใหม่ของขวัญวันเกิด r36s ของขวัญคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/p/c96b6b84a510bfcfe7eb59d6854ee1ec.jpg_200x200q90.jpg",
        "price": 6927.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16128951262.html",
        "sold": 0
    },
    {
        "product_name": "Vantage / All-In Set ห่อของขวัญฟรี [บอร์ดเกม Boardgame]",
        "product_image": "https://img.lazcdn.com/g/p/bc65e40559b4d6206b8761ab4a9bd67c.jpg_200x200q90.jpg",
        "price": 6422,
        "remark": "https://www.lazada.co.th/products/pdp-i844820235.html",
        "sold": 0
    },
    {
        "product_name": "ชุดของเล่นเด็กหลายฟังก์ชัน ไม้บีช",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6b5638a5983446cf9ce5c2f0f40bb51fz.jpg_200x200q90.jpg",
        "price": 5413.92,
        "remark": "https://www.lazada.co.th/products/pdp-i6001914061.html",
        "sold": 0
    },
    {
        "product_name": "MIYOO Mini Flip มินิเกมคอนโซลมือถือแบบย้อนยุคพลิก2.8หน้าจอ IPS คอนโซลวิดีโอเกมแบบพกพาคลาสสิกจำลองผู้เล่นย้อนยุคของขวัญ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S23c778bfb946414c96e8e85236047700L.jpg_200x200q90.jpg",
        "price": 4957.18,
        "remark": "https://www.lazada.co.th/products/pdp-i6028884246.html",
        "sold": 1
    },
    {
        "product_name": "HASBRO MONOPOLY SUPER ELECTRONIC BANKING SPECIAL EDITION  เกมส์เศรษฐีแบบกระดานใหญ่ เสริมสร้างทักษะการลงทุนและการคิด  โมโนโพลี่",
        "product_image": "https://img.lazcdn.com/g/p/28314f343222bd606d675ca48bad335a.jpg_200x200q90.jpg",
        "price": 4900,
        "remark": "https://www.lazada.co.th/products/pdp-i1390526501.html",
        "sold": 14
    },
    {
        "product_name": "***ของแท้100%-ของแถมมากมาย-ลด30%***\nR36H ใหม่แบบพกพาเกม 128G Gameboy Gameboy PSP ของเล่นเกมคอนโซล Retro เกมคอนโซล 21000 + เกมของขวัญปีใหม่ของขวัญวันเกิด r36s ของขวัญคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/p/c96b6b84a510bfcfe7eb59d6854ee1ec.jpg_200x200q90.jpg",
        "price": 4848.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16055334457.html",
        "sold": 0
    },
    {
        "product_name": "JJRC | รถรีโมทคอนโทรลปีนเขาแบบมืออาชีพ",
        "product_image": "https://img.lazcdn.com/3rd/q/aHR0cHM6Ly9hZS1waWMtYTEuYWxpZXhwcmVzcy1tZWRpYS5jb20va2YvUzlmODEyYWYxMTBmYjRkNzdhYjYxZGU2MGI3MWRjMjFhcS5qcGc=_200x200q90.png",
        "price": 4440.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6066577713.html",
        "sold": 2
    },
    {
        "product_name": "ของขวัญวันเกิดของเล่นสำหรับเด็กชาย 8-12 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9dc0b2159a8e4f2582db0ff049e62240X.jpg_200x200q90.jpg",
        "price": 4206.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16119366722.html",
        "sold": 0
    },
    {
        "product_name": "Giiker | ของเล่นเกมปริศนาตัวเลขอัจฉริยะสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd3b24c40a2fd40abb67041f51f03f077P.png_200x200q90.png",
        "price": 4063.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16049716182.html",
        "sold": 0
    },
    {
        "product_name": "HUAZINIAO | ของเล่นเสริมทักษะทางปัญญา บล็อก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9aef87738ad34563b2af53bbe19be287d.jpg_200x200q90.jpg",
        "price": 4016.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6062453661.html",
        "sold": 16
    },
    {
        "product_name": "เกมกระดานปริศนาการสร้างเพื่อการศึกษา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa08317550efb47d3bf70007718378045v.jpg_200x200q90.jpg",
        "price": 3766.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6003005197.html",
        "sold": 0
    },
    {
        "product_name": "Houston เกมส์ต่อทีวี เกมแพดคอนโซลอิเล็กทรอนิกส์ 30000 in 1 128GB เครื่องเล่นเกมส์ 3D arcade two player",
        "product_image": "https://img.lazcdn.com/g/p/e883081f846dd507e9a2daf22e9224c4.jpg_200x200q90.jpg",
        "price": 3630,
        "remark": "https://www.lazada.co.th/products/pdp-i5375846373.html",
        "sold": 39
    },
    {
        "product_name": "Potion Explosion ห้องเรียนนักปรุงยา (2nd Edition ถาดลูกแก้วเป็นพลาสติก) Board Game (ภาษาไทย)",
        "product_image": "https://img.lazcdn.com/g/p/93e12e040d20b0d9057e98a3a44e3db1.jpg_200x200q90.jpg",
        "price": 3500,
        "remark": "https://www.lazada.co.th/products/pdp-i5211711301.html",
        "sold": 0
    },
    {
        "product_name": "เกมพกพา R50S",
        "product_image": "https://img.lazcdn.com/g/p/87ddd68c6ca0d61a368f925b617e108c.jpg_200x200q90.jpg",
        "price": 3500,
        "remark": "https://www.lazada.co.th/products/pdp-i5969355423.html",
        "sold": 0
    },
    {
        "product_name": "HASBRO เกมชีวิต The Game of Life คลาสสิก เกมกระดาน สนุกได้ทั้งครอบครัว เกมยอดนิยมจากอเมริกา",
        "product_image": "https://img.lazcdn.com/g/p/fd210327d2a024c7eaecc3404b04d332.jpg_200x200q90.jpg",
        "price": 3390,
        "remark": "https://www.lazada.co.th/products/pdp-i5741712818.html",
        "sold": 0
    },
    {
        "product_name": "เกม เครื่องเล่นเกม 🎮 Mini Box Game ⭐️ 11 in 1  เสียบจอเล่นได้เลย ลงเกมให้ฟรี‼️",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0ce7e9766dd846bc9cafc0234ea67b83F.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i2758994880.html",
        "sold": 0
    },
    {
        "product_name": "Robotime | ชุดตัวต่อไม้แบบเขี้ยวลากดิน ระดับยาก ของเล่นปริศนา 3 มิติ สำหรับประกอบเอง เหมาะกับเด็กชายและผู้ใหญ่อายุ 12 ปีขึ้นไป",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scfecc9e95d1e4639a304223219c448700.jpg_200x200q90.jpg",
        "price": 3312.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5912596079.html",
        "sold": 15
    },
    {
        "product_name": "Brick | ตัวการ์ตูนสะสมมาร์คไรเดอร์ รุ่นที่ห้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S690901a444df4c3ba3555d1e9004686dS.png_200x200q90.png",
        "price": 3260.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6066500144.html",
        "sold": 2
    },
    {
        "product_name": "พร้อมส่ง🛵 เซ็ตบอร์ดเกม Boardgame สุดฮิตจากเมกา 🌟มีหลายแบบให้เลือก",
        "product_image": "https://img.lazcdn.com/g/p/c58c9ffc38cf515245588825a5d5d3fc.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5738467881.html",
        "sold": 0
    },
    {
        "product_name": "ของขวัญของเล่นเด็กชายสุดสร้างสรรค์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf2cfc412451247f381ec9310b929eee4p.jpg_200x200q90.jpg",
        "price": 3176.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16052766830.html",
        "sold": 0
    },
    {
        "product_name": "รถของเล่นควบคุมระยะไกล 2 ชั้นขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc467f90df06e490d8fc4b5d8b32775c4r.jpg_200x200q90.jpg",
        "price": 2820.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16083648559.html",
        "sold": 0
    },
    {
        "product_name": "ตั้งวงเล่นเกมส์ Borad game / Work from home💎การ์ดเกมส์ uno attack💎",
        "product_image": "https://img.lazcdn.com/g/p/abc1748cf396fbfe14867cad9059c47e.jpg_200x200q90.jpg",
        "price": 2800,
        "remark": "https://www.lazada.co.th/products/pdp-i2603649369.html",
        "sold": 0
    },
    {
        "product_name": "ซุ้มเกมจุกน้ำปลา ปาโป่ง ตุ๊กตาตก เต็งแดง93ซม. เกมปาร์ตี้งานเลี้ยงปีใหม่ งานวัดประจำปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scdc804632e1541adbaa2fc9bc05ba4b2R.jpg_200x200q90.jpg",
        "price": 2780,
        "remark": "https://www.lazada.co.th/products/pdp-i5976992908.html",
        "sold": 0
    },
    {
        "product_name": "R36H เกมคอนโซลคอนโซลเกมย้อนยุค 128GB วิดีโอเกมคอนโซลเกมแบบพกพาสามารถชาร์จคอนโซลเกมแบบพกพา 21000+Games เครื่องเล่นเกมพกพา",
        "product_image": "https://img.lazcdn.com/g/p/5945efc339f41080c7a793f276f8488d.jpg_200x200q90.jpg",
        "price": 2778,
        "remark": "https://www.lazada.co.th/products/pdp-i5985553153.html",
        "sold": 7
    },
    {
        "product_name": "【ส่งจากไทย+COD】R36H 128GB คอนโซลเกมย้อนยุคพร้อมเล่น 20000+ เกมในตัว แบบพกพาสไตล์ Gameboy PSP ของเล่นเกมคุณภาพดี ของขวัญวันเกิดเด็กผู้ชาย เปิดกล่องเล่นได้ทันที",
        "product_image": "https://img.lazcdn.com/g/p/27e7a6cf475abce2201f287be060427e.jpg_200x200q90.jpg",
        "price": 2778,
        "remark": "https://www.lazada.co.th/products/pdp-i16129861429.html",
        "sold": 0
    },
    {
        "product_name": "ของเล่นฝึกสมองภาษาอังกฤษสำหรับครอบครัวและโรงเรียนอนุบาล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S46ffbee75d0441f0811a0b9286ae1913y.jpg_200x200q90.jpg",
        "price": 2720,
        "remark": "https://www.lazada.co.th/products/pdp-i16111027056.html",
        "sold": 0
    },
    {
        "product_name": "Brick | ของเล่นรถแปลงร่างสร้างตึก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sef7b274bfc654ac3bcba629b5e0822c7q.png_200x200q90.png",
        "price": 2684,
        "remark": "https://www.lazada.co.th/products/pdp-i5996817994.html",
        "sold": 1
    },
    {
        "product_name": "Giiker ของเล่นอิเล็กทรอนิกส์กระดานปริศนาซูเปอร์สไลด์เกมเซ็นเซอร์อัจฉริยะ 500 + แนวนอนสมองครอบครัวปฏิสัมพันธ์การออกกำลังกายเด็กคิดของเล่น",
        "product_image": "https://img.lazcdn.com/g/p/ef76d9f6042b79be384d92ed28bfa43d.jpg_200x200q90.jpg",
        "price": 2538.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5175457557.html",
        "sold": 15
    },
    {
        "product_name": "PALONG | ชุดเกมกระดานมัลติฟังก์ชันเพื่อการศึกษา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0fefb808c20d43e8939eae126a0c8ffct.jpg_200x200q90.jpg",
        "price": 2491.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16049368294.html",
        "sold": 0
    },
    {
        "product_name": "Brick | ฟิกเกอร์ Kamen Rider",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S284b9f66cc3246a5a14926ca75d07512U.jpg_200x200q90.jpg",
        "price": 2398,
        "remark": "https://www.lazada.co.th/products/pdp-i5996906731.html",
        "sold": 6
    },
    {
        "product_name": "ซูโทเปีย จูดี้ แรบบิท ตำรวจคอสเพลย์เครื่องแต่งกาย ผู้หญิง นิค ฟ็อกซ์ชุดดิสนีย์ การ์ตูน อะนิเมะชุดอุปกรณ์เสริมชุด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S95ae974f52d54fa4b955e64b757869c59.png_200x200q90.png",
        "price": 2365.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5891730847.html",
        "sold": 0
    },
    {
        "product_name": "Hasbro | ฮาสโบร โมโนโพลี ซูเปอร์นัทเชอรัล รุ่นจอยน์เดอะฮันท์ เกมกระดานซื้อขายทรัพย์สินสำหรับผู้เล่น 2-6 คน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S86166487c4c54d5181217deb4ec05c6eO.png_200x200q90.png",
        "price": 2364.4,
        "remark": "https://www.lazada.co.th/products/pdp-i16116383281.html",
        "sold": 0
    },
    {
        "product_name": "Li Xiang|บล็อกตัวต่อเสริมทักษะการเรียนรู้สำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbe80b9ee565d4e6382409a32d777a108Q.jpg_200x200q90.jpg",
        "price": 2354.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6031868848.html",
        "sold": 13
    },
    {
        "product_name": "[พร้อมส่ง!!!] Memory Game เกมกระดาน เกมจับคู่ เปิดภาพ บอร์ดเกม ของเล่น ของเล่นเสริมพัฒนาการ ฝึกความจำ (แบรนด์ GoGo Toys)",
        "product_image": "https://img.lazcdn.com/g/p/d543786e033c4f587f4de8c950f2d189.jpg_200x200q90.jpg",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i2353483417.html",
        "sold": 0
    },
    {
        "product_name": "LALAPLAY | เกมฟุตบอลโต๊ะเพื่อการศึกษาแบบปฏิสัมพันธ์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd1d582b1a921478296059f9fa2e179e0j.jpg_200x200q90.jpg",
        "price": 3516.38,
        "remark": "https://www.lazada.co.th/products/pdp-i5878632398.html",
        "sold": 83
    },
    {
        "product_name": "【Zdandan】COD ไร้สาย การจำลองการเคลื่อนไหว 2.0 ของเล่นวิ่งอัจฉริยะ เสริมพัฒนาการรอบด้าน เกมแข่งรถ ของขวัญสำหรับเด็ก ไม่ต้องใช้จอ",
        "product_image": "https://img.lazcdn.com/g/p/f520e62d91b9196952ef73eb0d8ab030.jpg_200x200q90.jpg",
        "price": 2312,
        "remark": "https://www.lazada.co.th/products/pdp-i6024156639.html",
        "sold": 1
    },
    {
        "product_name": "มินเนี่ยนระเบิด Exploding Minions Board Game",
        "product_image": "https://img.lazcdn.com/g/p/46ca12a0b7cd701dd6b4fd070e51ddee.png_200x200q90.png",
        "price": 2300,
        "remark": "https://www.lazada.co.th/products/pdp-i5961632125.html",
        "sold": 0
    },
    {
        "product_name": "ชุดไดโนเสาร์ ไดโนเสาร์มิสชั่นส์ อลโลซอรัส MOC ชุดรถบรรทุกขนส่ง ของเล่นไดโนเสาร์สำหรับเด็ก ของเล่นสวนสนุกไดโนเสาร์ ของขวัญคริสต์มาส 76966",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2b17782810b140b89930927906be7b2cz.jpg_200x200q90.jpg",
        "price": 2245.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16099484411.html",
        "sold": 0
    },
    {
        "product_name": "【Clitomk】ของเล่นวิ่งอัจฉริยะ เกมการแข่งขันคู่ แทร็กการจําลองการเหนี่ยวนํา ระบบไร้สาย ของขวัญวันเกิด",
        "product_image": "https://img.lazcdn.com/g/p/b10689fa269f00bd817422441e6277dd.jpg_200x200q90.jpg",
        "price": 2238,
        "remark": "https://www.lazada.co.th/products/pdp-i5916884385.html",
        "sold": 2
    },
    {
        "product_name": "RABMIV | คอนโซลเกมพกพาสไตล์คลาสสิก ดูอัลแฮนด์ล รองรับการเล่นแบบหลายผู้เล่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbe3bcf4d5a5343f0953204193e9cf34cJ.jpg_200x200q90.jpg",
        "price": 2222,
        "remark": "https://www.lazada.co.th/products/pdp-i16064969310.html",
        "sold": 1
    },
    {
        "product_name": "JIHU | ของเล่นฝึกสมองสำหรับการแข่งขันสองคน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S70c2d3ba88024932880b78754ad33e78a.jpg_200x200q90.jpg",
        "price": 2222,
        "remark": "https://www.lazada.co.th/products/pdp-i6005801460.html",
        "sold": 3
    },
    {
        "product_name": "Yuecomfly ของเล่นวิ่งอัจฉริยะ ไร้สาย การจำลองการเคลื่อนไหว รางคู่ เกมเกมจำลองการแข่ง ของเล่นเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/cca9a4a7cb391c1fbfb96edecbfdd7c8.jpg_200x200q90.jpg",
        "price": 2198,
        "remark": "https://www.lazada.co.th/products/pdp-i16081546556.html",
        "sold": 0
    },
    {
        "product_name": "Brick | ตัวละครสร้างแบบ Saint Seiya Star Collection ชุดที่ 2",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se2bce72468f14a4e9a5f37373a35dd33a.jpg_200x200q90.jpg",
        "price": 2185.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16052896094.html",
        "sold": 0
    },
    {
        "product_name": "New R36S เกมคอนโซล Retro Game Console 128GB วิดีโอเกม เกมคอนโซลแบบพกพาสามารถชาร เครื่องเกมพกพา Gameboy",
        "product_image": "https://img.lazcdn.com/g/p/1ef44d74ba518f3ac0ae9b4d70f3ecf1.jpg_200x200q90.jpg",
        "price": 2160,
        "remark": "https://www.lazada.co.th/products/pdp-i5876567704.html",
        "sold": 1
    },
    {
        "product_name": "New คอนโซลเกม R36s ดั้งเดิมพร้อมชิปสองชิปคอนโซลแบบพกพาอาร์เคดย้อนยุค เกมเครื่องเกมอาร์เคด ของขวัญมือถือสําหรับเด็กผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/p/1f41119a8da9a519fc25925f40c2a100.jpg_200x200q90.jpg",
        "price": 2160,
        "remark": "https://www.lazada.co.th/products/pdp-i5876592934.html",
        "sold": 11
    },
    {
        "product_name": "ตุ๊กตาเกมส์สำหรับเด็กชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdd7f17155e3d4289bc2fa4683994a9f93.jpg_200x200q90.jpg",
        "price": 2122,
        "remark": "https://www.lazada.co.th/products/pdp-i16087181441.html",
        "sold": 0
    },
    {
        "product_name": "PALONG | กระดานเกมส์การศึกษาหลายฟังก์ชันสำหรับเด็กชาย 5-12 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6ba1c875fa6043d0ab09d08ca061699bg.jpg_200x200q90.jpg",
        "price": 2093.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16049328393.html",
        "sold": 0
    },
    {
        "product_name": "ของเล่นฝึกคิดเพื่อการศึกษาสำหรับเด็กอายุ 3 ถึง 6 ปีเครื่องเกมปาจิงโกะเดสก์ท็อปเล่นเครื่องเกมพินบอลของเล่นแบบโต้ตอบพ่อแม่และลูกเพื่อออกกำลังกายเด็กชายและเด็กหญิงสมาธิ",
        "product_image": "https://img.lazcdn.com/g/p/748a7ab284f4dc9ebce88b9a790c16b4.jpg_200x200q90.jpg",
        "price": 2078,
        "remark": "https://www.lazada.co.th/products/pdp-i4595048967.html",
        "sold": 37
    },
    {
        "product_name": "RABMIV | คอนโซลเกมพกพาสไตล์เรโทร ขนาดเล็ก รองรับผู้เล่นเดี่ยวและคู่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0333df7464194463a88adc617deb25b81.jpg_200x200q90.jpg",
        "price": 2074,
        "remark": "https://www.lazada.co.th/products/pdp-i16065136228.html",
        "sold": 0
    },
    {
        "product_name": "ของเล่นรถบรรทุกเทท้ายควบคุมด้วยรีโมท",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfd8e7679e6d24bae8284926c3bfd47aec.jpg_200x200q90.jpg",
        "price": 2070,
        "remark": "https://www.lazada.co.th/products/pdp-i16089233524.html",
        "sold": 0
    },
    {
        "product_name": "รถตักของเล่นควบคุมระยะไกลขนาดใหญ่สำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S507f55e56d0540169e6030dfc2f0572bQ.jpg_200x200q90.jpg",
        "price": 2042,
        "remark": "https://www.lazada.co.th/products/pdp-i16089052931.html",
        "sold": 0
    },
    {
        "product_name": "เกมกระดานคลูบอร์ด - เกมสืบสวนคดีฆาตกรรมคลาสสิก |   เกมกระดานสำหรับครอบครัวและปาร์ตี้ สำหรับผู้เล่น 2-6 คน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb51ae5fb08a940bd8489067fcc16f6daR.jpg_200x200q90.jpg",
        "price": 1983.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16116428891.html",
        "sold": 0
    },
    {
        "product_name": "LONGGAO | ชุดบล็อกหุ่นยนต์แปลงร่าง ประกอบยาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd18d0a8cb8584154a4af627e7134c46eq.jpg_200x200q90.jpg",
        "price": 1982,
        "remark": "https://www.lazada.co.th/products/pdp-i16089458091.html",
        "sold": 0
    },
    {
        "product_name": "เกมส์งานวัด ทรงโจรสลัด เกมส์จุกน้ำปลาของเล่นงานวัด ไม้แข็งไม้เต็งแดง ทรงสวยไม้เรียบ เกมตุ๊กตาตกปาเป้าปาโป่ง เกมงานเลี้ยงอีเว้นท์",
        "product_image": "https://img.lazcdn.com/g/p/8d86d0f9885615d1b22e4a17e85759d7.jpg_200x200q90.jpg",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i5207722838.html",
        "sold": 0
    },
    {
        "product_name": "Q3 เกมคอนโซล Q3 Retro Mini Handheld Game Console จอ 4.3 นิ้ว 10000 เกมย้อนยุค 90 คลาสสิก 64GB",
        "product_image": "https://img.lazcdn.com/g/p/d908278c096f77f56cbc87e66714181a.png_200x200q90.png",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i5579310052.html",
        "sold": 1
    },
    {
        "product_name": "Q3 เกมคอนโซล เครื่องเล่นวิดีโอเกม จอ 4.3 นิ้ว 10,000 เกมย้อนยุค 90 คลาสสิก Retro Mini Handheld Game Console จัดส่งไว ส่งจากในกรุงเทพ",
        "product_image": "https://img.lazcdn.com/g/p/236edc85a9409dd56b56e4fb9d2f9eef.png_200x200q90.png",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i5579297072.html",
        "sold": 0
    },
    {
        "product_name": "รถปิคอัพของเล่นควบคุมระยะไกลขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5bb2334917c6486e9eae6123e1be8b08s.jpg_200x200q90.jpg",
        "price": 1954.44,
        "remark": "https://www.lazada.co.th/products/pdp-i16053036148.html",
        "sold": 0
    },
    {
        "product_name": "รถโมเดล 1:18 พร้อมรีโมทควบคุมเสียงและไฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2817adf83719407fbcd0c424375920b2S.jpg_200x200q90.jpg",
        "price": 1946,
        "remark": "https://www.lazada.co.th/products/pdp-i16089368195.html",
        "sold": 0
    },
    {
        "product_name": "New R36s เกมคอนโซลคอนโซลเกมย้อนยุค 128GB/64GB วิดีโอเกมคอนโซลเกมแบบพกพาสามารถชาร์จคอนโซลเกมแบบพกพา Gameboy PSP",
        "product_image": "https://img.lazcdn.com/g/p/3e3bf66724e4e7a7d2b490d88b14199a.jpg_200x200q90.jpg",
        "price": 1918,
        "remark": "https://www.lazada.co.th/products/pdp-i5876658518.html",
        "sold": 0
    },
    {
        "product_name": "Aoduoyaya COD ไร้สาย การจำลองการเคลื่อนไหว 2.0 ของเล่นวิ่งอัจฉริยะ เสริมพัฒนาการรอบด้าน เกมแข่งรถ ของขวัญสำหรับเด็ก ไม่ต้องใช้จอ",
        "product_image": "https://img.lazcdn.com/g/p/5654e40fb36aa3ccb36162d2717033a8.jpg_200x200q90.jpg",
        "price": 1916,
        "remark": "https://www.lazada.co.th/products/pdp-i6018449815.html",
        "sold": 3
    },
    {
        "product_name": "เกมตีตัวตุ่น - ของเล่นเสริมพัฒนาการแบบอินเทอร์แอคทีฟพร้อมเสียงและแสง เหมาะสำหรับเด็กชายและเด็กหญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa065021a71c041b281ffeffa08e2e84b6.jpg_200x200q90.jpg",
        "price": 1912.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5966566188.html",
        "sold": 0
    },
    {
        "product_name": "KAKABEIER | ชุดของเล่นรถขุดและรถยนต์สำหรับเด็กเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scb5a4cb2a5464efe85001a223f3e4839g.jpg_200x200q90.jpg",
        "price": 1902,
        "remark": "https://www.lazada.co.th/products/pdp-i5996944143.html",
        "sold": 2
    },
    {
        "product_name": "ToyVille ของเล่นวิ่งอัจฉริยะ เกมการแข่งขันคู่ แทร็กการจําลองการเหนี่ยวนํา ระบบไร้สาย ของขวัญวันเกิด",
        "product_image": "https://img.lazcdn.com/g/p/68cb7976626785b3f7ca22b42a4255e6.jpg_200x200q90.jpg",
        "price": 1852,
        "remark": "https://www.lazada.co.th/products/pdp-i5908075740.html",
        "sold": 8
    },
    {
        "product_name": "R36S เกมคอนโซล retro game console 128GB วิดีโอเกม เกมคอนโซลแบบพกพาสามารถชาร เครื่องเกมพกพา Gameboy PSP ของขวัญวันเกิด",
        "product_image": "https://img.lazcdn.com/g/p/2ff72fc7e2470e5535d23d4c1db51988.jpg_200x200q90.jpg",
        "price": 1798,
        "remark": "https://www.lazada.co.th/products/pdp-i5873701121.html",
        "sold": 2
    },
    {
        "product_name": "Play Game👉 เกมกระดาน What do you meme Board Game (ภาษาอังกฤษ) - บอร์ดเกม  สนุกมาก  มีจำกัด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sacd0dd4362ba4a568260299298ec87072.png_200x200q90.png",
        "price": 1790,
        "remark": "https://www.lazada.co.th/products/pdp-i3398881088.html",
        "sold": 0
    },
    {
        "product_name": "DRAGOMINO ดราโกมิโน่ [TH/EN] ภาษาไทย / English ห่อของขวัญฟรี [บอร์ดเกม Boardgame]",
        "product_image": "https://img.lazcdn.com/g/p/2d73f2799d155a8c21c57a9e8502be6f.jpg_200x200q90.jpg",
        "price": 1782,
        "remark": "https://www.lazada.co.th/products/pdp-i4522273164.html",
        "sold": 5
    },
    {
        "product_name": "MATTEL | เกมการ์ดปาร์ตี้แบบหลายผู้เล่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S58366e6a03a9498188c94ea3f22c285cc.jpg_200x200q90.jpg",
        "price": 1726,
        "remark": "https://www.lazada.co.th/products/pdp-i6025700262.html",
        "sold": 3
    },
    {
        "product_name": "PALONG | ของเล่นปืนธนูสำหรับเด็กผู้ชาย ของขวัญวันเกิด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S06de2f6beafd448da94ddf4d85168000P.jpg_200x200q90.jpg",
        "price": 1722,
        "remark": "https://www.lazada.co.th/products/pdp-i5996887626.html",
        "sold": 0
    },
    {
        "product_name": "1 ชุดเกมไพ่ปาร์ตี้แบบสื่อสารทางจิต 2-12 ผู้เล่น เกมกระดานปาร์ตี้ ภาษาอังกฤษ เกมวางแผนเพื่อความบันเทิง ของเล่นสำหรับครอบครัวในวันหยุด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2c07c54f31bd4048bf10a7c29466e0c69.jpg_200x200q90.jpg",
        "price": 1718.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6075671815.html",
        "sold": 0
    },
    {
        "product_name": "Hasbro | เกมกระดานโมโนโพลีฉบับโปเกมอน คันโต ฉบับโปเกมอน ความรู้สึกในวัยเด็ก เกมปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa3a17afd63604ebaa53d2ba5fd1e6d9fT.png_200x200q90.png",
        "price": 1717.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16102069151.html",
        "sold": 0
    },
    {
        "product_name": "เกมคอนโซล R36S แบบย้อนยุคระบบลินุกซ์ 3.5 นิ้ว 28000 เกม",
        "product_image": "https://img.lazcdn.com/g/p/2c035df7ba1e2d0ef5be149f62ae56b6.jpg_200x200q90.jpg",
        "price": 1710,
        "remark": "https://www.lazada.co.th/products/pdp-i5798255020.html",
        "sold": 1
    },
    {
        "product_name": "G90 7.0 นิ้วคอนโซลเกมพกพาแบบพกพาเรโทร อาร์เคด เกม GBA เครื่องเล่นเกมที่เข้ากันได้ 64G สำหรับการเดินทางเด็กผู้ใหญ่ของขวัญ",
        "product_image": "https://img.lazcdn.com/g/p/bf19e16e4f3b5dbcbeadfcae5b85e357.jpg_200x200q90.jpg",
        "price": 1698,
        "remark": "https://www.lazada.co.th/products/pdp-i16102249501.html",
        "sold": 0
    },
    {
        "product_name": "RABMIV | คอนโซลเกมพกพาสไตล์เรโทร ขนาดเล็ก รองรับสองผู้เล่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa1167deff52c42a19b6f96be7077d228y.jpg_200x200q90.jpg",
        "price": 1696,
        "remark": "https://www.lazada.co.th/products/pdp-i16064982944.html",
        "sold": 0
    },
    {
        "product_name": "เกมคอนโซลแข่งโต๊ะไฟฟ้าเพื่อการศึกษา, ความท้าทายในการผจญภัย, พวงมาลัยขับรถจําลอง, ของเล่นเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5828158d5109414e850254e72f7420adL.jpg_200x200q90.jpg",
        "price": 1679.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6002219835.html",
        "sold": 0
    },
    {
        "product_name": "[สินค้าขายดี] Kushi Express คูชิ จานด่วน ภาษาไทย [TH] ห่อของขวัญฟรี [บอร์ดเกม Boardgame]",
        "product_image": "https://img.lazcdn.com/g/p/ca17f5592508ff6c05fa05c14f9150a2.jpg_200x200q90.jpg",
        "price": 1672,
        "remark": "https://www.lazada.co.th/products/pdp-i1068836815.html",
        "sold": 9
    },
    {
        "product_name": "So Clover! ห่อของขวัญฟรี [บอร์ดเกม Boardgame]",
        "product_image": "https://img.lazcdn.com/g/p/ca0218c9d371b8c596d5f1f8d57625a0.jpg_200x200q90.jpg",
        "price": 1656,
        "remark": "https://www.lazada.co.th/products/pdp-i2776995737.html",
        "sold": 2
    },
    {
        "product_name": "ของเล่นสร้างสรรค์โต๊ะประกอบศึกษา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sba17b85330764049a9d8bf6584d42497A.png_200x200q90.png",
        "price": 1645.66,
        "remark": "https://www.lazada.co.th/products/pdp-i6031786555.html",
        "sold": 1
    },
    {
        "product_name": "Hasbro | เกมกระดานสะสมฉลองครบรอบ 60 ปี Grateful Dead Monopoly สำหรับแฟนๆ และผู้เล่นแนวร็อค",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4c1a35f9d4a64d67a477525cc227b8983.png_200x200q90.png",
        "price": 1643.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16104119891.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องเกมพินบอลอวกาศ เล่นเกมยิงลูกแก้ว เครื่องเกมปริศนาตั้งโต๊ะ ของเล่นสำหรับเด็กอายุ 3 ถึง 6 ขวบ ฝึกสมาธิ",
        "product_image": "https://img.lazcdn.com/g/p/45ea6be752c8789cda889f51eba9a43f.jpg_200x200q90.jpg",
        "price": 1634,
        "remark": "https://www.lazada.co.th/products/pdp-i5741949395.html",
        "sold": 1
    },
    {
        "product_name": "เกมกระดานโมโนโพลีธีมออซซี่ ออสบอร์น ระดับพรีเมียม |   ของสะสมสำหรับแฟนเพลงเฮฟวีเมทัลและกิจกรรมสนุกๆ สำหรับครอบครัว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8695a9de56d9449b9925b21ce333782aw.png_200x200q90.png",
        "price": 1632.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16104532167.html",
        "sold": 0
    },
    {
        "product_name": "ชุดแบ็คแกมมอนแบบพกพาเกมกระดานคลาสสิกแบบม้วนขึ้นไมโครไฟเบอร์และหนัง PU เกมกระดานคลาสสิกเกมกระดานแบ็คแกมมอนหมากรุก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S75f0c59dbf7746768a103f16096edacfp.jpg_200x200q90.jpg",
        "price": 1625.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5939146263.html",
        "sold": 0
    },
    {
        "product_name": "XIAOGUAIDAN | เกมกระดานสำหรับครอบครัว ท้าทายความฉลาด Red Riding Hood",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf46474a556ce42cb876921cacd7b25f6A.jpg_200x200q90.jpg",
        "price": 1619.66,
        "remark": "https://www.lazada.co.th/products/pdp-i6066799693.html",
        "sold": 2
    },
    {
        "product_name": "ของเล่นแผ่นเต้นรำ เกมเต้นรำอิเล็กทรอนิกส์สำหรับเด็ก พร้อมโหมดเกมหลากหลาย ของขวัญวันเกิดที่เหมาะสำหรับเด็กอายุ 3 ปีขึ้นไป",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S80e6eac2487843108f4f94a50f066de1O.jpg_200x200q90.jpg",
        "price": 1617.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6070024069.html",
        "sold": 0
    },
    {
        "product_name": "2025 รุ่นใหม่ 7 สี  R36H คอนโซลเกมพกพาแบบโอเพ่นซอร์ส   คอนโซลพกพาแบบย้อนยุค เกมส์สุดคลาสสิก",
        "product_image": "https://img.lazcdn.com/g/p/0d378b9e84942a8aa5f7f00aed073c04.jpg_webp_200x200q90.jpg",
        "price": 1616.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5835779563.html",
        "sold": 0
    },
    {
        "product_name": "Now เกมคอนโซล R36S แบบย้อนยุคระบบลินุกซ์ 3.5 นิ้ว 28000 เกม",
        "product_image": "https://img.lazcdn.com/g/p/01a39c5cbdd703117e8c354cb188459c.jpg_200x200q90.jpg",
        "price": 1598,
        "remark": "https://www.lazada.co.th/products/pdp-i5873669373.html",
        "sold": 2
    },
    {
        "product_name": "Mattel Game Pictionary เกมวาดภาพทายคำ รุ่น DKD47",
        "product_image": "https://img.lazcdn.com/g/p/16621961af3209a439fbbd42d1b445cb.jpg_200x200q90.jpg",
        "price": 1598,
        "remark": "https://www.lazada.co.th/products/pdp-i5798822698.html",
        "sold": 1
    },
    {
        "product_name": "【ส่งจากไทย+COD】R36S เกมพกพา 64GB 20,000+ เกม ปลุกพลังเกมในตัวคุณด้วย ภาพคมชัด3D ราคาคุ้มสุดจบใน เครื่องเดียว",
        "product_image": "https://img.lazcdn.com/g/p/1fb7db538ae0d6edd53e343bcb583a1e.jpg_200x200q90.jpg",
        "price": 1594,
        "remark": "https://www.lazada.co.th/products/pdp-i5928477002.html",
        "sold": 4
    },
    {
        "product_name": "[ของแท้] บอร์ดเกมลดราคาพิเศษ ประจำLive เกมกล่องกลาง(1000-3000) เกมมือ1ลดราคากล่องบุบ/กล่องมีตำหนิ/กล่องมือสองสภาพดี",
        "product_image": "https://img.lazcdn.com/g/p/182da24b2634c292d5d3bf34086a15be.jpg_200x200q90.jpg",
        "price": 1590,
        "remark": "https://www.lazada.co.th/products/pdp-i646292110.html",
        "sold": 7
    },
    {
        "product_name": "SMART GAMES, Jump In ของเล่นฝึกสมอง เสริมเชาว์ สำหรับเด็ก 7 ปีขึ้นไป ลิขสิทธิ์แท้ จากเบลเยียม ร้านเป็นตัวแทนจำหน่ายในไทย",
        "product_image": "https://img.lazcdn.com/live/th/p/ce31cf63cf4acff360d9c91e85f994d8.jpg_200x200q90.jpg",
        "price": 1584,
        "remark": "https://www.lazada.co.th/products/pdp-i135980255.html",
        "sold": 4
    },
    {
        "product_name": "SMART GAMES, Asteroid Escape ของเล่นฝึกสมอง เสริมเชาว์ สำหรับเด็ก 8 ปีขึ้นไป ลิขสิทธิ์แท้ จากเบลเยียม ร้านเป็นตัวแทนจำหน่ายในไทย",
        "product_image": "https://img.lazcdn.com/g/p/6d9a4993996b97014d781fbf2da7c72e.jpg_200x200q90.jpg",
        "price": 1584,
        "remark": "https://www.lazada.co.th/products/pdp-i263955809.html",
        "sold": 5
    },
    {
        "product_name": "R36S เกมคอนโซล retro game console 128GB 40000+game วิดีโอเกม เกมคอนโซลแบบพกพาสามารถชาร เครื่องเกมพกพา ของขวัญวันเกิด",
        "product_image": "https://img.lazcdn.com/g/p/751b42b890b5c3bd7482c6ffe0c13ead.jpg_200x200q90.jpg",
        "price": 1566.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5915327731.html",
        "sold": 2
    },
    {
        "product_name": "รถของเล่นควบคุมระยะไกลสำหรับเด็กชาย 6-10 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbb832897075944dfbc18e843ce66e826j.jpg_200x200q90.jpg",
        "price": 1555.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6066320710.html",
        "sold": 0
    },
    {
        "product_name": "เกมกระดาน 106 ชิ้น เกมรัมมิกับไม้ 106 แผ่น ชุดเดินทาง กระดานรัมมี่ พร้อมกล่องพกพา เกมกระดานคลาสสิก เกมสำหรับผู้เล่นหลายคน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S88746d27485449f6a4ad0d278d463b12A.jpg_200x200q90.jpg",
        "price": 1552.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16055547060.html",
        "sold": 0
    },
    {
        "product_name": "ลูกบอลหลบหลีกแรงโน้มถ่วง ThinkFun | เกมตรรกะการสร้างทางวิ่งลูกแก้ว 3 มิติ | เกมฝึกสมอง STEM สำหรับเด็กอายุ 8 ปีขึ้นไป | ของเล่นเสริมพัฒนาการด้านการคิดเชิงพื้นที่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3d46f07b721c453687e9f29ce30fc9bbn.jpg_200x200q90.jpg",
        "price": 1545.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16073233552.html",
        "sold": 0
    },
    {
        "product_name": "คอนโซลเกมแบบพกพา LIXADA 3นิ้วจอ HD AV Output คอนโซลเกมย้อนยุคสร้างขึ้นในหลายเกมพร้อมที่จับสีดำ",
        "product_image": "https://img.lazcdn.com/g/p/7185705fca2e1c0a1378e23abbc21e68.jpg_200x200q90.jpg",
        "price": 1536,
        "remark": "https://www.lazada.co.th/products/pdp-i6078230305.html",
        "sold": 0
    },
    {
        "product_name": "421 ชิ้น ชุดตัวต่อคอนโซลเกมสะสม ของเล่นสร้างสรรค์ DIY ของขวัญคริสต์มาสสำหรับเด็ก ของขวัญสำหรับเด็กชาย เด็กหญิง และเพื่อนๆ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S49a7f68fd7a74f57ba52b27f7153abddF.jpg_200x200q90.jpg",
        "price": 1521.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16095468525.html",
        "sold": 0
    },
    {
        "product_name": "เกมโต๊ะลูกแก้วสำหรับเด็ก เกมยิงลูกแก้วจระเข้บนโต๊ะ พร้อมไฟและเสียงเพลง ของเล่นเสริมสร้างปฏิสัมพันธ์ระหว่างพ่อแม่ลูก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbc4833203c274c3cac7c307c471fbfe5O.jpg_200x200q90.jpg",
        "price": 1512.94,
        "remark": "https://www.lazada.co.th/products/pdp-i16108969300.html",
        "sold": 0
    },
    {
        "product_name": "HABA LogiCase กล่องวิเคราะห์เหตุผลสำหรับเด็กวัย 4 ปี 5 ปี 6 ปี 7 ปี โต๊ะเล่นเกมแบบคิดวิเคราะห์ ของเล่นการศึกษาสำหรับเด็ก ของเล่นกระดาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2fb726dd938f426584f009f6851e10a3h.jpg_200x200q90.jpg",
        "price": 1504.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5647228926.html",
        "sold": 1
    },
    {
        "product_name": "Game at home🔸 Hive Board game - บอร์ดเกม หมากแมลง",
        "product_image": "https://img.lazcdn.com/g/p/95ebdede08b35da854001f3ccbbe9157.png_200x200q90.png",
        "price": 1504,
        "remark": "https://www.lazada.co.th/products/pdp-i2913149248.html",
        "sold": 0
    },
    {
        "product_name": "ชุด DIY ของเล่นนุ่มๆ พร้อมผิวภายนอกและไส้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfab78f115e7b4efdad1db5411fef2942u.jpg_200x200q90.jpg",
        "price": 1462.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16083731714.html",
        "sold": 0
    },
    {
        "product_name": "ของเล่นแผ่นเต้นรำ เกมเต้นรำอิเล็กทรอนิกส์สำหรับเด็ก พร้อมโหมดเกมอเนกประสงค์ ไฟ LED ของขวัญวันเกิดที่เหมาะสำหรับเด็กชายและเด็กหญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S72a566bd4b434c6fa21a187f897cf785Y.jpg_200x200q90.jpg",
        "price": 1455.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16046160655.html",
        "sold": 0
    },
    {
        "product_name": "เกมโต๊ะพ่อแม่ลูก แบบจับกระต่ายเพื่อการศึกษาและปฏิสัมพันธ์สำหรับเด็กชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6ad5e0b951394c318cf28eec99204a46V.jpg_200x200q90.jpg",
        "price": 1451.96,
        "remark": "https://www.lazada.co.th/products/pdp-i6022308280.html",
        "sold": 7
    },
    {
        "product_name": "เกมแข่งม้าไฟฟ้า เกมกระดานสนุกสำหรับครอบครัว เด็กและผู้ใหญ่ ของเล่นฟุตบอลบนโต๊ะสุดเร้าใจสำหรับงานปาร์ตี้ เกมเล่นง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sba89ef3ce5624ecd9a1f901f9ec4e07ds.jpg_200x200q90.jpg",
        "price": 1445.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16046308347.html",
        "sold": 0
    },
    {
        "product_name": "GUTIAN | ชุดของเล่นรถขุดสำหรับเด็กอายุ 3-6 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1733b192e2d0432d8dc4c5d165c5e5efI.jpg_200x200q90.jpg",
        "price": 1430.98,
        "remark": "https://www.lazada.co.th/products/pdp-i6071782925.html",
        "sold": 3
    },
    {
        "product_name": "MENGTELI | ของเล่นปริศนาสำหรับเด็ก 1-2 ปี บล็อกสีไม้ Montessori",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdbb3d0fa3e7a43d6ac206012610057e8O.jpg_200x200q90.jpg",
        "price": 1419.36,
        "remark": "https://www.lazada.co.th/products/pdp-i5996809906.html",
        "sold": 0
    },
    {
        "product_name": "เกมกระดานเกาหลี เกมไพ่ กลยุทธ์การจัดการเกมปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfb4a5f15736f4932ab64a01cfd2b4b56R.jpg_200x200q90.jpg",
        "price": 1405.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5977497318.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเกมรัมมี่ขนาดใหญ่พิเศษสำหรับการเดินทาง เกมไพ่ดึงเลขสำหรับผู้ใหญ่ เกมบนโต๊ะสำหรับการสังสรรค์แบบสบายๆ ของเล่นเสริมพัฒนาการ ของขวัญ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa98385e9ab094686bf13182b79835ae49.jpg_200x200q90.jpg",
        "price": 1393.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5950972028.html",
        "sold": 0
    },
    {
        "product_name": "พรุ่งนี้รวย [TH] ภาษาไทย เกมคนไทย โดยนักออกแบบไทย ห่อของขวัญฟรี [บอร์ดเกม Boardgame]",
        "product_image": "https://img.lazcdn.com/g/p/518ec4975d7ed474c35d49e0e6f10ec3.jpg_200x200q90.jpg",
        "price": 1380,
        "remark": "https://www.lazada.co.th/products/pdp-i16063061809.html",
        "sold": 0
    },
    {
        "product_name": "มาใหม่MONOPOLY-Game of Thrones เกมกระดาน English Collection Edition PARTY friend Game",
        "product_image": "https://img.lazcdn.com/g/p/84840a3973b24016b97c7aa780e09fab.png_200x200q90.png",
        "price": 1378,
        "remark": "https://www.lazada.co.th/products/pdp-i808068095.html",
        "sold": 73
    },
    {
        "product_name": "เกมรางวิ่งลูกแก้วไม้ ของเล่นเสริมพัฒนาการ STEM สำหรับเด็ก เกมกระดานฝึกสมองสำหรับเด็กชายและเด็กหญิง ของขวัญวันเกิด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5a35a5596dd6413b864b0bd3ead6b8c4D.jpg_200x200q90.jpg",
        "price": 1376.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16106667696.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องเล่นเกมเทตริสหน้าจอใหญ่ 4.1 นิ้ว รุ่นใหม่ สไตล์ย้อนยุค สำหรับเด็ก เครื่องเล่นเกมพกพา ของเล่นปริศนาในวัยเด็ก ของเล่นเสริมพัฒนาการ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scc5058ea489c4774b1fc68d5aadc110b7.jpg_200x200q90.jpg",
        "price": 1362.18,
        "remark": "https://www.lazada.co.th/products/pdp-i16097868781.html",
        "sold": 0
    },
    {
        "product_name": "ของเล่นเด็กเสริมพัฒนาการแบบมอนเตสซอรี่ เกมผจญภัยรางหลายชั้น ลูกบอลกลิ้งแบบราง ของเล่นเสริมสร้างพัฒนาการสมอง ของขวัญคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6a32cb5b1ced4982a0a94d085a5ae59bL.jpg_200x200q90.jpg",
        "price": 1332.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5988091530.html",
        "sold": 0
    },
    {
        "product_name": "เกมโปเกมอนปิกาจูเวอร์ชั่นภาษาอังกฤษอสังหาริมทรัพย์สำหรับผู้ใหญ่และเด็ก2-6คนเกมสำหรับงานเลี้ยงวันเกิดของขวัญสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S40fd6d1230e847ca9836ee4da6b6edf8D.jpg_200x200q90.jpg",
        "price": 1328.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5862183575.html",
        "sold": 0
    },
    {
        "product_name": "MUZHAN | เครื่องทำเม็ดอาหารสัตว์ขนาดเล็ก แห้ง-เปียก ใช้งานได้ทั้งสองแบบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5cb724a4192c4003b165936150fbedcfd.jpg_200x200q90.jpg",
        "price": 80581.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16097639601.html",
        "sold": 0
    },
    {
        "product_name": "Joyoung | เครื่องทำนมถั่วเหลือง สำหรับบ้าน แบบอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S02ae93cedc914d759d0464a589cf86bac.png_200x200q90.png",
        "price": 40675.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16051328024.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องหั่นหมูสแตนเลส แบบตั้งพื้น ถอดหัวได้ 2200วัตต์ ประกันมอเตอร์ 1ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfa5bcc1360b84487b1bfa97877c06699Z.jpg_200x200q90.jpg",
        "price": 35000,
        "remark": "https://www.lazada.co.th/products/pdp-i16082757115.html",
        "sold": 0
    },
    {
        "product_name": "bixdo | แปรงสีฟันไฟฟ้าสีขาวลดแสงสีน้ำเงิน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S90de931351da436babeeb0509ed31c07Z.png_200x200q90.png",
        "price": 19519.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5952368175.html",
        "sold": 413
    },
    {
        "product_name": "ZHONGJIA |เครื่องตัดกระดูกไฟฟ้าขนาดเล็กสำหรับใช้ในบ้าน ตัดเท้าหมู กระดูกซี่โครง และกระดูกวัว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sedc7e28e38b34b2c810c0a65fb6bb548Y.jpg_200x200q90.jpg",
        "price": 17273.46,
        "remark": "https://www.lazada.co.th/products/pdp-i5938200775.html",
        "sold": 133
    },
    {
        "product_name": "หมอทอดไรนำมน Steamcook Basic 12 ลตร สครมไวท รน AV12E10CC",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6fb696d8d7c540f391243f550e2276b2i.png_200x200q90.png",
        "price": 17261.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5950646180.html",
        "sold": 0
    },
    {
        "product_name": "Ninja Foodi Power Mixer System CI100TH เครื่องปั่นมือถือ 3in1 เครื่องตี เครื่องสับ Hand Blender Chopper Mixer 850W ปรับความเร็วได้",
        "product_image": "https://img.lazcdn.com/g/p/532d9b9a11fe17cd65d169178833c617.png_200x200q90.png",
        "price": 15960,
        "remark": "https://www.lazada.co.th/products/pdp-i16101370218.html",
        "sold": 0
    },
    {
        "product_name": "Sooop ที่หั่นอาหารไฟฟ้าปรับความหนาได้110V พร้อมใบมีดสแตนเลสเครื่องตัดเนื้อขนาดกะทัดรัดสำหรับชีสขนมปังเนื้อบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/79dad28fd0f635820e1a13fda496e96b.jpg_200x200q90.jpg",
        "price": 14352,
        "remark": "https://www.lazada.co.th/products/pdp-i6052218286.html",
        "sold": 0
    },
    {
        "product_name": "ฮีตเตอร์แบบเหนี่ยวนำ ZVS 2500สำหรับการหลอมโลหะและการหลอมโลหะแบบ DIY",
        "product_image": "https://img.lazcdn.com/g/p/ab4939efedcb99c25b0dcd3c5db179f4.jpg_200x200q90.jpg",
        "price": 11596,
        "remark": "https://www.lazada.co.th/products/pdp-i6004611223.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำฮีตเตอร์ต่อประกบเซ็นเซอร์อัจฉริยะเครื่องต่อใยแก้วนำแสงหลอมรวมอิสระกับแบตเตอรี่โทรศัพท์ Li ชาร์จซ้ำได้สำหรับงานกลางแจ้งฮีตเตอร์ความร้อน",
        "product_image": "https://img.lazcdn.com/g/p/22c6279de3c286f3790c2aca73dd7200.jpg_200x200q90.jpg",
        "price": 11274,
        "remark": "https://www.lazada.co.th/products/pdp-i6052171971.html",
        "sold": 0
    },
    {
        "product_name": "KELAJI | โต๊ะรีดผ้าดูดเองไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saf5f549debec4b1399a9f3e95c86b3b63.jpg_200x200q90.jpg",
        "price": 10826.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16074921267.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องคั้นน้ำผลไม้พร้อมแยกกากหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se3235d9f8c784701b6e5fdb4d138b9841.jpg_200x200q90.jpg",
        "price": 10201.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5874173767.html",
        "sold": 10
    },
    {
        "product_name": "Mischief | เครื่องบดกาแฟไฟฟ้า MisChief Mini ใบมีด 7 แฉก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S05841e8c36274449883a03cabbd0aaa2c.jpg_200x200q90.jpg",
        "price": 9855.78,
        "remark": "https://www.lazada.co.th/products/pdp-i6066805349.html",
        "sold": 1
    },
    {
        "product_name": "Ninja Blast™ เครื่องปั่นพกพาไร้สาย 18 ออนซ์ กะทัดรัด ชาร์จไฟได้ (ปั่นได้ 10 ครั้ง/ชาร์จ)",
        "product_image": "https://img.lazcdn.com/g/p/f128b65beafc08d18e92a97cdb73ba92.png_200x200q90.png",
        "price": 8900,
        "remark": "https://www.lazada.co.th/products/pdp-i5887452795.html",
        "sold": 0
    },
    {
        "product_name": "Hurma | เครื่องคั้นน้ำผลไม้อัตโนมัติแยกชั้นกาก ป้อนอาหารได้มาก ทำความสะอาดง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S17616afa2de94392bb06aa82d873176bm.jpg_200x200q90.jpg",
        "price": 8650.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5877019314.html",
        "sold": 17
    },
    {
        "product_name": "Liven | เครื่องทำอาหารทอดไร้น้ำมันแบบไม่ต้องเคลือบ ความจุใหญ่ แหล่งความร้อนคู่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2172d1ca295645528d41055498a3c9dcI.png_200x200q90.png",
        "price": 7855.66,
        "remark": "https://www.lazada.co.th/products/pdp-i5968591761.html",
        "sold": 427
    },
    {
        "product_name": "APIXINTL | เครื่องทำอาหารอัตโนมัติเต็มรูปแบบสำหรับใช้ในบ้าน พร้อมฟังก์ชันหลายอย่าง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S380bbbdf925b4a449d10951cb7770a1ae.png_200x200q90.png",
        "price": 7413.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5880036187.html",
        "sold": 8
    },
    {
        "product_name": "Maxwin | กาต้มน้ำไฟฟ้าอัตโนมัติพร้อมกันความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S73faf881398d4347b6d266c01fa1ff70K.png_200x200q90.png",
        "price": 7147.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5981438272.html",
        "sold": 68
    },
    {
        "product_name": "กาน้ำชาแบบไฟฟ้า ทเมคเกอร์ กาต้มน้ำแก้ว 308Tx2",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3c3fbca3cf0340f78d28dbd9a4bf6dfcQ.png_200x200q90.png",
        "price": 6219.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5965762077.html",
        "sold": 0
    },
    {
        "product_name": "Joyoung | เครื่องปั่นขนาดครอบครัวเล็ก หลายฟังก์ชัน อัตโนมัติ เงียบ ทำความสะอาดง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S73864c96351240ae8143cf0323a4ff45i.png_200x200q90.png",
        "price": 5993.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16050749006.html",
        "sold": 0
    },
    {
        "product_name": "DANBIYIN | เครื่องบดเนื้อไฟฟ้า สำหรับใช้ในเชิงพาณิชย์และที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb521bc417fa04d87bcbde5c27e53ccaeT.jpg_200x200q90.jpg",
        "price": 5893.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16060646210.html",
        "sold": 0
    },
    {
        "product_name": "YIYUE | เครื่องสกัดน้ำผลไม้หลายฟังก์ชัน ความจุมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9086870a46884ec8aec6b984c124ccb4Y.jpg_200x200q90.jpg",
        "price": 5870.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5929437565.html",
        "sold": 1
    },
    {
        "product_name": "SUNATUR | เครื่องแปรรูปอาหารอัตโนมัติหลายฟังก์ชันสำหรับบ้านและธุรกิจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf6c7147e17d7407e81dae259457dc7a6Z.png_200x200q90.png",
        "price": 5564.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5875520180.html",
        "sold": 20
    },
    {
        "product_name": "Ukey | เครื่องหนีบผมไอน้ำเย็นประจุลบอ่อนโยน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se85085845738486eac4b9ea671c88f9da.png_200x200q90.png",
        "price": 5360.76,
        "remark": "https://www.lazada.co.th/products/pdp-i5990987641.html",
        "sold": 35
    },
    {
        "product_name": "AUX | เตาอบหลายฟังก์ชันสำหรับบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa962cfffd2194bb183278384a5cf50bei.png_200x200q90.png",
        "price": 5358,
        "remark": "https://www.lazada.co.th/products/pdp-i6006001655.html",
        "sold": 101
    },
    {
        "product_name": "Liven | เครื่องปั่นและทำนมถั่วเหลืองเงียบหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1cc04c3faabd4a8ea2437934faec2474v.jpg_200x200q90.jpg",
        "price": 5283.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5968615770.html",
        "sold": 108
    },
    {
        "product_name": "LONGKE | เครื่องผสมปูนและคอนกรีตแบบมือถือพลังสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S69077ffe51e54f9ba283192c9330d7a65.jpg_200x200q90.jpg",
        "price": 5212.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5910872099.html",
        "sold": 29
    },
    {
        "product_name": "NEW 2025 BABYKO เครื่องปั่นและนึ่งอาหารเด็กมาพร้อมใบมีดรุ่นใหม่ สแตนเลสแท้ สามารถปั่น นึ่ง อุ่นได้มากกว่าถึง 10 เมนู",
        "product_image": "https://img.lazcdn.com/g/p/0e1a6b389b42349d9cd1465b8ac7f888.jpg_200x200q90.jpg",
        "price": 4990,
        "remark": "https://www.lazada.co.th/products/pdp-i5794286674.html",
        "sold": 5
    },
    {
        "product_name": "Joyoung | เครื่องปั่นขนาดเล็กอัตโนมัติไม่ทิ้งเศษ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S49f7e9d6c84e4524ad76233a1006f526g.png_200x200q90.png",
        "price": 4774.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16051208387.html",
        "sold": 0
    },
    {
        "product_name": "ถังน้ำไฟฟ้าความจุใหญ่ ทำความร้อนอัตโนมัติ กันความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S19b283a1278d42178ac42a303228a501F.jpg_200x200q90.jpg",
        "price": 4703.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16102729792.html",
        "sold": 0
    },
    {
        "product_name": "MONGDIO | เครื่องบดกาแฟไฟฟ้าปริมาณแน่นอนแกนเหล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sda61f914e60c461186570f366146ed2b3.jpg_200x200q90.jpg",
        "price": 4695.38,
        "remark": "https://www.lazada.co.th/products/pdp-i6066488431.html",
        "sold": 5
    },
    {
        "product_name": "LONGKE | เครื่องผสมอาหารและคอนกรีตอุตสาหกรรมไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb477ec0d63254b48be67bc9bfd4363fd4.jpg_200x200q90.jpg",
        "price": 4359.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5910863482.html",
        "sold": 33
    },
    {
        "product_name": "LONGKE | เครื่องผสมปูนซีเมนต์ไฟฟ้ากำลังสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd3e456b04b5c430d92afee02cb2b1828Z.jpg_200x200q90.jpg",
        "price": 4322.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5910865292.html",
        "sold": 11
    },
    {
        "product_name": "HDBROS | กาต้มน้ำไฟฟ้าควบคุมอุณหภูมิสำหรับชากาแฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S599899495ff74ea29d1fd1fb447ce6d4S.jpg_200x200q90.jpg",
        "price": 4258.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5996975168.html",
        "sold": 26
    },
    {
        "product_name": "JIEXG | กาต้มน้ำไฟฟ้าพกพาสำหรับป้อนอาหารเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sff1b7d83ecb44628b96b890d514e8f43s.png_200x200q90.png",
        "price": 4241.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6019051904.html",
        "sold": 24
    },
    {
        "product_name": "ไมโครเวฟ เตาไมโครเวฟ ระบบลูกบิด ความจุสูง 28L กำลังไฟสูง 2200W ทำความร้อน 360° รับประกัน 3ปี",
        "product_image": "https://img.lazcdn.com/g/p/18c86af19daf47a374db68a2320d8f67.jpg_200x200q90.jpg",
        "price": 4598,
        "remark": "https://www.lazada.co.th/products/pdp-i6069889016.html",
        "sold": 24
    },
    {
        "product_name": "ท่อทำความร้อนสแตนเลสกำลังสูง หม้อต้มไฟฟ้าอุตสาหกรรม เครื่องทำความร้อนน้ำมันความร้อน วิศวกรรมน้ำ เสื้อกล้าม แท่ง 380V",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4f80a3a330e74480b0dd45c0aa726f22i.jpg_200x200q90.jpg",
        "price": 4172.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6026155227.html",
        "sold": 0
    },
    {
        "product_name": "JIEXG กาต้มน้ำอุณหภูมิคงที่ขนาดเล็กพกพาได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se131bfce47a4495c849221f3fbf40d72l.jpg_200x200q90.jpg",
        "price": 4153.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6019214161.html",
        "sold": 22
    },
    {
        "product_name": "Royalty Line | แก้วปั่นนมถั่วเหลืองมินิ ไม่ต้องกรอง ชาร์จ USB สำหรับ 1 คน ปั่นสมูทตี้/ซุปได้",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Seeb927e1ecea4ccbbb8c9719d40755c6o.jpg_200x200q90.jpg",
        "price": 4135.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6019155314.html",
        "sold": 192
    },
    {
        "product_name": "JIEXG | กาต้มน้ำพกพาพร้อมระบบทำความร้อนและเก็บความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8387145f88034711aff24c3d5afb4d5eC.jpg_200x200q90.jpg",
        "price": 4127.92,
        "remark": "https://www.lazada.co.th/products/pdp-i6019142303.html",
        "sold": 20
    },
    {
        "product_name": "YIYUE | เครื่องทำอาหารไร้น้ำมัน ความจุใหญ่ มองเห็นได้ ไม่ต้องกลับด้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc44fe4eac5984afca37cefa80b35773fp.jpg_200x200q90.jpg",
        "price": 4118.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6019175189.html",
        "sold": 0
    },
    {
        "product_name": "FANGTAITAI | เครื่องบดอเนกประสงค์สำหรับการใช้งานเชิงพาณิชย์และในบ้าน บดเป็นผงละเอียดสูง",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Se7f6e7173d134fc89a9a1c20c46a8687Y.png_200x200q90.png",
        "price": 4052.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5876971478.html",
        "sold": 69
    },
    {
        "product_name": "Bear | กระทะไฟฟ้าไม่ติดกระทะ ลึก หลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4d2181fad2664fefa3b097522859624eO.jpg_200x200q90.jpg",
        "price": 4022.08,
        "remark": "https://www.lazada.co.th/products/pdp-i5878398561.html",
        "sold": 130
    },
    {
        "product_name": "มันคือกล่องไดโอดบริดจ์ ติดตั้งกับแอร์บ้านที่เป็นระบบ อินเวอร์เตอร์ ทำหน้าที่ผสมไฟฟ้ากับโซล่าเซลล์ สำหรับแอร์ 9000-24000",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sda6d4479ce5c44f98140a023b899e2563.jpg_200x200q90.jpg",
        "price": 3996,
        "remark": "https://www.lazada.co.th/products/pdp-i16116214626.html",
        "sold": 0
    },
    {
        "product_name": "JIEXG | กาต้มน้ำไฟฟ้าสแตนเลสพกพา ความจุมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Safd5c00e85c345819e231cfe66e2f71aG.png_200x200q90.png",
        "price": 3971.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6019133249.html",
        "sold": 118
    },
    {
        "product_name": "JIEXG | กาต้มน้ำไฟฟ้าพกพาพร้อมฉนวนกันความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5435c4801e684b1090d78583813a92abz.jpg_200x200q90.jpg",
        "price": 3970.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6019106586.html",
        "sold": 23
    },
    {
        "product_name": "LONGKE | เครื่องผสมอาหารไฟฟ้าขนาดเล็กสำหรับครัวเรือน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb477ec0d63254b48be67bc9bfd4363fd4.jpg_200x200q90.jpg",
        "price": 3870.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5910846166.html",
        "sold": 1
    },
    {
        "product_name": "YIYUE | เครื่องทอดลมร้อนความจุใหญ่หลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S394105639c7d4c1fbc05a3f9fbeb57e5i.png_200x200q90.png",
        "price": 3818.9,
        "remark": "https://www.lazada.co.th/products/pdp-i6019192260.html",
        "sold": 1
    },
    {
        "product_name": "JIEXG | กาต้มน้ำไฟฟ้าพกพาขนาดเล็กสำหรับเดินทาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa9366811c124436394c118b5dfd41602l.jpg_200x200q90.jpg",
        "price": 3744.82,
        "remark": "https://www.lazada.co.th/products/pdp-i6019153249.html",
        "sold": 153
    },
    {
        "product_name": "mixwin | กาต้มน้ำไฟฟ้าอัตโนมัติสำหรับทำชาขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S54aa97a2dd414566ab650b3dafbe06a0n.jpg_200x200q90.jpg",
        "price": 3579.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5981196659.html",
        "sold": 103
    },
    {
        "product_name": "LONGKE | เครื่องผสมไฟฟ้ากำลังสูงสำหรับปูนซีเมนต์ สี และปูนฉาบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scccca1d8c00b4042a0f2cb243be735be0.jpg_200x200q90.jpg",
        "price": 3368.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5910939262.html",
        "sold": 1
    },
    {
        "product_name": "Sharp กระติกน้ำร้อน กาน้ำร้อน กาต้มน้ำ รุ่น KP - B36S 3.6 ลิตร กำลังไฟฟ้า 670 วัตต์ สีขาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc1aefd5348574d5f96b70d78ac8e39a2a.jpg_200x200q90.jpg",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i5832683117.html",
        "sold": 0
    },
    {
        "product_name": "JIEXG | ถ้วยตุ๋นไฟฟ้าสำหรับอาหารเช้าหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb54a8210d4dd4a18a0d21d1015cf548b1.png_200x200q90.png",
        "price": 3288.94,
        "remark": "https://www.lazada.co.th/products/pdp-i6019151480.html",
        "sold": 22
    },
    {
        "product_name": "Maxwin | กาต้มน้ำไฟฟ้าปากยาวแคบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sde953eea002d45b89807fb748c750936D.png_200x200q90.png",
        "price": 3249.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5981281445.html",
        "sold": 42
    },
    {
        "product_name": "หม้อต้มความดันสูงหนาแบบทนทานต่อการระเบิดสำหรับใช้ในครัวเรือน เตาแก๊ส เตาแม่เหล็กไฟฟ้า หม้อต้มน้ำ ขนาดเล็กสำหรับคนสองคน เครื่องปรุงรสสำหรับใช้ในธุรกิจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd5b8e3c3bb484bf29cc02d9dd824edddI.jpg_200x200q90.jpg",
        "price": 3057.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16082641300.html",
        "sold": 0
    },
    {
        "product_name": "UBelle | เครื่องหนีบผมและม้วนผม รุ่น UBelle HB-78 ช่วยลดไฟฟ้าสถิตและผมชี้ฟู",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Sa3dcd4f3060a45299220bc9483cb9db4j.png_200x200q90.png",
        "price": 3051.58,
        "remark": "https://www.lazada.co.th/products/pdp-i5909635713.html",
        "sold": 246
    },
    {
        "product_name": "JIEXG | หม้อพกพาสำหรับตุ๋น ต้ม และอุ่นนม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scbff7a2952c241b993374a36120f358fY.jpg_200x200q90.jpg",
        "price": 3045.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6019164512.html",
        "sold": 254
    },
    {
        "product_name": "SIRHINO | เครื่องหั่นหญ้าและผักสแตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S556f58ef43444950b98b78d59c71dda5I.jpg_200x200q90.jpg",
        "price": 3036,
        "remark": "https://www.lazada.co.th/products/pdp-i6028047624.html",
        "sold": 0
    },
    {
        "product_name": "หม้อต้มพกพาขนาดเล็กหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sefa75b8be8eb4a168847df854253ac9bh.png_200x200q90.png",
        "price": 3020,
        "remark": "https://www.lazada.co.th/products/pdp-i6005989446.html",
        "sold": 21
    },
    {
        "product_name": "sunnykinder | เครื่องปั่นและอุ่นนมสำหรับเด็กอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8223360215fc4271b176c5f173aadce9s.jpg_200x200q90.jpg",
        "price": 2868.66,
        "remark": "https://www.lazada.co.th/products/pdp-i5912448945.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องทำป๊อปคอร์นอัตโนมัติขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3d947a9fbf2848d39c4db4842bdef0e9H.jpg_200x200q90.jpg",
        "price": 2674,
        "remark": "https://www.lazada.co.th/products/pdp-i16089168711.html",
        "sold": 0
    },
    {
        "product_name": "AHKISS | เครื่องมือทำลอนผมแบบคลื่นน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd4991c5b0843466cab3f32e7c6cdc153d.png_200x200q90.png",
        "price": 2673.08,
        "remark": "https://www.lazada.co.th/products/pdp-i5991008528.html",
        "sold": 187
    },
    {
        "product_name": "JIEXG | กาต้มน้ำไฟฟ้าขนาดเล็กแบบพกพา, กาต้มน้ำร้อนและเก็บความร้อน, แก้วน้ำร้อนไฟฟ้าสำหรับเดินทาง",
        "product_image": "https://img.lazcdn.com/3rd/q/aHR0cHM6Ly9hZS1waWMtYTEuYWxpZXhwcmVzcy1tZWRpYS5jb20va2YvU2I0ZDY3MmRiY2IyOTQ4MjI4YzRjZjIwYzc1NDAxOTY4Wi5wbmc=_200x200q90.png",
        "price": 2668.16,
        "remark": "https://www.lazada.co.th/products/pdp-i6019047996.html",
        "sold": 568
    },
    {
        "product_name": "Bear | เครื่องบดเนื้อไฟฟ้าปรับความเร็วได้ 4 ระดับ พร้อมจอแสดงผลขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5ba2cc0422e148b384de9890fbcc93b13.jpg_200x200q90.jpg",
        "price": 2586.18,
        "remark": "https://www.lazada.co.th/products/pdp-i5878402656.html",
        "sold": 10
    },
    {
        "product_name": "Bear | กาต้มน้ำไฟฟ้าความจุใหญ่หลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se2aeedb35e514aa2876d66f75ee8ae22L.png_200x200q90.png",
        "price": 2582.3,
        "remark": "https://www.lazada.co.th/products/pdp-i5878294611.html",
        "sold": 72
    },
    {
        "product_name": "GEDO | กระทะทอดลึกช่วยประหยัดน้ำมัน สแตนเลส 304",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se7b9dd8c1f9d44809b0d0e307a82974fq.jpg_200x200q90.jpg",
        "price": 2470.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5876962477.html",
        "sold": 23
    },
    {
        "product_name": "**ของแท้จากช็อป100%-ลด29%-ของแถมอีกมากมาย***หม้ออบลมร้อน หม้อทอดไร้น้ำมัน ขนาด 3.5 ลิตร รุ่น MV-1350",
        "product_image": "https://img.lazcdn.com/g/p/4e92c963d683c0bea0d1cca9ddc83a06.jpg_200x200q90.jpg",
        "price": 2430.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5855106830.html",
        "sold": 2
    },
    {
        "product_name": "KUWUBIANJING | กาต้มน้ำไฟฟ้าอัจฉริยะควบคุมอุณหภูมิคงที่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf163aad637af45a5981a4c54d5a58fb3G.jpg_200x200q90.jpg",
        "price": 2350.9,
        "remark": "https://www.lazada.co.th/products/pdp-i6023211742.html",
        "sold": 4
    },
    {
        "product_name": "Bear | กาต้มน้ำไฟฟ้าขนาดเล็กพกพาได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se040bef2174f4040b565841e79d9c1564.png_200x200q90.png",
        "price": 2346.52,
        "remark": "https://www.lazada.co.th/products/pdp-i5877031687.html",
        "sold": 40
    },
    {
        "product_name": "พัดลมทำความสะอาดอากาศ กำจัดฝุ่น ป้องกันไฟฟ้าสถิตย์ ขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scc8680bac2a04c6f99140e36af74cf92f.jpg_200x200q90.jpg",
        "price": 2166,
        "remark": "https://www.lazada.co.th/products/pdp-i6028083421.html",
        "sold": 1
    },
    {
        "product_name": "YIYUE | เครื่องทำอาหารไร้น้ำมันอเนกประสงค์ ความจุใหญ่ ไร้ควัน ไขมันต่ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sefda214b422b419fb7fc05daf107bdfbP.jpg_200x200q90.jpg",
        "price": 2128.28,
        "remark": "https://www.lazada.co.th/products/pdp-i6019060768.html",
        "sold": 1
    },
    {
        "product_name": "Nanwei | เครื่องตัด ขัด เลื่อยไร้สาย 20V",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S855682e6a75b4d26a4baeed0c8aea4a0m.jpg_200x200q90.jpg",
        "price": 4019.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5955194605.html",
        "sold": 36
    },
    {
        "product_name": "CHNT | เครื่องเชื่อมทองแดงพกพา 2 แรงดันไฟฟ้า 220V/380V",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S826605d4a96e4904a78f9633ae5f2af4D.png_200x200q90.png",
        "price": 3615.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6003326886.html",
        "sold": 72
    },
    {
        "product_name": "AUX | กาต้มน้ำไฟฟ้าพกพาอัจฉริยะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1848c30b95e04bf9b7026c9015d4daceJ.png_200x200q90.png",
        "price": 2114.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5991842569.html",
        "sold": 42
    },
    {
        "product_name": "เครื่องปั่นน้ำผลไม้ แบบพกพา Electrolox รุ่น E3CB1-200S ร้อนนี้ต้องจัด",
        "product_image": "https://img.lazcdn.com/g/p/6a81dbd7c9f4ef6577557183cb3ffb70.jpg_200x200q90.jpg",
        "price": 1999,
        "remark": "https://www.lazada.co.th/products/pdp-i16078770655.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องผสมไฟฟ้าขนาดเล็กสำหรับใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd4d32b19d68b464f89f3213048531cb9e.jpg_200x200q90.jpg",
        "price": 1874.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16089420443.html",
        "sold": 0
    },
    {
        "product_name": "ABP | เครื่องหนีบและม้วนผมไอออนลบลดความเสียหาย 2-in-1 แผ่นเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2c30ffae501a40b2a60227418834a8caF.jpg_200x200q90.jpg",
        "price": 1837.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5974543383.html",
        "sold": 1
    },
    {
        "product_name": "ABP | เครื่องหนีบผมตรงจากข้าวโพดพอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd630f679af5c48a4aaf09639b432255bs.jpg_200x200q90.jpg",
        "price": 1809.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5931460022.html",
        "sold": 2
    },
    {
        "product_name": "ABP | เครื่องหนีบผมตรงและม้วนผมพร้อมไอออนลบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S65910e7bd5014d3d839ab84a33461bc5W.jpg_200x200q90.jpg",
        "price": 1803.76,
        "remark": "https://www.lazada.co.th/products/pdp-i5927769891.html",
        "sold": 2
    },
    {
        "product_name": "กระทะไฟฟ้าอเนกประสงค์ไม่ติดกระทะ ไร้ควัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6063ca59cf21407b9fec176138f5b501L.jpg_200x200q90.jpg",
        "price": 1794,
        "remark": "https://www.lazada.co.th/products/pdp-i6026070858.html",
        "sold": 0
    },
    {
        "product_name": "BONINGYU | เครื่องเพิ่มความชื้นและกระจายกลิ่นแบบ USB พร้อมเอฟเฟกต์ไฟลวงตา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sef0f01473d174f09aa66a9ed780b6a42b.jpg_200x200q90.jpg",
        "price": 1767.58,
        "remark": "https://www.lazada.co.th/products/pdp-i5968854652.html",
        "sold": 1
    },
    {
        "product_name": "Liven | เครื่องบดเนื้อหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb1f8c33c558c4472b1e3e40fb98cf63fk.png_200x200q90.png",
        "price": 1765.74,
        "remark": "https://www.lazada.co.th/products/pdp-i6011023683.html",
        "sold": 114
    },
    {
        "product_name": "กาต้มน้ำควบคุมอุณหภูมิสำหรับเด็กทารก ขนาด 1.2 ลิตร รุ่นใหม่ พร้อมระบบอุ่นนมอัตโนมัติ และฉนวนกันความร้อนอัจฉริยะ สำหรับนมผง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S42914778f62a4841af5a5eb8451ecdf2W.jpg_200x200q90.jpg",
        "price": 1764.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16099369804.html",
        "sold": 0
    },
    {
        "product_name": "Cool A Styler คูล อะ สไตเลอร์ ไดร์เป่าผม สีขาว ความเร็วสูง 1600W (CA-V11)",
        "product_image": "https://img.lazcdn.com/g/p/4ddb866504b1af8d3dd655d65cbc00f6.jpg_200x200q90.jpg",
        "price": 1740,
        "remark": "https://www.lazada.co.th/products/pdp-i6069687586.html",
        "sold": 0
    },
    {
        "product_name": "MAKETUBU | เครื่องเพิ่มความชื้นคุณภาพสูงสำหรับใช้งานจริง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9470d55a38fe4d51a5edf15c4667c6cbI.jpg_200x200q90.jpg",
        "price": 1726.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6001861433.html",
        "sold": 2
    },
    {
        "product_name": "yishujia office | กระทะไฟฟ้าไม่ติดกระทะ ใช้ได้หลายวัตถุประสงค์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb1b4c5bc69d94264973af8dd40f0a028l.jpg_200x200q90.jpg",
        "price": 1720.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16059015175.html",
        "sold": 0
    },
    {
        "product_name": "หม้อไฟฟ้าอเนกประสงค์แบบอัตโนมัติ แก้วหนา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S49eb98561cc54e689ef6d0bb938249afY.jpg_200x200q90.jpg",
        "price": 1618.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16056549417.html",
        "sold": 0
    },
    {
        "product_name": "JITIANSHE | เครื่องเพิ่มความชื้นรูปเปลวไฟ ของขวัญระดับไฮเอนด์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9b821b398f66412aaca11a43aa485d50c.jpg_200x200q90.jpg",
        "price": 1616,
        "remark": "https://www.lazada.co.th/products/pdp-i6026119864.html",
        "sold": 2
    },
    {
        "product_name": "ไดร์เป่าผมTUR BO  3900วัตต์ ช่างเสริมสวยนิยมใช้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S81159e169be04c2b949a9adeda20acddp.jpg_200x200q90.jpg",
        "price": 1598,
        "remark": "https://www.lazada.co.th/products/pdp-i5876999965.html",
        "sold": 18
    },
    {
        "product_name": "แก้วไฟฟ้า แบบต้ม-ตุ๋นในตัว",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S16897291fead4590a9505d1b8bf98dd5O.jpg_200x200q90.jpg",
        "price": 1585.36,
        "remark": "https://www.lazada.co.th/products/pdp-i6019193089.html",
        "sold": 5
    },
    {
        "product_name": "ABP | เครื่องหนีบผมลอนใหญ่ไอออนลบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S53bcddf6531649a59c842fed6274c69ar.jpg_200x200q90.jpg",
        "price": 1582.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5927787392.html",
        "sold": 34
    },
    {
        "product_name": "SANXUN | เครื่องทำชาอัตโนมัติแก้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbacf8595d38541fdbc34d37f39c773a7a.png_200x200q90.png",
        "price": 1574.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5909675417.html",
        "sold": 0
    },
    {
        "product_name": "LANWAN | เครื่องบดละเอียดสำหรับข้าวสาลีพริกและธัญพืช",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scfe9865c41ea40ab9532f0b988c4c3f4I.jpg_200x200q90.jpg",
        "price": 1554.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16046829948.html",
        "sold": 0
    },
    {
        "product_name": "Oral-B | แปรงสีฟันไฟฟ้าหัวกลมสำหรับผู้ใหญ่ ความสว่างชัดเจน   D12",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S99520c5d9a0e4b65b7ec2bdb75f2c1505.jpg_200x200q90.jpg",
        "price": 1550,
        "remark": "https://www.lazada.co.th/products/pdp-i16065506081.html",
        "sold": 49
    },
    {
        "product_name": "YOUYOUBABEI | กาชงชาหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb905af8cc96c48c89cce83c4f7cb8784u.jpg_200x200q90.jpg",
        "price": 1546,
        "remark": "https://www.lazada.co.th/products/pdp-i6006165721.html",
        "sold": 2
    },
    {
        "product_name": "กาต้มน้ำไฟฟ้าความจุใหญ่ ฉนวนกันความร้อน ปิดอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se9e547328dc5465c9e35b225261187d2x.jpg_200x200q90.jpg",
        "price": 1478.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6022316308.html",
        "sold": 5
    },
    {
        "product_name": "iicobear | กาต้มน้ำไฟฟ้ารักษาอุณหภูมิคงที่ Thermos",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seebc98ca6180422cb95e4bb7a2aabe48d.png_200x200q90.png",
        "price": 1449.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6007729263.html",
        "sold": 4
    },
    {
        "product_name": "iicobear | กาต้มน้ำไฟฟ้าควบคุมอุณหภูมิอัจฉริยะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2b2ad5ab85cd4d75995e0e4c32ec3ddb9.png_200x200q90.png",
        "price": 1447.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5952005860.html",
        "sold": 17
    },
    {
        "product_name": "JIEXG | กาต้มน้ำไฟฟ้าพกพาควบคุมอุณหภูมิคงที่",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S99a1668814734bd8b6a71af84cd8cff5t.png_200x200q90.png",
        "price": 1430,
        "remark": "https://www.lazada.co.th/products/pdp-i6019125408.html",
        "sold": 35
    },
    {
        "product_name": "เครื่องตีไข่มือถือ Pengocok Telur Listrik เครื่องผสมอาหารมือถือแบบไฟฟ้า Hawne",
        "product_image": "https://img.lazcdn.com/g/p/6d9987dec53d3c4d4a3a75e1a849c855.jpg_200x200q90.jpg",
        "price": 1410,
        "remark": "https://www.lazada.co.th/products/pdp-i16105696416.html",
        "sold": 0
    },
    {
        "product_name": "Archicook | กาต้มน้ำสแตนเลสปิดอัตโนมัติพร้อมฉนวนกันความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb5fff9f2fdaf49e6b4427a47233edf19R.jpg_200x200q90.jpg",
        "price": 1402.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5996843360.html",
        "sold": 12
    },
    {
        "product_name": "TMSU | ของขวัญวันเกิดเด็ก แปรงสีฟันไฟฟ้าสำหรับเด็กหญิงอายุ 10 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5e564d76394b4a3cac17567133f38159v.jpg_200x200q90.jpg",
        "price": 1388.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5948786732.html",
        "sold": 8
    },
    {
        "product_name": "HUALUOLAN | กาต้มน้ำอัตโนมัติพร้อมเทอร์โมสแตท 316 สเตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3816dd71293e44e9933aa4d4463ab75fQ.jpg_200x200q90.jpg",
        "price": 1367.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16060496069.html",
        "sold": 0
    },
    {
        "product_name": "TH Beauty Salon  แปรงสีฟันไฟฟ้า Oral B รุ่น Vitality Precision clean COD",
        "product_image": "https://img.lazcdn.com/g/p/48c8b4608b696bcaf4253f8f0b48bbdd.jpg_200x200q90.jpg",
        "price": 1316,
        "remark": "https://www.lazada.co.th/products/pdp-i16087488629.html",
        "sold": 1
    },
    {
        "product_name": "Oral-B แปรงสีฟันไฟฟ้า Vitality Precision Clean",
        "product_image": "https://img.lazcdn.com/g/p/1501ac10d80c35de25cf69c11086bd44.jpg_200x200q90.jpg",
        "price": 1316,
        "remark": "https://www.lazada.co.th/products/pdp-i5891835227.html",
        "sold": 1
    },
    {
        "product_name": "แปรงสีฟันไฟฟ้า Oral B รุ่น Vitality Precision clean",
        "product_image": "https://img.lazcdn.com/g/p/a3e9a13168a990c945ef1cb513c7dda7.jpg_200x200q90.jpg",
        "price": 1316,
        "remark": "https://www.lazada.co.th/products/pdp-i5891848045.html",
        "sold": 0
    },
    {
        "product_name": "JIFANPAUL | กาต้มน้ำไฟฟ้าพกพาหลายฟังก์ชันพร้อมควบคุมอุณหภูมิ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se2b4b342722c458cab63dad7195cc566I.jpg_200x200q90.jpg",
        "price": 1312.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5955192507.html",
        "sold": 8
    },
    {
        "product_name": "KUB | แปรงสีฟันไฟฟ้าสำหรับเด็กขนนุ่มอัตโนมัติ ผสมฟลูออไรด์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1b55eb39da544d1485a08b4ed85bf4379.jpg_200x200q90.jpg",
        "price": 1290,
        "remark": "https://www.lazada.co.th/products/pdp-i6005977060.html",
        "sold": 0
    },
    {
        "product_name": "BIAOTU | เครื่องพ่นไอน้ำอโรม่าแบบพกพา ความจุใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6b0089847b7a410f86bdee5e18dd66d9s.png_200x200q90.png",
        "price": 1270,
        "remark": "https://www.lazada.co.th/products/pdp-i6029722115.html",
        "sold": 1
    },
    {
        "product_name": "กลองชุดไฟฟ้า Roland VAD716 V-Drums Acoustic Design * กรุณาสอบถามก่อนสั่งซื้อ *",
        "product_image": "https://img.lazcdn.com/g/p/757f308cfccff0869f7b412a594e70de.png_200x200q90.png",
        "price": 800000,
        "remark": "https://www.lazada.co.th/products/pdp-i5548374833.html",
        "sold": 0
    },
    {
        "product_name": "TAYLOR 814CE BUILDER'S EDITION LTD SINKER REDWOOD TOP 50TH ANNIVERSARY [FREE CASE]",
        "product_image": "https://img.lazcdn.com/g/p/8564ab6adca2d7132d9e8fdd7bc2dc08.jpg_200x200q90.jpg",
        "price": 474400,
        "remark": "https://www.lazada.co.th/products/pdp-i5226244508.html",
        "sold": 0
    },
    {
        "product_name": "Nord Stage 4 เปียโนไฟฟ้า Digital Piano / Nord Stage 4 73 / Nord Stage 4 88 / Nord Stage 4 Compact",
        "product_image": "https://img.lazcdn.com/g/p/306bb1f240d63621c51eb90abd15db3c.jpg_200x200q90.jpg",
        "price": 472500,
        "remark": "https://www.lazada.co.th/products/pdp-i2475807629.html",
        "sold": 2
    },
    {
        "product_name": "Grand Piano : Classic GPX-152 WHP แกรนด์เปียโนสีขาว by Churairat Music",
        "product_image": "https://img.lazcdn.com/g/p/559821b0b6910724b95c3de11bf5a92f.jpg_200x200q90.jpg",
        "price": 456000,
        "remark": "https://www.lazada.co.th/products/pdp-i2279402327.html",
        "sold": 0
    },
    {
        "product_name": "กีตาร์ไฟฟ้า PRS Hollowbody II Piezo Charcoal Burst 10-Top /Case",
        "product_image": "https://img.lazcdn.com/g/p/403e1d729ae089972aaf2f38bc1bf865.png_200x200q90.png",
        "price": 450000,
        "remark": "https://www.lazada.co.th/products/pdp-i5362534835.html",
        "sold": 0
    },
    {
        "product_name": "Martin OMJM John Mayer กีตาร์โปร่ง",
        "product_image": "https://img.lazcdn.com/g/p/b86695eba82a0feee73d9ef357e776d6.jpg_200x200q90.jpg",
        "price": 440000,
        "remark": "https://www.lazada.co.th/products/pdp-i4531937796.html",
        "sold": 0
    },
    {
        "product_name": "Grand Piano : Classic GPX-152 EBP แกรนด์เปียโน สีดำ by Churairat Music",
        "product_image": "https://img.lazcdn.com/g/p/a3e61ba76dc7a783a3624af272f4380b.jpg_200x200q90.jpg",
        "price": 436000,
        "remark": "https://www.lazada.co.th/products/pdp-i2279465062.html",
        "sold": 0
    },
    {
        "product_name": "กีตาร์โปร่ง Martin 000-28EC Eric Clapton Signature",
        "product_image": "https://img.lazcdn.com/g/p/4ba38a3a73d517d69976bf17a97c2863.jpg_200x200q90.jpg",
        "price": 430000,
        "remark": "https://www.lazada.co.th/products/pdp-i5109712405.html",
        "sold": 0
    },
    {
        "product_name": "Taylor 814CE V-Class ( with Hardcase ) กีตาร์โปร่งไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/4ce81aa381644379cdac38e2c845936f.jpg_200x200q90.jpg",
        "price": 410000,
        "remark": "https://www.lazada.co.th/products/pdp-i3906672156.html",
        "sold": 1
    },
    {
        "product_name": "Roland Fantom Synthesizers Fantom-6 / Fantom-7 / Fantom-8 คีย์บอร์ด 61 76 88 Keys",
        "product_image": "https://img.lazcdn.com/g/p/ce78e2dbd02753bd0eedaf71ab1e8e64.jpg_200x200q90.jpg",
        "price": 320000,
        "remark": "https://www.lazada.co.th/products/pdp-i2925245721.html",
        "sold": 0
    },
    {
        "product_name": "Roland FANTOM EX Synthesizer Keyboard คีย์บอร์ด ซินธิไซเซอร์ FANTOM 6 EX / 7 EX / 8 EX | FAN TOM 6EX / 7EX / 8EX",
        "product_image": "https://img.lazcdn.com/g/p/8a1fcbfd72cd090a8e2615a1191a46cb.jpg_200x200q90.jpg",
        "price": 320000,
        "remark": "https://www.lazada.co.th/products/pdp-i5309402745.html",
        "sold": 0
    },
    {
        "product_name": "Martin OM-28 Acoustic Guitar กีตาร์โปร่ง OM28",
        "product_image": "https://img.lazcdn.com/g/p/3511077439b6069b687271243f2b32bb.jpg_200x200q90.jpg",
        "price": 288000,
        "remark": "https://www.lazada.co.th/products/pdp-i5694838923.html",
        "sold": 0
    },
    {
        "product_name": "Roland TD-27K กลองไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/19584634a1f56e110f1db8ba299b940b.jpg_200x200q90.jpg",
        "price": 210000,
        "remark": "https://www.lazada.co.th/products/pdp-i2210924229.html",
        "sold": 0
    },
    {
        "product_name": "Abasi Emi7 Legion Stealth กีตาร์ไฟฟ้า กีต้าร์",
        "product_image": "https://img.lazcdn.com/g/p/cd142b00fff90b93abb29ae52f01eec0.jpg_200x200q90.jpg",
        "price": 210000,
        "remark": "https://www.lazada.co.th/products/pdp-i5645386932.html",
        "sold": 0
    },
    {
        "product_name": "Abasi Emi6 Legion Stealth กีตาร์ไฟฟ้า กีต้าร์",
        "product_image": "https://img.lazcdn.com/g/p/64e023dc5836a4e515c439d62cdb9c71.jpg_200x200q90.jpg",
        "price": 200000,
        "remark": "https://www.lazada.co.th/products/pdp-i5645472349.html",
        "sold": 0
    },
    {
        "product_name": "ทูบา คอนเสิร์ต คีย์บีแฟลต 4 โรตารีวาล์ว พร้อมอุปกรณ์ครบชุด JY JYTU-E130 Tuba Concert Key Bb 4 Rotary Valves",
        "product_image": "https://img.lazcdn.com/g/p/5d4fdfbcd124efe86e520dff33687e95.jpg_200x200q90.jpg",
        "price": 188000,
        "remark": "https://www.lazada.co.th/products/pdp-i5750934115.html",
        "sold": 0
    },
    {
        "product_name": "Cort KX700 TT Electric Guitar กีตาร์ไฟฟ้า กีต้าร์ คอร์ท KX700TT KX 700 TT KX 700TT",
        "product_image": "https://img.lazcdn.com/g/p/deecb0b77d8a031dcba1b39d09594042.jpg_200x200q90.jpg",
        "price": 178000,
        "remark": "https://www.lazada.co.th/products/pdp-i5356700329.html",
        "sold": 0
    },
    {
        "product_name": "Taylor 214CE SB DLX กีตาร์โปร่งไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/fbd09a0d469f6071f7c7ca96bd5865ad.jpg_200x200q90.jpg",
        "price": 168000,
        "remark": "https://www.lazada.co.th/products/pdp-i2907187966.html",
        "sold": 0
    },
    {
        "product_name": "จักรยาน MERIDA SCULTURA ENDURANCE 4000 2025 สี SILK DARK SILVER (BLACK)",
        "product_image": "https://img.lazcdn.com/g/p/122512981e2e71bf80191a5a48f7aac3.jpg_200x200q90.jpg",
        "price": 165800,
        "remark": "https://www.lazada.co.th/products/pdp-i5274274565.html",
        "sold": 1
    },
    {
        "product_name": "กีตาร์ไฟฟ้า Strandberg Boden Standard NX 6 Plini Edition Mirage | กีตาร์ไฟฟ้าหัวตัด",
        "product_image": "https://img.lazcdn.com/g/p/577bcbfe5ca8eeddbc50b092576bae7c.jpg_200x200q90.jpg",
        "price": 164000,
        "remark": "https://www.lazada.co.th/products/pdp-i5778167827.html",
        "sold": 0
    },
    {
        "product_name": "บาริโทน แซกโซโฟน คีย์อีแฟลต พร้อมอุปกรณ์ครบชุด EVA JYBS-A600 Key Eb Baritone Saxophone",
        "product_image": "https://img.lazcdn.com/g/p/90f6a08ed8083fc10bf98868a562ef20.jpg_200x200q90.jpg",
        "price": 152000,
        "remark": "https://www.lazada.co.th/products/pdp-i5744862527.html",
        "sold": 0
    },
    {
        "product_name": "TAMA Superstar Hyper-Drive Limited Edition Drum Set กลองชุด HyperDrive",
        "product_image": "https://img.lazcdn.com/g/p/fc1a8ee0d9f79bd2fbb6b1e05624caeb.jpg_200x200q90.jpg",
        "price": 146300,
        "remark": "https://www.lazada.co.th/products/pdp-i5269903796.html",
        "sold": 0
    },
    {
        "product_name": "รับส่วนลดสูงสุด 10,000.- Strandberg Salen Classic NX6 Tremolo สี Black กีต้าร์ไฟฟ้า Strandberg Salen Classic Electric Guitar - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/24f906b391e8c2549bb0f9be5650e355.jpg_200x200q90.jpg",
        "price": 145998,
        "remark": "https://www.lazada.co.th/products/pdp-i5267563265.html",
        "sold": 0
    },
    {
        "product_name": "Sterling by Music Man Sabre กีตาร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/78dfaca3f1c730d9dc9f97b907a2f5d0.jpg_200x200q90.jpg",
        "price": 143000,
        "remark": "https://www.lazada.co.th/products/pdp-i4813190805.html",
        "sold": 0
    },
    {
        "product_name": "คีย์บอร์ด Roland FANTOM 06 Synthesizers Keyboard [ผ่อน 0% 10เดือน]",
        "product_image": "https://img.lazcdn.com/g/p/732d299caecc4cc2b234cc5a697ddd12.png_200x200q90.png",
        "price": 140000,
        "remark": "https://www.lazada.co.th/products/pdp-i5617771555.html",
        "sold": 0
    },
    {
        "product_name": "Roland FANTOM-O Series คีย์บอร์ด Roland Fantom-06 / Fantom-07 / Fantom-08 ซินธิไซเซอร์ Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/1a8a2421e79e30b92a33d046b0908505.jpg_200x200q90.jpg",
        "price": 140000,
        "remark": "https://www.lazada.co.th/products/pdp-i4816326729.html",
        "sold": 0
    },
    {
        "product_name": "กีตาร์ไฟฟ้า Ibanez RG550L-DY(Left Hand) Electric Guitar * กรุณาสอบถามก่อนสั่งซื้อ *",
        "product_image": "https://img.lazcdn.com/g/p/4ec410bd1014898a833a87d7bf58ccf6.png_200x200q90.png",
        "price": 136400,
        "remark": "https://www.lazada.co.th/products/pdp-i5907822139.html",
        "sold": 0
    },
    {
        "product_name": "กีต้าร์ไฟฟ้า MUSIC MAN AXIS Trance Gold",
        "product_image": "https://img.lazcdn.com/g/p/8957d5b31b9d0616b061f6b88ca0089d.png_200x200q90.png",
        "price": 130000,
        "remark": "https://www.lazada.co.th/products/pdp-i16088360812.html",
        "sold": 0
    },
    {
        "product_name": "Ibanez Genesis Collection RG550 ( made in Japan ) กีตาร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/509f30a6fe9b4e4bed10eeb10f24e006.jpg_200x200q90.jpg",
        "price": 125400,
        "remark": "https://www.lazada.co.th/products/pdp-i4790992618.html",
        "sold": 0
    },
    {
        "product_name": "Early Education Instrument Activity House Colorful Design toddler's Introductory Band Set Creative Play Percussion Station Ideal Gift for Preschoolers, Toddlers (3+), Kindergarten, Playground, Daycare Center, Schoolyard",
        "product_image": "https://img.lazcdn.com/g/p/13cd59898bc724f24d7f997c8a46c522.jpg_200x200q90.jpg",
        "price": 124615.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16087742039.html",
        "sold": 0
    },
    {
        "product_name": "Roland JUNO-D8 ซินธิไซเซอร์ Roland JUNO D8 Synthesizers - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/f90de73ee7a6c1a5c0bd6696f502b539.jpg_200x200q90.jpg",
        "price": 113998,
        "remark": "https://www.lazada.co.th/products/pdp-i5750673545.html",
        "sold": 0
    },
    {
        "product_name": "Epiphone 1959 Les Paul Standard กีตาร์ไฟฟ้า กีตาร์",
        "product_image": "https://img.lazcdn.com/g/p/8133858fb9e27d9bdf04ad8e324380e5.jpg_200x200q90.jpg",
        "price": 110000,
        "remark": "https://www.lazada.co.th/products/pdp-i5809641692.html",
        "sold": 0
    },
    {
        "product_name": "Epiphone 1959 Les Paul Standard กีต้าร์ไฟฟ้า Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/6c8c0035892a05479becfa39b7cfe901.jpg_200x200q90.jpg",
        "price": 110000,
        "remark": "https://www.lazada.co.th/products/pdp-i5256811749.html",
        "sold": 0
    },
    {
        "product_name": "เม้าท์ออแกน ฮาร์โมนิก้า 12 ช่อง คีย์ซี Hohner Amadeus , Key C 12 Holes (7544/48C #754401) Performance Series Chromatic Harmonica",
        "product_image": "https://img.lazcdn.com/g/p/e9e1fc9ac386c8b0eb646f743e1b788b.jpg_200x200q90.jpg",
        "price": 110000,
        "remark": "https://www.lazada.co.th/products/pdp-i5907743672.html",
        "sold": 0
    },
    {
        "product_name": "จักรยานเอนปั่น Matrix Recumbent Bike R30XR",
        "product_image": "https://img.lazcdn.com/g/p/4dca42e532ade2d614a7adca69afe7fe.jpg_200x200q90.jpg",
        "price": 109800,
        "remark": "https://www.lazada.co.th/products/pdp-i253179474.html",
        "sold": 2
    },
    {
        "product_name": "Dynasty DFZ Custom Elite Marching Snare Drum กลองสแนร์มาร์ชชิ่ง Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/e8466a5a1b6c1abdfb289451a49bedbb.jpg_200x200q90.jpg",
        "price": 108000,
        "remark": "https://www.lazada.co.th/products/pdp-i5886827113.html",
        "sold": 0
    },
    {
        "product_name": "ทูบา คอนเสิร์ต คีย์บีแฟลต 3 ลูกสูบ พร้อมอุปกรณ์ครบชุด JY JYTU-E120 Tuba Concert Key Bb 3 Piston Valve",
        "product_image": "https://img.lazcdn.com/g/p/292d0e2e163bfd671c8185a37333e16b.jpg_200x200q90.jpg",
        "price": 108000,
        "remark": "https://www.lazada.co.th/products/pdp-i5705120863.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE Studio กีตาร์ไฟฟ้า กีตาร์",
        "product_image": "https://img.lazcdn.com/g/p/fcd19a723e2ee7c6242b33f5e5372913.jpg_200x200q90.jpg",
        "price": 102600,
        "remark": "https://www.lazada.co.th/products/pdp-i5790798042.html",
        "sold": 0
    },
    {
        "product_name": "กีต้าร์ไฟฟ้า Epiphone Japan SHERATON Natural 1991",
        "product_image": "https://img.lazcdn.com/g/p/f3ca3d666f3d919fc97af7817bf8aaf2.jpg_200x200q90.jpg",
        "price": 100000,
        "remark": "https://www.lazada.co.th/products/pdp-i5508625932.html",
        "sold": 0
    },
    {
        "product_name": "⭐Germany Brand⭐ Hohner® Bravo III 80 Chromatic Accordion 80 Bass 37 Key แอคคอร์เดียน หีบเพลงชัก + แถมกระเป๋า",
        "product_image": "https://img.lazcdn.com/g/p/4a6f8176bcbab915a6c567a74d436530.jpg_200x200q90.jpg",
        "price": 99800,
        "remark": "https://www.lazada.co.th/products/pdp-i1656533.html",
        "sold": 2
    },
    {
        "product_name": "Hsienmo D45 Deluxe Acoustic Guitar กีตาร์โปร่ง พร้อมเคส D 45",
        "product_image": "https://img.lazcdn.com/g/p/9739a0d08d77448c71e63d2230f5797a.jpg_200x200q90.jpg",
        "price": 99800,
        "remark": "https://www.lazada.co.th/products/pdp-i5651620424.html",
        "sold": 0
    },
    {
        "product_name": "Paramount JBMT030N Bb Marching Tube มาร์ชชิ่งทูบา คีย์ Bb บอดี้ทองเหลือง เคลือบนิกเกิล  + แถมฟรีเคสแข็ง & ถุงมือ",
        "product_image": "https://img.lazcdn.com/g/p/b9a72d697ab83019a383efc76f8d831e.jpg_200x200q90.jpg",
        "price": 99800,
        "remark": "https://www.lazada.co.th/products/pdp-i5195064992.html",
        "sold": 0
    },
    {
        "product_name": "Cort KX707 EVERTUNE - Open Pore Black Electric Guitar กีตาร์ไฟฟ้า กีตาร์ 7 สาย สี Open Pore Black KX707 Electric Guitar",
        "product_image": "https://img.lazcdn.com/g/p/420322e1e4a11d165b6ccfdb6a18d020.jpg_200x200q90.jpg",
        "price": 99700,
        "remark": "https://www.lazada.co.th/products/pdp-i6008694159.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE Paul’s Guitar กีตาร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/59f0239cca2b246c7efb11c7f4304fe1.jpg_200x200q90.jpg",
        "price": 99000,
        "remark": "https://www.lazada.co.th/products/pdp-i5541357581.html",
        "sold": 0
    },
    {
        "product_name": "Roland JUNO-D7 ซินธิไซเซอร์ Roland JUNO D7 Synthesizers - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/64c1892ae10287d97077197fc31b75c2.jpg_200x200q90.jpg",
        "price": 95998,
        "remark": "https://www.lazada.co.th/products/pdp-i5750673544.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE PRS SE PAUL'S GUITAR-TEAL BLACK/BAG",
        "product_image": "https://img.lazcdn.com/g/p/28351d011c2063ebc81bc0dc9a670ceb.png_200x200q90.png",
        "price": 92400,
        "remark": "https://www.lazada.co.th/products/pdp-i5961661414.html",
        "sold": 0
    },
    {
        "product_name": "คีย์บอร์ด Roland A-88MKII MIDI Keyboard Controller [ผ่อน 0% 10เดือน]",
        "product_image": "https://img.lazcdn.com/g/p/a1fe36d44e846ba30392ae98baa5d418.png_200x200q90.png",
        "price": 92000,
        "remark": "https://www.lazada.co.th/products/pdp-i5690887327.html",
        "sold": 0
    },
    {
        "product_name": "Taylor Academy 10E Acoustic Guitar กีตาร์โปร่งไฟฟ้า Academy10 E Academy10E",
        "product_image": "https://img.lazcdn.com/g/p/62b5e84094b4333fbe4104437b34afcc.jpg_200x200q90.jpg",
        "price": 92000,
        "remark": "https://www.lazada.co.th/products/pdp-i5500811191.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE Custom 24-08 Quilt กีตาร์ไฟฟ้า กีตาร์ กีต้าร์ 2408",
        "product_image": "https://img.lazcdn.com/g/p/9c897e8e591cdcdee866c81ec3be4409.jpg_200x200q90.jpg",
        "price": 91800,
        "remark": "https://www.lazada.co.th/products/pdp-i5595913689.html",
        "sold": 0
    },
    {
        "product_name": "Korg® Kross 2 88 Synthesizer ซินธีไซเซอร์ 88 คีย์ มีเสียงเครื่องดนตรีอีสานในตัว ต่อคอมได้  มีมากกว่า 1,000 เสียงพรีเซ็ต + แถมฟรีอแดปเตอร์ & คู่มือ ** ประกันศูนย์ 1 ปี **",
        "product_image": "https://img.lazcdn.com/g/p/b9185a4bbe2e8ac9c57e2ad10ac7f841.jpg_200x200q90.jpg",
        "price": 90000,
        "remark": "https://www.lazada.co.th/products/pdp-i338278415.html",
        "sold": 0
    },
    {
        "product_name": "กลองชุด Prelude Classic ไม้ Poplar สีดำ กลองชุดใหญ่ CMC Classic  Options 6  ฟรีไม้กลอง CMC 5B 1คู่",
        "product_image": "https://img.lazcdn.com/g/p/bdb626b7292757886ef9bde8b6463cea.jpg_200x200q90.jpg",
        "price": 85800,
        "remark": "https://www.lazada.co.th/products/pdp-i334118242.html",
        "sold": 0
    },
    {
        "product_name": "FONZO V-34C GA Full Body",
        "product_image": "https://img.lazcdn.com/g/p/ff19b5bf4aa0ecad632251f2f779ea46.jpg_200x200q90.jpg",
        "price": 85000,
        "remark": "https://www.lazada.co.th/products/pdp-i4235509741.html",
        "sold": 0
    },
    {
        "product_name": "FONZO V-34C Dreadnought Full Body",
        "product_image": "https://img.lazcdn.com/g/p/09dc9e7ad610bd5ca3dc3f5dda2f80c6.jpg_200x200q90.jpg",
        "price": 85000,
        "remark": "https://www.lazada.co.th/products/pdp-i4235838977.html",
        "sold": 0
    },
    {
        "product_name": "จัดเซ็ท เครื่องดนตรี วงเมโลเดี้ยนระดับประถมศึกษา (กลองสีขาว)  20 คน",
        "product_image": "https://img.lazcdn.com/g/p/1c50aacd32f56592fb6c515cb7fea4d1.jpg_200x200q90.jpg",
        "price": 84600,
        "remark": "https://www.lazada.co.th/products/pdp-i5034742790.html",
        "sold": 0
    },
    {
        "product_name": "Washburn N24-Nuno Electric Guitars กีตาร์ไฟฟ้า กีตาร์",
        "product_image": "https://img.lazcdn.com/g/p/d4c1c3992b233b59a2af419c460d5bf3.jpg_200x200q90.jpg",
        "price": 84000,
        "remark": "https://www.lazada.co.th/products/pdp-i5783327987.html",
        "sold": 0
    },
    {
        "product_name": "Washburn N24-Nuno สี Vintage Matte กีต้าร์ไฟฟ้า Wasburn Electric Guitar - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/0c5dc10b5b0164d614492a18442c42b0.jpg_200x200q90.jpg",
        "price": 83998,
        "remark": "https://www.lazada.co.th/products/pdp-i5787851959.html",
        "sold": 0
    },
    {
        "product_name": "Washburn N24-Nuno สี Vintage Padauk กีต้าร์ไฟฟ้า Washburn Electric Guitar - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/ba6a913d0f92a3de86eb394a21c61379.jpg_200x200q90.jpg",
        "price": 83998,
        "remark": "https://www.lazada.co.th/products/pdp-i5788049096.html",
        "sold": 0
    },
    {
        "product_name": "Trombone (Bass) Custom TTC-67 Rose Brass Bell ทรอมโบน by Churairat Music",
        "product_image": "https://img.lazcdn.com/g/p/fa355b196b130f5f9c9978466129fda1.png_200x200q90.png",
        "price": 81000,
        "remark": "https://www.lazada.co.th/products/pdp-i2441133953.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE SWAMP ASH SPECIAL กีตาร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/72503c5b221fbc9cd3006223d2340542.jpg_200x200q90.jpg",
        "price": 79200,
        "remark": "https://www.lazada.co.th/products/pdp-i5550176261.html",
        "sold": 0
    },
    {
        "product_name": "TAYLOR 114 E LEFT HAND [FREE BAG]",
        "product_image": "https://img.lazcdn.com/g/p/193c43653fb1e6282e5e51e464527926.jpg_200x200q90.jpg",
        "price": 78800,
        "remark": "https://www.lazada.co.th/products/pdp-i5189740986.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE Custom 24-08 สี Vintage Sunburst กีต้าร์ไฟฟ้า PRS Electric Guitar - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/03e5eb2481b598de899190c253f96ba0.jpg_200x200q90.jpg",
        "price": 78398,
        "remark": "https://www.lazada.co.th/products/pdp-i5623560337.html",
        "sold": 0
    },
    {
        "product_name": "TAYLOR GS MINI E SPECIAL EDITION [FREE BAG]",
        "product_image": "https://img.lazcdn.com/g/p/49b0435c289a7344fde425bf6bee6389.png_200x200q90.png",
        "price": 78048,
        "remark": "https://www.lazada.co.th/products/pdp-i5843375671.html",
        "sold": 0
    },
    {
        "product_name": "Roland JUNO-D6 คีย์บอร์ด Digital Keyboard JUNO D6",
        "product_image": "https://img.lazcdn.com/g/p/9da15961b9c2c21df230b20fef300567.jpg_200x200q90.jpg",
        "price": 78000,
        "remark": "https://www.lazada.co.th/products/pdp-i5740729058.html",
        "sold": 0
    },
    {
        "product_name": "Roland JUNO-D6 ซินธิไซเซอร์ Roland JUNO D6 Synthesizers - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/753cec4ccf51f561e1a733cde1b888ad.jpg_200x200q90.jpg",
        "price": 77998,
        "remark": "https://www.lazada.co.th/products/pdp-i5750715403.html",
        "sold": 0
    },
    {
        "product_name": "Taylor Academy 10 กีตาร์โปร่ง แถมกระเป๋าฟรี !!",
        "product_image": "https://img.lazcdn.com/g/p/805eebf577dd33f67a9b8c8ac3b7ea52.jpg_200x200q90.jpg",
        "price": 76000,
        "remark": "https://www.lazada.co.th/products/pdp-i4017932192.html",
        "sold": 0
    },
    {
        "product_name": "Roland XPS-30 Synthesizer คีย์บอร์ดซินธีไซเซอร์ขนาด 61คีย์ ที่น้ำหนักเบา พกพาไปใช้งานได้สะดวก (ใส่ถ่านได้) ประกันศูนย์",
        "product_image": "https://img.lazcdn.com/g/p/af3b42a987c9d0e7d3c3906c34daa747.jpg_200x200q90.jpg",
        "price": 76000,
        "remark": "https://www.lazada.co.th/products/pdp-i3496954604.html",
        "sold": 0
    },
    {
        "product_name": "Sterling Kaizen กีต้าร์ไฟฟ้า Sterling Electric Guitar - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/e20db0295477806176469d5769909133.jpg_200x200q90.jpg",
        "price": 74798,
        "remark": "https://www.lazada.co.th/products/pdp-i5969453979.html",
        "sold": 0
    },
    {
        "product_name": "Cort X700 Triality OPBB Fishman with Bag กีตาร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/2a7d85c210e6720c7a7877ff7b958adb.jpg_200x200q90.jpg",
        "price": 74700,
        "remark": "https://www.lazada.co.th/products/pdp-i5055124350.html",
        "sold": 0
    },
    {
        "product_name": "Cort Modern Black with Case Acoustic Guitar กีตาร์โปร่งไฟฟ้า ModernBlack กีตาร์โปร่ง กีตาร์",
        "product_image": "https://img.lazcdn.com/g/p/9aa5bf32624853d84113f57f346e4bbb.jpg_200x200q90.jpg",
        "price": 74700,
        "remark": "https://www.lazada.co.th/products/pdp-i5179460338.html",
        "sold": 2
    },
    {
        "product_name": "กีต้าร์ไฟฟ้า Cort X700 Duality II สี Lava Burst Electric Guitar - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/c6f735cdb0066a43cd77c200c4b05811.jpg_200x200q90.jpg",
        "price": 74698,
        "remark": "https://www.lazada.co.th/products/pdp-i5578228134.html",
        "sold": 0
    },
    {
        "product_name": "Roland XPS-30 คีย์บอร์ด Roland XPS-30 Red",
        "product_image": "https://img.lazcdn.com/g/p/9d9f8f59f533734bcec60e670eb13325.jpg_200x200q90.jpg",
        "price": 74000,
        "remark": "https://www.lazada.co.th/products/pdp-i2208489554.html",
        "sold": 8
    },
    {
        "product_name": "Gretsch® G5422TG Electromatic Hollow Body with Bigsby® กีตาร์ไฟฟ้า 22 เฟรต ทรง Hollow Body Double Cut ฮาร์ดแวร์ทอง",
        "product_image": "https://img.lazcdn.com/g/p/a661373951cf54e10172d4767436bd69.jpg_200x200q90.jpg",
        "price": 73400,
        "remark": "https://www.lazada.co.th/products/pdp-i5772246594.html",
        "sold": 0
    },
    {
        "product_name": "Epiphone® Slash Les Paul Standard กีตาร์ไฟฟ้า ทรง Les Paul ซิกเนเจอร์ Slash บอดี้ไม้ Mahogany ไม้หน้า Flame Maple ปิ๊กอัพ ProBucker + แถมฟรี ฮาร์ดเคสกีตาร์ *ประกันศูนย์ 1 ปี*",
        "product_image": "https://img.lazcdn.com/g/p/3bde2d789b89620e8e343ae0df0b31bc.jpg_200x200q90.jpg",
        "price": 73400,
        "remark": "https://www.lazada.co.th/products/pdp-i2638815488.html",
        "sold": 0
    },
    {
        "product_name": "⭐USA Brand⭐ Gretsch® FSR G5427TG Electromatic Hollow Body Single Cut with Bigsby กีตาร์ไฟฟ้า *Limited Edition*",
        "product_image": "https://img.lazcdn.com/g/p/30c0fe4124294b1f887d2a4bcff76088.jpg_200x200q90.jpg",
        "price": 73200,
        "remark": "https://www.lazada.co.th/products/pdp-i5016151177.html",
        "sold": 0
    },
    {
        "product_name": "Sterling by Music Man Bongo Bass เบสไฟฟ้า Electric Bass",
        "product_image": "https://img.lazcdn.com/g/p/a91fe086e2a2312a89dfb137a28fb7a8.jpg_200x200q90.jpg",
        "price": 72600,
        "remark": "https://www.lazada.co.th/products/pdp-i16064748641.html",
        "sold": 0
    },
    {
        "product_name": "ของแท้ คีย์บอร์ดซินธีไซเซอร์ 61 คีย์ Roland® XPS-30 แซมเสียงดนตรีอีสานได้ ต่อไมค์ได้ | 1,400 เสียง ประกันศูนย์",
        "product_image": "https://img.lazcdn.com/g/p/a55915f905a04ff1de16f8e05f5d4640.jpg_200x200q90.jpg",
        "price": 72000,
        "remark": "https://www.lazada.co.th/products/pdp-i5727557131.html",
        "sold": 0
    },
    {
        "product_name": "Roland คีย์บอร์ด รุ่น XPS-10X ขนาด 61 คีย์ มี USB-C audio/MIDI interface คีย์บอร์ดไฟฟ้า - ประกันศูนย์",
        "product_image": "https://img.lazcdn.com/g/p/0789ff4e71bc927059b2166859e9f1d8.jpg_200x200q90.jpg",
        "price": 71800,
        "remark": "https://www.lazada.co.th/products/pdp-i16110326545.html",
        "sold": 0
    },
    {
        "product_name": "PRS  SE  SILVER SKY [FREE BAG]",
        "product_image": "https://img.lazcdn.com/g/p/7d324725aa5b58b6445dd43208e4d651.png_200x200q90.png",
        "price": 70560,
        "remark": "https://www.lazada.co.th/products/pdp-i5827479968.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE  SILVER SKY  2025  [FREE BAG]",
        "product_image": "https://img.lazcdn.com/g/p/6bb546b7b43e75a6e8390617983e8baa.png_200x200q90.png",
        "price": 70560,
        "remark": "https://www.lazada.co.th/products/pdp-i5860863489.html",
        "sold": 0
    },
    {
        "product_name": "AYERS ASD014P กลองสนแร์มาร์ชชิ่ง 14\" Marching Snare Drum 14\"",
        "product_image": "https://img.lazcdn.com/g/p/594394c54f06bd44bc2ad598f946c0e0.png_200x200q90.png",
        "price": 70000,
        "remark": "https://www.lazada.co.th/products/pdp-i6053374265.html",
        "sold": 0
    },
    {
        "product_name": "Guild D-140 กีตาร์โปร่ง GUILD D140",
        "product_image": "https://img.lazcdn.com/g/p/ea244ddb7426b9d0224651ea837bacf7.jpg_200x200q90.jpg",
        "price": 70000,
        "remark": "https://www.lazada.co.th/products/pdp-i4054765027.html",
        "sold": 0
    },
    {
        "product_name": "FONZO V-301S SJ Full Body",
        "product_image": "https://img.lazcdn.com/g/p/7765fcf30380aacb343ca514409900d5.jpg_200x200q90.jpg",
        "price": 69000,
        "remark": "https://www.lazada.co.th/products/pdp-i4980815930.html",
        "sold": 0
    },
    {
        "product_name": "กลองชุด TAMA CL32RZS-BAB  Superstar Classic (ไม่รวมฮาร์ดแวร์ และฉาบ) * กรุณาสอบถามก่อนสั่งซื้อ *",
        "product_image": "https://img.lazcdn.com/g/p/1c84217428eef3ffe9a7ba977d059ff0.png_200x200q90.png",
        "price": 68400,
        "remark": "https://www.lazada.co.th/products/pdp-i5904662794.html",
        "sold": 0
    },
    {
        "product_name": "กลองสแนร์ TAMA Starphonic PBC146 14\"x 6\" Bubinga [ผ่อน 0% 10เดือน]",
        "product_image": "https://img.lazcdn.com/g/p/9b200a8579ea845d27faf76ef717a9ca.png_200x200q90.png",
        "price": 68200,
        "remark": "https://www.lazada.co.th/products/pdp-i5600280062.html",
        "sold": 0
    },
    {
        "product_name": "แอคคอเดียน แอคคอร์เดี้ยน 120 เบส 41 คีย์ แถมสายสะพายและกระเป๋า Accordion Golden Cup JH2008 120 Bass 41 Key 5 Registers",
        "product_image": "https://img.lazcdn.com/g/p/e2b2e67548e780fa37e18ffaf590bc06.jpg_200x200q90.jpg",
        "price": 68000,
        "remark": "https://www.lazada.co.th/products/pdp-i5949980202.html",
        "sold": 0
    },
    {
        "product_name": "รับส่วนลดสูงสุด 10,000.- กีต้าร์โปร่ง Naga รุ่น Sungha Jung \"Light\" Series - S-60 GAC - Acoustic Guitar Naga S60 GAC ,ฟรีของแถม ,พร้อมSet Up&QC ,ประกันจากศูนย์ ,แท้100% ,ผ่อน0% ,ส่งฟรี เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/80cd5217d35d23eb834816eac375ee3c.jpg_200x200q90.jpg",
        "price": 67998,
        "remark": "https://www.lazada.co.th/products/pdp-i3016080657.html",
        "sold": 0
    },
    {
        "product_name": "Takamine GD90CE-MD กีตาร์โปร่งไฟฟ้า เเถมกระเป๋าฟรี !!!",
        "product_image": "https://img.lazcdn.com/g/p/0c7e8fe620545ca5395f1b20c4d42042.jpg_200x200q90.jpg",
        "price": 66640,
        "remark": "https://www.lazada.co.th/products/pdp-i4494320855.html",
        "sold": 0
    },
    {
        "product_name": "Takamine GD90CE กีตาร์โปร่งไฟฟ้า เเถมกระเป๋าฟรี !!!",
        "product_image": "https://img.lazcdn.com/g/p/151c091a3b1eccc9f3eeeb818577a94e.jpg_200x200q90.jpg",
        "price": 66640,
        "remark": "https://www.lazada.co.th/products/pdp-i3903352425.html",
        "sold": 0
    },
    {
        "product_name": "Takamine GN90CE กีตาร์โปร่งไฟฟ้า / GN90CE-MDNAT / GN90CE-ZCNAT",
        "product_image": "https://img.lazcdn.com/g/p/7efc043d521d4da8c474727447f8878e.jpg_200x200q90.jpg",
        "price": 66640,
        "remark": "https://www.lazada.co.th/products/pdp-i3903415096.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE Swamp Ash CE24 Sandblasted LTD Electric Guitar กีตาร์ไฟฟ้า PRSSE SwampAsh CE 24 Pual Reed Smith",
        "product_image": "https://img.lazcdn.com/g/p/48aaa248d8ed372509db020cbd648e75.jpg_200x200q90.jpg",
        "price": 66600,
        "remark": "https://www.lazada.co.th/products/pdp-i5480211460.html",
        "sold": 1
    },
    {
        "product_name": "กีตาร์ไฟฟ้า PRS SE Silver Sky สี Stone Blue",
        "product_image": "https://img.lazcdn.com/g/p/9859ab8a5746eb3cc8de8ebac867e51e.jpg_200x200q90.jpg",
        "price": 65800,
        "remark": "https://www.lazada.co.th/products/pdp-i5363009533.html",
        "sold": 0
    },
    {
        "product_name": "TAYLOR GS MINI  E  MAH SEB  [FREE BAG]",
        "product_image": "https://img.lazcdn.com/g/p/745916e5d6ac2c082666de09d622a2b7.png_200x200q90.png",
        "price": 65568,
        "remark": "https://www.lazada.co.th/products/pdp-i5843383688.html",
        "sold": 0
    },
    {
        "product_name": "ดับเบิ้ล เฟรนช์ฮอร์น คีย์เอฟ/บีแฟลต มี 4 คีย์ พร้อมอุปกรณ์ครบชุด JINBAO JBFH-601 Double French Horn Key F/Bb , 4 Key",
        "product_image": "https://img.lazcdn.com/g/p/f1c5e70c13d5f95e160051b8debe4d6f.jpg_200x200q90.jpg",
        "price": 65000,
        "remark": "https://www.lazada.co.th/products/pdp-i5671772781.html",
        "sold": 0
    },
    {
        "product_name": "Sire Larry Carlton X6 7 Strings กีตาร์ไฟฟ้า Electric Guitar รับประกันศูนย์ Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/2fb9e6ad03f6abe222c194f4a56c39ad.jpg_200x200q90.jpg",
        "price": 64800,
        "remark": "https://www.lazada.co.th/products/pdp-i5876682056.html",
        "sold": 0
    },
    {
        "product_name": "กีต้าร์ไฟฟ้า PRS SE : SILVER SKY ซิกเนเจอร์ John Mayer",
        "product_image": "https://img.lazcdn.com/g/p/a09a767d1f0c736eadd62de8cd0072fc.jpg_200x200q90.jpg",
        "price": 64700,
        "remark": "https://www.lazada.co.th/products/pdp-i3960149572.html",
        "sold": 0
    },
    {
        "product_name": "กีต้าร์ไฟฟ้า PRS SE Mark Holcomb Holcomb Burst 2017",
        "product_image": "https://img.lazcdn.com/g/p/ab82bf12c9ce5f9a4022f935065ad9f4.png_200x200q90.png",
        "price": 64000,
        "remark": "https://www.lazada.co.th/products/pdp-i16098567408.html",
        "sold": 0
    },
    {
        "product_name": "MEDELI AKX10S คีย์บอร์ด 61คีย์ จัดเต็ม จังหวะไทย หมอลำ ลูกทุ่ง Keyboard 61 Keys ประกันศูนย์ 1 ปี!!",
        "product_image": "https://img.lazcdn.com/g/p/50de8a96624ec95a33ac54b10e17312b.jpg_200x200q90.jpg",
        "price": 64000,
        "remark": "https://www.lazada.co.th/products/pdp-i5747132022.html",
        "sold": 1
    },
    {
        "product_name": "คีย์บอร์ด 61 คีย์ มีจังหวะไทยลูกทุ่งหมอลำ แซมพลิงเสียงเครื่องดนตรี อ.ดาว เล่นออกงานได้ Medeli AKX10S Arranger Keyboard 61 key",
        "product_image": "https://img.lazcdn.com/g/p/e7df3dea6758764a06975711d815fcb9.jpg_200x200q90.jpg",
        "price": 64000,
        "remark": "https://www.lazada.co.th/products/pdp-i5720340505.html",
        "sold": 0
    },
    {
        "product_name": "Sire Larry Carlton S7 FM New Gen กีตาร์ไฟฟ้า Electric Guitar รับประกันศูนย์ Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/726f6346a8f3b06c852d09823c36b8c0.png_200x200q90.png",
        "price": 64000,
        "remark": "https://www.lazada.co.th/products/pdp-i5885516611.html",
        "sold": 1
    },
    {
        "product_name": "Medeli คีย์บอร์ด 61 คีย์ แถมจังหวะลูกทุ่งหมอลำ+เสียงเครื่องดนตรีอีกมากกว่า 1,133 แบบ พร้อมไฟ LED Medeli AKX10S Keyboard",
        "product_image": "https://img.lazcdn.com/g/p/f2fb573e321daa97ffa2406aa17944e8.png_200x200q90.png",
        "price": 64000,
        "remark": "https://www.lazada.co.th/products/pdp-i5974253956.html",
        "sold": 0
    },
    {
        "product_name": "FONZO V-33C Full Body",
        "product_image": "https://img.lazcdn.com/g/p/18a450bd23a9151828bf165a13b448af.jpg_200x200q90.jpg",
        "price": 63800,
        "remark": "https://www.lazada.co.th/products/pdp-i3169436447.html",
        "sold": 0
    },
    {
        "product_name": "Roland FP-30X สี White เปียโนไฟฟ้า Roland FP30X , FP 30X Electric Piano - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/d789b3b7f49040367b6d6e7a14946b9b.jpg_200x200q90.jpg",
        "price": 62998,
        "remark": "https://www.lazada.co.th/products/pdp-i5608534975.html",
        "sold": 0
    },
    {
        "product_name": "ลำโพงมอนิเตอร์ Focal Alpha 50 EVO ( Pair )",
        "product_image": "https://img.lazcdn.com/g/p/19e2883da082ca20c71def916b8b3bcf.jpg_200x200q90.jpg",
        "price": 62160,
        "remark": "https://www.lazada.co.th/products/pdp-i2729144692.html",
        "sold": 4
    },
    {
        "product_name": "Epiphone Les Paul Modern Figured กีตาร์ไฟฟ้า กีตาร์",
        "product_image": "https://img.lazcdn.com/g/p/2bdb3f1570055b27c0dde8084fa35699.jpg_200x200q90.jpg",
        "price": 61600,
        "remark": "https://www.lazada.co.th/products/pdp-i5797767044.html",
        "sold": 0
    },
    {
        "product_name": "Takamine GN75CE กีตาร์โปร่งไฟฟ้า แถมกระเป๋าฟรี !!",
        "product_image": "https://img.lazcdn.com/g/p/79cd68add97aa5935b853a0b3da2059c.jpg_200x200q90.jpg",
        "price": 61320,
        "remark": "https://www.lazada.co.th/products/pdp-i4181959344.html",
        "sold": 0
    },
    {
        "product_name": "Sire Larry Carlton Q7 กีตาร์ไฟฟ้า Electric Guitar รับประกันศูนย์ Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/b2383cc6cd80a5fd7c6a8b3c15e0e601.jpg_200x200q90.jpg",
        "price": 60400,
        "remark": "https://www.lazada.co.th/products/pdp-i5885590200.html",
        "sold": 0
    },
    {
        "product_name": "กีต้าร์ไฟฟ้า PRS SE McCarty 594 Single Cut 2023",
        "product_image": "https://img.lazcdn.com/g/p/c9b35e33129ccbdec3364e6b15c56639.png_200x200q90.png",
        "price": 60000,
        "remark": "https://www.lazada.co.th/products/pdp-i16115637956.html",
        "sold": 0
    },
    {
        "product_name": "Golden Cup® JH2008 120 Bass 41 Key Accordion แอคคอเดียน แอคคอร์เดี้ยน 120 เบส 41 คีย์ แบบ Chromatic",
        "product_image": "https://img.lazcdn.com/g/p/ea60028c9b85d485d3f67ec37c70f2b3.jpg_200x200q90.jpg",
        "price": 59800,
        "remark": "https://www.lazada.co.th/products/pdp-i5181205529.html",
        "sold": 0
    },
    {
        "product_name": "⭐USA Brand⭐ Gretsch® G5230T Electromatic Jet FT Single-Cut with Bigsby กีตาร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/76fd37f86de2e46934ca2be036538ecc.jpg_200x200q90.jpg",
        "price": 59800,
        "remark": "https://www.lazada.co.th/products/pdp-i16060665100.html",
        "sold": 0
    },
    {
        "product_name": "Lava ME 3 , LAVA ME 4 , ME PLAY กีต้าร์โปร่งไฟฟ้า Electric Acoustic Guitar Lava Me3 , Lava Me4 เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/3a2c1749e0b8cc0fc49153c9b4b2a781.jpg_200x200q90.jpg",
        "price": 59798,
        "remark": "https://www.lazada.co.th/products/pdp-i4981611140.html",
        "sold": 1
    },
    {
        "product_name": "Alvarez AF70e Acoustic Guitar กีตาร์โปร่งไฟฟ้า AF 70 e",
        "product_image": "https://img.lazcdn.com/g/p/903ad80d6f379cf705f4e67080a077e1.jpg_200x200q90.jpg",
        "price": 59600,
        "remark": "https://www.lazada.co.th/products/pdp-i5499285404.html",
        "sold": 0
    },
    {
        "product_name": "TAYLOR GS MINI E MAH ES B [FREE BAG]",
        "product_image": "https://img.lazcdn.com/g/p/0fced72bc2495a2f0b756f0c564e997d.png_200x200q90.png",
        "price": 59328,
        "remark": "https://www.lazada.co.th/products/pdp-i5843457146.html",
        "sold": 0
    },
    {
        "product_name": "Casio PX-S1100 เปียโนไฟฟ้า PXS-1100 ส่งด่วน ติดตั้งฟรี มีไฟล์คู่มือภาษาไทย +ประกันศูนย์ 3ปี // Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/d0e388b340e0b8f89800148ea7845147.jpg_200x200q90.jpg",
        "price": 57800,
        "remark": "https://www.lazada.co.th/products/pdp-i316316970.html",
        "sold": 54
    },
    {
        "product_name": "Chillman Era P Series กีต้าร์ไฟฟ้า Chillman Era Electric Guitar - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/0467208dda6fd0ab53e9a1089ad25620.jpg_200x200q90.jpg",
        "price": 57798,
        "remark": "https://www.lazada.co.th/products/pdp-i6013561628.html",
        "sold": 0
    },
    {
        "product_name": "กีตาร์ไฟฟ้า PRS  SE NF3 MAPLE",
        "product_image": "https://img.lazcdn.com/g/p/20ba5b0689418f4334c5256bf23e2270.png_200x200q90.png",
        "price": 57600,
        "remark": "https://www.lazada.co.th/products/pdp-i5827720108.html",
        "sold": 0
    },
    {
        "product_name": "เปียโนไฟฟ้า KORG LP-380U",
        "product_image": "https://img.lazcdn.com/g/p/bdb159a2877c3f0b805729dfd72aabb9.jpg_200x200q90.jpg",
        "price": 57600,
        "remark": "https://www.lazada.co.th/products/pdp-i4828265020.html",
        "sold": 0
    },
    {
        "product_name": "Sterling John Petrucci JP70 Mystic Dream กีต้าร์ไฟฟ้า Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/fdcd724045ad37eb2647ba28ad0ced32.jpg_200x200q90.jpg",
        "price": 57200,
        "remark": "https://www.lazada.co.th/products/pdp-i5282727886.html",
        "sold": 0
    },
    {
        "product_name": "ลำโพงมอนิเตอร์ Genelec 8030C ( Pair ) Studio Monitor Genelec 8030",
        "product_image": "https://img.lazcdn.com/g/p/60ea8e5be1592e59125c22de3d2cc76c.jpg_200x200q90.jpg",
        "price": 57000,
        "remark": "https://www.lazada.co.th/products/pdp-i2339771585.html",
        "sold": 2
    },
    {
        "product_name": "ลำโพงมอนิเตอร์ Genelec 8030CP Studio Monitor Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/78d9321871093f82498e0f960261d724.jpg_200x200q90.jpg",
        "price": 57000,
        "remark": "https://www.lazada.co.th/products/pdp-i4288242801.html",
        "sold": 2
    },
    {
        "product_name": "กีตาร์โปร่ง Hsienmo Spring Dreadnought",
        "product_image": "https://img.lazcdn.com/g/p/9d622df7818357d8cbf89d97b25ca956.jpg_200x200q90.jpg",
        "price": 57000,
        "remark": "https://www.lazada.co.th/products/pdp-i5802378121.html",
        "sold": 0
    },
    {
        "product_name": "Ibanez RG470PB กีตาร์ไฟฟ้า กีตาร์ electric guitar",
        "product_image": "https://img.lazcdn.com/g/p/2615b15366e7ddc268c165885179f29b.jpg_200x200q90.jpg",
        "price": 56760,
        "remark": "https://www.lazada.co.th/products/pdp-i5829092016.html",
        "sold": 0
    },
    {
        "product_name": "Ibanez RG8EX Electric Guitar กีตาร์ไฟฟ้า RG 8 EX RG8 8EX กีตาร์ กีต้าร์ กีต้าร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/3bc7878bc10cd0c92c20b8379cadadd5.jpg_200x200q90.jpg",
        "price": 56760,
        "remark": "https://www.lazada.co.th/products/pdp-i5086968066.html",
        "sold": 0
    },
    {
        "product_name": "Roland FP-30X เปียโน88 คีย์ น้ำหนักคีย์เหมือนเปียโนไม้ มาพร้อมเสียงเปียโนระบบ SuperNatural เพิ่มเสียงดนตรีอีกมากมาย",
        "product_image": "https://img.lazcdn.com/g/p/3fe6d362fc73c6e864137fb08e00724c.jpg_200x200q90.jpg",
        "price": 56700,
        "remark": "https://www.lazada.co.th/products/pdp-i2935624088.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องตัดมิเนียมตัวเตี้ย 12 นิ้ว STM-02 (ไม่รวมใบตัด)",
        "product_image": "https://img.lazcdn.com/g/p/039aa47348bc8c9be3fd88fa7956dad8.jpg_200x200q90.jpg",
        "price": 56600,
        "remark": "https://www.lazada.co.th/products/pdp-i4335462220.html",
        "sold": 0
    },
    {
        "product_name": "🇹🇭 Overtone Alto Saxophone รุ่น OSA-501 EX พร้อมส่งในไทย รับประกันศูนย์ไทย 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/1ee555eb69e44f4997f0cac986bdb773.jpg_200x200q90.jpg",
        "price": 56160,
        "remark": "https://www.lazada.co.th/products/pdp-i5662087150.html",
        "sold": 0
    },
    {
        "product_name": "Ibanez RG470AHM Electric Guitar กีตาร์ไฟฟ้า RG 470 AHM RG470 470AHM กีตาร์ กีต้าร์ กีต้าร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/2e77236054be52d623a477aa4835bd1f.jpg_200x200q90.jpg",
        "price": 56100,
        "remark": "https://www.lazada.co.th/products/pdp-i5086944059.html",
        "sold": 0
    },
    {
        "product_name": "Takamine GN93CE GD93CE กีตาร์โปร่งไฟฟ้า แถมกระเป๋าฟรี !!",
        "product_image": "https://img.lazcdn.com/g/p/4250ffedbc7d83841b44bfd8607681e9.jpg_200x200q90.jpg",
        "price": 56000,
        "remark": "https://www.lazada.co.th/products/pdp-i4040340655.html",
        "sold": 2
    },
    {
        "product_name": "กลองสแนร์มาร์ชชิ่ง 14 นิ้ว 12 หลัก Symphony Marching Snare Drum JBMPZ-1412 แถมชุดอาร์มสะพาย , ไม้ตีกลอง , กุญแจกลอง",
        "product_image": "https://img.lazcdn.com/g/p/deb539df28023d61e6ec96e5ea3f4137.jpg_200x200q90.jpg",
        "price": 56000,
        "remark": "https://www.lazada.co.th/products/pdp-i3434625845.html",
        "sold": 0
    },
    {
        "product_name": "เม้าท์ออแกน ฮาร์โมนิก้า 14 ช่อง คีย์ซี Hohner Chromatic Meisterklasse 7565/56C Key C 14 Holes , Performance Series Chromatic Harmonica",
        "product_image": "https://img.lazcdn.com/g/p/41c05ba5144cace75eaacae4e3fe1bd7.jpg_200x200q90.jpg",
        "price": 55800,
        "remark": "https://www.lazada.co.th/products/pdp-i5921431741.html",
        "sold": 0
    },
    {
        "product_name": "Sire Larry Carlton S7 New Gen กีตาร์ไฟฟ้า Electric Guitar รับประกันศูนย์ Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/703e25a7fbaace140b2d87e45f80b902.jpg_200x200q90.jpg",
        "price": 55400,
        "remark": "https://www.lazada.co.th/products/pdp-i5866035577.html",
        "sold": 0
    },
    {
        "product_name": "Roland รุ่น FP-30X เปียโนไฟฟ้า 88 คีย์ เชื่อมต่อบลูทูธได้ ฟังก์ชั่นมากมาย แบรนด์ญี่ปุ่น ประกันศูนย์ 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/3f62eaf26635557fb4b898bdae5aa209.jpg_200x200q90.jpg",
        "price": 55000,
        "remark": "https://www.lazada.co.th/products/pdp-i3925202574.html",
        "sold": 4
    },
    {
        "product_name": "Sterling by Music Man JP60",
        "product_image": "https://img.lazcdn.com/g/p/255f45a58757ac6bfdb74cbe294c36f6.jpg_200x200q90.jpg",
        "price": 55000,
        "remark": "https://www.lazada.co.th/products/pdp-i2346735828.html",
        "sold": 2
    },
    {
        "product_name": "กีตาร์ไฟฟ้า Cort KX508 Multi Scale II | กีตาร์ไฟฟ้า 8 สาย Fishman Fluence Open Core 12 โทนเสียง",
        "product_image": "https://img.lazcdn.com/g/p/181e4ba33d247e8696811fa160f60fea.jpg_200x200q90.jpg",
        "price": 54700,
        "remark": "https://www.lazada.co.th/products/pdp-i5976279654.html",
        "sold": 0
    },
    {
        "product_name": "Sire Marcus Miller P6 4 Strings เบส รับประกันศูนย์ Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/87c050bd5493e6b749abfe4c1f4f65b9.jpg_200x200q90.jpg",
        "price": 53200,
        "remark": "https://www.lazada.co.th/products/pdp-i5891266129.html",
        "sold": 0
    },
    {
        "product_name": "กลองไฟฟ้า NUX DM7x (แถมฟรีหูฟัง+เก้าอี้)",
        "product_image": "https://img.lazcdn.com/g/p/d52f1dbfdc400b07a5427fbaaa60f940.jpg_200x200q90.jpg",
        "price": 53100,
        "remark": "https://www.lazada.co.th/products/pdp-i4831116504.html",
        "sold": 0
    },
    {
        "product_name": "Korg Kross 2 61 Synthesizer คีย์บอร์ด 61 คีย์ อัพเดทแซมป์เครื่องดนตรีไทยแล้ว ฟรีไฟล์คู่มือภาษาไทย Kross2 +รับประกันศูนย์ 1ปี Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/5e795bece9c6f829fa0569d64881f688.jpg_200x200q90.jpg",
        "price": 52800,
        "remark": "https://www.lazada.co.th/products/pdp-i126448117.html",
        "sold": 9
    },
    {
        "product_name": "Korg Kross 2 61 คีย์บอร์ด อัพเดทแซมป์เครื่อดนตรีไทยแล้ว Kross2 รับประกันศูนย์",
        "product_image": "https://img.lazcdn.com/g/p/80707a4514d177d3f2be70d04b5486c9.jpg_200x200q90.jpg",
        "price": 52800,
        "remark": "https://www.lazada.co.th/products/pdp-i2207563031.html",
        "sold": 3
    },
    {
        "product_name": "🇹🇭 Overtone Soprano Curve Saxophone รุ่น  OSSC-190EX พร้อมส่งในไทย รับประกันศูนย์ไทย 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/530fd27bd68ccff2a3a2c4bd637ce4af.png_200x200q90.png",
        "price": 52800,
        "remark": "https://www.lazada.co.th/products/pdp-i5780117254.html",
        "sold": 0
    },
    {
        "product_name": "คีย์บอร์ดไฟฟ้า 61 คีย์ KORG Kross 2 61 Keys มาตรฐาน + Preset 1075 แบบ (Synthesizer Workstation) ระบบเสียง EDS-i - รับประกันศูนย์ ส่งจากไทย",
        "product_image": "https://img.lazcdn.com/g/p/b44c0ca7f6165c0b474f7f1167b14c00.jpg_200x200q90.jpg",
        "price": 52800,
        "remark": "https://www.lazada.co.th/products/pdp-i6079174243.html",
        "sold": 0
    },
    {
        "product_name": "Korg Keystage 61 Keys สี Black คีย์บอร์ดใบ้ Korg Keystage Midi Keyboard เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/fcffe7a3ca7c6338a1b962e8c5228a58.jpg_200x200q90.jpg",
        "price": 52798,
        "remark": "https://www.lazada.co.th/products/pdp-i5105287261.html",
        "sold": 0
    },
    {
        "product_name": "Ibanez RG470DX Electric Guitar กีตาร์ไฟฟ้า RG 470 DX RG470 470DX กีต้าร์ กีตาร์ กีต้าร์ไฟฟ้า ElectricGuitar",
        "product_image": "https://img.lazcdn.com/g/p/56b3e06ecbb6fa0bcdd0e56ece043bf2.jpg_200x200q90.jpg",
        "price": 52360,
        "remark": "https://www.lazada.co.th/products/pdp-i5086492886.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE CE24 STANDARD SATIN กีตาร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/9bdf84e23af597897a5faa3c8c83d68b.jpg_200x200q90.jpg",
        "price": 52200,
        "remark": "https://www.lazada.co.th/products/pdp-i5550040910.html",
        "sold": 0
    },
    {
        "product_name": "Blessing BTR-1287S Trumpet Standard บีแฟลต ทรัมเป็ต",
        "product_image": "https://img.lazcdn.com/g/p/7f4989468310f97bcb094d0a86c6cea7.jpg_200x200q90.jpg",
        "price": 52000,
        "remark": "https://www.lazada.co.th/products/pdp-i6039573934.html",
        "sold": 0
    },
    {
        "product_name": "ดับเบิ้ล เฟรนช์ฮอร์น คีย์เอฟ/บีแฟลต มี 4 คีย์ พร้อมอุปกรณ์ครบชุด JY JYFH-E130 Double French Horn Key F/Bb , 4 Key",
        "product_image": "https://img.lazcdn.com/g/p/d82ca08fb3f8807da54378c715afa4fe.jpg_200x200q90.jpg",
        "price": 52000,
        "remark": "https://www.lazada.co.th/products/pdp-i5679291175.html",
        "sold": 0
    },
    {
        "product_name": "Ibanez RG470DXW Candy Apple กีตาร์ไฟฟ้า RG470DXW",
        "product_image": "https://img.lazcdn.com/g/p/9b8aea121ea5ff25670086c3cfb5d8aa.jpg_200x200q90.jpg",
        "price": 51920,
        "remark": "https://www.lazada.co.th/products/pdp-i5883156738.html",
        "sold": 0
    },
    {
        "product_name": "Ibanez RG450DXB กีตาร์ไฟฟ้า Electric Guitar รับประกันวงจร 1 ปี AssawaMusic อัศวมิวสิค",
        "product_image": "https://img.lazcdn.com/g/p/e3f25c384c3f3c27a1591026d36f22a7.jpg_200x200q90.jpg",
        "price": 51920,
        "remark": "https://www.lazada.co.th/products/pdp-i16108462082.html",
        "sold": 0
    },
    {
        "product_name": "กีตาร์โปร่งไฟฟ้า [แถมกระเป๋า] CRAFTER MIND W PRESTIGE ROSE-GCE VVS/BAG",
        "product_image": "https://img.lazcdn.com/g/p/c4eabba1853c2b408cf6f1d5eb0613b2.jpg_200x200q90.jpg",
        "price": 51840,
        "remark": "https://www.lazada.co.th/products/pdp-i4101916128.html",
        "sold": 7
    },
    {
        "product_name": "กีตาร์โปร่งไฟฟ้า (แถมกระเป๋า) CRAFTER STG G-27CE",
        "product_image": "https://img.lazcdn.com/g/p/f6f1dd42cbc0bdb1cb33e780770844d8.jpg_200x200q90.jpg",
        "price": 51840,
        "remark": "https://www.lazada.co.th/products/pdp-i4416364865.html",
        "sold": 0
    },
    {
        "product_name": "กีตาร์โปร่งไฟฟ้า CRAFTER STG J-27CE [FREE BAG]",
        "product_image": "https://img.lazcdn.com/g/p/17c9d1e5962e5e3036a4b6e6dbf5e7b7.jpg_200x200q90.jpg",
        "price": 51840,
        "remark": "https://www.lazada.co.th/products/pdp-i4101917183.html",
        "sold": 1
    },
    {
        "product_name": "Tyma Star Sea All Solid กีตาร์โปร่ง ทรง GA กีต้าร์โปร่ง ไม้แท้ทั้งตัว ระดับพรีเมียม",
        "product_image": "https://img.lazcdn.com/g/p/e0370e87e5cd7362b6c3778420a01684.jpg_200x200q90.jpg",
        "price": 51800,
        "remark": "https://www.lazada.co.th/products/pdp-i16046067741.html",
        "sold": 0
    },
    {
        "product_name": "Guild OM-240E กีตาร์โปร่ง Guild OM 240E",
        "product_image": "https://img.lazcdn.com/g/p/7d4b7f8e3984b6a045e7e4ecae657841.jpg_200x200q90.jpg",
        "price": 51800,
        "remark": "https://www.lazada.co.th/products/pdp-i3134648841.html",
        "sold": 0
    },
    {
        "product_name": "Nux DM-310H กลองไฟฟ้า Nux DM310H Electric Drum - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/6db50466dac6ff923031ce5e2ab5e993.jpg_200x200q90.jpg",
        "price": 51698,
        "remark": "https://www.lazada.co.th/products/pdp-i6044484092.html",
        "sold": 0
    },
    {
        "product_name": "พิณไฟฟ้าไม้พยุงทั้งตัว รุ่นมาตฐานดนตรีอีสาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9f6d74b60bfa4272b549a0ded430a500G.jpg_200x200q90.jpg",
        "price": 51000,
        "remark": "https://www.lazada.co.th/products/pdp-i3916559101.html",
        "sold": 0
    },
    {
        "product_name": "กลองชุด Pearl Midtown ชุด 4 ใบ พร้อมฮาร์ดแวร์",
        "product_image": "https://img.lazcdn.com/g/p/3d48ca383c96b728ef9f0d7182b71af2.jpg_200x200q90.jpg",
        "price": 50700,
        "remark": "https://www.lazada.co.th/products/pdp-i5082669106.html",
        "sold": 0
    },
    {
        "product_name": "Takamine GN71CE GD71CE กีตาร์โปร่งไฟฟ้า แถมกระเป๋าฟรี !!",
        "product_image": "https://img.lazcdn.com/g/p/3d1ede1bb75d56acd0c3abd2d092fc7e.jpg_200x200q90.jpg",
        "price": 50640,
        "remark": "https://www.lazada.co.th/products/pdp-i4040380060.html",
        "sold": 4
    },
    {
        "product_name": "Takamine GJ72CE แถมกระเป๋าฟรี!! Acoustic Guitar กีตาร์โปร่งไฟฟ้า กีตาร์โปร่ง กีต้าร์ GJ72 CE GJ-72CE",
        "product_image": "https://img.lazcdn.com/g/p/e1489973c297cf02ec658e5ca559e2bb.jpg_200x200q90.jpg",
        "price": 50640,
        "remark": "https://www.lazada.co.th/products/pdp-i5064894369.html",
        "sold": 1
    },
    {
        "product_name": "กระเดื่องคู่ TAMA Speed Cobra Limited Edition Black Copper HP910LWCB",
        "product_image": "https://img.lazcdn.com/g/p/2172b0d6b65d0d0336783e2f9b9a09d0.png_200x200q90.png",
        "price": 50600,
        "remark": "https://www.lazada.co.th/products/pdp-i111465664.html",
        "sold": 2
    },
    {
        "product_name": "กีต้าร์โปร่ง TYMA TD-28 , TF-28 all solid",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S11e3cd89b02242e19b4debff5658a8089.jpg_200x200q90.jpg",
        "price": 50400,
        "remark": "https://www.lazada.co.th/products/pdp-i5482721566.html",
        "sold": 0
    },
    {
        "product_name": "Tyma Blue Bird All Solid กีตาร์โปร่ง",
        "product_image": "https://img.lazcdn.com/g/p/49121f67cdf2f3c7a6479006c46eb7f5.jpg_200x200q90.jpg",
        "price": 50380,
        "remark": "https://www.lazada.co.th/products/pdp-i16048634214.html",
        "sold": 0
    },
    {
        "product_name": "กีต้าร์ไฟฟ้า Epiphone G-400 Les Paul Custom",
        "product_image": "https://img.lazcdn.com/g/p/920db78d8fa11461ebbbbfafb29f8ec1.png_200x200q90.png",
        "price": 50000,
        "remark": "https://www.lazada.co.th/products/pdp-i5695393395.html",
        "sold": 0
    },
    {
        "product_name": "รับส่วนลดสูงสุด 3,100.- หรือรับส่วนลด 10%, ซินธิไซเซอร์ Roland XPS10 สี Black , Red (XPS-10) ,ฟรีของเเถม ,พร้อมเช็ค QC ,ประกันจากศูนย์ ,แท้100% ,ผ่อน0% ,ส่งฟรี เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/f552ed6374ee7d6ececac7c9d49e24bf.jpg_200x200q90.jpg",
        "price": 50000,
        "remark": "https://www.lazada.co.th/products/pdp-i4156812283.html",
        "sold": 3
    },
    {
        "product_name": "กีตาร์ไฟฟ้า Epiphone Les Paul Modern",
        "product_image": "https://img.lazcdn.com/g/p/b5d8547ff1b6b055821587a52a45c42b.jpg_200x200q90.jpg",
        "price": 50000,
        "remark": "https://www.lazada.co.th/products/pdp-i5372466626.html",
        "sold": 0
    },
    {
        "product_name": "เปียโน ไฟฟ้า ยามาฮ่า CLP-220",
        "product_image": "https://img.lazcdn.com/g/p/926d60fdb4761e067452282ff9ace39d.jpg_200x200q90.jpg",
        "price": 50000,
        "remark": "https://www.lazada.co.th/products/pdp-i5906080268.html",
        "sold": 0
    },
    {
        "product_name": "ห้องน้ำผู้สูงอายุ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se0cdcb4db11b4602a318f30bce244781C.jpg_200x200q90.jpg",
        "price": 70000,
        "remark": "https://www.lazada.co.th/products/pdp-i16105511954.html",
        "sold": 0
    },
    {
        "product_name": "kodillv | ชักโครกอัจฉริยะติดผนัง ไม่มีถังน้ำติดตั้งล่วงหน้า 55 ซม. ระบบไซโฟน",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S2421cd7848914927a0cbcb9c05dcc3dbU.png_200x200q90.png",
        "price": 33273.28,
        "remark": "https://www.lazada.co.th/products/pdp-i6066892437.html",
        "sold": 0
    },
    {
        "product_name": "ZEPPER เครื่องชั่งน้ำหนักระบบดิจิตอล วัดค่า BMI พร้อมที่วัดส่วนสูง รุ่น TCS-250A-RT  250 kg",
        "product_image": "https://img.lazcdn.com/g/p/5b0fe882306edc828176086c355b6254.png_200x200q90.png",
        "price": 23000,
        "remark": "https://www.lazada.co.th/products/pdp-i5143651214.html",
        "sold": 0
    },
    {
        "product_name": "ชุดตู้ห้องน้ำหรูหราแบบนาโน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7fd939fe1e6145bdaf4c2105a471fb4c0.jpg_200x200q90.jpg",
        "price": 18209.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16103414414.html",
        "sold": 0
    },
    {
        "product_name": "ชักโครกติดผนังไม่ต้องใช้ไฟพร้อมถังน้ำติดตั้งไว้แล้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S817c67911b4b46889246ea125bb778a4y.jpg_200x200q90.jpg",
        "price": 18022.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6066615701.html",
        "sold": 0
    },
    {
        "product_name": "SSWW | โถสุขภัณฑ์ติดผนัง พร้อมถังน้ำฝังกำแพงและดีไซน์ลอยไม่ติดพื้น",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S90b84e4df732494f83db24eb6f39bb65r.png_200x200q90.png",
        "price": 14564.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5909665065.html",
        "sold": 7
    },
    {
        "product_name": "ชักโครกติดผนังอัจฉริยะพร้อมการควบคุมด้วยเสียง AI ไม่มีข้อจำกัดแรงดันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S48b268f340fc4737a12e327aed8e995aM.jpg_200x200q90.jpg",
        "price": 12660.54,
        "remark": "https://www.lazada.co.th/products/pdp-i6066572964.html",
        "sold": 0
    },
    {
        "product_name": "kodillv | ชักโครกอัจฉริยะติดผนังพร้อมถังน้ำในตัว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1b671f9375a44834bfe98e6c5fe42edey.jpg_200x200q90.jpg",
        "price": 12277.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6066847481.html",
        "sold": 0
    },
    {
        "product_name": "[ขายร้อนปี 2024] เครื่องถูหลังอัตโนมัติ, แปรงอาบน้ำไฟฟ้าในห้องน้ำของโรงแรม, เครื่องอาบน้ำติดผนัง, อุปกรณ์อาบน้ำของคนขี้เกียจ",
        "product_image": "https://img.lazcdn.com/g/p/b76a623176a35f2689d0e776e579560d.jpg_200x200q90.jpg",
        "price": 9198,
        "remark": "https://www.lazada.co.th/products/pdp-i5301378428.html",
        "sold": 5
    },
    {
        "product_name": "BATH&BATH BT-4048 สุขภัณฑ์ชิ้นเดียว 4.8L COLOSSAL",
        "product_image": "https://img.lazcdn.com/g/p/f95bd4898ded0de492f0bab89c262670.jpg_200x200q90.jpg",
        "price": 9180,
        "remark": "https://www.lazada.co.th/products/pdp-i5792839514.html",
        "sold": 1
    },
    {
        "product_name": "JOMOW|ชักโครกป้องกันน้ำกระเด็นแบบสิฟอนิก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S477d33c01cc44e6a9249b8b3bd89a399N.png_200x200q90.png",
        "price": 9021.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6003266566.html",
        "sold": 0
    },
    {
        "product_name": "JIAWENHUA | ราวจับห้องน้ำพับได้สำหรับผู้สูงอายุพร้อมป้องกันลื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb8237c66e52e4c15aa6b5568d4d4259cV.jpg_200x200q90.jpg",
        "price": 7990.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5910768809.html",
        "sold": 2
    },
    {
        "product_name": "กระจกห้องน้ำทรงกลม LED ป้องกันฝ้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7c9190ae555e4a1d88ddf2b52e8a14ebQ.png_200x200q90.png",
        "price": 7765.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16083400667.html",
        "sold": 0
    },
    {
        "product_name": "กระจกห้องน้ำพร้อมไฟ LED และระบบป้องกันฝ้าที่หน้าจอสัมผัส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0526965ddf2a4fa0941842456eb9febfA.png_200x200q90.png",
        "price": 7446,
        "remark": "https://www.lazada.co.th/products/pdp-i16065454147.html",
        "sold": 0
    },
    {
        "product_name": "CUNGSA | ชักโครกสแตนเลส 304 สำหรับใช้ในเรือนจำและสาธารณะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf26c92c7d281494fabfd64f48ad54ceeO.jpg_200x200q90.jpg",
        "price": 7071.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16110017281.html",
        "sold": 0
    },
    {
        "product_name": "ตู้กระจกห้องน้ำป้องกันฝ้าอัจฉริยะ พร้อมไฟและที่เก็บไดร์เป่าผม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saac1a44a22414af59e70d532da939bb47.jpg_200x200q90.jpg",
        "price": 6936.18,
        "remark": "https://www.lazada.co.th/products/pdp-i16052521216.html",
        "sold": 0
    },
    {
        "product_name": "PAMPAS | ชั้นเก็บของห้องน้ำมุมสำหรับสองชั้น ทำจากทองแดงแท้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb40ed33c4147464ab44dd8193dd0fbb9T.jpg_200x200q90.jpg",
        "price": 6237.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16083503669.html",
        "sold": 1
    },
    {
        "product_name": "WELLO รถเข็นนั่งถ่าย รถเข็นนั่งอาบน้ำ คร่อมชักโครกได้ เบาะนิ่ม นั่งสบาย โครงอลูมิเนียมอย่างดี ไม่เป็นสนิม",
        "product_image": "https://img.lazcdn.com/g/p/e79768101672cf1e18df8f165db37d5a.jpg_200x200q90.jpg",
        "price": 6198,
        "remark": "https://www.lazada.co.th/products/pdp-i1417444913.html",
        "sold": 80
    },
    {
        "product_name": "LUTUMEI | กระจกแต่งหน้าติดผนังไม่ต้องเจาะ ไม่มีไฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9e9d8c4189f0413e8dbb201c76b809aaw.jpg_200x200q90.jpg",
        "price": 5563.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6023039965.html",
        "sold": 8
    },
    {
        "product_name": "Midas ผ้าขนหนู Cotton 100% รุ่น Basic Living ขนาด 27x54 นิ้ว (12 ผืน) นุ่มนวล ผ่อนคลายผิวสัมผัส ส่งฟรี",
        "product_image": "https://img.lazcdn.com/g/p/e47095cd166f540d458d9792bacd4f75.jpg_200x200q90.jpg",
        "price": 5256,
        "remark": "https://www.lazada.co.th/products/pdp-i16088218321.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้นั่งถ่าย เก้าอี้อาบน้ำ รถอาบน้ำคนป่วย อลูมิเนียมอัลลอย วีลแชร์ เดินทางได้ รับน้ำหนักได้ 150กก. เก้าอี้ห้องน้ำชายชรา สุขาเคลื่อนที่ เบาะนุ่มสบาย พับได้ขนาดพกพา Shower Wheelchair",
        "product_image": "https://img.lazcdn.com/g/p/3bf68da358617165be02f412634112c7.jpg_200x200q90.jpg",
        "price": 4998,
        "remark": "https://www.lazada.co.th/products/pdp-i1754118861.html",
        "sold": 470
    },
    {
        "product_name": "Vidalido Shower Tent  เต๊นท์ห้องน้ำ    เต๊นท์ อาบน้ำ เปลี่ยนเสื้อผ้า แบบพกพา ถอดประกอบง่าย สินค้าพร้อมส่งจากไทย",
        "product_image": "https://img.lazcdn.com/g/p/e6b53d6b77ce40d13ba56e88c71dc15c.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i4193519135.html",
        "sold": 0
    },
    {
        "product_name": "ตีนกบฟรีไดฟ์วิ่งรุ่นใหม่สำหรับดำน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa9cfa4a8cd4b452697a90c1ca7d928adt.jpg_200x200q90.jpg",
        "price": 4890.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16083284973.html",
        "sold": 3
    },
    {
        "product_name": "JIAWENHUA | โครงช่วยยืนสำหรับผู้สูงอายุ ไม่ต้องเจาะ ป้องกันลื่น สำหรับห้องน้ำและโซฟา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S15f5350329b64c6282d541d02775bdd1e.jpg_200x200q90.jpg",
        "price": 4701.54,
        "remark": "https://www.lazada.co.th/products/pdp-i5910843266.html",
        "sold": 0
    },
    {
        "product_name": "JIAWENHUA | เก้าอี้นั่งอาบน้ำพับได้พร้อมราวจับคู่กันลื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S75b86e473c224d2f99d9ee97fa7c0551T.jpg_200x200q90.jpg",
        "price": 4646.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5910822826.html",
        "sold": 17
    },
    {
        "product_name": "JIAWENHUA | เก้าอี้นั่งอาบน้ำพับได้สำหรับผู้สูงอายุและสตรีมีครรภ์ พร้อมที่จับกันลื่นและความปลอดภัย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd86b7f209afd4143a6016aa9620b8b44v.jpg_200x200q90.jpg",
        "price": 4639.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5910938317.html",
        "sold": 4
    },
    {
        "product_name": "DONGPENG | ชุดโถส้วมแบบนั่งยองและถังชักโครก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S356766c20dd74618a581ea50e8dbdd86K.jpg_200x200q90.jpg",
        "price": 4613.64,
        "remark": "https://www.lazada.co.th/products/pdp-i5909472589.html",
        "sold": 34
    },
    {
        "product_name": "JIAWENHUA | เก้าอี้สำหรับผู้สูงอายุ ใช้นั่งยอง นั่งอาบน้ำ รองรับน้ำหนักได้เยอะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9ff76890891f4a52a05e9a1eeedbb089w.jpg_200x200q90.jpg",
        "price": 4541.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5910952008.html",
        "sold": 6
    },
    {
        "product_name": "ที่แขวนผ้าเช็ดตัวสไตล์ยุโรปสีทองแดงแบบโบราณ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se33301e5f0834d9c95087c5353a26f25b.jpg_200x200q90.jpg",
        "price": 4537.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16102797496.html",
        "sold": 1
    },
    {
        "product_name": "B&W | ชั้นวางของในห้องน้ำมุมสแตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sac67c2464c1747349ce6ac8e995f84a8T.png_200x200q90.png",
        "price": 4447.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5877760678.html",
        "sold": 6
    },
    {
        "product_name": "[Recycle] ERI Premium ฝารองนั่ง / ฝาชักโครก กึ่งอัตโนมัติไม่ใช้ไฟฟ้า สี MIDNIGHT",
        "product_image": "https://img.lazcdn.com/g/p/8b0b3a6da7c38bff2f4cf3d02422fd67.jpg_200x200q90.jpg",
        "price": 4280,
        "remark": "https://www.lazada.co.th/products/pdp-i5968901978.html",
        "sold": 3
    },
    {
        "product_name": "[Recycle] ERI Premium ฝารองนั่ง / ฝาชักโครก กึ่งอัตโนมัติไม่ใช้ไฟฟ้า สี WARM LIGHT",
        "product_image": "https://img.lazcdn.com/g/p/1d7d813562f4183db98d7063fb3d8180.jpg_200x200q90.jpg",
        "price": 4280,
        "remark": "https://www.lazada.co.th/products/pdp-i5968975369.html",
        "sold": 0
    },
    {
        "product_name": "[Recycle] ERI Premium ฝารองนั่ง / ฝาชักโครก กึ่งอัตโนมัติไม่ใช้ไฟฟ้า สี FRESH WATER",
        "product_image": "https://img.lazcdn.com/g/p/383f3ebff64ff03122a28121b8ad7456.jpg_200x200q90.jpg",
        "price": 4280,
        "remark": "https://www.lazada.co.th/products/pdp-i5969011274.html",
        "sold": 0
    },
    {
        "product_name": "JIAWENHUA | ที่นั่งอาบน้ำติดผนังกันลื่นสำหรับผู้สูงอายุและผู้พิการ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S16751a7bf07040c381c5180fa191386a3.jpg_200x200q90.jpg",
        "price": 4199.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5910864823.html",
        "sold": 100
    },
    {
        "product_name": "JIAWENHUA | ที่นั่งอาบน้ำสำหรับผู้สูงอายุ กันลื่น พร้อมพนักพิงแขน ปรับระดับความสูงได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S37cac406681d4ed38647ec2e0c04443bx.jpg_200x200q90.jpg",
        "price": 4176.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5910807803.html",
        "sold": 1
    },
    {
        "product_name": "SHANNAIER | ตู้กระจกห้องน้ำติดผนังพร้อมไฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5cc716676db4437aa882d20db89877d4E.png_200x200q90.png",
        "price": 4114.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16062490823.html",
        "sold": 0
    },
    {
        "product_name": "ตู้กระจกอลูมิเนียมทรงกลมขอบมน พร้อมไฟ ติดผนัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S540f10055e5641d49e77f9540f2e4335o.jpg_200x200q90.jpg",
        "price": 4039.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16053144865.html",
        "sold": 0
    },
    {
        "product_name": "bubuluck | เก้าอี้ชักโครกพกพาสำหรับผู้ใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9b00b011587e442b9e915f83173ac939d.jpg_200x200q90.jpg",
        "price": 3876.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5952503030.html",
        "sold": 2
    },
    {
        "product_name": "ตู้เก็บของในห้องน้ำกันน้ำแบบติดผนัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc2e9937b50034ec787ebe89d94d0918dS.png_200x200q90.png",
        "price": 3821.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16099399860.html",
        "sold": 0
    },
    {
        "product_name": "ห้องนำ้สำเร็ขรูปเดี่ยว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3bca9e9ca0aa4f448475aa1470e66916c.jpg_200x200q90.jpg",
        "price": 40000,
        "remark": "https://www.lazada.co.th/products/pdp-i16105847017.html",
        "sold": 0
    },
    {
        "product_name": "JUNSHEN | ชั้นวางของสไตล์โบราณสีทองเหลือง 1 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S45e61215ca7a4957a13518c0a1c807e60.jpg_200x200q90.jpg",
        "price": 3729.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6003358258.html",
        "sold": 0
    },
    {
        "product_name": "JIAWENHUA | ราวจับความปลอดภัยสำหรับห้องน้ำผู้สูงอายุ ไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S33643ad826584fde8bc8da267f7adf7bg.jpg_200x200q90.jpg",
        "price": 3389.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5910920526.html",
        "sold": 9
    },
    {
        "product_name": "DANBIYIN | กระจกห้องน้ำแขวนและติดเพดานสำหรับโรงแรมและบีแอนด์บี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S631b4a037f034315a1452bd15572a980F.jpg_200x200q90.jpg",
        "price": 3381.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16060299113.html",
        "sold": 0
    },
    {
        "product_name": "ม่านกั้นอาบน้ำกันน้ำได้ สามารถพับเก็บได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7d167c4e4ca842b19249c0510640fa33Z.jpg_200x200q90.jpg",
        "price": 3174.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16094763376.html",
        "sold": 0
    },
    {
        "product_name": "NAIERDENG | พรมป้องกันลื่นในห้องน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S912f2a9b5019452da741f834b9776ff8c.jpg_200x200q90.jpg",
        "price": 3104,
        "remark": "https://www.lazada.co.th/products/pdp-i6005928406.html",
        "sold": 0
    },
    {
        "product_name": "[ส่งไว] ANKER eufy Smart Scale P2 Pro เครื่องชั่งน้ำหนัก ดัชนีชี้วัดร่างกาย 16 รายการ ฟังก์ชั่นโมเดล 3D พร้อม BMI กันน้ำ IPX5 เชื่อมต่อ Wi-Fi และ บลูทูธ",
        "product_image": "https://img.lazcdn.com/g/p/17db9ac6d7045c4c43924ca30ac90ea2.jpg_200x200q90.jpg",
        "price": 2998,
        "remark": "https://www.lazada.co.th/products/pdp-i5732013254.html",
        "sold": 142
    },
    {
        "product_name": "JIDIDIAO | ผ้าม่านกั้นห้องน้ำแยกแห้งเปียก พร้อมถ้วยดูด เก็บพับได้ ไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se53cf05d0d9d4dafb7472bb462491ca3N.jpg_200x200q90.jpg",
        "price": 2952,
        "remark": "https://www.lazada.co.th/products/pdp-i6005890958.html",
        "sold": 0
    },
    {
        "product_name": "ZHIFAN | ม่านกั้นห้องน้ำกันน้ำ แบบพับได้ ไม่ต้องเจาะรู",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S907cd24808994887b5ffd452b489cdab3.jpg_200x200q90.jpg",
        "price": 2951.84,
        "remark": "https://www.lazada.co.th/products/pdp-i5933167075.html",
        "sold": 40
    },
    {
        "product_name": "JIAWENHUA | เก้าอี้นั่งอาบน้ำพับได้สำหรับผู้สูงอายุในห้องน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S38899434d52c45d8b49c5039a9f8fae9l.jpg_200x200q90.jpg",
        "price": 2948.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5910939216.html",
        "sold": 12
    },
    {
        "product_name": "JIAWENHUA | เก้าอี้ช่วยเหลือการอาบน้ำสำหรับผู้สูงอายุ ที่นั่งในห้องน้ำพับได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa04c369541054d4f8b81679b8e93a1d8j.jpg_200x200q90.jpg",
        "price": 2942.46,
        "remark": "https://www.lazada.co.th/products/pdp-i5910801792.html",
        "sold": 10
    },
    {
        "product_name": "Keluojing | อ่างล้างหน้าขนาดเล็กสี่เหลี่ยมติดผนัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S717eb0e1f002491bb5f5e7ab19b8c7d65.jpg_200x200q90.jpg",
        "price": 2930.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16062472746.html",
        "sold": 0
    },
    {
        "product_name": "JIAWENHUA | ราวจับห้องน้ำสำหรับสตรีตั้งครรภ์และผู้สูงอายุ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf006be4a0a994229bbbc9dd5ee6e7ccdj.jpg_200x200q90.jpg",
        "price": 2919.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5910761941.html",
        "sold": 11
    },
    {
        "product_name": "เก้าอี้นั่งถ่ายเก้าอี้อาบน้ำพิเศษสำหรับผู้สูงอายุ สุขาพับได้ เก้าอี้อาบน้ำในห้องน้ำเก้าอี้กันลื่นเก้าอี้อาบน้ำผู้ป่วยสำหรับสตรีม",
        "product_image": "https://img.lazcdn.com/g/p/13934ae87f38382644f60b55a1143981.jpg_200x200q90.jpg",
        "price": 2906,
        "remark": "https://www.lazada.co.th/products/pdp-i4894632691.html",
        "sold": 12
    },
    {
        "product_name": "DANBIYIN | อ่างล้างหน้าเซรามิคแบบกึ่งฝัง",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S3de8a027488e4560bd345780eb4ede966.jpg_200x200q90.jpg",
        "price": 2857.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16060209476.html",
        "sold": 0
    },
    {
        "product_name": "B&W | ชั้นวางของห้องน้ำมุม 304 สแตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbfb33c55129b4f12b18875793ef9602fS.png_200x200q90.png",
        "price": 2832.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5874290593.html",
        "sold": 170
    },
    {
        "product_name": "XINGQI | ตู้เก็บของในห้องน้ำกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd9cb59912d79400c88e65df2d02946efP.jpg_200x200q90.jpg",
        "price": 2830,
        "remark": "https://www.lazada.co.th/products/pdp-i6026044574.html",
        "sold": 0
    },
    {
        "product_name": "ม่านกั้นอาบน้ำรูปโค้งแม่เหล็ก ไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2e5316bd9f324fb3b508947eb926aa7fy.jpg_200x200q90.jpg",
        "price": 2812.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16089510501.html",
        "sold": 0
    },
    {
        "product_name": "DANBIYIN | ตู้กระจกติดผนังกันความชื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb9cef4bbeed446f09cb38cddf24b35948.jpg_200x200q90.jpg",
        "price": 2805.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16060313260.html",
        "sold": 0
    },
    {
        "product_name": "ผ้าม่านกั้นห้องน้ำพับได้ กันน้ำ ไม่เห็นผ่าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S126d878a6eff421a81970fac6536b197U.jpg_200x200q90.jpg",
        "price": 2792.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16089156970.html",
        "sold": 0
    },
    {
        "product_name": "SEGO เก้าอี้นั่งถ่าย เก้าอี้อาบน้ำ ผู้สูงอายุ พับได้ ปรับความสูงได้ โครงอลูมิเนียมอัลลอยด์  น้ำหนักเบาไม่เป็นสนิม คร่อมชักโครกได้",
        "product_image": "https://img.lazcdn.com/g/p/29b9c784d5f6dca27eb8a0cde9f9a148.png_200x200q90.png",
        "price": 2741,
        "remark": "https://www.lazada.co.th/products/pdp-i10694312.html",
        "sold": 333
    },
    {
        "product_name": "JIAWENHUA | ที่นั่งอาบน้ำพับได้ติดผนังกันลื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa0ed28a2336b45d1a15269da7e6c802dG.jpg_200x200q90.jpg",
        "price": 2722.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5910847443.html",
        "sold": 1
    },
    {
        "product_name": "ที่ลอยน้ำ EVA สำหรับผู้ใหญ่ ทนทาน NBR ลอยตัวสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb64dc3ad683c4da29df764cec01a80c4n.jpg_200x200q90.jpg",
        "price": 2708,
        "remark": "https://www.lazada.co.th/products/pdp-i16050191588.html",
        "sold": 1
    },
    {
        "product_name": "Badu | อ่างล้างหน้าสแตนเลสขนาดเล็กติดผนัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdc7c0072fc8c47aa9d7bf8d24b7f2649E.jpg_200x200q90.jpg",
        "price": 2701.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5929281593.html",
        "sold": 0
    },
    {
        "product_name": "UNHO ชั้นวางของในห้องน้ำ ไม้ไผ่ธรรมชาติคุณภาพสูง Tall Slim Floor Bathroom Storage Cabinet with 3-tier Shelves ห้องน้ํา, ห้องนั่งเล่น, ชั้นวางของในครัว",
        "product_image": "https://img.lazcdn.com/g/p/3f02335acfb46730bb87461cf3b99e9d.png_200x200q90.png",
        "price": 2699.54,
        "remark": "https://www.lazada.co.th/products/pdp-i5171359574.html",
        "sold": 1
    },
    {
        "product_name": "JIAWENHUA | เก้าอี้นั่งอาบน้ำพับได้ป้องกันลื่นสำหรับผู้สูงอายุและสตรีตั้งครรภ์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se1e59ba92b9b437b920fdd23db7533acZ.jpg_200x200q90.jpg",
        "price": 2698.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5910797897.html",
        "sold": 18
    },
    {
        "product_name": "SHANNAIER | อุปกรณ์ตกแต่งห้องน้ำสไตล์สแกนดิเนเวียน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb9307e9f7a5444b38cfb04d46d0fbe43g.jpg_200x200q90.jpg",
        "price": 2669.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16060996159.html",
        "sold": 0
    },
    {
        "product_name": "bubuluck | เก้าอี้ห้องน้ำพกพาติดเตียง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sec39acdf080d491d96e557a2f66ac9dc1.jpg_200x200q90.jpg",
        "price": 2646.46,
        "remark": "https://www.lazada.co.th/products/pdp-i5953954935.html",
        "sold": 5
    },
    {
        "product_name": "ตู้เก็บของติดผนังกันน้ำ ไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S174eec9f54864578907ee12bed1703d5E.jpg_200x200q90.jpg",
        "price": 2616.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16102889524.html",
        "sold": 0
    },
    {
        "product_name": "JIAWENHUA | เก้าอี้นั่งอาบน้ำสำหรับผู้สูงอายุ ป้องกันการลื่นล้ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf853de51bdae43468c6a8930a45266794.jpg_200x200q90.jpg",
        "price": 2596.38,
        "remark": "https://www.lazada.co.th/products/pdp-i5910803734.html",
        "sold": 13
    },
    {
        "product_name": "JIAWENHUA | ราวจับห้องน้ำทรงยูพับได้สำหรับผู้พิการและผู้สูงอายุ สแตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7e0945e36ecf4beebaf253cd96248c2d7.jpg_200x200q90.jpg",
        "price": 2592.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5910849194.html",
        "sold": 0
    },
    {
        "product_name": "ตู้กระจกเก็บของติดผนังสไตล์นอร์ดิก อลูมิเนียมสเปซ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S566201fe113a4c578a59113f373dc97bU.jpg_200x200q90.jpg",
        "price": 2562.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16102851640.html",
        "sold": 0
    },
    {
        "product_name": "Homyl ชั้นวางผ้าขนหนูสำหรับผ้าเช็ดตัวห้องน้ำจัดเก็บสีดำติดผนังแบบโลหะ",
        "product_image": "https://img.lazcdn.com/g/p/c97d9df92683561a90e2f3a84f3ac38d.jpg_200x200q90.jpg",
        "price": 2530,
        "remark": "https://www.lazada.co.th/products/pdp-i6019818661.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA เต็นท์ห้องน้ำกลางแจ้งในห้องน้ำเต้นท์แบบห้องห้องน้ำ Lixar Livre Funien เต็นท์กลางแจ้งห้องพักแบบพกพาห้องเต็นท์ห้องน้ำแบบพกพาเต็นท์กำบังกลางแจ้ง Buzhi Dalynn ห้องสุขาพร้อมถือ Abarich Huioperyue",
        "product_image": "https://img.lazcdn.com/g/p/ef8d8109df47744f24746a9fdf90044b.jpg_200x200q90.jpg",
        "price": 2504,
        "remark": "https://www.lazada.co.th/products/pdp-i5146727465.html",
        "sold": 0
    },
    {
        "product_name": "B&W | ชั้นวางมุมห้องน้ำ สแตนเลส 304",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seca7f10cac7743a7bc194068fb5500cfK.jpg_200x200q90.jpg",
        "price": 2472.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5862473609.html",
        "sold": 12
    },
    {
        "product_name": "ตู้เก็บของแบบตั้งสำหรับเครื่องซักผ้า ชั้นวางของสำหรับห้องน้ำ ชั้นวางของสำหรับกระดานล้างจาน ตู้เก็บของสำหรับบ้านแบบตั้งได้ ชั้นวางของสำหรับท่อระบายน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7a5ed8a2286944c88b3a454909c181ccT.jpg_200x200q90.jpg",
        "price": 2460,
        "remark": "https://www.lazada.co.th/products/pdp-i5996923656.html",
        "sold": 1
    },
    {
        "product_name": "JIAWENHUA | ที่นั่งอาบน้ำแบบพับเก็บได้ติดผนัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdbe21468f58a4a33a8764b6982da0f99Y.jpg_200x200q90.jpg",
        "price": 2455.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5910853982.html",
        "sold": 0
    },
    {
        "product_name": "JIAWENHUA | ราวจับห้องน้ำสำหรับผู้สูงอายุ ปลอดภัย ป้องกันการลื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S38be05a68d7a4061b77460815c9fd5ddV.jpg_200x200q90.jpg",
        "price": 2454.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5910836490.html",
        "sold": 181
    },
    {
        "product_name": "WUBUWEI | ชั้นวางของติดผนังหลายชั้น บางมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa7d0370d070046d282dfee37e3869d6fV.jpg_200x200q90.jpg",
        "price": 2375.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16062245698.html",
        "sold": 0
    },
    {
        "product_name": "JUNSHEN | ชั้นวางของในห้องน้ำสไตล์คลาสสิก ติดตั้งง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S94b3828f97114ef0bdfc20e6cc0338d49.jpg_200x200q90.jpg",
        "price": 2351.5,
        "remark": "https://www.lazada.co.th/products/pdp-i6003454223.html",
        "sold": 0
    },
    {
        "product_name": "ชั้นเก็บของเครื่องซักผ้าแบบเลื่อนวางบนห้องน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sebffce0f2c0643db8f519deba8868a52n.jpg_200x200q90.jpg",
        "price": 2346,
        "remark": "https://www.lazada.co.th/products/pdp-i5996901815.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องกรองน้ำบาดาล น้ำมีหินปูน กระบอกกรองน้ำใช้ 10”เกลียวทองเหลือง ฟรีกรองดักตะกอน ช่วยกรองหินปูน น้ำบ่อ น้ำกระด้าง คราบขาวตามกาะสุขภัณฑ์ คราบขาวพื้นห้องน้ำ ท่อ 6 หุน (3/4\") ไม่ต้องใช้ไฟ ติดตั้งง่าย",
        "product_image": "https://img.lazcdn.com/g/p/c9ef839c0462477bef65a2ab3fffaa16.png_200x200q90.png",
        "price": 2265.74,
        "remark": "https://www.lazada.co.th/products/pdp-i3390447458.html",
        "sold": 19
    },
    {
        "product_name": "Midas ผ้าขนหนู Cotton 100% รุ่น Basic Living ขนาดผ้าเช็ดผม 15x30 นิ้ว (12 ผืน) นุ่มนวล ผ่อนคลายผิวสัมผัส ส่งฟรี",
        "product_image": "https://img.lazcdn.com/g/p/9bf838a3b74b1f6c0d2e03d61ba9ac0d.jpg_200x200q90.jpg",
        "price": 2256,
        "remark": "https://www.lazada.co.th/products/pdp-i16087932595.html",
        "sold": 0
    },
    {
        "product_name": "MULUOZI | ชั้นเก็บของในห้องน้ำแบบหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf670bf5dfed54299bbc271604761cdd8b.png_200x200q90.png",
        "price": 2255.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16099808600.html",
        "sold": 0
    },
    {
        "product_name": "ERMO | ที่แขวนผ้าขนหนูดูดสูญญากาศระดับไฮเอนด์ ไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9ac386a687f14d20a121c2b2807e79022.jpg_200x200q90.jpg",
        "price": 2205.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16103229463.html",
        "sold": 2
    },
    {
        "product_name": "อ่างล้างหน้าพลาสติกขนาดเล็กแบบติดผนังไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S11447dd092a140a3b9ef28f343f6ff84p.jpg_200x200q90.jpg",
        "price": 2141.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16116385113.html",
        "sold": 0
    },
    {
        "product_name": "WATERTIME | แว่นว่ายน้ำกันฝ้า กันน้ำ พร้อมไดออปเตอร์ HD",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S52cd0d198459445aa454778def2b8b77E.jpg_200x200q90.jpg",
        "price": 2136.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5894953484.html",
        "sold": 89
    },
    {
        "product_name": "DANBIYIN | ชั้นเก็บของห้องน้ำหรูหราติดผนัง แผ่นหิน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6de66831826d40adb540c9ffcd2de351e.jpg_200x200q90.jpg",
        "price": 2128.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16060436369.html",
        "sold": 0
    },
    {
        "product_name": "B&W |ชั้นวางของสแตนเลส 304 สำหรับมุมห้องน้ำและข้างโถชักโครก แบบตั้งพื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3ab70cad3f514482b6ef0e86434ee3a0P.jpg_200x200q90.jpg",
        "price": 2127.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5879811626.html",
        "sold": 2
    },
    {
        "product_name": "และผู้ป่วย ใช้งานง่าย แข็งแรงที่สุด โครงอลูมิเนียม แสตนเลส เก้าอี้นั่งถ่าย ส้วมผู้ป่วย ส้วมคนแก่ เก้าอี้ห้องน้ำ ชักโครกพกพา ทนทานทุกสภาพการใช้งาน",
        "product_image": "https://img.lazcdn.com/g/p/9d0a0379c931a5d3d8f932279b4fed5e.jpg_200x200q90.jpg",
        "price": 2098,
        "remark": "https://www.lazada.co.th/products/pdp-i5883629150.html",
        "sold": 0
    },
    {
        "product_name": "สตรีมีครรภ์ และผู้ป่วย ใช้งานง่าย แข็งแรงที่สุด โครงอลูมิเนียม แสตนเลส เก้าอี้นั่งถ่าย ส้วมผู้ป่วย ส้วมคนแก่ เก้าอี้ห้องน้ำ ทนทานทุกสภาพการใช้งาน",
        "product_image": "https://img.lazcdn.com/g/p/479b6f406d8b1f5eeb3b489d9f0dc740.jpg_200x200q90.jpg",
        "price": 2098,
        "remark": "https://www.lazada.co.th/products/pdp-i5883634138.html",
        "sold": 0
    },
    {
        "product_name": "ชั้นวางผ้าขนหนูห้องน้ำไม่ต้องเจาะ อลูมิเนียมสีดำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S54b71c3fce0c4c49b6f13ff8a2359dbcC.jpg_200x200q90.jpg",
        "price": 2071.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16060405853.html",
        "sold": 0
    },
    {
        "product_name": "MLZH | ม่านกั้นห้องหลายฟังก์ชันสำหรับบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S70589b5dce394379ad816885b84d17d9o.jpg_200x200q90.jpg",
        "price": 2064.88,
        "remark": "https://www.lazada.co.th/products/pdp-i6017986175.html",
        "sold": 3
    },
    {
        "product_name": "FANBI | โถปัสสาวะแบบเก้าอี้พกพา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S10de10e3025f4354aefbcebdb6ed5c405.jpg_200x200q90.jpg",
        "price": 2049.98,
        "remark": "https://www.lazada.co.th/products/pdp-i6018005302.html",
        "sold": 7
    },
    {
        "product_name": "กระจกห้องน้ำความละเอียดสูง ติดผนังเต็มความยาว ใช้กาวไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8aa7d79fb28b4907b8026a6ca8e5e040u.jpg_200x200q90.jpg",
        "price": 2043.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16089341169.html",
        "sold": 0
    },
    {
        "product_name": "Digital Bathroom Scale เครื่องชั่งน้ำหนักดิจิตอล มาตรฐาน Digital Body Weight Scale เครื่องชั่งน้ำหนัก ตาชั่งดิจิตอล เครื่องชั่งน้ำหนักดิจิตอล เครื่องชั่งน้ำหนักคน",
        "product_image": "https://img.lazcdn.com/g/p/27c5d605b8ea5dfec8515695981c2e89.png_200x200q90.png",
        "price": 2016.4,
        "remark": "https://www.lazada.co.th/products/pdp-i4306042424.html",
        "sold": 1
    },
    {
        "product_name": "ม่านกั้นอาบน้ำพับได้ กันน้ำ ด้านเดียวอลูมิเนียม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4d96fd45cbec42638804203584c06a4c6.jpg_200x200q90.jpg",
        "price": 2013,
        "remark": "https://www.lazada.co.th/products/pdp-i16119418484.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้นั่งถ่าย แสตนเลส ผู้สูงอายุ สุขาเคลื่อนที่ เก้าอี้ขับถ่าย แบบพับได้ สุขภัณฑ์เคลื่อนที่ ส้วมเคลือนที่ แบบปรับสูงต่ำได้5ระดับ ห้องน้ำคนท้อง 3in1 เก้าอี้อาบน้ำ Toilet Patient",
        "product_image": "https://img.lazcdn.com/g/p/a980aa1a75bbf1d2a3bde9ca7b82af72.jpg_200x200q90.jpg",
        "price": 1998,
        "remark": "https://www.lazada.co.th/products/pdp-i4285876152.html",
        "sold": 1
    },
    {
        "product_name": "พรมเช็ดเท้า พรมห้องน้ำ ใหญ่ พรมเช็ดเท้าหนา พรมเช็ดซับน้ำ 40x60ซม. สีฟ้า (1ผืน) Bath Mat Large Washable Bathroom Floor Mat Blue Color 40x60cm. (1 unit)",
        "product_image": "https://img.lazcdn.com/g/p/0704d5c8b4f1a780dcd13d0ea08d8159.jpg_200x200q90.jpg",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i4591116523.html",
        "sold": 0
    },
    {
        "product_name": "CHUMX | ตู้เก็บของกันน้ำสำหรับห้องน้ำ ครัว และห้องสุขา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sef144910268840e0ac6421319608a4e2c.jpg_200x200q90.jpg",
        "price": 1973.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5910880122.html",
        "sold": 9
    },
    {
        "product_name": "เก้าอี้สุขาแบบพกพาผู้สูงอายุหญิงตั้งครรภ์เก้าอี้อาบน้ำในห้องน้ำ (สีเทา)",
        "product_image": "https://img.lazcdn.com/g/p/f858f891ce8806eb6381efca756a8efa.jpg_200x200q90.jpg",
        "price": 1970,
        "remark": "https://www.lazada.co.th/products/pdp-i6024669181.html",
        "sold": 0
    },
    {
        "product_name": "MMZECE | ตู้เก็บของในห้องน้ำกันน้ำ ไม่ต้องติดตั้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa355d879b5c04c8bb99cda702936a098N.jpg_200x200q90.jpg",
        "price": 1924,
        "remark": "https://www.lazada.co.th/products/pdp-i6026147027.html",
        "sold": 0
    },
    {
        "product_name": "ตู้เก็บของห้องน้ำติดผนังไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd6a6f09107984e41b71b21a6694d2c6b6.jpg_200x200q90.jpg",
        "price": 1898.32,
        "remark": "https://www.lazada.co.th/products/pdp-i16099633605.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้นั่งถ่าย เก้าอี้โถมีล้อห้องน้ำผู้สูงอายุผู้ป่วยทุพพลภาพเก้าอี้เคลื่อนที่เก้าอี้อาบน้ำเก้าอี้โถสุขภัณฑ์ผู้ใหญ่โถอา",
        "product_image": "https://img.lazcdn.com/g/p/a249a77ad0958e1eac939bdf4f5af941.jpg_200x200q90.jpg",
        "price": 1890,
        "remark": "https://www.lazada.co.th/products/pdp-i5903387421.html",
        "sold": 11
    },
    {
        "product_name": "SHENGXUE | เก้าอี้อาบน้ำหมุนไม่ลื่นอลูมิเนียม",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S5d3163411bf847f7859778d99eaa3d6fb.jpg_200x200q90.jpg",
        "price": 1854.84,
        "remark": "https://www.lazada.co.th/products/pdp-i5933214019.html",
        "sold": 6
    },
    {
        "product_name": "เก้าอี้นั่งถ่ายสำหรับผู้สูงอายุ ผู้พิการ และสตรีมีครรภ์ ห้องน้ำเคลื่อนที่ และเก้าอี้อาบน้ำพับได้สำหรับครัวเรือน  เก้าอี้นั่งถ่ายสำหรับผู้พิการ ผู้สูงอายุ และสตรีมีครรภ์ ห้องน้ำเคลื่อนที่ และเก้าอี้นั่งถ่ายแบบพับได้สำหรับครัวเรือนที่เสริมความแข็งแรง",
        "product_image": "https://img.lazcdn.com/g/p/78f3000ced799f543f6ca6421140ea3c.jpg_200x200q90.jpg",
        "price": 1840,
        "remark": "https://www.lazada.co.th/products/pdp-i5851678293.html",
        "sold": 3
    },
    {
        "product_name": "หุ่นยนต์นาฬิกาติดตามคนในห้องน้ำ ของเล่นบล็อกก่อสร้าง รูปเด็กชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S05e99e6273bb43b4b7c0007ac1d058e5u.jpg_200x200q90.jpg",
        "price": 1838,
        "remark": "https://www.lazada.co.th/products/pdp-i16089094992.html",
        "sold": 0
    },
    {
        "product_name": "SHENGXUE | เก้าอี้อาบน้ำกันลื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sddfbfa7226184747b9a7854608f48906v.jpg_200x200q90.jpg",
        "price": 1830.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5932840720.html",
        "sold": 7
    },
    {
        "product_name": "ของเล่นชุดต่อรูปยักษ์ดาราศาสตร์ไททัน ปะทะ คนห้องน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/See424cef158b4da28cd90e737b474c3cR.jpg_200x200q90.jpg",
        "price": 1794,
        "remark": "https://www.lazada.co.th/products/pdp-i16089274432.html",
        "sold": 0
    },
    {
        "product_name": "ห้องน้ำพกพาสำหรับตั้งแคมป์, ห้องน้ำเดินทางแบบพับปรับได้สำหรับตั้งแคมป์สีดำสำหรับตั้งแคมป์380lbs",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd11c12b419f94193ac95d20db19f281bu.jpg_200x200q90.jpg",
        "price": 1765.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16059777940.html",
        "sold": 0
    },
    {
        "product_name": "ตู้เก็บของแบบลิ้นชักกันน้ำ ขนาดแคบ ไม่ต้องประกอบ 18 ซม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S686b2f37c8864b8ba6c244154dcf657cY.jpg_200x200q90.jpg",
        "price": 1754,
        "remark": "https://www.lazada.co.th/products/pdp-i6026239168.html",
        "sold": 0
    },
    {
        "product_name": "ชั้นวางของในห้องน้ำมุมไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd4342e88cab24364b551d0d13db92f56x.png_200x200q90.png",
        "price": 1735.88,
        "remark": "https://www.lazada.co.th/products/pdp-i6078240380.html",
        "sold": 147
    },
    {
        "product_name": "Hosa | แว่นตากันน้ำกันฝ้าความละเอียดสูงสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S358823a310b542098e54311125988fadC.jpg_200x200q90.jpg",
        "price": 1730.66,
        "remark": "https://www.lazada.co.th/products/pdp-i16053114763.html",
        "sold": 0
    },
    {
        "product_name": "CREATE LOVE | ชุดคลุมอาบน้ำมีฮู้ด แห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S756c4863a1c24f388bbcacf5a5db84f2Q.jpg_200x200q90.jpg",
        "price": 1722.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5928076690.html",
        "sold": 18
    },
    {
        "product_name": "SHANNAIER | ชุดที่แขวนผ้าขนหนูพับได้ ไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S64fa090dccca4cbdbb43cd48b77ed020O.jpg_200x200q90.jpg",
        "price": 1720.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16062536568.html",
        "sold": 0
    },
    {
        "product_name": "B&W | ชั้นวางมุมห้องน้ำด้วยถ้วยดูดสุญญากาศ สแตนเลส 304",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S34a8edce3439430bb29b58acc067770bJ.jpg_200x200q90.jpg",
        "price": 1719.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5880246297.html",
        "sold": 11
    },
    {
        "product_name": "MEIKAIBIN | ชั้นวางของในห้องน้ำหลายประโยชน์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S76071046e387412f911eaf36f62e9cceQ.png_200x200q90.png",
        "price": 1703.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16054819488.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้นั่งถ่ายแบบพับได้สำหรับผู้สูงอายุ หญิงตั้งครรภ์ และผู้ป่วย ใช้ในบ้านหรือห้องน้ำ เคลื่อนย้ายได้ ใช้เป็นโถส้วมและเก้าอี้อาบน้ำได้  เก้าอี้นั่งถ่ายแบบพกพา และพับได้ สำหรับผู้สูงอายุ หญิงตั้งครรภ์ และผู้พิการ ใช้ในบ้าน แข็งแรง ทนทาน ปรับระดับได้ พร้อมฟ",
        "product_image": "https://img.lazcdn.com/g/p/3ef36bd1d6af2a93c3ead93efc4e0ea6.jpg_200x200q90.jpg",
        "price": 1684,
        "remark": "https://www.lazada.co.th/products/pdp-i5846479351.html",
        "sold": 3
    },
    {
        "product_name": "DAIWA | รอกสปินนิ่งเบาและโยนได้ไกล รุ่น Moonlight Beauty X LT ตกปลาทั้งน้ำจืดและน้ำเค็ม เน้นความเบา ลื่น และแม่นยำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa545d6bf7c6a49c0b445f031225b119ad.jpg_200x200q90.jpg",
        "price": 11491.32,
        "remark": "https://www.lazada.co.th/products/pdp-i6003246859.html",
        "sold": 4
    },
    {
        "product_name": "Ats886 เทมเพลตรอยสักไร้สายแบบพกพาสําหรับโทรศัพท์ Windows iOS และ Android",
        "product_image": "https://img.lazcdn.com/g/p/c26ae875b8c8b5d8605076ab291d61cb.jpg_200x200q90.jpg",
        "price": 5600,
        "remark": "https://www.lazada.co.th/products/pdp-i5172396080.html",
        "sold": 61
    },
    {
        "product_name": "เครื่องขัดเงา Shixin รุ่น STRONG209K เครื่องขัดเงาสำหรับงานทำเล็บ งานทันตกรรม และงานเครื่องประดับ เครื่องแกะสลักไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/See28d895752e403eb6abb2f7440dab7cO.jpg_200x200q90.jpg",
        "price": 4615.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5994098856.html",
        "sold": 0
    },
    {
        "product_name": "Florasis | ชุดแปรงแต่งหน้าเต็มเซ็ต สำหรับปัดแก้มและคอนทัวร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc56baf67fe744ea2a40add7f3b5f9811t.jpg_200x200q90.jpg",
        "price": 3360,
        "remark": "https://www.lazada.co.th/products/pdp-i6006056026.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องมือ PMU ไร้สายระดับมืออาชีพ - ไมโครแชดดิ้งสำหรับคิ้ว อายไลเนอร์ ริมฝีปาก แต่งหน้าถาวรหรือเข็มสัก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdc42c8ff5a474bccb811d959be946ad4Y.jpg_200x200q90.jpg",
        "price": 3291.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5993221173.html",
        "sold": 0
    },
    {
        "product_name": "LIWAN | กระจกแต่งหน้าหมุนบนโต๊ะ HD",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S292b18e8039c4a3a9472aeb73ffd860fy.png_200x200q90.png",
        "price": 3031.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6017917560.html",
        "sold": 1
    },
    {
        "product_name": "50-1000PCS ฟองน้ําใบหน้าบีบอัด Strong ดูดซับแผ่นทําความสะอาด Latex ฟรี Exfoliating แต่งหน้าฟองน้ํา Skin Care ฟองน้ํา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb0540bf354464796ac971bdc98ac00577.jpg_200x200q90.jpg",
        "price": 2896.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5889906664.html",
        "sold": 0
    },
    {
        "product_name": "SHANNAIER | กระจกติดผนังพร้อมไฟทันสมัย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sed764a3d46bb449a81f55ed4f2e66f11H.jpg_200x200q90.jpg",
        "price": 2862.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16060428493.html",
        "sold": 0
    },
    {
        "product_name": "MSQ | ชุดแปรงแต่งหน้ามืออาชีพสำหรับอายแชโดว์ ฟาวเดชัน บลัช และแป้ง ขนสัตว์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se3972625539846f7ab869b3414a76318E.jpg_200x200q90.jpg",
        "price": 2608.58,
        "remark": "https://www.lazada.co.th/products/pdp-i5859925313.html",
        "sold": 121
    },
    {
        "product_name": "กระจกตัดผม 3 ด้าน พร้อมไฟ LED สว่าง พกพาสะดวก มุมมอง 360 องศา กระจกแต่งหน้าแบบพับได้ 3 ตอน สำหรับแต่งหน้าและจัดแต่งทรงผมที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se46a54611e1a4c4a8f93639160cc34401.jpg_200x200q90.jpg",
        "price": 2146.24,
        "remark": "https://www.lazada.co.th/products/pdp-i5984644464.html",
        "sold": 0
    },
    {
        "product_name": "FWTDF | กระจกแต่งหน้า LED ขนาดใหญ่สำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S84c4b3c0a22c4d95962efbea5ad7490e1.jpg_200x200q90.jpg",
        "price": 2071.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16049185539.html",
        "sold": 0
    },
    {
        "product_name": "กระจกแต่งหน้า 10 เท่า ขยายภาพ 3 สี กระจกโต๊ะเครื่องแป้งแบบชาร์จไฟได้ ปรับความสูงได้ กระจกสองด้านสำหรับเครื่องสำอาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0a7096f8f9de471f890cb23b609dab81A.jpg_200x200q90.jpg",
        "price": 1842.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16099532558.html",
        "sold": 0
    },
    {
        "product_name": "BEAUTYBLENDER Original Beautyblender",
        "product_image": "https://img.lazcdn.com/g/p/f96184364f828cd0934116d7a95ffa9c.jpg_200x200q90.jpg",
        "price": 1790,
        "remark": "https://www.lazada.co.th/products/pdp-i4769069647.html",
        "sold": 77
    },
    {
        "product_name": "scbrush เซตแปรงโอวัลติน แปรงแต่งหน้ามืออาชีพ แปรงแต่งหน้า7ชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/a6bfb33994e35a00e40b82eb44c547a9.jpg_200x200q90.jpg",
        "price": 1728,
        "remark": "https://www.lazada.co.th/products/pdp-i5828195507.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องมือความงามอัลตราโซนิก  นวดหน้าเพื่อความงาม  ความถี่สูงอัลตราโซนิก  เครื่องความงามต่อต้านริ้วรอย",
        "product_image": "https://img.lazcdn.com/g/p/d104e64d72051467a2fa170f78228b77.png_200x200q90.png",
        "price": 1577.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5168180112.html",
        "sold": 0
    },
    {
        "product_name": "HANJIUGONG | กระจกแต่งหน้าพร้อมไฟขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2470bb41d79c4a94ac5cf0155c4e408af.jpg_200x200q90.jpg",
        "price": 1570.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16049332089.html",
        "sold": 0
    },
    {
        "product_name": "QINZHI | ชุดแปรงแต่งตา พร้อมแปรงเบลนด์, เฉดดิ้ง, อายแชโดว์ และแปรงรายละเอียด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa00ec519f94747dca8d6c3ff969b9340s.jpg_200x200q90.jpg",
        "price": 1541.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5875539225.html",
        "sold": 15
    },
    {
        "product_name": "REVITALASH LASH & BROW STYLER 3 IN 1 GROOMING TOOL",
        "product_image": "https://img.lazcdn.com/g/p/e53d4b50d622e426a3427a5d20fe0aca.png_200x200q90.png",
        "price": 1520,
        "remark": "https://www.lazada.co.th/products/pdp-i6071225043.html",
        "sold": 1
    },
    {
        "product_name": "MUID | กระจกแต่งหน้าพกพา LED พร้อมกล่องเก็บของ ของขวัญ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbd9323f8e4d9489db5fa52d6c9059a64t.jpg_200x200q90.jpg",
        "price": 1284.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5874224165.html",
        "sold": 9
    },
    {
        "product_name": "Tom Ford กระจกพกพา Compact Mirror (ของแท้จากช้อป)",
        "product_image": "https://img.lazcdn.com/g/p/28aa00f84ec77dc737def7f9577bce91.jpg_200x200q90.jpg",
        "price": 1180,
        "remark": "https://www.lazada.co.th/products/pdp-i16057868113.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องตัดเล็บไฟฟ้าแบบชาร์จ USB เงียบ พร้อมไฟ LED สำหรับเพื่อน นักเรียน ผู้ใหญ่ ผู้ชาย ผู้หญิง ใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S14fa94d86c214666bdfa124be99a807fz.jpg_200x200q90.jpg",
        "price": 1173.18,
        "remark": "https://www.lazada.co.th/products/pdp-i16096242106.html",
        "sold": 0
    },
    {
        "product_name": "Real Techniques | ชุดแปรงแต่งหน้าใยสังเคราะห์สำหรับผู้เริ่มต้นแต่งหน้า อุปกรณ์ชุดแปรงแต่งตาและแต่งหน้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbd8e6450d5c04cc594621f562560b4beX.jpg_200x200q90.jpg",
        "price": 1131.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5893741912.html",
        "sold": 206
    },
    {
        "product_name": "กระเป๋าเก็บยาทาเล็บขนาดใหญ่ พกพาสะดวก สำหรับเดินทาง ทำเล็บมืออาชีพ กระเป๋าโพลีเอสเตอร์อเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd39e309e261e46dcb0441fe0785e2e5fv.jpg_200x200q90.jpg",
        "price": 1123.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16080232765.html",
        "sold": 0
    },
    {
        "product_name": "MSQ | ชุดแปรงแต่งหน้า 11 ชิ้น สำหรับอายแชโดว์ บลัช คอนซีลเลอร์ และคอนทัวร์จมูก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se39558eec2ac4331be945a6a8e876034K.jpg_200x200q90.jpg",
        "price": 1059.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5877028914.html",
        "sold": 74
    },
    {
        "product_name": "เครื่องตัดขนหู จมูก และคิ้วหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf0685475525145bba4d61c56c20d2a2cn.jpg_200x200q90.jpg",
        "price": 1047.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16083604323.html",
        "sold": 2
    },
    {
        "product_name": "QINZHI | ชุดแปรงแต่งตาสำหรับเบลนด์และแชโดว์ ขนสัตว์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa3c8aaa6e5e34974a560b29836c542e0m.jpg_200x200q90.jpg",
        "price": 1032.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5877059332.html",
        "sold": 76
    },
    {
        "product_name": "4-IN-1 แบบพกพาความถี่สูงเครื่องความงามบนใบหน้าอิเล็กโทรดแสงสีม่วงแก้วหลอดแท่งสิวนวดหน้าสปาการดูแลผิว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S620d2feae0a0442c8a085b4a7f8990e0g.jpg_200x200q90.jpg",
        "price": 1015.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5939157187.html",
        "sold": 0
    },
    {
        "product_name": "Kate Spade New York กระเป๋าสะพายข้างรุ่น Tilly Quilted Small Crossbody KL640 001 สี Black",
        "product_image": "https://img.lazcdn.com/g/p/ac154f5ce1942724fa0f41ff96fc07f9.jpg_200x200q90.jpg",
        "price": 10500,
        "remark": "https://www.lazada.co.th/products/pdp-i5912459765.html",
        "sold": 0
    },
    {
        "product_name": "Kate Spade New York กระเป๋าสะพายข้างรุ่น Tilly Quilted Small Crossbody KL640 250 สี City Scape",
        "product_image": "https://img.lazcdn.com/g/p/5d91d0f5f001b55c13ab65517ceec772.jpg_200x200q90.jpg",
        "price": 10500,
        "remark": "https://www.lazada.co.th/products/pdp-i5912479621.html",
        "sold": 0
    },
    {
        "product_name": "MUVA | กระเป๋ารุ่น BOHO EDIT PATCH",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5d6179c3112541cb8eadea7d6663a816o.jpg_200x200q90.jpg",
        "price": 6746.62,
        "remark": "https://www.lazada.co.th/products/pdp-i6001920304.html",
        "sold": 16
    },
    {
        "product_name": "8angels - รุ่น Soda Cargo กระเป๋าสะพายข้างผู้หญิง ขนาด12.5นิ้ว (ปรับสาย-สั้นยาวได้)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S836fcaeb53684d41b918ba591d4d85f3m.jpg_200x200q90.jpg",
        "price": 1500,
        "remark": "https://www.lazada.co.th/products/pdp-i5837614333.html",
        "sold": 2
    },
    {
        "product_name": "Real Techniques | ชุดแปรงแต่งหน้าสำหรับบลัช, เซ็ตติ้ง, เชดโดว์, และคอนทัวร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S02909c061e734b2c9ddf1dccfb435af1t.jpg_200x200q90.jpg",
        "price": 1436.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5893781251.html",
        "sold": 38
    },
    {
        "product_name": "น้ำหอม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9424338ee4da4aee8c2b1e8c55b20d67e.jpg_200x200q90.jpg",
        "price": 30000,
        "remark": "https://www.lazada.co.th/products/pdp-i16095064444.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมกลิ่นมู่หลานไม่จำเพาะเพศ 45 มล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf139c6ccdca84548be5b5dc5ed449926f.jpg_200x200q90.jpg",
        "price": 23718.08,
        "remark": "https://www.lazada.co.th/products/pdp-i6031757106.html",
        "sold": 0
    },
    {
        "product_name": "LANCOME ABSOLUE LES PARFUM 6 AM ROSE 100ML",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S02224a575c8647c9a2f797872de4a04ae.jpg_200x200q90.jpg",
        "price": 22600,
        "remark": "https://www.lazada.co.th/products/pdp-i5768034004.html",
        "sold": 8
    },
    {
        "product_name": "รวมน้ำหอม เ..กอแ..ลง ข..องแ..ท้ * กล่องซีล *",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8fa6e290d1784282a10eccc268a9640do.jpg_200x200q90.jpg",
        "price": 18780,
        "remark": "https://www.lazada.co.th/products/pdp-i6075242264.html",
        "sold": 0
    },
    {
        "product_name": "รวมน้ำหอม หลุ.ย LV สเตลล่า ซิมโฟนี่ เมเทโอเร่ แ.ท้ 100 ml. *กล่องซีล*",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd0c67b5e0ea14915ac47d8c0b690626fJ.jpg_200x200q90.jpg",
        "price": 17380,
        "remark": "https://www.lazada.co.th/products/pdp-i16059226018.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมสำหรับรถเพื่อเป็นของขวัญ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S685e55cd874c48a284c5f76f4afa798eO.jpg_200x200q90.jpg",
        "price": 17082.32,
        "remark": "https://www.lazada.co.th/products/pdp-i16050723328.html",
        "sold": 64
    },
    {
        "product_name": "New! LANCOME IDOLE POWER​ EAU DE PARFUM INTENSE 100ML​ น้ำหอมลังโคม ฉีกกรอบเดิมๆ ด้วยความเข้มข้นใหม่ ขนาด 100 มล. (Perfume น้ำหอมผู้หญิง)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S458775e9041c4557b62a3efa9764add7E.jpg_200x200q90.jpg",
        "price": 15000,
        "remark": "https://www.lazada.co.th/products/pdp-i5589690153.html",
        "sold": 163
    },
    {
        "product_name": "น้ำหอมผู้หญิงcome Miracle EDP 100ml(แท้💯%)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0e84a2cfae1547119d83a1c01ba26154h.jpg_200x200q90.jpg",
        "price": 14800,
        "remark": "https://www.lazada.co.th/products/pdp-i5923113076.html",
        "sold": 0
    },
    {
        "product_name": "TOM FORD BEAUTY CAFE ROSE SIGNATURE EAU DE PARFUM - ทอม ฟอร์ด บิวตี้ น้ำหอม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd0e327e98aa043f085653db24cac1e38j.jpg_200x200q90.jpg",
        "price": 14300,
        "remark": "https://www.lazada.co.th/products/pdp-i5162771666.html",
        "sold": 11
    },
    {
        "product_name": "[สลักชื่อได้ไม่เกิน 3 ตัวอักษร] น้ำหอมผู้หญิง Chloé Iconic Signature Eau De Parfum | Lychee, Damasce Rose, Amber | A Powdery Honeyed Rose Perfume 100ML",
        "product_image": "https://img.lazcdn.com/g/p/848c9eac3802c86ae099057c684ebcd7.jpg_200x200q90.jpg",
        "price": 14060,
        "remark": "https://www.lazada.co.th/products/pdp-i5183998104.html",
        "sold": 17
    },
    {
        "product_name": "[สลักชื่อได้ไม่เกิน 3 ตัวอักษร] น้ำหอมผู้หญิง Chloé Iconic Signature Eau De Parfum | Lychee, Damasce Rose, Amber | A Powdery Honeyed Rose Perfume 75ML",
        "product_image": "https://img.lazcdn.com/g/p/2c3369a56ab47875dbc1667e74c1d2be.jpg_200x200q90.jpg",
        "price": 12540,
        "remark": "https://www.lazada.co.th/products/pdp-i5183977150.html",
        "sold": 11
    },
    {
        "product_name": "น้ำหอมผู้ชายตัวใหม่ล่าสุด \n Emporio Armani Stronger With You Amber 100ml \n#ป้ายไทย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5d9331c452514dcbb496a736fccdcb68f.jpg_200x200q90.jpg",
        "price": 12000,
        "remark": "https://www.lazada.co.th/products/pdp-i16066053473.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมกลิ่นหวานละมุนหรู โทนอุ่นนุ่ม 100ml EDP",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se0e88b26e2fd4e75900c3e94b6bcc357I.jpg_200x200q90.jpg",
        "price": 11998,
        "remark": "https://www.lazada.co.th/products/pdp-i16069041762.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมกลิ่นหวานลึกโทนแดง หรูอบอุ่น 100ml EDP",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S72a17c1444cb4c2b89b7a7e50591bf9cl.jpg_200x200q90.jpg",
        "price": 11998,
        "remark": "https://www.lazada.co.th/products/pdp-i16068971941.html",
        "sold": 0
    },
    {
        "product_name": "Black Paw | น้ำหอมกลิ่นสดชื่นใช้ได้นานสำหรับทุกเพศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S77033bcf42754b8a9250c4615f399266B.jpg_200x200q90.jpg",
        "price": 11988.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5872708442.html",
        "sold": 10
    },
    {
        "product_name": "กลิ่นหอมดอกไม้รวม Valen Dreams Collection EDP 100ml 🌱ทักแชทเช็คสต๊อกก่อนนะ🌿",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9ecb563fb32b4c3d956949bf17ffc2d1F.jpg_200x200q90.jpg",
        "price": 11980,
        "remark": "https://www.lazada.co.th/products/pdp-i5863983092.html",
        "sold": 0
    },
    {
        "product_name": "New! LANCOME IDOLE POWER​ EAU DE PARFUM INTENSE 50ML​ น้ำหอมลังโคม ฉีกกรอบเดิมๆ ด้วยความเข้มข้นใหม่ ขนาด 50 มล. (Perfume น้ำหอมผู้หญิง)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3e0b4f70ac0241c28ecde13ce799faaeI.jpg_200x200q90.jpg",
        "price": 10800,
        "remark": "https://www.lazada.co.th/products/pdp-i5589646405.html",
        "sold": 67
    },
    {
        "product_name": "รวมน้ำหอม CH ช…าแ..นล ผู้หญิง ช๊าน/โค.โค่ ข..องแ..ท้ *กล่องซีล*",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf321de3a03fe444eb54398400bd34ccaY.jpg_200x200q90.jpg",
        "price": 10380,
        "remark": "https://www.lazada.co.th/products/pdp-i16059057878.html",
        "sold": 0
    },
    {
        "product_name": "melt season | น้ำหอมทำพิเศษโทนไม้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc391a43ce5a74cf997a0dd1a5b46178ce.jpg_200x200q90.jpg",
        "price": 10288.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5894971709.html",
        "sold": 7
    },
    {
        "product_name": "น้ำหอมผู้หญิง โทนดอกไม้สะอาด นุ่มละมุน กลิ่นสุภาพ ขนาด 100 ml",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S592c33dfb50d4364830f2cfad5d5abedn.jpg_200x200q90.jpg",
        "price": 9998,
        "remark": "https://www.lazada.co.th/products/pdp-i6004490951.html",
        "sold": 0
    },
    {
        "product_name": "Miss Dior รุ่นใหม่ล่าสุด \n\nน้ำหอม Miss Dior Essence de Parfum \nสคบไทย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S215b2c30dc9945e89443eb0fa905f959U.jpg_200x200q90.jpg",
        "price": 9800,
        "remark": "https://www.lazada.co.th/products/pdp-i16074515873.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมกลิ่นหรูหราสายตะวันออก โทนหวานอุ่นเข้ม 100ml Parfum",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd62d6321c22e431fa015f780d851dadfG.jpg_200x200q90.jpg",
        "price": 9100,
        "remark": "https://www.lazada.co.th/products/pdp-i16069226499.html",
        "sold": 0
    },
    {
        "product_name": "[ แพค 12 ชิ้นสุดคุ้ม ] BSC NOOK MUSK OIL ขนาด 10 ML. น้ำหอมนุค กลิ่นหอม ติดทนนาน น้ำหอม #น้ำหอมติดทน  #น้ำหอมผู้ชาย  #น้ำหอมผู้หญิง #น้ำหอม",
        "product_image": "https://img.lazcdn.com/g/p/44c90b9a10afe75bd00e9eea3e332a7e.jpg_200x200q90.jpg",
        "price": 8908.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5052520935.html",
        "sold": 0
    },
    {
        "product_name": "VERSACE - Pour Homme Dylan Blue SPR24 EDT เวอร์ซาเช่ ชุดน้ำหอมชาย",
        "product_image": "https://img.lazcdn.com/g/p/dccee1263b726b45b7757fc6cae6dabc.jpg_200x200q90.jpg",
        "price": 8640,
        "remark": "https://www.lazada.co.th/products/pdp-i5252667328.html",
        "sold": 2
    },
    {
        "product_name": "น้ำหอมผู้หญิง โทนหวานนุ่ม หอมละมุน ใช้งานได้ทุกวัน ขวดสวยหรู EDP 100ML",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7dfc773437c04bc2be1d7a033d3fcfc7o.jpg_200x200q90.jpg",
        "price": 8300,
        "remark": "https://www.lazada.co.th/products/pdp-i16122313188.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมผู้หญิง กลิ่นเบอร์รี่หวานละมุน หอมสดใส ขวดลายดาว สไตล์หรู",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S34078d10bbc84fd6b3ff95f7e673bbdf0.jpg_200x200q90.jpg",
        "price": 7998,
        "remark": "https://www.lazada.co.th/products/pdp-i16122061832.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมผู้หญิง กลิ่นหวานสดใส โทนผลไม้ฟลอรัล 125ml EDP",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbd71faa4d64f47cabf1fd94cab1c894bQ.jpg_200x200q90.jpg",
        "price": 7998,
        "remark": "https://www.lazada.co.th/products/pdp-i16074775954.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมแท้💯กล่องซีล Glossier You Fleur Duo 50 ml + 8 ml",
        "product_image": "https://img.lazcdn.com/g/p/e34aab359c16132124767118b5e0f984.jpg_200x200q90.jpg",
        "price": 7980,
        "remark": "https://www.lazada.co.th/products/pdp-i16044031213.html",
        "sold": 0
    },
    {
        "product_name": "DAILY LAB | น้ำหอมปรับอากาศในรถพร้อมป้องกันหนัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbda9423a53594e87aff5573180deb40du.jpg_200x200q90.jpg",
        "price": 7371.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16084653319.html",
        "sold": 0
    },
    {
        "product_name": "##[ลดเหลือ 1,634.- Code PR2SFRU] Jo Malone English Pear & Freesia Cologne 30ml น้ำหอม แนวกลิ่นสดชื่น##",
        "product_image": "https://img.lazcdn.com/g/p/37e67b45098285bdd5cba0b00b39a917.jpg_200x200q90.jpg",
        "price": 7365.84,
        "remark": "https://www.lazada.co.th/products/pdp-i6063487155.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมผู้หญิง กลิ่นหวานละมุน ติดทน ลุคผู้ดี ขวดริบบิ้นแดง ลิมิเตด 90ml",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5a02193e274441e9a359ef5b3e0a5dbah.jpg_200x200q90.jpg",
        "price": 7198,
        "remark": "https://www.lazada.co.th/products/pdp-i16111936958.html",
        "sold": 0
    },
    {
        "product_name": "รวมน้ำหอม CH ช…าแ..นล ช๊าน/โค.โค่ ข..องแ..ท้ *กล่องซีล*",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0f047765dfc842be9c82aa9c563a56d7n.jpg_200x200q90.jpg",
        "price": 7180,
        "remark": "https://www.lazada.co.th/products/pdp-i16044174642.html",
        "sold": 0
    },
    {
        "product_name": "ใหม่! LANCOME IDOLE PEACH'N ROSES EDP 100ML น้ำหอมลังโคม กลิ่นโทนฟรุตตี้ฟลอรัลหวานฉ่ำ พร้อมยกระดับความหวานซ่อนเปรี้ยวของพีชให้โดดเด่นยิ่งขึ้นด้วยกลิ่นหอมนุ่มนวลทว่าทรงพลังจากกลีบกุหลาบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S05c676c6f65a4628af5457e72d732b24i.jpg_200x200q90.jpg",
        "price": 15000,
        "remark": "https://www.lazada.co.th/products/pdp-i6039076358.html",
        "sold": 39
    },
    {
        "product_name": "Jo Malone London - Cologne 100ml • Perfume โจ มาโลน ลอนดอน น้ำหอม",
        "product_image": "https://img.lazcdn.com/g/p/5d3b1885e33dee974c53796cb7b6353d.jpg_200x200q90.jpg",
        "price": 12800,
        "remark": "https://www.lazada.co.th/products/pdp-i2690274935.html",
        "sold": 992
    },
    {
        "product_name": "Coco Mademoiselle Eau De Parfum ชาแนล น้ำหอม กลิ่นดอกไม้ Amber Floral น้ำหอมแท้กลิ่นหรูหรา",
        "product_image": "https://img.lazcdn.com/g/p/aef99963afde7b2fbcf71b67aaf26cb1.jpg_200x200q90.jpg",
        "price": 8944,
        "remark": "https://www.lazada.co.th/products/pdp-i4112232541.html",
        "sold": 186
    },
    {
        "product_name": "YSL Y EDP น้ำหอมวายเอสแอลสำหรับผู้ชาย [60ml/100ml] (ของแท้ 100%)",
        "product_image": "https://img.lazcdn.com/g/p/3de79d87675e193ba46a86d7bb9297c7.jpg_200x200q90.jpg",
        "price": 7420,
        "remark": "https://www.lazada.co.th/products/pdp-i5758534759.html",
        "sold": 265
    },
    {
        "product_name": "YSL MYSLF EDP [60ml/100ml] น้ำหอมผู้ชายแนวใหม่ กลิ่นวูดดี้ฟลอรัล (ของแท้ 100%)",
        "product_image": "https://img.lazcdn.com/g/p/1353009eab186abebaf8a090d8856fdb.jpg_200x200q90.jpg",
        "price": 7260,
        "remark": "https://www.lazada.co.th/products/pdp-i5134365707.html",
        "sold": 151
    },
    {
        "product_name": "เป็นทางการ Maison Margiela  Never Ending Summer/Autumn Vibes 100ML Eau De Toilette",
        "product_image": "https://img.lazcdn.com/g/p/b404ca44354498a5e65e39995f864ae2.jpg_200x200q90.jpg",
        "price": 6910,
        "remark": "https://www.lazada.co.th/products/pdp-i16116969640.html",
        "sold": 7
    },
    {
        "product_name": "อย่างเป็นทางการ Jo Malone London Pear English Wild Bluebell Wood Sage & Sea Salt 100ML กลิ่นหอมยาวนาน Eau De Parfum",
        "product_image": "https://img.lazcdn.com/g/p/3c48df20abceef4ca9d962708e0d53a9.jpg_200x200q90.jpg",
        "price": 6811.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5511814978.html",
        "sold": 125
    },
    {
        "product_name": "Rêve Enchanté Eau De Parfum 100 ml. ( กล่องซีล สคบ.ไทย )",
        "product_image": "https://img.lazcdn.com/g/p/aece57fc95cf8afa148c87a2ef1337c4.jpg_200x200q90.jpg",
        "price": 6759.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6008541748.html",
        "sold": 0
    },
    {
        "product_name": "BURBERRY - Her EDP [ของแท้100%]",
        "product_image": "https://img.lazcdn.com/g/p/a89edf0acd62002d25065feff9a472c6.jpg_200x200q90.jpg",
        "price": 6588,
        "remark": "https://www.lazada.co.th/products/pdp-i3457340599.html",
        "sold": 971
    },
    {
        "product_name": "New! LANCOME IDOLE POWER​ EAU DE PARFUM INTENSE 25ML​ น้ำหอมลังโคม ฉีกกรอบเดิมๆ ด้วยความเข้มข้นใหม่ ขนาด 25 มล. (Perfume น้ำหอมผู้หญิง)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S286dba32000744458bca4360f9c88831h.jpg_200x200q90.jpg",
        "price": 6500,
        "remark": "https://www.lazada.co.th/products/pdp-i5570016327.html",
        "sold": 113
    },
    {
        "product_name": "อย่างเป็นทางการ Hermes Twilly / Tutti / Eau Poivree 85ML กลิ่นหอมยาวนาน Eau De Parfum",
        "product_image": "https://img.lazcdn.com/g/p/a55197f669caa33919b3ec86b58dc04f.jpg_200x200q90.jpg",
        "price": 6400,
        "remark": "https://www.lazada.co.th/products/pdp-i16123408375.html",
        "sold": 7
    },
    {
        "product_name": "Ysl Libre Eau De Parfum  น้ำหอม กลิ่นดอกไม้ วานิลลา",
        "product_image": "https://img.lazcdn.com/g/p/9efbb6f7229768e037f3d52f73cd0176.png_200x200q90.png",
        "price": 6364,
        "remark": "https://www.lazada.co.th/products/pdp-i2770652247.html",
        "sold": 184
    },
    {
        "product_name": "น้ำหอมปรับอากาศในรถ กลิ่นหอมยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6101d0c56e424617b63af1693e3579aeT.jpg_200x200q90.jpg",
        "price": 6335.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6016638066.html",
        "sold": 5
    },
    {
        "product_name": "อย่างเป็นทางการ Maison Margiela Never Ending Summer / Sailing Day / Autumn Vibes 100ML กลิ่นหอมยาวนาน Eau De Toilette",
        "product_image": "https://img.lazcdn.com/g/p/0ce33a6a566755c13620e8ee8ac2fa9b.jpg_200x200q90.jpg",
        "price": 6280,
        "remark": "https://www.lazada.co.th/products/pdp-i16123496196.html",
        "sold": 7
    },
    {
        "product_name": "Authentic Matiere Premiere Cologne Cedrat / Neroli Oranger / Parisian Musc 100ML น้ำหอมผู้ชาย Eau De Parfum",
        "product_image": "https://img.lazcdn.com/g/p/3f15dc24bbf3815019bd6062cbd028af.jpg_200x200q90.jpg",
        "price": 6214.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5989274350.html",
        "sold": 21
    },
    {
        "product_name": "Jo Malone London - Cologne 30ml • Perfume โจ มาโลน ลอนดอน น้ำหอม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb61b1cbda55f4253b85eb1d9c6315136e.jpg_200x200q90.jpg",
        "price": 6200,
        "remark": "https://www.lazada.co.th/products/pdp-i2690196868.html",
        "sold": 1618
    },
    {
        "product_name": "Jo Malone London Cologne 100ml 50ml 30ml 9ml • Perfume โจ มาโลน ลอนดอน น้ำหอม • Long-lasting perfumes with scents from fresh and uplifting citrus to opulent florals and warming woods •",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3b3dc21b5b9e47d09377a90dea4e8fb00.jpg_200x200q90.jpg",
        "price": 6200,
        "remark": "https://www.lazada.co.th/products/pdp-i5803850395.html",
        "sold": 792
    },
    {
        "product_name": "NEW! Issey Miyake Le Sel EDP น้ำหอมสำหรับผู้ชาย กลิ่นสดชื่นจากท้องทะเลสู่ผืนดิน อบอุ่น ลุ่มลึก กว่าเดิม",
        "product_image": "https://img.lazcdn.com/g/p/071eeeff9510f2de9fc462cb41f5585a.png_200x200q90.png",
        "price": 6080,
        "remark": "https://www.lazada.co.th/products/pdp-i5798613268.html",
        "sold": 477
    },
    {
        "product_name": "Juicy Couture Viva La Juicy Petals Please EDP 100ml น้ำหอมสำหรับผู้หญิง จากจูซี่ กูตูร์ กลิ่นหอมฟลอรัลฟรุ๊ตตี้",
        "product_image": "https://img.lazcdn.com/g/p/93cefd101ae02bd1374429caab4471fa.jpg_200x200q90.jpg",
        "price": 5998,
        "remark": "https://www.lazada.co.th/products/pdp-i16114955173.html",
        "sold": 0
    },
    {
        "product_name": "Juicy Couture Oui Eau de Parfum 100 ml. น้ำหอมสำหรับผู้หญิง ให้ความหอมหวานสดชื่นแนวฟลอรัล-ฟรุตตี้",
        "product_image": "https://img.lazcdn.com/g/p/3c62751a6e392f11e409dceb6d1ae59e.jpg_200x200q90.jpg",
        "price": 5998,
        "remark": "https://www.lazada.co.th/products/pdp-i16118972095.html",
        "sold": 0
    },
    {
        "product_name": "Black Paw | น้ำหอมสเปรย์กลิ่นหมึกหนังสือ กลางๆ สดชื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saea4f43afd14476a82ce8b16f4fb7b4a9.jpg_200x200q90.jpg",
        "price": 5996.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5878435776.html",
        "sold": 10
    },
    {
        "product_name": "น้ำหอมรถยนต์กลิ่นสดชื่น ยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbdf79c648dd448d3bc54bfd25f4ac742Z.jpg_200x200q90.jpg",
        "price": 5878,
        "remark": "https://www.lazada.co.th/products/pdp-i16101666708.html",
        "sold": 0
    },
    {
        "product_name": "Issey Miyake Le Sel d'Issey EDT น้ำหอมสำหรับผู้ชาย กลิ่นสดชื่นจากท้องทะเลสู่ผืนดิน เพิ่มรสชาติให้แก่การใช้ชีวิต",
        "product_image": "https://img.lazcdn.com/g/p/1e95f811ec5c4b8d7fbd24106987b72d.png_200x200q90.png",
        "price": 5600,
        "remark": "https://www.lazada.co.th/products/pdp-i5291026767.html",
        "sold": 1079
    },
    {
        "product_name": "[Exclusive Set] Marc Jacobs Fragrances Daisy Ever So Fresh Eau de Parfum 30ml Set เซ็ทน้ำหอม (Daisy Ever So Fresh EDP 30ml + Daisy Ever So Fresh EDP 4ml + Daisy Drop Pouch)",
        "product_image": "https://img.lazcdn.com/g/p/aadf366c4e2a49172f75f1cfa0b2454f.jpg_200x200q90.jpg",
        "price": 5600,
        "remark": "https://www.lazada.co.th/products/pdp-i4924827860.html",
        "sold": 88
    },
    {
        "product_name": "Miss Dior Blooming Bouquet - Eau De Parfum - 100ML*100% AUTHENTIC*",
        "product_image": "https://img.lazcdn.com/g/p/9696529503358bb879fbae3a65fb9b88.jpg_200x200q90.jpg",
        "price": 5586.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5867489410.html",
        "sold": 63
    },
    {
        "product_name": "HARNN ROSE & GERANIUM EAU DE TOILETTE 45 ML น้ำหอม ขนาด 45 ML",
        "product_image": "https://img.lazcdn.com/g/p/3e61d127893818cf3f4bb643201932d6.jpg_200x200q90.jpg",
        "price": 5561.4,
        "remark": "https://www.lazada.co.th/products/pdp-i4821335656.html",
        "sold": 20
    },
    {
        "product_name": "ร้านปลอดภาษี Valentino Valentina Pink 80ML น้ำหอม Eau De Parfum",
        "product_image": "https://img.lazcdn.com/g/p/0f4031ca5d32a33a94d75cac1cf2c4d1.jpg_200x200q90.jpg",
        "price": 5560,
        "remark": "https://www.lazada.co.th/products/pdp-i16124378531.html",
        "sold": 7
    },
    {
        "product_name": "อย่างเป็นทางการ Burberry \" Hero \" 100ML กลิ่นหอมยาวนาน Eau De Parfum",
        "product_image": "https://img.lazcdn.com/g/p/c79a152e7b8b674bf225718cb40c7c28.jpg_200x200q90.jpg",
        "price": 5406,
        "remark": "https://www.lazada.co.th/products/pdp-i5530327239.html",
        "sold": 104
    },
    {
        "product_name": "CHAXIANGSHI | น้ำหอมชาดาร์จีลิ่งสดชื่นจากธรรมชาติ ยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb69f7f8913d64f6f99c40175e1f85a8fh.jpg_200x200q90.jpg",
        "price": 5329.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5927282713.html",
        "sold": 0
    },
    {
        "product_name": "[Bestseller] Narciso Rodriguez for her EDP Intense น้ำหอมสำหรับผู้หญิง ปฐมบทใหม่ของความหอมที่เข้มข้น ดึงดูด ชวนหลงใหลกว่าเดิม",
        "product_image": "https://img.lazcdn.com/g/p/235b8cfd86e5701ff885462bd596313c.jpg_200x200q90.jpg",
        "price": 5240,
        "remark": "https://www.lazada.co.th/products/pdp-i5609429445.html",
        "sold": 972
    },
    {
        "product_name": "🎁☃️🎄Victoria's Secret แบบน้ำหอม EDP Deluxe Mini Fragrance Trio / giftset  ชุดของขวัญน้ำหอม 3 กลิ่นสุด Limited ใหม่แท้ 100% อเมริกา",
        "product_image": "https://img.lazcdn.com/g/p/844965bf4db584899405df74bf0f57ee.jpg_200x200q90.jpg",
        "price": 5198,
        "remark": "https://www.lazada.co.th/products/pdp-i4042298846.html",
        "sold": 0
    },
    {
        "product_name": "Butterfly Reserve collection - Ivory wood parfum 60ml",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S32a7cc7a8778446c9380cbee09b8bb9bl.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i5115804232.html",
        "sold": 3
    },
    {
        "product_name": "Burberry My Burberry Eau de Parfum For Women 90 ml. ( Tester Box )",
        "product_image": "https://img.lazcdn.com/g/p/1975523828fc86ed1c2ee1d1524ecf2a.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i5849711048.html",
        "sold": 0
    },
    {
        "product_name": "Authentic Atelier Cologne Pomelo Paradis 100ML น้ำหอมผู้ชาย Eau De Parfum",
        "product_image": "https://img.lazcdn.com/g/p/58b64e0200c48eb4fbc218f6e2de058c.jpg_200x200q90.jpg",
        "price": 5153.72,
        "remark": "https://www.lazada.co.th/products/pdp-i5911980251.html",
        "sold": 66
    },
    {
        "product_name": "Narciso Rodriguez for her EDP น้ำหอมสำหรับผู้หญิง มีเสน่ห์เย้ายวน สง่างามน่าดึงดูดใจ",
        "product_image": "https://img.lazcdn.com/g/p/d2a1293d5eaf74c00a958fee18d91222.jpg_200x200q90.jpg",
        "price": 5120,
        "remark": "https://www.lazada.co.th/products/pdp-i2693660457.html",
        "sold": 2113
    },
    {
        "product_name": "NEW! Narciso Rodriguez EDP Radiante น้ำหอมสำหรับผู้หญิง นุ่มนวล ผ่อนคลายและอ่อนโยน",
        "product_image": "https://img.lazcdn.com/g/p/cf93f493015cede0a3fc858ff986479b.jpg_200x200q90.jpg",
        "price": 5120,
        "remark": "https://www.lazada.co.th/products/pdp-i5731191223.html",
        "sold": 159
    },
    {
        "product_name": "CARLOTTA - น้ำหอม Carlotta Perfume Value Set for Women 5 bottles",
        "product_image": "https://img.lazcdn.com/g/p/b97497d29c824006a025e1ab83823778.jpg_200x200q90.jpg",
        "price": 5116,
        "remark": "https://www.lazada.co.th/products/pdp-i5877008065.html",
        "sold": 0
    },
    {
        "product_name": "JO MALONE LONDON น้ำหอม โจมาโลน แท้ 100% ป้ายคิง กล่อง โบว์ ถุง ครบ",
        "product_image": "https://img.lazcdn.com/g/p/ea84d915f5240077b3e542f790bf0e9b.jpg_200x200q90.jpg",
        "price": 5040,
        "remark": "https://www.lazada.co.th/products/pdp-i5644716587.html",
        "sold": 2
    },
    {
        "product_name": "แท้ 100% 001 Men'S And Women'S Perfume 100ML Eau De Toilette กลิ่นหอมยาวนาน",
        "product_image": "https://img.lazcdn.com/g/p/5f4c2bf9f9bf6424910f20e06b0a925c.jpg_200x200q90.jpg",
        "price": 5024.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16084322025.html",
        "sold": 8
    },
    {
        "product_name": "Issey Miyake L'Eau D'Issey EDT น้ำหอมสำหรับผู้หญิง ให้ความหอมสดชื่นของช่อดอกไม้สีขาว สง่างาม ไร้กาลเวลา",
        "product_image": "https://img.lazcdn.com/g/p/361522326e8a825ad283cfa3d6e20c6d.png_200x200q90.png",
        "price": 5000,
        "remark": "https://www.lazada.co.th/products/pdp-i2187396386.html",
        "sold": 574
    },
    {
        "product_name": "MONTBLANC Men's 5Pc Mini Fragrance Gift Set เซ็ตน้ำหอมสำหรับผู้ชายกลิ่นหอมใหม่สุดพิเศษจากต่างประเทศรับประกันลิขสิทธิ์แท้",
        "product_image": "https://img.lazcdn.com/g/p/5d8c237e9bc1c85a6ff607666667dbf9.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i4886324783.html",
        "sold": 0
    },
    {
        "product_name": "MONTBLANC Men's 5Pc Mini Fragrance Gift Set เซ็ตน้ำหอมสำหรับผู้ชายกลิ่นหอมใหม่สุดพิเศษจากต่างประเทศรับประกันลิขสิทธิ์แท้พร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/p/5d8c237e9bc1c85a6ff607666667dbf9.jpg_200x200q90.jpg",
        "price": 4900,
        "remark": "https://www.lazada.co.th/products/pdp-i4877848094.html",
        "sold": 0
    },
    {
        "product_name": "Marc Jacobs Fragrances Daisy Eau So Fresh Eau de Toilette น้ำหอม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9b2bd88aaeac4b52a8283f8cf76eaa46X.jpg_200x200q90.jpg",
        "price": 4860,
        "remark": "https://www.lazada.co.th/products/pdp-i4374509123.html",
        "sold": 139
    },
    {
        "product_name": "MADAME FIN โปรโมชั่นน้ำหอมมาดามฟินรุ่นคลาสสิก 1 ขวด น้ำหอมใหม่ SENSUOUS 1 ขวด สินค้าของแท้100% #น้ำหอมติดทน  #น้ำหอมผู้ชาย  #น้ำหอมผู้หญิง #น้ำหอม",
        "product_image": "https://img.lazcdn.com/g/p/cce4382cdfa4fa0427082141f3e5dfcf.jpg_200x200q90.jpg",
        "price": 4844,
        "remark": "https://www.lazada.co.th/products/pdp-i5052663633.html",
        "sold": 0
    },
    {
        "product_name": "Cacharel Noa EDT 100 ml. ( TESTER BOX ) 🌸น้ำหอมหญิง🌸 โนอา โดย คาชาเรล กลิ่นนุ่มนวลสดใส ด้วยดอกไม้",
        "product_image": "https://img.lazcdn.com/g/p/8aa8b67ad5b2be01cc6b70c312392683.jpg_200x200q90.jpg",
        "price": 4798,
        "remark": "https://www.lazada.co.th/products/pdp-i16098679169.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอม แท้ 30 ml. ของใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3b02c94f14e9468983319fbb1242c6eb1.jpg_200x200q90.jpg",
        "price": 4798,
        "remark": "https://www.lazada.co.th/products/pdp-i5564542741.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมปรับอากาศในรถแบบแข็ง กลิ่นยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S71127098205d43278269fa1428db7757G.jpg_200x200q90.jpg",
        "price": 4714.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16076694305.html",
        "sold": 0
    },
    {
        "product_name": "IDOLE EDP 10ML ขนาดพกพา น้ำหอมกลิ่นดอกไม้ สดชื่น ติดทน สำหรับผู้หญิงยุคใหม่ ทีเข้มแข็ง และมีพลัง perfume",
        "product_image": "https://img.lazcdn.com/g/p/4a4d3b4fcac98d05ec6c31198314de29.jpg_200x200q90.jpg",
        "price": 4681.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16122706005.html",
        "sold": 0
    },
    {
        "product_name": "BLACK PAW | น้ำหอมกลิ่นสดชื่นสีเขียว อยู่ได้นาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9e9d27dd6a9c48ccbcd339345435fb75w.jpg_200x200q90.jpg",
        "price": 4595.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5875679906.html",
        "sold": 6
    },
    {
        "product_name": "BLACK PAW | น้ำหอม Black Claw กลิ่นชาเขียวหอมสะอาด",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Sfe9915635a0142cea62be622a483eba5i.png_200x200q90.png",
        "price": 4581.06,
        "remark": "https://www.lazada.co.th/products/pdp-i5872215651.html",
        "sold": 22
    },
    {
        "product_name": "น้ำหอมสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb2ed7cb0b0a246fe8fe4be2870709e12N.jpg_200x200q90.jpg",
        "price": 4574.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16088154318.html",
        "sold": 0
    },
    {
        "product_name": "Narciso Rodriguez for her EDT น้ำหอมสำหรับผู้หญิง สง่างาม ซับซ้อน น่าหลงไหล",
        "product_image": "https://img.lazcdn.com/g/p/257f52e9f0eb1bb73f6f140e1b5df9d2.jpg_200x200q90.jpg",
        "price": 4480,
        "remark": "https://www.lazada.co.th/products/pdp-i2690801696.html",
        "sold": 728
    },
    {
        "product_name": "CHAXIANGSHI | น้ำหอมกลิ่นชารสปริง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S83e785025a5b4c9cb17db5b0e7beb748h.jpg_200x200q90.jpg",
        "price": 4470.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5933098340.html",
        "sold": 16
    },
    {
        "product_name": "DAILY LAB | น้ำหอมรถยนต์ทรงเปลือกหอย ใช้ได้นาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sece2c4c51f9b4f1aae6d4b7ba9732f71u.png_200x200q90.png",
        "price": 4461.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16083708848.html",
        "sold": 0
    },
    {
        "product_name": "Gallop | น้ำหอมปรับอากาศในรถที่มีกลิ่นยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb72bc1338a2044299d6688097a7198a7t.jpg_200x200q90.jpg",
        "price": 4417.06,
        "remark": "https://www.lazada.co.th/products/pdp-i5893769863.html",
        "sold": 194
    },
    {
        "product_name": "BURBERRY London for Men EDT 100 ml ( Tester Box ) น้ำหอมสำหรับชายหนุ่ม มอบกลิ่นหอมสดชื่นและนุ่มนวล เท่ห์ตามแบบฉบับหนุ่มผู้ดีอังกฤษ เรียบหรู น่าหลงใหล",
        "product_image": "https://img.lazcdn.com/g/p/9de1a9db941332aafe818c1232e2050a.jpg_200x200q90.jpg",
        "price": 4398,
        "remark": "https://www.lazada.co.th/products/pdp-i16081732740.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมผู้หญิง (แบรนด์ Enchant ของแท้ 100%) กลิ่น Winni Fred + Black Mod ปรคละกลิ่น 1 แถม 1 ขนาด 25ml ฟรุตตี้ น่ารักขี้เล่น + ฟรอรัล หรู ดูดี(น้ำหอมนำเข้าจากฝรั่งเศส)",
        "product_image": "https://img.lazcdn.com/g/p/d21d22a8d1c74cd0b5d29f5657f2cf99.jpg_200x200q90.jpg",
        "price": 4324.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16124043326.html",
        "sold": 0
    },
    {
        "product_name": "BURBERRY HERO MEN'S AND WOMEN'S EDP PERFUME / FRAGRANCE SPRAY 100ML",
        "product_image": "https://img.lazcdn.com/g/p/0d67bb6783313ae000f2ce881f50466d.jpg_200x200q90.jpg",
        "price": 4306.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5194642385.html",
        "sold": 94
    },
    {
        "product_name": "Sellion น้ำหอมกลิ่นโอเรียนเต็ลกูร์เมต์ 100 มล. น้ำหอมผู้หญิง EDP บรรจุภัณฑ์กล่องของขวัญฝรั่งเศสมีเสน่ห์",
        "product_image": "https://img.lazcdn.com/g/p/1175db96fcbd4253b57a7e45a944ead2.jpg_200x200q90.jpg",
        "price": 4262.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5844356851.html",
        "sold": 0
    },
    {
        "product_name": "ร้านปลอดภาษี Ariana Grande Thank U Next 105ML น้ำหอม Eau De Parfum",
        "product_image": "https://img.lazcdn.com/g/p/cc7dc3701f33d3dc4a3543667ab5908e.jpg_200x200q90.jpg",
        "price": 4260,
        "remark": "https://www.lazada.co.th/products/pdp-i16124168794.html",
        "sold": 7
    },
    {
        "product_name": "น้ำหอมผู้หญิง Chloé Iconic Signature Eau De Parfum | Lychee, Damasce Rose, Amber | A Powdery Honeyed Rose Perfume",
        "product_image": "https://img.lazcdn.com/g/p/dd9af5b05d8f72c4f9078ebceb25130f.jpg_200x200q90.jpg",
        "price": 4180,
        "remark": "https://www.lazada.co.th/products/pdp-i5146886720.html",
        "sold": 158
    },
    {
        "product_name": "Jimmy Choo | น้ำหอมกลิ่นอ่อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S705ec14ef7b74f0fb6128712e777c94fY.jpg_200x200q90.jpg",
        "price": 4173.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16085555269.html",
        "sold": 0
    },
    {
        "product_name": "HUALUNDESIGN  Bleu Eau De Parfum 100ml น้ำหอมผู้ชาย มอบของขวัญ",
        "product_image": "https://img.lazcdn.com/g/p/587839a96f5154bdd705b2aac8b30612.png_200x200q90.png",
        "price": 4138.62,
        "remark": "https://www.lazada.co.th/products/pdp-i6017408817.html",
        "sold": 16
    },
    {
        "product_name": "CALVIN KLEIN - CK Be EDT[ของแท้100%]",
        "product_image": "https://img.lazcdn.com/g/p/8221965670f61f2e45971db06ee91b7c.jpg_200x200q90.jpg",
        "price": 4085,
        "remark": "https://www.lazada.co.th/products/pdp-i3457297768.html",
        "sold": 1202
    },
    {
        "product_name": "✨น้ำหอมใหม่ล่าสุด! ✨ LANCOME IDÔLE Power L’Eau de Parfum intense 🌹💫 ขนาด 100ml",
        "product_image": "https://img.lazcdn.com/g/p/77df64cced492f6a6ba4f8c0bf1d43e5.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i16044758097.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอม Juicy Couture Viva La Juicy Rose Eau De Parfum ขนาด 100 ml. ของแท้ กล่องซีล",
        "product_image": "https://img.lazcdn.com/g/p/8f4ed055c376ee6081b6fafa8893a8ab.png_200x200q90.png",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i731340647.html",
        "sold": 4
    },
    {
        "product_name": "CHLOE - Signature EDP 20 ml.[ของแท้100%]",
        "product_image": "https://img.lazcdn.com/g/p/fee0c018d64a275837997779088b3c82.jpg_200x200q90.jpg",
        "price": 3960,
        "remark": "https://www.lazada.co.th/products/pdp-i782036223.html",
        "sold": 4143
    },
    {
        "product_name": "น้ำหอมกลิ่นอ่อนสำหรับผู้หญิง ใช้ได้นาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1dba60245fb246eea8ab581306d33a42T.jpg_200x200q90.jpg",
        "price": 3931.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5974542295.html",
        "sold": 0
    },
    {
        "product_name": "Moschino Toy2 EDP น้ำหอมมอสคิโนสำหรับผู้หญิง แนวกลิ่นหอมโทน Floral Aroma  (30ml/50ml/100ml) (ของแท้ 100%)",
        "product_image": "https://img.lazcdn.com/g/p/d5de8742b008984a899a2ef6aaee0f07.jpg_200x200q90.jpg",
        "price": 3930,
        "remark": "https://www.lazada.co.th/products/pdp-i3871761118.html",
        "sold": 102
    },
    {
        "product_name": "Jo Malone London - Cologne 9ml x2 • Perfume โจ มาโลน ลอนดอน น้ำหอม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se983384a1c564dfdbc43ba2d1cb55f752.jpg_200x200q90.jpg",
        "price": 3840,
        "remark": "https://www.lazada.co.th/products/pdp-i4895990362.html",
        "sold": 1807
    },
    {
        "product_name": "KVS | น้ำหอมรถยนต์กลิ่นยาวนาน 2025",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd7b904fefd614a1dae195e0db610eab5k.jpg_200x200q90.jpg",
        "price": 3789.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5909512856.html",
        "sold": 0
    },
    {
        "product_name": "[DAILYPAL] TAMBURINS Leather Wear Perfume 11 ml พร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/p/653d26dfc76dddf2d5486b0bb7eb78eb.jpg_200x200q90.jpg",
        "price": 3730,
        "remark": "https://www.lazada.co.th/products/pdp-i5472690044.html",
        "sold": 1
    },
    {
        "product_name": "น้ำหอม MITH : Cozy Musk",
        "product_image": "https://img.lazcdn.com/g/p/0c371c198fe62a9793c9be6103872fa1.png_200x200q90.png",
        "price": 3718,
        "remark": "https://www.lazada.co.th/products/pdp-i5013896694.html",
        "sold": 182
    },
    {
        "product_name": "Shiseido | Dark Opium น้ำหอม Eau de Parfum",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S13fe20217a0f4bdc8a695bddd50f52d9M.jpg_200x200q90.jpg",
        "price": 3714,
        "remark": "https://www.lazada.co.th/products/pdp-i16093867600.html",
        "sold": 0
    },
    {
        "product_name": "IMSOLE | น้ำหอมเฉพาะกลุ่ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saf3c5b2e6640486ba404c458f988b8a8N.png_200x200q90.png",
        "price": 3686,
        "remark": "https://www.lazada.co.th/products/pdp-i6005883452.html",
        "sold": 0
    },
    {
        "product_name": "KVS | น้ำหอมรถยนต์หรูหรา 2025",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S54ac259886fd49a183c659d1c936892eX.jpg_200x200q90.jpg",
        "price": 3673.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5909522752.html",
        "sold": 0
    },
    {
        "product_name": "Antidotes Body Perfume 50 ML | น้ำหอมฉีดตัว Eau de Parfum 50 มล | antidotes แอนติโดทส์",
        "product_image": "https://img.lazcdn.com/g/p/65ed3be3ef434a41bcd7a50b2d3d322e.jpg_200x200q90.jpg",
        "price": 3670.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5932235609.html",
        "sold": 184
    },
    {
        "product_name": "Ariana Grande Sweet Like Candy Eau de Parfum 100ml น้ำหอมอาเรียน่า กรานเด้ พิงค์ไลท์แคนดี้ ของแท้ กล่องซีล",
        "product_image": "https://img.lazcdn.com/g/p/ad4d15594d47221f7beb615223146433.jpg_200x200q90.jpg",
        "price": 3600,
        "remark": "https://www.lazada.co.th/products/pdp-i3148601098.html",
        "sold": 4
    },
    {
        "product_name": "ชุดของขวัญน้ำหอมสำหรับผู้ชาย กลิ่นไม้ ทนนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0fd5a51b36eb44feab2c87da0a2ec748H.jpg_200x200q90.jpg",
        "price": 3536,
        "remark": "https://www.lazada.co.th/products/pdp-i16120838744.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอม MITH : Love",
        "product_image": "https://img.lazcdn.com/g/p/f0c325d8032102e306ce84f2151e3476.png_200x200q90.png",
        "price": 3520.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5845910346.html",
        "sold": 24
    },
    {
        "product_name": "น้ำหอม Hawas for Men Eau De Parfum - 100ML (3.4 ออนซ์) โดย Rasasi",
        "product_image": "https://img.lazcdn.com/g/p/036eef011ad60c88d6c8ccfe4c330569.jpg_webp_200x200q90.jpg",
        "price": 3517.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16145236129.html",
        "sold": 0
    },
    {
        "product_name": "รวมกลิ่น!!! ขนาด 50ml (ซื้อ2แถม1 กดซื้อ2ขวด ขวดแถมแจ้งกลิ่นตรงข้อความค่ะ)",
        "product_image": "https://img.lazcdn.com/g/p/b323215631003fd709a2db42bd9d8edc.jpg_200x200q90.jpg",
        "price": 3477.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16114040995.html",
        "sold": 0
    },
    {
        "product_name": "【Watch shop】 AMOUAGE 100ml Mens Perfume Long Lasting Eau De Parfum Woody Oriental Aromatic Scent Fresh Warm Luxury Cologne Elegant Gift",
        "product_image": "https://img.lazcdn.com/g/p/094be54daa0f9c8fc48d3e858c18d842.png_200x200q90.png",
        "price": 3452.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6025407793.html",
        "sold": 0
    },
    {
        "product_name": "CHAXIANGSHI | น้ำหอมกลิ่นชาเบาๆ ทนนานสำหรับนักเรียน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5aabf5cd6b5a412598fb72d7735c22378.jpg_200x200q90.jpg",
        "price": 3437.94,
        "remark": "https://www.lazada.co.th/products/pdp-i6031754225.html",
        "sold": 4
    },
    {
        "product_name": "น้ำหอมคุณภาพสูงปรับแต่งได้ หอมยาวนาน กลิ่นอ่อนโยน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc2a01b53f935434ea7cebf3361f256d0e.png_200x200q90.png",
        "price": 3403.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6031710422.html",
        "sold": 12
    },
    {
        "product_name": "น้ำหอมแท้ ติด ทนนาน ของแท้100% BRITNEY SPEARS MIDNIGHT FANTASY EDP 100ml. น้ำหอมผู้หญิง มอบกลิ่นหอมหวานอบอวล เย้ายวนใจ ซ่อนความเปรี้ยวซ่า ร้าน Sokorea",
        "product_image": "https://img.lazcdn.com/g/p/f208d5f7e9ceaa330417918089552569.jpg_200x200q90.jpg",
        "price": 3398,
        "remark": "https://www.lazada.co.th/products/pdp-i3456617584.html",
        "sold": 17
    },
    {
        "product_name": "IMSOLE | น้ำหอมสำหรับผู้หญิง กลิ่นสดชื่นยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/See1064b0116049bf87534b6925aca910Z.png_200x200q90.png",
        "price": 3392,
        "remark": "https://www.lazada.co.th/products/pdp-i6005975170.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอม Moschino Cheap & Chic Eau De Toilette ขนาด100 ml. ของแท้ กล่องซีล",
        "product_image": "https://img.lazcdn.com/g/p/70f7bf37bb099ed4a8d39f54507feafa.png_200x200q90.png",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i760414395.html",
        "sold": 9
    },
    {
        "product_name": "ทางคลินิก Happy EDT 100ml Fragrance for Women perfume น้ำหอมผู้หญิง กลิ่นหอมติดทนนาน หรูหรา ทันสมัย",
        "product_image": "https://img.lazcdn.com/g/p/9675d3dc7122e799ad5741dc24d63ed9.png_200x200q90.png",
        "price": 3378,
        "remark": "https://www.lazada.co.th/products/pdp-i16111830579.html",
        "sold": 0
    },
    {
        "product_name": "Lanvin Eclat D Arpege Eau de Parfum 100ml น้ำหอม ลูกม่วง ลองแวง กลิ่นดอกไม้ ติดแป้ง นิดๆ ละมุน แป้งๆ",
        "product_image": "https://img.lazcdn.com/g/p/32b96b944224fe23420f3fd1744605e3.png_200x200q90.png",
        "price": 3368,
        "remark": "https://www.lazada.co.th/products/pdp-i2618783752.html",
        "sold": 926
    },
    {
        "product_name": "KVS | น้ำหอมสำหรับรถ กลิ่นโคโลญ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0cd74559312a4d75b8ccbf70f97b88f3p.jpg_200x200q90.jpg",
        "price": 3353.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16071959627.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมกลิ่นอ่อนๆ ที่อยู่ได้นาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sad5f5578d7b742dda4653815d7e8c873R.png_200x200q90.png",
        "price": 3327.3,
        "remark": "https://www.lazada.co.th/products/pdp-i6031640677.html",
        "sold": 20
    },
    {
        "product_name": "Parfum Excel น้ำหอม สำหรับสุนัขและแมว กลิ่น FLOWER ขนาด 100 มิลลิลิตร",
        "product_image": "https://img.lazcdn.com/g/p/f464170376c553df3fe4b8da7123e052.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i4890677261.html",
        "sold": 0
    },
    {
        "product_name": "Cacharel Anais Anais L’Original EDT 100 ml กล่องซีล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8359e09aedd2446abe25794eea3a8557p.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i5336870580.html",
        "sold": 14
    },
    {
        "product_name": "Davidoff Cool Water Women Sea Rose EDT [30 ml /50ml/100ml] ดาวิดอฟ น้ำหอมสำหรับผู้หญิง (ของแท้ 100%)",
        "product_image": "https://img.lazcdn.com/g/p/4adea9a7649a6668fa73d5b6476b05b4.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i4249011392.html",
        "sold": 24
    },
    {
        "product_name": "Parfum Roali น้ำหอม สำหรับสุนัขและแมว กลิ่น CYPRESS ขนาด 100 มิลลิลิตร",
        "product_image": "https://img.lazcdn.com/g/p/abfff0674a99117f4a0828f5550e61dc.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i4890599562.html",
        "sold": 0
    },
    {
        "product_name": "Parfum Alibe น้ำหอม สำหรับสุนัขและแมว กลิ่น MYRTLE ขนาด 100 มิลลิลิตร",
        "product_image": "https://img.lazcdn.com/g/p/721eac888e6626bdaff074886fe79e4b.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i4890625105.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมสำหรับผู้หญิงจากธรรมชาติ ที่มีความหอมยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3d3cdf08dd7d4e6f9e9f468ce0d64fa7Z.png_200x200q90.png",
        "price": 3226.24,
        "remark": "https://www.lazada.co.th/products/pdp-i6031678398.html",
        "sold": 0
    },
    {
        "product_name": "Blessing All | ธูปหอมไม้จันทร์และไม้สantalum สำหรับใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc386f8690ee14c8fab6812482d59152b3.jpg_200x200q90.jpg",
        "price": 3226,
        "remark": "https://www.lazada.co.th/products/pdp-i16099344408.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมราคาส่ง เปิดบิล ยกกล่อง ยกโหล",
        "product_image": "https://img.lazcdn.com/g/p/97704422e22fa4c924f935695cdd44df.jpg_200x200q90.jpg",
        "price": 3200,
        "remark": "https://www.lazada.co.th/products/pdp-i5812805066.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมปรับอากาศในรถที่มีกลิ่นยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S96daa296316243ee9281c63138fa720b3.jpg_200x200q90.jpg",
        "price": 3198.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16082245298.html",
        "sold": 0
    },
    {
        "product_name": "🔥🔥(น้ำหอม CC DOUBLE O)  น้ำหอม 365 FOR UNISEX 50Ml. หอมละมุนๆ มีความเท่ห์ๆลุยๆ ติดทนมากๆ กลิ่นคล้าย Dior Sauvage 🔥🔥",
        "product_image": "https://img.lazcdn.com/g/p/00549a6490939a407e35691eee1b7c68.png_200x200q90.png",
        "price": 3190,
        "remark": "https://www.lazada.co.th/products/pdp-i3664089534.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมรถระดับไฮเอนด์ ดีไซน์แบบเทพธิดา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S10d1d0c957f941e98840529053ceff80i.jpg_200x200q90.jpg",
        "price": 3166,
        "remark": "https://www.lazada.co.th/products/pdp-i16101748464.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมธรรมชาติจากกุหลาบบัลแกเรีย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf0eeed339f0842ac973b36877d8c3db7u.jpg_200x200q90.jpg",
        "price": 3164,
        "remark": "https://www.lazada.co.th/products/pdp-i16099123549.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมปรับอากาศรถยนต์หรูหราสร้างสรรค์ใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd6e0904edece4f1288b37e5d6bc8133dT.jpg_200x200q90.jpg",
        "price": 3106,
        "remark": "https://www.lazada.co.th/products/pdp-i16101631111.html",
        "sold": 0
    },
    {
        "product_name": "Black Paw | น้ำหอมสดชื่นยาวนานสำหรับทุกเพศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S56b30fef65df409da38af3854dea4e1bt.jpg_200x200q90.jpg",
        "price": 3069.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5877512084.html",
        "sold": 14
    },
    {
        "product_name": "Black Paw | น้ำหอมกลิ่นชาอู่หลง สำหรับทั้งชายและหญิง ใช้ได้นาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb5e056e0ceb64210b4ea437671fea1d16.jpg_200x200q90.jpg",
        "price": 3069.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5875785086.html",
        "sold": 18
    },
    {
        "product_name": "ออยล์น้ำหอมกลิ่น FULFILL กลิ่นลูกคุณหนู หอมหวาน ละมุน หรูหรา ดูลึกลับมีเสน่ห์ ชวนค้นหา",
        "product_image": "https://img.lazcdn.com/g/p/c55af7c8edd39d5d47ed53e57d1d3981.png_200x200q90.png",
        "price": 3045.38,
        "remark": "https://www.lazada.co.th/products/pdp-i4984290916.html",
        "sold": 5
    },
    {
        "product_name": "SHANGHETANG | ธูปสมุนไพรกลิ่นธรรมชาติใช้ในร่ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4d9cb5a7ed1747139b64213292bbd8b0A.jpg_200x200q90.jpg",
        "price": 3044,
        "remark": "https://www.lazada.co.th/products/pdp-i16099237125.html",
        "sold": 0
    },
    {
        "product_name": "Yves Rocher Flowerparty Summer Eau De Toilette For Women 50 ml. ( ไม่มีกล่อง No Box )",
        "product_image": "https://img.lazcdn.com/g/p/2ae3a5f1b7ef976df2e0a68c69d4b4a5.jpg_200x200q90.jpg",
        "price": 3032.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5159915769.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมรุ่น BE กลิ่นอบอุ่น Unisex EDT 100 ml., 200 ml. PCALK",
        "product_image": "https://img.lazcdn.com/g/p/fb7cf085803cb302c9e152e030c04dfc.jpg_200x200q90.jpg",
        "price": 2998,
        "remark": "https://www.lazada.co.th/products/pdp-i5882397709.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอม FOR HIM RED EDITION INTENSE 100 มล. (3.4 FL. OZ)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S63c7485255fb48e6b14a9431c96f4785r.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i5784829050.html",
        "sold": 0
    },
    {
        "product_name": "น้ำมันหอมสำหรับบ้านไร้ควัน ยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S049ee0e9f77244cf96018c9267ea71649.jpg_200x200q90.jpg",
        "price": 2918,
        "remark": "https://www.lazada.co.th/products/pdp-i16099299021.html",
        "sold": 0
    },
    {
        "product_name": "GUCCI - Flora Gorgeous Gardenia EDP Intense กุชชี่ น้ำหอมผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/3153bb2642b2610b35609edb72a8fb3f.jpg_200x200q90.jpg",
        "price": 2916,
        "remark": "https://www.lazada.co.th/products/pdp-i5821638499.html",
        "sold": 37
    },
    {
        "product_name": "BURBERRY - Goddess EDP Intense น้ำหอมผู้หญิง เบอร์เบอรี่ ก๊อดเดส โอ เดอ พาร์ฟูม อินเทนซ์",
        "product_image": "https://img.lazcdn.com/g/p/b8cc1a8be642570660b30447b894dfd3.jpg_200x200q90.jpg",
        "price": 2880,
        "remark": "https://www.lazada.co.th/products/pdp-i5289679869.html",
        "sold": 55
    },
    {
        "product_name": "ไม้หอมสำหรับในร่มคุณภาพดีแบบมีอายุ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S08e515fef10f42659b7e569bb7f50b68Z.jpg_200x200q90.jpg",
        "price": 2834,
        "remark": "https://www.lazada.co.th/products/pdp-i16099164918.html",
        "sold": 0
    },
    {
        "product_name": "YOUNGBEAST | น้ำหอมกลิ่นซิตรัส 50 มล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S46383c9ca8f840aeb3b0e1f93e983dfdF.png_200x200q90.png",
        "price": 2816.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16050864506.html",
        "sold": 2
    },
    {
        "product_name": "น้ำหอมผู้ชายแบบสเปรย์ 100 มล. (3.4 ออนซ์) กลิ่นหอมแบบอาหรับ ติดทนนาน กลิ่นหอมโดดเด่น ระดับพรีเมียม เหมาะสำหรับโอกาสพิเศษและใช้ในชีวิตประจำวัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8751a8978bae4aa1bd9530bdd3bf1855g.jpg_200x200q90.jpg",
        "price": 2806.72,
        "remark": "https://www.lazada.co.th/products/pdp-i5984243927.html",
        "sold": 0
    },
    {
        "product_name": "Butterfly Thai Perfume ขนาด 60 มล.",
        "product_image": "https://img.lazcdn.com/g/p/aac86392f9d2ff879ffbcdd2e7e3da2f.jpg_200x200q90.jpg",
        "price": 2790,
        "remark": "https://www.lazada.co.th/products/pdp-i3964533640.html",
        "sold": 1178
    },
    {
        "product_name": "KERASTASE Gloss Absolu - Gloss Le Parfum น้ำหอมเนรมิตผมสวย หอมล้ำลึกระดับโอตกูตูร์ ผสานสารสกัดบำรุงผมเข้มข้น เพื่อผลลัพธ์ผมสุขภาพดีชุ่มชื้นทุกเวลา 30ml",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8534e8dbc934440eaf125c16ddb6a5b7E.png_200x200q90.png",
        "price": 2780,
        "remark": "https://www.lazada.co.th/products/pdp-i5993206607.html",
        "sold": 211
    },
    {
        "product_name": "Davidoff Cool Water Sea Rose Woman Eau De Toilette น้ำหอม กลิ่นคูลวอเตอร์ โทนฟลอรัลหอมสดชื่น เย้ายวน",
        "product_image": "https://img.lazcdn.com/g/p/24bcb83bf2043654133a47bba20ead80.jpg_200x200q90.jpg",
        "price": 2774,
        "remark": "https://www.lazada.co.th/products/pdp-i5812764776.html",
        "sold": 26
    },
    {
        "product_name": "SHANGHETANG | น้ำยาฆ่าเชื้อจากสมุนไพร กลิ่นหอมสำหรับในร่ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2eed57dcd3a74688820c7d3e8d83c3d7v.jpg_200x200q90.jpg",
        "price": 2766,
        "remark": "https://www.lazada.co.th/products/pdp-i16099099734.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมผู้หญิง Omorose  1 ขวด ขนาดขวดล่ะ 25ml (หัวน้ำหอมนำเข้าจากฝรั่งเศส)",
        "product_image": "https://img.lazcdn.com/g/p/6c92f0185b2cee3d190bc57d5b18ce19.jpg_200x200q90.jpg",
        "price": 2745.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5898122970.html",
        "sold": 0
    },
    {
        "product_name": "BOSS Bottled Beyond For Him Regular 75ml - Ginger Leather EDP Perfume | by HUGO BOSS Fragrances",
        "product_image": "https://img.lazcdn.com/g/p/569a54926a9e6a156cdf0ddb596572bd.jpg_200x200q90.jpg",
        "price": 2718,
        "remark": "https://www.lazada.co.th/products/pdp-i5888075919.html",
        "sold": 11
    },
    {
        "product_name": "น้ำหอม Kaaf Pink เป็นน้ำหอมโทนหวานสดใส ดูหรูแบบผู้หญิงทันสมัย ขวดสีชมพูสดตัดกับฝาทอง ให้ความรู้สึกแพงและสะดุดตา 💖",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd8ba9bc2d1674c4fb3b5586a1abb31cfH.jpg_200x200q90.jpg",
        "price": 2698,
        "remark": "https://www.lazada.co.th/products/pdp-i16061886851.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมรถยนต์สไตล์เทพธิดาคริสตัล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S19b3a838562c4989b9995d3684f39d55g.jpg_200x200q90.jpg",
        "price": 2670,
        "remark": "https://www.lazada.co.th/products/pdp-i16101559426.html",
        "sold": 0
    },
    {
        "product_name": "น้ำยาหอมยาวนานจากธรรมชาติสำหรับใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S00c1aee6f66f426683d68ff24b6f8a77s.jpg_200x200q90.jpg",
        "price": 2662,
        "remark": "https://www.lazada.co.th/products/pdp-i16082384324.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมไม้บรรจุขวดคุณภาพสูง สำหรับผู้หญิงและผู้ชาย กลิ่นหอมติดทนนาน น้ำหอมส่วนตัวที่เย้ายวนใจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sddd6c2de29dc4adfbfa6ee128745e0c5U.jpg_200x200q90.jpg",
        "price": 2661.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5984434652.html",
        "sold": 0
    },
    {
        "product_name": "1. Matcha 101 (Eau De Parfum 50 ml + 5 ml) (Scent Studio)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S26497a53ab734e4b8a717cf977166ae6D.jpg_200x200q90.jpg",
        "price": 2660,
        "remark": "https://www.lazada.co.th/products/pdp-i4980257811.html",
        "sold": 431
    },
    {
        "product_name": "ลดราคา 50 % น้ำหอม ราคาถูก น้ำหอมผู้ชาย น้ำหอมปีเก่า รุ่นเก่า ตัวฮิต ตัวดัง",
        "product_image": "https://img.lazcdn.com/g/p/9c4e41e539b2118badc74dd0430069a5.jpg_200x200q90.jpg",
        "price": 2652,
        "remark": "https://www.lazada.co.th/products/pdp-i16054321078.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอม COACH มีหลายกลิ่น,มีหลายขนาดให้เลือก",
        "product_image": "https://img.lazcdn.com/g/p/5b8a99679119be6b7d11d9a996e4f83f.jpg_200x200q90.jpg",
        "price": 2649.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16066013480.html",
        "sold": 0
    },
    {
        "product_name": "🔥Best Seller🔥 มัดรวม น้ำหอมZara แพคคู่สุดคุ้ม ขายดีที่สุด ✨ กลิ่นหอมมาก หอมติดทนนาน รีบไปตำเลยค่ะ แท้💯 จากShop❗️❗️",
        "product_image": "https://img.lazcdn.com/g/p/037f4cc0d78720be6092435aa2d08296.jpg_200x200q90.jpg",
        "price": 2590,
        "remark": "https://www.lazada.co.th/products/pdp-i3829878556.html",
        "sold": 0
    },
    {
        "product_name": "FOR HIM NEO GREEN EDITION EDP 100 มล. (3.38 FL. OZ)",
        "product_image": "https://img.lazcdn.com/g/ot/common/bde3d2829db44cfe83a472e4da3c954a.jpeg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i5784622287.html",
        "sold": 0
    },
    {
        "product_name": "Cerapure เซราพิวเร่ น้ำหอม (Perfume) เพอร์ฟูม บอดี้ สเปรย์ กลิ่น Beloved Blossom  ขนาด 50 ml ของแท้ พร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/p/43f6cf88ee0a71e301b2b64ef452914b.jpg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i5336697466.html",
        "sold": 13
    },
    {
        "product_name": "BLACK PAW | น้ำหอมสไตล์จีนสำหรับทุกเพศ หอมยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S339a68aa6874427aaf15399bced3d9941.png_200x200q90.png",
        "price": 2570.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5878217571.html",
        "sold": 9
    },
    {
        "product_name": "Malya Perfume น้ำหอมกลิ่น Innosense 50 ML.",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbcd9c6e9f7a54debb10c4b1f51d4582fw.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i5522588660.html",
        "sold": 0
    },
    {
        "product_name": "Malya Perfume น้ำหอมกลิ่นผู้หญิง 50 ML.",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6f9015ccd9ea43e988a79cd3d00c91ea5.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i5516721649.html",
        "sold": 1
    },
    {
        "product_name": "CHUNFENGSHILI | น้ำหอมออสแมนธัส สำหรับทั้งชายและหญิง ยาวนาน สดชื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdff4cf7b8fc24758b5e4ca6f353901648.png_200x200q90.png",
        "price": 2556.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5844890399.html",
        "sold": 105
    },
    {
        "product_name": "TK ข้ามพรมแดน TEMU รุ่นยอดนิยม TK น้ำหอมฉีดผมและผิวกายขายดีที่สุด กลิ่นหอมติดทนนาน Perfume spray",
        "product_image": "https://img.lazcdn.com/g/p/0e02d103a45f0864278a085b3624e6ea.jpg_webp_200x200q90.jpg",
        "price": 2542.96,
        "remark": "https://www.lazada.co.th/products/pdp-i6006702985.html",
        "sold": 0
    },
    {
        "product_name": "Butterfly Thai Perfume - น้ำหอมบัตเตอร์ฟลาย ไทย เพอร์ฟูม ขนาด 60ml.",
        "product_image": "https://img.lazcdn.com/g/p/8a17884e277b5b065651bcea52ed2aff.jpg_200x200q90.jpg",
        "price": 2511,
        "remark": "https://www.lazada.co.th/products/pdp-i869112506.html",
        "sold": 3860
    },
    {
        "product_name": "น้ำหอม Paris Corner Ophidian Sweet Surrender ขนาด 100 ml ติดทน หอมนาน ของแท้100% นำเข้าจาก UAE",
        "product_image": "https://img.lazcdn.com/g/p/08d93eba48984213551a1d5e46c3caf7.jpg_200x200q90.jpg",
        "price": 2498,
        "remark": "https://www.lazada.co.th/products/pdp-i5419665076.html",
        "sold": 3
    },
    {
        "product_name": "ไม้หอมสำหรับในร่ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S794fd42b38f74219911e6235cf5cea101.jpg_200x200q90.jpg",
        "price": 2484,
        "remark": "https://www.lazada.co.th/products/pdp-i16099432049.html",
        "sold": 0
    },
    {
        "product_name": "เตียงไม้สำหรับเด็กสไตล์เจ้าหญิง สามารถเชื่อมต่อได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5dda4ce9fa4b430e9d0395ab19fb84795.jpg_200x200q90.jpg",
        "price": 50816.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16091248511.html",
        "sold": 0
    },
    {
        "product_name": "IGrow | ชุดโต๊ะเรียน สำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saa9203dc43b747609405f3b73294cd60P.png_200x200q90.png",
        "price": 30855.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16097545569.html",
        "sold": 0
    },
    {
        "product_name": "เตียงหัวเบาะ+เตียงเสริมเด็ก รุ่น Lovely Family พร้อมที่นอนสปริง **ตจว.มีค่าจัดส่ง สอบถามก่อนสั่งสินค้า**",
        "product_image": "https://img.lazcdn.com/g/p/bda36dc5e1c6c45c6ceac57ad7dfe55c.png_200x200q90.png",
        "price": 27000,
        "remark": "https://www.lazada.co.th/products/pdp-i5730313379.html",
        "sold": 0
    },
    {
        "product_name": "ชุดห้องนอน 3.5ฟุต ชุดห้องนอนเด็ก *ส่งฟรี กทม. ปริมณฑล ถ้าเขต ตจว. เช็คค่าส่งก่อนได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S30054eb5c90e4369ae2a2bc78728d7afl.jpg_200x200q90.jpg",
        "price": 23800,
        "remark": "https://www.lazada.co.th/products/pdp-i5150810711.html",
        "sold": 0
    },
    {
        "product_name": "cool baby|เตียงเด็กปรับระดับได้ พร้อมโต๊ะเปลี่ยนผ้าอ้อม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S13f47f7d839f4e78a2aa8726c90c4cdc9.jpg_200x200q90.jpg",
        "price": 16942.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5877120375.html",
        "sold": 587
    },
    {
        "product_name": "เต็นท์สำหรับเด็กหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf5dbc06a608f43f292ed636a35245e6b8.png_200x200q90.png",
        "price": 14840.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16083757145.html",
        "sold": 0
    },
    {
        "product_name": "MLOONG | โต๊ะเรียนปรับระดับได้สำหรับเด็ก 1 ชุด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9f48c308c41d47a1a9a393c8f6118224E.jpg_200x200q90.jpg",
        "price": 11300.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5909558481.html",
        "sold": 0
    },
    {
        "product_name": "XiMei WoodWork | เก้าอี้โยกไม้สำหรับในร่มและกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5f479e07ce7443d4886ecb3015906e65l.jpg_200x200q90.jpg",
        "price": 10325.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16099298975.html",
        "sold": 0
    },
    {
        "product_name": "DANBIYIN | เตียงเด็กอเนกประสงค์ไม่ได้ทาสี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sebf520ee80be45a8a32c8ffdec2c343cF.jpg_200x200q90.jpg",
        "price": 10185.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16060530941.html",
        "sold": 0
    },
    {
        "product_name": "เตียงพับได้สำหรับทารกแรกเกิด ใช้งานได้หลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S77080c9dd5f14e809bf4b2482d9d2ee7r.jpg_200x200q90.jpg",
        "price": 9243.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16120347980.html",
        "sold": 0
    },
    {
        "product_name": "โซฟาเก้าอี้ไดโนเสาร์และยีราฟการ์ตูน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc28a007d766e4d2e9762c931e4a44436G.jpg_200x200q90.jpg",
        "price": 7179.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16093473759.html",
        "sold": 0
    },
    {
        "product_name": "KEDINI | พรมป้องกันการลื่นสำหรับเด็กหนา ใช้ในห้องเด็กช่วงฤดูหนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S434a64bc21dd4c8385c4d5cea6a333a9S.jpg_200x200q90.jpg",
        "price": 6925.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16084735021.html",
        "sold": 0
    },
    {
        "product_name": "AOBIXIONG | เตียงเด็กพกพาที่มีโต๊ะเปลี่ยนผ้าอ้อม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S13fcd66dfeaa4c469fdbaaf1bce0e080n.jpg_200x200q90.jpg",
        "price": 6480.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6058679691.html",
        "sold": 0
    },
    {
        "product_name": "TY | ไม้กอล์ฟสำหรับเด็กมือใหม่ อายุ 3-12 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb96540b3fefb441abb17354139371c31o.jpg_200x200q90.jpg",
        "price": 6155.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5996754770.html",
        "sold": 0
    },
    {
        "product_name": "The Primitive | รถเข็นเด็กสำหรับแคมป์ปิ้งพับได้ มีที่นอน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfb98bbc93f1f45daa5285c55650aa3f9U.jpg_200x200q90.jpg",
        "price": 6121.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5909641864.html",
        "sold": 94
    },
    {
        "product_name": "Prettyia ชุดบ้านตุ๊กตา DIY ขนาดเล็กพร้อมเคสกันฝุ่นงานดนตรีชุดเฟอร์นิเจอร์บ้านตุ๊กตาอพาร์ทเมนต์สร้างสรรค์สำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/bc4448e42a2971d69d6cc9fc8a0be949.jpg_200x200q90.jpg",
        "price": 4415.48,
        "remark": "https://www.lazada.co.th/products/pdp-i6029715591.html",
        "sold": 0
    },
    {
        "product_name": "AYIJIE | เตียงเด็กอ่อนไม้เนื้อแข็งหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa71af11a14c146fda5e788c4a94ddf18Z.png_200x200q90.png",
        "price": 4038.18,
        "remark": "https://www.lazada.co.th/products/pdp-i16080070833.html",
        "sold": 0
    },
    {
        "product_name": "XINGWANMOKE | ชุดสร้างอาคารสถานที่ แบบห้องสมุด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8a4b9dbdcfac49b4be107053356e06374.png_200x200q90.png",
        "price": 3594.34,
        "remark": "https://www.lazada.co.th/products/pdp-i6031861068.html",
        "sold": 0
    },
    {
        "product_name": "WUBUWEI | ราวป้องกันความปลอดภัยสำหรับเตียงเด็กที่สามารถขยายได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3084167a2eb74982a327fe23a87c3e2aN.jpg_200x200q90.jpg",
        "price": 3529.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16057749971.html",
        "sold": 4
    },
    {
        "product_name": "เตียงเด็กอ่อนพกพาพับได้หลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4dc6d010fa6e47c0b6c2b899db056454J.jpg_200x200q90.jpg",
        "price": 3446.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16119624014.html",
        "sold": 0
    },
    {
        "product_name": "ZHUSHANXIA | โซฟาเด็กน่ารักลายการ์ตูนขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/See77fa870d3e4f7894ed4183e5bf344bz.jpg_200x200q90.jpg",
        "price": 3265.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5893776369.html",
        "sold": 12
    },
    {
        "product_name": "PAMPAS | ม่านเตียงสำหรับเตียงสองชั้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8c776bab53584d878c312af13c2c6deag.jpg_200x200q90.jpg",
        "price": 3062.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16096237776.html",
        "sold": 0
    },
    {
        "product_name": "S-NAIDE เตียงไม้พร้อมที่นอนแบบปรับได้ 3.5 ฟุต สำหรับเด็กแรกเกิดถึงวัยเตาะแตะตั้งแต่ 0-8 ปี - ไม้คุณภาพสูง ทนทาน ทำความสะอาดง่าย",
        "product_image": "https://img.lazcdn.com/g/p/232f3e3b0df272c9b50d4c8968b89d2f.jpg_200x200q90.jpg",
        "price": 2949.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5031698985.html",
        "sold": 109
    },
    {
        "product_name": "เตียงพกพาสำหรับทารก เตียงป้องกันแรงกด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S89661d82e7614676919828a4d01a8a3aM.jpg_200x200q90.jpg",
        "price": 2879.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16083612225.html",
        "sold": 0
    },
    {
        "product_name": "AOBIXIONG | โซฟาเด็กแบบการ์ตูนเจ้าหญิงน่ารัก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd334bff91cea40dfafc2dc18768b72b3a.jpg_200x200q90.jpg",
        "price": 2843.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16089345655.html",
        "sold": 0
    },
    {
        "product_name": "เตียงพับได้สำหรับทารกแบบพกพาหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc40b2cfb05674496b8814e87686a2c86b.png_200x200q90.png",
        "price": 2774.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16120311796.html",
        "sold": 0
    },
    {
        "product_name": "MLZH | เก้าอี้โยกไฟฟ้าสำหรับทารก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se1d276bc030a4a759fd804272a6c5c5di.jpg_200x200q90.jpg",
        "price": 2771.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5931401233.html",
        "sold": 1
    },
    {
        "product_name": "AYIJIE | เตียงเด็กทารกเป็นมิตรต่อสิ่งแวดล้อม ไม่ได้ทาสี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S89cddf43847e47db863a69ac6bf7b4dc5.jpg_200x200q90.jpg",
        "price": 2717.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16082525622.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้กินข้าวเด็ก โต๊ะกินข้าวเด็ก เก้าอี้ทานข้าวเด็ก พับได้ ปรับเป็นเก้าอี้โยกได้ มีล้อเลื่อน ปรับสูงต่ำได้ ถาด 2 ชั้น เบาะหนัง PU",
        "product_image": "https://img.lazcdn.com/g/p/2992dc5106c3dfaa712ffe85a8ae6f6b.png_200x200q90.png",
        "price": 2697.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16089853672.html",
        "sold": 4
    },
    {
        "product_name": "ZHENTAIYUAN | ชุดโต๊ะเรียนพลาสติกสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc8dee089abd543b0970541b8eacb8251D.jpg_200x200q90.jpg",
        "price": 2629.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16096053896.html",
        "sold": 0
    },
    {
        "product_name": "Lush age | เก้าอี้พับเด็กไม้แดงมาตรฐานชาติ งานประกอบแบบจีน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0acceadbaf2b45fbb759941c861954aad.jpg_200x200q90.jpg",
        "price": 2431.64,
        "remark": "https://www.lazada.co.th/products/pdp-i5894985570.html",
        "sold": 18
    },
    {
        "product_name": "เตียงเก้าอี้ที่เท้าแขนลายการ์ตูนน่ารักพับได้นอนโซฟานอนสบายปลอดภัยสำหรับการพักผ่อน",
        "product_image": "https://img.lazcdn.com/g/p/0df4b755207184fc40c6f96acde3e878.jpg_200x200q90.jpg",
        "price": 2382,
        "remark": "https://www.lazada.co.th/products/pdp-i16111320305.html",
        "sold": 0
    },
    {
        "product_name": "ZHUSHANXIA | โซฟาสำหรับอ่านหนังสือแบบพักผ่อนสำหรับคนเดียว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sad0cd74928e845b5b9629f39ded4167dt.jpg_200x200q90.jpg",
        "price": 2266.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5893636244.html",
        "sold": 39
    },
    {
        "product_name": "ชุดโต๊ะและเก้าอี้เรียนไม้เนื้อแข็งสำหรับอนุบาล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9d9183d79ecf4608b09e17f5f0ba8d5cx.jpg_200x200q90.jpg",
        "price": 2234,
        "remark": "https://www.lazada.co.th/products/pdp-i6040964255.html",
        "sold": 0
    },
    {
        "product_name": "CHIZHIDU | ตู้ข้างเตียงสไตล์มินิมอลสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Sd26b047261eb43668a86c68600932e42A.jpg_200x200q90.jpg",
        "price": 2176,
        "remark": "https://www.lazada.co.th/products/pdp-i6026095539.html",
        "sold": 2
    },
    {
        "product_name": "JACKDODO | ที่นอนเป่าลมในรถสำหรับเด็ก L",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2d780ad8439040d8a2d54257f541eebfp.jpg_200x200q90.jpg",
        "price": 2168.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5875583194.html",
        "sold": 4
    },
    {
        "product_name": "CHIZHIDU | เตียงเด็กทารกพับได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3b499dfde58c43919a99e47a7a30dbc9A.jpg_200x200q90.jpg",
        "price": 2127.28,
        "remark": "https://www.lazada.co.th/products/pdp-i16062339036.html",
        "sold": 0
    },
    {
        "product_name": "🌛 𝐆𝐨𝐨𝐝 𝐍i𝐠𝐡𝐭 💤 Satin Plus ที่นอน 3 ตอน ลาย We Bare Bear PB004",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2919d82c971b4d7ca5a42377f406e6b01.jpg_200x200q90.jpg",
        "price": 2120,
        "remark": "https://www.lazada.co.th/products/pdp-i16110047552.html",
        "sold": 0
    },
    {
        "product_name": "YANYANGTIAN | มุ้งกันยุงและม่านบังแดดแบบครบวงจร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9a6fc924e01e4feeb4fd149907a7b8caY.jpg_200x200q90.jpg",
        "price": 2100.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5909627668.html",
        "sold": 0
    },
    {
        "product_name": "Be | ชุดนอนผู้หญิงแขนสั้นขาสั้น สำหรับฤดูร้อน ทำจากฝ้าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd78c33a9c25b49fa97866e22b9a11938G.jpg_200x200q90.jpg",
        "price": 2083.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16099345578.html",
        "sold": 5
    },
    {
        "product_name": "FORUM ตลก ชุดสุนัขไส้กรอกเป่าลม การ์ตูน ชุดจั๊มสูทเต็มตัว ชุดเป่าลมสุนัขไส้กรอกน่ารัก ชุดตุ๊กตา ป้องกันน้ำ ชุดสุนัขเป่าลมรูปไส้กรอก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/0df774d4487854034089d7d46f1ee835.png_200x200q90.png",
        "price": 6858.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16135951380.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกีฬามวยแบบพรีเมียมส่วนตัวที่มีประกายวิบวับ ซีรีส์ Star-Shine",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S952effae60124460a2dfefadb88fb6cbi.png_200x200q90.png",
        "price": 6375.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16076607129.html",
        "sold": 0
    },
    {
        "product_name": "กระดานหน่วยพกพาได้อะคริลิคใสกระดานโต๊ะ IGT ของใช้บนโต๊ะ",
        "product_image": "https://img.lazcdn.com/g/p/8213045efa8f34d99e6f18af3e22b596.jpg_200x200q90.jpg",
        "price": 5950,
        "remark": "https://www.lazada.co.th/products/pdp-i16124831877.html",
        "sold": 0
    },
    {
        "product_name": "QIANSEPENG | เต็นท์ผีเสื้อทรงแปดเหลี่ยมพกพาได้ พร้อมโลโก้ส่วนตัวสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S76f5ca786bcc44baaf95d485b68e8428A.jpg_200x200q90.jpg",
        "price": 5695.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16098016036.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์ส่วนตัวกลางแจ้งสำหรับอาบน้ำและเปลี่ยนระหว่างการตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/31a6d5ca3d19109303f2173f93f407b6.jpg_200x200q90.jpg",
        "price": 5480,
        "remark": "https://www.lazada.co.th/products/pdp-i16122924051.html",
        "sold": 0
    },
    {
        "product_name": "LUTUMEI | หม้อไฟส่วนตัวสำหรับคนเดียว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf54069917b384c26956aca3ba469bfb86.png_200x200q90.png",
        "price": 5306,
        "remark": "https://www.lazada.co.th/products/pdp-i6026156495.html",
        "sold": 0
    },
    {
        "product_name": "QINBAOSHUIJING | คอลเลกชันส่วนตัวระดับพรีเมียม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S43bafe3d76384f148e7c0bd3db4b2216U.jpg_200x200q90.jpg",
        "price": 5264.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5951785932.html",
        "sold": 2
    },
    {
        "product_name": "เว็บแคม30fps คอมพิวเตอร์ USB กล้องเว็บแคมติดตั้งได้ง่าย1080P พร้อมหน้าปกส่วนตัวสำหรับการถ่ายทอดสดวิดีโอ",
        "product_image": "https://img.lazcdn.com/g/p/938477f00341728995db89b956b69da6.jpg_200x200q90.jpg",
        "price": 3428,
        "remark": "https://www.lazada.co.th/products/pdp-i5832215386.html",
        "sold": 0
    },
    {
        "product_name": "MAIDALING | แผ่นพื้นหลังตกแต่งวันเกิด สร้างบรรยากาศ ของใช้วันเกิดแรกสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S77af3dbfa6f3478f9e5660c31b5c502fI.png_200x200q90.png",
        "price": 3363.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16053165267.html",
        "sold": 0
    },
    {
        "product_name": "Chiwanji เหยือกถุงใส่ของใช้ซ้ำได้อเนกประสงค์แบบพกพามีมีฝาเกลียวถังน้ำที่เก็บน้ำ PC สำหรับเดินป่าดื่มน้ำ RV",
        "product_image": "https://img.lazcdn.com/g/p/ab42703ee369a15831fab187dfefb2e9.jpg_200x200q90.jpg",
        "price": 2810,
        "remark": "https://www.lazada.co.th/products/pdp-i6075099962.html",
        "sold": 0
    },
    {
        "product_name": "RIRIANN เตาแบบพกพา เตาแก๊สแคมปิ้ง น้ำหนักเบามาก สีกากีเชิ๊ต เตาตั้งแคมป์พับได้ เครื่องมือทำบาร์บีคิว ของใช้ในครัวเรือน เตาตั้งแคมป์กลางแจ้ง แบกเป้สะพายหลัง",
        "product_image": "https://img.lazcdn.com/g/p/9a5d33b04446352579f2a8702ae5aca6.jpg_200x200q90.jpg",
        "price": 2796,
        "remark": "https://www.lazada.co.th/products/pdp-i16141751839.html",
        "sold": 0
    },
    {
        "product_name": "MANNYI สีกากีเชิ๊ต เตาแก๊สแคมปิ้ง เตาแบบพกพา น้ำหนักเบามาก เตาบิวเทนสำหรับตั้งแคมป์ เตาทำอาหารทำอาหาร ของใช้ในครัวเรือน เตาตั้งแคมป์กลางแจ้ง แบกเป้สะพายหลัง",
        "product_image": "https://img.lazcdn.com/g/p/3ab8fb6d50e690dcba72acb843947946.jpg_200x200q90.jpg",
        "price": 2796,
        "remark": "https://www.lazada.co.th/products/pdp-i16141869087.html",
        "sold": 0
    },
    {
        "product_name": "กระเป๋าถือสำหรับกอล์ฟ honma กระเป๋าถือคุณภาพสูงแบบยูนิเซ็กส์ กันน้ำและทนต่อการสึกหรอ กระเป๋าใส่ลูกบอลขนาดเล็กสำหรับกีฬากลางแจ้ง กระเป๋าใส่ของใช้ส่วนตัว",
        "product_image": "https://img.lazcdn.com/g/p/7fdaa0d60575e618505d67a9909d2f3d.jpg_200x200q90.jpg",
        "price": 2759.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16147434997.html",
        "sold": 0
    },
    {
        "product_name": "กล่องอเนกประสงค์ตกปลาคาร์พฟีโนโวเคสใส่ของใช้ได้จริงสำหรับคลิปยางเฟืองท่อ",
        "product_image": "https://img.lazcdn.com/g/p/918c069123cab557bc1db18fe8e1868e.jpg_200x200q90.jpg",
        "price": 2704,
        "remark": "https://www.lazada.co.th/products/pdp-i5989101311.html",
        "sold": 0
    },
    {
        "product_name": "ลูกกอล์ฟพร้อมโลโก้ส่วนตัวสำหรับของขวัญระลึก Hole-in-One พร้อมกล่อง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6b222ef9f677447093a1eee2d5b8db69r.jpg_200x200q90.jpg",
        "price": 2622.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16091354485.html",
        "sold": 0
    },
    {
        "product_name": "SRAITH ชาร์จผ่าน USB ได้ คั้นน้ำผลไม้ไฟฟ้า ไร้สาย จอแสดงผลไฟฟ้า ที่บดน้ำแข็ง ของใช้ในครัว กำลังสูง ปั่นสมูทตี้ ใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/44f9024ffc778a12ca78185d1b7781ed.jpg_200x200q90.jpg",
        "price": 2616.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16090968537.html",
        "sold": 0
    },
    {
        "product_name": "BLACKON ไม่มีวงกลม ตาข่ายสไตล์อเมริกัน ตารางนิ้ว 1 นิ้ว หล่อด้วยมือ เหวี่ยงอวนจับปลา รอกตกปลา ลูกตุ้มเหล็ก ตาข่ายจับปลา ของใช้ตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/2e4eaf229ec477e67e93e457a5c2e840.jpg_200x200q90.jpg",
        "price": 2526,
        "remark": "https://www.lazada.co.th/products/pdp-i16146035063.html",
        "sold": 0
    },
    {
        "product_name": "BENGPEN 4 กรงเล็บ ตะขอเกี่ยว นержักร 3 กรงเล็บ ปีนป่าย ของใช้สำหรับปีนเขา ดีไซน์พับได้ ตะขอสแตนเลส ปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/0459b77cd0fbc9dd1d44d459d82efded.jpg_200x200q90.jpg",
        "price": 2419.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16121146970.html",
        "sold": 0
    },
    {
        "product_name": "ARVOL ที่ชาร์จ USB ถ้วยคั้นน้ำผลไม้ไฟฟ้า มัลติฟังก์ชั่ จุได้มาก ถ้วยดื่มน้ำ เครื่องคั้นน้ำผลไม้ เล็กๆน้อยๆ ถ้วยปั่นแบบพกพา ของใช้ในครัวเรือน",
        "product_image": "https://img.lazcdn.com/g/p/eb9ed952a2b404629389a7a7674a1217.jpg_200x200q90.jpg",
        "price": 2410.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16141225672.html",
        "sold": 0
    },
    {
        "product_name": "MARRCIAN 4 กรงเล็บ ตะขอเกี่ยว นержักร 3 กรงเล็บ ตะขอสแตนเลส ของใช้สำหรับปีนเขา โครงสร้างเหล็ก ตะขอเกี่ยวแบบพับได้ ปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/b42f232d6173b71b6514e73ca979e5ad.jpg_200x200q90.jpg",
        "price": 2383.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16126855017.html",
        "sold": 0
    },
    {
        "product_name": "KEQI 3 กรงเล็บ ตะขอเกี่ยว 4 กรงเล็บ นержักร ตะขอสแตนเลส ของใช้สำหรับปีนเขา ดีไซน์พับได้ ตะขออเนกประสงค์ ปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/bd44b070f7a90d0997bc184db2a27f94.png_200x200q90.png",
        "price": 2347.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16127220470.html",
        "sold": 0
    },
    {
        "product_name": "SRAITH 4 กรงเล็บ ตะขอเกี่ยว 3 กรงเล็บ นержักร ปีนป่าย ของใช้สำหรับปีนเขา ดีไซน์พับได้ ตะขอสแตนเลส ปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/5e15db94fef1f0b14222b81bbc858ed6.jpg_200x200q90.jpg",
        "price": 2344.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16127214604.html",
        "sold": 0
    },
    {
        "product_name": "MAYINGLONG | ผ้าเปียกทำความสะอาดที่สามารถล้างออกได้ แบบพกพา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfd783420e014488b8d2264108586c848P.jpg_200x200q90.jpg",
        "price": 2219.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16112235415.html",
        "sold": 0
    },
    {
        "product_name": "RUNDTY สร้างสรรค์ ชุดขี่ม้าเป่าลม การ์ตูน ป้องกันน้ำ ชุดคอสเพลย์ปาร์ตี้ ชุดตุ๊กตา พัดลมที่ถอดออกได้ ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/e596e4be4fce30f5f98775c3a39d5c7b.png_200x200q90.png",
        "price": 2200,
        "remark": "https://www.lazada.co.th/products/pdp-i16100889662.html",
        "sold": 0
    },
    {
        "product_name": "BOTISY สร้างสรรค์ ชุดขี่ม้าเป่าลม การ์ตูน ป้องกันน้ำ ชุดคอสเพลย์ปาร์ตี้ ชุดตุ๊กตา พัดลมที่ถอดออกได้ ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/d9c3232f3a577d99c3e12d6f5b86815a.jpg_200x200q90.jpg",
        "price": 2198,
        "remark": "https://www.lazada.co.th/products/pdp-i16100998952.html",
        "sold": 0
    },
    {
        "product_name": "ที่รักตะกร้าด้านหลังจักรยานสำหรับเด็กตะกร้าตะกร้าใส่ของสีดำติดตั้งง่ายมีสไตล์เดินทางด้วยจักรยานไฟฟ้าซื้อของใช้กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/bff0499c02aa155eab042df4c03c5cde.jpg_200x200q90.jpg",
        "price": 2194.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16097898294.html",
        "sold": 0
    },
    {
        "product_name": "ABOND สร้างสรรค์ ชุดขี่ม้าเป่าลม ป้องกันน้ำ การ์ตูน ชุดคอสเพลย์ปาร์ตี้ คอสเพลย์สำหรับผู้ใหญ่และเด็ก น้ำหนักเบา ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/258841efa8776ec0f098c19d19677412.png_200x200q90.png",
        "price": 2194,
        "remark": "https://www.lazada.co.th/products/pdp-i16101068839.html",
        "sold": 0
    },
    {
        "product_name": "ANGEL การ์ตูน ชุดขี่ม้าเป่าลม สร้างสรรค์ ป้องกันน้ำ ชุดเทศกาลตลก คอสเพลย์สำหรับผู้ใหญ่และเด็ก น้ำหนักเบา ชุดคอสเพลย์ปาร์ตี้ ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/b8e2a3f12e9ad213440153139609122c.png_200x200q90.png",
        "price": 2192,
        "remark": "https://www.lazada.co.th/products/pdp-i16100883663.html",
        "sold": 0
    },
    {
        "product_name": "Gazechimp เต็นท์ส่วนตัวแขวนหลังคาเรือแบบพกพาขนาด39.3X39.3X78.7นิ้วอเนกประสงค์ติดตั้งได้ง่ายสำหรับฝักบัวอาบน้ำกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/9c981302b449a772872dd93daf328d96.jpg_200x200q90.jpg",
        "price": 2188,
        "remark": "https://www.lazada.co.th/products/pdp-i5951827913.html",
        "sold": 0
    },
    {
        "product_name": "HONGUS สร้างสรรค์ ชุดขี่ม้าเป่าลม ป้องกันน้ำ การ์ตูน ชุดคอสเพลย์ปาร์ตี้ คอสเพลย์สำหรับผู้ใหญ่และเด็ก น้ำหนักเบา ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/2327c492c5c66f7942e585fce89e6ac7.png_200x200q90.png",
        "price": 2182,
        "remark": "https://www.lazada.co.th/products/pdp-i16101075166.html",
        "sold": 0
    },
    {
        "product_name": "SIMPLIC สร้างสรรค์ ชุดขี่ม้าเป่าลม การ์ตูน ป้องกันน้ำ ชุดคอสเพลย์ปาร์ตี้ คอสเพลย์สำหรับผู้ใหญ่และเด็ก พัดลมที่ถอดออกได้ ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/9a1f34986fdebc78e73e610374faa35e.png_200x200q90.png",
        "price": 2162,
        "remark": "https://www.lazada.co.th/products/pdp-i16101170519.html",
        "sold": 0
    },
    {
        "product_name": "VINEY การ์ตูน ชุดขี่ม้าเป่าลม สร้างสรรค์ ป้องกันน้ำ ชุดคอสเพลย์ปาร์ตี้ คอสเพลย์สำหรับผู้ใหญ่และเด็ก น้ำหนักเบา ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/0650f9b8513d6fe82ee7e077cca7f0b6.png_200x200q90.png",
        "price": 2162,
        "remark": "https://www.lazada.co.th/products/pdp-i16101292236.html",
        "sold": 0
    },
    {
        "product_name": "ZIAAN การ์ตูน ชุดขี่ม้าเป่าลม ป้องกันน้ำ สร้างสรรค์ ชุดคอสเพลย์ปาร์ตี้ ชุดตุ๊กตา น้ำหนักเบา ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/9270e836fe0d22b1194921ce1c0faa9b.png_200x200q90.png",
        "price": 2156,
        "remark": "https://www.lazada.co.th/products/pdp-i16101336126.html",
        "sold": 0
    },
    {
        "product_name": "YARUA สร้างสรรค์ ชุดขี่ม้าเป่าลม การ์ตูน ป้องกันน้ำ ชุดคอสเพลย์ปาร์ตี้ ระบบพองลมอัตโนมัติ น้ำหนักเบา ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/3792e82b98af3d04edfcfe8c83d2fc97.jpg_200x200q90.jpg",
        "price": 2152,
        "remark": "https://www.lazada.co.th/products/pdp-i16101202441.html",
        "sold": 0
    },
    {
        "product_name": "YOURUN การ์ตูน ชุดขี่ม้าเป่าลม สร้างสรรค์ ป้องกันน้ำ ชุดคอสเพลย์ปาร์ตี้ ชุดตุ๊กตา พัดลมที่ถอดออกได้ ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/89af33c8d6087bc825cfc65e67305e12.jpg_200x200q90.jpg",
        "price": 2144,
        "remark": "https://www.lazada.co.th/products/pdp-i16101216417.html",
        "sold": 0
    },
    {
        "product_name": "AISHA สร้างสรรค์ ชุดขี่ม้าเป่าลม ป้องกันน้ำ การ์ตูน ชุดเทศกาลตลก ชุดตุ๊กตา น้ำหนักเบา ชุดคอสเพลย์ปาร์ตี้ ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/d7881765e7aa7584178370f78772e319.jpg_200x200q90.jpg",
        "price": 2140,
        "remark": "https://www.lazada.co.th/products/pdp-i16101053242.html",
        "sold": 0
    },
    {
        "product_name": "ED การ์ตูน ชุดขี่ม้าเป่าลม ป้องกันน้ำ สร้างสรรค์ ชุดคอสเพลย์ปาร์ตี้ ระบบพองลมอัตโนมัติ น้ำหนักเบา ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/e497b6e1d42c051fcc52a462b4893f35.png_200x200q90.png",
        "price": 2124,
        "remark": "https://www.lazada.co.th/products/pdp-i16101153004.html",
        "sold": 0
    },
    {
        "product_name": "ชุด Baju Otot Baoblaze ผ้าเนื้อนุ่มน้ำหนักเบาสำหรับของใช้สำหรับปาร์ตี้ปีใหม่การแสดงบนเวทีงานคาร์นิวัล",
        "product_image": "https://img.lazcdn.com/g/p/18020d5114e3fcd731baf393ff9fb050.jpg_200x200q90.jpg",
        "price": 2108,
        "remark": "https://www.lazada.co.th/products/pdp-i16105914229.html",
        "sold": 0
    },
    {
        "product_name": "ผลิตภัณฑ์ขจัดคราบ Miss Mouth's Messy Eater - น้ำยาขจัดคราบ 4 ออนซ์ - ของใช้จำเป็นสำหรับทารกแรกเกิดและเด็กเล็ก - ขจัดคราบอาหาร คราบไขมัน คราบกาแฟ ออกจากผ้า ชุดชั้นใน และผ้าทุกชนิดโดยไม่ต้องซักแห้ง",
        "product_image": "https://img.lazcdn.com/g/p/cfa05ff4e035164507b5427ef4fb8797.jpg_webp_200x200q90.jpg",
        "price": 2093.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16145022230.html",
        "sold": 0
    },
    {
        "product_name": "GUDY การ์ตูน ชุดขี่ม้าเป่าลม สร้างสรรค์ ป้องกันน้ำ ชุดเทศกาลตลก ระบบพองลมอัตโนมัติ น้ำหนักเบา ชุดคอสเพลย์ปาร์ตี้ ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/d586021f69541023dfc12ac633fb4ef3.jpg_200x200q90.jpg",
        "price": 2076.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16101214507.html",
        "sold": 0
    },
    {
        "product_name": "LONGKE | พัดลมเป่าฝุ่นไฟฟ้าพลังสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se708b9cfad874cf2af39abba0854078dN.jpg_200x200q90.jpg",
        "price": 2630.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5910882630.html",
        "sold": 2
    },
    {
        "product_name": "Vaseline | โลชั่นอาบน้ำ Vaseline Daily Moisture Body Wash สูตร pH 5.5 ขนาด 1000 มล. x 2 ขวด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdeb30758f157429483cb66c04bf446edt.png_200x200q90.png",
        "price": 2382.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5964887354.html",
        "sold": 0
    },
    {
        "product_name": "Dove | โดฟ นอรสซง ออยล แคร แชมพ 680 มล. 2 ขวด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sef1ae4d445504e4fa3b34aea8d586c7br.png_200x200q90.png",
        "price": 2334.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16092772202.html",
        "sold": 0
    },
    {
        "product_name": "CHICKETTI สร้างสรรค์ ชุดขี่ม้าเป่าลม ป้องกันน้ำ การ์ตูน ชุดเทศกาลตลก คอสเพลย์สำหรับผู้ใหญ่และเด็ก น้ำหนักเบา ชุดคอสเพลย์ปาร์ตี้ ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/38e09ed5e274ed3acd2871fdde9f8c19.jpg_200x200q90.jpg",
        "price": 2076.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16100897638.html",
        "sold": 0
    },
    {
        "product_name": "Plu | สครับขัดผิวกาย Plu Body Scrub 200g x 2 โรสแมรี่ ขจัดเซลล์ผิวเก่า บำรุงให้ชุ่มชื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfd978c4584af448b9b8e9e3cbe6c2ecb0.png_200x200q90.png",
        "price": 2046.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5959396352.html",
        "sold": 1
    },
    {
        "product_name": "Mr.Snail | ชุดเครื่องใช้บนโต๊ะสำหรับครอบครัว 4 คน ดีไซน์สวยงาม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sda18f031158f47ceafb264bba6dbe160u.jpg_200x200q90.jpg",
        "price": 2038.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5874200186.html",
        "sold": 86
    },
    {
        "product_name": "TUS สร้างสรรค์ ชุดขี่ม้าเป่าลม ป้องกันน้ำ การ์ตูน ชุดเทศกาลตลก ชุดตุ๊กตา พัดลมที่ถอดออกได้ ชุดคอสเพลย์ปาร์ตี้ ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/25a55d419f3a1e94c5517ac2ab7a8f6b.jpg_200x200q90.jpg",
        "price": 2021.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16101358044.html",
        "sold": 0
    },
    {
        "product_name": "TOOYFUL เรือผ้าม่านสำหรับความเป็นส่วนตัวห้องเปลี่ยนเสื้อผ้าแขวนได้ห้องแต่งตัวม่านอาบน้ำเต็นท์ส่วนตัวสำหรับเรือโป๊ะถ่ายรูปชายหาด",
        "product_image": "https://img.lazcdn.com/g/p/b2eb445d98736f27c9ba2364e11295c9.jpg_200x200q90.jpg",
        "price": 1974,
        "remark": "https://www.lazada.co.th/products/pdp-i5970242981.html",
        "sold": 0
    },
    {
        "product_name": "SHEBE668 ตารางนิ้ว 1 นิ้ว ตาข่ายสไตล์อเมริกัน หล่อด้วยมือ ไม่มีวงกลม เหวี่ยงอวนจับปลา แข็งแกร่ง ลูกตุ้มเหล็ก ตาข่ายจับปลา ของใช้ตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/2ffbe4c5e749d0a7e53511d4bf8ff40d.jpg_200x200q90.jpg",
        "price": 1968.92,
        "remark": "https://www.lazada.co.th/products/pdp-i6012809164.html",
        "sold": 0
    },
    {
        "product_name": "JUNOTERNEY ประสิทธิภาพสูง เครื่องเจาะกระดาษ 30 หลุม น้ำหนักเบา ที่เจาะรู คุณภาพสูง รูปทรงกลม เครื่องเจาะปกเอกสาร ของใช้สำนักงาน",
        "product_image": "https://img.lazcdn.com/g/p/aa4cd17a47d217461532c74c67e56190.jpg_200x200q90.jpg",
        "price": 1916,
        "remark": "https://www.lazada.co.th/products/pdp-i16101271385.html",
        "sold": 0
    },
    {
        "product_name": "กล่องอุปกรณ์เสริมตกปลาเรือกล่องอุปกรณ์ตกปลา4ชั้นแบบพกพาสำหรับตกปลากล่องอเนกประสงค์พร้อมที่จับกล่องของใช้",
        "product_image": "https://img.lazcdn.com/g/p/e42a2adec2007f397082db61c6dce101.jpg_200x200q90.jpg",
        "price": 1910,
        "remark": "https://www.lazada.co.th/products/pdp-i5129028602.html",
        "sold": 0
    },
    {
        "product_name": "JDTYJDT สร้างสรรค์ ชุดขี่ม้าเป่าลม ป้องกันน้ำ การ์ตูน ชุดคอสเพลย์ปาร์ตี้ ชุดตุ๊กตา พัดลมที่ถอดออกได้ ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/665de6190f0af9696fb3a3997bbc657d.jpg_200x200q90.jpg",
        "price": 1898,
        "remark": "https://www.lazada.co.th/products/pdp-i16075060813.html",
        "sold": 0
    },
    {
        "product_name": "ผลิตภัณฑ์ใช้ประจำวัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8a345f7ee569466da9d610ab4f69aba78.jpg_200x200q90.jpg",
        "price": 1896.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16111316091.html",
        "sold": 0
    },
    {
        "product_name": "YZHX | ปั๊มพองบอลลูนฮีเลียมพกพา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S95bd3ca0184348279d2b60ef05b59a89P.jpg_200x200q90.jpg",
        "price": 1892,
        "remark": "https://www.lazada.co.th/products/pdp-i6026165497.html",
        "sold": 1
    },
    {
        "product_name": "YDIJEJ การ์ตูน ชุดขี่ม้าเป่าลม สร้างสรรค์ ป้องกันน้ำ ชุดคอสเพลย์ปาร์ตี้ ระบบพองลมอัตโนมัติ น้ำหนักเบา ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/3f9ceaefc2902e4f2ad768ee4f6300b1.jpg_200x200q90.jpg",
        "price": 1872,
        "remark": "https://www.lazada.co.th/products/pdp-i16089334811.html",
        "sold": 0
    },
    {
        "product_name": "MUQZI ตารางนิ้ว 1 นิ้ว ตาข่ายสไตล์อเมริกัน หล่อด้วยมือ ไม่มีวงกลม เหวี่ยงอวนจับปลา รอกตกปลา 4.8 เมตร ตาข่ายจับปลา ของใช้ตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/b36439a4f69fd245dc459e8b308ebdeb.jpg_200x200q90.jpg",
        "price": 1862,
        "remark": "https://www.lazada.co.th/products/pdp-i16147396666.html",
        "sold": 0
    },
    {
        "product_name": "GBDSVD สร้างสรรค์ ชุดขี่ม้าเป่าลม การ์ตูน ป้องกันน้ำ ชุดเทศกาลตลก ชุดตุ๊กตา น้ำหนักเบา ชุดคอสเพลย์ปาร์ตี้ ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/34b4caca42e7ed365290a14ab1cb15df.jpg_200x200q90.jpg",
        "price": 1848,
        "remark": "https://www.lazada.co.th/products/pdp-i16082261950.html",
        "sold": 0
    },
    {
        "product_name": "MAOMEI ไม่มีวงกลม ตาข่ายสไตล์อเมริกัน หล่อด้วยมือ ตารางนิ้ว 1 นิ้ว เหวี่ยงอวนจับปลา แข็งแกร่ง แบบพับได้ ตาข่ายจับปลา ของใช้ตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/ec9140e46c81e90bc86ac7842882c40f.png_200x200q90.png",
        "price": 1846,
        "remark": "https://www.lazada.co.th/products/pdp-i16146913335.html",
        "sold": 0
    },
    {
        "product_name": "PGM GOLF | กระเป๋าใส่รองเท้ากอล์ฟแบบพกพา น้ำหนักเบา กันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0a4ebf6afb634beb93ae4d2deb43eacdb.jpg_200x200q90.jpg",
        "price": 1814.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16055117188.html",
        "sold": 0
    },
    {
        "product_name": "MARRCIAN ปีนเขา ฟิงเกอร์บอร์ดปีนเขา ที่เสริมแรงจับ ที่บริหารแขน กระดานฝึกปีนเขา ของใช้สำหรับกีฬา ดึงขึ้น แผ่นหินแข็งแรง บ้านกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/abeb53c5544ce8a4c3a6efd14c4d4103.jpg_200x200q90.jpg",
        "price": 1811.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16086242602.html",
        "sold": 0
    },
    {
        "product_name": "เจลอาบน้ำควบคุมความมัน บำรุงผิวชุ่มชื้น กลิ่นหอมยาวนาน ไนโตรนาไมด์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S08f86c7bd025412bb12f212b32afdfb76.jpg_200x200q90.jpg",
        "price": 1800.02,
        "remark": "https://www.lazada.co.th/products/pdp-i16089746033.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องปั่นอาหารเด็ก เครื่องปั่น เครื่องบดอาหารสำหรับเด็ก  4ใบมีด ของใช้ครัวเรือน วัสดุสแตนเลส+พลาสติกเครื่องปั่นไฟฟ้าโถพลาสติกอย่างดี 300วัตต์ เครื่องปั่นผสมอาหารอเนกประสงค์ ของแท้ พร้อมส่งจากไทย",
        "product_image": "https://img.lazcdn.com/g/p/4e6f99422500ff724b78b4b3e398a9dd.jpg_200x200q90.jpg",
        "price": 1780,
        "remark": "https://www.lazada.co.th/products/pdp-i5615549469.html",
        "sold": 0
    },
    {
        "product_name": "WDAir ตะเกียงแอลกอฮอล์เตาแอลกอฮอล์น้ำหนักเบาสำหรับเดินทางร้านอาหารของใช้ในครัวเรือน",
        "product_image": "https://img.lazcdn.com/g/p/cb0578899c1f92ce848f4d005173ad5e.jpg_200x200q90.jpg",
        "price": 1772,
        "remark": "https://www.lazada.co.th/products/pdp-i5967046805.html",
        "sold": 0
    },
    {
        "product_name": "YAHURO ที่เสริมแรงจับ ฟิงเกอร์บอร์ดปีนเขา ปีนเขา ที่บริหารแขน กระดานฝึกปีนเขา ของใช้สำหรับกีฬา ไม้ แผ่นหินแข็งแรง บ้านกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/d60e2705d350039e38d244618227dc33.jpg_200x200q90.jpg",
        "price": 1771.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16086223149.html",
        "sold": 0
    },
    {
        "product_name": "Koolsoo ที่แขวนผ้าม่านสำหรับความเป็นส่วนตัวเรือม่านอาบน้ำทะเลที่คลุมผ้าอ๊อกซ์ฟอร์ดเต็นท์ส่วนตัวกลางแจ้งสำหรับถ่ายภาพชายหาด",
        "product_image": "https://img.lazcdn.com/g/p/eda8d5d7e60c72f00007b069d167b8bf.jpg_200x200q90.jpg",
        "price": 1760,
        "remark": "https://www.lazada.co.th/products/pdp-i5973207772.html",
        "sold": 0
    },
    {
        "product_name": "YUHENNY สร้างสรรค์ ชุดขี่ม้าเป่าลม ป้องกันน้ำ การ์ตูน ชุดคอสเพลย์ปาร์ตี้ ชุดตุ๊กตา พัดลมที่ถอดออกได้ ชุดเทศกาลตลก ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/6ef42f3b8c9fa5e04bcf90e5cce909bc.jpg_200x200q90.jpg",
        "price": 1760,
        "remark": "https://www.lazada.co.th/products/pdp-i16113648906.html",
        "sold": 0
    },
    {
        "product_name": "BEYTM การ์ตูน ชุดขี่ม้าเป่าลม ป้องกันน้ำ สร้างสรรค์ ชุดเทศกาลตลก ชุดตุ๊กตา น้ำหนักเบา ชุดคอสเพลย์ปาร์ตี้ ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/8c00c38b3fad8507d7b5eabbed0f047f.jpg_200x200q90.jpg",
        "price": 1752,
        "remark": "https://www.lazada.co.th/products/pdp-i16056628319.html",
        "sold": 0
    },
    {
        "product_name": "DXSFV ปีนเขา ฟิงเกอร์บอร์ดปีนเขา ที่บริหารแขน ที่เสริมแรงจับ กระดานฝึกปีนเขา ของใช้สำหรับกีฬา ไม้ แผ่นหินแข็งแรง บ้านกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/457d7a0de7c9d19afb3f9626006713f5.jpg_200x200q90.jpg",
        "price": 1733.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16137072465.html",
        "sold": 0
    },
    {
        "product_name": "RISEDOT แบบพับได้ ยาง MTB 26 27.5 291.95 นิ้ว น้ำหนักเบา ยางจักรยานแข่ง ใหม่ ป้องกันการแทง ยางจักรยานเสือภูเขา CST ของใช้สำหรับขี่",
        "product_image": "https://img.lazcdn.com/g/p/cd947e220f51585445d968bfb079d28c.jpg_200x200q90.jpg",
        "price": 1730.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16090908315.html",
        "sold": 0
    },
    {
        "product_name": "WAYCAI 26 27.5 291.95 นิ้ว ยาง MTB แบบพับได้ น้ำหนักเบา ยางจักรยานแข่ง ใหม่ ป้องกันการแทง ยางจักรยานเสือภูเขา CST ของใช้สำหรับขี่",
        "product_image": "https://img.lazcdn.com/g/p/f5cf40bfb2d934e3343945b7885935bc.jpg_200x200q90.jpg",
        "price": 1726.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5875465988.html",
        "sold": 4
    },
    {
        "product_name": "Dove | โดฟ แชมพ อนเทนส รแพร แชมพ 680 มล. x 2 ขวด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se8e176b1bd2e4168aeaab0a895ee53832.png_200x200q90.png",
        "price": 1725.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5968757085.html",
        "sold": 0
    },
    {
        "product_name": "ลูกกอล์ฟ 3 ชั้นพร้อมโลโก้ส่วนตัว 10 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3dd32b8c8d6249038790960a0f8fe7daN.png_200x200q90.png",
        "price": 1721.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16087341946.html",
        "sold": 0
    },
    {
        "product_name": "BAOZITI | เจลอาบน้ำอโลเวร่าและสมุนไพร ชุ่มชื่นอย่างอ่อนโยน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0e0ab621f96349c38c902d19d68b3089e.jpg_200x200q90.jpg",
        "price": 1704.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16117659227.html",
        "sold": 0
    },
    {
        "product_name": "MUQZI จังหวะคลิกเสียง ผู้ฝึกสอนวงสวิงกอล์ฟ แกนกอล์ฟ น้ำหนักเบา คลับฝึกซ้อมกอล์ฟ แบบพกพา ตามหลักสรีรศาสตร์ ผู้ฝึกสอนพัตเตอร์ยาวกอล์ฟ ของใช้สำหรับการฝึกอบรม",
        "product_image": "https://img.lazcdn.com/g/p/940cc32bd761365e841c9171dca9b495.jpg_200x200q90.jpg",
        "price": 1700,
        "remark": "https://www.lazada.co.th/products/pdp-i16147402356.html",
        "sold": 0
    },
    {
        "product_name": "MAOMEI น้ำหนักเบา ผู้ฝึกสอนวงสวิงกอล์ฟ แกนกอล์ฟ จังหวะคลิกเสียง คลับฝึกซ้อมกอล์ฟ ของเล่น หลายฟังก์ชัน ผู้ฝึกสอนพัตเตอร์ยาวกอล์ฟ ของใช้สำหรับการฝึกอบรม",
        "product_image": "https://img.lazcdn.com/g/p/ddac361f5281a0b6a33f78171ce08173.png_200x200q90.png",
        "price": 1696,
        "remark": "https://www.lazada.co.th/products/pdp-i16147306354.html",
        "sold": 0
    },
    {
        "product_name": "PICKING การ์ตูน ชุดขี่ม้าเป่าลม ป้องกันน้ำ สร้างสรรค์ ชุดเทศกาลตลก ชุดตุ๊กตา พัดลมที่ถอดออกได้ ชุดคอสเพลย์ปาร์ตี้ ของใช้สำหรับงานปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/6b9fb17e514e025697635a4c487f96aa.jpg_200x200q90.jpg",
        "price": 1676.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16100929611.html",
        "sold": 0
    },
    {
        "product_name": "ABOND 3 กรงเล็บ ตะขอเกี่ยว นержักร 4 กรงเล็บ ปีนป่าย ของใช้สำหรับปีนเขา ดีไซน์พับได้ ตะขอเกี่ยวแบบพับได้ ปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/704fb86750ef5a7829285fa15d0e8794.png_200x200q90.png",
        "price": 1662,
        "remark": "https://www.lazada.co.th/products/pdp-i16126845020.html",
        "sold": 0
    },
    {
        "product_name": "ANSINE 4 กรงเล็บ ตะขอเกี่ยว 3 กรงเล็บ นержักร ปีนป่าย ของใช้สำหรับปีนเขา ดีไซน์พับได้ ตะขอสแตนเลส ปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/bcf54ea1a012d1f0f29eead15b467e55.jpg_200x200q90.jpg",
        "price": 1660,
        "remark": "https://www.lazada.co.th/products/pdp-i16127166937.html",
        "sold": 0
    },
    {
        "product_name": "Shi Xiang|เครื่องหนีบผมไร้สายพกพาชาร์จผ่าน USB",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S420c2a8047f5473c89e857062dda68509.png_200x200q90.png",
        "price": 1653.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6022156767.html",
        "sold": 5
    },
    {
        "product_name": "WILD 3 กรงเล็บ ตะขอเกี่ยว นержักร 4 กรงเล็บ ปีนป่าย ของใช้สำหรับปีนเขา โครงสร้างเหล็ก ตะขออเนกประสงค์ ปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/1bf814af6f63cb26035884ac371d6561.png_200x200q90.png",
        "price": 1644,
        "remark": "https://www.lazada.co.th/products/pdp-i16121290720.html",
        "sold": 0
    },
    {
        "product_name": "Homerunpet Smart Pet Dryer 135L ▪️ประกันศูนย์ไทย3ปี▪️รุ่นPD135 ตู้เป่าขนสัตว์เลี้ยงขนาดใหญ่ แบบมีล้อ",
        "product_image": "https://img.lazcdn.com/g/p/56cb61f20d15ba0543985b6a86aab4b3.jpg_200x200q90.jpg",
        "price": 47800,
        "remark": "https://www.lazada.co.th/products/pdp-i5911666153.html",
        "sold": 0
    },
    {
        "product_name": "Homerunpet Pet Dryer PD135 ตู้เป่าขนสัตว์เลี้ยง by munkong",
        "product_image": "https://img.lazcdn.com/g/p/680aba5df7e27b9fc92deda6d7298185.jpg_200x200q90.jpg",
        "price": 45980,
        "remark": "https://www.lazada.co.th/products/pdp-i5687344785.html",
        "sold": 0
    },
    {
        "product_name": "HOMERUN | ห้องน้ำแมวอัตโนมัติเติมทรายได้ ขนาดใหญ่พิเศษ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S80843d23cb934abbb55d34dd541055e8x.jpg_200x200q90.jpg",
        "price": 43648,
        "remark": "https://www.lazada.co.th/products/pdp-i16120574193.html",
        "sold": 0
    },
    {
        "product_name": "Homerunpet Smart Litter Box ห้องน้ำแมวอัตโนมัติ ขนาดใหญ่ ระบบเติมทรายอัตโนมัติ ▪️ประกันศูนย์ไทย2ปี▪️",
        "product_image": "https://img.lazcdn.com/g/p/5f8370a5a61ee8a540f2de72d253c11e.jpg_200x200q90.jpg",
        "price": 41980,
        "remark": "https://www.lazada.co.th/products/pdp-i5911691727.html",
        "sold": 0
    },
    {
        "product_name": "PETKIT Purobot Ultra ห้องน้ำแมวอัตโนมัติมาพร้อมกล้อง Ai ตรวตจับแมวอัจฉริยะ ประกันศูนย์ไทย 2 ปี Onsite Service",
        "product_image": "https://img.lazcdn.com/g/p/930f1ab9a30e7cec2b6346a2523d9c97.png_200x200q90.png",
        "price": 39800,
        "remark": "https://www.lazada.co.th/products/pdp-i5430899594.html",
        "sold": 1
    },
    {
        "product_name": "HomeRunPet Drybo Pro Smart Pet Dryer PD80 Pro ตู้เป่าขนสัตว์เลี้ยง ไส้กรอง HEPA 2 ชั้น ความจุ 80 ลิตร รับประกัน 3 ปี",
        "product_image": "https://img.lazcdn.com/g/p/e16f5ec0e96862387c2a8c7099cf788d.png_200x200q90.png",
        "price": 33980,
        "remark": "https://www.lazada.co.th/products/pdp-i5749143517.html",
        "sold": 0
    },
    {
        "product_name": "AiRROBO | กล่องทรายแมวอัจฉริยะขนาดใหญ่พิเศษ พร้อมระบบทำความสะอาดไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S987f1d1c7c104ddaa5f687e50f6266487.jpg_200x200q90.jpg",
        "price": 30278,
        "remark": "https://www.lazada.co.th/products/pdp-i16120732794.html",
        "sold": 0
    },
    {
        "product_name": "PETKIT Pura-MAX PRO 2 ห้องน้ำแมวอัตโนมัติรุ่นโปรพร้อมกล้อง Ai อัจฉริยะ [Global Version] ประกันศูนย์ไทย 2 ปี",
        "product_image": "https://img.lazcdn.com/g/p/a92eea7291985dcccb7e38713799cf68.jpg_200x200q90.jpg",
        "price": 27800,
        "remark": "https://www.lazada.co.th/products/pdp-i5875970051.html",
        "sold": 0
    },
    {
        "product_name": "HATELI การทำความสะอาดด้วยตนเองกล่องทรายแมวอัตโนมัติอัจฉริยะสำหรับ65L ปิดมิดชิดแอปควบคุมกลิ่นเหงื่อขนาดใหญ่กล่องทรายแมวถาดขับถ่ายสัตว์เลี้ยงถาดทรายแมว",
        "product_image": "https://img.lazcdn.com/g/p/1fcd6d960da818ca8fd411e367f88787.jpg_200x200q90.jpg",
        "price": 26860,
        "remark": "https://www.lazada.co.th/products/pdp-i5176463397.html",
        "sold": 0
    },
    {
        "product_name": "โบลเวอร์ เติมอากาศบ่อปลา กุ้ง โบลเวอร์เติม-ดูดอากาศ Ring Blower NORVAX รุ่น NVT-220 3สาย 2.2kW. 2P 380V. ท่อ 2 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/p/9de6766a8004ae5f67da919c22dab294.jpg_200x200q90.jpg",
        "price": 24780,
        "remark": "https://www.lazada.co.th/products/pdp-i5322899434.html",
        "sold": 2
    },
    {
        "product_name": "HATELI กล่องทรายแมวอัตโนมัติ ดับกลิ่นอัตโนมัติ 65 ลิตร พร้อมรีโมทคอนโทรล ควบคุมผ่านแอป กล่องทรายแมวอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/p/aaf9246fd176915b6e92fa5cdc56c79c.jpg_200x200q90.jpg",
        "price": 24550,
        "remark": "https://www.lazada.co.th/products/pdp-i5826429982.html",
        "sold": 0
    },
    {
        "product_name": "[[พร้อมส่ง]] Y192 PETKIT PURA X 2024 (Gobal Version เชื่อมต่อ APPได้ ประกัน2ปี ศูนย์ไทย)   ห้องน้ำแมวอัตโนมัติ [แถมฟรี แผ่นดักทราย+น้ำยากำจัดกลิ่น ]ห้องน้ำแมว",
        "product_image": "https://img.lazcdn.com/g/p/e82ff573ecd96f169908508f5eb99b7a.png_200x200q90.png",
        "price": 23800,
        "remark": "https://www.lazada.co.th/products/pdp-i2330625601.html",
        "sold": 16
    },
    {
        "product_name": "Homerunpet CS106 Self-Cleaning Litter Box White ห้องน้ำแมวอัตโนมัติ by Pro Gadgets",
        "product_image": "https://img.lazcdn.com/g/p/8a47be333e33452540b76e1b4bfccfc1.jpg_200x200q90.jpg",
        "price": 23800,
        "remark": "https://www.lazada.co.th/products/pdp-i5776014334.html",
        "sold": 2
    },
    {
        "product_name": "【DUDUสัตว์เลี้ยง】Cat Castle Catกระบะทรายปิดมิดชิดขนาดใหญ่ห้องน้ำแมวDeodorizationและป้องกันการสาดผลิตภัณฑ์แมวกล่องครอกแมว + ที่นอนแมว",
        "product_image": "https://img.lazcdn.com/g/p/1625ff818c4f15edc1f0fa944517d7dd.jpg_200x200q90.jpg",
        "price": 22686,
        "remark": "https://www.lazada.co.th/products/pdp-i1721918084.html",
        "sold": 2
    },
    {
        "product_name": "AiRROBO | กล่องทรายแมวอัตโนมัติขนาดใหญ่ ป้องกันกระเด็นและกำจัดกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc925510134044ef7a45cdf5f99e8d734U.jpg_200x200q90.jpg",
        "price": 21748,
        "remark": "https://www.lazada.co.th/products/pdp-i16076366150.html",
        "sold": 0
    },
    {
        "product_name": "Pickfun | กล่องทรายแมวอัจฉริยะสำหรับหลายแมว วิเคราะห์สุขภาพ เติมทรายและทำความสะอาดอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8f1302ee3f744247ac125cb8343ca1dbE.jpg_200x200q90.jpg",
        "price": 21430,
        "remark": "https://www.lazada.co.th/products/pdp-i16089470041.html",
        "sold": 0
    },
    {
        "product_name": "Aclium Air Dryer ตู้เป่าขนสัตว์เลี้ยง by munkong",
        "product_image": "https://img.lazcdn.com/g/p/6f4060f3278dacc776da6df55d73403f.jpg_200x200q90.jpg",
        "price": 20700,
        "remark": "https://www.lazada.co.th/products/pdp-i5263238559.html",
        "sold": 2
    },
    {
        "product_name": "Lovinland Pet ถาดรองทรายแมวอัตโนมัติอัจฉริยะ ทำความสะอาดตัวเองได้ ปิดสนิท ตัวกรองประสิทธิภาพสูง ความจุ 65 ลิตร พร้อมระบบดับกลิ่น พร้อมการควบคุมผ่านแอป",
        "product_image": "https://img.lazcdn.com/g/p/30d3f428d5ea5938e269984fa71fa94e.jpg_200x200q90.jpg",
        "price": 19676,
        "remark": "https://www.lazada.co.th/products/pdp-i5821042903.html",
        "sold": 0
    },
    {
        "product_name": "โบลเวอร์ เติมอากาศบ่อปลา กุ้ง โบลเวอร์เติม-ดูดอากาศ  Ring Blower NORVAX รุ่น NVS-150 2สาย 1.5kW. 2P  220V. ท่อ 2 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/p/9de6766a8004ae5f67da919c22dab294.jpg_200x200q90.jpg",
        "price": 18580,
        "remark": "https://www.lazada.co.th/products/pdp-i5322729685.html",
        "sold": 0
    },
    {
        "product_name": "Alectric Pet Smart Cat Litter Box ห้องน้ำแมวอัจฉริยะ เชื่อมแอปฯได้ พร้อมระบบฆ่าเชื้อ รุ่น LB1 -  รับประกัน 3 ปี",
        "product_image": "https://img.lazcdn.com/g/p/7a8f30b5787f4877a2c58ae72453392b.jpg_200x200q90.jpg",
        "price": 17980,
        "remark": "https://www.lazada.co.th/products/pdp-i5107765624.html",
        "sold": 0
    },
    {
        "product_name": "VITAINNO VITA-PET PRO เครื่องกรูมมิ่งสัตว์เลี้ยง 9-in-1 ดูดขนพร้อมเป่าแห้ง 17000PA ปัตตาเลี่ยนไร้สาย หวีตัดแต่งขนสุนัข แมว เสียงเบา",
        "product_image": "https://img.lazcdn.com/g/p/a9b6a7003ec0854831c869f3e30168eb.jpg_200x200q90.jpg",
        "price": 17980,
        "remark": "https://www.lazada.co.th/products/pdp-i16060104590.html",
        "sold": 0
    },
    {
        "product_name": "Petkit | ห้องน้ำแมวอัตโนมัติ ดูดซับกลิ่น ทำความสะอาดเอง ขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S68d54c7ea40c4a1cbd6c6814135b5cb4Q.jpg_200x200q90.jpg",
        "price": 17232,
        "remark": "https://www.lazada.co.th/products/pdp-i16111912587.html",
        "sold": 0
    },
    {
        "product_name": "NEW AGE PET ตู้แมวพร้อมที่นั่ง ซ่อนกระบะทราย ไม่มีกลิ่น ECOFLEX เก็บของได้ ใช้เป็นม้านั่งใส่รองเท้า ดีไซน์มินิมอล",
        "product_image": "https://img.lazcdn.com/g/p/e3277911539d47ed4c91603a2c1f19e6.png_200x200q90.png",
        "price": 15998,
        "remark": "https://www.lazada.co.th/products/pdp-i16125426886.html",
        "sold": 0
    },
    {
        "product_name": "Petkit | อุปกรณ์ให้อาหารสัตว์เลี้ยงอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1920921bc7ee4428ac5e54a210c00ae6i.jpg_200x200q90.jpg",
        "price": 15106,
        "remark": "https://www.lazada.co.th/products/pdp-i16063358239.html",
        "sold": 37
    },
    {
        "product_name": "BAIWO | เครื่องฟอกอากาศพร้อมเก็บขนแมวอัตโนมัติลอยตัว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf313e9ae69834d41a9ed010eb46e7b5dg.jpg_200x200q90.jpg",
        "price": 13286,
        "remark": "https://www.lazada.co.th/products/pdp-i16068731856.html",
        "sold": 0
    },
    {
        "product_name": "โบลเวอร์ เติมอากาศบ่อปลา กุ้ง โบลเวอร์เติม-ดูดอากาศ  Ring Blower NORVAX รุ่น NVT-085 3สาย 0.85kW. 2P 380V. ท่อ 1 1/2 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/p/9de6766a8004ae5f67da919c22dab294.jpg_200x200q90.jpg",
        "price": 13180,
        "remark": "https://www.lazada.co.th/products/pdp-i5322659128.html",
        "sold": 0
    },
    {
        "product_name": "กล่องทรายแมวอัตโนมัติขนาดใหญ่ ป้องกันกลิ่นและทรายกระเด็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scebe3682e45442f2a11bab6a6feca2d2e.png_200x200q90.png",
        "price": 12706,
        "remark": "https://www.lazada.co.th/products/pdp-i16124706741.html",
        "sold": 0
    },
    {
        "product_name": "ทรายแมวเบนโทไนต์ควบคุมกลิ่นสำหรับแมวหลายตัว ไม่มีฝุ่น 2 กล่อง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S34da8d13252e404689f7a0b53938466d9.jpg_200x200q90.jpg",
        "price": 12248,
        "remark": "https://www.lazada.co.th/products/pdp-i16124709059.html",
        "sold": 0
    },
    {
        "product_name": "Ferwa | กล่องทรายแมวอัตโนมัติควบคุมกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbf992009a6c947b0b71b1cc38018422cs.png_200x200q90.png",
        "price": 11994,
        "remark": "https://www.lazada.co.th/products/pdp-i16089075949.html",
        "sold": 0
    },
    {
        "product_name": "HELLOLEIBOO | เครื่องฟอกอากาศสำหรับสัตว์เลี้ยง ดูดขนแมว กำจัดฝุ่น ลดกลิ่น ฆ่าเชื้อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S68a0b79279d446558e789c2a4a125894O.png_200x200q90.png",
        "price": 11484.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5942109878.html",
        "sold": 4
    },
    {
        "product_name": "UPKEYE | ทรายแมวธรรมชาติจากแร่ธาตุ ไม่มีฝุ่น ไม่มีกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S64cac9fbbe294c6985213bdded476f0c7.png_200x200q90.png",
        "price": 11279.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5927588585.html",
        "sold": 50
    },
    {
        "product_name": "[Energetic] กระบะทรายแมวพร้อมฝาปิดถาดใส่กระบะทรายแมวที่ปิดด้านบน",
        "product_image": "https://img.lazcdn.com/g/p/630021913ba0b2d12f31c4f763787536.jpg_200x200q90.jpg",
        "price": 10741.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6019141568.html",
        "sold": 0
    },
    {
        "product_name": "Toshiba | เครื่องฟอกอากาศสำหรับสัตว์เลี้ยง ลดกลิ่นและกำจัดภูมิแพ้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S94fb8ac7bf1f4dc4ae7496816caa828fQ.jpg_200x200q90.jpg",
        "price": 10288,
        "remark": "https://www.lazada.co.th/products/pdp-i16117821541.html",
        "sold": 0
    },
    {
        "product_name": "กรงสัตว์เลี้ยงขนาดใหญ่พื้นโล่ง 150*120*120ซม.",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7bb2f0d7f56b4f729fa1eef029c73181j.jpg_200x200q90.jpg",
        "price": 9800,
        "remark": "https://www.lazada.co.th/products/pdp-i5366472191.html",
        "sold": 0
    },
    {
        "product_name": "กล่องขยะสัตว์เลี้ยงชั้นเดียวขนาดใหญ่ ป้องกันกลิ่นและทำความสะอาดง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfaa5b5718402461e877c162ea88c7f9aL.jpg_200x200q90.jpg",
        "price": 9662,
        "remark": "https://www.lazada.co.th/products/pdp-i16116776055.html",
        "sold": 0
    },
    {
        "product_name": "ที่ครอบไม้กอล์ฟประดับสัตว์เลี้ยงน่ารัก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S411068fd274e4b11aa730c7ce4523b43y.jpg_200x200q90.jpg",
        "price": 9308,
        "remark": "https://www.lazada.co.th/products/pdp-i16122927546.html",
        "sold": 0
    },
    {
        "product_name": "Mango ห้องน้ำแมวอัตโนมัติ 78L ขนาดใหญ่ ห้องน้ำแมวอัจฉริยะ ปลอดภัยไม่หนีบแมว การควบคุมระยะไกล APP มีภาษาไทยรองรับ",
        "product_image": "https://img.lazcdn.com/g/p/92bbd25c572fe3bcd8f18fe59c4d2470.jpg_200x200q90.jpg",
        "price": 9198,
        "remark": "https://www.lazada.co.th/products/pdp-i5992955236.html",
        "sold": 0
    },
    {
        "product_name": "Integrated Litter Box 3-Tier Foldable Cat Kennel Large Space Multi-Level Cat Crate Spacious Interior Pet enclosure Easy to Clean for young cat Owners, Apartment Dwellers, Indoors, Home, Living Room, Bedroom",
        "product_image": "https://img.lazcdn.com/g/p/b0dbe3f5b1175af3dc75b1d37a4957ca.jpg_200x200q90.jpg",
        "price": 9018.78,
        "remark": "https://www.lazada.co.th/products/pdp-i6073678341.html",
        "sold": 0
    },
    {
        "product_name": "ถังทรายแมวอัตโนมัติ [78L] ขนาดใหญ่! ห้องโดยสารตรวจสอบอัตโนมัติ สำหรับแมวสัตว์เลี้ยงทุกสายพันธุ์ ใช้งานง่าย ปลอดภัย มั่นใจให้น้องแมวสะอาดตลอดวัน",
        "product_image": "https://img.lazcdn.com/g/p/db6fea2ca40c98d83853b879b0248cd4.jpg_200x200q90.jpg",
        "price": 8798,
        "remark": "https://www.lazada.co.th/products/pdp-i5989280421.html",
        "sold": 0
    },
    {
        "product_name": "PETX FRESH BOX V.1 เครื่องกำจัดกลิ่นสัตว์เลี้ยง ดับกลิ่นฉี่แมว ฉี่สุนัข กรองขนสัตว์ ฟอกอากาศ PM2.5",
        "product_image": "https://img.lazcdn.com/g/p/c628b376b951bc0240740b7f3f38cb6a.jpg_200x200q90.jpg",
        "price": 8400,
        "remark": "https://www.lazada.co.th/products/pdp-i1760188493.html",
        "sold": 68
    },
    {
        "product_name": "HELLOLEIBOO | เครื่องฟอกอากาศสำหรับสัตว์เลี้ยง กำจัดขนแมวลอยฟ้าอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbc1521b362da4273b992b696015318ee2.png_200x200q90.png",
        "price": 11552.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5960784042.html",
        "sold": 4
    },
    {
        "product_name": "โบลเวอร์ เติมอากาศบ่อปลา กุ้ง โบลเวอร์เติม-ดูดอากาศ  Ring Blower NORVAX รุ่น NVT-020 3สาย 0.2kW. 2P 380V. ท่อ 1 นิ้ว",
        "product_image": "https://img.lazcdn.com/g/p/9de6766a8004ae5f67da919c22dab294.jpg_200x200q90.jpg",
        "price": 9180,
        "remark": "https://www.lazada.co.th/products/pdp-i5322294657.html",
        "sold": 0
    },
    {
        "product_name": "กล่องขยะสำหรับสัตว์เลี้ยงแบบพกพาและใช้แล้วทิ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2be77a9a1e2441f9bf43c83ed1866bdaQ.jpg_200x200q90.jpg",
        "price": 8350,
        "remark": "https://www.lazada.co.th/products/pdp-i16116611335.html",
        "sold": 0
    },
    {
        "product_name": "Automatic Cat Toilet ส้วมแมว ห้องน้ำแมวอัจฉริยะ รองรับแมวหลายตัว ดีไซน์ใหญ่ เชื่อมแอปได้ ห้องน้ำแมวอัต ห้องน้ำแมวอัตโนมัติรุ่น กระบะทราย ห้องน้ำเเมวแบบอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/p/b1b90a320c6860e5a55641a88e6167b7.png_200x200q90.png",
        "price": 8230,
        "remark": "https://www.lazada.co.th/products/pdp-i6071158510.html",
        "sold": 0
    },
    {
        "product_name": "【DUDU Pet】ห้องน้ำแมวกึ่งอัตโนมัติขนาดใหญ่พิเศษชนิดลิ้นชักที่ล้อมรอบกล่องทำความสะอาดเฟอร์นิเจอร์กล่องทรายแมว",
        "product_image": "https://img.lazcdn.com/g/p/4faf8ee94c9485cf1f70ffa54e039278.jpg_200x200q90.jpg",
        "price": 8116,
        "remark": "https://www.lazada.co.th/products/pdp-i2350471001.html",
        "sold": 2
    },
    {
        "product_name": "MULUOZI | กล่องทรายแมวขนาดใหญ่ ควบคุมกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf037ee4b32b546e4959edd61153956fb6.jpg_200x200q90.jpg",
        "price": 8007.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16100923613.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องดูดขนแมวแบบอัตโนมัติเครื่องฟอกอากาศสำหรับสัตว์เลี้ยงกำจัดขนแมวกำจัดกลิ่นเหม็นรสชาติบริสุทธิ์พิเศษสำหรับการเลี้ยงแมว เครื่องฟอกอากาศcat",
        "product_image": "https://img.lazcdn.com/g/p/55a3f49faa47500a140f849134cd8898.jpg_200x200q90.jpg",
        "price": 7998,
        "remark": "https://www.lazada.co.th/products/pdp-i6017519615.html",
        "sold": 1
    },
    {
        "product_name": "DIGITALPET ตู้เป่าขนสัตว์เลี้ยงอัจฉริยะ แรงดูดอันทรงพลัง+ชุดโกนหนวดลมแรงมาก ไดร์เป่าผมสุนัข ตู้เป่าขนแมว ไดร์เป่าผม",
        "product_image": "https://img.lazcdn.com/g/p/902ce5028c0c8fde3677519cb148433e.jpg_200x200q90.jpg",
        "price": 7960,
        "remark": "https://www.lazada.co.th/products/pdp-i16115993566.html",
        "sold": 0
    },
    {
        "product_name": "Lovinland แมวครอกกล่องห้องน้ำกึ่งอัตโนมัติลิ้นชักประเภททำความสะอาดกล่องกึ่งล้อมรอบทำความสะอาดง่ายป้องกันสาดทิปถังกรองเฟอร์นิเจอร์",
        "product_image": "https://img.lazcdn.com/g/p/b41b453f54634fd72f99009fc0b79f26.jpg_200x200q90.jpg",
        "price": 7894,
        "remark": "https://www.lazada.co.th/products/pdp-i4261911583.html",
        "sold": 0
    },
    {
        "product_name": "โปรโมชั่น+ []✨ พร้อมส่ง ห้องน้ำแมว UFO cat litter box ห้องน้ำแมว ห้องน้ำแมวUFO ห้องน้ำแมวอวกาศ ห้องน้ำแมวเหมียวอวกาศ ราคาถูก ห้องน้ำแมว ห้องน้ำแมวทรงโดม มีฝาครอบ ห้องน้ำแมวพับได้  ห้องน้ำแมวพกพา",
        "product_image": "https://img.lazcdn.com/g/p/88a4217ad7a1dfd8c5c9ffc8693a386a.jpg_200x200q90.jpg",
        "price": 7560,
        "remark": "https://www.lazada.co.th/products/pdp-i4702307823.html",
        "sold": 0
    },
    {
        "product_name": "navipet PETKIT Pura Max 2 Cylinder ถังใส่ทรายสำหรับห้องน้ำแมวรุ่น Pura Max2 Maxlite2",
        "product_image": "https://img.lazcdn.com/g/p/3908066f8e548a2c7491b69763c6c7c4.jpg_200x200q90.jpg",
        "price": 7000,
        "remark": "https://www.lazada.co.th/products/pdp-i5977397302.html",
        "sold": 0
    },
    {
        "product_name": "กันน้ำพับเก็บได้สำหรับสัตว์เลี้ยงกล่องทรายแมวกล่องทรายแมว",
        "product_image": "https://img.lazcdn.com/g/p/b39ccc3d0d841bffd163fb6c37afd700.jpg_200x200q90.jpg",
        "price": 6937.98,
        "remark": "https://www.lazada.co.th/products/pdp-i6062347938.html",
        "sold": 0
    },
    {
        "product_name": "หมอนรองนั่งสำหรับสัตว์เลี้ยงกันน้ำ ถอดออกได้ และป้องกันขน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa50fea48ff1b4681a483980ecf795581Z.jpg_200x200q90.jpg",
        "price": 6876,
        "remark": "https://www.lazada.co.th/products/pdp-i16124754123.html",
        "sold": 0
    },
    {
        "product_name": "DIGITALPET PetDryer ควบคุมอุณหภูมิได้การฆ่าเชื้อด้วยไอออนลบ ไดร์เป่าขนสัตว์เลี้ยง ตู้อบแมว เครื่องเป่าขนแมว ตู้เป่าขนแมว",
        "product_image": "https://img.lazcdn.com/g/p/e68f282fec64f3ffcbda5decc1be0639.jpg_200x200q90.jpg",
        "price": 6798,
        "remark": "https://www.lazada.co.th/products/pdp-i16115939927.html",
        "sold": 0
    },
    {
        "product_name": "CHONGXIAOQI | กล่องทรายแมวขนาดใหญ่ป้องกันน้ำกระเด็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S39d883d7fe1b4a2e83e242db1662f8b8m.jpg_200x200q90.jpg",
        "price": 6718,
        "remark": "https://www.lazada.co.th/products/pdp-i16092357327.html",
        "sold": 0
    },
    {
        "product_name": "ทรายแมวเบนโทไนต์ ควบคุมกลิ่นและฝุ่น 12.7 กก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S25bd4cc5dbf44e03bf69a7d557405e79I.jpg_200x200q90.jpg",
        "price": 6500,
        "remark": "https://www.lazada.co.th/products/pdp-i16118589533.html",
        "sold": 0
    },
    {
        "product_name": "ทรายแมวกล่องดำป้ายฟ้า ควบคุมกลิ่น ไม่มีฝุ่น 12.7 กก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S180560316bc24b3e80fa277a2b9d48081.jpg_200x200q90.jpg",
        "price": 6318,
        "remark": "https://www.lazada.co.th/products/pdp-i16120812170.html",
        "sold": 0
    },
    {
        "product_name": "Carpum | กล่องทรายแมวอัตโนมัติขนาดใหญ่กึ่งปิด ป้องกันกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbe18a2e5de364c0b855d271e1ca06b79U.jpg_200x200q90.jpg",
        "price": 6274,
        "remark": "https://www.lazada.co.th/products/pdp-i16111901631.html",
        "sold": 0
    },
    {
        "product_name": "กล่องทรายแมวสองชั้นขนาดใหญ่ พร้อมพื้นที่จัดเก็บด้านบน 86 ซม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0166f87e727942d595b8edea5fe81390j.jpg_200x200q90.jpg",
        "price": 6242.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16103324484.html",
        "sold": 0
    },
    {
        "product_name": "โปรโมชั่น+ MPS Toilette Netta Maxi กระบะทรายแมว และ ห้องน้ำแมว ขนาดใหญ่มาก แมวน้ำหนักมากกว่า6กิโลยังเข้าสบายๆๆ ราคาถูก ห้องน้ำแมว ห้องน้ำแมวทรงโดม มีฝาครอบ ห้องน้ำแมวพับได้  ห้องน้ำแมวพกพา",
        "product_image": "https://img.lazcdn.com/g/p/d20d9fe9e85f3f1be09c2c6e019d95ad.jpg_200x200q90.jpg",
        "price": 6200,
        "remark": "https://www.lazada.co.th/products/pdp-i4702334698.html",
        "sold": 0
    },
    {
        "product_name": "MOMOVIDA Pet Grooming Kit PG1 เครื่องดูดฝุ่นและตัดแต่งขนสัตว์เลี้ยง แรงดูดปรับได้ 3 ระดับ ระดับเสียงรบกวนสูงสุดเพียง 70dBA ความจุ 1.9 ลิตร ง่ายต่อการทำความสะอาด น้ำหนักเบาและเคลื่อนย้ายสะดวก",
        "product_image": "https://img.lazcdn.com/g/p/cbee7a2a674083527f47ea5e65b4bd0b.jpg_200x200q90.jpg",
        "price": 5998,
        "remark": "https://www.lazada.co.th/products/pdp-i5631672611.html",
        "sold": 0
    },
    {
        "product_name": "Aoresac ทำความสะอาดง่ายกล่องห้องน้ำสุนัขสำหรับลูกสุนัขสำหรับฝึกสุนัข",
        "product_image": "https://img.lazcdn.com/g/p/0301382cce42d0c3f7429622efc782a4.jpg_200x200q90.jpg",
        "price": 5982,
        "remark": "https://www.lazada.co.th/products/pdp-i5940621830.html",
        "sold": 0
    },
    {
        "product_name": "กล่องทรายแมวแบบปิดฝาเปิดปิด ขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd8b878dad5a2482db5e28442fad480eaR.jpg_200x200q90.jpg",
        "price": 5974,
        "remark": "https://www.lazada.co.th/products/pdp-i16089340258.html",
        "sold": 0
    },
    {
        "product_name": "โปรโมชั่น+ Unicharm Pet Deo Toilet ห้องน้ำแมว unicharm กระบะทรายแมว ห้องน้ำแมวลดกลิ่น แบบมีฝาครอบ [UN02] ราคาถูก ห้องน้ำแมว ห้องน้ำแมวทรงโดม มีฝาครอบ ห้องน้ำแมวพับได้  ห้องน้ำแมวพกพา",
        "product_image": "https://img.lazcdn.com/g/p/30e3f71a08754a3fe0f08a83b5a4e24a.jpg_200x200q90.jpg",
        "price": 5960,
        "remark": "https://www.lazada.co.th/products/pdp-i4702330616.html",
        "sold": 0
    },
    {
        "product_name": "โปรโมชั่น+ Deo toilet เดโอทอยเล็ท ห้องน้ำแมว ลดกลิ่น จาก Unicharm รุ่น มีฝาครอบ (เปิดได้) ราคาถูก ห้องน้ำแมว ห้องน้ำแมวทรงโดม มีฝาครอบ ห้องน้ำแมวพับได้  ห้องน้ำแมวพกพา",
        "product_image": "https://img.lazcdn.com/g/p/554a5bc126df5c6b515ef5a821c4f935.jpg_200x200q90.jpg",
        "price": 5960,
        "remark": "https://www.lazada.co.th/products/pdp-i4702305838.html",
        "sold": 0
    },
    {
        "product_name": "LP83 กรงไม้ อะคริลิค ขนาดใหญ่ เป็นไม้เกรดA สำหรับสัตว์เลี้ยง หนูแฮมเตอร์ งู เม่น แกสบี้ นก กระต่าย กิ้งก่า เต่า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S08737b6138a64bcfaee6df4029ed300b3.jpg_200x200q90.jpg",
        "price": 5950.56,
        "remark": "https://www.lazada.co.th/products/pdp-i2918291868.html",
        "sold": 4
    },
    {
        "product_name": "Aoresac กล่องพ่นละอองยาสำหรับสัตว์เลี้ยงห้องออกซิเจนสำหรับแมวสุนัขแมว",
        "product_image": "https://img.lazcdn.com/g/p/6e830d7cc1c0ea0669394e0df0cec010.jpg_200x200q90.jpg",
        "price": 5898,
        "remark": "https://www.lazada.co.th/products/pdp-i5940478756.html",
        "sold": 0
    },
    {
        "product_name": "HOOPET | เสาลับเล็บแมว คอนโดแมวสำหรีบปีนป่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc47a5a13c15544e8823023b339dc7757k.jpg_200x200q90.jpg",
        "price": 5880.24,
        "remark": "https://www.lazada.co.th/products/pdp-i5894621776.html",
        "sold": 101
    },
    {
        "product_name": "Ongsee เตียงสำหรับสัตว์เลี้ยงที่นอนสุนัขยกระดับเตียงสัตว์เลี้ยงกรอบเสื่อที่ถอดออกได้เตียงนอนแมวเบาะนอนน้องแมวแบบพกพาสำหรับแมวและลูกสุนัขในร่ม",
        "product_image": "https://img.lazcdn.com/g/p/981d5b0315ec39405e58ca10265346e4.jpg_200x200q90.jpg",
        "price": 5862,
        "remark": "https://www.lazada.co.th/products/pdp-i5850308465.html",
        "sold": 0
    },
    {
        "product_name": "SHANNAIER | รั้วสุนัขและแมวแบบยืดขยายได้ ไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sab3993ee54d24a84b32303d9cfa4198d9.jpg_200x200q90.jpg",
        "price": 5828.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16062411587.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องเป่าขนสัตว์เลี้ยง ตู้อบแมวอัตโนมัติ Pet Dryer Box สำหรับแมวและสุนัข ระบบ PTC อบแห้งเร็ว เสียงเงียบ ควบคุมอุณหภูมิ ตั้งเวลาได้",
        "product_image": "https://img.lazcdn.com/g/p/cf47b0b7f99cda0f8b9b440441f3b79c.png_200x200q90.png",
        "price": 5776,
        "remark": "https://www.lazada.co.th/products/pdp-i16092791302.html",
        "sold": 3
    },
    {
        "product_name": "TAYISHENG | กล่องทรายแมวปิดขนาดใหญ่ป้องกันกลิ่นไม่หกเลอะเทอะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8417d4babb934500b9c38241023ec993O.jpg_200x200q90.jpg",
        "price": 5676,
        "remark": "https://www.lazada.co.th/products/pdp-i16118631369.html",
        "sold": 0
    },
    {
        "product_name": "petsche | กล่องทรายแมวพับได้ขนาดใหญ่พกพาสะดวก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbcbcd8de8843469bb26b3fda074d059fN.jpg_200x200q90.jpg",
        "price": 5600,
        "remark": "https://www.lazada.co.th/products/pdp-i16087247265.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องฟอกอากาศสำหรับสัตว์เลี้ยงดูดขนแมว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S46e228364ac74a23b57a3b6727a595be7.jpg_200x200q90.jpg",
        "price": 2776.84,
        "remark": "https://www.lazada.co.th/products/pdp-i5893812456.html",
        "sold": 1
    },
    {
        "product_name": "Moon OKY อุปกรณ์สำหรับสัตว์เลี้ยงทำจากสแตนเลสสตีลทนทานกล่องทรายแมวสำหรับถาดชำระโลหะทำความสะอาดง่ายแบบพกพาสำหรับแมวเล็กและใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/3d0f644451f619b7410e406bb77361dc.jpg_200x200q90.jpg",
        "price": 5398.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16118708046.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องให้อาหารสัตว์อัตโนมัติ โซล่า(ชุดไก่นอนนา)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdcfef4d24d644f449eb6bc2a68f509c2Y.jpg_200x200q90.jpg",
        "price": 5398,
        "remark": "https://www.lazada.co.th/products/pdp-i4990388407.html",
        "sold": 8
    },
    {
        "product_name": "[MALETKHAO] Catit (แคทอิท) SmartSift​​ ห้องน้ำแมว​คันโยก​ แยกมูลอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/p/989f9f2a0c17412307a4fc7063f5a518.jpg_200x200q90.jpg",
        "price": 5378,
        "remark": "https://www.lazada.co.th/products/pdp-i5039887901.html",
        "sold": 0
    },
    {
        "product_name": "กระบะทรายแมวขนาดใหญ ถาดรองฉแมว ตกแตงบานแมว โถสขภณฑรปยานอวกาศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S83aa0143800347c5b613b4fef6fc42a99.jpg_200x200q90.jpg",
        "price": 5367.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16075007577.html",
        "sold": 0
    },
    {
        "product_name": "สแตนเลสกล่องครอกแมวขนาดใหญ่พิเศษป้องกันการกระเด็นรายการด้านบนโลหะด้านสูงกล่องครอกแมวถาดสำหรับแมวขนาดใหญ่ (สีเทาอ่อน)",
        "product_image": "https://img.lazcdn.com/g/p/070db59323384a1db1f561992fd1abb3.jpg_200x200q90.jpg",
        "price": 5336,
        "remark": "https://www.lazada.co.th/products/pdp-i16120468287.html",
        "sold": 0
    },
    {
        "product_name": "MAVIS LAVEN สแตนเลสกล่องทรายแมวพับได้ปิดมิดชิดครอกพร้อมที่ตักสำหรับร้านขายสัตว์เลี้ยงที่บ้าน (สีชมพูพีช)",
        "product_image": "https://img.lazcdn.com/g/p/56e056de43622d90e4bddc06e4e3e691.jpg_200x200q90.jpg",
        "price": 5230,
        "remark": "https://www.lazada.co.th/products/pdp-i16051961976.html",
        "sold": 0
    },
    {
        "product_name": "KDO แปรงหวีขน สุดยอดสินค้า ถูกสุด PetNeedleComb แปรงหวีขนสัตว์เลี้ยง แปรงขนแมวสุนัข แบบพรีเมี่ยม ที่แปรงขน แปรงหมุดป้องกันการดึงขนน้อง แปรงหวีขนสัตว์ แปรงหวีขนสุนัข",
        "product_image": "https://img.lazcdn.com/g/p/6cd0080a3d3c8d20f804dc1875441184.jpg_200x200q90.jpg",
        "price": 5132,
        "remark": "https://www.lazada.co.th/products/pdp-i3375553225.html",
        "sold": 0
    },
    {
        "product_name": "Catit Smartsift ห้องน้ำแมวคันโยก ห้องน้ำโดมสำหรับแมว Size XL ขนาด 66x48x63 ซม.",
        "product_image": "https://img.lazcdn.com/g/p/d00eabbcfe2f40345e90cf887494be95.jpg_200x200q90.jpg",
        "price": 4998,
        "remark": "https://www.lazada.co.th/products/pdp-i746860107.html",
        "sold": 16
    },
    {
        "product_name": "𝗬𝘂𝗺𝗲' 𝗽𝗿𝗲𝗺𝗶𝘂𝗺 𝗽𝗲𝘁 𝗯𝗲𝗱 ที่นอนสัตว์เลี้ยงมีสไตล์ ที่นอนหมา ที่นอนแมว สไตล์ใหม่",
        "product_image": "https://img.lazcdn.com/g/p/66fb73e730bf3f6a2b429b2750fe873a.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i5069050631.html",
        "sold": 1
    },
    {
        "product_name": "GT90,GT75โต๊ะกรูมมิ่ง,โต๊ะตัดขนสุนัข,พับเก็บได้  แข็งแรงมาก มีด้ามจับหิ้ว เสาโต๊ะยาวถึง 120 ซม. ปรับระดับเสาได้ เสาเหลี่ยมแข็งแรง",
        "product_image": "https://img.lazcdn.com/g/p/ed375f82276a333df5cb279a5f2539ff.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i4374725284.html",
        "sold": 2
    },
    {
        "product_name": "กล่องครอกแมวกึ่งอัตโนมัติ กล่องครอกกึ่งปิดขนาดใหญ่พลาสติกแข็งแรงทนทานสำหรับแมวในร่ม",
        "product_image": "https://img.lazcdn.com/g/p/fbe523a0b9bac0404a86b0b5b28b9157.jpg_200x200q90.jpg",
        "price": 4810,
        "remark": "https://www.lazada.co.th/products/pdp-i16128657512.html",
        "sold": 0
    },
    {
        "product_name": "กล่องครอกแมว Hamwesh การออกแบบที่กว้างขวางด้านข้างสูงป้องกันการรั่วไหลการควบคุมกลิ่นกึ่งปิดกล่องครอกแมวขนาดใหญ่พิเศษพร้อมทำความสะอาดง่ายสำหรับแมวหลาย",
        "product_image": "https://img.lazcdn.com/g/p/88e2f9d822d63c161c6660082f97f80c.jpg_200x200q90.jpg",
        "price": 4810,
        "remark": "https://www.lazada.co.th/products/pdp-i16127753198.html",
        "sold": 0
    },
    {
        "product_name": "Catit SmartSift ห้องน้ำแมว​คันโยก​ แยกมูลอัตโนมัติ​ กระบะทรายแมว เหมาะกับแมวทุกขนาด ทุกสายพันธุ์",
        "product_image": "https://img.lazcdn.com/g/p/bbb0d3a2781fac93b43b621e8d213515.jpg_200x200q90.jpg",
        "price": 4798,
        "remark": "https://www.lazada.co.th/products/pdp-i5862960513.html",
        "sold": 0
    },
    {
        "product_name": "ห้องน้ำแมว​คันโยก​ แยกมูลอัตโนมัติ Catit SmartSift​ รุ่นใหม่สีขาว​ กระบะทรายแมว ส้วมแมว​ ​ของแท้ 100% คุณภาพสูง",
        "product_image": "https://img.lazcdn.com/g/p/6f39f93599c8c1b2676866ca24a6c585.jpg_200x200q90.jpg",
        "price": 4780,
        "remark": "https://www.lazada.co.th/products/pdp-i4295938791.html",
        "sold": 0
    },
    {
        "product_name": "SHENJINGMAO | ทาวเวอร์แมวไม้จริงหลายชั้นประหยัดพื้นที่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sebb8e75358c24483871e63e0aac391a3q.jpg_200x200q90.jpg",
        "price": 4746.28,
        "remark": "https://www.lazada.co.th/products/pdp-i6045912165.html",
        "sold": 6
    },
    {
        "product_name": "Momovida เครื่องให้อาหารและน้ำอัตโนมัติ 2 IN 1 WiFi และแอปควบคุม สำหรับสัตว์เลี้ยง สุนัข แมว รุ่น PTM-30A1",
        "product_image": "https://img.lazcdn.com/g/p/47904583a3ca18c71fd2b31a858d744c.jpg_200x200q90.jpg",
        "price": 4718,
        "remark": "https://www.lazada.co.th/products/pdp-i5977660285.html",
        "sold": 3
    },
    {
        "product_name": "พรมควบคุมขยะสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf1ed685b2a8a400ea4fab61b254f53f1s.jpg_200x200q90.jpg",
        "price": 4612,
        "remark": "https://www.lazada.co.th/products/pdp-i16116582681.html",
        "sold": 0
    },
    {
        "product_name": "GIORGIO ARMANI MALL#[ส่งเร็วจากกทม]กรงสุนัขใหญ่ กรงหมา กรงสุนัข กรงสุนัขท่อเหลี่ยมขนาดใหญ่ กรงสุนัขขนาดใหญ่ แข็งแรง ทนทาน กรงสัตว์เลี้ยง กรงสุนัข พับได้ พร้อมถาดพลาสติก เหมาะสำหรับ สุนัข แมว กระต่าย มอบของขวัญ",
        "product_image": "https://img.lazcdn.com/g/p/92f93f39ad58625e94160b1ec96e2490.jpg_200x200q90.jpg",
        "price": 4590,
        "remark": "https://www.lazada.co.th/products/pdp-i5796563370.html",
        "sold": 1
    },
    {
        "product_name": "ลังแมวแบบพับได้ทำความสะอาดง่ายแบบพกพาวัสดุ PP บ้านสุนัขแบบระบายอากาศได้ติดตั้งง่ายพับเก็บได้สำหรับการเดินป่าสำหรับตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/40e602d3646583d3b0154a420198e77c.jpg_200x200q90.jpg",
        "price": 4590,
        "remark": "https://www.lazada.co.th/products/pdp-i6042918791.html",
        "sold": 0
    },
    {
        "product_name": "Arm & Hammer® Pet Fresh Carpet Odor Eliminator 850 g ผงดูแลพรม ลดกลิ่นสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/p/35c344b456e1ddef1410a9f8e52e3f57.png_200x200q90.png",
        "price": 4570,
        "remark": "https://www.lazada.co.th/products/pdp-i16100361270.html",
        "sold": 0
    },
    {
        "product_name": "Meoof | พรมรองน้ำยาทรายแมวป้องกันการกระเด็น ทำความสะอาดง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb4afeefa834c4388ad6bcd2c80001565M.jpg_200x200q90.jpg",
        "price": 4567.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6054964781.html",
        "sold": 35
    },
    {
        "product_name": "Iris กรงกระต่ายไอริส Iris Rabbit Cage UK650",
        "product_image": "https://img.lazcdn.com/g/p/c1202dce21dfe678aae894ca34133a7b.jpg_200x200q90.jpg",
        "price": 4560,
        "remark": "https://www.lazada.co.th/products/pdp-i3395196011.html",
        "sold": 0
    },
    {
        "product_name": "พรมกันทรายแมว สองชั้น กรองทรายแมว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sad091edb16c24c55980618398bc9b2361.jpg_200x200q90.jpg",
        "price": 4537.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16116552800.html",
        "sold": 0
    },
    {
        "product_name": "NEW AGE PET กระบะทรายแมวสแตนเลส แบบปิดเต็ม ไม่มีกลิ่น ไม่ติดคราบ ล้างง่าย กันทรายกระเด็น ปลอดภัย",
        "product_image": "https://img.lazcdn.com/g/p/8ae090c8c7842cab947a01f419dce7a9.png_200x200q90.png",
        "price": 4398,
        "remark": "https://www.lazada.co.th/products/pdp-i16125425295.html",
        "sold": 0
    },
    {
        "product_name": "Keluojing | กล่องทรายแมวแบบลิ้นชักขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0da4776209ed4aea86bf5ecc4d82a1e3r.png_200x200q90.png",
        "price": 4332.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16062131933.html",
        "sold": 0
    },
    {
        "product_name": "ที่เลี้ยงสุนัขแบบพับได้ ทนทานต่อการกัดของสัตว์เลี้ยง ขนาดกลาง ขนาดเล็ก ที่เลี้ยงแมว ที่เลี้ยงกระต่าย ที่เลี้ยงสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd9ec444ccd22464a8811bb9e1d6a41c75.jpg_200x200q90.jpg",
        "price": 4296,
        "remark": "https://www.lazada.co.th/products/pdp-i5951157745.html",
        "sold": 0
    },
    {
        "product_name": "MAIKAJI | อุปกรณ์พิเศษอัจฉริยะสำหรับกล่องขยะแมว E1 Model",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2de972303ee74722afcedbcff5aae51bG.jpg_200x200q90.jpg",
        "price": 4216,
        "remark": "https://www.lazada.co.th/products/pdp-i16127648486.html",
        "sold": 0
    },
    {
        "product_name": "Cator | ทรายแมวควบคุมกลิ่น ไม่มีฝุ่น ไม่ติดกัน 2.6 กก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S39640287d21f4323ba29e56933fbf6f6j.png_200x200q90.png",
        "price": 4201.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5990922866.html",
        "sold": 23
    },
    {
        "product_name": "โปรโมชั่น+ Unicharm Pet Deo Toilet ห้องน้ำแมว unicharm ห้องน้ำแมวลดกลิ่น แบบไม่มีฝาครอบ [UN01] ราคาถูก ห้องน้ำแมว ห้องน้ำแมวทรงโดม มีฝาครอบ ห้องน้ำแมวพับได้  ห้องน้ำแมวพกพา",
        "product_image": "https://img.lazcdn.com/g/p/c86c54be3532e2cdc003822244ce55ff.jpg_200x200q90.jpg",
        "price": 4200,
        "remark": "https://www.lazada.co.th/products/pdp-i4702344558.html",
        "sold": 0
    },
    {
        "product_name": "cat toilet ห้องน้ำแมว (กึ่งอัตโนมัติ) My monster ของแท้ พลาสติก หนาแข็งแรง สีขาวชมพู/ ใช้ง่ายสะดวกสบายแค่พลิก ไม่ต้องสัมผัสกับปฏิกูลใดๆ ป้องกัน,ยับยั้งแบคทีเรีย กระบะไม่เหลืองดำ นอกจากนั้นยังช่วยประหยัดทรายแมว,ช่วยลดกลิ่นที่ไม่พึงประสงค์ แถมฟรี หมวกแก๊ป",
        "product_image": "https://img.lazcdn.com/g/p/0c0124fa6e9a91485bc448a6101f50aa.jpg_200x200q90.jpg",
        "price": 3998,
        "remark": "https://www.lazada.co.th/products/pdp-i639688283.html",
        "sold": 0
    },
    {
        "product_name": "ห้องน้ำแมว กึ่งอัตโนมัติ (Smartsift) กระบะทราย กระบะทรายแมว - PUPPY KITTENS",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa46b4fb1541940b28f4f29cb46ac4be75.jpg_200x200q90.jpg",
        "price": 4198,
        "remark": "https://www.lazada.co.th/products/pdp-i2806717068.html",
        "sold": 12
    },
    {
        "product_name": "กรงพับได้สำหรับสุนัขและแมวขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S25ae2b3706a5453f83cc646198dbcef6v.jpg_200x200q90.jpg",
        "price": 4106.46,
        "remark": "https://www.lazada.co.th/products/pdp-i6016644102.html",
        "sold": 1
    },
    {
        "product_name": "กล่องทรายแมวป้องกันกระเด็นขนาดใหญ่พิเศษ ขจัดกลิ่น สแตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3b84d810f0a1414d97dd53bbf1175035o.jpg_200x200q90.jpg",
        "price": 4081.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16116766221.html",
        "sold": 0
    },
    {
        "product_name": "ถุงมือกำจัดขนสัตว์เลี้ยงแบบไฟฟ้าสถิต รุ่นอัพเกรดปี 2025, ถุงมือกำจัดขนสัตว์เลี้ยงแบบใช้ซ้ำได้สำหรับแมวและสุนัข, ถุงมือกำจัดขนแมวและสุนัขคุณภาพพรีเมียมสำหรับโซฟา เฟอร์นิเจอร์ พรม และเบาะรถยนต์ (2)",
        "product_image": "https://img.lazcdn.com/g/p/1e2606b0aa341aa1d306ae60250174d4.jpg_webp_200x200q90.jpg",
        "price": 4030.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16080985000.html",
        "sold": 0
    },
    {
        "product_name": "กล่องทรายแมวห้องน้ำแมวชามป้อนอาหารเด็กกันรั่วไหลพลาสติกขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/eef18d73aa1184fc18d1785fac413f8e.jpg_200x200q90.jpg",
        "price": 4016,
        "remark": "https://www.lazada.co.th/products/pdp-i6055506033.html",
        "sold": 0
    },
    {
        "product_name": "CLPOWER | ไดร์เป่าขนสัตว์เลี้ยงพลังสูงเงียบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S62730e53d54843f7b9862f97596de208S.png_200x200q90.png",
        "price": 4014,
        "remark": "https://www.lazada.co.th/products/pdp-i16044605649.html",
        "sold": 0
    },
    {
        "product_name": "Miffer ห้องน้ำทรายแมวแฟชั่นกันน้ำกระเซ็นกับที่ตักลูกแมวทำความสะอาดง่ายสำหรับทรายแมวทุกชนิด",
        "product_image": "https://img.lazcdn.com/g/p/02ec930b2637fdb99e5499dd1f664bed.jpg_200x200q90.jpg",
        "price": 4011.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16128922105.html",
        "sold": 0
    },
    {
        "product_name": "++ของแท้ Sterpet ( 15 แคปซูล ) เนื้องอกมะเร็งจัดการได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se6a8da179ffb400c8cd5d4be0f1ee96cJ.jpg_200x200q90.jpg",
        "price": 4000,
        "remark": "https://www.lazada.co.th/products/pdp-i5208796138.html",
        "sold": 27
    },
    {
        "product_name": "cat toilet ห้องน้ำแมว (กึ่งอัตโนมัติ) My monster ของแท้ พลาสติก หนาแข็งแรง สีขาวครีม/ใช้ง่ายสะดวกสบายแค่พลิก ไม่ต้องสัมผัสกับปฏิกูลใดๆ ป้องกัน,ยับยั้งแบคทีเรีย กระบะไม่เหลืองดำ นอกจากนั้นยังช่วยประหยัดทรายแมว,ช่วยลดกลิ่นที่ไม่พึงประสงค์ แถมฟรี หมวกแก๊ป",
        "product_image": "https://img.lazcdn.com/g/p/1c3a49eadc282d0f1cd4a000c3e6a03f.png_200x200q90.png",
        "price": 3998,
        "remark": "https://www.lazada.co.th/products/pdp-i639572331.html",
        "sold": 0
    },
    {
        "product_name": "Carpum | กล่องทรายแมวป้องกันกลิ่นและไม่เลอะ แบบปิดสนิท",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S34793128b61347e2a102999ea51c31bce.jpg_200x200q90.jpg",
        "price": 3954,
        "remark": "https://www.lazada.co.th/products/pdp-i16111782847.html",
        "sold": 0
    },
    {
        "product_name": "Prettyia แพสระน้ำสำหรับสุนัขลอยน้ำได้เสื่อเป่าลมลอยได้เรือสัตว์เลี้ยงลอยน้ำได้สำหรับเล่นเกมทางน้ำกลางแจ้งในฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/a59b9ee596d0f629c028532ebbf00dab.jpg_200x200q90.jpg",
        "price": 3930.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16071380219.html",
        "sold": 0
    },
    {
        "product_name": "Gaines | แผ่นรองฉี่สัตว์เลี้ยงป้องกันกลิ่นและยับยั้งแบคทีเรีย 10 แผ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S56da1e3da28b4c58afd3d1739ffdad01d.png_200x200q90.png",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i16124964286.html",
        "sold": 0
    },
    {
        "product_name": "(ยกชุด6ใบ) กรงเดินทางสัตว์เลี้ยง ไซส์ L ยกชุด6ใบ เหมาะสำหรับฟาร์มและเพ็ทช๊อป",
        "product_image": "https://img.lazcdn.com/g/p/b39fcd9d885be345eeeb32e1f122cbf4.png_200x200q90.png",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i5362373111.html",
        "sold": 1
    },
    {
        "product_name": "WRA ทิชชู่เปียก แผ่นทำความสะอาด ซื้อ5แถม1 แพ็กใหญ่ ทิชชู่เปียก  ผ้าเปียก เช็ดทำความสะอาดสัตว์เลี้ยง ผ้าเช็ดทำความสะอาด กระดาษทำความสะอาด",
        "product_image": "https://img.lazcdn.com/g/p/50dacfbd767961aad81b0b1680b1eeaf.jpg_200x200q90.jpg",
        "price": 3890,
        "remark": "https://www.lazada.co.th/products/pdp-i5784197211.html",
        "sold": 0
    },
    {
        "product_name": "ถังรีดนมความจุมาก10L สำหรับปศุสัตว์โครงสร้างเหล็กกล้าไร้สนิมกันสนิม",
        "product_image": "https://img.lazcdn.com/g/p/b93359c01dfd4e65bdebe50bd8063687.jpg_200x200q90.jpg",
        "price": 3886.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6014781349.html",
        "sold": 0
    },
    {
        "product_name": "NEW AGE PET กระบะทรายแมวสแตนเลส แบบกึ่งปิด ไม่มีกลิ่น ไม่ติดคราบ ล้างง่าย กันทรายกระเด็น ทนทาน",
        "product_image": "https://img.lazcdn.com/g/p/b52d2797c7e3304da58fca83aa0b0e66.png_200x200q90.png",
        "price": 3798,
        "remark": "https://www.lazada.co.th/products/pdp-i16125594802.html",
        "sold": 0
    },
    {
        "product_name": "Miffer กระโถนแมวสแตนเลสกล่องทิ้งขยะทนทานสำหรับสัตว์เล็ก",
        "product_image": "https://img.lazcdn.com/g/p/ea8adcee17927e8f978cb0038b9e2d41.jpg_200x200q90.jpg",
        "price": 3782.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16118313585.html",
        "sold": 0
    },
    {
        "product_name": "(ยกชุด10ใบ) กรงเดินทางสัตว์เลี้ยงไซส์ m 10ชุด คละสีหูหิ้วขาว เหมาสำหรับฟาร์มและเพ็ทช๊อป",
        "product_image": "https://img.lazcdn.com/g/p/86ba610a9ab8731a80bad8ab8890cba9.png_200x200q90.png",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i5362340141.html",
        "sold": 1
    },
    {
        "product_name": "เสื่อกันน้ำอเนกประสงค์สำหรับให้อาหารแมวเสื่อรองที่เก็บขี้แมวซิลิโคนหนาเสื่อรองที่เก็บขี้แมวทำความสะอาดง่าย",
        "product_image": "https://img.lazcdn.com/g/p/ccf3f629447a20de56799db727fa0666.jpg_200x200q90.jpg",
        "price": 3766,
        "remark": "https://www.lazada.co.th/products/pdp-i16130822869.html",
        "sold": 0
    },
    {
        "product_name": "โปรโมชั่น+ Unicharm Pet Deo toilet เดโอทอยเล็ท ห้องน้ำแมวลดกลิ่น แบบไม่มีฝาครอบ ราคาถูก ห้องน้ำแมว ห้องน้ำแมวทรงโดม มีฝาครอบ ห้องน้ำแมวพับได้  ห้องน้ำแมวพกพา",
        "product_image": "https://img.lazcdn.com/g/p/8fead39ac4f76c8b0c4efe0783219e3f.jpg_200x200q90.jpg",
        "price": 3756,
        "remark": "https://www.lazada.co.th/products/pdp-i4702371414.html",
        "sold": 0
    },
    {
        "product_name": "ตู้กกลูกนก ตู้ฟักไข่ ตู้สำหรับสัตว์เลี้ยง Exotic พ่นยาให้ออกซิเจน",
        "product_image": "https://img.lazcdn.com/g/p/e47eef8d37c8a5a0626c25177b6e845e.jpg_200x200q90.jpg",
        "price": 3750.74,
        "remark": "https://www.lazada.co.th/products/pdp-i2310615638.html",
        "sold": 21
    },
    {
        "product_name": "เครื่องดูดขนสัตว์เลี้ยง Pet Grooming Vacuum Kit เครื่องตัดแต่งขน และดูดฝุ่น สำหรับสัตว์เลี้ยง การตัดแต่งสัตว์เลี้ยง ใช้ได้ทั้งสุนัขและแมว  ดูดซับเส้นขนได้ง่าย",
        "product_image": "https://img.lazcdn.com/g/p/8532a92e7609dfe890b8ac00532aa084.png_200x200q90.png",
        "price": 3714,
        "remark": "https://www.lazada.co.th/products/pdp-i4984645339.html",
        "sold": 145
    },
    {
        "product_name": "กล่องขยะสัตว์เลี้ยงปิดอัตโนมัติแบบครึ่งแมนนวลขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S72b8d65a716a48c780989e654b1efbeet.png_200x200q90.png",
        "price": 3646,
        "remark": "https://www.lazada.co.th/products/pdp-i16112036206.html",
        "sold": 0
    },
    {
        "product_name": "ABEYINUOR | กล่องทรายปิดกั้นกลิ่นขนาดใหญ่พิเศษ ไม่กระเด็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sba7ccd1fea644da980e62bad633873181.jpg_200x200q90.jpg",
        "price": 3646,
        "remark": "https://www.lazada.co.th/products/pdp-i16125593027.html",
        "sold": 0
    },
    {
        "product_name": "AutoBot | กล่องทรายแมวเงียบ ควบคุมทรายถ่านช่วยดับกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S14312ce67d894c1ea657bc368d15e0357.jpg_200x200q90.jpg",
        "price": 3608,
        "remark": "https://www.lazada.co.th/products/pdp-i16120021106.html",
        "sold": 0
    },
    {
        "product_name": "Paw & Pal ผลิตภัณฑ์ทำความสะอาดอเนกประสงค์ สำหรับสัตว์เลี้ยง Pet Multipurpose Cleaner 500ml.",
        "product_image": "https://img.lazcdn.com/g/p/41b73b0813f600fcdcd801fa6a4a5b2f.png_200x200q90.png",
        "price": 3600,
        "remark": "https://www.lazada.co.th/products/pdp-i5377256615.html",
        "sold": 0
    },
    {
        "product_name": "Unicharm Easy-toilet ห้องน้ำแมวลดกลิ่น เก็บกลิ่น อีซี่ทอยเล็ท แบบกว้างสบาย สำหรับแมวตัวใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/fd37765ac6764f16aec9645df7d61f2d.jpg_200x200q90.jpg",
        "price": 3578,
        "remark": "https://www.lazada.co.th/products/pdp-i4166447429.html",
        "sold": 111
    },
    {
        "product_name": "Moon Okey ห้องน้ำสุนัขพร้อมท่อระบายน้ำแบบพกพา",
        "product_image": "https://img.lazcdn.com/g/p/4137bc586d8006547ca93c834e68d0b4.jpg_200x200q90.jpg",
        "price": 3569.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16070900417.html",
        "sold": 0
    },
    {
        "product_name": "โปรโมชั่น+ PETLOVE เครื่องให้น้ำแมวอัตโนมัติ 2 ลิตร โถน้ำแมว วัสดุปลอดภัยไม่มีสนิม มีระบบป้องกันน้ำแห้งไหม้ ราคาถูก ห้องน้ำแมว ห้องน้ำแมวทรงโดม มีฝาครอบ ห้องน้ำแมวพับได้  ห้องน้ำแมวพกพา",
        "product_image": "https://img.lazcdn.com/g/p/906fa88308d87b5f6d1db23b5debd754.jpg_200x200q90.jpg",
        "price": 3560,
        "remark": "https://www.lazada.co.th/products/pdp-i4702417092.html",
        "sold": 0
    },
    {
        "product_name": "ZHONGHENG | กล่องทรายแมวขนาดใหญ่ป้องกันกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scfa51d60e3c3463f8eac602800165b48a.jpg_200x200q90.jpg",
        "price": 3560,
        "remark": "https://www.lazada.co.th/products/pdp-i16089339249.html",
        "sold": 0
    },
    {
        "product_name": "ABEYINUOR | กล่องทรายแมวป้องกันกลิ่นแบบปิด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S00c20411721c4b8dbd9e06f9ad24a61cR.jpg_200x200q90.jpg",
        "price": 3548,
        "remark": "https://www.lazada.co.th/products/pdp-i16141904496.html",
        "sold": 0
    },
    {
        "product_name": "BOBOKALA | กล่องทรายแมวป้องกันกลิ่นและไม่กระเด็น 70 ซม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S267faf11d8564448a1b058f59155cc9dS.png_200x200q90.png",
        "price": 3538,
        "remark": "https://www.lazada.co.th/products/pdp-i16120319187.html",
        "sold": 0
    },
    {
        "product_name": "ABEYINUOR | กล่องทรายแมวขนาดใหญ่กันน้ำและกันกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S95c03ed0ef0e4233aae4debe1a7c434fh.jpg_200x200q90.jpg",
        "price": 3506,
        "remark": "https://www.lazada.co.th/products/pdp-i16141611106.html",
        "sold": 0
    },
    {
        "product_name": "PRYNWAN Pets - Cotton Square Pet Bed ที่นอนสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/p/350cac40fe681b59283dc164c63da237.jpg_200x200q90.jpg",
        "price": 3500,
        "remark": "https://www.lazada.co.th/products/pdp-i5711087565.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องกำจัดกลิ่นกล่องทรายแมวครอกแมวเหมาะสำหรับตู้เสื้อผ้าห้องสัตว์เลี้ยงทุกชนิดตู้รองเท้าห้องครัวห้องน้ำพื้นที่ขนาดเล็กกำจัดกลิ่นและฝุ่นอัจฉริยะ",
        "product_image": "https://img.lazcdn.com/g/p/3b4376515f4a7993af79eb768dbf2e21.png_200x200q90.png",
        "price": 3484,
        "remark": "https://www.lazada.co.th/products/pdp-i4883830480.html",
        "sold": 0
    },
    {
        "product_name": "ไฟฉายความปลอดภัยสำหรับสุนัขเดินกลางคืน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0f0264d4ee694083a97777e17e75f564C.jpg_200x200q90.jpg",
        "price": 3482.32,
        "remark": "https://www.lazada.co.th/products/pdp-i16116615096.html",
        "sold": 0
    },
    {
        "product_name": "กล่องขยะแมวปิดสนิท กันกลิ่น กันน้ำ ป้องกันกระเด็น ขนาดใหญ่พิเศษ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdc40452d347d4cf0bff9a025eed953dfC.jpg_200x200q90.jpg",
        "price": 3482,
        "remark": "https://www.lazada.co.th/products/pdp-i16129428482.html",
        "sold": 0
    },
    {
        "product_name": "TIANDONGLI | กล่องทรายแมวขนาดใหญ่ ป้องกันกลิ่นและป้องกันการหกรั่ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc50402f9ae8e4952a8a3136ce6d9fd6fb.jpg_200x200q90.jpg",
        "price": 3480,
        "remark": "https://www.lazada.co.th/products/pdp-i16089346254.html",
        "sold": 0
    },
    {
        "product_name": "BOBOKALA | กล่องทรายแมวป้องกันกระเด็น ทนต่อการเกิดกลิ่น ขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4ae4eab380764c089f50edc76e9f1836p.jpg_200x200q90.jpg",
        "price": 3466,
        "remark": "https://www.lazada.co.th/products/pdp-i16120816225.html",
        "sold": 0
    },
    {
        "product_name": "[2025 ใหม่] เซิร์ฟเวอร์ลูกบอลอัตโนมัติอัจฉริยะสำหรับสัตว์เลี้ยง เครื่องขว้างลูกบอลฝึก เครื่องขว้างอัตโนมัติ วัสดุเกรดอาหาร เครื่องยิงเทนนิสสำหรับสุนัข ของเล่นแบบโต้ตอบกลางแจ้ง ลูกบอลเด้งสูง สิ่งประดิษฐ์สำหรับเดินสุนัข",
        "product_image": "https://img.lazcdn.com/g/p/50bf93106149570c655d51952248e9cb.jpg_200x200q90.jpg",
        "price": 3460,
        "remark": "https://www.lazada.co.th/products/pdp-i5033640463.html",
        "sold": 28
    },
    {
        "product_name": "กล่องทรายแมวขนาดใหญ่พิเศษ ป้องกันกลิ่นและไม่หกเลอะเทอะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4a1c2e9a1cba48189d47d985b9e7e607q.jpg_200x200q90.jpg",
        "price": 3452,
        "remark": "https://www.lazada.co.th/products/pdp-i16087086814.html",
        "sold": 0
    },
    {
        "product_name": "STXIAOJIZHAI | กล่องทรายแมวขนาดใหญ่พิเศษ สองชั้นแยกส่วน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S97a01a649eab4b7d9d82a9775432e179D.jpg_200x200q90.jpg",
        "price": 3431.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16112335201.html",
        "sold": 0
    },
    {
        "product_name": "ทรายแมวแบบจับตัวเป็นก้อน 5-in-1 ผสม 15.8 ปอนด์, ควบคุมกลิ่นและจับตัวเป็นก้อนได้รวดเร็ว, ดูดซับน้ำและสามารถทิ้งลงชักโครกได้, ปราศจากฝุ่น, เหมาะสำหรับแมวหลายตัว, ทรายแมวเบนโทไนต์เต้าหู้และมันสำปะหลัง, กลิ่นมะลิ, 7.9 ปอนด์/ถุง",
        "product_image": "https://img.lazcdn.com/g/p/424c9f85a35059e71016c018aed6ed34.jpg_webp_200x200q90.jpg",
        "price": 3423,
        "remark": "https://www.lazada.co.th/products/pdp-i16081277283.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องให้อาหารสัตว์ อัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc92816000b524d31a938bca7fa0800eah.jpg_200x200q90.jpg",
        "price": 3398,
        "remark": "https://www.lazada.co.th/products/pdp-i4910650462.html",
        "sold": 8
    },
    {
        "product_name": "DIGITALPETSmart Pet Feederแอปควบคุมอัจฉริยะแหล่งจ่ายไฟคู เครื่องให้อาหารแมวอัตโนมัติ ที่ให้อาหารสัตว์อัตโนมัติ ประกัน2ปี",
        "product_image": "https://img.lazcdn.com/g/p/2aa28cfc6e81c08cfed502731ed64b1a.jpg_200x200q90.jpg",
        "price": 3398,
        "remark": "https://www.lazada.co.th/products/pdp-i16116156391.html",
        "sold": 0
    },
    {
        "product_name": "บ้านสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S66257033650e435e8865b068c67dee13V.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i5214693948.html",
        "sold": 1
    },
    {
        "product_name": "สเปร์ยขจัดคราบบนขนสุนัข/แมว PURE PAWS - BIO-ENZYMATIC PRETREATMENT SPRAY, STAIN REMOVER, 16 OZ",
        "product_image": "https://img.lazcdn.com/g/p/d2916072311d6835ae67320c889e9d2f.jpg_200x200q90.jpg",
        "price": 3370,
        "remark": "https://www.lazada.co.th/products/pdp-i299408100.html",
        "sold": 0
    },
    {
        "product_name": "Puang | ชั้นเก็บอาหารสัตว์เลี้ยงหลายชั้น ทำจากเหล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7068162c8d114c9187edadb239dfc41ea.jpg_200x200q90.jpg",
        "price": 3348,
        "remark": "https://www.lazada.co.th/products/pdp-i5949715292.html",
        "sold": 0
    },
    {
        "product_name": "Pet Toilet Odor Purifier Smart for Cat for Cat Litter Box Deodorizer Dog for Cat Litter Deodorant",
        "product_image": "https://img.lazcdn.com/g/p/a45302d713e78807e0f2730f60937d95.jpg_200x200q90.jpg",
        "price": 3346,
        "remark": "https://www.lazada.co.th/products/pdp-i5911624047.html",
        "sold": 0
    },
    {
        "product_name": "ชุดปลูกหญ้าแมว MUJI จำนวน2ชิ้น47879612 (X 5)",
        "product_image": "https://img.lazcdn.com/g/p/5e2800b347a7e1d38215fbb562ff3497.png_200x200q90.png",
        "price": 3340,
        "remark": "https://www.lazada.co.th/products/pdp-i16119667455.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องกำจัดกลิ่นสัตว์เลี้ยงอัจฉริยะสำหรับอ่างอาบน้ำแมวและสุนัขกล่องทิ้งขยะเครื่องกำจัดกลิ่นสุนัขตัวฟอกอากาศชาร์จได้สำหรับสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/p/ef1beede60602c8c1edb075ebedb0fa9.jpg_200x200q90.jpg",
        "price": 3330,
        "remark": "https://www.lazada.co.th/products/pdp-i4873744165.html",
        "sold": 0
    },
    {
        "product_name": "YIFANGJIAYI | ชั้นเก็บของหลายฟังก์ชันสำหรับอุปกรณ์สัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S83bd11551fbd47bfb82162bd8609928fV.jpg_200x200q90.jpg",
        "price": 3328.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16145543547.html",
        "sold": 0
    },
    {
        "product_name": "ไดร์เป่าขนสัตว์ รุ่นใหม่ไดร์ขนสุนัข ไดร์เป่าขนแมว เครื่องเป่าขน ไดร์ไล่น้ำ สินค้าพร้อมส่งในไทย",
        "product_image": "https://img.lazcdn.com/g/p/4ff5e338d1169b64fddf9e3f57c9b88a.png_200x200q90.png",
        "price": 3312,
        "remark": "https://www.lazada.co.th/products/pdp-i4181585039.html",
        "sold": 0
    },
    {
        "product_name": "ปลอกคลุมไม้กอล์ฟลายสุนัขจมูกใหญ่สุดน่ารัก, ปลอกคลุมหัวไม้ไดรเวอร์, ปลอกคลุมไม้กอล์ฟขนาดเล็ก, อุปกรณ์เสริมกอล์ฟ",
        "product_image": "https://img.lazcdn.com/g/p/ec43948bc364ef793325ac816ff9f6c2.jpg_webp_200x200q90.jpg",
        "price": 3298.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16147378726.html",
        "sold": 0
    },
    {
        "product_name": "Dolity ที่ขัดฟัน Scaler เครื่องไล่แมวสัตว์",
        "product_image": "https://img.lazcdn.com/g/p/493f0c7373964a7d893e1e86a74c60cd.jpg_200x200q90.jpg",
        "price": 3262,
        "remark": "https://www.lazada.co.th/products/pdp-i6030932936.html",
        "sold": 0
    },
    {
        "product_name": "Gazechimp เครื่องไล่หนู/งูด้วยคลื่นอุลตร้าโซนิกนกนกกระสาแมวยับยั้ง",
        "product_image": "https://img.lazcdn.com/g/p/73f3be80afee363a8769ec9f7d943de4.jpg_200x200q90.jpg",
        "price": 3262,
        "remark": "https://www.lazada.co.th/products/pdp-i6055436794.html",
        "sold": 0
    },
    {
        "product_name": "BOBOKALA | กล่องทรายแมวป้องกันหก แบบมีฝาปิด ขนาดใหญ่พิเศษ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S64202ac6d17a45478c611d996b4eb7c0M.jpg_200x200q90.jpg",
        "price": 3242,
        "remark": "https://www.lazada.co.th/products/pdp-i16120732225.html",
        "sold": 0
    },
    {
        "product_name": "FUNNYDEER | ที่ขับถ่ายสุนัขอัตโนมัติพร้อมกำจัดของเสีย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8e9f59dc2cf7466bb7521e1d9f0d5ccfS.jpg_200x200q90.jpg",
        "price": 3223.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16052511112.html",
        "sold": 0
    },
    {
        "product_name": "Unicharm Easy-toilet อีซี่ทอยเล็ท ห้องน้ำแมวลดกลิ่น เก็บกลิ่น แบบมีฝาครอบ (พร้อมรีฟิล)",
        "product_image": "https://img.lazcdn.com/g/p/aee2f95330ebb88f2d64e841e411dcb9.jpg_200x200q90.jpg",
        "price": 3212,
        "remark": "https://www.lazada.co.th/products/pdp-i4936582141.html",
        "sold": 0
    },
    {
        "product_name": "ถุงมือกำจัดขนสัตว์เลี้ยง YomiHair Remover รุ่นอัพเกรดปี 2025 ถุงมือกำจัดขนสัตว์เลี้ยงด้วยไฟฟ้าสถิต ถุงมือกำจัดขนสัตว์เลี้ยงแบบสองด้าน ใช้ซ้ำได้สำหรับแมวและสุนัข (2 ชิ้น)",
        "product_image": "https://img.lazcdn.com/g/p/f3c031e1d3934d1eebcb4a505a56377f.jpg_webp_200x200q90.jpg",
        "price": 3211.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16081275306.html",
        "sold": 0
    },
    {
        "product_name": "บูสเตอร์เบาะนั่งสัตว์เลี้ยงที่สะดวกสบายพร้อมแผ่นซับน้ำสองด้านและปกสะอาดสุนัขได้ง่าย",
        "product_image": "https://img.lazcdn.com/g/p/6ef96b92272145ebdfa8879336e41f28.jpg_200x200q90.jpg",
        "price": 3202.74,
        "remark": "https://www.lazada.co.th/products/pdp-i6004399611.html",
        "sold": 0
    },
    {
        "product_name": "Taigepets | กล่องทรายแมวป้องกันกระเด็น ปิดสนิท ป้องกันกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc41cf1229ae341e082b5ea2069f96f14x.jpg_200x200q90.jpg",
        "price": 3199.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16092186111.html",
        "sold": 32
    },
    {
        "product_name": "เครื่องให้อาหารอัตโนมัติ สุนัขเม็ดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2d578fae296e47e5897765818cfbae80f.jpg_200x200q90.jpg",
        "price": 3198,
        "remark": "https://www.lazada.co.th/products/pdp-i5085107675.html",
        "sold": 3
    },
    {
        "product_name": "เครื่องให้อาหารสุนัขเม็ดใหญ่ อัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S199a0a3c372942439cd163b48c99dea0Z.jpg_200x200q90.jpg",
        "price": 3198,
        "remark": "https://www.lazada.co.th/products/pdp-i5042051179.html",
        "sold": 1
    },
    {
        "product_name": "กรงสุนัขใหญ่ กรงหมา รับน้ำหนักได้ 10-100KG ใช้งานนาน 10 ปี ไม่พัง เหมาะสำหรับสุนัข แมว และกระต่าย กรงกระต่าย กรงแมวแบบใหญ่ กรงเหล็กมีถาดรองรับ",
        "product_image": "https://img.lazcdn.com/g/p/c2262d6d088b8f7d76ba7a3638cdc9df.jpg_200x200q90.jpg",
        "price": 3178,
        "remark": "https://www.lazada.co.th/products/pdp-i5808404936.html",
        "sold": 10
    },
    {
        "product_name": "[12แถม1] Pramie แผ่นเช็ดทำความสะอาดสำหรับสัตว์เลี้ยง สูตรซิลเวอร์ไอออน กลิ่นสปา แพ็คใหญ่ 80 แผ่น 20x20 ซม.",
        "product_image": "https://img.lazcdn.com/g/p/c7b55cdb4e6eb86a819b7ff8fdf6cd83.jpg_200x200q90.jpg",
        "price": 3160,
        "remark": "https://www.lazada.co.th/products/pdp-i16110428290.html",
        "sold": 0
    },
    {
        "product_name": "Sukina Petto Pet Wipes 70 sheet (6 Packs) ผ้าเปียก สำหรับ เช็ดทำความสะอาด สุนัข แมว และสัตว์เลี้ยง 70 แผ่น (แพ๊ค 6 ห่อ)",
        "product_image": "https://img.lazcdn.com/g/p/2595d531b04801b3896092fc5e1bc3ee.jpg_200x200q90.jpg",
        "price": 3147.6,
        "remark": "https://www.lazada.co.th/products/pdp-i3481355847.html",
        "sold": 0
    },
    {
        "product_name": "ทรายแมวคอสมกแคท ชนดละเอยด กลนยฟанг (AK453) 6 กก. 3 ถง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S64dcd7a832144fb8b16f7b90cf07c815u.png_200x200q90.png",
        "price": 3135.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6026222158.html",
        "sold": 0
    },
    {
        "product_name": "ทรายแมวคอสมกแคท ชนดละเอยดพเศษ ไรกลน (AK452) 6 กก. 3 ถง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S25ea0bd7cd944333a0c4ba75bc2fec5eh.png_200x200q90.png",
        "price": 3135.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6026222152.html",
        "sold": 0
    },
    {
        "product_name": "แล็บ โค. โปรไบโอติกส์สำหรับสัตว์เลี้ยงเพื่อการลดอาการแพ้และเสริมสร้างภูมิคุ้มกัน - ช่วยบรรเทาอาการแพ้ตามฤดูกาล - ส่งเสริมสุขภาพลำไส้และระบบย่อยอาหาร - รสหมู - 30 เม็ดเคี้ยวแบบนิ่ม - บรรจุภัณฑ์อาจแตกต่างกัน",
        "product_image": "https://img.lazcdn.com/g/p/828b00f16234f65c49d1f0d1c27964b1.jpg_webp_200x200q90.jpg",
        "price": 3132.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16145056057.html",
        "sold": 0
    },
    {
        "product_name": "MAIKAJI | อุปกรณ์สำหรับกล่องทรายแมวอัจฉริยะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4c216c67a4644d2e9deb72cab7a70ef9Q.jpg_200x200q90.jpg",
        "price": 3124,
        "remark": "https://www.lazada.co.th/products/pdp-i16132554575.html",
        "sold": 0
    },
    {
        "product_name": "MAISHILANG | ของเล่นสุนัขหุ่นยนต์ AI ฉลาด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6ce7353eb33b4810915c0871e10b7f67U.jpg_200x200q90.jpg",
        "price": 3116.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16117996116.html",
        "sold": 0
    },
    {
        "product_name": "Carpum | กล่องทรายแมวขนาดใหญ่สองชั้นป้องกันการหกรั่ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc5bafceec2074ab48592173cfdbd847cw.jpg_200x200q90.jpg",
        "price": 3110,
        "remark": "https://www.lazada.co.th/products/pdp-i16111900630.html",
        "sold": 0
    },
    {
        "product_name": "แท่นวางแมวแบบแข็งด้านข้างพับได้กระเป๋าใส่สัตว์เลี้ยงเดินทางมือจับด้านบน4ด้านมีช่องระบายอากาศแข็งแรงทนทานสำหรับการเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/84b5628aa6af52686e92d5453c064dad.jpg_200x200q90.jpg",
        "price": 3106,
        "remark": "https://www.lazada.co.th/products/pdp-i6044694169.html",
        "sold": 0
    },
    {
        "product_name": "Asixxsix กล่องครอกแมวขนาดใหญ่พิเศษ Proof กล่องครอกสแตนเลสด้านสูงโลหะพร้อมที่ตักสำหรับแมวหลายตัว (ขนาดใหญ่พิเศษ 32.7 X 24.4 X 31.5 นิ้ว)",
        "product_image": "https://img.lazcdn.com/g/p/d88eb8b306e61dd21aa9702a7604b820.jpg_200x200q90.jpg",
        "price": 3104,
        "remark": "https://www.lazada.co.th/products/pdp-i16129090325.html",
        "sold": 0
    },
    {
        "product_name": "AFP กระบะทรายแมวพับได้ สีเทา",
        "product_image": "https://img.lazcdn.com/g/p/53f245e0ef40daa4fd10da34c6bde3d1.jpg_200x200q90.jpg",
        "price": 3098,
        "remark": "https://www.lazada.co.th/products/pdp-i5497595747.html",
        "sold": 0
    },
    {
        "product_name": "AFP กระบะทรายแมวแบบพับได้",
        "product_image": "https://img.lazcdn.com/g/p/67b6a4cf3c5ac2a2873b742ad03c8088.jpg_200x200q90.jpg",
        "price": 3098,
        "remark": "https://www.lazada.co.th/products/pdp-i5497815622.html",
        "sold": 0
    },
    {
        "product_name": "ถังรีดนมความจุมากสำหรับปศุสัตว์โครงสร้างเหล็กกล้าไร้สนิมกันสนิม",
        "product_image": "https://img.lazcdn.com/g/p/77519e8d9a370271deba893b4f487a70.jpg_200x200q90.jpg",
        "price": 3096.96,
        "remark": "https://www.lazada.co.th/products/pdp-i6014733817.html",
        "sold": 0
    },
    {
        "product_name": "[12แถม1] Pramie แผ่นเช็ดทำความสะอาดสำหรับสัตว์เลี้ยง สูตรไม่มีน้ำหอม แพ็คใหญ่ 80 แผ่น 20x20 ซม. ย่อยสลายได้ 12แถม1 แพ็ค",
        "product_image": "https://img.lazcdn.com/g/p/2058af76d6034e8fba515235ac366e1f.jpg_200x200q90.jpg",
        "price": 3096,
        "remark": "https://www.lazada.co.th/products/pdp-i5724353360.html",
        "sold": 0
    },
    {
        "product_name": "[12แถม1] Pramie แผ่นเช็ดทำความสะอาดสำหรับสัตว์เลี้ยง สูตรกลิ่นคาโมมายล์ แพ็คใหญ่ 80 แผ่น 20x20 ซม. ย่อยสลายได้ 12แถม1",
        "product_image": "https://img.lazcdn.com/g/p/97b36f6bbae33453e072d6ed718352d3.jpg_200x200q90.jpg",
        "price": 3096,
        "remark": "https://www.lazada.co.th/products/pdp-i5724205888.html",
        "sold": 0
    },
    {
        "product_name": "BOBOKALA | กล่องทรายแมวขนาดใหญ่ป้องกันการหกรั่ว 80 ซม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd973093ca5fa464eab808ab99908546cY.jpg_200x200q90.jpg",
        "price": 3082,
        "remark": "https://www.lazada.co.th/products/pdp-i16120478776.html",
        "sold": 0
    },
    {
        "product_name": "PETBLEE | กล่องขยะสัตว์เลี้ยงขนาดใหญ่ ป้องกันการกระเด็น สแตนเลสแบบมีขอบสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa7267ea192404d1987bdfe05b271be10v.jpg_200x200q90.jpg",
        "price": 3082,
        "remark": "https://www.lazada.co.th/products/pdp-i16090661487.html",
        "sold": 0
    },
    {
        "product_name": "Pet Blanket Sofa Pet Waterproof & Anti-Slip Dog Bed Cover and Bed Mat Incontinence Mattress Protectors Furniture",
        "product_image": "https://img.lazcdn.com/g/p/a7614dab01fc797f6b7778219af844b8.jpg_200x200q90.jpg",
        "price": 3076,
        "remark": "https://www.lazada.co.th/products/pdp-i6046622688.html",
        "sold": 0
    },
    {
        "product_name": "ชุดกรูมมิ่งการดูแลสัตว์เลี้ยงใหม่ 7-in-1 เครื่องโกนหนวดแมวและสุนัขมัลติฟังก์ชั่นผมผลักดันและหวีเครื่องดูดฝุ่นไฟฟ้าครัวเรือนแมวทําความสะอาดผม",
        "product_image": "https://img.lazcdn.com/g/p/1b99f7ab38ae9af44728a1ce22fe43bd.jpg_200x200q90.jpg",
        "price": 3066,
        "remark": "https://www.lazada.co.th/products/pdp-i5401395489.html",
        "sold": 1
    },
    {
        "product_name": "กล่องครอกสุนัขหญ้าสุนัขกระโถนสุนัขกระโถนหญ้าพรมทนทานหลายหลุมด้านล่างสำหรับอพาร์ทเมนท์",
        "product_image": "https://img.lazcdn.com/g/p/50c270b2d132180ef6d69f062696bf67.jpg_200x200q90.jpg",
        "price": 3057.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16125120996.html",
        "sold": 0
    },
    {
        "product_name": "ถุงมือกำจัดขนสัตว์เลี้ยง - ถุงมือกำจัดขนสัตว์เลี้ยงแบบไฟฟ้าสถิตรุ่นใหม่ปี 2025, ถุงมือกรูมมิ่งสัตว์เลี้ยงแบบสองด้านที่ล้างทำความสะอาดได้และนำกลับมาใช้ใหม่ได้ สำหรับโซฟา, เสื้อผ้า, เฟอร์นิเจอร์, พรม, เบาะรถยนต์ (2 ชิ้น)",
        "product_image": "https://img.lazcdn.com/g/p/e60a591059402d5de4c8159ca8eeb7dc.jpg_webp_200x200q90.jpg",
        "price": 3049.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16081233741.html",
        "sold": 0
    },
    {
        "product_name": "LORDE | ทรายแมวถั่วเหลืองดับกลิ่นและฆ่าเชื้อ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3bc055c3e9c745c5b824508a1979f440G.png_200x200q90.png",
        "price": 3047.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5935411224.html",
        "sold": 9
    },
    {
        "product_name": "zeze | ที่นอนสัตว์เลี้ยง โซฟาสัตว์เลี้ยง นุ่ม ซักได้ ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S734500442e5c4b2680afa306284520c8j.png_200x200q90.png",
        "price": 3020.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5914275983.html",
        "sold": 127
    },
    {
        "product_name": "Decopark | กล่องทรายแมวป้องกันกระเด็นขนาดใหญ่พิเศษ ควบคุมกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfde2813bdba84227a3ed0fea56375b692.png_200x200q90.png",
        "price": 3018,
        "remark": "https://www.lazada.co.th/products/pdp-i16087151760.html",
        "sold": 0
    },
    {
        "product_name": "กรงแมวอเนกประสงค์ระบายอากาศได้แบบพกพาพับเก็บได้เต็นท์แมวน้ำหนักเบาสำหรับสัตว์ขนาดเล็กอื่นๆ",
        "product_image": "https://img.lazcdn.com/g/p/401c223343b29ccb0fdd33b8268d3b5a.jpg_200x200q90.jpg",
        "price": 3016,
        "remark": "https://www.lazada.co.th/products/pdp-i6038308372.html",
        "sold": 0
    },
    {
        "product_name": "กล่องทรายแมวขนาดใหญ่พิเศษ พร้อมแผ่นกันกระเด็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S09351ea2b3864702874b524e93609c71M.jpg_200x200q90.jpg",
        "price": 3008,
        "remark": "https://www.lazada.co.th/products/pdp-i6028827187.html",
        "sold": 0
    },
    {
        "product_name": "[เซ็ตสุดคุ้ม] Unicharm Pet เซ็ตสุดคุ้ม สำหรับ 4 เดือน อีซี่ทอยเล็ท ทรายแมวลดกลิ่น แบบรีฟิล 4 ลิตร, 3.8 ลิตร x2 แพ็ค  + อีซี่ทอยเล็ท ชีท x2 แพ็ค",
        "product_image": "https://img.lazcdn.com/g/p/0487f7bd39a4c3003b1d121232a08d0c.jpg_200x200q90.jpg",
        "price": 3000,
        "remark": "https://www.lazada.co.th/products/pdp-i4304332444.html",
        "sold": 181
    },
    {
        "product_name": "Pet Soft ผ้าเปียกทำความสะอาดสำหรับสุนัข (ยกลัง 24 ห่อ) ทำความสะอาดสิ่งสกปรก เพิ่มความเงางามให้เส้นขน กลิ่นแอปเปิ้ล",
        "product_image": "https://img.lazcdn.com/g/p/9f8cc8be8b7353018d0ea52c24bd076b.jpg_200x200q90.jpg",
        "price": 2998,
        "remark": "https://www.lazada.co.th/products/pdp-i4867598680.html",
        "sold": 0
    },
    {
        "product_name": "iKKLE กรงสุนัขขนาดกลางถึงใหญ่ ทำจากท่อเหล็กสี่เหลี่ยมเสริมแรง มีช่องแสงด้านบนแบบโต้ตอบได้ ประตูสำหรับให้อาหาร และถาดพีวีซีสองถาด",
        "product_image": "https://img.lazcdn.com/g/p/cc6673e95e61469b19330e21e2ba7cea.png_200x200q90.png",
        "price": 2998,
        "remark": "https://www.lazada.co.th/products/pdp-i6072556178.html",
        "sold": 9
    },
    {
        "product_name": "PAIPAIMAO | กล่องทรายแมวแบบฝาเปิดปิดพร้อมขอบกันกระเด็น ขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfe05010909ef4e3daa46c25f09e2fcd7Z.jpg_200x200q90.jpg",
        "price": 2990,
        "remark": "https://www.lazada.co.th/products/pdp-i16127387200.html",
        "sold": 0
    },
    {
        "product_name": "โซฟาลอยน้ำแบบสูบลมสุนัขแบบพกพาสำหรับแม่น้ำทะเลสาบสระฤดูร้อนปาร์ตี้อาบแดดของเล่นแพยางพองลมสุนัขขนาดกลางถึงใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/879247e08333a255127758c1ead624eb.jpg_200x200q90.jpg",
        "price": 2988,
        "remark": "https://www.lazada.co.th/products/pdp-i6010262685.html",
        "sold": 0
    },
    {
        "product_name": "‼️พร้อมส่ง‼️คอกไม้สำหรับกระต่าย คอกสัตว์เลี้ยง แกสบี้ ชินชิล่า แพรี่ด็อก หมา แมว สัตว์เลี้ยงขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/p/5479d28262a7c7c738cab8549273da61.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i4666488441.html",
        "sold": 3
    },
    {
        "product_name": "เม็ดโรยทรายแมว ที่ดับกลิ่นทรายแมว ผงโรยทรายแมว ดับกลิ่นขี้แมว เม็ดดับกลิ่น Cat เม็ดหอมลดกลิ่นสำหรับทรายแมว Unicharm Pet กลิ่น Natural soap 450ml. (3ขว",
        "product_image": "https://img.lazcdn.com/g/p/3ba86b162d14c6330bc133d8567eb7ee.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i3359445138.html",
        "sold": 0
    },
    {
        "product_name": "PETBLEE | กล่องทรายแมวขนาดใหญ่แบบกึ่งปิด สแตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S31fc47c68a284fb99275dc05b6127249j.jpg_200x200q90.jpg",
        "price": 2976,
        "remark": "https://www.lazada.co.th/products/pdp-i16090617169.html",
        "sold": 0
    },
    {
        "product_name": "ABEYINUOR | กล่องทรายแมวป้องกันกลิ่นแบบปิดสนิท ขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se75497184bd345df8564335524c98c8dt.jpg_200x200q90.jpg",
        "price": 2974,
        "remark": "https://www.lazada.co.th/products/pdp-i16125505328.html",
        "sold": 0
    },
    {
        "product_name": "กล่องทรายแมวป้องกันกลิ่น ขนาดใหญ่ ป้องกันการกระเด็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0631ddbc5d1840e1a9254bd8da6552fdR.jpg_200x200q90.jpg",
        "price": 2939.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16102753573.html",
        "sold": 0
    },
    {
        "product_name": "ทบคอง콩 ทรายแมวสตรออรจนล ไมโครไฟเบอร (AK667) 2.8 กก. 6 ชน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sea051ce01fd640f98b3d680c39c76458C.png_200x200q90.png",
        "price": 2930.94,
        "remark": "https://www.lazada.co.th/products/pdp-i6026146295.html",
        "sold": 0
    },
    {
        "product_name": "PAIPAIMAO | กล่องทรายแมวป้องกันกระเด็นแบบใส่จากด้านบน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdd5e4dd833354bcbac00ada88d231b4ff.jpg_200x200q90.jpg",
        "price": 2904,
        "remark": "https://www.lazada.co.th/products/pdp-i16140098632.html",
        "sold": 0
    },
    {
        "product_name": "2.2N5คอกหมา กรงหมา คอกกั้นสัตว์เลี้ยงขนาดเล็ก รุ่นXXL ขนาด 200cm X 200cm X 52cm รุ่นไม่มีประตู",
        "product_image": "https://img.lazcdn.com/g/p/6255a6912873448c65d89fc5db3d7990.png_200x200q90.png",
        "price": 2900,
        "remark": "https://www.lazada.co.th/products/pdp-i2106508629.html",
        "sold": 19
    },
    {
        "product_name": "[PETClub] Unicharm Pet ห้องน้ำแมวลดกลิ่น Deo-toilet (เดโอทอยเล็ท) แบบมีฝาครอบ (ฟรีแผ่นรองซับ 1 แพ็ค และทรายแมว 2 ลิตร ในกล่อง)",
        "product_image": "https://img.lazcdn.com/g/p/abed95a7263d84b9cff6ba7408f0b98e.jpg_200x200q90.jpg",
        "price": 2900,
        "remark": "https://www.lazada.co.th/products/pdp-i331900403.html",
        "sold": 3
    },
    {
        "product_name": "WRA ทิชชู่เปียก แผ่นทำความสะอาด ทิชชู่เปียกสัตว์เลี้ยง ผ้าเปียกเช็ดตัว สูตรคาโมมายล์ ช่วยยับยั้งแบคทีเรีย สำหรับสุนัขและแมว ผ้าเช็ดทำความสะอาด กระดาษทำความสะอาด",
        "product_image": "https://img.lazcdn.com/g/p/0ee8a5ac27d45f438fd594b51f3d578d.jpg_200x200q90.jpg",
        "price": 2878,
        "remark": "https://www.lazada.co.th/products/pdp-i5783934947.html",
        "sold": 0
    },
    {
        "product_name": "MLZH | กรงสัตว์เลี้ยงอัตโนมัติสำหรับไข่กลิ้ง ขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6f776c494c744904bb87dc541f14300eg.jpg_200x200q90.jpg",
        "price": 2868.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16094613992.html",
        "sold": 0
    },
    {
        "product_name": "Yeasa | ทรายแมวถั่วเหลืองสีรุ้ง กลิ่นหอม ฝุ่นน้อย เกาะตัวเป็นก้อนอนุภาคเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S59fd7dcd14e94dabbe9624eb26d51676e.jpg_200x200q90.jpg",
        "price": 2854,
        "remark": "https://www.lazada.co.th/products/pdp-i16090742244.html",
        "sold": 0
    },
    {
        "product_name": "HOOPET | ที่นอนสัตว์เลี้ยงอุ่นสบายสำหรับทุกฤดูกาล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd9399dcdf2cd4ff1af8412b2962957d3v.jpg_200x200q90.jpg",
        "price": 2831.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6053746709.html",
        "sold": 0
    },
    {
        "product_name": "กล่องทรายแมวป้องกันกลิ่นและกระเด็น ขนาดใหญ่พิเศษ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scd2110b210a64c3aa96d32c52162d520f.png_200x200q90.png",
        "price": 2822,
        "remark": "https://www.lazada.co.th/products/pdp-i16087173463.html",
        "sold": 0
    },
    {
        "product_name": "hipidog | ทรายแมวดูดซับกลิ่นเบนโทไนต์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd8552cff3aed45d6bbbbb67fd2a5c9d0S.png_200x200q90.png",
        "price": 2816.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5841066071.html",
        "sold": 23
    },
    {
        "product_name": "กล่องครอกแมว กล่องครอกแบบปิดพร้อมพลั่วและแผ่นกันรั่ว กล่องครอกด้านข้างสูง ป้องกันการรั่วไหล รายการยอดนิยม ถาดรองครอกแมว ทำความสะอาดง่าย (2)",
        "product_image": "https://img.lazcdn.com/g/p/2ac9fcdf55cd4268fbca2ce92c207114.jpg_200x200q90.jpg",
        "price": 2812,
        "remark": "https://www.lazada.co.th/products/pdp-i16121897373.html",
        "sold": 0
    },
    {
        "product_name": "[[Sale!!!]] อุปกรณ์สัตว์เลี้ยง ของเล่นแมว ถูกๆ เครื่องให้น้ำ อัตโนมัติเซรามิกสัตว์เลี้ยงสุนัขป้อนน้ำอัตโนมัติสัตว์ SY15 ส่งฟรีทั่วไทย by powerfull4289",
        "product_image": "https://img.lazcdn.com/g/p/1b201d16254d7f1abed6a4c0a26cd3f5.jpg_200x200q90.jpg",
        "price": 2798,
        "remark": "https://www.lazada.co.th/products/pdp-i1244744551.html",
        "sold": 0
    },
    {
        "product_name": "Imac Zuma ห้องน้ำแมวแบบโดม สีเขียว มีลิ้นชักตักเปลี่ยนทรายง่ายสะดวก ประตูใสมองเห็น มีช่องใส่แผ่นคาร์บอนดูดกลิ่น",
        "product_image": "https://img.lazcdn.com/g/p/02497505019ec76e3777264d0d07d04c.jpg_200x200q90.jpg",
        "price": 2780,
        "remark": "https://www.lazada.co.th/products/pdp-i5046937130.html",
        "sold": 0
    },
    {
        "product_name": "YIMING |  รั้วกั้นสัตว์เลี้ยงสำหรับสุนัขและแมว ป้องกันบันได รั้วแบบยืดหดได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4237ae6ec8014a87ac828fab9df39691o.jpg_200x200q90.jpg",
        "price": 2760.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5927936933.html",
        "sold": 13
    },
    {
        "product_name": "ยกไปเลย 1 ลัง Kanimal Pet Wipes ทิชชู่เปียกสัตว์เลี้ยง ผ้าเปียกเช็ดตัว สูตรคาโมมายล์ ช่วยยับยั้งแบคทีเรีย สำหรับสุนัขและแมว",
        "product_image": "https://img.lazcdn.com/g/p/ea245399560d11d841d2c4bb2c72f3c6.jpg_200x200q90.jpg",
        "price": 2760,
        "remark": "https://www.lazada.co.th/products/pdp-i5167233612.html",
        "sold": 0
    },
    {
        "product_name": "ShineTrip เบาะนอนน้องแมวสัตว์เลี้ยง Kancan ยกระดับอลูมิเนียมกลางแจ้ง Huiop ด้วยเบาะนอนน้องแมวอัลลอยด์เตียงสำหรับสัตว์เลี้ยงยกระดับเตียงนอนยกสูงในร่มยกระดับเตียงอลูมิเนียมอัลลอยด์ Hxber Erythlechnical Siuke Lanru Dsfen",
        "product_image": "https://img.lazcdn.com/g/p/d078d7c8b38aaa5148b69f1fe0168595.jpg_200x200q90.jpg",
        "price": 2738,
        "remark": "https://www.lazada.co.th/products/pdp-i5640483971.html",
        "sold": 0
    },
    {
        "product_name": "TOMSHOO เตียงสำหรับสัตว์เลี้ยงเตียงพร้อมเตียงในร่มกลางแจ้ง,อะลูมินัมอัลลอยเบาะนอนน้องแมวยกสูงอะลูมินัมอัลลอยกับการใช้งานกลางแจ้งในร่มอลูมิเนียมเตียงสำหรับสัตว์เลี้ยงเบาะนอนน้องแมวโลหะผสมสัตว์เลี้ยงที่มี Lanru ยกเตียงนอนยกสูง",
        "product_image": "https://img.lazcdn.com/g/p/4b2bd23ccfb94381280fb44c4e370967.jpg_200x200q90.jpg",
        "price": 2732,
        "remark": "https://www.lazada.co.th/products/pdp-i5436910653.html",
        "sold": 0
    },
    {
        "product_name": "อ่างลitter ขนาดใหญ่สำหรับแมว Mango แบบปิดเต็มรูปแบบ ฝาด้านบนแบบถอดออกได้ อ่างลitter สำหรับแมว ผลิตจากจีนแผ่นดินใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9386f1ca38b64b619276040227bdb74c4.jpg_200x200q90.jpg",
        "price": 2732,
        "remark": "https://www.lazada.co.th/products/pdp-i5399403350.html",
        "sold": 2
    },
    {
        "product_name": "Zerodis กล่องทรายแมวขนาดใหญ่พิเศษแบบกึ่งปิดถาดรองกระทะพลาสติกพร้อมการออกแบบที่ถอดออกได้และตักด้านสูงสำหรับแมวหลายตัว 23.43x17.32in (สีชมพู)",
        "product_image": "https://img.lazcdn.com/g/p/836de791c668652cf42f0b7cc2151bf8.jpg_200x200q90.jpg",
        "price": 2728,
        "remark": "https://www.lazada.co.th/products/pdp-i16124335805.html",
        "sold": 0
    },
    {
        "product_name": "paikewei | กล่องขยะแมวป้องกันกระเด็นสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S69087dcce0ea45bbb15b0ba50a37bd3fF.jpg_200x200q90.jpg",
        "price": 2726,
        "remark": "https://www.lazada.co.th/products/pdp-i16123608906.html",
        "sold": 0
    },
    {
        "product_name": "BOBOKALA | กล่องทรายแมวขนาดใหญ่ป้องกันการกระเด็นและกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0cd0bba4cd5a411cb8eba1ca7623303bM.jpg_200x200q90.jpg",
        "price": 2720,
        "remark": "https://www.lazada.co.th/products/pdp-i16123385785.html",
        "sold": 0
    },
    {
        "product_name": "BOBOKALA | กล่องทรายแมวป้องกันกลิ่นและไม่กระเด็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6a12acea06264e928a079bbb7b916efeZ.png_200x200q90.png",
        "price": 2704,
        "remark": "https://www.lazada.co.th/products/pdp-i16120266893.html",
        "sold": 0
    },
    {
        "product_name": "WEVOLA | ทรายแร่กำจัดกลิ่นสำหรับสุนัขเล็ก สามารถล้างได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S01ffde5a9e414173baff2e4c7b658a86S.png_200x200q90.png",
        "price": 2702.52,
        "remark": "https://www.lazada.co.th/products/pdp-i6022175740.html",
        "sold": 1
    },
    {
        "product_name": "Hosttail เบาะนอนสัตว์เลี้ยงรุ่น Twinkle",
        "product_image": "https://img.lazcdn.com/g/p/782be360b22634ae78739071302b18f8.jpg_200x200q90.jpg",
        "price": 2700,
        "remark": "https://www.lazada.co.th/products/pdp-i5842826637.html",
        "sold": 5
    },
    {
        "product_name": "WRA ทิชชู่เปียก แผ่นทำความสะอาด 10+2แพคเล็ก พอว์พอว์ ผ้าเปียกสัตว์เลี้ยง เส้นใยธรรมชาติ อ่อนโยน สุนัข แมว 20 แผ่น ผ้าเช็ดทำความสะอาด กระดาษทำความสะอาด",
        "product_image": "https://img.lazcdn.com/g/p/7109679523926e58b115a1aa21bdba0a.jpg_200x200q90.jpg",
        "price": 2690,
        "remark": "https://www.lazada.co.th/products/pdp-i5782327066.html",
        "sold": 0
    },
    {
        "product_name": "น้ำพุสำหรับสัตว์เลี้ยงอัตโนมัติ DUOKA: ให้ทั้งเครื่องดื่มร้อนและเย็น ดีไซน์ไร้สาย ไม่ต้องใช้ไฟฟ้า ถาดสแตนเลส เหมาะสำหรับแมวและสุนัข ระบบหมุนเวียนน้ำ ชาร์จไฟได้ สินค้าขายดีทั่วโลก",
        "product_image": "https://img.lazcdn.com/g/p/7dc3e00ad212ff96c09959eb2fe33f67.jpg_200x200q90.jpg",
        "price": 2683.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16117226567.html",
        "sold": 0
    },
    {
        "product_name": "มุ้งจีบ มุ้งจีบสำหรับสัตว์เลียง มุ้งจีบกันแมวข่วน มีบริการติดตั้ง",
        "product_image": "https://img.lazcdn.com/g/p/2c472461a87b637f5a893a4d537ca86b.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i2896783383.html",
        "sold": 0
    },
    {
        "product_name": "WUKU | กล่องทรายแมวขนาดใหญ่หรูหราปิดทั้งหมด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sec3e780e72084b459914be50ae0c1a62x.jpg_200x200q90.jpg",
        "price": 2682,
        "remark": "https://www.lazada.co.th/products/pdp-i16092340653.html",
        "sold": 0
    },
    {
        "product_name": "Kanimal ผ้าเปียกหมาแมว (80 แผ่น x ยกลัง 12 ห่อ) ทิชชู่เปียก สะอาด อ่อนโยนและไม่ระคายเคือง เนื้อผ้าหนานุ่ม ดับกลิ่นได้",
        "product_image": "https://img.lazcdn.com/g/p/038cfdc446605994166996e2a300db3f.jpg_200x200q90.jpg",
        "price": 2678,
        "remark": "https://www.lazada.co.th/products/pdp-i4875413428.html",
        "sold": 0
    },
    {
        "product_name": "Zerodis สุนัขทำความสะอาดอุปกรณ์กรูมมิ่งกล่องครอกรายการด้านบนถาดทิ้งขยะโลหะพร้อมแผ่นป้องกันการรั่วสำหรับแมวหลายตัวขนาดใหญ่พิเศษขนาด 60 X 40 X 20 ซม สำหรับลูกแมวแมวสแตนเลส (ขนาดใหญ่พิเศษ 32.7",
        "product_image": "https://img.lazcdn.com/g/p/55baf664c4f31e7c57e04dfc74ca2d14.jpg_200x200q90.jpg",
        "price": 2672,
        "remark": "https://www.lazada.co.th/products/pdp-i16125469897.html",
        "sold": 0
    },
    {
        "product_name": "Mewo Mall 3-7ลิตร เครื่องให้อาหารสัตว์เลี้ยงอัตโนมัติ ที่ให้อาหารแบบออโต้ เครื่องให้อาหาร แมว สัตว์เลี้ยง สุนัข กระต่",
        "product_image": "https://img.lazcdn.com/g/p/5c47887a3eef52e966c76d538c772dc9.jpg_200x200q90.jpg",
        "price": 2664.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5383851803.html",
        "sold": 42
    },
    {
        "product_name": "MUHONGYU | กล่องทรายแมวพกพาแบบพับได้ขนาดใหญ่ชั่วคราว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5588450599404b589476c3aaea3f267fq.jpg_200x200q90.jpg",
        "price": 2660.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16110441360.html",
        "sold": 0
    },
    {
        "product_name": "Sukina Petto tofu cat litter Original 20L สุกินะ เพ็ทโตะ ทรายเต้าหู้ กลิ่นออริจินัล 20 ลิตร x 2 Bags",
        "product_image": "https://img.lazcdn.com/g/p/63a9f180a54fb6ed2d8fb0684e4691c7.png_200x200q90.png",
        "price": 2658,
        "remark": "https://www.lazada.co.th/products/pdp-i4805399834.html",
        "sold": 7
    },
    {
        "product_name": "hipidog | อ่างล้างหน้าแบบเปิดขนาดใหญ่แบบใช้แล้วทิ้งสำหรับแมว อ่างล้างหน้าพกพาได้ป้องกันการรั่วไหล อ่างล้างหน้าสำหรับแมวขนาดเล็ก อ่างล้างหน้าแบบเปิดสำหรับแมว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5eb6aee5cbfb462e8a23dbee7c8c7b624.jpg_200x200q90.jpg",
        "price": 2652.3,
        "remark": "https://www.lazada.co.th/products/pdp-i5840981750.html",
        "sold": 1
    },
    {
        "product_name": "สุนัขแมวเสื่อเตียงคอกสัตว์เลี้ยงขนาดใหญ่ผ้าปูสำหรับสุนัขอบอุ่นสำหรับสุนัขเล็กกลางใหญ่ลูกสุนัขลูกแมวเบาะที่นอนขนาดพิเศษ",
        "product_image": "https://img.lazcdn.com/g/p/a1b68a9a2908781b98519578989b6ee6.jpg_200x200q90.jpg",
        "price": 2621.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5731162223.html",
        "sold": 4
    },
    {
        "product_name": "WRA ทิชชู่เปียก แผ่นทำความสะอาดทิชชู่เปียกสำหรับสัตว์เลี้ยง  3ห่อ/1ห่อมี50แผ่น ผ้าเช็ดทำความสะอาด กระดาษทำความสะอาด",
        "product_image": "https://img.lazcdn.com/g/p/ebf9c837349f1577d255baba1dff9ee5.jpg_200x200q90.jpg",
        "price": 2650,
        "remark": "https://www.lazada.co.th/products/pdp-i5778420298.html",
        "sold": 0
    },
    {
        "product_name": "แผ่นรองให้อาหารแมวอย่างช้าๆเพื่อการดมกลิ่นแผ่นซิลิโคนเพื่อความสนุกสนานสำหรับให้อาหารสัตว์เลี้ยงทุกวันการดมกลิ่นแบบเปียก",
        "product_image": "https://img.lazcdn.com/g/p/1e812e1f6225139bbbc87c2f9a4c7b00.jpg_200x200q90.jpg",
        "price": 2636,
        "remark": "https://www.lazada.co.th/products/pdp-i6037893357.html",
        "sold": 0
    },
    {
        "product_name": "SHOUAI | กล่องทรายแมวแบบครึ่งปิดกันหกรั่ว สามารถเปิดได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S12396795ef314a3797184da15d2ea953w.jpg_200x200q90.jpg",
        "price": 2634,
        "remark": "https://www.lazada.co.th/products/pdp-i16127247977.html",
        "sold": 0
    },
    {
        "product_name": "LLwell กล่องทรายแมวกรงด้านสูงกึ่งปิดสินค้าพรมสัตว์เลี้ยงแมวใหญ่ถาดชำระสำหรับสัตว์กระต่ายแฮมสเตอร์ขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/p/cb31499431a2a8ae71593ba7221cecdf.jpg_200x200q90.jpg",
        "price": 2632,
        "remark": "https://www.lazada.co.th/products/pdp-i6073044817.html",
        "sold": 0
    },
    {
        "product_name": "โปรโมชั่น+ P275 ห้องน้ำแมว ขนาดใหญ่ แบบลิ้นชักทำความสะอาดง่าย เก็บกลิ่นดี ราคาถูก ห้องน้ำแมว ห้องน้ำแมวทรงโดม มีฝาครอบ ห้องน้ำแมวพับได้  ห้องน้ำแมวพกพา",
        "product_image": "https://img.lazcdn.com/g/p/b61eeed10e24e9e1a862602fb43d5fb5.jpg_200x200q90.jpg",
        "price": 2620,
        "remark": "https://www.lazada.co.th/products/pdp-i4702388307.html",
        "sold": 0
    },
    {
        "product_name": "กล่องครอกแมวแบบพกพา การออกแบบลิ้นชักขนาดใหญ่ กล่องครอกแมวแบบปิด ทำความสะอาดง่ายสำหรับใช้ในร่ม",
        "product_image": "https://img.lazcdn.com/g/p/3b59c8e6adbb46c0b3241b9da4013997.jpg_200x200q90.jpg",
        "price": 2620,
        "remark": "https://www.lazada.co.th/products/pdp-i16126333063.html",
        "sold": 0
    },
    {
        "product_name": "Ritogato Cool rayon bumper mat ที่นอนนวัตกรรมผ้าเย็น ไม่ต้องเเช่เย็น พร้อมหมอนในตัว สำหรับสัตว์เลี้ยง นำเข้าจากเกาหลี",
        "product_image": "https://img.lazcdn.com/g/p/be6240a78e955c0f25ffd0a8a5c8ad8c.jpg_200x200q90.jpg",
        "price": 2600,
        "remark": "https://www.lazada.co.th/products/pdp-i5181189967.html",
        "sold": 12
    },
    {
        "product_name": "shobi​ ห้องน้ำสำหรับสัตว์เลี้ยง​ เเบบสี่เหลี่ยม​ Do Does Did",
        "product_image": "https://img.lazcdn.com/g/p/bc868d4d74092afb956fd1393d0a7b34.jpg_200x200q90.jpg",
        "price": 2600,
        "remark": "https://www.lazada.co.th/products/pdp-i3664605333.html",
        "sold": 0
    },
    {
        "product_name": "[[แท้100%]] Cat toy กระเป๋าใส่หมาและแมว ถูกๆ กระเป๋าสัตว์เลี้ยงดีไซน์สวยงาม แข็งแรง ทน ส่งฟรีทั่วไทย by powerfull4289",
        "product_image": "https://img.lazcdn.com/g/p/34d50a9590866af2b38adeaaef48ad55.jpg_200x200q90.jpg",
        "price": 2598,
        "remark": "https://www.lazada.co.th/products/pdp-i1242656249.html",
        "sold": 0
    },
    {
        "product_name": "😸หมดกังวน จัดส่งฟรี  😸  [เซ็ตสุดคุ้ม] Unicharm Pet สำหรับ 2 เดือน เดโอทอยเล็ท แซนด์ ทรายแมว ลดกลิ่น 4ลิตร + เดโอทอยเล็ท ชีท ห้องน้ำเก็บกลิ่น  ✨",
        "product_image": "https://img.lazcdn.com/g/p/3908050b3dbdfe63414131726720eebe.jpg_200x200q90.jpg",
        "price": 2598,
        "remark": "https://www.lazada.co.th/products/pdp-i5388062285.html",
        "sold": 7
    },
    {
        "product_name": "ถุงมือกำจัดขนสัตว์เลี้ยง, เครื่องกำจัดขนสัตว์เลี้ยงด้วยไฟฟ้าสถิต, ที่กำจัดขนแมวและสุนัขแบบใช้ซ้ำได้สำหรับโซฟา, เฟอร์นิเจอร์, พรม, เบาะรถยนต์, ถุงมือสำหรับกรูมมิ่งสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/p/bf92e6b9ea6a31bd3237552a3aff61f7.jpg_200x200q90.jpg",
        "price": 2596.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16098515927.html",
        "sold": 0
    },
    {
        "product_name": "LIMAIXIAOSHENG | กล่องทรายแมวขนาดใหญ่ป้องกันการหก กึ่งปิด ควบคุมทราย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se5518d25c1ac41cdb7c14ab58dc4426eV.jpg_200x200q90.jpg",
        "price": 2588,
        "remark": "https://www.lazada.co.th/products/pdp-i16125942078.html",
        "sold": 0
    },
    {
        "product_name": "ถุงมือกำจัดขนสัตว์เลี้ยงสำหรับแมวและสุนัข, ถุงมือกำจัดขนสัตว์เลี้ยงแบบใช้ซ้ำได้สำหรับโซฟา, เฟอร์นิเจอร์, พรม",
        "product_image": "https://img.lazcdn.com/g/p/11181caeac28ef99b3fc31acfe51f383.jpg_200x200q90.jpg",
        "price": 2583.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16098509727.html",
        "sold": 0
    },
    {
        "product_name": "AOBIXIONG | อุปกรณ์ดูแลสัตว์เลี้ยงหลายฟังก์ชันสำหรับสุนัขและแมว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3f3ad60196c64290ae382e39ab44a17av.jpg_200x200q90.jpg",
        "price": 2582.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16118070356.html",
        "sold": 0
    },
    {
        "product_name": "Pet Protect Cleaner 5L. น้ำยาอเนกประสงค์ สูตรธรรมชาติ กลิ่นมิ้นท์ สดชื่น ทำความสะอาดพื้นบ้าน เช็ดพื้น สำหรับสุนัขและแมว (5,000 มล/แกลอน)",
        "product_image": "https://img.lazcdn.com/g/p/a1b3183d139a48507b911d427eba1c3c.jpg_200x200q90.jpg",
        "price": 2578,
        "remark": "https://www.lazada.co.th/products/pdp-i1228312422.html",
        "sold": 3
    },
    {
        "product_name": "ยางกแซนด 1968 ฮบ ทรายแมว (AK262) 7 กก.x2 ชน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf9bf4fbd183b4a26a3098cb3d87e2e6cM.png_200x200q90.png",
        "price": 2565.1,
        "remark": "https://www.lazada.co.th/products/pdp-i6026167203.html",
        "sold": 0
    },
    {
        "product_name": "ทรายแมวยองกแซนด 1959 ฟทโทนช โกยางอ (AK261) 7 กก. 2 ถง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S48a6dda4537a454b8deb1714e0138996O.png_200x200q90.png",
        "price": 2565.1,
        "remark": "https://www.lazada.co.th/products/pdp-i6026151779.html",
        "sold": 0
    },
    {
        "product_name": "Moon ชุดฝึกกัดสำหรับฝึกสุนัขแขนป้องกันสำหรับกัดสุนัขน่ารักป้องกันแขนกัด",
        "product_image": "https://img.lazcdn.com/g/p/30f4a95355754b761ab5b417d8ed7418.jpg_200x200q90.jpg",
        "price": 2554.72,
        "remark": "https://www.lazada.co.th/products/pdp-i4486111952.html",
        "sold": 5
    },
    {
        "product_name": "Meowhouse ที่กรองร่อนกล่องทรายแมวอุปกรณ์เสริมสำหรับสัตว์เลี้ยงที่ใช้งานได้จริงแทนที่บำรุงรักษาง่ายอุปกรณ์กรองกล่องทรายแมวอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/p/c8e2c743cccb7361c246f0721923061c.jpg_200x200q90.jpg",
        "price": 2554,
        "remark": "https://www.lazada.co.th/products/pdp-i5981971099.html",
        "sold": 0
    },
    {
        "product_name": "Care | ทรายแมวซับน้ำและกำจัดกลิ่นจากเต้าหู้ 20 กก.",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1333702d5a714a29a7c0ae1acd1925deR.jpg_200x200q90.jpg",
        "price": 2549.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5968593786.html",
        "sold": 0
    },
    {
        "product_name": "ของขวัญวันเกิดตุ๊กตาพัฟส์บีเกิล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se3cec66903664a5a9aa7e8c81b6a66c5I.jpg_200x200q90.jpg",
        "price": 2526,
        "remark": "https://www.lazada.co.th/products/pdp-i16089451033.html",
        "sold": 0
    },
    {
        "product_name": "ถุงมือกำจัดขนสัตว์เลี้ยง Yomi, ถุงมือกำจัดขนสัตว์เลี้ยงด้วยไฟฟ้าสถิต, ถุงมือกำจัดขนแมวและสุนัขแบบใช้ซ้ำได้, สำหรับโซฟา, เฟอร์นิเจอร์, พรม, เบาะรถยนต์ (3 ชิ้น)",
        "product_image": "https://img.lazcdn.com/g/p/de801c9b7bda6aaf4c4230fd4a2fd91e.jpg_webp_200x200q90.jpg",
        "price": 2503.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16108802563.html",
        "sold": 0
    },
    {
        "product_name": "ถุงมือกำจัดขนสัตว์เลี้ยง Yomi, ถุงมือกำจัดขนสัตว์เลี้ยงด้วยไฟฟ้าสถิต, ที่กำจัดขนแมวและสุนัขแบบใช้ซ้ำได้, สำหรับโซฟา, เฟอร์นิเจอร์, พรม, เบาะรถยนต์ (1 ชิ้น)",
        "product_image": "https://img.lazcdn.com/g/p/0892e343e36e182abe7d7a297fcb517c.jpg_webp_200x200q90.jpg",
        "price": 2503.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16089919643.html",
        "sold": 0
    },
    {
        "product_name": "[MALETKHAO] Catidea (แคทไอเดีย) ห้องน้ำแมว รุ่น Cat Ears CL 101 สีครีม ไซส์ XL (จำกัด 1 ชิ้นต่อ 1 ออเดอร์)",
        "product_image": "https://img.lazcdn.com/g/p/e754e7b4642f94c8944b873291a5b068.jpg_200x200q90.jpg",
        "price": 2498,
        "remark": "https://www.lazada.co.th/products/pdp-i5031022450.html",
        "sold": 0
    },
    {
        "product_name": "[Fish & Bone] Mango กระบะทรายแมว ขนาดใหญ่ แถมฟรี ที่ตักทราย ไซส์ใหญ่พิเศษ",
        "product_image": "https://img.lazcdn.com/g/p/05f47e6604100e8fa3d4c8898aa6553c.jpg_200x200q90.jpg",
        "price": 2486,
        "remark": "https://www.lazada.co.th/products/pdp-i4148072627.html",
        "sold": 16
    },
    {
        "product_name": "เครื่องเป่าขนสัตว์เลี้ยง 2100w เป่าและดูดพลังสูง ถังด้านในลดเสียงรบกวน ลมแรงและแห้งเร็ว ขนแห้งอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/p/c7a7b1707ca1570aba01c27d767205dc.png_200x200q90.png",
        "price": 2478,
        "remark": "https://www.lazada.co.th/products/pdp-i5124668777.html",
        "sold": 13
    },
    {
        "product_name": "กล่องทรายแมวสัตว์เลี้ยงที่ดีกว่าสำหรับทรายแมวแบบพกพากล่องทรายแมวกันน้ำกระเด็น",
        "product_image": "https://img.lazcdn.com/g/p/0b2086079aefb8040410c936370fc943.jpg_200x200q90.jpg",
        "price": 2472.18,
        "remark": "https://www.lazada.co.th/products/pdp-i6060676448.html",
        "sold": 0
    },
    {
        "product_name": "Aoresac ปากกาออกกำลังกายสุนัขปากกาของเล่นสัตว์เลี้ยงรั้วสุนัขขนาดใหญ่แบบพกพาสำหรับลูกสุนัข12แผงเหมาะสำหรับแมวสัตว์เลี้ยงที่มีน้ำหนักน้อยกว่า10กก.",
        "product_image": "https://img.lazcdn.com/g/p/61f02b9f231812ed1ddb24e9aa60f5c8.jpg_200x200q90.jpg",
        "price": 2460,
        "remark": "https://www.lazada.co.th/products/pdp-i5811067005.html",
        "sold": 1
    },
    {
        "product_name": "OOD ทรายแมวภูเขาไฟ ขนาด 8.5 kg 3 ถุง",
        "product_image": "https://img.lazcdn.com/g/p/6c5bed09eadbea89ea0f93c7816cdf17.jpg_200x200q90.jpg",
        "price": 2458,
        "remark": "https://www.lazada.co.th/products/pdp-i5795015259.html",
        "sold": 0
    },
    {
        "product_name": "ZHUOMO | บARRIERป้องกันน้ำกระเด็นสำหรับห้องน้ำสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd0830dbb166148988fc0431936f5b683u.jpg_200x200q90.jpg",
        "price": 2454,
        "remark": "https://www.lazada.co.th/products/pdp-i16142291202.html",
        "sold": 0
    },
    {
        "product_name": "ZHUOMO | รั้วป้องกันน้ำกระเด็นสำหรับห้องน้ำสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S68f7616c955a4851aa676c8beef7c43eK.jpg_200x200q90.jpg",
        "price": 2454,
        "remark": "https://www.lazada.co.th/products/pdp-i16142313142.html",
        "sold": 0
    },
    {
        "product_name": "Micky Cat | เครื่องให้อาหารสัตว์เลี้ยงอัจฉริยะพร้อมกล้อง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8b9cb66ae9414f3da4589dd6db803645r.jpg_200x200q90.jpg",
        "price": 2453.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5907904261.html",
        "sold": 8
    },
    {
        "product_name": "กล่องขยะแมวขนาดใหญ่ป้องกันกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se286c46ac70740b7bc043dbb9d1f4ac7L.jpg_200x200q90.jpg",
        "price": 2452.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16105637497.html",
        "sold": 0
    },
    {
        "product_name": "Gaines | ทรายแมวโซเดียมเบนโทไนต์คลีธรรมชาติ ควบคุมกลิ่น ป้องกันแบคทีเรีย 4 กก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4dafbc635b624acda6c5a0c13581b719r.jpg_200x200q90.jpg",
        "price": 2450,
        "remark": "https://www.lazada.co.th/products/pdp-i16124810417.html",
        "sold": 0
    },
    {
        "product_name": "PetSnowy Cat Toilet/mat/Filter Mesh/Rubber Strip/Charger/Cat Litter Complete Set of Accessories Toilets Ball Compartment",
        "product_image": "https://img.lazcdn.com/g/p/e23c1f0574a9d6b7325f4fbe5a745adc.jpg_webp_200x200q90.jpg",
        "price": 2446,
        "remark": "https://www.lazada.co.th/products/pdp-i16088070583.html",
        "sold": 0
    },
    {
        "product_name": "น้ำยาทำความสะอาดกรง Bioline สเปร์ยล้างกรงดับกลิ่น สำหรับกรงกระต่าย กรงแฮมเตอร์ กรงหนู สัตว์เลี้ยงขนาดเล็ก และกรงนก500ml.",
        "product_image": "https://img.lazcdn.com/g/p/6779657f5926b5f24240c8c035e7c34f.jpg_200x200q90.jpg",
        "price": 2437.56,
        "remark": "https://www.lazada.co.th/products/pdp-i3481214672.html",
        "sold": 0
    },
    {
        "product_name": "Unicharm Easy-toilet อีซี่ทอยเล็ท ห้องน้ำแมวลดกลิ่น เก็บกลิ่น แบบไม่มีฝาครอบ (พร้อมรีฟิล)",
        "product_image": "https://img.lazcdn.com/g/p/7114cf9e801f30ad04d8dea1ea676765.jpg_200x200q90.jpg",
        "price": 2426,
        "remark": "https://www.lazada.co.th/products/pdp-i4936539262.html",
        "sold": 0
    },
    {
        "product_name": "BOBOKALA | กล่องทรายแมวขนาดใหญ่ ป้องกันกระเด็น ควบคุมกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se8c3d6c2400e420897b83b3225be567aL.jpg_200x200q90.jpg",
        "price": 2422,
        "remark": "https://www.lazada.co.th/products/pdp-i16123590977.html",
        "sold": 0
    },
    {
        "product_name": "JINGZHIYU | ชั้นวางทรายแมวหลายชั้นแบบตั้งพื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc56efa03e6e84bfdbbb827fa11afc35fP.jpg_200x200q90.jpg",
        "price": 2418.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16045693424.html",
        "sold": 2
    },
    {
        "product_name": "รacks สำหรับสัตว์เลี้ยงแบบเหล็ก ชั้นวางของหลายชั้นสำหรับแมว ชั้นวางของสำหรับอาหารแมว ชั้นวางของสำหรับของเล่น ชั้นวางของสำหรับขยะแมว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S85b705adaa2f4d12be5a31d334943de2Y.png_200x200q90.png",
        "price": 2416,
        "remark": "https://www.lazada.co.th/products/pdp-i16077888961.html",
        "sold": 0
    },
    {
        "product_name": "แผ่นรองแมวลิตเตอร์ซิลิโคนขนาดใหญ่สำหรับให้อาหารแผ่นรองชามแผ่นรองสัตว์เลี้ยงกันน้ำชามอาหารแมวกันหกแผ่นรองชามแผ่นรองให้อาหารกันลื่น",
        "product_image": "https://img.lazcdn.com/g/p/e618d993bc378ce95219998a9e9dd3e5.jpg_200x200q90.jpg",
        "price": 2412,
        "remark": "https://www.lazada.co.th/products/pdp-i6062214591.html",
        "sold": 0
    },
    {
        "product_name": "KAMA MUTA | ชามป้อนอาหารสัตว์เลี้ยงป้องกันล้ม ไซส์เล็ก/กลาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa13e24379452444481a12a4616270ac9y.jpg_200x200q90.jpg",
        "price": 2409.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5909720903.html",
        "sold": 67
    },
    {
        "product_name": "😺รับประกัน5ปี คอกกรงสัตว์เลี้ยง คอนโดแมว ออกแบบกรงได้ตามต้องการ สำหรับสัตว์เลี้ยง สุนัข แมว กระต่าย สัตว์อื่น ๆกรงแมว กรงสัตว์เลี้ยง ขนาดใหญ่ พับได้ ไม่เป็นสนิม แข็งแรง ไม่กลัวการขีดข่วนกัด ของใช้ในชีวิตประจำวันทุกชนิด",
        "product_image": "https://img.lazcdn.com/g/p/84e5b62b7ccef55722bd37efbf6eefba.jpg_200x200q90.jpg",
        "price": 2408.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5011887037.html",
        "sold": 293
    },
    {
        "product_name": "Dettol(เดทตอล) | สารฆ่าเชื้อสำหรับสัตว์เลี้ยงที่ช่วยลดกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfc79f1ef3ff64eff988dbd047559928fs.jpg_200x200q90.jpg",
        "price": 2404,
        "remark": "https://www.lazada.co.th/products/pdp-i16090830067.html",
        "sold": 0
    },
    {
        "product_name": "HOOPET | กล่องทรายแมวป้องกันกลิ่นและไม่ให้น้ำกระเด็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S23e22ecbc9f24c31b5daa4ecbe70a5c8P.jpg_200x200q90.jpg",
        "price": 2402,
        "remark": "https://www.lazada.co.th/products/pdp-i16089432119.html",
        "sold": 0
    },
    {
        "product_name": "[แพคคู่] PettoBonnys น้ำยาทำความสะอาดอเนกประสงค์ น้ำยาถูพื้น สัตว์เลี้ยง สเปรย์ดับกลิ่นฉี่สุนัข แมว สารสกัดธรรมชาติ",
        "product_image": "https://img.lazcdn.com/g/p/a29915c0ab051e7d586353eee33cce6b.jpg_200x200q90.jpg",
        "price": 2400,
        "remark": "https://www.lazada.co.th/products/pdp-i16050225048.html",
        "sold": 0
    },
    {
        "product_name": "Petsnowy Snow+ Robertet Fragrance Box (Snowy Zephyr) 3 Pcs./Box น้ำหอมดับกลิ่น",
        "product_image": "https://img.lazcdn.com/g/p/d3f24333cc862dbfc64716734da76d78.jpg_200x200q90.jpg",
        "price": 2400,
        "remark": "https://www.lazada.co.th/products/pdp-i5314482454.html",
        "sold": 1
    },
    {
        "product_name": "[[Sale!!!]] อุปกรณ์สัตว์เลี้ยง ของเล่นแมว ถูกๆ กระเป๋าใส่สุนัขและแมวแบบใส ส่งฟรีทั่วไทย by powerfull4289",
        "product_image": "https://img.lazcdn.com/g/p/a50b96db83d7e66e03f2e10591bcefc4.jpg_200x200q90.jpg",
        "price": 2398,
        "remark": "https://www.lazada.co.th/products/pdp-i1244702913.html",
        "sold": 0
    },
    {
        "product_name": "Carry-home สะดวกเก็บและย้าย กรงสุนัขสแตนเลส กรงสัตว์ พับได้  กรงสุนัข  กรงสแตนเลสท่อเหลี่ยม กรงสแตนเลสพับ  ป้องกันสนิม มีล้อล็อคได้ กรงสุนัขใหญ่ๆ",
        "product_image": "https://img.lazcdn.com/g/p/ad1a57739022fad325c64eba16d7e77f.jpg_200x200q90.jpg",
        "price": 2398,
        "remark": "https://www.lazada.co.th/products/pdp-i5042795987.html",
        "sold": 40
    },
    {
        "product_name": "DIGITALPET รถเข็นสุนัขพับได้ รับนน.ได้ 20 kg รถเข็นสัตว์เลี้ยง รถเข็นสุนัข รถเข็นสุนัขใหญ่ รถเข็นแมว รถเข็นสัตว์เลี้ยง",
        "product_image": "https://img.lazcdn.com/g/p/641269a60a860fd805ac844da80b8549.jpg_200x200q90.jpg",
        "price": 2398,
        "remark": "https://www.lazada.co.th/products/pdp-i16116102584.html",
        "sold": 0
    },
    {
        "product_name": "เตียงนอนแมว เตียงนอนสุนัข กระต่าย ดีไซน์เตียงทรงเจ้าหญิง  มีที่นอนและหมอนแถมให้พร้อมใช้งาน ตัวเตียงทำจากเหล็กเส้นดัดแข็งแรงมาก พ่นด้วยสีทองเพิ่มความหรูหราลักชูให้กับลูกๆ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6c7690761f184546ac9e6a93b7865ce4x.jpg_200x200q90.jpg",
        "price": 2398,
        "remark": "https://www.lazada.co.th/products/pdp-i5721567014.html",
        "sold": 1
    },
    {
        "product_name": "กล่องทรายแมวกระบะทรายแมว SATmoon ถาดคอกสัตว์เลี้ยง Baju Atasan Terbuka กล่องเก็บของขนาดเล็กแมว",
        "product_image": "https://img.lazcdn.com/g/p/eade20cbd3d65d38ba8ec38f426d4517.jpg_200x200q90.jpg",
        "price": 2392.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16128333327.html",
        "sold": 0
    },
    {
        "product_name": "[ ถุงเติมแพคคู่] PettoBonnys น้ำยาทำความสะอาดอเนกประสงค์ น้ำยาถูพื้น สัตว์เลี้ยง สเปรย์ดับกลิ่นฉี่สุนัข แมว สารสกัดธรรมชาติ",
        "product_image": "https://img.lazcdn.com/g/p/2eba7d0bfb050b184102954c4eec6492.jpg_200x200q90.jpg",
        "price": 2392,
        "remark": "https://www.lazada.co.th/products/pdp-i16054215490.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องฟอกอากาศกำจัดขนสัตว์และดับกลิ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S97ba9bff93b94b1db252950b4317dd5ek.jpg_200x200q90.jpg",
        "price": 2388,
        "remark": "https://www.lazada.co.th/products/pdp-i16127587295.html",
        "sold": 0
    },
    {
        "product_name": "ABEYINUOR | กล่องทรายแมวป้องกันกลิ่น ป้องกันกระเด็น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb245168725824bd2a587131ef5f12517x.jpg_200x200q90.jpg",
        "price": 2386,
        "remark": "https://www.lazada.co.th/products/pdp-i16142496931.html",
        "sold": 0
    },
    {
        "product_name": "น้ำยาล้างกรง สเปร์ยทำความสะอาดกรงกระต่าย กรงกระรอก กรงแฮมเตอร์ หนูแกสบี้ และสัตว์เล็ก 500มล. (3 ขวด) Pet Protect Natural Cage and Hutch Cleaning Spray for Rabbits Hamster",
        "product_image": "https://img.lazcdn.com/g/p/12efe8a56eaf924883a5002ac63137ab.jpg_200x200q90.jpg",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i3883998604.html",
        "sold": 0
    },
    {
        "product_name": "Kin+Kind Fabric+Carpet Pee+Stain+Odor Destroyer สเปรย์ออร์แกนิคขจัดคราบและกลิ่นฉี่สัตว์เลี้ยงสำหรับผ้าและพรม กลิ่นฟลอรัล",
        "product_image": "https://img.lazcdn.com/g/p/b28cd6dcabba4b778babb161d13e2949.png_200x200q90.png",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i4450648870.html",
        "sold": 2
    },
    {
        "product_name": "หมากรุกแม่เหล็กโหมดเกมเกมกระดาน3โหมดเกมหมากรุกอิเลคโทรนิคส์ตั้งค่ากับคู่ต่อสู้ AI สำหรับการฝึกซ้อมการเดินทาง",
        "product_image": "https://img.lazcdn.com/g/p/a893069c13e0f7fe7f761acfae32dfaf.jpg_200x200q90.jpg",
        "price": 24788,
        "remark": "https://www.lazada.co.th/products/pdp-i5889718803.html",
        "sold": 1
    },
    {
        "product_name": "ไม้ตกปลาเรือ แผ่นเหล็ก 5G เขย่าช้า ดึงไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9f806c28f06b4cd882a9bf077ed3d826C.jpg_200x200q90.jpg",
        "price": 23420.88,
        "remark": "https://www.lazada.co.th/products/pdp-i6003146957.html",
        "sold": 0
    },
    {
        "product_name": "udiR／C/|รถรีโมทคอนโทรลออฟโรดแข่งความเร็ว 1/16",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb3ef17afafe348db9bf62104e69a9779h.png_200x200q90.png",
        "price": 12409.98,
        "remark": "https://www.lazada.co.th/products/pdp-i6029711078.html",
        "sold": 5
    },
    {
        "product_name": "WUQUGONGSHE | ตุ๊กตาสะสม AI สร้างสรรค์และอารมณ์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5f10aaff880443358805bbd3f45972fas.jpg_200x200q90.jpg",
        "price": 10926.76,
        "remark": "https://www.lazada.co.th/products/pdp-i6001920676.html",
        "sold": 0
    },
    {
        "product_name": "Mould King | ของเล่นโมเดลตึกควบคุมด้วยรีโมท",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4456c7f6f6024aa0ab313ff0c32b55c2U.jpg_200x200q90.jpg",
        "price": 9881.86,
        "remark": "https://www.lazada.co.th/products/pdp-i6003201817.html",
        "sold": 0
    },
    {
        "product_name": "TRIMUI | คอนโซลเกมพกพาแนวตั้งจำลอง GBA รุ่นพิเศษโลหะสไตล์เรโทร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbf2fc3a046b84b958fcbb894a5afbe79s.png_200x200q90.png",
        "price": 9213.24,
        "remark": "https://www.lazada.co.th/products/pdp-i5938272766.html",
        "sold": 34
    },
    {
        "product_name": "Mould King | โมเดลรถแทรกเตอร์ควบคุมระยะไกลสำหรับประกอบที่มีความซับซ้อนสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc0b257acb89841c7b065b438365501f7U.jpg_200x200q90.jpg",
        "price": 9193.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6003325064.html",
        "sold": 0
    },
    {
        "product_name": "R36H รุ่นใหม่ล่าสุด!!!***ของแถมมากมาย-ของแท้100%-ลด30%***แบบพกพาเกม 128G Gameboy Gameboy PSP ของเล่นเกมคอนโซล Retro เกมคอนโซล 21000 + เกมของขวัญปีใหม่ของขวัญวันเกิด r36s ของขวัญคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/p/c96b6b84a510bfcfe7eb59d6854ee1ec.jpg_200x200q90.jpg",
        "price": 6927.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16128951262.html",
        "sold": 0
    },
    {
        "product_name": "Vantage / All-In Set ห่อของขวัญฟรี [บอร์ดเกม Boardgame]",
        "product_image": "https://img.lazcdn.com/g/p/bc65e40559b4d6206b8761ab4a9bd67c.jpg_200x200q90.jpg",
        "price": 6422,
        "remark": "https://www.lazada.co.th/products/pdp-i844820235.html",
        "sold": 0
    },
    {
        "product_name": "ชุดของเล่นเด็กหลายฟังก์ชัน ไม้บีช",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6b5638a5983446cf9ce5c2f0f40bb51fz.jpg_200x200q90.jpg",
        "price": 5413.92,
        "remark": "https://www.lazada.co.th/products/pdp-i6001914061.html",
        "sold": 0
    },
    {
        "product_name": "MIYOO Mini Flip มินิเกมคอนโซลมือถือแบบย้อนยุคพลิก2.8หน้าจอ IPS คอนโซลวิดีโอเกมแบบพกพาคลาสสิกจำลองผู้เล่นย้อนยุคของขวัญ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S23c778bfb946414c96e8e85236047700L.jpg_200x200q90.jpg",
        "price": 4957.18,
        "remark": "https://www.lazada.co.th/products/pdp-i6028884246.html",
        "sold": 1
    },
    {
        "product_name": "HASBRO MONOPOLY SUPER ELECTRONIC BANKING SPECIAL EDITION  เกมส์เศรษฐีแบบกระดานใหญ่ เสริมสร้างทักษะการลงทุนและการคิด  โมโนโพลี่",
        "product_image": "https://img.lazcdn.com/g/p/28314f343222bd606d675ca48bad335a.jpg_200x200q90.jpg",
        "price": 4900,
        "remark": "https://www.lazada.co.th/products/pdp-i1390526501.html",
        "sold": 14
    },
    {
        "product_name": "***ของแท้100%-ของแถมมากมาย-ลด30%***\nR36H ใหม่แบบพกพาเกม 128G Gameboy Gameboy PSP ของเล่นเกมคอนโซล Retro เกมคอนโซล 21000 + เกมของขวัญปีใหม่ของขวัญวันเกิด r36s ของขวัญคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/p/c96b6b84a510bfcfe7eb59d6854ee1ec.jpg_200x200q90.jpg",
        "price": 4848.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16055334457.html",
        "sold": 0
    },
    {
        "product_name": "JJRC | รถรีโมทคอนโทรลปีนเขาแบบมืออาชีพ",
        "product_image": "https://img.lazcdn.com/3rd/q/aHR0cHM6Ly9hZS1waWMtYTEuYWxpZXhwcmVzcy1tZWRpYS5jb20va2YvUzlmODEyYWYxMTBmYjRkNzdhYjYxZGU2MGI3MWRjMjFhcS5qcGc=_200x200q90.png",
        "price": 4440.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6066577713.html",
        "sold": 2
    },
    {
        "product_name": "ของขวัญวันเกิดของเล่นสำหรับเด็กชาย 8-12 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9dc0b2159a8e4f2582db0ff049e62240X.jpg_200x200q90.jpg",
        "price": 4206.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16119366722.html",
        "sold": 0
    },
    {
        "product_name": "Giiker | ของเล่นเกมปริศนาตัวเลขอัจฉริยะสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd3b24c40a2fd40abb67041f51f03f077P.png_200x200q90.png",
        "price": 4063.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16049716182.html",
        "sold": 0
    },
    {
        "product_name": "HUAZINIAO | ของเล่นเสริมทักษะทางปัญญา บล็อก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9aef87738ad34563b2af53bbe19be287d.jpg_200x200q90.jpg",
        "price": 4016.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6062453661.html",
        "sold": 16
    },
    {
        "product_name": "เกมกระดานปริศนาการสร้างเพื่อการศึกษา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa08317550efb47d3bf70007718378045v.jpg_200x200q90.jpg",
        "price": 3766.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6003005197.html",
        "sold": 0
    },
    {
        "product_name": "Houston เกมส์ต่อทีวี เกมแพดคอนโซลอิเล็กทรอนิกส์ 30000 in 1 128GB เครื่องเล่นเกมส์ 3D arcade two player",
        "product_image": "https://img.lazcdn.com/g/p/e883081f846dd507e9a2daf22e9224c4.jpg_200x200q90.jpg",
        "price": 3630,
        "remark": "https://www.lazada.co.th/products/pdp-i5375846373.html",
        "sold": 39
    },
    {
        "product_name": "Potion Explosion ห้องเรียนนักปรุงยา (2nd Edition ถาดลูกแก้วเป็นพลาสติก) Board Game (ภาษาไทย)",
        "product_image": "https://img.lazcdn.com/g/p/93e12e040d20b0d9057e98a3a44e3db1.jpg_200x200q90.jpg",
        "price": 3500,
        "remark": "https://www.lazada.co.th/products/pdp-i5211711301.html",
        "sold": 0
    },
    {
        "product_name": "เกมพกพา R50S",
        "product_image": "https://img.lazcdn.com/g/p/87ddd68c6ca0d61a368f925b617e108c.jpg_200x200q90.jpg",
        "price": 3500,
        "remark": "https://www.lazada.co.th/products/pdp-i5969355423.html",
        "sold": 0
    },
    {
        "product_name": "HASBRO เกมชีวิต The Game of Life คลาสสิก เกมกระดาน สนุกได้ทั้งครอบครัว เกมยอดนิยมจากอเมริกา",
        "product_image": "https://img.lazcdn.com/g/p/fd210327d2a024c7eaecc3404b04d332.jpg_200x200q90.jpg",
        "price": 3390,
        "remark": "https://www.lazada.co.th/products/pdp-i5741712818.html",
        "sold": 0
    },
    {
        "product_name": "เกม เครื่องเล่นเกม 🎮 Mini Box Game ⭐️ 11 in 1  เสียบจอเล่นได้เลย ลงเกมให้ฟรี‼️",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0ce7e9766dd846bc9cafc0234ea67b83F.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i2758994880.html",
        "sold": 0
    },
    {
        "product_name": "Robotime | ชุดตัวต่อไม้แบบเขี้ยวลากดิน ระดับยาก ของเล่นปริศนา 3 มิติ สำหรับประกอบเอง เหมาะกับเด็กชายและผู้ใหญ่อายุ 12 ปีขึ้นไป",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scfecc9e95d1e4639a304223219c448700.jpg_200x200q90.jpg",
        "price": 3312.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5912596079.html",
        "sold": 15
    },
    {
        "product_name": "Brick | ตัวการ์ตูนสะสมมาร์คไรเดอร์ รุ่นที่ห้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S690901a444df4c3ba3555d1e9004686dS.png_200x200q90.png",
        "price": 3260.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6066500144.html",
        "sold": 2
    },
    {
        "product_name": "พร้อมส่ง🛵 เซ็ตบอร์ดเกม Boardgame สุดฮิตจากเมกา 🌟มีหลายแบบให้เลือก",
        "product_image": "https://img.lazcdn.com/g/p/c58c9ffc38cf515245588825a5d5d3fc.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i5738467881.html",
        "sold": 0
    },
    {
        "product_name": "ของขวัญของเล่นเด็กชายสุดสร้างสรรค์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf2cfc412451247f381ec9310b929eee4p.jpg_200x200q90.jpg",
        "price": 3176.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16052766830.html",
        "sold": 0
    },
    {
        "product_name": "รถของเล่นควบคุมระยะไกล 2 ชั้นขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc467f90df06e490d8fc4b5d8b32775c4r.jpg_200x200q90.jpg",
        "price": 2820.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16083648559.html",
        "sold": 0
    },
    {
        "product_name": "ตั้งวงเล่นเกมส์ Borad game / Work from home💎การ์ดเกมส์ uno attack💎",
        "product_image": "https://img.lazcdn.com/g/p/abc1748cf396fbfe14867cad9059c47e.jpg_200x200q90.jpg",
        "price": 2800,
        "remark": "https://www.lazada.co.th/products/pdp-i2603649369.html",
        "sold": 0
    },
    {
        "product_name": "ซุ้มเกมจุกน้ำปลา ปาโป่ง ตุ๊กตาตก เต็งแดง93ซม. เกมปาร์ตี้งานเลี้ยงปีใหม่ งานวัดประจำปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scdc804632e1541adbaa2fc9bc05ba4b2R.jpg_200x200q90.jpg",
        "price": 2780,
        "remark": "https://www.lazada.co.th/products/pdp-i5976992908.html",
        "sold": 0
    },
    {
        "product_name": "R36H เกมคอนโซลคอนโซลเกมย้อนยุค 128GB วิดีโอเกมคอนโซลเกมแบบพกพาสามารถชาร์จคอนโซลเกมแบบพกพา 21000+Games เครื่องเล่นเกมพกพา",
        "product_image": "https://img.lazcdn.com/g/p/5945efc339f41080c7a793f276f8488d.jpg_200x200q90.jpg",
        "price": 2778,
        "remark": "https://www.lazada.co.th/products/pdp-i5985553153.html",
        "sold": 7
    },
    {
        "product_name": "【ส่งจากไทย+COD】R36H 128GB คอนโซลเกมย้อนยุคพร้อมเล่น 20000+ เกมในตัว แบบพกพาสไตล์ Gameboy PSP ของเล่นเกมคุณภาพดี ของขวัญวันเกิดเด็กผู้ชาย เปิดกล่องเล่นได้ทันที",
        "product_image": "https://img.lazcdn.com/g/p/27e7a6cf475abce2201f287be060427e.jpg_200x200q90.jpg",
        "price": 2778,
        "remark": "https://www.lazada.co.th/products/pdp-i16129861429.html",
        "sold": 0
    },
    {
        "product_name": "ของเล่นฝึกสมองภาษาอังกฤษสำหรับครอบครัวและโรงเรียนอนุบาล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S46ffbee75d0441f0811a0b9286ae1913y.jpg_200x200q90.jpg",
        "price": 2720,
        "remark": "https://www.lazada.co.th/products/pdp-i16111027056.html",
        "sold": 0
    },
    {
        "product_name": "Brick | ของเล่นรถแปลงร่างสร้างตึก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sef7b274bfc654ac3bcba629b5e0822c7q.png_200x200q90.png",
        "price": 2684,
        "remark": "https://www.lazada.co.th/products/pdp-i5996817994.html",
        "sold": 1
    },
    {
        "product_name": "Giiker ของเล่นอิเล็กทรอนิกส์กระดานปริศนาซูเปอร์สไลด์เกมเซ็นเซอร์อัจฉริยะ 500 + แนวนอนสมองครอบครัวปฏิสัมพันธ์การออกกำลังกายเด็กคิดของเล่น",
        "product_image": "https://img.lazcdn.com/g/p/ef76d9f6042b79be384d92ed28bfa43d.jpg_200x200q90.jpg",
        "price": 2538.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5175457557.html",
        "sold": 15
    },
    {
        "product_name": "PALONG | ชุดเกมกระดานมัลติฟังก์ชันเพื่อการศึกษา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0fefb808c20d43e8939eae126a0c8ffct.jpg_200x200q90.jpg",
        "price": 2491.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16049368294.html",
        "sold": 0
    },
    {
        "product_name": "Brick | ฟิกเกอร์ Kamen Rider",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S284b9f66cc3246a5a14926ca75d07512U.jpg_200x200q90.jpg",
        "price": 2398,
        "remark": "https://www.lazada.co.th/products/pdp-i5996906731.html",
        "sold": 6
    },
    {
        "product_name": "ซูโทเปีย จูดี้ แรบบิท ตำรวจคอสเพลย์เครื่องแต่งกาย ผู้หญิง นิค ฟ็อกซ์ชุดดิสนีย์ การ์ตูน อะนิเมะชุดอุปกรณ์เสริมชุด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S95ae974f52d54fa4b955e64b757869c59.png_200x200q90.png",
        "price": 2365.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5891730847.html",
        "sold": 0
    },
    {
        "product_name": "Hasbro | ฮาสโบร โมโนโพลี ซูเปอร์นัทเชอรัล รุ่นจอยน์เดอะฮันท์ เกมกระดานซื้อขายทรัพย์สินสำหรับผู้เล่น 2-6 คน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S86166487c4c54d5181217deb4ec05c6eO.png_200x200q90.png",
        "price": 2364.4,
        "remark": "https://www.lazada.co.th/products/pdp-i16116383281.html",
        "sold": 0
    },
    {
        "product_name": "Li Xiang|บล็อกตัวต่อเสริมทักษะการเรียนรู้สำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbe80b9ee565d4e6382409a32d777a108Q.jpg_200x200q90.jpg",
        "price": 2354.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6031868848.html",
        "sold": 13
    },
    {
        "product_name": "[พร้อมส่ง!!!] Memory Game เกมกระดาน เกมจับคู่ เปิดภาพ บอร์ดเกม ของเล่น ของเล่นเสริมพัฒนาการ ฝึกความจำ (แบรนด์ GoGo Toys)",
        "product_image": "https://img.lazcdn.com/g/p/d543786e033c4f587f4de8c950f2d189.jpg_200x200q90.jpg",
        "price": 3900,
        "remark": "https://www.lazada.co.th/products/pdp-i2353483417.html",
        "sold": 0
    },
    {
        "product_name": "LALAPLAY | เกมฟุตบอลโต๊ะเพื่อการศึกษาแบบปฏิสัมพันธ์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd1d582b1a921478296059f9fa2e179e0j.jpg_200x200q90.jpg",
        "price": 3516.38,
        "remark": "https://www.lazada.co.th/products/pdp-i5878632398.html",
        "sold": 83
    },
    {
        "product_name": "【Zdandan】COD ไร้สาย การจำลองการเคลื่อนไหว 2.0 ของเล่นวิ่งอัจฉริยะ เสริมพัฒนาการรอบด้าน เกมแข่งรถ ของขวัญสำหรับเด็ก ไม่ต้องใช้จอ",
        "product_image": "https://img.lazcdn.com/g/p/f520e62d91b9196952ef73eb0d8ab030.jpg_200x200q90.jpg",
        "price": 2312,
        "remark": "https://www.lazada.co.th/products/pdp-i6024156639.html",
        "sold": 1
    },
    {
        "product_name": "มินเนี่ยนระเบิด Exploding Minions Board Game",
        "product_image": "https://img.lazcdn.com/g/p/46ca12a0b7cd701dd6b4fd070e51ddee.png_200x200q90.png",
        "price": 2300,
        "remark": "https://www.lazada.co.th/products/pdp-i5961632125.html",
        "sold": 0
    },
    {
        "product_name": "ชุดไดโนเสาร์ ไดโนเสาร์มิสชั่นส์ อลโลซอรัส MOC ชุดรถบรรทุกขนส่ง ของเล่นไดโนเสาร์สำหรับเด็ก ของเล่นสวนสนุกไดโนเสาร์ ของขวัญคริสต์มาส 76966",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2b17782810b140b89930927906be7b2cz.jpg_200x200q90.jpg",
        "price": 2245.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16099484411.html",
        "sold": 0
    },
    {
        "product_name": "【Clitomk】ของเล่นวิ่งอัจฉริยะ เกมการแข่งขันคู่ แทร็กการจําลองการเหนี่ยวนํา ระบบไร้สาย ของขวัญวันเกิด",
        "product_image": "https://img.lazcdn.com/g/p/b10689fa269f00bd817422441e6277dd.jpg_200x200q90.jpg",
        "price": 2238,
        "remark": "https://www.lazada.co.th/products/pdp-i5916884385.html",
        "sold": 2
    },
    {
        "product_name": "RABMIV | คอนโซลเกมพกพาสไตล์คลาสสิก ดูอัลแฮนด์ล รองรับการเล่นแบบหลายผู้เล่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbe3bcf4d5a5343f0953204193e9cf34cJ.jpg_200x200q90.jpg",
        "price": 2222,
        "remark": "https://www.lazada.co.th/products/pdp-i16064969310.html",
        "sold": 1
    },
    {
        "product_name": "JIHU | ของเล่นฝึกสมองสำหรับการแข่งขันสองคน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S70c2d3ba88024932880b78754ad33e78a.jpg_200x200q90.jpg",
        "price": 2222,
        "remark": "https://www.lazada.co.th/products/pdp-i6005801460.html",
        "sold": 3
    },
    {
        "product_name": "Yuecomfly ของเล่นวิ่งอัจฉริยะ ไร้สาย การจำลองการเคลื่อนไหว รางคู่ เกมเกมจำลองการแข่ง ของเล่นเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/cca9a4a7cb391c1fbfb96edecbfdd7c8.jpg_200x200q90.jpg",
        "price": 2198,
        "remark": "https://www.lazada.co.th/products/pdp-i16081546556.html",
        "sold": 0
    },
    {
        "product_name": "Brick | ตัวละครสร้างแบบ Saint Seiya Star Collection ชุดที่ 2",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se2bce72468f14a4e9a5f37373a35dd33a.jpg_200x200q90.jpg",
        "price": 2185.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16052896094.html",
        "sold": 0
    },
    {
        "product_name": "New R36S เกมคอนโซล Retro Game Console 128GB วิดีโอเกม เกมคอนโซลแบบพกพาสามารถชาร เครื่องเกมพกพา Gameboy",
        "product_image": "https://img.lazcdn.com/g/p/1ef44d74ba518f3ac0ae9b4d70f3ecf1.jpg_200x200q90.jpg",
        "price": 2160,
        "remark": "https://www.lazada.co.th/products/pdp-i5876567704.html",
        "sold": 1
    },
    {
        "product_name": "New คอนโซลเกม R36s ดั้งเดิมพร้อมชิปสองชิปคอนโซลแบบพกพาอาร์เคดย้อนยุค เกมเครื่องเกมอาร์เคด ของขวัญมือถือสําหรับเด็กผู้ชาย",
        "product_image": "https://img.lazcdn.com/g/p/1f41119a8da9a519fc25925f40c2a100.jpg_200x200q90.jpg",
        "price": 2160,
        "remark": "https://www.lazada.co.th/products/pdp-i5876592934.html",
        "sold": 11
    },
    {
        "product_name": "ตุ๊กตาเกมส์สำหรับเด็กชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdd7f17155e3d4289bc2fa4683994a9f93.jpg_200x200q90.jpg",
        "price": 2122,
        "remark": "https://www.lazada.co.th/products/pdp-i16087181441.html",
        "sold": 0
    },
    {
        "product_name": "PALONG | กระดานเกมส์การศึกษาหลายฟังก์ชันสำหรับเด็กชาย 5-12 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6ba1c875fa6043d0ab09d08ca061699bg.jpg_200x200q90.jpg",
        "price": 2093.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16049328393.html",
        "sold": 0
    },
    {
        "product_name": "ของเล่นฝึกคิดเพื่อการศึกษาสำหรับเด็กอายุ 3 ถึง 6 ปีเครื่องเกมปาจิงโกะเดสก์ท็อปเล่นเครื่องเกมพินบอลของเล่นแบบโต้ตอบพ่อแม่และลูกเพื่อออกกำลังกายเด็กชายและเด็กหญิงสมาธิ",
        "product_image": "https://img.lazcdn.com/g/p/748a7ab284f4dc9ebce88b9a790c16b4.jpg_200x200q90.jpg",
        "price": 2078,
        "remark": "https://www.lazada.co.th/products/pdp-i4595048967.html",
        "sold": 37
    },
    {
        "product_name": "RABMIV | คอนโซลเกมพกพาสไตล์เรโทร ขนาดเล็ก รองรับผู้เล่นเดี่ยวและคู่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0333df7464194463a88adc617deb25b81.jpg_200x200q90.jpg",
        "price": 2074,
        "remark": "https://www.lazada.co.th/products/pdp-i16065136228.html",
        "sold": 0
    },
    {
        "product_name": "ของเล่นรถบรรทุกเทท้ายควบคุมด้วยรีโมท",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfd8e7679e6d24bae8284926c3bfd47aec.jpg_200x200q90.jpg",
        "price": 2070,
        "remark": "https://www.lazada.co.th/products/pdp-i16089233524.html",
        "sold": 0
    },
    {
        "product_name": "รถตักของเล่นควบคุมระยะไกลขนาดใหญ่สำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S507f55e56d0540169e6030dfc2f0572bQ.jpg_200x200q90.jpg",
        "price": 2042,
        "remark": "https://www.lazada.co.th/products/pdp-i16089052931.html",
        "sold": 0
    },
    {
        "product_name": "เกมกระดานคลูบอร์ด - เกมสืบสวนคดีฆาตกรรมคลาสสิก |   เกมกระดานสำหรับครอบครัวและปาร์ตี้ สำหรับผู้เล่น 2-6 คน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb51ae5fb08a940bd8489067fcc16f6daR.jpg_200x200q90.jpg",
        "price": 1983.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16116428891.html",
        "sold": 0
    },
    {
        "product_name": "LONGGAO | ชุดบล็อกหุ่นยนต์แปลงร่าง ประกอบยาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd18d0a8cb8584154a4af627e7134c46eq.jpg_200x200q90.jpg",
        "price": 1982,
        "remark": "https://www.lazada.co.th/products/pdp-i16089458091.html",
        "sold": 0
    },
    {
        "product_name": "เกมส์งานวัด ทรงโจรสลัด เกมส์จุกน้ำปลาของเล่นงานวัด ไม้แข็งไม้เต็งแดง ทรงสวยไม้เรียบ เกมตุ๊กตาตกปาเป้าปาโป่ง เกมงานเลี้ยงอีเว้นท์",
        "product_image": "https://img.lazcdn.com/g/p/8d86d0f9885615d1b22e4a17e85759d7.jpg_200x200q90.jpg",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i5207722838.html",
        "sold": 0
    },
    {
        "product_name": "Q3 เกมคอนโซล Q3 Retro Mini Handheld Game Console จอ 4.3 นิ้ว 10000 เกมย้อนยุค 90 คลาสสิก 64GB",
        "product_image": "https://img.lazcdn.com/g/p/d908278c096f77f56cbc87e66714181a.png_200x200q90.png",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i5579310052.html",
        "sold": 1
    },
    {
        "product_name": "Q3 เกมคอนโซล เครื่องเล่นวิดีโอเกม จอ 4.3 นิ้ว 10,000 เกมย้อนยุค 90 คลาสสิก Retro Mini Handheld Game Console จัดส่งไว ส่งจากในกรุงเทพ",
        "product_image": "https://img.lazcdn.com/g/p/236edc85a9409dd56b56e4fb9d2f9eef.png_200x200q90.png",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i5579297072.html",
        "sold": 0
    },
    {
        "product_name": "รถปิคอัพของเล่นควบคุมระยะไกลขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5bb2334917c6486e9eae6123e1be8b08s.jpg_200x200q90.jpg",
        "price": 1954.44,
        "remark": "https://www.lazada.co.th/products/pdp-i16053036148.html",
        "sold": 0
    },
    {
        "product_name": "รถโมเดล 1:18 พร้อมรีโมทควบคุมเสียงและไฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2817adf83719407fbcd0c424375920b2S.jpg_200x200q90.jpg",
        "price": 1946,
        "remark": "https://www.lazada.co.th/products/pdp-i16089368195.html",
        "sold": 0
    },
    {
        "product_name": "New R36s เกมคอนโซลคอนโซลเกมย้อนยุค 128GB/64GB วิดีโอเกมคอนโซลเกมแบบพกพาสามารถชาร์จคอนโซลเกมแบบพกพา Gameboy PSP",
        "product_image": "https://img.lazcdn.com/g/p/3e3bf66724e4e7a7d2b490d88b14199a.jpg_200x200q90.jpg",
        "price": 1918,
        "remark": "https://www.lazada.co.th/products/pdp-i5876658518.html",
        "sold": 0
    },
    {
        "product_name": "Aoduoyaya COD ไร้สาย การจำลองการเคลื่อนไหว 2.0 ของเล่นวิ่งอัจฉริยะ เสริมพัฒนาการรอบด้าน เกมแข่งรถ ของขวัญสำหรับเด็ก ไม่ต้องใช้จอ",
        "product_image": "https://img.lazcdn.com/g/p/5654e40fb36aa3ccb36162d2717033a8.jpg_200x200q90.jpg",
        "price": 1916,
        "remark": "https://www.lazada.co.th/products/pdp-i6018449815.html",
        "sold": 3
    },
    {
        "product_name": "เกมตีตัวตุ่น - ของเล่นเสริมพัฒนาการแบบอินเทอร์แอคทีฟพร้อมเสียงและแสง เหมาะสำหรับเด็กชายและเด็กหญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa065021a71c041b281ffeffa08e2e84b6.jpg_200x200q90.jpg",
        "price": 1912.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5966566188.html",
        "sold": 0
    },
    {
        "product_name": "KAKABEIER | ชุดของเล่นรถขุดและรถยนต์สำหรับเด็กเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scb5a4cb2a5464efe85001a223f3e4839g.jpg_200x200q90.jpg",
        "price": 1902,
        "remark": "https://www.lazada.co.th/products/pdp-i5996944143.html",
        "sold": 2
    },
    {
        "product_name": "ToyVille ของเล่นวิ่งอัจฉริยะ เกมการแข่งขันคู่ แทร็กการจําลองการเหนี่ยวนํา ระบบไร้สาย ของขวัญวันเกิด",
        "product_image": "https://img.lazcdn.com/g/p/68cb7976626785b3f7ca22b42a4255e6.jpg_200x200q90.jpg",
        "price": 1852,
        "remark": "https://www.lazada.co.th/products/pdp-i5908075740.html",
        "sold": 8
    },
    {
        "product_name": "R36S เกมคอนโซล retro game console 128GB วิดีโอเกม เกมคอนโซลแบบพกพาสามารถชาร เครื่องเกมพกพา Gameboy PSP ของขวัญวันเกิด",
        "product_image": "https://img.lazcdn.com/g/p/2ff72fc7e2470e5535d23d4c1db51988.jpg_200x200q90.jpg",
        "price": 1798,
        "remark": "https://www.lazada.co.th/products/pdp-i5873701121.html",
        "sold": 2
    },
    {
        "product_name": "Play Game👉 เกมกระดาน What do you meme Board Game (ภาษาอังกฤษ) - บอร์ดเกม  สนุกมาก  มีจำกัด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sacd0dd4362ba4a568260299298ec87072.png_200x200q90.png",
        "price": 1790,
        "remark": "https://www.lazada.co.th/products/pdp-i3398881088.html",
        "sold": 0
    },
    {
        "product_name": "DRAGOMINO ดราโกมิโน่ [TH/EN] ภาษาไทย / English ห่อของขวัญฟรี [บอร์ดเกม Boardgame]",
        "product_image": "https://img.lazcdn.com/g/p/2d73f2799d155a8c21c57a9e8502be6f.jpg_200x200q90.jpg",
        "price": 1782,
        "remark": "https://www.lazada.co.th/products/pdp-i4522273164.html",
        "sold": 5
    },
    {
        "product_name": "MATTEL | เกมการ์ดปาร์ตี้แบบหลายผู้เล่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S58366e6a03a9498188c94ea3f22c285cc.jpg_200x200q90.jpg",
        "price": 1726,
        "remark": "https://www.lazada.co.th/products/pdp-i6025700262.html",
        "sold": 3
    },
    {
        "product_name": "PALONG | ของเล่นปืนธนูสำหรับเด็กผู้ชาย ของขวัญวันเกิด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S06de2f6beafd448da94ddf4d85168000P.jpg_200x200q90.jpg",
        "price": 1722,
        "remark": "https://www.lazada.co.th/products/pdp-i5996887626.html",
        "sold": 0
    },
    {
        "product_name": "1 ชุดเกมไพ่ปาร์ตี้แบบสื่อสารทางจิต 2-12 ผู้เล่น เกมกระดานปาร์ตี้ ภาษาอังกฤษ เกมวางแผนเพื่อความบันเทิง ของเล่นสำหรับครอบครัวในวันหยุด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2c07c54f31bd4048bf10a7c29466e0c69.jpg_200x200q90.jpg",
        "price": 1718.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6075671815.html",
        "sold": 0
    },
    {
        "product_name": "Hasbro | เกมกระดานโมโนโพลีฉบับโปเกมอน คันโต ฉบับโปเกมอน ความรู้สึกในวัยเด็ก เกมปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa3a17afd63604ebaa53d2ba5fd1e6d9fT.png_200x200q90.png",
        "price": 1717.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16102069151.html",
        "sold": 0
    },
    {
        "product_name": "เกมคอนโซล R36S แบบย้อนยุคระบบลินุกซ์ 3.5 นิ้ว 28000 เกม",
        "product_image": "https://img.lazcdn.com/g/p/2c035df7ba1e2d0ef5be149f62ae56b6.jpg_200x200q90.jpg",
        "price": 1710,
        "remark": "https://www.lazada.co.th/products/pdp-i5798255020.html",
        "sold": 1
    },
    {
        "product_name": "G90 7.0 นิ้วคอนโซลเกมพกพาแบบพกพาเรโทร อาร์เคด เกม GBA เครื่องเล่นเกมที่เข้ากันได้ 64G สำหรับการเดินทางเด็กผู้ใหญ่ของขวัญ",
        "product_image": "https://img.lazcdn.com/g/p/bf19e16e4f3b5dbcbeadfcae5b85e357.jpg_200x200q90.jpg",
        "price": 1698,
        "remark": "https://www.lazada.co.th/products/pdp-i16102249501.html",
        "sold": 0
    },
    {
        "product_name": "RABMIV | คอนโซลเกมพกพาสไตล์เรโทร ขนาดเล็ก รองรับสองผู้เล่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa1167deff52c42a19b6f96be7077d228y.jpg_200x200q90.jpg",
        "price": 1696,
        "remark": "https://www.lazada.co.th/products/pdp-i16064982944.html",
        "sold": 0
    },
    {
        "product_name": "เกมคอนโซลแข่งโต๊ะไฟฟ้าเพื่อการศึกษา, ความท้าทายในการผจญภัย, พวงมาลัยขับรถจําลอง, ของเล่นเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5828158d5109414e850254e72f7420adL.jpg_200x200q90.jpg",
        "price": 1679.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6002219835.html",
        "sold": 0
    },
    {
        "product_name": "[สินค้าขายดี] Kushi Express คูชิ จานด่วน ภาษาไทย [TH] ห่อของขวัญฟรี [บอร์ดเกม Boardgame]",
        "product_image": "https://img.lazcdn.com/g/p/ca17f5592508ff6c05fa05c14f9150a2.jpg_200x200q90.jpg",
        "price": 1672,
        "remark": "https://www.lazada.co.th/products/pdp-i1068836815.html",
        "sold": 9
    },
    {
        "product_name": "So Clover! ห่อของขวัญฟรี [บอร์ดเกม Boardgame]",
        "product_image": "https://img.lazcdn.com/g/p/ca0218c9d371b8c596d5f1f8d57625a0.jpg_200x200q90.jpg",
        "price": 1656,
        "remark": "https://www.lazada.co.th/products/pdp-i2776995737.html",
        "sold": 2
    },
    {
        "product_name": "ของเล่นสร้างสรรค์โต๊ะประกอบศึกษา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sba17b85330764049a9d8bf6584d42497A.png_200x200q90.png",
        "price": 1645.66,
        "remark": "https://www.lazada.co.th/products/pdp-i6031786555.html",
        "sold": 1
    },
    {
        "product_name": "Hasbro | เกมกระดานสะสมฉลองครบรอบ 60 ปี Grateful Dead Monopoly สำหรับแฟนๆ และผู้เล่นแนวร็อค",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4c1a35f9d4a64d67a477525cc227b8983.png_200x200q90.png",
        "price": 1643.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16104119891.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องเกมพินบอลอวกาศ เล่นเกมยิงลูกแก้ว เครื่องเกมปริศนาตั้งโต๊ะ ของเล่นสำหรับเด็กอายุ 3 ถึง 6 ขวบ ฝึกสมาธิ",
        "product_image": "https://img.lazcdn.com/g/p/45ea6be752c8789cda889f51eba9a43f.jpg_200x200q90.jpg",
        "price": 1634,
        "remark": "https://www.lazada.co.th/products/pdp-i5741949395.html",
        "sold": 1
    },
    {
        "product_name": "เกมกระดานโมโนโพลีธีมออซซี่ ออสบอร์น ระดับพรีเมียม |   ของสะสมสำหรับแฟนเพลงเฮฟวีเมทัลและกิจกรรมสนุกๆ สำหรับครอบครัว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8695a9de56d9449b9925b21ce333782aw.png_200x200q90.png",
        "price": 1632.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16104532167.html",
        "sold": 0
    },
    {
        "product_name": "ชุดแบ็คแกมมอนแบบพกพาเกมกระดานคลาสสิกแบบม้วนขึ้นไมโครไฟเบอร์และหนัง PU เกมกระดานคลาสสิกเกมกระดานแบ็คแกมมอนหมากรุก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S75f0c59dbf7746768a103f16096edacfp.jpg_200x200q90.jpg",
        "price": 1625.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5939146263.html",
        "sold": 0
    },
    {
        "product_name": "XIAOGUAIDAN | เกมกระดานสำหรับครอบครัว ท้าทายความฉลาด Red Riding Hood",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf46474a556ce42cb876921cacd7b25f6A.jpg_200x200q90.jpg",
        "price": 1619.66,
        "remark": "https://www.lazada.co.th/products/pdp-i6066799693.html",
        "sold": 2
    },
    {
        "product_name": "ของเล่นแผ่นเต้นรำ เกมเต้นรำอิเล็กทรอนิกส์สำหรับเด็ก พร้อมโหมดเกมหลากหลาย ของขวัญวันเกิดที่เหมาะสำหรับเด็กอายุ 3 ปีขึ้นไป",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S80e6eac2487843108f4f94a50f066de1O.jpg_200x200q90.jpg",
        "price": 1617.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6070024069.html",
        "sold": 0
    },
    {
        "product_name": "2025 รุ่นใหม่ 7 สี  R36H คอนโซลเกมพกพาแบบโอเพ่นซอร์ส   คอนโซลพกพาแบบย้อนยุค เกมส์สุดคลาสสิก",
        "product_image": "https://img.lazcdn.com/g/p/0d378b9e84942a8aa5f7f00aed073c04.jpg_webp_200x200q90.jpg",
        "price": 1616.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5835779563.html",
        "sold": 0
    },
    {
        "product_name": "Now เกมคอนโซล R36S แบบย้อนยุคระบบลินุกซ์ 3.5 นิ้ว 28000 เกม",
        "product_image": "https://img.lazcdn.com/g/p/01a39c5cbdd703117e8c354cb188459c.jpg_200x200q90.jpg",
        "price": 1598,
        "remark": "https://www.lazada.co.th/products/pdp-i5873669373.html",
        "sold": 2
    },
    {
        "product_name": "Mattel Game Pictionary เกมวาดภาพทายคำ รุ่น DKD47",
        "product_image": "https://img.lazcdn.com/g/p/16621961af3209a439fbbd42d1b445cb.jpg_200x200q90.jpg",
        "price": 1598,
        "remark": "https://www.lazada.co.th/products/pdp-i5798822698.html",
        "sold": 1
    },
    {
        "product_name": "【ส่งจากไทย+COD】R36S เกมพกพา 64GB 20,000+ เกม ปลุกพลังเกมในตัวคุณด้วย ภาพคมชัด3D ราคาคุ้มสุดจบใน เครื่องเดียว",
        "product_image": "https://img.lazcdn.com/g/p/1fb7db538ae0d6edd53e343bcb583a1e.jpg_200x200q90.jpg",
        "price": 1594,
        "remark": "https://www.lazada.co.th/products/pdp-i5928477002.html",
        "sold": 4
    },
    {
        "product_name": "[ของแท้] บอร์ดเกมลดราคาพิเศษ ประจำLive เกมกล่องกลาง(1000-3000) เกมมือ1ลดราคากล่องบุบ/กล่องมีตำหนิ/กล่องมือสองสภาพดี",
        "product_image": "https://img.lazcdn.com/g/p/182da24b2634c292d5d3bf34086a15be.jpg_200x200q90.jpg",
        "price": 1590,
        "remark": "https://www.lazada.co.th/products/pdp-i646292110.html",
        "sold": 7
    },
    {
        "product_name": "SMART GAMES, Jump In ของเล่นฝึกสมอง เสริมเชาว์ สำหรับเด็ก 7 ปีขึ้นไป ลิขสิทธิ์แท้ จากเบลเยียม ร้านเป็นตัวแทนจำหน่ายในไทย",
        "product_image": "https://img.lazcdn.com/live/th/p/ce31cf63cf4acff360d9c91e85f994d8.jpg_200x200q90.jpg",
        "price": 1584,
        "remark": "https://www.lazada.co.th/products/pdp-i135980255.html",
        "sold": 4
    },
    {
        "product_name": "SMART GAMES, Asteroid Escape ของเล่นฝึกสมอง เสริมเชาว์ สำหรับเด็ก 8 ปีขึ้นไป ลิขสิทธิ์แท้ จากเบลเยียม ร้านเป็นตัวแทนจำหน่ายในไทย",
        "product_image": "https://img.lazcdn.com/g/p/6d9a4993996b97014d781fbf2da7c72e.jpg_200x200q90.jpg",
        "price": 1584,
        "remark": "https://www.lazada.co.th/products/pdp-i263955809.html",
        "sold": 5
    },
    {
        "product_name": "R36S เกมคอนโซล retro game console 128GB 40000+game วิดีโอเกม เกมคอนโซลแบบพกพาสามารถชาร เครื่องเกมพกพา ของขวัญวันเกิด",
        "product_image": "https://img.lazcdn.com/g/p/751b42b890b5c3bd7482c6ffe0c13ead.jpg_200x200q90.jpg",
        "price": 1566.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5915327731.html",
        "sold": 2
    },
    {
        "product_name": "รถของเล่นควบคุมระยะไกลสำหรับเด็กชาย 6-10 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbb832897075944dfbc18e843ce66e826j.jpg_200x200q90.jpg",
        "price": 1555.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6066320710.html",
        "sold": 0
    },
    {
        "product_name": "เกมกระดาน 106 ชิ้น เกมรัมมิกับไม้ 106 แผ่น ชุดเดินทาง กระดานรัมมี่ พร้อมกล่องพกพา เกมกระดานคลาสสิก เกมสำหรับผู้เล่นหลายคน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S88746d27485449f6a4ad0d278d463b12A.jpg_200x200q90.jpg",
        "price": 1552.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16055547060.html",
        "sold": 0
    },
    {
        "product_name": "ลูกบอลหลบหลีกแรงโน้มถ่วง ThinkFun | เกมตรรกะการสร้างทางวิ่งลูกแก้ว 3 มิติ | เกมฝึกสมอง STEM สำหรับเด็กอายุ 8 ปีขึ้นไป | ของเล่นเสริมพัฒนาการด้านการคิดเชิงพื้นที่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3d46f07b721c453687e9f29ce30fc9bbn.jpg_200x200q90.jpg",
        "price": 1545.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16073233552.html",
        "sold": 0
    },
    {
        "product_name": "คอนโซลเกมแบบพกพา LIXADA 3นิ้วจอ HD AV Output คอนโซลเกมย้อนยุคสร้างขึ้นในหลายเกมพร้อมที่จับสีดำ",
        "product_image": "https://img.lazcdn.com/g/p/7185705fca2e1c0a1378e23abbc21e68.jpg_200x200q90.jpg",
        "price": 1536,
        "remark": "https://www.lazada.co.th/products/pdp-i6078230305.html",
        "sold": 0
    },
    {
        "product_name": "421 ชิ้น ชุดตัวต่อคอนโซลเกมสะสม ของเล่นสร้างสรรค์ DIY ของขวัญคริสต์มาสสำหรับเด็ก ของขวัญสำหรับเด็กชาย เด็กหญิง และเพื่อนๆ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S49a7f68fd7a74f57ba52b27f7153abddF.jpg_200x200q90.jpg",
        "price": 1521.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16095468525.html",
        "sold": 0
    },
    {
        "product_name": "เกมโต๊ะลูกแก้วสำหรับเด็ก เกมยิงลูกแก้วจระเข้บนโต๊ะ พร้อมไฟและเสียงเพลง ของเล่นเสริมสร้างปฏิสัมพันธ์ระหว่างพ่อแม่ลูก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbc4833203c274c3cac7c307c471fbfe5O.jpg_200x200q90.jpg",
        "price": 1512.94,
        "remark": "https://www.lazada.co.th/products/pdp-i16108969300.html",
        "sold": 0
    },
    {
        "product_name": "HABA LogiCase กล่องวิเคราะห์เหตุผลสำหรับเด็กวัย 4 ปี 5 ปี 6 ปี 7 ปี โต๊ะเล่นเกมแบบคิดวิเคราะห์ ของเล่นการศึกษาสำหรับเด็ก ของเล่นกระดาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2fb726dd938f426584f009f6851e10a3h.jpg_200x200q90.jpg",
        "price": 1504.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5647228926.html",
        "sold": 1
    },
    {
        "product_name": "Game at home🔸 Hive Board game - บอร์ดเกม หมากแมลง",
        "product_image": "https://img.lazcdn.com/g/p/95ebdede08b35da854001f3ccbbe9157.png_200x200q90.png",
        "price": 1504,
        "remark": "https://www.lazada.co.th/products/pdp-i2913149248.html",
        "sold": 0
    },
    {
        "product_name": "ชุด DIY ของเล่นนุ่มๆ พร้อมผิวภายนอกและไส้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfab78f115e7b4efdad1db5411fef2942u.jpg_200x200q90.jpg",
        "price": 1462.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16083731714.html",
        "sold": 0
    },
    {
        "product_name": "ของเล่นแผ่นเต้นรำ เกมเต้นรำอิเล็กทรอนิกส์สำหรับเด็ก พร้อมโหมดเกมอเนกประสงค์ ไฟ LED ของขวัญวันเกิดที่เหมาะสำหรับเด็กชายและเด็กหญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S72a566bd4b434c6fa21a187f897cf785Y.jpg_200x200q90.jpg",
        "price": 1455.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16046160655.html",
        "sold": 0
    },
    {
        "product_name": "เกมโต๊ะพ่อแม่ลูก แบบจับกระต่ายเพื่อการศึกษาและปฏิสัมพันธ์สำหรับเด็กชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6ad5e0b951394c318cf28eec99204a46V.jpg_200x200q90.jpg",
        "price": 1451.96,
        "remark": "https://www.lazada.co.th/products/pdp-i6022308280.html",
        "sold": 7
    },
    {
        "product_name": "เกมแข่งม้าไฟฟ้า เกมกระดานสนุกสำหรับครอบครัว เด็กและผู้ใหญ่ ของเล่นฟุตบอลบนโต๊ะสุดเร้าใจสำหรับงานปาร์ตี้ เกมเล่นง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sba89ef3ce5624ecd9a1f901f9ec4e07ds.jpg_200x200q90.jpg",
        "price": 1445.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16046308347.html",
        "sold": 0
    },
    {
        "product_name": "GUTIAN | ชุดของเล่นรถขุดสำหรับเด็กอายุ 3-6 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1733b192e2d0432d8dc4c5d165c5e5efI.jpg_200x200q90.jpg",
        "price": 1430.98,
        "remark": "https://www.lazada.co.th/products/pdp-i6071782925.html",
        "sold": 3
    },
    {
        "product_name": "MENGTELI | ของเล่นปริศนาสำหรับเด็ก 1-2 ปี บล็อกสีไม้ Montessori",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdbb3d0fa3e7a43d6ac206012610057e8O.jpg_200x200q90.jpg",
        "price": 1419.36,
        "remark": "https://www.lazada.co.th/products/pdp-i5996809906.html",
        "sold": 0
    },
    {
        "product_name": "เกมกระดานเกาหลี เกมไพ่ กลยุทธ์การจัดการเกมปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfb4a5f15736f4932ab64a01cfd2b4b56R.jpg_200x200q90.jpg",
        "price": 1405.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5977497318.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเกมรัมมี่ขนาดใหญ่พิเศษสำหรับการเดินทาง เกมไพ่ดึงเลขสำหรับผู้ใหญ่ เกมบนโต๊ะสำหรับการสังสรรค์แบบสบายๆ ของเล่นเสริมพัฒนาการ ของขวัญ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa98385e9ab094686bf13182b79835ae49.jpg_200x200q90.jpg",
        "price": 1393.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5950972028.html",
        "sold": 0
    },
    {
        "product_name": "พรุ่งนี้รวย [TH] ภาษาไทย เกมคนไทย โดยนักออกแบบไทย ห่อของขวัญฟรี [บอร์ดเกม Boardgame]",
        "product_image": "https://img.lazcdn.com/g/p/518ec4975d7ed474c35d49e0e6f10ec3.jpg_200x200q90.jpg",
        "price": 1380,
        "remark": "https://www.lazada.co.th/products/pdp-i16063061809.html",
        "sold": 0
    },
    {
        "product_name": "มาใหม่MONOPOLY-Game of Thrones เกมกระดาน English Collection Edition PARTY friend Game",
        "product_image": "https://img.lazcdn.com/g/p/84840a3973b24016b97c7aa780e09fab.png_200x200q90.png",
        "price": 1378,
        "remark": "https://www.lazada.co.th/products/pdp-i808068095.html",
        "sold": 73
    },
    {
        "product_name": "เกมรางวิ่งลูกแก้วไม้ ของเล่นเสริมพัฒนาการ STEM สำหรับเด็ก เกมกระดานฝึกสมองสำหรับเด็กชายและเด็กหญิง ของขวัญวันเกิด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5a35a5596dd6413b864b0bd3ead6b8c4D.jpg_200x200q90.jpg",
        "price": 1376.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16106667696.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องเล่นเกมเทตริสหน้าจอใหญ่ 4.1 นิ้ว รุ่นใหม่ สไตล์ย้อนยุค สำหรับเด็ก เครื่องเล่นเกมพกพา ของเล่นปริศนาในวัยเด็ก ของเล่นเสริมพัฒนาการ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scc5058ea489c4774b1fc68d5aadc110b7.jpg_200x200q90.jpg",
        "price": 1362.18,
        "remark": "https://www.lazada.co.th/products/pdp-i16097868781.html",
        "sold": 0
    },
    {
        "product_name": "ของเล่นเด็กเสริมพัฒนาการแบบมอนเตสซอรี่ เกมผจญภัยรางหลายชั้น ลูกบอลกลิ้งแบบราง ของเล่นเสริมสร้างพัฒนาการสมอง ของขวัญคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6a32cb5b1ced4982a0a94d085a5ae59bL.jpg_200x200q90.jpg",
        "price": 1332.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5988091530.html",
        "sold": 0
    },
    {
        "product_name": "เกมโปเกมอนปิกาจูเวอร์ชั่นภาษาอังกฤษอสังหาริมทรัพย์สำหรับผู้ใหญ่และเด็ก2-6คนเกมสำหรับงานเลี้ยงวันเกิดของขวัญสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S40fd6d1230e847ca9836ee4da6b6edf8D.jpg_200x200q90.jpg",
        "price": 1328.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5862183575.html",
        "sold": 0
    },
    {
        "product_name": "MUZHAN | เครื่องทำเม็ดอาหารสัตว์ขนาดเล็ก แห้ง-เปียก ใช้งานได้ทั้งสองแบบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5cb724a4192c4003b165936150fbedcfd.jpg_200x200q90.jpg",
        "price": 80581.38,
        "remark": "https://www.lazada.co.th/products/pdp-i16097639601.html",
        "sold": 0
    },
    {
        "product_name": "Joyoung | เครื่องทำนมถั่วเหลือง สำหรับบ้าน แบบอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S02ae93cedc914d759d0464a589cf86bac.png_200x200q90.png",
        "price": 40675.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16051328024.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องหั่นหมูสแตนเลส แบบตั้งพื้น ถอดหัวได้ 2200วัตต์ ประกันมอเตอร์ 1ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfa5bcc1360b84487b1bfa97877c06699Z.jpg_200x200q90.jpg",
        "price": 35000,
        "remark": "https://www.lazada.co.th/products/pdp-i16082757115.html",
        "sold": 0
    },
    {
        "product_name": "bixdo | แปรงสีฟันไฟฟ้าสีขาวลดแสงสีน้ำเงิน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S90de931351da436babeeb0509ed31c07Z.png_200x200q90.png",
        "price": 19519.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5952368175.html",
        "sold": 413
    },
    {
        "product_name": "ZHONGJIA |เครื่องตัดกระดูกไฟฟ้าขนาดเล็กสำหรับใช้ในบ้าน ตัดเท้าหมู กระดูกซี่โครง และกระดูกวัว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sedc7e28e38b34b2c810c0a65fb6bb548Y.jpg_200x200q90.jpg",
        "price": 17273.46,
        "remark": "https://www.lazada.co.th/products/pdp-i5938200775.html",
        "sold": 133
    },
    {
        "product_name": "หมอทอดไรนำมน Steamcook Basic 12 ลตร สครมไวท รน AV12E10CC",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6fb696d8d7c540f391243f550e2276b2i.png_200x200q90.png",
        "price": 17261.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5950646180.html",
        "sold": 0
    },
    {
        "product_name": "Ninja Foodi Power Mixer System CI100TH เครื่องปั่นมือถือ 3in1 เครื่องตี เครื่องสับ Hand Blender Chopper Mixer 850W ปรับความเร็วได้",
        "product_image": "https://img.lazcdn.com/g/p/532d9b9a11fe17cd65d169178833c617.png_200x200q90.png",
        "price": 15960,
        "remark": "https://www.lazada.co.th/products/pdp-i16101370218.html",
        "sold": 0
    },
    {
        "product_name": "Sooop ที่หั่นอาหารไฟฟ้าปรับความหนาได้110V พร้อมใบมีดสแตนเลสเครื่องตัดเนื้อขนาดกะทัดรัดสำหรับชีสขนมปังเนื้อบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/79dad28fd0f635820e1a13fda496e96b.jpg_200x200q90.jpg",
        "price": 14352,
        "remark": "https://www.lazada.co.th/products/pdp-i6052218286.html",
        "sold": 0
    },
    {
        "product_name": "ฮีตเตอร์แบบเหนี่ยวนำ ZVS 2500สำหรับการหลอมโลหะและการหลอมโลหะแบบ DIY",
        "product_image": "https://img.lazcdn.com/g/p/ab4939efedcb99c25b0dcd3c5db179f4.jpg_200x200q90.jpg",
        "price": 11596,
        "remark": "https://www.lazada.co.th/products/pdp-i6004611223.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องทำฮีตเตอร์ต่อประกบเซ็นเซอร์อัจฉริยะเครื่องต่อใยแก้วนำแสงหลอมรวมอิสระกับแบตเตอรี่โทรศัพท์ Li ชาร์จซ้ำได้สำหรับงานกลางแจ้งฮีตเตอร์ความร้อน",
        "product_image": "https://img.lazcdn.com/g/p/22c6279de3c286f3790c2aca73dd7200.jpg_200x200q90.jpg",
        "price": 11274,
        "remark": "https://www.lazada.co.th/products/pdp-i6052171971.html",
        "sold": 0
    },
    {
        "product_name": "KELAJI | โต๊ะรีดผ้าดูดเองไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saf5f549debec4b1399a9f3e95c86b3b63.jpg_200x200q90.jpg",
        "price": 10826.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16074921267.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องคั้นน้ำผลไม้พร้อมแยกกากหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se3235d9f8c784701b6e5fdb4d138b9841.jpg_200x200q90.jpg",
        "price": 10201.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5874173767.html",
        "sold": 10
    },
    {
        "product_name": "Mischief | เครื่องบดกาแฟไฟฟ้า MisChief Mini ใบมีด 7 แฉก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S05841e8c36274449883a03cabbd0aaa2c.jpg_200x200q90.jpg",
        "price": 9855.78,
        "remark": "https://www.lazada.co.th/products/pdp-i6066805349.html",
        "sold": 1
    },
    {
        "product_name": "Ninja Blast™ เครื่องปั่นพกพาไร้สาย 18 ออนซ์ กะทัดรัด ชาร์จไฟได้ (ปั่นได้ 10 ครั้ง/ชาร์จ)",
        "product_image": "https://img.lazcdn.com/g/p/f128b65beafc08d18e92a97cdb73ba92.png_200x200q90.png",
        "price": 8900,
        "remark": "https://www.lazada.co.th/products/pdp-i5887452795.html",
        "sold": 0
    },
    {
        "product_name": "Hurma | เครื่องคั้นน้ำผลไม้อัตโนมัติแยกชั้นกาก ป้อนอาหารได้มาก ทำความสะอาดง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S17616afa2de94392bb06aa82d873176bm.jpg_200x200q90.jpg",
        "price": 8650.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5877019314.html",
        "sold": 17
    },
    {
        "product_name": "Liven | เครื่องทำอาหารทอดไร้น้ำมันแบบไม่ต้องเคลือบ ความจุใหญ่ แหล่งความร้อนคู่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2172d1ca295645528d41055498a3c9dcI.png_200x200q90.png",
        "price": 7855.66,
        "remark": "https://www.lazada.co.th/products/pdp-i5968591761.html",
        "sold": 427
    },
    {
        "product_name": "APIXINTL | เครื่องทำอาหารอัตโนมัติเต็มรูปแบบสำหรับใช้ในบ้าน พร้อมฟังก์ชันหลายอย่าง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S380bbbdf925b4a449d10951cb7770a1ae.png_200x200q90.png",
        "price": 7413.32,
        "remark": "https://www.lazada.co.th/products/pdp-i5880036187.html",
        "sold": 8
    },
    {
        "product_name": "Maxwin | กาต้มน้ำไฟฟ้าอัตโนมัติพร้อมกันความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S73faf881398d4347b6d266c01fa1ff70K.png_200x200q90.png",
        "price": 7147.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5981438272.html",
        "sold": 68
    },
    {
        "product_name": "กาน้ำชาแบบไฟฟ้า ทเมคเกอร์ กาต้มน้ำแก้ว 308Tx2",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3c3fbca3cf0340f78d28dbd9a4bf6dfcQ.png_200x200q90.png",
        "price": 6219.02,
        "remark": "https://www.lazada.co.th/products/pdp-i5965762077.html",
        "sold": 0
    },
    {
        "product_name": "Joyoung | เครื่องปั่นขนาดครอบครัวเล็ก หลายฟังก์ชัน อัตโนมัติ เงียบ ทำความสะอาดง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S73864c96351240ae8143cf0323a4ff45i.png_200x200q90.png",
        "price": 5993.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16050749006.html",
        "sold": 0
    },
    {
        "product_name": "DANBIYIN | เครื่องบดเนื้อไฟฟ้า สำหรับใช้ในเชิงพาณิชย์และที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb521bc417fa04d87bcbde5c27e53ccaeT.jpg_200x200q90.jpg",
        "price": 5893.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16060646210.html",
        "sold": 0
    },
    {
        "product_name": "YIYUE | เครื่องสกัดน้ำผลไม้หลายฟังก์ชัน ความจุมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9086870a46884ec8aec6b984c124ccb4Y.jpg_200x200q90.jpg",
        "price": 5870.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5929437565.html",
        "sold": 1
    },
    {
        "product_name": "SUNATUR | เครื่องแปรรูปอาหารอัตโนมัติหลายฟังก์ชันสำหรับบ้านและธุรกิจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf6c7147e17d7407e81dae259457dc7a6Z.png_200x200q90.png",
        "price": 5564.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5875520180.html",
        "sold": 20
    },
    {
        "product_name": "Ukey | เครื่องหนีบผมไอน้ำเย็นประจุลบอ่อนโยน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se85085845738486eac4b9ea671c88f9da.png_200x200q90.png",
        "price": 5360.76,
        "remark": "https://www.lazada.co.th/products/pdp-i5990987641.html",
        "sold": 35
    },
    {
        "product_name": "AUX | เตาอบหลายฟังก์ชันสำหรับบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa962cfffd2194bb183278384a5cf50bei.png_200x200q90.png",
        "price": 5358,
        "remark": "https://www.lazada.co.th/products/pdp-i6006001655.html",
        "sold": 101
    },
    {
        "product_name": "Liven | เครื่องปั่นและทำนมถั่วเหลืองเงียบหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1cc04c3faabd4a8ea2437934faec2474v.jpg_200x200q90.jpg",
        "price": 5283.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5968615770.html",
        "sold": 108
    },
    {
        "product_name": "LONGKE | เครื่องผสมปูนและคอนกรีตแบบมือถือพลังสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S69077ffe51e54f9ba283192c9330d7a65.jpg_200x200q90.jpg",
        "price": 5212.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5910872099.html",
        "sold": 29
    },
    {
        "product_name": "NEW 2025 BABYKO เครื่องปั่นและนึ่งอาหารเด็กมาพร้อมใบมีดรุ่นใหม่ สแตนเลสแท้ สามารถปั่น นึ่ง อุ่นได้มากกว่าถึง 10 เมนู",
        "product_image": "https://img.lazcdn.com/g/p/0e1a6b389b42349d9cd1465b8ac7f888.jpg_200x200q90.jpg",
        "price": 4990,
        "remark": "https://www.lazada.co.th/products/pdp-i5794286674.html",
        "sold": 5
    },
    {
        "product_name": "Joyoung | เครื่องปั่นขนาดเล็กอัตโนมัติไม่ทิ้งเศษ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S49f7e9d6c84e4524ad76233a1006f526g.png_200x200q90.png",
        "price": 4774.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16051208387.html",
        "sold": 0
    },
    {
        "product_name": "ถังน้ำไฟฟ้าความจุใหญ่ ทำความร้อนอัตโนมัติ กันความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S19b283a1278d42178ac42a303228a501F.jpg_200x200q90.jpg",
        "price": 4703.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16102729792.html",
        "sold": 0
    },
    {
        "product_name": "MONGDIO | เครื่องบดกาแฟไฟฟ้าปริมาณแน่นอนแกนเหล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sda61f914e60c461186570f366146ed2b3.jpg_200x200q90.jpg",
        "price": 4695.38,
        "remark": "https://www.lazada.co.th/products/pdp-i6066488431.html",
        "sold": 5
    },
    {
        "product_name": "LONGKE | เครื่องผสมอาหารและคอนกรีตอุตสาหกรรมไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb477ec0d63254b48be67bc9bfd4363fd4.jpg_200x200q90.jpg",
        "price": 4359.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5910863482.html",
        "sold": 33
    },
    {
        "product_name": "LONGKE | เครื่องผสมปูนซีเมนต์ไฟฟ้ากำลังสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd3e456b04b5c430d92afee02cb2b1828Z.jpg_200x200q90.jpg",
        "price": 4322.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5910865292.html",
        "sold": 11
    },
    {
        "product_name": "HDBROS | กาต้มน้ำไฟฟ้าควบคุมอุณหภูมิสำหรับชากาแฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S599899495ff74ea29d1fd1fb447ce6d4S.jpg_200x200q90.jpg",
        "price": 4258.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5996975168.html",
        "sold": 26
    },
    {
        "product_name": "JIEXG | กาต้มน้ำไฟฟ้าพกพาสำหรับป้อนอาหารเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sff1b7d83ecb44628b96b890d514e8f43s.png_200x200q90.png",
        "price": 4241.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6019051904.html",
        "sold": 24
    },
    {
        "product_name": "ไมโครเวฟ เตาไมโครเวฟ ระบบลูกบิด ความจุสูง 28L กำลังไฟสูง 2200W ทำความร้อน 360° รับประกัน 3ปี",
        "product_image": "https://img.lazcdn.com/g/p/18c86af19daf47a374db68a2320d8f67.jpg_200x200q90.jpg",
        "price": 4598,
        "remark": "https://www.lazada.co.th/products/pdp-i6069889016.html",
        "sold": 24
    },
    {
        "product_name": "ท่อทำความร้อนสแตนเลสกำลังสูง หม้อต้มไฟฟ้าอุตสาหกรรม เครื่องทำความร้อนน้ำมันความร้อน วิศวกรรมน้ำ เสื้อกล้าม แท่ง 380V",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4f80a3a330e74480b0dd45c0aa726f22i.jpg_200x200q90.jpg",
        "price": 4172.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6026155227.html",
        "sold": 0
    },
    {
        "product_name": "JIEXG กาต้มน้ำอุณหภูมิคงที่ขนาดเล็กพกพาได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se131bfce47a4495c849221f3fbf40d72l.jpg_200x200q90.jpg",
        "price": 4153.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6019214161.html",
        "sold": 22
    },
    {
        "product_name": "Royalty Line | แก้วปั่นนมถั่วเหลืองมินิ ไม่ต้องกรอง ชาร์จ USB สำหรับ 1 คน ปั่นสมูทตี้/ซุปได้",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Seeb927e1ecea4ccbbb8c9719d40755c6o.jpg_200x200q90.jpg",
        "price": 4135.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6019155314.html",
        "sold": 192
    },
    {
        "product_name": "JIEXG | กาต้มน้ำพกพาพร้อมระบบทำความร้อนและเก็บความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8387145f88034711aff24c3d5afb4d5eC.jpg_200x200q90.jpg",
        "price": 4127.92,
        "remark": "https://www.lazada.co.th/products/pdp-i6019142303.html",
        "sold": 20
    },
    {
        "product_name": "YIYUE | เครื่องทำอาหารไร้น้ำมัน ความจุใหญ่ มองเห็นได้ ไม่ต้องกลับด้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc44fe4eac5984afca37cefa80b35773fp.jpg_200x200q90.jpg",
        "price": 4118.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6019175189.html",
        "sold": 0
    },
    {
        "product_name": "FANGTAITAI | เครื่องบดอเนกประสงค์สำหรับการใช้งานเชิงพาณิชย์และในบ้าน บดเป็นผงละเอียดสูง",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Se7f6e7173d134fc89a9a1c20c46a8687Y.png_200x200q90.png",
        "price": 4052.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5876971478.html",
        "sold": 69
    },
    {
        "product_name": "Bear | กระทะไฟฟ้าไม่ติดกระทะ ลึก หลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4d2181fad2664fefa3b097522859624eO.jpg_200x200q90.jpg",
        "price": 4022.08,
        "remark": "https://www.lazada.co.th/products/pdp-i5878398561.html",
        "sold": 130
    },
    {
        "product_name": "มันคือกล่องไดโอดบริดจ์ ติดตั้งกับแอร์บ้านที่เป็นระบบ อินเวอร์เตอร์ ทำหน้าที่ผสมไฟฟ้ากับโซล่าเซลล์ สำหรับแอร์ 9000-24000",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sda6d4479ce5c44f98140a023b899e2563.jpg_200x200q90.jpg",
        "price": 3996,
        "remark": "https://www.lazada.co.th/products/pdp-i16116214626.html",
        "sold": 0
    },
    {
        "product_name": "JIEXG | กาต้มน้ำไฟฟ้าสแตนเลสพกพา ความจุมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Safd5c00e85c345819e231cfe66e2f71aG.png_200x200q90.png",
        "price": 3971.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6019133249.html",
        "sold": 118
    },
    {
        "product_name": "JIEXG | กาต้มน้ำไฟฟ้าพกพาพร้อมฉนวนกันความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5435c4801e684b1090d78583813a92abz.jpg_200x200q90.jpg",
        "price": 3970.8,
        "remark": "https://www.lazada.co.th/products/pdp-i6019106586.html",
        "sold": 23
    },
    {
        "product_name": "LONGKE | เครื่องผสมอาหารไฟฟ้าขนาดเล็กสำหรับครัวเรือน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb477ec0d63254b48be67bc9bfd4363fd4.jpg_200x200q90.jpg",
        "price": 3870.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5910846166.html",
        "sold": 1
    },
    {
        "product_name": "YIYUE | เครื่องทอดลมร้อนความจุใหญ่หลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S394105639c7d4c1fbc05a3f9fbeb57e5i.png_200x200q90.png",
        "price": 3818.9,
        "remark": "https://www.lazada.co.th/products/pdp-i6019192260.html",
        "sold": 1
    },
    {
        "product_name": "JIEXG | กาต้มน้ำไฟฟ้าพกพาขนาดเล็กสำหรับเดินทาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa9366811c124436394c118b5dfd41602l.jpg_200x200q90.jpg",
        "price": 3744.82,
        "remark": "https://www.lazada.co.th/products/pdp-i6019153249.html",
        "sold": 153
    },
    {
        "product_name": "mixwin | กาต้มน้ำไฟฟ้าอัตโนมัติสำหรับทำชาขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S54aa97a2dd414566ab650b3dafbe06a0n.jpg_200x200q90.jpg",
        "price": 3579.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5981196659.html",
        "sold": 103
    },
    {
        "product_name": "LONGKE | เครื่องผสมไฟฟ้ากำลังสูงสำหรับปูนซีเมนต์ สี และปูนฉาบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scccca1d8c00b4042a0f2cb243be735be0.jpg_200x200q90.jpg",
        "price": 3368.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5910939262.html",
        "sold": 1
    },
    {
        "product_name": "Sharp กระติกน้ำร้อน กาน้ำร้อน กาต้มน้ำ รุ่น KP - B36S 3.6 ลิตร กำลังไฟฟ้า 670 วัตต์ สีขาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc1aefd5348574d5f96b70d78ac8e39a2a.jpg_200x200q90.jpg",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i5832683117.html",
        "sold": 0
    },
    {
        "product_name": "JIEXG | ถ้วยตุ๋นไฟฟ้าสำหรับอาหารเช้าหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb54a8210d4dd4a18a0d21d1015cf548b1.png_200x200q90.png",
        "price": 3288.94,
        "remark": "https://www.lazada.co.th/products/pdp-i6019151480.html",
        "sold": 22
    },
    {
        "product_name": "Maxwin | กาต้มน้ำไฟฟ้าปากยาวแคบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sde953eea002d45b89807fb748c750936D.png_200x200q90.png",
        "price": 3249.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5981281445.html",
        "sold": 42
    },
    {
        "product_name": "หม้อต้มความดันสูงหนาแบบทนทานต่อการระเบิดสำหรับใช้ในครัวเรือน เตาแก๊ส เตาแม่เหล็กไฟฟ้า หม้อต้มน้ำ ขนาดเล็กสำหรับคนสองคน เครื่องปรุงรสสำหรับใช้ในธุรกิจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd5b8e3c3bb484bf29cc02d9dd824edddI.jpg_200x200q90.jpg",
        "price": 3057.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16082641300.html",
        "sold": 0
    },
    {
        "product_name": "UBelle | เครื่องหนีบผมและม้วนผม รุ่น UBelle HB-78 ช่วยลดไฟฟ้าสถิตและผมชี้ฟู",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Sa3dcd4f3060a45299220bc9483cb9db4j.png_200x200q90.png",
        "price": 3051.58,
        "remark": "https://www.lazada.co.th/products/pdp-i5909635713.html",
        "sold": 246
    },
    {
        "product_name": "JIEXG | หม้อพกพาสำหรับตุ๋น ต้ม และอุ่นนม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scbff7a2952c241b993374a36120f358fY.jpg_200x200q90.jpg",
        "price": 3045.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6019164512.html",
        "sold": 254
    },
    {
        "product_name": "SIRHINO | เครื่องหั่นหญ้าและผักสแตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S556f58ef43444950b98b78d59c71dda5I.jpg_200x200q90.jpg",
        "price": 3036,
        "remark": "https://www.lazada.co.th/products/pdp-i6028047624.html",
        "sold": 0
    },
    {
        "product_name": "หม้อต้มพกพาขนาดเล็กหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sefa75b8be8eb4a168847df854253ac9bh.png_200x200q90.png",
        "price": 3020,
        "remark": "https://www.lazada.co.th/products/pdp-i6005989446.html",
        "sold": 21
    },
    {
        "product_name": "sunnykinder | เครื่องปั่นและอุ่นนมสำหรับเด็กอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8223360215fc4271b176c5f173aadce9s.jpg_200x200q90.jpg",
        "price": 2868.66,
        "remark": "https://www.lazada.co.th/products/pdp-i5912448945.html",
        "sold": 1
    },
    {
        "product_name": "เครื่องทำป๊อปคอร์นอัตโนมัติขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3d947a9fbf2848d39c4db4842bdef0e9H.jpg_200x200q90.jpg",
        "price": 2674,
        "remark": "https://www.lazada.co.th/products/pdp-i16089168711.html",
        "sold": 0
    },
    {
        "product_name": "AHKISS | เครื่องมือทำลอนผมแบบคลื่นน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd4991c5b0843466cab3f32e7c6cdc153d.png_200x200q90.png",
        "price": 2673.08,
        "remark": "https://www.lazada.co.th/products/pdp-i5991008528.html",
        "sold": 187
    },
    {
        "product_name": "JIEXG | กาต้มน้ำไฟฟ้าขนาดเล็กแบบพกพา, กาต้มน้ำร้อนและเก็บความร้อน, แก้วน้ำร้อนไฟฟ้าสำหรับเดินทาง",
        "product_image": "https://img.lazcdn.com/3rd/q/aHR0cHM6Ly9hZS1waWMtYTEuYWxpZXhwcmVzcy1tZWRpYS5jb20va2YvU2I0ZDY3MmRiY2IyOTQ4MjI4YzRjZjIwYzc1NDAxOTY4Wi5wbmc=_200x200q90.png",
        "price": 2668.16,
        "remark": "https://www.lazada.co.th/products/pdp-i6019047996.html",
        "sold": 568
    },
    {
        "product_name": "Bear | เครื่องบดเนื้อไฟฟ้าปรับความเร็วได้ 4 ระดับ พร้อมจอแสดงผลขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5ba2cc0422e148b384de9890fbcc93b13.jpg_200x200q90.jpg",
        "price": 2586.18,
        "remark": "https://www.lazada.co.th/products/pdp-i5878402656.html",
        "sold": 10
    },
    {
        "product_name": "Bear | กาต้มน้ำไฟฟ้าความจุใหญ่หลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se2aeedb35e514aa2876d66f75ee8ae22L.png_200x200q90.png",
        "price": 2582.3,
        "remark": "https://www.lazada.co.th/products/pdp-i5878294611.html",
        "sold": 72
    },
    {
        "product_name": "GEDO | กระทะทอดลึกช่วยประหยัดน้ำมัน สแตนเลส 304",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se7b9dd8c1f9d44809b0d0e307a82974fq.jpg_200x200q90.jpg",
        "price": 2470.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5876962477.html",
        "sold": 23
    },
    {
        "product_name": "**ของแท้จากช็อป100%-ลด29%-ของแถมอีกมากมาย***หม้ออบลมร้อน หม้อทอดไร้น้ำมัน ขนาด 3.5 ลิตร รุ่น MV-1350",
        "product_image": "https://img.lazcdn.com/g/p/4e92c963d683c0bea0d1cca9ddc83a06.jpg_200x200q90.jpg",
        "price": 2430.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5855106830.html",
        "sold": 2
    },
    {
        "product_name": "KUWUBIANJING | กาต้มน้ำไฟฟ้าอัจฉริยะควบคุมอุณหภูมิคงที่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf163aad637af45a5981a4c54d5a58fb3G.jpg_200x200q90.jpg",
        "price": 2350.9,
        "remark": "https://www.lazada.co.th/products/pdp-i6023211742.html",
        "sold": 4
    },
    {
        "product_name": "Bear | กาต้มน้ำไฟฟ้าขนาดเล็กพกพาได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se040bef2174f4040b565841e79d9c1564.png_200x200q90.png",
        "price": 2346.52,
        "remark": "https://www.lazada.co.th/products/pdp-i5877031687.html",
        "sold": 40
    },
    {
        "product_name": "พัดลมทำความสะอาดอากาศ กำจัดฝุ่น ป้องกันไฟฟ้าสถิตย์ ขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scc8680bac2a04c6f99140e36af74cf92f.jpg_200x200q90.jpg",
        "price": 2166,
        "remark": "https://www.lazada.co.th/products/pdp-i6028083421.html",
        "sold": 1
    },
    {
        "product_name": "YIYUE | เครื่องทำอาหารไร้น้ำมันอเนกประสงค์ ความจุใหญ่ ไร้ควัน ไขมันต่ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sefda214b422b419fb7fc05daf107bdfbP.jpg_200x200q90.jpg",
        "price": 2128.28,
        "remark": "https://www.lazada.co.th/products/pdp-i6019060768.html",
        "sold": 1
    },
    {
        "product_name": "Nanwei | เครื่องตัด ขัด เลื่อยไร้สาย 20V",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S855682e6a75b4d26a4baeed0c8aea4a0m.jpg_200x200q90.jpg",
        "price": 4019.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5955194605.html",
        "sold": 36
    },
    {
        "product_name": "CHNT | เครื่องเชื่อมทองแดงพกพา 2 แรงดันไฟฟ้า 220V/380V",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S826605d4a96e4904a78f9633ae5f2af4D.png_200x200q90.png",
        "price": 3615.42,
        "remark": "https://www.lazada.co.th/products/pdp-i6003326886.html",
        "sold": 72
    },
    {
        "product_name": "AUX | กาต้มน้ำไฟฟ้าพกพาอัจฉริยะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1848c30b95e04bf9b7026c9015d4daceJ.png_200x200q90.png",
        "price": 2114.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5991842569.html",
        "sold": 42
    },
    {
        "product_name": "เครื่องปั่นน้ำผลไม้ แบบพกพา Electrolox รุ่น E3CB1-200S ร้อนนี้ต้องจัด",
        "product_image": "https://img.lazcdn.com/g/p/6a81dbd7c9f4ef6577557183cb3ffb70.jpg_200x200q90.jpg",
        "price": 1999,
        "remark": "https://www.lazada.co.th/products/pdp-i16078770655.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องผสมไฟฟ้าขนาดเล็กสำหรับใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd4d32b19d68b464f89f3213048531cb9e.jpg_200x200q90.jpg",
        "price": 1874.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16089420443.html",
        "sold": 0
    },
    {
        "product_name": "ABP | เครื่องหนีบและม้วนผมไอออนลบลดความเสียหาย 2-in-1 แผ่นเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2c30ffae501a40b2a60227418834a8caF.jpg_200x200q90.jpg",
        "price": 1837.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5974543383.html",
        "sold": 1
    },
    {
        "product_name": "ABP | เครื่องหนีบผมตรงจากข้าวโพดพอง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd630f679af5c48a4aaf09639b432255bs.jpg_200x200q90.jpg",
        "price": 1809.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5931460022.html",
        "sold": 2
    },
    {
        "product_name": "ABP | เครื่องหนีบผมตรงและม้วนผมพร้อมไอออนลบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S65910e7bd5014d3d839ab84a33461bc5W.jpg_200x200q90.jpg",
        "price": 1803.76,
        "remark": "https://www.lazada.co.th/products/pdp-i5927769891.html",
        "sold": 2
    },
    {
        "product_name": "กระทะไฟฟ้าอเนกประสงค์ไม่ติดกระทะ ไร้ควัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6063ca59cf21407b9fec176138f5b501L.jpg_200x200q90.jpg",
        "price": 1794,
        "remark": "https://www.lazada.co.th/products/pdp-i6026070858.html",
        "sold": 0
    },
    {
        "product_name": "BONINGYU | เครื่องเพิ่มความชื้นและกระจายกลิ่นแบบ USB พร้อมเอฟเฟกต์ไฟลวงตา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sef0f01473d174f09aa66a9ed780b6a42b.jpg_200x200q90.jpg",
        "price": 1767.58,
        "remark": "https://www.lazada.co.th/products/pdp-i5968854652.html",
        "sold": 1
    },
    {
        "product_name": "Liven | เครื่องบดเนื้อหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb1f8c33c558c4472b1e3e40fb98cf63fk.png_200x200q90.png",
        "price": 1765.74,
        "remark": "https://www.lazada.co.th/products/pdp-i6011023683.html",
        "sold": 114
    },
    {
        "product_name": "กาต้มน้ำควบคุมอุณหภูมิสำหรับเด็กทารก ขนาด 1.2 ลิตร รุ่นใหม่ พร้อมระบบอุ่นนมอัตโนมัติ และฉนวนกันความร้อนอัจฉริยะ สำหรับนมผง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S42914778f62a4841af5a5eb8451ecdf2W.jpg_200x200q90.jpg",
        "price": 1764.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16099369804.html",
        "sold": 0
    },
    {
        "product_name": "Cool A Styler คูล อะ สไตเลอร์ ไดร์เป่าผม สีขาว ความเร็วสูง 1600W (CA-V11)",
        "product_image": "https://img.lazcdn.com/g/p/4ddb866504b1af8d3dd655d65cbc00f6.jpg_200x200q90.jpg",
        "price": 1740,
        "remark": "https://www.lazada.co.th/products/pdp-i6069687586.html",
        "sold": 0
    },
    {
        "product_name": "MAKETUBU | เครื่องเพิ่มความชื้นคุณภาพสูงสำหรับใช้งานจริง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9470d55a38fe4d51a5edf15c4667c6cbI.jpg_200x200q90.jpg",
        "price": 1726.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6001861433.html",
        "sold": 2
    },
    {
        "product_name": "yishujia office | กระทะไฟฟ้าไม่ติดกระทะ ใช้ได้หลายวัตถุประสงค์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb1b4c5bc69d94264973af8dd40f0a028l.jpg_200x200q90.jpg",
        "price": 1720.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16059015175.html",
        "sold": 0
    },
    {
        "product_name": "หม้อไฟฟ้าอเนกประสงค์แบบอัตโนมัติ แก้วหนา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S49eb98561cc54e689ef6d0bb938249afY.jpg_200x200q90.jpg",
        "price": 1618.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16056549417.html",
        "sold": 0
    },
    {
        "product_name": "JITIANSHE | เครื่องเพิ่มความชื้นรูปเปลวไฟ ของขวัญระดับไฮเอนด์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9b821b398f66412aaca11a43aa485d50c.jpg_200x200q90.jpg",
        "price": 1616,
        "remark": "https://www.lazada.co.th/products/pdp-i6026119864.html",
        "sold": 2
    },
    {
        "product_name": "ไดร์เป่าผมTUR BO  3900วัตต์ ช่างเสริมสวยนิยมใช้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S81159e169be04c2b949a9adeda20acddp.jpg_200x200q90.jpg",
        "price": 1598,
        "remark": "https://www.lazada.co.th/products/pdp-i5876999965.html",
        "sold": 18
    },
    {
        "product_name": "แก้วไฟฟ้า แบบต้ม-ตุ๋นในตัว",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S16897291fead4590a9505d1b8bf98dd5O.jpg_200x200q90.jpg",
        "price": 1585.36,
        "remark": "https://www.lazada.co.th/products/pdp-i6019193089.html",
        "sold": 5
    },
    {
        "product_name": "ABP | เครื่องหนีบผมลอนใหญ่ไอออนลบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S53bcddf6531649a59c842fed6274c69ar.jpg_200x200q90.jpg",
        "price": 1582.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5927787392.html",
        "sold": 34
    },
    {
        "product_name": "SANXUN | เครื่องทำชาอัตโนมัติแก้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbacf8595d38541fdbc34d37f39c773a7a.png_200x200q90.png",
        "price": 1574.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5909675417.html",
        "sold": 0
    },
    {
        "product_name": "LANWAN | เครื่องบดละเอียดสำหรับข้าวสาลีพริกและธัญพืช",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scfe9865c41ea40ab9532f0b988c4c3f4I.jpg_200x200q90.jpg",
        "price": 1554.1,
        "remark": "https://www.lazada.co.th/products/pdp-i16046829948.html",
        "sold": 0
    },
    {
        "product_name": "Oral-B | แปรงสีฟันไฟฟ้าหัวกลมสำหรับผู้ใหญ่ ความสว่างชัดเจน   D12",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S99520c5d9a0e4b65b7ec2bdb75f2c1505.jpg_200x200q90.jpg",
        "price": 1550,
        "remark": "https://www.lazada.co.th/products/pdp-i16065506081.html",
        "sold": 49
    },
    {
        "product_name": "YOUYOUBABEI | กาชงชาหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb905af8cc96c48c89cce83c4f7cb8784u.jpg_200x200q90.jpg",
        "price": 1546,
        "remark": "https://www.lazada.co.th/products/pdp-i6006165721.html",
        "sold": 2
    },
    {
        "product_name": "กาต้มน้ำไฟฟ้าความจุใหญ่ ฉนวนกันความร้อน ปิดอัตโนมัติ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se9e547328dc5465c9e35b225261187d2x.jpg_200x200q90.jpg",
        "price": 1478.56,
        "remark": "https://www.lazada.co.th/products/pdp-i6022316308.html",
        "sold": 5
    },
    {
        "product_name": "iicobear | กาต้มน้ำไฟฟ้ารักษาอุณหภูมิคงที่ Thermos",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seebc98ca6180422cb95e4bb7a2aabe48d.png_200x200q90.png",
        "price": 1449.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6007729263.html",
        "sold": 4
    },
    {
        "product_name": "iicobear | กาต้มน้ำไฟฟ้าควบคุมอุณหภูมิอัจฉริยะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2b2ad5ab85cd4d75995e0e4c32ec3ddb9.png_200x200q90.png",
        "price": 1447.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5952005860.html",
        "sold": 17
    },
    {
        "product_name": "JIEXG | กาต้มน้ำไฟฟ้าพกพาควบคุมอุณหภูมิคงที่",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S99a1668814734bd8b6a71af84cd8cff5t.png_200x200q90.png",
        "price": 1430,
        "remark": "https://www.lazada.co.th/products/pdp-i6019125408.html",
        "sold": 35
    },
    {
        "product_name": "เครื่องตีไข่มือถือ Pengocok Telur Listrik เครื่องผสมอาหารมือถือแบบไฟฟ้า Hawne",
        "product_image": "https://img.lazcdn.com/g/p/6d9987dec53d3c4d4a3a75e1a849c855.jpg_200x200q90.jpg",
        "price": 1410,
        "remark": "https://www.lazada.co.th/products/pdp-i16105696416.html",
        "sold": 0
    },
    {
        "product_name": "Archicook | กาต้มน้ำสแตนเลสปิดอัตโนมัติพร้อมฉนวนกันความร้อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb5fff9f2fdaf49e6b4427a47233edf19R.jpg_200x200q90.jpg",
        "price": 1402.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5996843360.html",
        "sold": 12
    },
    {
        "product_name": "TMSU | ของขวัญวันเกิดเด็ก แปรงสีฟันไฟฟ้าสำหรับเด็กหญิงอายุ 10 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5e564d76394b4a3cac17567133f38159v.jpg_200x200q90.jpg",
        "price": 1388.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5948786732.html",
        "sold": 8
    },
    {
        "product_name": "HUALUOLAN | กาต้มน้ำอัตโนมัติพร้อมเทอร์โมสแตท 316 สเตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3816dd71293e44e9933aa4d4463ab75fQ.jpg_200x200q90.jpg",
        "price": 1367.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16060496069.html",
        "sold": 0
    },
    {
        "product_name": "TH Beauty Salon  แปรงสีฟันไฟฟ้า Oral B รุ่น Vitality Precision clean COD",
        "product_image": "https://img.lazcdn.com/g/p/48c8b4608b696bcaf4253f8f0b48bbdd.jpg_200x200q90.jpg",
        "price": 1316,
        "remark": "https://www.lazada.co.th/products/pdp-i16087488629.html",
        "sold": 1
    },
    {
        "product_name": "Oral-B แปรงสีฟันไฟฟ้า Vitality Precision Clean",
        "product_image": "https://img.lazcdn.com/g/p/1501ac10d80c35de25cf69c11086bd44.jpg_200x200q90.jpg",
        "price": 1316,
        "remark": "https://www.lazada.co.th/products/pdp-i5891835227.html",
        "sold": 1
    },
    {
        "product_name": "แปรงสีฟันไฟฟ้า Oral B รุ่น Vitality Precision clean",
        "product_image": "https://img.lazcdn.com/g/p/a3e9a13168a990c945ef1cb513c7dda7.jpg_200x200q90.jpg",
        "price": 1316,
        "remark": "https://www.lazada.co.th/products/pdp-i5891848045.html",
        "sold": 0
    },
    {
        "product_name": "JIFANPAUL | กาต้มน้ำไฟฟ้าพกพาหลายฟังก์ชันพร้อมควบคุมอุณหภูมิ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se2b4b342722c458cab63dad7195cc566I.jpg_200x200q90.jpg",
        "price": 1312.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5955192507.html",
        "sold": 8
    },
    {
        "product_name": "KUB | แปรงสีฟันไฟฟ้าสำหรับเด็กขนนุ่มอัตโนมัติ ผสมฟลูออไรด์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1b55eb39da544d1485a08b4ed85bf4379.jpg_200x200q90.jpg",
        "price": 1290,
        "remark": "https://www.lazada.co.th/products/pdp-i6005977060.html",
        "sold": 0
    },
    {
        "product_name": "BIAOTU | เครื่องพ่นไอน้ำอโรม่าแบบพกพา ความจุใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6b0089847b7a410f86bdee5e18dd66d9s.png_200x200q90.png",
        "price": 1270,
        "remark": "https://www.lazada.co.th/products/pdp-i6029722115.html",
        "sold": 1
    },
    {
        "product_name": "กลองชุดไฟฟ้า Roland VAD716 V-Drums Acoustic Design * กรุณาสอบถามก่อนสั่งซื้อ *",
        "product_image": "https://img.lazcdn.com/g/p/757f308cfccff0869f7b412a594e70de.png_200x200q90.png",
        "price": 800000,
        "remark": "https://www.lazada.co.th/products/pdp-i5548374833.html",
        "sold": 0
    },
    {
        "product_name": "TAYLOR 814CE BUILDER'S EDITION LTD SINKER REDWOOD TOP 50TH ANNIVERSARY [FREE CASE]",
        "product_image": "https://img.lazcdn.com/g/p/8564ab6adca2d7132d9e8fdd7bc2dc08.jpg_200x200q90.jpg",
        "price": 474400,
        "remark": "https://www.lazada.co.th/products/pdp-i5226244508.html",
        "sold": 0
    },
    {
        "product_name": "Nord Stage 4 เปียโนไฟฟ้า Digital Piano / Nord Stage 4 73 / Nord Stage 4 88 / Nord Stage 4 Compact",
        "product_image": "https://img.lazcdn.com/g/p/306bb1f240d63621c51eb90abd15db3c.jpg_200x200q90.jpg",
        "price": 472500,
        "remark": "https://www.lazada.co.th/products/pdp-i2475807629.html",
        "sold": 2
    },
    {
        "product_name": "Grand Piano : Classic GPX-152 WHP แกรนด์เปียโนสีขาว by Churairat Music",
        "product_image": "https://img.lazcdn.com/g/p/559821b0b6910724b95c3de11bf5a92f.jpg_200x200q90.jpg",
        "price": 456000,
        "remark": "https://www.lazada.co.th/products/pdp-i2279402327.html",
        "sold": 0
    },
    {
        "product_name": "กีตาร์ไฟฟ้า PRS Hollowbody II Piezo Charcoal Burst 10-Top /Case",
        "product_image": "https://img.lazcdn.com/g/p/403e1d729ae089972aaf2f38bc1bf865.png_200x200q90.png",
        "price": 450000,
        "remark": "https://www.lazada.co.th/products/pdp-i5362534835.html",
        "sold": 0
    },
    {
        "product_name": "Martin OMJM John Mayer กีตาร์โปร่ง",
        "product_image": "https://img.lazcdn.com/g/p/b86695eba82a0feee73d9ef357e776d6.jpg_200x200q90.jpg",
        "price": 440000,
        "remark": "https://www.lazada.co.th/products/pdp-i4531937796.html",
        "sold": 0
    },
    {
        "product_name": "Grand Piano : Classic GPX-152 EBP แกรนด์เปียโน สีดำ by Churairat Music",
        "product_image": "https://img.lazcdn.com/g/p/a3e61ba76dc7a783a3624af272f4380b.jpg_200x200q90.jpg",
        "price": 436000,
        "remark": "https://www.lazada.co.th/products/pdp-i2279465062.html",
        "sold": 0
    },
    {
        "product_name": "กีตาร์โปร่ง Martin 000-28EC Eric Clapton Signature",
        "product_image": "https://img.lazcdn.com/g/p/4ba38a3a73d517d69976bf17a97c2863.jpg_200x200q90.jpg",
        "price": 430000,
        "remark": "https://www.lazada.co.th/products/pdp-i5109712405.html",
        "sold": 0
    },
    {
        "product_name": "Taylor 814CE V-Class ( with Hardcase ) กีตาร์โปร่งไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/4ce81aa381644379cdac38e2c845936f.jpg_200x200q90.jpg",
        "price": 410000,
        "remark": "https://www.lazada.co.th/products/pdp-i3906672156.html",
        "sold": 1
    },
    {
        "product_name": "Roland Fantom Synthesizers Fantom-6 / Fantom-7 / Fantom-8 คีย์บอร์ด 61 76 88 Keys",
        "product_image": "https://img.lazcdn.com/g/p/ce78e2dbd02753bd0eedaf71ab1e8e64.jpg_200x200q90.jpg",
        "price": 320000,
        "remark": "https://www.lazada.co.th/products/pdp-i2925245721.html",
        "sold": 0
    },
    {
        "product_name": "Roland FANTOM EX Synthesizer Keyboard คีย์บอร์ด ซินธิไซเซอร์ FANTOM 6 EX / 7 EX / 8 EX | FAN TOM 6EX / 7EX / 8EX",
        "product_image": "https://img.lazcdn.com/g/p/8a1fcbfd72cd090a8e2615a1191a46cb.jpg_200x200q90.jpg",
        "price": 320000,
        "remark": "https://www.lazada.co.th/products/pdp-i5309402745.html",
        "sold": 0
    },
    {
        "product_name": "Martin OM-28 Acoustic Guitar กีตาร์โปร่ง OM28",
        "product_image": "https://img.lazcdn.com/g/p/3511077439b6069b687271243f2b32bb.jpg_200x200q90.jpg",
        "price": 288000,
        "remark": "https://www.lazada.co.th/products/pdp-i5694838923.html",
        "sold": 0
    },
    {
        "product_name": "Roland TD-27K กลองไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/19584634a1f56e110f1db8ba299b940b.jpg_200x200q90.jpg",
        "price": 210000,
        "remark": "https://www.lazada.co.th/products/pdp-i2210924229.html",
        "sold": 0
    },
    {
        "product_name": "Abasi Emi7 Legion Stealth กีตาร์ไฟฟ้า กีต้าร์",
        "product_image": "https://img.lazcdn.com/g/p/cd142b00fff90b93abb29ae52f01eec0.jpg_200x200q90.jpg",
        "price": 210000,
        "remark": "https://www.lazada.co.th/products/pdp-i5645386932.html",
        "sold": 0
    },
    {
        "product_name": "Abasi Emi6 Legion Stealth กีตาร์ไฟฟ้า กีต้าร์",
        "product_image": "https://img.lazcdn.com/g/p/64e023dc5836a4e515c439d62cdb9c71.jpg_200x200q90.jpg",
        "price": 200000,
        "remark": "https://www.lazada.co.th/products/pdp-i5645472349.html",
        "sold": 0
    },
    {
        "product_name": "ทูบา คอนเสิร์ต คีย์บีแฟลต 4 โรตารีวาล์ว พร้อมอุปกรณ์ครบชุด JY JYTU-E130 Tuba Concert Key Bb 4 Rotary Valves",
        "product_image": "https://img.lazcdn.com/g/p/5d4fdfbcd124efe86e520dff33687e95.jpg_200x200q90.jpg",
        "price": 188000,
        "remark": "https://www.lazada.co.th/products/pdp-i5750934115.html",
        "sold": 0
    },
    {
        "product_name": "Cort KX700 TT Electric Guitar กีตาร์ไฟฟ้า กีต้าร์ คอร์ท KX700TT KX 700 TT KX 700TT",
        "product_image": "https://img.lazcdn.com/g/p/deecb0b77d8a031dcba1b39d09594042.jpg_200x200q90.jpg",
        "price": 178000,
        "remark": "https://www.lazada.co.th/products/pdp-i5356700329.html",
        "sold": 0
    },
    {
        "product_name": "Taylor 214CE SB DLX กีตาร์โปร่งไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/fbd09a0d469f6071f7c7ca96bd5865ad.jpg_200x200q90.jpg",
        "price": 168000,
        "remark": "https://www.lazada.co.th/products/pdp-i2907187966.html",
        "sold": 0
    },
    {
        "product_name": "จักรยาน MERIDA SCULTURA ENDURANCE 4000 2025 สี SILK DARK SILVER (BLACK)",
        "product_image": "https://img.lazcdn.com/g/p/122512981e2e71bf80191a5a48f7aac3.jpg_200x200q90.jpg",
        "price": 165800,
        "remark": "https://www.lazada.co.th/products/pdp-i5274274565.html",
        "sold": 1
    },
    {
        "product_name": "กีตาร์ไฟฟ้า Strandberg Boden Standard NX 6 Plini Edition Mirage | กีตาร์ไฟฟ้าหัวตัด",
        "product_image": "https://img.lazcdn.com/g/p/577bcbfe5ca8eeddbc50b092576bae7c.jpg_200x200q90.jpg",
        "price": 164000,
        "remark": "https://www.lazada.co.th/products/pdp-i5778167827.html",
        "sold": 0
    },
    {
        "product_name": "บาริโทน แซกโซโฟน คีย์อีแฟลต พร้อมอุปกรณ์ครบชุด EVA JYBS-A600 Key Eb Baritone Saxophone",
        "product_image": "https://img.lazcdn.com/g/p/90f6a08ed8083fc10bf98868a562ef20.jpg_200x200q90.jpg",
        "price": 152000,
        "remark": "https://www.lazada.co.th/products/pdp-i5744862527.html",
        "sold": 0
    },
    {
        "product_name": "TAMA Superstar Hyper-Drive Limited Edition Drum Set กลองชุด HyperDrive",
        "product_image": "https://img.lazcdn.com/g/p/fc1a8ee0d9f79bd2fbb6b1e05624caeb.jpg_200x200q90.jpg",
        "price": 146300,
        "remark": "https://www.lazada.co.th/products/pdp-i5269903796.html",
        "sold": 0
    },
    {
        "product_name": "รับส่วนลดสูงสุด 10,000.- Strandberg Salen Classic NX6 Tremolo สี Black กีต้าร์ไฟฟ้า Strandberg Salen Classic Electric Guitar - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/24f906b391e8c2549bb0f9be5650e355.jpg_200x200q90.jpg",
        "price": 145998,
        "remark": "https://www.lazada.co.th/products/pdp-i5267563265.html",
        "sold": 0
    },
    {
        "product_name": "Sterling by Music Man Sabre กีตาร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/78dfaca3f1c730d9dc9f97b907a2f5d0.jpg_200x200q90.jpg",
        "price": 143000,
        "remark": "https://www.lazada.co.th/products/pdp-i4813190805.html",
        "sold": 0
    },
    {
        "product_name": "คีย์บอร์ด Roland FANTOM 06 Synthesizers Keyboard [ผ่อน 0% 10เดือน]",
        "product_image": "https://img.lazcdn.com/g/p/732d299caecc4cc2b234cc5a697ddd12.png_200x200q90.png",
        "price": 140000,
        "remark": "https://www.lazada.co.th/products/pdp-i5617771555.html",
        "sold": 0
    },
    {
        "product_name": "Roland FANTOM-O Series คีย์บอร์ด Roland Fantom-06 / Fantom-07 / Fantom-08 ซินธิไซเซอร์ Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/1a8a2421e79e30b92a33d046b0908505.jpg_200x200q90.jpg",
        "price": 140000,
        "remark": "https://www.lazada.co.th/products/pdp-i4816326729.html",
        "sold": 0
    },
    {
        "product_name": "กีตาร์ไฟฟ้า Ibanez RG550L-DY(Left Hand) Electric Guitar * กรุณาสอบถามก่อนสั่งซื้อ *",
        "product_image": "https://img.lazcdn.com/g/p/4ec410bd1014898a833a87d7bf58ccf6.png_200x200q90.png",
        "price": 136400,
        "remark": "https://www.lazada.co.th/products/pdp-i5907822139.html",
        "sold": 0
    },
    {
        "product_name": "กีต้าร์ไฟฟ้า MUSIC MAN AXIS Trance Gold",
        "product_image": "https://img.lazcdn.com/g/p/8957d5b31b9d0616b061f6b88ca0089d.png_200x200q90.png",
        "price": 130000,
        "remark": "https://www.lazada.co.th/products/pdp-i16088360812.html",
        "sold": 0
    },
    {
        "product_name": "Ibanez Genesis Collection RG550 ( made in Japan ) กีตาร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/509f30a6fe9b4e4bed10eeb10f24e006.jpg_200x200q90.jpg",
        "price": 125400,
        "remark": "https://www.lazada.co.th/products/pdp-i4790992618.html",
        "sold": 0
    },
    {
        "product_name": "Early Education Instrument Activity House Colorful Design toddler's Introductory Band Set Creative Play Percussion Station Ideal Gift for Preschoolers, Toddlers (3+), Kindergarten, Playground, Daycare Center, Schoolyard",
        "product_image": "https://img.lazcdn.com/g/p/13cd59898bc724f24d7f997c8a46c522.jpg_200x200q90.jpg",
        "price": 124615.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16087742039.html",
        "sold": 0
    },
    {
        "product_name": "Roland JUNO-D8 ซินธิไซเซอร์ Roland JUNO D8 Synthesizers - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/f90de73ee7a6c1a5c0bd6696f502b539.jpg_200x200q90.jpg",
        "price": 113998,
        "remark": "https://www.lazada.co.th/products/pdp-i5750673545.html",
        "sold": 0
    },
    {
        "product_name": "Epiphone 1959 Les Paul Standard กีตาร์ไฟฟ้า กีตาร์",
        "product_image": "https://img.lazcdn.com/g/p/8133858fb9e27d9bdf04ad8e324380e5.jpg_200x200q90.jpg",
        "price": 110000,
        "remark": "https://www.lazada.co.th/products/pdp-i5809641692.html",
        "sold": 0
    },
    {
        "product_name": "Epiphone 1959 Les Paul Standard กีต้าร์ไฟฟ้า Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/6c8c0035892a05479becfa39b7cfe901.jpg_200x200q90.jpg",
        "price": 110000,
        "remark": "https://www.lazada.co.th/products/pdp-i5256811749.html",
        "sold": 0
    },
    {
        "product_name": "เม้าท์ออแกน ฮาร์โมนิก้า 12 ช่อง คีย์ซี Hohner Amadeus , Key C 12 Holes (7544/48C #754401) Performance Series Chromatic Harmonica",
        "product_image": "https://img.lazcdn.com/g/p/e9e1fc9ac386c8b0eb646f743e1b788b.jpg_200x200q90.jpg",
        "price": 110000,
        "remark": "https://www.lazada.co.th/products/pdp-i5907743672.html",
        "sold": 0
    },
    {
        "product_name": "จักรยานเอนปั่น Matrix Recumbent Bike R30XR",
        "product_image": "https://img.lazcdn.com/g/p/4dca42e532ade2d614a7adca69afe7fe.jpg_200x200q90.jpg",
        "price": 109800,
        "remark": "https://www.lazada.co.th/products/pdp-i253179474.html",
        "sold": 2
    },
    {
        "product_name": "Dynasty DFZ Custom Elite Marching Snare Drum กลองสแนร์มาร์ชชิ่ง Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/e8466a5a1b6c1abdfb289451a49bedbb.jpg_200x200q90.jpg",
        "price": 108000,
        "remark": "https://www.lazada.co.th/products/pdp-i5886827113.html",
        "sold": 0
    },
    {
        "product_name": "ทูบา คอนเสิร์ต คีย์บีแฟลต 3 ลูกสูบ พร้อมอุปกรณ์ครบชุด JY JYTU-E120 Tuba Concert Key Bb 3 Piston Valve",
        "product_image": "https://img.lazcdn.com/g/p/292d0e2e163bfd671c8185a37333e16b.jpg_200x200q90.jpg",
        "price": 108000,
        "remark": "https://www.lazada.co.th/products/pdp-i5705120863.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE Studio กีตาร์ไฟฟ้า กีตาร์",
        "product_image": "https://img.lazcdn.com/g/p/fcd19a723e2ee7c6242b33f5e5372913.jpg_200x200q90.jpg",
        "price": 102600,
        "remark": "https://www.lazada.co.th/products/pdp-i5790798042.html",
        "sold": 0
    },
    {
        "product_name": "กีต้าร์ไฟฟ้า Epiphone Japan SHERATON Natural 1991",
        "product_image": "https://img.lazcdn.com/g/p/f3ca3d666f3d919fc97af7817bf8aaf2.jpg_200x200q90.jpg",
        "price": 100000,
        "remark": "https://www.lazada.co.th/products/pdp-i5508625932.html",
        "sold": 0
    },
    {
        "product_name": "⭐Germany Brand⭐ Hohner® Bravo III 80 Chromatic Accordion 80 Bass 37 Key แอคคอร์เดียน หีบเพลงชัก + แถมกระเป๋า",
        "product_image": "https://img.lazcdn.com/g/p/4a6f8176bcbab915a6c567a74d436530.jpg_200x200q90.jpg",
        "price": 99800,
        "remark": "https://www.lazada.co.th/products/pdp-i1656533.html",
        "sold": 2
    },
    {
        "product_name": "Hsienmo D45 Deluxe Acoustic Guitar กีตาร์โปร่ง พร้อมเคส D 45",
        "product_image": "https://img.lazcdn.com/g/p/9739a0d08d77448c71e63d2230f5797a.jpg_200x200q90.jpg",
        "price": 99800,
        "remark": "https://www.lazada.co.th/products/pdp-i5651620424.html",
        "sold": 0
    },
    {
        "product_name": "Paramount JBMT030N Bb Marching Tube มาร์ชชิ่งทูบา คีย์ Bb บอดี้ทองเหลือง เคลือบนิกเกิล  + แถมฟรีเคสแข็ง & ถุงมือ",
        "product_image": "https://img.lazcdn.com/g/p/b9a72d697ab83019a383efc76f8d831e.jpg_200x200q90.jpg",
        "price": 99800,
        "remark": "https://www.lazada.co.th/products/pdp-i5195064992.html",
        "sold": 0
    },
    {
        "product_name": "Cort KX707 EVERTUNE - Open Pore Black Electric Guitar กีตาร์ไฟฟ้า กีตาร์ 7 สาย สี Open Pore Black KX707 Electric Guitar",
        "product_image": "https://img.lazcdn.com/g/p/420322e1e4a11d165b6ccfdb6a18d020.jpg_200x200q90.jpg",
        "price": 99700,
        "remark": "https://www.lazada.co.th/products/pdp-i6008694159.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE Paul’s Guitar กีตาร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/59f0239cca2b246c7efb11c7f4304fe1.jpg_200x200q90.jpg",
        "price": 99000,
        "remark": "https://www.lazada.co.th/products/pdp-i5541357581.html",
        "sold": 0
    },
    {
        "product_name": "Roland JUNO-D7 ซินธิไซเซอร์ Roland JUNO D7 Synthesizers - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/64c1892ae10287d97077197fc31b75c2.jpg_200x200q90.jpg",
        "price": 95998,
        "remark": "https://www.lazada.co.th/products/pdp-i5750673544.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE PRS SE PAUL'S GUITAR-TEAL BLACK/BAG",
        "product_image": "https://img.lazcdn.com/g/p/28351d011c2063ebc81bc0dc9a670ceb.png_200x200q90.png",
        "price": 92400,
        "remark": "https://www.lazada.co.th/products/pdp-i5961661414.html",
        "sold": 0
    },
    {
        "product_name": "คีย์บอร์ด Roland A-88MKII MIDI Keyboard Controller [ผ่อน 0% 10เดือน]",
        "product_image": "https://img.lazcdn.com/g/p/a1fe36d44e846ba30392ae98baa5d418.png_200x200q90.png",
        "price": 92000,
        "remark": "https://www.lazada.co.th/products/pdp-i5690887327.html",
        "sold": 0
    },
    {
        "product_name": "Taylor Academy 10E Acoustic Guitar กีตาร์โปร่งไฟฟ้า Academy10 E Academy10E",
        "product_image": "https://img.lazcdn.com/g/p/62b5e84094b4333fbe4104437b34afcc.jpg_200x200q90.jpg",
        "price": 92000,
        "remark": "https://www.lazada.co.th/products/pdp-i5500811191.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE Custom 24-08 Quilt กีตาร์ไฟฟ้า กีตาร์ กีต้าร์ 2408",
        "product_image": "https://img.lazcdn.com/g/p/9c897e8e591cdcdee866c81ec3be4409.jpg_200x200q90.jpg",
        "price": 91800,
        "remark": "https://www.lazada.co.th/products/pdp-i5595913689.html",
        "sold": 0
    },
    {
        "product_name": "Korg® Kross 2 88 Synthesizer ซินธีไซเซอร์ 88 คีย์ มีเสียงเครื่องดนตรีอีสานในตัว ต่อคอมได้  มีมากกว่า 1,000 เสียงพรีเซ็ต + แถมฟรีอแดปเตอร์ & คู่มือ ** ประกันศูนย์ 1 ปี **",
        "product_image": "https://img.lazcdn.com/g/p/b9185a4bbe2e8ac9c57e2ad10ac7f841.jpg_200x200q90.jpg",
        "price": 90000,
        "remark": "https://www.lazada.co.th/products/pdp-i338278415.html",
        "sold": 0
    },
    {
        "product_name": "กลองชุด Prelude Classic ไม้ Poplar สีดำ กลองชุดใหญ่ CMC Classic  Options 6  ฟรีไม้กลอง CMC 5B 1คู่",
        "product_image": "https://img.lazcdn.com/g/p/bdb626b7292757886ef9bde8b6463cea.jpg_200x200q90.jpg",
        "price": 85800,
        "remark": "https://www.lazada.co.th/products/pdp-i334118242.html",
        "sold": 0
    },
    {
        "product_name": "FONZO V-34C GA Full Body",
        "product_image": "https://img.lazcdn.com/g/p/ff19b5bf4aa0ecad632251f2f779ea46.jpg_200x200q90.jpg",
        "price": 85000,
        "remark": "https://www.lazada.co.th/products/pdp-i4235509741.html",
        "sold": 0
    },
    {
        "product_name": "FONZO V-34C Dreadnought Full Body",
        "product_image": "https://img.lazcdn.com/g/p/09dc9e7ad610bd5ca3dc3f5dda2f80c6.jpg_200x200q90.jpg",
        "price": 85000,
        "remark": "https://www.lazada.co.th/products/pdp-i4235838977.html",
        "sold": 0
    },
    {
        "product_name": "จัดเซ็ท เครื่องดนตรี วงเมโลเดี้ยนระดับประถมศึกษา (กลองสีขาว)  20 คน",
        "product_image": "https://img.lazcdn.com/g/p/1c50aacd32f56592fb6c515cb7fea4d1.jpg_200x200q90.jpg",
        "price": 84600,
        "remark": "https://www.lazada.co.th/products/pdp-i5034742790.html",
        "sold": 0
    },
    {
        "product_name": "Washburn N24-Nuno Electric Guitars กีตาร์ไฟฟ้า กีตาร์",
        "product_image": "https://img.lazcdn.com/g/p/d4c1c3992b233b59a2af419c460d5bf3.jpg_200x200q90.jpg",
        "price": 84000,
        "remark": "https://www.lazada.co.th/products/pdp-i5783327987.html",
        "sold": 0
    },
    {
        "product_name": "Washburn N24-Nuno สี Vintage Matte กีต้าร์ไฟฟ้า Wasburn Electric Guitar - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/0c5dc10b5b0164d614492a18442c42b0.jpg_200x200q90.jpg",
        "price": 83998,
        "remark": "https://www.lazada.co.th/products/pdp-i5787851959.html",
        "sold": 0
    },
    {
        "product_name": "Washburn N24-Nuno สี Vintage Padauk กีต้าร์ไฟฟ้า Washburn Electric Guitar - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/ba6a913d0f92a3de86eb394a21c61379.jpg_200x200q90.jpg",
        "price": 83998,
        "remark": "https://www.lazada.co.th/products/pdp-i5788049096.html",
        "sold": 0
    },
    {
        "product_name": "Trombone (Bass) Custom TTC-67 Rose Brass Bell ทรอมโบน by Churairat Music",
        "product_image": "https://img.lazcdn.com/g/p/fa355b196b130f5f9c9978466129fda1.png_200x200q90.png",
        "price": 81000,
        "remark": "https://www.lazada.co.th/products/pdp-i2441133953.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE SWAMP ASH SPECIAL กีตาร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/72503c5b221fbc9cd3006223d2340542.jpg_200x200q90.jpg",
        "price": 79200,
        "remark": "https://www.lazada.co.th/products/pdp-i5550176261.html",
        "sold": 0
    },
    {
        "product_name": "TAYLOR 114 E LEFT HAND [FREE BAG]",
        "product_image": "https://img.lazcdn.com/g/p/193c43653fb1e6282e5e51e464527926.jpg_200x200q90.jpg",
        "price": 78800,
        "remark": "https://www.lazada.co.th/products/pdp-i5189740986.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE Custom 24-08 สี Vintage Sunburst กีต้าร์ไฟฟ้า PRS Electric Guitar - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/03e5eb2481b598de899190c253f96ba0.jpg_200x200q90.jpg",
        "price": 78398,
        "remark": "https://www.lazada.co.th/products/pdp-i5623560337.html",
        "sold": 0
    },
    {
        "product_name": "TAYLOR GS MINI E SPECIAL EDITION [FREE BAG]",
        "product_image": "https://img.lazcdn.com/g/p/49b0435c289a7344fde425bf6bee6389.png_200x200q90.png",
        "price": 78048,
        "remark": "https://www.lazada.co.th/products/pdp-i5843375671.html",
        "sold": 0
    },
    {
        "product_name": "Roland JUNO-D6 คีย์บอร์ด Digital Keyboard JUNO D6",
        "product_image": "https://img.lazcdn.com/g/p/9da15961b9c2c21df230b20fef300567.jpg_200x200q90.jpg",
        "price": 78000,
        "remark": "https://www.lazada.co.th/products/pdp-i5740729058.html",
        "sold": 0
    },
    {
        "product_name": "Roland JUNO-D6 ซินธิไซเซอร์ Roland JUNO D6 Synthesizers - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/753cec4ccf51f561e1a733cde1b888ad.jpg_200x200q90.jpg",
        "price": 77998,
        "remark": "https://www.lazada.co.th/products/pdp-i5750715403.html",
        "sold": 0
    },
    {
        "product_name": "Taylor Academy 10 กีตาร์โปร่ง แถมกระเป๋าฟรี !!",
        "product_image": "https://img.lazcdn.com/g/p/805eebf577dd33f67a9b8c8ac3b7ea52.jpg_200x200q90.jpg",
        "price": 76000,
        "remark": "https://www.lazada.co.th/products/pdp-i4017932192.html",
        "sold": 0
    },
    {
        "product_name": "Roland XPS-30 Synthesizer คีย์บอร์ดซินธีไซเซอร์ขนาด 61คีย์ ที่น้ำหนักเบา พกพาไปใช้งานได้สะดวก (ใส่ถ่านได้) ประกันศูนย์",
        "product_image": "https://img.lazcdn.com/g/p/af3b42a987c9d0e7d3c3906c34daa747.jpg_200x200q90.jpg",
        "price": 76000,
        "remark": "https://www.lazada.co.th/products/pdp-i3496954604.html",
        "sold": 0
    },
    {
        "product_name": "Sterling Kaizen กีต้าร์ไฟฟ้า Sterling Electric Guitar - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/e20db0295477806176469d5769909133.jpg_200x200q90.jpg",
        "price": 74798,
        "remark": "https://www.lazada.co.th/products/pdp-i5969453979.html",
        "sold": 0
    },
    {
        "product_name": "Cort X700 Triality OPBB Fishman with Bag กีตาร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/2a7d85c210e6720c7a7877ff7b958adb.jpg_200x200q90.jpg",
        "price": 74700,
        "remark": "https://www.lazada.co.th/products/pdp-i5055124350.html",
        "sold": 0
    },
    {
        "product_name": "Cort Modern Black with Case Acoustic Guitar กีตาร์โปร่งไฟฟ้า ModernBlack กีตาร์โปร่ง กีตาร์",
        "product_image": "https://img.lazcdn.com/g/p/9aa5bf32624853d84113f57f346e4bbb.jpg_200x200q90.jpg",
        "price": 74700,
        "remark": "https://www.lazada.co.th/products/pdp-i5179460338.html",
        "sold": 2
    },
    {
        "product_name": "กีต้าร์ไฟฟ้า Cort X700 Duality II สี Lava Burst Electric Guitar - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/c6f735cdb0066a43cd77c200c4b05811.jpg_200x200q90.jpg",
        "price": 74698,
        "remark": "https://www.lazada.co.th/products/pdp-i5578228134.html",
        "sold": 0
    },
    {
        "product_name": "Roland XPS-30 คีย์บอร์ด Roland XPS-30 Red",
        "product_image": "https://img.lazcdn.com/g/p/9d9f8f59f533734bcec60e670eb13325.jpg_200x200q90.jpg",
        "price": 74000,
        "remark": "https://www.lazada.co.th/products/pdp-i2208489554.html",
        "sold": 8
    },
    {
        "product_name": "Gretsch® G5422TG Electromatic Hollow Body with Bigsby® กีตาร์ไฟฟ้า 22 เฟรต ทรง Hollow Body Double Cut ฮาร์ดแวร์ทอง",
        "product_image": "https://img.lazcdn.com/g/p/a661373951cf54e10172d4767436bd69.jpg_200x200q90.jpg",
        "price": 73400,
        "remark": "https://www.lazada.co.th/products/pdp-i5772246594.html",
        "sold": 0
    },
    {
        "product_name": "Epiphone® Slash Les Paul Standard กีตาร์ไฟฟ้า ทรง Les Paul ซิกเนเจอร์ Slash บอดี้ไม้ Mahogany ไม้หน้า Flame Maple ปิ๊กอัพ ProBucker + แถมฟรี ฮาร์ดเคสกีตาร์ *ประกันศูนย์ 1 ปี*",
        "product_image": "https://img.lazcdn.com/g/p/3bde2d789b89620e8e343ae0df0b31bc.jpg_200x200q90.jpg",
        "price": 73400,
        "remark": "https://www.lazada.co.th/products/pdp-i2638815488.html",
        "sold": 0
    },
    {
        "product_name": "⭐USA Brand⭐ Gretsch® FSR G5427TG Electromatic Hollow Body Single Cut with Bigsby กีตาร์ไฟฟ้า *Limited Edition*",
        "product_image": "https://img.lazcdn.com/g/p/30c0fe4124294b1f887d2a4bcff76088.jpg_200x200q90.jpg",
        "price": 73200,
        "remark": "https://www.lazada.co.th/products/pdp-i5016151177.html",
        "sold": 0
    },
    {
        "product_name": "Sterling by Music Man Bongo Bass เบสไฟฟ้า Electric Bass",
        "product_image": "https://img.lazcdn.com/g/p/a91fe086e2a2312a89dfb137a28fb7a8.jpg_200x200q90.jpg",
        "price": 72600,
        "remark": "https://www.lazada.co.th/products/pdp-i16064748641.html",
        "sold": 0
    },
    {
        "product_name": "ของแท้ คีย์บอร์ดซินธีไซเซอร์ 61 คีย์ Roland® XPS-30 แซมเสียงดนตรีอีสานได้ ต่อไมค์ได้ | 1,400 เสียง ประกันศูนย์",
        "product_image": "https://img.lazcdn.com/g/p/a55915f905a04ff1de16f8e05f5d4640.jpg_200x200q90.jpg",
        "price": 72000,
        "remark": "https://www.lazada.co.th/products/pdp-i5727557131.html",
        "sold": 0
    },
    {
        "product_name": "Roland คีย์บอร์ด รุ่น XPS-10X ขนาด 61 คีย์ มี USB-C audio/MIDI interface คีย์บอร์ดไฟฟ้า - ประกันศูนย์",
        "product_image": "https://img.lazcdn.com/g/p/0789ff4e71bc927059b2166859e9f1d8.jpg_200x200q90.jpg",
        "price": 71800,
        "remark": "https://www.lazada.co.th/products/pdp-i16110326545.html",
        "sold": 0
    },
    {
        "product_name": "PRS  SE  SILVER SKY [FREE BAG]",
        "product_image": "https://img.lazcdn.com/g/p/7d324725aa5b58b6445dd43208e4d651.png_200x200q90.png",
        "price": 70560,
        "remark": "https://www.lazada.co.th/products/pdp-i5827479968.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE  SILVER SKY  2025  [FREE BAG]",
        "product_image": "https://img.lazcdn.com/g/p/6bb546b7b43e75a6e8390617983e8baa.png_200x200q90.png",
        "price": 70560,
        "remark": "https://www.lazada.co.th/products/pdp-i5860863489.html",
        "sold": 0
    },
    {
        "product_name": "AYERS ASD014P กลองสนแร์มาร์ชชิ่ง 14\" Marching Snare Drum 14\"",
        "product_image": "https://img.lazcdn.com/g/p/594394c54f06bd44bc2ad598f946c0e0.png_200x200q90.png",
        "price": 70000,
        "remark": "https://www.lazada.co.th/products/pdp-i6053374265.html",
        "sold": 0
    },
    {
        "product_name": "Guild D-140 กีตาร์โปร่ง GUILD D140",
        "product_image": "https://img.lazcdn.com/g/p/ea244ddb7426b9d0224651ea837bacf7.jpg_200x200q90.jpg",
        "price": 70000,
        "remark": "https://www.lazada.co.th/products/pdp-i4054765027.html",
        "sold": 0
    },
    {
        "product_name": "FONZO V-301S SJ Full Body",
        "product_image": "https://img.lazcdn.com/g/p/7765fcf30380aacb343ca514409900d5.jpg_200x200q90.jpg",
        "price": 69000,
        "remark": "https://www.lazada.co.th/products/pdp-i4980815930.html",
        "sold": 0
    },
    {
        "product_name": "กลองชุด TAMA CL32RZS-BAB  Superstar Classic (ไม่รวมฮาร์ดแวร์ และฉาบ) * กรุณาสอบถามก่อนสั่งซื้อ *",
        "product_image": "https://img.lazcdn.com/g/p/1c84217428eef3ffe9a7ba977d059ff0.png_200x200q90.png",
        "price": 68400,
        "remark": "https://www.lazada.co.th/products/pdp-i5904662794.html",
        "sold": 0
    },
    {
        "product_name": "กลองสแนร์ TAMA Starphonic PBC146 14\"x 6\" Bubinga [ผ่อน 0% 10เดือน]",
        "product_image": "https://img.lazcdn.com/g/p/9b200a8579ea845d27faf76ef717a9ca.png_200x200q90.png",
        "price": 68200,
        "remark": "https://www.lazada.co.th/products/pdp-i5600280062.html",
        "sold": 0
    },
    {
        "product_name": "แอคคอเดียน แอคคอร์เดี้ยน 120 เบส 41 คีย์ แถมสายสะพายและกระเป๋า Accordion Golden Cup JH2008 120 Bass 41 Key 5 Registers",
        "product_image": "https://img.lazcdn.com/g/p/e2b2e67548e780fa37e18ffaf590bc06.jpg_200x200q90.jpg",
        "price": 68000,
        "remark": "https://www.lazada.co.th/products/pdp-i5949980202.html",
        "sold": 0
    },
    {
        "product_name": "รับส่วนลดสูงสุด 10,000.- กีต้าร์โปร่ง Naga รุ่น Sungha Jung \"Light\" Series - S-60 GAC - Acoustic Guitar Naga S60 GAC ,ฟรีของแถม ,พร้อมSet Up&QC ,ประกันจากศูนย์ ,แท้100% ,ผ่อน0% ,ส่งฟรี เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/80cd5217d35d23eb834816eac375ee3c.jpg_200x200q90.jpg",
        "price": 67998,
        "remark": "https://www.lazada.co.th/products/pdp-i3016080657.html",
        "sold": 0
    },
    {
        "product_name": "Takamine GD90CE-MD กีตาร์โปร่งไฟฟ้า เเถมกระเป๋าฟรี !!!",
        "product_image": "https://img.lazcdn.com/g/p/0c7e8fe620545ca5395f1b20c4d42042.jpg_200x200q90.jpg",
        "price": 66640,
        "remark": "https://www.lazada.co.th/products/pdp-i4494320855.html",
        "sold": 0
    },
    {
        "product_name": "Takamine GD90CE กีตาร์โปร่งไฟฟ้า เเถมกระเป๋าฟรี !!!",
        "product_image": "https://img.lazcdn.com/g/p/151c091a3b1eccc9f3eeeb818577a94e.jpg_200x200q90.jpg",
        "price": 66640,
        "remark": "https://www.lazada.co.th/products/pdp-i3903352425.html",
        "sold": 0
    },
    {
        "product_name": "Takamine GN90CE กีตาร์โปร่งไฟฟ้า / GN90CE-MDNAT / GN90CE-ZCNAT",
        "product_image": "https://img.lazcdn.com/g/p/7efc043d521d4da8c474727447f8878e.jpg_200x200q90.jpg",
        "price": 66640,
        "remark": "https://www.lazada.co.th/products/pdp-i3903415096.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE Swamp Ash CE24 Sandblasted LTD Electric Guitar กีตาร์ไฟฟ้า PRSSE SwampAsh CE 24 Pual Reed Smith",
        "product_image": "https://img.lazcdn.com/g/p/48aaa248d8ed372509db020cbd648e75.jpg_200x200q90.jpg",
        "price": 66600,
        "remark": "https://www.lazada.co.th/products/pdp-i5480211460.html",
        "sold": 1
    },
    {
        "product_name": "กีตาร์ไฟฟ้า PRS SE Silver Sky สี Stone Blue",
        "product_image": "https://img.lazcdn.com/g/p/9859ab8a5746eb3cc8de8ebac867e51e.jpg_200x200q90.jpg",
        "price": 65800,
        "remark": "https://www.lazada.co.th/products/pdp-i5363009533.html",
        "sold": 0
    },
    {
        "product_name": "TAYLOR GS MINI  E  MAH SEB  [FREE BAG]",
        "product_image": "https://img.lazcdn.com/g/p/745916e5d6ac2c082666de09d622a2b7.png_200x200q90.png",
        "price": 65568,
        "remark": "https://www.lazada.co.th/products/pdp-i5843383688.html",
        "sold": 0
    },
    {
        "product_name": "ดับเบิ้ล เฟรนช์ฮอร์น คีย์เอฟ/บีแฟลต มี 4 คีย์ พร้อมอุปกรณ์ครบชุด JINBAO JBFH-601 Double French Horn Key F/Bb , 4 Key",
        "product_image": "https://img.lazcdn.com/g/p/f1c5e70c13d5f95e160051b8debe4d6f.jpg_200x200q90.jpg",
        "price": 65000,
        "remark": "https://www.lazada.co.th/products/pdp-i5671772781.html",
        "sold": 0
    },
    {
        "product_name": "Sire Larry Carlton X6 7 Strings กีตาร์ไฟฟ้า Electric Guitar รับประกันศูนย์ Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/2fb9e6ad03f6abe222c194f4a56c39ad.jpg_200x200q90.jpg",
        "price": 64800,
        "remark": "https://www.lazada.co.th/products/pdp-i5876682056.html",
        "sold": 0
    },
    {
        "product_name": "กีต้าร์ไฟฟ้า PRS SE : SILVER SKY ซิกเนเจอร์ John Mayer",
        "product_image": "https://img.lazcdn.com/g/p/a09a767d1f0c736eadd62de8cd0072fc.jpg_200x200q90.jpg",
        "price": 64700,
        "remark": "https://www.lazada.co.th/products/pdp-i3960149572.html",
        "sold": 0
    },
    {
        "product_name": "กีต้าร์ไฟฟ้า PRS SE Mark Holcomb Holcomb Burst 2017",
        "product_image": "https://img.lazcdn.com/g/p/ab82bf12c9ce5f9a4022f935065ad9f4.png_200x200q90.png",
        "price": 64000,
        "remark": "https://www.lazada.co.th/products/pdp-i16098567408.html",
        "sold": 0
    },
    {
        "product_name": "MEDELI AKX10S คีย์บอร์ด 61คีย์ จัดเต็ม จังหวะไทย หมอลำ ลูกทุ่ง Keyboard 61 Keys ประกันศูนย์ 1 ปี!!",
        "product_image": "https://img.lazcdn.com/g/p/50de8a96624ec95a33ac54b10e17312b.jpg_200x200q90.jpg",
        "price": 64000,
        "remark": "https://www.lazada.co.th/products/pdp-i5747132022.html",
        "sold": 1
    },
    {
        "product_name": "คีย์บอร์ด 61 คีย์ มีจังหวะไทยลูกทุ่งหมอลำ แซมพลิงเสียงเครื่องดนตรี อ.ดาว เล่นออกงานได้ Medeli AKX10S Arranger Keyboard 61 key",
        "product_image": "https://img.lazcdn.com/g/p/e7df3dea6758764a06975711d815fcb9.jpg_200x200q90.jpg",
        "price": 64000,
        "remark": "https://www.lazada.co.th/products/pdp-i5720340505.html",
        "sold": 0
    },
    {
        "product_name": "Sire Larry Carlton S7 FM New Gen กีตาร์ไฟฟ้า Electric Guitar รับประกันศูนย์ Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/726f6346a8f3b06c852d09823c36b8c0.png_200x200q90.png",
        "price": 64000,
        "remark": "https://www.lazada.co.th/products/pdp-i5885516611.html",
        "sold": 1
    },
    {
        "product_name": "Medeli คีย์บอร์ด 61 คีย์ แถมจังหวะลูกทุ่งหมอลำ+เสียงเครื่องดนตรีอีกมากกว่า 1,133 แบบ พร้อมไฟ LED Medeli AKX10S Keyboard",
        "product_image": "https://img.lazcdn.com/g/p/f2fb573e321daa97ffa2406aa17944e8.png_200x200q90.png",
        "price": 64000,
        "remark": "https://www.lazada.co.th/products/pdp-i5974253956.html",
        "sold": 0
    },
    {
        "product_name": "FONZO V-33C Full Body",
        "product_image": "https://img.lazcdn.com/g/p/18a450bd23a9151828bf165a13b448af.jpg_200x200q90.jpg",
        "price": 63800,
        "remark": "https://www.lazada.co.th/products/pdp-i3169436447.html",
        "sold": 0
    },
    {
        "product_name": "Roland FP-30X สี White เปียโนไฟฟ้า Roland FP30X , FP 30X Electric Piano - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/d789b3b7f49040367b6d6e7a14946b9b.jpg_200x200q90.jpg",
        "price": 62998,
        "remark": "https://www.lazada.co.th/products/pdp-i5608534975.html",
        "sold": 0
    },
    {
        "product_name": "ลำโพงมอนิเตอร์ Focal Alpha 50 EVO ( Pair )",
        "product_image": "https://img.lazcdn.com/g/p/19e2883da082ca20c71def916b8b3bcf.jpg_200x200q90.jpg",
        "price": 62160,
        "remark": "https://www.lazada.co.th/products/pdp-i2729144692.html",
        "sold": 4
    },
    {
        "product_name": "Epiphone Les Paul Modern Figured กีตาร์ไฟฟ้า กีตาร์",
        "product_image": "https://img.lazcdn.com/g/p/2bdb3f1570055b27c0dde8084fa35699.jpg_200x200q90.jpg",
        "price": 61600,
        "remark": "https://www.lazada.co.th/products/pdp-i5797767044.html",
        "sold": 0
    },
    {
        "product_name": "Takamine GN75CE กีตาร์โปร่งไฟฟ้า แถมกระเป๋าฟรี !!",
        "product_image": "https://img.lazcdn.com/g/p/79cd68add97aa5935b853a0b3da2059c.jpg_200x200q90.jpg",
        "price": 61320,
        "remark": "https://www.lazada.co.th/products/pdp-i4181959344.html",
        "sold": 0
    },
    {
        "product_name": "Sire Larry Carlton Q7 กีตาร์ไฟฟ้า Electric Guitar รับประกันศูนย์ Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/b2383cc6cd80a5fd7c6a8b3c15e0e601.jpg_200x200q90.jpg",
        "price": 60400,
        "remark": "https://www.lazada.co.th/products/pdp-i5885590200.html",
        "sold": 0
    },
    {
        "product_name": "กีต้าร์ไฟฟ้า PRS SE McCarty 594 Single Cut 2023",
        "product_image": "https://img.lazcdn.com/g/p/c9b35e33129ccbdec3364e6b15c56639.png_200x200q90.png",
        "price": 60000,
        "remark": "https://www.lazada.co.th/products/pdp-i16115637956.html",
        "sold": 0
    },
    {
        "product_name": "Golden Cup® JH2008 120 Bass 41 Key Accordion แอคคอเดียน แอคคอร์เดี้ยน 120 เบส 41 คีย์ แบบ Chromatic",
        "product_image": "https://img.lazcdn.com/g/p/ea60028c9b85d485d3f67ec37c70f2b3.jpg_200x200q90.jpg",
        "price": 59800,
        "remark": "https://www.lazada.co.th/products/pdp-i5181205529.html",
        "sold": 0
    },
    {
        "product_name": "⭐USA Brand⭐ Gretsch® G5230T Electromatic Jet FT Single-Cut with Bigsby กีตาร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/76fd37f86de2e46934ca2be036538ecc.jpg_200x200q90.jpg",
        "price": 59800,
        "remark": "https://www.lazada.co.th/products/pdp-i16060665100.html",
        "sold": 0
    },
    {
        "product_name": "Lava ME 3 , LAVA ME 4 , ME PLAY กีต้าร์โปร่งไฟฟ้า Electric Acoustic Guitar Lava Me3 , Lava Me4 เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/3a2c1749e0b8cc0fc49153c9b4b2a781.jpg_200x200q90.jpg",
        "price": 59798,
        "remark": "https://www.lazada.co.th/products/pdp-i4981611140.html",
        "sold": 1
    },
    {
        "product_name": "Alvarez AF70e Acoustic Guitar กีตาร์โปร่งไฟฟ้า AF 70 e",
        "product_image": "https://img.lazcdn.com/g/p/903ad80d6f379cf705f4e67080a077e1.jpg_200x200q90.jpg",
        "price": 59600,
        "remark": "https://www.lazada.co.th/products/pdp-i5499285404.html",
        "sold": 0
    },
    {
        "product_name": "TAYLOR GS MINI E MAH ES B [FREE BAG]",
        "product_image": "https://img.lazcdn.com/g/p/0fced72bc2495a2f0b756f0c564e997d.png_200x200q90.png",
        "price": 59328,
        "remark": "https://www.lazada.co.th/products/pdp-i5843457146.html",
        "sold": 0
    },
    {
        "product_name": "Casio PX-S1100 เปียโนไฟฟ้า PXS-1100 ส่งด่วน ติดตั้งฟรี มีไฟล์คู่มือภาษาไทย +ประกันศูนย์ 3ปี // Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/d0e388b340e0b8f89800148ea7845147.jpg_200x200q90.jpg",
        "price": 57800,
        "remark": "https://www.lazada.co.th/products/pdp-i316316970.html",
        "sold": 54
    },
    {
        "product_name": "Chillman Era P Series กีต้าร์ไฟฟ้า Chillman Era Electric Guitar - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/0467208dda6fd0ab53e9a1089ad25620.jpg_200x200q90.jpg",
        "price": 57798,
        "remark": "https://www.lazada.co.th/products/pdp-i6013561628.html",
        "sold": 0
    },
    {
        "product_name": "กีตาร์ไฟฟ้า PRS  SE NF3 MAPLE",
        "product_image": "https://img.lazcdn.com/g/p/20ba5b0689418f4334c5256bf23e2270.png_200x200q90.png",
        "price": 57600,
        "remark": "https://www.lazada.co.th/products/pdp-i5827720108.html",
        "sold": 0
    },
    {
        "product_name": "เปียโนไฟฟ้า KORG LP-380U",
        "product_image": "https://img.lazcdn.com/g/p/bdb159a2877c3f0b805729dfd72aabb9.jpg_200x200q90.jpg",
        "price": 57600,
        "remark": "https://www.lazada.co.th/products/pdp-i4828265020.html",
        "sold": 0
    },
    {
        "product_name": "Sterling John Petrucci JP70 Mystic Dream กีต้าร์ไฟฟ้า Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/fdcd724045ad37eb2647ba28ad0ced32.jpg_200x200q90.jpg",
        "price": 57200,
        "remark": "https://www.lazada.co.th/products/pdp-i5282727886.html",
        "sold": 0
    },
    {
        "product_name": "ลำโพงมอนิเตอร์ Genelec 8030C ( Pair ) Studio Monitor Genelec 8030",
        "product_image": "https://img.lazcdn.com/g/p/60ea8e5be1592e59125c22de3d2cc76c.jpg_200x200q90.jpg",
        "price": 57000,
        "remark": "https://www.lazada.co.th/products/pdp-i2339771585.html",
        "sold": 2
    },
    {
        "product_name": "ลำโพงมอนิเตอร์ Genelec 8030CP Studio Monitor Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/78d9321871093f82498e0f960261d724.jpg_200x200q90.jpg",
        "price": 57000,
        "remark": "https://www.lazada.co.th/products/pdp-i4288242801.html",
        "sold": 2
    },
    {
        "product_name": "กีตาร์โปร่ง Hsienmo Spring Dreadnought",
        "product_image": "https://img.lazcdn.com/g/p/9d622df7818357d8cbf89d97b25ca956.jpg_200x200q90.jpg",
        "price": 57000,
        "remark": "https://www.lazada.co.th/products/pdp-i5802378121.html",
        "sold": 0
    },
    {
        "product_name": "Ibanez RG470PB กีตาร์ไฟฟ้า กีตาร์ electric guitar",
        "product_image": "https://img.lazcdn.com/g/p/2615b15366e7ddc268c165885179f29b.jpg_200x200q90.jpg",
        "price": 56760,
        "remark": "https://www.lazada.co.th/products/pdp-i5829092016.html",
        "sold": 0
    },
    {
        "product_name": "Ibanez RG8EX Electric Guitar กีตาร์ไฟฟ้า RG 8 EX RG8 8EX กีตาร์ กีต้าร์ กีต้าร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/3bc7878bc10cd0c92c20b8379cadadd5.jpg_200x200q90.jpg",
        "price": 56760,
        "remark": "https://www.lazada.co.th/products/pdp-i5086968066.html",
        "sold": 0
    },
    {
        "product_name": "Roland FP-30X เปียโน88 คีย์ น้ำหนักคีย์เหมือนเปียโนไม้ มาพร้อมเสียงเปียโนระบบ SuperNatural เพิ่มเสียงดนตรีอีกมากมาย",
        "product_image": "https://img.lazcdn.com/g/p/3fe6d362fc73c6e864137fb08e00724c.jpg_200x200q90.jpg",
        "price": 56700,
        "remark": "https://www.lazada.co.th/products/pdp-i2935624088.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องตัดมิเนียมตัวเตี้ย 12 นิ้ว STM-02 (ไม่รวมใบตัด)",
        "product_image": "https://img.lazcdn.com/g/p/039aa47348bc8c9be3fd88fa7956dad8.jpg_200x200q90.jpg",
        "price": 56600,
        "remark": "https://www.lazada.co.th/products/pdp-i4335462220.html",
        "sold": 0
    },
    {
        "product_name": "🇹🇭 Overtone Alto Saxophone รุ่น OSA-501 EX พร้อมส่งในไทย รับประกันศูนย์ไทย 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/1ee555eb69e44f4997f0cac986bdb773.jpg_200x200q90.jpg",
        "price": 56160,
        "remark": "https://www.lazada.co.th/products/pdp-i5662087150.html",
        "sold": 0
    },
    {
        "product_name": "Ibanez RG470AHM Electric Guitar กีตาร์ไฟฟ้า RG 470 AHM RG470 470AHM กีตาร์ กีต้าร์ กีต้าร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/2e77236054be52d623a477aa4835bd1f.jpg_200x200q90.jpg",
        "price": 56100,
        "remark": "https://www.lazada.co.th/products/pdp-i5086944059.html",
        "sold": 0
    },
    {
        "product_name": "Takamine GN93CE GD93CE กีตาร์โปร่งไฟฟ้า แถมกระเป๋าฟรี !!",
        "product_image": "https://img.lazcdn.com/g/p/4250ffedbc7d83841b44bfd8607681e9.jpg_200x200q90.jpg",
        "price": 56000,
        "remark": "https://www.lazada.co.th/products/pdp-i4040340655.html",
        "sold": 2
    },
    {
        "product_name": "กลองสแนร์มาร์ชชิ่ง 14 นิ้ว 12 หลัก Symphony Marching Snare Drum JBMPZ-1412 แถมชุดอาร์มสะพาย , ไม้ตีกลอง , กุญแจกลอง",
        "product_image": "https://img.lazcdn.com/g/p/deb539df28023d61e6ec96e5ea3f4137.jpg_200x200q90.jpg",
        "price": 56000,
        "remark": "https://www.lazada.co.th/products/pdp-i3434625845.html",
        "sold": 0
    },
    {
        "product_name": "เม้าท์ออแกน ฮาร์โมนิก้า 14 ช่อง คีย์ซี Hohner Chromatic Meisterklasse 7565/56C Key C 14 Holes , Performance Series Chromatic Harmonica",
        "product_image": "https://img.lazcdn.com/g/p/41c05ba5144cace75eaacae4e3fe1bd7.jpg_200x200q90.jpg",
        "price": 55800,
        "remark": "https://www.lazada.co.th/products/pdp-i5921431741.html",
        "sold": 0
    },
    {
        "product_name": "Sire Larry Carlton S7 New Gen กีตาร์ไฟฟ้า Electric Guitar รับประกันศูนย์ Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/703e25a7fbaace140b2d87e45f80b902.jpg_200x200q90.jpg",
        "price": 55400,
        "remark": "https://www.lazada.co.th/products/pdp-i5866035577.html",
        "sold": 0
    },
    {
        "product_name": "Roland รุ่น FP-30X เปียโนไฟฟ้า 88 คีย์ เชื่อมต่อบลูทูธได้ ฟังก์ชั่นมากมาย แบรนด์ญี่ปุ่น ประกันศูนย์ 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/3f62eaf26635557fb4b898bdae5aa209.jpg_200x200q90.jpg",
        "price": 55000,
        "remark": "https://www.lazada.co.th/products/pdp-i3925202574.html",
        "sold": 4
    },
    {
        "product_name": "Sterling by Music Man JP60",
        "product_image": "https://img.lazcdn.com/g/p/255f45a58757ac6bfdb74cbe294c36f6.jpg_200x200q90.jpg",
        "price": 55000,
        "remark": "https://www.lazada.co.th/products/pdp-i2346735828.html",
        "sold": 2
    },
    {
        "product_name": "กีตาร์ไฟฟ้า Cort KX508 Multi Scale II | กีตาร์ไฟฟ้า 8 สาย Fishman Fluence Open Core 12 โทนเสียง",
        "product_image": "https://img.lazcdn.com/g/p/181e4ba33d247e8696811fa160f60fea.jpg_200x200q90.jpg",
        "price": 54700,
        "remark": "https://www.lazada.co.th/products/pdp-i5976279654.html",
        "sold": 0
    },
    {
        "product_name": "Sire Marcus Miller P6 4 Strings เบส รับประกันศูนย์ Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/87c050bd5493e6b749abfe4c1f4f65b9.jpg_200x200q90.jpg",
        "price": 53200,
        "remark": "https://www.lazada.co.th/products/pdp-i5891266129.html",
        "sold": 0
    },
    {
        "product_name": "กลองไฟฟ้า NUX DM7x (แถมฟรีหูฟัง+เก้าอี้)",
        "product_image": "https://img.lazcdn.com/g/p/d52f1dbfdc400b07a5427fbaaa60f940.jpg_200x200q90.jpg",
        "price": 53100,
        "remark": "https://www.lazada.co.th/products/pdp-i4831116504.html",
        "sold": 0
    },
    {
        "product_name": "Korg Kross 2 61 Synthesizer คีย์บอร์ด 61 คีย์ อัพเดทแซมป์เครื่องดนตรีไทยแล้ว ฟรีไฟล์คู่มือภาษาไทย Kross2 +รับประกันศูนย์ 1ปี Music Arms",
        "product_image": "https://img.lazcdn.com/g/p/5e795bece9c6f829fa0569d64881f688.jpg_200x200q90.jpg",
        "price": 52800,
        "remark": "https://www.lazada.co.th/products/pdp-i126448117.html",
        "sold": 9
    },
    {
        "product_name": "Korg Kross 2 61 คีย์บอร์ด อัพเดทแซมป์เครื่อดนตรีไทยแล้ว Kross2 รับประกันศูนย์",
        "product_image": "https://img.lazcdn.com/g/p/80707a4514d177d3f2be70d04b5486c9.jpg_200x200q90.jpg",
        "price": 52800,
        "remark": "https://www.lazada.co.th/products/pdp-i2207563031.html",
        "sold": 3
    },
    {
        "product_name": "🇹🇭 Overtone Soprano Curve Saxophone รุ่น  OSSC-190EX พร้อมส่งในไทย รับประกันศูนย์ไทย 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/530fd27bd68ccff2a3a2c4bd637ce4af.png_200x200q90.png",
        "price": 52800,
        "remark": "https://www.lazada.co.th/products/pdp-i5780117254.html",
        "sold": 0
    },
    {
        "product_name": "คีย์บอร์ดไฟฟ้า 61 คีย์ KORG Kross 2 61 Keys มาตรฐาน + Preset 1075 แบบ (Synthesizer Workstation) ระบบเสียง EDS-i - รับประกันศูนย์ ส่งจากไทย",
        "product_image": "https://img.lazcdn.com/g/p/b44c0ca7f6165c0b474f7f1167b14c00.jpg_200x200q90.jpg",
        "price": 52800,
        "remark": "https://www.lazada.co.th/products/pdp-i6079174243.html",
        "sold": 0
    },
    {
        "product_name": "Korg Keystage 61 Keys สี Black คีย์บอร์ดใบ้ Korg Keystage Midi Keyboard เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/fcffe7a3ca7c6338a1b962e8c5228a58.jpg_200x200q90.jpg",
        "price": 52798,
        "remark": "https://www.lazada.co.th/products/pdp-i5105287261.html",
        "sold": 0
    },
    {
        "product_name": "Ibanez RG470DX Electric Guitar กีตาร์ไฟฟ้า RG 470 DX RG470 470DX กีต้าร์ กีตาร์ กีต้าร์ไฟฟ้า ElectricGuitar",
        "product_image": "https://img.lazcdn.com/g/p/56b3e06ecbb6fa0bcdd0e56ece043bf2.jpg_200x200q90.jpg",
        "price": 52360,
        "remark": "https://www.lazada.co.th/products/pdp-i5086492886.html",
        "sold": 0
    },
    {
        "product_name": "PRS SE CE24 STANDARD SATIN กีตาร์ไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/9bdf84e23af597897a5faa3c8c83d68b.jpg_200x200q90.jpg",
        "price": 52200,
        "remark": "https://www.lazada.co.th/products/pdp-i5550040910.html",
        "sold": 0
    },
    {
        "product_name": "Blessing BTR-1287S Trumpet Standard บีแฟลต ทรัมเป็ต",
        "product_image": "https://img.lazcdn.com/g/p/7f4989468310f97bcb094d0a86c6cea7.jpg_200x200q90.jpg",
        "price": 52000,
        "remark": "https://www.lazada.co.th/products/pdp-i6039573934.html",
        "sold": 0
    },
    {
        "product_name": "ดับเบิ้ล เฟรนช์ฮอร์น คีย์เอฟ/บีแฟลต มี 4 คีย์ พร้อมอุปกรณ์ครบชุด JY JYFH-E130 Double French Horn Key F/Bb , 4 Key",
        "product_image": "https://img.lazcdn.com/g/p/d82ca08fb3f8807da54378c715afa4fe.jpg_200x200q90.jpg",
        "price": 52000,
        "remark": "https://www.lazada.co.th/products/pdp-i5679291175.html",
        "sold": 0
    },
    {
        "product_name": "Ibanez RG470DXW Candy Apple กีตาร์ไฟฟ้า RG470DXW",
        "product_image": "https://img.lazcdn.com/g/p/9b8aea121ea5ff25670086c3cfb5d8aa.jpg_200x200q90.jpg",
        "price": 51920,
        "remark": "https://www.lazada.co.th/products/pdp-i5883156738.html",
        "sold": 0
    },
    {
        "product_name": "Ibanez RG450DXB กีตาร์ไฟฟ้า Electric Guitar รับประกันวงจร 1 ปี AssawaMusic อัศวมิวสิค",
        "product_image": "https://img.lazcdn.com/g/p/e3f25c384c3f3c27a1591026d36f22a7.jpg_200x200q90.jpg",
        "price": 51920,
        "remark": "https://www.lazada.co.th/products/pdp-i16108462082.html",
        "sold": 0
    },
    {
        "product_name": "กีตาร์โปร่งไฟฟ้า [แถมกระเป๋า] CRAFTER MIND W PRESTIGE ROSE-GCE VVS/BAG",
        "product_image": "https://img.lazcdn.com/g/p/c4eabba1853c2b408cf6f1d5eb0613b2.jpg_200x200q90.jpg",
        "price": 51840,
        "remark": "https://www.lazada.co.th/products/pdp-i4101916128.html",
        "sold": 7
    },
    {
        "product_name": "กีตาร์โปร่งไฟฟ้า (แถมกระเป๋า) CRAFTER STG G-27CE",
        "product_image": "https://img.lazcdn.com/g/p/f6f1dd42cbc0bdb1cb33e780770844d8.jpg_200x200q90.jpg",
        "price": 51840,
        "remark": "https://www.lazada.co.th/products/pdp-i4416364865.html",
        "sold": 0
    },
    {
        "product_name": "กีตาร์โปร่งไฟฟ้า CRAFTER STG J-27CE [FREE BAG]",
        "product_image": "https://img.lazcdn.com/g/p/17c9d1e5962e5e3036a4b6e6dbf5e7b7.jpg_200x200q90.jpg",
        "price": 51840,
        "remark": "https://www.lazada.co.th/products/pdp-i4101917183.html",
        "sold": 1
    },
    {
        "product_name": "Tyma Star Sea All Solid กีตาร์โปร่ง ทรง GA กีต้าร์โปร่ง ไม้แท้ทั้งตัว ระดับพรีเมียม",
        "product_image": "https://img.lazcdn.com/g/p/e0370e87e5cd7362b6c3778420a01684.jpg_200x200q90.jpg",
        "price": 51800,
        "remark": "https://www.lazada.co.th/products/pdp-i16046067741.html",
        "sold": 0
    },
    {
        "product_name": "Guild OM-240E กีตาร์โปร่ง Guild OM 240E",
        "product_image": "https://img.lazcdn.com/g/p/7d4b7f8e3984b6a045e7e4ecae657841.jpg_200x200q90.jpg",
        "price": 51800,
        "remark": "https://www.lazada.co.th/products/pdp-i3134648841.html",
        "sold": 0
    },
    {
        "product_name": "Nux DM-310H กลองไฟฟ้า Nux DM310H Electric Drum - เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/6db50466dac6ff923031ce5e2ab5e993.jpg_200x200q90.jpg",
        "price": 51698,
        "remark": "https://www.lazada.co.th/products/pdp-i6044484092.html",
        "sold": 0
    },
    {
        "product_name": "พิณไฟฟ้าไม้พยุงทั้งตัว รุ่นมาตฐานดนตรีอีสาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9f6d74b60bfa4272b549a0ded430a500G.jpg_200x200q90.jpg",
        "price": 51000,
        "remark": "https://www.lazada.co.th/products/pdp-i3916559101.html",
        "sold": 0
    },
    {
        "product_name": "กลองชุด Pearl Midtown ชุด 4 ใบ พร้อมฮาร์ดแวร์",
        "product_image": "https://img.lazcdn.com/g/p/3d48ca383c96b728ef9f0d7182b71af2.jpg_200x200q90.jpg",
        "price": 50700,
        "remark": "https://www.lazada.co.th/products/pdp-i5082669106.html",
        "sold": 0
    },
    {
        "product_name": "Takamine GN71CE GD71CE กีตาร์โปร่งไฟฟ้า แถมกระเป๋าฟรี !!",
        "product_image": "https://img.lazcdn.com/g/p/3d1ede1bb75d56acd0c3abd2d092fc7e.jpg_200x200q90.jpg",
        "price": 50640,
        "remark": "https://www.lazada.co.th/products/pdp-i4040380060.html",
        "sold": 4
    },
    {
        "product_name": "Takamine GJ72CE แถมกระเป๋าฟรี!! Acoustic Guitar กีตาร์โปร่งไฟฟ้า กีตาร์โปร่ง กีต้าร์ GJ72 CE GJ-72CE",
        "product_image": "https://img.lazcdn.com/g/p/e1489973c297cf02ec658e5ca559e2bb.jpg_200x200q90.jpg",
        "price": 50640,
        "remark": "https://www.lazada.co.th/products/pdp-i5064894369.html",
        "sold": 1
    },
    {
        "product_name": "กระเดื่องคู่ TAMA Speed Cobra Limited Edition Black Copper HP910LWCB",
        "product_image": "https://img.lazcdn.com/g/p/2172b0d6b65d0d0336783e2f9b9a09d0.png_200x200q90.png",
        "price": 50600,
        "remark": "https://www.lazada.co.th/products/pdp-i111465664.html",
        "sold": 2
    },
    {
        "product_name": "กีต้าร์โปร่ง TYMA TD-28 , TF-28 all solid",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S11e3cd89b02242e19b4debff5658a8089.jpg_200x200q90.jpg",
        "price": 50400,
        "remark": "https://www.lazada.co.th/products/pdp-i5482721566.html",
        "sold": 0
    },
    {
        "product_name": "Tyma Blue Bird All Solid กีตาร์โปร่ง",
        "product_image": "https://img.lazcdn.com/g/p/49121f67cdf2f3c7a6479006c46eb7f5.jpg_200x200q90.jpg",
        "price": 50380,
        "remark": "https://www.lazada.co.th/products/pdp-i16048634214.html",
        "sold": 0
    },
    {
        "product_name": "กีต้าร์ไฟฟ้า Epiphone G-400 Les Paul Custom",
        "product_image": "https://img.lazcdn.com/g/p/920db78d8fa11461ebbbbfafb29f8ec1.png_200x200q90.png",
        "price": 50000,
        "remark": "https://www.lazada.co.th/products/pdp-i5695393395.html",
        "sold": 0
    },
    {
        "product_name": "รับส่วนลดสูงสุด 3,100.- หรือรับส่วนลด 10%, ซินธิไซเซอร์ Roland XPS10 สี Black , Red (XPS-10) ,ฟรีของเเถม ,พร้อมเช็ค QC ,ประกันจากศูนย์ ,แท้100% ,ผ่อน0% ,ส่งฟรี เต่าแดง",
        "product_image": "https://img.lazcdn.com/g/p/f552ed6374ee7d6ececac7c9d49e24bf.jpg_200x200q90.jpg",
        "price": 50000,
        "remark": "https://www.lazada.co.th/products/pdp-i4156812283.html",
        "sold": 3
    },
    {
        "product_name": "กีตาร์ไฟฟ้า Epiphone Les Paul Modern",
        "product_image": "https://img.lazcdn.com/g/p/b5d8547ff1b6b055821587a52a45c42b.jpg_200x200q90.jpg",
        "price": 50000,
        "remark": "https://www.lazada.co.th/products/pdp-i5372466626.html",
        "sold": 0
    },
    {
        "product_name": "เปียโน ไฟฟ้า ยามาฮ่า CLP-220",
        "product_image": "https://img.lazcdn.com/g/p/926d60fdb4761e067452282ff9ace39d.jpg_200x200q90.jpg",
        "price": 50000,
        "remark": "https://www.lazada.co.th/products/pdp-i5906080268.html",
        "sold": 0
    },
    {
        "product_name": "ห้องน้ำผู้สูงอายุ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se0cdcb4db11b4602a318f30bce244781C.jpg_200x200q90.jpg",
        "price": 70000,
        "remark": "https://www.lazada.co.th/products/pdp-i16105511954.html",
        "sold": 0
    },
    {
        "product_name": "kodillv | ชักโครกอัจฉริยะติดผนัง ไม่มีถังน้ำติดตั้งล่วงหน้า 55 ซม. ระบบไซโฟน",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S2421cd7848914927a0cbcb9c05dcc3dbU.png_200x200q90.png",
        "price": 33273.28,
        "remark": "https://www.lazada.co.th/products/pdp-i6066892437.html",
        "sold": 0
    },
    {
        "product_name": "ZEPPER เครื่องชั่งน้ำหนักระบบดิจิตอล วัดค่า BMI พร้อมที่วัดส่วนสูง รุ่น TCS-250A-RT  250 kg",
        "product_image": "https://img.lazcdn.com/g/p/5b0fe882306edc828176086c355b6254.png_200x200q90.png",
        "price": 23000,
        "remark": "https://www.lazada.co.th/products/pdp-i5143651214.html",
        "sold": 0
    },
    {
        "product_name": "ชุดตู้ห้องน้ำหรูหราแบบนาโน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7fd939fe1e6145bdaf4c2105a471fb4c0.jpg_200x200q90.jpg",
        "price": 18209.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16103414414.html",
        "sold": 0
    },
    {
        "product_name": "ชักโครกติดผนังไม่ต้องใช้ไฟพร้อมถังน้ำติดตั้งไว้แล้ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S817c67911b4b46889246ea125bb778a4y.jpg_200x200q90.jpg",
        "price": 18022.22,
        "remark": "https://www.lazada.co.th/products/pdp-i6066615701.html",
        "sold": 0
    },
    {
        "product_name": "SSWW | โถสุขภัณฑ์ติดผนัง พร้อมถังน้ำฝังกำแพงและดีไซน์ลอยไม่ติดพื้น",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S90b84e4df732494f83db24eb6f39bb65r.png_200x200q90.png",
        "price": 14564.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5909665065.html",
        "sold": 7
    },
    {
        "product_name": "ชักโครกติดผนังอัจฉริยะพร้อมการควบคุมด้วยเสียง AI ไม่มีข้อจำกัดแรงดันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S48b268f340fc4737a12e327aed8e995aM.jpg_200x200q90.jpg",
        "price": 12660.54,
        "remark": "https://www.lazada.co.th/products/pdp-i6066572964.html",
        "sold": 0
    },
    {
        "product_name": "kodillv | ชักโครกอัจฉริยะติดผนังพร้อมถังน้ำในตัว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1b671f9375a44834bfe98e6c5fe42edey.jpg_200x200q90.jpg",
        "price": 12277.4,
        "remark": "https://www.lazada.co.th/products/pdp-i6066847481.html",
        "sold": 0
    },
    {
        "product_name": "[ขายร้อนปี 2024] เครื่องถูหลังอัตโนมัติ, แปรงอาบน้ำไฟฟ้าในห้องน้ำของโรงแรม, เครื่องอาบน้ำติดผนัง, อุปกรณ์อาบน้ำของคนขี้เกียจ",
        "product_image": "https://img.lazcdn.com/g/p/b76a623176a35f2689d0e776e579560d.jpg_200x200q90.jpg",
        "price": 9198,
        "remark": "https://www.lazada.co.th/products/pdp-i5301378428.html",
        "sold": 5
    },
    {
        "product_name": "BATH&BATH BT-4048 สุขภัณฑ์ชิ้นเดียว 4.8L COLOSSAL",
        "product_image": "https://img.lazcdn.com/g/p/f95bd4898ded0de492f0bab89c262670.jpg_200x200q90.jpg",
        "price": 9180,
        "remark": "https://www.lazada.co.th/products/pdp-i5792839514.html",
        "sold": 1
    },
    {
        "product_name": "JOMOW|ชักโครกป้องกันน้ำกระเด็นแบบสิฟอนิก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S477d33c01cc44e6a9249b8b3bd89a399N.png_200x200q90.png",
        "price": 9021.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6003266566.html",
        "sold": 0
    },
    {
        "product_name": "JIAWENHUA | ราวจับห้องน้ำพับได้สำหรับผู้สูงอายุพร้อมป้องกันลื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb8237c66e52e4c15aa6b5568d4d4259cV.jpg_200x200q90.jpg",
        "price": 7990.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5910768809.html",
        "sold": 2
    },
    {
        "product_name": "กระจกห้องน้ำทรงกลม LED ป้องกันฝ้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7c9190ae555e4a1d88ddf2b52e8a14ebQ.png_200x200q90.png",
        "price": 7765.3,
        "remark": "https://www.lazada.co.th/products/pdp-i16083400667.html",
        "sold": 0
    },
    {
        "product_name": "กระจกห้องน้ำพร้อมไฟ LED และระบบป้องกันฝ้าที่หน้าจอสัมผัส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0526965ddf2a4fa0941842456eb9febfA.png_200x200q90.png",
        "price": 7446,
        "remark": "https://www.lazada.co.th/products/pdp-i16065454147.html",
        "sold": 0
    },
    {
        "product_name": "CUNGSA | ชักโครกสแตนเลส 304 สำหรับใช้ในเรือนจำและสาธารณะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf26c92c7d281494fabfd64f48ad54ceeO.jpg_200x200q90.jpg",
        "price": 7071.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16110017281.html",
        "sold": 0
    },
    {
        "product_name": "ตู้กระจกห้องน้ำป้องกันฝ้าอัจฉริยะ พร้อมไฟและที่เก็บไดร์เป่าผม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saac1a44a22414af59e70d532da939bb47.jpg_200x200q90.jpg",
        "price": 6936.18,
        "remark": "https://www.lazada.co.th/products/pdp-i16052521216.html",
        "sold": 0
    },
    {
        "product_name": "PAMPAS | ชั้นเก็บของห้องน้ำมุมสำหรับสองชั้น ทำจากทองแดงแท้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb40ed33c4147464ab44dd8193dd0fbb9T.jpg_200x200q90.jpg",
        "price": 6237.36,
        "remark": "https://www.lazada.co.th/products/pdp-i16083503669.html",
        "sold": 1
    },
    {
        "product_name": "WELLO รถเข็นนั่งถ่าย รถเข็นนั่งอาบน้ำ คร่อมชักโครกได้ เบาะนิ่ม นั่งสบาย โครงอลูมิเนียมอย่างดี ไม่เป็นสนิม",
        "product_image": "https://img.lazcdn.com/g/p/e79768101672cf1e18df8f165db37d5a.jpg_200x200q90.jpg",
        "price": 6198,
        "remark": "https://www.lazada.co.th/products/pdp-i1417444913.html",
        "sold": 80
    },
    {
        "product_name": "LUTUMEI | กระจกแต่งหน้าติดผนังไม่ต้องเจาะ ไม่มีไฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9e9d8c4189f0413e8dbb201c76b809aaw.jpg_200x200q90.jpg",
        "price": 5563.7,
        "remark": "https://www.lazada.co.th/products/pdp-i6023039965.html",
        "sold": 8
    },
    {
        "product_name": "Midas ผ้าขนหนู Cotton 100% รุ่น Basic Living ขนาด 27x54 นิ้ว (12 ผืน) นุ่มนวล ผ่อนคลายผิวสัมผัส ส่งฟรี",
        "product_image": "https://img.lazcdn.com/g/p/e47095cd166f540d458d9792bacd4f75.jpg_200x200q90.jpg",
        "price": 5256,
        "remark": "https://www.lazada.co.th/products/pdp-i16088218321.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้นั่งถ่าย เก้าอี้อาบน้ำ รถอาบน้ำคนป่วย อลูมิเนียมอัลลอย วีลแชร์ เดินทางได้ รับน้ำหนักได้ 150กก. เก้าอี้ห้องน้ำชายชรา สุขาเคลื่อนที่ เบาะนุ่มสบาย พับได้ขนาดพกพา Shower Wheelchair",
        "product_image": "https://img.lazcdn.com/g/p/3bf68da358617165be02f412634112c7.jpg_200x200q90.jpg",
        "price": 4998,
        "remark": "https://www.lazada.co.th/products/pdp-i1754118861.html",
        "sold": 470
    },
    {
        "product_name": "Vidalido Shower Tent  เต๊นท์ห้องน้ำ    เต๊นท์ อาบน้ำ เปลี่ยนเสื้อผ้า แบบพกพา ถอดประกอบง่าย สินค้าพร้อมส่งจากไทย",
        "product_image": "https://img.lazcdn.com/g/p/e6b53d6b77ce40d13ba56e88c71dc15c.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i4193519135.html",
        "sold": 0
    },
    {
        "product_name": "ตีนกบฟรีไดฟ์วิ่งรุ่นใหม่สำหรับดำน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa9cfa4a8cd4b452697a90c1ca7d928adt.jpg_200x200q90.jpg",
        "price": 4890.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16083284973.html",
        "sold": 3
    },
    {
        "product_name": "JIAWENHUA | โครงช่วยยืนสำหรับผู้สูงอายุ ไม่ต้องเจาะ ป้องกันลื่น สำหรับห้องน้ำและโซฟา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S15f5350329b64c6282d541d02775bdd1e.jpg_200x200q90.jpg",
        "price": 4701.54,
        "remark": "https://www.lazada.co.th/products/pdp-i5910843266.html",
        "sold": 0
    },
    {
        "product_name": "JIAWENHUA | เก้าอี้นั่งอาบน้ำพับได้พร้อมราวจับคู่กันลื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S75b86e473c224d2f99d9ee97fa7c0551T.jpg_200x200q90.jpg",
        "price": 4646.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5910822826.html",
        "sold": 17
    },
    {
        "product_name": "JIAWENHUA | เก้าอี้นั่งอาบน้ำพับได้สำหรับผู้สูงอายุและสตรีมีครรภ์ พร้อมที่จับกันลื่นและความปลอดภัย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd86b7f209afd4143a6016aa9620b8b44v.jpg_200x200q90.jpg",
        "price": 4639.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5910938317.html",
        "sold": 4
    },
    {
        "product_name": "DONGPENG | ชุดโถส้วมแบบนั่งยองและถังชักโครก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S356766c20dd74618a581ea50e8dbdd86K.jpg_200x200q90.jpg",
        "price": 4613.64,
        "remark": "https://www.lazada.co.th/products/pdp-i5909472589.html",
        "sold": 34
    },
    {
        "product_name": "JIAWENHUA | เก้าอี้สำหรับผู้สูงอายุ ใช้นั่งยอง นั่งอาบน้ำ รองรับน้ำหนักได้เยอะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9ff76890891f4a52a05e9a1eeedbb089w.jpg_200x200q90.jpg",
        "price": 4541.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5910952008.html",
        "sold": 6
    },
    {
        "product_name": "ที่แขวนผ้าเช็ดตัวสไตล์ยุโรปสีทองแดงแบบโบราณ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se33301e5f0834d9c95087c5353a26f25b.jpg_200x200q90.jpg",
        "price": 4537.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16102797496.html",
        "sold": 1
    },
    {
        "product_name": "B&W | ชั้นวางของในห้องน้ำมุมสแตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sac67c2464c1747349ce6ac8e995f84a8T.png_200x200q90.png",
        "price": 4447.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5877760678.html",
        "sold": 6
    },
    {
        "product_name": "[Recycle] ERI Premium ฝารองนั่ง / ฝาชักโครก กึ่งอัตโนมัติไม่ใช้ไฟฟ้า สี MIDNIGHT",
        "product_image": "https://img.lazcdn.com/g/p/8b0b3a6da7c38bff2f4cf3d02422fd67.jpg_200x200q90.jpg",
        "price": 4280,
        "remark": "https://www.lazada.co.th/products/pdp-i5968901978.html",
        "sold": 3
    },
    {
        "product_name": "[Recycle] ERI Premium ฝารองนั่ง / ฝาชักโครก กึ่งอัตโนมัติไม่ใช้ไฟฟ้า สี WARM LIGHT",
        "product_image": "https://img.lazcdn.com/g/p/1d7d813562f4183db98d7063fb3d8180.jpg_200x200q90.jpg",
        "price": 4280,
        "remark": "https://www.lazada.co.th/products/pdp-i5968975369.html",
        "sold": 0
    },
    {
        "product_name": "[Recycle] ERI Premium ฝารองนั่ง / ฝาชักโครก กึ่งอัตโนมัติไม่ใช้ไฟฟ้า สี FRESH WATER",
        "product_image": "https://img.lazcdn.com/g/p/383f3ebff64ff03122a28121b8ad7456.jpg_200x200q90.jpg",
        "price": 4280,
        "remark": "https://www.lazada.co.th/products/pdp-i5969011274.html",
        "sold": 0
    },
    {
        "product_name": "JIAWENHUA | ที่นั่งอาบน้ำติดผนังกันลื่นสำหรับผู้สูงอายุและผู้พิการ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S16751a7bf07040c381c5180fa191386a3.jpg_200x200q90.jpg",
        "price": 4199.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5910864823.html",
        "sold": 100
    },
    {
        "product_name": "JIAWENHUA | ที่นั่งอาบน้ำสำหรับผู้สูงอายุ กันลื่น พร้อมพนักพิงแขน ปรับระดับความสูงได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S37cac406681d4ed38647ec2e0c04443bx.jpg_200x200q90.jpg",
        "price": 4176.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5910807803.html",
        "sold": 1
    },
    {
        "product_name": "SHANNAIER | ตู้กระจกห้องน้ำติดผนังพร้อมไฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5cc716676db4437aa882d20db89877d4E.png_200x200q90.png",
        "price": 4114.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16062490823.html",
        "sold": 0
    },
    {
        "product_name": "ตู้กระจกอลูมิเนียมทรงกลมขอบมน พร้อมไฟ ติดผนัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S540f10055e5641d49e77f9540f2e4335o.jpg_200x200q90.jpg",
        "price": 4039.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16053144865.html",
        "sold": 0
    },
    {
        "product_name": "bubuluck | เก้าอี้ชักโครกพกพาสำหรับผู้ใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9b00b011587e442b9e915f83173ac939d.jpg_200x200q90.jpg",
        "price": 3876.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5952503030.html",
        "sold": 2
    },
    {
        "product_name": "ตู้เก็บของในห้องน้ำกันน้ำแบบติดผนัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc2e9937b50034ec787ebe89d94d0918dS.png_200x200q90.png",
        "price": 3821.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16099399860.html",
        "sold": 0
    },
    {
        "product_name": "ห้องนำ้สำเร็ขรูปเดี่ยว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3bca9e9ca0aa4f448475aa1470e66916c.jpg_200x200q90.jpg",
        "price": 40000,
        "remark": "https://www.lazada.co.th/products/pdp-i16105847017.html",
        "sold": 0
    },
    {
        "product_name": "JUNSHEN | ชั้นวางของสไตล์โบราณสีทองเหลือง 1 ชิ้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S45e61215ca7a4957a13518c0a1c807e60.jpg_200x200q90.jpg",
        "price": 3729.6,
        "remark": "https://www.lazada.co.th/products/pdp-i6003358258.html",
        "sold": 0
    },
    {
        "product_name": "JIAWENHUA | ราวจับความปลอดภัยสำหรับห้องน้ำผู้สูงอายุ ไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S33643ad826584fde8bc8da267f7adf7bg.jpg_200x200q90.jpg",
        "price": 3389.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5910920526.html",
        "sold": 9
    },
    {
        "product_name": "DANBIYIN | กระจกห้องน้ำแขวนและติดเพดานสำหรับโรงแรมและบีแอนด์บี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S631b4a037f034315a1452bd15572a980F.jpg_200x200q90.jpg",
        "price": 3381.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16060299113.html",
        "sold": 0
    },
    {
        "product_name": "ม่านกั้นอาบน้ำกันน้ำได้ สามารถพับเก็บได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7d167c4e4ca842b19249c0510640fa33Z.jpg_200x200q90.jpg",
        "price": 3174.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16094763376.html",
        "sold": 0
    },
    {
        "product_name": "NAIERDENG | พรมป้องกันลื่นในห้องน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S912f2a9b5019452da741f834b9776ff8c.jpg_200x200q90.jpg",
        "price": 3104,
        "remark": "https://www.lazada.co.th/products/pdp-i6005928406.html",
        "sold": 0
    },
    {
        "product_name": "[ส่งไว] ANKER eufy Smart Scale P2 Pro เครื่องชั่งน้ำหนัก ดัชนีชี้วัดร่างกาย 16 รายการ ฟังก์ชั่นโมเดล 3D พร้อม BMI กันน้ำ IPX5 เชื่อมต่อ Wi-Fi และ บลูทูธ",
        "product_image": "https://img.lazcdn.com/g/p/17db9ac6d7045c4c43924ca30ac90ea2.jpg_200x200q90.jpg",
        "price": 2998,
        "remark": "https://www.lazada.co.th/products/pdp-i5732013254.html",
        "sold": 142
    },
    {
        "product_name": "JIDIDIAO | ผ้าม่านกั้นห้องน้ำแยกแห้งเปียก พร้อมถ้วยดูด เก็บพับได้ ไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se53cf05d0d9d4dafb7472bb462491ca3N.jpg_200x200q90.jpg",
        "price": 2952,
        "remark": "https://www.lazada.co.th/products/pdp-i6005890958.html",
        "sold": 0
    },
    {
        "product_name": "ZHIFAN | ม่านกั้นห้องน้ำกันน้ำ แบบพับได้ ไม่ต้องเจาะรู",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S907cd24808994887b5ffd452b489cdab3.jpg_200x200q90.jpg",
        "price": 2951.84,
        "remark": "https://www.lazada.co.th/products/pdp-i5933167075.html",
        "sold": 40
    },
    {
        "product_name": "JIAWENHUA | เก้าอี้นั่งอาบน้ำพับได้สำหรับผู้สูงอายุในห้องน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S38899434d52c45d8b49c5039a9f8fae9l.jpg_200x200q90.jpg",
        "price": 2948.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5910939216.html",
        "sold": 12
    },
    {
        "product_name": "JIAWENHUA | เก้าอี้ช่วยเหลือการอาบน้ำสำหรับผู้สูงอายุ ที่นั่งในห้องน้ำพับได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa04c369541054d4f8b81679b8e93a1d8j.jpg_200x200q90.jpg",
        "price": 2942.46,
        "remark": "https://www.lazada.co.th/products/pdp-i5910801792.html",
        "sold": 10
    },
    {
        "product_name": "Keluojing | อ่างล้างหน้าขนาดเล็กสี่เหลี่ยมติดผนัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S717eb0e1f002491bb5f5e7ab19b8c7d65.jpg_200x200q90.jpg",
        "price": 2930.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16062472746.html",
        "sold": 0
    },
    {
        "product_name": "JIAWENHUA | ราวจับห้องน้ำสำหรับสตรีตั้งครรภ์และผู้สูงอายุ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf006be4a0a994229bbbc9dd5ee6e7ccdj.jpg_200x200q90.jpg",
        "price": 2919.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5910761941.html",
        "sold": 11
    },
    {
        "product_name": "เก้าอี้นั่งถ่ายเก้าอี้อาบน้ำพิเศษสำหรับผู้สูงอายุ สุขาพับได้ เก้าอี้อาบน้ำในห้องน้ำเก้าอี้กันลื่นเก้าอี้อาบน้ำผู้ป่วยสำหรับสตรีม",
        "product_image": "https://img.lazcdn.com/g/p/13934ae87f38382644f60b55a1143981.jpg_200x200q90.jpg",
        "price": 2906,
        "remark": "https://www.lazada.co.th/products/pdp-i4894632691.html",
        "sold": 12
    },
    {
        "product_name": "DANBIYIN | อ่างล้างหน้าเซรามิคแบบกึ่งฝัง",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S3de8a027488e4560bd345780eb4ede966.jpg_200x200q90.jpg",
        "price": 2857.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16060209476.html",
        "sold": 0
    },
    {
        "product_name": "B&W | ชั้นวางของห้องน้ำมุม 304 สแตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbfb33c55129b4f12b18875793ef9602fS.png_200x200q90.png",
        "price": 2832.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5874290593.html",
        "sold": 170
    },
    {
        "product_name": "XINGQI | ตู้เก็บของในห้องน้ำกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd9cb59912d79400c88e65df2d02946efP.jpg_200x200q90.jpg",
        "price": 2830,
        "remark": "https://www.lazada.co.th/products/pdp-i6026044574.html",
        "sold": 0
    },
    {
        "product_name": "ม่านกั้นอาบน้ำรูปโค้งแม่เหล็ก ไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2e5316bd9f324fb3b508947eb926aa7fy.jpg_200x200q90.jpg",
        "price": 2812.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16089510501.html",
        "sold": 0
    },
    {
        "product_name": "DANBIYIN | ตู้กระจกติดผนังกันความชื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb9cef4bbeed446f09cb38cddf24b35948.jpg_200x200q90.jpg",
        "price": 2805.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16060313260.html",
        "sold": 0
    },
    {
        "product_name": "ผ้าม่านกั้นห้องน้ำพับได้ กันน้ำ ไม่เห็นผ่าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S126d878a6eff421a81970fac6536b197U.jpg_200x200q90.jpg",
        "price": 2792.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16089156970.html",
        "sold": 0
    },
    {
        "product_name": "SEGO เก้าอี้นั่งถ่าย เก้าอี้อาบน้ำ ผู้สูงอายุ พับได้ ปรับความสูงได้ โครงอลูมิเนียมอัลลอยด์  น้ำหนักเบาไม่เป็นสนิม คร่อมชักโครกได้",
        "product_image": "https://img.lazcdn.com/g/p/29b9c784d5f6dca27eb8a0cde9f9a148.png_200x200q90.png",
        "price": 2741,
        "remark": "https://www.lazada.co.th/products/pdp-i10694312.html",
        "sold": 333
    },
    {
        "product_name": "JIAWENHUA | ที่นั่งอาบน้ำพับได้ติดผนังกันลื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa0ed28a2336b45d1a15269da7e6c802dG.jpg_200x200q90.jpg",
        "price": 2722.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5910847443.html",
        "sold": 1
    },
    {
        "product_name": "ที่ลอยน้ำ EVA สำหรับผู้ใหญ่ ทนทาน NBR ลอยตัวสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb64dc3ad683c4da29df764cec01a80c4n.jpg_200x200q90.jpg",
        "price": 2708,
        "remark": "https://www.lazada.co.th/products/pdp-i16050191588.html",
        "sold": 1
    },
    {
        "product_name": "Badu | อ่างล้างหน้าสแตนเลสขนาดเล็กติดผนัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdc7c0072fc8c47aa9d7bf8d24b7f2649E.jpg_200x200q90.jpg",
        "price": 2701.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5929281593.html",
        "sold": 0
    },
    {
        "product_name": "UNHO ชั้นวางของในห้องน้ำ ไม้ไผ่ธรรมชาติคุณภาพสูง Tall Slim Floor Bathroom Storage Cabinet with 3-tier Shelves ห้องน้ํา, ห้องนั่งเล่น, ชั้นวางของในครัว",
        "product_image": "https://img.lazcdn.com/g/p/3f02335acfb46730bb87461cf3b99e9d.png_200x200q90.png",
        "price": 2699.54,
        "remark": "https://www.lazada.co.th/products/pdp-i5171359574.html",
        "sold": 1
    },
    {
        "product_name": "JIAWENHUA | เก้าอี้นั่งอาบน้ำพับได้ป้องกันลื่นสำหรับผู้สูงอายุและสตรีตั้งครรภ์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se1e59ba92b9b437b920fdd23db7533acZ.jpg_200x200q90.jpg",
        "price": 2698.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5910797897.html",
        "sold": 18
    },
    {
        "product_name": "SHANNAIER | อุปกรณ์ตกแต่งห้องน้ำสไตล์สแกนดิเนเวียน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb9307e9f7a5444b38cfb04d46d0fbe43g.jpg_200x200q90.jpg",
        "price": 2669.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16060996159.html",
        "sold": 0
    },
    {
        "product_name": "bubuluck | เก้าอี้ห้องน้ำพกพาติดเตียง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sec39acdf080d491d96e557a2f66ac9dc1.jpg_200x200q90.jpg",
        "price": 2646.46,
        "remark": "https://www.lazada.co.th/products/pdp-i5953954935.html",
        "sold": 5
    },
    {
        "product_name": "ตู้เก็บของติดผนังกันน้ำ ไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S174eec9f54864578907ee12bed1703d5E.jpg_200x200q90.jpg",
        "price": 2616.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16102889524.html",
        "sold": 0
    },
    {
        "product_name": "JIAWENHUA | เก้าอี้นั่งอาบน้ำสำหรับผู้สูงอายุ ป้องกันการลื่นล้ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf853de51bdae43468c6a8930a45266794.jpg_200x200q90.jpg",
        "price": 2596.38,
        "remark": "https://www.lazada.co.th/products/pdp-i5910803734.html",
        "sold": 13
    },
    {
        "product_name": "JIAWENHUA | ราวจับห้องน้ำทรงยูพับได้สำหรับผู้พิการและผู้สูงอายุ สแตนเลส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7e0945e36ecf4beebaf253cd96248c2d7.jpg_200x200q90.jpg",
        "price": 2592.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5910849194.html",
        "sold": 0
    },
    {
        "product_name": "ตู้กระจกเก็บของติดผนังสไตล์นอร์ดิก อลูมิเนียมสเปซ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S566201fe113a4c578a59113f373dc97bU.jpg_200x200q90.jpg",
        "price": 2562.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16102851640.html",
        "sold": 0
    },
    {
        "product_name": "Homyl ชั้นวางผ้าขนหนูสำหรับผ้าเช็ดตัวห้องน้ำจัดเก็บสีดำติดผนังแบบโลหะ",
        "product_image": "https://img.lazcdn.com/g/p/c97d9df92683561a90e2f3a84f3ac38d.jpg_200x200q90.jpg",
        "price": 2530,
        "remark": "https://www.lazada.co.th/products/pdp-i6019818661.html",
        "sold": 0
    },
    {
        "product_name": "LIXADA เต็นท์ห้องน้ำกลางแจ้งในห้องน้ำเต้นท์แบบห้องห้องน้ำ Lixar Livre Funien เต็นท์กลางแจ้งห้องพักแบบพกพาห้องเต็นท์ห้องน้ำแบบพกพาเต็นท์กำบังกลางแจ้ง Buzhi Dalynn ห้องสุขาพร้อมถือ Abarich Huioperyue",
        "product_image": "https://img.lazcdn.com/g/p/ef8d8109df47744f24746a9fdf90044b.jpg_200x200q90.jpg",
        "price": 2504,
        "remark": "https://www.lazada.co.th/products/pdp-i5146727465.html",
        "sold": 0
    },
    {
        "product_name": "B&W | ชั้นวางมุมห้องน้ำ สแตนเลส 304",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seca7f10cac7743a7bc194068fb5500cfK.jpg_200x200q90.jpg",
        "price": 2472.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5862473609.html",
        "sold": 12
    },
    {
        "product_name": "ตู้เก็บของแบบตั้งสำหรับเครื่องซักผ้า ชั้นวางของสำหรับห้องน้ำ ชั้นวางของสำหรับกระดานล้างจาน ตู้เก็บของสำหรับบ้านแบบตั้งได้ ชั้นวางของสำหรับท่อระบายน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7a5ed8a2286944c88b3a454909c181ccT.jpg_200x200q90.jpg",
        "price": 2460,
        "remark": "https://www.lazada.co.th/products/pdp-i5996923656.html",
        "sold": 1
    },
    {
        "product_name": "JIAWENHUA | ที่นั่งอาบน้ำแบบพับเก็บได้ติดผนัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdbe21468f58a4a33a8764b6982da0f99Y.jpg_200x200q90.jpg",
        "price": 2455.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5910853982.html",
        "sold": 0
    },
    {
        "product_name": "JIAWENHUA | ราวจับห้องน้ำสำหรับผู้สูงอายุ ปลอดภัย ป้องกันการลื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S38be05a68d7a4061b77460815c9fd5ddV.jpg_200x200q90.jpg",
        "price": 2454.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5910836490.html",
        "sold": 181
    },
    {
        "product_name": "WUBUWEI | ชั้นวางของติดผนังหลายชั้น บางมาก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa7d0370d070046d282dfee37e3869d6fV.jpg_200x200q90.jpg",
        "price": 2375.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16062245698.html",
        "sold": 0
    },
    {
        "product_name": "JUNSHEN | ชั้นวางของในห้องน้ำสไตล์คลาสสิก ติดตั้งง่าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S94b3828f97114ef0bdfc20e6cc0338d49.jpg_200x200q90.jpg",
        "price": 2351.5,
        "remark": "https://www.lazada.co.th/products/pdp-i6003454223.html",
        "sold": 0
    },
    {
        "product_name": "ชั้นเก็บของเครื่องซักผ้าแบบเลื่อนวางบนห้องน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sebffce0f2c0643db8f519deba8868a52n.jpg_200x200q90.jpg",
        "price": 2346,
        "remark": "https://www.lazada.co.th/products/pdp-i5996901815.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องกรองน้ำบาดาล น้ำมีหินปูน กระบอกกรองน้ำใช้ 10”เกลียวทองเหลือง ฟรีกรองดักตะกอน ช่วยกรองหินปูน น้ำบ่อ น้ำกระด้าง คราบขาวตามกาะสุขภัณฑ์ คราบขาวพื้นห้องน้ำ ท่อ 6 หุน (3/4\") ไม่ต้องใช้ไฟ ติดตั้งง่าย",
        "product_image": "https://img.lazcdn.com/g/p/c9ef839c0462477bef65a2ab3fffaa16.png_200x200q90.png",
        "price": 2265.74,
        "remark": "https://www.lazada.co.th/products/pdp-i3390447458.html",
        "sold": 19
    },
    {
        "product_name": "Midas ผ้าขนหนู Cotton 100% รุ่น Basic Living ขนาดผ้าเช็ดผม 15x30 นิ้ว (12 ผืน) นุ่มนวล ผ่อนคลายผิวสัมผัส ส่งฟรี",
        "product_image": "https://img.lazcdn.com/g/p/9bf838a3b74b1f6c0d2e03d61ba9ac0d.jpg_200x200q90.jpg",
        "price": 2256,
        "remark": "https://www.lazada.co.th/products/pdp-i16087932595.html",
        "sold": 0
    },
    {
        "product_name": "MULUOZI | ชั้นเก็บของในห้องน้ำแบบหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf670bf5dfed54299bbc271604761cdd8b.png_200x200q90.png",
        "price": 2255.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16099808600.html",
        "sold": 0
    },
    {
        "product_name": "ERMO | ที่แขวนผ้าขนหนูดูดสูญญากาศระดับไฮเอนด์ ไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9ac386a687f14d20a121c2b2807e79022.jpg_200x200q90.jpg",
        "price": 2205.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16103229463.html",
        "sold": 2
    },
    {
        "product_name": "อ่างล้างหน้าพลาสติกขนาดเล็กแบบติดผนังไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S11447dd092a140a3b9ef28f343f6ff84p.jpg_200x200q90.jpg",
        "price": 2141.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16116385113.html",
        "sold": 0
    },
    {
        "product_name": "WATERTIME | แว่นว่ายน้ำกันฝ้า กันน้ำ พร้อมไดออปเตอร์ HD",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S52cd0d198459445aa454778def2b8b77E.jpg_200x200q90.jpg",
        "price": 2136.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5894953484.html",
        "sold": 89
    },
    {
        "product_name": "DANBIYIN | ชั้นเก็บของห้องน้ำหรูหราติดผนัง แผ่นหิน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6de66831826d40adb540c9ffcd2de351e.jpg_200x200q90.jpg",
        "price": 2128.58,
        "remark": "https://www.lazada.co.th/products/pdp-i16060436369.html",
        "sold": 0
    },
    {
        "product_name": "B&W |ชั้นวางของสแตนเลส 304 สำหรับมุมห้องน้ำและข้างโถชักโครก แบบตั้งพื้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3ab70cad3f514482b6ef0e86434ee3a0P.jpg_200x200q90.jpg",
        "price": 2127.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5879811626.html",
        "sold": 2
    },
    {
        "product_name": "และผู้ป่วย ใช้งานง่าย แข็งแรงที่สุด โครงอลูมิเนียม แสตนเลส เก้าอี้นั่งถ่าย ส้วมผู้ป่วย ส้วมคนแก่ เก้าอี้ห้องน้ำ ชักโครกพกพา ทนทานทุกสภาพการใช้งาน",
        "product_image": "https://img.lazcdn.com/g/p/9d0a0379c931a5d3d8f932279b4fed5e.jpg_200x200q90.jpg",
        "price": 2098,
        "remark": "https://www.lazada.co.th/products/pdp-i5883629150.html",
        "sold": 0
    },
    {
        "product_name": "สตรีมีครรภ์ และผู้ป่วย ใช้งานง่าย แข็งแรงที่สุด โครงอลูมิเนียม แสตนเลส เก้าอี้นั่งถ่าย ส้วมผู้ป่วย ส้วมคนแก่ เก้าอี้ห้องน้ำ ทนทานทุกสภาพการใช้งาน",
        "product_image": "https://img.lazcdn.com/g/p/479b6f406d8b1f5eeb3b489d9f0dc740.jpg_200x200q90.jpg",
        "price": 2098,
        "remark": "https://www.lazada.co.th/products/pdp-i5883634138.html",
        "sold": 0
    },
    {
        "product_name": "ชั้นวางผ้าขนหนูห้องน้ำไม่ต้องเจาะ อลูมิเนียมสีดำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S54b71c3fce0c4c49b6f13ff8a2359dbcC.jpg_200x200q90.jpg",
        "price": 2071.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16060405853.html",
        "sold": 0
    },
    {
        "product_name": "MLZH | ม่านกั้นห้องหลายฟังก์ชันสำหรับบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S70589b5dce394379ad816885b84d17d9o.jpg_200x200q90.jpg",
        "price": 2064.88,
        "remark": "https://www.lazada.co.th/products/pdp-i6017986175.html",
        "sold": 3
    },
    {
        "product_name": "FANBI | โถปัสสาวะแบบเก้าอี้พกพา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S10de10e3025f4354aefbcebdb6ed5c405.jpg_200x200q90.jpg",
        "price": 2049.98,
        "remark": "https://www.lazada.co.th/products/pdp-i6018005302.html",
        "sold": 7
    },
    {
        "product_name": "กระจกห้องน้ำความละเอียดสูง ติดผนังเต็มความยาว ใช้กาวไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8aa7d79fb28b4907b8026a6ca8e5e040u.jpg_200x200q90.jpg",
        "price": 2043.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16089341169.html",
        "sold": 0
    },
    {
        "product_name": "Digital Bathroom Scale เครื่องชั่งน้ำหนักดิจิตอล มาตรฐาน Digital Body Weight Scale เครื่องชั่งน้ำหนัก ตาชั่งดิจิตอล เครื่องชั่งน้ำหนักดิจิตอล เครื่องชั่งน้ำหนักคน",
        "product_image": "https://img.lazcdn.com/g/p/27c5d605b8ea5dfec8515695981c2e89.png_200x200q90.png",
        "price": 2016.4,
        "remark": "https://www.lazada.co.th/products/pdp-i4306042424.html",
        "sold": 1
    },
    {
        "product_name": "ม่านกั้นอาบน้ำพับได้ กันน้ำ ด้านเดียวอลูมิเนียม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4d96fd45cbec42638804203584c06a4c6.jpg_200x200q90.jpg",
        "price": 2013,
        "remark": "https://www.lazada.co.th/products/pdp-i16119418484.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้นั่งถ่าย แสตนเลส ผู้สูงอายุ สุขาเคลื่อนที่ เก้าอี้ขับถ่าย แบบพับได้ สุขภัณฑ์เคลื่อนที่ ส้วมเคลือนที่ แบบปรับสูงต่ำได้5ระดับ ห้องน้ำคนท้อง 3in1 เก้าอี้อาบน้ำ Toilet Patient",
        "product_image": "https://img.lazcdn.com/g/p/a980aa1a75bbf1d2a3bde9ca7b82af72.jpg_200x200q90.jpg",
        "price": 1998,
        "remark": "https://www.lazada.co.th/products/pdp-i4285876152.html",
        "sold": 1
    },
    {
        "product_name": "พรมเช็ดเท้า พรมห้องน้ำ ใหญ่ พรมเช็ดเท้าหนา พรมเช็ดซับน้ำ 40x60ซม. สีฟ้า (1ผืน) Bath Mat Large Washable Bathroom Floor Mat Blue Color 40x60cm. (1 unit)",
        "product_image": "https://img.lazcdn.com/g/p/0704d5c8b4f1a780dcd13d0ea08d8159.jpg_200x200q90.jpg",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i4591116523.html",
        "sold": 0
    },
    {
        "product_name": "CHUMX | ตู้เก็บของกันน้ำสำหรับห้องน้ำ ครัว และห้องสุขา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sef144910268840e0ac6421319608a4e2c.jpg_200x200q90.jpg",
        "price": 1973.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5910880122.html",
        "sold": 9
    },
    {
        "product_name": "เก้าอี้สุขาแบบพกพาผู้สูงอายุหญิงตั้งครรภ์เก้าอี้อาบน้ำในห้องน้ำ (สีเทา)",
        "product_image": "https://img.lazcdn.com/g/p/f858f891ce8806eb6381efca756a8efa.jpg_200x200q90.jpg",
        "price": 1970,
        "remark": "https://www.lazada.co.th/products/pdp-i6024669181.html",
        "sold": 0
    },
    {
        "product_name": "MMZECE | ตู้เก็บของในห้องน้ำกันน้ำ ไม่ต้องติดตั้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa355d879b5c04c8bb99cda702936a098N.jpg_200x200q90.jpg",
        "price": 1924,
        "remark": "https://www.lazada.co.th/products/pdp-i6026147027.html",
        "sold": 0
    },
    {
        "product_name": "ตู้เก็บของห้องน้ำติดผนังไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd6a6f09107984e41b71b21a6694d2c6b6.jpg_200x200q90.jpg",
        "price": 1898.32,
        "remark": "https://www.lazada.co.th/products/pdp-i16099633605.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้นั่งถ่าย เก้าอี้โถมีล้อห้องน้ำผู้สูงอายุผู้ป่วยทุพพลภาพเก้าอี้เคลื่อนที่เก้าอี้อาบน้ำเก้าอี้โถสุขภัณฑ์ผู้ใหญ่โถอา",
        "product_image": "https://img.lazcdn.com/g/p/a249a77ad0958e1eac939bdf4f5af941.jpg_200x200q90.jpg",
        "price": 1890,
        "remark": "https://www.lazada.co.th/products/pdp-i5903387421.html",
        "sold": 11
    },
    {
        "product_name": "SHENGXUE | เก้าอี้อาบน้ำหมุนไม่ลื่นอลูมิเนียม",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S5d3163411bf847f7859778d99eaa3d6fb.jpg_200x200q90.jpg",
        "price": 1854.84,
        "remark": "https://www.lazada.co.th/products/pdp-i5933214019.html",
        "sold": 6
    },
    {
        "product_name": "เก้าอี้นั่งถ่ายสำหรับผู้สูงอายุ ผู้พิการ และสตรีมีครรภ์ ห้องน้ำเคลื่อนที่ และเก้าอี้อาบน้ำพับได้สำหรับครัวเรือน  เก้าอี้นั่งถ่ายสำหรับผู้พิการ ผู้สูงอายุ และสตรีมีครรภ์ ห้องน้ำเคลื่อนที่ และเก้าอี้นั่งถ่ายแบบพับได้สำหรับครัวเรือนที่เสริมความแข็งแรง",
        "product_image": "https://img.lazcdn.com/g/p/78f3000ced799f543f6ca6421140ea3c.jpg_200x200q90.jpg",
        "price": 1840,
        "remark": "https://www.lazada.co.th/products/pdp-i5851678293.html",
        "sold": 3
    },
    {
        "product_name": "หุ่นยนต์นาฬิกาติดตามคนในห้องน้ำ ของเล่นบล็อกก่อสร้าง รูปเด็กชาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S05e99e6273bb43b4b7c0007ac1d058e5u.jpg_200x200q90.jpg",
        "price": 1838,
        "remark": "https://www.lazada.co.th/products/pdp-i16089094992.html",
        "sold": 0
    },
    {
        "product_name": "SHENGXUE | เก้าอี้อาบน้ำกันลื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sddfbfa7226184747b9a7854608f48906v.jpg_200x200q90.jpg",
        "price": 1830.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5932840720.html",
        "sold": 7
    },
    {
        "product_name": "ของเล่นชุดต่อรูปยักษ์ดาราศาสตร์ไททัน ปะทะ คนห้องน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/See424cef158b4da28cd90e737b474c3cR.jpg_200x200q90.jpg",
        "price": 1794,
        "remark": "https://www.lazada.co.th/products/pdp-i16089274432.html",
        "sold": 0
    },
    {
        "product_name": "ห้องน้ำพกพาสำหรับตั้งแคมป์, ห้องน้ำเดินทางแบบพับปรับได้สำหรับตั้งแคมป์สีดำสำหรับตั้งแคมป์380lbs",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd11c12b419f94193ac95d20db19f281bu.jpg_200x200q90.jpg",
        "price": 1765.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16059777940.html",
        "sold": 0
    },
    {
        "product_name": "ตู้เก็บของแบบลิ้นชักกันน้ำ ขนาดแคบ ไม่ต้องประกอบ 18 ซม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S686b2f37c8864b8ba6c244154dcf657cY.jpg_200x200q90.jpg",
        "price": 1754,
        "remark": "https://www.lazada.co.th/products/pdp-i6026239168.html",
        "sold": 0
    },
    {
        "product_name": "ชั้นวางของในห้องน้ำมุมไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd4342e88cab24364b551d0d13db92f56x.png_200x200q90.png",
        "price": 1735.88,
        "remark": "https://www.lazada.co.th/products/pdp-i6078240380.html",
        "sold": 147
    },
    {
        "product_name": "Hosa | แว่นตากันน้ำกันฝ้าความละเอียดสูงสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S358823a310b542098e54311125988fadC.jpg_200x200q90.jpg",
        "price": 1730.66,
        "remark": "https://www.lazada.co.th/products/pdp-i16053114763.html",
        "sold": 0
    },
    {
        "product_name": "CREATE LOVE | ชุดคลุมอาบน้ำมีฮู้ด แห้งไว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S756c4863a1c24f388bbcacf5a5db84f2Q.jpg_200x200q90.jpg",
        "price": 1722.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5928076690.html",
        "sold": 18
    },
    {
        "product_name": "SHANNAIER | ชุดที่แขวนผ้าขนหนูพับได้ ไม่ต้องเจาะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S64fa090dccca4cbdbb43cd48b77ed020O.jpg_200x200q90.jpg",
        "price": 1720.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16062536568.html",
        "sold": 0
    },
    {
        "product_name": "B&W | ชั้นวางมุมห้องน้ำด้วยถ้วยดูดสุญญากาศ สแตนเลส 304",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S34a8edce3439430bb29b58acc067770bJ.jpg_200x200q90.jpg",
        "price": 1719.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5880246297.html",
        "sold": 11
    },
    {
        "product_name": "MEIKAIBIN | ชั้นวางของในห้องน้ำหลายประโยชน์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S76071046e387412f911eaf36f62e9cceQ.png_200x200q90.png",
        "price": 1703.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16054819488.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้นั่งถ่ายแบบพับได้สำหรับผู้สูงอายุ หญิงตั้งครรภ์ และผู้ป่วย ใช้ในบ้านหรือห้องน้ำ เคลื่อนย้ายได้ ใช้เป็นโถส้วมและเก้าอี้อาบน้ำได้  เก้าอี้นั่งถ่ายแบบพกพา และพับได้ สำหรับผู้สูงอายุ หญิงตั้งครรภ์ และผู้พิการ ใช้ในบ้าน แข็งแรง ทนทาน ปรับระดับได้ พร้อมฟ",
        "product_image": "https://img.lazcdn.com/g/p/3ef36bd1d6af2a93c3ead93efc4e0ea6.jpg_200x200q90.jpg",
        "price": 1684,
        "remark": "https://www.lazada.co.th/products/pdp-i5846479351.html",
        "sold": 3
    },
    {
        "product_name": "DAIWA | รอกสปินนิ่งเบาและโยนได้ไกล รุ่น Moonlight Beauty X LT ตกปลาทั้งน้ำจืดและน้ำเค็ม เน้นความเบา ลื่น และแม่นยำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa545d6bf7c6a49c0b445f031225b119ad.jpg_200x200q90.jpg",
        "price": 11491.32,
        "remark": "https://www.lazada.co.th/products/pdp-i6003246859.html",
        "sold": 4
    },
    {
        "product_name": "Ats886 เทมเพลตรอยสักไร้สายแบบพกพาสําหรับโทรศัพท์ Windows iOS และ Android",
        "product_image": "https://img.lazcdn.com/g/p/c26ae875b8c8b5d8605076ab291d61cb.jpg_200x200q90.jpg",
        "price": 5600,
        "remark": "https://www.lazada.co.th/products/pdp-i5172396080.html",
        "sold": 61
    },
    {
        "product_name": "เครื่องขัดเงา Shixin รุ่น STRONG209K เครื่องขัดเงาสำหรับงานทำเล็บ งานทันตกรรม และงานเครื่องประดับ เครื่องแกะสลักไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/See28d895752e403eb6abb2f7440dab7cO.jpg_200x200q90.jpg",
        "price": 4615.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5994098856.html",
        "sold": 0
    },
    {
        "product_name": "Florasis | ชุดแปรงแต่งหน้าเต็มเซ็ต สำหรับปัดแก้มและคอนทัวร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc56baf67fe744ea2a40add7f3b5f9811t.jpg_200x200q90.jpg",
        "price": 3360,
        "remark": "https://www.lazada.co.th/products/pdp-i6006056026.html",
        "sold": 0
    },
    {
        "product_name": "ชุดเครื่องมือ PMU ไร้สายระดับมืออาชีพ - ไมโครแชดดิ้งสำหรับคิ้ว อายไลเนอร์ ริมฝีปาก แต่งหน้าถาวรหรือเข็มสัก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdc42c8ff5a474bccb811d959be946ad4Y.jpg_200x200q90.jpg",
        "price": 3291.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5993221173.html",
        "sold": 0
    },
    {
        "product_name": "LIWAN | กระจกแต่งหน้าหมุนบนโต๊ะ HD",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S292b18e8039c4a3a9472aeb73ffd860fy.png_200x200q90.png",
        "price": 3031.64,
        "remark": "https://www.lazada.co.th/products/pdp-i6017917560.html",
        "sold": 1
    },
    {
        "product_name": "50-1000PCS ฟองน้ําใบหน้าบีบอัด Strong ดูดซับแผ่นทําความสะอาด Latex ฟรี Exfoliating แต่งหน้าฟองน้ํา Skin Care ฟองน้ํา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb0540bf354464796ac971bdc98ac00577.jpg_200x200q90.jpg",
        "price": 2896.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5889906664.html",
        "sold": 0
    },
    {
        "product_name": "SHANNAIER | กระจกติดผนังพร้อมไฟทันสมัย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sed764a3d46bb449a81f55ed4f2e66f11H.jpg_200x200q90.jpg",
        "price": 2862.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16060428493.html",
        "sold": 0
    },
    {
        "product_name": "MSQ | ชุดแปรงแต่งหน้ามืออาชีพสำหรับอายแชโดว์ ฟาวเดชัน บลัช และแป้ง ขนสัตว์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se3972625539846f7ab869b3414a76318E.jpg_200x200q90.jpg",
        "price": 2608.58,
        "remark": "https://www.lazada.co.th/products/pdp-i5859925313.html",
        "sold": 121
    },
    {
        "product_name": "กระจกตัดผม 3 ด้าน พร้อมไฟ LED สว่าง พกพาสะดวก มุมมอง 360 องศา กระจกแต่งหน้าแบบพับได้ 3 ตอน สำหรับแต่งหน้าและจัดแต่งทรงผมที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se46a54611e1a4c4a8f93639160cc34401.jpg_200x200q90.jpg",
        "price": 2146.24,
        "remark": "https://www.lazada.co.th/products/pdp-i5984644464.html",
        "sold": 0
    },
    {
        "product_name": "FWTDF | กระจกแต่งหน้า LED ขนาดใหญ่สำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S84c4b3c0a22c4d95962efbea5ad7490e1.jpg_200x200q90.jpg",
        "price": 2071.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16049185539.html",
        "sold": 0
    },
    {
        "product_name": "กระจกแต่งหน้า 10 เท่า ขยายภาพ 3 สี กระจกโต๊ะเครื่องแป้งแบบชาร์จไฟได้ ปรับความสูงได้ กระจกสองด้านสำหรับเครื่องสำอาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0a7096f8f9de471f890cb23b609dab81A.jpg_200x200q90.jpg",
        "price": 1842.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16099532558.html",
        "sold": 0
    },
    {
        "product_name": "BEAUTYBLENDER Original Beautyblender",
        "product_image": "https://img.lazcdn.com/g/p/f96184364f828cd0934116d7a95ffa9c.jpg_200x200q90.jpg",
        "price": 1790,
        "remark": "https://www.lazada.co.th/products/pdp-i4769069647.html",
        "sold": 77
    },
    {
        "product_name": "scbrush เซตแปรงโอวัลติน แปรงแต่งหน้ามืออาชีพ แปรงแต่งหน้า7ชิ้น",
        "product_image": "https://img.lazcdn.com/g/p/a6bfb33994e35a00e40b82eb44c547a9.jpg_200x200q90.jpg",
        "price": 1728,
        "remark": "https://www.lazada.co.th/products/pdp-i5828195507.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องมือความงามอัลตราโซนิก  นวดหน้าเพื่อความงาม  ความถี่สูงอัลตราโซนิก  เครื่องความงามต่อต้านริ้วรอย",
        "product_image": "https://img.lazcdn.com/g/p/d104e64d72051467a2fa170f78228b77.png_200x200q90.png",
        "price": 1577.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5168180112.html",
        "sold": 0
    },
    {
        "product_name": "HANJIUGONG | กระจกแต่งหน้าพร้อมไฟขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2470bb41d79c4a94ac5cf0155c4e408af.jpg_200x200q90.jpg",
        "price": 1570.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16049332089.html",
        "sold": 0
    },
    {
        "product_name": "QINZHI | ชุดแปรงแต่งตา พร้อมแปรงเบลนด์, เฉดดิ้ง, อายแชโดว์ และแปรงรายละเอียด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa00ec519f94747dca8d6c3ff969b9340s.jpg_200x200q90.jpg",
        "price": 1541.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5875539225.html",
        "sold": 15
    },
    {
        "product_name": "REVITALASH LASH & BROW STYLER 3 IN 1 GROOMING TOOL",
        "product_image": "https://img.lazcdn.com/g/p/e53d4b50d622e426a3427a5d20fe0aca.png_200x200q90.png",
        "price": 1520,
        "remark": "https://www.lazada.co.th/products/pdp-i6071225043.html",
        "sold": 1
    },
    {
        "product_name": "MUID | กระจกแต่งหน้าพกพา LED พร้อมกล่องเก็บของ ของขวัญ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbd9323f8e4d9489db5fa52d6c9059a64t.jpg_200x200q90.jpg",
        "price": 1284.04,
        "remark": "https://www.lazada.co.th/products/pdp-i5874224165.html",
        "sold": 9
    },
    {
        "product_name": "Tom Ford กระจกพกพา Compact Mirror (ของแท้จากช้อป)",
        "product_image": "https://img.lazcdn.com/g/p/28aa00f84ec77dc737def7f9577bce91.jpg_200x200q90.jpg",
        "price": 1180,
        "remark": "https://www.lazada.co.th/products/pdp-i16057868113.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องตัดเล็บไฟฟ้าแบบชาร์จ USB เงียบ พร้อมไฟ LED สำหรับเพื่อน นักเรียน ผู้ใหญ่ ผู้ชาย ผู้หญิง ใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S14fa94d86c214666bdfa124be99a807fz.jpg_200x200q90.jpg",
        "price": 1173.18,
        "remark": "https://www.lazada.co.th/products/pdp-i16096242106.html",
        "sold": 0
    },
    {
        "product_name": "Real Techniques | ชุดแปรงแต่งหน้าใยสังเคราะห์สำหรับผู้เริ่มต้นแต่งหน้า อุปกรณ์ชุดแปรงแต่งตาและแต่งหน้า",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbd8e6450d5c04cc594621f562560b4beX.jpg_200x200q90.jpg",
        "price": 1131.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5893741912.html",
        "sold": 206
    },
    {
        "product_name": "กระเป๋าเก็บยาทาเล็บขนาดใหญ่ พกพาสะดวก สำหรับเดินทาง ทำเล็บมืออาชีพ กระเป๋าโพลีเอสเตอร์อเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd39e309e261e46dcb0441fe0785e2e5fv.jpg_200x200q90.jpg",
        "price": 1123.72,
        "remark": "https://www.lazada.co.th/products/pdp-i16080232765.html",
        "sold": 0
    },
    {
        "product_name": "MSQ | ชุดแปรงแต่งหน้า 11 ชิ้น สำหรับอายแชโดว์ บลัช คอนซีลเลอร์ และคอนทัวร์จมูก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se39558eec2ac4331be945a6a8e876034K.jpg_200x200q90.jpg",
        "price": 1059.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5877028914.html",
        "sold": 74
    },
    {
        "product_name": "เครื่องตัดขนหู จมูก และคิ้วหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf0685475525145bba4d61c56c20d2a2cn.jpg_200x200q90.jpg",
        "price": 1047.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16083604323.html",
        "sold": 2
    },
    {
        "product_name": "QINZHI | ชุดแปรงแต่งตาสำหรับเบลนด์และแชโดว์ ขนสัตว์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa3c8aaa6e5e34974a560b29836c542e0m.jpg_200x200q90.jpg",
        "price": 1032.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5877059332.html",
        "sold": 76
    },
    {
        "product_name": "4-IN-1 แบบพกพาความถี่สูงเครื่องความงามบนใบหน้าอิเล็กโทรดแสงสีม่วงแก้วหลอดแท่งสิวนวดหน้าสปาการดูแลผิว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S620d2feae0a0442c8a085b4a7f8990e0g.jpg_200x200q90.jpg",
        "price": 1015.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5939157187.html",
        "sold": 0
    },
    {
        "product_name": "Kate Spade New York กระเป๋าสะพายข้างรุ่น Tilly Quilted Small Crossbody KL640 001 สี Black",
        "product_image": "https://img.lazcdn.com/g/p/ac154f5ce1942724fa0f41ff96fc07f9.jpg_200x200q90.jpg",
        "price": 10500,
        "remark": "https://www.lazada.co.th/products/pdp-i5912459765.html",
        "sold": 0
    },
    {
        "product_name": "Kate Spade New York กระเป๋าสะพายข้างรุ่น Tilly Quilted Small Crossbody KL640 250 สี City Scape",
        "product_image": "https://img.lazcdn.com/g/p/5d91d0f5f001b55c13ab65517ceec772.jpg_200x200q90.jpg",
        "price": 10500,
        "remark": "https://www.lazada.co.th/products/pdp-i5912479621.html",
        "sold": 0
    },
    {
        "product_name": "MUVA | กระเป๋ารุ่น BOHO EDIT PATCH",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5d6179c3112541cb8eadea7d6663a816o.jpg_200x200q90.jpg",
        "price": 6746.62,
        "remark": "https://www.lazada.co.th/products/pdp-i6001920304.html",
        "sold": 16
    },
    {
        "product_name": "8angels - รุ่น Soda Cargo กระเป๋าสะพายข้างผู้หญิง ขนาด12.5นิ้ว (ปรับสาย-สั้นยาวได้)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S836fcaeb53684d41b918ba591d4d85f3m.jpg_200x200q90.jpg",
        "price": 1500,
        "remark": "https://www.lazada.co.th/products/pdp-i5837614333.html",
        "sold": 2
    },
    {
        "product_name": "Real Techniques | ชุดแปรงแต่งหน้าสำหรับบลัช, เซ็ตติ้ง, เชดโดว์, และคอนทัวร์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S02909c061e734b2c9ddf1dccfb435af1t.jpg_200x200q90.jpg",
        "price": 1436.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5893781251.html",
        "sold": 38
    },
    {
        "product_name": "น้ำหอม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9424338ee4da4aee8c2b1e8c55b20d67e.jpg_200x200q90.jpg",
        "price": 30000,
        "remark": "https://www.lazada.co.th/products/pdp-i16095064444.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมกลิ่นมู่หลานไม่จำเพาะเพศ 45 มล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf139c6ccdca84548be5b5dc5ed449926f.jpg_200x200q90.jpg",
        "price": 23718.08,
        "remark": "https://www.lazada.co.th/products/pdp-i6031757106.html",
        "sold": 0
    },
    {
        "product_name": "LANCOME ABSOLUE LES PARFUM 6 AM ROSE 100ML",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S02224a575c8647c9a2f797872de4a04ae.jpg_200x200q90.jpg",
        "price": 22600,
        "remark": "https://www.lazada.co.th/products/pdp-i5768034004.html",
        "sold": 8
    },
    {
        "product_name": "รวมน้ำหอม เ..กอแ..ลง ข..องแ..ท้ * กล่องซีล *",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8fa6e290d1784282a10eccc268a9640do.jpg_200x200q90.jpg",
        "price": 18780,
        "remark": "https://www.lazada.co.th/products/pdp-i6075242264.html",
        "sold": 0
    },
    {
        "product_name": "รวมน้ำหอม หลุ.ย LV สเตลล่า ซิมโฟนี่ เมเทโอเร่ แ.ท้ 100 ml. *กล่องซีล*",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd0c67b5e0ea14915ac47d8c0b690626fJ.jpg_200x200q90.jpg",
        "price": 17380,
        "remark": "https://www.lazada.co.th/products/pdp-i16059226018.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมสำหรับรถเพื่อเป็นของขวัญ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S685e55cd874c48a284c5f76f4afa798eO.jpg_200x200q90.jpg",
        "price": 17082.32,
        "remark": "https://www.lazada.co.th/products/pdp-i16050723328.html",
        "sold": 64
    },
    {
        "product_name": "New! LANCOME IDOLE POWER​ EAU DE PARFUM INTENSE 100ML​ น้ำหอมลังโคม ฉีกกรอบเดิมๆ ด้วยความเข้มข้นใหม่ ขนาด 100 มล. (Perfume น้ำหอมผู้หญิง)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S458775e9041c4557b62a3efa9764add7E.jpg_200x200q90.jpg",
        "price": 15000,
        "remark": "https://www.lazada.co.th/products/pdp-i5589690153.html",
        "sold": 163
    },
    {
        "product_name": "น้ำหอมผู้หญิงcome Miracle EDP 100ml(แท้💯%)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0e84a2cfae1547119d83a1c01ba26154h.jpg_200x200q90.jpg",
        "price": 14800,
        "remark": "https://www.lazada.co.th/products/pdp-i5923113076.html",
        "sold": 0
    },
    {
        "product_name": "TOM FORD BEAUTY CAFE ROSE SIGNATURE EAU DE PARFUM - ทอม ฟอร์ด บิวตี้ น้ำหอม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd0e327e98aa043f085653db24cac1e38j.jpg_200x200q90.jpg",
        "price": 14300,
        "remark": "https://www.lazada.co.th/products/pdp-i5162771666.html",
        "sold": 11
    },
    {
        "product_name": "[สลักชื่อได้ไม่เกิน 3 ตัวอักษร] น้ำหอมผู้หญิง Chloé Iconic Signature Eau De Parfum | Lychee, Damasce Rose, Amber | A Powdery Honeyed Rose Perfume 100ML",
        "product_image": "https://img.lazcdn.com/g/p/848c9eac3802c86ae099057c684ebcd7.jpg_200x200q90.jpg",
        "price": 14060,
        "remark": "https://www.lazada.co.th/products/pdp-i5183998104.html",
        "sold": 17
    },
    {
        "product_name": "[สลักชื่อได้ไม่เกิน 3 ตัวอักษร] น้ำหอมผู้หญิง Chloé Iconic Signature Eau De Parfum | Lychee, Damasce Rose, Amber | A Powdery Honeyed Rose Perfume 75ML",
        "product_image": "https://img.lazcdn.com/g/p/2c3369a56ab47875dbc1667e74c1d2be.jpg_200x200q90.jpg",
        "price": 12540,
        "remark": "https://www.lazada.co.th/products/pdp-i5183977150.html",
        "sold": 11
    },
    {
        "product_name": "น้ำหอมผู้ชายตัวใหม่ล่าสุด \n Emporio Armani Stronger With You Amber 100ml \n#ป้ายไทย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5d9331c452514dcbb496a736fccdcb68f.jpg_200x200q90.jpg",
        "price": 12000,
        "remark": "https://www.lazada.co.th/products/pdp-i16066053473.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมกลิ่นหวานละมุนหรู โทนอุ่นนุ่ม 100ml EDP",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se0e88b26e2fd4e75900c3e94b6bcc357I.jpg_200x200q90.jpg",
        "price": 11998,
        "remark": "https://www.lazada.co.th/products/pdp-i16069041762.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมกลิ่นหวานลึกโทนแดง หรูอบอุ่น 100ml EDP",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S72a17c1444cb4c2b89b7a7e50591bf9cl.jpg_200x200q90.jpg",
        "price": 11998,
        "remark": "https://www.lazada.co.th/products/pdp-i16068971941.html",
        "sold": 0
    },
    {
        "product_name": "Black Paw | น้ำหอมกลิ่นสดชื่นใช้ได้นานสำหรับทุกเพศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S77033bcf42754b8a9250c4615f399266B.jpg_200x200q90.jpg",
        "price": 11988.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5872708442.html",
        "sold": 10
    },
    {
        "product_name": "กลิ่นหอมดอกไม้รวม Valen Dreams Collection EDP 100ml 🌱ทักแชทเช็คสต๊อกก่อนนะ🌿",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9ecb563fb32b4c3d956949bf17ffc2d1F.jpg_200x200q90.jpg",
        "price": 11980,
        "remark": "https://www.lazada.co.th/products/pdp-i5863983092.html",
        "sold": 0
    },
    {
        "product_name": "New! LANCOME IDOLE POWER​ EAU DE PARFUM INTENSE 50ML​ น้ำหอมลังโคม ฉีกกรอบเดิมๆ ด้วยความเข้มข้นใหม่ ขนาด 50 มล. (Perfume น้ำหอมผู้หญิง)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3e0b4f70ac0241c28ecde13ce799faaeI.jpg_200x200q90.jpg",
        "price": 10800,
        "remark": "https://www.lazada.co.th/products/pdp-i5589646405.html",
        "sold": 67
    },
    {
        "product_name": "รวมน้ำหอม CH ช…าแ..นล ผู้หญิง ช๊าน/โค.โค่ ข..องแ..ท้ *กล่องซีล*",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf321de3a03fe444eb54398400bd34ccaY.jpg_200x200q90.jpg",
        "price": 10380,
        "remark": "https://www.lazada.co.th/products/pdp-i16059057878.html",
        "sold": 0
    },
    {
        "product_name": "melt season | น้ำหอมทำพิเศษโทนไม้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc391a43ce5a74cf997a0dd1a5b46178ce.jpg_200x200q90.jpg",
        "price": 10288.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5894971709.html",
        "sold": 7
    },
    {
        "product_name": "น้ำหอมผู้หญิง โทนดอกไม้สะอาด นุ่มละมุน กลิ่นสุภาพ ขนาด 100 ml",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S592c33dfb50d4364830f2cfad5d5abedn.jpg_200x200q90.jpg",
        "price": 9998,
        "remark": "https://www.lazada.co.th/products/pdp-i6004490951.html",
        "sold": 0
    },
    {
        "product_name": "Miss Dior รุ่นใหม่ล่าสุด \n\nน้ำหอม Miss Dior Essence de Parfum \nสคบไทย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S215b2c30dc9945e89443eb0fa905f959U.jpg_200x200q90.jpg",
        "price": 9800,
        "remark": "https://www.lazada.co.th/products/pdp-i16074515873.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมกลิ่นหรูหราสายตะวันออก โทนหวานอุ่นเข้ม 100ml Parfum",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd62d6321c22e431fa015f780d851dadfG.jpg_200x200q90.jpg",
        "price": 9100,
        "remark": "https://www.lazada.co.th/products/pdp-i16069226499.html",
        "sold": 0
    },
    {
        "product_name": "[ แพค 12 ชิ้นสุดคุ้ม ] BSC NOOK MUSK OIL ขนาด 10 ML. น้ำหอมนุค กลิ่นหอม ติดทนนาน น้ำหอม #น้ำหอมติดทน  #น้ำหอมผู้ชาย  #น้ำหอมผู้หญิง #น้ำหอม",
        "product_image": "https://img.lazcdn.com/g/p/44c90b9a10afe75bd00e9eea3e332a7e.jpg_200x200q90.jpg",
        "price": 8908.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5052520935.html",
        "sold": 0
    },
    {
        "product_name": "VERSACE - Pour Homme Dylan Blue SPR24 EDT เวอร์ซาเช่ ชุดน้ำหอมชาย",
        "product_image": "https://img.lazcdn.com/g/p/dccee1263b726b45b7757fc6cae6dabc.jpg_200x200q90.jpg",
        "price": 8640,
        "remark": "https://www.lazada.co.th/products/pdp-i5252667328.html",
        "sold": 2
    },
    {
        "product_name": "น้ำหอมผู้หญิง โทนหวานนุ่ม หอมละมุน ใช้งานได้ทุกวัน ขวดสวยหรู EDP 100ML",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7dfc773437c04bc2be1d7a033d3fcfc7o.jpg_200x200q90.jpg",
        "price": 8300,
        "remark": "https://www.lazada.co.th/products/pdp-i16122313188.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมผู้หญิง กลิ่นเบอร์รี่หวานละมุน หอมสดใส ขวดลายดาว สไตล์หรู",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S34078d10bbc84fd6b3ff95f7e673bbdf0.jpg_200x200q90.jpg",
        "price": 7998,
        "remark": "https://www.lazada.co.th/products/pdp-i16122061832.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมผู้หญิง กลิ่นหวานสดใส โทนผลไม้ฟลอรัล 125ml EDP",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbd71faa4d64f47cabf1fd94cab1c894bQ.jpg_200x200q90.jpg",
        "price": 7998,
        "remark": "https://www.lazada.co.th/products/pdp-i16074775954.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมแท้💯กล่องซีล Glossier You Fleur Duo 50 ml + 8 ml",
        "product_image": "https://img.lazcdn.com/g/p/e34aab359c16132124767118b5e0f984.jpg_200x200q90.jpg",
        "price": 7980,
        "remark": "https://www.lazada.co.th/products/pdp-i16044031213.html",
        "sold": 0
    },
    {
        "product_name": "DAILY LAB | น้ำหอมปรับอากาศในรถพร้อมป้องกันหนัง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbda9423a53594e87aff5573180deb40du.jpg_200x200q90.jpg",
        "price": 7371.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16084653319.html",
        "sold": 0
    },
    {
        "product_name": "##[ลดเหลือ 1,634.- Code PR2SFRU] Jo Malone English Pear & Freesia Cologne 30ml น้ำหอม แนวกลิ่นสดชื่น##",
        "product_image": "https://img.lazcdn.com/g/p/37e67b45098285bdd5cba0b00b39a917.jpg_200x200q90.jpg",
        "price": 7365.84,
        "remark": "https://www.lazada.co.th/products/pdp-i6063487155.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมผู้หญิง กลิ่นหวานละมุน ติดทน ลุคผู้ดี ขวดริบบิ้นแดง ลิมิเตด 90ml",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5a02193e274441e9a359ef5b3e0a5dbah.jpg_200x200q90.jpg",
        "price": 7198,
        "remark": "https://www.lazada.co.th/products/pdp-i16111936958.html",
        "sold": 0
    },
    {
        "product_name": "รวมน้ำหอม CH ช…าแ..นล ช๊าน/โค.โค่ ข..องแ..ท้ *กล่องซีล*",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0f047765dfc842be9c82aa9c563a56d7n.jpg_200x200q90.jpg",
        "price": 7180,
        "remark": "https://www.lazada.co.th/products/pdp-i16044174642.html",
        "sold": 0
    },
    {
        "product_name": "ใหม่! LANCOME IDOLE PEACH'N ROSES EDP 100ML น้ำหอมลังโคม กลิ่นโทนฟรุตตี้ฟลอรัลหวานฉ่ำ พร้อมยกระดับความหวานซ่อนเปรี้ยวของพีชให้โดดเด่นยิ่งขึ้นด้วยกลิ่นหอมนุ่มนวลทว่าทรงพลังจากกลีบกุหลาบ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S05c676c6f65a4628af5457e72d732b24i.jpg_200x200q90.jpg",
        "price": 15000,
        "remark": "https://www.lazada.co.th/products/pdp-i6039076358.html",
        "sold": 39
    },
    {
        "product_name": "Jo Malone London - Cologne 100ml • Perfume โจ มาโลน ลอนดอน น้ำหอม",
        "product_image": "https://img.lazcdn.com/g/p/5d3b1885e33dee974c53796cb7b6353d.jpg_200x200q90.jpg",
        "price": 12800,
        "remark": "https://www.lazada.co.th/products/pdp-i2690274935.html",
        "sold": 992
    },
    {
        "product_name": "Coco Mademoiselle Eau De Parfum ชาแนล น้ำหอม กลิ่นดอกไม้ Amber Floral น้ำหอมแท้กลิ่นหรูหรา",
        "product_image": "https://img.lazcdn.com/g/p/aef99963afde7b2fbcf71b67aaf26cb1.jpg_200x200q90.jpg",
        "price": 8944,
        "remark": "https://www.lazada.co.th/products/pdp-i4112232541.html",
        "sold": 186
    },
    {
        "product_name": "YSL Y EDP น้ำหอมวายเอสแอลสำหรับผู้ชาย [60ml/100ml] (ของแท้ 100%)",
        "product_image": "https://img.lazcdn.com/g/p/3de79d87675e193ba46a86d7bb9297c7.jpg_200x200q90.jpg",
        "price": 7420,
        "remark": "https://www.lazada.co.th/products/pdp-i5758534759.html",
        "sold": 265
    },
    {
        "product_name": "YSL MYSLF EDP [60ml/100ml] น้ำหอมผู้ชายแนวใหม่ กลิ่นวูดดี้ฟลอรัล (ของแท้ 100%)",
        "product_image": "https://img.lazcdn.com/g/p/1353009eab186abebaf8a090d8856fdb.jpg_200x200q90.jpg",
        "price": 7260,
        "remark": "https://www.lazada.co.th/products/pdp-i5134365707.html",
        "sold": 151
    },
    {
        "product_name": "เป็นทางการ Maison Margiela  Never Ending Summer/Autumn Vibes 100ML Eau De Toilette",
        "product_image": "https://img.lazcdn.com/g/p/b404ca44354498a5e65e39995f864ae2.jpg_200x200q90.jpg",
        "price": 6910,
        "remark": "https://www.lazada.co.th/products/pdp-i16116969640.html",
        "sold": 7
    },
    {
        "product_name": "อย่างเป็นทางการ Jo Malone London Pear English Wild Bluebell Wood Sage & Sea Salt 100ML กลิ่นหอมยาวนาน Eau De Parfum",
        "product_image": "https://img.lazcdn.com/g/p/3c48df20abceef4ca9d962708e0d53a9.jpg_200x200q90.jpg",
        "price": 6811.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5511814978.html",
        "sold": 125
    },
    {
        "product_name": "Rêve Enchanté Eau De Parfum 100 ml. ( กล่องซีล สคบ.ไทย )",
        "product_image": "https://img.lazcdn.com/g/p/aece57fc95cf8afa148c87a2ef1337c4.jpg_200x200q90.jpg",
        "price": 6759.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6008541748.html",
        "sold": 0
    },
    {
        "product_name": "BURBERRY - Her EDP [ของแท้100%]",
        "product_image": "https://img.lazcdn.com/g/p/a89edf0acd62002d25065feff9a472c6.jpg_200x200q90.jpg",
        "price": 6588,
        "remark": "https://www.lazada.co.th/products/pdp-i3457340599.html",
        "sold": 971
    },
    {
        "product_name": "New! LANCOME IDOLE POWER​ EAU DE PARFUM INTENSE 25ML​ น้ำหอมลังโคม ฉีกกรอบเดิมๆ ด้วยความเข้มข้นใหม่ ขนาด 25 มล. (Perfume น้ำหอมผู้หญิง)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S286dba32000744458bca4360f9c88831h.jpg_200x200q90.jpg",
        "price": 6500,
        "remark": "https://www.lazada.co.th/products/pdp-i5570016327.html",
        "sold": 113
    },
    {
        "product_name": "อย่างเป็นทางการ Hermes Twilly / Tutti / Eau Poivree 85ML กลิ่นหอมยาวนาน Eau De Parfum",
        "product_image": "https://img.lazcdn.com/g/p/a55197f669caa33919b3ec86b58dc04f.jpg_200x200q90.jpg",
        "price": 6400,
        "remark": "https://www.lazada.co.th/products/pdp-i16123408375.html",
        "sold": 7
    },
    {
        "product_name": "Ysl Libre Eau De Parfum  น้ำหอม กลิ่นดอกไม้ วานิลลา",
        "product_image": "https://img.lazcdn.com/g/p/9efbb6f7229768e037f3d52f73cd0176.png_200x200q90.png",
        "price": 6364,
        "remark": "https://www.lazada.co.th/products/pdp-i2770652247.html",
        "sold": 184
    },
    {
        "product_name": "น้ำหอมปรับอากาศในรถ กลิ่นหอมยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6101d0c56e424617b63af1693e3579aeT.jpg_200x200q90.jpg",
        "price": 6335.06,
        "remark": "https://www.lazada.co.th/products/pdp-i6016638066.html",
        "sold": 5
    },
    {
        "product_name": "อย่างเป็นทางการ Maison Margiela Never Ending Summer / Sailing Day / Autumn Vibes 100ML กลิ่นหอมยาวนาน Eau De Toilette",
        "product_image": "https://img.lazcdn.com/g/p/0ce33a6a566755c13620e8ee8ac2fa9b.jpg_200x200q90.jpg",
        "price": 6280,
        "remark": "https://www.lazada.co.th/products/pdp-i16123496196.html",
        "sold": 7
    },
    {
        "product_name": "Authentic Matiere Premiere Cologne Cedrat / Neroli Oranger / Parisian Musc 100ML น้ำหอมผู้ชาย Eau De Parfum",
        "product_image": "https://img.lazcdn.com/g/p/3f15dc24bbf3815019bd6062cbd028af.jpg_200x200q90.jpg",
        "price": 6214.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5989274350.html",
        "sold": 21
    },
    {
        "product_name": "Jo Malone London - Cologne 30ml • Perfume โจ มาโลน ลอนดอน น้ำหอม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb61b1cbda55f4253b85eb1d9c6315136e.jpg_200x200q90.jpg",
        "price": 6200,
        "remark": "https://www.lazada.co.th/products/pdp-i2690196868.html",
        "sold": 1618
    },
    {
        "product_name": "Jo Malone London Cologne 100ml 50ml 30ml 9ml • Perfume โจ มาโลน ลอนดอน น้ำหอม • Long-lasting perfumes with scents from fresh and uplifting citrus to opulent florals and warming woods •",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3b3dc21b5b9e47d09377a90dea4e8fb00.jpg_200x200q90.jpg",
        "price": 6200,
        "remark": "https://www.lazada.co.th/products/pdp-i5803850395.html",
        "sold": 792
    },
    {
        "product_name": "NEW! Issey Miyake Le Sel EDP น้ำหอมสำหรับผู้ชาย กลิ่นสดชื่นจากท้องทะเลสู่ผืนดิน อบอุ่น ลุ่มลึก กว่าเดิม",
        "product_image": "https://img.lazcdn.com/g/p/071eeeff9510f2de9fc462cb41f5585a.png_200x200q90.png",
        "price": 6080,
        "remark": "https://www.lazada.co.th/products/pdp-i5798613268.html",
        "sold": 477
    },
    {
        "product_name": "Juicy Couture Viva La Juicy Petals Please EDP 100ml น้ำหอมสำหรับผู้หญิง จากจูซี่ กูตูร์ กลิ่นหอมฟลอรัลฟรุ๊ตตี้",
        "product_image": "https://img.lazcdn.com/g/p/93cefd101ae02bd1374429caab4471fa.jpg_200x200q90.jpg",
        "price": 5998,
        "remark": "https://www.lazada.co.th/products/pdp-i16114955173.html",
        "sold": 0
    },
    {
        "product_name": "Juicy Couture Oui Eau de Parfum 100 ml. น้ำหอมสำหรับผู้หญิง ให้ความหอมหวานสดชื่นแนวฟลอรัล-ฟรุตตี้",
        "product_image": "https://img.lazcdn.com/g/p/3c62751a6e392f11e409dceb6d1ae59e.jpg_200x200q90.jpg",
        "price": 5998,
        "remark": "https://www.lazada.co.th/products/pdp-i16118972095.html",
        "sold": 0
    },
    {
        "product_name": "Black Paw | น้ำหอมสเปรย์กลิ่นหมึกหนังสือ กลางๆ สดชื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saea4f43afd14476a82ce8b16f4fb7b4a9.jpg_200x200q90.jpg",
        "price": 5996.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5878435776.html",
        "sold": 10
    },
    {
        "product_name": "น้ำหอมรถยนต์กลิ่นสดชื่น ยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbdf79c648dd448d3bc54bfd25f4ac742Z.jpg_200x200q90.jpg",
        "price": 5878,
        "remark": "https://www.lazada.co.th/products/pdp-i16101666708.html",
        "sold": 0
    },
    {
        "product_name": "Issey Miyake Le Sel d'Issey EDT น้ำหอมสำหรับผู้ชาย กลิ่นสดชื่นจากท้องทะเลสู่ผืนดิน เพิ่มรสชาติให้แก่การใช้ชีวิต",
        "product_image": "https://img.lazcdn.com/g/p/1e95f811ec5c4b8d7fbd24106987b72d.png_200x200q90.png",
        "price": 5600,
        "remark": "https://www.lazada.co.th/products/pdp-i5291026767.html",
        "sold": 1079
    },
    {
        "product_name": "[Exclusive Set] Marc Jacobs Fragrances Daisy Ever So Fresh Eau de Parfum 30ml Set เซ็ทน้ำหอม (Daisy Ever So Fresh EDP 30ml + Daisy Ever So Fresh EDP 4ml + Daisy Drop Pouch)",
        "product_image": "https://img.lazcdn.com/g/p/aadf366c4e2a49172f75f1cfa0b2454f.jpg_200x200q90.jpg",
        "price": 5600,
        "remark": "https://www.lazada.co.th/products/pdp-i4924827860.html",
        "sold": 88
    },
    {
        "product_name": "Miss Dior Blooming Bouquet - Eau De Parfum - 100ML*100% AUTHENTIC*",
        "product_image": "https://img.lazcdn.com/g/p/9696529503358bb879fbae3a65fb9b88.jpg_200x200q90.jpg",
        "price": 5586.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5867489410.html",
        "sold": 63
    },
    {
        "product_name": "HARNN ROSE & GERANIUM EAU DE TOILETTE 45 ML น้ำหอม ขนาด 45 ML",
        "product_image": "https://img.lazcdn.com/g/p/3e61d127893818cf3f4bb643201932d6.jpg_200x200q90.jpg",
        "price": 5561.4,
        "remark": "https://www.lazada.co.th/products/pdp-i4821335656.html",
        "sold": 20
    },
    {
        "product_name": "ร้านปลอดภาษี Valentino Valentina Pink 80ML น้ำหอม Eau De Parfum",
        "product_image": "https://img.lazcdn.com/g/p/0f4031ca5d32a33a94d75cac1cf2c4d1.jpg_200x200q90.jpg",
        "price": 5560,
        "remark": "https://www.lazada.co.th/products/pdp-i16124378531.html",
        "sold": 7
    },
    {
        "product_name": "อย่างเป็นทางการ Burberry \" Hero \" 100ML กลิ่นหอมยาวนาน Eau De Parfum",
        "product_image": "https://img.lazcdn.com/g/p/c79a152e7b8b674bf225718cb40c7c28.jpg_200x200q90.jpg",
        "price": 5406,
        "remark": "https://www.lazada.co.th/products/pdp-i5530327239.html",
        "sold": 104
    },
    {
        "product_name": "CHAXIANGSHI | น้ำหอมชาดาร์จีลิ่งสดชื่นจากธรรมชาติ ยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb69f7f8913d64f6f99c40175e1f85a8fh.jpg_200x200q90.jpg",
        "price": 5329.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5927282713.html",
        "sold": 0
    },
    {
        "product_name": "[Bestseller] Narciso Rodriguez for her EDP Intense น้ำหอมสำหรับผู้หญิง ปฐมบทใหม่ของความหอมที่เข้มข้น ดึงดูด ชวนหลงใหลกว่าเดิม",
        "product_image": "https://img.lazcdn.com/g/p/235b8cfd86e5701ff885462bd596313c.jpg_200x200q90.jpg",
        "price": 5240,
        "remark": "https://www.lazada.co.th/products/pdp-i5609429445.html",
        "sold": 972
    },
    {
        "product_name": "🎁☃️🎄Victoria's Secret แบบน้ำหอม EDP Deluxe Mini Fragrance Trio / giftset  ชุดของขวัญน้ำหอม 3 กลิ่นสุด Limited ใหม่แท้ 100% อเมริกา",
        "product_image": "https://img.lazcdn.com/g/p/844965bf4db584899405df74bf0f57ee.jpg_200x200q90.jpg",
        "price": 5198,
        "remark": "https://www.lazada.co.th/products/pdp-i4042298846.html",
        "sold": 0
    },
    {
        "product_name": "Butterfly Reserve collection - Ivory wood parfum 60ml",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S32a7cc7a8778446c9380cbee09b8bb9bl.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i5115804232.html",
        "sold": 3
    },
    {
        "product_name": "Burberry My Burberry Eau de Parfum For Women 90 ml. ( Tester Box )",
        "product_image": "https://img.lazcdn.com/g/p/1975523828fc86ed1c2ee1d1524ecf2a.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i5849711048.html",
        "sold": 0
    },
    {
        "product_name": "Authentic Atelier Cologne Pomelo Paradis 100ML น้ำหอมผู้ชาย Eau De Parfum",
        "product_image": "https://img.lazcdn.com/g/p/58b64e0200c48eb4fbc218f6e2de058c.jpg_200x200q90.jpg",
        "price": 5153.72,
        "remark": "https://www.lazada.co.th/products/pdp-i5911980251.html",
        "sold": 66
    },
    {
        "product_name": "Narciso Rodriguez for her EDP น้ำหอมสำหรับผู้หญิง มีเสน่ห์เย้ายวน สง่างามน่าดึงดูดใจ",
        "product_image": "https://img.lazcdn.com/g/p/d2a1293d5eaf74c00a958fee18d91222.jpg_200x200q90.jpg",
        "price": 5120,
        "remark": "https://www.lazada.co.th/products/pdp-i2693660457.html",
        "sold": 2113
    },
    {
        "product_name": "NEW! Narciso Rodriguez EDP Radiante น้ำหอมสำหรับผู้หญิง นุ่มนวล ผ่อนคลายและอ่อนโยน",
        "product_image": "https://img.lazcdn.com/g/p/cf93f493015cede0a3fc858ff986479b.jpg_200x200q90.jpg",
        "price": 5120,
        "remark": "https://www.lazada.co.th/products/pdp-i5731191223.html",
        "sold": 159
    },
    {
        "product_name": "CARLOTTA - น้ำหอม Carlotta Perfume Value Set for Women 5 bottles",
        "product_image": "https://img.lazcdn.com/g/p/b97497d29c824006a025e1ab83823778.jpg_200x200q90.jpg",
        "price": 5116,
        "remark": "https://www.lazada.co.th/products/pdp-i5877008065.html",
        "sold": 0
    },
    {
        "product_name": "JO MALONE LONDON น้ำหอม โจมาโลน แท้ 100% ป้ายคิง กล่อง โบว์ ถุง ครบ",
        "product_image": "https://img.lazcdn.com/g/p/ea84d915f5240077b3e542f790bf0e9b.jpg_200x200q90.jpg",
        "price": 5040,
        "remark": "https://www.lazada.co.th/products/pdp-i5644716587.html",
        "sold": 2
    },
    {
        "product_name": "แท้ 100% 001 Men'S And Women'S Perfume 100ML Eau De Toilette กลิ่นหอมยาวนาน",
        "product_image": "https://img.lazcdn.com/g/p/5f4c2bf9f9bf6424910f20e06b0a925c.jpg_200x200q90.jpg",
        "price": 5024.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16084322025.html",
        "sold": 8
    },
    {
        "product_name": "Issey Miyake L'Eau D'Issey EDT น้ำหอมสำหรับผู้หญิง ให้ความหอมสดชื่นของช่อดอกไม้สีขาว สง่างาม ไร้กาลเวลา",
        "product_image": "https://img.lazcdn.com/g/p/361522326e8a825ad283cfa3d6e20c6d.png_200x200q90.png",
        "price": 5000,
        "remark": "https://www.lazada.co.th/products/pdp-i2187396386.html",
        "sold": 574
    },
    {
        "product_name": "MONTBLANC Men's 5Pc Mini Fragrance Gift Set เซ็ตน้ำหอมสำหรับผู้ชายกลิ่นหอมใหม่สุดพิเศษจากต่างประเทศรับประกันลิขสิทธิ์แท้",
        "product_image": "https://img.lazcdn.com/g/p/5d8c237e9bc1c85a6ff607666667dbf9.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i4886324783.html",
        "sold": 0
    },
    {
        "product_name": "MONTBLANC Men's 5Pc Mini Fragrance Gift Set เซ็ตน้ำหอมสำหรับผู้ชายกลิ่นหอมใหม่สุดพิเศษจากต่างประเทศรับประกันลิขสิทธิ์แท้พร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/p/5d8c237e9bc1c85a6ff607666667dbf9.jpg_200x200q90.jpg",
        "price": 4900,
        "remark": "https://www.lazada.co.th/products/pdp-i4877848094.html",
        "sold": 0
    },
    {
        "product_name": "Marc Jacobs Fragrances Daisy Eau So Fresh Eau de Toilette น้ำหอม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9b2bd88aaeac4b52a8283f8cf76eaa46X.jpg_200x200q90.jpg",
        "price": 4860,
        "remark": "https://www.lazada.co.th/products/pdp-i4374509123.html",
        "sold": 139
    },
    {
        "product_name": "MADAME FIN โปรโมชั่นน้ำหอมมาดามฟินรุ่นคลาสสิก 1 ขวด น้ำหอมใหม่ SENSUOUS 1 ขวด สินค้าของแท้100% #น้ำหอมติดทน  #น้ำหอมผู้ชาย  #น้ำหอมผู้หญิง #น้ำหอม",
        "product_image": "https://img.lazcdn.com/g/p/cce4382cdfa4fa0427082141f3e5dfcf.jpg_200x200q90.jpg",
        "price": 4844,
        "remark": "https://www.lazada.co.th/products/pdp-i5052663633.html",
        "sold": 0
    },
    {
        "product_name": "Cacharel Noa EDT 100 ml. ( TESTER BOX ) 🌸น้ำหอมหญิง🌸 โนอา โดย คาชาเรล กลิ่นนุ่มนวลสดใส ด้วยดอกไม้",
        "product_image": "https://img.lazcdn.com/g/p/8aa8b67ad5b2be01cc6b70c312392683.jpg_200x200q90.jpg",
        "price": 4798,
        "remark": "https://www.lazada.co.th/products/pdp-i16098679169.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอม แท้ 30 ml. ของใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3b02c94f14e9468983319fbb1242c6eb1.jpg_200x200q90.jpg",
        "price": 4798,
        "remark": "https://www.lazada.co.th/products/pdp-i5564542741.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมปรับอากาศในรถแบบแข็ง กลิ่นยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S71127098205d43278269fa1428db7757G.jpg_200x200q90.jpg",
        "price": 4714.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16076694305.html",
        "sold": 0
    },
    {
        "product_name": "IDOLE EDP 10ML ขนาดพกพา น้ำหอมกลิ่นดอกไม้ สดชื่น ติดทน สำหรับผู้หญิงยุคใหม่ ทีเข้มแข็ง และมีพลัง perfume",
        "product_image": "https://img.lazcdn.com/g/p/4a4d3b4fcac98d05ec6c31198314de29.jpg_200x200q90.jpg",
        "price": 4681.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16122706005.html",
        "sold": 0
    },
    {
        "product_name": "BLACK PAW | น้ำหอมกลิ่นสดชื่นสีเขียว อยู่ได้นาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9e9d27dd6a9c48ccbcd339345435fb75w.jpg_200x200q90.jpg",
        "price": 4595.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5875679906.html",
        "sold": 6
    },
    {
        "product_name": "BLACK PAW | น้ำหอม Black Claw กลิ่นชาเขียวหอมสะอาด",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Sfe9915635a0142cea62be622a483eba5i.png_200x200q90.png",
        "price": 4581.06,
        "remark": "https://www.lazada.co.th/products/pdp-i5872215651.html",
        "sold": 22
    },
    {
        "product_name": "น้ำหอมสำหรับผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb2ed7cb0b0a246fe8fe4be2870709e12N.jpg_200x200q90.jpg",
        "price": 4574.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16088154318.html",
        "sold": 0
    },
    {
        "product_name": "Narciso Rodriguez for her EDT น้ำหอมสำหรับผู้หญิง สง่างาม ซับซ้อน น่าหลงไหล",
        "product_image": "https://img.lazcdn.com/g/p/257f52e9f0eb1bb73f6f140e1b5df9d2.jpg_200x200q90.jpg",
        "price": 4480,
        "remark": "https://www.lazada.co.th/products/pdp-i2690801696.html",
        "sold": 728
    },
    {
        "product_name": "CHAXIANGSHI | น้ำหอมกลิ่นชารสปริง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S83e785025a5b4c9cb17db5b0e7beb748h.jpg_200x200q90.jpg",
        "price": 4470.98,
        "remark": "https://www.lazada.co.th/products/pdp-i5933098340.html",
        "sold": 16
    },
    {
        "product_name": "DAILY LAB | น้ำหอมรถยนต์ทรงเปลือกหอย ใช้ได้นาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sece2c4c51f9b4f1aae6d4b7ba9732f71u.png_200x200q90.png",
        "price": 4461.52,
        "remark": "https://www.lazada.co.th/products/pdp-i16083708848.html",
        "sold": 0
    },
    {
        "product_name": "Gallop | น้ำหอมปรับอากาศในรถที่มีกลิ่นยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb72bc1338a2044299d6688097a7198a7t.jpg_200x200q90.jpg",
        "price": 4417.06,
        "remark": "https://www.lazada.co.th/products/pdp-i5893769863.html",
        "sold": 194
    },
    {
        "product_name": "BURBERRY London for Men EDT 100 ml ( Tester Box ) น้ำหอมสำหรับชายหนุ่ม มอบกลิ่นหอมสดชื่นและนุ่มนวล เท่ห์ตามแบบฉบับหนุ่มผู้ดีอังกฤษ เรียบหรู น่าหลงใหล",
        "product_image": "https://img.lazcdn.com/g/p/9de1a9db941332aafe818c1232e2050a.jpg_200x200q90.jpg",
        "price": 4398,
        "remark": "https://www.lazada.co.th/products/pdp-i16081732740.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมผู้หญิง (แบรนด์ Enchant ของแท้ 100%) กลิ่น Winni Fred + Black Mod ปรคละกลิ่น 1 แถม 1 ขนาด 25ml ฟรุตตี้ น่ารักขี้เล่น + ฟรอรัล หรู ดูดี(น้ำหอมนำเข้าจากฝรั่งเศส)",
        "product_image": "https://img.lazcdn.com/g/p/d21d22a8d1c74cd0b5d29f5657f2cf99.jpg_200x200q90.jpg",
        "price": 4324.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16124043326.html",
        "sold": 0
    },
    {
        "product_name": "BURBERRY HERO MEN'S AND WOMEN'S EDP PERFUME / FRAGRANCE SPRAY 100ML",
        "product_image": "https://img.lazcdn.com/g/p/0d67bb6783313ae000f2ce881f50466d.jpg_200x200q90.jpg",
        "price": 4306.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5194642385.html",
        "sold": 94
    },
    {
        "product_name": "Sellion น้ำหอมกลิ่นโอเรียนเต็ลกูร์เมต์ 100 มล. น้ำหอมผู้หญิง EDP บรรจุภัณฑ์กล่องของขวัญฝรั่งเศสมีเสน่ห์",
        "product_image": "https://img.lazcdn.com/g/p/1175db96fcbd4253b57a7e45a944ead2.jpg_200x200q90.jpg",
        "price": 4262.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5844356851.html",
        "sold": 0
    },
    {
        "product_name": "ร้านปลอดภาษี Ariana Grande Thank U Next 105ML น้ำหอม Eau De Parfum",
        "product_image": "https://img.lazcdn.com/g/p/cc7dc3701f33d3dc4a3543667ab5908e.jpg_200x200q90.jpg",
        "price": 4260,
        "remark": "https://www.lazada.co.th/products/pdp-i16124168794.html",
        "sold": 7
    },
    {
        "product_name": "น้ำหอมผู้หญิง Chloé Iconic Signature Eau De Parfum | Lychee, Damasce Rose, Amber | A Powdery Honeyed Rose Perfume",
        "product_image": "https://img.lazcdn.com/g/p/dd9af5b05d8f72c4f9078ebceb25130f.jpg_200x200q90.jpg",
        "price": 4180,
        "remark": "https://www.lazada.co.th/products/pdp-i5146886720.html",
        "sold": 158
    },
    {
        "product_name": "Jimmy Choo | น้ำหอมกลิ่นอ่อน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S705ec14ef7b74f0fb6128712e777c94fY.jpg_200x200q90.jpg",
        "price": 4173.78,
        "remark": "https://www.lazada.co.th/products/pdp-i16085555269.html",
        "sold": 0
    },
    {
        "product_name": "HUALUNDESIGN  Bleu Eau De Parfum 100ml น้ำหอมผู้ชาย มอบของขวัญ",
        "product_image": "https://img.lazcdn.com/g/p/587839a96f5154bdd705b2aac8b30612.png_200x200q90.png",
        "price": 4138.62,
        "remark": "https://www.lazada.co.th/products/pdp-i6017408817.html",
        "sold": 16
    },
    {
        "product_name": "CALVIN KLEIN - CK Be EDT[ของแท้100%]",
        "product_image": "https://img.lazcdn.com/g/p/8221965670f61f2e45971db06ee91b7c.jpg_200x200q90.jpg",
        "price": 4085,
        "remark": "https://www.lazada.co.th/products/pdp-i3457297768.html",
        "sold": 1202
    },
    {
        "product_name": "✨น้ำหอมใหม่ล่าสุด! ✨ LANCOME IDÔLE Power L’Eau de Parfum intense 🌹💫 ขนาด 100ml",
        "product_image": "https://img.lazcdn.com/g/p/77df64cced492f6a6ba4f8c0bf1d43e5.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i16044758097.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอม Juicy Couture Viva La Juicy Rose Eau De Parfum ขนาด 100 ml. ของแท้ กล่องซีล",
        "product_image": "https://img.lazcdn.com/g/p/8f4ed055c376ee6081b6fafa8893a8ab.png_200x200q90.png",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i731340647.html",
        "sold": 4
    },
    {
        "product_name": "CHLOE - Signature EDP 20 ml.[ของแท้100%]",
        "product_image": "https://img.lazcdn.com/g/p/fee0c018d64a275837997779088b3c82.jpg_200x200q90.jpg",
        "price": 3960,
        "remark": "https://www.lazada.co.th/products/pdp-i782036223.html",
        "sold": 4143
    },
    {
        "product_name": "น้ำหอมกลิ่นอ่อนสำหรับผู้หญิง ใช้ได้นาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1dba60245fb246eea8ab581306d33a42T.jpg_200x200q90.jpg",
        "price": 3931.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5974542295.html",
        "sold": 0
    },
    {
        "product_name": "Moschino Toy2 EDP น้ำหอมมอสคิโนสำหรับผู้หญิง แนวกลิ่นหอมโทน Floral Aroma  (30ml/50ml/100ml) (ของแท้ 100%)",
        "product_image": "https://img.lazcdn.com/g/p/d5de8742b008984a899a2ef6aaee0f07.jpg_200x200q90.jpg",
        "price": 3930,
        "remark": "https://www.lazada.co.th/products/pdp-i3871761118.html",
        "sold": 102
    },
    {
        "product_name": "Jo Malone London - Cologne 9ml x2 • Perfume โจ มาโลน ลอนดอน น้ำหอม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se983384a1c564dfdbc43ba2d1cb55f752.jpg_200x200q90.jpg",
        "price": 3840,
        "remark": "https://www.lazada.co.th/products/pdp-i4895990362.html",
        "sold": 1807
    },
    {
        "product_name": "KVS | น้ำหอมรถยนต์กลิ่นยาวนาน 2025",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd7b904fefd614a1dae195e0db610eab5k.jpg_200x200q90.jpg",
        "price": 3789.96,
        "remark": "https://www.lazada.co.th/products/pdp-i5909512856.html",
        "sold": 0
    },
    {
        "product_name": "[DAILYPAL] TAMBURINS Leather Wear Perfume 11 ml พร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/p/653d26dfc76dddf2d5486b0bb7eb78eb.jpg_200x200q90.jpg",
        "price": 3730,
        "remark": "https://www.lazada.co.th/products/pdp-i5472690044.html",
        "sold": 1
    },
    {
        "product_name": "น้ำหอม MITH : Cozy Musk",
        "product_image": "https://img.lazcdn.com/g/p/0c371c198fe62a9793c9be6103872fa1.png_200x200q90.png",
        "price": 3718,
        "remark": "https://www.lazada.co.th/products/pdp-i5013896694.html",
        "sold": 182
    },
    {
        "product_name": "Shiseido | Dark Opium น้ำหอม Eau de Parfum",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S13fe20217a0f4bdc8a695bddd50f52d9M.jpg_200x200q90.jpg",
        "price": 3714,
        "remark": "https://www.lazada.co.th/products/pdp-i16093867600.html",
        "sold": 0
    },
    {
        "product_name": "IMSOLE | น้ำหอมเฉพาะกลุ่ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saf3c5b2e6640486ba404c458f988b8a8N.png_200x200q90.png",
        "price": 3686,
        "remark": "https://www.lazada.co.th/products/pdp-i6005883452.html",
        "sold": 0
    },
    {
        "product_name": "KVS | น้ำหอมรถยนต์หรูหรา 2025",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S54ac259886fd49a183c659d1c936892eX.jpg_200x200q90.jpg",
        "price": 3673.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5909522752.html",
        "sold": 0
    },
    {
        "product_name": "Antidotes Body Perfume 50 ML | น้ำหอมฉีดตัว Eau de Parfum 50 มล | antidotes แอนติโดทส์",
        "product_image": "https://img.lazcdn.com/g/p/65ed3be3ef434a41bcd7a50b2d3d322e.jpg_200x200q90.jpg",
        "price": 3670.92,
        "remark": "https://www.lazada.co.th/products/pdp-i5932235609.html",
        "sold": 184
    },
    {
        "product_name": "Ariana Grande Sweet Like Candy Eau de Parfum 100ml น้ำหอมอาเรียน่า กรานเด้ พิงค์ไลท์แคนดี้ ของแท้ กล่องซีล",
        "product_image": "https://img.lazcdn.com/g/p/ad4d15594d47221f7beb615223146433.jpg_200x200q90.jpg",
        "price": 3600,
        "remark": "https://www.lazada.co.th/products/pdp-i3148601098.html",
        "sold": 4
    },
    {
        "product_name": "ชุดของขวัญน้ำหอมสำหรับผู้ชาย กลิ่นไม้ ทนนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0fd5a51b36eb44feab2c87da0a2ec748H.jpg_200x200q90.jpg",
        "price": 3536,
        "remark": "https://www.lazada.co.th/products/pdp-i16120838744.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอม MITH : Love",
        "product_image": "https://img.lazcdn.com/g/p/f0c325d8032102e306ce84f2151e3476.png_200x200q90.png",
        "price": 3520.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5845910346.html",
        "sold": 24
    },
    {
        "product_name": "น้ำหอม Hawas for Men Eau De Parfum - 100ML (3.4 ออนซ์) โดย Rasasi",
        "product_image": "https://img.lazcdn.com/g/p/036eef011ad60c88d6c8ccfe4c330569.jpg_webp_200x200q90.jpg",
        "price": 3517.9,
        "remark": "https://www.lazada.co.th/products/pdp-i16145236129.html",
        "sold": 0
    },
    {
        "product_name": "รวมกลิ่น!!! ขนาด 50ml (ซื้อ2แถม1 กดซื้อ2ขวด ขวดแถมแจ้งกลิ่นตรงข้อความค่ะ)",
        "product_image": "https://img.lazcdn.com/g/p/b323215631003fd709a2db42bd9d8edc.jpg_200x200q90.jpg",
        "price": 3477.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16114040995.html",
        "sold": 0
    },
    {
        "product_name": "【Watch shop】 AMOUAGE 100ml Mens Perfume Long Lasting Eau De Parfum Woody Oriental Aromatic Scent Fresh Warm Luxury Cologne Elegant Gift",
        "product_image": "https://img.lazcdn.com/g/p/094be54daa0f9c8fc48d3e858c18d842.png_200x200q90.png",
        "price": 3452.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6025407793.html",
        "sold": 0
    },
    {
        "product_name": "CHAXIANGSHI | น้ำหอมกลิ่นชาเบาๆ ทนนานสำหรับนักเรียน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5aabf5cd6b5a412598fb72d7735c22378.jpg_200x200q90.jpg",
        "price": 3437.94,
        "remark": "https://www.lazada.co.th/products/pdp-i6031754225.html",
        "sold": 4
    },
    {
        "product_name": "น้ำหอมคุณภาพสูงปรับแต่งได้ หอมยาวนาน กลิ่นอ่อนโยน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc2a01b53f935434ea7cebf3361f256d0e.png_200x200q90.png",
        "price": 3403.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6031710422.html",
        "sold": 12
    },
    {
        "product_name": "น้ำหอมแท้ ติด ทนนาน ของแท้100% BRITNEY SPEARS MIDNIGHT FANTASY EDP 100ml. น้ำหอมผู้หญิง มอบกลิ่นหอมหวานอบอวล เย้ายวนใจ ซ่อนความเปรี้ยวซ่า ร้าน Sokorea",
        "product_image": "https://img.lazcdn.com/g/p/f208d5f7e9ceaa330417918089552569.jpg_200x200q90.jpg",
        "price": 3398,
        "remark": "https://www.lazada.co.th/products/pdp-i3456617584.html",
        "sold": 17
    },
    {
        "product_name": "IMSOLE | น้ำหอมสำหรับผู้หญิง กลิ่นสดชื่นยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/See1064b0116049bf87534b6925aca910Z.png_200x200q90.png",
        "price": 3392,
        "remark": "https://www.lazada.co.th/products/pdp-i6005975170.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอม Moschino Cheap & Chic Eau De Toilette ขนาด100 ml. ของแท้ กล่องซีล",
        "product_image": "https://img.lazcdn.com/g/p/70f7bf37bb099ed4a8d39f54507feafa.png_200x200q90.png",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i760414395.html",
        "sold": 9
    },
    {
        "product_name": "ทางคลินิก Happy EDT 100ml Fragrance for Women perfume น้ำหอมผู้หญิง กลิ่นหอมติดทนนาน หรูหรา ทันสมัย",
        "product_image": "https://img.lazcdn.com/g/p/9675d3dc7122e799ad5741dc24d63ed9.png_200x200q90.png",
        "price": 3378,
        "remark": "https://www.lazada.co.th/products/pdp-i16111830579.html",
        "sold": 0
    },
    {
        "product_name": "Lanvin Eclat D Arpege Eau de Parfum 100ml น้ำหอม ลูกม่วง ลองแวง กลิ่นดอกไม้ ติดแป้ง นิดๆ ละมุน แป้งๆ",
        "product_image": "https://img.lazcdn.com/g/p/32b96b944224fe23420f3fd1744605e3.png_200x200q90.png",
        "price": 3368,
        "remark": "https://www.lazada.co.th/products/pdp-i2618783752.html",
        "sold": 926
    },
    {
        "product_name": "KVS | น้ำหอมสำหรับรถ กลิ่นโคโลญ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0cd74559312a4d75b8ccbf70f97b88f3p.jpg_200x200q90.jpg",
        "price": 3353.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16071959627.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมกลิ่นอ่อนๆ ที่อยู่ได้นาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sad5f5578d7b742dda4653815d7e8c873R.png_200x200q90.png",
        "price": 3327.3,
        "remark": "https://www.lazada.co.th/products/pdp-i6031640677.html",
        "sold": 20
    },
    {
        "product_name": "Parfum Excel น้ำหอม สำหรับสุนัขและแมว กลิ่น FLOWER ขนาด 100 มิลลิลิตร",
        "product_image": "https://img.lazcdn.com/g/p/f464170376c553df3fe4b8da7123e052.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i4890677261.html",
        "sold": 0
    },
    {
        "product_name": "Cacharel Anais Anais L’Original EDT 100 ml กล่องซีล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8359e09aedd2446abe25794eea3a8557p.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i5336870580.html",
        "sold": 14
    },
    {
        "product_name": "Davidoff Cool Water Women Sea Rose EDT [30 ml /50ml/100ml] ดาวิดอฟ น้ำหอมสำหรับผู้หญิง (ของแท้ 100%)",
        "product_image": "https://img.lazcdn.com/g/p/4adea9a7649a6668fa73d5b6476b05b4.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i4249011392.html",
        "sold": 24
    },
    {
        "product_name": "Parfum Roali น้ำหอม สำหรับสุนัขและแมว กลิ่น CYPRESS ขนาด 100 มิลลิลิตร",
        "product_image": "https://img.lazcdn.com/g/p/abfff0674a99117f4a0828f5550e61dc.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i4890599562.html",
        "sold": 0
    },
    {
        "product_name": "Parfum Alibe น้ำหอม สำหรับสุนัขและแมว กลิ่น MYRTLE ขนาด 100 มิลลิลิตร",
        "product_image": "https://img.lazcdn.com/g/p/721eac888e6626bdaff074886fe79e4b.jpg_200x200q90.jpg",
        "price": 3300,
        "remark": "https://www.lazada.co.th/products/pdp-i4890625105.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมสำหรับผู้หญิงจากธรรมชาติ ที่มีความหอมยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3d3cdf08dd7d4e6f9e9f468ce0d64fa7Z.png_200x200q90.png",
        "price": 3226.24,
        "remark": "https://www.lazada.co.th/products/pdp-i6031678398.html",
        "sold": 0
    },
    {
        "product_name": "Blessing All | ธูปหอมไม้จันทร์และไม้สantalum สำหรับใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc386f8690ee14c8fab6812482d59152b3.jpg_200x200q90.jpg",
        "price": 3226,
        "remark": "https://www.lazada.co.th/products/pdp-i16099344408.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมราคาส่ง เปิดบิล ยกกล่อง ยกโหล",
        "product_image": "https://img.lazcdn.com/g/p/97704422e22fa4c924f935695cdd44df.jpg_200x200q90.jpg",
        "price": 3200,
        "remark": "https://www.lazada.co.th/products/pdp-i5812805066.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมปรับอากาศในรถที่มีกลิ่นยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S96daa296316243ee9281c63138fa720b3.jpg_200x200q90.jpg",
        "price": 3198.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16082245298.html",
        "sold": 0
    },
    {
        "product_name": "🔥🔥(น้ำหอม CC DOUBLE O)  น้ำหอม 365 FOR UNISEX 50Ml. หอมละมุนๆ มีความเท่ห์ๆลุยๆ ติดทนมากๆ กลิ่นคล้าย Dior Sauvage 🔥🔥",
        "product_image": "https://img.lazcdn.com/g/p/00549a6490939a407e35691eee1b7c68.png_200x200q90.png",
        "price": 3190,
        "remark": "https://www.lazada.co.th/products/pdp-i3664089534.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมรถระดับไฮเอนด์ ดีไซน์แบบเทพธิดา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S10d1d0c957f941e98840529053ceff80i.jpg_200x200q90.jpg",
        "price": 3166,
        "remark": "https://www.lazada.co.th/products/pdp-i16101748464.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมธรรมชาติจากกุหลาบบัลแกเรีย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf0eeed339f0842ac973b36877d8c3db7u.jpg_200x200q90.jpg",
        "price": 3164,
        "remark": "https://www.lazada.co.th/products/pdp-i16099123549.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมปรับอากาศรถยนต์หรูหราสร้างสรรค์ใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd6e0904edece4f1288b37e5d6bc8133dT.jpg_200x200q90.jpg",
        "price": 3106,
        "remark": "https://www.lazada.co.th/products/pdp-i16101631111.html",
        "sold": 0
    },
    {
        "product_name": "Black Paw | น้ำหอมสดชื่นยาวนานสำหรับทุกเพศ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S56b30fef65df409da38af3854dea4e1bt.jpg_200x200q90.jpg",
        "price": 3069.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5877512084.html",
        "sold": 14
    },
    {
        "product_name": "Black Paw | น้ำหอมกลิ่นชาอู่หลง สำหรับทั้งชายและหญิง ใช้ได้นาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb5e056e0ceb64210b4ea437671fea1d16.jpg_200x200q90.jpg",
        "price": 3069.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5875785086.html",
        "sold": 18
    },
    {
        "product_name": "ออยล์น้ำหอมกลิ่น FULFILL กลิ่นลูกคุณหนู หอมหวาน ละมุน หรูหรา ดูลึกลับมีเสน่ห์ ชวนค้นหา",
        "product_image": "https://img.lazcdn.com/g/p/c55af7c8edd39d5d47ed53e57d1d3981.png_200x200q90.png",
        "price": 3045.38,
        "remark": "https://www.lazada.co.th/products/pdp-i4984290916.html",
        "sold": 5
    },
    {
        "product_name": "SHANGHETANG | ธูปสมุนไพรกลิ่นธรรมชาติใช้ในร่ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4d9cb5a7ed1747139b64213292bbd8b0A.jpg_200x200q90.jpg",
        "price": 3044,
        "remark": "https://www.lazada.co.th/products/pdp-i16099237125.html",
        "sold": 0
    },
    {
        "product_name": "Yves Rocher Flowerparty Summer Eau De Toilette For Women 50 ml. ( ไม่มีกล่อง No Box )",
        "product_image": "https://img.lazcdn.com/g/p/2ae3a5f1b7ef976df2e0a68c69d4b4a5.jpg_200x200q90.jpg",
        "price": 3032.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5159915769.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมรุ่น BE กลิ่นอบอุ่น Unisex EDT 100 ml., 200 ml. PCALK",
        "product_image": "https://img.lazcdn.com/g/p/fb7cf085803cb302c9e152e030c04dfc.jpg_200x200q90.jpg",
        "price": 2998,
        "remark": "https://www.lazada.co.th/products/pdp-i5882397709.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอม FOR HIM RED EDITION INTENSE 100 มล. (3.4 FL. OZ)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S63c7485255fb48e6b14a9431c96f4785r.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i5784829050.html",
        "sold": 0
    },
    {
        "product_name": "น้ำมันหอมสำหรับบ้านไร้ควัน ยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S049ee0e9f77244cf96018c9267ea71649.jpg_200x200q90.jpg",
        "price": 2918,
        "remark": "https://www.lazada.co.th/products/pdp-i16099299021.html",
        "sold": 0
    },
    {
        "product_name": "GUCCI - Flora Gorgeous Gardenia EDP Intense กุชชี่ น้ำหอมผู้หญิง",
        "product_image": "https://img.lazcdn.com/g/p/3153bb2642b2610b35609edb72a8fb3f.jpg_200x200q90.jpg",
        "price": 2916,
        "remark": "https://www.lazada.co.th/products/pdp-i5821638499.html",
        "sold": 37
    },
    {
        "product_name": "BURBERRY - Goddess EDP Intense น้ำหอมผู้หญิง เบอร์เบอรี่ ก๊อดเดส โอ เดอ พาร์ฟูม อินเทนซ์",
        "product_image": "https://img.lazcdn.com/g/p/b8cc1a8be642570660b30447b894dfd3.jpg_200x200q90.jpg",
        "price": 2880,
        "remark": "https://www.lazada.co.th/products/pdp-i5289679869.html",
        "sold": 55
    },
    {
        "product_name": "ไม้หอมสำหรับในร่มคุณภาพดีแบบมีอายุ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S08e515fef10f42659b7e569bb7f50b68Z.jpg_200x200q90.jpg",
        "price": 2834,
        "remark": "https://www.lazada.co.th/products/pdp-i16099164918.html",
        "sold": 0
    },
    {
        "product_name": "YOUNGBEAST | น้ำหอมกลิ่นซิตรัส 50 มล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S46383c9ca8f840aeb3b0e1f93e983dfdF.png_200x200q90.png",
        "price": 2816.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16050864506.html",
        "sold": 2
    },
    {
        "product_name": "น้ำหอมผู้ชายแบบสเปรย์ 100 มล. (3.4 ออนซ์) กลิ่นหอมแบบอาหรับ ติดทนนาน กลิ่นหอมโดดเด่น ระดับพรีเมียม เหมาะสำหรับโอกาสพิเศษและใช้ในชีวิตประจำวัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8751a8978bae4aa1bd9530bdd3bf1855g.jpg_200x200q90.jpg",
        "price": 2806.72,
        "remark": "https://www.lazada.co.th/products/pdp-i5984243927.html",
        "sold": 0
    },
    {
        "product_name": "Butterfly Thai Perfume ขนาด 60 มล.",
        "product_image": "https://img.lazcdn.com/g/p/aac86392f9d2ff879ffbcdd2e7e3da2f.jpg_200x200q90.jpg",
        "price": 2790,
        "remark": "https://www.lazada.co.th/products/pdp-i3964533640.html",
        "sold": 1178
    },
    {
        "product_name": "KERASTASE Gloss Absolu - Gloss Le Parfum น้ำหอมเนรมิตผมสวย หอมล้ำลึกระดับโอตกูตูร์ ผสานสารสกัดบำรุงผมเข้มข้น เพื่อผลลัพธ์ผมสุขภาพดีชุ่มชื้นทุกเวลา 30ml",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8534e8dbc934440eaf125c16ddb6a5b7E.png_200x200q90.png",
        "price": 2780,
        "remark": "https://www.lazada.co.th/products/pdp-i5993206607.html",
        "sold": 211
    },
    {
        "product_name": "Davidoff Cool Water Sea Rose Woman Eau De Toilette น้ำหอม กลิ่นคูลวอเตอร์ โทนฟลอรัลหอมสดชื่น เย้ายวน",
        "product_image": "https://img.lazcdn.com/g/p/24bcb83bf2043654133a47bba20ead80.jpg_200x200q90.jpg",
        "price": 2774,
        "remark": "https://www.lazada.co.th/products/pdp-i5812764776.html",
        "sold": 26
    },
    {
        "product_name": "SHANGHETANG | น้ำยาฆ่าเชื้อจากสมุนไพร กลิ่นหอมสำหรับในร่ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2eed57dcd3a74688820c7d3e8d83c3d7v.jpg_200x200q90.jpg",
        "price": 2766,
        "remark": "https://www.lazada.co.th/products/pdp-i16099099734.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมผู้หญิง Omorose  1 ขวด ขนาดขวดล่ะ 25ml (หัวน้ำหอมนำเข้าจากฝรั่งเศส)",
        "product_image": "https://img.lazcdn.com/g/p/6c92f0185b2cee3d190bc57d5b18ce19.jpg_200x200q90.jpg",
        "price": 2745.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5898122970.html",
        "sold": 0
    },
    {
        "product_name": "BOSS Bottled Beyond For Him Regular 75ml - Ginger Leather EDP Perfume | by HUGO BOSS Fragrances",
        "product_image": "https://img.lazcdn.com/g/p/569a54926a9e6a156cdf0ddb596572bd.jpg_200x200q90.jpg",
        "price": 2718,
        "remark": "https://www.lazada.co.th/products/pdp-i5888075919.html",
        "sold": 11
    },
    {
        "product_name": "น้ำหอม Kaaf Pink เป็นน้ำหอมโทนหวานสดใส ดูหรูแบบผู้หญิงทันสมัย ขวดสีชมพูสดตัดกับฝาทอง ให้ความรู้สึกแพงและสะดุดตา 💖",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd8ba9bc2d1674c4fb3b5586a1abb31cfH.jpg_200x200q90.jpg",
        "price": 2698,
        "remark": "https://www.lazada.co.th/products/pdp-i16061886851.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมรถยนต์สไตล์เทพธิดาคริสตัล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S19b3a838562c4989b9995d3684f39d55g.jpg_200x200q90.jpg",
        "price": 2670,
        "remark": "https://www.lazada.co.th/products/pdp-i16101559426.html",
        "sold": 0
    },
    {
        "product_name": "น้ำยาหอมยาวนานจากธรรมชาติสำหรับใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S00c1aee6f66f426683d68ff24b6f8a77s.jpg_200x200q90.jpg",
        "price": 2662,
        "remark": "https://www.lazada.co.th/products/pdp-i16082384324.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอมไม้บรรจุขวดคุณภาพสูง สำหรับผู้หญิงและผู้ชาย กลิ่นหอมติดทนนาน น้ำหอมส่วนตัวที่เย้ายวนใจ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sddd6c2de29dc4adfbfa6ee128745e0c5U.jpg_200x200q90.jpg",
        "price": 2661.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5984434652.html",
        "sold": 0
    },
    {
        "product_name": "1. Matcha 101 (Eau De Parfum 50 ml + 5 ml) (Scent Studio)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S26497a53ab734e4b8a717cf977166ae6D.jpg_200x200q90.jpg",
        "price": 2660,
        "remark": "https://www.lazada.co.th/products/pdp-i4980257811.html",
        "sold": 431
    },
    {
        "product_name": "ลดราคา 50 % น้ำหอม ราคาถูก น้ำหอมผู้ชาย น้ำหอมปีเก่า รุ่นเก่า ตัวฮิต ตัวดัง",
        "product_image": "https://img.lazcdn.com/g/p/9c4e41e539b2118badc74dd0430069a5.jpg_200x200q90.jpg",
        "price": 2652,
        "remark": "https://www.lazada.co.th/products/pdp-i16054321078.html",
        "sold": 0
    },
    {
        "product_name": "น้ำหอม COACH มีหลายกลิ่น,มีหลายขนาดให้เลือก",
        "product_image": "https://img.lazcdn.com/g/p/5b8a99679119be6b7d11d9a996e4f83f.jpg_200x200q90.jpg",
        "price": 2649.7,
        "remark": "https://www.lazada.co.th/products/pdp-i16066013480.html",
        "sold": 0
    },
    {
        "product_name": "🔥Best Seller🔥 มัดรวม น้ำหอมZara แพคคู่สุดคุ้ม ขายดีที่สุด ✨ กลิ่นหอมมาก หอมติดทนนาน รีบไปตำเลยค่ะ แท้💯 จากShop❗️❗️",
        "product_image": "https://img.lazcdn.com/g/p/037f4cc0d78720be6092435aa2d08296.jpg_200x200q90.jpg",
        "price": 2590,
        "remark": "https://www.lazada.co.th/products/pdp-i3829878556.html",
        "sold": 0
    },
    {
        "product_name": "FOR HIM NEO GREEN EDITION EDP 100 มล. (3.38 FL. OZ)",
        "product_image": "https://img.lazcdn.com/g/ot/common/bde3d2829db44cfe83a472e4da3c954a.jpeg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i5784622287.html",
        "sold": 0
    },
    {
        "product_name": "Cerapure เซราพิวเร่ น้ำหอม (Perfume) เพอร์ฟูม บอดี้ สเปรย์ กลิ่น Beloved Blossom  ขนาด 50 ml ของแท้ พร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/p/43f6cf88ee0a71e301b2b64ef452914b.jpg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i5336697466.html",
        "sold": 13
    },
    {
        "product_name": "BLACK PAW | น้ำหอมสไตล์จีนสำหรับทุกเพศ หอมยาวนาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S339a68aa6874427aaf15399bced3d9941.png_200x200q90.png",
        "price": 2570.82,
        "remark": "https://www.lazada.co.th/products/pdp-i5878217571.html",
        "sold": 9
    },
    {
        "product_name": "Malya Perfume น้ำหอมกลิ่น Innosense 50 ML.",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbcd9c6e9f7a54debb10c4b1f51d4582fw.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i5522588660.html",
        "sold": 0
    },
    {
        "product_name": "Malya Perfume น้ำหอมกลิ่นผู้หญิง 50 ML.",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6f9015ccd9ea43e988a79cd3d00c91ea5.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i5516721649.html",
        "sold": 1
    },
    {
        "product_name": "CHUNFENGSHILI | น้ำหอมออสแมนธัส สำหรับทั้งชายและหญิง ยาวนาน สดชื่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sdff4cf7b8fc24758b5e4ca6f353901648.png_200x200q90.png",
        "price": 2556.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5844890399.html",
        "sold": 105
    },
    {
        "product_name": "TK ข้ามพรมแดน TEMU รุ่นยอดนิยม TK น้ำหอมฉีดผมและผิวกายขายดีที่สุด กลิ่นหอมติดทนนาน Perfume spray",
        "product_image": "https://img.lazcdn.com/g/p/0e02d103a45f0864278a085b3624e6ea.jpg_webp_200x200q90.jpg",
        "price": 2542.96,
        "remark": "https://www.lazada.co.th/products/pdp-i6006702985.html",
        "sold": 0
    },
    {
        "product_name": "Butterfly Thai Perfume - น้ำหอมบัตเตอร์ฟลาย ไทย เพอร์ฟูม ขนาด 60ml.",
        "product_image": "https://img.lazcdn.com/g/p/8a17884e277b5b065651bcea52ed2aff.jpg_200x200q90.jpg",
        "price": 2511,
        "remark": "https://www.lazada.co.th/products/pdp-i869112506.html",
        "sold": 3860
    },
    {
        "product_name": "น้ำหอม Paris Corner Ophidian Sweet Surrender ขนาด 100 ml ติดทน หอมนาน ของแท้100% นำเข้าจาก UAE",
        "product_image": "https://img.lazcdn.com/g/p/08d93eba48984213551a1d5e46c3caf7.jpg_200x200q90.jpg",
        "price": 2498,
        "remark": "https://www.lazada.co.th/products/pdp-i5419665076.html",
        "sold": 3
    },
    {
        "product_name": "ไม้หอมสำหรับในร่ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S794fd42b38f74219911e6235cf5cea101.jpg_200x200q90.jpg",
        "price": 2484,
        "remark": "https://www.lazada.co.th/products/pdp-i16099432049.html",
        "sold": 0
    },
    {
        "product_name": "เตียงไม้สำหรับเด็กสไตล์เจ้าหญิง สามารถเชื่อมต่อได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5dda4ce9fa4b430e9d0395ab19fb84795.jpg_200x200q90.jpg",
        "price": 50816.96,
        "remark": "https://www.lazada.co.th/products/pdp-i16091248511.html",
        "sold": 0
    },
    {
        "product_name": "IGrow | ชุดโต๊ะเรียน สำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saa9203dc43b747609405f3b73294cd60P.png_200x200q90.png",
        "price": 30855.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16097545569.html",
        "sold": 0
    },
    {
        "product_name": "เตียงหัวเบาะ+เตียงเสริมเด็ก รุ่น Lovely Family พร้อมที่นอนสปริง **ตจว.มีค่าจัดส่ง สอบถามก่อนสั่งสินค้า**",
        "product_image": "https://img.lazcdn.com/g/p/bda36dc5e1c6c45c6ceac57ad7dfe55c.png_200x200q90.png",
        "price": 27000,
        "remark": "https://www.lazada.co.th/products/pdp-i5730313379.html",
        "sold": 0
    },
    {
        "product_name": "ชุดห้องนอน 3.5ฟุต ชุดห้องนอนเด็ก *ส่งฟรี กทม. ปริมณฑล ถ้าเขต ตจว. เช็คค่าส่งก่อนได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S30054eb5c90e4369ae2a2bc78728d7afl.jpg_200x200q90.jpg",
        "price": 23800,
        "remark": "https://www.lazada.co.th/products/pdp-i5150810711.html",
        "sold": 0
    },
    {
        "product_name": "cool baby|เตียงเด็กปรับระดับได้ พร้อมโต๊ะเปลี่ยนผ้าอ้อม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S13f47f7d839f4e78a2aa8726c90c4cdc9.jpg_200x200q90.jpg",
        "price": 16942.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5877120375.html",
        "sold": 587
    },
    {
        "product_name": "เต็นท์สำหรับเด็กหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf5dbc06a608f43f292ed636a35245e6b8.png_200x200q90.png",
        "price": 14840.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16083757145.html",
        "sold": 0
    },
    {
        "product_name": "MLOONG | โต๊ะเรียนปรับระดับได้สำหรับเด็ก 1 ชุด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9f48c308c41d47a1a9a393c8f6118224E.jpg_200x200q90.jpg",
        "price": 11300.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5909558481.html",
        "sold": 0
    },
    {
        "product_name": "XiMei WoodWork | เก้าอี้โยกไม้สำหรับในร่มและกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5f479e07ce7443d4886ecb3015906e65l.jpg_200x200q90.jpg",
        "price": 10325.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16099298975.html",
        "sold": 0
    },
    {
        "product_name": "DANBIYIN | เตียงเด็กอเนกประสงค์ไม่ได้ทาสี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sebf520ee80be45a8a32c8ffdec2c343cF.jpg_200x200q90.jpg",
        "price": 10185.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16060530941.html",
        "sold": 0
    },
    {
        "product_name": "เตียงพับได้สำหรับทารกแรกเกิด ใช้งานได้หลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S77080c9dd5f14e809bf4b2482d9d2ee7r.jpg_200x200q90.jpg",
        "price": 9243.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16120347980.html",
        "sold": 0
    },
    {
        "product_name": "โซฟาเก้าอี้ไดโนเสาร์และยีราฟการ์ตูน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc28a007d766e4d2e9762c931e4a44436G.jpg_200x200q90.jpg",
        "price": 7179.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16093473759.html",
        "sold": 0
    },
    {
        "product_name": "KEDINI | พรมป้องกันการลื่นสำหรับเด็กหนา ใช้ในห้องเด็กช่วงฤดูหนาว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S434a64bc21dd4c8385c4d5cea6a333a9S.jpg_200x200q90.jpg",
        "price": 6925.98,
        "remark": "https://www.lazada.co.th/products/pdp-i16084735021.html",
        "sold": 0
    },
    {
        "product_name": "AOBIXIONG | เตียงเด็กพกพาที่มีโต๊ะเปลี่ยนผ้าอ้อม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S13fcd66dfeaa4c469fdbaaf1bce0e080n.jpg_200x200q90.jpg",
        "price": 6480.14,
        "remark": "https://www.lazada.co.th/products/pdp-i6058679691.html",
        "sold": 0
    },
    {
        "product_name": "TY | ไม้กอล์ฟสำหรับเด็กมือใหม่ อายุ 3-12 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb96540b3fefb441abb17354139371c31o.jpg_200x200q90.jpg",
        "price": 6155.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5996754770.html",
        "sold": 0
    },
    {
        "product_name": "The Primitive | รถเข็นเด็กสำหรับแคมป์ปิ้งพับได้ มีที่นอน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfb98bbc93f1f45daa5285c55650aa3f9U.jpg_200x200q90.jpg",
        "price": 6121.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5909641864.html",
        "sold": 94
    },
    {
        "product_name": "Prettyia ชุดบ้านตุ๊กตา DIY ขนาดเล็กพร้อมเคสกันฝุ่นงานดนตรีชุดเฟอร์นิเจอร์บ้านตุ๊กตาอพาร์ทเมนต์สร้างสรรค์สำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/p/bc4448e42a2971d69d6cc9fc8a0be949.jpg_200x200q90.jpg",
        "price": 4415.48,
        "remark": "https://www.lazada.co.th/products/pdp-i6029715591.html",
        "sold": 0
    },
    {
        "product_name": "AYIJIE | เตียงเด็กอ่อนไม้เนื้อแข็งหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa71af11a14c146fda5e788c4a94ddf18Z.png_200x200q90.png",
        "price": 4038.18,
        "remark": "https://www.lazada.co.th/products/pdp-i16080070833.html",
        "sold": 0
    },
    {
        "product_name": "XINGWANMOKE | ชุดสร้างอาคารสถานที่ แบบห้องสมุด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8a4b9dbdcfac49b4be107053356e06374.png_200x200q90.png",
        "price": 3594.34,
        "remark": "https://www.lazada.co.th/products/pdp-i6031861068.html",
        "sold": 0
    },
    {
        "product_name": "WUBUWEI | ราวป้องกันความปลอดภัยสำหรับเตียงเด็กที่สามารถขยายได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3084167a2eb74982a327fe23a87c3e2aN.jpg_200x200q90.jpg",
        "price": 3529.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16057749971.html",
        "sold": 4
    },
    {
        "product_name": "เตียงเด็กอ่อนพกพาพับได้หลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4dc6d010fa6e47c0b6c2b899db056454J.jpg_200x200q90.jpg",
        "price": 3446.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16119624014.html",
        "sold": 0
    },
    {
        "product_name": "ZHUSHANXIA | โซฟาเด็กน่ารักลายการ์ตูนขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/See77fa870d3e4f7894ed4183e5bf344bz.jpg_200x200q90.jpg",
        "price": 3265.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5893776369.html",
        "sold": 12
    },
    {
        "product_name": "PAMPAS | ม่านเตียงสำหรับเตียงสองชั้น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8c776bab53584d878c312af13c2c6deag.jpg_200x200q90.jpg",
        "price": 3062.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16096237776.html",
        "sold": 0
    },
    {
        "product_name": "S-NAIDE เตียงไม้พร้อมที่นอนแบบปรับได้ 3.5 ฟุต สำหรับเด็กแรกเกิดถึงวัยเตาะแตะตั้งแต่ 0-8 ปี - ไม้คุณภาพสูง ทนทาน ทำความสะอาดง่าย",
        "product_image": "https://img.lazcdn.com/g/p/232f3e3b0df272c9b50d4c8968b89d2f.jpg_200x200q90.jpg",
        "price": 2949.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5031698985.html",
        "sold": 109
    },
    {
        "product_name": "เตียงพกพาสำหรับทารก เตียงป้องกันแรงกด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S89661d82e7614676919828a4d01a8a3aM.jpg_200x200q90.jpg",
        "price": 2879.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16083612225.html",
        "sold": 0
    },
    {
        "product_name": "AOBIXIONG | โซฟาเด็กแบบการ์ตูนเจ้าหญิงน่ารัก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd334bff91cea40dfafc2dc18768b72b3a.jpg_200x200q90.jpg",
        "price": 2843.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16089345655.html",
        "sold": 0
    },
    {
        "product_name": "เตียงพับได้สำหรับทารกแบบพกพาหลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc40b2cfb05674496b8814e87686a2c86b.png_200x200q90.png",
        "price": 2774.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16120311796.html",
        "sold": 0
    },
    {
        "product_name": "MLZH | เก้าอี้โยกไฟฟ้าสำหรับทารก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se1d276bc030a4a759fd804272a6c5c5di.jpg_200x200q90.jpg",
        "price": 2771.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5931401233.html",
        "sold": 1
    },
    {
        "product_name": "AYIJIE | เตียงเด็กทารกเป็นมิตรต่อสิ่งแวดล้อม ไม่ได้ทาสี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S89cddf43847e47db863a69ac6bf7b4dc5.jpg_200x200q90.jpg",
        "price": 2717.84,
        "remark": "https://www.lazada.co.th/products/pdp-i16082525622.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้กินข้าวเด็ก โต๊ะกินข้าวเด็ก เก้าอี้ทานข้าวเด็ก พับได้ ปรับเป็นเก้าอี้โยกได้ มีล้อเลื่อน ปรับสูงต่ำได้ ถาด 2 ชั้น เบาะหนัง PU",
        "product_image": "https://img.lazcdn.com/g/p/2992dc5106c3dfaa712ffe85a8ae6f6b.png_200x200q90.png",
        "price": 2697.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16089853672.html",
        "sold": 4
    },
    {
        "product_name": "ZHENTAIYUAN | ชุดโต๊ะเรียนพลาสติกสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc8dee089abd543b0970541b8eacb8251D.jpg_200x200q90.jpg",
        "price": 2629.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16096053896.html",
        "sold": 0
    },
    {
        "product_name": "Lush age | เก้าอี้พับเด็กไม้แดงมาตรฐานชาติ งานประกอบแบบจีน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0acceadbaf2b45fbb759941c861954aad.jpg_200x200q90.jpg",
        "price": 2431.64,
        "remark": "https://www.lazada.co.th/products/pdp-i5894985570.html",
        "sold": 18
    },
    {
        "product_name": "เตียงเก้าอี้ที่เท้าแขนลายการ์ตูนน่ารักพับได้นอนโซฟานอนสบายปลอดภัยสำหรับการพักผ่อน",
        "product_image": "https://img.lazcdn.com/g/p/0df4b755207184fc40c6f96acde3e878.jpg_200x200q90.jpg",
        "price": 2382,
        "remark": "https://www.lazada.co.th/products/pdp-i16111320305.html",
        "sold": 0
    },
    {
        "product_name": "ZHUSHANXIA | โซฟาสำหรับอ่านหนังสือแบบพักผ่อนสำหรับคนเดียว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sad0cd74928e845b5b9629f39ded4167dt.jpg_200x200q90.jpg",
        "price": 2266.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5893636244.html",
        "sold": 39
    },
    {
        "product_name": "ชุดโต๊ะและเก้าอี้เรียนไม้เนื้อแข็งสำหรับอนุบาล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9d9183d79ecf4608b09e17f5f0ba8d5cx.jpg_200x200q90.jpg",
        "price": 2234,
        "remark": "https://www.lazada.co.th/products/pdp-i6040964255.html",
        "sold": 0
    },
    {
        "product_name": "CHIZHIDU | ตู้ข้างเตียงสไตล์มินิมอลสำหรับเด็ก",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Sd26b047261eb43668a86c68600932e42A.jpg_200x200q90.jpg",
        "price": 2176,
        "remark": "https://www.lazada.co.th/products/pdp-i6026095539.html",
        "sold": 2
    },
    {
        "product_name": "JACKDODO | ที่นอนเป่าลมในรถสำหรับเด็ก L",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2d780ad8439040d8a2d54257f541eebfp.jpg_200x200q90.jpg",
        "price": 2168.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5875583194.html",
        "sold": 4
    },
    {
        "product_name": "CHIZHIDU | เตียงเด็กทารกพับได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3b499dfde58c43919a99e47a7a30dbc9A.jpg_200x200q90.jpg",
        "price": 2127.28,
        "remark": "https://www.lazada.co.th/products/pdp-i16062339036.html",
        "sold": 0
    },
    {
        "product_name": "🌛 𝐆𝐨𝐨𝐝 𝐍i𝐠𝐡𝐭 💤 Satin Plus ที่นอน 3 ตอน ลาย We Bare Bear PB004",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2919d82c971b4d7ca5a42377f406e6b01.jpg_200x200q90.jpg",
        "price": 2120,
        "remark": "https://www.lazada.co.th/products/pdp-i16110047552.html",
        "sold": 0
    },
    {
        "product_name": "YANYANGTIAN | มุ้งกันยุงและม่านบังแดดแบบครบวงจร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9a6fc924e01e4feeb4fd149907a7b8caY.jpg_200x200q90.jpg",
        "price": 2100.1,
        "remark": "https://www.lazada.co.th/products/pdp-i5909627668.html",
        "sold": 0
    },
    {
        "product_name": "Be | ชุดนอนผู้หญิงแขนสั้นขาสั้น สำหรับฤดูร้อน ทำจากฝ้าย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd78c33a9c25b49fa97866e22b9a11938G.jpg_200x200q90.jpg",
        "price": 2083.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16099345578.html",
        "sold": 5
    },
    {
        "product_name": "Bunise ตู้เก็บของไม้ สไตล์มินิมอลโมเดิร์น สำหรับห้องนอน สี/ขนาดเลือกได้ รุ่น Z3EMB01 จัดส่งฟรีทั่วไทย บริการประกอบ",
        "product_image": "https://img.lazcdn.com/g/p/a5f6d37bbef1c4be7647c45e7c6c6f06.png_200x200q90.png",
        "price": 159960,
        "remark": "https://www.lazada.co.th/products/pdp-i5949880627.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ร้านค้าร้านกาแฟบ้านออฟฟิตขนาด 2.5 × 2 เมตร สไตล์มินิมอล",
        "product_image": "https://img.lazcdn.com/g/p/38e1c3018b9a41abee56480bbac690c0.jpg_200x200q90.jpg",
        "price": 119000,
        "remark": "https://www.lazada.co.th/products/pdp-i3575597625.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ร้านค้าร้านกาแฟสไตล์นอร์ดิกขนาด 2*2 เมตรผนังสามชั้น",
        "product_image": "https://img.lazcdn.com/g/p/8cfc1294eaa15e3c7ec8641406eb535e.jpg_200x200q90.jpg",
        "price": 119000,
        "remark": "https://www.lazada.co.th/products/pdp-i3600699602.html",
        "sold": 0
    },
    {
        "product_name": "Bunise ตู้เก็บของไม้ สไตล์ลักชัวรี สำหรับห้องนั่งเล่น สี/ขนาดเลือกได้ รุ่น MKE06-5012-01 จัดส่งฟรีทั่วไทย บริการประกอบ",
        "product_image": "https://img.lazcdn.com/g/p/bb9300f3e33d6f3f8c0a883f8f3df6f3.png_200x200q90.png",
        "price": 103960,
        "remark": "https://www.lazada.co.th/products/pdp-i5949948073.html",
        "sold": 0
    },
    {
        "product_name": "Chic Republicตู้อเนกประสงค์ รุ่น CREEK/147",
        "product_image": "https://img.lazcdn.com/g/p/08af39aa904e4839ff510e9b1bfbb550.jpg_200x200q90.jpg",
        "price": 96492,
        "remark": "https://www.lazada.co.th/products/pdp-i2213002752.html",
        "sold": 0
    },
    {
        "product_name": "Ashley  ตู้อเนกประสงค์ รุ่น STURLAYNE/142,Low Cabinet",
        "product_image": "https://img.lazcdn.com/g/p/63b3640ac0b2f30eb9c3cf53db0d97e3.jpg_200x200q90.jpg",
        "price": 78000,
        "remark": "https://www.lazada.co.th/products/pdp-i5555358484.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ร้านค้าร้านกาแฟมินิมอลขนาด 1.5x1.5 เมตร",
        "product_image": "https://img.lazcdn.com/g/p/40db57a8c4ce0574198057ce98ef35f4.jpg_200x200q90.jpg",
        "price": 71800,
        "remark": "https://www.lazada.co.th/products/pdp-i3600600865.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ไม้วินเทจ ตู้ไม้สัก สูง 210 xก105xล45 cm. ตู้ไม้สักคลาสสิก ชั้นวางของไม้สัก ตู้มีไฟ สีเสี้ยนขาว โชว์ลายไม้ มีประกันส่ง Vintage Teak Wooden Cabinet",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4a737ccf47904e9d8a0ab805446bfec6H.jpg_200x200q90.jpg",
        "price": 60700,
        "remark": "https://www.lazada.co.th/products/pdp-i5120508139.html",
        "sold": 0
    },
    {
        "product_name": "Chic Republic  ตู้อเนกประสงค์   รุ่น LORD/133",
        "product_image": "https://img.lazcdn.com/g/p/7e8f298f27b6d2edd0072273e8673523.jpg_200x200q90.jpg",
        "price": 56194,
        "remark": "https://www.lazada.co.th/products/pdp-i5104385087.html",
        "sold": 0
    },
    {
        "product_name": "Chic Republic  ตู้อเนกประสงค์   รุ่น EMMERSON/92",
        "product_image": "https://img.lazcdn.com/g/p/67413ba37c1a25c39a3da521bc2ed730.jpg_200x200q90.jpg",
        "price": 52272,
        "remark": "https://www.lazada.co.th/products/pdp-i5104388976.html",
        "sold": 0
    },
    {
        "product_name": "Chic Republic  ตู้อเนกประสงค์   รุ่น CLARA/142",
        "product_image": "https://img.lazcdn.com/g/p/0d2763d540a927c386c55ea2d6c83e9b.jpg_200x200q90.jpg",
        "price": 48382,
        "remark": "https://www.lazada.co.th/products/pdp-i5104478389.html",
        "sold": 0
    },
    {
        "product_name": "Chic Republic ตู้อเนกประสงค์  รุ่น ISABEL/80",
        "product_image": "https://img.lazcdn.com/g/p/702209246277e3b6cc5b5953dd0a0b96.jpg_200x200q90.jpg",
        "price": 38624,
        "remark": "https://www.lazada.co.th/products/pdp-i5088010744.html",
        "sold": 0
    },
    {
        "product_name": "Chic Republic ROBUSTO/90,ตู้อเนกประสงค์ - สี เทาเข้ม",
        "product_image": "https://img.lazcdn.com/g/p/01f4016949e4f1e879e4987ea5e2b767.jpg_200x200q90.jpg",
        "price": 38624,
        "remark": "https://www.lazada.co.th/products/pdp-i2924227640.html",
        "sold": 0
    },
    {
        "product_name": "Chic Republic  ตู้อเนกประสงค์   รุ่น JULIET/90",
        "product_image": "https://img.lazcdn.com/g/p/6a5bca7901173071998c425d83046ac4.jpg_200x200q90.jpg",
        "price": 38478,
        "remark": "https://www.lazada.co.th/products/pdp-i5100002405.html",
        "sold": 0
    },
    {
        "product_name": "Chic Republic  ตู้อเนกประสงค์   รุ่น JULIET/66",
        "product_image": "https://img.lazcdn.com/g/p/4bd2759b09c862f067d47b9b68479a42.jpg_200x200q90.jpg",
        "price": 38478,
        "remark": "https://www.lazada.co.th/products/pdp-i5099961639.html",
        "sold": 0
    },
    {
        "product_name": "Chic Republic  ตู้อเนกประสงค์   รุ่น PHANTHOM/90",
        "product_image": "https://img.lazcdn.com/g/p/14dcb15bea20468378d3d6ade2270f10.jpg_200x200q90.jpg",
        "price": 38218,
        "remark": "https://www.lazada.co.th/products/pdp-i5104123380.html",
        "sold": 0
    },
    {
        "product_name": "(รอทำ 20 วัน) ตู้ไม้สัก ขนาดใหญ่ กว้าง 150 x สูง 80 x ลึก 50 cm. ตู้ไซด์บอร์ดไม้สัก เคาน์เตอร์ไม้สัก (ประกอบแล้ว) 4 ลิ้นชัก ไม้สักแท้ทุกชิ้นส่วน",
        "product_image": "https://img.lazcdn.com/g/p/c06932d2a13e7eabbb25fe7ea740bc18.jpg_200x200q90.jpg",
        "price": 32600,
        "remark": "https://www.lazada.co.th/products/pdp-i4879728534.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ไม้สักแท้ กว้าง 160 x สูง 75 x ลึก 50 cm. (ประกอบแล้ว) มี 2 สี 15 ลิ้นชัก โต๊ะวางทีวีไม้ ตู้มินิมอล โต๊ะวางของ ตู้ยาจีน ตู้เก็บของ หลายช่อง งานสวย",
        "product_image": "https://img.lazcdn.com/g/p/9f49b4efe716e012bf37c029ed576eff.jpg_200x200q90.jpg",
        "price": 32300,
        "remark": "https://www.lazada.co.th/products/pdp-i4502529951.html",
        "sold": 0
    },
    {
        "product_name": "(จัดส่งทั้งตู้) ตู้ไม้สัก บุหวายแท้ สูง 135 x กว้าง 80 x ลึก 40 cm. สีสัก 2 ลิ้นชัก ตู้ไม้วินเทจ ไม้สักเก่า แข็งแรง Teak Wooden Cabinet Rattan",
        "product_image": "https://img.lazcdn.com/g/p/45a53fec4feb0e36b339a551c7603ed9.jpg_200x200q90.jpg",
        "price": 30700,
        "remark": "https://www.lazada.co.th/products/pdp-i4701588248.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ไม้สัก ตู้ไม้วินเทจ สูง 160 x กว้าง 70 x ลึก 35 cm. (จัดส่งทั้งตู้) ตู้ไม้คลาสสิค ตู้เก็บของ ตู้โชว์สินค้า สีเสี้ยนดำน้ำตาล ไม้สักแท้ ทุกชิ้นส่วน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S531b607f333343a19e66fb08dd1f41c4B.jpg_200x200q90.jpg",
        "price": 25900,
        "remark": "https://www.lazada.co.th/products/pdp-i5550074705.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ไม้สัก ตู้ไม้มินิมอล สูง 100 x กว้าง 80 x ลึก 40 cm. (จัดส่งทั้งตู้) 8 ลิ้นชัก มีรางเลื่อน มี 2สี ตู้วางทีวีไม้สัก โต๊ะวางของ มีประกันการส่ง",
        "product_image": "https://img.lazcdn.com/g/p/0f3ff2cebc8d6afb245e0aa4998857e8.jpg_200x200q90.jpg",
        "price": 25700,
        "remark": "https://www.lazada.co.th/products/pdp-i4477326846.html",
        "sold": 2
    },
    {
        "product_name": "ตู้ไม้สัก ตู้ไม้มินิมอล (จัดส่งทั้งตู้) กว้าง 80 x ลึก 40 x สูง 100 cm. ตู้ 8 ลิ้นชัก ตู้เก็บเสื้อผ้าไม้สัก ตู้วางทีวีไม้สัก สีเสี้ยนดำน้ำตาล งานสวย",
        "product_image": "https://img.lazcdn.com/g/p/6a1606de322e60022f7773ad77f99da3.jpg_200x200q90.jpg",
        "price": 25600,
        "remark": "https://www.lazada.co.th/products/pdp-i4972867551.html",
        "sold": 2
    },
    {
        "product_name": "ตู้ไม้สัก สีสักทอง กว้าง 120 x สูง 130 x ลึก 40 cm. (จัดส่งทั้งตู้) มี 2 สี ตู้โชว์ไม้สัก ไม้สักแท้ทุกชิ้นส่วน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1cf39e791182469c88b60acdc832b009O.jpg_200x200q90.jpg",
        "price": 22500,
        "remark": "https://www.lazada.co.th/products/pdp-i5650367891.html",
        "sold": 0
    },
    {
        "product_name": "(ส่งฟรีพร้อมติดตั้ง) ตู้เอกสารเหล็ก 4 ลิ้นชัก มอก. ยี่ห้อ TAIYO เหล็กหนา 0.6 มม. มาตราฐาน มอก. 63-2560",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S60699015d12d45679adf6876ecda13bct.jpg_200x200q90.jpg",
        "price": 21000,
        "remark": "https://www.lazada.co.th/products/pdp-i16086453637.html",
        "sold": 0
    },
    {
        "product_name": "ตู้เก็บของไม้สัก ขนาด กว้าง 50 ยาว 120 สูง 90 เซ็น ราคา 11,000บาทรยมจัดส่งฟรี ภาคใต้บวกเพิ่ม 500 บาท รอสินค้า 15-20 วันค่ะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S78fe6a959cf44f24a4865d2eeba27558M.jpg_200x200q90.jpg",
        "price": 21000,
        "remark": "https://www.lazada.co.th/products/pdp-i4341586879.html",
        "sold": 1
    },
    {
        "product_name": "ตู้ลิ้นชัก ไม้สัก รุ่น 6 ลิ้นชัก สีฟอก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5b3a37ce835a4339a3e0250e3bc83116m.jpg_200x200q90.jpg",
        "price": 19000,
        "remark": "https://www.lazada.co.th/products/pdp-i5265262576.html",
        "sold": 0
    },
    {
        "product_name": "MOLESUN ตู้เก็บของ (กทม.ติดตั้งฟรี)**อ่านเนื้อหารายละเอียด**",
        "product_image": "https://img.lazcdn.com/g/p/6acea0d284b8427e965ebeb5722f3a44.jpg_200x200q90.jpg",
        "price": 15998,
        "remark": "https://www.lazada.co.th/products/pdp-i5450524028.html",
        "sold": 0
    },
    {
        "product_name": "Chic Republic ตู้อเนกประสงค์  รุ่น MURLAND/106",
        "product_image": "https://img.lazcdn.com/g/p/997aaed035b3546cbda88e31fb28a21e.jpg_200x200q90.jpg",
        "price": 15102,
        "remark": "https://www.lazada.co.th/products/pdp-i5112759822.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ไม้สักสามบาน กว้าง50ซ.มยาว120ซ.มสูง90ซ.ม",
        "product_image": "https://img.lazcdn.com/g/p/603221ad2216aa919bfeb3c62ee28f4f.jpg_200x200q90.jpg",
        "price": 15000,
        "remark": "https://www.lazada.co.th/products/pdp-i3946169302.html",
        "sold": 15
    },
    {
        "product_name": "ตู้เก็บของรุ่นใหม่ เข้ากับมุมบ้านได้ดี ช่วยจัดระเบียบบ้านให้น่ามอง (กทม. ติดตั้งฟรี)",
        "product_image": "https://img.lazcdn.com/g/p/a069b38405d50cfea0f7dad3b972d355.jpg_200x200q90.jpg",
        "price": 13998,
        "remark": "https://www.lazada.co.th/products/pdp-i5076718209.html",
        "sold": 0
    },
    {
        "product_name": "(จัดส่งทั้งตู้) ตู้ไม้สักแท้ ตู้ไม้วินเทจ สูง 100 x กว้าง 50 x ลึก 40 cm. 5 ลิ้นชัก ขาสิงห์ ไม้สักแท้ทุกชิ้นส่วน ตู้มีกุญแจ มีประกันการจัดส่ง",
        "product_image": "https://img.lazcdn.com/g/p/d2ce581c6bffce04624c355143c738a2.jpg_200x200q90.jpg",
        "price": 13900,
        "remark": "https://www.lazada.co.th/products/pdp-i4177235932.html",
        "sold": 0
    },
    {
        "product_name": "(ส่งฟรีพร้อมติดตั้ง) ตู้เอกสารเหล็กบานเลื่อน 3 ฟุต กระจก/ทึบ มอก. ยี่ห้อ TAIYO มาตรฐาน มอก. 353-2566",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5454a2843340446eaef30be7f6ad2d53x.jpg_200x200q90.jpg",
        "price": 13800,
        "remark": "https://www.lazada.co.th/products/pdp-i16088423372.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ไม้สัก ตู้วางทีวี สูง80 xยาว75xลึก40cm  2 บาน 1 ลิ้นชัก ตู้เอนกประสงค์ ตู้โชว์ ตู้กระจก ใส่ของ ใส่หนังสือ สำเร็จรูป รับประกันการจัดส่ง",
        "product_image": "https://img.lazcdn.com/g/p/e93097a222469ae7ac696fc1b83501dc.jpg_200x200q90.jpg",
        "price": 13640,
        "remark": "https://www.lazada.co.th/products/pdp-i5173536107.html",
        "sold": 1
    },
    {
        "product_name": "ตู้เก็บของ Optimus รุ่น SPS-22 ชั้นยาว 4 ชั้น ตู้เก็บของ  ตู้เก็บอุปกรณ์เครื่องมือ ตู้หนังสือ ตู้เก็บเอกสาร ก76 x ล46 x ส185 ซม",
        "product_image": "https://img.lazcdn.com/g/p/148459be0e0e94cd696f5d3dc49d5588.jpg_200x200q90.jpg",
        "price": 11980,
        "remark": "https://www.lazada.co.th/products/pdp-i3468242081.html",
        "sold": 43
    },
    {
        "product_name": "Lucky World เฟอร์นิเจอร์เหล็ก ตู้เอกสารเหล็ก ตู้เหล็ก รุ่น KWS-183-MC (สีครีมเมทัลลิค) ตู้บานเปิดทึบสูง",
        "product_image": "https://img.lazcdn.com/g/p/9e722f6c117827fb2ea3e176089e74c6.jpg_200x200q90.jpg",
        "price": 11620,
        "remark": "https://www.lazada.co.th/products/pdp-i1677102690.html",
        "sold": 7
    },
    {
        "product_name": "Lucky World เฟอร์นิเจอร์เหล็ก ตู้เอกสารเหล็ก ตู้เหล็ก รุ่น KWS-183-TG (สีเทาทราย) ตู้บานเปิดทึบสูง",
        "product_image": "https://img.lazcdn.com/g/p/5d0a7e2ce4d5cb90169e49cb01141622.jpg_200x200q90.jpg",
        "price": 11620,
        "remark": "https://www.lazada.co.th/products/pdp-i1677202625.html",
        "sold": 10
    },
    {
        "product_name": "ตู้อเนกประสงค์เหล็ก ทรงสูง 60ซม. (บานเปิดกระจกใส) SC-GL04",
        "product_image": "https://img.lazcdn.com/g/p/f24c9436e5caf1c894d2523bd5ae9105.jpg_200x200q90.jpg",
        "price": 11480,
        "remark": "https://www.lazada.co.th/products/pdp-i5097139372.html",
        "sold": 0
    },
    {
        "product_name": "ตู้วางของอเนกประสงค์ไม้สักแท้100%(((ส่งฟรียกเว้นภาคใต้))",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Seaaf7a5b5b0548ccb0fb6143f880896b2.jpg_200x200q90.jpg",
        "price": 11400,
        "remark": "https://www.lazada.co.th/products/pdp-i4193123013.html",
        "sold": 5
    },
    {
        "product_name": "LUCKY ตู้บานเลื่อนทึบเหล็ก สีขาว รุ่น DO-314 ตู้เก็บเอกสารเหล็ก สำหรับบ้านและสำนักงาน  ตู้เก็บของ CABINET by สยามสตีลอินเตอร์เนชั่นแนล Siam Steel",
        "product_image": "https://img.lazcdn.com/g/p/3851f2d075162c47ab3c16720df5dc70.png_200x200q90.png",
        "price": 10980,
        "remark": "https://www.lazada.co.th/products/pdp-i3333230357.html",
        "sold": 3
    },
    {
        "product_name": "Lucky World เฟอร์นิเจอร์เหล็ก ตู้เหล็ก ตู้ลิ้นชักเหล็ก รุ่น CDX-15 - TG สีเทาทราย ตู้เก็บเอกสาร 15 ลิ้นชัก",
        "product_image": "https://img.lazcdn.com/g/p/6c5d3ed87c07e2c4dcaace62ea4d2f86.jpg_200x200q90.jpg",
        "price": 10700,
        "remark": "https://www.lazada.co.th/products/pdp-i1588828554.html",
        "sold": 1
    },
    {
        "product_name": "Luckyworld ตู้เก็บเอกสาร 15 ลิ้นชัก รุ่น CDX-15",
        "product_image": "https://img.lazcdn.com/g/p/2666408f6d6bda50fab8ecf710b8394a.png_200x200q90.png",
        "price": 10680,
        "remark": "https://www.lazada.co.th/products/pdp-i599798.html",
        "sold": 30
    },
    {
        "product_name": "IRONSERVICE : ตู้เก็บของ 4 ชั้น มีบานพับ เปิด-ปิด 3 บาน ท็อปไม้  \" เฟอร์นิเจอร์ โครงเหล็กกันสนิม ตกแต่งภายในและภายนอก มีประกัน \" (จัดส่งรวดเร็ว)",
        "product_image": "https://img.lazcdn.com/g/p/966baf6435af8dbe31b0c36394ce0d95.jpg_200x200q90.jpg",
        "price": 10643.36,
        "remark": "https://www.lazada.co.th/products/pdp-i4513728154.html",
        "sold": 5
    },
    {
        "product_name": "ตู้เก็บของเหล็กตู้อเนกประสงค์ 1บานเปิด60ซม. CARGO มาตรฐาน JIS",
        "product_image": "https://img.lazcdn.com/g/p/35ba0d79dae2ef4cf87d7c8d2c2a8434.png_200x200q90.png",
        "price": 10580,
        "remark": "https://www.lazada.co.th/products/pdp-i5558030767.html",
        "sold": 0
    },
    {
        "product_name": "Lucky World ตู้เก็บเอกสาร 15 ลิ้นชัก CDX-15",
        "product_image": "https://img.lazcdn.com/g/p/0a90dd926cf86ba472df55de825a1459.jpg_200x200q90.jpg",
        "price": 10400,
        "remark": "https://www.lazada.co.th/products/pdp-i1679566347.html",
        "sold": 80
    },
    {
        "product_name": "MOOVE ตู้อเนกประสงค์E1 บานเลื่อน160x40x79สีไม้",
        "product_image": "https://img.lazcdn.com/g/p/698cfdb7ab5a7d3f2f417208a858d525.jpg_200x200q90.jpg",
        "price": 10380,
        "remark": "https://www.lazada.co.th/products/pdp-i5759609030.html",
        "sold": 6
    },
    {
        "product_name": "Keyless Combination Lock Low-Height Filing Cabinet Modern Design Multi-Drawer Wooden Cabinet Lockable Office Furniture Room Divider Function for Business Managers, Students, Workspace, Reception Area",
        "product_image": "https://img.lazcdn.com/g/p/35d0165d7172a89e081bd12650d016b9.jpg_200x200q90.jpg",
        "price": 10198.92,
        "remark": "https://www.lazada.co.th/products/pdp-i6079436622.html",
        "sold": 0
    },
    {
        "product_name": "Lucky World ตู้เก็บเอกสาร 4 ลิ้นชัก KCDX-4 (เกรด C) ไม่มีการรับประกันสินค้า, ไม่รับเปลี่ยน",
        "product_image": "https://img.lazcdn.com/g/p/1d9018bd24aff6ec2a5338abf037dfd0.jpg_200x200q90.jpg",
        "price": 10000,
        "remark": "https://www.lazada.co.th/products/pdp-i5688721138.html",
        "sold": 1
    },
    {
        "product_name": "BETTER ตู้เหล็ก 2 บานเปิด รุ่น LK-2 สีเทาสลับ [ไม่รวมประกอบ] |LAN|",
        "product_image": "https://img.lazcdn.com/g/p/0bcd76ac8018b7522cfe64250168aa18.jpg_200x200q90.jpg",
        "price": 9762,
        "remark": "https://www.lazada.co.th/products/pdp-i3281566452.html",
        "sold": 22
    },
    {
        "product_name": "Better ตู้เอกสาร 4 ลิ้นชัก รุ่น DR-4 สีเทาสลับ [ไม่รวมประกอบ] |LAN|",
        "product_image": "https://img.lazcdn.com/g/p/f898a90cfb03dbb9aebe2579b20b9123.jpg_200x200q90.jpg",
        "price": 9460,
        "remark": "https://www.lazada.co.th/products/pdp-i3590503021.html",
        "sold": 26
    },
    {
        "product_name": "Lucky World ตู้เก็บเอกสาร 3 ลิ้นชัก KCDX-3",
        "product_image": "https://img.lazcdn.com/g/p/9a05c36cfb538d4a9ac06184634c62b2.jpg_200x200q90.jpg",
        "price": 9380,
        "remark": "https://www.lazada.co.th/products/pdp-i1679620406.html",
        "sold": 21
    },
    {
        "product_name": "Smart From ตู้เอกสาร 15 ลิ้นชัก รุ่น MD-15 สีเขียว/ขาว [ไม่รวมประกอบ] |LAN|",
        "product_image": "https://img.lazcdn.com/g/p/0a02591085c41969782eb9b82d15bc0e.jpg_200x200q90.jpg",
        "price": 9232,
        "remark": "https://www.lazada.co.th/products/pdp-i3270378994.html",
        "sold": 14
    },
    {
        "product_name": "LEECO ลีโก้ ตู้บานเลื่อนทึบ 4 ฟุต ตู้อเนกประสงค์เก็บของใช้ในบ้านและสำนักงาน ชั้นวางปรับระดับได้ รุ่น SLS-0204",
        "product_image": "https://img.lazcdn.com/g/p/a6dad3503118bd6edd485d5eb0007e55.png_200x200q90.png",
        "price": 9051.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5518323024.html",
        "sold": 0
    },
    {
        "product_name": "LUCKY ตู้บานเลื่อนทึบเหล็ก สีดำ รุ่น DO-313 ตู้เก็บเอกสารเหล็ก สำหรับบ้านและสำนักงาน  ตู้เก็บของ CABINET",
        "product_image": "https://img.lazcdn.com/g/p/4f475778997054ec0cf3deb80fa2351e.png_200x200q90.png",
        "price": 8980,
        "remark": "https://www.lazada.co.th/products/pdp-i2959566747.html",
        "sold": 9
    },
    {
        "product_name": "LEECO ลีโก้ ตู้เหล็ก ตู้ล็อคเกอร์ ตู้อเนกประสงค์ 1 บาน 3ชั้นเก็บของพร้อมตัวล็อค รุ่น LK 1201",
        "product_image": "https://img.lazcdn.com/g/p/c04addc0848d17d1aaf7d8e3a6d5ad3b.png_200x200q90.png",
        "price": 8887.46,
        "remark": "https://www.lazada.co.th/products/pdp-i4728365916.html",
        "sold": 1
    },
    {
        "product_name": "LEECO ลีโก้ ตู้เหล็ก ตู้ลิ้นชักเก็บของ ตู้อเนกประสงค์ 6 ลิ้นชัก รุ่น CT-742-A",
        "product_image": "https://img.lazcdn.com/g/p/8a5b451527cb5f86f169faa314ebaf6c.png_200x200q90.png",
        "price": 8671.22,
        "remark": "https://www.lazada.co.th/products/pdp-i4726075032.html",
        "sold": 9
    },
    {
        "product_name": "ตู้เหล็ก ตู้เอกสาร ตู้เก็บของ ตู้อเนกประสงค์ สีขาวน้ำตาล หลากหลายแบบ  ส่งฟรีทั่วประเทศ",
        "product_image": "https://img.lazcdn.com/g/p/08190289b3d549b402fa7e1dfe9bc653.jpg_200x200q90.jpg",
        "price": 8380,
        "remark": "https://www.lazada.co.th/products/pdp-i3378248035.html",
        "sold": 29
    },
    {
        "product_name": "NEED | ตู้เหล็กสีขาว มินิมอล ตู้สีขาวแต่งบ้าน มี5 แบบ ตู้เอนกประสงค์ ตู้กระจกสีขาว ส่งฟรี 🔥",
        "product_image": "https://img.lazcdn.com/g/p/194581591e13d9d502a26dd5f4e09705.png_200x200q90.png",
        "price": 8380,
        "remark": "https://www.lazada.co.th/products/pdp-i3777864486.html",
        "sold": 3
    },
    {
        "product_name": "NEED | ตู้เหล็กสีเขียวมิ้นท์พร้อมส่ง 5 แบบ ตู้เก็บของ ตู้เก็บเอกสาร ตู้กระจก ออกVat ได้ ส่งฟรี 🔥",
        "product_image": "https://img.lazcdn.com/g/p/461bda736f0803eb739a983dbf06be7f.png_200x200q90.png",
        "price": 8380,
        "remark": "https://www.lazada.co.th/products/pdp-i3491874729.html",
        "sold": 11
    },
    {
        "product_name": "ตู้เก็บเอกสาร ตู้เก็บของ ตู้เหล็ก 2 บานเปิดทึบ (ส่งฟรีทั่วไทย/ต่างจังหวัดส่งไม่ประกอบ) ออกใบกำกับภาษีได้",
        "product_image": "https://img.lazcdn.com/g/p/46ed46b878db09da67b9112b3864ced3.jpg_200x200q90.jpg",
        "price": 8380,
        "remark": "https://www.lazada.co.th/products/pdp-i2285064909.html",
        "sold": 47
    },
    {
        "product_name": "ตู้ไม้สัก ตู้ไม้คลาสสิค สูง 130 x กว้าง 50 x ลึก 30 cm. (ประกอบแล้ว) ทำสีเสี้ยนขาว โชว์ลายไม้ ทำจากไม้สักแท้ ทุกชิ้นส่วน ร้านจัดส่งเอง ปลอดภัย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S62aed2803b6d43b5b4077779e1151180e.jpg_200x200q90.jpg",
        "price": 8300,
        "remark": "https://www.lazada.co.th/products/pdp-i5311462377.html",
        "sold": 0
    },
    {
        "product_name": "(ส่งฟรี) ตู้ไม้สักแท้ 3 ชั้น ตู้เก็บของไม้สัก สูง 110 x กว้าง 60 x ลึก 30 cm. (จัดส่งทั้งตู้) 2 บานเปิด ตู้กระจกไม้สัก ตู้โชว์ไม้สัก มีประกันการจัดส่ง",
        "product_image": "https://img.lazcdn.com/g/p/7c58568f8bfbd135a1c75f19db9df947.jpg_200x200q90.jpg",
        "price": 8300,
        "remark": "https://www.lazada.co.th/products/pdp-i3084763728.html",
        "sold": 0
    },
    {
        "product_name": "LEECO ลีโก้ ตู้เหล็ก ตู้ลิ้นชักเก็บของ ตู้อเนกประสงค์ 4 ลิ้นชัก รุ่น CT-704",
        "product_image": "https://img.lazcdn.com/g/p/35380337946c27d05815872c55040c6a.png_200x200q90.png",
        "price": 8238.74,
        "remark": "https://www.lazada.co.th/products/pdp-i4725959235.html",
        "sold": 9
    },
    {
        "product_name": "Better ตู้เอกสาร 15 ลิ้นชั้ก รุ่น DR-15 สีเทาสลับ [ไม่รวมประกอบ] |LAN|",
        "product_image": "https://img.lazcdn.com/g/p/49d0476dbe7e3a73ea02e4c2bd9b747e.jpg_200x200q90.jpg",
        "price": 8186,
        "remark": "https://www.lazada.co.th/products/pdp-i3590269790.html",
        "sold": 116
    },
    {
        "product_name": "LEECO ลีโก้ ตู้เหล็ก ตู้ล็อคเกอร์ ตู้อเนกประสงค์ ขนาดมินิ ตกแต่งห้องส่วย 3 บาน รุ่น LK-2203",
        "product_image": "https://img.lazcdn.com/g/p/10d241df75b2de3735c9ac0c27430dbd.png_200x200q90.png",
        "price": 8156.58,
        "remark": "https://www.lazada.co.th/products/pdp-i5305935075.html",
        "sold": 0
    },
    {
        "product_name": "LEECO ลีโก้ ตู้เหล็ก ตู้ลิ้นชักเก็บของ ตู้อเนกประสงค์ 4 ลิ้นชัก รุ่น CT 704-A",
        "product_image": "https://img.lazcdn.com/g/p/4744cdf9ddfe3eeb87043a2957c20b5a.png_200x200q90.png",
        "price": 8109,
        "remark": "https://www.lazada.co.th/products/pdp-i4615576734.html",
        "sold": 21
    },
    {
        "product_name": "Luckyworld ตู้เก็บเอกสาร 6 ลิ้นชัก รุ่น CDX-6",
        "product_image": "https://img.lazcdn.com/g/p/2462e92efaeaf7a60995875ef94d88bd.png_200x200q90.png",
        "price": 8020,
        "remark": "https://www.lazada.co.th/products/pdp-i1076051.html",
        "sold": 11
    },
    {
        "product_name": "โรงไม้ประสิทธิ์ ตู้อเนกประสงค์ไม้สักแท้ สีไม้สักทอง 4,5 ลิ้นชัก ขนาด 50*45*75ซม. พร้อมกุญแจ แต่ละชั้น",
        "product_image": "https://img.lazcdn.com/g/p/8be913b59e32762df86215d0a7118bbc.jpg_200x200q90.jpg",
        "price": 8000,
        "remark": "https://www.lazada.co.th/products/pdp-i5715148420.html",
        "sold": 1
    },
    {
        "product_name": "ตู้เหล็กใส่ของ ตู้เหล็กเอนกประสงค์ 75*25*85 ซม.มีให้เลือก 2 ขนาด | จัดสั่งทั้งชิ้นตามภาพ  | จัดส่งแบบ bulky ค่ะ",
        "product_image": "https://img.lazcdn.com/g/p/eeb27a7420ff9ac239d2f8084d6e879c.jpg_200x200q90.jpg",
        "price": 7980,
        "remark": "https://www.lazada.co.th/products/pdp-i5954348617.html",
        "sold": 0
    },
    {
        "product_name": "ตู้เหล็กเก็บของ ตู้เหล็ก 2 บานเปิดทึบ ตู้เหล็กทึบอเนกประสงค์ ส่งฟรี",
        "product_image": "https://img.lazcdn.com/g/p/409c577dca2171cce3df8e84b705036f.jpg_200x200q90.jpg",
        "price": 7980,
        "remark": "https://www.lazada.co.th/products/pdp-i4127572139.html",
        "sold": 12
    },
    {
        "product_name": "Luckyworld ตู้เก็บเอกสาร 10 ลิ้นชัก รุ่น CDX-10",
        "product_image": "https://img.lazcdn.com/g/p/519a2b3274f0458669183c2b2c7d130a.png_200x200q90.png",
        "price": 7880,
        "remark": "https://www.lazada.co.th/products/pdp-i599793.html",
        "sold": 11
    },
    {
        "product_name": "Luckyworld ตู้เก็บเอกสาร 2 ลิ้นชัก รุ่น KCDX-2",
        "product_image": "https://img.lazcdn.com/g/p/cf7513ced34ce47e09e5710798844afc.png_200x200q90.png",
        "price": 7860,
        "remark": "https://www.lazada.co.th/products/pdp-i599780.html",
        "sold": 19
    },
    {
        "product_name": "Better ตู้เอกสาร 3 ลิ้นชัก รุ่น DR-3 สีเทาสลับ [ไม่รวมประกอบ] |LAN|",
        "product_image": "https://img.lazcdn.com/g/p/0b98f25c531c7ad202cd2ecd08181210.jpg_200x200q90.jpg",
        "price": 7528,
        "remark": "https://www.lazada.co.th/products/pdp-i3590323858.html",
        "sold": 24
    },
    {
        "product_name": "ตู้โมเดิร์น 2 ลิ้นชัก ไม้สักคัดเกรด พร้อมติดรางเลื่อนทุกชั้น",
        "product_image": "https://img.lazcdn.com/g/p/8e8c95c643da430872ff1b894424c882.jpg_200x200q90.jpg",
        "price": 7380,
        "remark": "https://www.lazada.co.th/products/pdp-i5238744194.html",
        "sold": 2
    },
    {
        "product_name": "Lucky World ตู้เก็บเอกสาร 10 ลิ้นชัก CDX-10",
        "product_image": "https://img.lazcdn.com/g/p/447358da967877d8dc990ddc7089fade.jpg_200x200q90.jpg",
        "price": 7230,
        "remark": "https://www.lazada.co.th/products/pdp-i1675608779.html",
        "sold": 35
    },
    {
        "product_name": "Lucky World ตู้เก็บเอกสาร 2 ลิ้นชัก KCDX-2",
        "product_image": "https://img.lazcdn.com/g/p/23469e3c28f60c393d75caf6b903a557.jpg_200x200q90.jpg",
        "price": 7190,
        "remark": "https://www.lazada.co.th/products/pdp-i1679544956.html",
        "sold": 23
    },
    {
        "product_name": "KOL by KIOSK ตู้เหล็กบานเลื่อนทึบ รุ่น KOD-4  ขนาด 4 ฟุต มีหลายสี",
        "product_image": "https://img.lazcdn.com/g/p/66101936bf493dd8919f9dcf4a260bd4.jpg_200x200q90.jpg",
        "price": 7190,
        "remark": "https://www.lazada.co.th/products/pdp-i5717309281.html",
        "sold": 3
    },
    {
        "product_name": "[จัดส่งพร้อมติดตั้งฟรี] KOL ตู้เหล็กบานเลื่อนกระจก 4 ฟุต พร้อม 2 แผ่นชั้นปรับระดับได้และกุญแจ",
        "product_image": "https://img.lazcdn.com/g/p/6aaad1dc906cac1123867dcc65cf17d4.jpg_200x200q90.jpg",
        "price": 7180,
        "remark": "https://www.lazada.co.th/products/pdp-i4779680638.html",
        "sold": 12
    },
    {
        "product_name": "[จัดส่งพร้อมติดตั้งฟรี] KOL ตู้เหล็กบานเลื่อนทึบ 4 ฟุต  พร้อม 2 แผ่นชั้นปรับระดับได้และกุญแจ",
        "product_image": "https://img.lazcdn.com/g/p/767550bf1d50c18c01c032f73b42e395.jpg_200x200q90.jpg",
        "price": 7180,
        "remark": "https://www.lazada.co.th/products/pdp-i4779766107.html",
        "sold": 8
    },
    {
        "product_name": "IRONSERVICE : ตู้เก็บของ  พร้อมลิ้นชัก 4 ตัว  \" เฟอร์นิเจอร์ โครงเหล็กกันสนิม ตกแต่งภายในและภายนอก มีประกัน \" (จัดส่งรวดเร็ว)",
        "product_image": "https://img.lazcdn.com/g/p/dd9ac0a84a9c242059e474378421c517.jpg_200x200q90.jpg",
        "price": 7156.8,
        "remark": "https://www.lazada.co.th/products/pdp-i4779333154.html",
        "sold": 0
    },
    {
        "product_name": "Lucky World ตู้เก็บเอกสาร 6 ลิ้นชัก CDX-6",
        "product_image": "https://img.lazcdn.com/g/p/a83844302414a2e6602bf3c562fa2ceb.jpg_200x200q90.jpg",
        "price": 7150,
        "remark": "https://www.lazada.co.th/products/pdp-i1655226133.html",
        "sold": 101
    },
    {
        "product_name": "Better ตู้บานเลื่อนทึบ 4 ฟุต รุ่น SL-4 สีเทาสลับ [ไม่รวมประกอบ] |LAN|",
        "product_image": "https://img.lazcdn.com/g/p/b070d93b2fb1ebbaf9e936972099d365.jpg_200x200q90.jpg",
        "price": 7134,
        "remark": "https://www.lazada.co.th/products/pdp-i3296398540.html",
        "sold": 42
    },
    {
        "product_name": "LEECO ลีโก้ ตู้เหล็ก ตู้ลิ้นชักเก็บของ ตู้อเนกประสงค์ 3 ลิ้นชักพร้อมล้อ รุ่นCT-103",
        "product_image": "https://img.lazcdn.com/g/p/6ddd5081209637cb13a22722cb55bf4f.png_200x200q90.png",
        "price": 7049.42,
        "remark": "https://www.lazada.co.th/products/pdp-i4731863920.html",
        "sold": 12
    },
    {
        "product_name": "LEECO ลีโก้ ตู้เหล็ก ตู้ลิ้นชักเก็บของ ตู้อเนกประสงค์ 3 ลิ้นชักใหญ่ รุ่น CT-603 A",
        "product_image": "https://img.lazcdn.com/g/p/591509804279801c2b6fad42992e4a09.png_200x200q90.png",
        "price": 7049.42,
        "remark": "https://www.lazada.co.th/products/pdp-i4615572557.html",
        "sold": 14
    },
    {
        "product_name": "ตู้เก็บเอกสารเหล็ก, ตู้เก็บของ 4 ชั้นปรับระดับได้, ตู้เสื้อผ้าขนาดใหญ่, ตู้เก็บของในครัวที่แข็งแรงทนทาน -ออกใบแจ้งหนี้ได",
        "product_image": "https://img.lazcdn.com/g/p/11e75274552ffe988e187c1c768f7d6c.jpg_200x200q90.jpg",
        "price": 6998,
        "remark": "https://www.lazada.co.th/products/pdp-i5823326285.html",
        "sold": 0
    },
    {
        "product_name": "ตู้เหล็ก ตู้ล็อคเกอร์ ตู้อเนกประสงค์ ตู้เก็บรองเท้า ตู้มีกุญแจ ตู้เหล็กบานเปิด 4 ชั้น 3 แถว ชั้นวางของ มีประตู ชั้นวางของเหล็ก",
        "product_image": "https://img.lazcdn.com/g/p/a0625f1bb0c1490a0a9caad19d782423.jpg_200x200q90.jpg",
        "price": 6980,
        "remark": "https://www.lazada.co.th/products/pdp-i1446246523.html",
        "sold": 8
    },
    {
        "product_name": "Aidia [5สี] ตู้เหล็ก ขนาดเล็ก 3 ลิ้นชัก พร้อมล้อเลื่อน สีส้ม ขาว ดำ เขียว ฟ้า ขนาด 39x50x60 cm. ตู้เอกสาร ลิ้นชักเหล็ก ตู้ขนาดเล็ก ตู้",
        "product_image": "https://img.lazcdn.com/g/p/7d84b43768a99de7d9900a3fe9d1577d.jpg_200x200q90.jpg",
        "price": 6980,
        "remark": "https://www.lazada.co.th/products/pdp-i504984246.html",
        "sold": 66
    },
    {
        "product_name": "LEECO ลีโก้ ตู้เหล็ก ตู้ลิ้นชักเก็บของ ตู้อเนกประสงค์ 3 ลิ้นชักพร้อมล้อ รุ่นCT-103 A",
        "product_image": "https://img.lazcdn.com/g/p/2a30769a0fff23fd76357864319f2bd6.png_200x200q90.png",
        "price": 6854.8,
        "remark": "https://www.lazada.co.th/products/pdp-i4725919743.html",
        "sold": 16
    },
    {
        "product_name": "ตู้ไม้สัก ตู้เอกสารไม้สัก 3 ลิ้นชัก ตู้ใส่ของ ตู้เก็บของ ตู้เสื้อผ้า",
        "product_image": "https://img.lazcdn.com/g/p/347971235a0b46b81e7f15871c93806d.jpg_200x200q90.jpg",
        "price": 6780,
        "remark": "https://www.lazada.co.th/products/pdp-i5870920205.html",
        "sold": 0
    },
    {
        "product_name": "IRONSERVICE : ตู้เก็บของทึบ แบบบานพับ  : \" เฟอร์นิเจอร์ โครงเหล็กกันสนิม ตกแต่งภายในและภายนอก มีประกัน \" (จัดส่งรวดเร็ว)",
        "product_image": "https://img.lazcdn.com/g/p/ef4aa1a67854541333f463fb87ea30d2.jpg_200x200q90.jpg",
        "price": 6645.6,
        "remark": "https://www.lazada.co.th/products/pdp-i4998164727.html",
        "sold": 0
    },
    {
        "product_name": "สินค้าพร้อมส่ง ตู้เหล็กบานเปิด  4ชั้น 3 แถว เบา ตู้ล็อคเกอร์ ตู้อเนกประสงค์ ตู้เก็บรองเท้า ตู้มีกุญแจ ชั้นวางของ มีประตู ชั้นวางเหล็ก",
        "product_image": "https://img.lazcdn.com/g/p/600cb5efb0852fd51a24553d16f9c1eb.jpg_200x200q90.jpg",
        "price": 6644.96,
        "remark": "https://www.lazada.co.th/products/pdp-i1430110333.html",
        "sold": 67
    },
    {
        "product_name": "Rina Hey ตู้อเนกประสงค์  รุ่น CLARITY/120",
        "product_image": "https://img.lazcdn.com/g/p/90b7804068a79e2291f7742ec98cd5cd.jpg_200x200q90.jpg",
        "price": 6506,
        "remark": "https://www.lazada.co.th/products/pdp-i5185910831.html",
        "sold": 12
    },
    {
        "product_name": "ตู้เหล็ก ตู้ล็อกเกอร์ ตู้เก็บเอกสาร ตู้เก็บของ ตู้เหล็กบานเปิด หลากหลายสี(ส่งฟรีทั่วไทย/ต่างจังหวัดส่งไม่ประกอบ) ออกใบกำกับภาษีได้",
        "product_image": "https://img.lazcdn.com/g/p/3e8289998b2659e756c53630578a667e.jpg_200x200q90.jpg",
        "price": 6380,
        "remark": "https://www.lazada.co.th/products/pdp-i3602908343.html",
        "sold": 156
    },
    {
        "product_name": "NANGUAHEZI | ตู้เก็บของหลายชั้น ความจุมาก สวยงามหรูหรา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd322bf685d304f61908b0681c960ea6bN.jpg_200x200q90.jpg",
        "price": 6232.88,
        "remark": "https://www.lazada.co.th/products/pdp-i6001895089.html",
        "sold": 0
    },
    {
        "product_name": "✨ตู้ไม้สักแท้ 3 ลิ้นชักพร้อมกุญแจล็อก(งานทำสี)✨ 📏ความกว้าง 50 ซม.ความยาว 44 ซม.สูง 64 ซม.",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa06f8e3b4d804ccab9342448932db679V.jpg_200x200q90.jpg",
        "price": 6000,
        "remark": "https://www.lazada.co.th/products/pdp-i5855803111.html",
        "sold": 0
    },
    {
        "product_name": "Livinghome FurnitureMall ตู้เอกสารสูง ขนาด 80x40x168.6 cm. รุ่น ROCCO สีน้ำตาล/เทา",
        "product_image": "https://img.lazcdn.com/g/p/05a9be67abf6e001f43c4ce4346021ff.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i4261442096.html",
        "sold": 2
    },
    {
        "product_name": "Better ตู้เอกสาร 10 ลิ้นชั้ก รุ่น DR-10 สีเทาสลับ [ไม่รวมประกอบ] |LAN|",
        "product_image": "https://img.lazcdn.com/g/p/393aa0b8ec3c22907afc44c1c6e02e00.jpg_200x200q90.jpg",
        "price": 5934,
        "remark": "https://www.lazada.co.th/products/pdp-i2848043731.html",
        "sold": 151
    },
    {
        "product_name": "Better ตู้บานเลื่อนทึบ 3 ฟุต รุ่น SL-3 สีเทาสลับ [ไม่รวมประกอบ] |LAN|",
        "product_image": "https://img.lazcdn.com/g/p/1887d0cf9989a55ac1e65755ffe2e9f2.jpg_200x200q90.jpg",
        "price": 5914,
        "remark": "https://www.lazada.co.th/products/pdp-i3297089628.html",
        "sold": 43
    },
    {
        "product_name": "[จัดส่งพร้อมติดตั้งฟรี] KOL ตู้เหล็กบานเลื่อนกระจก 3 ฟุตพร้อม 2 แผ่นชั้นปรับระดับได้และกุญแจ",
        "product_image": "https://img.lazcdn.com/g/p/9dca0607cab5a8c7abe3cd8ee1344877.jpg_200x200q90.jpg",
        "price": 5780,
        "remark": "https://www.lazada.co.th/products/pdp-i4779689247.html",
        "sold": 21
    },
    {
        "product_name": "จัดส่งพร้อมติดตั้งฟรี] KOL ตู้เหล็กบานเลื่อนทึบ3ฟุต พร้อม 2 แผ่นชั้นปรับระดับได้และกุญแจ",
        "product_image": "https://img.lazcdn.com/g/p/a87deaa27d15fd0a3bc244fa162dfb6a.jpg_200x200q90.jpg",
        "price": 5780,
        "remark": "https://www.lazada.co.th/products/pdp-i4779616133.html",
        "sold": 9
    },
    {
        "product_name": "ตู้ไม้สักแท้ ตู้ลิ้นชัก3ชั้น ตู้เอกสาร ตู้หัวเตียง ตู้ไม้สักแท้100%ราคาถูกๆ ขนาด45*50*66cm",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S982fb65fa86d4faca87b2f66401fedf4P.jpg_200x200q90.jpg",
        "price": 5700,
        "remark": "https://www.lazada.co.th/products/pdp-i1903798637.html",
        "sold": 6
    },
    {
        "product_name": "Tomato Home ตู้ Desire 3dr Sideboard กว้าง119ซม | ตู้มินิมอล ตู้เก็บของ ตู้เอนกประสงค์ | ดีไซน์ดูดี",
        "product_image": "https://img.lazcdn.com/g/p/341bd79b053ca5a24808cd190abce983.jpg_200x200q90.jpg",
        "price": 5700,
        "remark": "https://www.lazada.co.th/products/pdp-i5803615530.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ลิ้นชัก ตู้เก็บของ  ไม้MDF ตู้วินเทจ สีขาว 4ชั้น กว้าง80cm.ลึก40cm.สูง96cm.",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4baae3bd02ba4afeb1f89df65efebceeR.jpg_200x200q90.jpg",
        "price": 5353.3,
        "remark": "https://www.lazada.co.th/products/pdp-i4229726251.html",
        "sold": 11
    },
    {
        "product_name": "CABSET01 ตู้เอกสาร ตู้ล็อคเกอร์ ตู้เสื้อผ้า รวมทุกรุ่น ตู้เหล็ก ดีไซน์สวยงาม แข็งแรง ทนทาน ใช้งานได้ทุกฟังก์ชั่น",
        "product_image": "https://img.lazcdn.com/g/p/7360775bc161b57e56607848770ada45.png_200x200q90.png",
        "price": 5312.16,
        "remark": "https://www.lazada.co.th/products/pdp-i5719605063.html",
        "sold": 15
    },
    {
        "product_name": "ตู้ลิ้นชัก80ซม.🌈มี5สี ล้อรางสไลด์อย่างดี ดึงใช้งานสะดวก [สินค้ามีพร้อมส่ง] Brownfurniture",
        "product_image": "https://img.lazcdn.com/g/p/6402d44ee91e9d18c327ce4d0192b727.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i4159881811.html",
        "sold": 4
    },
    {
        "product_name": "KOL by KIOSK ตู้เหล็กบานเลื่อนทึบ รุ่น KOD-3  ขนาด 3 ฟุต มีหลายสี",
        "product_image": "https://img.lazcdn.com/g/p/b0b83073007e4b2272529fef6f59a5ee.jpg_200x200q90.jpg",
        "price": 5140.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5261183434.html",
        "sold": 15
    },
    {
        "product_name": "ตู้บานเปิด 4 ชั้น โครงทึบ Leaf KASSA HOME รุ่น ZKG-Clear Vid-V.2 ขนาด 70 x 50 x 162 ซม. สีขาว - เทา",
        "product_image": "https://img.lazcdn.com/g/p/52108326b1ef83844c44a35dc2259ca4.jpg_200x200q90.jpg",
        "price": 5060,
        "remark": "https://www.lazada.co.th/products/pdp-i5952773338.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ลิ้นชักเอกสาร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5cece7da149e41b18fa8f82eb7e14e38Y.jpg_200x200q90.jpg",
        "price": 5000,
        "remark": "https://www.lazada.co.th/products/pdp-i4827597498.html",
        "sold": 1
    },
    {
        "product_name": "metal cabinet ตู้เหล็กเก็บเอกสาร ตู้เหล็กลัคกี้ ตู้เก็บของ ตู้เหล็กใส่ของ ตู้เหล็กเอกสาร ตู้เหล็ก ตู้เก็บของอเนก",
        "product_image": "https://img.lazcdn.com/g/p/f3aad3d649ba6e321ce28820551a5a83.jpg_200x200q90.jpg",
        "price": 4998,
        "remark": "https://www.lazada.co.th/products/pdp-i4210060205.html",
        "sold": 61
    },
    {
        "product_name": "Nhaphatr Shop ตู้เหล็กใส่เอกสารหนา ตู้เหล็ก ตู้เก็บของ ตู้เหล็กเก็บของ ลิ้นชัก ลิ้นชักเก็บของ ตู้เหล็ก ตู้เก็บของใหญ่ ตู้เหล็กใส่ของ ตู้เหล",
        "product_image": "https://img.lazcdn.com/g/p/b461a9868ccff509285e385265679c1b.jpg_200x200q90.jpg",
        "price": 4998,
        "remark": "https://www.lazada.co.th/products/pdp-i4187957236.html",
        "sold": 5
    },
    {
        "product_name": "OUSHIDUN | ตู้ลิ้นชักเก็บของแบบมีกุญแจใต้โต๊ะทำงาน      29850",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc1b52ed3c4c143d2ace13d89c0817eada.jpg_200x200q90.jpg",
        "price": 4886.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16060029191.html",
        "sold": 0
    },
    {
        "product_name": "Isidoro ตู้เก็บเอกสารสำนักงาน ห้องเก็บเอกสาร ตู้เก็บเอกสาร ตู้เอกสารการเงิน การจัดเก็บ ลิ้นชักล็อคได้ ตู้เก็บของพร้อมชั้น",
        "product_image": "https://img.lazcdn.com/g/p/af4de574ef788b45eb495228eb0b2dca.jpg_200x200q90.jpg",
        "price": 4872,
        "remark": "https://www.lazada.co.th/products/pdp-i6028401838.html",
        "sold": 0
    },
    {
        "product_name": "ตู้เอกสารไม้ 80 ซม. รุ่น C 792WOS สีคาปู/ขาว [สินค้าไม่รวมประกอบ] |LAN|",
        "product_image": "https://img.lazcdn.com/g/p/ed54469148d64c669331583b5836e124.jpg_200x200q90.jpg",
        "price": 4790,
        "remark": "https://www.lazada.co.th/products/pdp-i2411102399.html",
        "sold": 4
    },
    {
        "product_name": "Locker Cabinet ตู้เอกสารเหล็ก ตู้เก็บของ ตู้เก็บเอกสาร ตู้เหล็กเอกสาร หลายชั้น ตู้ล๊อกเกอร์  ตู้เหล็กเก็บของ ล็อกเกอร์ตู้เสื้อผ้าเหล็ก ตู้โชว์กระจก ตู้อเนกประสงค์ mall",
        "product_image": "https://img.lazcdn.com/g/p/4a19de6e575c1444743e0efcf8a0c7b5.jpg_200x200q90.jpg",
        "price": 4658.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5394551336.html",
        "sold": 0
    },
    {
        "product_name": "MEIJIASIตู้เหล็ก ตู้เสื้อผ้าเหล็ก ตู้เก็บเอกสารเหล็ก ตู้เก็บของเหล็ก 8/12/18 กริด คณะรัฐมนตรี ตู้เสื้อผ้า ตู้เก็บของ ตู้ล็อคได้ มาพร้อมกุญแจ แพลตฟอร์มให้บริการติดตั้ง ร้านค้ามีการรับประกันสิบปี",
        "product_image": "https://img.lazcdn.com/g/p/0a4812d82feb85a518ab300793586fa3.png_200x200q90.png",
        "price": 4638,
        "remark": "https://www.lazada.co.th/products/pdp-i5802081748.html",
        "sold": 30
    },
    {
        "product_name": "IRONSERVICE : ตู้เก็บของ 2 ประตู :\" เฟอร์นิเจอร์ โครงเหล็กกันสนิม ตกแต่งภายในและภายนอก มีประกัน \" (จัดส่งรวดเร็ว)",
        "product_image": "https://img.lazcdn.com/g/p/55e92c1e36f3f5abc4953d3f7e340787.jpg_200x200q90.jpg",
        "price": 4583.76,
        "remark": "https://www.lazada.co.th/products/pdp-i5031800385.html",
        "sold": 3
    },
    {
        "product_name": "MEIJIASIตู้เก็บเอกสาร ตู้เก็บเอกสารเหล็ก คณะรัฐมนตรี เหล็กหนา กันขโมยและกันขโมย ตู้เหล็ก คณะรัฐมนตรี ตู้สำนักงาน ตู้ล็อคได้ มาพร้อมกุญแจ แพลตฟอร์มให้บริการติดตั้ง ร้านค้ามีการรับประกันสิบปี",
        "product_image": "https://img.lazcdn.com/g/p/615b459d45c7e69df9eb8bab8fca152e.png_200x200q90.png",
        "price": 4538,
        "remark": "https://www.lazada.co.th/products/pdp-i5802126085.html",
        "sold": 39
    },
    {
        "product_name": "Locker Cabinet ตู้เอกสารเหล็ก ตู้เก็บของ ตู้เก็บเอกสาร ตู้เหล็กเอกสาร หลายชั้น ตู้ล๊อกเกอร์  ตู้เหล็กเก็บของ ล็อกเกอร์ตู้เสื้อผ้าเหล็ก ตู้โชว์กระจก ตู้ ตู้อเนกประสงค์ orina",
        "product_image": "https://img.lazcdn.com/g/p/d62760e7ce40fcb6ba3754ddd74528ca.jpg_200x200q90.jpg",
        "price": 4258.28,
        "remark": "https://www.lazada.co.th/products/pdp-i5394506449.html",
        "sold": 34
    },
    {
        "product_name": "ตู้เก็บของ ตู้แบบมินิมอล ตู้เก็บอเนกประสงค์ ตู้ไม้ ตู้เก็บของ สไตล์นอร์ดิก ชั้นวางของ ตู้อเนกประสงค์ มีลิ้นชัก ไม้อัด MDF",
        "product_image": "https://img.lazcdn.com/g/p/40b4dccbaa6431a14ba96adae6cef35f.png_200x200q90.png",
        "price": 4168,
        "remark": "https://www.lazada.co.th/products/pdp-i3482949587.html",
        "sold": 126
    },
    {
        "product_name": "junhong |ตู้เก็บของพลาสติกสองประตูพับได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scd8c7c504ffe4ab995403e8c5ce01c28S.jpg_200x200q90.jpg",
        "price": 4165.38,
        "remark": "https://www.lazada.co.th/products/pdp-i5949720652.html",
        "sold": 5
    },
    {
        "product_name": "ส่งฟรี  ตู้ลิ้นชักเก็บของ 4 ชั้น ล้อคได้ รุ่น DW601",
        "product_image": "https://img.lazcdn.com/g/p/fe926effc1ef8bb6974b496d21dbb397.jpg_200x200q90.jpg",
        "price": 3990,
        "remark": "https://www.lazada.co.th/products/pdp-i4290543549.html",
        "sold": 0
    },
    {
        "product_name": "ตู้เก็บของ60ซม. ตู้ล็อกเกอร์ มีให้เลือก2,3,4ชั้น มี4สี [สินค้าพร้อมส่ง] Brownfurniture",
        "product_image": "https://img.lazcdn.com/g/p/f52d8ae81f278db115960127c9a12026.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i2492907132.html",
        "sold": 1
    },
    {
        "product_name": "MOOVE ตู้ลิ้นชัก4ชั้น CHIC 42x40x85 ลายไม้อ่อน",
        "product_image": "https://img.lazcdn.com/g/p/1db4c6fa30fe38fabf371f7b3e28fd3a.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5669508448.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ลิ้นชักเก็บของ ล็อคได้ 🌈มี7สี ขนาด60x42x83ซม. [สินค้าจัดส่งเป็นแพ็ค ลูกค้าประกอบเอง] BROWNFURNITURE",
        "product_image": "https://img.lazcdn.com/g/p/0e071e447d7bca0ceb61699b21766150.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i2383602877.html",
        "sold": 4
    },
    {
        "product_name": "ตู้เหล็ก ตู้เอนกประสงค์ ตู้เก็บของ ตู้ใส่ของ ตู้ใส่ของในออฟฟิศ ตู้หัวเตียง ทรงเตี้ย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S619a10efd9a54c209c245eb95787accbg.jpg_200x200q90.jpg",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i4809989137.html",
        "sold": 2
    },
    {
        "product_name": "ตู้ลิ้นชัก ตู้ชั้นเก็บของ ตู้เก็บของ ขนาด3/4/5/6ลิ้นชัก มีหลายขนาด มีลิ้นชัก จัดเก็บได้เยอะมาก กันน้ำ กันฝุ่น แข็งแรง ประกอบง่าย พร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/p/8a70bbc92810c5aca08bac0bda25b1db.png_200x200q90.png",
        "price": 3780,
        "remark": "https://www.lazada.co.th/products/pdp-i4429258745.html",
        "sold": 0
    },
    {
        "product_name": "ตู้เก็บเอกสาร  ตู้เก็บเอกสารสำนักงาน ตู้เก็บของ ตู้ล็อคได้ ตู้บานเปิด ขนาด 90*40*92CM.",
        "product_image": "https://img.lazcdn.com/g/p/99cef0af22132776e411ee58c3c7337a.jpg_200x200q90.jpg",
        "price": 3678,
        "remark": "https://www.lazada.co.th/products/pdp-i5804424917.html",
        "sold": 1
    },
    {
        "product_name": "ตู้เก็บของสำนักงานเคลื่อนย้ายได้พร้อมล็อค",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S994e33e331e64433b25c16ed9fb7e04eV.jpg_200x200q90.jpg",
        "price": 3482,
        "remark": "https://www.lazada.co.th/products/pdp-i5996926677.html",
        "sold": 0
    },
    {
        "product_name": "DECOS ตู้ล็อกเกอร์ 6 ช่อง 80 ซม. รุ่น LK-04 สีพรีเมียร์โอ๊ค [ไม่รวมประกอบ] |EA|",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S67c912aa94b84253ba0f41dacb42cf801.jpg_200x200q90.jpg",
        "price": 3442,
        "remark": "https://www.lazada.co.th/products/pdp-i5580376310.html",
        "sold": 0
    },
    {
        "product_name": "NAIJIA |ตู้เก็บของอเนกประสงค์สำหรับสำนักงาน รวมชั้นวางหนังสือและตู้เก็บเอกสาร 1112-P106-1-mq",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S878e2a01a21847a8a5ed5ffc2e3d3f19g.jpg_200x200q90.jpg",
        "price": 3416,
        "remark": "https://www.lazada.co.th/products/pdp-i5996922504.html",
        "sold": 1
    },
    {
        "product_name": "JIJIANG | ตู้ล็อคเก็บของแบบเคลื่อนที่ ตู้เอกสาร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scf8dad24ee774f5482260a46a9689c9dK.jpg_200x200q90.jpg",
        "price": 3382,
        "remark": "https://www.lazada.co.th/products/pdp-i16088586825.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ชั้นเก็บของ ตู้เก็บของ ตู้กั้นห้อง ขนาด60/80/90/100cm มีลิ้นชัก มีช่องเก็บของ มีชั้นเก็บของ ราคาถูก รับน้ำหนักได้มาก ช่องจัดเก็บเยอะ ราคาถูกสุด!! วัสดุทนรอยทนน้ำ สินค้าต้องประกอบเอง เก็บเงินปลายทางได้ พร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/p/06cc5e26cebc1f0a4cc9a7abad172709.png_200x200q90.png",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i4754815047.html",
        "sold": 1
    },
    {
        "product_name": "ตู้เก็บของ ตู้เก็บเอกสาร ตู้เก็บของไม้ ชั้นเก็บของ ตู้เก็บของกระจก ตู้หนังสือ ตู้ไม้เก็บเอกสาร ตู้เก็บของกระจก ตู้อเนกประสงค์ ตู้ไม้",
        "product_image": "https://img.lazcdn.com/g/p/cd5c3cf04e18c19823bc1c861d529796.png_200x200q90.png",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i4557144826.html",
        "sold": 0
    },
    {
        "product_name": "Besta ตู้เก็บเอกสาร ชั้นล็อกเกอร์ บ็อกซ์ 60 4 กุญแจมี 2 สี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf2bb7882fb4e4a04ad315b50ac91cf41r.jpg_200x200q90.jpg",
        "price": 3380,
        "remark": "https://www.lazada.co.th/products/pdp-i2266116997.html",
        "sold": 7
    },
    {
        "product_name": "MOLESUN ตู้เก็บของ ใช้งานได้อเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/p/e6074b1007e8933bd2f7da48121a7e29.jpg_200x200q90.jpg",
        "price": 3358,
        "remark": "https://www.lazada.co.th/products/pdp-i5333826841.html",
        "sold": 0
    },
    {
        "product_name": "ZHUOHE | ตู้เก็บของใต้โต๊ะแบบลิ้นชัก",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scae2ef2113c84d5883cab26074866e7a8.png_200x200q90.png",
        "price": 3331.82,
        "remark": "https://www.lazada.co.th/products/pdp-i16049455287.html",
        "sold": 3
    },
    {
        "product_name": "ตู้ล็อคเกอร์ 4 ชั้น กว้าง 60 ซม. ลึก 40 ซม. มีกุญแจล็อค ( สินค้าส่งเป็นแพ็คกล่อง / ลูกค้าประกอบเอง ) ไม้หนาแข็งแรง ผลิตในไทย",
        "product_image": "https://img.lazcdn.com/g/p/af6f7ec78cc0568ceeb5dc01eb90eefa.png_200x200q90.png",
        "price": 3200,
        "remark": "https://www.lazada.co.th/products/pdp-i4881723455.html",
        "sold": 2
    },
    {
        "product_name": "ตู้ล็อกเกอร์60ซม. ตู้เเก็บของ🌈มี3ขนาดความสูง  [สินค้ามีพร้อมส่ง] brownfurniture",
        "product_image": "https://img.lazcdn.com/g/p/ddd6944b71e258e52c930760fd71a38f.jpg_200x200q90.jpg",
        "price": 3180,
        "remark": "https://www.lazada.co.th/products/pdp-i1758066941.html",
        "sold": 0
    },
    {
        "product_name": "TATA ตู้เก็บเอกสาร ตู้เหล็กใส่ของ ตู้ลิ้นชัก มีกุญแจล็อค ล็อครหัสผ่าน อเนกประสงค์ มีล้อ ตู้เก็บของ ตู้เหล็กเอกสาร",
        "product_image": "https://img.lazcdn.com/g/p/324160bfd47b806d1c2370ef83c3f342.jpg_200x200q90.jpg",
        "price": 3178,
        "remark": "https://www.lazada.co.th/products/pdp-i5440891751.html",
        "sold": 22
    },
    {
        "product_name": "ZHENTAIYUAN | ตู้เก็บของมีลิ้นชักล็อค พร้อมล้อเลื่อนใต้โต๊ะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Saaf27b9640d64a0c9639095a555131d95.jpg_200x200q90.jpg",
        "price": 3011.62,
        "remark": "https://www.lazada.co.th/products/pdp-i16086730776.html",
        "sold": 0
    },
    {
        "product_name": "ANYHOME ตู้เก็บของ 4 ชั้น 60-4 สีขาว",
        "product_image": "https://img.lazcdn.com/g/p/0b0ceb75b8c9a05e1ad933ef367c525b.jpg_200x200q90.jpg",
        "price": 2980,
        "remark": "https://www.lazada.co.th/products/pdp-i5911252384.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ลิ้นชักไม้สำหรับเอกสาร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4f103b470c7044dc97fd25ceff8ad52fP.jpg_200x200q90.jpg",
        "price": 2895.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16066210261.html",
        "sold": 0
    },
    {
        "product_name": "ตู้เก็บของแบบเลื่อนประตู",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sea1a37f1a7d8408f831f1bd3c46d7a46D.jpg_200x200q90.jpg",
        "price": 2870.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5926574131.html",
        "sold": 0
    },
    {
        "product_name": "ตู้เก็บของ ตู้หนังสือ ตู้วางหนังสือ ชั้นวางหนังสือ ตู้โชว์ ตู้ไม้ ตู้เก็บของอเนกประสงค์",
        "product_image": "https://img.lazcdn.com/g/p/5ec7417eb089421d0667ab4069f0b9d2.jpg_200x200q90.jpg",
        "price": 2777.36,
        "remark": "https://www.lazada.co.th/products/pdp-i4176587402.html",
        "sold": 18
    },
    {
        "product_name": "CHUMX | ตู้เก็บของแบบลิ้นชักสำหรับมือถือ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd9812a8e87f5492c9c4f21b8d8a07e7fM.jpg_200x200q90.jpg",
        "price": 2769.42,
        "remark": "https://www.lazada.co.th/products/pdp-i5910792650.html",
        "sold": 73
    },
    {
        "product_name": "ตู้บานเปิด 2 ชั้น โครงทึบ Leaf KASSA HOME รุ่น ZKG-Clear Vid-V.2 ขนาด 70 x 50 x 82 ซม. สีขาว - เทา",
        "product_image": "https://img.lazcdn.com/g/p/9b7e9092202ff7426d929f0fb92a39a0.jpg_200x200q90.jpg",
        "price": 2740,
        "remark": "https://www.lazada.co.th/products/pdp-i5952813252.html",
        "sold": 1
    },
    {
        "product_name": "ตู้เก็บของใต้โต๊ะแบบลิ้นชักที่สามารถเคลื่อนย้ายได้และมีกุญแจล็อค",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd2c79bf9f61c48bda48e0a2d56d79414c.jpg_200x200q90.jpg",
        "price": 2651.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16065650802.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ล็อคเกอร์ 3 ชั้น กว้าง 60 ซม. ลึก 40 ซม. มีกุญแจล็อค ( สินค้าส่งเป็นแพ็คกล่อง / ลูกค้าประกอบเอง ) ไม้หนาแข็งแรง ผลิตในไทย",
        "product_image": "https://img.lazcdn.com/g/p/cb79134f66198e318e7b56b18a34f33c.png_200x200q90.png",
        "price": 2600,
        "remark": "https://www.lazada.co.th/products/pdp-i4881807475.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ลิ้นชักเอนกประสงค์(มีกุญแจล็อคได้ทุกลิ้นชัก)(สินค้าจัดส่งแบบประกอบเป็นใบแล้ว)(ready)",
        "product_image": "https://img.lazcdn.com/g/p/37c79253eeb45a87b2d6cff312170463.jpg_200x200q90.jpg",
        "price": 2598,
        "remark": "https://www.lazada.co.th/products/pdp-i406142257.html",
        "sold": 1
    },
    {
        "product_name": "OYIla | ตู้เก็บของแบบมีล้อและล็อคได้ ขนาดหนา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9dce819e6976485d860454fd4a604f99C.png_200x200q90.png",
        "price": 2569.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16052636362.html",
        "sold": 0
    },
    {
        "product_name": "Carlino: ตู้สูง ตู้เก็บเอกสาร ตู้สำนักงาน ตู้โชว์กระจก ตู้เก็บของ ตู้อเนกประสงค์ ชั้นวางหนังสือ/Billy 5 tier Cabnet",
        "product_image": "https://img.lazcdn.com/g/p/83ba0d15ed2126c4caba84f9e8212247.jpg_200x200q90.jpg",
        "price": 2560,
        "remark": "https://www.lazada.co.th/products/pdp-i5512300538.html",
        "sold": 1
    },
    {
        "product_name": "OUFENGHUADU |  ตู้เก็บเอกสารใต้โต๊ะ",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S2d6dcf3f9bd44265b6cdf8142889de83y.jpg_200x200q90.jpg",
        "price": 2528,
        "remark": "https://www.lazada.co.th/products/pdp-i6027519316.html",
        "sold": 1
    },
    {
        "product_name": "ตู้ไม้ ตู้ไม้เก็บของ ตู้ลิ้นชัก 5 ชั้น ขนาดหน้ากว้าง 23 x ลึก 15 x สูง 36 ซม. ไม้สัก สีน้ำตาลโอ๊ค",
        "product_image": "https://img.lazcdn.com/g/p/2b792038e451e615094373d7d1e614e3.jpg_200x200q90.jpg",
        "price": 2398,
        "remark": "https://www.lazada.co.th/products/pdp-i4325782361.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ไม้ ตู้ไม้เก็บของ สีเนื้อไม้สัก ลิ้นชัก 5 ชั้น ขนาดหน้ากว้าง 23 x ลึก 15 x สูง 36 ซม.",
        "product_image": "https://img.lazcdn.com/g/p/da10107b46ebd8c928c20abd0e060cf9.jpg_200x200q90.jpg",
        "price": 2390,
        "remark": "https://www.lazada.co.th/products/pdp-i4329763278.html",
        "sold": 0
    },
    {
        "product_name": "ตู้เก็บของ ชั้นวางของ 5 ช่อง ขนาด 60 ซม. DH สีพรีเมียร์โอ๊ค",
        "product_image": "https://img.lazcdn.com/g/p/e1dde83a4a5eebf0e5cc88648955d667.jpg_200x200q90.jpg",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i2789615515.html",
        "sold": 0
    },
    {
        "product_name": "Hom heart ตู้เก็บของ ตู้ลิ้นชัก ตู้อเนกประสงค์ ตู้เก็บของอเนกประสงค์ สีขาวธรรมชาติ 80 ซม./120 ซม. มี 2 ขนาด",
        "product_image": "https://img.lazcdn.com/g/p/14f44ab32f054918e2b05a621e64e893.jpg_200x200q90.jpg",
        "price": 2213.48,
        "remark": "https://www.lazada.co.th/products/pdp-i4175265183.html",
        "sold": 33
    },
    {
        "product_name": "Hom heart ตู้เก็บของ ชั้นวางของ ตู้เก็บเอกสาร ตู้ลิ้นชัก ชั้นเก็บของ ตู้ไม้เอนกประสงค์  ลิ้นชัก 6ชั้น แข็งแรง ทนทาน มี4รุ่น",
        "product_image": "https://img.lazcdn.com/g/p/bd00039ba1a0457ddd4dbfff60cbae88.jpg_200x200q90.jpg",
        "price": 2213.48,
        "remark": "https://www.lazada.co.th/products/pdp-i4175216312.html",
        "sold": 80
    },
    {
        "product_name": "Besee | ตู้เก็บของสไตล์วินเทจอเมริกันสำหรับห้องนั่งเล่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S626c6c1fed7e4f45a1ae1277b727076ev.jpg_200x200q90.jpg",
        "price": 2205.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5934731438.html",
        "sold": 0
    },
    {
        "product_name": "ตู้ลิ้นชักสีพาสเทล (มีล้อ) รุ่น KS (หน้ากว้างกว่าเดิม)",
        "product_image": "https://img.lazcdn.com/g/p/0877a4ccf9286b8b5f97e865ed5e63f9.jpg_200x200q90.jpg",
        "price": 2118,
        "remark": "https://www.lazada.co.th/products/pdp-i5068442518.html",
        "sold": 20
    },
    {
        "product_name": "70cmตู้เก็บเอกสาร ตู้เก็บเอกสารสำนักงานตู้เก็บของพร้อมล็อค ตู้เก็บของสำนักงาน ตู้เก็บของบ้าน ตู้เก็บเอกสารใต้โต๊ะ",
        "product_image": "https://img.lazcdn.com/g/p/de1efdcd12a5224cb1e711825407a904.jpg_200x200q90.jpg",
        "price": 2092,
        "remark": "https://www.lazada.co.th/products/pdp-i5856782262.html",
        "sold": 4
    },
    {
        "product_name": "ตู้เก็บของสารพัดประโยชน์สำหรับขนม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S59fc39215bac4a0fb530b62fd6169158X.jpg_200x200q90.jpg",
        "price": 2009.74,
        "remark": "https://www.lazada.co.th/products/pdp-i5874347245.html",
        "sold": 12
    },
    {
        "product_name": "ตู้ล็อคเกอร์ 2 ชั้น กว้าง 60 ซม. ลึก 40 ซม. มีกุญแจล็อค ( สินค้าส่งเป็นแพ็คกล่อง / ลูกค้าประกอบเอง ) ไม้หนาแข็งแรง ผลิตในไทย",
        "product_image": "https://img.lazcdn.com/g/p/cf94533d14ec26ca16eb08a5e4e38fb4.png_200x200q90.png",
        "price": 2000,
        "remark": "https://www.lazada.co.th/products/pdp-i4881974152.html",
        "sold": 1
    },
    {
        "product_name": "monqiqi ตู้เหล็กเอกสาร 3/5/6ชั้น พร้อมล็อคและล้อ ตู้ชั้นเก็บของ ลิ้นชักโลหะ ตู้เอกสารลิ้นชักหลายชั้นโต๊ะข้างเตียงโฮมออฟฟิ",
        "product_image": "https://img.lazcdn.com/g/p/68ec6cc310a391958940077f757f4b1c.jpg_200x200q90.jpg",
        "price": 1998,
        "remark": "https://www.lazada.co.th/products/pdp-i5874956803.html",
        "sold": 0
    },
    {
        "product_name": "ตู้เก็บของอเนกประสงค์ ตู้เก็บของ ตู้เก็บเอกสาร ขนาด 40 ซม. ทำมาจากไม้ปาติเคิลบอร์ด เล็กกระทัดรัด แข็งแรง ทนทาน สินค้าคุณภาพ พร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/p/2b5545975e2e9982c67cb4618110b99a.jpg_200x200q90.jpg",
        "price": 1998,
        "remark": "https://www.lazada.co.th/products/pdp-i4726028642.html",
        "sold": 2
    },
    {
        "product_name": "ตู้ลิ้นชักเอนกประสงค์มีล้อเลื่อนได้(มีกุญแจล็อคได้ทุกลิ้นชัก)(สินค้าจัดส่งแบบประกอบเป็นใบแล้ว)(ready)",
        "product_image": "https://img.lazcdn.com/g/p/1ea363e531215cd541724ebe1c4587a8.png_200x200q90.png",
        "price": 1998,
        "remark": "https://www.lazada.co.th/products/pdp-i569930101.html",
        "sold": 11
    },
    {
        "product_name": "QICAIKAOLA | ตู้เอกสารไม้พร้อมล็อค",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S73f3ac56eb414dd98c8645ba38680d81N.jpg_200x200q90.jpg",
        "price": 1959.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16099839145.html",
        "sold": 0
    },
    {
        "product_name": "MEIZHUFU | ลิ้นชักเก็บเอกสารหลายชั้นแบบเคลื่อนย้ายได้ใต้โต๊ะ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc39d4bab82f141d2929bbb02b863ba4cs.jpg_200x200q90.jpg",
        "price": 1940.68,
        "remark": "https://www.lazada.co.th/products/pdp-i5909489586.html",
        "sold": 3
    },
    {
        "product_name": "ตู้เก็บเอกสารเคลื่อนที่ใต้โต๊ะทำงาน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb78861caacb74b96b04ffebac431f052X.jpg_200x200q90.jpg",
        "price": 1882,
        "remark": "https://www.lazada.co.th/products/pdp-i6026179056.html",
        "sold": 0
    },
    {
        "product_name": "ลิ้นชัก ตู้เก็บของ ตู้อเนกประสงค์ ตู้ลิ้นชักไม้ ลิ้นชักเก็บของ ชั้นวางของ ตู้จัดเก็บของ สไตล์มินิมอล จุของได้เยอะ เนื้อไม้ดี ทนทาน",
        "product_image": "https://img.lazcdn.com/g/p/eb1d35d587e34f921ba1a4b64f08d515.png_200x200q90.png",
        "price": 1880,
        "remark": "https://www.lazada.co.th/products/pdp-i4621289277.html",
        "sold": 69
    },
    {
        "product_name": "ตู้เก็บของสำนักงาน วัสดุเป็นไม้ เก็บของได้เยอะ จัดเก็บเอกสารสำคัญ มีกุญแจล็อค  แข็งแรง คุณภาพดี จัดส่งไว แนะนำ",
        "product_image": "https://img.lazcdn.com/g/p/80820efd1e34b4342de61a4ae016bda7.jpg_200x200q90.jpg",
        "price": 1838,
        "remark": "https://www.lazada.co.th/products/pdp-i5322194917.html",
        "sold": 7
    },
    {
        "product_name": "ตู้เก็บของ ตู้เก็บเอกสาร ชั้นวางของ หลากหลายฟังก์ชั่น เฟอร์นิเจอร์สำนักงาน แข็งแรง คุณภาพดี จัดเก็บเอกสารสำคัญ มีกุญแจล็อค",
        "product_image": "https://img.lazcdn.com/g/p/ec46c3fa2ae3d27a57bccc2ae91914a3.jpg_200x200q90.jpg",
        "price": 1838,
        "remark": "https://www.lazada.co.th/products/pdp-i5322181623.html",
        "sold": 6
    },
    {
        "product_name": "TV cabinet teak wood rattan door 1.5m long ตู้หวาย มินิ มอล ตู้เก็บของหวาย ไม้สักแท้100% ยาว 1.5 เมตร Free Delivery",
        "product_image": "https://img.lazcdn.com/g/p/d2fa3d95b71e90f5424bb12131b3cea1.jpg_200x200q90.jpg",
        "price": 1800,
        "remark": "https://www.lazada.co.th/products/pdp-i5593039672.html",
        "sold": 0
    },
    {
        "product_name": "KIMDELIN ครัวตู้เก็บของไม้ไผ่คริลิคแสดงตู้เก็บของไม้",
        "product_image": "https://img.lazcdn.com/g/p/f945204ea99d5163268c6326decd2223.jpg_200x200q90.jpg",
        "price": 1798.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5331877174.html",
        "sold": 101
    },
    {
        "product_name": "ตู้เก็บของ ตู้เอกสาร ตู้เก็บของสำนักงาน ตู้หนังสือ ชั้นวางหนังสือ ตั้งรหัสประตูได้ ห้องนั่งเล่นห้องทำงานเรียบง่าย ประหยัดพื้นที่ใช้สอย",
        "product_image": "https://img.lazcdn.com/g/p/47c0df12f9cbcf5e0f8e5156b96f355d.jpg_200x200q90.jpg",
        "price": 1798,
        "remark": "https://www.lazada.co.th/products/pdp-i5784037677.html",
        "sold": 0
    },
    {
        "product_name": "ตู้เก็บของ ลิ้นชัก100/120cm ตู้เก็บเอกสาร สำนักงาน เก็บอุปกรณ์  Filing cabinet",
        "product_image": "https://img.lazcdn.com/g/p/2150919bb9b632f3b0f1c839540bee76.png_200x200q90.png",
        "price": 1798,
        "remark": "https://www.lazada.co.th/products/pdp-i5671411501.html",
        "sold": 0
    },
    {
        "product_name": "3/5/6 ชั้น ตู้เก็บของเหล็ก ตู้เก็บเอกสาร สำนักงาน เก็บอุปกรณ์ มีล้อ เลื่อนได้ ตู้ข้างเตียง ใช้ได้หลายสถานการณ์ มีให้เลือก 2 สี",
        "product_image": "https://img.lazcdn.com/g/p/8210ee3a59d1ac20353d2898a9d904b5.jpg_200x200q90.jpg",
        "price": 1795.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5797883394.html",
        "sold": 0
    },
    {
        "product_name": "TATA ไม้เนื้อแข็งตู้ลิ้นชักส ลิ้นชักใส่ของ ตู้เตี้ย ตู้ทรงเตี้ย5/4/3ชั้น ชั้นลิ้นชักบ้านออกแบบสง่างามสไตล์ที่น้อยที่สุดไม้เนื้อแข็ง",
        "product_image": "https://img.lazcdn.com/g/p/127ec26d9b342026d69cbf4ce58f879d.jpg_200x200q90.jpg",
        "price": 1787.84,
        "remark": "https://www.lazada.co.th/products/pdp-i6011874228.html",
        "sold": 0
    },
    {
        "product_name": "ไฟเส้นแถบเปลี่ยนสีได้ ใช้ได้ทั้งภายนอกและภายในกันแดดกันฝน สำหรับตกแต่งบ้าน RGB Led Strip Light 5050 Three Row 220V LED",
        "product_image": "https://img.lazcdn.com/g/p/4e36bf5aeadc35386b68ffa6e456aa47.jpg_200x200q90.jpg",
        "price": 11180,
        "remark": "https://www.lazada.co.th/products/pdp-i4872637967.html",
        "sold": 0
    },
    {
        "product_name": "LED Strip Light COB IP65 220V 100M ไฟเส้นแอลอีดี สวย สว่าง สมูท IP65 กันน้ำ ยกม้วน 100 เมตร+หัวจ่าย5ชุด",
        "product_image": "https://img.lazcdn.com/g/p/573ffcf3f0d400952dec3617893be446.jpg_200x200q90.jpg",
        "price": 8300,
        "remark": "https://www.lazada.co.th/products/pdp-i5857897635.html",
        "sold": 0
    },
    {
        "product_name": "ไฟเส้น LED Striplight 5050 220V RGB เปลี่ยนสีได้ 100เมตร ไฟสายยาง กันน้ำ ไฟประดับ ราคาส่ง สอบถามได้นะคะ",
        "product_image": "https://img.lazcdn.com/g/p/6cdb063c5ca223afabaf5f739a992619.jpg_200x200q90.jpg",
        "price": 6974,
        "remark": "https://www.lazada.co.th/products/pdp-i3122966687.html",
        "sold": 19
    },
    {
        "product_name": "ไฟเส้น ไฟสายยาง Led Stripไฟสายยางท่อแบน SMD 220v  IP67 ไฟเส้นประดับตกแต่ง (100 เมตร)(แถมฟรี ปลั๊กหัวจ่าย 2ตัว)",
        "product_image": "https://img.lazcdn.com/g/p/d4c77090671c6d402293257c4f9c43d9.jpg_200x200q90.jpg",
        "price": 5124.6,
        "remark": "https://www.lazada.co.th/products/pdp-i4135620337.html",
        "sold": 78
    },
    {
        "product_name": "FANYAO | แถบไฟ LED กันน้ำสว่างสุดๆ สองด้าน วงกลม 220V",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8ff32d5bacdf4ab4bf167edc99782fffb.jpg_200x200q90.jpg",
        "price": 2533.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5948805903.html",
        "sold": 7
    },
    {
        "product_name": "FANYAO | เส้นไฟ LED สว่างมากกันน้ำ 220v",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd52e0c491f3f4f0296fdf3a3fee2bb15r.jpg_200x200q90.jpg",
        "price": 2488.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5893334171.html",
        "sold": 27
    },
    {
        "product_name": "ไฟแถบ LED นีออน RGB IC DC 24V กันน้ำ ควบคุมผ่านแอพบลูทูธและรีโมทคอนโทรล ไฟตกแต่งห้อง 5M 10M 15M 20M ริบบิ้น LED RGB",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7eb0683d292a442aa0e3566fe7d37c7al.jpg_200x200q90.jpg",
        "price": 2196.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5918343095.html",
        "sold": 0
    },
    {
        "product_name": "บลูทูธ RGB COB LED Strip Light USB 5V ความหนาแน่นสูง 576 LEDs/M หรี่แสงได้แสงเชิงเส้นพร้อม 24key รีโมทคอนโทรล IR App Contro",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2779277773d540ceb29254ccf6e6649aa.jpg_200x200q90.jpg",
        "price": 1534.34,
        "remark": "https://www.lazada.co.th/products/pdp-i6032650954.html",
        "sold": 2
    },
    {
        "product_name": "ไฟแถบไฟ LED Wi-Fi COB CCT 12V 1M 2M 3M 4M 5M 10M WWWW ตกแต่งหลอดไฟแบบหรี่ได้สีอบอุ่นยืดหยุ่นสำหรับ Alexa Google Assistant/Tuya",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb7c23d2fec194febb3f1ae19fd2bf136F.jpg_200x200q90.jpg",
        "price": 1529.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5997396356.html",
        "sold": 0
    },
    {
        "product_name": "AC 220V LED Strip 5M 10M 20M 50M IP44 ยืดหยุ่น LED เทปริบบิ้น 2835 120 LEDs/M Stripe Light พร้อมกาวสําหรับตกแต่งบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9643de0ff0124957bd36adc7a6b2ca55D.jpg_200x200q90.jpg",
        "price": 1519.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5832334193.html",
        "sold": 0
    },
    {
        "product_name": "ไฟ LED แถบ RGBIC แบบกันน้ำ ใช้กับ WiFi 12V ความยาว 2 ม. 3 ม. 5 ม. 10 ม. ปรับแต่งสีได้เอง สำหรับงานปาร์ตี้ ห้องเล่นเกม ควบคุมด้วยรีโมท รองรับ Alexa และ Google Home",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S895508c512184bea9ff26a03decf89cbb.jpg_200x200q90.jpg",
        "price": 1506.92,
        "remark": "https://www.lazada.co.th/products/pdp-i6016971952.html",
        "sold": 0
    },
    {
        "product_name": "แถบไฟ LED COB สว่างพิเศษ ขนาด 30 มม. ความสว่าง 1600LED/เมตร ใช้ไฟ DC24V เหมาะสำหรับใช้ในอาคาร ไฟแบ็คไลท์ทีวี แถบไฟ LED แบบยืดหยุ่น",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S07f3063f97084216b08eb72c05224d07l.jpg_200x200q90.jpg",
        "price": 1449.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5959779857.html",
        "sold": 0
    },
    {
        "product_name": "ไฟแถบไฟ LED 220โวลต์0.5ม. 5ม. 10ม. 20ม. 25ม. 30ม. 40ม. 2835 120แอลอีดีเทปกาวไฟริบบิ้นกันน้ำ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4c88730a40ee4e55900284fdc8146a11R.jpg_200x200q90.jpg",
        "price": 1448.38,
        "remark": "https://www.lazada.co.th/products/pdp-i5945614306.html",
        "sold": 0
    },
    {
        "product_name": "ไฟแถบ LED RGBIC COB 12V ควบคุมผ่านแอป Tuya Smart Life รองรับ WS2811 IC แบบยืดหยุ่น ปรับแต่งได้ ใช้กับ Alexa และ Google",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3427de0737384a4c934bd9ec4b72857aS.jpg_200x200q90.jpg",
        "price": 1424.46,
        "remark": "https://www.lazada.co.th/products/pdp-i5964570154.html",
        "sold": 0
    },
    {
        "product_name": "【พร้อมส่ง】 แถบไฟ  แถบไฟ led กันน้ำ  ไฟเส้น LED  กันน้ำรถแถบไฟ  ไฟแถบ LED นีออนสีสวย กันน้ำ แรงดัน 220V เสียบไฟบ้านได้",
        "product_image": "https://img.lazcdn.com/g/p/bbc15b316d90cb1773ffcbc11555c728.jpg_200x200q90.jpg",
        "price": 1390,
        "remark": "https://www.lazada.co.th/products/pdp-i4436761395.html",
        "sold": 116
    },
    {
        "product_name": "ไฟแถบ LED DC 12V 24V RGBW/RGBWW ชิป 4-in-1 SMD 5050 108 120LEDs/เมตร แบบยืดหยุ่น สำหรับตกแต่งห้องนั่งเล่น ห้องนอน และบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb9646541169649f8986198a444546575D.jpg_200x200q90.jpg",
        "price": 1375.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6078340367.html",
        "sold": 0
    },
    {
        "product_name": "ไฟ LED แถบยาว 5-20 เมตร 12V รุ่น 5050 RGB RGBW RGBWW ควบคุมผ่านแอพ WiFi  60 หลอด/เมตร ปรับความสว่างได้  แบบยืดหยุ่น  รองรับ Alexa",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S52afae4d0c3f4ef5b01c8007272dfbbde.jpg_200x200q90.jpg",
        "price": 1304.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16064655884.html",
        "sold": 0
    },
    {
        "product_name": "🔥รับประกัน1ปี🔥10/15/20/30M 220V ไฟแถบ LED RGB บลูทูธ/รีโมทคอนโทรล SMD 5050 Waterproof ตกแต่งกลางแจ้ง / ในร่ม ของขวัญแสงสว่าง ในสวนหลังบ้าน/ห้องครัว/ห้องนอน",
        "product_image": "https://img.lazcdn.com/g/p/bac0aacc55a9d269f81235cce5fb59b0.png_200x200q90.png",
        "price": 1278,
        "remark": "https://www.lazada.co.th/products/pdp-i4644230143.html",
        "sold": 49
    },
    {
        "product_name": "ไฟแถบ LED Tuya Wifi 12V RGB SMD 5050 RGBCCT แบบยืดหยุ่น พร้อมเซ็นเซอร์ตรวจจับความเคลื่อนไหว PIR ปรับความสว่างได้ สำหรับห้องนอน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7673cf3d852948bbb190c54d761dcf12W.jpg_200x200q90.jpg",
        "price": 1252.16,
        "remark": "https://www.lazada.co.th/products/pdp-i5939060470.html",
        "sold": 0
    },
    {
        "product_name": "ไฟแถบนีออน LED ตัดได้ไฟนีออนแคบแบบยืดหยุ่น ยาว 5-30 เมตร พร้อมปลั๊ก ดัดงอได้ สีสวยกันน้ำแรงดัน 220V",
        "product_image": "https://img.lazcdn.com/g/p/38e909e97c55e497fe2744a59ec266c8.png_200x200q90.png",
        "price": 1218,
        "remark": "https://www.lazada.co.th/products/pdp-i6044412715.html",
        "sold": 1
    },
    {
        "product_name": "ไฟแต่งห้อง พร้อมส่งในประเทศไทย จัดส่งรวดเร็ว ไฟติดห้อง ไฟเส้นเปลี่ยนสีได้ ขนาด 10/15/20/30M รุ่น5050 ไฟเส้น RGB ไฟริบบิ้น ไฟตกแต่งห้อง LED Strip Light IP65 ไฟตกแต่ง รีโมท",
        "product_image": "https://img.lazcdn.com/g/p/c9cb8f99ac1a78c27eebbde6302af775.jpg_200x200q90.jpg",
        "price": 1214.1,
        "remark": "https://www.lazada.co.th/products/pdp-i4707022338.html",
        "sold": 14
    },
    {
        "product_name": "ไฟ LED แบบ COB แถบยืดหยุ่น DC12V 24V พร้อมสาย 2PIN /DC กันน้ำระดับ IP67 สำหรับตกแต่งบ้านภายนอกอาคาร แสงนีออนแบบริบบิ้น 3000K 4000K 6000K",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S990b92fcd23c427b83cc4ea7d6c20757w.jpg_200x200q90.jpg",
        "price": 1205.88,
        "remark": "https://www.lazada.co.th/products/pdp-i5976143257.html",
        "sold": 0
    },
    {
        "product_name": "480LED แสงแถบไฟ Led 12V 24V 2835 /M สว่างสุดๆยาว5เมตรเทปแถบไฟ Led อียืดหยุ่นสองแถวไม่กันน้ำตกแต่งไฟ",
        "product_image": "https://img.lazcdn.com/g/p/6c386625b81c52653e1c91f83be57162.jpg_200x200q90.jpg",
        "price": 1200,
        "remark": "https://www.lazada.co.th/products/pdp-i4281630667.html",
        "sold": 80
    },
    {
        "product_name": "220V ไฟ LED Strip แถบไฟกันน้ำ ไฟนางฟ้า ไฟในห้อง แถบไฟสองแถวที่ยืดหยุ่นได้ Bluetooth รีโมท ตกแต่งคริสต์มาส สีขาวนวล/สีขาวนวล SMD 2835 120Leds/m 10/15/20/30m",
        "product_image": "https://img.lazcdn.com/g/p/c675ca2bf59190e945241263710f1df9.jpg_200x200q90.jpg",
        "price": 1164.06,
        "remark": "https://www.lazada.co.th/products/pdp-i4829416698.html",
        "sold": 43
    },
    {
        "product_name": "Tuya ไฟแถบไฟนีออน Wifi อัจฉริยะ24V หรี่แสงได้ RGB เพลงไฟ LED เทปปากการูปหัวใจห้องนอนอุปกรณ์ตกแต่งสวนกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/d951b673c770537a0184b3f9ee31224e.jpg_200x200q90.jpg",
        "price": 1141.56,
        "remark": "https://www.lazada.co.th/products/pdp-i5162642447.html",
        "sold": 15
    },
    {
        "product_name": "10/15/20/30M 220V ไฟแถบ LED RGB บลูทูธ/รีโมทคอนโทรล SMD 5050 Waterproof ตกแต่งกลางแจ้ง / ในร่ม ของขวัญแสงสว่าง ในสวนหลังบ้าน/ห้องครัว/ห้องนอน LED RGB Strip",
        "product_image": "https://img.lazcdn.com/g/p/8b7322ff07f9555e73c8a80f5d06fd2e.png_200x200q90.png",
        "price": 1133.72,
        "remark": "https://www.lazada.co.th/products/pdp-i4695125478.html",
        "sold": 1052
    },
    {
        "product_name": "5M 12V 24V COB LED Strip Light RGB RGBW RGBCCT CCT ริบบิ้นยืดหยุ่น 320LEDs 784LEDs 840LEDs warm Cool สีขาวธรรมชาติ Linear โคมไฟ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb996568abd8a43fc98aa9caac06ce4471.jpg_200x200q90.jpg",
        "price": 1131.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5722583618.html",
        "sold": 0
    },
    {
        "product_name": "ไฟแถบ LED COB ปรับความสว่างได้ 10M 5M CCT 2700K-6500K แสงขาวน้ำเงิน-ขาวธรรมชาติ-ขาวอบอุ่น เปลี่ยนสีได้ 576LEDs/M ความสว่างสูง พร้อมรีโมทคอนโทรล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2abb46fb2be84fa09f27f5f923956299B.jpg_200x200q90.jpg",
        "price": 1112.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5938939772.html",
        "sold": 0
    },
    {
        "product_name": "ไฟ LED lybmtwf สำหรับ21319โคมไฟ Perk กลางบล็อกตัวต่ออิฐ (ไม่รวมรุ่นบล็อก)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0fd8d9bfd9e54ef5ad27a56497e9bbddr.png_200x200q90.png",
        "price": 1103.18,
        "remark": "https://www.lazada.co.th/products/pdp-i16099562371.html",
        "sold": 0
    },
    {
        "product_name": "หลอด Backlight Toshiba ใหม่ 40PU200T 40PB200T 5×14LED",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S63a4fafb51474ba4ad20f567fe059fd7O.jpg_200x200q90.jpg",
        "price": 1100,
        "remark": "https://www.lazada.co.th/products/pdp-i5772430636.html",
        "sold": 5
    },
    {
        "product_name": "หลอดไฟ LED แถบยาว 3 ป้องกัน หลอดไฟดูดฝุ่น แสงสว่างสูง แถบบาง หลอดไฟกลางแจ้ง ชุดเต็มรูปแบบ สำหรับใช้ในบ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sca006b442c87441096c5d80b16011e58T.jpg_200x200q90.jpg",
        "price": 1086,
        "remark": "https://www.lazada.co.th/products/pdp-i6066522900.html",
        "sold": 0
    },
    {
        "product_name": "ไฟแถบนีออน neon flex มีสวิทช์ เปิด/ปิด ไฟเส้นนีออนกันน้ำ ไฟLED 220V รุ่นใหม่ 2835 120เม็ด/เมตร ความยาว 10/15/20 เมตร แสงวอร์มไวท์และแสงขาว พร้อมปลั๊กและหัวปิด",
        "product_image": "https://img.lazcdn.com/g/p/5e0efef90b91f47771b0c3e07aef2293.png_200x200q90.png",
        "price": 1078,
        "remark": "https://www.lazada.co.th/products/pdp-i5278220852.html",
        "sold": 7
    },
    {
        "product_name": "ไฟแถบ LED อินเทอร์เฟซ 24V DC พร้อมกาวในตัว, ไฟนีออนแบบ COB แทนแถบไฟ 1-10 เมตร สำหรับตกแต่งห้อง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S757e3e476a5a4cc994e11fa1c67ea873o.jpg_200x200q90.jpg",
        "price": 1053.72,
        "remark": "https://www.lazada.co.th/products/pdp-i5981899142.html",
        "sold": 1
    },
    {
        "product_name": "BUNISE เต็นท์กลางแจ้งทรงพีระมิดอินเดียน ทรงหมวกกว้าง สไตล์แคมป์ลักซ์ชัวรี เหมาะสำหรับร้านอาหาร ลานกางเต็นท์ งานเอ็กซ์โป และแหล่งท่องเที่ยว รุ่น P2418 จัดส่งฟรีทั่วไทย",
        "product_image": "https://img.lazcdn.com/g/p/42159ed7eb13b314a9069732f189c38f.jpg_200x200q90.jpg",
        "price": 1394400,
        "remark": "https://www.lazada.co.th/products/pdp-i5242824733.html",
        "sold": 0
    },
    {
        "product_name": "Thule Tepui Autana 4-person roof top tent haze grey เต็นท์ THULE",
        "product_image": "https://img.lazcdn.com/g/p/57567e0db5838a10effe84e061aa76e7.jpg_200x200q90.jpg",
        "price": 278000,
        "remark": "https://www.lazada.co.th/products/pdp-i4657273394.html",
        "sold": 0
    },
    {
        "product_name": "Dometic TRT120E เต็นท์หลังคาแบบไฟฟ้า",
        "product_image": "https://img.lazcdn.com/g/p/b8e8fced21a768e8401174682962780d.png_200x200q90.png",
        "price": 176000,
        "remark": "https://www.lazada.co.th/products/pdp-i3108625479.html",
        "sold": 0
    },
    {
        "product_name": "Arcane Warrior | เต็นท์หลังคาแข็งพับได้ติดรถยนต์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3ec6d1ed735f4dbf81bf9bb83c88affeI.jpg_200x200q90.jpg",
        "price": 142775.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5971318515.html",
        "sold": 0
    },
    {
        "product_name": "Snow Peak Landlock  เต็นท์แคมป์ปิ้ง สำหรับ 6 คน (แถม Ground Sheet ) ตรงรุ่น",
        "product_image": "https://img.lazcdn.com/g/p/90543b3adcc216bb974c84b2a5102cf3.jpg_200x200q90.jpg",
        "price": 118000,
        "remark": "https://www.lazada.co.th/products/pdp-i5399580218.html",
        "sold": 0
    },
    {
        "product_name": "Coody Official Familia pro 17.2 +พร้อมส่ง+ เต็นท์เสาลมรุ่นใหม่ แฟมิลี่โปร ขนาดใหญ่ ประกันเสาลม 5 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sac3eb824c7a442cc8699b6dd9bb7e4cdq.jpg_200x200q90.jpg",
        "price": 114960,
        "remark": "https://www.lazada.co.th/products/pdp-i16057327190.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์เป่าลม coody 17.28 รับประกันของแท้ (มีประกันศูนย์)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfe63bfa65adf4344b1b4364886b8a45fk.jpg_200x200q90.jpg",
        "price": 110440,
        "remark": "https://www.lazada.co.th/products/pdp-i5719364850.html",
        "sold": 0
    },
    {
        "product_name": "🔥แถมทาร์ป🔥COODY เต็นท์ลม รุ่นAir 17.2 กันน้ำดีเยี่ยม ดีไซน์หรูหรา 2 ห้องและห้องนั่งเล่นขนาดใหญ่พิเศษ รเต็นท์เป่าลมตั้งแคมป์กันรังสี UV กันน้ำ ใช้กลางแจ้ง 17.28 ตรม. หรูหราดีไซน์ใหม่ !!!",
        "product_image": "https://img.lazcdn.com/g/p/650c4b2fc38cdcd5297bf6307ba3679f.jpg_200x200q90.jpg",
        "price": 110400,
        "remark": "https://www.lazada.co.th/products/pdp-i5099023010.html",
        "sold": 6
    },
    {
        "product_name": "Coody Official Coody 17.2 เต็นท์เสาลม เต็นท์เป่าลม ขนาดใหญ่ พร้อมส่ง รับประกันเสาลม 5 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sac153f2f2b714eefbb3b7cfac739b75df.jpg_200x200q90.jpg",
        "price": 110400,
        "remark": "https://www.lazada.co.th/products/pdp-i5666616938.html",
        "sold": 0
    },
    {
        "product_name": "Rooftop Tent ยี่ห้อ Ironman รุ่น Orion 1400",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S24c72c64915b4fa5af4245158ccec868V.jpg_200x200q90.jpg",
        "price": 102238,
        "remark": "https://www.lazada.co.th/products/pdp-i5509899674.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์ยูร์ทแคมปิ้งกลางแจ้งอุ่นสบาย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S81e22b2d6c9940a2baecfdc7fb413dedD.jpg_200x200q90.jpg",
        "price": 99854.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16076456591.html",
        "sold": 0
    },
    {
        "product_name": "🔥พร้อมส่ง🔥COODy 13.68 เต็นท์สูบลม 2 ห้องนอนและ 1ห้องนั่งเล่น ผ้าหนากันฝนและระบายอากาศได้🔥🔥 🔥มีรุ่นอัพเกรด กับรุ่นไม่อัพเกรด สอบถามได้คะ🔥🔥🔥",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9ab738ad47364fd7ac44a40fd654f219x.jpg_200x200q90.jpg",
        "price": 92400,
        "remark": "https://www.lazada.co.th/products/pdp-i5190739570.html",
        "sold": 24
    },
    {
        "product_name": "Coody Official Coody 13.68 รุ่นอัพเกรด พร้อมส่ง เต็นท์เสาลม พร้อมท่อแอร์ รับประกันเสาลม 5 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7589c989a198485cbf4b9879fbbdd232j.jpg_200x200q90.jpg",
        "price": 92400,
        "remark": "https://www.lazada.co.th/products/pdp-i5218434109.html",
        "sold": 0
    },
    {
        "product_name": "CARRYBOY CB.103-06 แครี่บอยเต็นท์หลังคารถ 215x133x150cm สำหรับนอน 1-2 คน ฝาแข็ง ทรงสามเหลี่ยม แบบพกพาสะดวก",
        "product_image": "https://img.lazcdn.com/g/p/d5547d891a584d7ebe332854d4173497.jpg_200x200q90.jpg",
        "price": 90000,
        "remark": "https://www.lazada.co.th/products/pdp-i5749656629.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์ลม Coody Bestona",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5f60705461634ea8b05726012fc6816a9.jpg_200x200q90.jpg",
        "price": 90000,
        "remark": "https://www.lazada.co.th/products/pdp-i5732529016.html",
        "sold": 0
    },
    {
        "product_name": "🔥รุ่นใหม่ 🔥Coody Bestona เต็นท์เสาลมผ้า TC กว้างขวาง หลังคาสูง 275cm ระบายอากาศได้ดี",
        "product_image": "https://img.lazcdn.com/g/p/8c5387cc64d2dacd7b3f582382229312.jpg_200x200q90.jpg",
        "price": 90000,
        "remark": "https://www.lazada.co.th/products/pdp-i5757343737.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์หลังคารถยนต์พับอัตโนมัติกันน้ำพร้อมเปลือกแข็ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf3773327820a4c5e86def8eab44757eds.jpg_200x200q90.jpg",
        "price": 88687.22,
        "remark": "https://www.lazada.co.th/products/pdp-i16050633353.html",
        "sold": 0
    },
    {
        "product_name": "Rooftop เต็นท์หลังคารถBLACKBULL HYBRID II 1.6 รุ่นใหม่ล่าสุด ขนาด1.6 นอน3-4คน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S819712bec1cd4fa28ce82f566a3b4675x.jpg_200x200q90.jpg",
        "price": 85800,
        "remark": "https://www.lazada.co.th/products/pdp-i4839133244.html",
        "sold": 0
    },
    {
        "product_name": "🔥COODY🔥 เต็นท์เป่าลมผ้าฝ้าย Coody 10.0 Pro พื้นที่ขนาดใหญ่ เชื่อมต่อกับเต็นท์ รุ่น 13.6, 17.2 ได้ ประตูเปิดได้หน้า-หลัง",
        "product_image": "https://img.lazcdn.com/g/p/7579c7847d4da46ca3bfba2650d24a34.png_200x200q90.png",
        "price": 80400,
        "remark": "https://www.lazada.co.th/products/pdp-i5742918569.html",
        "sold": 0
    },
    {
        "product_name": "(ฟรีทาร์ป)(สินค้าพร้อมจัดส่ง) เต็นท์coody13.68 รับประกัน5ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2408f5579e404a7aa177120d269d4347z.jpg_200x200q90.jpg",
        "price": 76000,
        "remark": "https://www.lazada.co.th/products/pdp-i5187147745.html",
        "sold": 0
    },
    {
        "product_name": "Coody Official Coody 10.0 เต็นท์เสาลม รุ่น10.0 ประกันเสาลม 5 ปี เต็นท์เป่าลม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se8e6528a4f0d4142bee98644b0d893d8Z.jpg_200x200q90.jpg",
        "price": 73200,
        "remark": "https://www.lazada.co.th/products/pdp-i5730692824.html",
        "sold": 0
    },
    {
        "product_name": "BUNISE เต็นท์แคมป์กันแดด ขนาดใหญ่ ทรงแปดขา พร้อมดีไซน์ยอดเขาเดี่ยว สองยอด สามยอด และยอดเมฆ เหมาะสำหรับตั้งแคมป์กลางแจ้ง รุ่น P2416 จัดส่งฟรีทั่วไทย",
        "product_image": "https://img.lazcdn.com/g/p/f9cbe5566c6daaa73a9d018fec595e2a.jpg_200x200q90.jpg",
        "price": 65730,
        "remark": "https://www.lazada.co.th/products/pdp-i5242942209.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์เสาลมสุดฮิต เต็นท์ครอบครัว Coody Air Tent 8.0",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S27a24bb2117b4e3898ced3e18e54caa2S.jpg_200x200q90.jpg",
        "price": 63600,
        "remark": "https://www.lazada.co.th/products/pdp-i5838626891.html",
        "sold": 0
    },
    {
        "product_name": "❗coody 8.0 🔥รับประกันเสาลม 5ปี จากCoodyThailand 🔥เต็นท์สูบลม กันแดด กันน้ำ 1000mmขึ้นไป",
        "product_image": "https://img.lazcdn.com/g/p/1a614ea5b53cd576d0e20eb7d4dce15a.png_200x200q90.png",
        "price": 63600,
        "remark": "https://www.lazada.co.th/products/pdp-i5114669982.html",
        "sold": 5
    },
    {
        "product_name": "🔥รุ่น8.0 !!! รับประกัน5ปี จากCoody Thailand🔥แถมทาร์ป เต็นท์เป่าลมแคมป์ปิ้งกลางแจ้ง รุ่น 8.0 / รุ่น10.0 มีสามสี กากี/เขียว/ดำ ผ้าหนากันฝนและระบายอากาศดี",
        "product_image": "https://img.lazcdn.com/g/p/22d17c9761082e772ea2d837825fc058.jpg_200x200q90.jpg",
        "price": 63600,
        "remark": "https://www.lazada.co.th/products/pdp-i5030322305.html",
        "sold": 55
    },
    {
        "product_name": "เต็นท์เป่าลม Coody 8.0 รับประกันของแท้ตัวอัพเกรด (มีประกันศูนย์)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0c0bd1a0c9a64ab98398719280ec396bo.jpg_200x200q90.jpg",
        "price": 63600,
        "remark": "https://www.lazada.co.th/products/pdp-i5719361871.html",
        "sold": 0
    },
    {
        "product_name": "🇰🇷พร้อมส่ง🇰🇷 Coody 8.0 Luxury Air tent เต็นท์เป่าลม แถม Rain cover",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf58af2282528427daff0dbaedfb1cbbd0.jpg_200x200q90.jpg",
        "price": 63600,
        "remark": "https://www.lazada.co.th/products/pdp-i5380302273.html",
        "sold": 1
    },
    {
        "product_name": "Coody Official Coody 8.0 รุ่นอัพเกรด พร้อมส่งทุกสี เต็นท์เสาลม พร้อมท่อแอร์ รับประกันเสาลม 5 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S12fc96d77aa9436c957a5c8f2b41cf57r.jpg_200x200q90.jpg",
        "price": 63600,
        "remark": "https://www.lazada.co.th/products/pdp-i5218342157.html",
        "sold": 1
    },
    {
        "product_name": "Coody เต็นท์ 8.0 รุ่น upgrade เต็นท์เสาลม \"แถม  rain cover \" รับประกัน 5 ปี สินค้าพร้อมจัดส่ง",
        "product_image": "https://img.lazcdn.com/g/p/87a78b65ad13601cd8a766e29a2e2ab0.jpg_200x200q90.jpg",
        "price": 63600,
        "remark": "https://www.lazada.co.th/products/pdp-i5382913507.html",
        "sold": 0
    },
    {
        "product_name": "🔥รุ่นอัพเกรด‼️ COODY เต็นท์เป่าลมรุ่นAir 8.0 (แถมทาร์ปในตัว)มีสีกากี/เขียว ผ้าหนา กันแดด กันฝนได้อย่างดี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S670154785e2846c78f090b49443822acP.jpg_200x200q90.jpg",
        "price": 63600,
        "remark": "https://www.lazada.co.th/products/pdp-i3919172022.html",
        "sold": 2
    },
    {
        "product_name": "MUSHE | เต็นท์พองลมสำหรับแคมปิ้ง 2 ห้อง 1 โถน 13.68 ตรม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1b7061febdef464ca1e4e3d1b41c3736C.jpg_200x200q90.jpg",
        "price": 62965.06,
        "remark": "https://www.lazada.co.th/products/pdp-i16083204839.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์เปิดเร็วสำหรับทริปขับรถนอกสถานที่",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S95b9b7ca66b54280aff0f1687e234df7o.png_200x200q90.png",
        "price": 62658.58,
        "remark": "https://www.lazada.co.th/products/pdp-i5876551651.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์เสาลม 8.0+Riancoverเคลือบไวนิลดำ+ประตูTPUใส+มุ้ง+เสา3เส้น มีช่องใส่ท่อแอร์",
        "product_image": "https://img.lazcdn.com/g/p/a9ba8d2245a5f572fd84988acb622749.jpg_200x200q90.jpg",
        "price": 62392.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5768471335.html",
        "sold": 5
    },
    {
        "product_name": "เต็นท์เสาลม MARS08 ขนาด 8+8 ตารางเมตร พร้อมห้องเสริม 16 ตารางเมตร หนึ่งห้องนอนหนึ่งห้องนั่งเล่น ระบายอากาศได้ดี ถอดประกอบได้ ประกัน 5 ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf508673abae444b39d8dd1f9039edf45d.jpg_200x200q90.jpg",
        "price": 59800,
        "remark": "https://www.lazada.co.th/products/pdp-i16111760136.html",
        "sold": 0
    },
    {
        "product_name": "‼️ประกัน5ปี‼️MARS08 เต็นท์เสาลม8+ 8พร้อมห้องเสริมขนาด16ตร.ม แบบหนึ่งห้องนอนหนึ่งห้องนั่งเล่นขยายได้ ถอดประกอบได้",
        "product_image": "https://img.lazcdn.com/g/p/4bcf6ed4d34a42e542cf6e92d1426c69.jpg_200x200q90.jpg",
        "price": 59800,
        "remark": "https://www.lazada.co.th/products/pdp-i5953441825.html",
        "sold": 5
    },
    {
        "product_name": "กระโจมดาว เต็นท์กิจกรรม Mountpeak เต็นท์ครอบครัว เต็นท์ขนาดใหญ่ เต็นท์สนาม เต็นท์เดินป่า เต็นท์พับได้ ขนาด 15-40 คน",
        "product_image": "https://img.lazcdn.com/g/p/535b423f7a14660203300ecd49ac7e47.jpg_200x200q90.jpg",
        "price": 57794,
        "remark": "https://www.lazada.co.th/products/pdp-i5200298882.html",
        "sold": 7
    },
    {
        "product_name": "Naturehike|เต็นท์ผ้าฝ้ายสำหรับแคมปิ้งกลางแจ้ง รุ่นฮัมมูราบี",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S98ac955aaef8413da019800d7055b243t.png_200x200q90.png",
        "price": 56634.26,
        "remark": "https://www.lazada.co.th/products/pdp-i5894738622.html",
        "sold": 22
    },
    {
        "product_name": "MSR Hubba Hubba LT 3 เต๊นท์",
        "product_image": "https://img.lazcdn.com/g/p/6985304eed2ab8a681422d6175af0520.jpg_200x200q90.jpg",
        "price": 56400,
        "remark": "https://www.lazada.co.th/products/pdp-i16071073701.html",
        "sold": 0
    },
    {
        "product_name": "Naturehike เต็นท์ลม Gents 12 สำหรับแคมป์ปิ้งกลางแจ้ง ทรงตัวดี กันลม ผลิตจากผ้าฝ้ายหนาพิเศษ เหมาะสำหรับค้างคืน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se8b4cd669f8b4c15aaedd828501a59f7G.jpg_200x200q90.jpg",
        "price": 55802.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5894436460.html",
        "sold": 2
    },
    {
        "product_name": "Coody เต็นท์เป่าลม รุ่น9.0 รับประกันของแท้ (มีประกันศูนย์)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0120192694db4336bad72c533200a0fen.jpg_200x200q90.jpg",
        "price": 55000,
        "remark": "https://www.lazada.co.th/products/pdp-i5719447764.html",
        "sold": 0
    },
    {
        "product_name": "🔥พร้อมส่ง🔥Coody yustona เต็นท์เสาลมรุ่นใหม่ผ้าฝ้าย TC น้ำหนักเบา รับประกัน 5 ปี",
        "product_image": "https://img.lazcdn.com/g/p/82cb632cfd825415b9c5d94c52a79e58.jpg_200x200q90.jpg",
        "price": 54960,
        "remark": "https://www.lazada.co.th/products/pdp-i6048288706.html",
        "sold": 0
    },
    {
        "product_name": "MSR Hubba Hubba LT 3-Person Lightweight Backpacking Tent เต็นท์เดินป่ารุ่นใหม่ 2025 คุณภาพสูง นำ้หนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/54528f9b00a005eaf7efb568fdb6a3b2.png_200x200q90.png",
        "price": 54050,
        "remark": "https://www.lazada.co.th/products/pdp-i5690809429.html",
        "sold": 1
    },
    {
        "product_name": "เต๊นท์อุโมงค์ Coleman Tunnel Shelter 240 tent รุ่นใหม่ 2024",
        "product_image": "https://img.lazcdn.com/g/p/cc1114f950220b814c95f1b2c8d6f6af.png_200x200q90.png",
        "price": 53900,
        "remark": "https://www.lazada.co.th/products/pdp-i5305310675.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์โดมเป่าลม Gooutspringhill TC Cottom สำหรับครอบครัว รองรับ 4-6 คน มั่นใจด้วยPU2000 กันน้ำและป้องกันรังสียูวี พกพาสะดวก",
        "product_image": "https://img.lazcdn.com/g/p/acc545047e535005fd8dbd1545b534b4.jpg_200x200q90.jpg",
        "price": 53800,
        "remark": "https://www.lazada.co.th/products/pdp-i6008297686.html",
        "sold": 0
    },
    {
        "product_name": "Sea To Summit ALTO TR2 ULTRALIGHT BACKPACKING TENT เต็นท์",
        "product_image": "https://img.lazcdn.com/g/p/251e66fc632c8e687d2be2ffac3948bc.jpg_200x200q90.jpg",
        "price": 53740,
        "remark": "https://www.lazada.co.th/products/pdp-i2802155191.html",
        "sold": 0
    },
    {
        "product_name": "Coleman Tough Speed Dome #Greige เต็นท์แคมป์ปิ้ง 2 ห้องรุ่นใหม่ปี 2026 ขนาด 3-4 คน",
        "product_image": "https://img.lazcdn.com/g/p/6635ca97cd288831d90bf2c2ddd5f000.png_200x200q90.png",
        "price": 52000,
        "remark": "https://www.lazada.co.th/products/pdp-i16109300482.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์หลังคา เหมาะสำหรับหลังคา SUV เต็นท์กันน้ำเต็นท์กลางแจ้ง 195x130x101cm",
        "product_image": "https://img.lazcdn.com/g/p/0a69efb4938e72835607ebb6369e8591.jpg_200x200q90.jpg",
        "price": 52000,
        "remark": "https://www.lazada.co.th/products/pdp-i4999181027.html",
        "sold": 1
    },
    {
        "product_name": "(ฟรีทาร์ป)(สินค้าพร้อมจัดส่ง) เต็นท์Coody8.0 รับประกัน5ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se132a8a3f25943efb08bdc11b81bbd8fz.jpg_200x200q90.jpg",
        "price": 51800,
        "remark": "https://www.lazada.co.th/products/pdp-i5184445868.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์หลังคารถHEMI4x4 รุ่นRTT-5 (New model) เต็นท์บนรถ Roof toptent",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8858edd49dc740cba7a0a2f9fc1f1581U.jpg_200x200q90.jpg",
        "price": 51000,
        "remark": "https://www.lazada.co.th/products/pdp-i5303136335.html",
        "sold": 0
    },
    {
        "product_name": "Coody Official Air Tent Havena เฮเวนน่า เต็นท์เสาลม รุ่นใหม่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S58cef0d1b30649b7b1537ea64736429fO.jpg_200x200q90.jpg",
        "price": 50400,
        "remark": "https://www.lazada.co.th/products/pdp-i5764069027.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์หลังคา เหมาะสำหรับหลังคา SUV เต็นท์กันน้ำเต็นท์กลางแจ้ง 188x130x110cm",
        "product_image": "https://img.lazcdn.com/g/p/2c5347af357d4318f6cc25cec412805c.jpg_200x200q90.jpg",
        "price": 50000,
        "remark": "https://www.lazada.co.th/products/pdp-i4999093685.html",
        "sold": 0
    },
    {
        "product_name": "🔥พร้อมส่ง🔥JC&House  เต็นท์ขนาด 8+8ตรม.ขนาดใหญ่ กว้าง ขวาง สามารถต่อเพิ่มด้านหน้า หรือด้านหลังได้",
        "product_image": "https://img.lazcdn.com/g/p/9dc91eea97f4875fe451b069eaa9411d.jpg_200x200q90.jpg",
        "price": 50000,
        "remark": "https://www.lazada.co.th/products/pdp-i5847732460.html",
        "sold": 1
    },
    {
        "product_name": "เต็นท์หลังคา เหมาะสำหรับหลังคา SUV เต็นท์กันน้ำเต็นท์กลางแจ้ง 188x130x105cm",
        "product_image": "https://img.lazcdn.com/g/p/4e6ed409c751f03a003c6a970f099ab9.jpg_200x200q90.jpg",
        "price": 49711.8,
        "remark": "https://www.lazada.co.th/products/pdp-i4999189039.html",
        "sold": 10
    },
    {
        "product_name": "เต็นท์หลังคารถ กันฝนกันแดด เหมาะ2-3คน UPF50+ ผ้า PVC 600D พร้อมบันได+โคมไฟ เต็นท์แคมป์ปิ้งบนรถ SUV/กระบะ",
        "product_image": "https://img.lazcdn.com/g/p/ab3725ac42792e21223d33be57cff519.jpg_200x200q90.jpg",
        "price": 49498.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6018571804.html",
        "sold": 1
    },
    {
        "product_name": "เต็นท์หลังคารถ เหมาะ2-3คน กันฝนกันแดด UPF50+ ผ้า PVC 600D พร้อมบันได+โคมไฟ เต็นท์แคมป์ปิ้งบนรถ SUV/กระบะ",
        "product_image": "https://img.lazcdn.com/g/p/9097a304e06fa25698a37069e06d42d1.jpg_200x200q90.jpg",
        "price": 49498.02,
        "remark": "https://www.lazada.co.th/products/pdp-i6018617436.html",
        "sold": 2
    },
    {
        "product_name": "เต็นท์หลังคารถHEKI4x4 Thailand รุ่นRTT-2 ขนาด1.4 (Roof Top Tent) เต็นท์นอนบนรถ",
        "product_image": "https://img.lazcdn.com/g/p/6c65812aec602743d4ea9ada48f5ac02.jpg_200x200q90.jpg",
        "price": 49000,
        "remark": "https://www.lazada.co.th/products/pdp-i4489490947.html",
        "sold": 1
    },
    {
        "product_name": "K2 Guardian Glamping Tent  เต็นท์แคมป์ปิ้ง ขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/59facf27b0f5c937f2a48a082f782460.jpg_200x200q90.jpg",
        "price": 48100,
        "remark": "https://www.lazada.co.th/products/pdp-i5337987678.html",
        "sold": 1
    },
    {
        "product_name": "landscape | เตนทหลงคารถยนต LSP7.10 สำหรบ 2-3 คน (สคาค)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf7535a529c1449a8bdc162dee79b3ae3j.png_200x200q90.png",
        "price": 47114.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5933025761.html",
        "sold": 0
    },
    {
        "product_name": "landscape | เตนทหลงคารถยนต LSP7.10 สำหรบ 2-3 คน (สเบจ)",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scaebc4151f4742ef9e4a35de4722c088G.png_200x200q90.png",
        "price": 47114.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5933339247.html",
        "sold": 0
    },
    {
        "product_name": "💥NEMO HORNET ELITE OSMO 1P 2P TENTเต็นท์เดินป่า สำหรับ 1คน2คน น้ำหนักเบา พับเก็บเล็ก ประกัน3ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S01574d0b251c4f7cb0c8de98a62189edl.jpg_200x200q90.jpg",
        "price": 47000,
        "remark": "https://www.lazada.co.th/products/pdp-i16076112625.html",
        "sold": 0
    },
    {
        "product_name": "Coleman JP Tough Speed Dome{2026NEW}[Greige]#เต็นท์ 2 ห้อง สำหรับครอบครัว 4-5 คน",
        "product_image": "https://img.lazcdn.com/g/p/b7a5c650a8fb83f0dc528d7a79eaa5f4.jpg_200x200q90.jpg",
        "price": 47000,
        "remark": "https://www.lazada.co.th/products/pdp-i16107978556.html",
        "sold": 0
    },
    {
        "product_name": "MSR Hubba Shield 2 เต็นท์",
        "product_image": "https://img.lazcdn.com/g/p/7e2e069b1266ae9b8a7b3dda44acde0a.jpg_200x200q90.jpg",
        "price": 46800,
        "remark": "https://www.lazada.co.th/products/pdp-i16071164464.html",
        "sold": 0
    },
    {
        "product_name": "พร้อมส่ง Mountainhiker เต็นท์คณะละครสัตว์ เต็นท์ตั้งแคมป์ 10-15 คนกันฝนและแดดเต็นท์เห็ด",
        "product_image": "https://img.lazcdn.com/g/p/064173bd74e70d822bcea90a73471336.jpg_200x200q90.jpg",
        "price": 46796,
        "remark": "https://www.lazada.co.th/products/pdp-i4822669146.html",
        "sold": 0
    },
    {
        "product_name": "เต๊นท์ครอบครัว 2  ห้อง ใหม่ล่าสุด 2025 Coleman JP Tough 2-Room 3025",
        "product_image": "https://img.lazcdn.com/g/p/875190e74ef4cb354fbe287096fdd455.png_200x200q90.png",
        "price": 46200,
        "remark": "https://www.lazada.co.th/products/pdp-i5818100214.html",
        "sold": 2
    },
    {
        "product_name": "เต็นท์หลังคารถHEKI4x4 Thailand รุ่นRTT-1  ขนาด1.4 (roof top tent) เต็นท์นอนบนรถ",
        "product_image": "https://img.lazcdn.com/g/p/c0320f5faba288792a60c52444b8ba42.jpg_200x200q90.jpg",
        "price": 45000,
        "remark": "https://www.lazada.co.th/products/pdp-i4133702018.html",
        "sold": 1
    },
    {
        "product_name": "[ใหม่ 2026] Nemo เต็นท์เดินป่า 1 คน Dragonfly Osmo Ultralight Tent",
        "product_image": "https://img.lazcdn.com/g/p/d018b4b2563b3d90c567ad1ddc92bb9b.jpg_200x200q90.jpg",
        "price": 44070,
        "remark": "https://www.lazada.co.th/products/pdp-i16103600394.html",
        "sold": 0
    },
    {
        "product_name": "Naturehike Village 13  Flagship PRO หลังคา เต็นท์เปิดอย่างรวดเร็ว เต็นท์กันแดดไวนิลไทเทเนียมกลางคนตั้งแคมป์หลังคากันฝน",
        "product_image": "https://img.lazcdn.com/g/p/893c14c4fb0f9a556ac0d655e8a13f60.jpg_200x200q90.jpg",
        "price": 43398,
        "remark": "https://www.lazada.co.th/products/pdp-i5939487179.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | เต็นท์แค้มปิ้งกันลม กันน้ำ ทรงโดม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf9c41253516542aba00663ba8a4b9032C.png_200x200q90.png",
        "price": 43083.18,
        "remark": "https://www.lazada.co.th/products/pdp-i6064296925.html",
        "sold": 0
    },
    {
        "product_name": "[พร้อมส่ง] เต็นท์เป่าลม 1 ห้องนอน สำหรับ 4 คน Inflatable Tent",
        "product_image": "https://img.lazcdn.com/g/p/ea822fa0f695c65164b5bd70b9e7a099.jpg_200x200q90.jpg",
        "price": 42000,
        "remark": "https://www.lazada.co.th/products/pdp-i4154844043.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์นอนหลังคารถเจน 4 (รุ่นพรีเมี่ยม) เต็นท์หลังคารถพับเก็บง่าย ใช้งานได้จริง กันแดด กันฝนกันยุงระบายอากาศดีพร้อมลุย",
        "product_image": "https://img.lazcdn.com/g/p/af378506893920bf8b6e2b0bf37f9153.jpg_200x200q90.jpg",
        "price": 41380,
        "remark": "https://www.lazada.co.th/products/pdp-i5807550715.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์นอนหลังคารถเจน 4 รุ่นพรีเมี่ยม เต็นท์หลังคารถพับเก็บง่าย ใช้งานได้จริง กันแดด กันฝนกันยุงระบายอากาศดีพร้อมลุย",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0894bee0cd0744be9eaaeb9d2ab5b0f24.jpg_200x200q90.jpg",
        "price": 41380,
        "remark": "https://www.lazada.co.th/products/pdp-i5798808871.html",
        "sold": 0
    },
    {
        "product_name": "[ผ่อน 0%]groundcover Acorn House Dome 3.45 Tent Black",
        "product_image": "https://img.lazcdn.com/g/p/2ccd2f98e851f7321d932d32d0a2ccab.jpg_200x200q90.jpg",
        "price": 39900,
        "remark": "https://www.lazada.co.th/products/pdp-i4379517967.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์เป่าลม 1 ห้องนอน รุ่น Air Seconds 4.1 F&B สำหรับ 4 คน กันน้ำ กันแดด ระบายอากาศดี ติดตั้งง่าย เหมาะสำหรับแคมป์ปิ้งและเดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/00cb94c1ec6a398bd415bb74770c35ad.png_200x200q90.png",
        "price": 39900,
        "remark": "https://www.lazada.co.th/products/pdp-i5941216133.html",
        "sold": 0
    },
    {
        "product_name": "🔥พร้อมส่ง🔥Xintu B07 เต็นท์โมดูล A/B ผ้าฝ้ายเทคโนโลยี 210g TC มีให้เลือก 2 แบบ",
        "product_image": "https://img.lazcdn.com/g/p/c0e0cb86516e0606e48696edf271fa25.jpg_200x200q90.jpg",
        "price": 39800,
        "remark": "https://www.lazada.co.th/products/pdp-i5853744902.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | เต็นท์พองน้ำหนักเบา สำหรับกลางแจ้ง กันน้ำ กันแดด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6136cc6c66de4afb8e0cb1cd2eef0879A.png_200x200q90.png",
        "price": 39005.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5894536476.html",
        "sold": 0
    },
    {
        "product_name": "NEMO HORNET OSMO 2P เต็นท์เดินป่าน้ำหนักเบา ขนาด 2 คน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc794ced321d845f08a022eb92b6b1e01e.jpg_200x200q90.jpg",
        "price": 39000,
        "remark": "https://www.lazada.co.th/products/pdp-i5278416031.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์แค้มปิ้งพองลมขนาดใหญ่สำหรับกลางแจ้ง 12.96 ตร.ม.",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se73359ad33284136a4a6d77afe72840d1.jpg_200x200q90.jpg",
        "price": 38565.08,
        "remark": "https://www.lazada.co.th/products/pdp-i16083902821.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | เต็นท์เดินป่าเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scb4005f64f894bdea29aae96b0b0ea20v.jpg_200x200q90.jpg",
        "price": 38097.36,
        "remark": "https://www.lazada.co.th/products/pdp-i5894543163.html",
        "sold": 7
    },
    {
        "product_name": "เต็นท์เป่าลม Camping Tent เต้นท์แค้มปิ้ง เต็นท์ เต็นท์ปิกนิก พื้นที่ภายในขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/0b5145a022c935272b21a39b504ea5e5.jpg_200x200q90.jpg",
        "price": 37998,
        "remark": "https://www.lazada.co.th/products/pdp-i5997720935.html",
        "sold": 4
    },
    {
        "product_name": "ABORON เต็นท์เติมลมเต็นท์แคมป์ปิ้งพองได้ CQ8พร้อมติดตั้งง่ายปั๊มมือ4ฤดูเต็นท์กันน้ำอ็อกซ์ฟอร์ดสำหรับผู้ใหญ่8-10คน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5af828444de84ee0bc2ca20a794adf0cm.png_200x200q90.png",
        "price": 37498.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5856281466.html",
        "sold": 0
    },
    {
        "product_name": "ประกัน1ปี🔥พร้อมส่งทันทีใน24ชม.🔥16FT Tank08 เต็นท์เสาลม ครบชุดห้องเสริม+TPU ผ้าแคนวาส มี2สีให้เลือก",
        "product_image": "https://img.lazcdn.com/g/p/5221df6976364a0de1b83b34b8b077f1.jpg_200x200q90.jpg",
        "price": 37200,
        "remark": "https://www.lazada.co.th/products/pdp-i16071035392.html",
        "sold": 0
    },
    {
        "product_name": "MOBI GARDEN เต็นท์ครอบครัวแบบพองลม 2-4 คน กันน้ำ กันฝน กันแดด พร้อมใช้",
        "product_image": "https://img.lazcdn.com/g/p/8bd0d7537d6a32ef6e4ae26af1b7e80a.jpg_200x200q90.jpg",
        "price": 36986,
        "remark": "https://www.lazada.co.th/products/pdp-i4580577029.html",
        "sold": 2
    },
    {
        "product_name": "กลางแจ้ง 10 ตรม เต็นท์เป่าลมผ้าฝ้ายระบายอากาศกันน้ำได้ 6-7 คนเต็นท์แคมป์แบบพกพาขนาด เต็นท์แคมป์ปิ้ง เต็นท์ขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/96294b0effdd4f7a9fc6a59679861439.jpg_200x200q90.jpg",
        "price": 36898,
        "remark": "https://www.lazada.co.th/products/pdp-i5837028421.html",
        "sold": 0
    },
    {
        "product_name": "MSR เต็นท์เดินป่า 1 คน Hubba Hubba LT 1",
        "product_image": "https://img.lazcdn.com/g/p/9ee9b71e020fb41332df3770a1104322.jpg_200x200q90.jpg",
        "price": 36750,
        "remark": "https://www.lazada.co.th/products/pdp-i5679702365.html",
        "sold": 1
    },
    {
        "product_name": "【Outdoor】เต็นท์เป่าลมแบบตั้งอิสระสำหรับตั้งแคมป์กลางแจ้ง 420D ขนาด 8 ตร.ม. สำหรับ 3-5 คน พร้อมช่องเปิดเปิดอย่างรวดเร็ว",
        "product_image": "https://img.lazcdn.com/g/p/afd2259caf1b1d5be2c42c911f390945.png_200x200q90.png",
        "price": 36364,
        "remark": "https://www.lazada.co.th/products/pdp-i5912827459.html",
        "sold": 1
    },
    {
        "product_name": "Kingcamp | เต็นท์แคมปิ้งติดตั้งไว้ได้เร็ว ขยายได้ ใช้งานได้กับรถยนต์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S208b99adddec4730adf6a4466c8119f5k.jpg_200x200q90.jpg",
        "price": 36104.44,
        "remark": "https://www.lazada.co.th/products/pdp-i6072705850.html",
        "sold": 1
    },
    {
        "product_name": "Mountainhiker เต็นท์คณะละครสัตว์ กระโจมใหญ่ เห็ด คนกันฝนและแดด กันน้ำ 4000 mm. ตั้งแคมป์ ขนาดใหญ่ 15x15 ฟุต (สำหรับ 10-20 คน)",
        "product_image": "https://img.lazcdn.com/g/p/1dcef2585ad168dbfa42718b30c1fe28.jpg_200x200q90.jpg",
        "price": 35990,
        "remark": "https://www.lazada.co.th/products/pdp-i5314586797.html",
        "sold": 0
    },
    {
        "product_name": "🔥พร้อมส่งทันทีใน24ชม.🔥 Mountain เต็นท์เสาลม8.0 + Riancoverเคลือบไวนิลดำ+ประตูTPUใส+มุ้ง+เสา3เส้น มีช่องใส่ท่อแอร์‼️",
        "product_image": "https://img.lazcdn.com/g/p/377dc83a47d74c7655dc2b7f702269bd.jpg_200x200q90.jpg",
        "price": 30880.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5663428000.html",
        "sold": 3
    },
    {
        "product_name": "WOLFNEST | เต็นท์กันความร้อนพร้อมที่บังแดด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9f949babee4246c5b41bf9bce5e328fcB.jpg_200x200q90.jpg",
        "price": 35358.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16096480396.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | เต็นท์teepee สำหรับในร่ม ทำจากฝ้าย",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/Sb8217db8047f403eaf27b60bbb421052j.png_200x200q90.png",
        "price": 35292.38,
        "remark": "https://www.lazada.co.th/products/pdp-i5894694928.html",
        "sold": 17
    },
    {
        "product_name": "💥NEMO Equipment เต้นท์ รุ่น HORNET OSMO ULTRALIGHT BACKPACKING TENT 2 P",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S49251b8c80f94dbda6126c6c82a35df0d.jpg_200x200q90.jpg",
        "price": 35000,
        "remark": "https://www.lazada.co.th/products/pdp-i16076298188.html",
        "sold": 0
    },
    {
        "product_name": "MSR Hubba Hubba LT 1-Person Backpacking Tent เต๊นท์เดินป่าน้ำหนักเบา เต๊นท์เดินป่าล่าสุด เต๊นท์ตัวจบ",
        "product_image": "https://img.lazcdn.com/g/p/0726997b156b806dd7f09eb9d92d6c63.png_200x200q90.png",
        "price": 35000,
        "remark": "https://www.lazada.co.th/products/pdp-i5687641723.html",
        "sold": 0
    },
    {
        "product_name": "Naturehike 2025 New Star River EXT Ultralight 2 Person Hiking Tent Expandable Double Canopy Double Door Window",
        "product_image": "https://img.lazcdn.com/g/p/e9c1475c25515dbb8454b3de6bf73a8a.jpg_200x200q90.jpg",
        "price": 34780,
        "remark": "https://www.lazada.co.th/products/pdp-i16057101905.html",
        "sold": 0
    },
    {
        "product_name": "MOBI GARDEN เต็นท์แกลมปิ้งตั้งแคมป์กันน้ำกันฝนสำหรับ4-6คนพร้อม2เต็นท์ภายในกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/ad556d8276eddc4c4c7fa05e1a8c6966.jpg_200x200q90.jpg",
        "price": 33844,
        "remark": "https://www.lazada.co.th/products/pdp-i4609215383.html",
        "sold": 0
    },
    {
        "product_name": "NEW‼️เต็นท์Coleman Instant Up Pro 4 🎉เต็นกางเร็ว รุ่นใหม่ล่าสุด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S42feecc39cc4437785543a46f6137af9Z.jpg_200x200q90.jpg",
        "price": 33800,
        "remark": "https://www.lazada.co.th/products/pdp-i5912125707.html",
        "sold": 0
    },
    {
        "product_name": "Xintu M05 เต็นท์เสาลม ผ้าTCกันฝนPU2000+ กันแดดได้ดี**รับประกันเสาลม5ปี**",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7255315a0a634f3ba2cbc9dde198baf2V.jpg_200x200q90.jpg",
        "price": 33800,
        "remark": "https://www.lazada.co.th/products/pdp-i5847700375.html",
        "sold": 0
    },
    {
        "product_name": "Naturehike Thailand เต็นท์  Village 13 Quick-opening tent Living Room Version",
        "product_image": "https://img.lazcdn.com/g/p/58f91bed83a574b1ff1a959b8e395fcf.jpg_200x200q90.jpg",
        "price": 33800,
        "remark": "https://www.lazada.co.th/products/pdp-i4781274950.html",
        "sold": 0
    },
    {
        "product_name": "Mountainhiker เต็นท์เป่าลม Village13 เต็นท์แคมปิ้ง กันน้ำกันแดด 2ห้องนอน 1ห้องนั่งเล่น",
        "product_image": "https://img.lazcdn.com/g/p/eba69dad52f283a007c02c80cc966082.jpg_200x200q90.jpg",
        "price": 33592.78,
        "remark": "https://www.lazada.co.th/products/pdp-i5768496155.html",
        "sold": 13
    },
    {
        "product_name": "【HCS】เต็นท์เป่าลมแบบตั้งอิสระสำหรับตั้งแคมป์กลางแจ้ง 420D ขนาด 8 ตร.ม. สำหรับ 3-5 คน พร้อมช่องเปิดเปิดอย่างรวดเร็ว",
        "product_image": "https://img.lazcdn.com/g/p/86bf38ae5a53f90c3adbda34e6d4a16d.png_200x200q90.png",
        "price": 32564,
        "remark": "https://www.lazada.co.th/products/pdp-i5912858083.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์เป่าลมสำหรับตั้งแคมป์กลางแจ้ง 420D เต็นท์เป่าลมตั้งได้อิสระขนาด 8 ตร.ม. พร้อมปั๊มสำหรับ 3-5 คน เต็นท์เป่าลมตั้งเร็วสำหรับการผจญภัยกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/p/3198c90f7dea04572c5e8d1f4aabd537.png_200x200q90.png",
        "price": 32564,
        "remark": "https://www.lazada.co.th/products/pdp-i5953518792.html",
        "sold": 0
    },
    {
        "product_name": "【HOSPORT Camping Mall】 เต็นท์เป่าลม เต็นท์เสาลม 8.0+ Riancover เคลือบไวนิลดำ+ประตู TPU ใส+มุ้ง+เสา3เส้น มีช่องใส่ท่อแอร์",
        "product_image": "https://img.lazcdn.com/g/p/9a19a0a915c8e8e6ecd58eb0f2cec7f3.jpg_200x200q90.jpg",
        "price": 32564,
        "remark": "https://www.lazada.co.th/products/pdp-i5933929200.html",
        "sold": 0
    },
    {
        "product_name": "🔥xintu🔥เต็นท์เสาลม6.0 รุ่นอัพเกรด พร้อม conopy ห้องเสริมตรงรุ่นต่อด้วยซิป ผ้าTC กันฝน กันแดดได้ดี",
        "product_image": "https://img.lazcdn.com/g/p/45a139d7fc0c8a766fd99f46879c6503.jpg_200x200q90.jpg",
        "price": 32110,
        "remark": "https://www.lazada.co.th/products/pdp-i5956668835.html",
        "sold": 0
    },
    {
        "product_name": "Naturehike กลางแจ้ง 6.3 ตรม เต็นท์เป่าลมผ้าฝ้ายระบายอากาศกันน้ำได้ 3-4 คนเต็นท์แคมป์แบบพกพาขนาดใหญ่พร้อมปั๊มลม",
        "product_image": "https://img.lazcdn.com/g/p/686f5275b7a72219179cda15551ad193.jpg_200x200q90.jpg",
        "price": 28324,
        "remark": "https://www.lazada.co.th/products/pdp-i4890666695.html",
        "sold": 3
    },
    {
        "product_name": "Snowpeak | เต็นท์นอนกลางแจ้งสำหรับห้องนอน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sceaf9b6ebaad4323a183dba6a7fb622fM.jpg_200x200q90.jpg",
        "price": 31697.16,
        "remark": "https://www.lazada.co.th/products/pdp-i5875725014.html",
        "sold": 3
    },
    {
        "product_name": "Naturehike เต็นท์แคมป์ปิ้ง Village13/Village17/ Vilaage5.0 เต็นท์วิลเลท เต็นท์ขนาดใหญ่ พร้อมอุปกรณ์ครบชุด กันน้ำ กันแดด ระบายอากาศได้ด",
        "product_image": "https://img.lazcdn.com/g/p/674df6cb5854a7d6cbad66a139cdbe4e.jpg_200x200q90.jpg",
        "price": 31398,
        "remark": "https://www.lazada.co.th/products/pdp-i4593306077.html",
        "sold": 1
    },
    {
        "product_name": "Naturehike Village 13 เต็นท์แคมป์ปิ้งจุ 5-8 คน ขนาดใหญ่ รุ่น Tiblack PRO สี Deep Brown (รุ่น Flagship) CNH22ZP004",
        "product_image": "https://img.lazcdn.com/g/p/3a85d0de884e39abbde551772a3e3c42.jpg_200x200q90.jpg",
        "price": 31048,
        "remark": "https://www.lazada.co.th/products/pdp-i16114071380.html",
        "sold": 0
    },
    {
        "product_name": "พร้อมส่ง Mountainhiker เต็นท์คณะละครสัตว์ เต็นท์ตั้งแคมป์ 10-15 คนกันฝนและแดดเต็นท์เห็ด 8ประตู  ขนาด ​450x450x280cm",
        "product_image": "https://img.lazcdn.com/g/p/94f00d09b440045b4e3ce6f5e6b9c0da.jpg_200x200q90.jpg",
        "price": 30988,
        "remark": "https://www.lazada.co.th/products/pdp-i4650484991.html",
        "sold": 0
    },
    {
        "product_name": "🔥พร้อมส่ง🔥 เต็นท์ Naturehike Air 6.3 upgraded มีช่องใส่ท่อแอร์ เต็นท์สูบลม กางง่าย ขายดีมาก พร้อมส่งจากไทย🇹🇭",
        "product_image": "https://img.lazcdn.com/g/p/86f46404259c443c571dce7496a637b9.png_200x200q90.png",
        "price": 30400,
        "remark": "https://www.lazada.co.th/products/pdp-i4497256172.html",
        "sold": 3
    },
    {
        "product_name": "Blackdeer Flying Bird Tent#เต็นท์เปิดด้านข้าง 4 ด้าน เต็นท์ขนาด 4-6 คน",
        "product_image": "https://img.lazcdn.com/g/p/4bde1845d7df62ab7576bdb5e8f4de20.jpg_200x200q90.jpg",
        "price": 30000,
        "remark": "https://www.lazada.co.th/products/pdp-i5123984395.html",
        "sold": 0
    },
    {
        "product_name": "JC&House เต็นท์เสาลม 6.3 รุ่นอัพเกรด \"แถม rain cover\" รับประกัน 5 ปี สินค้าพร้อมส่ง",
        "product_image": "https://img.lazcdn.com/g/p/a23b99a0e12e534470287ca4ac8312b4.jpg_200x200q90.jpg",
        "price": 30000,
        "remark": "https://www.lazada.co.th/products/pdp-i5921873573.html",
        "sold": 0
    },
    {
        "product_name": "รุ่นอัพเกรดJC Houseเต็นท์เสาลม6.3+7.2mผ้าฝ้ายTC มาพร้อมทาร์ปกันฝนด้านหน้า กันน้ำระบายอากาศ มีช่องแอร์ รับประกันเสาลม5ปี",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc8ed5cbb13c2459d83be5f1f6bd906c5L.jpg_200x200q90.jpg",
        "price": 30000,
        "remark": "https://www.lazada.co.th/products/pdp-i5908349090.html",
        "sold": 0
    },
    {
        "product_name": "🔥พร้อมส่งในไทย🔥JC&House เต็นท์เสาลม 6.3+6.6m ผ้าฝ้าย TC มาพร้อมทาร์ปกันฝนด้านหน้า กันน้ำ ระบายอากาศ มีช่องแอร์",
        "product_image": "https://img.lazcdn.com/g/p/080374791ae6a96de521dcda02e59857.jpg_200x200q90.jpg",
        "price": 30000,
        "remark": "https://www.lazada.co.th/products/pdp-i5847745613.html",
        "sold": 5
    },
    {
        "product_name": "🔥พร้อมส่ง🔥Naturehike เต็นท์ Air 6.3 รุ่นอัพเกรด (มีช่องแอร์)ขนาด3-4คน มีปั้มลมในตัว ของแท้💯%",
        "product_image": "https://img.lazcdn.com/g/p/8250bbd6c77f3cbf00edee28fd191bdd.jpg_200x200q90.jpg",
        "price": 29800,
        "remark": "https://www.lazada.co.th/products/pdp-i5357717820.html",
        "sold": 4
    },
    {
        "product_name": "เต๊นท์ครอบครัว กางง่าย  Coleman Instant Up Pro 4 ใหม่ล่าสุด 2025",
        "product_image": "https://img.lazcdn.com/g/p/290453b29be5af18a5eb6abe218d9bac.png_200x200q90.png",
        "price": 29700,
        "remark": "https://www.lazada.co.th/products/pdp-i5909155352.html",
        "sold": 0
    },
    {
        "product_name": "เต้นท์ Naturehike Village 13 Flagship รุ่นใหม่ Full Option มีห้องเสริมมาในชุด ได้พื้นที่ใช้สอยสุดคุ้ม",
        "product_image": "https://img.lazcdn.com/g/p/294c7c86d000de1797dc05a005066296.jpg_200x200q90.jpg",
        "price": 29200,
        "remark": "https://www.lazada.co.th/products/pdp-i5896551629.html",
        "sold": 2
    },
    {
        "product_name": "เต็นท์เคบิ้น ทรงเสาเต็นท์คันธนู",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sf50a61c4627b4e67bef0336a16a87bc2j.jpg_200x200q90.jpg",
        "price": 29000,
        "remark": "https://www.lazada.co.th/products/pdp-i5256566837.html",
        "sold": 0
    },
    {
        "product_name": "MOBI GARDEN เต็นท์แคมปิ้งฮอลิเดย์สตาร์เต็นท์ครอบครัวกลางแจ้งกันน้ำแกลมปิ้ง",
        "product_image": "https://img.lazcdn.com/g/p/828306c2dfd955d5a4a4ac04e592fa85.jpg_200x200q90.jpg",
        "price": 28914,
        "remark": "https://www.lazada.co.th/products/pdp-i4937324946.html",
        "sold": 34
    },
    {
        "product_name": "เต็นท์ Air 8.0 เต็นท์แค้มป์ปิ้ง เต็นท์ลม ผ้าหนา ทนแดด ทนฝน กางง่ายเพียงสูบลมเข้า *สินค้าพร้อมส่งในไทย*",
        "product_image": "https://img.lazcdn.com/g/p/1d76c67ad025ccf55e77fa3a268e1447.jpg_200x200q90.jpg",
        "price": 28398,
        "remark": "https://www.lazada.co.th/products/pdp-i5594176229.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | เต็นท์กันน้ำ 2 ห้องนอน 2 ห้องนั่งเล่นพร้อมหลังคาบังแดด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd27e327b07e94688b2e34f11001daed2v.jpg_200x200q90.jpg",
        "price": 27873.32,
        "remark": "https://www.lazada.co.th/products/pdp-i16068794487.html",
        "sold": 21
    },
    {
        "product_name": "Naturehike Village 13 Auto Tent เต็นท์กางอัตโนมัติ 2 ห้องนอน ขนาดใหญ่ 4-6 คน",
        "product_image": "https://img.lazcdn.com/g/p/53a1f6339e042c78a268b39089f23ad8.jpg_200x200q90.jpg",
        "price": 27800,
        "remark": "https://www.lazada.co.th/products/pdp-i5697669702.html",
        "sold": 0
    },
    {
        "product_name": "Naturehike Village13 เต็นท์อัตโนมัติกลางแจ้ง ชาร์ม แคมป์ปิ้ง 2 หลัง 1 เต็นท์นั่งเล่น กันน้ำและกันลม ค่ายปิกนิกกลางแจ้งหรูหรารวดเร็วแบบพกพาเปิดเต็นท์",
        "product_image": "https://img.lazcdn.com/g/p/2b2d3b10ca2d26754339d88aaa754253.jpg_200x200q90.jpg",
        "price": 27798,
        "remark": "https://www.lazada.co.th/products/pdp-i4742702646.html",
        "sold": 19
    },
    {
        "product_name": "MUSHE | เต็นท์พองลมกันฝนขนาดใหญ่ 18.5 ตร.ม.",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se38a9ee8a3ba42a1aba88209255ff32aL.jpg_200x200q90.jpg",
        "price": 27734.86,
        "remark": "https://www.lazada.co.th/products/pdp-i16083313952.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์กระโจม WIMAN เต็นท์แกลมปิ้ง กันน้ำ ไม่มีเสากลาง วัสดุหนา ตั้งง่าย",
        "product_image": "https://img.lazcdn.com/g/p/f56344a0e55b9da5140b4174824a3aa6.png_200x200q90.png",
        "price": 27400,
        "remark": "https://www.lazada.co.th/products/pdp-i4884889959.html",
        "sold": 3
    },
    {
        "product_name": "เต็นท์กระโจม WIMAN แคนวาสไร้เสากลาง สีขาว กันน้ำ สำหรับแคมป์ปิ้ง/รีสอร์ท",
        "product_image": "https://img.lazcdn.com/g/p/642ff68ad62a52a82a8bf4ef9d522472.png_200x200q90.png",
        "price": 27400,
        "remark": "https://www.lazada.co.th/products/pdp-i5296564266.html",
        "sold": 0
    },
    {
        "product_name": "CHAOMU | เต็นท์โดมพีซีใสสร้างสรรค์ 3.5 เมตร",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S39da746231014180bb05bcdc15fbfd90U.jpg_200x200q90.jpg",
        "price": 27290,
        "remark": "https://www.lazada.co.th/products/pdp-i16073925841.html",
        "sold": 0
    },
    {
        "product_name": "Coleman Instant Up Pro 4P Tent ออกแบบมาเพื่อความสะดวกสบายและความรวดเร็วในการกาง",
        "product_image": "https://img.lazcdn.com/g/p/8101111f315d27b4cb9c2a23e1f5872e.png_200x200q90.png",
        "price": 27000,
        "remark": "https://www.lazada.co.th/products/pdp-i5911643367.html",
        "sold": 0
    },
    {
        "product_name": "Naturehike Village 13 เต็นท์อัตโนมัติกลางแจ้ง กันน้ำ กันลม พกพาสะดวก เปิดเร็ว เหมาะสำหรับแคมป์ปิ้งและปิกนิก CNH22ZP004",
        "product_image": "https://img.lazcdn.com/g/p/2b2d3b10ca2d26754339d88aaa754253.jpg_200x200q90.jpg",
        "price": 26602,
        "remark": "https://www.lazada.co.th/products/pdp-i16126117704.html",
        "sold": 0
    },
    {
        "product_name": "COD [จัดส่งฟรี] Inflatable Camping เต็นท์ Oxford ผ้า Air เต็นท์ Sunshine-Proof Inflatable House Quick เปิดสำหรับ Camping",
        "product_image": "https://img.lazcdn.com/g/p/6f979e5967b04cc53fbc5f541467a5bb.jpg_200x200q90.jpg",
        "price": 26448,
        "remark": "https://www.lazada.co.th/products/pdp-i6078678759.html",
        "sold": 0
    },
    {
        "product_name": "Naturehike เต็นท์ตั้งแคมป์กลางแจ้ง 2 ห้องนอนสำหรับครอบครัว 5-8 คน Village 13 Village 17 เต็นท์เปิดเร็วอัตโนมัติ 100% ของแท",
        "product_image": "https://img.lazcdn.com/g/p/2798eb2bcb44a108a25dfa9c73c4e700.jpg_200x200q90.jpg",
        "price": 26202,
        "remark": "https://www.lazada.co.th/products/pdp-i16129521863.html",
        "sold": 0
    },
    {
        "product_name": "Mountainhiker เต็นท์ผ้าใบ ผ้าฝ้า ขนาดใหญ่ พับได้ สนาม เดินป่า กันน้ำ3000mm ขนาดใหญ่ 10x10 ฟุต (6 คน) ขนาดกลาง 8x10 ฟุต (5 คน)",
        "product_image": "https://img.lazcdn.com/g/p/dc63e33735d24faae4e0699c07153afe.jpg_200x200q90.jpg",
        "price": 26154,
        "remark": "https://www.lazada.co.th/products/pdp-i5200884974.html",
        "sold": 15
    },
    {
        "product_name": "LinSi | เต็นท์ผ้าออกซฟอร์ดพราง กันน้ำ 3x4 เมตร",
        "product_image": "https://img.lazcdn.com/3rd/q/aHR0cHM6Ly9hZS1waWMtYTEuYWxpZXhwcmVzcy1tZWRpYS5jb20va2YvUzAyOWY5ZmJhZjUwMjQ0NWFiMzY1YzQxODhkMDFjNDY2TC5qcGc=_200x200q90.png",
        "price": 26114.48,
        "remark": "https://www.lazada.co.th/products/pdp-i16083248444.html",
        "sold": 0
    },
    {
        "product_name": "MSR Elixir 2 Tent V3 เต๊นท์เดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/fc131ca4ca83dc684701989a0c1e0020.png_200x200q90.png",
        "price": 25300,
        "remark": "https://www.lazada.co.th/products/pdp-i5690975004.html",
        "sold": 1
    },
    {
        "product_name": "Naturehike เต็นท์ Village 13​ ออโต้2ห้องนอน 1ห้องนั่งเล่น กางอัตโนมัติ​ กันน้ำระดับ2000mm นอนได้ 4-6 คน ระบายอากาศดี  CNH22ZP004",
        "product_image": "https://img.lazcdn.com/g/p/b475f60cdf7732e391a31da8ffe3f7b8.png_200x200q90.png",
        "price": 25198,
        "remark": "https://www.lazada.co.th/products/pdp-i16114352923.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์เป่าลม เต็นท์แคมปิ้ง ทรงบ้าน สนามนอน 12.6 ตร กันแดด UPF50+ กันฝน PU3000+",
        "product_image": "https://img.lazcdn.com/g/p/a4d684a131a6cfc9e1fb1d460fb31893.jpg_200x200q90.jpg",
        "price": 25192,
        "remark": "https://www.lazada.co.th/products/pdp-i5739963082.html",
        "sold": 7
    },
    {
        "product_name": "พร้อมส่ง Mountainhiker Vimanbell เต็นท์กระโจม ขนาดใหญ่ ผ้าใบอย่างดี กันน้ํา 8000 มม. เต็นท์กระดิ่ง สีขาว สําหรับตั้งแคมป์",
        "product_image": "https://img.lazcdn.com/g/p/522b8dec63c393ee0c3ea990fe33b660.jpg_200x200q90.jpg",
        "price": 25149.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5198881648.html",
        "sold": 8
    },
    {
        "product_name": "เต้นท์ Naturehike Village 13 Flagship (มีห้องเสริม) และ Village 13 Ti-Black ขนาด 4-6 คน",
        "product_image": "https://img.lazcdn.com/g/p/288cbc3208b23bac9680284a85707a28.jpg_200x200q90.jpg",
        "price": 25000,
        "remark": "https://www.lazada.co.th/products/pdp-i5896527954.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์ Automatic 2.0 BLACKDOG เต็นท์รุ่นใหม่เคลือบไวนิล ใหญ่ กางง่าย กันแดด กันฝน",
        "product_image": "https://img.lazcdn.com/g/p/2b8e5e75d66becc3c63e839964517668.png_200x200q90.png",
        "price": 25000,
        "remark": "https://www.lazada.co.th/products/pdp-i5811212910.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | เต็นท์ตั้งแคมป์แบบติดตั้งอัตโนมัติสำหรับค้างคืน",
        "product_image": "https://img.lazcdn.com/collect/ae/kf/S817e885e55184dacb1bc19e3cd7b5301l.jpg_200x200q90.jpg",
        "price": 24969.86,
        "remark": "https://www.lazada.co.th/products/pdp-i5894627412.html",
        "sold": 69
    },
    {
        "product_name": "New เต็นท์ใส รุ่น See Through Cooling Tent ติดแอร์ Bubble Tent มาตรฐาน มอก. วิมานแอร์ ขนาดเต็นท์ 3.5m x 3.5m",
        "product_image": "https://img.lazcdn.com/g/p/47fd288e5de37a53bcd7bc911b386e4f.jpg_200x200q90.jpg",
        "price": 24200,
        "remark": "https://www.lazada.co.th/products/pdp-i4924673300.html",
        "sold": 1
    },
    {
        "product_name": "NatureHike | เต็นท์กลางแจ้งกันน้ำทรงหกเหลี่ยม หนา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scc24b9afaeb24b2ebb42077cfa08afbcu.png_200x200q90.png",
        "price": 24111.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5894732724.html",
        "sold": 14
    },
    {
        "product_name": "Mountainhiker Village13 เต็นท์บ้านออโต้ 2ห้องนอน 1ห้องนั่งเล่น กางอัตโนมัติ กันน้ำกันแดด",
        "product_image": "https://img.lazcdn.com/g/p/7c1209ef7e833d3c3a4fe522921d1141.jpg_200x200q90.jpg",
        "price": 23995.2,
        "remark": "https://www.lazada.co.th/products/pdp-i5365541852.html",
        "sold": 1
    },
    {
        "product_name": "จัดส่งฟรี [มาถึงภายใน 3 วัน] เต็นท์เป่าลมสำหรับเด็กพกพา น้ำหนักเบา ทนทาน เหมาะสำหรับเล่นน้ำในสระและแคมป์ปิ้งฤดูร้อน",
        "product_image": "https://img.lazcdn.com/g/p/6457d71e95073107226f33ea5c9e0cb4.jpg_200x200q90.jpg",
        "price": 23994,
        "remark": "https://www.lazada.co.th/products/pdp-i16078280102.html",
        "sold": 0
    },
    {
        "product_name": "MOBI GARDEN เต็นท์แคมปิ้งกันน้ำสำหรับ2-3คนกันฝนกันลมพกพาได้พื้นที่ขนาดใหญ่4ฤดูกระเป๋าเป้ปีนเขา",
        "product_image": "https://img.lazcdn.com/g/p/0dd44a80d0d914024a5d375e290c3f35.jpg_200x200q90.jpg",
        "price": 23762,
        "remark": "https://www.lazada.co.th/products/pdp-i4399099459.html",
        "sold": 4
    },
    {
        "product_name": "DOD SHONEN TENT TC (T1-757-TN)",
        "product_image": "https://img.lazcdn.com/g/p/5b8b5e110ea8a8b3f9624f0aaac50e31.jpg_200x200q90.jpg",
        "price": 23520,
        "remark": "https://www.lazada.co.th/products/pdp-i5303842913.html",
        "sold": 0
    },
    {
        "product_name": "Mobi Garden | เต็นท์กันน้ำพับได้สำหรับ 3-4 คน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S01c9388bcd7c497b8e7211920cadfd20d.jpg_200x200q90.jpg",
        "price": 23090.5,
        "remark": "https://www.lazada.co.th/products/pdp-i6004026838.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์เป่าลมไฟฟ้าหลังรถ เต็นท์อุโมงค์ 14.2㎡ พร้อมผ้าใบกันแดด กางเร็ว แคมป์ปิ้ง SUV",
        "product_image": "https://img.lazcdn.com/g/p/1c1f9ac4e1389910b26e81d2ea76eb30.jpg_200x200q90.jpg",
        "price": 22998,
        "remark": "https://www.lazada.co.th/products/pdp-i5767727620.html",
        "sold": 2
    },
    {
        "product_name": "อย่าช้า!CABIN FB TENT 3-4 PERSON  KARANA #GREEN เต็นท์เคบิน เอฟบี 3-4 คนนอน สีเขียวมีจำนวนจำกัด",
        "product_image": "https://img.lazcdn.com/g/p/d6e6140fb3a48f16caa354d4be742246.jpg_200x200q90.jpg",
        "price": 22800,
        "remark": "https://www.lazada.co.th/products/pdp-i5166901835.html",
        "sold": 0
    },
    {
        "product_name": "MSR Elixir 1 Tent V3 เต็นท์เดินป่าน้ำหนักเบา สำหรับ 1 คน พกพาสะดวก กางง่ายเก็บง่าย",
        "product_image": "https://img.lazcdn.com/g/p/b129723b79ef0801c41cf862722362be.jpg_200x200q90.jpg",
        "price": 22800,
        "remark": "https://www.lazada.co.th/products/pdp-i5962683877.html",
        "sold": 0
    },
    {
        "product_name": "Mobi Garden | เต็นท์แคมปิ้งสำหรับครอบครัวกันฝน 2 ห้อง 1 โถง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S469285175381427ebb2e8b25203ed60fJ.jpg_200x200q90.jpg",
        "price": 22714.74,
        "remark": "https://www.lazada.co.th/products/pdp-i6023210929.html",
        "sold": 57
    },
    {
        "product_name": "Naturehike  เต็นท์ผ้าฝ้ายสุดคลาสสิค ดีไซน์วินเทจ สำหรับแคมป์ปิ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8a00614d664a42ae9540e1df8d79e20bz.png_200x200q90.png",
        "price": 22137.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5894522680.html",
        "sold": 1
    },
    {
        "product_name": "Coleman JP Tough Dome VI 3025 รุ่นใหม่ล่าสุด",
        "product_image": "https://img.lazcdn.com/g/p/c84c9b212418232d980987fd22842a5a.png_200x200q90.png",
        "price": 22000,
        "remark": "https://www.lazada.co.th/products/pdp-i5283330368.html",
        "sold": 0
    },
    {
        "product_name": "tourus | เต็นท์พองลมกันน้ำ แบบพกพา ไม่ต้องติดตั้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S16d3f750c8bd462a9dcfe37b57e5a00c0.png_200x200q90.png",
        "price": 21741.12,
        "remark": "https://www.lazada.co.th/products/pdp-i16083551064.html",
        "sold": 0
    },
    {
        "product_name": "พร้อมส่ง Mountainhiker เต็นท์กลางแจ้ง เต้นท์ครอบครัว เต๊นแคมป์ปิ้ง Cotton Canvas Tent เต็นท์นอน ขนาด 3-4คน 5-6คน กันแดด กันฝน เต็นท์ทรงบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/fd6a023642574ba660c1fd4f812becef.jpg_200x200q90.jpg",
        "price": 21596,
        "remark": "https://www.lazada.co.th/products/pdp-i4850193456.html",
        "sold": 0
    },
    {
        "product_name": "พร้อมส่ง Cotton Canvas Tent เต็นท์ครอบครัว Mountainhiker spring tant 3x3M กางง่าย เสาอลูมิเนียม ขนาดใหญ่10x10ft.(6 คน) , ขนาดกลาง8.5x6ft.(5คน)",
        "product_image": "https://img.lazcdn.com/g/p/dc63e33735d24faae4e0699c07153afe.jpg_200x200q90.jpg",
        "price": 21596,
        "remark": "https://www.lazada.co.th/products/pdp-i4492942803.html",
        "sold": 7
    },
    {
        "product_name": "เต็นท์เป่าลม Mountainhiker แบบหนา กันแดด กันฝน สําหรับตั้งแคมป์กลางแจ้ง UPF50+ ขนาด 6-8 คน",
        "product_image": "https://img.lazcdn.com/g/p/019823e634b3f408162f4102c457e358.jpg_200x200q90.jpg",
        "price": 21088,
        "remark": "https://www.lazada.co.th/products/pdp-i5602263130.html",
        "sold": 12
    },
    {
        "product_name": "เต็นท์สำหรับ 2 คน Coleman Roomy Front 2-Room  New 2025",
        "product_image": "https://img.lazcdn.com/g/p/44457a77148c60670bb9deb5331014da.jpg_200x200q90.jpg",
        "price": 20460,
        "remark": "https://www.lazada.co.th/products/pdp-i5698718649.html",
        "sold": 4
    },
    {
        "product_name": "MOBI GARDEN Era190 เต็นท์กางค้างคืน กันแดดกันฝนได้ พื้นที่กว้าง ทรงบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/ea3f716d6d7600ef4864087090f7c242.jpg_200x200q90.jpg",
        "price": 20000,
        "remark": "https://www.lazada.co.th/products/pdp-i6051469424.html",
        "sold": 0
    },
    {
        "product_name": "Mountainhiker  Canvas Bell Tent เต็นท์กระโจม ผ้าแคนวาส สีขาว กันน้ำร้อย ระบายอากาศดี ขนาดใหญ่ 3m 4m 5m",
        "product_image": "https://img.lazcdn.com/g/p/cae66796c41880159e1de38eec024966.jpg_200x200q90.jpg",
        "price": 19998,
        "remark": "https://www.lazada.co.th/products/pdp-i4330386068.html",
        "sold": 8
    },
    {
        "product_name": "Vidalido Vicore Instant Tent Size M และ L เต็นท์ กางอัตโนมัติ ขนาดใหญ่ 4-8 คน เต็นท์  ส่งไวจากกทม",
        "product_image": "https://img.lazcdn.com/g/p/8412a6f4fc02100143494a7051124f1c.jpg_200x200q90.jpg",
        "price": 19978,
        "remark": "https://www.lazada.co.th/products/pdp-i5521833432.html",
        "sold": 0
    },
    {
        "product_name": "ประกัน2ปี‼️พร้อมส่งทันทีใน24ชม.Mountain เต็นท์เสาลม6.2+6.2ตรม. แถมปั๊มไฟฟ้า‼️ห้องเสริม กันฝนกันแดด เคลือบไทเทดำ ต้านลมดี",
        "product_image": "https://img.lazcdn.com/g/p/71433e9557b4d8bf191de0055a1ba8b1.jpg_200x200q90.jpg",
        "price": 19863.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5937671885.html",
        "sold": 0
    },
    {
        "product_name": "MSR Zoic 2 Tent เต็นท์น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/96d13a20f3cd4896292881c541eae54f.png_200x200q90.png",
        "price": 19800,
        "remark": "https://www.lazada.co.th/products/pdp-i5873126710.html",
        "sold": 0
    },
    {
        "product_name": "Vidalido เต็นท์เสาลม ขนาดใหญ่ 3-4 คน กันน้ำ กันแดด พร้อมกระเป๋าจัดเก็บ",
        "product_image": "https://img.lazcdn.com/g/p/fca2b212ed4e2d36e3390de01559750b.png_200x200q90.png",
        "price": 19800,
        "remark": "https://www.lazada.co.th/products/pdp-i5930431912.html",
        "sold": 0
    },
    {
        "product_name": "Vidalido Air Tent Wish House เต็นท์เสาลม มาใหม่ รุ่นอัพเกรด ขนาด 4-5 คน ของแท้💯 รับประกัน 1 ปี",
        "product_image": "https://img.lazcdn.com/g/p/38dce184ba5ee0b886428420f10e8dba.jpg_200x200q90.jpg",
        "price": 19800,
        "remark": "https://www.lazada.co.th/products/pdp-i6005101894.html",
        "sold": 0
    },
    {
        "product_name": "Vidalido Wish House เต็นท์เสาลม รุ่นใหม่ รองรับได้ 3-4 คน กันน้ำ กันแดด กางง่าย อุปกรณ์ครบชุด พร้อมกระเป๋าจัดเก็บ",
        "product_image": "https://img.lazcdn.com/g/p/805addc7f133b567e11a60237d7b66d0.jpg_200x200q90.jpg",
        "price": 19780,
        "remark": "https://www.lazada.co.th/products/pdp-i5957197678.html",
        "sold": 0
    },
    {
        "product_name": "ABORON CQ5 เต็นท์ สำหรับผู้ใหญ่4-6คนเต็นท์ตั้งแคมป์แบบเป่าลมเป่าลมร้อนพร้อมแจ็คเตากันน้ำได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd0c66193aae3407396d7ef0680824e52E.jpg_200x200q90.jpg",
        "price": 19498.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5856076536.html",
        "sold": 1
    },
    {
        "product_name": "Aboron เต็นท์เป่าลมขนาด 6.3–12 ตร.ม กันน้ำและระบายอากาศได้ แถมปั๊มลม ของแท้รับประกัน พร้อมส่งทันที",
        "product_image": "https://img.lazcdn.com/g/p/4edd2079faa525c796345d412dce7863.png_200x200q90.png",
        "price": 19498.5,
        "remark": "https://www.lazada.co.th/products/pdp-i5974152652.html",
        "sold": 2
    },
    {
        "product_name": "Naturehike|เต็นท์พับได้เปิดเร็ว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7e3c03c5fc954e0b9f175ffbb6b7a292U.png_200x200q90.png",
        "price": 19335.52,
        "remark": "https://www.lazada.co.th/products/pdp-i5894459938.html",
        "sold": 16
    },
    {
        "product_name": "WOLFNEST | เต็นท์พองลมพกพาป้องกันฝนพร้อมที่พักผ่อนจากแดด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8ed6f4ed7caf46f39ce67959611bf54fv.jpg_200x200q90.jpg",
        "price": 19298.76,
        "remark": "https://www.lazada.co.th/products/pdp-i16084233747.html",
        "sold": 0
    },
    {
        "product_name": "MOBI GARDEN เต็นท์ตั้งแคมป์2-3คนกันน้ำกันฝน Windproof 4ฤดูกาลแบกเป้เดินป่า",
        "product_image": "https://img.lazcdn.com/g/p/5f941b5c04122e5f95399dfc90c357f1.jpg_200x200q90.jpg",
        "price": 19220,
        "remark": "https://www.lazada.co.th/products/pdp-i4229640338.html",
        "sold": 2
    },
    {
        "product_name": "เต็นท์เสาลม Mountain Air Village 13 รุ่นใหม่ กันฝน PU 4000mm กันแดด UPF50+ แถมปั้มลมฟรี",
        "product_image": "https://img.lazcdn.com/g/p/041624db3edfd4c3f1b9d2d7b9944024.jpg_200x200q90.jpg",
        "price": 19200,
        "remark": "https://www.lazada.co.th/products/pdp-i5976479751.html",
        "sold": 0
    },
    {
        "product_name": "tourus | เต็นท์แค้มปิ้งพองตัวเอง 6.3 ตร.ม",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1d5b608968ca46f380bdee6a97b68be7w.jpg_200x200q90.jpg",
        "price": 19041.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16083831773.html",
        "sold": 0
    },
    {
        "product_name": "‼️ประกัน2ปี‼️พร้อมส่งทันทีใน24ชม.🔥Mountain เต็นท์เสาลม8.0+RiancoverเคลือบดำประตูTPUใสมุ้งเสา3เส้น มีช่องใส่ท่อแอร์‼️",
        "product_image": "https://img.lazcdn.com/g/p/1a88113c12d5e0a4d607ba552b2abd9f.jpg_200x200q90.jpg",
        "price": 18200,
        "remark": "https://www.lazada.co.th/products/pdp-i5808438972.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์ Vidalido vicore 2022 เต็นท์แคมป์ปิ้ง เต็นท์สนาม เต็นท์อัตโนมัติ รุ่นใหม่ล่าสุด ขนาด 6-8 คน 2 ห้องนอน กางง่าย พับเก็บง่าย",
        "product_image": "https://img.lazcdn.com/g/p/4b99e6811a85a4890e220b4772abb5a3.png_200x200q90.png",
        "price": 18780,
        "remark": "https://www.lazada.co.th/products/pdp-i3911227095.html",
        "sold": 9
    },
    {
        "product_name": "Coleman JP Roomy Front 2-Room {Graige -สีเทาเบจ}#เต็นท์สองห้องขนาดกะทัดรัดนอนได้ 2-3 คน",
        "product_image": "https://img.lazcdn.com/g/p/93003a94fbe609cac8c7037b8723fda4.jpg_200x200q90.jpg",
        "price": 18600,
        "remark": "https://www.lazada.co.th/products/pdp-i5657800929.html",
        "sold": 0
    },
    {
        "product_name": "3F UL เกียร์ LanShan 2 pro เต็นท์ 2 คนกลางแจ้ง Ultralight Camping เต็นท์ 3 ฤดู Professional 20D ไนลอนทั้งสองด้านซิลิคอนเต็นท์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc2a86995d29e4a969c10e1fb1ace3389o.jpg_200x200q90.jpg",
        "price": 18338.62,
        "remark": "https://www.lazada.co.th/products/pdp-i5724878743.html",
        "sold": 0
    },
    {
        "product_name": "Mobi Garden | ชุดเต็นท์ค่ายพิรามิดทรงยูร์ตฝ้ายมองโกล",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sbf532e2864fa43c8994b56579b90cf62g.jpg_200x200q90.jpg",
        "price": 18054,
        "remark": "https://www.lazada.co.th/products/pdp-i16068996417.html",
        "sold": 21
    },
    {
        "product_name": "MOBI GARDEN เต็นท์แคมป์ปิ้งสำหรับครอบครัวเต็นท์อัตโนมัติเต็นท์พื้นที่ขนาดใหญ่2เสากันน้ำฟรี",
        "product_image": "https://img.lazcdn.com/g/p/3419c15f7c4877ad8f35b28dc9557208.jpg_200x200q90.jpg",
        "price": 18000,
        "remark": "https://www.lazada.co.th/products/pdp-i4621210733.html",
        "sold": 41
    },
    {
        "product_name": "🔥พร้อมส่ง🔥Naturehike 6.0 รุ่น2 VIP จัดเต็ม เต็นท์กันแดดไวนิลไทเทเนียนกลางแจ้ง สำหรับ3-4คน",
        "product_image": "https://img.lazcdn.com/g/p/aa569e72a771dc1aee8231966bd4bf96.jpg_200x200q90.jpg",
        "price": 18000,
        "remark": "https://www.lazada.co.th/products/pdp-i5752527645.html",
        "sold": 1
    },
    {
        "product_name": "Onetigris Camping RAVEN NEST Tunnel Hot  เต็นท์ตั้งเเคมป์ขนาดใหญ่ เต็นท์กันฝน เต็นท์แคมป์ เต็นท์",
        "product_image": "https://img.lazcdn.com/g/p/6839a431106b7e6920d26b3b67a0a44e.jpg_200x200q90.jpg",
        "price": 17980,
        "remark": "https://www.lazada.co.th/products/pdp-i5971041698.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์เสาลม Vidalido รุ่นใหม่ รองรับ3-4คน กันน้ำ กันแดด อุปกรณ์ครบชุด Wish House",
        "product_image": "https://img.lazcdn.com/g/p/b577e9e880f7cde81f83450f0363bb4c.jpg_200x200q90.jpg",
        "price": 17980,
        "remark": "https://www.lazada.co.th/products/pdp-i5989833320.html",
        "sold": 1
    },
    {
        "product_name": "อย่าช้า!กลางแจ้งหนา oxford เต็นท์ตั้งแคมป์เต็นท์พายุฝนคู่ชั้นเดียวเตียงตั้งแคมป์เต็นท์ใช้กลางแจ้งอุปกรณ์มีจำนวนจำกัด",
        "product_image": "https://img.lazcdn.com/g/p/4a81830de8a58c3a1d1f6e99846167d0.jpg_200x200q90.jpg",
        "price": 17900,
        "remark": "https://www.lazada.co.th/products/pdp-i5166632731.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | เต็นท์เดินป่าเบาๆ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfefc8be326164651afefca4bed4418dck.png_200x200q90.png",
        "price": 17888.32,
        "remark": "https://www.lazada.co.th/products/pdp-i6064565077.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | เต็นท์แค้มปิ้งติดตั้งง่าย กัน UV",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S58cc88fbba9d42af936b7e0e0ca1865e7.png_200x200q90.png",
        "price": 17726.64,
        "remark": "https://www.lazada.co.th/products/pdp-i5894789040.html",
        "sold": 147
    },
    {
        "product_name": "Mobi Garden | เต็นท์กันแดดแบบตั้งเองได้ ใช้งานได้สองทาง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S005a615ffdd6454aacfadcf545b2690cz.jpg_200x200q90.jpg",
        "price": 17535.72,
        "remark": "https://www.lazada.co.th/products/pdp-i6024359321.html",
        "sold": 103
    },
    {
        "product_name": "Naturehike Double Layer Backpacking Tent 10D Nylon 1-2 Person Ultralight Aluminum Pole Camping Tent Waterproof Lightweight",
        "product_image": "https://img.lazcdn.com/g/p/075453cc7f473cea46777e34898c5cb8.jpg_200x200q90.jpg",
        "price": 17300,
        "remark": "https://www.lazada.co.th/products/pdp-i16054702230.html",
        "sold": 0
    },
    {
        "product_name": "เต๊นท์ Vidalido Teepee Auto Pro Tent เต๊นท์ทรงกระโจม  เทอเรส ใหญ่ นั่งเล่นได้สบาย ไม่ต้องกางทาร์ป ส้งจากไทย",
        "product_image": "https://img.lazcdn.com/g/p/e316a3999b51c1530f607cd522ee360f.jpg_200x200q90.jpg",
        "price": 17180,
        "remark": "https://www.lazada.co.th/products/pdp-i4203265755.html",
        "sold": 4
    },
    {
        "product_name": "⛺แบรนด์แท้ 100% 🚙Laduta BigGen เต็นท์(ต่อ)ท้ายรถ SUV+PPV +รถไฟฟ้า เหมาะสำหรับครอบครัวใหญ่ นอนได้6-8คน",
        "product_image": "https://img.lazcdn.com/g/p/667af85fce7d5fbb38a06dd0d665cf36.jpg_200x200q90.jpg",
        "price": 17180,
        "remark": "https://www.lazada.co.th/products/pdp-i5435607029.html",
        "sold": 0
    },
    {
        "product_name": "BUNISE เต็นท์ทรงสามเหลี่ยมอินเดียน แบบผ้าเสริมหนา ใช้ได้ทั้งเด็กและผู้ใหญ่ เหมาะสำหรับแคมป์กลางแจ้ง ในบ้าน หรือสวนพักผ่อน รุ่น P2410 จัดส่งฟรีทั่วไทย",
        "product_image": "https://img.lazcdn.com/g/p/cf474258bb1c11bc9b7abb91826d2f2f.jpg_200x200q90.jpg",
        "price": 17100,
        "remark": "https://www.lazada.co.th/products/pdp-i5242897425.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์ประกอบ 4x8 ทรงจั่ว ผ้าใบ UV เเท้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S35cfac17671d48f681278934ef6ce67eU.jpg_200x200q90.jpg",
        "price": 17000,
        "remark": "https://www.lazada.co.th/products/pdp-i4896199510.html",
        "sold": 12
    },
    {
        "product_name": "Homful Bell YART  เต็นท์กระโจม ผ้าTC Cotton Canvas สวยหรู   มี 3 ขนาด ให้เลือก   พร้อมส่งจากกทม.",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S12b81f1c1a674803a01e8f2e68b3d691C.jpg_200x200q90.jpg",
        "price": 17000,
        "remark": "https://www.lazada.co.th/products/pdp-i4979820808.html",
        "sold": 0
    },
    {
        "product_name": "🔥ส่งจากไทย🔥Vidalido Poon Saan Pro XL เต็นท์ Cabin ขนาดใหญ่ 4-6 คน ไซส์ XL กางง่าย สวยงาม",
        "product_image": "https://img.lazcdn.com/g/p/af9aad5d4ec8d09414937c33ffdbf2a3.jpg_200x200q90.jpg",
        "price": 16980,
        "remark": "https://www.lazada.co.th/products/pdp-i5789664068.html",
        "sold": 1
    },
    {
        "product_name": "Onetigris COCO Nest Solo Hot Tent เต็นท์ตั้งเเคมป์ เต็นท์แคมป์ เต็นท์ เต้นท์สนาม",
        "product_image": "https://img.lazcdn.com/g/p/793ac480c218195ff22dc64b93676fb0.jpg_200x200q90.jpg",
        "price": 16980,
        "remark": "https://www.lazada.co.th/products/pdp-i5876495894.html",
        "sold": 0
    },
    {
        "product_name": "Naturehike Thailand เต็นท์ Cloud Trace 10D superlight single tent",
        "product_image": "https://img.lazcdn.com/g/p/1c55c52ee81c51d71368d5c314257b2b.jpg_200x200q90.jpg",
        "price": 16980,
        "remark": "https://www.lazada.co.th/products/pdp-i4048079817.html",
        "sold": 0
    },
    {
        "product_name": "เต๊นท์พร้อมกราวชีท Coleman Cross Dome 270 #สีชาโคล  + Ground Sheet (flysheet thai) สั่งตัดตรงรุ่นขนาด 270*270",
        "product_image": "https://img.lazcdn.com/g/p/1ceb5a822cca533324457aff6fd4ed2a.jpg_200x200q90.jpg",
        "price": 16760,
        "remark": "https://www.lazada.co.th/products/pdp-i5296622988.html",
        "sold": 0
    },
    {
        "product_name": "Naturehike 10D Camping เต็นท์ Ultralight กันน้ํา 1 คนเดินป่าเต็นท์กลางแจ้งชายหาดแบบพกพาตกปลา Trekking Shelter เต็นท์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S04f489cf8b8b4f30a34216abc8e04b83b.jpg_200x200q90.jpg",
        "price": 16699.14,
        "remark": "https://www.lazada.co.th/products/pdp-i5513223169.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์เสาลมอุโมงค์ ใหญ่16.9ตรม. กันน้ำ3000mm ชมดาว ประตูTPUใส กันยุงได้ 360° วัสดุทนทาน",
        "product_image": "https://img.lazcdn.com/g/p/a8b14e002750e18007c5d77e09ca4da1.jpg_200x200q90.jpg",
        "price": 16696.8,
        "remark": "https://www.lazada.co.th/products/pdp-i5807430388.html",
        "sold": 0
    },
    {
        "product_name": "NatureHike | เต็นท์ 2 คน Naturehike รุ่น Yun Shang – น้ำหนักเบา 1.2 กก. กันฝนได้ เเคมป์ปิ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sefe0c352873c42e2ab8bdec4e13132352.jpg_200x200q90.jpg",
        "price": 16615.44,
        "remark": "https://www.lazada.co.th/products/pdp-i5894197357.html",
        "sold": 5
    },
    {
        "product_name": "NatureHike | เต็นท์แค้มปิ้งกันฝนสำหรับการเดินทางข้ามคืน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3522c2aff37542e7aa79e3b163bc1734w.jpg_200x200q90.jpg",
        "price": 16520.66,
        "remark": "https://www.lazada.co.th/products/pdp-i5894714405.html",
        "sold": 12
    },
    {
        "product_name": "EUSSUE | เต็นท์กันน้ำหลังรถเปิดเร็วทรงหกเหลี่ยมขนาดใหญ่",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se50b7e03fe1742e7ae44f82675faa2ceO.jpg_200x200q90.jpg",
        "price": 16501.24,
        "remark": "https://www.lazada.co.th/products/pdp-i16083434180.html",
        "sold": 0
    },
    {
        "product_name": "🔥พร้อมส่ง🔥Vidalido Vicore Auto Instant Tent Size M และ L เต็นท์กางอัตโนมัติ ขนาดใหญ่ 4-8 คน วัสดุพรีเมี่ยม",
        "product_image": "https://img.lazcdn.com/g/p/0bd11cc2cec994a4534d2e41ec576d9f.jpg_200x200q90.jpg",
        "price": 16400,
        "remark": "https://www.lazada.co.th/products/pdp-i5789208314.html",
        "sold": 0
    },
    {
        "product_name": "อย่าช้า!พร้อมส่งกระโจมดาว เต็นท์กิจกรรม Mountpeak เต็นท์ครอบครัว เต็นท์ขนาดใหญ่ เต็นท์สนาม เต็นท์เดินป่า เต็นท์พับได้มีจำนวนจำกัด",
        "product_image": "https://img.lazcdn.com/g/p/ceba981665a061e901e58ff30c7a2590.jpg_200x200q90.jpg",
        "price": 16396,
        "remark": "https://www.lazada.co.th/products/pdp-i5166697601.html",
        "sold": 0
    },
    {
        "product_name": "ZHUOLESHI | เต็นท์ป้องกัน UV สำหรับท้ายรถ อัตโนมัติ 2 ห้องและพื้นที่นั่งเล่นพร้อมหลังคา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S81fc8bb2e7d34d37a5bc77a338a58e978.jpg_200x200q90.jpg",
        "price": 16304.54,
        "remark": "https://www.lazada.co.th/products/pdp-i6075853699.html",
        "sold": 0
    },
    {
        "product_name": "อย่าช้า!เต้นท์ สนามเดินป่า Lagoona KN ล๊อตใหม่2023 (สินค้าพร้อมส่ง)มีจำนวนจำกัด",
        "product_image": "https://img.lazcdn.com/g/p/92223f806241b3ab0fe35f72d9bef0bb.jpg_200x200q90.jpg",
        "price": 16180,
        "remark": "https://www.lazada.co.th/products/pdp-i5166660643.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์ประกอบ3x6 ทรงโค้ง",
        "product_image": "https://img.lazcdn.com/g/p/668bda3f7c6bf527c5488128438569c0.jpg_200x200q90.jpg",
        "price": 16000,
        "remark": "https://www.lazada.co.th/products/pdp-i5784414053.html",
        "sold": 0
    },
    {
        "product_name": "Naturehike พร้อมส่งในไทย เต็นท์ 6.0 รุ่น 2 เต็นท์กางอัตโนมัติกันแดดไวนิลไทเทเนียมกลางแจ้ง 4-8 คน กันน้ำดีเยี่ยม",
        "product_image": "https://img.lazcdn.com/g/p/cc81bc01858138a50184eb701767af9b.jpg_200x200q90.jpg",
        "price": 15998,
        "remark": "https://www.lazada.co.th/products/pdp-i5906842750.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์ Vidalido Vicore Instant by Passion Camp",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S38da032341024765a629629f9f54681aN.jpg_200x200q90.jpg",
        "price": 15980,
        "remark": "https://www.lazada.co.th/products/pdp-i5809191414.html",
        "sold": 4
    },
    {
        "product_name": "Tanxianzhe เต็นท์เป่าลมอัตโนมัติ TXZ-2000พื้นที่กว้างขวาง สำหรับ3-6คน ทนแดดทนฝน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd03b2076e2fd497ca86c167b5e62235bn.jpg_200x200q90.jpg",
        "price": 15980,
        "remark": "https://www.lazada.co.th/products/pdp-i5828693237.html",
        "sold": 0
    },
    {
        "product_name": "Vidalido Vicore Auto Instant Tent Size M และ L เต็นท์กางอัตโนมัติ ขนาดใหญ่ 4-8 คน วัสดุพรีเมี่ยม",
        "product_image": "https://img.lazcdn.com/g/p/d57d4800a4fe070ebfa4bc1e2f62c680.jpg_200x200q90.jpg",
        "price": 15980,
        "remark": "https://www.lazada.co.th/products/pdp-i5832645108.html",
        "sold": 3
    },
    {
        "product_name": "🔥Peir️🔥 เตียงลมแคมป์ปิ้ง พร้อมเต็นท์ในตัว มีมุ้งกันยุง นอนนุ่ม รับน้ำหนักถึง 300kg",
        "product_image": "https://img.lazcdn.com/g/p/58f54ba9d5464c4054342e22c043b59c.jpg_200x200q90.jpg",
        "price": 15800,
        "remark": "https://www.lazada.co.th/products/pdp-i5853710744.html",
        "sold": 0
    },
    {
        "product_name": "3F UL เกียร์อย่างเป็นทางการ Lanshan 1 pro เต็นท์กลางแจ้ง 1 คน Ultralight Camping เต็นท์ 3 Season Professional 20D Silnylon Rodless",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S7973c7a9b01841ef940170723d2444b3y.jpg_200x200q90.jpg",
        "price": 15347.9,
        "remark": "https://www.lazada.co.th/products/pdp-i5725964690.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์แคมปิ้งอัตโนมัติกันน้ำแบบพองได้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se23f1263b953475985b0ad42d929a759z.jpg_200x200q90.jpg",
        "price": 15341.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16076461281.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์อัตโนมัติ Naturehike Village 6.0 รุ่นเปิดเร็ว สำหรับ 4-8 คน ผ้า 150D ทาไทเทเนียมกลูสีดำ สำหรับแคมป์กลางแจ้ง และเดินป่าครอบครัว",
        "product_image": "https://img.lazcdn.com/g/p/9fb54ad6f4ad9ee9066e8174d3d9db38.jpg_200x200q90.jpg",
        "price": 15310.08,
        "remark": "https://www.lazada.co.th/products/pdp-i6027180895.html",
        "sold": 1
    },
    {
        "product_name": "K2 STEALTH  สีดำ เต็นท์แคมป์ปิ้ง 6P (เสาอลูมิเนียม)",
        "product_image": "https://img.lazcdn.com/g/p/e48a1cd7f521df38dd5be70958458ed8.jpg_200x200q90.jpg",
        "price": 14546.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5338096462.html",
        "sold": 98
    },
    {
        "product_name": "เต็นท์แคมป์ปิ้ง K2 STEALTH เต็นท์กันน้ำ ขนาด5-6คน เสาอลูมิเนียม  เต็นท์K2(รับประตลอดอายุการใช้งาน)",
        "product_image": "https://img.lazcdn.com/g/p/d697106241ee222ff1d62f2c1c33fca0.jpg_200x200q90.jpg",
        "price": 15200,
        "remark": "https://www.lazada.co.th/products/pdp-i5397620969.html",
        "sold": 5
    },
    {
        "product_name": "เต็นท์ K2 STEALTH สำหรับ 5-6 คนนอน เต็นท์แคมป์ปิ้ง กันฝนกันลม",
        "product_image": "https://img.lazcdn.com/g/p/37ad06279114d61de84e8227cff19311.jpg_200x200q90.jpg",
        "price": 15200,
        "remark": "https://www.lazada.co.th/products/pdp-i5852774159.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์ K2 STEALTH เต็นท์แคมป์ปิ้ง 5 คนนอน ใหญ่พิเศษ  เต็นท์คุณภาพสูง กันน้ำ ประกันตลอดอายุการใช้งาน",
        "product_image": "https://img.lazcdn.com/g/p/886eae737858868c205df9a180458f77.jpg_200x200q90.jpg",
        "price": 15200,
        "remark": "https://www.lazada.co.th/products/pdp-i5008500588.html",
        "sold": 1
    },
    {
        "product_name": "เต็นท์​K2 STEALTH Black Edition2024  ขนาด5-6คนนอน รับประกันตลอดอายุการใช้งาน",
        "product_image": "https://img.lazcdn.com/g/p/b71f8ad8ea714cafb94c7f9a1f18f810.jpg_200x200q90.jpg",
        "price": 15200,
        "remark": "https://www.lazada.co.th/products/pdp-i5007420321.html",
        "sold": 14
    },
    {
        "product_name": "Field and camping เต็นท์LAGOONA KN - สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/1e4b50ecd6cfb846c616a652310f539e.jpg_200x200q90.jpg",
        "price": 15190,
        "remark": "https://www.lazada.co.th/products/pdp-i16098764340.html",
        "sold": 1
    },
    {
        "product_name": "Field and Camping เต็นท์ LAGOONA EX - สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/d8a4bf563e82ef3900ad468984e27813.jpg_200x200q90.jpg",
        "price": 15190,
        "remark": "https://www.lazada.co.th/products/pdp-i16098812206.html",
        "sold": 0
    },
    {
        "product_name": "OneTigris PLATOON Camping Tent เต็นท์กำบัง Shelter เต็นท์บุชคราฟ เต็นท์แคมป์ปิ้ง",
        "product_image": "https://img.lazcdn.com/g/p/04ee6131ae6bbff3b37664a1a6cc09fa.jpg_200x200q90.jpg",
        "price": 15180,
        "remark": "https://www.lazada.co.th/products/pdp-i5226374287.html",
        "sold": 1
    },
    {
        "product_name": "Coleman JP Cross Dome 270 Charcoal เต็นท์ทรงโดม สำหรับ 4-5 คน",
        "product_image": "https://img.lazcdn.com/g/p/0769ee594dcc54a70000c026958c5796.png_200x200q90.png",
        "price": 15180,
        "remark": "https://www.lazada.co.th/products/pdp-i5099860717.html",
        "sold": 0
    },
    {
        "product_name": "เต๊นท์ coleman jp crossdome 270 (สีใหม่ล่าสุด)",
        "product_image": "https://img.lazcdn.com/g/p/72fed0d0eaa5847ae2716aa0d82427d5.jpg_200x200q90.jpg",
        "price": 15180,
        "remark": "https://www.lazada.co.th/products/pdp-i5086628220.html",
        "sold": 0
    },
    {
        "product_name": "Naturehike 2025 ใหม่Campingเต็นท์Ultralight 2 คนกันน้ําขนาดใหญ่Canopyเต็นท์กลางแจ้ง 4 Season 1 คนเต็นท์ชายหาด",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S6d86158749474e99b437ad898bff17adw.jpg_200x200q90.jpg",
        "price": 15095.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5894347927.html",
        "sold": 0
    },
    {
        "product_name": "winpolar | เต็นท์ติดท้ายรถ SUV ติดตั้งได้ทันที",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S085dc78c4591413a9ca4760bacc6c40ah.jpg_200x200q90.jpg",
        "price": 15022.66,
        "remark": "https://www.lazada.co.th/products/pdp-i16085963039.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์ Coleman Cross Dome 270 #Chacoal Grey ล็อตใหม่ 2025",
        "product_image": "https://img.lazcdn.com/g/p/c6d3bde44d7152760be61c66e6678172.jpg_200x200q90.jpg",
        "price": 15000,
        "remark": "https://www.lazada.co.th/products/pdp-i5086881558.html",
        "sold": 44
    },
    {
        "product_name": "Naturehike Village 6.02 เต็นท์กางอัตโนมัติ ขนาด 3-4 คน มีให้เลือก 2 แบบ",
        "product_image": "https://img.lazcdn.com/g/p/d66679b18535604175a52b52509a1a40.jpg_200x200q90.jpg",
        "price": 14980,
        "remark": "https://www.lazada.co.th/products/pdp-i5698894185.html",
        "sold": 4
    },
    {
        "product_name": "NatureHike | เต็นท์แค้มปิ้งสำหรับคนเดียวและสองคน ขนาดหนึ่งห้องหนึ่งโถง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S8b4e2e0ea55244d7a21053e8b342597fL.png_200x200q90.png",
        "price": 14905.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5894245840.html",
        "sold": 2
    },
    {
        "product_name": "3F UL เกียร์ LanShan 2 2 คน Outdoor Ultralight Camping เต็นท์ 3 ฤดู Professional 15D ซิลิโคน Rodless-เต็นท์ 4 ฤดู",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Se8ed6b1c93a2429a8574fd9f7dc16aad0.jpg_200x200q90.jpg",
        "price": 14896.34,
        "remark": "https://www.lazada.co.th/products/pdp-i5722138676.html",
        "sold": 0
    },
    {
        "product_name": "OneTigris TETRA Ultralight Tent เต็นท์กระโจมสำหรับ 2 คน เต็นท์แคมป์ปิ้ง",
        "product_image": "https://img.lazcdn.com/g/p/4d95db63511fd4af4126332e8356c6e4.jpg_200x200q90.jpg",
        "price": 14780,
        "remark": "https://www.lazada.co.th/products/pdp-i4316451365.html",
        "sold": 1
    },
    {
        "product_name": "NaturehikeThailand Mongar 15D UL light weight camping tent เต็นท์สำหรับเดินป่า Mongar 15D ขนาด 1-2 คน",
        "product_image": "https://img.lazcdn.com/g/p/e111f9f4dea73218e1bb6c209291d57f.jpg_200x200q90.jpg",
        "price": 14700,
        "remark": "https://www.lazada.co.th/products/pdp-i5684355769.html",
        "sold": 0
    },
    {
        "product_name": "เต็นท์เป่าลม 6.3+6.3 ตรม เต็นท์แคมปิ้ง มีช่องระบายอากาศ แบบพกพา กันน้ำระบายอากาศได้ 5-10คน",
        "product_image": "https://img.lazcdn.com/g/p/4191f7c87327ffd3524dbce5d28596a1.jpg_200x200q90.jpg",
        "price": 14635.2,
        "remark": "https://www.lazada.co.th/products/pdp-i6042878345.html",
        "sold": 2
    },
    {
        "product_name": "เต็นท์ครอบคัว Blackdeer Archeos Family นอนได้ 4 คน ของแท้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5e832a4b3dd843b0a3d513a813ad930f5.jpg_200x200q90.jpg",
        "price": 14400,
        "remark": "https://www.lazada.co.th/products/pdp-i4952529840.html",
        "sold": 0
    },
    {
        "product_name": "Outdoor Folding Lounger, Reclining Beach Chair with Adjustable Backrest, Waterproof Sunbed for Pool, Patio, Garden, Stackable Design",
        "product_image": "https://img.lazcdn.com/g/p/633bb3e3064bfa0eddab31569e893c24.jpg_200x200q90.jpg",
        "price": 37271.44,
        "remark": "https://www.lazada.co.th/products/pdp-i6074520398.html",
        "sold": 0
    },
    {
        "product_name": "Rester เก้าอี้นวด เก้าอี้นวดพกพาเก้าอี้ปิคนิคพับได้ พร้อมที่ฟพักแขน รุ่น iCamp",
        "product_image": "https://img.lazcdn.com/g/p/73c1cb4e392eb91bd66ce87b392d4ef4.jpg_200x200q90.jpg",
        "price": 19800,
        "remark": "https://www.lazada.co.th/products/pdp-i6063935997.html",
        "sold": 0
    },
    {
        "product_name": "Snowpeak | เก้าอี้พับแบบพกพารุ่น LV-091 น้ำหนักเบา เหมาะสำหรับสถานที่กลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd9f08a0ec76f4a3b9240f3fcf3de32c6V.jpg_200x200q90.jpg",
        "price": 17845.12,
        "remark": "https://www.lazada.co.th/products/pdp-i5877016440.html",
        "sold": 23
    },
    {
        "product_name": "Snowpeak | เก้าอี้ฮาร์ปพกพาพับได้ หลังสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5085cdd60b864bc8bd4c0c1128cc26a6P.jpg_200x200q90.jpg",
        "price": 17801.36,
        "remark": "https://www.lazada.co.th/products/pdp-i5878104183.html",
        "sold": 3
    },
    {
        "product_name": "NEMO MOONLITE ELITE RECLINING CAMP CHAIR  เก้าอี้พกพา น้ำหนักเบา เนื้อผ้าตาข่ายโปร่ง จัดเก็บได้เล็ก พกพาสะดวก",
        "product_image": "https://img.lazcdn.com/g/p/8a20c6949efffb70e2cbfc83121b4b57.jpg_200x200q90.jpg",
        "price": 17064,
        "remark": "https://www.lazada.co.th/products/pdp-i5144679723.html",
        "sold": 3
    },
    {
        "product_name": "KUJIMA | เก้าอี้พับได้สำหรับกลางแจ้ง อลูมิเนียม รับน้ำหนักสูง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S60221cf428a040bea6d6ee951b06eeear.jpg_200x200q90.jpg",
        "price": 11935.8,
        "remark": "https://www.lazada.co.th/products/pdp-i16053563812.html",
        "sold": 1
    },
    {
        "product_name": "NEMO เก้าอี้เดินป่า MOONLITE RECLINING CAMP CHAIR",
        "product_image": "https://img.lazcdn.com/g/p/0eaed34e909572a2ce27b8c6bb733e63.jpg_200x200q90.jpg",
        "price": 11900,
        "remark": "https://www.lazada.co.th/products/pdp-i5150440598.html",
        "sold": 1
    },
    {
        "product_name": "Helinox เก้าอี้เดินป่าน้ำหนักเบา Chair Zero High-Back [รับประกันศูนย์ไทย 5 ปี]",
        "product_image": "https://img.lazcdn.com/g/p/85bd93c5743003c34cd4caa151494260.jpg_200x200q90.jpg",
        "price": 11900,
        "remark": "https://www.lazada.co.th/products/pdp-i4351619558.html",
        "sold": 1
    },
    {
        "product_name": "NEMO MOONLITE RECLINING CAMP CHAIR เก้าอี้เดินป่าน้ำหนักเบา พับเก็บเล็ก พกพาสะดวก",
        "product_image": "https://img.lazcdn.com/g/p/3b9831431cdcdd422e2b0d835be03289.png_200x200q90.png",
        "price": 11900,
        "remark": "https://www.lazada.co.th/products/pdp-i5941127604.html",
        "sold": 0
    },
    {
        "product_name": "TNR | เก้าอี้พับได้สำหรับแคมป์ปิ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0949378b0e5349acaaf33c4417dc9990R.jpg_200x200q90.jpg",
        "price": 11560.6,
        "remark": "https://www.lazada.co.th/products/pdp-i16084239543.html",
        "sold": 0
    },
    {
        "product_name": "HELINOX เก้าอี้เดินป่า พับเล็ก น้ำหนักเบา CHAIR ZERO L [รับประกันศูนย์ไทย 5 ปี]",
        "product_image": "https://img.lazcdn.com/g/p/093a9952b38967bb46b91f92e9415755.jpg_200x200q90.jpg",
        "price": 11100,
        "remark": "https://www.lazada.co.th/products/pdp-i4351578806.html",
        "sold": 5
    },
    {
        "product_name": "Ta-Da Chair ตัวแทนจำหน่ายอย่างเป็นทางการ ไม้เท้าเก้าอี้พับได้ เก้าอี้พกพา เก้าอี้พับได้พร้อมกระเป๋าสะพายสุดเท่ห์",
        "product_image": "https://img.lazcdn.com/g/p/f7629f198c6fcf8f54c60a15094b4622.png_200x200q90.png",
        "price": 11000,
        "remark": "https://www.lazada.co.th/products/pdp-i2915578909.html",
        "sold": 2
    },
    {
        "product_name": "Helinox Chair One เก้าอี้พับพกพา เก้าอี้สนาม สำหรับแค้มปิ้ง เดินป่า หรือกิจกรรม outdoor โดย TANKstore",
        "product_image": "https://img.lazcdn.com/g/p/f88b6937d89b8fd7c74dde949378b4cd.jpg_200x200q90.jpg",
        "price": 9600,
        "remark": "https://www.lazada.co.th/products/pdp-i1245890982.html",
        "sold": 28
    },
    {
        "product_name": "Helinox Chair One สี Multicam เก้าอี้พับพกพา เก้าอี้สนาม สำหรับแคมป์ปิ้ง เดินป่า หรือกิจกรรม outdoor โดย TANKstore",
        "product_image": "https://img.lazcdn.com/g/p/4c2b2898e260d2b1cd000b8fc4d72d0f.jpg_200x200q90.jpg",
        "price": 9600,
        "remark": "https://www.lazada.co.th/products/pdp-i243258771.html",
        "sold": 6
    },
    {
        "product_name": "2-in-1 Design Foldable Handbag Chair Lightweight Collapsible Armchair Adjustable Backrest Portable Seating Ermobilenomic Support for Outdoor Enthusiasts, Apartment Dwellers, Living Room, Bedroom, Balcony, Picnic",
        "product_image": "https://img.lazcdn.com/g/p/f9a1ed15ac6caf9e4df6d77de4483fc1.jpg_200x200q90.jpg",
        "price": 8983.74,
        "remark": "https://www.lazada.co.th/products/pdp-i16046163609.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้พับ Helinox Tactical Chair",
        "product_image": "https://img.lazcdn.com/g/p/dfaacdf59e24182f10704ee12a3f9bf0.jpg_200x200q90.jpg",
        "price": 8600,
        "remark": "https://www.lazada.co.th/products/pdp-i2230723327.html",
        "sold": 15
    },
    {
        "product_name": "เก้าอี้พับ Helinox Chair One Home",
        "product_image": "https://img.lazcdn.com/g/p/735481a9f43ff726176a326852a474e6.jpg_200x200q90.jpg",
        "price": 8600,
        "remark": "https://www.lazada.co.th/products/pdp-i848096641.html",
        "sold": 2
    },
    {
        "product_name": "Foldable Design Adjustable Highspine Camp Chair Lightweight Reclining Lounger 3-Position Recline Portable Seating Built-in Storage Pockets for Campers, Anglers, Sports Spectators, Camping, Fishing Trips, Outdoors, Beach Outings",
        "product_image": "https://img.lazcdn.com/g/p/b36c30c3bddb734be2520be9f7946afd.jpg_200x200q90.jpg",
        "price": 8422.14,
        "remark": "https://www.lazada.co.th/products/pdp-i16046651036.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้แค้มป์ปิ้ง Coleman JP Lay Chair NX 18 ปรับได้ 18 รูปแบบ",
        "product_image": "https://img.lazcdn.com/g/p/52c60b653725a5a7cdcb207ace060e40.png_200x200q90.png",
        "price": 8250,
        "remark": "https://www.lazada.co.th/products/pdp-i5787287295.html",
        "sold": 3
    },
    {
        "product_name": "COLEMAN JP LAY CHAIR เก้าอี้แคมป์ปิ้ง เก้าอี้พับได้ เก้าอี้สนาม เก้าอี้พกพา",
        "product_image": "https://img.lazcdn.com/g/p/0332a125369073dc38c494493e600b63.jpg_200x200q90.jpg",
        "price": 7920,
        "remark": "https://www.lazada.co.th/products/pdp-i2560428807.html",
        "sold": 86
    },
    {
        "product_name": "เก้าอี้พับ Coleman JP Lay Chair NX",
        "product_image": "https://img.lazcdn.com/g/p/e7b26e267e6f44043652f25ea83ef61d.jpg_200x200q90.jpg",
        "price": 7920,
        "remark": "https://www.lazada.co.th/products/pdp-i16050306047.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้แคมป์ปิ้งค์ Coleman LAYCHAIR",
        "product_image": "https://img.lazcdn.com/g/p/0af592bea18000cbfb0794b8e87ff18e.jpg_200x200q90.jpg",
        "price": 7580,
        "remark": "https://www.lazada.co.th/products/pdp-i5793596460.html",
        "sold": 0
    },
    {
        "product_name": "YUZHIYUAN | เก้าอี้ตกปลาพับได้สำหรับทุกสภาพพื้นผิว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sb7f440889d1449fcae927f91b689d542J.jpg_200x200q90.jpg",
        "price": 7575.08,
        "remark": "https://www.lazada.co.th/products/pdp-i5893298713.html",
        "sold": 91
    },
    {
        "product_name": "Coleman JP Lay Chair NX 18{Heather Gray-เทา}เก้าอี้แคมป์ที่นั่งสบาย ปรับได้อย่างอิสระ 18 รูปแบบ",
        "product_image": "https://img.lazcdn.com/g/p/518ad5e8b9c49b8c8929baa7c3b2475d.jpg_200x200q90.jpg",
        "price": 7500,
        "remark": "https://www.lazada.co.th/products/pdp-i5740691940.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้Coleman Lay Chair สีOlive 🎉สินค้าพร้อมจัดส่งทันที",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sa3a253e19cc14bc4a98167863e5ce3dbD.jpg_200x200q90.jpg",
        "price": 7380,
        "remark": "https://www.lazada.co.th/products/pdp-i4722061824.html",
        "sold": 9
    },
    {
        "product_name": "Kingcamp | เก้าอี้พับได้สำหรับแคมป์ปิ้งกลางแจ้งพร้อมพนักพิงกันความร้อน 2 ที่นั่ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Scd02b983bab548688338af04197e317dP.jpg_200x200q90.jpg",
        "price": 7317.94,
        "remark": "https://www.lazada.co.th/products/pdp-i5913939117.html",
        "sold": 34
    },
    {
        "product_name": "Coleman Lay Chair NX #Greige เก้าอี้พับปรับเอนได้ 3 ระดับ นั่งสบาย พกพาสะดวก",
        "product_image": "https://img.lazcdn.com/g/p/b3ae2c542b6c8e928fed9c9ba91ac508.png_200x200q90.png",
        "price": 7260,
        "remark": "https://www.lazada.co.th/products/pdp-i5690687564.html",
        "sold": 4
    },
    {
        "product_name": "Coleman Lay Chair NX #Healther Grey เก้าอี้พับปรับเอนได้ 3 ระดับ นั่งสบาย พกพาสะดวก",
        "product_image": "https://img.lazcdn.com/g/p/62db8fe3e1ad9b469c579550f02f2263.png_200x200q90.png",
        "price": 7260,
        "remark": "https://www.lazada.co.th/products/pdp-i5690916172.html",
        "sold": 3
    },
    {
        "product_name": "VERTICO เก้าอี้แคมป์ปิ้ง รุ่นพับได้ พร้อมพนักพิงสูงเก้าอี้แคมป์ดีไซน์สวย โดดเด่นด้วยลายทางวินเทจ",
        "product_image": "https://img.lazcdn.com/g/p/bd56349e9484d69331ca6e958c17fd9d.png_200x200q90.png",
        "price": 7180,
        "remark": "https://www.lazada.co.th/products/pdp-i16077215359.html",
        "sold": 0
    },
    {
        "product_name": "🔥พร้อมส่ง🔥เก้าอี้แคมป์ปิ้ง Coody OKE Chair ดีไซน์พนักพิงสูง รับน้ำหนักได้ดี ผ้า 600D สองชั้น",
        "product_image": "https://img.lazcdn.com/g/p/3761fcdc1758b2b8c90152204c45a167.jpg_200x200q90.jpg",
        "price": 6928,
        "remark": "https://www.lazada.co.th/products/pdp-i5991164738.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้สนามปรับเอน4ระดับ  K2 Relaxing chair XT 🔥  ผ้าแคนวาส เก้าอี้เเค้มป์ปิง  เก้าอี้สนาม เก้าอี้ปรับเอน camping เก้าอี้พับ เก้าอี้พับนอนได้ เก้าอี้ตกปลา รับน้ำหนักได้ 150kg",
        "product_image": "https://img.lazcdn.com/g/p/a8fd7a35332d17198f3560cace1f6b0e.jpg_200x200q90.jpg",
        "price": 6920,
        "remark": "https://www.lazada.co.th/products/pdp-i1900994031.html",
        "sold": 16
    },
    {
        "product_name": "เก้าอี้ K2 RELAXING XT อลูมิเนียม ปรับเอนได้ 4 ระดับ เก้าอี้สนาม เก้าอี้แคมป์ปิ้ง",
        "product_image": "https://img.lazcdn.com/g/p/62b4efb60c73bdf5af137fdf0e2cb6ca.jpg_200x200q90.jpg",
        "price": 6920,
        "remark": "https://www.lazada.co.th/products/pdp-i5397827444.html",
        "sold": 22
    },
    {
        "product_name": "Coleman JP Lay Chair เก้าอี้แค้มปิ้งพับได้",
        "product_image": "https://img.lazcdn.com/g/p/756b7f22dbf6d57ebaf920b3d1d860e4.png_200x200q90.png",
        "price": 6820,
        "remark": "https://www.lazada.co.th/products/pdp-i4148584947.html",
        "sold": 9
    },
    {
        "product_name": "Coleman japan Lay Chair เก้าอี้โคลแมน สีเบจ",
        "product_image": "https://img.lazcdn.com/g/p/6405a7e3d8101574e39fb658591b8d4c.png_200x200q90.png",
        "price": 6820,
        "remark": "https://www.lazada.co.th/products/pdp-i4756516408.html",
        "sold": 0
    },
    {
        "product_name": "MOBI GARDEN เก้าอี้สนามหลังสูงพร้อมกับแขนสำนักงานที่สะดวกสบายบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/35bb635e7e73436b0ff39cfddd760b7c.jpg_200x200q90.jpg",
        "price": 6600,
        "remark": "https://www.lazada.co.th/products/pdp-i5413310501.html",
        "sold": 14
    },
    {
        "product_name": "Kingcamp | เก้าอี้พับได้สำหรับกลางแจ้งปรับได้ 5 ระดับ",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S0e526ad91e7e4227b88ce82d448b6e5bm.jpg_200x200q90.jpg",
        "price": 6208.9,
        "remark": "https://www.lazada.co.th/products/pdp-i6027430363.html",
        "sold": 3
    },
    {
        "product_name": "เก้าอี้ไม้พับ ยี่ห้อ TNR ไม้จริง มี 2 ชนิดให้เลือก (ไม้บีชหรือไม้วอลนัทดำ) พับเก็บได้ น้ำหนักเบา ขนาดกะทัดรัด แข็งแรง สวยงาม เก้าอี้พกพา เก้าตั้งแคมป์ แคมป์ปิ้ง กางเต้นท์ Folding wooden chair Kermit style",
        "product_image": "https://img.lazcdn.com/g/p/d347a097fa1b870c9554c1d923558b52.jpg_200x200q90.jpg",
        "price": 6180,
        "remark": "https://www.lazada.co.th/products/pdp-i545836999.html",
        "sold": 41
    },
    {
        "product_name": "BENNUO | เก้าอี้ตกปลาหลายฟังก์ชันสำหรับกลางแจ้ง",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S2c69874c23564847a66d3a5c4e23cf22f.jpg_200x200q90.jpg",
        "price": 6056.4,
        "remark": "https://www.lazada.co.th/products/pdp-i5985272079.html",
        "sold": 4
    },
    {
        "product_name": "MOBI GARDEN ตั้งแคมป์เก้าอี้พับผีเสื้อแข็งเก้าอี้ไม้แกลมปิ้งปิกนิกชายหาดกลางแจ้งหรูหรา",
        "product_image": "https://img.lazcdn.com/g/p/a9ab2dad7daa4e05081e7d41554a0794.jpg_200x200q90.jpg",
        "price": 6054,
        "remark": "https://www.lazada.co.th/products/pdp-i3782410179.html",
        "sold": 4
    },
    {
        "product_name": "BENNUO | เก้าอี้ตกปลาพับได้หลายฟังก์ชันน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S4322152db9054d9497cfce9eee674099g.jpg_200x200q90.jpg",
        "price": 5959.38,
        "remark": "https://www.lazada.co.th/products/pdp-i5985278495.html",
        "sold": 212
    },
    {
        "product_name": "MOBI GARDEN Camping Chair Kermit Detachable Folding Portable Lightweight Fishing Outdoor",
        "product_image": "https://img.lazcdn.com/g/p/8a2ca7a059a8d005894de014f5907330.jpg_200x200q90.jpg",
        "price": 5888,
        "remark": "https://www.lazada.co.th/products/pdp-i4326215175.html",
        "sold": 9
    },
    {
        "product_name": "YUZHIYUAN | เก้าอี้ตกปลาพับได้ ใช้งานได้หลายแบบสำหรับทุกสภาพพื้นผิว",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S5e5581c350b64069bb60fd077aaac383w.jpg_200x200q90.jpg",
        "price": 5869.48,
        "remark": "https://www.lazada.co.th/products/pdp-i5893332775.html",
        "sold": 585
    },
    {
        "product_name": "K2 Relaxing XT เก้าปรับได้ 4 ระดับ ผ้าแคนวาส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S1c24219294e7497886f56db72aebb6d9g.jpg_200x200q90.jpg",
        "price": 5860,
        "remark": "https://www.lazada.co.th/products/pdp-i4359347161.html",
        "sold": 1
    },
    {
        "product_name": "NATURAL LIFE เก้าอี้พับปรับระดับสีเขียว CHAIR LOUNGER 7058/7058-GR_SW3",
        "product_image": "https://img.lazcdn.com/g/p/52900183f30a5ff5f5ec337475d59326.jpg_200x200q90.jpg",
        "price": 5800,
        "remark": "https://www.lazada.co.th/products/pdp-i4984857239.html",
        "sold": 48
    },
    {
        "product_name": "KELTY Camping Chair เก้าอี้แคมป์แบบพับได้ เคลตี้ แท้",
        "product_image": "https://img.lazcdn.com/g/p/05b38096728a11df5e1df2c95ee7ffca.jpg_200x200q90.jpg",
        "price": 5790,
        "remark": "https://www.lazada.co.th/products/pdp-i5588088873.html",
        "sold": 0
    },
    {
        "product_name": "Sunbathing Chair, Portable Folding Beach Lounger, Outdoor Adjustable Recliner, Sun Bed, Lightweight Oxford Cloth, for Sunbathing, Camping, Patio",
        "product_image": "https://img.lazcdn.com/g/p/67c1b8951ea5c923adcc237eed2e374e.jpg_200x200q90.jpg",
        "price": 5721.68,
        "remark": "https://www.lazada.co.th/products/pdp-i6075062361.html",
        "sold": 0
    },
    {
        "product_name": "K2 RELAXING XT เก้าอี้ผ้าแคนวาส ปรับได้ 4 ระดับ",
        "product_image": "https://img.lazcdn.com/g/p/5ed53580ca79eb80304f67480d48796d.jpg_200x200q90.jpg",
        "price": 5658.58,
        "remark": "https://www.lazada.co.th/products/pdp-i6027179658.html",
        "sold": 6
    },
    {
        "product_name": "Folding Fishing Chair, lightweight Aluminum Alloy, Portable Multi-Function Adjustable Stool, Outdoor Camping, Hiking, small Seat",
        "product_image": "https://img.lazcdn.com/g/p/22b8f8c1578cc77b3a3453dff13240b3.png_200x200q90.png",
        "price": 5654,
        "remark": "https://www.lazada.co.th/products/pdp-i6008421189.html",
        "sold": 0
    },
    {
        "product_name": "BENNUO | เก้าอี้ตกปลาพกพาแบบพับได้หลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S803e3dc98bb247348ad6d86df29b38e7V.jpg_200x200q90.jpg",
        "price": 5644.22,
        "remark": "https://www.lazada.co.th/products/pdp-i5985239491.html",
        "sold": 8
    },
    {
        "product_name": "BENNUO | เก้าอี้ตกปลาพกพาปรับได้ พับได้ ขนาดเล็ก น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sfdf13ceb51294bd28d9860aeaf8abb6cj.jpg_200x200q90.jpg",
        "price": 5642.16,
        "remark": "https://www.lazada.co.th/products/pdp-i5985295449.html",
        "sold": 1
    },
    {
        "product_name": "OneTigris DragonHide Camping Chair 06 เก้าอี้แคมป์ปิ้งแบบพกพา น้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/86d56619ab811e581b7dc427a0b3fbc3.jpg_200x200q90.jpg",
        "price": 5580,
        "remark": "https://www.lazada.co.th/products/pdp-i5098334176.html",
        "sold": 13
    },
    {
        "product_name": "BENNUO|เก้าอี้ตกปลาพกพาแบบพับได้ สำหรับแค้มปิ้งและตกปลา พร้อมฟีเจอร์นอน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S92195dbfa5c64f2e9521f75561b05c037.jpg_200x200q90.jpg",
        "price": 5564.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5984993879.html",
        "sold": 2
    },
    {
        "product_name": "BENNUO | เก้าอี้ตกปลาพับได้หลายฟังก์ชัน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S70da622620de40f1bf84b8e9a6426cfeE.jpg_200x200q90.jpg",
        "price": 5564.7,
        "remark": "https://www.lazada.co.th/products/pdp-i5985368040.html",
        "sold": 3
    },
    {
        "product_name": "KEEPHIKEเก้าอี้พับกลางแจ้ง ขาพับหนา ปิคนิคตั้งแคมป์ พับเร็ว ผ้าอ็อกซ์ฟอร์ด 600D ทนการฉีกขาด รับน้ำหนักได้ 150 กก.",
        "product_image": "https://img.lazcdn.com/g/p/fdc3ce4b8479ce0293ac49ed139ac759.jpg_200x200q90.jpg",
        "price": 5536,
        "remark": "https://www.lazada.co.th/products/pdp-i16111636402.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้แคมปิ้งปรับระดับได้ YELLOW ROUTE BLACK CAIMAN ￼",
        "product_image": "https://img.lazcdn.com/g/p/a19e4ba1498b3676657ac88c732eee5b.jpg_200x200q90.jpg",
        "price": 5496,
        "remark": "https://www.lazada.co.th/products/pdp-i5582290193.html",
        "sold": 0
    },
    {
        "product_name": "TNR | เก้าอี้พับได้สำหรับการแคมป์และตกปลา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S17b0494083a54fb49bb71dc090867b3f6.jpg_200x200q90.jpg",
        "price": 5405.88,
        "remark": "https://www.lazada.co.th/products/pdp-i16084671792.html",
        "sold": 0
    },
    {
        "product_name": "พร้อมส่ง เก้าอี้พับ เก้าอี้ตั้งแคมป์ Mountainhiker โครงสร้างอลูมิเนียมเคลือบอย่างดี ผ้าOxford 600D ราวจับไม้บีช",
        "product_image": "https://img.lazcdn.com/g/p/8940a8ea0f10fdc73fcdc38ba8aa68c4.jpg_200x200q90.jpg",
        "price": 5366,
        "remark": "https://www.lazada.co.th/products/pdp-i4825462308.html",
        "sold": 0
    },
    {
        "product_name": "KELTY เก้าอี้แคมป์พับได้ขาสูง ที่นั่ง 1 คน รุ่น ESSENTIAL CHAIR",
        "product_image": "https://img.lazcdn.com/g/p/4239260aae45e74f3b93aae436aaaf8d.jpg_200x200q90.jpg",
        "price": 5310,
        "remark": "https://www.lazada.co.th/products/pdp-i16069386653.html",
        "sold": 1
    },
    {
        "product_name": "KELTY เก้าอี้แคมป์พับได้ขาเตี้ย ที่นั่ง 1 คน รุ่น LOWDOWN CHAIR",
        "product_image": "https://img.lazcdn.com/g/p/c187c1a98c3f03153252ec724a09a756.jpg_200x200q90.jpg",
        "price": 5310,
        "remark": "https://www.lazada.co.th/products/pdp-i4578983121.html",
        "sold": 9
    },
    {
        "product_name": "MOBI GARDEN ตั้งแคมป์เก้าอี้พับไม้เนื้อแข็งแบบพกพาแกลมปิ้งกลางแจ้งหรูหราอุจจาระตกปลา",
        "product_image": "https://img.lazcdn.com/g/p/75abd744a8de0ef1f222a525a5cef712.jpg_200x200q90.jpg",
        "price": 5298,
        "remark": "https://www.lazada.co.th/products/pdp-i3779469408.html",
        "sold": 5
    },
    {
        "product_name": "เก้าอี้พับ\tColeman JP เก้าอี้พับ Fireplace Folding Chair สี OD19 Beige 34675",
        "product_image": "https://img.lazcdn.com/g/p/843a9ae6e7b3262f487c9e81106e22ba.jpg_200x200q90.jpg",
        "price": 5280,
        "remark": "https://www.lazada.co.th/products/pdp-i16050052970.html",
        "sold": 0
    },
    {
        "product_name": "The Primitive | เก้าอี้พกพาหลายประโยชน์",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S039d141225134aab93be40dcf3e2627ah.jpg_200x200q90.jpg",
        "price": 5197.3,
        "remark": "https://www.lazada.co.th/products/pdp-i5909647095.html",
        "sold": 184
    },
    {
        "product_name": "REX เก้าอี้เอนหลังพับได้ ชุดสำหรับตั้งแคมป์ ทำจากผ้าฝ้ายหนานุ่ม ทนทาน และมาพร้อมอุปกรณ์เสริมสำรองฟรี",
        "product_image": "https://img.lazcdn.com/g/p/03e1f974853f337695eda071d059efeb.jpg_200x200q90.jpg",
        "price": 5180,
        "remark": "https://www.lazada.co.th/products/pdp-i16069378156.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้สนาม โคลแมน เจดี โฟล์ดิ้ง แชร์ ไวด์",
        "product_image": "https://img.lazcdn.com/g/p/f4d1300af9cb3fdfb06759a33063ab28.jpg_200x200q90.jpg",
        "price": 5130,
        "remark": "https://www.lazada.co.th/products/pdp-i4268889988.html",
        "sold": 0
    },
    {
        "product_name": "เก้าอี้ CAMP CHAIR IRONMAN เก้าอี้สำหรับสายตั้งแคมป์ รองรับน้ำหนักได้ 130-150 Kg",
        "product_image": "https://img.lazcdn.com/g/p/c6674d31b2e40d41a6752f4dc9a2856f.jpg_200x200q90.jpg",
        "price": 5100,
        "remark": "https://www.lazada.co.th/products/pdp-i3942944447.html",
        "sold": 3
    },
    {
        "product_name": "เก้าอี้ตกปลาแคมปิ้ง  เก้าอี้ชิงหลิว YING JIANG  ขาปรับได่6ระดับ วัสดุแข็งแรงอลูมิเนียม แถมฟรี กระเป๋าใบใหญ่",
        "product_image": "https://img.lazcdn.com/g/p/843e003846ceed9bdf543fce89e43d69.jpg_200x200q90.jpg",
        "price": 5078,
        "remark": "https://www.lazada.co.th/products/pdp-i5285741167.html",
        "sold": 2
    },
    {
        "product_name": "เก้าอี้ตกปลาแคมปิ้ง เก้าอี้ชิงหลิว ขาปรับยืดได้ วัสดุแข็งแรงอลูมิเนียม แถมฟรี กระเป๋าใบใหญ่ พร้อมอุปกรณ์.",
        "product_image": "https://img.lazcdn.com/g/p/ffee1c8ff912bf470d4c872a379b9345.jpg_200x200q90.jpg",
        "price": 5078,
        "remark": "https://www.lazada.co.th/products/pdp-i5286093514.html",
        "sold": 2
    },
    {
        "product_name": "【Hospor】เก้าอี้ kermit พับได้ Oxford ผ้าเก้าอี้พักผ่อนที่มีน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/a3ef76d3f7ac896b0bb25ca75df1ca3b.jpg_200x200q90.jpg",
        "price": 5052,
        "remark": "https://www.lazada.co.th/products/pdp-i5843897722.html",
        "sold": 0
    },
    {
        "product_name": "สนามเดินป่า เก้าอี้สนาม ปรับเอนหลังได้ 3 ระดับ รุ่น KING / FCSW018, FCSW056,FCSW062",
        "product_image": "https://img.lazcdn.com/g/p/3bbd1c0b68962cf259b734acbc3d9855.jpg_200x200q90.jpg",
        "price": 4990,
        "remark": "https://www.lazada.co.th/products/pdp-i4082789316.html",
        "sold": 1598
    },
    {
        "product_name": "Naturehike TY11 Outdoor Adjustable Pillow Chair เก้าอี้พับแค้มป์ปิ้งนั่งสบายปรับเอนได้ 3 ระดับ",
        "product_image": "https://img.lazcdn.com/g/p/e812d1e86cf2c53ec76f397837fb9917.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i5016492633.html",
        "sold": 5
    },
    {
        "product_name": "เก้าอี้สนาม K2 Relaxing เก้าอี้พับ แคมป์ปิ้ง อลูมิเนียม ปรับ3 ระดับ ผ้าOxford แข็งแรง คุณภาพสูง",
        "product_image": "https://img.lazcdn.com/g/p/c77cacf5f6a6c8bd15ae579a0973b2a6.jpg_200x200q90.jpg",
        "price": 4940,
        "remark": "https://www.lazada.co.th/products/pdp-i4795249407.html",
        "sold": 2
    },
    {
        "product_name": "K2 เก้าอี้ Relaxing ปรับ3ระดับ เก้าอี้แคมป์ปิ้ง เก้าอี้ปรับเอนได้ เก้าอี้อลูมิเนียม",
        "product_image": "https://img.lazcdn.com/g/p/4338225b1c30a17a54b6ee7866f4d1dc.jpg_200x200q90.jpg",
        "price": 4940,
        "remark": "https://www.lazada.co.th/products/pdp-i5397653870.html",
        "sold": 5
    },
    {
        "product_name": "JIAZHIDIAO | เก้าอี้ตกปลาพกพาขนาดเล็กน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S3308d8a3c01345d8840ab4f6f8ab54ddH.jpg_200x200q90.jpg",
        "price": 4922.92,
        "remark": "https://www.lazada.co.th/products/pdp-i6010972819.html",
        "sold": 5
    },
    {
        "product_name": "Field and camping สนามเดินป่า เก้าอี้ King ปรับระดับ - สีดำ",
        "product_image": "https://img.lazcdn.com/g/p/6eacf1e3c636bf330b59e3f16cb01d29.jpg_200x200q90.jpg",
        "price": 4790,
        "remark": "https://www.lazada.co.th/products/pdp-i4013542053.html",
        "sold": 45
    },
    {
        "product_name": "เก้าอี้พับไม้แท้ TNR Camping ทรง Kermit ขาไม้แท้ พร้อมกระเป๋าจัดเก็บผ้า Canvas  รองรับน้ำหนักได้ถึง 120kg. 🎉",
        "product_image": "https://img.lazcdn.com/g/p/62c50c6ac4f2aca99d57ea55b8d8b9d1.jpg_200x200q90.jpg",
        "price": 4780,
        "remark": "https://www.lazada.co.th/products/pdp-i3983563198.html",
        "sold": 4
    },
    {
        "product_name": "เก้าอี้พับ พกพา Coleman JP Healing Chair Next HB",
        "product_image": "https://img.lazcdn.com/g/p/4b68ab23e40e6d227172eadfd1503155.png_200x200q90.png",
        "price": 4730,
        "remark": "https://www.lazada.co.th/products/pdp-i5838360311.html",
        "sold": 0
    },
    {
        "product_name": "K2 RELAXING เก้าอี้แคมป์ปิ่งปรับได้ 3 ระดับ",
        "product_image": "https://img.lazcdn.com/g/p/24e3ad63f38abe66d0b91a7d33d840da.jpg_200x200q90.jpg",
        "price": 4727.58,
        "remark": "https://www.lazada.co.th/products/pdp-i5338187108.html",
        "sold": 62
    },
    {
        "product_name": "Mobi Garden | เก้าอี้พับได้สำหรับกลางแจ้งไม้",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S787ce269e1b0487c91aedb47d2f8c0abU.jpg_200x200q90.jpg",
        "price": 4672.16,
        "remark": "https://www.lazada.co.th/products/pdp-i6014215208.html",
        "sold": 5
    },
    {
        "product_name": "เก้าอี้พับ Coleman JP Aluminum Deck Chair Mesh",
        "product_image": "https://img.lazcdn.com/g/p/7e2a41fa2b6f6f81224f4685dd1ab45a.png_200x200q90.png",
        "price": 4620,
        "remark": "https://www.lazada.co.th/products/pdp-i5087455666.html",
        "sold": 8
    },
    {
        "product_name": "BENNUO | เก้าอี้พับได้สำหรับตกปลาแบบพกพา",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S09781f4c79584c88865d9031700100538.jpg_200x200q90.jpg",
        "price": 4610.16,
        "remark": "https://www.lazada.co.th/products/pdp-i5985423158.html",
        "sold": 31
    },
    {
        "product_name": "รูปปั้นตุ๊กตาคริสต์มาสรูปปั้นบ้านในหมู่บ้านคริสต์มาส Acituna สำหรับตกแต่งโต๊ะตู้",
        "product_image": "https://img.lazcdn.com/g/p/54428ae0061beb9574fd6e90780d29ec.jpg_200x200q90.jpg",
        "price": 8658,
        "remark": "https://www.lazada.co.th/products/pdp-i5912591823.html",
        "sold": 0
    },
    {
        "product_name": "[85ชิ้น] ลูกบอลตกแต่ง ต้นคริสต์มาส 8cm.ลูกบอลประดับ 85 ชิ้น ลูกตุ้มแขวน ต้นคริสต์มาส บอลประดับต้นสน คริสมาสตกแต่ง - 85pcs Christmas Balls Baubles Decorations",
        "product_image": "https://img.lazcdn.com/g/p/df97488963fb8b305fda3489ca17676a.jpg_200x200q90.jpg",
        "price": 6980,
        "remark": "https://www.lazada.co.th/products/pdp-i4264694151.html",
        "sold": 0
    },
    {
        "product_name": "กล่องดนตรีคริสต์มาส กล่องดนตรีซานต้า มีไฟ บนเรือ (1ชิ้น) Christmas Music Box Santa in Pirate Ship  with Light (1unit)",
        "product_image": "https://img.lazcdn.com/g/p/b28ef1c582f284c70c0b996f76787f50.jpg_200x200q90.jpg",
        "price": 6980,
        "remark": "https://www.lazada.co.th/products/pdp-i5921256678.html",
        "sold": 0
    },
    {
        "product_name": "[55ชิ้น] ลูกบอลตกแต่ง 8cm. ต้นคริสต์มาส ลูกบอลประดับ ลูกตุ้มแขวน ต้นคริสต์มาส บอลประดับต้นสน คริสมาสตกแต่ง - 55pcs Christmas Balls Baubles Decorations Tree Ornament",
        "product_image": "https://img.lazcdn.com/g/p/611c43b45374b02d46292f8f9aaecc40.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i4264726794.html",
        "sold": 0
    },
    {
        "product_name": "[55 ชิ้น] ลูกบอลตกแต่ง ต้นคริสต์มาส 8cm. ลูกบอลประดับ ลูกตุ้มแขวน ต้นคริสต์มาส บอลประดับต้นสน คริสมาสตกแต่ง - 55pcs Christmas Balls Baubles Decorations Tree Ornament",
        "product_image": "https://img.lazcdn.com/g/p/f4760ce557349a8d25d5d76875ec7555.jpg_200x200q90.jpg",
        "price": 5980,
        "remark": "https://www.lazada.co.th/products/pdp-i4263348805.html",
        "sold": 0
    },
    {
        "product_name": "สวนสนามหลังบ้านเป่าลมรูปกวางซานตาคลอสขนาด12ฟุตสำหรับเทศกาลคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/p/1efaa95da47e1eb6c4ac1112023f5222.jpg_200x200q90.jpg",
        "price": 5928,
        "remark": "https://www.lazada.co.th/products/pdp-i6003103685.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องประดับที่ประดับคริสต์มาสแบบเป่าลมได้คริสต์มาสซานตาคลอส Viphome",
        "product_image": "https://img.lazcdn.com/g/p/991b5d380918b7f45f5bb57539af3041.jpg_200x200q90.jpg",
        "price": 5864,
        "remark": "https://www.lazada.co.th/products/pdp-i5971563504.html",
        "sold": 0
    },
    {
        "product_name": "Homyl ฟิกเกอร์ลูกโป่งซานตาคริสต์มาสตกแต่งรูปซานตาคลอสวันหยุดสำหรับตกแต่งในร่มกลางแจ้งคริสต์มาสของ Homyl",
        "product_image": "https://img.lazcdn.com/g/p/ff83cb063db59632d5db3ea385c0106c.jpg_200x200q90.jpg",
        "price": 5692,
        "remark": "https://www.lazada.co.th/products/pdp-i16059900107.html",
        "sold": 0
    },
    {
        "product_name": "ตกแต่งคริสต์มาสเป่าลมสำหรับตกแต่งเทศกาลคริสต์มาส Predolo มีไฟซานตาคลอส",
        "product_image": "https://img.lazcdn.com/g/p/15cf7fa5859aec58916dbc1b2e820765.jpg_200x200q90.jpg",
        "price": 5650,
        "remark": "https://www.lazada.co.th/products/pdp-i5973219649.html",
        "sold": 0
    },
    {
        "product_name": "ตุ๊กตาซานต้าเล่นสกี ตกแต่งคริสต์มาส ปีใหม่ 65cm Red Skiing Santa Clause Christmas Holiday Decoration Figurine Festive",
        "product_image": "https://img.lazcdn.com/g/p/bced24450cb80960841ed63760e66123.png_200x200q90.png",
        "price": 5580,
        "remark": "https://www.lazada.co.th/products/pdp-i5923630721.html",
        "sold": 0
    },
    {
        "product_name": "Happy New year พระเจ้าแห่งความมั่งคั่ง LED Inflatable Santa Claus Decor - ตกแต่งสนามหญ้าคริสต์มาสกลางแจ้งพร้อมไฟ ซานตา, เพนกวิน และตุ๊กตาหิมะ, ซุ้มเป่าลมสำหรับงานปาร์ตี้กลางแจ้ง ตกแต่งวันหยุดคริสต์มาส ﻿ซานตาคลอสเป่าลมสำหรับตกแต่งภายนอกอาคาร VIB-TH",
        "product_image": "https://img.lazcdn.com/g/p/2ad5cf906d9b9c56a04e7ead1a36724e.jpg_200x200q90.jpg",
        "price": 5172,
        "remark": "https://www.lazada.co.th/products/pdp-i5939589698.html",
        "sold": 31
    },
    {
        "product_name": "วงกบประดับคริสต์มาส 2.7 ม.",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S266a28a64882442889a0c13e979ed2eed.jpg_200x200q90.jpg",
        "price": 5047.04,
        "remark": "https://www.lazada.co.th/products/pdp-i16107174275.html",
        "sold": 0
    },
    {
        "product_name": "กล่องดนตรีซานต้า หิมะ ต้นคริสต์มาส มีไฟ กล่องดนตรีคริสต์มาส สีแดง (1ชิ้น) Christmas Music Box Santa Snow Globe Tree Snow Blowing with Light Red Color (1unit)",
        "product_image": "https://img.lazcdn.com/g/p/eb69dd9a796b764b0ab0fc2ba80bb014.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i5920306671.html",
        "sold": 0
    },
    {
        "product_name": "กล่องดนตรีซานต้า หิมะ ต้นคริสต์มาส มีไฟ ปราสาท กล่องดนตรีคริสต์มาส (1ชิ้น) Christmas Music Box Santa Snow Castle Globe Snow Blowing with Light White Color (1unit)",
        "product_image": "https://img.lazcdn.com/g/p/c674b751a6a2645e24ca1c0f72409ff4.jpg_200x200q90.jpg",
        "price": 4980,
        "remark": "https://www.lazada.co.th/products/pdp-i5920199844.html",
        "sold": 0
    },
    {
        "product_name": "MagiDeal ชุดสะสมรูปปั้นการประสูติของพระเยซูคริสต์ตุ๊กตาคริสต์มาสงานศิลปะสำหรับตั้งโต๊ะ",
        "product_image": "https://img.lazcdn.com/g/p/680d5a3e3c4ad90b15fdf78aeaf1dfd0.jpg_200x200q90.jpg",
        "price": 4722,
        "remark": "https://www.lazada.co.th/products/pdp-i5931092459.html",
        "sold": 0
    },
    {
        "product_name": "Kesoto งานฝีมือตุ๊กตาคริสต์มาสรูปปั้นการประสูติสำหรับชั้นวางหนังสือตั้งโต๊ะในร่ม",
        "product_image": "https://img.lazcdn.com/g/p/a27ee660240c534d3768a391842e7eaf.jpg_200x200q90.jpg",
        "price": 4722,
        "remark": "https://www.lazada.co.th/products/pdp-i6032925513.html",
        "sold": 0
    },
    {
        "product_name": "รูปปั้นฉากการประสูติ BNGOOD ตุ๊กตาคริสต์มาสงานฝีมือสะสมสำหรับงานศิลปะสำหรับตกแต่งบ้านประติมากรรมเรซินสำหรับห้องนั่งเล่นตั้งโต๊ะ",
        "product_image": "https://img.lazcdn.com/g/p/ca31df1e489bf32b02222efb6fcce5c9.jpg_200x200q90.jpg",
        "price": 4722,
        "remark": "https://www.lazada.co.th/products/pdp-i5923983840.html",
        "sold": 0
    },
    {
        "product_name": "กล่องใส่ของขวัญลูกโป่งซานตาคริสต์มาสดวงจันทร์ของ BAYAH ไฟ LED ของขวัญคริสต์มาสเสาเครื่องตกแต่งภายนอกสำหรับวันหยุดสนามหลังบ้านระเบียงบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/f2480d7adeb3e9a58cedbf7a349141bc.jpg_200x200q90.jpg",
        "price": 4678,
        "remark": "https://www.lazada.co.th/products/pdp-i5990689987.html",
        "sold": 0
    },
    {
        "product_name": "ลูกโป่งซานตาคริสต์มาส Predolo เครื่องตกแต่งภายนอกตกแต่งคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/p/c98c25fff6ddcc87c11075f0650e53ee.jpg_200x200q90.jpg",
        "price": 4152,
        "remark": "https://www.lazada.co.th/products/pdp-i5960867481.html",
        "sold": 0
    },
    {
        "product_name": "ลูกกลมหิมะคริสมาสต์ FoMing กับรูปทรงรถไฟแสงแวววาวสไตล์วินเทจตุ๊กตาหิมะที่สร้างสรรค์สำหรับอุปกรณ์งานเลี้ยงบนโต๊ะ",
        "product_image": "https://img.lazcdn.com/g/p/a5cbd5601e1394ae71e5e0a885d54fef.jpg_200x200q90.jpg",
        "price": 4148,
        "remark": "https://www.lazada.co.th/products/pdp-i16052676896.html",
        "sold": 0
    },
    {
        "product_name": "กล่องดนตรีคริสต์มาส กล่องดนตรีซานต้า มีไฟ ในรถต้นคริสมาส (1ชิ้น) Christmas Music Box Santa in Car with Christmas Tree Snow Globe with Light (1unit)",
        "product_image": "https://img.lazcdn.com/g/p/aed45e2b2677a8a1511a3866ca29f622.jpg_200x200q90.jpg",
        "price": 3998,
        "remark": "https://www.lazada.co.th/products/pdp-i5920610499.html",
        "sold": 0
    },
    {
        "product_name": "ตุ๊กตาคริสมาส กวาง reindeer ซานตาคลอส แขวนผนัง (1ชิ้น) Santa Claus Reindeer Wall Hanging (1 unit)",
        "product_image": "https://img.lazcdn.com/g/p/fae5048a8b519a28d3f23762bce5ab92.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5424595023.html",
        "sold": 0
    },
    {
        "product_name": "นัทแครกเกอร์ 60cm. ตุ๊กตาคริสมาส ตกแต่งคริสมาส คลาสสิก สีแดง (1ตัว) Large Nutcracker Dolls 60cm. Christmas Nutcracker Ornaments, Traditional Xmas Gift Toy Decoration (1 unit)",
        "product_image": "https://img.lazcdn.com/g/p/b8c57ea8b1c8313c9e54fb07621da0c7.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5897876177.html",
        "sold": 0
    },
    {
        "product_name": "ตุ๊กตาซานตาคลอส ปีนบันได ตุ๊กตาคริสมาส ตุ๊กตาตกแต่ง (1ชิ้น) Christmas Santa Doll Climbing Ladder Christmas Decoration (1 unit)",
        "product_image": "https://img.lazcdn.com/g/p/170e440c10e283cb367dcc02e0e5378b.jpg_200x200q90.jpg",
        "price": 3980,
        "remark": "https://www.lazada.co.th/products/pdp-i5423570570.html",
        "sold": 0
    },
    {
        "product_name": "PetBetter ไฟตกแต่งคริสต์มาสแอลอีดีแบบฝังเข้ากับสิ่งปลูกสร้างรูปกวางเรนเดียร์คริสต์มาสซานต้าแบบพองได้สำหรับตกแต่งสวนงานปาร์ตี้วันหยุด",
        "product_image": "https://img.lazcdn.com/g/p/77e4a782220b26106469c2139b910c8f.jpg_200x200q90.jpg",
        "price": 3886,
        "remark": "https://www.lazada.co.th/products/pdp-i5991860019.html",
        "sold": 0
    },
    {
        "product_name": "Homyl รถเรนเดียร์คริสต์มาสซานต้าแบบพองได้ขนาดใหญ่พร้อมกล่องของขวัญสำหรับสนามหญ้าห้างสรรพสินค้า",
        "product_image": "https://img.lazcdn.com/g/p/73feef415065e347eef4ed5054dbe575.jpg_200x200q90.jpg",
        "price": 3814,
        "remark": "https://www.lazada.co.th/products/pdp-i5957843622.html",
        "sold": 0
    },
    {
        "product_name": "8ft เป่าลมลายคริสมาสต์มีไฟประดับตกแต่งเทศกาลคริสต์มาสรูปตุ๊กตาหิมะของตกแต่งขนาดยักษ์พร้อมไฟ LED สำหรับสวนหลังบ้านลานบ้านวันหยุด",
        "product_image": "https://img.lazcdn.com/g/p/fa23c69c362c999829b61f99bf6e9f55.jpg_200x200q90.jpg",
        "price": 3770,
        "remark": "https://www.lazada.co.th/products/pdp-i5957371391.html",
        "sold": 0
    },
    {
        "product_name": "ใหม่ ต้นคริสมาสตร์เกล็ดหิมะ ขนาดใหญ๋ 0.6m-2.4m ฐานเป็นเหล็กเเข็งเเรง ต้นคริสมาสต์ปลอม ต้นสนปลอม สำหรับตกเเต่งปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/37c4d43c55f2573ec97763dd7aad61e2.jpg_200x200q90.jpg",
        "price": 3760,
        "remark": "https://www.lazada.co.th/products/pdp-i4973998461.html",
        "sold": 0
    },
    {
        "product_name": "ใหม่2025 ต้นคริสมาสตร์เกล็ดหิมะ ขนาดใหญ๋ 0.6m-2.4m ฐานเป็นเหล็กเเข็งเเรง ต้นคริสมาสต์ปลอม ต้นสนปลอม สำหรับตกเเต่งปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/f0a7e076b751bb4d79f81d3bc6b60aa2.jpg_200x200q90.jpg",
        "price": 3760,
        "remark": "https://www.lazada.co.th/products/pdp-i4973790624.html",
        "sold": 1
    },
    {
        "product_name": "ชุดตกแต่งคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sd162fa1cc4044e30968be882e3a4e94d8.jpg_200x200q90.jpg",
        "price": 3686.46,
        "remark": "https://www.lazada.co.th/products/pdp-i16103167851.html",
        "sold": 0
    },
    {
        "product_name": "รูปปั้นมนุษย์หิมะของตกแต่งวันคริสต์มาสที่ประดับคริสต์มาสแบบเป่าลมได้ BNWEAR อุปกรณ์ตกแต่งสนามซานตาคลอสตลกสำหรับลานวันหยุด",
        "product_image": "https://img.lazcdn.com/g/p/3f44ccff31f53e59d92d2827eb3e20f0.jpg_200x200q90.jpg",
        "price": 3660,
        "remark": "https://www.lazada.co.th/products/pdp-i5999964550.html",
        "sold": 0
    },
    {
        "product_name": "กล่องดนตรีคริสต์มาส ไฟLED กล่องดนตรีซานต้า Toy Shop (1ชิ้น) Christmas Music Box LED Light Santa Toy Shop Music Box (1 unit)",
        "product_image": "https://img.lazcdn.com/g/p/ac079d78efba5ab50c1117154041144a.jpg_200x200q90.jpg",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i5917333204.html",
        "sold": 0
    },
    {
        "product_name": "กล่องดนตรีซานต้า มีไฟ รถไฟ กล่องดนตรีคริสต์มาส สีแดง (1ชิ้น) Christmas Music Box Santa Snow Globe on Train with Light Red Color (1unit)",
        "product_image": "https://img.lazcdn.com/g/p/48b7c5d22a395677c8bfa860379e7f56.jpg_200x200q90.jpg",
        "price": 3580,
        "remark": "https://www.lazada.co.th/products/pdp-i5920151102.html",
        "sold": 0
    },
    {
        "product_name": "Resin Rotating Music Figurines with LED Light Christmas Music Box Gingerbread Man Snow House Ornaments 2pcs Home Decor",
        "product_image": "https://img.lazcdn.com/g/p/de39cd604cd76f4132d3d1581050d89c.jpg_200x200q90.jpg",
        "price": 3540.5,
        "remark": "https://www.lazada.co.th/products/pdp-i16124681295.html",
        "sold": 0
    },
    {
        "product_name": "ตกแต่งรูปปั้นคริสต์มาสตกแต่งคริสต์มาสคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/p/eedeaf34a7403af38efa1432692a9a60.jpg_200x200q90.jpg",
        "price": 3482,
        "remark": "https://www.lazada.co.th/products/pdp-i5988528597.html",
        "sold": 0
    },
    {
        "product_name": "Amagogo รูปปั้นคริสต์มาสตกแต่งคริสต์มาสฤดูหนาว,รูปปั้นคริสต์มาสเหล็กตกแต่งคริสต์มาสสำหรับฉลองวันเกิดบ้านไร่ศูนย์การค้าในร่ม",
        "product_image": "https://img.lazcdn.com/g/p/eff67416cc40358c591c85d18fb11b9e.jpg_200x200q90.jpg",
        "price": 3482,
        "remark": "https://www.lazada.co.th/products/pdp-i6025033011.html",
        "sold": 0
    },
    {
        "product_name": "Homyl รูปปั้นคริสต์มาสเครื่องประดับตกแต่งวันคริสต์มาสตกแต่งคริสต์มาสสำหรับบ้านไร่งานแต่งงาน",
        "product_image": "https://img.lazcdn.com/g/p/899336c581f412d1de83989648ef6cae.jpg_200x200q90.jpg",
        "price": 3441.56,
        "remark": "https://www.lazada.co.th/products/pdp-i16109158979.html",
        "sold": 0
    },
    {
        "product_name": "รูปปั้นคริสต์มาส WDEarth ของตกแต่งของตกแต่งเทศกาลคริสต์มาสรูปปั้นคริสต์มาสสำหรับห้างสรรพสินค้าฉลองงานแต่งงานบ้านไร่ในร่ม",
        "product_image": "https://img.lazcdn.com/g/p/9bc47d245dcaf54be18b2590462aa146.jpg_200x200q90.jpg",
        "price": 3406.64,
        "remark": "https://www.lazada.co.th/products/pdp-i16105523145.html",
        "sold": 0
    },
    {
        "product_name": "ปฏิทินคริสต์มาสมหาสมุทรอัน2024การประสูติสำหรับห้องนอนของขวัญปาร์ตี้ห้องนั่งเล่น",
        "product_image": "https://img.lazcdn.com/g/p/60930b040df2a551c05392e51499fad9.jpg_200x200q90.jpg",
        "price": 3316,
        "remark": "https://www.lazada.co.th/products/pdp-i5894035056.html",
        "sold": 0
    },
    {
        "product_name": "ชุดคิตหนังสือคริสต์มาสแบบ DIY จาก Oceanside สำหรับตกแต่งบ้านตุ๊กตาบ้านจิ๋วแบบทำมือสำหรับตกแต่งหนังสือโต๊ะสำนักงานชุดที่คั่นหนังสือ",
        "product_image": "https://img.lazcdn.com/g/p/d19777d730c4a483b6644db712e86167.jpg_200x200q90.jpg",
        "price": 3112,
        "remark": "https://www.lazada.co.th/products/pdp-i5927723702.html",
        "sold": 0
    },
    {
        "product_name": "Fityle บ้านคริสต์มาสเรืองแสงบ้านตกแต่งคริสต์มาสตุ๊กตามนุษย์หิมะบ้านบ้านคริสต์มาสทำจากเรซินสำหรับเป็นของขวัญชั้นวางของสำนักงาน",
        "product_image": "https://img.lazcdn.com/g/p/f5e5c3a180fe4418f45c45447fceb8e1.jpg_200x200q90.jpg",
        "price": 3100,
        "remark": "https://www.lazada.co.th/products/pdp-i5408643099.html",
        "sold": 0
    },
    {
        "product_name": "ตกแต่งชิงช้าสวรรค์คริสต์มาสพร้อมหน้าซานตาคลอส ไฟ LED และเสียงเพลง ของตกแต่งคริสต์มาสหมุนได้แบบเคลื่อนไหวสำหรับของขวัญงานปาร์ตี้ที่บ้าน",
        "product_image": "https://img.lazcdn.com/g/ff/kf/Sc89cf49342854d1aaa1c59c8c8db699dx.jpg_200x200q90.jpg",
        "price": 3035.38,
        "remark": "https://www.lazada.co.th/products/pdp-i6003652985.html",
        "sold": 0
    },
    {
        "product_name": "PetBetter การแสดงผลแบบซานต้าสำหรับปีนเขารูปตลกมีไฟตกแต่งหน้าต่างคริสต์มาสตกแต่งในร่มสำหรับบันไดลาน",
        "product_image": "https://img.lazcdn.com/g/p/fcc34203e498bc87dd55bc7602cec64a.jpg_200x200q90.jpg",
        "price": 2998,
        "remark": "https://www.lazada.co.th/products/pdp-i5991439428.html",
        "sold": 0
    },
    {
        "product_name": "ฟิกกาเทียกวางเรนเดียร์ซานตาคลอสของตกแต่งคริสต์มาสแบบเป่าลมได้",
        "product_image": "https://img.lazcdn.com/g/p/073c960dcd6a4a2d83d9201aa8ebee4b.jpg_200x200q90.jpg",
        "price": 2950,
        "remark": "https://www.lazada.co.th/products/pdp-i5968787491.html",
        "sold": 0
    },
    {
        "product_name": "ของตกแต่งตุ๊กตาหิมะเป่าลมคริสต์มาส - ตุ๊กตาการ์ตูนสำหรับงานห้างสรรพสินค้า",
        "product_image": "https://img.lazcdn.com/g/p/ad19f24f5ca800bac26d8e724365dfd1.png_200x200q90.png",
        "price": 2672,
        "remark": "https://www.lazada.co.th/products/pdp-i5967113165.html",
        "sold": 0
    },
    {
        "product_name": "[Questionno] เรนเดียร์สีดำตุ๊กตาคริสต์มาสสร้างขึ้นจากสำหรับห้องนั่งเล่นอัลลอยและของตกแต่งวันหยุดสำนักงาน",
        "product_image": "https://img.lazcdn.com/g/p/70c15c8d8204bd9747a71532ec689521.jpg_200x200q90.jpg",
        "price": 2920,
        "remark": "https://www.lazada.co.th/products/pdp-i16119240070.html",
        "sold": 0
    },
    {
        "product_name": "เครื่องประดับเป่าลมรูปซานตาคลอสของตกแต่งคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/p/de440f91a88071017e7f7e25bc88d77c.jpg_200x200q90.jpg",
        "price": 2914,
        "remark": "https://www.lazada.co.th/products/pdp-i5956868825.html",
        "sold": 0
    },
    {
        "product_name": "Amleso ต้นคริสต์มาสหูตะกร้าต้นคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/p/5af57c34bfba1089717d4da0d7387ff2.jpg_200x200q90.jpg",
        "price": 2914,
        "remark": "https://www.lazada.co.th/products/pdp-i5958085829.html",
        "sold": 0
    },
    {
        "product_name": "CCCOOL ตกแต่งคริสต์มาสลานพื้นหลังการถ่ายภาพสำหรับที่ไม่เหมือนใคร",
        "product_image": "https://img.lazcdn.com/g/p/a4a91cf997c754c832becad81d78e192.jpg_200x200q90.jpg",
        "price": 2893,
        "remark": "https://www.lazada.co.th/products/pdp-i16087849779.html",
        "sold": 0
    },
    {
        "product_name": "Christmas Lights Dachshund Christmas Shiny Decorations Dachshund Christmas Holiday Decorations",
        "product_image": "https://img.lazcdn.com/g/p/2b3e96a9264f07d024a27cf773427e2f.jpg_200x200q90.jpg",
        "price": 2217.42,
        "remark": "https://www.lazada.co.th/products/pdp-i16105569952.html",
        "sold": 0
    },
    {
        "product_name": "Leipupa อุปกรณ์ตกแต่งวัยคริสมาสต์รูปปั้นหมู่บ้านคริสต์มาสสำหรับชั้นวางหนังสือบนโต๊ะวันหยุด",
        "product_image": "https://img.lazcdn.com/g/p/c87a56c79af43bb977d888bafc89b272.jpg_200x200q90.jpg",
        "price": 2806,
        "remark": "https://www.lazada.co.th/products/pdp-i5929581574.html",
        "sold": 0
    },
    {
        "product_name": "Moon AYAMOO เครื่องประดับต้นกล่องของขวัญคริสต์มาสตกแต่งคริสต์มาส3ชิ้นเครื่องประดับกลางแจ้งในบ้านศิลปะจากโลหะเรืองแสงตกแต่งคริสต์มาส S 15/20/25ซม",
        "product_image": "https://img.lazcdn.com/g/p/a785c4e475bfe4fd9297cc8720966e7d.jpg_200x200q90.jpg",
        "price": 2786,
        "remark": "https://www.lazada.co.th/products/pdp-i5922512766.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟลูกกลมหิมะคริสมาสต์แวววาวรูปปั้นประดับรถสีแดงกล่องดนตรีครีเอทีฟโคมไฟดนตรีโคมไฟน้ำสำหรับวันเกิด",
        "product_image": "https://img.lazcdn.com/g/p/ed5154f55840a496c7fd6e4d3b4eae43.jpg_200x200q90.jpg",
        "price": 2786,
        "remark": "https://www.lazada.co.th/products/pdp-i6015131532.html",
        "sold": 0
    },
    {
        "product_name": "Sersun หุ่นตกแต่งคริสต์มาสตกแต่งสำหรับโต๊ะในวันหยุดรูปรูปปั้นทางศาสนาตกแต่งสำหรับยามค่ำคืนของลูกกลมหิมะคริสมาสต์",
        "product_image": "https://img.lazcdn.com/g/p/b66f1db7f95ca91e16a9c0adddd9d777.jpg_200x200q90.jpg",
        "price": 2762,
        "remark": "https://www.lazada.co.th/products/pdp-i6011199232.html",
        "sold": 0
    },
    {
        "product_name": "อุปกรณ์แอลอีดีแบบฝังเข้ากับสิ่งปลูกสร้างปาร์ตี้สำหรับวันหยุดคริสต์มาสอุปกรณ์ตกแต่งเทศกาลซานตาคลอสปีนเขาแบบเป่าลมเค้าโครงฉาก",
        "product_image": "https://img.lazcdn.com/g/p/1409139a74b5a9f428a05ff1b035e960.jpg_200x200q90.jpg",
        "price": 2675.26,
        "remark": "https://www.lazada.co.th/products/pdp-i16103384061.html",
        "sold": 0
    },
    {
        "product_name": "BAYAH ที่ประดับคริสต์มาสแบบเป่าลมได้คริสต์มาสกลางแจ้งตกแต่งงานปาร์ตี้ซานต้า",
        "product_image": "https://img.lazcdn.com/g/p/64f85cc23d421280a04e8be835ab6075.jpg_200x200q90.jpg",
        "price": 2674,
        "remark": "https://www.lazada.co.th/products/pdp-i5957769432.html",
        "sold": 0
    },
    {
        "product_name": "ไอเดียของขวัญแบบเสียบรูปสหรัฐเป่าลมได้มีไฟ LED มีในตัวตกแต่งรูปซานตาคลอสคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/p/f65a8990ca48446a64114740f8608b25.jpg_200x200q90.jpg",
        "price": 2674,
        "remark": "https://www.lazada.co.th/products/pdp-i5981578291.html",
        "sold": 0
    },
    {
        "product_name": "ฟิกกาเทียคริสต์มาสเป่าลมตกแต่งเค้าโครงฉากเครื่องตกแต่งภายนอกแอลอีดีแบบฝังเข้ากับสิ่งปลูกสร้างคริสต์มาสขนาดยักษ์สำหรับระเบียงนอกระเบียง",
        "product_image": "https://img.lazcdn.com/g/p/212379533619e54740a84de7e4aeb5cc.jpg_200x200q90.jpg",
        "price": 2642,
        "remark": "https://www.lazada.co.th/products/pdp-i5968759923.html",
        "sold": 0
    },
    {
        "product_name": "ไฟคริสต์มาส ไฟประดับ LED ตั้งโต๊ะ ซานต้า ไม้เท้า กวางเรนเดีย กล่องของขวัญ (1ชิ้น) Christmas LED Light Santa Reindeer Cane Presents Light (1 unit)",
        "product_image": "https://img.lazcdn.com/g/p/a07c650a60b72aabe782a2035a3d64c8.jpg_200x200q90.jpg",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i5942419886.html",
        "sold": 0
    },
    {
        "product_name": "กล่องดนตรีคริสต์มาส พร้อมไฟและเพลง 8.5x21cm Christmas Music Box Santa/Snowman with Light & Music Decoration Festive",
        "product_image": "https://img.lazcdn.com/g/p/6be5f7ff2eb7de3b785c82e8a308aa67.png_200x200q90.png",
        "price": 2580,
        "remark": "https://www.lazada.co.th/products/pdp-i5919197508.html",
        "sold": 2
    },
    {
        "product_name": "WDBEST รูปแกะสลักฉากคริสต์มาสต์เรืองแสงขนาดเล็กพร้อมโต๊ะคริสต์มาสดนตรีชิ้นกลางเครื่องประดับตั้งโต๊ะสำหรับรถยนต์หน้าต่างร้านค้า",
        "product_image": "https://img.lazcdn.com/g/p/7b622ab9a539672d9edc67a9effc0568.jpg_200x200q90.jpg",
        "price": 2574,
        "remark": "https://www.lazada.co.th/products/pdp-i6070952343.html",
        "sold": 0
    },
    {
        "product_name": "ZYPlanet ฉากคริสต์มาสหิมะมีไฟตกแต่งตุ๊กตาเรซิ่นตั้งโต๊ะขนาดเล็ก",
        "product_image": "https://img.lazcdn.com/g/p/498b395bfb9d9f2f7e7b49bbd7ed4f3b.jpg_200x200q90.jpg",
        "price": 2574,
        "remark": "https://www.lazada.co.th/products/pdp-i5922777463.html",
        "sold": 0
    },
    {
        "product_name": "CCCOOL ฉากหิมะคริสต์มาสมีไฟขนาดเล็กตกแต่งโต๊ะสำหรับหน้าต่างร้านค้า",
        "product_image": "https://img.lazcdn.com/g/p/527f9c1b1b587a912b6bafd71ee153ab.jpg_200x200q90.jpg",
        "price": 2574,
        "remark": "https://www.lazada.co.th/products/pdp-i5972400780.html",
        "sold": 0
    },
    {
        "product_name": "🎄【Special price】🎄Shao เครื่องประดับปฏิทินคริสต์มาสจุติชุดก่อสร้างรถไฟซานตาคลอสแม่เหล็กของขวัญแปลกใจ24วันของตกแต่งคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/p/4caf86970d99ad814478d17b0703e2d5.jpg_200x200q90.jpg",
        "price": 2548.34,
        "remark": "https://www.lazada.co.th/products/pdp-i16086061717.html",
        "sold": 0
    },
    {
        "product_name": "ตกแต่งคริสต์มาส Sunnimix ตุ๊กตาจำลองซานต้าคลอสแบบคลาสสิกสำหรับโต๊ะทำงานในงานเทศกาล",
        "product_image": "https://img.lazcdn.com/g/p/b092ed905cce47e4db35657418d9c6f6.jpg_200x200q90.jpg",
        "price": 2460,
        "remark": "https://www.lazada.co.th/products/pdp-i5914535611.html",
        "sold": 0
    },
    {
        "product_name": "Moon NUNA รูปปั้นกวางคริสต์มาส3ชิ้นรูปปั้นกวางเรนเดียร์เล็กกลางใหญ่ในร่มของประดับรูปกวางลาออกสำหรับตู้สำนักงาน",
        "product_image": "https://img.lazcdn.com/g/p/145cead35c0a98f2ffa688e11ea9181c.jpg_200x200q90.jpg",
        "price": 2394.3,
        "remark": "https://www.lazada.co.th/products/pdp-i6035775615.html",
        "sold": 0
    },
    {
        "product_name": "รูปปั้นในการประสูติคริสต์มาสของสะสมวันคริสต์มาสรูปปั้นทางศาสนาของสำนักงานบ้านหุ่นตกแต่งโต๊ะอาหารสำหรับวันหยุด",
        "product_image": "https://img.lazcdn.com/g/p/472743f186d8024f6de51535a8b27e79.jpg_200x200q90.jpg",
        "price": 2386,
        "remark": "https://www.lazada.co.th/products/pdp-i6000774219.html",
        "sold": 0
    },
    {
        "product_name": "ชุดของประดับคริสต์มาส 14 ชิ้น แดง-ทอง 14-Pcs Red Gold Christmas Ornament Set Festive Holiday Baubles Nutcracker Snowman",
        "product_image": "https://img.lazcdn.com/g/p/4befcf6b6152a19210e4a8c01e4b4fca.png_200x200q90.png",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i5939462535.html",
        "sold": 0
    },
    {
        "product_name": "ตุ๊กตาโนมส์ ตุ๊กตาคริสมาส ตุ๊กตาคนแคระ 19 x 19 x 50cm. (1ชิ้น) Gnome Doll Gnome Christmas Decorations Elf Dwarf Christmas Elf Doll Tomte Nisse 19 x 19 x 50cm. (1 unit)",
        "product_image": "https://img.lazcdn.com/g/p/eb6cf1d6453034521c0cc69b6da47f71.jpg_200x200q90.jpg",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i4323122798.html",
        "sold": 0
    },
    {
        "product_name": "ต้นคริสต์มาสแก้ว มีไฟ ตกแต่งคริสต์มาส ตั้งโต๊ะ สีขาวรุ้ง/สีแดงน้ำตาล (1ชิ้น) Christmas Tree Glass Light-Up Christmas Tree White Rainbow/Red-Brown (1 unit)",
        "product_image": "https://img.lazcdn.com/g/p/2ef34857cf5c92d184186376da9621c9.jpg_200x200q90.jpg",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i5918744218.html",
        "sold": 0
    },
    {
        "product_name": "ตุ๊กตาหิมะเซรามิก ตกแต่งคริสต์มาส ของตกแต่งตั้งโต๊ะ สีขาว/ทอง Ceramic Snowman Christmas Festive Tabletop Decoration",
        "product_image": "https://img.lazcdn.com/g/p/f14c5bfd0fc38f2379ca764cadc1f1b8.png_200x200q90.png",
        "price": 2380,
        "remark": "https://www.lazada.co.th/products/pdp-i5923177105.html",
        "sold": 1
    },
    {
        "product_name": "มนุษย์หิมะบนโลกหิมะคริสต์มาสแฟนซีมีไฟตกแต่งตกแต่งคริสต์มาสสวนสัตว์",
        "product_image": "https://img.lazcdn.com/g/p/3624b81045d8470918bb3e3a905be50f.jpg_200x200q90.jpg",
        "price": 2308,
        "remark": "https://www.lazada.co.th/products/pdp-i5944785700.html",
        "sold": 0
    },
    {
        "product_name": "ตุ๊กตามนุษย์หิมะคริสต์มาสที่เป็นขาปรับขยายได้สำหรับของตกแต่งบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/d83955242a84e55f70c12e97cfb750c7.jpg_200x200q90.jpg",
        "price": 2288,
        "remark": "https://www.lazada.co.th/products/pdp-i16057837496.html",
        "sold": 0
    },
    {
        "product_name": "ส่องสว่างคริสต์มาสสำหรับงานปาร์ตี้ในร่มเครื่องประดับตั้งโต๊ะการตกแต่งคริสต์มาสดนตรีงานฝีมือสร้างคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/p/ab8f7f1d4a31be0c6dd1395e664e6403.jpg_200x200q90.jpg",
        "price": 2272,
        "remark": "https://www.lazada.co.th/products/pdp-i16059450042.html",
        "sold": 0
    },
    {
        "product_name": "Bhuuno กระเช้าต้นคริสต์มาสกระโปรง Pohon Buatan ตกแต่งคริสต์มาสบ้านไร่ทรงกลมแฮนด์เมดในร่มกลางแจ้งต้นคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/p/7e5f4b1ce9f6821a0cff8a0acf629b25.jpg_200x200q90.jpg",
        "price": 2262,
        "remark": "https://www.lazada.co.th/products/pdp-i5944926699.html",
        "sold": 0
    },
    {
        "product_name": "ฐานรองรูปต้นคริสต์มาส Amleso ต้นคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/p/cffa781821f600ca31dad31f58bfac13.jpg_200x200q90.jpg",
        "price": 2262,
        "remark": "https://www.lazada.co.th/products/pdp-i5944855587.html",
        "sold": 0
    },
    {
        "product_name": "ต้นคริสต์มาสสีขาวขนาดเล็ก 20 นิ้ว ต้นคริสต์มาสเทียมพร้อมไฟ ต้นคริสต์มาสบนโต๊ะพร้อมกล่องเกล็ดหิมะและลูกบอลสำหรับตกแต่งคริสต์มาส DIY (สีขาว)",
        "product_image": "https://img.lazcdn.com/g/p/1883b5db61771dc4ed9af3355dc0c56e.jpg_webp_200x200q90.jpg",
        "price": 2246.6,
        "remark": "https://www.lazada.co.th/products/pdp-i5660956698.html",
        "sold": 0
    },
    {
        "product_name": "รูปปั้นต้นคริสต์มาสประดิษฐ์บนโต๊ะตุ๊กตาตกแต่งต้นคริสต์มาสสำหรับตั้งโต๊ะในบ้าน",
        "product_image": "https://img.lazcdn.com/g/p/21d6d6ffbc2b0f4e0ab4aff2e41dc7d9.jpg_200x200q90.jpg",
        "price": 2242,
        "remark": "https://www.lazada.co.th/products/pdp-i5900924990.html",
        "sold": 0
    },
    {
        "product_name": "ตุ๊กตาจำลองซานต้าคลอสกล่องดนตรีคริสต์มาสมีไฟ WBStar",
        "product_image": "https://img.lazcdn.com/g/p/b1d8c6bc93439d0383919dc143c4f2a3.jpg_200x200q90.jpg",
        "price": 2240.54,
        "remark": "https://www.lazada.co.th/products/pdp-i16087958469.html",
        "sold": 0
    },
    {
        "product_name": "Homyl รูปปั้นการประสูติคริสต์มาสไฟ LED ประดับโต๊ะรางหญ้า",
        "product_image": "https://img.lazcdn.com/g/p/df7e04e8d34d0c703a0dd0621266e517.jpg_200x200q90.jpg",
        "price": 2144,
        "remark": "https://www.lazada.co.th/products/pdp-i16068880007.html",
        "sold": 0
    },
    {
        "product_name": "Sharplace บ้านเรืองแสงประดับสวนดนตรีคริสต์มาสสำหรับประดับโต๊ะชิ้นกลางห้องนอนห้องครัวในร่มปาร์ตี้",
        "product_image": "https://img.lazcdn.com/g/p/682e177fcafe7a62944eafb22212b9df.jpg_200x200q90.jpg",
        "price": 2094,
        "remark": "https://www.lazada.co.th/products/pdp-i16120091768.html",
        "sold": 0
    },
    {
        "product_name": "Homyl รูปปั้นขนาดเล็กงานศิลป์ชุดฟิกเกอร์ขนาดเล็กฉากการประสูติคริสต์มาส11x สำหรับชั้นวางหนังสือรูปปั้นตกแต่งคริสต์มาสความคิดสร้างสรรค์",
        "product_image": "https://img.lazcdn.com/g/p/f4001a443290e964f84b29291bc5bd5d.jpg_200x200q90.jpg",
        "price": 2080,
        "remark": "https://www.lazada.co.th/products/pdp-i6067782525.html",
        "sold": 0
    },
    {
        "product_name": "Footful ลูกกลมหิมะคริสมาสต์ทีวีมีไฟตกแต่งการตกแต่งคริสต์มาสกล่องดนตรีดนตรีสำหรับวางบนโต๊ะบ้านชั้นวางสำหรับห้องนอนของขวัญ",
        "product_image": "https://img.lazcdn.com/g/p/2907a61eaa5e59afc74a078d71af74c3.jpg_200x200q90.jpg",
        "price": 2064.16,
        "remark": "https://www.lazada.co.th/products/pdp-i16108552507.html",
        "sold": 0
    },
    {
        "product_name": "รูปปั้นกวางคริสต์มาสเทียมสีดำสำหรับตกแต่งสำนักงาน",
        "product_image": "https://img.lazcdn.com/g/p/87be051fe93c95f7e991da70224aa082.jpg_200x200q90.jpg",
        "price": 2064,
        "remark": "https://www.lazada.co.th/products/pdp-i16108563716.html",
        "sold": 0
    },
    {
        "product_name": "Simhoa อุปกรณ์ตกแต่งเครื่องตกแต่งภายนอกรูปร่างซานต้าคริสต์มาสสำหรับสนามหญ้าแอลอีดีแบบฝังเข้ากับสิ่งปลูกสร้าง",
        "product_image": "https://img.lazcdn.com/g/p/36a2d19d4feb671d01037c48b7c8b65b.jpg_200x200q90.jpg",
        "price": 2022,
        "remark": "https://www.lazada.co.th/products/pdp-i5936707849.html",
        "sold": 0
    },
    {
        "product_name": "Oceanside ตกแต่งโต๊ะของตกแต่งวันคริสต์มาสหมู่บ้านคริสต์มาสป้ายตกแต่งคริสต์มาสของขวัญคริสต์มาสสำหรับตั้งโต๊ะในบ้าน Mantel วันหยุด",
        "product_image": "https://img.lazcdn.com/g/p/e39f0b187795a72fdb7f7c06165e290d.jpg_200x200q90.jpg",
        "price": 2020,
        "remark": "https://www.lazada.co.th/products/pdp-i5947832974.html",
        "sold": 0
    },
    {
        "product_name": "รูปปั้นบ้านคริสต์มาส Dolity ลูกบอลหิมะไฟใช้พลังงานจากแบตเตอรี่ของประดับบนโต๊ะสำหรับห้องนอนห้องนั่งเล่นทำด้วยมือน้ำหนักเบา",
        "product_image": "https://img.lazcdn.com/g/p/3813585b384756431a5f66f8689b22d3.jpg_200x200q90.jpg",
        "price": 1996,
        "remark": "https://www.lazada.co.th/products/pdp-i16097825552.html",
        "sold": 0
    },
    {
        "product_name": "ของตกแต่งบ้านคริสต์มาส โมเดลบ้านโพลีเรซิน ของขวัญ ประดับตกแต่ง Christmas Decorative House Figurines Polyresin Festive",
        "product_image": "https://img.lazcdn.com/g/p/75931f714fdc9c089feed7643b3bcde0.png_200x200q90.png",
        "price": 1994,
        "remark": "https://www.lazada.co.th/products/pdp-i5926829038.html",
        "sold": 0
    },
    {
        "product_name": "ต้นคริสต์มาสเซรามิค ตกแต่งบ้าน สีขาว/ทอง Ceramic Christmas Tree White/Gold Table Ornament for Holiday and Festive Season",
        "product_image": "https://img.lazcdn.com/g/p/50be7cd7b27118cd3a9e3958e1c593f8.png_200x200q90.png",
        "price": 1990,
        "remark": "https://www.lazada.co.th/products/pdp-i5939857475.html",
        "sold": 0
    },
    {
        "product_name": "กล่องดนตรี ตกแต่งคริสต์มาส ซานต้า/ต้นคริสต์มาส Christmas Music Box Santa / Christmas Tree with Light and Music Festive",
        "product_image": "https://img.lazcdn.com/g/p/0598fe61008c700a693febb49a7ef923.png_200x200q90.png",
        "price": 1990,
        "remark": "https://www.lazada.co.th/products/pdp-i5921783866.html",
        "sold": 0
    },
    {
        "product_name": "กล่องดนตรีคริสต์มาส ไฟLED กล่องดนตรีซานต้า/snowman (1ชิ้น) Christmas Music Box LED Light Glass Ball Santa/Snowman Music Box (1 unit)",
        "product_image": "https://img.lazcdn.com/g/p/47259f04064abfc3c1b312ff5fbf016c.jpg_200x200q90.jpg",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i5915526547.html",
        "sold": 0
    },
    {
        "product_name": "นัทแครกเกอร์ ตุ๊กตาคริสมาส ตกแต่งคริสมาส ตุ๊กตาไม้ King & Guard (1ชิ้น) Wooden Christmas Nutcracker Christmas Decor King & Guard Soldier Decorative Christmas Nutcracker (1 unit)",
        "product_image": "https://img.lazcdn.com/g/p/1d0fdcf261fb191d0e67e5c751d33bd3.jpg_200x200q90.jpg",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i5898145387.html",
        "sold": 2
    },
    {
        "product_name": "นัทแครกเกอร์ 20cm. 2ชิ้น ตุ๊กตาคริสมาส ตกแต่งคริสมาส ตุ๊กตาไม้ (1ชุด) Wooden Nutcracker 20cm. 2pcs. Christmas Decor Decorative Christmas Nutcracker (1 set)",
        "product_image": "https://img.lazcdn.com/g/p/bbd6254b6a20881511e286a0a1107dd7.jpg_200x200q90.jpg",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i5905105394.html",
        "sold": 0
    },
    {
        "product_name": "นัทแครกเกอร์ ตุ๊กตาคริสมาส ตกแต่งคริสมาส ตุ๊กตาไม้ สีทอง (1ชิ้น) Wooden Nutcracker Christmas Decor Guard Soldier Decorative Christmas Nutcracker Gold Color (1 unit)",
        "product_image": "https://img.lazcdn.com/g/p/6e40ba702967e40bcb8360ca363e0c26.jpg_200x200q90.jpg",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i5898179387.html",
        "sold": 0
    },
    {
        "product_name": "ลูกบอลประดับต้นคริสต์มาส 8cm (35 ชิ้น/กล่อง) Champagne Gold Silver Red Christmas Ball Ornaments Set",
        "product_image": "https://img.lazcdn.com/g/p/915e5a73559a4b8c533b20936832ccd5.png_200x200q90.png",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i5404753295.html",
        "sold": 0
    },
    {
        "product_name": "ลูกบอลคริสต์มาสขนาด 8ซม. ชุด 35 ลูก สีแดง-ขาว 8cm Christmas Ball Ornaments Set of 35 Red & White Baubles for Christmas Tree Decoration",
        "product_image": "https://img.lazcdn.com/g/p/e1db80d785ade6d9eab0068415f6c63a.png_200x200q90.png",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i5898618070.html",
        "sold": 0
    },
    {
        "product_name": "ตุ๊กตาคริสมาส ตุ๊กตาซานต้า 33ซม. (1ตัว) Santa Claus Decoration Santa Doll (1unit)",
        "product_image": "https://img.lazcdn.com/g/p/b7f9100d7c91ecf054a521394eb65fe1.jpg_200x200q90.jpg",
        "price": 1980,
        "remark": "https://www.lazada.co.th/products/pdp-i4961343573.html",
        "sold": 1
    },
    {
        "product_name": "Traditional Christmas Shed Christmas Shed Decoration Religious Statue Decoration Resin Crafts",
        "product_image": "https://img.lazcdn.com/g/p/3b8573a671c0c3f6d13fe3d7795382b9.jpg_200x200q90.jpg",
        "price": 1974.92,
        "remark": "https://www.lazada.co.th/products/pdp-i16124841805.html",
        "sold": 0
    },
    {
        "product_name": "รูปปั้นการประสูติคริสต์มาส Beatydailday พร้อมสำหรับห้องนั่งเล่นเครื่องประดับตั้งโต๊ะแสง",
        "product_image": "https://img.lazcdn.com/g/p/880d0b8bea8d424b33b0238d2948aaa5.jpg_200x200q90.jpg",
        "price": 1960,
        "remark": "https://www.lazada.co.th/products/pdp-i5974489859.html",
        "sold": 0
    },
    {
        "product_name": "ไฟลูกบอลหิมะรูปรูปปั้นบ้านคริสต์มาส15x8x21.5cm",
        "product_image": "https://img.lazcdn.com/g/p/ebe48da05bec319977ce37a065a26f63.jpg_200x200q90.jpg",
        "price": 1958,
        "remark": "https://www.lazada.co.th/products/pdp-i5899064538.html",
        "sold": 0
    },
    {
        "product_name": "รูปปั้นบ้านคริสต์มาสดวงจันทร์ความหวังลูกบอลหิมะของขวัญวันคริสต์มาสของตกแต่งภาพ15X8X21.5ซม.",
        "product_image": "https://img.lazcdn.com/g/p/9a853b79000dba1c5ec5770d2d10e06e.jpg_200x200q90.jpg",
        "price": 1958,
        "remark": "https://www.lazada.co.th/products/pdp-i6021586392.html",
        "sold": 0
    },
    {
        "product_name": "รูปปั้นบ้านคริสต์มาส Amagogo ลูกบอลหิมะสว่างแบบดั้งเดิมเสาเข็มตกแต่งของขวัญคริสต์มาสขนาด15X8X21.5ซม. ทำด้วยมือโต๊ะสำนักงาน",
        "product_image": "https://img.lazcdn.com/g/p/f2a6112b25cc3badf61b0770b35c69a7.jpg_200x200q90.jpg",
        "price": 1958,
        "remark": "https://www.lazada.co.th/products/pdp-i6007977215.html",
        "sold": 0
    },
    {
        "product_name": "รูปปั้นการตกแต่งคริสต์มาส Dolity รูปแกะสลักสไตล์วินเทจประดับคริสต์มาสสำหรับห้องนอนปาร์ตี้ตั้งโต๊ะ",
        "product_image": "https://img.lazcdn.com/g/p/e9a8f94ef0c70012dee7611e44e0fd75.jpg_200x200q90.jpg",
        "price": 1954,
        "remark": "https://www.lazada.co.th/products/pdp-i5414044980.html",
        "sold": 0
    },
    {
        "product_name": "ตุ๊กตาซานต้าตั้งโชว์รูปปั้นงานฝีมือในซานต้าที่สร้างสรรค์แปดด้านสำหรับวางบนโต๊ะในงานวันเกิดรูปปั้นศิลปะบนการตกแต่งคริสต์มาส",
        "product_image": "https://img.lazcdn.com/g/p/9aeda7dace53d17acf68f5c1f187f70c.jpg_200x200q90.jpg",
        "price": 1942,
        "remark": "https://www.lazada.co.th/products/pdp-i5979371836.html",
        "sold": 0
    },
    {
        "product_name": "Baosity รูปปั้นซานต้าที่สร้างสรรค์สำหรับตกแต่งในการตกแต่งคริสต์มาส,ประติมากรรมงานฝีมือตุ๊กตาซานต้าแบบยืนสำหรับวางโชว์บนโต๊ะในงานวันเกิด",
        "product_image": "https://img.lazcdn.com/g/p/fef6de26d0533e3fadbed55f7bca15b3.jpg_200x200q90.jpg",
        "price": 1942,
        "remark": "https://www.lazada.co.th/products/pdp-i6022026964.html",
        "sold": 0
    },
    {
        "product_name": "Hellery รูปปั้นคริสต์มาสหมู่บ้านของขวัญตกแต่งสำหรับด้านบนของเคาน์เตอร์ด้านบนของโต๊ะชิ้นกลาง",
        "product_image": "https://img.lazcdn.com/g/p/d3788696f7110ac2ac0c374d913ef2ac.jpg_200x200q90.jpg",
        "price": 1888,
        "remark": "https://www.lazada.co.th/products/pdp-i5929701245.html",
        "sold": 0
    },
    {
        "product_name": "ของประดับหมู่บ้านในเทศกาลคริสต์มาสหมู่บ้านหิมะสำหรับตกแต่งวันหยุดบ้านสไตล์กริสโวลด์เครื่องประดับคริสต์มาสของขวัญ",
        "product_image": "https://img.lazcdn.com/g/p/2476638de4c122cef5e5a9bbd5e35c29.jpg_200x200q90.jpg",
        "price": 1886.2,
        "remark": "https://www.lazada.co.th/products/pdp-i16139070292.html",
        "sold": 0
    },
    {
        "product_name": "รูปปั้นคริสมาสต์รูปพระจันทร์และราชินีประดับบ้านไฟ LED ของขวัญวันคริสต์มาสสำหรับวางกลางห้องนั่งเล่นสำนักงานรูปตกแต่ง",
        "product_image": "https://img.lazcdn.com/g/p/c0dd8726047067e9b39d35553099e157.jpg_200x200q90.jpg",
        "price": 1882,
        "remark": "https://www.lazada.co.th/products/pdp-i16121012431.html",
        "sold": 0
    },
    {
        "product_name": "ตกแต่งกล่องกล่องของขวัญคริสต์มาส Zypplanet สำหรับวันหยุดปีใหม่ในร่ม",
        "product_image": "https://img.lazcdn.com/g/p/937d436675540baeeaf6925489b06b85.jpg_200x200q90.jpg",
        "price": 1878,
        "remark": "https://www.lazada.co.th/products/pdp-i5971628977.html",
        "sold": 0
    },
    {
        "product_name": "Homyl ตัวซานตาคลอสตั้งโต๊ะสำหรับตกแต่งตุ๊กตาคริสต์มาสตุ๊กตาจำลองซานต้าคลอส60เซนติเมตรสูงสำหรับของตกแต่งวันหยุด",
        "product_image": "https://img.lazcdn.com/g/p/8b0b0ada77065f04c6f9afa81f05d9cb.jpg_200x200q90.jpg",
        "price": 1862.96,
        "remark": "https://www.lazada.co.th/products/pdp-i6003499760.html",
        "sold": 0
    },
    {
        "product_name": "โคมไฟกลางคืนลูกกลมหิมะคริสมาสต์ของ Figatia ที่มีไฟการประสูติของตกแต่งคริสต์มาสประดับบนโต๊ะสำหรับงานปาร์ตี้ในบ้านวันหยุดห้องนอน",
        "product_image": "https://img.lazcdn.com/g/p/2b86df792f95328c22a1ec779f649782.jpg_200x200q90.jpg",
        "price": 1840,
        "remark": "https://www.lazada.co.th/products/pdp-i5944931742.html",
        "sold": 0
    },
    {
        "product_name": "Fityle ตกแต่งคริสต์มาสลูกกลมหิมะคริสมาสต์มีไฟตุ๊กตาสำหรับตกแต่งโคมไฟกลางคืนสำหรับตั้งโต๊ะสำนักงานชั้นวางของในวันหยุด",
        "product_image": "https://img.lazcdn.com/g/p/bea0f4b181b129d29a4887f020995007.jpg_200x200q90.jpg",
        "price": 1840,
        "remark": "https://www.lazada.co.th/products/pdp-i5953577018.html",
        "sold": 0
    },
    {
        "product_name": "บ้านในหมู่บ้านคริสต์มาสมีไฟรูปตุ๊กตาหิมะของขวัญคริสต์มาสหมุนได้เครื่องประดับตั้งโต๊ะสำหรับห้องนั่งเล่นโต๊ะบ้านห้องนอน",
        "product_image": "https://img.lazcdn.com/g/p/90940a17e49e68461eb55eaa4602e8f2.jpg_200x200q90.jpg",
        "price": 1834,
        "remark": "https://www.lazada.co.th/products/pdp-i5923919076.html",
        "sold": 0
    },
    {
        "product_name": "Simhoa โคมไฟลูกบอลหิมะแนวดนตรีสำหรับตกแต่งวันคริสมาสต์ Kado Kotak Musik เรืองแสงสำหรับตู้ฟาร์มห้องนั่งเล่นสำนักงานห้องนอน",
        "product_image": "https://img.lazcdn.com/g/p/271daa9234351b2d22bc240e44393383.jpg_200x200q90.jpg",
        "price": 1834,
        "remark": "https://www.lazada.co.th/products/pdp-i5960496563.html",
        "sold": 0
    },
    {
        "product_name": "Daywolf รูปปั้นงานฝีมือรูปร่างซานต้าตุ๊กตาคริสต์มาสพร้อมเครื่องประดับมีแสงสำหรับงานเทศกาลเตาผิงกลางบ้านของขวัญวันเกิด",
        "product_image": "https://img.lazcdn.com/g/p/80745ba0ef77201d04a4dcb9b6bcde41.jpg_200x200q90.jpg",
        "price": 1822,
        "remark": "https://www.lazada.co.th/products/pdp-i5913168829.html",
        "sold": 0
    },
    {
        "product_name": "ของตกแต่งคริสต์มาส แขวนผนัง วงแหวนต้นคริสต์มาส แขวนประตู",
        "product_image": "https://img.lazcdn.com/g/ff/kf/S9e32afed82cb471f8686f426dc9551c6V.jpg_200x200q90.jpg",
        "price": 1817.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16103207419.html",
        "sold": 0
    },
    {
        "product_name": "Santa Claus Reindeer Christmas Dolls 3PCS Standing Decorative Doll New Year Ornament Merry Christmas",
        "product_image": "https://img.lazcdn.com/g/p/41c2baedc94401634a688a4872efaf66.jpg_200x200q90.jpg",
        "price": 1788.68,
        "remark": "https://www.lazada.co.th/products/pdp-i16125002446.html",
        "sold": 0
    }
]